(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5701"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5701"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bzZjF", function(module, exports) {

var $4h6k4 = parcelRequire("4h6k4");

var $QygZs = parcelRequire("QygZs");

var $4bGxI = parcelRequire("4bGxI");

var $bl2p3 = parcelRequire("bl2p3");

var $M3yYZ = parcelRequire("M3yYZ");

var $3akwj = parcelRequire("3akwj");

var $i2a3I = parcelRequire("i2a3I");

var $3CnuR = parcelRequire("3CnuR");

var $54lXz = parcelRequire("54lXz");

var $8IO0M = parcelRequire("8IO0M");

var $1IXAI = parcelRequire("1IXAI");

var $knM87 = parcelRequire("knM87");

var $kxvFW = parcelRequire("kxvFW");

var $84v9a = parcelRequire("84v9a");

var $d62of = parcelRequire("d62of");

var $2pJVD = parcelRequire("2pJVD");
const page = ()=>{
    // console.log("pppppppppp");
    LOG_BLUE(document.querySelector('#RelatorioCaptacao'));
    if (document.querySelector('#Home')) return 0, $4h6k4.default;
    else if (document.querySelector('#TodosClientes')) return 0, $QygZs.default;
    else if (document.querySelector('#DashboardGerencial')) return 0, $4bGxI.default;
    else if (document.querySelector('#DashboardGerencialSai')) return 0, $4bGxI.default;
    else if (document.querySelector('#NovoGerencialSap')) return 0, $3akwj.default;
    else if (document.querySelector('#RelatorioCaptacao')) return 0, $1IXAI.default;
    else if (document.querySelector('#Aprovacoes')) return 0, $i2a3I.default;
    else if (document.querySelector('#EmailFundacao')) return 0, $knM87.default;
    else if (document.querySelector('#Reuniao')) return 0, $54lXz.default;
    else if (document.querySelector('#Reuniao_Sai')) return 0, $8IO0M.default;
    else if (document.querySelector('#Investimentos')) return 0, $kxvFW.default;
    else if (document.querySelector('#CalendarioReuniao')) return 0, $84v9a.default;
    else if (document.querySelector("[id^='step']")) return 0, $3CnuR.default;
    else return null;
};
if (!page()) return;
const app = Vue.createApp(page());
app.component('NotificationsContainer', (0, $bl2p3.default));
app.component('ModalTarefaRapido', (0, $d62of.default));
app.mixin((0, $M3yYZ.default));
app.mixin((0, $2pJVD.default));
app.use(Quasar);
Quasar.lang.set(Quasar.lang.ptBR);
app.mount('#app');
window.instance = app;

});
parcelRegister("4h6k4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31cda782274f73ad$export$2e2bcd8739ae039; });

var $4nzoT = parcelRequire("4nzoT");

var $9f1jB = parcelRequire("9f1jB");

var $bF0nE = parcelRequire("bF0nE");

var $4Fazw = parcelRequire("4Fazw");

var $i5cs0 = parcelRequire("i5cs0");

var $1UZGW = parcelRequire("1UZGW");

var $U7jaT = parcelRequire("U7jaT");

var $kcxIT = parcelRequire("kcxIT");

var $bJHXi = parcelRequire("bJHXi");

var $8TiaI = parcelRequire("8TiaI");

var $kKHf6 = parcelRequire("kKHf6");

var $SxmxE = parcelRequire("SxmxE");

var $5XTTN = parcelRequire("5XTTN");

var $1F5Ay = parcelRequire("1F5Ay");

var $DhNZ3 = parcelRequire("DhNZ3");
parcelRequire("2m7Ys");

var $lY3Fi = parcelRequire("lY3Fi");

var $bfGVy = parcelRequire("bfGVy");
parcelRequire("h4RPk");

var $fpYz8 = parcelRequire("fpYz8");

var $kxhz7 = parcelRequire("kxhz7");
const { setColorsInFunctionOfAHexadecimalColor: $31cda782274f73ad$var$setColorsInFunctionOfAHexadecimalColor } = (0, $1F5Ay.useCharts)();
const { generateRange: $31cda782274f73ad$var$generateRange, showToastify: $31cda782274f73ad$var$showToastify, api: $31cda782274f73ad$var$api, errorDefault: $31cda782274f73ad$var$errorDefault, destroyApexChart: $31cda782274f73ad$var$destroyApexChart, initTipy: $31cda782274f73ad$var$initTipy, FormatREALBackEnd: $31cda782274f73ad$var$FormatREALBackEnd, getChoicesActive: $31cda782274f73ad$var$getChoicesActive, addClassForTime: $31cda782274f73ad$var$addClassForTime, sortedArray: $31cda782274f73ad$var$sortedArray } = GLOBAL;
const $31cda782274f73ad$var$selectFundacao = ()=>document.querySelector('[name=fundacao_lista]');
const $31cda782274f73ad$var$selectFundos = ()=>document.querySelector('#fundos_lista');
const $31cda782274f73ad$var$selectEscalas = ()=>document.querySelector('[name=escala_lista]');
const $31cda782274f73ad$var$divFundo = ()=>document.querySelector('.select-fundo');
const { getEmailEnvinhado: $31cda782274f73ad$var$getEmailEnvinhado } = (0, $kxhz7.emailFundacaoService)();
const $31cda782274f73ad$var$arrPlaceholder = $31cda782274f73ad$var$generateRange(8, {
    id: 1,
    politica: 1,
    nome: "Adelino Jos\xe9 Jacques Gamb\xf4a Fernandez de Oliveira Netto",
    placeholder: true
});
let $31cda782274f73ad$var$userLogado = document.getElementById('usuario-logado').value;
const $31cda782274f73ad$var$listaFundosOriginaisProspectQuente = [];
var $31cda782274f73ad$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $i5cs0.default),
        (0, $8TiaI.default),
        (0, $lY3Fi.default)
    ],
    components: {
        ModalResumo: $4nzoT.default,
        ModalEmailEnviados: $fpYz8.default,
        ModalEmailEnvio: $bfGVy.default,
        TableAtendimento: $bF0nE.default,
        AvatarPersona: $4Fazw.default,
        ConfirmModal: $1UZGW.default,
        TaskItem: $U7jaT.default,
        NewTaskItem: $kcxIT.default,
        SearchFundacao: $9f1jB.default,
        ModalSendEmail: $bJHXi.default,
        ProcessoItem: $kKHf6.default,
        ModalNovoProcesso: $SxmxE.default,
        NewProcessoItem: $5XTTN.default,
        DrawerAtendimentoRapido: $DhNZ3.default
    },
    data () {
        return {
            emailEnviadoSelecionado: null,
            timeStampLimpaTabel: null,
            fundacoes: [],
            atendimentos: $31cda782274f73ad$var$arrPlaceholder,
            fundacoesSemAtendimentoQuente: [],
            data_inicial: '',
            data_inicial_politica: '',
            estrategias: [],
            fundos: [],
            isFilterActive: false,
            data_final: '',
            data_final_politica: '',
            dataInicioFormatted: '',
            dataFinalFormatted: '',
            prospect: [],
            atendimentosQuentes: [],
            modalConfirm: {},
            haveModalResumo: true,
            chartHomeLoading: true,
            abatask: false,
            abaProcesso: false,
            processos: [],
            numeroProcessosValidos: 0,
            processosValidosPorcent: 0,
            processosTotaisPorcent: 0,
            semestres: [],
            novaTaskOpen: false,
            tarefas: [],
            totalPage: [],
            semestreFilter: '',
            statusFilter: '',
            chartEstrategias: null,
            timingSearch: null,
            queryProcessoFundacao: '',
            statusProcesso: {
                vencido: 0,
                sem_exito: 0,
                em_andamento: 0,
                porc_vencido: 0,
                porc_sem_exito: 0,
                porc_em_andamento: 0
            },
            chart_estrategias: [],
            isProspectsPaused: false,
            status: {
                atrasado: 0,
                pendente: 0,
                realizado: 0
            },
            pagination: {
                elementPerPage: 10,
                page: 1,
                totalPage: 1,
                next: '',
                previous: ''
            },
            stateSave: {
                searchs: {
                    searchFilterAtendimentos: (arr)=>arr,
                    searchFilterProspect: (arr)=>arr
                }
            },
            queryAtendimento: {
                search: ''
            }
        };
    },
    watch: {
        'queryAtendimento.search': {
            handler: function(novoValor, valorAntigo) {
                this.queryAtendimento.search = novoValor;
            }
        },
        tipoAtendimentoRapido () {
            alert(this.tipoAtendimentoRapido);
        },
        semestres () {
            if (!window.listOfChoices) return;
            setTimeout(()=>{
                const choicePeriodo = GLOBAL.getChoicesActive('select_periodo', listOfChoices);
                if (!choicePeriodo) return;
                choicePeriodo.clearStore([]);
                choicePeriodo.setChoices([
                    {
                        value: '',
                        label: "Selecione um per\xedodo"
                    },
                    ...this.semestres
                ]);
                choicePeriodo.setChoiceByValue('');
            }, 200);
        },
        data_inicial () {
            if (this.data_inicial !== 'DD/MM/YYYY') this.formatDate('data_inicial');
        },
        data_final () {
            if (this.data_final !== 'DD/MM/YYYY') this.formatDate('data_final');
        },
        data_inicial_politica () {
            if (this.data_inicial_politica !== 'DD/MM/YYYY') this.formatDate('data_inicial_politica');
        },
        data_final_politica () {
            if (this.data_final_politica !== 'DD/MM/YYYY') this.formatDate('data_final_politica');
        }
    },
    computed: {
        atendimentosView () {
            return this.stateSave.searchs.searchFilterAtendimentos(this.atendimentos);
        },
        prospectsView () {
            return this.stateSave.searchs.searchFilterProspect(this.prospect);
        },
        numeroAtendimentos () {
            return {
                total: this.status.pendente + this.status.atrasado + this.status.realizado,
                pendentes: this.status.pendente,
                atrasados: this.status.atrasado,
                realizados: this.status.realizado
            };
        },
        numeroTarefas () {
            return {
                total: this.isFundacao ? this.tarefas.filter((task)=>task.fundacao)?.length : this.tarefas.filter((task)=>task.cliente_pf)?.length || 0,
                realizados: this.tarefas.filter((i)=>i.status == '2')?.length || 0
            };
        }
    },
    methods: {
        limparEmailSelecionado () {
            this.emailEnviadoSelecionado = null;
        },
        async onClickEmailUnicoSelecionado (idEmail) {
            modal_padrao_vue.closeModal('email_lista_enviados');
            const emailData = (await $31cda782274f73ad$var$getEmailEnvinhado(idEmail))?.results?.[0];
            await new Promise((resolve)=>setTimeout(resolve, 500));
            modal_padrao_vue.openModal('email_envio_template');
            setTimeout(()=>{
                this.emailEnviadoSelecionado = emailData;
            }, 50);
        },
        openModalHistoricoEmail () {
            modal_padrao_vue.openModal('email_lista_enviados');
            setTimeout(()=>{
                const modal = document.querySelector('.modal_padrao_vue[data-active="email_lista_enviados"]');
                if (!modal) return;
                modal.style.width = '800px';
            }, 100);
        },
        closeModalHistoricoEmail () {
            modal_padrao_vue.closeModal('email_lista_enviados');
        },
        async getFundacoes () {
            const urlApi = '/clientes/processos_fundacoes/';
            const { data: data } = await $31cda782274f73ad$var$api.get(urlApi);
            this.fundacoes = data?.results?.fundacoes?.map((itemFundacao)=>({
                    value: itemFundacao[0],
                    label: itemFundacao[1]
                }));
        },
        openModalNovoProcesso () {
            modal_padrao_vue.openModal('modal_novo_processo');
        },
        setQueryProcessoFundacao () {
            const params = new URLSearchParams();
            if (this.semestreFilter) params.append('semestre', this.semestreFilter);
            if (this.statusFilter) params.append('status', this.statusFilter);
            this.queryProcessoFundacao = params.toString().length > 0 ? '?' + params.toString() : '';
        },
        toggleButtonClasses (eventClick, buttonNoClicked) {
            eventClick.target.classList.remove('quartenary');
            eventClick.target.classList.add('secondary');
            buttonNoClicked.classList.add('quartenary');
            buttonNoClicked.classList.remove('secondary');
        },
        async filtrarPorPeriodo () {
            const choicePeriodo = GLOBAL.getChoicesActive('select_periodo', listOfChoices);
            if (!choicePeriodo) return;
            this.semestreFilter = choicePeriodo.getValue(true);
            await this.getProcessosFundacao();
            this.updateChartEstrategias();
        },
        async filtrarPorStatus (status) {
            if (!status) return;
            this.isFilterActive = true;
            this.statusFilter = status;
            await this.getProcessosFundacao();
            this.updateChartEstrategias();
        },
        setStatusProcessos ({ count: count, porcentagem: porcentagem }) {
            this.statusProcesso = {
                vencido: count['Vencidos'],
                sem_exito: count["Sem \xeaxito"],
                em_andamento: count['Em andamento'],
                porc_vencido: porcentagem['Vencidos'],
                porc_sem_exito: porcentagem["Sem \xeaxito"],
                porc_em_andamento: porcentagem['Em andamento']
            };
        },
        async getSemestres () {
            const url = `/clientes/processos_fundacoes/?semestre=${this.semestreFilter}`;
            const { data: data } = await $31cda782274f73ad$var$api.get(url);
            this.semestres = data?.results?.semestres?.map((fundo)=>({
                    value: fundo.id,
                    label: fundo.semestre
                }));
        },
        async getInfoEstrategia (idEstrategia) {
            NProgress.start();
            try {
                const { data: data } = await axios.get(`${window.location.origin}/clientes/processos_fundacoes/?&estrategia=${idEstrategia}&semestre=${this.semestreFilter}`);
                this.processos = data?.results?.processos;
                this.estrategias = data?.results?.estrategias?.map((estrategia)=>({
                        value: estrategia.id,
                        label: estrategia.nome
                    }));
                this.fundos = data?.results?.fundos?.map((fundo)=>({
                        value: fundo.id,
                        label: fundo.sigla
                    }));
                this.semestres = data?.results?.semestres?.map((fundo)=>({
                        value: fundo.id,
                        label: fundo.semestre
                    }));
                const countStatus = data?.results?.count_status;
                const porcentagemStatus = data?.results?.porcentagem_status;
                this.setStatusProcessos({
                    count: countStatus,
                    porcentagem: porcentagemStatus
                });
            } catch (e) {
                $31cda782274f73ad$var$errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        updateChartEstrategias () {
            const series = this.chart_estrategias.map((estrategia)=>parseFloat(estrategia.porcentagem));
            const labels = this.chart_estrategias.map((estrategia)=>estrategia.nome);
            const ids = this.chart_estrategias.map((estrategia)=>estrategia.id);
            const t = this;
            const options = {
                series: series,
                chart: {
                    width: 380,
                    type: 'pie',
                    events: {
                        click: function(event, chartContext, config) {
                            // debugger
                            let posSelected = config.globals?.selectedDataPoints[0];
                            const idEstrategiaClicked = ids[posSelected];
                            if (!idEstrategiaClicked) return;
                            t.isFilterActive = true;
                            console.log({
                                idEstrategiaClicked: idEstrategiaClicked
                            });
                            t.getInfoEstrategia(idEstrategiaClicked);
                        }
                    }
                },
                labels: labels,
                dataLabels: {
                    show: false
                },
                colors: GLOBAL.defineColors(labels),
                legend: {
                    position: 'bottom'
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }
                ]
            };
            this.chartEstrategias?.updateOptions(options);
        },
        initializeChartEstrategiaToggle () {
            const buttonValue = document.querySelector('.chart-valor');
            const buttonPorcentagem = document.querySelector('.chart-porcentagem');
            buttonPorcentagem.addEventListener('click', async (eventClick)=>{
                this.createChartEstrategias('porcentagem');
                this.toggleButtonClasses(eventClick, buttonValue);
            });
            buttonValue.addEventListener('click', async (eventClick)=>{
                this.createChartEstrategias('valor');
                this.toggleButtonClasses(eventClick, buttonPorcentagem);
            });
        },
        createChartEstrategias (tipo = 'porcentagem') {
            // const atual = tipo === 'porcentagem' ? 'porcentagem' : 'valor'
            $31cda782274f73ad$var$destroyApexChart('porcentagem');
            $31cda782274f73ad$var$destroyApexChart('valor');
            const series = this.chart_estrategias.map((estrategia)=>parseFloat(estrategia[tipo]));
            const labels = this.chart_estrategias.map((estrategia)=>estrategia.nome);
            const ids = this.chart_estrategias.map((estrategia)=>estrategia.id);
            const t = this;
            const total = series.reduce((acc, value)=>acc + value, 0);
            // console.log({ series })
            const options = {
                series: series,
                chart: {
                    width: 380,
                    id: tipo,
                    type: 'pie',
                    events: {
                        click: function(event, chartContext, config) {
                            let posSelected = config.globals?.selectedDataPoints[0];
                            const idEstrategiaClicked = ids[posSelected];
                            if (!idEstrategiaClicked) return;
                            t.isFilterActive = true;
                            t.getInfoEstrategia(idEstrategiaClicked);
                        }
                    }
                },
                labels: labels,
                dataLabels: {
                    show: false
                },
                colors: GLOBAL.defineColors(labels),
                legend: {
                    position: 'bottom'
                },
                plotOptions: {
                    pie: {
                        minAngleToShow: 0.01
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function(val, { seriesIndex: seriesIndex }) {
                        const percentage = (series[seriesIndex] / total * 100).toFixed(2);
                        return `${percentage}%`;
                    }
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            }
                        }
                    }
                ]
            };
            this.chartEstrategias = new ApexCharts(document.querySelector('#chart-estrategias'), options);
            this.chartEstrategias.render();
        },
        async getProcessosFundacao () {
            try {
                this.setQueryProcessoFundacao();
                const url = `/clientes/processos_fundacoes/${this.queryProcessoFundacao}`;
                const { data: data } = await $31cda782274f73ad$var$api.get(url);
                /* console.log('data fundacao: ', data) */ this.processos = data?.results?.processos;
                this.processosValidosPorcent = data?.results?.porcentagem_status?.Vencidos + data?.results?.porcentagem_status["Sem \xeaxito"];
                this.processosTotaisPorcent = data?.results?.porcentagem_status['Em andamento'];
                this.numeroProcessosValidos = data?.results?.count_status?.Vencidos + data?.results?.count_status["Sem \xeaxito"];
                /* console.log(this.processos) */ this.estrategias = data?.results?.estrategias?.map((estrategia)=>({
                        value: estrategia.id,
                        label: estrategia.nome
                    }));
                this.fundos = data?.results?.fundos?.map((fundo)=>({
                        value: fundo.id,
                        label: fundo.sigla
                    }));
                this.semestres = data?.results?.semestres?.map((fundo)=>({
                        value: fundo.id,
                        label: fundo.semestre
                    }));
                const countStatus = data?.results?.count_status;
                const porcentagemStatus = data?.results?.porcentagem_status;
                this.setStatusProcessos({
                    count: countStatus,
                    porcentagem: porcentagemStatus
                });
                /* console.log(data?.results.porcentagem_estrategias) */ this.chart_estrategias = data?.results?.porcentagem_estrategias.filter((itemPorcetagemEstrategia)=>itemPorcetagemEstrategia?.nome !== null);
            } catch (error) {
                console.log(error);
            }
        },
        testeEnvioProcesso () {
            console.log('teste de processo enviado com sucesso!');
        },
        async getFundacoesSemAtendimentoQuente () {
            try {
                const { data: data } = await $31cda782274f73ad$var$api.get('/clientes/ativa_atendimento_quente_fundacao/');
                return data || null;
            } catch (error) {
                console.log(error);
            }
        },
        async sendProcessoEditadoSucess () {
            // showToastify(text)
            await this.getProcessosFundacao();
            $31cda782274f73ad$var$initTipy();
        },
        async limparFiltroEstrategia () {
            // debugger
            this.isFilterActive = false;
            this.statusFilter = null;
            await this.getProcessosFundacao();
            this.updateChartEstrategias();
            $31cda782274f73ad$var$initTipy();
        },
        async ativaAtendimentoQuente (payload) {
            try {
                const fundosParam = !payload.idFundos || payload.idFundos === 'no-founds' ? '' : payload.idFundos;
                $31cda782274f73ad$var$listaFundosOriginaisProspectQuente.length;
                const { data: data } = await $31cda782274f73ad$var$api.get(`/clientes/ativa_atendimento_quente_fundacao/?id=${payload.idFundacao}&sigla=${fundosParam}&escala=${payload.idEscala}`);
                this.clearModalAtivacaoValues();
                $31cda782274f73ad$var$showToastify("\u2705 Atendimento quente adicionado");
                return data?.lista_fundacoes || [];
            } catch (error) {
                console.log(error);
            }
        },
        async removeFundoAtendimentoQuente (params) {
            try {
                const urlParams = new URLSearchParams();
                urlParams.set('id', params.id_fundacao);
                urlParams.set('fundo_id', params.fundos_id);
                const { data: data } = await $31cda782274f73ad$var$api.get(`/clientes/remover_fundos_fundacao/?${urlParams.toString()}`);
                console.log('fundos removidos: ', data);
            } catch (e) {
                console.error(e);
            }
        },
        async addAtendimentoQuente () {
            const choiceFundacao = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectFundacao()?.id, listOfChoices);
            const choiceEscala = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectEscalas()?.id, listOfChoices);
            if (!choiceFundacao) return;
            const idFundacao = choiceFundacao.getValue(true);
            const idFundos = Array.from($31cda782274f73ad$var$selectFundos().options).map((option)=>option.value).join(',');
            const idEscala = choiceEscala.getValue(true);
            const payload = {
                idFundacao: idFundacao,
                idFundos: idFundos,
                idEscala: idEscala
            };
            const listaFundoRemoverProspectQuente = $31cda782274f73ad$var$listaFundosOriginaisProspectQuente.filter((itemFundoOriginal)=>!idFundos.includes(itemFundoOriginal.value));
            if (listaFundoRemoverProspectQuente.length > 0) {
                const params = {
                    id_fundacao: idFundacao,
                    fundos_id: listaFundoRemoverProspectQuente.map((itemFundoRemover)=>itemFundoRemover.value)
                };
                await this.removeFundoAtendimentoQuente(params);
            }
            this.fundacoesSemAtendimentoQuente = await this.ativaAtendimentoQuente(payload);
            choiceFundacao.removeActiveItems();
            choiceEscala.removeActiveItems();
            await this.getAtendimentosQuentes();
            this.setChoicesFundacaoSemAtendimentoQuente();
            $31cda782274f73ad$var$listaFundosOriginaisProspectQuente.splice(0, $31cda782274f73ad$var$listaFundosOriginaisProspectQuente.length);
        },
        addEventButtons () {
            const btnAtiva = document.querySelector('.ativa-atendimento');
            const btnCancelar = document.querySelector('.cancel-ativacao');
            const btnFechar = document.querySelector('.close-btn-ativacao');
            if (!btnAtiva || !btnCancelar || !btnFechar) return;
            btnAtiva.addEventListener('click', ()=>{
                this.addAtendimentoQuente();
            });
            btnCancelar.addEventListener('click', ()=>{
                this.clearModalAtivacaoValues();
            });
            btnFechar.addEventListener('click', ()=>{
                this.clearModalAtivacaoValues();
            });
        },
        clearModalAtivacaoValues () {
            const choiceFundacao = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectFundacao().id, listOfChoices);
            const choiceEscala = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectEscalas().id, listOfChoices);
            const choiceFundos = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectFundos().id, listOfChoices);
            choiceFundacao.setChoiceByValue('');
            choiceEscala.setChoiceByValue('');
            // choiceFundacao.removeActiveItems()
            // choiceEscala.removeActiveItems()
            choiceFundos.removeActiveItems();
            choiceFundos.setChoices([]);
            $31cda782274f73ad$var$selectFundacao().value = '';
            $31cda782274f73ad$var$selectEscalas().value = '';
        // selectFundos().value = ''
        },
        addEventSelectFundacao () {
            if (!$31cda782274f73ad$var$selectFundacao()) return;
            $31cda782274f73ad$var$selectFundacao().addEventListener('change', ()=>{
                this.checkActivateBtnProspectQuente();
                if ($31cda782274f73ad$var$selectFundacao().value) this.getExistProspectQuente($31cda782274f73ad$var$selectFundacao().value);
            /* 				console.log(selectFundacao().value)
				console.log(JSON.stringify(this.atendimentosQuentes)) */ });
            $31cda782274f73ad$var$selectEscalas().addEventListener('change', ()=>{
                this.checkActivateBtnProspectQuente();
            });
        },
        async getExistProspectQuente (idProspect) {
            const dataProspectQuente = await this.getAtendimentoQuenteByFundacaoUnique(idProspect);
            if (dataProspectQuente) {
                const choiceFundacao = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectFundacao()?.id, listOfChoices);
                const choiceEscala = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectEscalas()?.id, listOfChoices);
                const choiceFundo = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectFundos().id, listOfChoices);
                if (choiceFundacao && choiceEscala && choiceFundo) {
                    /* console.log(dataProspectQuente) */ choiceEscala.setChoiceByValue(parseFloat(dataProspectQuente.escala));
                    dataProspectQuente.sigla_fundo.forEach((itemSiglaFundo)=>{
                        const fundoAtual = this.fundos.filter((itemFundo)=>itemFundo.label === itemSiglaFundo);
                        choiceFundo.setChoiceByValue(fundoAtual[0].value);
                        $31cda782274f73ad$var$listaFundosOriginaisProspectQuente.push(fundoAtual[0]);
                    });
                    this.checkActivateBtnProspectQuente();
                }
            }
        },
        checkActivateBtnProspectQuente () {
            const btnAtiva = document.querySelector('.ativa-atendimento');
            console.log($31cda782274f73ad$var$selectEscalas().value);
            if ($31cda782274f73ad$var$selectFundacao().value && $31cda782274f73ad$var$selectEscalas().value) btnAtiva.classList.remove('disabled');
            else btnAtiva.classList.add('disabled');
        },
        setChoicesFundacaoSemAtendimentoQuente () {
            const choiceFundacao = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectFundacao().id, listOfChoices);
            choiceFundacao.clearStore([]);
            const options = this.fundacoesSemAtendimentoQuente?.map((fundacao)=>{
                return {
                    value: fundacao.id,
                    label: fundacao.sigla
                };
            });
            choiceFundacao.setChoices([
                {
                    value: '',
                    label: "Selecione uma funda\xe7\xe3o"
                },
                ...options
            ]);
            choiceFundacao.setChoiceByValue('');
        },
        setChoicesFundosByFundacao (fundos) {
            const choiceFundo = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectFundos().id, listOfChoices);
            choiceFundo.clearStore([]);
            if (fundos?.length) {
                const options = fundos.map((f)=>{
                    return {
                        value: f.id,
                        label: f.sigla
                    };
                });
                choiceFundo.setChoices([
                    ...options
                ]);
            } else {
                choiceFundo.setChoices([
                    {
                        value: 'no-founds',
                        label: 'Sem fundos'
                    }
                ]);
                choiceFundo.setChoiceByValue('no-founds');
            }
        },
        setChoicesEscalasByFundacao (escalas) {
            const choiceEscala = GLOBAL.getChoicesActive($31cda782274f73ad$var$selectEscalas().id, listOfChoices);
            choiceEscala.clearStore([]);
            const options = escalas.map((f)=>{
                return {
                    value: f.id,
                    label: f.nome
                };
            });
            choiceEscala.setChoices([
                {
                    value: '',
                    label: 'Selecione uma escala'
                },
                ...options
            ]);
            choiceEscala.setChoiceByValue('');
        },
        setFundacaoExist () {},
        formatDate (date) {
            if (this[date]) {
                const [year, month, day] = this[date].split('/');
                this.dataInicioFormatted = `${day}/${month}/${year}`;
            } else this.dataInicioFormatted = '';
        },
        formatDateFinal () {
            if (this.data_final) {
                const [year, month, day] = this.data_final.split('/');
                this.dataFinalFormatted = `${day}/${month}/${year}`;
            } else this.dataFinalFormatted = '';
        },
        //!!! Modal methods Home
        modalOpen (item1) {
            this.$refs.modalResumo.OpenModalResumo(item1);
        },
        modalOpenWithAtendimento (item1) {
            this.$refs.modalResumo.modalOpenAtendimento(item1);
        },
        handleOpenModalConfirmHome (data) {
            this.$refs.modalResumo.handleOpenModalConfirm(item);
        },
        totalPageCalcula () {
            let array = Array.from(Array(this.pagination.totalPage), (e, i)=>i + 1);
            this.totalPage = array;
        },
        openModalProspectHome (item1) {
            this.$refs.modalResumo.openModalProspect(item1);
        },
        openModalCancelAtendimentoQuenteHome (item1) {
            this.$refs.modalResumo.openModalCancelAtendimentoQuente(item1);
        },
        //!!! modal Confirm Home
        openModalProspect (prospect) {
            const nameCurto = prospect.nome.split(' ')[0];
            this.modalConfirm = {
                open: true,
                text: `Deseja converter <b class="text-primary-pure">${nameCurto}</b> em um cliente `,
                data: prospect,
                id: 'prospect'
            };
        },
        selectRentabilidade (type, client) {
            this.$refs.modalResumo.selectRentabilidade(type, client);
        },
        //-------------------------------------------
        //!!! GET  🍃 Home
        async getAtendimentos () {
            try {
                const params = new URLSearchParams();
                const dataInicialPoliticaFormated = this.data_inicial_politica.split('/').reverse().join('-');
                params.append('data_inicial', dataInicialPoliticaFormated);
                const dataFinalPoliticaFormated = this.data_final_politica.split('/').reverse().join('-');
                params.append('data_final', dataFinalPoliticaFormated);
                /* 				const end = this.isFundacao
					? '?exibicao=fundacao'
					: '?exibicao=cliente_pf' */ params.append('exibicao', this.isFundacao ? 'fundacao' : 'cliente_pf');
                params.append('search', this.queryAtendimento.search);
                const request = await $31cda782274f73ad$var$api.get(`/api/atendimentos/?${params.toString()}`);
                const data = await request.data.results;
                this.atendimentos = data?.atendimentos;
                this.status = data?.status;
                this.isFundacao && this.initChartRealizados();
                setTimeout(()=>{
                    $31cda782274f73ad$var$initTipy();
                }, 150);
            } catch (e) {
                $31cda782274f73ad$var$errorDefault(e);
            }
        },
        async getProspect (paramUrl) {
            try {
                const url = paramUrl ?? `/api/clientepf/?prospect=true`;
                const request = await $31cda782274f73ad$var$api.get(url);
                this.paginationChange(request.data);
                const data = await request.data.results;
                this.prospect = data;
                setTimeout(()=>$31cda782274f73ad$var$initTipy(), 150);
            } catch (e) {
                $31cda782274f73ad$var$errorDefault(e);
            }
        },
        paginationChange (data) {
            this.pagination = {
                ...this.pagination,
                elementPerPage: 10,
                totalPage: Math.ceil(data.count / this.pagination.elementPerPage),
                next: data.next,
                previous: data.previous
            };
            this.totalPageCalcula();
        },
        async next () {
            await this.getProspect(this.pagination.next);
            this.pagination.page = this.pagination.page + 1;
        },
        async previous () {
            await this.getProspect(this.pagination.previous);
            this.pagination.page = this.pagination.page - 1;
        },
        async clickPage (page) {
            await this.getProspect(`/api/clientepf/?prospect=true&page=${page}`);
            this.pagination.page = page;
        },
        async getAtendimentosQuentes () {
            try {
                const url = this.isFundacao ? `/api/fundacao/?atendimento_quente=true` : `/api/clientepf/?atendimento_quente=true`;
                const request = await $31cda782274f73ad$var$api.get(url);
                const data = await request.data.results;
                this.atendimentosQuentes = data;
                setTimeout(()=>$31cda782274f73ad$var$initTipy(), 150);
            } catch (e) {
                $31cda782274f73ad$var$errorDefault(e);
            }
        },
        async getAtendimentoQuenteByFundacaoUnique (idFundacao) {
            const { data: data } = await $31cda782274f73ad$var$api.get(`/api/fundacao/?atendimento_quente=true&id=${idFundacao}`);
            return data?.results[0];
        },
        //--------------------------------------------
        //!!! SENDS HOME
        async sendProspectFalse (prospect) {
            const obj = {
                prospect: false
            };
            try {
                const request2 = await axios.patch(`/api/clientepf/${prospect.id}/`, {
                    ...obj
                });
                await this.getProspect();
                const nameCurto = this.isFundacao ? request2.data.sigla : request2.data.nome.split(' ')[0];
                $31cda782274f73ad$var$showToastify(`\u{2705} ${nameCurto} foi convertido(a) em cliente.`);
                this.modalConfirm = {};
            } catch (e) {
                $31cda782274f73ad$var$errorDefault(e);
            }
        },
        async sendNewProspect (e) {
            e.preventDefault();
            const form = document.querySelector('#form_novo_prospect');
            if (!form.checkValidity()) {
                form.querySelectorAll('.field').forEach((i)=>$31cda782274f73ad$var$addClassForTime(i, 'required-field', 3000));
                $31cda782274f73ad$var$showToastify("\u26A0\uFE0F Preencha todos os campos obrigat\xf3rios para enviar");
                return;
            } else {
                const fields = form.querySelectorAll('[name]');
                const obj = Array.from(fields).reduce((acc, { name: name, value: value })=>{
                    const valueLimpo = name == 'patrimonio_externo' ? value ? $31cda782274f73ad$var$FormatREALBackEnd(value) : 0 : value;
                    acc[name] = valueLimpo;
                    return acc;
                }, {});
                obj.prospect = true;
                obj.usuario_responsavel = [
                    $31cda782274f73ad$var$userLogado
                ] //necessario enviar um array
                ;
                try {
                    NProgress.start();
                    const request = await axios.post(`/api/clientepf/`, obj);
                    await this.getProspect();
                    $31cda782274f73ad$var$showToastify("\u2705 Prospect criado com sucesso");
                    modal_padrao.closeModal();
                // if (this.clienteAtivo.id) {
                // 	await this.getDadosModal(this.clienteAtivo.id, true);
                // }
                } catch (e) {
                    $31cda782274f73ad$var$errorDefault(e);
                } finally{
                    NProgress.done();
                }
            }
        },
        async sendNewTask (obj) {
            const { data: data } = await this.$refs.modalResumo.sendNewTask(obj);
            this.activeAbaTask(false);
            this.novaTaskOpen = false;
            setTimeout(()=>{
                const el = document.querySelector(`.item-task[data-id='${data.id}']`);
                el && $31cda782274f73ad$var$addClassForTime(el, '!border-primary-pure', 3000);
                el && el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 300);
        },
        async taskEnviadaSucess (text) {
            await this.activeAbaTask(false);
            $31cda782274f73ad$var$showToastify(text);
        },
        //-----------------------------------------------
        debounceFunction: (fn, timing, wait = 200)=>{
            return (...args)=>{
                clearTimeout(timing);
                timing = setTimeout(()=>fn(...args), wait);
            };
        },
        async initChartRealizados () {
            const params = new URLSearchParams();
            const dataInicialPoliticaFormated = this.data_inicial_politica.split('/').reverse().join('-');
            params.append('data_inicial', dataInicialPoliticaFormated);
            const dataFinalPoliticaFormated = this.data_final_politica.split('/').reverse().join('-');
            params.append('data_final', dataFinalPoliticaFormated);
            const request = await $31cda782274f73ad$var$api.get(`${window.location.origin}/atendimento/grafico_realizados_semana/?${params.toString()}`);
            const data = await request.data;
            const dataChart = [
                {
                    name: 'Realizado',
                    type: 'column',
                    data: Object.values(data.grafico_realizado)
                },
                {
                    name: 'Previsto',
                    type: 'line',
                    data: Object.values(data.grafico_previsto)
                }
            ];
            window.chartRealizados?.updateOptions({
                series: dataChart,
                labels: Object.keys(data.grafico_previsto)
            });
            this.chartHomeLoading = false;
        },
        async getTarefas () {
            try {
                const dataInicialFormated = this.data_inicial.split('/').reverse().join('-');
                const dataFinalFormated = this.data_final.split('/').reverse().join('-');
                const { data: data } = await $31cda782274f73ad$var$api.get(`/api/tarefas/?data_inicial=${dataInicialFormated}&data_final=${dataFinalFormated}`);
                this.tarefas = data.results?.map((i)=>({
                        ...i,
                        nome: this.isFundacao ? i.nome_fundacao : i.nome_cliente_pf,
                        politica: this.isFundacao ? i.politica_fundacao : i.politica_cliente
                    }));
                this.tarefas = this.ordenateTarefas();
            } catch (e) {
                $31cda782274f73ad$var$errorDefault(e);
            }
        },
        async handlePeriodoTasks () {
            await this.getTarefas();
        },
        async handlePeriodoPolitica () {
            await this.getAtendimentos();
            this.$refs.tableAtendimento.atualizarAgendamentoDetalhes();
        },
        setDates () {
            const hoje = new Date();
            const primeiroDiaMesAnterior = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
            const dataFinal = Quasar.date.addToDate(hoje, {
                days: 30
            });
            this.data_inicial = Quasar.date.formatDate(primeiroDiaMesAnterior, 'DD/MM/YYYY');
            this.data_final = Quasar.date.formatDate(dataFinal, 'DD/MM/YYYY');
            this.data_inicial_politica = Quasar.date.formatDate(primeiroDiaMesAnterior, 'DD/MM/YYYY');
            this.data_final_politica = Quasar.date.formatDate(dataFinal, 'DD/MM/YYYY');
        },
        ordenateTarefas () {
            return this.tarefas.map((i)=>{
                if (i.get_status == '3') i.ordem = 1;
                if (i.get_status == '1') i.ordem = 2;
                if (i.get_status == '2') i.ordem = 3;
                if (i.get_status == '0') i.ordem = 4;
                return i;
            }).sort((a, b)=>a.ordem - b.ordem);
        },
        async activeAbaTask (progress = true) {
            progress && NProgress.start();
            await this.getTarefas();
            // this.ordenateTarefas()
            if (progress) this.abatask = true;
            progress && NProgress.done();
        },
        async activeAbaProcesso (progress = true) {
            this.processos = [];
            progress && NProgress.start();
            await this.getProcessosFundacao();
            // this.ordenateTarefas()
            $31cda782274f73ad$var$initTipy();
            if (progress) {
                this.abaProcesso = true;
                this.createChartEstrategias();
            }
            progress && NProgress.done();
        },
        deactivateAbaTask () {
            this.abatask = false;
        },
        getPercent (real, total) {
            const calc = real / total * 100;
            return `${isNaN(calc.toFixed()) ? 0 : calc.toFixed()}%`;
        },
        sortedArray ({ event: event, key: key, dataKey: dataKey, number: number }) {
            this.stateSave.searchs.searchFilterAtendimentos = (a)=>a;
            const target = event.currentTarget;
            const att = target.getAttribute('order');
            target.closest('thead').querySelectorAll('th').forEach((el)=>el !== target && el.removeAttribute('order'));
            if (att == 'up') target.setAttribute('order', 'down');
            if (att == 'down') target.setAttribute('order', 'up');
            if (!att) target.setAttribute('order', 'up');
            const clone = this[dataKey];
            const result = clone.sort((a, b)=>{
                const A = number ? a[key] : a[key].toLowerCase();
                const B = number ? b[key] : b[key].toLowerCase();
                if (A < B) return -1;
                if (B > A) return 1;
                return 0;
            });
            this[dataKey] = att == 'up' ? result : result.reverse();
        },
        handleClickSearch (id) {
            this.modalOpen({
                id: id
            });
        },
        changeScrollState () {
            this.isProspectsPaused = !this.isProspectsPaused;
        },
        async getValuesSemAtendimentoQuente () {
            const prospect_quente_values = this.isFundacao && await this.getFundacoesSemAtendimentoQuente();
            this.fundacoesSemAtendimentoQuente = prospect_quente_values.lista_fundacoes;
            this.isFundacao && this.setChoicesFundacaoSemAtendimentoQuente();
            this.isFundacao && this.setChoicesFundosByFundacao(prospect_quente_values.todos_os_fundos);
            this.isFundacao && this.setChoicesEscalasByFundacao(prospect_quente_values.todas_as_escalas);
        },
        clearClienteAtendimentoRapidoUnico () {
            this.timeStampLimpaTabel = Date.now();
            this.clearClienteAtendimentoRapido();
        },
        async createAtendimentoRapidoUnico (tipoAtendimentoRapido, menssagemAtendimentoRapido) {
            await this.createAtendimentoRapido(tipoAtendimentoRapido, menssagemAtendimentoRapido);
            this.clearClienteAtendimentoRapidoUnico();
            window.location = `${window.origin}/atendimento/home_fundacao/`;
        }
    },
    async created () {
        this.activeAbaProcesso(false);
        this.setDates();
        !this.isFundacao && this.getProspect();
        this.getAtendimentosQuentes();
        await this.getAtendimentos();
        this.haveProspect = true;
        await this.getValuesSemAtendimentoQuente();
        this.activeAbaTask(false);
    },
    async mounted () {
        await this.$refs.modalResumo.getTags();
        this.isFundacao && this.addEventButtons();
        this.isFundacao && this.addEventSelectFundacao();
        this.initializeChartEstrategiaToggle();
        this.isFundacao && await this.getSemestres();
        await this.getFundacoes();
        $31cda782274f73ad$var$initTipy();
        this.stateSave.searchs.searchFilterAtendimentos = (newValue, oldValue)=>{
            const maped = newValue.map((i)=>{
                if (i.status == 'Pendente') i.ordem = 1;
                if (i.status == 'Atrasado') i.ordem = 2;
                if (i.status == 'Realizado') i.ordem = 3;
                return i;
            }).sort((a, b)=>a.ordem - b.ordem);
            return maped;
        };
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("4nzoT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3304c5383a58886e$export$2e2bcd8739ae039; });

var $2m7Ys = parcelRequire("2m7Ys");

var $bG4BG = parcelRequire("bG4BG");

var $23ZM6 = parcelRequire("23ZM6");

var $8t0Yl = parcelRequire("8t0Yl");

var $5pg84 = parcelRequire("5pg84");

var $cqNI6 = parcelRequire("cqNI6");

var $aZQYO = parcelRequire("aZQYO");

var $edB7g = parcelRequire("edB7g");

var $U7jaT = parcelRequire("U7jaT");

var $kcxIT = parcelRequire("kcxIT");

var $1UZGW = parcelRequire("1UZGW");

var $niAA9 = parcelRequire("niAA9");

var $4Fazw = parcelRequire("4Fazw");

var $i5cs0 = parcelRequire("i5cs0");

var $dgm2Z = parcelRequire("dgm2Z");

var $jWBFq = parcelRequire("jWBFq");

var $j0jCN = parcelRequire("j0jCN");

var $5XTTN = parcelRequire("5XTTN");

var $kKHf6 = parcelRequire("kKHf6");

var $9YhWF = parcelRequire("9YhWF");

var $cpXN9 = parcelRequire("cpXN9");

var $hmmUY = parcelRequire("hmmUY");

var $jzAJi = parcelRequire("jzAJi");

var $415wX = parcelRequire("415wX");
const { createSetorChart: $3304c5383a58886e$var$createSetorChart } = (0, $j0jCN.useSetorChart)();
const { getInformacoesFundacao: $3304c5383a58886e$var$getInformacoesFundacao } = (0, $hmmUY.fundacaoService)();
const { getInfoAtendimentoCliente: $3304c5383a58886e$var$getInfoAtendimentoCliente } = (0, $jzAJi.clientAssetsService)();
const { setValueInChoices: $3304c5383a58886e$var$setValueInChoices, politicas: $3304c5383a58886e$var$politicas, isFundacao: $3304c5383a58886e$var$isFundacao, showToastify: $3304c5383a58886e$var$showToastify, initFlatpickr: $3304c5383a58886e$var$initFlatpickr, getChoicesActive: $3304c5383a58886e$var$getChoicesActive, api: $3304c5383a58886e$var$api, changeColorModal: $3304c5383a58886e$var$changeColorModal, FormatREALBackEnd: $3304c5383a58886e$var$FormatREALBackEnd, FormatREAL: $3304c5383a58886e$var$FormatREAL, estadosBR: $3304c5383a58886e$var$estadosBR, dispatchEventChange: $3304c5383a58886e$var$dispatchEventChange, addClassForTime: $3304c5383a58886e$var$addClassForTime, errorDefault: $3304c5383a58886e$var$errorDefault, initTipy: $3304c5383a58886e$var$initTipy, setSelectedOptionInChoices: $3304c5383a58886e$var$setSelectedOptionInChoices, colorsChatAtendimento: $3304c5383a58886e$var$colorsChatAtendimento } = GLOBAL;
let $3304c5383a58886e$var$userLogado = document.getElementById('usuario-logado').value;
NProgress.configure({
    trickleSpeed: 40,
    trickle: true,
    minimum: 0.65
});
var $3304c5383a58886e$export$2e2bcd8739ae039 = {
    template: document.getElementById('template-component-modal'),
    props: [
        'atendimentos',
        'sendNewProspect'
    ],
    mixins: [
        (0, $i5cs0.default),
        (0, $dgm2Z.default),
        (0, $jWBFq.default),
        (0, $cpXN9.default)
    ],
    emits: [
        'get-atendimentos',
        'get-atendimentos-quentes',
        'setId'
    ],
    data () {
        return {
            below1660px: window.matchMedia('(max-width:1666px)').matches,
            chaves: [],
            rentabilidades: {
                rentabilidade_bm_ano: '-',
                rentabilidade_bm_12_meses: '-',
                rentabilidade_bm_inicio: '-',
                selected: 'cdi'
            },
            clientepf: [],
            modalConfirm: {},
            fundacoes_select: [],
            consultorias: [],
            setores: [],
            options_status: [
                {
                    value: 'prospect',
                    label: 'Prospect'
                },
                {
                    value: 'entrada_recorrente',
                    label: 'Entrada Recorrente'
                },
                {
                    value: 'manutencao',
                    label: "Manuten\xe7\xe3o"
                },
                {
                    value: 'saida_recorrente',
                    label: "Sa\xedda Recorrente"
                }
            ],
            novoAtendimentoOpen: false,
            tabInformacoesOpen: false,
            pontosContato: [],
            pontoContatoItem: {},
            tarefas: [],
            processos: [],
            fundos: [],
            estrategias: [],
            clienteAtivo: {
                tag: []
            },
            clienteAtivoEditado: {
                tag: []
            },
            atendimentoIDAtivo: null,
            atendimentoIDAtivoEdit: null,
            alterarSobre: false,
            atendimentosModal: [],
            atendimentosModalView: [],
            politicaAtendimentoSelect: [],
            atendimentoData: [],
            estados: '',
            adicionarContato: false,
            isFundacao: $3304c5383a58886e$var$isFundacao(),
            editor: {
                descricao: '',
                observacoes: ''
            },
            inputDate: '',
            agendaPoliticas: null,
            optionsAgendaPoliticas: [
                [
                    'Update',
                    'Update'
                ],
                [
                    "Reuni\xe3o",
                    "Reuni\xe3o"
                ]
            ],
            novaPoliticaOpen: false,
            novaTaskOpen: false,
            novoProcessOpen: false,
            activeTabTaskProcesso: 'tarefas',
            modalConfirm: {},
            tags: [],
            atendimentosQuentes: [],
            bordaPura: false,
            openModal: false,
            widthLine: '',
            fundos: [],
            officers: '',
            usuariosResponsaveis: '',
            atendimentos_editar: [],
            periodo_ativo_liquidez: '',
            ativosLiquidez: false,
            ativosRating: false,
            chart_setor: false,
            semestres: [],
            activeTabAtendimento: 'Geral',
            atendimentosSequoia: [],
            fundacaoIdSelecionadoSequoia: null,
            isFundacaoSequoia: false,
            listTabsFundacao: []
        };
    },
    components: {
        CadastrarAtendimento: $bG4BG.default,
        UserDadosModal: $23ZM6.default,
        UserEditDadosModal: $8t0Yl.default,
        AtendimentoItem: $5pg84.default,
        NovoContato: $cqNI6.default,
        AgendaPoliticasItem: $aZQYO.default,
        NovaPolitica: $edB7g.default,
        TaskItem: $U7jaT.default,
        NewTaskItem: $kcxIT.default,
        ConfirmModal: $1UZGW.default,
        AvatarPersona: $4Fazw.default,
        NewProcessoItem: $5XTTN.default,
        ProcessoItem: $kKHf6.default
    },
    watch: {
        pontosContato: {
            //ordena por principal
            handler (newValue, oldValue) {
                if (newValue.length) {
                    const novo = JSON.stringify(newValue?.map((i)=>i.principal));
                    const velho = JSON.stringify(oldValue?.map((i)=>i.principal));
                    if (novo !== velho) return this.pontosContato.sort((x, y)=>Number(x.principal) - Number(y.principal)).reverse();
                }
            },
            deep: true
        },
        clienteAtivo: {
            handler () {
                this.clienteAtivo.estado_sigla = this.setEstadoSigla(this.clienteAtivo.estado_id || this.clienteAtivo.estado);
            },
            deep: true
        },
        agendaPoliticas: {
            handler () {
                if (this.agendaPoliticas) this.agendaPoliticas = this.agendaPoliticas.sort(function(a, b) {
                    return new Date(b.data) - new Date(a.data);
                });
            },
            deep: true
        },
        async 'clienteAtivo.tag' () {
            await this.getTags();
            if (window.choicesTag) window.choicesTag.destroy();
            const select = document.querySelector('#select-add-tag');
            const choices = GLOBAL.initChoices(select);
            const arrTagIds = this.clienteAtivo.tag?.map(({ id: id })=>id);
            window.choicesTag = choices;
            const optionsFiltradas = this.tags.map((tag)=>({
                    value: tag.id,
                    label: tag.titulo
                })).map((tag)=>({
                    ...tag,
                    disabled: arrTagIds.includes(tag.value)
                }));
            choices.setChoices([
                ...optionsFiltradas
            ], 'value', 'label', true);
            window.listOfChoices = [
                ...window.listOfChoices,
                choices
            ];
            (0, $niAA9.default)();
        },
        activeTabAtendimento () {
            /* console.log(this.atendimentosModal) */ this.filterAtendimentosByAba();
        }
    },
    computed: {
        tabOptions () {
            if (!this.listTabsFundacao || !this.listTabsFundacao.length) return [];
            const geral = this.listTabsFundacao.find((tab)=>this.toPascalCase(tab.nome) === 'Geral');
            const outros = this.listTabsFundacao.filter((tab)=>this.toPascalCase(tab.nome) !== 'Geral' && tab.nome !== "SEQU\xd3IA");
            const tabsOrdenadas = [];
            if (geral) tabsOrdenadas.push({
                id: geral.id,
                nome: geral.nome
            });
            tabsOrdenadas.push(...outros.map((tab)=>({
                    id: tab.id,
                    nome: tab.nome
                })));
            return tabsOrdenadas;
        },
        activeTabAtendimentoNome () {
            if (this.listTabsFundacao.length && this.activeTabAtendimento) {
                const tipoAbaFundacao = this.listTabsFundacao.find((item)=>item.id === Number(this.activeTabAtendimento));
                if (tipoAbaFundacao?.nome) return this.toPascalCase(tipoAbaFundacao.nome);
            }
            return 'Geral';
        },
        async criaAtendimentoRapidoSequoia ({ textoAtendimento: textoAtendimento, tituloAtendimento: tituloAtendimento, dataAtendimento: dataAtendimento }) {
            try {
                const responseAtendimentoRapido = await this.createAtendimentoRapido('0', textoAtendimento, tituloAtendimento, dataAtendimento ?? null);
            } catch (e) {
                console.log(e);
            }
        },
        atendimentoTotalCount () {
            if (this.atendimentosModalView) {
                const atualData = new Date();
                return this.atendimentosModalView.filter((item)=>new Date(item.data).getFullYear() >= atualData.getFullYear());
            }
            return [];
        },
        agendaPoliticasTotalCount () {
            if (this.agendaPoliticas) {
                const atualData = new Date();
                return this.agendaPoliticas.filter((item)=>new Date(item.data).getFullYear() >= atualData.getFullYear());
            }
            return [];
        },
        tarefasTotalCount () {
            const dataAtual = new Date();
            if (this.tarefas) {
                const tarefasAtuais = this.tarefas.filter((item)=>new Date(item.data).getFullYear() >= dataAtual.getFullYear());
                if (this.isFundacao) {
                    if (this.processos) {
                        const processosAtuais = this.processos.filter((item)=>new Date(item.data).getFullYear() >= dataAtual.getFullYear());
                        return [
                            ...tarefasAtuais,
                            ...processosAtuais
                        ];
                    }
                }
                return tarefasAtuais;
            }
        },
        classBelow1660px () {
            return {
                below1660: this.below1660px
            };
        },
        patrimonioFormated () {
            const value = $3304c5383a58886e$var$FormatREAL(this.isFundacao ? this.clienteAtivo.patrimonio : this.clienteAtivo.patrimonio_externo);
            return value;
        },
        valorTotalPatrimonio () {
            const valorTotal = this.formatMoeda(this.isFundacao ? this.clienteAtivo.patrimonio : this.clienteAtivo.patrimonio_manual && this.clienteAtivo.patrimonio_manual > 0 ? (Number(this.clienteAtivo.patrimonio_manual) || 0) + (Number(this.clienteAtivo.patrimonio_interno) || 0) : this.clienteAtivo.patrimonio_interno);
            return valorTotal;
        }
    },
    methods: {
        async getAtendimentosSequoia (id) {
            const { getAtendimentosFundacao: getAtendimentosFundacao } = (0, $415wX.default)();
            return await getAtendimentosFundacao(id);
        },
        async criarAtendimentoRapidoSequoia ({ tituloAtendimento: tituloAtendimento, textoAtendimento: textoAtendimento, dataAtendimento: dataAtendimento }) {
            try {
                const responseAtendimentoRapido = await this.createAtendimentoRapido('0', textoAtendimento, tituloAtendimento, dataAtendimento ?? null);
            } catch (e) {
                console.log(e);
            }
        },
        filtrarAtendimentosPorTab (idTab) {
            this.activeTabAtendimento = idTab;
            var item;
            return this.atendimentosModalView;
        },
        openModalSolitacao (id, tipoSolicitacao) {
            //const nameCurto = prospect.nome.split(' ')[0]
            if (tipoSolicitacao === 'delete') this.modalConfirm = {
                open: true,
                text: `Deseja mesmo excluir esse atendimento? `,
                data: {
                    id: id
                },
                id: 'solicitar_delete',
                botao: "Solicitar exclus\xe3o",
                header: 'Excluir atendimento'
            };
            else if (tipoSolicitacao === 'edicao') this.modalConfirm = {
                open: true,
                text: `Deseja editar esse atendimento? `,
                data: {
                    id: id
                },
                id: 'solicitar_editar',
                botao: "Solicitar edi\xe7\xe3o",
                header: 'Editar atendimento'
            };
            else if (tipoSolicitacao === 'edicao_contato') this.modalConfirm = {
                open: true,
                text: `Deseja editar esse contato? `,
                data: {
                    id: id
                },
                id: 'solicitar_editar_contato',
                botao: "Solicitar edi\xe7\xe3o",
                header: 'Editar Ponto de Contato'
            };
        },
        isValidEditPontoContato (IdContato) {
            let status;
            if (this.status_edita_ponto_contato) {
                const _status = this.status_edita_ponto_contato.filter((statusEditaContato)=>statusEditaContato[1] === IdContato)[0] || [];
                if (_status && _status?.length > 0) status = _status[0];
            }
            if (status === 'Aprovado') return true;
            return false;
        },
        async editPontoContato (contato, event) {
            if (this.isFundacao) {
                contato.isEditEnabled = true;
                this.editContatos(contato, event);
                return;
            }
            const idContato = contato?.id;
            if (this.isValidEditPontoContato(idContato)) {
                contato.isEditEnabled = true;
                contato.isEditar = false;
                this.editContatos(contato, event);
            } else {
                contato.isEditar = true;
                contato.isEditEnabled = false;
                this.editContatos(contato, event);
            }
        },
        async checkFundacaoSequoia (id) {
            try {
                const { data: data } = await $3304c5383a58886e$var$api.get(`${(0, $9YhWF.URLS).atendimento_sequoia}?fundacao=${id}`);
                return data.fundacoes_sequoia && data.fundacoes_sequoia.length > 0;
            } catch (e) {
                console.error("Erro ao verificar funda\xe7\xe3o Sequoia:", e);
                return false;
            }
        },
        async sendSolicitacaoEdicaoContato () {
            try {
                const id = this.modalConfirm.data?.id;
                const responseSolicitarEdicao = await axios.get(`/clientes/solicitar_editar/${id}/`);
                if (responseSolicitarEdicao.data?.error) throw new Error(responseSolicitarEdicao.data?.error);
                GLOBAL.showToastify("\u2705 Solicita\xe7\xe3o enviada com sucesso");
                //await this.getDadosModal(this.clienteAtivo.id, true)
                await this.getDadosUpdateModal();
                this.modalConfirm = {};
            } catch (e) {
                GLOBAL.showToastify(`\u{274C} ${e.message || "Erro ao solicitar edi\xe7\xe3o do contato"}`);
            } finally{
                NProgress.done();
            }
        },
        async sendRequestAtendimento () {
            const idModal = this.modalConfirm.id;
            if (idModal === 'solicitar_delete') await this.sendRequestDeleteAtendimento();
            else if (idModal === 'solicitar_editar') await this.sendRequestEdicaoAtendimento();
        },
        async sendRequestDeleteAtendimento () {
            try {
                const id = this.modalConfirm.data?.id;
                const responseSolicitarDelete = await axios.delete(`/atendimento/solicitar_delete/${id}`);
                if (responseSolicitarDelete.data?.error) throw new Error(responseSolicitarDelete.data?.error);
                GLOBAL.showToastify("\u2705 Solicita\xe7\xe3o enviada com sucesso");
                await this.getDadosModal(this.clienteAtivo.id, true);
                this.modalConfirm = {};
            } catch (e) {
                GLOBAL.showToastify(`\u{274C} ${e.message || "Erro ao solicitar exclus\xe3o"}`);
            } finally{
                NProgress.done();
            }
        },
        async sendRequestEdicaoAtendimento () {
            try {
                const id = this.modalConfirm.data?.id;
                const responseSolicitarEditar = await axios.get(`/atendimento/solicitar_editar/${id}`);
                if (responseSolicitarEditar.data?.error) throw new Error(responseSolicitarEditar.data?.error);
                GLOBAL.showToastify("\u2705 Solicita\xe7\xe3o enviada com sucesso");
                await this.getDadosModal(this.clienteAtivo.id, true);
                this.modalConfirm = {};
            } catch (e) {
                GLOBAL.showToastify(`\u{274C} ${e.message || "Erro ao solicitar edi\xe7\xe3o"}`);
            } finally{
                NProgress.done();
            }
        },
        async OpenModalResumo ({ id: id, atendimentoID: atendimentoID }) {
            NProgress.start();
            const tab1 = document.querySelector(".tab-item[data-tab='tab-modal-1']");
            tab1 && tab1.click();
            this.usuariosResponsaveis = [];
            await this.getProcessosFundacao(id);
            await this.getDadosModal(id);
            await this.getChavesRentabilidades();
            this.isFundacaoSequoia = await this.checkFundacaoSequoia(id);
            this.updateSelectsModal();
            this.atendimentoIDAtivo = atendimentoID;
            $3304c5383a58886e$var$changeColorModal(this.clienteAtivo.politica, $3304c5383a58886e$var$politicas);
            setTimeout(()=>{
                modal_full.openModal('resumo-1');
                this.openModal = true;
                this.fundacaoIdSelecionadoSequoia = id;
            }, 50);
            NProgress.done();
            $3304c5383a58886e$var$initTipy();
            (0, $niAA9.default)();
            const itemTab = this.listTabsFundacao.find((item)=>item.nome === 'Geral');
            if (itemTab) this.activeTabAtendimento = itemTab.id;
        },
        async modalOpenAtendimento ({ id: id, atendimentoID: atendimentoID }) {
            this.below1660px && this.toggleTabInformacoes(true);
            document.querySelector(".tab-item[data-tab='tab-modal-1']").click();
            await this.OpenModalResumo({
                id: id,
                atendimentoID: atendimentoID
            });
            setTimeout(()=>{
                this.toggleNovoAtendimentoOpen(true);
                this.bordaPura = true;
                setTimeout(()=>{
                    this.bordaPura = false;
                }, 1500);
                setTimeout(()=>document.querySelector('.cadastrar [name="atendimento"]').focus(), 300);
            }, 450);
        },
        updateSelectsModal () {
            // Dispara change para mudar valores
            $3304c5383a58886e$var$setValueInChoices('cliente-modal-select', this.clienteAtivo.id) // seleciona cliente ativo
            ;
            $3304c5383a58886e$var$setValueInChoices('estado-modal-select', String(this.clienteAtivo.estado_id));
            $3304c5383a58886e$var$setValueInChoices('politica-modal-select', this.clienteAtivo.politica);
            if (this.usuariosResponsaveis?.length) $3304c5383a58886e$var$setValueInChoices('responsavel-modal-select', this.usuariosResponsaveis.map((i)=>i.id));
            $3304c5383a58886e$var$dispatchEventChange('#estado-modal-select');
            $3304c5383a58886e$var$dispatchEventChange('#cliente-modal-select');
            $3304c5383a58886e$var$dispatchEventChange('#politica-modal-select');
            $3304c5383a58886e$var$dispatchEventChange('#date-modal-input');
            $3304c5383a58886e$var$dispatchEventChange('#responsavel-modal-select');
        },
        closeModal (e) {
            const btnPerfil = document.querySelector('[name=btn-tab-perfil]');
            const btnInvestimentos = document.querySelector('[name=btn-tab-investimentos]');
            modal_full.closeModal();
            this.toggleTabInformacoes(false);
            this.toggleNovoAtendimentoOpen(false);
            this.alterarSobre = false;
            this.novaPoliticaOpen = false;
            // this.agendaPoliticas = "";
            this.novaPoliticaOpen = false;
            this.atendimentoIDAtivo = null;
            this.infoGraficoModal = null;
            this.isPerfil = false;
            this.activeTab = 'investimentos';
            this.rendaFixa = false;
            this.ativo_table = false;
            this.ativosLiquidez = false;
            this.ativosRating = false;
            this.resetButtonsFilters();
            btnPerfil.classList.remove(...[
                'active',
                'secondary'
            ]);
            btnPerfil.classList.add('tertiary');
            btnInvestimentos.classList.add(...[
                'active',
                'secondary'
            ]);
            btnInvestimentos.classList.remove('tertiary');
            const accordionWrapper = document.querySelector('#atendimento-wrapper');
            if (accordionWrapper?.querySelector('.accordion-tittle.active')) accordionWrapper.click();
            this.emptyFields(this.atendimentoData, document.querySelector('#novoAtendimentoForm'));
            this.destroyAllCharts();
            if (this.pontosContato.length) this.pontosContato = this.pontosContato.map((i)=>{
                i.edicao = false;
                return i;
            });
            this.fundacaoIdSelecionado = null;
        },
        formatOfficersNames (officers) {
            return officers.map(({ nome: nome })=>nome.split('.').map((word)=>(0, $2m7Ys.capitalize)(word)).join(' ')).join(', ');
        },
        async getLimitesLiquidez (clienteID) {
            const url = `api/tabela_clientepf/detalhes_limites_liquidez/?cliente=${clienteID}`;
            const responseLimiteLiquidez = await $3304c5383a58886e$var$api.get(url);
            return responseLimiteLiquidez.data;
        },
        async getDadosModal (id, updateSameCliente) {
            this.modalConfirm = {};
            if (id !== this.clienteAtivo.id || updateSameCliente) try {
                let request = null;
                let url = '';
                let atendimentosApi = null;
                if (this.isFundacao) /* url = `/atendimento/informacoes_modal_fundacao/?fundacao=${id}` */ /* await api.get(
							`${URLS.atendimento_sequoia}?fundacao=${id}`
						) */ request = await $3304c5383a58886e$var$getInformacoesFundacao(`?fundacao=${id}`);
                else {
                    url = `/atendimento/informacoes_modal_cliente_pf/?`;
                    request = await $3304c5383a58886e$var$getInfoAtendimentoCliente(`?cliente_pf=${id}`);
                }
                /* request = await api.get(url) */ const { atendimentos: atendimentos, tarefas: tarefas, clientes: clientes, contatos: contatos, grafico_carteira: grafico_carteira, status_exclusao: status_exclusao, status_edicao: status_edicao, status_edita_ponto_contato: status_edita_ponto_contato, concentracoes: concentracoes, consultorias: consultorias, tags: tags, politica_atendida: politica_atendida, fundacoes: fundacoes, tarefas_realizadas: tarefas_realizadas, bm_cdi: bm_cdi, id_carteira: id_carteira, status_cliente: status_cliente, data_atual_carteira: data_atual_carteira, total_eventos_de_credito: total_eventos_de_credito, usuario_responsavel: usuario_responsavel, tipo_fundacao: tipo_fundacao } = await request;
                const officerSpan = document.querySelector('.officer');
                if (officerSpan && usuario_responsavel?.length) officerSpan.textContent = `Officers: ${this.formatOfficersNames(usuario_responsavel)}`;
                this.usuariosResponsaveis = usuario_responsavel;
                if (this.isFundacao) {
                    if (!tipo_fundacao || !Array.isArray(tipo_fundacao) || tipo_fundacao.length === 0 || tipo_fundacao.length === 1 && (tipo_fundacao[0] === 0 || tipo_fundacao[0] === '0') || tipo_fundacao === '0') this.listTabsFundacao = [
                        {
                            id: 3,
                            nome: 'Geral',
                            ativo: true
                        }
                    ];
                    else this.listTabsFundacao = tipo_fundacao;
                    let atendimentosSequoia = [];
                    const temAbaSequoia = tipo_fundacao.some((item)=>this.toPascalCase(item.nome) === 'Sequoia');
                    if (temAbaSequoia) {
                        this.fundacaoIdSelecionado = id;
                        const sequoiaData = await this.getAtendimentosSequoiaById();
                        atendimentosSequoia = sequoiaData?.atendimentos_por_fundacao[0]?.atendimentos || [];
                        atendimentosSequoia = atendimentosSequoia.map((item)=>({
                                ...item,
                                tipo_atendimento: 'Sequoia',
                                isAtendimentoSequoia: true
                            }));
                    }
                    const todosAtendimentos = [
                        ...atendimentos || [],
                        ...atendimentosSequoia
                    ];
                    atendimentosApi = {
                        atendimento_politicas: todosAtendimentos
                    };
                } else atendimentosApi = atendimentos;
                this.setAtendimentosModal(atendimentosApi, usuario_responsavel, status_exclusao, status_edicao);
                this.setContatos(contatos, this.isFundacao ? fundacoes : clientes);
                this.fundacoes_select = fundacoes || [];
                this.setClientePF(this.isFundacao ? fundacoes : clientes);
                this.agendaPoliticas = [];
                this.setAgendaPoliticas(atendimentos.filter((atendimento)=>atendimento.data));
                this.total_eventos_de_credito = total_eventos_de_credito;
                this.clienteAtivo = this.clientepf.filter((i)=>i.id == id)[0];
                this.graficoCarteira = grafico_carteira;
                this.margens = concentracoes;
                this.consultorias = consultorias;
                this.idCarteira = id_carteira;
                this.dataAtualCarteira = data_atual_carteira;
                this.atendimentos_editar = atendimentos;
                this.status_edita_ponto_contato = status_edita_ponto_contato;
                if (!this.isFundacao) {
                    this.setOptionSelectedStatus(status_cliente);
                    this.setDates();
                    this.ondisableAtualizarVolatilidade();
                }
                this.setTarefas(tarefas);
                this.clienteAtivo.politica_atendida = politica_atendida;
                if (this.isFundacao) this.clienteAtivo.tarefas_realizadas = `${tarefas_realizadas == '-' ? '-' : `${tarefas_realizadas}%`}`;
                this.setClienteTags(tags);
                if (!this.isFundacao) {
                    if (bm_cdi.length) this.fillRentabilidades(bm_cdi[0]);
                    this.rentabilidades.selected = 'cdi';
                    const choice = GLOBAL.getChoicesActive('rentabilidade-modal-select', window.listOfChoices);
                    $3304c5383a58886e$var$setSelectedOptionInChoices(choice, '1');
                }
                this.updateSelectsModal();
                return request;
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        async getProcessosFundacao (id) {
            try {
                const url = `/clientes/processos_fundacoes/?id=${id}`;
                const { data: data } = await $3304c5383a58886e$var$api.get(url);
                this.processos = data?.results?.processos || [];
                this.estrategias = data?.results?.estrategias?.map((estrategia)=>({
                        value: estrategia.id,
                        label: estrategia.nome
                    }));
                this.fundos = data?.results?.fundos?.map((fundo)=>({
                        value: fundo.id,
                        label: fundo.sigla
                    }));
                this.semestres = data?.results?.semestres?.map((item)=>({
                        value: item.id,
                        label: item.semestre
                    }));
            } catch (error) {
                console.log(error);
            }
        },
        async getDadosUpdateModal () {
            await this.getDadosModal(this.clienteAtivo.id, true);
            $3304c5383a58886e$var$changeColorModal(this.clienteAtivo.politica, $3304c5383a58886e$var$politicas);
        },
        async getTags () {
            try {
                const end = this.isFundacao ? '?tag_sai=true' : '?tag_sap=true';
                const request = await $3304c5383a58886e$var$api.get(`/api/tag/${end}/`);
                const data = await request.data;
                this.tags = data?.results;
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        async getRentabilidades (value) {
            try {
                const { data: data } = await axios.get(`/api/benchmark/?cliente_pf=${this.clienteAtivo.id}&chave=${value}`);
                if (!data.results.length) {
                    this.rentabilidades.rentabilidade_bm_ano = '-';
                    this.rentabilidades.rentabilidade_bm_12_meses = '-';
                    this.rentabilidades.rentabilidade_bm_inicio = '-';
                    return;
                }
                this.fillRentabilidades(data.results[0]);
            } catch (err) {
                $3304c5383a58886e$var$errorDefault(err);
            }
        },
        setAgendaPoliticas (data) {
            this.agendaPoliticas = data;
        },
        setAtendimentosModal (data, usuario_responsavel, exclusao_status, edicao_status) {
            this.officers = this.formatOfficersNames(usuario_responsavel);
            if (this.isFundacao) {
                this.setSelectPoliticas(data.atendimento_politicas);
                this.atendimentosModal = data.atendimento_politicas || [];
                /* 	this.atendimentosSequoia = data.atendimento_sequoia
					? data.atendimento_sequoia.map((item) => {
							item.isAtendimentoSequoia = true
							return item
					  })
					: [] */ /* this.atendimentosModalView = this.atendimentosModal.filter(
					(item) => item.atendimento
				) */ this.filterAtendimentosByAba();
            } else {
                this.setSelectPoliticas(data);
                this.atendimentosModal = data;
                const atendimentosModal = data.filter((i)=>i.atendimento);
                const atendimentosModalViewWithStatusExclusaoAndEdicao = atendimentosModal.map((atendimento)=>{
                    const status = exclusao_status.filter((status)=>status[1] === atendimento.id);
                    const statusEdicao = edicao_status.filter((statusEdicao)=>statusEdicao[1] === atendimento.id);
                    return {
                        ...atendimento,
                        status_exclusao: status,
                        status_edicao: statusEdicao
                    };
                });
                this.atendimentosModalView = atendimentosModalViewWithStatusExclusaoAndEdicao;
            }
        },
        setSelectPoliticas (data) {
            this.politicaAtendimentoSelect = [
                ...data
            ];
            const seDateOption = (i)=>{
                const data = (v)=>`${moment(v.data, 'YYYY-MM-DD').format('DD/MM/YYYY')} ${v.atendimento ? ' - Realizado' : ''}`;
                return {
                    value: i.id,
                    label: data(i)
                };
            };
            const opts = this.politicaAtendimentoSelect.map(seDateOption);
            this.populateSelect('politica-modal-select', opts);
        },
        defineColors (labels) {
            const c = [];
            labels?.forEach((label)=>{
                const obj = GLOBAL.tipos_investimentos?.find((obj)=>obj.tipo == label);
                if (obj) c.push(obj.color);
            });
            return c;
        },
        async reloadModalData () {
            NProgress.start();
            await this.getDadosModal(this.clienteAtivo.id, true);
            await this.getProcessosFundacao(this.clienteAtivo.id);
            this.setGraficoCarteira();
            this.setGraficoPerfilInvestidor();
            NProgress.done();
        },
        async getPerfilInvestidor (id) {
            try {
                const { data: data } = await $3304c5383a58886e$var$api.get(`api/perfil_investidor/${id}/`);
                this.perfilInvestidor = data;
            } catch (error) {
                console.log(error);
            }
        },
        toggleClass (el, names) {
            names.forEach((name)=>{
                el.classList.toggle(name);
            });
        },
        handleClickBtnsChartsFilter () {
            const btns = document.querySelectorAll('.btn-chart-filter');
            btns.forEach((btn)=>{
                btn.addEventListener('click', (e)=>{
                    GLOBAL.destroyApexChart([
                        'chartAtivo',
                        'chartEmissor',
                        'chartTipo',
                        'chartIndice',
                        'chartTempoVencimentoIPCA',
                        'chartTempoVencimentoPos',
                        'chartTempoVencimentoPre'
                    ]);
                    let btnAtual = null;
                    btns.forEach((i)=>{
                        if (i.classList.contains('active')) btnAtual = i;
                    });
                    if (btnAtual == btn) return;
                    if (!btn.classList.contains('active')) this.toggleClass(btn, [
                        'active',
                        'secondary',
                        'tertiary'
                    ]);
                    const filterBtn = [];
                    btns.forEach((b)=>{
                        if (btn.id != b.id) filterBtn.push(b);
                    });
                    filterBtn.forEach((i)=>{
                        i.classList.remove('active');
                        i.classList.remove('secondary');
                        i.classList.add('tertiary');
                    });
                });
            });
        },
        clickChartAtivo (nameSelected) {
            this.ativo_chart = true;
            this.ativo_table = true;
            this.emissor_chart = false;
            this.tipo_chart = false;
            this.indice_chart = false;
            this.tempo_vencimento_chart = false;
            this.ativosRating = false;
            this.getInfoModalClienteTabInvestimentos(nameSelected);
        },
        // async getDadosItensCarteira() {
        // 	NProgress.start()
        // 	try {
        // 		const { data } = await axios.get(
        // 			`${window.location.origin}/api/carteira/${this.idCarteira}`
        // 		)
        // 		console.log({data})
        // 		data &&
        // 			data.itens_carteira.forEach((i) => {
        // 				if (i.tipo_investimento === 'Renda Fixa') {
        // 					this.emissores = i.emissores
        // 					this.tipos = i.tipos
        // 					this.indices = i.indices
        // 					this.tempo_vencimento = i.tempo_vencimento
        // 				}
        // 			})
        // 	} catch (e) {
        // 		errorDefault(e)
        // 	} finally {
        // 		NProgress.done()
        // 	}
        // },
        templateBodyTable (list_investimentos) {
            let template = '';
            list_investimentos?.forEach((item)=>{
                template += `<tr>
				<td class="py-10" data-reference="coluna_1">
					<div class="flex gap-4 items-center ">
						<div class="cursor-pointer">
	
						</div>
	
						${item.tipo_investimento}
					</div>
	
				</td>
				<td class="py-10 centralizado" data-reference="coluna_2">
				
				${Number(item.pct_renda_fixa).toFixed(2)}
				</td>
				<td class="py-10 centralizado" data-reference="coluna_3">
				${Number(item.pct_global).toFixed(2)}
				</td>
				<td class="py-10 centralizado" data-reference="coluna_4">
					${GLOBAL.formatReal2(item.valor)}
				</td>
				<td class="py-10 centralizado" data-reference="coluna_5">
				
				${Number(item.taxa).toFixed(2)}
				</td>
				<td class="py-10 centralizado" data-reference="coluna_6">
				${item.vencimento}
				</td>
				<td class="py-10 centralizado" data-reference="coluna_7">
					${item.indexador}
				</td>
	
			</tr>`;
            });
            return template;
        },
        templateBodyTableOutrosInvestimentos (list_investimentos) {
            let template = '';
            list_investimentos?.forEach((item)=>{
                template += `<tr>
				<td class="py-10" data-reference="coluna_1">
					<div class="flex gap-4 items-center ">
						<div class="cursor-pointer">
	
						</div>
	
						${item.tipo_investimento}
					</div>
	
				</td>
				<td class="py-10 centralizado" data-reference="coluna_2">
				
				${Number(item.pct_global).toFixed(2)}
				</td>
				<td class="py-10 centralizado" data-reference="coluna_3">
				${Number(item.pct_tipo_investimento).toFixed(2)}
				</td>
				<td class="py-10 centralizado" data-reference="coluna_4">
					${GLOBAL.formatReal2(item.valor)}
				</td>
				
	
			</tr>`;
            });
            return template;
        },
        async alternaVisualizacaoChartAtivo (e) {
            const el = e.target;
            let classOutroBtn = '.table-btn';
            if (el.classList.contains('chart-btn')) {
                this.ativo_table = false;
                classOutroBtn = '.table-btn';
            } else if (el.classList.contains('table-btn')) {
                this.ativo_table = true;
                classOutroBtn = '.chart-btn';
            }
            if (!el.classList.contains('active')) {
                this.toggleClass(el, [
                    'active',
                    'secondary',
                    'tertiary'
                ]);
                if (classOutroBtn) this.toggleClass(document.querySelector(classOutroBtn), [
                    'active',
                    'secondary',
                    'tertiary'
                ]);
            }
        },
        async getDadosInvestimentosClientes (nameSelected) {
            try {
                NProgress.start();
                const url = `${window.location.origin}/atendimento/grafico_composicao_cliente_pf/?cliente_pf=${this.clienteAtivo.id}&tipo_investimento=${nameSelected}`;
                const { data: data } = await axios.get(url);
                const investimentos = data?.composicao_investimentos;
                const valores = Object.values(investimentos);
                return valores;
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        async getDadosInvestimentosClientesRendaFixaLiquidez () {
            try {
                NProgress.start();
                const url = `${window.location.origin}/atendimento/grafico_composicao_cliente_pf/?cliente_pf=${this.clienteAtivo.id}`;
                // &tipo_investimento=Renda Fixa
                const { data: data } = await axios.get(url);
                const investimentos = data;
                //const valores = Object.values(investimentos)
                return investimentos;
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        exportPdf (id) {
            if (!id) return;
            window.location.href = `${window.location.origin}/clientes/gera_html_cliente/${id}/`;
        },
        async getDadosInvestimentosClientesFilter (tipo, paramFilter) {
            try {
                NProgress.start();
                const url = `${window.location.origin}/atendimento/grafico_composicao_cliente_pf/?cliente_pf=${this.clienteAtivo.id}&tipo_investimento=${tipo}&${paramFilter}`;
                const { data: data } = await axios.get(url);
                const investimentos = data;
                //const valores = Object.values(investimentos)
                return investimentos;
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        formatGraficoCarteiraItemToSort (item) {
            const itemSerialized = {
                ...item,
                pct_global: Number(item.pct_global),
                pct_renda_fixa: Number(item.pct_renda_fixa),
                valor: Number(item.valor)
            };
            if (item.taxa) itemSerialized.taxa = Number(item.taxa);
            if (item.pct_renda_fixa) itemSerialized.pct_renda_fixa = Number(item.pct_renda_fixa);
            if (item.pct_tipo_investimento) itemSerialized.pct_tipo_investimento = Number(item.pct_tipo_investimento);
            if (item.vencimento) itemSerialized.vencimento = GLOBAL.convertStringDateToDateInstance(item.vencimento).getTime();
            return itemSerialized;
        },
        onSortAtivosTable (orderByKey) {
            let graficoCarteiraSerialized = [];
            if (orderByKey === this.ativosTableSortKey) this.ativosTableSortOrderInDesc = !this.ativosTableSortOrderInDesc;
            this.ativosTableSortKey = orderByKey;
            if (this.rendaFixa) graficoCarteiraSerialized = this.carteiraTabelaInvestimento.map(this.formatGraficoCarteiraItemToSort);
            else graficoCarteiraSerialized = this.graficoCarteira.map(this.formatGraficoCarteiraItemToSort);
            const graficoCarteiraSorted = GLOBAL.mergeSortAnArrayWithObjects(graficoCarteiraSerialized, orderByKey, this.ativosTableSortOrderInDesc);
            return graficoCarteiraSorted.map((item)=>({
                    ...item,
                    vencimento: item.vencimento ? GLOBAL.formatDateObject(new Date().setTime(item.vencimento)) : ''
                }));
        },
        onSortAtivosTableRendaFixa (orderByKey) {
            let table = document.querySelector('#table_ativos');
            if (!table) table = document.querySelector('#table_ativos_liquidez');
            const bodyTable = table.querySelector('tbody');
            const ativosSorted = this.onSortAtivosTable(orderByKey);
            bodyTable.innerHTML = this.templateBodyTable(ativosSorted);
        },
        onSortAtivosTableOutrosInvestimentos (orderByKey) {
            const table = document.querySelector('#table_ativos');
            const bodyTable = table.querySelector('tbody');
            const ativosSorted = this.onSortAtivosTable(orderByKey);
            bodyTable.innerHTML = this.templateBodyTableOutrosInvestimentos(ativosSorted);
        },
        async clickItensInvestimentos (nameSelected) {
            this.ativo_chart = true;
            this.ativo_table = true;
            NProgress.start();
            try {
                const results = await this.getDadosInvestimentosClientes(nameSelected);
                const table = document.querySelector('#table_ativos');
                const bodyTable = table.querySelector('tbody');
                this.graficoCarteira = results?.map((i)=>({
                        valor: i[0].valor,
                        tipo_investimento: i[0].nome,
                        pct_global: i[0].pct_global,
                        pct_tipo_investimento: i[0].pct_tipo_investimento
                    }));
                bodyTable.innerHTML = this.templateBodyTableOutrosInvestimentos(this.graficoCarteira);
                const chartAtendimento = Apex._chartInstances?.filter((i)=>i.id == 'chartTabInvestimentos')[0];
                chartAtendimento?.chart.destroy();
                GLOBAL.destroyApexChart([
                    'chartTabInvestimentos'
                ]);
                this.setGraficoAtivo({
                    name: nameSelected
                });
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        toggleClass (el, names) {
            names.forEach((name)=>{
                el.classList.toggle(name);
            });
        },
        async getDadosItensCarteira () {
            NProgress.start();
            try {
                const { data: data } = await axios.get(`${window.location.origin}/api/carteira/${this.idCarteira}`);
                data && data.itens_carteira.forEach((i)=>{
                    if (i.tipo_investimento === 'Renda Fixa') {
                        this.emissores = i.emissores['todos'];
                        this.setores = i.emissores?.setores;
                        this.emissores_fgc = i.emissores['FGC'];
                        this.tipos = i.tipos['todos'];
                        this.tipos_fgc = i.tipos['FGC'];
                        this.indices = i.indices;
                        this.tempo_vencimento = i.tempo_vencimento;
                    }
                });
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        async alternaVisualizacaoChartTipo (e) {
            const el = e.target;
            let classOutroBtn = '.tipos_fgc';
            if (el.classList.contains('tipos_todos')) {
                classOutroBtn = '.tipos_fgc';
                await this.getInfoChartFiltro('#chart-tipo', 'chartTipo', this.tipos, 'tipos', true);
            } else if (el.classList.contains('tipos_fgc')) {
                classOutroBtn = '.tipos_todos';
                //alterar pra nova variavel ainda
                await this.getInfoChartFiltro('#chart-tipo', 'chartTipo', this.tipos_fgc, 'tipos');
            }
            if (!el.classList.contains('active')) {
                this.toggleClass(el, [
                    'active',
                    'secondary',
                    'tertiary'
                ]);
                if (classOutroBtn) this.toggleClass(document.querySelector(classOutroBtn), [
                    'active',
                    'secondary',
                    'tertiary'
                ]);
            }
        },
        async onSelectChange (event) {
            this.clienteAtivoEditado = {
                ...this.clienteAtivoEditado,
                status_cliente: event?.target?.value || ''
            };
            await this.sendClienteAtivoEditado();
        },
        //Grafico por emissor
        async getInfoModalEmissor (nameSelected) {
            this.ativosRating = false;
            this.rating_chart = false;
            this.ativo_chart = false;
            this.emissor_chart = true;
            this.tipo_chart = false;
            this.indice_chart = false;
            this.tempo_vencimento_chart = false;
            this.ativosLiquidez = false;
            await this.getDadosItensCarteira();
            await this.getInfoChartFiltro('#chart-emissor', 'chartEmissor', this.emissores, 'emissores', true);
        },
        orderTable () {
            this.graficoCarteira = this.graficoCarteira.reverse();
            const table = document.querySelector('#table_ativos');
            const bodyTable = table.querySelector('tbody');
            bodyTable.innerHTML = this.templateBodyTable(this.graficoCarteira);
        },
        setEstadoSigla (id) {
            const estado = $3304c5383a58886e$var$estadosBR.filter((i)=>i.id == id);
            return estado.length ? estado[0].sigla : '';
        },
        setPolitica (id) {
            const users = this.isFundacao ? $3304c5383a58886e$var$politicas.fundacao : $3304c5383a58886e$var$politicas.clientePF;
            const politicasArr = Object.entries(users).map(([key, value])=>value);
            const final = politicasArr.filter((i)=>id == i.id);
            return final.length ? final[0].name : null;
        },
        setContatos (data) {
            this.pontosContato = data;
            if (this.usuariosResponsaveis.length) {
                const selectOpts = this.usuariosResponsaveis?.map(({ id: id, nome: nome })=>({
                        value: id,
                        label: nome
                    }));
                this.populateSelect('responsavel-modal-select', selectOpts);
                $3304c5383a58886e$var$dispatchEventChange('#responsavel-modal-select');
            }
        },
        setAtendimentoData (data) {
            this.atendimentoData = data;
        },
        setId (id) {
            // setValueInChoices('cliente-modal-select', this.clienteAtivo.id)
            this.setSelectPoliticas(this.atendimentos_editar);
            this.atendimentoIDAtivo = id;
            setTimeout(()=>{
                this.updateSelectsModal();
            }, 300);
        },
        //fetchs
        setClientePF (data) {
            this.clientepf = data;
            this.populateSelectClientePF();
        },
        setClienteTags (data) {
            this.clienteAtivo.tag = data;
        // setTimeout(() => {
        // }, 300);
        },
        async setToggleContatoPrincipal (contato) {
            try {
                const request = await axios.patch(`/api/contatos/${contato.id}/`, {
                    principal: !contato.principal
                });
                await this.getDadosModal(this.clienteAtivo.id, true);
                this.modalConfirm = {};
                const nomeCurto = contato.nome.split(' ')[0];
                $3304c5383a58886e$var$showToastify(`\u{2705} ${nomeCurto} Alterado(a) com sucesso.`);
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        async setAtendimentoQuente () {
            try {
                const url = this.isFundacao ? `/api/fundacao/${this.clienteAtivo.id}/` : `/api/clientepf/${this.clienteAtivo.id}/`;
                const request = await axios.patch(url, {
                    atendimento_quente: true
                });
                const nameCurto = this.isFundacao ? this.clienteAtivo.sigla : request.data.nome.split(' ')[0];
                $3304c5383a58886e$var$showToastify(`\u{2705} ${nameCurto} agora \xe9 um atendimento quente.`);
                this.modalConfirm = {};
                await this.getDadosModal(this.clienteAtivo.id, true);
                // await this.getAtendimentosQuentes()
                this.$emit('get-atendimentos-quentes');
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        async setCancelAtendimentoQuente (data) {
            try {
                const url = this.isFundacao ? `/api/fundacao/${data.id}/` : `/api/clientepf/${data.id}/`;
                const request = await axios.patch(url, {
                    atendimento_quente: false
                });
                const nameCurto = this.isFundacao ? request.data.sigla : this.clienteAtivo.sigla;
                $3304c5383a58886e$var$showToastify(`\u{2705} ${nameCurto} foi removido(a) dos atendimentos quentes.`);
                this.modalConfirm = {};
                this.$emit('get-atendimentos-quentes');
                this.$emit('get-values-sem-atendimento-quente');
                await this.getDadosModal(data.id, true);
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        async setTarefas (tasks) {
            this.tarefas = tasks.map((i)=>({
                    ...i,
                    nome: this.isFundacao ? this.clienteAtivo.sigla : this.clienteAtivo.nome,
                    politica: this.clienteAtivo.politica
                }));
        },
        async getChavesRentabilidades () {
            const response = await $3304c5383a58886e$var$api.get('/api/benchmark/chaves/');
            const { data: data } = response;
            this.chaves = Object.entries(data);
            this.setOptionsRentabilidades();
        },
        setOptionSelectedStatus (status) {
            const selectStatus = GLOBAL.getChoicesActive('status-modal-select', window.listOfChoices);
            if (status[0].status_cliente) selectStatus?.setChoiceByValue(status[0].status_cliente);
        },
        setOptionsRentabilidades () {
            if (this.chaves.length) {
                const selectOpts = this.chaves.map((item)=>({
                        value: item[0],
                        label: item[1]
                    }));
                this.populateSelect('rentabilidade-modal-select', selectOpts);
                const selectRentabilidade = GLOBAL.getChoicesActive('rentabilidade-modal-select', window.listOfChoices);
                const item = this.chaves[0];
                selectRentabilidade?.setChoiceByValue(item[0]);
            }
        },
        async fillRentabilidades (rentabilidades) {
            if (this.clienteAtivo?.rentabilidade_ano <= 0 || rentabilidades?.rentabilidade_bm_ano <= 0) this.rentabilidades.rentabilidade_bm_ano = '-';
            else this.rentabilidades.rentabilidade_bm_ano = Number(this.clienteAtivo?.rentabilidade_ano / rentabilidades?.rentabilidade_bm_ano * 100).toFixed(2) || '-';
            if (this.clienteAtivo?.rentabilidade_12_meses <= 0 || rentabilidades?.rentabilidade_bm_12_meses <= 0) this.rentabilidades.rentabilidade_bm_12_meses = '-';
            else this.rentabilidades.rentabilidade_bm_12_meses = Number(this.clienteAtivo.rentabilidade_12_meses / rentabilidades?.rentabilidade_bm_12_meses * 100).toFixed(2) || '-';
            if (this.clienteAtivo?.rentabilidade_desde_inicio <= 0 || rentabilidades?.rentabilidade_bm_inicio <= 0) this.rentabilidades.rentabilidade_bm_inicio = '-';
            else this.rentabilidades.rentabilidade_bm_inicio = Number(this.clienteAtivo.rentabilidade_desde_inicio / rentabilidades?.rentabilidade_bm_inicio * 100).toFixed(2) || '-';
        },
        async sendEdicao ({ id: id, index: index }) {
            try {
                await axios.patch(`/api/contatos/${id}/`, {
                    ...this.pontosContato[index],
                    ...this.pontoContatoItem
                });
                this.pontosContato[index] = {
                    ...this.pontosContato[index],
                    ...this.pontoContatoItem
                };
                this.pontosContato[index].editado = false;
                this.editor.observacoes = '';
                this.editor.descricao = '';
                this.pontoContatoItem = {};
                $3304c5383a58886e$var$showToastify("\u2705 Contato editado com sucesso.");
                this.setContatos(this.pontosContato);
                await axios.post(`${window.location.origin}/clientes/editado/${id}/`, this.pontosContato[index]);
                await this.getDadosUpdateModal();
                $3304c5383a58886e$var$initTipy();
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        async sendAdicionarContato (obj) {
            if (!obj.nome) {
                $3304c5383a58886e$var$showToastify("\u26A0\uFE0F Preencha o nome antes de enviar");
                return;
            }
            try {
                await axios.post(`/api/contatos/`, {
                    ...obj,
                    [this.isFundacao ? 'fundacao' : 'cliente_pf']: this.clienteAtivo.id,
                    principal: this.pontosContato.length >= 1 ? false : true
                });
                await this.getDadosModal(this.clienteAtivo.id, true);
                tippy('[data-tippy-content]', {
                    allowHTML: true,
                    placement: 'top',
                    boundary: 'HTMLElement'
                });
                document.querySelectorAll('.novo-atendimento p[contenteditable]').forEach((i)=>i.innerText = '');
                this.adicionarContato = false;
                $3304c5383a58886e$var$showToastify("\u2705 Contato Criado Com Sucesso.");
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        async sendAtendimento (dados) {
            const politicaSelected = dados.tipo === '0';
            const tipoAbaFundacao = this.listTabsFundacao.find((itemTab)=>itemTab.id === Number(dados.tipoAtendimento || this.activeTabAtendimento));
            try {
                NProgress.start();
                this.novoAtendimentoOpen = false;
                const [dia, mes, ano] = dados.data_atendimento?.split('/');
                const data_atendimento = moment(new Date(ano, mes - 1, dia)).toDate();
                const data = dados.data ? moment(new Date(dados.data), 'DD/MM/YYYY').toDate() : null;
                const obj = {
                    ...dados,
                    usuario_responsavel: [
                        ...dados.contato_atendimento
                    ],
                    data_atendimento: data_atendimento,
                    data: politicaSelected ? data : null,
                    tipo_atendimento: tipoAbaFundacao ? this.toPascalCase(tipoAbaFundacao.nome) : null,
                    concluido: true
                };
                delete obj.contato_atendimento;
                if (this.isFundacao) {
                    delete obj.cliente_pf;
                    obj.fundacao = this.clienteAtivo.id;
                } else delete obj.modalidade_fundacao;
                delete obj.politica_atendimento;
                let request;
                if (this.isFundacao && this.activeTabAtendimentoNome === 'Sequoia') {
                    this.fundacaoIdSelecionado = this.clienteAtivo.id || this.fundacaoIdSelecionado;
                    this.criarAtendimentoRapidoSequoia({
                        tituloAtendimento: obj.titulo_atendimento,
                        textoAtendimento: obj.atendimento,
                        dataAtendimento: obj.data_atendimento
                    });
                } else if (politicaSelected) {
                    if (dados.politica_atendimento == this.atendimentoIDAtivo) obj.concluido = true;
                    request = await axios.put(`${window.location.origin}/api/atendimentos/${dados.politica_atendimento}/`, obj);
                    await axios.post(`${window.location.origin}/atendimento/editado/${dados.politica_atendimento}`, obj);
                } else if (dados.id) request = await axios.put(`${window.location.origin}/api/atendimentos/${dados.id}/`, obj);
                else request = await axios.post(`${window.location.origin}/api/atendimentos/`, obj);
                // if (politicaSelected) {
                // 	if (dados.politica_atendimento == this.atendimentoIDAtivo) obj.concluido = true
                // 	request = dados?.id ? await axios.post(`${window.location.origin}/atendimento/editado/${dados.politica_atendimento}`, obj) :
                // 	await axios.put(`${window.location.origin}/api/atendimentos/${dados.politica_atendimento}/`, obj)
                // } else {
                // 	request = dados.id ? await axios.put(`${window.location.origin}/api/atendimentos/${dados.id}/`, obj) :
                // 	await axios.post(`${window.location.origin}/api/atendimentos/`, obj)
                // }
                await this.getDadosModal(this.clienteAtivo.id, true);
                this.emptyFields(dados, document.querySelector('#novoAtendimentoForm'));
                $3304c5383a58886e$var$showToastify("\u2705 Atendimento criado com sucesso.");
                if (!(this.isFundacao && this.isFundacaoSequoia && this.activeTabAtendimento !== 'sequoia')) {
                    const atendimentoWrapper = document.getElementById('atendimento-wrapper');
                    const last = atendimentoWrapper.querySelector(`[data-accordion="acc-${await request.data.id}"]`);
                    if (last && !last.parentElement.classList.contains('active')) last.click();
                    else {
                        last && last.click();
                        setTimeout(()=>{
                            last && last.click();
                        }, 150);
                    }
                    setTimeout(()=>{
                        last && last.scrollIntoView({
                            behavior: 'smooth',
                            block: 'end'
                        });
                        $3304c5383a58886e$var$addClassForTime(last?.closest('.item-borda'), 'border-primary-pure', 2000);
                    }, 200);
                }
                this.$emit('get-atendimentos');
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            } finally{
                NProgress.done();
                $3304c5383a58886e$var$dispatchEventChange('#date-modal-input');
                $3304c5383a58886e$var$dispatchEventChange('#novoAtendimentoForm');
            }
        },
        async getAtendimentosEmit () {
            await this.getDadosModal(this.clienteAtivo.id, true);
        },
        async sendClienteAtivoEditado (message = true) {
            NProgress.start();
            try {
                const obj = {
                    ...this.clienteAtivoEditado,
                    taxa: this.clienteAtivoEditado.taxa ? Number(String(this.clienteAtivoEditado.taxa).replace(',', '.')).toFixed(2) : null,
                    tag: this.clienteAtivoEditado.tag?.length ? this.clienteAtivoEditado.tag.map((i)=>i.id) : [],
                    patrimonio_externo: this.clienteAtivoEditado.patrimonio_externo ? $3304c5383a58886e$var$FormatREALBackEnd(this.clienteAtivoEditado.patrimonio_externo) : 0,
                    patrimonio_manual: this.clienteAtivoEditado.patrimonio_manual ? $3304c5383a58886e$var$FormatREALBackEnd(this.clienteAtivoEditado.patrimonio_manual) : 0,
                    estado: Number(this.clienteAtivoEditado.estado_id)
                };
                const url = this.isFundacao ? `/api/fundacao/${this.clienteAtivo.id}/` : `/api/clientepf/${this.clienteAtivo.id}/`;
                const request = await axios.patch(url, obj);
                this.alterarInformacoesSobre(false);
                const nomeCurto = this.isFundacao ? request.data.sigla : request.data.nome.split(' ')[0];
                const text = this.isFundacao ? `\u{2705} Funda\xe7ao ${nomeCurto} alterado(a) com sucesso.` : `\u{2705} Cliente ${nomeCurto} alterado(a) com sucesso.`;
                message && $3304c5383a58886e$var$showToastify(text, {
                    className: 'sucess'
                });
                await this.getDadosUpdateModal();
                this.populateSelectClientePF();
                this.$emit('get-atendimentos');
                if (this.clienteAtivo.atendimento_quente) this.$emit('get-atendimentos-quentes');
            } catch (e) {
                this.clienteAtivoEditado = this.clienteAtivo;
                $3304c5383a58886e$var$errorDefault(e);
            }
            NProgress.done();
        },
        async sendNewTask (obj) {
            //COM ERRO
            NProgress.start();
            if (!obj.deadline || !obj.descricao) {
                $3304c5383a58886e$var$showToastify("\u26A0\uFE0F Preencha Todos os campos");
                return;
            }
            try {
                const cliente = {
                    [this.isFundacao ? 'fundacao' : 'cliente_pf']: this.clienteAtivo.id
                };
                const request2 = await axios.post(`/api/tarefas/`, {
                    ...obj,
                    ...cliente,
                    deadline: moment(obj.deadline, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    status: '1',
                    usuario_responsavel: [
                        $3304c5383a58886e$var$userLogado
                    ]
                });
                this.novaTaskOpen = false;
                if (this.clienteAtivo?.id) await this.getDadosModal(this.clienteAtivo.id, true);
                $3304c5383a58886e$var$showToastify("\u2705 Tarefa Criada com sucesso.");
                return request2;
            } catch (e) {
                this.novaTaskOpen = false;
                $3304c5383a58886e$var$errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        async sendNewProcesso (obj) {
            NProgress.start();
            const { valor: valor } = obj;
            let valorFinal = 0;
            if (valor.includes(',')) {
                const valorTransformado = parseFloat(valor.replaceAll('.', '').replace(',', '.')) * 10;
                valorFinal = valorTransformado.toFixed(2);
            } else if (valor.length == 3) valorFinal = (parseFloat(valor) / 100).toFixed(2);
            else valorFinal = valor;
            try {
                const response = await axios.post(`${window.location.origin}/clientes/processos_fundacoes/`, {
                    ...obj,
                    fundacao: this.clienteAtivo.id,
                    valor: valorFinal
                });
                this.novoProcessOpen = false;
                if (this.clienteAtivo?.id) {
                    await this.getDadosModal(this.clienteAtivo.id, true);
                    await this.getProcessosFundacao(this.clienteAtivo.id);
                }
                $3304c5383a58886e$var$showToastify("\u2705 Processo Criado com sucesso.");
                return response;
            } catch (e) {
                this.novoProcessOpen = false;
                $3304c5383a58886e$var$errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        async sendAddTag (_, idTag = false) {
            const select = document.querySelector('#select-add-tag');
            const value = idTag ? idTag : select.value;
            this.updateClienteAtivo(this.clienteAtivo);
            if (!value) {
                $3304c5383a58886e$var$showToastify("\u26A0\uFE0F Selecione uma TAG para prosseguir");
                return;
            }
            this.clienteAtivoEditado.tag.push({
                id: value
            });
            try {
                await this.sendClienteAtivoEditado(true);
                modal_padrao.closeModal();
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        async sendNewTag () {
            const form = document.getElementById('form-create-tag');
            if (!form.checkValidity()) $3304c5383a58886e$var$showToastify("\u26A0\uFE0F Preencha todos os campos para criar uma TAG");
            else {
                const fields = [
                    ...form.querySelectorAll('[name]')
                ];
                const obj = fields.reduce((acc, { name: name, value: value })=>{
                    acc[name] = value;
                    return acc;
                }, {});
                if (this.isFundacao) obj.tag_sai = true;
                else obj.tag_sap = true;
                try {
                    const request = await axios.post(`/api/tag/`, obj);
                    const data = await request.data;
                    this.sendAddTag(false, await data.id);
                    $3304c5383a58886e$var$showToastify("\u2705 Tag criada e adicionada com sucesso.");
                    modal_padrao.closeModal();
                    await this.getDadosModal(this.clienteAtivo.id, true);
                } catch (e) {
                    $3304c5383a58886e$var$errorDefault(e);
                }
            }
        },
        openModalAtendimentoQuente () {
            const nameCurto = this.isFundacao ? this.clienteAtivo.sigla : this.clienteAtivo.nome.split(' ')[0];
            this.modalConfirm = {
                open: true,
                text: `Deseja converter <b class="text-primary-pure">${nameCurto}</b> em um atendimento quente`,
                data: this.clienteAtivo,
                id: 'quente',
                class: 'fire'
            };
        },
        openModalCancelAtendimentoQuente (item) {
            const nameCurto = this.isFundacao ? item.sigla : item.nome.split(' ')[0];
            this.modalConfirm = {
                open: true,
                text: `Deseja remover <b class="text-primary-pure">${nameCurto}</b> dos atendimentos quentes`,
                data: item,
                id: 'cancel-quente',
                class: 'remove',
                botao: 'Remover'
            };
        },
        openModalRemoveTag (tag) {
            const nameCurto = this.isFundacao ? this.clienteAtivo.sigla : this.clienteAtivo.nome.split(' ')[0];
            this.modalConfirm = {
                open: true,
                text: `Deseja remover <b class="text-primary-pure">${tag.titulo}</b> do(a) cliente ${nameCurto}`,
                data: tag,
                id: 'remove-tag',
                class: 'remove',
                botao: 'Remover'
            };
        },
        openModalPrincipalStar (contato) {
            const nameCurto = contato.nome.split(' ')[0];
            const text = contato.principal ? `Deseja remover <b class="text-primary-pure">${nameCurto}</b> dos contatos principais` : `Deseja tornar <b class="text-primary-pure">${nameCurto}</b> o contato  principal`;
            this.modalConfirm = {
                open: true,
                text: text,
                data: contato,
                id: 'principal-star',
                class: contato.principal ? 'remove' : ''
            };
        },
        //------------------------------------------------------------
        async removeTag (tag) {
            this.updateClienteAtivo(this.clienteAtivo);
            const arrTagRemovida = this.clienteAtivoEditado.tag.filter((i)=>i.id != tag.id);
            this.clienteAtivoEditado.tag = arrTagRemovida;
            try {
                this.modalConfirm = {};
                await this.sendClienteAtivoEditado(false);
                $3304c5383a58886e$var$showToastify("\u2705 Tag Removida com sucesso.");
            } catch (e) {
                $3304c5383a58886e$var$errorDefault(e);
            }
        },
        colorTag (cor) {
            return {
                '--color': cor
            };
        },
        toggleTabInformacoes (status) {
            this.tabInformacoesOpen = status;
            _BIG({
                status: status
            });
        },
        toggleNovoAtendimentoOpen (status) {
            this.novoAtendimentoOpen = status;
            this.updateSelectsModal();
        },
        formatMoeda (value) {
            return Number(value).toLocaleString('pt-BR');
        },
        arrExample (n) {
            return Array(n).fill(0);
        },
        alterarInformacoesSobre (value) {
            this.alterarSobre = value;
        },
        populateSelect (selectID, opts) {
            const choices = GLOBAL.getChoicesActive(selectID, window.listOfChoices);
            choices?.clearStore();
            choices?.setChoices([
                ...opts
            ], 'value', 'label', true);
        },
        async sendTaskEditadaSucess (text) {
            // this.OpenModalSucesso(text)
            $3304c5383a58886e$var$showToastify(text);
            await this.getDadosModal(this.clienteAtivo.id, true);
        },
        async sendProcessoEditadoSucess (text) {
            $3304c5383a58886e$var$showToastify(text);
            await this.getProcessosFundacao(this.clienteAtivo.id);
            $3304c5383a58886e$var$initTipy();
        },
        handleChangePontosContato ({ event: event, id: id, index: index }) {
            const target = event.currentTarget;
            const name = target.getAttribute('name');
            this.pontoContatoItem[name] = target.innerText;
            this.pontosContato[index].editado = true;
        },
        handleChangePontosContatoEditor ({ v: v, index: index, name: name }) {
            this.pontoContatoItem[name] = v;
            this.pontosContato[index].editado = true;
        },
        emptyFields (data, form) {
            Object.entries(data).map(([key, _])=>{
                const el = form.querySelector(`[name="${key}"]`);
                if (el) {
                    if (el.tagName === 'SELECT') {
                        const choices = GLOBAL.getChoicesActive(el.id, listOfChoices);
                        choices && choices.removeActiveItems();
                    } else el.value = '';
                    el.dispatchEvent(new Event('change', {
                        bubbles: true,
                        cancelable: true
                    }));
                }
            });
            form.dispatchEvent(new Event('change', {
                bubbles: true,
                cancelable: true
            }));
            form.querySelectorAll('.required-field').forEach((i)=>i.classList.remove('required-field'));
        },
        toPascalCase (str) {
            return (0, $2m7Ys.startCase)((0, $2m7Ys.camelCase)(str)).replace(/ /g, '');
        },
        filterAtendimentosByAba () {
            let atendimentosFiltrados = null;
            if (this.listTabsFundacao.length && this.activeTabAtendimento && this.atendimentosModal) {
                const tipoAbaFundacao = this.listTabsFundacao.find((item)=>item.id === this.activeTabAtendimento);
                if (tipoAbaFundacao) {
                    if (this.toPascalCase(tipoAbaFundacao.nome) !== 'Sequoia') this.atendimentosModalView = this.atendimentosModal.map((itemAtendimento)=>{
                        if (itemAtendimento.tipo_atendimento === '0' || itemAtendimento.tipo_atendimento === null) return {
                            ...itemAtendimento,
                            tipo_atendimento: 'Geral'
                        };
                        return itemAtendimento;
                    }).filter((item)=>item.tipo_atendimento === this.activeTabAtendimentoNome && item.data_atendimento);
                    else this.atendimentosModalView = this.atendimentosModal.filter((item)=>item.tipo_atendimento === this.activeTabAtendimentoNome);
                    atendimentosFiltrados = this.atendimentosModalView;
                    atendimentosFiltrados = atendimentosFiltrados.sort((a, b)=>new Date(b.data_atendimento) - new Date(a.data_atendimento));
                    this.atendimentosModalView = atendimentosFiltrados;
                }
            }
        },
        populateSelectClientePF () {
            const selectOpts = this.clientepf.map(({ id: id, nome: nome })=>({
                    value: id,
                    label: nome
                }));
            this.populateSelect('cliente-modal-select', selectOpts);
            // DEIXAR SELECIONADO O CLIENTE ATIVO
            const selectCliente = GLOBAL.getChoicesActive('cliente-modal-select', listOfChoices);
            selectCliente.setChoiceByValue(this.clienteAtivo.id);
        },
        politicasArr () {
            const politicas1 = this.isFundacao ? $3304c5383a58886e$var$politicas.fundacao : $3304c5383a58886e$var$politicas.clientePF;
            const politicasArr = Object.entries(politicas1).map(([key, value])=>value);
            return politicasArr.filter((politica)=>politica.name !== 'AI');
        },
        updateClienteAtivo (data) {
            this.clienteAtivoEditado = data;
        },
        async cancelarEdicao ({ event: event, id: id, index: index }) {
            const url = this.isFundacao ? `/api/contatos/?fundacao=${this.clienteAtivo.id}` : `/api/contatos/?cliente_pf=${this.clienteAtivo.id}`;
            const request = await $3304c5383a58886e$var$api.get(url);
            const data = await request.data;
            this.editor.observacoes = '';
            this.editor.descricao = '';
            this.setContatos(await data?.results);
            if (this.pontosContato[index]) this.pontosContato[index].edicao = false;
        },
        getLength (item) {
            return item?.length ? item.length : null;
        },
        openModalTag () {
            modal_padrao.openModal('incluir-tag');
        },
        generateRange2: (totalElementos, valor)=>{
            return Array(totalElementos).fill(valor);
        },
        handleOpenModalConfirm (data) {
            const nameCurto = data.nome_cliente_pf.split(' ')[0];
            this.modalConfirm = {
                open: true,
                text: `Deseja tornar ${nameCurto} um atendimento quente`,
                data: data
            };
        },
        debounceFunction: (fn, timing, wait = 200)=>{
            return (...args)=>{
                clearTimeout(timing);
                timing = setTimeout(()=>fn(...args), wait);
            };
        },
        //!!! Retabilidades
        setRentabilidades () {
            const { rentabilidade_ano: rentabilidade_ano, rentabilidade_12_meses: rentabilidade_12_meses, rentabilidade_desde_inicio: rentabilidade_desde_inicio, rentabilidade_bm_ano: rentabilidade_bm_ano, rentabilidade_bm_12_meses: rentabilidade_bm_12_meses, rentabilidade_bm_inicio: rentabilidade_bm_inicio } = this.clienteAtivo;
            this.clienteAtivo.rentabilidade_ano = parseFloat(Number(rentabilidade_ano).toFixed(2));
            this.clienteAtivo.rentabilidade_12_meses = parseFloat(Number(rentabilidade_12_meses).toFixed(2));
            this.clienteAtivo.rentabilidade_desde_inicio = parseFloat(Number(rentabilidade_desde_inicio).toFixed(2));
            this.clienteAtivo.rentabilidade_relativa_ano = rentabilidade_bm_ano && rentabilidade_ano ? parseFloat((Number(rentabilidade_ano) / Number(rentabilidade_bm_ano) * 100).toFixed(2)) : '-';
            this.clienteAtivo.rentabilidade_relativa_12_meses = rentabilidade_bm_12_meses && rentabilidade_12_meses ? parseFloat((Number(rentabilidade_12_meses) / Number(rentabilidade_bm_12_meses) * 100).toFixed(2)) : '-';
            this.clienteAtivo.rentabilidade_relativa_inicio = rentabilidade_bm_inicio && rentabilidade_desde_inicio ? parseFloat((Number(rentabilidade_desde_inicio) / Number(rentabilidade_bm_inicio) * 100).toFixed(2)) : '-';
        },
        editContatos (contato, { target: target }) {
            this.pontosContato = this.pontosContato.map((i)=>{
                i.edicao = false;
                return i;
            });
            contato.edicao = true;
            this.editor.descricao = contato.descricao;
            this.editor.observacoes = contato.observacoes;
            const el = target.closest('.ponto-contato-el');
            el && setTimeout(()=>el.scrollIntoView({
                    block: 'center'
                }), 100);
        },
        openAddTag () {
            modal_padrao.openModal('criar_tag');
        },
        async handleChangeRentabilidade (event) {
            const value = event.target.value;
            this.rentabilidades.selected = event.target.innerText;
            await this.getRentabilidades(value);
        }
    },
    async created () {
        $3304c5383a58886e$var$initTipy();
    },
    async mounted () {
        await this.getChavesRentabilidades();
        const inputDate = document.querySelector('#date-modal-input');
        if (inputDate) this.inputDate = $3304c5383a58886e$var$initFlatpickr(inputDate);
        const self = this;
        window.addEventListener('resize', ()=>self.below1660px = window.matchMedia('(max-width:1666px)').matches);
        this.handleClickBtnsChartsFilter();
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("2m7Ys", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("bG4BG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $880730bf575b9c44$export$2e2bcd8739ae039; });
parcelRequire("jAamd");
parcelRequire("dgm2Z");
parcelRequire("42cM4");

var $67nR7 = parcelRequire("67nR7");
const { showToastify: $880730bf575b9c44$var$showToastify, getChoicesActive: $880730bf575b9c44$var$getChoicesActive } = GLOBAL;
let $880730bf575b9c44$var$backupEmptyDados = null;
let $880730bf575b9c44$var$editorAtendimentoQuill = null;
var $880730bf575b9c44$export$2e2bcd8739ae039 = {
    props: [
        'novoAtendimentoOpen',
        'isFundacaoAtendimento',
        'abaAtual',
        'atendimentoid',
        'bordaPura',
        'usuarios',
        'atendimentos',
        'edit',
        'tabAtendimentos'
    ],
    data () {
        return {
            dados: {
                cliente_pf: null,
                tipo: null,
                data: null,
                data_atendimento: null,
                atendimento: '',
                notificacao: null,
                fundacao: null,
                politica_atendimento: null,
                titulo_atendimento: '',
                usuario_criacao: null,
                usuario_atualizacao: null,
                user: [],
                usuario_responsavel: null,
                contato_atendimento: '',
                tipo_atendimento: null
            },
            idAtendimento: true,
            qeditor: '',
            requireds: [],
            politicaAtendimentoSelect: []
        };
    },
    computed: {
        title () {
            if (this.atendimentoid) return 'Editar Atendimento';
            if (this.abaAtual === 'Sequoia' && this.isFundacaoAtendimento) return 'Cadastrar Atendimento Sequoia';
            return 'Cadastrar Atendimento';
        },
        dataIsPolitica () {
            return !this.dados.tipo == '0';
        },
        openClass () {
            return {
                atendimentoOpen: this.novoAtendimentoOpen,
                'borda-pura': this.bordaPura
            };
        }
    },
    watch: {
        isFundacaoAtendimento () {
            this.updateRequireds();
        },
        'dados.titulo_atendimento' () {
            this.updateRequireds();
        },
        dados () {
            this.$emit('atendimentoData', {
                ...this.dados,
                atendimento: this.qeditor
            });
        },
        novoAtendimentoOpen (val) {
            if (this.atendimentoid) {
                const atendimento = this.atendimentos?.find((i)=>i.id === this.atendimentoid);
                if (atendimento) {
                    this.qeditor = atendimento.atendimento || atendimento.atendimento_html;
                    this.dados = {
                        ...atendimento
                    };
                    this.$nextTick(()=>{
                        if ($880730bf575b9c44$var$editorAtendimentoQuill) {
                            $880730bf575b9c44$var$editorAtendimentoQuill.setText('') // Limpa primeiro
                            ;
                            const content = atendimento.atendimento || atendimento.atendimento_html || '';
                            if (content) $880730bf575b9c44$var$editorAtendimentoQuill.clipboard.dangerouslyPasteHTML(content);
                        }
                    });
                }
                const tituloAtendimento = document.querySelector('#titulo_atendimento');
                if (tituloAtendimento) tituloAtendimento.value = atendimento?.titulo_atendimento;
                const choices = GLOBAL.getChoicesActive('tipo-modal-select', window.listOfChoices);
                choices.setChoiceByValue(atendimento?.tipo);
                GLOBAL.dispatchEventChange('#tipo-modal-select');
                const politica = GLOBAL.getChoicesActive('politica-modal-select', window.listOfChoices);
                // const ultima = politica._currentState.choices.at(-1).value
                this.setSelectPoliticas(this.atendimentos, true);
                GLOBAL.dispatchEventChange('#politica-modal-select');
                politica.setChoiceByValue(atendimento.id);
                GLOBAL.dispatchEventChange('#politica-modal-select');
                const data = document.querySelector('#date-modal-input');
                data.value = atendimento.data_atendimento;
                GLOBAL.dispatchEventChange('#date-modal-input');
                const choicesNotificacao = GLOBAL.getChoicesActive('notificacao-modal-select', window.listOfChoices);
                choicesNotificacao?.setChoiceByValue(atendimento.notificacao);
                _BIG('IF', this.atendimentoid);
            } else if (this.novoAtendimentoOpen) {
                _BIG('Else');
                const choices = GLOBAL.getChoicesActive('tipo-modal-select', window.listOfChoices);
                //this.dados.data = null
                choices.setChoiceByValue('0');
                GLOBAL.dispatchEventChange('#tipo-modal-select');
                const politica = GLOBAL.getChoicesActive('politica-modal-select', window.listOfChoices);
                this.setSelectPoliticas(this.atendimentos, false);
                // const ultima = politica._currentState.choices.at(-1).value
                politica.setChoiceByValue(this.atendimentoid).enable();
                GLOBAL.dispatchEventChange('#politica-modal-select');
                GLOBAL.dispatchEventChange('#date-modal-input');
                this.$nextTick(()=>{
                    this.qeditor = '';
                    if ($880730bf575b9c44$var$editorAtendimentoQuill) $880730bf575b9c44$var$editorAtendimentoQuill.setText('');
                });
            }
            this.dados.data_atendimento = this.dataModal();
        }
    },
    methods: {
        createEditorCadastrarAtendimentoQuill () {
            const SizeStyle = (0, $67nR7.default).import('attributors/style/size');
            const AlignStyle = (0, $67nR7.default).import('attributors/style/align');
            SizeStyle.whitelist = null;
            (0, $67nR7.default).register(AlignStyle, true);
            (0, $67nR7.default).register(SizeStyle, true);
            $880730bf575b9c44$var$editorAtendimentoQuill = new (0, $67nR7.default)('#editor-atendimento', {
                theme: 'snow',
                formats: [
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'size',
                    'color',
                    'list',
                    'background',
                    'align',
                    'header'
                ],
                modules: {
                    toolbar: [
                        [
                            {
                                header: [
                                    1,
                                    2,
                                    false
                                ]
                            }
                        ],
                        [
                            {
                                size: [
                                    'small',
                                    false,
                                    'large',
                                    'huge'
                                ]
                            }
                        ],
                        [
                            'bold',
                            'italic',
                            'underline'
                        ],
                        [
                            {
                                list: 'ordered'
                            },
                            {
                                list: 'bullet'
                            },
                            {
                                list: 'check'
                            }
                        ],
                        [
                            {
                                color: []
                            },
                            {
                                background: []
                            }
                        ],
                        [
                            {
                                align: []
                            }
                        ],
                        [
                            'clean'
                        ]
                    ]
                }
            });
            $880730bf575b9c44$var$editorAtendimentoQuill.on('text-change', ()=>{
                this.qeditor = $880730bf575b9c44$var$editorAtendimentoQuill.root.innerHTML;
            });
            $880730bf575b9c44$var$editorAtendimentoQuill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta)=>{
                console.log(node);
                return delta;
            });
            if (this.qeditor) $880730bf575b9c44$var$editorAtendimentoQuill.clipboard.dangerouslyPasteHTML(this.qeditor);
        },
        updateRequireds () {
            if (this.isFundacaoAtendimento && this.abaAtual === 'Sequoia') this.requireds = [];
            else // Demais casos (como já está)
            this.requireds = [
                {
                    data: this.dados.tipo,
                    ref: this.$refs.tipo
                },
                {
                    data: this.dados.cliente_pf,
                    ref: this.$refs.cliente_pf
                },
                {
                    data: this.dados.contato_atendimento,
                    ref: this.$refs.contato_atendimento
                },
                {
                    data: this.dados.data_atendimento,
                    ref: this.$refs.data
                }
            ];
        },
        onBeforeEnter (el) {
            GLOBAL.addClassForTime(document.querySelector('.tab-informacoes .tabs'), 'overflow-hidden', 500);
            const pai = el.closest('.cadastrar');
            gsap.set(pai, {
                height: '5.13rem'
            });
        },
        onEnter (el, done) {
            const pai = el.closest('.cadastrar');
            const content = document.querySelector('.modal_full .content');
            gsap.timeline({
                ease: 'power1',
                delay: 0
            }).set(pai, {
                clipPath: ' clip-path: inset(calc(100% - 5.13rem) 0 0 0)'
            }).set(content, {
                overflowY: 'hidden'
            }).to(pai, {
                clipPath: 'inset(0 0 0 0)',
                height: 'auto',
                duration: 0.4
            }).add(()=>{
                pai.classList.add('withShadow');
            }).set(content, {
                overflowY: 'auto'
            });
            done();
        },
        onBeforeLeave (el) {
            GLOBAL.addClassForTime(document.querySelector('.tab-informacoes .tabs'), 'overflow-hidden', 500);
        },
        onLeave (el, done) {
            const content = document.querySelector('.modal_full .content');
            const pai = el.closest('.cadastrar');
            gsap.timeline({
                ease: 'power1',
                delay: 0
            }).set(content, {
                overflowY: 'hidden'
            }).to(pai, {
                height: '5.13rem',
                duration: 0.3
            }).add(()=>{
                pai.classList.remove('withShadow');
                done();
            }, '-=0.15').set(content, {
                overflowY: 'auto'
            });
        },
        toggleAtendimento (open) {
            if (!open) this.$emit('setId', null);
            this.$emit('open', open);
        },
        setSelectPoliticas (data, editar) {
            const atendimentosValidos = data?.filter((i)=>i.status !== 'Realizado');
            const atendimentoAtual = this.atendimentos?.find((i)=>i.id === this.atendimentoid);
            this.politicaAtendimentoSelect = editar ? [
                ...atendimentosValidos.filter((i)=>i.atendimento === null),
                atendimentoAtual
            ] // ✅ Inclui apenas: sem vínculo OU o atual
             : [
                ...atendimentosValidos.filter((i)=>i.atendimento === null)
            ];
            const seDateOption = (i)=>{
                const data = (v)=>`${moment(v.data, 'YYYY-MM-DD').format('DD/MM/YYYY')}`;
                return {
                    value: i.id,
                    label: data(i)
                };
            };
            const opts = this.politicaAtendimentoSelect.map(seDateOption);
            this.populateSelect('politica-modal-select', opts);
        },
        populateSelect (selectID, opts) {
            const choices = GLOBAL.getChoicesActive(selectID, window.listOfChoices);
            choices?.clearStore();
            choices?.setChoices([
                ...opts
            ], 'value', 'label', true, true);
            choices?.init();
        },
        changePolitica (event) {
            const idPolitica = event?.target.value;
            if (idPolitica) {
                const atendimento = this.atendimentos?.find((i)=>i.id === Number(idPolitica));
                if (atendimento) this.dados.data = atendimento.data;
            }
        },
        // mudaValue({ currentTarget }) {
        // 	const options = currentTarget.querySelectorAll("option")
        // 	const values = Array.from(options).map(i => i.value)
        // 	currentTarget.value = new String([...values])
        // 	// currentTarget.dispatchEvent(new Event("change", { bubbles: true, cancelable: true }));
        // },
        handleChange (event) {
            const form = event.currentTarget;
            const field = event.target;
            this.dados[field.name] = field.name === 'contato_atendimento' ? $880730bf575b9c44$var$getChoicesActive(field.id, listOfChoices).getValue().map((i)=>i.value) : field.value;
            const requiredField = this.requireds.filter((i)=>{
                return (i.ref?.name || i.ref?.$attrs?.name || i.ref?.querySelector(`[name="${field.name}"]`)?.name) == field.name;
            });
            if (requiredField?.length) {
                const index = this.requireds.indexOf(requiredField[0]);
                this.requireds[index].data = field.value;
            }
            this.$emit('atendimentoData', {
                ...this.dados,
                atendimento: this.qeditor
            });
            this.checkRequired(event)();
        },
        getValidacao (value, el) {
            if (!value) el?.classList?.add('required-field');
            else el?.classList?.remove('required-field');
        },
        addRequiredPoliticas () {
            const politica_atendimentoOBJ = {
                data: this.dados.politica_atendimento,
                ref: this.$refs.politica_atendimento
            };
            if (this.dados.tipo == '0') {
                politica_atendimentoOBJ.ref?.classList.add('required-field');
                if (!this.requireds.filter((i)=>i.ref?.classList?.contains('politica-atendimento'))?.length) this.requireds.push(politica_atendimentoOBJ);
            } else if (this.dados.tipo == '1') {
                this.requireds = this.requireds.filter((i)=>!i.ref?.classList?.contains('politica-atendimento'));
                politica_atendimentoOBJ.ref?.classList.remove('required-field');
            }
        },
        checkRequired (event) {
            function functionCallback(callback) {
                this.addRequiredPoliticas();
                if (this.isFundacaoAtendimento && this.abaAtual === 'Sequoia') {
                    callback && callback();
                    return;
                }
                this.addRequiredPoliticas();
                //se é evento pega somente o campo do evento
                if (!callback) {
                    if (event && !event.detail) return;
                }
                if (event?.detail) {
                    const field = this.requireds.filter((i)=>{
                        i.ref == event.target || (i.ref, event.target.closest('.field'));
                    });
                    field?.length && this.getValidacao(event.target.value, field[0].ref);
                    return;
                }
                this.requireds.forEach((i)=>this.getValidacao(i.data, i.ref));
                // const isEditorValid = this.qeditor ? true : false
                if (this.requireds.every((i)=>i.data)) callback && callback();
                else $880730bf575b9c44$var$showToastify("\u26A0\uFE0F Preencha todos os campos Obrigatorios");
            }
            return functionCallback.bind(this);
        },
        emitEnvio () {
            const tituloAtendimentoDefault = 'Atendimento';
            let tituloAtendimento = tituloAtendimentoDefault;
            if (this.dados.titulo_atendimento.trim()) tituloAtendimento = this.dados.titulo_atendimento;
            GLOBAL.dispatchEventChange('#date-modal-input');
            if (!this.dados.tipo) this.dados.tipo = document.querySelector('#tipo-modal-select').value;
            if (!this.dados.tipo_atendimento) this.dados.tipo_atendimento = document.querySelector('#tipoAtendimento-modal-select')?.value;
            this.dados.atendimento = this.qeditor;
            const enviaEmmit = ()=>this.$emit('send-atendimento', {
                    ...this.dados,
                    titulo_atendimento: tituloAtendimento,
                    atendimento: this.qeditor,
                    atendimento_html: this.dados.atendimento_html ? this.qeditor : this.dados.atendimento_html
                });
            this.checkRequired()(enviaEmmit);
        },
        dataModal () {
            if (this.atendimentoid) {
                const atendimento = this.atendimentos?.filter((i)=>i.id === this.atendimentoid);
                if (atendimento.length && atendimento[0].data_atendimento) return moment(new Date(atendimento[0].data_atendimento)).format('DD/MM/YYYY');
            }
            return moment(new Date()).format('DD/MM/YYYY');
        },
        createNovoAtendimento () {
            this.$emit('setId', null);
            this.toggleAtendimento(true);
        },
        togglePolitica ({ target: { value: value } }) {
            const politica = GLOBAL.getChoicesActive('politica-modal-select', window.listOfChoices);
            if (value === '0') {
                this.$refs.politica_atendimento.classList.remove('disabled');
                if (this.atendimentoid) politica.setChoiceByValue(this.atendimentoid).enable();
                else politica?.enable();
            } else {
                politica?.removeActiveItems();
                this.$refs.politica_atendimento.classList.add('disabled');
            }
        }
    },
    mounted () {
        const selectNotificacao = document.getElementById('notificacao-modal-select');
        const selectTipoAtendimento = document.getElementById('tipoAtendimento-modal-select');
        if (this.atendimentoid) {
            const atendimento = this.atendimentos?.filter((i)=>i.id === this.atendimentoid);
            if (atendimento.length) {
                this.qeditor = atendimento[0].atendimento;
                this.dados = {
                    ...atendimento[0]
                };
            } else this.dados = {};
        }
        if (selectNotificacao) GLOBAL.initChoices(selectNotificacao);
        this.$emit('atendimentoData', {
            ...this.dados
        });
        this.updateRequireds();
        this.dados.data_atendimento = this.dataModal();
        this.$refs.tipo.addEventListener('change', this.togglePolitica);
        this.createEditorCadastrarAtendimentoQuill();
    },
    updated () {
        const selectNotificacao = document.getElementById('notificacao-modal-select');
        const selectTipoAtendimento = document.getElementById('tipoAtendimento-modal-select');
        if (selectNotificacao) GLOBAL.initChoices(selectNotificacao);
        this.$nextTick(()=>{
            const selectTipoAtendimento = document.getElementById('tipoAtendimento-modal-select');
            if (selectTipoAtendimento) {
                GLOBAL.initChoices(selectTipoAtendimento);
                if (this.tabAtendimentos?.length) {
                    const opts = this.tabAtendimentos.map((item)=>({
                            value: item.id || item.value,
                            label: item.nome || item.label
                        }));
                    this.populateSelect('tipoAtendimento-modal-select', opts);
                }
            }
        });
        this.$emit('atendimentoData', {
            ...this.dados,
            atendimento: this.qeditor
        });
        if (!this.atendimentoid) {
            if (this.dados?.id) this.dados = $880730bf575b9c44$var$backupEmptyDados;
            else $880730bf575b9c44$var$backupEmptyDados = this.dados;
        }
    },
    template: /* html */ `
		<div class="cadastrar absolute bottom-0 w-full border border-transparent transition-colors rounded-lg" :class="openClass" >
			<div class="card-mini w-full p-16 min-h-[initial] rounded-t-md bg-white z-20"
				>
				<form id="novoAtendimentoForm" @change="handleChange" ref="form">
				<Transition
				@before-enter="onBeforeEnter"
				@enter="onEnter"
				@before-leave="onBeforeLeave"
				@leave="onLeave"
				>

					<div v-show="novoAtendimentoOpen" class="grid grid-cols-6 gap-8 pb-16 cadastrar-content">
						<p class="text-primary-pure font-medium mb-8 col-span-6">{{title}}</p>
						<div class="flex flex-col col-span-3 field" ref="cliente_pf">
							<label class="label text-neutral-80">Cliente*</label>
							<div class="select-container h-48">
								<select js-choices id="cliente-modal-select" name="cliente_pf"
									js-choices-props='{	"searchEnabled": true, "searchChoices": true }'>
									<option value="" disabled selected placeholder="Selecione o cliente"></option>
		
								</select>
							</div>
						</div>

						<div v-show="abaAtual !== 'Sequoia'" class="flex flex-col col-span-3 field" ref="tipo">
							<label class="label text-neutral-80">Tipo*</label>
							<div class="select-container h-48 ">
								<select js-choices  name="tipo" id="tipo-modal-select" ref="tipo">
									<option value="" selected disabled hidden></option>
									<option value="0">Pol\xedtica de atendimento</option>
									<option value="1">Outro</option>
								</select>
							</div>
						</div>
		
						<div class="flex flex-col col-span-6 field" ref="contato_atendimento">
							<label class="label text-neutral-80">Atendido por*</label>
							<div class="select-container h-48 select-multiplo" id="atendido-select-wrapper">
								<select js-choices placeholder="Selecione" multiple id="responsavel-modal-select"  name="contato_atendimento"
									js-choices-props='{ "removeItems": true, "removeItemButton": true}'>
									
								</select>
							</div>
						</div>

						<div class="flex flex-col col-span-2 field" ref="titulo_atendimento">
							<label class="label text-neutral-80" >T\xedtulo </label>
							<input
							
								class="h-48 input-text"
								placeholder="Digite o titulo"
								js-ativo
								type="text"
								name="titulo_atendimento"
								id="titulo_atendimento"
								ref="titulo_atendimento" />
							
						</div>
		
						<div class="flex flex-col col-span-2 field" ref="data">
							<label class="label text-neutral-80">Data *</label>
							<div class="input-icon icon-left">
								<input class="input-text appearance-none h-48 text-sm"  js-ativo type="text"   name="data_atendimento" id="date-modal-input" v-model="dados.data_atendimento">
								<svg>
									<use xlink:href="#icon_date"></use>
								</svg>
							</div>
						</div>

						<div v-show="abaAtual !== 'Sequoia'" class="politica-atendimento flex flex-col col-span-2 field disabled"  ref="politica_atendimento">
							<label class="label text-neutral-80">Pol\xedtica de Atendimento</label>
							<div class="select-container h-48">
								<select id="politica-modal-select" js-choices name="politica_atendimento" @change="changePolitica">
		
								</select>
								
							</div>
						</div>

						<div v-show="isFundacaoAtendimento && abaAtual !== 'Sequoia'" class="grid grid-cols-4 col-span-3 gap-16 field">
							<div class="col-span-2" >
								<label class="label text-neutral-80">Notifica\xe7\xf5es</label>
								<div class="select-container h-48">
									<select js-choices  name="notificacao" id="notificacao-modal-select">
										<option value="" selected disabled hidden></option>
										<option value="0" >Risco de reinvestimento</option>
										<option value="1" >Processo de sele\xe7\xe3o pr\xf3ximo</option>
										<option value="2" >Sem notifica\xe7\xf5es</option>
									</select>
								</div>
							</div>
							
							<div class="col-span-2">
								<label class="label text-neutral-80">Tipo atendimento:</label>
								<div class="select-container h-48">
									<select js-choices name="tipoAtendimento" id="tipoAtendimento-modal-select">
										<option value="" selected disabled hidden></option>
										
									</select>
								</div>
							</div>
						</div>
						<div class="w-full h-full min-h-max col-span-6 ">

							<div v-if="true" id="editor-atendimento" class=" min-h-[4rem] h-max"></div>

							<q-editor
								v-else
								v-model="qeditor"
								ref="atendimento"
								js-ativo
								name="atendimento"
								:dense="$q.screen.lt.md"
								:toolbar="[
									['unordered', 'left', 'center', 'right', 'justify' ], [ 'bold', 'italic', 'underline', 'strike' ], [ 'undo', 'redo' ] 

								]"
								@paste.native="onPasteCreateAtendimento"/>
						</div>
						
					</div>

				</Transition>
				</form>
		
				<div v-if="novoAtendimentoOpen" class="flex items-center gap-8">
					<button @click="toggleAtendimento(false)" class="btn secondary h-48 flex-1">Cancelar</button>
					<button class="btn h-48 flex-[2]" @click="emitEnvio">Enviar Atendimento</button>
				</div>
		
				<button v-else class="btn w-full h-48" @click="createNovoAtendimento">Novo
					atendimento</button>
			</div>
		
		</div>
		`
};

});
parcelRegister("jAamd", function(module, exports) {
module.exports = {
    content: [
        './templates/*.html',
        './templates/*/*.html',
        '/clientes/templates/*/*.html',
        './*/templates/*.html',
        './*/templates/*/*.html',
        './*/templates/*/*/*.html',
        './*/templates/*/*/*/*.html',
        './front_assets/static/front_assets/src/js/modules/*.js',
        './front_assets/static/front_assets/src/js/vue/*/*.js',
        './front_assets/static/front_assets/src/js/vue/**/*.js'
    ],
    safelist: [
        'flex',
        'flex-wrap',
        'w-20',
        'h-20',
        'breadcrumb-wrapper',
        'errorlist',
        'table-container',
        'td-link',
        'td-number-link',
        'badge',
        'font-medium',
        'font-semibold',
        'text-primary-pure',
        'opacity',
        'sidebar',
        'toastify',
        'shadow-[0px_-8px_26px_rgba(212,_213,_217,_0.2)]',
        'max-h-[28.5rem]',
        'required-field',
        'overflow-hidden'
    ],
    theme: {
        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            white: '#fff',
            'white-10': $e41969d9ac0b215a$var$withOpacity('--white-10'),
            'white-10-0': $e41969d9ac0b215a$var$withOpacity('--white-10')({
                opacityValue: 0.1
            }),
            'neutral-10': '#F8F9FA',
            'neutral-20': '#F1F3F5',
            'neutral-30': '#E9ECEF',
            'neutral-40': '#DEE2E6',
            'neutral-50': '#CED4DA',
            'neutral-60': '#b8bcbf',
            'neutral-70': '#949799',
            'neutral-75': '#6d6f71',
            'neutral-80': '#495057',
            'neutral-90': '#3e3e40',
            'neutral-100': '#252526',
            'primary-10': $e41969d9ac0b215a$var$withOpacity('--primary-10'),
            'primary-10-o': $e41969d9ac0b215a$var$withOpacity('--primary-10-o'),
            'primary-30': $e41969d9ac0b215a$var$withOpacity('--primary-30'),
            'primary-pure': $e41969d9ac0b215a$var$withOpacity('--primary-pure'),
            'primary-20': '#FF871E',
            'primary-40': '#FF871E',
            'primary-60': '#FF871E',
            'primary-70': '#FF871E',
            'primary-80': '#FF871E',
            'primary-90': '#FF871E',
            'primary-100': '#FF871E',
            'yellow-50': '#FFBB0B',
            'green-50': '#18B25D',
            'laranja-50': '#D83232',
            //alerts
            'alert-red-100': '#EC3539',
            'alert-red-10': '#FEEBEC',
            'alert-red-10-o': 'rgba(236, 53, 57, 0.1)',
            'alert-green-100': '#A6CE44',
            'alert-green-10': '#F7FBED',
            'alert-green-10-o': 'rgba(24, 178, 93, 0.1)',
            'alert-warning-100': '#FDD426',
            'alert-warning-10': '#FFFBEA',
            'alert-warning-10-o': 'rgba(253, 212, 38, 0.1)'
        },
        spacing: {
            0: '0',
            1: '1px',
            2: '0.125rem',
            4: '0.25rem',
            6: ' 0.38rem',
            8: '0.5rem',
            10: '.625rem',
            12: '0.75rem',
            14: '0.875rem',
            16: '1rem',
            18: '1.13rem',
            20: '1.25rem',
            24: '1.5rem',
            28: '1.75rem',
            32: '2rem',
            34: '2.75rem',
            40: '2.5rem',
            42: '2.63rem',
            48: '3rem',
            56: '3.5rem',
            64: '4rem',
            72: '4.5rem',
            80: '5rem',
            96: '6rem',
            120: '7.5rem',
            160: '10rem'
        },
        fontFamily: {
            sans: [
                'Roboto Flex',
                'sans-serif'
            ]
        },
        lineHeight: {
            100: '100%',
            140: '140%',
            150: '150%'
        },
        screens: {
            min2xl: {
                min: '1441px'
            },
            // => @media (max-width: 1535px) { ... }
            '2xl': {
                max: '1667px'
            },
            // => @media (max-width: 1535px) { ... }
            xl: {
                max: '1367px'
            },
            // => @media (max-width: 1279px) { ... }
            lg: {
                max: '1281px'
            },
            // => @media (max-width: 1023px) { ... }
            md2: {
                max: '1180px'
            },
            // => @media (max-width: 767px) { ... }
            md: {
                max: '767px'
            },
            // => @media (max-width: 767px) { ... }
            sm: {
                max: '639px'
            }
        },
        extend: {
            gridTemplateColumns: {
                teste: '350px minmax(300px, 1fr) 50px',
                home: 'minmax(auto, 814px) minmax(auto, 570px)'
            },
            letterSpacing: {
                tight: '-0.02em'
            },
            fontSize: {
                '2xl': [
                    '1.5rem',
                    {
                        lineHeight: '150%'
                    }
                ],
                xl: [
                    '1.125rem',
                    {
                        lineHeight: '150%'
                    }
                ],
                base: [
                    '1rem',
                    {
                        lineHeight: '150%'
                    }
                ],
                sm: [
                    '0.875rem',
                    {
                        lineHeight: '150%'
                    }
                ],
                xs: [
                    '.75rem',
                    {
                        lineHeight: '150%',
                        letterSpacing: '0.03em'
                    }
                ],
                'xs-space': [
                    '.75rem',
                    {
                        lineHeight: '150%',
                        letterSpacing: '0.1em'
                    }
                ]
            },
            boxShadow: {
                xs: '0px 1px 2px #CED4DA',
                sm: '0px 8px 16px rgba(206, 212, 218, 0.3)',
                lg: '0px 24px 32px rgba(206, 212, 218, 0.25)',
                regular: '0px 8px 16px rgba(206, 212, 218, 0.3)',
                medium: '0px 8px 16px rgba(212, 213, 217, 0.3)'
            }
        }
    }
};
function $e41969d9ac0b215a$var$withOpacity(variableName) {
    return ({ opacityValue: opacityValue })=>{
        if (opacityValue !== undefined) return `rgba(var(${variableName}), ${opacityValue})`;
        return `rgb(var(${variableName}))`;
    };
}

});

parcelRegister("dgm2Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a7ddf150c200c1b$export$2e2bcd8739ae039; });
var $9a7ddf150c200c1b$export$2e2bcd8739ae039 = {
    emits: [],
    props: {},
    methods: {}
};

});

parcelRegister("42cM4", function(module, exports) {
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */ const { entries: $fe0d20ea148325c5$var$entries, setPrototypeOf: $fe0d20ea148325c5$var$setPrototypeOf, isFrozen: $fe0d20ea148325c5$var$isFrozen, getPrototypeOf: $fe0d20ea148325c5$var$getPrototypeOf, getOwnPropertyDescriptor: $fe0d20ea148325c5$var$getOwnPropertyDescriptor } = Object;
let { freeze: $fe0d20ea148325c5$var$freeze, seal: $fe0d20ea148325c5$var$seal, create: $fe0d20ea148325c5$var$create } = Object; // eslint-disable-line import/no-mutable-exports
let { apply: $fe0d20ea148325c5$var$apply, construct: $fe0d20ea148325c5$var$construct } = typeof Reflect !== 'undefined' && Reflect;
if (!$fe0d20ea148325c5$var$freeze) $fe0d20ea148325c5$var$freeze = function freeze(x) {
    return x;
};
if (!$fe0d20ea148325c5$var$seal) $fe0d20ea148325c5$var$seal = function seal(x) {
    return x;
};
if (!$fe0d20ea148325c5$var$apply) $fe0d20ea148325c5$var$apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
};
if (!$fe0d20ea148325c5$var$construct) $fe0d20ea148325c5$var$construct = function construct(Func, args) {
    return new Func(...args);
};
const $fe0d20ea148325c5$var$arrayForEach = $fe0d20ea148325c5$var$unapply(Array.prototype.forEach);
const $fe0d20ea148325c5$var$arrayLastIndexOf = $fe0d20ea148325c5$var$unapply(Array.prototype.lastIndexOf);
const $fe0d20ea148325c5$var$arrayPop = $fe0d20ea148325c5$var$unapply(Array.prototype.pop);
const $fe0d20ea148325c5$var$arrayPush = $fe0d20ea148325c5$var$unapply(Array.prototype.push);
const $fe0d20ea148325c5$var$arraySplice = $fe0d20ea148325c5$var$unapply(Array.prototype.splice);
const $fe0d20ea148325c5$var$stringToLowerCase = $fe0d20ea148325c5$var$unapply(String.prototype.toLowerCase);
const $fe0d20ea148325c5$var$stringToString = $fe0d20ea148325c5$var$unapply(String.prototype.toString);
const $fe0d20ea148325c5$var$stringMatch = $fe0d20ea148325c5$var$unapply(String.prototype.match);
const $fe0d20ea148325c5$var$stringReplace = $fe0d20ea148325c5$var$unapply(String.prototype.replace);
const $fe0d20ea148325c5$var$stringIndexOf = $fe0d20ea148325c5$var$unapply(String.prototype.indexOf);
const $fe0d20ea148325c5$var$stringTrim = $fe0d20ea148325c5$var$unapply(String.prototype.trim);
const $fe0d20ea148325c5$var$objectHasOwnProperty = $fe0d20ea148325c5$var$unapply(Object.prototype.hasOwnProperty);
const $fe0d20ea148325c5$var$regExpTest = $fe0d20ea148325c5$var$unapply(RegExp.prototype.test);
const $fe0d20ea148325c5$var$typeErrorCreate = $fe0d20ea148325c5$var$unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */ function $fe0d20ea148325c5$var$unapply(func) {
    return function(thisArg) {
        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return $fe0d20ea148325c5$var$apply(func, thisArg, args);
    };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function $fe0d20ea148325c5$var$unconstruct(func) {
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $fe0d20ea148325c5$var$construct(func, args);
    };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */ function $fe0d20ea148325c5$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $fe0d20ea148325c5$var$stringToLowerCase;
    if ($fe0d20ea148325c5$var$setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    $fe0d20ea148325c5$var$setPrototypeOf(set, null);
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!$fe0d20ea148325c5$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */ function $fe0d20ea148325c5$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++){
        const isPropertyExist = $fe0d20ea148325c5$var$objectHasOwnProperty(array, index);
        if (!isPropertyExist) array[index] = null;
    }
    return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */ function $fe0d20ea148325c5$var$clone(object) {
    const newObject = $fe0d20ea148325c5$var$create(null);
    for (const [property, value] of $fe0d20ea148325c5$var$entries(object)){
        const isPropertyExist = $fe0d20ea148325c5$var$objectHasOwnProperty(object, property);
        if (isPropertyExist) {
            if (Array.isArray(value)) newObject[property] = $fe0d20ea148325c5$var$cleanArray(value);
            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = $fe0d20ea148325c5$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */ function $fe0d20ea148325c5$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $fe0d20ea148325c5$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $fe0d20ea148325c5$var$unapply(desc.get);
            if (typeof desc.value === 'function') return $fe0d20ea148325c5$var$unapply(desc.value);
        }
        object = $fe0d20ea148325c5$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
const $fe0d20ea148325c5$var$html$1 = $fe0d20ea148325c5$var$freeze([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'section',
    'select',
    'shadow',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr'
]);
const $fe0d20ea148325c5$var$svg$1 = $fe0d20ea148325c5$var$freeze([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern'
]);
const $fe0d20ea148325c5$var$svgFilters = $fe0d20ea148325c5$var$freeze([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence'
]);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const $fe0d20ea148325c5$var$svgDisallowed = $fe0d20ea148325c5$var$freeze([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use'
]);
const $fe0d20ea148325c5$var$mathMl$1 = $fe0d20ea148325c5$var$freeze([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts'
]);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const $fe0d20ea148325c5$var$mathMlDisallowed = $fe0d20ea148325c5$var$freeze([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none'
]);
const $fe0d20ea148325c5$var$text = $fe0d20ea148325c5$var$freeze([
    '#text'
]);
const $fe0d20ea148325c5$var$html = $fe0d20ea148325c5$var$freeze([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns',
    'slot'
]);
const $fe0d20ea148325c5$var$svg = $fe0d20ea148325c5$var$freeze([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'amplitude',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'exponent',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'slope',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'tablevalues',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan'
]);
const $fe0d20ea148325c5$var$mathMl = $fe0d20ea148325c5$var$freeze([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnsalign',
    'columnlines',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lspace',
    'lquote',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns'
]);
const $fe0d20ea148325c5$var$xml = $fe0d20ea148325c5$var$freeze([
    'xlink:href',
    'xml:id',
    'xlink:title',
    'xml:space',
    'xmlns:xlink'
]);
// eslint-disable-next-line unicorn/better-regex
const $fe0d20ea148325c5$var$MUSTACHE_EXPR = $fe0d20ea148325c5$var$seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const $fe0d20ea148325c5$var$ERB_EXPR = $fe0d20ea148325c5$var$seal(/<%[\w\W]*|[\w\W]*%>/gm);
const $fe0d20ea148325c5$var$TMPLIT_EXPR = $fe0d20ea148325c5$var$seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
const $fe0d20ea148325c5$var$DATA_ATTR = $fe0d20ea148325c5$var$seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const $fe0d20ea148325c5$var$ARIA_ATTR = $fe0d20ea148325c5$var$seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const $fe0d20ea148325c5$var$IS_ALLOWED_URI = $fe0d20ea148325c5$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const $fe0d20ea148325c5$var$IS_SCRIPT_OR_DATA = $fe0d20ea148325c5$var$seal(/^(?:\w+script|data):/i);
const $fe0d20ea148325c5$var$ATTR_WHITESPACE = $fe0d20ea148325c5$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const $fe0d20ea148325c5$var$DOCTYPE_NAME = $fe0d20ea148325c5$var$seal(/^html$/i);
const $fe0d20ea148325c5$var$CUSTOM_ELEMENT = $fe0d20ea148325c5$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var $fe0d20ea148325c5$var$EXPRESSIONS = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ARIA_ATTR: $fe0d20ea148325c5$var$ARIA_ATTR,
    ATTR_WHITESPACE: $fe0d20ea148325c5$var$ATTR_WHITESPACE,
    CUSTOM_ELEMENT: $fe0d20ea148325c5$var$CUSTOM_ELEMENT,
    DATA_ATTR: $fe0d20ea148325c5$var$DATA_ATTR,
    DOCTYPE_NAME: $fe0d20ea148325c5$var$DOCTYPE_NAME,
    ERB_EXPR: $fe0d20ea148325c5$var$ERB_EXPR,
    IS_ALLOWED_URI: $fe0d20ea148325c5$var$IS_ALLOWED_URI,
    IS_SCRIPT_OR_DATA: $fe0d20ea148325c5$var$IS_SCRIPT_OR_DATA,
    MUSTACHE_EXPR: $fe0d20ea148325c5$var$MUSTACHE_EXPR,
    TMPLIT_EXPR: $fe0d20ea148325c5$var$TMPLIT_EXPR
});
/* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const $fe0d20ea148325c5$var$NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    progressingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12 // Deprecated
};
const $fe0d20ea148325c5$var$getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const $fe0d20ea148325c5$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
    }
};
const $fe0d20ea148325c5$var$_createHooksMap = function _createHooksMap() {
    return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
};
function $fe0d20ea148325c5$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $fe0d20ea148325c5$var$getGlobal();
    const DOMPurify = (root)=>$fe0d20ea148325c5$var$createDOMPurify(root);
    DOMPurify.version = '3.2.6';
    DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $fe0d20ea148325c5$var$NODE_TYPE.document || !window1.Element) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let { document: document } = window1;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
    const ElementPrototype = Element.prototype;
    const cloneNode = $fe0d20ea148325c5$var$lookupGetter(ElementPrototype, 'cloneNode');
    const remove = $fe0d20ea148325c5$var$lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = $fe0d20ea148325c5$var$lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = $fe0d20ea148325c5$var$lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = $fe0d20ea148325c5$var$lookupGetter(ElementPrototype, 'parentNode');
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
    const { importNode: importNode } = originalDocument;
    let hooks = $fe0d20ea148325c5$var$_createHooksMap();
    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof $fe0d20ea148325c5$var$entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = $fe0d20ea148325c5$var$EXPRESSIONS;
    let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = $fe0d20ea148325c5$var$EXPRESSIONS;
    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $fe0d20ea148325c5$var$addToSet({}, [
        ...$fe0d20ea148325c5$var$html$1,
        ...$fe0d20ea148325c5$var$svg$1,
        ...$fe0d20ea148325c5$var$svgFilters,
        ...$fe0d20ea148325c5$var$mathMl$1,
        ...$fe0d20ea148325c5$var$text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $fe0d20ea148325c5$var$addToSet({}, [
        ...$fe0d20ea148325c5$var$html,
        ...$fe0d20ea148325c5$var$svg,
        ...$fe0d20ea148325c5$var$mathMl,
        ...$fe0d20ea148325c5$var$xml
    ]);
    /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal($fe0d20ea148325c5$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $fe0d20ea148325c5$var$addToSet({}, [
        'annotation-xml',
        'audio',
        'colgroup',
        'desc',
        'foreignobject',
        'head',
        'iframe',
        'math',
        'mi',
        'mn',
        'mo',
        'ms',
        'mtext',
        'noembed',
        'noframes',
        'noscript',
        'plaintext',
        'script',
        'style',
        'svg',
        'template',
        'thead',
        'title',
        'video',
        'xmp'
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $fe0d20ea148325c5$var$addToSet({}, [
        'audio',
        'video',
        'img',
        'source',
        'image',
        'track'
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $fe0d20ea148325c5$var$addToSet({}, [
        'alt',
        'class',
        'for',
        'id',
        'label',
        'name',
        'pattern',
        'placeholder',
        'role',
        'summary',
        'title',
        'value',
        'style',
        'xmlns'
    ]);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $fe0d20ea148325c5$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $fe0d20ea148325c5$var$stringToString);
    let MATHML_TEXT_INTEGRATION_POINTS = $fe0d20ea148325c5$var$addToSet({}, [
        'mi',
        'mo',
        'mn',
        'ms',
        'mtext'
    ]);
    let HTML_INTEGRATION_POINTS = $fe0d20ea148325c5$var$addToSet({}, [
        'annotation-xml'
    ]);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = $fe0d20ea148325c5$var$addToSet({}, [
        'title',
        'style',
        'font',
        'a',
        'script'
    ]);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        'application/xhtml+xml',
        'text/html'
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = $fe0d20ea148325c5$var$clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? $fe0d20ea148325c5$var$stringToString : $fe0d20ea148325c5$var$stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? $fe0d20ea148325c5$var$addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? $fe0d20ea148325c5$var$addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? $fe0d20ea148325c5$var$addToSet({}, cfg.ALLOWED_NAMESPACES, $fe0d20ea148325c5$var$stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? $fe0d20ea148325c5$var$addToSet($fe0d20ea148325c5$var$clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? $fe0d20ea148325c5$var$addToSet($fe0d20ea148325c5$var$clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? $fe0d20ea148325c5$var$addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'FORBID_TAGS') ? $fe0d20ea148325c5$var$addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : $fe0d20ea148325c5$var$clone({});
        FORBID_ATTR = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'FORBID_ATTR') ? $fe0d20ea148325c5$var$addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : $fe0d20ea148325c5$var$clone({});
        USE_PROFILES = $fe0d20ea148325c5$var$objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || $fe0d20ea148325c5$var$IS_ALLOWED_URI;
        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
        MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
        HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = $fe0d20ea148325c5$var$addToSet({}, $fe0d20ea148325c5$var$text);
            ALLOWED_ATTR = [];
            if (USE_PROFILES.html === true) {
                $fe0d20ea148325c5$var$addToSet(ALLOWED_TAGS, $fe0d20ea148325c5$var$html$1);
                $fe0d20ea148325c5$var$addToSet(ALLOWED_ATTR, $fe0d20ea148325c5$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $fe0d20ea148325c5$var$addToSet(ALLOWED_TAGS, $fe0d20ea148325c5$var$svg$1);
                $fe0d20ea148325c5$var$addToSet(ALLOWED_ATTR, $fe0d20ea148325c5$var$svg);
                $fe0d20ea148325c5$var$addToSet(ALLOWED_ATTR, $fe0d20ea148325c5$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $fe0d20ea148325c5$var$addToSet(ALLOWED_TAGS, $fe0d20ea148325c5$var$svgFilters);
                $fe0d20ea148325c5$var$addToSet(ALLOWED_ATTR, $fe0d20ea148325c5$var$svg);
                $fe0d20ea148325c5$var$addToSet(ALLOWED_ATTR, $fe0d20ea148325c5$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $fe0d20ea148325c5$var$addToSet(ALLOWED_TAGS, $fe0d20ea148325c5$var$mathMl$1);
                $fe0d20ea148325c5$var$addToSet(ALLOWED_ATTR, $fe0d20ea148325c5$var$mathMl);
                $fe0d20ea148325c5$var$addToSet(ALLOWED_ATTR, $fe0d20ea148325c5$var$xml);
            }
        }
        /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $fe0d20ea148325c5$var$clone(ALLOWED_TAGS);
            $fe0d20ea148325c5$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
        }
        if (cfg.ADD_ATTR) {
            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $fe0d20ea148325c5$var$clone(ALLOWED_ATTR);
            $fe0d20ea148325c5$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
        }
        if (cfg.ADD_URI_SAFE_ATTR) $fe0d20ea148325c5$var$addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        if (cfg.FORBID_CONTENTS) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $fe0d20ea148325c5$var$clone(FORBID_CONTENTS);
            $fe0d20ea148325c5$var$addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) $fe0d20ea148325c5$var$addToSet(ALLOWED_TAGS, [
            'html',
            'head',
            'body'
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            $fe0d20ea148325c5$var$addToSet(ALLOWED_TAGS, [
                'tbody'
            ]);
            delete FORBID_TAGS.tbody;
        }
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw $fe0d20ea148325c5$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw $fe0d20ea148325c5$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            // Overwrite existing TrustedTypes policy.
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            // Sign local variables required by `sanitize`.
            emptyHTML = trustedTypesPolicy.createHTML('');
        } else {
            // Uninitialized policy, attempt to initialize the internal dompurify policy.
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = $fe0d20ea148325c5$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            // If creating the internal policy succeeded sign internal variables.
            if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
        }
        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if ($fe0d20ea148325c5$var$freeze) $fe0d20ea148325c5$var$freeze(cfg);
        CONFIG = cfg;
    };
    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = $fe0d20ea148325c5$var$addToSet({}, [
        ...$fe0d20ea148325c5$var$svg$1,
        ...$fe0d20ea148325c5$var$svgFilters,
        ...$fe0d20ea148325c5$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $fe0d20ea148325c5$var$addToSet({}, [
        ...$fe0d20ea148325c5$var$mathMl$1,
        ...$fe0d20ea148325c5$var$mathMlDisallowed
    ]);
    /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element);
        // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
        };
        const tagName = $fe0d20ea148325c5$var$stringToLowerCase(element.tagName);
        const parentTagName = $fe0d20ea148325c5$var$stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) {
            // The only way to switch from HTML namespace to SVG
            // is via <svg>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
            // The only way to switch from MathML to SVG is via`
            // svg if parent is either <annotation-xml> or MathML
            // text integration points.
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            // We only allow elements that are defined in SVG
            // spec. All others are disallowed in SVG namespace.
            return Boolean(ALL_SVG_TAGS[tagName]);
        }
        if (element.namespaceURI === MATHML_NAMESPACE) {
            // The only way to switch from HTML namespace to MathML
            // is via <math>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
            // The only way to switch from SVG to MathML is via
            // <math> and HTML integration points
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
            // We only allow elements that are defined in MathML
            // spec. All others are disallowed in MathML namespace.
            return Boolean(ALL_MATHML_TAGS[tagName]);
        }
        if (element.namespaceURI === HTML_NAMESPACE) {
            // The only way to switch from SVG to HTML is via
            // HTML integration points, and from MathML to HTML
            // is via MathML text integration points
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            // We disallow tags that are specific for MathML
            // or SVG and should never appear in HTML namespace
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        }
        // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
        // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
   * _forceRemove
   *
   * @param node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
        $fe0d20ea148325c5$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            getParentNode(node).removeChild(node);
        } catch (_) {
            remove(node);
        }
    };
    /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */ const _removeAttribute = function _removeAttribute(name, element) {
        try {
            $fe0d20ea148325c5$var$arrayPush(DOMPurify.removed, {
                attribute: element.getAttributeNode(name),
                from: element
            });
        } catch (_) {
            $fe0d20ea148325c5$var$arrayPush(DOMPurify.removed, {
                attribute: null,
                from: element
            });
        }
        element.removeAttribute(name);
        // We void attribute values for unremovable "is" attributes
        if (name === 'is') {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(element);
            } catch (_) {}
            else try {
                element.setAttribute(name, '');
            } catch (_) {}
        }
    };
    /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = $fe0d20ea148325c5$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {
            // Syntax error if dirtyPayload is invalid xml
            }
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(element) {
        return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
    };
    /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */ const _isNode = function _isNode(value) {
        return typeof Node === 'function' && value instanceof Node;
    };
    function _executeHooks(hooks, currentNode, data) {
        $fe0d20ea148325c5$var$arrayForEach(hooks, (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    }
    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */ const _sanitizeElements = function _sanitizeElements(currentNode) {
        let content = null;
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
        /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $fe0d20ea148325c5$var$regExpTest(/<[/\w!]/g, currentNode.innerHTML) && $fe0d20ea148325c5$var$regExpTest(/<[/\w!]/g, currentNode.textContent)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === $fe0d20ea148325c5$var$NODE_TYPE.progressingInstruction) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === $fe0d20ea148325c5$var$NODE_TYPE.comment && $fe0d20ea148325c5$var$regExpTest(/<[/\w]/g, currentNode.data)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $fe0d20ea148325c5$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
            }
            /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    for(let i = childCount - 1; i >= 0; --i){
                        const childClone = cloneNode(childNodes[i], true);
                        childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                        parentNode.insertBefore(childClone, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        }
        /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && $fe0d20ea148325c5$var$regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $fe0d20ea148325c5$var$NODE_TYPE.text) {
            /* Get the element's text content */ content = currentNode.textContent;
            $fe0d20ea148325c5$var$arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                content = $fe0d20ea148325c5$var$stringReplace(content, expr, ' ');
            });
            if (currentNode.textContent !== content) {
                $fe0d20ea148325c5$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
        return false;
    };
    /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && $fe0d20ea148325c5$var$regExpTest(DATA_ATTR, lcName)) ;
        else if (ALLOW_ARIA_ATTR && $fe0d20ea148325c5$var$regExpTest(ARIA_ATTR, lcName)) ;
        else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
            if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $fe0d20ea148325c5$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && $fe0d20ea148325c5$var$regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $fe0d20ea148325c5$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
            else return false;
        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
        else if ($fe0d20ea148325c5$var$regExpTest(IS_ALLOWED_URI$1, $fe0d20ea148325c5$var$stringReplace(value, ATTR_WHITESPACE, ''))) ;
        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && $fe0d20ea148325c5$var$stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
        else if (ALLOW_UNKNOWN_PROTOCOLS && !$fe0d20ea148325c5$var$regExpTest(IS_SCRIPT_OR_DATA, $fe0d20ea148325c5$var$stringReplace(value, ATTR_WHITESPACE, ''))) ;
        else if (value) return false;
        return true;
    };
    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return tagName !== 'annotation-xml' && $fe0d20ea148325c5$var$stringMatch(tagName, CUSTOM_ELEMENT);
    };
    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
        const { attributes: attributes } = currentNode;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
        const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR,
            forceKeepAttr: undefined
        };
        let l = attributes.length;
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            const attr = attributes[l];
            const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
            const lcName = transformCaseFunc(name);
            const initValue = attrValue;
            let value = name === 'value' ? initValue : $fe0d20ea148325c5$var$stringTrim(initValue);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode);
                // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && $fe0d20ea148325c5$var$regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && $fe0d20ea148325c5$var$regExpTest(/\/>/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) $fe0d20ea148325c5$var$arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                value = $fe0d20ea148325c5$var$stringReplace(value, expr, ' ');
            });
            /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
            if (!_isValidAttribute(lcTag, lcName, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                if (namespaceURI) ;
                else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                    case 'TrustedHTML':
                        value = trustedTypesPolicy.createHTML(value);
                        break;
                    case 'TrustedScriptURL':
                        value = trustedTypesPolicy.createScriptURL(value);
                        break;
                }
            }
            /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) _forceRemove(currentNode);
                else $fe0d20ea148325c5$var$arrayPop(DOMPurify.removed);
            } catch (_) {
                _removeAttribute(name, currentNode);
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
    };
    /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
            /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
            /* Check attributes next */ _sanitizeAttributes(shadowNode);
            /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = '<!-->';
        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
            if (typeof dirty.toString === 'function') {
                dirty = dirty.toString();
                if (typeof dirty !== 'string') throw $fe0d20ea148325c5$var$typeErrorCreate('dirty is not a string, aborting');
            } else throw $fe0d20ea148325c5$var$typeErrorCreate('toString is not a function');
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
        if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
            if (dirty.nodeName) {
                const tagName = transformCaseFunc(dirty.nodeName);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw $fe0d20ea148325c5$var$typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
            }
        } else if (dirty instanceof Node) {
            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $fe0d20ea148325c5$var$NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === 'HTML') body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
        /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
            /* Sanitize tags and elements */ _sanitizeElements(currentNode);
            /* Check attributes next */ _sanitizeAttributes(currentNode);
            /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
        }
        /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $fe0d20ea148325c5$var$regExpTest($fe0d20ea148325c5$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) $fe0d20ea148325c5$var$arrayForEach([
            MUSTACHE_EXPR,
            ERB_EXPR,
            TMPLIT_EXPR
        ], (expr)=>{
            serializedHTML = $fe0d20ea148325c5$var$stringReplace(serializedHTML, expr, ' ');
        });
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
    };
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') return;
        $fe0d20ea148325c5$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
        if (hookFunction !== undefined) {
            const index = $fe0d20ea148325c5$var$arrayLastIndexOf(hooks[entryPoint], hookFunction);
            return index === -1 ? undefined : $fe0d20ea148325c5$var$arraySplice(hooks[entryPoint], index, 1)[0];
        }
        return $fe0d20ea148325c5$var$arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
        hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
        hooks = $fe0d20ea148325c5$var$_createHooksMap();
    };
    return DOMPurify;
}
var $fe0d20ea148325c5$export$2e2bcd8739ae039 = $fe0d20ea148325c5$var$createDOMPurify();

});

parcelRegister("67nR7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4745e6c36dc68f88$export$2e2bcd8739ae039; });

var $lsAGk = parcelRequire("lsAGk");

var $bJLKV = parcelRequire("bJLKV");

var $bs5Uw = parcelRequire("bs5Uw");

var $2FTCE = parcelRequire("2FTCE");

var $5rhwP = parcelRequire("5rhwP");

var $gaO49 = parcelRequire("gaO49");

var $dAjLf = parcelRequire("dAjLf");

var $4ClAK = parcelRequire("4ClAK");

var $2jcr6 = parcelRequire("2jcr6");

var $3QPIl = parcelRequire("3QPIl");

var $j5J3l = parcelRequire("j5J3l");

var $aw1MP = parcelRequire("aw1MP");

var $k1Wht = parcelRequire("k1Wht");

var $EBaVF = parcelRequire("EBaVF");

var $NPXJE = parcelRequire("NPXJE");

var $fOmah = parcelRequire("fOmah");

var $iDTEz = parcelRequire("iDTEz");

var $lRuiA = parcelRequire("lRuiA");

var $ho0yq = parcelRequire("ho0yq");

var $bg1an = parcelRequire("bg1an");

var $kIiEv = parcelRequire("kIiEv");

var $cRYaX = parcelRequire("cRYaX");

var $fWPEs = parcelRequire("fWPEs");

var $jkw9l = parcelRequire("jkw9l");

var $ghSE1 = parcelRequire("ghSE1");

var $6A024 = parcelRequire("6A024");

var $gi9MJ = parcelRequire("gi9MJ");

var $iXNXI = parcelRequire("iXNXI");

var $8q2LS = parcelRequire("8q2LS");

var $e7EBO = parcelRequire("e7EBO");

var $8JDEJ = parcelRequire("8JDEJ");
(0, $lsAGk.default).register({
    'attributors/attribute/direction': (0, $bs5Uw.DirectionAttribute),
    'attributors/class/align': (0, $bJLKV.AlignClass),
    'attributors/class/background': (0, $4ClAK.BackgroundClass),
    'attributors/class/color': (0, $2jcr6.ColorClass),
    'attributors/class/direction': (0, $bs5Uw.DirectionClass),
    'attributors/class/font': (0, $3QPIl.FontClass),
    'attributors/class/size': (0, $j5J3l.SizeClass),
    'attributors/style/align': (0, $bJLKV.AlignStyle),
    'attributors/style/background': (0, $4ClAK.BackgroundStyle),
    'attributors/style/color': (0, $2jcr6.ColorStyle),
    'attributors/style/direction': (0, $bs5Uw.DirectionStyle),
    'attributors/style/font': (0, $3QPIl.FontStyle),
    'attributors/style/size': (0, $j5J3l.SizeStyle)
}, true);
(0, $lsAGk.default).register({
    'formats/align': (0, $bJLKV.AlignClass),
    'formats/direction': (0, $bs5Uw.DirectionClass),
    'formats/indent': (0, $2FTCE.default),
    'formats/background': (0, $4ClAK.BackgroundStyle),
    'formats/color': (0, $2jcr6.ColorStyle),
    'formats/font': (0, $3QPIl.FontClass),
    'formats/size': (0, $j5J3l.SizeClass),
    'formats/blockquote': (0, $5rhwP.default),
    'formats/code-block': (0, $kIiEv.default),
    'formats/header': (0, $gaO49.default),
    'formats/list': (0, $dAjLf.default),
    'formats/bold': (0, $aw1MP.default),
    'formats/code': (0, $kIiEv.Code),
    'formats/italic': (0, $k1Wht.default),
    'formats/link': (0, $EBaVF.default),
    'formats/script': (0, $NPXJE.default),
    'formats/strike': (0, $fOmah.default),
    'formats/underline': (0, $iDTEz.default),
    'formats/formula': (0, $lRuiA.default),
    'formats/image': (0, $ho0yq.default),
    'formats/video': (0, $bg1an.default),
    'modules/syntax': (0, $cRYaX.default),
    'modules/table': (0, $fWPEs.default),
    'modules/toolbar': (0, $jkw9l.default),
    'themes/bubble': (0, $e7EBO.default),
    'themes/snow': (0, $8JDEJ.default),
    'ui/icons': (0, $ghSE1.default),
    'ui/picker': (0, $6A024.default),
    'ui/icon-picker': (0, $iXNXI.default),
    'ui/color-picker': (0, $gi9MJ.default),
    'ui/tooltip': (0, $8q2LS.default)
}, true);
var $4745e6c36dc68f88$export$2e2bcd8739ae039 = (0, $lsAGk.default);

});
parcelRegister("lsAGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9f8aab3ef7eb5fa$export$2e2bcd8739ae039; });

var $1coM0 = parcelRequire("1coM0");

var $eT6zx = parcelRequire("eT6zx");

var $aA0eA = parcelRequire("aA0eA");

var $faDi5 = parcelRequire("faDi5");

var $i4Ja5 = parcelRequire("i4Ja5");

var $2v3kg = parcelRequire("2v3kg");

var $i9ca8 = parcelRequire("i9ca8");

var $b1sv1 = parcelRequire("b1sv1");

var $1oJfc = parcelRequire("1oJfc");

var $eKsv8 = parcelRequire("eKsv8");

var $cgEGO = parcelRequire("cgEGO");

var $kZq8S = parcelRequire("kZq8S");

var $71beM = parcelRequire("71beM");

var $eD1QA = parcelRequire("eD1QA");

var $8oCDW = parcelRequire("8oCDW");

var $gNHrB = parcelRequire("gNHrB");

var $9ixpP = parcelRequire("9ixpP");
(0, $1coM0.default).register({
    'blots/block': (0, $eT6zx.default),
    'blots/block/embed': (0, $eT6zx.BlockEmbed),
    'blots/break': (0, $aA0eA.default),
    'blots/container': (0, $faDi5.default),
    'blots/cursor': (0, $i4Ja5.default),
    'blots/embed': (0, $2v3kg.default),
    'blots/inline': (0, $i9ca8.default),
    'blots/scroll': (0, $b1sv1.default),
    'blots/text': (0, $1oJfc.default),
    'modules/clipboard': (0, $eKsv8.default),
    'modules/history': (0, $cgEGO.default),
    'modules/keyboard': (0, $kZq8S.default),
    'modules/uploader': (0, $71beM.default),
    'modules/input': (0, $8oCDW.default),
    'modules/uiNode': (0, $gNHrB.default)
});
var $f9f8aab3ef7eb5fa$export$2e2bcd8739ae039 = (0, $1coM0.default);

});
parcelRegister("1coM0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039; });

var $h21cN = parcelRequire("h21cN");

var $9uxoP = parcelRequire("9uxoP");

var $eD1QA = parcelRequire("eD1QA");

var $9Ud7C = parcelRequire("9Ud7C");

var $lK3Fw = parcelRequire("lK3Fw");

var $8h5XC = parcelRequire("8h5XC");

var $6frwg = parcelRequire("6frwg");

var $9ixpP = parcelRequire("9ixpP");

var $36WOi = parcelRequire("36WOi");

var $9AxMn = parcelRequire("9AxMn");

var $bzBuA = parcelRequire("bzBuA");

var $kO1v8 = parcelRequire("kO1v8");

var $8GfdF = parcelRequire("8GfdF");
const $0dfa20e5dbbb7e1d$var$debug = (0, $6frwg.default)('quill');
const $0dfa20e5dbbb7e1d$export$bc58ce2776ecdb6f = new $9uxoP.Registry();
$9uxoP.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $0dfa20e5dbbb7e1d$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $lK3Fw.default).events;
    static sources = (0, $lK3Fw.default).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA))),
        parchment: $9uxoP,
        'core/module': (0, $9ixpP.default),
        'core/theme': (0, $bzBuA.default)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $6frwg.default).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $8h5XC.default).get(node) || $0dfa20e5dbbb7e1d$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $0dfa20e5dbbb7e1d$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $0dfa20e5dbbb7e1d$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $0dfa20e5dbbb7e1d$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($0dfa20e5dbbb7e1d$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $0dfa20e5dbbb7e1d$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $0dfa20e5dbbb7e1d$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $8h5XC.default).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $lK3Fw.default)();
        const scrollBlotName = $9uxoP.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $9Ud7C.default)(this.scroll);
        this.selection = new (0, $36WOi.default)(this.scroll, this.emitter);
        this.composition = new (0, $9AxMn.default)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $lK3Fw.default).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $lK3Fw.default).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $lK3Fw.default).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $lK3Fw.default).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, length, source);
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $lK3Fw.default).sources.API;
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
            if (range == null) return change;
            if (this.scroll.query(name, $9uxoP.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $lK3Fw.default).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039.sources.API;
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, 0, name, value, source);
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, length, source);
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $kO1v8.default)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $lK3Fw.default).sources.API;
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $36WOi.Range)(Math.max(0, index), length), source);
            if (source !== (0, $lK3Fw.default).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $lK3Fw.default).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $lK3Fw.default).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $lK3Fw.default).sources.API;
        return $0dfa20e5dbbb7e1d$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $0dfa20e5dbbb7e1d$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $0dfa20e5dbbb7e1d$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $0dfa20e5dbbb7e1d$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $0dfa20e5dbbb7e1d$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $0dfa20e5dbbb7e1d$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $bzBuA.default) : $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $0dfa20e5dbbb7e1d$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $h21cN.default)({}, $0dfa20e5dbbb7e1d$var$expandModuleConfig(quillModuleDefaults), $0dfa20e5dbbb7e1d$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$0dfa20e5dbbb7e1d$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$0dfa20e5dbbb7e1d$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $0dfa20e5dbbb7e1d$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $8GfdF.default)(options.formats, config.registry, $0dfa20e5dbbb7e1d$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $0dfa20e5dbbb7e1d$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $0dfa20e5dbbb7e1d$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $h21cN.default)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $0dfa20e5dbbb7e1d$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $0dfa20e5dbbb7e1d$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $lK3Fw.default).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $0dfa20e5dbbb7e1d$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $0dfa20e5dbbb7e1d$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $lK3Fw.default).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $lK3Fw.default).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $lK3Fw.default).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $lK3Fw.default).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $0dfa20e5dbbb7e1d$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $lK3Fw.default).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $0dfa20e5dbbb7e1d$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $lK3Fw.default).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $lK3Fw.default).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $36WOi.Range)(start, end - start);
}

});
parcelRegister("h21cN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6638ef266600669$export$2e2bcd8739ae039; });

var $f34V3 = parcelRequire("f34V3");

var $lpBDp = parcelRequire("lpBDp");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $c6638ef266600669$var$merge = (0, $lpBDp.default)(function(object, source, srcIndex) {
    (0, $f34V3.default)(object, source, srcIndex);
});
var $c6638ef266600669$export$2e2bcd8739ae039 = $c6638ef266600669$var$merge;

});
parcelRegister("f34V3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af4af3b18973f196$export$2e2bcd8739ae039; });

var $liuc6 = parcelRequire("liuc6");

var $fnvHv = parcelRequire("fnvHv");

var $b6AUT = parcelRequire("b6AUT");

var $apuQs = parcelRequire("apuQs");

var $iiCpe = parcelRequire("iiCpe");

var $2JtFO = parcelRequire("2JtFO");

var $jPtV7 = parcelRequire("jPtV7");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $af4af3b18973f196$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $b6AUT.default)(source, function(srcValue, key) {
        stack || (stack = new (0, $liuc6.default));
        if ((0, $iiCpe.default)(srcValue)) (0, $apuQs.default)(object, source, key, srcIndex, $af4af3b18973f196$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $jPtV7.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $fnvHv.default)(object, key, newValue);
        }
    }, (0, $2JtFO.default));
}
var $af4af3b18973f196$export$2e2bcd8739ae039 = $af4af3b18973f196$var$baseMerge;

});
parcelRegister("liuc6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f812b36057138195$export$2e2bcd8739ae039; });

var $e2Aqw = parcelRequire("e2Aqw");

var $7OOPm = parcelRequire("7OOPm");

var $fF7tG = parcelRequire("fF7tG");

var $8woae = parcelRequire("8woae");

var $dOV9j = parcelRequire("dOV9j");

var $dxtsF = parcelRequire("dxtsF");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f812b36057138195$var$Stack(entries) {
    var data = this.__data__ = new (0, $e2Aqw.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$f812b36057138195$var$Stack.prototype.clear = (0, $7OOPm.default);
$f812b36057138195$var$Stack.prototype['delete'] = (0, $fF7tG.default);
$f812b36057138195$var$Stack.prototype.get = (0, $8woae.default);
$f812b36057138195$var$Stack.prototype.has = (0, $dOV9j.default);
$f812b36057138195$var$Stack.prototype.set = (0, $dxtsF.default);
var $f812b36057138195$export$2e2bcd8739ae039 = $f812b36057138195$var$Stack;

});
parcelRegister("e2Aqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a38d823309c355a7$export$2e2bcd8739ae039; });

var $A7bfs = parcelRequire("A7bfs");

var $fNXZa = parcelRequire("fNXZa");

var $7NQ5Q = parcelRequire("7NQ5Q");

var $lFG52 = parcelRequire("lFG52");

var $hGk84 = parcelRequire("hGk84");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a38d823309c355a7$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$a38d823309c355a7$var$ListCache.prototype.clear = (0, $A7bfs.default);
$a38d823309c355a7$var$ListCache.prototype['delete'] = (0, $fNXZa.default);
$a38d823309c355a7$var$ListCache.prototype.get = (0, $7NQ5Q.default);
$a38d823309c355a7$var$ListCache.prototype.has = (0, $lFG52.default);
$a38d823309c355a7$var$ListCache.prototype.set = (0, $hGk84.default);
var $a38d823309c355a7$export$2e2bcd8739ae039 = $a38d823309c355a7$var$ListCache;

});
parcelRegister("A7bfs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06c8eeca626df762$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $06c8eeca626df762$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $06c8eeca626df762$export$2e2bcd8739ae039 = $06c8eeca626df762$var$listCacheClear;

});

parcelRegister("fNXZa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b819f67ad8776d8a$export$2e2bcd8739ae039; });

var $8WEAa = parcelRequire("8WEAa");
/** Used for built-in method references. */ var $b819f67ad8776d8a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $b819f67ad8776d8a$var$splice = $b819f67ad8776d8a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b819f67ad8776d8a$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $8WEAa.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $b819f67ad8776d8a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $b819f67ad8776d8a$export$2e2bcd8739ae039 = $b819f67ad8776d8a$var$listCacheDelete;

});
parcelRegister("8WEAa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6833384b2c6ce8c8$export$2e2bcd8739ae039; });

var $a8hBh = parcelRequire("a8hBh");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6833384b2c6ce8c8$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $a8hBh.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $6833384b2c6ce8c8$export$2e2bcd8739ae039 = $6833384b2c6ce8c8$var$assocIndexOf;

});
parcelRegister("a8hBh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76084dcca9912c75$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $76084dcca9912c75$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $76084dcca9912c75$export$2e2bcd8739ae039 = $76084dcca9912c75$var$eq;

});



parcelRegister("7NQ5Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ae584a18b104aaf$export$2e2bcd8739ae039; });

var $8WEAa = parcelRequire("8WEAa");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5ae584a18b104aaf$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $8WEAa.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $5ae584a18b104aaf$export$2e2bcd8739ae039 = $5ae584a18b104aaf$var$listCacheGet;

});

parcelRegister("lFG52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc6e11948fb52f4e$export$2e2bcd8739ae039; });

var $8WEAa = parcelRequire("8WEAa");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fc6e11948fb52f4e$var$listCacheHas(key) {
    return (0, $8WEAa.default)(this.__data__, key) > -1;
}
var $fc6e11948fb52f4e$export$2e2bcd8739ae039 = $fc6e11948fb52f4e$var$listCacheHas;

});

parcelRegister("hGk84", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdf5f9276c8ddf13$export$2e2bcd8739ae039; });

var $8WEAa = parcelRequire("8WEAa");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $cdf5f9276c8ddf13$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $8WEAa.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $cdf5f9276c8ddf13$export$2e2bcd8739ae039 = $cdf5f9276c8ddf13$var$listCacheSet;

});


parcelRegister("7OOPm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b14a12f7f3d103b$export$2e2bcd8739ae039; });

var $e2Aqw = parcelRequire("e2Aqw");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $5b14a12f7f3d103b$var$stackClear() {
    this.__data__ = new (0, $e2Aqw.default);
    this.size = 0;
}
var $5b14a12f7f3d103b$export$2e2bcd8739ae039 = $5b14a12f7f3d103b$var$stackClear;

});

parcelRegister("fF7tG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6707c4d033b2087$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b6707c4d033b2087$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $b6707c4d033b2087$export$2e2bcd8739ae039 = $b6707c4d033b2087$var$stackDelete;

});

parcelRegister("8woae", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63440e5c53852365$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $63440e5c53852365$var$stackGet(key) {
    return this.__data__.get(key);
}
var $63440e5c53852365$export$2e2bcd8739ae039 = $63440e5c53852365$var$stackGet;

});

parcelRegister("dOV9j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0fc468316a37a9a$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a0fc468316a37a9a$var$stackHas(key) {
    return this.__data__.has(key);
}
var $a0fc468316a37a9a$export$2e2bcd8739ae039 = $a0fc468316a37a9a$var$stackHas;

});

parcelRegister("dxtsF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db535d70d63a7d8$export$2e2bcd8739ae039; });

var $e2Aqw = parcelRequire("e2Aqw");

var $cnNjY = parcelRequire("cnNjY");

var $5XRvl = parcelRequire("5XRvl");
/** Used as the size to enable large array optimizations. */ var $9db535d70d63a7d8$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9db535d70d63a7d8$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $e2Aqw.default)) {
        var pairs = data.__data__;
        if (!(0, $cnNjY.default) || pairs.length < $9db535d70d63a7d8$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $5XRvl.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $9db535d70d63a7d8$export$2e2bcd8739ae039 = $9db535d70d63a7d8$var$stackSet;

});
parcelRegister("cnNjY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $903de42986dc0c55$export$2e2bcd8739ae039; });

var $61Nxa = parcelRequire("61Nxa");

var $3dxin = parcelRequire("3dxin");
/* Built-in method references that are verified to be native. */ var $903de42986dc0c55$var$Map = (0, $61Nxa.default)((0, $3dxin.default), 'Map');
var $903de42986dc0c55$export$2e2bcd8739ae039 = $903de42986dc0c55$var$Map;

});
parcelRegister("61Nxa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4639427c7f305a69$export$2e2bcd8739ae039; });

var $c9fYd = parcelRequire("c9fYd");

var $ivAaW = parcelRequire("ivAaW");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4639427c7f305a69$var$getNative(object, key) {
    var value = (0, $ivAaW.default)(object, key);
    return (0, $c9fYd.default)(value) ? value : undefined;
}
var $4639427c7f305a69$export$2e2bcd8739ae039 = $4639427c7f305a69$var$getNative;

});
parcelRegister("c9fYd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d82b6aade85b624$export$2e2bcd8739ae039; });

var $2VsVA = parcelRequire("2VsVA");

var $WmoDx = parcelRequire("WmoDx");

var $iiCpe = parcelRequire("iiCpe");

var $lMOWq = parcelRequire("lMOWq");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8d82b6aade85b624$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8d82b6aade85b624$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8d82b6aade85b624$var$funcProto = Function.prototype, $8d82b6aade85b624$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8d82b6aade85b624$var$funcToString = $8d82b6aade85b624$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8d82b6aade85b624$var$hasOwnProperty = $8d82b6aade85b624$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8d82b6aade85b624$var$reIsNative = RegExp('^' + $8d82b6aade85b624$var$funcToString.call($8d82b6aade85b624$var$hasOwnProperty).replace($8d82b6aade85b624$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8d82b6aade85b624$var$baseIsNative(value) {
    if (!(0, $iiCpe.default)(value) || (0, $WmoDx.default)(value)) return false;
    var pattern = (0, $2VsVA.default)(value) ? $8d82b6aade85b624$var$reIsNative : $8d82b6aade85b624$var$reIsHostCtor;
    return pattern.test((0, $lMOWq.default)(value));
}
var $8d82b6aade85b624$export$2e2bcd8739ae039 = $8d82b6aade85b624$var$baseIsNative;

});
parcelRegister("2VsVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2217581a41eb0d4e$export$2e2bcd8739ae039; });

var $8frC0 = parcelRequire("8frC0");

var $iiCpe = parcelRequire("iiCpe");
/** `Object#toString` result references. */ var $2217581a41eb0d4e$var$asyncTag = '[object AsyncFunction]', $2217581a41eb0d4e$var$funcTag = '[object Function]', $2217581a41eb0d4e$var$genTag = '[object GeneratorFunction]', $2217581a41eb0d4e$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $2217581a41eb0d4e$var$isFunction(value) {
    if (!(0, $iiCpe.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $8frC0.default)(value);
    return tag == $2217581a41eb0d4e$var$funcTag || tag == $2217581a41eb0d4e$var$genTag || tag == $2217581a41eb0d4e$var$asyncTag || tag == $2217581a41eb0d4e$var$proxyTag;
}
var $2217581a41eb0d4e$export$2e2bcd8739ae039 = $2217581a41eb0d4e$var$isFunction;

});
parcelRegister("8frC0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6015249c77efa11e$export$2e2bcd8739ae039; });

var $k7yso = parcelRequire("k7yso");

var $5eMaz = parcelRequire("5eMaz");

var $lKopD = parcelRequire("lKopD");
/** `Object#toString` result references. */ var $6015249c77efa11e$var$nullTag = '[object Null]', $6015249c77efa11e$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $6015249c77efa11e$var$symToStringTag = (0, $k7yso.default) ? (0, $k7yso.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $6015249c77efa11e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $6015249c77efa11e$var$undefinedTag : $6015249c77efa11e$var$nullTag;
    return $6015249c77efa11e$var$symToStringTag && $6015249c77efa11e$var$symToStringTag in Object(value) ? (0, $5eMaz.default)(value) : (0, $lKopD.default)(value);
}
var $6015249c77efa11e$export$2e2bcd8739ae039 = $6015249c77efa11e$var$baseGetTag;

});
parcelRegister("k7yso", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea5f308a6b980f07$export$2e2bcd8739ae039; });

var $3dxin = parcelRequire("3dxin");
/** Built-in value references. */ var $ea5f308a6b980f07$var$Symbol = (0, $3dxin.default).Symbol;
var $ea5f308a6b980f07$export$2e2bcd8739ae039 = $ea5f308a6b980f07$var$Symbol;

});
parcelRegister("3dxin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $257c69c15cc11a71$export$2e2bcd8739ae039; });

var $lTJe9 = parcelRequire("lTJe9");
/** Detect free variable `self`. */ var $257c69c15cc11a71$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $257c69c15cc11a71$var$root = (0, $lTJe9.default) || $257c69c15cc11a71$var$freeSelf || Function('return this')();
var $257c69c15cc11a71$export$2e2bcd8739ae039 = $257c69c15cc11a71$var$root;

});
parcelRegister("lTJe9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff11d13239d20bbe$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $ff11d13239d20bbe$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $ff11d13239d20bbe$export$2e2bcd8739ae039 = $ff11d13239d20bbe$var$freeGlobal;

});



parcelRegister("5eMaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d039fff6947a3a4$export$2e2bcd8739ae039; });

var $k7yso = parcelRequire("k7yso");
/** Used for built-in method references. */ var $3d039fff6947a3a4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3d039fff6947a3a4$var$hasOwnProperty = $3d039fff6947a3a4$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3d039fff6947a3a4$var$nativeObjectToString = $3d039fff6947a3a4$var$objectProto.toString;
/** Built-in value references. */ var $3d039fff6947a3a4$var$symToStringTag = (0, $k7yso.default) ? (0, $k7yso.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3d039fff6947a3a4$var$getRawTag(value) {
    var isOwn = $3d039fff6947a3a4$var$hasOwnProperty.call(value, $3d039fff6947a3a4$var$symToStringTag), tag = value[$3d039fff6947a3a4$var$symToStringTag];
    try {
        value[$3d039fff6947a3a4$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3d039fff6947a3a4$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3d039fff6947a3a4$var$symToStringTag] = tag;
        else delete value[$3d039fff6947a3a4$var$symToStringTag];
    }
    return result;
}
var $3d039fff6947a3a4$export$2e2bcd8739ae039 = $3d039fff6947a3a4$var$getRawTag;

});

parcelRegister("lKopD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd50d4aec15a416c$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $fd50d4aec15a416c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $fd50d4aec15a416c$var$nativeObjectToString = $fd50d4aec15a416c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $fd50d4aec15a416c$var$objectToString(value) {
    return $fd50d4aec15a416c$var$nativeObjectToString.call(value);
}
var $fd50d4aec15a416c$export$2e2bcd8739ae039 = $fd50d4aec15a416c$var$objectToString;

});


parcelRegister("iiCpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d527b31354a4c50f$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d527b31354a4c50f$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $d527b31354a4c50f$export$2e2bcd8739ae039 = $d527b31354a4c50f$var$isObject;

});


parcelRegister("WmoDx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0af6ca5893df8800$export$2e2bcd8739ae039; });

var $f3gAd = parcelRequire("f3gAd");
/** Used to detect methods masquerading as native. */ var $0af6ca5893df8800$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $f3gAd.default) && (0, $f3gAd.default).keys && (0, $f3gAd.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $0af6ca5893df8800$var$isMasked(func) {
    return !!$0af6ca5893df8800$var$maskSrcKey && $0af6ca5893df8800$var$maskSrcKey in func;
}
var $0af6ca5893df8800$export$2e2bcd8739ae039 = $0af6ca5893df8800$var$isMasked;

});
parcelRegister("f3gAd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af53ffe43de70f91$export$2e2bcd8739ae039; });

var $3dxin = parcelRequire("3dxin");
/** Used to detect overreaching core-js shims. */ var $af53ffe43de70f91$var$coreJsData = (0, $3dxin.default)['__core-js_shared__'];
var $af53ffe43de70f91$export$2e2bcd8739ae039 = $af53ffe43de70f91$var$coreJsData;

});


parcelRegister("lMOWq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc5988fd0d13b8e$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $fdc5988fd0d13b8e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $fdc5988fd0d13b8e$var$funcToString = $fdc5988fd0d13b8e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $fdc5988fd0d13b8e$var$toSource(func) {
    if (func != null) {
        try {
            return $fdc5988fd0d13b8e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $fdc5988fd0d13b8e$export$2e2bcd8739ae039 = $fdc5988fd0d13b8e$var$toSource;

});


parcelRegister("ivAaW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7972eeb1dc7c25b$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d7972eeb1dc7c25b$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $d7972eeb1dc7c25b$export$2e2bcd8739ae039 = $d7972eeb1dc7c25b$var$getValue;

});



parcelRegister("5XRvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457bf756578ea451$export$2e2bcd8739ae039; });

var $6C1uG = parcelRequire("6C1uG");

var $94UXy = parcelRequire("94UXy");

var $27l6X = parcelRequire("27l6X");

var $6QxnW = parcelRequire("6QxnW");

var $3PZD3 = parcelRequire("3PZD3");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $457bf756578ea451$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$457bf756578ea451$var$MapCache.prototype.clear = (0, $6C1uG.default);
$457bf756578ea451$var$MapCache.prototype['delete'] = (0, $94UXy.default);
$457bf756578ea451$var$MapCache.prototype.get = (0, $27l6X.default);
$457bf756578ea451$var$MapCache.prototype.has = (0, $6QxnW.default);
$457bf756578ea451$var$MapCache.prototype.set = (0, $3PZD3.default);
var $457bf756578ea451$export$2e2bcd8739ae039 = $457bf756578ea451$var$MapCache;

});
parcelRegister("6C1uG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d07735bf0cf2054$export$2e2bcd8739ae039; });

var $aAqWG = parcelRequire("aAqWG");

var $e2Aqw = parcelRequire("e2Aqw");

var $cnNjY = parcelRequire("cnNjY");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $4d07735bf0cf2054$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $aAqWG.default),
        'map': new ((0, $cnNjY.default) || (0, $e2Aqw.default)),
        'string': new (0, $aAqWG.default)
    };
}
var $4d07735bf0cf2054$export$2e2bcd8739ae039 = $4d07735bf0cf2054$var$mapCacheClear;

});
parcelRegister("aAqWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b522b041a841c1f$export$2e2bcd8739ae039; });

var $2O6k7 = parcelRequire("2O6k7");

var $9XX3s = parcelRequire("9XX3s");

var $3feYL = parcelRequire("3feYL");

var $jvYhP = parcelRequire("jvYhP");

var $1eGKL = parcelRequire("1eGKL");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7b522b041a841c1f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$7b522b041a841c1f$var$Hash.prototype.clear = (0, $2O6k7.default);
$7b522b041a841c1f$var$Hash.prototype['delete'] = (0, $9XX3s.default);
$7b522b041a841c1f$var$Hash.prototype.get = (0, $3feYL.default);
$7b522b041a841c1f$var$Hash.prototype.has = (0, $jvYhP.default);
$7b522b041a841c1f$var$Hash.prototype.set = (0, $1eGKL.default);
var $7b522b041a841c1f$export$2e2bcd8739ae039 = $7b522b041a841c1f$var$Hash;

});
parcelRegister("2O6k7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20b527fe070682b4$export$2e2bcd8739ae039; });

var $hkqhf = parcelRequire("hkqhf");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $20b527fe070682b4$var$hashClear() {
    this.__data__ = (0, $hkqhf.default) ? (0, $hkqhf.default)(null) : {};
    this.size = 0;
}
var $20b527fe070682b4$export$2e2bcd8739ae039 = $20b527fe070682b4$var$hashClear;

});
parcelRegister("hkqhf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9d8b008d3b64fe4$export$2e2bcd8739ae039; });

var $61Nxa = parcelRequire("61Nxa");
/* Built-in method references that are verified to be native. */ var $c9d8b008d3b64fe4$var$nativeCreate = (0, $61Nxa.default)(Object, 'create');
var $c9d8b008d3b64fe4$export$2e2bcd8739ae039 = $c9d8b008d3b64fe4$var$nativeCreate;

});


parcelRegister("9XX3s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74176ecc247bb355$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $74176ecc247bb355$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $74176ecc247bb355$export$2e2bcd8739ae039 = $74176ecc247bb355$var$hashDelete;

});

parcelRegister("3feYL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25ce645775aef9d4$export$2e2bcd8739ae039; });

var $hkqhf = parcelRequire("hkqhf");
/** Used to stand-in for `undefined` hash values. */ var $25ce645775aef9d4$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $25ce645775aef9d4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $25ce645775aef9d4$var$hasOwnProperty = $25ce645775aef9d4$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $25ce645775aef9d4$var$hashGet(key) {
    var data = this.__data__;
    if (0, $hkqhf.default) {
        var result = data[key];
        return result === $25ce645775aef9d4$var$HASH_UNDEFINED ? undefined : result;
    }
    return $25ce645775aef9d4$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $25ce645775aef9d4$export$2e2bcd8739ae039 = $25ce645775aef9d4$var$hashGet;

});

parcelRegister("jvYhP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e34fad34a04f5b4b$export$2e2bcd8739ae039; });

var $hkqhf = parcelRequire("hkqhf");
/** Used for built-in method references. */ var $e34fad34a04f5b4b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e34fad34a04f5b4b$var$hasOwnProperty = $e34fad34a04f5b4b$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e34fad34a04f5b4b$var$hashHas(key) {
    var data = this.__data__;
    return (0, $hkqhf.default) ? data[key] !== undefined : $e34fad34a04f5b4b$var$hasOwnProperty.call(data, key);
}
var $e34fad34a04f5b4b$export$2e2bcd8739ae039 = $e34fad34a04f5b4b$var$hashHas;

});

parcelRegister("1eGKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e68432d6258227d$export$2e2bcd8739ae039; });

var $hkqhf = parcelRequire("hkqhf");
/** Used to stand-in for `undefined` hash values. */ var $0e68432d6258227d$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $0e68432d6258227d$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $hkqhf.default) && value === undefined ? $0e68432d6258227d$var$HASH_UNDEFINED : value;
    return this;
}
var $0e68432d6258227d$export$2e2bcd8739ae039 = $0e68432d6258227d$var$hashSet;

});



parcelRegister("94UXy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69c0abc08145dd2b$export$2e2bcd8739ae039; });

var $hTk55 = parcelRequire("hTk55");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $69c0abc08145dd2b$var$mapCacheDelete(key) {
    var result = (0, $hTk55.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $69c0abc08145dd2b$export$2e2bcd8739ae039 = $69c0abc08145dd2b$var$mapCacheDelete;

});
parcelRegister("hTk55", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d067266a4ee53146$export$2e2bcd8739ae039; });

var $a7zSD = parcelRequire("a7zSD");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d067266a4ee53146$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $a7zSD.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $d067266a4ee53146$export$2e2bcd8739ae039 = $d067266a4ee53146$var$getMapData;

});
parcelRegister("a7zSD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75e663e8ac2d2602$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $75e663e8ac2d2602$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $75e663e8ac2d2602$export$2e2bcd8739ae039 = $75e663e8ac2d2602$var$isKeyable;

});



parcelRegister("27l6X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18ac9c7a1d6d129b$export$2e2bcd8739ae039; });

var $hTk55 = parcelRequire("hTk55");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $18ac9c7a1d6d129b$var$mapCacheGet(key) {
    return (0, $hTk55.default)(this, key).get(key);
}
var $18ac9c7a1d6d129b$export$2e2bcd8739ae039 = $18ac9c7a1d6d129b$var$mapCacheGet;

});

parcelRegister("6QxnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fc17f00baa73f9b$export$2e2bcd8739ae039; });

var $hTk55 = parcelRequire("hTk55");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4fc17f00baa73f9b$var$mapCacheHas(key) {
    return (0, $hTk55.default)(this, key).has(key);
}
var $4fc17f00baa73f9b$export$2e2bcd8739ae039 = $4fc17f00baa73f9b$var$mapCacheHas;

});

parcelRegister("3PZD3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb5f0b9ffe5c56a$export$2e2bcd8739ae039; });

var $hTk55 = parcelRequire("hTk55");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2cb5f0b9ffe5c56a$var$mapCacheSet(key, value) {
    var data = (0, $hTk55.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $2cb5f0b9ffe5c56a$export$2e2bcd8739ae039 = $2cb5f0b9ffe5c56a$var$mapCacheSet;

});




parcelRegister("fnvHv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b321981dc34ad9dd$export$2e2bcd8739ae039; });

var $7iG1m = parcelRequire("7iG1m");

var $a8hBh = parcelRequire("a8hBh");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b321981dc34ad9dd$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $a8hBh.default)(object[key], value) || value === undefined && !(key in object)) (0, $7iG1m.default)(object, key, value);
}
var $b321981dc34ad9dd$export$2e2bcd8739ae039 = $b321981dc34ad9dd$var$assignMergeValue;

});
parcelRegister("7iG1m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $015f24604c1ea177$export$2e2bcd8739ae039; });

var $jTFSO = parcelRequire("jTFSO");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $015f24604c1ea177$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $jTFSO.default)) (0, $jTFSO.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $015f24604c1ea177$export$2e2bcd8739ae039 = $015f24604c1ea177$var$baseAssignValue;

});
parcelRegister("jTFSO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7c3a4807507e126$export$2e2bcd8739ae039; });

var $61Nxa = parcelRequire("61Nxa");
var $e7c3a4807507e126$var$defineProperty = function() {
    try {
        var func = (0, $61Nxa.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $e7c3a4807507e126$export$2e2bcd8739ae039 = $e7c3a4807507e126$var$defineProperty;

});



parcelRegister("b6AUT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $815ce41cfef71477$export$2e2bcd8739ae039; });

var $5esEm = parcelRequire("5esEm");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $815ce41cfef71477$var$baseFor = (0, $5esEm.default)();
var $815ce41cfef71477$export$2e2bcd8739ae039 = $815ce41cfef71477$var$baseFor;

});
parcelRegister("5esEm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cf47bdbfaf76588$export$2e2bcd8739ae039; });
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3cf47bdbfaf76588$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $3cf47bdbfaf76588$export$2e2bcd8739ae039 = $3cf47bdbfaf76588$var$createBaseFor;

});


parcelRegister("apuQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79442a61c70521ed$export$2e2bcd8739ae039; });

var $fnvHv = parcelRequire("fnvHv");

var $cLGnB = parcelRequire("cLGnB");

var $hHZg1 = parcelRequire("hHZg1");

var $kG8QS = parcelRequire("kG8QS");

var $gEuKx = parcelRequire("gEuKx");

var $jRLtw = parcelRequire("jRLtw");

var $03TET = parcelRequire("03TET");

var $ciiq8 = parcelRequire("ciiq8");

var $fgu66 = parcelRequire("fgu66");

var $2VsVA = parcelRequire("2VsVA");

var $iiCpe = parcelRequire("iiCpe");

var $inqRu = parcelRequire("inqRu");

var $bLelA = parcelRequire("bLelA");

var $jPtV7 = parcelRequire("jPtV7");

var $7n5zD = parcelRequire("7n5zD");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $79442a61c70521ed$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $jPtV7.default)(object, key), srcValue = (0, $jPtV7.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $fnvHv.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $03TET.default)(srcValue), isBuff = !isArr && (0, $fgu66.default)(srcValue), isTyped = !isArr && !isBuff && (0, $bLelA.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $03TET.default)(objValue)) newValue = objValue;
            else if ((0, $ciiq8.default)(objValue)) newValue = (0, $kG8QS.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $cLGnB.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $hHZg1.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $inqRu.default)(srcValue) || (0, $jRLtw.default)(srcValue)) {
            newValue = objValue;
            if ((0, $jRLtw.default)(objValue)) newValue = (0, $7n5zD.default)(objValue);
            else if (!(0, $iiCpe.default)(objValue) || (0, $2VsVA.default)(objValue)) newValue = (0, $gEuKx.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $fnvHv.default)(object, key, newValue);
}
var $79442a61c70521ed$export$2e2bcd8739ae039 = $79442a61c70521ed$var$baseMergeDeep;

});
parcelRegister("cLGnB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94babf897a57c67e$export$2e2bcd8739ae039; });

var $3dxin = parcelRequire("3dxin");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $3dxin.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $94babf897a57c67e$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("hHZg1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce45f8494a83f105$export$2e2bcd8739ae039; });

var $7k3Pr = parcelRequire("7k3Pr");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $ce45f8494a83f105$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $7k3Pr.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $ce45f8494a83f105$export$2e2bcd8739ae039 = $ce45f8494a83f105$var$cloneTypedArray;

});
parcelRegister("7k3Pr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $554d5eef7445b759$export$2e2bcd8739ae039; });

var $hY6DR = parcelRequire("hY6DR");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $554d5eef7445b759$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $hY6DR.default)(result).set(new (0, $hY6DR.default)(arrayBuffer));
    return result;
}
var $554d5eef7445b759$export$2e2bcd8739ae039 = $554d5eef7445b759$var$cloneArrayBuffer;

});
parcelRegister("hY6DR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d14d3132174115a9$export$2e2bcd8739ae039; });

var $3dxin = parcelRequire("3dxin");
/** Built-in value references. */ var $d14d3132174115a9$var$Uint8Array = (0, $3dxin.default).Uint8Array;
var $d14d3132174115a9$export$2e2bcd8739ae039 = $d14d3132174115a9$var$Uint8Array;

});



parcelRegister("kG8QS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0de98b38d00f80c$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $f0de98b38d00f80c$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $f0de98b38d00f80c$export$2e2bcd8739ae039 = $f0de98b38d00f80c$var$copyArray;

});

parcelRegister("gEuKx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1f83c069ae9f8fe$export$2e2bcd8739ae039; });

var $7SJl2 = parcelRequire("7SJl2");

var $7sAem = parcelRequire("7sAem");

var $8q6v1 = parcelRequire("8q6v1");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $c1f83c069ae9f8fe$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $8q6v1.default)(object) ? (0, $7SJl2.default)((0, $7sAem.default)(object)) : {};
}
var $c1f83c069ae9f8fe$export$2e2bcd8739ae039 = $c1f83c069ae9f8fe$var$initCloneObject;

});
parcelRegister("7SJl2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bd0bece1b060558$export$2e2bcd8739ae039; });

var $iiCpe = parcelRequire("iiCpe");
/** Built-in value references. */ var $5bd0bece1b060558$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $5bd0bece1b060558$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iiCpe.default)(proto)) return {};
        if ($5bd0bece1b060558$var$objectCreate) return $5bd0bece1b060558$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $5bd0bece1b060558$export$2e2bcd8739ae039 = $5bd0bece1b060558$var$baseCreate;

});

parcelRegister("7sAem", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56e740936dcb150b$export$2e2bcd8739ae039; });

var $aZtRh = parcelRequire("aZtRh");
/** Built-in value references. */ var $56e740936dcb150b$var$getPrototype = (0, $aZtRh.default)(Object.getPrototypeOf, Object);
var $56e740936dcb150b$export$2e2bcd8739ae039 = $56e740936dcb150b$var$getPrototype;

});
parcelRegister("aZtRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8006c31fb457c127$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $8006c31fb457c127$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $8006c31fb457c127$export$2e2bcd8739ae039 = $8006c31fb457c127$var$overArg;

});


parcelRegister("8q6v1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6215cb17a83674a1$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $6215cb17a83674a1$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $6215cb17a83674a1$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $6215cb17a83674a1$var$objectProto;
    return value === proto;
}
var $6215cb17a83674a1$export$2e2bcd8739ae039 = $6215cb17a83674a1$var$isPrototype;

});


parcelRegister("jRLtw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e767cb206129d23c$export$2e2bcd8739ae039; });

var $5n6Th = parcelRequire("5n6Th");

var $aA60L = parcelRequire("aA60L");
/** Used for built-in method references. */ var $e767cb206129d23c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e767cb206129d23c$var$hasOwnProperty = $e767cb206129d23c$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $e767cb206129d23c$var$propertyIsEnumerable = $e767cb206129d23c$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $e767cb206129d23c$var$isArguments = (0, $5n6Th.default)(function() {
    return arguments;
}()) ? (0, $5n6Th.default) : function(value) {
    return (0, $aA60L.default)(value) && $e767cb206129d23c$var$hasOwnProperty.call(value, 'callee') && !$e767cb206129d23c$var$propertyIsEnumerable.call(value, 'callee');
};
var $e767cb206129d23c$export$2e2bcd8739ae039 = $e767cb206129d23c$var$isArguments;

});
parcelRegister("5n6Th", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e947211d1c7ee59$export$2e2bcd8739ae039; });

var $8frC0 = parcelRequire("8frC0");

var $aA60L = parcelRequire("aA60L");
/** `Object#toString` result references. */ var $3e947211d1c7ee59$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $3e947211d1c7ee59$var$baseIsArguments(value) {
    return (0, $aA60L.default)(value) && (0, $8frC0.default)(value) == $3e947211d1c7ee59$var$argsTag;
}
var $3e947211d1c7ee59$export$2e2bcd8739ae039 = $3e947211d1c7ee59$var$baseIsArguments;

});
parcelRegister("aA60L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b41ede4369525df$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $7b41ede4369525df$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $7b41ede4369525df$export$2e2bcd8739ae039 = $7b41ede4369525df$var$isObjectLike;

});



parcelRegister("03TET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00bb74946ef61490$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $00bb74946ef61490$var$isArray = Array.isArray;
var $00bb74946ef61490$export$2e2bcd8739ae039 = $00bb74946ef61490$var$isArray;

});

parcelRegister("ciiq8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f35746d9284a197$export$2e2bcd8739ae039; });

var $8xBRZ = parcelRequire("8xBRZ");

var $aA60L = parcelRequire("aA60L");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $8f35746d9284a197$var$isArrayLikeObject(value) {
    return (0, $aA60L.default)(value) && (0, $8xBRZ.default)(value);
}
var $8f35746d9284a197$export$2e2bcd8739ae039 = $8f35746d9284a197$var$isArrayLikeObject;

});
parcelRegister("8xBRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $637ec7f0c5bc1274$export$2e2bcd8739ae039; });

var $2VsVA = parcelRequire("2VsVA");

var $jKhdf = parcelRequire("jKhdf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $637ec7f0c5bc1274$var$isArrayLike(value) {
    return value != null && (0, $jKhdf.default)(value.length) && !(0, $2VsVA.default)(value);
}
var $637ec7f0c5bc1274$export$2e2bcd8739ae039 = $637ec7f0c5bc1274$var$isArrayLike;

});
parcelRegister("jKhdf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5ffaa48c4611e33$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $e5ffaa48c4611e33$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e5ffaa48c4611e33$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $e5ffaa48c4611e33$var$MAX_SAFE_INTEGER;
}
var $e5ffaa48c4611e33$export$2e2bcd8739ae039 = $e5ffaa48c4611e33$var$isLength;

});



parcelRegister("fgu66", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1cfb2610a79da7e$export$2e2bcd8739ae039; });

var $3dxin = parcelRequire("3dxin");

var $4HQ0g = parcelRequire("4HQ0g");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $3dxin.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $4HQ0g.default);
var $b1cfb2610a79da7e$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("4HQ0g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36d38454b76763b9$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $36d38454b76763b9$var$stubFalse() {
    return false;
}
var $36d38454b76763b9$export$2e2bcd8739ae039 = $36d38454b76763b9$var$stubFalse;

});


parcelRegister("inqRu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60f36236d29ea32$export$2e2bcd8739ae039; });

var $8frC0 = parcelRequire("8frC0");

var $7sAem = parcelRequire("7sAem");

var $aA60L = parcelRequire("aA60L");
/** `Object#toString` result references. */ var $d60f36236d29ea32$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $d60f36236d29ea32$var$funcProto = Function.prototype, $d60f36236d29ea32$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d60f36236d29ea32$var$funcToString = $d60f36236d29ea32$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d60f36236d29ea32$var$hasOwnProperty = $d60f36236d29ea32$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $d60f36236d29ea32$var$objectCtorString = $d60f36236d29ea32$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $d60f36236d29ea32$var$isPlainObject(value) {
    if (!(0, $aA60L.default)(value) || (0, $8frC0.default)(value) != $d60f36236d29ea32$var$objectTag) return false;
    var proto = (0, $7sAem.default)(value);
    if (proto === null) return true;
    var Ctor = $d60f36236d29ea32$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $d60f36236d29ea32$var$funcToString.call(Ctor) == $d60f36236d29ea32$var$objectCtorString;
}
var $d60f36236d29ea32$export$2e2bcd8739ae039 = $d60f36236d29ea32$var$isPlainObject;

});

parcelRegister("bLelA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88ff368c56a92883$export$2e2bcd8739ae039; });

var $iaspZ = parcelRequire("iaspZ");

var $ijBt2 = parcelRequire("ijBt2");

var $cYLhX = parcelRequire("cYLhX");
/* Node.js helper references. */ var $88ff368c56a92883$var$nodeIsTypedArray = (0, $cYLhX.default) && (0, $cYLhX.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $88ff368c56a92883$var$isTypedArray = $88ff368c56a92883$var$nodeIsTypedArray ? (0, $ijBt2.default)($88ff368c56a92883$var$nodeIsTypedArray) : (0, $iaspZ.default);
var $88ff368c56a92883$export$2e2bcd8739ae039 = $88ff368c56a92883$var$isTypedArray;

});
parcelRegister("iaspZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d39f346f907eb944$export$2e2bcd8739ae039; });

var $8frC0 = parcelRequire("8frC0");

var $jKhdf = parcelRequire("jKhdf");

var $aA60L = parcelRequire("aA60L");
/** `Object#toString` result references. */ var $d39f346f907eb944$var$argsTag = '[object Arguments]', $d39f346f907eb944$var$arrayTag = '[object Array]', $d39f346f907eb944$var$boolTag = '[object Boolean]', $d39f346f907eb944$var$dateTag = '[object Date]', $d39f346f907eb944$var$errorTag = '[object Error]', $d39f346f907eb944$var$funcTag = '[object Function]', $d39f346f907eb944$var$mapTag = '[object Map]', $d39f346f907eb944$var$numberTag = '[object Number]', $d39f346f907eb944$var$objectTag = '[object Object]', $d39f346f907eb944$var$regexpTag = '[object RegExp]', $d39f346f907eb944$var$setTag = '[object Set]', $d39f346f907eb944$var$stringTag = '[object String]', $d39f346f907eb944$var$weakMapTag = '[object WeakMap]';
var $d39f346f907eb944$var$arrayBufferTag = '[object ArrayBuffer]', $d39f346f907eb944$var$dataViewTag = '[object DataView]', $d39f346f907eb944$var$float32Tag = '[object Float32Array]', $d39f346f907eb944$var$float64Tag = '[object Float64Array]', $d39f346f907eb944$var$int8Tag = '[object Int8Array]', $d39f346f907eb944$var$int16Tag = '[object Int16Array]', $d39f346f907eb944$var$int32Tag = '[object Int32Array]', $d39f346f907eb944$var$uint8Tag = '[object Uint8Array]', $d39f346f907eb944$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d39f346f907eb944$var$uint16Tag = '[object Uint16Array]', $d39f346f907eb944$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $d39f346f907eb944$var$typedArrayTags = {};
$d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$float32Tag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$float64Tag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$int8Tag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$int16Tag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$int32Tag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$uint8Tag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$uint8ClampedTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$uint16Tag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$uint32Tag] = true;
$d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$argsTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$arrayTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$arrayBufferTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$boolTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$dataViewTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$dateTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$errorTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$funcTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$mapTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$numberTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$objectTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$regexpTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$setTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$stringTag] = $d39f346f907eb944$var$typedArrayTags[$d39f346f907eb944$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $d39f346f907eb944$var$baseIsTypedArray(value) {
    return (0, $aA60L.default)(value) && (0, $jKhdf.default)(value.length) && !!$d39f346f907eb944$var$typedArrayTags[(0, $8frC0.default)(value)];
}
var $d39f346f907eb944$export$2e2bcd8739ae039 = $d39f346f907eb944$var$baseIsTypedArray;

});

parcelRegister("ijBt2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5571097ae09b9a7$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d5571097ae09b9a7$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $d5571097ae09b9a7$export$2e2bcd8739ae039 = $d5571097ae09b9a7$var$baseUnary;

});

parcelRegister("cYLhX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $972fc52ad9e19420$export$2e2bcd8739ae039; });

var $lTJe9 = parcelRequire("lTJe9");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $lTJe9.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $972fc52ad9e19420$export$2e2bcd8739ae039 = nodeUtil;

});


parcelRegister("jPtV7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6f9fd4e8739b48d$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e6f9fd4e8739b48d$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $e6f9fd4e8739b48d$export$2e2bcd8739ae039 = $e6f9fd4e8739b48d$var$safeGet;

});

parcelRegister("7n5zD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55df013c51167d0c$export$2e2bcd8739ae039; });

var $1NdSt = parcelRequire("1NdSt");

var $2JtFO = parcelRequire("2JtFO");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $55df013c51167d0c$var$toPlainObject(value) {
    return (0, $1NdSt.default)(value, (0, $2JtFO.default)(value));
}
var $55df013c51167d0c$export$2e2bcd8739ae039 = $55df013c51167d0c$var$toPlainObject;

});
parcelRegister("1NdSt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e521d69d14c82d$export$2e2bcd8739ae039; });

var $1w3Ki = parcelRequire("1w3Ki");

var $7iG1m = parcelRequire("7iG1m");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $14e521d69d14c82d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $7iG1m.default)(object, key, newValue);
        else (0, $1w3Ki.default)(object, key, newValue);
    }
    return object;
}
var $14e521d69d14c82d$export$2e2bcd8739ae039 = $14e521d69d14c82d$var$copyObject;

});
parcelRegister("1w3Ki", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11abaf70a1d6229c$export$2e2bcd8739ae039; });

var $7iG1m = parcelRequire("7iG1m");

var $a8hBh = parcelRequire("a8hBh");
/** Used for built-in method references. */ var $11abaf70a1d6229c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $11abaf70a1d6229c$var$hasOwnProperty = $11abaf70a1d6229c$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $11abaf70a1d6229c$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($11abaf70a1d6229c$var$hasOwnProperty.call(object, key) && (0, $a8hBh.default)(objValue, value)) || value === undefined && !(key in object)) (0, $7iG1m.default)(object, key, value);
}
var $11abaf70a1d6229c$export$2e2bcd8739ae039 = $11abaf70a1d6229c$var$assignValue;

});


parcelRegister("2JtFO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fd6cd46b0cd1227$export$2e2bcd8739ae039; });

var $hzfh4 = parcelRequire("hzfh4");

var $1NIbM = parcelRequire("1NIbM");

var $8xBRZ = parcelRequire("8xBRZ");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $1fd6cd46b0cd1227$var$keysIn(object) {
    return (0, $8xBRZ.default)(object) ? (0, $hzfh4.default)(object, true) : (0, $1NIbM.default)(object);
}
var $1fd6cd46b0cd1227$export$2e2bcd8739ae039 = $1fd6cd46b0cd1227$var$keysIn;

});
parcelRegister("hzfh4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cca18db2231c298b$export$2e2bcd8739ae039; });

var $f9EUm = parcelRequire("f9EUm");

var $jRLtw = parcelRequire("jRLtw");

var $03TET = parcelRequire("03TET");

var $fgu66 = parcelRequire("fgu66");

var $4Or53 = parcelRequire("4Or53");

var $bLelA = parcelRequire("bLelA");
/** Used for built-in method references. */ var $cca18db2231c298b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cca18db2231c298b$var$hasOwnProperty = $cca18db2231c298b$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $cca18db2231c298b$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $03TET.default)(value), isArg = !isArr && (0, $jRLtw.default)(value), isBuff = !isArr && !isArg && (0, $fgu66.default)(value), isType = !isArr && !isArg && !isBuff && (0, $bLelA.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $f9EUm.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $cca18db2231c298b$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $4Or53.default)(key, length)))) result.push(key);
    return result;
}
var $cca18db2231c298b$export$2e2bcd8739ae039 = $cca18db2231c298b$var$arrayLikeKeys;

});
parcelRegister("f9EUm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0876dbd26cbb06a$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b0876dbd26cbb06a$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $b0876dbd26cbb06a$export$2e2bcd8739ae039 = $b0876dbd26cbb06a$var$baseTimes;

});

parcelRegister("4Or53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3810d6901f36f0cb$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $3810d6901f36f0cb$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $3810d6901f36f0cb$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $3810d6901f36f0cb$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $3810d6901f36f0cb$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $3810d6901f36f0cb$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $3810d6901f36f0cb$export$2e2bcd8739ae039 = $3810d6901f36f0cb$var$isIndex;

});


parcelRegister("1NIbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14fca511c905747a$export$2e2bcd8739ae039; });

var $iiCpe = parcelRequire("iiCpe");

var $8q6v1 = parcelRequire("8q6v1");

var $l9k9b = parcelRequire("l9k9b");
/** Used for built-in method references. */ var $14fca511c905747a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $14fca511c905747a$var$hasOwnProperty = $14fca511c905747a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $14fca511c905747a$var$baseKeysIn(object) {
    if (!(0, $iiCpe.default)(object)) return (0, $l9k9b.default)(object);
    var isProto = (0, $8q6v1.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$14fca511c905747a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $14fca511c905747a$export$2e2bcd8739ae039 = $14fca511c905747a$var$baseKeysIn;

});
parcelRegister("l9k9b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f65a11070a544449$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f65a11070a544449$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $f65a11070a544449$export$2e2bcd8739ae039 = $f65a11070a544449$var$nativeKeysIn;

});






parcelRegister("lpBDp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0405d3199c3706f4$export$2e2bcd8739ae039; });

var $jeoHy = parcelRequire("jeoHy");

var $pQ7C5 = parcelRequire("pQ7C5");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $0405d3199c3706f4$var$createAssigner(assigner) {
    return (0, $jeoHy.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $pQ7C5.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $0405d3199c3706f4$export$2e2bcd8739ae039 = $0405d3199c3706f4$var$createAssigner;

});
parcelRegister("jeoHy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0027c595271274e$export$2e2bcd8739ae039; });

var $iVhE2 = parcelRequire("iVhE2");

var $gPHBx = parcelRequire("gPHBx");

var $6hoiP = parcelRequire("6hoiP");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $e0027c595271274e$var$baseRest(func, start) {
    return (0, $6hoiP.default)((0, $gPHBx.default)(func, start, (0, $iVhE2.default)), func + '');
}
var $e0027c595271274e$export$2e2bcd8739ae039 = $e0027c595271274e$var$baseRest;

});
parcelRegister("iVhE2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc6b3cc0d8ad5488$export$2e2bcd8739ae039; });
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $dc6b3cc0d8ad5488$var$identity(value) {
    return value;
}
var $dc6b3cc0d8ad5488$export$2e2bcd8739ae039 = $dc6b3cc0d8ad5488$var$identity;

});

parcelRegister("gPHBx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4133bb74cdd2e4a$export$2e2bcd8739ae039; });

var $8XaeJ = parcelRequire("8XaeJ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c4133bb74cdd2e4a$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $c4133bb74cdd2e4a$var$overRest(func, start, transform) {
    start = $c4133bb74cdd2e4a$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $c4133bb74cdd2e4a$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $8XaeJ.default)(func, this, otherArgs);
    };
}
var $c4133bb74cdd2e4a$export$2e2bcd8739ae039 = $c4133bb74cdd2e4a$var$overRest;

});
parcelRegister("8XaeJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $684bc62fd68332af$export$2e2bcd8739ae039; });
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $684bc62fd68332af$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $684bc62fd68332af$export$2e2bcd8739ae039 = $684bc62fd68332af$var$apply;

});


parcelRegister("6hoiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49272e9af24d932c$export$2e2bcd8739ae039; });

var $6e7kh = parcelRequire("6e7kh");

var $caEM8 = parcelRequire("caEM8");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $49272e9af24d932c$var$setToString = (0, $caEM8.default)((0, $6e7kh.default));
var $49272e9af24d932c$export$2e2bcd8739ae039 = $49272e9af24d932c$var$setToString;

});
parcelRegister("6e7kh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4889bbb297deca9a$export$2e2bcd8739ae039; });

var $8q4fS = parcelRequire("8q4fS");

var $jTFSO = parcelRequire("jTFSO");

var $iVhE2 = parcelRequire("iVhE2");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4889bbb297deca9a$var$baseSetToString = !(0, $jTFSO.default) ? (0, $iVhE2.default) : function(func, string) {
    return (0, $jTFSO.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $8q4fS.default)(string),
        'writable': true
    });
};
var $4889bbb297deca9a$export$2e2bcd8739ae039 = $4889bbb297deca9a$var$baseSetToString;

});
parcelRegister("8q4fS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62140d6554f8aede$export$2e2bcd8739ae039; });
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $62140d6554f8aede$var$constant(value) {
    return function() {
        return value;
    };
}
var $62140d6554f8aede$export$2e2bcd8739ae039 = $62140d6554f8aede$var$constant;

});


parcelRegister("caEM8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dc60c5c3fc8cb4c$export$2e2bcd8739ae039; });
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $8dc60c5c3fc8cb4c$var$HOT_COUNT = 800, $8dc60c5c3fc8cb4c$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8dc60c5c3fc8cb4c$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $8dc60c5c3fc8cb4c$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $8dc60c5c3fc8cb4c$var$nativeNow(), remaining = $8dc60c5c3fc8cb4c$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $8dc60c5c3fc8cb4c$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $8dc60c5c3fc8cb4c$export$2e2bcd8739ae039 = $8dc60c5c3fc8cb4c$var$shortOut;

});



parcelRegister("pQ7C5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04dac4379c5d321c$export$2e2bcd8739ae039; });

var $a8hBh = parcelRequire("a8hBh");

var $8xBRZ = parcelRequire("8xBRZ");

var $4Or53 = parcelRequire("4Or53");

var $iiCpe = parcelRequire("iiCpe");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $04dac4379c5d321c$var$isIterateeCall(value, index, object) {
    if (!(0, $iiCpe.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $8xBRZ.default)(object) && (0, $4Or53.default)(index, object.length) : type == 'string' && index in object) return (0, $a8hBh.default)(object[index], value);
    return false;
}
var $04dac4379c5d321c$export$2e2bcd8739ae039 = $04dac4379c5d321c$var$isIterateeCall;

});



parcelRegister("9uxoP", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $6e90d2db6e8da73a$export$775b6bb06e53a214; });
$parcel$export(module.exports, "Attributor", function () { return $6e90d2db6e8da73a$export$217610c4183502d0; });
$parcel$export(module.exports, "Registry", function () { return $6e90d2db6e8da73a$export$4d9facee29974f3; });
$parcel$export(module.exports, "ClassAttributor", function () { return $6e90d2db6e8da73a$export$651d45509677cf07; });
$parcel$export(module.exports, "StyleAttributor", function () { return $6e90d2db6e8da73a$export$7c8099bbfe87b94d; });
$parcel$export(module.exports, "AttributorStore", function () { return $6e90d2db6e8da73a$export$68ad86ab95e8de42; });
$parcel$export(module.exports, "LeafBlot", function () { return $6e90d2db6e8da73a$export$7420b9c542181544; });
$parcel$export(module.exports, "ParentBlot", function () { return $6e90d2db6e8da73a$export$e43113f0aad76fe; });
$parcel$export(module.exports, "InlineBlot", function () { return $6e90d2db6e8da73a$export$f67a34bc25a7a861; });
$parcel$export(module.exports, "BlockBlot", function () { return $6e90d2db6e8da73a$export$4f7f03641f7bfc8c; });
$parcel$export(module.exports, "ContainerBlot", function () { return $6e90d2db6e8da73a$export$c898d510319704c0; });
$parcel$export(module.exports, "EmbedBlot", function () { return $6e90d2db6e8da73a$export$297a1fa96f55f00f; });
$parcel$export(module.exports, "ScrollBlot", function () { return $6e90d2db6e8da73a$export$7175329dad7a46f1; });
$parcel$export(module.exports, "TextBlot", function () { return $6e90d2db6e8da73a$export$10ac0c5716409de6; });
var $6e90d2db6e8da73a$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($6e90d2db6e8da73a$export$775b6bb06e53a214 || {});
class $6e90d2db6e8da73a$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $6e90d2db6e8da73a$export$775b6bb06e53a214.TYPE & $6e90d2db6e8da73a$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $6e90d2db6e8da73a$export$775b6bb06e53a214.LEVEL | attributeBit : $6e90d2db6e8da73a$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $6e90d2db6e8da73a$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $6e90d2db6e8da73a$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $6e90d2db6e8da73a$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $6e90d2db6e8da73a$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $6e90d2db6e8da73a$export$775b6bb06e53a214.LEVEL & $6e90d2db6e8da73a$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $6e90d2db6e8da73a$export$775b6bb06e53a214.LEVEL & $6e90d2db6e8da73a$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $6e90d2db6e8da73a$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $6e90d2db6e8da73a$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $6e90d2db6e8da73a$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $6e90d2db6e8da73a$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$6e90d2db6e8da73a$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $6e90d2db6e8da73a$export$4d9facee29974f3 = $6e90d2db6e8da73a$var$_Registry;
function $6e90d2db6e8da73a$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $6e90d2db6e8da73a$var$ClassAttributor extends $6e90d2db6e8da73a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $6e90d2db6e8da73a$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($6e90d2db6e8da73a$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $6e90d2db6e8da73a$export$651d45509677cf07 = $6e90d2db6e8da73a$var$ClassAttributor;
function $6e90d2db6e8da73a$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $6e90d2db6e8da73a$var$StyleAttributor extends $6e90d2db6e8da73a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$6e90d2db6e8da73a$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$6e90d2db6e8da73a$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$6e90d2db6e8da73a$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $6e90d2db6e8da73a$export$7c8099bbfe87b94d = $6e90d2db6e8da73a$var$StyleAttributor;
class $6e90d2db6e8da73a$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $6e90d2db6e8da73a$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $6e90d2db6e8da73a$export$217610c4183502d0.keys(this.domNode), classes = $6e90d2db6e8da73a$export$651d45509677cf07.keys(this.domNode), styles = $6e90d2db6e8da73a$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $6e90d2db6e8da73a$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $6e90d2db6e8da73a$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $6e90d2db6e8da73a$export$68ad86ab95e8de42 = $6e90d2db6e8da73a$var$AttributorStore, $6e90d2db6e8da73a$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $6e90d2db6e8da73a$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $6e90d2db6e8da73a$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $6e90d2db6e8da73a$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $6e90d2db6e8da73a$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $6e90d2db6e8da73a$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $6e90d2db6e8da73a$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$6e90d2db6e8da73a$var$_ShadowBlot.blotName = "abstract";
let $6e90d2db6e8da73a$var$ShadowBlot = $6e90d2db6e8da73a$var$_ShadowBlot;
const $6e90d2db6e8da73a$var$_LeafBlot = class _LeafBlot extends $6e90d2db6e8da73a$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$6e90d2db6e8da73a$var$_LeafBlot.scope = $6e90d2db6e8da73a$export$775b6bb06e53a214.INLINE_BLOT;
let $6e90d2db6e8da73a$var$LeafBlot = $6e90d2db6e8da73a$var$_LeafBlot;
const $6e90d2db6e8da73a$export$7420b9c542181544 = $6e90d2db6e8da73a$var$LeafBlot;
class $6e90d2db6e8da73a$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $6e90d2db6e8da73a$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($6e90d2db6e8da73a$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $6e90d2db6e8da73a$var$_ParentBlot = class _ParentBlot extends $6e90d2db6e8da73a$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $6e90d2db6e8da73a$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $6e90d2db6e8da73a$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $6e90d2db6e8da73a$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $6e90d2db6e8da73a$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $6e90d2db6e8da73a$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$6e90d2db6e8da73a$var$_ParentBlot.uiClass = "";
let $6e90d2db6e8da73a$var$ParentBlot = $6e90d2db6e8da73a$var$_ParentBlot;
const $6e90d2db6e8da73a$export$e43113f0aad76fe = $6e90d2db6e8da73a$var$ParentBlot;
function $6e90d2db6e8da73a$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $6e90d2db6e8da73a$var$_InlineBlot = class _InlineBlot extends $6e90d2db6e8da73a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $6e90d2db6e8da73a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $6e90d2db6e8da73a$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $6e90d2db6e8da73a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $6e90d2db6e8da73a$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $6e90d2db6e8da73a$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$6e90d2db6e8da73a$var$_InlineBlot.allowedChildren = [
    $6e90d2db6e8da73a$var$_InlineBlot,
    $6e90d2db6e8da73a$export$7420b9c542181544
], $6e90d2db6e8da73a$var$_InlineBlot.blotName = "inline", $6e90d2db6e8da73a$var$_InlineBlot.scope = $6e90d2db6e8da73a$export$775b6bb06e53a214.INLINE_BLOT, $6e90d2db6e8da73a$var$_InlineBlot.tagName = "SPAN";
let $6e90d2db6e8da73a$var$InlineBlot = $6e90d2db6e8da73a$var$_InlineBlot;
const $6e90d2db6e8da73a$export$f67a34bc25a7a861 = $6e90d2db6e8da73a$var$InlineBlot, $6e90d2db6e8da73a$var$_BlockBlot = class _BlockBlot extends $6e90d2db6e8da73a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $6e90d2db6e8da73a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $6e90d2db6e8da73a$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $6e90d2db6e8da73a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $6e90d2db6e8da73a$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $6e90d2db6e8da73a$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$6e90d2db6e8da73a$var$_BlockBlot.blotName = "block", $6e90d2db6e8da73a$var$_BlockBlot.scope = $6e90d2db6e8da73a$export$775b6bb06e53a214.BLOCK_BLOT, $6e90d2db6e8da73a$var$_BlockBlot.tagName = "P", $6e90d2db6e8da73a$var$_BlockBlot.allowedChildren = [
    $6e90d2db6e8da73a$export$f67a34bc25a7a861,
    $6e90d2db6e8da73a$var$_BlockBlot,
    $6e90d2db6e8da73a$export$7420b9c542181544
];
let $6e90d2db6e8da73a$var$BlockBlot = $6e90d2db6e8da73a$var$_BlockBlot;
const $6e90d2db6e8da73a$export$4f7f03641f7bfc8c = $6e90d2db6e8da73a$var$BlockBlot, $6e90d2db6e8da73a$var$_ContainerBlot = class _ContainerBlot extends $6e90d2db6e8da73a$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$6e90d2db6e8da73a$var$_ContainerBlot.blotName = "container", $6e90d2db6e8da73a$var$_ContainerBlot.scope = $6e90d2db6e8da73a$export$775b6bb06e53a214.BLOCK_BLOT;
let $6e90d2db6e8da73a$var$ContainerBlot = $6e90d2db6e8da73a$var$_ContainerBlot;
const $6e90d2db6e8da73a$export$c898d510319704c0 = $6e90d2db6e8da73a$var$ContainerBlot;
class $6e90d2db6e8da73a$var$EmbedBlot extends $6e90d2db6e8da73a$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $6e90d2db6e8da73a$export$297a1fa96f55f00f = $6e90d2db6e8da73a$var$EmbedBlot, $6e90d2db6e8da73a$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $6e90d2db6e8da73a$var$MAX_OPTIMIZE_ITERATIONS = 100, $6e90d2db6e8da73a$var$_ScrollBlot = class _ScrollBlot extends $6e90d2db6e8da73a$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $6e90d2db6e8da73a$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $6e90d2db6e8da73a$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $6e90d2db6e8da73a$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $6e90d2db6e8da73a$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $6e90d2db6e8da73a$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$6e90d2db6e8da73a$var$_ScrollBlot.blotName = "scroll", $6e90d2db6e8da73a$var$_ScrollBlot.defaultChild = $6e90d2db6e8da73a$export$4f7f03641f7bfc8c, $6e90d2db6e8da73a$var$_ScrollBlot.allowedChildren = [
    $6e90d2db6e8da73a$export$4f7f03641f7bfc8c,
    $6e90d2db6e8da73a$export$c898d510319704c0
], $6e90d2db6e8da73a$var$_ScrollBlot.scope = $6e90d2db6e8da73a$export$775b6bb06e53a214.BLOCK_BLOT, $6e90d2db6e8da73a$var$_ScrollBlot.tagName = "DIV";
let $6e90d2db6e8da73a$var$ScrollBlot = $6e90d2db6e8da73a$var$_ScrollBlot;
const $6e90d2db6e8da73a$export$7175329dad7a46f1 = $6e90d2db6e8da73a$var$ScrollBlot, $6e90d2db6e8da73a$var$_TextBlot = class _TextBlot extends $6e90d2db6e8da73a$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$6e90d2db6e8da73a$var$_TextBlot.blotName = "text", $6e90d2db6e8da73a$var$_TextBlot.scope = $6e90d2db6e8da73a$export$775b6bb06e53a214.INLINE_BLOT;
let $6e90d2db6e8da73a$var$TextBlot = $6e90d2db6e8da73a$var$_TextBlot;
const $6e90d2db6e8da73a$export$10ac0c5716409de6 = $6e90d2db6e8da73a$var$TextBlot;

});

parcelRegister("eD1QA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AttributeMap = module.exports.OpIterator = module.exports.Op = void 0;

var $fUWNQ = parcelRequire("fUWNQ");

var $1aBA2 = parcelRequire("1aBA2");

var $kAkAj = parcelRequire("kAkAj");

var $6SAA9 = parcelRequire("6SAA9");
module.exports.AttributeMap = $6SAA9.default;

var $1RICl = parcelRequire("1RICl");
module.exports.Op = $1RICl.default;

var $7vAFl = parcelRequire("7vAFl");
module.exports.OpIterator = $7vAFl.default;
const $aa662408d64d801d$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $aa662408d64d801d$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $aa662408d64d801d$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $1aBA2(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($kAkAj(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $1RICl.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $1RICl.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $7vAFl.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $1RICl.default.length(nextOp);
        }
        return new $aa662408d64d801d$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $7vAFl.default(this.ops);
        const otherIter = new $7vAFl.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $aa662408d64d801d$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $aa662408d64d801d$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $aa662408d64d801d$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $6SAA9.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $kAkAj(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $aa662408d64d801d$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $aa662408d64d801d$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $aa662408d64d801d$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $aa662408d64d801d$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $aa662408d64d801d$var$Delta();
        const diffResult = $fUWNQ(strings[0], strings[1], cursor, true);
        const thisIter = new $7vAFl.default(this.ops);
        const otherIter = new $7vAFl.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $fUWNQ.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $fUWNQ.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $fUWNQ.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($kAkAj(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $6SAA9.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $7vAFl.default(this.ops);
        let line = new $aa662408d64d801d$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $1RICl.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $aa662408d64d801d$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $aa662408d64d801d$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($1RICl.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($1RICl.default.length(baseOp), $6SAA9.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $7vAFl.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $aa662408d64d801d$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $aa662408d64d801d$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $6SAA9.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $7vAFl.default(this.ops);
        const otherIter = new $7vAFl.default(other.ops);
        const delta = new $aa662408d64d801d$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($1RICl.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $aa662408d64d801d$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $6SAA9.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $7vAFl.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$aa662408d64d801d$var$Delta.Op = $1RICl.default;
$aa662408d64d801d$var$Delta.OpIterator = $7vAFl.default;
$aa662408d64d801d$var$Delta.AttributeMap = $6SAA9.default;
$aa662408d64d801d$var$Delta.handlers = {};
module.exports.default = $aa662408d64d801d$var$Delta;
module.exports = $aa662408d64d801d$var$Delta;
module.exports.default = $aa662408d64d801d$var$Delta;

});
parcelRegister("fUWNQ", function(module, exports) {
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $b969b305151dcafd$var$DIFF_DELETE = -1;
var $b969b305151dcafd$var$DIFF_INSERT = 1;
var $b969b305151dcafd$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $b969b305151dcafd$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $b969b305151dcafd$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $b969b305151dcafd$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $b969b305151dcafd$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $b969b305151dcafd$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $b969b305151dcafd$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $b969b305151dcafd$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $b969b305151dcafd$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $b969b305151dcafd$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $b969b305151dcafd$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $b969b305151dcafd$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $b969b305151dcafd$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $b969b305151dcafd$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $b969b305151dcafd$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $b969b305151dcafd$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $b969b305151dcafd$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $b969b305151dcafd$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $b969b305151dcafd$var$DIFF_DELETE,
            text1
        ],
        [
            $b969b305151dcafd$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $b969b305151dcafd$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $b969b305151dcafd$var$diff_main(text1_a, text2_a);
        var diffs_b = $b969b305151dcafd$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $b969b305151dcafd$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $b969b305151dcafd$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $b969b305151dcafd$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $b969b305151dcafd$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $b969b305151dcafd$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $b969b305151dcafd$var$DIFF_DELETE,
            text1
        ],
        [
            $b969b305151dcafd$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $b969b305151dcafd$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $b969b305151dcafd$var$diff_main(text1a, text2a);
    var diffsb = $b969b305151dcafd$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $b969b305151dcafd$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($b969b305151dcafd$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $b969b305151dcafd$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $b969b305151dcafd$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($b969b305151dcafd$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $b969b305151dcafd$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $b969b305151dcafd$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $b969b305151dcafd$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $b969b305151dcafd$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $b969b305151dcafd$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $b969b305151dcafd$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $b969b305151dcafd$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $b969b305151dcafd$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $b969b305151dcafd$var$diff_cleanupMerge(diffs);
    $b969b305151dcafd$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $b969b305151dcafd$var$DIFF_DELETE && diffs[pointer][0] == $b969b305151dcafd$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $b969b305151dcafd$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $b969b305151dcafd$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $b969b305151dcafd$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $b969b305151dcafd$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $b969b305151dcafd$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $b969b305151dcafd$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $b969b305151dcafd$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $b969b305151dcafd$var$whitespaceRegex_ = /\s/;
var $b969b305151dcafd$var$linebreakRegex_ = /[\r\n]/;
var $b969b305151dcafd$var$blanklineEndRegex_ = /\n\r?\n$/;
var $b969b305151dcafd$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $b969b305151dcafd$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($b969b305151dcafd$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($b969b305151dcafd$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($b969b305151dcafd$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($b969b305151dcafd$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($b969b305151dcafd$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($b969b305151dcafd$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($b969b305151dcafd$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($b969b305151dcafd$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $b969b305151dcafd$var$DIFF_EQUAL && diffs[pointer + 1][0] == $b969b305151dcafd$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $b969b305151dcafd$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $b969b305151dcafd$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $b969b305151dcafd$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $b969b305151dcafd$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $b969b305151dcafd$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $b969b305151dcafd$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $b969b305151dcafd$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $b969b305151dcafd$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $b969b305151dcafd$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($b969b305151dcafd$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $b969b305151dcafd$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $b969b305151dcafd$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $b969b305151dcafd$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $b969b305151dcafd$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $b969b305151dcafd$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $b969b305151dcafd$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $b969b305151dcafd$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $b969b305151dcafd$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $b969b305151dcafd$var$DIFF_EQUAL && diffs[pointer + 1][0] === $b969b305151dcafd$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $b969b305151dcafd$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $b969b305151dcafd$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $b969b305151dcafd$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $b969b305151dcafd$var$starts_with_pair_end(str) {
    return $b969b305151dcafd$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $b969b305151dcafd$var$ends_with_pair_start(str) {
    return $b969b305151dcafd$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $b969b305151dcafd$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $b969b305151dcafd$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($b969b305151dcafd$var$ends_with_pair_start(before) || $b969b305151dcafd$var$starts_with_pair_end(after)) return null;
    return $b969b305151dcafd$var$remove_empty_tuples([
        [
            $b969b305151dcafd$var$DIFF_EQUAL,
            before
        ],
        [
            $b969b305151dcafd$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $b969b305151dcafd$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $b969b305151dcafd$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $b969b305151dcafd$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $b969b305151dcafd$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $b969b305151dcafd$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $b969b305151dcafd$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $b969b305151dcafd$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $b969b305151dcafd$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$b969b305151dcafd$var$diff.INSERT = $b969b305151dcafd$var$DIFF_INSERT;
$b969b305151dcafd$var$diff.DELETE = $b969b305151dcafd$var$DIFF_DELETE;
$b969b305151dcafd$var$diff.EQUAL = $b969b305151dcafd$var$DIFF_EQUAL;
module.exports = $b969b305151dcafd$var$diff;

});

parcelRegister("1aBA2", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("kAkAj", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("6SAA9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1aBA2 = parcelRequire("1aBA2");

var $kAkAj = parcelRequire("kAkAj");
var $502429a3bfa2853d$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $1aBA2(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$kAkAj(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($502429a3bfa2853d$var$AttributeMap || ($502429a3bfa2853d$var$AttributeMap = {}));
module.exports.default = $502429a3bfa2853d$var$AttributeMap;

});

parcelRegister("1RICl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $15bd59c675beddf9$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($15bd59c675beddf9$var$Op || ($15bd59c675beddf9$var$Op = {}));
module.exports.default = $15bd59c675beddf9$var$Op;

});

parcelRegister("7vAFl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1RICl = parcelRequire("1RICl");
class $5777deb4a74bed37$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $1RICl.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $1RICl.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
module.exports.default = $5777deb4a74bed37$var$Iterator;

});


parcelRegister("9Ud7C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $736385c3af56583d$export$2e2bcd8739ae039; });

var $kZLOs = parcelRequire("kZLOs");
var $hxeaL = parcelRequire("hxeaL");
var $h21cN = parcelRequire("h21cN");

var $9uxoP = parcelRequire("9uxoP");

var $eD1QA = parcelRequire("eD1QA");

var $eT6zx = parcelRequire("eT6zx");

var $aA0eA = parcelRequire("aA0eA");

var $i4Ja5 = parcelRequire("i4Ja5");

var $1oJfc = parcelRequire("1oJfc");

var $36WOi = parcelRequire("36WOi");
const $736385c3af56583d$var$ASCII = /^[ -~]*$/;
class $736385c3af56583d$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $736385c3af56583d$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
        const normalizedOps = $736385c3af56583d$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $eD1QA.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $eT6zx.BlockEmbed), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $h21cN.default)({}, (0, $eT6zx.bubbleFormats)(line));
                    if (line instanceof (0, $eT6zx.default)) {
                        const [leaf] = line.descendant((0, $9uxoP.LeafBlot), offset);
                        if (leaf) formats = (0, $h21cN.default)(formats, (0, $eT6zx.bubbleFormats)(leaf));
                    }
                    attributes = (0, $eD1QA.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $9uxoP.Scope).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $eT6zx.BlockEmbed), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $9uxoP.LeafBlot), index - 1);
                        if (leaf instanceof (0, $1oJfc.default)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $9uxoP.EmbedBlot) && leaf.statics.scope === (0, $9uxoP.Scope).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $9uxoP.LeafBlot), index);
                        if (leaf) {
                            const formats = (0, $h21cN.default)({}, (0, $eT6zx.bubbleFormats)(leaf));
                            attributes = (0, $eD1QA.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $eD1QA.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).retain(length, (0, $kZLOs.default)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).retain(length, (0, $kZLOs.default)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $eT6zx.default)) lines.push(blot);
            else if (blot instanceof (0, $9uxoP.LeafBlot)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $9uxoP.LeafBlot), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $eT6zx.bubbleFormats)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $736385c3af56583d$var$combineFormats((0, $eT6zx.bubbleFormats)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $736385c3af56583d$var$convertHTML(line, lineOffset, length, true);
            return $736385c3af56583d$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $736385c3af56583d$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).insert(text, (0, $kZLOs.default)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $eT6zx.default).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $aA0eA.default);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($736385c3af56583d$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $eT6zx.bubbleFormats)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $i4Ja5.default).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $736385c3af56583d$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $736385c3af56583d$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $hxeaL.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $736385c3af56583d$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $736385c3af56583d$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$736385c3af56583d$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $736385c3af56583d$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$736385c3af56583d$var$convertHTML(child, offset, length)}${$736385c3af56583d$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$736385c3af56583d$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$736385c3af56583d$var$convertHTML(child, offset, length)}${$736385c3af56583d$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $736385c3af56583d$var$getListType(types.pop());
    return `</li></${endTag}>${$736385c3af56583d$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $736385c3af56583d$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $1oJfc.default)) {
        const escapedText = (0, $1oJfc.escapeText)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $9uxoP.ParentBlot)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $736385c3af56583d$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($736385c3af56583d$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $736385c3af56583d$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $736385c3af56583d$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $736385c3af56583d$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
}
function $736385c3af56583d$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $36WOi.Range)(index + amount, length);
}
function $736385c3af56583d$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $736385c3af56583d$export$2e2bcd8739ae039 = $736385c3af56583d$var$Editor;

});
parcelRegister("kZLOs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f48e97cd112c6834$export$2e2bcd8739ae039; });

var $347Yu = parcelRequire("347Yu");
/** Used to compose bitmasks for cloning. */ var $f48e97cd112c6834$var$CLONE_DEEP_FLAG = 1, $f48e97cd112c6834$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $f48e97cd112c6834$var$cloneDeep(value) {
    return (0, $347Yu.default)(value, $f48e97cd112c6834$var$CLONE_DEEP_FLAG | $f48e97cd112c6834$var$CLONE_SYMBOLS_FLAG);
}
var $f48e97cd112c6834$export$2e2bcd8739ae039 = $f48e97cd112c6834$var$cloneDeep;

});
parcelRegister("347Yu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23b7ee6f4af341fa$export$2e2bcd8739ae039; });

var $liuc6 = parcelRequire("liuc6");

var $lHRCq = parcelRequire("lHRCq");

var $1w3Ki = parcelRequire("1w3Ki");

var $5aobH = parcelRequire("5aobH");

var $4G5YW = parcelRequire("4G5YW");

var $cLGnB = parcelRequire("cLGnB");

var $kG8QS = parcelRequire("kG8QS");

var $kLIk0 = parcelRequire("kLIk0");

var $keHbB = parcelRequire("keHbB");

var $eajdV = parcelRequire("eajdV");

var $9I8Sl = parcelRequire("9I8Sl");

var $lJOFV = parcelRequire("lJOFV");

var $2LKuQ = parcelRequire("2LKuQ");

var $3Wxqq = parcelRequire("3Wxqq");

var $gEuKx = parcelRequire("gEuKx");

var $03TET = parcelRequire("03TET");

var $fgu66 = parcelRequire("fgu66");

var $89A5w = parcelRequire("89A5w");

var $iiCpe = parcelRequire("iiCpe");

var $2QdA6 = parcelRequire("2QdA6");

var $ixH48 = parcelRequire("ixH48");

var $2JtFO = parcelRequire("2JtFO");
/** Used to compose bitmasks for cloning. */ var $23b7ee6f4af341fa$var$CLONE_DEEP_FLAG = 1, $23b7ee6f4af341fa$var$CLONE_FLAT_FLAG = 2, $23b7ee6f4af341fa$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $23b7ee6f4af341fa$var$argsTag = '[object Arguments]', $23b7ee6f4af341fa$var$arrayTag = '[object Array]', $23b7ee6f4af341fa$var$boolTag = '[object Boolean]', $23b7ee6f4af341fa$var$dateTag = '[object Date]', $23b7ee6f4af341fa$var$errorTag = '[object Error]', $23b7ee6f4af341fa$var$funcTag = '[object Function]', $23b7ee6f4af341fa$var$genTag = '[object GeneratorFunction]', $23b7ee6f4af341fa$var$mapTag = '[object Map]', $23b7ee6f4af341fa$var$numberTag = '[object Number]', $23b7ee6f4af341fa$var$objectTag = '[object Object]', $23b7ee6f4af341fa$var$regexpTag = '[object RegExp]', $23b7ee6f4af341fa$var$setTag = '[object Set]', $23b7ee6f4af341fa$var$stringTag = '[object String]', $23b7ee6f4af341fa$var$symbolTag = '[object Symbol]', $23b7ee6f4af341fa$var$weakMapTag = '[object WeakMap]';
var $23b7ee6f4af341fa$var$arrayBufferTag = '[object ArrayBuffer]', $23b7ee6f4af341fa$var$dataViewTag = '[object DataView]', $23b7ee6f4af341fa$var$float32Tag = '[object Float32Array]', $23b7ee6f4af341fa$var$float64Tag = '[object Float64Array]', $23b7ee6f4af341fa$var$int8Tag = '[object Int8Array]', $23b7ee6f4af341fa$var$int16Tag = '[object Int16Array]', $23b7ee6f4af341fa$var$int32Tag = '[object Int32Array]', $23b7ee6f4af341fa$var$uint8Tag = '[object Uint8Array]', $23b7ee6f4af341fa$var$uint8ClampedTag = '[object Uint8ClampedArray]', $23b7ee6f4af341fa$var$uint16Tag = '[object Uint16Array]', $23b7ee6f4af341fa$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $23b7ee6f4af341fa$var$cloneableTags = {};
$23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$argsTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$arrayTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$arrayBufferTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$dataViewTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$boolTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$dateTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$float32Tag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$float64Tag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$int8Tag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$int16Tag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$int32Tag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$mapTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$numberTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$objectTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$regexpTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$setTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$stringTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$symbolTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$uint8Tag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$uint8ClampedTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$uint16Tag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$uint32Tag] = true;
$23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$errorTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$funcTag] = $23b7ee6f4af341fa$var$cloneableTags[$23b7ee6f4af341fa$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $23b7ee6f4af341fa$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $23b7ee6f4af341fa$var$CLONE_DEEP_FLAG, isFlat = bitmask & $23b7ee6f4af341fa$var$CLONE_FLAT_FLAG, isFull = bitmask & $23b7ee6f4af341fa$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $iiCpe.default)(value)) return value;
    var isArr = (0, $03TET.default)(value);
    if (isArr) {
        result = (0, $2LKuQ.default)(value);
        if (!isDeep) return (0, $kG8QS.default)(value, result);
    } else {
        var tag = (0, $lJOFV.default)(value), isFunc = tag == $23b7ee6f4af341fa$var$funcTag || tag == $23b7ee6f4af341fa$var$genTag;
        if ((0, $fgu66.default)(value)) return (0, $cLGnB.default)(value, isDeep);
        if (tag == $23b7ee6f4af341fa$var$objectTag || tag == $23b7ee6f4af341fa$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $gEuKx.default)(value);
            if (!isDeep) return isFlat ? (0, $keHbB.default)(value, (0, $4G5YW.default)(result, value)) : (0, $kLIk0.default)(value, (0, $5aobH.default)(result, value));
        } else {
            if (!$23b7ee6f4af341fa$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $3Wxqq.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $liuc6.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $2QdA6.default)(value)) value.forEach(function(subValue) {
        result.add($23b7ee6f4af341fa$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $89A5w.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $23b7ee6f4af341fa$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $9I8Sl.default) : (0, $eajdV.default) : isFlat ? (0, $2JtFO.default) : (0, $ixH48.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $lHRCq.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $1w3Ki.default)(result, key, $23b7ee6f4af341fa$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $23b7ee6f4af341fa$export$2e2bcd8739ae039 = $23b7ee6f4af341fa$var$baseClone;

});
parcelRegister("lHRCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcd734b6f2a33be6$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $fcd734b6f2a33be6$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $fcd734b6f2a33be6$export$2e2bcd8739ae039 = $fcd734b6f2a33be6$var$arrayEach;

});

parcelRegister("5aobH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c30a61ae624c734$export$2e2bcd8739ae039; });

var $1NdSt = parcelRequire("1NdSt");

var $ixH48 = parcelRequire("ixH48");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3c30a61ae624c734$var$baseAssign(object, source) {
    return object && (0, $1NdSt.default)(source, (0, $ixH48.default)(source), object);
}
var $3c30a61ae624c734$export$2e2bcd8739ae039 = $3c30a61ae624c734$var$baseAssign;

});
parcelRegister("ixH48", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7fcb700e7c7ab2b$export$2e2bcd8739ae039; });

var $hzfh4 = parcelRequire("hzfh4");

var $hEQZt = parcelRequire("hEQZt");

var $8xBRZ = parcelRequire("8xBRZ");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $d7fcb700e7c7ab2b$var$keys(object) {
    return (0, $8xBRZ.default)(object) ? (0, $hzfh4.default)(object) : (0, $hEQZt.default)(object);
}
var $d7fcb700e7c7ab2b$export$2e2bcd8739ae039 = $d7fcb700e7c7ab2b$var$keys;

});
parcelRegister("hEQZt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdaf46e81e16eb97$export$2e2bcd8739ae039; });

var $8q6v1 = parcelRequire("8q6v1");

var $aunG4 = parcelRequire("aunG4");
/** Used for built-in method references. */ var $cdaf46e81e16eb97$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cdaf46e81e16eb97$var$hasOwnProperty = $cdaf46e81e16eb97$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cdaf46e81e16eb97$var$baseKeys(object) {
    if (!(0, $8q6v1.default)(object)) return (0, $aunG4.default)(object);
    var result = [];
    for(var key in Object(object))if ($cdaf46e81e16eb97$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $cdaf46e81e16eb97$export$2e2bcd8739ae039 = $cdaf46e81e16eb97$var$baseKeys;

});
parcelRegister("aunG4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a2f129a5c84b236$export$2e2bcd8739ae039; });

var $aZtRh = parcelRequire("aZtRh");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7a2f129a5c84b236$var$nativeKeys = (0, $aZtRh.default)(Object.keys, Object);
var $7a2f129a5c84b236$export$2e2bcd8739ae039 = $7a2f129a5c84b236$var$nativeKeys;

});




parcelRegister("4G5YW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $367fb98d129cfa0c$export$2e2bcd8739ae039; });

var $1NdSt = parcelRequire("1NdSt");

var $2JtFO = parcelRequire("2JtFO");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $367fb98d129cfa0c$var$baseAssignIn(object, source) {
    return object && (0, $1NdSt.default)(source, (0, $2JtFO.default)(source), object);
}
var $367fb98d129cfa0c$export$2e2bcd8739ae039 = $367fb98d129cfa0c$var$baseAssignIn;

});

parcelRegister("kLIk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1ea93cc4e813f18$export$2e2bcd8739ae039; });

var $1NdSt = parcelRequire("1NdSt");

var $894bh = parcelRequire("894bh");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f1ea93cc4e813f18$var$copySymbols(source, object) {
    return (0, $1NdSt.default)(source, (0, $894bh.default)(source), object);
}
var $f1ea93cc4e813f18$export$2e2bcd8739ae039 = $f1ea93cc4e813f18$var$copySymbols;

});
parcelRegister("894bh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ee26838d9fd158e$export$2e2bcd8739ae039; });

var $Dctpi = parcelRequire("Dctpi");

var $eovyB = parcelRequire("eovyB");
/** Used for built-in method references. */ var $5ee26838d9fd158e$var$objectProto = Object.prototype;
/** Built-in value references. */ var $5ee26838d9fd158e$var$propertyIsEnumerable = $5ee26838d9fd158e$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5ee26838d9fd158e$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5ee26838d9fd158e$var$getSymbols = !$5ee26838d9fd158e$var$nativeGetSymbols ? (0, $eovyB.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $Dctpi.default)($5ee26838d9fd158e$var$nativeGetSymbols(object), function(symbol) {
        return $5ee26838d9fd158e$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $5ee26838d9fd158e$export$2e2bcd8739ae039 = $5ee26838d9fd158e$var$getSymbols;

});
parcelRegister("Dctpi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $075d5192631a0d4e$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $075d5192631a0d4e$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $075d5192631a0d4e$export$2e2bcd8739ae039 = $075d5192631a0d4e$var$arrayFilter;

});

parcelRegister("eovyB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7abc92b4a8b2e19$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $a7abc92b4a8b2e19$var$stubArray() {
    return [];
}
var $a7abc92b4a8b2e19$export$2e2bcd8739ae039 = $a7abc92b4a8b2e19$var$stubArray;

});



parcelRegister("keHbB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebb69d50b3156993$export$2e2bcd8739ae039; });

var $1NdSt = parcelRequire("1NdSt");

var $eM80O = parcelRequire("eM80O");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ebb69d50b3156993$var$copySymbolsIn(source, object) {
    return (0, $1NdSt.default)(source, (0, $eM80O.default)(source), object);
}
var $ebb69d50b3156993$export$2e2bcd8739ae039 = $ebb69d50b3156993$var$copySymbolsIn;

});
parcelRegister("eM80O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1bc36b6b539388$export$2e2bcd8739ae039; });

var $cfjnX = parcelRequire("cfjnX");

var $7sAem = parcelRequire("7sAem");

var $894bh = parcelRequire("894bh");

var $eovyB = parcelRequire("eovyB");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ac1bc36b6b539388$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $ac1bc36b6b539388$var$getSymbolsIn = !$ac1bc36b6b539388$var$nativeGetSymbols ? (0, $eovyB.default) : function(object) {
    var result = [];
    while(object){
        (0, $cfjnX.default)(result, (0, $894bh.default)(object));
        object = (0, $7sAem.default)(object);
    }
    return result;
};
var $ac1bc36b6b539388$export$2e2bcd8739ae039 = $ac1bc36b6b539388$var$getSymbolsIn;

});
parcelRegister("cfjnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ea5ec4aa1dcb6a5$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8ea5ec4aa1dcb6a5$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $8ea5ec4aa1dcb6a5$export$2e2bcd8739ae039 = $8ea5ec4aa1dcb6a5$var$arrayPush;

});



parcelRegister("eajdV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a500e946d7f79093$export$2e2bcd8739ae039; });

var $2aeuq = parcelRequire("2aeuq");

var $894bh = parcelRequire("894bh");

var $ixH48 = parcelRequire("ixH48");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $a500e946d7f79093$var$getAllKeys(object) {
    return (0, $2aeuq.default)(object, (0, $ixH48.default), (0, $894bh.default));
}
var $a500e946d7f79093$export$2e2bcd8739ae039 = $a500e946d7f79093$var$getAllKeys;

});
parcelRegister("2aeuq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1937c14f924ef6f0$export$2e2bcd8739ae039; });

var $cfjnX = parcelRequire("cfjnX");

var $03TET = parcelRequire("03TET");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $1937c14f924ef6f0$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $03TET.default)(object) ? result : (0, $cfjnX.default)(result, symbolsFunc(object));
}
var $1937c14f924ef6f0$export$2e2bcd8739ae039 = $1937c14f924ef6f0$var$baseGetAllKeys;

});


parcelRegister("9I8Sl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $711f1b962f11bedb$export$2e2bcd8739ae039; });

var $2aeuq = parcelRequire("2aeuq");

var $eM80O = parcelRequire("eM80O");

var $2JtFO = parcelRequire("2JtFO");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $711f1b962f11bedb$var$getAllKeysIn(object) {
    return (0, $2aeuq.default)(object, (0, $2JtFO.default), (0, $eM80O.default));
}
var $711f1b962f11bedb$export$2e2bcd8739ae039 = $711f1b962f11bedb$var$getAllKeysIn;

});

parcelRegister("lJOFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd351bfdfb2ec16e$export$2e2bcd8739ae039; });

var $8Jr7A = parcelRequire("8Jr7A");

var $cnNjY = parcelRequire("cnNjY");

var $kfdNd = parcelRequire("kfdNd");

var $gbENw = parcelRequire("gbENw");

var $9tmxi = parcelRequire("9tmxi");

var $8frC0 = parcelRequire("8frC0");

var $lMOWq = parcelRequire("lMOWq");
/** `Object#toString` result references. */ var $fd351bfdfb2ec16e$var$mapTag = '[object Map]', $fd351bfdfb2ec16e$var$objectTag = '[object Object]', $fd351bfdfb2ec16e$var$promiseTag = '[object Promise]', $fd351bfdfb2ec16e$var$setTag = '[object Set]', $fd351bfdfb2ec16e$var$weakMapTag = '[object WeakMap]';
var $fd351bfdfb2ec16e$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $fd351bfdfb2ec16e$var$dataViewCtorString = (0, $lMOWq.default)((0, $8Jr7A.default)), $fd351bfdfb2ec16e$var$mapCtorString = (0, $lMOWq.default)((0, $cnNjY.default)), $fd351bfdfb2ec16e$var$promiseCtorString = (0, $lMOWq.default)((0, $kfdNd.default)), $fd351bfdfb2ec16e$var$setCtorString = (0, $lMOWq.default)((0, $gbENw.default)), $fd351bfdfb2ec16e$var$weakMapCtorString = (0, $lMOWq.default)((0, $9tmxi.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $fd351bfdfb2ec16e$var$getTag = (0, $8frC0.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $8Jr7A.default) && $fd351bfdfb2ec16e$var$getTag(new (0, $8Jr7A.default)(new ArrayBuffer(1))) != $fd351bfdfb2ec16e$var$dataViewTag || (0, $cnNjY.default) && $fd351bfdfb2ec16e$var$getTag(new (0, $cnNjY.default)) != $fd351bfdfb2ec16e$var$mapTag || (0, $kfdNd.default) && $fd351bfdfb2ec16e$var$getTag((0, $kfdNd.default).resolve()) != $fd351bfdfb2ec16e$var$promiseTag || (0, $gbENw.default) && $fd351bfdfb2ec16e$var$getTag(new (0, $gbENw.default)) != $fd351bfdfb2ec16e$var$setTag || (0, $9tmxi.default) && $fd351bfdfb2ec16e$var$getTag(new (0, $9tmxi.default)) != $fd351bfdfb2ec16e$var$weakMapTag) $fd351bfdfb2ec16e$var$getTag = function(value) {
    var result = (0, $8frC0.default)(value), Ctor = result == $fd351bfdfb2ec16e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $lMOWq.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $fd351bfdfb2ec16e$var$dataViewCtorString:
            return $fd351bfdfb2ec16e$var$dataViewTag;
        case $fd351bfdfb2ec16e$var$mapCtorString:
            return $fd351bfdfb2ec16e$var$mapTag;
        case $fd351bfdfb2ec16e$var$promiseCtorString:
            return $fd351bfdfb2ec16e$var$promiseTag;
        case $fd351bfdfb2ec16e$var$setCtorString:
            return $fd351bfdfb2ec16e$var$setTag;
        case $fd351bfdfb2ec16e$var$weakMapCtorString:
            return $fd351bfdfb2ec16e$var$weakMapTag;
    }
    return result;
};
var $fd351bfdfb2ec16e$export$2e2bcd8739ae039 = $fd351bfdfb2ec16e$var$getTag;

});
parcelRegister("8Jr7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b790721c6d94c4$export$2e2bcd8739ae039; });

var $61Nxa = parcelRequire("61Nxa");

var $3dxin = parcelRequire("3dxin");
/* Built-in method references that are verified to be native. */ var $65b790721c6d94c4$var$DataView = (0, $61Nxa.default)((0, $3dxin.default), 'DataView');
var $65b790721c6d94c4$export$2e2bcd8739ae039 = $65b790721c6d94c4$var$DataView;

});

parcelRegister("kfdNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebcfe858d7efac8c$export$2e2bcd8739ae039; });

var $61Nxa = parcelRequire("61Nxa");

var $3dxin = parcelRequire("3dxin");
/* Built-in method references that are verified to be native. */ var $ebcfe858d7efac8c$var$Promise = (0, $61Nxa.default)((0, $3dxin.default), 'Promise');
var $ebcfe858d7efac8c$export$2e2bcd8739ae039 = $ebcfe858d7efac8c$var$Promise;

});

parcelRegister("gbENw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc8d51ff8408eb7f$export$2e2bcd8739ae039; });

var $61Nxa = parcelRequire("61Nxa");

var $3dxin = parcelRequire("3dxin");
/* Built-in method references that are verified to be native. */ var $bc8d51ff8408eb7f$var$Set = (0, $61Nxa.default)((0, $3dxin.default), 'Set');
var $bc8d51ff8408eb7f$export$2e2bcd8739ae039 = $bc8d51ff8408eb7f$var$Set;

});

parcelRegister("9tmxi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e584da784ab7e90$export$2e2bcd8739ae039; });

var $61Nxa = parcelRequire("61Nxa");

var $3dxin = parcelRequire("3dxin");
/* Built-in method references that are verified to be native. */ var $6e584da784ab7e90$var$WeakMap = (0, $61Nxa.default)((0, $3dxin.default), 'WeakMap');
var $6e584da784ab7e90$export$2e2bcd8739ae039 = $6e584da784ab7e90$var$WeakMap;

});


parcelRegister("2LKuQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $204409cbaba73a60$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $204409cbaba73a60$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $204409cbaba73a60$var$hasOwnProperty = $204409cbaba73a60$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $204409cbaba73a60$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $204409cbaba73a60$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $204409cbaba73a60$export$2e2bcd8739ae039 = $204409cbaba73a60$var$initCloneArray;

});

parcelRegister("3Wxqq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2df0b76764ce36ff$export$2e2bcd8739ae039; });

var $7k3Pr = parcelRequire("7k3Pr");

var $6WA6z = parcelRequire("6WA6z");

var $cTqpd = parcelRequire("cTqpd");

var $lAcsR = parcelRequire("lAcsR");

var $hHZg1 = parcelRequire("hHZg1");
/** `Object#toString` result references. */ var $2df0b76764ce36ff$var$boolTag = '[object Boolean]', $2df0b76764ce36ff$var$dateTag = '[object Date]', $2df0b76764ce36ff$var$mapTag = '[object Map]', $2df0b76764ce36ff$var$numberTag = '[object Number]', $2df0b76764ce36ff$var$regexpTag = '[object RegExp]', $2df0b76764ce36ff$var$setTag = '[object Set]', $2df0b76764ce36ff$var$stringTag = '[object String]', $2df0b76764ce36ff$var$symbolTag = '[object Symbol]';
var $2df0b76764ce36ff$var$arrayBufferTag = '[object ArrayBuffer]', $2df0b76764ce36ff$var$dataViewTag = '[object DataView]', $2df0b76764ce36ff$var$float32Tag = '[object Float32Array]', $2df0b76764ce36ff$var$float64Tag = '[object Float64Array]', $2df0b76764ce36ff$var$int8Tag = '[object Int8Array]', $2df0b76764ce36ff$var$int16Tag = '[object Int16Array]', $2df0b76764ce36ff$var$int32Tag = '[object Int32Array]', $2df0b76764ce36ff$var$uint8Tag = '[object Uint8Array]', $2df0b76764ce36ff$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2df0b76764ce36ff$var$uint16Tag = '[object Uint16Array]', $2df0b76764ce36ff$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $2df0b76764ce36ff$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $2df0b76764ce36ff$var$arrayBufferTag:
            return (0, $7k3Pr.default)(object);
        case $2df0b76764ce36ff$var$boolTag:
        case $2df0b76764ce36ff$var$dateTag:
            return new Ctor(+object);
        case $2df0b76764ce36ff$var$dataViewTag:
            return (0, $6WA6z.default)(object, isDeep);
        case $2df0b76764ce36ff$var$float32Tag:
        case $2df0b76764ce36ff$var$float64Tag:
        case $2df0b76764ce36ff$var$int8Tag:
        case $2df0b76764ce36ff$var$int16Tag:
        case $2df0b76764ce36ff$var$int32Tag:
        case $2df0b76764ce36ff$var$uint8Tag:
        case $2df0b76764ce36ff$var$uint8ClampedTag:
        case $2df0b76764ce36ff$var$uint16Tag:
        case $2df0b76764ce36ff$var$uint32Tag:
            return (0, $hHZg1.default)(object, isDeep);
        case $2df0b76764ce36ff$var$mapTag:
            return new Ctor;
        case $2df0b76764ce36ff$var$numberTag:
        case $2df0b76764ce36ff$var$stringTag:
            return new Ctor(object);
        case $2df0b76764ce36ff$var$regexpTag:
            return (0, $cTqpd.default)(object);
        case $2df0b76764ce36ff$var$setTag:
            return new Ctor;
        case $2df0b76764ce36ff$var$symbolTag:
            return (0, $lAcsR.default)(object);
    }
}
var $2df0b76764ce36ff$export$2e2bcd8739ae039 = $2df0b76764ce36ff$var$initCloneByTag;

});
parcelRegister("6WA6z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e42a8aa930acc5$export$2e2bcd8739ae039; });

var $7k3Pr = parcelRequire("7k3Pr");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $50e42a8aa930acc5$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $7k3Pr.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $50e42a8aa930acc5$export$2e2bcd8739ae039 = $50e42a8aa930acc5$var$cloneDataView;

});

parcelRegister("cTqpd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $962f1ab60d82aa7a$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $962f1ab60d82aa7a$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $962f1ab60d82aa7a$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $962f1ab60d82aa7a$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $962f1ab60d82aa7a$export$2e2bcd8739ae039 = $962f1ab60d82aa7a$var$cloneRegExp;

});

parcelRegister("lAcsR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb66a0efe8f277e3$export$2e2bcd8739ae039; });

var $k7yso = parcelRequire("k7yso");
/** Used to convert symbols to primitives and strings. */ var $fb66a0efe8f277e3$var$symbolProto = (0, $k7yso.default) ? (0, $k7yso.default).prototype : undefined, $fb66a0efe8f277e3$var$symbolValueOf = $fb66a0efe8f277e3$var$symbolProto ? $fb66a0efe8f277e3$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $fb66a0efe8f277e3$var$cloneSymbol(symbol) {
    return $fb66a0efe8f277e3$var$symbolValueOf ? Object($fb66a0efe8f277e3$var$symbolValueOf.call(symbol)) : {};
}
var $fb66a0efe8f277e3$export$2e2bcd8739ae039 = $fb66a0efe8f277e3$var$cloneSymbol;

});


parcelRegister("89A5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01882e11ce525e29$export$2e2bcd8739ae039; });

var $ez2V2 = parcelRequire("ez2V2");

var $ijBt2 = parcelRequire("ijBt2");

var $cYLhX = parcelRequire("cYLhX");
/* Node.js helper references. */ var $01882e11ce525e29$var$nodeIsMap = (0, $cYLhX.default) && (0, $cYLhX.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $01882e11ce525e29$var$isMap = $01882e11ce525e29$var$nodeIsMap ? (0, $ijBt2.default)($01882e11ce525e29$var$nodeIsMap) : (0, $ez2V2.default);
var $01882e11ce525e29$export$2e2bcd8739ae039 = $01882e11ce525e29$var$isMap;

});
parcelRegister("ez2V2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9a6993adfca6593$export$2e2bcd8739ae039; });

var $lJOFV = parcelRequire("lJOFV");

var $aA60L = parcelRequire("aA60L");
/** `Object#toString` result references. */ var $a9a6993adfca6593$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $a9a6993adfca6593$var$baseIsMap(value) {
    return (0, $aA60L.default)(value) && (0, $lJOFV.default)(value) == $a9a6993adfca6593$var$mapTag;
}
var $a9a6993adfca6593$export$2e2bcd8739ae039 = $a9a6993adfca6593$var$baseIsMap;

});


parcelRegister("2QdA6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $211af914a03024ea$export$2e2bcd8739ae039; });

var $gBPd9 = parcelRequire("gBPd9");

var $ijBt2 = parcelRequire("ijBt2");

var $cYLhX = parcelRequire("cYLhX");
/* Node.js helper references. */ var $211af914a03024ea$var$nodeIsSet = (0, $cYLhX.default) && (0, $cYLhX.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $211af914a03024ea$var$isSet = $211af914a03024ea$var$nodeIsSet ? (0, $ijBt2.default)($211af914a03024ea$var$nodeIsSet) : (0, $gBPd9.default);
var $211af914a03024ea$export$2e2bcd8739ae039 = $211af914a03024ea$var$isSet;

});
parcelRegister("gBPd9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $031ed5fde6ab4095$export$2e2bcd8739ae039; });

var $lJOFV = parcelRequire("lJOFV");

var $aA60L = parcelRequire("aA60L");
/** `Object#toString` result references. */ var $031ed5fde6ab4095$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $031ed5fde6ab4095$var$baseIsSet(value) {
    return (0, $aA60L.default)(value) && (0, $lJOFV.default)(value) == $031ed5fde6ab4095$var$setTag;
}
var $031ed5fde6ab4095$export$2e2bcd8739ae039 = $031ed5fde6ab4095$var$baseIsSet;

});




parcelRegister("hxeaL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc40832121bcf079$export$2e2bcd8739ae039; });

var $dDCt5 = parcelRequire("dDCt5");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $cc40832121bcf079$var$isEqual(value, other) {
    return (0, $dDCt5.default)(value, other);
}
var $cc40832121bcf079$export$2e2bcd8739ae039 = $cc40832121bcf079$var$isEqual;

});
parcelRegister("dDCt5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9edcc1db5812353e$export$2e2bcd8739ae039; });

var $43SHl = parcelRequire("43SHl");

var $aA60L = parcelRequire("aA60L");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $9edcc1db5812353e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $aA60L.default)(value) && !(0, $aA60L.default)(other)) return value !== value && other !== other;
    return (0, $43SHl.default)(value, other, bitmask, customizer, $9edcc1db5812353e$var$baseIsEqual, stack);
}
var $9edcc1db5812353e$export$2e2bcd8739ae039 = $9edcc1db5812353e$var$baseIsEqual;

});
parcelRegister("43SHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f51df213f3e53fc$export$2e2bcd8739ae039; });

var $liuc6 = parcelRequire("liuc6");

var $iNOpo = parcelRequire("iNOpo");

var $gAHoD = parcelRequire("gAHoD");

var $lP9zo = parcelRequire("lP9zo");

var $lJOFV = parcelRequire("lJOFV");

var $03TET = parcelRequire("03TET");

var $fgu66 = parcelRequire("fgu66");

var $bLelA = parcelRequire("bLelA");
/** Used to compose bitmasks for value comparisons. */ var $2f51df213f3e53fc$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2f51df213f3e53fc$var$argsTag = '[object Arguments]', $2f51df213f3e53fc$var$arrayTag = '[object Array]', $2f51df213f3e53fc$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $2f51df213f3e53fc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f51df213f3e53fc$var$hasOwnProperty = $2f51df213f3e53fc$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2f51df213f3e53fc$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $03TET.default)(object), othIsArr = (0, $03TET.default)(other), objTag = objIsArr ? $2f51df213f3e53fc$var$arrayTag : (0, $lJOFV.default)(object), othTag = othIsArr ? $2f51df213f3e53fc$var$arrayTag : (0, $lJOFV.default)(other);
    objTag = objTag == $2f51df213f3e53fc$var$argsTag ? $2f51df213f3e53fc$var$objectTag : objTag;
    othTag = othTag == $2f51df213f3e53fc$var$argsTag ? $2f51df213f3e53fc$var$objectTag : othTag;
    var objIsObj = objTag == $2f51df213f3e53fc$var$objectTag, othIsObj = othTag == $2f51df213f3e53fc$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $fgu66.default)(object)) {
        if (!(0, $fgu66.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $liuc6.default));
        return objIsArr || (0, $bLelA.default)(object) ? (0, $iNOpo.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $gAHoD.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2f51df213f3e53fc$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2f51df213f3e53fc$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $2f51df213f3e53fc$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $liuc6.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $liuc6.default));
    return (0, $lP9zo.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $2f51df213f3e53fc$export$2e2bcd8739ae039 = $2f51df213f3e53fc$var$baseIsEqualDeep;

});
parcelRegister("iNOpo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db03e7b2b94f2ceb$export$2e2bcd8739ae039; });

var $dF9iG = parcelRequire("dF9iG");

var $3pZcY = parcelRequire("3pZcY");

var $aSQ1W = parcelRequire("aSQ1W");
/** Used to compose bitmasks for value comparisons. */ var $db03e7b2b94f2ceb$var$COMPARE_PARTIAL_FLAG = 1, $db03e7b2b94f2ceb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $db03e7b2b94f2ceb$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $db03e7b2b94f2ceb$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $db03e7b2b94f2ceb$var$COMPARE_UNORDERED_FLAG ? new (0, $dF9iG.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $3pZcY.default)(other, function(othValue, othIndex) {
                if (!(0, $aSQ1W.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $db03e7b2b94f2ceb$export$2e2bcd8739ae039 = $db03e7b2b94f2ceb$var$equalArrays;

});
parcelRegister("dF9iG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f26519198c50f33$export$2e2bcd8739ae039; });

var $5XRvl = parcelRequire("5XRvl");

var $9XPaB = parcelRequire("9XPaB");

var $4BPJm = parcelRequire("4BPJm");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $9f26519198c50f33$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $5XRvl.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$9f26519198c50f33$var$SetCache.prototype.add = $9f26519198c50f33$var$SetCache.prototype.push = (0, $9XPaB.default);
$9f26519198c50f33$var$SetCache.prototype.has = (0, $4BPJm.default);
var $9f26519198c50f33$export$2e2bcd8739ae039 = $9f26519198c50f33$var$SetCache;

});
parcelRegister("9XPaB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7411510aec1bd64f$export$2e2bcd8739ae039; });
/** Used to stand-in for `undefined` hash values. */ var $7411510aec1bd64f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $7411510aec1bd64f$var$setCacheAdd(value) {
    this.__data__.set(value, $7411510aec1bd64f$var$HASH_UNDEFINED);
    return this;
}
var $7411510aec1bd64f$export$2e2bcd8739ae039 = $7411510aec1bd64f$var$setCacheAdd;

});

parcelRegister("4BPJm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35b2bec3aa193e1f$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $35b2bec3aa193e1f$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $35b2bec3aa193e1f$export$2e2bcd8739ae039 = $35b2bec3aa193e1f$var$setCacheHas;

});


parcelRegister("3pZcY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d32f957331b826$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $27d32f957331b826$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $27d32f957331b826$export$2e2bcd8739ae039 = $27d32f957331b826$var$arraySome;

});

parcelRegister("aSQ1W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ec74ea962ca2419$export$2e2bcd8739ae039; });
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7ec74ea962ca2419$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $7ec74ea962ca2419$export$2e2bcd8739ae039 = $7ec74ea962ca2419$var$cacheHas;

});


parcelRegister("gAHoD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c141abbbc37395af$export$2e2bcd8739ae039; });

var $k7yso = parcelRequire("k7yso");

var $hY6DR = parcelRequire("hY6DR");

var $a8hBh = parcelRequire("a8hBh");

var $iNOpo = parcelRequire("iNOpo");

var $6A1gP = parcelRequire("6A1gP");

var $8KL36 = parcelRequire("8KL36");
/** Used to compose bitmasks for value comparisons. */ var $c141abbbc37395af$var$COMPARE_PARTIAL_FLAG = 1, $c141abbbc37395af$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $c141abbbc37395af$var$boolTag = '[object Boolean]', $c141abbbc37395af$var$dateTag = '[object Date]', $c141abbbc37395af$var$errorTag = '[object Error]', $c141abbbc37395af$var$mapTag = '[object Map]', $c141abbbc37395af$var$numberTag = '[object Number]', $c141abbbc37395af$var$regexpTag = '[object RegExp]', $c141abbbc37395af$var$setTag = '[object Set]', $c141abbbc37395af$var$stringTag = '[object String]', $c141abbbc37395af$var$symbolTag = '[object Symbol]';
var $c141abbbc37395af$var$arrayBufferTag = '[object ArrayBuffer]', $c141abbbc37395af$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $c141abbbc37395af$var$symbolProto = (0, $k7yso.default) ? (0, $k7yso.default).prototype : undefined, $c141abbbc37395af$var$symbolValueOf = $c141abbbc37395af$var$symbolProto ? $c141abbbc37395af$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c141abbbc37395af$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $c141abbbc37395af$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $c141abbbc37395af$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $hY6DR.default)(object), new (0, $hY6DR.default)(other))) return false;
            return true;
        case $c141abbbc37395af$var$boolTag:
        case $c141abbbc37395af$var$dateTag:
        case $c141abbbc37395af$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $a8hBh.default)(+object, +other);
        case $c141abbbc37395af$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $c141abbbc37395af$var$regexpTag:
        case $c141abbbc37395af$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $c141abbbc37395af$var$mapTag:
            var convert = (0, $6A1gP.default);
        case $c141abbbc37395af$var$setTag:
            var isPartial = bitmask & $c141abbbc37395af$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $8KL36.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $c141abbbc37395af$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $iNOpo.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $c141abbbc37395af$var$symbolTag:
            if ($c141abbbc37395af$var$symbolValueOf) return $c141abbbc37395af$var$symbolValueOf.call(object) == $c141abbbc37395af$var$symbolValueOf.call(other);
    }
    return false;
}
var $c141abbbc37395af$export$2e2bcd8739ae039 = $c141abbbc37395af$var$equalByTag;

});
parcelRegister("6A1gP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca7172708d9f2f8$export$2e2bcd8739ae039; });
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $4ca7172708d9f2f8$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $4ca7172708d9f2f8$export$2e2bcd8739ae039 = $4ca7172708d9f2f8$var$mapToArray;

});

parcelRegister("8KL36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65f71d8c5136803c$export$2e2bcd8739ae039; });
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $65f71d8c5136803c$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $65f71d8c5136803c$export$2e2bcd8739ae039 = $65f71d8c5136803c$var$setToArray;

});


parcelRegister("lP9zo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe35c8bf30148fc0$export$2e2bcd8739ae039; });

var $eajdV = parcelRequire("eajdV");
/** Used to compose bitmasks for value comparisons. */ var $fe35c8bf30148fc0$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $fe35c8bf30148fc0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fe35c8bf30148fc0$var$hasOwnProperty = $fe35c8bf30148fc0$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $fe35c8bf30148fc0$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $fe35c8bf30148fc0$var$COMPARE_PARTIAL_FLAG, objProps = (0, $eajdV.default)(object), objLength = objProps.length, othProps = (0, $eajdV.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $fe35c8bf30148fc0$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $fe35c8bf30148fc0$export$2e2bcd8739ae039 = $fe35c8bf30148fc0$var$equalObjects;

});




parcelRegister("eT6zx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad6b4cddf012d104$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "blockDelta", function () { return $ad6b4cddf012d104$export$992ff47219af5a2b; });
$parcel$export(module.exports, "BlockEmbed", function () { return $ad6b4cddf012d104$export$48b9f0688962d028; });
$parcel$export(module.exports, "bubbleFormats", function () { return $ad6b4cddf012d104$export$e4bb5a6163449612; });

var $9uxoP = parcelRequire("9uxoP");

var $eD1QA = parcelRequire("eD1QA");

var $aA0eA = parcelRequire("aA0eA");

var $i9ca8 = parcelRequire("i9ca8");

var $1oJfc = parcelRequire("1oJfc");
const $ad6b4cddf012d104$var$NEWLINE_LENGTH = 1;
class $ad6b4cddf012d104$export$2e2bcd8739ae039 extends (0, $9uxoP.BlockBlot) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $ad6b4cddf012d104$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $9uxoP.Scope).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $aA0eA.default)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $ad6b4cddf012d104$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $ad6b4cddf012d104$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$ad6b4cddf012d104$export$2e2bcd8739ae039.blotName = 'block';
$ad6b4cddf012d104$export$2e2bcd8739ae039.tagName = 'P';
$ad6b4cddf012d104$export$2e2bcd8739ae039.defaultChild = (0, $aA0eA.default);
$ad6b4cddf012d104$export$2e2bcd8739ae039.allowedChildren = [
    (0, $aA0eA.default),
    (0, $i9ca8.default),
    (0, $9uxoP.EmbedBlot),
    (0, $1oJfc.default)
];
class $ad6b4cddf012d104$export$48b9f0688962d028 extends (0, $9uxoP.EmbedBlot) {
    attach() {
        super.attach();
        this.attributes = new (0, $9uxoP.AttributorStore)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $9uxoP.Scope).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($ad6b4cddf012d104$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$ad6b4cddf012d104$export$48b9f0688962d028.scope = (0, $9uxoP.Scope).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $ad6b4cddf012d104$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $9uxoP.LeafBlot)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $ad6b4cddf012d104$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))()).insert('\n', $ad6b4cddf012d104$export$e4bb5a6163449612(blot));
}
function $ad6b4cddf012d104$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $ad6b4cddf012d104$export$e4bb5a6163449612(blot.parent, formats, filter);
}

});
parcelRegister("aA0eA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b3d72b5098c2218$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");
class $7b3d72b5098c2218$var$Break extends (0, $9uxoP.EmbedBlot) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$7b3d72b5098c2218$var$Break.blotName = 'break';
$7b3d72b5098c2218$var$Break.tagName = 'BR';
var $7b3d72b5098c2218$export$2e2bcd8739ae039 = $7b3d72b5098c2218$var$Break;

});

parcelRegister("i9ca8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d362807ce44c87fb$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");

var $aA0eA = parcelRequire("aA0eA");

var $1oJfc = parcelRequire("1oJfc");
class $d362807ce44c87fb$var$Inline extends (0, $9uxoP.InlineBlot) {
    static allowedChildren = [
        $d362807ce44c87fb$var$Inline,
        (0, $aA0eA.default),
        (0, $9uxoP.EmbedBlot),
        (0, $1oJfc.default)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $d362807ce44c87fb$var$Inline.order.indexOf(self);
        const otherIndex = $d362807ce44c87fb$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($d362807ce44c87fb$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $9uxoP.Scope).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $d362807ce44c87fb$var$Inline && $d362807ce44c87fb$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $d362807ce44c87fb$export$2e2bcd8739ae039 = $d362807ce44c87fb$var$Inline;

});
parcelRegister("1oJfc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $104b20e0a9b3478d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "escapeText", function () { return $104b20e0a9b3478d$export$96e6fc3a139b2555; });

var $9uxoP = parcelRequire("9uxoP");
class $104b20e0a9b3478d$export$2e2bcd8739ae039 extends (0, $9uxoP.TextBlot) {
}
// https://lodash.com/docs#escape
const $104b20e0a9b3478d$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $104b20e0a9b3478d$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$104b20e0a9b3478d$var$entityMap[s]);
}

});



parcelRegister("i4Ja5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d28ba1e4644a64ce$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");

var $1oJfc = parcelRequire("1oJfc");
class $d28ba1e4644a64ce$var$Cursor extends (0, $9uxoP.EmbedBlot) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($d28ba1e4644a64ce$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $9uxoP.Scope).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $d28ba1e4644a64ce$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $d28ba1e4644a64ce$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $1oJfc.default) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $1oJfc.default) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($d28ba1e4644a64ce$var$Cursor.CONTENTS).join('');
        textNode.data = $d28ba1e4644a64ce$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $d28ba1e4644a64ce$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $d28ba1e4644a64ce$export$2e2bcd8739ae039 = $d28ba1e4644a64ce$var$Cursor;

});

parcelRegister("36WOi", function(module, exports) {

$parcel$export(module.exports, "Range", function () { return $243f8d1c34ec1890$export$9a58ef0d7ad3278c; });
$parcel$export(module.exports, "default", function () { return $243f8d1c34ec1890$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");

var $kZLOs = parcelRequire("kZLOs");
var $hxeaL = parcelRequire("hxeaL");

var $lK3Fw = parcelRequire("lK3Fw");

var $6frwg = parcelRequire("6frwg");
const $243f8d1c34ec1890$var$debug = (0, $6frwg.default)('quill:selection');
class $243f8d1c34ec1890$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $243f8d1c34ec1890$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $243f8d1c34ec1890$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $lK3Fw.default).sources.USER), 1);
        });
        this.emitter.on((0, $lK3Fw.default).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $lK3Fw.default).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $lK3Fw.default).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $lK3Fw.default).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $lK3Fw.default).sources.SILENT);
            }
        });
        this.update((0, $lK3Fw.default).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $lK3Fw.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $lK3Fw.default).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $lK3Fw.default).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $9uxoP.Scope).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $9uxoP.LeafBlot)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $243f8d1c34ec1890$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $243f8d1c34ec1890$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $9uxoP.LeafBlot)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $243f8d1c34ec1890$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$243f8d1c34ec1890$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$243f8d1c34ec1890$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $243f8d1c34ec1890$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $lK3Fw.default).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $243f8d1c34ec1890$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $lK3Fw.default).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $hxeaL.default)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $lK3Fw.default).events.SELECTION_CHANGE,
                (0, $kZLOs.default)(this.lastRange),
                (0, $kZLOs.default)(oldRange),
                source
            ];
            this.emitter.emit((0, $lK3Fw.default).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $lK3Fw.default).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $243f8d1c34ec1890$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $243f8d1c34ec1890$export$2e2bcd8739ae039 = $243f8d1c34ec1890$var$Selection;

});
parcelRegister("lK3Fw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd40bd669e642ea0$export$2e2bcd8739ae039; });
parcelRequire("r30PK");
var $9caoK = parcelRequire("9caoK");

var $8h5XC = parcelRequire("8h5XC");

var $6frwg = parcelRequire("6frwg");
const $fd40bd669e642ea0$var$debug = (0, $6frwg.default)('quill:events');
const $fd40bd669e642ea0$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$fd40bd669e642ea0$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $8h5XC.default).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $fd40bd669e642ea0$var$Emitter extends (0, (/*@__PURE__*/$parcel$interopDefault($9caoK))) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $fd40bd669e642ea0$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $fd40bd669e642ea0$var$debug.log.call($fd40bd669e642ea0$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $fd40bd669e642ea0$export$2e2bcd8739ae039 = $fd40bd669e642ea0$var$Emitter;

});
parcelRegister("r30PK", function(module, exports) {

$parcel$export(module.exports, "EventEmitter", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9caoK")))); });

var $9caoK = parcelRequire("9caoK");
var $cb543f1558e03bad$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($9caoK)));

});
parcelRegister("9caoK", function(module, exports) {
'use strict';
var $6b1d4ceb6a218f97$var$has = Object.prototype.hasOwnProperty, $6b1d4ceb6a218f97$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $6b1d4ceb6a218f97$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $6b1d4ceb6a218f97$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $6b1d4ceb6a218f97$var$Events().__proto__) $6b1d4ceb6a218f97$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $6b1d4ceb6a218f97$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $6b1d4ceb6a218f97$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $6b1d4ceb6a218f97$var$EE(fn, context || emitter, once), evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $6b1d4ceb6a218f97$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $6b1d4ceb6a218f97$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $6b1d4ceb6a218f97$var$EventEmitter() {
    this._events = new $6b1d4ceb6a218f97$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($6b1d4ceb6a218f97$var$has.call(events, name)) names.push($6b1d4ceb6a218f97$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $6b1d4ceb6a218f97$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $6b1d4ceb6a218f97$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $6b1d4ceb6a218f97$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $6b1d4ceb6a218f97$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $6b1d4ceb6a218f97$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event;
        if (this._events[evt]) $6b1d4ceb6a218f97$var$clearEvent(this, evt);
    } else {
        this._events = new $6b1d4ceb6a218f97$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$6b1d4ceb6a218f97$var$EventEmitter.prototype.off = $6b1d4ceb6a218f97$var$EventEmitter.prototype.removeListener;
$6b1d4ceb6a218f97$var$EventEmitter.prototype.addListener = $6b1d4ceb6a218f97$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$6b1d4ceb6a218f97$var$EventEmitter.prefixed = $6b1d4ceb6a218f97$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$6b1d4ceb6a218f97$var$EventEmitter.EventEmitter = $6b1d4ceb6a218f97$var$EventEmitter;
module.exports = $6b1d4ceb6a218f97$var$EventEmitter;

});


parcelRegister("8h5XC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $606488e3f0e6d76d$export$2e2bcd8739ae039; });
var $606488e3f0e6d76d$export$2e2bcd8739ae039 = new WeakMap();

});

parcelRegister("6frwg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48c97d8ee49a14ef$export$2e2bcd8739ae039; });
const $48c97d8ee49a14ef$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $48c97d8ee49a14ef$var$level = 'warn';
function $48c97d8ee49a14ef$var$debug(method) {
    if ($48c97d8ee49a14ef$var$level) {
        if ($48c97d8ee49a14ef$var$levels.indexOf(method) <= $48c97d8ee49a14ef$var$levels.indexOf($48c97d8ee49a14ef$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $48c97d8ee49a14ef$var$namespace(ns) {
    return $48c97d8ee49a14ef$var$levels.reduce((logger, method)=>{
        logger[method] = $48c97d8ee49a14ef$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$48c97d8ee49a14ef$var$namespace.level = (newLevel)=>{
    $48c97d8ee49a14ef$var$level = newLevel;
};
$48c97d8ee49a14ef$var$debug.level = $48c97d8ee49a14ef$var$namespace.level;
var $48c97d8ee49a14ef$export$2e2bcd8739ae039 = $48c97d8ee49a14ef$var$namespace;

});




parcelRegister("9ixpP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c4fb7204d4dc6ca$export$2e2bcd8739ae039; });
class $6c4fb7204d4dc6ca$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $6c4fb7204d4dc6ca$export$2e2bcd8739ae039 = $6c4fb7204d4dc6ca$var$Module;

});

parcelRegister("9AxMn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fb1adb6b4e02571$export$2e2bcd8739ae039; });

var $2v3kg = parcelRequire("2v3kg");

var $lK3Fw = parcelRequire("lK3Fw");
class $6fb1adb6b4e02571$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $2v3kg.default))) {
            this.emitter.emit((0, $lK3Fw.default).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $lK3Fw.default).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $lK3Fw.default).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $lK3Fw.default).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $6fb1adb6b4e02571$export$2e2bcd8739ae039 = $6fb1adb6b4e02571$var$Composition;

});
parcelRegister("2v3kg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d210e796f74345e$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");

var $1oJfc = parcelRequire("1oJfc");
const $1d210e796f74345e$var$GUARD_TEXT = '\uFEFF';
class $1d210e796f74345e$var$Embed extends (0, $9uxoP.EmbedBlot) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($1d210e796f74345e$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($1d210e796f74345e$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($1d210e796f74345e$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $1oJfc.default)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $1oJfc.default)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $1d210e796f74345e$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $1d210e796f74345e$export$2e2bcd8739ae039 = $1d210e796f74345e$var$Embed;

});


parcelRegister("bzBuA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86d00bcf2caabea4$export$2e2bcd8739ae039; });
class $86d00bcf2caabea4$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $86d00bcf2caabea4$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $86d00bcf2caabea4$export$2e2bcd8739ae039 = $86d00bcf2caabea4$var$Theme;

});

parcelRegister("kO1v8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f259a43d586469fb$export$2e2bcd8739ae039; });
const $f259a43d586469fb$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $f259a43d586469fb$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $f259a43d586469fb$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $f259a43d586469fb$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $f259a43d586469fb$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $f259a43d586469fb$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $f259a43d586469fb$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $f259a43d586469fb$var$paddingValueToInt(style.scrollPaddingLeft), $f259a43d586469fb$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $f259a43d586469fb$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $f259a43d586469fb$var$paddingValueToInt(style.scrollPaddingTop), $f259a43d586469fb$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $f259a43d586469fb$var$getParentElement(current);
    }
};
var $f259a43d586469fb$export$2e2bcd8739ae039 = $f259a43d586469fb$var$scrollRectIntoView;

});

parcelRegister("8GfdF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $651e0d38c109a42a$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");
const $651e0d38c109a42a$var$MAX_REGISTER_ITERATIONS = 100;
const $651e0d38c109a42a$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $651e0d38c109a42a$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $9uxoP.Registry)();
    $651e0d38c109a42a$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $651e0d38c109a42a$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $651e0d38c109a42a$export$2e2bcd8739ae039 = $651e0d38c109a42a$var$createRegistryWithFormats;

});


parcelRegister("faDi5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0b64486bc21593a$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");
class $b0b64486bc21593a$var$Container extends (0, $9uxoP.ContainerBlot) {
}
var $b0b64486bc21593a$export$2e2bcd8739ae039 = $b0b64486bc21593a$var$Container;

});

parcelRegister("b1sv1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8065e50eeaa06e43$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");

var $eD1QA = parcelRequire("eD1QA");

var $lK3Fw = parcelRequire("lK3Fw");

var $eT6zx = parcelRequire("eT6zx");

var $aA0eA = parcelRequire("aA0eA");

var $faDi5 = parcelRequire("faDi5");
function $8065e50eeaa06e43$var$isLine(blot) {
    return blot instanceof (0, $eT6zx.default) || blot instanceof (0, $eT6zx.BlockEmbed);
}
function $8065e50eeaa06e43$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $8065e50eeaa06e43$var$Scroll extends (0, $9uxoP.ScrollBlot) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $eT6zx.default);
    static allowedChildren = [
        (0, $eT6zx.default),
        (0, $eT6zx.BlockEmbed),
        (0, $faDi5.default)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $lK3Fw.default).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $lK3Fw.default).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $lK3Fw.default).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $eT6zx.BlockEmbed) || last instanceof (0, $eT6zx.BlockEmbed)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $aA0eA.default) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $9uxoP.Scope).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $9uxoP.Scope).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $eT6zx.BlockEmbed), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert({
                [first.key]: first.value
            });
            $8065e50eeaa06e43$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $eT6zx.bubbleFormats)(this.line(index)[0]);
            const attributes = (0, $eD1QA.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $8065e50eeaa06e43$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $8065e50eeaa06e43$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $9uxoP.LeafBlot) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($8065e50eeaa06e43$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($8065e50eeaa06e43$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $9uxoP.ContainerBlot)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $lK3Fw.default).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $lK3Fw.default).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$8065e50eeaa06e43$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $lK3Fw.default).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $lK3Fw.default).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $eT6zx.BlockEmbed), index);
        if (blot && blot.statics.blotName === key && $8065e50eeaa06e43$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $9uxoP.Scope).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $9uxoP.Scope).BLOCK & (0, $9uxoP.Scope).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $8065e50eeaa06e43$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $eD1QA.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $9uxoP.LeafBlot), index);
                const formats = (0, $eT6zx.bubbleFormats)(leaf);
                attributes = (0, $eD1QA.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $9uxoP.Scope).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $9uxoP.LeafBlot), index);
                    const formats = (0, $eT6zx.bubbleFormats)(leaf);
                    attributes = (0, $eD1QA.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $8065e50eeaa06e43$export$2e2bcd8739ae039 = $8065e50eeaa06e43$var$Scroll;

});

parcelRegister("eKsv8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abcb784bf806848d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "traverse", function () { return $abcb784bf806848d$export$df3f009e3d155b20; });

var $9uxoP = parcelRequire("9uxoP");

var $eD1QA = parcelRequire("eD1QA");

var $eT6zx = parcelRequire("eT6zx");

var $6frwg = parcelRequire("6frwg");

var $9ixpP = parcelRequire("9ixpP");

var $1coM0 = parcelRequire("1coM0");

var $bJLKV = parcelRequire("bJLKV");

var $4ClAK = parcelRequire("4ClAK");

var $kIiEv = parcelRequire("kIiEv");

var $2jcr6 = parcelRequire("2jcr6");

var $bs5Uw = parcelRequire("bs5Uw");

var $3QPIl = parcelRequire("3QPIl");

var $j5J3l = parcelRequire("j5J3l");

var $kZq8S = parcelRequire("kZq8S");

var $g6NUK = parcelRequire("g6NUK");
const $abcb784bf806848d$var$debug = (0, $6frwg.default)('quill:clipboard');
const $abcb784bf806848d$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $abcb784bf806848d$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $abcb784bf806848d$export$c695b9637111f586
    ],
    [
        'br',
        $abcb784bf806848d$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $abcb784bf806848d$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $abcb784bf806848d$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $abcb784bf806848d$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $abcb784bf806848d$var$matchStyles
    ],
    [
        'li',
        $abcb784bf806848d$var$matchIndent
    ],
    [
        'ol, ul',
        $abcb784bf806848d$var$matchList
    ],
    [
        'pre',
        $abcb784bf806848d$var$matchCodeBlock
    ],
    [
        'tr',
        $abcb784bf806848d$var$matchTable
    ],
    [
        'b',
        $abcb784bf806848d$var$createMatchAlias('bold')
    ],
    [
        'i',
        $abcb784bf806848d$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $abcb784bf806848d$var$createMatchAlias('strike')
    ],
    [
        'style',
        $abcb784bf806848d$var$matchIgnore
    ]
];
const $abcb784bf806848d$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $bJLKV.AlignAttribute),
    (0, $bs5Uw.DirectionAttribute)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $abcb784bf806848d$var$STYLE_ATTRIBUTORS = [
    (0, $bJLKV.AlignStyle),
    (0, $4ClAK.BackgroundStyle),
    (0, $2jcr6.ColorStyle),
    (0, $bs5Uw.DirectionStyle),
    (0, $3QPIl.FontStyle),
    (0, $j5J3l.SizeStyle)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $abcb784bf806848d$export$2e2bcd8739ae039 extends (0, $9ixpP.default) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $abcb784bf806848d$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $kIiEv.default).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert(text || '', {
            [(0, $kIiEv.default).blotName]: formats[(0, $kIiEv.default).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($abcb784bf806848d$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $g6NUK.default)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $abcb784bf806848d$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $1coM0.default).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $1coM0.default).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $1coM0.default).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $kZq8S.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $abcb784bf806848d$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $1coM0.default).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $abcb784bf806848d$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
}
function $abcb784bf806848d$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $abcb784bf806848d$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $9uxoP.EmbedBlot)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $abcb784bf806848d$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$abcb784bf806848d$var$isLine(node.previousElementSibling, scroll) && !$abcb784bf806848d$var$isLine(node.nextElementSibling, scroll);
}
const $abcb784bf806848d$var$preNodes = new WeakMap();
function $abcb784bf806848d$var$isPre(node) {
    if (node == null) return false;
    if (!$abcb784bf806848d$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $abcb784bf806848d$var$preNodes.set(node, true);
        else $abcb784bf806848d$var$preNodes.set(node, $abcb784bf806848d$var$isPre(node.parentNode));
    }
    return $abcb784bf806848d$var$preNodes.get(node);
}
function $abcb784bf806848d$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $abcb784bf806848d$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
}
function $abcb784bf806848d$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $abcb784bf806848d$var$applyFormat(delta, format, true, scroll);
    };
}
function $abcb784bf806848d$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $9uxoP.Attributor).keys(node);
    const classes = (0, $9uxoP.ClassAttributor).keys(node);
    const styles = (0, $9uxoP.StyleAttributor).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $9uxoP.Scope).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $abcb784bf806848d$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $abcb784bf806848d$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $abcb784bf806848d$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $abcb784bf806848d$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $abcb784bf806848d$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $9uxoP.EmbedBlot)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $9uxoP.BlockBlot) && !$abcb784bf806848d$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $abcb784bf806848d$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $abcb784bf806848d$var$matchBreak(node, delta) {
    if (!$abcb784bf806848d$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $abcb784bf806848d$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $abcb784bf806848d$var$applyFormat(delta, 'code-block', language, scroll);
}
function $abcb784bf806848d$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))();
}
function $abcb784bf806848d$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$abcb784bf806848d$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
}
function $abcb784bf806848d$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $abcb784bf806848d$var$applyFormat(delta, 'list', list, scroll);
}
function $abcb784bf806848d$export$c695b9637111f586(node, delta, scroll) {
    if (!$abcb784bf806848d$var$deltaEndsWith(delta, '\n')) {
        if ($abcb784bf806848d$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($abcb784bf806848d$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $eT6zx.BlockEmbed)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $abcb784bf806848d$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $abcb784bf806848d$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().insert('\t').concat(delta);
    return delta;
}
function $abcb784bf806848d$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $abcb784bf806848d$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $abcb784bf806848d$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$abcb784bf806848d$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$abcb784bf806848d$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $abcb784bf806848d$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $abcb784bf806848d$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $abcb784bf806848d$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $abcb784bf806848d$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}

});
parcelRegister("bJLKV", function(module, exports) {

$parcel$export(module.exports, "AlignAttribute", function () { return $88b8f0fc05242626$export$2ef0f9fb04a51388; });
$parcel$export(module.exports, "AlignClass", function () { return $88b8f0fc05242626$export$7f3685f5846c07da; });
$parcel$export(module.exports, "AlignStyle", function () { return $88b8f0fc05242626$export$d2060f5d114c9fe8; });

var $9uxoP = parcelRequire("9uxoP");
const $88b8f0fc05242626$var$config = {
    scope: (0, $9uxoP.Scope).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $88b8f0fc05242626$export$2ef0f9fb04a51388 = new (0, $9uxoP.Attributor)('align', 'align', $88b8f0fc05242626$var$config);
const $88b8f0fc05242626$export$7f3685f5846c07da = new (0, $9uxoP.ClassAttributor)('align', 'ql-align', $88b8f0fc05242626$var$config);
const $88b8f0fc05242626$export$d2060f5d114c9fe8 = new (0, $9uxoP.StyleAttributor)('align', 'text-align', $88b8f0fc05242626$var$config);

});

parcelRegister("4ClAK", function(module, exports) {

$parcel$export(module.exports, "BackgroundClass", function () { return $35cb75b28a76bd4a$export$8aa96c8963152b12; });
$parcel$export(module.exports, "BackgroundStyle", function () { return $35cb75b28a76bd4a$export$dc1cbcab4c682ef; });

var $9uxoP = parcelRequire("9uxoP");

var $2jcr6 = parcelRequire("2jcr6");
const $35cb75b28a76bd4a$export$8aa96c8963152b12 = new (0, $9uxoP.ClassAttributor)('background', 'ql-bg', {
    scope: (0, $9uxoP.Scope).INLINE
});
const $35cb75b28a76bd4a$export$dc1cbcab4c682ef = new (0, $2jcr6.ColorAttributor)('background', 'background-color', {
    scope: (0, $9uxoP.Scope).INLINE
});

});
parcelRegister("2jcr6", function(module, exports) {

$parcel$export(module.exports, "ColorAttributor", function () { return $1ae700ac0f344ea6$export$c992e3369f248f6e; });
$parcel$export(module.exports, "ColorClass", function () { return $1ae700ac0f344ea6$export$42795dcf0ec6f3c8; });
$parcel$export(module.exports, "ColorStyle", function () { return $1ae700ac0f344ea6$export$1415f56796d9a5a9; });

var $9uxoP = parcelRequire("9uxoP");
class $1ae700ac0f344ea6$export$c992e3369f248f6e extends (0, $9uxoP.StyleAttributor) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $1ae700ac0f344ea6$export$42795dcf0ec6f3c8 = new (0, $9uxoP.ClassAttributor)('color', 'ql-color', {
    scope: (0, $9uxoP.Scope).INLINE
});
const $1ae700ac0f344ea6$export$1415f56796d9a5a9 = new $1ae700ac0f344ea6$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $9uxoP.Scope).INLINE
});

});


parcelRegister("kIiEv", function(module, exports) {

$parcel$export(module.exports, "CodeBlockContainer", function () { return $f14662aaf69a0768$export$3b131632d3d15165; });
$parcel$export(module.exports, "default", function () { return $f14662aaf69a0768$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Code", function () { return $f14662aaf69a0768$export$52f0f02147b12c03; });

var $eT6zx = parcelRequire("eT6zx");

var $aA0eA = parcelRequire("aA0eA");

var $i4Ja5 = parcelRequire("i4Ja5");

var $i9ca8 = parcelRequire("i9ca8");

var $1oJfc = parcelRequire("1oJfc");

var $faDi5 = parcelRequire("faDi5");

var $1coM0 = parcelRequire("1coM0");
class $f14662aaf69a0768$export$3b131632d3d15165 extends (0, $faDi5.default) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $1oJfc.escapeText)(this.code(index, length))}\n</pre>`;
    }
}
class $f14662aaf69a0768$export$2e2bcd8739ae039 extends (0, $eT6zx.default) {
    static TAB = '  ';
    static register() {
        (0, $1coM0.default).register($f14662aaf69a0768$export$3b131632d3d15165);
    }
}
class $f14662aaf69a0768$export$52f0f02147b12c03 extends (0, $i9ca8.default) {
}
$f14662aaf69a0768$export$52f0f02147b12c03.blotName = 'code';
$f14662aaf69a0768$export$52f0f02147b12c03.tagName = 'CODE';
$f14662aaf69a0768$export$2e2bcd8739ae039.blotName = 'code-block';
$f14662aaf69a0768$export$2e2bcd8739ae039.className = 'ql-code-block';
$f14662aaf69a0768$export$2e2bcd8739ae039.tagName = 'DIV';
$f14662aaf69a0768$export$3b131632d3d15165.blotName = 'code-block-container';
$f14662aaf69a0768$export$3b131632d3d15165.className = 'ql-code-block-container';
$f14662aaf69a0768$export$3b131632d3d15165.tagName = 'DIV';
$f14662aaf69a0768$export$3b131632d3d15165.allowedChildren = [
    $f14662aaf69a0768$export$2e2bcd8739ae039
];
$f14662aaf69a0768$export$2e2bcd8739ae039.allowedChildren = [
    (0, $1oJfc.default),
    (0, $aA0eA.default),
    (0, $i4Ja5.default)
];
$f14662aaf69a0768$export$2e2bcd8739ae039.requiredContainer = $f14662aaf69a0768$export$3b131632d3d15165;

});

parcelRegister("bs5Uw", function(module, exports) {

$parcel$export(module.exports, "DirectionAttribute", function () { return $8566e4f8c00c3263$export$4158215dafad9efa; });
$parcel$export(module.exports, "DirectionClass", function () { return $8566e4f8c00c3263$export$630028b3af294dec; });
$parcel$export(module.exports, "DirectionStyle", function () { return $8566e4f8c00c3263$export$175979e518d1dfd1; });

var $9uxoP = parcelRequire("9uxoP");
const $8566e4f8c00c3263$var$config = {
    scope: (0, $9uxoP.Scope).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $8566e4f8c00c3263$export$4158215dafad9efa = new (0, $9uxoP.Attributor)('direction', 'dir', $8566e4f8c00c3263$var$config);
const $8566e4f8c00c3263$export$630028b3af294dec = new (0, $9uxoP.ClassAttributor)('direction', 'ql-direction', $8566e4f8c00c3263$var$config);
const $8566e4f8c00c3263$export$175979e518d1dfd1 = new (0, $9uxoP.StyleAttributor)('direction', 'direction', $8566e4f8c00c3263$var$config);

});

parcelRegister("3QPIl", function(module, exports) {

$parcel$export(module.exports, "FontClass", function () { return $2cde57cdd9a9e4da$export$78a99ee601572ab; });
$parcel$export(module.exports, "FontStyle", function () { return $2cde57cdd9a9e4da$export$23b468d4ca3f8c96; });

var $9uxoP = parcelRequire("9uxoP");
const $2cde57cdd9a9e4da$var$config = {
    scope: (0, $9uxoP.Scope).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $2cde57cdd9a9e4da$export$78a99ee601572ab = new (0, $9uxoP.ClassAttributor)('font', 'ql-font', $2cde57cdd9a9e4da$var$config);
class $2cde57cdd9a9e4da$var$FontStyleAttributor extends (0, $9uxoP.StyleAttributor) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $2cde57cdd9a9e4da$export$23b468d4ca3f8c96 = new $2cde57cdd9a9e4da$var$FontStyleAttributor('font', 'font-family', $2cde57cdd9a9e4da$var$config);

});

parcelRegister("j5J3l", function(module, exports) {

$parcel$export(module.exports, "SizeClass", function () { return $de616e8a46097543$export$c84684d52bca9684; });
$parcel$export(module.exports, "SizeStyle", function () { return $de616e8a46097543$export$5443b95a30e89ac5; });

var $9uxoP = parcelRequire("9uxoP");
const $de616e8a46097543$export$c84684d52bca9684 = new (0, $9uxoP.ClassAttributor)('size', 'ql-size', {
    scope: (0, $9uxoP.Scope).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $de616e8a46097543$export$5443b95a30e89ac5 = new (0, $9uxoP.StyleAttributor)('size', 'font-size', {
    scope: (0, $9uxoP.Scope).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});

});

parcelRegister("kZq8S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f47dc87548d85542$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "deleteRange", function () { return $f47dc87548d85542$export$a6c813797f379898; });

var $kZLOs = parcelRequire("kZLOs");
var $hxeaL = parcelRequire("hxeaL");

var $eD1QA = parcelRequire("eD1QA");

var $9uxoP = parcelRequire("9uxoP");

var $1coM0 = parcelRequire("1coM0");

var $6frwg = parcelRequire("6frwg");

var $9ixpP = parcelRequire("9ixpP");
const $f47dc87548d85542$var$debug = (0, $6frwg.default)('quill:keyboard');
const $f47dc87548d85542$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $f47dc87548d85542$export$2e2bcd8739ae039 extends (0, $9ixpP.default) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $f47dc87548d85542$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $f47dc87548d85542$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$f47dc87548d85542$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $1coM0.default).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $9uxoP.TextBlot) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $9uxoP.TextBlot) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $hxeaL.default)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $eD1QA.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $eD1QA.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $f47dc87548d85542$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $9uxoP.Scope).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $1coM0.default).sources.SILENT);
        this.quill.focus();
    }
}
const $f47dc87548d85542$var$defaultOptions = {
    bindings: {
        bold: $f47dc87548d85542$var$makeFormatHandler('bold'),
        italic: $f47dc87548d85542$var$makeFormatHandler('italic'),
        underline: $f47dc87548d85542$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $1coM0.default).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $1coM0.default).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $1coM0.default).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $1coM0.default).sources.USER);
            }
        },
        'indent code-block': $f47dc87548d85542$var$makeCodeBlockHandler(true),
        'outdent code-block': $f47dc87548d85542$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $1coM0.default).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $1coM0.default).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $1coM0.default).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $1coM0.default).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $1coM0.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $1coM0.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $f47dc87548d85542$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $1coM0.default).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
                        this.quill.setSelection(index, (0, $1coM0.default).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $1coM0.default).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $1coM0.default).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $1coM0.default).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $1coM0.default).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $1coM0.default).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $f47dc87548d85542$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $f47dc87548d85542$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $f47dc87548d85542$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $f47dc87548d85542$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $f47dc87548d85542$var$makeTableArrowHandler(false),
        'table up': $f47dc87548d85542$var$makeTableArrowHandler(true)
    }
};
$f47dc87548d85542$export$2e2bcd8739ae039.DEFAULTS = $f47dc87548d85542$var$defaultOptions;
function $f47dc87548d85542$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $1coM0.default).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $1coM0.default).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $1coM0.default).sources.USER);
            this.quill.setSelection(index, length, (0, $1coM0.default).sources.SILENT);
        }
    };
}
function $f47dc87548d85542$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $9uxoP.EmbedBlot))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $1coM0.default).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $1coM0.default).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $1coM0.default).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $1coM0.default).sources.USER);
            return false;
        }
    };
}
function $f47dc87548d85542$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $1coM0.default).sources.USER);
        }
    };
}
function $f47dc87548d85542$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $1coM0.default).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $1coM0.default).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $1coM0.default).sources.USER);
                }
            }
            return false;
        }
    };
}
function $f47dc87548d85542$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $kZLOs.default)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$f47dc87548d85542$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $f47dc87548d85542$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $eD1QA.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $1coM0.default).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $1coM0.default).sources.USER);
    quill.setSelection(range.index, (0, $1coM0.default).sources.SILENT);
}
function $f47dc87548d85542$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}

});

parcelRegister("g6NUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bba3ecd676896bdf$export$2e2bcd8739ae039; });

var $dYs8D = parcelRequire("dYs8D");

var $jvWA4 = parcelRequire("jvWA4");
const $bba3ecd676896bdf$var$NORMALIZERS = [
    (0, $jvWA4.default),
    (0, $dYs8D.default)
];
const $bba3ecd676896bdf$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $bba3ecd676896bdf$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $bba3ecd676896bdf$export$2e2bcd8739ae039 = $bba3ecd676896bdf$var$normalizeExternalHTML;

});
parcelRegister("dYs8D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2c6b49e039a4453$export$2e2bcd8739ae039; });
const $a2c6b49e039a4453$var$normalWeightRegexp = /font-weight:\s*normal/;
const $a2c6b49e039a4453$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $a2c6b49e039a4453$var$isBlockElement = (element)=>{
    return element && $a2c6b49e039a4453$var$blockTagNames.includes(element.tagName);
};
const $a2c6b49e039a4453$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$a2c6b49e039a4453$var$isBlockElement(br.previousElementSibling) && $a2c6b49e039a4453$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $a2c6b49e039a4453$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($a2c6b49e039a4453$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $a2c6b49e039a4453$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $a2c6b49e039a4453$var$normalizeFontWeight(doc);
        $a2c6b49e039a4453$var$normalizeEmptyLines(doc);
    }
}

});

parcelRegister("jvWA4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e34e5a84ea2190ca$export$2e2bcd8739ae039; });
const $e34e5a84ea2190ca$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $e34e5a84ea2190ca$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $e34e5a84ea2190ca$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $e34e5a84ea2190ca$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($e34e5a84ea2190ca$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($e34e5a84ea2190ca$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $e34e5a84ea2190ca$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($e34e5a84ea2190ca$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$e34e5a84ea2190ca$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $e34e5a84ea2190ca$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $e34e5a84ea2190ca$var$normalizeListItem(doc);
}

});



parcelRegister("cgEGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee68aba1ccc2662$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");

var $9ixpP = parcelRequire("9ixpP");

var $1coM0 = parcelRequire("1coM0");
class $8ee68aba1ccc2662$export$2e2bcd8739ae039 extends (0, $9ixpP.default) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $1coM0.default).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $1coM0.default).events.SELECTION_CHANGE) {
                if (value && source !== (0, $1coM0.default).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $1coM0.default).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $1coM0.default).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $8ee68aba1ccc2662$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $8ee68aba1ccc2662$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $1coM0.default).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $8ee68aba1ccc2662$var$transformStack(this.stack.undo, delta);
        $8ee68aba1ccc2662$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $1coM0.default).sources.USER);
        else {
            const index = $8ee68aba1ccc2662$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $1coM0.default).sources.USER);
        }
    }
}
function $8ee68aba1ccc2662$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $8ee68aba1ccc2662$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $8ee68aba1ccc2662$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $9uxoP.Scope).BLOCK) != null;
    });
    return false;
}
function $8ee68aba1ccc2662$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($8ee68aba1ccc2662$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $8ee68aba1ccc2662$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}

});

parcelRegister("71beM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51c157ef7769c477$export$2e2bcd8739ae039; });

var $eD1QA = parcelRequire("eD1QA");

var $lK3Fw = parcelRequire("lK3Fw");

var $9ixpP = parcelRequire("9ixpP");
class $51c157ef7769c477$var$Uploader extends (0, $9ixpP.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$51c157ef7769c477$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $lK3Fw.default).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $lK3Fw.default).sources.SILENT);
        });
    }
};
var $51c157ef7769c477$export$2e2bcd8739ae039 = $51c157ef7769c477$var$Uploader;

});

parcelRegister("8oCDW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61ce8a5a28998b48$export$2e2bcd8739ae039; });

var $eD1QA = parcelRequire("eD1QA");

var $9ixpP = parcelRequire("9ixpP");

var $1coM0 = parcelRequire("1coM0");

var $kZq8S = parcelRequire("kZq8S");
const $61ce8a5a28998b48$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $61ce8a5a28998b48$var$Input extends (0, $9ixpP.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $1coM0.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $kZq8S.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index).insert(text, formats), (0, $1coM0.default).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $1coM0.default).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$61ce8a5a28998b48$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $61ce8a5a28998b48$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $61ce8a5a28998b48$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $61ce8a5a28998b48$export$2e2bcd8739ae039 = $61ce8a5a28998b48$var$Input;

});

parcelRegister("gNHrB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b2ec0e9c875497$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");

var $9ixpP = parcelRequire("9ixpP");

var $1coM0 = parcelRequire("1coM0");
const $c3b2ec0e9c875497$var$isMac = /Mac/i.test(navigator.platform);
const $c3b2ec0e9c875497$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $c3b2ec0e9c875497$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($c3b2ec0e9c875497$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $c3b2ec0e9c875497$var$UINode extends (0, $9ixpP.default) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $9uxoP.ParentBlot)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $1coM0.default).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $c3b2ec0e9c875497$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $c3b2ec0e9c875497$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $9uxoP.ParentBlot)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $c3b2ec0e9c875497$export$2e2bcd8739ae039 = $c3b2ec0e9c875497$var$UINode;

});


parcelRegister("2FTCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f2a8e914162690b$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");
class $1f2a8e914162690b$var$IndentAttributor extends (0, $9uxoP.ClassAttributor) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $1f2a8e914162690b$var$IndentClass = new $1f2a8e914162690b$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $9uxoP.Scope).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $1f2a8e914162690b$export$2e2bcd8739ae039 = $1f2a8e914162690b$var$IndentClass;

});

parcelRegister("5rhwP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f5d12236127bb8f$export$2e2bcd8739ae039; });

var $eT6zx = parcelRequire("eT6zx");
class $3f5d12236127bb8f$var$Blockquote extends (0, $eT6zx.default) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $3f5d12236127bb8f$export$2e2bcd8739ae039 = $3f5d12236127bb8f$var$Blockquote;

});

parcelRegister("gaO49", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc646a90badfd4bb$export$2e2bcd8739ae039; });

var $eT6zx = parcelRequire("eT6zx");
class $bc646a90badfd4bb$var$Header extends (0, $eT6zx.default) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $bc646a90badfd4bb$export$2e2bcd8739ae039 = $bc646a90badfd4bb$var$Header;

});

parcelRegister("dAjLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e3df7459c9a1944$export$2e2bcd8739ae039; });

var $eT6zx = parcelRequire("eT6zx");

var $faDi5 = parcelRequire("faDi5");

var $1coM0 = parcelRequire("1coM0");
class $9e3df7459c9a1944$export$122a2a667e12876b extends (0, $faDi5.default) {
}
$9e3df7459c9a1944$export$122a2a667e12876b.blotName = 'list-container';
$9e3df7459c9a1944$export$122a2a667e12876b.tagName = 'OL';
class $9e3df7459c9a1944$export$2e2bcd8739ae039 extends (0, $eT6zx.default) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $1coM0.default).register($9e3df7459c9a1944$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$9e3df7459c9a1944$export$2e2bcd8739ae039.blotName = 'list';
$9e3df7459c9a1944$export$2e2bcd8739ae039.tagName = 'LI';
$9e3df7459c9a1944$export$122a2a667e12876b.allowedChildren = [
    $9e3df7459c9a1944$export$2e2bcd8739ae039
];
$9e3df7459c9a1944$export$2e2bcd8739ae039.requiredContainer = $9e3df7459c9a1944$export$122a2a667e12876b;

});

parcelRegister("aw1MP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a7e474f437b6fa2$export$2e2bcd8739ae039; });

var $i9ca8 = parcelRequire("i9ca8");
class $7a7e474f437b6fa2$var$Bold extends (0, $i9ca8.default) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $7a7e474f437b6fa2$export$2e2bcd8739ae039 = $7a7e474f437b6fa2$var$Bold;

});

parcelRegister("k1Wht", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9511bfbd8325a34$export$2e2bcd8739ae039; });

var $aw1MP = parcelRequire("aw1MP");
class $e9511bfbd8325a34$var$Italic extends (0, $aw1MP.default) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $e9511bfbd8325a34$export$2e2bcd8739ae039 = $e9511bfbd8325a34$var$Italic;

});

parcelRegister("EBaVF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a092c6cf81c146$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sanitize", function () { return $07a092c6cf81c146$export$83d2e9e3e4ee39ed; });

var $i9ca8 = parcelRequire("i9ca8");
class $07a092c6cf81c146$export$2e2bcd8739ae039 extends (0, $i9ca8.default) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $07a092c6cf81c146$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $07a092c6cf81c146$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}

});

parcelRegister("NPXJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $095ce261fca6d2bb$export$2e2bcd8739ae039; });

var $i9ca8 = parcelRequire("i9ca8");
class $095ce261fca6d2bb$var$Script extends (0, $i9ca8.default) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $095ce261fca6d2bb$export$2e2bcd8739ae039 = $095ce261fca6d2bb$var$Script;

});

parcelRegister("fOmah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b82cb801aa9ec738$export$2e2bcd8739ae039; });

var $aw1MP = parcelRequire("aw1MP");
class $b82cb801aa9ec738$var$Strike extends (0, $aw1MP.default) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $b82cb801aa9ec738$export$2e2bcd8739ae039 = $b82cb801aa9ec738$var$Strike;

});

parcelRegister("iDTEz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9270a22d9555db4$export$2e2bcd8739ae039; });

var $i9ca8 = parcelRequire("i9ca8");
class $d9270a22d9555db4$var$Underline extends (0, $i9ca8.default) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $d9270a22d9555db4$export$2e2bcd8739ae039 = $d9270a22d9555db4$var$Underline;

});

parcelRegister("lRuiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fea60ceeac7c4747$export$2e2bcd8739ae039; });

var $2v3kg = parcelRequire("2v3kg");
class $fea60ceeac7c4747$var$Formula extends (0, $2v3kg.default) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $fea60ceeac7c4747$export$2e2bcd8739ae039 = $fea60ceeac7c4747$var$Formula;

});

parcelRegister("ho0yq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca851b9e77986bc1$export$2e2bcd8739ae039; });

var $9uxoP = parcelRequire("9uxoP");

var $EBaVF = parcelRequire("EBaVF");
const $ca851b9e77986bc1$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $ca851b9e77986bc1$var$Image extends (0, $9uxoP.EmbedBlot) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $ca851b9e77986bc1$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $EBaVF.sanitize)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($ca851b9e77986bc1$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $ca851b9e77986bc1$export$2e2bcd8739ae039 = $ca851b9e77986bc1$var$Image;

});

parcelRegister("bg1an", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $832217f47a7473c6$export$2e2bcd8739ae039; });

var $eT6zx = parcelRequire("eT6zx");

var $EBaVF = parcelRequire("EBaVF");
const $832217f47a7473c6$var$ATTRIBUTES = [
    'height',
    'width'
];
class $832217f47a7473c6$var$Video extends (0, $eT6zx.BlockEmbed) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $832217f47a7473c6$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $EBaVF.default).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($832217f47a7473c6$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $832217f47a7473c6$export$2e2bcd8739ae039 = $832217f47a7473c6$var$Video;

});

parcelRegister("cRYaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95e91ced9e483bc6$export$2e2bcd8739ae039; });

var $eD1QA = parcelRequire("eD1QA");

var $9uxoP = parcelRequire("9uxoP");

var $i9ca8 = parcelRequire("i9ca8");

var $1coM0 = parcelRequire("1coM0");

var $9ixpP = parcelRequire("9ixpP");

var $eT6zx = parcelRequire("eT6zx");

var $aA0eA = parcelRequire("aA0eA");

var $i4Ja5 = parcelRequire("i4Ja5");

var $1oJfc = parcelRequire("1oJfc");

var $kIiEv = parcelRequire("kIiEv");

var $eKsv8 = parcelRequire("eKsv8");
const $95e91ced9e483bc6$var$TokenAttributor = new (0, $9uxoP.ClassAttributor)('code-token', 'hljs', {
    scope: (0, $9uxoP.Scope).INLINE
});
class $95e91ced9e483bc6$export$9460eee64f276be7 extends (0, $i9ca8.default) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $kIiEv.default).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $95e91ced9e483bc6$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $95e91ced9e483bc6$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $95e91ced9e483bc6$var$TokenAttributor.add(this.domNode, value);
        else {
            $95e91ced9e483bc6$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$95e91ced9e483bc6$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$95e91ced9e483bc6$export$9460eee64f276be7.blotName = 'code-token';
$95e91ced9e483bc6$export$9460eee64f276be7.className = 'ql-token';
class $95e91ced9e483bc6$export$6c415d1fdae3dfdb extends (0, $kIiEv.default) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $95e91ced9e483bc6$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $95e91ced9e483bc6$var$SyntaxCodeBlockContainer extends (0, $kIiEv.CodeBlockContainer) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $95e91ced9e483bc6$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $95e91ced9e483bc6$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $95e91ced9e483bc6$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $eT6zx.blockDelta)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $95e91ced9e483bc6$export$6c415d1fdae3dfdb.blotName,
                            $95e91ced9e483bc6$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $95e91ced9e483bc6$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $1oJfc.escapeText)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $95e91ced9e483bc6$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$95e91ced9e483bc6$var$SyntaxCodeBlockContainer.allowedChildren = [
    $95e91ced9e483bc6$export$6c415d1fdae3dfdb
];
$95e91ced9e483bc6$export$6c415d1fdae3dfdb.requiredContainer = $95e91ced9e483bc6$var$SyntaxCodeBlockContainer;
$95e91ced9e483bc6$export$6c415d1fdae3dfdb.allowedChildren = [
    $95e91ced9e483bc6$export$9460eee64f276be7,
    (0, $i4Ja5.default),
    (0, $1oJfc.default),
    (0, $aA0eA.default)
];
const $95e91ced9e483bc6$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $95e91ced9e483bc6$export$2e2bcd8739ae039 extends (0, $9ixpP.default) {
    static register() {
        (0, $1coM0.default).register($95e91ced9e483bc6$export$9460eee64f276be7, true);
        (0, $1coM0.default).register($95e91ced9e483bc6$export$6c415d1fdae3dfdb, true);
        (0, $1coM0.default).register($95e91ced9e483bc6$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $1coM0.default).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $95e91ced9e483bc6$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($95e91ced9e483bc6$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $95e91ced9e483bc6$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $1coM0.default).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $1coM0.default).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($95e91ced9e483bc6$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $1coM0.default).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $1coM0.default).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $1oJfc.escapeText)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $kIiEv.default).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $kIiEv.default).className);
        container.innerHTML = $95e91ced9e483bc6$var$highlight(this.options.hljs, language, text);
        return (0, $eKsv8.traverse)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $95e91ced9e483bc6$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(delta.length(), {
                    [$95e91ced9e483bc6$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $kIiEv.default).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$95e91ced9e483bc6$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};

});

parcelRegister("fWPEs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9c456b2ed84caf3$export$2e2bcd8739ae039; });

var $eD1QA = parcelRequire("eD1QA");

var $1coM0 = parcelRequire("1coM0");

var $9ixpP = parcelRequire("9ixpP");

var $k8CNS = parcelRequire("k8CNS");
class $b9c456b2ed84caf3$var$Table extends (0, $9ixpP.default) {
    static register() {
        (0, $1coM0.default).register((0, $k8CNS.TableCell));
        (0, $1coM0.default).register((0, $k8CNS.TableRow));
        (0, $1coM0.default).register((0, $k8CNS.TableBody));
        (0, $1coM0.default).register((0, $k8CNS.TableContainer));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $k8CNS.TableContainer)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $1coM0.default).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $1coM0.default).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $1coM0.default).sources.USER);
        this.quill.setSelection(offset, (0, $1coM0.default).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $k8CNS.TableCell).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $1coM0.default).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $1coM0.default).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $1coM0.default).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $1coM0.default).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $1coM0.default).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $k8CNS.tableId)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))().retain(range.index));
        this.quill.updateContents(delta, (0, $1coM0.default).sources.USER);
        this.quill.setSelection(range.index, (0, $1coM0.default).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $1coM0.default).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $1coM0.default).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $1coM0.default).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $b9c456b2ed84caf3$export$2e2bcd8739ae039 = $b9c456b2ed84caf3$var$Table;

});
parcelRegister("k8CNS", function(module, exports) {

$parcel$export(module.exports, "TableCell", function () { return $ea92a78d70f191b7$export$1e4baea7053fc0e3; });
$parcel$export(module.exports, "tableId", function () { return $ea92a78d70f191b7$export$9bd6f73cbe857f1b; });
$parcel$export(module.exports, "TableRow", function () { return $ea92a78d70f191b7$export$b05581f4e764e162; });
$parcel$export(module.exports, "TableBody", function () { return $ea92a78d70f191b7$export$76ccd210b9029917; });
$parcel$export(module.exports, "TableContainer", function () { return $ea92a78d70f191b7$export$f2c3aea42b2a048f; });

var $eT6zx = parcelRequire("eT6zx");

var $faDi5 = parcelRequire("faDi5");
class $ea92a78d70f191b7$export$1e4baea7053fc0e3 extends (0, $eT6zx.default) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $ea92a78d70f191b7$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $ea92a78d70f191b7$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $ea92a78d70f191b7$export$b05581f4e764e162 extends (0, $faDi5.default) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $ea92a78d70f191b7$export$76ccd210b9029917 extends (0, $faDi5.default) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $ea92a78d70f191b7$export$f2c3aea42b2a048f extends (0, $faDi5.default) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($ea92a78d70f191b7$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $ea92a78d70f191b7$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($ea92a78d70f191b7$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($ea92a78d70f191b7$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($ea92a78d70f191b7$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $ea92a78d70f191b7$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($ea92a78d70f191b7$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($ea92a78d70f191b7$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $ea92a78d70f191b7$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($ea92a78d70f191b7$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($ea92a78d70f191b7$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$ea92a78d70f191b7$export$f2c3aea42b2a048f.allowedChildren = [
    $ea92a78d70f191b7$export$76ccd210b9029917
];
$ea92a78d70f191b7$export$76ccd210b9029917.requiredContainer = $ea92a78d70f191b7$export$f2c3aea42b2a048f;
$ea92a78d70f191b7$export$76ccd210b9029917.allowedChildren = [
    $ea92a78d70f191b7$export$b05581f4e764e162
];
$ea92a78d70f191b7$export$b05581f4e764e162.requiredContainer = $ea92a78d70f191b7$export$76ccd210b9029917;
$ea92a78d70f191b7$export$b05581f4e764e162.allowedChildren = [
    $ea92a78d70f191b7$export$1e4baea7053fc0e3
];
$ea92a78d70f191b7$export$1e4baea7053fc0e3.requiredContainer = $ea92a78d70f191b7$export$b05581f4e764e162;
function $ea92a78d70f191b7$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}

});


parcelRegister("jkw9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e128d2d528663507$export$2e2bcd8739ae039; });

var $eD1QA = parcelRequire("eD1QA");

var $9uxoP = parcelRequire("9uxoP");

var $1coM0 = parcelRequire("1coM0");

var $6frwg = parcelRequire("6frwg");

var $9ixpP = parcelRequire("9ixpP");
const $e128d2d528663507$var$debug = (0, $6frwg.default)('quill:toolbar');
class $e128d2d528663507$export$2e2bcd8739ae039 extends (0, $9ixpP.default) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $e128d2d528663507$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $e128d2d528663507$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $1coM0.default).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $e128d2d528663507$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $9uxoP.EmbedBlot)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($eD1QA)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $1coM0.default).sources.USER);
            } else this.quill.format(format, value, (0, $1coM0.default).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$e128d2d528663507$export$2e2bcd8739ae039.DEFAULTS = {};
function $e128d2d528663507$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $e128d2d528663507$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $e128d2d528663507$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $e128d2d528663507$var$addSelect(group, format, value);
                else $e128d2d528663507$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $e128d2d528663507$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$e128d2d528663507$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $9uxoP.Scope).INLINE) != null) this.quill.format(name, false, (0, $1coM0.default).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $1coM0.default).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $1coM0.default).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $1coM0.default).sources.USER);
            this.quill.format('direction', value, (0, $1coM0.default).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $1coM0.default).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $1coM0.default).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $1coM0.default).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $1coM0.default).sources.USER);
            } else this.quill.format('list', value, (0, $1coM0.default).sources.USER);
        }
    }
};

});

parcelRegister("ghSE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdb89f2579c846b6$export$2e2bcd8739ae039; });
const $bdb89f2579c846b6$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $bdb89f2579c846b6$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $bdb89f2579c846b6$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $bdb89f2579c846b6$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $bdb89f2579c846b6$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $bdb89f2579c846b6$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $bdb89f2579c846b6$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $bdb89f2579c846b6$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $bdb89f2579c846b6$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $bdb89f2579c846b6$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $bdb89f2579c846b6$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $bdb89f2579c846b6$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $bdb89f2579c846b6$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $bdb89f2579c846b6$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $bdb89f2579c846b6$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $bdb89f2579c846b6$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $bdb89f2579c846b6$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $bdb89f2579c846b6$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $bdb89f2579c846b6$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $bdb89f2579c846b6$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $bdb89f2579c846b6$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $bdb89f2579c846b6$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $bdb89f2579c846b6$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $bdb89f2579c846b6$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $bdb89f2579c846b6$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $bdb89f2579c846b6$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $bdb89f2579c846b6$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $bdb89f2579c846b6$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $bdb89f2579c846b6$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $bdb89f2579c846b6$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $bdb89f2579c846b6$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $bdb89f2579c846b6$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $bdb89f2579c846b6$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $bdb89f2579c846b6$export$2e2bcd8739ae039 = {
    align: {
        '': $bdb89f2579c846b6$var$alignLeftIcon,
        center: $bdb89f2579c846b6$var$alignCenterIcon,
        right: $bdb89f2579c846b6$var$alignRightIcon,
        justify: $bdb89f2579c846b6$var$alignJustifyIcon
    },
    background: $bdb89f2579c846b6$var$backgroundIcon,
    blockquote: $bdb89f2579c846b6$var$blockquoteIcon,
    bold: $bdb89f2579c846b6$var$boldIcon,
    clean: $bdb89f2579c846b6$var$cleanIcon,
    code: $bdb89f2579c846b6$var$codeIcon,
    'code-block': $bdb89f2579c846b6$var$codeIcon,
    color: $bdb89f2579c846b6$var$colorIcon,
    direction: {
        '': $bdb89f2579c846b6$var$directionLeftToRightIcon,
        rtl: $bdb89f2579c846b6$var$directionRightToLeftIcon
    },
    formula: $bdb89f2579c846b6$var$formulaIcon,
    header: {
        '1': $bdb89f2579c846b6$var$headerIcon,
        '2': $bdb89f2579c846b6$var$header2Icon,
        '3': $bdb89f2579c846b6$var$header3Icon,
        '4': $bdb89f2579c846b6$var$header4Icon,
        '5': $bdb89f2579c846b6$var$header5Icon,
        '6': $bdb89f2579c846b6$var$header6Icon
    },
    italic: $bdb89f2579c846b6$var$italicIcon,
    image: $bdb89f2579c846b6$var$imageIcon,
    indent: {
        '+1': $bdb89f2579c846b6$var$indentIcon,
        '-1': $bdb89f2579c846b6$var$outdentIcon
    },
    link: $bdb89f2579c846b6$var$linkIcon,
    list: {
        bullet: $bdb89f2579c846b6$var$listBulletIcon,
        check: $bdb89f2579c846b6$var$listCheckIcon,
        ordered: $bdb89f2579c846b6$var$listOrderedIcon
    },
    script: {
        sub: $bdb89f2579c846b6$var$subscriptIcon,
        super: $bdb89f2579c846b6$var$superscriptIcon
    },
    strike: $bdb89f2579c846b6$var$strikeIcon,
    table: $bdb89f2579c846b6$var$tableIcon,
    underline: $bdb89f2579c846b6$var$underlineIcon,
    video: $bdb89f2579c846b6$var$videoIcon
};

});

parcelRegister("6A024", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca62152037b44ae$export$2e2bcd8739ae039; });
const $4ca62152037b44ae$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $4ca62152037b44ae$var$optionsCounter = 0;
function $4ca62152037b44ae$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $4ca62152037b44ae$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $4ca62152037b44ae$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $4ca62152037b44ae$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $4ca62152037b44ae$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$4ca62152037b44ae$var$optionsCounter}`;
        $4ca62152037b44ae$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $4ca62152037b44ae$export$2e2bcd8739ae039 = $4ca62152037b44ae$var$Picker;

});

parcelRegister("gi9MJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc5eae118ad1a63$export$2e2bcd8739ae039; });

var $6A024 = parcelRequire("6A024");
class $bdc5eae118ad1a63$var$ColorPicker extends (0, $6A024.default) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $bdc5eae118ad1a63$export$2e2bcd8739ae039 = $bdc5eae118ad1a63$var$ColorPicker;

});

parcelRegister("iXNXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dce47e24cbb6ce2e$export$2e2bcd8739ae039; });

var $6A024 = parcelRequire("6A024");
class $dce47e24cbb6ce2e$var$IconPicker extends (0, $6A024.default) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $dce47e24cbb6ce2e$export$2e2bcd8739ae039 = $dce47e24cbb6ce2e$var$IconPicker;

});

parcelRegister("8q2LS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6212e6b7849117c1$export$2e2bcd8739ae039; });
const $6212e6b7849117c1$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $6212e6b7849117c1$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($6212e6b7849117c1$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $6212e6b7849117c1$export$2e2bcd8739ae039 = $6212e6b7849117c1$var$Tooltip;

});

parcelRegister("e7EBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a48138320801c330$export$2e2bcd8739ae039; });

var $h21cN = parcelRequire("h21cN");

var $lK3Fw = parcelRequire("lK3Fw");

var $6wXO5 = parcelRequire("6wXO5");

var $36WOi = parcelRequire("36WOi");

var $ghSE1 = parcelRequire("ghSE1");

var $1coM0 = parcelRequire("1coM0");
const $a48138320801c330$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $a48138320801c330$export$572b56f7a5e9813a extends (0, $6wXO5.BaseTooltip) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $lK3Fw.default).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $lK3Fw.default).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $lK3Fw.default).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $36WOi.Range)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $lK3Fw.default).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $a48138320801c330$export$2e2bcd8739ae039 extends (0, $6wXO5.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $a48138320801c330$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $a48138320801c330$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $ghSE1.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $ghSE1.default));
        }
    }
}
$a48138320801c330$export$2e2bcd8739ae039.DEFAULTS = (0, $h21cN.default)({}, (0, $6wXO5.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $1coM0.default).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});

});
parcelRegister("6wXO5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c141fa579ca4a9e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BaseTooltip", function () { return $4c141fa579ca4a9e$export$ba0102162f9e195c; });

var $h21cN = parcelRequire("h21cN");

var $lK3Fw = parcelRequire("lK3Fw");

var $bzBuA = parcelRequire("bzBuA");

var $gi9MJ = parcelRequire("gi9MJ");

var $iXNXI = parcelRequire("iXNXI");

var $6A024 = parcelRequire("6A024");

var $8q2LS = parcelRequire("8q2LS");
const $4c141fa579ca4a9e$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $4c141fa579ca4a9e$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $4c141fa579ca4a9e$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $4c141fa579ca4a9e$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $4c141fa579ca4a9e$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $4c141fa579ca4a9e$export$2e2bcd8739ae039 extends (0, $bzBuA.default) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $4c141fa579ca4a9e$var$fillSelect(select, $4c141fa579ca4a9e$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $iXNXI.default)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $4c141fa579ca4a9e$var$fillSelect(select, $4c141fa579ca4a9e$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $gi9MJ.default)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $4c141fa579ca4a9e$var$fillSelect(select, $4c141fa579ca4a9e$var$FONTS);
                else if (select.classList.contains('ql-header')) $4c141fa579ca4a9e$var$fillSelect(select, $4c141fa579ca4a9e$var$HEADERS);
                else if (select.classList.contains('ql-size')) $4c141fa579ca4a9e$var$fillSelect(select, $4c141fa579ca4a9e$var$SIZES);
            }
            return new (0, $6A024.default)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $lK3Fw.default).events.EDITOR_CHANGE, update);
    }
}
$4c141fa579ca4a9e$export$2e2bcd8739ae039.DEFAULTS = (0, $h21cN.default)({}, (0, $bzBuA.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $4c141fa579ca4a9e$export$ba0102162f9e195c extends (0, $8q2LS.default) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $lK3Fw.default).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $lK3Fw.default).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $4c141fa579ca4a9e$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $lK3Fw.default).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $lK3Fw.default).sources.USER);
                        this.quill.setSelection(index + 2, (0, $lK3Fw.default).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $4c141fa579ca4a9e$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $4c141fa579ca4a9e$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}

});


parcelRegister("8JDEJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01a42658f8a9a67e$export$2e2bcd8739ae039; });

var $h21cN = parcelRequire("h21cN");

var $lK3Fw = parcelRequire("lK3Fw");

var $6wXO5 = parcelRequire("6wXO5");

var $EBaVF = parcelRequire("EBaVF");

var $36WOi = parcelRequire("36WOi");

var $ghSE1 = parcelRequire("ghSE1");

var $1coM0 = parcelRequire("1coM0");
const $01a42658f8a9a67e$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $01a42658f8a9a67e$var$SnowTooltip extends (0, $6wXO5.BaseTooltip) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $lK3Fw.default).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $lK3Fw.default).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $lK3Fw.default).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $EBaVF.default), range.index);
                if (link != null) {
                    this.linkRange = new (0, $36WOi.Range)(range.index - offset, link.length());
                    const preview = (0, $EBaVF.default).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $01a42658f8a9a67e$var$SnowTheme extends (0, $6wXO5.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $01a42658f8a9a67e$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $ghSE1.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $ghSE1.default));
            // @ts-expect-error
            this.tooltip = new $01a42658f8a9a67e$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$01a42658f8a9a67e$var$SnowTheme.DEFAULTS = (0, $h21cN.default)({}, (0, $6wXO5.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $1coM0.default).sources.USER);
                }
            }
        }
    }
});
var $01a42658f8a9a67e$export$2e2bcd8739ae039 = $01a42658f8a9a67e$var$SnowTheme;

});



parcelRegister("23ZM6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $180bc7cc23b5edcb$export$2e2bcd8739ae039; });
var $180bc7cc23b5edcb$export$2e2bcd8739ae039 = {
    props: [
        'clienteAtivo',
        'setPolitica',
        'patrimonio',
        'isFundacao',
        'consultorias',
        'dataAtualCarteira',
        'options'
    ],
    emits: [
        'openModal',
        'openModalRemoveQuente',
        'change-select'
    ],
    data () {
        return {
            labels: ''
        };
    },
    methods: {
        openModal () {
            this.$emit('openModal');
        },
        openModalRemoveQuente () {
            this.$emit('openModalRemoveQuente', this.clienteAtivo);
        },
        dateFormated (date) {
            return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        },
        showLabels () {
            clienteAtivo.consultoria || clienteAtivo.gestao || clienteAtivo.distribuicao;
        }
    },
    watch: {
        clienteAtivo: {
            handler (newValue, oldValue) {
                //	console.log('CLIENTE ATIVASSSOO', newValue)
                const { distribuicao: distribuicao, gestao: gestao, consultoria: consultoria } = newValue;
                const obj = {
                    distribuicao: distribuicao,
                    gestao: gestao,
                    consultoria: consultoria
                };
                let objReferencia = {
                    gestao: "Gest\xe3o",
                    distribuicao: "Distribui\xe7\xe3o",
                    consultoria: 'Consultoria'
                };
                let arr = Object.entries(obj).filter(([key, val])=>val).map(([key, val])=>objReferencia[key]);
                if (!arr.length) return;
                let result = arr.join(', ');
                if (arr.length > 2) {
                    let position = String(result).lastIndexOf(',');
                    result = result.substring(0, position) + ' e' + result.substring(position + 1);
                }
                this.labels = result;
            },
            deep: true
        }
    },
    template: /* html */ `
			<div>
				<div class="flex flex-wrap items-center gap-8 mb-16 text-xs text-neutral-100" v-if="!isFundacao">
						<span class="badge badge-mini text-xs">
							{{ setPolitica(clienteAtivo.politica) }}
						</span>

						<span v-show="clienteAtivo.estado_sigla" class="flex gap-4 items-center">
							<svg class="h-20 w-20">
								<use xlink:href="#icon_mapa"></use>
							</svg>
							{{ clienteAtivo.estado_sigla }}
						</span>

						<div v-if="clienteAtivo.consultoria_id && isFundacao" class="inline-flex items-center gap-4 text-xs text-neutral-100">
							
									<svg class="w-24 h-24" style="--icon-color: #C11F39">
										<use xlink:href="#icon_pessoa_fisica"></use>
									</svg>
								
							<p>{{ consultorias.find(consultoria => consultoria.id === clienteAtivo.consultoria_id).nome }}</p>
						</div>

						<div class="inline-flex items-center gap-4 text-xs text-neutral-100" v-show="!isFundacao">
							<p>PLE:</p>
							<span class="badge badge-mini">
								R$  {{ !patrimonio || patrimonio == "0,00"  ?  "-" : patrimonio }}
							</span>
						</div>

						<!-- <button v-show="!clienteAtivo.atendimento_quente" type="button" class="py-4 px-8 mt-4 text-neutral-80 font-medium inline-flex items-center gap-4 transition-colors w-max rounded-md border border-neutral-50 hover:text-primary-pure hover:bg-primary-pure/10 hover:border-primary-pure group shrink-0"  @click="openModal">
							<svg class=" w-14 h-18 group-hover:hidden"><use xlink:href="#icon_fire_outline"></use></svg>
							<svg class=" w-14 h-18  hidden group-hover:!block "><use xlink:href="#icon_fire_filled"></use></svg>
							Atendimento quente
						</button>

						<button v-show="clienteAtivo.atendimento_quente" type="button" class="btn-remove-quente py-4 px-8 font-medium inline-flex items-center gap-4 transition-colors w-max rounded-md border  text-primary-pure bg-primary-pure/10 border-primary-pure shrink-0"  @click="openModalRemoveQuente">
							<svg class=" w-14 h-18 "><use xlink:href="#icon_fire_filled"></use></svg>
							Atendimento quente
						</button> -->

						<div v-if="clienteAtivo.data_nascimento" class="inline-flex items-center gap-4 text-xs text-neutral-100"  v-show="!isFundacao">
							
								<svg class="w-20 h-20" style="--icon-color: #C11F39">
									<use xlink:href="#icon_agenda"></use>
								</svg>
							
							<p>{{clienteAtivo.idade}} Anos - {{ dateFormated(clienteAtivo.data_nascimento) }}</p>
						</div>

						<div v-if="clienteAtivo.gestao || clienteAtivo.consultoria || clienteAtivo.distribuicao" class="inline-flex items-center gap-4 text-xs text-neutral-100"  v-show="!isFundacao">
						
							<svg class="w-20 h-20" style="--icon-color: #C11F39">
								<use xlink:href="#icon_consultoria"></use>
							</svg>
							<p>{{labels}}</p>
						</div>
						
						
						<div v-if="clienteAtivo.taxa && (clienteAtivo.gestao || clienteAtivo.consultoria || clienteAtivo.distribuicao)" class="inline-flex items-center gap-4 text-xs text-neutral-100"  v-show="!isFundacao">
							<svg class="w-20 h-20" style="--icon-color: #C11F39">
								<use xlink:href="#icon_taxa"></use>
							</svg>
							<p>{{clienteAtivo.taxa}}%</p>
						</div>
						
						<div  class="select-container select-status !h-32 items-center gap-4 !text-xs text-neutral-100"  v-show="!isFundacao">
								<select  @change="(e) => $emit('change-select', e)" class="!text-xs" js-choices  name="status" id="status-modal-select" js-choices-props='{"searchEnabled": true, "searchChoices": true}'>
										<option class="!text-xs" value="" selected>Selecione um status</option>
										<option class="!text-xs" :key="opt.value" :value="opt.value" v-for="opt in options">{{opt.label}}</option>
								</select>
						</div>
				</div>

				<div class="flex items-center justify-between gap-8">	
					<p class="flex items-center gap-6 text-sm neutral-100">
						<svg class="h-20 w-20 shrink-0" v-if="!isFundacao && clienteAtivo.sigla ">
							<use xlink:href="#icon_person_2"></use>
						</svg>
						
						<svg v-else-if="isFundacao && clienteAtivo.sigla" class="w-[20px] h-[20px] shrink-0" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6.66602 17.5028V3.33026C6.66602 2.86983 7.03927 2.49658 7.4997 2.49658H12.5018C12.9622 2.49658 13.3355 2.86983 13.3355 3.33026V17.5028" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M17.5034 17.5031V6.59269C17.5034 6.17232 17.1626 5.83154 16.7422 5.83154H13.335" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M6.66547 5.83154H3.25822C2.83785 5.83154 2.49707 6.17232 2.49707 6.59269V17.5031" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M13.335 8.33237H15.4192" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M13.335 10.8333H15.4192" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M13.335 13.3343H15.4192" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M4.58105 8.33237H6.66526" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M4.58105 10.8333H6.66526" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M4.58105 13.3343H6.66526" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M8.75 10.8333H11.251" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M8.75 13.3343H11.251" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M8.75 8.33237H11.251" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M8.75 5.83139H11.251" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M9.99985 15.8354V17.5028" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M18.3367 17.5028H1.66309" stroke="#003769" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
						{{ clienteAtivo.sigla }}
					</p>
				</div>
	`
};

});

parcelRegister("8t0Yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62a1c93db33eed37$export$2e2bcd8739ae039; });
const { initChoices: $62a1c93db33eed37$var$initChoices, setValueInChoices: $62a1c93db33eed37$var$setValueInChoices, getChoicesActive: $62a1c93db33eed37$var$getChoicesActive, FormatREAL: $62a1c93db33eed37$var$FormatREAL, showToastify: $62a1c93db33eed37$var$showToastify, estadosBR: $62a1c93db33eed37$var$estadosBR } = GLOBAL;
var $62a1c93db33eed37$export$2e2bcd8739ae039 = {
    props: [
        'clienteAtivo',
        'setPolitica',
        'politicasArr',
        'patrimonio',
        'isFundacao',
        'consultorias',
        'alterarSobre'
    ],
    data () {
        return {
            modelValue: {},
            counter: 0,
            estados: $62a1c93db33eed37$var$estadosBR,
            taxaDisabled: false,
            consultoriasArr: []
        };
    },
    methods: {
        handleChange (event) {
            const form = event.currentTarget;
            const field = event.target;
            const checkbox = field.classList.contains('checkInput');
            this.modelValue[field.name] = checkbox ? field.checked : field.value;
        //	console.log(this.modelValue);
        //faer verificaçao para checkbox
        },
        onlyNumbers (e) {
            e.target.value = String(e.target.value).replace(/[A-Za-z]/g, '');
        },
        initLabs () {
            const inputDate = document.getElementById('user-edit-input-date');
            GLOBAL.initFlatpickr(inputDate, {
                altInput: true,
                dateFormat: 'YYYY-MM-DD',
                altFormat: 'DD-MM-YYYY',
                allowInput: false,
                parseDate: (datestr, format)=>{
                    return moment(datestr, format, true).toDate();
                },
                formatDate: (date, format, locale)=>{
                    // locale can also be used
                    return moment(date).format(format);
                }
            });
        },
        dataFormated (data) {
            // console.log(data, moment(data, "YYYY-MM-DD").format("DD/MM/YYYY"), moment(data, "YYYY-MM-DD").toDate());
            return data;
        },
        clearEqualZero (e, name) {
            //console.log(e.target, e);
            if (this.clienteAtivo[name] <= 0 && e.target.value <= 0) e.target.value = '';
        // if(patrimonio <= 0){
        // 	console.log(patrimonio);
        // }
        },
        handleChangeTaxa (e) {
            //console.log(e, 'e')
            this.modelValue[e.target.name] = e.target.value;
            if (e.keyCode == 8) return;
            if (Math.abs(e.target.value) > 100) $62a1c93db33eed37$var$showToastify("\u26A0\uFE0F Taxa precisa ser inferior ou igual a 100%", {
                className: 'error'
            });
        }
    },
    updated () {
        this.initLabs();
    },
    mounted () {
        this.initLabs();
    },
    watch: {
        modelValue: {
            handler (newValue, oldValue) {
                if (!this.modelValue.gestao && !this.modelValue.consultoria) {
                    this.modelValue.taxa = '';
                    document.querySelector('#form-sobre input[name="taxa"]').value = '';
                    this.taxaDisabled = true;
                } else this.taxaDisabled = false;
                if (!this.modelValue.data_nascimento) this.modelValue.data_nascimento = null;
                //	console.log("EMIT", this.modelValue);
                //	console.log("NEW MODEL", newValue);
                this.$emit('update-cliente-ativo', this.modelValue);
            },
            deep: true
        },
        clienteAtivo: {
            handler (newValue, oldValue) {
                //	console.log("MODEL", this.clienteAtivo);
                this.modelValue = {
                    ...newValue
                };
            },
            deep: true
        },
        alterarSobre (newValue, oldValue) {
            const el = document.querySelector('#select-consultorias-edicao');
            if (!el) return;
            const choiceStarted = el.getAttribute('data-choice');
            if (newValue) {
                let choices;
                if (!choiceStarted) {
                    choices = $62a1c93db33eed37$var$initChoices(document.querySelector('#select-consultorias-edicao'));
                    window.listOfChoices = [
                        ...window.listOfChoices,
                        choices
                    ];
                }
                const choiceActive = $62a1c93db33eed37$var$getChoicesActive('select-consultorias-edicao', window.listOfChoices);
                const options = this.consultorias.map((consultoria)=>({
                        value: consultoria.id,
                        label: consultoria.nome,
                        selected: this.clienteAtivo.consultoria_id === consultoria.id
                    }));
                options.unshift({
                    value: '',
                    label: 'Selecione uma consultoria',
                    selected: !this.clienteAtivo.consultoria_id
                });
                choiceActive.setChoices(options, 'value', 'label', true);
            }
        }
    },
    template: html`
		<form
			class="grid grid-cols-2 gap-16  overflow-hidden"
			id="form-sobre"
			@change="handleChange">
			<div class="flex flex-col text-sm neutral-10 2xl:col-span-2 ">
				<div class="label-icon w-max">
					<label class="label">Nome</label>
				</div>

				<input
					class="input-text h-48 w-full"
					:class="{ 'hover:!border-transparent focus:!border-transparent !border-transparent cursor-not-allowed'  : isFundacao }"
					:readonly="isFundacao"
					js-ativo
					type="text"
					:value="clienteAtivo.nome"
					name="nome" />
			</div>

			<div class="flex flex-col flex-1">
				<label class="label">Politicas</label>

				<div class="select-container h-48">
					<select
						js-choices
						placeholder="placeholder"
						id="select-politica-edicao"
						name="politica">
						<option
							v-for="politica in politicasArr()"
							key="politica.id"
							:value="politica.id">
							{{ politica.name }}
						</option>
					</select>
				</div>
			</div>

			<div class="flex flex-col flex-1">
				<label class="label">Estado</label>

				<div class="select-container h-48">
					<select
						js-choices
						placeholder="placeholder"
						name="estado_id"
						id="estado-modal-select"
						js-choices-props='{"searchEnabled": true, "searchChoices": true, "position":"bottom"}'>
						<option v-for="estado in estados" :value="estado.id">
							{{estado.nome}}
						</option>
					</select>
				</div>
			</div>

			<div class="flex flex-col flex-1" v-if="isFundacao">
				<label class="label">Consultorias</label>

				<div class="select-container h-48" v-if="consultorias?.length">
					<select
						js-choices
						placeholder="placeholder"
						id="select-consultorias-edicao"
						name="consultoria"></select>
				</div>
			</div>

			<div class="flex flex-col text-sm neutral-100  w-full 2xl:col-span-2 ">
				<div class="label-icon w-max">
					<label v-show="!isFundacao" class="label">PLE </label>
				</div>

				<div
					class="flex items-center gap-16"
					:class="{ '!mt-24'  : isFundacao }">
					<div class="relative w-full h-max" v-show="!isFundacao">
						<p
							class="absolute top-0 bottom-0 my-auto h-max z-[2] text-neutral-70 font-medium text-normal left-8">
							R$
						</p>
						<input
							class="input-text h-48 w-full pl-32"
							data-mask="000.000.000.000.000,00"
							data-mask-reverse="true"
							js-ativo
							type="text"
							@focus="(e) => clearEqualZero(e, 'patrimonio_externo')"
							:value="modelValue.patrimonio_externo"
							name="patrimonio_externo" />
					</div>

					<label
						class="radio-container round size-24  inline-flex items-center font-medium gap-8 cursor-pointer">
						<div class="check-label">
							<input
								type="checkbox"
								name="status"
								class="sr-only checkInput"
								:checked="clienteAtivo.status" />
							<span class="radio-circle">
								<i class="radio-circle-inner"></i>
							</span>
						</div>
						Ativado
					</label>
				</div>
			</div>

			<div class="flex gap-8 justify-between items-center ">
				<div class="flex flex-col 2xl:col-span-2 flex-1">
					<label v-show="!isFundacao" class="label">Offshore</label>
					<div class="flex items-center w-full gap-16">
						<div class="relative w-full h-max" v-show="!isFundacao">
							<p
								class="absolute top-0 bottom-0 my-auto h-max z-[2] text-neutral-70 font-medium text-normal left-8">
								R$
							</p>
							<input
								class="input-text h-48 w-full pl-32"
								data-mask="000.000.000.000.000,00"
								js-ativo
								type="text"
								@focus="(e) => clearEqualZero(e, 'patrimonio_manual')"
								:value="modelValue.patrimonio_manual"
								name="patrimonio_manual" />
						</div>
					</div>
				</div>
				<div class="w-[200px]  flex items-center mt-16">
					<label
						v-show="!isFundacao"
						class="radio-container round size-20 flex-1 inline-flex items-center font-medium gap-8 cursor-pointer">
						<div class="check-label">
							<input
								type="checkbox"
								name="atualizar_automaticamente"
								class="sr-only checkInput"
								:checked="clienteAtivo.atualizar_automaticamente" />
							<span class="radio-circle">
								<i class="radio-circle-inner"></i>
							</span>
						</div>
						Atualização Automática
					</label>
				</div>
			</div>

			<div v-show="!isFundacao" class="flex items-start gap-16  w-full  ">
				<label class="flex-1">
					Data de Nascimento
					<div
						class="flex-1 font-medium text-sm leading-100 text-neutral-70 border border-neutral-30 rounded-md h-max">
						<input
							type="date"
							name="data_nascimento"
							id="user-edit-input-date"
							placeholder="Escolha a data"
							:value="modelValue.data_nascimento ? modelValue.data_nascimento : dataFormated(clienteAtivo.data_nascimento)"
							class="w-full px-10 h-48" />
					</div>
				</label>
			</div>

			<div
				v-show="!isFundacao"
				class="flex gap-16 items-center  col-span-2 w-full">
				<label class="flex-1">
					Profissão
					<input
						class="input-text h-48 w-full "
						js-ativo
						type="text"
						:value="modelValue.profissao"
						name="profissao" />
				</label>
			</div>

			<div v-show="!isFundacao" class="flex  gap-16 items-center  w-full ">
				<label class="flex-1" :class="taxaDisabled ? 'disabled' : ''">
					Taxa de administração (%)
					<input
						class="input-text h-48 w-full"
						@input="onlyNumbers"
						js-ativo
						type="text"
						:value="modelValue.taxa"
						@keyup="handleChangeTaxa"
						name="taxa" />
				</label>
				<label class="flex-1">
					Taxa de performace (%)
					<input
						class="input-text h-48 w-full"
						@input="onlyNumbers"
						js-ativo
						type="text"
						:value="modelValue.taxa_performance"
						@keyup="handleChangeTaxa"
						name="taxa_performance" />
				</label>
			</div>
			<div
				v-show="!isFundacao"
				class="flex flex-1  gap-16 items-center justify-start  w-full ">
				<div
					class="flex gap-8  flex-1 items-center mt-16 flex-col flex-wrap w-full">
					<label
						class="radio-container round size-24 inline-flex items-center font-medium gap-8 cursor-pointer">
						<div class="check-label">
							<input
								type="checkbox"
								name="distribuicao"
								class="sr-only checkInput"
								:checked="clienteAtivo.distribuicao" />
							<span class="radio-circle">
								<i class="radio-circle-inner"></i>
							</span>
						</div>
						Distribuição
					</label>
					<label
						class="radio-container round size-24 inline-flex items-center font-medium gap-8 cursor-pointer">
						<div class="check-label">
							<input
								type="checkbox"
								name="gestao"
								class="sr-only checkInput"
								:checked="clienteAtivo.gestao" />
							<span class="radio-circle">
								<i class="radio-circle-inner"></i>
							</span>
						</div>
						Gestão
					</label>
					<label
						class="radio-container round size-24 inline-flex items-center font-medium gap-8 cursor-pointer">
						<div class="check-label">
							<input
								type="checkbox"
								name="consultoria"
								class="sr-only checkInput"
								:checked="clienteAtivo.consultoria" />
							<span class="radio-circle">
								<i class="radio-circle-inner"></i>
							</span>
						</div>
						Consultoria
					</label>
				</div>
			</div>
		</form>
	`
};

});

parcelRegister("5pg84", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3efbcc771aedb155$export$2e2bcd8739ae039; });
//!!! Cadastrar Atendimento

var $2m7Ys = parcelRequire("2m7Ys");
var $3efbcc771aedb155$export$2e2bcd8739ae039 = {
    props: [
        'atendimento',
        'index',
        'contatos',
        'officer',
        'edite',
        'isFundacaoAtendimento'
    ],
    emits: [
        'update-atendimentos',
        'open-modal-solicitacao'
    ],
    computed: {
        dataAccordion () {
            return `acc-${this.atendimento.id}`;
        }
    },
    data () {
        return {
            officerString: ''
        };
    },
    mounted () {
        this.officerString = this.formatOfficersNames(this.atendimento?.dados_usuario_responsavel);
    /* console.log({atendimento: this.atendimento.atendimento}) */ },
    methods: {
        formatOfficersNames (officers) {
            return officers?.map(({ nome: nome })=>nome.split('.').map((word)=>(0, $2m7Ys.capitalize)(word)).join(' ')).join(', ');
        },
        calculaDiferencaDias (data_criacao) {
            const hoje = new Date();
            const dataCriacao = new Date(data_criacao);
            return Quasar.date.getDateDiff(hoje, dataCriacao, 'days');
        },
        isValidEditAtendimento () {
            let diffDias = this.calculaDiferencaDias(this.atendimento.data_criacao);
            let status = '';
            if (this.atendimento?.status_edicao[0]) {
                const [_status, id] = this.atendimento?.status_edicao[0];
                status = _status;
            }
            if (status === 'Aprovado' || status !== 'Editado' && diffDias <= 30) return true;
            return false;
        },
        openEditAtendimento () {
            if (this.isValidEditAtendimento()) {
                this.$emit('atendimentoData', {
                    ...this.atendimento
                });
                this.$emit('setId', this.atendimento.id);
                this.edite(true);
            } else this.$emit('open-modal-solicitacao', this.atendimento.id, 'edicao');
        },
        dataFormated (data) {
            return data ? moment(data).format('DD/MM/YYYY') : '';
        },
        userFiltrered (userID) {
            const user = todosUsuarios.filter((user)=>user.id == userID);
            return user?.length ? user[0].nome : '';
        },
        nomeContatos (arr) {
            if (!Array.isArray(arr)) return '';
            // const reducecallback = (id) => (acc, i) => {
            // 	if (i.id == id) acc = i.nome
            // 	return acc
            // }
            // return arr.map(id => this.contatos.reduce(reducecallback(id), "")).join(", ")
            return arr.join(', \n');
        },
        getTipo (string) {
            if (!string) return '';
            if (GLOBAL.isFundacao() && this.atendimento.isAtendimentoSequoia) return "Pol\xedtica Sequoia";
            let tipo = String(string).slice('.')[0] || '';
            if (tipo === '0') return "Pol\xedtica de atendimento";
            else if (tipo === '1') return 'Outro';
            return '';
        },
        getNotificacao (string) {
            if (!string) return '';
            else if (string === '0') return 'Risco de reinvestimento';
            else if (string === '1') return "Processo de sele\xe7\xe3o pr\xf3ximo";
            else if (string === '2') return "Sem notifica\xe7\xe3o";
        }
    },
    updated () {
        this.officerString = this.formatOfficersNames(this.atendimento?.dados_usuario_responsavel);
    },
    template: html`
		<div class="item" v-if="atendimento">
			<div
				class="flex gap-8 w-full item-borda border border-transparent transition-[border-color] duration-[750]  rounded overflow-hidden">
				<div class="accordion w-full">
					<div class="accordion-item" js-accordion js-accordion-gsap>
						<div
							class="accordion-title"
							:data-accordion="dataAccordion"
							js-comentario-parent="atendimento-item">
							<span class="text-1-line ">
								{{officerString}} -
								{{dataFormated(atendimento.data_atendimento)}} -
								{{atendimento.titulo_atendimento}}</span
							>
							<svg>
								<use xlink:href="#seta_up"></use>
							</svg>
						</div>

						<div class="accordion-content" :data-accordion="dataAccordion">
							<div class="accordion-container">
								<div class="p-14">
									<div
										class="flex w-full justify-end gap-24 pb-8 items-center "
										:class="{'justify-between': atendimento.status_exclusao?.length > 0 || atendimento.status_edicao?.length > 0}">
										<div class="flex items-center gap-8 w-full">
											<span
												v-for="tag in atendimento.status_exclusao"
												class="badge  !w-max !h-40 items-center "
												:class="tag[0]"
												js-badge>
												{{ tag[0] }} (Exclusão)</span
											>
											<span
												v-for="tag_edicao in atendimento.status_edicao"
												class="badge  !w-max !h-40 items-center "
												:class="tag_edicao[0]"
												js-badge>
												{{ tag_edicao[0] }} (Edição)</span
											>
										</div>
										<div class="flex  gap-4 items-center">
											<button
												v-if="!isFundacaoAtendimento"
												class="btn secondary h-40"
												@click="openEditAtendimento">
												Editar
											</button>
											<button
												v-if="!isFundacaoAtendimento"
												class="btn tertiary p-8  h-40"
												@click="$emit('open-modal-solicitacao', atendimento.id, 'delete')">
												<q-icon
													size="24px"
													name="delete"
													class="cursor-pointer"></q-icon>
											</button>
										</div>
									</div>
									<div
										
										v-html="atendimento.atendimento_html || atendimento.atendimento || atendimento.descricao_atendimento"
										class="text-black text-sm mb-16"></div>

									<hr class="border-neutral-30" />

									<div
										v-show="atendimento.tipo"
										class="flex flex-col gap-4 mt-16">
										<span class="text-neutral-70 text-sm">Tipo</span>
										<span class="text-neutral-90 text-sm"
											>{{getTipo(atendimento.tipo)}}</span
										>
									</div>

									<div
										v-show="atendimento.contato_atendimento"
										class="flex flex-col gap-4 mt-16">
										<span class="text-neutral-70 text-sm">Contato</span>
										<span
											class="text-neutral-90 text-sm"
											style="white-space: break-spaces;"
											>{{nomeContatos(atendimento.contato_atendimento)}}</span
										>
									</div>

									<div
										class="flex flex-col gap-4 mt-16"
										v-show="atendimento.notificacao && atendimento.fundacao_id">
										<span class="text-neutral-70 text-sm">Notificação</span>
										<span class="text-neutral-90 text-sm"
											>{{getNotificacao(atendimento.notificacao)}}</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="avatar !rounded-md">
				<img src="{% static 'front_assets/dist/images/avatar.png' %}" alt="avatar" />
			</div> -->
			</div>
			<div class="flex justify-end w-full mt-8">
				<p class="text-neutral-80 text-xs mr-40">
					{{atendimento.data ? new
					Date(atendimento.data)?.toLocaleDateString('pt-br') : ''}}
				</p>
			</div>
		</div>
	`
};

});

parcelRegister("cqNI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90ce792aab7b2ca5$export$2e2bcd8739ae039; });
var $90ce792aab7b2ca5$export$2e2bcd8739ae039 = {
    props: [
        'editando',
        'isFundacao'
    ],
    data () {
        return {
            novoContatoDados: {
                descricao: '',
                observacoes: ''
            }
        };
    },
    methods: {
        handleChange (event) {
            const target = event?.currentTarget;
            const name = target?.getAttribute('name');
            this.novoContatoDados[name] = target?.innerText;
        },
        closeAtendimento () {
            document.querySelectorAll('.novo-atendimento p[contenteditable]').forEach((i)=>i.innerText = '');
            this.$emit('closeAtendimento');
        },
        sendAtendimento () {
            this.$emit('sendAtendimento', this.novoContatoDados);
        },
        onBeforeEnter (el) {
            document.querySelector('.table-contato').scrollTop = 0;
            gsap.set(el, {
                height: 0,
                overflow: 'hidden',
                scaleY: 0
            });
        },
        onEnter (el, done) {
            console.log('enter');
            done();
            gsap.timeline({
                ease: 'power1',
                delay: 0
            }).to(el, {
                scaleY: 1,
                height: this.isFundacao ? '13.69rem' : '26.5rem',
                duration: 0.2,
                transformOrigin: 'top'
            });
        }
    },
    template: /* html */ `
	<Transition @before-enter="onBeforeEnter" @enter="onEnter">
	<div class="table-row editando novo-atendimento bg-white z-20 ">
		<p class="text-primary-pure font-medium mb-8 col-span-8">Novo Contato</p>

	
		<div class="flex flex-col gap-4 col-span-2">
			<label class="text-xs text-neutral-80 font-medium">Nome</label>
			<p class="row-item" name="nome" @input="handleChange" contenteditable="true">
			</p>
		</div>
		
		<div class="flex flex-col gap-4">
			<label class="text-xs text-neutral-80 font-medium">Telefone</label>
			<p class="row-item" name="telefone" @input="handleChange" contenteditable="true">
			</p>
		</div>
		<div class="flex flex-col gap-4">
			<label class="text-xs text-neutral-80 font-medium">Celular</label>
			<p class="row-item" contenteditable="true">
			</p>
		</div>
	
		<div class="flex flex-col gap-4 col-span-2">
			<label class="text-xs text-neutral-80 font-medium ">Email</label>
			<p class="row-item" name="email" contenteditable="true"  @input="handleChange">
			</p>
		</div>
			<div v-if="!isFundacao" class="row-item col-start-1 col-end-8 flex flex-col gap-4">
			<label class="text-xs text-neutral-80 font-medium">Descri\xe7\xe3o:</label>
		
		<q-editor
			v-model="novoContatoDados.descricao"
			js-ativo
			max-height="5rem"
			min-height="5rem"
			name="descricao"
			class="w-full  col-span-full "
			:dense="$q.screen.lt.md"
			:toolbar="[
				 ['unordered' ], 

			]"
			/>
					
		</div>
	<div v-if="isFundacao" class="row-item col-start-1 col-end-8 flex flex-col gap-4">
			<label class="text-xs text-neutral-80 font-medium">Observa\xe7\xf5es:</label>
			<p name="observacoes" @input="handleChange" contenteditable="true" >
			</p>
		</div>
	
		<div v-else class="row-item col-start-1 col-end-8 flex flex-col gap-4">
			<label class="text-xs text-neutral-80 font-medium">Observa\xe7\xf5es:</label>
			
				<q-editor
			v-model="novoContatoDados.observacoes"
			js-ativo
			max-height="3rem"
			min-height="3rem"
			name="observacoes"
			class="w-full  col-span-full "
			:dense="$q.screen.lt.md"
			:toolbar="[
				 ['unordered' ], 

			]"
			/>
			</p>
		</div>
	
	
		<div class="col-span-8 flex justify-between">
			<button class="btn secondary " @click="closeAtendimento">Cancelar</button>
			<button class="btn" @click="sendAtendimento">Salvar</button>
		</div>
	
	</div>
</Transition	>
	`
};

});

parcelRegister("aZQYO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8018b2975dc819d1$export$2e2bcd8739ae039; });
var $8018b2975dc819d1$export$2e2bcd8739ae039 = {
    props: [
        'agendaPoliticas',
        'optionsAgendaPoliticas',
        'isFundacaoAgenda'
    ],
    data () {
        return {
            isLoadingDelete: false
        };
    },
    mounted () {
        this.initLibs();
    },
    updated () {
        this.initLibs();
    },
    methods: {
        dataFormated (data) {
            return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY');
        },
        initLibs () {
            const selects = [
                ...document.querySelectorAll('.agenda-politicas-select-container select')
            ];
            const choices = selects.map((i)=>GLOBAL.initChoices(i, {
                    searchEnabled: false,
                    searchChoices: false,
                    itemSelectText: 'Selecionar',
                    noResultsText: 'Nada Encontrado...'
                }));
            selects.forEach(this.handleChange);
            setTimeout(()=>{
                const datesInput = [
                    ...document.querySelectorAll('.date-input-politicas')
                ];
                window.datesInputPolitica && datesInputPolitica.map((i)=>i.destroy());
                window.datesInputPolitica = datesInput.map((i)=>GLOBAL.initFlatpickr(i));
                datesInput.forEach(this.handleChange);
            }, 150);
        },
        eventCallback ({ target: target }) {
            const value = target.value;
            const name = target.name;
            const id = target.getAttribute('data-id');
            this.sendAlteracaoAgenda(name, id, value);
        },
        handleChange (i) {
            i.addEventListener('change', this.eventCallback);
        },
        async sendAlteracaoAgenda (name, id, value) {
            const isDate = name === 'data';
            const dataFormated = isDate ? moment(value, 'DD/MM/YYYY').toDate() : '';
            const data = {
                [name]: isDate ? dataFormated : value
            };
            try {
                const request = await axios.patch(`/api/atendimentos/${id}/`, data);
                this.$emit('openModal', this.data);
                GLOBAL.showToastify("\u2705 Alterado com sucesso.");
            } catch (e) {
                GLOBAL.errorDefault(e, "\u274C Ocorreu um erro ao Alterar");
            }
        },
        async deleteAtendimento (id) {
            try {
                this.isLoadingDelete = true;
                await axios.delete(`/api/atendimentos/${id}`);
                this.$emit('update-atendimentos');
                GLOBAL.showToastify("\u2705 Deletado com sucesso");
            } catch (e) {
                GLOBAL.errorDefault(e, "\u274C Ocorreu um erro ao excluir");
            } finally{
                NProgress.done();
                setTimeout(()=>{
                    this.isLoadingDelete = false;
                }, 500);
            }
        }
    },
    /* :class="{ item.atendimento:'disabled'  }" */ template: html`
		<li
			class="flex items-center gap-8"
			v-for="item in agendaPoliticas"
			:key="item.id">
			<!-- <div class="flex-1 font-medium text-sm leading-100 text-neutral-70 p-12 border border-neutral-30 rounded-md h-40" >
				{{dataFormated(item.data)}}
			</div> -->
			<div class="flex-1 flex items-center justify-start border border-[#E9ECEF] rounded">
				<input
					class="w-120 border-none outline-none text-sm input-text appearance-none  date-input-politicas h-40"
					js-ativo
					type="text"
					readonly="readonly"
					name="data"
					:data-id="item.id"
					:value="dataFormated(item.data)" />

				<q-chip v-if="item.concluido" dense color="green-50" text-color="white" icon="check_circle">
					Atendida
				</q-chip>
			</div>

			<div
				class="select-container w-160 h-40 agenda-politicas-select-container">
				<select js-choices :data-id="item.id" name="modalidade_cliente_pf">
					<option
						v-for="([key,value]) in optionsAgendaPoliticas"
						:selected="value == item.modalidade_cliente_pf"
						:value="key">
						{{value }}
					</option>
				</select>
			</div>
			<button
				:disabled="isLoadingDelete"
				@click="() => deleteAtendimento(item.id)"
				v-if="!isFundacaoAgenda"
				class="btn tertiary p-8  h-40">
				<q-icon size="24px" name="delete" class="cursor-pointer"></q-icon>
			</button>
		</li>
	`
};

});

parcelRegister("edB7g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a59f1214306cd738$export$2e2bcd8739ae039; });
var $a59f1214306cd738$export$2e2bcd8739ae039 = {
    props: [
        'novaAgendaPolitica',
        'optionsAgendaPoliticas',
        'clienteAtivo',
        'isFundacao'
    ],
    data () {
        return {
            data: {},
            userLogado: document.getElementById('usuario-logado').value
        };
    },
    mounted () {
        this.initLibs();
        gsap.timeline().set(this.$refs.nova_politica, {
            height: 0,
            overflow: 'hidden'
        }).to(this.$refs.nova_politica, {
            duration: 0.25,
            height: 'auto'
        }).to(this.$refs.nova_politica, {
            overflow: 'initial'
        }, '+=0.2');
    },
    unmounted () {},
    created () {
        console.log('created');
    },
    watch: {
        data: {
            handler () {
                _BIG('Nova politica');
            //console.log(this.data)
            },
            deep: true
        }
    },
    methods: {
        handleChange (event) {
            const target = event.target;
            const name = target.getAttribute('name');
            this.data[name] = target.value;
        //console.log(`rolou alteracao na ${name}  = ${target.value}`)
        //	console.log(JSON.stringify(this.data))
        },
        initLibs () {
            const select = document.querySelector('.nova-agenda-politicas-select-container select');
            const choices = GLOBAL.initChoices(select, {
                searchEnabled: false,
                searchChoices: false,
                itemSelectText: 'Selecionar',
                noResultsText: 'Nada Encontrado...'
            });
            window.listOfChoices = [
                ...window.listOfChoices,
                choices
            ];
            const inputDate = document.getElementById('nova-politica-input-date');
            GLOBAL.initFlatpickr(inputDate);
        },
        closeAtendimento () {
            const inputDate = document.querySelector('#nova-politica-input-date');
            inputDate.value = '';
            const choices = GLOBAL.getChoicesActive('select-nova-politica-modal', window.listOfChoices);
            choices.setChoiceByValue('');
            this.data = {};
            this.$emit('close');
        },
        createNewchoices () {
            const selects = document.querySelector('.nova-agenda-politicas-select-container select');
        },
        async sendPolitica () {
            if (Object.keys(this.data).length < 2) {
                GLOBAL.showToastify("\u26A0\uFE0F Preencha todos os valores antes de enviar");
                return;
            }
            const data1 = this.data.data;
            const dataFormated = moment(data1, 'DD/MM/YYYY').format();
            //	console.log('ANTES DE ENVIAR ADRIANO', this.userLogado)
            try {
                NProgress.start();
                const request = await axios.post(`/api/atendimentos/`, {
                    ...this.data,
                    tipo: '1',
                    data: dataFormated,
                    usuario_responsavel: [
                        this.userLogado
                    ],
                    [this.isFundacao ? 'fundacao' : 'cliente_pf']: this.clienteAtivo.id
                });
                GLOBAL.showToastify("\u2705 Enviado com sucesso");
                this.$emit('update');
                this.closeAtendimento();
            } catch (e) {
                GLOBAL.errorDefault(e, "\u274C Ocorreu um erro ao Alterar");
            } finally{
                NProgress.done();
            }
        },
        onBeforeEnter (el) {
            gsap.set(el, {
                height: 0
            });
        },
        onEnter (el, done) {
            console.log(el, done);
            gsap.timeline({
                ease: 'power1',
                delay: 0
            }).to(el, {
                height: '19rem',
                duration: 0.2
            });
        // done()
        }
    },
    template: /* html */ `
	
				<li ref="nova_politica" class="p-8 border border-primary-pure rounded-md">
					<p class="text-primary-pure font-medium mb-8">Nova Politicas</p>

					<form id="form-nova-politica" class="flex items-center gap-8 " @change="handleChange">
						<div class="flex-1 font-medium text-sm leading-100 text-neutral-70 border border-neutral-30 rounded-md h-40">
							<input type="date" name="data" id="nova-politica-input-date" placeholder="Escolha a data" class="w-full p-10">
						</div>
			
						<div class="select-container w-160 h-40 nova-agenda-politicas-select-container">
							<select js-choices name="modalidade_cliente_pf" id="select-nova-politica-modal">
								<option value="" selected disabled placeholder>Selecione uma politica</option>
								<option v-for="([key,value]) in optionsAgendaPoliticas" :value="key">{{value}}</option>
							</select>
						</div>
			
			
					</form>
			
					<div class="col-span-8 flex justify-between mt-8">
						<button class="btn secondary" @click="closeAtendimento">Cancelar</button>
						<button class="btn" @click="sendPolitica">Salvar</button>
					</div>
				</li>

	`
};

});

parcelRegister("U7jaT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a8ae65907f143ee$export$2e2bcd8739ae039; });

var $4Fazw = parcelRequire("4Fazw");

var $1UZGW = parcelRequire("1UZGW");

var $i5cs0 = parcelRequire("i5cs0");

var $4yQva = parcelRequire("4yQva");
const { isFundacao: $0a8ae65907f143ee$var$isFundacao } = GLOBAL;
const { deletarTarefa: $0a8ae65907f143ee$var$deletarTarefa } = (0, $4yQva.default)();
const $0a8ae65907f143ee$var$OPTIONS_TAKS = {
    CONCLUIR: 'concluir',
    DELETAR: 'deletar'
};
var $0a8ae65907f143ee$export$2e2bcd8739ae039 = {
    emits: [
        'enviar',
        'open'
    ],
    props: [
        'data'
    ],
    mixins: [
        (0, $i5cs0.default)
    ],
    data () {
        return {
            editado: false,
            editando: false,
            taskdados: {},
            text: 'Deseja concluir a tarefa',
            modalConfirm: false,
            modalAction: $0a8ae65907f143ee$var$OPTIONS_TAKS.CONCLUIR,
            loading: false
        };
    },
    components: {
        AvatarPersona: $4Fazw.default,
        ConfirmModal: $1UZGW.default
    },
    watch: {
        editando () {
            if (this.editando) this.$refs.deadline.dispatchEvent(new Event('change'));
        },
        taskdados: {
            handler () {
                _BIG('taskdados');
                console.log(this.taskdados);
            },
            deep: true
        }
    },
    mounted () {
        if (this.$refs.deadline) GLOBAL.initFlatpickr(this.$refs.deadline);
    },
    methods: {
        openConfirmModal (action) {
            this.modalAction = action;
            this.text = action === $0a8ae65907f143ee$var$OPTIONS_TAKS.DELETAR ? 'Deseja mesmo excluir essa tarefa?' : 'Deseja concluir a tarefa';
            this.modalHeader = action === $0a8ae65907f143ee$var$OPTIONS_TAKS.DELETAR ? 'Excluir Tarefa' : 'Concluir Tarefa';
            this.botao = action === $0a8ae65907f143ee$var$OPTIONS_TAKS.DELETAR ? 'Excluir' : 'Concluir';
            this.modalConfirm = true;
        },
        handleConfirm () {
            if (this.modalAction === $0a8ae65907f143ee$var$OPTIONS_TAKS.DELETAR) this.cancelarTarefa();
            else this.concluirTask();
        },
        getStatus (statusValue) {
            return GLOBAL.taskStatus?.filter((i)=>statusValue == i.value)?.reduce((acc, i)=>acc = i.label, '');
        },
        classStatus (status) {
            return `status-${status}`;
        },
        async sendEdicao (e) {
            this.loading = true;
            NProgress.start();
            const deadline = this.taskdados.deadline ? {
                deadline: moment(this.taskdados.deadline, 'DD/MM/YYYY').format('YYYY-MM-DD')
            } : {};
            try {
                const request = await axios.patch(`/api/tarefas/${this.data.id}/`, {
                    ...this.taskdados,
                    ...deadline,
                    cliente_pf: this.data.cliente_pf
                });
                this.cancelarEdicao();
                this.$emit('enviar', "\u2705 Tarefa alterada com sucesso");
            } catch (e) {
                console.log(e);
                showToastify('Ocorreu um erro');
            } finally{
                NProgress.done();
                this.loading = false;
            }
        },
        cancelarEdicao () {
            this.taskdados = {};
            this.editado = false;
            this.editando = false;
            this.$refs.deadline.value = this.data.deadline;
            this.$refs.descricao.innerHTML = this.data.descricao;
            this.$refs.deadline.dispatchEvent(new Event('change'));
        },
        handleChange ({ target: target }) {
            const value = target.tagName === 'INPUT' ? target.value : target.innerText;
            this.taskdados[target.getAttribute('name')] = value.trim();
            this.editado = true;
        },
        dataFormated (data) {
            return moment(data, 'YYYY/MM/DD').format('DD/MM/YYYY');
        },
        async concluirTask () {
            this.loading = true;
            NProgress.start();
            try {
                const key = this.isFundacao ? 'fundacao' : 'cliente_pf';
                const value = this.isFundacao ? this.data.fundacao : this.data.cliente_pf;
                this.cancelarConclusao();
                const request = await axios.patch(`/api/tarefas/${this.data.id}/`, {
                    key: value,
                    concluida: true,
                    status: '2'
                });
                this.$emit('enviar', " \u2705 Tarefa concluida com sucesso");
                this.modalConfirm = false;
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
                this.loading = false;
            }
        },
        async cancelarTarefa () {
            this.loading = true;
            NProgress.start();
            console.log('tarefa: ', this.data);
            try {
                await $0a8ae65907f143ee$var$deletarTarefa(this.data.id);
                this.$emit('enviar', " \u2705 Tarefa deletada com sucesso");
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
                this.loading = false;
            }
        },
        cancelarConclusao () {
            this.modalConfirm = false;
        }
    },
    template: /*html*/ `
		<confirm-modal
	        v-if="modalConfirm"
	        @enviar="handleConfirm"
	        @cancelar="cancelarConclusao"
	        :text="text"
	        :modal-data="{id: modalAction === 'deletar' ? 'delete' : 'check', header: modalHeader, botao: botao}"
	    ></confirm-modal>
		<div v-show="isFundacao ? data.fundacao : data.cliente_pf" class="table-row relative group item-task !h-max !min-h-max transition-[height] overflow-hidden" :class="{'editando' : editando  }"  :data-id="data.id">
		
		<div @click="$emit('open')" class=" w-40 h-40 cursor-pointer" style="grid-area:'icon'">
			<avatar-persona class="w-40 h-40" :type="data.politica"></avatar-persona>
		</div>
	
		<p @click="$emit('open')" class="row-item cursor-pointer" :class="{'only-2-lines' : !editando }" style="grid-area:nome">{{data.nome}}</p>
		<p v-html="data.descricao" class="row-item border border-transparent !p-4 rounded-md transition-[height] !h-max" ref="descricao" style="grid-area:desc; white-space: break-spaces;"
			@input="handleChange" :contenteditable="editando" name="descricao" :style="{minHeight: editando ? '70px' : null}"></p>

		<p class="row-item" style="grid-area:ultima">-</p>
	
		<p v-show="!editando" class="row-item  border border-transparent !p-4 rounded-md" style="grid-area:deadline">
			{{dataFormated( data.deadline) }}
		</p>
	
		<input v-show="editando" class="row-item  border border-transparent !p-4 rounded-md editavel"
			style="grid-area:deadline" ref="deadline" type="text" @change="handleChange" :value="dataFormated(data.deadline)"
			name="deadline" />
	
		<p class="row-item label" :class="classStatus(data.get_status)" style="grid-area:status">{{ getStatus(data.get_status) }}</p>
	
		<div v-show="!editando" style="grid-area:check" @click="openConfirmModal('concluir')">
            <svg class="w-40 h-40 text-neutral-60 hover:text-green-50 transition-colors cursor-pointer" >
                <use xlink:href="#icon_check_task"></use>
            </svg>
        </div>

		
		<div v-show="!editando" class="flex items-center gap-16 absolute right-12 bottom-8 w-max">
            <button type="button" @click="openConfirmModal('deletar')"
                class="editar w-32 h-32 opacity-0 group-hover:opacity-100 btn secondary !p-4">
                <q-icon name="delete" size="24px"/>
            </button>
        
            <button type="button"  @click="editando = true"
                class="editar w-32 h-32 opacity-0 group-hover:opacity-100 btn secondary !p-4">
                <q-icon name="edit" size="24px"/>
            </button>
        </div>

		
	
		<div class="flex justify-between col-span-6" v-show="editando">
			<button type="button" class="btn secondary" @click="cancelarEdicao">Cancelar</button>
			<button type="button" class="btn" :class="{'disabled' : !editado }" @click="sendEdicao">Salvar alteracoes</button>
		</div>
	</div>
	`
};

});
parcelRegister("4Fazw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3653311b713a5f4f$export$2e2bcd8739ae039; });
var $3653311b713a5f4f$export$2e2bcd8739ae039 = {
    props: [
        'type'
    ],
    setup (props) {
        return {
            avatarColor: GLOBAL.generateAvatarColor(props.type)
        };
    },
    template: /* html */ `
		<div class="inline-flex justify-center">
			<svg class="h-40 w-40" :style="avatarColor">
				<use xlink:href="#icon_person"></use>
			</svg>
		</div>
	`
};

});

parcelRegister("1UZGW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $165ae00ec361dd07$export$2e2bcd8739ae039; });
var $165ae00ec361dd07$export$2e2bcd8739ae039 = {
    props: [
        "text",
        "data",
        "modalData"
    ],
    methods: {
        send () {
            this.$emit("enviar", this.data);
        },
        cancel () {
            this.$emit("cancelar", this.data);
        },
        handleClick ({ target: target }) {
            console.log("clicou fora");
            if (target !== modal || !target.closest("modal-sucesso-1-wrapper")) this.cancel();
        },
        onBeforeEnter (el) {
            gsap.set(el, {
                y: 30,
                scale: 1
            });
            gsap.set(el.querySelector("svg"), {
                scale: 0
            });
        },
        onEnter (el, done) {
            gsap.timeline({
                ease: "power1",
                delay: 0
            }).to(el, {
                y: 0,
                duration: 0.2
            });
            gsap.to(el.querySelector("svg"), {
                scale: 1,
                duration: 0.2,
                transformOrigin: "bottom"
            });
            done();
        }
    },
    mounted () {
        gsap.to(this.$refs.modal, {
            y: 0
        });
    },
    template: `
			<Transition 
			@before-enter="onBeforeEnter" 
			@enter="onEnter" 
			>
				<div class="modal-sucesso-1">
					<header v-if="modalData.header" class="text-headline-2 rounded-t-lg bg-primary-pure !p-20 w-full h-[60px] !flex !items-center text-white" >
						<p class="!flex-1 !w-full">{{modalData.header}}</p>
					</header>
					<div :class="{'!rounded-t-none': modalData.header}"
						class="modal-sucesso-1-wrapper bg-white border border-neutral-30 flex flex-col w-full  max-w-[400px] overflow-hidden   h-max mx-auto py-16 px-24 gap-24 shadow-lg rounded-lg"
						ref="modal" style="transform:translatey(30px);">
						<div class="flex flex-col gap-8 mx-auto">
							<div v-if="modalData">
								<div v-if="modalData.class == 'remove'">
			
									<svg class="w-48 h-48 mx-auto my-16" xmlns="http://www.w3.org/2000/svg"
										xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 496.158 496.158"
										style="enable-background:new 0 0 496.158 496.158;" xml:space="preserve">
										<path d="M0,248.085C0,111.063,111.069,0.003,248.075,0.003c137.013,0,248.083,111.061,248.083,248.082 c0,137.002-111.07,248.07-248.083,248.07C111.069,496.155,0,385.087,0,248.085z"   style="fill: rgb(var(--primary-pure));"/>
										<path style="fill:#FFFFFF;" d="M383.546,206.286H112.612c-3.976,0-7.199,3.225-7.199,7.2v69.187c0,3.976,3.224,7.199,7.199,7.199
							h270.934c3.976,0,7.199-3.224,7.199-7.199v-69.187C390.745,209.511,387.521,206.286,383.546,206.286z" />
			
									</svg>
			
			
								</div>
								<div v-if="modalData.class === 'fire'">
									<svg class="w-48 h-48 mx-auto my-16">
										<use xlink:href="#icon_fire_filled"></use>
									</svg>
			
								</div>
			
							</div>
							<p class="text-center text-neutral-80 font-semibold py-16" v-html="text"></p>
							<div class="flex justify-between col-span-6 gap-32">
								<button class="btn secondary" @click="cancel">Cancelar</button>
								<button class="btn" @click="send">{{modalData?.botao ? modalData.botao  : 'Concluir'}}</button>
							</div>
						</div>
					</div>
			
				</div>
			</Transition>
	
	`
};

});

parcelRegister("i5cs0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2a25a18e3c98e5a$export$2e2bcd8739ae039; });
const { isFundacao: $d2a25a18e3c98e5a$var$isFundacao } = GLOBAL;
var $d2a25a18e3c98e5a$export$2e2bcd8739ae039 = {
    data () {
        return {
            isGestorSAI: null,
            isGestorSAP: null,
            acessSAP: null,
            acessSAI: null,
            acessCalendario: null,
            isFundacao: $d2a25a18e3c98e5a$var$isFundacao()
        };
    },
    mounted () {
        setTimeout(()=>{
            this.isGestorSAI = document.getElementById("isGestorSAI").value == "True";
            this.isGestorSAP = document.getElementById("isGestorSAP").value == "True";
            this.acessSAI = document.getElementById("acessSAI").value == "True";
            this.acessSAP = document.getElementById("acessSAP").value == "True";
            this.acessCalendario = document.getElementById("acessCalendario").value == "True";
        }, 100);
    }
};

});

parcelRegister("4yQva", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3523102a68cf569d$export$2e2bcd8739ae039; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $3523102a68cf569d$export$2e2bcd8739ae039() {
    const api = (0, $c8Lpu.useApi)();
    async function getTarefas(params = {}) {
        return api.query(`${window.location.origin}${(0, $9YhWF.URLS).api_tarefa}`, params);
    }
    async function criarTarefa(data) {
        return api.mutation(`${window.location.origin}${(0, $9YhWF.URLS).api_tarefa}`, 'post', data);
    }
    async function atualizarTarefa(id, data) {
        return api.mutation(`${window.location.origin}${(0, $9YhWF.URLS).api_tarefa}${id}/`, 'put', data);
    }
    async function deletarTarefa(id) {
        return api.mutation(`${window.location.origin}${(0, $9YhWF.URLS).api_tarefa}${id}/`, 'delete');
    }
    return {
        getTarefas: getTarefas,
        criarTarefa: criarTarefa,
        atualizarTarefa: atualizarTarefa,
        deletarTarefa: deletarTarefa,
        ...api
    };
}

});
parcelRegister("c8Lpu", function(module, exports) {

$parcel$export(module.exports, "useApi", function () { return $8d6b020ea4d55c3d$export$eb2799109db70ffd; });
const { errorDefault: $8d6b020ea4d55c3d$var$errorDefault } = GLOBAL;
function $8d6b020ea4d55c3d$export$eb2799109db70ffd() {
    async function query(url, params = {}, options = {}) {
        NProgress.start();
        try {
            const { data: data } = await axios.get(url, {
                params: params,
                ...options
            });
            return data;
        } catch (e) {
            $8d6b020ea4d55c3d$var$errorDefault(e);
        } finally{
            NProgress.done();
        }
    }
    async function mutation(url, method, body = {}, params = {}, options = {}) {
        NProgress.start();
        try {
            const { data: data } = await axios[method](url, body, {
                params: params,
                ...options
            });
            return data;
        } catch (e) {
            $8d6b020ea4d55c3d$var$errorDefault(e);
        } finally{
            NProgress.done();
        }
    }
    return {
        query: query,
        mutation: mutation
    };
}

});

parcelRegister("9YhWF", function(module, exports) {

$parcel$export(module.exports, "URLS", function () { return $7427a3334c8f1273$export$2389c26b9ec125dd; });
const $7427a3334c8f1273$export$2389c26b9ec125dd = {
    atendimento_reuniao_sai: '/atendimento/reunioes_realizadas_sai/',
    atendimento_sequoia: '/atendimento/atendimento_sequoia/',
    email_templates: '/clientes/email_templates/',
    send_email: '/clientes/send_email/',
    fundacao_contatos: '/clientes/fundacao_contatos/',
    email_enviados: '/clientes/email_enviados/',
    atendimento_gerenciador_sai: '/atendimento/dashboard_gerencial_fundacao/',
    top_bottom_sai: '/clientes/top_bottom_sai/',
    top_bottom_sap: '/clientes/top_bottom_sap/',
    cliente_filtro_fundacao: '/clientes/filtros_fundacao/',
    informacoes_modal_fundacao: '/atendimento/informacoes_modal_fundacao/',
    informacoes_modal_cliente_pf: '/atendimento/informacoes_modal_cliente_pf/',
    grafico_bolhas_fundacoes: '/atendimento/grafico_bolhas_fundacoes/',
    info_data_politica_fundacao: '/atendimento/info_data_politica_fundacao/',
    atendimento_rapido_fundacao: '/atendimento/atendimento_rapido_fundacao/',
    grafico_tempo_vencimento: '/atendimento/grafico_tempo_vencimento/',
    tabela_clientepf_volatilidade: '/api/tabela_clientepf/detalhes_volatilidade/',
    tabela_clientepf_retorno: '/api/tabela_clientepf/detalhes_retorno/',
    investimentos_clientes_pf_api: '/clientes/investimentos/clientes_pf_api/',
    clientes_todos_user_sap: '/clientes/todos_user_sap/',
    processo_seletivo: '/api/processo_seletivo/',
    api_fundacao: '/api/fundacao/',
    api_clientepf: '/api/clientepf/',
    atendimento_solicitacoes: '/atendimento/solicitacoes/',
    api_notificacao: '/api/notificacao/',
    calendario: '/clientes/calendar/events_api/',
    calendario_auth: '/clientes/auth/microsoft/login/',
    api_tarefa: '/api/tarefas/',
    clientes_calendar_user_api: '/clientes/calendar/users_api',
    clientes_calendar_user_events_api: '/clientes/calendar/user/events/',
    relatorio_politica_agendamento: '/atendimento/relatorio_politica_agendamento/',
    cliente_realocacao: "/clientes/realocacao/"
};

});



parcelRegister("kcxIT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb4f165c6f84b7ce$export$2e2bcd8739ae039; });
var $eb4f165c6f84b7ce$export$2e2bcd8739ae039 = {
    props: [
        "editando"
    ],
    emits: [
        "enviar",
        "cancelar"
    ],
    data () {
        return {
            data: {}
        };
    },
    watch: {
        editando () {
            if (this.editando === false) {
                this.data = {};
                this.$refs.textarea.value = "";
                this.$refs.data.value = "";
            }
        }
    },
    mounted () {
        GLOBAL.initFlatpickr(this.$refs.data);
    },
    methods: {
        handleChange ({ target: target }) {
            const value = target.value;
            this.data[target.getAttribute("name")] = value.trim();
        },
        prevent (e) {
            console.log("aaaaaaaaaaa");
            e.preventDefault();
        },
        enviar () {
            this.$emit("enviar", this.data);
        },
        cancelar () {
            this.$emit("cancelar");
        },
        onBeforeEnter (el) {
            gsap.set(el, {
                height: 0
            });
        },
        onEnter (el, done) {
            gsap.timeline({
                ease: "power1",
                delay: 0
            }).to(el, {
                height: "auto",
                duration: 0.2
            });
            this.$refs.new_task.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            done();
        }
    },
    template: `
		<Transition @before-enter="onBeforeEnter" @enter="onEnter">
			<div class="p-16 border !h-[18.75rem] border-primary-pure rounded-md new-task-el overflow-hidden " ref="new_task">
				<p class="text-primary-pure  font-medium mb-8">Nova Tarefa</p>
				<form class="flex flex-col items-center gap-8 " @change="handleChange" @submit="prevent">
		
					<div class="flex-1 flex flex-col gap-4 w-full">
						<label class="label">Descri\xe7\xe3o</label>
						<textarea ref="textarea" name="descricao" class="w-full p-10 input-text h-[5rem]"></textarea>
					</div>
		
					<div class="flex-1 flex flex-col  w-full">
						<label class="label">Prazo Final</label>
						<input ref="data" type="date" name="deadline" placeholder="Escolha o Prazo Final"
							class="w-full p-10 input-text">
					</div>
		
					<div class=" flex justify-between mt-8 w-full">
						<button type="button" class="btn secondary" @click="cancelar">Cancelar</button>
						<button type="button" class="btn" @click="enviar">Enviar</button>
					</div>
		
				</form>
			</div>
		</Transition>

	`
};

});

parcelRegister("niAA9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0460917e066ef034$export$2e2bcd8739ae039; });
function $0460917e066ef034$export$2e2bcd8739ae039() {
    const attr = "[js-badge]";
    const badges = document.querySelectorAll(`.badge${attr}`);
    if (!badges.length) return;
    badges.forEach((badge)=>{
        const color = getComputedStyle(badge).getPropertyValue("--color");
        if (!color) return;
        badge.style.color = color;
        badge.style.background = GLOBAL.addAlpha(color, 0.1);
    });
}

});

parcelRegister("jWBFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e850a708e44f691b$export$2e2bcd8739ae039; });

var $1tEcV = parcelRequire("1tEcV");

var $5Xbti = parcelRequire("5Xbti");

var $hGX9G = parcelRequire("hGX9G");

var $1F5Ay = parcelRequire("1F5Ay");

var $55FHZ = parcelRequire("55FHZ");

var $9nXqm = parcelRequire("9nXqm");

var $ik92V = parcelRequire("ik92V");

var $6OLqX = parcelRequire("6OLqX");

var $8yQJ6 = parcelRequire("8yQJ6");

var $kRDUb = parcelRequire("kRDUb");

var $jzAJi = parcelRequire("jzAJi");

var $j0jCN = parcelRequire("j0jCN");

var $4s5N5 = parcelRequire("4s5N5");
const { getDadosTempoVencimento: $e850a708e44f691b$var$getDadosTempoVencimento, getDetalhesVolatilidade: $e850a708e44f691b$var$getDetalhesVolatilidade, getDetalhesRetorno: $e850a708e44f691b$var$getDetalhesRetorno } = (0, $jzAJi.clientAssetsService)();
const { createCarteiraMarginsChart: $e850a708e44f691b$var$createCarteiraMarginsChart } = (0, $5Xbti.useCarteiraMarginsChart)();
const { createCarteiraAlvosChart: $e850a708e44f691b$var$createCarteiraAlvosChart } = (0, $1tEcV.useCarteiraAlvosChart)();
const { createTempoVencimentoCharts: $e850a708e44f691b$var$createTempoVencimentoCharts } = (0, $hGX9G.useChartTempoVencimento)();
const { createLiquidezMarginsChart: $e850a708e44f691b$var$createLiquidezMarginsChart } = (0, $ik92V.useLiquidezMarginsChart)();
const { createLiquidezAlvosChart: $e850a708e44f691b$var$createLiquidezAlvosChart } = (0, $55FHZ.useLiquidezAlvosChart)();
const { createRatingChart: $e850a708e44f691b$var$createRatingChart } = (0, $9nXqm.useRatingChart)();
const { createSetorChart: $e850a708e44f691b$var$createSetorChart } = (0, $j0jCN.useSetorChart)();
const { createVolatilidadeChart: $e850a708e44f691b$var$createVolatilidadeChart } = (0, $8yQJ6.useVolatilidade)();
const { createRetornoChart: $e850a708e44f691b$var$createRetornoChart } = (0, $6OLqX.useRetorno)();
const { setColorsInFunctionOfAHexadecimalColor: $e850a708e44f691b$var$setColorsInFunctionOfAHexadecimalColor } = (0, $1F5Ay.useCharts)();
var $e850a708e44f691b$export$2e2bcd8739ae039 = {
    emits: [],
    components: {
        TableClienteRealocacao: $4s5N5.default
    },
    data: ()=>({
            realocacao_table: false,
            activeTab: 'investimentos',
            porcentagem_rating: {},
            dadosClienteRating: '',
            buttonRatingAtivo: '',
            rating_chart_fgc: false,
            rating_chart_total: false,
            rating_chart_total_fgc: false,
            emissor_chart: false,
            rating_chart: false,
            tipo_chart: false,
            indice_chart: false,
            divisao_chart: false,
            tempo_vencimento_chart: false,
            ativo_chart: false,
            ativo_table: false,
            tipo_investimento: '',
            total_eventos_de_credito: '',
            ativosTableSortKey: '',
            ativosTableSortOrderInDesc: false,
            infoGraficoModal: null,
            chartError: null,
            isPerfil: false,
            rendaFixa: false,
            isInvestimento: false,
            idCarteira: '',
            dataAtualCarteira: '',
            emissores: {},
            emissores_fgc: {},
            tipos: {},
            indices: {},
            tempo_vencimento: {},
            volatilidade1M: {},
            volatilidade3M: {},
            periodoAtivo: '1M',
            graficoCarteira: null,
            ativosSetor: false,
            limitesLiquidez: {},
            margens: null,
            perfilInvestidor: [],
            data_inicio: '',
            data_fim: '',
            dataInicioFormatted: '',
            dataFimFormatted: '',
            disableAtualizarVolatilidade: false,
            retorno: {},
            filterRetornoMesAtivo: 12,
            carteiraTabelaInvestimento: []
        }),
    watch: {
        data_inicio () {
            if (this.data_inicio !== 'DD/MM/YYYY') this.formatDate();
            this.ondisableAtualizarVolatilidade();
        },
        data_fim () {
            if (this.data_fim !== 'DD/MM/YYYY') this.formatDateFim();
            this.ondisableAtualizarVolatilidade();
        }
    },
    computed: {
        idClienteAtivo () {
            console.log(this.clienteAtivo);
            return this.clienteAtivo?.id;
        }
    },
    methods: {
        onInput () {
            const parts = this.dataInicioFormatted.split('/');
            if (parts.length === 3) {
                const [day, month, year] = parts;
                this.data_inicio = `${year}-${month}-${day}`;
            }
        },
        formatDate () {
            if (this.data_inicio) {
                const [year, month, day] = this.data_inicio.split('/');
                this.dataInicioFormatted = `${day}/${month}/${year}`;
            } else this.dataInicioFormatted = '';
        },
        formatDateFim () {
            if (this.data_fim) {
                const [year, month, day] = this.data_fim.split('/');
                this.dataFimFormatted = `${day}/${month}/${year}`;
            } else this.dataFimFormatted = '';
        },
        async onTabDivisaoClick (name) {
            this.resetButtonsFilters();
            this.ativo_table = false;
            this.ativosLiquidez = false;
            this.ativosRating = false;
            this.isInvestimento = false;
            this.destroyAllCharts();
            this.activeTab = name;
            switch(name){
                case 'concentracao':
                    this.onConcentracaoTabClick();
                    break;
                case 'liquidez':
                    this.onLiquidezTabClick();
                    break;
                case 'volatilidade':
                    this.onVolatilidadeTabClick();
                    break;
                case 'retorno':
                    this.filterRetornoMesAtivo = 12;
                    this.onRetornoTabClick();
                    break;
                case 'investimentos':
                    await this.onInvestimentosTabClick();
                    break;
                default:
                    await this.onInvestimentosTabClick();
            }
        },
        keyVencimento (key) {
            let keyVencimento = '';
            switch(key){
                case "At\xe9 5 dias":
                    keyVencimento = 'vencimento_5_dias';
                    return keyVencimento;
                case 'De 6 a 35 dias':
                    keyVencimento = 'vencimento_6_a_35_dias';
                    return keyVencimento;
                case 'De 36 a 65 dias':
                    keyVencimento = 'vencimento_36_a_65_dias';
                    return keyVencimento;
                case 'Acima de 65 dias':
                    keyVencimento = 'vencimento_65_dias';
                    return keyVencimento;
                default:
                    return keyVencimento;
            }
        },
        async setTableAtivosLiquidez (valores) {
            GLOBAL.destroyApexChart([
                'chartCarteiraAlvos',
                'chartCarteiraMargens'
            ]);
            this.ativosLiquidez = true;
            this.isPerfil = false;
            NProgress.start();
            try {
                const table = document.querySelector('#table_ativos_liquidez');
                const bodyTable = table?.querySelector('tbody');
                this.graficoCarteira = valores?.map((i)=>({
                        valor: i[0].valor,
                        tipo_investimento: i[0].nome,
                        pct_global: i[0].pct_global,
                        pct_renda_fixa: i[0].pct_tipo_investimento,
                        indexador: i[0].indexador,
                        taxa: i[0].taxa,
                        vencimento: i[0].vencimento
                    }));
                bodyTable.innerHTML = this.templateBodyTable(this.graficoCarteira);
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        async onLiquidezTabClick () {
            this.isPerfil = true;
            const limites_liquidez = await this.getLimitesLiquidez(this.clienteAtivo.id);
            const { vencimento_5_dias: vencimento_5_dias, vencimento_6_a_35_dias: vencimento_6_a_35_dias, vencimento_36_a_65_dias: vencimento_36_a_65_dias, vencimento_65_dias: vencimento_65_dias } = await this.getDadosInvestimentosClientesRendaFixaLiquidez('Renda Fixa');
            const dadosRendaFixa = {
                vencimento_5_dias: vencimento_5_dias,
                vencimento_6_a_35_dias: vencimento_6_a_35_dias,
                vencimento_36_a_65_dias: vencimento_36_a_65_dias,
                vencimento_65_dias: vencimento_65_dias
            };
            this.limitesLiquidez = limites_liquidez;
            setTimeout(()=>{
                const t = this;
                $e850a708e44f691b$var$createLiquidezMarginsChart(this.limitesLiquidez, dadosRendaFixa);
                const chart = Apex._chartInstances?.filter((i)=>i.id == 'chartCarteiraMargens')?.[0];
                if (chart) chart.chart.updateOptions({
                    chart: {
                        ...(0, $kRDUb.CARTEIRA_MARGINS_CHART_OPTIONS).chart,
                        events: {
                            click: async function(event, chartContext, config) {
                                const key = config?.globals?.labels[config?.dataPointIndex];
                                t.periodo_ativo_liquidez = key;
                                const keyVenc = t.keyVencimento(key);
                                const valores = Object.values(dadosRendaFixa[keyVenc]);
                                t.setTableAtivosLiquidez(valores);
                            }
                        }
                    }
                });
                $e850a708e44f691b$var$createLiquidezAlvosChart(this.limitesLiquidez);
            }, 500);
        },
        async onVolatilidadeTabClick () {
            this.isPerfil = true;
            this.ondisableAtualizarVolatilidade();
            this.volatilidade1M = await this.getInfoDetalhesVolatilidade('1M', this.data_inicio.replaceAll('/', '-'), this.data_fim.replaceAll('/', '-'));
            this.volatilidade3M = await this.getInfoDetalhesVolatilidade('3M', this.data_inicio.replaceAll('/', '-'), this.data_fim.replaceAll('/', '-'));
            const dados_1m = {
                volatilidades: this.volatilidade1M?.volatilidades.map((v)=>v.volatilidade),
                labels: this.volatilidade1M?.volatilidades.map((v)=>v?.data.replaceAll('-', '/')),
                rentabilidades: this.volatilidade1M?.volatilidades.map((v)=>v.rentabilidade_diaria),
                periodo: this.volatilidade1M?.volatilidades_perfil.find((item)=>this.volatilidade1M.periodo === item.periodo) || {
                    periodo: '1M'
                },
                message: this.volatilidade1M?.volatilidades_perfil[0]?.mensagem,
                estatisticas: this.volatilidade1M?.estatisticas
            };
            const dados_3m = {
                volatilidades: this.volatilidade3M?.volatilidades.map((v)=>v.volatilidade),
                labels: this.volatilidade3M?.volatilidades.map((v)=>v?.data.replaceAll('-', '/')),
                rentabilidades: this.volatilidade3M?.volatilidades.map((v)=>v.rentabilidade_diaria),
                periodo: this.volatilidade3M?.volatilidades_perfil.find((item)=>this.volatilidade3M.periodo === item.periodo) || {
                    periodo: '3M'
                },
                message: this.volatilidade3M?.volatilidades_perfil[0]?.mensagem,
                estatisticas: this.volatilidade3M?.estatisticas
            };
            setTimeout(()=>{
                $e850a708e44f691b$var$createVolatilidadeChart(dados_1m);
                $e850a708e44f691b$var$createVolatilidadeChart(dados_3m);
            }, 500);
        },
        async handlePeriodoVolatilidade () {
            this.periodoAtivo = this.periodoAtivo === '1M' ? '3M' : '1M';
            GLOBAL.destroyApexChart([
                'xchart-volatilidade-1m',
                'xchart-volatilidade-3m',
                'chart-volatilidade-1m',
                'chart-volatilidade-3m'
            ]);
            Apex._chartInstances?.map((i)=>{
                return i?.chart.destroy();
            });
            await this.onVolatilidadeTabClick();
        },
        ondisableAtualizarVolatilidade () {
            let [day, month, year] = this.dataAtualCarteira.split('/');
            let newDate = new Date(year, month - 1, day);
            let dateFormated = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
            let [diaInicio, mesInicio, anoInicio] = this.data_inicio.split('/');
            const dataInicio = new Date(anoInicio, mesInicio - 1, diaInicio);
            let [diaFim, mesFim, anoFim] = this.data_fim.split('/');
            const dataFim = new Date(anoFim, mesFim - 1, diaFim);
            if (dataInicio > dataFim || dataFim > dateFormated) this.disableAtualizarVolatilidade = true;
            else this.disableAtualizarVolatilidade = false;
        },
        async handleFilterRetorno (quantidade_meses) {
            this.filterRetornoMesAtivo = quantidade_meses;
            GLOBAL.destroyApexChart([
                'xchart-retorno',
                'chart-retorno'
            ]);
            Apex._chartInstances?.map((i)=>{
                return i?.chart.destroy();
            });
            await this.onRetornoTabClick();
        },
        async onRetornoTabClick () {
            this.isPerfil = true;
            this.retorno = await $e850a708e44f691b$var$getDetalhesRetorno(this.clienteAtivo.id, this.filterRetornoMesAtivo);
            const dados = {
                cdi: this.retorno?.porcentagem_cdi?.map((cdi)=>cdi.porcentagem_cdi),
                labels: this.retorno?.rentabilidades_diarias.map((v)=>v?.data.replaceAll('-', '/')),
                cotas: this.retorno?.rentabilidades_diarias.map((v)=>v.valor_cota),
                rentabilidades: this.retorno?.rentabilidades_diarias.map((v)=>v.rentabilidade)
            };
            setTimeout(()=>{
                $e850a708e44f691b$var$createRetornoChart(dados);
            }, 500);
        },
        async onInvestimentosTabClick () {
            this.isPerfil = false;
            if (this.rendaFixa) {
                this.rendaFixa = false;
                this.isInvestimento = false;
                this.tipo_investimento = '';
                this.ativo_table = false;
                this.ativosLiquidez = false;
                this.ativosRating = false;
            }
            this.setGraficoTabInvestimentos();
        },
        onConcentracaoTabClick () {
            this.isPerfil = true;
            setTimeout(()=>{
                $e850a708e44f691b$var$createCarteiraMarginsChart(this.graficoCarteira, this.margens);
                $e850a708e44f691b$var$createCarteiraAlvosChart(this.graficoCarteira, this.margens);
            }, 500);
        },
        switchFixedIncomeOption (chartName) {
            this.rating_chart = false;
            this.ativo_chart = false;
            this.emissor_chart = false;
            this.tipo_chart = false;
            this.indice_chart = false;
            this.tempo_vencimento_chart = false;
            this.setor_chart = false;
            this.ativosRating = false;
            this[chartName] = true;
        },
        async setTableAtivosRating (valores) {
            GLOBAL.destroyApexChart([
                'chart-rating'
            ]);
            this.ativosRating = true;
            this.isPerfil = false;
            NProgress.start();
            try {
                const table = document.querySelector('#table_ativos_rating');
                const bodyTable = table?.querySelector('tbody');
                const carteira = valores?.map((i)=>{
                    const arrItem = i[0] ? i[0] : i;
                    return {
                        valor: arrItem?.valor,
                        tipo_investimento: arrItem?.nome,
                        pct_global: arrItem?.pct_global,
                        pct_renda_fixa: arrItem?.pct_tipo_investimento,
                        indexador: arrItem?.indexador,
                        taxa: arrItem?.taxa,
                        vencimento: arrItem?.vencimento
                    };
                });
                bodyTable.innerHTML = this.templateBodyTable(carteira);
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        async getInfoRating () {
            this.rating_chart_fgc = true;
            this.rating_chart_total = false;
            this.rating_chart_total_fgc = false;
            this.ativosRating = false;
            this.buttonRatingAtivo = 'porcentagem_rating';
            this.switchFixedIncomeOption('rating_chart');
            const buttonRatingPorcentagem = document.querySelector('[data-rating="porcentagem_rating"]');
            if (!buttonRatingPorcentagem.classList.contains('active')) {
                const buttonsRating = document.querySelectorAll('.btn-chart-rating');
                buttonsRating?.forEach((button)=>{
                    if (button.classList.contains('active')) this.toggleClass(button, [
                        'active',
                        'secondary',
                        'tertiary'
                    ]);
                });
                this.toggleClass(buttonRatingPorcentagem, [
                    'active',
                    'secondary',
                    'tertiary'
                ]);
            }
            const { porcentagem_rating: porcentagem_rating } = await this.getDadosInvestimentosClientesFilter('Renda Fixa');
            this.porcentagem_rating = porcentagem_rating;
            setTimeout(()=>{
                this.destroyAllCharts();
                const chart = Apex['_chartInstances']?.filter((i)=>i.id == 'chart-rating')[0];
                if (chart) chart.chart.destroy();
                $e850a708e44f691b$var$createRatingChart(this.porcentagem_rating);
                this.addEventClickChartRating();
            }, 600);
        },
        async voltarChartRating () {
            this.rating_chart_fgc = true;
            this.rating_chart_total = false;
            this.rating_chart_total_fgc = false;
            this.ativosRating = false;
            const buttonsRatingPorcentagem = document.querySelectorAll('[data-rating]');
            buttonsRatingPorcentagem?.forEach(async (buttonRating)=>{
                if (buttonRating.classList.contains('active')) {
                    const dataRating = buttonRating.getAttribute('data-rating');
                    const dadosClienteRating = await this.getDadosInvestimentosClientesFilter('Renda Fixa');
                    this.porcentagem_rating = dadosClienteRating[dataRating];
                }
            });
            setTimeout(()=>{
                this.destroyAllCharts();
                const chart = Apex['_chartInstances']?.filter((i)=>i.id == 'chart-rating')[0];
                if (chart) chart.chart.destroy();
                $e850a708e44f691b$var$createRatingChart(this.porcentagem_rating);
                this.addEventClickChartRating();
            }, 600);
        },
        async voltarChartSetor () {
            this.ativosSetor = false;
            setTimeout(()=>{
                this.destroyAllCharts();
                const chart = Apex['_chartInstances']?.filter((i)=>i.id == 'chart-setor')[0];
                if (chart) chart.chart.destroy();
                $e850a708e44f691b$var$createSetorChart(this.setores);
                this.addEventClickChartSetor();
            }, 600);
        },
        getAtivosTipoPorcentagem (dadosClientesRating) {
            let ativos;
            const t = this;
            switch(t.buttonRatingAtivo){
                case 'porcentagem_rating':
                    ativos = dadosClientesRating.composicao_investimentos;
                    break;
                case 'porcentagem_rating_fgc':
                    ativos = dadosClientesRating.grafico_fgc;
                    break;
                case 'porcentagem_rating_fgc_menos_total':
                    ativos = dadosClientesRating.grafico_composicao_investimentos_menos_fgc;
                    break;
                default:
                    ativos = [];
            }
            return ativos;
        },
        addEventClickChartRating () {
            const t = this;
            const chart = Apex._chartInstances?.filter((i)=>i.id == 'chart-rating')?.[0];
            if (chart) chart.chart.updateOptions({
                chart: {
                    events: {
                        click: async function(event, chartContext, config) {
                            const key = config?.globals?.labels[config?.dataPointIndex];
                            if (!key) return;
                            t.periodo_ativo_rating = key;
                            const dadosClientesRating = await t.getDadosInvestimentosClientesFilter('Renda Fixa', `&rating=${key}`);
                            const listAtivos = t.getAtivosTipoPorcentagem(dadosClientesRating);
                            const valores = Object.values(listAtivos);
                            t.setTableAtivosRating(valores);
                        }
                    }
                }
            });
        },
        async alternaVisualizacaoChartRating (e, tipoRating) {
            this.ativosRating = false;
            const el = e?.target;
            const dataRating = el.getAttribute('data-rating');
            if (!el.classList.contains('active')) {
                const buttonsRating = document.querySelectorAll('.btn-chart-rating');
                buttonsRating?.forEach((button)=>{
                    if (button.classList.contains('active')) this.toggleClass(button, [
                        'active',
                        'secondary',
                        'tertiary'
                    ]);
                });
                this.toggleClass(el, [
                    'active',
                    'secondary',
                    'tertiary'
                ]);
            }
            const dadosClienteRating = await this.getDadosInvestimentosClientesFilter(tipoRating);
            if (dataRating) {
                this.buttonRatingAtivo = dataRating;
                this.porcentagem_rating = dadosClienteRating[dataRating];
            }
            setTimeout(()=>{
                this.destroyAllCharts();
                $e850a708e44f691b$var$createRatingChart(this.porcentagem_rating);
                this.addEventClickChartRating();
            }, 600);
        },
        async getInfoModalEmissor () {
            this.switchFixedIncomeOption('emissor_chart');
            await this.getDadosItensCarteira();
            this.chart_setor = false;
            await this.getInfoChartFiltro('#chart-emissor', 'chartEmissor', this.emissores, 'emissores', true);
        },
        alternaEstiloButtonChartEmissores (e) {
            const el = e.target;
            let classOutroBtn = [
                '.emissores_fgc',
                '.emissores_setor',
                '.emissores_todos'
            ];
            if (el.classList.contains('emissores_todos')) classOutroBtn = [
                '.emissores_fgc',
                '.emissores_setor',
                '.emissores_relocacao'
            ];
            else if (el.classList.contains('emissores_fgc')) classOutroBtn = [
                '.emissores_todos',
                '.emissores_setor',
                '.emissores_relocacao'
            ];
            else if (el.classList.contains('emissores_setor')) classOutroBtn = [
                '.emissores_todos',
                '.emissores_fgc',
                '.emissores_relocacao'
            ];
            else if (el.classList.contains('emissores_relocacao')) classOutroBtn = [
                '.emissores_todos',
                '.emissores_fgc',
                '.emissores_setor'
            ];
            if (!el.classList.contains('active')) {
                this.toggleClass(el, [
                    'active',
                    'secondary',
                    'tertiary'
                ]);
                if (classOutroBtn) classOutroBtn.forEach((selector)=>{
                    const btn = document.querySelector(selector);
                    if (btn) {
                        btn.classList.remove('active', 'secondary');
                        btn.classList.add('tertiary');
                    }
                });
            }
        },
        async setTableAtivosSetor (valores) {
            GLOBAL.destroyApexChart([
                'chart-setor'
            ]);
            this.ativosSetor = true;
            this.isPerfil = false;
            NProgress.start();
            try {
                const table = document.querySelector('#table_ativos_setor');
                const bodyTable = table?.querySelector('tbody');
                console.log({
                    valores: valores
                });
                const rowTable = valores?.map((i)=>{
                    const arrItem = i[0] ? i[0] : i;
                    return {
                        valor: arrItem?.valor,
                        tipo_investimento: arrItem?.nome,
                        pct_global: arrItem?.pct_global,
                        pct_renda_fixa: arrItem?.pct_tipo_investimento,
                        indexador: arrItem?.indexador,
                        taxa: arrItem?.taxa,
                        vencimento: arrItem?.vencimento
                    };
                });
                bodyTable.innerHTML = this.templateBodyTable(rowTable);
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        addEventClickChartSetor () {
            const t = this;
            const chart = Apex._chartInstances?.filter((i)=>i.id == 'chart-setor')?.[0];
            if (chart) chart.chart.updateOptions({
                chart: {
                    events: {
                        click: async function(event, chartContext, config) {
                            const key = config?.globals?.labels[config?.dataPointIndex];
                            if (!key) return;
                            t.periodo_ativo_setor = key;
                            const dadosClientesRating = await t.getDadosInvestimentosClientesFilter('Renda Fixa', `&setor=${key}`);
                            const listAtivos = dadosClientesRating?.ativos_grafico_setor;
                            const valores = Object.values(listAtivos);
                            t.setTableAtivosSetor(valores);
                        }
                    }
                }
            });
        },
        async getInfoModalSetor () {
            this.destroyAllCharts();
            const chart = Apex['_chartInstances']?.filter((i)=>i.id == 'chart-setor')[0];
            if (chart) chart.chart.destroy();
            this.switchFixedIncomeOption('setor_chart');
            await this.getDadosItensCarteira();
            $e850a708e44f691b$var$createSetorChart(this.setores);
            this.addEventClickChartSetor();
        },
        async alternaVisualizacaoChartEmissores (e) {
            const id = e.target.id;
            console.log({
                id: id
            });
            const verTodos = id === 'emissores';
            if (id === 'realocacao') {
                this.emissor_chart = false;
                this.chart_setor = false;
                this.realocacao_table = true;
                this.alternaEstiloButtonChartEmissores(e);
                return;
            } else this.realocacao_table = false;
            if (id && id !== 'setores') {
                this.emissor_chart = true;
                this.chart_setor = false;
                this.destroyAllCharts();
                setTimeout(async ()=>{
                    this.destroyAllCharts();
                    const chart = Apex['_chartInstances']?.filter((i)=>i.id == 'chartEmissor')[0];
                    if (chart) chart.chart.destroy();
                    //this.addEventClickChartRating()
                    await this.getInfoChartFiltro('#chart-emissor', 'chartEmissor', this[id], 'emissores', verTodos);
                }, 600);
            } else {
                this.chart_setor = true;
                this.getInfoModalSetor();
            }
            this.alternaEstiloButtonChartEmissores(e);
        },
        setChartBarraFiltro (idElement, idChart, itens, key, verTodos = false) {
            const chart = Apex._chartInstances?.filter((i)=>i.id == idChart)[0];
            if (chart) chart.chart.destroy();
            if (GLOBAL.isString(itens)) {
                chart?.chart.destroy();
                this.chartError = itens;
                return;
            } else this.chartError = null;
            let seriesValue = [];
            let labels = [];
            let valores = [];
            if (itens) {
                if (key === 'emissores' && verTodos) {
                    valores = Object.values(itens[key]);
                    seriesValue = valores.map((valor)=>valor.Total);
                } else if (key === 'emissores' && !verTodos) {
                    valores = Object.values(itens[key]);
                    seriesValue = valores.map((valor)=>valor.Total_fgc);
                } else seriesValue = Object.values(itens[key]);
                labels = Object.keys(itens[key]);
            }
            let seriesInfo = [];
            itens?.info.forEach((i)=>{
                seriesInfo.push(i.valor);
            });
            labels = labels?.map((label)=>{
                return label || 'OUTROS';
            });
            let valorLinha = 0;
            if (key === 'emissores') valorLinha = 250000.0;
            else if (key === 'tipos') valorLinha = verTodos ? 250000.0 : 1000000.0 - this.total_eventos_de_credito;
            const annotations = {
                yaxis: [
                    {
                        y: valorLinha,
                        strokeDashArray: 3,
                        borderColor: '#6D6F71',
                        label: {
                            show: false,
                            borderColor: '#775DD0',
                            style: {
                                color: '#fff',
                                background: '#775DD0'
                            },
                            text: undefined
                        }
                    }
                ]
            };
            const legend = key === 'tipos' || key === 'emissores' ? {
                show: true,
                markers: {
                    width: 20,
                    height: 4,
                    strokeColor: '#fff',
                    radius: 8
                },
                itemMargin: {
                    horizontal: 8,
                    vertical: 24
                }
            } : {
                show: false
            };
            console.log({
                seriesInfo: seriesInfo,
                seriesValue: seriesValue
            });
            new ApexCharts(document.querySelector(idElement), {
                chart: {
                    id: idChart,
                    type: 'bar',
                    height: 450,
                    // width: labels.length > 12
                    // ? `${labels.length * 150}px`
                    // : '100%',
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    }
                },
                colors: [
                    '#c11f39',
                    '#7B0100'
                ],
                labels: labels,
                annotations: annotations,
                series: [
                    {
                        name: 'Valor presente',
                        data: seriesValue
                    },
                    {
                        name: "Rendimento at\xe9 vencimento",
                        data: seriesInfo
                    }
                ],
                legend: legend,
                tooltip: {
                    enabled: true,
                    shared: true,
                    intersect: false,
                    custom: (seriesName)=>{
                        const currentValue = seriesName.series[seriesName.seriesIndex];
                        const valorEmissor = key === 'emissores' && verTodos;
                        const currentIndex = seriesName.dataPointIndex;
                        const isFGC = this.emissores_fgc?.emissores[labels[currentIndex]];
                        const porcentagem = valorEmissor ? `<p class="text-neutral-70 font-normal text-xs">Percentual do PL: ${valores[currentIndex].Percentual}%</p>` : '';
                        const porcentagemFgc = key === 'emissores' && !verTodos ? `<p class="text-neutral-70 font-normal text-xs">Percentual do PL: ${valores[currentIndex].Percentual_fgc}%</p>` : '';
                        const diffFGCValue = itens?.info[currentIndex].dif_fgc == '-' ? "N\xe3o encontrado" : GLOBAL.formatReal2(itens?.info[currentIndex].dif_fgc);
                        const diffFGC = isFGC ? `
					<p class="text-neutral-70 font-normal text-xs">Dif. FGC: ${diffFGCValue}</p>` : '';
                        return `<div class="p-12 bg-white">
								<p class="font-medium text-sm text-neutral-100">${labels[currentIndex]}</p>
								<p class="text-neutral-70 font-normal text-xs">${GLOBAL.formatReal2(currentValue[currentIndex])}</p>
								${porcentagem || porcentagemFgc}
								<p class="text-neutral-70 font-normal text-xs">Rentabilizado: ${seriesInfo[currentIndex] == '-' ? "N\xe3o encontrado" : GLOBAL.formatReal2(seriesInfo[currentIndex])}</p>
								${diffFGC}
							</div>`;
                    }
                },
                yaxis: {
                    show: true,
                    showAlways: true,
                    labels: {
                        formatter: function(val, index) {
                            let formatter = Intl.NumberFormat('en', {
                                notation: 'compact'
                            });
                            return ` ${formatter.format(val)}`;
                        }
                    }
                },
                xaxis: {
                    type: 'category',
                    categories: labels,
                    labels: {
                        show: true,
                        formatter: (val)=>{
                            let str = val.length > 10 ? val.substring(0, 10) + '...' : val;
                            return str || 'OUTROS';
                        }
                    },
                    style: {
                        colors: [
                            '#01071B'
                        ],
                        fontSize: '10px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 400,
                        cssClass: 'apexcharts-xaxis-label'
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function(val, opt) {
                        return '';
                    }
                }
            }).render();
        },
        async setGraficoTabInvestimentos (info /* dados dos investimentos */ ) {
            await this.getDadosUpdateModal();
            const t = this;
            const idChart = '#chart-tab-divisao-investimento';
            GLOBAL.destroyApexChart('chartTabInvestimentos');
            if (GLOBAL.isString(this.graficoCarteira)) {
                //coloca a mensagem que o back manda se a resposta for string
                this.chartError = this.graficoCarteira;
                return;
            } else this.chartError = null;
            const graficoCarteiraOrdered = GLOBAL.mergeSortAnArrayWithObjects(this.graficoCarteira?.map((i)=>({
                    ...i,
                    porcentagem: Number(i.porcentagem)
                })), 'porcentagem', true);
            const series = graficoCarteiraOrdered.map((i)=>i.porcentagem);
            const valores = graficoCarteiraOrdered.map((i)=>Number(i.valor));
            const labels = graficoCarteiraOrdered.map((i)=>i.tipo_investimento);
            const colors = this.defineColors(labels);
            if (info) this.infoGraficoModal = info.name;
            else this.infoGraficoModal = null;
            document.querySelector(idChart).innerHTML = '';
            new ApexCharts(document.querySelector(idChart), {
                ...optionsApexAtendimento,
                chart: {
                    fontFamily: 'Roboto Flex, sans-serif',
                    id: 'chartTabInvestimentos',
                    width: '100%',
                    height: 450,
                    type: 'donut',
                    events: {
                        click: function(event, chartContext, config) {
                            if (t.isFundacao) return;
                            if (t.infoGraficoModal) return;
                            let posSelected = config.globals?.selectedDataPoints[0];
                            let labels = config.globals?.labels;
                            const nameSelected = labels[posSelected];
                            if (!nameSelected) return;
                            t.getInfoModalClienteTabInvestimentos(nameSelected);
                        }
                    }
                },
                colors: colors,
                tooltip: {
                    enabled: true,
                    x: {
                        formatter: function(value, opts) {
                            return value;
                        }
                    },
                    y: {
                        formatter: function(value, opts) {
                            const index = opts.seriesIndex;
                            const sum = valores.reduce((a, b)=>a + b, 0);
                            const percent = valores / sum * 100;
                            return `${GLOBAL.formatReal2(valores[index])} (${value.toFixed(2)}%)`;
                        }
                    }
                },
                legend: {
                    show: true,
                    showForSingleSeries: false,
                    showForNullSeries: true,
                    showForZeroSeries: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    verticalAlign: 'center',
                    floating: false,
                    fontSize: '0.88rem',
                    fontFamily: 'Roboto Flex, sans-serif',
                    fontWeight: 400,
                    inverseOrder: false,
                    offsetX: 0,
                    offsetY: 0,
                    markers: {
                        // width: 12,
                        // height: 12,
                        strokeWidth: 0,
                        strokeColor: '#fff',
                        radius: 12
                    }
                },
                series: series,
                labels: labels
            }).render();
            document.querySelectorAll('#chart-tab-divisao-investimento .apexcharts-datalabels').forEach((label, index)=>{
                const rect = label.querySelector('rect');
                const text = label.querySelector('text').textContent;
                const i = labels.findIndex((label)=>text.startsWith(label));
                const x = parseInt(Number(rect.getAttribute('x'))) + 11;
                const y = parseInt(Number(rect.getAttribute('y'))) + 15;
                rect.insertAdjacentHTML('afterend', `<circle cx="${x}" cy="${y}" r="6" fill="${colorsChatAtendimento[i]}"/>`);
            });
        },
        //Grafico por emissor
        async getInfoChartFiltro (idElement, idChart, itens, key, verTodos) {
            NProgress.start();
            try {
                this.setChartBarraFiltro(idElement, idChart, itens, key, verTodos);
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        //Grafico por tipo
        async getInfoModalTipo () {
            this.switchFixedIncomeOption('tipo_chart');
            await this.getDadosItensCarteira();
            await this.getInfoChartFiltro('#chart-tipo', 'chartTipo', this.tipos, 'tipos', true);
        },
        async getInfoModalIndice () {
            this.switchFixedIncomeOption('indice_chart');
            NProgress.start();
            try {
                await this.getDadosItensCarteira();
                this.setGraficoIndice();
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        async getInfoModalTempoVencimento () {
            this.switchFixedIncomeOption('tempo_vencimento_chart');
            this.tempo_vencimento = await $e850a708e44f691b$var$getDadosTempoVencimento(this.clienteAtivo.id);
            await $e850a708e44f691b$var$createTempoVencimentoCharts(this.tempo_vencimento);
        },
        async getInfoModalClienteTabInvestimentos (nameSelected) {
            this.isInvestimento = true;
            this.tipo_investimento = nameSelected;
            this.ativosTableSortKey = '';
            this.ativosTableSortOrderInDesc = false;
            if (nameSelected !== 'Renda Fixa') {
                this.rendaFixa = false;
                await this.clickItensInvestimentos(nameSelected);
            } else {
                this.rendaFixa = true;
                this.ativo_chart = true;
                this.ativo_table = true;
                NProgress.start();
                try {
                    const results = await this.getDadosInvestimentosClientes(nameSelected);
                    const table = document.querySelector('#table_ativos');
                    const bodyTable = table.querySelector('tbody');
                    this.carteiraTabelaInvestimento = results?.map((i)=>({
                            valor: i[0].valor,
                            tipo_investimento: i[0].nome,
                            pct_global: i[0].pct_global,
                            pct_renda_fixa: i[0].pct_tipo_investimento,
                            indexador: i[0].indexador,
                            taxa: i[0].taxa,
                            vencimento: i[0].vencimento
                        }));
                    bodyTable.innerHTML = this.templateBodyTable(this.carteiraTabelaInvestimento);
                    const chartAtendimento1 = Apex._chartInstances?.filter((i)=>i.id == 'chartTabInvestimentos')[0];
                    chartAtendimento1?.chart.destroy();
                    GLOBAL.destroyApexChart([
                        'chartTabInvestimentos'
                    ]);
                    this.setGraficoAtivo({
                        name: nameSelected
                    });
                } catch (e) {
                    GLOBAL.errorDefault(e);
                } finally{
                    NProgress.done();
                }
            }
        },
        async getInfoDetalhesVolatilidade (periodo, data_inicio, data_fim) {
            const resultVolatilidade = await $e850a708e44f691b$var$getDetalhesVolatilidade(this.clienteAtivo.id, periodo, data_inicio, data_fim);
            return resultVolatilidade;
        },
        async getInfoModalCliente (nameSelected, rating = '') {
            NProgress.start();
            try {
                const { data: data } = await axios.get(`${window.location.origin}/atendimento/grafico_composicao_cliente_pf/?cliente_pf=${this.clienteAtivo.id}&tipo_investimento=${nameSelected}&rating=${rating}`);
                console.log({
                    data: data
                });
                this.porcentagem_rating = data?.porcentagem_rating;
                if (!data?.composicao_investimentos) return;
                const composisaoInvestimentos = Object.values(data?.composicao_investimentos)?.flat();
                this.graficoCarteira = composisaoInvestimentos?.map((i)=>({
                        valor: i.valor,
                        tipo_investimento: i.nome,
                        porcentagem: i.taxa
                    }));
                const chartAtendimento1 = Apex._chartInstances?.filter((i)=>i.id == 'chartIndice')[0];
                chartAtendimento1 && chartAtendimento1.chart.destroy();
                this.setGraficoCarteira({
                    name: nameSelected
                });
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        setGraficoCarteira (info /* dados dos investimentos */ ) {
            const t = this;
            const idChart = t.isFundacao ? '#chart-divisao-investimento' : '#chart-divisao-investimento-pf';
            const id = t.isFundacao ? 'chartAtendimento' : 'chartCarteira';
            GLOBAL.destroyApexChart(id);
            if (GLOBAL.isString(this.graficoCarteira)) {
                //coloca a mensagem que o back manda se a resposta for string
                chartAtendimento?.chart.destroy();
                this.chartError = this.graficoCarteira;
                return;
            } else this.chartError = null;
            const graficoCarteiraOrdered = GLOBAL.mergeSortAnArrayWithObjects(this.graficoCarteira?.map((i)=>({
                    ...i,
                    porcentagem: Number(i.porcentagem)
                })), 'porcentagem', true);
            const valores = graficoCarteiraOrdered.map((i)=>Number(i.valor));
            const porcentagens = graficoCarteiraOrdered.map((i)=>Number(i.porcentagem));
            let labels;
            if (t.isFundacao) labels = graficoCarteiraOrdered.map((i)=>i.estrategia);
            else labels = graficoCarteiraOrdered.map((i)=>i.tipo_investimento);
            const series = graficoCarteiraOrdered.map((i)=>Number(i.valor));
            if (info) this.infoGraficoModal = info.name;
            else this.infoGraficoModal = null;
            new ApexCharts(document.querySelector(idChart), {
                ...optionsApexAtendimento,
                chart: {
                    fontFamily: 'Roboto Flex, sans-serif',
                    id: id,
                    width: '100%',
                    height: '380px',
                    type: 'donut',
                    events: {
                        click: function(event, chartContext, config) {
                            if (t.isFundacao) return;
                            if (t.infoGraficoModal) return;
                            let posSelected = config.globals?.selectedDataPoints[0];
                            let labels = config.globals?.labels;
                            const nameSelected = labels[posSelected];
                            if (!nameSelected) return;
                            t.getInfoModalCliente(nameSelected);
                        }
                    }
                },
                title: {
                    text: 'Carteira Atual',
                    align: 'center',
                    margin: 0,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '16px',
                        fontWeight: 'normal',
                        fontFamily: undefined,
                        color: '#263238'
                    }
                },
                tooltip: {
                    enabled: true,
                    x: {
                        formatter: function(value, opts) {
                            return `${value}%`;
                        }
                    },
                    y: {
                        formatter: function(value) {
                            const sum = valores?.reduce((a, b)=>a + b, 0);
                            const percent = value / sum * 100;
                            return `${GLOBAL.formatReal2(value)} (${percent?.toFixed(2)}%)`;
                        }
                    }
                },
                legend: {
                    show: true,
                    showForSingleSeries: false,
                    showForNullSeries: true,
                    showForZeroSeries: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    verticalAlign: 'center',
                    floating: false,
                    fontSize: '0.88rem',
                    fontFamily: 'Roboto Flex, sans-serif',
                    fontWeight: 400,
                    inverseOrder: false,
                    offsetX: 0,
                    offsetY: 0,
                    markers: {
                        strokeWidth: 0,
                        strokeColor: '#fff',
                        radius: 12
                    }
                },
                series: series,
                labels: labels
            }).render();
            document.querySelectorAll('#chart-divisao-investimento-pf .apexcharts-datalabels').forEach((label, index)=>{
                const rect = label.querySelector('rect');
                const text = label.querySelector('text').textContent;
                const i = labels.findIndex((label)=>text.startsWith(label));
                const x = parseInt(Number(rect.getAttribute('x'))) + 11;
                const y = parseInt(Number(rect.getAttribute('y'))) + 15;
                rect.insertAdjacentHTML('afterend', `<circle cx="${x}" cy="${y}" r="6" fill="${colorsChatAtendimento[i]}"/>`);
            });
            this.divisao_chart = true;
        },
        setGraficoIndice (info) {
            const t = this;
            const idChart = '#chart-indice';
            this.divisao_chart = false;
            GLOBAL.destroyApexChart([
                'chartCarteira',
                'chartIndice'
            ]);
            if (GLOBAL.isString(this.indices)) {
                //coloca a mensagem que o back manda se a resposta for string
                chartIndice?.chart.destroy();
                this.chartError = this.indices;
                return;
            } else this.chartError = null;
            let labels = Object.keys(this.indices);
            labels = labels.map((label)=>label === '' || label === 'null' ? 'OUTROS' : label);
            const values = Object.values(this.indices);
            const series = values.map((item)=>item.valor);
            if (info) this.infoGraficoModal = info.name;
            else this.infoGraficoModal = null;
            new ApexCharts(document.querySelector(idChart), {
                ...optionsApexAtendimento,
                chart: {
                    fontFamily: 'Roboto Flex, sans-serif',
                    id: 'chartIndice',
                    width: '100%',
                    height: 450,
                    type: 'donut',
                    events: {
                        click: function(event, chartContext, config) {
                            if (t.isFundacao) return;
                            if (t.infoGraficoModal) return;
                            let posSelected = config.globals?.selectedDataPoints[0];
                            let labels = config.globals?.labels;
                            const nameSelected = labels[posSelected];
                            if (!nameSelected) return;
                            t.getInfoModalCliente(nameSelected);
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    x: {
                        formatter: function(value, opts) {
                            return value;
                        }
                    },
                    y: {
                        formatter: function(value, opts) {
                            return `${GLOBAL.formatReal2(value)} (${values[opts.seriesIndex].porcentagem}%)`;
                        }
                    }
                },
                legend: {
                    show: true,
                    showForSingleSeries: false,
                    showForNullSeries: true,
                    showForZeroSeries: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    verticalAlign: 'center',
                    floating: false,
                    fontSize: '0.75rem',
                    fontFamily: 'Roboto Flex, sans-serif',
                    fontWeight: 400,
                    inverseOrder: false,
                    width: '100%',
                    offsetX: 0,
                    offsetY: 0,
                    markers: {
                        // width: 12,
                        // height: 12,
                        strokeWidth: 0,
                        strokeColor: '#fff',
                        radius: 12
                    }
                },
                series: series,
                labels: labels
            }).render();
            document.querySelectorAll('#chart-indice .apexcharts-datalabels').forEach((label, index)=>{
                const rect = label.querySelector('rect');
                const text = label.querySelector('text').textContent;
                const i = labels.findIndex((label)=>text.startsWith(label));
                const x = parseInt(Number(rect.getAttribute('x'))) + 11;
                const y = parseInt(Number(rect.getAttribute('y'))) + 15;
                rect.insertAdjacentHTML('afterend', `<circle cx="${x}" cy="${y}" r="6" fill="${colorsChatAtendimento[i]}"/>`);
            });
        },
        setGraficoAtivo (info /* dados dos investimentos */ ) {
            const idChart = '#chart-ativo';
            const chartAtivo = Apex._chartInstances?.filter((i)=>i.id === 'chartAtivo')[0];
            GLOBAL.destroyApexChart([
                'chartTabInvestimentos'
            ]);
            if (chartAtivo) chartAtivo.chart.destroy();
            if (GLOBAL.isString(this.graficoCarteira)) {
                //coloca a mensagem que o back manda se a resposta for string
                chartAtivo?.chart.destroy();
                this.chartError = this.graficoCarteira;
                return;
            } else this.chartError = null;
            const series = this.graficoCarteira?.map((i)=>Number(i.valor)) || [];
            let keyPct = '';
            if (this.rendaFixa) keyPct = 'pct_renda_fixa';
            else keyPct = 'pct_tipo_investimento';
            const porcentagens = this.graficoCarteira?.map((i)=>{
                return Number(i[keyPct]);
            });
            const labels = this.graficoCarteira?.map((i)=>i.tipo_investimento) || [];
            if (info) this.infoGraficoModal = info.name;
            else this.infoGraficoModal = null;
            new ApexCharts(document.querySelector(idChart), {
                ...optionsApexAtendimento,
                chart: {
                    fontFamily: 'Roboto Flex, sans-serif',
                    id: 'chartAtivo',
                    width: '100%',
                    height: '380px',
                    type: 'donut'
                },
                legend: {
                    show: true,
                    showForSingleSeries: false,
                    showForNullSeries: true,
                    showForZeroSeries: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    verticalAlign: 'center',
                    floating: false,
                    fontSize: '0.88rem',
                    fontFamily: 'Roboto Flex, sans-serif',
                    fontWeight: 400,
                    inverseOrder: false,
                    offsetX: 0,
                    offsetY: 0,
                    markers: {
                        strokeWidth: 0,
                        strokeColor: '#fff',
                        radius: 12
                    }
                },
                tooltip: {
                    y: {
                        formatter: function(value, opts) {
                            const index = opts.seriesIndex;
                            const sum = opts.config.series.reduce((a, b)=>a + b, 0);
                            return `${GLOBAL.formatReal2(value)} (${porcentagens[index].toFixed(2)}%) `;
                        }
                    }
                },
                series: series,
                labels: labels
            }).render();
            document.querySelectorAll('#chart-ativo .apexcharts-datalabels').forEach((label, index)=>{
                const rect = label.querySelector('rect');
                const text = label.querySelector('text').textContent;
                const i = labels.findIndex((label)=>text.startsWith(label));
                const x = parseInt(Number(rect.getAttribute('x'))) + 11;
                const y = parseInt(Number(rect.getAttribute('y'))) + 15;
                rect.insertAdjacentHTML('afterend', `<circle cx="${x}" cy="${y}" r="6" fill="${colorsChatAtendimento[i]}"/>`);
            });
        },
        async setGraficoPerfilInvestidor (info /* dados dos investimentos */ ) {
            const t = this;
            const idChart = '#chart-divisao-carteira-investimentos';
            const ChartInvestimento = Apex._chartInstances?.filter((i)=>i.id === 'ChartInvestimento')[0];
            if (ChartInvestimento) ChartInvestimento.chart.destroy();
            if (GLOBAL.isString(this.graficoCarteira)) {
                //coloca a mensagem que o back manda se a resposta for string
                ChartInvestimento?.chart.destroy();
                this.chartError = this.graficoCarteira;
                return;
            } else this.chartError = null;
            if (this.clienteAtivo.perfil_investidor_id) await this.getPerfilInvestidor(this.clienteAtivo.perfil_investidor_id);
            else this.perfilInvestidor = [];
            const series = this.perfilInvestidor?.item_perfil_investidor_read?.map((i)=>Number(i.alvo));
            const labels = this.perfilInvestidor?.item_perfil_investidor_read?.map((i)=>i.tipo_investimento);
            if (info) this.infoGraficoModal = info.name;
            else this.infoGraficoModal = null;
            const colors = this.defineColors(labels);
            new ApexCharts(document.querySelector(idChart), {
                ...optionsApexAtendimento,
                chart: {
                    fontFamily: 'Roboto Flex, sans-serif',
                    id: 'chartInvestimento',
                    width: '100%',
                    height: '380px',
                    type: 'donut',
                    events: {
                        click: function(event, chartContext, config) {
                            if (t.isFundacao) return;
                            if (t.infoGraficoModal) return;
                            let posSelected = config.globals?.selectedDataPoints[0];
                            let labels = config.globals?.labels;
                            const nameSelected = labels[posSelected];
                            if (!nameSelected) return;
                            t.getInfoModalCliente(nameSelected);
                        }
                    }
                },
                colors: colors,
                tooltip: {
                    enabled: true,
                    x: {
                        formatter: function(value) {
                            return `${value}%`;
                        }
                    },
                    y: {
                        formatter: function(value, opts) {
                            return `${value.toFixed(1)}%`;
                        }
                    }
                },
                title: {
                    text: `${this.perfilInvestidor.nome}`,
                    align: 'center',
                    margin: 0,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '16px',
                        fontWeight: 'normal',
                        fontFamily: undefined,
                        color: '#263238'
                    }
                },
                legend: {
                    show: true,
                    showForSingleSeries: false,
                    showForNullSeries: true,
                    showForZeroSeries: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    verticalAlign: 'center',
                    floating: false,
                    fontSize: '0.75rem',
                    fontFamily: 'Roboto Flex, sans-serif',
                    fontWeight: 400,
                    inverseOrder: false,
                    width: '100%',
                    offsetX: 0,
                    offsetY: 0,
                    markers: {
                        strokeWidth: 0,
                        strokeColor: '#fff',
                        radius: 12
                    }
                },
                series: series,
                labels: labels
            }).render();
            document.querySelectorAll('#chart-divisao-carteira-investimentos .apexcharts-datalabels').forEach((label, index)=>{
                const rect = label.querySelector('rect');
                const text = label.querySelector('text').textContent;
                const i = labels.findIndex((label)=>text.startsWith(label));
                const x = parseInt(Number(rect.getAttribute('x'))) + 11;
                const y = parseInt(Number(rect.getAttribute('y'))) + 15;
                rect.insertAdjacentHTML('afterend', `<circle cx="${x}" cy="${y}" r="6" fill="${colorsChatAtendimento[i]}"/>`);
            });
        },
        resetButtonsFilters () {
            const btns = document.querySelectorAll('.btn-chart-filter');
            this.switchFixedIncomeOption('');
            btns.forEach((btn)=>{
                if (btn.classList.contains('ativo-inicial')) !btn.classList.contains('active') && this.toggleClass(btn, [
                    'active',
                    'secondary',
                    'tertiary'
                ]);
                else {
                    btn.classList.add('tertiary');
                    btn.classList.remove(...[
                        'secondary',
                        'active'
                    ]);
                }
            });
        },
        destroyAllCharts () {
            GLOBAL.destroyApexChart([
                'chartCarteira',
                'chartTabInvestimentos',
                'chartInvestimento',
                'chartAtivo',
                'chartEmissor',
                'chartTipo',
                'chartIndice',
                'chartTempoVencimentoIPCA',
                'chartTempoVencimentoPos',
                'chartTempoVencimentoPre',
                'chartCarteiraMargens',
                'chart-volatilidade-1m',
                'chart-volatilidade-3m',
                'chart-retorno',
                'chart-rating'
            ]);
        },
        setDates () {
            let [day, month, year] = this.dataAtualCarteira.split('/');
            let newDate = new Date(year, month - 1, day);
            let dataInicio = Quasar.date.subtractFromDate(newDate, {
                days: 90
            });
            this.data_inicio = Quasar.date.formatDate(dataInicio, 'DD/MM/YYYY');
            this.data_fim = Quasar.date.formatDate(newDate, 'DD/MM/YYYY');
        }
    },
    mounted () {}
};

});
parcelRegister("1tEcV", function(module, exports) {

$parcel$export(module.exports, "useCarteiraAlvosChart", function () { return $1137b044bb399fab$export$18cb53d8199830e3; });

var $8YPrY = parcelRequire("8YPrY");

var $1F5Ay = parcelRequire("1F5Ay");
const { createChart: $1137b044bb399fab$var$createChart, setColorsInFunctionOfAHexadecimalColor: $1137b044bb399fab$var$setColorsInFunctionOfAHexadecimalColor } = (0, $1F5Ay.useCharts)();
function $1137b044bb399fab$export$18cb53d8199830e3() {
    function createCarteiraAlvosChart(graficoCarteira, concentracao) {
        const graficoCarteiraOrdered = GLOBAL.mergeSortAnArrayWithObjects(graficoCarteira?.map((i)=>({
                ...i,
                porcentagem: Number(i.porcentagem)
            })), 'porcentagem', true);
        const concentracaoOrdered = GLOBAL.mergeSortAnArrayWithObjects(concentracao?.map((i)=>({
                ...i,
                porcentagem: Number(i.porcentagem)
            })), 'porcentagem', true);
        let series = concentracaoOrdered.map((item)=>{
            const itemCarteira = graficoCarteira.find(({ tipo_investimento: tipo_investimento })=>tipo_investimento === item.tipo_investimento);
            return {
                name: item.tipo_investimento,
                data: [
                    parseFloat(item.alvo),
                    itemCarteira?.porcentagem ? parseFloat(itemCarteira.porcentagem) : 0
                ],
                porcentagem: itemCarteira?.porcentagem ? Number(itemCarteira.porcentagem) : 0
            };
        });
        series = [
            ...series,
            ...graficoCarteiraOrdered.filter(({ tipo_investimento: tipo_investimento })=>!series.some((item)=>item.name === tipo_investimento)).map((item)=>{
                return {
                    name: item.tipo_investimento,
                    data: [
                        0,
                        parseFloat(item.porcentagem)
                    ],
                    porcentagem: Number(item.porcentagem)
                };
            })
        ];
        series = GLOBAL.mergeSortAnArrayWithObjects(series, 'porcentagem', true);
        const categories = series.map(({ name: name })=>name);
        const colors = GLOBAL.defineColors(categories);
        const options = {
            ...(0, $8YPrY.CARTEIRA_ALVOS_CHART_OPTIONS),
            series: series,
            colors: colors
        };
        $1137b044bb399fab$var$createChart((0, $8YPrY.CARTEIRA_ALVOS_CHART_ID), options);
    }
    return {
        createCarteiraAlvosChart: createCarteiraAlvosChart
    };
}

});
parcelRegister("8YPrY", function(module, exports) {

$parcel$export(module.exports, "CARTEIRA_ALVOS_CHART_OPTIONS", function () { return $689bd648247f656e$export$fbf5325514b0e83a; });
$parcel$export(module.exports, "CARTEIRA_ALVOS_CHART_ID", function () { return $689bd648247f656e$export$5747d2ce73be8419; });
const $689bd648247f656e$export$fbf5325514b0e83a = {
    chart: {
        type: 'bar',
        height: 200,
        stacked: true,
        id: 'chartCarteiraAlvos',
        fontFamily: 'Roboto Flex, sans-serif',
        toolbar: {
            show: false
        },
        zoom: {
            enabled: false
        }
    },
    plotOptions: {
        bar: {
            horizontal: true,
            height: 27,
            dataLabels: {
                total: {
                    enabled: false
                }
            }
        }
    },
    dataLabels: {
        enabled: true,
        enabledOnSeries: true,
        formatter: (val)=>{
            return `${parseFloat(val).toFixed(2)}%`;
        },
        style: {
            fontSize: '10px'
        }
    },
    title: {
        text: 'Carteira vs Alvos',
        margin: 4,
        fontWeight: 400,
        fontFamily: 'Roboto Flex, sans-serif',
        align: 'center',
        color: '#5C5C5C'
    },
    xaxis: {
        categories: [
            'Perfil',
            'Carteira'
        ],
        labels: {
            formatter: (value)=>{
                return `${value}%`;
            }
        }
    },
    yaxis: {
        max: 100,
        min: 0,
        stepSize: 10
    },
    tooltip: {
        y: {
            formatter: (val)=>{
                return `${parseFloat(val).toFixed(2)}%`;
            }
        }
    },
    legend: {
        show: true,
        showForSingleSeries: true,
        showForNullSeries: true,
        showForZeroSeries: true,
        fontSize: '10px',
        fontFamily: 'Roboto Flex, sans-serif',
        fontWeight: 400
    }
};
const $689bd648247f656e$export$5747d2ce73be8419 = '#chart-carteira-alvos';

});

parcelRegister("1F5Ay", function(module, exports) {

$parcel$export(module.exports, "useCharts", function () { return $135df48c01954433$export$477fcce2970f82d7; });
/**
 * A composable to handle charts. It abstracts charts common features.
 * 
 * @returns chart, chartElement, createChart, setColorsInFunctionOfAHexadecimalColor
 */ function $135df48c01954433$export$477fcce2970f82d7() {
    let chart;
    let chartElement;
    /**
	 * This method creates a new chart using ApexCharts.
	 * 
	 * @param {*} chartElementSelector Chart element selector
	 * @param {*} options Chart options
	 */ function createChart(chartElementSelector, options = {}) {
        chartElement = document.querySelector(chartElementSelector);
        chart = new ApexCharts(chartElement, {
            ...options
        });
        chart.render();
    }
    /**
	 * This method set a range of colors based in a unique color and a factor value that will reduce the color opacity based in this factor and the series children index.
	 * 
	 * @param {*} color 
	 * @param {*} series 
	 * @param {*} stepFactor 
	 * @returns 
	 */ function setColorsInFunctionOfAHexadecimalColor(color, series, stepFactor = 15) {
        return Object.keys(series).map((_, index)=>`${color}${GLOBAL.convertDecimalInHexadecimal(255 - index * stepFactor)}`);
    }
    return {
        chart: chart,
        chartElement: chartElement,
        createChart: createChart,
        setColorsInFunctionOfAHexadecimalColor: setColorsInFunctionOfAHexadecimalColor
    };
}

});


parcelRegister("5Xbti", function(module, exports) {

$parcel$export(module.exports, "useCarteiraMarginsChart", function () { return $455b5c756e5f105d$export$a714c806b5c3b175; });

var $kRDUb = parcelRequire("kRDUb");

var $1F5Ay = parcelRequire("1F5Ay");

var $d6LoN = parcelRequire("d6LoN");
const { buildMarginsLines: $455b5c756e5f105d$var$buildMarginsLines, serializeLimites: $455b5c756e5f105d$var$serializeLimites } = (0, $d6LoN.useConcentracao)();
const { createChart: $455b5c756e5f105d$var$createChart, setColorsInFunctionOfAHexadecimalColor: $455b5c756e5f105d$var$setColorsInFunctionOfAHexadecimalColor } = (0, $1F5Ay.useCharts)();
function $455b5c756e5f105d$export$a714c806b5c3b175() {
    function createCarteiraMarginsChart(graficoCarteira, margins) {
        const graficoCarteiraOrdered = GLOBAL.mergeSortAnArrayWithObjects(graficoCarteira?.map((i)=>({
                ...i,
                porcentagem: Number(i.porcentagem)
            })), 'porcentagem', true);
        const seriesData = graficoCarteiraOrdered.map(({ porcentagem: porcentagem })=>parseFloat(porcentagem));
        const investimentosMargins = graficoCarteiraOrdered.map((itemCarteira)=>{
            const investimentoMargins = margins.find(({ tipo_investimento: tipo_investimento })=>itemCarteira.tipo_investimento === tipo_investimento);
            if (!investimentoMargins) return null;
            const { limite_inferior: limite_inferior, limite_superior: limite_superior } = investimentoMargins;
            return $455b5c756e5f105d$var$serializeLimites(limite_inferior, limite_superior);
        });
        const categories = graficoCarteiraOrdered.map(({ tipo_investimento: tipo_investimento })=>tipo_investimento);
        const colors = GLOBAL.defineColors(categories);
        const options = {
            ...(0, $kRDUb.CARTEIRA_MARGINS_CHART_OPTIONS),
            colors: colors,
            series: [
                {
                    data: seriesData
                }
            ],
            xaxis: {
                type: 'category',
                categories: categories,
                max: 100,
                stepSize: 10,
                labels: {
                    formatter: (value)=>{
                        return `${value}%`;
                    }
                }
            },
            tooltip: {
                enabled: true,
                shared: false,
                followCursor: true,
                x: {
                    show: false
                },
                custom: handleCustomTooltip(investimentosMargins, categories)
            }
        };
        $455b5c756e5f105d$var$createChart((0, $kRDUb.CARTEIRA_MARGINS_CHART_ID), options);
        $455b5c756e5f105d$var$buildMarginsLines((0, $kRDUb.CARTEIRA_MARGINS_CHART_ID), investimentosMargins);
        window.addEventListener('resize', ()=>setTimeout(()=>$455b5c756e5f105d$var$buildMarginsLines((0, $kRDUb.CARTEIRA_MARGINS_CHART_ID), investimentosMargins), 500));
    }
    function handleCustomTooltip(margins, categories) {
        return ({ series: series, seriesIndex: seriesIndex, dataPointIndex: dataPointIndex })=>{
            const margin = margins[dataPointIndex];
            const tipoInvestimento = categories[dataPointIndex];
            return `
			<div class="arrow_box p-8 bg-white"
			>
				<p class="font-medium text-sm text-neutral-100">${tipoInvestimento}</p>
				<p class="text-neutral-70 font-normal text-xs">Porcentagem: ${parseFloat(series[seriesIndex][dataPointIndex]).toFixed(2)}%</p>
				${margin ? `<p class="text-neutral-70 font-normal text-xs">Margem inferior: ${margin[0]}%</p>
				<p class="text-neutral-70 font-normal text-xs">Margem superior: ${margin[1]}%</p>` : ``}
			</div>
		`;
        };
    }
    return {
        createCarteiraMarginsChart: createCarteiraMarginsChart
    };
}

});
parcelRegister("kRDUb", function(module, exports) {

$parcel$export(module.exports, "CARTEIRA_MARGINS_CHART_OPTIONS", function () { return $f307b637f166549c$export$ba7378882f772e2b; });
$parcel$export(module.exports, "CARTEIRA_MARGINS_CHART_ID", function () { return $f307b637f166549c$export$fdce83568c42d93f; });
const $f307b637f166549c$export$ba7378882f772e2b = {
    title: {
        text: 'Carteira vs Margens',
        margin: 4,
        fontWeight: 400,
        fontFamily: 'Roboto Flex, sans-serif',
        align: 'center',
        color: '#5C5C5C'
    },
    chart: {
        id: 'chartCarteiraMargens',
        fontFamily: 'Roboto Flex, sans-serif',
        type: 'bar',
        height: 600,
        toolbar: {
            show: false
        },
        zoom: {
            enabled: false
        }
    },
    dataLabels: {
        enabled: false
    },
    plotOptions: {
        bar: {
            horizontal: true,
            barHeight: '50%',
            distributed: true
        }
    },
    legend: {
        show: true,
        showForSingleSeries: true,
        showForNullSeries: true,
        showForZeroSeries: true,
        fontSize: '10px',
        fontFamily: 'Roboto Flex, sans-serif',
        fontWeight: 400
    }
};
const $f307b637f166549c$export$fdce83568c42d93f = '#chart-carteira-margens';

});

parcelRegister("d6LoN", function(module, exports) {

$parcel$export(module.exports, "useConcentracao", function () { return $98b09a59b9fe58a9$export$6fbea450820852d0; });
function $98b09a59b9fe58a9$export$6fbea450820852d0() {
    function buildMarginsLines(chartElementSelector, margins) {
        const chartElement = document.querySelector(chartElementSelector);
        const oldLines = chartElement.querySelectorAll('.margins-chart-line');
        if (oldLines?.length) oldLines.forEach((line)=>{
            line.remove();
        });
        const chartElementRect = chartElement.getBoundingClientRect();
        const seriesWrapper = chartElement.querySelector('.apexcharts-series');
        const bars = Array.from(seriesWrapper?.getElementsByTagName('path'));
        const grid = chartElement.querySelector('.apexcharts-grid');
        const gridRect = grid.getBoundingClientRect();
        const gridWidth = gridRect.width;
        const offset = gridRect.left - chartElementRect.left;
        bars.forEach((bar, index)=>{
            const margin = margins[index];
            if (!margin) return;
            const line = document.createElement('div');
            const start = gridWidth * GLOBAL.convertPercentageInDecimal(margin[0]) + offset;
            const end = gridWidth * GLOBAL.convertPercentageInDecimal(margin[1]) + offset;
            const barRect = bar.getBoundingClientRect();
            line.style.top = `${barRect.top - chartElementRect.top + barRect.height + 4}px`;
            line.style.left = `${start}px`;
            line.style.width = `${end - start}px`;
            line.setAttribute('class', 'margins-chart-line');
            chartElement.appendChild(line);
        });
    }
    function serializeLimites(limite_inferior, limite_superior) {
        const limiteInferiorSerialized = parseFloat(limite_inferior) < 0 ? '0' : limite_inferior;
        const limiteSuperiorSerialized = parseFloat(limite_superior) > 100 ? '100' : limite_superior;
        return [
            limiteInferiorSerialized,
            limiteSuperiorSerialized
        ];
    }
    return {
        buildMarginsLines: buildMarginsLines,
        serializeLimites: serializeLimites
    };
}

});


parcelRegister("hGX9G", function(module, exports) {

$parcel$export(module.exports, "useChartTempoVencimento", function () { return $ce143ee33a8a213b$export$620a2f99b7a0ae35; });

var $89w2G = parcelRequire("89w2G");
function $ce143ee33a8a213b$export$620a2f99b7a0ae35() {
    let tempo_vencimento;
    let maxTaxa;
    async function createTempoVencimentoCharts(data) {
        tempo_vencimento = data;
        const ativos_geral = [
            ...tempo_vencimento?.data_ipca?.ativos ?? [],
            ...tempo_vencimento?.data_pos?.ativos ?? [],
            ...tempo_vencimento?.data_pre?.ativos ?? []
        ];
        const anos_ate_vencimento_geral = [
            ...ativos_geral.map((i)=>i.anos_ate_vencimento)
        ];
        const anos_filtrados = anos_ate_vencimento_geral.filter((valor)=>!isNaN(valor) && typeof valor === 'number');
        maxTaxa = Math.max(...anos_filtrados);
        try {
            (0, $89w2G.TEMPO_VENCIMENTO_CHARTS).forEach(({ key: key, idChart: idChart, idEl: idEl, colors: colors, title: title })=>setChartTempoVencimento(key, idChart, idEl, colors, title));
        } catch (e) {
            GLOBAL.errorDefault(e);
        } finally{
            NProgress.done();
        }
    }
    function setChartTempoVencimento(key, idChart, idEl, colors, title) {
        if (!tempo_vencimento[key]) {
            console.warn(`Chave "${key}" n\xe3o encontrada em tempo_vencimento`);
            return;
        }
        const { ativos: ativos = [], porcentagem_categoria: porcentagem_categoria = 0, porcentagem_global: porcentagem_global = 0, ponto_medio: ponto_medio = {} } = tempo_vencimento[key];
        if (!ativos || !Array.isArray(ativos)) {
            console.warn(`Ativos inv\xe1lidos para a chave "${key}"`);
            return;
        }
        const series = [];
        const ativosData = ativos.map(({ anos_ate_vencimento: anos_ate_vencimento, taxa_com_gross_up: taxa_com_gross_up, taxa_de_compra: taxa_de_compra })=>{
            const taxa = verifica(taxa_com_gross_up, taxa_de_compra);
            return [
                anos_ate_vencimento,
                taxa
            ];
        });
        const label = document.getElementById(title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase());
        if (!label) {
            console.warn(`Elemento n\xe3o encontrado para o t\xedtulo "${title}"`);
            return;
        }
        function verifica(taxa_com_gross_up, taxa_de_compra) {
            if (taxa_com_gross_up && parseFloat(taxa_com_gross_up) > 0) return taxa_com_gross_up;
            else return taxa_de_compra;
        }
        series.push({
            name: title,
            data: ativos.map(({ anos_ate_vencimento: anos_ate_vencimento, taxa_com_gross_up: taxa_com_gross_up, taxa_de_compra: taxa_de_compra })=>{
                const taxa = verifica(taxa_com_gross_up, taxa_de_compra);
                return [
                    anos_ate_vencimento,
                    taxa
                ];
            })
        });
        if (ativos.length > 1 && ponto_medio?.anos_ate_vencimento && ponto_medio?.taxa_de_compra) series.push({
            name: "Ponto M\xe9dio",
            data: [
                [
                    parseFloat(ponto_medio?.anos_ate_vencimento),
                    parseFloat(ponto_medio?.taxa_de_compra)
                ]
            ]
        });
        label.innerHTML = html`<div
			class="grid grid-cols-2 gap-0 border ml-4 rounded  "
			style="border-color:rgba(193, 31, 57, 0.10); width: 9rem;">
			<div
				class="col-span-full flex items-center justify-center p-4 text-xs  font-semibold"
				style="background-color:rgba(193, 31, 57, 0.10); color:rgba(193, 31, 57, 1); ">
				${title}
			</div>
			<div
				class="border-[.0313rem] border-neutral-30 text-xs font-normal pl-6 pr-6 py-4 border-b-0 border-l-0 text-neutral-100">
				Categoria
			</div>
			<div
				class="border-[.0313rem] border-neutral-30 text-xs font-normal pl-6 pr-6 py-4 border-b-0 border-r-0 text-neutral-100">
				${parseFloat(porcentagem_categoria).toFixed(2)}%
			</div>
			<div
				class="border-[.0313rem] border-neutral-30 text-xs font-normal pl-6 pr-6 py-4 border-b-0 border-l-0 text-neutral-100">
				Global
			</div>
			<div
				class="border-[.0313rem] border-neutral-30 text-xs font-normal pl-6 pr-6 py-4 border-b-0 border-r-0 text-neutral-100">
				${parseFloat(porcentagem_global).toFixed(2)}%
			</div>
		</div> `;
        const options = {
            chart: {
                id: idChart,
                height: 450,
                width: `100%`,
                type: 'scatter',
                zoom: {
                    enabled: true,
                    type: 'xy',
                    autoScaleYaxis: true
                },
                toolbar: {
                    show: true,
                    tools: {
                        zoom: false,
                        selection: false,
                        reset: true
                    }
                }
            },
            colors: colors,
            title: {
                text: undefined,
                align: 'left',
                floating: false,
                offsetY: -4,
                style: {
                    fontSize: '14px',
                    fontWeight: 'normal',
                    color: '#252526'
                }
            },
            subtitle: {
                text: undefined,
                align: 'left',
                offsetY: 14,
                style: {
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#C11F39'
                },
                floating: false
            },
            tooltip: {
                enabled: true,
                shared: false,
                followCursor: true,
                x: {
                    show: false
                },
                custom: (seriesName)=>{
                    const ativo = ativos[seriesName?.dataPointIndex];
                    if (!ativo) return '';
                    const { valor: valor = 0, data_compra: data_compra = '', nome: nome = '', data_vencimento: data_vencimento = '', pr_categoria: pr_categoria = 0, pr_global: pr_global = 0, pr_estrategia: pr_estrategia = 0, taxa_de_compra: taxa_de_compra = 0, taxa_com_gross_up: taxa_com_gross_up = 0 } = ativo;
                    return seriesName?.seriesIndex === 0 ? `<div class="arrow_box p-8 bg-white">
                            <p class="font-medium text-sm text-neutral-100">${nome ? String(nome).toUpperCase() : '-'}</p>
                            <p class="text-neutral-70 font-normal text-xs">Valor: ${GLOBAL.formatReal2(valor)}</p>
                            <p class="text-neutral-70 font-normal text-xs">Pr. Categoria: ${parseFloat(pr_categoria || 0).toFixed(2)}%</p>
                            <p class="text-neutral-70 font-normal text-xs">Pr. Estrategia: ${parseFloat(pr_estrategia || 0).toFixed(2)}%</p>
                            <p class="text-neutral-70 font-normal text-xs">Pr. Global: ${parseFloat(pr_global || 0).toFixed(2)}%</p>
                            <p class="text-neutral-70 font-normal text-xs">Taxa de compra: ${parseFloat(taxa_de_compra || 0).toFixed(2)}%</p>		
                            <p class="text-neutral-70 font-normal text-xs">Taxa com Gross Up: ${parseFloat(taxa_com_gross_up || 0).toFixed(2)}%</p>	
                            <p class="text-neutral-70 font-normal text-xs">Data de vencimento: ${GLOBAL.fDate(data_vencimento)}</p>
                            <p class="text-neutral-70 font-normal text-xs">Data de compra: ${GLOBAL.fDate(data_compra)}</p>
                        </div>` : `<div class="arrow_box p-8 bg-white">
                    <p class="font-medium text-sm text-neutral-100">${String(title).toUpperCase()}</p>
                    <p class="text-neutral-70 font-normal text-xs">Data M\xe9dia: ${GLOBAL.calcData(parseFloat(ponto_medio?.anos_ate_vencimento || 0) * 365)}</p>
                    
                    <p class="text-neutral-70 font-normal text-xs">Taxa M\xe9dia: ${parseFloat(ponto_medio?.taxa_de_compra || 0).toFixed(2)}%</p>
                    <p class="text-neutral-70 font-normal text-xs">Total: ${GLOBAL.formatReal2(parseFloat(ponto_medio?.valor || 0).toFixed(2))}</p>
                    
                </div>`;
                }
            },
            series: series,
            xaxis: {
                min: 0,
                max: maxTaxa,
                type: 'numeric',
                decimalsInFloat: 2,
                title: {
                    text: "Anos at\xe9 o vencimento do ativo."
                }
            },
            yaxis: {
                show: true,
                showAlways: false,
                showForNullSeries: true,
                decimalsInFloat: 2,
                labels: {
                    formatter: (val)=>`${parseFloat(val).toFixed(2)}%`
                }
            }
        };
        new ApexCharts(document.querySelector(idEl), options).render();
    }
    return {
        setChartTempoVencimento: setChartTempoVencimento,
        createTempoVencimentoCharts: createTempoVencimentoCharts
    };
}

});
parcelRegister("89w2G", function(module, exports) {

$parcel$export(module.exports, "TEMPO_VENCIMENTO_CHARTS", function () { return $5ef804e6ede8e3a2$export$d37442d5e7951295; });
const $5ef804e6ede8e3a2$export$d37442d5e7951295 = [
    {
        key: 'data_pre',
        idChart: 'chartTempoVencimentoPre',
        idEl: '#chart-tempo-vencimento-pre',
        colors: [
            '#003769',
            '#FFBB0B'
        ],
        title: "Pr\xe9"
    },
    {
        key: 'data_ipca',
        idChart: 'chartTempoVencimentoIPCA',
        idEl: '#chart-tempo-vencimento-ipca',
        colors: [
            '#95FF8C',
            '#FFBB0B'
        ],
        title: 'IPCA+'
    },
    {
        key: 'data_pos',
        idChart: 'chartTempoVencimentoPos',
        idEl: '#chart-tempo-vencimento-pos',
        colors: [
            '#8A96FF',
            '#FFBB0B'
        ],
        title: "P\xf3s"
    }
];

});


parcelRegister("55FHZ", function(module, exports) {

$parcel$export(module.exports, "useLiquidezAlvosChart", function () { return $3b4dc5d5e75a1367$export$a20caf1336e352f3; });

var $8YPrY = parcelRequire("8YPrY");

var $U6HEo = parcelRequire("U6HEo");

var $1F5Ay = parcelRequire("1F5Ay");
const { createChart: $3b4dc5d5e75a1367$var$createChart, setColorsInFunctionOfAHexadecimalColor: $3b4dc5d5e75a1367$var$setColorsInFunctionOfAHexadecimalColor } = (0, $1F5Ay.useCharts)();
function $3b4dc5d5e75a1367$export$a20caf1336e352f3() {
    function createLiquidezAlvosChart(limitesLiquidez) {
        const { limites: limites, valores_liquidez: valores_liquidez } = limitesLiquidez;
        const series = valores_liquidez.map(({ periodo: periodo, carteira: carteira, porcentagem_acumulada: porcentagem_acumulada })=>{
            const item = limites?.find((valorLiquidez)=>valorLiquidez.periodo === periodo);
            return {
                name: periodo,
                data: [
                    parseFloat(item?.objetivo) || 0,
                    carteira ? parseFloat(carteira) : 0
                ]
            };
        });
        const seriesWithPorcentagemAcumulada = valores_liquidez.map(({ periodo: periodo, carteira: carteira, porcentagem_acumulada: porcentagem_acumulada })=>{
            const item = limites?.find((valorLiquidez)=>valorLiquidez.periodo === periodo);
            return {
                name: periodo,
                data: [
                    parseFloat(item?.objetivo) || 0,
                    carteira ? parseFloat(carteira) : 0,
                    porcentagem_acumulada ? parseFloat(porcentagem_acumulada) : 0
                ]
            };
        });
        const options = {
            ...(0, $8YPrY.CARTEIRA_ALVOS_CHART_OPTIONS),
            chart: {
                ...(0, $8YPrY.CARTEIRA_ALVOS_CHART_OPTIONS).chart,
                height: 170
            },
            series: series,
            title: {
                text: undefined
            },
            tooltip: {
                y: {
                    title: {
                        formatter: (seriesName)=>''
                    },
                    formatter: (val, { seriesIndex: seriesIndex, dataPointIndex: dataPointIndex, w: w })=>{
                        const nameSerie = w.globals.seriesNames[seriesIndex];
                        const itemSerie = seriesWithPorcentagemAcumulada.find((serie)=>serie.name === nameSerie);
                        const acumulado = `${Number(itemSerie?.data[2]).toFixed(2)}%` || '-';
                        return `<div class="arrow_box p-8 ">
									<p class="text-neutral-100 font-medium text-xs"> ${nameSerie}: ${parseFloat(val).toFixed(2)}%</p>			
									${w.globals.labels[dataPointIndex] === 'Carteira' ? `<p class="text-neutral-100 font-medium text-xs">Acumulado: ${acumulado} ` : ''}</p>
								</div>`;
                    }
                }
            },
            colors: $3b4dc5d5e75a1367$var$setColorsInFunctionOfAHexadecimalColor('#7B0100', series, 20)
        };
        $3b4dc5d5e75a1367$var$createChart((0, $U6HEo.LIQUIDEZ_ALVOS_CHART_ID), options);
    }
    return {
        createLiquidezAlvosChart: createLiquidezAlvosChart
    };
}

});
parcelRegister("U6HEo", function(module, exports) {

$parcel$export(module.exports, "LIQUIDEZ_MARGINS_CHART_ID", function () { return $0a8a6e297719513d$export$4ae9be0c722ce655; });
$parcel$export(module.exports, "LIQUIDEZ_ALVOS_CHART_ID", function () { return $0a8a6e297719513d$export$fcd2290487b2d395; });
const $0a8a6e297719513d$export$4ae9be0c722ce655 = '#chart-liquidez-margens';
const $0a8a6e297719513d$export$fcd2290487b2d395 = '#chart-liquidez-alvos';

});


parcelRegister("9nXqm", function(module, exports) {

$parcel$export(module.exports, "useRatingChart", function () { return $6d545b6d8b071f51$export$f0ddc9e160cb3fda; });

var $co1vA = parcelRequire("co1vA");

var $1F5Ay = parcelRequire("1F5Ay");
const { createChart: $6d545b6d8b071f51$var$createChart, setColorsInFunctionOfAHexadecimalColor: $6d545b6d8b071f51$var$setColorsInFunctionOfAHexadecimalColor } = (0, $1F5Ay.useCharts)();
function $6d545b6d8b071f51$export$f0ddc9e160cb3fda() {
    function createRatingChart(dados) {
        const dadosValidos = Object.entries(dados).filter((dado)=>dado[1] !== 0);
        const labels = dadosValidos.map((dado)=>dado[0]);
        const series = dadosValidos.map((dado)=>dado[1]);
        const colors = GLOBAL.defineColors(labels, 'tipos_rating');
        const options = {
            series: series,
            chart: {
                width: '100%',
                height: 370,
                id: 'chart-rating',
                type: 'pie'
            },
            noData: {
                text: 'Sem valores'
            },
            labels: labels,
            legend: {
                position: 'bottom',
                onItemClick: {
                    toggleDataSeries: false
                },
                onItemHover: {
                    highlightDataSeries: false
                }
            },
            colors: colors,
            dataLabels: {
                enabled: false
            },
            tooltip: {
                enabled: true,
                shared: true,
                intersect: false,
                custom: (seriesName)=>{
                    const currentValue = seriesName.series[seriesName.seriesIndex];
                    const currentIndex = labels[seriesName.seriesIndex];
                    const bgColor = colors[seriesName.seriesIndex];
                    return `<div class="arrow_box p-8 !bg-[${bgColor}]" style="background: ${bgColor} !important"
			>
				<p class="font-semibold text-sm text-white">Rating</p>
				<p class="font-medium text-sm text-white">${currentIndex} : ${currentValue}%</p>
				
			</div>`;
                }
            }
        };
        $6d545b6d8b071f51$var$createChart((0, $co1vA.RATING_CHART_ID), options);
    }
    return {
        createRatingChart: createRatingChart
    };
}

});
parcelRegister("co1vA", function(module, exports) {

$parcel$export(module.exports, "RATING_CHART_ID", function () { return $9048e578b2062b2b$export$a5ff5609b1eff678; });
const $9048e578b2062b2b$export$a5ff5609b1eff678 = '#chart-rating';

});


parcelRegister("ik92V", function(module, exports) {

$parcel$export(module.exports, "useLiquidezMarginsChart", function () { return $d5711ca1388213ef$export$98b827699fd541e8; });

var $kRDUb = parcelRequire("kRDUb");

var $U6HEo = parcelRequire("U6HEo");

var $1F5Ay = parcelRequire("1F5Ay");

var $d6LoN = parcelRequire("d6LoN");
const { buildMarginsLines: $d5711ca1388213ef$var$buildMarginsLines, serializeLimites: $d5711ca1388213ef$var$serializeLimites } = (0, $d6LoN.useConcentracao)();
const { createChart: $d5711ca1388213ef$var$createChart, setColorsInFunctionOfAHexadecimalColor: $d5711ca1388213ef$var$setColorsInFunctionOfAHexadecimalColor } = (0, $1F5Ay.useCharts)();
function $d5711ca1388213ef$export$98b827699fd541e8() {
    function createLiquidezMarginsChart(limitesLiquidez, dados) {
        const { limites: limites, valores_liquidez: valores_liquidez } = limitesLiquidez;
        const seriesData = valores_liquidez.map(({ carteira: carteira })=>parseFloat(carteira).toFixed(2));
        const categories = valores_liquidez.map(({ periodo: periodo })=>periodo);
        const margins = limites.map(({ limite_inferior: limite_inferior, limite_superior: limite_superior })=>$d5711ca1388213ef$var$serializeLimites(limite_inferior, limite_superior));
        const options = {
            ...(0, $kRDUb.CARTEIRA_MARGINS_CHART_OPTIONS),
            series: [
                {
                    name: 'Carteira',
                    type: 'bar',
                    data: seriesData
                }
            ],
            colors: $d5711ca1388213ef$var$setColorsInFunctionOfAHexadecimalColor('#7B0100', seriesData, 20),
            xaxis: {
                type: 'category',
                categories: categories,
                max: 100,
                stepSize: 10,
                labels: {
                    formatter: (value)=>{
                        return `${value}%`;
                    }
                }
            },
            title: {
                text: undefined
            },
            legend: {
                show: false
            },
            tooltip: {
                enabled: true,
                shared: false,
                followCursor: true,
                x: {
                    show: false
                },
                custom: handleCustomTooltip(margins, categories, dados)
            }
        };
        $d5711ca1388213ef$var$createChart((0, $U6HEo.LIQUIDEZ_MARGINS_CHART_ID), options);
        $d5711ca1388213ef$var$buildMarginsLines((0, $U6HEo.LIQUIDEZ_MARGINS_CHART_ID), margins);
        window.addEventListener('resize', ()=>setTimeout(()=>$d5711ca1388213ef$var$buildMarginsLines((0, $U6HEo.LIQUIDEZ_MARGINS_CHART_ID), margins), 500));
    }
    function keyVencimento(key) {
        let keyVencimento = '';
        switch(key){
            case "At\xe9 5 dias":
                keyVencimento = 'vencimento_5_dias';
                return keyVencimento;
            case 'De 6 a 35 dias':
                keyVencimento = 'vencimento_6_a_35_dias';
                return keyVencimento;
            case 'De 36 a 65 dias':
                keyVencimento = 'vencimento_36_a_65_dias';
                return keyVencimento;
            case 'Acima de 65 dias':
                keyVencimento = 'vencimento_65_dias';
                return keyVencimento;
            default:
                return keyVencimento;
        }
    }
    function handleCustomTooltip(margins, categories, dados) {
        return ({ series: series, seriesIndex: seriesIndex, dataPointIndex: dataPointIndex })=>{
            const margin = margins[dataPointIndex];
            const periodo = categories[dataPointIndex];
            const keyPeriodo = keyVencimento(periodo);
            const qtdAtivos = dados[keyPeriodo] ? Object.values(dados[keyPeriodo])?.length : 0;
            return `
			<div class="arrow_box p-8 bg-white"
			>
				<p class="font-medium text-sm text-neutral-100">${periodo}</p>
				<p class="text-neutral-70 font-normal text-xs">Carteira: ${parseFloat(series[seriesIndex][dataPointIndex]).toFixed(2)}%</p>
				<p class="text-neutral-70 font-normal text-xs">QTD. Ativos: ${qtdAtivos}</p>
				${margin ? `<p class="text-neutral-70 font-normal text-xs">Margem inferior: ${margin[0]}%</p>
				<p class="text-neutral-70 font-normal text-xs">Margem superior: ${margin[1]}%</p>` : ``}
			</div>
		`;
        };
    }
    return {
        createLiquidezMarginsChart: createLiquidezMarginsChart
    };
}

});

parcelRegister("6OLqX", function(module, exports) {

$parcel$export(module.exports, "useRetorno", function () { return $4f6c34f275c28638$export$38fa778157b77e94; });

var $aKkH8 = parcelRequire("aKkH8");

var $1F5Ay = parcelRequire("1F5Ay");
const { createChart: $4f6c34f275c28638$var$createChart } = (0, $1F5Ay.useCharts)();
function $4f6c34f275c28638$export$38fa778157b77e94() {
    function createRetornoChart({ cdi: cdi, labels: labels, cotas: cotas, rentabilidades: rentabilidades }) {
        const options = {
            ...(0, $aKkH8.RETORNO_CHART_OPTIONS),
            noData: {
                text: "Dados n\xe3o encontrados",
                align: 'center',
                verticalAlign: 'middle',
                style: {
                    color: undefined,
                    fontSize: '12px',
                    fontFamily: undefined
                }
            },
            chart: {
                width: '100%',
                heigth: 400,
                id: 'chart-retorno',
                ...(0, $aKkH8.RETORNO_CHART_OPTIONS).chart
            },
            series: [
                {
                    name: 'CDI',
                    data: cdi
                },
                {
                    name: 'Rent. Acumulada',
                    data: cotas
                }
            ],
            xaxis: {
                type: 'category',
                tickAmount: 12,
                categories: labels,
                labels: {
                    show: true,
                    rotate: 0,
                    style: {
                        fontSize: '10px',
                        cssClass: 'apexcharts-xaxis-label'
                    }
                }
            },
            yaxis: {
                forceNiceScale: true,
                labels: {
                    formatter: function(y) {
                        if (typeof y !== 'undefined') return y + '%';
                        return y;
                    }
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                followCursor: true,
                custom: handleCustomTooltip(cdi, labels, cotas, rentabilidades)
            }
        };
        $4f6c34f275c28638$var$createChart((0, $aKkH8.RETORNO_CHART_ID), options);
    }
    function handleCustomTooltip(cdi, labels, cotas, rentabilidades) {
        return ({ dataPointIndex: dataPointIndex })=>{
            const data = labels[dataPointIndex];
            const _cdi = cdi[dataPointIndex];
            const cdiTexto = _cdi ? `${_cdi}%` : '-';
            const rentabilidade = rentabilidades[dataPointIndex];
            const rentabilidadeTexto = rentabilidade ? `${rentabilidade}%` : '-';
            const acumulada = cotas[dataPointIndex];
            const acumuladaTexto = acumulada ? `${acumulada}%` : '-';
            return `
			<div class="arrow_box p-8 bg-white"
			>
				<p class="font-medium text-sm text-neutral-100">${data}</p>
				${`<p class="text-neutral-70 font-normal text-xs">CDI - \xdaltimos 12 meses: ${cdiTexto}</p>
				<p class="text-neutral-70 font-normal text-xs">Rentabilidade: ${rentabilidadeTexto}</p>
				<p class="text-neutral-70 font-normal text-xs">Rentabilidade Acumulada: ${acumuladaTexto}</p>
				
				`}
			</div>
		`;
        };
    }
    return {
        createRetornoChart: createRetornoChart
    };
}

});
parcelRegister("aKkH8", function(module, exports) {

$parcel$export(module.exports, "RETORNO_CHART_OPTIONS", function () { return $7d2e40ce067758aa$export$5b03bd0f89559d54; });
$parcel$export(module.exports, "RETORNO_CHART_ID", function () { return $7d2e40ce067758aa$export$578f89d6432d6316; });
const $7d2e40ce067758aa$export$5b03bd0f89559d54 = {
    chart: {
        height: 350,
        type: 'line',
        stacked: false,
        toolbar: {
            show: false
        },
        zoom: {
            enabled: false
        }
    },
    stroke: {
        width: [
            2,
            2
        ],
        curve: 'straight'
    },
    plotOptions: {
        bar: {
            columnWidth: '50%'
        }
    },
    legend: {
        markers: {
            width: 20,
            height: 4,
            radius: 0
        },
        horizontalAlign: 'left',
        itemMargin: {
            vertical: 20
        }
    },
    fill: {
        opacity: [
            1,
            1,
            1
        ],
        gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [
                0,
                100,
                100,
                100
            ]
        }
    },
    markers: {
        size: 0
    },
    colors: [
        '#5a5568',
        '#6B0000'
    ],
    yaxis: {
        title: {
            text: ''
        }
    }
};
const $7d2e40ce067758aa$export$578f89d6432d6316 = '#chart-retorno';

});


parcelRegister("8yQJ6", function(module, exports) {

$parcel$export(module.exports, "useVolatilidade", function () { return $63ba661a577a15cb$export$c8a026071b813e3c; });

var $fcA3d = parcelRequire("fcA3d");

var $1F5Ay = parcelRequire("1F5Ay");
const { createChart: $63ba661a577a15cb$var$createChart } = (0, $1F5Ay.useCharts)();
function $63ba661a577a15cb$export$c8a026071b813e3c() {
    function createVolatilidadeChart({ volatilidades: volatilidades, rentabilidades: rentabilidades, labels: labels, periodo: periodo, message: message, estatisticas: estatisticas }) {
        const max_value = Math.max(...volatilidades, ...rentabilidades);
        const maxObj = max_value < periodo?.objetivo ? {
            max: periodo?.objetivo
        } : null;
        const options = {
            ...(0, $fcA3d.VOLATILIDADE_CHART_OPTIONS),
            noData: {
                text: !volatilidades.length ? "Volatididade n\xe3o encontrada na data solicitada" : "Dados n\xe3o encontrados",
                align: 'center',
                verticalAlign: 'middle',
                style: {
                    color: undefined,
                    fontSize: '14px',
                    fontFamily: undefined
                }
            },
            chart: {
                width: volatilidades.length > 80 ? `${volatilidades.length * 12}px` : '100%',
                heigth: 400,
                id: periodo?.periodo === '1M' ? (0, $fcA3d.VOLATILIDADE_CHART_ID_1M) : (0, $fcA3d.VOLATILIDADE_CHART_ID_3M),
                ...(0, $fcA3d.VOLATILIDADE_CHART_OPTIONS).chart
            },
            series: [
                {
                    name: "Rend. Di\xe1rio",
                    type: 'column',
                    data: rentabilidades
                },
                {
                    name: periodo?.periodo,
                    type: 'line',
                    data: volatilidades
                }
            ],
            xaxis: {
                type: 'category',
                categories: labels,
                labels: {
                    show: true,
                    rotate: 0,
                    style: {
                        fontSize: '10px',
                        cssClass: 'apexcharts-xaxis-label'
                    }
                }
            },
            yaxis: {
                ...maxObj,
                forceNiceScale: true,
                labels: {
                    formatter: function(y) {
                        if (typeof y !== 'undefined') return y + '%';
                        return y;
                    }
                }
            },
            annotations: {
                yaxis: [
                    {
                        y: Number(periodo?.objetivo) || null,
                        strokeDashArray: 3,
                        borderColor: '#6D6F71',
                        label: {
                            show: false,
                            position: 'bottom',
                            borderColor: '#000',
                            style: {
                                color: '#000',
                                background: '#fff',
                                padding: {
                                    bottom: 4
                                }
                            },
                            text: ''
                        }
                    }
                ]
            },
            tooltip: {
                shared: true,
                intersect: false,
                followCursor: true,
                custom: handleCustomTooltip(volatilidades, rentabilidades, labels, periodo, estatisticas)
            }
        };
        if (periodo?.periodo === '1M') $63ba661a577a15cb$var$createChart((0, $fcA3d.VOLATILIDADE_CHART_ID_1M), options);
        else $63ba661a577a15cb$var$createChart((0, $fcA3d.VOLATILIDADE_CHART_ID_3M), options);
    }
    function handleCustomTooltip(volatilidades, rentabilidades, labels, periodo, estatisticas) {
        return ({ series: series, seriesIndex: seriesIndex, dataPointIndex: dataPointIndex })=>{
            const volatilidade = volatilidades[dataPointIndex];
            const rentabilidade_diaria = rentabilidades[dataPointIndex];
            const data = labels[dataPointIndex];
            const volatilidadeTexto = volatilidade ? `${volatilidade}%` : '-';
            const rentabilidadeTexto = rentabilidade_diaria ? `${rentabilidade_diaria}%` : '-';
            return `
			<div class="arrow_box p-8 bg-white"
			>
				<p class="font-medium text-sm text-neutral-100">${data}</p>
				${`<p class="text-neutral-70 font-normal text-xs">Volatilidade: ${volatilidadeTexto}</p>
				<p class="text-neutral-70 font-normal text-xs">Rentabilidade: ${rentabilidadeTexto}</p>
				<p class="text-neutral-70 font-normal text-xs">Objetivo: ${periodo?.objetivo || 'Sem Perfil'}</p>
				<p class="text-neutral-70 font-normal text-xs">Limite Superior: ${periodo?.limite_superior || 'Sem Perfil'}</p>
				<p class="text-neutral-70 font-normal text-xs">Limite Inferior: ${periodo?.limite_inferior || 'Sem Perfil'}</p>
				<p class="text-neutral-70 font-normal text-xs">M\xe9dia: ${estatisticas.media || '-'}</p>
				<p class="text-neutral-70 font-normal text-xs">Mediana: ${estatisticas?.mediana || '-'}</p>
				`}
			</div>
		`;
        };
    }
    return {
        createVolatilidadeChart: createVolatilidadeChart
    };
}

});
parcelRegister("fcA3d", function(module, exports) {

$parcel$export(module.exports, "VOLATILIDADE_CHART_OPTIONS", function () { return $b113f0f358f3714f$export$65441cc7114eb77; });
$parcel$export(module.exports, "VOLATILIDADE_CHART_ID_1M", function () { return $b113f0f358f3714f$export$60d401d8f9e5bf0d; });
$parcel$export(module.exports, "VOLATILIDADE_CHART_ID_3M", function () { return $b113f0f358f3714f$export$58960bd0ddff4241; });
const $b113f0f358f3714f$export$65441cc7114eb77 = {
    chart: {
        height: 350,
        type: 'line',
        stacked: false,
        toolbar: {
            show: false
        },
        zoom: {
            enabled: false
        }
    },
    stroke: {
        width: [
            0,
            2,
            2
        ],
        curve: 'straight'
    },
    plotOptions: {
        bar: {
            columnWidth: '50%'
        }
    },
    legend: {
        markers: {
            width: 20,
            height: 4,
            radius: 0
        },
        horizontalAlign: 'left',
        itemMargin: {
            vertical: 20
        }
    },
    fill: {
        opacity: [
            1,
            1,
            1
        ],
        gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [
                0,
                100,
                100,
                100
            ]
        }
    },
    markers: {
        size: 0
    },
    colors: [
        '#6B0000',
        '#840505',
        '#9E1616'
    ],
    yaxis: {
        title: {
            text: ''
        }
    }
};
const $b113f0f358f3714f$export$60d401d8f9e5bf0d = '#chart-volatilidade-1m';
const $b113f0f358f3714f$export$58960bd0ddff4241 = '#chart-volatilidade-3m';

});


parcelRegister("jzAJi", function(module, exports) {

$parcel$export(module.exports, "clientAssetsService", function () { return $e3fdc6ea5d9eb00c$export$cb98470248b2ef06; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $e3fdc6ea5d9eb00c$export$cb98470248b2ef06() {
    const api = (0, $c8Lpu.useApi)();
    async function getDadosTempoVencimento(clienteId) {
        return api.query(`${window.location.origin}${(0, $9YhWF.URLS).grafico_tempo_vencimento}${clienteId}`);
    }
    async function getDetalhesVolatilidade(clienteId, periodo, data_inicio, data_fim) {
        return api.query(`${window.location.origin}${(0, $9YhWF.URLS).tabela_clientepf_volatilidade}?cliente=${clienteId}&periodo=${periodo}&data_inicio=${data_inicio}&data_fim=${data_fim}`);
    }
    async function getDetalhesRetorno(clienteId, quatidade_meses) {
        return api.query(`${window.location.origin}${(0, $9YhWF.URLS).tabela_clientepf_retorno}?cliente=${clienteId}&quantidade_meses=${quatidade_meses}`);
    }
    async function getInfoAtendimentoCliente(query = '', params = {}) {
        return api.query(`${window.location.origin}${(0, $9YhWF.URLS).informacoes_modal_cliente_pf}${query}`, params);
    }
    return {
        getDadosTempoVencimento: getDadosTempoVencimento,
        getDetalhesVolatilidade: getDetalhesVolatilidade,
        getDetalhesRetorno: getDetalhesRetorno,
        getInfoAtendimentoCliente: getInfoAtendimentoCliente,
        ...api
    };
}

});

parcelRegister("j0jCN", function(module, exports) {

$parcel$export(module.exports, "useSetorChart", function () { return $dd5d3d7daf77515d$export$5d7f612365410bc5; });

var $57ti1 = parcelRequire("57ti1");

var $1F5Ay = parcelRequire("1F5Ay");
const { createChart: $dd5d3d7daf77515d$var$createChart } = (0, $1F5Ay.useCharts)();
function $dd5d3d7daf77515d$export$5d7f612365410bc5() {
    function createSetorChart(dados) {
        const dadosValidos = Object.entries(dados).filter((dado)=>dado[1] !== 0);
        const labels = dadosValidos.map((dado)=>dado[0]);
        const series = dadosValidos.map((dado)=>dado[1].quantidade);
        const percentual = dadosValidos.map((dado)=>dado[1].percentual);
        console.log({
            dados: dados,
            labels: labels,
            series: series,
            dadosValidos: dadosValidos
        });
        const colors = GLOBAL.defineColors(labels);
        const options = {
            series: series,
            chart: {
                width: '100%',
                height: 340,
                id: 'chart-setor',
                type: 'pie'
            },
            noData: {
                text: 'Sem valores'
            },
            labels: labels,
            legend: {
                position: 'bottom',
                onItemClick: {
                    toggleDataSeries: false
                },
                onItemHover: {
                    highlightDataSeries: false
                }
            },
            colors: colors,
            dataLabels: {
                enabled: false
            },
            tooltip: {
                enabled: true,
                shared: true,
                intersect: false,
                custom: (seriesName)=>{
                    const percentualValue = percentual[seriesName.seriesIndex];
                    const currentIndex = labels[seriesName.seriesIndex];
                    const bgColor = colors[seriesName.seriesIndex];
                    return `<div class="arrow_box p-8 !bg-[${bgColor}]" style="background: ${bgColor} !important">
									<p class="font-semibold text-sm text-white">Setor</p>
									<p class="font-medium text-sm text-white">${currentIndex} : ${percentualValue}%</p>
									
								</div>`;
                }
            }
        };
        $dd5d3d7daf77515d$var$createChart((0, $57ti1.SETOR_CHART_ID), options);
    }
    return {
        createSetorChart: createSetorChart
    };
}

});
parcelRegister("57ti1", function(module, exports) {

$parcel$export(module.exports, "SETOR_CHART_ID", function () { return $3ba45382b0e31b79$export$efbcb94c8826019d; });
const $3ba45382b0e31b79$export$efbcb94c8826019d = '#chart-setor';

});


parcelRegister("4s5N5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33de44e282e6193a$export$2e2bcd8739ae039; });

var $diqzg = parcelRequire("diqzg");

var $9YhWF = parcelRequire("9YhWF");

var $26SB8 = parcelRequire("26SB8");
var $33de44e282e6193a$export$2e2bcd8739ae039 = {
    props: [
        'clienteId'
    ],
    mixins: [
        (0, $diqzg.default)
    ],
    data () {
        return {
            tabelaRealocacao: null,
            columns: [
                {
                    id: 'emissor',
                    name: 'Nome do emissor',
                    width: '220px',
                    formatter: (cell, row)=>{
                        return row.percentual_disponivel === "\u2014" ? (0, $26SB8.html)(`<span>${cell} <span style="font-size:11px;color:#888">(N\xe3o definido)</span></span>`) : cell;
                    }
                },
                {
                    id: 'percentual_disponivel',
                    name: "% Dispon\xedvel",
                    width: '150px',
                    sort: {
                        compare: (a, b)=>{
                            if (a === "\u2014" && b !== "\u2014") return 1;
                            if (b === "\u2014" && a !== "\u2014") return -1;
                            if (a === "\u2014" && b === "\u2014") return 0;
                            return b - a;
                        }
                    },
                    formatter: (cell, row)=>{
                        return cell === "\u2014" ? "N\xe3o definido" : typeof cell === 'number' ? `${cell.toFixed(2)}%` : cell;
                    }
                },
                {
                    id: 'valor_disponivel',
                    name: "Valor Dispon\xedvel para Aloca\xe7\xe3o",
                    width: '220px',
                    sort: {
                        compare: (a, b)=>{
                            if (a === "\u2014" && b !== "\u2014") return 1;
                            if (b === "\u2014" && a !== "\u2014") return -1;
                            if (a === "\u2014" && b === "\u2014") return 0;
                            return b - a;
                        }
                    },
                    formatter: (cell, row)=>{
                        if (cell === "\u2014" || cell === '-') return "N\xe3o definido";
                        const valor = typeof cell === 'number' ? cell.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        }) : cell;
                        if (typeof cell === 'number' && cell > 0) return (0, $26SB8.html)(`<span style="color: #18b25d; font-weight: bold;">${valor}</span>`);
                        if (cell < 0) return (0, $26SB8.html)(`<span style="color:red">${valor}</span>`);
                        return valor;
                    }
                }
            ],
            data: []
        };
    },
    methods: {
        iniciarTabela () {
            this.tabelaRealocacao = this.iniciarTabelaGenerica(this.columns, `${(0, $9YhWF.URLS).cliente_realocacao}?cliente_id=${this.clienteId}`, (response)=>{
                const data = response?.data || [];
                return this.formateDataTabelaRelacaoCliente(data);
            }, (response)=>response?.data?.length || 0, {
                pagination: {
                    enabled: false,
                    limit: 9999,
                    summary: false
                }
            });
            this.tabelaRealocacao.render(this.$refs.tableRealocacao);
        },
        formateDataTabelaRelacaoCliente (data = []) {
            return data?.sort((a, b)=>b.valor_disponivel - a.valor_disponivel);
        }
    },
    mounted () {
        this.iniciarTabela();
    },
    template: `
        <div>
            <div ref="tableRealocacao"></div>
        </div>
    `
};

});
parcelRegister("diqzg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae1909c58eee1a6$export$2e2bcd8739ae039; });

var $XhB8N = parcelRequire("XhB8N");

var $26SB8 = parcelRequire("26SB8");

var $2m7Ys = parcelRequire("2m7Ys");
var $9ae1909c58eee1a6$export$2e2bcd8739ae039 = {
    methods: {
        iniciarTabelaGenerica (columns, url, customThenCallback, customTotalCallback, options = (0, $XhB8N.CONFIG_GRID_DEFAULT)) {
            const defaultConfig = {
                server: {
                    url: url,
                    then: (data)=>customThenCallback(data),
                    total: (data)=>{
                        const result = customTotalCallback(data);
                        return typeof result === 'number' ? result : result.length;
                    }
                },
                search: false,
                pagination: {
                    enabled: false,
                    limit: 10,
                    summary: false,
                    server: {
                        url: (urlApi, page, limit)=>`${urlApi}&page=${++page}&paginate_by=${limit}`
                    }
                }
            };
            const finalConfig = (0, $2m7Ys.merge)({}, (0, $XhB8N.CONFIG_GRID_DEFAULT), defaultConfig, options);
            const gridInstance = new (0, $26SB8.Grid)({
                columns: columns,
                ...finalConfig
            });
            return gridInstance;
        }
    }
};

});
parcelRegister("XhB8N", function(module, exports) {

$parcel$export(module.exports, "CONFIG_GRID_DEFAULT", function () { return $0b232968977c1d91$export$6c4fd4d88949050d; });
const $0b232968977c1d91$export$6c4fd4d88949050d = {
    search: false,
    resizable: true,
    data: [],
    autoWidth: true,
    width: '100%',
    sort: false,
    style: {
        container: {
            border: 'none'
        },
        table: {
            border: 'none'
        },
        tr: {
            border: 'none'
        },
        th: {
            'border-bottom': '1px solid #e9ecef',
            padding: '8px'
        },
        td: {
            'border-bottom': '1px solid #e9ecef',
            cursor: 'pointer',
            color: '#495057',
            'font-family': 'Roboto Flex',
            'font-size': '14px',
            'font-weight': 500,
            'line-height': '150%',
            'letter-spacing': '-0.28px',
            padding: '8px'
        },
        footer: {
            border: 'none'
        }
    },
    language: {
        search: {
            placeholder: 'Busque aqui...'
        },
        pagination: {
            previous: 'Anterior',
            next: "Pr\xf3ximo",
            navigate: function(page, pages) {
                return `P\xe1gina ${page} de ${pages}`;
            },
            page: function(page) {
                return `P\xe1gina ${page}`;
            },
            showing: function(from, to, total) {
                return `Mostrando registros`;
            },
            of: 'de',
            to: 'a',
            results: function() {
                return 'resultados';
            }
        },
        sort: {
            sortAsc: 'Classificar em ordem crescente',
            sortDesc: 'Classificar em ordem decrescente'
        },
        loading: 'Carregando...',
        noRecordsFound: 'Nenhum registro encontrado',
        error: 'Ocorreu um erro ao buscar os dados',
        empty: "Nenhum dado dispon\xedvel",
        columns: {
            select: 'Selecionar',
            actions: "A\xe7\xf5es"
        },
        buttons: {
            ok: 'OK',
            cancel: 'Cancelar',
            close: 'Fechar',
            save: 'Salvar',
            edit: 'Editar',
            delete: 'Excluir',
            view: 'Visualizar',
            export: 'Exportar',
            print: 'Imprimir'
        }
    }
};

});

parcelRegister("26SB8", function(module, exports) {

$parcel$export(module.exports, "html", function () { return K; });
$parcel$export(module.exports, "className", function () { return rt; });
$parcel$export(module.exports, "BaseStore", function () { return st; });
$parcel$export(module.exports, "BaseActions", function () { return ut; });
$parcel$export(module.exports, "PluginBaseComponent", function () { return ht; });
$parcel$export(module.exports, "Grid", function () { return ae; });
$parcel$export(module.exports, "h", function () { return b; });
function t(t, e) {
    for(var n = 0; n < e.length; n++){
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function e(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
}
function n() {
    return n = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var n = arguments[e];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
    }, n.apply(this, arguments);
}
function r(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, i(t, e);
}
function i(t, e) {
    return i = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, i(t, e);
}
function o(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function s(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
    return r;
}
function a(t, e) {
    var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (n) return (n = n.call(t)).next.bind(n);
    if (Array.isArray(t) || (n = function(t, e) {
        if (t) {
            if ("string" == typeof t) return s(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(t, e) : void 0;
        }
    }(t)) || e && t && "number" == typeof t.length) {
        n && (t = n);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var u, l, c, p, h, f, d, _ = {}, m = [], g = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function v(t, e) {
    for(var n in e)t[n] = e[n];
    return t;
}
function y(t) {
    var e = t.parentNode;
    e && e.removeChild(t);
}
function b(t, e, n) {
    var r, i, o, s = {};
    for(o in e)"key" == o ? r = e[o] : "ref" == o ? i = e[o] : s[o] = e[o];
    if (arguments.length > 2 && (s.children = arguments.length > 3 ? u.call(arguments, 2) : n), "function" == typeof t && null != t.defaultProps) for(o in t.defaultProps)void 0 === s[o] && (s[o] = t.defaultProps[o]);
    return w(t, s, r, i, null);
}
function w(t, e, n, r, i) {
    var o = {
        type: t,
        props: e,
        key: n,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == i ? ++c : i
    };
    return null == i && null != l.vnode && l.vnode(o), o;
}
function k() {
    return {
        current: null
    };
}
function S(t) {
    return t.children;
}
function C(t, e) {
    this.props = t, this.context = e;
}
function P(t, e) {
    if (null == e) return t.__ ? P(t.__, t.__.__k.indexOf(t) + 1) : null;
    for(var n; e < t.__k.length; e++)if (null != (n = t.__k[e]) && null != n.__e) return n.__e;
    return "function" == typeof t.type ? P(t) : null;
}
function x(t) {
    var e, n;
    if (null != (t = t.__) && null != t.__c) {
        for(t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++)if (null != (n = t.__k[e]) && null != n.__e) {
            t.__e = t.__c.base = n.__e;
            break;
        }
        return x(t);
    }
}
function N(t) {
    (!t.__d && (t.__d = !0) && h.push(t) && !E.__r++ || f !== l.debounceRendering) && ((f = l.debounceRendering) || setTimeout)(E);
}
function E() {
    for(var t; E.__r = h.length;)t = h.sort(function(t, e) {
        return t.__v.__b - e.__v.__b;
    }), h = [], t.some(function(t) {
        var e, n, r, i, o, s;
        t.__d && (o = (i = (e = t).__v).__e, (s = e.__P) && (n = [], (r = v({}, i)).__v = i.__v + 1, U(s, i, r, e.__n, void 0 !== s.ownerSVGElement, null != i.__h ? [
            o
        ] : null, n, null == o ? P(i) : o, i.__h), H(n, i), i.__e != o && x(i)));
    });
}
function F(t, e, n, r, i, o, s, a, u, l) {
    var c, p, h, f, d, g, v, y = r && r.__k || m, b = y.length;
    for(n.__k = [], c = 0; c < e.length; c++)if (null != (f = n.__k[c] = null == (f = e[c]) || "boolean" == typeof f ? null : "string" == typeof f || "number" == typeof f || "bigint" == typeof f ? w(null, f, null, null, f) : Array.isArray(f) ? w(S, {
        children: f
    }, null, null, null) : f.__b > 0 ? w(f.type, f.props, f.key, null, f.__v) : f)) {
        if (f.__ = n, f.__b = n.__b + 1, null === (h = y[c]) || h && f.key == h.key && f.type === h.type) y[c] = void 0;
        else for(p = 0; p < b; p++){
            if ((h = y[p]) && f.key == h.key && f.type === h.type) {
                y[p] = void 0;
                break;
            }
            h = null;
        }
        U(t, f, h = h || _, i, o, s, a, u, l), d = f.__e, (p = f.ref) && h.ref != p && (v || (v = []), h.ref && v.push(h.ref, null, f), v.push(p, f.__c || d, f)), null != d ? (null == g && (g = d), "function" == typeof f.type && f.__k === h.__k ? f.__d = u = T(f, u, t) : u = D(t, f, h, y, d, u), "function" == typeof n.type && (n.__d = u)) : u && h.__e == u && u.parentNode != t && (u = P(h));
    }
    for(n.__e = g, c = b; c--;)null != y[c] && ("function" == typeof n.type && null != y[c].__e && y[c].__e == n.__d && (n.__d = P(r, c + 1)), j(y[c], y[c]));
    if (v) for(c = 0; c < v.length; c++)O(v[c], v[++c], v[++c]);
}
function T(t, e, n) {
    for(var r, i = t.__k, o = 0; i && o < i.length; o++)(r = i[o]) && (r.__ = t, e = "function" == typeof r.type ? T(r, e, n) : D(n, r, r, i, r.__e, e));
    return e;
}
function D(t, e, n, r, i, o) {
    var s, a, u;
    if (void 0 !== e.__d) s = e.__d, e.__d = void 0;
    else if (null == n || i != o || null == i.parentNode) t: if (null == o || o.parentNode !== t) t.appendChild(i), s = null;
    else {
        for(a = o, u = 0; (a = a.nextSibling) && u < r.length; u += 2)if (a == i) break t;
        t.insertBefore(i, o), s = o;
    }
    return void 0 !== s ? s : i.nextSibling;
}
function R(t, e, n) {
    "-" === e[0] ? t.setProperty(e, n) : t[e] = null == n ? "" : "number" != typeof n || g.test(e) ? n : n + "px";
}
function L(t, e, n, r, i) {
    var o;
    t: if ("style" === e) {
        if ("string" == typeof n) t.style.cssText = n;
        else {
            if ("string" == typeof r && (t.style.cssText = r = ""), r) for(e in r)n && e in n || R(t.style, e, "");
            if (n) for(e in n)r && n[e] === r[e] || R(t.style, e, n[e]);
        }
    } else if ("o" === e[0] && "n" === e[1]) o = e !== (e = e.replace(/Capture$/, "")), e = e.toLowerCase() in t ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + o] = n, n ? r || t.addEventListener(e, o ? I : A, o) : t.removeEventListener(e, o ? I : A, o);
    else if ("dangerouslySetInnerHTML" !== e) {
        if (i) e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("href" !== e && "list" !== e && "form" !== e && "tabIndex" !== e && "download" !== e && e in t) try {
            t[e] = null == n ? "" : n;
            break t;
        } catch (t) {}
        "function" == typeof n || (null != n && (!1 !== n || "a" === e[0] && "r" === e[1]) ? t.setAttribute(e, n) : t.removeAttribute(e));
    }
}
function A(t) {
    this.l[t.type + !1](l.event ? l.event(t) : t);
}
function I(t) {
    this.l[t.type + !0](l.event ? l.event(t) : t);
}
function U(t, e, n, r, i, o, s, a, u) {
    var c, p, h, f, d, _, m, g, y, b, w, k, P, x = e.type;
    if (void 0 !== e.constructor) return null;
    null != n.__h && (u = n.__h, a = e.__e = n.__e, e.__h = null, o = [
        a
    ]), (c = l.__b) && c(e);
    try {
        t: if ("function" == typeof x) {
            if (g = e.props, y = (c = x.contextType) && r[c.__c], b = c ? y ? y.props.value : c.__ : r, n.__c ? m = (p = e.__c = n.__c).__ = p.__E : ("prototype" in x && x.prototype.render ? e.__c = p = new x(g, b) : (e.__c = p = new C(g, b), p.constructor = x, p.render = W), y && y.sub(p), p.props = g, p.state || (p.state = {}), p.context = b, p.__n = r, h = p.__d = !0, p.__h = []), null == p.__s && (p.__s = p.state), null != x.getDerivedStateFromProps && (p.__s == p.state && (p.__s = v({}, p.__s)), v(p.__s, x.getDerivedStateFromProps(g, p.__s))), f = p.props, d = p.state, h) null == x.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
            else {
                if (null == x.getDerivedStateFromProps && g !== f && null != p.componentWillReceiveProps && p.componentWillReceiveProps(g, b), !p.__e && null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(g, p.__s, b) || e.__v === n.__v) {
                    p.props = g, p.state = p.__s, e.__v !== n.__v && (p.__d = !1), p.__v = e, e.__e = n.__e, e.__k = n.__k, e.__k.forEach(function(t) {
                        t && (t.__ = e);
                    }), p.__h.length && s.push(p);
                    break t;
                }
                null != p.componentWillUpdate && p.componentWillUpdate(g, p.__s, b), null != p.componentDidUpdate && p.__h.push(function() {
                    p.componentDidUpdate(f, d, _);
                });
            }
            if (p.context = b, p.props = g, p.__v = e, p.__P = t, w = l.__r, k = 0, "prototype" in x && x.prototype.render) p.state = p.__s, p.__d = !1, w && w(e), c = p.render(p.props, p.state, p.context);
            else do p.__d = !1, w && w(e), c = p.render(p.props, p.state, p.context), p.state = p.__s;
            while (p.__d && ++k < 25);
            p.state = p.__s, null != p.getChildContext && (r = v(v({}, r), p.getChildContext())), h || null == p.getSnapshotBeforeUpdate || (_ = p.getSnapshotBeforeUpdate(f, d)), P = null != c && c.type === S && null == c.key ? c.props.children : c, F(t, Array.isArray(P) ? P : [
                P
            ], e, n, r, i, o, s, a, u), p.base = e.__e, e.__h = null, p.__h.length && s.push(p), m && (p.__E = p.__ = null), p.__e = !1;
        } else null == o && e.__v === n.__v ? (e.__k = n.__k, e.__e = n.__e) : e.__e = M(n.__e, e, n, r, i, o, s, u);
        (c = l.diffed) && c(e);
    } catch (t) {
        e.__v = null, (u || null != o) && (e.__e = a, e.__h = !!u, o[o.indexOf(a)] = null), l.__e(t, e, n);
    }
}
function H(t, e) {
    l.__c && l.__c(e, t), t.some(function(e) {
        try {
            t = e.__h, e.__h = [], t.some(function(t) {
                t.call(e);
            });
        } catch (t) {
            l.__e(t, e.__v);
        }
    });
}
function M(t, e, n, r, i, o, s, a) {
    var l, c, p, h = n.props, f = e.props, d = e.type, m = 0;
    if ("svg" === d && (i = !0), null != o) {
        for(; m < o.length; m++)if ((l = o[m]) && "setAttribute" in l == !!d && (d ? l.localName === d : 3 === l.nodeType)) {
            t = l, o[m] = null;
            break;
        }
    }
    if (null == t) {
        if (null === d) return document.createTextNode(f);
        t = i ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, f.is && f), o = null, a = !1;
    }
    if (null === d) h === f || a && t.data === f || (t.data = f);
    else {
        if (o = o && u.call(t.childNodes), c = (h = n.props || _).dangerouslySetInnerHTML, p = f.dangerouslySetInnerHTML, !a) {
            if (null != o) for(h = {}, m = 0; m < t.attributes.length; m++)h[t.attributes[m].name] = t.attributes[m].value;
            (p || c) && (p && (c && p.__html == c.__html || p.__html === t.innerHTML) || (t.innerHTML = p && p.__html || ""));
        }
        if (function(t, e, n, r, i) {
            var o;
            for(o in n)"children" === o || "key" === o || o in e || L(t, o, null, n[o], r);
            for(o in e)i && "function" != typeof e[o] || "children" === o || "key" === o || "value" === o || "checked" === o || n[o] === e[o] || L(t, o, e[o], n[o], r);
        }(t, f, h, i, a), p) e.__k = [];
        else if (m = e.props.children, F(t, Array.isArray(m) ? m : [
            m
        ], e, n, r, i && "foreignObject" !== d, o, s, o ? o[0] : n.__k && P(n, 0), a), null != o) for(m = o.length; m--;)null != o[m] && y(o[m]);
        a || ("value" in f && void 0 !== (m = f.value) && (m !== t.value || "progress" === d && !m || "option" === d && m !== h.value) && L(t, "value", m, h.value, !1), "checked" in f && void 0 !== (m = f.checked) && m !== t.checked && L(t, "checked", m, h.checked, !1));
    }
    return t;
}
function O(t, e, n) {
    try {
        "function" == typeof t ? t(e) : t.current = e;
    } catch (t) {
        l.__e(t, n);
    }
}
function j(t, e, n) {
    var r, i;
    if (l.unmount && l.unmount(t), (r = t.ref) && (r.current && r.current !== t.__e || O(r, null, e)), null != (r = t.__c)) {
        if (r.componentWillUnmount) try {
            r.componentWillUnmount();
        } catch (t) {
            l.__e(t, e);
        }
        r.base = r.__P = null;
    }
    if (r = t.__k) for(i = 0; i < r.length; i++)r[i] && j(r[i], e, "function" != typeof t.type);
    n || null == t.__e || y(t.__e), t.__e = t.__d = void 0;
}
function W(t, e, n) {
    return this.constructor(t, n);
}
function B(t, e, n) {
    var r, i, o;
    l.__ && l.__(t, e), i = (r = "function" == typeof n) ? null : n && n.__k || e.__k, o = [], U(e, t = (!r && n || e).__k = b(S, null, [
        t
    ]), i || _, _, void 0 !== e.ownerSVGElement, !r && n ? [
        n
    ] : i ? null : e.firstChild ? u.call(e.childNodes) : null, o, !r && n ? n : i ? i.__e : e.firstChild, r), H(o, t);
}
function z() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
        var e = 16 * Math.random() | 0;
        return ("x" == t ? e : 3 & e | 8).toString(16);
    });
}
u = m.slice, l = {
    __e: function(t, e, n, r) {
        for(var i, o, s; e = e.__;)if ((i = e.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(t)), s = i.__d), null != i.componentDidCatch && (i.componentDidCatch(t, r || {}), s = i.__d), s) return i.__E = i;
        } catch (e) {
            t = e;
        }
        throw t;
    }
}, c = 0, p = function(t) {
    return null != t && void 0 === t.constructor;
}, C.prototype.setState = function(t, e) {
    var n;
    n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v({}, this.state), "function" == typeof t && (t = t(v({}, n), this.props)), t && v(n, t), null != t && this.__v && (e && this.__h.push(e), N(this));
}, C.prototype.forceUpdate = function(t) {
    this.__v && (this.__e = !0, t && this.__h.push(t), N(this));
}, C.prototype.render = S, h = [], E.__r = 0, d = 0;
var q = /*#__PURE__*/ function() {
    function t(t) {
        this._id = void 0, this._id = t || z();
    }
    return e(t, [
        {
            key: "id",
            get: function() {
                return this._id;
            }
        }
    ]), t;
}(), V = {
    search: {
        placeholder: "Type a keyword..."
    },
    sort: {
        sortAsc: "Sort column ascending",
        sortDesc: "Sort column descending"
    },
    pagination: {
        previous: "Previous",
        next: "Next",
        navigate: function(t, e) {
            return "Page " + t + " of " + e;
        },
        page: function(t) {
            return "Page " + t;
        },
        showing: "Showing",
        of: "of",
        to: "to",
        results: "results"
    },
    loading: "Loading...",
    noRecordsFound: "No matching records found",
    error: "An error happened while fetching the data"
}, G = /*#__PURE__*/ function() {
    function t(t) {
        this._language = void 0, this._defaultLanguage = void 0, this._language = t, this._defaultLanguage = V;
    }
    var e = t.prototype;
    return e.getString = function(t, e) {
        if (!e || !t) return null;
        var n = t.split("."), r = n[0];
        if (e[r]) {
            var i = e[r];
            return "string" == typeof i ? function() {
                return i;
            } : "function" == typeof i ? i : this.getString(n.slice(1).join("."), i);
        }
        return null;
    }, e.translate = function(t) {
        var e, n = this.getString(t, this._language);
        return (e = n || this.getString(t, this._defaultLanguage)) ? e.apply(void 0, [].slice.call(arguments, 1)) : t;
    }, t;
}(), X = /*#__PURE__*/ function(t) {
    function e(e, n) {
        var r, i;
        return (r = t.call(this, e, n) || this).config = void 0, r._ = void 0, r.config = function(t) {
            if (!t) return null;
            var e = Object.keys(t);
            return e.length ? t[e[0]].props.value : null;
        }(n), r.config && (r._ = (i = r.config.translator, function(t) {
            return i.translate.apply(i, [
                t
            ].concat([].slice.call(arguments, 1)));
        })), r;
    }
    return r(e, t), e;
}(C), $ = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    return r(e, t), e.prototype.render = function() {
        return b(this.props.parentElement, {
            dangerouslySetInnerHTML: {
                __html: this.props.content
            }
        });
    }, e;
}(X);
function K(t, e) {
    return b($, {
        content: t,
        parentElement: e
    });
}
$.defaultProps = {
    parentElement: "span"
};
var Y, Z = /*#__PURE__*/ function(t) {
    function e(e) {
        var n;
        return (n = t.call(this) || this).data = void 0, n.update(e), n;
    }
    r(e, t);
    var n = e.prototype;
    return n.cast = function(t) {
        return t instanceof HTMLElement ? K(t.outerHTML) : t;
    }, n.update = function(t) {
        return this.data = this.cast(t), this;
    }, e;
}(q), J = /*#__PURE__*/ function(t) {
    function n(e) {
        var n;
        return (n = t.call(this) || this)._cells = void 0, n.cells = e || [], n;
    }
    r(n, t);
    var i = n.prototype;
    return i.cell = function(t) {
        return this._cells[t];
    }, i.toArray = function() {
        return this.cells.map(function(t) {
            return t.data;
        });
    }, n.fromCells = function(t) {
        return new n(t.map(function(t) {
            return new Z(t.data);
        }));
    }, e(n, [
        {
            key: "cells",
            get: function() {
                return this._cells;
            },
            set: function(t) {
                this._cells = t;
            }
        },
        {
            key: "length",
            get: function() {
                return this.cells.length;
            }
        }
    ]), n;
}(q), Q = /*#__PURE__*/ function(t) {
    function n(e) {
        var n;
        return (n = t.call(this) || this)._rows = void 0, n._length = void 0, n.rows = e instanceof Array ? e : e instanceof J ? [
            e
        ] : [], n;
    }
    return r(n, t), n.prototype.toArray = function() {
        return this.rows.map(function(t) {
            return t.toArray();
        });
    }, n.fromRows = function(t) {
        return new n(t.map(function(t) {
            return J.fromCells(t.cells);
        }));
    }, n.fromArray = function(t) {
        return new n((t = function(t) {
            return !t[0] || t[0] instanceof Array ? t : [
                t
            ];
        }(t)).map(function(t) {
            return new J(t.map(function(t) {
                return new Z(t);
            }));
        }));
    }, e(n, [
        {
            key: "rows",
            get: function() {
                return this._rows;
            },
            set: function(t) {
                this._rows = t;
            }
        },
        {
            key: "length",
            get: function() {
                return this._length || this.rows.length;
            },
            set: function(t) {
                this._length = t;
            }
        }
    ]), n;
}(q), tt = /*#__PURE__*/ function() {
    function t() {
        this.callbacks = void 0;
    }
    var e = t.prototype;
    return e.init = function(t) {
        this.callbacks || (this.callbacks = {}), t && !this.callbacks[t] && (this.callbacks[t] = []);
    }, e.on = function(t, e) {
        return this.init(t), this.callbacks[t].push(e), this;
    }, e.off = function(t, e) {
        var n = t;
        return this.init(), this.callbacks[n] && 0 !== this.callbacks[n].length ? (this.callbacks[n] = this.callbacks[n].filter(function(t) {
            return t != e;
        }), this) : this;
    }, e.emit = function(t) {
        var e = arguments, n = t;
        return this.init(n), this.callbacks[n].length > 0 && (this.callbacks[n].forEach(function(t) {
            return t.apply(void 0, [].slice.call(e, 1));
        }), !0);
    }, t;
}();
!function(t) {
    t[t.Initiator = 0] = "Initiator", t[t.ServerFilter = 1] = "ServerFilter", t[t.ServerSort = 2] = "ServerSort", t[t.ServerLimit = 3] = "ServerLimit", t[t.Extractor = 4] = "Extractor", t[t.Transformer = 5] = "Transformer", t[t.Filter = 6] = "Filter", t[t.Sort = 7] = "Sort", t[t.Limit = 8] = "Limit";
}(Y || (Y = {}));
var et = /*#__PURE__*/ function(t) {
    function n(e) {
        var n;
        return (n = t.call(this) || this).id = void 0, n._props = void 0, n._props = {}, n.id = z(), e && n.setProps(e), n;
    }
    r(n, t);
    var i = n.prototype;
    return i.process = function() {
        var t = [].slice.call(arguments);
        this.validateProps instanceof Function && this.validateProps.apply(this, t), this.emit.apply(this, [
            "beforeProcess"
        ].concat(t));
        var e = this._process.apply(this, t);
        return this.emit.apply(this, [
            "afterProcess"
        ].concat(t)), e;
    }, i.setProps = function(t) {
        return Object.assign(this._props, t), this.emit("propsUpdated", this), this;
    }, e(n, [
        {
            key: "props",
            get: function() {
                return this._props;
            }
        }
    ]), n;
}(tt), nt = /*#__PURE__*/ function(t) {
    function n() {
        return t.apply(this, arguments) || this;
    }
    return r(n, t), n.prototype._process = function(t) {
        var e, n, r, i, o;
        return this.props.keyword ? (e = String(this.props.keyword).trim(), n = this.props.columns, r = this.props.ignoreHiddenColumns, i = t, o = this.props.selector, e = e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), new Q(i.rows.filter(function(t, i) {
            return t.cells.some(function(t, s) {
                if (!t) return !1;
                if (r && n && n[s] && "object" == typeof n[s] && n[s].hidden) return !1;
                var a = "";
                if ("function" == typeof o) a = o(t.data, i, s);
                else if ("object" == typeof t.data) {
                    var u = t.data;
                    u && u.props && u.props.content && (a = u.props.content);
                } else a = String(t.data);
                return new RegExp(e, "gi").test(a);
            });
        }))) : t;
    }, e(n, [
        {
            key: "type",
            get: function() {
                return Y.Filter;
            }
        }
    ]), n;
}(et);
function rt() {
    var t = "gridjs";
    return "" + t + [].slice.call(arguments).reduce(function(t, e) {
        return t + "-" + e;
    }, "");
}
function it() {
    return [].slice.call(arguments).filter(function(t) {
        return t;
    }).reduce(function(t, e) {
        return (t || "") + " " + e;
    }, "").trim() || null;
}
var ot, st = /*#__PURE__*/ function(t) {
    function n(e) {
        var n;
        return (n = t.call(this) || this)._state = void 0, n.dispatcher = void 0, n.dispatcher = e, n._state = n.getInitialState(), e.register(n._handle.bind(o(n))), n;
    }
    r(n, t);
    var i = n.prototype;
    return i._handle = function(t) {
        this.handle(t.type, t.payload);
    }, i.setState = function(t) {
        var e = this._state;
        this._state = t, this.emit("updated", t, e);
    }, e(n, [
        {
            key: "state",
            get: function() {
                return this._state;
            }
        }
    ]), n;
}(tt), at = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    r(e, t);
    var n = e.prototype;
    return n.getInitialState = function() {
        return {
            keyword: null
        };
    }, n.handle = function(t, e) {
        "SEARCH_KEYWORD" === t && this.search(e.keyword);
    }, n.search = function(t) {
        this.setState({
            keyword: t
        });
    }, e;
}(st), ut = /*#__PURE__*/ function() {
    function t(t) {
        this.dispatcher = void 0, this.dispatcher = t;
    }
    return t.prototype.dispatch = function(t, e) {
        this.dispatcher.dispatch({
            type: t,
            payload: e
        });
    }, t;
}(), lt = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    return r(e, t), e.prototype.search = function(t) {
        this.dispatch("SEARCH_KEYWORD", {
            keyword: t
        });
    }, e;
}(ut), ct = /*#__PURE__*/ function(t) {
    function i() {
        return t.apply(this, arguments) || this;
    }
    return r(i, t), i.prototype._process = function(t) {
        if (!this.props.keyword) return t;
        var e = {};
        return this.props.url && (e.url = this.props.url(t.url, this.props.keyword)), this.props.body && (e.body = this.props.body(t.body, this.props.keyword)), n({}, t, e);
    }, e(i, [
        {
            key: "type",
            get: function() {
                return Y.ServerFilter;
            }
        }
    ]), i;
}(et), pt = new /*#__PURE__*/ (function() {
    function t() {}
    var e = t.prototype;
    return e.format = function(t, e) {
        return "[Grid.js] [" + e.toUpperCase() + "]: " + t;
    }, e.error = function(t, e) {
        void 0 === e && (e = !1);
        var n = this.format(t, "error");
        if (e) throw Error(n);
        console.error(n);
    }, e.warn = function(t) {
        console.warn(this.format(t, "warn"));
    }, e.info = function(t) {
        console.info(this.format(t, "info"));
    }, t;
}()), ht = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    return r(e, t), e;
}(X);
!function(t) {
    t[t.Header = 0] = "Header", t[t.Footer = 1] = "Footer", t[t.Cell = 2] = "Cell";
}(ot || (ot = {}));
var ft = /*#__PURE__*/ function() {
    function t() {
        this.plugins = void 0, this.plugins = [];
    }
    var e = t.prototype;
    return e.get = function(t) {
        var e = this.plugins.filter(function(e) {
            return e.id === t;
        });
        return e.length > 0 ? e[0] : null;
    }, e.add = function(t) {
        return t.id ? null !== this.get(t.id) ? (pt.error("Duplicate plugin ID: " + t.id), this) : (this.plugins.push(t), this) : (pt.error("Plugin ID cannot be empty"), this);
    }, e.remove = function(t) {
        return this.plugins.splice(this.plugins.indexOf(this.get(t)), 1), this;
    }, e.list = function(t) {
        var e;
        return e = null != t || null != t ? this.plugins.filter(function(e) {
            return e.position === t;
        }) : this.plugins, e.sort(function(t, e) {
            return t.order - e.order;
        });
    }, t;
}(), dt = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    return r(e, t), e.prototype.render = function() {
        var t = this;
        if (this.props.pluginId) {
            var e = this.config.plugin.get(this.props.pluginId);
            return e ? b(S, {}, b(e.component, n({
                plugin: e
            }, e.props, this.props.props))) : null;
        }
        return void 0 !== this.props.position ? b(S, {}, this.config.plugin.list(this.props.position).map(function(e) {
            return b(e.component, n({
                plugin: e
            }, e.props, t.props.props));
        })) : null;
    }, e;
}(X), _t = /*#__PURE__*/ function(t) {
    function e(e, n) {
        var r;
        (r = t.call(this, e, n) || this).searchProcessor = void 0, r.actions = void 0, r.store = void 0, r.storeUpdatedFn = void 0, r.actions = new lt(r.config.dispatcher), r.store = new at(r.config.dispatcher);
        var i, s = e.keyword;
        return e.enabled && (s && r.actions.search(s), r.storeUpdatedFn = r.storeUpdated.bind(o(r)), r.store.on("updated", r.storeUpdatedFn), i = e.server ? new ct({
            keyword: e.keyword,
            url: e.server.url,
            body: e.server.body
        }) : new nt({
            keyword: e.keyword,
            columns: r.config.header && r.config.header.columns,
            ignoreHiddenColumns: e.ignoreHiddenColumns || void 0 === e.ignoreHiddenColumns,
            selector: e.selector
        }), r.searchProcessor = i, r.config.pipeline.register(i)), r;
    }
    r(e, t);
    var n = e.prototype;
    return n.componentWillUnmount = function() {
        this.config.pipeline.unregister(this.searchProcessor), this.store.off("updated", this.storeUpdatedFn);
    }, n.storeUpdated = function(t) {
        this.searchProcessor.setProps({
            keyword: t.keyword
        });
    }, n.onChange = function(t) {
        this.actions.search(t.target.value);
    }, n.render = function() {
        if (!this.props.enabled) return null;
        var t, e, n, r = this.onChange.bind(this);
        return this.searchProcessor instanceof ct && (t = r, e = this.props.debounceTimeout, r = function() {
            var r = arguments;
            return new Promise(function(i) {
                n && clearTimeout(n), n = setTimeout(function() {
                    return i(t.apply(void 0, [].slice.call(r)));
                }, e);
            });
        }), b("div", {
            className: rt(it("search", this.config.className.search))
        }, b("input", {
            type: "search",
            placeholder: this._("search.placeholder"),
            "aria-label": this._("search.placeholder"),
            onInput: r,
            className: it(rt("input"), rt("search", "input")),
            value: this.store.state.keyword
        }));
    }, e;
}(ht);
_t.defaultProps = {
    debounceTimeout: 250
};
var mt = /*#__PURE__*/ function(t) {
    function n() {
        return t.apply(this, arguments) || this;
    }
    r(n, t);
    var i = n.prototype;
    return i.validateProps = function() {
        if (isNaN(Number(this.props.limit)) || isNaN(Number(this.props.page))) throw Error("Invalid parameters passed");
    }, i._process = function(t) {
        var e = this.props.page;
        return new Q(t.rows.slice(e * this.props.limit, (e + 1) * this.props.limit));
    }, e(n, [
        {
            key: "type",
            get: function() {
                return Y.Limit;
            }
        }
    ]), n;
}(et), gt = /*#__PURE__*/ function(t) {
    function i() {
        return t.apply(this, arguments) || this;
    }
    return r(i, t), i.prototype._process = function(t) {
        var e = {};
        return this.props.url && (e.url = this.props.url(t.url, this.props.page, this.props.limit)), this.props.body && (e.body = this.props.body(t.body, this.props.page, this.props.limit)), n({}, t, e);
    }, e(i, [
        {
            key: "type",
            get: function() {
                return Y.ServerLimit;
            }
        }
    ]), i;
}(et), vt = /*#__PURE__*/ function(t) {
    function n(e, n) {
        var r;
        return (r = t.call(this, e, n) || this).processor = void 0, r.onUpdateFn = void 0, r.setTotalFromTabularFn = void 0, r.state = {
            limit: e.limit,
            page: e.page || 0,
            total: 0
        }, r;
    }
    r(n, t);
    var i = n.prototype;
    return i.componentWillMount = function() {
        var t, e = this;
        this.props.enabled && (this.setTotalFromTabularFn = this.setTotalFromTabular.bind(this), this.props.server ? (t = new gt({
            limit: this.state.limit,
            page: this.state.page,
            url: this.props.server.url,
            body: this.props.server.body
        }), this.config.pipeline.on("afterProcess", this.setTotalFromTabularFn)) : (t = new mt({
            limit: this.state.limit,
            page: this.state.page
        })).on("beforeProcess", this.setTotalFromTabularFn), this.processor = t, this.config.pipeline.register(t), this.config.pipeline.on("error", function() {
            e.setState({
                total: 0,
                page: 0
            });
        }));
    }, i.setTotalFromTabular = function(t) {
        this.setTotal(t.length);
    }, i.onUpdate = function(t) {
        this.props.resetPageOnUpdate && t !== this.processor && this.setPage(0);
    }, i.componentDidMount = function() {
        this.onUpdateFn = this.onUpdate.bind(this), this.config.pipeline.on("updated", this.onUpdateFn);
    }, i.componentWillUnmount = function() {
        this.config.pipeline.unregister(this.processor), this.config.pipeline.off("updated", this.onUpdateFn);
    }, i.setPage = function(t) {
        if (t >= this.pages || t < 0 || t === this.state.page) return null;
        this.setState({
            page: t
        }), this.processor.setProps({
            page: t
        });
    }, i.setTotal = function(t) {
        this.setState({
            total: t
        });
    }, i.renderPages = function() {
        var t = this;
        if (this.props.buttonsCount <= 0) return null;
        var e = Math.min(this.pages, this.props.buttonsCount), n = Math.min(this.state.page, Math.floor(e / 2));
        return this.state.page + Math.floor(e / 2) >= this.pages && (n = e - (this.pages - this.state.page)), b(S, null, this.pages > e && this.state.page - n > 0 && b(S, null, b("button", {
            tabIndex: 0,
            role: "button",
            onClick: this.setPage.bind(this, 0),
            title: this._("pagination.firstPage"),
            "aria-label": this._("pagination.firstPage"),
            className: this.config.className.paginationButton
        }, this._("1")), b("button", {
            tabIndex: -1,
            className: it(rt("spread"), this.config.className.paginationButton)
        }, "...")), Array.from(Array(e).keys()).map(function(e) {
            return t.state.page + (e - n);
        }).map(function(e) {
            return b("button", {
                tabIndex: 0,
                role: "button",
                onClick: t.setPage.bind(t, e),
                className: it(t.state.page === e ? it(rt("currentPage"), t.config.className.paginationButtonCurrent) : null, t.config.className.paginationButton),
                title: t._("pagination.page", e + 1),
                "aria-label": t._("pagination.page", e + 1)
            }, t._("" + (e + 1)));
        }), this.pages > e && this.pages > this.state.page + n + 1 && b(S, null, b("button", {
            tabIndex: -1,
            className: it(rt("spread"), this.config.className.paginationButton)
        }, "..."), b("button", {
            tabIndex: 0,
            role: "button",
            onClick: this.setPage.bind(this, this.pages - 1),
            title: this._("pagination.page", this.pages),
            "aria-label": this._("pagination.page", this.pages),
            className: this.config.className.paginationButton
        }, this._("" + this.pages))));
    }, i.renderSummary = function() {
        return b(S, null, this.props.summary && this.state.total > 0 && b("div", {
            role: "status",
            "aria-live": "polite",
            className: it(rt("summary"), this.config.className.paginationSummary),
            title: this._("pagination.navigate", this.state.page + 1, this.pages)
        }, this._("pagination.showing"), " ", b("b", null, this._("" + (this.state.page * this.state.limit + 1))), " ", this._("pagination.to"), " ", b("b", null, this._("" + Math.min((this.state.page + 1) * this.state.limit, this.state.total))), " ", this._("pagination.of"), " ", b("b", null, this._("" + this.state.total)), " ", this._("pagination.results")));
    }, i.render = function() {
        return this.props.enabled ? b("div", {
            className: it(rt("pagination"), this.config.className.pagination)
        }, this.renderSummary(), b("div", {
            className: rt("pages")
        }, this.props.prevButton && b("button", {
            tabIndex: 0,
            role: "button",
            disabled: 0 === this.state.page,
            onClick: this.setPage.bind(this, this.state.page - 1),
            title: this._("pagination.previous"),
            "aria-label": this._("pagination.previous"),
            className: it(this.config.className.paginationButton, this.config.className.paginationButtonPrev)
        }, this._("pagination.previous")), this.renderPages(), this.props.nextButton && b("button", {
            tabIndex: 0,
            role: "button",
            disabled: this.pages === this.state.page + 1 || 0 === this.pages,
            onClick: this.setPage.bind(this, this.state.page + 1),
            title: this._("pagination.next"),
            "aria-label": this._("pagination.next"),
            className: it(this.config.className.paginationButton, this.config.className.paginationButtonNext)
        }, this._("pagination.next")))) : null;
    }, e(n, [
        {
            key: "pages",
            get: function() {
                return Math.ceil(this.state.total / this.state.limit);
            }
        }
    ]), n;
}(ht);
function yt(t, e) {
    return "string" == typeof t ? t.indexOf("%") > -1 ? e / 100 * parseInt(t, 10) : parseInt(t, 10) : t;
}
function bt(t) {
    return t ? Math.floor(t) + "px" : "";
}
vt.defaultProps = {
    summary: !0,
    nextButton: !0,
    prevButton: !0,
    buttonsCount: 3,
    limit: 10,
    resetPageOnUpdate: !0
};
var wt = /*#__PURE__*/ function(t) {
    function e(e, n) {
        var r;
        return (r = t.call(this, e, n) || this).tableElement = void 0, r.tableClassName = void 0, r.tableStyle = void 0, r.tableElement = r.props.tableRef.current.base.cloneNode(!0), r.tableElement.style.position = "absolute", r.tableElement.style.width = "100%", r.tableElement.style.zIndex = "-2147483640", r.tableElement.style.visibility = "hidden", r.tableClassName = r.tableElement.className, r.tableStyle = r.tableElement.style.cssText, r;
    }
    r(e, t);
    var i = e.prototype;
    return i.widths = function() {
        this.tableElement.className = this.tableClassName + " " + rt("shadowTable"), this.tableElement.style.tableLayout = "auto", this.tableElement.style.width = "auto", this.tableElement.style.padding = "0", this.tableElement.style.margin = "0", this.tableElement.style.border = "none", this.tableElement.style.outline = "none";
        var t = Array.from(this.base.parentNode.querySelectorAll("thead th")).reduce(function(t, e) {
            var r;
            return e.style.width = e.clientWidth + "px", n(((r = {})[e.getAttribute("data-column-id")] = {
                minWidth: e.clientWidth
            }, r), t);
        }, {});
        return this.tableElement.className = this.tableClassName, this.tableElement.style.cssText = this.tableStyle, this.tableElement.style.tableLayout = "auto", Array.from(this.base.parentNode.querySelectorAll("thead th")).reduce(function(t, e) {
            return t[e.getAttribute("data-column-id")].width = e.clientWidth, t;
        }, t);
    }, i.render = function() {
        var t = this;
        return this.props.tableRef.current ? b("div", {
            ref: function(e) {
                e && e.appendChild(t.tableElement);
            }
        }) : null;
    }, e;
}(X);
function kt(t) {
    if (!t) return "";
    var e = t.split(" ");
    return 1 === e.length && /([a-z][A-Z])+/g.test(t) ? t : e.map(function(t, e) {
        return 0 == e ? t.toLowerCase() : t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
    }).join("");
}
var St = /*#__PURE__*/ function(t) {
    function i() {
        var e;
        return (e = t.call(this) || this)._columns = void 0, e._columns = [], e;
    }
    r(i, t);
    var o = i.prototype;
    return o.adjustWidth = function(t) {
        var e = t.container, n = t.tableRef, r = t.tempRef, o = t.tempRef || !0;
        if (!e) return this;
        var s = e.clientWidth, u = {
            current: null
        }, l = {};
        if (n.current && o) {
            var c = b(wt, {
                tableRef: n
            });
            c.ref = u, B(c, r.current), l = u.current.widths();
        }
        for(var p, h = a(i.tabularFormat(this.columns).reduce(function(t, e) {
            return t.concat(e);
        }, [])); !(p = h()).done;){
            var f = p.value;
            f.columns && f.columns.length > 0 || (!f.width && o ? f.id in l && (f.width = bt(l[f.id].width), f.minWidth = bt(l[f.id].minWidth)) : f.width = bt(yt(f.width, s)));
        }
        return n.current && o && B(null, r.current), this;
    }, o.setSort = function(t, e) {
        for(var r, i = a(e || this.columns || []); !(r = i()).done;){
            var o = r.value;
            o.columns && o.columns.length > 0 && (o.sort = {
                enabled: !1
            }), void 0 === o.sort && t.sort && (o.sort = {
                enabled: !0
            }), o.sort ? "object" == typeof o.sort && (o.sort = n({
                enabled: !0
            }, o.sort)) : o.sort = {
                enabled: !1
            }, o.columns && this.setSort(t, o.columns);
        }
    }, o.setFixedHeader = function(t, e) {
        for(var n, r = a(e || this.columns || []); !(n = r()).done;){
            var i = n.value;
            void 0 === i.fixedHeader && (i.fixedHeader = t.fixedHeader), i.columns && this.setFixedHeader(t, i.columns);
        }
    }, o.setResizable = function(t, e) {
        for(var n, r = a(e || this.columns || []); !(n = r()).done;){
            var i = n.value;
            void 0 === i.resizable && (i.resizable = t.resizable), i.columns && this.setResizable(t, i.columns);
        }
    }, o.setID = function(t) {
        for(var e, n = a(t || this.columns || []); !(e = n()).done;){
            var r = e.value;
            r.id || "string" != typeof r.name || (r.id = kt(r.name)), r.id || pt.error('Could not find a valid ID for one of the columns. Make sure a valid "id" is set for all columns.'), r.columns && this.setID(r.columns);
        }
    }, o.populatePlugins = function(t, e) {
        for(var r, i = a(e); !(r = i()).done;){
            var o = r.value;
            void 0 !== o.plugin && t.plugin.add(n({
                id: o.id,
                props: {}
            }, o.plugin, {
                position: ot.Cell
            }));
        }
    }, i.fromColumns = function(t) {
        for(var e, n = new i, r = a(t); !(e = r()).done;){
            var o = e.value;
            if ("string" == typeof o || p(o)) n.columns.push({
                name: o
            });
            else if ("object" == typeof o) {
                var s = o;
                s.columns && (s.columns = i.fromColumns(s.columns).columns), "object" == typeof s.plugin && void 0 === s.data && (s.data = null), n.columns.push(o);
            }
        }
        return n;
    }, i.fromUserConfig = function(t) {
        var e = new i;
        return t.from ? e.columns = i.fromHTMLTable(t.from).columns : t.columns ? e.columns = i.fromColumns(t.columns).columns : !t.data || "object" != typeof t.data[0] || t.data[0] instanceof Array || (e.columns = Object.keys(t.data[0]).map(function(t) {
            return {
                name: t
            };
        })), e.columns.length ? (e.setID(), e.setSort(t), e.setFixedHeader(t), e.setResizable(t), e.populatePlugins(t, e.columns), e) : null;
    }, i.fromHTMLTable = function(t) {
        for(var e, n = new i, r = a(t.querySelector("thead").querySelectorAll("th")); !(e = r()).done;){
            var o = e.value;
            n.columns.push({
                name: o.innerHTML,
                width: o.width
            });
        }
        return n;
    }, i.tabularFormat = function(t) {
        var e = [], n = t || [], r = [];
        if (n && n.length) {
            e.push(n);
            for(var i, o = a(n); !(i = o()).done;){
                var s = i.value;
                s.columns && s.columns.length && (r = r.concat(s.columns));
            }
            r.length && (e = e.concat(this.tabularFormat(r)));
        }
        return e;
    }, i.leafColumns = function(t) {
        var e = [], n = t || [];
        if (n && n.length) for(var r, i = a(n); !(r = i()).done;){
            var o = r.value;
            o.columns && 0 !== o.columns.length || e.push(o), o.columns && (e = e.concat(this.leafColumns(o.columns)));
        }
        return e;
    }, i.maximumDepth = function(t) {
        return this.tabularFormat([
            t
        ]).length - 1;
    }, e(i, [
        {
            key: "columns",
            get: function() {
                return this._columns;
            },
            set: function(t) {
                this._columns = t;
            }
        },
        {
            key: "visibleColumns",
            get: function() {
                return this._columns.filter(function(t) {
                    return !t.hidden;
                });
            }
        }
    ]), i;
}(q), Ct = /*#__PURE__*/ function() {
    function t() {
        this._callbacks = void 0, this._isDispatching = void 0, this._isHandled = void 0, this._isPending = void 0, this._lastID = void 0, this._pendingPayload = void 0, this._callbacks = {}, this._isDispatching = !1, this._isHandled = {}, this._isPending = {}, this._lastID = 1;
    }
    var e = t.prototype;
    return e.register = function(t) {
        var e = "ID_" + this._lastID++;
        return this._callbacks[e] = t, e;
    }, e.unregister = function(t) {
        if (!this._callbacks[t]) throw Error("Dispatcher.unregister(...): " + t + " does not map to a registered callback.");
        delete this._callbacks[t];
    }, e.waitFor = function(t) {
        if (!this._isDispatching) throw Error("Dispatcher.waitFor(...): Must be invoked while dispatching.");
        for(var e = 0; e < t.length; e++){
            var n = t[e];
            if (this._isPending[n]) {
                if (!this._isHandled[n]) throw Error("Dispatcher.waitFor(...): Circular dependency detected while ' +\n            'waiting for " + n + ".");
            } else {
                if (!this._callbacks[n]) throw Error("Dispatcher.waitFor(...): " + n + " does not map to a registered callback.");
                this._invokeCallback(n);
            }
        }
    }, e.dispatch = function(t) {
        if (this._isDispatching) throw Error("Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.");
        this._startDispatching(t);
        try {
            for(var e in this._callbacks)this._isPending[e] || this._invokeCallback(e);
        } finally{
            this._stopDispatching();
        }
    }, e.isDispatching = function() {
        return this._isDispatching;
    }, e._invokeCallback = function(t) {
        this._isPending[t] = !0, this._callbacks[t](this._pendingPayload), this._isHandled[t] = !0;
    }, e._startDispatching = function(t) {
        for(var e in this._callbacks)this._isPending[e] = !1, this._isHandled[e] = !1;
        this._pendingPayload = t, this._isDispatching = !0;
    }, e._stopDispatching = function() {
        delete this._pendingPayload, this._isDispatching = !1;
    }, t;
}(), Pt = function() {}, xt = /*#__PURE__*/ function(t) {
    function e(e) {
        var n;
        return (n = t.call(this) || this).data = void 0, n.set(e), n;
    }
    r(e, t);
    var n = e.prototype;
    return n.get = function() {
        try {
            return Promise.resolve(this.data()).then(function(t) {
                return {
                    data: t,
                    total: t.length
                };
            });
        } catch (t) {
            return Promise.reject(t);
        }
    }, n.set = function(t) {
        return t instanceof Array ? this.data = function() {
            return t;
        } : t instanceof Function && (this.data = t), this;
    }, e;
}(Pt), Nt = /*#__PURE__*/ function(t) {
    function e(e) {
        var n;
        return (n = t.call(this) || this).options = void 0, n.options = e, n;
    }
    r(e, t);
    var i = e.prototype;
    return i.handler = function(t) {
        return "function" == typeof this.options.handle ? this.options.handle(t) : t.ok ? t.json() : (pt.error("Could not fetch data: " + t.status + " - " + t.statusText, !0), null);
    }, i.get = function(t) {
        var e = n({}, this.options, t);
        return "function" == typeof e.data ? e.data(e) : fetch(e.url, e).then(this.handler.bind(this)).then(function(t) {
            return {
                data: e.then(t),
                total: "function" == typeof e.total ? e.total(t) : void 0
            };
        });
    }, e;
}(Pt), Et = /*#__PURE__*/ function() {
    function t() {}
    return t.createFromUserConfig = function(t) {
        var e = null;
        return t.data && (e = new xt(t.data)), t.from && (e = new xt(this.tableElementToArray(t.from)), t.from.style.display = "none"), t.server && (e = new Nt(t.server)), e || pt.error("Could not determine the storage type", !0), e;
    }, t.tableElementToArray = function(t) {
        for(var e, n, r = [], i = a(t.querySelector("tbody").querySelectorAll("tr")); !(e = i()).done;){
            for(var o, s = [], u = a(e.value.querySelectorAll("td")); !(o = u()).done;){
                var l = o.value;
                1 === l.childNodes.length && l.childNodes[0].nodeType === Node.TEXT_NODE ? s.push((n = l.innerHTML, (new DOMParser).parseFromString(n, "text/html").documentElement.textContent)) : s.push(K(l.innerHTML));
            }
            r.push(s);
        }
        return r;
    }, t;
}(), Ft = "undefined" != typeof Symbol ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
function Tt(t, e, n) {
    if (!t.s) {
        if (n instanceof Dt) {
            if (!n.s) return void (n.o = Tt.bind(null, t, e));
            1 & e && (e = n.s), n = n.v;
        }
        if (n && n.then) return void n.then(Tt.bind(null, t, e), Tt.bind(null, t, 2));
        t.s = e, t.v = n;
        var r = t.o;
        r && r(t);
    }
}
var Dt = /*#__PURE__*/ function() {
    function t() {}
    return t.prototype.then = function(e, n) {
        var r = new t, i = this.s;
        if (i) {
            var o = 1 & i ? e : n;
            if (o) {
                try {
                    Tt(r, 1, o(this.v));
                } catch (t) {
                    Tt(r, 2, t);
                }
                return r;
            }
            return this;
        }
        return this.o = function(t) {
            try {
                var i = t.v;
                1 & t.s ? Tt(r, 1, e ? e(i) : i) : n ? Tt(r, 1, n(i)) : Tt(r, 2, i);
            } catch (t) {
                Tt(r, 2, t);
            }
        }, r;
    }, t;
}();
function Rt(t) {
    return t instanceof Dt && 1 & t.s;
}
var Lt, At = /*#__PURE__*/ function(t) {
    function n(e) {
        var n;
        return (n = t.call(this) || this)._steps = new Map, n.cache = new Map, n.lastProcessorIndexUpdated = -1, e && e.forEach(function(t) {
            return n.register(t);
        }), n;
    }
    r(n, t);
    var i = n.prototype;
    return i.clearCache = function() {
        this.cache = new Map, this.lastProcessorIndexUpdated = -1;
    }, i.register = function(t, e) {
        if (void 0 === e && (e = null), null === t.type) throw Error("Processor type is not defined");
        t.on("propsUpdated", this.processorPropsUpdated.bind(this)), this.addProcessorByPriority(t, e), this.afterRegistered(t);
    }, i.unregister = function(t) {
        if (t) {
            var e = this._steps.get(t.type);
            e && e.length && (this._steps.set(t.type, e.filter(function(e) {
                return e != t;
            })), this.emit("updated", t));
        }
    }, i.addProcessorByPriority = function(t, e) {
        var n = this._steps.get(t.type);
        if (!n) {
            var r = [];
            this._steps.set(t.type, r), n = r;
        }
        if (null === e || e < 0) n.push(t);
        else if (n[e]) {
            var i = n.slice(0, e - 1), o = n.slice(e + 1);
            this._steps.set(t.type, i.concat(t).concat(o));
        } else n[e] = t;
    }, i.getStepsByType = function(t) {
        return this.steps.filter(function(e) {
            return e.type === t;
        });
    }, i.getSortedProcessorTypes = function() {
        return Object.keys(Y).filter(function(t) {
            return !isNaN(Number(t));
        }).map(function(t) {
            return Number(t);
        });
    }, i.process = function(t) {
        try {
            var e = this, n = function(t) {
                return e.lastProcessorIndexUpdated = i.length, e.emit("afterProcess", o), o;
            }, r = e.lastProcessorIndexUpdated, i = e.steps, o = t, s = function(t, n) {
                try {
                    var s = function(t, e, n) {
                        if ("function" == typeof t[Ft]) {
                            var r, i, o, s = t[Ft]();
                            if (function t(n) {
                                try {
                                    for(; !(r = s.next()).done;)if ((n = e(r.value)) && n.then) {
                                        if (!Rt(n)) return void n.then(t, o || (o = Tt.bind(null, i = new Dt, 2)));
                                        n = n.v;
                                    }
                                    i ? Tt(i, 1, n) : i = n;
                                } catch (t) {
                                    Tt(i || (i = new Dt), 2, t);
                                }
                            }(), s.return) {
                                var a = function(t) {
                                    try {
                                        r.done || s.return();
                                    } catch (t) {}
                                    return t;
                                };
                                if (i && i.then) return i.then(a, function(t) {
                                    throw a(t);
                                });
                                a();
                            }
                            return i;
                        }
                        if (!("length" in t)) throw new TypeError("Object is not iterable");
                        for(var u = [], l = 0; l < t.length; l++)u.push(t[l]);
                        return function(t, e, n) {
                            var r, i, o = -1;
                            return function n(s) {
                                try {
                                    for(; ++o < t.length;)if ((s = e(o)) && s.then) {
                                        if (!Rt(s)) return void s.then(n, i || (i = Tt.bind(null, r = new Dt, 2)));
                                        s = s.v;
                                    }
                                    r ? Tt(r, 1, s) : r = s;
                                } catch (t) {
                                    Tt(r || (r = new Dt), 2, t);
                                }
                            }(), r;
                        }(u, function(t) {
                            return e(u[t]);
                        });
                    }(i, function(t) {
                        var n = e.findProcessorIndexByID(t.id), i = function() {
                            if (n >= r) return Promise.resolve(t.process(o)).then(function(n) {
                                e.cache.set(t.id, o = n);
                            });
                            o = e.cache.get(t.id);
                        }();
                        if (i && i.then) return i.then(function() {});
                    });
                } catch (t) {
                    return n(t);
                }
                return s && s.then ? s.then(void 0, n) : s;
            }(0, function(t) {
                throw pt.error(t), e.emit("error", o), t;
            });
            return Promise.resolve(s && s.then ? s.then(n) : n());
        } catch (t) {
            return Promise.reject(t);
        }
    }, i.findProcessorIndexByID = function(t) {
        return this.steps.findIndex(function(e) {
            return e.id == t;
        });
    }, i.setLastProcessorIndex = function(t) {
        var e = this.findProcessorIndexByID(t.id);
        this.lastProcessorIndexUpdated > e && (this.lastProcessorIndexUpdated = e);
    }, i.processorPropsUpdated = function(t) {
        this.setLastProcessorIndex(t), this.emit("propsUpdated"), this.emit("updated", t);
    }, i.afterRegistered = function(t) {
        this.setLastProcessorIndex(t), this.emit("afterRegister"), this.emit("updated", t);
    }, e(n, [
        {
            key: "steps",
            get: function() {
                for(var t, e = [], n = a(this.getSortedProcessorTypes()); !(t = n()).done;){
                    var r = this._steps.get(t.value);
                    r && r.length && (e = e.concat(r));
                }
                return e.filter(function(t) {
                    return t;
                });
            }
        }
    ]), n;
}(tt), It = /*#__PURE__*/ function(t) {
    function n() {
        return t.apply(this, arguments) || this;
    }
    return r(n, t), n.prototype._process = function(t) {
        try {
            return Promise.resolve(this.props.storage.get(t));
        } catch (t) {
            return Promise.reject(t);
        }
    }, e(n, [
        {
            key: "type",
            get: function() {
                return Y.Extractor;
            }
        }
    ]), n;
}(et), Ut = /*#__PURE__*/ function(t) {
    function n() {
        return t.apply(this, arguments) || this;
    }
    return r(n, t), n.prototype._process = function(t) {
        var e = Q.fromArray(t.data);
        return e.length = t.total, e;
    }, e(n, [
        {
            key: "type",
            get: function() {
                return Y.Transformer;
            }
        }
    ]), n;
}(et), Ht = /*#__PURE__*/ function(t) {
    function i() {
        return t.apply(this, arguments) || this;
    }
    return r(i, t), i.prototype._process = function() {
        return Object.entries(this.props.serverStorageOptions).filter(function(t) {
            return "function" != typeof t[1];
        }).reduce(function(t, e) {
            var r;
            return n({}, t, ((r = {})[e[0]] = e[1], r));
        }, {});
    }, e(i, [
        {
            key: "type",
            get: function() {
                return Y.Initiator;
            }
        }
    ]), i;
}(et), Mt = /*#__PURE__*/ function(t) {
    function n() {
        return t.apply(this, arguments) || this;
    }
    r(n, t);
    var i = n.prototype;
    return i.castData = function(t) {
        if (!t || !t.length) return [];
        if (!this.props.header || !this.props.header.columns) return t;
        var e = St.leafColumns(this.props.header.columns);
        return t[0] instanceof Array ? t.map(function(t) {
            var n = 0;
            return e.map(function(e, r) {
                return void 0 !== e.data ? (n++, "function" == typeof e.data ? e.data(t) : e.data) : t[r - n];
            });
        }) : "object" != typeof t[0] || t[0] instanceof Array ? [] : t.map(function(t) {
            return e.map(function(e, n) {
                return void 0 !== e.data ? "function" == typeof e.data ? e.data(t) : e.data : e.id ? t[e.id] : (pt.error("Could not find the correct cell for column at position " + n + ".\n                          Make sure either 'id' or 'selector' is defined for all columns."), null);
            });
        });
    }, i._process = function(t) {
        return {
            data: this.castData(t.data),
            total: t.total
        };
    }, e(n, [
        {
            key: "type",
            get: function() {
                return Y.Transformer;
            }
        }
    ]), n;
}(et), Ot = /*#__PURE__*/ function() {
    function t() {}
    return t.createFromConfig = function(t) {
        var e = new At;
        return t.storage instanceof Nt && e.register(new Ht({
            serverStorageOptions: t.server
        })), e.register(new It({
            storage: t.storage
        })), e.register(new Mt({
            header: t.header
        })), e.register(new Ut), e;
    }, t;
}(), jt = /*#__PURE__*/ function() {
    function t(e) {
        this._userConfig = void 0, Object.assign(this, n({}, t.defaultConfig(), e)), this._userConfig = {};
    }
    var e = t.prototype;
    return e.assign = function(t) {
        for(var e = 0, n = Object.keys(t); e < n.length; e++){
            var r = n[e];
            "_userConfig" !== r && (this[r] = t[r]);
        }
        return this;
    }, e.update = function(e) {
        return e ? (this._userConfig = n({}, this._userConfig, e), this.assign(t.fromUserConfig(this._userConfig)), this) : this;
    }, t.defaultConfig = function() {
        return {
            plugin: new ft,
            dispatcher: new Ct,
            tableRef: {
                current: null
            },
            tempRef: {
                current: null
            },
            width: "100%",
            height: "auto",
            autoWidth: !0,
            style: {},
            className: {}
        };
    }, t.fromUserConfig = function(e) {
        var r = new t(e);
        return r._userConfig = e, "boolean" == typeof e.sort && e.sort && r.assign({
            sort: {
                multiColumn: !0
            }
        }), r.assign({
            header: St.fromUserConfig(r)
        }), r.assign({
            storage: Et.createFromUserConfig(e)
        }), r.assign({
            pipeline: Ot.createFromConfig(r)
        }), r.assign({
            translator: new G(e.language)
        }), r.plugin.add({
            id: "search",
            position: ot.Header,
            component: _t,
            props: n({
                enabled: !0 === e.search || e.search instanceof Object
            }, e.search)
        }), r.plugin.add({
            id: "pagination",
            position: ot.Footer,
            component: vt,
            props: n({
                enabled: !0 === e.pagination || e.pagination instanceof Object
            }, e.pagination)
        }), e.plugins && e.plugins.forEach(function(t) {
            return r.plugin.add(t);
        }), r;
    }, t;
}();
!function(t) {
    t[t.Init = 0] = "Init", t[t.Loading = 1] = "Loading", t[t.Loaded = 2] = "Loaded", t[t.Rendered = 3] = "Rendered", t[t.Error = 4] = "Error";
}(Lt || (Lt = {}));
var Wt, Bt, zt, qt, Vt = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    r(e, t);
    var i = e.prototype;
    return i.content = function() {
        return this.props.column && "function" == typeof this.props.column.formatter ? this.props.column.formatter(this.props.cell.data, this.props.row, this.props.column) : this.props.column && this.props.column.plugin ? b(dt, {
            pluginId: this.props.column.id,
            props: {
                column: this.props.column,
                cell: this.props.cell,
                row: this.props.row
            }
        }) : this.props.cell.data;
    }, i.handleClick = function(t) {
        this.props.messageCell || this.config.eventEmitter.emit("cellClick", t, this.props.cell, this.props.column, this.props.row);
    }, i.getCustomAttributes = function(t) {
        return t ? "function" == typeof t.attributes ? t.attributes(this.props.cell.data, this.props.row, this.props.column) : t.attributes : {};
    }, i.render = function() {
        return b("td", n({
            role: this.props.role,
            colSpan: this.props.colSpan,
            "data-column-id": this.props.column && this.props.column.id,
            className: it(rt("td"), this.props.className, this.config.className.td),
            style: n({}, this.props.style, this.config.style.td),
            onClick: this.handleClick.bind(this)
        }, this.getCustomAttributes(this.props.column)), this.content());
    }, e;
}(X), Gt = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    r(e, t);
    var n = e.prototype;
    return n.getColumn = function(t) {
        if (this.props.header) {
            var e = St.leafColumns(this.props.header.columns);
            if (e) return e[t];
        }
        return null;
    }, n.handleClick = function(t) {
        this.props.messageRow || this.config.eventEmitter.emit("rowClick", t, this.props.row);
    }, n.getChildren = function() {
        var t = this;
        return this.props.children ? this.props.children : b(S, null, this.props.row.cells.map(function(e, n) {
            var r = t.getColumn(n);
            return r && r.hidden ? null : b(Vt, {
                key: e.id,
                cell: e,
                row: t.props.row,
                column: r
            });
        }));
    }, n.render = function() {
        return b("tr", {
            className: it(rt("tr"), this.config.className.tr),
            onClick: this.handleClick.bind(this)
        }, this.getChildren());
    }, e;
}(X), Xt = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    return r(e, t), e.prototype.render = function() {
        return b(Gt, {
            messageRow: !0
        }, b(Vt, {
            role: "alert",
            colSpan: this.props.colSpan,
            messageCell: !0,
            cell: new Z(this.props.message),
            className: it(rt("message"), this.props.className ? this.props.className : null)
        }));
    }, e;
}(X), $t = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    r(e, t);
    var n = e.prototype;
    return n.headerLength = function() {
        return this.props.header ? this.props.header.visibleColumns.length : 0;
    }, n.render = function() {
        var t = this;
        return b("tbody", {
            className: it(rt("tbody"), this.config.className.tbody)
        }, this.props.data && this.props.data.rows.map(function(e) {
            return b(Gt, {
                key: e.id,
                row: e,
                header: t.props.header
            });
        }), this.props.status === Lt.Loading && (!this.props.data || 0 === this.props.data.length) && b(Xt, {
            message: this._("loading"),
            colSpan: this.headerLength(),
            className: it(rt("loading"), this.config.className.loading)
        }), this.props.status === Lt.Rendered && this.props.data && 0 === this.props.data.length && b(Xt, {
            message: this._("noRecordsFound"),
            colSpan: this.headerLength(),
            className: it(rt("notfound"), this.config.className.notfound)
        }), this.props.status === Lt.Error && b(Xt, {
            message: this._("error"),
            colSpan: this.headerLength(),
            className: it(rt("error"), this.config.className.error)
        }));
    }, e;
}(X), Kt = /*#__PURE__*/ function(t) {
    function n() {
        return t.apply(this, arguments) || this;
    }
    r(n, t);
    var i = n.prototype;
    return i.validateProps = function() {
        for(var t, e = a(this.props.columns); !(t = e()).done;){
            var n = t.value;
            void 0 === n.direction && (n.direction = 1), 1 !== n.direction && -1 !== n.direction && pt.error("Invalid sort direction " + n.direction);
        }
    }, i.compare = function(t, e) {
        return t > e ? 1 : t < e ? -1 : 0;
    }, i.compareWrapper = function(t, e) {
        for(var n, r = 0, i = a(this.props.columns); !(n = i()).done;){
            var o = n.value;
            if (0 !== r) break;
            var s = t.cells[o.index].data, u = e.cells[o.index].data;
            r |= "function" == typeof o.compare ? o.compare(s, u) * o.direction : this.compare(s, u) * o.direction;
        }
        return r;
    }, i._process = function(t) {
        var e = [].concat(t.rows);
        e.sort(this.compareWrapper.bind(this));
        var n = new Q(e);
        return n.length = t.length, n;
    }, e(n, [
        {
            key: "type",
            get: function() {
                return Y.Sort;
            }
        }
    ]), n;
}(et), Yt = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    r(e, t);
    var n = e.prototype;
    return n.getInitialState = function() {
        return [];
    }, n.handle = function(t, e) {
        "SORT_COLUMN" === t ? this.sortColumn(e.index, e.direction, e.multi, e.compare) : "SORT_COLUMN_TOGGLE" === t && this.sortToggle(e.index, e.multi, e.compare);
    }, n.sortToggle = function(t, e, n) {
        var r = [].concat(this.state).find(function(e) {
            return e.index === t;
        });
        this.sortColumn(t, r && 1 === r.direction ? -1 : 1, e, n);
    }, n.sortColumn = function(t, e, n, r) {
        var i = [].concat(this.state), o = i.length, s = i.find(function(e) {
            return e.index === t;
        }), a = !1, u = !1, l = !1, c = !1;
        if (void 0 !== s ? n ? -1 === s.direction ? l = !0 : c = !0 : 1 === o ? c = !0 : o > 1 && (u = !0, a = !0) : 0 === o ? a = !0 : o > 0 && !n ? (a = !0, u = !0) : o > 0 && n && (a = !0), u && (i = []), a) i.push({
            index: t,
            direction: e,
            compare: r
        });
        else if (c) {
            var p = i.indexOf(s);
            i[p].direction = e;
        } else if (l) {
            var h = i.indexOf(s);
            i.splice(h, 1);
        }
        this.setState(i);
    }, e;
}(st), Zt = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    r(e, t);
    var n = e.prototype;
    return n.sortColumn = function(t, e, n, r) {
        this.dispatch("SORT_COLUMN", {
            index: t,
            direction: e,
            multi: n,
            compare: r
        });
    }, n.sortToggle = function(t, e, n) {
        this.dispatch("SORT_COLUMN_TOGGLE", {
            index: t,
            multi: e,
            compare: n
        });
    }, e;
}(ut), Jt = /*#__PURE__*/ function(t) {
    function i() {
        return t.apply(this, arguments) || this;
    }
    return r(i, t), i.prototype._process = function(t) {
        var e = {};
        return this.props.url && (e.url = this.props.url(t.url, this.props.columns)), this.props.body && (e.body = this.props.body(t.body, this.props.columns)), n({}, t, e);
    }, e(i, [
        {
            key: "type",
            get: function() {
                return Y.ServerSort;
            }
        }
    ]), i;
}(et), Qt = /*#__PURE__*/ function(t) {
    function e(e, n) {
        var r;
        return (r = t.call(this, e, n) || this).sortProcessor = void 0, r.actions = void 0, r.store = void 0, r.updateStateFn = void 0, r.updateSortProcessorFn = void 0, r.actions = new Zt(r.config.dispatcher), r.store = new Yt(r.config.dispatcher), e.enabled && (r.sortProcessor = r.getOrCreateSortProcessor(), r.updateStateFn = r.updateState.bind(o(r)), r.store.on("updated", r.updateStateFn), r.state = {
            direction: 0
        }), r;
    }
    r(e, t);
    var i = e.prototype;
    return i.componentWillUnmount = function() {
        this.config.pipeline.unregister(this.sortProcessor), this.store.off("updated", this.updateStateFn), this.updateSortProcessorFn && this.store.off("updated", this.updateSortProcessorFn);
    }, i.updateState = function() {
        var t = this, e = this.store.state.find(function(e) {
            return e.index === t.props.index;
        });
        this.setState(e ? {
            direction: e.direction
        } : {
            direction: 0
        });
    }, i.updateSortProcessor = function(t) {
        this.sortProcessor.setProps({
            columns: t
        });
    }, i.getOrCreateSortProcessor = function() {
        var t = Y.Sort;
        this.config.sort && "object" == typeof this.config.sort.server && (t = Y.ServerSort);
        var e, r = this.config.pipeline.getStepsByType(t);
        return r.length > 0 ? e = r[0] : (this.updateSortProcessorFn = this.updateSortProcessor.bind(this), this.store.on("updated", this.updateSortProcessorFn), e = t === Y.ServerSort ? new Jt(n({
            columns: this.store.state
        }, this.config.sort.server)) : new Kt({
            columns: this.store.state
        }), this.config.pipeline.register(e)), e;
    }, i.changeDirection = function(t) {
        t.preventDefault(), t.stopPropagation(), this.actions.sortToggle(this.props.index, !0 === t.shiftKey && this.config.sort.multiColumn, this.props.compare);
    }, i.render = function() {
        if (!this.props.enabled) return null;
        var t = this.state.direction, e = "neutral";
        return 1 === t ? e = "asc" : -1 === t && (e = "desc"), b("button", {
            tabIndex: -1,
            "aria-label": this._("sort.sort" + (1 === t ? "Desc" : "Asc")),
            title: this._("sort.sort" + (1 === t ? "Desc" : "Asc")),
            className: it(rt("sort"), rt("sort", e), this.config.className.sort),
            onClick: this.changeDirection.bind(this)
        });
    }, e;
}(X), te = /*#__PURE__*/ function(t) {
    function e() {
        for(var e, n = arguments.length, r = new Array(n), i = 0; i < n; i++)r[i] = arguments[i];
        return (e = t.call.apply(t, [
            this
        ].concat(r)) || this).moveFn = void 0, e.upFn = void 0, e;
    }
    r(e, t);
    var n = e.prototype;
    return n.getPageX = function(t) {
        return t instanceof MouseEvent ? Math.floor(t.pageX) : Math.floor(t.changedTouches[0].pageX);
    }, n.start = function(t) {
        var e, n, r, i, o;
        t.stopPropagation(), this.setState({
            offsetStart: parseInt(this.props.thRef.current.style.width, 10) - this.getPageX(t)
        }), this.upFn = this.end.bind(this), this.moveFn = (e = this.move.bind(this), n = 10, function() {
            var t = [].slice.call(arguments);
            r ? (clearTimeout(i), i = setTimeout(function() {
                Date.now() - o >= n && (e.apply(void 0, t), o = Date.now());
            }, Math.max(n - (Date.now() - o), 0))) : (e.apply(void 0, t), o = Date.now(), r = !0);
        }), document.addEventListener("mouseup", this.upFn), document.addEventListener("touchend", this.upFn), document.addEventListener("mousemove", this.moveFn), document.addEventListener("touchmove", this.moveFn);
    }, n.move = function(t) {
        t.stopPropagation();
        var e = this.props.thRef.current;
        this.state.offsetStart + this.getPageX(t) >= parseInt(e.style.minWidth, 10) && (e.style.width = this.state.offsetStart + this.getPageX(t) + "px");
    }, n.end = function(t) {
        t.stopPropagation(), document.removeEventListener("mouseup", this.upFn), document.removeEventListener("mousemove", this.moveFn), document.removeEventListener("touchmove", this.moveFn), document.removeEventListener("touchend", this.upFn);
    }, n.render = function() {
        return b("div", {
            className: it(rt("th"), rt("resizable")),
            onMouseDown: this.start.bind(this),
            onTouchStart: this.start.bind(this),
            onClick: function(t) {
                return t.stopPropagation();
            }
        });
    }, e;
}(X), ee = /*#__PURE__*/ function(t) {
    function e(e, n) {
        var r;
        return (r = t.call(this, e, n) || this).sortRef = {
            current: null
        }, r.thRef = {
            current: null
        }, r.state = {
            style: {}
        }, r;
    }
    r(e, t);
    var i = e.prototype;
    return i.isSortable = function() {
        return this.props.column.sort.enabled;
    }, i.isResizable = function() {
        return this.props.column.resizable;
    }, i.onClick = function(t) {
        t.stopPropagation(), this.isSortable() && this.sortRef.current.changeDirection(t);
    }, i.keyDown = function(t) {
        this.isSortable() && 13 === t.which && this.onClick(t);
    }, i.componentDidMount = function() {
        var t = this;
        setTimeout(function() {
            if (t.props.column.fixedHeader && t.thRef.current) {
                var e = t.thRef.current.offsetTop;
                "number" == typeof e && t.setState({
                    style: {
                        top: e
                    }
                });
            }
        }, 0);
    }, i.content = function() {
        return void 0 !== this.props.column.name ? this.props.column.name : void 0 !== this.props.column.plugin ? b(dt, {
            pluginId: this.props.column.plugin.id,
            props: {
                column: this.props.column
            }
        }) : null;
    }, i.getCustomAttributes = function() {
        var t = this.props.column;
        return t ? "function" == typeof t.attributes ? t.attributes(null, null, this.props.column) : t.attributes : {};
    }, i.render = function() {
        var t = {};
        return this.isSortable() && (t.tabIndex = 0), b("th", n({
            ref: this.thRef,
            "data-column-id": this.props.column && this.props.column.id,
            className: it(rt("th"), this.isSortable() ? rt("th", "sort") : null, this.props.column.fixedHeader ? rt("th", "fixed") : null, this.config.className.th),
            onClick: this.onClick.bind(this),
            style: n({}, this.config.style.th, {
                minWidth: this.props.column.minWidth,
                width: this.props.column.width
            }, this.state.style, this.props.style),
            onKeyDown: this.keyDown.bind(this),
            rowSpan: this.props.rowSpan > 1 ? this.props.rowSpan : void 0,
            colSpan: this.props.colSpan > 1 ? this.props.colSpan : void 0
        }, this.getCustomAttributes(), t), b("div", {
            className: rt("th", "content")
        }, this.content()), this.isSortable() && b(Qt, n({
            ref: this.sortRef,
            index: this.props.index
        }, this.props.column.sort)), this.isResizable() && this.props.index < this.config.header.visibleColumns.length - 1 && b(te, {
            column: this.props.column,
            thRef: this.thRef
        }));
    }, e;
}(X), ne = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    r(e, t);
    var n = e.prototype;
    return n.renderColumn = function(t, e, n, r) {
        var i = function(t, e, n) {
            var r = St.maximumDepth(t), i = n - e;
            return {
                rowSpan: Math.floor(i - r - r / i),
                colSpan: t.columns && t.columns.length || 1
            };
        }(t, e, r);
        return b(ee, {
            column: t,
            index: n,
            colSpan: i.colSpan,
            rowSpan: i.rowSpan
        });
    }, n.renderRow = function(t, e, n) {
        var r = this, i = St.leafColumns(this.props.header.columns);
        return b(Gt, null, t.map(function(t) {
            return t.hidden ? null : r.renderColumn(t, e, i.indexOf(t), n);
        }));
    }, n.renderRows = function() {
        var t = this, e = St.tabularFormat(this.props.header.columns);
        return e.map(function(n, r) {
            return t.renderRow(n, r, e.length);
        });
    }, n.render = function() {
        return this.props.header ? b("thead", {
            key: this.props.header.id,
            className: it(rt("thead"), this.config.className.thead)
        }, this.renderRows()) : null;
    }, e;
}(X), re = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    return r(e, t), e.prototype.render = function() {
        return b("table", {
            role: "grid",
            className: it(rt("table"), this.config.className.table),
            style: n({}, this.config.style.table, {
                height: this.props.height
            })
        }, b(ne, {
            header: this.props.header
        }), b($t, {
            data: this.props.data,
            status: this.props.status,
            header: this.props.header
        }));
    }, e;
}(X), ie = /*#__PURE__*/ function(t) {
    function e(e, n) {
        var r;
        return (r = t.call(this, e, n) || this).headerRef = {
            current: null
        }, r.state = {
            isActive: !0
        }, r;
    }
    r(e, t);
    var i = e.prototype;
    return i.componentDidMount = function() {
        0 === this.headerRef.current.children.length && this.setState({
            isActive: !1
        });
    }, i.render = function() {
        return this.state.isActive ? b("div", {
            ref: this.headerRef,
            className: it(rt("head"), this.config.className.header),
            style: n({}, this.config.style.header)
        }, b(dt, {
            position: ot.Header
        })) : null;
    }, e;
}(X), oe = /*#__PURE__*/ function(t) {
    function e(e, n) {
        var r;
        return (r = t.call(this, e, n) || this).footerRef = {
            current: null
        }, r.state = {
            isActive: !0
        }, r;
    }
    r(e, t);
    var i = e.prototype;
    return i.componentDidMount = function() {
        0 === this.footerRef.current.children.length && this.setState({
            isActive: !1
        });
    }, i.render = function() {
        return this.state.isActive ? b("div", {
            ref: this.footerRef,
            className: it(rt("footer"), this.config.className.footer),
            style: n({}, this.config.style.footer)
        }, b(dt, {
            position: ot.Footer
        })) : null;
    }, e;
}(X), se = /*#__PURE__*/ function(t) {
    function e(e, n) {
        var r;
        return (r = t.call(this, e, n) || this).configContext = void 0, r.processPipelineFn = void 0, r.configContext = function(t, e) {
            var n = {
                __c: e = "__cC" + d++,
                __: null,
                Consumer: function(t, e) {
                    return t.children(e);
                },
                Provider: function(t) {
                    var n, r;
                    return this.getChildContext || (n = [], (r = {})[e] = this, this.getChildContext = function() {
                        return r;
                    }, this.shouldComponentUpdate = function(t) {
                        this.props.value !== t.value && n.some(N);
                    }, this.sub = function(t) {
                        n.push(t);
                        var e = t.componentWillUnmount;
                        t.componentWillUnmount = function() {
                            n.splice(n.indexOf(t), 1), e && e.call(t);
                        };
                    }), t.children;
                }
            };
            return n.Provider.__ = n.Consumer.contextType = n;
        }(), r.state = {
            status: Lt.Loading,
            header: e.header,
            data: null
        }, r;
    }
    r(e, t);
    var i = e.prototype;
    return i.processPipeline = function() {
        try {
            var t = this;
            t.props.config.eventEmitter.emit("beforeLoad"), t.setState({
                status: Lt.Loading
            });
            var e = function(e, n) {
                try {
                    var r = Promise.resolve(t.props.pipeline.process()).then(function(e) {
                        t.setState({
                            data: e,
                            status: Lt.Loaded
                        }), t.props.config.eventEmitter.emit("load", e);
                    });
                } catch (t) {
                    return n(t);
                }
                return r && r.then ? r.then(void 0, n) : r;
            }(0, function(e) {
                pt.error(e), t.setState({
                    status: Lt.Error,
                    data: null
                });
            });
            return Promise.resolve(e && e.then ? e.then(function() {}) : void 0);
        } catch (t) {
            return Promise.reject(t);
        }
    }, i.componentDidMount = function() {
        try {
            var t = this, e = t.props.config;
            return Promise.resolve(t.processPipeline()).then(function() {
                e.header && t.state.data && t.state.data.length && t.setState({
                    header: e.header.adjustWidth(e)
                }), t.processPipelineFn = t.processPipeline.bind(t), t.props.pipeline.on("updated", t.processPipelineFn);
            });
        } catch (t) {
            return Promise.reject(t);
        }
    }, i.componentWillUnmount = function() {
        this.props.pipeline.off("updated", this.processPipelineFn);
    }, i.componentDidUpdate = function(t, e) {
        e.status != Lt.Rendered && this.state.status == Lt.Loaded && (this.setState({
            status: Lt.Rendered
        }), this.props.config.eventEmitter.emit("ready"));
    }, i.render = function() {
        return b(this.configContext.Provider, {
            value: this.props.config
        }, b("div", {
            role: "complementary",
            className: it("gridjs", rt("container"), this.state.status === Lt.Loading ? rt("loading") : null, this.props.config.className.container),
            style: n({}, this.props.config.style.container, {
                width: this.props.width
            })
        }, this.state.status === Lt.Loading && b("div", {
            className: rt("loading-bar")
        }), b(ie, null), b("div", {
            className: rt("wrapper"),
            style: {
                height: this.props.height
            }
        }, b(re, {
            ref: this.props.config.tableRef,
            data: this.state.data,
            header: this.state.header,
            width: this.props.width,
            height: this.props.height,
            status: this.state.status
        })), b(oe, null), b("div", {
            ref: this.props.config.tempRef,
            id: "gridjs-temp",
            className: rt("temp")
        })));
    }, e;
}(X), ae = /*#__PURE__*/ function(t) {
    function e(e) {
        var n;
        return (n = t.call(this) || this).config = void 0, n.plugin = void 0, n.config = new jt({
            instance: o(n),
            eventEmitter: o(n)
        }).update(e), n.plugin = n.config.plugin, n;
    }
    r(e, t);
    var n = e.prototype;
    return n.updateConfig = function(t) {
        return this.config.update(t), this;
    }, n.createElement = function() {
        return b(se, {
            config: this.config,
            pipeline: this.config.pipeline,
            header: this.config.header,
            width: this.config.width,
            height: this.config.height
        });
    }, n.forceRender = function() {
        return this.config && this.config.container || pt.error("Container is empty. Make sure you call render() before forceRender()", !0), this.config.pipeline.clearCache(), B(null, this.config.container), B(this.createElement(), this.config.container), this;
    }, n.render = function(t) {
        return t || pt.error("Container element cannot be null", !0), t.childNodes.length > 0 ? (pt.error("The container element " + t + " is not empty. Make sure the container is empty and call render() again"), this) : (this.config.container = t, B(this.createElement(), t), this);
    }, e;
}(tt), ue = 0, le = [], ce = [], pe = l.__b, he = l.__r, fe = l.diffed, de = l.__c, _e = l.unmount;
function me(t, e) {
    l.__h && l.__h(Bt, t, ue || e), ue = 0;
    var n = Bt.__H || (Bt.__H = {
        __: [],
        __h: []
    });
    return t >= n.__.length && n.__.push({
        __V: ce
    }), n.__[t];
}
function ge(t, e) {
    var n = me(Wt++, 3);
    !l.__s && Se(n.__H, e) && (n.__ = t, n.i = e, Bt.__H.__h.push(n));
}
function ve(t) {
    return ue = 5, function(t, e) {
        var n = me(Wt++, 7);
        return Se(n.__H, e) ? (n.__V = t(), n.i = e, n.__h = t, n.__V) : n.__;
    }(function() {
        return {
            current: t
        };
    }, []);
}
function ye() {
    for(var t; t = le.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach(we), t.__H.__h.forEach(ke), t.__H.__h = [];
    } catch (e) {
        t.__H.__h = [], l.__e(e, t.__v);
    }
}
l.__b = function(t) {
    Bt = null, pe && pe(t);
}, l.__r = function(t) {
    he && he(t), Wt = 0;
    var e = (Bt = t.__c).__H;
    e && (zt === Bt ? (e.__h = [], Bt.__h = [], e.__.forEach(function(t) {
        t.__N && (t.__ = t.__N), t.__V = ce, t.__N = t.i = void 0;
    })) : (e.__h.forEach(we), e.__h.forEach(ke), e.__h = [])), zt = Bt;
}, l.diffed = function(t) {
    fe && fe(t);
    var e = t.__c;
    e && e.__H && (e.__H.__h.length && (1 !== le.push(e) && qt === l.requestAnimationFrame || ((qt = l.requestAnimationFrame) || function(t) {
        var e, n = function() {
            clearTimeout(r), be && cancelAnimationFrame(e), setTimeout(t);
        }, r = setTimeout(n, 100);
        be && (e = requestAnimationFrame(n));
    })(ye)), e.__H.__.forEach(function(t) {
        t.i && (t.__H = t.i), t.__V !== ce && (t.__ = t.__V), t.i = void 0, t.__V = ce;
    })), zt = Bt = null;
}, l.__c = function(t, e) {
    e.some(function(t) {
        try {
            t.__h.forEach(we), t.__h = t.__h.filter(function(t) {
                return !t.__ || ke(t);
            });
        } catch (n) {
            e.some(function(t) {
                t.__h && (t.__h = []);
            }), e = [], l.__e(n, t.__v);
        }
    }), de && de(t, e);
}, l.unmount = function(t) {
    _e && _e(t);
    var e, n = t.__c;
    n && n.__H && (n.__H.__.forEach(function(t) {
        try {
            we(t);
        } catch (t) {
            e = t;
        }
    }), e && l.__e(e, n.__v));
};
var be = "function" == typeof requestAnimationFrame;
function we(t) {
    var e = Bt, n = t.__c;
    "function" == typeof n && (t.__c = void 0, n()), Bt = e;
}
function ke(t) {
    var e = Bt;
    t.__c = t.__(), Bt = e;
}
function Se(t, e) {
    return !t || t.length !== e.length || e.some(function(e, n) {
        return e !== t[n];
    });
}

});




parcelRegister("5XTTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457dd2d023f41b6b$export$2e2bcd8739ae039; });
var $457dd2d023f41b6b$export$2e2bcd8739ae039 = {
    props: {
        editando: {
            type: Boolean,
            default: false
        },
        isFundacaoActivate: {
            type: Boolean,
            default: false
        },
        fundacoes: {
            type: Array,
            default: ()=>[]
        },
        estrategias: {
            type: Array,
            default: ()=>[]
        },
        fundos: {
            type: Array,
            default: ()=>[]
        },
        semestres: {
            type: Array,
            default: ()=>[]
        }
    },
    emits: [
        'enviar',
        'cancelar'
    ],
    data () {
        const uid = crypto.randomUUID();
        return {
            data: {
                fundacao: '',
                estrategia: '',
                fundo: '',
                valor: '',
                comentario: '',
                semestre: ''
            },
            selectIds: {
                estrategia: `estrategia-${uid}`,
                fundacao: `fundacao-${uid}`,
                semestre: `semestre-${uid}`,
                fundo: `fundo-${uid}`
            }
        };
    },
    watch: {
        editando () {},
        fundacoes () {
            if (this.isFundacaoActivate) {
                const fundacoesChoices = GLOBAL.getChoicesActive(this.selectIds.fundacao, window.listOfChoices);
                fundacoesChoices?.setChoices([
                    ...this.fundacoes
                ], 'value', 'label', true);
            }
        },
        estrategias () {
            /* console.log('estrategias: ' + JSON.stringify(this.estrategias)) */ const estrategiasChoices = GLOBAL.getChoicesActive(this.selectIds.estrategia, window.listOfChoices);
            estrategiasChoices?.setChoices([
                ...this.estrategias
            ], 'value', 'label', true);
        },
        fundos () {
            const fundosChoices = GLOBAL.getChoicesActive(this.selectIds.fundo, window.listOfChoices);
            fundosChoices?.setChoices([
                ...this.fundos
            ], 'value', 'label', true);
        },
        semestres () {
            const semestresChoices = GLOBAL.getChoicesActive(this.selectIds.semestre, window.listOfChoices);
            semestresChoices?.setChoices([
                ...this.semestres
            ], 'value', 'label', true);
        }
    },
    mounted () {
        this.$nextTick(()=>{
            const select = document.querySelector('[js-choices]');
            if (select) new Choices(select) // Inicializa Choices.js
            ;
        });
    },
    methods: {
        handleChange ({ target: target }) {
            const value = target.value;
            this.data[target.getAttribute('name')] = value.trim();
        },
        prevent (e) {
            e.preventDefault();
        },
        enviar () {
            this.$emit('enviar', this.data);
            GLOBAL.initTipy();
            this.data = {
                fundacao: '',
                estrategia: '',
                fundo: '',
                valor: '',
                comentario: '',
                semestre: ''
            };
            this.limparFormularios();
        },
        cancelar () {
            this.$emit('cancelar');
            this.data = {
                fundacao: '',
                estrategia: '',
                fundo: '',
                valor: '',
                comentario: ''
            };
        },
        onBeforeEnter (el) {
            gsap.set(el, {
                height: 0
            });
        },
        onEnter (el, done) {
            gsap.timeline({
                ease: 'power1',
                delay: 0
            }).to(el, {
                height: 'auto',
                duration: 0.2
            });
            this.$refs.new_processo.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            done();
        },
        limparFormularios () {
            const fundacoesChoices = GLOBAL.getChoicesActive('fundacao', listOfChoices);
            const estrategiasChoices = GLOBAL.getChoicesActive('estrategia', listOfChoices);
            const fundosChoices = GLOBAL.getChoicesActive('fundo', listOfChoices);
            fundacoesChoices.removeActiveItems();
            estrategiasChoices.removeActiveItems();
            fundosChoices.removeActiveItems();
        }
    },
    template: html`
		<Transition @before-enter="onBeforeEnter" @enter="onEnter">
			<div
				class="p-16 border !h-[33rem] border-primary-pure rounded-md new-task-el overflow-hidden "
				ref="new_processo">
				<p class="text-primary-pure  font-medium mb-8">Novo Processo</p>
				<form class="flex flex-col items-center gap-8 " @submit="prevent">
					<div v-show="false" class="flex-1 flex flex-col  w-full">
						<label class="label">Estratégia</label>
						<div class="select-container h-40">
							<select
								v-model="data.estrategia"
								name="estrategia"
								:id="selectIds.estrategia"
								js-choices>
								<option value="" selected>Escolha uma estratégia</option>
							</select>
						</div>
					</div>
					<div v-if="isFundacaoActivate" class="flex-1 flex flex-col  w-full">
						<label class="label">Fundações</label>
						<div class="select-container h-40">
							<select
								v-model="data.fundacao"
								name="fundacao"
								:id="selectIds.fundacao"
								js-choices
								js-choices-props='{ "searchEnabled": true, "searchChoices": true,  "removeItems": true, "removeItemButton": true}'>
								<option value="" selected>Escolha uma fundação</option>
							</select>
						</div>
					</div>
					<div class="flex-1 flex flex-col  w-full">
						<label class="label">Semestre</label>
						<div class="select-container h-40">
							<select
								v-model="data.semestre"
								name="semestre"
								:id="selectIds.semestre"
								js-choices>
								<option value="" selected>Escolha um semestre</option>
							</select>
						</div>
					</div>
					<div class="flex-1 flex flex-col  w-full">
						<label class="label">Fundo</label>
						<div class="select-container h-40">
							<select
								v-model="data.fundo"
								name="fundo"
								:id="selectIds.fundo"
								js-choices>
								<option value="" selected>Escolha um fundo</option>
							</select>
						</div>
					</div>
					<div class="flex-1 flex flex-col  w-full">
						<label class="label">Valor</label>
						<input
							v-model="data.valor"
							type="text"
							name="valor"
							id="valor_processo"
							data-mask="000.000.000.000.000,00"
							data-mask-reverse="true"
							placeholder="R$"
							class="w-full p-10 input-text" />
					</div>
					<div class="flex-1 flex flex-col gap-4 w-full">
						<label class="label">Comentário</label>
						<textarea
							v-model="data.comentario"
							name="comentario"
							class="w-full p-10 input-text h-[5rem]"></textarea>
					</div>

					<div class=" flex justify-between mt-8 w-full">
						<button type="button" class="btn secondary" @click="cancelar">
							Cancelar
						</button>
						<button type="button" class="btn" @click="enviar">Enviar</button>
					</div>
				</form>
			</div>
		</Transition>
	`
};

});

parcelRegister("kKHf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1b9a59af3d878cd$export$2e2bcd8739ae039; });

var $4Fazw = parcelRequire("4Fazw");

var $1UZGW = parcelRequire("1UZGW");

var $i5cs0 = parcelRequire("i5cs0");
const { isFundacao: $f1b9a59af3d878cd$var$isFundacao, initTipy: $f1b9a59af3d878cd$var$initTipy } = GLOBAL;
var $f1b9a59af3d878cd$export$2e2bcd8739ae039 = {
    emits: [
        'enviar',
        'open',
        'atualiza:processos'
    ],
    props: [
        'data',
        'estrategias',
        'fundos',
        'semestres'
    ],
    mixins: [
        (0, $i5cs0.default)
    ],
    data () {
        return {
            editado: false,
            editando: false,
            taskdados: {},
            text: 'Deseja marcar o processo como vencido',
            modalConfirm: false
        };
    },
    components: {
        AvatarPersona: $4Fazw.default,
        ConfirmModal: $1UZGW.default
    },
    computed: {
        valorMoney () {
            return GLOBAL.formatReal2(this.data.valor);
        }
    },
    watch: {
        editando () {
            if (this.editando) {
                const estrategiasChoices = GLOBAL.getChoicesActive(`estrategia-${this.data.id}`, listOfChoices);
                estrategiasChoices?.setChoiceByValue(this.data.estrategia);
                const fundoChoices = GLOBAL.getChoicesActive(`fundo-${this.data.id}`, listOfChoices);
                fundoChoices?.setChoiceByValue(this.data.fundo);
                const semestreChoice = GLOBAL.getChoicesActive(`semestre-${this.data.id}`, listOfChoices);
                semestreChoice?.setChoiceByValue(this.data.semestre);
            }
        },
        taskdados: {
            handler () {
                _BIG('taskdados');
            },
            deep: true
        }
    },
    mounted () {
        if (this.$refs.deadline) GLOBAL.initFlatpickr(this.$refs.deadline);
        const selects = [
            ...document.querySelectorAll(`.item-processo #estrategia-${this.data.id}, .item-processo #fundo-${this.data.id}, .item-processo #semestre-${this.data.id}`)
        ];
        const choices = selects.map((i)=>GLOBAL.initChoices(i, {
                searchEnabled: false,
                searchChoices: false,
                itemSelectText: 'Selecionar',
                noResultsText: 'Nada Encontrado...'
            }));
        setTimeout(()=>{
            listOfChoices = [
                ...listOfChoices,
                ...choices
            ];
            const estrategiasChoices = GLOBAL.getChoicesActive(`estrategia-${this.data.id}`, listOfChoices);
            if (this.estrategias?.length && estrategiasChoices) estrategiasChoices.setChoices([
                ...this.estrategias
            ], 'value', 'label', true);
            const fundoChoices = GLOBAL.getChoicesActive(`fundo-${this.data.id}`, listOfChoices);
            if (!fundoChoices) return;
            fundoChoices?.setChoices([
                ...this.fundos
            ], 'value', 'label', true);
            const semestreChoice = GLOBAL.getChoicesActive(`semestre-${this.data.id}`, listOfChoices);
            if (!semestreChoice) return;
            semestreChoice?.setChoices([
                ...this.semestres
            ], 'value', 'label', true);
        }, 300);
    /* console.log(this.data) */ },
    methods: {
        getStatus (statusValue) {
            return GLOBAL.taskStatus?.filter((i)=>statusValue == i.value)?.reduce((acc, i)=>acc = i.label, '');
        },
        classStatus (status) {
            return `status-${status}`;
        },
        async sendEdicao (e) {
            NProgress.start();
            try {
                const request = await axios.patch(`${window.location.origin}/clientes/processos_fundacoes/?id=${this.data.id}`, {
                    ...this.taskdados
                });
                this.cancelarEdicao();
                this.$emit('enviar', "\u2705 Tarefa alterada com sucesso");
            } catch (e) {
                console.log(e);
                GLOBAL.showToastify('Ocorreu um erro');
            } finally{
                NProgress.done();
            }
        },
        cancelarEdicao () {
            if (this.editado) this.$emit('atualiza:processos');
            this.taskdados = {};
            this.editado = false;
            this.editando = false;
            this.$refs.comentario.innerText = this.data.comentario;
        },
        handleChange ({ target: target }) {
            const value = target.tagName === 'INPUT' || target.tagName === 'SELECT' ? target.value : target.innerText;
            this.taskdados[target.getAttribute('name')] = value.trim();
            this.editado = true;
        },
        dataFormated (data) {
            return moment(data, 'YYYY/MM/DD').format('DD/MM/YYYY');
        },
        openModalConfirm (status) {
            this.status = status;
            this.text = `Deseja alterar status do processo para ${this.status}`;
            this.modalConfirm = true;
        },
        async updateStatus () {
            NProgress.start();
            try {
                this.cancelarConclusao();
                const request = await axios.patch(`${window.location.origin}/clientes/processos_fundacoes/?id=${this.data.id}`, {
                    status: this.status
                });
                this.$emit('enviar', " \u2705 Tarefa concluida com sucesso");
                this.modalConfirm = false;
            } catch (e) {
                GLOBAL.errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        cancelarConclusao () {
            this.modalConfirm = false;
        }
    },
    template: html`
		<confirm-modal
			v-if="modalConfirm"
			@enviar="updateStatus"
			@cancelar="cancelarConclusao"
			:text="text"
			:modal-data="{id: 'check',header: '',}"></confirm-modal>

		<div
			v-show="isFundacao ? data.fundacao : data.cliente_pf"
			class="table-row  relative group item-processo min-h-[5.5rem]  pb-24 transition-[height]"
			:class="{'editando' : editando, '!min-h-[13rem]': editando }"
			:data-id="data.id">
			<div
				@click="$emit('open')"
				class=" w-40 h-40 cursor-pointer"
				style="grid-area:'icon'">
				<avatar-persona
					class="w-40 h-40"
					:type="data.politica"></avatar-persona>
			</div>

			<p
				@click="$emit('open')"
				class="row-item cursor-pointer"
				:class="{'only-2-lines' : !editando }"
				style="grid-area:'fundacao'">
				{{data.nome_fundacao}}
			</p>
			
<div v-show="editando" class="select-container h-40">
							<select
							@change="handleChange"
								v-model="data.fundo"
								name="fundo"
								:id="'fundo-' + data.id"
								js-choices>
								<option value="" selected>Escolha um fundo</option>
							</select>
						</div>
			<p v-show="!editando"
				@click="$emit('open')"
				class="row-item cursor-pointer "
				:class="{'only-2-lines' : !editando }"
				style="grid-area:'fundo'">
				{{data.sigla_fundo}}
			</p>

			

			<div v-show="editando" class="select-container h-40">
							<select
							@change="handleChange"
								v-model="data.estrategia"
								name="estrategia"
								:id="'estrategia-' + data.id"
								js-choices>
								<option value="" selected>Escolha uma estratégia</option>
							</select>
						</div>

			<p v-if="false"
				class="row-item border border-transparent !p-4 rounded-md transition-[height]"
				ref="estrategia"
				style="grid-area:'estrategia'; white-space: break-spaces;"
				@input="handleChange"
				:contenteditable="editando"
				name="estrategia"
			>
				{{data.nome_estrategia}}
			</p>

			<div v-show="editando" class="select-container h-40">
							<select
							@change="handleChange"
								v-model="data.semestre"
								name="semestre"
								:id="'semestre-' + data.id"
								js-choices>
								<option value="" selected>Escolha um semestre</option>
							</select>
						</div>
			<p v-show="!editando"
				@click="$emit('open')"
				class="row-item cursor-pointer "
				:class="{'only-2-lines' : !editando }"
				style="grid-area:'semestre';">
				{{data.semestre_nome}}
			</p>

			<p 
				class="row-item border border-transparent !p-4 rounded-md transition-[height] "
				ref="valor"
				style="grid-area:'valor'; white-space: break-spaces;"
				@input="handleChange"
				:contenteditable="editando"
			
				name="valor"
				>
				{{editando ? data.valor : valorMoney}}
			</p>

			<p v-if=!editando
				class="row-item border border-transparent !p-4 rounded-md transition-[height]"
				ref="comentario"
				style="grid-area:'comentario'; white-space: break-spaces;"
				
				name="comentario"
				>
					<div class="tippy-el" 	:data-tippy-content="data.comentario ? data.comentario : 'Sem comentário' "
							:data-tippy-delay="150"  >
								<q-icon class="text-neutral-60" name="playlist_add_check_circle" size="1.5rem"></q-icon>
							
							</div>
			</p>
			<p v-if="editando"
				class="row-item border border-transparent !p-4 rounded-md transition-[height]"
				ref="comentario"
				style="grid-area:desc !important; white-space: break-spaces;"
				@input="handleChange"
				:contenteditable="editando"
				name="comentario"
				:style="{minHeight: editando ? '70px' : null}">
				{{data.comentario}}
			</p>

			<div
				v-show="!editando"
				style="grid-area:'check'"
				class="flex flex-nowrap gap-4 items-center">
				<div @click="() => openModalConfirm('Vencidos')">
					<svg
						:class="[data.status === 'Vencidos' ? '!text-green-50': 'text-neutral-60']"
						class="w-24 h-24  hover:text-green-50 transition-colors cursor-pointer">
						<use xlink:href="#icon_check_processo"></use>
					</svg>
				</div>
				<div @click="() => openModalConfirm('Sem êxito')">
					<svg
						:class="[data.status === 'Sem êxito' ? '!text-alert-red-100': 'text-neutral-60']"
						class="w-24 h-24 text-neutral-60 hover:text-alert-red-100 transition-colors cursor-pointer">
						<use xlink:href="#icon_cancel_processo"></use>
					</svg>
				</div>
			</div>

			<button
				type="button"
				v-show="!editando"
				@click="editando = true"
				class="editar absolute  w-32 h-32 opacity-0 group-hover:opacity-100 btn secondary !p-4 right-12 bottom-8">
				<svg class="w-full h-full">
					<use xlink:href="#icon_edit"></use>
				</svg>
			</button>

			<div class="flex justify-between col-span-6 " v-show="editando">
				<button type="button" class="btn secondary" @click="cancelarEdicao">
					Cancelar
				</button>
				<button
					type="button"
					class="btn"
					:class="{'disabled' : !editado }"
					@click="sendEdicao">
					Salvar alteracoes
				</button>
			</div>
		</div>
	`
};

});

parcelRegister("cpXN9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90a63341af4d250a$export$2e2bcd8739ae039; });

var $2m7Ys = parcelRequire("2m7Ys");

var $415wX = parcelRequire("415wX");
const { getAtendimentosFundacao: $90a63341af4d250a$var$getAtendimentosFundacao, updateAtendimentoSequoia: $90a63341af4d250a$var$updateAtendimentoSequoia, createAtendimentoSequoia: $90a63341af4d250a$var$createAtendimentoRapidoService } = (0, $415wX.default)();
var $90a63341af4d250a$export$2e2bcd8739ae039 = {
    data () {
        return {
            isLoadingAtendimentoRapido: false,
            fundacaoIdSelecionado: null
        };
    },
    methods: {
        addClienteAtendimentoRapido (clienteId) {
            this.fundacaoIdSelecionado = clienteId;
        },
        removeClienteAtendimentoRapido (clienteId) {
            this.fundacaoIdSelecionado = null;
        },
        clearClienteAtendimentoRapido () {
            this.fundacaoIdSelecionado = null;
        },
        async createAtendimentoRapido (tipoAtendimentoRapido, menssagemAtendimentoRapido, tituloAtendimento = null, dataAtendimento = null) {
            try {
                this.isLoadingAtendimentoRapido = true;
                /* 				const { atendimentos } = await getAtendimentosFundacao(
					this.listaClientesAtendimentoRapido
				) */ const formDataAtendimentoRapido = {
                    fundacao: Number(this.fundacaoIdSelecionado),
                    titulo_atendimento: tituloAtendimento,
                    tipo: '0',
                    data_atendimento: dataAtendimento ?? new Date().toISOString(),
                    descricao_atendimento: menssagemAtendimentoRapido,
                    concluido: true,
                    modalidade_fundacao: '0'
                };
                const responseAtividadeRapida = await $90a63341af4d250a$var$createAtendimentoRapidoService(formDataAtendimentoRapido);
                this.clearClienteAtendimentoRapido();
                return responseAtividadeRapida;
            } catch (e) {
                console.log(e);
            } finally{
                this.isLoadingAtendimentoRapido = false;
            }
        },
        async updateAtendimentoRapido (menssagemAtendimentoRapido, tituloAtendimento = null, dataAtendimento = null, idAtendimento = null) {
            try {
                this.isLoadingAtendimentoRapido = true;
                /* 				const { atendimentos } = await getAtendimentosFundacao(
					this.listaClientesAtendimentoRapido
				) */ const formDataAtendimentoRapido = {
                    titulo_atendimento: tituloAtendimento,
                    data_atendimento: dataAtendimento ?? new Date().toISOString(),
                    descricao_atendimento: menssagemAtendimentoRapido
                };
                const responseAtividadeRapida = await $90a63341af4d250a$var$updateAtendimentoSequoia(formDataAtendimentoRapido, idAtendimento);
                this.clearClienteAtendimentoRapido();
                return responseAtividadeRapida;
            } catch (e) {
                console.log(e);
            } finally{
                this.isLoadingAtendimentoRapido = false;
            }
        },
        async getAtendimentosSequoiaById () {
            try {
                this.isLoadingAtendimentoRapido = true;
                const responseAtendimentosSequoia = await $90a63341af4d250a$var$getAtendimentosFundacao(this.fundacaoIdSelecionado);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).isEmpty(responseAtendimentosSequoia)) return [];
                return responseAtendimentosSequoia;
            } catch (e) {
                console.log(e);
            } finally{
                this.isLoadingAtendimentoRapido = false;
            }
        }
    }
};

});
parcelRegister("415wX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ecb8ba94d2dcddb$export$2e2bcd8739ae039; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $2ecb8ba94d2dcddb$export$2e2bcd8739ae039() {
    const api = (0, $c8Lpu.useApi)();
    async function getAtendimentos() {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).atendimento_sequoia}`);
    }
    async function getAtendimentosFundacao(idFundacoes) {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).atendimento_sequoia}?fundacao=${idFundacoes}`);
    }
    async function createAtendimentoSequoia(data) {
        return api.mutation(`${window.origin}${(0, $9YhWF.URLS).atendimento_sequoia}`, 'post', data);
    }
    async function updateAtendimentoSequoia(data, id) {
        return api.mutation(`${window.origin}${(0, $9YhWF.URLS).atendimento_sequoia}?pk=${id}`, 'put', data);
    }
    return {
        getAtendimentos: getAtendimentos,
        getAtendimentosFundacao: getAtendimentosFundacao,
        createAtendimentoSequoia: createAtendimentoSequoia,
        updateAtendimentoSequoia: updateAtendimentoSequoia,
        ...api
    };
}

});


parcelRegister("hmmUY", function(module, exports) {

$parcel$export(module.exports, "fundacaoService", function () { return $ca3644c01ad0ebe2$export$647267183e22f12d; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $ca3644c01ad0ebe2$export$647267183e22f12d() {
    const api = (0, $c8Lpu.useApi)();
    async function getFiltroFundacao(query = '?=') {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).cliente_filtro_fundacao}${query}`);
    }
    async function getInformacoesFundacao(fundacaoId = '', params = {}) {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).informacoes_modal_fundacao}${fundacaoId}`, params);
    }
    async function getFundacoes(params = {}) {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).api_fundacao}`, params);
    }
    return {
        getFiltroFundacao: getFiltroFundacao,
        getInformacoesFundacao: getInformacoesFundacao,
        getFundacoes: getFundacoes,
        ...api
    };
}

});


parcelRegister("9f1jB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ba688eb78456bf3$export$2e2bcd8739ae039; });
const { ref: $6ba688eb78456bf3$var$ref, watch: $6ba688eb78456bf3$var$watch } = Vue;
// Suponho que GLOBAL.isFundacao seja usado em outro lugar, mantendo aqui para referência
const { isFundacao: $6ba688eb78456bf3$var$isFundacao } = GLOBAL;
// Variável global para o debounce
window.timingSearchFundacao = null;
var $6ba688eb78456bf3$export$2e2bcd8739ae039 = {
    emits: [
        'click:item',
        'update:searchQuery'
    ],
    props: {
        searchQuery: {
            type: String,
            default: ''
        }
    },
    setup (props, ctx) {
        const inputValue = $6ba688eb78456bf3$var$ref(props.searchQuery);
        $6ba688eb78456bf3$var$watch(()=>props.searchQuery, (novaQuery)=>{
            if (novaQuery !== inputValue.value) inputValue.value = novaQuery;
        });
        $6ba688eb78456bf3$var$watch(inputValue, (val)=>{
            ctx.emit('update:searchQuery', val);
        });
        function debounceFunction(fn, wait = 300) {
            return (...args)=>{
                clearTimeout(window.timingSearchFundacao);
                window.timingSearchFundacao = setTimeout(()=>fn(...args), wait);
            };
        }
        function search(e) {
        /* console.log('Buscando por:', inputValue.value) */ }
        return {
            inputValue: inputValue,
            debounceFunction: debounceFunction,
            search: search
        };
    },
    template: html`
		<div class="input-icon relative">
			<q-input
				v-model="inputValue"
				outlined
				debounce="1000"
				class="h-48 w-[20.88rem]"
				placeholder="Pesquise.."
				js-ativo
				type="text"
				@keydown="(e) => debounceFunction(search, 800)(e)" />

			<svg
				v-if="inputValue"
				class="!w-32 !h-32 cursor-pointer"
				style="--cor-1: rgba(109,111,113,1);"
				@click="inputValue = ''">
				<use xlink:href="#icon_close"></use>
			</svg>
			<svg v-else>
				<use xlink:href="#icon_search"></use>
			</svg>
		</div>
	`
};

});

parcelRegister("bF0nE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87d3d193d860ada8$export$2e2bcd8739ae039; });

var $26SB8 = parcelRequire("26SB8");
parcelRequire("cjsNR");

var $4Fazw = parcelRequire("4Fazw");
const { tipoSistema: $87d3d193d860ada8$var$tipoSistema } = window;
const { isFundacao: $87d3d193d860ada8$var$isFundacao, initTipy: $87d3d193d860ada8$var$initTipy } = GLOBAL;
let $87d3d193d860ada8$var$isActivateCheckboxHeader = false;
function $87d3d193d860ada8$var$checkIsValidDate(data) {
    const isDataValid = new Date(data);
    return !isNaN(isDataValid.getTime());
}
var $87d3d193d860ada8$export$2e2bcd8739ae039 = {
    props: [
        'data',
        'data_inicial_politica',
        'data_final_politica',
        'limparTabela',
        'search'
    ],
    emits: [
        'open-modal',
        'open-modal-with-atendimento',
        'ordenate',
        'open-send-email',
        'click-checked-cliente',
        'click-unchecked-cliente',
        'clear-clientes'
    ],
    data () {
        return {
            isFundacao: $87d3d193d860ada8$var$isFundacao(),
            tableAtendimento: null,
            atendimentos: [],
            controllerTabelaFundacao: null
        };
    },
    components: {
        AvatarPersona: $4Fazw.default
    },
    watch: {
        limparTabela () {
            this.limparCheckboxAtendimentoRapido();
        },
        // Quando o termo de busca mudar, refaz a consulta
        search () {
            this.atualizarAgendamentoDetalhes();
        },
        // Se o intervalo de datas mudar, refaz a consulta
        data_inicial_politica () {
            this.atualizarAgendamentoDetalhes();
        },
        data_final_politica () {
            this.atualizarAgendamentoDetalhes();
        }
    },
    methods: {
        openModal (id, politica, atendimentoID) {
            this.$emit('open-modal', {
                id: id,
                politica: politica,
                atendimentoID: atendimentoID
            });
        },
        generateStatusColor (status) {
            if (status === 'Atrasado') return 'color: #c11f39 !important;';
            else if (status === 'Realizado') return 'color: #18b25d !important;';
            else if (status === 'Pendente') return 'color: #ffbb0b !important;';
            else return 'color: #252526 !important;';
        },
        columnsTableAtendimento () {
            const columns = [
                {
                    id: 'id',
                    name: 'id',
                    hidden: true
                },
                {
                    id: 'checkbox',
                    name: (0, $26SB8.html)(html`<label
							data-type="header-fundacao-checkbox"
							class="fundacao-checkbox">
							<input type="checkbox" disabled />
							<span class="checkmark"></span>
						</label>`),
                    width: '4rem',
                    hidden: !this.isFundacao,
                    formatter: (cell, row)=>{
                        const itemAtendimento = this.atendimentos.find((itemAtendimento)=>itemAtendimento.id === row._cells[0]?.data);
                        const id = itemAtendimento.fundacao || itemAtendimento.cliente_pf;
                        return (0, $26SB8.html)(html`<label
								data-type="body-fundacao-checkbox"
								class="fundacao-checkbox">
								<input type="checkbox" value="${id}" />
								<span class="checkmark"></span>
							</label>`);
                    }
                },
                {
                    id: 'name',
                    name: 'Nomes',
                    width: '260px',
                    formatter: (cell, row)=>{
                        const id = row._cells[0]?.data;
                        const atendimento = this.atendimentos?.find((atendimento)=>atendimento.id === Number(id));
                        const typePolitica = $87d3d193d860ada8$var$isFundacao() ? atendimento.politica_fundacao : atendimento.politica_cliente;
                        const columnName = (0, $26SB8.html)(html`<div
								class="inline-flex justify-center items-center gap-8 btn-open-modal-${id}"
								data-tippy-content="${$87d3d193d860ada8$var$isFundacao() ? atendimento.nome_fundacao : atendimento.nome_cliente_pf}">
								<svg
									class="h-40 w-40 shrink-0"
									style="${GLOBAL.generateAvatarColor(typePolitica)}">
									<use xlink:href="#icon_person"></use>
								</svg>
								${cell}
							</div> `);
                        setTimeout(()=>{
                            const openModal = document.querySelector(`.btn-open-modal-${id}`);
                            if (openModal) openModal.addEventListener('click', async ()=>{
                                this.handleOpenModal(atendimento);
                            });
                        }, 0);
                        return columnName;
                    }
                },
                {
                    id: 'last_attendant',
                    name: "\xdaltimo Atendimento",
                    width: '150px',
                    formatter: (cell, row)=>{
                        const id = row._cells[0]?.data;
                        const atendimento = this.atendimentos?.find((atendimento)=>atendimento.id === Number(id));
                        return this.ultimaData(atendimento);
                    },
                    sort: {
                        compare: (a, b)=>{
                            if ($87d3d193d860ada8$var$checkIsValidDate(a) && $87d3d193d860ada8$var$checkIsValidDate(b)) {
                                const dataFormatA = new Date(a);
                                const dataFormatB = new Date(b);
                                if (dataFormatA > dataFormatB) return 1;
                                else if (dataFormatA < dataFormatB) return -1;
                            }
                            return 0;
                        }
                    }
                },
                {
                    id: 'date_politic',
                    name: 'Data da politica',
                    width: '150px',
                    formatter: (cell, row)=>{
                        const id = row._cells[0]?.data;
                        const atendimento = this.atendimentos?.find((atendimento)=>atendimento.id === Number(id));
                        if (!atendimento.data) return '-';
                        const dateObject = new Date(atendimento.data);
                        return GLOBAL.formatDateObject(dateObject);
                    },
                    sort: {
                        compare: (a, b)=>{
                            if ($87d3d193d860ada8$var$checkIsValidDate(a) && $87d3d193d860ada8$var$checkIsValidDate(b)) {
                                const dataFormatA = new Date(a);
                                const dataFormatB = new Date(b);
                                if (dataFormatA > dataFormatB) return 1;
                                else if (dataFormatA < dataFormatB) return -1;
                            }
                            return 0;
                        }
                    }
                },
                {
                    id: 'status',
                    name: 'Status',
                    width: '100px',
                    formatter: (cell)=>{
                        return (0, $26SB8.html)(html`<div style="${this.generateStatusColor(cell)}">
								${cell}
							</div> `);
                    }
                },
                {
                    id: 'actions',
                    name: '',
                    width: '80px',
                    formatter: (cell, row)=>{
                        const id = row._cells[0]?.data;
                        const atendimento = this.atendimentos?.find((atendimento)=>atendimento.id === Number(id));
                        const columnActions = (0, $26SB8.html)(`
              <div class="flex gap-8 items-center justify-center ">
                <div
                  data-tippy-content="Enviar E-mail"
                  class="tippy-el btn-action-${id}">
                  <div
                    class="cursor-pointer hover:scale-125 transition-transform inline-flex active:scale-110 justify-center w-full ">
                    <svg
                      class="h-32 w-32 border border-transparent rounded-lg hover:border-neutral-60 ">
                      <use xlink:href="#icon_email"></use>
                    </svg>
                  </div>
                </div>
                <div data-tippy-content="Enviar E-mail"
                  class="tippy-el btn-criar-${id}" >
                  <div data-tippy-content="Criar atendimento" class="tippy-el">
                    <div class="cursor-pointer hover:scale-125 transition-transform inline-flex active:scale-110 justify-center w-full">
                      <svg class="h-32 w-32 border border-transparent rounded-lg hover:border-neutral-60">
                        <use xlink:href="#icon_check"></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            `);
                        setTimeout(()=>{
                            const sendEmail = document.querySelector(`.btn-action-${id}`);
                            if (sendEmail) sendEmail.addEventListener('click', async ()=>{
                                this.openSendEmail($87d3d193d860ada8$var$isFundacao() ? atendimento.fundacao : atendimento.cliente_pf);
                            });
                            const criarAtendimmento = document.querySelector(`.btn-criar-${id}`);
                            if (criarAtendimmento) criarAtendimmento.addEventListener('click', async ()=>{
                                this.handleOpenModal(atendimento, true);
                            });
                        }, 0);
                        return columnActions;
                    }
                }
            ];
            return columns;
        },
        async atualizarAgendamentoDetalhes () {
            const exibicao = this.isFundacao ? '?exibicao=fundacao' : '?exibicao=cliente_pf';
            const dataInicialPoliticaFormated = this.data_inicial_politica.split('/').reverse().join('-');
            const dataFinalPoliticaFormated = this.data_final_politica.split('/').reverse().join('-');
            // Adiciona o termo de busca à URL, se houver
            const searchParam = this.search ? `&search=${encodeURIComponent(this.search)}` : '';
            this.tableAtendimento.updateConfig({
                server: {
                    url: `/api/atendimentos/${exibicao}&data_inicial=${dataInicialPoliticaFormated}&data_final=${dataFinalPoliticaFormated}${searchParam}`,
                    then: (responseAtendimentos)=>{
                        const atendimentos = responseAtendimentos?.results?.atendimentos;
                        this.atendimentos = atendimentos;
                        let arrayForTable = [];
                        if (atendimentos) {
                            if ($87d3d193d860ada8$var$isFundacao()) arrayForTable = atendimentos.map(({ id: id, sigla_fundacao: sigla_fundacao, ultimo_atendimento_fundacao: ultimo_atendimento_fundacao, data: data, status: status })=>[
                                    id,
                                    null,
                                    sigla_fundacao,
                                    ultimo_atendimento_fundacao,
                                    data,
                                    status,
                                    'teste'
                                ]);
                            else arrayForTable = atendimentos.map(({ id: id, nome_cliente_pf: nome_cliente_pf, ultimo_atendimento_cliente_pf: ultimo_atendimento_cliente_pf, status: status })=>[
                                    id,
                                    null,
                                    nome_cliente_pf,
                                    ultimo_atendimento_cliente_pf,
                                    status,
                                    'teste'
                                ]);
                        }
                        return arrayForTable;
                    },
                    total: (responseAtendimentos)=>responseAtendimentos?.count
                },
                search: false,
                pagination: {
                    enabled: true,
                    limit: 100,
                    server: {
                        url: (urlApi, page, limit)=>{
                            return `${urlApi}&page=${++page}&paginate_by=${limit}`;
                        }
                    }
                }
            }).forceRender();
        },
        createTableAtendimento () {
            this.resetController();
            const columns = this.columnsTableAtendimento();
            const exibicao = this.isFundacao ? '?exibicao=fundacao' : '?exibicao=cliente_pf';
            const dataInicialPoliticaFormated = this.data_inicial_politica.split('/').reverse().join('-');
            const dataFinalPoliticaFormated = this.data_final_politica.split('/').reverse().join('-');
            // Inclui o termo de busca ao montar a URL pela primeira vez
            const searchParam = this.search ? `&search=${encodeURIComponent(this.search)}` : '';
            this.tableAtendimento = new (0, $26SB8.Grid)({
                resizable: true,
                columns: columns,
                autoWidth: true,
                width: '100%',
                sort: false,
                server: {
                    url: `/api/atendimentos/${exibicao}&data_inicial=${dataInicialPoliticaFormated}&data_final=${dataFinalPoliticaFormated}${searchParam}`,
                    then: (responseAtendimentos)=>{
                        const atendimentos = responseAtendimentos?.results?.atendimentos;
                        this.atendimentos = atendimentos;
                        let arrayForTable = [];
                        if (atendimentos) {
                            if ($87d3d193d860ada8$var$isFundacao()) arrayForTable = atendimentos.map(({ id: id, sigla_fundacao: sigla_fundacao, ultimo_atendimento_fundacao: ultimo_atendimento_fundacao, data: data, status: status })=>[
                                    id,
                                    null,
                                    sigla_fundacao,
                                    ultimo_atendimento_fundacao,
                                    data,
                                    status,
                                    'teste'
                                ]);
                            else arrayForTable = atendimentos.map(({ id: id, nome_cliente_pf: nome_cliente_pf, ultimo_atendimento_cliente_pf: ultimo_atendimento_cliente_pf, data: data, status: status })=>[
                                    id,
                                    null,
                                    nome_cliente_pf,
                                    ultimo_atendimento_cliente_pf,
                                    data,
                                    status,
                                    'teste'
                                ]);
                        }
                        this.agendaEventoListenerCheckboxAtendimentoRapido();
                        arrayForTable = arrayForTable.sort((a, b)=>{
                            const dateA = new Date(a[3]);
                            const dateB = new Date(b[3]);
                            const timeA = isNaN(dateA) ? -Infinity : dateA.getTime();
                            const timeB = isNaN(dateB) ? -Infinity : dateB.getTime();
                            return timeA - timeB;
                        });
                        return arrayForTable;
                    },
                    total: (responseAtendimentos)=>responseAtendimentos?.count
                },
                search: false,
                pagination: {
                    enabled: true,
                    limit: 100,
                    server: {
                        url: (urlApi, page, limit)=>{
                            return `${urlApi}&page=${++page}&paginate_by=${limit}`;
                        }
                    }
                },
                style: {
                    container: {
                        border: 'none'
                    },
                    table: {
                        border: 'none'
                    },
                    tr: {
                        border: 'none'
                    },
                    th: {
                        'border-bottom': '1px solid #e9ecef'
                    },
                    td: {
                        'border-bottom': '1px solid #e9ecef',
                        cursor: 'pointer'
                    },
                    footer: {
                        border: 'none'
                    }
                },
                language: {
                    search: {
                        placeholder: 'Busque aqui...'
                    },
                    pagination: {
                        previous: '<',
                        next: '>',
                        to: '/',
                        of: 'de',
                        showing: 'Mostrando',
                        results: ()=>'Resultados'
                    },
                    loading: 'Carregando dados...',
                    noRecordsFound: 'Nenhum dado encontrado.'
                }
            });
            this.tableAtendimento.on('beforeLoad', ()=>{
                this.resetController();
            });
            this.tableAtendimento.render(document.querySelector('#table_atendimentos'));
        },
        openModalWithAtendimento (id, politica, atendimentoID) {
            this.$emit('open-modal-with-atendimento', {
                id: id,
                politica: politica,
                atendimentoID: atendimentoID
            });
        },
        ordenate (event, key, dataKey, number) {
            this.$emit('ordenate', {
                event: event,
                key: key,
                dataKey: dataKey,
                ...number
            });
        },
        canculateDiference (end) {
            if (end == 'Sem atendimentos') return '-';
            else return GLOBAL.calculateDateDiference(end);
        },
        handleOpenModal (atendimento, withAtendimento) {
            const clienteID = this.isFundacao ? atendimento.fundacao : atendimento.cliente_pf;
            const politica = this.isFundacao ? atendimento.politica_fundacao : atendimento.politica_cliente;
            if (withAtendimento) this.openModalWithAtendimento(clienteID, politica, atendimento.id);
            else this.openModal(clienteID, politica, atendimento.id);
        },
        ultimaData (atendimento) {
            return this.isFundacao ? this.canculateDiference(atendimento.ultimo_atendimento_fundacao) : this.canculateDiference(atendimento.ultimo_atendimento_cliente_pf);
        },
        openSendEmail (id) {
            this.$emit('open-send-email', id);
        },
        handleCheckboxTabelaFundacao () {
            const elHeader = document.querySelector('label[data-type="header-fundacao-checkbox"]');
            const listaCheckedOriginal = document.querySelectorAll('label[data-type="body-fundacao-checkbox"]');
            listaCheckedOriginal.forEach((itemCheckedOriginal)=>{
                itemCheckedOriginal.addEventListener('click', (e)=>{
                    const currentTarget = itemCheckedOriginal.querySelector('input[type="checkbox"]');
                    setTimeout(()=>{
                        const inputHeader = elHeader.querySelector('input[type="checkbox"]');
                        const listaChecked = document.querySelectorAll('label[data-type="body-fundacao-checkbox"] input[type="checkbox"]:checked');
                        if (currentTarget.checked) this.$emit('click-checked-cliente', currentTarget.value);
                        else this.$emit('click-unchecked-cliente', currentTarget.value);
                        if (!$87d3d193d860ada8$var$isActivateCheckboxHeader && listaChecked.length >= 1) {
                            inputHeader.indeterminate = true;
                            $87d3d193d860ada8$var$isActivateCheckboxHeader = true;
                        } else if ($87d3d193d860ada8$var$isActivateCheckboxHeader && listaChecked.length <= 0) {
                            inputHeader.indeterminate = false;
                            $87d3d193d860ada8$var$isActivateCheckboxHeader = false;
                        }
                    }, 0);
                }, {
                    signal: this.controllerTabelaFundacao.signal
                });
            });
            elHeader?.addEventListener('click', (e)=>{
                setTimeout(()=>{
                    this.limparCheckboxAtendimentoRapido();
                    this.$emit('clear-clientes');
                }, 0);
            }, {
                signal: this.controllerTabelaFundacao.signal
            });
        },
        agendaEventoListenerCheckboxAtendimentoRapido () {
            let currentAttemp = 1;
            const maxAttemp = 5;
            let intervalId = setInterval(()=>{
                const isRenderTableCheckedItems = document.querySelectorAll('label[data-type="body-fundacao-checkbox"] span.checkmark').length;
                if (isRenderTableCheckedItems >= 0) {
                    this.handleCheckboxTabelaFundacao();
                    clearInterval(intervalId);
                } else if (currentAttemp > maxAttemp) clearInterval(intervalId);
                else currentAttemp++;
            }, 1000);
        },
        resetController () {
            if (this.controllerTabelaFundacao) this.controllerTabelaFundacao.abort();
            this.controllerTabelaFundacao = new AbortController();
        },
        limparCheckboxAtendimentoRapido () {
            const checkboxOriginal = document.querySelector('label[data-type="header-fundacao-checkbox"] input[type="checkbox"]');
            const listaCheckedOriginal = document.querySelectorAll('label[data-type="body-fundacao-checkbox"] input[type="checkbox"]:checked');
            if (listaCheckedOriginal.length > 0) Array.from(listaCheckedOriginal).forEach((itemCheckBox)=>{
                itemCheckBox.checked = false;
            });
            checkboxOriginal.indeterminate = false;
            checkboxOriginal.checked = false;
            $87d3d193d860ada8$var$isActivateCheckboxHeader = false;
        }
    },
    computed: {
        skeletonClass () {
            return {
                skeleton: this.data[0]?.placeholder
            };
        }
    },
    mounted () {
        this.createTableAtendimento();
        setTimeout(()=>{
            tippy('[data-tippy-content]', {
                allowHTML: true,
                placement: 'top',
                boundary: 'HTMLElement'
            });
        }, 1000);
        this.tableAtendimento.on('ready', ()=>{
            this.agendaEventoListenerCheckboxAtendimentoRapido();
        });
    },
    beforeUnmount () {
        this.controllerTabelaFundacao.abort();
    },
    template: html`
		<div
			id="wrapper-container-tabela"
			class="w-[100%] max-h-[29.15rem] overflow-y-auto overflow-x-scroll flex-1 table-wrapper  box-border relative">
			<table id="table_atendimentos" class="!flex" js-table-ordenation></table>
		</div>
	`
};

});
parcelRegister("cjsNR", function(module, exports) {

var $26SB8 = parcelRequire("26SB8");
function $8f6d9a1b40f6323f$var$i(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, $8f6d9a1b40f6323f$var$r(t, e);
}
function $8f6d9a1b40f6323f$var$r(t, e) {
    return $8f6d9a1b40f6323f$var$r = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, $8f6d9a1b40f6323f$var$r(t, e);
}
var $8f6d9a1b40f6323f$export$d8b9223b055954f5 = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    $8f6d9a1b40f6323f$var$i(e, t);
    var s = e.prototype;
    return s.getInitialState = function() {
        return {
            rowIds: []
        };
    }, s.handle = function(t, e) {
        "CHECK" === t && this.check(e.ROW_ID), "UNCHECK" === t && this.uncheck(e.ROW_ID);
    }, s.check = function(t) {
        this.state.rowIds.indexOf(t) > -1 || this.setState({
            rowIds: [
                t
            ].concat(this.state.rowIds)
        });
    }, s.uncheck = function(t) {
        var e = this.state.rowIds.indexOf(t);
        if (-1 !== e) {
            var s = [].concat(this.state.rowIds);
            s.splice(e, 1), this.setState({
                rowIds: s
            });
        }
    }, e;
}((0, $26SB8.BaseStore)), $8f6d9a1b40f6323f$export$41fd140d846da0fe = /*#__PURE__*/ function(t) {
    function e() {
        return t.apply(this, arguments) || this;
    }
    $8f6d9a1b40f6323f$var$i(e, t);
    var s = e.prototype;
    return s.check = function(t) {
        this.dispatch("CHECK", {
            ROW_ID: t
        });
    }, s.uncheck = function(t) {
        this.dispatch("UNCHECK", {
            ROW_ID: t
        });
    }, e;
}((0, $26SB8.BaseActions)), $8f6d9a1b40f6323f$export$e8905133e7bf3121 = /*#__PURE__*/ function(t) {
    function e(e, s) {
        var n;
        if ((n = t.call(this, e, s) || this).actions = void 0, n.store = void 0, n.storeUpdatedFn = void 0, n.isDataCell = function(t) {
            return void 0 !== t.row;
        }, n.getParentTR = function() {
            return n.base && n.base.parentElement && n.base.parentElement.parentElement;
        }, n.state = {
            isChecked: !1
        }, n.isDataCell(e)) {
            if (e.store) n.store = e.store;
            else {
                var o = new $8f6d9a1b40f6323f$export$d8b9223b055954f5(n.config.dispatcher);
                n.store = o, e.plugin.props.store = o;
            }
            n.actions = new $8f6d9a1b40f6323f$export$41fd140d846da0fe(n.config.dispatcher), n.storeUpdatedFn = n.storeUpdated.bind(function(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }(n)), n.store.on("updated", n.storeUpdatedFn), e.cell.data && n.check();
        }
        return n;
    }
    $8f6d9a1b40f6323f$var$i(e, t);
    var n = e.prototype;
    return n.componentWillUnmount = function() {
        this.store.off("updated", this.storeUpdatedFn);
    }, n.componentDidMount = function() {
        this.store && this.storeUpdated(this.store.state);
    }, n.storeUpdated = function(t) {
        var e = this.getParentTR();
        if (e) {
            var s = t.rowIds.indexOf(this.props.id(this.props.row)) > -1;
            this.setState({
                isChecked: s
            }), s ? e.classList.add(this.props.selectedClassName) : e.classList.remove(this.props.selectedClassName);
        }
    }, n.check = function() {
        this.actions.check(this.props.id(this.props.row)), this.props.cell.update(!0);
    }, n.uncheck = function() {
        this.actions.uncheck(this.props.id(this.props.row)), this.props.cell.update(!1);
    }, n.toggle = function() {
        this.state.isChecked ? this.uncheck() : this.check();
    }, n.render = function() {
        var t = this;
        return this.isDataCell(this.props) ? (0, $26SB8.h)("input", {
            type: "checkbox",
            checked: this.state.isChecked,
            onChange: function() {
                return t.toggle();
            },
            className: this.props.checkboxClassName
        }) : null;
    }, e;
}((0, $26SB8.PluginBaseComponent));
$8f6d9a1b40f6323f$export$e8905133e7bf3121.defaultProps = {
    selectedClassName: (0, $26SB8.className)("tr", "selected"),
    checkboxClassName: (0, $26SB8.className)("checkbox")
};

});


parcelRegister("bJHXi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88b5fe4b9654e140$export$2e2bcd8739ae039; });

var $8TiaI = parcelRequire("8TiaI");

var $jPDDn = parcelRequire("jPDDn");
const { ref: $88b5fe4b9654e140$var$ref } = Vue;
const $88b5fe4b9654e140$var$instancia = {
    template: document.getElementById("modal_send_email"),
    mixins: [
        (0, $8TiaI.default)
    ],
    emits: [],
    components: {
        ModalHeader: $jPDDn.default
    },
    props: {
        isFundacao: Boolean
    },
    mounted () {
        GLOBAL.addRequiredLabel(document.getElementById("form_send_email"));
    },
    setup (props, ctx) {},
    delimiters: [
        "{*",
        "*}"
    ]
};
var $88b5fe4b9654e140$export$2e2bcd8739ae039 = $88b5fe4b9654e140$var$instancia;

});
parcelRegister("8TiaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67918e58303759d9$export$2e2bcd8739ae039; });
const { api: $67918e58303759d9$var$api, getChoicesActive: $67918e58303759d9$var$getChoicesActive, showToastify: $67918e58303759d9$var$showToastify } = GLOBAL;
var $67918e58303759d9$export$2e2bcd8739ae039 = {
    data () {
        return {
            state: {
                sending: false
            }
        };
    },
    computed: {
        btnClass () {
            return {
                disabled: this.state.sending
            };
        }
    },
    methods: {
        clearFields (els, type) {
            if (type === "select") {
                console.log("passou");
                els.forEach((s)=>{
                    const select = $67918e58303759d9$var$getChoicesActive(s.id, listOfChoices);
                    select?.setChoiceByValue(0);
                });
            } else if (type === "input") {
                console.log(els, "input");
                els.forEach((i)=>i.value = "");
            }
        },
        /**
		 * @summary Callback que recebe um  field de formulario e adiciona
		 * @summary remove classe se for valido
		 * @param {HTMLFormElement} field
		 * @return {Boolean} - diz se esta valido ou nao
		 */ toogleValideField (field) {
            const label = field.closest("[js-field]")?.querySelector("label");
            const valid = field.checkValidity();
            if (valid && label) label.classList.remove("error");
            else label.classList.add("error");
            return valid;
        },
        data () {
            return {
                modelo: document.querySelector("#select-modelo")?.value,
                responsaveis: $67918e58303759d9$var$getChoicesActive("select-responsaveis", listOfChoices),
                cliente: document.querySelector("#select-cliente")?.value,
                titulo: document.querySelector("#input-titulo")?.value,
                corpo_email: document.querySelector("#textarea-corpo-email")?.value
            };
        },
        elementos () {
            return {
                modeloEl: document.querySelector("#select-modelo"),
                responsaveisEl: $67918e58303759d9$var$getChoicesActive("select-responsaveis", listOfChoices),
                clienteEl: document.querySelector("#select-cliente"),
                tituloEl: document.querySelector("#input-titulo"),
                corpo_emailEl: document.querySelector("#textarea-corpo-email")
            };
        },
        /**
		 * @summary  envia o request de e-mail se for valido
		 * fecha o modal quando enviado e limpa os campos
		 * @param {Event} Callback evento
		 */ async sendEmail ({ currentTarget: currentTarget }) {
            NProgress.start();
            const form = currentTarget.closest("form");
            const fields = [
                ...form.querySelectorAll("[name]")
            ];
            fields?.map(this.toogleValideField);
            const valid = fields?.every((f)=>f.checkValidity());
            if (!valid) {
                $67918e58303759d9$var$showToastify("\u26A0\uFE0F Preencha todos os campos obrigatorios.");
                return;
            }
            const { modelo: modelo, responsaveis: responsaveis, cliente: cliente, titulo: titulo, corpo_email: corpo_email } = this.data();
            const { modeloEl: modeloEl, responsaveisEl: responsaveisEl, clienteEl: clienteEl, tituloEl: tituloEl, corpo_emailEl: corpo_emailEl } = this.elementos();
            const data = {
                modelo: modelo,
                contatos: responsaveis?.getValue()?.map((i)=>i.value),
                cliente: Number(cliente),
                titulo: titulo,
                corpo_email: corpo_email
            };
            try {
                this.state.sending = true;
                const request = await axios.post(window.home_data.url_email, data);
                $67918e58303759d9$var$showToastify("\u2705 Email enviado com sucesso.");
                this.clearFields([
                    modeloEl,
                    responsaveisEl,
                    clienteEl
                ], "select");
                this.clearFields([
                    tituloEl,
                    corpo_emailEl
                ], "input");
                modal_padrao_vue.closeModal();
            } catch (e) {
                console.log(e);
                $67918e58303759d9$var$showToastify("\u274C Ocorreu um erro ao enviar o email.");
            } finally{
                this.state.sending = false;
                NProgress.done();
            }
        },
        closeSendEmail () {
            const { modeloEl: modeloEl, responsaveisEl: responsaveisEl, clienteEl: clienteEl, tituloEl: tituloEl, corpo_emailEl: corpo_emailEl } = this.elementos();
            this.clearFields([
                modeloEl,
                responsaveisEl,
                clienteEl
            ], "select");
            this.clearFields([
                tituloEl,
                corpo_emailEl
            ], "input");
            modal_padrao_vue.closeModal();
        },
        async getContatos (idCliente) {
            const url = this.isFundacao ? `/api/contatos/?fundacao=${idCliente}` : `/api/contatos/?cliente_pf=${idCliente}`;
            const { data: data } = await $67918e58303759d9$var$api.get(url);
            console.log({
                data: data,
                fun: this.isFundacao
            });
            return data.results;
        },
        async handleChangeCliente (choicesClientes, choicesResponsaveis) {
            choicesResponsaveis?.clearStore();
            const idCliente = choicesClientes.getValue()?.value;
            const data = await this.getContatos(idCliente);
            const optionsContatos = data.map(({ id: id, nome: nome, principal: principal })=>({
                    value: id,
                    label: nome,
                    selected: principal
                }));
            choicesResponsaveis?.setChoices([
                ...optionsContatos
            ], "value", "label", true);
        },
        async openSendEmail (idPass) {
            _BIG("id_cliente");
            console.log(idPass);
            NProgress.start();
            const choicesClientes = $67918e58303759d9$var$getChoicesActive("select-cliente", window.listOfChoices);
            const choicesResponsaveis = $67918e58303759d9$var$getChoicesActive("select-responsaveis", window.listOfChoices);
            choicesClientes?.clearStore();
            const optionsClientes = todosClientesUsuario?.map(({ id: id, nome: nome })=>({
                    value: id,
                    label: nome,
                    selected: id == idPass
                }));
            console.log({
                idPass: idPass
            }, 'aqui');
            const data = await this.getContatos(idPass);
            choicesResponsaveis?.clearStore();
            let optionsContatos = [];
            console.log({
                idPass: idPass
            }, 'aqui');
            optionsContatos = data?.map(({ id: id, nome: nome, principal: principal })=>({
                    value: id,
                    label: nome,
                    selected: principal
                }));
            choicesResponsaveis?.setChoices([
                ...optionsContatos
            ], "value", "label", true);
            optionsContatos = [];
            choicesClientes?.setChoices([
                ...optionsClientes
            ], "value", "label", true);
            // choicesClientes.passedElement.element?.addEventListener("change", () =>
            // //	this.handleChangeCliente(choicesClientes, choicesResponsaveis)
            // );
            modal_padrao_vue.openModal("enviar_email");
            NProgress.done();
        }
    }
};

});

parcelRegister("jPDDn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e701863b0ce04635$export$2e2bcd8739ae039; });
const { ref: $e701863b0ce04635$var$ref } = Vue;
var $e701863b0ce04635$export$2e2bcd8739ae039 = {
    emits: [],
    props: {
        titulo: {
            type: String,
            required: true
        },
        close: {
            type: Function,
            required: true
        }
    },
    setup (props, ctx) {
    // const modal_padrao = modal_padrao;
    // return {
    // 	modal_padrao,
    // };
    },
    template: html`
		<header
			class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure"
		>
			<h2 class="text-lg font-medium text-white">{{titulo}}</h2>
			<button
				type="button"
				class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
				data-xclose="modal_padrao"
				@click="close"
			>
				<svg class="w-32 h-32">
					<use xlink:href="#icon_close"></use>
				</svg>
			</button>
		</header>
	`
};

});


parcelRegister("SxmxE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a3eec5f8dffc227$export$2e2bcd8739ae039; });

var $5XTTN = parcelRequire("5XTTN");
const { showToastify: $0a3eec5f8dffc227$var$showToastify, errorDefault: $0a3eec5f8dffc227$var$errorDefault, FormatREALBackEnd: $0a3eec5f8dffc227$var$FormatREALBackEnd } = GLOBAL;
var $0a3eec5f8dffc227$export$2e2bcd8739ae039 = {
    components: {
        NewProcessoItem: $5XTTN.default
    },
    props: [
        'fundacoes',
        'estrategias',
        'fundos',
        'semestres'
    ],
    emits: [
        'processo-enviado'
    ],
    data () {},
    methods: {
        closeModalNovoProcesso () {
            modal_padrao_vue.closeModal('modal_novo_processo');
        },
        async sendNewProcesso (obj) {
            /* NProgress.start() */ /* 			const valorInput = document.querySelector('#valor_processo')
			console.log(obj) */ const { valor: valor } = obj;
            let valorFinal = 0;
            if (valor.includes(',')) {
                const valorTransformado = parseFloat(valor.replaceAll('.', '').replace(',', '.')) * 10;
                /* console.log(valorTransformado) */ valorFinal = valorTransformado.toFixed(2);
            } else if (valor.length == 3) valorFinal = (parseFloat(valor) / 100).toFixed(2);
            else valorFinal = valor;
            /* 			console.log(valor)
			console.log(valorFinal) */ try {
                const response = await axios.post(`${window.location.origin}/clientes/pr	ocessos_fundacoes/`, {
                    ...obj,
                    /* fundacao: this.clienteAtivo.id, */ valor: valorFinal
                });
                if (this.clienteAtivo?.id) {
                    await this.getDadosModal(this.clienteAtivo.id, true);
                    await this.getProcessosFundacao(this.clienteAtivo.id);
                }
                $0a3eec5f8dffc227$var$showToastify("\u2705 Processo Criado com sucesso.");
                this.$emit('processo-enviado', response);
                return response;
            } catch (e) {
                $0a3eec5f8dffc227$var$errorDefault(e);
            } finally{
            /* NProgress.done() */ }
        }
    },
    mounted () {},
    template: `
		<section 
			class="modal--content rounded-md flex-1 w-auto !overflow-[initial]"
			data-id="modal_novo_processo"
			>
				<new-processo-item
					class="!border-none"
					:is-fundacao-activate="true"
					:fundacoes="fundacoes"
					:estrategias="estrategias"
					:fundos="fundos"
					:semestres="semestres"
					@cancelar="closeModalNovoProcesso"
					@enviar="(obj)=>sendNewProcesso(obj)"></new-processo-item>
		</section>
	
	`
};

});

parcelRegister("DhNZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0761745f5e3e5893$export$2e2bcd8739ae039; });
var $0761745f5e3e5893$export$2e2bcd8739ae039 = {
    props: {
        totalSelecionado: {
            type: Number,
            default: 0
        },
        loadingAtendimentoRapido: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'criar:atendimento',
        'limpar:atendimento'
    ],
    data () {
        return {
            optionsSelects: {
                optionsPoliticaAtendimentoRapido: [
                    {
                        value: '0',
                        label: "Pol\xedtica de atendimento"
                    },
                    {
                        value: '1',
                        label: 'Outro'
                    }
                ]
            },
            model: {
                politicaAtendimentoRapido: null,
                menssagemPoliticaAtendimentoRapido: ''
            }
        };
    },
    computed: {
        isFormValid () {
            return this.model.politicaAtendimentoRapido && this.totalSelecionado > 0;
        },
        labelSelecionados () {
            return `${this.totalSelecionado} ${this.totalSelecionado === 1 ? 'Item Selecionado' : 'Itens Selecionados'}`;
        }
    },
    methods: {
        limparAtendimentoRapido () {
            this.resetForm();
            this.$emit('limpar:atendimento');
        },
        criarAtendimento () {
            if (!this.isFormValid) return;
            this.$emit('criar:atendimento', this.model.politicaAtendimentoRapido?.value, this.model.menssagemPoliticaAtendimentoRapido);
        },
        resetForm () {
            this.model.politicaAtendimentoRapido = null;
            this.model.menssagemPoliticaAtendimentoRapido = '';
        }
    },
    watch: {
        totalSelecionado (newVal) {
            if (newVal === 0) this.resetForm();
        }
    },
    template: `<div class="
        fixed 
        bottom-0 
        inset-x-0 
        w-full
        h-[5rem]
        !pl-[279px]
        !pr-[190px]
        bg-white
        shadow-[0px_-4px_12px_rgba(0,0,0,0.1)]
        transition-transform duration-300
        z-50">
        <form @submit.stop.prevent="criarAtendimento" class="w-full h-full">
            <div class="flex justify-between items-center w-full h-full bg-white mx-auto px-24">
                <div class="flex items-center h-full">
                    <q-checkbox 
                        size="xs" 
                        indeterminate-value="maybe" 
                        :label="labelSelecionados" 
                        color="primary-pure"
                        :model-value="true"
                        @click="limparAtendimentoRapido"/>
                </div>
                <div class="flex items-center gap-16 h-full">
                    <q-select 
                        outlined 
                        v-model="model.politicaAtendimentoRapido" 
                        :label="model.politicaAtendimentoRapido ? '': 'Pol\xedtica padr\xe3o'" 
                        class="min-w-[11rem]"  
                        :options="optionsSelects.optionsPoliticaAtendimentoRapido" 
                        />
                    <q-input 
                        outlined 
                        v-model="model.menssagemPoliticaAtendimentoRapido" 
                        :label="model.menssagemPoliticaAtendimentoRapido ? '': 'Mensagem padr\xe3o...'" 
                        class="w-[20rem]" 
                        input-class="primary-pure"/>
                    <q-btn
                        type="submit"
                        class="btn h-48 primary"
                        :loading="loadingAtendimentoRapido"
                        :disable="!isFormValid"
                        >
                        Enviar atendimento
                    </q-btn>
                </div>
            </div>
        </form>
    </div>`
};

});

parcelRegister("lY3Fi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffe20b62700b3dad$export$2e2bcd8739ae039; });

var $aNdj6 = parcelRequire("aNdj6");

var $2m7Ys = parcelRequire("2m7Ys");
const { getAtendimentosFundacao: $ffe20b62700b3dad$var$getAtendimentosFundacao, createAtendimentoRapido: $ffe20b62700b3dad$var$createAtendimentoRapidoService } = (0, $aNdj6.default)();
var $ffe20b62700b3dad$export$2e2bcd8739ae039 = {
    name: 'AtendimentoRapidoMixin',
    data () {
        return {
            isLoadingAtendimentoRapido: false,
            listaClientesAtendimentoRapido: []
        };
    },
    methods: {
        addClienteAtendimentoRapido (clienteId) {
            this.listaClientesAtendimentoRapido.push(clienteId);
            this.listaClientesAtendimentoRapido = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).uniq(this.listaClientesAtendimentoRapido);
        },
        removeClienteAtendimentoRapido (clienteId) {
            this.listaClientesAtendimentoRapido = this.listaClientesAtendimentoRapido.filter((itemClienteId)=>itemClienteId !== clienteId);
        },
        clearClienteAtendimentoRapido () {
            this.listaClientesAtendimentoRapido = [];
        },
        async createAtendimentoRapido (tipoAtendimentoRapido, menssagemAtendimentoRapido, tituloAtendimento = null, dataAtendimento = null) {
            try {
                this.isLoadingAtendimentoRapido = true;
                const { atendimentos: atendimentos } = await $ffe20b62700b3dad$var$getAtendimentosFundacao(this.listaClientesAtendimentoRapido);
                const dataAtedimentoComum = atendimentos.reduce((acumuladorAtendimento, itemAtendimento)=>{
                    acumuladorAtendimento.fundacoesId.push(itemAtendimento.id);
                    acumuladorAtendimento.fundacoesData.push(itemAtendimento.atendimento_data || new Date().toISOString());
                    return acumuladorAtendimento;
                }, {
                    fundacoesId: [],
                    fundacoesData: []
                });
                const formDataAtendimentoRapido = {
                    fundacoes_ids: dataAtedimentoComum.fundacoesId,
                    tipo_atendimento: tipoAtendimentoRapido,
                    atendimento: menssagemAtendimentoRapido,
                    notificacao: '2',
                    data: dataAtendimento ? dataAtendimento : dataAtedimentoComum.fundacoesData,
                    data_atendimento: new Date().toISOString(),
                    titulo_atendimento: tituloAtendimento
                };
                const responseAtividadeRapida = await $ffe20b62700b3dad$var$createAtendimentoRapidoService(formDataAtendimentoRapido);
                this.clearClienteAtendimentoRapido();
                GLOBAL.showToastify("\u2705 Atendimento(s) criado com sucesso.");
                return responseAtividadeRapida;
            } catch (e) {
                console.log(e);
            } finally{
                this.isLoadingAtendimentoRapido = false;
            }
        }
    }
};

});
parcelRegister("aNdj6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7db8cd7be498814c$export$2e2bcd8739ae039; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $7db8cd7be498814c$export$2e2bcd8739ae039() {
    const api = (0, $c8Lpu.useApi)();
    async function getAtendimentosFundacao(idFundacoes) {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).info_data_politica_fundacao}?fundacao=${idFundacoes}`);
    }
    async function createAtendimentoRapido(data) {
        return api.mutation(`${window.origin}${(0, $9YhWF.URLS).atendimento_rapido_fundacao}`, 'post', data);
    }
    return {
        getAtendimentosFundacao: getAtendimentosFundacao,
        createAtendimentoRapido: createAtendimentoRapido,
        ...api
    };
}

});


parcelRegister("bfGVy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $831264e03f8f8952$export$2e2bcd8739ae039; });

var $kxhz7 = parcelRequire("kxhz7");

var $hmmUY = parcelRequire("hmmUY");

var $7h4Zs = parcelRequire("7h4Zs");

var $67nR7 = parcelRequire("67nR7");

var $eayks = parcelRequire("eayks");

var $3Zw81 = parcelRequire("3Zw81");
const { getFundacoesContatos: $831264e03f8f8952$var$getFundacoesContatos, getTemplatesEmail: $831264e03f8f8952$var$getTemplatesEmail } = (0, $kxhz7.emailFundacaoService)();
const { getFiltroFundacao: $831264e03f8f8952$var$getFiltroFundacao } = (0, $hmmUY.fundacaoService)();
const { getChoicesActive: $831264e03f8f8952$var$getChoicesActive } = GLOBAL;
var $831264e03f8f8952$export$2e2bcd8739ae039 = {
    props: [
        'emailEnviadoSelecionado'
    ],
    emits: [
        'fechar-modal-envio'
    ],
    components: {
        SelectMultiple: $7h4Zs.default,
        FiltroEmail: $eayks.default
    },
    data () {
        return {
            modelFiltros: {
                fundo: [],
                tag: [],
                tempoSenAtendimentoRapido: null
            },
            readonlyMode: false,
            btnFiltro: null,
            dialogFiltros: false,
            quill: null,
            corpo_email: '',
            fundacoesList: [],
            templates: [],
            templateSelecionado: '',
            assunto: '',
            filtros: {
                fundo: [],
                tag: [],
                tempoSenAtendimentoRapido: null
            },
            fundoOption: [],
            tagOption: [],
            tempoSenAtendimentoRapidoOption: [
                {
                    label: '1 a 3 meses',
                    value: '1,3'
                },
                {
                    label: '4 a 6 meses',
                    value: '4,6'
                },
                {
                    label: 'Mais de 6 meses',
                    value: '6,1000'
                }
            ],
            loading: {
                enviarEmail: false
            }
        };
    },
    watch: {
        emailEnviadoSelecionado (newVal) {
            if (newVal) {
                // Preenche selects e inputs
                this.assunto = newVal.assunto;
                this.templateSelecionado = newVal.template_id?.toString() || '';
                this.$nextTick(()=>{
                    // Fundacao
                    const selectFundacoes = $831264e03f8f8952$var$getChoicesActive('email_fundacao', window.listOfChoices);
                    selectFundacoes?.setChoiceByValue([
                        newVal.envinhado_para_id
                    ]);
                    // Template
                    const selectModelos = $831264e03f8f8952$var$getChoicesActive('email_modelo', window.listOfChoices);
                    selectModelos?.setChoiceByValue(newVal.template_id);
                    // Corpo do email
                    if (this.quill) {
                        this.setDeltaToQuillByContent(newVal.corpo_alterado || newVal.corpo);
                        this.quill.enable(false);
                    }
                    // Desabilita selects e input
                    selectFundacoes?.disable();
                    selectModelos?.disable();
                });
                this.readonlyMode = true;
            } else {
                // Habilita edição novamente
                this.readonlyMode = false;
                this.$nextTick(()=>{
                    const selectFundacoes = $831264e03f8f8952$var$getChoicesActive('email_fundacao', window.listOfChoices);
                    const selectModelos = $831264e03f8f8952$var$getChoicesActive('email_modelo', window.listOfChoices);
                    selectFundacoes?.enable();
                    selectModelos?.enable();
                    if (this.quill) this.quill.enable(true);
                });
            }
        },
        templateSelecionado () {
            const template = this.templates.find((t)=>t.id_template === parseInt(this.templateSelecionado));
            if (template) {
                this.assunto = template.assunto;
                this.$nextTick(()=>{
                    if (this.quill) this.setDeltaToQuillByContent(template.corpo);
                });
            } else {
                this.assunto = '';
                this.$nextTick(()=>{
                    if (this.quill) this.clearEditor();
                });
            }
        }
    },
    computed: {
        tituloHeaderModal () {
            return this.readonlyMode ? 'E-mail Cliente' : 'Criar novo E-mail';
        }
    },
    methods: {
        abrirMenuFiltros () {
            this.$nextTick(()=>{
                this.menuOpen = true;
                if (this.$refs.btnFiltro) console.warn("Ref do bot\xe3o Filtros est\xe1 perdido!");
            });
        },
        fecharMenuFiltros () {
            this.menuOpen = false;
        },
        async initSelectFiltros () {
            const listaFiltroFundacao = await $831264e03f8f8952$var$getFiltroFundacao();
            this.fundoOption = listaFiltroFundacao?.fundos?.map((item)=>({
                    value: item[1],
                    label: item[1]
                }));
            this.tagOption = listaFiltroFundacao?.tags?.map((item)=>({
                    value: item[0],
                    label: item[1]
                }));
        // Popula Choices.js dos filtros se necessário
        },
        async getFundacoesFiltroQuery (campo) {
            const paramsUrl = new URLSearchParams();
            if (campo !== 'tempo' && campo !== 'all' && this.filtros[campo]) paramsUrl.append(campo, this.filtros[campo].map((itemFiltro)=>itemFiltro.value).join(','));
            if (this.filtros.tempoSenAtendimentoRapido) paramsUrl.append('meses_sem_atendimento', this.filtros.tempoSenAtendimentoRapido);
            const queryFiltroFundacao = paramsUrl.size > 0 ? `?${paramsUrl.toString()}` : '';
            return await $831264e03f8f8952$var$getFundacoesContatos(queryFiltroFundacao);
        },
        async getInfoFundacoesFiltro () {
            let responseFundacoesFundo = [];
            let responseFundacoesTag = [];
            let responseFundacoesTempo = [];
            let fundacoesUnificado = [];
            if (this.filtros.fundo && this.filtros.fundo.length > 0) responseFundacoesFundo = await this.getFundacoesFiltroQuery('fundo');
            if (this.filtros.tag && this.filtros.tag.length > 0) responseFundacoesTag = await this.getFundacoesFiltroQuery('tag');
            if (this.filtros.tempoSenAtendimentoRapido) responseFundacoesTempo = await this.getFundacoesFiltroQuery('tempo');
            const temFiltroFundo = this.filtros.fundo && this.filtros.fundo.length > 0;
            const temFiltroTag = this.filtros.tag && this.filtros.tag.length > 0;
            const temFiltroTempo = this.filtros.tempoSenAtendimentoRapido;
            if (!temFiltroFundo && !temFiltroTag && !temFiltroTempo) fundacoesUnificado = await this.getFundacoesFiltroQuery('all');
            else {
                let resultadosCombinados = [];
                if (temFiltroFundo) resultadosCombinados = resultadosCombinados.concat(responseFundacoesFundo);
                if (temFiltroTag) resultadosCombinados = resultadosCombinados.concat(responseFundacoesTag);
                if (temFiltroTempo) resultadosCombinados = resultadosCombinados.concat(responseFundacoesTempo);
                fundacoesUnificado = resultadosCombinados;
            }
            this.fundacoesList = fundacoesUnificado;
            this.initSelectFundacoes();
        },
        initSelectFundacoes () {
            const opcoes = this.fundacoesList?.map((f)=>({
                    value: f.id_fundacao,
                    label: f.sigla_fundacao
                }));
            const selectFundacoes = $831264e03f8f8952$var$getChoicesActive('email_fundacao', window.listOfChoices);
            selectFundacoes?.clearChoices();
            selectFundacoes?.setChoices([
                {
                    value: '',
                    label: 'Selecione'
                },
                ...opcoes
            ]);
        },
        initSelectModelos () {
            const opcoes = this.templates?.map((t)=>({
                    value: t.id_template,
                    label: t.assunto
                }));
            const selectModelos = $831264e03f8f8952$var$getChoicesActive('email_modelo', window.listOfChoices);
            selectModelos?.clearChoices();
            selectModelos?.setChoices([
                {
                    value: '',
                    label: 'Selecione'
                },
                ...opcoes
            ]);
            // Adiciona evento para atualizar templateSelecionado ao mudar o select
            const selectElement = selectModelos.passedElement.element;
            selectElement.removeEventListener('change', this.handleModeloChange);
            selectElement.addEventListener('change', this.handleModeloChange);
        },
        handleModeloChange (e) {
            this.templateSelecionado = e.target.value;
        },
        initQuillEditor () {
            this.quill = new (0, $67nR7.default)(this.$refs.editor, {
                theme: 'snow',
                modules: {
                    toolbar: [
                        [
                            {
                                header: [
                                    1,
                                    2,
                                    false
                                ]
                            }
                        ],
                        [
                            'bold',
                            'italic',
                            'underline'
                        ],
                        [
                            {
                                list: 'ordered'
                            },
                            {
                                list: 'bullet'
                            }
                        ],
                        [
                            {
                                color: []
                            },
                            {
                                background: []
                            }
                        ],
                        [
                            'clean',
                            'image'
                        ]
                    ]
                }
            });
            this.quill.on('text-change', ()=>{
                this.corpo_email = this.quill.root.innerHTML;
            });
        },
        setDeltaToQuillByContent (content) {
            // Limpa o editor antes de inserir novo conteúdo
            this.quill.setText('', 'silent');
            this.$nextTick(()=>{
                // Insere o HTML diretamente no editor
                this.quill.root.innerHTML = content || '';
                // Atualiza o corpo_email para manter sincronizado
                this.corpo_email = this.quill.root.innerHTML;
            });
        },
        clearEditor () {
            this.quill.setText('', 'silent');
            this.$nextTick(()=>{
                this.quill.root.innerHTML = '';
                this.corpo_email = '';
            });
        },
        async aplicarFiltrosFundacao (filtros) {
            const paramsUrl = new URLSearchParams();
            if (filtros.fundo && filtros.fundo.length > 0) paramsUrl.append('fundo', filtros.fundo.map((item)=>item.value).join(','));
            if (filtros.tag && filtros.tag.length > 0) paramsUrl.append('tag', filtros.tag.map((item)=>item.value).join(','));
            if (filtros.tempoSenAtendimentoRapido) paramsUrl.append('meses_sem_atendimento', filtros.tempoSenAtendimentoRapido);
            const query = paramsUrl.size > 0 ? `?${paramsUrl.toString()}` : '';
            // Busca as fundações filtradas
            this.fundacoesList = await $831264e03f8f8952$var$getFundacoesContatos(query);
            this.initSelectFundacoes();
            this.limparCamposEnvioEmail();
        },
        async limparFiltrosEmail () {
            this.modelFiltros = {
                fundo: [],
                tag: [],
                tempoSenAtendimentoRapido: null
            };
            this.limparCamposEnvioEmail();
            this.fundacoesList = await $831264e03f8f8952$var$getFundacoesContatos();
            this.initSelectFundacoes();
        },
        limparCamposEnvioEmail () {
            // Limpa selects
            const selectFundacoes = $831264e03f8f8952$var$getChoicesActive('email_fundacao', window.listOfChoices);
            const selectModelos = $831264e03f8f8952$var$getChoicesActive('email_modelo', window.listOfChoices);
            selectFundacoes?.removeActiveItems();
            selectModelos?.removeActiveItems();
            // Limpa inputs
            this.assunto = '';
            this.templateSelecionado = '';
            // Limpa editor
            this.clearEditor();
        },
        filtrarFundacoesValid () {
            const selectFundacoes = $831264e03f8f8952$var$getChoicesActive('email_fundacao', window.listOfChoices);
            return selectFundacoes.getValue(true).filter((id)=>id !== '').map(Number);
        },
        fecharModalEmailEnvio () {
            modal_padrao_vue.closeModal('email_envio_template');
            this.limparFiltrosEmail();
            this.readonlyMode = false;
            this.$emit('fechar-modal-envio');
        },
        async enviarEmailFundacao () {
            this.loading.enviarEmail = true;
            const fundacoesFiltrado = this.filtrarFundacoesValid();
            let assinatura = '';
            const usuarioAtual = GLOBAL.usuario.nome;
            if (usuarioAtual.toLowerCase() === 'ismael') assinatura = (0, $3Zw81.assinaturaTemplateEmailIsmael);
            else if (usuarioAtual.toLowerCase() === 'matheus') assinatura = (0, $3Zw81.assinaturaTemplateEmailMatheus);
            else assinatura = (0, $3Zw81.assinaturaTemplateEmailFundacao);
            const corpoFinal = this.corpo_email + '<br/>' + assinatura;
            const data = {
                template_id: this.templateSelecionado,
                clientes_ids: fundacoesFiltrado,
                assunto: this.assunto,
                corpo: corpoFinal
            };
            if (!fundacoesFiltrado.length || !this.assunto || !this.corpo_email) {
                GLOBAL.showToastify("\u26A0\uFE0F Preencha todos os campos obrigat\xf3rios.");
                return;
            }
            try {
                await (0, $kxhz7.emailFundacaoService)().sendEmail(data);
                GLOBAL.showToastify("\u2705 Email enviado com sucesso.");
                this.limparCamposEnvioEmail();
                window.location.reload();
            // Se necessário, atualize a tabela de emails aqui
            } catch (err) {
                GLOBAL.showToastify("\u274C Erro ao enviar email.");
            } finally{
                this.loading.enviarEmail = false;
            }
        }
    },
    async mounted () {
        this.initQuillEditor();
        this.fundacoesList = await $831264e03f8f8952$var$getFundacoesContatos();
        this.templates = (await $831264e03f8f8952$var$getTemplatesEmail())?.results || [];
        await this.initSelectFiltros();
        this.initSelectFundacoes();
        this.initSelectModelos();
    },
    template: `
         <section
            class="modal--content rounded-md flex-1 w-full !h-max overflow-[initial] relative"
            data-id="email_envio_template">
            <div class="w-full">
                <div
                    class="flex flex-col gap-32 mb-16 md2:mb-0 !mx-auto">
					<header class="flex items-center justify-between w-full px-24 pt-24 pb-16 bg-primary-pure">
						 <h2 class="text-lg font-medium text-white">{{ tituloHeaderModal }}</h2>
						<button 
							type="button" 
							class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
							@click="fecharModalEmailEnvio">
							<svg class="w-32 h-32">
								<use xlink:href="#icon_close"></use>
							</svg>
						</button>
					</header>

                    <div class="flex items-center gap-8 px-24">
						<q-btn 
							v-if="!readonlyMode"
							label="Filtros" 
							color="primary" 
							icon="filter_alt" 
							class="btn !h-48 ml-auto !px-8 py-4">
							<q-menu
								:anchor="anchor"
								:self="self"
								:offset="[0, 10]"
								transition-show="jump-down"
								transition-hide="jump-up"
							>
								<div class="min-w-[300px] max-w-[400px]">

									<filtro-email 
										:model-value="modelFiltros"
										@update:modelValue="modelFiltros = $event"
										@aplicar-filtros="aplicarFiltrosFundacao(modelFiltros)"
										@limpar-filtros="limparFiltrosEmail()"
									>
									</filtro-email>

								</div>
							</q-menu>
						</q-btn>
                    </div>
                    <div class="w-full max-h-[600px] overflow-y-scroll px-24">
                        <form @submit.prevent="enviarEmailFundacao" class="flex gap-16 flex-col">
                            <div class="flex flex-col">
                                <label class="font-semibold label">Funda\xe7\xf5es</label>
                                <div class="h-48 select-container select-multiplo">
                                    <select
                                        js-choices
                                        name="email_fundacao"
                                        id="email_fundacao"
                                        multiple
                                        js-choices-props='{ "searchEnabled": true, "searchChoices": true,  "removeItems": true, "removeItemButton": true}'></select>
                                </div>
                            </div>

                            <div class="flex flex-col">
                                <label class="font-semibold label">Modelo</label>
                                <div class="h-48 select-container">
                                    <select
                                        js-choices
                                        name="email_modelo"
                                        id="email_modelo"
                                        js-choices-props='{ "searchEnabled": true, "searchChoices": true,  "removeItems": true, "removeItemButton": true}'></select>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-semibold label">Assunto</label>
                                <input
                                    v-model="assunto"
                                    name="email_assunto"
                                    class="h-48 input-text"
                                    js-ativo
                                    type="text"
                                    required
									:readonly="readonlyMode" />
                            </div>
                            <div class="flex flex-col">
                                <label class="font-semibold label">Corpo do e-mail</label>
                                <div ref="editor"></div>
                            </div>
                            <div v-if="!readonlyMode" class="w-full flex justify-end items-center">
                                <button v-if="false" class="h-48 btn" type="submit">Enviar email</button>
                                <q-btn  :loading="loading.enviarEmail" class="h-48 btn" type="submit">Enviar email</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

			
			
        </section>
    `
};

});
parcelRegister("kxhz7", function(module, exports) {

$parcel$export(module.exports, "emailFundacaoService", function () { return $ef3483d2261ecb3b$export$a9311c26a60d4d4d; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $ef3483d2261ecb3b$export$a9311c26a60d4d4d() {
    const api = (0, $c8Lpu.useApi)();
    async function getTemplatesEmail(query = '?=') {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).email_templates}${query}`);
    }
    async function getFundacoesContatos(query = '?=') {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).fundacao_contatos}${query}`);
    }
    async function sendEmail(data, query = '?=') {
        return api.mutation(`${window.origin}${(0, $9YhWF.URLS).send_email}${query}`, 'post', data);
    }
    async function getEmailEnvinhado(id, query = '') {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).email_enviados}${id}/${query}`);
    }
    async function getFiltrosFundacaoEmail(query = '?=') {}
    return {
        getTemplatesEmail: getTemplatesEmail,
        getFundacoesContatos: getFundacoesContatos,
        sendEmail: sendEmail,
        getEmailEnvinhado: getEmailEnvinhado,
        ...api
    };
}

});

parcelRegister("7h4Zs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54bdfde885e4b527$export$2e2bcd8739ae039; });
parcelRequire("2l7AP");
var $54bdfde885e4b527$export$2e2bcd8739ae039 = {
    props: {
        model: Array,
        options: Array,
        label: String,
        submitfc: Function,
        menuOffset: Array,
        badgeColor: {
            type: String,
            default: 'primary'
        },
        menuProps: {
            type: Object,
            default: ()=>({})
        }
    },
    emmits: [
        'changed'
    ],
    data () {
        return {
            valueShown: Object,
            optionsList: Array,
            stringOptions: String,
            initialModel: this.model,
            changed: false
        };
    },
    methods: {
        updateValueShown (arr) {
            if (!arr) return;
            this.emitEventChange(arr);
            if (arr?.length == 0) return this.valueShown = {};
            const active = arr[0]?.label;
            const qnt = arr?.length - 2;
            const active2 = arr[1]?.label;
            this.valueShown = {
                active: active,
                qnt: qnt,
                active2: active2
            };
        },
        emitEventChange (value) {
            this.$emit('changed', value);
        },
        filterFn (val, update, options) {
            if (val === '') return update(()=>{
                this.optionsList = options;
            });
            update(()=>{
                const needle = val.toLowerCase();
                this.optionsList = options.filter((v)=>v.label.toLowerCase().indexOf(needle) > -1);
            });
        },
        clearOptions () {
            while(this.model.length)this.model.pop();
            this.changed = true;
            this.valueShown = {};
        },
        selectAllOptions () {
            let selectedList = [];
            this.optionsList.forEach((opt)=>{
                this.model.push(opt);
                selectedList.push(opt);
            });
            this.changed = true;
            this.valueShown = {
                active: this.model[0].label,
                active2: this.model[1]?.label,
                qnt: this.model.length - 1
            };
        },
        handleCloseDialog () {
            const initial = this.initialModel ? this.initialModel.map((obj)=>obj?.value).join(', ') : '';
            const current = this.model ? this.model.map((obj)=>obj.value).join(', ') : '';
            if (initial !== current || this.changed) this.submitfc();
        }
    },
    watch: {
        model: {
            handler (value) {
                this.updateValueShown(value);
            },
            deep: true
        }
    },
    mounted () {
        this.updateValueShown(this.model);
    },
    template: html`
		<q-select
			:outlined="true"
			multiple
			dense
			use-input
			v-model="model"
			behavior="menu"
			:menu-offset="menuOffset"
			:label="label"
			:options="optionsList"
			:menu-props="menuProps"
			@filter="(val, update) => filterFn(val, update, options)"
			@update:model-value="(value) => updateValueShown(value)"
			@popup-hide="handleCloseDialog">
			<template v-slot:option="{ itemProps, opt, selected, toggleOption }">
				<q-item v-bind="itemProps">
					<q-item-section>
						<q-item-label> {{ opt.label }} </q-item-label>
					</q-item-section>

					<q-item-section side>
						<q-toggle
							:model-value="selected"
							:color="badgeColor"
							@update:model-value="toggleOption(opt)"></q-toggle>
					</q-item-section>
				</q-item>
			</template>

			<template v-slot:selected>
				<div class="flex gap-8 flex-wrap">
					<q-badge
						v-if="valueShown.active"
						rounded
						class="p-8"
						:color="badgeColor"
						outline
						:label=" valueShown.active" />
					<q-badge
						v-if="valueShown.active2"
						rounded
						class="p-8"
						:color="badgeColor"
						outline
						:label=" valueShown.active2" />
					<q-chip v-if="valueShown.qnt >= 1">+{{ valueShown.qnt }}</q-chip>
				</div>

				<!-- 	<q-btn
					:class="{ '!opacity-100': model.length }"
					class="!right-[9.5rem]"
					color="primary"
					label="Limpar"
					@click="clearOptions" /> -->
			</template>
		</q-select>
	`
};

});
parcelRegister("2l7AP", function(module, exports) {
/*
 * While in local development, make sure you've run `npm run build` first.
 */ 
var $5Xj7l = parcelRequire("5Xj7l");
var $9dfbacbd5bd8bd2b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5Xj7l))).default;

});
parcelRegister("5Xj7l", function(module, exports) {

var $bNDrn = parcelRequire("bNDrn");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestartProcess = module.exports.LogTimings = module.exports.LogOutput = module.exports.Logger = module.exports.LogExit = module.exports.LogError = module.exports.KillOthers = module.exports.KillOnSignal = module.exports.InputHandler = module.exports.concurrently = module.exports.Command = void 0;

var $b27q8 = parcelRequire("b27q8");
Object.defineProperty(module.exports, "Command", {
    enumerable: true,
    get: function() {
        return $b27q8.Command;
    }
});

var $eYU9f = parcelRequire("eYU9f");
Object.defineProperty(module.exports, "concurrently", {
    enumerable: true,
    get: function() {
        return $eYU9f.concurrently;
    }
});

var $bNJZn = parcelRequire("bNJZn");
Object.defineProperty(module.exports, "InputHandler", {
    enumerable: true,
    get: function() {
        return $bNJZn.InputHandler;
    }
});

var $9XkYi = parcelRequire("9XkYi");
Object.defineProperty(module.exports, "KillOnSignal", {
    enumerable: true,
    get: function() {
        return $9XkYi.KillOnSignal;
    }
});

var $18X8B = parcelRequire("18X8B");
Object.defineProperty(module.exports, "KillOthers", {
    enumerable: true,
    get: function() {
        return $18X8B.KillOthers;
    }
});

var $3lRsA = parcelRequire("3lRsA");
Object.defineProperty(module.exports, "LogError", {
    enumerable: true,
    get: function() {
        return $3lRsA.LogError;
    }
});

var $4CdUI = parcelRequire("4CdUI");
Object.defineProperty(module.exports, "LogExit", {
    enumerable: true,
    get: function() {
        return $4CdUI.LogExit;
    }
});

var $8Urwk = parcelRequire("8Urwk");
Object.defineProperty(module.exports, "LogOutput", {
    enumerable: true,
    get: function() {
        return $8Urwk.LogOutput;
    }
});

var $5by7l = parcelRequire("5by7l");
Object.defineProperty(module.exports, "LogTimings", {
    enumerable: true,
    get: function() {
        return $5by7l.LogTimings;
    }
});

var $i9kaL = parcelRequire("i9kaL");
Object.defineProperty(module.exports, "RestartProcess", {
    enumerable: true,
    get: function() {
        return $i9kaL.RestartProcess;
    }
});

var $l7Xin = parcelRequire("l7Xin");
Object.defineProperty(module.exports, "Logger", {
    enumerable: true,
    get: function() {
        return $l7Xin.Logger;
    }
});
module.exports.default = (commands, options = {})=>{
    const logger = new $l7Xin.Logger({
        hide: options.hide,
        prefixFormat: options.prefix,
        prefixLength: options.prefixLength,
        raw: options.raw,
        timestampFormat: options.timestampFormat
    });
    return (0, $eYU9f.concurrently)(commands, {
        maxProcesses: options.maxProcesses,
        raw: options.raw,
        successCondition: options.successCondition,
        cwd: options.cwd,
        logger: logger,
        outputStream: options.outputStream || $bNDrn.stdout,
        group: options.group,
        controllers: [
            new $3lRsA.LogError({
                logger: logger
            }),
            new $8Urwk.LogOutput({
                logger: logger
            }),
            new $4CdUI.LogExit({
                logger: logger
            }),
            new $bNJZn.InputHandler({
                logger: logger,
                defaultInputTarget: options.defaultInputTarget,
                inputStream: options.inputStream || (options.handleInput ? $bNDrn.stdin : undefined),
                pauseInputStreamOnFinish: options.pauseInputStreamOnFinish
            }),
            new $9XkYi.KillOnSignal({
                process: process
            }),
            new $i9kaL.RestartProcess({
                logger: logger,
                delay: options.restartDelay,
                tries: options.restartTries
            }),
            new $18X8B.KillOthers({
                logger: logger,
                conditions: options.killOthers || []
            }),
            new $5by7l.LogTimings({
                logger: options.timings ? logger : undefined,
                timestampFormat: options.timestampFormat
            })
        ],
        prefixColors: options.prefixColors || [],
        additionalArguments: options.additionalArguments
    });
};

});
parcelRegister("bNDrn", function(module, exports) {
// shim for using process in browser
var $8972dd6366fe5fef$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8972dd6366fe5fef$var$cachedSetTimeout;
var $8972dd6366fe5fef$var$cachedClearTimeout;
function $8972dd6366fe5fef$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $8972dd6366fe5fef$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $8972dd6366fe5fef$var$cachedSetTimeout = setTimeout;
        else $8972dd6366fe5fef$var$cachedSetTimeout = $8972dd6366fe5fef$var$defaultSetTimout;
    } catch (e) {
        $8972dd6366fe5fef$var$cachedSetTimeout = $8972dd6366fe5fef$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $8972dd6366fe5fef$var$cachedClearTimeout = clearTimeout;
        else $8972dd6366fe5fef$var$cachedClearTimeout = $8972dd6366fe5fef$var$defaultClearTimeout;
    } catch (e) {
        $8972dd6366fe5fef$var$cachedClearTimeout = $8972dd6366fe5fef$var$defaultClearTimeout;
    }
})();
function $8972dd6366fe5fef$var$runTimeout(fun) {
    if ($8972dd6366fe5fef$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8972dd6366fe5fef$var$cachedSetTimeout === $8972dd6366fe5fef$var$defaultSetTimout || !$8972dd6366fe5fef$var$cachedSetTimeout) && setTimeout) {
        $8972dd6366fe5fef$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8972dd6366fe5fef$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8972dd6366fe5fef$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8972dd6366fe5fef$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8972dd6366fe5fef$var$runClearTimeout(marker) {
    if ($8972dd6366fe5fef$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8972dd6366fe5fef$var$cachedClearTimeout === $8972dd6366fe5fef$var$defaultClearTimeout || !$8972dd6366fe5fef$var$cachedClearTimeout) && clearTimeout) {
        $8972dd6366fe5fef$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8972dd6366fe5fef$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8972dd6366fe5fef$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8972dd6366fe5fef$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8972dd6366fe5fef$var$queue = [];
var $8972dd6366fe5fef$var$draining = false;
var $8972dd6366fe5fef$var$currentQueue;
var $8972dd6366fe5fef$var$queueIndex = -1;
function $8972dd6366fe5fef$var$cleanUpNextTick() {
    if (!$8972dd6366fe5fef$var$draining || !$8972dd6366fe5fef$var$currentQueue) return;
    $8972dd6366fe5fef$var$draining = false;
    if ($8972dd6366fe5fef$var$currentQueue.length) $8972dd6366fe5fef$var$queue = $8972dd6366fe5fef$var$currentQueue.concat($8972dd6366fe5fef$var$queue);
    else $8972dd6366fe5fef$var$queueIndex = -1;
    if ($8972dd6366fe5fef$var$queue.length) $8972dd6366fe5fef$var$drainQueue();
}
function $8972dd6366fe5fef$var$drainQueue() {
    if ($8972dd6366fe5fef$var$draining) return;
    var timeout = $8972dd6366fe5fef$var$runTimeout($8972dd6366fe5fef$var$cleanUpNextTick);
    $8972dd6366fe5fef$var$draining = true;
    var len = $8972dd6366fe5fef$var$queue.length;
    while(len){
        $8972dd6366fe5fef$var$currentQueue = $8972dd6366fe5fef$var$queue;
        $8972dd6366fe5fef$var$queue = [];
        while(++$8972dd6366fe5fef$var$queueIndex < len)if ($8972dd6366fe5fef$var$currentQueue) $8972dd6366fe5fef$var$currentQueue[$8972dd6366fe5fef$var$queueIndex].run();
        $8972dd6366fe5fef$var$queueIndex = -1;
        len = $8972dd6366fe5fef$var$queue.length;
    }
    $8972dd6366fe5fef$var$currentQueue = null;
    $8972dd6366fe5fef$var$draining = false;
    $8972dd6366fe5fef$var$runClearTimeout(timeout);
}
$8972dd6366fe5fef$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8972dd6366fe5fef$var$queue.push(new $8972dd6366fe5fef$var$Item(fun, args));
    if ($8972dd6366fe5fef$var$queue.length === 1 && !$8972dd6366fe5fef$var$draining) $8972dd6366fe5fef$var$runTimeout($8972dd6366fe5fef$var$drainQueue);
};
// v8 likes predictible objects
function $8972dd6366fe5fef$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8972dd6366fe5fef$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8972dd6366fe5fef$var$process.title = 'browser';
$8972dd6366fe5fef$var$process.browser = true;
$8972dd6366fe5fef$var$process.env = {};
$8972dd6366fe5fef$var$process.argv = [];
$8972dd6366fe5fef$var$process.version = ''; // empty string to avoid regexp issues
$8972dd6366fe5fef$var$process.versions = {};
function $8972dd6366fe5fef$var$noop() {}
$8972dd6366fe5fef$var$process.on = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.addListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.once = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.off = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.removeListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.removeAllListeners = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.emit = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.prependListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.prependOnceListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.listeners = function(name) {
    return [];
};
$8972dd6366fe5fef$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$8972dd6366fe5fef$var$process.cwd = function() {
    return '/';
};
$8972dd6366fe5fef$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$8972dd6366fe5fef$var$process.umask = function() {
    return 0;
};

});

parcelRegister("b27q8", function(module, exports) {

var $bNDrn = parcelRequire("bNDrn");
"use strict";
var $8085a32b83bb31cb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8085a32b83bb31cb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8085a32b83bb31cb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8085a32b83bb31cb$var$__createBinding(result, mod, k);
    }
    $8085a32b83bb31cb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Command = void 0;

const $8085a32b83bb31cb$var$Rx = $8085a32b83bb31cb$var$__importStar((parcelRequire("7fhTn")));
class $8085a32b83bb31cb$var$Command {
    /** @deprecated */ get killable() {
        return $8085a32b83bb31cb$var$Command.canKill(this);
    }
    constructor({ index: index, name: name, command: command, prefixColor: prefixColor, env: env, cwd: cwd }, spawnOpts, spawn, killProcess){
        this.close = new $8085a32b83bb31cb$var$Rx.Subject();
        this.error = new $8085a32b83bb31cb$var$Rx.Subject();
        this.stdout = new $8085a32b83bb31cb$var$Rx.Subject();
        this.stderr = new $8085a32b83bb31cb$var$Rx.Subject();
        this.timer = new $8085a32b83bb31cb$var$Rx.Subject();
        this.killed = false;
        this.exited = false;
        this.index = index;
        this.name = name;
        this.command = command;
        this.prefixColor = prefixColor;
        this.env = env || {};
        this.cwd = cwd;
        this.killProcess = killProcess;
        this.spawn = spawn;
        this.spawnOpts = spawnOpts;
    }
    /**
     * Starts this command, piping output, error and close events onto the corresponding observables.
     */ start() {
        const child = this.spawn(this.command, this.spawnOpts);
        this.process = child;
        this.pid = child.pid;
        const startDate = new Date(Date.now());
        const highResStartTime = $bNDrn.hrtime();
        this.timer.next({
            startDate: startDate
        });
        $8085a32b83bb31cb$var$Rx.fromEvent(child, 'error').subscribe((event)=>{
            this.process = undefined;
            const endDate = new Date(Date.now());
            this.timer.next({
                startDate: startDate,
                endDate: endDate
            });
            this.error.next(event);
        });
        $8085a32b83bb31cb$var$Rx.fromEvent(child, 'close').subscribe(([exitCode, signal])=>{
            this.process = undefined;
            this.exited = true;
            const endDate = new Date(Date.now());
            this.timer.next({
                startDate: startDate,
                endDate: endDate
            });
            const [durationSeconds, durationNanoSeconds] = $bNDrn.hrtime(highResStartTime);
            this.close.next({
                command: this,
                index: this.index,
                exitCode: exitCode !== null && exitCode !== void 0 ? exitCode : String(signal),
                killed: this.killed,
                timings: {
                    startDate: startDate,
                    endDate: endDate,
                    durationSeconds: durationSeconds + durationNanoSeconds / 1e9
                }
            });
        });
        child.stdout && $8085a32b83bb31cb$var$pipeTo($8085a32b83bb31cb$var$Rx.fromEvent(child.stdout, 'data'), this.stdout);
        child.stderr && $8085a32b83bb31cb$var$pipeTo($8085a32b83bb31cb$var$Rx.fromEvent(child.stderr, 'data'), this.stderr);
        this.stdin = child.stdin || undefined;
    }
    /**
     * Kills this command, optionally specifying a signal to send to it.
     */ kill(code) {
        if ($8085a32b83bb31cb$var$Command.canKill(this)) {
            this.killed = true;
            this.killProcess(this.pid, code);
        }
    }
    /**
     * Detects whether a command can be killed.
     *
     * Also works as a type guard on the input `command`.
     */ static canKill(command) {
        return !!command.pid && !!command.process;
    }
}
module.exports.Command = $8085a32b83bb31cb$var$Command;
/**
 * Pipes all events emitted by `stream` into `subject`.
 */ function $8085a32b83bb31cb$var$pipeTo(stream, subject) {
    stream.subscribe((event)=>subject.next(event));
}

});
parcelRegister("7fhTn", function(module, exports) {
"use strict";
var $5467d0265db2cc61$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5467d0265db2cc61$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5467d0265db2cc61$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interval = module.exports.iif = module.exports.generate = module.exports.fromEventPattern = module.exports.fromEvent = module.exports.from = module.exports.forkJoin = module.exports.empty = module.exports.defer = module.exports.connectable = module.exports.concat = module.exports.combineLatest = module.exports.bindNodeCallback = module.exports.bindCallback = module.exports.UnsubscriptionError = module.exports.TimeoutError = module.exports.SequenceError = module.exports.ObjectUnsubscribedError = module.exports.NotFoundError = module.exports.EmptyError = module.exports.ArgumentOutOfRangeError = module.exports.firstValueFrom = module.exports.lastValueFrom = module.exports.isObservable = module.exports.identity = module.exports.noop = module.exports.pipe = module.exports.NotificationKind = module.exports.Notification = module.exports.Subscriber = module.exports.Subscription = module.exports.Scheduler = module.exports.VirtualAction = module.exports.VirtualTimeScheduler = module.exports.animationFrameScheduler = module.exports.animationFrame = module.exports.queueScheduler = module.exports.queue = module.exports.asyncScheduler = module.exports.async = module.exports.asapScheduler = module.exports.asap = module.exports.AsyncSubject = module.exports.ReplaySubject = module.exports.BehaviorSubject = module.exports.Subject = module.exports.animationFrames = module.exports.observable = module.exports.ConnectableObservable = module.exports.Observable = void 0;
module.exports.filter = module.exports.expand = module.exports.exhaustMap = module.exports.exhaustAll = module.exports.exhaust = module.exports.every = module.exports.endWith = module.exports.elementAt = module.exports.distinctUntilKeyChanged = module.exports.distinctUntilChanged = module.exports.distinct = module.exports.dematerialize = module.exports.delayWhen = module.exports.delay = module.exports.defaultIfEmpty = module.exports.debounceTime = module.exports.debounce = module.exports.count = module.exports.connect = module.exports.concatWith = module.exports.concatMapTo = module.exports.concatMap = module.exports.concatAll = module.exports.combineLatestWith = module.exports.combineLatestAll = module.exports.combineAll = module.exports.catchError = module.exports.bufferWhen = module.exports.bufferToggle = module.exports.bufferTime = module.exports.bufferCount = module.exports.buffer = module.exports.auditTime = module.exports.audit = module.exports.config = module.exports.NEVER = module.exports.EMPTY = module.exports.scheduled = module.exports.zip = module.exports.using = module.exports.timer = module.exports.throwError = module.exports.range = module.exports.race = module.exports.partition = module.exports.pairs = module.exports.onErrorResumeNext = module.exports.of = module.exports.never = module.exports.merge = void 0;
module.exports.switchMap = module.exports.switchAll = module.exports.subscribeOn = module.exports.startWith = module.exports.skipWhile = module.exports.skipUntil = module.exports.skipLast = module.exports.skip = module.exports.single = module.exports.shareReplay = module.exports.share = module.exports.sequenceEqual = module.exports.scan = module.exports.sampleTime = module.exports.sample = module.exports.refCount = module.exports.retryWhen = module.exports.retry = module.exports.repeatWhen = module.exports.repeat = module.exports.reduce = module.exports.raceWith = module.exports.publishReplay = module.exports.publishLast = module.exports.publishBehavior = module.exports.publish = module.exports.pluck = module.exports.pairwise = module.exports.onErrorResumeNextWith = module.exports.observeOn = module.exports.multicast = module.exports.min = module.exports.mergeWith = module.exports.mergeScan = module.exports.mergeMapTo = module.exports.mergeMap = module.exports.flatMap = module.exports.mergeAll = module.exports.max = module.exports.materialize = module.exports.mapTo = module.exports.map = module.exports.last = module.exports.isEmpty = module.exports.ignoreElements = module.exports.groupBy = module.exports.first = module.exports.findIndex = module.exports.find = module.exports.finalize = void 0;
module.exports.zipWith = module.exports.zipAll = module.exports.withLatestFrom = module.exports.windowWhen = module.exports.windowToggle = module.exports.windowTime = module.exports.windowCount = module.exports.window = module.exports.toArray = module.exports.timestamp = module.exports.timeoutWith = module.exports.timeout = module.exports.timeInterval = module.exports.throwIfEmpty = module.exports.throttleTime = module.exports.throttle = module.exports.tap = module.exports.takeWhile = module.exports.takeUntil = module.exports.takeLast = module.exports.take = module.exports.switchScan = module.exports.switchMapTo = void 0;

var $879ii = parcelRequire("879ii");
Object.defineProperty(module.exports, "Observable", {
    enumerable: true,
    get: function() {
        return $879ii.Observable;
    }
});

var $hEwEw = parcelRequire("hEwEw");
Object.defineProperty(module.exports, "ConnectableObservable", {
    enumerable: true,
    get: function() {
        return $hEwEw.ConnectableObservable;
    }
});

var $I1Tai = parcelRequire("I1Tai");
Object.defineProperty(module.exports, "observable", {
    enumerable: true,
    get: function() {
        return $I1Tai.observable;
    }
});

var $jAywM = parcelRequire("jAywM");
Object.defineProperty(module.exports, "animationFrames", {
    enumerable: true,
    get: function() {
        return $jAywM.animationFrames;
    }
});

var $7qEr0 = parcelRequire("7qEr0");
Object.defineProperty(module.exports, "Subject", {
    enumerable: true,
    get: function() {
        return $7qEr0.Subject;
    }
});

var $i5kDY = parcelRequire("i5kDY");
Object.defineProperty(module.exports, "BehaviorSubject", {
    enumerable: true,
    get: function() {
        return $i5kDY.BehaviorSubject;
    }
});

var $jaL5r = parcelRequire("jaL5r");
Object.defineProperty(module.exports, "ReplaySubject", {
    enumerable: true,
    get: function() {
        return $jaL5r.ReplaySubject;
    }
});

var $kJoTA = parcelRequire("kJoTA");
Object.defineProperty(module.exports, "AsyncSubject", {
    enumerable: true,
    get: function() {
        return $kJoTA.AsyncSubject;
    }
});

var $EeTNx = parcelRequire("EeTNx");
Object.defineProperty(module.exports, "asap", {
    enumerable: true,
    get: function() {
        return $EeTNx.asap;
    }
});
Object.defineProperty(module.exports, "asapScheduler", {
    enumerable: true,
    get: function() {
        return $EeTNx.asapScheduler;
    }
});

var $iblpQ = parcelRequire("iblpQ");
Object.defineProperty(module.exports, "async", {
    enumerable: true,
    get: function() {
        return $iblpQ.async;
    }
});
Object.defineProperty(module.exports, "asyncScheduler", {
    enumerable: true,
    get: function() {
        return $iblpQ.asyncScheduler;
    }
});

var $cTlo5 = parcelRequire("cTlo5");
Object.defineProperty(module.exports, "queue", {
    enumerable: true,
    get: function() {
        return $cTlo5.queue;
    }
});
Object.defineProperty(module.exports, "queueScheduler", {
    enumerable: true,
    get: function() {
        return $cTlo5.queueScheduler;
    }
});

var $7By2u = parcelRequire("7By2u");
Object.defineProperty(module.exports, "animationFrame", {
    enumerable: true,
    get: function() {
        return $7By2u.animationFrame;
    }
});
Object.defineProperty(module.exports, "animationFrameScheduler", {
    enumerable: true,
    get: function() {
        return $7By2u.animationFrameScheduler;
    }
});

var $8BXqA = parcelRequire("8BXqA");
Object.defineProperty(module.exports, "VirtualTimeScheduler", {
    enumerable: true,
    get: function() {
        return $8BXqA.VirtualTimeScheduler;
    }
});
Object.defineProperty(module.exports, "VirtualAction", {
    enumerable: true,
    get: function() {
        return $8BXqA.VirtualAction;
    }
});

var $5pHsW = parcelRequire("5pHsW");
Object.defineProperty(module.exports, "Scheduler", {
    enumerable: true,
    get: function() {
        return $5pHsW.Scheduler;
    }
});

var $3NoDj = parcelRequire("3NoDj");
Object.defineProperty(module.exports, "Subscription", {
    enumerable: true,
    get: function() {
        return $3NoDj.Subscription;
    }
});

var $9btgx = parcelRequire("9btgx");
Object.defineProperty(module.exports, "Subscriber", {
    enumerable: true,
    get: function() {
        return $9btgx.Subscriber;
    }
});

var $luK57 = parcelRequire("luK57");
Object.defineProperty(module.exports, "Notification", {
    enumerable: true,
    get: function() {
        return $luK57.Notification;
    }
});
Object.defineProperty(module.exports, "NotificationKind", {
    enumerable: true,
    get: function() {
        return $luK57.NotificationKind;
    }
});

var $2LtHu = parcelRequire("2LtHu");
Object.defineProperty(module.exports, "pipe", {
    enumerable: true,
    get: function() {
        return $2LtHu.pipe;
    }
});

var $6UXs2 = parcelRequire("6UXs2");
Object.defineProperty(module.exports, "noop", {
    enumerable: true,
    get: function() {
        return $6UXs2.noop;
    }
});

var $doKTd = parcelRequire("doKTd");
Object.defineProperty(module.exports, "identity", {
    enumerable: true,
    get: function() {
        return $doKTd.identity;
    }
});

var $hDw7E = parcelRequire("hDw7E");
Object.defineProperty(module.exports, "isObservable", {
    enumerable: true,
    get: function() {
        return $hDw7E.isObservable;
    }
});

var $cjWvy = parcelRequire("cjWvy");
Object.defineProperty(module.exports, "lastValueFrom", {
    enumerable: true,
    get: function() {
        return $cjWvy.lastValueFrom;
    }
});

var $laJT3 = parcelRequire("laJT3");
Object.defineProperty(module.exports, "firstValueFrom", {
    enumerable: true,
    get: function() {
        return $laJT3.firstValueFrom;
    }
});

var $9y9D2 = parcelRequire("9y9D2");
Object.defineProperty(module.exports, "ArgumentOutOfRangeError", {
    enumerable: true,
    get: function() {
        return $9y9D2.ArgumentOutOfRangeError;
    }
});

var $k5xMc = parcelRequire("k5xMc");
Object.defineProperty(module.exports, "EmptyError", {
    enumerable: true,
    get: function() {
        return $k5xMc.EmptyError;
    }
});

var $fzrJl = parcelRequire("fzrJl");
Object.defineProperty(module.exports, "NotFoundError", {
    enumerable: true,
    get: function() {
        return $fzrJl.NotFoundError;
    }
});

var $fblAT = parcelRequire("fblAT");
Object.defineProperty(module.exports, "ObjectUnsubscribedError", {
    enumerable: true,
    get: function() {
        return $fblAT.ObjectUnsubscribedError;
    }
});

var $62noZ = parcelRequire("62noZ");
Object.defineProperty(module.exports, "SequenceError", {
    enumerable: true,
    get: function() {
        return $62noZ.SequenceError;
    }
});

var $5oCQ5 = parcelRequire("5oCQ5");
Object.defineProperty(module.exports, "TimeoutError", {
    enumerable: true,
    get: function() {
        return $5oCQ5.TimeoutError;
    }
});

var $4cbvs = parcelRequire("4cbvs");
Object.defineProperty(module.exports, "UnsubscriptionError", {
    enumerable: true,
    get: function() {
        return $4cbvs.UnsubscriptionError;
    }
});

var $ibMlF = parcelRequire("ibMlF");
Object.defineProperty(module.exports, "bindCallback", {
    enumerable: true,
    get: function() {
        return $ibMlF.bindCallback;
    }
});

var $jTXd9 = parcelRequire("jTXd9");
Object.defineProperty(module.exports, "bindNodeCallback", {
    enumerable: true,
    get: function() {
        return $jTXd9.bindNodeCallback;
    }
});

var $fHu9p = parcelRequire("fHu9p");
Object.defineProperty(module.exports, "combineLatest", {
    enumerable: true,
    get: function() {
        return $fHu9p.combineLatest;
    }
});

var $2YgGw = parcelRequire("2YgGw");
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function() {
        return $2YgGw.concat;
    }
});

var $24vN0 = parcelRequire("24vN0");
Object.defineProperty(module.exports, "connectable", {
    enumerable: true,
    get: function() {
        return $24vN0.connectable;
    }
});

var $aVPeW = parcelRequire("aVPeW");
Object.defineProperty(module.exports, "defer", {
    enumerable: true,
    get: function() {
        return $aVPeW.defer;
    }
});

var $9aeMj = parcelRequire("9aeMj");
Object.defineProperty(module.exports, "empty", {
    enumerable: true,
    get: function() {
        return $9aeMj.empty;
    }
});

var $dL0gl = parcelRequire("dL0gl");
Object.defineProperty(module.exports, "forkJoin", {
    enumerable: true,
    get: function() {
        return $dL0gl.forkJoin;
    }
});

var $2PY6v = parcelRequire("2PY6v");
Object.defineProperty(module.exports, "from", {
    enumerable: true,
    get: function() {
        return $2PY6v.from;
    }
});

var $la5Mt = parcelRequire("la5Mt");
Object.defineProperty(module.exports, "fromEvent", {
    enumerable: true,
    get: function() {
        return $la5Mt.fromEvent;
    }
});

var $diUca = parcelRequire("diUca");
Object.defineProperty(module.exports, "fromEventPattern", {
    enumerable: true,
    get: function() {
        return $diUca.fromEventPattern;
    }
});

var $7hDHk = parcelRequire("7hDHk");
Object.defineProperty(module.exports, "generate", {
    enumerable: true,
    get: function() {
        return $7hDHk.generate;
    }
});

var $8hvhD = parcelRequire("8hvhD");
Object.defineProperty(module.exports, "iif", {
    enumerable: true,
    get: function() {
        return $8hvhD.iif;
    }
});

var $aIEIf = parcelRequire("aIEIf");
Object.defineProperty(module.exports, "interval", {
    enumerable: true,
    get: function() {
        return $aIEIf.interval;
    }
});

var $fMdVJ = parcelRequire("fMdVJ");
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $fMdVJ.merge;
    }
});

var $fSH8M = parcelRequire("fSH8M");
Object.defineProperty(module.exports, "never", {
    enumerable: true,
    get: function() {
        return $fSH8M.never;
    }
});

var $253k8 = parcelRequire("253k8");
Object.defineProperty(module.exports, "of", {
    enumerable: true,
    get: function() {
        return $253k8.of;
    }
});

var $5W86T = parcelRequire("5W86T");
Object.defineProperty(module.exports, "onErrorResumeNext", {
    enumerable: true,
    get: function() {
        return $5W86T.onErrorResumeNext;
    }
});

var $bCWwp = parcelRequire("bCWwp");
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $bCWwp.pairs;
    }
});

var $cmbhc = parcelRequire("cmbhc");
Object.defineProperty(module.exports, "partition", {
    enumerable: true,
    get: function() {
        return $cmbhc.partition;
    }
});

var $fm02T = parcelRequire("fm02T");
Object.defineProperty(module.exports, "race", {
    enumerable: true,
    get: function() {
        return $fm02T.race;
    }
});

var $8jGlj = parcelRequire("8jGlj");
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $8jGlj.range;
    }
});

var $5qPs4 = parcelRequire("5qPs4");
Object.defineProperty(module.exports, "throwError", {
    enumerable: true,
    get: function() {
        return $5qPs4.throwError;
    }
});

var $5VhA3 = parcelRequire("5VhA3");
Object.defineProperty(module.exports, "timer", {
    enumerable: true,
    get: function() {
        return $5VhA3.timer;
    }
});

var $fsBsD = parcelRequire("fsBsD");
Object.defineProperty(module.exports, "using", {
    enumerable: true,
    get: function() {
        return $fsBsD.using;
    }
});

var $8aMcK = parcelRequire("8aMcK");
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $8aMcK.zip;
    }
});

var $90c1e = parcelRequire("90c1e");
Object.defineProperty(module.exports, "scheduled", {
    enumerable: true,
    get: function() {
        return $90c1e.scheduled;
    }
});

var $9aeMj = parcelRequire("9aeMj");
Object.defineProperty(module.exports, "EMPTY", {
    enumerable: true,
    get: function() {
        return $9aeMj.EMPTY;
    }
});

var $fSH8M = parcelRequire("fSH8M");
Object.defineProperty(module.exports, "NEVER", {
    enumerable: true,
    get: function() {
        return $fSH8M.NEVER;
    }
});

$5467d0265db2cc61$var$__exportStar((parcelRequire("8v10a")), module.exports);

var $1ckGp = parcelRequire("1ckGp");
Object.defineProperty(module.exports, "config", {
    enumerable: true,
    get: function() {
        return $1ckGp.config;
    }
});

var $GJKWZ = parcelRequire("GJKWZ");
Object.defineProperty(module.exports, "audit", {
    enumerable: true,
    get: function() {
        return $GJKWZ.audit;
    }
});

var $74irm = parcelRequire("74irm");
Object.defineProperty(module.exports, "auditTime", {
    enumerable: true,
    get: function() {
        return $74irm.auditTime;
    }
});

var $5AHzz = parcelRequire("5AHzz");
Object.defineProperty(module.exports, "buffer", {
    enumerable: true,
    get: function() {
        return $5AHzz.buffer;
    }
});

var $lra6r = parcelRequire("lra6r");
Object.defineProperty(module.exports, "bufferCount", {
    enumerable: true,
    get: function() {
        return $lra6r.bufferCount;
    }
});

var $iwmnp = parcelRequire("iwmnp");
Object.defineProperty(module.exports, "bufferTime", {
    enumerable: true,
    get: function() {
        return $iwmnp.bufferTime;
    }
});

var $4LjBN = parcelRequire("4LjBN");
Object.defineProperty(module.exports, "bufferToggle", {
    enumerable: true,
    get: function() {
        return $4LjBN.bufferToggle;
    }
});

var $aDvMT = parcelRequire("aDvMT");
Object.defineProperty(module.exports, "bufferWhen", {
    enumerable: true,
    get: function() {
        return $aDvMT.bufferWhen;
    }
});

var $cKLIx = parcelRequire("cKLIx");
Object.defineProperty(module.exports, "catchError", {
    enumerable: true,
    get: function() {
        return $cKLIx.catchError;
    }
});

var $hi56J = parcelRequire("hi56J");
Object.defineProperty(module.exports, "combineAll", {
    enumerable: true,
    get: function() {
        return $hi56J.combineAll;
    }
});

var $5mmFD = parcelRequire("5mmFD");
Object.defineProperty(module.exports, "combineLatestAll", {
    enumerable: true,
    get: function() {
        return $5mmFD.combineLatestAll;
    }
});

var $bkZDh = parcelRequire("bkZDh");
Object.defineProperty(module.exports, "combineLatestWith", {
    enumerable: true,
    get: function() {
        return $bkZDh.combineLatestWith;
    }
});

var $ibJWH = parcelRequire("ibJWH");
Object.defineProperty(module.exports, "concatAll", {
    enumerable: true,
    get: function() {
        return $ibJWH.concatAll;
    }
});

var $lUHBy = parcelRequire("lUHBy");
Object.defineProperty(module.exports, "concatMap", {
    enumerable: true,
    get: function() {
        return $lUHBy.concatMap;
    }
});

var $hqJGA = parcelRequire("hqJGA");
Object.defineProperty(module.exports, "concatMapTo", {
    enumerable: true,
    get: function() {
        return $hqJGA.concatMapTo;
    }
});

var $lQTUa = parcelRequire("lQTUa");
Object.defineProperty(module.exports, "concatWith", {
    enumerable: true,
    get: function() {
        return $lQTUa.concatWith;
    }
});

var $6yr3x = parcelRequire("6yr3x");
Object.defineProperty(module.exports, "connect", {
    enumerable: true,
    get: function() {
        return $6yr3x.connect;
    }
});

var $3BlwT = parcelRequire("3BlwT");
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $3BlwT.count;
    }
});

var $1YliC = parcelRequire("1YliC");
Object.defineProperty(module.exports, "debounce", {
    enumerable: true,
    get: function() {
        return $1YliC.debounce;
    }
});

var $h30H1 = parcelRequire("h30H1");
Object.defineProperty(module.exports, "debounceTime", {
    enumerable: true,
    get: function() {
        return $h30H1.debounceTime;
    }
});

var $kJW6J = parcelRequire("kJW6J");
Object.defineProperty(module.exports, "defaultIfEmpty", {
    enumerable: true,
    get: function() {
        return $kJW6J.defaultIfEmpty;
    }
});

var $6jlJh = parcelRequire("6jlJh");
Object.defineProperty(module.exports, "delay", {
    enumerable: true,
    get: function() {
        return $6jlJh.delay;
    }
});

var $iw846 = parcelRequire("iw846");
Object.defineProperty(module.exports, "delayWhen", {
    enumerable: true,
    get: function() {
        return $iw846.delayWhen;
    }
});

var $eII53 = parcelRequire("eII53");
Object.defineProperty(module.exports, "dematerialize", {
    enumerable: true,
    get: function() {
        return $eII53.dematerialize;
    }
});

var $j2jlR = parcelRequire("j2jlR");
Object.defineProperty(module.exports, "distinct", {
    enumerable: true,
    get: function() {
        return $j2jlR.distinct;
    }
});

var $44MsQ = parcelRequire("44MsQ");
Object.defineProperty(module.exports, "distinctUntilChanged", {
    enumerable: true,
    get: function() {
        return $44MsQ.distinctUntilChanged;
    }
});

var $3AgXM = parcelRequire("3AgXM");
Object.defineProperty(module.exports, "distinctUntilKeyChanged", {
    enumerable: true,
    get: function() {
        return $3AgXM.distinctUntilKeyChanged;
    }
});

var $8fwR4 = parcelRequire("8fwR4");
Object.defineProperty(module.exports, "elementAt", {
    enumerable: true,
    get: function() {
        return $8fwR4.elementAt;
    }
});

var $dS4q4 = parcelRequire("dS4q4");
Object.defineProperty(module.exports, "endWith", {
    enumerable: true,
    get: function() {
        return $dS4q4.endWith;
    }
});

var $i80A2 = parcelRequire("i80A2");
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $i80A2.every;
    }
});

var $hUsVc = parcelRequire("hUsVc");
Object.defineProperty(module.exports, "exhaust", {
    enumerable: true,
    get: function() {
        return $hUsVc.exhaust;
    }
});

var $b1bNb = parcelRequire("b1bNb");
Object.defineProperty(module.exports, "exhaustAll", {
    enumerable: true,
    get: function() {
        return $b1bNb.exhaustAll;
    }
});

var $k75zC = parcelRequire("k75zC");
Object.defineProperty(module.exports, "exhaustMap", {
    enumerable: true,
    get: function() {
        return $k75zC.exhaustMap;
    }
});

var $189NR = parcelRequire("189NR");
Object.defineProperty(module.exports, "expand", {
    enumerable: true,
    get: function() {
        return $189NR.expand;
    }
});

var $9UB7l = parcelRequire("9UB7l");
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $9UB7l.filter;
    }
});

var $1UQBm = parcelRequire("1UQBm");
Object.defineProperty(module.exports, "finalize", {
    enumerable: true,
    get: function() {
        return $1UQBm.finalize;
    }
});

var $5b0bg = parcelRequire("5b0bg");
Object.defineProperty(module.exports, "find", {
    enumerable: true,
    get: function() {
        return $5b0bg.find;
    }
});

var $iCzrW = parcelRequire("iCzrW");
Object.defineProperty(module.exports, "findIndex", {
    enumerable: true,
    get: function() {
        return $iCzrW.findIndex;
    }
});

var $c0ecv = parcelRequire("c0ecv");
Object.defineProperty(module.exports, "first", {
    enumerable: true,
    get: function() {
        return $c0ecv.first;
    }
});

var $3e5pj = parcelRequire("3e5pj");
Object.defineProperty(module.exports, "groupBy", {
    enumerable: true,
    get: function() {
        return $3e5pj.groupBy;
    }
});

var $iuPJp = parcelRequire("iuPJp");
Object.defineProperty(module.exports, "ignoreElements", {
    enumerable: true,
    get: function() {
        return $iuPJp.ignoreElements;
    }
});

var $cOYnk = parcelRequire("cOYnk");
Object.defineProperty(module.exports, "isEmpty", {
    enumerable: true,
    get: function() {
        return $cOYnk.isEmpty;
    }
});

var $jwbyz = parcelRequire("jwbyz");
Object.defineProperty(module.exports, "last", {
    enumerable: true,
    get: function() {
        return $jwbyz.last;
    }
});

var $dlvLZ = parcelRequire("dlvLZ");
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $dlvLZ.map;
    }
});

var $jHEjl = parcelRequire("jHEjl");
Object.defineProperty(module.exports, "mapTo", {
    enumerable: true,
    get: function() {
        return $jHEjl.mapTo;
    }
});

var $gXR8J = parcelRequire("gXR8J");
Object.defineProperty(module.exports, "materialize", {
    enumerable: true,
    get: function() {
        return $gXR8J.materialize;
    }
});

var $bL8Bf = parcelRequire("bL8Bf");
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $bL8Bf.max;
    }
});

var $bGQoL = parcelRequire("bGQoL");
Object.defineProperty(module.exports, "mergeAll", {
    enumerable: true,
    get: function() {
        return $bGQoL.mergeAll;
    }
});

var $crJRG = parcelRequire("crJRG");
Object.defineProperty(module.exports, "flatMap", {
    enumerable: true,
    get: function() {
        return $crJRG.flatMap;
    }
});

var $9yos9 = parcelRequire("9yos9");
Object.defineProperty(module.exports, "mergeMap", {
    enumerable: true,
    get: function() {
        return $9yos9.mergeMap;
    }
});

var $aGrfq = parcelRequire("aGrfq");
Object.defineProperty(module.exports, "mergeMapTo", {
    enumerable: true,
    get: function() {
        return $aGrfq.mergeMapTo;
    }
});

var $52bW5 = parcelRequire("52bW5");
Object.defineProperty(module.exports, "mergeScan", {
    enumerable: true,
    get: function() {
        return $52bW5.mergeScan;
    }
});

var $joqn9 = parcelRequire("joqn9");
Object.defineProperty(module.exports, "mergeWith", {
    enumerable: true,
    get: function() {
        return $joqn9.mergeWith;
    }
});

var $2QRuw = parcelRequire("2QRuw");
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $2QRuw.min;
    }
});

var $0YCgj = parcelRequire("0YCgj");
Object.defineProperty(module.exports, "multicast", {
    enumerable: true,
    get: function() {
        return $0YCgj.multicast;
    }
});

var $030h7 = parcelRequire("030h7");
Object.defineProperty(module.exports, "observeOn", {
    enumerable: true,
    get: function() {
        return $030h7.observeOn;
    }
});

var $8XKni = parcelRequire("8XKni");
Object.defineProperty(module.exports, "onErrorResumeNextWith", {
    enumerable: true,
    get: function() {
        return $8XKni.onErrorResumeNextWith;
    }
});

var $zmZZf = parcelRequire("zmZZf");
Object.defineProperty(module.exports, "pairwise", {
    enumerable: true,
    get: function() {
        return $zmZZf.pairwise;
    }
});

var $kSUeX = parcelRequire("kSUeX");
Object.defineProperty(module.exports, "pluck", {
    enumerable: true,
    get: function() {
        return $kSUeX.pluck;
    }
});

var $3DSIU = parcelRequire("3DSIU");
Object.defineProperty(module.exports, "publish", {
    enumerable: true,
    get: function() {
        return $3DSIU.publish;
    }
});

var $4Yf1V = parcelRequire("4Yf1V");
Object.defineProperty(module.exports, "publishBehavior", {
    enumerable: true,
    get: function() {
        return $4Yf1V.publishBehavior;
    }
});

var $htmo4 = parcelRequire("htmo4");
Object.defineProperty(module.exports, "publishLast", {
    enumerable: true,
    get: function() {
        return $htmo4.publishLast;
    }
});

var $hO5Vx = parcelRequire("hO5Vx");
Object.defineProperty(module.exports, "publishReplay", {
    enumerable: true,
    get: function() {
        return $hO5Vx.publishReplay;
    }
});

var $QP0wQ = parcelRequire("QP0wQ");
Object.defineProperty(module.exports, "raceWith", {
    enumerable: true,
    get: function() {
        return $QP0wQ.raceWith;
    }
});

var $1DJZU = parcelRequire("1DJZU");
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $1DJZU.reduce;
    }
});

var $7l3DT = parcelRequire("7l3DT");
Object.defineProperty(module.exports, "repeat", {
    enumerable: true,
    get: function() {
        return $7l3DT.repeat;
    }
});

var $adOrM = parcelRequire("adOrM");
Object.defineProperty(module.exports, "repeatWhen", {
    enumerable: true,
    get: function() {
        return $adOrM.repeatWhen;
    }
});

var $1vc7D = parcelRequire("1vc7D");
Object.defineProperty(module.exports, "retry", {
    enumerable: true,
    get: function() {
        return $1vc7D.retry;
    }
});

var $aSde1 = parcelRequire("aSde1");
Object.defineProperty(module.exports, "retryWhen", {
    enumerable: true,
    get: function() {
        return $aSde1.retryWhen;
    }
});

var $7Z891 = parcelRequire("7Z891");
Object.defineProperty(module.exports, "refCount", {
    enumerable: true,
    get: function() {
        return $7Z891.refCount;
    }
});

var $99Y2Y = parcelRequire("99Y2Y");
Object.defineProperty(module.exports, "sample", {
    enumerable: true,
    get: function() {
        return $99Y2Y.sample;
    }
});

var $lGCWc = parcelRequire("lGCWc");
Object.defineProperty(module.exports, "sampleTime", {
    enumerable: true,
    get: function() {
        return $lGCWc.sampleTime;
    }
});

var $keq7K = parcelRequire("keq7K");
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $keq7K.scan;
    }
});

var $htbrG = parcelRequire("htbrG");
Object.defineProperty(module.exports, "sequenceEqual", {
    enumerable: true,
    get: function() {
        return $htbrG.sequenceEqual;
    }
});

var $109B7 = parcelRequire("109B7");
Object.defineProperty(module.exports, "share", {
    enumerable: true,
    get: function() {
        return $109B7.share;
    }
});

var $171Pf = parcelRequire("171Pf");
Object.defineProperty(module.exports, "shareReplay", {
    enumerable: true,
    get: function() {
        return $171Pf.shareReplay;
    }
});

var $cYZh1 = parcelRequire("cYZh1");
Object.defineProperty(module.exports, "single", {
    enumerable: true,
    get: function() {
        return $cYZh1.single;
    }
});

var $giKyY = parcelRequire("giKyY");
Object.defineProperty(module.exports, "skip", {
    enumerable: true,
    get: function() {
        return $giKyY.skip;
    }
});

var $6aRM0 = parcelRequire("6aRM0");
Object.defineProperty(module.exports, "skipLast", {
    enumerable: true,
    get: function() {
        return $6aRM0.skipLast;
    }
});

var $8h7Qd = parcelRequire("8h7Qd");
Object.defineProperty(module.exports, "skipUntil", {
    enumerable: true,
    get: function() {
        return $8h7Qd.skipUntil;
    }
});

var $ddo0F = parcelRequire("ddo0F");
Object.defineProperty(module.exports, "skipWhile", {
    enumerable: true,
    get: function() {
        return $ddo0F.skipWhile;
    }
});

var $2hoDR = parcelRequire("2hoDR");
Object.defineProperty(module.exports, "startWith", {
    enumerable: true,
    get: function() {
        return $2hoDR.startWith;
    }
});

var $4ezR0 = parcelRequire("4ezR0");
Object.defineProperty(module.exports, "subscribeOn", {
    enumerable: true,
    get: function() {
        return $4ezR0.subscribeOn;
    }
});

var $7cM1p = parcelRequire("7cM1p");
Object.defineProperty(module.exports, "switchAll", {
    enumerable: true,
    get: function() {
        return $7cM1p.switchAll;
    }
});

var $9q5AD = parcelRequire("9q5AD");
Object.defineProperty(module.exports, "switchMap", {
    enumerable: true,
    get: function() {
        return $9q5AD.switchMap;
    }
});

var $aXTon = parcelRequire("aXTon");
Object.defineProperty(module.exports, "switchMapTo", {
    enumerable: true,
    get: function() {
        return $aXTon.switchMapTo;
    }
});

var $6UQzS = parcelRequire("6UQzS");
Object.defineProperty(module.exports, "switchScan", {
    enumerable: true,
    get: function() {
        return $6UQzS.switchScan;
    }
});

var $RyKIh = parcelRequire("RyKIh");
Object.defineProperty(module.exports, "take", {
    enumerable: true,
    get: function() {
        return $RyKIh.take;
    }
});

var $eetG1 = parcelRequire("eetG1");
Object.defineProperty(module.exports, "takeLast", {
    enumerable: true,
    get: function() {
        return $eetG1.takeLast;
    }
});

var $hmAHy = parcelRequire("hmAHy");
Object.defineProperty(module.exports, "takeUntil", {
    enumerable: true,
    get: function() {
        return $hmAHy.takeUntil;
    }
});

var $l0lbO = parcelRequire("l0lbO");
Object.defineProperty(module.exports, "takeWhile", {
    enumerable: true,
    get: function() {
        return $l0lbO.takeWhile;
    }
});

var $itLai = parcelRequire("itLai");
Object.defineProperty(module.exports, "tap", {
    enumerable: true,
    get: function() {
        return $itLai.tap;
    }
});

var $cmWmG = parcelRequire("cmWmG");
Object.defineProperty(module.exports, "throttle", {
    enumerable: true,
    get: function() {
        return $cmWmG.throttle;
    }
});

var $jO5Pf = parcelRequire("jO5Pf");
Object.defineProperty(module.exports, "throttleTime", {
    enumerable: true,
    get: function() {
        return $jO5Pf.throttleTime;
    }
});

var $g9w3F = parcelRequire("g9w3F");
Object.defineProperty(module.exports, "throwIfEmpty", {
    enumerable: true,
    get: function() {
        return $g9w3F.throwIfEmpty;
    }
});

var $05fTJ = parcelRequire("05fTJ");
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $05fTJ.timeInterval;
    }
});

var $5oCQ5 = parcelRequire("5oCQ5");
Object.defineProperty(module.exports, "timeout", {
    enumerable: true,
    get: function() {
        return $5oCQ5.timeout;
    }
});

var $bqhsW = parcelRequire("bqhsW");
Object.defineProperty(module.exports, "timeoutWith", {
    enumerable: true,
    get: function() {
        return $bqhsW.timeoutWith;
    }
});

var $NLpTp = parcelRequire("NLpTp");
Object.defineProperty(module.exports, "timestamp", {
    enumerable: true,
    get: function() {
        return $NLpTp.timestamp;
    }
});

var $dEi09 = parcelRequire("dEi09");
Object.defineProperty(module.exports, "toArray", {
    enumerable: true,
    get: function() {
        return $dEi09.toArray;
    }
});

var $3UEiK = parcelRequire("3UEiK");
Object.defineProperty(module.exports, "window", {
    enumerable: true,
    get: function() {
        return $3UEiK.window;
    }
});

var $8FElb = parcelRequire("8FElb");
Object.defineProperty(module.exports, "windowCount", {
    enumerable: true,
    get: function() {
        return $8FElb.windowCount;
    }
});

var $fxabb = parcelRequire("fxabb");
Object.defineProperty(module.exports, "windowTime", {
    enumerable: true,
    get: function() {
        return $fxabb.windowTime;
    }
});

var $6KMpd = parcelRequire("6KMpd");
Object.defineProperty(module.exports, "windowToggle", {
    enumerable: true,
    get: function() {
        return $6KMpd.windowToggle;
    }
});

var $8F6gz = parcelRequire("8F6gz");
Object.defineProperty(module.exports, "windowWhen", {
    enumerable: true,
    get: function() {
        return $8F6gz.windowWhen;
    }
});

var $8hSe0 = parcelRequire("8hSe0");
Object.defineProperty(module.exports, "withLatestFrom", {
    enumerable: true,
    get: function() {
        return $8hSe0.withLatestFrom;
    }
});

var $cfyGJ = parcelRequire("cfyGJ");
Object.defineProperty(module.exports, "zipAll", {
    enumerable: true,
    get: function() {
        return $cfyGJ.zipAll;
    }
});

var $bQ6MC = parcelRequire("bQ6MC");
Object.defineProperty(module.exports, "zipWith", {
    enumerable: true,
    get: function() {
        return $bQ6MC.zipWith;
    }
});

});
parcelRegister("879ii", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;

var $9btgx = parcelRequire("9btgx");

var $3NoDj = parcelRequire("3NoDj");

var $I1Tai = parcelRequire("I1Tai");

var $2LtHu = parcelRequire("2LtHu");

var $1ckGp = parcelRequire("1ckGp");

var $8VYz5 = parcelRequire("8VYz5");

var $8hXo6 = parcelRequire("8hXo6");
var $5e862fc7c16c57da$var$Observable = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $5e862fc7c16c57da$var$isSubscriber(observerOrNext) ? observerOrNext : new $9btgx.SafeSubscriber(observerOrNext, error, complete);
        $8hXo6.errorContext(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $5e862fc7c16c57da$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new $9btgx.SafeSubscriber({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[$I1Tai.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return $2LtHu.pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $5e862fc7c16c57da$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
module.exports.Observable = $5e862fc7c16c57da$var$Observable;
function $5e862fc7c16c57da$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : $1ckGp.config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $5e862fc7c16c57da$var$isObserver(value) {
    return value && $8VYz5.isFunction(value.next) && $8VYz5.isFunction(value.error) && $8VYz5.isFunction(value.complete);
}
function $5e862fc7c16c57da$var$isSubscriber(value) {
    return value && value instanceof $9btgx.Subscriber || $5e862fc7c16c57da$var$isObserver(value) && $3NoDj.isSubscription(value);
}

});
parcelRegister("9btgx", function(module, exports) {
"use strict";
var $6afbd7aff7cf8e1c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_OBSERVER = module.exports.SafeSubscriber = module.exports.Subscriber = void 0;

var $8VYz5 = parcelRequire("8VYz5");

var $3NoDj = parcelRequire("3NoDj");

var $1ckGp = parcelRequire("1ckGp");

var $fymAc = parcelRequire("fymAc");

var $6UXs2 = parcelRequire("6UXs2");

var $dIOCC = parcelRequire("dIOCC");

var $gSdPs = parcelRequire("gSdPs");

var $8hXo6 = parcelRequire("8hXo6");
var $6afbd7aff7cf8e1c$var$Subscriber = function(_super) {
    $6afbd7aff7cf8e1c$var$__extends(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ($3NoDj.isSubscription(destination)) destination.add(_this);
        } else _this.destination = module.exports.EMPTY_OBSERVER;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $6afbd7aff7cf8e1c$var$SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $6afbd7aff7cf8e1c$var$handleStoppedNotification($dIOCC.nextNotification(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $6afbd7aff7cf8e1c$var$handleStoppedNotification($dIOCC.errorNotification(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $6afbd7aff7cf8e1c$var$handleStoppedNotification($dIOCC.COMPLETE_NOTIFICATION, this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}($3NoDj.Subscription);
module.exports.Subscriber = $6afbd7aff7cf8e1c$var$Subscriber;
var $6afbd7aff7cf8e1c$var$_bind = Function.prototype.bind;
function $6afbd7aff7cf8e1c$var$bind(fn, thisArg) {
    return $6afbd7aff7cf8e1c$var$_bind.call(fn, thisArg);
}
var $6afbd7aff7cf8e1c$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $6afbd7aff7cf8e1c$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $6afbd7aff7cf8e1c$var$handleUnhandledError(error);
        }
        else $6afbd7aff7cf8e1c$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $6afbd7aff7cf8e1c$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $6afbd7aff7cf8e1c$var$SafeSubscriber = function(_super) {
    $6afbd7aff7cf8e1c$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ($8VYz5.isFunction(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && $1ckGp.config.useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $6afbd7aff7cf8e1c$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $6afbd7aff7cf8e1c$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $6afbd7aff7cf8e1c$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $6afbd7aff7cf8e1c$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($6afbd7aff7cf8e1c$var$Subscriber);
module.exports.SafeSubscriber = $6afbd7aff7cf8e1c$var$SafeSubscriber;
function $6afbd7aff7cf8e1c$var$handleUnhandledError(error) {
    if ($1ckGp.config.useDeprecatedSynchronousErrorHandling) $8hXo6.captureError(error);
    else $fymAc.reportUnhandledError(error);
}
function $6afbd7aff7cf8e1c$var$defaultErrorHandler(err) {
    throw err;
}
function $6afbd7aff7cf8e1c$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = $1ckGp.config.onStoppedNotification;
    onStoppedNotification && $gSdPs.timeoutProvider.setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
module.exports.EMPTY_OBSERVER = {
    closed: true,
    next: $6UXs2.noop,
    error: $6afbd7aff7cf8e1c$var$defaultErrorHandler,
    complete: $6UXs2.noop
};

});
parcelRegister("8VYz5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFunction = void 0;
function $6812a08557d9d49a$var$isFunction(value) {
    return typeof value === 'function';
}
module.exports.isFunction = $6812a08557d9d49a$var$isFunction;

});

parcelRegister("3NoDj", function(module, exports) {
"use strict";
var $2c390e4ff1d3eaaa$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $2c390e4ff1d3eaaa$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2c390e4ff1d3eaaa$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSubscription = module.exports.EMPTY_SUBSCRIPTION = module.exports.Subscription = void 0;

var $8VYz5 = parcelRequire("8VYz5");

var $4cbvs = parcelRequire("4cbvs");

var $59Z75 = parcelRequire("59Z75");
var $2c390e4ff1d3eaaa$var$Subscription = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = $2c390e4ff1d3eaaa$var$__values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ($8VYz5.isFunction(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof $4cbvs.UnsubscriptionError ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = $2c390e4ff1d3eaaa$var$__values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $2c390e4ff1d3eaaa$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof $4cbvs.UnsubscriptionError) errors = $2c390e4ff1d3eaaa$var$__spreadArray($2c390e4ff1d3eaaa$var$__spreadArray([], $2c390e4ff1d3eaaa$var$__read(errors)), $2c390e4ff1d3eaaa$var$__read(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new $4cbvs.UnsubscriptionError(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $2c390e4ff1d3eaaa$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) $59Z75.arrRemove(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && $59Z75.arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
module.exports.Subscription = $2c390e4ff1d3eaaa$var$Subscription;
module.exports.EMPTY_SUBSCRIPTION = $2c390e4ff1d3eaaa$var$Subscription.EMPTY;
function $2c390e4ff1d3eaaa$var$isSubscription(value) {
    return value instanceof $2c390e4ff1d3eaaa$var$Subscription || value && 'closed' in value && $8VYz5.isFunction(value.remove) && $8VYz5.isFunction(value.add) && $8VYz5.isFunction(value.unsubscribe);
}
module.exports.isSubscription = $2c390e4ff1d3eaaa$var$isSubscription;
function $2c390e4ff1d3eaaa$var$execFinalizer(finalizer) {
    if ($8VYz5.isFunction(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("4cbvs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnsubscriptionError = void 0;

var $jHWC9 = parcelRequire("jHWC9");
module.exports.UnsubscriptionError = $jHWC9.createErrorClass(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

});
parcelRegister("jHWC9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createErrorClass = void 0;
function $e58f800cd5c6f388$var$createErrorClass(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}
module.exports.createErrorClass = $e58f800cd5c6f388$var$createErrorClass;

});


parcelRegister("59Z75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrRemove = void 0;
function $3c1d32db23224a0e$var$arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}
module.exports.arrRemove = $3c1d32db23224a0e$var$arrRemove;

});


parcelRegister("1ckGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.config = void 0;
module.exports.config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("fymAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportUnhandledError = void 0;

var $1ckGp = parcelRequire("1ckGp");

var $gSdPs = parcelRequire("gSdPs");
function $b52b8c787b5deb00$var$reportUnhandledError(err) {
    $gSdPs.timeoutProvider.setTimeout(function() {
        var onUnhandledError = $1ckGp.config.onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}
module.exports.reportUnhandledError = $b52b8c787b5deb00$var$reportUnhandledError;

});
parcelRegister("gSdPs", function(module, exports) {
"use strict";
var $c48c6a9c89324bd4$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $c48c6a9c89324bd4$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeoutProvider = void 0;
module.exports.timeoutProvider = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = module.exports.timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, $c48c6a9c89324bd4$var$__spreadArray([
            handler,
            timeout
        ], $c48c6a9c89324bd4$var$__read(args)));
        return setTimeout.apply(void 0, $c48c6a9c89324bd4$var$__spreadArray([
            handler,
            timeout
        ], $c48c6a9c89324bd4$var$__read(args)));
    },
    clearTimeout: function(handle) {
        var delegate = module.exports.timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("6UXs2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.noop = void 0;
function $509616d0b9a432b3$var$noop() {}
module.exports.noop = $509616d0b9a432b3$var$noop;

});

parcelRegister("dIOCC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNotification = module.exports.nextNotification = module.exports.errorNotification = module.exports.COMPLETE_NOTIFICATION = void 0;
module.exports.COMPLETE_NOTIFICATION = function() {
    return $9fd6a6e4d164ccb7$var$createNotification('C', undefined, undefined);
}();
function $9fd6a6e4d164ccb7$var$errorNotification(error) {
    return $9fd6a6e4d164ccb7$var$createNotification('E', undefined, error);
}
module.exports.errorNotification = $9fd6a6e4d164ccb7$var$errorNotification;
function $9fd6a6e4d164ccb7$var$nextNotification(value) {
    return $9fd6a6e4d164ccb7$var$createNotification('N', value, undefined);
}
module.exports.nextNotification = $9fd6a6e4d164ccb7$var$nextNotification;
function $9fd6a6e4d164ccb7$var$createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}
module.exports.createNotification = $9fd6a6e4d164ccb7$var$createNotification;

});

parcelRegister("8hXo6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.captureError = module.exports.errorContext = void 0;

var $1ckGp = parcelRequire("1ckGp");
var $608dfa6e8e87d6a5$var$context = null;
function $608dfa6e8e87d6a5$var$errorContext(cb) {
    if ($1ckGp.config.useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$608dfa6e8e87d6a5$var$context;
        if (isRoot) $608dfa6e8e87d6a5$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $608dfa6e8e87d6a5$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $608dfa6e8e87d6a5$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
module.exports.errorContext = $608dfa6e8e87d6a5$var$errorContext;
function $608dfa6e8e87d6a5$var$captureError(err) {
    if ($1ckGp.config.useDeprecatedSynchronousErrorHandling && $608dfa6e8e87d6a5$var$context) {
        $608dfa6e8e87d6a5$var$context.errorThrown = true;
        $608dfa6e8e87d6a5$var$context.error = err;
    }
}
module.exports.captureError = $608dfa6e8e87d6a5$var$captureError;

});


parcelRegister("I1Tai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.observable = void 0;
module.exports.observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

});

parcelRegister("2LtHu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipeFromArray = module.exports.pipe = void 0;

var $doKTd = parcelRequire("doKTd");
function $2037026c0b667597$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $2037026c0b667597$var$pipeFromArray(fns);
}
module.exports.pipe = $2037026c0b667597$var$pipe;
function $2037026c0b667597$var$pipeFromArray(fns) {
    if (fns.length === 0) return $doKTd.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
module.exports.pipeFromArray = $2037026c0b667597$var$pipeFromArray;

});
parcelRegister("doKTd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.identity = void 0;
function $9c11e38e0e31caf5$var$identity(x) {
    return x;
}
module.exports.identity = $9c11e38e0e31caf5$var$identity;

});



parcelRegister("hEwEw", function(module, exports) {
"use strict";
var $cd9f8032f9785be9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectableObservable = void 0;

var $879ii = parcelRequire("879ii");

var $3NoDj = parcelRequire("3NoDj");

var $7Z891 = parcelRequire("7Z891");

var $a1JN2 = parcelRequire("a1JN2");

var $3xclF = parcelRequire("3xclF");
var $cd9f8032f9785be9$var$ConnectableObservable = function(_super) {
    $cd9f8032f9785be9$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if ($3xclF.hasLift(source)) _this.lift = source.lift;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function() {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 || _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function() {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new $3NoDj.Subscription();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe($a1JN2.createOperatorSubscriber(subject_1, undefined, function() {
                _this._teardown();
                subject_1.complete();
            }, function(err) {
                _this._teardown();
                subject_1.error(err);
            }, function() {
                return _this._teardown();
            })));
            if (connection.closed) {
                this._connection = null;
                connection = $3NoDj.Subscription.EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $7Z891.refCount()(this);
    };
    return ConnectableObservable;
}($879ii.Observable);
module.exports.ConnectableObservable = $cd9f8032f9785be9$var$ConnectableObservable;

});
parcelRegister("7Z891", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.refCount = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $5d048c3b387e4fdf$var$refCount() {
    return $3xclF.operate(function(source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = $a1JN2.createOperatorSubscriber(subscriber, undefined, undefined, undefined, function() {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) sharedConnection.unsubscribe();
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) connection = source.connect();
    });
}
module.exports.refCount = $5d048c3b387e4fdf$var$refCount;

});
parcelRegister("3xclF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.operate = module.exports.hasLift = void 0;

var $8VYz5 = parcelRequire("8VYz5");
function $292e084e3f45ea00$var$hasLift(source) {
    return $8VYz5.isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
module.exports.hasLift = $292e084e3f45ea00$var$hasLift;
function $292e084e3f45ea00$var$operate(init) {
    return function(source) {
        if ($292e084e3f45ea00$var$hasLift(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}
module.exports.operate = $292e084e3f45ea00$var$operate;

});

parcelRegister("a1JN2", function(module, exports) {
"use strict";
var $74cd844bec5640d6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OperatorSubscriber = module.exports.createOperatorSubscriber = void 0;

var $9btgx = parcelRequire("9btgx");
function $74cd844bec5640d6$var$createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new $74cd844bec5640d6$var$OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
module.exports.createOperatorSubscriber = $74cd844bec5640d6$var$createOperatorSubscriber;
var $74cd844bec5640d6$var$OperatorSubscriber = function(_super) {
    $74cd844bec5640d6$var$__extends(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}($9btgx.Subscriber);
module.exports.OperatorSubscriber = $74cd844bec5640d6$var$OperatorSubscriber;

});



parcelRegister("jAywM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.animationFrames = void 0;

var $879ii = parcelRequire("879ii");

var $irCO0 = parcelRequire("irCO0");

var $emiyc = parcelRequire("emiyc");
function $e42c299492a3fe7c$var$animationFrames(timestampProvider) {
    return timestampProvider ? $e42c299492a3fe7c$var$animationFramesFactory(timestampProvider) : $e42c299492a3fe7c$var$DEFAULT_ANIMATION_FRAMES;
}
module.exports.animationFrames = $e42c299492a3fe7c$var$animationFrames;
function $e42c299492a3fe7c$var$animationFramesFactory(timestampProvider) {
    return new $879ii.Observable(function(subscriber) {
        var provider = timestampProvider || $irCO0.performanceTimestampProvider;
        var start = provider.now();
        var id = 0;
        var run = function() {
            if (!subscriber.closed) id = $emiyc.animationFrameProvider.requestAnimationFrame(function(timestamp) {
                id = 0;
                var now = provider.now();
                subscriber.next({
                    timestamp: timestampProvider ? now : timestamp,
                    elapsed: now - start
                });
                run();
            });
        };
        run();
        return function() {
            if (id) $emiyc.animationFrameProvider.cancelAnimationFrame(id);
        };
    });
}
var $e42c299492a3fe7c$var$DEFAULT_ANIMATION_FRAMES = $e42c299492a3fe7c$var$animationFramesFactory();

});
parcelRegister("irCO0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.performanceTimestampProvider = void 0;
module.exports.performanceTimestampProvider = {
    now: function() {
        return (module.exports.performanceTimestampProvider.delegate || performance).now();
    },
    delegate: undefined
};

});

parcelRegister("emiyc", function(module, exports) {
"use strict";
var $a74182893e099a01$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a74182893e099a01$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.animationFrameProvider = void 0;

var $3NoDj = parcelRequire("3NoDj");
module.exports.animationFrameProvider = {
    schedule: function(callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = module.exports.animationFrameProvider.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function(timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new $3NoDj.Subscription(function() {
            return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
        });
    },
    requestAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = module.exports.animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, $a74182893e099a01$var$__spreadArray([], $a74182893e099a01$var$__read(args)));
    },
    cancelAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = module.exports.animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, $a74182893e099a01$var$__spreadArray([], $a74182893e099a01$var$__read(args)));
    },
    delegate: undefined
};

});


parcelRegister("7qEr0", function(module, exports) {
"use strict";
var $568a5390f2e8e051$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $568a5390f2e8e051$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnonymousSubject = module.exports.Subject = void 0;

var $879ii = parcelRequire("879ii");

var $3NoDj = parcelRequire("3NoDj");

var $fblAT = parcelRequire("fblAT");

var $59Z75 = parcelRequire("59Z75");

var $8hXo6 = parcelRequire("8hXo6");
var $568a5390f2e8e051$var$Subject = function(_super) {
    $568a5390f2e8e051$var$__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $568a5390f2e8e051$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new $fblAT.ObjectUnsubscribedError();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        $8hXo6.errorContext(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = $568a5390f2e8e051$var$__values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        $8hXo6.errorContext(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        $8hXo6.errorContext(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return $3NoDj.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new $3NoDj.Subscription(function() {
            _this.currentObservers = null;
            $59Z75.arrRemove(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new $879ii.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $568a5390f2e8e051$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($879ii.Observable);
module.exports.Subject = $568a5390f2e8e051$var$Subject;
var $568a5390f2e8e051$var$AnonymousSubject = function(_super) {
    $568a5390f2e8e051$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : $3NoDj.EMPTY_SUBSCRIPTION;
    };
    return AnonymousSubject;
}($568a5390f2e8e051$var$Subject);
module.exports.AnonymousSubject = $568a5390f2e8e051$var$AnonymousSubject;

});
parcelRegister("fblAT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectUnsubscribedError = void 0;

var $jHWC9 = parcelRequire("jHWC9");
module.exports.ObjectUnsubscribedError = $jHWC9.createErrorClass(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

});


parcelRegister("i5kDY", function(module, exports) {
"use strict";
var $d2a8b509fb83d55a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BehaviorSubject = void 0;

var $7qEr0 = parcelRequire("7qEr0");
var $d2a8b509fb83d55a$var$BehaviorSubject = function(_super) {
    $d2a8b509fb83d55a$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($7qEr0.Subject);
module.exports.BehaviorSubject = $d2a8b509fb83d55a$var$BehaviorSubject;

});

parcelRegister("jaL5r", function(module, exports) {
"use strict";
var $df5379f0475eeae5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReplaySubject = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $kX1bI = parcelRequire("kX1bI");
var $df5379f0475eeae5$var$ReplaySubject = function(_super) {
    $df5379f0475eeae5$var$__extends(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = $kX1bI.dateTimestampProvider;
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}($7qEr0.Subject);
module.exports.ReplaySubject = $df5379f0475eeae5$var$ReplaySubject;

});
parcelRegister("kX1bI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dateTimestampProvider = void 0;
module.exports.dateTimestampProvider = {
    now: function() {
        return (module.exports.dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined
};

});


parcelRegister("kJoTA", function(module, exports) {
"use strict";
var $f17b525ad4d6f1b4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsyncSubject = void 0;

var $7qEr0 = parcelRequire("7qEr0");
var $f17b525ad4d6f1b4$var$AsyncSubject = function(_super) {
    $f17b525ad4d6f1b4$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._hasValue = false;
        _this._isComplete = false;
        return _this;
    }
    AsyncSubject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped || _isComplete) {
            _hasValue && subscriber.next(_value);
            subscriber.complete();
        }
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.isStopped) {
            this._value = value;
            this._hasValue = true;
        }
    };
    AsyncSubject.prototype.complete = function() {
        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
        if (!_isComplete) {
            this._isComplete = true;
            _hasValue && _super.prototype.next.call(this, _value);
            _super.prototype.complete.call(this);
        }
    };
    return AsyncSubject;
}($7qEr0.Subject);
module.exports.AsyncSubject = $f17b525ad4d6f1b4$var$AsyncSubject;

});

parcelRegister("EeTNx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.asap = module.exports.asapScheduler = void 0;

var $bko7K = parcelRequire("bko7K");

var $6fg30 = parcelRequire("6fg30");
module.exports.asapScheduler = new $6fg30.AsapScheduler($bko7K.AsapAction);
module.exports.asap = module.exports.asapScheduler;

});
parcelRegister("bko7K", function(module, exports) {
"use strict";
var $83f44680518ecbc0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsapAction = void 0;

var $gxnPp = parcelRequire("gxnPp");

var $dXIl8 = parcelRequire("dXIl8");
var $83f44680518ecbc0$var$AsapAction = function(_super) {
    $83f44680518ecbc0$var$__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = $dXIl8.immediateProvider.setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            $dXIl8.immediateProvider.clearImmediate(id);
            if (scheduler._scheduled === id) scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}($gxnPp.AsyncAction);
module.exports.AsapAction = $83f44680518ecbc0$var$AsapAction;

});
parcelRegister("gxnPp", function(module, exports) {
"use strict";
var $c0a2362cbc2daab7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsyncAction = void 0;

var $6deFq = parcelRequire("6deFq");

var $fPT8h = parcelRequire("fPT8h");

var $59Z75 = parcelRequire("59Z75");
var $c0a2362cbc2daab7$var$AsyncAction = function(_super) {
    $c0a2362cbc2daab7$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return $fPT8h.intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) $fPT8h.intervalProvider.clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            $59Z75.arrRemove(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}($6deFq.Action);
module.exports.AsyncAction = $c0a2362cbc2daab7$var$AsyncAction;

});
parcelRegister("6deFq", function(module, exports) {
"use strict";
var $485f558e7c42c6eb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Action = void 0;

var $3NoDj = parcelRequire("3NoDj");
var $485f558e7c42c6eb$var$Action = function(_super) {
    $485f558e7c42c6eb$var$__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($3NoDj.Subscription);
module.exports.Action = $485f558e7c42c6eb$var$Action;

});

parcelRegister("fPT8h", function(module, exports) {
"use strict";
var $b87662a2e70b5e64$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b87662a2e70b5e64$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.intervalProvider = void 0;
module.exports.intervalProvider = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = module.exports.intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, $b87662a2e70b5e64$var$__spreadArray([
            handler,
            timeout
        ], $b87662a2e70b5e64$var$__read(args)));
        return setInterval.apply(void 0, $b87662a2e70b5e64$var$__spreadArray([
            handler,
            timeout
        ], $b87662a2e70b5e64$var$__read(args)));
    },
    clearInterval: function(handle) {
        var delegate = module.exports.intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

});


parcelRegister("dXIl8", function(module, exports) {
"use strict";
var $a2a32e0c3ecba5af$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a2a32e0c3ecba5af$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.immediateProvider = void 0;

var $lurSf = parcelRequire("lurSf");
var $a2a32e0c3ecba5af$var$setImmediate = $lurSf.Immediate.setImmediate, $a2a32e0c3ecba5af$var$clearImmediate = $lurSf.Immediate.clearImmediate;
module.exports.immediateProvider = {
    setImmediate: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = module.exports.immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || $a2a32e0c3ecba5af$var$setImmediate).apply(void 0, $a2a32e0c3ecba5af$var$__spreadArray([], $a2a32e0c3ecba5af$var$__read(args)));
    },
    clearImmediate: function(handle) {
        var delegate = module.exports.immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || $a2a32e0c3ecba5af$var$clearImmediate)(handle);
    },
    delegate: undefined
};

});
parcelRegister("lurSf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TestTools = module.exports.Immediate = void 0;
var $fa520586375e849b$var$nextHandle = 1;
var $fa520586375e849b$var$resolved;
var $fa520586375e849b$var$activeHandles = {};
function $fa520586375e849b$var$findAndClearHandle(handle) {
    if (handle in $fa520586375e849b$var$activeHandles) {
        delete $fa520586375e849b$var$activeHandles[handle];
        return true;
    }
    return false;
}
module.exports.Immediate = {
    setImmediate: function(cb) {
        var handle = $fa520586375e849b$var$nextHandle++;
        $fa520586375e849b$var$activeHandles[handle] = true;
        if (!$fa520586375e849b$var$resolved) $fa520586375e849b$var$resolved = Promise.resolve();
        $fa520586375e849b$var$resolved.then(function() {
            return $fa520586375e849b$var$findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        $fa520586375e849b$var$findAndClearHandle(handle);
    }
};
module.exports.TestTools = {
    pending: function() {
        return Object.keys($fa520586375e849b$var$activeHandles).length;
    }
};

});



parcelRegister("6fg30", function(module, exports) {
"use strict";
var $48c0977ae8cd4ab7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsapScheduler = void 0;

var $kpIo0 = parcelRequire("kpIo0");
var $48c0977ae8cd4ab7$var$AsapScheduler = function(_super) {
    $48c0977ae8cd4ab7$var$__extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}($kpIo0.AsyncScheduler);
module.exports.AsapScheduler = $48c0977ae8cd4ab7$var$AsapScheduler;

});
parcelRegister("kpIo0", function(module, exports) {
"use strict";
var $edc8929829f054a7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsyncScheduler = void 0;

var $5pHsW = parcelRequire("5pHsW");
var $edc8929829f054a7$var$AsyncScheduler = function(_super) {
    $edc8929829f054a7$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = $5pHsW.Scheduler.now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($5pHsW.Scheduler);
module.exports.AsyncScheduler = $edc8929829f054a7$var$AsyncScheduler;

});
parcelRegister("5pHsW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Scheduler = void 0;

var $kX1bI = parcelRequire("kX1bI");
var $3f1100ef49a360cc$var$Scheduler = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = $kX1bI.dateTimestampProvider.now;
    return Scheduler;
}();
module.exports.Scheduler = $3f1100ef49a360cc$var$Scheduler;

});




parcelRegister("iblpQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.async = module.exports.asyncScheduler = void 0;

var $gxnPp = parcelRequire("gxnPp");

var $kpIo0 = parcelRequire("kpIo0");
module.exports.asyncScheduler = new $kpIo0.AsyncScheduler($gxnPp.AsyncAction);
module.exports.async = module.exports.asyncScheduler;

});

parcelRegister("cTlo5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.queue = module.exports.queueScheduler = void 0;

var $013No = parcelRequire("013No");

var $ayI8h = parcelRequire("ayI8h");
module.exports.queueScheduler = new $ayI8h.QueueScheduler($013No.QueueAction);
module.exports.queue = module.exports.queueScheduler;

});
parcelRegister("013No", function(module, exports) {
"use strict";
var $003309dc0b86ac39$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueueAction = void 0;

var $gxnPp = parcelRequire("gxnPp");
var $003309dc0b86ac39$var$QueueAction = function(_super) {
    $003309dc0b86ac39$var$__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && delay > 0 || delay == null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.flush(this);
        return 0;
    };
    return QueueAction;
}($gxnPp.AsyncAction);
module.exports.QueueAction = $003309dc0b86ac39$var$QueueAction;

});

parcelRegister("ayI8h", function(module, exports) {
"use strict";
var $7aff50270f13c596$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueueScheduler = void 0;

var $kpIo0 = parcelRequire("kpIo0");
var $7aff50270f13c596$var$QueueScheduler = function(_super) {
    $7aff50270f13c596$var$__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}($kpIo0.AsyncScheduler);
module.exports.QueueScheduler = $7aff50270f13c596$var$QueueScheduler;

});


parcelRegister("7By2u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.animationFrame = module.exports.animationFrameScheduler = void 0;

var $7WN8s = parcelRequire("7WN8s");

var $faaSj = parcelRequire("faaSj");
module.exports.animationFrameScheduler = new $faaSj.AnimationFrameScheduler($7WN8s.AnimationFrameAction);
module.exports.animationFrame = module.exports.animationFrameScheduler;

});
parcelRegister("7WN8s", function(module, exports) {
"use strict";
var $5c9410787aea9ae7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnimationFrameAction = void 0;

var $gxnPp = parcelRequire("gxnPp");

var $emiyc = parcelRequire("emiyc");
var $5c9410787aea9ae7$var$AnimationFrameAction = function(_super) {
    $5c9410787aea9ae7$var$__extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = $emiyc.animationFrameProvider.requestAnimationFrame(function() {
            return scheduler.flush(undefined);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && id === scheduler._scheduled && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            $emiyc.animationFrameProvider.cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}($gxnPp.AsyncAction);
module.exports.AnimationFrameAction = $5c9410787aea9ae7$var$AnimationFrameAction;

});

parcelRegister("faaSj", function(module, exports) {
"use strict";
var $b0a039baf88cfb96$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnimationFrameScheduler = void 0;

var $kpIo0 = parcelRequire("kpIo0");
var $b0a039baf88cfb96$var$AnimationFrameScheduler = function(_super) {
    $b0a039baf88cfb96$var$__extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId;
        if (action) flushId = action.id;
        else {
            flushId = this._scheduled;
            this._scheduled = undefined;
        }
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}($kpIo0.AsyncScheduler);
module.exports.AnimationFrameScheduler = $b0a039baf88cfb96$var$AnimationFrameScheduler;

});


parcelRegister("8BXqA", function(module, exports) {
"use strict";
var $644fe08bd46ca312$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VirtualAction = module.exports.VirtualTimeScheduler = void 0;

var $gxnPp = parcelRequire("gxnPp");

var $3NoDj = parcelRequire("3NoDj");

var $kpIo0 = parcelRequire("kpIo0");
var $644fe08bd46ca312$var$VirtualTimeScheduler = function(_super) {
    $644fe08bd46ca312$var$__extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
        if (schedulerActionCtor === void 0) schedulerActionCtor = $644fe08bd46ca312$var$VirtualAction;
        if (maxFrames === void 0) maxFrames = Infinity;
        var _this = _super.call(this, schedulerActionCtor, function() {
            return _this.frame;
        }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error;
        var action;
        while((action = actions[0]) && action.delay <= maxFrames){
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}($kpIo0.AsyncScheduler);
module.exports.VirtualTimeScheduler = $644fe08bd46ca312$var$VirtualTimeScheduler;
var $644fe08bd46ca312$var$VirtualAction = function(_super) {
    $644fe08bd46ca312$var$__extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (Number.isFinite(delay)) {
            if (!this.id) return _super.prototype.schedule.call(this, state, delay);
            this.active = false;
            var action = new VirtualAction(this.scheduler, this.work);
            this.add(action);
            return action.schedule(state, delay);
        } else return $3NoDj.Subscription.EMPTY;
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return 1;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}($gxnPp.AsyncAction);
module.exports.VirtualAction = $644fe08bd46ca312$var$VirtualAction;

});

parcelRegister("luK57", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.observeNotification = module.exports.Notification = module.exports.NotificationKind = void 0;

var $9aeMj = parcelRequire("9aeMj");

var $253k8 = parcelRequire("253k8");

var $5qPs4 = parcelRequire("5qPs4");

var $8VYz5 = parcelRequire("8VYz5");
var $fa60252a255b7b6a$var$NotificationKind;
(function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})($fa60252a255b7b6a$var$NotificationKind = module.exports.NotificationKind || (module.exports.NotificationKind = {}));
var $fa60252a255b7b6a$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function(observer) {
        return $fa60252a255b7b6a$var$observeNotification(this, observer);
    };
    Notification.prototype.do = function(nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        var _a;
        return $8VYz5.isFunction((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next) ? this.observe(nextOrObserver) : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === 'N' ? $253k8.of(value) : kind === 'E' ? $5qPs4.throwError(function() {
            return error;
        }) : kind === 'C' ? $9aeMj.EMPTY : 0;
        if (!result) throw new TypeError("Unexpected notification kind " + kind);
        return result;
    };
    Notification.createNext = function(value) {
        return new Notification('N', value);
    };
    Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
}();
module.exports.Notification = $fa60252a255b7b6a$var$Notification;
function $fa60252a255b7b6a$var$observeNotification(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== 'string') throw new TypeError('Invalid notification, missing "kind"');
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 || _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 || _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 || _c.call(observer);
}
module.exports.observeNotification = $fa60252a255b7b6a$var$observeNotification;

});
parcelRegister("9aeMj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.empty = module.exports.EMPTY = void 0;

var $879ii = parcelRequire("879ii");
module.exports.EMPTY = new $879ii.Observable(function(subscriber) {
    return subscriber.complete();
});
function $6ac082de652c7482$var$empty(scheduler) {
    return scheduler ? $6ac082de652c7482$var$emptyScheduled(scheduler) : module.exports.EMPTY;
}
module.exports.empty = $6ac082de652c7482$var$empty;
function $6ac082de652c7482$var$emptyScheduled(scheduler) {
    return new $879ii.Observable(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});

parcelRegister("253k8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.of = void 0;

var $5D9gI = parcelRequire("5D9gI");

var $2PY6v = parcelRequire("2PY6v");
function $183ea06d3260df4a$var$of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = $5D9gI.popScheduler(args);
    return $2PY6v.from(args, scheduler);
}
module.exports.of = $183ea06d3260df4a$var$of;

});
parcelRegister("5D9gI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.popNumber = module.exports.popScheduler = module.exports.popResultSelector = void 0;

var $8VYz5 = parcelRequire("8VYz5");

var $3iFVU = parcelRequire("3iFVU");
function $4197c8ceb78719f4$var$last(arr) {
    return arr[arr.length - 1];
}
function $4197c8ceb78719f4$var$popResultSelector(args) {
    return $8VYz5.isFunction($4197c8ceb78719f4$var$last(args)) ? args.pop() : undefined;
}
module.exports.popResultSelector = $4197c8ceb78719f4$var$popResultSelector;
function $4197c8ceb78719f4$var$popScheduler(args) {
    return $3iFVU.isScheduler($4197c8ceb78719f4$var$last(args)) ? args.pop() : undefined;
}
module.exports.popScheduler = $4197c8ceb78719f4$var$popScheduler;
function $4197c8ceb78719f4$var$popNumber(args, defaultValue) {
    return typeof $4197c8ceb78719f4$var$last(args) === 'number' ? args.pop() : defaultValue;
}
module.exports.popNumber = $4197c8ceb78719f4$var$popNumber;

});
parcelRegister("3iFVU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isScheduler = void 0;

var $8VYz5 = parcelRequire("8VYz5");
function $26739493849dd96d$var$isScheduler(value) {
    return value && $8VYz5.isFunction(value.schedule);
}
module.exports.isScheduler = $26739493849dd96d$var$isScheduler;

});


parcelRegister("2PY6v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.from = void 0;

var $90c1e = parcelRequire("90c1e");

var $aJ0vk = parcelRequire("aJ0vk");
function $210ef78f4347bc8d$var$from(input, scheduler) {
    return scheduler ? $90c1e.scheduled(input, scheduler) : $aJ0vk.innerFrom(input);
}
module.exports.from = $210ef78f4347bc8d$var$from;

});
parcelRegister("90c1e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scheduled = void 0;

var $hxthZ = parcelRequire("hxthZ");

var $7SOxz = parcelRequire("7SOxz");

var $bMOzJ = parcelRequire("bMOzJ");

var $iqQyX = parcelRequire("iqQyX");

var $i3lL5 = parcelRequire("i3lL5");

var $kB4eI = parcelRequire("kB4eI");

var $fDuy1 = parcelRequire("fDuy1");

var $8OnhW = parcelRequire("8OnhW");

var $6cyMM = parcelRequire("6cyMM");

var $7BQyd = parcelRequire("7BQyd");

var $ldaMT = parcelRequire("ldaMT");

var $hHTTB = parcelRequire("hHTTB");

var $7YxvQ = parcelRequire("7YxvQ");
function $68dd6fdc8e575939$var$scheduled(input, scheduler) {
    if (input != null) {
        if ($kB4eI.isInteropObservable(input)) return $hxthZ.scheduleObservable(input, scheduler);
        if ($8OnhW.isArrayLike(input)) return $bMOzJ.scheduleArray(input, scheduler);
        if ($fDuy1.isPromise(input)) return $7SOxz.schedulePromise(input, scheduler);
        if ($7BQyd.isAsyncIterable(input)) return $i3lL5.scheduleAsyncIterable(input, scheduler);
        if ($6cyMM.isIterable(input)) return $iqQyX.scheduleIterable(input, scheduler);
        if ($hHTTB.isReadableStreamLike(input)) return $7YxvQ.scheduleReadableStreamLike(input, scheduler);
    }
    throw $ldaMT.createInvalidObservableTypeError(input);
}
module.exports.scheduled = $68dd6fdc8e575939$var$scheduled;

});
parcelRegister("hxthZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scheduleObservable = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $030h7 = parcelRequire("030h7");

var $4ezR0 = parcelRequire("4ezR0");
function $cc4c3cf2b600705f$var$scheduleObservable(input, scheduler) {
    return $aJ0vk.innerFrom(input).pipe($4ezR0.subscribeOn(scheduler), $030h7.observeOn(scheduler));
}
module.exports.scheduleObservable = $cc4c3cf2b600705f$var$scheduleObservable;

});
parcelRegister("aJ0vk", function(module, exports) {
"use strict";
var $7cee7f8489fca86a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7cee7f8489fca86a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7cee7f8489fca86a$var$__asyncValues = module.exports && module.exports.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7cee7f8489fca86a$var$__values === "function" ? $7cee7f8489fca86a$var$__values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $7cee7f8489fca86a$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromReadableStreamLike = module.exports.fromAsyncIterable = module.exports.fromIterable = module.exports.fromPromise = module.exports.fromArrayLike = module.exports.fromInteropObservable = module.exports.innerFrom = void 0;

var $8OnhW = parcelRequire("8OnhW");

var $fDuy1 = parcelRequire("fDuy1");

var $879ii = parcelRequire("879ii");

var $kB4eI = parcelRequire("kB4eI");

var $7BQyd = parcelRequire("7BQyd");

var $ldaMT = parcelRequire("ldaMT");

var $6cyMM = parcelRequire("6cyMM");

var $hHTTB = parcelRequire("hHTTB");

var $8VYz5 = parcelRequire("8VYz5");

var $fymAc = parcelRequire("fymAc");

var $I1Tai = parcelRequire("I1Tai");
function $7cee7f8489fca86a$var$innerFrom(input) {
    if (input instanceof $879ii.Observable) return input;
    if (input != null) {
        if ($kB4eI.isInteropObservable(input)) return $7cee7f8489fca86a$var$fromInteropObservable(input);
        if ($8OnhW.isArrayLike(input)) return $7cee7f8489fca86a$var$fromArrayLike(input);
        if ($fDuy1.isPromise(input)) return $7cee7f8489fca86a$var$fromPromise(input);
        if ($7BQyd.isAsyncIterable(input)) return $7cee7f8489fca86a$var$fromAsyncIterable(input);
        if ($6cyMM.isIterable(input)) return $7cee7f8489fca86a$var$fromIterable(input);
        if ($hHTTB.isReadableStreamLike(input)) return $7cee7f8489fca86a$var$fromReadableStreamLike(input);
    }
    throw $ldaMT.createInvalidObservableTypeError(input);
}
module.exports.innerFrom = $7cee7f8489fca86a$var$innerFrom;
function $7cee7f8489fca86a$var$fromInteropObservable(obj) {
    return new $879ii.Observable(function(subscriber) {
        var obs = obj[$I1Tai.observable]();
        if ($8VYz5.isFunction(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
module.exports.fromInteropObservable = $7cee7f8489fca86a$var$fromInteropObservable;
function $7cee7f8489fca86a$var$fromArrayLike(array) {
    return new $879ii.Observable(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
module.exports.fromArrayLike = $7cee7f8489fca86a$var$fromArrayLike;
function $7cee7f8489fca86a$var$fromPromise(promise) {
    return new $879ii.Observable(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, $fymAc.reportUnhandledError);
    });
}
module.exports.fromPromise = $7cee7f8489fca86a$var$fromPromise;
function $7cee7f8489fca86a$var$fromIterable(iterable) {
    return new $879ii.Observable(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = $7cee7f8489fca86a$var$__values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
module.exports.fromIterable = $7cee7f8489fca86a$var$fromIterable;
function $7cee7f8489fca86a$var$fromAsyncIterable(asyncIterable) {
    return new $879ii.Observable(function(subscriber) {
        $7cee7f8489fca86a$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
module.exports.fromAsyncIterable = $7cee7f8489fca86a$var$fromAsyncIterable;
function $7cee7f8489fca86a$var$fromReadableStreamLike(readableStream) {
    return $7cee7f8489fca86a$var$fromAsyncIterable($hHTTB.readableStreamLikeToAsyncGenerator(readableStream));
}
module.exports.fromReadableStreamLike = $7cee7f8489fca86a$var$fromReadableStreamLike;
function $7cee7f8489fca86a$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return $7cee7f8489fca86a$var$__awaiter(this, void 0, void 0, function() {
        var value, e_2_1;
        return $7cee7f8489fca86a$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = $7cee7f8489fca86a$var$__asyncValues(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("8OnhW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isArrayLike = void 0;
module.exports.isArrayLike = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

});

parcelRegister("fDuy1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isPromise = void 0;

var $8VYz5 = parcelRequire("8VYz5");
function $b62231a89f44b4db$var$isPromise(value) {
    return $8VYz5.isFunction(value === null || value === void 0 ? void 0 : value.then);
}
module.exports.isPromise = $b62231a89f44b4db$var$isPromise;

});

parcelRegister("kB4eI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInteropObservable = void 0;

var $I1Tai = parcelRequire("I1Tai");

var $8VYz5 = parcelRequire("8VYz5");
function $efea8c97c32a3f10$var$isInteropObservable(input) {
    return $8VYz5.isFunction(input[$I1Tai.observable]);
}
module.exports.isInteropObservable = $efea8c97c32a3f10$var$isInteropObservable;

});

parcelRegister("7BQyd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAsyncIterable = void 0;

var $8VYz5 = parcelRequire("8VYz5");
function $58a4c09641c65edc$var$isAsyncIterable(obj) {
    return Symbol.asyncIterator && $8VYz5.isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}
module.exports.isAsyncIterable = $58a4c09641c65edc$var$isAsyncIterable;

});

parcelRegister("ldaMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createInvalidObservableTypeError = void 0;
function $f7132e146cd34d39$var$createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
module.exports.createInvalidObservableTypeError = $f7132e146cd34d39$var$createInvalidObservableTypeError;

});

parcelRegister("6cyMM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isIterable = void 0;

var $9E8ln = parcelRequire("9E8ln");

var $8VYz5 = parcelRequire("8VYz5");
function $483ed8cdb24a0f02$var$isIterable(input) {
    return $8VYz5.isFunction(input === null || input === void 0 ? void 0 : input[$9E8ln.iterator]);
}
module.exports.isIterable = $483ed8cdb24a0f02$var$isIterable;

});
parcelRegister("9E8ln", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.iterator = module.exports.getSymbolIterator = void 0;
function $705e5266f0d9bcab$var$getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
module.exports.getSymbolIterator = $705e5266f0d9bcab$var$getSymbolIterator;
module.exports.iterator = $705e5266f0d9bcab$var$getSymbolIterator();

});


parcelRegister("hHTTB", function(module, exports) {
"use strict";
var $ce41cf8e4b407c30$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ce41cf8e4b407c30$var$__await = module.exports && module.exports.__await || function(v) {
    return this instanceof $ce41cf8e4b407c30$var$__await ? (this.v = v, this) : new $ce41cf8e4b407c30$var$__await(v);
};
var $ce41cf8e4b407c30$var$__asyncGenerator = module.exports && module.exports.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ce41cf8e4b407c30$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isReadableStreamLike = module.exports.readableStreamLikeToAsyncGenerator = void 0;

var $8VYz5 = parcelRequire("8VYz5");
function $ce41cf8e4b407c30$var$readableStreamLikeToAsyncGenerator(readableStream) {
    return $ce41cf8e4b407c30$var$__asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return $ce41cf8e4b407c30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        $ce41cf8e4b407c30$var$__await(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        $ce41cf8e4b407c30$var$__await(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        $ce41cf8e4b407c30$var$__await(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
module.exports.readableStreamLikeToAsyncGenerator = $ce41cf8e4b407c30$var$readableStreamLikeToAsyncGenerator;
function $ce41cf8e4b407c30$var$isReadableStreamLike(obj) {
    return $8VYz5.isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}
module.exports.isReadableStreamLike = $ce41cf8e4b407c30$var$isReadableStreamLike;

});


parcelRegister("030h7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.observeOn = void 0;

var $h257w = parcelRequire("h257w");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $00907e924281a9f2$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $3xclF.operate(function(source, subscriber) {
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            return $h257w.executeSchedule(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return $h257w.executeSchedule(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return $h257w.executeSchedule(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}
module.exports.observeOn = $00907e924281a9f2$var$observeOn;

});
parcelRegister("h257w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.executeSchedule = void 0;
function $c666985c836f1bf5$var$executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}
module.exports.executeSchedule = $c666985c836f1bf5$var$executeSchedule;

});


parcelRegister("4ezR0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.subscribeOn = void 0;

var $3xclF = parcelRequire("3xclF");
function $31544817370fb4ae$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $3xclF.operate(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}
module.exports.subscribeOn = $31544817370fb4ae$var$subscribeOn;

});


parcelRegister("7SOxz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.schedulePromise = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $030h7 = parcelRequire("030h7");

var $4ezR0 = parcelRequire("4ezR0");
function $5bd4c7d5f202e1ff$var$schedulePromise(input, scheduler) {
    return $aJ0vk.innerFrom(input).pipe($4ezR0.subscribeOn(scheduler), $030h7.observeOn(scheduler));
}
module.exports.schedulePromise = $5bd4c7d5f202e1ff$var$schedulePromise;

});

parcelRegister("bMOzJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scheduleArray = void 0;

var $879ii = parcelRequire("879ii");
function $894b689b91ebd132$var$scheduleArray(input, scheduler) {
    return new $879ii.Observable(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}
module.exports.scheduleArray = $894b689b91ebd132$var$scheduleArray;

});

parcelRegister("iqQyX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scheduleIterable = void 0;

var $879ii = parcelRequire("879ii");

var $9E8ln = parcelRequire("9E8ln");

var $8VYz5 = parcelRequire("8VYz5");

var $h257w = parcelRequire("h257w");
function $d6b36d91a3b2c60e$var$scheduleIterable(input, scheduler) {
    return new $879ii.Observable(function(subscriber) {
        var iterator;
        $h257w.executeSchedule(subscriber, scheduler, function() {
            iterator = input[$9E8ln.iterator]();
            $h257w.executeSchedule(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return $8VYz5.isFunction(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}
module.exports.scheduleIterable = $d6b36d91a3b2c60e$var$scheduleIterable;

});

parcelRegister("i3lL5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scheduleAsyncIterable = void 0;

var $879ii = parcelRequire("879ii");

var $h257w = parcelRequire("h257w");
function $d24962977991cfe2$var$scheduleAsyncIterable(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new $879ii.Observable(function(subscriber) {
        $h257w.executeSchedule(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            $h257w.executeSchedule(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}
module.exports.scheduleAsyncIterable = $d24962977991cfe2$var$scheduleAsyncIterable;

});

parcelRegister("7YxvQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scheduleReadableStreamLike = void 0;

var $i3lL5 = parcelRequire("i3lL5");

var $hHTTB = parcelRequire("hHTTB");
function $5ce821ee54ac7ff3$var$scheduleReadableStreamLike(input, scheduler) {
    return $i3lL5.scheduleAsyncIterable($hHTTB.readableStreamLikeToAsyncGenerator(input), scheduler);
}
module.exports.scheduleReadableStreamLike = $5ce821ee54ac7ff3$var$scheduleReadableStreamLike;

});




parcelRegister("5qPs4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.throwError = void 0;

var $879ii = parcelRequire("879ii");

var $8VYz5 = parcelRequire("8VYz5");
function $3f474ab982a10524$var$throwError(errorOrErrorFactory, scheduler) {
    var errorFactory = $8VYz5.isFunction(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new $879ii.Observable(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}
module.exports.throwError = $3f474ab982a10524$var$throwError;

});


parcelRegister("hDw7E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isObservable = void 0;

var $879ii = parcelRequire("879ii");

var $8VYz5 = parcelRequire("8VYz5");
function $cd6eff00b83bf0c4$var$isObservable(obj) {
    return !!obj && (obj instanceof $879ii.Observable || $8VYz5.isFunction(obj.lift) && $8VYz5.isFunction(obj.subscribe));
}
module.exports.isObservable = $cd6eff00b83bf0c4$var$isObservable;

});

parcelRegister("cjWvy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lastValueFrom = void 0;

var $k5xMc = parcelRequire("k5xMc");
function $8f84a4d4814d61c1$var$lastValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function(value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function() {
                if (_hasValue) resolve(_value);
                else if (hasConfig) resolve(config.defaultValue);
                else reject(new $k5xMc.EmptyError());
            }
        });
    });
}
module.exports.lastValueFrom = $8f84a4d4814d61c1$var$lastValueFrom;

});
parcelRegister("k5xMc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EmptyError = void 0;

var $jHWC9 = parcelRequire("jHWC9");
module.exports.EmptyError = $jHWC9.createErrorClass(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});

});


parcelRegister("laJT3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.firstValueFrom = void 0;

var $k5xMc = parcelRequire("k5xMc");

var $9btgx = parcelRequire("9btgx");
function $f69e205a413006ea$var$firstValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var subscriber = new $9btgx.SafeSubscriber({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new $k5xMc.EmptyError());
            }
        });
        source.subscribe(subscriber);
    });
}
module.exports.firstValueFrom = $f69e205a413006ea$var$firstValueFrom;

});

parcelRegister("9y9D2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArgumentOutOfRangeError = void 0;

var $jHWC9 = parcelRequire("jHWC9");
module.exports.ArgumentOutOfRangeError = $jHWC9.createErrorClass(function(_super) {
    return function ArgumentOutOfRangeErrorImpl() {
        _super(this);
        this.name = 'ArgumentOutOfRangeError';
        this.message = 'argument out of range';
    };
});

});

parcelRegister("fzrJl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotFoundError = void 0;

var $jHWC9 = parcelRequire("jHWC9");
module.exports.NotFoundError = $jHWC9.createErrorClass(function(_super) {
    return function NotFoundErrorImpl(message) {
        _super(this);
        this.name = 'NotFoundError';
        this.message = message;
    };
});

});

parcelRegister("62noZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SequenceError = void 0;

var $jHWC9 = parcelRequire("jHWC9");
module.exports.SequenceError = $jHWC9.createErrorClass(function(_super) {
    return function SequenceErrorImpl(message) {
        _super(this);
        this.name = 'SequenceError';
        this.message = message;
    };
});

});

parcelRegister("5oCQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeout = module.exports.TimeoutError = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $ZrESv = parcelRequire("ZrESv");

var $3xclF = parcelRequire("3xclF");

var $aJ0vk = parcelRequire("aJ0vk");

var $jHWC9 = parcelRequire("jHWC9");

var $a1JN2 = parcelRequire("a1JN2");

var $h257w = parcelRequire("h257w");
module.exports.TimeoutError = $jHWC9.createErrorClass(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function $3edd524105d1f417$var$timeout(config, schedulerArg) {
    var _a = $ZrESv.isValidDate(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? $3edd524105d1f417$var$timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : $iblpQ.asyncScheduler : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return $3xclF.operate(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = $h257w.executeSchedule(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    $aJ0vk.innerFrom(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
module.exports.timeout = $3edd524105d1f417$var$timeout;
function $3edd524105d1f417$var$timeoutErrorFactory(info) {
    throw new module.exports.TimeoutError(info);
}

});
parcelRegister("ZrESv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidDate = void 0;
function $0b8b26fcc4cdf655$var$isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}
module.exports.isValidDate = $0b8b26fcc4cdf655$var$isValidDate;

});


parcelRegister("ibMlF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindCallback = void 0;

var $lLUCm = parcelRequire("lLUCm");
function $d3dec2119c7ef70e$var$bindCallback(callbackFunc, resultSelector, scheduler) {
    return $lLUCm.bindCallbackInternals(false, callbackFunc, resultSelector, scheduler);
}
module.exports.bindCallback = $d3dec2119c7ef70e$var$bindCallback;

});
parcelRegister("lLUCm", function(module, exports) {
"use strict";
var $fd99e7d9dc034d03$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $fd99e7d9dc034d03$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindCallbackInternals = void 0;

var $3iFVU = parcelRequire("3iFVU");

var $879ii = parcelRequire("879ii");

var $4ezR0 = parcelRequire("4ezR0");

var $iJicw = parcelRequire("iJicw");

var $030h7 = parcelRequire("030h7");

var $kJoTA = parcelRequire("kJoTA");
function $fd99e7d9dc034d03$var$bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ($3iFVU.isScheduler(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return $fd99e7d9dc034d03$var$bindCallbackInternals(isNodeStyle, callbackFunc, scheduler).apply(this, args).pipe($iJicw.mapOneOrManyArgs(resultSelector));
        };
    }
    if (scheduler) return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $fd99e7d9dc034d03$var$bindCallbackInternals(isNodeStyle, callbackFunc).apply(this, args).pipe($4ezR0.subscribeOn(scheduler), $030h7.observeOn(scheduler));
    };
    return function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var subject = new $kJoTA.AsyncSubject();
        var uninitialized = true;
        return new $879ii.Observable(function(subscriber) {
            var subs = subject.subscribe(subscriber);
            if (uninitialized) {
                uninitialized = false;
                var isAsync_1 = false;
                var isComplete_1 = false;
                callbackFunc.apply(_this, $fd99e7d9dc034d03$var$__spreadArray($fd99e7d9dc034d03$var$__spreadArray([], $fd99e7d9dc034d03$var$__read(args)), [
                    function() {
                        var results = [];
                        for(var _i = 0; _i < arguments.length; _i++)results[_i] = arguments[_i];
                        if (isNodeStyle) {
                            var err = results.shift();
                            if (err != null) {
                                subject.error(err);
                                return;
                            }
                        }
                        subject.next(1 < results.length ? results : results[0]);
                        isComplete_1 = true;
                        if (isAsync_1) subject.complete();
                    }
                ]));
                if (isComplete_1) subject.complete();
                isAsync_1 = true;
            }
            return subs;
        });
    };
}
module.exports.bindCallbackInternals = $fd99e7d9dc034d03$var$bindCallbackInternals;

});
parcelRegister("iJicw", function(module, exports) {
"use strict";
var $da2a8c4a76eacc7c$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $da2a8c4a76eacc7c$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapOneOrManyArgs = void 0;

var $dlvLZ = parcelRequire("dlvLZ");
var $da2a8c4a76eacc7c$var$isArray = Array.isArray;
function $da2a8c4a76eacc7c$var$callOrApply(fn, args) {
    return $da2a8c4a76eacc7c$var$isArray(args) ? fn.apply(void 0, $da2a8c4a76eacc7c$var$__spreadArray([], $da2a8c4a76eacc7c$var$__read(args))) : fn(args);
}
function $da2a8c4a76eacc7c$var$mapOneOrManyArgs(fn) {
    return $dlvLZ.map(function(args) {
        return $da2a8c4a76eacc7c$var$callOrApply(fn, args);
    });
}
module.exports.mapOneOrManyArgs = $da2a8c4a76eacc7c$var$mapOneOrManyArgs;

});
parcelRegister("dlvLZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.map = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $9b75e1fb68b16bd2$var$map(project, thisArg) {
    return $3xclF.operate(function(source, subscriber) {
        var index = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}
module.exports.map = $9b75e1fb68b16bd2$var$map;

});




parcelRegister("jTXd9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindNodeCallback = void 0;

var $lLUCm = parcelRequire("lLUCm");
function $e7d115784793c529$var$bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    return $lLUCm.bindCallbackInternals(true, callbackFunc, resultSelector, scheduler);
}
module.exports.bindNodeCallback = $e7d115784793c529$var$bindNodeCallback;

});

parcelRegister("fHu9p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.combineLatestInit = module.exports.combineLatest = void 0;

var $879ii = parcelRequire("879ii");

var $cFES0 = parcelRequire("cFES0");

var $2PY6v = parcelRequire("2PY6v");

var $doKTd = parcelRequire("doKTd");

var $iJicw = parcelRequire("iJicw");

var $5D9gI = parcelRequire("5D9gI");

var $9W21Q = parcelRequire("9W21Q");

var $a1JN2 = parcelRequire("a1JN2");

var $h257w = parcelRequire("h257w");
function $b6e242778239a156$var$combineLatest() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = $5D9gI.popScheduler(args);
    var resultSelector = $5D9gI.popResultSelector(args);
    var _a = $cFES0.argsArgArrayOrObject(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return $2PY6v.from([], scheduler);
    var result = new $879ii.Observable($b6e242778239a156$var$combineLatestInit(observables, scheduler, keys ? function(values) {
        return $9W21Q.createObject(keys, values);
    } : $doKTd.identity));
    return resultSelector ? result.pipe($iJicw.mapOneOrManyArgs(resultSelector)) : result;
}
module.exports.combineLatest = $b6e242778239a156$var$combineLatest;
function $b6e242778239a156$var$combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = $doKTd.identity;
    return function(subscriber) {
        $b6e242778239a156$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $b6e242778239a156$var$maybeSchedule(scheduler, function() {
                    var source = $2PY6v.from(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
module.exports.combineLatestInit = $b6e242778239a156$var$combineLatestInit;
function $b6e242778239a156$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) $h257w.executeSchedule(subscription, scheduler, execute);
    else execute();
}

});
parcelRegister("cFES0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.argsArgArrayOrObject = void 0;
var $9399044edefc766b$var$isArray = Array.isArray;
var $9399044edefc766b$var$getPrototypeOf = Object.getPrototypeOf, $9399044edefc766b$var$objectProto = Object.prototype, $9399044edefc766b$var$getKeys = Object.keys;
function $9399044edefc766b$var$argsArgArrayOrObject(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($9399044edefc766b$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($9399044edefc766b$var$isPOJO(first_1)) {
            var keys = $9399044edefc766b$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
module.exports.argsArgArrayOrObject = $9399044edefc766b$var$argsArgArrayOrObject;
function $9399044edefc766b$var$isPOJO(obj) {
    return obj && typeof obj === 'object' && $9399044edefc766b$var$getPrototypeOf(obj) === $9399044edefc766b$var$objectProto;
}

});

parcelRegister("9W21Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createObject = void 0;
function $73bb1aaf9401a723$var$createObject(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}
module.exports.createObject = $73bb1aaf9401a723$var$createObject;

});


parcelRegister("2YgGw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concat = void 0;

var $ibJWH = parcelRequire("ibJWH");

var $5D9gI = parcelRequire("5D9gI");

var $2PY6v = parcelRequire("2PY6v");
function $229e20a52a717f3c$var$concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $ibJWH.concatAll()($2PY6v.from(args, $5D9gI.popScheduler(args)));
}
module.exports.concat = $229e20a52a717f3c$var$concat;

});
parcelRegister("ibJWH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concatAll = void 0;

var $bGQoL = parcelRequire("bGQoL");
function $d3dce4f6ec3f23ff$var$concatAll() {
    return $bGQoL.mergeAll(1);
}
module.exports.concatAll = $d3dce4f6ec3f23ff$var$concatAll;

});
parcelRegister("bGQoL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeAll = void 0;

var $9yos9 = parcelRequire("9yos9");

var $doKTd = parcelRequire("doKTd");
function $882c432a4c7a11bc$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return $9yos9.mergeMap($doKTd.identity, concurrent);
}
module.exports.mergeAll = $882c432a4c7a11bc$var$mergeAll;

});
parcelRegister("9yos9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeMap = void 0;

var $dlvLZ = parcelRequire("dlvLZ");

var $aJ0vk = parcelRequire("aJ0vk");

var $3xclF = parcelRequire("3xclF");

var $4EiaP = parcelRequire("4EiaP");

var $8VYz5 = parcelRequire("8VYz5");
function $6f4a41df9a5d98e1$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ($8VYz5.isFunction(resultSelector)) return $6f4a41df9a5d98e1$var$mergeMap(function(a, i) {
        return $dlvLZ.map(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })($aJ0vk.innerFrom(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return $3xclF.operate(function(source, subscriber) {
        return $4EiaP.mergeInternals(source, subscriber, project, concurrent);
    });
}
module.exports.mergeMap = $6f4a41df9a5d98e1$var$mergeMap;

});
parcelRegister("4EiaP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeInternals = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $h257w = parcelRequire("h257w");

var $a1JN2 = parcelRequire("a1JN2");
function $3628febcc2a24c24$var$mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        $aJ0vk.innerFrom(project(value, index++)).subscribe($a1JN2.createOperatorSubscriber(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) $h257w.executeSchedule(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe($a1JN2.createOperatorSubscriber(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}
module.exports.mergeInternals = $3628febcc2a24c24$var$mergeInternals;

});





parcelRegister("24vN0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectable = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $879ii = parcelRequire("879ii");

var $aVPeW = parcelRequire("aVPeW");
var $18249d39acd65622$var$DEFAULT_CONFIG = {
    connector: function() {
        return new $7qEr0.Subject();
    },
    resetOnDisconnect: true
};
function $18249d39acd65622$var$connectable(source, config) {
    if (config === void 0) config = $18249d39acd65622$var$DEFAULT_CONFIG;
    var connection = null;
    var connector = config.connector, _a = config.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
    var subject = connector();
    var result = new $879ii.Observable(function(subscriber) {
        return subject.subscribe(subscriber);
    });
    result.connect = function() {
        if (!connection || connection.closed) {
            connection = $aVPeW.defer(function() {
                return source;
            }).subscribe(subject);
            if (resetOnDisconnect) connection.add(function() {
                return subject = connector();
            });
        }
        return connection;
    };
    return result;
}
module.exports.connectable = $18249d39acd65622$var$connectable;

});
parcelRegister("aVPeW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defer = void 0;

var $879ii = parcelRequire("879ii");

var $aJ0vk = parcelRequire("aJ0vk");
function $7f56f96c4b02c672$var$defer(observableFactory) {
    return new $879ii.Observable(function(subscriber) {
        $aJ0vk.innerFrom(observableFactory()).subscribe(subscriber);
    });
}
module.exports.defer = $7f56f96c4b02c672$var$defer;

});


parcelRegister("dL0gl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.forkJoin = void 0;

var $879ii = parcelRequire("879ii");

var $cFES0 = parcelRequire("cFES0");

var $aJ0vk = parcelRequire("aJ0vk");

var $5D9gI = parcelRequire("5D9gI");

var $a1JN2 = parcelRequire("a1JN2");

var $iJicw = parcelRequire("iJicw");

var $9W21Q = parcelRequire("9W21Q");
function $a03fde4cad785260$var$forkJoin() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = $5D9gI.popResultSelector(args);
    var _a = $cFES0.argsArgArrayOrObject(args), sources = _a.args, keys = _a.keys;
    var result = new $879ii.Observable(function(subscriber) {
        var length = sources.length;
        if (!length) {
            subscriber.complete();
            return;
        }
        var values = new Array(length);
        var remainingCompletions = length;
        var remainingEmissions = length;
        var _loop_1 = function(sourceIndex) {
            var hasValue = false;
            $aJ0vk.innerFrom(sources[sourceIndex]).subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
                if (!hasValue) {
                    hasValue = true;
                    remainingEmissions--;
                }
                values[sourceIndex] = value;
            }, function() {
                return remainingCompletions--;
            }, undefined, function() {
                if (!remainingCompletions || !hasValue) {
                    if (!remainingEmissions) subscriber.next(keys ? $9W21Q.createObject(keys, values) : values);
                    subscriber.complete();
                }
            }));
        };
        for(var sourceIndex = 0; sourceIndex < length; sourceIndex++)_loop_1(sourceIndex);
    });
    return resultSelector ? result.pipe($iJicw.mapOneOrManyArgs(resultSelector)) : result;
}
module.exports.forkJoin = $a03fde4cad785260$var$forkJoin;

});

parcelRegister("la5Mt", function(module, exports) {
"use strict";
var $f67f041c7506a2ab$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromEvent = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $879ii = parcelRequire("879ii");

var $9yos9 = parcelRequire("9yos9");

var $8OnhW = parcelRequire("8OnhW");

var $8VYz5 = parcelRequire("8VYz5");

var $iJicw = parcelRequire("iJicw");
var $f67f041c7506a2ab$var$nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var $f67f041c7506a2ab$var$eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var $f67f041c7506a2ab$var$jqueryMethods = [
    'on',
    'off'
];
function $f67f041c7506a2ab$var$fromEvent(target, eventName, options, resultSelector) {
    if ($8VYz5.isFunction(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $f67f041c7506a2ab$var$fromEvent(target, eventName, options).pipe($iJicw.mapOneOrManyArgs(resultSelector));
    var _a = $f67f041c7506a2ab$var$__read($f67f041c7506a2ab$var$isEventTarget(target) ? $f67f041c7506a2ab$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $f67f041c7506a2ab$var$isNodeStyleEventEmitter(target) ? $f67f041c7506a2ab$var$nodeEventEmitterMethods.map($f67f041c7506a2ab$var$toCommonHandlerRegistry(target, eventName)) : $f67f041c7506a2ab$var$isJQueryStyleEventEmitter(target) ? $f67f041c7506a2ab$var$jqueryMethods.map($f67f041c7506a2ab$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ($8OnhW.isArrayLike(target)) return $9yos9.mergeMap(function(subTarget) {
            return $f67f041c7506a2ab$var$fromEvent(subTarget, eventName, options);
        })($aJ0vk.innerFrom(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new $879ii.Observable(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
module.exports.fromEvent = $f67f041c7506a2ab$var$fromEvent;
function $f67f041c7506a2ab$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $f67f041c7506a2ab$var$isNodeStyleEventEmitter(target) {
    return $8VYz5.isFunction(target.addListener) && $8VYz5.isFunction(target.removeListener);
}
function $f67f041c7506a2ab$var$isJQueryStyleEventEmitter(target) {
    return $8VYz5.isFunction(target.on) && $8VYz5.isFunction(target.off);
}
function $f67f041c7506a2ab$var$isEventTarget(target) {
    return $8VYz5.isFunction(target.addEventListener) && $8VYz5.isFunction(target.removeEventListener);
}

});

parcelRegister("diUca", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromEventPattern = void 0;

var $879ii = parcelRequire("879ii");

var $8VYz5 = parcelRequire("8VYz5");

var $iJicw = parcelRequire("iJicw");
function $9af88c01d1043159$var$fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return $9af88c01d1043159$var$fromEventPattern(addHandler, removeHandler).pipe($iJicw.mapOneOrManyArgs(resultSelector));
    return new $879ii.Observable(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return $8VYz5.isFunction(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}
module.exports.fromEventPattern = $9af88c01d1043159$var$fromEventPattern;

});

parcelRegister("7hDHk", function(module, exports) {
"use strict";
var $54d8ea1cd2ad5873$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generate = void 0;

var $doKTd = parcelRequire("doKTd");

var $3iFVU = parcelRequire("3iFVU");

var $aVPeW = parcelRequire("aVPeW");

var $iqQyX = parcelRequire("iqQyX");
function $54d8ea1cd2ad5873$var$generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
    var _a, _b;
    var resultSelector;
    var initialState;
    if (arguments.length === 1) _a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? $doKTd.identity : _b, scheduler = _a.scheduler;
    else {
        initialState = initialStateOrOptions;
        if (!resultSelectorOrScheduler || $3iFVU.isScheduler(resultSelectorOrScheduler)) {
            resultSelector = $doKTd.identity;
            scheduler = resultSelectorOrScheduler;
        } else resultSelector = resultSelectorOrScheduler;
    }
    function gen() {
        var state;
        return $54d8ea1cd2ad5873$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    state = initialState;
                    _a.label = 1;
                case 1:
                    if (!(!condition || condition(state))) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        resultSelector(state)
                    ];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    state = iterate(state);
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }
    return $aVPeW.defer(scheduler ? function() {
        return $iqQyX.scheduleIterable(gen(), scheduler);
    } : gen);
}
module.exports.generate = $54d8ea1cd2ad5873$var$generate;

});

parcelRegister("8hvhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.iif = void 0;

var $aVPeW = parcelRequire("aVPeW");
function $60782d79bcb5f5ea$var$iif(condition, trueResult, falseResult) {
    return $aVPeW.defer(function() {
        return condition() ? trueResult : falseResult;
    });
}
module.exports.iif = $60782d79bcb5f5ea$var$iif;

});

parcelRegister("aIEIf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interval = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $5VhA3 = parcelRequire("5VhA3");
function $7cdd981cca48cfd1$var$interval(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = $iblpQ.asyncScheduler;
    if (period < 0) period = 0;
    return $5VhA3.timer(period, period, scheduler);
}
module.exports.interval = $7cdd981cca48cfd1$var$interval;

});
parcelRegister("5VhA3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timer = void 0;

var $879ii = parcelRequire("879ii");

var $iblpQ = parcelRequire("iblpQ");

var $3iFVU = parcelRequire("3iFVU");

var $ZrESv = parcelRequire("ZrESv");
function $44ffe9c4c15ef805$var$timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = $iblpQ.async;
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ($3iFVU.isScheduler(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new $879ii.Observable(function(subscriber) {
        var due = $ZrESv.isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}
module.exports.timer = $44ffe9c4c15ef805$var$timer;

});


parcelRegister("fMdVJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.merge = void 0;

var $bGQoL = parcelRequire("bGQoL");

var $aJ0vk = parcelRequire("aJ0vk");

var $9aeMj = parcelRequire("9aeMj");

var $5D9gI = parcelRequire("5D9gI");

var $2PY6v = parcelRequire("2PY6v");
function $b7c624ee42c7af55$var$merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = $5D9gI.popScheduler(args);
    var concurrent = $5D9gI.popNumber(args, Infinity);
    var sources = args;
    return !sources.length ? $9aeMj.EMPTY : sources.length === 1 ? $aJ0vk.innerFrom(sources[0]) : $bGQoL.mergeAll(concurrent)($2PY6v.from(sources, scheduler));
}
module.exports.merge = $b7c624ee42c7af55$var$merge;

});

parcelRegister("fSH8M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.never = module.exports.NEVER = void 0;

var $879ii = parcelRequire("879ii");

var $6UXs2 = parcelRequire("6UXs2");
module.exports.NEVER = new $879ii.Observable($6UXs2.noop);
function $b8fd5cffc15f09be$var$never() {
    return module.exports.NEVER;
}
module.exports.never = $b8fd5cffc15f09be$var$never;

});

parcelRegister("5W86T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.onErrorResumeNext = void 0;

var $879ii = parcelRequire("879ii");

var $2RXLX = parcelRequire("2RXLX");

var $a1JN2 = parcelRequire("a1JN2");

var $6UXs2 = parcelRequire("6UXs2");

var $aJ0vk = parcelRequire("aJ0vk");
function $4528a90e2d81e938$var$onErrorResumeNext() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var nextSources = $2RXLX.argsOrArgArray(sources);
    return new $879ii.Observable(function(subscriber) {
        var sourceIndex = 0;
        var subscribeNext = function() {
            if (sourceIndex < nextSources.length) {
                var nextSource = void 0;
                try {
                    nextSource = $aJ0vk.innerFrom(nextSources[sourceIndex++]);
                } catch (err) {
                    subscribeNext();
                    return;
                }
                var innerSubscriber = new $a1JN2.OperatorSubscriber(subscriber, undefined, $6UXs2.noop, $6UXs2.noop);
                nextSource.subscribe(innerSubscriber);
                innerSubscriber.add(subscribeNext);
            } else subscriber.complete();
        };
        subscribeNext();
    });
}
module.exports.onErrorResumeNext = $4528a90e2d81e938$var$onErrorResumeNext;

});
parcelRegister("2RXLX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.argsOrArgArray = void 0;
var $216ee5994c49551c$var$isArray = Array.isArray;
function $216ee5994c49551c$var$argsOrArgArray(args) {
    return args.length === 1 && $216ee5994c49551c$var$isArray(args[0]) ? args[0] : args;
}
module.exports.argsOrArgArray = $216ee5994c49551c$var$argsOrArgArray;

});


parcelRegister("bCWwp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pairs = void 0;

var $2PY6v = parcelRequire("2PY6v");
function $8770a37deb0e1a0f$var$pairs(obj, scheduler) {
    return $2PY6v.from(Object.entries(obj), scheduler);
}
module.exports.pairs = $8770a37deb0e1a0f$var$pairs;

});

parcelRegister("cmbhc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.partition = void 0;

var $3C8X6 = parcelRequire("3C8X6");

var $9UB7l = parcelRequire("9UB7l");

var $aJ0vk = parcelRequire("aJ0vk");
function $8ff0495cbe8f3cf2$var$partition(source, predicate, thisArg) {
    return [
        $9UB7l.filter(predicate, thisArg)($aJ0vk.innerFrom(source)),
        $9UB7l.filter($3C8X6.not(predicate, thisArg))($aJ0vk.innerFrom(source))
    ];
}
module.exports.partition = $8ff0495cbe8f3cf2$var$partition;

});
parcelRegister("3C8X6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.not = void 0;
function $2a1bdd749de1b4fe$var$not(pred, thisArg) {
    return function(value, index) {
        return !pred.call(thisArg, value, index);
    };
}
module.exports.not = $2a1bdd749de1b4fe$var$not;

});

parcelRegister("9UB7l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filter = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $737622caa02cf605$var$filter(predicate, thisArg) {
    return $3xclF.operate(function(source, subscriber) {
        var index = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}
module.exports.filter = $737622caa02cf605$var$filter;

});


parcelRegister("fm02T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.raceInit = module.exports.race = void 0;

var $879ii = parcelRequire("879ii");

var $aJ0vk = parcelRequire("aJ0vk");

var $2RXLX = parcelRequire("2RXLX");

var $a1JN2 = parcelRequire("a1JN2");
function $b2d8f224f42352cd$var$race() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    sources = $2RXLX.argsOrArgArray(sources);
    return sources.length === 1 ? $aJ0vk.innerFrom(sources[0]) : new $879ii.Observable($b2d8f224f42352cd$var$raceInit(sources));
}
module.exports.race = $b2d8f224f42352cd$var$race;
function $b2d8f224f42352cd$var$raceInit(sources) {
    return function(subscriber) {
        var subscriptions = [];
        var _loop_1 = function(i) {
            subscriptions.push($aJ0vk.innerFrom(sources[i]).subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
                if (subscriptions) {
                    for(var s = 0; s < subscriptions.length; s++)s !== i && subscriptions[s].unsubscribe();
                    subscriptions = null;
                }
                subscriber.next(value);
            })));
        };
        for(var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++)_loop_1(i);
    };
}
module.exports.raceInit = $b2d8f224f42352cd$var$raceInit;

});

parcelRegister("8jGlj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.range = void 0;

var $879ii = parcelRequire("879ii");

var $9aeMj = parcelRequire("9aeMj");
function $60e0f175435540d5$var$range(start, count, scheduler) {
    if (count == null) {
        count = start;
        start = 0;
    }
    if (count <= 0) return $9aeMj.EMPTY;
    var end = count + start;
    return new $879ii.Observable(scheduler ? function(subscriber) {
        var n = start;
        return scheduler.schedule(function() {
            if (n < end) {
                subscriber.next(n++);
                this.schedule();
            } else subscriber.complete();
        });
    } : function(subscriber) {
        var n = start;
        while(n < end && !subscriber.closed)subscriber.next(n++);
        subscriber.complete();
    });
}
module.exports.range = $60e0f175435540d5$var$range;

});

parcelRegister("fsBsD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.using = void 0;

var $879ii = parcelRequire("879ii");

var $aJ0vk = parcelRequire("aJ0vk");

var $9aeMj = parcelRequire("9aeMj");
function $b416878068d2be14$var$using(resourceFactory, observableFactory) {
    return new $879ii.Observable(function(subscriber) {
        var resource = resourceFactory();
        var result = observableFactory(resource);
        var source = result ? $aJ0vk.innerFrom(result) : $9aeMj.EMPTY;
        source.subscribe(subscriber);
        return function() {
            if (resource) resource.unsubscribe();
        };
    });
}
module.exports.using = $b416878068d2be14$var$using;

});

parcelRegister("8aMcK", function(module, exports) {
"use strict";
var $5f34a659fe9a4298$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5f34a659fe9a4298$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zip = void 0;

var $879ii = parcelRequire("879ii");

var $aJ0vk = parcelRequire("aJ0vk");

var $2RXLX = parcelRequire("2RXLX");

var $9aeMj = parcelRequire("9aeMj");

var $a1JN2 = parcelRequire("a1JN2");

var $5D9gI = parcelRequire("5D9gI");
function $5f34a659fe9a4298$var$zip() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = $5D9gI.popResultSelector(args);
    var sources = $2RXLX.argsOrArgArray(args);
    return sources.length ? new $879ii.Observable(function(subscriber) {
        var buffers = sources.map(function() {
            return [];
        });
        var completed = sources.map(function() {
            return false;
        });
        subscriber.add(function() {
            buffers = completed = null;
        });
        var _loop_1 = function(sourceIndex) {
            $aJ0vk.innerFrom(sources[sourceIndex]).subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
                buffers[sourceIndex].push(value);
                if (buffers.every(function(buffer) {
                    return buffer.length;
                })) {
                    var result = buffers.map(function(buffer) {
                        return buffer.shift();
                    });
                    subscriber.next(resultSelector ? resultSelector.apply(void 0, $5f34a659fe9a4298$var$__spreadArray([], $5f34a659fe9a4298$var$__read(result))) : result);
                    if (buffers.some(function(buffer, i) {
                        return !buffer.length && completed[i];
                    })) subscriber.complete();
                }
            }, function() {
                completed[sourceIndex] = true;
                !buffers[sourceIndex].length && subscriber.complete();
            }));
        };
        for(var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++)_loop_1(sourceIndex);
        return function() {
            buffers = completed = null;
        };
    }) : $9aeMj.EMPTY;
}
module.exports.zip = $5f34a659fe9a4298$var$zip;

});

parcelRegister("8v10a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("GJKWZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.audit = void 0;

var $3xclF = parcelRequire("3xclF");

var $aJ0vk = parcelRequire("aJ0vk");

var $a1JN2 = parcelRequire("a1JN2");
function $08076a996eac08f0$var$audit(durationSelector) {
    return $3xclF.operate(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var isComplete = false;
        var endDuration = function() {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
            isComplete && subscriber.complete();
        };
        var cleanupDuration = function() {
            durationSubscriber = null;
            isComplete && subscriber.complete();
        };
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            hasValue = true;
            lastValue = value;
            if (!durationSubscriber) $aJ0vk.innerFrom(durationSelector(value)).subscribe(durationSubscriber = $a1JN2.createOperatorSubscriber(subscriber, endDuration, cleanupDuration));
        }, function() {
            isComplete = true;
            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
        }));
    });
}
module.exports.audit = $08076a996eac08f0$var$audit;

});

parcelRegister("74irm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.auditTime = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $GJKWZ = parcelRequire("GJKWZ");

var $5VhA3 = parcelRequire("5VhA3");
function $525735f9c30e7f86$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $iblpQ.asyncScheduler;
    return $GJKWZ.audit(function() {
        return $5VhA3.timer(duration, scheduler);
    });
}
module.exports.auditTime = $525735f9c30e7f86$var$auditTime;

});

parcelRegister("5AHzz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buffer = void 0;

var $3xclF = parcelRequire("3xclF");

var $6UXs2 = parcelRequire("6UXs2");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");
function $41221d2a2377d335$var$buffer(closingNotifier) {
    return $3xclF.operate(function(source, subscriber) {
        var currentBuffer = [];
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            return currentBuffer.push(value);
        }, function() {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        $aJ0vk.innerFrom(closingNotifier).subscribe($a1JN2.createOperatorSubscriber(subscriber, function() {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, $6UXs2.noop));
        return function() {
            currentBuffer = null;
        };
    });
}
module.exports.buffer = $41221d2a2377d335$var$buffer;

});

parcelRegister("lra6r", function(module, exports) {
"use strict";
var $f9b3f4cbce9f760a$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bufferCount = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $59Z75 = parcelRequire("59Z75");
function $f9b3f4cbce9f760a$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
    return $3xclF.operate(function(source, subscriber) {
        var buffers = [];
        var count = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var e_1, _a, e_2, _b;
            var toEmit = null;
            if (count++ % startBufferEvery === 0) buffers.push([]);
            try {
                for(var buffers_1 = $f9b3f4cbce9f760a$var$__values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()){
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                    if (bufferSize <= buffer.length) {
                        toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
                        toEmit.push(buffer);
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (toEmit) try {
                for(var toEmit_1 = $f9b3f4cbce9f760a$var$__values(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()){
                    var buffer = toEmit_1_1.value;
                    $59Z75.arrRemove(buffers, buffer);
                    subscriber.next(buffer);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }, function() {
            var e_3, _a;
            try {
                for(var buffers_2 = $f9b3f4cbce9f760a$var$__values(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()){
                    var buffer = buffers_2_1.value;
                    subscriber.next(buffer);
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            subscriber.complete();
        }, undefined, function() {
            buffers = null;
        }));
    });
}
module.exports.bufferCount = $f9b3f4cbce9f760a$var$bufferCount;

});

parcelRegister("iwmnp", function(module, exports) {
"use strict";
var $d7bc92ab54468d61$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bufferTime = void 0;

var $3NoDj = parcelRequire("3NoDj");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $59Z75 = parcelRequire("59Z75");

var $iblpQ = parcelRequire("iblpQ");

var $5D9gI = parcelRequire("5D9gI");

var $h257w = parcelRequire("h257w");
function $d7bc92ab54468d61$var$bufferTime(bufferTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)otherArgs[_i - 1] = arguments[_i];
    var scheduler = (_a = $5D9gI.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : $iblpQ.asyncScheduler;
    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxBufferSize = otherArgs[1] || Infinity;
    return $3xclF.operate(function(source, subscriber) {
        var bufferRecords = [];
        var restartOnEmit = false;
        var emit = function(record) {
            var buffer = record.buffer, subs = record.subs;
            subs.unsubscribe();
            $59Z75.arrRemove(bufferRecords, record);
            subscriber.next(buffer);
            restartOnEmit && startBuffer();
        };
        var startBuffer = function() {
            if (bufferRecords) {
                var subs = new $3NoDj.Subscription();
                subscriber.add(subs);
                var buffer = [];
                var record_1 = {
                    buffer: buffer,
                    subs: subs
                };
                bufferRecords.push(record_1);
                $h257w.executeSchedule(subs, scheduler, function() {
                    return emit(record_1);
                }, bufferTimeSpan);
            }
        };
        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) $h257w.executeSchedule(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
        else restartOnEmit = true;
        startBuffer();
        var bufferTimeSubscriber = $a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var e_1, _a;
            var recordsCopy = bufferRecords.slice();
            try {
                for(var recordsCopy_1 = $d7bc92ab54468d61$var$__values(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()){
                    var record = recordsCopy_1_1.value;
                    var buffer = record.buffer;
                    buffer.push(value);
                    maxBufferSize <= buffer.length && emit(record);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length)subscriber.next(bufferRecords.shift().buffer);
            bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 || bufferTimeSubscriber.unsubscribe();
            subscriber.complete();
            subscriber.unsubscribe();
        }, undefined, function() {
            return bufferRecords = null;
        });
        source.subscribe(bufferTimeSubscriber);
    });
}
module.exports.bufferTime = $d7bc92ab54468d61$var$bufferTime;

});

parcelRegister("4LjBN", function(module, exports) {
"use strict";
var $377ac30fb49beb92$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bufferToggle = void 0;

var $3NoDj = parcelRequire("3NoDj");

var $3xclF = parcelRequire("3xclF");

var $aJ0vk = parcelRequire("aJ0vk");

var $a1JN2 = parcelRequire("a1JN2");

var $6UXs2 = parcelRequire("6UXs2");

var $59Z75 = parcelRequire("59Z75");
function $377ac30fb49beb92$var$bufferToggle(openings, closingSelector) {
    return $3xclF.operate(function(source, subscriber) {
        var buffers = [];
        $aJ0vk.innerFrom(openings).subscribe($a1JN2.createOperatorSubscriber(subscriber, function(openValue) {
            var buffer = [];
            buffers.push(buffer);
            var closingSubscription = new $3NoDj.Subscription();
            var emitBuffer = function() {
                $59Z75.arrRemove(buffers, buffer);
                subscriber.next(buffer);
                closingSubscription.unsubscribe();
            };
            closingSubscription.add($aJ0vk.innerFrom(closingSelector(openValue)).subscribe($a1JN2.createOperatorSubscriber(subscriber, emitBuffer, $6UXs2.noop)));
        }, $6UXs2.noop));
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var e_1, _a;
            try {
                for(var buffers_1 = $377ac30fb49beb92$var$__values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()){
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(buffers.length > 0)subscriber.next(buffers.shift());
            subscriber.complete();
        }));
    });
}
module.exports.bufferToggle = $377ac30fb49beb92$var$bufferToggle;

});

parcelRegister("aDvMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bufferWhen = void 0;

var $3xclF = parcelRequire("3xclF");

var $6UXs2 = parcelRequire("6UXs2");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");
function $7be6343ceeb1251e$var$bufferWhen(closingSelector) {
    return $3xclF.operate(function(source, subscriber) {
        var buffer = null;
        var closingSubscriber = null;
        var openBuffer = function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            var b = buffer;
            buffer = [];
            b && subscriber.next(b);
            $aJ0vk.innerFrom(closingSelector()).subscribe(closingSubscriber = $a1JN2.createOperatorSubscriber(subscriber, openBuffer, $6UXs2.noop));
        };
        openBuffer();
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            return buffer === null || buffer === void 0 ? void 0 : buffer.push(value);
        }, function() {
            buffer && subscriber.next(buffer);
            subscriber.complete();
        }, undefined, function() {
            return buffer = closingSubscriber = null;
        }));
    });
}
module.exports.bufferWhen = $7be6343ceeb1251e$var$bufferWhen;

});

parcelRegister("cKLIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.catchError = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $a1JN2 = parcelRequire("a1JN2");

var $3xclF = parcelRequire("3xclF");
function $948ecb9683ad4598$var$catchError(selector) {
    return $3xclF.operate(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe($a1JN2.createOperatorSubscriber(subscriber, undefined, undefined, function(err) {
            handledResult = $aJ0vk.innerFrom(selector(err, $948ecb9683ad4598$var$catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}
module.exports.catchError = $948ecb9683ad4598$var$catchError;

});

parcelRegister("hi56J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.combineAll = void 0;

var $5mmFD = parcelRequire("5mmFD");
module.exports.combineAll = $5mmFD.combineLatestAll;

});
parcelRegister("5mmFD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.combineLatestAll = void 0;

var $fHu9p = parcelRequire("fHu9p");

var $efc78 = parcelRequire("efc78");
function $0101d0e615c53c9d$var$combineLatestAll(project) {
    return $efc78.joinAllInternals($fHu9p.combineLatest, project);
}
module.exports.combineLatestAll = $0101d0e615c53c9d$var$combineLatestAll;

});
parcelRegister("efc78", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.joinAllInternals = void 0;

var $doKTd = parcelRequire("doKTd");

var $iJicw = parcelRequire("iJicw");

var $2LtHu = parcelRequire("2LtHu");

var $9yos9 = parcelRequire("9yos9");

var $dEi09 = parcelRequire("dEi09");
function $a5ebdcff48b54576$var$joinAllInternals(joinFn, project) {
    return $2LtHu.pipe($dEi09.toArray(), $9yos9.mergeMap(function(sources) {
        return joinFn(sources);
    }), project ? $iJicw.mapOneOrManyArgs(project) : $doKTd.identity);
}
module.exports.joinAllInternals = $a5ebdcff48b54576$var$joinAllInternals;

});
parcelRegister("dEi09", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toArray = void 0;

var $1DJZU = parcelRequire("1DJZU");

var $3xclF = parcelRequire("3xclF");
var $9efcf9806f088fde$var$arrReducer = function(arr, value) {
    return arr.push(value), arr;
};
function $9efcf9806f088fde$var$toArray() {
    return $3xclF.operate(function(source, subscriber) {
        $1DJZU.reduce($9efcf9806f088fde$var$arrReducer, [])(source).subscribe(subscriber);
    });
}
module.exports.toArray = $9efcf9806f088fde$var$toArray;

});
parcelRegister("1DJZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reduce = void 0;

var $9vrCz = parcelRequire("9vrCz");

var $3xclF = parcelRequire("3xclF");
function $131d1d237502f733$var$reduce(accumulator, seed) {
    return $3xclF.operate($9vrCz.scanInternals(accumulator, seed, arguments.length >= 2, false, true));
}
module.exports.reduce = $131d1d237502f733$var$reduce;

});
parcelRegister("9vrCz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scanInternals = void 0;

var $a1JN2 = parcelRequire("a1JN2");
function $6ebc6f4c99c35707$var$scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}
module.exports.scanInternals = $6ebc6f4c99c35707$var$scanInternals;

});






parcelRegister("bkZDh", function(module, exports) {
"use strict";
var $84115eec0e2531be$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $84115eec0e2531be$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.combineLatestWith = void 0;

var $47dw7 = parcelRequire("47dw7");
function $84115eec0e2531be$var$combineLatestWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return $47dw7.combineLatest.apply(void 0, $84115eec0e2531be$var$__spreadArray([], $84115eec0e2531be$var$__read(otherSources)));
}
module.exports.combineLatestWith = $84115eec0e2531be$var$combineLatestWith;

});
parcelRegister("47dw7", function(module, exports) {
"use strict";
var $2ff24d1331f9aef3$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2ff24d1331f9aef3$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.combineLatest = void 0;

var $fHu9p = parcelRequire("fHu9p");

var $3xclF = parcelRequire("3xclF");

var $2RXLX = parcelRequire("2RXLX");

var $iJicw = parcelRequire("iJicw");

var $2LtHu = parcelRequire("2LtHu");

var $5D9gI = parcelRequire("5D9gI");
function $2ff24d1331f9aef3$var$combineLatest() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = $5D9gI.popResultSelector(args);
    return resultSelector ? $2LtHu.pipe($2ff24d1331f9aef3$var$combineLatest.apply(void 0, $2ff24d1331f9aef3$var$__spreadArray([], $2ff24d1331f9aef3$var$__read(args))), $iJicw.mapOneOrManyArgs(resultSelector)) : $3xclF.operate(function(source, subscriber) {
        $fHu9p.combineLatestInit($2ff24d1331f9aef3$var$__spreadArray([
            source
        ], $2ff24d1331f9aef3$var$__read($2RXLX.argsOrArgArray(args))))(subscriber);
    });
}
module.exports.combineLatest = $2ff24d1331f9aef3$var$combineLatest;

});


parcelRegister("lUHBy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concatMap = void 0;

var $9yos9 = parcelRequire("9yos9");

var $8VYz5 = parcelRequire("8VYz5");
function $ff40a6f23419b280$var$concatMap(project, resultSelector) {
    return $8VYz5.isFunction(resultSelector) ? $9yos9.mergeMap(project, resultSelector, 1) : $9yos9.mergeMap(project, 1);
}
module.exports.concatMap = $ff40a6f23419b280$var$concatMap;

});

parcelRegister("hqJGA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concatMapTo = void 0;

var $lUHBy = parcelRequire("lUHBy");

var $8VYz5 = parcelRequire("8VYz5");
function $cb084da715ecbf5c$var$concatMapTo(innerObservable, resultSelector) {
    return $8VYz5.isFunction(resultSelector) ? $lUHBy.concatMap(function() {
        return innerObservable;
    }, resultSelector) : $lUHBy.concatMap(function() {
        return innerObservable;
    });
}
module.exports.concatMapTo = $cb084da715ecbf5c$var$concatMapTo;

});

parcelRegister("lQTUa", function(module, exports) {
"use strict";
var $fe89d1d7309c3a5a$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $fe89d1d7309c3a5a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concatWith = void 0;

var $8T0RJ = parcelRequire("8T0RJ");
function $fe89d1d7309c3a5a$var$concatWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return $8T0RJ.concat.apply(void 0, $fe89d1d7309c3a5a$var$__spreadArray([], $fe89d1d7309c3a5a$var$__read(otherSources)));
}
module.exports.concatWith = $fe89d1d7309c3a5a$var$concatWith;

});
parcelRegister("8T0RJ", function(module, exports) {
"use strict";
var $678421b0b74dd3b5$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $678421b0b74dd3b5$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concat = void 0;

var $3xclF = parcelRequire("3xclF");

var $ibJWH = parcelRequire("ibJWH");

var $5D9gI = parcelRequire("5D9gI");

var $2PY6v = parcelRequire("2PY6v");
function $678421b0b74dd3b5$var$concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = $5D9gI.popScheduler(args);
    return $3xclF.operate(function(source, subscriber) {
        $ibJWH.concatAll()($2PY6v.from($678421b0b74dd3b5$var$__spreadArray([
            source
        ], $678421b0b74dd3b5$var$__read(args)), scheduler)).subscribe(subscriber);
    });
}
module.exports.concat = $678421b0b74dd3b5$var$concat;

});


parcelRegister("6yr3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connect = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $aJ0vk = parcelRequire("aJ0vk");

var $3xclF = parcelRequire("3xclF");

var $69N72 = parcelRequire("69N72");
var $4c5ae7ccadb16e2c$var$DEFAULT_CONFIG = {
    connector: function() {
        return new $7qEr0.Subject();
    }
};
function $4c5ae7ccadb16e2c$var$connect(selector, config) {
    if (config === void 0) config = $4c5ae7ccadb16e2c$var$DEFAULT_CONFIG;
    var connector = config.connector;
    return $3xclF.operate(function(source, subscriber) {
        var subject = connector();
        $aJ0vk.innerFrom(selector($69N72.fromSubscribable(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}
module.exports.connect = $4c5ae7ccadb16e2c$var$connect;

});
parcelRegister("69N72", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromSubscribable = void 0;

var $879ii = parcelRequire("879ii");
function $47b9ae149ebbbf4c$var$fromSubscribable(subscribable) {
    return new $879ii.Observable(function(subscriber) {
        return subscribable.subscribe(subscriber);
    });
}
module.exports.fromSubscribable = $47b9ae149ebbbf4c$var$fromSubscribable;

});


parcelRegister("3BlwT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.count = void 0;

var $1DJZU = parcelRequire("1DJZU");
function $29f58721a646259f$var$count(predicate) {
    return $1DJZU.reduce(function(total, value, i) {
        return !predicate || predicate(value, i) ? total + 1 : total;
    }, 0);
}
module.exports.count = $29f58721a646259f$var$count;

});

parcelRegister("1YliC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.debounce = void 0;

var $3xclF = parcelRequire("3xclF");

var $6UXs2 = parcelRequire("6UXs2");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");
function $16fbeaa4b193f91e$var$debounce(durationSelector) {
    return $3xclF.operate(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var emit = function() {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            hasValue = true;
            lastValue = value;
            durationSubscriber = $a1JN2.createOperatorSubscriber(subscriber, emit, $6UXs2.noop);
            $aJ0vk.innerFrom(durationSelector(value)).subscribe(durationSubscriber);
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = durationSubscriber = null;
        }));
    });
}
module.exports.debounce = $16fbeaa4b193f91e$var$debounce;

});

parcelRegister("h30H1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.debounceTime = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $c693410db720544a$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $iblpQ.asyncScheduler;
    return $3xclF.operate(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}
module.exports.debounceTime = $c693410db720544a$var$debounceTime;

});

parcelRegister("kJW6J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultIfEmpty = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $f1951591c1a91e2e$var$defaultIfEmpty(defaultValue) {
    return $3xclF.operate(function(source, subscriber) {
        var hasValue = false;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}
module.exports.defaultIfEmpty = $f1951591c1a91e2e$var$defaultIfEmpty;

});

parcelRegister("6jlJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $iw846 = parcelRequire("iw846");

var $5VhA3 = parcelRequire("5VhA3");
function $49855f69f04579f4$var$delay(due, scheduler) {
    if (scheduler === void 0) scheduler = $iblpQ.asyncScheduler;
    var duration = $5VhA3.timer(due, scheduler);
    return $iw846.delayWhen(function() {
        return duration;
    });
}
module.exports.delay = $49855f69f04579f4$var$delay;

});
parcelRegister("iw846", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delayWhen = void 0;

var $2YgGw = parcelRequire("2YgGw");

var $RyKIh = parcelRequire("RyKIh");

var $iuPJp = parcelRequire("iuPJp");

var $jHEjl = parcelRequire("jHEjl");

var $9yos9 = parcelRequire("9yos9");

var $aJ0vk = parcelRequire("aJ0vk");
function $d7b178bbe816ef36$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return $2YgGw.concat(subscriptionDelay.pipe($RyKIh.take(1), $iuPJp.ignoreElements()), source.pipe($d7b178bbe816ef36$var$delayWhen(delayDurationSelector)));
    };
    return $9yos9.mergeMap(function(value, index) {
        return $aJ0vk.innerFrom(delayDurationSelector(value, index)).pipe($RyKIh.take(1), $jHEjl.mapTo(value));
    });
}
module.exports.delayWhen = $d7b178bbe816ef36$var$delayWhen;

});
parcelRegister("RyKIh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.take = void 0;

var $9aeMj = parcelRequire("9aeMj");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $0a0fe8765b2f4c6c$var$take(count) {
    return count <= 0 ? function() {
        return $9aeMj.EMPTY;
    } : $3xclF.operate(function(source, subscriber) {
        var seen = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}
module.exports.take = $0a0fe8765b2f4c6c$var$take;

});

parcelRegister("iuPJp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ignoreElements = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $6UXs2 = parcelRequire("6UXs2");
function $d773281739a24348$var$ignoreElements() {
    return $3xclF.operate(function(source, subscriber) {
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, $6UXs2.noop));
    });
}
module.exports.ignoreElements = $d773281739a24348$var$ignoreElements;

});

parcelRegister("jHEjl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapTo = void 0;

var $dlvLZ = parcelRequire("dlvLZ");
function $e5814d661fc830db$var$mapTo(value) {
    return $dlvLZ.map(function() {
        return value;
    });
}
module.exports.mapTo = $e5814d661fc830db$var$mapTo;

});



parcelRegister("eII53", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dematerialize = void 0;

var $luK57 = parcelRequire("luK57");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $ab775e3c705627bc$var$dematerialize() {
    return $3xclF.operate(function(source, subscriber) {
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(notification) {
            return $luK57.observeNotification(notification, subscriber);
        }));
    });
}
module.exports.dematerialize = $ab775e3c705627bc$var$dematerialize;

});

parcelRegister("j2jlR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.distinct = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $6UXs2 = parcelRequire("6UXs2");

var $aJ0vk = parcelRequire("aJ0vk");
function $039391678105c17b$var$distinct(keySelector, flushes) {
    return $3xclF.operate(function(source, subscriber) {
        var distinctKeys = new Set();
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var key = keySelector ? keySelector(value) : value;
            if (!distinctKeys.has(key)) {
                distinctKeys.add(key);
                subscriber.next(value);
            }
        }));
        flushes && $aJ0vk.innerFrom(flushes).subscribe($a1JN2.createOperatorSubscriber(subscriber, function() {
            return distinctKeys.clear();
        }, $6UXs2.noop));
    });
}
module.exports.distinct = $039391678105c17b$var$distinct;

});

parcelRegister("44MsQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.distinctUntilChanged = void 0;

var $doKTd = parcelRequire("doKTd");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $2f7d212604136f33$var$distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) keySelector = $doKTd.identity;
    comparator = comparator !== null && comparator !== void 0 ? comparator : $2f7d212604136f33$var$defaultCompare;
    return $3xclF.operate(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
module.exports.distinctUntilChanged = $2f7d212604136f33$var$distinctUntilChanged;
function $2f7d212604136f33$var$defaultCompare(a, b) {
    return a === b;
}

});

parcelRegister("3AgXM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.distinctUntilKeyChanged = void 0;

var $44MsQ = parcelRequire("44MsQ");
function $29c1e4703fe4bafb$var$distinctUntilKeyChanged(key, compare) {
    return $44MsQ.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
module.exports.distinctUntilKeyChanged = $29c1e4703fe4bafb$var$distinctUntilKeyChanged;

});

parcelRegister("8fwR4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.elementAt = void 0;

var $9y9D2 = parcelRequire("9y9D2");

var $9UB7l = parcelRequire("9UB7l");

var $g9w3F = parcelRequire("g9w3F");

var $kJW6J = parcelRequire("kJW6J");

var $RyKIh = parcelRequire("RyKIh");
function $601935bea5162028$var$elementAt(index, defaultValue) {
    if (index < 0) throw new $9y9D2.ArgumentOutOfRangeError();
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe($9UB7l.filter(function(v, i) {
            return i === index;
        }), $RyKIh.take(1), hasDefaultValue ? $kJW6J.defaultIfEmpty(defaultValue) : $g9w3F.throwIfEmpty(function() {
            return new $9y9D2.ArgumentOutOfRangeError();
        }));
    };
}
module.exports.elementAt = $601935bea5162028$var$elementAt;

});
parcelRegister("g9w3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.throwIfEmpty = void 0;

var $k5xMc = parcelRequire("k5xMc");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $bc265ab038fc4bc9$var$throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) errorFactory = $bc265ab038fc4bc9$var$defaultErrorFactory;
    return $3xclF.operate(function(source, subscriber) {
        var hasValue = false;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
module.exports.throwIfEmpty = $bc265ab038fc4bc9$var$throwIfEmpty;
function $bc265ab038fc4bc9$var$defaultErrorFactory() {
    return new $k5xMc.EmptyError();
}

});


parcelRegister("dS4q4", function(module, exports) {
"use strict";
var $a193bf2281c55e57$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a193bf2281c55e57$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.endWith = void 0;

var $2YgGw = parcelRequire("2YgGw");

var $253k8 = parcelRequire("253k8");
function $a193bf2281c55e57$var$endWith() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return function(source) {
        return $2YgGw.concat(source, $253k8.of.apply(void 0, $a193bf2281c55e57$var$__spreadArray([], $a193bf2281c55e57$var$__read(values))));
    };
}
module.exports.endWith = $a193bf2281c55e57$var$endWith;

});

parcelRegister("i80A2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.every = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $d3296c907b225203$var$every(predicate, thisArg) {
    return $3xclF.operate(function(source, subscriber) {
        var index = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            if (!predicate.call(thisArg, value, index++, source)) {
                subscriber.next(false);
                subscriber.complete();
            }
        }, function() {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}
module.exports.every = $d3296c907b225203$var$every;

});

parcelRegister("hUsVc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exhaust = void 0;

var $b1bNb = parcelRequire("b1bNb");
module.exports.exhaust = $b1bNb.exhaustAll;

});
parcelRegister("b1bNb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exhaustAll = void 0;

var $k75zC = parcelRequire("k75zC");

var $doKTd = parcelRequire("doKTd");
function $8058ef6a9fe30a1d$var$exhaustAll() {
    return $k75zC.exhaustMap($doKTd.identity);
}
module.exports.exhaustAll = $8058ef6a9fe30a1d$var$exhaustAll;

});
parcelRegister("k75zC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exhaustMap = void 0;

var $dlvLZ = parcelRequire("dlvLZ");

var $aJ0vk = parcelRequire("aJ0vk");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $ea48c8e4ac87e677$var$exhaustMap(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe($ea48c8e4ac87e677$var$exhaustMap(function(a, i) {
            return $aJ0vk.innerFrom(project(a, i)).pipe($dlvLZ.map(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return $3xclF.operate(function(source, subscriber) {
        var index = 0;
        var innerSub = null;
        var isComplete = false;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(outerValue) {
            if (!innerSub) {
                innerSub = $a1JN2.createOperatorSubscriber(subscriber, undefined, function() {
                    innerSub = null;
                    isComplete && subscriber.complete();
                });
                $aJ0vk.innerFrom(project(outerValue, index++)).subscribe(innerSub);
            }
        }, function() {
            isComplete = true;
            !innerSub && subscriber.complete();
        }));
    });
}
module.exports.exhaustMap = $ea48c8e4ac87e677$var$exhaustMap;

});



parcelRegister("189NR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.expand = void 0;

var $3xclF = parcelRequire("3xclF");

var $4EiaP = parcelRequire("4EiaP");
function $0d2e2481ee341732$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Infinity;
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return $3xclF.operate(function(source, subscriber) {
        return $4EiaP.mergeInternals(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
}
module.exports.expand = $0d2e2481ee341732$var$expand;

});

parcelRegister("1UQBm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.finalize = void 0;

var $3xclF = parcelRequire("3xclF");
function $1653d2fd3b38f95e$var$finalize(callback) {
    return $3xclF.operate(function(source, subscriber) {
        try {
            source.subscribe(subscriber);
        } finally{
            subscriber.add(callback);
        }
    });
}
module.exports.finalize = $1653d2fd3b38f95e$var$finalize;

});

parcelRegister("5b0bg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createFind = module.exports.find = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $3c4e1eb52f54dd1f$var$find(predicate, thisArg) {
    return $3xclF.operate($3c4e1eb52f54dd1f$var$createFind(predicate, thisArg, 'value'));
}
module.exports.find = $3c4e1eb52f54dd1f$var$find;
function $3c4e1eb52f54dd1f$var$createFind(predicate, thisArg, emit) {
    var findIndex = emit === 'index';
    return function(source, subscriber) {
        var index = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var i = index++;
            if (predicate.call(thisArg, value, i, source)) {
                subscriber.next(findIndex ? i : value);
                subscriber.complete();
            }
        }, function() {
            subscriber.next(findIndex ? -1 : undefined);
            subscriber.complete();
        }));
    };
}
module.exports.createFind = $3c4e1eb52f54dd1f$var$createFind;

});

parcelRegister("iCzrW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findIndex = void 0;

var $3xclF = parcelRequire("3xclF");

var $5b0bg = parcelRequire("5b0bg");
function $d8e7462a436f1349$var$findIndex(predicate, thisArg) {
    return $3xclF.operate($5b0bg.createFind(predicate, thisArg, 'index'));
}
module.exports.findIndex = $d8e7462a436f1349$var$findIndex;

});

parcelRegister("c0ecv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.first = void 0;

var $k5xMc = parcelRequire("k5xMc");

var $9UB7l = parcelRequire("9UB7l");

var $RyKIh = parcelRequire("RyKIh");

var $kJW6J = parcelRequire("kJW6J");

var $g9w3F = parcelRequire("g9w3F");

var $doKTd = parcelRequire("doKTd");
function $8bd08011aec04571$var$first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? $9UB7l.filter(function(v, i) {
            return predicate(v, i, source);
        }) : $doKTd.identity, $RyKIh.take(1), hasDefaultValue ? $kJW6J.defaultIfEmpty(defaultValue) : $g9w3F.throwIfEmpty(function() {
            return new $k5xMc.EmptyError();
        }));
    };
}
module.exports.first = $8bd08011aec04571$var$first;

});

parcelRegister("3e5pj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.groupBy = void 0;

var $879ii = parcelRequire("879ii");

var $aJ0vk = parcelRequire("aJ0vk");

var $7qEr0 = parcelRequire("7qEr0");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $2596dfa65334ecf4$var$groupBy(keySelector, elementOrOptions, duration, connector) {
    return $3xclF.operate(function(source, subscriber) {
        var element;
        if (!elementOrOptions || typeof elementOrOptions === 'function') element = elementOrOptions;
        else duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector;
        var groups = new Map();
        var notify = function(cb) {
            groups.forEach(cb);
            cb(subscriber);
        };
        var handleError = function(err) {
            return notify(function(consumer) {
                return consumer.error(err);
            });
        };
        var activeGroups = 0;
        var teardownAttempted = false;
        var groupBySourceSubscriber = new $a1JN2.OperatorSubscriber(subscriber, function(value) {
            try {
                var key_1 = keySelector(value);
                var group_1 = groups.get(key_1);
                if (!group_1) {
                    groups.set(key_1, group_1 = connector ? connector() : new $7qEr0.Subject());
                    var grouped = createGroupedObservable(key_1, group_1);
                    subscriber.next(grouped);
                    if (duration) {
                        var durationSubscriber_1 = $a1JN2.createOperatorSubscriber(group_1, function() {
                            group_1.complete();
                            durationSubscriber_1 === null || durationSubscriber_1 === void 0 || durationSubscriber_1.unsubscribe();
                        }, undefined, undefined, function() {
                            return groups.delete(key_1);
                        });
                        groupBySourceSubscriber.add($aJ0vk.innerFrom(duration(grouped)).subscribe(durationSubscriber_1));
                    }
                }
                group_1.next(element ? element(value) : value);
            } catch (err) {
                handleError(err);
            }
        }, function() {
            return notify(function(consumer) {
                return consumer.complete();
            });
        }, handleError, function() {
            return groups.clear();
        }, function() {
            teardownAttempted = true;
            return activeGroups === 0;
        });
        source.subscribe(groupBySourceSubscriber);
        function createGroupedObservable(key, groupSubject) {
            var result = new $879ii.Observable(function(groupSubscriber) {
                activeGroups++;
                var innerSub = groupSubject.subscribe(groupSubscriber);
                return function() {
                    innerSub.unsubscribe();
                    --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
                };
            });
            result.key = key;
            return result;
        }
    });
}
module.exports.groupBy = $2596dfa65334ecf4$var$groupBy;

});

parcelRegister("cOYnk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmpty = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $9558fcd34c3e2ac4$var$isEmpty() {
    return $3xclF.operate(function(source, subscriber) {
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function() {
            subscriber.next(false);
            subscriber.complete();
        }, function() {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}
module.exports.isEmpty = $9558fcd34c3e2ac4$var$isEmpty;

});

parcelRegister("jwbyz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.last = void 0;

var $k5xMc = parcelRequire("k5xMc");

var $9UB7l = parcelRequire("9UB7l");

var $eetG1 = parcelRequire("eetG1");

var $g9w3F = parcelRequire("g9w3F");

var $kJW6J = parcelRequire("kJW6J");

var $doKTd = parcelRequire("doKTd");
function $e359f866b7fcdd95$var$last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? $9UB7l.filter(function(v, i) {
            return predicate(v, i, source);
        }) : $doKTd.identity, $eetG1.takeLast(1), hasDefaultValue ? $kJW6J.defaultIfEmpty(defaultValue) : $g9w3F.throwIfEmpty(function() {
            return new $k5xMc.EmptyError();
        }));
    };
}
module.exports.last = $e359f866b7fcdd95$var$last;

});
parcelRegister("eetG1", function(module, exports) {
"use strict";
var $a5c964b381ef612b$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.takeLast = void 0;

var $9aeMj = parcelRequire("9aeMj");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $a5c964b381ef612b$var$takeLast(count) {
    return count <= 0 ? function() {
        return $9aeMj.EMPTY;
    } : $3xclF.operate(function(source, subscriber) {
        var buffer = [];
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            buffer.push(value);
            count < buffer.length && buffer.shift();
        }, function() {
            var e_1, _a;
            try {
                for(var buffer_1 = $a5c964b381ef612b$var$__values(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()){
                    var value = buffer_1_1.value;
                    subscriber.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            subscriber.complete();
        }, undefined, function() {
            buffer = null;
        }));
    });
}
module.exports.takeLast = $a5c964b381ef612b$var$takeLast;

});


parcelRegister("gXR8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.materialize = void 0;

var $luK57 = parcelRequire("luK57");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $c59b607f805e7b7c$var$materialize() {
    return $3xclF.operate(function(source, subscriber) {
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            subscriber.next($luK57.Notification.createNext(value));
        }, function() {
            subscriber.next($luK57.Notification.createComplete());
            subscriber.complete();
        }, function(err) {
            subscriber.next($luK57.Notification.createError(err));
            subscriber.complete();
        }));
    });
}
module.exports.materialize = $c59b607f805e7b7c$var$materialize;

});

parcelRegister("bL8Bf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.max = void 0;

var $1DJZU = parcelRequire("1DJZU");

var $8VYz5 = parcelRequire("8VYz5");
function $88fac14160cb5648$var$max(comparer) {
    return $1DJZU.reduce($8VYz5.isFunction(comparer) ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    });
}
module.exports.max = $88fac14160cb5648$var$max;

});

parcelRegister("crJRG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flatMap = void 0;

var $9yos9 = parcelRequire("9yos9");
module.exports.flatMap = $9yos9.mergeMap;

});

parcelRegister("aGrfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeMapTo = void 0;

var $9yos9 = parcelRequire("9yos9");

var $8VYz5 = parcelRequire("8VYz5");
function $7c72f679b78afa75$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ($8VYz5.isFunction(resultSelector)) return $9yos9.mergeMap(function() {
        return innerObservable;
    }, resultSelector, concurrent);
    if (typeof resultSelector === 'number') concurrent = resultSelector;
    return $9yos9.mergeMap(function() {
        return innerObservable;
    }, concurrent);
}
module.exports.mergeMapTo = $7c72f679b78afa75$var$mergeMapTo;

});

parcelRegister("52bW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeScan = void 0;

var $3xclF = parcelRequire("3xclF");

var $4EiaP = parcelRequire("4EiaP");
function $3aa665da10e1346b$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return $3xclF.operate(function(source, subscriber) {
        var state = seed;
        return $4EiaP.mergeInternals(source, subscriber, function(value, index) {
            return accumulator(state, value, index);
        }, concurrent, function(value) {
            state = value;
        }, false, undefined, function() {
            return state = null;
        });
    });
}
module.exports.mergeScan = $3aa665da10e1346b$var$mergeScan;

});

parcelRegister("joqn9", function(module, exports) {
"use strict";
var $e1e4b7364ca4c2be$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e1e4b7364ca4c2be$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeWith = void 0;

var $99t9M = parcelRequire("99t9M");
function $e1e4b7364ca4c2be$var$mergeWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return $99t9M.merge.apply(void 0, $e1e4b7364ca4c2be$var$__spreadArray([], $e1e4b7364ca4c2be$var$__read(otherSources)));
}
module.exports.mergeWith = $e1e4b7364ca4c2be$var$mergeWith;

});
parcelRegister("99t9M", function(module, exports) {
"use strict";
var $6a9b9239637f0107$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $6a9b9239637f0107$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.merge = void 0;

var $3xclF = parcelRequire("3xclF");

var $bGQoL = parcelRequire("bGQoL");

var $5D9gI = parcelRequire("5D9gI");

var $2PY6v = parcelRequire("2PY6v");
function $6a9b9239637f0107$var$merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = $5D9gI.popScheduler(args);
    var concurrent = $5D9gI.popNumber(args, Infinity);
    return $3xclF.operate(function(source, subscriber) {
        $bGQoL.mergeAll(concurrent)($2PY6v.from($6a9b9239637f0107$var$__spreadArray([
            source
        ], $6a9b9239637f0107$var$__read(args)), scheduler)).subscribe(subscriber);
    });
}
module.exports.merge = $6a9b9239637f0107$var$merge;

});


parcelRegister("2QRuw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.min = void 0;

var $1DJZU = parcelRequire("1DJZU");

var $8VYz5 = parcelRequire("8VYz5");
function $2139ee574001529c$var$min(comparer) {
    return $1DJZU.reduce($8VYz5.isFunction(comparer) ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    });
}
module.exports.min = $2139ee574001529c$var$min;

});

parcelRegister("0YCgj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.multicast = void 0;

var $hEwEw = parcelRequire("hEwEw");

var $8VYz5 = parcelRequire("8VYz5");

var $6yr3x = parcelRequire("6yr3x");
function $002f054d670bf051$var$multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory = $8VYz5.isFunction(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function() {
        return subjectOrSubjectFactory;
    };
    if ($8VYz5.isFunction(selector)) return $6yr3x.connect(selector, {
        connector: subjectFactory
    });
    return function(source) {
        return new $hEwEw.ConnectableObservable(source, subjectFactory);
    };
}
module.exports.multicast = $002f054d670bf051$var$multicast;

});

parcelRegister("8XKni", function(module, exports) {
"use strict";
var $6867ce7c32cd3ad2$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $6867ce7c32cd3ad2$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.onErrorResumeNext = module.exports.onErrorResumeNextWith = void 0;

var $2RXLX = parcelRequire("2RXLX");

var $5W86T = parcelRequire("5W86T");
function $6867ce7c32cd3ad2$var$onErrorResumeNextWith() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var nextSources = $2RXLX.argsOrArgArray(sources);
    return function(source) {
        return $5W86T.onErrorResumeNext.apply(void 0, $6867ce7c32cd3ad2$var$__spreadArray([
            source
        ], $6867ce7c32cd3ad2$var$__read(nextSources)));
    };
}
module.exports.onErrorResumeNextWith = $6867ce7c32cd3ad2$var$onErrorResumeNextWith;
module.exports.onErrorResumeNext = $6867ce7c32cd3ad2$var$onErrorResumeNextWith;

});

parcelRegister("zmZZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pairwise = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $06a51c143e3c166c$var$pairwise() {
    return $3xclF.operate(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}
module.exports.pairwise = $06a51c143e3c166c$var$pairwise;

});

parcelRegister("kSUeX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pluck = void 0;

var $dlvLZ = parcelRequire("dlvLZ");
function $f34479f18afbf419$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return $dlvLZ.map(function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    });
}
module.exports.pluck = $f34479f18afbf419$var$pluck;

});

parcelRegister("3DSIU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.publish = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $0YCgj = parcelRequire("0YCgj");

var $6yr3x = parcelRequire("6yr3x");
function $2a6f76884ed26b48$var$publish(selector) {
    return selector ? function(source) {
        return $6yr3x.connect(selector)(source);
    } : function(source) {
        return $0YCgj.multicast(new $7qEr0.Subject())(source);
    };
}
module.exports.publish = $2a6f76884ed26b48$var$publish;

});

parcelRegister("4Yf1V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.publishBehavior = void 0;

var $i5kDY = parcelRequire("i5kDY");

var $hEwEw = parcelRequire("hEwEw");
function $39e86cae20e93443$var$publishBehavior(initialValue) {
    return function(source) {
        var subject = new $i5kDY.BehaviorSubject(initialValue);
        return new $hEwEw.ConnectableObservable(source, function() {
            return subject;
        });
    };
}
module.exports.publishBehavior = $39e86cae20e93443$var$publishBehavior;

});

parcelRegister("htmo4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.publishLast = void 0;

var $kJoTA = parcelRequire("kJoTA");

var $hEwEw = parcelRequire("hEwEw");
function $cb8682b981cb7d4d$var$publishLast() {
    return function(source) {
        var subject = new $kJoTA.AsyncSubject();
        return new $hEwEw.ConnectableObservable(source, function() {
            return subject;
        });
    };
}
module.exports.publishLast = $cb8682b981cb7d4d$var$publishLast;

});

parcelRegister("hO5Vx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.publishReplay = void 0;

var $jaL5r = parcelRequire("jaL5r");

var $0YCgj = parcelRequire("0YCgj");

var $8VYz5 = parcelRequire("8VYz5");
function $cf6bb42afec8d8eb$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    if (selectorOrScheduler && !$8VYz5.isFunction(selectorOrScheduler)) timestampProvider = selectorOrScheduler;
    var selector = $8VYz5.isFunction(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function(source) {
        return $0YCgj.multicast(new $jaL5r.ReplaySubject(bufferSize, windowTime, timestampProvider), selector)(source);
    };
}
module.exports.publishReplay = $cf6bb42afec8d8eb$var$publishReplay;

});

parcelRegister("QP0wQ", function(module, exports) {
"use strict";
var $09ec6c79ec2713a3$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $09ec6c79ec2713a3$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.raceWith = void 0;

var $fm02T = parcelRequire("fm02T");

var $3xclF = parcelRequire("3xclF");

var $doKTd = parcelRequire("doKTd");
function $09ec6c79ec2713a3$var$raceWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return !otherSources.length ? $doKTd.identity : $3xclF.operate(function(source, subscriber) {
        $fm02T.raceInit($09ec6c79ec2713a3$var$__spreadArray([
            source
        ], $09ec6c79ec2713a3$var$__read(otherSources)))(subscriber);
    });
}
module.exports.raceWith = $09ec6c79ec2713a3$var$raceWith;

});

parcelRegister("7l3DT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.repeat = void 0;

var $9aeMj = parcelRequire("9aeMj");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");

var $5VhA3 = parcelRequire("5VhA3");
function $557d51e49af00779$var$repeat(countOrConfig) {
    var _a;
    var count = Infinity;
    var delay;
    if (countOrConfig != null) {
        if (typeof countOrConfig === 'object') _a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay;
        else count = countOrConfig;
    }
    return count <= 0 ? function() {
        return $9aeMj.EMPTY;
    } : $3xclF.operate(function(source, subscriber) {
        var soFar = 0;
        var sourceSub;
        var resubscribe = function() {
            sourceSub === null || sourceSub === void 0 || sourceSub.unsubscribe();
            sourceSub = null;
            if (delay != null) {
                var notifier = typeof delay === 'number' ? $5VhA3.timer(delay) : $aJ0vk.innerFrom(delay(soFar));
                var notifierSubscriber_1 = $a1JN2.createOperatorSubscriber(subscriber, function() {
                    notifierSubscriber_1.unsubscribe();
                    subscribeToSource();
                });
                notifier.subscribe(notifierSubscriber_1);
            } else subscribeToSource();
        };
        var subscribeToSource = function() {
            var syncUnsub = false;
            sourceSub = source.subscribe($a1JN2.createOperatorSubscriber(subscriber, undefined, function() {
                if (++soFar < count) {
                    if (sourceSub) resubscribe();
                    else syncUnsub = true;
                } else subscriber.complete();
            }));
            if (syncUnsub) resubscribe();
        };
        subscribeToSource();
    });
}
module.exports.repeat = $557d51e49af00779$var$repeat;

});

parcelRegister("adOrM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.repeatWhen = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $7qEr0 = parcelRequire("7qEr0");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $7712400aa4ca357c$var$repeatWhen(notifier) {
    return $3xclF.operate(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var completions$;
        var isNotifierComplete = false;
        var isMainComplete = false;
        var checkComplete = function() {
            return isMainComplete && isNotifierComplete && (subscriber.complete(), true);
        };
        var getCompletionSubject = function() {
            if (!completions$) {
                completions$ = new $7qEr0.Subject();
                $aJ0vk.innerFrom(notifier(completions$)).subscribe($a1JN2.createOperatorSubscriber(subscriber, function() {
                    if (innerSub) subscribeForRepeatWhen();
                    else syncResub = true;
                }, function() {
                    isNotifierComplete = true;
                    checkComplete();
                }));
            }
            return completions$;
        };
        var subscribeForRepeatWhen = function() {
            isMainComplete = false;
            innerSub = source.subscribe($a1JN2.createOperatorSubscriber(subscriber, undefined, function() {
                isMainComplete = true;
                !checkComplete() && getCompletionSubject().next();
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRepeatWhen();
            }
        };
        subscribeForRepeatWhen();
    });
}
module.exports.repeatWhen = $7712400aa4ca357c$var$repeatWhen;

});

parcelRegister("1vc7D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.retry = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $doKTd = parcelRequire("doKTd");

var $5VhA3 = parcelRequire("5VhA3");

var $aJ0vk = parcelRequire("aJ0vk");
function $118216e7b5c5f1eb$var$retry(configOrCount) {
    if (configOrCount === void 0) configOrCount = Infinity;
    var config;
    if (configOrCount && typeof configOrCount === 'object') config = configOrCount;
    else config = {
        count: configOrCount
    };
    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
    return count <= 0 ? $doKTd.identity : $3xclF.operate(function(source, subscriber) {
        var soFar = 0;
        var innerSub;
        var subscribeForRetry = function() {
            var syncUnsub = false;
            innerSub = source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
                if (resetOnSuccess) soFar = 0;
                subscriber.next(value);
            }, undefined, function(err) {
                if (soFar++ < count) {
                    var resub_1 = function() {
                        if (innerSub) {
                            innerSub.unsubscribe();
                            innerSub = null;
                            subscribeForRetry();
                        } else syncUnsub = true;
                    };
                    if (delay != null) {
                        var notifier = typeof delay === 'number' ? $5VhA3.timer(delay) : $aJ0vk.innerFrom(delay(err, soFar));
                        var notifierSubscriber_1 = $a1JN2.createOperatorSubscriber(subscriber, function() {
                            notifierSubscriber_1.unsubscribe();
                            resub_1();
                        }, function() {
                            subscriber.complete();
                        });
                        notifier.subscribe(notifierSubscriber_1);
                    } else resub_1();
                } else subscriber.error(err);
            }));
            if (syncUnsub) {
                innerSub.unsubscribe();
                innerSub = null;
                subscribeForRetry();
            }
        };
        subscribeForRetry();
    });
}
module.exports.retry = $118216e7b5c5f1eb$var$retry;

});

parcelRegister("aSde1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.retryWhen = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $7qEr0 = parcelRequire("7qEr0");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $7ea934c6b2167ae9$var$retryWhen(notifier) {
    return $3xclF.operate(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var errors$;
        var subscribeForRetryWhen = function() {
            innerSub = source.subscribe($a1JN2.createOperatorSubscriber(subscriber, undefined, undefined, function(err) {
                if (!errors$) {
                    errors$ = new $7qEr0.Subject();
                    $aJ0vk.innerFrom(notifier(errors$)).subscribe($a1JN2.createOperatorSubscriber(subscriber, function() {
                        return innerSub ? subscribeForRetryWhen() : syncResub = true;
                    }));
                }
                if (errors$) errors$.next(err);
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRetryWhen();
            }
        };
        subscribeForRetryWhen();
    });
}
module.exports.retryWhen = $7ea934c6b2167ae9$var$retryWhen;

});

parcelRegister("99Y2Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sample = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $3xclF = parcelRequire("3xclF");

var $6UXs2 = parcelRequire("6UXs2");

var $a1JN2 = parcelRequire("a1JN2");
function $6ab38860da87e5e7$var$sample(notifier) {
    return $3xclF.operate(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            hasValue = true;
            lastValue = value;
        }));
        $aJ0vk.innerFrom(notifier).subscribe($a1JN2.createOperatorSubscriber(subscriber, function() {
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        }, $6UXs2.noop));
    });
}
module.exports.sample = $6ab38860da87e5e7$var$sample;

});

parcelRegister("lGCWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sampleTime = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $99Y2Y = parcelRequire("99Y2Y");

var $aIEIf = parcelRequire("aIEIf");
function $fc9bb96e4a9c264e$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $iblpQ.asyncScheduler;
    return $99Y2Y.sample($aIEIf.interval(period, scheduler));
}
module.exports.sampleTime = $fc9bb96e4a9c264e$var$sampleTime;

});

parcelRegister("keq7K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scan = void 0;

var $3xclF = parcelRequire("3xclF");

var $9vrCz = parcelRequire("9vrCz");
function $eba96121578ac826$var$scan(accumulator, seed) {
    return $3xclF.operate($9vrCz.scanInternals(accumulator, seed, arguments.length >= 2, true));
}
module.exports.scan = $eba96121578ac826$var$scan;

});

parcelRegister("htbrG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sequenceEqual = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");
function $cb7e05eaad40a05f$var$sequenceEqual(compareTo, comparator) {
    if (comparator === void 0) comparator = function(a, b) {
        return a === b;
    };
    return $3xclF.operate(function(source, subscriber) {
        var aState = $cb7e05eaad40a05f$var$createState();
        var bState = $cb7e05eaad40a05f$var$createState();
        var emit = function(isEqual) {
            subscriber.next(isEqual);
            subscriber.complete();
        };
        var createSubscriber = function(selfState, otherState) {
            var sequenceEqualSubscriber = $a1JN2.createOperatorSubscriber(subscriber, function(a) {
                var buffer = otherState.buffer, complete = otherState.complete;
                if (buffer.length === 0) complete ? emit(false) : selfState.buffer.push(a);
                else !comparator(a, buffer.shift()) && emit(false);
            }, function() {
                selfState.complete = true;
                var complete = otherState.complete, buffer = otherState.buffer;
                complete && emit(buffer.length === 0);
                sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 || sequenceEqualSubscriber.unsubscribe();
            });
            return sequenceEqualSubscriber;
        };
        source.subscribe(createSubscriber(aState, bState));
        $aJ0vk.innerFrom(compareTo).subscribe(createSubscriber(bState, aState));
    });
}
module.exports.sequenceEqual = $cb7e05eaad40a05f$var$sequenceEqual;
function $cb7e05eaad40a05f$var$createState() {
    return {
        buffer: [],
        complete: false
    };
}

});

parcelRegister("109B7", function(module, exports) {
"use strict";
var $0bad3c6b7e812465$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0bad3c6b7e812465$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.share = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $7qEr0 = parcelRequire("7qEr0");

var $9btgx = parcelRequire("9btgx");

var $3xclF = parcelRequire("3xclF");
function $0bad3c6b7e812465$var$share(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new $7qEr0.Subject();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return $3xclF.operate(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0bad3c6b7e812465$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new $9btgx.SafeSubscriber({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0bad3c6b7e812465$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0bad3c6b7e812465$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                $aJ0vk.innerFrom(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
module.exports.share = $0bad3c6b7e812465$var$share;
function $0bad3c6b7e812465$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new $9btgx.SafeSubscriber({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return $aJ0vk.innerFrom(on.apply(void 0, $0bad3c6b7e812465$var$__spreadArray([], $0bad3c6b7e812465$var$__read(args)))).subscribe(onSubscriber);
}

});

parcelRegister("171Pf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shareReplay = void 0;

var $jaL5r = parcelRequire("jaL5r");

var $109B7 = parcelRequire("109B7");
function $0cf7dc64317d3f9d$var$shareReplay(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return $109B7.share({
        connector: function() {
            return new $jaL5r.ReplaySubject(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}
module.exports.shareReplay = $0cf7dc64317d3f9d$var$shareReplay;

});

parcelRegister("cYZh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.single = void 0;

var $k5xMc = parcelRequire("k5xMc");

var $62noZ = parcelRequire("62noZ");

var $fzrJl = parcelRequire("fzrJl");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $973a9e48f556e289$var$single(predicate) {
    return $3xclF.operate(function(source, subscriber) {
        var hasValue = false;
        var singleValue;
        var seenValue = false;
        var index = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            seenValue = true;
            if (!predicate || predicate(value, index++, source)) {
                hasValue && subscriber.error(new $62noZ.SequenceError('Too many matching values'));
                hasValue = true;
                singleValue = value;
            }
        }, function() {
            if (hasValue) {
                subscriber.next(singleValue);
                subscriber.complete();
            } else subscriber.error(seenValue ? new $fzrJl.NotFoundError('No matching values') : new $k5xMc.EmptyError());
        }));
    });
}
module.exports.single = $973a9e48f556e289$var$single;

});

parcelRegister("giKyY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.skip = void 0;

var $9UB7l = parcelRequire("9UB7l");
function $bde272402e2ffa3e$var$skip(count) {
    return $9UB7l.filter(function(_, index) {
        return count <= index;
    });
}
module.exports.skip = $bde272402e2ffa3e$var$skip;

});

parcelRegister("6aRM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.skipLast = void 0;

var $doKTd = parcelRequire("doKTd");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $47ed637c3f7f08e9$var$skipLast(skipCount) {
    return skipCount <= 0 ? $doKTd.identity : $3xclF.operate(function(source, subscriber) {
        var ring = new Array(skipCount);
        var seen = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var valueIndex = seen++;
            if (valueIndex < skipCount) ring[valueIndex] = value;
            else {
                var index = valueIndex % skipCount;
                var oldValue = ring[index];
                ring[index] = value;
                subscriber.next(oldValue);
            }
        }));
        return function() {
            ring = null;
        };
    });
}
module.exports.skipLast = $47ed637c3f7f08e9$var$skipLast;

});

parcelRegister("8h7Qd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.skipUntil = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");

var $6UXs2 = parcelRequire("6UXs2");
function $6065fe5ffcb27e56$var$skipUntil(notifier) {
    return $3xclF.operate(function(source, subscriber) {
        var taking = false;
        var skipSubscriber = $a1JN2.createOperatorSubscriber(subscriber, function() {
            skipSubscriber === null || skipSubscriber === void 0 || skipSubscriber.unsubscribe();
            taking = true;
        }, $6UXs2.noop);
        $aJ0vk.innerFrom(notifier).subscribe(skipSubscriber);
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            return taking && subscriber.next(value);
        }));
    });
}
module.exports.skipUntil = $6065fe5ffcb27e56$var$skipUntil;

});

parcelRegister("ddo0F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.skipWhile = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $99ef1d1826d6dfd2$var$skipWhile(predicate) {
    return $3xclF.operate(function(source, subscriber) {
        var taking = false;
        var index = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            return (taking || (taking = !predicate(value, index++))) && subscriber.next(value);
        }));
    });
}
module.exports.skipWhile = $99ef1d1826d6dfd2$var$skipWhile;

});

parcelRegister("2hoDR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.startWith = void 0;

var $2YgGw = parcelRequire("2YgGw");

var $5D9gI = parcelRequire("5D9gI");

var $3xclF = parcelRequire("3xclF");
function $1a9048b10cfb8c80$var$startWith() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = $5D9gI.popScheduler(values);
    return $3xclF.operate(function(source, subscriber) {
        (scheduler ? $2YgGw.concat(values, source, scheduler) : $2YgGw.concat(values, source)).subscribe(subscriber);
    });
}
module.exports.startWith = $1a9048b10cfb8c80$var$startWith;

});

parcelRegister("7cM1p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.switchAll = void 0;

var $9q5AD = parcelRequire("9q5AD");

var $doKTd = parcelRequire("doKTd");
function $53eee7833f8aa4b5$var$switchAll() {
    return $9q5AD.switchMap($doKTd.identity);
}
module.exports.switchAll = $53eee7833f8aa4b5$var$switchAll;

});
parcelRegister("9q5AD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.switchMap = void 0;

var $aJ0vk = parcelRequire("aJ0vk");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $6dbae0ca09358687$var$switchMap(project, resultSelector) {
    return $3xclF.operate(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            $aJ0vk.innerFrom(project(value, outerIndex)).subscribe(innerSubscriber = $a1JN2.createOperatorSubscriber(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}
module.exports.switchMap = $6dbae0ca09358687$var$switchMap;

});


parcelRegister("aXTon", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.switchMapTo = void 0;

var $9q5AD = parcelRequire("9q5AD");

var $8VYz5 = parcelRequire("8VYz5");
function $7fba61d418f29670$var$switchMapTo(innerObservable, resultSelector) {
    return $8VYz5.isFunction(resultSelector) ? $9q5AD.switchMap(function() {
        return innerObservable;
    }, resultSelector) : $9q5AD.switchMap(function() {
        return innerObservable;
    });
}
module.exports.switchMapTo = $7fba61d418f29670$var$switchMapTo;

});

parcelRegister("6UQzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.switchScan = void 0;

var $9q5AD = parcelRequire("9q5AD");

var $3xclF = parcelRequire("3xclF");
function $5090c1dc50c001fe$var$switchScan(accumulator, seed) {
    return $3xclF.operate(function(source, subscriber) {
        var state = seed;
        $9q5AD.switchMap(function(value, index) {
            return accumulator(state, value, index);
        }, function(_, innerValue) {
            return state = innerValue, innerValue;
        })(source).subscribe(subscriber);
        return function() {
            state = null;
        };
    });
}
module.exports.switchScan = $5090c1dc50c001fe$var$switchScan;

});

parcelRegister("hmAHy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.takeUntil = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");

var $6UXs2 = parcelRequire("6UXs2");
function $ca40f5e76ff92d8e$var$takeUntil(notifier) {
    return $3xclF.operate(function(source, subscriber) {
        $aJ0vk.innerFrom(notifier).subscribe($a1JN2.createOperatorSubscriber(subscriber, function() {
            return subscriber.complete();
        }, $6UXs2.noop));
        !subscriber.closed && source.subscribe(subscriber);
    });
}
module.exports.takeUntil = $ca40f5e76ff92d8e$var$takeUntil;

});

parcelRegister("l0lbO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.takeWhile = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $f4aa08d7d5ae9c75$var$takeWhile(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return $3xclF.operate(function(source, subscriber) {
        var index = 0;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var result = predicate(value, index++);
            (result || inclusive) && subscriber.next(value);
            !result && subscriber.complete();
        }));
    });
}
module.exports.takeWhile = $f4aa08d7d5ae9c75$var$takeWhile;

});

parcelRegister("itLai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tap = void 0;

var $8VYz5 = parcelRequire("8VYz5");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $doKTd = parcelRequire("doKTd");
function $d73f85723b8a3751$var$tap(observerOrNext, error, complete) {
    var tapObserver = $8VYz5.isFunction(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? $3xclF.operate(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : $doKTd.identity;
}
module.exports.tap = $d73f85723b8a3751$var$tap;

});

parcelRegister("cmWmG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.throttle = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");
function $9014d02ba9b9c2e9$var$throttle(durationSelector, config) {
    return $3xclF.operate(function(source, subscriber) {
        var _a = config !== null && config !== void 0 ? config : {}, _b = _a.leading, leading = _b === void 0 ? true : _b, _c = _a.trailing, trailing = _c === void 0 ? false : _c;
        var hasValue = false;
        var sendValue = null;
        var throttled = null;
        var isComplete = false;
        var endThrottling = function() {
            throttled === null || throttled === void 0 || throttled.unsubscribe();
            throttled = null;
            if (trailing) {
                send();
                isComplete && subscriber.complete();
            }
        };
        var cleanupThrottling = function() {
            throttled = null;
            isComplete && subscriber.complete();
        };
        var startThrottle = function(value) {
            return throttled = $aJ0vk.innerFrom(durationSelector(value)).subscribe($a1JN2.createOperatorSubscriber(subscriber, endThrottling, cleanupThrottling));
        };
        var send = function() {
            if (hasValue) {
                hasValue = false;
                var value = sendValue;
                sendValue = null;
                subscriber.next(value);
                !isComplete && startThrottle(value);
            }
        };
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            hasValue = true;
            sendValue = value;
            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
        }, function() {
            isComplete = true;
            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
        }));
    });
}
module.exports.throttle = $9014d02ba9b9c2e9$var$throttle;

});

parcelRegister("jO5Pf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.throttleTime = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $cmWmG = parcelRequire("cmWmG");

var $5VhA3 = parcelRequire("5VhA3");
function $e6b734b0279a0b19$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $iblpQ.asyncScheduler;
    var duration$ = $5VhA3.timer(duration, scheduler);
    return $cmWmG.throttle(function() {
        return duration$;
    }, config);
}
module.exports.throttleTime = $e6b734b0279a0b19$var$throttleTime;

});

parcelRegister("05fTJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeInterval = module.exports.timeInterval = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $00fcccba081de31e$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $iblpQ.asyncScheduler;
    return $3xclF.operate(function(source, subscriber) {
        var last = scheduler.now();
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var now = scheduler.now();
            var interval = now - last;
            last = now;
            subscriber.next(new $00fcccba081de31e$var$TimeInterval(value, interval));
        }));
    });
}
module.exports.timeInterval = $00fcccba081de31e$var$timeInterval;
var $00fcccba081de31e$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $00fcccba081de31e$var$TimeInterval;

});

parcelRegister("bqhsW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeoutWith = void 0;

var $iblpQ = parcelRequire("iblpQ");

var $ZrESv = parcelRequire("ZrESv");

var $5oCQ5 = parcelRequire("5oCQ5");
function $850fabc7f555325f$var$timeoutWith(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : $iblpQ.async;
    if ($ZrESv.isValidDate(due)) first = due;
    else if (typeof due === 'number') each = due;
    if (withObservable) _with = function() {
        return withObservable;
    };
    else throw new TypeError('No observable provided to switch to');
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return $5oCQ5.timeout({
        first: first,
        each: each,
        scheduler: scheduler,
        with: _with
    });
}
module.exports.timeoutWith = $850fabc7f555325f$var$timeoutWith;

});

parcelRegister("NLpTp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timestamp = void 0;

var $kX1bI = parcelRequire("kX1bI");

var $dlvLZ = parcelRequire("dlvLZ");
function $09595bac06ff9268$var$timestamp(timestampProvider) {
    if (timestampProvider === void 0) timestampProvider = $kX1bI.dateTimestampProvider;
    return $dlvLZ.map(function(value) {
        return {
            value: value,
            timestamp: timestampProvider.now()
        };
    });
}
module.exports.timestamp = $09595bac06ff9268$var$timestamp;

});

parcelRegister("3UEiK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.window = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $6UXs2 = parcelRequire("6UXs2");

var $aJ0vk = parcelRequire("aJ0vk");
function $2d95dd12be1696af$var$window(windowBoundaries) {
    return $3xclF.operate(function(source, subscriber) {
        var windowSubject = new $7qEr0.Subject();
        subscriber.next(windowSubject.asObservable());
        var errorHandler = function(err) {
            windowSubject.error(err);
            subscriber.error(err);
        };
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value);
        }, function() {
            windowSubject.complete();
            subscriber.complete();
        }, errorHandler));
        $aJ0vk.innerFrom(windowBoundaries).subscribe($a1JN2.createOperatorSubscriber(subscriber, function() {
            windowSubject.complete();
            subscriber.next(windowSubject = new $7qEr0.Subject());
        }, $6UXs2.noop, errorHandler));
        return function() {
            windowSubject === null || windowSubject === void 0 || windowSubject.unsubscribe();
            windowSubject = null;
        };
    });
}
module.exports.window = $2d95dd12be1696af$var$window;

});

parcelRegister("8FElb", function(module, exports) {
"use strict";
var $650171e095a51248$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.windowCount = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");
function $650171e095a51248$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
    return $3xclF.operate(function(source, subscriber) {
        var windows = [
            new $7qEr0.Subject()
        ];
        var starts = [];
        var count = 0;
        subscriber.next(windows[0].asObservable());
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var e_1, _a;
            try {
                for(var windows_1 = $650171e095a51248$var$__values(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()){
                    var window_1 = windows_1_1.value;
                    window_1.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var c = count - windowSize + 1;
            if (c >= 0 && c % startEvery === 0) windows.shift().complete();
            if (++count % startEvery === 0) {
                var window_2 = new $7qEr0.Subject();
                windows.push(window_2);
                subscriber.next(window_2.asObservable());
            }
        }, function() {
            while(windows.length > 0)windows.shift().complete();
            subscriber.complete();
        }, function(err) {
            while(windows.length > 0)windows.shift().error(err);
            subscriber.error(err);
        }, function() {
            starts = null;
            windows = null;
        }));
    });
}
module.exports.windowCount = $650171e095a51248$var$windowCount;

});

parcelRegister("fxabb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.windowTime = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $iblpQ = parcelRequire("iblpQ");

var $3NoDj = parcelRequire("3NoDj");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $59Z75 = parcelRequire("59Z75");

var $5D9gI = parcelRequire("5D9gI");

var $h257w = parcelRequire("h257w");
function $b4f1d57e3679a1fa$var$windowTime(windowTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)otherArgs[_i - 1] = arguments[_i];
    var scheduler = (_a = $5D9gI.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : $iblpQ.asyncScheduler;
    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxWindowSize = otherArgs[1] || Infinity;
    return $3xclF.operate(function(source, subscriber) {
        var windowRecords = [];
        var restartOnClose = false;
        var closeWindow = function(record) {
            var window = record.window, subs = record.subs;
            window.complete();
            subs.unsubscribe();
            $59Z75.arrRemove(windowRecords, record);
            restartOnClose && startWindow();
        };
        var startWindow = function() {
            if (windowRecords) {
                var subs = new $3NoDj.Subscription();
                subscriber.add(subs);
                var window_1 = new $7qEr0.Subject();
                var record_1 = {
                    window: window_1,
                    subs: subs,
                    seen: 0
                };
                windowRecords.push(record_1);
                subscriber.next(window_1.asObservable());
                $h257w.executeSchedule(subs, scheduler, function() {
                    return closeWindow(record_1);
                }, windowTimeSpan);
            }
        };
        if (windowCreationInterval !== null && windowCreationInterval >= 0) $h257w.executeSchedule(subscriber, scheduler, startWindow, windowCreationInterval, true);
        else restartOnClose = true;
        startWindow();
        var loop = function(cb) {
            return windowRecords.slice().forEach(cb);
        };
        var terminate = function(cb) {
            loop(function(_a) {
                var window = _a.window;
                return cb(window);
            });
            cb(subscriber);
            subscriber.unsubscribe();
        };
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            loop(function(record) {
                record.window.next(value);
                maxWindowSize <= ++record.seen && closeWindow(record);
            });
        }, function() {
            return terminate(function(consumer) {
                return consumer.complete();
            });
        }, function(err) {
            return terminate(function(consumer) {
                return consumer.error(err);
            });
        }));
        return function() {
            windowRecords = null;
        };
    });
}
module.exports.windowTime = $b4f1d57e3679a1fa$var$windowTime;

});

parcelRegister("6KMpd", function(module, exports) {
"use strict";
var $4eac9654c0c37922$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.windowToggle = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $3NoDj = parcelRequire("3NoDj");

var $3xclF = parcelRequire("3xclF");

var $aJ0vk = parcelRequire("aJ0vk");

var $a1JN2 = parcelRequire("a1JN2");

var $6UXs2 = parcelRequire("6UXs2");

var $59Z75 = parcelRequire("59Z75");
function $4eac9654c0c37922$var$windowToggle(openings, closingSelector) {
    return $3xclF.operate(function(source, subscriber) {
        var windows = [];
        var handleError = function(err) {
            while(0 < windows.length)windows.shift().error(err);
            subscriber.error(err);
        };
        $aJ0vk.innerFrom(openings).subscribe($a1JN2.createOperatorSubscriber(subscriber, function(openValue) {
            var window = new $7qEr0.Subject();
            windows.push(window);
            var closingSubscription = new $3NoDj.Subscription();
            var closeWindow = function() {
                $59Z75.arrRemove(windows, window);
                window.complete();
                closingSubscription.unsubscribe();
            };
            var closingNotifier;
            try {
                closingNotifier = $aJ0vk.innerFrom(closingSelector(openValue));
            } catch (err) {
                handleError(err);
                return;
            }
            subscriber.next(window.asObservable());
            closingSubscription.add(closingNotifier.subscribe($a1JN2.createOperatorSubscriber(subscriber, closeWindow, $6UXs2.noop, handleError)));
        }, $6UXs2.noop));
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            var e_1, _a;
            var windowsCopy = windows.slice();
            try {
                for(var windowsCopy_1 = $4eac9654c0c37922$var$__values(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()){
                    var window_1 = windowsCopy_1_1.value;
                    window_1.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(0 < windows.length)windows.shift().complete();
            subscriber.complete();
        }, handleError, function() {
            while(0 < windows.length)windows.shift().unsubscribe();
        }));
    });
}
module.exports.windowToggle = $4eac9654c0c37922$var$windowToggle;

});

parcelRegister("8F6gz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.windowWhen = void 0;

var $7qEr0 = parcelRequire("7qEr0");

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");
function $64e703675d3ce993$var$windowWhen(closingSelector) {
    return $3xclF.operate(function(source, subscriber) {
        var window;
        var closingSubscriber;
        var handleError = function(err) {
            window.error(err);
            subscriber.error(err);
        };
        var openWindow = function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            window === null || window === void 0 || window.complete();
            window = new $7qEr0.Subject();
            subscriber.next(window.asObservable());
            var closingNotifier;
            try {
                closingNotifier = $aJ0vk.innerFrom(closingSelector());
            } catch (err) {
                handleError(err);
                return;
            }
            closingNotifier.subscribe(closingSubscriber = $a1JN2.createOperatorSubscriber(subscriber, openWindow, openWindow, handleError));
        };
        openWindow();
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            return window.next(value);
        }, function() {
            window.complete();
            subscriber.complete();
        }, handleError, function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            window = null;
        }));
    });
}
module.exports.windowWhen = $64e703675d3ce993$var$windowWhen;

});

parcelRegister("8hSe0", function(module, exports) {
"use strict";
var $6089f92da72d5a04$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $6089f92da72d5a04$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.withLatestFrom = void 0;

var $3xclF = parcelRequire("3xclF");

var $a1JN2 = parcelRequire("a1JN2");

var $aJ0vk = parcelRequire("aJ0vk");

var $doKTd = parcelRequire("doKTd");

var $6UXs2 = parcelRequire("6UXs2");

var $5D9gI = parcelRequire("5D9gI");
function $6089f92da72d5a04$var$withLatestFrom() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = $5D9gI.popResultSelector(inputs);
    return $3xclF.operate(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            $aJ0vk.innerFrom(inputs[i]).subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every($doKTd.identity)) && (hasValue = null);
                }
            }, $6UXs2.noop));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe($a1JN2.createOperatorSubscriber(subscriber, function(value) {
            if (ready) {
                var values = $6089f92da72d5a04$var$__spreadArray([
                    value
                ], $6089f92da72d5a04$var$__read(otherValues));
                subscriber.next(project ? project.apply(void 0, $6089f92da72d5a04$var$__spreadArray([], $6089f92da72d5a04$var$__read(values))) : values);
            }
        }));
    });
}
module.exports.withLatestFrom = $6089f92da72d5a04$var$withLatestFrom;

});

parcelRegister("cfyGJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zipAll = void 0;

var $8aMcK = parcelRequire("8aMcK");

var $efc78 = parcelRequire("efc78");
function $8eb1cb19942b605c$var$zipAll(project) {
    return $efc78.joinAllInternals($8aMcK.zip, project);
}
module.exports.zipAll = $8eb1cb19942b605c$var$zipAll;

});

parcelRegister("bQ6MC", function(module, exports) {
"use strict";
var $89e9d00655447099$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $89e9d00655447099$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zipWith = void 0;

var $7wp9W = parcelRequire("7wp9W");
function $89e9d00655447099$var$zipWith() {
    var otherInputs = [];
    for(var _i = 0; _i < arguments.length; _i++)otherInputs[_i] = arguments[_i];
    return $7wp9W.zip.apply(void 0, $89e9d00655447099$var$__spreadArray([], $89e9d00655447099$var$__read(otherInputs)));
}
module.exports.zipWith = $89e9d00655447099$var$zipWith;

});
parcelRegister("7wp9W", function(module, exports) {
"use strict";
var $579f09b3b28f75da$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $579f09b3b28f75da$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zip = void 0;

var $8aMcK = parcelRequire("8aMcK");

var $3xclF = parcelRequire("3xclF");
function $579f09b3b28f75da$var$zip() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $3xclF.operate(function(source, subscriber) {
        $8aMcK.zip.apply(void 0, $579f09b3b28f75da$var$__spreadArray([
            source
        ], $579f09b3b28f75da$var$__read(sources))).subscribe(subscriber);
    });
}
module.exports.zip = $579f09b3b28f75da$var$zip;

});




parcelRegister("eYU9f", function(module, exports) {
"use strict";
var $ae823927579ed107$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concurrently = void 0;

const $ae823927579ed107$var$assert_1 = $ae823927579ed107$var$__importDefault((parcelRequire("iWlGy")));

const $ae823927579ed107$var$lodash_1 = $ae823927579ed107$var$__importDefault((parcelRequire("2m7Ys")));

var $iyJxE = parcelRequire("iyJxE");

const $ae823927579ed107$var$spawn_command_1 = $ae823927579ed107$var$__importDefault((parcelRequire("9Yqv2")));

const $ae823927579ed107$var$tree_kill_1 = $ae823927579ed107$var$__importDefault((parcelRequire("3M1TQ")));

var $b27q8 = parcelRequire("b27q8");

var $8A6Qz = parcelRequire("8A6Qz");

var $judok = parcelRequire("judok");

var $6myFh = parcelRequire("6myFh");

var $9wGap = parcelRequire("9wGap");

var $gzABk = parcelRequire("gzABk");

var $kyVoJ = parcelRequire("kyVoJ");

var $3RPGu = parcelRequire("3RPGu");

var $lteuy = parcelRequire("lteuy");
const $ae823927579ed107$var$defaults = {
    spawn: $ae823927579ed107$var$spawn_command_1.default,
    kill: $ae823927579ed107$var$tree_kill_1.default,
    raw: false,
    controllers: [],
    cwd: undefined
};
/**
 * Core concurrently functionality -- spawns the given commands concurrently and
 * returns the commands themselves + the result according to the specified success condition.
 *
 * @see CompletionListener
 */ function $ae823927579ed107$var$concurrently(baseCommands, baseOptions) {
    $ae823927579ed107$var$assert_1.default.ok(Array.isArray(baseCommands), '[concurrently] commands should be an array');
    $ae823927579ed107$var$assert_1.default.notStrictEqual(baseCommands.length, 0, '[concurrently] no commands provided');
    const options = $ae823927579ed107$var$lodash_1.default.defaults(baseOptions, $ae823927579ed107$var$defaults);
    const prefixColorSelector = new $lteuy.PrefixColorSelector(options.prefixColors);
    const commandParsers = [
        new $9wGap.StripQuotes(),
        new $judok.ExpandNpmShortcut(),
        new $6myFh.ExpandNpmWildcard()
    ];
    if (options.additionalArguments) commandParsers.push(new $8A6Qz.ExpandArguments(options.additionalArguments));
    let commands = (0, $ae823927579ed107$var$lodash_1.default)(baseCommands).map($ae823927579ed107$var$mapToCommandInfo).flatMap((command)=>$ae823927579ed107$var$parseCommand(command, commandParsers)).map((command, index)=>{
        return new $b27q8.Command({
            index: index,
            prefixColor: prefixColorSelector.getNextColor(),
            ...command
        }, (0, $kyVoJ.getSpawnOpts)({
            raw: options.raw,
            env: command.env,
            cwd: command.cwd || options.cwd
        }), options.spawn, options.kill);
    }).value();
    const handleResult = options.controllers.reduce(({ commands: prevCommands, onFinishCallbacks: onFinishCallbacks }, controller)=>{
        const { commands: commands, onFinish: onFinish } = controller.handle(prevCommands);
        return {
            commands: commands,
            onFinishCallbacks: $ae823927579ed107$var$lodash_1.default.concat(onFinishCallbacks, onFinish ? [
                onFinish
            ] : [])
        };
    }, {
        commands: commands,
        onFinishCallbacks: []
    });
    commands = handleResult.commands;
    if (options.logger && options.outputStream) {
        const outputWriter = new $3RPGu.OutputWriter({
            outputStream: options.outputStream,
            group: !!options.group,
            commands: commands
        });
        options.logger.output.subscribe(({ command: command, text: text })=>outputWriter.write(command, text));
    }
    const commandsLeft = commands.slice();
    const maxProcesses = Math.max(1, (typeof options.maxProcesses === 'string' && options.maxProcesses.endsWith('%') ? Math.round((0, $iyJxE.cpus)().length * Number(options.maxProcesses.slice(0, -1)) / 100) : Number(options.maxProcesses)) || commandsLeft.length);
    for(let i = 0; i < maxProcesses; i++)$ae823927579ed107$var$maybeRunMore(commandsLeft);
    const result = new $gzABk.CompletionListener({
        successCondition: options.successCondition
    }).listen(commands).finally(()=>{
        handleResult.onFinishCallbacks.forEach((onFinish)=>onFinish());
    });
    return {
        result: result,
        commands: commands
    };
}
module.exports.concurrently = $ae823927579ed107$var$concurrently;
function $ae823927579ed107$var$mapToCommandInfo(command) {
    if (typeof command === 'string') return $ae823927579ed107$var$mapToCommandInfo({
        command: command
    });
    $ae823927579ed107$var$assert_1.default.ok(command.command, '[concurrently] command cannot be empty');
    return {
        command: command.command,
        name: command.name || '',
        env: command.env || {},
        cwd: command.cwd || '',
        ...command.prefixColor ? {
            prefixColor: command.prefixColor
        } : {}
    };
}
function $ae823927579ed107$var$parseCommand(command, parsers) {
    return parsers.reduce((commands, parser)=>$ae823927579ed107$var$lodash_1.default.flatMap(commands, (command)=>parser.parse(command)), $ae823927579ed107$var$lodash_1.default.castArray(command));
}
function $ae823927579ed107$var$maybeRunMore(commandsLeft) {
    const command = commandsLeft.shift();
    if (!command) return;
    command.start();
    command.close.subscribe(()=>{
        $ae823927579ed107$var$maybeRunMore(commandsLeft);
    });
}

});
parcelRegister("iWlGy", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $bNDrn = parcelRequire("bNDrn");
'use strict';
function $dc9e77027bb41b68$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dc9e77027bb41b68$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc9e77027bb41b68$var$_typeof(o);
}
function $dc9e77027bb41b68$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $dc9e77027bb41b68$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $dc9e77027bb41b68$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dc9e77027bb41b68$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dc9e77027bb41b68$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $dc9e77027bb41b68$var$_toPropertyKey(arg) {
    var key = $dc9e77027bb41b68$var$_toPrimitive(arg, "string");
    return $dc9e77027bb41b68$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dc9e77027bb41b68$var$_toPrimitive(input, hint) {
    if ($dc9e77027bb41b68$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dc9e77027bb41b68$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $dc9e77027bb41b68$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $e8Hgs = parcelRequire("e8Hgs");
var $dc9e77027bb41b68$var$_require$codes = $e8Hgs.codes, $dc9e77027bb41b68$var$ERR_AMBIGUOUS_ARGUMENT = $dc9e77027bb41b68$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $dc9e77027bb41b68$var$ERR_INVALID_ARG_TYPE = $dc9e77027bb41b68$var$_require$codes.ERR_INVALID_ARG_TYPE, $dc9e77027bb41b68$var$ERR_INVALID_ARG_VALUE = $dc9e77027bb41b68$var$_require$codes.ERR_INVALID_ARG_VALUE, $dc9e77027bb41b68$var$ERR_INVALID_RETURN_VALUE = $dc9e77027bb41b68$var$_require$codes.ERR_INVALID_RETURN_VALUE, $dc9e77027bb41b68$var$ERR_MISSING_ARGS = $dc9e77027bb41b68$var$_require$codes.ERR_MISSING_ARGS;

var $h57Od = parcelRequire("h57Od");

var $lp2MB = parcelRequire("lp2MB");
var $dc9e77027bb41b68$var$inspect = $lp2MB.inspect;

var $lp2MB = parcelRequire("lp2MB");
var $dc9e77027bb41b68$require$_require$types = $lp2MB.types;
var $dc9e77027bb41b68$var$isPromise = $dc9e77027bb41b68$require$_require$types.isPromise, $dc9e77027bb41b68$var$isRegExp = $dc9e77027bb41b68$require$_require$types.isRegExp;

var $dc9e77027bb41b68$var$objectAssign = (parcelRequire("4wLnw"))();

var $dc9e77027bb41b68$var$objectIs = (parcelRequire("a0WHf"))();

var $dc9e77027bb41b68$var$RegExpPrototypeTest = (parcelRequire("5lpi0"))('RegExp.prototype.test');
var $dc9e77027bb41b68$var$errorCache = new Map();
var $dc9e77027bb41b68$var$isDeepEqual;
var $dc9e77027bb41b68$var$isDeepStrictEqual;
var $dc9e77027bb41b68$var$parseExpressionAt;
var $dc9e77027bb41b68$var$findNodeAround;
var $dc9e77027bb41b68$var$decoder;

function $dc9e77027bb41b68$var$lazyLoadComparison() {
    var comparison = (parcelRequire("7cnie"));
    $dc9e77027bb41b68$var$isDeepEqual = comparison.isDeepEqual;
    $dc9e77027bb41b68$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $dc9e77027bb41b68$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $dc9e77027bb41b68$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $dc9e77027bb41b68$var$escapeFn = function escapeFn(str) {
    return $dc9e77027bb41b68$var$meta[str.charCodeAt(0)];
};
var $dc9e77027bb41b68$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $dc9e77027bb41b68$var$assert = module.exports = $dc9e77027bb41b68$var$ok;
var $dc9e77027bb41b68$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $dc9e77027bb41b68$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $h57Od(obj);
}
function $dc9e77027bb41b68$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($dc9e77027bb41b68$var$warned === false) {
            $dc9e77027bb41b68$var$warned = true;
            var warn = $bNDrn.emitWarning ? $bNDrn.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $dc9e77027bb41b68$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $h57Od(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$dc9e77027bb41b68$var$assert.fail = $dc9e77027bb41b68$var$fail;
// The AssertionError is defined in internal/error.
$dc9e77027bb41b68$var$assert.AssertionError = $h57Od;
function $dc9e77027bb41b68$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $h57Od({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $dc9e77027bb41b68$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $dc9e77027bb41b68$var$innerOk.apply(void 0, [
        $dc9e77027bb41b68$var$ok,
        args.length
    ].concat(args));
}
$dc9e77027bb41b68$var$assert.ok = $dc9e77027bb41b68$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $dc9e77027bb41b68$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $dc9e77027bb41b68$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $dc9e77027bb41b68$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$dc9e77027bb41b68$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc9e77027bb41b68$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $dc9e77027bb41b68$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$dc9e77027bb41b68$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc9e77027bb41b68$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc9e77027bb41b68$var$isDeepEqual === undefined) $dc9e77027bb41b68$var$lazyLoadComparison();
    if (!$dc9e77027bb41b68$var$isDeepEqual(actual, expected)) $dc9e77027bb41b68$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$dc9e77027bb41b68$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc9e77027bb41b68$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc9e77027bb41b68$var$isDeepEqual === undefined) $dc9e77027bb41b68$var$lazyLoadComparison();
    if ($dc9e77027bb41b68$var$isDeepEqual(actual, expected)) $dc9e77027bb41b68$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $dc9e77027bb41b68$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc9e77027bb41b68$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc9e77027bb41b68$var$isDeepEqual === undefined) $dc9e77027bb41b68$var$lazyLoadComparison();
    if (!$dc9e77027bb41b68$var$isDeepStrictEqual(actual, expected)) $dc9e77027bb41b68$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$dc9e77027bb41b68$var$assert.notDeepStrictEqual = $dc9e77027bb41b68$var$notDeepStrictEqual;
function $dc9e77027bb41b68$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc9e77027bb41b68$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc9e77027bb41b68$var$isDeepEqual === undefined) $dc9e77027bb41b68$var$lazyLoadComparison();
    if ($dc9e77027bb41b68$var$isDeepStrictEqual(actual, expected)) $dc9e77027bb41b68$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $dc9e77027bb41b68$var$notDeepStrictEqual
    });
}
$dc9e77027bb41b68$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc9e77027bb41b68$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$dc9e77027bb41b68$var$objectIs(actual, expected)) $dc9e77027bb41b68$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$dc9e77027bb41b68$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc9e77027bb41b68$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc9e77027bb41b68$var$objectIs(actual, expected)) $dc9e77027bb41b68$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $dc9e77027bb41b68$var$Comparison = /*#__PURE__*/ $dc9e77027bb41b68$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $dc9e77027bb41b68$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $dc9e77027bb41b68$var$isRegExp(obj[key]) && $dc9e77027bb41b68$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $dc9e77027bb41b68$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$dc9e77027bb41b68$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $dc9e77027bb41b68$var$Comparison(actual, keys);
            var b = new $dc9e77027bb41b68$var$Comparison(expected, keys, actual);
            var err = new $h57Od({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $dc9e77027bb41b68$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $dc9e77027bb41b68$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($dc9e77027bb41b68$var$isRegExp(expected)) return $dc9e77027bb41b68$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $dc9e77027bb41b68$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($dc9e77027bb41b68$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $h57Od({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $dc9e77027bb41b68$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($dc9e77027bb41b68$var$isDeepEqual === undefined) $dc9e77027bb41b68$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $dc9e77027bb41b68$var$isRegExp(expected[key]) && $dc9e77027bb41b68$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $dc9e77027bb41b68$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $dc9e77027bb41b68$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $dc9e77027bb41b68$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $dc9e77027bb41b68$var$NO_EXCEPTION_SENTINEL;
}
function $dc9e77027bb41b68$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $dc9e77027bb41b68$var$isPromise(obj) || obj !== null && $dc9e77027bb41b68$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $dc9e77027bb41b68$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$dc9e77027bb41b68$var$checkIsPromise(resultPromise)) throw new $dc9e77027bb41b68$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($dc9e77027bb41b68$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $dc9e77027bb41b68$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $dc9e77027bb41b68$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $dc9e77027bb41b68$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $dc9e77027bb41b68$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($dc9e77027bb41b68$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $dc9e77027bb41b68$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $dc9e77027bb41b68$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $dc9e77027bb41b68$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $dc9e77027bb41b68$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $dc9e77027bb41b68$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $dc9e77027bb41b68$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$dc9e77027bb41b68$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $dc9e77027bb41b68$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $dc9e77027bb41b68$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $dc9e77027bb41b68$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $dc9e77027bb41b68$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$dc9e77027bb41b68$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $dc9e77027bb41b68$var$expectsError.apply(void 0, [
        throws,
        $dc9e77027bb41b68$var$getActual(promiseFn)
    ].concat(args));
};
$dc9e77027bb41b68$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $dc9e77027bb41b68$var$waitForActual(promiseFn).then(function(result) {
        return $dc9e77027bb41b68$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$dc9e77027bb41b68$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $dc9e77027bb41b68$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $dc9e77027bb41b68$var$getActual(fn)
    ].concat(args));
};
$dc9e77027bb41b68$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $dc9e77027bb41b68$var$waitForActual(fn).then(function(result) {
        return $dc9e77027bb41b68$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$dc9e77027bb41b68$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($dc9e77027bb41b68$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $dc9e77027bb41b68$var$inspect(err);
        var newErr = new $h57Od({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $dc9e77027bb41b68$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$dc9e77027bb41b68$var$isRegExp(regexp)) throw new $dc9e77027bb41b68$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $dc9e77027bb41b68$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($dc9e77027bb41b68$var$_typeof(string), " (").concat($dc9e77027bb41b68$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($dc9e77027bb41b68$var$inspect(regexp), ". Input:\n\n").concat($dc9e77027bb41b68$var$inspect(string), "\n"));
        var err = new $h57Od({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$dc9e77027bb41b68$var$assert.match = function match(string, regexp, message) {
    $dc9e77027bb41b68$var$internalMatch(string, regexp, message, match, 'match');
};
$dc9e77027bb41b68$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $dc9e77027bb41b68$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $dc9e77027bb41b68$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $dc9e77027bb41b68$var$innerOk.apply(void 0, [
        $dc9e77027bb41b68$var$strict,
        args.length
    ].concat(args));
}
$dc9e77027bb41b68$var$assert.strict = $dc9e77027bb41b68$var$objectAssign($dc9e77027bb41b68$var$strict, $dc9e77027bb41b68$var$assert, {
    equal: $dc9e77027bb41b68$var$assert.strictEqual,
    deepEqual: $dc9e77027bb41b68$var$assert.deepStrictEqual,
    notEqual: $dc9e77027bb41b68$var$assert.notStrictEqual,
    notDeepEqual: $dc9e77027bb41b68$var$assert.notDeepStrictEqual
});
$dc9e77027bb41b68$var$assert.strict.strict = $dc9e77027bb41b68$var$assert.strict;

});
parcelRegister("e8Hgs", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $a4b35f7448677631$export$e45cb6485273080e; }, function (v) { return $a4b35f7448677631$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $a4b35f7448677631$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $a4b35f7448677631$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a4b35f7448677631$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a4b35f7448677631$var$_typeof(o);
}
function $a4b35f7448677631$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a4b35f7448677631$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a4b35f7448677631$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a4b35f7448677631$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a4b35f7448677631$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a4b35f7448677631$var$_toPropertyKey(arg) {
    var key = $a4b35f7448677631$var$_toPrimitive(arg, "string");
    return $a4b35f7448677631$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a4b35f7448677631$var$_toPrimitive(input, hint) {
    if ($a4b35f7448677631$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a4b35f7448677631$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a4b35f7448677631$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4b35f7448677631$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a4b35f7448677631$var$_setPrototypeOf(subClass, superClass);
}
function $a4b35f7448677631$var$_setPrototypeOf(o, p) {
    $a4b35f7448677631$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a4b35f7448677631$var$_setPrototypeOf(o, p);
}
function $a4b35f7448677631$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a4b35f7448677631$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a4b35f7448677631$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a4b35f7448677631$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a4b35f7448677631$var$_possibleConstructorReturn(this, result);
    };
}
function $a4b35f7448677631$var$_possibleConstructorReturn(self, call) {
    if (call && ($a4b35f7448677631$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a4b35f7448677631$var$_assertThisInitialized(self);
}
function $a4b35f7448677631$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a4b35f7448677631$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a4b35f7448677631$var$_getPrototypeOf(o) {
    $a4b35f7448677631$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a4b35f7448677631$var$_getPrototypeOf(o);
}
var $a4b35f7448677631$var$codes = {};
// Lazy loaded
var $a4b35f7448677631$var$assert;
var $a4b35f7448677631$var$util;
function $a4b35f7448677631$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $a4b35f7448677631$var$_inherits(NodeError, _Base);
        var _super = $a4b35f7448677631$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $a4b35f7448677631$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $a4b35f7448677631$var$_createClass(NodeError);
    }(Base);
    $a4b35f7448677631$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $a4b35f7448677631$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $a4b35f7448677631$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $a4b35f7448677631$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $a4b35f7448677631$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$a4b35f7448677631$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$a4b35f7448677631$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($a4b35f7448677631$var$assert === undefined) $a4b35f7448677631$var$assert = (parcelRequire("iWlGy"));
    $a4b35f7448677631$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $a4b35f7448677631$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($a4b35f7448677631$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($a4b35f7448677631$var$oneOf(expected, 'type'));
    else {
        var type = $a4b35f7448677631$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($a4b35f7448677631$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($a4b35f7448677631$var$_typeof(actual));
    return msg;
}, TypeError);

$a4b35f7448677631$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($a4b35f7448677631$var$util === undefined) $a4b35f7448677631$var$util = (parcelRequire("lp2MB"));
    var inspected = $a4b35f7448677631$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$a4b35f7448677631$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($a4b35f7448677631$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$a4b35f7448677631$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($a4b35f7448677631$var$assert === undefined) $a4b35f7448677631$var$assert = (parcelRequire("iWlGy"));
    $a4b35f7448677631$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$a4b35f7448677631$export$e45cb6485273080e = $a4b35f7448677631$var$codes;

});
parcelRegister("lp2MB", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $bNDrn = parcelRequire("bNDrn");
var $f94e1768415cdf09$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $f94e1768415cdf09$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$f94e1768415cdf09$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($f94e1768415cdf09$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($f94e1768415cdf09$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($f94e1768415cdf09$var$isNull(x) || !$f94e1768415cdf09$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $f94e1768415cdf09$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($bNDrn.throwDeprecation) throw new Error(msg);
            else if ($bNDrn.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $f94e1768415cdf09$var$debugs = {};
var $f94e1768415cdf09$var$debugEnvRegex = /^$/;
var $f94e1768415cdf09$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$f94e1768415cdf09$var$debugs[set]) {
        if ($f94e1768415cdf09$var$debugEnvRegex.test(set)) {
            var pid = $bNDrn.pid;
            $f94e1768415cdf09$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $f94e1768415cdf09$var$debugs[set] = function() {};
    }
    return $f94e1768415cdf09$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $f94e1768415cdf09$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $f94e1768415cdf09$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($f94e1768415cdf09$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($f94e1768415cdf09$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($f94e1768415cdf09$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($f94e1768415cdf09$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($f94e1768415cdf09$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $f94e1768415cdf09$var$stylizeWithColor;
    return $f94e1768415cdf09$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $f94e1768415cdf09$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$f94e1768415cdf09$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$f94e1768415cdf09$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $f94e1768415cdf09$var$stylizeWithColor(str, styleType) {
    var style = $f94e1768415cdf09$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $f94e1768415cdf09$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $f94e1768415cdf09$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $f94e1768415cdf09$var$stylizeNoColor(str, styleType) {
    return str;
}
function $f94e1768415cdf09$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $f94e1768415cdf09$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $f94e1768415cdf09$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$f94e1768415cdf09$var$isString(ret)) ret = $f94e1768415cdf09$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $f94e1768415cdf09$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $f94e1768415cdf09$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($f94e1768415cdf09$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $f94e1768415cdf09$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($f94e1768415cdf09$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($f94e1768415cdf09$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($f94e1768415cdf09$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($f94e1768415cdf09$var$isError(value)) return $f94e1768415cdf09$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($f94e1768415cdf09$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($f94e1768415cdf09$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($f94e1768415cdf09$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($f94e1768415cdf09$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($f94e1768415cdf09$var$isError(value)) base = ' ' + $f94e1768415cdf09$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($f94e1768415cdf09$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $f94e1768415cdf09$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $f94e1768415cdf09$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $f94e1768415cdf09$var$reduceToSingleString(output, base, braces);
}
function $f94e1768415cdf09$var$formatPrimitive(ctx, value) {
    if ($f94e1768415cdf09$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($f94e1768415cdf09$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($f94e1768415cdf09$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($f94e1768415cdf09$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($f94e1768415cdf09$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $f94e1768415cdf09$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $f94e1768415cdf09$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($f94e1768415cdf09$var$hasOwnProperty(value, String(i))) output.push($f94e1768415cdf09$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($f94e1768415cdf09$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $f94e1768415cdf09$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$f94e1768415cdf09$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($f94e1768415cdf09$var$isNull(recurseTimes)) str = $f94e1768415cdf09$var$formatValue(ctx, desc.value, null);
            else str = $f94e1768415cdf09$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($f94e1768415cdf09$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $f94e1768415cdf09$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("fpRel"));
function $f94e1768415cdf09$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $f94e1768415cdf09$var$isArray;
function $f94e1768415cdf09$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $f94e1768415cdf09$var$isBoolean;
function $f94e1768415cdf09$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $f94e1768415cdf09$var$isNull;
function $f94e1768415cdf09$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $f94e1768415cdf09$var$isNullOrUndefined;
function $f94e1768415cdf09$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $f94e1768415cdf09$var$isNumber;
function $f94e1768415cdf09$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $f94e1768415cdf09$var$isString;
function $f94e1768415cdf09$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $f94e1768415cdf09$var$isSymbol;
function $f94e1768415cdf09$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $f94e1768415cdf09$var$isUndefined;
function $f94e1768415cdf09$var$isRegExp(re) {
    return $f94e1768415cdf09$var$isObject(re) && $f94e1768415cdf09$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $f94e1768415cdf09$var$isRegExp;
module.exports.types.isRegExp = $f94e1768415cdf09$var$isRegExp;
function $f94e1768415cdf09$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $f94e1768415cdf09$var$isObject;
function $f94e1768415cdf09$var$isDate(d) {
    return $f94e1768415cdf09$var$isObject(d) && $f94e1768415cdf09$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $f94e1768415cdf09$var$isDate;
module.exports.types.isDate = $f94e1768415cdf09$var$isDate;
function $f94e1768415cdf09$var$isError(e) {
    return $f94e1768415cdf09$var$isObject(e) && ($f94e1768415cdf09$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $f94e1768415cdf09$var$isError;
module.exports.types.isNativeError = $f94e1768415cdf09$var$isError;
function $f94e1768415cdf09$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $f94e1768415cdf09$var$isFunction;
function $f94e1768415cdf09$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $f94e1768415cdf09$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("7jOQT"));
function $f94e1768415cdf09$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $f94e1768415cdf09$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $f94e1768415cdf09$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $f94e1768415cdf09$var$timestamp() {
    var d = new Date();
    var time = [
        $f94e1768415cdf09$var$pad(d.getHours()),
        $f94e1768415cdf09$var$pad(d.getMinutes()),
        $f94e1768415cdf09$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $f94e1768415cdf09$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $f94e1768415cdf09$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dncHQ"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$f94e1768415cdf09$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $f94e1768415cdf09$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $f94e1768415cdf09$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($f94e1768415cdf09$var$kCustomPromisifiedSymbol && original[$f94e1768415cdf09$var$kCustomPromisifiedSymbol]) {
        var fn = original[$f94e1768415cdf09$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $f94e1768415cdf09$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($f94e1768415cdf09$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $f94e1768415cdf09$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $f94e1768415cdf09$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $f94e1768415cdf09$var$kCustomPromisifiedSymbol;
function $f94e1768415cdf09$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $f94e1768415cdf09$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $bNDrn.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $bNDrn.nextTick($f94e1768415cdf09$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $f94e1768415cdf09$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $f94e1768415cdf09$var$callbackify;

});
parcelRegister("fpRel", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $gmFZX = parcelRequire("gmFZX");

var $36y3y = parcelRequire("36y3y");

var $3Rml8 = parcelRequire("3Rml8");

var $4rC0W = parcelRequire("4rC0W");
function $b3927b48210f6a44$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $b3927b48210f6a44$var$BigIntSupported = typeof BigInt !== 'undefined';
var $b3927b48210f6a44$var$SymbolSupported = typeof Symbol !== 'undefined';
var $b3927b48210f6a44$var$ObjectToString = $b3927b48210f6a44$var$uncurryThis(Object.prototype.toString);
var $b3927b48210f6a44$var$numberValue = $b3927b48210f6a44$var$uncurryThis(Number.prototype.valueOf);
var $b3927b48210f6a44$var$stringValue = $b3927b48210f6a44$var$uncurryThis(String.prototype.valueOf);
var $b3927b48210f6a44$var$booleanValue = $b3927b48210f6a44$var$uncurryThis(Boolean.prototype.valueOf);
if ($b3927b48210f6a44$var$BigIntSupported) var $b3927b48210f6a44$var$bigIntValue = $b3927b48210f6a44$var$uncurryThis(BigInt.prototype.valueOf);
if ($b3927b48210f6a44$var$SymbolSupported) var $b3927b48210f6a44$var$symbolValue = $b3927b48210f6a44$var$uncurryThis(Symbol.prototype.valueOf);
function $b3927b48210f6a44$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $gmFZX;
module.exports.isGeneratorFunction = $36y3y;
module.exports.isTypedArray = $4rC0W;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $b3927b48210f6a44$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $b3927b48210f6a44$var$isPromise;
function $b3927b48210f6a44$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $4rC0W(value) || $b3927b48210f6a44$var$isDataView(value);
}
module.exports.isArrayBufferView = $b3927b48210f6a44$var$isArrayBufferView;
function $b3927b48210f6a44$var$isUint8Array(value) {
    return $3Rml8(value) === 'Uint8Array';
}
module.exports.isUint8Array = $b3927b48210f6a44$var$isUint8Array;
function $b3927b48210f6a44$var$isUint8ClampedArray(value) {
    return $3Rml8(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $b3927b48210f6a44$var$isUint8ClampedArray;
function $b3927b48210f6a44$var$isUint16Array(value) {
    return $3Rml8(value) === 'Uint16Array';
}
module.exports.isUint16Array = $b3927b48210f6a44$var$isUint16Array;
function $b3927b48210f6a44$var$isUint32Array(value) {
    return $3Rml8(value) === 'Uint32Array';
}
module.exports.isUint32Array = $b3927b48210f6a44$var$isUint32Array;
function $b3927b48210f6a44$var$isInt8Array(value) {
    return $3Rml8(value) === 'Int8Array';
}
module.exports.isInt8Array = $b3927b48210f6a44$var$isInt8Array;
function $b3927b48210f6a44$var$isInt16Array(value) {
    return $3Rml8(value) === 'Int16Array';
}
module.exports.isInt16Array = $b3927b48210f6a44$var$isInt16Array;
function $b3927b48210f6a44$var$isInt32Array(value) {
    return $3Rml8(value) === 'Int32Array';
}
module.exports.isInt32Array = $b3927b48210f6a44$var$isInt32Array;
function $b3927b48210f6a44$var$isFloat32Array(value) {
    return $3Rml8(value) === 'Float32Array';
}
module.exports.isFloat32Array = $b3927b48210f6a44$var$isFloat32Array;
function $b3927b48210f6a44$var$isFloat64Array(value) {
    return $3Rml8(value) === 'Float64Array';
}
module.exports.isFloat64Array = $b3927b48210f6a44$var$isFloat64Array;
function $b3927b48210f6a44$var$isBigInt64Array(value) {
    return $3Rml8(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $b3927b48210f6a44$var$isBigInt64Array;
function $b3927b48210f6a44$var$isBigUint64Array(value) {
    return $3Rml8(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $b3927b48210f6a44$var$isBigUint64Array;
function $b3927b48210f6a44$var$isMapToString(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object Map]';
}
$b3927b48210f6a44$var$isMapToString.working = typeof Map !== 'undefined' && $b3927b48210f6a44$var$isMapToString(new Map());
function $b3927b48210f6a44$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $b3927b48210f6a44$var$isMapToString.working ? $b3927b48210f6a44$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $b3927b48210f6a44$var$isMap;
function $b3927b48210f6a44$var$isSetToString(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object Set]';
}
$b3927b48210f6a44$var$isSetToString.working = typeof Set !== 'undefined' && $b3927b48210f6a44$var$isSetToString(new Set());
function $b3927b48210f6a44$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $b3927b48210f6a44$var$isSetToString.working ? $b3927b48210f6a44$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $b3927b48210f6a44$var$isSet;
function $b3927b48210f6a44$var$isWeakMapToString(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object WeakMap]';
}
$b3927b48210f6a44$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $b3927b48210f6a44$var$isWeakMapToString(new WeakMap());
function $b3927b48210f6a44$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $b3927b48210f6a44$var$isWeakMapToString.working ? $b3927b48210f6a44$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $b3927b48210f6a44$var$isWeakMap;
function $b3927b48210f6a44$var$isWeakSetToString(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object WeakSet]';
}
$b3927b48210f6a44$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $b3927b48210f6a44$var$isWeakSetToString(new WeakSet());
function $b3927b48210f6a44$var$isWeakSet(value) {
    return $b3927b48210f6a44$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $b3927b48210f6a44$var$isWeakSet;
function $b3927b48210f6a44$var$isArrayBufferToString(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$b3927b48210f6a44$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $b3927b48210f6a44$var$isArrayBufferToString(new ArrayBuffer());
function $b3927b48210f6a44$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $b3927b48210f6a44$var$isArrayBufferToString.working ? $b3927b48210f6a44$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $b3927b48210f6a44$var$isArrayBuffer;
function $b3927b48210f6a44$var$isDataViewToString(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object DataView]';
}
$b3927b48210f6a44$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $b3927b48210f6a44$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $b3927b48210f6a44$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $b3927b48210f6a44$var$isDataViewToString.working ? $b3927b48210f6a44$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $b3927b48210f6a44$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $b3927b48210f6a44$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $b3927b48210f6a44$var$isSharedArrayBufferToString(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $b3927b48210f6a44$var$isSharedArrayBuffer(value) {
    if (typeof $b3927b48210f6a44$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $b3927b48210f6a44$var$isSharedArrayBufferToString.working === 'undefined') $b3927b48210f6a44$var$isSharedArrayBufferToString.working = $b3927b48210f6a44$var$isSharedArrayBufferToString(new $b3927b48210f6a44$var$SharedArrayBufferCopy());
    return $b3927b48210f6a44$var$isSharedArrayBufferToString.working ? $b3927b48210f6a44$var$isSharedArrayBufferToString(value) : value instanceof $b3927b48210f6a44$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $b3927b48210f6a44$var$isSharedArrayBuffer;
function $b3927b48210f6a44$var$isAsyncFunction(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $b3927b48210f6a44$var$isAsyncFunction;
function $b3927b48210f6a44$var$isMapIterator(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $b3927b48210f6a44$var$isMapIterator;
function $b3927b48210f6a44$var$isSetIterator(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $b3927b48210f6a44$var$isSetIterator;
function $b3927b48210f6a44$var$isGeneratorObject(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $b3927b48210f6a44$var$isGeneratorObject;
function $b3927b48210f6a44$var$isWebAssemblyCompiledModule(value) {
    return $b3927b48210f6a44$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $b3927b48210f6a44$var$isWebAssemblyCompiledModule;
function $b3927b48210f6a44$var$isNumberObject(value) {
    return $b3927b48210f6a44$var$checkBoxedPrimitive(value, $b3927b48210f6a44$var$numberValue);
}
module.exports.isNumberObject = $b3927b48210f6a44$var$isNumberObject;
function $b3927b48210f6a44$var$isStringObject(value) {
    return $b3927b48210f6a44$var$checkBoxedPrimitive(value, $b3927b48210f6a44$var$stringValue);
}
module.exports.isStringObject = $b3927b48210f6a44$var$isStringObject;
function $b3927b48210f6a44$var$isBooleanObject(value) {
    return $b3927b48210f6a44$var$checkBoxedPrimitive(value, $b3927b48210f6a44$var$booleanValue);
}
module.exports.isBooleanObject = $b3927b48210f6a44$var$isBooleanObject;
function $b3927b48210f6a44$var$isBigIntObject(value) {
    return $b3927b48210f6a44$var$BigIntSupported && $b3927b48210f6a44$var$checkBoxedPrimitive(value, $b3927b48210f6a44$var$bigIntValue);
}
module.exports.isBigIntObject = $b3927b48210f6a44$var$isBigIntObject;
function $b3927b48210f6a44$var$isSymbolObject(value) {
    return $b3927b48210f6a44$var$SymbolSupported && $b3927b48210f6a44$var$checkBoxedPrimitive(value, $b3927b48210f6a44$var$symbolValue);
}
module.exports.isSymbolObject = $b3927b48210f6a44$var$isSymbolObject;
function $b3927b48210f6a44$var$isBoxedPrimitive(value) {
    return $b3927b48210f6a44$var$isNumberObject(value) || $b3927b48210f6a44$var$isStringObject(value) || $b3927b48210f6a44$var$isBooleanObject(value) || $b3927b48210f6a44$var$isBigIntObject(value) || $b3927b48210f6a44$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $b3927b48210f6a44$var$isBoxedPrimitive;
function $b3927b48210f6a44$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($b3927b48210f6a44$var$isArrayBuffer(value) || $b3927b48210f6a44$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $b3927b48210f6a44$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("gmFZX", function(module, exports) {
'use strict';

var $be9f4761c81f038a$var$hasToStringTag = (parcelRequire("lCI1x"))();

var $ic5Ua = parcelRequire("ic5Ua");
var $be9f4761c81f038a$var$$toString = $ic5Ua('Object.prototype.toString');
/** @type {import('.')} */ var $be9f4761c81f038a$var$isStandardArguments = function isArguments(value) {
    if ($be9f4761c81f038a$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $be9f4761c81f038a$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $be9f4761c81f038a$var$isLegacyArguments = function isArguments(value) {
    if ($be9f4761c81f038a$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $be9f4761c81f038a$var$$toString(value) !== '[object Array]' && 'callee' in value && $be9f4761c81f038a$var$$toString(value.callee) === '[object Function]';
};
var $be9f4761c81f038a$var$supportsStandardArguments = function() {
    return $be9f4761c81f038a$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$be9f4761c81f038a$var$isStandardArguments.isLegacyArguments = $be9f4761c81f038a$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $be9f4761c81f038a$var$supportsStandardArguments ? $be9f4761c81f038a$var$isStandardArguments : $be9f4761c81f038a$var$isLegacyArguments;

});
parcelRegister("lCI1x", function(module, exports) {
'use strict';

var $90lay = parcelRequire("90lay");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $90lay() && !!Symbol.toStringTag;
};

});
parcelRegister("90lay", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("ic5Ua", function(module, exports) {
'use strict';

var $g8pTf = parcelRequire("g8pTf");

var $h8x15 = parcelRequire("h8x15");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $d3eded94a1544156$var$$indexOf = $h8x15([
    $g8pTf('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $g8pTf(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $d3eded94a1544156$var$$indexOf(name, '.prototype.') > -1) return $h8x15(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("g8pTf", function(module, exports) {
'use strict';
var $bbf179ed4a129a54$var$undefined1;

var $46Dvc = parcelRequire("46Dvc");

var $5UzY5 = parcelRequire("5UzY5");

var $cEuzQ = parcelRequire("cEuzQ");

var $83eHO = parcelRequire("83eHO");

var $8guok = parcelRequire("8guok");

var $581LG = parcelRequire("581LG");

var $lviAQ = parcelRequire("lviAQ");

var $ktkAV = parcelRequire("ktkAV");

var $39H5r = parcelRequire("39H5r");

var $c4Wib = parcelRequire("c4Wib");

var $dLo3X = parcelRequire("dLo3X");

var $4ewHn = parcelRequire("4ewHn");

var $2c5va = parcelRequire("2c5va");

var $lIpN8 = parcelRequire("lIpN8");

var $4yRKn = parcelRequire("4yRKn");
var $bbf179ed4a129a54$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $bbf179ed4a129a54$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $bbf179ed4a129a54$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $aFkv5 = parcelRequire("aFkv5");

var $fsjb6 = parcelRequire("fsjb6");
var $bbf179ed4a129a54$var$throwTypeError = function() {
    throw new $lviAQ();
};
var $bbf179ed4a129a54$var$ThrowTypeError = $aFkv5 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $bbf179ed4a129a54$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $aFkv5(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $bbf179ed4a129a54$var$throwTypeError;
        }
    }
}() : $bbf179ed4a129a54$var$throwTypeError;

var $bbf179ed4a129a54$var$hasSymbols = (parcelRequire("kAvTi"))();

var $aDq44 = parcelRequire("aDq44");

var $kZQrB = parcelRequire("kZQrB");

var $9zOgm = parcelRequire("9zOgm");

var $9aVsL = parcelRequire("9aVsL");

var $dXMAI = parcelRequire("dXMAI");
var $bbf179ed4a129a54$var$needsEval = {};
var $bbf179ed4a129a54$var$TypedArray = typeof Uint8Array === 'undefined' || !$aDq44 ? undefined : $aDq44(Uint8Array);
var $bbf179ed4a129a54$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $bbf179ed4a129a54$var$hasSymbols && $aDq44 ? $aDq44([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $bbf179ed4a129a54$var$needsEval,
    '%AsyncGenerator%': $bbf179ed4a129a54$var$needsEval,
    '%AsyncGeneratorFunction%': $bbf179ed4a129a54$var$needsEval,
    '%AsyncIteratorPrototype%': $bbf179ed4a129a54$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5UzY5,
    '%eval%': eval,
    '%EvalError%': $cEuzQ,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $bbf179ed4a129a54$var$$Function,
    '%GeneratorFunction%': $bbf179ed4a129a54$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $bbf179ed4a129a54$var$hasSymbols && $aDq44 ? $aDq44($aDq44([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$bbf179ed4a129a54$var$hasSymbols || !$aDq44 ? undefined : $aDq44(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $46Dvc,
    '%Object.getOwnPropertyDescriptor%': $aFkv5,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $83eHO,
    '%ReferenceError%': $8guok,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$bbf179ed4a129a54$var$hasSymbols || !$aDq44 ? undefined : $aDq44(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $bbf179ed4a129a54$var$hasSymbols && $aDq44 ? $aDq44(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $bbf179ed4a129a54$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $581LG,
    '%ThrowTypeError%': $bbf179ed4a129a54$var$ThrowTypeError,
    '%TypedArray%': $bbf179ed4a129a54$var$TypedArray,
    '%TypeError%': $lviAQ,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $ktkAV,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $dXMAI,
    '%Function.prototype.apply%': $9aVsL,
    '%Object.defineProperty%': $fsjb6,
    '%Object.getPrototypeOf%': $kZQrB,
    '%Math.abs%': $39H5r,
    '%Math.floor%': $c4Wib,
    '%Math.max%': $dLo3X,
    '%Math.min%': $4ewHn,
    '%Math.pow%': $2c5va,
    '%Math.round%': $lIpN8,
    '%Math.sign%': $4yRKn,
    '%Reflect.getPrototypeOf%': $9zOgm
};
if ($aDq44) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $bbf179ed4a129a54$var$errorProto = $aDq44($aDq44(e));
    $bbf179ed4a129a54$var$INTRINSICS['%Error.prototype%'] = $bbf179ed4a129a54$var$errorProto;
}
var $bbf179ed4a129a54$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $bbf179ed4a129a54$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $bbf179ed4a129a54$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $bbf179ed4a129a54$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $aDq44) value = $aDq44(gen.prototype);
    }
    $bbf179ed4a129a54$var$INTRINSICS[name] = value;
    return value;
};
var $bbf179ed4a129a54$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $1HeiI = parcelRequire("1HeiI");

var $bvsVM = parcelRequire("bvsVM");
var $bbf179ed4a129a54$var$$concat = $1HeiI.call($dXMAI, Array.prototype.concat);
var $bbf179ed4a129a54$var$$spliceApply = $1HeiI.call($9aVsL, Array.prototype.splice);
var $bbf179ed4a129a54$var$$replace = $1HeiI.call($dXMAI, String.prototype.replace);
var $bbf179ed4a129a54$var$$strSlice = $1HeiI.call($dXMAI, String.prototype.slice);
var $bbf179ed4a129a54$var$$exec = $1HeiI.call($dXMAI, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $bbf179ed4a129a54$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $bbf179ed4a129a54$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $bbf179ed4a129a54$var$stringToPath = function stringToPath(string) {
    var first = $bbf179ed4a129a54$var$$strSlice(string, 0, 1);
    var last = $bbf179ed4a129a54$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $581LG('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $581LG('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $bbf179ed4a129a54$var$$replace(string, $bbf179ed4a129a54$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $bbf179ed4a129a54$var$$replace(subString, $bbf179ed4a129a54$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $bbf179ed4a129a54$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($bvsVM($bbf179ed4a129a54$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $bbf179ed4a129a54$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($bvsVM($bbf179ed4a129a54$var$INTRINSICS, intrinsicName)) {
        var value = $bbf179ed4a129a54$var$INTRINSICS[intrinsicName];
        if (value === $bbf179ed4a129a54$var$needsEval) value = $bbf179ed4a129a54$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $lviAQ('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $581LG('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $lviAQ('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $lviAQ('"allowMissing" argument must be a boolean');
    if ($bbf179ed4a129a54$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $581LG('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $bbf179ed4a129a54$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $bbf179ed4a129a54$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $bbf179ed4a129a54$var$$spliceApply(parts, $bbf179ed4a129a54$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $bbf179ed4a129a54$var$$strSlice(part, 0, 1);
        var last = $bbf179ed4a129a54$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $581LG('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($bvsVM($bbf179ed4a129a54$var$INTRINSICS, intrinsicRealName)) value = $bbf179ed4a129a54$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $lviAQ('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($aFkv5 && i + 1 >= parts.length) {
                var desc = $aFkv5(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $bvsVM(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $bbf179ed4a129a54$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("46Dvc", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5UzY5", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("cEuzQ", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("83eHO", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("8guok", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("581LG", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("lviAQ", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("ktkAV", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("39H5r", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("c4Wib", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("dLo3X", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4ewHn", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("2c5va", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("lIpN8", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4yRKn", function(module, exports) {
'use strict';

var $dz7eY = parcelRequire("dz7eY");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($dz7eY(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("dz7eY", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("aFkv5", function(module, exports) {
'use strict';

var $efADp = parcelRequire("efADp");
var $7c3da2ad7778e3f1$require$$gOPD = $efADp;
if ($7c3da2ad7778e3f1$require$$gOPD) try {
    $7c3da2ad7778e3f1$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $7c3da2ad7778e3f1$require$$gOPD = null;
}
module.exports = $7c3da2ad7778e3f1$require$$gOPD;

});
parcelRegister("efADp", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("fsjb6", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $b40858e368b93ff1$var$$defineProperty = Object.defineProperty || false;
if ($b40858e368b93ff1$var$$defineProperty) try {
    $b40858e368b93ff1$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $b40858e368b93ff1$var$$defineProperty = false;
}
module.exports = $b40858e368b93ff1$var$$defineProperty;

});

parcelRegister("kAvTi", function(module, exports) {
'use strict';
var $efcfe84b55199368$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $90lay = parcelRequire("90lay");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $efcfe84b55199368$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $efcfe84b55199368$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $90lay();
};

});

parcelRegister("aDq44", function(module, exports) {
'use strict';

var $9zOgm = parcelRequire("9zOgm");

var $kZQrB = parcelRequire("kZQrB");

var $eDun3 = parcelRequire("eDun3");
/** @type {import('.')} */ module.exports = $9zOgm ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $9zOgm(O);
} : $kZQrB ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kZQrB(O);
} : $eDun3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eDun3(O);
} : null;

});
parcelRegister("9zOgm", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("kZQrB", function(module, exports) {
'use strict';

var $46Dvc = parcelRequire("46Dvc");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $46Dvc.getPrototypeOf || null;

});

parcelRegister("eDun3", function(module, exports) {
'use strict';

var $h8x15 = parcelRequire("h8x15");

var $aFkv5 = parcelRequire("aFkv5");
var $aa7c443f58d9cd9d$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $aa7c443f58d9cd9d$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $aa7c443f58d9cd9d$var$desc = !!$aa7c443f58d9cd9d$var$hasProtoAccessor && $aFkv5 && $aFkv5(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $aa7c443f58d9cd9d$var$$Object = Object;
var $aa7c443f58d9cd9d$var$$getPrototypeOf = $aa7c443f58d9cd9d$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $aa7c443f58d9cd9d$var$desc && typeof $aa7c443f58d9cd9d$var$desc.get === 'function' ? $h8x15([
    $aa7c443f58d9cd9d$var$desc.get
]) : typeof $aa7c443f58d9cd9d$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $aa7c443f58d9cd9d$var$$getPrototypeOf(value == null ? value : $aa7c443f58d9cd9d$var$$Object(value));
} : false;

});
parcelRegister("h8x15", function(module, exports) {
'use strict';

var $1HeiI = parcelRequire("1HeiI");

var $lviAQ = parcelRequire("lviAQ");

var $dXMAI = parcelRequire("dXMAI");

var $g9Yix = parcelRequire("g9Yix");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $lviAQ('a function is required');
    return $g9Yix($1HeiI, $dXMAI, args);
};

});
parcelRegister("1HeiI", function(module, exports) {
'use strict';

var $iLsIR = parcelRequire("iLsIR");
module.exports = Function.prototype.bind || $iLsIR;

});
parcelRegister("iLsIR", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $da92e57f5b5e30c8$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $da92e57f5b5e30c8$var$toStr = Object.prototype.toString;
var $da92e57f5b5e30c8$var$max = Math.max;
var $da92e57f5b5e30c8$var$funcType = '[object Function]';
var $da92e57f5b5e30c8$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $da92e57f5b5e30c8$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $da92e57f5b5e30c8$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $da92e57f5b5e30c8$var$toStr.apply(target) !== $da92e57f5b5e30c8$var$funcType) throw new TypeError($da92e57f5b5e30c8$var$ERROR_MESSAGE + target);
    var args = $da92e57f5b5e30c8$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $da92e57f5b5e30c8$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $da92e57f5b5e30c8$var$concatty(args, arguments));
    };
    var boundLength = $da92e57f5b5e30c8$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $da92e57f5b5e30c8$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("dXMAI", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("g9Yix", function(module, exports) {
'use strict';

var $1HeiI = parcelRequire("1HeiI");

var $9aVsL = parcelRequire("9aVsL");

var $dXMAI = parcelRequire("dXMAI");

var $c91sb = parcelRequire("c91sb");
/** @type {import('./actualApply')} */ module.exports = $c91sb || $1HeiI.call($dXMAI, $9aVsL);

});
parcelRegister("9aVsL", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("c91sb", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("bvsVM", function(module, exports) {
'use strict';
var $860908066adaa2d9$var$call = Function.prototype.call;
var $860908066adaa2d9$var$$hasOwn = Object.prototype.hasOwnProperty;

var $1HeiI = parcelRequire("1HeiI");
/** @type {import('.')} */ module.exports = $1HeiI.call($860908066adaa2d9$var$call, $860908066adaa2d9$var$$hasOwn);

});




parcelRegister("36y3y", function(module, exports) {
'use strict';

var $ic5Ua = parcelRequire("ic5Ua");

var $3yeH4 = parcelRequire("3yeH4");
var $242c5989b9c4f878$var$isFnRegex = $3yeH4(/^\s*(?:function)?\*/);

var $242c5989b9c4f878$var$hasToStringTag = (parcelRequire("lCI1x"))();

var $aDq44 = parcelRequire("aDq44");
var $242c5989b9c4f878$var$toStr = $ic5Ua('Object.prototype.toString');
var $242c5989b9c4f878$var$fnToStr = $ic5Ua('Function.prototype.toString');
var $242c5989b9c4f878$var$getGeneratorFunc = function() {
    if (!$242c5989b9c4f878$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
/** @type {undefined | false | null | GeneratorFunctionConstructor} */ var $242c5989b9c4f878$var$GeneratorFunction;
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($242c5989b9c4f878$var$isFnRegex($242c5989b9c4f878$var$fnToStr(fn))) return true;
    if (!$242c5989b9c4f878$var$hasToStringTag) {
        var str = $242c5989b9c4f878$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$aDq44) return false;
    if (typeof $242c5989b9c4f878$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $242c5989b9c4f878$var$getGeneratorFunc();
        $242c5989b9c4f878$var$GeneratorFunction = generatorFunc ? /** @type {GeneratorFunctionConstructor} */ $aDq44(generatorFunc) : false;
    }
    return $aDq44(fn) === $242c5989b9c4f878$var$GeneratorFunction;
};

});
parcelRegister("3yeH4", function(module, exports) {
'use strict';

var $ic5Ua = parcelRequire("ic5Ua");

var $dmlOu = parcelRequire("dmlOu");
var $295ff1f3682d5d89$var$$exec = $ic5Ua('RegExp.prototype.exec');

var $lviAQ = parcelRequire("lviAQ");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$dmlOu(regex)) throw new $lviAQ('`regex` must be a RegExp');
    return function test(s) {
        return $295ff1f3682d5d89$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("dmlOu", function(module, exports) {
'use strict';

var $ic5Ua = parcelRequire("ic5Ua");

var $9b9e401d12e228a9$var$hasToStringTag = (parcelRequire("lCI1x"))();

var $bvsVM = parcelRequire("bvsVM");

var $aFkv5 = parcelRequire("aFkv5");
/** @type {import('.')} */ var $9b9e401d12e228a9$var$fn;
if ($9b9e401d12e228a9$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $9b9e401d12e228a9$var$$exec = $ic5Ua('RegExp.prototype.exec');
    /** @type {object} */ var $9b9e401d12e228a9$var$isRegexMarker = {};
    var $9b9e401d12e228a9$var$throwRegexMarker = function() {
        throw $9b9e401d12e228a9$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $9b9e401d12e228a9$var$badStringifier = {
        toString: $9b9e401d12e228a9$var$throwRegexMarker,
        valueOf: $9b9e401d12e228a9$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $9b9e401d12e228a9$var$badStringifier[Symbol.toPrimitive] = $9b9e401d12e228a9$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $9b9e401d12e228a9$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $aFkv5(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $bvsVM(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $9b9e401d12e228a9$var$$exec(value, /** @type {unknown} */ $9b9e401d12e228a9$var$badStringifier);
        } catch (e) {
            return e === $9b9e401d12e228a9$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $9b9e401d12e228a9$var$$toString = $ic5Ua('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $9b9e401d12e228a9$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $9b9e401d12e228a9$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $9b9e401d12e228a9$var$$toString(value) === $9b9e401d12e228a9$var$regexClass;
    };
}
module.exports = $9b9e401d12e228a9$var$fn;

});



parcelRegister("3Rml8", function(module, exports) {
'use strict';

var $7RbmX = parcelRequire("7RbmX");

var $cL5Pj = parcelRequire("cL5Pj");

var $fgeGE = parcelRequire("fgeGE");

var $ic5Ua = parcelRequire("ic5Ua");

var $aFkv5 = parcelRequire("aFkv5");

var $aDq44 = parcelRequire("aDq44");
var $2cf7a695331c4d58$var$$toString = $ic5Ua('Object.prototype.toString');

var $2cf7a695331c4d58$var$hasToStringTag = (parcelRequire("lCI1x"))();
var $2cf7a695331c4d58$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $2cf7a695331c4d58$var$typedArrays = $cL5Pj();
var $2cf7a695331c4d58$var$$slice = $ic5Ua('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $2cf7a695331c4d58$var$$indexOf = $ic5Ua('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $2cf7a695331c4d58$var$cache = {
    __proto__: null
};
if ($2cf7a695331c4d58$var$hasToStringTag && $aFkv5 && $aDq44) $7RbmX($2cf7a695331c4d58$var$typedArrays, function(typedArray) {
    var arr = new $2cf7a695331c4d58$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $aDq44) {
        var proto = $aDq44(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $aFkv5(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $aDq44(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $aFkv5(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $2cf7a695331c4d58$var$cache['$' + typedArray] = $fgeGE(descriptor.get);
    }
});
else $7RbmX($2cf7a695331c4d58$var$typedArrays, function(typedArray) {
    var arr = new $2cf7a695331c4d58$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $2cf7a695331c4d58$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $fgeGE(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $2cf7a695331c4d58$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $7RbmX(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $2cf7a695331c4d58$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $2cf7a695331c4d58$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $2cf7a695331c4d58$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $7RbmX(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $2cf7a695331c4d58$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $2cf7a695331c4d58$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$2cf7a695331c4d58$var$hasToStringTag) {
        /** @type {string} */ var tag = $2cf7a695331c4d58$var$$slice($2cf7a695331c4d58$var$$toString(value), 8, -1);
        if ($2cf7a695331c4d58$var$$indexOf($2cf7a695331c4d58$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $2cf7a695331c4d58$var$trySlices(value);
    }
    if (!$aFkv5) return null;
     // unknown engine
    return $2cf7a695331c4d58$var$tryTypedArrays(value);
};

});
parcelRegister("7RbmX", function(module, exports) {
'use strict';

var $lb5Rs = parcelRequire("lb5Rs");
var $5b864d523f6d2be7$var$toStr = Object.prototype.toString;
var $5b864d523f6d2be7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $5b864d523f6d2be7$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($5b864d523f6d2be7$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $5b864d523f6d2be7$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $5b864d523f6d2be7$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($5b864d523f6d2be7$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $5b864d523f6d2be7$var$isArray(x) {
    return $5b864d523f6d2be7$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$lb5Rs(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($5b864d523f6d2be7$var$isArray(list)) $5b864d523f6d2be7$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $5b864d523f6d2be7$var$forEachString(list, iterator, receiver);
    else $5b864d523f6d2be7$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("lb5Rs", function(module, exports) {
'use strict';
var $f6af2bfb9ae6dc47$var$fnToStr = Function.prototype.toString;
var $f6af2bfb9ae6dc47$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $f6af2bfb9ae6dc47$var$badArrayLike;
var $f6af2bfb9ae6dc47$var$isCallableMarker;
if (typeof $f6af2bfb9ae6dc47$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $f6af2bfb9ae6dc47$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $f6af2bfb9ae6dc47$var$isCallableMarker;
        }
    });
    $f6af2bfb9ae6dc47$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $f6af2bfb9ae6dc47$var$reflectApply(function() {
        throw 42;
    }, null, $f6af2bfb9ae6dc47$var$badArrayLike);
} catch (_) {
    if (_ !== $f6af2bfb9ae6dc47$var$isCallableMarker) $f6af2bfb9ae6dc47$var$reflectApply = null;
}
else $f6af2bfb9ae6dc47$var$reflectApply = null;
var $f6af2bfb9ae6dc47$var$constructorRegex = /^\s*class\b/;
var $f6af2bfb9ae6dc47$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $f6af2bfb9ae6dc47$var$fnToStr.call(value);
        return $f6af2bfb9ae6dc47$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $f6af2bfb9ae6dc47$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($f6af2bfb9ae6dc47$var$isES6ClassFn(value)) return false;
        $f6af2bfb9ae6dc47$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $f6af2bfb9ae6dc47$var$toStr = Object.prototype.toString;
var $f6af2bfb9ae6dc47$var$objectClass = '[object Object]';
var $f6af2bfb9ae6dc47$var$fnClass = '[object Function]';
var $f6af2bfb9ae6dc47$var$genClass = '[object GeneratorFunction]';
var $f6af2bfb9ae6dc47$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $f6af2bfb9ae6dc47$var$ddaClass2 = '[object HTML document.all class]';
var $f6af2bfb9ae6dc47$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $f6af2bfb9ae6dc47$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $f6af2bfb9ae6dc47$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $f6af2bfb9ae6dc47$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $f6af2bfb9ae6dc47$var$all = document.all;
    if ($f6af2bfb9ae6dc47$var$toStr.call($f6af2bfb9ae6dc47$var$all) === $f6af2bfb9ae6dc47$var$toStr.call(document.all)) $f6af2bfb9ae6dc47$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($f6af2bfb9ae6dc47$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $f6af2bfb9ae6dc47$var$toStr.call(value);
            return (str === $f6af2bfb9ae6dc47$var$ddaClass || str === $f6af2bfb9ae6dc47$var$ddaClass2 || str === $f6af2bfb9ae6dc47$var$ddaClass3 // opera 12.16
             || str === $f6af2bfb9ae6dc47$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $f6af2bfb9ae6dc47$var$reflectApply ? function isCallable(value) {
    if ($f6af2bfb9ae6dc47$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $f6af2bfb9ae6dc47$var$reflectApply(value, null, $f6af2bfb9ae6dc47$var$badArrayLike);
    } catch (e) {
        if (e !== $f6af2bfb9ae6dc47$var$isCallableMarker) return false;
    }
    return !$f6af2bfb9ae6dc47$var$isES6ClassFn(value) && $f6af2bfb9ae6dc47$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($f6af2bfb9ae6dc47$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($f6af2bfb9ae6dc47$var$hasToStringTag) return $f6af2bfb9ae6dc47$var$tryFunctionObject(value);
    if ($f6af2bfb9ae6dc47$var$isES6ClassFn(value)) return false;
    var strClass = $f6af2bfb9ae6dc47$var$toStr.call(value);
    if (strClass !== $f6af2bfb9ae6dc47$var$fnClass && strClass !== $f6af2bfb9ae6dc47$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $f6af2bfb9ae6dc47$var$tryFunctionObject(value);
};

});


parcelRegister("cL5Pj", function(module, exports) {
'use strict';

var $gtkul = parcelRequire("gtkul");
var $949e64dd3294f40e$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $gtkul.length; i++)if (typeof $949e64dd3294f40e$var$g[$gtkul[i]] === 'function') // @ts-expect-error
    out[out.length] = $gtkul[i];
    return out;
};

});
parcelRegister("gtkul", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("fgeGE", function(module, exports) {
'use strict';

var $gR0pe = parcelRequire("gR0pe");

var $fsjb6 = parcelRequire("fsjb6");

var $h8x15 = parcelRequire("h8x15");

var $5o788 = parcelRequire("5o788");
module.exports = function callBind(originalFunction) {
    var func = $h8x15(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $gR0pe(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($fsjb6) $fsjb6(module.exports, 'apply', {
    value: $5o788
});
else module.exports.apply = $5o788;

});
parcelRegister("gR0pe", function(module, exports) {
'use strict';

var $g8pTf = parcelRequire("g8pTf");

var $jQSMq = parcelRequire("jQSMq");

var $c451e92d6ea3bc72$var$hasDescriptors = (parcelRequire("2VTh6"))();

var $aFkv5 = parcelRequire("aFkv5");

var $lviAQ = parcelRequire("lviAQ");
var $c451e92d6ea3bc72$var$$floor = $g8pTf('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $lviAQ('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $c451e92d6ea3bc72$var$$floor(length) !== length) throw new $lviAQ('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $aFkv5) {
        var desc = $aFkv5(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($c451e92d6ea3bc72$var$hasDescriptors) $jQSMq(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $jQSMq(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("jQSMq", function(module, exports) {
'use strict';

var $fsjb6 = parcelRequire("fsjb6");

var $581LG = parcelRequire("581LG");

var $lviAQ = parcelRequire("lviAQ");

var $aFkv5 = parcelRequire("aFkv5");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $lviAQ('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $lviAQ('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $lviAQ('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $lviAQ('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $lviAQ('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $lviAQ('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$aFkv5 && $aFkv5(obj, property);
    if ($fsjb6) $fsjb6(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $581LG('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("2VTh6", function(module, exports) {
'use strict';

var $fsjb6 = parcelRequire("fsjb6");
var $222bc8192baf7d3a$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$fsjb6;
};
$222bc8192baf7d3a$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$fsjb6) return null;
    try {
        return $fsjb6([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $222bc8192baf7d3a$var$hasPropertyDescriptors;

});


parcelRegister("5o788", function(module, exports) {
'use strict';

var $1HeiI = parcelRequire("1HeiI");

var $9aVsL = parcelRequire("9aVsL");

var $g9Yix = parcelRequire("g9Yix");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $g9Yix($1HeiI, $9aVsL, arguments);
};

});



parcelRegister("4rC0W", function(module, exports) {
'use strict';

var $3Rml8 = parcelRequire("3Rml8");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$3Rml8(value);
};

});


parcelRegister("7jOQT", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("dncHQ", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("h57Od", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $bNDrn = parcelRequire("bNDrn");
'use strict';
function $0335905abe4dc61c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0335905abe4dc61c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0335905abe4dc61c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0335905abe4dc61c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0335905abe4dc61c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0335905abe4dc61c$var$_defineProperty(obj, key, value) {
    key = $0335905abe4dc61c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0335905abe4dc61c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0335905abe4dc61c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0335905abe4dc61c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0335905abe4dc61c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0335905abe4dc61c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0335905abe4dc61c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0335905abe4dc61c$var$_toPropertyKey(arg) {
    var key = $0335905abe4dc61c$var$_toPrimitive(arg, "string");
    return $0335905abe4dc61c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0335905abe4dc61c$var$_toPrimitive(input, hint) {
    if ($0335905abe4dc61c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0335905abe4dc61c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0335905abe4dc61c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0335905abe4dc61c$var$_setPrototypeOf(subClass, superClass);
}
function $0335905abe4dc61c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0335905abe4dc61c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0335905abe4dc61c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0335905abe4dc61c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0335905abe4dc61c$var$_possibleConstructorReturn(this, result);
    };
}
function $0335905abe4dc61c$var$_possibleConstructorReturn(self, call) {
    if (call && ($0335905abe4dc61c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0335905abe4dc61c$var$_assertThisInitialized(self);
}
function $0335905abe4dc61c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0335905abe4dc61c$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $0335905abe4dc61c$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$0335905abe4dc61c$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $0335905abe4dc61c$var$_construct(Class, arguments, $0335905abe4dc61c$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $0335905abe4dc61c$var$_setPrototypeOf(Wrapper, Class);
    };
    return $0335905abe4dc61c$var$_wrapNativeSuper(Class);
}
function $0335905abe4dc61c$var$_construct(Parent, args, Class) {
    if ($0335905abe4dc61c$var$_isNativeReflectConstruct()) $0335905abe4dc61c$var$_construct = Reflect.construct.bind();
    else $0335905abe4dc61c$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $0335905abe4dc61c$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $0335905abe4dc61c$var$_construct.apply(null, arguments);
}
function $0335905abe4dc61c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0335905abe4dc61c$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $0335905abe4dc61c$var$_setPrototypeOf(o, p) {
    $0335905abe4dc61c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0335905abe4dc61c$var$_setPrototypeOf(o, p);
}
function $0335905abe4dc61c$var$_getPrototypeOf(o) {
    $0335905abe4dc61c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0335905abe4dc61c$var$_getPrototypeOf(o);
}
function $0335905abe4dc61c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0335905abe4dc61c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0335905abe4dc61c$var$_typeof(o);
}

var $lp2MB = parcelRequire("lp2MB");
var $0335905abe4dc61c$var$inspect = $lp2MB.inspect;

var $e8Hgs = parcelRequire("e8Hgs");
var $0335905abe4dc61c$var$ERR_INVALID_ARG_TYPE = $e8Hgs.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $0335905abe4dc61c$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $0335905abe4dc61c$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $0335905abe4dc61c$var$blue = '';
var $0335905abe4dc61c$var$green = '';
var $0335905abe4dc61c$var$red = '';
var $0335905abe4dc61c$var$white = '';
var $0335905abe4dc61c$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $0335905abe4dc61c$var$kMaxShortLength = 10;
function $0335905abe4dc61c$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $0335905abe4dc61c$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $0335905abe4dc61c$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $0335905abe4dc61c$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $0335905abe4dc61c$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $0335905abe4dc61c$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $0335905abe4dc61c$var$_typeof(actual) === 'object' && $0335905abe4dc61c$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $0335905abe4dc61c$var$kMaxShortLength) {
            if (($0335905abe4dc61c$var$_typeof(actual) !== 'object' || actual === null) && ($0335905abe4dc61c$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($0335905abe4dc61c$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $bNDrn.stderr && $bNDrn.stderr.isTTY ? $bNDrn.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($0335905abe4dc61c$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($0335905abe4dc61c$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $0335905abe4dc61c$var$kReadableOperator[operator] + "\n".concat($0335905abe4dc61c$var$green, "+ actual").concat($0335905abe4dc61c$var$white, " ").concat($0335905abe4dc61c$var$red, "- expected").concat($0335905abe4dc61c$var$white);
    var skippedMsg = " ".concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($0335905abe4dc61c$var$red, "-").concat($0335905abe4dc61c$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($0335905abe4dc61c$var$green, "+").concat($0335905abe4dc61c$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$0335905abe4dc61c$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $0335905abe4dc61c$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($0335905abe4dc61c$var$green, "+").concat($0335905abe4dc61c$var$white, " ").concat(actualLine);
                other += "\n".concat($0335905abe4dc61c$var$red, "-").concat($0335905abe4dc61c$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white).concat(other, "\n") + "".concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $0335905abe4dc61c$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $0335905abe4dc61c$var$_inherits(AssertionError, _Error);
    var _super = $0335905abe4dc61c$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $0335905abe4dc61c$var$_classCallCheck(this, AssertionError);
        if ($0335905abe4dc61c$var$_typeof(options) !== 'object' || options === null) throw new $0335905abe4dc61c$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($bNDrn.stderr && $bNDrn.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($bNDrn.stderr && $bNDrn.stderr.getColorDepth && $bNDrn.stderr.getColorDepth() !== 1) {
                    $0335905abe4dc61c$var$blue = "\x1B[34m";
                    $0335905abe4dc61c$var$green = "\x1B[32m";
                    $0335905abe4dc61c$var$white = "\x1B[39m";
                    $0335905abe4dc61c$var$red = "\x1B[31m";
                } else {
                    $0335905abe4dc61c$var$blue = '';
                    $0335905abe4dc61c$var$green = '';
                    $0335905abe4dc61c$var$white = '';
                    $0335905abe4dc61c$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($0335905abe4dc61c$var$_typeof(actual) === 'object' && actual !== null && $0335905abe4dc61c$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $0335905abe4dc61c$var$copyError(actual);
                expected = $0335905abe4dc61c$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $0335905abe4dc61c$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $0335905abe4dc61c$var$kReadableOperator[operator];
                var res = $0335905abe4dc61c$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $0335905abe4dc61c$var$_typeof(actual) === 'object' && actual !== null) base = $0335905abe4dc61c$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($0335905abe4dc61c$var$blue, "...").concat($0335905abe4dc61c$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $0335905abe4dc61c$var$inspectValue(actual);
                var other = '';
                var knownOperators = $0335905abe4dc61c$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($0335905abe4dc61c$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($0335905abe4dc61c$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($0335905abe4dc61c$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($0335905abe4dc61c$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $0335905abe4dc61c$var$_possibleConstructorReturn(_this);
    }
    $0335905abe4dc61c$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $0335905abe4dc61c$var$inspect(this, $0335905abe4dc61c$var$_objectSpread($0335905abe4dc61c$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $0335905abe4dc61c$var$_wrapNativeSuper(Error), $0335905abe4dc61c$var$inspect.custom);
module.exports = $0335905abe4dc61c$var$AssertionError;

});

parcelRegister("4wLnw", function(module, exports) {
'use strict';

var $cF6Pc = parcelRequire("cF6Pc");
var $34bee6f7b4717e96$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $34bee6f7b4717e96$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $cF6Pc;
    if ($34bee6f7b4717e96$var$lacksProperEnumerationOrder()) return $cF6Pc;
    if ($34bee6f7b4717e96$var$assignHasPendingExceptions()) return $cF6Pc;
    return Object.assign;
};

});
parcelRegister("cF6Pc", function(module, exports) {
'use strict';

var $4Cmql = parcelRequire("4Cmql");

var $937e9ba0a377c77b$var$hasSymbols = (parcelRequire("90lay"))();

var $ic5Ua = parcelRequire("ic5Ua");

var $46Dvc = parcelRequire("46Dvc");
var $937e9ba0a377c77b$var$$push = $ic5Ua('Array.prototype.push');
var $937e9ba0a377c77b$var$$propIsEnumerable = $ic5Ua('Object.prototype.propertyIsEnumerable');
var $937e9ba0a377c77b$var$originalGetSymbols = $937e9ba0a377c77b$var$hasSymbols ? $46Dvc.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $46Dvc(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $46Dvc(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $4Cmql(from);
        var getSymbols = $937e9ba0a377c77b$var$hasSymbols && ($46Dvc.getOwnPropertySymbols || $937e9ba0a377c77b$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($937e9ba0a377c77b$var$$propIsEnumerable(from, key)) $937e9ba0a377c77b$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($937e9ba0a377c77b$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("4Cmql", function(module, exports) {
'use strict';
var $35cc1af9bf14da48$var$slice = Array.prototype.slice;

var $jcEgj = parcelRequire("jcEgj");
var $35cc1af9bf14da48$var$origKeys = Object.keys;

var $35cc1af9bf14da48$var$keysShim = $35cc1af9bf14da48$var$origKeys ? function keys(o) {
    return $35cc1af9bf14da48$var$origKeys(o);
} : (parcelRequire("92sS9"));
var $35cc1af9bf14da48$var$originalKeys = Object.keys;
$35cc1af9bf14da48$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($jcEgj(object)) return $35cc1af9bf14da48$var$originalKeys($35cc1af9bf14da48$var$slice.call(object));
            return $35cc1af9bf14da48$var$originalKeys(object);
        };
    } else Object.keys = $35cc1af9bf14da48$var$keysShim;
    return Object.keys || $35cc1af9bf14da48$var$keysShim;
};
module.exports = $35cc1af9bf14da48$var$keysShim;

});
parcelRegister("jcEgj", function(module, exports) {
'use strict';
var $dfae5e81ac3babdc$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $dfae5e81ac3babdc$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $dfae5e81ac3babdc$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("92sS9", function(module, exports) {
'use strict';
var $694ab26e66bef184$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $694ab26e66bef184$var$has = Object.prototype.hasOwnProperty;
    var $694ab26e66bef184$var$toStr = Object.prototype.toString;
    var $694ab26e66bef184$var$isArgs = (parcelRequire("jcEgj")); // eslint-disable-line global-require
    var $694ab26e66bef184$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $694ab26e66bef184$var$hasDontEnumBug = !$694ab26e66bef184$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $694ab26e66bef184$var$hasProtoEnumBug = $694ab26e66bef184$var$isEnumerable.call(function() {}, 'prototype');
    var $694ab26e66bef184$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $694ab26e66bef184$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $694ab26e66bef184$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $694ab26e66bef184$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$694ab26e66bef184$var$excludedKeys['$' + k] && $694ab26e66bef184$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $694ab26e66bef184$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $694ab26e66bef184$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$694ab26e66bef184$var$hasAutomationEqualityBug) return $694ab26e66bef184$var$equalsConstructorPrototype(o);
        try {
            return $694ab26e66bef184$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $694ab26e66bef184$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $694ab26e66bef184$var$toStr.call(object) === '[object Function]';
        var isArguments = $694ab26e66bef184$var$isArgs(object);
        var isString = isObject && $694ab26e66bef184$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $694ab26e66bef184$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$694ab26e66bef184$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $694ab26e66bef184$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($694ab26e66bef184$var$hasDontEnumBug) {
            var skipConstructor = $694ab26e66bef184$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $694ab26e66bef184$var$dontEnums.length; ++k)if (!(skipConstructor && $694ab26e66bef184$var$dontEnums[k] === 'constructor') && $694ab26e66bef184$var$has.call(object, $694ab26e66bef184$var$dontEnums[k])) theKeys.push($694ab26e66bef184$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $694ab26e66bef184$var$keysShim;

});




parcelRegister("a0WHf", function(module, exports) {
'use strict';

var $3F4ht = parcelRequire("3F4ht");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $3F4ht;
};

});
parcelRegister("3F4ht", function(module, exports) {
'use strict';
var $2aa88584ddef2284$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($2aa88584ddef2284$var$numberIsNaN(a) && $2aa88584ddef2284$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("5lpi0", function(module, exports) {
'use strict';

var $g8pTf = parcelRequire("g8pTf");

var $fgeGE = parcelRequire("fgeGE");
var $3e4287e18e14882b$var$$indexOf = $fgeGE($g8pTf('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $g8pTf(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $3e4287e18e14882b$var$$indexOf(name, '.prototype.') > -1) return $fgeGE(intrinsic);
    return intrinsic;
};

});

parcelRegister("7cnie", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $53dbb8e51426ed3d$var$_slicedToArray(arr, i) {
    return $53dbb8e51426ed3d$var$_arrayWithHoles(arr) || $53dbb8e51426ed3d$var$_iterableToArrayLimit(arr, i) || $53dbb8e51426ed3d$var$_unsupportedIterableToArray(arr, i) || $53dbb8e51426ed3d$var$_nonIterableRest();
}
function $53dbb8e51426ed3d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $53dbb8e51426ed3d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $53dbb8e51426ed3d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $53dbb8e51426ed3d$var$_arrayLikeToArray(o, minLen);
}
function $53dbb8e51426ed3d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $53dbb8e51426ed3d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $53dbb8e51426ed3d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $53dbb8e51426ed3d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $53dbb8e51426ed3d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $53dbb8e51426ed3d$var$_typeof(o);
}
var $53dbb8e51426ed3d$var$regexFlagsSupported = /a/g.flags !== undefined;
var $53dbb8e51426ed3d$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $53dbb8e51426ed3d$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $53dbb8e51426ed3d$var$objectIs = Object.is ? Object.is : (parcelRequire("iibXl"));
var $53dbb8e51426ed3d$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $53dbb8e51426ed3d$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("i3kuY"));
function $53dbb8e51426ed3d$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $53dbb8e51426ed3d$var$hasOwnProperty = $53dbb8e51426ed3d$var$uncurryThis(Object.prototype.hasOwnProperty);
var $53dbb8e51426ed3d$var$propertyIsEnumerable = $53dbb8e51426ed3d$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $53dbb8e51426ed3d$var$objectToString = $53dbb8e51426ed3d$var$uncurryThis(Object.prototype.toString);

var $lp2MB = parcelRequire("lp2MB");
var $53dbb8e51426ed3d$require$_require$types = $lp2MB.types;
var $53dbb8e51426ed3d$var$isAnyArrayBuffer = $53dbb8e51426ed3d$require$_require$types.isAnyArrayBuffer, $53dbb8e51426ed3d$var$isArrayBufferView = $53dbb8e51426ed3d$require$_require$types.isArrayBufferView, $53dbb8e51426ed3d$var$isDate = $53dbb8e51426ed3d$require$_require$types.isDate, $53dbb8e51426ed3d$var$isMap = $53dbb8e51426ed3d$require$_require$types.isMap, $53dbb8e51426ed3d$var$isRegExp = $53dbb8e51426ed3d$require$_require$types.isRegExp, $53dbb8e51426ed3d$var$isSet = $53dbb8e51426ed3d$require$_require$types.isSet, $53dbb8e51426ed3d$var$isNativeError = $53dbb8e51426ed3d$require$_require$types.isNativeError, $53dbb8e51426ed3d$var$isBoxedPrimitive = $53dbb8e51426ed3d$require$_require$types.isBoxedPrimitive, $53dbb8e51426ed3d$var$isNumberObject = $53dbb8e51426ed3d$require$_require$types.isNumberObject, $53dbb8e51426ed3d$var$isStringObject = $53dbb8e51426ed3d$require$_require$types.isStringObject, $53dbb8e51426ed3d$var$isBooleanObject = $53dbb8e51426ed3d$require$_require$types.isBooleanObject, $53dbb8e51426ed3d$var$isBigIntObject = $53dbb8e51426ed3d$require$_require$types.isBigIntObject, $53dbb8e51426ed3d$var$isSymbolObject = $53dbb8e51426ed3d$require$_require$types.isSymbolObject, $53dbb8e51426ed3d$var$isFloat32Array = $53dbb8e51426ed3d$require$_require$types.isFloat32Array, $53dbb8e51426ed3d$var$isFloat64Array = $53dbb8e51426ed3d$require$_require$types.isFloat64Array;
function $53dbb8e51426ed3d$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $53dbb8e51426ed3d$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($53dbb8e51426ed3d$var$isNonIndex).concat($53dbb8e51426ed3d$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $53dbb8e51426ed3d$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $53dbb8e51426ed3d$var$ONLY_ENUMERABLE = undefined;
var $53dbb8e51426ed3d$var$kStrict = true;
var $53dbb8e51426ed3d$var$kLoose = false;
var $53dbb8e51426ed3d$var$kNoIterator = 0;
var $53dbb8e51426ed3d$var$kIsArray = 1;
var $53dbb8e51426ed3d$var$kIsSet = 2;
var $53dbb8e51426ed3d$var$kIsMap = 3;
// Check if they have the same source and flags
function $53dbb8e51426ed3d$var$areSimilarRegExps(a, b) {
    return $53dbb8e51426ed3d$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $53dbb8e51426ed3d$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $53dbb8e51426ed3d$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $53dbb8e51426ed3d$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $53dbb8e51426ed3d$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $53dbb8e51426ed3d$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $53dbb8e51426ed3d$var$isEqualBoxedPrimitive(val1, val2) {
    if ($53dbb8e51426ed3d$var$isNumberObject(val1)) return $53dbb8e51426ed3d$var$isNumberObject(val2) && $53dbb8e51426ed3d$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($53dbb8e51426ed3d$var$isStringObject(val1)) return $53dbb8e51426ed3d$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($53dbb8e51426ed3d$var$isBooleanObject(val1)) return $53dbb8e51426ed3d$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($53dbb8e51426ed3d$var$isBigIntObject(val1)) return $53dbb8e51426ed3d$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $53dbb8e51426ed3d$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $53dbb8e51426ed3d$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $53dbb8e51426ed3d$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($53dbb8e51426ed3d$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $53dbb8e51426ed3d$var$numberIsNaN(val1) && $53dbb8e51426ed3d$var$numberIsNaN(val2);
        if ($53dbb8e51426ed3d$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $53dbb8e51426ed3d$var$_typeof(val1) !== 'object') {
            if (val2 === null || $53dbb8e51426ed3d$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $53dbb8e51426ed3d$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $53dbb8e51426ed3d$var$objectToString(val1);
    var val2Tag = $53dbb8e51426ed3d$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $53dbb8e51426ed3d$var$getOwnNonIndexProperties(val1, $53dbb8e51426ed3d$var$ONLY_ENUMERABLE);
        var keys2 = $53dbb8e51426ed3d$var$getOwnNonIndexProperties(val2, $53dbb8e51426ed3d$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $53dbb8e51426ed3d$var$keyCheck(val1, val2, strict, memos, $53dbb8e51426ed3d$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$53dbb8e51426ed3d$var$isMap(val1) && $53dbb8e51426ed3d$var$isMap(val2) || !$53dbb8e51426ed3d$var$isSet(val1) && $53dbb8e51426ed3d$var$isSet(val2)) return false;
    }
    if ($53dbb8e51426ed3d$var$isDate(val1)) {
        if (!$53dbb8e51426ed3d$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($53dbb8e51426ed3d$var$isRegExp(val1)) {
        if (!$53dbb8e51426ed3d$var$isRegExp(val2) || !$53dbb8e51426ed3d$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($53dbb8e51426ed3d$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($53dbb8e51426ed3d$var$isArrayBufferView(val1)) {
        if (!strict && ($53dbb8e51426ed3d$var$isFloat32Array(val1) || $53dbb8e51426ed3d$var$isFloat64Array(val1))) {
            if (!$53dbb8e51426ed3d$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$53dbb8e51426ed3d$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $53dbb8e51426ed3d$var$getOwnNonIndexProperties(val1, $53dbb8e51426ed3d$var$ONLY_ENUMERABLE);
        var _keys2 = $53dbb8e51426ed3d$var$getOwnNonIndexProperties(val2, $53dbb8e51426ed3d$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $53dbb8e51426ed3d$var$keyCheck(val1, val2, strict, memos, $53dbb8e51426ed3d$var$kNoIterator, _keys);
    } else if ($53dbb8e51426ed3d$var$isSet(val1)) {
        if (!$53dbb8e51426ed3d$var$isSet(val2) || val1.size !== val2.size) return false;
        return $53dbb8e51426ed3d$var$keyCheck(val1, val2, strict, memos, $53dbb8e51426ed3d$var$kIsSet);
    } else if ($53dbb8e51426ed3d$var$isMap(val1)) {
        if (!$53dbb8e51426ed3d$var$isMap(val2) || val1.size !== val2.size) return false;
        return $53dbb8e51426ed3d$var$keyCheck(val1, val2, strict, memos, $53dbb8e51426ed3d$var$kIsMap);
    } else if ($53dbb8e51426ed3d$var$isAnyArrayBuffer(val1)) {
        if (!$53dbb8e51426ed3d$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($53dbb8e51426ed3d$var$isBoxedPrimitive(val1) && !$53dbb8e51426ed3d$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $53dbb8e51426ed3d$var$keyCheck(val1, val2, strict, memos, $53dbb8e51426ed3d$var$kNoIterator);
}
function $53dbb8e51426ed3d$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $53dbb8e51426ed3d$var$propertyIsEnumerable(val, k);
    });
}
function $53dbb8e51426ed3d$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$53dbb8e51426ed3d$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $53dbb8e51426ed3d$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($53dbb8e51426ed3d$var$propertyIsEnumerable(val1, key)) {
                    if (!$53dbb8e51426ed3d$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($53dbb8e51426ed3d$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $53dbb8e51426ed3d$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $53dbb8e51426ed3d$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $53dbb8e51426ed3d$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $53dbb8e51426ed3d$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $53dbb8e51426ed3d$var$kNoIterator || iterationType === $53dbb8e51426ed3d$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $53dbb8e51426ed3d$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $53dbb8e51426ed3d$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $53dbb8e51426ed3d$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($53dbb8e51426ed3d$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $53dbb8e51426ed3d$var$findLooseMatchingPrimitives(prim) {
    switch($53dbb8e51426ed3d$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($53dbb8e51426ed3d$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $53dbb8e51426ed3d$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $53dbb8e51426ed3d$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $53dbb8e51426ed3d$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $53dbb8e51426ed3d$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$53dbb8e51426ed3d$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $53dbb8e51426ed3d$var$innerDeepEqual(item, curB, false, memo);
}
function $53dbb8e51426ed3d$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $53dbb8e51426ed3d$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($53dbb8e51426ed3d$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$53dbb8e51426ed3d$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $53dbb8e51426ed3d$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($53dbb8e51426ed3d$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$53dbb8e51426ed3d$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$53dbb8e51426ed3d$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $53dbb8e51426ed3d$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $53dbb8e51426ed3d$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($53dbb8e51426ed3d$var$innerDeepEqual(key1, key2, strict, memo) && $53dbb8e51426ed3d$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $53dbb8e51426ed3d$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $53dbb8e51426ed3d$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $53dbb8e51426ed3d$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($53dbb8e51426ed3d$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$53dbb8e51426ed3d$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$53dbb8e51426ed3d$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $53dbb8e51426ed3d$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $53dbb8e51426ed3d$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($53dbb8e51426ed3d$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$53dbb8e51426ed3d$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$53dbb8e51426ed3d$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$53dbb8e51426ed3d$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $53dbb8e51426ed3d$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $53dbb8e51426ed3d$var$kIsSet) {
        if (!$53dbb8e51426ed3d$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $53dbb8e51426ed3d$var$kIsMap) {
        if (!$53dbb8e51426ed3d$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $53dbb8e51426ed3d$var$kIsArray) for(; i < a.length; i++){
        if ($53dbb8e51426ed3d$var$hasOwnProperty(a, i)) {
            if (!$53dbb8e51426ed3d$var$hasOwnProperty(b, i) || !$53dbb8e51426ed3d$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($53dbb8e51426ed3d$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$53dbb8e51426ed3d$var$hasOwnProperty(b, key) || !$53dbb8e51426ed3d$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$53dbb8e51426ed3d$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $53dbb8e51426ed3d$var$isDeepEqual(val1, val2) {
    return $53dbb8e51426ed3d$var$innerDeepEqual(val1, val2, $53dbb8e51426ed3d$var$kLoose);
}
function $53dbb8e51426ed3d$var$isDeepStrictEqual(val1, val2) {
    return $53dbb8e51426ed3d$var$innerDeepEqual(val1, val2, $53dbb8e51426ed3d$var$kStrict);
}
module.exports = {
    isDeepEqual: $53dbb8e51426ed3d$var$isDeepEqual,
    isDeepStrictEqual: $53dbb8e51426ed3d$var$isDeepStrictEqual
};

});
parcelRegister("iibXl", function(module, exports) {
'use strict';

var $iNVsS = parcelRequire("iNVsS");

var $fgeGE = parcelRequire("fgeGE");

var $3F4ht = parcelRequire("3F4ht");

var $a0WHf = parcelRequire("a0WHf");

var $7h2Ee = parcelRequire("7h2Ee");
var $d5132eb2ce8d4cb2$var$polyfill = $fgeGE($a0WHf(), Object);
$iNVsS($d5132eb2ce8d4cb2$var$polyfill, {
    getPolyfill: $a0WHf,
    implementation: $3F4ht,
    shim: $7h2Ee
});
module.exports = $d5132eb2ce8d4cb2$var$polyfill;

});
parcelRegister("iNVsS", function(module, exports) {
'use strict';

var $4Cmql = parcelRequire("4Cmql");
var $db0960ec50fb040c$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $db0960ec50fb040c$var$toStr = Object.prototype.toString;
var $db0960ec50fb040c$var$concat = Array.prototype.concat;

var $jQSMq = parcelRequire("jQSMq");
var $db0960ec50fb040c$var$isFunction = function(fn) {
    return typeof fn === 'function' && $db0960ec50fb040c$var$toStr.call(fn) === '[object Function]';
};

var $db0960ec50fb040c$var$supportsDescriptors = (parcelRequire("2VTh6"))();
var $db0960ec50fb040c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$db0960ec50fb040c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($db0960ec50fb040c$var$supportsDescriptors) $jQSMq(object, name, value, true);
    else $jQSMq(object, name, value);
};
var $db0960ec50fb040c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $4Cmql(map);
    if ($db0960ec50fb040c$var$hasSymbols) props = $db0960ec50fb040c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$db0960ec50fb040c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$db0960ec50fb040c$var$defineProperties.supportsDescriptors = !!$db0960ec50fb040c$var$supportsDescriptors;
module.exports = $db0960ec50fb040c$var$defineProperties;

});

parcelRegister("7h2Ee", function(module, exports) {
'use strict';

var $a0WHf = parcelRequire("a0WHf");

var $iNVsS = parcelRequire("iNVsS");
module.exports = function shimObjectIs() {
    var polyfill = $a0WHf();
    $iNVsS(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("i3kuY", function(module, exports) {
'use strict';

var $fgeGE = parcelRequire("fgeGE");

var $iNVsS = parcelRequire("iNVsS");

var $kuhJ8 = parcelRequire("kuhJ8");

var $3AExO = parcelRequire("3AExO");

var $h2nJt = parcelRequire("h2nJt");
var $d24868697f732af9$var$polyfill = $fgeGE($3AExO(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $iNVsS($d24868697f732af9$var$polyfill, {
    getPolyfill: $3AExO,
    implementation: $kuhJ8,
    shim: $h2nJt
});
module.exports = $d24868697f732af9$var$polyfill;

});
parcelRegister("kuhJ8", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("3AExO", function(module, exports) {
'use strict';

var $kuhJ8 = parcelRequire("kuhJ8");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $kuhJ8;
};

});

parcelRegister("h2nJt", function(module, exports) {
'use strict';

var $iNVsS = parcelRequire("iNVsS");

var $3AExO = parcelRequire("3AExO");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $3AExO();
    $iNVsS(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("iyJxE", function(module, exports) {

$parcel$export(module.exports, "cpus", function () { return $d82eba9f9feff8bb$export$9b60beb643db4d69; }, function (v) { return $d82eba9f9feff8bb$export$9b60beb643db4d69 = v; });
var $d82eba9f9feff8bb$export$edf525f30916fbb8;
var $d82eba9f9feff8bb$export$640106f6dc7d2706;
var $d82eba9f9feff8bb$export$3ea386628068cf62;
var $d82eba9f9feff8bb$export$749d472264fad440;
var $d82eba9f9feff8bb$export$8b931a48d9488767;
var $d82eba9f9feff8bb$export$9123f37609399513;
var $d82eba9f9feff8bb$export$9b60beb643db4d69;
var $d82eba9f9feff8bb$export$bf9fb029d174d554;
var $d82eba9f9feff8bb$export$23d3fad09dc44362;
var $d82eba9f9feff8bb$export$d2f3c2f7e0c7dcf5;
var $d82eba9f9feff8bb$export$3bf7c33313eba0fe;
var $d82eba9f9feff8bb$export$7925d89f138dad5b;
var $d82eba9f9feff8bb$export$722a64dea1b767dc;
var $d82eba9f9feff8bb$export$9e6c06a7d47f9af7;
var $d82eba9f9feff8bb$export$6b76988456c0292f;
var $d82eba9f9feff8bb$export$266d3b9babd1fc45;
var $d82eba9f9feff8bb$export$c1d46b5ea6262c0b;
$d82eba9f9feff8bb$export$edf525f30916fbb8 = function() {
    return 'LE';
};
$d82eba9f9feff8bb$export$640106f6dc7d2706 = function() {
    if (typeof location !== 'undefined') return location.hostname;
    else return '';
};
$d82eba9f9feff8bb$export$3ea386628068cf62 = function() {
    return [];
};
$d82eba9f9feff8bb$export$749d472264fad440 = function() {
    return 0;
};
$d82eba9f9feff8bb$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$d82eba9f9feff8bb$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$d82eba9f9feff8bb$export$9b60beb643db4d69 = function() {
    return [];
};
$d82eba9f9feff8bb$export$bf9fb029d174d554 = function() {
    return 'Browser';
};
$d82eba9f9feff8bb$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== 'undefined') return navigator.appVersion;
    return '';
};
$d82eba9f9feff8bb$export$d2f3c2f7e0c7dcf5 = $d82eba9f9feff8bb$export$3bf7c33313eba0fe = function() {
    return {};
};
$d82eba9f9feff8bb$export$7925d89f138dad5b = function() {
    return 'javascript';
};
$d82eba9f9feff8bb$export$722a64dea1b767dc = function() {
    return 'browser';
};
$d82eba9f9feff8bb$export$9e6c06a7d47f9af7 = $d82eba9f9feff8bb$export$6b76988456c0292f = function() {
    return '/tmp';
};
$d82eba9f9feff8bb$export$266d3b9babd1fc45 = '\n';
$d82eba9f9feff8bb$export$c1d46b5ea6262c0b = function() {
    return '/';
};

});

parcelRegister("9Yqv2", function(module, exports) {

var $bNDrn = parcelRequire("bNDrn");

var $lp2MB = parcelRequire("lp2MB");

var $gJoSY = parcelRequire("gJoSY");
var $742e45e9b3a1bbd9$require$spawn = $gJoSY.spawn;
module.exports = function(command, options) {
    var file, args;
    if ($bNDrn.platform === 'win32') {
        file = 'cmd.exe';
        args = [
            '/s',
            '/c',
            '"' + command + '"'
        ];
        options = $lp2MB._extend({}, options);
        options.windowsVerbatimArguments = true;
    } else {
        file = '/bin/sh';
        args = [
            '-c',
            command
        ];
    }
    return $742e45e9b3a1bbd9$require$spawn(file, args, options);
};

});
parcelRegister("gJoSY", function(module, exports) {
"use strict";

});


parcelRegister("3M1TQ", function(module, exports) {

var $bNDrn = parcelRequire("bNDrn");
'use strict';

var $gJoSY = parcelRequire("gJoSY");
var $2bf7540915c1e80b$var$spawn = $gJoSY.spawn;
var $2bf7540915c1e80b$var$exec = $gJoSY.exec;
module.exports = function(pid, signal, callback) {
    if (typeof signal === 'function' && callback === undefined) {
        callback = signal;
        signal = undefined;
    }
    pid = parseInt(pid);
    if (Number.isNaN(pid)) {
        if (callback) return callback(new Error("pid must be a number"));
        else throw new Error("pid must be a number");
    }
    var tree = {};
    var pidsToProcess = {};
    tree[pid] = [];
    pidsToProcess[pid] = 1;
    switch($bNDrn.platform){
        case 'win32':
            $2bf7540915c1e80b$var$exec('taskkill /pid ' + pid + ' /T /F', callback);
            break;
        case 'darwin':
            $2bf7540915c1e80b$var$buildProcessTree(pid, tree, pidsToProcess, function(parentPid) {
                return $2bf7540915c1e80b$var$spawn('pgrep', [
                    '-P',
                    parentPid
                ]);
            }, function() {
                $2bf7540915c1e80b$var$killAll(tree, signal, callback);
            });
            break;
        // case 'sunos':
        //     buildProcessTreeSunOS(pid, tree, pidsToProcess, function () {
        //         killAll(tree, signal, callback);
        //     });
        //     break;
        default:
            $2bf7540915c1e80b$var$buildProcessTree(pid, tree, pidsToProcess, function(parentPid) {
                return $2bf7540915c1e80b$var$spawn('ps', [
                    '-o',
                    'pid',
                    '--no-headers',
                    '--ppid',
                    parentPid
                ]);
            }, function() {
                $2bf7540915c1e80b$var$killAll(tree, signal, callback);
            });
            break;
    }
};
function $2bf7540915c1e80b$var$killAll(tree, signal, callback) {
    var killed = {};
    try {
        Object.keys(tree).forEach(function(pid) {
            tree[pid].forEach(function(pidpid) {
                if (!killed[pidpid]) {
                    $2bf7540915c1e80b$var$killPid(pidpid, signal);
                    killed[pidpid] = 1;
                }
            });
            if (!killed[pid]) {
                $2bf7540915c1e80b$var$killPid(pid, signal);
                killed[pid] = 1;
            }
        });
    } catch (err) {
        if (callback) return callback(err);
        else throw err;
    }
    if (callback) return callback();
}
function $2bf7540915c1e80b$var$killPid(pid, signal) {
    try {
        $bNDrn.kill(parseInt(pid, 10), signal);
    } catch (err) {
        if (err.code !== 'ESRCH') throw err;
    }
}
function $2bf7540915c1e80b$var$buildProcessTree(parentPid, tree, pidsToProcess, spawnChildProcessesList, cb) {
    var ps = spawnChildProcessesList(parentPid);
    var allData = '';
    ps.stdout.on('data', function(data) {
        var data = data.toString('ascii');
        allData += data;
    });
    var onClose = function(code) {
        delete pidsToProcess[parentPid];
        if (code != 0) {
            // no more parent processes
            if (Object.keys(pidsToProcess).length == 0) cb();
            return;
        }
        allData.match(/\d+/g).forEach(function(pid) {
            pid = parseInt(pid, 10);
            tree[parentPid].push(pid);
            tree[pid] = [];
            pidsToProcess[pid] = 1;
            $2bf7540915c1e80b$var$buildProcessTree(pid, tree, pidsToProcess, spawnChildProcessesList, cb);
        });
    };
    ps.on('close', onClose);
}

});

parcelRegister("8A6Qz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpandArguments = void 0;

var $cCwXa = parcelRequire("cCwXa");
/**
 * Replace placeholders with additional arguments.
 */ class $63f6ff2c6d817844$var$ExpandArguments {
    constructor(additionalArguments){
        this.additionalArguments = additionalArguments;
    }
    parse(commandInfo) {
        const command = commandInfo.command.replace(/\\?\{([@*]|[1-9][0-9]*)\}/g, (match, placeholderTarget)=>{
            // Don't replace the placeholder if it is escaped by a backslash.
            if (match.startsWith('\\')) return match.slice(1);
            // Replace numeric placeholder if value exists in additional arguments.
            if (!isNaN(placeholderTarget) && placeholderTarget <= this.additionalArguments.length) return (0, $cCwXa.quote)([
                this.additionalArguments[placeholderTarget - 1]
            ]);
            // Replace all arguments placeholder.
            if (placeholderTarget === '@') return (0, $cCwXa.quote)(this.additionalArguments);
            // Replace combined arguments placeholder.
            if (placeholderTarget === '*') return (0, $cCwXa.quote)([
                this.additionalArguments.join(' ')
            ]);
            // Replace placeholder with empty string
            // if value doesn't exist in additional arguments.
            return '';
        });
        return {
            ...commandInfo,
            command: command
        };
    }
}
module.exports.ExpandArguments = $63f6ff2c6d817844$var$ExpandArguments;

});
parcelRegister("cCwXa", function(module, exports) {

$parcel$export(module.exports, "quote", function () { return $9302987f5c4084fa$export$ee7a15c61bfdeb11; }, function (v) { return $9302987f5c4084fa$export$ee7a15c61bfdeb11 = v; });
var $9302987f5c4084fa$export$ee7a15c61bfdeb11;
var $9302987f5c4084fa$export$98e6a39c04603d36;
'use strict';

$9302987f5c4084fa$export$ee7a15c61bfdeb11 = (parcelRequire("3ixv1"));

$9302987f5c4084fa$export$98e6a39c04603d36 = (parcelRequire("8LT3J"));

});
parcelRegister("3ixv1", function(module, exports) {
'use strict';
module.exports = function quote(xs) {
    return xs.map(function(s) {
        if (s === '') return '\'\'';
        if (s && typeof s === 'object') return s.op.replace(/(.)/g, '\\$1');
        if (/["\s]/.test(s) && !/'/.test(s)) return "'" + s.replace(/(['\\])/g, '\\$1') + "'";
        if (/["'\s]/.test(s)) return '"' + s.replace(/(["\\$`!])/g, '\\$1') + '"';
        return String(s).replace(/([A-Za-z]:)?([#!"$&'()*,:;<=>?@[\\\]^`{|}])/g, '$1\\$2');
    }).join(' ');
};

});

parcelRegister("8LT3J", function(module, exports) {
'use strict';
// '<(' is process substitution operator and
// can be parsed the same as control operator
var $662d6c1c5e8e8c87$var$CONTROL = '(?:' + [
    '\\|\\|',
    '\\&\\&',
    ';;',
    '\\|\\&',
    '\\<\\(',
    '\\<\\<\\<',
    '>>',
    '>\\&',
    '<\\&',
    '[&;()|<>]'
].join('|') + ')';
var $662d6c1c5e8e8c87$var$controlRE = new RegExp('^' + $662d6c1c5e8e8c87$var$CONTROL + '$');
var $662d6c1c5e8e8c87$var$META = '|&;()<> \\t';
var $662d6c1c5e8e8c87$var$SINGLE_QUOTE = '"((\\\\"|[^"])*?)"';
var $662d6c1c5e8e8c87$var$DOUBLE_QUOTE = '\'((\\\\\'|[^\'])*?)\'';
var $662d6c1c5e8e8c87$var$hash = /^#$/;
var $662d6c1c5e8e8c87$var$SQ = "'";
var $662d6c1c5e8e8c87$var$DQ = '"';
var $662d6c1c5e8e8c87$var$DS = '$';
var $662d6c1c5e8e8c87$var$TOKEN = '';
var $662d6c1c5e8e8c87$var$mult = 0x100000000; // Math.pow(16, 8);
for(var $662d6c1c5e8e8c87$var$i = 0; $662d6c1c5e8e8c87$var$i < 4; $662d6c1c5e8e8c87$var$i++)$662d6c1c5e8e8c87$var$TOKEN += ($662d6c1c5e8e8c87$var$mult * Math.random()).toString(16);
var $662d6c1c5e8e8c87$var$startsWithToken = new RegExp('^' + $662d6c1c5e8e8c87$var$TOKEN);
function $662d6c1c5e8e8c87$var$matchAll(s, r) {
    var origIndex = r.lastIndex;
    var matches = [];
    var matchObj;
    while(matchObj = r.exec(s)){
        matches.push(matchObj);
        if (r.lastIndex === matchObj.index) r.lastIndex += 1;
    }
    r.lastIndex = origIndex;
    return matches;
}
function $662d6c1c5e8e8c87$var$getVar(env, pre, key) {
    var r = typeof env === 'function' ? env(key) : env[key];
    if (typeof r === 'undefined' && key != '') r = '';
    else if (typeof r === 'undefined') r = '$';
    if (typeof r === 'object') return pre + $662d6c1c5e8e8c87$var$TOKEN + JSON.stringify(r) + $662d6c1c5e8e8c87$var$TOKEN;
    return pre + r;
}
function $662d6c1c5e8e8c87$var$parseInternal(string, env, opts) {
    if (!opts) opts = {};
    var BS = opts.escape || '\\';
    var BAREWORD = '(\\' + BS + '[\'"' + $662d6c1c5e8e8c87$var$META + ']|[^\\s\'"' + $662d6c1c5e8e8c87$var$META + '])+';
    var chunker = new RegExp([
        '(' + $662d6c1c5e8e8c87$var$CONTROL + ')',
        '(' + BAREWORD + '|' + $662d6c1c5e8e8c87$var$SINGLE_QUOTE + '|' + $662d6c1c5e8e8c87$var$DOUBLE_QUOTE + ')+'
    ].join('|'), 'g');
    var matches = $662d6c1c5e8e8c87$var$matchAll(string, chunker);
    if (matches.length === 0) return [];
    if (!env) env = {};
    var commented = false;
    return matches.map(function(match) {
        var s = match[0];
        if (!s || commented) return void 0;
        if ($662d6c1c5e8e8c87$var$controlRE.test(s)) return {
            op: s
        };
        // Hand-written scanner/parser for Bash quoting rules:
        //
        // 1. inside single quotes, all characters are printed literally.
        // 2. inside double quotes, all characters are printed literally
        //    except variables prefixed by '$' and backslashes followed by
        //    either a double quote or another backslash.
        // 3. outside of any quotes, backslashes are treated as escape
        //    characters and not printed (unless they are themselves escaped)
        // 4. quote context can switch mid-token if there is no whitespace
        //     between the two quote contexts (e.g. all'one'"token" parses as
        //     "allonetoken")
        var quote = false;
        var esc = false;
        var out = '';
        var isGlob = false;
        var i;
        function parseEnvVar() {
            i += 1;
            var varend;
            var varname;
            var char = s.charAt(i);
            if (char === '{') {
                i += 1;
                if (s.charAt(i) === '}') throw new Error('Bad substitution: ' + s.slice(i - 2, i + 1));
                varend = s.indexOf('}', i);
                if (varend < 0) throw new Error('Bad substitution: ' + s.slice(i));
                varname = s.slice(i, varend);
                i = varend;
            } else if (/[*@#?$!_-]/.test(char)) {
                varname = char;
                i += 1;
            } else {
                var slicedFromI = s.slice(i);
                varend = slicedFromI.match(/[^\w\d_]/);
                if (!varend) {
                    varname = slicedFromI;
                    i = s.length;
                } else {
                    varname = slicedFromI.slice(0, varend.index);
                    i += varend.index - 1;
                }
            }
            return $662d6c1c5e8e8c87$var$getVar(env, '', varname);
        }
        for(i = 0; i < s.length; i++){
            var c = s.charAt(i);
            isGlob = isGlob || !quote && (c === '*' || c === '?');
            if (esc) {
                out += c;
                esc = false;
            } else if (quote) {
                if (c === quote) quote = false;
                else if (quote == $662d6c1c5e8e8c87$var$SQ) out += c;
                else {
                    if (c === BS) {
                        i += 1;
                        c = s.charAt(i);
                        if (c === $662d6c1c5e8e8c87$var$DQ || c === BS || c === $662d6c1c5e8e8c87$var$DS) out += c;
                        else out += BS + c;
                    } else if (c === $662d6c1c5e8e8c87$var$DS) out += parseEnvVar();
                    else out += c;
                }
            } else if (c === $662d6c1c5e8e8c87$var$DQ || c === $662d6c1c5e8e8c87$var$SQ) quote = c;
            else if ($662d6c1c5e8e8c87$var$controlRE.test(c)) return {
                op: s
            };
            else if ($662d6c1c5e8e8c87$var$hash.test(c)) {
                commented = true;
                var commentObj = {
                    comment: string.slice(match.index + i + 1)
                };
                if (out.length) return [
                    out,
                    commentObj
                ];
                return [
                    commentObj
                ];
            } else if (c === BS) esc = true;
            else if (c === $662d6c1c5e8e8c87$var$DS) out += parseEnvVar();
            else out += c;
        }
        if (isGlob) return {
            op: 'glob',
            pattern: out
        };
        return out;
    }).reduce(function(prev, arg) {
        // TODO: replace this whole reduce with a concat
        return typeof arg === 'undefined' ? prev : prev.concat(arg);
    }, []);
}
module.exports = function parse(s, env, opts) {
    var mapped = $662d6c1c5e8e8c87$var$parseInternal(s, env, opts);
    if (typeof env !== 'function') return mapped;
    return mapped.reduce(function(acc, s) {
        if (typeof s === 'object') return acc.concat(s);
        var xs = s.split(RegExp('(' + $662d6c1c5e8e8c87$var$TOKEN + '.*?' + $662d6c1c5e8e8c87$var$TOKEN + ')', 'g'));
        if (xs.length === 1) return acc.concat(xs[0]);
        return acc.concat(xs.filter(Boolean).map(function(x) {
            if ($662d6c1c5e8e8c87$var$startsWithToken.test(x)) return JSON.parse(x.split($662d6c1c5e8e8c87$var$TOKEN)[1]);
            return x;
        }));
    }, []);
};

});



parcelRegister("judok", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpandNpmShortcut = void 0;
/**
 * Expands commands prefixed with `npm:`, `yarn:` or `pnpm:` into the full version `npm run <command>` and so on.
 */ class $e2fb34e6036e4b2b$var$ExpandNpmShortcut {
    parse(commandInfo) {
        const [, npmCmd, cmdName, args] = commandInfo.command.match(/^(npm|yarn|pnpm):(\S+)(.*)/) || [];
        if (!cmdName) return commandInfo;
        return {
            ...commandInfo,
            name: commandInfo.name || cmdName,
            command: `${npmCmd} run ${cmdName}${args}`
        };
    }
}
module.exports.ExpandNpmShortcut = $e2fb34e6036e4b2b$var$ExpandNpmShortcut;

});

parcelRegister("6myFh", function(module, exports) {
"use strict";
var $4a1fafd8724dea8d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpandNpmWildcard = void 0;

const $4a1fafd8724dea8d$var$fs_1 = $4a1fafd8724dea8d$var$__importDefault((parcelRequire("gJoSY")));

const $4a1fafd8724dea8d$var$lodash_1 = $4a1fafd8724dea8d$var$__importDefault((parcelRequire("2m7Ys")));
const $4a1fafd8724dea8d$var$OMISSION = /\(!([^)]+)\)/;
/**
 * Finds wildcards in npm/yarn/pnpm run commands and replaces them with all matching scripts in the
 * `package.json` file of the current directory.
 */ class $4a1fafd8724dea8d$var$ExpandNpmWildcard {
    static readPackage() {
        try {
            const json = $4a1fafd8724dea8d$var$fs_1.default.readFileSync('package.json', {
                encoding: 'utf-8'
            });
            return JSON.parse(json);
        } catch (e) {
            return {};
        }
    }
    constructor(readPackage = $4a1fafd8724dea8d$var$ExpandNpmWildcard.readPackage){
        this.readPackage = readPackage;
    }
    parse(commandInfo) {
        const [, npmCmd, cmdName, args] = commandInfo.command.match(/(npm|yarn|pnpm) run (\S+)([^&]*)/) || [];
        const wildcardPosition = (cmdName || '').indexOf('*');
        // If the regex didn't match an npm script, or it has no wildcard,
        // then we have nothing to do here
        if (!cmdName || wildcardPosition === -1) return commandInfo;
        if (!this.scripts) this.scripts = Object.keys(this.readPackage().scripts || {});
        const omissionRegex = cmdName.match($4a1fafd8724dea8d$var$OMISSION);
        const cmdNameSansOmission = cmdName.replace($4a1fafd8724dea8d$var$OMISSION, '');
        const preWildcard = $4a1fafd8724dea8d$var$lodash_1.default.escapeRegExp(cmdNameSansOmission.slice(0, wildcardPosition));
        const postWildcard = $4a1fafd8724dea8d$var$lodash_1.default.escapeRegExp(cmdNameSansOmission.slice(wildcardPosition + 1));
        const wildcardRegex = new RegExp(`^${preWildcard}(.*?)${postWildcard}$`);
        // If 'commandInfo.name' doesn't match 'cmdName', this means a custom name
        // has been specified and thus becomes the prefix (as described in the README).
        const prefix = commandInfo.name !== cmdName ? commandInfo.name : '';
        return this.scripts.map((script)=>{
            const match = script.match(wildcardRegex);
            if (omissionRegex) {
                const toOmit = script.match(new RegExp(omissionRegex[1]));
                if (toOmit) return;
            }
            if (match) return {
                ...commandInfo,
                command: `${npmCmd} run ${script}${args}`,
                // Will use an empty command name if no prefix has been specified and
                // the wildcard match is empty, e.g. if `npm:watch-*` matches `npm run watch-`.
                name: prefix + match[1]
            };
        }).filter((commandInfo)=>!!commandInfo);
    }
}
module.exports.ExpandNpmWildcard = $4a1fafd8724dea8d$var$ExpandNpmWildcard;

});

parcelRegister("9wGap", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StripQuotes = void 0;
/**
 * Strips quotes around commands so that they can run on the current shell.
 */ class $6ef7cfb20107bf81$var$StripQuotes {
    parse(commandInfo) {
        let { command: command } = commandInfo;
        // Removes the quotes surrounding a command.
        if (/^"(.+?)"$/.test(command) || /^'(.+?)'$/.test(command)) command = command.slice(1, command.length - 1);
        return {
            ...commandInfo,
            command: command
        };
    }
}
module.exports.StripQuotes = $6ef7cfb20107bf81$var$StripQuotes;

});

parcelRegister("gzABk", function(module, exports) {
"use strict";
var $c10c4e72dcf445b6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c10c4e72dcf445b6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c10c4e72dcf445b6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c10c4e72dcf445b6$var$__createBinding(result, mod, k);
    }
    $c10c4e72dcf445b6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompletionListener = void 0;

const $c10c4e72dcf445b6$var$Rx = $c10c4e72dcf445b6$var$__importStar((parcelRequire("7fhTn")));

var $2wRUS = parcelRequire("2wRUS");
/**
 * Provides logic to determine whether lists of commands ran successfully.
 */ class $c10c4e72dcf445b6$var$CompletionListener {
    constructor({ successCondition: successCondition = 'all', scheduler: scheduler }){
        this.successCondition = successCondition;
        this.scheduler = scheduler;
    }
    isSuccess(events) {
        if (this.successCondition === 'first') return events[0].exitCode === 0;
        else if (this.successCondition === 'last') return events[events.length - 1].exitCode === 0;
        const commandSyntaxMatch = this.successCondition.match(/^!?command-(.+)$/);
        if (commandSyntaxMatch == null) // If not a `command-` syntax, then it's an 'all' condition or it's treated as such.
        return events.every(({ exitCode: exitCode })=>exitCode === 0);
        // Check `command-` syntax condition.
        // Note that a command's `name` is not necessarily unique,
        // in which case all of them must meet the success condition.
        const nameOrIndex = commandSyntaxMatch[1];
        const targetCommandsEvents = events.filter(({ command: command, index: index })=>command.name === nameOrIndex || index === Number(nameOrIndex));
        if (this.successCondition.startsWith('!')) // All commands except the specified ones must exit succesfully
        return events.every((event)=>targetCommandsEvents.includes(event) || event.exitCode === 0);
        // Only the specified commands must exit succesfully
        return targetCommandsEvents.length > 0 && targetCommandsEvents.every((event)=>event.exitCode === 0);
    }
    /**
     * Given a list of commands, wait for all of them to exit and then evaluate their exit codes.
     *
     * @returns A Promise that resolves if the success condition is met, or rejects otherwise.
     */ listen(commands) {
        const closeStreams = commands.map((command)=>command.close);
        return $c10c4e72dcf445b6$var$Rx.lastValueFrom($c10c4e72dcf445b6$var$Rx.merge(...closeStreams).pipe((0, $2wRUS.bufferCount)(closeStreams.length), (0, $2wRUS.switchMap)((exitInfos)=>this.isSuccess(exitInfos) ? this.emitWithScheduler($c10c4e72dcf445b6$var$Rx.of(exitInfos)) : this.emitWithScheduler($c10c4e72dcf445b6$var$Rx.throwError(exitInfos))), (0, $2wRUS.take)(1)));
    }
    emitWithScheduler(input) {
        return this.scheduler ? input.pipe($c10c4e72dcf445b6$var$Rx.observeOn(this.scheduler)) : input;
    }
}
module.exports.CompletionListener = $c10c4e72dcf445b6$var$CompletionListener;

});
parcelRegister("2wRUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeAll = module.exports.merge = module.exports.max = module.exports.materialize = module.exports.mapTo = module.exports.map = module.exports.last = module.exports.isEmpty = module.exports.ignoreElements = module.exports.groupBy = module.exports.first = module.exports.findIndex = module.exports.find = module.exports.finalize = module.exports.filter = module.exports.expand = module.exports.exhaustMap = module.exports.exhaustAll = module.exports.exhaust = module.exports.every = module.exports.endWith = module.exports.elementAt = module.exports.distinctUntilKeyChanged = module.exports.distinctUntilChanged = module.exports.distinct = module.exports.dematerialize = module.exports.delayWhen = module.exports.delay = module.exports.defaultIfEmpty = module.exports.debounceTime = module.exports.debounce = module.exports.count = module.exports.connect = module.exports.concatWith = module.exports.concatMapTo = module.exports.concatMap = module.exports.concatAll = module.exports.concat = module.exports.combineLatestWith = module.exports.combineLatest = module.exports.combineLatestAll = module.exports.combineAll = module.exports.catchError = module.exports.bufferWhen = module.exports.bufferToggle = module.exports.bufferTime = module.exports.bufferCount = module.exports.buffer = module.exports.auditTime = module.exports.audit = void 0;
module.exports.timeInterval = module.exports.throwIfEmpty = module.exports.throttleTime = module.exports.throttle = module.exports.tap = module.exports.takeWhile = module.exports.takeUntil = module.exports.takeLast = module.exports.take = module.exports.switchScan = module.exports.switchMapTo = module.exports.switchMap = module.exports.switchAll = module.exports.subscribeOn = module.exports.startWith = module.exports.skipWhile = module.exports.skipUntil = module.exports.skipLast = module.exports.skip = module.exports.single = module.exports.shareReplay = module.exports.share = module.exports.sequenceEqual = module.exports.scan = module.exports.sampleTime = module.exports.sample = module.exports.refCount = module.exports.retryWhen = module.exports.retry = module.exports.repeatWhen = module.exports.repeat = module.exports.reduce = module.exports.raceWith = module.exports.race = module.exports.publishReplay = module.exports.publishLast = module.exports.publishBehavior = module.exports.publish = module.exports.pluck = module.exports.partition = module.exports.pairwise = module.exports.onErrorResumeNext = module.exports.observeOn = module.exports.multicast = module.exports.min = module.exports.mergeWith = module.exports.mergeScan = module.exports.mergeMapTo = module.exports.mergeMap = module.exports.flatMap = void 0;
module.exports.zipWith = module.exports.zipAll = module.exports.zip = module.exports.withLatestFrom = module.exports.windowWhen = module.exports.windowToggle = module.exports.windowTime = module.exports.windowCount = module.exports.window = module.exports.toArray = module.exports.timestamp = module.exports.timeoutWith = module.exports.timeout = void 0;

var $GJKWZ = parcelRequire("GJKWZ");
Object.defineProperty(module.exports, "audit", {
    enumerable: true,
    get: function() {
        return $GJKWZ.audit;
    }
});

var $74irm = parcelRequire("74irm");
Object.defineProperty(module.exports, "auditTime", {
    enumerable: true,
    get: function() {
        return $74irm.auditTime;
    }
});

var $5AHzz = parcelRequire("5AHzz");
Object.defineProperty(module.exports, "buffer", {
    enumerable: true,
    get: function() {
        return $5AHzz.buffer;
    }
});

var $lra6r = parcelRequire("lra6r");
Object.defineProperty(module.exports, "bufferCount", {
    enumerable: true,
    get: function() {
        return $lra6r.bufferCount;
    }
});

var $iwmnp = parcelRequire("iwmnp");
Object.defineProperty(module.exports, "bufferTime", {
    enumerable: true,
    get: function() {
        return $iwmnp.bufferTime;
    }
});

var $4LjBN = parcelRequire("4LjBN");
Object.defineProperty(module.exports, "bufferToggle", {
    enumerable: true,
    get: function() {
        return $4LjBN.bufferToggle;
    }
});

var $aDvMT = parcelRequire("aDvMT");
Object.defineProperty(module.exports, "bufferWhen", {
    enumerable: true,
    get: function() {
        return $aDvMT.bufferWhen;
    }
});

var $cKLIx = parcelRequire("cKLIx");
Object.defineProperty(module.exports, "catchError", {
    enumerable: true,
    get: function() {
        return $cKLIx.catchError;
    }
});

var $hi56J = parcelRequire("hi56J");
Object.defineProperty(module.exports, "combineAll", {
    enumerable: true,
    get: function() {
        return $hi56J.combineAll;
    }
});

var $5mmFD = parcelRequire("5mmFD");
Object.defineProperty(module.exports, "combineLatestAll", {
    enumerable: true,
    get: function() {
        return $5mmFD.combineLatestAll;
    }
});

var $47dw7 = parcelRequire("47dw7");
Object.defineProperty(module.exports, "combineLatest", {
    enumerable: true,
    get: function() {
        return $47dw7.combineLatest;
    }
});

var $bkZDh = parcelRequire("bkZDh");
Object.defineProperty(module.exports, "combineLatestWith", {
    enumerable: true,
    get: function() {
        return $bkZDh.combineLatestWith;
    }
});

var $8T0RJ = parcelRequire("8T0RJ");
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function() {
        return $8T0RJ.concat;
    }
});

var $ibJWH = parcelRequire("ibJWH");
Object.defineProperty(module.exports, "concatAll", {
    enumerable: true,
    get: function() {
        return $ibJWH.concatAll;
    }
});

var $lUHBy = parcelRequire("lUHBy");
Object.defineProperty(module.exports, "concatMap", {
    enumerable: true,
    get: function() {
        return $lUHBy.concatMap;
    }
});

var $hqJGA = parcelRequire("hqJGA");
Object.defineProperty(module.exports, "concatMapTo", {
    enumerable: true,
    get: function() {
        return $hqJGA.concatMapTo;
    }
});

var $lQTUa = parcelRequire("lQTUa");
Object.defineProperty(module.exports, "concatWith", {
    enumerable: true,
    get: function() {
        return $lQTUa.concatWith;
    }
});

var $6yr3x = parcelRequire("6yr3x");
Object.defineProperty(module.exports, "connect", {
    enumerable: true,
    get: function() {
        return $6yr3x.connect;
    }
});

var $3BlwT = parcelRequire("3BlwT");
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $3BlwT.count;
    }
});

var $1YliC = parcelRequire("1YliC");
Object.defineProperty(module.exports, "debounce", {
    enumerable: true,
    get: function() {
        return $1YliC.debounce;
    }
});

var $h30H1 = parcelRequire("h30H1");
Object.defineProperty(module.exports, "debounceTime", {
    enumerable: true,
    get: function() {
        return $h30H1.debounceTime;
    }
});

var $kJW6J = parcelRequire("kJW6J");
Object.defineProperty(module.exports, "defaultIfEmpty", {
    enumerable: true,
    get: function() {
        return $kJW6J.defaultIfEmpty;
    }
});

var $6jlJh = parcelRequire("6jlJh");
Object.defineProperty(module.exports, "delay", {
    enumerable: true,
    get: function() {
        return $6jlJh.delay;
    }
});

var $iw846 = parcelRequire("iw846");
Object.defineProperty(module.exports, "delayWhen", {
    enumerable: true,
    get: function() {
        return $iw846.delayWhen;
    }
});

var $eII53 = parcelRequire("eII53");
Object.defineProperty(module.exports, "dematerialize", {
    enumerable: true,
    get: function() {
        return $eII53.dematerialize;
    }
});

var $j2jlR = parcelRequire("j2jlR");
Object.defineProperty(module.exports, "distinct", {
    enumerable: true,
    get: function() {
        return $j2jlR.distinct;
    }
});

var $44MsQ = parcelRequire("44MsQ");
Object.defineProperty(module.exports, "distinctUntilChanged", {
    enumerable: true,
    get: function() {
        return $44MsQ.distinctUntilChanged;
    }
});

var $3AgXM = parcelRequire("3AgXM");
Object.defineProperty(module.exports, "distinctUntilKeyChanged", {
    enumerable: true,
    get: function() {
        return $3AgXM.distinctUntilKeyChanged;
    }
});

var $8fwR4 = parcelRequire("8fwR4");
Object.defineProperty(module.exports, "elementAt", {
    enumerable: true,
    get: function() {
        return $8fwR4.elementAt;
    }
});

var $dS4q4 = parcelRequire("dS4q4");
Object.defineProperty(module.exports, "endWith", {
    enumerable: true,
    get: function() {
        return $dS4q4.endWith;
    }
});

var $i80A2 = parcelRequire("i80A2");
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $i80A2.every;
    }
});

var $hUsVc = parcelRequire("hUsVc");
Object.defineProperty(module.exports, "exhaust", {
    enumerable: true,
    get: function() {
        return $hUsVc.exhaust;
    }
});

var $b1bNb = parcelRequire("b1bNb");
Object.defineProperty(module.exports, "exhaustAll", {
    enumerable: true,
    get: function() {
        return $b1bNb.exhaustAll;
    }
});

var $k75zC = parcelRequire("k75zC");
Object.defineProperty(module.exports, "exhaustMap", {
    enumerable: true,
    get: function() {
        return $k75zC.exhaustMap;
    }
});

var $189NR = parcelRequire("189NR");
Object.defineProperty(module.exports, "expand", {
    enumerable: true,
    get: function() {
        return $189NR.expand;
    }
});

var $9UB7l = parcelRequire("9UB7l");
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $9UB7l.filter;
    }
});

var $1UQBm = parcelRequire("1UQBm");
Object.defineProperty(module.exports, "finalize", {
    enumerable: true,
    get: function() {
        return $1UQBm.finalize;
    }
});

var $5b0bg = parcelRequire("5b0bg");
Object.defineProperty(module.exports, "find", {
    enumerable: true,
    get: function() {
        return $5b0bg.find;
    }
});

var $iCzrW = parcelRequire("iCzrW");
Object.defineProperty(module.exports, "findIndex", {
    enumerable: true,
    get: function() {
        return $iCzrW.findIndex;
    }
});

var $c0ecv = parcelRequire("c0ecv");
Object.defineProperty(module.exports, "first", {
    enumerable: true,
    get: function() {
        return $c0ecv.first;
    }
});

var $3e5pj = parcelRequire("3e5pj");
Object.defineProperty(module.exports, "groupBy", {
    enumerable: true,
    get: function() {
        return $3e5pj.groupBy;
    }
});

var $iuPJp = parcelRequire("iuPJp");
Object.defineProperty(module.exports, "ignoreElements", {
    enumerable: true,
    get: function() {
        return $iuPJp.ignoreElements;
    }
});

var $cOYnk = parcelRequire("cOYnk");
Object.defineProperty(module.exports, "isEmpty", {
    enumerable: true,
    get: function() {
        return $cOYnk.isEmpty;
    }
});

var $jwbyz = parcelRequire("jwbyz");
Object.defineProperty(module.exports, "last", {
    enumerable: true,
    get: function() {
        return $jwbyz.last;
    }
});

var $dlvLZ = parcelRequire("dlvLZ");
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $dlvLZ.map;
    }
});

var $jHEjl = parcelRequire("jHEjl");
Object.defineProperty(module.exports, "mapTo", {
    enumerable: true,
    get: function() {
        return $jHEjl.mapTo;
    }
});

var $gXR8J = parcelRequire("gXR8J");
Object.defineProperty(module.exports, "materialize", {
    enumerable: true,
    get: function() {
        return $gXR8J.materialize;
    }
});

var $bL8Bf = parcelRequire("bL8Bf");
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $bL8Bf.max;
    }
});

var $99t9M = parcelRequire("99t9M");
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $99t9M.merge;
    }
});

var $bGQoL = parcelRequire("bGQoL");
Object.defineProperty(module.exports, "mergeAll", {
    enumerable: true,
    get: function() {
        return $bGQoL.mergeAll;
    }
});

var $crJRG = parcelRequire("crJRG");
Object.defineProperty(module.exports, "flatMap", {
    enumerable: true,
    get: function() {
        return $crJRG.flatMap;
    }
});

var $9yos9 = parcelRequire("9yos9");
Object.defineProperty(module.exports, "mergeMap", {
    enumerable: true,
    get: function() {
        return $9yos9.mergeMap;
    }
});

var $aGrfq = parcelRequire("aGrfq");
Object.defineProperty(module.exports, "mergeMapTo", {
    enumerable: true,
    get: function() {
        return $aGrfq.mergeMapTo;
    }
});

var $52bW5 = parcelRequire("52bW5");
Object.defineProperty(module.exports, "mergeScan", {
    enumerable: true,
    get: function() {
        return $52bW5.mergeScan;
    }
});

var $joqn9 = parcelRequire("joqn9");
Object.defineProperty(module.exports, "mergeWith", {
    enumerable: true,
    get: function() {
        return $joqn9.mergeWith;
    }
});

var $2QRuw = parcelRequire("2QRuw");
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $2QRuw.min;
    }
});

var $0YCgj = parcelRequire("0YCgj");
Object.defineProperty(module.exports, "multicast", {
    enumerable: true,
    get: function() {
        return $0YCgj.multicast;
    }
});

var $030h7 = parcelRequire("030h7");
Object.defineProperty(module.exports, "observeOn", {
    enumerable: true,
    get: function() {
        return $030h7.observeOn;
    }
});

var $8XKni = parcelRequire("8XKni");
Object.defineProperty(module.exports, "onErrorResumeNext", {
    enumerable: true,
    get: function() {
        return $8XKni.onErrorResumeNext;
    }
});

var $zmZZf = parcelRequire("zmZZf");
Object.defineProperty(module.exports, "pairwise", {
    enumerable: true,
    get: function() {
        return $zmZZf.pairwise;
    }
});

var $jTWUY = parcelRequire("jTWUY");
Object.defineProperty(module.exports, "partition", {
    enumerable: true,
    get: function() {
        return $jTWUY.partition;
    }
});

var $kSUeX = parcelRequire("kSUeX");
Object.defineProperty(module.exports, "pluck", {
    enumerable: true,
    get: function() {
        return $kSUeX.pluck;
    }
});

var $3DSIU = parcelRequire("3DSIU");
Object.defineProperty(module.exports, "publish", {
    enumerable: true,
    get: function() {
        return $3DSIU.publish;
    }
});

var $4Yf1V = parcelRequire("4Yf1V");
Object.defineProperty(module.exports, "publishBehavior", {
    enumerable: true,
    get: function() {
        return $4Yf1V.publishBehavior;
    }
});

var $htmo4 = parcelRequire("htmo4");
Object.defineProperty(module.exports, "publishLast", {
    enumerable: true,
    get: function() {
        return $htmo4.publishLast;
    }
});

var $hO5Vx = parcelRequire("hO5Vx");
Object.defineProperty(module.exports, "publishReplay", {
    enumerable: true,
    get: function() {
        return $hO5Vx.publishReplay;
    }
});

var $auAJ2 = parcelRequire("auAJ2");
Object.defineProperty(module.exports, "race", {
    enumerable: true,
    get: function() {
        return $auAJ2.race;
    }
});

var $QP0wQ = parcelRequire("QP0wQ");
Object.defineProperty(module.exports, "raceWith", {
    enumerable: true,
    get: function() {
        return $QP0wQ.raceWith;
    }
});

var $1DJZU = parcelRequire("1DJZU");
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $1DJZU.reduce;
    }
});

var $7l3DT = parcelRequire("7l3DT");
Object.defineProperty(module.exports, "repeat", {
    enumerable: true,
    get: function() {
        return $7l3DT.repeat;
    }
});

var $adOrM = parcelRequire("adOrM");
Object.defineProperty(module.exports, "repeatWhen", {
    enumerable: true,
    get: function() {
        return $adOrM.repeatWhen;
    }
});

var $1vc7D = parcelRequire("1vc7D");
Object.defineProperty(module.exports, "retry", {
    enumerable: true,
    get: function() {
        return $1vc7D.retry;
    }
});

var $aSde1 = parcelRequire("aSde1");
Object.defineProperty(module.exports, "retryWhen", {
    enumerable: true,
    get: function() {
        return $aSde1.retryWhen;
    }
});

var $7Z891 = parcelRequire("7Z891");
Object.defineProperty(module.exports, "refCount", {
    enumerable: true,
    get: function() {
        return $7Z891.refCount;
    }
});

var $99Y2Y = parcelRequire("99Y2Y");
Object.defineProperty(module.exports, "sample", {
    enumerable: true,
    get: function() {
        return $99Y2Y.sample;
    }
});

var $lGCWc = parcelRequire("lGCWc");
Object.defineProperty(module.exports, "sampleTime", {
    enumerable: true,
    get: function() {
        return $lGCWc.sampleTime;
    }
});

var $keq7K = parcelRequire("keq7K");
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $keq7K.scan;
    }
});

var $htbrG = parcelRequire("htbrG");
Object.defineProperty(module.exports, "sequenceEqual", {
    enumerable: true,
    get: function() {
        return $htbrG.sequenceEqual;
    }
});

var $109B7 = parcelRequire("109B7");
Object.defineProperty(module.exports, "share", {
    enumerable: true,
    get: function() {
        return $109B7.share;
    }
});

var $171Pf = parcelRequire("171Pf");
Object.defineProperty(module.exports, "shareReplay", {
    enumerable: true,
    get: function() {
        return $171Pf.shareReplay;
    }
});

var $cYZh1 = parcelRequire("cYZh1");
Object.defineProperty(module.exports, "single", {
    enumerable: true,
    get: function() {
        return $cYZh1.single;
    }
});

var $giKyY = parcelRequire("giKyY");
Object.defineProperty(module.exports, "skip", {
    enumerable: true,
    get: function() {
        return $giKyY.skip;
    }
});

var $6aRM0 = parcelRequire("6aRM0");
Object.defineProperty(module.exports, "skipLast", {
    enumerable: true,
    get: function() {
        return $6aRM0.skipLast;
    }
});

var $8h7Qd = parcelRequire("8h7Qd");
Object.defineProperty(module.exports, "skipUntil", {
    enumerable: true,
    get: function() {
        return $8h7Qd.skipUntil;
    }
});

var $ddo0F = parcelRequire("ddo0F");
Object.defineProperty(module.exports, "skipWhile", {
    enumerable: true,
    get: function() {
        return $ddo0F.skipWhile;
    }
});

var $2hoDR = parcelRequire("2hoDR");
Object.defineProperty(module.exports, "startWith", {
    enumerable: true,
    get: function() {
        return $2hoDR.startWith;
    }
});

var $4ezR0 = parcelRequire("4ezR0");
Object.defineProperty(module.exports, "subscribeOn", {
    enumerable: true,
    get: function() {
        return $4ezR0.subscribeOn;
    }
});

var $7cM1p = parcelRequire("7cM1p");
Object.defineProperty(module.exports, "switchAll", {
    enumerable: true,
    get: function() {
        return $7cM1p.switchAll;
    }
});

var $9q5AD = parcelRequire("9q5AD");
Object.defineProperty(module.exports, "switchMap", {
    enumerable: true,
    get: function() {
        return $9q5AD.switchMap;
    }
});

var $aXTon = parcelRequire("aXTon");
Object.defineProperty(module.exports, "switchMapTo", {
    enumerable: true,
    get: function() {
        return $aXTon.switchMapTo;
    }
});

var $6UQzS = parcelRequire("6UQzS");
Object.defineProperty(module.exports, "switchScan", {
    enumerable: true,
    get: function() {
        return $6UQzS.switchScan;
    }
});

var $RyKIh = parcelRequire("RyKIh");
Object.defineProperty(module.exports, "take", {
    enumerable: true,
    get: function() {
        return $RyKIh.take;
    }
});

var $eetG1 = parcelRequire("eetG1");
Object.defineProperty(module.exports, "takeLast", {
    enumerable: true,
    get: function() {
        return $eetG1.takeLast;
    }
});

var $hmAHy = parcelRequire("hmAHy");
Object.defineProperty(module.exports, "takeUntil", {
    enumerable: true,
    get: function() {
        return $hmAHy.takeUntil;
    }
});

var $l0lbO = parcelRequire("l0lbO");
Object.defineProperty(module.exports, "takeWhile", {
    enumerable: true,
    get: function() {
        return $l0lbO.takeWhile;
    }
});

var $itLai = parcelRequire("itLai");
Object.defineProperty(module.exports, "tap", {
    enumerable: true,
    get: function() {
        return $itLai.tap;
    }
});

var $cmWmG = parcelRequire("cmWmG");
Object.defineProperty(module.exports, "throttle", {
    enumerable: true,
    get: function() {
        return $cmWmG.throttle;
    }
});

var $jO5Pf = parcelRequire("jO5Pf");
Object.defineProperty(module.exports, "throttleTime", {
    enumerable: true,
    get: function() {
        return $jO5Pf.throttleTime;
    }
});

var $g9w3F = parcelRequire("g9w3F");
Object.defineProperty(module.exports, "throwIfEmpty", {
    enumerable: true,
    get: function() {
        return $g9w3F.throwIfEmpty;
    }
});

var $05fTJ = parcelRequire("05fTJ");
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $05fTJ.timeInterval;
    }
});

var $5oCQ5 = parcelRequire("5oCQ5");
Object.defineProperty(module.exports, "timeout", {
    enumerable: true,
    get: function() {
        return $5oCQ5.timeout;
    }
});

var $bqhsW = parcelRequire("bqhsW");
Object.defineProperty(module.exports, "timeoutWith", {
    enumerable: true,
    get: function() {
        return $bqhsW.timeoutWith;
    }
});

var $NLpTp = parcelRequire("NLpTp");
Object.defineProperty(module.exports, "timestamp", {
    enumerable: true,
    get: function() {
        return $NLpTp.timestamp;
    }
});

var $dEi09 = parcelRequire("dEi09");
Object.defineProperty(module.exports, "toArray", {
    enumerable: true,
    get: function() {
        return $dEi09.toArray;
    }
});

var $3UEiK = parcelRequire("3UEiK");
Object.defineProperty(module.exports, "window", {
    enumerable: true,
    get: function() {
        return $3UEiK.window;
    }
});

var $8FElb = parcelRequire("8FElb");
Object.defineProperty(module.exports, "windowCount", {
    enumerable: true,
    get: function() {
        return $8FElb.windowCount;
    }
});

var $fxabb = parcelRequire("fxabb");
Object.defineProperty(module.exports, "windowTime", {
    enumerable: true,
    get: function() {
        return $fxabb.windowTime;
    }
});

var $6KMpd = parcelRequire("6KMpd");
Object.defineProperty(module.exports, "windowToggle", {
    enumerable: true,
    get: function() {
        return $6KMpd.windowToggle;
    }
});

var $8F6gz = parcelRequire("8F6gz");
Object.defineProperty(module.exports, "windowWhen", {
    enumerable: true,
    get: function() {
        return $8F6gz.windowWhen;
    }
});

var $8hSe0 = parcelRequire("8hSe0");
Object.defineProperty(module.exports, "withLatestFrom", {
    enumerable: true,
    get: function() {
        return $8hSe0.withLatestFrom;
    }
});

var $7wp9W = parcelRequire("7wp9W");
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $7wp9W.zip;
    }
});

var $cfyGJ = parcelRequire("cfyGJ");
Object.defineProperty(module.exports, "zipAll", {
    enumerable: true,
    get: function() {
        return $cfyGJ.zipAll;
    }
});

var $bQ6MC = parcelRequire("bQ6MC");
Object.defineProperty(module.exports, "zipWith", {
    enumerable: true,
    get: function() {
        return $bQ6MC.zipWith;
    }
});

});
parcelRegister("jTWUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.partition = void 0;

var $3C8X6 = parcelRequire("3C8X6");

var $9UB7l = parcelRequire("9UB7l");
function $e7d0db3d096907b2$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $9UB7l.filter(predicate, thisArg)(source),
            $9UB7l.filter($3C8X6.not(predicate, thisArg))(source)
        ];
    };
}
module.exports.partition = $e7d0db3d096907b2$var$partition;

});

parcelRegister("auAJ2", function(module, exports) {
"use strict";
var $7a3931a575adbd82$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $7a3931a575adbd82$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.race = void 0;

var $2RXLX = parcelRequire("2RXLX");

var $QP0wQ = parcelRequire("QP0wQ");
function $7a3931a575adbd82$var$race() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $QP0wQ.raceWith.apply(void 0, $7a3931a575adbd82$var$__spreadArray([], $7a3931a575adbd82$var$__read($2RXLX.argsOrArgArray(args))));
}
module.exports.race = $7a3931a575adbd82$var$race;

});



parcelRegister("kyVoJ", function(module, exports) {
"use strict";
var $ef8381ac600daa3b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSpawnOpts = void 0;

const $ef8381ac600daa3b$var$supports_color_1 = $ef8381ac600daa3b$var$__importDefault((parcelRequire("259Fo")));
const $ef8381ac600daa3b$var$getSpawnOpts = ({ colorSupport: colorSupport = $ef8381ac600daa3b$var$supports_color_1.default.stdout, cwd: cwd, process: process = $parcel$global.process, raw: raw = false, env: env = {} })=>({
        cwd: cwd || process.cwd(),
        ...raw && {
            stdio: 'inherit'
        },
        .../^win/.test(process.platform) && {
            detached: false
        },
        env: {
            ...colorSupport ? {
                FORCE_COLOR: colorSupport.level.toString()
            } : {},
            ...process.env,
            ...env
        }
    });
module.exports.getSpawnOpts = $ef8381ac600daa3b$var$getSpawnOpts;

});
parcelRegister("259Fo", function(module, exports) {
/* eslint-env browser */ 'use strict';
function $18438bf7df53e842$var$getChromeVersion() {
    const matches = /(Chrome|Chromium)\/(?<chromeVersion>\d+)\./.exec(navigator.userAgent);
    if (!matches) return;
    return Number.parseInt(matches.groups.chromeVersion, 10);
}
const $18438bf7df53e842$var$colorSupport = $18438bf7df53e842$var$getChromeVersion() >= 69 ? {
    level: 1,
    hasBasic: true,
    has256: false,
    has16m: false
} : false;
module.exports = {
    stdout: $18438bf7df53e842$var$colorSupport,
    stderr: $18438bf7df53e842$var$colorSupport
};

});


parcelRegister("3RPGu", function(module, exports) {
"use strict";
var $2d0e69c349a389c6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2d0e69c349a389c6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2d0e69c349a389c6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2d0e69c349a389c6$var$__createBinding(result, mod, k);
    }
    $2d0e69c349a389c6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OutputWriter = void 0;

const $2d0e69c349a389c6$var$Rx = $2d0e69c349a389c6$var$__importStar((parcelRequire("7fhTn")));
/**
 * Class responsible for actually writing output onto a writable stream.
 */ class $2d0e69c349a389c6$var$OutputWriter {
    constructor({ outputStream: outputStream, group: group, commands: commands }){
        this.activeCommandIndex = 0;
        this.outputStream = outputStream;
        this.group = group;
        this.buffers = commands.map(()=>[]);
        if (this.group) $2d0e69c349a389c6$var$Rx.merge(...commands.map((c)=>c.close)).subscribe((command)=>{
            if (command.index !== this.activeCommandIndex) return;
            for(let i = command.index + 1; i < commands.length; i++){
                this.activeCommandIndex = i;
                this.flushBuffer(i);
                if (!commands[i].exited) break;
            }
        });
    }
    write(command, text) {
        if (this.group && command) {
            if (command.index <= this.activeCommandIndex) this.outputStream.write(text);
            else this.buffers[command.index].push(text);
        } else // "global" logs (command=null) are output out of order
        this.outputStream.write(text);
    }
    flushBuffer(index) {
        this.buffers[index].forEach((t)=>this.outputStream.write(t));
        this.buffers[index] = [];
    }
}
module.exports.OutputWriter = $2d0e69c349a389c6$var$OutputWriter;

});

parcelRegister("lteuy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrefixColorSelector = void 0;
function $fa178c2ac20e140d$var$getConsoleColorsWithoutCustomColors(customColors) {
    return $fa178c2ac20e140d$var$PrefixColorSelector.ACCEPTABLE_CONSOLE_COLORS.filter(// Consider the "Bright" variants of colors to be the same as the plain color to avoid similar colors
    (color)=>!customColors.includes(color.replace(/Bright$/, '')));
}
/**
 * Creates a generator that yields an infinite stream of colors.
 */ function* $fa178c2ac20e140d$var$createColorGenerator(customColors) {
    // Custom colors should be used as is, except for "auto"
    const nextAutoColors = $fa178c2ac20e140d$var$getConsoleColorsWithoutCustomColors(customColors);
    let lastColor;
    for (const customColor of customColors){
        let currentColor = customColor;
        if (currentColor !== 'auto') yield currentColor; // Manual color
        else {
            // Find the first auto color that is not the same as the last color
            while(currentColor === 'auto' || lastColor === currentColor){
                if (!nextAutoColors.length) // There could be more "auto" values than auto colors so this needs to be able to refill
                nextAutoColors.push(...$fa178c2ac20e140d$var$PrefixColorSelector.ACCEPTABLE_CONSOLE_COLORS);
                currentColor = String(nextAutoColors.shift());
            }
            yield currentColor; // Auto color
        }
        lastColor = currentColor;
    }
    const lastCustomColor = customColors[customColors.length - 1] || '';
    if (lastCustomColor !== 'auto') while(true)yield lastCustomColor; // If last custom color was not "auto" then return same color forever, to maintain existing behaviour
    // Finish the initial set(s) of auto colors to avoid repetition
    for (const color of nextAutoColors)yield color;
    // Yield an infinite stream of acceptable console colors
    //
    // If the given custom colors use every ACCEPTABLE_CONSOLE_COLORS except one then there is a chance a color will be repeated,
    // however its highly unlikely and low consequence so not worth the extra complexity to account for it
    while(true)for (const color of $fa178c2ac20e140d$var$PrefixColorSelector.ACCEPTABLE_CONSOLE_COLORS)yield color; // Repeat colors forever
}
class $fa178c2ac20e140d$var$PrefixColorSelector {
    constructor(customColors = []){
        this.colorGenerator = $fa178c2ac20e140d$var$createColorGenerator(customColors);
    }
    /** A list of colors that are readable in a terminal. */ static get ACCEPTABLE_CONSOLE_COLORS() {
        // Colors picked randomly, can be amended if required
        return [
            // Prevent duplicates, in case the list becomes significantly large
            ...new Set([
                // Text colors
                'cyan',
                'yellow',
                'greenBright',
                'blueBright',
                'magentaBright',
                'white',
                'grey',
                'red',
                // Background colors
                'bgCyan',
                'bgYellow',
                'bgGreenBright',
                'bgBlueBright',
                'bgMagenta',
                'bgWhiteBright',
                'bgGrey',
                'bgRed'
            ])
        ];
    }
    /**
     * @returns The given custom colors then a set of acceptable console colors indefinitely.
     */ getNextColor() {
        return this.colorGenerator.next().value;
    }
}
module.exports.PrefixColorSelector = $fa178c2ac20e140d$var$PrefixColorSelector;

});


parcelRegister("bNJZn", function(module, exports) {
"use strict";
var $8977f1c8aae6111a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8977f1c8aae6111a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8977f1c8aae6111a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8977f1c8aae6111a$var$__createBinding(result, mod, k);
    }
    $8977f1c8aae6111a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputHandler = void 0;

const $8977f1c8aae6111a$var$Rx = $8977f1c8aae6111a$var$__importStar((parcelRequire("7fhTn")));

var $2wRUS = parcelRequire("2wRUS");

const $8977f1c8aae6111a$var$defaults = $8977f1c8aae6111a$var$__importStar((parcelRequire("lLL3u")));
/**
 * Sends input from concurrently through to commands.
 *
 * Input can start with a command identifier, in which case it will be sent to that specific command.
 * For instance, `0:bla` will send `bla` to command at index `0`, and `server:stop` will send `stop`
 * to command with name `server`.
 *
 * If the input doesn't start with a command identifier, it is then always sent to the default target.
 */ class $8977f1c8aae6111a$var$InputHandler {
    constructor({ defaultInputTarget: defaultInputTarget, inputStream: inputStream, pauseInputStreamOnFinish: pauseInputStreamOnFinish, logger: logger }){
        this.logger = logger;
        this.defaultInputTarget = defaultInputTarget || $8977f1c8aae6111a$var$defaults.defaultInputTarget;
        this.inputStream = inputStream;
        this.pauseInputStreamOnFinish = pauseInputStreamOnFinish !== false;
    }
    handle(commands) {
        const { inputStream: inputStream } = this;
        if (!inputStream) return {
            commands: commands
        };
        $8977f1c8aae6111a$var$Rx.fromEvent(inputStream, 'data').pipe((0, $2wRUS.map)((data)=>String(data))).subscribe((data)=>{
            const dataParts = data.split(/:(.+)/);
            const targetId = dataParts.length > 1 ? dataParts[0] : this.defaultInputTarget;
            const input = dataParts[1] || data;
            const command = commands.find((command)=>command.name === targetId || command.index.toString() === targetId.toString());
            if (command && command.stdin) command.stdin.write(input);
            else this.logger.logGlobalEvent(`Unable to find command ${targetId}, or it has no stdin open\n`);
        });
        return {
            commands: commands,
            onFinish: ()=>{
                if (this.pauseInputStreamOnFinish) // https://github.com/kimmobrunfeldt/concurrently/issues/252
                inputStream.pause();
            }
        };
    }
}
module.exports.InputHandler = $8977f1c8aae6111a$var$InputHandler;

});
parcelRegister("lLL3u", function(module, exports) {
"use strict";
// This file is meant to be a shared place for default configs.
// It's read by the flow controllers, the executable, etc.
// Refer to tests for the meaning of the different possible values.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.passthroughArguments = module.exports.timings = module.exports.cwd = module.exports.timestampFormat = module.exports.success = module.exports.restartDelay = module.exports.restartTries = module.exports.raw = module.exports.prefixLength = module.exports.prefixColors = module.exports.prefix = module.exports.nameSeparator = module.exports.hide = module.exports.maxProcesses = module.exports.handleInput = module.exports.defaultInputTarget = void 0;
module.exports.defaultInputTarget = 0;
/**
 * Whether process.stdin should be forwarded to child processes.
 */ module.exports.handleInput = false;
/**
 * How many processes to run at once.
 */ module.exports.maxProcesses = 0;
/**
 * Indices and names of commands whose output are not to be logged.
 */ module.exports.hide = '';
/**
 * The character to split <names> on.
 */ module.exports.nameSeparator = ',';
/**
 * Which prefix style to use when logging processes output.
 */ module.exports.prefix = '';
/**
 * Default prefix color.
 * @see https://www.npmjs.com/package/chalk
 */ module.exports.prefixColors = 'reset';
/**
 * How many bytes we'll show on the command prefix.
 */ module.exports.prefixLength = 10;
module.exports.raw = false;
/**
 * Number of attempts of restarting a process, if it exits with non-0 code.
 */ module.exports.restartTries = 0;
/**
 * How many milliseconds concurrently should wait before restarting a process.
 */ module.exports.restartDelay = 0;
/**
 * Condition of success for concurrently itself.
 */ module.exports.success = 'all';
/**
 * Date format used when logging date/time.
 * @see https://date-fns.org/v2.0.1/docs/format
 */ module.exports.timestampFormat = 'yyyy-MM-dd HH:mm:ss.SSS';
/**
 * Current working dir passed as option to spawn command.
 * Defaults to process.cwd()
 */ module.exports.cwd = undefined;
/**
 * Whether to show timing information for processes in console output.
 */ module.exports.timings = false;
/**
 * Passthrough additional arguments to commands (accessible via placeholders) instead of treating them as commands.
 */ module.exports.passthroughArguments = false;

});


parcelRegister("9XkYi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KillOnSignal = void 0;

var $2wRUS = parcelRequire("2wRUS");
/**
 * Watches the main concurrently process for signals and sends the same signal down to each spawned
 * command.
 */ class $73f9e445f205688b$var$KillOnSignal {
    constructor({ process: process }){
        this.process = process;
    }
    handle(commands) {
        let caughtSignal;
        [
            'SIGINT',
            'SIGTERM',
            'SIGHUP'
        ].forEach((signal)=>{
            this.process.on(signal, ()=>{
                caughtSignal = signal;
                commands.forEach((command)=>command.kill(signal));
            });
        });
        return {
            commands: commands.map((command)=>{
                const closeStream = command.close.pipe((0, $2wRUS.map)((exitInfo)=>{
                    const exitCode = caughtSignal === 'SIGINT' ? 0 : exitInfo.exitCode;
                    return {
                        ...exitInfo,
                        exitCode: exitCode
                    };
                }));
                return new Proxy(command, {
                    get (target, prop) {
                        return prop === 'close' ? closeStream : target[prop];
                    }
                });
            })
        };
    }
}
module.exports.KillOnSignal = $73f9e445f205688b$var$KillOnSignal;

});

parcelRegister("18X8B", function(module, exports) {
"use strict";
var $0d54695034a4966c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KillOthers = void 0;

const $0d54695034a4966c$var$lodash_1 = $0d54695034a4966c$var$__importDefault((parcelRequire("2m7Ys")));

var $2wRUS = parcelRequire("2wRUS");

var $b27q8 = parcelRequire("b27q8");
/**
 * Sends a SIGTERM signal to all commands when one of the commands exits with a matching condition.
 */ class $0d54695034a4966c$var$KillOthers {
    constructor({ logger: logger, conditions: conditions }){
        this.logger = logger;
        this.conditions = $0d54695034a4966c$var$lodash_1.default.castArray(conditions);
    }
    handle(commands) {
        const conditions = this.conditions.filter((condition)=>condition === 'failure' || condition === 'success');
        if (!conditions.length) return {
            commands: commands
        };
        const closeStates = commands.map((command)=>command.close.pipe((0, $2wRUS.map)(({ exitCode: exitCode })=>exitCode === 0 ? 'success' : 'failure'), (0, $2wRUS.filter)((state)=>conditions.includes(state))));
        closeStates.forEach((closeState)=>closeState.subscribe(()=>{
                const killableCommands = commands.filter((command)=>$b27q8.Command.canKill(command));
                if (killableCommands.length) {
                    this.logger.logGlobalEvent('Sending SIGTERM to other processes..');
                    killableCommands.forEach((command)=>command.kill());
                }
            }));
        return {
            commands: commands
        };
    }
}
module.exports.KillOthers = $0d54695034a4966c$var$KillOthers;

});

parcelRegister("3lRsA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogError = void 0;
/**
 * Logs when commands failed executing, e.g. due to the executable not existing in the system.
 */ class $270ccd549fc77eb7$var$LogError {
    constructor({ logger: logger }){
        this.logger = logger;
    }
    handle(commands) {
        commands.forEach((command)=>command.error.subscribe((event)=>{
                this.logger.logCommandEvent(`Error occurred when executing command: ${command.command}`, command);
                const errorText = String(event instanceof Error ? event.stack || event : event);
                this.logger.logCommandEvent(errorText, command);
            }));
        return {
            commands: commands
        };
    }
}
module.exports.LogError = $270ccd549fc77eb7$var$LogError;

});

parcelRegister("4CdUI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogExit = void 0;
/**
 * Logs the exit code/signal of commands.
 */ class $35c58107cd1cae57$var$LogExit {
    constructor({ logger: logger }){
        this.logger = logger;
    }
    handle(commands) {
        commands.forEach((command)=>command.close.subscribe(({ exitCode: exitCode })=>{
                this.logger.logCommandEvent(`${command.command} exited with code ${exitCode}`, command);
            }));
        return {
            commands: commands
        };
    }
}
module.exports.LogExit = $35c58107cd1cae57$var$LogExit;

});

parcelRegister("8Urwk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogOutput = void 0;
/**
 * Logs the stdout and stderr output of commands.
 */ class $67c8e6ab8786023a$var$LogOutput {
    constructor({ logger: logger }){
        this.logger = logger;
    }
    handle(commands) {
        commands.forEach((command)=>{
            command.stdout.subscribe((text)=>this.logger.logCommandText(text.toString(), command));
            command.stderr.subscribe((text)=>this.logger.logCommandText(text.toString(), command));
        });
        return {
            commands: commands
        };
    }
}
module.exports.LogOutput = $67c8e6ab8786023a$var$LogOutput;

});

parcelRegister("5by7l", function(module, exports) {
"use strict";
var $3c6871daeb12c245$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3c6871daeb12c245$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3c6871daeb12c245$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3c6871daeb12c245$var$__createBinding(result, mod, k);
    }
    $3c6871daeb12c245$var$__setModuleDefault(result, mod);
    return result;
};
var $3c6871daeb12c245$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogTimings = void 0;

const $3c6871daeb12c245$var$assert = $3c6871daeb12c245$var$__importStar((parcelRequire("iWlGy")));

const $3c6871daeb12c245$var$format_1 = $3c6871daeb12c245$var$__importDefault((parcelRequire("dOn2u")));

const $3c6871daeb12c245$var$lodash_1 = $3c6871daeb12c245$var$__importDefault((parcelRequire("2m7Ys")));

const $3c6871daeb12c245$var$Rx = $3c6871daeb12c245$var$__importStar((parcelRequire("7fhTn")));

var $2wRUS = parcelRequire("2wRUS");

const $3c6871daeb12c245$var$defaults = $3c6871daeb12c245$var$__importStar((parcelRequire("lLL3u")));
/**
 * Logs timing information about commands as they start/stop and then a summary when all commands finish.
 */ class $3c6871daeb12c245$var$LogTimings {
    static mapCloseEventToTimingInfo({ command: command, timings: timings, killed: killed, exitCode: exitCode }) {
        const readableDurationMs = (timings.endDate.getTime() - timings.startDate.getTime()).toLocaleString();
        return {
            name: command.name,
            duration: readableDurationMs,
            'exit code': exitCode,
            killed: killed,
            command: command.command
        };
    }
    constructor({ logger: logger, timestampFormat: timestampFormat = $3c6871daeb12c245$var$defaults.timestampFormat }){
        this.logger = logger;
        this.timestampFormat = timestampFormat;
    }
    printExitInfoTimingTable(exitInfos) {
        $3c6871daeb12c245$var$assert.ok(this.logger);
        const exitInfoTable = (0, $3c6871daeb12c245$var$lodash_1.default)(exitInfos).sortBy(({ timings: timings })=>timings.durationSeconds).reverse().map($3c6871daeb12c245$var$LogTimings.mapCloseEventToTimingInfo).value();
        this.logger.logGlobalEvent('Timings:');
        this.logger.logTable(exitInfoTable);
        return exitInfos;
    }
    handle(commands) {
        const { logger: logger } = this;
        if (!logger) return {
            commands: commands
        };
        // individual process timings
        commands.forEach((command)=>{
            command.timer.subscribe(({ startDate: startDate, endDate: endDate })=>{
                if (!endDate) {
                    const formattedStartDate = (0, $3c6871daeb12c245$var$format_1.default)(startDate, this.timestampFormat);
                    logger.logCommandEvent(`${command.command} started at ${formattedStartDate}`, command);
                } else {
                    const durationMs = endDate.getTime() - startDate.getTime();
                    const formattedEndDate = (0, $3c6871daeb12c245$var$format_1.default)(endDate, this.timestampFormat);
                    logger.logCommandEvent(`${command.command} stopped at ${formattedEndDate} after ${durationMs.toLocaleString()}ms`, command);
                }
            });
        });
        // overall summary timings
        const closeStreams = commands.map((command)=>command.close);
        const allProcessesClosed = $3c6871daeb12c245$var$Rx.merge(...closeStreams).pipe((0, $2wRUS.bufferCount)(closeStreams.length), (0, $2wRUS.take)(1));
        allProcessesClosed.subscribe((exitInfos)=>this.printExitInfoTimingTable(exitInfos));
        return {
            commands: commands
        };
    }
}
module.exports.LogTimings = $3c6871daeb12c245$var$LogTimings;

});
parcelRegister("dOn2u", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a0e1d0f2de80122b$export$2e2bcd8739ae039; });

var $jErRN = parcelRequire("jErRN");

var $aTXeq = parcelRequire("aTXeq");

var $eSkdO = parcelRequire("eSkdO");

var $hbQ65 = parcelRequire("hbQ65");

var $kFnkg = parcelRequire("kFnkg");

var $acufH = parcelRequire("acufH");

var $fzwAn = parcelRequire("fzwAn");

var $gnXng = parcelRequire("gnXng");

var $iswne = parcelRequire("iswne");

var $6fzT5 = parcelRequire("6fzT5");

var $9oc0q = parcelRequire("9oc0q");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $a0e1d0f2de80122b$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $a0e1d0f2de80122b$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $a0e1d0f2de80122b$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $a0e1d0f2de80122b$var$doubleQuoteRegExp = /''/g;
var $a0e1d0f2de80122b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $a0e1d0f2de80122b$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $iswne.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $6fzT5.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $9oc0q.default);
    var firstWeekContainsDate = (0, $gnXng.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $gnXng.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $eSkdO.default)(dirtyDate);
    if (!(0, $jErRN.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $acufH.default)(originalDate);
    var utcDate = (0, $aTXeq.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($a0e1d0f2de80122b$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $kFnkg.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($a0e1d0f2de80122b$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $a0e1d0f2de80122b$var$cleanEscapedString(substring);
        var formatter = (0, $hbQ65.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $fzwAn.isProtectedWeekYearToken)(substring)) (0, $fzwAn.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $fzwAn.isProtectedDayOfYearToken)(substring)) (0, $fzwAn.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($a0e1d0f2de80122b$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $a0e1d0f2de80122b$var$cleanEscapedString(input) {
    var matched = input.match($a0e1d0f2de80122b$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($a0e1d0f2de80122b$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("jErRN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4e75e7f0f542124$export$2e2bcd8739ae039; });

var $jXLUk = parcelRequire("jXLUk");

var $eSkdO = parcelRequire("eSkdO");

var $iswne = parcelRequire("iswne");
function $e4e75e7f0f542124$export$2e2bcd8739ae039(dirtyDate) {
    (0, $iswne.default)(1, arguments);
    if (!(0, $jXLUk.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $eSkdO.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("jXLUk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e888b076df638656$export$2e2bcd8739ae039; });

var $fVa7p = parcelRequire("fVa7p");

var $iswne = parcelRequire("iswne");
function $e888b076df638656$export$2e2bcd8739ae039(value) {
    (0, $iswne.default)(1, arguments);
    return value instanceof Date || (0, $fVa7p.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});
parcelRegister("fVa7p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b97407360a5cbf3c$export$2e2bcd8739ae039; });
function $b97407360a5cbf3c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b97407360a5cbf3c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b97407360a5cbf3c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("iswne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d703f44426e8ed16$export$2e2bcd8739ae039; });
function $d703f44426e8ed16$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("eSkdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02cb72c3e6f37463$export$2e2bcd8739ae039; });

var $fVa7p = parcelRequire("fVa7p");

var $iswne = parcelRequire("iswne");
function $02cb72c3e6f37463$export$2e2bcd8739ae039(argument) {
    (0, $iswne.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $fVa7p.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("aTXeq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7efcfc9db18fd644$export$2e2bcd8739ae039; });

var $dSmmY = parcelRequire("dSmmY");

var $iswne = parcelRequire("iswne");

var $gnXng = parcelRequire("gnXng");
function $7efcfc9db18fd644$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $iswne.default)(2, arguments);
    var amount = (0, $gnXng.default)(dirtyAmount);
    return (0, $dSmmY.default)(dirtyDate, -amount);
}

});
parcelRegister("dSmmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1a1ab9ff0f5bcab$export$2e2bcd8739ae039; });

var $gnXng = parcelRequire("gnXng");

var $eSkdO = parcelRequire("eSkdO");

var $iswne = parcelRequire("iswne");
function $a1a1ab9ff0f5bcab$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $iswne.default)(2, arguments);
    var timestamp = (0, $eSkdO.default)(dirtyDate).getTime();
    var amount = (0, $gnXng.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("gnXng", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bedcd9c952c70e8f$export$2e2bcd8739ae039; });
function $bedcd9c952c70e8f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("hbQ65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c83be02c9de95abe$export$2e2bcd8739ae039; });

var $bMnug = parcelRequire("bMnug");

var $4iZZm = parcelRequire("4iZZm");

var $efIik = parcelRequire("efIik");

var $cxCjz = parcelRequire("cxCjz");

var $3xxHk = parcelRequire("3xxHk");

var $iTdUv = parcelRequire("iTdUv");

var $5VIMf = parcelRequire("5VIMf");
var $c83be02c9de95abe$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $c83be02c9de95abe$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $5VIMf.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $3xxHk.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $iTdUv.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $iTdUv.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $efIik.default)(date);
        // Padding
        return (0, $iTdUv.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $iTdUv.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $iTdUv.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $iTdUv.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $5VIMf.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $iTdUv.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $cxCjz.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $iTdUv.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $4iZZm.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $iTdUv.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $5VIMf.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $bMnug.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $iTdUv.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $iTdUv.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $iTdUv.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $iTdUv.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $c83be02c9de95abe$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $c83be02c9de95abe$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $c83be02c9de95abe$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $c83be02c9de95abe$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $c83be02c9de95abe$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $c83be02c9de95abe$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $5VIMf.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $5VIMf.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $iTdUv.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $iTdUv.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $5VIMf.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $5VIMf.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $5VIMf.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $c83be02c9de95abe$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $c83be02c9de95abe$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $c83be02c9de95abe$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $c83be02c9de95abe$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $c83be02c9de95abe$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $c83be02c9de95abe$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $c83be02c9de95abe$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $c83be02c9de95abe$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $c83be02c9de95abe$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $c83be02c9de95abe$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $iTdUv.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $iTdUv.default)(timestamp, token.length);
    }
};
function $c83be02c9de95abe$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $iTdUv.default)(minutes, 2);
}
function $c83be02c9de95abe$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $iTdUv.default)(Math.abs(offset) / 60, 2);
    }
    return $c83be02c9de95abe$var$formatTimezone(offset, dirtyDelimiter);
}
function $c83be02c9de95abe$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $iTdUv.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $iTdUv.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $c83be02c9de95abe$export$2e2bcd8739ae039 = $c83be02c9de95abe$var$formatters;

});
parcelRegister("bMnug", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89366575dbf853ac$export$2e2bcd8739ae039; });

var $eSkdO = parcelRequire("eSkdO");

var $iswne = parcelRequire("iswne");
var $89366575dbf853ac$var$MILLISECONDS_IN_DAY = 86400000;
function $89366575dbf853ac$export$2e2bcd8739ae039(dirtyDate) {
    (0, $iswne.default)(1, arguments);
    var date = (0, $eSkdO.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $89366575dbf853ac$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("4iZZm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3228ed8c59babeeb$export$2e2bcd8739ae039; });

var $eSkdO = parcelRequire("eSkdO");

var $g8CZL = parcelRequire("g8CZL");

var $8srCC = parcelRequire("8srCC");

var $iswne = parcelRequire("iswne");
var $3228ed8c59babeeb$var$MILLISECONDS_IN_WEEK = 604800000;
function $3228ed8c59babeeb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $iswne.default)(1, arguments);
    var date = (0, $eSkdO.default)(dirtyDate);
    var diff = (0, $g8CZL.default)(date).getTime() - (0, $8srCC.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $3228ed8c59babeeb$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("g8CZL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbfba4551a1ec3f2$export$2e2bcd8739ae039; });

var $eSkdO = parcelRequire("eSkdO");

var $iswne = parcelRequire("iswne");
function $bbfba4551a1ec3f2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $iswne.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $eSkdO.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("8srCC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62865d5fe341469f$export$2e2bcd8739ae039; });

var $efIik = parcelRequire("efIik");

var $g8CZL = parcelRequire("g8CZL");

var $iswne = parcelRequire("iswne");
function $62865d5fe341469f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $iswne.default)(1, arguments);
    var year = (0, $efIik.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $g8CZL.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("efIik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a604d3691e67f8ba$export$2e2bcd8739ae039; });

var $eSkdO = parcelRequire("eSkdO");

var $iswne = parcelRequire("iswne");

var $g8CZL = parcelRequire("g8CZL");
function $a604d3691e67f8ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $iswne.default)(1, arguments);
    var date = (0, $eSkdO.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $g8CZL.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $g8CZL.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("cxCjz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92164998f328c09d$export$2e2bcd8739ae039; });

var $eSkdO = parcelRequire("eSkdO");

var $ev6tk = parcelRequire("ev6tk");

var $ekDGM = parcelRequire("ekDGM");

var $iswne = parcelRequire("iswne");
var $92164998f328c09d$var$MILLISECONDS_IN_WEEK = 604800000;
function $92164998f328c09d$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $iswne.default)(1, arguments);
    var date = (0, $eSkdO.default)(dirtyDate);
    var diff = (0, $ev6tk.default)(date, options).getTime() - (0, $ekDGM.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $92164998f328c09d$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("ev6tk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e8fb210d83cb1d$export$2e2bcd8739ae039; });

var $eSkdO = parcelRequire("eSkdO");

var $iswne = parcelRequire("iswne");

var $gnXng = parcelRequire("gnXng");

var $6fzT5 = parcelRequire("6fzT5");
function $a8e8fb210d83cb1d$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $iswne.default)(1, arguments);
    var defaultOptions = (0, $6fzT5.getDefaultOptions)();
    var weekStartsOn = (0, $gnXng.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $eSkdO.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("6fzT5", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $48cffb4a71204a3c$export$430a3269e24b912e; });
var $48cffb4a71204a3c$var$defaultOptions = {};
function $48cffb4a71204a3c$export$430a3269e24b912e() {
    return $48cffb4a71204a3c$var$defaultOptions;
}
function $48cffb4a71204a3c$export$95365be1b0704abc(newOptions) {
    $48cffb4a71204a3c$var$defaultOptions = newOptions;
}

});


parcelRegister("ekDGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6f1b85fd04c73a6$export$2e2bcd8739ae039; });

var $3xxHk = parcelRequire("3xxHk");

var $iswne = parcelRequire("iswne");

var $ev6tk = parcelRequire("ev6tk");

var $gnXng = parcelRequire("gnXng");

var $6fzT5 = parcelRequire("6fzT5");
function $a6f1b85fd04c73a6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $iswne.default)(1, arguments);
    var defaultOptions = (0, $6fzT5.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gnXng.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $3xxHk.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $ev6tk.default)(firstWeek, options);
    return date;
}

});
parcelRegister("3xxHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $293e97dba969d784$export$2e2bcd8739ae039; });

var $eSkdO = parcelRequire("eSkdO");

var $iswne = parcelRequire("iswne");

var $ev6tk = parcelRequire("ev6tk");

var $gnXng = parcelRequire("gnXng");

var $6fzT5 = parcelRequire("6fzT5");
function $293e97dba969d784$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $iswne.default)(1, arguments);
    var date = (0, $eSkdO.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $6fzT5.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gnXng.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $ev6tk.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $ev6tk.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("iTdUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc08276101761363$export$2e2bcd8739ae039; });
function $dc08276101761363$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("5VIMf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4515027642801dbe$export$2e2bcd8739ae039; });

var $iTdUv = parcelRequire("iTdUv");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $4515027642801dbe$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $iTdUv.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $iTdUv.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $iTdUv.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $iTdUv.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $iTdUv.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $iTdUv.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $iTdUv.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $iTdUv.default)(fractionalSeconds, token.length);
    }
};
var $4515027642801dbe$export$2e2bcd8739ae039 = $4515027642801dbe$var$formatters;

});


parcelRegister("kFnkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0b9bb0683595ebc$export$2e2bcd8739ae039; });
var $f0b9bb0683595ebc$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $f0b9bb0683595ebc$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $f0b9bb0683595ebc$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $f0b9bb0683595ebc$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $f0b9bb0683595ebc$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $f0b9bb0683595ebc$var$timeLongFormatter(timePattern, formatLong));
};
var $f0b9bb0683595ebc$var$longFormatters = {
    p: $f0b9bb0683595ebc$var$timeLongFormatter,
    P: $f0b9bb0683595ebc$var$dateTimeLongFormatter
};
var $f0b9bb0683595ebc$export$2e2bcd8739ae039 = $f0b9bb0683595ebc$var$longFormatters;

});

parcelRegister("acufH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76d27dd8c69f66fe$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $76d27dd8c69f66fe$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("fzwAn", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $b56366c1736c3f4e$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $b56366c1736c3f4e$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $b56366c1736c3f4e$export$8073c1ae88f0e727; });
var $b56366c1736c3f4e$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $b56366c1736c3f4e$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $b56366c1736c3f4e$export$c6cc36aa33304772(token) {
    return $b56366c1736c3f4e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $b56366c1736c3f4e$export$c6b49d6dceb604a1(token) {
    return $b56366c1736c3f4e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $b56366c1736c3f4e$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("9oc0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d5fab0986f315bb$export$2e2bcd8739ae039; });

var $5Y9ck = parcelRequire("5Y9ck");
var $6d5fab0986f315bb$export$2e2bcd8739ae039 = (0, $5Y9ck.default);

});
parcelRegister("5Y9ck", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4589b0d9b3029edd$export$2e2bcd8739ae039; });

var $lxRzP = parcelRequire("lxRzP");

var $cUH8C = parcelRequire("cUH8C");

var $buOMC = parcelRequire("buOMC");

var $g6K0T = parcelRequire("g6K0T");

var $1koh2 = parcelRequire("1koh2");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $4589b0d9b3029edd$var$locale = {
    code: 'en-US',
    formatDistance: (0, $lxRzP.default),
    formatLong: (0, $cUH8C.default),
    formatRelative: (0, $buOMC.default),
    localize: (0, $g6K0T.default),
    match: (0, $1koh2.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $4589b0d9b3029edd$export$2e2bcd8739ae039 = $4589b0d9b3029edd$var$locale;

});
parcelRegister("lxRzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faf63d46ff5a017b$export$2e2bcd8739ae039; });
var $faf63d46ff5a017b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $faf63d46ff5a017b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $faf63d46ff5a017b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $faf63d46ff5a017b$export$2e2bcd8739ae039 = $faf63d46ff5a017b$var$formatDistance;

});

parcelRegister("cUH8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $966c2d51f2dcbfc1$export$2e2bcd8739ae039; });

var $epRDS = parcelRequire("epRDS");
var $966c2d51f2dcbfc1$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $966c2d51f2dcbfc1$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $966c2d51f2dcbfc1$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $966c2d51f2dcbfc1$var$formatLong = {
    date: (0, $epRDS.default)({
        formats: $966c2d51f2dcbfc1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $epRDS.default)({
        formats: $966c2d51f2dcbfc1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $epRDS.default)({
        formats: $966c2d51f2dcbfc1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $966c2d51f2dcbfc1$export$2e2bcd8739ae039 = $966c2d51f2dcbfc1$var$formatLong;

});
parcelRegister("epRDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7ed02b30a280f9d$export$2e2bcd8739ae039; });
function $a7ed02b30a280f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("buOMC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85e9e3889b828c30$export$2e2bcd8739ae039; });
var $85e9e3889b828c30$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $85e9e3889b828c30$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $85e9e3889b828c30$var$formatRelativeLocale[token];
};
var $85e9e3889b828c30$export$2e2bcd8739ae039 = $85e9e3889b828c30$var$formatRelative;

});

parcelRegister("g6K0T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bba0e634ad91e229$export$2e2bcd8739ae039; });

var $ib7mH = parcelRequire("ib7mH");
var $bba0e634ad91e229$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $bba0e634ad91e229$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $bba0e634ad91e229$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $bba0e634ad91e229$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $bba0e634ad91e229$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $bba0e634ad91e229$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $bba0e634ad91e229$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $bba0e634ad91e229$var$localize = {
    ordinalNumber: $bba0e634ad91e229$var$ordinalNumber,
    era: (0, $ib7mH.default)({
        values: $bba0e634ad91e229$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $ib7mH.default)({
        values: $bba0e634ad91e229$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $ib7mH.default)({
        values: $bba0e634ad91e229$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $ib7mH.default)({
        values: $bba0e634ad91e229$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $ib7mH.default)({
        values: $bba0e634ad91e229$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $bba0e634ad91e229$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $bba0e634ad91e229$export$2e2bcd8739ae039 = $bba0e634ad91e229$var$localize;

});
parcelRegister("ib7mH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $036a4e5126a0437a$export$2e2bcd8739ae039; });
function $036a4e5126a0437a$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("1koh2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f7a7cf3269179bf$export$2e2bcd8739ae039; });

var $a9Dq8 = parcelRequire("a9Dq8");

var $7LyqM = parcelRequire("7LyqM");
var $0f7a7cf3269179bf$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $0f7a7cf3269179bf$var$parseOrdinalNumberPattern = /\d+/i;
var $0f7a7cf3269179bf$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $0f7a7cf3269179bf$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $0f7a7cf3269179bf$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $0f7a7cf3269179bf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0f7a7cf3269179bf$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $0f7a7cf3269179bf$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $0f7a7cf3269179bf$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $0f7a7cf3269179bf$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $0f7a7cf3269179bf$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $0f7a7cf3269179bf$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $0f7a7cf3269179bf$var$match = {
    ordinalNumber: (0, $7LyqM.default)({
        matchPattern: $0f7a7cf3269179bf$var$matchOrdinalNumberPattern,
        parsePattern: $0f7a7cf3269179bf$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $a9Dq8.default)({
        matchPatterns: $0f7a7cf3269179bf$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f7a7cf3269179bf$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $a9Dq8.default)({
        matchPatterns: $0f7a7cf3269179bf$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f7a7cf3269179bf$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $a9Dq8.default)({
        matchPatterns: $0f7a7cf3269179bf$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f7a7cf3269179bf$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $a9Dq8.default)({
        matchPatterns: $0f7a7cf3269179bf$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f7a7cf3269179bf$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $a9Dq8.default)({
        matchPatterns: $0f7a7cf3269179bf$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0f7a7cf3269179bf$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0f7a7cf3269179bf$export$2e2bcd8739ae039 = $0f7a7cf3269179bf$var$match;

});
parcelRegister("a9Dq8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $764952bf4353fed2$export$2e2bcd8739ae039; });
function $764952bf4353fed2$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $764952bf4353fed2$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $764952bf4353fed2$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $764952bf4353fed2$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $764952bf4353fed2$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("7LyqM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a77a1769ca72946$export$2e2bcd8739ae039; });
function $5a77a1769ca72946$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("i9kaL", function(module, exports) {
"use strict";
var $d368b71da9de7332$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d368b71da9de7332$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d368b71da9de7332$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d368b71da9de7332$var$__createBinding(result, mod, k);
    }
    $d368b71da9de7332$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestartProcess = void 0;

const $d368b71da9de7332$var$Rx = $d368b71da9de7332$var$__importStar((parcelRequire("7fhTn")));

var $2wRUS = parcelRequire("2wRUS");

const $d368b71da9de7332$var$defaults = $d368b71da9de7332$var$__importStar((parcelRequire("lLL3u")));
/**
 * Restarts commands that fail up to a defined number of times.
 */ class $d368b71da9de7332$var$RestartProcess {
    constructor({ delay: delay, tries: tries, logger: logger, scheduler: scheduler }){
        this.logger = logger;
        this.delay = delay != null ? +delay : $d368b71da9de7332$var$defaults.restartDelay;
        this.tries = tries != null ? +tries : $d368b71da9de7332$var$defaults.restartTries;
        this.tries = this.tries < 0 ? Infinity : this.tries;
        this.scheduler = scheduler;
    }
    handle(commands) {
        if (this.tries === 0) return {
            commands: commands
        };
        commands.map((command)=>command.close.pipe((0, $2wRUS.take)(this.tries), (0, $2wRUS.takeWhile)(({ exitCode: exitCode })=>exitCode !== 0))).map((failure, index)=>$d368b71da9de7332$var$Rx.merge(// Delay the emission (so that the restarts happen on time),
            // explicitly telling the subscriber that a restart is needed
            failure.pipe((0, $2wRUS.delay)(this.delay, this.scheduler), (0, $2wRUS.mapTo)(true)), // Skip the first N emissions (as these would be duplicates of the above),
            // meaning it will be empty because of success, or failed all N times,
            // and no more restarts should be attempted.
            failure.pipe((0, $2wRUS.skip)(this.tries), (0, $2wRUS.mapTo)(false), (0, $2wRUS.defaultIfEmpty)(false))).subscribe((restart)=>{
                const command = commands[index];
                if (restart) {
                    this.logger.logCommandEvent(`${command.command} restarted`, command);
                    command.start();
                }
            }));
        return {
            commands: commands.map((command)=>{
                const closeStream = command.close.pipe((0, $2wRUS.filter)(({ exitCode: exitCode }, emission)=>{
                    // We let all success codes pass, and failures only after restarting won't happen again
                    return exitCode === 0 || emission >= this.tries;
                }));
                return new Proxy(command, {
                    get (target, prop) {
                        return prop === 'close' ? closeStream : target[prop];
                    }
                });
            })
        };
    }
}
module.exports.RestartProcess = $d368b71da9de7332$var$RestartProcess;

});

parcelRegister("l7Xin", function(module, exports) {
"use strict";
var $f6183f3e3dc5500c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f6183f3e3dc5500c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f6183f3e3dc5500c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f6183f3e3dc5500c$var$__createBinding(result, mod, k);
    }
    $f6183f3e3dc5500c$var$__setModuleDefault(result, mod);
    return result;
};
var $f6183f3e3dc5500c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

const $f6183f3e3dc5500c$var$chalk_1 = $f6183f3e3dc5500c$var$__importDefault((parcelRequire("lyF3d")));

const $f6183f3e3dc5500c$var$format_1 = $f6183f3e3dc5500c$var$__importDefault((parcelRequire("dOn2u")));

const $f6183f3e3dc5500c$var$lodash_1 = $f6183f3e3dc5500c$var$__importDefault((parcelRequire("2m7Ys")));

const $f6183f3e3dc5500c$var$Rx = $f6183f3e3dc5500c$var$__importStar((parcelRequire("7fhTn")));

const $f6183f3e3dc5500c$var$defaults = $f6183f3e3dc5500c$var$__importStar((parcelRequire("lLL3u")));
class $f6183f3e3dc5500c$var$Logger {
    constructor({ hide: hide, prefixFormat: prefixFormat, prefixLength: prefixLength, raw: raw = false, timestampFormat: timestampFormat }){
        /**
         * Observable that emits when there's been output logged.
         * If `command` is is `undefined`, then the log is for a global event.
         */ this.output = new $f6183f3e3dc5500c$var$Rx.Subject();
        // To avoid empty strings from hiding the output of commands that don't have a name,
        // keep in the list of commands to hide only strings with some length.
        // This might happen through the CLI when no `--hide` argument is specified, for example.
        this.hide = $f6183f3e3dc5500c$var$lodash_1.default.castArray(hide).filter((name)=>name || name === 0).map(String);
        this.raw = raw;
        this.prefixFormat = prefixFormat;
        this.prefixLength = prefixLength || $f6183f3e3dc5500c$var$defaults.prefixLength;
        this.timestampFormat = timestampFormat || $f6183f3e3dc5500c$var$defaults.timestampFormat;
    }
    shortenText(text) {
        if (!text || text.length <= this.prefixLength) return text;
        const ellipsis = '..';
        const prefixLength = this.prefixLength - ellipsis.length;
        const endLength = Math.floor(prefixLength / 2);
        const beginningLength = prefixLength - endLength;
        const beginnning = text.slice(0, beginningLength);
        const end = text.slice(text.length - endLength, text.length);
        return beginnning + ellipsis + end;
    }
    getPrefixesFor(command) {
        return {
            pid: String(command.pid),
            index: String(command.index),
            name: command.name,
            command: this.shortenText(command.command),
            time: (0, $f6183f3e3dc5500c$var$format_1.default)(Date.now(), this.timestampFormat)
        };
    }
    getPrefix(command) {
        const prefix = this.prefixFormat || (command.name ? 'name' : 'index');
        if (prefix === 'none') return '';
        const prefixes = this.getPrefixesFor(command);
        if (Object.keys(prefixes).includes(prefix)) return `[${prefixes[prefix]}]`;
        return $f6183f3e3dc5500c$var$lodash_1.default.reduce(prefixes, (prev, val, key)=>{
            const keyRegex = new RegExp($f6183f3e3dc5500c$var$lodash_1.default.escapeRegExp(`{${key}}`), 'g');
            return prev.replace(keyRegex, String(val));
        }, prefix);
    }
    colorText(command, text) {
        var _a;
        let color;
        if (command.prefixColor && command.prefixColor.startsWith('#')) color = $f6183f3e3dc5500c$var$chalk_1.default.hex(command.prefixColor);
        else {
            const defaultColor = $f6183f3e3dc5500c$var$lodash_1.default.get($f6183f3e3dc5500c$var$chalk_1.default, $f6183f3e3dc5500c$var$defaults.prefixColors, $f6183f3e3dc5500c$var$chalk_1.default.reset);
            color = $f6183f3e3dc5500c$var$lodash_1.default.get($f6183f3e3dc5500c$var$chalk_1.default, (_a = command.prefixColor) !== null && _a !== void 0 ? _a : '', defaultColor);
        }
        return color(text);
    }
    /**
     * Logs an event for a command (e.g. start, stop).
     *
     * If raw mode is on, then nothing is logged.
     */ logCommandEvent(text, command) {
        if (this.raw) return;
        this.logCommandText($f6183f3e3dc5500c$var$chalk_1.default.reset(text) + '\n', command);
    }
    logCommandText(text, command) {
        if (this.hide.includes(String(command.index)) || this.hide.includes(command.name)) return;
        const prefix = this.colorText(command, this.getPrefix(command));
        return this.log(prefix + (prefix ? ' ' : ''), text, command);
    }
    /**
     * Logs a global event (e.g. sending signals to processes).
     *
     * If raw mode is on, then nothing is logged.
     */ logGlobalEvent(text) {
        if (this.raw) return;
        this.log($f6183f3e3dc5500c$var$chalk_1.default.reset('-->') + ' ', $f6183f3e3dc5500c$var$chalk_1.default.reset(text) + '\n');
    }
    /**
     * Logs a table from an input object array, like `console.table`.
     *
     * Each row is a single input item, and they are presented in the input order.
     */ logTable(tableContents) {
        // For now, can only print array tables with some content.
        if (this.raw || !Array.isArray(tableContents) || !tableContents.length) return;
        let nextColIndex = 0;
        const headers = {};
        const contentRows = tableContents.map((row)=>{
            const rowContents = [];
            Object.keys(row).forEach((col)=>{
                if (!headers[col]) headers[col] = {
                    index: nextColIndex++,
                    length: col.length
                };
                const colIndex = headers[col].index;
                const formattedValue = String(row[col] == null ? '' : row[col]);
                // Update the column length in case this rows value is longer than the previous length for the column.
                headers[col].length = Math.max(formattedValue.length, headers[col].length);
                rowContents[colIndex] = formattedValue;
                return rowContents;
            });
            return rowContents;
        });
        const headersFormatted = Object.keys(headers).map((header)=>header.padEnd(headers[header].length, ' '));
        if (!headersFormatted.length) // No columns exist.
        return;
        const borderRowFormatted = headersFormatted.map((header)=>"\u2500".padEnd(header.length, "\u2500"));
        this.logGlobalEvent(`\u{250C}\u{2500}${borderRowFormatted.join("\u2500\u252C\u2500")}\u{2500}\u{2510}`);
        this.logGlobalEvent(`\u{2502} ${headersFormatted.join(" \u2502 ")} \u{2502}`);
        this.logGlobalEvent(`\u{251C}\u{2500}${borderRowFormatted.join("\u2500\u253C\u2500")}\u{2500}\u{2524}`);
        contentRows.forEach((contentRow)=>{
            const contentRowFormatted = headersFormatted.map((header, colIndex)=>{
                // If the table was expanded after this row was processed, it won't have this column.
                // Use an empty string in this case.
                const col = contentRow[colIndex] || '';
                return col.padEnd(header.length, ' ');
            });
            this.logGlobalEvent(`\u{2502} ${contentRowFormatted.join(" \u2502 ")} \u{2502}`);
        });
        this.logGlobalEvent(`\u{2514}\u{2500}${borderRowFormatted.join("\u2500\u2534\u2500")}\u{2500}\u{2518}`);
    }
    log(prefix, text, command) {
        if (this.raw) return this.emit(command, text);
        // #70 - replace some ANSI code that would impact clearing lines
        text = text.replace(/\u2026/g, '...');
        const lines = text.split('\n').map((line, index, lines)=>{
            // First line will write prefix only if we finished the last write with a LF.
            // Last line won't write prefix because it should be empty.
            if (index === 0 || index === lines.length - 1) return line;
            return prefix + line;
        });
        if (!this.lastChar || this.lastChar === '\n') this.emit(command, prefix);
        this.lastChar = text[text.length - 1];
        this.emit(command, lines.join('\n'));
    }
    emit(command, text) {
        this.output.next({
            command: command,
            text: text
        });
    }
}
module.exports.Logger = $f6183f3e3dc5500c$var$Logger;

});
parcelRegister("lyF3d", function(module, exports) {
'use strict';

var $aizT8 = parcelRequire("aizT8");

var $epveV = parcelRequire("epveV");
var $fb1c9dcbd100ff40$require$stdoutColor = $epveV.stdout;
var $fb1c9dcbd100ff40$require$stderrColor = $epveV.stderr;

var $hHT3c = parcelRequire("hHT3c");
var $fb1c9dcbd100ff40$require$stringReplaceAll = $hHT3c.stringReplaceAll;
var $fb1c9dcbd100ff40$require$stringEncaseCRLFWithFirstIndex = $hHT3c.stringEncaseCRLFWithFirstIndex;
const { isArray: $fb1c9dcbd100ff40$var$isArray } = Array;
// `supportsColor.level` → `ansiStyles.color[name]` mapping
const $fb1c9dcbd100ff40$var$levelMapping = [
    'ansi',
    'ansi',
    'ansi256',
    'ansi16m'
];
const $fb1c9dcbd100ff40$var$styles = Object.create(null);
const $fb1c9dcbd100ff40$var$applyOptions = (object, options = {})=>{
    if (options.level && !(Number.isInteger(options.level) && options.level >= 0 && options.level <= 3)) throw new Error('The `level` option should be an integer from 0 to 3');
    // Detect level if not set manually
    const colorLevel = $fb1c9dcbd100ff40$require$stdoutColor ? $fb1c9dcbd100ff40$require$stdoutColor.level : 0;
    object.level = options.level === undefined ? colorLevel : options.level;
};
class $fb1c9dcbd100ff40$var$ChalkClass {
    constructor(options){
        // eslint-disable-next-line no-constructor-return
        return $fb1c9dcbd100ff40$var$chalkFactory(options);
    }
}
const $fb1c9dcbd100ff40$var$chalkFactory = (options)=>{
    const chalk = {};
    $fb1c9dcbd100ff40$var$applyOptions(chalk, options);
    chalk.template = (...arguments_)=>$fb1c9dcbd100ff40$var$chalkTag(chalk.template, ...arguments_);
    Object.setPrototypeOf(chalk, $fb1c9dcbd100ff40$var$Chalk.prototype);
    Object.setPrototypeOf(chalk.template, chalk);
    chalk.template.constructor = ()=>{
        throw new Error('`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead.');
    };
    chalk.template.Instance = $fb1c9dcbd100ff40$var$ChalkClass;
    return chalk.template;
};
function $fb1c9dcbd100ff40$var$Chalk(options) {
    return $fb1c9dcbd100ff40$var$chalkFactory(options);
}
for (const [styleName, style] of Object.entries($aizT8))$fb1c9dcbd100ff40$var$styles[styleName] = {
    get () {
        const builder = $fb1c9dcbd100ff40$var$createBuilder(this, $fb1c9dcbd100ff40$var$createStyler(style.open, style.close, this._styler), this._isEmpty);
        Object.defineProperty(this, styleName, {
            value: builder
        });
        return builder;
    }
};
$fb1c9dcbd100ff40$var$styles.visible = {
    get () {
        const builder = $fb1c9dcbd100ff40$var$createBuilder(this, this._styler, true);
        Object.defineProperty(this, 'visible', {
            value: builder
        });
        return builder;
    }
};
const $fb1c9dcbd100ff40$var$usedModels = [
    'rgb',
    'hex',
    'keyword',
    'hsl',
    'hsv',
    'hwb',
    'ansi',
    'ansi256'
];
for (const model of $fb1c9dcbd100ff40$var$usedModels)$fb1c9dcbd100ff40$var$styles[model] = {
    get () {
        const { level: level } = this;
        return function(...arguments_) {
            const styler = $fb1c9dcbd100ff40$var$createStyler($aizT8.color[$fb1c9dcbd100ff40$var$levelMapping[level]][model](...arguments_), $aizT8.color.close, this._styler);
            return $fb1c9dcbd100ff40$var$createBuilder(this, styler, this._isEmpty);
        };
    }
};
for (const model of $fb1c9dcbd100ff40$var$usedModels){
    const bgModel = 'bg' + model[0].toUpperCase() + model.slice(1);
    $fb1c9dcbd100ff40$var$styles[bgModel] = {
        get () {
            const { level: level } = this;
            return function(...arguments_) {
                const styler = $fb1c9dcbd100ff40$var$createStyler($aizT8.bgColor[$fb1c9dcbd100ff40$var$levelMapping[level]][model](...arguments_), $aizT8.bgColor.close, this._styler);
                return $fb1c9dcbd100ff40$var$createBuilder(this, styler, this._isEmpty);
            };
        }
    };
}
const $fb1c9dcbd100ff40$var$proto = Object.defineProperties(()=>{}, {
    ...$fb1c9dcbd100ff40$var$styles,
    level: {
        enumerable: true,
        get () {
            return this._generator.level;
        },
        set (level) {
            this._generator.level = level;
        }
    }
});
const $fb1c9dcbd100ff40$var$createStyler = (open, close, parent)=>{
    let openAll;
    let closeAll;
    if (parent === undefined) {
        openAll = open;
        closeAll = close;
    } else {
        openAll = parent.openAll + open;
        closeAll = close + parent.closeAll;
    }
    return {
        open: open,
        close: close,
        openAll: openAll,
        closeAll: closeAll,
        parent: parent
    };
};
const $fb1c9dcbd100ff40$var$createBuilder = (self, _styler, _isEmpty)=>{
    const builder = (...arguments_)=>{
        if ($fb1c9dcbd100ff40$var$isArray(arguments_[0]) && $fb1c9dcbd100ff40$var$isArray(arguments_[0].raw)) // Called as a template literal, for example: chalk.red`2 + 3 = {bold ${2+3}}`
        return $fb1c9dcbd100ff40$var$applyStyle(builder, $fb1c9dcbd100ff40$var$chalkTag(builder, ...arguments_));
        // Single argument is hot path, implicit coercion is faster than anything
        // eslint-disable-next-line no-implicit-coercion
        return $fb1c9dcbd100ff40$var$applyStyle(builder, arguments_.length === 1 ? '' + arguments_[0] : arguments_.join(' '));
    };
    // We alter the prototype because we must return a function, but there is
    // no way to create a function with a different prototype
    Object.setPrototypeOf(builder, $fb1c9dcbd100ff40$var$proto);
    builder._generator = self;
    builder._styler = _styler;
    builder._isEmpty = _isEmpty;
    return builder;
};
const $fb1c9dcbd100ff40$var$applyStyle = (self, string)=>{
    if (self.level <= 0 || !string) return self._isEmpty ? '' : string;
    let styler = self._styler;
    if (styler === undefined) return string;
    const { openAll: openAll, closeAll: closeAll } = styler;
    if (string.indexOf('\u001B') !== -1) while(styler !== undefined){
        // Replace any instances already present with a re-opening code
        // otherwise only the part of the string until said closing code
        // will be colored, and the rest will simply be 'plain'.
        string = $fb1c9dcbd100ff40$require$stringReplaceAll(string, styler.close, styler.open);
        styler = styler.parent;
    }
    // We can move both next actions out of loop, because remaining actions in loop won't have
    // any/visible effect on parts we add here. Close the styling before a linebreak and reopen
    // after next line to fix a bleed issue on macOS: https://github.com/chalk/chalk/pull/92
    const lfIndex = string.indexOf('\n');
    if (lfIndex !== -1) string = $fb1c9dcbd100ff40$require$stringEncaseCRLFWithFirstIndex(string, closeAll, openAll, lfIndex);
    return openAll + string + closeAll;
};
let $fb1c9dcbd100ff40$var$template;

const $fb1c9dcbd100ff40$var$chalkTag = (chalk, ...strings)=>{
    const [firstString] = strings;
    if (!$fb1c9dcbd100ff40$var$isArray(firstString) || !$fb1c9dcbd100ff40$var$isArray(firstString.raw)) // If chalk() was called by itself or with a string,
    // return the string itself as a string.
    return strings.join(' ');
    const arguments_ = strings.slice(1);
    const parts = [
        firstString.raw[0]
    ];
    for(let i = 1; i < firstString.length; i++)parts.push(String(arguments_[i - 1]).replace(/[{}\\]/g, '\\$&'), String(firstString.raw[i]));
    if ($fb1c9dcbd100ff40$var$template === undefined) $fb1c9dcbd100ff40$var$template = (parcelRequire("j1O1i"));
    return $fb1c9dcbd100ff40$var$template(chalk, parts.join(''));
};
Object.defineProperties($fb1c9dcbd100ff40$var$Chalk.prototype, $fb1c9dcbd100ff40$var$styles);
const $fb1c9dcbd100ff40$var$chalk = $fb1c9dcbd100ff40$var$Chalk(); // eslint-disable-line new-cap
$fb1c9dcbd100ff40$var$chalk.supportsColor = $fb1c9dcbd100ff40$require$stdoutColor;
$fb1c9dcbd100ff40$var$chalk.stderr = $fb1c9dcbd100ff40$var$Chalk({
    level: $fb1c9dcbd100ff40$require$stderrColor ? $fb1c9dcbd100ff40$require$stderrColor.level : 0
}); // eslint-disable-line new-cap
$fb1c9dcbd100ff40$var$chalk.stderr.supportsColor = $fb1c9dcbd100ff40$require$stderrColor;
module.exports = $fb1c9dcbd100ff40$var$chalk;

});
parcelRegister("aizT8", function(module, exports) {
'use strict';
const wrapAnsi16 = (fn, offset)=>(...args)=>{
        const code = fn(...args);
        return `\u001B[${code + offset}m`;
    };
const wrapAnsi256 = (fn, offset)=>(...args)=>{
        const code = fn(...args);
        return `\u001B[${38 + offset};5;${code}m`;
    };
const wrapAnsi16m = (fn, offset)=>(...args)=>{
        const rgb = fn(...args);
        return `\u001B[${38 + offset};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
    };
const ansi2ansi = (n)=>n;
const rgb2rgb = (r, g, b)=>[
        r,
        g,
        b
    ];
const setLazyProperty = (object, property, get)=>{
    Object.defineProperty(object, property, {
        get: ()=>{
            const value = get();
            Object.defineProperty(object, property, {
                value: value,
                enumerable: true,
                configurable: true
            });
            return value;
        },
        enumerable: true,
        configurable: true
    });
};
/** @type {typeof import('color-convert')} */ let colorConvert;

const makeDynamicStyles = (wrap, targetSpace, identity, isBackground)=>{
    if (colorConvert === undefined) colorConvert = (parcelRequire("5e8Fs"));
    const offset = isBackground ? 10 : 0;
    const styles = {};
    for (const [sourceSpace, suite] of Object.entries(colorConvert)){
        const name = sourceSpace === 'ansi16' ? 'ansi' : sourceSpace;
        if (sourceSpace === targetSpace) styles[name] = wrap(identity, offset);
        else if (typeof suite === 'object') styles[name] = wrap(suite[targetSpace], offset);
    }
    return styles;
};
function assembleStyles() {
    const codes = new Map();
    const styles = {
        modifier: {
            reset: [
                0,
                0
            ],
            // 21 isn't widely supported and 22 does the same thing
            bold: [
                1,
                22
            ],
            dim: [
                2,
                22
            ],
            italic: [
                3,
                23
            ],
            underline: [
                4,
                24
            ],
            inverse: [
                7,
                27
            ],
            hidden: [
                8,
                28
            ],
            strikethrough: [
                9,
                29
            ]
        },
        color: {
            black: [
                30,
                39
            ],
            red: [
                31,
                39
            ],
            green: [
                32,
                39
            ],
            yellow: [
                33,
                39
            ],
            blue: [
                34,
                39
            ],
            magenta: [
                35,
                39
            ],
            cyan: [
                36,
                39
            ],
            white: [
                37,
                39
            ],
            // Bright color
            blackBright: [
                90,
                39
            ],
            redBright: [
                91,
                39
            ],
            greenBright: [
                92,
                39
            ],
            yellowBright: [
                93,
                39
            ],
            blueBright: [
                94,
                39
            ],
            magentaBright: [
                95,
                39
            ],
            cyanBright: [
                96,
                39
            ],
            whiteBright: [
                97,
                39
            ]
        },
        bgColor: {
            bgBlack: [
                40,
                49
            ],
            bgRed: [
                41,
                49
            ],
            bgGreen: [
                42,
                49
            ],
            bgYellow: [
                43,
                49
            ],
            bgBlue: [
                44,
                49
            ],
            bgMagenta: [
                45,
                49
            ],
            bgCyan: [
                46,
                49
            ],
            bgWhite: [
                47,
                49
            ],
            // Bright color
            bgBlackBright: [
                100,
                49
            ],
            bgRedBright: [
                101,
                49
            ],
            bgGreenBright: [
                102,
                49
            ],
            bgYellowBright: [
                103,
                49
            ],
            bgBlueBright: [
                104,
                49
            ],
            bgMagentaBright: [
                105,
                49
            ],
            bgCyanBright: [
                106,
                49
            ],
            bgWhiteBright: [
                107,
                49
            ]
        }
    };
    // Alias bright black as gray (and grey)
    styles.color.gray = styles.color.blackBright;
    styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
    styles.color.grey = styles.color.blackBright;
    styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
    for (const [groupName, group] of Object.entries(styles)){
        for (const [styleName, style] of Object.entries(group)){
            styles[styleName] = {
                open: `\u001B[${style[0]}m`,
                close: `\u001B[${style[1]}m`
            };
            group[styleName] = styles[styleName];
            codes.set(style[0], style[1]);
        }
        Object.defineProperty(styles, groupName, {
            value: group,
            enumerable: false
        });
    }
    Object.defineProperty(styles, 'codes', {
        value: codes,
        enumerable: false
    });
    styles.color.close = '\u001B[39m';
    styles.bgColor.close = '\u001B[49m';
    setLazyProperty(styles.color, 'ansi', ()=>makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, false));
    setLazyProperty(styles.color, 'ansi256', ()=>makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, false));
    setLazyProperty(styles.color, 'ansi16m', ()=>makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, false));
    setLazyProperty(styles.bgColor, 'ansi', ()=>makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, true));
    setLazyProperty(styles.bgColor, 'ansi256', ()=>makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, true));
    setLazyProperty(styles.bgColor, 'ansi16m', ()=>makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, true));
    return styles;
}
// Make the export immutable
Object.defineProperty(module, 'exports', {
    enumerable: true,
    get: assembleStyles
});

});
parcelRegister("5e8Fs", function(module, exports) {

var $4X2cG = parcelRequire("4X2cG");

var $AeIL1 = parcelRequire("AeIL1");
const $3ce4fbc24439fe2a$var$convert = {};
const $3ce4fbc24439fe2a$var$models = Object.keys($4X2cG);
function $3ce4fbc24439fe2a$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $3ce4fbc24439fe2a$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$3ce4fbc24439fe2a$var$models.forEach((fromModel)=>{
    $3ce4fbc24439fe2a$var$convert[fromModel] = {};
    Object.defineProperty($3ce4fbc24439fe2a$var$convert[fromModel], 'channels', {
        value: $4X2cG[fromModel].channels
    });
    Object.defineProperty($3ce4fbc24439fe2a$var$convert[fromModel], 'labels', {
        value: $4X2cG[fromModel].labels
    });
    const routes = $AeIL1(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $3ce4fbc24439fe2a$var$convert[fromModel][toModel] = $3ce4fbc24439fe2a$var$wrapRounded(fn);
        $3ce4fbc24439fe2a$var$convert[fromModel][toModel].raw = $3ce4fbc24439fe2a$var$wrapRaw(fn);
    });
});
module.exports = $3ce4fbc24439fe2a$var$convert;

});
parcelRegister("4X2cG", function(module, exports) {
/* MIT license */ /* eslint-disable no-mixed-operators */ 
var $9Tslv = parcelRequire("9Tslv");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $39ae61b1f88a13af$var$reverseKeywords = {};
for (const key of Object.keys($9Tslv))$39ae61b1f88a13af$var$reverseKeywords[$9Tslv[key]] = key;
const $39ae61b1f88a13af$var$convert = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
module.exports = $39ae61b1f88a13af$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($39ae61b1f88a13af$var$convert)){
    if (!('channels' in $39ae61b1f88a13af$var$convert[model])) throw new Error('missing channels property: ' + model);
    if (!('labels' in $39ae61b1f88a13af$var$convert[model])) throw new Error('missing channel labels property: ' + model);
    if ($39ae61b1f88a13af$var$convert[model].labels.length !== $39ae61b1f88a13af$var$convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
    const { channels: channels, labels: labels } = $39ae61b1f88a13af$var$convert[model];
    delete $39ae61b1f88a13af$var$convert[model].channels;
    delete $39ae61b1f88a13af$var$convert[model].labels;
    Object.defineProperty($39ae61b1f88a13af$var$convert[model], 'channels', {
        value: channels
    });
    Object.defineProperty($39ae61b1f88a13af$var$convert[model], 'labels', {
        value: labels
    });
}
$39ae61b1f88a13af$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$39ae61b1f88a13af$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$39ae61b1f88a13af$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $39ae61b1f88a13af$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$39ae61b1f88a13af$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $39ae61b1f88a13af$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$39ae61b1f88a13af$var$convert.rgb.keyword = function(rgb) {
    const reversed = $39ae61b1f88a13af$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($9Tslv)){
        const value = $9Tslv[keyword];
        // Compute comparative distance
        const distance = $39ae61b1f88a13af$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$39ae61b1f88a13af$var$convert.keyword.rgb = function(keyword) {
    return $9Tslv[keyword];
};
$39ae61b1f88a13af$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$39ae61b1f88a13af$var$convert.rgb.lab = function(rgb) {
    const xyz = $39ae61b1f88a13af$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$39ae61b1f88a13af$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$39ae61b1f88a13af$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$39ae61b1f88a13af$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$39ae61b1f88a13af$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$39ae61b1f88a13af$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$39ae61b1f88a13af$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$39ae61b1f88a13af$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$39ae61b1f88a13af$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$39ae61b1f88a13af$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$39ae61b1f88a13af$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$39ae61b1f88a13af$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$39ae61b1f88a13af$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $39ae61b1f88a13af$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$39ae61b1f88a13af$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $39ae61b1f88a13af$var$convert.rgb.ansi16($39ae61b1f88a13af$var$convert.hsv.rgb(args), args[2]);
};
$39ae61b1f88a13af$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$39ae61b1f88a13af$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$39ae61b1f88a13af$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$39ae61b1f88a13af$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$39ae61b1f88a13af$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map((char)=>{
        return char + char;
    }).join('');
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$39ae61b1f88a13af$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$39ae61b1f88a13af$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$39ae61b1f88a13af$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$39ae61b1f88a13af$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$39ae61b1f88a13af$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$39ae61b1f88a13af$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$39ae61b1f88a13af$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$39ae61b1f88a13af$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$39ae61b1f88a13af$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$39ae61b1f88a13af$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$39ae61b1f88a13af$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$39ae61b1f88a13af$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$39ae61b1f88a13af$var$convert.gray.hsv = $39ae61b1f88a13af$var$convert.gray.hsl;
$39ae61b1f88a13af$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$39ae61b1f88a13af$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$39ae61b1f88a13af$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$39ae61b1f88a13af$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$39ae61b1f88a13af$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

});
parcelRegister("9Tslv", function(module, exports) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});


parcelRegister("AeIL1", function(module, exports) {

var $4X2cG = parcelRequire("4X2cG");
/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $06cec82badecde76$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($4X2cG);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $06cec82badecde76$var$deriveBFS(fromModel) {
    const graph = $06cec82badecde76$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($4X2cG[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $06cec82badecde76$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $06cec82badecde76$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $4X2cG[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $06cec82badecde76$var$link($4X2cG[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    const graph = $06cec82badecde76$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $06cec82badecde76$var$wrapConversion(toModel, graph);
    }
    return conversion;
};

});



parcelRegister("epveV", function(module, exports) {
'use strict';
module.exports = {
    stdout: false,
    stderr: false
};

});

parcelRegister("hHT3c", function(module, exports) {
'use strict';
const $ce4127bcbd04b06b$var$stringReplaceAll = (string, substring, replacer)=>{
    let index = string.indexOf(substring);
    if (index === -1) return string;
    const substringLength = substring.length;
    let endIndex = 0;
    let returnValue = '';
    do {
        returnValue += string.substr(endIndex, index - endIndex) + substring + replacer;
        endIndex = index + substringLength;
        index = string.indexOf(substring, endIndex);
    }while (index !== -1);
    returnValue += string.substr(endIndex);
    return returnValue;
};
const $ce4127bcbd04b06b$var$stringEncaseCRLFWithFirstIndex = (string, prefix, postfix, index)=>{
    let endIndex = 0;
    let returnValue = '';
    do {
        const gotCR = string[index - 1] === '\r';
        returnValue += string.substr(endIndex, (gotCR ? index - 1 : index) - endIndex) + prefix + (gotCR ? '\r\n' : '\n') + postfix;
        endIndex = index + 1;
        index = string.indexOf('\n', endIndex);
    }while (index !== -1);
    returnValue += string.substr(endIndex);
    return returnValue;
};
module.exports = {
    stringReplaceAll: $ce4127bcbd04b06b$var$stringReplaceAll,
    stringEncaseCRLFWithFirstIndex: $ce4127bcbd04b06b$var$stringEncaseCRLFWithFirstIndex
};

});

parcelRegister("j1O1i", function(module, exports) {
'use strict';
const $dda4e93af993cd5c$var$TEMPLATE_REGEX = /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
const $dda4e93af993cd5c$var$STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
const $dda4e93af993cd5c$var$STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
const $dda4e93af993cd5c$var$ESCAPE_REGEX = /\\(u(?:[a-f\d]{4}|{[a-f\d]{1,6}})|x[a-f\d]{2}|.)|([^\\])/gi;
const $dda4e93af993cd5c$var$ESCAPES = new Map([
    [
        'n',
        '\n'
    ],
    [
        'r',
        '\r'
    ],
    [
        't',
        '\t'
    ],
    [
        'b',
        '\b'
    ],
    [
        'f',
        '\f'
    ],
    [
        'v',
        '\v'
    ],
    [
        '0',
        '\0'
    ],
    [
        '\\',
        '\\'
    ],
    [
        'e',
        '\u001B'
    ],
    [
        'a',
        '\u0007'
    ]
]);
function $dda4e93af993cd5c$var$unescape(c) {
    const u = c[0] === 'u';
    const bracket = c[1] === '{';
    if (u && !bracket && c.length === 5 || c[0] === 'x' && c.length === 3) return String.fromCharCode(parseInt(c.slice(1), 16));
    if (u && bracket) return String.fromCodePoint(parseInt(c.slice(2, -1), 16));
    return $dda4e93af993cd5c$var$ESCAPES.get(c) || c;
}
function $dda4e93af993cd5c$var$parseArguments(name, arguments_) {
    const results = [];
    const chunks = arguments_.trim().split(/\s*,\s*/g);
    let matches;
    for (const chunk of chunks){
        const number = Number(chunk);
        if (!Number.isNaN(number)) results.push(number);
        else if (matches = chunk.match($dda4e93af993cd5c$var$STRING_REGEX)) results.push(matches[2].replace($dda4e93af993cd5c$var$ESCAPE_REGEX, (m, escape, character)=>escape ? $dda4e93af993cd5c$var$unescape(escape) : character));
        else throw new Error(`Invalid Chalk template style argument: ${chunk} (in style '${name}')`);
    }
    return results;
}
function $dda4e93af993cd5c$var$parseStyle(style) {
    $dda4e93af993cd5c$var$STYLE_REGEX.lastIndex = 0;
    const results = [];
    let matches;
    while((matches = $dda4e93af993cd5c$var$STYLE_REGEX.exec(style)) !== null){
        const name = matches[1];
        if (matches[2]) {
            const args = $dda4e93af993cd5c$var$parseArguments(name, matches[2]);
            results.push([
                name
            ].concat(args));
        } else results.push([
            name
        ]);
    }
    return results;
}
function $dda4e93af993cd5c$var$buildStyle(chalk, styles) {
    const enabled = {};
    for (const layer of styles)for (const style of layer.styles)enabled[style[0]] = layer.inverse ? null : style.slice(1);
    let current = chalk;
    for (const [styleName, styles] of Object.entries(enabled)){
        if (!Array.isArray(styles)) continue;
        if (!(styleName in current)) throw new Error(`Unknown Chalk style: ${styleName}`);
        current = styles.length > 0 ? current[styleName](...styles) : current[styleName];
    }
    return current;
}
module.exports = (chalk, temporary)=>{
    const styles = [];
    const chunks = [];
    let chunk = [];
    // eslint-disable-next-line max-params
    temporary.replace($dda4e93af993cd5c$var$TEMPLATE_REGEX, (m, escapeCharacter, inverse, style, close, character)=>{
        if (escapeCharacter) chunk.push($dda4e93af993cd5c$var$unescape(escapeCharacter));
        else if (style) {
            const string = chunk.join('');
            chunk = [];
            chunks.push(styles.length === 0 ? string : $dda4e93af993cd5c$var$buildStyle(chalk, styles)(string));
            styles.push({
                inverse: inverse,
                styles: $dda4e93af993cd5c$var$parseStyle(style)
            });
        } else if (close) {
            if (styles.length === 0) throw new Error('Found extraneous } in Chalk template literal');
            chunks.push($dda4e93af993cd5c$var$buildStyle(chalk, styles)(chunk.join('')));
            chunk = [];
            styles.pop();
        } else chunk.push(character);
    });
    chunks.push(chunk.join(''));
    if (styles.length > 0) {
        const errMessage = `Chalk template literal is missing ${styles.length} closing bracket${styles.length === 1 ? '' : 's'} (\`}\`)`;
        throw new Error(errMessage);
    }
    return chunks.join('');
};

});






parcelRegister("eayks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50ca0e18edf9768$export$2e2bcd8739ae039; });

var $hmmUY = parcelRequire("hmmUY");

var $7h4Zs = parcelRequire("7h4Zs");
const { getFiltroFundacao: $a50ca0e18edf9768$var$getFiltroFundacao } = (0, $hmmUY.fundacaoService)();
var $a50ca0e18edf9768$export$2e2bcd8739ae039 = {
    components: {
        SelectMultiple: $7h4Zs.default
    },
    props: {
        modelValue: {
            type: Object,
            default: ()=>({
                    fundo: [],
                    tag: [],
                    tempoSenAtendimentoRapido: null
                })
        }
    },
    data () {
        return {
            fundoOption: [],
            tagOption: [],
            tempoSenAtendimentoRapidoOption: [
                {
                    label: '1 a 3 meses',
                    value: '1,3'
                },
                {
                    label: '4 a 6 meses',
                    value: '4,6'
                },
                {
                    label: 'Mais de 6 meses',
                    value: '6,1000'
                }
            ]
        };
    },
    emits: [
        'update:modelValue',
        'aplicar-filtros',
        'limpar-filtros'
    ],
    methods: {
        async fetchOptions () {
            const listaFiltroFundacao = await $a50ca0e18edf9768$var$getFiltroFundacao();
            this.fundoOption = listaFiltroFundacao?.fundos?.map((item)=>({
                    value: item[1],
                    label: item[1]
                }));
            this.tagOption = listaFiltroFundacao?.tags?.map((item)=>({
                    value: item[0],
                    label: item[1]
                }));
        },
        onChangeFundo (val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                fundo: val
            });
        },
        onChangeTag (val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                tag: val
            });
        },
        onChangeTempo (val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                tempoSenAtendimentoRapido: val
            });
        },
        limparFiltros () {
            this.$emit('limpar-filtros');
        },
        aplicarFiltros () {
            this.$emit('aplicar-filtros');
        }
    },
    async mounted () {
        await this.fetchOptions();
    },
    template: `
        <section class="modal--content rounded-md w-full !overflow-visible relative" data-id="email_fundacao_filtros">
            <header class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
                <h2 class="text-lg font-medium text-white">Filtros</h2>
            </header>
            <div class="flex flex-col gap-24 !p-24 w-full">
                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Fundos: </label>
                    <select-multiple
                        :options="fundoOption"
                        :model="modelValue.fundo"
                        :submitfc="() => {}"
                        @changed="onChangeFundo">
                    </select-multiple>
                </div>
                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Tags: </label>
                    <select-multiple
                        :options="tagOption"
                        :model="modelValue.tag"
                        :submitfc="() => {}"
                        @changed="onChangeTag">
                    </select-multiple>
                </div>
                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Faixas: </label>
                    <q-select
                        class="q-select-tempo-filtro"
                        :options="tempoSenAtendimentoRapidoOption"
                        :model-value="modelValue.tempoSenAtendimentoRapido"
                        @update:model-value="onChangeTempo"
                        option-value="value"
                        option-label="label"
                        emit-value
                        map-options
                        clearable
                        outlined
                        placeholder="Selecione uma faixa de tempo..."
                        behavior="menu"
                        :menu-props="{ maxHeight: '200px' }">
                    </q-select>
                </div>
            </div>
            <div class="w-full flex gap-24 justify-between items-center p-24 !mt-96">
                <button type="button" class="btn h-48 secondary" @click="limparFiltros">
                    Limpar Filtros
                </button>
                <button type="button" class="btn h-48 primary" @click="aplicarFiltros">
                    Aplicar Filtros
                </button>
            </div>
        </section>
    `
};

});

parcelRegister("3Zw81", function(module, exports) {

$parcel$export(module.exports, "assinaturaTemplateEmailFundacao", function () { return $2e7ffda58e1b04eb$export$749529e79aebdc5d; });
$parcel$export(module.exports, "assinaturaTemplateEmailIsmael", function () { return $2e7ffda58e1b04eb$export$9a2267d6bfd6ddc9; });
$parcel$export(module.exports, "assinaturaTemplateEmailMatheus", function () { return $2e7ffda58e1b04eb$export$52daef8ccf45a26c; });
const $2e7ffda58e1b04eb$export$749529e79aebdc5d = `
	<p style="line-height: 0.8;"><strong>Rela\xe7\xf5es com Investidores Institucionais</strong></p>

	<p style="line-height: 0.8;">ri@azquest.com.br</p>

	<p style="line-height: 0.8;">clientesinstitucionais@unifinance.com.br</p>

	<p style="line-height: 0.8;">Tel. (21) 3138-6514</p>

	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>

	<p style="color: #B0B0B0; line-height: 0.8;">A Unifinance AAI \xe9 distribuidora exclusiva dos fundos da AZ Quest para Entidade
	Fechada de Previd\xeancia Complementar \u{2013} EFPC. Institui\xe7\xf5es contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.</p>

	<p style="line-height: 0.8;"><a href="https://www.unifinance.com.br" target="_blank">www.unifinance.com.br</a></p>

`;
const $2e7ffda58e1b04eb$export$9a2267d6bfd6ddc9 = `
<div style="font-family: Arial, Helvetica, sans-serif; background-color: white; color: #242424; font-size: 14px; line-height: 1.5;">

  <p style="margin-top: 10px;">Estou \xe0 disposi\xe7\xe3o para qualquer eventualidade.</p>

  <p style="margin-top: 10px;">Atenciosamente,</p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 14px; font-weight: bold; color: #1d252c;">
    Ismael Ramos, CFP<sup style="font-size: 10px;">\xae</sup>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 13px; color: #1d252c;">
    Candidato ao CFA N\xedvel III
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    <a href="mailto:ri@azquest.com.br" style="color: #1d252c;">ri@azquest.com.br</a><br>
    <a href="mailto:ismael.ramos@unifinance.com.br" style="color: #1d252c;">ismael.ramos@unifinance.com.br</a>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    Tel: (21) 3138-6506 / (21) 97173-1290
  </p>

  <p>
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 10pt; color: #7f7f7f;">
    A Unifinance AAI \xe9 distribuidora exclusiva dos fundos da AZ Quest para Entidades Fechadas de Previd\xeancia Complementar \u{2013} EFPC. Institui\xe7\xf5es contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.
  </p>

   <a href="www.unifinance.com.br" style="margin-top: 10px;">www.unifinance.com.br</a>
</div>

`;
const $2e7ffda58e1b04eb$export$52daef8ccf45a26c = `
	<div style="font-family: Arial, Helvetica, sans-serif; background-color: white; color: #242424; font-size: 14px; line-height: 1.5;">

  <p style="margin-top: 10px;">Estou \xe0 disposi\xe7\xe3o para qualquer eventualidade.</p>

  <p style="margin-top: 10px;">Atenciosamente,</p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 14px; font-weight: bold; color: #1d252c;">
    Matheus Giannini<sup style="font-size: 10px;">\xae</sup>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    <a href="mailto:ri@azquest.com.br" style="color: #1d252c;">ri@azquest.com.br</a><br>
    <a href="matheus@unifinance.com.br" style="color: #1d252c;">matheus@unifinance.com.br</a>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    Tel: (21) 3138-6514
  </p>

  <p>
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 10pt; color: #7f7f7f;">
    A Unifinance AAI \xe9 distribuidora exclusiva dos fundos da AZ Quest para Entidades Fechadas de Previd\xeancia Complementar \u{2013} EFPC. Institui\xe7\xf5es contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.
  </p>

  <a href="www.unifinance.com.br" style="margin-top: 10px;">www.unifinance.com.br</a>
</div>
`;

});


parcelRegister("h4RPk", function(module, exports) {
var $c6ec904c53539750$export$2e2bcd8739ae039 = {
    template: `
       <section
            class="modal--content rounded-md w-full !overflow-visible relative"
            data-id="email_fundacao_filtros">
            <header
                class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
                <h2 class="text-lg font-medium text-white">Filtros</h2>
                <button
                    type="button"
                    class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
                    data-xclose="modal_padrao_vue">
                    <svg class="w-32 h-32">
                        <use xlink:href="#icon_close"></use>
                    </svg>
                </button>
            </header>
            <div class="flex flex-col gap-24 !p-24 w-full">
                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Fundos: </label>
                    <select-multiple></select-multiple>
                </div>

                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Tags: </label>
                    <select-multiple></select-multiple>
                </div>

                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Faixas: </label>
                    <q-select></q-select>
                </div>
            </div>
            <div class="w-full flex gap-24 justify-between items-center p-24 !mt-96">
                <button
                    type="button"
                    class="btn h-48 secondary">
                    Limpar Filtros
                </button>
                <button
                    type="button"
                    class="btn h-48 primary">
                    Aplicar Filtros
                </button>
                
            </div>
        </section>


    `
};

});

parcelRegister("fpYz8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3982bea2495a584$export$2e2bcd8739ae039; });

var $26SB8 = parcelRequire("26SB8");

var $9YhWF = parcelRequire("9YhWF");

var $diqzg = parcelRequire("diqzg");
var $b3982bea2495a584$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $diqzg.default)
    ],
    emits: [
        'fechar-modal',
        'email-selecionado'
    ],
    data () {
        return {
            tableHistoricoEmails: null
        };
    },
    methods: {
        mapAndFilterSolicitations (data) {
            const lista = data?.results || [];
            return lista.map((item)=>({
                    ID: item.id,
                    Para: item.enviado_para,
                    Assunto: item.assunto,
                    Enviados: item.enviado_em,
                    acao: item
                }));
        },
        getTotalEmails (data) {
            return data?.count || 0;
        },
        formatDataEmail (data) {
            if (!data) return '';
            const d = new Date(data);
            return `${d.toLocaleDateString('pt-BR')} ${d.toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        },
        renderHistoricoAcoes (row) {
            const tamanhoCell = row?.cells?.length || 0;
            if (tamanhoCell === 0) return '';
            const idEmail = row?.cells?.[tamanhoCell - 1]?.data?.id;
            if (!idEmail) return '';
            return (0, $26SB8.html)(`<svg 
                        style="width:24px; height:24px; cursor:pointer;" 
                        class="icon-20 icon-neutral-60 btn-ver-email" 
                        title="Visualizar E-mail Enviado"
                        data-id="${idEmail}">
                        <use xlink:href="#icon_search"></use>
                    </svg>`);
        },
        onClickSelecionarEmail (idEmail) {
            this.$emit('email-selecionado', idEmail);
        },
        iniciarTabelaHistoricoEmails () {
            const tabela = document.getElementById('tabela-historico-emails');
            if (!tabela) return;
            const columns = [
                {
                    id: 'ID',
                    name: 'ID',
                    hidden: true,
                    width: '100px'
                },
                {
                    id: 'Para',
                    name: 'Para',
                    width: '10rem'
                },
                {
                    id: 'Assunto',
                    name: 'Assunto',
                    hidden: false
                },
                {
                    id: 'Enviados',
                    name: 'Enviados',
                    formatter: (cell)=>this.formatDataEmail(cell)
                },
                {
                    id: 'acao',
                    name: '',
                    width: '40px',
                    formatter: (cell, row)=>this.renderHistoricoAcoes(row)
                }
            ];
            this.tableHistoricoEmails = this.iniciarTabelaGenerica(columns, `${window.origin}${(0, $9YhWF.URLS).email_enviados}?`, (data)=>this.mapAndFilterSolicitations(data), (data)=>this.getTotalEmails(data));
            this.tableHistoricoEmails.render(tabela);
            tabela.addEventListener('click', (e)=>{
                const icon = e.target.closest('.btn-ver-email');
                if (icon) {
                    const id = icon.getAttribute('data-id');
                    this.$emit('email-selecionado', id);
                }
            });
        },
        onClickFecharModal () {
            modal_padrao_vue.closeModal('email_lista_enviados');
            this.$emit('fechar-modal');
        }
    },
    async mounted () {
        this.iniciarTabelaHistoricoEmails();
    },
    template: `
    <section
            class="modal--content rounded-md flex-1 w-full !h-max overflow-[initial] relative"
            data-id="email_lista_enviados"
            data-modal-id="email_lista_enviados">
         <div class="w-full h-full">
		 <header class="flex items-center justify-between w-full px-24 pt-24 pb-16 bg-primary-pure">
                <h2 class="text-lg font-medium text-white">Hist\xf3rico de E-mail</h2>
                <button 
					type="button" 
					class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
					@click="onClickFecharModal">
                    <svg class="w-32 h-32">
                        <use xlink:href="#icon_close"></use>
                    </svg>
                </button>
            </header>
             <div
                class="flex flex-col gap-32 mt-16 mb-16 md2:mt-16 md2:mb-0 !mx-auto p-24 !max-h-[400px] !overflow-y-scroll"">
                <div id="tabela-historico-emails"></div>
            </div>
         </div>
    </section>
    `
};

});


parcelRegister("QygZs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09df715aac3ee188$export$2e2bcd8739ae039; });

var $4nzoT = parcelRequire("4nzoT");

var $itImq = parcelRequire("itImq");

var $i5cs0 = parcelRequire("i5cs0");

var $6ZtoT = parcelRequire("6ZtoT");

var $9YhWF = parcelRequire("9YhWF");
const { FormatREALVirgula: $09df715aac3ee188$var$FormatREALVirgula, api: $09df715aac3ee188$var$api, FormatREAL: $09df715aac3ee188$var$FormatREAL } = GLOBAL;
var $09df715aac3ee188$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $i5cs0.default)
    ],
    data () {
        return {
            atendimentos: [],
            haveModalResumo: true,
            filter_az: '',
            abaNomeAz: '',
            usuario_responsavel: '',
            todos_clientes: window.global_clientes?.todos_clientes
        };
    },
    components: {
        ModalResumo: $4nzoT.default,
        CardFundacao: $6ZtoT.default,
        PdfModel: $itImq.default
    },
    methods: {
        patrimonioFormated (patrimonio) {
            if (patrimonio == '-') return patrimonio;
            if (patrimonio == '0') return '-';
            const value = $09df715aac3ee188$var$FormatREALVirgula(patrimonio);
            return value;
        },
        politicaFormated (politica) {
            const porc = parseFloat(politica.replace(',', '.')) * 100;
            return porc.toFixed(0);
        },
        getAtendimentos () {
            console.log('Hello darknees my old friend.');
            window.location.reload();
        },
        getAtendimentosQuentes () {
            console.log('Hello darknees my old friend.');
        },
        reloadFilter (fundo, nome) {
            let filtersOBJ = GLOBAL.splitFilters(window.location.search) || {};
            filtersOBJ['az'] = fundo;
            filtersOBJ['usuario_responsavel'] = this.usuario_responsavel;
            filtersOBJ['nome_aba'] = nome;
            this.abaNomeAz = nome;
            const newFilters = GLOBAL.generateStringFilterFromObject({
                ...filtersOBJ
            });
            // debugger
            window.location.href = `/clientes/todos_clientes_fundacao/${newFilters}`;
        },
        openModal ({ currentTarget: currentTarget }) {
            const id = currentTarget.getAttribute('data-id');
            const politica = currentTarget.getAttribute('data-politica');
            this.$refs.modalResumo.OpenModalResumo({
                id: id,
                politica: politica,
                atendimentoID: 0
            });
        },
        sendNewProspect () {
            console.log('Hello darknees my old friend.');
        },
        openFeedback () {
            document.querySelector('.modal_padrao').classList.add('!min-h-max');
        },
        async handleFilter () {
            console.log('lidar com filtro');
        },
        /**
		 * Recarrega a página trazendo dados do usuario selecionado.
		 * Chamada no mounted.
		 */ changeSelectFundacao () {
            setTimeout(()=>{
                const select = document.querySelector('#fundacao_alterna');
                const urlParams = new URLSearchParams(window.location.search);
                const usuario_responsavel = urlParams.get('usuario_responsavel');
                this.usuario_responsavel = usuario_responsavel;
                const inputUserResponsavel = document.querySelector('#usuario_responsavel');
                inputUserResponsavel.value = this.usuario_responsavel;
                select?.addEventListener('change', ()=>{
                    const select = document.querySelector('#fundacao_alterna');
                    this.usuario_responsavel = select?.value;
                    inputUserResponsavel.value = this.usuario_responsavel;
                    this.reloadFilter(this.filter_az);
                });
            }, 100);
        },
        /**
		 * Seta valores dos inputs hidden a cada mudança no select.
		 * Os inputs serão usados para filtrar o intervalo escolhido.
		 * Chamada no mounted.
		 */ changeSelectPatrimonio () {
            const select = document.querySelector('.patrimonio-select');
            select?.addEventListener('change', ()=>{
                const inputMin = document.querySelector('[name=patrimonio_min]');
                const inputMax = document.querySelector('[name=patrimonio_max]');
                const values = select?.value.split('-');
                inputMin.value = values[0] || '';
                inputMax.value = values[1] || '';
            });
        },
        /**
		 * Verifica valores dos filtros de patrimônio e seta opçao do select.
		 * Chamada no mounted
		 */ filterPatrimonio () {
            const select = GLOBAL.getChoicesActive('patrimonio-select', window.listOfChoices);
            if (!select) return;
            const url = new URL(window.location);
            const filters = GLOBAL.splitFilters(url.search);
            if (!filters) return;
            let arrFilter = Object.entries(filters);
            let str = '';
            arrFilter.forEach(([chave, valor])=>{
                if (chave == 'patrimonio_min' && valor != '') str += `${valor}`;
                if (chave == 'patrimonio_max' && valor != '') str += `-${valor}`;
            });
            GLOBAL.setSelectedOptionInChoicesDispatch(select, str);
        },
        clearAllSelects () {
            const selects = Array.from(document.querySelectorAll('select'));
            selects.forEach((sel)=>{
                try {
                    sel.value = '';
                    if (typeof sel.selectedIndex !== 'undefined') sel.selectedIndex = -1;
                    sel.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                } catch (e) {}
                const choice = GLOBAL.getChoicesActive(sel.id, window.listOfChoices);
                if (choice) GLOBAL.setSelectedOptionInChoicesDispatch(choice, '');
            });
            const custom = Array.from(document.querySelectorAll('.patrimonio-select'));
            custom.forEach((el)=>{
                try {
                    el.value = '';
                    el.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                } catch (e) {}
                const choice = GLOBAL.getChoicesActive(el.id || el.getAttribute('name') || 'patrimonio-select', window.listOfChoices);
                if (choice) GLOBAL.setSelectedOptionInChoicesDispatch(choice, '');
            });
        },
        /**
		 * Busca todas as fundações de determinado usuário. Chamada em clickChart()
		 * @param {string | number} id - id do usuário selecionado.
		 * @return {array} array de objetos das fundações separadas por categoria.
		 */ async getDadosGraficoBolhas (id) {
            try {
                const { data: response } = await $09df715aac3ee188$var$api.get(`${(0, $9YhWF.URLS).grafico_bolhas_fundacoes}${id}`);
                return response;
            } catch (err) {}
        },
        calculaIntervalo (valor) {
            // Os valores negativos ainda estão sendo considerados dentro do intervalo de zero, até saber o que fazer
            if (valor <= 500000000) return 6;
            else if (valor > 500000000 && valor <= 1000000000) return 10;
            else if (valor > 1000000000 && valor <= 5000000000) return 14;
            else if (valor > 5000000000) return 18;
        },
        zoomOut (dataLenght) {
            let inicio = 0;
            let final = dataLenght;
            document.querySelector('#chart-bubble').addEventListener('wheel', (event)=>{
                event.preventDefault();
                event.stopImmediatePropagation();
                if (event.wheelDeltaY > 0) {
                    if (inicio > final) {
                        let aux = inicio;
                        inicio = final;
                        final = aux;
                    } else {
                        chartBubble.zoomX(inicio, final);
                        inicio = inicio + 2 <= final ? inicio + 2 : final;
                        final = final - 2 >= 0 ? final - 2 : 0;
                    }
                } else {
                    chartBubble.zoomX(inicio, final);
                    inicio = inicio - 2 >= 0 ? inicio - 2 : 0;
                    final = final + 2 > dataLenght ? dataLenght : final + 2;
                }
            });
        },
        fillCharts (data, chart, bubble) {
            let colors = [
                '#55A7FF',
                '#699CC9',
                '#437199',
                '#153047'
            ];
            if (chart == chartBubble) {
                let series = [
                    {
                        name: 'Clientes',
                        data: []
                    }
                ];
                if (data.length > 0) {
                    //solução temporária até encontrar como colocar padding no inicio dos dados
                    series[0].data.push({
                        name: '',
                        x: '',
                        y: 0,
                        z: 0
                    });
                    data.forEach((item, index)=>{
                        series[0].data.push({
                            name: item.sigla,
                            x: item.sigla,
                            y: item.politica_atendida,
                            z: this.calculaIntervalo(Number(item.patrimonio) * 1000),
                            fillColor: 'red',
                            patrimonio: item.patrimonio
                        });
                    });
                    //solução temporária até encontrar como colocar padding no fim dos dados
                    series[0].data.push({
                        name: 'fim',
                        x: 'fim',
                        y: 0,
                        z: 0
                    });
                }
                //alterando a cor conforme valor
                series[0].data.forEach((item)=>{
                    switch(item.z){
                        case 6:
                            item.fillColor = colors[0];
                            break;
                        case 10:
                            item.fillColor = colors[1];
                            break;
                        case 14:
                            item.fillColor = colors[2];
                            break;
                        case 18:
                            item.fillColor = colors[3];
                            break;
                        default:
                            break;
                    }
                });
                const isVazio = series[0].data.length === 0 ? true : false;
                const widthChart = series[0].data.length - 2 < 30 ? '100%' : `${(series[0].data.length - 2) * 40}px`;
                chart.updateOptions({
                    series: series,
                    chart: {
                        //tamanho pra calculado com base em quantidade de clientes
                        width: `${isVazio ? '100%' : widthChart}`
                    },
                    title: {
                        text: ` ${bubble}`
                    },
                    tooltip: {
                        enabled: true,
                        x: {
                            show: true,
                            formatter: function(valor, { w: w }) {
                                return w.globals.categoryLabels[valor - 1];
                            }
                        },
                        y: {
                            formatter: function(valor, { dataPointIndex: dataPointIndex }) {
                                const patrimonio = GLOBAL.FormatREAL(series[0].data[dataPointIndex].patrimonio);
                                return patrimonio || '0,00';
                            },
                            title: {
                                formatter: (seriesName)=>"Patrim\xf4nio (Mil):"
                            }
                        },
                        z: {
                            formatter: function(valor, y) {
                                /* Intervalos considerados
										0 - 500 milhões
										500 - 1 bi
										1 - 5 bi
										acima de 5 bi
									*/ switch(valor){
                                    case 6:
                                        return `entre R$ ${0} e R$ ${$09df715aac3ee188$var$FormatREAL('500000000')}`;
                                    case 10:
                                        return `entre R$ ${$09df715aac3ee188$var$FormatREAL('500000000')} e R$ ${$09df715aac3ee188$var$FormatREAL('1000000000')}`;
                                    case 14:
                                        return `entre R$ ${$09df715aac3ee188$var$FormatREAL('1000000000')} e R$ ${$09df715aac3ee188$var$FormatREAL('5000000000')}`;
                                    case 18:
                                        return `acima de R$ ${$09df715aac3ee188$var$FormatREAL('5000000000')}`;
                                }
                            },
                            title: 'Intervalo:'
                        }
                    }
                });
            }
        },
        color (bubble) {
            switch(bubble){
                case 'SAI/Cliente':
                    return '#2945D3';
                case 'SAI':
                    return '#4D82E9';
                case 'N/A':
                    return '#6d6f71';
                case 'Consultor/Gestor':
                    return '#079F69';
                default:
                    return '';
            }
        },
        removeBorder (divs, bubble) {
            divs.forEach((item)=>{
                if (item.getAttribute('bubble') != bubble) item.classList.remove(`border-bubble-${item.getAttribute('bubble').split('/').join('-')}`);
            });
        },
        positionArrow (svgs, bubble) {
            svgs.forEach((item)=>{
                if (item.getAttribute('bubble') != bubble) {
                    item.style.transform = 'rotate(0)';
                    item.style.transition = '.2s ease opacity, .2s ease transform';
                }
            });
        },
        clickChart () {
            const divs = document.querySelectorAll('.card-bubble');
            const svgs = document.querySelectorAll('.arrow-bubble');
            const divChart = document.querySelector('#bubble');
            divs?.forEach((i)=>{
                i.addEventListener('click', async ()=>{
                    const bubble = i.getAttribute('bubble');
                    const strBubble = bubble.split('/').join('-');
                    //altera cor das bordas dos cards
                    i.classList.toggle(`border-bubble-${strBubble}`);
                    this.removeBorder(divs, bubble);
                    this.positionArrow(svgs, bubble);
                    //adiciona borda a div do gráfico
                    divChart.style.borderColor = this.color(bubble);
                    const svg = document.querySelector(`.arrow_click-${strBubble}`);
                    if (i.classList.contains(`border-bubble-${strBubble}`)) {
                        // terminando ainda
                        let id;
                        const select = document.querySelector('[name=fundacao_alterna');
                        const choice = GLOBAL.getChoicesActive(select.id, window.listOfChoices);
                        const options = choice._presetChoices;
                        options.forEach((op)=>{
                            if (op.selected) {
                                const aux = choice._presetOptions;
                                aux.forEach((i)=>{
                                    if (i.value == op.value) id = i.getAttribute('userId');
                                });
                            }
                        });
                        const data = await this.getDadosGraficoBolhas(id);
                        this.fillCharts(data[bubble], chartBubble, bubble);
                        this.zoomOut(data[bubble].length);
                        divChart.classList.remove('invisible');
                        svg.style.transform = 'rotate(90deg)';
                        svg.style.transition = '.2s ease opacity, .2s ease transform';
                    } else {
                        divChart.classList.add('invisible');
                        svg.style.transform = 'rotate(0)';
                        svg.style.transition = '.2s ease opacity, .2s ease transform';
                    }
                });
            });
        }
    },
    mounted () {
        setTimeout(()=>{
            this.filterPatrimonio();
            GLOBAL.verifyFilter('modelo_negocio', 'modelo_negocio');
        // this.setSelectFundacao()
        }, 1000);
        const urlParams = new URLSearchParams(window.location.search);
        const az = urlParams.get('az');
        const nome_aba = urlParams.get('nome_aba') || 'Geral';
        this.filter_az = az;
        this.abaNomeAz = nome_aba;
        const abaGeral = Array.from(document.querySelectorAll('.abaFilter')).find((element)=>{
            return String(element.getAttribute('name'))?.toLowerCase() === 'geral';
        });
        if (abaGeral && !this.filter_az) this.reloadFilter(abaGeral.getAttribute('id'), nome_aba);
        this.changeSelectPatrimonio();
        this.clickChart();
        this.changeSelectFundacao();
        const usuario_responsavel = urlParams.get('usuario_responsavel');
        this.usuario_responsavel = usuario_responsavel;
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("itImq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d73d588d644b9edc$export$2e2bcd8739ae039; });
var $d73d588d644b9edc$export$2e2bcd8739ae039 = {
    props: [],
    data () {},
    mounted () {},
    methods: {
        currentDate: ()=>{
            return new Date().toDateString();
        }
    },
    watch: {
        data: {
            handler () {
                _BIG('Nova politica');
                console.log(this.data);
            },
            deep: true
        }
    },
    template: /* html */ `
	<div id="model-pdf" class=" w-full py-10">
			<h1 class="text-lg">Suitability UF Report</h1>
			<h2 style="color: #87849c">
				Form: Question\xe1rio de Perfil do Investidor - Suitability
			</h2>
			<table class="table-pdf-model w-full">
				<thead>
					<tr>
						<th>Status</th>
						<th>Preenchimento Forms</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Fonte</td>
						<td>Formul\xe1rio de Cadastro</td>
					</tr>
					<tr>
						<td>1.1 RG / CNH (Frente e Verso)</td>
						<td>
							
								<img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSqTLWA6zn1UO9UdOXNmbB_2wLJvXnrXGC_g&usqp=CAU" />
						
						</td>
					</tr>
					<tr>
						<td>1.2 Comprovante de Resid\xeancia</td>
						<td>
							<img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSqTLWA6zn1UO9UdOXNmbB_2wLJvXnrXGC_g&usqp=CAU" />
						</td>
					</tr>
					<tr>
						<td>2.1 Nome Completo</td>
						<td>
							Bruno dos Santos Rodrigues de Siqueira
						</td>
					</tr>
					<tr>
						<td>2.2 CPF</td>
						<td>
							033.319.897.38
						</td>
					</tr>
					<tr>
						<td>2.3 Data de Nascimento</td>
						<td>
							18-Dez-2002
						</td>
					</tr>
					<tr>
						<td>2.4 Local de Nascimento</td>
						<td>
							RJ - SG
						</td>
					</tr>
					<tr>
						<td>2.5 Profiss\xe3o</td>
						<td>
							Desenvolvedor
						</td>
					</tr>

					<tr>
						<td>2.6 Telefone</td>
						<td>
							( 21 ) 98656-4067
						</td>
					</tr>

					<tr>
						<td>2.7 Celular</td>
						<td>
							( 21 ) 98656-4067
						</td>
					</tr>

					<tr>
						<td>2.8 E-mail</td>
						<td>
							contaps4762@gmail.com
						</td>
					</tr>

					<tr>
						<td>2.9 Renda Anual (R$)</td>
						<td>
							2.000,00
						</td>
					</tr>

					<tr>
						<td>2.10 Renda Familiar Anual (R$)</td>
						<td>
							30.000,00
						</td>
					</tr>

					<tr>
						<td>2.11 Qual \xe9 a sua participa\xe7\xe3o na renda familiar %?</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>2.12 N\xfamero de Filhos</td>
						<td>
							2
						</td>
					</tr>

					<tr>
						<td>2.13 Idade dos Filhos</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>2.14 N\xedvl de Escolaridade</td>
						<td>
							Fundamental - Incompleto
						</td>
					</tr>

					<tr>
						<td>2.15 \xc1rea de Forma\xe7\xe3o Acad\xeamica</td>
						<td>
							Astronomia
						</td>
					</tr>

					<tr>
						<td>2.16 Pessoa Politicamente Exposta?</td>
						<td>
							Sim
						</td>
					</tr>

					<tr>
						<td>3.1 Possui seguro de vida?</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>3.2 Qual o premio pago anualmente?</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td>3.3 Qual o valor da cobertura?</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>3.4 \xc9 fumante?</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>3.5 Possui seguro de sa\xfade?</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>3.6 Qual a seguradora?</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>3.7 O plano de sa\xfade \xe9</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>3.8 Quanto voc\xea gasta com a mensalidade do seu
							plano?
						</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>3.9 Possui alguma doen\xe7a pr\xe9 existente?
						</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>4.1 Patrim\xf4nio Atual
						</td>
						<td>
							De R$ 5 milh\xf5es a R$ 10 milh\xf5es
						</td>
					</tr>

					<tr>
						<td>
							4.2 Qual \xe9 a Origem de seus Recursos?
						</td>
						<td>
							Realoca\xe7\xe3o de Investimentos
						</td>
					</tr>

					<tr>
						<td>
							4.2 Qual \xe9 a Origem de seus Recursos?
						</td>
						<td>
							Realoca\xe7\xe3o de Investimentos
						</td>
					</tr>

					<tr>
						<td>
							4.3 Relacione a composi\xe7\xe3o atual do seu patrim\xf4nio
							(indicando os valores que possui em investimentos
							financeiros e imobilizados)
						</td>
						<td>
				
						</td>
					</tr>

					<tr>
						<td>
							4.4 Qual a parcela do seu patrim\xf4nio total dever\xe1
							ser investida por meio da Unifinance?
						</td>
						<td>
							Menos de 10%
						</td>
					</tr>

					<tr>
						<td>
							5.1 Qual das op\xe7\xf5es a seguir melhor define seu
							objetivo de investimento?
						</td>
						<td>
							Preserva\xe7\xe3o de Capital - Objetivo \xe9 obter um retorno suficiente para
							compensar a infla\xe7\xe3o, mantendo o valor real do capital constante, sem
							se expor.
						</td>
					</tr>

					<tr>
						<td>
							5.2 Qual o horizonte aproximado para seu objetivo
							de investimento citado na quest\xe3o anterior?
						</td>
						<td>
							10 anos ou mais
						</td>
					</tr>

					<tr>
						<td>
							5.3 Em seus investimentos pessoais, qual parcela
							voc\xea precisar\xe1 de liquidez?
						</td>
						<td>
							6 meses
						</td>
					</tr>

					<tr>
						<td>
								5.4 Que percentual de sua renda voc\xea investe
							regularmente, incluindo poupan\xe7a?
						</td>
						<td>
								Entre 11% e 20%
						</td>
					</tr>

					<tr>
						<td>
							5.5 Com qual frequ\xeancia voc\xea avalia o desempenho
							da sua carteira de investimentos?
						</td>
						<td>
							Poder\xe1 alterar ou resgatar investimentos em at\xe9 6 meses.
						</td>
					</tr>

					<tr>
						<td>
							6.1 Possui alguma experi\xeancia profissional no
							mercado financeiro
						</td>
						<td>
							Sim, at\xe9 5 anos
						</td>
					</tr>

					<tr>
						<td>
							6.2 J\xe1 aplicou nas seguintes op\xe7\xf5es de
							investimentos?
						</td>
						<td>
							Participa\xe7\xf5es Societ\xe1rias, Fundos DI
						</td>
					</tr>

					<tr>
						<td>
							6.3 H\xe1 quanto tempo investe por conta pr\xf3pria ou
							atrav\xe9s de algum advisor/consultor?
						</td>
						<td>
							Menos de 3 anos
						</td>
					</tr>

					<tr>
						<td>
							7.1 Qual a varia\xe7\xe3o percentual negativa m\xe1xima que
							voc\xea considera aceit\xe1vel em seus investimentos em
							condi\xe7\xf5es normais de mercado, no per\xedodo de 30
							dias?
						</td>
						<td>
							1%
						</td>
					</tr>

					<tr>
						<td>
							7.2 Dentre os fundos de investimento abaixo, e seus
							respectivos poss\xedveis rendimentos, qual
							representaria sua op\xe7\xe3o de investimento preferida?
						</td>
						<td>
							Fundo B - Retorno M\xednimo: 2,10% ; M\xe9dio: 11,20% ; M\xe1ximo: 12,90%
						</td>
					</tr>

					<tr>
						<td>
							7.3 Em momentos de crise, o que voc\xea faria se
							houvesse redu\xe7\xe3o significativa no valor do seu
							investimento?
						</td>
						<td>
							Resgataria todo o investimento e deixaria os recursos na conta corrente.
						</td>
					</tr>

					<tr>
						<td>
							8.1 Banco
						</td>
						<td>
							BB
						</td>
					</tr>

					<tr>
						<td>
							8.2 Ag\xeancia 
						</td>
						<td>
						2432424
						</td>
					</tr>

					<tr>
						<td>
							8.3 Conta Corrente
						</td>
						<td>
							2344343
						</td>
					</tr>

					<tr>
						<td>
							9.1 Estado Civil
						</td>
						<td>
							Casado(a)
						</td>
					</tr>

					<tr>
						<td>
							9.2 Nome completo do c\xf4njuge (caso aplic\xe1vel)
						</td>
						<td>
				
						</td>
					</tr>

					<tr>
						<td>
							9.3 CPF do c\xf4njuge (caso aplic\xe1vel)
						</td>
						<td>
							232443322	
						</td>
					</tr>

					<tr>
						<td>
							9.4 Possui outra nacionalidade? Qual? 
						</td>
						<td>
		
						</td>
					</tr>

					<tr>
						<td>
							9.5 Ocupa\xe7\xe3o Atual
						</td>
						<td>
		
						</td>
					</tr>

					<tr>
						<td>
							9.6 Empresa que Trabalha
						</td>
						<td>
							SocialBrand
						</td>
					</tr>

					<tr>
						<td>
							9.7 CNPJ da empresa 
						</td>
						<td>
							98765432345678
						</td>
					</tr>

					<tr>
						<td>
							9.8 Data de Admiss\xe3o
						</td>
						<td>
							13-out-2020
						</td>
					</tr>

					<tr>
						<td>
							9.9 E-mail Profissional 
						</td>
						<td>
							test@test.com
						</td>
					</tr>

					<tr>
						<td>
							9.9 E-mail Profissional 
						</td>
						<td>
							test@test.com
						</td>
					</tr>

					<tr>
						<td>
							9.10 Endere\xe7o Comercial
						</td>
						<td>
							3444, bc, sc, 44444, Brazil
						</td>
					</tr>

					<tr>
						<td>
							9.11 Participa\xe7\xf5es Societ\xe1rias 
						</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td>
							9.12 Refer\xeancias Pessoais
						</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td>
							9.13 Autoriza revelar, disponibilizar, compartilhar
							seus dados e/ou informa\xe7\xf5es da sua conta,
							relat\xf3rios, documentos confidenciais e/ou sigilosos
							para terceiros?
						</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td>
							9.14 Informe Nome, CPF e e-mail da pessoa
							autorizada a receber as informa\xe7\xf5es.
						</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td>
							9.15 Termo de Consentimento aos Servi\xe7os de
							Consultoria de Valores Mobili\xe1rios da UF Consult
						</td>
						<td>
							Agreed
						</td>
					</tr>

					<tr>
						<td>
							Terms and Conditions 
						</td>
						<td>
							Agreed
						</td>
					</tr>

					<tr>
						<td>
							9.16 Assinatura
						</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td>
							Added Time
						</td>
						<td>
							{{currentDate()}}
						</td>
					</tr>

					<tr>
						<td>
							CRM Status
						</td>
						<td>
							<div class="relative flex items-center justify-center bg-alert-green-10">
								<div class="w-1 h-full top-0 left-0 absolute bg-alert-green-100"></div>
									New Record - Record added
								</div>
						</td>
					</tr>

					<tr>
						<td>
							Referrer Name
						</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>
							SMS Status
						</td>
						<td>
						</td>
					</tr>

					<tr>
						<td>
							Task Owner
						</td>
						<td>
						</td>
					</tr>

					<tr>
						<td colspan="2">
							<h1 class="font-medium"> Comments </h1>
							<p>No Comments</p>
						</td>
					</tr>

				</tbody>
			</table>
	</div>
	`
};

});

parcelRegister("6ZtoT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $516f3eea2c1d17d0$export$2e2bcd8739ae039; });
const { ref: $516f3eea2c1d17d0$var$ref, mounted: $516f3eea2c1d17d0$var$mounted } = Vue;
var $516f3eea2c1d17d0$export$2e2bcd8739ae039 = {
    emits: [],
    props: {
        name: String,
        politica: Number,
        patrimonio: Number,
        clientes: Array,
        colors: Array,
        open: Function
    },
    setup (props, ctx) {
        const arrow_click = $516f3eea2c1d17d0$var$ref(`arrow_click-${props.name}`);
        const politicaAtendida = $516f3eea2c1d17d0$var$ref("");
        const patrimonioFormated = (patrimonio)=>{
            if (patrimonio == "-") return patrimonio;
            if (patrimonio == "0") return "-";
            const value = FormatREALVirgula(patrimonio);
            return value;
        };
        const politicaId = (bubble)=>{
            switch(bubble){
                case "SAI/Cliente":
                    return "0";
                case "SAI":
                    return "1";
                case "N/A":
                    return "2";
                case "Consultor/Gestor":
                    return "3";
                default:
                    return "";
            }
        };
        return {
            arrow_click: arrow_click,
            patrimonioFormated: patrimonioFormated,
            politicaId: politicaId,
            politicaAtendida: politicaAtendida
        };
    },
    mounted () {
        setTimeout(()=>{
            console.log("a", this.props?.name);
        }, 2000);
        this.politicaAtendida.value = this.politicaId(this.props?.name);
        console.log("a", this.politicaAtendida.value, this.props?.name);
    },
    template: html`
		<div class="flex flex-col gap-8 swiper-slide flex-0  ">
			<div
				class="rounded-md border border-neutral-30 p-16 h-[110px] max-h-[110px] relative card-bubble cursor-pointer "
				:bubble="name"
			>
				<span
					class="block absolute top-0 l-16 h-[6px] w-[32px]   rounded-br-md rounded-bl-md"
					:class="colors[0]"
				></span>
				<div class="flex gap-8 justify-between w-full items-center">
					<h1 class="font-medium tracking-widest text-xs" :class="colors[1]">
						{{name}}
					</h1>
					<div
						class="rounded-full h-24 w-24 bg-primary-10 flex items-center justify-center"
						:class="colors[1]"
					>
						<svg
							:class="arrow_click"
							
							class="w-24 h-24 arrow-bubble "
							:bubble="name"
							style="--cor-1:#2945D3"
						>
							<use xlink:href="#arrow_right_color"></use>
						</svg>
					</div>
				</div>

				<div
					class="flex justify-between mt-16 text-xs gap-4 font-semibold text-neutral-80"
				>
					<div>
						<p class="mb-6">Patrimônio (Mil)</p>
						<p class="text-sm font-medium text-neutral-70">
							R$
							<span class="text-sm text-neutral-100">{{patrimonio}}</span>
						</p>
					</div>
					<div>
						<p class="mb-6">Política atendida</p>
						<p class="text-sm font-medium text-neutral-70">{{politica}}%</p>
					</div>
				</div>
			</div>

			<div
				class="card-wrapper bg-neutral-10 flex flex-col gap-12 border border-neutral-30 p-16 h-[21.3rem] overflow-auto"
			>
				<div v-for="cliente in clientes" :key="cliente.id" v-show="cliente.Atendida== '0'">
					
                    <div
                    
				v-if="cliente.politica == '0'"
					class="card-cliente group"
					:data-nome="cliente.nome"
					:data-id="cliente.id"
					:data-politica="cliente.politica"
					@click="open"
				>
					<div class="flex justify-between">
						<p class="text-sm font-medium text-neutral-100 two-line">
							 {{cliente.sigla}}
						</p>
						<svg
							class="flex-shrink-0 w-16 h-16 transition-colors duration-300 svg-user"
							style="--cor-1:#D4D5D9"
						>
							<use xlink:href="#icon_users"></use>
						</svg>
					</div>

				   <p class="text-xs font-medium text-neutral-80">
                                Patrimônio (Mil)<span class="text-sm font-medium ml-14 text-neutral-70">R$ {{cliente.patrimonio_interno}}
                                    
                            </p>
   
					<div class="flex items-center gap-4">
						<svg
							class="flex-shrink-0 w-16 h-16 transition-colors duration-300 svg-user"
							style="--cor-1:#D4D5D9"
						>
							<use xlink:href="#icon_phone"></use>
						</svg>
						<p v-if="cliente.telefone != 'None'">{{ cliente.telefone}} </p>
					</div>

					<div class="flex items-center gap-4">
						<svg class="w-20 h-20" style="--cor-1:#D4D5D9">
							<use xlink:href="#icon_mail"></use>
						</svg>
						<p
							class="text-ellipsis whitespace-nowrap overflow-hidden  w-[200px]"
						>
						{{ cliente.email}} 
						</p>
					</div>
				</div>
                <div v-else class="hidden"></div>
			</div>  

				<svg class="hidden w-full h-16 my-16 md2:block">
					<use xlink:href="#icon_delimiter"></use>
				</svg>
			</div>  
				</div>

					
			</div>
		</div>
	`
};

});


parcelRegister("4bGxI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30c9309af16ee1dd$export$2e2bcd8739ae039; });

var $4nzoT = parcelRequire("4nzoT");

var $i5cs0 = parcelRequire("i5cs0");

var $4Fazw = parcelRequire("4Fazw");
parcelRequire("8tccp");

var $1UZGW = parcelRequire("1UZGW");

var $26SB8 = parcelRequire("26SB8");

var $bxPLa = parcelRequire("bxPLa");

var $lDrXI = parcelRequire("lDrXI");

var $bX0Y4 = parcelRequire("bX0Y4");

var $gNUk4 = parcelRequire("gNUk4");

var $ija2p = parcelRequire("ija2p");

var $8ZGCf = parcelRequire("8ZGCf");

var $geOYu = parcelRequire("geOYu");
parcelRequire("lY3Fi");

var $b6Cs4 = parcelRequire("b6Cs4");

var $cpXN9 = parcelRequire("cpXN9");

var $2m7Ys = parcelRequire("2m7Ys");

var $6Bddm = parcelRequire("6Bddm");

var $9YhWF = parcelRequire("9YhWF");
const { errorDefault: $30c9309af16ee1dd$var$errorDefault, api: $30c9309af16ee1dd$var$api, FormatREALVirgula: $30c9309af16ee1dd$var$FormatREALVirgula, debounceFunction: $30c9309af16ee1dd$var$debounceFunction, estadosBR: $30c9309af16ee1dd$var$estadosBR } = GLOBAL;
const $30c9309af16ee1dd$var$url_browser = new URL(window.location.href);
const { getProcessoSeletivo: $30c9309af16ee1dd$var$getProcessoSeletivo, createProcessoSeletivo: $30c9309af16ee1dd$var$createProcessoSeletivo, deleteProcessoSeletivo: $30c9309af16ee1dd$var$deleteProcessoSeletivo } = (0, $6Bddm.default)();
var $30c9309af16ee1dd$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $i5cs0.default),
        (0, $cpXN9.default)
    ],
    components: {
        ModalResumo: $4nzoT.default,
        AvatarPersona: $4Fazw.default,
        ConfirmModal: $1UZGW.default,
        GraficoGerencialSai: $bxPLa.default,
        TableGerencialSai: $8ZGCf.default,
        ModalAtendimentoGerenciadorSai: $geOYu.default,
        ModalInfoAtendimentoGerencial: $b6Cs4.default
    },
    data () {
        return {
            listaFundacaoAtendimento: [],
            data: {},
            tableFundacoes: null,
            fundacoesAtivos: [],
            filterFundacoes: '',
            filter_az: '',
            abasFilter: [],
            dashboard_gerencial: [],
            fundosSelect: [],
            modalConfirm: {},
            principais_clientes_cliente_pf: global_tables.principais_clientes_cliente_pf,
            principais_prospects: global_tables.principais_prospects,
            principais_sap: global_tables.principais_sap,
            acompanhamento_officers: global_tables.acompanhamento_officers,
            grafico_importancia_estado: [],
            /* 			es: {
				sigla: '',
			}, */ haveModalResumo: true,
            filterMesAtivo: '',
            tipoParticipacaoFundo: 'nominal',
            chartParticipacaoFundo: null,
            chartCaptacaoSemestral: null,
            chartCaptacaoMensal: null,
            chartPle: null,
            _copiaOptionsChartCaptacaoSemestral: null,
            _copiaSerieChartCaptacaoSemestral: null,
            _copiaCategoriasChartCaptacaoSemestral: null,
            isCaptacaoSemestralSelected: false,
            isLoadChartCaptacaoMensal: false,
            fundacaoId: null,
            fundacaoSequoiaInfoSelecionado: null,
            atendimentoSequoiaEditarSelecionado: null,
            isModoEditarAtendimentoSai: false,
            isLoadingModalAtendimentoSai: false
        };
    },
    methods: {
        async enviarAtendimentoRapido (e) {
            const { tituloAtendimento: tituloAtendimento, textoAtendimento: textoAtendimento, dataAtendimento: dataAtendimento } = e;
            try {
                this.isLoadingModalAtendimentoSai = true;
                const responseAtendimentoRapido = await this.createAtendimentoRapido('0', textoAtendimento, tituloAtendimento, dataAtendimento ?? null);
                modal_padrao_vue.closeModal('modal_atendimento_gerencial_sai');
                window.location = `${window.origin}/atendimento/dashboard_gerencial_fundacao/?az=${this.filter_az}`;
            } catch (e) {
                console.log(e);
            } finally{
                this.isLoadingModalAtendimentoSai = false;
            }
        },
        async editarAtendimentoRapidoSequoia (atendimentoData) {
            try {
                this.isLoadingModalAtendimentoSai = true;
                const { textoAtendimento: textoAtendimento, tituloAtendimento: tituloAtendimento, dataAtendimento: dataAtendimento, idAtendimento: idAtendimento } = atendimentoData;
                const responseAtendimentoRapido = await this.updateAtendimentoRapido(textoAtendimento, tituloAtendimento, dataAtendimento, idAtendimento);
                modal_padrao_vue.closeModal('modal_atendimento_gerencial_sai');
                window.location = `${window.origin}/atendimento/dashboard_gerencial_fundacao/?az=${this.filter_az}`;
            } catch (e) {
                console.log(e);
            } finally{
                this.isLoadingModalAtendimentoSai = false;
            }
        },
        closeModalAtendimentoRapido () {
            this.isModoEditarAtendimentoSai = false;
            this.atendimentoSequoiaEditarSelecionado = null;
            this.clearClienteAtendimentoRapido();
        },
        openModalInfoGerencial (fundacaoSelecionado) {
            const { atendimentosFundacao: atendimentosFundacao } = fundacaoSelecionado;
            this.fundacaoSequoiaInfoSelecionado = atendimentosFundacao;
            modal_padrao_vue.openModal('modal_info_gerencial_sai');
            this.$nextTick(()=>{
                const modals = document.querySelectorAll('[data-active="modal_info_gerencial_sai"]');
                if (modals && modals.length > 0) modals.forEach((item1)=>{
                    item1.style.width = '36rem';
                });
                else console.warn("Modal ainda n\xe3o est\xe1 no DOM");
            });
        },
        onClickEditarAtendimentoSequoia (idAtendimento) {
            if (this.fundacaoSequoiaInfoSelecionado && idAtendimento) {
                const atendimentoSelecionado = this.fundacaoSequoiaInfoSelecionado.atendimentos.find((item1)=>item1.id === idAtendimento);
                this.atendimentoSequoiaEditarSelecionado = atendimentoSelecionado;
                if (this.atendimentoSequoiaEditarSelecionado) {
                    this.isModoEditarAtendimentoSai = true;
                    modal_padrao_vue.closeModal('modal_info_gerencial_sai');
                    setTimeout(()=>{
                        this.openModalAtendimentoRapidoGerencial({
                            id: this.atendimentoSequoiaEditarSelecionado.fundacao
                        });
                    }, 1000);
                }
            }
        },
        openModalAtendimentoRapidoGerencial (fundacao) {
            this.addClienteAtendimentoRapido(fundacao.id);
            modal_padrao_vue.openModal('modal_atendimento_gerencial_sai');
        },
        getAbaAZById (id) {
            if (!id) return '';
            return this.abasFilter.find((item1)=>item1.id === Number(id))?.nome ?? '';
        },
        initPLeChart () {
            this.chartPle = new ApexCharts(document.querySelector('#chart_ple'), (0, $ija2p.pleOptions));
            this.chartPle?.render();
        },
        initParticipacaoChart () {
            this.chartParticipacaoFundo = new ApexCharts(document.querySelector('#chart_segmento_sai'), (0, $lDrXI.participacaoOptions));
            this.chartParticipacaoFundo.render();
        },
        initCaptacaoSemestralChart () {
            this.chartCaptacaoSemestral = new ApexCharts(document.querySelector('#chart_bar'), (0, $bX0Y4.captacaoSemestralOptions));
            this.chartCaptacaoSemestral.render();
        },
        initCaptacaoMensalChart () {
            this.addEventListenerCaptacaoSemestralChart();
            this.chartCaptacaoMensal = new ApexCharts(document.querySelector('#chart_captacao_mensal'), this._copiaOptionsChartCaptacaoSemestral);
            this.chartCaptacaoMensal?.render();
        },
        initAllChart () {
            this.initParticipacaoChart();
            this.initCaptacaoSemestralChart();
            this.initCaptacaoMensalChart();
            this.initPLeChart();
        },
        addEventListenerCaptacaoSemestralChart () {
            this._copiaOptionsChartCaptacaoSemestral = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).cloneDeep((0, $gNUk4.captacaoMensalOptions));
            if (!this._copiaOptionsChartCaptacaoSemestral.chart.events) this._copiaOptionsChartCaptacaoSemestral.chart.events = {};
            this._copiaOptionsChartCaptacaoSemestral.chart.events.dataPointSelection = (event, chartContext, config)=>{
                if (!this.isCaptacaoSemestralSelected) {
                    const barraSelecionadaIdx = config.dataPointIndex;
                    const todasSeries = chartContext.w.config.series;
                    this._copiaCategoriasChartCaptacaoSemestral = chartContext.w.config.xaxis.categories;
                    const todosOsValoresBarraSelecionada = todasSeries.filter((item1)=>{
                        return item1 && item1.data[barraSelecionadaIdx];
                    }).map((item1)=>{
                        return {
                            name: item1.name,
                            data: [
                                {
                                    y: Number(item1.data[barraSelecionadaIdx]),
                                    x: this._copiaCategoriasChartCaptacaoSemestral[barraSelecionadaIdx]
                                }
                            ]
                        };
                    });
                    this._copiaSerieChartCaptacaoSemestral = todasSeries;
                    const baseOptions = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).cloneDeep((0, $gNUk4.captacaoMensalOptions));
                    const barraOptions = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).cloneDeep((0, $gNUk4.captacaoSemestralBarraOptions));
                    this._copiaOptionsChartCaptacaoSemestral = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).merge({}, baseOptions, barraOptions);
                    this._copiaOptionsChartCaptacaoSemestral.chart.events = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).cloneDeep(this.chartCaptacaoMensal?.w?.config?.chart?.events);
                    this._copiaOptionsChartCaptacaoSemestral.series = [
                        ...todosOsValoresBarraSelecionada
                    ];
                    this.chartCaptacaoMensal?.destroy();
                    this.chartCaptacaoMensal = new ApexCharts(document.querySelector('#chart_captacao_mensal'), this._copiaOptionsChartCaptacaoSemestral);
                    this.chartCaptacaoMensal?.render();
                    this.isCaptacaoSemestralSelected = true;
                } else {
                    this.recreateChartCaptacaoSemestral();
                    this.isCaptacaoSemestralSelected = false;
                }
            };
        },
        recreateChartCaptacaoSemestral () {
            this._copiaOptionsChartCaptacaoSemestral = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).cloneDeep((0, $gNUk4.captacaoMensalOptions));
            this._copiaOptionsChartCaptacaoSemestral.chart.events = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).cloneDeep(this.chartCaptacaoMensal?.w?.config?.chart?.events);
            this._copiaOptionsChartCaptacaoSemestral.series = this._copiaSerieChartCaptacaoSemestral;
            this._copiaOptionsChartCaptacaoSemestral.xaxis.categories = this._copiaCategoriasChartCaptacaoSemestral;
            this.chartCaptacaoMensal?.destroy();
            this.chartCaptacaoMensal = new ApexCharts(document.querySelector('#chart_captacao_mensal'), this._copiaOptionsChartCaptacaoSemestral);
            this.chartCaptacaoMensal?.render();
        },
        async updateChartCaptacaoMensalRecreate () {
            if (this.isCaptacaoSemestralSelected) {
                this.isLoadChartCaptacaoMensal = true;
                this.recreateChartCaptacaoSemestral();
                await new Promise((resolve)=>setTimeout(resolve, 1000));
                this.isCaptacaoSemestralSelected = false;
                this.isLoadChartCaptacaoMensal = false;
            }
        },
        reloadFilter (fundoID) {
            window.location.href = `/atendimento/dashboard_gerencial_fundacao/?az=${fundoID}`;
        },
        openModal ({ currentTarget: currentTarget }, idActive, politicaActive) {
            const id = idActive || currentTarget?.getAttribute('data-id');
            const politica = politicaActive || currentTarget?.getAttribute('data-politica');
            this.$refs.modalResumo.OpenModalResumo({
                id: id,
                politica: politica,
                atendimentoID: null
            });
        },
        debounce (fn, wait, timing) {
            return (...args)=>{
                clearTimeout(timing);
                timing = setTimeout(()=>fn(...args), wait);
            };
        },
        submitDropdown () {
            const form = document.querySelector('#form-dropdown');
            form.submit();
        },
        patrimonioFormated (patrimonio) {
            if (patrimonio == '-' || patrimonio?.toLowerCase() == 'none') return '-';
            const value = $30c9309af16ee1dd$var$FormatREALVirgula(patrimonio);
            return value;
        },
        arrExample (n) {
            return Array(n).fill(0);
        },
        async getDadosCharts () {
            try {
                const { data: response } = await $30c9309af16ee1dd$var$api.get(`/atendimento/graficos_dashboard_gerencial/?az=${this.filter_az}`);
                return response;
            } catch (err) {
                $30c9309af16ee1dd$var$errorDefault(err);
            }
        },
        fillCharts (data, chart) {
            if (!this.isFundacao) {
                if (chart == chartSegmento) {
                    let currentData;
                    if (this.isFundacao) {
                        const { grafico_segmento_fundacao: grafico_segmento_fundacao } = data;
                        currentData = grafico_segmento_fundacao;
                    } else {
                        const { grafico_segmento_cliente_pf: grafico_segmento_cliente_pf } = data;
                        currentData = grafico_segmento_cliente_pf;
                    }
                    let series = currentData?.map((obj)=>Number(obj.value));
                    chart.updateOptions({
                        series: series,
                        labels: currentData.map((obj)=>obj.name)
                    });
                }
                if (chart == chartProdutos) {
                    let currentData;
                    if (this.isFundacao) {
                        const { grafico_principais_produtos_fundacao: grafico_principais_produtos_fundacao } = data;
                        currentData = grafico_principais_produtos_fundacao;
                    } else {
                        const { grafico_principais_produtos_cliente_pf: grafico_principais_produtos_cliente_pf } = data;
                        currentData = grafico_principais_produtos_cliente_pf;
                    }
                    const series = currentData.map((obj)=>Number(obj.value));
                    chart.updateOptions({
                        series: series,
                        labels: currentData.map((obj)=>obj.name)
                    });
                }
            } else {
                if (chart == this.chartParticipacaoFundo) {
                    let currentParticipacaoFundo = [];
                    if (this.tipoParticipacaoFundo === 'ajustado') currentParticipacaoFundo = data['grafico_participacao_fundo2'];
                    else if (this.tipoParticipacaoFundo === 'nominal') currentParticipacaoFundo = data['grafico_participacao_fundo'];
                    let currentData = currentParticipacaoFundo?.sort((a, b)=>b.value - a.value);
                    let series = currentData.map((obj)=>Number(obj.value));
                    chart.updateOptions({
                        series: series,
                        labels: currentData.map((obj)=>obj.name)
                    }, true, true, true);
                }
                if (chart == this.chartPle) {
                    const { grafico_evolucao_patrimonio: grafico_evolucao_patrimonio } = data;
                    let currentData = grafico_evolucao_patrimonio;
                    let series = [
                        {
                            name: "Patrim\xf4nio",
                            data: currentData.map((obj)=>Number(obj.value))
                        }
                    ];
                    chart.updateOptions({
                        series: series,
                        labels: currentData.map((obj)=>obj.name)
                    });
                }
                if (chart == this.chartCaptacaoSemestral) {
                    //const { captacoes } = data
                    let currentData = data;
                    let series = [
                        {
                            name: 'Ajustado',
                            type: 'column',
                            data: currentData.map((obj)=>Number(obj.captacao_ajustada))
                        },
                        {
                            name: 'Total',
                            type: 'column',
                            data: currentData.map((obj)=>Number(obj.captacao_total))
                        },
                        {
                            name: 'Meta',
                            type: 'line',
                            data: currentData.map((obj)=>Number(obj.meta))
                        }
                    ];
                    const seriesIdx = 1;
                    const dataPoints = series[seriesIdx].data;
                    const cats = currentData.map((obj)=>obj.semestre);
                    const points = dataPoints.map((v, i)=>{
                        return {
                            x: cats[i],
                            y: v,
                            marker: {
                                size: 0
                            },
                            label: {
                                text: GLOBAL.FMoneyK(v),
                                offsetY: v >= 0 ? -1 : 24,
                                offsetX: 6,
                                style: {
                                    fontSize: '12px',
                                    color: v >= 0 ? '#003769' : '#C11F39',
                                    background: 'transparent'
                                },
                                borderWidth: 0,
                                borderColor: 'transparent'
                            }
                        };
                    }).filter((pt)=>pt);
                    chart.updateOptions({
                        series: series,
                        labels: currentData.map((obj)=>obj.semestre),
                        chart: {
                            width: currentData?.length <= 12 ? '100%' : `${currentData?.length * 40}px`
                        },
                        annotations: {
                            points: points
                        }
                    });
                }
                if (chart == this.chartCaptacaoMensal) {
                    const { fundos_semestre: fundos_semestre, nomes_fundos: nomes_fundos } = data;
                    let arr = Object.entries(fundos_semestre);
                    let series = [];
                    let label = [];
                    for ([chave, itemFundoSemestre] of arr)label.push(chave);
                    nomes_fundos?.forEach((array)=>{
                        let valores = [];
                        for ([chave, itemFundoSemestre] of arr){
                            let valor = 0;
                            if (itemFundoSemestre?.length == 1) {
                                if (itemFundoSemestre[0].nome === array[0]) valor = itemFundoSemestre[0].valor;
                                else valor = 0;
                            } else itemFundoSemestre?.forEach((item1, index)=>{
                                if (index == 0) {
                                    if (item1.nome === array[0]) valor = item1.valor;
                                } else if (item1[0].nome === array[0]) valor = item1[0].valor;
                            });
                            valores.push(valor);
                        }
                        series = [
                            ...series,
                            {
                                name: array[0],
                                data: valores
                            }
                        ];
                        valores = [];
                    });
                    chart.updateOptions({
                        series: series,
                        xaxis: {
                            type: 'category',
                            categories: label
                        }
                    });
                }
            }
        },
        alternarValor () {
            const btn = document.querySelector('.alternar-valor');
            const btnAjustado = document.querySelector('.alternar-valor-ajustado');
            btnAjustado.addEventListener('click', async (eventClick)=>{
                this.toggleButtonClasses(eventClick, btn);
                let data = await this.getDadosCharts();
                const { fundos_semestre: fundos_semestre, nomes_fundos: nomes_fundos } = data;
                let arr = Object.entries(fundos_semestre);
                let series = [];
                let label = [];
                for ([chave, itemFundoSemestre] of arr)label.push(chave);
                nomes_fundos.forEach((array)=>{
                    let valores = [];
                    for ([chave, itemFundoSemestre] of arr){
                        let valor = 0;
                        if (itemFundoSemestre?.length == 1) {
                            if (itemFundoSemestre[0].nome === array[0]) valor = itemFundoSemestre[0].valor_ajustado;
                            else valor = 0;
                        } else itemFundoSemestre.forEach((item1, index)=>{
                            if (index == 0) {
                                if (item1.nome === array[0]) valor = item1.valor_ajustado;
                            } else if (item1[0].nome === array[0]) valor = item1[0].valor_ajustado;
                        });
                        valores.push(valor);
                    }
                    series = [
                        ...series,
                        {
                            name: array[0],
                            data: valores
                        }
                    ];
                    valores = [];
                });
                await this.updateChartCaptacaoMensalRecreate();
                this.chartCaptacaoMensal?.updateOptions({
                    series: series,
                    xaxis: {
                        type: 'category',
                        categories: label
                    }
                });
            });
            btn.addEventListener('click', async (eventClick)=>{
                this.toggleButtonClasses(eventClick, btnAjustado);
                let data = await this.getDadosCharts();
                await this.updateChartCaptacaoMensalRecreate();
                this.fillCharts(data, this.chartCaptacaoMensal);
            });
        },
        addEventBtnsFiltroFundacoes () {
            const btnFiltrar = document.querySelector('.filtrarFundacoes');
            const btnLimpar = document.querySelector('.limparFiltros');
            if (btnFiltrar) btnFiltrar.addEventListener('click', ()=>this.filtrarFundacoes());
            if (btnLimpar) btnLimpar.addEventListener('click', ()=>this.limparFundacoes());
        },
        limparFundacoes () {
            this.filterFundacoes = '';
            const acima = document.querySelector('input[name="acima"]');
            const abaixo = document.querySelector('input[name="abaixo"]');
            const selectEstado = document.querySelector('select[name="estado"]');
            const choiceEstado = GLOBAL.getChoicesActive(selectEstado.id, listOfChoices);
            const selectFundo = document.querySelector('select[name="fundo_sigla"]');
            const choiceFundo = GLOBAL.getChoicesActive(selectFundo.id, listOfChoices);
            acima.value = '';
            abaixo.value = '';
            choiceEstado.removeActiveItems();
            choiceFundo.removeActiveItems();
            this.tableFundacoes?.updateConfig({
                server: {
                    url: `${window.origin}${(0, $9YhWF.URLS).api_fundacao}?ativo=True${this.filterFundacoes}`,
                    then: (data)=>this.mapAndFilterSolicitations(data.results),
                    total: (data)=>data.count
                }
            }).forceRender();
        },
        async filtrarFundacoes () {
            const acima = document.querySelector('input[name="acima"]');
            const abaixo = document.querySelector('input[name="abaixo"]');
            const selectEstado = document.querySelector('select[name="estado"]');
            const choiceEstado = GLOBAL.getChoicesActive(selectEstado.id, listOfChoices);
            const valuesEstadosSelecionados = choiceEstado.getValue(true);
            const selectFundo = document.querySelector('select[name="fundo_sigla"]');
            const choiceFundo = GLOBAL.getChoicesActive(selectFundo.id, listOfChoices);
            const valuesFundosSelecionadas = choiceFundo.getValue(true);
            let filter = '';
            filter += '&fundo_sigla=' + valuesFundosSelecionadas?.join(',');
            filter += '&estado=' + valuesEstadosSelecionados?.join(',');
            filter += handleCallback(`acima,${Number(GLOBAL.FormatREALBackEnd(acima.value)) || ''}`);
            filter += handleCallback(`abaixo,${Number(GLOBAL.FormatREALBackEnd(abaixo.value)) || ''}`);
            function handleCallback(itemFilter) {
                const filtro = itemFilter?.split(',');
                const [param, value] = filtro;
                let filtersOBJ = {};
                filtersOBJ[param] = value;
                const filtros = Object.entries(filtersOBJ).map(([key1, value])=>`&${key1.trim()}=${value.trim()}`);
                const newFilters = `${filtros.join('')}`;
                return newFilters;
            }
            filter += `&az=${$30c9309af16ee1dd$var$url_browser.split('=')[1]}`;
            this.filterFundacoes = filter;
            this.tableFundacoes?.updateConfig({
                server: {
                    url: `${window.origin}${(0, $9YhWF.URLS).api_fundacao}?ativo=True${this.filterFundacoes}`,
                    then: (data)=>this.mapAndFilterSolicitations(data.results),
                    total: (data)=>data.count
                }
            }).forceRender();
        },
        mapSolicitacao (item1) {
            const objTable = {
                politica: item1.politica,
                id: item1.id,
                nome: item1.nome,
                patrimonio: item1.patrimonio_unifinance,
                estado: item1.estado,
                sigla_fundo: item1.sigla_fundo?.join(', ')
            };
            return objTable;
        },
        mapAndFilterSolicitations (solicitacoes) {
            const _arrData = solicitacoes?.map((item1)=>this.mapSolicitacao(item1));
            const solicitacoesFiltradas = _arrData;
            return solicitacoesFiltradas.map((item1)=>Object.values(item1));
        },
        iniciarTabelaGenerica (tableSelector, columns, url, customThenCallback, count, by) {
            const table = document.querySelector(tableSelector);
            const gridInstance = new (0, $26SB8.Grid)({
                search: false,
                resizable: true,
                columns: columns,
                data: [],
                autoWidth: true,
                width: '100%',
                sort: false,
                server: {
                    url: url,
                    then: (data)=>customThenCallback(data),
                    total: count
                },
                search: {
                    debounceTimeout: 500,
                    server: {
                        url: (prev, keyword)=>{
                            return `${prev}&search=${keyword}&paginate_by=9999&az=${$30c9309af16ee1dd$var$url_browser.search.split('=')[1]}`;
                        }
                    }
                },
                pagination: {
                    enabled: true,
                    limit: by ?? 10,
                    summary: true,
                    server: {
                        url: (urlApi, page, limit)=>`${urlApi}&page=${++page}&paginate_by=${limit}&az=${$30c9309af16ee1dd$var$url_browser.search.split('=')[1]}`
                    }
                },
                style: {
                    container: {
                        border: 'none'
                    },
                    table: {
                        border: 'none'
                    },
                    tr: {
                        border: 'none'
                    },
                    th: {
                        'border-bottom': '1px solid #e9ecef'
                    },
                    td: {
                        'border-bottom': '1px solid #e9ecef',
                        cursor: 'pointer',
                        color: '#495057',
                        'font-family': 'Roboto Flex',
                        'font-size': '14px',
                        'font-weight': 500,
                        'line-height': '150%',
                        'letter-spacing': '-0.28px'
                    },
                    footer: {
                        border: 'none'
                    }
                },
                language: {
                    search: {
                        placeholder: 'Busque aqui...'
                    },
                    pagination: {
                        previous: '<',
                        next: '>',
                        to: '/',
                        of: 'de',
                        showing: 'Mostrando',
                        results: ()=>'Resultados'
                    }
                }
            });
            gridInstance.render(table);
            return gridInstance;
        },
        iniciartableFundacoesAtivo () {
            const columns = [
                {
                    name: 'politica',
                    hidden: true,
                    width: '40px'
                },
                {
                    name: 'ID',
                    hidden: true,
                    width: '40px'
                },
                // { name: 'tipo-solicitacao', hidden: true },
                // { name: 'conteudo-editado', hidden: true },
                // { name: 'index', hidden: true },
                {
                    name: 'Nomes',
                    hidden: false,
                    width: '360px',
                    formatter: (cell, row)=>{
                        return cell ? (0, $26SB8.html)(html`<div class="flex gap-4 items-center w-full">
									<div class="cursor-pointer">
										<div class="inline-flex justify-center">
											<svg
												class="h-40 w-40"
												style="${GLOBAL.generateAvatarColor(row.cells[0].data)}">
												<use xlink:href="#icon_person"></use>
											</svg>
										</div>
									</div>
									${cell}
							  </div>`) : (0, $26SB8.html)(html`<div class="flex gap-4 items-center"></div>`);
                    }
                },
                {
                    name: "Patrim\xf4nio",
                    hidden: false,
                    width: '200px',
                    formatter: (cell)=>{
                        if (cell) return GLOBAL.formatReal2(cell);
                    }
                },
                {
                    name: 'Estado',
                    width: '200px',
                    hidden: false,
                    formatter: (cell)=>{
                        const estado = $30c9309af16ee1dd$var$estadosBR.find((estado)=>Number(estado.id) === Number(cell));
                        if (cell) return estado?.nome;
                    }
                },
                {
                    name: 'Fundos',
                    width: '300px',
                    hidden: false
                }
            ];
            this.tableFundacoes = this.iniciarTabelaGenerica('#table_fundacoes_ativos', columns, `${window.origin}${(0, $9YhWF.URLS).api_fundacao}?ativo=True${this.filterFundacoes}`, (data)=>this.mapAndFilterSolicitations(data.results), (data)=>data.count, document.querySelector('#select-table').value);
            this.tableFundacoes.on('rowClick', (...args)=>{
                const dados = args[1];
                const politica = dados.cells[0].data;
                const id = dados.cells[1].data;
                this.openModal({}, id, politica);
            });
        },
        sortedArray (event, key1, dataKey, number) {
            // this.stateSave.searchs.searchFilterAtendimentos = (a) => a
            const target = event.currentTarget;
            const att = target.getAttribute('order');
            target.closest('thead').querySelectorAll('th').forEach((el)=>el !== target && el.removeAttribute('order'));
            if (att == 'up') target.setAttribute('order', 'down');
            if (att == 'down') target.setAttribute('order', 'up');
            if (!att) target.setAttribute('order', 'up');
            const clone = this[dataKey];
            const result = clone.sort((a, b)=>{
                const A = number ? a[key1].replaceAll('.', '').replaceAll(',', '') : a[key1].toLowerCase();
                const B = number ? b[key1].replaceAll('.', '').replaceAll(',', '') : b[key1].toLowerCase();
                if (number) return A - B;
                else {
                    if (A < B) return -1;
                    if (B > A) return 1;
                    return 0;
                }
            });
            this[dataKey] = att == 'up' ? result : result.reverse();
        },
        // getAtendimentos() {
        // 	console.log("Hello darknees my old friend.");
        // },
        // getAtendimentosQuentes() {
        // 	console.log("Hello darknees my old friend.");
        // },
        // openModal({ currentTarget }) {
        // 	const id = currentTarget.getAttribute("data-id")
        // 	const politica = currentTarget.getAttribute("data-politica")
        // 	this.$refs.modalResumo.OpenModalResumo({ id, politica, atendimentoID: 0 });
        // }
        openModalProcesso () {
            modal_padrao.openModal('modal_filtro');
        },
        openModalDeleteProcesso (id) {
            this.modalConfirm = {
                open: true,
                text: `Deseja mesmo excluir esse processo? `,
                data: {
                    id: id
                },
                id: 'delete_processo',
                botao: 'Excluir',
                header: 'Excluir Processo'
            };
        },
        hiddenSectionModal () {
            const modal = document.querySelector('.modal_padrao');
            const btns = document.querySelectorAll('.btn-modal');
            btns.forEach((i)=>{
                i.addEventListener('click', ()=>{
                    const id = i.dataset.id;
                    modal.querySelectorAll(`section`).forEach((i)=>{
                        i.classList.add('hidden');
                    });
                    modal.querySelector(`section[data-id=${id}]`).classList.remove('hidden');
                });
            });
        },
        /* fillMap() {
			let colors = [
				'#D2E2F3',
				'#93C7FF',
				'#83BFFF',
				'#75B5F0',
				'#74B7FF',
				'#71B5FF',
				'#6BA4D4',
				'#639DD4',
				'#59A9FF',
				'#55A7FF',
				'#52A8FF',
				'#4FA7FF',
				'#46A3FF',
				'#459EF6',
				'#2D90ED',
				'#2A94FF',
				'#2793FF',
				'#0080FF',
				'#699CC9',
				'#528FC4',
				'#3A7DB8',
				'#437199',
				'#437199',
				'#186EBF',
				'#195386',
				'#164A78',
				'#164269',
				'#163C5E',
				'#153654',
				'#153047',
			].reverse()

			const estadosOrdenados = this.grafico_importancia_estado
				.sort(function (x, y) {
					return x.value - y.value
				})
				.reverse()

			estadosOrdenados.forEach((regiao, i) => {
				const path = document.querySelector(
					`.svg-es path[data-es="${regiao.name}"]`
				)
				if (path) {
					if (regiao.value > 0) {
						path.style.fill = colors[i]
					} else {
						path.style.fill = '#D2E2F3CC'
					}
				}
			})
		},

		async hoverES(e, es) {
			const tooltip = document.querySelector('.tooltip-es')
			tooltip.style.opacity = 0
			tooltip.style.transform = 'translateY(16px)'

			const path = document.querySelector(`.svg-es path[data-es="${es}"]`)

			this.es.sigla = es

			const data = this.grafico_importancia_estado.find(
				(obj) => obj.name.toLowerCase().trim() == es.toLowerCase()
			)

			if (data) {
				this.es = {
					sigla: data.name + ' - ',
					fullName: data.nome,
					value: 'R$ ' + this.patrimonioFormated(data.value),
				}
			} else {
				this.es = {
					sigla: '',
					fullName: 'Sem dados',
					value: '',
				}
			}

			tooltip.style.opacity = 1
			tooltip.style.transform = 'translateY(0)'
		},

		hoverLeave(e) {
			this.es = {
				sigla: '',
			}
			const tooltip = document.querySelector('.tooltip-es')
			tooltip.style.opacity = 0
			tooltip.style.transform = 'translateY(16px)'
		}, */ addBuscaSelect (listOfChoices1) {
            const fundacao = document.querySelector('[name=fundacao]');
            if (!fundacao) return;
            const hasAttr = fundacao.getAttribute('js-choices-props');
            const props = hasAttr ? JSON.parse(hasAttr) : {};
            let newFundacao = GLOBAL.initChoices(fundacao, {
                searchEnabled: true,
                searchChoices: true,
                itemSelectText: 'Selecionar',
                noResultsText: 'Nada Encontrado...',
                noResultsText: '...',
                noChoicesText: '...',
                ...props
            });
            window.listOfChoices = [
                ...listOfChoices1,
                newFundacao
            ];
        },
        toggleDisablebBtnNovoProcesso (fundacaoValue) {
            const btn = document.querySelector('.submit-processo');
            if (fundacaoValue) btn.classList.remove('disabled');
            else btn.classList.add('disabled');
        },
        eventProcesso () {
            const fundacao = document.querySelector('[name=fundacao]');
            const btn = document.querySelector('.submit-processo');
            fundacao.addEventListener('change', ()=>{
                this.toggleDisablebBtnNovoProcesso(fundacao.value);
            });
            this.toggleDisablebBtnNovoProcesso(fundacao.value);
            btn.addEventListener('click', ()=>{
                this.cadastrarProcessoSeletivo();
            });
        },
        limpaDados (dados) {
            let arrDados = Object.entries(dados);
            for ([key, item] of arrDados){
                if (key == 'fundacao') GLOBAL.setValueInChoices(item.id, '');
                item.value = '';
            }
        //	this.eventProcesso()
        },
        async cadastrarProcessoSeletivo () {
            let elementos = {
                fundacao: document.querySelector('[name=fundacao]'),
                estrategia: document.querySelector('[name=estrategia]'),
                valor: document.querySelector('[name=valor]'),
                data: document.querySelector('[name=deadline]'),
                observacoes: document.querySelector('[name=observacoes]')
            };
            let data = {
                fundacao: elementos.fundacao.value || null,
                estrategia: elementos.estrategia.value,
                valor: elementos.valor.value ? GLOBAL.FormatREALBackEnd(elementos.valor.value) : null,
                data: elementos.data.value ? elementos.data.value.split('/').reverse().join('-') : null,
                observacoes: elementos.observacoes.value || null
            };
            try {
                const response = await $30c9309af16ee1dd$var$createProcessoSeletivo(data);
                await this.populaProcessos();
                GLOBAL.showToastify('Processo cadastrado');
                this.limpaDados(elementos);
                return response;
            } catch (err) {
                console.log(err);
                GLOBAL.showToastify("Processo n\xe3o cadastrado");
            }
        },
        geraTemplateProcesso (i) {
            return html`<tr class="" data-tippy-content="${i.observacoes ?? '-'}">
				<td class="py-10">${i.nome_fundacao}</td>
				<td class="py-10">${i.estrategia || '-'}</td>

				<td class="py-10">${i.data?.split('-').reverse().join('/') || '-'}</td>
				<td class="py-10">
					<div class="flex items-center">
						R$ ${GLOBAL.FormatREAL(i.valor) || GLOBAL.FormatREAL('0.00')}
					</div>
				</td>
				<td class="py-10">
					<div class="flex items-center justify-center">
						<button
							type="button"
							id_processo="${i.id}"
							class="delete_processo w-full relative transition-transform place-items-center   cursor-pointer  text-primary-pure">
							<svg class="w-20 h-20 ">
								<use xlink:href="#icon_delete"></use>
							</svg>
						</button>
					</div>
				</td>
			</tr>`;
        },
        addClickDeleteProcesso () {
            document.querySelectorAll('.delete_processo').forEach((button)=>{
                button.addEventListener('click', ()=>{
                    const id = button.getAttribute('id_processo');
                    this.openModalDeleteProcesso(id);
                });
            });
        },
        async deleteProcessoSeletivo () {
            try {
                const id = this.modalConfirm.data?.id;
                const responseDelete = await $30c9309af16ee1dd$var$deleteProcessoSeletivo(id);
                if (responseDelete.data?.error) throw new Error(responseDelete.data?.error);
                GLOBAL.showToastify("\u2705 Processo excluido com sucesso");
                this.modalConfirm = {};
                await this.populaProcessos();
            } catch (e) {
                GLOBAL.showToastify(`\u{274C} ${e.message || 'Erro ao excluir processo'}`);
            }
        },
        async populaProcessos () {
            try {
                const response = await $30c9309af16ee1dd$var$getProcessoSeletivo();
                const body = document.querySelector('.body-processos-seletivos');
                body.innerHTML = '';
                response?.results.forEach((i)=>{
                    body.innerHTML += this.geraTemplateProcesso(i);
                });
                this.addClickDeleteProcesso();
                tippy('[data-tippy-content]', {
                    allowHTML: true,
                    placement: 'top-start',
                    boundary: 'HTMLElement'
                });
                return response;
            } catch (err) {
                console.log(err);
            }
        },
        async filterValuesChart (qtdMeses) {
            const { captacoes: captacoes, captacoes_12_meses: captacoes_12_meses, captacoes_24_meses: captacoes_24_meses, captacoes_36_meses: captacoes_36_meses } = await this.getDadosCharts();
            if (qtdMeses === this.filterMesAtivo) this.filterMesAtivo = '';
            else this.filterMesAtivo = qtdMeses;
            switch(this.filterMesAtivo){
                case 12:
                    this.fillCharts(captacoes_12_meses, this.chartCaptacaoSemestral);
                    return;
                case 24:
                    this.fillCharts(captacoes_24_meses, this.chartCaptacaoSemestral);
                    return;
                case 36:
                    this.fillCharts(captacoes_36_meses, this.chartCaptacaoSemestral);
                    return;
                default:
                    this.fillCharts(captacoes, this.chartCaptacaoSemestral);
                    return;
            }
        },
        toggleButtonClasses (eventClick, buttonNoClicked) {
            eventClick.target.classList.remove('quartenary');
            eventClick.target.classList.add('secondary');
            buttonNoClicked.classList.add('quartenary');
            buttonNoClicked.classList.remove('secondary');
        },
        setParticipationChartOptions (responseDadosCharts) {
            let currentParticipacaoFundo = [];
            if (this.tipoParticipacaoFundo === 'ajustado') currentParticipacaoFundo = responseDadosCharts['grafico_participacao_fundo2'];
            else if (this.tipoParticipacaoFundo === 'nominal') currentParticipacaoFundo = responseDadosCharts['grafico_participacao_fundo'];
            const sortParticipacaoFundo = currentParticipacaoFundo.reverse();
            const labels = sortParticipacaoFundo.map((item_grafico)=>item_grafico.name);
            const series = sortParticipacaoFundo.map((item_grafico)=>Number(item_grafico.value));
            this.chartParticipacaoFundo.updateOptions({
                series: series,
                labels: labels
            });
            window.dispatchEvent(new Event('resize'));
        },
        async handleClickButtonAjustado (eventClick, buttonValueNominal) {
            this.toggleButtonClasses(eventClick, buttonValueNominal);
            const responseDadosCharts = await this.getDadosCharts();
            this.tipoParticipacaoFundo = 'ajustado';
            this.setParticipationChartOptions(responseDadosCharts);
        /* this.fillCharts(responseDadosCharts, chartParticipacaoFundo) */ },
        async handleClickbuttonNominal (eventClick, buttonValueAjustado) {
            this.toggleButtonClasses(eventClick, buttonValueAjustado);
            const responseDadosCharts = await this.getDadosCharts();
            this.tipoParticipacaoFundo = 'nominal';
            this.setParticipationChartOptions(responseDadosCharts);
        /* this.fillCharts(responseDadosCharts, chartParticipacaoFundo) */ },
        initializeChartToggle () {
            const buttonValueNominal = document.querySelector('.chart-part');
            const buttonValueAjustado = document.querySelector('.chart-part-ajustado');
            buttonValueAjustado.addEventListener('click', async (eventClick)=>this.handleClickButtonAjustado(eventClick, buttonValueNominal));
            buttonValueNominal.addEventListener('click', async (eventClick)=>this.handleClickbuttonNominal(eventClick, buttonValueAjustado));
        },
        async setFilterAz () {
            const { abas: abas } = await this.getDadosCharts();
            const abaGeral = abas?.find((aba)=>String(aba.nome)?.toLowerCase() === 'geral');
            if (abaGeral) this.reloadFilter(abaGeral.id);
            this.filterValuesChart(36);
        },
        async getFundacoesAtivos (params = '') {
            try {
                const { data: data } = await $30c9309af16ee1dd$var$api.get(`${(0, $9YhWF.URLS).api_fundacao}?&ativo=True${params}`);
                return data;
            } catch (err) {
                $30c9309af16ee1dd$var$errorDefault(err);
            }
        }
    },
    async mounted () {
        GLOBAL.initFlatpickr(document.querySelector('[name=deadline]'), {
            position: 'above'
        });
        const urlParams = new URLSearchParams(window.location.search);
        const az = urlParams.get('az');
        if (!az) await this.setFilterAz(az);
        this.filter_az = az ?? '';
        let data = await this.getDadosCharts();
        let { grafico_importancia_estado: grafico_importancia_estado, abas: abas } = data;
        this.abasFilter = abas;
        if (this.getAbaAZById(this.filter_az).toLowerCase() !== "sequ\xf3ia") {
            this.alternarValor();
            this.initializeChartToggle();
            this.initAllChart();
            // this.fundacoesAtivos = await this.getFundacoesAtivos(this.filterFundacoes)
            this.iniciartableFundacoesAtivo();
            this.grafico_importancia_estado = grafico_importancia_estado;
            setTimeout(()=>{
                if (!this.isFundacao) {
                    chartSegmento && this.fillCharts(data, chartSegmento);
                    chartProdutos && this.fillCharts(data, chartProdutos);
                } else {
                    this.chartPle && this.fillCharts(data, this.chartPle);
                    this.chartCaptacaoSemestral && this.fillCharts(data.captacoes, this.chartCaptacaoSemestral);
                    this.chartCaptacaoMensal && this.fillCharts(data, this.chartCaptacaoMensal);
                    this.chartParticipacaoFundo && this.fillCharts(data, this.chartParticipacaoFundo);
                }
                /* this.fillMap() */ document.querySelector('select[name="usuario_responsavel"]').value = urlParams.get('usuario_responsavel');
                this.addEventBtnsFiltroFundacoes();
                this.addBuscaSelect(listOfChoices);
                this.eventProcesso();
                this.populaProcessos();
                this.$nextTick(()=>{
                    window.dispatchEvent(new Event('resize'));
                });
                this.filterValuesChart(36);
            }, 400);
        }
    },
    beforeMount () {
        this.$nextTick((function() {}).bind(this));
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("8tccp", function(module, exports) {
function $62aa7eab14c9b56b$export$2e2bcd8739ae039(element, events, callback) {
    const outside = "data-outside";
    const html = document.documentElement;
    if (!element.hasAttribute(outside)) {
        events.forEach((userEvent)=>{
            html.addEventListener(userEvent, handleOutsideClick) //adiciona evento de click que vai aproveitar do bubble
            ;
        });
        element.setAttribute(outside, "") //coloca atributo para nao adicionar o evento mais de uma vez
        ;
    }
    function handleOutsideClick(event) {
        if (!element.contains(event.target)) {
            element.removeAttribute(outside, "");
            events.forEach((userEvent)=>{
                html.removeEventListener(userEvent, handleOutsideClick) //adiciona evento de click que vai aproveitar do bubble
                ;
            });
            callback();
        }
    }
}

});

parcelRegister("bxPLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $867aed35b3df2975$export$2e2bcd8739ae039; });
const { FormatREALVirgula: $867aed35b3df2975$var$FormatREALVirgula } = GLOBAL;
var $867aed35b3df2975$export$2e2bcd8739ae039 = {
    props: {
        grafico_importancia_estado: []
    },
    data () {
        return {
            es: {
                sigla: ''
            }
        };
    },
    watch: {
        grafico_importancia_estado () {
            if (this.grafico_importancia_estado && this.grafico_importancia_estado.length > 0) setTimeout(()=>{
                this.fillMap();
            }, 600);
        }
    },
    methods: {
        fillMap () {
            let colors = [
                '#D2E2F3',
                '#93C7FF',
                '#83BFFF',
                '#75B5F0',
                '#74B7FF',
                '#71B5FF',
                '#6BA4D4',
                '#639DD4',
                '#59A9FF',
                '#55A7FF',
                '#52A8FF',
                '#4FA7FF',
                '#46A3FF',
                '#459EF6',
                '#2D90ED',
                '#2A94FF',
                '#2793FF',
                '#0080FF',
                '#699CC9',
                '#528FC4',
                '#3A7DB8',
                '#437199',
                '#437199',
                '#186EBF',
                '#195386',
                '#164A78',
                '#164269',
                '#163C5E',
                '#153654',
                '#153047'
            ].reverse();
            const estadosOrdenados = this.grafico_importancia_estado.sort(function(x, y) {
                return x.value - y.value;
            }).reverse();
            estadosOrdenados.forEach((regiao, i)=>{
                const path = document.querySelector(`.svg-es path[data-es="${regiao.name}"]`);
                if (path) {
                    if (regiao.value > 0) path.style.fill = colors[i];
                    else path.style.fill = '#D2E2F3CC';
                }
            });
        },
        async hoverES (e, es) {
            const tooltip = document.querySelector('.tooltip-es');
            console.log(tooltip);
            tooltip.style.opacity = 0;
            tooltip.style.transform = 'translateY(16px)';
            const path = document.querySelector(`.svg-es path[data-es="${es}"]`);
            this.es.sigla = es;
            const data = this.grafico_importancia_estado.find((obj)=>obj.name.toLowerCase().trim() == es.toLowerCase());
            if (data) this.es = {
                sigla: data.name + ' - ',
                fullName: data.nome,
                value: 'R$ ' + this.patrimonioFormated(data.value)
            };
            else this.es = {
                sigla: '',
                fullName: 'Sem dados',
                value: ''
            };
            tooltip.style.opacity = 1;
            tooltip.style.transform = 'translateY(0)';
        },
        hoverLeave (e) {
            this.es = {
                sigla: ''
            };
            const tooltip = document.querySelector('.tooltip-es');
            tooltip.style.opacity = 0;
            tooltip.style.transform = 'translateY(16px)';
        },
        patrimonioFormated (patrimonio) {
            if (patrimonio == '-' || patrimonio?.toLowerCase() == 'none') return '-';
            const value = $867aed35b3df2975$var$FormatREALVirgula(patrimonio);
            return value;
        }
    },
    mounted () {},
    template: `
					<svg class="svg-es cursor-pointer" width="400" height="410" viewBox="0 0 245 251" fill="none"
						xmlns="http://www.w3.org/	2000/svg">
						<path class="hover:!opacity-50 transition-all duration-300" data-es="RO" @mouseenter="e => hoverES(e, 'RO')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M45.5786 97.4411L45.7475 97.3141V97.1452L45.7056 97.1033L45.7475 97.0615L45.8313 97.1033H45.9151H46.084L46.211 97.0196L46.2948 96.9358L46.3366 96.8088L46.715 96.598L46.8001 96.5142L46.9258 96.5561L46.9677 96.5142L47.1366 96.4723L47.2204 96.3466L47.473 96.3034V96.2615V96.1777L47.5149 96.0939L47.6838 95.967L47.8527 95.7994L47.9365 95.6305L48.1473 95.4616V95.167L48.1041 95.0413L47.9784 94.9562V94.9143L48.0203 94.8725L48.2311 94.9562H48.273L48.3568 94.9143L48.4838 94.9994L48.5675 94.9143L48.6094 94.9562V95.0413H48.6513H48.7783L48.8202 94.9994L48.7783 94.8725H48.904H48.9459L49.0729 94.9994H49.1148L49.1986 94.9562H49.2837L49.4945 95.0413L49.5783 94.9562H49.6201L49.7458 94.8725H49.789H49.8309L49.9566 94.9143H50.2093L50.2931 94.8725V94.8306H50.3363H50.5458L50.6309 94.8725H50.7565V94.9562L50.8403 94.9994L50.8835 95.0413L51.0092 95.1251L51.0511 95.2521L51.093 95.3359L51.22 95.3778H51.3038L51.4308 95.5035H51.4727L51.5146 95.5467V95.6724H51.5565L51.6403 95.6305L51.6835 95.8413H51.7254L51.7673 95.8832L51.8091 96.0088H51.851L51.9348 95.9251L51.978 95.8832H52.0618L52.1037 95.7994H52.1456L52.2294 95.8413H52.2726L52.4402 95.5035L52.524 95.4616L52.5672 95.1251H52.6091H52.6929H52.7348L52.778 95.0413L52.8199 94.9994L52.9455 94.9562L53.0725 94.9143H53.1144H53.2401L53.3239 94.9562L53.5347 95.1251H53.5766H53.6185L53.6617 95.167V95.2521L53.7036 95.294L53.8293 95.2521L53.8712 95.167L53.9563 95.2521L54.04 95.2089L54.0819 95.2521V95.167L53.9981 94.9562L53.9563 94.8725V94.8306L53.9981 94.6198V94.4522V94.3671V94.3252V94.2833L54.04 94.2414L54.2089 94.3252L54.3346 94.409H54.3765L54.4184 94.3671V94.3252H54.5873L54.6292 94.2414L54.9238 94.0725L55.0089 93.9887L55.2183 93.9049H55.2615L55.471 94.0306V94.0725V94.1144V94.1576V94.2414L55.598 94.4522L55.5561 94.6198V94.6617L55.6818 94.7049V94.7887L55.598 94.9143V94.9994H55.6399H55.6818L55.8075 95.0413L55.8926 95.1251L56.0602 94.9994H56.1453L56.229 94.9562L56.1871 94.8725L56.229 94.8306H56.2709H56.4398L56.4817 94.7887V94.7468L56.5655 94.6617L56.5236 94.536H56.5655L56.6074 94.4941L56.6506 94.4522H56.7344L56.6925 94.3671L56.7763 94.2833V94.1995L56.8601 94.1144H56.9871L57.0709 94.0306V93.9887L57.1547 93.9468V93.9049L57.1979 93.778L57.2398 93.6942L57.2816 93.6523L57.2398 93.5672V93.5253L57.1979 93.4415V93.3996V93.2307L57.1547 93.1888V93.105V93.0631L57.1979 93.0199L57.2816 92.7253V92.5578V92.5159L57.3654 92.5578L57.4073 92.5159L57.4492 92.4308L57.5762 92.347L57.7451 92.22L57.9127 92.1781H57.9965H58.0816L58.1235 92.22L58.2492 92.3889H58.2924L58.418 92.347L58.5869 92.22V92.1781H58.6707L58.7126 92.22L58.7964 92.347L58.8815 92.3051H59.0072L59.1761 92.347H59.2599L59.3018 92.3051L59.3869 92.2632V92.1781H59.4288L59.5125 92.1362L59.5544 92.0943H59.6382L59.8909 92.1362L60.0598 92.0943H60.1436H60.1855L60.2706 92.0524L60.4382 92.0105L60.607 91.9254L60.9435 91.7997H61.0273V91.8416V91.9254L60.9435 92.1362V92.1781L61.0273 92.22H61.1124L61.3232 92.1781L61.5327 92.22L61.8704 92.0105H62.038L62.0799 91.9686V91.8835L62.038 91.589V91.4214L61.9961 91.2944V91.2525V91.2106L62.1218 91.0836L62.165 90.9998L62.0799 90.8309V90.6214L62.165 90.4945L62.2069 90.4526L62.2907 90.4945H62.3745L62.5015 90.4107H62.5434L62.796 90.4526L62.7541 90.2837L62.8798 90.1161L62.8379 90.0742L62.8798 90.031L62.9217 89.9472V89.8634L63.0068 89.8215L63.0487 89.6107L63.0906 89.5688H63.1325L63.1744 89.6107V89.6526L63.2595 89.7364H63.3014L63.4271 89.5269V89.4418H63.3852L63.3014 89.3581V89.2324L63.1744 89.1054L63.1325 88.9797V88.9378L63.3433 88.7689V88.6851L63.2595 88.6L63.0906 88.5581V88.4743L63.3014 88.3473V87.969L63.3852 87.9271L63.5122 87.969L63.5541 87.9271L63.6379 87.8001L63.6798 87.7163H63.7649H63.8068L63.9324 87.7582L64.0594 87.8001L64.2689 87.969H64.3108L64.354 87.9271L64.4378 87.8001V87.7163L64.5216 87.5906L64.6905 87.4636L64.5216 87.1691V87.1272L64.6486 87.0015L64.8594 86.8745L64.985 86.6637L65.0269 86.6218L65.0688 86.4961L65.0269 86.4529V86.3691L65.1539 86.2853L65.1958 86.1583L65.2796 86.1164L65.3215 86.0327L65.2796 85.9489L65.3215 85.6543L65.8688 85.6962H66.0795H67.1321H69.9941L70.0779 85.78H70.1211L70.163 85.8219H70.2049L70.2887 85.9489L70.3306 86.0327H70.4994L70.7521 86.1583L70.8778 86.2853L70.9629 86.3691L71.0886 86.4529V86.4961L71.1724 86.5799L71.1305 86.6218L71.1724 86.7488L71.2156 86.7907L71.1724 86.8745L71.1305 86.9164V86.9583V87.0015L71.1724 87.0853L71.2575 87.1272L71.3413 87.296L71.2994 87.3379L71.3413 87.3798L71.5939 87.5055L71.6358 87.5906L71.6777 87.6325L71.7196 87.5906L71.7628 87.6325H71.8047L71.8466 87.6744H71.8885L71.9304 87.8001L71.8885 87.8852H71.9304V87.969L71.9723 88.0528L71.9304 88.1379H72.0155L72.0574 88.2217L72.0993 88.2636V88.3054H72.1412L72.2669 88.1798L72.352 88.1379L72.3939 88.0528H72.4358L72.4777 88.0109L72.5628 88.096L72.6046 88.1798L72.6884 88.2217L72.8573 88.2636H72.9411L73.0249 88.3054L73.1087 88.3473L73.1519 88.3905V88.4743L73.1087 88.5581L73.0668 88.727L73.1087 88.8946V89.0216L73.1519 89.1054L73.1938 89.1473H73.2776L73.3195 89.2324L73.2776 89.3581L73.3614 89.4418L73.3195 89.5269L73.2357 89.6526V89.6945L73.2776 89.7364L73.5722 89.9472H73.6141L73.6573 89.8634L73.5303 89.7364V89.6526L73.5722 89.6107L73.6573 89.5688L73.6991 89.5269L73.8667 89.5688L73.9518 89.6526H74.1194H74.2032L74.2464 89.7796L74.2883 89.8634V89.9472H74.1613L74.1194 89.9891L74.2464 90.0742L74.3302 90.1999L74.2883 90.2837L74.3302 90.3688L74.414 90.4107L74.4559 90.4526L74.414 90.5363V90.5795L74.5829 90.9998L74.7518 91.0417L74.9193 90.9579H75.0463H75.172L75.2558 91.1255L75.3409 91.1687L75.4247 91.2944V91.4214L75.4666 91.4633L75.5085 91.4214L75.7612 91.5052L75.8463 91.4633H75.9719V91.3782H76.0976L76.2246 91.2944V91.1687V91.1255L76.2665 91.0836L76.2246 90.9998L76.2665 90.916L76.3503 90.8309V90.6214L76.3922 90.5363H76.4354L76.5611 90.6214H76.6868L76.7719 90.6633L76.8557 90.5795V90.5363L76.9394 90.4945V90.4526L76.9826 90.4107L76.9394 90.3688L76.9826 90.2837H77.0664L77.1502 90.2418L77.1921 90.3688L77.2353 90.4107L77.4029 90.3688L77.5299 90.4107L77.5718 90.4526L77.6556 90.4945L77.6975 90.5363L77.6556 90.6633L77.6975 90.7052L77.8245 90.9579H77.9083H77.9502L77.9921 90.9998H78.0339L78.2028 91.0836H78.2447H78.3298V91.1255V91.1687L78.3717 91.2106L78.4136 91.3782L78.5393 91.5052L78.5812 91.6308L78.6663 91.7159L78.5393 91.8835L78.4974 91.9254L78.3298 92.2632L78.2866 92.3889V92.5159L78.2028 92.5997V92.6835H78.1609L78.119 92.8104V92.8942V92.978V93.0631L78.2028 93.1888L78.2447 93.2307L78.2866 93.3577L78.3298 93.3996V93.4834V93.5253L78.2866 93.7361L78.3298 93.8198L78.2866 93.863L78.2447 93.8198L78.119 93.778H77.9921L77.9083 93.8198L77.8664 93.9049H77.6556V93.9468V94.0306L77.6975 94.0725L77.7813 94.0306V94.0725L77.7394 94.1995L77.7813 94.2833L77.7394 94.3252L77.6975 94.409V94.4522V94.5779L77.7813 94.536V94.5779L77.8664 94.6198H77.9921L78.0771 94.7049L78.1609 94.7468L78.0771 94.7887L78.1609 94.9143L78.119 94.9562V95.0413H78.0771L77.9502 95.167L77.9921 95.2089V95.2521L78.0339 95.294L78.0771 95.3359L78.3298 95.4616L78.1609 95.5035V95.5467L78.2866 95.6724L78.3717 95.6305V95.7143H78.4136V95.8832H78.4555V95.9251H78.4974V95.967L78.4555 96.1777L78.4974 96.2615H78.5393L78.5812 96.2196V96.2615H78.6244L78.5812 96.3034L78.4974 96.4723H78.4136L78.4555 96.598V96.6831L78.3298 96.725L78.2866 96.8088H78.2028L78.1609 96.7669L77.9921 96.8507L78.0339 96.8939H78.119L78.2866 96.9777V97.1033L78.1609 97.2722L78.2447 97.3141L78.3298 97.356V97.3979L78.2866 97.483L78.3717 97.5249V97.6506L78.4136 97.7776V97.8195V97.9452L78.3298 98.0303V98.1978L78.2866 98.2397L78.3298 98.2829V98.3248H78.2866L78.2447 98.4086L78.2866 98.4505V98.5775L78.2028 98.6194V98.6613L78.119 98.8721L77.9921 98.9559V98.9978L77.9502 99.0397L77.9921 99.1667H77.9502V99.2505L77.9083 99.3342V99.4193L77.8664 99.6288V99.672H77.9921V99.7139L78.119 99.7558V99.7977V99.8815L78.1609 99.9247L77.9921 99.9666V100.05V100.092V100.219L78.0339 100.303L78.119 100.429L78.2028 100.556L78.119 100.598L78.1609 100.681H78.2028L78.2447 100.767H78.3298H78.3717L78.4136 100.892H78.4555V101.061L78.4974 101.145H78.5393L78.5812 101.187L78.6663 101.229L78.6244 101.271V101.314H78.6663H78.7082L78.6663 101.523L78.6244 101.566L78.6663 101.608L78.5812 101.776V102.029L78.6663 102.112V102.197L78.5812 102.281L78.6244 102.408L78.5812 102.45L78.6244 102.534L78.5393 102.661L78.5812 102.703V102.745V102.829V102.912V102.956H78.5393L78.4974 102.997V103.123L78.5812 103.207H78.6244V103.25L78.5393 103.292V103.334L78.5812 103.418V103.503L78.6244 103.545L78.5812 103.67L78.6244 103.755H78.5393V103.712L78.4974 103.67V103.628L78.4555 103.67L78.4136 103.712L78.4555 103.797L78.4136 103.881V104.007L78.3298 104.05V104.134V104.301H78.2866L78.3298 104.345V104.428H78.3717V104.512L78.3298 104.639V104.723L78.2866 104.765V104.892H78.2447H78.1609V104.934L78.919 104.976H81.5701H84.9387H84.9806V105.101L85.0225 105.145H85.0644L85.0225 105.312H85.0644L85.1063 105.27L85.1901 105.312L85.2333 105.354L85.1901 105.481H85.2333H85.2752V105.523L85.3171 105.565V105.607L85.359 105.649H85.4009H85.4428H85.486L85.6117 105.734L85.6536 105.692H85.6117L85.6536 105.565L85.6117 105.523L85.6954 105.565L85.8224 105.439H85.8643L85.9062 105.396L85.9481 105.439H85.99H86.0332V105.481V105.565V105.607L86.0751 105.649H86.117H86.2427H86.2846L86.3697 105.692L86.4535 105.734H86.4954L86.5805 105.776L86.6224 105.692H86.6643L86.7899 105.649L86.8332 105.692L86.875 105.734L86.9588 105.692L87.0426 105.734L87.0845 105.692L87.1277 105.734H87.1696H87.2115V105.692L87.2534 105.649L87.2953 105.692L87.3372 105.859L87.5061 105.817L87.548 105.776L87.5899 105.859H87.6318L87.675 105.776V105.817H87.7588H87.8426V105.776L87.9277 105.817L87.8844 105.944L87.8426 105.901L87.8844 105.986H87.8007V106.028L87.8426 106.07V106.112L87.8844 106.196H87.9695V106.239H88.0114L87.9695 106.281L87.9277 106.323H87.8844V106.407V106.534L87.9695 106.659V106.743L88.0114 106.828V106.912L88.0952 106.996L88.2222 107.038L88.2641 107.165V107.248L88.2222 107.29H88.2641L88.2222 107.334L88.2641 107.459V107.543V107.585L88.2222 107.67V107.712L88.179 107.754H88.1371L88.0952 107.796L88.0533 107.838H87.9277L87.8426 108.048L87.7588 108.09L87.7169 108.132L87.675 108.175L87.6318 108.217L87.5899 108.175V108.217V108.259L87.5061 108.343L87.4223 108.47V108.512L87.2953 108.554V108.596H87.2534L87.2115 108.637V108.596L87.1696 108.637L87.2115 108.679H87.1696L87.2115 108.723H87.1277L87.1696 108.764H87.1277H87.0845L87.0426 108.806L87.0845 108.848L87.0426 108.89L87.0845 108.975L87.0426 109.017H87.0845L87.0426 109.101L87.0845 109.143H87.0426V109.227V109.27V109.396H87.0007L87.0426 109.437V109.523V109.564L87.0007 109.606L87.0845 109.648L87.0426 109.69L87.0845 109.817V109.901H87.1277V109.943V109.985H87.0845V110.027H87.1277V110.07L87.0845 110.112H87.1696V110.154H87.1277L87.1696 110.195L87.1277 110.237L87.1696 110.279H87.1277L87.1696 110.364L87.0845 110.406L87.1277 110.364L87.1696 110.406V110.448V110.532V110.49H87.2115V110.532H87.2534V110.574L87.2953 110.616V110.659V110.701L87.3791 110.743L87.4642 110.785L87.5061 110.743L87.548 110.785L87.5899 110.743L87.6318 110.785L87.7169 110.743L87.8007 110.868H87.8426L87.8844 110.912L87.8426 110.995L87.8844 111.079V111.121V111.163H87.8426L87.9695 111.248L87.9277 111.29L87.9695 111.332V111.374H87.9277H87.8844L87.9695 111.416V111.459L87.9277 111.543L87.8844 111.626H87.9695V111.71L88.0114 111.753V111.795H88.0533V111.837H88.0952L88.2222 111.921L88.2641 112.048H88.306L88.3898 112.174V112.426V112.51V112.553L88.3479 112.595V112.679L88.3898 112.805V112.848L88.4317 112.932V112.974V113.015H88.4736L89.1897 113.605L89.064 113.648L88.9789 113.732V113.774L88.8952 113.857V113.942H88.8533L88.8114 113.984V114.068L88.7263 114.152L88.7682 114.363L88.7263 114.446L88.6844 114.49L88.6006 114.532L88.5168 114.49L88.4736 114.446L88.3898 114.49V114.446L88.3479 114.49H88.306H88.2222V114.532H88.179V114.573V114.615L88.0533 114.657L87.9277 114.826L87.7588 114.868L87.7169 114.91L87.6318 114.994L87.5899 115.037V115.121L87.548 115.246H87.5061L87.4223 115.288L87.3372 115.373L87.3791 115.457V115.541L87.2953 115.668V115.837L87.2115 116.046V116.131V116.173L87.2953 116.383V116.552L87.2534 116.762L87.2953 117.057L87.2534 117.183L87.1277 117.31L87.0426 117.562H86.9588L86.9169 117.646L86.875 117.604H86.8332H86.7899L86.7481 117.646L86.6224 117.604L86.5805 117.646V117.688L86.5373 117.73L86.4954 117.815L86.4535 117.857V117.983H86.4116L86.3697 118.025H86.2846V118.11L86.2427 118.193H86.2008L86.117 118.32H86.0332V118.404L85.99 118.446L86.0332 118.488V118.53V118.572L86.0751 118.615L86.0332 118.699L86.117 118.741L85.9481 118.951H85.9062H85.8643V119.035V119.077L85.7805 119.204V119.288H85.7387V119.457H85.6954L85.6536 119.583H85.5698V119.624V119.709L85.5279 119.751V119.709V119.751V119.793L85.486 119.877H85.4428L85.486 119.962V120.004V120.046V120.088V120.172H85.4428V120.214H85.4009V120.341L85.486 120.424L85.4009 120.466V120.509V120.635L85.359 120.719H85.2752V120.761H85.2333L85.1063 120.888V120.93L84.9387 120.972L84.8955 120.93L84.8117 120.972L84.7698 121.013V120.972L84.6442 121.013L84.4753 121.14V121.266H84.3915V121.308H84.3483L84.3064 121.351L84.1807 121.435H84.1388L84.0969 121.477H84.0537L83.9699 121.435L83.8442 121.477V121.519L83.801 121.561V121.603V121.646L83.7591 121.603L83.7172 121.688H83.6334V121.73H83.5915V121.772L83.5064 121.813V121.855V121.898L83.4646 121.94L83.5064 121.982H83.4646L83.4227 122.024H83.4646H83.4227L83.4646 122.066L83.4227 122.108H83.3808V122.151H83.3389V122.193L83.3808 122.235L83.3389 122.277L83.17 122.193L83.0862 122.235L83.0024 122.193V122.066H82.9592L82.8754 122.024L82.7497 121.982L82.7065 121.898L82.6227 121.855H82.5389L82.3282 121.772L82.2863 121.688L82.1174 121.561L82.0755 121.477L82.0336 121.393L82.0755 121.308L82.0336 121.266H81.9917L81.8647 121.351H81.8228L81.7809 121.266H81.739H81.6971H81.6552V121.308L81.5282 121.351L81.4863 121.182H81.5282L81.5701 121.224V121.182L81.5282 121.14V121.057L81.5701 121.013L81.612 121.057L81.6552 121.013L81.4863 120.93L81.4025 120.972L81.3174 120.93H81.2756H81.2337V120.972L81.3607 121.013L81.3174 121.057L81.2337 121.099H81.1918L81.1499 121.013H81.108L81.0229 120.972H80.981V121.057L80.9391 121.14V121.182L80.8972 121.224L80.7702 121.14L80.6864 121.224L80.7283 121.099H80.6864L80.6445 121.14L80.6864 121.182L80.6445 121.224L80.6026 121.182V121.14L80.5188 121.099H80.4337V121.057L80.3918 121.14L80.4337 121.182L80.3499 121.266L80.2661 121.182L80.1811 121.224L80.1392 121.182L80.0973 121.14L80.0554 121.099V121.013H80.0135H79.9284L79.8446 121.057L79.8027 121.013V120.93L79.7189 120.888H79.6757L79.7189 121.013L79.6338 121.057H79.4662V121.14H79.3811H79.1716L79.0447 121.182L79.0866 121.266H79.0447H79.0028L78.919 121.308L78.6663 121.393L78.5393 121.308H78.4136L78.3298 121.266L78.2447 121.224V121.182L78.119 121.14H78.0771H78.0339L77.9921 121.099L78.0339 120.972L77.9921 120.93L77.9502 120.972V121.013H77.8664L77.7813 121.099H77.7394V121.013H77.6975V121.099H77.6556L77.5718 121.057V121.14H77.5299L77.4029 121.099V121.057L77.3191 121.099L77.2353 121.013L77.2772 121.057L77.1921 121.099L77.0664 121.182L77.0245 121.14V121.182H76.9394L76.8976 121.14L76.8557 121.182L76.8976 121.224L76.8557 121.266H76.8138V121.14H76.7719L76.73 121.224L76.6868 121.266L76.5611 121.224L76.5192 121.182V121.266H76.4773V121.224L76.3922 121.266L76.3503 121.351V121.266V121.224V121.182H76.3084L76.2665 121.266L76.1827 121.224V121.099L76.0976 121.013V120.888V120.761L76.0138 120.593V120.551L75.93 120.593H75.8881L75.8031 120.551V120.509L75.7193 120.424L75.6774 120.466L75.6355 120.424H75.5504L75.5936 120.341L75.5504 120.299H75.5085L75.5504 120.214L75.5085 120.172L75.3828 120.13V120.172H75.4247L75.3828 120.214L75.2977 120.088V119.919H75.2558H75.2139L75.172 119.962L75.0882 119.835H75.0031V119.666L74.9193 119.709L74.8355 119.666V119.624H74.7936L74.7518 119.541L74.6667 119.457V119.415L74.7086 119.33V119.204L74.6667 119.162L74.6248 118.951L74.6667 118.868L74.6248 118.824L74.5829 118.783H74.541L74.4991 118.868H74.4559L74.414 118.783L74.3721 118.741L74.3302 118.699V118.572H74.2464V118.657V118.699V118.741L74.2032 118.824L74.1194 118.783V118.615L74.0356 118.53H73.9937L73.9518 118.615L73.9086 118.572H73.8667L73.8248 118.741H73.741V118.783L73.6573 118.741L73.6991 118.824H73.6573L73.5722 118.741L73.5303 118.783L73.4884 118.699H73.4046L73.3614 118.783L73.3195 118.699L73.2357 118.783V118.741H73.2776L73.2357 118.699L73.1938 118.741L73.1087 118.699L73.0668 118.741L72.983 118.657L72.9411 118.699L72.8992 118.657V118.572V118.53L72.8141 118.657L72.7722 118.572L72.6884 118.488V118.362L72.6465 118.32H72.6046L72.5628 118.404L72.5196 118.362L72.5628 118.277V118.235H72.5196L72.4777 118.32H72.4358V118.193H72.3939L72.352 118.235L72.3939 118.32L72.2669 118.362L72.1412 118.235L72.0574 118.277H71.9723L71.8885 118.235L71.552 118.068V117.983L71.6358 117.941L71.5939 117.899L71.5101 117.941H71.4683L71.4251 117.899L71.4683 117.815V117.773H71.4251H71.3413L71.3832 117.646V117.604H71.3413L71.2575 117.646V117.688L71.1724 117.773H71.0467V117.857L71.0048 117.815L70.9629 117.857L70.8778 117.815L70.8359 117.899V117.941V117.983L70.7521 117.899V117.815H70.7102L70.6683 117.941L70.5413 117.899L70.4575 117.773L70.3738 117.604V117.562V117.477V117.435L70.2468 117.393L70.2049 117.435L70.163 117.477H70.1211L70.0779 117.435L70.1211 117.352L70.036 117.268H69.9941L69.9103 117.099L69.8265 117.057V116.931L69.7414 116.888L69.6576 116.804H69.5738L69.5306 116.846V116.888L69.4887 116.931V116.846H69.4049L69.363 116.931H69.3211L69.2793 116.888V116.846L69.1104 116.804L69.0685 116.721L69.1104 116.594H69.0266V116.468L68.9415 116.426L68.8577 116.173L68.8158 116.088H68.732L68.6469 116.046L68.6888 115.921L68.7739 115.879V115.837L68.732 115.794H68.6888H68.5631V115.752L68.605 115.71V115.626H68.5212H68.4374H68.3942V115.541L68.3104 115.584V115.541V115.499H68.2266V115.373H68.1848L68.1415 115.415L68.1848 115.499L68.0997 115.541L68.0159 115.457L67.974 115.415L67.9321 115.457L67.974 115.541V115.584L67.9321 115.626H67.8051L67.7632 115.668H67.6375V115.71H67.6794V115.752L67.7213 115.794V115.837H67.6375L67.5943 115.794H67.5524H67.3429L67.1321 115.71L67.0052 115.626L66.8795 115.668L66.8376 115.626L66.6687 115.499L66.6268 115.331L66.543 115.288L66.4998 115.331L66.4579 115.288L66.416 115.246H66.543L66.4579 115.163V115.037H66.2484H66.0376L65.8688 114.91L65.7431 114.657L65.6161 114.615L65.4904 114.573L65.3634 114.532L65.3215 114.446L65.1107 114.363L64.985 114.405L64.9013 114.321L64.6054 114.237H64.4378L64.3108 114.152L64.2689 114.194L64.1851 114.279L64.1432 114.321L64.1013 114.279L64.0162 114.405L63.8905 114.363L63.7649 114.279H63.6798L63.6379 114.321V114.405L63.596 114.532V114.615V114.657L63.5541 114.699H63.469L63.3433 114.784L63.2163 114.826L63.1744 114.784L63.0068 114.657H62.9649V114.699L62.9217 114.742L62.8379 114.657L62.7541 114.742H62.7123L62.6704 114.615L62.5853 114.573H62.5434L62.5015 114.615H62.4596H62.4177V114.532H62.3745L62.3326 114.573L62.2488 114.657H62.2069V114.532L62.165 114.49H62.1218H62.0799L62.038 114.657V114.699H61.9961H61.9542H61.9123L61.8704 114.657L61.9123 114.573V114.405H61.8272L61.7853 114.446H61.7434L61.6596 114.405H61.6178L61.5327 114.321L61.407 114.49L61.28 114.532L61.2381 114.615L61.1962 114.657L61.1543 114.615L61.1124 114.573L61.1543 114.446V114.363H60.9435H60.8178L60.4814 114.321L60.3963 114.237L60.3544 114.194L60.1855 114.026L60.1017 113.899L60.0179 113.857L59.849 113.774L59.8071 113.648V113.605L59.849 113.521L59.8909 113.31V113.099L59.849 112.89L59.8071 112.848L59.7233 112.89L59.5544 112.974H59.5125L59.4288 112.848L59.3869 112.805H59.3018H59.1342L58.7964 112.679L58.6288 112.637L58.5437 112.553L58.5018 112.343L58.5437 112.216L58.6288 112.09V112.048L58.5437 111.963L58.5018 112.006L58.3761 112.048L58.418 112.174V112.301L58.3761 112.426H58.2924H58.2492L58.2073 112.343L58.2924 112.132L58.2492 112.09L58.2073 112.048L58.0816 111.963H57.9965L57.9546 112.048L57.8289 112.216H57.787L57.7451 112.132V112.048L57.8289 111.921L57.9127 111.879L57.9546 111.795L57.9127 111.71L57.8289 111.543L57.787 111.501H57.7019H57.66H57.4924L57.2816 111.626L57.1979 111.543L57.1128 111.416L57.0709 111.374L56.9871 111.416L56.9452 111.543H56.902H56.8601L56.7763 111.374H56.7344L56.6074 111.416H56.5655V111.332L56.6074 111.248L56.5655 111.206L56.5236 111.248V111.206L56.6074 111.079L56.6925 110.785L56.6506 110.743L56.5655 110.701H56.3979L56.3128 110.574V110.532L56.3979 110.321V110.112L56.2709 109.732V109.648L56.229 109.564H56.1453L55.9764 109.648H55.6399L55.598 109.69L55.6818 109.774V109.817V109.859H55.598L55.3453 109.732L55.1764 109.606L55.1345 109.564L55.1764 109.523L55.3453 109.354L55.4291 109.185V109.143L55.3453 108.975V108.932L55.3872 108.848L55.3034 108.764V108.679L55.4291 108.554L55.471 108.428L55.4291 108.385L55.3872 108.343H55.1764L54.9238 108.259H54.8819L54.84 108.175L54.7562 107.712V107.501L54.6711 107.29L54.713 107.207L54.9238 107.165L54.9657 107.123L54.9238 107.038H54.6711L54.6292 106.996L54.5454 106.659V106.448L54.5873 106.407L54.7562 106.365L54.7981 106.323L54.7562 106.239H54.713H54.6292H54.5873L54.5035 105.986V105.901L54.5873 105.817L54.713 105.692L55.0089 105.607L55.0508 105.523L55.0089 105.439L54.9238 105.27L54.8819 105.228L55.0926 105.059L55.2183 104.976V104.934L55.0926 104.807L55.0508 104.681L55.0089 104.554V104.512L55.1345 104.554L55.0508 104.218L54.7981 103.881L54.6711 103.797H54.5873L54.5035 103.755V103.628H54.5873L54.6292 103.503L54.5873 103.376L54.6292 103.207V103.081L54.5873 102.956L54.5454 102.829L54.4184 102.787H54.2927L54.2508 102.745V102.703L54.2089 102.661L54.167 102.618L54.2089 102.576V102.492L54.2927 102.45V102.408V102.365L54.2508 102.197L54.167 102.07L54.2089 101.903L54.1238 101.818L54.0819 101.734L54.1238 101.608H54.2508L54.3346 101.523L54.4184 101.398V101.187L54.3346 101.019L54.4184 100.892L54.5035 100.85L54.6292 100.681L54.7562 100.556L54.84 100.303L54.8819 100.261L54.9238 100.176L54.9657 100.092V100.05V100.008L54.8819 99.8396V99.7139L54.9238 99.545L54.8819 99.2923L54.7981 99.2086L54.7562 99.0397L54.713 98.9559L54.7981 98.6613L54.7562 98.4924L54.713 98.4086V98.2829V98.1978L54.7562 98.0303L54.9657 97.8195L55.0089 97.6506L54.9657 97.5668L54.7981 97.4411L54.713 97.2303L54.6292 97.0615L54.5873 96.8939L54.5035 96.8088L54.3346 96.6412L53.9981 96.5142V96.5561L54.04 96.598V96.6412L53.9981 96.725L53.8293 96.8088H53.7874L53.7455 96.7669V96.8088L53.7874 96.8939L53.6617 96.9358V97.1452V97.2303V97.2722L53.5766 97.3141L53.4509 97.2303L53.409 97.3979H53.3239L53.282 97.4411V97.483L53.3239 97.6087V97.6506H53.282L53.2401 97.6087L53.0725 97.6506V97.5249H53.0293L52.9455 97.5668L52.9036 97.6087L52.8618 97.5668L52.8199 97.3979H52.778L52.7348 97.483V97.4411L52.6929 97.3979L52.778 97.3141H52.7348H52.6929L52.6091 97.2303L52.4821 97.356V97.4411L52.3564 97.3979L52.4402 97.2722L52.3564 97.1884V97.1452H52.3983H52.4821H52.524L52.5672 97.1033H52.524V97.0196L52.4402 97.0615L52.3983 97.1033H52.3145H52.2294L52.1875 97.1452V97.2303H52.1456L52.0618 97.1452L51.978 97.1033L52.0199 97.0196V96.9358L51.9348 96.9777V97.0196L51.978 97.1452L51.9348 97.1884L51.8929 97.2722L51.851 97.3141L51.8091 97.2722V97.3141L51.7673 97.2722L51.7254 97.1884L51.8091 97.1452V97.1033H51.7673L51.7254 97.0615H51.6835V97.1452H51.5984V97.2303L51.5565 97.2722V97.3141H51.4308H51.3457L51.3876 97.2303V97.1884L51.4308 97.1452L51.3876 97.1033L51.3457 97.0615H51.2619L51.1781 97.1033V97.1452H51.093V97.0615H51.0511L51.0092 97.1033L51.0511 97.1452H51.0092L50.9673 97.1884V97.1452L50.9254 97.1033L50.8403 97.1452L50.7565 97.1884L50.7146 97.356L50.7984 97.3979H50.7565L50.6728 97.356V97.4411L50.6309 97.3979H50.589V97.3141L50.462 97.4411H50.4201L50.3363 97.2722H50.1255L50.0404 97.3141L50.0836 97.356H50.0404L49.9985 97.4411L49.9566 97.3979V97.3141V97.2722H49.9147H49.8728V97.3141H49.789V97.2722L49.7458 97.3141L49.7039 97.2722L49.662 97.3141L49.6201 97.2722L49.4945 97.3141V97.3979H49.3675V97.4411L49.4094 97.5249L49.3675 97.483L49.3256 97.5249H49.3675L49.2837 97.5668H49.2418L49.1986 97.5249L49.0729 97.4411V97.5249L49.031 97.483V97.5249L48.9891 97.5668H48.9459L48.8621 97.6087V97.5249L48.8202 97.5668V97.6506H48.7783L48.6945 97.6087H48.6513L48.6094 97.5668L48.5675 97.6087H48.4L48.3568 97.6506V97.6925V97.7776L48.1892 97.8195L48.0622 97.7776V97.8195L48.0203 97.8614V97.9033H47.9784L47.9365 97.9452V97.9884H48.0203H47.9365L47.8946 97.9452L47.9365 97.8195L47.8527 97.7776L47.8095 97.8195H47.7257L47.7676 97.8614H47.7257L47.6419 97.8195H47.6H47.5149V97.9033H47.473V97.8614H47.3893L47.3474 97.9033H47.3055L47.1785 97.8614V97.9452L47.0947 97.9033H47.0528L47.0947 97.9452L47.0528 97.9884L47.0096 97.9452L46.9677 97.9884V98.0303L46.9258 97.9884L46.715 97.9452L45.5786 97.4411Z"
							fill="#1169bc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="AC" @mouseenter="e => hoverES(e, 'AC')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M2.17829 80.1836L2.55796 80.3931L5.12532 81.5308L7.98726 82.8347L9.08176 83.382L9.29254 83.4671L12.1977 84.0562L12.2815 84.0981L13.2071 84.3927L13.3341 84.4346H13.4598L16.0284 85.0656L16.4068 85.1507L18.0485 85.5291L19.943 85.9926L22.2158 86.4547L22.89 86.6236L23.4792 86.7506L23.9413 87.0452L24.952 87.5924L27.268 88.8545L28.5301 89.5706L29.2462 89.949L30.8461 90.7908L32.0244 91.38L33.2878 92.0961L33.4972 92.1799L33.6661 92.265L34.3391 92.5596L37.0334 93.7379L38.5495 94.4108L42.337 96.0525L43.3477 96.4741L43.5166 96.5998L43.7261 96.643L43.9788 96.7687L45.5786 97.4429L46.715 97.947L46.6731 97.9902V98.074H46.6312L46.6731 98.1578H46.6312V98.1996H46.6731V98.2415H46.6312L46.5893 98.3266L46.5474 98.2847L46.5056 98.2415V98.2847V98.2415L46.4205 98.2847L46.4623 98.3266L46.4205 98.4104L46.3786 98.3685V98.4523H46.2529L46.1259 98.4942L46.084 98.5361H46.0421H46.0002V98.5793L45.9583 98.6212H45.9151L45.8732 98.6631H45.8313V98.705H45.7894V98.7888L45.7475 98.7469L45.6637 98.7888V98.832L45.5786 98.8739V98.9158V98.9577H45.4948L45.4529 99.0415H45.3692V99.0847V99.1685L45.2841 99.2104V99.1685H45.2003H45.1584H45.1165L45.1584 99.2523V99.2941L45.1165 99.2523L45.0733 99.336V99.2941V99.3792L45.0314 99.336L44.9895 99.3792V99.4211V99.463H44.9057V99.5049V99.463L44.8638 99.5049L44.9057 99.5468V99.5887L44.8206 99.5468L44.7787 99.5887V99.6306H44.7368L44.6949 99.6738L44.653 99.8414L44.6111 99.8833V99.7995L44.5692 99.8833H44.526V99.8414L44.4841 99.8833H44.526H44.4841L44.4003 99.9684V99.9265V100.01L44.3584 100.052H44.4422L44.4003 100.094L44.3584 100.136V100.094L44.3166 100.136V100.221L44.2747 100.263V100.305L44.2315 100.263V100.305H44.1896L44.1477 100.347L44.1058 100.305V100.347H44.0639L44.022 100.389H44.0639L43.895 100.474L43.8531 100.516H43.8112V100.474H43.7693H43.7261L43.6423 100.516H43.5585L43.5166 100.558V100.641L43.5585 100.683H43.5166L43.4747 100.725H43.4315L43.3477 100.768L43.3058 100.81H43.2221L43.137 100.725H43.0113L42.9694 100.683H42.8843L42.8424 100.725L42.7167 100.768L42.6748 100.725L42.5897 100.683L42.5478 100.725L42.5059 100.683V100.725L42.4221 100.683L42.3802 100.725L42.337 100.768L42.4221 100.852L42.3802 100.936L42.4221 101.021V101.063H42.3802L42.337 101.105L42.2532 101.063H42.1694V101.147L42.0857 101.063L42.0006 101.105L41.9168 101.063L41.8749 101.021H41.833L41.7479 101.147L41.7911 101.23V101.399H41.7479H41.706L41.6641 101.441V101.525L41.6222 101.568L41.4533 101.61L41.4114 101.652L41.3276 101.694L41.2425 101.652L41.1587 101.694V101.778H41.0331H40.9912L40.9061 101.82L40.7804 101.863L40.7385 101.905L40.6115 102.114L40.5696 102.241L40.4439 102.367L40.4007 102.452L40.275 102.578L40.148 102.494L39.9804 103.209L39.9386 103.167L39.8967 103.209L39.8535 103.167V103.209H39.8116V103.167L39.7697 103.209V103.167L39.7278 103.083H39.6859L39.644 103.041H39.6021H39.5589V102.999H39.4751V102.957L39.4332 102.999V102.914H39.3494V102.872L39.3062 102.914V102.872L39.2643 102.83L39.1805 102.788L39.1386 102.83L39.0967 102.788H39.0535L39.0116 102.747H38.9278H38.8441L38.8022 102.788V102.747H38.7171L38.6752 102.83L38.6333 102.788L38.5914 102.83H38.5076V102.788V102.83L38.4225 102.788L38.2968 102.872L38.2117 102.83L38.1279 102.788V102.83L38.086 102.788V102.83L38.0441 102.788L38.0022 102.83H37.959V102.914H37.9171H37.8333L37.7495 102.957V103.041L37.7077 102.999L37.6645 103.083L37.6226 103.125L37.5807 103.167H37.5388L37.4969 103.252V103.294V103.378H37.5388L37.5807 103.419L37.5388 103.461V103.505L37.4969 103.546L37.5388 103.588L37.4969 103.63L37.4131 103.672L37.3699 103.757L37.2861 103.799V103.841L37.2023 103.883L37.1172 104.009H37.0753L37.0334 104.136H36.9496L36.9077 104.261H36.8658L36.9077 104.303L36.8658 104.43L36.7807 104.472L36.7388 104.556V104.599V104.683L36.6969 104.767L36.6132 104.809L36.57 104.852L36.4862 104.894L36.4443 104.977H36.4024H36.3605H36.2335L36.1916 105.019L36.1497 105.103L36.1078 105.146L36.0227 105.061H35.9808L35.7713 105.146L35.7281 105.23L35.7713 105.272L35.7281 105.314L35.6862 105.356V105.398L35.6443 105.356L35.6024 105.314H35.5605L35.4755 105.23L35.3917 105.314L35.139 105.356L35.0133 105.441V105.525L34.9282 105.608L34.8025 105.694V105.735L34.381 105.819L33.708 105.988L33.7499 105.861L33.6661 105.777L33.708 105.694L33.6242 105.65H33.5823H33.5391L33.4972 105.608L33.4553 105.567V105.525L33.4134 105.483L33.4553 105.398L33.4134 105.356L33.4553 105.272H33.4972V105.23V105.188L33.5391 105.103H33.4972L33.4553 105.146L33.4134 105.103H33.4553V105.061L33.3715 105.103L33.3297 105.061V105.019L33.2878 105.061V105.146V105.061L33.2027 105.019L33.2446 104.977H33.2027V105.019H33.1189L33.1608 105.061H33.1189H33.077L33.0351 105.103L32.9919 105.061L33.0351 105.019H32.9919L32.95 105.061L32.9081 105.019H32.95H32.9081L32.8243 105.061V105.146H32.7824L32.7392 105.103H32.6973L32.6554 105.146H32.6973V105.103L32.7392 105.188H32.6973L32.6554 105.146V105.103H32.6135L32.5297 105.188L32.4446 105.146L32.3608 105.061L32.277 105.103V105.061H32.2352L32.277 104.977H32.1933H32.1501L32.0663 105.019H32.0244L32.0663 105.103H31.9825V105.061L31.9406 105.103L31.8974 105.061H31.8555L31.8974 105.019V104.977H31.8136V104.936H31.7717L31.7298 104.894L31.6879 104.936L31.6447 104.894L31.5609 104.936L31.519 104.809L31.4771 104.894L31.4352 104.852L31.3501 104.894L31.2663 104.852L31.2244 104.936L31.1825 104.852H31.0988V104.809L31.0556 104.852H31.0137L31.0556 104.809H31.0137V104.767L30.9299 104.809L30.8461 104.767L30.8029 104.725H30.7191L30.6353 104.767L30.5934 104.725L30.5083 104.641L30.4664 104.725L30.3826 104.683H30.4245V104.641L30.2988 104.683L30.2556 104.725H30.2988L30.2556 104.767L30.2137 104.683H30.1718V104.725L30.1299 104.683L30.088 104.725L29.9611 104.683V104.641L29.9192 104.725H29.8773V104.683L29.8354 104.725H29.7935L29.8354 104.641H29.7516V104.683L29.6665 104.641L29.6246 104.725V104.683H29.5827L29.5408 104.599L29.4989 104.641L29.5408 104.683H29.4989L29.4557 104.599L29.4138 104.641L29.3719 104.556H29.33L29.2881 104.641H29.1611V104.725L29.1192 104.683V104.725H29.0773L29.0354 104.683L28.9935 104.725V104.767L28.9517 104.725H28.8666V104.641L28.8247 104.683L28.7409 104.641H28.6152V104.725H28.572H28.5301V104.683L28.3193 104.641V104.683V104.725L28.2355 104.683H28.1517V104.767L28.1098 104.725L28.0247 104.767L27.8572 104.725L27.8153 104.809L27.7721 104.767L27.6883 104.809L27.6464 104.852L27.6045 104.809L27.5207 104.894L27.4775 104.809L27.3937 104.894L27.3518 104.852L27.3937 104.809H27.3518L27.3099 104.725L27.268 104.641H27.2248V104.683L27.1829 104.641V104.599L27.0991 104.641L27.0572 104.599H27.0153V104.556H26.9302V104.599H26.8045H26.7627L26.6776 104.556L26.6357 104.599L26.5938 104.556L26.5519 104.599L26.51 104.556L26.383 104.514L26.2992 104.556L26.2573 104.599L26.2154 104.556H26.1735H26.0465V104.641H26.0046H25.9627L25.9208 104.725L25.8776 104.683L25.8357 104.767L25.7938 104.725L25.7519 104.809V104.767L25.71 104.809L25.6682 104.852H25.5831V104.894L25.5412 104.852V104.894H25.4574L25.4993 104.936L25.4574 104.894L25.4155 104.936H25.3736V104.977H25.3317H25.2885H25.2466V104.936L25.2047 104.977V104.936L25.1628 105.019H25.1209L25.1628 104.977L25.079 105.019V105.103V105.061H25.0358V105.103H24.9939L24.952 105.188H24.9101L24.8682 105.23L24.7844 105.272V105.314L24.7412 105.272V105.314H24.6993L24.6574 105.272V105.314H24.5737V105.356L24.5318 105.398L24.4467 105.356H24.3629H24.321L24.2791 105.314L24.1521 105.356H24.1102L24.0683 105.441L24.0264 105.398H23.9845L23.9413 105.441L23.8156 105.483L23.7318 105.441L23.6467 105.483L23.6048 105.441L23.5629 105.398L23.4373 105.441L23.3941 105.398V105.356H23.3522L23.2684 105.314L23.2265 105.356V105.314L23.1427 105.272L23.0995 105.314L23.0576 105.272H23.0157L23.0576 105.23L22.9738 105.061L22.8468 104.977L22.8049 104.852L22.7211 104.809H22.6792L22.6373 104.725H22.5522V104.683L22.4684 104.641L21.9212 105.019L21.8793 103.209V101.61V100.978V99.1266L21.9212 98.4104V97.5267V97.4848L21.9631 97.3578H22.0482L22.0901 97.3997L22.132 97.274L22.1739 97.2321L22.2996 97.274L22.3847 97.2321L22.4265 97.147V97.0214H22.4684V96.9376L22.5103 96.8957L22.4684 96.8525L22.5103 96.8106H22.4684L22.3847 96.5998H22.3428V96.516H22.2577L22.1739 96.4322L22.2158 96.3903L22.132 96.3484L22.0482 96.1376L22.0901 96.0957L22.132 96.0106H22.0901L22.132 95.9688V95.885L22.0482 95.8431V95.8012L22.132 95.758L22.0901 95.885H22.132L22.1739 95.8431L22.2577 95.9269H22.2996L22.3428 95.885L22.2996 95.8012H22.2158V95.758L22.2577 95.7161L22.2158 95.6323H22.2577L22.2996 95.6742H22.3847H22.4265V95.6323H22.3847V95.5053L22.4684 95.5485V95.4634H22.5103L22.5954 95.3796L22.6373 95.4634V95.4215L22.5522 95.2958L22.5103 95.2107L22.5522 95.1688L22.5954 95.2107H22.6373L22.5954 95.085H22.6373H22.6792L22.7211 94.958L22.6792 95.0012L22.6373 94.958L22.5522 95.0012V95.0431H22.5103V95.0012L22.4265 95.0431V95.0012L22.3847 94.958L22.3428 95.0431H22.2996V95.0012H22.2577H22.2158V95.0431L22.132 95.085H22.0901L22.0482 95.1688H22.005H21.9631V95.2539V95.2958L21.9212 95.2539L21.8793 95.2958L21.8374 95.3377V95.3796V95.4215V95.4634L21.7523 95.4215L21.7955 95.4634H21.7104V95.5053V95.5485V95.5053L21.6685 95.5485H21.7104H21.6685V95.5904L21.6266 95.5485L21.5847 95.6323H21.5428V95.6742L21.5009 95.6323L21.4158 95.7161H21.3739L21.332 95.758L21.2902 95.8012H21.2483H21.2902V95.8431L21.2483 95.885L21.1632 95.8012L21.1213 95.8431L21.0794 95.885H21.1213L21.0794 95.9269V95.9688L21.0375 95.9269L21.0794 95.9688H21.0375L21.0794 96.0106V96.0957H21.0375H20.9956V96.1376L20.8686 96.1795V96.2214H20.9105L20.8686 96.2633L20.8267 96.3052L20.7848 96.3484H20.701L20.6578 96.3903L20.6159 96.3484V96.3903L20.574 96.3484V96.4322L20.4902 96.4741V96.4322L20.3632 96.516L20.2794 96.5998V96.643H20.2375L20.1957 96.8106H20.1538L20.1119 96.8957H20.0687L20.0268 96.9795H19.8592V97.0214V96.9795L19.816 97.0633L19.7741 97.0214V97.0633L19.7322 97.1051L19.6484 97.3159L19.6065 97.274V97.3997V97.4429V97.4848H19.4376L19.3538 97.4429L19.3119 97.4848H19.2268L19.1849 97.5267H19.1011L19.0174 97.6105L18.8904 97.6943L18.6796 97.7794L18.5539 97.8632L18.512 97.9051L18.4688 97.947L18.4269 98.1159L18.385 98.1578L18.3431 98.2415L18.2593 98.3266V98.4523H18.1323L18.0066 98.4104H17.9648V98.4942H17.8797L17.6283 98.5793H17.5851L17.4594 98.4523L17.3743 98.4942V98.5793H17.3324L17.2905 98.5361L17.2067 98.6631H15.4812H12.1126V98.5793L12.2396 98.5361L12.2815 98.4523V98.3685V98.2847L12.1977 98.2415L12.1558 98.1996L12.1977 98.1159L12.2815 98.074L12.3234 97.947L12.4072 97.9051L12.3653 97.8632L12.2815 97.7794V97.6105L12.2396 97.5686V97.5267L12.3653 97.3997L12.4504 97.3578L12.2815 97.274L12.1126 97.1902H12.0288L11.945 97.147L11.9031 97.1051L11.8599 97.147L11.7761 97.0633H11.6923V97.0214L11.7342 96.8957V96.8106L11.7761 96.6849V96.5579L11.818 96.4741L11.7342 96.3484L11.7761 96.1795H11.7342H11.6923L11.5653 96.0957L11.6085 95.7161L11.5234 95.6742L11.3978 95.7161L11.3127 95.6742L11.2289 95.7161H11.187L11.1032 95.6323V95.5904H11.0613V95.5485V95.4634H11.0181L10.9762 95.4215H10.9343L10.8924 95.3796L10.8505 95.4215H10.8086L10.7654 95.3796H10.7235L10.6397 95.2958L10.5978 95.3377H10.5559H10.514H10.4708H10.4289V95.2958V95.3377H10.387L10.3451 95.3796L10.2182 95.3377V95.3796L10.1763 95.3377H10.1344L9.96679 95.3796H9.92358L9.88169 95.3377H9.92358H9.88169V95.2958H9.83979V95.2539V95.2958L9.7979 95.2539H9.756H9.71411V95.2958V95.2107L9.6709 95.2539V95.2107H9.62901L9.58711 95.1688V95.2107L9.50332 95.1688H9.41954L9.37633 95.1269L9.33444 95.1688V95.1269H9.29254V95.085L9.25065 95.1269L9.20875 95.085L9.16686 95.1269H9.12496H9.08176L9.03986 95.085V95.0431L8.95607 95.085V95.0431H8.91418L8.87229 95.085V95.0431H8.82908V95.0012V95.0431L8.74529 95.0012L8.7034 94.958L8.74529 94.9161V94.8743H8.7034H8.28183H5.84146L5.92525 94.7905L5.96715 94.6216V94.5797L6.05094 94.5378L6.17793 94.4959L6.21982 94.4108L6.30361 94.3689L6.34551 94.2432L6.5144 94.2013V94.1594L6.4725 94.0743L6.43061 94.0324L6.55629 93.9905L6.68328 93.7798L6.80897 93.696L6.85086 93.7798H6.89276L7.01975 93.696V93.6541L7.10354 93.6122L7.14544 93.569L7.18733 93.5271V93.4852L7.06165 93.4433L7.01975 93.4014L7.14544 93.3163L7.31432 93.2325L7.39811 93.1487L7.4819 92.9379V92.7703L7.52511 92.6852L7.4819 92.6015V92.4326L7.44001 92.3488V92.3069L7.4819 92.265L7.52511 92.1799L7.35622 92.138L7.23053 91.7596L7.10354 91.7177H7.01975V91.5489L6.97786 91.6758L6.93596 91.7177L6.85086 91.6326L6.80897 91.4651V91.38L6.76707 91.3381V91.2124H6.68328L6.59819 91.0854V90.9178L6.4725 90.7908L6.43061 90.5381L6.3874 90.4125L6.30361 90.3706L6.21982 90.2436H6.13603L6.00904 90.2017L5.92525 90.2436H5.84146L5.79826 90.2017H5.75636L5.71447 90.1179H5.67257L5.58878 90.0328V89.9071L5.54689 89.8652L5.50369 89.9071V89.8233L5.46179 89.7814L5.378 89.8233L5.33611 89.6544L5.378 89.6125L5.4199 89.4436L5.33611 89.1072L5.25101 88.8964H5.12532L5.08343 88.8545H4.99833L4.87265 88.8126L4.83075 88.8545V88.8126L4.74696 88.8545L4.66186 88.7288L4.61997 88.5599L4.57807 88.4761H4.53618H4.49428H4.40919L4.3254 88.3923L4.15651 88.3491H4.11461V88.2654H4.03082L3.94703 88.2235L3.82004 88.0546L3.86194 87.8451L3.77815 87.76L3.82004 87.5924L3.73625 87.4654L3.69436 87.4235V87.3816L3.60926 87.3397L3.56736 87.2127L3.48357 87.1709L3.52547 87.0452V86.9601L3.48357 86.7925L3.52547 86.6655L3.48357 86.4979L3.39978 86.4128L3.31468 86.2871L3.2309 86.2452L3.27279 86.1182V85.9926L3.14711 85.8656L3.02011 85.9088H2.93632L2.89443 85.698L2.80933 85.6129H2.68365L2.64175 85.6561H2.59986L2.55796 85.6129L2.51476 85.571V85.4453L2.47286 85.3615L2.34718 85.2345L2.38907 85.1926H2.47286L2.38907 85.0237L2.43097 84.94H2.47286L2.55796 85.0656H2.72554H2.76743L2.85253 84.94L2.89443 84.8562V84.7292L2.93632 84.5184L2.89443 84.3927L2.80933 84.3508L2.59986 84.2238L2.55796 84.1819L2.26339 84.0981H2.0945L2.05261 84.0562L1.96751 83.9292L1.92561 83.8036H1.79993L1.67293 83.6766L1.63104 83.509L1.50536 83.4671L1.37836 83.3401L1.12568 83.0874H1.04189L1 82.8766H1.04189H1.12568L1.25268 82.8347L1.37836 82.6253V82.5402L1.46346 82.4564L1.37836 82.3726V82.1618L1.29457 82.078L1.16889 81.7834V81.6984L1.21078 81.6565L1.25268 81.6984L1.29457 81.7834L1.33647 81.7402H1.37836L1.50536 81.8672L1.75803 81.9091L1.79993 81.8253L1.84182 81.6984L2.01071 81.6146H2.0945L2.22018 81.6565L2.38907 81.5727H2.43097V81.6146V81.6984H2.47286L2.68365 81.5727L2.80933 81.4038V81.3619L2.72554 81.193V80.9835L2.64175 80.8984L2.51476 80.8146L2.47286 80.7727L2.43097 80.562L2.34718 80.4782L2.30528 80.3931L2.22018 80.3093V80.2674L2.17829 80.1836Z"
							fill="#3482cc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="AM" @mouseenter="e => hoverES(e, 'AM')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M2.17822 80.1811L2.22012 80.1379L2.34711 80.0122L2.55789 79.7596L2.64168 79.592V79.5069L2.55789 79.465V79.3393V79.2542L2.4728 79.0866V79.0434L2.55789 78.8758L2.68358 78.7489L2.72547 78.6232V78.5813L2.76737 78.4543H2.80926L2.85247 78.4124L2.93626 78.2867L3.02005 78.2448L3.14704 78.034L3.18893 77.9489L3.35782 77.8232L3.39972 77.7813L3.5254 77.6976H3.5673H3.69429L3.73618 77.5706L3.94697 77.403L4.07265 77.3598H4.15644L4.19964 77.3179H4.32533L4.45232 77.2341H4.49422L4.57801 77.1922H4.6618L4.78879 77.1503V77.0233L4.83068 76.9814L4.91447 76.9395L4.95637 76.8557H5.04147L5.08336 76.8976L5.12526 76.8557H5.20905H5.29414L5.41983 76.8125H5.63061L5.7144 76.7706V76.7287L5.79819 76.6868V76.7287L5.84139 76.7706L5.92518 76.6868L5.88329 76.6449L5.92518 76.6031V76.5598H5.96708L6.00897 76.518V76.4342L6.09276 76.3923L6.13597 76.4342H6.17786L6.26165 76.3085L6.30355 76.2653L6.26165 76.2234L6.30355 76.1815L6.34544 76.0558L6.38733 76.0139V75.9707L6.43054 75.9288L6.38733 75.8031L6.43054 75.7612H6.47243V75.6761L6.43054 75.5923L6.34544 75.5504L6.30355 75.3816L6.26165 75.3397L6.21976 75.1289L6.17786 75.1708V75.087L6.13597 75.0032V74.9194V74.8762V74.8343L6.00897 74.7086H5.96708L5.92518 74.5816L5.84139 74.5397L5.79819 74.4978V74.4141V74.3708V74.2033L5.58872 73.9925V73.9087V73.7398L5.7144 73.6141L5.67251 73.5722L5.7144 73.529L5.67251 73.2777H5.7144L5.79819 73.1926V73.1507L5.84139 73.1088H5.88329L5.96708 73.0669V72.9818L6.00897 72.8142V72.7723V72.6872V72.6453L6.05087 72.5615L6.09276 72.6034V72.5196V72.4777V72.3926L6.17786 72.3088V72.2669V72.2251L6.21976 72.1832H6.26165H6.30355L6.43054 72.14V71.9724L6.47243 71.9305H6.55622V71.8873L6.68322 71.8454L6.76701 71.7197H6.8089V71.5927H6.8508L6.89269 71.467H6.93589L7.01968 71.4251V71.34L7.14537 71.2981V71.2562V71.2143L7.18726 71.1724V71.1306H7.23047V71.0455V71.0036V70.9617V70.9198L7.31426 70.8779L7.35615 70.9198L7.39805 70.8779L7.35615 70.7941V70.709L7.31426 70.6671V70.5833L7.35615 70.4563L7.43994 70.4144L7.39805 70.3306L7.43994 70.2887V70.2455V70.1198L7.39805 70.0361V69.8672V69.8253L7.43994 69.6564L7.48183 69.5726L7.43994 69.5307L7.52504 69.4888L7.56693 69.3618L7.60883 69.3199V69.278L7.65072 69.1942V69.1091L7.73451 69.0672V69.0253L7.77772 68.8997V68.8146L7.86151 68.7308V68.6889L7.9034 68.647L7.9453 68.6051V68.5619L7.98719 68.52V68.4362V68.3943L7.9453 68.3092L7.98719 68.2254V68.1835V68.0565V68.0146H7.9453L7.98719 67.9727L7.9034 67.847V67.8052H7.86151V67.762L7.9034 67.7201L7.9453 67.6782H7.98719L8.03039 67.5944H8.11418V67.6363L8.23987 67.5944L8.28176 67.5525L8.32497 67.3836L8.40876 67.4255L8.49255 67.3836L8.53444 67.3417L8.57633 67.2998L8.61954 67.3417L8.66143 67.2998L8.70333 67.2147L8.78712 67.2579V67.2147L8.82901 67.1728L8.78712 67.1309V67.089H8.87222V67.0471H8.95601V67.0052L9.08169 67.089L9.16679 67.0471H9.20868L9.29247 67.089L9.33437 67.0052H9.37626V67.0471L9.46136 67.0052L9.58705 66.9201V66.7944L9.62894 66.7526V66.7107L9.58705 66.6675L9.67084 66.6256L9.71404 66.5837H9.79783L9.83972 66.5418L9.96672 66.4161H10.0086H10.0924L10.1343 66.2891H10.2181V66.3729H10.2613L10.3032 66.2891L10.3451 66.331V66.3729H10.387V66.331V66.2472L10.514 66.2053V66.1202L10.4708 66.0783V66.0364L10.5559 65.9945V66.0783L10.5978 66.0364L10.6397 66.1202H10.6815V66.0364H10.7653V65.9526L10.7234 65.9107H10.7653L10.8085 65.9526L10.8923 65.8688H10.9761V65.7418V65.6999V65.6162L11.018 65.573L11.0612 65.4473H11.1869L11.2707 65.3635H11.3558V65.3216L11.3126 65.2784H11.3558H11.4396L11.4815 65.2365L11.6504 65.2784L11.6085 65.3216V65.4054L11.6923 65.3635L11.776 65.1946L11.8179 65.2784L11.903 65.2365L12.0287 65.1946V65.1108L12.0706 65.0689L12.1557 65.1527L12.1976 65.1108L12.1557 65.0689L12.3233 64.9838H12.3652V64.9419L12.4503 64.9L12.4922 64.8581L12.576 64.9L12.7449 64.7743L12.7868 64.6892L12.8705 64.6473L12.8287 64.6054L12.9543 64.4785L13.0813 64.4366L13.1232 64.3528V64.269L13.2502 64.3109L13.2921 64.3528L13.334 64.3947V64.3109V64.269H13.4597L13.5016 64.1839L13.5448 64.142L13.5867 64.1839L13.7124 64.142L13.6705 64.1001L13.7124 64.0582L13.6705 64.0163L13.7124 63.9744H13.7543L13.7962 63.9325V63.8893H13.8394V63.8474L13.7962 63.7636L13.9232 63.7217V63.8055L13.965 63.7636V63.6798L14.0069 63.7217L14.0488 63.6798V63.6366L14.092 63.5947L14.1758 63.6366L14.2596 63.5528L14.3447 63.5109L14.5123 63.4691L14.5961 63.4272H14.6812L14.7231 63.384L14.765 63.4691V63.5109H14.8488L14.8907 63.4691V63.384V63.3421L14.9339 63.3002L14.9758 63.384V63.4691H15.0595L15.1433 63.5528H15.1865L15.2703 63.5109L15.396 63.5528L15.4811 63.4691L15.523 63.5528L15.6906 63.4272L15.6487 63.384L15.6906 63.3421L15.7338 63.3002V63.3421V63.384L15.6906 63.5109L15.6068 63.5528V63.5947L15.6906 63.6366L15.7338 63.6798H15.8176L15.9433 63.5947L16.0284 63.5109L16.1122 63.3421L16.1959 63.384V63.3002L16.2378 63.2583L16.3229 63.3002L16.4486 63.384H16.4905V63.3421L16.4067 63.2583V63.1326L16.4905 63.1745L16.5337 63.2164L16.5756 63.1745V63.1326L16.6175 63.0894H16.7013L16.7851 63.1745H16.8283L16.8702 63.2164V63.2583H16.954L17.0797 63.0894L17.1648 63.0056L17.2485 63.0894L17.3323 63.0475L17.3742 63.0056L17.4174 63.0475V63.1326H17.4593H17.585L17.6282 63.1745V63.2164L17.6701 63.1745V63.0894L17.585 63.0475L17.5431 62.9637H17.6282L17.712 63.0894L17.7958 63.1326L17.8796 63.0475L17.9228 63.0056L17.8796 62.838L17.8377 62.7529H17.8796L18.0066 62.7948L18.0904 62.7529H18.1323V62.8799H18.1742L18.2174 62.711H18.2593L18.3012 62.7529L18.2593 62.838L18.3012 63.0056L18.3849 62.9218V62.838L18.4268 62.7948H18.4687H18.5119H18.5538V62.8799L18.6376 62.838L18.5957 62.7529H18.7214L18.8484 62.9218L18.8903 62.838V62.7529L18.9322 62.711L19.0173 62.6691L19.0592 62.711L19.0173 62.7948L19.0592 62.838L19.1849 62.7529V62.6691H19.2687L19.2268 62.7948L19.3119 62.838H19.3538L19.3957 62.7529H19.4794H19.5213H19.6064L19.6483 62.6691L19.6064 62.5853L19.5632 62.5421V62.5002L19.6483 62.5421L19.6902 62.5853L19.7321 62.6691L19.8591 62.711L19.901 62.7529L19.9429 62.6691V62.6272L19.9848 62.5853H20.0267L20.0686 62.5421L20.1118 62.4164L20.1956 62.3745L20.3213 62.3327L20.2794 62.2057L20.3213 62.1638L20.4902 62.08L20.4064 61.953L20.3632 61.8692H20.4483L20.532 61.9111L20.6158 61.8692V61.8273L20.6577 61.7854L20.6158 61.7003L20.6577 61.5746L20.7009 61.5327L20.7428 61.4476L20.8685 61.4908L20.9536 61.3638L20.9955 61.3219H21.0374H21.1212L21.2482 61.4476L21.3739 61.4908H21.4158L21.4577 61.5746H21.5428L21.5847 61.4908V61.3638V61.1963L21.6265 61.2382L21.6684 61.28L21.7103 61.3638V61.1112H21.8373H21.8792V61.1963L21.7954 61.3638V61.4476L21.8373 61.4908L21.8792 61.5327L21.963 61.4908L22.09 61.4476L22.1738 61.4057L22.2576 61.3638L22.2995 61.3219L22.3846 61.2382L22.3427 61.1531L22.5522 61.1963L22.5954 61.3219L22.5103 61.4908L22.5522 61.5327H22.6373L22.6792 61.3638L22.721 61.3219L22.8467 61.4057H22.8899V61.3219H23.0156L23.0575 61.28L22.9737 61.1963L23.0575 61.1531L23.1426 61.1963H23.3102L23.3521 61.1531L23.4372 61.1963L23.521 61.3638L23.5629 61.4476L23.6467 61.4908L23.6899 61.4057L23.7318 61.3638L23.6899 61.28L23.7318 61.2382L23.8155 61.3219L23.8993 61.3638L23.9412 61.4057V61.5746L23.9844 61.7854L23.9412 61.8273L23.8155 61.8692V61.953L23.9844 62.08L23.8993 62.1638H23.9844L24.1939 62.08V62.1219L24.152 62.1638L24.0682 62.2057L24.1101 62.2908L24.1939 62.3327H24.3209L24.3628 62.3745L24.4047 62.3327L24.4466 62.3745L24.4885 62.5853L24.5317 62.6272H24.5736L24.6574 62.5853V62.5002L24.6993 62.4583L24.8263 62.4164V62.3745L24.6993 62.2908L24.7844 62.1219L24.8263 62.08L24.91 62.1219L24.9519 62.1638L25.0357 62.1219L25.0789 62.08V62.0381V61.9949L25.1208 62.1219L25.1627 62.1638H25.2465H25.3316L25.2465 62.2476L25.2884 62.3745H25.3316L25.4573 62.4164L25.4992 62.4583V62.5421H25.5411L25.71 62.4583L25.8776 62.3745L26.0045 62.2057L26.0464 61.9949V61.7435L26.1302 61.6584H26.1734L26.468 59.9329L26.7626 58.2911L27.6882 53.0713L28.1517 50.335L28.7408 46.8408L29.1611 44.4842L29.1192 44.2734L29.1611 44.1896L29.2462 44.1045V44.0207V43.768L29.288 43.6424V43.5573L29.3718 43.5154L29.4988 43.4735V43.3897L29.4137 43.2208V42.9681V42.9262L29.3299 42.7573L29.288 42.5898L29.3299 42.4628L29.4137 42.2952V42.1263L29.4988 42.0425V41.9587V41.8317L29.3299 41.6209L29.288 41.579L29.3299 41.4102L29.288 41.3683L29.2043 41.3264V41.2845H29.2462L29.288 41.2007H29.3718L29.3299 41.1156L29.2462 41.0737L29.1611 41.1156L29.0773 40.9899V40.9061L28.9516 40.7791L28.8665 40.7372L28.8246 40.6953H28.7408L28.6989 40.6534V40.6115V40.4008V40.3157L28.6151 40.2319H28.5719L28.4043 40.1062L28.4881 39.9792V39.8954L28.4043 39.8535H28.3624L28.3192 39.7697L28.1517 39.6427L28.1935 39.6008L28.1098 39.5589L28.1517 39.517H28.0666L28.1098 39.4319V39.39L28.1517 39.3481H28.2354L28.1935 39.2644L28.2354 39.2212L28.3192 39.0955L28.3624 38.9698L28.4043 38.8847L28.4462 38.8009H28.4043V38.7171L28.3624 38.6752H28.3192L28.2773 38.5901L28.1935 38.5482L28.2354 38.4644L28.2773 38.3374L28.1935 38.2118L28.1517 38.1699L28.1935 38.001L28.1098 37.9172H28.0247H27.9828V37.7902L27.8152 37.7483L27.6882 37.7064V37.6645L27.5206 37.6226L27.4355 37.5807L27.3936 37.5375L27.3517 37.4537H27.3098L27.2247 37.328L27.1409 37.2848H27.0572V37.201L26.9302 37.1591H26.8464L26.7207 36.9065L26.6356 36.9484L26.468 36.9065L26.4261 36.9484L26.2572 36.8227L26.1734 36.7376L26.1302 36.6538H26.0883L26.0464 36.57L26.0045 36.5281L25.8776 36.3592L25.8357 36.3173L25.7938 36.2335L25.4573 35.939L25.4154 35.8958V35.7282L25.4573 35.6431L25.4992 35.5174L25.4573 34.8013V34.2972L25.4992 33.1176V31.6448V31.1394H25.5411H25.583L25.6262 31.2232L25.6681 31.2664H25.7519L25.7938 31.2232L25.8357 31.1394L25.7519 31.0556H25.9208L25.9627 31.1394L26.1302 31.1813L26.2153 31.0975L26.2991 30.9718L26.341 31.0137L26.4261 30.9718L26.468 31.0556L26.6356 31.0137L26.7207 30.9718H26.7626L26.8045 30.9286L26.8883 30.9718H26.9302V31.0556L27.0572 30.9718L27.099 30.8867L27.2247 30.8448L27.3098 30.7178L27.3936 30.8029L27.4774 30.761L27.5206 30.5921L27.6044 30.5503H27.6882V30.4665L27.7301 30.4233L27.899 30.4665L27.9409 30.5084L28.0247 30.634H28.0666L28.1098 30.6759H28.1935V30.634H28.2773V30.5084L28.4462 30.4233V30.3395H28.6151H28.657V30.2557L28.6989 30.1719H28.7408H28.7827L28.8246 30.0868L28.8665 30.0449L28.9935 30.003H29.0354L29.0773 30.0449L29.1192 30.1287H29.2043L29.2462 30.1719V30.2557L29.288 30.2976L29.4137 30.3814V30.4665L29.6664 30.7178L29.7515 30.8029L29.7934 30.761L29.8353 30.7178V30.634L29.961 30.6759L30.0461 30.634L30.088 30.5503L30.1718 30.5921L30.1299 30.634L30.1718 30.761L30.1299 30.8448H30.2556H30.2988H30.3825L30.4663 30.8029V30.8448L30.6352 30.8029L30.719 30.8448V30.761V30.6759L30.7609 30.634V30.5503L30.846 30.5084L30.8879 30.5503H30.9717L31.0555 30.5921H31.1406L31.1825 30.634H31.2244L31.2663 30.5503L31.0555 30.2138L30.9298 30.1287L30.846 30.0868L30.8028 30.0449V29.9192L30.8879 29.8341H30.9717H31.0136L31.0555 29.7084L31.0136 29.5395L30.9717 29.4976L30.9298 29.4139V29.2869L31.0136 29.245H31.0987V29.2031L31.1406 29.1193L31.0555 29.0342H31.0136L30.8879 28.9504H30.8028V28.8666V28.8247L30.7609 28.7396L30.8028 28.6977L30.9298 28.6558L30.8879 28.572L30.6771 28.4869L30.5933 28.4031L30.719 28.3194L30.6771 28.2343L30.6352 28.1924L30.2988 27.8978H30.2556L30.1718 27.9397L30.1299 27.8559H30.0461V27.814L29.961 27.7302H29.7934L29.7096 27.7721L29.6245 27.7302L29.5826 27.7721L29.3718 27.9829L29.2462 27.9397V27.8559V27.814L29.2043 27.7721L29.1192 27.814L28.9097 27.7721L28.7408 27.814H28.4462L28.3192 27.7721L28.1935 27.6451H28.1098L28.0666 27.7302H27.9409L27.8152 27.7721L27.7301 27.814L27.6463 27.7721L27.6044 27.814L27.5625 27.7302V27.6032V27.5194L27.4355 27.5613H27.3936H27.2679L27.099 27.6883L27.0153 27.7302L26.9721 27.8559L26.9302 27.8978L26.8045 27.8559L26.7207 27.7721V26.4249V24.6562V23.7306H26.8464L26.8045 23.7725L26.8464 23.8144L27.0153 23.7725L27.099 23.8144V23.7725L27.1409 23.6887H27.1828L27.3517 23.563H27.4355H27.5206L27.5625 23.5198L27.6044 23.563H27.7301V23.6049H27.8152H27.899L27.9409 23.563L28.0247 23.6049L28.0666 23.5198H28.1098L28.2354 23.436L28.4462 23.3522L28.53 23.2671L28.9097 23.436L28.9516 23.3941V23.436L28.9935 23.4779L29.0354 23.3941L29.0773 23.436L29.1192 23.4779L29.1611 23.436L29.3299 23.4779L29.5407 23.6049V23.6887L29.5826 23.6468H30.846H33.8336H37.1603H37.2022V23.563L37.1603 23.5198H37.0333L37.1171 23.3941L36.9914 23.3103H36.9077L36.8658 23.3522L36.7807 23.3941H36.6969L36.655 23.2252L36.6969 23.0144H36.655H36.528V22.9306V22.805L36.6131 22.7199L36.655 22.3834L36.6969 22.3415L36.7807 22.2577L36.8658 22.1726H36.9496L37.0333 22.0469L37.1171 22.005L37.2022 22.0888L37.286 22.0469H37.3279L37.413 22.1307L37.4549 22.2996L37.5387 22.3415L37.5806 22.5104L37.6225 22.5523H37.6644L37.7495 22.5942L37.8752 22.5523L38.0022 22.678L38.1278 22.805L38.3386 23.0144H38.5494L38.5913 22.9725L38.6332 22.8887L38.717 22.8469L38.7589 22.7631L38.717 22.5942L38.8859 22.5523L39.0535 22.4253L39.1804 22.2577L39.2223 22.2158L39.3061 22.1307L39.5169 21.7105L39.602 21.6686H39.7277L40.0223 21.7942H40.3168H40.5276L40.6114 21.7105L40.7384 21.374L40.906 21.247L40.9479 21.0362L41.033 20.9105L41.1168 20.8254L41.5802 20.616L41.664 20.4471L41.7059 20.3633H41.8329H41.9586L42.0856 20.4471L42.2532 20.616L42.2951 21.2889L42.337 21.4159V21.7524L42.5058 22.3834L42.5896 22.6361L42.6315 22.7199L42.8423 22.8469L42.9274 22.805L43.2639 22.8469L43.3896 22.8887L43.5165 23.0576L43.6003 23.2252L43.6422 23.3941L43.7692 23.6468L43.726 23.8144L43.7692 23.9832L43.8111 24.1089L43.853 24.2359L43.8949 25.1196V25.2885L43.9368 25.4993L43.853 25.7507L43.8111 26.256V26.8452L43.853 27.0141L43.8111 27.2668L45.2421 26.8452L46.8419 28.3194L48.6094 29.8773L49.2417 29.7084L49.4093 29.7503L49.4512 29.7922L49.5363 29.8773L49.5782 29.9611H49.6201L49.8309 29.9192L49.8728 29.8341H49.9147L49.9985 29.8773L50.0835 29.7922V29.7503L50.1254 29.6246V29.5814H50.2092L50.3362 29.5395L50.4619 29.5814H50.5457L50.6308 29.5395H50.6727H50.7146H50.7565H50.7984V29.4558L50.8835 29.372V29.245L50.9673 29.2031V29.0774L51.0092 29.0342H51.1348L51.1781 29.0774L51.2199 28.9923L51.3037 28.9504L51.3456 28.8247L51.3037 28.7396L51.4307 28.7828L51.5983 28.6977L51.7253 28.6139L51.7672 28.6558L51.851 28.6139L51.8929 28.572L51.9348 28.5301L51.978 28.572L52.0199 28.5301L52.0618 28.445H52.1037L52.1875 28.3194H52.2725H52.3563H52.3982L52.4401 28.2775L52.482 28.3194L52.5239 28.3613L52.5671 28.4031L52.609 28.3194L52.7347 28.2343L52.9036 28.4031L52.8617 28.2775H52.9455L52.9874 28.2343V28.2775L53.1144 28.3194L53.1563 28.2775L53.1982 28.4031L53.2401 28.3613H53.3238L53.282 28.4031L53.3238 28.4869H53.4089L53.4508 28.572L53.4927 28.6139L53.4508 28.6558L53.5346 28.7396V28.7828L53.6184 28.8666L53.5765 28.9923V29.0342H53.7035V29.0774L53.6184 29.1612L53.6616 29.3288H53.6184L53.5765 29.372L53.5346 29.3288L53.4927 29.372L53.5346 29.4558L53.4927 29.5814H53.4089V29.6246L53.3671 29.7503H53.3238L53.1982 29.8341V29.9611L53.1144 30.0868L53.1563 30.1287L53.1982 30.1719L53.282 30.3814L53.3238 30.4233V30.5084H53.3671L53.4089 30.5503L53.4927 30.4233H53.6616L53.7035 30.3814H53.7454L53.7873 30.3395H53.8292H53.9562L54.04 30.2976V30.2557L54.1238 30.1719L54.167 30.0449L54.2089 30.003V29.9192V29.8773L54.2927 29.9192L54.3346 29.8773L54.2927 29.7922L54.3346 29.7503L54.2927 29.7084V29.6665L54.2089 29.4976L54.2927 29.4558L54.3346 29.3288L54.3765 29.2869H54.4183L54.4616 29.2031L54.5872 29.1193L54.5453 29.0774L54.6291 28.9923L54.7129 28.7396L54.7561 28.7828L54.8818 28.6977H55.0507H55.0926L55.1345 28.7396L55.0926 28.7828L55.1345 28.8247L55.1764 28.7828L55.2615 28.8247L55.3872 28.7828H55.471L55.5128 28.8666L55.471 28.9085H55.556L55.6398 28.8247L55.7236 28.6558L55.7655 28.445L55.8074 28.4031L55.8506 28.2775L55.7236 28.2343V28.1924V28.1505L55.7655 28.1086L55.8074 27.9397V27.7721L55.8506 27.6451L55.8074 27.5194H55.8925L56.0182 27.4775V27.3924L56.1452 27.3086L56.229 27.3924H56.2709L56.3128 27.3505L56.3979 27.4356L56.356 27.5613L56.3979 27.6032L56.4817 27.5613L56.6506 27.6032V27.5194L56.7343 27.4775L56.8181 27.3505L56.9451 27.2249L57.0289 27.0979L56.987 27.056L56.9451 26.9303L57.0289 26.8452H57.0708L57.1127 26.8884V26.9303L57.1546 26.9722L57.2397 26.9303L57.2816 26.8452L57.3654 26.7614L57.3235 26.7195H57.4073H57.4492V26.8452H57.5343H57.5762V26.7614L57.66 26.6357L57.6181 26.5938L57.8707 26.4249L57.9545 26.2979L57.9964 26.3411L58.0815 26.5087L58.0396 26.5506V26.5938L58.1234 26.6776L58.2491 26.8452L58.2923 26.8884H58.3342L58.5018 26.8033V26.7195H58.5437L58.5869 26.5938V26.5506V26.5087L58.6288 26.4668L58.7126 26.5087H58.7545L58.8396 26.4668H58.8814L58.9652 26.383L59.049 26.256H59.0909L59.176 26.1722H59.3017L59.3868 26.0466H59.3436L59.3868 25.9615L59.3436 25.9196L59.4287 25.8777L59.5544 25.6669L59.6814 25.5831V25.5412V25.4993L59.7233 25.5412L59.849 25.4993L59.9341 25.4142L60.0178 25.3304L60.1435 25.2466L60.1854 25.2885H60.2286L60.3543 25.2034V25.1615L60.4381 25.0777V25.0359L60.5232 24.9521L60.607 24.994H60.6489H60.7759L60.8178 25.1196L60.7327 25.2466L60.607 25.3723L60.6489 25.4142L60.607 25.4561L60.5232 25.625V25.6669L60.4813 25.7939L60.5232 25.8358H60.607H60.7327L60.7759 25.8777L60.8178 25.9615L60.8597 26.0034L60.9016 25.9615L60.8597 25.9196V25.8777V25.8358L60.9435 25.7939V25.7507V25.7088V25.625V25.5412L60.9853 25.4993L61.0272 25.4561V25.4142L61.0704 25.3723L61.1123 25.3304L61.238 25.2466V25.2034H61.3231L61.365 25.1196L61.4488 25.0777L61.4907 25.0359L61.5758 25.0777H61.6177L61.7434 24.9521L61.7853 24.867L61.8704 24.7413V24.6562H61.9123H61.9961L62.0798 24.6143H62.1217H62.2068L62.2906 24.5724V24.4467L62.3744 24.3616L62.4176 24.2359L62.5014 24.1521L62.5433 23.9832V23.9414L62.5852 23.8144H62.5433L62.5014 23.6887L62.5433 23.6468V23.6049V23.5198H62.5014V23.4779L62.5852 23.2671V23.1833L62.6271 23.1414L62.5852 23.0576H62.6271V22.9306H62.5433V22.8887L62.5852 22.678V22.5942V22.4685V22.3834L62.6703 22.3415L62.7122 22.2996L62.8379 22.2577V22.1726H62.8798L62.9649 22.0888L63.0068 22.0469H63.0487L63.1325 21.9631L63.1743 22.005L63.2162 21.9631L63.2594 22.005H63.3432L63.427 22.0469L63.554 21.9631H63.5959L63.6378 22.005L63.6797 22.0469H63.8905L63.9324 22.1726L64.0162 22.1307L64.0594 22.005H64.227L64.3107 22.0469L64.3539 22.005L64.3958 21.9199H64.4377L64.5215 21.9631L64.5634 21.9199V21.878L64.6053 21.8361L64.6485 21.7942V21.7524L64.8161 21.6254L64.8593 21.6686L64.9012 21.7105L64.8593 21.7942H64.985L65.0269 21.8361L65.0688 21.7942V21.7105L65.0269 21.5416L65.0688 21.4997H65.1107H65.1539H65.1958L65.2796 21.374H65.3215V21.3308V21.247H65.4052L65.4903 21.1632H65.5322L65.6579 21.1213L65.6998 21.0781H65.8268L65.9957 21.1632V21.2051H66.1214L66.2052 21.1213L66.2484 21.0362H66.2903L66.416 21.1213H66.4578L66.4997 21.0781H66.5429L66.6686 20.9943H66.7105V20.9105V20.8686L66.7524 20.7416H66.7105V20.6579L66.8794 20.5741L66.9213 20.6579L67.2578 20.8686L67.4267 20.9524L67.5523 20.9105L67.9739 20.7835H68.1415L68.1847 20.8254H68.3104V20.9105V21.0362L68.3523 21.1632L68.4374 21.3308L68.5212 21.4159L68.6469 21.5416L68.7319 21.6686L69.0265 21.8361L69.2792 21.7942L69.4887 21.7105L69.6576 21.7524L70.1629 21.8361H70.2467L70.3305 21.9631V22.005L70.7521 22.1307L70.8777 22.2158H70.9209L71.0047 22.2996L71.0466 22.5104L71.0047 22.7199L70.8358 23.0995L70.8777 23.7725L70.8358 23.8576L70.6683 23.9832L70.6251 24.0251L70.5832 24.1089L70.4156 24.2778L70.3737 24.4467V24.5305V24.5724L70.5413 24.6562L70.6683 24.8251L70.7102 24.9089L70.794 24.9521L70.8358 25.1196L70.9209 25.2034L71.0466 25.2885L71.1723 25.4142L71.3412 25.4993H71.3831L71.425 25.5412L71.5101 25.7507V25.7939L71.4682 25.8777L71.5101 26.0034L71.5939 26.0466L71.7196 26.6776L71.9304 27.183L71.9722 27.5194L72.0992 27.7721H72.1411H72.3519H72.3938H72.4357V27.814L72.3938 27.9397V28.0248L72.4357 28.0667L72.3938 28.1505L72.4357 28.2343L72.5195 28.3613L72.6046 28.4869V28.572L72.5627 28.7396L72.4357 28.8666L72.3519 29.1612L72.3938 29.3288L72.4776 29.4139L72.5195 29.4558V29.7084L72.4776 29.7503L72.2668 29.9192L72.0992 30.1719L72.0573 30.2976L72.0154 30.3814L72.1411 30.9718L72.0992 31.2232L72.0573 31.4759L72.1411 31.6029V31.8974H72.2249L72.3519 31.8123L72.4776 31.9812L72.5195 32.0231L72.5627 32.192L72.6046 32.2758L72.5627 32.3177V32.3609L72.5195 32.4447L72.4776 32.5704L72.5195 32.6974L72.4776 32.95L72.5627 33.1595V33.3703L72.6465 33.4554L72.7303 33.623V33.7919V33.9594V34.1283L72.8141 34.254L72.9411 34.3391L73.0667 34.381L73.1086 34.4648L73.2356 34.5067L73.3613 34.8864V34.9283V34.9701V35.0958H73.3194V35.139L73.3613 35.1809L73.4045 35.2647V35.3485L73.5302 35.5174L73.5721 35.6012L73.614 35.6863L73.6991 35.7701H73.7829L73.8667 35.812V35.8539L73.8248 35.939L73.8667 36.0646L73.7829 36.1065V36.2335L73.8248 36.3173H73.9086L73.8667 36.4011L73.7829 36.443V36.4862L73.8667 36.6119L73.8248 36.6538L73.8667 36.6957L73.9086 36.7376H73.9518L73.9937 36.6957L74.2031 36.8227L74.1612 36.8646V37.0335L74.1193 37.0754L74.0775 37.1173L74.1193 37.2429L74.0356 37.2848V37.328H73.9937L73.9518 37.4537L73.8667 37.4956L73.8248 37.5375L73.6572 37.6226V37.7064H73.6991L73.6572 37.7902L73.614 37.7483L73.5721 37.7902V37.8753L73.5302 37.9591H73.4883L73.4464 38.001L73.4883 38.128L73.4464 38.1699V38.2118L73.4045 38.2536L73.4464 38.3374V38.4225L73.4883 38.4644L73.5721 38.5482V38.632H73.4883V38.6752L73.5302 38.7171L73.5721 38.8009V38.8428L73.5302 38.8847H73.4883L73.4464 38.9266H73.4045H73.3613H73.3194V39.0117L73.2356 39.0536L73.1937 39.0117V39.0536H73.0667V39.0955V39.1793H73.1086L73.1518 39.2212L73.1086 39.2644L72.983 39.2212L72.9411 39.2644V39.3063L72.8573 39.3481L72.8141 39.2644L72.7722 39.2212L72.7303 39.1793V39.1374H72.5627L72.4776 39.0955V39.1374L72.3519 39.0536L72.31 39.0955V39.2212L72.2249 39.2644V39.39H72.2668L72.31 39.517L72.2249 39.5589V39.6008L72.2668 39.7265L72.3938 39.8116L72.4776 39.7697L72.5195 39.8535H72.5627L72.6046 39.8954V39.8535H72.6884L72.7303 39.8954L72.8992 39.9373L72.9411 40.0211L73.0248 40.0643V40.1062L73.0667 40.1481V40.19L73.0248 40.2319L73.1086 40.2738V40.3157H73.1518L73.2775 40.4845L73.3194 40.5683H73.4045L73.4464 40.6534L73.5302 40.7372V40.7791L73.614 40.7372L73.6991 40.821L73.7829 40.948H73.9518L74.0356 40.9899H74.1193V41.1156L74.2882 41.1588L74.3301 41.2007L74.4139 41.2845H74.4558L74.499 41.3264H74.5828L74.6666 41.4953L74.6247 41.579L74.6666 41.6209L74.7085 41.6628L74.7517 41.706L74.8355 41.7479H74.9193H75.0031L75.1301 41.8736L75.2557 42.0006L75.2976 42.0844L75.4246 42.379V42.5047L75.5935 42.6735L75.6354 42.7992L75.6773 43.01L75.8462 43.2208L75.93 43.3478L75.9719 43.5154L76.0138 43.6424L76.1827 43.6843H76.3502H76.4353L76.5191 43.6424L76.6029 43.5573L76.6867 43.5154L76.8137 43.5573L76.9826 43.5992L77.1083 43.7262L77.4866 43.8518L77.6136 43.8937L77.8244 43.9788L78.0339 44.1464L78.119 44.2734L78.2028 44.4842L78.5392 44.7788L78.5811 44.8207H78.6243V44.6518L78.6662 44.6099V44.5261L78.6243 44.4842L78.5811 44.3991L78.3717 44.3153L78.2447 44.0626V43.9369V43.8937L78.1609 43.8518H77.992L77.9501 43.7262L77.7812 43.6843H77.7393V43.6424L77.8663 43.4735L77.9082 43.4316L77.9501 43.3478V43.2627L77.7812 43.0951L77.6555 43.0519L77.6974 42.9681L77.7812 42.8843L77.8244 42.6735L77.8663 42.5479L77.9082 42.379L77.9501 42.3371L77.992 42.2952L77.9501 42.1682L77.992 42.0844L78.0339 42.0006L78.0771 41.9587L78.0339 41.8736L77.992 41.8317V41.7898L78.0771 41.7479L77.992 41.6628V41.6209L78.0339 41.579H78.1609L78.2028 41.4953V41.3264L78.1609 41.2426L78.0771 41.1588V41.1156V41.0318H77.992L77.9501 40.9899L77.992 40.821L77.9501 40.6953L77.992 40.6534V40.5264L78.119 40.4426V40.2319L78.2028 40.1481V40.1062L78.1609 40.0643V39.8954V39.7697L78.2447 39.5589L78.3717 39.4738L78.5811 39.3063L78.6243 39.2212V39.0955L78.7081 38.9698L78.75 38.9266H78.8757L78.9189 38.8847V38.8428V38.759H79.0446L79.1284 38.6752L79.2973 38.5901L79.3392 38.5482L79.4243 38.5063L79.55 38.5482L79.7188 38.3793H79.8026H79.8445L80.1391 38.3374L80.181 38.2955V38.1699L80.2229 38.128L80.181 38.0429V37.9591L80.2229 37.9172H80.2661L80.3499 37.9591H80.4756L80.6026 38.001V37.9591L80.6445 37.9172L80.7701 37.8753L80.8133 37.9172L80.8552 37.9591L80.9809 37.9172H81.0228L81.1917 38.001L81.2336 38.1699L81.2755 38.2118H81.3606H81.4025L81.5701 38.2955H81.739H81.8227L81.8646 38.2536L81.9078 38.2955H81.9497L81.9916 38.2536H82.0754L82.1173 38.4225L82.0754 38.4644V38.632H82.1173V38.7171L82.2862 38.8847L82.4119 38.8009L82.4551 38.8428L82.497 38.8847V38.9698V39.0117L82.5389 39.1374H82.7497L82.8335 39.1793V39.39V39.4319V39.4738H82.8754L82.9172 39.517L82.9591 39.5589L83.0023 39.517L83.0442 39.6008L83.0023 39.6846L82.9591 39.7265V39.7697L83.0861 39.8116L83.0442 39.8954L83.0861 39.9373L83.0442 40.0211L83.0861 40.1062L83.128 40.1481L83.0861 40.2319L83.2118 40.19L83.3388 40.2738L83.3807 40.2319L83.5915 40.3157H83.6334L83.5915 40.4008L83.6334 40.4426L83.7172 40.3589L83.8442 40.3157V40.2738H83.8861L83.928 40.2319H83.9698L84.0968 40.2738V40.1481L84.3063 40.2319V40.2738H84.3914L84.4333 40.3157H84.4752L84.6441 40.1481V40.1062L84.559 40.0643L84.6441 39.9792H84.686L84.7279 39.8954L84.686 39.8535L84.7279 39.8116L84.686 39.7697L84.7279 39.7265L84.8117 39.6427H84.8536H84.9387H85.0643L85.1062 39.6846L85.1481 39.6427L85.19 39.6008L85.2751 39.5589H85.4008L85.4427 39.4738H85.5697H85.6116L85.6535 39.4319L85.8224 39.3481H85.8643L85.9062 39.2644V39.1374H85.8643L85.9062 39.0117L85.8224 38.9266V38.8009H85.7805H85.7386L85.6535 38.7171L85.6116 38.6752L85.5697 38.5901L85.4859 38.5482V38.4644L85.4008 38.5063L85.3589 38.4225L85.4008 38.3793V38.2955L85.317 38.2536V38.2118L85.2751 37.9591L85.3589 37.9172V37.8753L85.4008 37.7902V37.7064L85.6535 37.5375V37.4537L85.6116 37.4118L85.6535 37.3699L85.6116 37.328L85.6535 37.2848L85.6954 37.1591L85.7805 37.1173V37.0754L85.8224 36.9903L85.7805 36.8646V36.8227H85.9062V36.6538L85.9481 36.6119L85.99 36.57L85.8643 36.4011L85.9062 36.3592L85.9481 36.1903L85.9062 36.0646L85.9481 36.0228L85.99 36.0646L86.0751 36.0228L86.117 35.939V35.8539L86.1589 35.812L86.2426 35.8539L86.2007 35.7701L86.3277 35.6431H86.3696L86.4115 35.5593L86.3696 35.5174V35.4755L86.3277 35.4336L86.3696 35.3485L86.4115 35.2647L86.4953 35.0958V34.9283L86.6642 34.7594L86.6223 34.7175H86.7061L86.7899 34.5918L86.9169 34.5499L86.875 34.4648L86.9169 34.4229V34.381V34.2972L87.0007 34.2121L86.9588 34.1702L86.9169 34.1283V34.0445L87.0426 33.9175V33.8756L87.2533 33.7919L87.3371 33.75L87.4222 33.6649L87.4641 33.2446L87.5479 33.0338H91.2949H92.7677H94.6203V34.8013V34.8445L94.6622 34.9283V35.0958L94.7041 35.139H94.746L94.8311 35.2228L94.7879 35.6012L94.8311 35.6431V35.7282L94.7041 35.9809V36.1903L94.746 36.4011H94.7879V36.4862V36.5281L94.746 36.6119V36.9065L94.9148 37.0335L95.0837 37.1173V37.1591H95.2094V37.201L95.2513 37.1591L95.3351 37.201L95.4202 37.328L95.5459 37.3699L95.5878 37.4956H95.631L95.6729 37.5375L95.631 37.7483L95.6729 37.9172L95.7148 37.9591L95.7567 38.0429V38.1699V38.2118L95.7148 38.2955H95.631V38.4225L95.6729 38.4644V38.5901L95.631 38.632V38.7171L95.7148 38.8009V38.8428H95.7567L95.7986 39.0117V39.0536L95.9256 39.0955L96.0512 39.2212V39.2644L96.0931 39.3063L96.135 39.2644L96.2201 39.3063L96.3458 39.5589L96.4296 39.6008H96.5147V39.6427L96.5985 39.7265H96.6404V39.7697L96.6823 39.8116V39.8535L96.935 40.0211V40.0643H96.9769L97.0201 40.0211L97.062 40.0643L97.1039 40.0211V40.1062L97.1457 40.19H97.1876L97.2295 40.2738H97.2714V40.2319H97.3146L97.4822 40.3589V40.4008L97.3565 40.4426L97.3984 40.5264L97.3565 40.6534L97.5241 40.7791V40.8642L97.6092 40.9061V40.948V40.9899L97.5673 41.0318L97.5241 41.1156L97.5673 41.1588L97.5241 41.2845L97.6092 41.3683H97.6511H97.693H97.7349L97.7768 41.4102L97.9038 41.5371V41.706L97.9457 41.7479V41.7898L97.9876 41.8317L98.0295 41.7898L98.0714 41.9155L98.1983 41.9587L98.1565 42.0425L98.4929 42.0006V41.9587H98.5767L98.6618 42.1263L98.8294 42.1682L98.9564 42.379L99.0402 42.4209L99.1659 42.5898L99.2091 42.5479L99.3766 42.3371L99.4185 42.2952V42.1682L99.5874 42.1263L99.6712 42.0425L99.6293 42.0006L99.6712 41.9155L99.9239 41.7479H99.9658L100.051 41.7898L100.093 41.8736V41.9155L100.135 42.0425L100.304 42.0844L100.345 42.1263V42.2101L100.304 42.3371L100.387 42.4209V42.5479L100.345 42.5898L100.218 42.9681V43.0951L100.177 43.137V43.2208V43.3046L100.26 43.3897H100.345L100.304 43.4316V43.5154L100.429 43.5573V43.6843H100.471L100.555 43.6424L100.682 43.6843L100.724 43.7262L100.682 43.8099L100.724 43.8518L100.766 43.8099L100.808 43.8937L100.935 43.8099H101.018L101.145 43.8518V43.8937L101.271 43.9369V43.9788H101.313L101.355 44.1045L101.398 44.1464L101.44 44.2315H101.482H101.524V44.3153V44.3572H101.566L101.649 44.3153L101.735 44.3572V44.3153L101.86 44.3572L101.944 44.3153V44.5261L101.987 44.6099L102.029 44.6937L101.987 44.7788H102.071L102.155 44.9044L102.282 44.8207L102.324 44.8625L102.576 44.8207V44.7788L102.618 44.7369L102.702 44.8207L102.66 44.8625L102.702 44.9463L102.744 44.9044L102.871 44.9882H102.955H102.997L103.039 45.1152H103.124L103.082 45.2841L103.207 45.199L103.249 45.2841L103.291 45.326L103.376 45.2841V45.3679L103.418 45.4517L103.671 45.3679V45.4098L103.629 45.4936L103.713 45.5368L103.797 45.4098H103.882V45.4936L103.924 45.5368H103.965V45.6206L103.882 45.6625L103.924 45.7463L104.049 45.6625L104.176 45.7882L104.26 45.7463L104.218 45.6625L104.344 45.7044L104.471 45.7882L104.513 45.6625H104.68V45.7044H104.723L104.765 45.6206V45.5787H104.807L104.849 45.6206L104.807 45.6625L104.849 45.7044L104.933 45.7463H104.976L105.018 45.7044L105.102 45.6625L105.144 45.7463H105.186L105.228 45.7044L105.271 45.7882L105.354 45.7044V45.7463L105.313 45.9151L105.354 45.957V45.9989H105.438H105.565L105.649 46.1678L105.775 46.0408L105.86 46.1259V46.1678V46.2097L105.944 46.2516L105.986 46.2935V46.3354L105.902 46.4205L105.944 46.5462L106.027 46.6313L106.154 46.9259L106.196 46.9678L106.449 46.9259L106.491 47.0097L106.575 47.0934L106.618 47.2204L106.66 47.2623L106.912 47.3042H106.954L106.996 47.3461L107.122 47.4299L107.249 47.5988L107.333 47.6407H107.417H107.669L107.838 47.5569H107.922L108.007 47.6407L108.049 47.6826L108.091 47.8096V47.9353V47.9772L108.049 48.1042L107.922 48.2298L107.796 48.3987V48.5676L107.838 48.6095H107.922L108.049 48.6514L108.175 48.6933L108.216 48.7771L108.343 48.8622H108.511L108.638 48.819H108.722L108.764 48.8622L108.807 48.819L108.849 48.6514V48.6095H108.933L108.974 48.6514L109.058 48.6095L109.101 48.5244L109.227 48.4825L109.311 48.3987H109.353H109.438L109.606 48.6095L109.649 48.5676L109.732 48.5244L109.816 48.4825L109.858 48.5244L109.943 48.6095H110.027L110.153 48.5244L110.196 48.4406L110.28 48.3987L110.405 48.4406H110.532L110.616 48.3987L110.658 48.2717H110.7V48.1879L110.743 48.146L110.827 48.1042L110.996 48.0623L111.163 47.8515L111.29 47.8934L111.332 47.8515L111.374 47.8096L111.416 47.7677H111.5H111.585H111.669L111.963 47.6826V47.7245L111.922 47.8096L111.711 48.146L111.542 48.4406L111.374 48.6095L111.205 48.7352L110.953 48.9041L110.532 49.1149L110.322 49.1568L110.196 49.2405L110.153 49.2824L110.027 49.577L109.985 49.6621V49.7878L109.943 49.8716L109.691 50.2094V50.2513L109.732 50.2932L109.858 50.335L109.943 50.3769H110.027L110.069 50.4188L109.901 50.7985L109.564 51.5552L109.227 52.2295L109.016 52.7767L108.554 53.7874L107.838 55.386L107.796 55.4292L107.543 56.0183L107.08 57.0696L106.912 57.4912L106.66 58.0803L106.238 59.0073L104.807 62.1219L102.955 66.1634L102.534 67.1728L101.987 68.3524L101.018 70.5414L98.5348 76.0558L98.4929 76.1396L98.4091 76.1815V76.2234H98.3659H98.1983L98.1565 76.2653L98.1146 76.4761L98.0714 76.5598L97.9876 76.6868L97.8619 76.7287L97.5241 77.0233L97.3984 77.2341L97.2714 77.3598L97.1876 77.5287V78.0759L97.2714 78.2016L97.3146 78.4124L97.4822 78.8758L97.6511 79.0866L97.7349 79.1285L97.7768 79.2542H97.82L97.9876 79.2961L98.0714 79.3812L98.1565 79.465L98.3659 79.8433L98.4929 79.9703L98.6186 80.0122H98.6618L98.7456 80.1811L98.7875 80.2649L98.8713 80.3068L98.9145 80.4757L99.0402 80.6014L99.124 80.9379L99.0821 81.1905L99.124 81.4013V81.4851L99.251 81.654L99.3347 81.7378L99.2929 81.781L99.0821 81.9905L98.8713 82.412L98.8294 82.6228L98.7875 82.8323L98.8294 83.0012L98.8713 83.212L98.9145 83.2957V83.4214L98.7037 83.6322L98.6186 83.8011L98.451 83.9687L98.4091 84.0119V84.1795V84.2646L98.324 84.3902L98.1146 84.601L97.8619 84.7267L97.82 84.8118H97.7768V84.8956L97.8619 84.9794V85.274L97.9876 85.4847L98.1146 85.6536L98.1565 85.8212V85.9063L98.1983 86.032L98.3659 86.3266L98.4091 86.4104L98.3659 86.5373L98.4091 86.663L98.3659 86.7481L98.1983 86.8319L98.1565 86.9576L98.2402 87.2103L98.1565 87.3373L98.1983 87.59L98.1565 87.6737V87.7575L98.1983 87.7994L98.2402 87.9264L98.1983 87.9683L98.0295 88.0521L97.9876 88.1372L98.0295 88.221L97.9876 88.3048V88.3899L97.82 88.5993L97.7768 88.6845L97.693 88.8101L97.6511 88.852L97.5673 89.0209L97.6092 89.1466L97.6511 89.2317V89.3155L97.6092 89.4844L97.693 89.5682L97.7349 89.652V89.7357L97.693 89.779L97.6511 89.9046L97.6092 89.9884L97.4403 90.3681L97.4822 90.41L97.6092 90.4519L97.7768 90.3681H97.82L97.9876 90.3262L98.1565 90.41V90.4519L98.1146 90.4938L97.9876 90.5789L97.7349 90.8302L97.6511 90.9153H97.6092H97.5673H97.5241L97.4403 90.9572L97.062 90.9991H93.3569H93.1893H88.6424L85.1481 90.9572H83.128H82.5808H82.497H77.9501H77.9082H77.8244L77.6974 90.7046L77.6555 90.6627L77.6974 90.5357L77.6555 90.4938L77.5717 90.4519L77.5298 90.41L77.4028 90.3681L77.2353 90.41L77.1921 90.3681L77.1502 90.2411L77.0664 90.283H76.9826L76.9394 90.3681L76.9826 90.41L76.9394 90.4519V90.4938L76.8556 90.5357V90.5789L76.7718 90.6627L76.6867 90.6208H76.561L76.4353 90.5357H76.3921L76.3502 90.6208V90.8302L76.2665 90.9153L76.2246 90.9991L76.2665 91.0829L76.2246 91.1248V91.168V91.2937L76.0976 91.3775H75.9719V91.4626H75.8462L75.7611 91.5045L75.5084 91.4207L75.4665 91.4626L75.4246 91.4207V91.2937L75.3408 91.168L75.2557 91.1248L75.172 90.9572H75.0463H74.9193L74.7517 91.041L74.5828 90.9991L74.4139 90.5789V90.5357L74.4558 90.4519L74.4139 90.41L74.3301 90.3681L74.2882 90.283L74.3301 90.1992L74.2463 90.0735L74.1193 89.9884L74.1612 89.9465H74.2882V89.8627L74.2463 89.779L74.2031 89.652H74.1193H73.9518L73.8667 89.5682L73.6991 89.5263L73.6572 89.5682L73.5721 89.6101L73.5302 89.652V89.7357L73.6572 89.8627L73.614 89.9465H73.5721L73.2775 89.7357L73.2356 89.6939V89.652L73.3194 89.5263L73.3613 89.4412L73.2775 89.3574L73.3194 89.2317L73.2775 89.1466H73.1937L73.1518 89.1047L73.1086 89.0209V88.8939L73.0667 88.7263L73.1086 88.5575L73.1518 88.4737V88.3899L73.1086 88.3467L73.0248 88.3048L72.9411 88.2629H72.8573L72.6884 88.221L72.6046 88.1791L72.5627 88.0953L72.4776 88.0102L72.4357 88.0521H72.3938L72.3519 88.1372L72.2668 88.1791L72.1411 88.3048H72.0992V88.2629L72.0573 88.221L72.0154 88.1372H71.9304L71.9722 88.0521L71.9304 87.9683V87.8845H71.8885L71.9304 87.7994L71.8885 87.6737H71.8466L71.8047 87.6318H71.7628L71.7196 87.59L71.6777 87.6318L71.6358 87.59L71.5939 87.5049L71.3412 87.3792L71.2993 87.3373L71.3412 87.2954L71.2574 87.1265L71.1723 87.0846L71.1304 87.0008V86.9576V86.9157L71.1723 86.8738L71.2155 86.79L71.1723 86.7481L71.1304 86.6211L71.1723 86.5792L71.0885 86.4955V86.4522L70.9628 86.3685L70.8777 86.2847L70.7521 86.1577L70.4994 86.032H70.3305L70.2886 85.9482L70.2048 85.8212H70.1629L70.121 85.7793H70.0778L69.994 85.6955H67.1321H66.0795H65.8687L65.3215 85.6536L65.2796 85.9482L65.3215 86.032L65.2796 86.1158L65.1958 86.1577L65.1539 86.2847L65.0269 86.3685V86.4522L65.0688 86.4955L65.0269 86.6211L64.985 86.663L64.8593 86.8738L64.6485 87.0008L64.5215 87.1265V87.1684L64.6904 87.463L64.5215 87.59L64.4377 87.7156V87.7994L64.3539 87.9264L64.3107 87.9683H64.2688L64.0594 87.7994L63.9324 87.7575L63.8067 87.7156H63.7648H63.6797L63.6378 87.7994L63.554 87.9264L63.5121 87.9683L63.3851 87.9264L63.3013 87.9683V88.3467L63.0906 88.4737V88.5575L63.2594 88.5993L63.3432 88.6845V88.7682L63.1325 88.9371V88.979L63.1743 89.1047L63.3013 89.2317V89.3574L63.3851 89.4412H63.427V89.5263L63.3013 89.7357H63.2594L63.1743 89.652V89.6101L63.1325 89.5682H63.0906L63.0487 89.6101L63.0068 89.8208L62.9217 89.8627V89.9465L62.8798 90.0303L62.8379 90.0735L62.8798 90.1154L62.7541 90.283L62.796 90.4519L62.5433 90.41H62.5014L62.3744 90.4938H62.2906L62.2068 90.4519L62.1649 90.4938L62.0798 90.6208V90.8302L62.1649 90.9991L62.1217 91.0829L61.9961 91.2099V91.2518V91.2937L62.038 91.4207V91.5883L62.0798 91.8829V91.968L62.038 92.0098H61.8704L61.5326 92.2193L61.3231 92.1774L61.1123 92.2193H61.0272L60.9435 92.1774V92.1355L61.0272 91.9248V91.841V91.7991H60.9435L60.607 91.9248L60.4381 92.0098L60.2705 92.0517L60.1854 92.0936H60.1435H60.0597L59.8908 92.1355L59.6382 92.0936H59.5544L59.5125 92.1355L59.4287 92.1774H59.3868V92.2625L59.3017 92.3044L59.2598 92.3463H59.176L59.0071 92.3044H58.8814L58.7963 92.3463L58.7126 92.2193L58.6707 92.1774H58.5869V92.2193L58.418 92.3463L58.2923 92.3882H58.2491L58.1234 92.2193L58.0815 92.1774H57.9964H57.9126L57.7451 92.2193L57.5762 92.3463L57.4492 92.4301L57.4073 92.5152L57.3654 92.5571L57.2816 92.5152V92.5571V92.7247L57.1978 93.0192L57.1546 93.0625V93.1043V93.1881L57.1978 93.23V93.3989V93.4408L57.2397 93.5246V93.5665L57.2816 93.6516L57.2397 93.6935L57.1978 93.7773L57.1546 93.9043V93.9462L57.0708 93.9881V94.03L56.987 94.1137H56.86L56.7762 94.1988V94.2826L56.6924 94.3664L56.7343 94.4515H56.6506L56.6073 94.4934L56.5655 94.5353H56.5236L56.5655 94.661L56.4817 94.7461V94.788L56.4398 94.8299H56.2709H56.229L56.1871 94.8718L56.229 94.9556L56.1452 94.9988H56.0601L55.8925 95.1245L55.8074 95.0407L55.6817 94.9988H55.6398H55.5979V94.9137L55.6817 94.788V94.7042L55.556 94.661V94.6191L55.5979 94.4515L55.471 94.2407V94.157V94.1137V94.0719V94.03L55.2615 93.9043H55.2183L55.0088 93.9881L54.9237 94.0719L54.6291 94.2407L54.5872 94.3245H54.4183V94.3664L54.3765 94.4083H54.3346L54.2089 94.3245L54.04 94.2407L53.9981 94.2826V94.3245V94.3664V94.4515V94.6191L53.9562 94.8299V94.8718L53.9981 94.9556L54.0819 95.1664V95.2515L54.04 95.2083L53.9562 95.2515L53.8711 95.1664L53.8292 95.2515L53.7035 95.2934L53.6616 95.2515V95.1664L53.6184 95.1245H53.5765H53.5346L53.3238 94.9556L53.2401 94.9137H53.1144H53.0725L52.9455 94.9556L52.8198 94.9988L52.7779 95.0407L52.7347 95.1245H52.6928H52.609H52.5671L52.5239 95.4609L52.4401 95.5028L52.2725 95.8406H52.2293L52.1456 95.7987H52.1037L52.0618 95.8825H51.978L51.9348 95.9244L51.851 96.0082H51.8091L51.7672 95.8825L51.7253 95.8406H51.6834L51.6402 95.6298L51.5564 95.6717H51.5145V95.546L51.4726 95.5028H51.4307L51.3037 95.3771H51.2199L51.093 95.3352L51.0511 95.2515L51.0092 95.1245L50.8835 95.0407L50.8403 94.9988L50.7565 94.9556V94.8718H50.6308L50.5457 94.8299H50.3362H50.293V94.8718L50.2092 94.9137H49.9566L49.8309 94.8718H49.789H49.7458L49.6201 94.9556H49.5782L49.4944 95.0407L49.2836 94.9556H49.1985L49.1147 94.9988H49.0728L48.9458 94.8718H48.9039H48.7783L48.8202 94.9988L48.7783 95.0407H48.6513H48.6094V94.9556L48.5675 94.9137L48.4837 94.9988L48.3567 94.9137L48.2729 94.9556H48.231L48.0202 94.8718L47.9783 94.9137V94.9556L48.104 95.0407L48.1472 95.1664V95.4609L47.9364 95.6298L47.8527 95.7987L47.6838 95.9663L47.5149 96.0933L47.473 96.1771V96.2609V96.3027L47.2203 96.346L47.1365 96.4716L46.9676 96.5135L46.9257 96.5554L46.8 96.5135L46.715 96.5973L46.3366 96.8081L46.2947 96.9351L46.2109 97.0189L46.0839 97.1027H45.915H45.8312L45.7474 97.0608L45.7056 97.1027L45.7474 97.1446V97.3135L45.5786 97.4405L43.9787 96.7662L43.726 96.6405L43.5165 96.5973L43.3477 96.4716L42.337 96.0501L38.5494 94.4083L37.0333 93.7354L34.339 92.5571L33.666 92.2625L33.4972 92.1774L33.2877 92.0936L32.0243 91.3775L30.846 90.7884L29.2462 89.9465L28.53 89.5682L27.2679 88.852L24.9519 87.59L23.9412 87.0427L23.4791 86.7481L22.8899 86.6211L22.2157 86.4522L19.9429 85.9901L18.0485 85.5266L16.4067 85.1483L16.0284 85.0632L13.4597 84.4321H13.334L13.207 84.3902L12.2814 84.0957L12.1976 84.0538L9.29247 83.4646L9.08169 83.3795L7.98719 82.8323L5.12526 81.5283L2.55789 80.3906L2.17822 80.1811Z"
							fill="#52a8ff" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="RR" @mouseenter="e => hoverES(e, 'RR')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M61.8273 12.4085V12.3247V12.1139V11.945L61.7016 11.7774L61.4489 11.5247L61.3651 11.3978L61.2381 11.314V11.2721L61.1544 11.0613L60.9436 10.9343L60.8598 10.8505L60.5652 10.6829L60.4382 10.6397L60.3125 10.5559L60.1855 10.514L60.018 10.5559L59.9761 10.514L59.8491 10.3451L59.7234 10.1357L59.5545 10.0087L59.4288 9.883L59.3869 9.58842L59.2599 9.54522L59.1342 9.46143L59.0491 9.29385L58.9235 9.20875L58.7965 9.12496V9.08307L58.7546 9.04117L58.7127 8.87229L58.587 8.7034L58.5019 8.45072L58.4181 8.36693L58.2924 8.28314L58.1235 8.15615L57.9546 8.03046L57.8708 7.77779V7.567L57.9127 7.44132L58.0397 7.31432H58.1235L58.6708 7.567L58.8816 7.77779L59.091 8.24125L59.3018 8.40883L59.5126 8.49392L59.5964 8.40883H59.7234L59.8491 8.45072V8.40883L60.1436 8.36693L60.3125 8.28314H60.4814H60.5652L60.9017 8.32504L61.0706 8.28314L61.1544 8.24125H61.28V8.32504H61.3232H61.407L61.5327 8.36693L61.6178 8.40883H61.7854L61.9124 8.32504H61.9543L62.0381 8.45072H62.1219L62.2489 8.57771L62.3745 8.7885V8.87229L62.3326 8.91418L62.3745 8.99797L62.5015 9.12496L62.6704 9.46143L62.7542 9.50333V9.54522L62.965 9.58842V9.756L63.0488 9.7979H63.0907L63.1745 9.96679H63.2164V9.883V9.83979L63.2596 9.883L63.3015 9.7979L63.3434 9.756L63.3852 9.67221L63.4271 9.63032H63.5122L63.5541 9.58842L63.596 9.54522L63.6379 9.58842L63.8068 9.50333L63.8487 9.46143L63.8906 9.50333V9.46143H63.9325L63.9744 9.50333V9.54522H64.1014L64.2271 9.58842L64.396 9.54522H64.4797L64.6054 9.58842L64.5635 9.63032L64.6054 9.67221L64.6905 9.71411L64.7324 9.756H64.7743V9.71411H64.8594L64.9432 9.756L65.0689 9.63032H64.9851L64.9432 9.58842V9.54522H64.8594L64.8162 9.50333V9.46143L64.8594 9.41954V9.37764L64.9013 9.25065V9.20875V9.16686V9.08307V9.04117H64.9851L65.0689 9.08307L65.1108 9.12496L65.1959 9.29385L65.2797 9.33575L65.3635 9.46143L65.4905 9.58842L65.5324 9.67221L65.4905 9.756L65.5324 9.7979L65.4905 9.83979V9.883H65.5742H65.6161L65.7431 9.83979V9.96679V10.0087H65.785H65.8269L65.8688 10.0506H65.9107L65.9958 10.1357L66.0377 10.0925L66.0796 10.1776V10.0925L66.0377 9.96679H66.0796L66.1215 10.0087V9.96679H66.1634L66.2485 10.0087H66.2904L66.3742 10.0506L66.458 10.0087V9.92489V9.883L66.585 9.756L66.6269 9.71411L66.5431 9.63032L66.585 9.58842V9.54522H66.4999H66.458H66.4161L66.458 9.46143H66.3742V9.41954L66.4999 9.29385H66.585L66.7106 9.25065L66.9633 9.41954H67.0903L67.1741 9.37764H67.216V9.33575L67.2579 9.25065L67.2998 9.29385L67.343 9.33575H67.3849L67.4268 9.41954L67.5944 9.37764L67.6376 9.41954L67.8051 9.46143H67.8889L67.8051 9.7979L67.7214 9.883V10.0925L67.7632 10.1357V10.1776L67.8889 10.3451H67.974H68.0578L68.1416 10.3884H68.2267H68.3105H68.3943L68.5213 10.4721L68.647 10.5559V10.6397L68.7321 10.7248H68.774L68.8159 10.7667V10.8086L68.774 10.8505V11.0194L68.7321 11.1032H68.647L68.7321 11.1451L68.9834 11.2721V11.3978H69.0685L69.1523 11.5247L69.2361 11.6085L69.2793 11.6504H69.3631H69.405L69.4469 11.6085L69.6158 11.4396L69.6577 11.3559V11.2302H69.7415L69.8685 11.1451L69.9522 11.0613L70.0779 10.9775L70.2049 10.8086L70.2887 10.8505H70.3306H70.3738L70.4157 10.9343H70.4576L70.4995 11.0613H70.5414L70.5833 11.1451L70.7103 11.2302H70.7522V11.1451H70.7941V11.0613L70.836 11.0194L70.7941 10.9343L70.836 10.8086L70.7941 10.6829V10.5559L70.7522 10.514L70.836 10.4302V10.3884H70.7522L70.7103 10.3033L70.5833 10.2195V10.1776L70.7103 10.0925H70.6684V10.0506L70.5833 10.0087L70.5414 9.92489V9.883L70.4576 9.83979L70.4995 9.67221V9.63032V9.58842V9.54522L70.6252 9.50333L70.7103 9.41954L70.7522 9.29385L70.6252 9.25065L70.5833 9.08307H70.6252L70.7103 8.99797V8.95608V8.91418L70.7941 8.87229L71.0049 8.95608L71.0886 8.91418H71.1724H71.2994V8.87229L71.3413 8.83039L71.4683 8.87229H71.594L71.6359 8.91418H71.7197L71.7629 8.99797V9.04117H71.8048H71.9305L71.8886 8.99797V8.91418L71.9724 8.87229H72.0156L72.0575 8.83039L72.0156 8.74529V8.61961L71.9724 8.6615L71.8886 8.61961H71.9305L71.9724 8.53582L71.9305 8.45072H72.0156L72.1412 8.40883V8.36693L72.0575 8.28314L72.225 8.32504V8.28314L72.2669 8.24125H72.3101L72.352 8.28314L72.3939 8.32504L72.4358 8.24125H72.4777H72.5196V8.15615H72.5628L72.5196 8.11425H72.4358L72.4777 8.03046L72.5196 7.98857L72.5628 8.03046H72.6047V7.98857H72.6466H72.7723V7.94667L72.8142 7.98857H72.8574L72.8993 8.03046H72.9412V7.98857L73.0669 8.11425H73.1088V8.07236H73.1939V8.19935H73.2358L73.3195 8.28314L73.3614 8.24125H73.4046V8.28314H73.4884L73.5722 8.24125L73.6141 8.32504H73.783L73.8668 8.40883L73.9087 8.36693L73.9519 8.40883L74.0357 8.45072L74.1614 8.40883V8.45072V8.53582L74.2884 8.57771H74.3303H74.3721L74.4559 8.61961V8.6615L74.4991 8.61961L74.541 8.57771H74.6667V8.53582V8.49392H74.6248V8.40883H74.7086L74.7518 8.36693V8.32504H74.7937L74.8356 8.36693H74.8775L74.9194 8.32504L74.8775 8.28314V8.19935V8.15615L74.9613 8.11425L75.0883 8.19935L75.1302 8.15615L75.1721 8.11425V8.15615V8.19935L75.214 8.15615H75.2978L75.341 8.07236L75.3829 8.11425L75.4248 8.03046L75.4666 7.98857H75.5085L75.4666 8.03046V8.11425L75.5085 8.15615L75.6774 8.32504L75.7193 8.45072L75.8031 8.49392V8.45072V8.40883V8.36693L75.8463 8.19935V8.15615H75.9301L75.972 8.11425L76.0558 8.15615H76.0977H76.1409L76.1828 8.11425L76.1409 8.07236L76.1828 8.03046H76.2247H76.3085V8.07236L76.3923 8.11425H76.4774V8.07236L76.5193 7.94667L76.4774 7.86157H76.5611V7.77779L76.603 7.73589V7.694L76.6868 7.65079V7.694H76.73H76.8138V7.65079L76.7719 7.6089V7.567H76.8138L76.9827 7.52511L77.0246 7.44132H77.0665V7.48321L77.0246 7.52511L77.0665 7.567L77.1922 7.52511H77.2773H77.3192H77.3611L77.403 7.48321H77.4449H77.4868V7.52511H77.5719V7.6089H77.6138H77.6556L77.6975 7.52511L77.7813 7.48321L77.8245 7.567H77.9083L78.034 7.52511H78.0772L78.1191 7.48321V7.44132L78.2029 7.39942L78.2867 7.31432H78.3299V7.27243L78.3718 7.14675L78.4137 7.10485L78.3299 7.06165V7.01975L78.2867 6.93596H78.3299L78.3718 6.89407L78.3299 6.76707V6.68329L78.3718 6.64139V6.5995V6.5576L78.5394 6.5144L78.6245 6.43061H78.6664L78.7083 6.34682H78.792H78.8339L78.8758 6.38871L78.8339 6.43061H78.919V6.38871H78.9609H79.0447V6.43061H79.2555L79.3812 6.4725H79.4663V6.38871H79.592L79.5501 6.30492L79.6339 6.26172V6.21982H79.8028L79.7609 6.17793L79.8446 6.13603V6.09414L79.719 6.05225V5.96715H79.6758L79.6339 5.92525H79.592V5.88336L79.5082 5.84146L79.5501 5.71578H79.6758V5.67257L79.719 5.71578H79.8028L79.8446 5.75767H79.8865V5.67257L79.9703 5.71578L80.0135 5.79957L80.0554 5.71578L80.223 5.79957V5.71578L80.3081 5.84146L80.35 5.79957H80.3919L80.4757 5.88336L80.5189 5.92525H80.5608V5.96715H80.6446V6.05225L80.7284 5.96715H80.7703V5.92525L80.8973 5.88336L80.981 5.79957L81.0648 5.84146H81.108L81.1499 5.79957H81.2756H81.4445V5.84146H81.5283H81.6121V5.79957L81.6553 5.67257H81.781L81.8229 5.63068L81.8648 5.54689L81.8229 5.4199H81.9499L81.9918 5.378L81.9499 5.33611L81.908 5.29421L81.9918 5.21042L81.9499 5.16722V5.08343L81.8648 5.04153V4.95774H81.908H81.9918V4.91585L82.0755 4.87265L82.1174 4.78886V4.66317L82.2025 4.57807H82.3282L82.3701 4.62128L82.4971 4.66317L82.6228 4.49428H82.6647L82.7498 4.45239L82.7066 4.41049L82.7498 4.3686H82.8755V4.3254L83.0444 4.2835L83.1281 4.3254L83.17 4.2835L83.2119 4.19971H83.2538L83.297 4.15782H83.2538L83.297 4.11592L83.2538 4.07272L83.297 4.03082L83.3808 3.94703H83.4646L83.5065 3.90514V3.86324L83.5916 3.82135V3.77815L83.6754 3.69436L83.7173 3.61057L83.7592 3.56867L83.7173 3.52678V3.48357L83.8862 3.44168V3.35789L83.97 3.2741L84.0119 3.2309H84.097L84.1389 3.02142L84.097 2.93632L84.0538 2.76874L83.97 2.72685V2.64175L83.8862 2.55796L83.8443 2.43228L83.7592 2.38907L83.8011 2.22149L83.7592 2.1364L83.8011 2.05261V2.01071L83.7592 1.96882L83.7173 2.05261V2.01071L83.6754 1.88503L83.7173 1.79993L83.6754 1.71614L83.5497 1.63235V1.54725L83.5065 1.50536H83.4646H83.4227H83.297L83.2119 1.46346L83.297 1.33778H83.3808L83.4646 1.29457L83.5497 1.25268L83.6754 1.29457H83.7173L83.8011 1.33778L83.8862 1.37967L83.97 1.33778L84.0119 1.37967L84.0538 1.33778H84.097V1.42157L84.2226 1.50536H84.3915L84.4334 1.46346L84.5172 1.42157L84.6861 1.46346H84.8118H84.8537H84.8956H84.9807L85.0226 1.58914H85.0645L85.1902 1.50536V1.42157V1.37967L85.2753 1.42157L85.4009 1.33778L85.486 1.37967V1.42157V1.46346L85.5698 1.42157H85.6117H85.6955H85.7387H85.8225L85.8644 1.29457H86.0333V1.25268H86.0752L86.1171 1.21078V1.12699H86.2428L86.3279 1.0851L86.3698 1.04189L86.4535 1L86.5373 1.04189L86.5805 1.12699V1.21078L86.7062 1.29457L86.79 1.25268L86.917 1.16889L86.9589 1.29457L87.1278 1.50536L87.1697 1.79993V1.84182H87.2954L87.3373 1.88503L87.3792 1.92692V1.96882L87.4224 2.05261H87.4643L87.5899 2.1364V2.1796L87.6318 2.1364L87.7169 2.1796H87.7588L87.8007 2.22149L87.7588 2.26339L87.8007 2.30528L87.7169 2.38907L87.8007 2.43228V2.47417L87.7588 2.51607V2.55796V2.59986V2.68365L87.8426 2.85253L87.8007 2.89443L87.8426 2.93632L87.8007 3.02142L87.8426 3.10521H87.8007V3.189L87.7588 3.2741L87.7169 3.35789L87.675 3.77815L87.6318 3.82135L87.5899 3.86324L87.548 3.94703L87.5899 3.98893L87.548 4.07272L87.5062 4.11592L87.5899 4.19971V4.2835V4.41049L87.5062 4.57807L87.5899 4.62128V4.66317L87.3792 4.87265L87.2954 4.99964L87.2535 5.04153L87.2954 5.08343V5.16722V5.25232L87.1278 5.33611L87.0846 5.29421L87.0427 5.33611H87.0008L86.917 5.378L86.9589 5.505H86.8751L86.917 5.58878H86.8332V5.54689H86.79L86.7481 5.58878V5.67257L86.79 5.71578L86.7481 5.88336L86.79 5.92525H86.917H86.9589H87.1278L87.0846 5.84146L87.2116 5.79957V5.84146V5.88336L87.2954 5.84146L87.3373 5.88336V5.92525V5.96715H87.3792H87.5062L87.548 6.01035L87.6318 5.96715L87.675 6.01035L87.7169 5.96715H87.7588L87.8007 6.05225L87.8845 6.09414L87.9277 6.05225V6.09414H87.9696L87.9277 6.05225L87.9696 5.92525H88.0115V5.96715L88.1372 6.01035L88.1791 5.96715V6.01035L88.2642 6.05225L88.2223 6.09414L88.348 6.13603L88.3061 6.17793L88.348 6.21982L88.4318 6.13603H88.5169L88.5588 6.05225V6.09414L88.6425 6.13603L88.6007 6.21982L88.6425 6.26172H88.6844H88.7263L88.8114 6.21982L88.8533 6.26172L88.9371 6.30492L88.979 6.26172V6.17793H89.0209L89.0641 6.30492H89.1479V6.34682H89.2317L89.3168 6.4725H89.4006L89.4844 6.5576L89.5263 6.5995L89.6533 6.72518L89.737 6.68329L89.8208 6.76707L89.737 6.81028L89.7789 6.93596V6.97786L89.6952 7.01975L89.6114 7.10485V7.18864H89.5682H89.5263L89.4844 7.27243L89.4425 7.31432V7.35622V7.39942H89.5263L89.5682 7.44132L89.4006 7.65079L89.4425 7.694V7.81968L89.4844 7.94667V7.98857L89.5682 8.07236L89.6114 8.11425L89.737 8.19935H89.9897L90.1586 8.28314L90.1154 8.40883L90.0735 8.45072L89.9478 8.7034H89.9897L90.0735 8.7885H90.1586V8.83039V8.91418L90.2843 8.95608V9.04117H90.2424L90.2005 8.99797V9.04117L90.2424 9.08307L90.3262 8.99797V9.08307L90.2843 9.12496L90.3262 9.16686L90.3681 9.12496H90.4113L90.3681 9.16686L90.4113 9.20875L90.3262 9.29385V9.33575H90.4113L90.4532 9.37764L90.4951 9.29385H90.5789V9.33575H90.7059L90.7478 9.41954V9.46143L90.7897 9.50333L90.7059 9.54522V9.58842V9.63032H90.6627L90.6208 9.58842H90.5789L90.6208 9.63032L90.5789 9.67221H90.4532V9.83979L90.3681 9.756L90.4113 9.83979H90.3262L90.2843 9.883V10.0087V10.0506H90.3262V10.0925V10.1776L90.3681 10.2195V10.3033L90.3262 10.2614L90.2843 10.3033L90.2424 10.3451L90.2843 10.3884V10.4302L90.2424 10.4721L90.2005 10.3884L90.1586 10.4721L90.0735 10.514H90.0316L90.0735 10.4721V10.4302H90.0316L89.9897 10.514H89.9478L89.8627 10.5559L89.8208 10.6397L89.737 10.6829V10.7248H89.7789V10.7667L89.8208 10.8086L89.8627 10.8505L89.8208 10.8924L89.8627 10.9775L89.8208 11.0613L89.737 11.1032L89.6952 11.0613L89.6533 11.1451H89.6114L89.5682 11.187L89.5263 11.2302L89.4844 11.2721V11.314H89.3587L89.3168 11.3559L89.2736 11.4829H89.1898L89.2317 11.5247H89.1479L89.0641 11.6085L89.0209 11.5666L88.979 11.6085L88.8952 11.5666V11.6504L88.8533 11.6085L88.7682 11.6504H88.6844V11.7342L88.6425 11.8193L88.6007 11.8612H88.6425V11.9031L88.5588 11.945L88.6007 11.9869H88.7263V12.072L88.7682 12.1558L88.8952 12.1977L88.979 12.2815V12.4085L88.8533 12.4504V12.4923H88.9371V12.5341H88.8952H88.8533L88.8114 12.6192L88.7682 12.703V12.7449V12.8287H88.8114L88.8952 12.7868H88.9371L88.8952 12.9138L88.9371 13.1233L88.979 13.1665V13.2503L88.9371 13.2922L88.8533 13.2503L88.8114 13.2922L88.8533 13.4192L88.8114 13.4611L88.7682 13.503L88.7263 13.5449L88.6844 13.5868L88.6425 13.7556H88.5588L88.5169 13.8813V13.9664L88.4737 14.0083L88.5588 14.0921L88.4737 14.134H88.348V14.1759L88.3061 14.3448L88.3899 14.5556L88.348 14.5975H88.2642H88.3061H88.348V14.6394H88.3061L88.2642 14.6813V14.7231H88.348V14.8082H88.3061L88.2642 14.765L88.2223 14.8501L88.1372 14.892V14.9758L88.0534 15.0177V15.0609L88.0953 15.1866L88.0534 15.2704L88.0115 15.3555V15.4393L88.0953 15.5231L88.0534 15.565L88.0115 15.7758V15.8177L87.8845 15.9865L87.8426 16.1122L87.9277 16.1541V16.1973L87.8426 16.2811L87.8845 16.3649L87.8426 16.4068L87.8845 16.4919L87.8426 16.5338V16.5757V16.7865L87.8007 16.9122L87.8426 17.1648L87.8007 17.2486L87.8426 17.5013V17.5445L87.9277 17.6702L87.9696 17.7121L87.9277 17.7972V17.8391L88.0115 17.9229V18.0067L88.0534 18.0485H87.9696V18.1336H88.0115L88.1372 18.2174L88.2223 18.3012L88.1791 18.3863L88.3061 18.5539L88.2642 18.5958V18.6809L88.3061 18.7228V18.7647L88.4318 18.8485L88.3899 18.9336L88.4318 18.9755V19.0174L88.3899 19.143L88.4737 19.2281H88.4318V19.3119L88.348 19.3957V19.4376L88.4318 19.6065L88.5169 19.6903L88.5588 19.6065L88.6007 19.6903L88.6844 19.7754V19.8173H88.7263L88.7682 19.9011L88.8114 19.8592L88.8533 19.8173V19.9011L88.979 19.943L89.0209 20.0281L89.106 20.1119H89.1479L89.1898 20.07H89.3168H89.4006V20.1119L89.4844 20.1538L89.4425 20.2375L89.5263 20.3226V20.4064L89.4425 20.4483L89.4844 20.6172H89.4425L89.4844 20.6591L89.4425 20.7429L89.4006 20.7848V20.8267V20.8699V20.9118V20.9956L89.4844 21.0794L89.4425 21.1226L89.4844 21.1645V21.2064V21.2902L89.4006 21.332L89.3587 21.459L89.4006 21.6266H89.4425V21.6698L89.4844 21.7117L89.4425 21.7536H89.5263L89.4844 21.7955H89.4425L89.4006 21.8374H89.4425V21.8793V21.9212V22.0482H89.4006L89.3587 22.0901L89.4006 22.132L89.3587 22.259V22.3847L89.2736 22.4265L89.3168 22.5116L89.2736 22.5535L89.3587 22.6792L89.3168 22.8062L89.3587 22.89H89.4006H89.4425H89.4844L89.5682 22.8481H89.6952L89.737 22.9319L89.7789 22.9738L89.8627 22.89L89.8208 22.8062L89.8627 22.7643V22.8062L89.9478 22.9319L89.9059 23.0589V23.1008L89.8627 23.1427V23.1008L89.7789 23.1427L89.737 23.2265L89.7789 23.2684H89.737L89.6952 23.3535L89.737 23.3954L89.6952 23.4373V23.4792H89.8208L89.8627 23.5643V23.6061L89.9059 23.5643L90.0316 23.6061L90.0735 23.648L90.1586 23.7318L90.2005 23.6899H90.3262L90.3681 23.648L90.4532 23.6061L90.537 23.6899L90.5789 23.648V23.6899H90.6208L90.6627 23.7318V23.7737L90.7059 23.8156V23.9007L90.7897 23.9845V24.0683H90.8315V24.0264L90.8734 23.9845L90.9153 24.0264V24.1953V24.2372L90.9572 24.321L91.0842 24.3629H91.2099L91.2531 24.5318L91.3369 24.5737L91.295 24.7006L91.3369 24.7844H91.4207L91.5058 24.7425V24.7844V24.8682L91.5896 24.9533V24.9952H91.6315L91.5896 25.079H91.6734H91.7153V25.1209L91.7572 25.079V24.9952H91.8842L91.926 25.0371V25.079L91.9679 25.2479L91.926 25.2898V25.3736H92.0098L92.0517 25.3317H92.0949L92.1787 25.4155L92.2206 25.4574L92.1787 25.5006L92.2206 25.5425L92.2625 25.6682L92.2206 25.71H92.2625L92.3044 25.7519L92.3476 25.7951L92.3895 25.837H92.5152L92.5571 25.9208L92.6841 25.9627V25.9208H92.7679H92.8098L92.8949 26.0046L92.9368 26.0478H92.9787L93.0205 26.0897H93.0624H93.1462L93.2313 26.1316L93.3151 26.0897L93.357 26.1316L93.3989 26.0897L93.4421 26.1735L93.484 26.2154H93.5259L93.5678 26.1735H93.6097L93.6516 26.2573L93.8205 26.2154L93.9043 26.2573H93.9894V26.2154L94.0313 26.2573L94.0732 26.3424L94.115 26.3843L94.1569 26.3424H94.1988L94.4934 26.2992V26.3843L94.4515 26.4262V26.4681L94.4934 26.51L94.5785 26.5519L94.6623 26.6789L94.5785 26.7208V26.7627L94.5366 26.8045L94.6204 26.8464V33.0351H92.7679H91.295H87.548L87.4643 33.2459L87.4224 33.6661L87.3373 33.7512L87.2535 33.7931L87.0427 33.8769V33.9188L86.917 34.0458V34.1296L86.9589 34.1715L87.0008 34.2134L86.917 34.2985V34.3823V34.4242L86.8751 34.4661L86.917 34.5512L86.79 34.593L86.7062 34.7187H86.6224L86.6643 34.7606L86.4954 34.9295V35.0971L86.4116 35.266L86.3698 35.3498L86.3279 35.4349L86.3698 35.4768V35.5187L86.4116 35.5606L86.3698 35.6443H86.3279L86.2009 35.7713L86.2428 35.8551L86.159 35.8132L86.1171 35.8551V35.9402L86.0752 36.024L85.9901 36.0659L85.9482 36.024L85.9063 36.0659L85.9482 36.1916L85.9063 36.3605L85.8644 36.4024L85.9901 36.5713L85.9482 36.6132L85.9063 36.6551V36.8239H85.7806V36.8658L85.8225 36.9915L85.7806 37.0766V37.1185L85.6955 37.1604L85.6536 37.2861L85.6117 37.3293L85.6536 37.3712L85.6117 37.4131L85.6536 37.455V37.5388L85.4009 37.7077V37.7914L85.359 37.8765V37.9184L85.2753 37.9603L85.3171 38.213V38.2549L85.4009 38.2968V38.3806L85.359 38.4238L85.4009 38.5076L85.486 38.4657V38.5495L85.5698 38.5914L85.6117 38.6765L85.6536 38.7184L85.7387 38.8022H85.7806H85.8225V38.9278L85.9063 39.0129L85.8644 39.1386H85.9063V39.2656L85.8644 39.3494H85.8225L85.6536 39.4332L85.6117 39.4751H85.5698H85.4428L85.4009 39.5602H85.2753L85.1902 39.6021L85.1483 39.644L85.1064 39.6859L85.0645 39.644H84.9388H84.8537H84.8118L84.728 39.7278L84.6861 39.771L84.728 39.8129L84.6861 39.8548L84.728 39.8967L84.6861 39.9804H84.6442L84.5591 40.0655L84.6442 40.1074V40.1493L84.4753 40.3169H84.4334L84.3915 40.275H84.3064V40.2331L84.097 40.1493V40.275L83.97 40.2331H83.9281L83.8862 40.275H83.8443V40.3169L83.7173 40.3601L83.6335 40.4439L83.5916 40.402L83.6335 40.3169H83.5916L83.3808 40.2331L83.3389 40.275L83.2119 40.1912L83.0863 40.2331L83.1281 40.1493L83.0863 40.1074L83.0444 40.0223L83.0863 39.9386L83.0444 39.8967L83.0863 39.8129L82.9593 39.771V39.7278L83.0025 39.6859L83.0444 39.6021L83.0025 39.5183L82.9593 39.5602L82.9174 39.5183L82.8755 39.4751H82.8336V39.4332V39.3913V39.1805L82.7498 39.1386H82.539L82.4971 39.0129V38.971V38.8859L82.4552 38.8441L82.412 38.8022L82.2863 38.8859L82.1174 38.7184V38.6333H82.0755V38.4657L82.1174 38.4238L82.0755 38.2549H81.9918L81.9499 38.2968H81.908L81.8648 38.2549L81.8229 38.2968H81.7391H81.5702L81.4026 38.213H81.3607H81.2756L81.2337 38.1711L81.1918 38.0022L81.0229 37.9184H80.981L80.8554 37.9603L80.8135 37.9184L80.7703 37.8765L80.6446 37.9184L80.6027 37.9603V38.0022L80.4757 37.9603H80.35L80.2662 37.9184H80.223L80.1811 37.9603V38.0441L80.223 38.1292L80.1811 38.1711V38.2968L80.1392 38.3387L79.8446 38.3806H79.8028H79.719L79.5501 38.5495L79.4244 38.5076L79.3393 38.5495L79.2974 38.5914L79.1285 38.6765L79.0447 38.7603H78.919V38.8441V38.8859L78.8758 38.9278H78.7501L78.7083 38.971L78.6245 39.0967V39.2224L78.5813 39.3075L78.3718 39.4751L78.2448 39.5602L78.161 39.771V39.8967V40.0655L78.2029 40.1074V40.1493L78.1191 40.2331V40.4439L77.9921 40.5277V40.6547L77.9502 40.6966L77.9921 40.8223L77.9502 40.9912L77.9921 41.0331H78.0772V41.1168V41.16L78.161 41.2438L78.2029 41.3276V41.4965L78.161 41.5803H78.034L77.9921 41.6222V41.6641L78.0772 41.7492L77.9921 41.7911V41.833L78.034 41.8749L78.0772 41.96L78.034 42.0019L77.9921 42.0857L77.9502 42.1694L77.9921 42.2964L77.9502 42.3383L77.9083 42.3802L77.8664 42.5491L77.8245 42.6748L77.7813 42.8856L77.6975 42.9694L77.6556 43.0532L77.7813 43.0964L77.9502 43.264V43.349L77.9083 43.4328L77.8664 43.4747L77.7394 43.6436V43.6855H77.7813L77.9502 43.7274L77.9921 43.8531H78.161L78.2448 43.895V43.9382V44.0639L78.3718 44.3166L78.5813 44.4003L78.6245 44.4854L78.6664 44.5273V44.6111L78.6245 44.653V44.8219H78.5813L78.5394 44.78L78.2029 44.4854L78.1191 44.2747L78.034 44.1477L77.8245 43.9801L77.6138 43.895L77.4868 43.8531L77.1084 43.7274L76.9827 43.6004L76.8138 43.5585L76.6868 43.5166L76.603 43.5585L76.5193 43.6436L76.4355 43.6855H76.3504H76.1828L76.0139 43.6436L75.972 43.5166L75.9301 43.349L75.8463 43.2221L75.6774 43.0113L75.6355 42.8005L75.5936 42.6748L75.4248 42.5059V42.3802L75.2978 42.0857L75.2559 42.0019L75.1302 41.8749L75.0032 41.7492H74.9194H74.8356L74.7518 41.7073L74.7086 41.6641L74.6667 41.6222L74.6248 41.5803L74.6667 41.4965L74.5829 41.3276H74.4991L74.4559 41.2857H74.414L74.3303 41.2019L74.2884 41.16L74.1195 41.1168V40.9912H74.0357L73.9519 40.9493H73.783L73.6992 40.8223L73.6141 40.7385L73.5303 40.7804V40.7385L73.4465 40.6547L73.4046 40.5696H73.3195L73.2776 40.4858L73.152 40.3169H73.1088V40.275L73.025 40.2331L73.0669 40.1912V40.1493L73.025 40.1074V40.0655L72.9412 40.0223L72.8993 39.9386L72.7304 39.8967L72.6885 39.8548H72.6047V39.8967L72.5628 39.8548H72.5196L72.4777 39.771L72.3939 39.8129L72.2669 39.7278L72.225 39.6021V39.5602L72.3101 39.5183L72.2669 39.3913H72.225V39.2656L72.3101 39.2224V39.0967L72.352 39.0548L72.4777 39.1386V39.0967L72.5628 39.1386H72.7304V39.1805L72.7723 39.2224L72.8142 39.2656L72.8574 39.3494L72.9412 39.3075V39.2656L72.9831 39.2224L73.1088 39.2656L73.152 39.2224L73.1088 39.1805H73.0669V39.0967V39.0548H73.1939V39.0129L73.2358 39.0548L73.3195 39.0129V38.9278H73.3614H73.4046H73.4465L73.4884 38.8859H73.5303L73.5722 38.8441V38.8022L73.5303 38.7184L73.4884 38.6765V38.6333H73.5722V38.5495L73.4884 38.4657L73.4465 38.4238V38.3387L73.4046 38.2549L73.4465 38.213V38.1711L73.4884 38.1292L73.4465 38.0022L73.4884 37.9603H73.5303L73.5722 37.8765V37.7914L73.6141 37.7496L73.6573 37.7914L73.6992 37.7077H73.6573V37.6239L73.8249 37.5388L73.8668 37.4969L73.9519 37.455L73.9938 37.3293H74.0357V37.2861L74.1195 37.2442L74.0776 37.1185L74.1195 37.0766L74.1614 37.0347V36.8658L74.2033 36.8239L73.9938 36.6969L73.9519 36.7388H73.9087L73.8668 36.6969L73.8249 36.6551L73.8668 36.6132L73.783 36.4875V36.4443L73.8668 36.4024L73.9087 36.3186H73.8249L73.783 36.2348V36.1078L73.8668 36.0659L73.8249 35.9402L73.8668 35.8551V35.8132L73.783 35.7713H73.6992L73.6141 35.6875L73.5722 35.6024L73.5303 35.5187L73.4046 35.3498V35.266L73.3614 35.1822L73.3195 35.1403V35.0971H73.3614V34.9714V34.9295V34.8876L73.2358 34.5079L73.1088 34.4661L73.0669 34.3823L72.9412 34.3404L72.8142 34.2553L72.7304 34.1296V33.9607V33.7931V33.6242L72.6466 33.4567L72.5628 33.3716V33.1608L72.4777 32.9513L72.5196 32.6986L72.4777 32.5716L72.5196 32.4459L72.5628 32.3621V32.3189L72.6047 32.2771L72.5628 32.1933L72.5196 32.0244L72.4777 31.9825L72.352 31.8136L72.225 31.8987H72.1412V31.6041L72.0575 31.4771L72.0994 31.2244L72.1412 30.9731L72.0156 30.3826L72.0575 30.2988L72.0994 30.1731L72.2669 29.9205L72.4777 29.7516L72.5196 29.7097V29.457L72.4777 29.4151L72.3939 29.33L72.352 29.1624L72.4358 28.8679L72.5628 28.7409L72.6047 28.5733V28.4882L72.5196 28.3625L72.4358 28.2355L72.3939 28.1517L72.4358 28.0679L72.3939 28.026V27.9409L72.4358 27.8153V27.7734H72.3939H72.352H72.1412H72.0994L71.9724 27.5207L71.9305 27.1842L71.7197 26.6789L71.594 26.0478L71.5102 26.0046L71.4683 25.8789L71.5102 25.7951V25.7519L71.4251 25.5425L71.3832 25.5006H71.3413L71.1724 25.4155L71.0467 25.2898L70.9211 25.2047L70.836 25.1209L70.7941 24.9533L70.7103 24.9101L70.6684 24.8263L70.5414 24.6574L70.3738 24.5737V24.5318V24.448L70.4157 24.2791L70.5833 24.1102L70.6252 24.0264L70.6684 23.9845L70.836 23.8588L70.8779 23.7737L70.836 23.1008L71.0049 22.7211L71.0467 22.5116L71.0049 22.3009L70.9211 22.2171H70.8779L70.7522 22.132L70.3306 22.0063V21.9644L70.2468 21.8374H70.163L69.6577 21.7536L69.4888 21.7117L69.2793 21.7955L69.0266 21.8374L68.7321 21.6698L68.647 21.5428L68.5213 21.4171L68.4375 21.332L68.3524 21.1645L68.3105 21.0375V20.9118V20.8267H68.1848L68.1416 20.7848H67.974L67.5525 20.9118L67.4268 20.9537L67.2579 20.8699L66.9214 20.6591L66.8795 20.5753L66.6687 20.3645V20.3226L66.7106 20.1957L66.6687 20.0281L66.5431 19.6065V19.5227L66.7106 19.3119V19.1863L66.6269 19.143L66.4161 19.1012L66.0796 19.143L65.4905 19.27L65.1108 19.3957L64.9013 19.4376H64.6486H64.3109L64.0163 19.3119L63.8068 19.2281L63.6379 19.1863L63.2164 19.0174L63.0907 18.9336L63.0488 18.9755L62.965 18.8917H62.9218L62.8799 18.9336H62.838H62.7961L62.7542 18.8917L62.7961 18.8485L62.7123 18.8066V18.7647H62.6272L62.5853 18.7228L62.6272 18.639L62.6704 18.512V18.4282L62.7123 18.3431V18.2593V18.2174L62.7542 18.2593H62.7961V18.1336L62.9218 18.0485V17.9648L63.0069 17.881L63.0488 17.7972V17.7121L63.0069 17.6283H63.0488V17.5445L62.965 17.4594V17.4175L63.0488 17.3337H63.0907L63.0488 17.2486L62.965 17.2067V17.081L63.0069 17.0391V16.9972H62.9218V16.954V16.9122L62.8799 16.8284V16.7865L62.9218 16.7446L62.8799 16.7027L62.6704 16.5757L62.6272 16.4919L62.5434 16.323V15.9446L62.3326 15.8595L62.2907 15.7758L62.207 15.6501L62.1651 15.5231L61.9543 15.3123L61.8705 15.1447L61.6178 14.9339L61.4908 14.8082L61.5327 14.7231L61.6178 14.5556L61.6597 14.4286V14.3448V14.0921V13.9664L61.4908 13.503L61.5327 13.0814L61.407 12.9976L61.3651 12.9138L61.407 12.7868L61.4908 12.703L61.7016 12.4923L61.7854 12.3666L61.8273 12.4085Z"
							fill="#195386" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="AP" @mouseenter="e => hoverES(e, 'AP')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M119.583 19.1439L120.045 19.102L120.34 18.9344L120.72 19.0601L120.678 19.6073L120.888 19.86L121.225 19.7762L122.278 20.5762L123.792 20.7856L124.971 20.4492L125.056 20.4073L125.139 20.4492L125.181 20.3654H125.265L125.308 20.4073L125.35 20.3654V20.3235L125.392 20.2816L125.35 20.1546V20.1127V20.0708L125.392 20.0289V20.0708H125.476V20.1546L125.561 20.1965L125.603 20.0708L125.645 20.1127V20.0708L125.687 20.0289L125.645 19.9857L125.687 19.9019H125.77L125.812 19.9438L125.856 19.9019L125.897 19.9438H125.939L126.065 19.9019H126.107L126.065 19.8181H126.023L125.981 19.7762L126.107 19.733L126.15 19.6492H126.192L126.234 19.6073H126.276L126.318 19.5654L126.36 19.5236H126.403H126.487H126.57L126.612 19.5654H126.57L126.487 19.6073L126.57 19.6492L126.612 19.6073L126.656 19.6911L126.697 19.6492L126.656 19.733L126.57 19.7762L126.612 19.86H126.57L126.529 19.9019V19.9438H126.612L126.656 19.9019L126.781 19.9438H126.865L126.907 20.0289H126.95V19.9857H127.076V20.0289L127.118 19.9857V20.1127H127.245H127.287L127.328 20.1546H127.37V20.1127H127.454L127.539 20.1965H127.581H127.665L127.75 20.2816H127.876L127.959 20.2384H128.001L128.086 20.2816L128.17 20.2384L128.254 20.2816L128.339 20.2384V20.1965L128.296 20.1546L128.254 20.0708H128.296L128.465 20.1546L128.507 20.0708H128.549L128.592 20.0289H128.676L128.718 19.9438H128.801L128.843 19.9019L128.886 19.86L128.928 19.7762V19.6911L129.012 19.6492H129.096L129.139 19.733L129.181 19.6911L129.223 19.7762V19.86L129.265 19.9019L129.349 19.9438H129.434V20.0289L129.559 20.0708V20.1546L129.643 20.1965L129.728 20.1546L129.77 20.2384L129.601 20.3654L129.559 20.3235V20.4492L129.517 20.4911H129.434L129.476 20.533L129.434 20.6181L129.39 20.6599V20.7018L129.434 20.7437H129.476L129.434 20.7018H129.476L129.517 20.7437L129.559 20.7018L129.601 20.6599H129.643L129.686 20.6181H129.728L129.77 20.6599L129.812 20.7018V20.6599L129.854 20.7018L129.896 20.6599H130.023L130.107 20.6181L130.317 20.5762H130.57H130.696L130.781 20.6599V20.7018L130.865 20.7856L130.907 20.8275H131.117L131.285 20.9126L131.538 20.8707L131.579 20.7437L131.538 20.7018H131.579L131.623 20.7437V20.7018H131.706L131.748 20.7437L131.79 20.7018L131.832 20.5762L131.875 20.533V20.4492L131.959 20.4073V20.2816H132.085V20.2384L132.043 20.1546H132.17V20.1127H132.212L132.421 20.0289L132.506 19.9438L132.548 19.9857V19.9019L132.59 19.9438L132.632 19.9019L132.759 19.86L132.801 19.8181H132.843L132.927 19.7762V19.733L133.264 19.4817L133.306 19.3966L133.264 19.3547L133.39 19.229V19.1439L133.432 19.102L133.474 19.0601H133.559L133.601 19.0182L133.559 18.9763L133.601 18.8925H133.727V18.7655L133.854 18.6398H133.937V18.5547L133.895 18.4291L133.979 18.3872H134.021V18.344L134.063 18.2602H134.106L134.063 18.1345L133.937 18.0494L133.979 17.9656L133.895 17.8818L133.979 17.798L134.021 17.7548L134.063 17.798L134.148 17.5872L134.19 17.5021L134.274 17.3346L134.359 17.1657V17.1238L134.401 17.04L134.359 16.9549L134.401 16.8711L134.526 16.6603L134.568 16.5346L134.737 16.2819L134.821 16.1982L134.863 16.2401H134.905L134.99 16.1131V16.0712H134.948L134.905 16.0293V15.9455V15.9036H134.948L134.99 15.8185L135.074 15.6509V15.5658V15.5239L135.116 15.3982L135.158 15.3563L135.243 15.1874L135.326 15.0186L135.201 14.8929L135.243 14.8091L135.285 14.7659L135.243 14.724L135.201 14.7659L135.158 14.724L135.201 14.6402L135.243 14.6821L135.285 14.6402L135.243 14.5983L135.285 14.5145L135.326 14.4294L135.41 14.3875L135.495 14.4294L135.453 14.2186L135.537 14.1348V14.0511L135.621 14.0092L135.705 13.9673V13.9241L135.748 13.8822L135.79 13.9241L135.832 14.0092L135.916 13.9673L135.957 13.9241L136.126 13.6714L136.168 13.6295V13.5457L136.379 13.293L136.421 13.1673L136.674 12.662L136.757 12.5769L136.799 12.4093L136.842 12.3674L136.926 12.2823L136.884 12.2404L137.01 12.1985L137.221 11.7351L137.347 11.6094L137.39 11.5256L137.432 11.231L137.474 11.1878L137.515 11.1459L137.557 10.9351L137.642 10.8513L137.81 10.8932L137.852 10.7676L137.81 10.5987L137.852 10.5149L137.937 10.473L137.979 10.4311H138.063L138.146 10.3892L138.232 10.2622V10.2203L138.273 10.1784L138.315 10.1365L138.441 10.0933L138.484 10.0095V9.96762L138.61 9.88383L138.694 9.75684L138.737 9.63116V9.50416V9.42037L138.779 9.33658L138.904 9.20959L138.946 9.1677L139.157 9.1258L139.241 9.08391L139.326 8.99881L139.452 8.95691L139.579 8.87312V8.74613V8.66234L139.621 8.57855L139.746 8.24208L139.83 8.0732L139.873 7.90562V7.69483L139.915 7.65163L139.957 7.48405L139.999 6.9368L140.126 6.47334L140.168 6.43145L140.21 6.38955L140.377 6.34766L140.462 6.43145H140.546L140.757 6.64223L140.925 6.76791L141.43 7.27327L142.019 7.90562V7.94751L142.146 8.11509L142.188 8.24208L142.272 8.36777L142.399 8.74613V8.78933L142.441 8.83123V9.08391L142.483 9.20959V9.37848V9.50416L142.524 9.54606L142.819 9.71495H142.988L143.072 9.79874V9.84063H143.114V10.0933L143.072 10.2203V10.5149V10.5987V10.6838L143.03 10.7257L143.072 10.8513L143.03 10.9351V11.0202V11.1878L143.072 11.4837L143.157 12.4093L143.072 12.6201V12.5769L143.03 12.6201V12.662V13.0403L143.072 13.1673L143.451 14.2186L143.408 14.3456L143.366 14.4294V14.5564V14.6402L143.408 14.8091L143.535 14.9348V15.0186L143.493 15.1037V15.2293L143.535 15.3131L143.577 15.4401L143.661 15.5239V15.6928V15.7766L143.704 15.9455L143.746 16.0293L143.788 16.155L143.914 16.2819V16.4508V16.5765L143.957 16.7035L143.914 16.7873L144.041 16.7454L144.124 16.8292H144.166L144.208 16.913L144.166 16.9981V17.0819L144.251 17.1238L144.293 17.2076V17.5453L144.377 17.5872L144.503 17.7129V17.798L144.546 17.8399V18.0926V18.1345V18.1764L144.588 18.2602L144.63 18.5128L144.588 18.6817L144.503 18.7236L144.461 18.8074H144.503V18.7655H144.546H144.588L144.713 18.6817H144.799L144.882 18.7236L144.924 18.8074V18.8925L145.008 19.0182L145.051 19.0601V19.1871L145.008 19.3128L145.051 19.3966L145.093 19.4817L145.051 19.6073L145.135 19.6492L145.177 19.733V19.9438L145.219 20.0289L145.303 20.1546V20.2816V20.4073H145.346L145.388 20.4492L145.471 20.6181L145.513 20.7018L145.555 20.8275V20.9545L145.513 20.9964H145.43V21.0383L145.64 20.9545L146.061 20.7856L146.188 20.7437L146.524 20.6181H146.777H146.944L147.029 20.6599V20.7018H147.071L147.155 20.7856L147.197 20.9126L147.366 21.1234V21.1653L147.408 21.2072L147.45 21.291H147.492L147.577 21.3761L147.619 21.418L147.577 21.5018L147.619 21.5437V21.5856L147.702 21.7126V21.7963L147.829 21.8801V22.0909L147.871 22.1328L147.913 22.2179L148.081 22.6382L148.292 23.1854L148.713 23.1016L149.133 23.2692H149.218L149.428 23.3543L149.555 23.3962L149.766 23.5219L150.27 23.8165L150.313 23.8597V23.9434L150.27 23.9853V24.0272H150.355L150.397 24.2799L150.481 24.8691L150.522 25.2487V25.3744V25.4582L150.481 25.7528L150.522 25.8379L150.439 26.2162L150.313 26.427L150.355 26.5527L150.397 26.8473L150.439 26.9324V27.1L150.313 27.3107L150.27 27.4377L150.186 27.6053H150.144L150.102 27.6472H150.144L150.102 28.0688L150.144 28.1107V28.2796V28.3633L150.102 28.4471L149.975 28.5741H149.933L149.808 28.7849L149.766 28.9106L149.639 29.1633L149.513 29.2471V29.289H149.471L149.428 29.2471V29.289V29.3309V29.3741L149.386 29.4578H149.428V29.5416V29.5835L149.386 29.5416L149.344 29.5835V29.6686H149.26V29.7105H149.218L149.175 30.2159H148.797H148.544L148.333 30.2578L148.25 30.2997L147.829 30.3835L147.619 30.4686L147.324 30.678L147.282 30.7199H147.239L147.071 30.8888L146.986 31.0577L146.861 31.3104L146.819 31.6468L146.777 31.7725L146.65 31.9414L146.524 32.3198L146.44 32.4887L146.313 32.7413L146.188 32.994L146.061 33.1197L145.893 33.2467L145.766 33.3724L145.64 33.5413L145.177 33.8777L144.924 34.0034L144.713 34.0466L144.166 34.2142H144.082L143.999 34.2561L143.746 34.4669L143.704 34.5088L143.577 34.6777V34.7196H143.535L143.408 34.8885L143.366 34.9303L143.282 35.056L143.157 35.183L143.03 35.2668H142.988L142.862 35.3506L142.483 35.3938L142.23 35.4776L142.019 35.8141L141.935 35.983L141.768 36.1924L141.683 36.3194L141.557 36.4451L141.515 36.4883L141.43 36.614L141.388 36.6978V36.7397L141.346 37.0775L141.052 37.372L140.968 37.4558L140.883 37.7504L140.757 38.0031L140.546 38.2138L140.377 38.3395L140.294 38.4246L140.041 38.7192L139.873 38.8868L139.452 39.6029L139.41 39.6448L139.368 39.7286L139.326 39.7718V39.8137V39.9813L139.283 40.4028V40.6136H139.241L139.283 41.0758L139.326 41.2028V41.3285L139.283 41.4122L139.199 41.5392L138.737 42.0027L138.568 42.1284L138.063 42.1703L138.021 42.1284L137.852 41.9608L137.768 42.0027L137.684 42.1703V42.2122L137.642 42.1703H137.599V42.1284V41.9608V41.9176L137.515 41.8757H137.474L137.432 41.9176L137.474 42.1284L137.432 42.1703V42.2122L137.305 42.1703L137.137 42.2122L137.052 42.2554L136.968 42.2973V42.3392L137.01 42.3811L137.094 42.4649V42.5067L137.052 42.5918L136.926 42.6337L136.757 42.55H136.715L136.674 42.5067V42.423L136.715 42.2973L136.632 42.0865V42.0446H136.463L136.379 41.9608H136.295H135.999L135.916 41.9176H135.663L135.495 41.8338H135.326L135.201 41.5392L135.158 41.4973L134.99 41.4555L134.905 41.3704L134.779 41.4555L134.737 41.4122L134.695 41.3704L134.779 41.2866L134.821 41.1609L134.779 41.1177V40.9082L134.653 40.7812V40.6974V40.6555L134.695 40.6136L134.737 40.5704H134.821H134.863L134.905 40.4028L134.863 40.3177L134.779 40.1921L134.695 40.1502L134.61 40.0664L134.568 40.0232L134.485 40.1083H134.443L134.316 40.1502L134.19 40.1921H134.106H134.021L134.063 40.1083L134.232 39.8975L134.148 39.8556V39.7718V39.6867L134.274 39.4759V39.3921V39.3502V39.3083V39.2665V39.1395L134.232 39.0557L134.19 38.9719V38.9287V38.803V38.6773L134.148 38.4665L134.063 38.3814H133.854L133.685 38.4246L133.559 38.5084H133.474L133.39 38.4665L133.221 38.2138V38.172V38.0869L133.137 38.0031L133.054 37.8774L133.096 37.7504L133.012 37.6666L133.179 37.4139L133.137 37.372L133.054 37.2031V37.0775L133.137 36.9086V36.7397L133.096 36.6559L133.012 36.5721H132.927L132.801 36.4883L132.717 36.4032L132.674 36.2356L132.212 35.8979L132.17 35.8141L132.127 35.7303L132.085 35.6884L131.959 35.6452L131.79 35.6884L131.623 35.6452L131.579 35.6033L131.412 35.1411L131.37 34.9722L131.328 34.7615V34.552L131.285 34.5088L131.159 34.425L131.075 34.3412L131.117 34.0885L130.99 34.0466L130.948 33.9615V33.8358L130.907 33.794L130.865 33.7089L130.738 33.6251L130.654 33.4994L130.57 33.4575L130.528 33.2467L130.57 33.1197L130.612 33.0778L130.485 32.867L130.359 32.7832L130.317 32.6144L130.275 32.4887L130.148 32.4049L130.107 32.2779L130.19 32.1522V32.1103V32.0252L130.148 31.8576L130.234 31.6468L130.19 31.605L130.107 31.5631L130.19 31.4361L130.148 31.3942L130.234 31.3104L130.275 31.2685V31.1834L130.234 31.0996V31.0158L130.275 30.8888L130.443 30.678L130.485 30.4254L130.528 30.3835V30.3416L130.401 30.2578L130.317 30.2997L130.275 30.2578L130.234 30.1308L130.19 30.047L130.023 29.9213L129.981 29.7943L129.938 29.7524H129.896L129.854 29.7105L129.601 29.5416L129.476 29.4578L129.39 29.289L129.307 29.2052L128.97 29.0363L128.928 28.9944L128.634 28.7849L128.592 28.6579L128.634 28.616V28.4471L128.592 28.4052L128.549 28.3633L128.507 28.2364V28.1945L128.549 28.1526V28.1107L128.507 28.0269H128.465V27.9418L128.381 27.858L128.339 27.8161V27.6053V27.5215V27.4377L128.423 27.3526H128.465L128.549 27.3945H128.634L128.676 27.3526V27.3107L128.718 27.1851L128.676 27.1L128.592 27.0162L128.549 26.8905V26.7635H128.507L128.465 26.8054V26.8473L128.254 26.8054L127.918 26.9743H127.834L127.792 26.8905V26.8473L127.876 26.7635L127.918 26.6378L127.876 26.5527L127.75 26.5108H127.707V26.3432L127.792 26.3L127.876 26.2581L127.834 26.1324L127.792 26.0906H127.665V26.1324L127.623 26.1743L127.497 26.0487L127.245 26.0906L127.201 26.1743H127.118L127.076 26.0906L127.16 26.0487L127.201 26.0055L127.16 25.8798L127.201 25.796L127.16 25.7109L127.076 25.7528L127.034 25.9217H126.95V25.8798L126.907 25.8379L126.823 25.9217L126.781 25.8798L126.739 25.796L126.865 25.669V25.6271L126.739 25.5433L126.697 25.5852L126.739 25.669V25.7109L126.656 25.796V25.8379L126.487 25.796L126.445 25.7109L126.403 25.796H126.36L126.318 25.7528L126.276 25.669L126.192 25.6271H126.107L126.065 25.669L126.15 25.7528L126.192 25.796L126.15 25.8379H126.065L126.023 25.796L125.897 25.8379V25.796L125.939 25.7528V25.7109L125.856 25.7528L125.729 25.7109L125.687 25.7528V25.7109L125.729 25.5433V25.5014H125.645L125.603 25.4163H125.476V25.5014L125.392 25.5433H125.35V25.5014L125.392 25.4582V25.4163L125.434 25.3325H125.392L125.308 25.2906L125.265 25.3325V25.2487L125.181 25.2055L125.139 25.2906L125.056 25.2487L124.971 25.2906V25.2055V25.0798L124.929 24.9961L124.845 25.0379H124.803L124.845 25.0798L124.803 25.1217L124.718 25.0798L124.634 25.1636H124.592L124.55 25.1217L124.467 25.1636L124.508 25.2055H124.423V25.1636L124.467 25.0798L124.423 25.0379L124.467 24.9542L124.381 24.7853H124.256V24.7434L124.298 24.6583L124.34 24.5745V24.5326L124.298 24.5745L124.256 24.6164L124.214 24.5326H124.171V24.4907H124.214V24.4488L124.129 24.3637L124.171 24.3218H124.087V24.238L124.045 24.1961V24.238L124.003 24.1961H123.918H123.876V24.111H123.834L123.792 24.1961V24.3218L123.75 24.2799L123.708 24.1542L123.623 24.111L123.54 24.0691V23.9853H123.456L123.414 23.9434L123.329 23.9853V23.9434L123.287 23.9016L123.329 23.8597L123.287 23.8165H123.329L123.287 23.7746L123.245 23.8165L123.161 23.7746L123.203 23.7327L123.245 23.6908L123.161 23.7327V23.6908H123.119L123.076 23.6489H123.034L123.076 23.607H122.992H122.95V23.5651L122.909 23.607H122.825V23.5651H122.782V23.5219L122.614 23.4381L122.572 23.5651L122.487 23.48H122.403H122.361L122.278 23.5219L122.109 23.48H122.067V23.5219L121.983 23.48V23.5219L121.898 23.5651L121.856 23.5219H121.814L121.73 23.48L121.687 23.4381L121.645 23.3962L121.434 23.3543V23.3124L121.351 23.3543L121.225 23.3124L121.183 23.3543L121.098 23.3124L120.972 23.3962H120.93L120.803 23.4381L120.761 23.3962H120.678L120.636 23.3543V23.3962H120.509L120.34 23.3543V23.3124L120.298 23.2692V23.2273L120.34 23.1854L120.298 23.1016L120.425 23.0165H120.383V22.9746L120.34 22.9327L120.298 22.8908V22.722L120.256 22.6382V22.5963V22.5544L120.214 22.5125L120.172 22.3017H120.214L120.256 22.2179V22.1747H120.298V22.1328V22.0909L120.256 22.049H120.172L120.214 21.9652L120.13 21.922L120.089 21.8801L120.045 21.8382L120.003 21.7544L119.962 21.6707V21.5856L119.92 21.5437V21.4599H119.962L119.92 21.291L120.003 21.2491L119.962 21.1653L120.003 21.0802L119.962 21.0383H120.003V20.9545L120.089 20.9126L120.13 20.8707V20.8275L120.214 20.7856V20.7437L120.256 20.7018V20.6181H120.214L120.172 20.533L120.13 20.4911L120.003 20.3654L119.962 20.2384V20.1127L120.003 20.0708L119.962 20.0289L120.003 19.9438H120.045L120.003 19.8181L119.962 19.733L119.625 19.3547L119.583 19.3128L119.541 19.2709V19.1871L119.583 19.1439Z"
							fill="#3482cc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="TO" @mouseenter="e => hoverES(e, 'TO')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M145.177 107.837L145.261 107.669V107.5L145.346 107.333L145.388 107.206V107.122L145.429 107.037L145.471 106.995L145.555 106.911L145.64 106.869L145.682 106.616L145.724 106.448L145.682 106.322V106.238L145.64 106.069L145.682 105.944V105.858L145.766 105.817L145.808 105.691L145.935 105.606V105.564L145.977 105.48V105.311L145.935 105.227V105.059L145.893 104.933L145.935 104.849L145.85 104.638L145.935 104.511L146.06 104.386V104.3L146.019 104.217L145.935 104.175V104.006V103.964L145.977 103.88V103.838L146.019 103.796H146.102V103.755V103.669L146.229 103.459L146.187 103.333V103.249L146.144 103.164V103.038L146.019 102.955V102.87L146.144 102.744L146.229 102.617L146.271 102.533H146.355H146.397L146.44 102.491L146.482 102.364L146.566 102.238L146.524 102.111L146.566 101.986V101.86L146.692 101.817H146.735L146.777 101.775L146.735 101.649L146.819 101.228L146.986 101.144L147.029 101.06L147.155 100.975L147.197 100.933L147.155 100.808V100.766L147.282 100.471L147.324 100.26L147.408 100.049L147.366 99.7549H147.324V99.713L147.366 99.5022L147.45 99.3333L147.535 99.2496L147.577 99.1239L147.66 99.0388L147.829 98.955L147.913 98.8712L147.955 98.7442V98.5766L148.039 98.4496V98.3658L148.124 98.2388V98.0713L148.249 97.8186L148.376 97.6916V97.6497V97.6078L148.418 97.5659L148.46 97.4402L148.502 97.3132L148.544 97.1024L148.797 96.8079V96.7241L148.839 96.6822V96.5552L148.924 96.4295V96.2606L149.008 96.2187L149.049 96.1349L149.091 96.0498V95.9242L149.133 95.8404L149.218 95.7553L149.175 95.6296L149.091 95.5026V95.4607H149.133V95.3769V95.2931L149.218 94.9985L149.386 94.8297L149.428 94.6608V94.6189V94.4513V94.4081L149.471 94.2405V94.1986L149.555 94.1135L149.639 94.0297L149.766 93.9878L149.807 93.7352H149.975L150.144 93.5244L150.355 93.3568V93.3136V93.2298L150.397 93.1879L150.565 92.9352L150.649 92.7676L150.691 92.6407V92.5569L150.733 92.4299L151.07 92.1353L151.113 92.0096L151.197 91.8407L151.28 91.7569L151.364 91.6299L151.449 91.588L151.744 91.3354L151.996 91.2516H152.164L152.291 91.2097L152.333 91.1246L152.459 90.957L152.627 90.7043L152.922 90.2828L153.006 90.1571L153.049 89.9882L153.133 89.9044L153.175 89.7787L153.427 89.5679L153.511 89.4409V89.3572L153.553 88.9788L153.596 88.8937L153.638 88.768L153.806 88.5153H153.849L154.017 88.4315L154.144 88.3464L154.227 88.2627L154.311 88.0519L154.353 87.9262L154.396 87.5897L154.522 87.337L154.606 87.1682L154.648 87.0844L154.691 86.9574L154.733 86.7479L154.691 86.6209L154.733 86.5371V86.4101L154.775 86.3682V86.3263L154.858 86.2844L154.9 86.2006V85.9899V85.9061L154.858 85.6953L154.943 85.5683V85.4007L154.985 85.2318L154.943 84.9373V84.8954V84.7684L154.985 84.7265L155.027 84.6427V84.6008L154.985 84.5157L154.9 84.4738L154.733 84.4319L154.606 84.3481L154.48 84.1792L154.353 84.0954L154.144 83.9265L153.975 83.8428L153.891 83.759L153.849 83.6739L153.722 83.3793V83.3374L153.596 83.0847V82.959L153.638 82.6226L153.722 82.5794L153.806 82.4118L153.975 82.201L154.227 81.9483L154.311 81.8645V81.8226L154.396 81.6957L154.522 81.5281L154.648 81.3592L154.691 81.1903L154.816 80.9808L154.858 80.8538L154.816 80.6862L154.775 80.3066V79.9282V79.8863V79.7174V79.6336L154.691 79.3391L154.648 79.2959V79.2121V79.0864L154.691 79.0013L154.816 78.8756L154.858 78.7918H154.9L155.027 78.7486L155.28 78.6229L155.448 78.454L155.7 78.2865L155.785 78.2014L155.869 78.0757H156.164L156.333 77.9919L156.416 77.9487L156.5 77.9068L156.753 77.8649H156.922H156.964H157.047H157.131L157.342 77.7811H157.384L157.469 77.6973L157.595 77.4865L157.931 77.4027L158.058 77.3176L158.1 77.2339L158.142 77.1501V76.9812L158.058 76.7285V76.6447L158.1 76.5177L158.184 76.4339V76.3082L158.269 76.1813L158.311 76.1394L158.395 75.9705L158.689 75.7178L158.773 75.6759L158.9 75.5502L158.942 75.4651L159.026 75.3394L159.067 75.2975H159.405L159.531 75.3394L159.7 75.4651L159.784 75.5083L159.826 75.4651L159.867 75.2975L159.826 75.1705L159.784 75.1286L159.7 75.0868L159.616 75.0449L159.573 74.9611V74.9192L159.616 74.876L159.573 74.7922L159.531 74.5814L159.489 74.4557V74.3287V74.203L159.573 74.1192L159.658 74.0341L159.742 73.9923L159.911 74.0341L160.12 73.9504L160.289 73.8247L160.373 73.7396L160.415 73.6139V73.5288L160.289 73.3612L160.12 73.3193L160.078 73.2774V73.1923L160.12 73.1085L160.205 72.9815L160.289 72.8978L160.373 72.8559L160.625 72.814L160.752 72.7302V72.6032V72.5613L160.667 72.4343V72.3924L160.5 72.2248L160.415 72.0978L160.373 72.0559V72.014L160.331 71.7195V71.6776V71.5087L160.373 71.4249L160.415 71.3398L160.5 71.2979L160.794 71.3398L160.92 71.2979H160.962L161.005 71.256L161.089 71.2141L161.173 71.0884L161.3 70.8357L161.342 70.7506V70.625V70.5412L161.089 70.3723L161.005 70.3304L160.962 70.2885L160.878 70.2034H160.752L160.542 70.1615L160.458 70.1196L160.373 70.0777L160.331 70.0358L160.205 69.8669L160.162 69.825V69.8669V69.7831L160.078 69.6561L160.036 69.5724V69.4886V69.4467L159.953 69.3616L159.911 69.3197L159.867 69.2359L159.784 69.194H159.742L159.7 69.2778L159.573 69.2359L159.447 69.2778H159.405L159.363 69.3197H159.278L159.236 69.3616L159.111 69.4035H159.026L158.731 69.3616H158.522H158.436L158.269 69.3197L158.184 69.1508H158.142L157.974 69.1089H157.722V69.067H157.637L157.553 69.0251L157.511 68.9832V68.9413V68.8994L157.595 68.9413L157.637 68.8994L157.764 68.9413L157.805 68.8994L157.847 68.7305L157.889 68.6886L157.974 68.6467L158.142 68.6886L158.226 68.7305L158.269 68.8143L158.395 68.8562L158.436 68.8143L158.563 68.6886L158.647 68.4779V68.3522L158.689 68.2252V68.1414L158.816 67.9725L158.942 67.8887L159.153 67.9306L159.278 67.8468L159.911 67.7617L159.994 67.8049L160.205 67.9725H160.373L160.5 68.0563L160.667 68.1414L160.752 68.1833H160.794L160.878 68.2671L161.005 68.309L161.089 68.3522L161.509 68.3941L161.678 68.436L161.889 68.3941L162.1 68.1833H162.142H162.225L162.436 68.2252H162.562H162.604L162.9 68.3522L162.941 68.436L162.983 68.5616V68.6049V68.6467V68.8562L163.151 69.067L163.236 69.1508H163.445L163.614 69.1089H163.783L164.12 69.3197L164.245 69.3616L164.54 69.6143L164.793 69.6994L164.878 69.6561H164.92L165.298 70.0358L165.383 70.2885V70.498L165.425 70.6669V70.7506V70.9195L165.34 71.2141L165.298 71.3398L165.383 71.5087L165.467 71.5925L165.634 71.9721L165.678 72.1829L165.72 72.2248V72.6451L165.593 73.0247L165.678 73.1504L165.72 73.3193V73.3612V73.4869L165.678 73.6558L165.72 73.8247L165.803 74.203L165.887 74.4138L165.972 74.5395L166.014 74.6665V74.7922V74.876L165.845 75.2137V75.2556L165.803 75.4651L165.761 75.634L165.72 75.8029L165.678 75.8448L165.803 76.1813L165.761 76.265H165.72L165.551 76.5177V76.6028L165.509 76.6447V76.8123V76.9393V76.9812L165.425 77.1069L165.298 77.3595L165.34 77.4865L165.298 77.5284V77.6122V77.9068L165.172 78.1176L165.087 78.3703V78.4121H165.13V78.454L165.214 78.6648L165.256 78.7918L165.214 78.8756L165.087 79.1283V79.2959L165.045 79.381L165.003 79.5066V79.5485L164.962 79.6336L164.793 79.8012L164.709 79.8431L164.54 80.0539L164.498 80.2228L164.372 80.3904L164.289 80.4336L164.204 80.3904L164.078 80.3485H163.993L163.951 80.3904L163.741 80.5174V80.5593V80.6862V80.77L163.825 80.8538L164.078 80.9808L164.204 81.1065L164.331 81.4011H164.372H164.414H164.498L164.625 81.1903L164.709 81.1484H165.003L165.045 81.1903L165.298 81.3592L165.383 81.5281L165.425 81.6119L165.383 81.8226L165.214 81.9064V81.9483L164.878 82.0753L164.793 82.1172L164.709 82.2848L164.878 82.3267L164.962 82.2848L165.087 82.2429H165.172H165.256V82.3267L165.298 82.5375L165.383 82.6226V82.832L165.425 82.8739H165.467L165.509 82.7902H165.678L165.72 82.832L165.761 82.8739V82.9171L165.72 82.959L165.678 83.0009V83.0428H165.72H165.761L165.845 83.0847H165.887L165.93 83.1266L165.887 83.2117L166.014 83.2955V83.4212L165.972 83.5063V83.5482L166.014 83.632L166.098 83.6739L166.182 83.5901V83.5482H166.098L166.056 83.4644V83.4212H166.14H166.182L166.225 83.5063L166.309 83.5482L166.393 83.632L166.434 83.6739L166.393 83.7171H166.351H166.267L166.309 83.759V83.8009V83.8428L166.52 83.8847V83.9684H166.478L166.434 83.9265V83.9684L166.478 84.0116L166.434 84.0535V84.1373H166.478L166.52 84.1792L166.561 84.1373L166.645 84.1792L166.687 84.1373V84.1792V84.2211H166.772V84.2643L166.729 84.3481L166.772 84.3062H166.814H166.856L166.814 84.3481L166.856 84.4738L166.898 84.5589L166.856 84.6008H166.94L166.856 84.6427V84.6846H166.898H166.94V84.7265L166.982 84.7684L167.025 84.8116H167.109V84.8535H167.151V84.8954L167.234 84.8535V84.9373H167.276V84.9792V85.021L167.361 85.1061L167.403 85.148V85.1899H167.487V85.3156V85.4007L167.571 85.3588H167.614L167.656 85.4845L167.698 85.4426L167.656 85.5683L167.698 85.6102L167.74 85.5683V85.6102V85.6534H167.698L167.782 85.7372L167.698 85.7791H167.867L167.992 85.9061V86.0318L168.076 86.0737L168.034 86.1155L168.119 86.1574V86.2006H168.245V86.2425H168.287H168.329H168.371V86.2844H168.414L168.456 86.1574L168.498 86.2006V86.1574L168.623 86.1155L168.582 86.0737L168.665 86.0318V85.948V85.9061H168.709L168.75 85.821H168.834H168.876V85.7791V85.7372H168.918L168.961 85.7791H169.003L169.045 85.6953H169.087V85.6102L169.171 85.5683V85.6102L169.213 85.6534L169.256 85.6102L169.298 85.5683L169.34 85.6534H169.381V85.6102H169.423L169.55 85.5683L169.592 85.5264L169.634 85.5683H169.676V85.5264L169.718 85.5683V85.5264L169.76 85.4845L169.803 85.4426V85.4845H169.845L169.887 85.3588L169.929 85.4007L169.971 85.3588H170.012H170.056L170.098 85.3156H170.139L170.181 85.2737L170.265 85.3156H170.307H170.392L170.434 85.2318H170.476L170.56 85.2737H170.603L170.687 85.1899H170.812L170.898 85.2318V85.2737H170.981L171.023 85.3156L171.107 85.3588V85.4007V85.4845L171.192 85.5264L171.36 85.6102L171.529 85.7372L171.57 85.821V85.8629L171.612 85.9061V85.948V86.1155V86.2006L171.697 86.2844V86.3682L171.654 86.4101H171.57L171.529 86.4952V86.579L171.402 86.9155V86.9574V87.0006L171.487 87.0425L171.57 87.1263L171.529 87.1682L171.445 87.2519L171.402 87.3789L171.445 87.5897L171.36 87.7154L171.276 87.7992L171.192 87.8843L171.107 87.9262H170.981L170.898 87.9681H170.812L170.645 87.8843L170.476 87.9681L170.392 88.01L170.307 88.0519L170.181 88.0951L170.139 88.1789L170.098 88.2208L170.056 88.3045L170.012 88.2627H169.971H169.929H169.845L169.718 88.2208V88.2627V88.3045H169.676L169.718 88.3896L169.634 88.4315L169.592 88.3896L169.634 88.5153V88.5572V88.5991L169.592 88.6842L169.634 88.7261L169.508 88.8518L169.465 88.8937L169.423 88.8099L169.381 88.8518V88.8937H169.298V88.9788L169.34 89.0626H169.298L169.34 89.1045L169.298 89.1464L169.34 89.1883L169.298 89.2315L169.34 89.2734H169.298V89.3153L169.256 89.3572V89.399L169.213 89.4409L169.171 89.399V89.4409H169.129L169.171 89.4841H169.129V89.526L169.087 89.4841V89.526H169.045V89.4841V89.5679L169.003 89.526V89.5679V89.6098V89.6517H168.961L168.918 89.6098V89.6517H168.876H168.918V89.6936L168.961 89.6517L169.003 89.6936V89.7355H168.961L169.003 89.7787H168.961V89.8206H168.918V89.8625L168.876 89.9044L168.918 89.9463L168.876 89.9882L168.961 90.0301H169.003L168.961 90.0733H169.045L169.003 90.1152L169.045 90.1571L169.087 90.2409L169.045 90.2828H169.003L168.918 90.3679V90.4935H168.876H168.834H168.792L168.834 90.6205L168.876 90.6624V90.7462H168.918V90.7881H168.961L169.003 90.9151L168.961 90.957V91.0827L168.918 91.1246L168.961 91.1678L168.918 91.2097H168.876V91.2516L168.918 91.2935L168.876 91.3354H168.75L168.665 91.4205L168.623 91.4624L168.582 91.4205H168.54H168.498L168.414 91.4624L168.456 91.5462V91.588L168.498 91.6299H168.54L168.582 91.715L168.498 91.7569V91.7988L168.414 91.8407V91.8826L168.329 91.9245H168.287L168.245 91.9677L168.287 92.0515V92.0934L168.245 92.1353V92.1772H168.161V92.1353V92.1772L168.119 92.2623V92.3042H167.992L167.95 92.3461L168.034 92.388L168.076 92.3461V92.388H168.119V92.4299L168.034 92.4718V92.515V92.5569H167.992L168.034 92.5988H167.95V92.6407L168.076 92.7244V92.6825H168.161L168.245 92.7244L168.329 92.6825L168.287 92.7676H168.329H168.371V92.7244H168.456L168.54 92.7676L168.75 92.6825H168.876L168.918 92.7676L168.876 92.8095H168.834H168.792L168.834 92.8514H168.792L168.834 92.8933L168.792 92.9352L168.834 93.019H168.792L168.834 93.1041H168.876H168.961L169.003 93.0622L169.045 93.019V93.0622V93.146H169.087L169.256 93.1879L169.298 93.2298L169.34 93.3136L169.298 93.4406V93.4825L169.381 93.5244L169.465 93.4825V93.5244L169.508 93.6095L169.465 93.6933L169.423 93.777L169.508 93.904L169.465 93.9459L169.423 93.9878V94.0297L169.34 94.0716V94.1135V94.1567L169.381 94.2405L169.508 94.1986H169.55V94.2824L169.634 94.4081L169.718 94.4932L169.76 94.5351L169.803 94.577L169.887 94.704L169.845 94.8297V94.8715L169.971 94.9134V94.8715L170.012 94.8297L170.098 94.7878H170.265L170.392 94.7459H170.434L170.518 94.8297L170.645 94.8715L170.603 94.9134L170.56 94.9985V95.0823L170.603 95.1242L170.687 95.208H170.771L170.854 95.2512L170.898 95.335L171.023 95.2931L171.107 95.335V95.4188L171.023 95.5026V95.5458L171.107 95.6715V95.7134L171.234 95.7553V95.7985L170.981 95.966L170.898 96.0079V96.1349L170.812 96.2606V96.4295L170.771 96.5133L170.518 96.6822L170.56 96.8498V96.9349L170.603 96.9768V97.0187H170.687H170.898L171.023 97.1024L171.065 97.1875L171.023 97.2294L170.981 97.3551V97.397L171.107 97.4402H171.234L171.402 97.3551L171.445 97.4402L171.529 97.524L171.487 97.6497H171.529L171.612 97.7348L171.529 97.7767V97.8186L171.654 97.8605V97.9875L171.612 98.0294V98.155L171.697 98.2388L171.612 98.3239L171.654 98.4915L171.612 98.5766L171.739 98.7442V98.955L171.781 98.9969L171.823 99.1239L171.949 99.1658H171.992L172.201 99.4184L172.287 99.713L172.412 99.7549L172.539 99.8387L172.623 99.7549L172.707 99.7968H172.876L173.087 99.7549L173.254 99.713L173.338 99.7549L173.381 99.7968L173.423 99.8387L173.549 100.008L173.718 99.9657L173.97 100.008L174.265 99.7968L174.349 99.7549H174.39L174.432 99.7968L174.476 100.175L174.559 100.302L174.601 100.26L174.728 100.218L174.896 100.302L175.023 100.26L175.317 100.175L175.57 100.302L175.865 100.344L176.159 100.175L176.243 100.091L176.285 99.9657L176.243 99.8387L176.201 99.7549L176.285 99.6279L176.327 99.713H176.454V99.7968L176.412 99.8387L176.454 100.008V100.175V100.302V100.344L176.412 100.386L176.37 100.471L176.285 100.681L176.201 100.849L176.117 100.891H175.865L175.78 100.933L175.696 100.975H175.654V101.018V101.06L175.612 101.144L175.696 101.27L175.654 101.439H175.612H175.401L175.276 101.522L175.19 101.607L175.149 101.691L174.896 101.86L174.812 101.902L174.77 102.028H174.685L174.601 102.07H174.476L174.432 102.111L174.39 102.28L174.223 102.322V102.449L174.181 102.491L174.096 102.533L173.97 102.491L173.843 102.617H173.718L173.591 102.66L173.549 102.617L173.423 102.66V102.702L173.338 102.744L173.254 102.786V102.828L173.296 102.87L173.381 102.997L173.423 103.038V103.08L173.381 103.249L173.254 103.333L173.001 103.502H173.043L173.17 103.544V103.711L173.128 103.796L173.043 103.838L172.876 103.922L172.834 103.964L172.792 104.049L172.749 104.175V104.217L172.834 104.386V104.427L172.623 104.553L172.539 104.68L172.328 104.806L172.287 104.849L172.243 104.933L172.118 105.017H172.076V105.144L171.949 105.269L171.823 105.606L171.781 106.027L171.654 106.238L171.57 106.364H171.487L170.981 106.616L170.812 106.658L170.854 106.742L170.812 106.869H170.771V106.953L170.812 106.995V107.08L170.854 107.248L170.939 107.375L171.065 107.416H171.107L171.192 107.458V107.627V107.669L171.318 107.753V107.795V108.006L171.36 108.131L171.402 108.174L171.445 108.216L171.57 108.258L171.612 108.342H171.654H171.739H171.823L171.949 108.384L171.992 108.469L172.034 108.511H172.076L172.16 108.469H172.201H172.328L172.412 108.511L172.623 108.469L172.792 108.553L172.918 108.595H172.96L173.043 108.637H173.128L173.212 108.722V108.764L173.254 108.847L173.338 108.889L173.423 108.931L173.465 108.889L173.549 108.847L173.591 108.931H173.718L173.801 108.889L173.843 108.931L173.97 108.974H174.012L174.054 109.016V109.1V109.142L173.759 109.184L173.634 109.226L173.507 109.184L173.423 109.226L173.212 109.142L173.001 109.016H172.96H172.918H172.876L172.792 109.058L172.707 109.016L172.623 109.058V109.142L172.665 109.226L172.707 109.269L172.749 109.395V109.478L172.665 109.522L172.539 109.731L172.328 109.816L172.243 109.858L172.287 109.9L172.412 109.858L172.496 109.942L172.581 109.984V110.026L172.496 110.069V110.111L172.539 110.153L172.496 110.236L172.412 110.278V110.32V110.363L172.37 110.405L172.287 110.363L172.243 110.405L172.287 110.489L172.243 110.573L172.328 110.7L172.412 110.658L172.454 110.7L172.539 110.784H172.623L172.792 110.7L172.918 110.742L173.001 110.784L173.087 110.826L173.254 110.784L173.338 110.7H173.423H173.465L173.507 110.784V110.867L173.381 110.994H173.254L173.043 111.078L172.792 111.12H172.707L172.539 111.162L172.496 111.247L172.454 111.289L172.37 111.331L172.243 111.458V111.542H172.201L172.118 111.584V111.667L172.201 111.753V111.794L172.243 111.836L172.16 111.878L172.201 111.962V112.005L172.287 112.047L172.328 112.131L172.287 112.215V112.3L172.243 112.425V112.467L172.16 112.509L172.201 112.552V112.594V112.636L172.16 112.678L172.287 112.72V112.804L172.328 112.847L172.287 112.973L172.201 113.015H172.243L172.328 113.142L172.287 113.183L172.243 113.267L172.37 113.309H172.412L172.539 113.351H172.581V113.394L172.412 113.436V113.478V113.52L172.37 113.562L172.412 113.604L172.454 113.562L172.496 113.647L172.581 113.689H172.623L172.749 113.773L172.792 113.856L172.749 113.898V113.983L172.707 114.025V114.067L172.749 114.109L172.792 114.067H172.834H172.876H172.918L173.001 114.151L173.043 114.236V114.278L173.001 114.362V114.573L173.17 114.614L173.465 114.489L173.591 114.446L173.634 114.531L173.591 114.614L173.634 114.698L173.591 114.825H173.338L173.17 114.867L173.043 114.909H173.001L172.96 114.951L172.918 115.078L172.876 115.12L172.834 115.162L172.876 115.245L172.792 115.456L172.876 115.498V115.54H172.918H172.96L173.001 115.625L172.918 115.709L172.834 115.751L172.749 115.878H172.792V115.92L172.876 115.962L172.918 116.004V116.172L172.834 116.214L172.876 116.298V116.382L172.834 116.425V116.509V116.593L172.876 116.635L172.918 116.678L172.96 116.762L172.876 116.845L172.749 116.93L172.834 117.056L172.792 117.14L172.749 117.225V117.309L172.707 117.52L172.834 117.476L172.876 117.393H172.918L173.212 117.434L173.338 117.351H173.423L173.718 117.225L173.801 117.267L173.886 117.309L173.843 117.351L173.676 117.434L173.591 117.393L173.465 117.434V117.476L173.423 117.52L173.381 117.561H173.212L173.087 117.603V117.561L172.876 117.645L172.834 117.603L172.792 117.645L172.665 117.687H172.496V117.729L172.328 117.772L172.243 117.729L172.287 117.645L172.243 117.603L172.287 117.561V117.476V117.434L172.328 117.393V117.267V117.225L172.287 117.182L172.328 117.14L172.287 117.098L172.328 117.056H172.287L172.328 116.972L172.243 116.93V116.845V116.887L172.201 116.845L172.118 116.887L172.076 116.845H172.034V116.803V116.72L171.992 116.678L171.907 117.393H171.865L171.823 117.434L171.781 117.476V117.645H171.612H170.645L169.929 117.603L169.508 117.856H169.465L169.508 117.898L169.423 117.94V118.024H169.381L169.34 118.109V118.151H169.298V118.193V118.234L169.171 118.276V118.234V118.193L169.129 118.234V118.193V118.151H169.045L169.003 118.234L168.918 118.276L168.834 118.361V118.403L168.709 118.445L168.665 118.529H168.582L168.498 118.614V118.656H168.456V118.614H168.414H168.371H168.329V118.656V118.74H168.245L168.161 118.782H168.119L168.076 118.824L167.992 118.867L167.95 118.824V118.867H167.867V118.909V118.951L167.823 118.992V118.951L167.782 118.909L167.74 118.951V118.992H167.698V118.909L167.656 118.951H167.571L167.487 119.034H167.529V119.118L167.445 119.161L167.361 119.118L167.319 119.161L167.234 119.118L167.276 119.076L167.234 119.034L167.151 119.076L167.067 119.034L167.025 119.076H166.982H166.94V119.118L166.814 119.161L166.856 119.287L166.814 119.329H166.729V119.414H166.687L166.645 119.498H166.561L166.603 119.456H166.561V119.414H166.434L166.393 119.456L166.267 119.414H166.182L166.098 119.329L166.056 119.287L166.014 119.371H165.972L165.93 119.414V119.498L165.803 119.54L165.761 119.665H165.72L165.678 119.623V119.54L165.551 119.414L165.593 119.371L165.72 119.329L165.678 119.287L165.593 119.245L165.509 119.287L165.34 119.245V119.161L165.425 118.992H165.34L165.256 119.034H165.214L165.13 118.992H165.087L165.003 119.034L164.878 118.992L164.836 118.782L164.878 118.614L164.836 118.571H164.709L164.54 118.487L164.498 118.529L164.456 118.487L164.414 118.571L164.372 118.614V118.656H164.331L164.372 118.698V118.74V118.782H164.331V118.824L164.289 118.867L164.204 118.909L164.331 118.951L164.289 119.034L164.245 119.076H164.289L164.245 119.118L164.289 119.161H164.245V119.203L164.331 119.245V119.287L164.289 119.329L164.372 119.371V119.414L164.414 119.498L164.331 119.582H164.289V119.709V119.75L164.331 119.834L164.289 119.876L164.331 120.003V120.087L164.414 120.171H164.498V120.298L164.456 120.34H164.414L164.372 120.423L164.331 120.465L164.289 120.55L164.245 120.592L164.204 120.676L164.162 120.803L163.404 119.961V119.918L163.278 119.834L163.151 119.876L163.025 119.834L162.983 119.876H162.9L162.856 119.834V119.792L162.814 119.834H162.773V119.75L162.731 119.709H162.689V119.75V119.709H162.647H162.604L162.562 119.665L162.52 119.792H162.478H162.436L162.394 119.834L162.351 119.792V119.75L162.309 119.709L162.267 119.582H162.183L162.056 119.623L162.015 119.54L161.973 119.582V119.54L162.015 119.498L161.973 119.456H161.847V119.414V119.371V119.329L161.805 119.371V119.329L161.72 119.371V119.329L161.678 119.371L161.72 119.54H161.678V119.582V119.623V119.665H161.594L161.552 119.709L161.509 119.665L161.467 119.709L161.425 119.665V119.709L161.3 119.75L161.256 119.792L161.215 119.75V119.792L161.173 119.75L161.131 119.792V119.75L161.215 119.623V119.414H161.173L161.131 119.371V119.329L161.173 119.287L161.215 119.245L161.173 119.161V119.118V119.076V119.034V118.992L161.215 118.951V118.867L161.256 118.824V118.782L161.215 118.824H161.173L161.089 118.782L161.047 118.824H161.005L160.962 118.867V118.909L160.878 118.951L160.836 118.909L160.794 118.951L160.752 118.909L160.711 118.992H160.667V119.034L160.625 119.076H160.542V119.118H160.5L160.458 119.161V119.076V119.118H160.415H160.373V119.203V119.245L160.247 119.287H160.289H160.247H160.289V119.329H160.247H160.205V119.287H160.162H160.12H160.036L160.078 119.329L160.036 119.371L160.078 119.414H160.036L159.994 119.371H159.953L159.911 119.414H159.867V119.456H159.826L159.784 119.54V119.498L159.742 119.54H159.7H159.658L159.573 119.582L159.531 119.54L159.489 119.582V119.623V119.665L159.447 119.709L159.405 119.623H159.32V119.498H159.363L159.32 119.456V119.414H159.363L159.278 119.371V119.329H159.236V119.245V119.203V119.161V119.118L159.194 119.076L159.236 119.034V118.951V118.909V118.867H159.278L159.236 118.74V118.698L159.194 118.656V118.74H159.153L159.111 118.698L159.026 118.656L158.942 118.74V118.909L158.9 118.992V119.034L158.816 119.076L158.731 119.118V119.245L158.773 119.287L158.731 119.329V119.456L158.689 119.582L158.731 119.623V119.75L158.647 119.834H158.605H158.563L158.436 119.709L158.478 119.623L158.522 119.498V119.456L158.478 119.414L158.436 119.329H158.478L158.563 119.245V119.161V119.034H158.605L158.563 118.992L158.605 118.951L158.522 118.909V118.824L158.478 118.782H158.522V118.74H158.563V118.656L158.605 118.614L158.563 118.487H158.478L158.522 118.445L158.478 118.361V118.32H158.436V118.234V118.193H158.395L158.353 118.151H158.269L158.226 118.024V117.94V117.898H158.142H158.1V117.856L158.058 117.814L158.016 117.856L157.974 117.772H157.931V117.856H157.889V117.814H157.805V117.856L157.764 117.814L157.722 117.856L157.678 117.772H157.637V117.645V117.561L157.595 117.476L157.637 117.393L157.595 117.309H157.553L157.511 117.225H157.469L157.427 117.182L157.3 117.056V117.098H157.258V117.014H157.216L157.174 116.972H157.131V116.93L157.089 116.887V116.845H157.047L157.005 116.803V116.845H156.964L156.922 116.803L156.964 116.72L156.922 116.678V116.593H156.88H156.837L156.795 116.551L156.753 116.593L156.795 116.635H156.753L156.711 116.678L156.122 117.561L156.08 117.476L155.953 117.393L155.911 117.309L155.869 117.267L155.827 117.225H155.785L155.7 117.267H155.658V117.225H155.489L155.448 117.14V117.098H155.489L155.448 117.056L155.533 116.972V116.93V116.887L155.575 116.845H155.448L155.364 116.762H155.322L155.238 116.467L155.111 116.551L155.069 116.678H155.027L154.943 116.762L154.816 116.845L154.775 116.887V116.972L154.691 117.014L154.648 117.056L154.606 117.014L154.564 117.056L154.522 117.098V117.14L154.438 117.182V117.309L154.396 117.393V117.434H154.353L154.311 117.476L154.227 117.645V117.687H154.269V117.772H154.227L154.1 117.982L153.975 118.151L153.891 118.234L153.764 118.487V118.529L153.849 118.571V118.656L153.806 118.74L153.764 118.824L153.849 118.951L153.806 119.034L153.849 119.118L153.806 119.203L153.849 119.329V119.371V119.456L153.68 119.582L153.091 119.245L152.207 118.74L150.355 117.645L150.313 117.603H150.27L150.144 117.561H150.06L149.891 117.434L149.849 117.476L149.766 117.393L149.68 117.351L149.555 117.393H149.513L149.471 117.309H149.344L149.302 117.225H149.133L149.091 117.267L149.008 117.225L148.839 117.182L148.797 117.14L148.713 117.182L148.671 117.14H148.629V117.182L148.544 117.14V117.098H148.502L148.46 117.014V117.056L148.376 117.014V116.93H148.333V116.887L148.291 116.93V116.887H148.208V116.845H148.124H148.166L148.081 116.803V116.845L148.039 116.803H147.997V116.762L147.955 116.803V116.72H147.913V116.678H147.871V116.593L147.829 116.551L147.871 116.467L147.913 116.425L147.871 116.34L147.955 116.256L147.913 116.214L147.955 116.172H147.913L147.997 116.131V116.004L147.913 115.962L147.955 115.92V115.878L147.913 115.793L147.955 115.751V115.793V115.836V115.793H147.997L148.039 115.836V115.751L148.081 115.793H148.124L148.081 115.751L148.124 115.667V115.625L148.166 115.54V115.498L148.208 115.414L148.249 115.456L148.291 115.414L148.249 115.245L148.291 115.12H148.333V115.162H148.376L148.502 115.078V115.036H148.586L148.544 114.993L148.502 114.951V114.993L148.46 115.036V114.951L148.376 114.909L148.333 114.825L148.418 114.741V114.531H148.46L148.502 114.489V114.404L148.544 114.362L148.629 114.32L148.671 114.278V114.236H148.755V114.193H148.797V114.067L148.881 113.942L148.713 114.025V114.109L148.671 114.151H148.629L148.586 114.109V114.067H148.544V114.109L148.629 114.151V114.193H148.544L148.46 114.236H148.418L148.502 114.278H148.376L148.333 114.362H148.208L148.166 114.489H148.124H147.997V114.531L147.829 114.614L147.786 114.656V114.698L147.829 114.741V114.783L147.744 114.741H147.702L147.744 114.825L147.702 114.867L147.618 114.825V114.867V114.909H147.535H147.491L147.535 114.951L147.491 114.993V115.078V115.12H147.408L147.366 115.204L147.324 115.287H147.366L147.324 115.331L147.239 115.372L147.197 115.414L147.239 115.54L147.197 115.583L147.113 115.54L147.029 115.625H147.071V115.583H147.113V115.625L147.071 115.667L147.113 115.709L147.071 115.751L147.113 115.836L147.071 115.878H147.029H146.902V115.92L146.819 115.962V116.004L146.86 116.045L146.902 116.087L146.86 116.131L146.777 116.172V116.214V116.256H146.86L146.819 116.298V116.382H146.777L146.735 116.467L146.777 116.635H146.735L146.692 116.678L146.735 116.72L146.692 116.803L146.608 116.93V116.845L146.566 116.762L146.482 116.803H146.271L146.06 116.72V116.678L146.187 116.593V116.551H146.144H146.019L145.977 116.678H145.935L145.893 116.635V116.551L145.977 116.382H145.85L145.893 116.298V116.131L145.808 116.045L145.85 115.92H145.766L145.724 115.751L145.766 115.667V115.583L145.724 115.54L145.429 115.583V115.414L145.388 115.331L145.429 115.245L145.471 115.204L145.597 115.245H145.64V115.162L145.513 115.078L145.555 114.951L145.64 114.867L145.682 114.656L145.766 114.531L145.724 114.362L145.808 114.32L145.893 114.362V114.32L145.935 114.151L145.85 114.109L145.893 113.898L145.85 113.773L145.766 113.647L145.808 113.52L145.766 113.478V113.351V113.309L145.85 113.225V113.142L145.766 113.015V112.847L145.724 112.804L145.555 112.847L145.513 112.72L145.555 112.636V112.425L145.597 112.342V112.215L145.64 111.962V111.836L145.513 111.709V111.667L145.555 111.542V111.5L145.513 111.458L145.555 111.373L145.724 111.205V111.078L145.64 110.953L145.682 110.867L145.808 110.826V110.7L145.682 110.573H145.555L145.513 110.531V110.32L145.471 110.236L145.429 110.153L145.388 109.942L145.346 109.858L145.302 109.773V109.731L145.471 109.564L145.513 109.522L145.597 109.478L145.64 109.395L145.682 109.353V109.184L145.64 109.058L145.682 108.974V108.931V108.847V108.805L145.64 108.764H145.597H145.513L145.346 108.722H145.302L145.177 108.469L145.219 108.3L145.177 108.216V108.047V107.964V107.837Z"
							fill="#6ba4da" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="MT" @mouseenter="e => hoverES(e, 'MT')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M77.6556 94.0294V93.9456V93.9037H77.8664L77.9083 93.8186L77.9921 93.7767H78.1191L78.2448 93.8186L78.2867 93.8618L78.3299 93.8186L78.2867 93.7348L78.3299 93.524V93.4821V93.3983L78.2867 93.3565L78.2448 93.2295L78.2029 93.1876L78.1191 93.0619V92.9768V92.893V92.8092L78.161 92.6822H78.2029V92.5984L78.2867 92.5146V92.3876L78.3299 92.262L78.4975 91.9242L78.5394 91.8823L78.6664 91.7147L78.5813 91.6296L78.5394 91.5039L78.4137 91.3769L78.3718 91.2093L78.3299 91.1675V91.1242V91.0824H78.2448H78.2029L78.034 90.9986H77.9921L77.9502 90.9567H82.4971H82.5809H83.1281H85.1483L88.6425 90.9986H93.1894H93.357H97.0621L97.4404 90.9567L97.5242 90.9148H97.5674H97.6093H97.6512L97.735 90.8297L97.9877 90.5783L98.1147 90.4932L98.1566 90.4513V90.4094L97.9877 90.3256L97.8201 90.3675H97.7769L97.6093 90.4513L97.4823 90.4094L97.4404 90.3675L97.6093 89.9879L97.6512 89.9041L97.6931 89.7784L97.735 89.7352V89.6514L97.6931 89.5676L97.6093 89.4838L97.6512 89.3149V89.2311L97.6093 89.146L97.5674 89.0203L97.6512 88.8515L97.6931 88.8096L97.7769 88.6839L97.8201 88.5988L97.9877 88.3893V88.3042L98.0296 88.2204L97.9877 88.1366L98.0296 88.0515L98.1985 87.9677L98.2404 87.9258L98.1985 87.7989L98.1566 87.757V87.6732L98.1985 87.5894L98.1566 87.3367L98.2404 87.2097L98.1566 86.957L98.1985 86.8313L98.366 86.7476L98.4093 86.6625L98.366 86.5368L98.4093 86.4098L98.366 86.326L98.1985 86.0314L98.1566 85.9057V85.8206L98.1147 85.6531L97.9877 85.4842L97.862 85.2734V84.9788L97.7769 84.895V84.8112H97.8201L97.862 84.7261L98.1147 84.6005L98.3242 84.3897L98.4093 84.264V84.1789V84.0113L98.4511 83.9681L98.6187 83.8005L98.7038 83.6316L98.9146 83.4209V83.2952L98.8714 83.2114L98.8295 83.0006L98.7876 82.8317L98.8295 82.6222L98.8714 82.4115L99.0822 81.9899L99.293 81.7804L99.3349 81.7372V81.6953L99.4187 81.7372L99.7551 81.948L99.7983 82.0318L99.9659 82.3696L100.177 82.579L100.346 82.8736L100.513 83.2952V83.3371L100.555 83.6316L100.598 83.6735H100.682L100.766 83.7167L100.808 83.8005L100.893 84.3478L100.935 84.6005L101.146 84.9788L101.187 85.1058L101.229 85.568V85.695L101.398 85.8625L101.566 86.2003L101.86 86.4517L101.902 86.7895L101.944 86.8732L101.987 86.9151L102.155 86.957L102.24 87.0002L102.366 87.2097V87.2948V87.3367L102.282 87.5462L102.24 87.757L102.155 87.884V87.9258V88.0096L102.24 88.1785V88.2204V88.2623L102.113 88.4731V88.515L102.155 88.6407L102.324 88.8515V88.9366L102.282 89.0203V89.0622L102.408 89.146L102.449 89.1879L102.408 89.3149L102.324 89.3987L102.366 89.5257V89.5676L102.449 89.6095L102.535 89.6514L102.493 89.946L102.535 89.9879L102.618 90.1148L102.702 90.3675L102.66 90.5783L102.702 90.704H102.871L103.082 90.6202L103.376 90.7878L103.502 90.8729H103.587H103.713L103.797 90.9567V91.1242L103.755 91.2931L103.797 91.335L103.882 91.3769L104.007 91.5039H104.218L104.429 91.5458L104.471 91.6728L104.513 91.7147H104.597L104.807 91.6728L104.849 91.6296L104.933 91.6728L105.06 91.7147L105.144 91.7566L105.186 91.7985L105.524 92.2187L105.775 92.3457L105.818 92.4714L105.902 92.5984L105.986 92.6403V92.7673L106.071 92.8092L106.113 92.893V92.9768L105.986 93.1457L106.028 93.2714L105.986 93.3565V93.3983L106.028 93.4402L106.113 93.524L106.155 93.6091L106.238 93.651L106.322 93.6929L106.407 93.7348L106.66 93.6929L106.744 93.7348L107.122 93.7767H107.165L107.249 93.7348L107.333 93.7767L107.502 93.8186L107.586 93.9456L107.713 94.2821H107.754V94.3659V94.5766L107.796 94.6604V94.7455L107.838 94.8293H107.88L108.007 94.7874L108.133 94.7036V94.6604H108.175H108.258L108.427 94.6185L110.869 94.8293L111.585 94.8712L113.858 95.082L118.783 95.4604L120.425 95.6292L121.183 95.6711L124.298 95.9238L127.539 96.1765L130.359 96.3873L133.179 96.5967H133.516L135.79 96.7656L140.715 97.1021L141.683 97.1872L143.199 97.271L144.546 97.3548L148.377 97.6075V97.6494V97.6912L148.25 97.8182L148.124 98.0709V98.2385L148.039 98.3655V98.4493L147.955 98.5763V98.7439L147.913 98.8708L147.829 98.9546L147.66 99.0384L147.577 99.1235L147.535 99.2492L147.45 99.333L147.366 99.5019L147.324 99.7127V99.7546H147.366L147.408 100.049L147.324 100.26L147.282 100.471L147.155 100.765V100.807L147.197 100.933L147.155 100.975L147.029 101.06L146.986 101.144L146.819 101.227L146.735 101.649L146.777 101.775L146.735 101.817H146.692L146.566 101.86V101.985L146.524 102.111L146.566 102.238L146.482 102.364L146.44 102.491L146.397 102.533H146.355H146.271L146.229 102.617L146.144 102.743L146.019 102.869V102.954L146.144 103.038V103.164L146.188 103.249V103.333L146.229 103.458L146.102 103.669V103.754V103.796H146.019L145.977 103.838V103.88L145.935 103.964V104.006V104.174L146.019 104.216L146.061 104.3V104.385L145.935 104.511L145.85 104.638L145.935 104.849L145.893 104.932L145.935 105.058V105.227L145.977 105.311V105.48L145.935 105.564V105.605L145.808 105.691L145.766 105.816L145.682 105.858V105.943L145.64 106.069L145.682 106.238V106.322L145.724 106.447L145.682 106.616L145.64 106.869L145.555 106.911L145.471 106.995L145.43 107.036L145.388 107.121V107.205L145.346 107.332L145.261 107.5V107.669L145.177 107.836V107.963V108.047V108.216L145.219 108.3L145.177 108.469L145.303 108.721H145.346L145.513 108.763H145.597H145.64L145.682 108.805V108.847V108.931V108.974L145.64 109.058L145.682 109.184V109.352L145.64 109.394L145.597 109.478L145.513 109.521L145.471 109.563L145.303 109.731V109.773L145.346 109.858L145.388 109.942L145.43 110.152L145.471 110.236L145.513 110.32V110.531L145.555 110.573H145.682L145.808 110.7V110.825L145.682 110.867L145.64 110.952L145.724 111.078V111.205L145.555 111.373L145.513 111.458L145.555 111.499V111.541L145.513 111.667V111.709L145.64 111.836V111.962L145.597 112.214V112.341L145.555 112.425V112.636L145.513 112.72L145.555 112.847L145.724 112.803L145.766 112.847V113.014L145.85 113.141V113.225L145.766 113.309V113.351V113.478L145.808 113.52L145.766 113.647L145.85 113.772L145.893 113.898L145.85 114.109L145.935 114.151L145.893 114.32V114.361L145.808 114.32L145.724 114.361L145.766 114.53L145.682 114.656L145.64 114.867L145.555 114.951L145.513 115.078L145.64 115.161V115.245H145.597L145.471 115.203L145.43 115.245L145.388 115.33L145.43 115.414V115.583L145.724 115.54L145.766 115.583V115.667L145.724 115.751L145.766 115.919H145.85L145.808 116.045L145.893 116.13V116.298L145.85 116.382H145.977L145.893 116.55V116.634L145.935 116.677H145.977L146.019 116.55H146.144H146.188V116.592L146.061 116.677V116.719L146.271 116.803H146.482L146.566 116.761L146.608 116.845V116.93L146.65 117.014V117.098L146.608 117.181L146.566 117.308L146.524 117.434V117.687L146.397 117.729L146.313 117.856H146.271L146.188 117.814L146.102 117.856L146.144 117.981L146.229 118.023V118.066L146.188 118.15L146.019 118.192L145.977 118.234L146.061 118.403L146.102 118.445V118.529L146.061 118.739L146.102 118.908L146.061 118.992L146.019 119.076H146.061L146.144 119.161V119.245V119.414L146.061 119.539L146.019 119.581V119.792L145.977 119.834L145.893 119.961L145.808 120.045L145.766 120.129L145.64 120.212V120.381L145.682 120.55L145.64 120.634L145.555 120.676L145.471 120.845L145.346 120.97L145.177 121.055L145.051 121.223L145.008 121.645L144.924 121.77L144.882 121.981L144.799 122.234L144.672 122.401L144.588 122.359L144.503 122.401H144.461L144.419 122.444L144.377 122.528L144.503 122.696L144.461 122.907L144.503 122.992L144.461 123.117L144.546 123.286V123.328V123.454V123.496V123.581V123.748V123.834L144.419 123.959V124.086L144.503 124.212V124.381L144.63 124.675L144.588 124.801L144.546 124.885L144.377 125.012H144.251L144.166 124.928H144.124H144.082V125.012L144.124 125.179V125.306L144.04 125.39L143.957 125.559L143.83 125.812L143.746 126.064L143.704 126.148L143.746 126.359L143.704 126.485L143.619 126.527L143.661 126.696V126.737L143.619 126.822L143.577 126.906L143.661 127.032V127.117L143.746 127.201L143.788 127.285L143.746 127.412L143.788 127.579L143.577 127.917L143.619 128.126L143.451 128.463H143.408L143.366 128.548L143.408 128.674V128.716L143.366 128.801L143.324 128.843L143.282 128.926L143.241 128.968V129.095L143.324 129.221L143.282 129.306L143.157 129.39L143.03 129.601V129.726V129.81L142.988 129.937L143.072 130.021V130.063H143.03L142.777 130.232H142.735L142.651 130.357V130.484L142.357 130.652L142.062 130.821L141.893 130.863L141.768 130.821L141.724 130.737L141.683 130.526L141.557 130.442H141.472L141.43 130.526L141.346 130.61L141.22 130.695L141.093 130.61L140.925 130.652L140.841 130.821H140.757L140.715 130.905L140.63 130.99L140.377 130.948L140.335 130.99L140.252 131.074L140.168 131.284L139.999 131.326L139.873 131.621L139.83 131.663H139.662L139.535 131.746V131.915L139.452 132.042V132.168L139.494 132.252L139.579 132.294V132.337L139.452 132.421L139.368 132.463L139.326 132.59V132.799L139.41 132.884V132.968L139.241 133.221V133.263L139.283 133.346V133.388L139.199 133.515L139.241 133.641V133.683V133.726L139.199 133.768L139.073 133.81L139.031 133.894V133.935L139.073 134.062V134.146H138.988H138.904L138.863 134.021H138.779V134.062H138.737L138.779 134.188L138.904 134.526V134.61L138.863 134.735L138.821 134.777L138.61 135.157V135.241L138.441 135.325L138.315 135.535L138.273 135.62L138.146 135.746L138.105 135.872L138.063 135.915L137.937 135.788H137.684L137.642 135.872V135.957V135.999L137.557 135.957L137.473 135.999L137.39 136.21L137.305 136.251L137.01 136.293L136.884 136.251H136.799L136.757 136.293L136.715 136.251L136.59 136.335L136.168 136.251L136.084 136.293H135.916H135.79L135.832 136.419L135.79 136.588H135.748V136.672L135.579 136.799V136.924L135.537 136.966L135.453 137.051L135.41 137.177L135.368 137.261V137.304L135.326 137.43V137.472L135.201 137.557L135.157 137.514L135.116 137.557L135.074 137.599L135.032 137.641L134.905 137.599L134.653 137.724L134.526 137.809H134.443L134.359 137.851L134.316 137.893H134.274L134.19 137.851L134.106 137.893V138.019L133.979 138.061L134.021 138.146L133.979 138.23V138.44H133.937H133.854V138.482L133.979 138.651V138.693H133.937H133.895L133.812 138.608H133.768L133.727 138.693V138.735H133.601L133.516 138.819H133.432H133.348V138.777H133.306L133.179 138.861V138.946H133.137L133.095 139.03L133.137 139.071V139.113V139.198L133.095 139.24V139.282V139.366L133.179 139.45L133.095 139.493V139.535L133.179 139.619H133.348H133.39V139.661V139.746L133.432 139.788L133.559 139.871L133.516 139.913V139.955L133.559 139.913L133.643 139.955L133.559 139.998L133.601 140.04V140.082V140.124L133.559 140.208H133.516H133.432V140.293H133.474V140.335V140.419L133.432 140.461V140.544L133.348 140.502V140.588L133.264 140.502H133.221V140.588L133.264 140.629H133.179L133.221 140.713L133.179 140.755H133.095L133.012 140.671H132.97L133.012 140.84L132.885 140.755H132.843H132.801L132.843 140.84L132.801 140.882V140.924H132.885L132.927 141.093L132.885 141.135L132.843 141.05L132.801 141.008L132.759 141.05L132.717 141.093L132.801 141.219L132.759 141.177L132.674 141.219L132.59 141.26V141.302H132.674L132.632 141.344V141.513H132.548L132.506 141.597V141.639V141.724H132.464L132.421 141.766L132.379 141.724L132.254 141.85H132.212V141.935H132.17V141.892H132.127L132.085 141.935L132.043 141.892L132.001 141.977H131.917L131.832 142.019H131.875L131.832 142.06L131.748 142.102V142.186H131.706L131.665 142.229H131.623V142.144H131.579V142.186H131.538L131.623 142.271L131.579 142.355H131.623V142.397H131.454H131.496L131.538 142.482H131.496V142.439H131.454V142.482V142.524L131.412 142.482V142.524L131.37 142.566L131.328 142.524H131.243H131.201L131.159 142.482L131.117 142.524V142.482L131.075 142.524V142.608L131.117 142.65H131.075V142.733L131.032 142.777H130.99V142.818H130.948V142.902V142.944V142.986V143.029L130.906 143.071V143.113L130.865 143.197V143.155H130.823V143.324L130.865 143.366L130.823 143.408V143.449V143.491H130.781L130.823 143.533H130.781V143.576H130.738L130.781 143.66H130.738V143.702H130.781V143.744V143.786V143.744L130.823 143.786V143.828L130.781 143.871H130.738V143.913V143.871V143.955L130.696 143.913H130.654L130.696 143.955H130.612L130.654 143.997H130.612V144.039H130.57H130.528L130.57 144.081H130.528H130.485L130.443 144.124V144.166V144.208L130.401 144.333H130.359V144.375L130.317 144.418L130.275 144.502L130.234 144.46L130.19 144.502V144.586L130.148 144.713V144.755V144.797H130.107V144.922L130.065 144.966L130.023 145.049H129.938L129.981 145.175L129.896 145.218V145.26L129.812 145.302V145.344V145.386L129.854 145.344V145.386H129.896L129.854 145.428V145.47H129.812L129.896 145.513L129.938 145.555L129.896 145.597H129.938V145.638H129.896V145.68V145.722H129.981L129.938 145.764H129.896H129.938V145.849L129.896 145.891V145.849V145.891L129.854 145.933H129.896V145.975H129.854V146.017H129.812V146.06L129.77 146.102L129.728 146.144L129.77 146.186L129.728 146.228H129.77V146.311V146.355V146.397V146.355L129.728 146.438V146.48L129.686 146.564V146.607V146.691V146.649V146.691L129.643 146.775V146.817H129.686H129.643V146.902L129.686 146.944L129.643 146.986L129.686 147.028V147.069V147.111V147.155V147.196V147.238L129.643 147.28V147.322L129.601 147.364H129.643L129.601 147.406V147.491L129.643 147.575V147.659H129.686L129.643 147.702L129.686 147.744V147.786L129.643 147.827H129.686V147.869L129.728 147.911L129.686 147.953L129.812 148.038V147.996L129.854 148.038L129.938 148.08V148.122L129.981 148.164L130.023 148.206H130.065L130.107 148.291H130.148L130.107 148.333L130.19 148.417L130.148 148.459L130.19 148.544L130.275 148.627V148.669L130.317 148.753L130.275 148.964L130.317 149.006L130.359 149.048V149.091L130.401 149.133L130.359 149.258L130.57 149.385L130.654 149.553L130.696 149.595L130.738 149.68V150.058H130.107L129.981 150.016L129.938 149.933H129.896L129.812 149.891L129.728 149.848H129.686L129.559 149.806L129.307 149.764L129.139 149.806L129.096 149.848H129.054L128.928 149.806L128.801 149.848L128.676 149.764H128.634V149.722L128.592 149.764L128.549 149.68V149.722H128.507V149.68L128.465 149.722V149.68L128.423 149.722V149.764L128.381 149.722V149.764H128.339V149.891L128.296 149.933L128.254 150.016H128.212L128.17 150.058L128.086 150.016L128.045 149.975H128.001L127.959 149.933H127.876L127.792 149.891H127.707V149.806H127.665L127.623 149.848H127.539V149.806L127.412 149.764L127.37 149.68V149.638H127.287V149.68L127.245 149.638H127.076V149.68L126.992 149.722L126.95 149.764L126.907 149.806L126.865 149.891L126.823 149.806H126.739V149.764H126.697L126.655 149.806L126.612 149.764H126.57L126.36 149.806L126.318 149.764L126.276 149.722V149.68H126.234L126.276 149.638H126.234H126.192V149.595H126.15V149.553V149.511H126.107L126.065 149.553V149.511V149.469L126.023 149.427H125.981V149.385H125.939V149.342L125.897 149.385V149.342L125.856 149.3L125.77 149.342V149.258H125.729L125.77 149.3H125.729L125.687 149.217H125.603H125.561V149.258H125.518H125.434L125.392 149.217L125.35 149.258H125.308V149.3L125.265 149.258L125.308 149.175H125.265L125.308 149.133L125.265 149.048V149.006V148.964L125.308 148.88L125.35 148.838V148.753L125.518 148.544L125.561 148.459L125.603 148.375V148.333L125.687 148.164L125.729 148.122V148.08L125.812 148.038L125.856 147.996V147.869L125.939 147.827L126.15 147.744L126.192 147.702H126.234H126.318H126.36H126.487H126.528L126.612 147.617L126.697 147.659L126.781 147.617H126.823L126.95 145.007L126.865 144.966V144.88L126.781 144.839L126.612 144.88L126.528 144.966H126.487H126.445V145.049L126.403 145.091L126.318 145.218H126.192L126.107 145.26L126.065 145.386L126.023 145.428L125.981 145.555L126.023 145.68L125.77 145.764L125.729 145.807L125.687 145.891L125.518 146.06L125.476 146.102L125.434 146.144L125.392 146.186L125.308 146.27L125.265 146.311L125.139 146.355V146.397H125.098L125.056 146.438L125.012 146.397H124.971L124.803 146.438L124.761 146.522L124.718 146.607H124.676V146.649L124.634 146.607V146.691V146.733V146.775H124.676V146.817L124.634 146.902V146.986V147.028L124.508 147.155V147.196L124.466 147.28L124.508 147.322L124.466 147.364L124.381 147.322H124.298L124.256 147.364V147.322V147.364L124.214 147.322L124.129 147.364L124.087 147.28L124.045 147.322L124.003 147.28H123.918L123.876 147.238L123.792 147.28L123.75 147.322H123.708L123.667 147.364H123.581L123.54 147.406H123.456L123.414 147.491L123.329 147.533L123.287 147.575H123.203H123.161L123.119 147.617H123.076H122.992H122.95H122.909L122.825 147.575H122.782V147.533V147.575L122.656 147.491L122.572 147.449L122.614 147.406L122.656 147.28H122.614V147.238H122.572L122.614 147.196L122.572 147.155V147.069L122.614 147.111V147.069V147.028L122.487 146.986L122.445 146.944L122.403 146.902V146.859L122.361 146.817L122.319 146.859L122.277 146.817L122.067 146.775L122.025 146.691V146.649H121.983L122.025 146.564H121.983V146.522H121.94L121.856 146.48H121.73L121.687 146.438H121.645L121.519 146.522L121.478 146.438L121.434 146.48V146.438L121.351 146.397L121.309 146.438L121.14 146.522L121.014 146.564L120.93 146.522L120.888 146.564L120.803 146.607H120.761V146.649L120.678 146.607L120.636 146.564V146.649L120.551 146.691H120.509H120.467L120.34 146.733L120.298 146.817V146.859L120.256 146.944H120.298L120.256 146.986V147.028H120.214H120.13L120.045 147.111H120.003L119.92 147.196H119.878V147.238V147.28L119.751 147.322H119.709L119.625 147.364L119.498 147.322L119.414 147.364L119.372 147.28H119.33H119.12L119.078 147.322H118.994V147.364L118.951 147.322L118.909 147.406L118.867 147.364L118.825 147.449V147.491L118.783 147.449L118.699 147.406V147.449L118.656 147.406V147.449H118.614V147.491V147.449L118.572 147.491H118.489V147.449V147.491H118.447H118.404H118.362L118.32 147.449L118.278 147.406V147.449L118.236 147.406L118.194 147.449L118.152 147.406V147.449L118.109 147.406L118.067 147.491L117.983 147.575L117.899 147.533V147.491H117.814H117.772L117.731 147.449V147.491H117.689L117.731 147.449H117.689V147.406L117.647 147.364L117.562 147.406V147.364H117.52V147.322H117.394V147.28L117.436 147.322V147.28L117.352 147.238V147.196H117.309V147.238L117.267 147.196V147.238L117.225 147.196L117.267 147.155L117.225 147.196V147.111H117.183V147.069H117.141L117.1 147.028L117.141 146.986L117.1 146.944V146.986H117.058H117.014V146.944L116.973 146.986L117.014 146.944L116.931 146.902L116.973 146.859H116.931L116.805 146.902L116.762 146.859L116.72 146.902H116.762V146.944L116.678 146.902V146.859V146.902H116.594V146.775H116.552L116.467 146.733L116.425 146.691L116.383 146.733H116.342V146.691L116.258 146.649L116.173 146.691L116.131 146.649H116.089H116.005H115.963V146.607H115.92V146.564L115.836 146.48L115.794 146.438L115.752 146.48H115.71L115.669 146.522V146.48L115.625 146.522V146.48H115.583H115.542V146.397H115.458L115.416 146.355V146.311L115.331 146.27H115.373L115.289 146.186V146.228L115.247 146.186H115.205V146.102V146.06H115.163V146.102L115.12 146.06V145.975H115.163L115.12 145.933H115.163L115.12 145.891L115.163 145.807H115.12L115.163 145.764L115.078 145.807L115.036 145.764L114.952 145.68V145.764L114.911 145.722L114.825 145.638L114.784 145.555V145.597V145.638V145.68L114.7 145.638V145.597V145.555L114.616 145.638L114.574 145.555L114.531 145.638L114.489 145.555L114.405 145.638L114.363 145.555L114.278 145.638L114.236 145.555H114.194L114.153 145.513H114.111L114.069 145.47H114.026L113.984 145.513L113.942 145.428L113.9 145.47V145.513L113.774 145.386L113.816 145.302H113.774H113.689L113.647 145.344L113.605 145.302L113.647 145.26H113.605L113.563 145.302L113.521 145.26L113.48 145.175L113.436 145.218L113.353 145.091L113.311 145.133L113.353 145.175L113.269 145.218L113.227 145.175L113.269 145.133L113.184 145.175V145.133H113.227L113.269 145.091H113.1L113.016 145.049V145.091V145.133L112.931 145.175L112.847 145.049L112.889 145.007H112.805H112.763H112.722L112.68 144.966L112.636 145.049V144.922H112.595L112.553 144.966V144.88L112.511 144.922V144.797V144.755L112.469 144.797V144.713H112.553L112.469 144.628L112.385 144.586L112.3 144.502H112.258L112.3 144.586H112.258L112.216 144.502H112.174H112.132L112.047 144.544L111.922 144.502L111.88 144.46L111.837 144.502H111.795L111.753 144.544H111.711V144.586V144.628L111.669 144.586H111.627L111.542 144.628L111.5 144.586L111.458 144.628L111.416 144.586V144.755L111.332 144.713L111.291 144.755H111.247L111.291 144.839L111.205 144.797V144.839H111.122L111.08 144.797H110.996V144.88L110.953 144.839V144.88L110.996 144.966L110.911 144.922L110.869 144.966H110.911H110.827H110.785V145.007L110.827 145.049L110.785 145.133H110.743L110.7 145.175L110.658 145.133H110.616L110.574 145.175V145.218H110.491V145.26L110.406 145.175V145.133L110.447 145.175V145.133L110.364 145.091V145.133H110.322V145.175L110.196 145.218V145.26L110.153 145.344H110.069L110.027 145.428L109.985 145.386L109.902 145.428L109.816 145.513L109.775 145.47V145.386L109.691 145.428V145.344H109.649V145.386L109.522 145.302H109.48V145.218L109.438 145.302L109.396 145.26L109.438 145.344H109.396V145.386H109.353L109.311 145.428L109.269 145.386L109.143 145.47L109.016 145.428H108.975L109.016 145.513H108.933H108.891H108.807H108.764V145.47H108.68V145.513L108.596 145.47L108.554 145.428V145.47L108.596 145.513L108.554 145.555L108.511 145.47H108.469L108.511 145.513L108.469 145.555L108.385 145.513V145.47L108.344 145.428L108.258 145.47L108.302 145.428H108.133L108.091 145.386H108.007V145.47H107.964H107.88V145.555L107.796 145.597L107.838 145.638V145.68L107.713 145.764L107.669 145.807L107.713 145.891H107.669L107.586 145.849L107.417 145.891V146.017L107.333 146.06L107.417 146.102H107.46L107.502 146.144L107.46 146.186H107.417L107.375 146.228L107.46 146.27V146.311L107.417 146.355H107.333L107.291 146.397L107.333 146.48L107.291 146.522L107.249 146.48L107.207 146.564L107.249 146.607L107.207 146.691H107.165L107.122 146.817L107.038 146.859L106.954 146.817L106.869 146.859L106.744 146.902L106.66 147.028H106.575L106.533 147.111H106.491L106.533 147.196L106.491 147.238V147.28L106.533 147.322L106.618 147.28V147.322L106.491 147.491L106.449 147.617L106.365 147.702H106.322H106.28L106.238 147.786V147.827H106.155L106.113 148.08H106.071L106.028 148.038L105.986 148.08H105.902L105.86 148.164L105.775 148.206V148.333H105.649V148.375L105.48 148.291L105.397 148.375H105.271L105.144 148.417H105.018H104.976V148.459L104.933 148.417L104.849 148.5L104.807 148.459L104.849 148.544H104.933V148.586H104.807L104.724 148.627L104.597 148.586V148.669L104.555 148.627L104.597 148.586H104.555L104.513 148.627L104.471 148.586L104.429 148.627L104.344 148.669V148.711H104.26V148.753L104.218 148.711L104.176 148.753L104.133 148.711L104.091 148.669H104.049L103.966 148.796L103.882 148.753V148.796L103.839 148.838V148.88L103.755 148.838L103.671 148.964H103.587L103.629 149.091L103.587 149.175L103.502 149.133L103.418 149.006V148.88L103.208 148.922L103.039 148.838L103.082 148.753L102.955 148.669L102.913 148.627H102.829L102.787 148.5L102.618 148.544V148.5L102.576 148.375H102.618L102.66 148.333L102.576 148.291L102.535 148.206H102.576L102.535 148.164L102.493 148.08L102.408 147.996H102.366V148.038L102.24 148.08V148.038H102.197V147.996L102.113 147.953L102.155 147.911V147.827V147.786L102.197 147.744L102.24 147.702H102.197V147.659L102.155 147.617V147.575V147.533V147.491H102.113V147.406H102.071L102.029 147.238V147.155V147.069L101.944 147.028V146.859L101.86 146.775L101.777 146.817L101.693 146.986L100.893 146.27L100.304 146.649L100.177 146.691V146.607L100.135 146.649L100.093 146.607H100.051L100.008 146.564H99.9659L99.8821 146.522V146.355L99.7983 146.27H99.7132L99.6294 146.355L99.4187 146.27V146.06L99.3768 146.017L99.293 146.06L99.2511 146.017L99.2092 145.975L99.2511 145.849L99.0403 145.891L98.9146 145.849L98.9565 145.764L98.9146 145.68H98.7876H98.7457V145.638H98.7038H98.6619V145.68L98.5768 145.638V145.597H98.5349V145.513L98.4511 145.47V145.302L98.366 145.344L98.3242 145.302V145.26L98.366 145.218L98.2823 145.175V145.133L98.1985 145.091L98.1566 145.049L98.1985 145.007L98.0715 144.922V144.88H98.0296L97.9458 144.755H97.9039V144.671H97.862L97.735 144.586L97.6931 144.249L97.7769 144.124L97.735 144.081H97.6931L97.5674 144.124H97.5242V144.081V143.955H97.4823V143.913V143.871V143.786L97.5674 143.702H97.4823V143.66V143.618H97.5674V143.576H97.4823V143.449L97.5242 143.408L97.5674 143.324H97.4823L97.3985 143.239V143.197H97.3566H97.3148V143.113L97.3566 143.029L97.3148 142.986L97.2715 143.029L97.2297 142.986L97.2715 142.902L97.2297 142.86L97.2715 142.818L97.3148 142.733H97.2715L97.3148 142.566H97.2715L97.3148 142.524L97.2715 142.482L97.3148 142.439H97.2715L97.3148 142.397L97.2297 142.271V142.229V142.06H97.3148V142.019V141.977L97.2715 141.85L97.2297 141.766L97.2715 141.597V141.513L97.3148 141.26V141.177L97.4823 140.797L97.5242 140.755L97.5674 140.671L97.735 140.588L97.7769 140.461L97.9458 140.377L98.0296 140.293L98.1147 140.124V140.04L98.0296 139.913L97.9458 139.746L98.0296 139.535V139.493L98.0715 139.45L98.1147 139.493L98.1566 139.45L98.2823 139.366L98.2404 139.324L98.2823 139.113V138.988L98.1985 138.861V138.693L98.0715 138.735H98.0296H97.9877H97.9039L97.7769 138.651L97.735 138.904L97.6512 138.988L97.4823 139.071L95.2933 138.946L91.0423 138.777L86.7062 138.693L86.4954 136.251L86.2846 133.641L84.2645 131.284L84.6442 131.242H86.2428L86.0752 128.168L85.9482 128.212L85.7806 128.126L85.7387 127.917L85.6955 127.832H85.7387L85.6955 127.748V127.664L85.6536 127.621H85.6955L85.6536 127.579V127.495L85.6117 127.454V127.368L85.486 127.327V127.285L85.5279 127.327V127.243L85.4009 127.159L85.4428 127.117H85.4009V127.032L85.359 126.99H85.3171H85.2752L85.3171 126.948V126.906H85.2752V126.864H85.2334L85.2752 126.822V126.779V126.696V126.654L85.3171 126.696V126.654V126.612V126.527L85.2752 126.57V126.527L85.2334 126.57V126.527V126.485L85.1901 126.527V126.485V126.443L85.1483 126.485L85.1064 126.443L85.1483 126.401L85.0645 126.359L85.0226 126.274L84.9807 126.232V126.19L84.9388 126.148V126.064L84.8956 126.023L84.9388 125.979L84.8956 125.896V125.854L84.9807 125.812V125.77L84.8956 125.728V125.643L84.8537 125.601V125.517V125.432H84.7699H84.728V125.39V125.306L84.7699 125.265L84.8118 125.223V125.179L84.7699 125.096L84.8537 125.054L84.7699 124.97L84.8537 124.928L84.8118 124.885V124.843L84.8537 124.801H84.8956L84.9807 124.759L85.1064 124.633V124.59L85.1483 124.507L85.2334 124.423V124.381L85.2752 124.296V124.212L85.3171 124.17V124.212V124.17H85.4009V124.128L85.359 124.086H85.1901L85.1064 123.959L85.1483 124.001L85.1901 123.917H85.2334L85.1901 123.875V123.834H85.1483H85.1064L85.0226 123.79H84.9807L85.0226 123.834H84.9807V123.623L84.9388 123.539L84.9807 123.496V123.454H84.9388H84.8956L84.8537 123.496V123.539L84.8118 123.496L84.8537 123.454L84.8956 123.412V123.328L84.9388 123.286H84.8537H84.8118H84.7699H84.728L84.8537 123.159V123.117L84.7699 123.159L84.728 123.117V123.076H84.7699H84.8537L84.8956 123.034L84.8118 122.992V122.949H84.8537H84.8956L84.8537 122.907H84.728L84.6861 122.865L84.6442 122.907L84.601 122.865H84.4753L84.5591 122.781L84.5172 122.739H84.4753H84.3915V122.823H84.3483L84.3064 122.739H84.2226L84.2645 122.654H84.1807L84.2226 122.612H84.1389L84.097 122.57L84.0538 122.612H84.0119V122.528L83.97 122.57V122.528V122.486L83.8862 122.401L83.8443 122.486H83.8011L83.7592 122.528H83.7173V122.486V122.528L83.6335 122.486L83.5497 122.401L83.5065 122.276L83.4646 122.318V122.401L83.3808 122.318V122.234L83.3389 122.192V122.15H83.3808V122.107H83.4227L83.4646 122.065L83.4227 122.023H83.4646H83.4227L83.4646 121.981H83.5065L83.4646 121.939L83.5065 121.897V121.854V121.812L83.5916 121.77V121.728H83.6335V121.686H83.7173L83.7592 121.601L83.8011 121.645V121.601V121.559L83.8443 121.518V121.476L83.97 121.434L84.0538 121.476H84.097L84.1389 121.434H84.1807L84.3064 121.35L84.3483 121.307H84.3915V121.265H84.4753V121.139L84.6442 121.012L84.7699 120.97V121.012L84.8118 120.97L84.8956 120.928L84.9388 120.97L85.1064 120.928V120.887L85.2334 120.76H85.2752V120.718H85.359L85.4009 120.634V120.508V120.465L85.486 120.423L85.4009 120.339V120.212H85.4428V120.17H85.486V120.087V120.045V120.003V119.961L85.4428 119.876H85.486L85.5279 119.792V119.75V119.708V119.75L85.5698 119.708V119.623V119.581H85.6536L85.6955 119.456H85.7387V119.287H85.7806V119.203L85.8644 119.076V119.034V118.95H85.9063H85.9482L86.1171 118.739L86.0333 118.698L86.0752 118.614L86.0333 118.571V118.529V118.487L85.9901 118.445L86.0333 118.403V118.319H86.1171L86.2009 118.192H86.2428L86.2846 118.108V118.023H86.3697L86.4116 117.981H86.4535V117.856L86.4954 117.814L86.5373 117.729L86.5805 117.687V117.645L86.6224 117.603L86.7481 117.645L86.79 117.603H86.8332H86.8751L86.917 117.645L86.9589 117.561H87.0427L87.1278 117.308L87.2535 117.181L87.2954 117.056L87.2535 116.761L87.2954 116.55V116.382L87.2116 116.172V116.13V116.045L87.2954 115.836V115.667L87.3791 115.54V115.456L87.3373 115.372L87.4224 115.287L87.5061 115.245H87.548L87.5899 115.119V115.036L87.6318 114.992L87.7169 114.909L87.7588 114.867L87.9277 114.825L88.0534 114.656L88.1791 114.614V114.572V114.53H88.2223V114.488H88.3061H88.348L88.3899 114.445V114.488L88.4736 114.445L88.5169 114.488L88.6006 114.53L88.6844 114.488L88.7263 114.445L88.7682 114.361L88.7263 114.151L88.8114 114.067V113.983L88.8533 113.941H88.8952V113.856L88.979 113.772V113.73L89.0641 113.647L89.1898 113.603L88.4736 113.014H88.4318V112.972V112.93L88.3899 112.847V112.803L88.348 112.678V112.594L88.3899 112.552V112.509V112.425V112.172L88.3061 112.047H88.2642L88.2223 111.92L88.0953 111.836H88.0534V111.794H88.0115V111.752L87.9696 111.709V111.625H87.8845L87.9277 111.541L87.9696 111.458V111.414L87.8845 111.373H87.9277H87.9696V111.331L87.9277 111.289L87.9696 111.247L87.8426 111.162H87.8845V111.12V111.078L87.8426 110.994L87.8845 110.91L87.8426 110.867H87.8007L87.7169 110.741L87.6318 110.783L87.5899 110.741L87.548 110.783L87.5061 110.741L87.4642 110.783L87.3791 110.741L87.2954 110.7V110.658V110.614L87.2535 110.573V110.531H87.2116V110.489H87.1697V110.531V110.447V110.405L87.1278 110.363L87.0846 110.405L87.1697 110.363L87.1278 110.278H87.1697L87.1278 110.236L87.1697 110.194L87.1278 110.152H87.1697V110.11H87.0846L87.1278 110.069V110.025H87.0846V109.983H87.1278V109.942V109.9H87.0846V109.816L87.0427 109.689L87.0846 109.647L87.0008 109.605L87.0427 109.563V109.521V109.436L87.0008 109.394H87.0427V109.269V109.225V109.142H87.0846L87.0427 109.1L87.0846 109.016H87.0427L87.0846 108.974L87.0427 108.889L87.0846 108.847L87.0427 108.805L87.0846 108.763H87.1278H87.1697L87.1278 108.721H87.2116L87.1697 108.678H87.2116L87.1697 108.636L87.2116 108.594V108.636L87.2535 108.594H87.2954V108.552L87.4224 108.511V108.469L87.5061 108.342L87.5899 108.258V108.216V108.174L87.6318 108.216L87.675 108.174L87.7169 108.131L87.7588 108.089L87.8426 108.047L87.9277 107.836H88.0534L88.0953 107.794L88.1372 107.753H88.1791L88.2223 107.711V107.669L88.2642 107.584V107.542V107.458L88.2223 107.332L88.2642 107.289H88.2223L88.2642 107.247V107.163L88.2223 107.036L88.0953 106.995L88.0115 106.911V106.827L87.9696 106.742V106.658L87.8845 106.532V106.405V106.322H87.9277L87.9696 106.28L88.0115 106.238H87.9696V106.195H87.8845L87.8426 106.111V106.069L87.8007 106.027V105.985H87.8845L87.8426 105.9L87.8845 105.943L87.9277 105.816L87.8426 105.774V105.816H87.7588H87.675V105.774L87.6318 105.858H87.5899L87.548 105.774L87.5061 105.816L87.3373 105.858L87.2954 105.691L87.2535 105.647L87.2116 105.691V105.732H87.1697H87.1278L87.0846 105.691L87.0427 105.732L86.9589 105.691L86.8751 105.732L86.8332 105.691L86.79 105.647L86.6643 105.691H86.6224L86.5805 105.774L86.4954 105.732H86.4535L86.3697 105.691L86.2846 105.647H86.2428H86.1171H86.0752L86.0333 105.605V105.564V105.48V105.438H85.9901H85.9482L85.9063 105.395L85.8644 105.438H85.8225L85.6955 105.564L85.6117 105.522L85.6536 105.564L85.6117 105.691H85.6536L85.6117 105.732L85.486 105.647H85.4428H85.4009H85.359L85.3171 105.605V105.564L85.2752 105.522V105.48H85.2334H85.1901L85.2334 105.353L85.1901 105.311L85.1064 105.269L85.0645 105.311H85.0226L85.0645 105.143H85.0226L84.9807 105.1V104.974H84.9388H81.5702H78.919L78.161 104.932V104.891H78.2448H78.2867V104.764L78.3299 104.722V104.638L78.3718 104.511V104.427H78.3299V104.343L78.2867 104.3H78.3299V104.133V104.049L78.4137 104.006V103.88L78.4556 103.796L78.4137 103.711L78.4556 103.669L78.4975 103.627V103.669L78.5394 103.711V103.754H78.6245L78.5813 103.669L78.6245 103.543L78.5813 103.502V103.416L78.5394 103.333V103.291L78.6245 103.249V103.206H78.5813L78.4975 103.122V102.996L78.5394 102.954H78.5813V102.911V102.827V102.743V102.702L78.5394 102.66L78.6245 102.533L78.5813 102.449L78.6245 102.407L78.5813 102.28L78.6664 102.196V102.111L78.5813 102.027V101.775L78.6664 101.607L78.6245 101.565L78.6664 101.522L78.7082 101.313H78.6664H78.6245V101.269L78.6664 101.227L78.5813 101.186L78.5394 101.144H78.4975L78.4556 101.06V100.891H78.4137L78.3718 100.765H78.3299H78.2448L78.2029 100.68H78.161L78.1191 100.596L78.2029 100.554L78.1191 100.428L78.034 100.302L77.9921 100.218V100.091V100.049V99.9653L78.161 99.9235L78.1191 99.8803V99.7965V99.7546L77.9921 99.7127V99.6708H77.8664V99.6276L77.9083 99.4181V99.333L77.9502 99.2492V99.1654H77.9921L77.9502 99.0384L77.9921 98.9965V98.9546L78.1191 98.8708L78.2029 98.6601V98.6182L78.2867 98.5763V98.4493L78.2448 98.4074L78.2867 98.3236H78.3299V98.2817L78.2867 98.2385L78.3299 98.1966V98.029L78.4137 97.9439V97.8182V97.7763L78.3718 97.6494V97.5237L78.2867 97.4818L78.3299 97.3967V97.3548L78.2448 97.3129L78.161 97.271L78.2867 97.1021V96.9764L78.1191 96.8926H78.034L77.9921 96.8494L78.161 96.7656L78.2029 96.8075H78.2867L78.3299 96.7237L78.4556 96.6818V96.5967L78.4137 96.4711H78.4975L78.5813 96.3022L78.6245 96.2603H78.5813V96.2184L78.5394 96.2603H78.4975L78.4556 96.1765L78.4975 95.9657V95.9238H78.4556V95.8819H78.4137V95.713H78.3718V95.6292L78.2867 95.6711L78.161 95.5455V95.5022L78.3299 95.4604L78.0772 95.3347L78.034 95.2928L77.9921 95.2509V95.2077L77.9502 95.1658L78.0772 95.0401H78.1191V94.955L78.161 94.9131L78.0772 94.7874L78.161 94.7455L78.0772 94.7036L77.9921 94.6185H77.8664L77.7813 94.5766V94.5347L77.6975 94.5766V94.451V94.4077L77.7394 94.324L77.7813 94.2821L77.7394 94.1983L77.7813 94.0713V94.0294L77.6975 94.0713L77.6556 94.0294Z"
							fill="#3482cc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="GO" @mouseenter="e => hoverES(e, 'GO')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M129.686 146.608V146.564L129.728 146.481V146.439L129.77 146.355V146.397V146.355V146.312V146.228H129.728L129.77 146.186L129.728 146.144L129.77 146.102L129.812 146.06V146.017H129.854V145.975H129.896V145.933H129.854L129.896 145.891V145.849V145.891L129.938 145.849V145.764H129.896H129.938L129.981 145.723H129.896V145.681V145.639H129.938V145.597H129.896L129.938 145.555L129.896 145.513L129.812 145.47H129.854V145.428L129.896 145.386H129.854V145.344L129.812 145.386V145.344V145.302L129.896 145.26V145.218L129.981 145.175L129.938 145.05H130.023L130.065 144.966L130.107 144.923V144.797H130.148V144.755V144.713L130.19 144.586V144.502L130.234 144.46L130.275 144.502L130.317 144.419L130.359 144.375V144.333H130.401L130.443 144.208V144.166V144.124L130.485 144.081H130.528H130.57L130.528 144.039H130.57H130.612V143.997H130.654L130.612 143.955H130.696L130.654 143.913H130.696L130.738 143.955V143.871V143.913V143.871H130.781L130.823 143.828V143.786L130.781 143.744V143.786V143.744V143.702H130.738V143.66H130.781L130.738 143.577H130.781V143.534H130.823L130.781 143.492H130.823V143.45V143.408L130.865 143.366L130.823 143.324V143.155H130.865V143.197L130.906 143.113V143.071L130.948 143.029V142.986V142.944V142.902V142.819H130.99V142.777H131.032L131.075 142.734V142.65H131.117L131.075 142.608V142.524L131.117 142.482V142.524L131.159 142.482L131.201 142.524H131.243H131.328L131.37 142.566L131.412 142.524V142.482L131.454 142.524V142.482V142.439H131.496V142.482H131.538L131.496 142.397H131.454H131.623V142.355H131.579L131.623 142.271L131.538 142.186H131.579V142.144H131.623V142.23H131.665L131.706 142.186H131.748V142.103L131.832 142.061L131.875 142.019H131.832L131.917 141.977H132.001L132.043 141.892L132.085 141.935L132.127 141.892H132.17V141.935H132.212V141.85H132.254L132.379 141.724L132.421 141.766L132.464 141.724H132.506V141.639V141.597L132.548 141.513H132.632V141.344L132.674 141.303H132.59V141.261L132.674 141.219L132.759 141.177L132.801 141.219L132.717 141.093L132.759 141.05L132.801 141.008L132.843 141.05L132.885 141.135L132.927 141.093L132.885 140.924H132.801V140.882L132.843 140.84L132.801 140.755H132.843H132.885L133.012 140.84L132.97 140.672H133.012L133.095 140.755H133.179L133.221 140.713L133.179 140.63H133.264L133.221 140.588V140.503H133.264L133.348 140.588V140.503L133.432 140.545V140.461L133.474 140.419V140.335V140.293H133.432V140.208H133.516H133.559L133.601 140.124V140.082V140.041L133.559 139.999L133.643 139.955L133.559 139.914L133.516 139.955V139.914L133.559 139.872L133.432 139.788L133.39 139.746V139.661V139.619H133.348H133.179L133.095 139.535V139.493L133.179 139.45L133.095 139.366V139.282V139.241L133.137 139.199V139.114V139.072L133.095 139.03L133.137 138.946H133.179V138.861L133.306 138.777H133.348V138.819H133.432H133.516L133.601 138.735H133.727V138.693L133.768 138.608H133.812L133.895 138.693H133.937H133.979V138.651L133.854 138.483V138.441H133.937H133.979V138.23L134.021 138.146L133.979 138.061L134.106 138.019V137.893L134.19 137.852L134.274 137.893H134.316L134.359 137.852L134.443 137.81H134.526L134.653 137.725L134.905 137.599L135.032 137.641L135.074 137.599L135.116 137.557L135.157 137.514L135.201 137.557L135.326 137.472V137.43L135.368 137.304V137.261L135.41 137.177L135.453 137.052L135.537 136.966L135.579 136.925V136.799L135.748 136.672V136.588H135.79L135.832 136.419L135.79 136.294H135.916H136.084L136.168 136.252L136.59 136.335L136.715 136.252L136.757 136.294L136.799 136.252H136.884L137.01 136.294L137.305 136.252L137.39 136.21L137.473 135.999L137.557 135.957L137.642 135.999V135.957V135.872L137.684 135.788H137.937L138.063 135.915L138.105 135.872L138.146 135.746L138.273 135.621L138.315 135.536L138.441 135.325L138.61 135.241V135.157L138.821 134.777L138.863 134.736L138.904 134.61V134.526L138.779 134.188L138.737 134.063H138.779V134.021H138.863L138.904 134.146H138.988H139.073V134.063L139.031 133.936V133.894L139.073 133.81L139.199 133.768L139.241 133.726V133.683V133.641L139.199 133.515L139.283 133.388V133.347L139.241 133.263V133.221L139.41 132.968V132.884L139.326 132.799V132.59L139.368 132.463L139.452 132.421L139.579 132.337V132.294L139.494 132.252L139.452 132.168V132.043L139.535 131.916V131.747L139.662 131.663H139.83L139.873 131.621L139.999 131.326L140.168 131.285L140.252 131.074L140.335 130.99L140.377 130.948L140.63 130.99L140.715 130.905L140.757 130.821H140.841L140.925 130.652L141.093 130.61L141.22 130.695L141.346 130.61L141.43 130.526L141.472 130.443H141.557L141.683 130.526L141.724 130.737L141.768 130.821L141.893 130.863L142.062 130.821L142.357 130.652L142.651 130.485V130.358L142.735 130.232H142.777L143.03 130.063H143.072V130.021L142.988 129.937L143.03 129.81V129.727V129.601L143.157 129.39L143.282 129.306L143.324 129.221L143.241 129.096V128.969L143.282 128.927L143.324 128.843L143.366 128.801L143.408 128.716V128.674L143.366 128.548L143.408 128.463H143.451L143.619 128.127L143.577 127.917L143.788 127.579L143.746 127.412L143.788 127.285L143.746 127.201L143.661 127.117V127.032L143.577 126.907L143.619 126.823L143.661 126.738V126.696L143.619 126.527L143.704 126.485L143.746 126.359L143.704 126.148L143.746 126.065L143.83 125.812L143.957 125.559L144.04 125.39L144.124 125.307V125.18L144.082 125.012V124.928H144.124H144.166L144.251 125.012H144.377L144.546 124.885L144.588 124.801L144.63 124.676L144.503 124.381V124.212L144.419 124.086V123.959L144.546 123.834V123.749V123.581V123.496V123.454V123.328V123.287L144.461 123.118L144.503 122.992L144.461 122.907L144.503 122.696L144.377 122.529L144.419 122.445L144.461 122.402H144.503L144.588 122.36L144.672 122.402L144.799 122.234L144.882 121.981L144.924 121.77L145.008 121.645L145.051 121.223L145.177 121.056L145.346 120.971L145.471 120.845L145.555 120.676L145.64 120.634L145.682 120.55L145.64 120.381V120.213L145.766 120.129L145.808 120.045L145.893 119.961L145.977 119.834L146.019 119.792V119.581L146.061 119.54L146.144 119.414V119.245V119.161L146.061 119.076H146.019L146.061 118.992L146.102 118.909L146.061 118.74L146.102 118.529V118.445L146.061 118.403L145.977 118.234L146.019 118.192L146.188 118.151L146.229 118.067V118.024L146.144 117.982L146.102 117.856L146.188 117.814L146.271 117.856H146.313L146.397 117.729L146.524 117.687V117.434L146.566 117.309L146.608 117.182L146.65 117.098V117.014L146.608 116.93L146.692 116.803L146.735 116.72L146.692 116.678L146.735 116.634H146.777L146.735 116.467L146.777 116.382H146.819V116.298L146.861 116.256H146.777V116.214V116.172L146.861 116.13L146.902 116.087L146.861 116.045L146.819 116.003V115.962L146.902 115.92V115.878H147.029H147.071L147.113 115.836L147.071 115.751L147.113 115.709L147.071 115.667L147.113 115.625V115.583H147.071V115.625H147.029L147.113 115.54L147.197 115.583L147.239 115.54L147.197 115.414L147.239 115.372L147.324 115.33L147.366 115.287H147.324L147.366 115.203L147.408 115.12H147.492V115.078V114.993L147.535 114.951L147.492 114.909H147.535H147.619V114.867V114.825L147.702 114.867L147.744 114.825L147.702 114.741H147.744L147.829 114.783V114.741L147.786 114.698V114.656L147.829 114.614L147.997 114.531V114.489H148.124H148.166L148.208 114.362H148.333L148.377 114.278H148.502L148.418 114.236H148.46L148.544 114.193H148.629V114.151L148.544 114.109V114.067H148.586V114.109L148.629 114.151H148.671L148.713 114.109V114.025L148.881 113.941L148.797 114.067V114.193H148.755V114.236H148.671V114.278L148.629 114.32L148.544 114.362L148.502 114.404V114.489L148.46 114.531H148.418V114.741L148.333 114.825L148.377 114.909L148.46 114.951V115.036L148.502 114.993V114.951L148.544 114.993L148.586 115.036H148.502V115.078L148.377 115.162H148.333V115.12H148.291L148.25 115.245L148.291 115.414L148.25 115.456L148.208 115.414L148.166 115.498V115.54L148.124 115.625V115.667L148.081 115.751L148.124 115.793H148.081L148.039 115.751V115.836L147.997 115.793H147.955V115.836V115.793V115.751L147.913 115.793L147.955 115.878V115.92L147.913 115.962L147.997 116.003V116.13L147.913 116.172H147.955L147.913 116.214L147.955 116.256L147.871 116.34L147.913 116.425L147.871 116.467L147.829 116.551L147.871 116.593V116.678H147.913V116.72H147.955V116.803L147.997 116.761V116.803H148.039L148.081 116.845V116.803L148.166 116.845H148.124H148.208V116.887H148.291V116.93L148.333 116.887V116.93H148.377V117.014L148.46 117.056V117.014L148.502 117.098H148.544V117.14L148.629 117.182V117.14H148.671L148.713 117.182L148.797 117.14L148.839 117.182L149.008 117.225L149.091 117.267L149.133 117.225H149.302L149.344 117.309H149.471L149.513 117.392H149.555L149.681 117.351L149.766 117.392L149.849 117.476L149.891 117.434L150.06 117.561H150.144L150.27 117.603H150.313L150.355 117.645L152.207 118.74L153.091 119.245L153.68 119.581L153.849 119.456V119.371V119.329L153.806 119.203L153.849 119.118L153.806 119.034L153.849 118.95L153.764 118.823L153.806 118.74L153.849 118.656V118.571L153.764 118.529V118.487L153.891 118.234L153.975 118.151L154.1 117.982L154.227 117.772H154.269V117.687H154.227V117.645L154.311 117.476L154.353 117.434H154.396V117.392L154.438 117.309V117.182L154.522 117.14V117.098L154.564 117.056L154.606 117.014L154.648 117.056L154.691 117.014L154.775 116.972V116.887L154.817 116.845L154.944 116.761L155.027 116.678H155.069L155.111 116.551L155.238 116.467L155.322 116.761H155.364L155.448 116.845H155.575L155.533 116.887V116.93V116.972L155.448 117.056L155.49 117.098H155.448V117.14L155.49 117.225H155.658V117.267H155.7L155.785 117.225H155.827L155.869 117.267L155.911 117.309L155.953 117.392L156.08 117.476L156.122 117.561L156.711 116.678L156.753 116.634H156.795L156.753 116.593L156.795 116.551L156.837 116.593H156.88H156.922V116.678L156.964 116.72L156.922 116.803L156.964 116.845H157.006V116.803L157.047 116.845H157.089V116.887L157.131 116.93V116.972H157.174L157.216 117.014H157.258V117.098H157.3V117.056L157.427 117.182L157.469 117.225H157.511L157.553 117.309H157.595L157.637 117.392L157.595 117.476L157.637 117.561V117.645V117.772H157.679L157.722 117.856L157.764 117.814L157.806 117.856V117.814H157.889V117.856H157.931V117.772H157.974L158.016 117.856L158.058 117.814L158.1 117.856V117.898H158.142H158.226V117.94V118.024L158.269 118.151H158.353L158.395 118.192H158.437V118.234V118.319H158.478V118.361L158.522 118.445L158.478 118.487H158.564L158.605 118.614L158.564 118.656V118.74H158.522V118.782H158.478L158.522 118.823V118.909L158.605 118.95L158.564 118.992L158.605 119.034H158.564V119.161V119.245L158.478 119.329H158.437L158.478 119.414L158.522 119.456V119.498L158.478 119.623L158.437 119.708L158.564 119.834H158.605H158.647L158.731 119.75V119.623L158.689 119.581L158.731 119.456V119.329L158.773 119.287L158.731 119.245V119.118L158.816 119.076L158.9 119.034V118.992L158.942 118.909V118.74L159.026 118.656L159.111 118.698L159.153 118.74H159.195V118.656L159.236 118.698V118.74L159.278 118.867H159.236V118.909V118.95V119.034L159.195 119.076L159.236 119.118V119.161V119.203V119.245V119.329H159.278V119.371L159.363 119.414H159.32V119.456L159.363 119.498H159.32V119.623H159.405L159.447 119.708L159.489 119.665V119.623V119.581L159.531 119.54L159.573 119.581L159.658 119.54H159.7H159.742L159.784 119.498V119.54L159.826 119.456H159.868V119.414H159.911L159.953 119.371H159.995L160.036 119.414H160.078L160.036 119.371L160.078 119.329L160.036 119.287H160.12H160.162H160.205V119.329H160.247H160.289V119.287H160.247H160.289H160.247L160.373 119.245V119.203V119.118H160.415H160.458V119.076V119.161L160.5 119.118H160.542V119.076H160.626L160.667 119.034V118.992H160.711L160.753 118.909L160.794 118.95L160.836 118.909L160.878 118.95L160.962 118.909V118.867L161.005 118.823H161.047L161.089 118.782L161.173 118.823H161.215L161.257 118.782V118.823L161.215 118.867V118.95L161.173 118.992V119.034V119.076V119.118V119.161L161.215 119.245L161.173 119.287L161.131 119.329V119.371L161.173 119.414H161.215V119.623L161.131 119.75V119.792L161.173 119.75L161.215 119.792V119.75L161.257 119.792L161.3 119.75L161.425 119.708V119.665L161.467 119.708L161.509 119.665L161.552 119.708L161.594 119.665H161.678V119.623V119.581V119.54H161.72L161.678 119.371L161.72 119.329V119.371L161.805 119.329V119.371L161.847 119.329V119.371V119.414V119.456H161.973L162.015 119.498L161.973 119.54V119.581L162.015 119.54L162.057 119.623L162.184 119.581H162.267L162.309 119.708L162.351 119.75V119.792L162.394 119.834L162.436 119.792H162.478H162.52L162.562 119.665L162.604 119.708H162.647H162.689V119.75V119.708H162.731L162.773 119.75V119.834H162.815L162.856 119.792V119.834L162.9 119.876H162.983L163.025 119.834L163.151 119.876L163.278 119.834L163.404 119.918V119.961L164.162 120.803L164.204 120.676L164.246 120.592L164.289 120.55L164.331 120.465L164.373 120.423L164.414 120.34H164.456L164.498 120.298V120.171H164.414L164.331 120.087V120.003L164.289 119.876L164.331 119.834L164.289 119.75V119.708V119.581H164.331L164.414 119.498L164.373 119.414V119.371L164.289 119.329L164.331 119.287V119.245L164.246 119.203V119.161H164.289L164.246 119.118L164.289 119.076H164.246L164.289 119.034L164.331 118.95L164.204 118.909L164.289 118.867L164.331 118.823V118.782H164.373V118.74V118.698L164.331 118.656H164.373V118.614L164.414 118.571L164.456 118.487L164.498 118.529L164.54 118.487L164.709 118.571H164.836L164.878 118.614L164.836 118.782L164.878 118.992L165.004 119.034L165.087 118.992H165.131L165.214 119.034H165.256L165.34 118.992H165.425L165.34 119.161V119.245L165.509 119.287L165.593 119.245L165.678 119.287L165.72 119.329L165.593 119.371L165.551 119.414L165.678 119.54V119.623L165.72 119.665H165.762L165.803 119.54L165.93 119.498V119.414L165.972 119.371H166.014L166.056 119.287L166.098 119.329L166.182 119.414H166.267L166.393 119.456L166.435 119.414H166.562V119.456H166.603L166.562 119.498H166.645L166.687 119.414H166.729V119.329H166.814L166.856 119.287L166.814 119.161L166.94 119.118V119.076H166.982H167.025L167.067 119.034L167.151 119.076L167.234 119.034L167.276 119.076L167.234 119.118L167.32 119.161L167.361 119.118L167.445 119.161L167.529 119.118V119.034H167.487L167.571 118.95H167.656L167.698 118.909V118.992H167.74V118.95L167.782 118.909L167.824 118.95V118.992L167.867 118.95V118.909V118.867H167.951V118.823L167.993 118.867L168.076 118.823L168.119 118.782H168.161L168.245 118.74H168.329V118.656V118.614H168.371H168.414H168.456V118.656H168.498V118.614L168.582 118.529H168.665L168.709 118.445L168.834 118.403V118.361L168.918 118.276L169.003 118.234L169.045 118.151H169.129V118.192V118.234L169.171 118.192V118.234V118.276L169.298 118.234V118.192V118.151H169.34V118.109L169.382 118.024H169.423V117.94L169.509 117.898L169.465 117.856H169.509L169.929 117.603L170.645 117.645H171.612H171.781V117.476L171.823 117.434L171.865 117.392H171.907L171.992 116.678L172.034 116.72V116.803V116.845H172.076L172.118 116.887L172.202 116.845L172.244 116.887V116.845V116.93L172.329 116.972L172.287 117.056H172.329L172.287 117.098L172.329 117.14L172.287 117.182L172.329 117.225V117.267V117.392L172.287 117.434V117.476V117.561L172.244 117.603L172.287 117.645L172.244 117.729L172.329 117.772L172.496 117.729V117.687H172.665L172.792 117.645L172.834 117.603L172.876 117.645L173.087 117.561V117.603L173.212 117.561H173.381L173.423 117.519L173.465 117.476V117.434L173.591 117.392L173.676 117.434L173.843 117.351L173.887 117.309V117.392L173.801 117.561L173.718 117.603L173.634 117.687H173.549L173.507 117.729L173.381 117.772L173.338 117.814H173.296L173.254 117.856H173.212L173.129 117.814H173.087H173.043L173.002 117.856L172.876 117.898V117.982L172.834 118.024V118.067V118.109L172.792 118.151L172.749 118.234L172.707 118.319L172.581 118.445L172.623 118.529L172.665 118.614H172.707L172.749 118.656V118.782L172.665 118.823L172.707 118.909L172.623 118.95L172.665 118.992H172.707V119.076V119.118L172.623 119.161V119.245L172.581 119.371L172.539 119.414V119.456H172.707V119.54V119.623L172.623 119.75L172.749 119.834H172.792V119.918L172.834 120.045H172.876H172.918L173.087 119.961L173.212 119.834L173.296 119.876L173.507 119.834L173.76 119.665L173.801 119.623H173.887L173.97 119.581L174.181 119.498L174.265 119.54L174.307 119.581V119.623L174.265 119.792L174.054 119.918L173.97 119.961L173.887 120.129L173.801 120.171L173.76 120.213L173.634 120.256L173.507 120.298L173.381 120.34L173.254 120.381L173.212 120.465L173.087 120.55V120.592V120.634L173.17 120.592L173.212 120.676L173.296 120.803V120.845L173.17 120.887V120.929H173.212V121.012L173.17 121.098L173.087 121.181L173.129 121.265L173.087 121.35L173.129 121.434L173.17 121.476L173.212 121.434L173.254 121.476L173.423 121.434L173.549 121.56L173.591 121.602L173.423 121.77L173.254 121.854L173.212 121.939H173.17L173.087 122.023L173.002 122.192L172.96 122.234L173.002 122.276L173.087 122.318L173.129 122.36V122.402H173.087L172.918 122.529V122.57L173.002 122.612L173.129 122.57L173.212 122.739L173.17 122.781L172.876 122.865L172.834 122.907L172.96 122.992L172.918 123.076V123.118H173.043L173.129 123.201V123.243V123.287L172.96 123.581V123.749L172.918 123.876L173.129 124.001L173.212 124.043L173.254 124.086L173.212 124.212L173.296 124.296L173.254 124.338L173.17 124.507L173.043 124.591H173.087H173.129L173.17 124.676L173.087 124.801H173.043L173.002 124.759L172.918 124.843L173.002 124.885H173.129L173.254 124.97H173.338V125.012V125.138L173.423 125.18L173.634 125.223L173.76 125.18L173.843 125.223L173.887 125.307L173.843 125.432H173.97V125.517H174.012L174.096 125.476L174.181 125.432L174.265 125.517L174.181 125.685L174.307 125.77H174.391L174.433 125.854V125.896H174.476L174.518 125.854H174.601L174.643 125.896L174.601 125.98H174.728L174.812 126.023L174.854 126.274L174.896 126.317L174.938 126.401L175.023 126.443H175.107L175.149 126.485L175.107 126.57V126.612L175.065 126.654L175.023 126.696V126.823L174.981 126.865H174.896L174.812 126.948H174.77L174.728 126.99L174.601 126.948L174.518 126.823L174.476 126.865V126.907H174.518V126.948L174.56 126.99V127.074L174.518 127.117L174.476 127.201L174.518 127.243L174.601 127.327V127.369V127.412L174.56 127.454H174.601L174.56 127.496L174.601 127.538L174.685 127.621L174.728 127.665L174.685 127.706L174.601 127.665L174.643 127.748H174.601L174.643 127.79V127.832H174.601H174.643L174.685 127.874L174.643 128.001L174.56 128.043L174.685 128.169V128.212L174.601 128.296L174.643 128.337V128.421L174.56 128.463H174.518V128.421V128.463H174.433V128.506V128.548L174.391 128.59L174.433 128.632L174.518 128.716H174.56V128.759V128.885H174.518V128.969V129.096V129.137V129.179V129.306L174.476 129.348L174.433 129.39V129.432L174.349 129.474L174.265 129.516V129.558H174.307L174.391 129.685L174.349 129.81H174.307L174.265 129.895L174.181 130.021L174.096 129.979L174.054 130.148L174.012 130.19H173.928H173.887L173.843 130.105H173.76L173.718 130.148H173.676L173.591 130.063V130.021H173.549L173.591 130.148L173.465 130.274L173.296 130.19H173.254V130.232H173.17L173.129 130.105H173.043L172.96 130.148H172.792L172.749 130.105V130.021H172.665L172.623 129.979H172.581L172.623 129.895V129.854L172.665 129.81L172.707 129.685H172.623L172.581 129.643V129.558V129.432H172.496V129.348L172.371 129.306H172.329L172.287 129.263H172.244L172.076 129.096L171.907 129.012L171.823 128.885H171.698L171.654 128.759V128.716L171.529 128.759L171.445 128.716L171.402 128.801L171.445 128.885L171.402 128.927L171.36 128.969L171.234 129.012H171.192V129.137L171.065 129.221V129.306L171.107 129.39V129.432V129.474L171.234 129.516H171.276L171.36 129.643L171.276 129.854L171.234 129.937L171.192 130.148L171.234 130.232V130.316L171.276 130.358L171.36 130.401V130.443V130.485L171.318 130.526L171.276 130.652L171.36 130.695V130.737L171.402 130.779L171.445 130.948L171.402 130.99L171.318 130.948H171.276L171.192 131.032H171.149L171.107 131.074L171.023 131.158L170.94 131.116L170.854 131.158H170.813L170.687 131.199L170.603 131.158L170.518 131.116L170.35 130.99L170.223 130.948L170.056 130.863L169.887 130.821L169.718 130.737L169.465 130.695L169.256 130.652L169.213 130.737L168.876 130.948L168.834 130.99V131.074L168.918 131.158L169.003 131.199V131.285L169.087 131.326L169.045 131.368L169.003 131.452L168.918 131.621L168.876 131.747L168.751 131.916L168.792 132.043L168.751 132.084L168.834 132.252L168.918 132.168L168.961 132.126H169.003H169.045V132.421H169.171L169.382 132.674L169.34 132.841H169.256L169.171 132.926L169.298 132.968V133.01L169.213 133.094L169.087 133.137L169.003 133.179L168.918 133.263L168.792 133.432V133.683L168.709 133.936V134.146V134.23L168.876 134.357L169.003 134.399L169.087 134.483H169.129V134.526L169.298 134.568V134.61L169.256 134.694L169.298 134.777L169.256 134.988L169.34 135.157L169.465 135.283V135.41L169.55 135.621L169.465 135.788L169.509 135.83L169.465 135.872L169.592 136.083V136.168L169.55 136.21V136.252H169.465L168.624 136.462L168.034 136.588L167.867 136.715L167.824 136.757L167.782 136.715L167.74 136.757L167.698 136.715L167.614 136.63L167.529 136.672L167.571 136.588L167.529 136.546H167.487H167.529L167.487 136.588H167.445V136.63H167.403V136.672L167.361 136.63L167.32 136.715H167.361H167.32V136.757H167.361H167.32L167.361 136.799H167.32H167.361L167.32 136.841H167.276L167.234 136.799V136.841V136.883H167.193H167.151V136.925H167.109V136.966L167.067 137.01L167.025 137.052V137.093H166.982H166.94H166.898L166.814 137.135L166.772 137.093H166.645V137.052V137.093L166.603 137.052V137.093H166.562H166.52V137.135V137.093V137.177L166.435 137.219H166.478H166.393V137.177H166.351L166.309 137.093L166.267 137.135V137.093H166.225V137.052H166.14V137.01H166.098V136.966H166.056V136.925V136.883V136.799V136.757V136.715H166.098V136.672V136.63L166.056 136.588H166.14V136.546V136.504H166.098V136.462L166.14 136.419H166.056L166.098 136.377L166.056 136.335V136.252H166.014H166.056L166.098 136.168V136.125H166.056L166.098 136.083V136.041V135.999V135.957V135.915L166.14 135.872H166.182V135.788H166.225V135.746L166.267 135.704L166.309 135.577H166.351V135.536V135.494L166.393 135.452V135.41V135.452V135.368H166.435V135.325L166.393 135.283V135.199L166.435 135.115V135.03L166.393 134.988H166.351L166.309 134.946L166.351 134.904V134.821V134.736L166.309 134.652L166.393 134.441L166.435 134.399L166.393 134.357H166.351L166.225 134.315H166.056L166.014 134.273V134.23H165.972L165.887 134.105H165.803V133.81H165.298H164.878H164.289H163.573H161.973H161.847H160.92V133.894V134.568H160.836L160.753 134.694L160.711 134.821L160.667 134.988V135.115L160.753 135.157L160.836 135.115L160.878 135.199L160.92 135.368L160.878 135.452H160.836L160.711 135.621L160.667 135.704L160.5 135.746L160.415 135.872V135.915V135.999L160.458 136.21L160.5 136.252L160.458 136.294V136.335V136.419H160.5V136.504H160.458V136.546L160.5 136.588L160.542 136.546L160.626 136.588V136.63V136.715L160.542 136.799L160.584 136.841L160.542 136.966L160.5 137.052V137.177L160.458 137.304V137.346H161.636H161.973H162.057H162.562H163.32L164.162 137.304H164.54H166.478V137.346V137.388L166.435 137.43L166.478 137.472V137.514H166.435V137.557L166.393 137.599V137.557H166.351V137.599L166.309 137.557V137.599V137.641V137.683L166.267 137.725L166.309 137.766H166.267V137.81L166.182 137.852L166.225 137.893V137.935H166.267L166.225 137.977L166.267 138.019L166.225 138.061H166.267L166.309 138.104V138.146L166.267 138.188H166.309L166.351 138.272H166.309L166.351 138.314L166.393 138.356H166.351L166.393 138.483L166.351 138.608H166.309V138.651L166.225 138.693L166.182 138.777L166.225 138.819L166.182 138.861V138.946L166.14 138.988L166.098 139.114H166.056L166.014 139.199L165.887 139.408L165.803 139.45L165.762 139.493L165.72 139.535L165.762 139.703L165.72 139.83L165.635 139.872L165.593 139.955L165.551 139.999V140.124V140.208V140.25L165.593 140.293L165.635 140.377V140.461H165.72L165.678 140.503L165.72 140.545V140.503L165.762 140.545L165.803 140.503L165.845 140.545L165.803 140.588H165.845L165.803 140.63H165.845L165.803 140.672H165.887H165.93V140.713L165.972 140.755V140.713H166.056V140.797V140.84H166.098V140.797L166.182 140.755V140.797H166.267V140.84H166.309H166.267L166.309 140.882L166.267 140.924L166.309 140.966L166.393 140.882V140.84L166.435 140.882L166.393 140.966L166.435 140.924L166.478 141.008V141.05L166.52 141.008H166.562V141.093L166.603 141.05V141.093V141.135H166.645V141.219L166.687 141.261L166.729 141.219L166.772 141.177L166.814 141.261H166.772H166.814L166.856 141.303L166.772 141.344L166.814 141.388L166.856 141.344V141.471L166.814 141.513H166.856H166.898L166.982 141.555V141.639V141.682H166.94L166.982 141.724L166.94 141.766L166.898 141.85L166.94 141.892H166.982H166.94V141.977H167.025V142.019V142.061V142.103V142.144V142.186L167.109 142.23L167.067 142.271V142.313L167.193 142.271L167.109 142.355L167.151 142.482V142.524H167.067L167.109 142.608H167.151V142.65H167.193L167.151 142.692H167.109L167.151 142.734H167.193L167.151 142.819L167.234 142.777H167.276L167.32 142.861H167.361L167.403 142.902L167.276 142.944L167.32 142.986V143.029L167.361 142.986L167.403 143.029L167.361 143.071L167.445 143.113L167.403 143.155L167.445 143.197L167.487 143.155V143.197L167.571 143.239L167.614 143.281L167.571 143.324L167.445 143.366H167.529V143.408H167.487V143.45L167.571 143.408V143.45L167.487 143.492L167.529 143.534H167.487H167.445L167.487 143.577H167.445V143.619L167.403 143.577V143.619V143.577L167.361 143.619V143.66H167.32L167.361 143.702L167.276 143.66V143.619H167.234V143.744H167.276L167.234 143.786V143.744L167.193 143.786H167.151V143.828H167.193L167.151 143.871L167.109 143.828L167.067 143.871L167.109 143.913L166.982 143.871V143.913H166.94V143.955H166.982H166.94L166.898 143.913L166.856 143.955V143.913V144.039H166.814L166.772 143.997V144.039L166.729 143.997V144.124L166.687 144.039L166.645 144.124L166.687 144.166H166.645V144.208L166.603 144.25L166.645 144.333L166.562 144.292L166.478 144.333L166.52 144.375L166.478 144.419L166.435 144.333L166.351 144.375V144.333L166.309 144.375L166.351 144.419L166.309 144.46H166.182L166.225 144.502L166.182 144.544L166.267 144.586H166.225H166.182H166.14L166.182 144.628L166.225 144.671V144.713H166.182V144.671L166.14 144.713V144.755V144.797H166.056H166.014L165.972 144.839L166.014 144.923H165.972L166.014 144.966L165.972 145.008L165.93 144.966H165.845V145.008V145.05H165.762L165.803 145.091V145.133L165.678 145.175V145.218H165.72L165.762 145.26V145.302L165.72 145.344L165.762 145.428V145.47L165.678 145.428L165.635 145.47H165.593V145.513H165.551L165.635 145.597L165.593 145.639V145.597H165.509L165.551 145.639L165.509 145.681L165.467 145.597L165.34 145.639V145.597H165.298V145.555L165.214 145.513V145.47V145.555H165.256L165.131 145.639L165.172 145.681V145.808L165.131 145.849L165.087 145.808V145.849V145.891H165.045L165.087 145.933V145.975H165.131V146.017H165.045L165.087 146.06V146.102H165.131V146.144V146.228H165.045L165.004 146.312H165.045L165.172 146.355L165.214 146.439L165.256 146.481V146.564V146.691V146.733H165.298L165.34 146.775L165.425 146.649L165.467 146.817H165.509H165.551L165.593 146.775L165.803 146.733L165.887 146.691H165.972L166.056 146.733L166.182 146.775L166.309 146.733L166.393 146.775L166.435 146.859L166.478 146.944L166.603 147.07L166.687 147.197L166.729 147.28V147.364V147.491H166.645V147.575V147.617H166.687V147.659V147.702L166.603 147.786H166.52V147.828H166.478L166.435 147.87V147.953L166.393 148.038L166.309 148.122L166.267 148.164V148.206L166.309 148.249V148.291L166.267 148.333V148.375L166.182 148.417V148.459L166.225 148.501L166.182 148.544H166.14L166.225 148.586H166.182L166.14 148.628L166.098 148.67L166.056 148.711L166.098 148.753L166.14 148.838V148.88V148.922L166.182 148.964L166.14 149.048L166.182 149.091H166.14L166.182 149.133H166.225L166.267 149.175L166.225 149.217H166.267L166.225 149.259L166.267 149.301H166.225L166.267 149.342V149.386H166.309V149.469L166.435 149.553V149.638H166.393V149.68V149.764H166.435V149.806L166.52 149.848L166.562 149.891L166.52 149.933L166.562 149.975H166.52H166.562L166.603 150.059V150.142L166.562 150.186H166.52H166.478L166.52 150.269L166.435 150.227H166.393L166.267 150.311L166.225 150.353L166.14 150.311V150.395H166.182V150.437L166.098 150.48V150.522H166.014L165.972 150.564L165.93 150.522V150.606L165.845 150.648H165.93V150.69H165.845L165.803 150.733V150.69H165.72L165.678 150.775L165.72 150.817V150.859H165.678L165.635 150.817H165.593L165.509 150.9H165.467V150.942L165.383 150.9V150.942L165.34 150.986L165.383 151.027H165.34L165.298 151.069L165.256 151.027L165.172 151.069V151.153L165.087 151.195V151.237V151.28L165.045 151.237V151.195V151.069V151.027H165.004L164.92 151.111H164.878L164.836 151.195L164.793 151.237H164.709L164.793 151.28H164.751H164.709L164.625 151.364V151.406V151.448V151.49L164.583 151.448V151.406L164.498 151.448L164.54 151.531L164.456 151.575L164.414 151.617L164.456 151.658L164.498 151.742L164.583 151.784L164.498 151.869V151.911H164.456L164.373 151.953V151.911L164.331 151.869H164.289L164.204 152.08H164.162H164.12V152.122L164.036 152.206H163.993H163.951V152.122H163.783L163.825 152.206H163.783L163.741 152.248L163.698 152.331L163.741 152.375V152.416H163.656L163.614 152.458L163.531 152.5L163.489 152.458H163.446L163.404 152.416L163.446 152.375H163.404L163.362 152.331L163.32 152.375L163.236 152.416V152.5L163.194 152.584L163.236 152.626V152.669H163.194L163.109 152.626L163.067 152.584L163.025 152.626V152.669L162.983 152.711L163.025 152.753V152.795L162.983 152.837H162.942L162.9 152.795L162.856 152.837L162.689 152.753L162.647 152.795L162.604 152.922H162.562L162.478 152.964L162.436 153.006L162.394 152.964V152.837H162.351H162.309V152.753V152.669V152.626L162.184 152.711H162.142L162.1 152.669V152.626L162.015 152.584L161.931 152.542L161.889 152.458L161.847 152.416H161.805L161.762 152.5L161.72 152.542H161.636H161.594L161.467 152.5L161.384 152.458L161.257 152.416V152.331L161.173 152.248V152.164H161.089L160.962 152.122H160.794L160.753 152.08V151.995H160.584L160.542 151.911H160.5H160.458L160.373 151.995L160.205 152.122V152.164L160.289 152.206V152.248H160.247H160.162L160.12 152.164H160.078H160.036L159.995 152.122L159.911 152.164H159.7H159.658V152.08H159.616H159.573L159.489 152.122L159.405 152.08L159.195 152.206L159.153 152.164L159.195 152.08L159.153 152.037H159.111L158.984 152.122L158.9 152.037H158.773L158.731 151.995V151.911L158.689 151.869H158.564L158.522 151.911H158.478L158.226 151.869L158.184 151.911V151.953V151.995H158.1H158.016H157.931L157.847 152.037L157.764 151.995L157.637 152.037L157.511 151.995L157.384 152.08L157.3 152.037L157.216 152.08L157.131 152.206H157.047L157.006 151.995L156.964 151.953L156.753 151.911L156.711 151.827H156.542L156.5 151.742H156.375L156.248 151.869L156.164 151.911L156.122 151.953H156.08V152.08H156.038L155.995 152.164H155.953L155.827 152.122L155.7 152.206V152.29L155.658 152.375L155.49 152.458V152.416H155.406L155.364 152.375H155.28V152.331L155.322 152.29V152.248H155.195L155.027 152.375L154.985 152.416L154.817 152.458L154.691 152.416L154.648 152.458V152.5L154.775 152.584V152.626V152.669L154.733 152.711L154.648 152.753L154.564 152.837L154.48 153.006L154.438 153.131L154.311 153.175H154.269L154.227 153.216L154.186 153.258L154.144 153.384L154.1 153.426L153.975 153.384H153.933L153.849 153.595L153.722 153.72L153.68 153.847L153.638 153.889L153.511 153.931L153.428 153.889H153.386L153.302 153.679L153.006 153.384L152.964 153.258V153.175V153.048V153.006L152.922 152.964H152.88L152.755 152.922L152.669 152.964H152.628L152.586 153.006L152.628 153.175L152.586 153.216V153.258H152.544L152.502 153.3L152.417 153.258L152.08 153.3L151.955 153.342V153.384L151.911 153.426L152.038 153.553L151.997 153.637H151.955L151.828 153.553H151.786H151.702L151.617 153.595L151.491 153.679L151.407 153.72H151.364L151.28 153.679L151.197 153.72L151.155 153.806L151.113 153.889H151.07H151.028L150.902 153.847H150.775L150.691 153.764H150.607L150.566 153.72L150.522 153.679H150.48L150.355 153.764H150.186L149.933 153.72L149.891 153.637H149.681H149.597L149.555 153.679L149.471 153.889L149.386 153.973L149.26 154.1L148.755 154.016L148.544 154.142H148.418L148.208 154.1L148.081 154.142L147.997 154.184L147.955 154.226L147.871 154.268L147.786 154.353L147.577 154.647L147.45 154.984L147.408 155.026H147.324L147.197 155.068L147.155 155.111V155.153L147.029 155.489L146.902 155.658H146.861L146.692 155.742L146.608 155.784V155.868L146.692 156.078L146.65 156.205L146.692 156.247V156.415L146.524 156.668L146.44 156.836H146.397V156.878L146.229 156.962L146.144 157.047H145.766H145.682H145.597L145.555 157.089L145.597 157.215L145.555 157.299L145.219 157.384L145.177 157.467V157.551V157.594L145.135 157.678L145.008 157.846H144.882L144.713 158.015L144.63 158.142V158.184L144.588 158.267V158.393L144.503 158.52L144.461 158.689L144.377 158.773V158.815L144.335 158.898L144.377 158.94L144.588 159.109L144.672 159.236V159.278L144.588 159.362H144.546L144.166 159.236L143.957 159.151V159.109L143.913 159.067L143.872 159.025L143.788 158.94H143.661V158.815H143.535L143.577 158.773L143.535 158.731L143.493 158.773L143.366 158.731L143.451 158.689V158.646L143.408 158.604L143.366 158.478H143.324V158.393L143.241 158.309L143.199 158.267L143.157 158.309V158.267L143.03 158.184V158.142H142.988H142.904L142.862 158.098H142.777L142.693 158.015H142.524L142.441 157.973L142.399 157.889H142.315V157.846L142.272 157.889L142.23 157.846H142.188H142.146V157.889H142.062L142.019 157.931L141.977 157.889L141.851 157.846V157.762L141.81 157.804L141.768 157.762L141.724 157.72H141.683V157.594H141.515L141.43 157.551L141.304 157.594V157.551L141.262 157.509V157.467V157.426H141.135L141.093 157.384H141.052V157.342H141.01L141.052 157.299H141.01L140.968 157.257H140.925H140.841L140.799 157.215H140.757L140.715 157.257L140.63 157.173L140.588 157.215H140.504L140.462 157.173V157.131H140.421L140.294 157.089H140.21H140.168L140.126 157.047H139.999V157.004H139.915L139.873 157.047L139.788 157.089V157.047H139.704L139.621 157.004H139.579L139.494 157.047L139.283 156.92L139.241 156.962L139.157 156.878H139.199L139.157 156.836L139.115 156.878H139.073L139.031 156.794L138.988 156.836V156.794H138.946V156.753H138.988H138.946H138.863L138.779 156.668L138.737 156.709L138.652 156.668H138.694L138.61 156.626H138.652L138.484 156.542H138.357V156.5L138.399 156.457H138.357H138.315V156.5H138.273L138.188 156.415V156.373H138.146L138.105 156.289H138.063V156.247L138.021 156.162H137.937L137.894 156.078H137.852V156.036H137.768L137.726 155.995V156.036H137.684H137.642L137.599 155.995L137.557 155.953L137.599 156.036H137.557H137.515L137.473 155.995H137.39V155.953L137.346 155.995L137.305 156.036L137.263 156.078V156.036L137.305 155.995L137.263 155.953H137.221L137.137 155.909V155.953V155.909L137.094 155.868H137.052L137.01 155.826L136.968 155.868H136.884L136.842 155.826H136.799V155.784H136.842H136.799L136.715 155.7H136.757L136.715 155.658V155.573L136.674 155.531V155.573L136.59 155.531H136.548L136.505 155.489H136.463L136.421 155.447L136.379 155.405H136.337V155.32L136.295 155.278V155.237H136.252V155.195H136.21L136.126 155.237V155.195L136.084 155.237V155.195L135.999 155.153H135.832L135.748 155.068V155.111L135.663 155.068H135.537V155.153H135.453L135.368 155.111L135.284 155.068V155.026H135.243V154.984H135.157H135.201V154.9H135.074L135.116 154.858H135.032V154.815L134.905 154.689V154.647L134.821 154.605V154.564V154.52L134.737 154.479V154.437L134.61 154.184H134.443L134.274 154.1L134.148 154.058V154.016L134.063 153.973H133.937V154.016L133.854 154.058L133.727 154.142L133.685 154.184H133.516L133.432 154.226L133.39 154.184L133.179 154.142H133.137L132.927 154.226L132.843 154.184H132.717L132.632 154.142H132.506L132.337 154.058L132.254 154.1L132.17 154.058H132.127V154.016L131.959 153.931L131.706 153.889V153.764L131.665 153.72H131.538L131.579 153.637L131.538 153.553L131.454 153.469V153.384L131.412 153.3V153.258L131.538 153.089L131.706 153.048L131.748 152.922L131.79 152.837L131.917 152.753L131.959 152.584V152.542L132.001 152.5H132.043H132.17L132.421 152.458L132.506 152.29L132.632 152.164L132.674 152.037L132.632 151.995V151.953L132.506 151.869L132.421 151.827L132.296 151.784H132.254H131.959L131.665 151.7H131.496L131.285 151.742L131.075 151.869L131.032 152.037H130.99L130.906 151.995H130.738L130.528 151.784V151.531L130.485 151.364V151.195L130.359 150.817V150.69L130.317 150.437L130.275 150.311L130.317 150.227L130.401 150.186L130.443 150.142H130.612H130.654L130.696 150.101L130.738 150.059V149.68L130.696 149.595L130.654 149.553L130.57 149.386L130.359 149.259L130.401 149.133L130.359 149.091V149.048L130.317 149.006L130.275 148.964L130.317 148.753L130.275 148.67V148.628L130.19 148.544L130.148 148.459L130.19 148.417L130.107 148.333L130.148 148.291H130.107L130.065 148.206H130.023L129.981 148.164L129.938 148.122V148.08L129.854 148.038L129.812 147.997V148.038L129.686 147.953L129.728 147.912L129.686 147.87V147.828H129.643L129.686 147.786V147.744L129.643 147.702L129.686 147.659H129.643V147.575L129.601 147.491V147.406L129.643 147.364H129.601L129.643 147.322V147.28L129.686 147.239V147.197V147.155V147.112V147.07V147.028L129.643 146.986L129.686 146.944L129.643 146.902V146.817H129.686H129.643V146.775L129.686 146.691V146.649V146.691V146.608Z"
							fill="#195386" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="MS" @mouseenter="e => hoverES(e, 'MS')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M99.9658 159.699L100.893 157.763L101.524 156.373H101.987L102.071 156.248H102.029L102.071 156.163L101.987 156.079L101.944 156.037H101.902V155.532H101.608L102.913 151.323L103.544 151.281V151.237L103.46 151.196L103.418 151.154V151.112V151.07L103.376 151.028L103.334 151.07L103.249 151.028V151.07L102.787 150.648L102.744 150.481L102.66 150.101L101.902 148.67H102.155V148.544L101.902 148.334L101.987 148.081L101.902 147.997H101.86L101.776 147.828H101.735L101.649 147.617L101.566 147.576L101.524 147.492L101.566 147.407V147.323V147.281L101.524 147.323V147.281L101.566 147.197H101.482H101.524L101.566 147.112L101.482 147.155V147.112L101.524 147.07V147.028L101.44 146.986V146.945H101.482L101.693 146.986L101.776 146.818L101.86 146.776L101.944 146.859V147.028L102.029 147.07V147.155V147.239L102.071 147.407H102.113V147.492H102.155V147.534V147.576V147.617L102.197 147.659V147.703H102.24L102.197 147.744L102.155 147.786V147.828V147.912L102.113 147.954L102.197 147.997V148.039H102.24V148.081L102.366 148.039V147.997H102.408L102.493 148.081L102.535 148.165L102.576 148.207H102.535L102.576 148.292L102.66 148.334L102.618 148.375H102.576L102.618 148.501V148.544L102.787 148.501L102.829 148.628H102.913L102.955 148.67L103.082 148.754L103.039 148.839L103.207 148.923L103.418 148.881V149.007L103.502 149.134L103.587 149.175L103.629 149.092L103.587 148.965H103.671L103.755 148.839L103.838 148.881V148.839L103.882 148.797V148.754L103.965 148.797L104.049 148.67H104.091L104.133 148.712L104.176 148.754L104.218 148.712L104.26 148.754V148.712H104.344V148.67L104.429 148.628L104.471 148.586L104.513 148.628L104.555 148.586H104.597L104.555 148.628L104.597 148.67V148.586L104.724 148.628L104.807 148.586H104.933V148.544H104.849L104.807 148.459L104.849 148.501L104.933 148.417L104.976 148.459V148.417H105.018H105.144L105.271 148.375H105.396L105.48 148.292L105.649 148.375V148.334H105.775V148.207L105.86 148.165L105.902 148.081H105.986L106.027 148.039L106.071 148.081H106.113L106.154 147.828H106.238V147.786L106.28 147.703H106.322H106.365L106.449 147.617L106.491 147.492L106.618 147.323V147.281L106.533 147.323L106.491 147.281V147.239L106.533 147.197L106.491 147.112H106.533L106.575 147.028H106.66L106.744 146.903L106.869 146.859L106.954 146.818L107.038 146.859L107.122 146.818L107.165 146.692H107.207L107.249 146.608L107.207 146.565L107.249 146.481L107.291 146.523L107.333 146.481L107.291 146.397L107.333 146.355H107.417L107.46 146.312V146.27L107.375 146.228L107.417 146.186H107.46L107.502 146.145L107.46 146.103H107.417L107.333 146.061L107.417 146.018V145.892L107.585 145.85L107.669 145.892H107.712L107.669 145.808L107.712 145.765L107.838 145.681V145.639L107.796 145.597L107.88 145.555V145.47H107.964H108.007V145.387H108.091L108.133 145.428H108.302L108.258 145.47L108.343 145.428L108.385 145.47V145.514L108.469 145.555L108.511 145.514L108.469 145.47H108.511L108.554 145.555L108.596 145.514L108.554 145.47V145.428L108.596 145.47L108.68 145.514V145.47H108.764V145.514H108.807H108.891H108.933H109.016L108.975 145.428H109.016L109.143 145.47L109.269 145.387L109.311 145.428L109.353 145.387H109.396V145.345H109.438L109.396 145.261L109.438 145.303L109.48 145.219V145.303H109.522L109.649 145.387V145.345H109.691V145.428L109.774 145.387V145.47L109.816 145.514L109.901 145.428L109.985 145.387L110.027 145.428L110.069 145.345H110.153L110.196 145.261V145.219L110.322 145.176V145.134H110.364V145.092L110.447 145.134V145.176L110.405 145.134V145.176L110.491 145.261V145.219H110.574V145.176L110.616 145.134H110.658L110.7 145.176L110.743 145.134H110.785L110.827 145.05L110.785 145.008V144.966H110.827H110.911H110.869L110.911 144.923L110.996 144.966L110.953 144.881V144.839L110.996 144.881V144.797H111.08L111.122 144.839H111.205V144.797L111.291 144.839L111.247 144.756H111.291L111.332 144.714L111.416 144.756V144.587L111.458 144.629L111.5 144.587L111.542 144.629L111.627 144.587H111.669L111.711 144.629V144.587V144.545H111.753L111.795 144.503H111.836L111.88 144.461L111.922 144.503L112.047 144.545L112.132 144.503H112.174H112.216L112.258 144.587H112.3L112.258 144.503H112.3L112.385 144.587L112.469 144.629L112.553 144.714H112.469V144.797L112.511 144.756V144.797V144.923L112.553 144.881V144.966L112.594 144.923H112.636V145.05L112.68 144.966L112.721 145.008H112.763H112.805H112.889L112.847 145.05L112.931 145.176L113.016 145.134V145.092V145.05L113.1 145.092H113.269L113.227 145.134H113.184V145.176L113.269 145.134L113.227 145.176L113.269 145.219L113.353 145.176L113.311 145.134L113.353 145.092L113.436 145.219L113.48 145.176L113.521 145.261L113.563 145.303L113.605 145.261H113.647L113.605 145.303L113.647 145.345L113.689 145.303H113.774H113.816L113.774 145.387L113.9 145.514V145.47L113.942 145.428L113.984 145.514L114.025 145.47H114.069L114.111 145.514H114.152L114.194 145.555H114.236L114.278 145.639L114.363 145.555L114.405 145.639L114.489 145.555L114.531 145.639L114.574 145.555L114.616 145.639L114.7 145.555V145.597V145.639L114.783 145.681V145.639V145.597V145.555L114.825 145.639L114.91 145.723L114.952 145.765V145.681L115.036 145.765L115.078 145.808L115.163 145.765L115.12 145.808H115.163L115.12 145.892L115.163 145.934H115.12L115.163 145.976H115.12V146.061L115.163 146.103V146.061H115.205V146.103V146.186H115.247L115.289 146.228V146.186L115.373 146.27H115.331L115.416 146.312V146.355L115.458 146.397H115.542V146.481H115.583H115.625V146.523L115.669 146.481V146.523L115.71 146.481H115.752L115.794 146.439L115.836 146.481L115.92 146.565V146.608H115.963V146.65H116.005H116.089H116.131L116.173 146.692L116.258 146.65L116.341 146.692V146.734H116.383L116.425 146.692L116.467 146.734L116.552 146.776H116.594V146.903H116.678V146.859V146.903L116.762 146.945V146.903H116.72L116.762 146.859L116.805 146.903L116.931 146.859H116.972L116.931 146.903L117.014 146.945L116.972 146.986L117.014 146.945V146.986H117.058H117.099V146.945L117.141 146.986L117.099 147.028L117.141 147.07H117.183V147.112H117.225V147.197L117.267 147.155L117.225 147.197L117.267 147.239V147.197L117.309 147.239V147.197H117.352V147.239L117.436 147.281V147.323L117.394 147.281V147.323H117.52V147.365H117.562V147.407L117.647 147.365L117.689 147.407V147.45H117.731L117.689 147.492H117.731V147.45L117.772 147.492H117.814H117.899V147.534L117.983 147.576L118.067 147.492L118.109 147.407L118.152 147.45V147.407L118.194 147.45L118.236 147.407L118.278 147.45V147.407L118.32 147.45L118.362 147.492H118.403H118.447H118.489V147.45V147.492H118.572L118.614 147.45V147.492V147.45H118.656V147.407L118.699 147.45V147.407L118.783 147.45L118.825 147.492V147.45L118.867 147.365L118.909 147.407L118.951 147.323L118.994 147.365V147.323H119.078L119.12 147.281H119.33H119.372L119.414 147.365L119.498 147.323L119.625 147.365L119.709 147.323H119.751L119.878 147.281V147.239V147.197H119.92L120.003 147.112H120.045L120.13 147.028H120.214H120.256V146.986L120.298 146.945H120.256L120.298 146.859V146.818L120.34 146.734L120.467 146.692H120.509H120.551L120.636 146.65V146.565L120.678 146.608L120.761 146.65V146.608H120.803L120.888 146.565L120.93 146.523L121.014 146.565L121.14 146.523L121.309 146.439L121.35 146.397L121.434 146.439V146.481L121.477 146.439L121.519 146.523L121.645 146.439H121.687L121.73 146.481H121.856L121.94 146.523H121.983V146.565H122.025L121.983 146.65H122.025V146.692L122.067 146.776L122.277 146.818L122.319 146.859L122.361 146.818L122.403 146.859V146.903L122.445 146.945L122.487 146.986L122.614 147.028V147.07V147.112L122.572 147.07V147.155L122.614 147.197L122.572 147.239H122.614V147.281H122.656L122.614 147.407L122.572 147.45L122.656 147.492L122.781 147.576V147.534V147.576H122.825L122.908 147.617H122.95H122.992H123.076H123.119L123.161 147.576H123.203H123.287L123.329 147.534L123.414 147.492L123.456 147.407H123.539L123.581 147.365H123.666L123.708 147.323H123.75L123.792 147.281L123.876 147.239L123.918 147.281H124.003L124.045 147.323L124.087 147.281L124.129 147.365L124.214 147.323L124.256 147.365V147.323V147.365L124.298 147.323H124.381L124.466 147.365L124.508 147.323L124.466 147.281L124.508 147.197V147.155L124.634 147.028V146.986V146.903L124.676 146.818V146.776H124.634V146.734V146.692V146.608L124.676 146.65V146.608H124.718L124.761 146.523L124.803 146.439L124.97 146.397H125.012L125.056 146.439L125.097 146.397H125.139V146.355L125.265 146.312L125.308 146.27L125.392 146.186L125.434 146.145L125.476 146.103L125.518 146.061L125.687 145.892L125.728 145.808L125.77 145.765L126.023 145.681L125.981 145.555L126.023 145.428L126.065 145.387L126.107 145.261L126.192 145.219H126.318L126.403 145.092L126.445 145.05V144.966H126.487H126.528L126.612 144.881L126.781 144.839L126.865 144.881V144.966L126.95 145.008L126.823 147.617H126.781L126.697 147.659L126.612 147.617L126.528 147.703H126.487H126.36H126.318H126.234H126.192L126.15 147.744L125.939 147.828L125.855 147.87V147.997L125.812 148.039L125.728 148.081V148.123L125.687 148.165L125.603 148.334V148.375L125.561 148.459L125.518 148.544L125.35 148.754V148.839L125.308 148.881L125.265 148.965V149.007V149.048L125.308 149.134L125.265 149.175H125.308L125.265 149.259L125.308 149.301V149.259H125.35L125.392 149.217L125.434 149.259H125.518H125.561V149.217H125.603H125.687L125.728 149.301H125.77L125.728 149.259H125.77V149.343L125.855 149.301L125.897 149.343V149.386L125.939 149.343V149.386H125.981V149.428H126.023L126.065 149.47V149.512V149.554L126.107 149.512H126.15V149.554V149.596H126.192V149.639H126.234H126.276L126.234 149.681H126.276V149.723L126.318 149.765L126.36 149.806L126.57 149.765H126.612L126.655 149.806L126.697 149.765H126.739V149.806H126.823L126.865 149.892L126.907 149.806L126.95 149.765L126.992 149.723L127.076 149.681V149.639H127.245L127.286 149.681V149.639H127.37V149.681L127.412 149.765L127.539 149.806V149.848H127.623L127.665 149.806H127.707V149.892H127.792L127.876 149.933H127.959L128.001 149.975H128.044L128.086 150.017L128.17 150.059L128.212 150.017H128.254L128.296 149.933L128.339 149.892V149.765H128.381V149.723L128.423 149.765V149.723L128.465 149.681V149.723L128.507 149.681V149.723H128.549V149.681L128.592 149.765L128.634 149.723V149.765H128.676L128.801 149.848L128.928 149.806L129.054 149.848H129.096L129.139 149.806L129.307 149.765L129.559 149.806L129.686 149.848H129.728L129.812 149.892L129.896 149.933H129.938L129.981 150.017L130.106 150.059H130.738L130.696 150.101L130.654 150.143H130.612H130.443L130.401 150.186L130.317 150.228L130.275 150.312L130.317 150.437L130.359 150.69V150.817L130.485 151.196V151.364L130.528 151.532V151.785L130.738 151.995H130.906L130.99 152.037H131.032L131.075 151.87L131.285 151.743L131.496 151.701H131.664L131.959 151.785H132.254H132.295L132.421 151.828L132.506 151.87L132.632 151.954V151.995L132.674 152.037L132.632 152.164L132.506 152.29L132.421 152.459L132.17 152.501H132.043H132.001L131.959 152.543V152.585L131.917 152.753L131.79 152.837L131.748 152.922L131.706 153.048L131.537 153.09L131.412 153.259V153.301L131.454 153.385V153.47L131.537 153.553L131.579 153.637L131.537 153.721H131.664L131.706 153.764V153.89L131.959 153.932L132.127 154.017V154.059H132.17L132.254 154.101L132.337 154.059L132.506 154.143H132.632L132.717 154.184H132.843L132.927 154.226L133.137 154.143H133.179L133.39 154.184L133.432 154.226L133.516 154.184H133.685L133.726 154.143L133.853 154.059L133.937 154.017V153.974H134.063L134.148 154.017V154.059L134.274 154.101L134.443 154.184H134.61L134.737 154.437V154.479L134.821 154.521V154.564V154.606L134.905 154.648V154.69L135.032 154.815V154.859H135.116L135.074 154.901H135.201V154.984H135.157H135.243V155.026H135.284V155.068L135.368 155.111L135.453 155.153H135.537V155.068H135.663L135.748 155.111V155.068L135.832 155.153H135.999L136.084 155.195V155.237L136.126 155.195V155.237L136.21 155.195H136.252V155.237H136.295V155.279L136.337 155.321V155.406H136.379L136.421 155.448L136.463 155.49H136.505L136.548 155.532H136.59L136.673 155.574V155.532L136.715 155.574V155.659L136.757 155.701H136.715L136.799 155.784H136.842H136.799V155.826H136.842L136.884 155.868H136.968L137.01 155.826L137.052 155.868H137.094L137.137 155.91V155.953V155.91L137.221 155.953H137.263L137.305 155.995L137.263 156.037V156.079L137.305 156.037L137.346 155.995L137.39 155.953V155.995H137.473L137.515 156.037H137.557H137.599L137.557 155.953L137.599 155.995L137.642 156.037H137.684H137.726V155.995L137.768 156.037H137.852V156.079H137.894L137.937 156.163H138.021L138.063 156.248V156.29H138.104L138.146 156.373H138.188V156.415L138.273 156.5H138.315V156.457H138.357H138.399L138.357 156.5V156.542H138.484L138.652 156.626H138.61L138.694 156.668H138.652L138.737 156.71L138.779 156.668L138.862 156.753H138.946H138.988H138.946V156.795H138.988V156.837L139.031 156.795L139.073 156.879H139.115L139.157 156.837L139.199 156.879H139.157L139.241 156.963L139.283 156.921L139.494 157.048L139.579 157.004H139.621L139.704 157.048H139.788V157.09L139.873 157.048L139.915 157.004H139.999V157.048H140.126L140.168 157.09H140.21H140.293L140.42 157.131H140.462V157.173L140.504 157.215H140.588L140.63 157.173L140.715 157.257L140.757 157.215H140.799L140.841 157.257H140.925H140.968L141.01 157.299H141.051L141.01 157.342H141.051V157.384H141.093L141.135 157.426H141.262V157.468V157.51L141.304 157.552V157.595L141.43 157.552L141.515 157.595H141.683V157.721H141.724L141.768 157.763L141.81 157.804L141.851 157.763V157.846L141.977 157.89L142.019 157.931L142.062 157.89H142.146V157.846H142.188H142.23L142.272 157.89L142.315 157.846V157.89H142.399L142.441 157.973L142.524 158.015H142.693L142.777 158.099H142.862L142.904 158.142H142.988H143.03V158.184L143.157 158.268V158.31L143.199 158.268L143.24 158.31L143.324 158.394V158.479H143.366L143.408 158.604L143.451 158.646V158.689L143.366 158.731L143.493 158.773L143.535 158.731L143.577 158.773L143.535 158.815H143.661V158.941H143.788L143.872 159.026L143.913 159.068L143.957 159.11V159.152L143.872 159.193L143.788 159.279V159.362L143.999 159.657L144.04 159.741V159.868V159.952H143.957H143.913L143.788 159.91H143.746L143.661 159.952L143.619 160.035L143.493 160.373L143.451 160.415L143.366 160.583L143.324 160.793L143.282 160.835V160.878L143.408 161.004L143.324 161.13L143.366 161.215V161.257L143.451 161.341V161.551V161.72L143.493 161.804L143.577 161.93V161.973V162.015V162.057L143.451 162.351L143.535 162.562V162.73L143.493 162.857L143.451 162.899L143.535 163.024L143.577 163.109V163.193L143.408 163.53L143.282 163.824L143.199 164.077L143.157 164.162L142.946 164.33L142.862 164.371L142.777 164.457L142.693 164.498H142.651L142.524 164.54L142.357 164.582H142.104L141.724 164.666L141.599 164.751L141.472 164.835H141.43L141.388 164.877L141.346 165.046L141.262 165.088L141.051 165.466V165.508L140.968 165.551L140.799 165.677L140.715 165.76L140.504 166.098L140.462 166.224L140.335 166.35L140.041 166.519L139.999 166.56L139.957 166.602V166.646L139.915 166.687L139.873 166.729L139.662 167.193L139.621 167.402L139.704 167.529V167.571V167.613L139.662 167.824V168.035L139.704 168.16L139.788 168.244L139.746 168.539L139.704 168.624L139.452 168.791H139.41H139.157L139.073 168.833L138.904 169.044L138.862 169.171L138.779 169.297V169.424L138.694 169.633L138.568 169.676L138.526 169.76H138.484L138.357 169.802H138.188L138.146 169.844L138.104 169.928L138.146 170.138L138.104 170.224L138.146 170.265L138.231 170.391L138.273 170.644L138.315 170.686L138.273 170.897L138.231 171.065V171.107V171.149V171.191L138.188 171.233L137.937 171.444L137.894 171.613L137.852 171.738L137.81 171.865L137.684 171.991L137.599 172.117L137.557 172.16L137.39 172.244H137.263L137.01 172.202H136.968L136.884 172.244L136.799 172.411L136.715 172.538L136.757 172.622L136.968 172.791V172.917L137.052 173.086V173.211V173.254L136.884 173.549L136.799 173.633L136.757 173.717L136.505 173.802L136.379 173.885L136.252 174.18V174.264L136.21 174.391L135.915 174.6L135.832 174.727L135.748 174.769V174.811H135.663L135.453 175.064L135.41 175.191L135.243 175.738L135.032 176.033L134.948 176.116L134.905 176.158L134.863 176.285L134.568 176.495L134.526 176.538L134.401 176.664L134.359 176.747H134.316L134.274 176.789L134.148 176.832L133.979 176.916L133.768 176.958L133.643 177.085L133.516 177.169L133.432 177.211L133.306 177.295L133.054 177.38L132.885 177.505L132.759 177.547L132.421 177.758L132.379 177.842L132.17 178.011L132.085 178.18H132.043L131.875 178.263L131.537 178.347L131.496 178.389H131.454L131.201 178.516L131.117 178.642L131.075 178.684L130.823 178.769L130.781 178.811L130.654 178.936L130.528 179.105L130.485 179.189V179.231V179.274L130.528 179.316L130.401 179.526H130.359L130.065 179.905L129.981 179.989L129.938 180.031H129.812H129.686V180.073H129.643L129.265 180.2L129.139 180.242L129.054 180.284L128.97 180.325L128.928 180.367L128.843 180.494L128.676 180.536H128.634V180.578L128.507 180.705L128.381 180.747L128.17 180.873L127.959 180.958L127.876 181L127.792 181.042L127.707 181.167V181.21L127.623 181.294L127.539 181.336L127.412 181.42L127.37 181.589L127.245 181.758V181.842V182.556L127.076 182.725V182.809L126.907 183.062L126.823 183.356L126.739 183.567V183.609L126.655 183.778L126.445 184.072L126.403 184.114L126.107 184.198L125.728 184.451L125.392 184.62L125.223 184.578L125.181 184.62L125.097 184.662V184.703L124.929 184.998V185.251L124.845 185.503L124.803 185.756L124.761 185.925L124.718 186.009L124.676 186.136L124.634 186.387V186.43L124.508 186.64L124.466 186.892L124.423 187.019L124.466 187.061L124.423 187.145L124.466 187.272V187.44L124.339 187.819L124.298 187.903L124.171 188.029L123.918 188.156L123.456 188.492L123.287 188.534H123.245L123.203 188.576L123.034 188.45V188.367L122.992 188.282V188.198L122.867 188.156L122.781 188.198L122.698 188.114L122.614 188.072L122.487 187.945L122.403 187.903L122.319 187.692V187.609L122.277 187.567L122.192 187.525L121.983 187.482L121.856 187.356V187.398H121.814H121.772L121.687 187.356H121.645L121.561 187.314L121.434 187.356V187.314L121.477 187.23L121.35 187.187V187.103L121.267 187.145L121.225 187.187H121.183L121.14 187.103H121.098L121.056 187.061H120.972L120.93 186.978H120.845L120.803 186.934L120.719 187.061L120.636 187.145V187.23L120.592 187.272L120.34 187.314V187.23H120.256L120.214 187.272H120.172L120.13 187.314H120.045V187.356L119.961 187.398L119.92 187.44L119.794 187.398L119.709 187.482V187.567L119.667 187.525L119.541 187.567L119.498 187.482H119.456L119.414 187.567H119.33V187.65H119.247V187.692V187.734L119.203 187.776L119.247 187.903H119.161V187.945L119.12 187.903H119.078H118.994L118.909 187.861L118.867 187.903L118.783 187.861L118.741 187.903L118.656 187.945L118.572 187.987L118.489 188.029H118.447L118.403 188.114L118.32 188.072V188.029L118.278 188.072L118.194 188.029L118.152 187.945L118.109 187.903L118.025 187.987H117.983V188.029L117.899 188.072H117.856L117.814 188.029L117.772 188.072L117.647 188.114V188.072H117.562L117.52 188.114V188.156H117.267L117.141 188.114V188.072H117.099V188.029H117.058L117.014 187.987L116.889 187.903H116.805L116.678 188.114H116.636L116.552 188.072L116.51 188.029H116.425V187.945H116.383L116.341 187.987H116.3L116.258 187.945H116.214L116.173 187.903V187.819V187.776H116.089L116.131 187.692L116.005 187.609L116.047 187.525L116.089 187.356L116.047 187.272V187.061V187.019L116.005 186.978L116.089 186.809V186.682L116.005 186.598H116.047L116.005 186.514L116.047 186.387L116.089 186.345L116.047 186.303H116.005L115.963 186.345L115.92 186.303L115.878 186.261L115.92 186.136L115.878 186.093H115.836V185.925L115.794 185.84L115.752 185.883L115.71 185.84L115.625 185.798V185.756L115.5 185.798L115.458 185.756V185.714V185.545L115.5 185.461V185.42L115.542 185.378L115.458 185.293V185.209L115.416 185.125V185.083L115.373 184.956L115.331 184.872H115.289V184.83V184.789H115.373L115.416 184.662L115.373 184.62L115.583 184.367L115.625 184.156L115.583 184.072H115.542V183.989L115.458 183.862L115.331 183.778L115.373 183.694L115.331 183.567V183.525L115.458 183.483L115.542 183.399L115.5 183.356H115.458L115.416 183.314L115.458 183.272L115.373 183.147H115.458L115.5 183.062L115.542 183.02L115.416 182.894V182.767L115.331 182.725L115.247 182.683H115.205L115.078 182.725V182.6V182.514L115.036 182.431L114.952 182.262H114.994V182.136L114.952 182.094L114.994 182.052L114.952 182.009L114.91 181.967L114.825 181.925L114.869 181.758L114.825 181.715L114.91 181.673L114.825 181.505V181.462V181.42H114.742L114.783 181.378L114.742 181.336L114.783 181.252L114.742 181.125V181.042L114.658 181L114.7 180.915L114.658 180.789L114.7 180.747V180.62V180.578V180.536L114.742 180.494V180.411L114.825 180.367V180.284L114.869 180.242L114.952 180.284V180.242L114.91 180.2V180.158L114.952 180.116V180.073L114.994 179.947L114.952 179.821L114.994 179.778L114.952 179.694V179.569L114.91 179.526V179.4L114.783 179.274L114.658 179.189L114.616 179.147H114.531L114.489 179.063L114.447 178.978L114.278 178.894L114.152 178.558V178.474L114.111 178.389L114.152 178.305H114.194V178.263L114.236 178.136L114.194 177.969L114.152 177.927L114.194 177.884L114.152 177.842L114.025 177.8L113.984 177.842L113.942 177.8L113.9 177.842L113.858 177.8L113.774 177.758L113.816 177.674V177.632L113.647 177.547L113.605 177.422L113.563 177.253L113.48 177.169H113.227L113.1 177.127L113.058 177.169L113.016 177.127L112.931 177.169L112.889 177.211H112.847H112.763L112.68 177.127L112.553 177.169V177.253H112.511L112.469 177.211L112.3 177.169L112.216 177.127H112.174L112.132 177.169H112.047L112.005 177.211L112.047 177.169H112.005H111.963L111.836 177.085H111.795V177.127L111.753 177.169H111.711H111.627H111.585L111.542 177.211L111.5 177.169V177.127H111.416V177.169L111.374 177.085L111.332 177.127H111.291H111.247V177.085L111.122 177V176.916L111.08 176.874H110.953L110.911 176.832L110.869 176.874L110.785 176.789L110.7 176.747L110.658 176.705L110.616 176.747L110.532 176.664V176.622H110.491L110.447 176.538V176.495H110.405V176.453L110.364 176.495L110.322 176.453L110.28 176.327V176.285V176.243V176.158L110.196 176.116H110.238L110.196 176.074V176.033L110.111 175.991L110.153 175.947V175.822L110.111 175.864H110.069H109.985V175.906L109.943 175.864L109.901 175.906L109.858 175.864L109.816 175.906L109.774 175.864V175.906H109.733V175.864H109.691V175.906L109.649 175.864L109.606 175.947H109.48L109.438 175.991V176.033H109.353V176.116L109.311 176.158V176.2L109.353 176.243H109.311V176.327L109.227 176.285V176.369H109.269L109.143 176.453V176.538L109.102 176.58L109.143 176.622H109.102L109.058 176.705L109.016 176.664H108.975V176.705H108.933L108.891 176.747L108.849 176.705V176.747L108.807 176.789V176.832L108.68 176.916H108.638H108.596L108.638 177.042H108.596L108.554 177L108.469 176.958L108.385 176.916L108.343 176.832V176.789V176.747L108.302 176.789V176.747H108.258H108.216V176.789L108.258 176.832V176.874H108.216V176.916L108.175 176.958L108.091 177.042L108.007 177L108.049 176.958L108.007 176.916L107.964 176.874L107.922 176.916H107.88H107.838V176.958L107.754 177H107.712V176.958H107.669L107.712 176.916H107.669L107.585 176.958V177.042V177.085V177.169L107.502 177.211L107.46 177.253L107.375 177.295H107.333L107.291 177.211H107.249L107.165 177.169L107.122 177.127L107.165 177.042L107.122 176.958H107.08L106.996 177V177.042L106.954 177.085L106.913 177.042L106.869 177H106.913H106.869L106.827 176.958L106.786 177H106.702L106.66 176.958L106.618 176.874L106.533 176.916H106.449L106.407 176.874L106.449 176.832L106.407 176.789L106.322 176.874L106.28 176.832L106.238 176.874H106.154L106.113 176.916L106.071 176.874V176.832H105.986L106.027 176.916H105.986H105.902L105.86 176.958L105.818 176.916L105.775 176.958H105.733L105.691 176.916L105.733 176.789L105.649 176.832L105.523 176.789L105.438 176.832L105.396 176.789L105.355 176.832H105.313H105.271L105.228 176.874V176.832L105.186 176.789V176.747L105.144 176.705L105.102 176.747H105.06V176.705V176.747V176.789L105.102 176.832H105.018V176.874L104.891 176.958L104.807 176.874H104.68V176.832L104.638 176.874V176.832L104.597 176.789H104.555V176.747L104.471 176.789V176.832L104.386 176.874L104.429 176.916H104.386L104.302 176.874V176.832L104.26 176.874V176.832H104.218L104.176 176.789L104.133 176.832H104.049V176.789H104.007L104.049 176.705H103.965V176.664L103.924 176.705V176.664L103.797 176.622L103.713 176.664L103.755 176.622H103.671L103.587 176.538L103.544 176.58V176.622V176.538L103.502 176.58L103.46 176.538L103.376 176.58H103.334V176.538H103.249L103.166 176.453H103.124L103.082 176.495L102.997 176.538L102.829 176.495H102.787L102.744 176.411V176.285V176.243L102.702 176.285V176.243H102.66V176.2H102.618V176.158H102.576L102.618 176.116L102.576 176.033V175.991V175.947L102.408 176.033H102.24L102.197 175.991L102.113 175.906L102.071 175.947H101.987V175.991L101.944 176.033V176.074L101.86 175.991L101.818 176.033H101.776V176.116H101.818V176.2L101.735 176.243H101.693H101.649L101.524 176.158L101.482 176.2L101.44 176.327H101.398L101.355 176.243H101.313L101.271 176.158L101.229 176.116L101.018 176.2L101.06 176.243L100.977 176.2H100.893L100.85 176.158H100.766H100.598L100.64 176.074L100.598 176.033L100.555 175.906H100.471L100.429 175.864L100.387 175.947H100.304L100.26 175.906L100.219 175.947L100.26 175.738L100.219 175.695H100.135V175.611L100.177 175.527L100.387 175.4V175.358V175.233L100.471 175.149L100.555 174.853V174.769H100.513L100.471 174.727L100.598 174.643H100.682L100.724 174.6L100.682 174.558L100.346 174.391V174.349L100.471 174.306L100.598 174.264L100.724 174.011V173.885H100.64L100.555 173.802L100.513 173.758V173.717L100.555 173.633L100.808 173.464L100.893 173.38V173.338L100.64 173.211L100.598 173.127L100.513 172.96L100.598 172.833L100.724 172.791V172.749L100.64 172.664L100.429 172.58L100.387 172.454V172.327L100.429 172.202L100.513 172.16L100.598 172.033L100.64 171.949V171.865L100.724 171.655L100.766 171.528L101.018 171.233L101.06 171.149L101.102 171.022L101.06 170.98L100.808 170.938L100.724 170.855L100.64 170.771L100.682 170.728L101.06 170.475L101.102 170.391V170.18L101.018 169.844V169.802L101.145 169.591L101.018 169.38L100.977 169.213L101.102 169.129L101.229 168.918L101.313 168.833L101.271 168.749V168.582V168.539H101.187L101.102 168.624H101.018L100.977 168.582L100.893 168.413L100.85 168.371L100.766 168.329L100.682 168.371L100.598 168.329L100.64 168.244L100.766 168.16L101.018 167.991L101.06 167.866L101.018 167.782L100.808 167.613H100.724L100.598 167.697H100.513L100.429 167.655V167.613L100.513 167.402L100.598 167.36L100.682 167.318L100.935 167.36H101.018V167.318L100.977 167.235L100.935 167.15L100.766 166.94L100.724 166.855L100.682 166.813H100.64H100.598L100.471 167.066H100.26V166.982V166.94L100.304 166.813L100.346 166.687V166.646H100.219L100.093 166.477V166.35L100.177 166.224L100.051 165.846L100.093 165.677L100.219 165.466V165.382L100.051 165.129L99.7983 165.088L99.6294 164.961L99.5456 164.666L99.5875 164.54L99.6294 164.33V164.246L99.5875 164.204L99.5456 164.162H99.4186L99.3767 164.204L99.2929 164.288V164.33L99.1659 164.246L99.124 164.077L99.1659 164.035L99.2091 163.951L99.3767 163.909L99.4186 163.824L99.3767 163.782L99.3348 163.74H99.1659L99.124 163.698V163.657L99.1659 163.613L99.2091 163.53H99.3348L99.4605 163.488L99.5037 163.362L99.6294 163.277L99.8821 163.235V163.193L99.9658 162.982L100.051 162.94H100.177H100.26L100.346 162.899L100.429 162.73L100.513 162.688H100.555L100.64 162.73L100.766 162.857L100.85 162.688L101.018 162.477L101.06 162.393L99.3348 161.046L99.9658 159.699Z"
							fill="#1169bc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="MG" @mouseenter="e => hoverES(e, 'MG')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M143.366 161.217L143.324 161.132L143.408 161.006L143.282 160.88V160.837L143.324 160.795L143.366 160.585L143.451 160.417L143.493 160.375L143.619 160.037L143.661 159.953L143.746 159.912H143.788L143.914 159.953H143.957H144.041V159.87V159.743L143.999 159.659L143.788 159.364V159.281L143.872 159.195L143.957 159.154L144.166 159.239L144.546 159.364H144.588L144.672 159.281V159.239L144.588 159.112L144.377 158.943L144.335 158.901L144.377 158.817V158.775L144.461 158.691L144.503 158.523L144.588 158.396V158.27L144.63 158.186V158.144L144.713 158.017L144.882 157.848H145.008L145.135 157.681L145.177 157.597V157.554V157.47L145.219 157.386L145.555 157.301L145.597 157.217L145.555 157.092L145.597 157.05H145.682H145.766H146.144L146.23 156.965L146.397 156.881V156.839H146.44L146.524 156.67L146.692 156.417V156.25L146.65 156.208L146.692 156.081L146.608 155.87V155.786L146.692 155.744L146.861 155.661H146.902L147.029 155.492L147.155 155.155V155.113L147.197 155.07L147.324 155.028H147.408L147.45 154.986L147.577 154.65L147.786 154.355L147.871 154.27L147.955 154.228L147.997 154.186L148.081 154.145L148.208 154.103L148.419 154.145H148.544L148.755 154.019L149.26 154.103L149.386 153.976L149.471 153.892L149.555 153.681L149.597 153.639H149.681H149.891L149.933 153.723L150.186 153.766H150.355L150.481 153.681H150.522L150.566 153.723L150.608 153.766H150.691L150.775 153.85H150.902L151.028 153.892H151.07H151.113L151.155 153.808L151.197 153.723L151.28 153.681L151.364 153.723H151.407L151.491 153.681L151.617 153.597L151.702 153.555H151.786H151.828L151.955 153.639H151.997L152.038 153.555L151.911 153.428L151.955 153.386V153.345L152.08 153.303L152.417 153.261L152.502 153.303L152.544 153.261H152.586V153.219L152.628 153.177L152.586 153.008L152.628 152.966H152.67L152.755 152.924L152.88 152.966H152.922L152.964 153.008V153.05V153.177V153.261L153.006 153.386L153.302 153.681L153.386 153.892H153.428L153.511 153.934L153.638 153.892L153.68 153.85L153.722 153.723L153.849 153.597L153.933 153.386H153.975L154.1 153.428L154.144 153.386L154.186 153.261L154.227 153.219L154.269 153.177H154.311L154.438 153.134L154.48 153.008L154.564 152.839L154.648 152.755L154.733 152.714L154.775 152.672V152.628V152.587L154.648 152.503V152.461L154.691 152.419L154.817 152.461L154.986 152.419L155.027 152.377L155.195 152.25H155.322V152.292L155.28 152.334V152.377H155.364L155.406 152.419H155.49V152.461L155.658 152.377L155.7 152.292V152.208L155.827 152.124L155.953 152.166H155.995L156.038 152.082H156.08V151.956H156.122L156.164 151.914L156.248 151.872L156.375 151.745H156.5L156.542 151.83H156.711L156.753 151.914L156.964 151.956L157.006 151.997L157.048 152.208H157.131L157.216 152.082L157.3 152.039L157.384 152.082L157.511 151.997L157.637 152.039L157.764 151.997L157.847 152.039L157.931 151.997H158.016H158.1H158.184V151.956V151.914L158.226 151.872L158.478 151.914H158.522L158.564 151.872H158.689L158.731 151.914V151.997L158.773 152.039H158.9L158.984 152.124L159.111 152.039H159.153L159.195 152.082L159.153 152.166L159.195 152.208L159.405 152.082L159.489 152.124L159.573 152.082H159.616H159.658V152.166H159.7H159.911L159.995 152.124L160.036 152.166H160.078H160.12L160.162 152.25H160.247H160.289V152.208L160.205 152.166V152.124L160.373 151.997L160.458 151.914H160.5H160.542L160.584 151.997H160.753V152.082L160.794 152.124H160.962L161.089 152.166H161.173V152.25L161.257 152.334V152.419L161.384 152.461L161.467 152.503L161.594 152.545H161.636H161.72L161.762 152.503L161.805 152.419H161.847L161.889 152.461L161.931 152.545L162.015 152.587L162.1 152.628V152.672L162.142 152.714H162.184L162.309 152.628V152.672V152.755V152.839H162.351H162.394V152.966L162.436 153.008L162.478 152.966L162.562 152.924H162.604L162.647 152.797L162.689 152.755L162.856 152.839L162.9 152.797L162.942 152.839H162.983L163.025 152.797V152.755L162.983 152.714L163.025 152.672V152.628L163.067 152.587L163.109 152.628L163.194 152.672H163.236V152.628L163.194 152.587L163.236 152.503V152.419L163.32 152.377L163.362 152.334L163.404 152.377H163.446L163.404 152.419L163.446 152.461H163.489L163.531 152.503L163.615 152.461L163.656 152.419H163.742V152.377L163.698 152.334L163.742 152.25L163.783 152.208H163.825L163.783 152.124H163.951V152.208H163.993H164.036L164.12 152.124V152.082H164.162H164.204L164.289 151.872H164.331L164.373 151.914V151.956L164.456 151.914H164.498V151.872L164.583 151.787L164.498 151.745L164.456 151.661L164.414 151.619L164.456 151.577L164.54 151.534L164.498 151.45L164.583 151.408V151.45L164.625 151.492V151.45V151.408V151.366L164.709 151.283H164.751H164.793L164.709 151.239H164.793L164.836 151.197L164.878 151.114H164.92L165.004 151.03H165.045V151.072V151.197V151.239L165.087 151.283V151.239V151.197L165.172 151.156V151.072L165.256 151.03L165.298 151.072L165.34 151.03H165.383L165.34 150.988L165.383 150.945V150.903L165.467 150.945V150.903H165.509L165.593 150.819H165.635L165.678 150.861H165.72V150.819L165.678 150.777L165.72 150.692H165.804V150.735L165.845 150.692H165.931V150.65H165.845L165.931 150.608V150.525L165.972 150.566L166.014 150.525H166.098V150.483L166.182 150.439V150.398H166.14V150.314L166.225 150.356L166.267 150.314L166.393 150.23H166.435L166.52 150.272L166.478 150.188H166.52H166.562L166.603 150.145V150.061L166.562 149.977H166.52H166.562L166.52 149.935L166.562 149.893L166.52 149.85L166.435 149.808V149.767H166.393V149.683V149.641H166.435V149.556L166.309 149.472V149.388H166.267V149.345L166.225 149.303H166.267L166.225 149.261L166.267 149.219H166.225L166.267 149.177L166.225 149.135H166.182L166.14 149.094H166.182L166.14 149.05L166.182 148.967L166.14 148.925V148.883V148.841L166.098 148.756L166.056 148.714L166.098 148.672L166.14 148.63L166.182 148.588H166.225L166.14 148.546H166.182L166.225 148.503L166.182 148.461V148.419L166.267 148.377V148.336L166.309 148.294V148.252L166.267 148.209V148.167L166.309 148.125L166.393 148.041L166.435 147.956V147.872L166.478 147.83H166.52V147.788H166.603L166.687 147.704V147.661V147.619H166.645V147.578V147.494H166.729V147.367V147.283L166.687 147.199L166.603 147.072L166.478 146.946L166.435 146.861L166.393 146.778L166.309 146.736L166.182 146.778L166.056 146.736L165.972 146.694H165.887L165.804 146.736L165.593 146.778L165.551 146.819H165.509H165.467L165.425 146.652L165.34 146.778L165.298 146.736H165.256V146.694V146.567V146.483L165.214 146.441L165.172 146.357L165.045 146.314H165.004L165.045 146.23H165.131V146.147V146.105H165.087V146.063L165.045 146.02H165.131V145.978H165.087V145.936L165.045 145.894H165.087V145.852V145.81L165.131 145.852L165.172 145.81V145.683L165.131 145.641L165.256 145.557H165.214V145.472V145.515L165.298 145.557V145.599H165.34V145.641L165.467 145.599L165.509 145.683L165.551 145.641L165.509 145.599H165.593V145.641L165.635 145.599L165.551 145.515H165.593V145.472H165.635L165.678 145.43L165.762 145.472V145.43L165.72 145.347L165.762 145.305V145.263L165.72 145.221H165.678V145.178L165.804 145.136V145.094L165.762 145.052H165.845V145.01V144.968H165.931L165.972 145.01L166.014 144.968L165.972 144.925H166.014L165.972 144.841L166.014 144.799H166.056H166.14V144.757V144.716L166.182 144.674V144.716H166.225V144.674L166.182 144.63L166.14 144.589H166.182H166.225H166.267L166.182 144.547L166.225 144.505L166.182 144.463H166.309L166.351 144.421L166.309 144.378L166.351 144.336V144.378L166.435 144.336L166.478 144.421L166.52 144.378L166.478 144.336L166.562 144.294L166.645 144.336L166.603 144.252L166.645 144.21V144.168H166.687L166.645 144.126L166.687 144.041L166.729 144.126V143.999L166.772 144.041V143.999L166.814 144.041H166.856V143.916V143.958L166.898 143.916L166.94 143.958H166.982H166.94V143.916H166.982V143.874L167.109 143.916L167.067 143.874L167.109 143.831L167.151 143.874L167.193 143.831H167.151V143.789H167.193L167.234 143.747V143.789L167.276 143.747H167.234V143.621H167.276V143.663L167.361 143.705L167.32 143.663H167.361V143.621L167.403 143.579V143.621V143.579L167.445 143.621V143.579H167.487L167.445 143.536H167.487H167.529L167.487 143.494L167.571 143.452V143.41L167.487 143.452V143.41H167.529V143.368H167.445L167.571 143.326L167.614 143.283L167.571 143.241L167.487 143.2V143.158L167.445 143.2L167.403 143.158L167.445 143.116L167.361 143.074L167.403 143.032L167.361 142.989L167.32 143.032V142.989L167.276 142.947L167.403 142.905L167.361 142.863H167.32L167.276 142.779H167.234L167.151 142.821L167.193 142.736H167.151L167.109 142.694H167.151L167.193 142.652H167.151V142.61H167.109L167.067 142.527H167.151V142.485L167.109 142.358L167.193 142.274L167.067 142.316V142.274L167.109 142.232L167.025 142.189V142.147V142.105V142.063V142.021V141.979H166.94V141.894H166.982H166.94L166.898 141.852L166.94 141.769L166.982 141.727L166.94 141.685H166.982V141.642V141.558L166.898 141.516H166.856H166.814L166.856 141.474V141.347L166.814 141.39L166.772 141.347L166.856 141.305L166.814 141.263H166.772H166.814L166.772 141.179L166.729 141.221L166.687 141.263L166.645 141.221V141.137H166.603V141.096V141.052L166.562 141.096V141.011H166.52L166.478 141.052V141.011L166.435 140.927L166.393 140.969L166.435 140.885L166.393 140.843V140.885L166.309 140.969L166.267 140.927L166.309 140.885L166.267 140.843H166.309H166.267V140.8H166.182V140.758L166.098 140.8V140.843H166.056V140.8V140.716H165.972V140.758L165.931 140.716V140.674H165.887H165.804L165.845 140.632H165.804L165.845 140.59H165.804L165.845 140.547L165.804 140.505L165.762 140.547L165.72 140.505V140.547L165.678 140.505L165.72 140.463H165.635V140.379L165.593 140.296L165.551 140.252V140.211V140.127V140.001L165.593 139.958L165.635 139.874L165.72 139.832L165.762 139.705L165.72 139.538L165.762 139.496L165.804 139.453L165.887 139.411L166.014 139.201L166.056 139.116H166.098L166.14 138.99L166.182 138.948V138.863L166.225 138.822L166.182 138.78L166.225 138.696L166.309 138.654V138.611H166.351L166.393 138.485L166.351 138.358H166.393L166.351 138.316L166.309 138.274H166.351L166.309 138.19H166.267L166.309 138.149V138.107L166.267 138.063H166.225L166.267 138.022L166.225 137.98L166.267 137.938H166.225V137.896L166.182 137.854L166.267 137.812V137.769H166.309L166.267 137.727L166.309 137.685V137.643V137.601V137.559L166.351 137.601V137.559H166.393V137.601L166.435 137.559V137.516H166.478V137.474L166.435 137.432L166.478 137.391V137.349V137.307V137.264H166.435L166.478 137.222H166.435L166.52 137.18V137.096V137.138V137.096H166.562H166.603V137.054L166.645 137.096V137.054V137.096H166.772L166.814 137.138L166.898 137.096H166.94H166.982H167.025V137.054L167.067 137.012L167.109 136.969V136.927H167.151V136.885H167.193H167.234V136.843V136.801L167.276 136.843H167.32L167.361 136.801H167.32H167.361L167.32 136.759H167.361H167.32V136.718H167.361H167.32L167.361 136.633L167.403 136.674V136.633H167.445V136.591H167.487L167.529 136.549H167.487H167.529L167.571 136.591L167.529 136.674L167.614 136.633L167.698 136.718L167.74 136.759L167.782 136.718L167.824 136.759L167.867 136.718L168.034 136.591L168.624 136.465L169.465 136.254H169.55V136.212L169.592 136.17V136.085L169.465 135.874L169.509 135.833L169.465 135.791L169.55 135.623L169.465 135.412V135.285L169.34 135.16L169.256 134.991L169.298 134.78L169.256 134.696L169.298 134.612V134.57L169.129 134.529V134.485H169.087L169.003 134.402L168.876 134.36L168.709 134.233V134.149V133.938L168.792 133.685V133.434L168.918 133.265L169.003 133.181L169.087 133.14L169.213 133.096L169.298 133.013V132.971L169.171 132.929L169.256 132.844H169.34L169.382 132.676L169.171 132.423H169.045V132.129H169.003H168.961L168.918 132.171L168.834 132.255L168.751 132.087L168.792 132.045L168.751 131.918L168.876 131.749L168.918 131.623L169.003 131.455L169.045 131.371L169.087 131.329L169.003 131.287V131.202L168.918 131.16L168.834 131.076V130.992L168.876 130.951L169.213 130.74L169.256 130.655L169.465 130.698L169.718 130.74L169.887 130.824L170.056 130.865L170.223 130.951L170.35 130.992L170.518 131.118L170.603 131.16L170.687 131.202L170.813 131.16H170.854L170.94 131.118L171.023 131.16L171.107 131.076L171.149 131.034H171.192L171.276 130.951H171.318L171.402 130.992L171.445 130.951L171.402 130.782L171.36 130.74V130.698L171.276 130.655L171.318 130.529L171.36 130.487V130.445V130.403L171.276 130.36L171.234 130.318V130.234L171.192 130.151L171.234 129.94L171.276 129.856L171.36 129.645L171.276 129.518H171.234L171.107 129.476V129.434V129.393L171.065 129.309V129.224L171.192 129.14V129.014H171.234L171.36 128.971L171.402 128.929L171.445 128.887L171.402 128.803L171.445 128.718L171.529 128.762L171.654 128.718V128.762L171.698 128.887H171.823L171.907 129.014L172.076 129.098L172.244 129.266H172.287L172.329 129.309H172.371L172.496 129.351V129.434H172.581V129.56V129.645L172.623 129.687H172.707L172.665 129.813L172.623 129.856V129.898L172.581 129.982H172.623L172.665 130.024H172.749V130.107L172.792 130.151H172.96L173.043 130.107H173.129L173.17 130.234H173.254V130.192H173.296L173.465 130.276L173.591 130.151L173.549 130.024H173.591V130.066L173.676 130.151H173.718L173.76 130.107H173.843L173.887 130.192H173.928H174.012L174.054 130.151L174.096 129.982L174.181 130.024L174.265 129.898L174.307 129.813H174.349V129.856H174.433L174.56 129.982L174.518 130.151H174.601L174.643 130.234L174.77 130.276V130.403V130.571L174.728 130.613V130.655V130.865L174.518 131.076L174.476 131.118V131.202L174.391 131.245V131.329L174.307 131.371L174.265 131.455V131.498L174.307 131.54V131.623L174.265 131.665V131.707L174.181 131.749H174.096V131.792H174.012L173.97 131.834H173.843V131.918L173.97 132.002V132.129L174.012 132.213L174.054 132.171V132.213L174.096 132.296L174.265 132.255L174.223 132.213L174.265 132.171L174.307 132.129L174.349 132.087V132.002L174.391 131.96V131.918V131.876H174.518H174.56H174.601H174.685L174.728 131.749L174.685 131.707H174.77V131.582L174.854 131.498L175.065 131.455L175.359 131.623L175.401 131.582H175.443V131.54H175.527L175.57 131.498H175.612V131.413H175.654V131.371H175.696L175.738 131.329L175.823 131.371L175.907 131.329L175.99 131.371H176.074H176.117H176.201L176.243 131.329V131.371V131.329H176.285V131.287H176.327V131.245V131.202L176.37 131.245V131.202H176.454H176.496V131.16H176.538H176.58V131.118L176.665 130.992L176.707 130.907L176.665 130.865L176.707 130.782H176.749V130.824L176.79 130.698L176.832 130.74V130.782L176.917 130.74L176.959 130.698L177.001 130.571H177.043V130.529H177.085V130.445L177.127 130.487V130.445L177.254 130.318V130.276H177.338L177.38 130.234H177.421H177.465L177.548 130.318H177.59L177.674 130.276L177.759 130.36L177.885 130.276H177.927V130.318H177.969V130.276L178.012 130.234H177.969L178.054 130.192L178.096 130.107H178.138V130.151H178.179L178.306 130.066L178.432 129.94H178.474V129.898V129.856L178.516 129.813V129.771L178.558 129.813H178.601V129.771V129.729H178.727L178.769 129.645L178.811 129.687L178.854 129.603L178.811 129.518L178.854 129.56H178.896V129.518H178.938H179.021L178.979 129.476V129.434L179.063 129.393L179.106 129.309L179.148 129.351L179.19 129.266L179.232 129.224L179.274 129.266L179.358 129.182V129.098L179.443 129.056L179.485 128.971L179.61 129.014V128.971H179.652H179.696V128.929L179.779 128.887L179.737 128.929L179.821 128.971L180.2 129.014H180.243L180.285 128.971L180.368 128.845L180.452 128.676L180.495 128.635V128.676L180.537 128.635V128.551L180.79 128.466V128.424L180.874 128.466V128.424V128.382H180.958L180.916 128.34L181 128.256L181.043 128.298L181.085 128.256H181.127V128.214H181.168L181.294 128.171V128.129H181.337V128.087H181.421L181.463 128.045H181.547V128.003V128.045L181.632 127.92H181.674H181.716H181.758V127.835L181.716 127.877H181.674V127.835V127.793L181.716 127.835V127.793V127.709L181.758 127.667H181.799H181.885L181.841 127.624H181.799L181.841 127.582L181.799 127.54H181.841L181.885 127.498L181.799 127.456V127.414L181.926 127.456L181.968 127.414L181.926 127.371H182.01H182.052V127.329H182.094L182.136 127.287H182.221H182.263V127.245L182.305 127.287L182.347 127.245V127.204H182.389L182.474 127.162V127.077L182.516 127.12L182.557 127.035V127.077H182.599H182.641V126.993H182.684V126.909H182.726V126.867L182.81 126.951V126.867L182.852 126.909L182.894 126.867L182.852 126.825L182.894 126.74H182.936L182.979 126.782L183.021 126.74H182.979L183.021 126.698L183.063 126.74L183.105 126.614H183.147L183.189 126.573H183.23H183.274L183.357 126.487L183.399 126.446V126.487V126.446H183.441H183.483V126.404H183.526V126.362L183.61 126.404V126.32H183.694H183.779L183.821 126.277V126.32L183.863 126.277L183.905 126.32H183.947L183.988 126.277L184.03 126.235H184.074V126.193L184.115 126.235L184.157 126.193L184.241 126.151L184.325 126.067L184.452 126.025L184.494 125.982H184.536H184.578V126.025L184.621 125.982V125.94L184.663 125.982L184.705 125.94H184.746L184.788 125.898H184.83L184.788 125.856H184.873V125.814L184.999 125.773L185.125 125.856L185.168 125.814H185.21H185.252H185.294H185.419L185.463 125.898V125.856H185.419L185.463 125.814L185.505 125.856V125.814V125.773H185.63V125.731V125.688L185.672 125.731V125.814H185.715V125.856H185.841L185.925 125.94H185.968V125.856L186.136 125.898V125.982H186.094L186.136 126.025L186.219 125.982L186.263 125.856H186.304V125.94L186.346 125.982H186.388L186.43 125.94V125.982H186.472V125.94H186.514V125.982V126.025H186.557H186.599L186.641 125.982V126.025H186.683L186.725 126.067V126.025L186.767 126.067L186.81 125.982H186.894V125.94H186.935H187.061H187.019L187.104 125.982V126.025L187.146 125.982H187.188L187.23 126.067H187.272V126.151V126.067H187.314L187.357 126.151L187.399 126.109L187.441 126.151V126.109H187.483L187.525 126.151V126.109L187.567 126.151V126.109H187.608L187.652 126.151V126.109V126.193H187.735L187.777 126.235V126.193L187.819 126.235L187.904 126.193V126.235H187.861L187.904 126.277L187.946 126.235V126.277L187.988 126.193L188.072 126.235H188.114L188.072 126.277H188.114V126.32L188.156 126.277L188.199 126.362H188.283L188.325 126.404L188.199 126.573V126.614L188.114 126.698L188.03 126.993L187.988 127.12L187.946 127.162L187.777 127.54L187.735 127.793V127.835L187.694 127.962V128.003V128.045L187.735 128.003V128.129H187.777V128.214L187.694 128.256L187.777 128.298H187.694H187.735L187.694 128.34H187.735L187.694 128.382L187.735 128.424V128.382H187.777V128.466H187.819L187.861 128.509H187.946L188.199 128.593H188.325L188.366 128.635H188.408H188.452L188.493 128.676H188.661L188.703 128.718L188.746 128.762V128.803L188.703 128.845V128.887H188.788L188.83 128.845H188.914V128.887H188.956H188.999L189.041 128.929L189.083 128.971L189.293 129.014L189.377 129.056H189.419L189.503 129.014H189.588L189.63 129.098L189.841 129.224L189.883 129.266H189.841V129.351L189.883 129.434H189.924L189.966 129.351L190.008 129.393V129.309H190.093L190.135 129.266H190.177H190.219H190.261V129.224L190.177 129.14L190.219 129.098H190.303L190.345 129.056L190.303 128.971L190.345 128.929H190.43V128.887L190.472 128.845H190.514L190.555 128.803L190.597 128.845L190.724 128.762L190.892 128.676H190.935H191.019L191.103 128.593L191.145 128.551H191.186L191.272 128.509L191.313 128.551H191.397L191.439 128.509V128.466L191.734 128.424H191.777H191.903L191.945 128.382H191.986L192.072 128.424V128.382L192.239 128.466H192.366L192.45 128.551H192.492V128.509L192.534 128.551L192.619 128.593L192.661 128.676L192.703 128.635H192.744L192.786 128.551L192.828 128.635H192.871L192.955 128.593H192.997V128.635L193.124 128.718L193.166 128.676L193.292 128.718L193.334 128.676L193.461 128.762H193.544L193.586 128.803L193.628 128.929V128.971H193.671L193.713 129.014V128.971L193.755 129.098H193.797V129.056L193.839 129.098L193.881 129.14H193.923L193.966 129.098L194.008 129.14H193.966V129.182L194.05 129.224L194.092 129.309H194.175V129.351L194.217 129.393L194.386 129.518L194.47 129.603L194.681 129.645L194.723 129.729L194.808 129.813L194.892 129.856V129.898L194.975 129.856H194.933H195.017V129.898H195.06L195.017 129.94L195.102 129.982L195.144 130.024L195.186 129.982L195.27 130.066V130.024L195.312 130.107H195.355H195.312L195.439 130.192L195.523 130.276L195.564 130.192L195.65 130.107L195.733 130.151L195.775 130.192L195.817 130.234L195.902 130.36H195.944L196.07 130.403V130.487H196.155H196.197L196.323 130.571L196.45 130.74H196.659V130.824L196.617 130.992L196.786 131.034L196.912 131.118L197.039 131.076L197.081 131.118L197.164 131.245L197.291 131.118H197.333L197.375 131.202L197.417 131.245L197.586 131.287L197.628 131.371L197.67 131.329L197.753 131.413L197.839 131.329L197.964 131.245L198.049 131.287L198.133 131.245L198.175 131.287L198.259 131.245V131.16H198.301L198.344 131.245H198.428V131.329L198.47 131.371L198.512 131.413L198.595 131.455L198.68 131.54L198.722 131.665H198.764V131.792H198.806H198.848L198.933 131.749L199.186 131.665L199.395 131.623L199.438 131.665H199.522L199.69 131.749L199.817 131.707V131.623H199.901L199.942 131.582H200.028L200.069 131.54L200.153 131.498L200.195 131.371H200.28L200.364 131.329L200.533 131.287L200.575 131.245H200.617L202.131 132.634L202.721 133.181L203.184 133.644L203.353 133.771V133.812L203.479 134.696L203.521 135.37H203.564H203.689L203.773 135.327H203.815L203.9 135.412L204.026 135.37L204.111 135.327H204.237L204.362 135.412H204.406L204.531 135.454L204.615 135.496L204.7 135.538L204.742 135.496L204.784 135.37H204.826L204.995 135.327L205.12 135.202L205.247 135.243L205.373 135.16H205.542L205.668 135.033H205.71V134.907L205.753 134.865L205.795 134.823V134.738L205.878 134.823H205.962H206.004H206.047H206.131L206.173 135.033H206.257H206.299L206.468 134.991L206.509 134.949L206.551 134.991L206.595 134.907H206.636V134.78V134.738H206.72V134.78L206.889 134.865L206.931 134.949L206.889 135.033L206.931 135.118L207.015 135.16L207.142 135.118L207.184 135.076H207.226L207.184 134.991L207.226 134.907H207.309L207.393 134.865H207.436V134.907H207.478L207.562 135.033V135.076L207.689 135.118L207.773 135.285H207.815L207.857 135.202H207.899L207.984 135.327H208.026L208.067 135.37V135.412L208.026 135.454L208.109 135.496V135.538L208.278 135.58L208.236 135.665L208.278 135.749H208.362L208.446 135.707H208.573V135.623L208.615 135.538L208.698 135.496L208.74 135.538L208.784 135.58L208.825 135.538L208.909 135.412L208.951 135.454H208.993L209.12 135.58L209.162 135.749L209.204 135.791V135.749L209.288 135.833V135.791L209.331 135.833H209.415L209.457 135.874L209.498 135.833L209.582 135.791L209.625 135.833H209.667L209.709 135.874L209.751 135.833H209.793H209.835H209.962L210.046 135.791L210.088 135.833L210.131 135.791H210.173H210.215L210.298 135.749H210.34L210.382 135.833V135.874H210.425V135.96H210.467V136.001H210.509V136.085H210.551V136.127L210.593 136.085L210.72 136.17H210.762V136.338L210.677 136.38L210.72 136.422L210.762 136.38V136.422H210.804V136.38H210.846H210.887L210.929 136.338V136.422H210.973L211.056 136.38L211.098 136.422H211.14H211.182V136.38L211.267 136.338V136.38L211.224 136.465L211.267 136.507H211.309L211.351 136.422H211.393L211.351 136.549V136.507V136.591H211.309V136.633L211.351 136.591L211.393 136.633V136.674L211.435 136.718H211.393V136.759H211.477L211.52 136.801H211.477L211.52 136.843H211.562H211.604L211.562 136.885H211.604V136.927H211.646V136.885H211.687L211.729 136.969H211.771V137.012H211.814V136.969H211.898V137.054H212.024V136.969H212.067H212.235L212.277 137.012H212.318H212.277L212.193 137.138V137.18H212.277L212.404 137.307V137.391L212.487 137.432L212.529 137.516V137.601H212.614V137.685L212.656 137.727V137.812L212.529 137.896V137.938H212.487L212.445 137.896H212.404L212.445 137.98H212.487L212.529 138.063L212.487 138.232L212.404 138.274V138.316L212.318 138.358V138.401L212.193 138.569L212.235 138.654L212.277 138.696L212.318 138.822H212.193L212.151 138.863L212.067 138.907L212.024 139.074H211.982L211.94 139.032H211.898V138.99H211.856L211.814 139.032V139.116L211.729 139.158V139.201L211.687 139.243L211.646 139.285L211.562 139.496L211.52 139.58V139.621L211.477 139.748H211.393V139.832L211.351 139.916L211.267 139.958L211.224 139.874H211.182L211.224 139.79L211.182 139.705L211.14 139.79L211.098 139.916L211.056 140.001H211.014L210.929 140.169L210.804 140.296L210.762 140.338H210.72V140.421H210.677L210.72 140.463H210.762V140.59H210.804V140.674V140.716H210.72L210.593 140.674L210.551 140.632V140.674H210.467L210.34 140.59H210.298L210.256 140.632V140.674L210.215 140.632L210.173 140.674H210.088L210.004 140.843V140.885L209.962 140.969L209.92 141.179L209.835 141.347V141.432L209.878 141.474L209.92 141.516L209.878 141.6V141.727L209.793 141.769L209.709 141.979L209.625 142.021L209.709 142.063L209.793 142.105H209.962L210.004 142.147L210.088 142.105L210.173 142.147V142.232L210.215 142.274V142.358L210.256 142.4L210.215 142.441V142.485H210.131V142.527L210.088 142.568V142.694L210.046 142.779H209.962L209.92 142.694L209.835 142.779H209.793L209.751 142.821L209.667 142.736H209.625V142.694L209.498 142.61L209.457 142.652L209.331 142.694H209.288L209.246 142.736H209.204L209.12 142.694H209.078H208.993L208.951 142.652V142.61H208.825L208.74 142.652V142.779L208.657 142.947L208.573 143.158L208.446 143.283H208.404L208.362 143.452V143.494V143.536L208.236 143.789V143.874V143.916H208.32V143.958L208.278 144.21L208.193 144.336L208.236 144.547L208.362 144.589V144.674L208.278 144.757L208.32 144.883L208.278 144.925H208.236V145.01L208.278 145.052V145.136L208.404 145.221L208.236 145.263L208.151 145.389H208.109V145.472H208.026V145.557L208.109 145.599L208.026 145.683L208.067 145.725V145.81V145.852V145.894L207.899 145.978L208.026 146.063L208.067 146.105L208.193 146.063L208.278 146.105L208.362 146.188L208.573 146.23V146.272V146.314L208.657 146.441H208.698V146.525H208.784V146.652L208.74 146.736L208.784 146.778L208.825 146.819L208.909 147.03L209.036 147.114L209.12 147.03H209.246L209.204 147.072L209.246 147.157H209.204V147.199V147.283L209.288 147.325L209.331 147.409L209.415 147.325H209.457L209.54 147.452L209.582 147.536L209.625 147.409V147.325L209.667 147.367L209.709 147.452L209.793 147.494L209.751 147.578L209.793 147.619L209.878 147.661L209.92 147.704V147.83L209.962 147.872H210.004L210.046 147.999L210.088 148.041L210.215 147.999L210.256 148.083H210.298H210.382L210.467 148.209L210.425 148.294L210.467 148.377L210.425 148.461L210.509 148.546L210.551 148.63L210.509 148.714L210.551 148.672L210.635 148.714L210.677 148.799V148.841L210.467 149.135L210.131 149.303V149.345L210.173 149.388L210.298 149.472L210.382 149.514V149.683L210.215 149.598L210.131 149.556H210.088L209.962 149.472V149.43L209.878 149.472L209.835 149.388H209.793L209.709 149.303H209.625L209.582 149.345L209.498 149.303L209.457 149.345H209.373V149.303H209.204H209.12L208.951 149.261L208.909 149.345L208.784 149.219H208.657L208.573 149.094H208.531L208.404 149.177L208.278 149.261H208.151V149.388H208.067H207.984V149.43V149.472L207.942 149.556L207.984 149.598L207.899 149.641V149.725L207.773 149.767L207.731 149.85L207.689 149.893L207.604 149.85L207.562 149.893L207.52 149.85L207.393 149.935L207.351 149.893V149.808H207.268H207.184L207.142 149.85L207.057 149.808H207.015H206.973L207.015 149.683H206.973V149.641H206.931L206.847 149.683L206.889 149.598L206.847 149.514H206.804L206.762 149.472L206.72 149.514L206.678 149.556L206.636 149.514H206.595L206.468 149.683L206.426 149.725L206.384 149.683H206.342L206.299 149.598L206.257 149.683H206.215L206.173 149.725L206.973 150.483L207.015 150.777L206.847 150.819L206.804 150.777L206.678 150.735H206.636H206.551H206.509L206.468 150.692H206.426V150.608L206.342 150.566H206.257V150.483L206.215 150.525L206.173 150.483V150.525H206.131L206.089 150.566L206.004 150.65H205.962L205.92 150.608H205.878V150.692V150.735V150.777H205.837L205.795 150.735L205.71 150.692L205.668 150.735L205.626 150.861H205.5V150.777H205.415L205.373 150.903H205.331L205.373 150.819L205.247 150.861V150.903V150.945H205.162L204.995 151.03V151.114L204.953 151.156V151.197L204.995 151.239V151.283H204.953V151.324V151.366L204.995 151.408L204.784 151.577L204.658 151.703L204.615 151.745V151.914L204.658 151.956V152.082V152.166V152.208H204.573V152.292V152.377H204.7L204.615 152.419L204.531 152.461L204.447 152.587L204.489 152.628L205.037 152.672H205.206L205.415 152.714H205.457V152.755V152.797L205.415 153.177V153.303H205.373L205.331 153.639L205.373 153.681V153.723L205.331 153.766L205.289 153.808H205.247V153.85L205.331 153.892L205.289 153.934L205.373 153.892V153.934H205.415L205.373 153.976H205.457L205.542 154.061H205.626L205.668 154.103L205.878 154.145L205.92 154.186L205.962 154.439V154.481V154.734L206.047 154.817L206.004 154.861L206.089 154.903V154.944V154.986L206.047 155.028L206.004 155.07L205.962 155.113L205.92 155.07L205.878 155.113L205.795 155.155H205.415H205.289H205.079H204.995H204.91L204.826 155.028V154.986L204.784 154.944L204.742 154.861L204.658 154.903H204.573H204.531H204.153L204.068 155.028L204.111 155.113L204.068 155.197H204.111L204.068 155.239L204.111 155.281H204.153L204.237 155.408L204.279 155.365V155.323V155.239L204.362 155.323H204.406L204.531 155.281L204.573 155.323L204.615 155.408V155.45H204.658H204.7L204.784 155.492L204.826 155.575L204.868 155.617V155.702H204.91L204.953 155.744L205.079 155.786V155.828H205.162V155.87L205.206 155.955H205.247V155.997L205.289 156.039H205.331H205.373H205.415L205.457 155.997V156.039V156.081H205.415L205.247 156.208H205.162V156.292L205.12 156.334L205.206 156.417L205.162 156.502L205.206 156.544H205.247V156.628H205.373L205.415 156.712L205.457 156.67H205.5V156.755L205.542 156.712V156.797V156.839H205.584H205.668L205.71 156.881L205.753 156.923V156.965H205.795L205.837 157.006V157.092H205.92L205.878 157.175L205.92 157.217L205.962 157.259V157.344H206.004V157.386H206.047L206.004 157.428L206.047 157.47V157.554L206.004 157.597H205.962V157.681L206.004 157.723L205.962 157.764H206.004L206.089 157.806V157.933H206.004L205.92 157.975L205.962 158.017H206.047L206.004 158.059V158.101H206.047H206.089H206.131L206.173 158.144L206.131 158.228H206.089L206.047 158.27H206.004L205.962 158.396V158.481L206.047 158.523L206.004 158.564V158.606L205.837 158.733V158.775V158.859L205.795 158.901V158.943L205.837 158.986V159.07L205.92 159.112L205.878 159.154V159.195L205.753 159.364V159.406H205.542L205.415 159.364L205.289 159.322V159.406L205.331 159.49L205.289 159.617L205.331 159.701L205.373 159.786V159.828L205.247 159.87V159.912H205.12V159.995H205.079H205.037L204.995 160.037H204.953L204.91 160.248L204.868 160.29H204.826H204.784L204.742 160.375L204.658 160.417H204.573L204.531 160.459L204.489 160.585L204.531 160.628L204.489 160.67V160.753V160.795L204.447 160.88L204.489 160.922L204.406 160.964V161.048L204.489 161.09L204.531 161.175H204.489V161.217L204.573 161.259L204.531 161.343L204.489 161.47H204.447L204.489 161.553V161.595H204.447V161.848L204.406 161.89L204.32 161.975L204.279 161.932L204.153 161.975V162.059L204.068 162.184H204.026L203.984 162.142L203.9 162.184H203.731L203.689 162.226L203.648 162.395L203.606 162.437L203.648 162.521V162.564L203.689 162.648L203.606 162.732V162.859L203.564 162.901L203.521 162.942V162.984L203.479 163.111L203.437 163.153V163.237L203.395 163.321L203.437 163.364L203.353 163.448H203.395L203.353 163.49L203.311 163.573L203.268 163.615V163.659L203.226 163.784L203.1 163.868L203.058 163.826L203.017 163.868V163.911H202.764H201.459H200.869V163.953L200.828 163.995V164.037V164.206L200.784 164.248L200.742 164.373L200.784 164.415L200.742 164.458H200.617V164.5L200.575 164.542L200.49 164.584L200.448 164.626L200.406 164.668H200.364H200.322L200.364 164.753L200.28 164.795V164.837L200.237 164.963H200.322V165.006L200.406 165.215L200.617 165.257V165.342V165.426V165.637L200.575 165.721V165.848L200.533 165.889L200.575 166.015V166.057V166.1H200.49L200.448 166.142V166.184L200.364 166.31V166.395L200.322 166.437L200.28 166.479V166.52L200.322 166.562H200.448H200.533L200.49 166.647L200.533 166.689V166.647L200.575 166.689L200.533 166.731L200.49 166.773H200.448L200.49 166.815L200.406 166.857L200.364 166.942L200.322 166.984V167.026L200.28 167.068L200.237 167.11L200.28 167.152L200.237 167.195H200.195L200.237 167.237L200.28 167.362H200.237V167.32H200.153V167.404V167.446V167.489L200.111 167.531L200.153 167.573L200.111 167.615H200.028L199.986 167.657H199.942H199.901H199.817L199.859 167.699L199.775 167.868L199.859 167.951L199.817 167.993L199.775 168.037L199.69 168.078L199.648 168.12L199.69 168.162L199.606 168.204V168.288L199.564 168.331L199.606 168.373L199.564 168.457V168.415L199.522 168.457V168.541L199.395 168.499L199.353 168.541L199.228 168.499H199.143L199.101 168.541L198.975 168.584H198.848L198.806 168.541L198.722 168.626L198.68 168.668V168.709H198.639L198.595 168.668L198.512 168.709L198.428 168.793V168.835L198.512 168.878V168.92L198.595 169.004H198.639L198.68 169.046H198.722H198.764L198.848 169.131L198.891 169.173V169.215H198.806L198.764 169.173V169.215V169.257V169.299L198.639 169.426V169.468H198.553V169.551L198.512 169.593V169.635H198.344V169.72V169.804H198.301L198.259 169.888L198.217 169.93L198.175 169.973V170.015L198.133 170.057V170.099H198.091L198.175 170.267L198.133 170.309V170.393L198.175 170.435V170.393L198.217 170.435L198.175 170.52L198.217 170.562L198.175 170.604L198.133 170.646L198.049 170.688L198.006 170.73L197.964 170.773V170.94L197.922 171.024V171.067H197.964L198.006 171.109L197.922 171.151L197.964 171.193L197.922 171.235L197.964 171.32L197.88 171.362V171.404L197.797 171.446H197.839L197.922 171.488L197.88 171.53L197.839 171.571H197.753L197.712 171.53L197.67 171.571V171.698L197.628 171.74V171.782V171.824L197.586 171.909L197.712 171.951V171.993L197.797 172.119L197.753 172.162L197.67 172.204L197.628 172.329H197.544L197.501 172.371V172.413L197.459 172.456V172.498L197.333 172.54V172.582L197.375 172.624L197.249 172.709L197.206 172.751L197.081 172.919L197.122 172.962H197.164L197.081 173.046L197.122 173.087H197.164H197.249V173.171L197.291 173.213H197.333L197.375 173.171H197.417H197.459H197.501L197.586 173.213L197.628 173.256H197.586L197.628 173.34L197.67 173.298L197.712 173.34V173.424V173.466V173.508V173.551L197.459 173.635V173.677L197.291 173.719H197.164L197.039 173.76H196.997L196.955 173.846L196.533 173.971L196.491 174.013L196.07 174.182L195.775 174.308V174.393L195.691 174.435H195.65H195.608L195.523 174.477L195.355 174.518L195.228 174.56L195.186 174.602L194.933 174.687L194.681 174.813L194.639 174.855L194.47 174.94L194.134 175.024L193.923 175.108V175.151L193.755 175.318L193.502 175.402L193.419 175.445H193.375L193.208 175.571H193.166L193.039 175.613L192.955 175.655V175.697L192.997 175.74L192.955 175.782L192.871 175.908L192.703 175.949V175.908H192.619H192.534L192.408 175.949V176.035L192.324 176.076L192.281 175.993L192.239 175.866V175.824L192.366 175.74V175.655V175.571H192.281H192.239L192.155 175.529V175.487H192.113L191.945 175.613L191.903 175.571V175.529L191.861 175.571H191.819L191.777 175.529H191.734L191.692 175.487V175.445L191.65 175.402L191.608 175.445L191.566 175.402L191.524 175.445H191.439L191.313 175.487L191.23 175.445L191.186 175.402L191.145 175.445H191.061L191.019 175.402H190.977L190.892 175.445V175.487L190.766 175.571L190.597 175.697H190.514L190.472 175.74L190.303 175.824H190.219H190.135H190.05V175.782L190.008 175.74H189.966L189.924 175.824L189.714 175.866L189.672 175.908L189.63 175.866L189.546 175.824V175.697L189.503 175.74H189.461L189.419 175.824H189.377V175.866V175.908H189.335V175.824L189.293 175.866L189.208 175.782H189.166H189.124V175.824H189.041V175.908L188.999 175.949V175.908L188.956 175.824H188.872L188.83 175.866H188.788H188.703L188.619 175.993L188.577 175.949H188.535V175.908L188.452 175.866H188.493L188.452 175.824V175.782H188.408H188.366L188.199 175.908H188.156H188.114L188.03 175.949L187.946 175.993L187.861 175.949L187.819 175.993H187.777V176.035L187.735 175.993V176.076H187.652L187.608 176.118L187.357 176.202L187.272 176.245H187.23L187.104 176.287V176.329H187.061L187.019 176.371H186.977L186.935 176.413L186.852 176.329H186.725V176.371L186.557 176.413H186.514V176.497H186.472L186.43 176.54V176.497L186.346 176.455V176.497V176.54L186.263 176.582L186.219 176.54V176.582V176.624V176.707H186.177H186.136L186.094 176.749L186.052 176.707L186.01 176.791L185.968 176.834H185.925H185.883H185.841L185.799 176.918L185.715 176.96H185.672V176.918L185.588 176.96V177.002L185.505 177.044L185.463 177.087L185.419 177.044L185.378 177.087L185.336 176.918V176.96L185.294 176.918H185.252H185.21L185.168 176.96V176.918L185.125 177.002H185.041L184.999 177.044L184.957 177.002H184.873H184.788L184.746 176.96L184.663 177.044L184.621 177.087H184.578H184.536V177.002H184.41H184.368L184.283 176.96L184.241 177.002H184.199H184.157L184.115 177.087V177.129V177.171L184.074 177.129L183.905 177.297L183.779 177.338V177.382L183.694 177.424V177.465H183.61V177.424L183.483 177.465L183.441 177.424L183.357 177.465L183.316 177.424H183.274L183.147 177.465L183.105 177.507V177.591L182.979 177.634V177.676L182.894 177.76V177.802L182.852 177.76H182.768L182.684 177.718L182.599 177.76L182.474 177.676H182.432L182.347 177.76H182.263L182.179 177.802H182.136L182.094 177.844H182.052L182.01 177.886L181.968 177.971V178.013L181.885 178.055L181.799 178.097H181.758H181.674L181.632 178.055H181.59L181.547 178.097L181.463 178.138L181.421 178.265H181.337H181.168L181.043 178.349L181 178.391L180.832 178.349H180.79H180.705H180.621V178.307L180.537 178.349L180.41 178.391L180.285 178.476L180.2 178.433L180.158 178.476L180.074 178.518H180.032L179.99 178.56L179.905 178.602H179.863L179.779 178.686L179.737 178.729V178.771L179.779 178.813L179.696 178.896L179.527 178.938H179.485L179.401 178.98H179.358L179.148 179.107L179.19 179.149L179.148 179.233V179.276H179.106L179.063 179.318L178.938 179.276L178.727 179.318L178.685 179.36H178.601L178.558 179.444H178.474L178.348 179.527H178.306H178.221L178.263 179.402L178.221 179.36L178.179 179.318H178.096L178.054 179.276L178.012 179.233H177.969L177.843 179.149H177.801L177.843 179.191L177.759 179.402L177.674 179.36L177.507 179.486H177.465L177.421 179.527H177.38L177.212 179.571L177.169 179.527V179.486L177.212 179.444L177.338 179.36L177.296 179.276H177.212V179.191L177.127 179.276H177.169L177.127 179.318H177.043L176.959 179.444L176.749 179.486L176.665 179.527H176.622L176.538 179.444L176.58 179.402V179.36L176.665 179.276H176.622L176.665 179.191H176.707L176.665 179.107V179.065L176.58 179.023L176.454 179.107L176.327 179.065L176.285 179.107V179.149L176.243 179.191L176.201 179.233L176.243 179.276V179.318H176.327L176.37 179.444L176.454 179.486V179.527H176.496L176.37 179.571L176.327 179.613L176.243 179.571H176.159V179.613L176.117 179.654H176.074V179.696L175.949 179.738L175.907 179.78L175.738 179.823L175.696 179.991L175.78 180.075H175.823L175.949 180.033L176.074 179.991H176.117H176.243H176.285H176.243L176.327 180.118V180.202H176.37V180.286L176.327 180.327H176.285L176.243 180.413V180.454L176.285 180.496L176.327 180.538H176.37V180.58H176.285L176.243 180.538H176.201L176.159 180.454L176.117 180.413L176.074 180.496H175.99L176.032 180.707V180.749L175.99 180.791L175.907 180.833H175.865L175.823 180.791V180.707L175.738 180.665V180.707L175.654 180.665V180.707H175.57H175.527L175.485 180.791H175.443V180.875V180.917H175.401L175.318 180.96H175.276V180.875V180.833H175.232V180.749V180.707H175.149V180.665L175.191 180.58H175.149L175.065 180.622V180.665L174.981 180.749H174.896L174.854 180.791L174.812 180.833L174.728 180.875L174.643 180.917V180.96L174.56 181.002L174.518 181.044L174.391 181.002L174.265 181.085L174.096 181.044L173.97 181.085L173.887 181.169H173.801L173.718 181.254L173.634 181.212L173.676 181.169L173.718 181.044V181.002L173.676 180.875V180.833L173.634 180.875L173.423 180.917L173.381 180.875L173.338 180.917L173.129 181.002L173.087 181.085L173.043 181.044H172.96V180.96H172.918H172.834L172.749 181.085L172.623 181.044L172.496 181.085L172.454 181.127L172.329 181.085L172.287 181.002L172.244 180.96V180.917H172.202V180.875H172.287L172.244 180.749L172.287 180.707L172.244 180.665V180.58L172.329 180.413L172.412 180.369V180.327H172.454V180.286L172.496 180.244V180.202H172.371L172.329 180.244L172.244 180.118H172.202V180.075L172.16 180.118H172.076L171.949 180.033V180.075L171.865 180.033V179.991H171.781L171.739 179.865H171.654L171.612 179.823L171.654 179.78L171.612 179.738V179.696L171.654 179.654L171.739 179.696V179.654L171.865 179.613L171.907 179.571L171.992 179.613L172.034 179.571L172.076 179.613L172.034 179.654H172.076L172.16 179.613V179.527L172.118 179.486L172.076 179.444H171.992L171.949 179.402V179.36L172.076 179.318L171.949 179.191L172.034 179.107H171.907V179.023L172.034 178.896V178.813L171.992 178.855H171.949L171.865 178.813V178.771H171.781V178.686H171.698H171.571L171.529 178.644L171.445 178.686V178.602L171.234 178.518L171.276 178.476V178.391L171.192 178.349H171.149V178.307L171.192 178.265L171.149 178.224H171.065L171.023 178.265V178.224L170.981 178.182H170.898H170.854L170.771 178.138V178.182L170.645 178.138L170.603 178.097H170.56V178.055L170.434 178.013V177.971L170.476 177.844L170.434 177.802L170.476 177.718H170.392L170.35 177.634H170.307V177.591H170.265V177.549V177.507L170.223 177.465V177.424H170.182V177.382H170.14L170.098 177.338H170.14L170.223 177.255L170.182 177.171L170.223 177.129L170.182 177.087V177.044L170.223 177.002L170.265 176.918L170.307 176.96L170.265 176.876L170.392 176.791L170.35 176.749L170.434 176.54L170.392 176.497H170.434H170.476H170.56L170.603 176.371L170.771 176.329L170.854 176.245V176.202H170.771L170.729 176.076L170.645 176.035L170.56 175.949L170.434 175.993L170.35 175.949H170.307H170.265H170.223H170.182H170.14L170.098 175.908V175.866V175.824H170.14L170.182 175.866L170.265 175.824H170.35L170.476 175.782V175.74L170.392 175.697L170.307 175.613L170.35 175.529H170.392V175.487L170.476 175.529L170.518 175.487V175.445H170.56L170.603 175.402L170.729 175.487H170.771V175.445V175.402V175.36L170.729 175.318L170.687 175.235H170.645L170.603 175.193L170.518 175.066V174.982L170.434 174.94L170.476 174.855L170.392 174.771L170.434 174.729H170.476L170.518 174.687L170.56 174.602L170.518 174.56V174.518L170.434 174.393H170.392H170.35L170.307 174.308L170.35 174.224L170.434 174.182V174.14L170.56 174.013L170.518 173.929H170.56L170.603 173.887H170.687V173.846V173.719V173.677V173.635L170.729 173.551L170.687 173.466V173.424L170.729 173.382V173.298L170.981 173.34L171.065 173.298V173.171L171.149 173.129H171.192L171.149 173.046L171.192 173.004H171.276V172.919L171.36 172.877V172.835L171.318 172.793L171.36 172.751V172.709L171.402 172.624V172.582L171.445 172.54H171.487V172.498L171.402 172.413L171.36 172.371L171.318 172.288L171.36 172.246V172.162L171.445 172.077L171.402 172.035V171.951L171.36 171.909V171.867V171.824H171.318H171.276L171.192 171.782H171.107L171.023 171.74V171.698L170.854 171.782V171.824L170.771 171.782L170.729 171.74L170.771 171.698H170.729V171.657L170.687 171.615H170.645L170.603 171.53L170.56 171.488V171.446V171.404V171.362V171.277H170.476H170.434L170.392 171.362H170.35L170.307 171.404L170.265 171.446L170.182 171.571L170.14 171.488L170.098 171.446V171.488H170.013L169.887 171.404L169.845 171.362L169.887 171.277H169.845H169.76L169.718 171.32L169.676 171.362L169.509 171.32H169.423L169.382 171.362V171.404L169.34 171.446H169.256V171.488H169.213V171.53L169.087 171.571L169.045 171.615H169.003L168.961 171.657H168.876V171.698L168.834 171.657L168.792 171.698L168.709 171.657L168.665 171.698L168.624 171.657H168.582H168.54L168.456 171.698V171.657L168.414 171.698L168.371 171.657H168.329L168.287 171.615H168.329V171.571L168.287 171.488H168.329L168.371 171.404L168.329 171.32L168.371 171.277L168.414 171.235L168.371 171.193L168.287 171.151L168.245 171.067V171.024L168.203 170.94H168.161L168.203 170.898L168.12 170.815V170.773V170.688L168.076 170.604V170.562H168.034L167.993 170.477L167.909 170.52V170.435L167.951 170.393V170.351L167.993 170.309H167.951H167.824H167.782V170.351L167.74 170.267L167.656 170.14V170.099L167.614 170.057L167.656 169.93L167.529 169.804L167.614 169.762V169.72V169.678H167.698V169.635L167.571 169.593L167.529 169.551H167.487L167.529 169.426L167.487 169.341L167.445 169.215L167.403 169.088L167.445 169.046V168.962L167.487 168.835L167.445 168.793L167.361 168.751L167.32 168.668H167.234L167.193 168.584V168.499H167.067L166.982 168.415L166.898 168.246L166.982 168.037L167.067 167.868L166.982 167.699L167.067 167.657L167.109 167.531H167.151L167.193 167.489L167.234 167.32H167.276L167.234 167.237L167.32 167.152V167.11L167.361 167.068L167.445 167.11H167.656V167.068L167.698 167.026L167.74 166.942V166.857L167.782 166.773V166.731V166.689L167.698 166.647V166.562V166.52L167.614 166.479V166.437V166.395V166.352H167.571L167.487 166.184L167.529 166.142L167.487 166.057V165.973H167.445L167.403 165.889L167.234 165.848L167.151 165.804H167.067L166.94 165.679L166.814 165.637L166.772 165.553H166.687L166.562 165.468V165.426L166.603 165.384V165.342H166.562V165.3L166.603 165.257H166.562L166.603 165.215H166.562L166.603 165.173L166.562 165.131L166.603 165.048H166.562V165.006V164.963V164.921L166.52 164.795L166.603 164.753L166.562 164.71H166.603V164.668V164.584H166.645V164.458L166.687 164.373H166.729L166.814 164.248H166.856L166.94 164.037V163.995L166.856 163.868L166.814 163.784H166.772V163.659L166.729 163.573H166.687L166.562 163.532L166.478 163.364L166.309 163.321L166.225 163.237H166.14L166.056 163.111H165.887H165.845L165.804 162.984L165.635 162.901V162.817V162.774L165.72 162.732V162.69V162.648L165.678 162.564L165.593 162.479L165.467 162.353V162.311L165.425 162.353L165.383 162.395H165.298L165.214 162.479H165.045L164.962 162.521V162.564H164.793L164.709 162.606V162.732L164.583 162.859H164.498L164.414 162.901L164.331 162.817L164.289 162.774L164.204 162.69V162.648V162.606L163.993 162.437H163.951L163.825 162.479L163.742 162.521L163.615 162.479H163.404L163.194 162.564L163.109 162.521H163.067L162.983 162.648L162.942 162.69V162.732V162.774V162.817H162.983L163.025 162.859V162.901L162.983 162.984V163.069V163.153L162.942 163.237L162.815 163.364H162.773L162.604 163.279L162.52 163.153L162.478 162.942L162.309 162.817H162.267L162.225 162.859V163.069L162.184 163.153L162.142 163.237L162.057 163.364L161.931 163.321L161.889 163.448L161.72 163.532H161.594L161.467 163.49L161.384 163.406L161.257 163.364L161.215 163.237H161.173H161.131L161.089 163.195L161.047 163.069L160.92 162.859L160.836 162.817L160.794 162.774H160.667L160.626 162.817L160.667 162.859L160.626 163.069V163.111L160.836 163.321V163.364L160.794 163.448H160.753L160.667 163.49H160.542H160.5H160.458L160.415 163.448L160.331 163.364L160.205 163.321H160.078L159.995 163.364H159.953H159.868H159.826L159.658 163.321L159.447 163.364H159.364L159.153 163.448H158.984H158.858L158.731 163.406H158.564L158.478 163.448L158.311 163.615L158.184 163.659H158.058L158.016 163.615H157.889L157.679 163.532H157.637L157.511 163.573L157.342 163.615H157.089H157.048L156.922 163.7L156.88 163.742L156.837 163.868L156.88 163.953V163.995L156.837 164.037L156.753 164.121L156.669 164.29V164.415V164.458L156.753 164.584L156.711 164.795L156.795 165.006V165.048V165.131V165.173L156.711 165.342L156.669 165.384H156.584L156.206 165.131L156.164 165.09L156.206 164.373V164.248L156.164 163.911L156.08 163.7L156.038 163.615L155.869 163.573L155.785 163.532H155.617L155.575 163.573L155.406 163.911L155.238 164.29L155.153 164.373L154.9 164.542V164.584H154.859L154.775 164.542L154.564 164.5H154.522L154.353 164.248V164.164L154.311 164.037L154.1 163.659V163.321L154.059 163.237V163.195V163.026L154.144 162.69L154.227 162.606H154.353L154.438 162.564V162.479V162.395L154.396 162.353H154.353L154.144 162.311L154.017 162.353L153.891 162.437L153.764 162.479L153.259 162.437H153.133L152.964 162.269L152.922 162.226L152.838 162.059L152.711 162.017L152.544 161.975L152.502 162.017H152.375L152.207 162.059L152.08 162.101V162.142H151.997H151.575L151.364 162.101H151.322H151.113H151.07L150.818 162.142L150.691 162.226H150.566H150.439L150.355 162.184L150.018 162.059L149.681 162.101L149.597 162.059H149.513L149.471 162.017L149.302 161.848L149.218 161.806L149.175 161.764H149.133H148.924L148.797 161.806H148.755L148.713 161.764L148.544 161.722H148.419L148.25 161.806L147.997 161.722L147.829 161.764H147.786L147.702 161.722H147.577V161.637L147.45 161.595L147.197 161.301L147.071 161.259L146.944 161.217L146.861 161.175L146.777 161.217L146.692 161.259H146.566L146.482 161.301L146.397 161.384H146.271H146.188L146.144 161.47L146.019 161.637L145.935 161.679L145.85 161.764L145.724 161.975H145.682L145.597 162.017H145.555L145.261 162.101L144.924 162.184H144.84V162.226L144.713 162.311L144.546 162.353L144.503 162.395L144.377 162.521H144.293H144.208H144.124V162.606L143.999 162.69L143.914 162.774H143.872H143.788V162.817L143.577 163.111L143.535 163.026L143.451 162.901L143.493 162.859L143.535 162.732V162.564L143.451 162.353L143.577 162.059V162.017V161.975V161.932L143.493 161.806L143.451 161.722V161.553V161.343L143.366 161.259V161.217Z"
							fill="#195386" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="PR" @mouseenter="e => hoverES(e, 'PR')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M121.225 197.373L121.267 197.331V197.247L121.351 197.078L121.392 196.994L121.478 196.869L121.603 196.784L121.772 196.573L121.856 196.447L121.94 196.278L121.983 196.027L122.067 195.9L122.109 195.774L122.192 195.647H122.277L122.319 195.563L122.277 195.395L122.234 195.311L122.15 195.227L122.109 195.142L122.15 195.058L122.109 194.932V194.805L122.234 194.469V194.216L122.319 194.047L122.361 193.88L122.445 193.542L122.572 193.164L122.614 193.038L122.698 192.995L122.74 192.911L122.825 192.7L122.867 192.575L122.95 192.364L122.992 191.902V191.817L122.909 191.522L122.867 191.353L122.95 191.058L123.119 190.891L123.245 190.722L123.329 190.511L123.372 190.427L123.287 190.091L123.203 189.964L122.992 189.755L122.95 189.628V189.502V189.46V189.375L122.867 189.165V189.08L122.825 189.038L122.909 188.869L123.076 188.744L123.203 188.575L123.245 188.533H123.287L123.456 188.491L123.918 188.155L124.171 188.028L124.298 187.902L124.339 187.818L124.466 187.439V187.271L124.423 187.144L124.466 187.06L124.423 187.018L124.466 186.891L124.508 186.639L124.634 186.429V186.386L124.676 186.135L124.718 186.008L124.761 185.924L124.803 185.755L124.845 185.502L124.929 185.25V184.997L125.098 184.702V184.66L125.181 184.618L125.223 184.577L125.392 184.618L125.729 184.45L126.107 184.197L126.403 184.113L126.445 184.071L126.655 183.777L126.739 183.608V183.566L126.823 183.355L126.907 183.061L127.076 182.808V182.724L127.245 182.555V181.84V181.757L127.37 181.588L127.412 181.419L127.539 181.335L127.623 181.293L127.707 181.209V181.166L127.792 181.04L127.876 180.999L127.959 180.957L128.17 180.872L128.381 180.746L128.507 180.704L128.634 180.577V180.535H128.676L128.843 180.493L128.928 180.366L128.97 180.324L129.054 180.282L129.139 180.24L129.265 180.199L129.643 180.072H129.686V180.03H129.812H129.938L129.981 179.988L130.065 179.904L130.359 179.524H130.401L130.528 179.315L130.57 179.441L130.612 179.568L130.696 179.441L130.865 179.399L130.948 179.315L131.032 179.23L131.117 179.188V179.146L131.201 179.104L131.285 179.062L131.328 179.02L131.623 178.977L131.748 179.02L132.043 179.23L132.127 179.273L132.337 179.188H132.464H132.506L132.548 179.23L132.717 179.273L132.885 179.357H133.012L133.264 179.273L133.643 179.02L133.727 178.977H133.768L133.854 179.104L134.021 179.273H134.063L134.148 179.315L134.274 179.399H134.316L134.526 179.273H134.61V179.23H134.695L134.737 179.273H134.779L134.863 179.315L135.074 179.399H135.368L135.495 179.441L135.579 179.357L135.663 179.315L135.832 179.273L135.874 179.315L135.957 179.441V179.609V179.651H135.999L136.168 179.568L136.252 179.524L136.421 179.482L136.379 179.23V179.188L136.421 179.02V178.977L136.463 178.851L136.548 178.726L136.59 178.683L136.674 178.641H136.715L136.799 178.683L137.01 178.81H137.179H137.221L137.39 178.851L137.599 178.977H137.726L137.979 179.188L138.021 179.23L138.063 179.273L138.146 179.357L138.273 179.399H138.315L138.779 179.273L138.863 179.315H138.904L138.946 179.357H139.031V179.399L139.073 179.568L139.115 179.651H139.241L139.368 179.568H139.452H139.662L139.746 179.609L139.915 179.735L140.041 179.777L140.126 179.82L140.168 179.777L140.335 179.735L140.377 179.777H140.462L140.63 179.693H140.673L140.799 179.524H140.925L141.093 179.609H141.177L141.262 179.568L141.43 179.609H141.515L141.683 179.651H141.724L141.851 179.609L141.935 179.651L142.019 179.735H142.062L142.104 179.904L142.23 179.988H142.272L142.399 180.03L142.483 180.072L142.61 180.157L142.862 180.24H143.199L143.535 180.409H143.619L143.704 180.366H143.83L143.913 180.493H143.957L144.04 180.451H144.082H144.251L144.293 180.493L144.546 180.662L144.63 180.83L144.672 180.872L144.713 180.999L144.84 181.04V181.082V181.124L144.799 181.377L144.84 181.419H144.966H145.093L145.135 181.461L145.177 181.504H145.219H145.261L145.388 181.461L145.555 181.166L145.597 181.124L145.64 181.082H145.682H145.766L145.808 181.166L145.935 181.209L146.019 181.251L146.102 181.209L146.188 181.124L146.355 181.166L146.44 181.209L146.482 181.251L146.524 181.335L146.566 181.377L146.65 181.419L146.735 181.335H146.777L146.902 181.419L146.986 181.377L147.113 181.419L147.155 181.335H147.197V181.209L147.239 181.166H147.324L147.408 181.124L147.535 181.209V181.251L147.619 181.335L147.66 181.419H147.786H147.871L147.913 181.335H147.997L148.081 181.293L148.25 181.377L148.291 181.419V181.461H148.333L148.418 181.419L148.502 181.461H148.629L148.755 181.419L148.839 181.335L148.966 181.377H149.05H149.091L149.175 181.251H149.26L149.344 181.293L149.471 181.166V181.124L149.597 181.166H149.681L149.724 181.293H149.766H149.808L149.849 181.251L149.808 181.166V181.124L149.849 181.082L149.975 181.166V181.209L150.018 181.293L149.975 181.419L149.933 181.461V181.504L150.06 181.63H150.186L150.27 181.671L150.397 181.757V181.798H150.355V181.84L150.313 181.924V181.966V182.093H150.397L150.48 182.177L150.522 182.135L150.566 182.177L150.607 182.219H150.691L150.818 182.177L150.86 182.219L150.902 182.261H150.944V182.304L150.986 182.346H151.028L151.07 182.388H151.155L151.239 182.429L151.322 182.388H151.407L151.449 182.429L151.491 182.471L151.407 182.598L151.449 182.64L151.533 182.682L151.575 182.766L151.617 182.724V182.766L151.66 182.808H151.786L151.744 182.851L151.786 182.893L151.911 183.102V183.188V183.229L151.955 183.271H151.997L151.955 183.355L151.997 183.398L152.08 183.566V183.693L152.122 183.777V183.86L152.08 183.946L152.038 183.902V183.987V184.029H152.164L152.291 184.113V184.155L152.333 184.197L152.291 184.24L152.249 184.197L152.122 184.24V184.282H152.164H152.207H152.249V184.324V184.366H152.291L152.333 184.408H152.375V184.491H152.459L152.417 184.535L152.459 184.577H152.417L152.375 184.535H152.333L152.291 184.577L152.249 184.618V184.66V184.744V184.787V184.829L152.164 184.787V184.871L152.122 184.913L152.164 184.997H152.122L152.08 185.04L152.122 185.082L152.249 185.166L152.207 185.208L152.249 185.291L152.207 185.377L152.249 185.418V185.46L152.164 185.544L152.122 185.629L152.164 185.671V185.713V185.755H152.207V185.797L152.164 185.839L152.249 185.882V185.924L152.333 185.966V186.008H152.375V186.049V186.091H152.417L152.459 186.135H152.502V186.176H152.544V186.218L152.586 186.26L152.544 186.344V186.386L152.586 186.471H152.544L152.459 186.429V186.471V186.513V186.555L152.417 186.597L152.502 186.639L152.459 186.68V186.724L152.502 186.807V186.891V186.933V186.976L152.417 187.018L152.333 187.06H152.291V187.102L152.333 187.144L152.249 187.102H152.207L152.291 187.144L152.249 187.186H152.207L152.249 187.229V187.313L152.291 187.355L152.333 187.439L152.417 187.355V187.48L152.459 187.524L152.502 187.566L152.544 187.607V187.649H152.586L152.669 187.691V187.649L152.755 187.607V187.649H152.796V187.691L152.838 187.733H152.796H152.711L152.755 187.818L152.796 187.775L152.838 187.818V187.86H152.88V187.902H152.796V187.944H152.838L152.922 187.986V188.028L152.88 188.071V188.113H152.922L152.964 188.155V188.197H153.006L152.964 188.238H152.922H152.964L152.922 188.28H152.964H153.006H153.049V188.324H153.091V188.407L153.133 188.449L153.175 188.491L153.259 188.533V188.575H153.302L153.259 188.618L153.302 188.66V188.702H153.344L153.469 188.744L153.428 188.786H153.469L153.428 188.828L153.553 188.869V188.913L153.596 188.869L153.638 188.913L153.68 188.869L153.722 188.913V188.955L153.849 189.038H153.891V189.08L153.933 189.122L153.849 189.165V189.249V189.375V189.46L153.764 189.502L153.806 189.544L153.975 189.669V189.713H154.059L154.1 189.755L154.059 189.796H154.1L154.144 189.838L154.1 189.922L154.144 189.964L154.186 190.007V190.049V190.091L154.227 190.133L154.269 190.091H154.311L154.396 190.175H154.438V190.26H154.564L154.606 190.302H154.691L154.733 190.344L154.606 190.469H154.564L154.48 190.596L154.396 190.722V190.764L154.438 190.807L154.48 190.722H154.522V190.764L154.48 190.849L154.396 190.933L154.438 190.975L154.396 191.058H154.438V191.102V191.144H154.396L154.353 191.185L154.311 191.227V191.311L154.186 191.353H154.144L154.186 191.438V191.522L154.227 191.564L154.186 191.606L154.144 191.691L154.1 191.649L154.059 191.691H154.017V191.733V191.775L154.059 191.858V191.902H154.017L154.1 191.944L154.059 191.985L154.017 192.027V192.069L154.059 192.111L154.017 192.238H154.059V192.28H154.1V192.322L154.059 192.406H154.1V192.448H154.144L154.269 192.575H154.353H154.396L154.48 192.616H154.522H154.691V192.533H154.775V192.491L154.817 192.448H154.9H154.944H154.985H155.153L155.195 192.491L155.28 192.533L155.322 192.448H155.364V192.491H155.448V192.448H155.49L155.533 192.533H155.575L155.617 192.491H155.658L155.7 192.406L155.742 192.364V192.322V192.28L155.785 192.238L155.742 192.28L155.7 192.238L155.742 192.196H155.785L155.869 192.238L155.953 192.196H155.995V192.238H155.953L155.911 192.364L155.995 192.322H156.038V192.406H156.122V192.448H156.206L156.248 192.533L156.333 192.448H156.416H156.458L156.5 192.491H156.542V192.448H156.584L156.795 192.406L156.88 192.448H156.922L156.837 192.364L156.88 192.322L156.964 192.406L157.047 192.322L157.089 192.364L157.131 192.448H157.216L157.3 192.491L157.342 192.616L157.427 192.575L157.469 192.491H157.511V192.575H157.553L157.637 192.533L157.806 192.491L157.847 192.533L157.889 192.575V192.491V192.448V192.406L157.974 192.448L158.016 192.491L157.974 192.533H158.016L157.974 192.575L158.016 192.616H157.974L158.058 192.658L158.1 192.575L158.184 192.533V192.491H158.269L158.353 192.406L158.395 192.448L158.437 192.406L158.478 192.448L158.522 192.491L158.564 192.448L158.605 192.533L158.647 192.575V192.616L158.689 192.7H158.773V192.743H158.816V192.785H158.858L158.9 192.827V192.869H158.942H159.026V192.827L159.068 192.869V192.911L159.026 192.953V193.038H158.984V193.122L158.9 193.164L158.858 193.206L158.731 193.291V193.374V193.416L158.689 193.458L158.647 193.542L158.689 193.627L158.647 193.669H158.773V193.711V193.753L158.731 193.795L158.689 193.838H158.731L158.689 193.922V193.88H158.647V193.922V194.006V194.047V194.089L158.689 194.133L158.647 194.174L158.689 194.216L158.647 194.258V194.3V194.342L158.605 194.427L158.522 194.469V194.511H158.478V194.553V194.595V194.637V194.68H158.522V194.722L158.564 194.764V194.847H158.647V194.889L158.689 194.932V195.016L158.731 195.058L158.773 195.1L158.858 195.184H158.9L158.942 195.1L158.984 195.058L159.068 194.932L159.111 194.889H159.195V194.805L159.236 194.637L159.489 194.469H159.573L159.616 194.427L159.742 194.469L159.826 194.511V194.553H159.868L159.995 194.68V194.722V194.764H160.078V194.805L160.12 194.764H160.162V194.889H160.12V194.974L160.205 194.889L160.247 194.805L160.331 194.722V194.68H160.373L160.415 194.764H160.458V194.68V194.637L160.5 194.595V194.553V194.511H160.542H160.584V194.469V194.427L160.626 194.385L160.667 194.469L160.711 194.511L160.753 194.553V194.595H160.794L160.753 194.637V194.68L160.836 194.722H160.878V194.764L160.836 194.805L160.878 194.932L160.836 195.016L160.878 195.058V195.1L160.962 195.227V195.269L161.047 195.353V195.395L161.131 195.436L161.215 195.48L161.173 195.522H161.131V195.605L161.089 195.689L160.962 195.731L161.005 195.816L161.089 195.858H161.173L161.215 195.942L161.257 195.984L161.467 196.153L161.552 196.111L161.636 196.069L161.678 196.111L161.72 196.069H161.805V196.027V195.984V195.942L161.889 195.984L161.931 195.942H161.973H162.015L161.973 195.984L162.015 196.027L161.636 196.363L161.552 196.447V196.531H161.594L161.552 196.573L161.342 196.742L161.215 196.869L161.047 197.121L160.92 197.289L160.878 197.5L160.836 197.542H160.753L160.584 197.584L160.415 197.667L160.247 197.711L160.458 197.836L160.373 198.047H160.331V198.131V198.173H160.289L160.247 198.216L160.205 198.3H159.953L159.826 198.342L159.616 198.511L159.447 198.72L159.236 199.1L158.9 199.647L158.858 199.9V199.983L158.816 199.941L158.773 199.983L158.689 200.025V200.067V200.109L158.647 200.194L158.689 200.236L158.605 200.405L158.522 200.7L158.478 200.741L158.522 200.783H158.478L158.437 200.825L158.395 200.783V200.825H158.353H158.311V200.783H158.269V200.741L158.226 200.7L158.184 200.656L158.058 200.741V200.783H158.016H157.974V200.825H157.764H157.089H156.206L156.289 200.867H156.248H156.206V200.825H156.164L156.122 200.867L156.08 200.909V200.951H156.038L155.995 200.994H155.953V201.036H155.869H155.827L155.785 200.951H155.742L155.7 201.036H155.658L155.617 201.078L155.533 200.994V200.909L155.49 200.951H155.406V200.994H155.364L155.322 200.909L155.28 200.951L155.195 200.909L155.153 200.951H155.195H155.153L155.111 201.036V200.994H155.069V201.036L155.027 200.994H154.985L154.944 200.951H154.9L154.858 200.994H154.775V201.036H154.691L154.648 201.078L154.564 201.12H154.522H154.48L154.522 201.162L154.48 201.204L154.396 201.247V201.289V201.331V201.372H154.311H154.353L154.311 201.414V201.456L154.269 201.414V201.456L154.227 201.414H154.186L154.144 201.456V201.498L154.186 201.541H154.144H154.186V201.583H154.1L154.144 201.625L154.1 201.667V201.625H154.059H154.017L153.891 201.709L153.849 201.751H153.806V201.794H153.764V201.836L153.722 201.794L153.764 201.836H153.722V201.878H153.68V201.92H153.596H153.553V201.962L153.511 201.92V201.878L153.469 201.962L153.386 201.92V202.003V201.962L153.344 202.003H153.302L153.259 202.045V201.962H153.217H153.133L153.091 202.045L153.006 202.13L152.964 202.089V202.13L152.922 202.172H152.964L152.922 202.214H152.88L152.922 202.298V202.256V202.298L152.88 202.341H152.838V202.383L152.796 202.341L152.755 202.383L152.711 202.341V202.383L152.669 202.298H152.628V202.341L152.669 202.383H152.628H152.586H152.544H152.586L152.544 202.467L152.459 202.425L152.375 202.298V202.383H152.333V202.341H152.291H152.249V202.383L152.207 202.298H152.164V202.256V202.298H152.122L152.038 202.256L152.08 202.214V202.13H152.038V202.214L151.955 202.256V202.214V202.172H151.911V202.13H151.87V202.172L151.828 202.13L151.786 202.172L151.744 202.13H151.702L151.786 202.045H151.702L151.66 201.962L151.575 201.92L151.491 202.003H151.449L151.407 201.92L151.491 201.836H151.407H151.322V201.709L151.239 201.667L151.197 201.583H151.155V201.625H151.197V201.709H151.155L151.113 201.583L151.07 201.625V201.667L150.986 201.625L150.944 201.498L150.902 201.541H150.86L150.818 201.456V201.372L150.775 201.414H150.733L150.818 201.372V201.289L150.775 201.247V201.331H150.733L150.691 201.289H150.649L150.607 201.247L150.566 201.204L150.607 201.162L150.439 201.12L150.397 201.162L150.355 201.12L150.313 201.078L150.186 201.12L150.144 201.078L150.186 201.036L150.144 200.994L150.06 201.036L150.018 201.078L150.102 201.12L149.933 201.289L149.975 201.204V201.078L149.933 201.036L149.808 200.994V201.036H149.724V201.078L149.766 201.162L149.724 201.204L149.597 201.12H149.555H149.513L149.428 201.162H149.386H149.344L149.302 201.204V201.247V201.204L149.26 201.078L149.218 201.204L149.091 201.289L149.05 201.247L149.008 201.331L148.924 201.204L148.839 201.289V201.247L148.881 201.12L148.839 201.078L148.755 201.12L148.713 201.078L148.671 201.12L148.629 201.162H148.671L148.713 201.204H148.755V201.162L148.797 201.204L148.755 201.289L148.713 201.331L148.671 201.372L148.629 201.414L148.586 201.372V201.331H148.502L148.46 201.289H148.418L148.377 201.331L148.333 201.247V201.162L148.208 201.12V201.162V201.247L148.124 201.204L148.039 201.247L147.913 201.289L147.786 201.372V201.456H147.702L147.744 201.541V201.583L147.702 201.625L147.744 201.667V201.709H147.702V201.751H147.786V201.794L147.744 201.751L147.702 201.794L147.66 201.751L147.577 201.709L147.535 201.667V201.625L147.492 201.667V201.625L147.535 201.541L147.492 201.456L147.282 201.331V201.289L147.239 201.331H147.197H147.155H147.071L147.029 201.247L146.986 201.204L147.029 201.162L146.944 201.12V201.162V201.12H146.861V201.078H146.819V201.162L146.777 201.12H146.819H146.735L146.692 201.078L146.65 201.12L146.608 201.078L146.524 201.12L146.355 201.204V201.162V201.078H146.313L146.271 200.951H146.229L146.102 201.078V201.204L146.144 201.247H146.188L146.271 201.204H146.313H146.355V201.289L146.313 201.331H146.271L146.144 201.372H146.061L145.893 201.331L145.808 201.414L145.766 201.498L145.682 201.583L145.766 201.751H145.724L145.682 201.794L145.597 201.836L145.555 201.878L145.513 201.962L145.43 202.089L145.388 202.13L145.219 202.214L145.346 202.467L145.303 202.509H145.219H145.135V202.383L145.093 202.341L144.84 202.383L144.799 202.425L144.755 202.467L144.672 202.509L144.63 202.636L144.588 202.678L144.546 202.636L144.419 202.467H144.377L144.335 202.593L144.293 202.72L144.251 202.762H144.208H144.124V202.551L143.999 202.425H143.957L143.913 202.467L143.999 202.636L143.957 202.72H143.913L143.872 202.636H143.746V202.509L143.619 202.425L143.577 202.383L143.241 202.509L143.199 202.467L143.072 202.383L143.03 202.509H142.988V202.593L142.946 202.636L142.904 202.678L142.819 202.72H142.735V202.762H142.693L142.651 202.72L142.566 202.762V202.803H142.524L142.441 202.845H142.357H142.315H142.272L142.23 202.93L142.188 202.972L142.062 203.014V203.056H142.019L141.977 203.14H142.019V203.183L141.935 203.267L141.977 203.309L142.019 203.351L141.893 203.393L141.851 203.434V203.52L141.768 203.478V203.52L141.81 203.561L141.724 203.603V203.645L141.768 203.73L141.893 203.772L141.851 203.814V203.856H141.893H141.935L142.019 203.898L141.977 203.94L142.019 203.982L141.935 204.025V204.067H141.893V204.109V204.151L141.935 204.192L141.977 204.278H142.019L142.062 204.361H142.104V204.403L142.188 204.445L142.146 204.487V204.529L142.23 204.572L142.188 204.614V204.656V204.74L142.104 204.782L142.146 204.867L142.104 204.909V204.951H141.977L141.935 204.992H141.851V205.034H141.81V205.119H141.683L141.641 205.076L141.557 205.119V205.076H141.515L141.388 205.119H141.304L141.22 205.161H141.135L141.052 205.245L141.135 205.329V205.414L141.093 205.456L141.01 205.498L141.052 205.414L140.883 205.329L140.841 205.203L140.757 205.119V205.034L140.715 204.951L140.673 204.909H140.63H140.546L140.588 204.825L140.546 204.782L140.504 204.698L140.421 204.656L140.294 204.698H139.957H139.873H139.746H139.662L139.579 204.614L139.452 204.529L139.283 204.656H139.199L139.031 204.614L138.694 204.698H138.61L138.484 204.656L138.357 204.74L138.273 204.698L138.188 204.782H138.146L138.105 204.74V204.698L137.979 204.656H137.81L137.684 204.572L137.642 204.614L137.557 204.572H137.473V204.529L137.305 204.572L137.263 204.487V204.445H137.179V204.403L137.094 204.361L137.052 204.319H137.01L136.968 204.278H136.884L136.842 204.192H136.799L136.757 204.151V204.025L136.674 203.982H136.59L136.548 203.94H136.463H136.379L136.21 203.772L136.126 203.856L135.999 203.898H135.874L135.832 203.856H135.79H135.748L135.663 203.898H135.621V203.856L135.495 203.73H135.368L135.284 203.772L135.243 203.687L135.201 203.772L135.116 203.687L135.032 203.73H134.99L134.948 203.687L134.905 203.645L134.863 203.687L134.779 203.73H134.737H134.61H134.568H134.526H134.485L134.401 203.603H134.316L134.148 203.478L134.021 203.52L133.937 203.561L133.895 203.52L133.854 203.561L133.768 203.52L133.685 203.603L133.643 203.561H133.601H133.559V203.52L133.516 203.478L133.432 203.434V203.393L133.39 203.351L133.306 203.309L133.179 203.183L133.054 203.225H133.012L132.97 203.183L132.927 203.225L132.885 203.14L132.801 203.098L132.759 203.14H132.717L132.674 203.183H132.632L132.548 203.14L132.464 203.183H132.421L132.379 203.14H132.337H132.254H132.17H132.127L131.959 203.225H131.917H131.875H131.832H131.748L131.706 203.183L131.623 203.225H131.579L131.496 203.267L131.243 203.14L130.99 203.309L130.865 203.351L130.696 203.434H130.612L130.57 203.393L130.528 203.351H130.485L130.401 203.309L130.359 203.267L130.317 203.225L130.275 203.14H130.234L130.19 203.183H130.148L130.107 203.14H130.023L129.938 203.056H129.896V203.014L129.728 202.93L129.643 202.845H129.601V202.803L129.559 202.762V202.72L129.476 202.593H129.434V202.509L129.265 202.593H129.223L129.181 202.551H129.096V202.509H129.054H129.012V202.551L128.97 202.509L128.928 202.551L128.843 202.467L128.801 202.509L128.549 202.678L128.507 202.72H128.423L128.296 202.803H128.254H128.212L128.086 202.845L127.918 202.803H127.75V202.762L127.623 202.678H127.581L127.539 202.551L127.412 202.593H127.328H127.287L127.201 202.551L127.16 202.509H127.201L127.16 202.467L127.118 202.425L127.201 202.298L127.118 202.256V202.172H127.076L126.992 202.045L126.95 202.003L126.823 201.92L126.781 201.836L126.739 201.751H126.697L126.57 201.667V201.625L126.612 201.583L126.57 201.498L126.612 201.372H126.655V201.331V201.289L126.612 201.204H126.57H126.528V201.162L126.487 201.204V201.162V201.12L126.445 201.162L126.403 201.12V201.078H126.318L126.36 201.036H126.318L126.36 200.994L126.276 200.951V200.909L126.234 200.951L126.192 200.909V200.867V200.825L126.15 200.867H126.107V200.825V200.783L125.981 200.741V200.7H126.023L125.981 200.656L125.939 200.489H125.981H126.023V200.405L126.065 200.489H126.107L126.065 200.405L126.107 200.362H126.065L125.981 200.405L126.023 200.32H126.065L126.107 200.278H126.065H125.981V200.236V200.194L125.939 200.236L125.897 200.194H125.981V200.152H126.023L126.065 200.109H125.981L126.023 200.025H125.939H125.981V199.983L125.939 199.9L125.897 199.941V199.9L125.939 199.814H125.981V199.773L126.023 199.731L126.107 199.773V199.731H126.023L126.065 199.647V199.605H125.939L126.023 199.562V199.52L125.939 199.478L125.856 199.436L125.897 199.394H125.981L125.939 199.352H126.023L125.897 199.267L125.812 199.31L125.856 199.183V199.142H125.77L125.812 199.1L125.729 199.058H125.812L125.77 198.973L125.856 199.015V199.058L125.897 199.015V198.973L125.939 198.931L125.856 198.889V198.847L125.812 198.762L125.729 198.72L125.645 198.762L125.687 198.678H125.729V198.636L125.687 198.678L125.645 198.636L125.687 198.552L125.645 198.511L125.518 198.594V198.552L125.476 198.594V198.552L125.518 198.511L125.476 198.467L125.392 198.511H125.35V198.467H125.308V198.511H125.265L125.308 198.594L125.265 198.678L125.223 198.636V198.552L125.181 198.467H125.139H125.098V198.425L125.139 198.384L125.012 198.3L124.971 198.258L124.929 198.173L124.845 198.131L124.803 198.173L124.718 198.258L124.676 198.3L124.592 198.216L124.55 198.131H124.466L124.423 198.258V198.467H124.381V198.511L124.298 198.384L124.214 198.173V198.089L124.381 197.878V197.752L124.339 197.711H124.298L124.087 197.878L123.961 198.005H123.918L123.792 197.963L123.708 198.005L123.667 198.089H123.708L123.876 198.173V198.216L123.918 198.258H123.876H123.75L123.581 198.131H123.54L123.498 198.173V198.342H123.414L123.329 198.258L123.245 198.089H123.161L122.95 198.216L122.825 198.425H122.782L122.656 198.342L122.572 198.384V198.425V198.511L122.529 198.594L122.319 198.762L122.361 198.931L122.319 198.973H122.277L122.192 198.762L122.067 198.594L121.983 198.552L121.856 198.467L121.73 198.552H121.687L121.645 198.467L121.687 198.384L121.603 198.342L121.519 198.3H121.478L121.309 198.342V198.005L121.267 197.878V197.625L121.14 197.542V197.458V197.416L121.225 197.373Z"
							fill="#52a8ff" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="RS" @mouseenter="e => hoverES(e, 'RS')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M104.344 226.335L104.386 226.082L104.344 225.83V225.746L104.555 225.408L104.849 225.157L104.976 225.113H105.313L105.565 225.03L105.607 224.988L105.775 224.862L106.071 224.609L106.449 224.104L106.575 223.935L106.785 223.768L106.954 223.515L107.249 223.346L107.417 223.262L107.502 223.177L107.627 223.093L107.754 222.924V222.799V222.715L107.796 222.504L107.88 222.462H108.133L108.216 222.42L108.511 221.873L108.554 221.746L108.511 221.579L108.638 221.326L108.807 221.115L108.891 220.862L109.016 220.821H109.227L109.396 220.694L109.48 220.652L109.901 220.61H109.985L110.027 220.357L110.111 220.231L109.985 220.104L110.027 219.937L110.111 219.852L110.196 219.81L110.491 219.726L110.574 219.641L110.7 219.473L110.743 219.39V219.221L110.7 218.926L110.743 218.799L110.827 218.757L110.953 218.673H111.416L111.585 218.463L111.669 218.295L111.795 218.126L112.3 217.705L112.469 217.621L112.553 217.537L112.594 217.453L112.511 217.368L112.427 217.243V217.157V217.074L112.511 216.948L112.68 216.906L112.889 216.863L113.1 216.821L113.269 216.779L113.311 216.737V216.695L113.184 216.401V216.316V216.274L113.352 216.021L113.521 215.979L113.689 216.063H114.069L114.194 216.106L114.236 216.148L114.278 216.274L114.321 216.359L114.363 216.443H114.447L114.489 216.359V216.232L114.616 215.895V215.812L114.405 215.685L114.236 215.559L113.984 215.474L113.942 215.348L113.984 215.264L114.236 215.179L114.447 215.137L114.7 214.927L114.742 214.885L114.825 214.843H114.869L114.91 214.801L114.869 214.717L114.952 214.674L114.91 214.59L114.952 214.548L114.994 214.464H115.078L115.163 214.506V214.548L115.12 214.632V214.674L115.289 214.759H115.331L115.373 214.717V214.632V214.59L115.458 214.506L115.583 214.464L115.668 214.295L115.71 214.212H115.794L115.878 214.337H115.963H116.005L116.047 214.254L116.214 214.085L116.467 213.959L116.51 213.917V213.832L116.425 213.706H116.383V213.623L116.467 213.537H116.636L116.678 213.496L116.72 213.328L116.762 213.243H116.805H116.889L117.058 213.285H117.141L117.183 213.201L117.309 212.99L117.562 212.781H117.647L117.73 212.823L117.814 212.948L117.899 213.032L117.941 213.075L117.983 213.032L118.025 212.99L117.983 212.823L118.025 212.781L118.109 212.738L118.278 212.696L118.447 212.781L118.572 212.823L118.614 212.738V212.654L118.572 212.57L118.278 212.443L118.236 212.359L118.278 212.317L118.32 212.275L118.447 212.233L118.656 212.401L118.699 212.443L118.783 212.401L118.825 212.275H118.909L119.036 212.317H119.078L119.161 212.275L119.203 212.19V212.148L119.372 211.981V211.812V211.559V211.434L119.414 211.348H119.498H119.667L119.709 211.307L119.751 211.181L119.794 210.97L119.92 210.717H119.961L120.045 210.759L120.088 211.012L120.172 211.054H120.214H120.256L120.298 211.012L120.383 210.928H120.509L120.761 211.012L120.803 210.97V210.886L120.761 210.717V210.634L120.803 210.549H120.845L120.888 210.592L120.972 210.801H121.056H121.098L121.14 210.717L121.183 210.592L121.309 210.381V210.297L121.35 210.212H121.392L121.434 210.254L121.561 210.381L121.645 210.549H121.687L121.772 210.507L121.814 210.423L121.856 210.381H122.025H122.15L122.234 210.339V210.254L122.192 210.212L122.067 210.128V210.044H122.109H122.277L122.319 210.001L122.403 209.917H122.445L122.572 210.001V210.044L122.698 210.212L122.74 210.254L122.825 210.297L122.908 210.254V210.17L122.867 210.044V209.959V209.917H122.908L122.992 209.959L123.076 210.044L123.161 210.17H123.203L123.329 210.128V209.959L123.372 209.876L123.414 209.834H123.539L123.623 209.792L123.666 209.707V209.623V209.539L123.708 209.412L123.792 209.286V209.203L123.834 209.034L123.918 208.95H123.961L124.003 208.992V209.034V209.203L124.087 209.245H124.171H124.298H124.339H124.508L124.55 209.159L124.634 208.992L124.803 208.95L124.887 208.823V208.697L124.929 208.612L125.056 208.57H125.139H125.223V208.487V208.36L125.265 208.318H125.35L125.434 208.36L125.476 208.445H125.561L125.645 208.318L125.687 208.192L125.728 208.15H125.855L125.939 208.36L125.981 208.403H126.023L126.065 208.445H126.107H126.15L126.192 208.403L126.36 208.276L126.445 208.318L126.528 208.528H126.612L126.697 208.487H126.739L126.781 208.445L126.865 208.403L126.907 208.36H126.992H127.034L127.118 208.403V208.445L127.159 208.487V208.57V208.697L127.201 208.739H127.245L127.328 208.528H127.37H127.454H127.497L127.665 208.445H127.75H127.792L127.917 208.57L128.001 208.612H128.044H128.128V208.57V208.487V208.445L128.044 208.36V208.318V208.276V208.192H128.086H128.128H128.212L128.254 208.276L128.339 208.318L128.634 208.234L128.676 208.15L128.717 208.023L128.801 207.939H128.843L128.886 207.897L128.928 207.939L128.97 208.023L129.012 208.065H129.054H129.096H129.139H129.265V208.108L129.307 208.15H129.348V208.192V208.234V208.276L129.307 208.36L129.181 208.57V208.612V208.654V208.697H129.223H129.265L129.348 208.57L129.601 208.445L129.686 208.403H129.728L129.938 208.528H130.023L130.065 208.487L130.106 208.276V208.234H130.148L130.19 208.192L130.233 208.234L130.317 208.403V208.445H130.359L130.485 208.403L130.738 208.318V208.234V208.192L130.696 208.065V208.023V207.981L130.823 207.855H130.865H130.99H131.032L131.075 207.897L131.032 207.981L130.906 208.15V208.276L130.948 208.318H130.99L131.159 208.192H131.201L131.243 208.276H131.285V208.36L131.201 208.487L131.159 208.528V208.654H131.201L131.243 208.697L131.328 208.739L131.37 208.697V208.487L131.412 208.36H131.454L131.579 208.403V208.57L131.623 208.612H131.664L131.79 208.57L131.875 208.528V208.487L132.043 208.403H132.085L132.127 208.445V208.612V208.654H132.17H132.212L132.295 208.612H132.337H132.421H132.464L132.506 208.654H132.59H132.632V208.697H132.674V208.739L132.632 208.865V208.907L132.717 208.95V208.992L132.759 208.95L132.843 208.865L132.885 208.823H132.927L132.97 208.907L133.012 209.034V209.076L133.054 209.118H133.095L133.179 209.034V208.907L133.221 208.865H133.264H133.306L133.39 208.992L133.474 209.034H133.516L133.559 208.992L133.685 208.95L133.726 208.907H133.853H133.895L133.979 208.865L134.063 208.992L134.274 209.034H134.401V208.992V208.907V208.865V208.823L134.61 208.697H134.653H134.695V208.739L134.653 208.865V208.907V208.992L134.779 209.118L134.821 209.159L134.863 209.203H134.905L134.948 209.159L134.905 208.992V208.95H134.948H134.99V208.992H135.032L134.99 209.159L135.032 209.286L135.116 209.245L135.201 209.159H135.243L135.326 209.245L135.41 209.286L135.495 209.37H135.537V209.328L135.579 209.286L135.537 209.203L135.495 209.118V209.034V208.992H135.537H135.663H135.748L135.79 208.95L135.915 209.034L135.874 209.076L135.748 209.118L135.663 209.203V209.245L135.832 209.286H135.874L135.957 209.412H135.999V209.454H136.042L136.084 209.412L136.126 209.328L136.168 209.203L136.252 209.118L136.295 209.076H136.337L136.379 209.118L136.337 209.328H136.379H136.421L136.505 209.286H136.59L136.632 209.245L136.715 209.286V209.328V209.412V209.497L136.757 209.539H136.842L136.926 209.497L137.052 209.539H137.094H137.137L137.263 209.454H137.305V209.539L137.221 209.581L137.263 209.623V209.665L137.346 209.707L137.39 209.749L137.473 209.707H137.599L137.684 209.749V209.834H137.642H137.432H137.39H137.346V209.876V209.917L137.432 209.959H137.515H137.642L137.768 210.086V210.128V210.17L137.599 210.297L137.642 210.339H137.726L137.81 210.297L137.894 210.254H137.937L137.979 210.297V210.507L138.063 210.634H138.146V210.592L138.104 210.465L138.146 210.423V210.381H138.273H138.357V210.423L138.273 210.634L138.315 210.676L138.399 210.634L138.484 210.592L138.61 210.717H138.652H138.694V210.676V210.634L138.61 210.549V210.465H138.694L138.904 210.423V210.465L138.988 210.507L139.073 210.592H139.115L139.157 210.549L139.199 210.423L139.241 210.381H139.326L139.41 210.423V210.465L139.368 210.549L139.41 210.634H139.452H139.494H139.535L139.579 210.592V210.465H139.662H139.704V210.507H139.746L139.662 210.759L139.704 210.801H139.788L139.873 210.676H139.957H139.999V210.717V210.759L139.957 210.928L139.999 211.012L140.041 211.054H140.083L140.126 210.97V210.928H140.168V210.886L140.252 210.928L140.42 210.886H140.546L140.588 210.97H140.63V211.139L140.673 211.181L140.715 211.223H140.757V211.265L140.883 211.392V211.475V211.517H140.968L141.01 211.434L141.051 211.392L141.093 211.348L141.177 211.307L141.262 211.348V211.392L141.22 211.559L141.304 211.601L141.388 211.686L141.515 211.601L141.599 211.643H141.641V211.686V211.77L141.683 211.812L141.641 211.854V211.938L141.768 211.981L141.851 211.938L141.893 212.023V212.106L142.019 212.19L142.062 212.275L142.104 212.317L142.146 212.275L142.188 212.233L142.272 212.275H142.399L142.482 212.359L142.609 212.443H142.735V212.485L142.777 212.612V212.654H142.819L142.946 212.612H142.988L143.072 212.654L143.113 212.696L143.072 212.823L143.113 212.865H143.24V212.906V212.99V213.075L143.324 213.159L143.451 213.243V213.37V213.412L143.493 213.454V213.496H143.577L143.619 213.37L143.661 213.328L143.704 213.37L143.746 213.454L143.913 213.537H143.999L144.04 213.579L143.999 213.664L144.082 213.748L144.04 213.79L144.251 213.832L144.335 213.917V213.959V214.001V214.085L144.293 214.17L144.208 214.212L144.166 214.254L144.293 214.295L144.335 214.337L144.377 214.421L144.335 214.548L144.377 214.59H144.419H144.461L144.588 214.464H144.63L144.713 214.59V214.632L144.882 214.59V214.632H144.924L144.882 214.717L144.924 214.843L144.882 214.927V214.97L144.966 215.012L145.008 214.927L145.051 214.97V215.012L145.093 215.054V215.179V215.306H145.135L145.346 215.432H145.429H145.471V215.559L145.555 215.601L145.597 215.643L145.682 215.768L145.64 215.895L145.766 215.937L145.893 216.063L145.85 216.148L145.893 216.232H145.977L146.061 216.148H146.102L146.188 216.232L146.271 216.359L146.355 216.401L146.397 216.443H146.44H146.482V216.316H146.524H146.566L146.692 216.359H146.86H146.944L147.029 216.443L147.071 216.484H147.155H147.324L147.366 216.568H147.408H147.45L147.491 216.443L147.535 216.401H147.577L147.618 216.443V216.61V216.695L147.66 216.653H147.702L147.66 216.526H147.702L147.744 216.484H147.829L147.913 216.526L147.955 216.568V216.61H147.997L148.081 216.653L148.208 216.61V216.568H148.166L148.124 216.526L148.25 216.443V216.484L148.333 216.653L148.377 216.695L148.418 216.653L148.502 216.568H148.544L148.586 216.61H148.629H148.671L148.755 216.737V216.863L148.797 216.906L148.924 216.863L148.881 216.779L148.797 216.653H148.839L148.881 216.568L148.966 216.526V216.484L149.008 216.443V216.484L149.091 216.526V216.568L149.049 216.61L149.008 216.695V216.737H149.091L149.175 216.821L149.26 216.737L149.344 216.779H149.386H149.555L149.597 216.737L149.639 216.653L149.68 216.61L149.766 216.653L149.849 216.61V216.568L149.891 216.526H149.933L149.975 216.61H150.018H150.06L150.102 216.695L150.144 216.779L150.228 216.737L150.186 216.695L150.144 216.653L150.186 216.61H150.228L150.355 216.695H150.397L150.439 216.653H150.48L150.439 216.568V216.526L150.522 216.568L150.566 216.526L150.649 216.568H150.691H150.649L150.522 216.61L150.607 216.653V216.737V216.779V216.821H150.775L150.733 216.863L150.775 216.906L150.86 216.779L150.944 216.821L150.902 216.779V216.695H150.944L150.986 216.821H151.028L151.07 216.863L151.113 216.906L151.155 216.863L151.113 216.821L151.155 216.737H151.113L151.197 216.695V216.653H151.238V216.821L151.197 216.863L151.238 216.906L151.364 216.863V216.906H151.407L151.364 216.948L151.449 217.032L151.364 217.116L151.322 217.201H151.364L151.449 217.243L151.491 217.368L151.533 217.41L151.575 217.368V217.41V217.453V217.495V217.579H151.66L151.702 217.663L151.66 217.705L151.617 217.748H151.575V217.705H151.533H151.449L151.28 217.748V217.663L151.197 217.748H151.155L151.113 217.705V217.621L151.07 217.663H151.028L150.986 217.748L150.944 217.79L150.902 217.832L150.944 217.874L150.902 217.915H150.944L150.86 217.957L150.818 218.001H150.775V218.042H150.818V218.126H150.86L150.902 218.168H150.818L150.775 218.21V218.252V218.295H150.733V218.21H150.607H150.649H150.566V218.252V218.337L150.522 218.421L150.566 218.463L150.48 218.505V218.463H150.439L150.522 218.337L150.48 218.295L150.439 218.337H150.397L150.355 218.295V218.252L150.313 218.295H150.228L150.186 218.379V218.463L150.27 218.505H150.228V218.548L150.186 218.59L150.102 218.548V218.59V218.548L150.06 218.59V218.632V218.673L150.018 218.715H150.06V218.757V218.799H150.102V218.884L150.018 218.842V218.968V219.01H150.06L150.018 219.179L150.102 219.137V219.179H150.06V219.221L150.018 219.263L149.975 219.305L150.102 219.263V219.346L150.144 219.305H150.228H150.186V219.346H150.144V219.39H150.102V219.432V219.473L150.018 219.515L150.06 219.557L149.975 219.599L150.018 219.641H150.144H150.102V219.726H150.06V219.852L150.144 219.894L150.186 219.937L150.27 219.979L150.186 220.021L150.144 219.979V220.021V220.104L150.102 220.063L150.06 220.104V220.19L149.975 220.273L150.102 220.231H150.144V220.273H150.102V220.315H150.06V220.357L150.018 220.399V220.441L149.724 220.568H149.849V220.61V220.568L149.975 220.526H150.018H150.06L150.102 220.484H150.144V220.526H150.06L150.102 220.568H150.06H150.018L150.06 220.61V220.652H149.975V220.735H150.018L149.975 220.779V220.862H150.018H149.975H149.891H149.849L149.891 220.946L149.849 220.988V220.946H149.807H149.68L149.724 220.988V221.073V221.115H149.639V221.157L149.597 221.199L149.639 221.241L149.68 221.284H149.597L149.555 221.241L149.513 221.284H149.471H149.428L149.386 221.326V221.241L149.302 221.326V221.284L149.26 221.241H149.302H149.218V221.199L149.302 221.157V221.115H149.344H149.26L149.175 221.157V221.199V221.241V221.284H149.218V221.368H149.26H149.218V221.41V221.535L149.26 221.494L149.218 221.535L149.26 221.579L149.175 221.621L149.218 221.535L149.091 221.621V221.579V221.535H149.133L149.175 221.452H149.049V221.41H148.966L149.008 221.368H148.924V221.326L148.839 221.41H148.924L148.966 221.452V221.494L148.839 221.535H148.881L148.839 221.579H148.881L148.924 221.621H148.881L148.755 221.704H148.797H148.839V221.746H148.924H148.881V221.873L148.839 221.915H148.881V221.957L148.924 221.999V222.041H148.966V221.957L149.008 221.915V221.957H149.049V221.999L149.133 222.041H149.091L149.133 222.083H149.218L149.26 222.126V222.168H149.302H149.344L149.302 222.21H149.428V222.252L149.386 222.293H149.471L149.555 222.335L149.386 222.083H149.302L149.218 221.999L149.133 221.915H149.091L149.049 221.746H149.091H149.133H149.218L149.344 221.704H149.386V221.662H149.513L149.555 221.621L149.724 221.535L149.766 221.579L149.849 221.535L149.933 221.494L149.975 221.41L150.018 221.368H150.102V221.41H150.144H150.186L150.228 221.452H150.313L150.397 221.494L150.522 221.535H150.607L150.649 221.621V221.662H150.691L150.733 221.704H150.691V221.746L150.775 221.788L150.733 221.83V221.873H150.775H150.818H150.86L150.902 221.915V221.957L150.944 221.915V221.957H151.028H151.07L151.197 222.041H151.238L151.322 221.999L151.364 222.041V222.083L151.407 222.126V222.083V222.126H151.449L151.364 222.168V222.21H151.407H151.449H151.575L151.449 222.335V222.42L151.322 222.546L150.986 222.924L150.27 223.977L150.186 224.104L150.144 224.188L150.06 224.272L150.018 224.357L149.849 224.693L149.68 225.03L149.513 225.324L149.386 225.619L149.302 225.746L149.049 226.335L148.881 226.713L148.797 226.924L148.713 227.135L148.46 227.808L148.377 228.019L148.291 228.229V228.313L148.208 228.44L148.166 228.608L147.997 229.113L147.871 229.408L147.702 229.702L147.491 230.082L147.029 230.671L146.819 230.966L146.271 231.766L145.597 232.691L145.555 232.775L145.177 233.365L145.008 233.617L144.798 233.828L144.503 234.164L144.293 234.417L143.999 234.669L143.872 234.755L143.324 235.217L142.819 235.68L142.482 235.933L142.399 236.058L142.188 236.311L142.019 236.522L141.557 236.858L141.093 237.238L140.673 237.533L140.293 237.742L139.704 238.08L139.115 238.374L138.526 238.711L138.104 239.006L137.852 239.216L137.515 239.553L136.926 240.184L136.884 240.311V240.478L136.757 240.311L136.632 240.353L136.421 240.522L136.21 240.647L135.957 240.942L135.748 241.195L135.453 241.616L135.243 241.994L135.074 242.415L134.779 243.173L134.737 243.384L134.61 243.973L134.484 244.394L134.19 245.067L133.937 245.489L133.643 246.12L133.474 246.414L133.264 246.709L132.801 247.298L132.421 247.635L130.906 248.856L130.233 249.445L129.643 249.909L129.475 250.034L128.843 250.456H128.801L128.717 250.498L128.676 250.456H128.592H128.549L128.507 250.414V250.371L128.465 250.245V250.161L128.423 250.119L127.917 250.076H127.876V250.034L127.917 249.992L127.876 249.951V249.909L127.834 249.824L127.876 249.782L127.917 249.698L127.834 249.614L127.876 249.529L127.917 249.487V249.067L128.001 248.603L128.044 247.93L127.917 247.298L127.959 246.667L128.381 246.036L128.97 245.698L129.265 245.741L129.643 245.278L129.265 245.151L129.39 245.025L129.434 245.109H129.39L129.434 245.151H129.475L129.39 245.025L130.023 244.731L130.19 244.478L130.148 244.436L130.275 244.309L130.654 244.225L130.738 244.015L130.106 243.467V243.509L130.065 243.467L130.023 243.425L129.812 243.384L129.686 243.3L129.643 243.131L129.475 243.173L129.434 243.258H129.39L129.348 243.215L129.307 243.173L129.181 243.089L129.096 243.047L129.012 243.089H128.97L128.886 242.962H128.843L128.759 243.047L128.634 242.962L128.592 242.92V242.878H128.549L128.507 242.92L128.423 242.752L128.339 242.625V242.584L128.296 242.5V242.458V242.373H128.254H128.212H128.044L127.959 242.415V242.373L127.917 242.415L127.792 242.331V242.289H127.707L127.665 242.205L127.539 242.163V242.078L127.454 242.036L127.37 241.953V241.867V241.826L127.159 241.742L127.201 241.7L127.245 241.531L127.201 241.447V241.363L127.118 241.32V241.278H127.159L127.201 241.195L127.118 241.153V241.069L127.034 241.026L126.992 240.942V240.816L126.907 240.689L126.865 240.647V240.605H126.823L126.781 240.563L126.823 240.522L126.739 240.478V240.436L126.697 240.395L126.739 240.269H126.612L126.655 240.226V240.184L126.57 240.016L126.612 239.974L126.57 239.931L126.655 239.974L126.697 239.931L126.57 239.889V239.805H126.487V239.764L126.445 239.805L126.403 239.764L126.318 239.722L126.276 239.764V239.722H126.192L126.107 239.678H126.065L126.023 239.637L125.981 239.553H125.939L125.981 239.511L125.939 239.469H125.897V239.384V239.342V239.3L125.812 239.258L125.77 239.3L125.645 239.258L125.603 239.174L125.518 239.133V239.089L125.392 239.047L125.308 239.006H125.265H125.223L125.139 238.922V238.88H125.181V238.837H125.223V238.795H125.181L125.139 238.753H124.97L124.929 238.711H124.887V238.669H124.845L124.803 238.627H124.761H124.803H124.761H124.718L124.676 238.669H124.634V238.711L124.55 238.795L124.508 238.753L124.423 238.88V238.837H124.339V238.795L124.298 238.753H124.339L124.298 238.711L124.087 238.627V238.542L124.003 238.458L122.15 237.069L122.192 236.985L122.15 236.944L122.109 236.9L122.067 236.817L122.15 236.775V236.733V236.775V236.733L122.109 236.648L122.067 236.691L122.025 236.564L121.983 236.522L121.898 236.48L121.94 236.438L121.772 236.185L121.73 236.144L121.687 236.1H121.561V236.058H121.519V236.017L121.392 235.975V235.891L121.35 235.849V235.806H120.803L120.719 235.722H120.678L120.636 235.68L120.592 235.722H120.509L120.467 235.638L120.256 235.596L120.088 235.68L120.003 235.638L119.961 235.68H119.836L119.794 235.722L119.667 235.554H119.625L119.667 235.511L119.541 235.427L119.456 235.344H119.498L119.456 235.302H119.414V235.344H119.372L119.247 235.302L119.203 235.344H119.161V235.259H119.203L119.161 235.217V235.175L119.036 235.133V235.091L119.078 235.049V235.006L119.036 234.964L118.909 234.922L118.867 234.88L118.909 234.838L118.867 234.796L118.783 234.755L118.825 234.711H118.783V234.669L118.741 234.628V234.586V234.628L118.656 234.586L118.572 234.628L118.53 234.669H118.572V234.711V234.755L118.489 234.88L118.447 234.922H118.403V234.964V235.006H118.32L118.278 234.964L118.152 234.922L118.109 234.88H118.025V234.838H117.983H117.941L117.814 234.755V234.711H117.772H117.73L117.772 234.669L117.73 234.628H117.647V234.586L117.309 234.544H117.267V234.502H117.225V234.291L117.183 234.249L117.225 234.207L117.141 234.122H117.014V234.08L117.099 234.038L117.058 233.996L116.972 233.955V233.911H117.014L116.972 233.869V233.828L116.889 233.786L116.847 233.828H116.805V233.786H116.762L116.72 233.744H116.678V233.66H116.72V233.617V233.575V233.533L116.762 233.449H116.678L116.594 233.322V233.365L116.552 233.322L116.594 233.28V233.155H116.552L116.467 233.113V233.028H116.425H116.383L116.3 233.07H116.258V233.028L116.214 232.986H116.131L116.047 232.944L116.089 232.86L116.131 232.817V232.775L116.089 232.733H116.047V232.649H115.963L115.92 232.566L115.794 232.607L115.752 232.566V232.522V232.439L115.668 232.397L115.625 232.355V232.271L115.5 232.228L115.458 232.271V232.228L115.373 232.186L115.331 232.102L115.289 232.06V231.975L115.247 231.891H115.205V231.849H115.163L115.12 231.891L115.036 231.933H114.994V231.891H114.91L114.869 231.933H114.825L114.783 231.975L114.742 232.06L114.7 232.018L114.658 232.102L114.742 232.144H114.7V232.228L114.783 232.313L114.742 232.397H114.7L114.658 232.48L114.7 232.522L114.658 232.566V232.607H114.574H114.489V232.566L114.447 232.522L114.405 232.607H114.363L114.321 232.522H114.278L114.321 232.566H114.278V232.691L114.236 232.733L114.278 232.775H114.152V232.817L114.111 232.902L113.984 232.86L114.025 232.944L113.942 232.986H113.774H113.731V233.028L113.647 233.155V233.197L113.521 233.155L113.479 233.197L113.394 233.365H113.311V233.407H113.269L113.184 233.322L113.142 233.365H113.058L113.016 233.407L112.974 233.449L112.847 233.407L112.721 233.365L112.636 233.407V233.449L112.511 233.407V233.365L112.469 233.197V232.902L112.511 232.775L112.553 232.733L112.511 232.691V232.607V232.566H112.469L112.553 232.397L112.511 232.355V232.228L112.636 232.06V231.975L112.594 231.933L112.553 231.891L112.511 231.766L112.469 231.722V231.68H112.511L112.427 231.639V231.555V231.513H112.342V231.471H112.3H112.258L112.174 231.428V231.386V231.302L112.132 231.26H112.089L112.005 231.344H111.963L111.922 231.176H111.88L111.795 231.218H111.753V231.176L111.795 231.091H111.753L111.711 231.049L111.627 231.008V230.924L111.711 230.881V230.839H111.627L111.542 230.755L111.5 230.671L111.542 230.586L111.458 230.544L111.416 230.502L111.5 230.418L111.374 230.377H111.205L111.163 230.333L111.122 230.291V230.25H111.163V230.208L111.08 230.166H111.038L110.996 230.25H110.953V230.166L110.996 230.124L110.953 230.082L110.911 230.039L110.869 230.082H110.827V230.039L110.785 229.955V229.913V229.871L110.743 229.829V229.871L110.658 229.913L110.532 229.871H110.491V229.786L110.405 229.744V229.702L110.364 229.66H110.322V229.702H110.196L110.153 229.66H110.196V229.618H110.111V229.535L110.069 229.491V229.45H110.111V229.366H110.027L109.985 229.239L109.943 229.282H109.858L109.774 229.197L109.816 229.155L109.774 229.113L109.691 228.944L109.606 228.987L109.564 229.071H109.522L109.48 228.987L109.438 228.944V228.86L109.353 228.819H109.185V228.777L109.143 228.692L109.227 228.65V228.524L109.185 228.482L109.143 228.566L109.016 228.44V228.355L108.891 228.397H108.849L108.764 228.44L108.722 228.397L108.807 228.313L108.764 228.188L108.68 228.229L108.596 228.144H108.638H108.68V228.102L108.596 228.019L108.554 227.935H108.427V227.893L108.554 227.85V227.808L108.511 227.85L108.469 227.808V227.766L108.385 227.808L108.343 227.766L108.258 227.808L108.175 227.724V227.64H108.133L108.049 227.597L107.88 227.555H107.754L107.712 227.471L107.754 227.346V227.302L107.627 227.261L107.585 227.177H107.502L107.46 227.135L107.375 227.093H107.291H107.165V227.051H107.08L106.954 227.219V227.177L106.912 227.219V227.177L106.869 227.135L106.785 227.093L106.66 227.135H106.533L106.491 227.051H106.407H106.238L106.196 227.093V227.177H106.113L106.027 227.135H105.944V227.093H105.986V227.051H105.944L105.86 227.135L105.818 227.219H105.86L105.818 227.261H105.775L105.649 227.219V227.302H105.733V227.388L105.649 227.429H105.565L105.48 227.597L105.396 227.682V227.766H105.313V227.85L105.355 227.893H105.313H105.355V227.935L105.396 228.019L105.355 228.061L105.313 228.102H105.271L105.144 228.188L105.102 228.313L105.018 228.355H104.849L104.807 228.313V228.271L104.765 228.229L104.723 228.271V228.313L104.638 228.397H104.596L104.555 228.313L104.471 228.188L104.429 228.144L104.386 228.229L104.176 228.313L104.133 228.229L104.091 228.271L103.965 228.355V228.44H103.924H103.838H103.755V228.355L103.797 228.313L103.713 228.271H103.587L103.502 228.229H103.376H103.334L103.291 228.355L103.124 228.313L102.955 228.271L102.913 228.188L102.871 228.144L102.913 227.893L102.871 227.85L102.576 227.724L102.449 227.682L102.366 227.724L102.449 227.64H102.744L102.955 227.555L103.376 227.302L103.502 227.177L103.587 226.966L103.713 226.84L103.838 226.713L104.218 226.503L104.344 226.335Z"
							fill="#3482cc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="BA" @mouseenter="e => hoverES(e, 'BA')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M170.813 106.997L170.771 106.955V106.871H170.813L170.854 106.744L170.813 106.66L170.981 106.619L171.487 106.366H171.571L171.654 106.24L171.781 106.029L171.823 105.608L171.949 105.271L172.076 105.146V105.019H172.118L172.243 104.935L172.287 104.851L172.329 104.808L172.539 104.682L172.623 104.555L172.834 104.43V104.388L172.749 104.219V104.177L172.792 104.051L172.834 103.966L172.876 103.924L173.043 103.84L173.129 103.798L173.17 103.713V103.546L173.043 103.504H173.002L173.254 103.335L173.381 103.251L173.423 103.082V103.04L173.381 102.999L173.296 102.872L173.254 102.83V102.788L173.338 102.746L173.423 102.704V102.662L173.549 102.619L173.591 102.662L173.718 102.619H173.843L173.97 102.493L174.096 102.535L174.181 102.493L174.223 102.451V102.324L174.391 102.282L174.432 102.114L174.476 102.072H174.601L174.685 102.03H174.77L174.812 101.904L174.896 101.862L175.149 101.693L175.191 101.609L175.276 101.524L175.401 101.441H175.612H175.654L175.696 101.272L175.612 101.146L175.654 101.062V101.02V100.977H175.696L175.78 100.935L175.865 100.893H176.117L176.201 100.851L176.285 100.683L176.37 100.473L176.412 100.388L176.454 100.346V100.304V100.177V100.01L176.412 99.8407L176.454 99.7988V99.715H176.327L176.285 99.6299H176.327H176.412H176.538L176.621 99.588L176.748 99.4624H176.832L177.043 99.3354H177.085L177.169 99.4205L177.254 99.5462V99.6731V99.8407V99.9258L177.338 100.052L177.507 100.177L177.548 100.22V100.43L177.59 100.473L177.716 100.557L177.759 100.599L177.843 100.641L177.927 100.81L178.096 100.935L178.138 101.02L178.096 101.23L178.138 101.357L178.306 101.482V101.568L178.263 101.609L178.096 101.777L178.012 101.904L178.054 101.988V102.114L178.012 102.199L178.054 102.324L178.096 102.619V102.662L178.138 102.704L178.179 102.746H178.221L178.306 102.788H178.39L178.432 102.872L178.474 102.913V102.957L178.558 103.335L178.769 103.504L178.979 103.546L179.106 103.588V103.63L179.19 103.84L179.232 103.882H179.401L179.443 103.924V103.966H179.485L179.821 104.008H179.948H180.074L180.116 104.051L180.243 104.008H180.327L180.368 104.051L180.452 104.093L180.495 104.135L180.579 104.177L180.663 104.303H180.747H180.79L180.916 104.346H180.958V104.388L181.21 104.598L181.337 104.471H181.379L181.421 104.43H181.505L181.632 104.303H181.674L181.716 104.388L181.885 104.261L181.926 104.219L181.968 104.177V104.051L182.094 103.798H182.136H182.263V103.671L182.305 103.63L182.432 103.588L182.474 103.546L182.557 103.504L182.726 103.546L182.852 103.504V103.461L182.894 103.335L182.81 103.082H182.852V103.04L182.894 102.999L182.979 102.957H183.021H183.105L183.188 102.913L183.23 102.872L183.315 102.704L183.399 102.662H183.568L183.736 102.788H183.779H183.821H183.863L183.988 102.746L184.074 102.662L184.115 102.577L184.157 102.535H184.199L184.368 102.577L184.494 102.535L184.536 102.493L184.788 102.199L184.83 102.157H184.915L184.999 102.199L185.041 102.241L185.083 102.282L185.21 102.535L185.336 102.619L185.463 102.662H185.504L185.63 102.577H185.672L185.799 102.662L185.883 102.704L185.968 102.746H186.01H186.052L186.136 102.704H186.177L186.219 102.619L186.304 102.451L186.346 102.409H186.472L186.514 102.366L186.557 102.282L186.683 101.862L186.725 101.819L186.81 101.735V101.693L186.767 101.482L186.81 101.315L186.852 101.23H186.935L187.019 101.272L187.188 101.357H187.357H187.483V101.315L187.525 101.104L187.608 101.02L187.652 100.893L187.693 100.851L187.777 100.768L187.904 100.683L187.988 100.599V100.43V100.346V100.304V100.262V100.22L188.241 99.9677L188.366 99.7988L188.408 99.5043V99.3786L188.366 99.2935L188.452 99.1678L188.493 99.1259H188.661H188.872V99.0408L188.914 98.9151L189.041 98.8313L189.083 98.6624L189.041 98.5786L188.956 98.5354L188.83 98.4098L188.914 98.2409V98.199L188.872 98.1571H188.788V98.0733V98.0314H188.872V97.9463L188.999 97.9044L189.041 97.8206V97.7368L189.124 97.6517V97.6098L189.041 97.526L188.956 97.4841L188.872 97.399H188.788H188.746L188.703 97.3153L188.452 97.2315L188.408 97.1896L188.325 97.1464L188.241 96.895V96.8099V96.768V96.6842L188.072 96.3896L187.946 96.3477L187.988 96.2626V96.2208H188.03L187.946 96.1789V96.01L187.904 95.8424V95.7573L188.114 95.4208L188.241 95.337L188.325 95.1681L188.408 95.0844L188.535 95.0425L188.914 94.9155L189.041 94.8317L189.293 94.6209L189.377 94.579L189.503 94.4101L189.63 94.2844H189.672L189.797 94.2425H189.841L189.924 94.1587L190.093 93.9899L190.177 93.948L190.303 93.9061L190.388 93.948H190.43L190.514 93.9899L190.682 94.2006L190.724 94.2844L190.85 94.4952L190.977 94.6209H191.103H191.145L191.23 94.7479L191.313 94.7898H191.355L191.397 94.9574H191.439H191.482L191.524 94.8736H191.692L191.777 94.8317H191.819H191.903L191.944 94.9155L191.986 94.9574L192.113 94.8736L192.197 94.6628H192.281L192.366 94.7479V94.6628H192.408L192.45 94.6209L192.492 94.6628H192.534V94.706H192.577L192.661 94.7479V94.7898H192.703H192.786H192.828V94.9155L193.081 94.8736H193.124L193.25 94.8317L193.334 94.8736L193.419 94.9574V95.0006L193.461 95.0425L193.419 95.1681V95.2532L193.461 95.4208L193.502 95.5046V95.5478L193.628 95.6316H193.755L193.839 95.6735L193.966 95.8424H194.008H194.05L194.133 95.7573H194.175L194.217 95.8424V95.9681L194.302 96.0951V96.2208H194.386L194.639 96.1789L194.681 96.137V96.01L194.766 95.9681L194.85 95.8843L194.933 95.8005V95.6735V95.6316L194.975 95.6735L195.102 95.7154V95.7573H195.186L195.312 95.7154H195.397L195.481 95.6735L195.523 95.7154L195.65 95.5478L195.691 95.4627L195.733 95.4208L195.86 95.4627L195.986 95.4208L196.155 95.4627L196.322 95.4208L196.364 95.337L196.322 95.2532L196.364 95.21L196.449 95.1681L196.575 95.21L196.617 95.1681L196.702 95.1263L196.744 95.0844V94.9155L196.786 94.8736L196.912 94.7898L197.081 94.706L197.122 94.6628H197.164V94.4952L197.375 94.3682L197.417 94.2844H197.459L197.586 94.2425H197.712L197.753 94.2006L197.88 94.1155L197.964 94.0736H198.006L198.091 94.1155H198.175L198.259 94.0736H198.511H198.638L198.764 94.0318L198.975 93.9061H199.059H199.143L199.228 93.8642L199.395 93.948L199.564 93.821L199.648 93.948H199.69H199.775L199.859 94.0318H199.901L199.942 93.9899L199.986 93.9061L200.111 93.8642L200.195 93.7791H200.237L200.322 93.821H200.406L200.49 93.4426L200.617 93.3156V93.1899L200.742 93.0642H200.784L200.869 92.9791L201.037 92.8535V92.6846V92.5589L201.08 92.39V92.3481H201.375L201.417 92.2643V92.1792L201.669 92.1373H201.711V92.0535H201.795L201.837 91.9697H201.879H201.922H201.964H202.048L202.09 92.0535L202.217 92.0116V91.8428L202.3 91.8009L202.342 91.632H202.384L202.426 91.5482V91.4644L202.469 91.4225V91.3793H202.511L202.553 91.2536H202.637L202.721 91.1698L202.89 90.959L202.931 91.0009L203.016 90.7901L203.1 90.6226L203.142 90.4956L203.226 90.4118V90.3699H203.311H203.353L203.521 90.4956H203.648L203.773 90.5807H203.815L203.9 90.5375L203.984 90.4537H204.111V90.4118L204.153 90.3699H204.195L204.32 90.4118L204.362 90.3699L204.406 90.4118L204.447 90.3699L204.489 90.4118L204.531 90.3699L204.573 90.4118L204.868 90.3699L204.826 90.4537V90.4956L204.784 90.5375V90.5807L204.826 90.6645L204.868 90.7064V90.7483L204.91 90.7901L204.953 90.8752H205.079V90.9171L205.12 90.8752H205.162H205.247H205.331H205.373L205.415 91.0428L205.373 91.2117L205.457 91.2536L205.584 91.1698H205.626L205.71 91.1266L205.837 91.1698V91.2536H205.92L206.089 91.2117V91.2955L206.173 91.3793H206.215V91.4225V91.5482L206.299 91.632V91.7171L206.426 91.759V91.9265H206.509V92.1373L206.551 92.2211L206.595 92.3062L206.636 92.39V92.4319V92.4738L206.678 92.517V92.6427L206.72 92.6846L206.678 92.7697L206.762 92.8116L206.804 92.8954H206.889V92.9373L206.973 92.8954L207.057 92.9373H207.099V93.021H207.142L207.226 93.0642L207.351 93.148H207.393H207.52L207.562 93.2318L207.646 93.2737L207.604 93.3588V93.4426V93.4845L207.562 93.5683V93.6115L207.478 93.7372L207.52 93.821V93.9061H207.562V93.9899L207.52 94.0318L207.393 94.0736V94.1155V94.1587L207.309 94.2006L207.184 94.1587V94.2006H207.142L207.099 94.2425L207.226 94.4101L207.184 94.4533L207.226 94.5371L207.142 94.6209L207.184 94.706V94.7898V94.8317H207.142L207.057 94.8736V95.0006L207.015 95.0844L206.973 95.1681L207.142 95.0844H207.309L207.351 95.1263L207.562 95.2532L207.731 95.2951L207.899 95.337L208.109 95.2532H208.193H208.236L208.278 95.21L208.362 95.1263H208.404L208.446 94.9574L208.488 94.9155L208.615 94.8736H208.657H208.698L208.825 94.9155L208.867 94.9574L208.951 94.8317L209.078 94.579L209.162 94.4952H209.246L209.373 94.6209L209.498 94.6628H209.54L209.709 94.4952V94.3682V94.3263L209.793 94.0736L209.878 93.9899L209.962 93.5264L210.004 93.4007L209.962 93.2318L210.004 93.021L210.088 92.7697L210.215 92.6427L210.256 92.6008H210.34H210.382L210.425 92.6427H210.467L210.593 92.7697L210.72 92.8535L210.762 92.9373H210.846H210.973L211.224 92.8116L211.309 92.7265L211.393 92.6427H211.562H211.771H211.814L211.898 92.6008L212.024 92.5589L212.277 92.2643L212.318 92.2211L212.362 92.0954L212.445 92.0535L212.571 91.8009L212.529 91.632L212.404 91.3793V91.3374V91.2955V91.2117L212.445 91.1698L212.571 91.1266L212.909 91.0428L212.993 91.0847H213.076L213.329 90.9171L213.624 90.959H213.709L213.751 90.9171L213.793 90.8752L213.835 90.832L213.793 90.7064V90.6226V90.5807L213.751 90.3699L213.666 90.201L213.709 90.0753H213.876H213.96L214.087 90.0321H214.213L214.466 89.9483V89.9064L214.507 89.8645L214.551 89.8226L214.718 89.7807L214.76 89.7375L215.013 89.6538L215.14 89.57V89.4862L215.182 89.443H215.265H215.349L215.392 89.3173H215.434L215.602 89.2754H215.645H215.687L215.729 89.3173L215.771 89.3592L215.855 89.443H215.94H216.107H216.192L216.234 89.4862L216.276 89.57V89.6119V89.6538L216.318 89.7807L216.402 89.8226L216.444 89.8645L216.487 89.9483L216.444 89.9902V90.201V90.2429L216.487 90.328L216.529 90.3699L216.571 90.4118H216.613V90.3699L216.74 90.4118L216.865 90.3699L216.907 90.328L216.949 90.2848L217.034 90.3699V90.4118L217.202 90.4537L217.413 90.4956L217.581 90.5375L217.749 90.5807H217.791L217.876 90.6645L218.044 90.7483L218.129 90.9171L218.213 90.959L218.254 91.0009H218.296H218.338L218.465 90.959L218.718 90.9171L218.802 90.8752H218.885L219.18 90.9171H219.223L219.265 90.959L219.433 91.0847L219.602 91.2536L219.727 91.2955L219.812 91.3793L219.854 91.5063L219.896 91.7171V91.8428L219.938 91.9265L220.023 92.0954L220.191 92.1792L220.275 92.1373H220.318L220.402 91.9697V91.5901L220.443 91.5063L220.654 91.1698L220.78 91.1266L221.033 91.1698L221.201 91.2955L221.285 91.3793L221.243 91.5482L221.201 91.632L221.033 91.759L220.991 91.8009V91.8428L220.949 91.8846V91.9265L220.991 92.0116L221.074 92.1373L221.201 92.2643L221.369 92.39L221.454 92.4319L221.538 92.4738L221.664 92.517L221.791 92.39L221.959 92.2211H222.001L222.085 92.1792H222.212V92.2643L222.338 92.39L222.38 92.517V92.5589L222.338 92.6008L222.212 92.6846L222.169 92.7697L222.212 92.8535H222.296L222.169 92.9791L222.212 93.148L222.254 93.1899L222.296 93.2318L222.38 93.3588L222.464 93.5683L222.422 93.6534L222.632 94.1155L222.716 94.3682L222.885 94.5371L222.927 94.6628L222.969 94.706V94.7898L222.927 94.8317V94.9155L222.969 94.9574H223.096L223.222 95.0844L223.305 95.0425L223.432 95.0844L223.474 95.0425H223.516L223.685 95.0844H223.727V95.1263L223.769 95.1681H223.811L223.896 95.2532H223.98H224.021L224.105 95.337L224.19 95.4208L224.148 95.5478L224.105 95.6316V95.6735L224.063 95.7154L224.021 95.7573L224.063 95.8005V95.8424L224.021 95.8843V95.9262L223.98 95.8843L223.938 95.9262V95.9681V96.0951L223.98 96.1789L224.063 96.2208L224.105 96.2626L224.148 96.3045L224.232 96.3477L224.274 96.3896L224.232 96.4315H224.19H224.148L224.063 96.5153L224.021 96.5991L223.938 96.6423V96.6842V96.7261V96.8099V96.9369V97.0626L224.021 97.2315H224.063V97.2734L224.19 97.399L224.316 97.4422H224.358L224.4 97.4841L224.358 97.5679L224.316 97.6517L224.358 97.6936V97.7368L224.274 97.8206V97.9463L224.19 98.0733V98.1152L224.274 98.1571L224.4 98.4098L224.443 98.4517H224.485L224.569 98.4098H224.653V98.4935H224.696H224.78L224.905 98.5354L224.947 98.4935L225.243 98.6624L225.285 98.7462V98.8313V98.8732V98.9989L225.452 99.3354L225.579 99.5043V99.588L225.538 99.7988V99.8407L225.621 99.8826L225.789 100.683V100.724L225.832 100.768L225.663 100.851H225.538L225.494 100.893L225.369 100.977H225.327L225.285 101.02V101.062H225.243H225.2V101.104L225.158 101.146V101.188H225.2L225.074 101.23L225.116 101.315L225.074 101.357L225.285 101.735L225.327 101.862V101.904V101.946L225.285 102.03V102.114V102.072L225.243 102.114V102.157H225.158V102.199L225.2 102.241V102.282L225.243 102.324V102.366L225.327 103.082L224.569 103.377L224.358 103.461L224.19 103.546H224.021V103.377V103.335L223.938 103.251H223.896L223.853 103.166H223.811L223.685 103.208L223.643 103.166L223.601 103.124L223.516 103.208L223.432 103.166L223.39 103.251H223.305L223.222 103.208H223.18H223.096L223.054 103.124L222.927 103.166H222.885L222.843 103.251V103.335V103.419V103.504L222.801 103.63L222.758 103.713H222.716L222.674 103.757L222.716 103.84L222.674 103.924H222.716L222.758 104.051L222.716 104.093L222.674 104.177V104.261L222.758 104.388V104.513L222.843 104.555V104.598L222.885 104.555H222.927V104.64L223.054 104.682V104.724L223.011 104.808L223.054 104.851L223.096 104.935L223.263 105.019L223.305 105.102L223.349 105.146H223.39V105.061L223.474 105.102L223.516 105.146V105.188L223.558 105.271H223.516V105.313L223.558 105.355H223.601V105.397H223.643V105.44H223.685V105.524L223.643 105.65H223.601V105.693L223.643 105.777L223.727 105.819H223.769V105.86L223.727 105.946L223.769 105.987L223.727 106.029L223.811 106.071L223.896 106.155L223.98 106.197L224.021 106.155L224.148 106.282L224.19 106.24L224.274 106.282H224.316H224.358L224.316 106.324V106.366V106.408V106.45L224.274 106.492H224.232L224.274 106.577H224.232V106.619H224.274V106.66L224.232 106.702L224.274 106.744L224.232 106.787V106.829L224.148 106.871V106.955L224.232 107.082H224.19V107.124L224.274 107.166H224.19V107.208L224.232 107.25L224.274 107.208V107.25L224.316 107.377L224.358 107.418V107.46L224.316 107.502V107.544H224.4V107.629L224.443 107.586H224.485V107.629H224.443L224.485 107.671L224.527 107.713V107.755H224.569V107.671H224.611V107.629H224.696L224.738 107.671H224.78V107.755V107.797L224.821 107.839L224.863 107.797V107.839L224.905 107.755H224.947L225.032 107.797H224.947H224.905L224.99 107.839V107.882L225.116 107.839V107.882V107.924H225.074H225.032V107.966V108.008L225.074 108.049H225.116L225.158 108.133H225.2L225.285 108.176H225.327L225.369 108.218L225.327 108.26V108.344L225.411 108.386L225.452 108.344L225.494 108.386H225.579L225.621 108.429L225.663 108.386L225.747 108.471H225.874V108.555H225.916H225.958L226.042 108.513H226.085L226.042 108.639H226.127L226.21 108.681V108.639V108.597L226.294 108.513L226.252 108.429H226.294H226.336V108.344L226.379 108.386L226.421 108.344H226.463L226.505 108.429L226.547 108.471H226.589H226.632L226.716 108.429H226.758H226.8L226.758 108.513L226.8 108.555H226.842L226.8 108.513H226.842H226.883L226.927 108.555H226.969H227.179V108.471L227.263 108.386H227.347H227.516H227.558L227.641 108.344L227.81 108.218L227.936 108.091L228.063 107.966H228.105L228.147 107.882H228.231H228.274H228.231L228.274 107.924L228.231 108.008L227.978 108.26L227.81 108.513L227.347 109.48L227.179 109.775L226.883 110.491L226.547 111.207L226.505 111.417L226.336 111.669L226.21 111.88L226.127 112.007L226.085 112.133L226.042 112.217L225.663 112.849L225.538 113.017L225.2 113.48L224.947 113.858L224.905 113.9V113.944L224.863 114.027H224.821L224.696 114.238L224.527 114.448L224.443 114.575L224.358 114.743L224.274 114.911L224.148 115.122L224.063 115.164L223.98 115.248L223.896 115.333V115.458V115.5H223.811L223.769 115.585L223.685 115.627L223.601 115.753L223.39 115.964L223.096 116.384L222.969 116.469L222.843 116.637L222.716 116.764L222.632 116.889L222.549 117.016H222.464L222.338 117.142L222.212 117.353L222.043 117.522H221.959H221.916H221.832L221.749 117.564L221.538 117.689L221.369 117.858L221.243 117.9H221.16L221.074 117.858V117.9L220.865 117.858L220.569 117.816L220.696 117.522L220.738 117.395L220.696 117.311L220.36 117.395L220.443 117.564L220.36 117.689V117.731H220.318L220.233 117.858L220.191 117.9L220.107 118.026L220.065 118.069H220.023L219.854 118.195H219.77L219.685 118.278L219.643 118.363L219.602 118.405H219.56L219.518 118.447L219.433 118.573V118.616L219.307 118.658L219.223 118.7H219.265L219.18 118.742L219.096 118.784L218.929 118.869L218.844 118.911L218.802 118.994L218.676 119.036L218.549 119.12V119.163H218.465L218.38 119.205L218.296 119.331L218.213 119.626V119.667L218.171 120.005L218.213 120.173L218.296 120.3L218.338 120.342L218.507 120.215L218.549 120.258L218.591 120.342L218.549 120.384H218.591V120.467V120.552L218.633 120.594L218.676 120.678L218.633 120.72L218.676 120.762L218.591 120.889L218.507 120.847V120.931H218.549H218.591L218.549 120.973V121.015L218.423 121.1V121.183L218.38 121.394V121.478L218.423 121.52H218.507V121.562V121.604L218.591 121.647L218.549 121.689V121.815H218.633L218.676 121.773V121.815V121.942L218.633 122.025L218.507 122.152V122.109L218.465 122.025H218.38L218.296 122.109H218.171L218.213 122.152V122.236L218.171 122.278L218.044 122.404L218.002 122.573V122.825L218.086 123.078L218.171 123.204L218.296 123.414V123.456L218.38 123.498L218.423 123.625V123.793V123.836L218.338 124.214V124.298L218.296 124.509L218.254 124.636V124.72L218.129 125.098L218.086 125.309L218.044 125.434V125.561V125.603L218.002 125.856L218.044 125.982V125.94L218.086 125.982V126.067V126.109V126.151L218.044 126.193V126.234L217.96 126.403V126.572L217.876 126.909L217.834 127.245L217.749 127.414V127.623L217.707 127.792L217.665 127.876L217.581 128.298V128.55V128.718V129.014L217.665 129.181L217.749 129.223H217.791L217.834 129.14V129.223H217.791V129.35L217.749 129.392H217.791V129.35H217.834V129.603V129.856L217.876 130.107L217.918 130.234V130.318L218.002 130.571V131.202V131.918V132.087V132.212L218.044 132.465L218.002 132.507L218.044 132.549L218.129 133.096L218.254 133.559V133.601L218.296 133.643L218.338 133.981V134.401L218.38 134.823L218.465 135.159H218.507L218.591 135.454V135.496L218.633 135.538L218.802 135.874L218.844 135.917V135.959L218.802 136.001V136.043L218.885 136.085V136.127L218.844 136.17L218.802 136.254L218.676 136.465L218.507 137.054L218.38 137.348L218.296 137.601L218.254 137.643V137.812V137.896L218.296 138.021L218.254 138.063L218.213 138.19L218.171 138.232L218.129 138.358L218.044 138.401L217.918 138.568V138.61H217.876L217.834 138.779V138.821L217.918 138.695L217.834 138.906L217.876 139.074L217.918 139.116H217.96V139.158L217.918 139.243V139.41L217.834 139.452L217.749 139.537L217.623 139.748V139.874L217.581 139.916V139.958L217.623 139.916V139.958V140.043L217.581 140.085V140.168L217.454 140.421V140.59L217.413 140.799V140.884V141.01L217.371 141.137L217.413 141.179L217.329 141.263V141.432V141.557H217.287L217.244 141.599L217.202 141.684V141.768L217.16 141.81H217.118V141.852L217.076 142.105L217.118 142.526L217.202 142.652L217.287 142.736L217.202 142.779L217.034 143.032V143.283L216.907 143.494V143.746L216.949 143.788L216.907 143.83L216.865 143.915V144.083L216.823 144.168L216.74 144.21L216.696 144.294L216.655 144.463V144.925V145.01L216.613 145.221L216.655 145.557V145.683L216.696 145.977L216.782 146.272V146.693L216.823 146.988L216.782 147.03V147.114L216.823 147.366L217.118 147.788H217.16L217.118 147.83L216.823 148.083L216.865 148.208L216.74 148.293L216.696 148.377L216.36 148.714L216.318 148.799V148.882L216.36 148.924L216.318 148.966L215.982 149.135H215.897L215.855 149.093L215.771 149.135L215.687 149.219H215.645L215.518 149.261L215.224 149.43L215.055 149.597L214.929 149.766L214.76 150.061L214.593 150.397L214.551 150.355H214.507H214.424V150.313H214.382L214.424 150.397L214.507 150.355L214.466 150.397L214.507 150.482L214.551 150.439L214.34 150.735L214.045 151.282V151.366L213.918 151.619V151.661L213.876 151.829L213.918 151.871L213.835 152.039V151.997V151.913L213.793 151.871L213.709 151.829L212.318 150.944L212.277 150.903L212.109 150.777L211.393 150.313L210.382 149.682V149.513L210.298 149.472L210.173 149.388L210.131 149.345V149.303L210.467 149.135L210.677 148.841V148.799L210.635 148.714L210.551 148.672L210.509 148.714L210.551 148.63L210.509 148.546L210.425 148.461L210.467 148.377L210.425 148.293L210.467 148.208L210.382 148.083H210.298H210.256L210.215 147.999L210.088 148.041L210.046 147.999L210.004 147.872H209.962L209.92 147.83V147.704L209.878 147.661L209.793 147.619L209.751 147.577L209.793 147.493L209.709 147.451L209.667 147.366L209.625 147.324V147.408L209.582 147.535L209.54 147.451L209.457 147.324H209.415L209.331 147.408L209.288 147.324L209.204 147.283V147.199V147.157H209.246L209.204 147.072L209.246 147.03H209.12L209.036 147.114L208.909 147.03L208.825 146.819L208.784 146.777L208.74 146.735L208.784 146.652V146.525H208.698V146.441H208.657L208.573 146.314V146.272V146.23L208.362 146.188L208.278 146.104L208.193 146.062L208.067 146.104L208.026 146.062L207.899 145.977L208.067 145.894V145.852V145.81V145.725L208.026 145.683L208.109 145.599L208.026 145.557V145.472H208.109V145.388H208.151L208.236 145.262L208.404 145.221L208.278 145.135V145.052L208.236 145.01V144.925H208.278L208.32 144.883L208.278 144.757L208.362 144.673V144.588L208.236 144.546L208.193 144.336L208.278 144.21L208.32 143.957V143.915H208.236V143.873V143.788L208.362 143.536V143.494V143.452L208.404 143.283H208.446L208.573 143.157L208.657 142.946L208.74 142.779V142.652L208.825 142.61H208.951V142.652L208.993 142.694H209.078H209.12L209.204 142.736H209.246L209.288 142.694H209.331L209.457 142.652L209.498 142.61L209.625 142.694V142.736H209.667L209.751 142.821L209.793 142.779H209.835L209.92 142.694L209.962 142.779H210.046L210.088 142.694V142.568L210.131 142.526V142.484H210.215V142.441L210.256 142.399L210.215 142.357V142.274L210.173 142.232V142.147L210.088 142.105L210.004 142.147L209.962 142.105H209.793L209.709 142.063L209.625 142.021L209.709 141.979L209.793 141.768L209.878 141.726V141.599L209.92 141.516L209.878 141.474L209.835 141.432V141.347L209.92 141.179L209.962 140.968L210.004 140.884V140.843L210.088 140.674H210.173L210.215 140.632L210.256 140.674V140.632L210.298 140.59H210.34L210.467 140.674H210.551V140.632L210.593 140.674L210.72 140.716H210.804V140.674V140.59H210.762V140.463H210.72L210.677 140.421H210.72V140.337H210.762L210.804 140.295L210.929 140.168L211.014 140.001H211.056L211.098 139.916L211.14 139.79L211.182 139.705L211.224 139.79L211.182 139.874H211.224L211.267 139.958L211.351 139.916L211.393 139.832V139.748H211.477L211.52 139.621V139.579L211.562 139.495L211.646 139.285L211.687 139.243L211.729 139.201V139.158L211.814 139.116V139.032L211.856 138.99H211.898V139.032H211.94L211.982 139.074H212.024L212.067 138.906L212.151 138.863L212.193 138.821H212.318L212.277 138.695L212.235 138.654L212.193 138.568L212.318 138.401V138.358L212.404 138.316V138.274L212.487 138.232L212.529 138.063L212.487 137.979H212.445L212.404 137.896H212.445L212.487 137.937H212.529V137.896L212.656 137.812V137.727L212.614 137.685V137.601H212.529V137.516L212.487 137.432L212.404 137.39V137.306L212.277 137.179H212.193V137.138L212.277 137.012H212.318H212.277L212.235 136.969H212.067H212.024V137.054H211.898V136.969H211.814V137.012H211.771V136.969H211.729L211.687 136.885H211.646V136.927H211.604V136.885H211.562L211.604 136.843H211.562H211.52L211.477 136.801H211.52L211.477 136.759H211.393V136.717H211.435L211.393 136.674V136.632L211.351 136.59L211.309 136.632V136.59H211.351V136.506V136.548L211.393 136.421H211.351L211.309 136.506H211.267L211.224 136.465L211.267 136.379V136.338L211.182 136.379V136.421H211.14H211.098L211.056 136.379L210.973 136.421H210.929V136.338L210.887 136.379H210.846H210.804V136.421H210.762V136.379L210.72 136.421L210.677 136.379L210.762 136.338V136.17H210.72L210.593 136.085L210.551 136.127V136.085H210.509V136.001H210.467V135.959H210.425V135.874H210.382V135.832L210.34 135.748H210.298L210.215 135.79H210.173H210.131L210.088 135.832L210.046 135.79L209.962 135.832H209.835H209.793H209.751L209.709 135.874L209.667 135.832H209.625L209.582 135.79L209.498 135.832L209.457 135.874L209.415 135.832H209.331L209.288 135.79V135.832L209.204 135.748V135.79L209.162 135.748L209.12 135.58L208.993 135.454H208.951L208.909 135.412L208.825 135.538L208.784 135.58L208.74 135.538L208.698 135.496L208.615 135.538L208.573 135.623V135.707H208.446L208.362 135.748H208.278L208.236 135.665L208.278 135.58L208.109 135.538V135.496L208.026 135.454L208.067 135.412V135.37L208.026 135.327H207.984L207.899 135.201H207.857L207.815 135.285H207.773L207.689 135.117L207.562 135.076V135.032L207.478 134.907H207.436V134.865H207.393L207.309 134.907H207.226L207.184 134.99L207.226 135.076H207.184L207.142 135.117L207.015 135.159L206.931 135.117L206.889 135.032L206.931 134.949L206.889 134.865L206.72 134.78V134.738H206.636V134.78V134.907H206.595L206.551 134.99L206.509 134.949L206.468 134.99L206.299 135.032H206.257H206.173L206.131 134.823H206.047H206.004H205.962H205.878L205.795 134.738V134.823L205.753 134.865L205.71 134.907V135.032H205.668L205.542 135.159H205.373L205.247 135.243L205.12 135.201L204.995 135.327L204.826 135.37H204.784L204.742 135.496L204.7 135.538L204.615 135.496L204.531 135.454L204.406 135.412H204.362L204.237 135.327H204.111L204.026 135.37L203.9 135.412L203.815 135.327H203.773L203.689 135.37H203.564H203.521L203.479 134.696L203.353 133.812V133.77L203.184 133.643L202.721 133.181L202.131 132.634L200.617 131.245H200.575L200.533 131.287L200.364 131.329L200.28 131.37H200.195L200.153 131.497L200.069 131.539L200.028 131.581H199.942L199.901 131.623H199.817V131.707L199.69 131.749L199.522 131.665H199.438L199.395 131.623L199.186 131.665L198.933 131.749L198.848 131.792H198.806H198.764V131.665H198.722L198.68 131.539L198.595 131.454L198.511 131.412L198.47 131.37L198.428 131.329V131.245H198.344L198.301 131.16H198.259V131.245L198.175 131.287L198.133 131.245L198.049 131.287L197.964 131.245L197.839 131.329L197.753 131.412L197.67 131.329L197.628 131.37L197.586 131.287L197.417 131.245L197.375 131.202L197.333 131.118H197.291L197.164 131.245L197.081 131.118L197.039 131.076L196.912 131.118L196.786 131.034L196.617 130.992L196.659 130.823V130.739H196.449L196.322 130.571L196.197 130.487H196.155H196.07V130.403L195.944 130.36H195.902L195.817 130.234L195.775 130.192L195.733 130.15L195.65 130.107L195.564 130.192L195.523 130.276L195.439 130.192L195.312 130.107H195.355H195.312L195.27 130.023V130.065L195.186 129.981L195.144 130.023L195.102 129.981L195.017 129.939L195.06 129.898H195.017V129.856H194.933H194.975L194.892 129.898V129.856L194.808 129.812L194.723 129.729L194.681 129.645L194.47 129.603L194.386 129.518L194.217 129.392L194.175 129.35V129.308H194.092L194.05 129.223L193.966 129.181V129.14H194.008L193.966 129.098L193.923 129.14H193.881L193.839 129.098L193.797 129.056V129.098H193.755L193.713 128.971V129.014L193.671 128.971H193.628V128.929L193.586 128.803L193.544 128.761H193.461L193.334 128.676L193.292 128.718L193.166 128.676L193.124 128.718L192.997 128.634V128.592H192.955L192.871 128.634H192.828L192.786 128.55L192.744 128.634H192.703L192.661 128.676L192.619 128.592L192.534 128.55L192.492 128.509V128.55H192.45L192.366 128.465H192.239L192.071 128.382V128.423L191.986 128.382H191.944L191.903 128.423H191.777H191.734L191.439 128.465V128.509L191.397 128.55H191.313L191.272 128.509L191.186 128.55H191.145L191.103 128.592L191.019 128.676H190.935H190.892L190.724 128.761L190.597 128.845L190.555 128.803L190.514 128.845H190.472L190.43 128.887V128.929H190.345L190.303 128.971L190.345 129.056L190.303 129.098H190.219L190.177 129.14L190.261 129.223V129.265H190.219H190.177H190.135L190.093 129.308H190.008V129.392L189.966 129.35L189.924 129.434H189.882L189.841 129.35V129.265H189.882L189.841 129.223L189.63 129.098L189.588 129.014H189.503L189.419 129.056H189.377L189.293 129.014L189.083 128.971L189.041 128.929L188.999 128.887H188.956H188.914V128.845H188.83L188.788 128.887H188.703V128.845L188.746 128.803V128.761L188.703 128.718L188.661 128.676H188.493L188.452 128.634H188.408H188.366L188.325 128.592H188.199L187.946 128.509H187.861L187.819 128.465H187.777V128.382H187.735V128.423L187.693 128.382L187.735 128.34H187.693L187.735 128.298H187.693H187.777L187.693 128.256L187.777 128.214V128.129H187.735V128.003L187.693 128.045V128.003V127.961L187.735 127.834V127.792L187.777 127.54L187.946 127.161L187.988 127.119L188.03 126.992L188.114 126.698L188.199 126.614V126.572L188.325 126.403L188.283 126.361H188.199L188.156 126.276L188.114 126.32V126.276H188.072L188.114 126.234H188.072L187.988 126.193L187.946 126.276V126.234L187.904 126.276L187.861 126.234H187.904V126.193L187.819 126.234L187.777 126.193V126.234L187.735 126.193H187.652V126.109V126.151L187.608 126.109H187.566V126.151L187.525 126.109V126.151L187.483 126.109H187.441V126.151L187.399 126.109L187.357 126.151L187.314 126.067H187.272V126.151V126.067H187.23L187.188 125.982H187.146L187.104 126.025V125.982L187.019 125.94H187.061H186.935H186.894V125.982H186.81L186.767 126.067L186.725 126.025V126.067L186.683 126.025H186.641V125.982L186.599 126.025H186.557H186.514V125.982V125.94H186.472V125.982H186.43V125.94L186.388 125.982H186.346L186.304 125.94V125.856H186.263L186.219 125.982L186.136 126.025L186.094 125.982H186.136V125.898L185.968 125.856V125.94H185.925L185.841 125.856H185.715V125.814H185.672V125.73L185.63 125.687V125.73V125.772H185.504V125.814V125.856L185.463 125.814L185.419 125.856H185.463V125.898L185.419 125.814H185.294H185.252H185.21H185.168L185.125 125.856L184.999 125.772L184.873 125.814V125.856H184.788L184.83 125.898H184.788L184.746 125.94H184.705L184.663 125.982L184.621 125.94V125.982L184.578 126.025V125.982H184.536H184.494L184.452 126.025L184.325 126.067L184.241 126.151L184.157 126.193L184.115 126.234L184.074 126.193V126.234H184.03L183.988 126.276L183.947 126.32H183.905L183.863 126.276L183.821 126.32V126.276L183.779 126.32H183.694H183.61V126.403L183.526 126.361V126.403H183.483V126.445H183.441H183.399V126.487V126.445L183.357 126.487L183.274 126.572H183.23H183.188L183.147 126.614H183.105L183.063 126.74L183.021 126.698L182.979 126.74H183.021L182.979 126.782L182.936 126.74H182.894L182.852 126.825L182.894 126.867L182.852 126.909L182.81 126.867V126.951L182.726 126.867V126.909H182.684V126.992H182.641V127.076H182.599H182.557V127.034L182.516 127.119L182.474 127.076V127.161L182.389 127.203H182.347V127.245L182.305 127.287L182.263 127.245V127.287H182.221H182.136L182.094 127.329H182.052V127.371H182.01H181.926L181.968 127.414L181.926 127.456L181.799 127.414V127.456L181.885 127.498L181.841 127.54H181.799L181.841 127.582L181.799 127.623H181.841L181.885 127.667H181.799H181.758L181.716 127.709V127.792V127.834L181.674 127.792V127.834V127.876H181.716L181.758 127.834V127.919H181.716H181.674H181.632L181.547 128.045V128.003V128.045H181.463L181.421 128.087H181.337V128.129H181.294V128.171L181.168 128.214H181.126V128.256H181.085L181.043 128.298L180.999 128.256L180.916 128.34L180.958 128.382H180.874V128.423V128.465L180.79 128.423V128.465L180.537 128.55V128.634L180.495 128.676V128.634L180.452 128.676L180.368 128.845L180.285 128.971L180.243 129.014H180.2L179.821 128.971L179.737 128.929L179.779 128.887L179.696 128.929V128.971H179.652H179.61V129.014L179.485 128.971L179.443 129.056L179.358 129.098V129.181L179.274 129.265L179.232 129.223L179.19 129.265L179.148 129.35L179.106 129.308L179.063 129.392L178.979 129.434V129.476L179.021 129.518H178.937H178.896V129.56H178.854L178.81 129.518L178.854 129.603L178.81 129.687L178.769 129.645L178.727 129.729H178.601V129.771V129.812H178.558L178.516 129.771V129.812L178.474 129.856V129.898V129.939H178.432L178.306 130.065L178.179 130.15H178.138V130.107H178.096L178.054 130.192L177.969 130.234H178.012L177.969 130.276V130.318H177.927V130.276H177.885L177.759 130.36L177.674 130.276L177.59 130.318H177.548L177.465 130.234H177.421H177.38L177.338 130.276H177.254V130.318L177.127 130.445V130.487L177.085 130.445V130.529H177.043V130.571H177.001L176.959 130.698L176.917 130.739L176.832 130.781V130.739L176.79 130.698L176.748 130.823V130.781H176.707L176.665 130.865L176.707 130.907L176.665 130.992L176.58 131.118V131.16H176.538H176.496V131.202H176.454H176.37V131.245L176.327 131.202V131.245V131.287H176.285V131.329H176.243V131.37V131.329L176.201 131.37H176.117H176.074H175.99L175.907 131.329L175.823 131.37L175.738 131.329L175.696 131.37H175.654V131.412H175.612V131.497H175.57L175.527 131.539H175.443V131.581H175.401L175.359 131.623L175.065 131.454L174.854 131.497L174.77 131.581V131.707H174.685L174.728 131.749L174.685 131.876H174.601H174.559H174.518H174.391V131.918V131.96L174.349 132.001V132.087L174.307 132.128L174.265 132.17L174.223 132.212L174.265 132.254L174.096 132.296L174.054 132.212V132.17L174.012 132.212L173.97 132.128V132.001L173.843 131.918V131.834H173.97L174.012 131.792H174.096V131.749H174.181L174.265 131.707V131.665L174.307 131.623V131.539L174.265 131.497V131.454L174.307 131.37L174.391 131.329V131.245L174.476 131.202V131.118L174.518 131.076L174.728 130.865V130.654V130.612L174.77 130.571V130.403V130.276L174.643 130.234L174.601 130.15H174.518L174.559 129.981L174.432 129.856H174.349V129.812L174.391 129.687L174.307 129.56H174.265V129.518L174.349 129.476L174.432 129.434V129.392L174.476 129.35L174.518 129.308V129.181V129.14V129.098V128.971V128.887H174.559V128.761V128.718H174.518L174.432 128.634L174.391 128.592L174.432 128.55V128.509V128.465H174.518V128.423V128.465H174.559L174.643 128.423V128.34L174.601 128.298L174.685 128.214V128.171L174.559 128.045L174.643 128.003L174.685 127.876L174.643 127.834H174.601H174.643V127.792L174.601 127.75H174.643L174.601 127.667L174.685 127.709L174.728 127.667L174.685 127.623L174.601 127.54L174.559 127.498L174.601 127.456H174.559L174.601 127.414V127.371V127.329L174.518 127.245L174.476 127.203L174.518 127.119L174.559 127.076V126.992L174.518 126.951V126.909H174.476V126.867L174.518 126.825L174.601 126.951L174.728 126.992L174.77 126.951H174.812L174.896 126.867H174.981L175.023 126.825V126.698L175.065 126.656L175.107 126.614V126.572L175.149 126.487L175.107 126.445H175.023L174.938 126.403L174.896 126.32L174.854 126.276L174.812 126.025L174.728 125.982H174.601L174.643 125.898L174.601 125.856H174.518L174.476 125.898H174.432V125.856L174.391 125.772H174.307L174.181 125.687L174.265 125.52L174.181 125.434L174.096 125.478L174.012 125.52H173.97V125.434H173.843L173.887 125.309L173.843 125.225L173.76 125.182L173.634 125.225L173.423 125.182L173.338 125.14V125.014V124.972H173.254L173.129 124.887H173.002L172.918 124.845L173.002 124.762L173.043 124.803H173.087L173.17 124.678L173.129 124.593H173.087H173.043L173.17 124.509L173.254 124.34L173.296 124.298L173.212 124.214L173.254 124.089L173.212 124.045L173.129 124.004L172.918 123.878L172.96 123.751V123.583L173.129 123.289V123.245V123.204L173.043 123.12H172.918V123.078L172.96 122.994L172.834 122.909L172.876 122.867L173.17 122.783L173.212 122.741L173.129 122.573L173.002 122.614L172.918 122.573V122.531L173.087 122.404H173.129V122.362L173.087 122.32L173.002 122.278L172.96 122.236L173.002 122.194L173.087 122.025L173.17 121.942H173.212L173.254 121.856L173.423 121.773L173.591 121.604L173.549 121.562L173.423 121.436L173.254 121.478L173.212 121.436L173.17 121.478L173.129 121.436L173.087 121.352L173.129 121.267L173.087 121.183L173.17 121.1L173.212 121.015V120.931H173.17V120.889L173.296 120.847V120.805L173.212 120.678L173.17 120.594L173.087 120.636V120.594V120.552L173.212 120.467L173.254 120.384L173.381 120.342L173.507 120.3L173.634 120.258L173.76 120.215L173.801 120.173L173.887 120.131L173.97 119.963L174.054 119.92L174.265 119.794L174.307 119.626V119.584L174.265 119.542L174.181 119.5L173.97 119.584L173.887 119.626H173.801L173.76 119.667L173.507 119.836L173.296 119.878L173.212 119.836L173.087 119.963L172.918 120.047H172.876H172.834L172.792 119.92V119.836H172.749L172.623 119.753L172.707 119.626V119.542V119.458H172.539V119.416L172.581 119.373L172.623 119.247V119.163L172.707 119.12V119.078V118.994H172.665L172.623 118.953L172.707 118.911L172.665 118.826L172.749 118.784V118.658L172.707 118.616H172.665L172.623 118.531L172.581 118.447L172.707 118.322L172.749 118.236L172.792 118.153L172.834 118.111V118.069V118.026L172.876 117.984V117.9L173.002 117.858L173.043 117.816H173.087H173.129L173.212 117.858H173.254L173.296 117.816H173.338L173.381 117.774L173.507 117.731L173.549 117.689H173.634L173.718 117.605L173.801 117.564L173.887 117.395V117.311L173.801 117.269L173.718 117.227L173.423 117.353H173.338L173.212 117.437L172.918 117.395H172.876L172.834 117.478L172.707 117.522L172.749 117.311V117.227L172.792 117.142L172.834 117.058L172.749 116.932L172.876 116.847L172.96 116.764L172.918 116.68L172.876 116.637L172.834 116.595V116.511V116.427L172.876 116.384V116.3L172.834 116.216L172.918 116.174V116.006L172.876 115.964L172.792 115.922V115.88H172.749L172.834 115.753L172.918 115.711L173.002 115.627L172.96 115.542H172.918H172.876V115.5L172.792 115.458L172.876 115.248L172.834 115.164L172.876 115.122L172.918 115.08L172.96 114.953L173.002 114.911H173.043L173.17 114.869L173.338 114.827H173.591L173.634 114.7L173.591 114.616L173.634 114.533L173.591 114.448L173.465 114.491L173.17 114.616L173.002 114.575V114.364L173.043 114.28V114.238L173.002 114.153L172.918 114.069H172.876H172.834H172.792L172.749 114.111L172.707 114.069V114.027L172.749 113.985V113.9L172.792 113.858L172.749 113.775L172.623 113.691H172.581L172.496 113.649L172.454 113.564L172.412 113.606L172.37 113.564L172.412 113.522V113.48V113.438L172.581 113.396V113.353H172.539L172.412 113.311H172.37L172.243 113.269L172.287 113.186L172.329 113.144L172.243 113.017H172.202L172.287 112.975L172.329 112.849L172.287 112.806V112.722L172.16 112.68L172.202 112.638V112.596V112.554L172.16 112.511L172.243 112.469V112.427L172.287 112.302V112.217L172.329 112.133L172.287 112.049L172.202 112.007V111.964L172.16 111.88L172.243 111.838L172.202 111.796V111.755L172.118 111.669V111.586L172.202 111.544H172.243V111.46L172.37 111.333L172.454 111.291L172.496 111.249L172.539 111.164L172.707 111.122H172.792L173.043 111.08L173.254 110.997H173.381L173.507 110.87V110.786L173.465 110.702H173.423H173.338L173.254 110.786L173.087 110.828L173.002 110.786L172.918 110.744L172.792 110.702L172.623 110.786H172.539L172.454 110.702L172.412 110.66L172.329 110.702L172.243 110.575L172.287 110.491L172.243 110.407L172.287 110.365L172.37 110.407L172.412 110.365V110.322V110.28L172.496 110.238L172.539 110.155L172.496 110.113V110.071L172.581 110.028V109.986L172.496 109.944L172.412 109.86L172.287 109.902L172.243 109.86L172.329 109.818L172.539 109.733L172.665 109.524L172.749 109.48V109.397L172.707 109.271L172.665 109.228L172.623 109.144V109.06L172.707 109.018L172.792 109.06L172.876 109.018H172.918H172.96H173.002L173.212 109.144L173.423 109.228L173.507 109.186L173.634 109.228L173.76 109.186L174.054 109.144V109.102V109.018L174.012 108.976H173.97L173.843 108.933L173.801 108.891L173.718 108.933H173.591L173.549 108.849L173.465 108.891L173.423 108.933L173.338 108.891L173.254 108.849L173.212 108.766V108.724L173.129 108.639H173.043L172.96 108.597H172.918L172.792 108.555L172.623 108.471L172.412 108.513L172.329 108.471H172.202H172.16L172.076 108.513H172.034L171.992 108.471L171.949 108.386L171.823 108.344H171.739H171.654H171.612L171.571 108.26L171.445 108.218L171.402 108.176L171.36 108.133L171.318 108.008V107.797V107.755L171.192 107.671V107.629V107.46L171.107 107.418H171.065L170.94 107.377L170.854 107.25L170.813 107.082V106.997Z"
							fill="#6ba4da" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="PI" @mouseenter="e => hoverES(e, 'PI')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M174.896 100.303L174.854 100.051L174.896 99.9669V99.8818H174.981H175.023L175.065 99.7561L175.107 99.7142V99.6723L175.19 99.6291L175.232 99.5035L175.276 99.3778L175.317 99.3346L175.401 99.0832L175.317 98.9981H175.359V98.9143L175.401 98.7454V98.7035L175.485 98.6197V98.5346L175.527 98.409V98.3671L175.57 98.2833L175.527 98.1563L175.485 98.1144L175.443 98.0725V97.9036V97.8617L175.401 97.8198V97.7779L175.485 97.6509V97.609L175.527 97.4414V97.3982L175.57 97.3564L175.654 97.3145L175.696 97.1888V97.1456V97.1037L175.654 97.0199L175.696 96.978L175.654 96.8942V96.851L175.612 96.8091L175.654 96.7672L175.57 96.7253L175.654 96.5983L175.612 96.4307L175.654 96.3037V96.2618H175.696V96.22L175.654 96.1362L175.612 96.0943L175.57 96.0511L175.612 96.0092L175.57 95.9254V95.8416L175.654 95.7565L175.612 95.6727L175.696 95.6308V95.5889L175.738 95.4619L175.823 95.42V95.3781L175.907 95.3362L175.865 95.2524L175.907 95.2092H175.865L175.907 95.1673L175.865 95.1255V95.0836H175.823L175.865 95.0417H175.823V94.9566V94.9147L175.696 94.7471L175.654 94.662L175.57 94.5782L175.527 94.5363H175.443L175.359 94.4944L175.317 94.4525L175.276 94.4944L175.232 94.4525L175.276 94.3674H175.232V94.2836H175.19V94.2417L175.149 94.1579V94.1147H175.232V94.031L175.19 93.9472V93.8634L175.232 93.7364H175.19V93.6107L175.149 93.4837H175.19L175.232 93.4418L175.149 93.358L175.107 93.3148L175.065 93.1891L175.023 93.1472V92.9783V92.8946H175.065V92.8108H175.023V92.7689V92.6838L174.981 92.6419L174.938 92.6L174.981 92.5162L174.938 92.4311V92.3473L174.812 92.2635L174.77 92.1365L174.685 92.0527V92.0108L174.643 91.8838L174.601 91.8001L174.685 91.7163V91.6744V91.6312V91.5474V91.5055L174.77 91.4636L174.728 91.4217L174.77 91.3785L174.812 91.2947L174.854 91.2528H174.896L174.938 91.2109V91.169L174.854 91.1258L174.812 91.0839L174.854 91.0001L174.938 90.9582L174.981 90.8744V90.8312H175.023L175.149 90.7056L175.232 90.7475L175.276 90.5799L175.359 90.5367H175.443L175.401 90.4529L175.485 90.411H175.57L175.696 90.1164L175.738 90.0745L175.696 90.0313L175.738 89.9056L175.78 89.8218H175.823V89.7799L175.948 89.8218L176.032 89.7367L175.865 89.653V89.6111L176.032 89.4854L176.074 89.4422V89.3584L176.117 89.3165L176.074 89.2327L176.117 89.1895L176.201 89.0638L176.159 89.0219L176.201 88.8949L176.159 88.7273L176.201 88.6854L176.243 88.6003V88.5585V88.5166V88.4747L176.327 88.4328L176.285 88.3909L176.37 88.3477H176.412L176.454 88.3058L176.412 88.222L176.496 88.1801V88.1382V88.0112L176.58 87.9274V87.8004L176.665 87.7166V87.464L177.001 87.1694L176.959 87.0856L177.001 87.0437L177.043 86.9586H177.127L177.169 86.8748L177.127 86.7491L177.169 86.664L177.212 86.5802L177.169 86.4964L177.254 86.3276V86.2019L177.296 86.1587L177.212 86.033L177.296 85.9492H177.338H177.379V85.9073L177.254 85.8222L177.338 85.6965L177.379 85.6546V85.6114L177.338 85.5695L177.379 85.5276L177.421 85.4857V85.4019V85.3601H177.465L177.548 85.3168V85.275L177.421 85.1912L177.548 85.1493V85.1074L177.465 85.0642L177.421 84.9804H177.465L177.506 84.9385V84.8547L177.59 84.8128L177.632 84.7277L177.59 84.602L177.674 84.5601V84.475L177.716 84.5169L177.759 84.475L177.716 84.4331L177.759 84.3493L177.716 84.2656L177.759 84.2223V84.2656H177.801V84.2223L177.759 84.1386L177.801 84.0548L177.885 84.0129V83.9697V83.8859H177.927L178.012 83.844L177.927 83.8021V83.7602H177.969L178.054 83.8021H178.096L178.054 83.7183L178.096 83.6751H178.179L178.221 83.6332V83.5913H178.263L178.306 83.5494V83.4656L178.348 83.3805H178.39L178.474 83.4224L178.643 83.2548L178.685 83.171L178.769 83.1278H178.896H178.937L179.021 83.086L179.148 83.1278L179.232 83.0441L179.274 83.0022H179.316L179.401 83.0441V83.086H179.443L179.527 83.0022L179.652 82.9603L179.695 82.8333L179.821 82.7495L179.863 82.7914H179.948L179.99 82.7495L180.243 82.6657L180.368 82.7076H180.41L180.495 82.7495L180.663 82.6238H180.747L180.832 82.5387H180.874H180.958L181.043 82.4968L181.168 82.4549L181.21 82.4968L181.252 82.4549L181.294 82.3711L181.337 82.286L181.379 82.2022L181.421 82.1603L181.505 82.2022L181.59 82.1603L181.632 82.0765L181.674 82.0333V81.9915L181.716 81.9496L181.884 81.8658L181.926 81.782L182.094 81.8239L182.136 81.8658L182.389 81.782L182.474 81.9496L182.557 81.9915H182.599H182.641H182.726L182.768 81.782L182.81 81.7388L182.852 81.5712H182.894L182.979 81.5293L183.021 81.4861L183.147 81.4442L183.274 81.2334V81.1915L183.399 81.1077L183.441 81.0658L183.483 80.9388L183.694 80.897H183.736L183.779 80.7294L183.863 80.6443H183.946V80.6024L184.115 80.5186L184.283 80.4767L184.41 80.3497L184.494 80.2659L184.621 80.224H184.704L184.915 80.1389L185.041 80.224H185.083L185.21 80.0132L185.294 79.9294V79.8875L185.252 79.7606L185.294 79.6768L185.336 79.593V79.466H185.419H185.504L185.715 79.2133V79.0444L185.799 79.0025H185.883V78.9606V78.8349V78.793L185.968 78.6661L186.135 78.5823L186.177 78.4553L186.219 78.4134H186.262V78.5404H186.304H186.346L186.388 78.4553L186.262 78.2877V78.2458V78.2026H186.304H186.43L186.514 78.3296H186.557L186.599 78.2458V78.0769L186.641 77.9931H186.725L186.767 77.9499L187.061 77.908L187.146 77.8242H187.23L187.314 77.8661V77.9499L187.399 77.9931H187.441L187.483 77.908L187.525 77.8661L187.735 77.908L187.904 77.7823L188.114 77.7404L188.156 77.6553L188.199 77.6134L188.241 77.5716L188.366 77.6553L188.451 77.5716H188.493H188.661L188.746 77.5297H188.788V77.5716L188.83 77.6134L188.999 77.5716L189.082 77.6134L189.208 77.6553L189.335 77.7823L189.461 77.8242L189.546 77.908H189.588H189.63V77.8661H189.672H189.714L189.755 77.908V77.9499L189.797 78.0769L189.841 78.1188L190.05 78.2026L190.093 78.2458L190.135 78.3296L190.177 78.4134L190.345 78.4985V78.4553L190.43 78.4134L190.555 78.4553H190.639L190.724 78.4134H190.766V78.2877L190.935 78.3296L191.019 78.1607L191.271 78.2026L191.439 78.1607L191.566 78.0769L191.608 77.9931H191.65L191.903 77.9499L192.113 77.9931L192.239 78.0769H192.281H192.366L192.534 77.9931L192.661 77.8661H192.786L192.871 77.9499H192.955L193.124 77.908H193.166L193.25 77.8242L193.292 77.6553L193.502 77.5716L193.671 77.3608L193.713 77.2351V77.1932V77.1513L193.755 76.8986L193.881 76.7297V76.6459V76.5189L193.966 76.3514L193.881 76.3095V76.2663L193.923 76.2244L194.008 76.1825L193.966 76.0568L194.008 75.9298L193.923 75.8041V75.7622L194.05 75.5514V75.4244L194.092 75.3826L194.217 75.2569V75.215L194.175 75.1718L194.092 75.215L194.05 75.1718L194.092 75.0461L194.133 74.8772L194.092 74.7934V74.7096L194.05 74.6677L194.008 74.5826V74.5407H193.966L193.839 74.4988L193.713 74.4569L193.586 74.2881H193.46L193.375 74.2043L193.334 74.1624L193.292 73.9097V73.8678L193.208 73.8259L193.124 73.7827H192.955L192.871 73.6989L192.828 73.53L192.702 73.4043V73.3624L192.744 73.3205L192.828 73.2787V73.2354L192.871 73.1936V73.1517V73.026L192.828 72.9828L192.744 72.899L192.661 72.8152V72.7314L192.619 72.5625L192.577 72.5206V72.4355L192.702 72.226L192.577 71.9734L192.619 71.8464L192.577 71.7626L192.534 71.5518L192.577 71.468V71.4261H192.702V71.341L192.619 71.0464L192.661 70.837V70.7951L192.619 70.7519L192.577 70.71V70.6262L192.619 70.5843L192.661 70.4992L192.871 70.4573H192.955L192.997 70.3735L193.039 70.2465L193.166 70.1627L193.208 69.9101L193.334 69.7844V69.7425L193.375 69.5736L193.419 69.5317L193.586 69.4898L193.671 69.4047L193.713 69.2371L193.755 69.1952L193.923 69.152L194.008 69.1101V69.0263L194.175 68.9425L194.26 68.9007L194.302 68.8156L194.344 68.6061V68.521V68.4791L194.26 68.2683V68.1845L194.428 67.9737V67.848L194.386 67.6373L194.344 67.5116L194.302 67.2589L194.217 67.1319H194.175V67.0481V66.8792L194.05 66.5847V66.5009L194.092 66.2901L194.008 66.2063V66.1644L193.839 65.9955V65.9536V65.7847L193.797 65.659L193.586 65.4483H193.544L193.502 65.3226V65.1956L193.628 65.0699L193.671 64.9848V64.901L193.544 64.8172L193.502 64.7753L193.46 64.6902L193.502 64.6064L193.586 64.5226L193.671 64.4794V64.4376L193.713 64.3957L193.923 64.1011L193.966 64.0173L194.008 63.9335V63.8903L193.966 63.7227L194.05 63.5957V63.47H194.092V63.4281V63.3849V63.3431L193.966 63.2593L193.923 63.1755L193.966 63.0066L193.881 62.9228L193.628 62.7539V62.712H193.586L193.502 62.7539H193.419V62.712V62.5431V62.4174L193.292 62.2067V62.1229L193.25 61.9121V61.7864L193.292 61.6594L193.544 61.3648L193.586 61.3229L193.628 61.281H193.881V61.2391L193.755 61.1541L193.797 61.0703L193.839 61.0284L193.966 60.9865L194.05 60.9014V60.7757L194.133 60.523L194.175 60.4811L194.26 60.2284H194.344L194.386 60.2703H194.428L194.47 60.1446L194.513 60.0177L194.808 59.8069L194.891 59.7231V59.5974V59.5555V59.4704L195.144 59.0501L195.186 59.0083L195.228 58.965L195.186 58.8813L195.144 58.7556L195.186 58.7137L195.228 58.6286V58.5448L195.144 58.3759V58.334V58.2921L195.186 58.2083L195.312 58.0813L195.439 57.9138H195.523L195.564 57.8287V57.7868L195.608 57.6611L195.733 57.576L195.817 57.5341L195.902 57.4503L196.07 57.2395V57.1976V57.1557V57.1138L196.112 57.0287L196.239 56.9449V56.8193L196.281 56.7342L196.322 56.776H196.364V56.903L196.449 56.9868H196.491H196.533L196.617 56.9449L196.702 56.8193H196.744H196.786V56.903L196.828 56.9449L196.912 56.903L196.955 56.8193V56.7342L197.08 56.776H197.164L197.333 56.6504L197.375 56.6923L197.544 56.776H197.586L197.67 56.7342L197.88 56.6504L198.091 56.6923L198.133 56.6504V56.6923L198.175 56.6085L198.133 56.4815L198.217 56.4396V56.3977L198.428 56.3558L198.511 56.1869L198.595 56.145V56.1031V56.0193L198.638 55.9342L198.68 55.8923H198.764V55.8504V55.8085V55.7666H198.722H198.553V55.6815L198.595 55.6397L198.68 55.5559H198.891L198.975 55.514L199.186 55.4721H199.311L199.395 55.4302L199.48 55.3032H199.522V55.2613L199.564 55.1343L199.606 55.0505H199.648L199.733 55.0924H199.775V54.8816V54.8397L199.859 54.7559V54.6303V54.587L199.901 54.5452L199.986 54.5033L200.069 54.4614L200.195 54.2925L200.237 54.2087L200.406 54.083L200.49 54.0411L200.533 53.8303V53.7884L200.659 53.6614L200.617 53.5358L200.575 53.4925L200.406 53.3669L200.364 53.325L200.28 53.198L200.195 53.1142L200.237 52.9466V52.8196L200.364 52.7777V52.7358L200.322 52.6507V52.4413L200.448 52.3143L200.533 52.2305L200.617 52.2724L200.7 52.4413L200.911 52.6088L201.037 52.6507H201.08L201.331 52.9034L201.5 52.9885V53.0304L201.669 53.1561L201.922 53.2831H201.964L202.09 53.2412H202.131L202.258 53.325H202.426L202.511 53.2412H202.595L202.806 53.2831L202.848 53.325L202.889 53.2831L202.973 53.325L203.1 53.2831L203.268 53.3669H203.311L203.479 53.4507L203.52 53.4088H203.564V53.5776H203.606V53.6195L203.731 53.7033H203.815H203.9V53.7884L203.984 53.9141V53.9979L204.026 54.083H203.984L204.026 54.1249L203.984 54.2087V54.2506L203.942 54.3357H203.984V54.4614L203.9 54.5033V54.5452H203.815V54.6303L203.731 54.714L203.606 54.8397L203.564 54.9248V55.0505L203.184 55.7248L203.1 55.9342V55.9761L203.016 56.0612V56.145L202.973 56.2288V56.272L203.1 56.2288V56.3139V56.4396H203.142L203.184 56.5247H203.395H203.437V56.5666V56.6923V56.776L203.52 56.8611L203.564 57.0287V57.0706L203.647 57.0287H203.731L203.606 57.0706L203.564 57.1138V57.3233L203.479 57.4503H203.311V57.4922L203.268 57.5341V57.576L203.353 57.6192L203.437 57.6611L203.52 57.8705L203.479 58.1651L203.437 58.2083L203.479 58.2502L203.564 58.2921H203.689H203.773L203.858 58.3759H203.984L204.111 58.461V58.5029H204.026L203.984 58.5448L203.942 58.7556L204.026 58.8394L203.942 58.965L203.731 59.1758V59.2177L203.815 59.1339V59.1758H203.858L203.9 59.3028V59.3447L203.942 59.3866L203.984 59.4285V59.4704L204.026 59.5555L204.068 59.6393L204.153 59.7231L204.237 59.892L204.153 60.1028H204.111V60.1446H204.068V60.1865L204.026 60.2284L204.068 60.3122L204.111 60.3973L203.984 60.4811V60.523H204.026L204.111 60.4811L204.195 60.4392H204.279L204.362 60.3973L204.406 60.4392L204.447 60.3973V60.4392L204.531 60.4811H204.573L204.7 60.523H204.826L204.868 60.5649V60.6068L204.784 60.6919L204.826 60.7757L204.742 61.0284L204.7 61.0703L204.784 61.1973V61.281L204.868 61.3229L205.037 61.3648L204.953 61.4486L204.742 61.7864L204.826 62.2918V62.3755V62.4174L204.742 62.4593L204.658 62.6282L204.573 62.712V62.7539V62.9228L204.489 63.0904V63.1336V63.3012L204.406 63.4281V63.5957L204.32 63.6808L204.279 63.8065H204.237L204.195 63.9335H204.111H204.068L204.111 63.9754H204.195V64.0173V64.0592L204.153 64.1849V64.27L204.32 64.3538L204.447 64.5226L204.489 64.5645L204.32 64.7753L204.153 64.9429L204.111 65.028V65.0699L204.026 65.1118V65.1537L204.111 65.1956L204.279 65.2375V65.2794L204.195 65.3226L204.153 65.4483V65.4902L204.068 65.5321L204.111 65.7428L204.026 65.8266L204.153 65.9955L204.111 66.0793L204.195 66.2063V66.2901H204.237H204.279V66.332L204.32 66.3739L204.362 66.2901L204.447 66.332L204.658 66.6266L204.7 66.5847H204.742V66.6684L204.826 66.7117V66.8373L204.784 67.0062H204.995V67.09H205.037V67.1319L205.078 67.1738V67.2589L205.247 67.3427L205.331 67.2589H205.373L205.415 67.3846L205.5 67.3427V67.4684L205.668 67.5535L205.709 67.6792L205.753 67.6373H205.795L205.878 67.7629H205.962H206.004L206.047 67.848L206.004 67.9737L206.047 68.1426L205.92 68.2264L206.047 68.3102H206.089L206.131 68.3953L206.047 68.4372V68.4791V68.5629V68.6061L206.131 68.648V68.7318L206.089 68.8574L206.004 68.9007L205.962 69.0263L206.004 69.0682L206.089 69.1952L206.131 69.279L206.089 69.3209H205.962L205.92 69.3628V69.4047L205.962 69.4898L206.004 69.5317L206.047 69.5736L206.089 69.6574V69.7006L206.004 69.7844V69.8263V69.8682V69.9101V69.9952L205.962 70.037L206.004 70.1208V70.2046L206.131 70.2897V70.4573L206.173 70.5424L206.215 70.6262L206.173 70.7951L206.131 70.8789L206.004 70.9208L205.962 70.9627L206.004 71.0464L206.047 71.2153L206.131 71.341L206.089 71.4261L206.131 71.5937L206.173 71.7626L206.131 71.9734L206.173 72.0991L206.257 72.3098L206.215 72.4355L206.342 72.5625V72.899L206.299 73.026L206.257 73.0679V73.1098L206.173 73.1936V73.3205V73.3624V73.4043L206.299 73.3624L206.384 73.4462L206.468 73.7408L206.551 73.9097L206.509 74.0354V74.1205V74.1624V74.2043V74.3718V74.4988L206.678 74.7096L206.762 74.9204L206.804 74.9623L206.889 75.0042L206.931 75.0461V75.1299V75.215V75.2569L206.889 75.4663L206.804 75.5095V75.5933L206.847 75.8041V76.0149V76.0987L206.889 76.2663V76.3514V76.4352L207.142 76.6878L207.226 76.8986V76.9405L207.309 77.0243V77.0662L207.226 77.2351L207.267 77.277L207.393 77.404H207.731L207.857 77.5297L207.984 77.6134L208.025 77.6553L208.278 77.6985L208.573 77.7404H208.74L208.825 77.7823L208.867 77.8242L208.951 77.908V77.9499L208.993 78.0769L209.036 78.1188L209.078 78.2458L209.12 78.2877H209.204L209.288 78.2026L209.373 78.1607L209.498 78.2026V78.2458L209.415 78.3296L209.373 78.3715L209.288 78.4553L209.246 78.5404H209.204L209.12 78.5823V78.7498L209.078 78.8349L209.162 79.0444L209.12 79.1295V79.4241L209.246 79.466V79.5079L209.12 79.5498V79.593L209.078 79.5498V79.6349H209.12V79.6768L209.036 79.7606V79.8025L208.951 79.9713L208.867 80.0132V80.0551L208.74 80.224L208.784 80.3078L208.698 80.5605V80.6443L208.657 80.6875L208.615 80.897L208.573 81.2334L208.615 81.4023L208.573 81.4861L208.404 81.5712L208.446 81.655L208.362 81.9915L207.731 82.2441L207.689 82.3279L207.604 82.3711L207.393 82.413L207.351 82.4968V82.5806L207.478 82.9184L207.52 82.9603L207.731 83.2129V83.2548L207.773 83.2967V83.3386V83.4224V83.5494V83.5913L207.646 83.844L207.562 84.0967L207.604 84.3493L207.731 84.475L207.898 84.5169L208.236 84.6439H208.278L208.32 84.6858L208.404 84.7696V84.8128L208.446 84.9385V85.0223L208.404 85.5276V85.5695V85.6546L208.193 86.033L208.151 86.1587L208.067 86.3695L208.025 86.5383L208.067 86.6221L208.109 86.664V86.7491L208.067 86.791V86.8329L207.857 86.7491L207.815 86.791V86.8329L207.773 86.8748H207.689L207.646 86.9167V87.0018L207.604 87.0437H207.52L207.478 87.1275L207.436 87.1694L207.393 87.2532V87.2964H207.267L207.226 87.3383L207.184 87.3802L207.057 87.4221L207.015 87.464L206.931 87.5058L206.973 87.6747L206.931 87.7166V87.7585V87.8004H206.889V87.8855L206.72 87.9274V87.9693L206.678 88.0112L206.72 88.1801L206.595 88.3058H206.468V88.2639L206.426 88.1801L206.384 88.1382H206.257L206.215 88.222H206.257V88.3477H206.215L206.173 88.3909V88.4747V88.5585L206.131 88.6422L206.047 88.7273L205.962 88.6422L205.836 88.5585L205.795 88.5166V88.4747L205.709 88.3909L205.626 88.4328H205.584L205.542 88.5585L205.331 88.6003L205.289 88.7273L205.247 88.9381L205.078 88.8949V89.0219L205.037 89.1476L204.995 89.1895H204.953L204.91 89.2746L204.826 89.3165H204.784L204.742 89.2746H204.658V89.3584L204.573 89.5273L204.531 89.5692L204.489 89.6111L204.447 89.653H204.362L204.32 89.6948H204.279V89.7799L204.32 89.9056L204.237 89.9894H204.153L204.111 90.0313L204.026 90.0745H203.815L203.689 90.2421L203.647 90.284L203.479 90.3691H203.353H203.311H203.226V90.411L203.142 90.4948L203.1 90.6218L203.016 90.7893L202.931 91.0001L202.889 90.9582L202.721 91.169L202.637 91.2528H202.553L202.511 91.3785H202.469V91.4217L202.426 91.4636V91.5474L202.384 91.6312H202.342L202.3 91.8001L202.217 91.842V92.0108L202.09 92.0527L202.048 91.9689H201.964H201.922H201.879H201.837L201.795 92.0527H201.711V92.1365H201.669L201.417 92.1784V92.2635L201.375 92.3473H201.08V92.3892L201.037 92.5581V92.6838V92.8527L200.869 92.9783L200.784 93.0634H200.742L200.617 93.1891V93.3148L200.49 93.4418L200.406 93.8202H200.322L200.237 93.7783H200.195L200.111 93.8634L199.986 93.9053L199.942 93.9891L199.901 94.031H199.859L199.775 93.9472H199.69H199.648L199.564 93.8202L199.395 93.9472L199.228 93.8634L199.142 93.9053H199.059H198.975L198.764 94.031L198.638 94.0728H198.511H198.259L198.175 94.1147H198.091L198.006 94.0728H197.964L197.88 94.1147L197.753 94.1998L197.712 94.2417H197.586L197.459 94.2836H197.417L197.375 94.3674L197.164 94.4944V94.662H197.122L197.08 94.7052L196.912 94.789L196.786 94.8728L196.744 94.9147V95.0836L196.702 95.1255L196.617 95.1673L196.575 95.2092L196.449 95.1673L196.364 95.2092L196.322 95.2524L196.364 95.3362L196.322 95.42L196.155 95.4619L195.986 95.42L195.86 95.4619L195.733 95.42L195.691 95.4619L195.65 95.547L195.523 95.7146L195.481 95.6727L195.397 95.7146H195.312L195.186 95.7565H195.102V95.7146L194.975 95.6727L194.933 95.6308V95.6727V95.7997L194.85 95.8835L194.766 95.9673L194.681 96.0092V96.1362L194.639 96.1781L194.386 96.22H194.302V96.0943L194.217 95.9673V95.8416L194.175 95.7565H194.133L194.05 95.8416H194.008H193.966L193.839 95.6727L193.755 95.6308H193.628L193.502 95.547V95.5038L193.46 95.42L193.419 95.2524V95.1673L193.46 95.0417L193.419 94.9998V94.9566L193.334 94.8728L193.25 94.8309L193.124 94.8728H193.081L192.828 94.9147V94.789H192.786H192.702H192.661V94.7471L192.577 94.7052H192.534V94.662H192.492L192.45 94.6201L192.408 94.662H192.366V94.7471L192.281 94.662H192.197L192.113 94.8728L191.986 94.9566L191.944 94.9147L191.903 94.8309H191.819H191.777L191.692 94.8728H191.524L191.482 94.9566H191.439H191.397L191.355 94.789H191.313L191.23 94.7471L191.145 94.6201H191.103H190.977L190.85 94.4944L190.724 94.2836L190.682 94.1998L190.513 93.9891L190.43 93.9472H190.388L190.303 93.9053L190.177 93.9472L190.093 93.9891L189.924 94.1579L189.841 94.2417H189.797L189.672 94.2836H189.63L189.503 94.4093L189.377 94.5782L189.293 94.6201L189.041 94.8309L188.914 94.9147L188.535 95.0417L188.408 95.0836L188.324 95.1673L188.241 95.3362L188.114 95.42L187.904 95.7565V95.8416L187.946 96.0092V96.1781L188.03 96.22H187.988V96.2618L187.946 96.3469L188.072 96.3888L188.241 96.6834V96.7672V96.8091V96.8942L188.324 97.1456L188.408 97.1888L188.451 97.2307L188.703 97.3145L188.746 97.3982H188.788H188.872L188.956 97.4833L189.041 97.5252L189.124 97.609V97.6509L189.041 97.736V97.8198L188.999 97.9036L188.872 97.9455V98.0306H188.788V98.0725V98.1563H188.872L188.914 98.1982V98.2401L188.83 98.409L188.956 98.5346L189.041 98.5778L189.082 98.6616L189.041 98.8305L188.914 98.9143L188.872 99.04V99.1251H188.661H188.493L188.451 99.167L188.366 99.2927L188.408 99.3778V99.5035L188.366 99.798L188.241 99.9669L187.988 100.22V100.261V100.303V100.345V100.429V100.598L187.904 100.682L187.777 100.767L187.693 100.851L187.652 100.893L187.608 101.02L187.525 101.103L187.483 101.314V101.356H187.357H187.188L187.019 101.271L186.935 101.229H186.852L186.81 101.314L186.767 101.482L186.81 101.692V101.734L186.725 101.818L186.683 101.861L186.557 102.282L186.514 102.365L186.472 102.409H186.346L186.304 102.45L186.219 102.618L186.177 102.703H186.135L186.052 102.745H186.01H185.968L185.883 102.703L185.799 102.661L185.672 102.576H185.63L185.504 102.661H185.463L185.336 102.618L185.21 102.534L185.083 102.282L185.041 102.24L184.999 102.198L184.915 102.156H184.83L184.788 102.198L184.536 102.492L184.494 102.534L184.368 102.576L184.199 102.534H184.157L184.115 102.576L184.073 102.661L183.988 102.745L183.863 102.787H183.821H183.779H183.736L183.568 102.661H183.399L183.315 102.703L183.23 102.871L183.188 102.913L183.105 102.956H183.021H182.979L182.894 102.998L182.852 103.04V103.082H182.81L182.894 103.334L182.852 103.46V103.503L182.726 103.545L182.557 103.503L182.474 103.545L182.432 103.587L182.305 103.629L182.263 103.671V103.798H182.136H182.094L181.968 104.05V104.176L181.926 104.218L181.884 104.26L181.716 104.387L181.674 104.302H181.632L181.505 104.429H181.421L181.379 104.471H181.337L181.21 104.598L180.958 104.387V104.345H180.916L180.79 104.302H180.747H180.663L180.579 104.176L180.495 104.134L180.452 104.092L180.368 104.05L180.326 104.007H180.243L180.116 104.05L180.074 104.007H179.948H179.821L179.485 103.965H179.443V103.923L179.401 103.881H179.232L179.19 103.84L179.106 103.629V103.587L178.979 103.545L178.769 103.503L178.558 103.334L178.474 102.956V102.913L178.432 102.871L178.39 102.787H178.306L178.221 102.745H178.179L178.137 102.703L178.096 102.661V102.618L178.054 102.323L178.012 102.198L178.054 102.113V101.987L178.012 101.903L178.096 101.776L178.263 101.609L178.306 101.567V101.482L178.137 101.356L178.096 101.229L178.137 101.02L178.096 100.934L177.927 100.809L177.843 100.64L177.759 100.598L177.716 100.556L177.59 100.472L177.548 100.429V100.22L177.506 100.176L177.338 100.051L177.254 99.925V99.8399V99.6723V99.5454L177.169 99.4197L177.085 99.3346H177.043L176.832 99.4616H176.748L176.621 99.5872L176.538 99.6291H176.412H176.327H176.285L176.201 99.7561L176.243 99.8399L176.285 99.9669L176.243 100.093L176.159 100.176L175.865 100.345L175.57 100.303L175.317 100.176L175.023 100.261L174.896 100.303Z"
							fill="#1169bc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="CE" @mouseenter="e => hoverES(e, 'CE')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M203.017 56.1454V56.0616L203.1 55.9765V55.9346L203.184 55.7251L203.564 55.0509V54.9252L203.606 54.8401L203.731 54.7144L203.815 54.6306V54.5455H203.9V54.5036L203.984 54.4617V54.336H203.942L203.984 54.2509V54.209L204.026 54.1252L203.984 54.0834H204.026L203.984 53.9983V53.9145L203.9 53.7888V53.7037H203.815H203.731L203.606 53.6199V53.578H203.564V53.4091L203.858 53.2415L203.9 53.1983L203.984 53.1564L204.153 53.1983H204.406L204.489 53.1564L204.826 53.1983L204.953 53.2415L204.995 53.1983L205.037 53.2415H205.206L205.542 53.1983L205.626 53.1564L205.795 53.1145L205.879 53.0726H206.131L206.173 52.9889L206.215 53.0307H206.342V52.9889L206.384 53.0307L206.426 52.9889L206.468 53.0307H206.51L206.551 53.1564L206.637 53.1145H206.72L206.847 53.0726L206.973 52.947H207.057H207.226H207.52L207.604 52.9038L207.773 52.947L208.109 52.9038L208.236 52.8619L208.278 52.82L208.488 52.7362L208.573 52.6511V52.5673L208.699 52.5254L208.951 52.6511L209.078 52.6943H209.288H209.457L209.751 52.6511L210.004 52.6943H210.173V52.6511L210.425 52.6943L210.635 52.7362L210.593 52.6943L210.804 52.82L210.846 52.8619L210.973 52.82V52.7781H211.182L211.309 52.82V52.8619H211.351H211.393H211.435H211.52L211.646 52.9038L211.687 52.8619H211.604L211.646 52.82L211.856 52.947H211.94L211.856 52.9038H211.771H211.856L212.067 52.9889L211.982 52.947L212.151 52.9889L212.193 53.0726L212.319 53.1145H212.362L212.404 53.1564H212.446H212.487L212.656 53.2834L212.824 53.4091L212.909 53.451L213.077 53.578L213.204 53.6199L213.371 53.7888H213.413L213.54 53.8726H213.709L213.793 53.9145L213.876 53.9983L213.918 54.0415H213.96L214.045 53.9983L214.129 54.0415L214.213 54.1671L214.298 54.2928L214.34 54.336H214.424L214.551 54.4198L214.76 54.5455L214.971 54.6306L215.098 54.7982L215.266 54.8401L215.393 54.882L215.518 55.009L215.602 55.0509L215.729 55.009L215.855 55.0509L215.982 55.1779L216.024 55.2197H216.065L216.149 55.2616L216.234 55.3035H216.36H216.402L216.487 55.3873L216.571 55.4724L216.824 55.767L216.949 55.9765H216.991V56.0197L217.118 56.1035H217.202H217.244H217.287L217.329 56.2291L217.455 56.398L217.582 56.4818V56.4399L217.665 56.525H217.749L217.834 56.4818H217.876L217.918 56.4399H218.002L218.213 56.5669L218.296 56.7345L218.38 56.7764V56.8615H218.423L218.465 57.0291L218.549 57.1142H218.676L218.802 57.2399L218.886 57.3236L219.013 57.3669H219.096H219.138L219.18 57.4087L219.391 57.6614L219.433 57.7452L219.56 57.8709H219.644L219.812 57.956L220.065 58.2087L220.107 58.2506L220.233 58.2925H220.402L220.485 58.3344H220.569L220.654 58.3763L220.738 58.4181L220.78 58.4614H220.822L220.907 58.5032H220.949H221.033L221.075 58.5451L221.16 58.5032H221.243V58.4614V58.4181L221.202 58.3763L221.285 58.4614L221.496 58.8397V58.8816L221.707 59.1762L221.916 59.5126L222.043 59.6815L222.212 59.8072L222.296 59.8923L222.338 59.9342L222.254 59.8923L222.296 59.9342H222.338V59.8923H222.38H222.464L222.507 59.9342L222.591 60.0599L222.758 60.2707L222.801 60.3126L222.927 60.4815L222.969 60.5234L223.054 60.6504L223.222 60.9017L223.264 60.9449L223.432 61.2395L223.601 61.3233L223.896 61.6598L223.938 61.7016L224.105 61.8705L224.232 61.9543L224.274 61.9962L224.443 62.1651L224.696 62.4178L224.863 62.5435L225.116 62.7124H225.2L225.369 62.8394H225.453H225.494L225.58 62.8812L225.621 62.8394L225.663 63.0069H225.621L225.705 63.1339L225.789 63.3015L225.874 63.4704L226 63.5961L226.085 63.638L226.127 63.6812L226.252 63.8488L226.336 63.9339L226.421 64.0176L226.716 64.2703L226.884 64.3541L227.052 64.396L227.136 64.3541L227.305 64.2703L227.347 64.3122L227.431 64.396V64.4379H227.516L227.852 64.6068L228.063 64.6487L228.147 64.6906L228.189 64.7325V64.6906V64.7325H228.274L228.358 64.7757L228.525 64.9014L228.61 65.0284L228.652 65.1121L228.736 65.4067L228.821 65.6175L228.778 65.6594L228.189 65.7851L227.6 65.9121L227.474 65.954L226.421 66.2066L226.336 66.4593L226.294 66.6688L226.169 67.0066L225.958 67.0904L225.916 67.1323L225.874 67.1742L225.832 67.343L225.621 67.5538L225.58 67.8903L225.494 68.016V68.1011L225.538 68.143V68.2268L225.494 68.3537V68.4375L225.538 68.5213V68.5632H225.494L225.453 68.6064L225.369 68.6902L225.2 68.8159L225.116 68.8578L225.074 68.9848V69.0267L225.032 69.0686L225.074 69.1956L225.032 69.2794L224.905 69.4482V69.4901V69.532L224.863 69.7428L224.822 69.7847L224.78 69.8685L224.696 69.9104H224.611L224.527 70.0793L224.443 70.1212L224.232 70.2469V70.2901L224.19 70.332V70.4158L224.105 70.4995L223.98 70.7522L223.853 70.7954L223.727 70.9211L223.685 70.963V71.1319L223.643 71.2576V71.3414L223.727 71.2995H223.811V71.3414H223.896L223.811 71.5103L223.727 71.6791L223.516 71.8886V71.9318L223.432 72.0156L223.474 72.0994L223.391 72.3521L223.305 72.4359L223.264 72.521L223.18 72.6048V72.6885V72.7317L223.096 72.7736H223.054L223.011 72.8155L222.927 72.8574L222.674 73.0682L222.632 73.152V73.3628L222.591 73.4047H222.549L222.464 73.4885V73.5304H222.38L222.296 73.6155L222.212 73.5736H222.085L222.043 73.4885V73.5736L221.916 73.6574L221.874 73.6155L221.833 73.5304V73.4885H221.791V73.4047L221.749 73.4466L221.707 73.4047L221.664 73.4466H221.622L221.496 73.5736L221.412 73.6155L221.454 73.6993L221.369 73.783H221.327L221.285 73.91L221.243 73.9938V74.0357L221.075 74.2046V74.2884L220.907 74.3303V74.4573L220.949 74.4992V74.5411L220.907 74.583L220.865 74.6681L220.78 74.6249L220.738 74.7519L220.696 74.7938L220.612 74.8357V74.8775H220.654V74.9626V75.0045L220.569 75.0883V75.1721L220.612 75.2991L220.696 75.341L220.654 75.3829H220.612V75.4667H220.527V75.5099L220.485 75.5518H220.443L220.485 75.5937H220.527H220.569V75.6356H220.612H220.78H220.822L220.907 75.5937L220.991 75.6775H220.949L220.738 75.8464V75.8883V75.9302L220.654 75.972V76.099L220.485 76.2666L220.402 76.3517L220.36 76.4355L220.402 76.4774L220.318 76.6044V76.6463L220.275 76.6882V76.7301L220.191 76.772L220.275 76.8571V76.9409L220.191 77.0247L220.149 77.0665L220.107 77.1084V77.1935L220.191 77.2354V77.3192L220.149 77.3611L220.065 77.4043H220.107H220.065L220.023 77.53V77.5719L220.065 77.6989L220.107 77.7408V77.8246L220.149 77.8665V77.9084V77.9503H220.233L220.275 78.0354L220.36 78.0773V78.161L220.275 78.1192H220.191L220.233 78.161V78.2029L220.149 78.2461L220.107 78.288L220.065 78.3299L219.98 78.4137L220.023 78.4556V78.4988L219.98 78.5407V78.5826L219.938 78.6245L219.854 78.6664H219.771V78.7502H219.685H219.644V78.7934L219.475 78.8353L219.433 78.8772L219.475 78.9191V79.0029L219.518 79.088L219.433 79.1299L219.475 79.2137H219.56V79.2555L219.602 79.2974H219.56L219.518 79.3825H219.475L219.433 79.4244L219.475 79.4663H219.518L219.644 79.5501L219.727 79.5933H219.771L219.896 79.6352V79.719L220.023 79.7609V79.8028L219.98 79.8879L220.023 79.9298L220.065 79.9717L220.107 80.0136V80.0555L220.065 80.1825L220.023 80.2663L219.98 80.3082V80.477L219.938 80.5189L219.98 80.5608L219.938 80.6027V80.6878L220.065 80.6446H220.191L220.233 80.6878H220.318L220.36 80.7297L220.318 80.8135L220.36 80.8554V80.9392L220.443 80.9824L220.485 81.0243L220.569 81.0662L220.738 80.9824L220.78 81.0243L220.738 81.0662L220.78 81.15H220.822V81.2338L220.865 81.3608L220.822 81.4445L220.78 81.4864V81.5715V81.6134V81.6553L220.696 81.7391L220.612 81.8661L220.569 81.9918L220.527 82.0337L220.485 82.1188H220.569V82.2445H220.485V82.2864L220.443 82.3283V82.3715L220.191 82.4134V82.4553L220.233 82.4972L220.275 82.5809L220.191 82.666L220.149 82.7498L220.191 82.7917H220.107L220.149 82.8336V82.9187L220.107 82.9606L220.149 83.0025L220.107 83.0444V83.0863L219.98 83.1282L219.938 83.1714H219.812L219.771 83.2133V83.339L219.727 83.3809V83.4228V83.466H219.685L219.602 83.5079L219.644 83.5498L219.602 83.5917L219.56 83.6754H219.518H219.475L219.391 83.7186L219.349 83.6754V83.7186L219.307 83.7605H219.223H219.138V83.7186H219.096L219.054 83.8024L219.138 83.8443V83.9281L219.096 84.0551H219.013H218.929H218.886L218.802 84.0132L218.718 84.097V84.2227L218.633 84.2659L218.591 84.2227H218.507V84.3078H218.465L218.423 84.2659L218.38 84.3078H218.338V84.3497V84.3916L218.296 84.4754L218.338 84.5605L218.296 84.6443L218.254 84.728L218.213 84.7699V84.8131V84.855H218.171H218.129L218.086 84.8969L217.96 84.855V84.8131L217.918 84.6862H217.876L217.834 84.728L217.665 84.6862L217.582 84.8131L217.413 84.9388L217.371 84.8969L217.455 84.8131L217.413 84.728V84.6443L217.371 84.4754L217.329 84.3916V84.3078L217.202 84.2227L217.16 84.097L217.076 84.0551H216.907L216.824 83.9281L216.697 83.8862L216.613 83.9281H216.529L216.487 83.97H216.402L216.444 83.9281V83.8862V83.8024L216.318 83.7605V83.7186L216.276 83.6754L216.234 83.7186H216.065V83.6335L216.107 83.5917V83.466L216.149 83.4228L216.234 83.339H216.276L216.234 83.2971H216.192L216.149 83.2552L216.065 83.1282L216.024 82.9606V82.9187L215.94 82.8755L215.771 82.7079L215.687 82.6241L215.518 82.4972H215.476L215.393 82.4553L215.224 82.3715H215.182L215.013 82.3283L214.929 82.2445L214.887 82.1607L214.802 82.0769H214.76L214.593 81.9499L214.466 81.8661L214.382 81.7823L214.298 81.6553H214.255L214.213 81.6134H214.087L213.96 81.5296L213.876 81.4445H213.835L213.709 81.4864H213.582L213.287 81.5296L213.077 81.5715H212.993H212.909H212.824L212.698 81.5296L212.656 81.5715L212.446 81.6553L212.362 81.6134H212.319L212.024 81.9499L211.898 81.9918L211.729 81.9499L211.646 82.0337H211.309L210.846 82.1188L210.257 82.2445L210.088 81.9918L210.046 81.9499H209.962L209.793 81.8661L209.457 81.9499H209.162H208.657L208.362 81.9918L208.446 81.6553L208.404 81.5715L208.573 81.4864L208.615 81.4027L208.573 81.2338L208.615 80.8973L208.657 80.6878L208.699 80.6446V80.5608L208.784 80.3082L208.74 80.2244L208.867 80.0555V80.0136L208.951 79.9717L209.036 79.8028V79.7609L209.12 79.6771V79.6352H209.078V79.5501L209.12 79.5933V79.5501L209.246 79.5082V79.4663L209.12 79.4244V79.1299L209.162 79.0448L209.078 78.8353L209.12 78.7502V78.5826L209.204 78.5407H209.246L209.288 78.4556L209.373 78.3718L209.415 78.3299L209.498 78.2461V78.2029L209.373 78.161L209.288 78.2029L209.204 78.288H209.12L209.078 78.2461L209.036 78.1192L208.993 78.0773L208.951 77.9503V77.9084L208.867 77.8246L208.826 77.7827L208.74 77.7408H208.573L208.278 77.6989L208.026 77.6557L207.984 77.6138L207.857 77.53L207.731 77.4043H207.393L207.268 77.2773L207.226 77.2354L207.309 77.0665V77.0247L207.226 76.9409V76.899L207.142 76.6882L206.889 76.4355V76.3517V76.2666L206.847 76.099V76.0153V75.8045L206.804 75.5937V75.5099L206.889 75.4667L206.931 75.2572V75.2153V75.1302V75.0464L206.889 75.0045L206.804 74.9626L206.762 74.9208L206.678 74.71L206.51 74.4992V74.3722V74.2046V74.1627V74.1208V74.0357L206.551 73.91L206.468 73.7412L206.384 73.4466L206.299 73.3628L206.173 73.4047V73.3628V73.3209V73.1939L206.257 73.1101V73.0682L206.299 73.0263L206.342 72.8993V72.5629L206.215 72.4359L206.257 72.3102L206.173 72.0994L206.131 71.9737L206.173 71.7629L206.131 71.594L206.089 71.4265L206.131 71.3414L206.047 71.2157L206.004 71.0468L205.962 70.963L206.004 70.9211L206.131 70.8792L206.173 70.7954L206.215 70.6265L206.173 70.5427L206.131 70.4577V70.2901L206.004 70.205V70.1212L205.962 70.0374L206.004 69.9955V69.9104V69.8685V69.8266V69.7847L206.089 69.7009V69.6577L206.047 69.5739L206.004 69.532L205.962 69.4901L205.92 69.405V69.3632L205.962 69.3213H206.089L206.131 69.2794L206.089 69.1956L206.004 69.0686L205.962 69.0267L206.004 68.901L206.089 68.8578L206.131 68.7321V68.6483L206.047 68.6064V68.5632V68.4794V68.4375L206.131 68.3956L206.089 68.3105H206.047L205.92 68.2268L206.047 68.143L206.004 67.9741L206.047 67.8484L206.004 67.7633H205.962H205.879L205.795 67.6376H205.753L205.71 67.6795L205.668 67.5538L205.5 67.4687V67.343L205.415 67.3849L205.373 67.2592H205.331L205.247 67.343L205.079 67.2592V67.1742L205.037 67.1323V67.0904H204.995V67.0066H204.784L204.826 66.8377V66.712L204.742 66.6688V66.585H204.7L204.658 66.6269L204.448 66.3323L204.362 66.2904L204.321 66.3742L204.279 66.3323V66.2904H204.237H204.195V66.2066L204.111 66.0796L204.153 65.9959L204.026 65.827L204.111 65.7432L204.068 65.5324L204.153 65.4905V65.4486L204.195 65.3229L204.279 65.2797V65.2378L204.111 65.1959L204.026 65.154V65.1121L204.111 65.0702V65.0284L204.153 64.9433L204.321 64.7757L204.489 64.5649L204.448 64.523L204.321 64.3541L204.153 64.2703V64.1852L204.195 64.0595V64.0176V63.9757H204.111L204.068 63.9339H204.111H204.195L204.237 63.8069H204.279L204.321 63.6812L204.406 63.5961V63.4285L204.489 63.3015V63.1339V63.0907L204.573 62.9231V62.7543V62.7124L204.658 62.6286L204.742 62.4597L204.826 62.4178V62.3759V62.2921L204.742 61.7867L204.953 61.449L205.037 61.3652L204.868 61.3233L204.784 61.2814V61.1976L204.7 61.0706L204.742 61.0287L204.826 60.776L204.784 60.6922L204.868 60.6071V60.5653L204.826 60.5234H204.7L204.573 60.4815H204.531L204.448 60.4396V60.3977L204.406 60.4396L204.362 60.3977L204.279 60.4396H204.195L204.111 60.4815L204.026 60.5234H203.984V60.4815L204.111 60.3977L204.068 60.3126L204.026 60.2288L204.068 60.1869V60.145H204.111V60.1031H204.153L204.237 59.8923L204.153 59.7234L204.068 59.6396L204.026 59.5559L203.984 59.4708V59.4289L203.942 59.387L203.9 59.3451V59.3032L203.858 59.1762H203.815V59.1343L203.731 59.2181V59.1762L203.942 58.9654L204.026 58.8397L203.942 58.7559L203.984 58.5451L204.026 58.5032H204.111V58.4614L203.984 58.3763H203.858L203.773 58.2925H203.69H203.564L203.479 58.2506L203.437 58.2087L203.479 58.1655L203.521 57.8709L203.437 57.6614L203.353 57.6195L203.268 57.5763V57.5344L203.311 57.4925V57.4506H203.479L203.564 57.3236V57.1142L203.606 57.071L203.731 57.0291H203.648L203.564 57.071V57.0291L203.521 56.8615L203.437 56.7764V56.6926V56.5669V56.525H203.395H203.184L203.142 56.4399H203.1V56.3142V56.2291L202.973 56.2724V56.2291L203.017 56.1454Z"
							fill="#195386" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="RN" @mouseenter="e => hoverES(e, 'RN')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M220.612 74.8772V74.8353L220.696 74.7934L220.738 74.7516L220.78 74.6246L220.865 74.6678L220.907 74.5827L220.949 74.5408V74.4989L220.907 74.457V74.33L221.074 74.2881V74.2043L221.243 74.0354V73.9935L221.285 73.9097L221.327 73.7827H221.369L221.454 73.6989L221.412 73.6152L221.496 73.5733L221.622 73.4463H221.664L221.707 73.4044L221.749 73.4463L221.791 73.4044V73.4882H221.832V73.5301L221.874 73.6152L221.916 73.6571L222.043 73.5733V73.4882L222.085 73.5733H222.212L222.296 73.6152L222.38 73.5301H222.464V73.4882L222.549 73.4044H222.591L222.632 73.3625V73.1517L222.674 73.0679L222.927 72.8571L223.011 72.8152L223.054 72.7733H223.096L223.18 72.7314V72.6882V72.6044L223.263 72.5207L223.305 72.4356L223.39 72.3518L223.474 72.0991L223.432 72.0153L223.516 71.9315V71.8883L223.727 71.6788L223.811 71.5099L223.896 71.3411H223.811V71.2992H223.727L223.643 71.3411V71.2573L223.685 71.1316V70.9627L223.727 70.9208L223.853 70.7951L223.98 70.7519L224.105 70.4992L224.19 70.4154V70.3317L224.232 70.2898V70.2466L224.443 70.1209L224.527 70.079L224.611 69.9101H224.696L224.78 69.8682L224.821 69.7844L224.863 69.7425L224.905 69.5317V69.4898V69.4479L225.032 69.279L225.074 69.1953L225.032 69.0683L225.074 69.0264V68.9845L225.116 68.8575L225.2 68.8156L225.369 68.6899L225.452 68.6061L225.494 68.5629H225.538V68.521L225.494 68.4372V68.3534L225.538 68.2264V68.1427L225.494 68.1008V68.0157L225.579 67.89L225.621 67.5535L225.832 67.3427L225.874 67.1738L225.916 67.1319L225.958 67.09L226.169 67.0063L226.294 66.6685L226.336 66.459L226.421 66.2063L227.474 65.9537L227.6 65.9118L228.189 65.7848L228.778 65.6591L228.821 65.6172L228.863 65.701L228.989 65.9118L229.072 65.9955L229.241 66.1644L229.367 66.2482H229.41L229.536 66.2901L229.62 66.2482L229.705 66.2063H229.789L229.872 66.2482L230.041 66.332L230.125 66.3739L230.21 66.332L230.378 66.2482H230.505H230.547L230.588 66.2063L230.63 66.1644L230.883 66.332L231.01 66.3739H231.136L231.261 66.5009L231.388 66.6685L231.641 66.9212L231.852 67.0063L231.978 67.09L232.061 67.0482L232.019 67.09L232.105 67.1738L232.146 67.1319L232.188 67.09H232.23V67.2157L232.314 67.2589L232.441 67.2157L232.694 67.2589L232.736 67.1738L232.819 67.2157L232.861 67.1738H232.903H232.946L233.114 67.2157L233.156 67.1738H233.325L233.45 67.09H233.577L233.872 67.1319L234.083 67.1738L234.292 67.2589H234.419L234.461 67.2157L234.545 67.2589L234.672 67.3008V67.3427L234.798 67.2589H234.883L235.092 67.3008H235.639L235.808 67.2589L235.977 67.1738L236.103 67.09H236.23L236.356 67.0063H236.524L236.566 66.9631H236.692H236.903L237.155 67.0482L237.323 67.1319H237.492L237.661 67.1738L237.828 67.1319L237.87 67.1738H237.914L237.997 67.2157L238.081 67.2589L238.334 67.3008L238.376 67.3427H238.461L238.797 67.4265L238.839 67.4684L238.881 67.4265H238.965V67.3846L239.261 67.5535L239.47 67.5954L239.639 67.6792H239.765L239.892 67.8481L239.934 67.9319L240.017 67.9738L240.186 68.1008L240.355 68.3102L240.397 68.3953L240.439 68.4372L240.481 68.5629L240.565 68.9007L240.607 68.9845L240.692 69.0683L240.775 69.1102L240.859 69.1953V69.279L240.944 69.4047H240.986V69.6155L241.028 69.6574L241.112 69.7425L241.154 69.7844V69.7425V69.8682L241.197 69.952V69.9952L241.239 70.0371V70.1628L241.281 70.2466L241.323 70.3735H241.365V70.4154V70.5843L241.406 70.71H241.448V70.9627V71.0046L241.492 71.0897H241.575V71.1316L241.533 71.4262V71.5099L241.575 71.5518V71.6788L241.617 71.7626H241.659V71.8045V72.2261L241.701 72.3099L241.744 72.3518L241.786 72.3099H241.828V72.4356V72.5626V72.6044V72.6882L241.87 72.8571H241.997L242.039 72.9828H242.081V73.026L242.123 73.1098L242.081 73.2787L242.123 73.4044V73.4463H242.165V73.5733V73.9097V73.9516L242.206 74.2462V74.2043L242.248 74.2462V74.2881L242.292 74.4151L242.333 74.4989H242.375L242.417 74.5408H242.543V74.5827L242.586 74.9204V75.0461L242.543 75.088L242.586 75.2569L242.628 75.3826L242.67 75.4245H242.712H242.754H242.796L242.839 75.4664L242.881 75.6353L242.964 75.8879V76.0149V76.0987V76.1825L242.923 76.2244L242.839 76.2663L242.712 76.3095H242.67H242.628L242.543 76.3933L242.417 76.4352H242.375L242.206 76.2663H242.165L242.123 76.3095H242.081L242.039 76.4771H241.954L241.87 76.6041H241.828L241.744 76.646L241.575 76.6041H241.533L241.492 76.519L241.448 76.3933H241.406L241.365 76.4771H241.197L241.07 76.5609H240.734L240.65 76.519L240.523 76.3514L240.439 76.3095L240.312 76.2244H240.27L240.144 76.1825H240.059V76.1406L240.017 76.1825L239.934 76.1406H239.892L239.85 76.1825H239.808H239.765L239.723 76.1406V76.1825L239.681 76.1406H239.597H239.555L239.512 76.0987V76.1406H239.47H239.428H239.386L239.344 76.2244H239.303V76.1825H239.176L239.134 76.1406V76.0987L239.05 76.0149H238.965H238.923L238.839 75.9717L238.713 75.9298H238.67V75.9717H238.628L238.545 75.9298L238.418 76.0568L238.376 76.0987H238.334H238.292L237.997 76.1406L237.955 76.1825H237.492L236.945 76.2244L236.819 76.1825H236.734L236.566 76.1406L236.524 76.0987V76.0568V75.9717L236.356 75.9298L236.272 75.8461L236.187 75.6772V75.7191H236.145V75.6772H236.103L236.061 75.7191L235.977 75.7623H235.934L235.892 75.8042H235.808H235.766H235.683L235.514 75.8461H235.261H235.219L235.05 75.8879L235.008 75.6772L234.925 75.6353L234.798 75.5934H234.756V75.5096V75.4664V75.4245L234.839 75.2988V75.088V75.0461L234.756 74.9623L234.672 74.8772L234.461 75.0042L234.335 75.0461L234.125 74.9623L233.914 75.3826H233.745L233.494 75.3407L233.45 75.5515V75.6353L233.325 75.8461L233.283 75.9298V76.0149L233.325 76.1406V76.2663H233.367L233.494 76.3514L233.577 76.3933L233.619 76.519L233.661 76.5609L233.745 76.6041H233.788L233.83 76.646V76.8987L233.872 77.0662V77.1081L233.788 77.0662L233.745 77.1081L233.661 76.9824L233.45 76.8987L233.409 76.8568L233.325 76.8987L233.367 76.9824L233.241 77.2351L233.199 77.5297L233.114 77.6135L233.199 77.7405L233.283 77.7824H233.325V77.8243H233.367L233.409 77.8662L233.45 77.9081L233.494 78.0351L233.45 78.2877L233.409 78.3296L233.283 78.3715L233.199 78.4553H233.114L233.072 78.4985L233.03 78.5404L233.072 78.6242V78.6661L232.819 79.0445H232.777H232.65L232.525 79.0026H232.314L232.188 79.3403H232.146L231.978 79.2552L231.852 79.0445L231.894 78.9188V78.835L231.978 78.708L232.061 78.4134L231.809 78.4553V78.1188L231.388 77.7405L231.178 77.8243L230.967 77.9081H230.925L230.757 77.9932L230.63 78.1188V78.0769L230.672 78.0351H230.588V77.9932L230.547 77.9081V77.8243L230.505 77.6986L230.461 77.6135H230.378L230.167 77.7824L230.125 77.8243L229.999 77.8662L229.916 77.9081L229.62 77.9932H229.578L229.452 78.1607L229.199 78.3296H228.947L228.821 78.2458V78.1607L228.778 78.1188V78.0769L228.694 77.9932L228.736 77.9081V77.7405L228.652 77.6986L228.568 77.6135L228.61 77.5297L228.441 77.4878L228.274 77.5716L227.936 77.5297H227.852L227.389 77.6135L227.474 77.404L227.431 77.3608L227.474 77.277L227.431 77.1932V77.0243V76.9406H227.389V76.8568L227.431 76.6879L227.389 76.646V76.6041L227.474 76.4771H227.516H227.641H227.683H227.81L227.936 76.3514L227.978 75.9717L228.021 75.8461L227.978 75.8042L227.936 75.7191V75.6353L227.978 75.5934V75.5515V75.5096L228.063 75.4245V75.2569L228.105 75.1299H228.147L228.316 75.0461L228.358 75.0042L228.399 74.8772L228.483 74.8353L228.61 74.8772H228.694V74.6678L228.821 74.5408L228.905 74.457H228.947L228.989 74.4151L229.116 74.3719L229.199 74.33V74.2462L229.325 74.2043L229.367 74.1624L229.41 74.0354H229.367L229.283 73.9935L229.367 73.7827L229.325 73.6989V73.6152L229.283 73.4044L229.325 73.3625H229.199L229.116 73.3206L228.989 73.3625L228.947 73.2787L228.863 73.2355H228.821L228.778 73.2787L228.736 73.3625L228.694 73.4463H228.61L228.525 73.4044L228.483 73.4463L228.316 73.4882L228.189 73.6152H228.063H228.021L227.936 73.7827H227.852H227.727H227.6L227.558 73.8259V73.9935L227.389 74.0354L227.347 73.9935H227.263V74.0354H227.136H227.052V74.1205H226.927L226.842 74.0773L226.758 74.1205L226.674 74.2043H226.547H226.421L226.379 74.2881H226.169L226.042 74.2462L226 74.2043H225.958L225.747 74.33L225.705 74.3719V74.457H225.663L225.579 74.5408L225.663 74.5827L225.579 74.6246L225.663 74.7097L225.621 74.7516V74.8353L225.663 74.9204H225.705H225.579H225.452H225.369L225.285 75.0461L225.327 75.088H225.285L225.2 75.1299L225.158 75.215L225.2 75.2569L225.158 75.3407V75.3826L225.074 75.4245L225.032 75.4664L224.863 75.3826V75.5515L224.905 75.5934L224.863 75.6353H224.78L224.696 75.7191L224.611 75.7623H224.527L224.443 75.6772V75.6353L224.4 75.6772L224.358 75.7623L224.316 75.8042H224.105L224.148 75.8461L224.063 75.9298L224.105 76.0568H224.063L224.021 76.0987H223.98H223.938L223.98 76.0149L223.896 75.9717V75.8879H223.853V75.9717H223.811V76.0149H223.769L223.727 76.0568L223.685 76.1825L223.601 76.2244L223.558 76.3095L223.474 76.3933H223.432H223.349L223.263 76.2244L223.18 76.2663H223.011L222.927 76.1825H222.758L222.716 76.1406L222.632 76.1825H222.591L222.38 76.3095V76.1825H222.254L222.212 76.0987L222.127 76.0149H222.085H222.043H222.001H221.959L221.916 75.9717H221.874V75.8879L221.832 75.8461L221.791 75.7623L221.749 75.7191L221.707 75.6772H221.664L221.538 75.7191L221.412 75.6353L221.369 75.5934H221.285L221.16 75.6353L221.201 75.5096L221.16 75.4245L221.243 75.2988L221.327 75.1718L221.243 75.215L221.16 75.2569H221.118L221.033 75.3407L220.991 75.2988H220.949L220.865 75.2569H220.822L220.78 75.2988L220.822 75.3407H220.696L220.612 75.2988L220.569 75.1718V75.088L220.654 75.0042V74.9623V74.8772H220.612Z"
							fill="#3482cc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="AL" @mouseenter="e => hoverES(e, 'AL')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M222.716 94.3675L222.927 94.158L223.054 94.1148L223.222 93.9472V93.8634V93.8202L223.305 93.6527L223.432 93.5257L223.558 93.4L223.601 93.3581H223.685H223.769L223.853 93.3149H223.896H223.98L224.021 93.2311H224.105H224.19H224.232L224.316 93.1892L224.358 93.0635L224.443 92.9784V92.9365L224.485 92.8946L224.527 92.8527L224.569 92.7689L224.738 92.6001L224.78 92.5163L224.863 92.4731L224.905 92.5163L224.947 92.3893V92.3474L225.032 92.3055L225.116 92.2204L225.158 92.1366L225.2 92.0947L225.243 91.842L225.2 91.8001L225.285 91.7163V91.6312L225.243 91.5893L225.369 91.5056H225.411L225.538 91.3786H225.579H225.621L225.663 91.3367L225.747 91.4218V91.5056L225.789 91.5474H225.832V91.5893L225.874 91.6312L225.916 91.7163L226 91.8001V91.842L226.042 91.9258L226.127 91.969V92.0528V92.0947L226.085 92.1366L226.042 92.1785V92.2204L226.127 92.1785V92.2636L226.294 92.1785V92.2204L226.252 92.2636L226.294 92.3055L226.379 92.3474H226.547L226.589 92.3055L226.547 92.2636L226.589 92.1785L226.674 92.0947L226.758 92.0528L226.883 92.0947L227.01 91.969L227.094 92.0109H227.136L227.221 92.0528H227.347V92.0947V92.2204L227.305 92.2636L227.474 92.4312H227.6H227.683L227.81 92.5163L227.894 92.6001L228.316 92.7689L228.358 92.8527H228.441V92.8946V92.9365L228.525 93.0203L228.652 93.1892L228.736 93.273L228.778 93.3149L228.863 93.4V93.4419V93.4838L228.905 93.5676H228.947V93.6527V93.6946V93.7364V93.7783L229.072 93.6527L229.158 93.6108L229.41 93.7783L229.325 93.8634V93.9472V93.9891L229.367 94.031L229.494 93.9472L229.578 93.9053L229.663 93.7783H229.705L229.872 93.8634L229.916 93.9053L230.041 94.0729L229.999 94.1999L230.041 94.2837V94.1999L230.083 94.2837H230.252L230.378 94.4945L230.547 94.5783L230.672 94.7053H230.714L230.757 94.6621H230.799V94.6202L230.757 94.5783V94.4945L230.883 94.4094V94.3675L230.841 94.3256L230.925 94.158L231.01 94.0729H231.052L231.178 94.031H231.136L231.178 93.9891H231.305L231.347 94.031L231.388 94.1148H231.641L231.894 93.9891L232.272 94.031L232.356 94.0729L232.483 94.2418L232.567 94.2837V94.2418L232.609 94.2837H232.65V94.3256L232.694 94.3675L232.736 94.3256V94.3675L232.777 94.3256V94.3675H232.819V94.4094V94.4526L232.903 94.4094H232.946L233.03 94.3675H233.072V94.3256V94.2837H233.03V94.1148L233.45 93.9891L233.494 93.9472L233.536 93.9053V93.8634L233.577 93.7783H233.619L233.661 93.8202L233.703 93.7783L233.745 93.7364H233.788V93.6946L233.872 93.6527V93.6108H233.956V93.6946L233.998 93.7364L234.041 93.6527L234.083 93.6946H234.167L234.25 93.6527L234.335 93.6946L234.377 93.6527L234.419 93.6108L234.377 93.5676V93.5257L234.461 93.5676H234.503L234.545 93.5257L234.588 93.4419L234.63 93.4L234.672 93.3581V93.4L234.714 93.3581L234.756 93.4V93.3581H234.798L234.883 93.3149L234.925 93.3581H234.966V93.4H235.008V93.3581L235.05 93.4L235.177 93.3581V93.3149L235.092 93.273V93.1892L235.05 93.1473H234.966V93.0635V93.0203L234.925 92.9784V92.8946H235.05H235.135L235.219 92.8108V92.7257H235.261L235.303 92.6838L235.345 92.5582H235.387H235.43L235.472 92.5163H235.514H235.556H235.639H235.683H235.725V92.4731L235.808 92.4312L235.892 92.3474V92.3055L235.934 92.2636L235.892 92.1785L235.808 92.1366L235.766 92.0528L235.808 91.969L236.061 91.8839L236.187 91.7163L236.397 91.6744L236.566 91.7163L236.65 91.6312H236.734H236.777H236.819V91.5893L236.903 91.5474L236.945 91.5056H237.028H237.072L237.114 91.4218V91.3786H237.155H237.197L237.239 91.3367L237.281 91.3786L237.45 91.3367L237.534 91.4218H237.576H237.661L237.703 91.3367L237.787 91.3786L237.87 91.2948H237.914L237.955 91.3786V91.3367V91.4218L237.914 91.5056L237.955 91.5474L237.914 91.5893H237.955L237.997 91.6312L238.081 91.6744L238.166 91.7163L238.25 91.6744H238.292H238.334L238.376 91.6312L238.461 91.6744L238.503 91.5893H238.628L238.713 91.5056H238.755H238.797H238.839L238.881 91.4637L238.965 91.3786H239.092L239.134 91.2948L239.176 91.2529H239.217H239.261L239.303 91.1691H239.386L239.428 91.1259L239.47 91.084V91.1691L239.555 91.084H239.639V91.1259L239.681 91.084V91.1259L239.723 91.1691V91.1259H239.808V91.084H239.85H239.892H239.934L239.892 91.1691H239.934V91.211L239.976 91.2529H240.103V91.211H240.186H240.228H240.27L240.312 91.2948L240.607 91.3786L240.944 91.4637H240.986H241.07L241.239 91.5474L241.323 91.5056L241.406 91.5474H241.492H241.533H241.701L241.828 91.6312V91.7163V91.7582L241.744 91.842L241.701 91.969L241.659 92.0947L241.617 92.1366L241.492 92.2636L241.406 92.3893L241.365 92.4312L241.323 92.5582V92.6419L241.281 92.6838H241.323L241.281 92.7257L241.197 92.8108V92.8527V92.8946L241.112 92.9784V93.0203L241.028 93.0635V93.1892L240.986 93.2311H240.944V93.3581V93.4L240.902 93.4838L240.817 93.5257L240.775 93.5676V93.6108L240.734 93.6946L240.65 93.7364V93.7783L240.607 93.9053L240.481 94.031L240.397 94.0729L240.312 94.1999L240.228 94.2418L240.186 94.2837H240.228L240.103 94.3256L240.059 94.3675V94.4094L239.934 94.4526L239.892 94.4945L239.765 94.6202L239.723 94.7053L239.681 94.9147L239.597 95.0836H239.512V95.1674H239.47L239.344 95.2944L239.303 95.3782L239.134 95.5039V95.6309H239.05L238.965 95.7147V95.7566L238.881 95.7998L238.797 95.8836H238.755L238.67 96.0092L238.586 96.0943L238.545 96.1781L238.461 96.3038V96.3889V96.5146H238.376L238.292 96.6416L238.25 96.5984H238.292V96.5565H238.25L238.081 96.5984L237.914 96.8092H237.87L237.745 96.9362L237.703 97.0199L237.745 96.9781L237.492 97.2726L237.366 97.4834L237.281 97.6091L237.197 97.8199L236.945 98.0307L236.819 98.2833L236.734 98.409L236.566 98.6617L236.397 98.9563L236.314 99.0401V99.1252L236.23 99.2089L236.145 99.1671L236.061 99.2508L235.892 99.4616L235.85 99.5454L235.766 99.6292V99.6724L235.683 99.6292L235.598 99.6724L235.514 99.7562L235.43 99.9251L235.261 100.009L235.092 100.22L234.883 100.387L234.756 100.556L234.714 100.64V100.724V100.851L234.756 100.893V100.934L234.714 100.976H234.672L234.503 101.229L234.25 101.776L234.208 101.818L234.167 101.861L234.125 101.818L234.083 101.734L233.956 101.482L233.914 101.356H233.872L233.745 101.271L233.703 101.229L233.577 101.314V101.356H233.536L233.409 101.398H233.367V101.356H233.409H233.241L233.199 101.398L233.072 101.314L233.114 101.145L233.072 100.976V100.767L233.03 100.682L232.946 100.556L232.903 100.472L232.777 100.387V100.345L232.736 100.303L232.694 100.262H232.65H232.609L232.525 100.345H232.399L232.356 100.387H232.272H232.23L232.146 100.345H232.105L232.019 100.262L231.936 100.22H231.894L231.936 100.176V100.135L231.809 100.093H231.767L231.556 100.051L231.514 100.009L231.388 99.9251L231.347 99.8819V99.84V99.7981V99.7562L231.305 99.6724H231.22L231.136 99.5873L230.925 99.5454L230.883 99.4616L230.799 99.3346L230.714 99.2508L230.672 99.1252V99.0833V99.0401L230.63 98.9982V98.9563V98.8306V98.7874V98.7036L230.588 98.6198V98.5779L230.42 98.4928H230.378H230.336L230.21 98.5779H230.167H230.083L229.916 98.409L229.578 98.1144L229.452 98.0307L229.158 97.9888H228.989H228.905L228.863 97.9456V97.9037L228.821 97.8199L228.736 97.6929L228.61 97.5672L228.525 97.5253L228.399 97.4834L228.231 97.3564L228.189 97.3145L228.147 97.2726H228.063L227.936 97.2307L227.768 97.1456L227.727 97.1037L227.474 97.0618L226.969 96.9781H226.842L226.758 96.9362L226.294 96.6416V96.5984L226.252 96.5146L226.21 96.4308L226.127 96.3889L225.958 96.3038L225.747 96.2619H225.705L225.538 96.347H225.494L225.452 96.22L225.369 96.1362L225.327 96.0511H225.285H225.2V95.9673H225.158L224.905 95.7566L224.863 95.7147H224.821L224.696 95.7566L224.443 95.6728L224.232 95.6309L224.148 95.5471L224.19 95.4201L224.105 95.3363L224.021 95.2525H223.98H223.896L223.811 95.1674H223.769L223.727 95.1255V95.0836H223.685L223.516 95.0417H223.474L223.432 95.0836L223.305 95.0417L223.222 95.0836L223.096 94.9566H222.969L222.927 94.9147V94.8309L222.969 94.7891V94.7053L222.927 94.6621L222.885 94.5364L222.716 94.3675Z"
							fill="#1169bc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="SE" @mouseenter="e => hoverES(e, 'SE')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M222.716 103.71H222.758L222.801 103.627L222.843 103.501V103.416V103.332V103.248L222.885 103.163H222.927L223.054 103.121L223.096 103.205H223.18H223.222L223.305 103.248H223.39L223.432 103.163L223.516 103.205L223.601 103.121L223.643 103.163L223.685 103.205L223.811 103.163H223.853L223.896 103.248H223.938L224.021 103.332V103.374V103.543H224.19L224.358 103.458L224.569 103.374L225.327 103.079L225.243 102.363V102.321L225.2 102.28V102.238L225.158 102.196V102.154H225.243V102.111L225.285 102.069V102.111V102.027L225.327 101.943V101.901V101.859L225.285 101.732L225.074 101.354L225.116 101.312L225.074 101.227L225.2 101.185H225.158V101.143L225.2 101.101V101.059H225.243H225.285V101.017L225.327 100.974H225.369L225.494 100.89L225.538 100.849H225.663L225.832 100.765L225.789 100.722V100.68L225.621 99.8797L225.538 99.8378V99.7959L225.579 99.5851V99.5014L225.452 99.3325L225.285 98.996V98.8703V98.8284V98.7433L225.243 98.6595L224.947 98.4906L224.905 98.5325L224.78 98.4906H224.696H224.653V98.4069H224.569L224.485 98.4488H224.443L224.4 98.4069L224.274 98.1542L224.19 98.1123V98.0704L224.274 97.9434V97.8177L224.358 97.7339V97.6907L224.316 97.6488L224.358 97.565L224.4 97.4812L224.358 97.4393H224.316L224.19 97.3961L224.063 97.2705V97.2286H224.021L223.938 97.0597V96.934V96.807V96.7232V96.6813V96.6394L224.021 96.5962L224.063 96.5124L224.148 96.4286H224.19H224.232L224.274 96.3867L224.232 96.3448L224.148 96.3016L224.105 96.2598L224.063 96.2179L223.98 96.176L223.938 96.0922V95.9652V95.9233L223.98 95.8814L224.021 95.9233V95.8814L224.063 95.8395V95.7976L224.021 95.7544L224.063 95.7125L224.105 95.6706V95.6287L224.148 95.5449L224.232 95.6287L224.443 95.6706L224.696 95.7544L224.821 95.7125H224.863L224.905 95.7544L225.158 95.9652H225.2V96.049H225.285H225.327L225.369 96.1341L225.452 96.2179L225.494 96.3448H225.538L225.705 96.2598H225.747L225.958 96.3016L226.127 96.3867L226.21 96.4286L226.252 96.5124L226.294 96.5962V96.6394L226.758 96.934L226.842 96.9759H226.969L227.474 97.0597L227.727 97.1016L227.768 97.1435L227.936 97.2286L228.063 97.2705H228.147L228.189 97.3124L228.231 97.3543L228.399 97.4812L228.525 97.5231L228.61 97.565L228.736 97.6907L228.821 97.8177L228.863 97.9015V97.9434L228.905 97.9866H228.989H229.158L229.452 98.0285L229.578 98.1123L229.916 98.4069L230.083 98.5757H230.167H230.21L230.336 98.4906H230.378H230.42L230.588 98.5757V98.6176L230.63 98.7014V98.7852V98.8284V98.9541V98.996L230.672 99.0379V99.0811V99.123L230.714 99.2487L230.799 99.3325L230.883 99.4595L230.925 99.5433L231.136 99.5851L231.22 99.6702H231.305L231.347 99.754V99.7959V99.8378V99.8797L231.388 99.9229L231.514 100.007L231.556 100.049L231.767 100.091H231.809L231.936 100.132V100.174L231.894 100.217H231.936L232.019 100.259L232.105 100.343H232.146L232.23 100.385H232.272H232.356L232.399 100.343H232.525L232.609 100.259H232.651H232.694L232.736 100.301L232.777 100.343V100.385L232.903 100.47L232.946 100.554L233.03 100.68L233.072 100.765V100.974L233.114 101.143L233.072 101.312L233.199 101.396L233.241 101.354H233.409H233.367V101.396H233.409L233.536 101.354H233.577V101.312L233.703 101.227L233.745 101.269L233.872 101.354H233.914L233.956 101.48L234.083 101.732L234.125 101.816V101.859V101.901V101.985L234.083 101.943L233.872 101.985L233.494 102.069L232.988 102.28L232.736 102.406L232.525 102.574L232.356 102.701L232.061 102.827L231.556 103.163L231.347 103.374L231.305 103.416L230.757 103.963L230.588 104.174L230.42 104.427L230.21 104.721V104.805L230.041 105.016L229.578 105.69L229.41 106.026L229.452 106.068L229.116 106.447L228.778 106.868L228.568 107.247L228.399 107.752L228.358 107.794V107.879H228.274H228.231H228.147L228.105 107.963H228.063L227.936 108.088L227.81 108.215L227.641 108.341L227.558 108.383H227.516H227.347H227.263L227.179 108.468V108.552H226.969H226.927L226.883 108.51H226.842H226.8L226.842 108.552H226.8L226.758 108.51L226.8 108.426H226.758H226.716L226.632 108.468H226.589H226.547L226.505 108.426L226.463 108.341H226.421L226.379 108.383L226.336 108.341V108.426H226.294H226.252L226.294 108.51L226.21 108.594V108.636V108.678L226.127 108.636H226.042L226.085 108.51H226.042L225.958 108.552H225.916H225.874V108.468H225.747L225.663 108.383L225.621 108.426L225.579 108.383H225.494L225.452 108.341L225.411 108.383L225.327 108.341V108.257L225.369 108.215L225.327 108.174H225.285L225.2 108.13H225.158L225.116 108.047H225.074L225.032 108.005V107.963V107.921H225.074H225.116V107.879V107.836L224.99 107.879V107.836L224.905 107.794H224.947H225.032L224.947 107.752H224.905L224.863 107.836V107.794L224.821 107.836L224.78 107.794V107.752V107.668H224.738L224.696 107.626H224.611V107.668H224.569V107.752H224.527V107.71L224.485 107.668L224.443 107.626H224.485V107.583H224.443L224.4 107.626V107.541H224.316V107.499L224.358 107.457V107.416L224.316 107.374L224.274 107.247V107.205L224.232 107.247L224.19 107.205V107.163H224.274L224.19 107.121V107.079H224.232L224.148 106.952V106.868L224.232 106.826V106.784L224.274 106.741L224.232 106.699L224.274 106.658V106.616H224.232V106.574H224.274L224.232 106.489H224.274L224.316 106.447V106.405V106.363V106.321L224.358 106.279H224.316H224.274L224.19 106.237L224.148 106.279L224.021 106.152L223.98 106.194L223.896 106.152L223.811 106.068L223.727 106.026L223.769 105.985L223.727 105.943L223.769 105.858V105.816H223.727L223.643 105.774L223.601 105.69V105.647H223.643L223.685 105.521V105.437H223.643V105.394H223.601V105.352H223.558L223.516 105.31V105.268H223.558L223.516 105.185V105.143L223.474 105.1L223.39 105.058V105.143H223.349L223.305 105.1L223.263 105.016L223.096 104.932L223.054 104.848L223.011 104.805L223.054 104.721V104.679L222.927 104.637V104.552H222.885L222.843 104.595V104.552L222.758 104.51V104.385L222.674 104.258V104.174L222.716 104.09L222.758 104.048L222.716 103.921H222.674L222.716 103.837L222.674 103.754L222.716 103.71Z"
							fill="#52a8ff" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="DF" @mouseenter="e => hoverES(e, 'DF')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M160.415 135.918V135.875L160.5 135.749L160.667 135.707L160.711 135.623L160.836 135.454H160.878L160.92 135.37L160.878 135.202L160.836 135.118L160.753 135.16L160.667 135.118V134.991L160.711 134.823L160.753 134.696L160.836 134.571H160.92V133.896V133.812H161.847H161.973H163.573H164.289H164.878H165.298H165.804V134.107H165.887L165.972 134.233H166.014V134.276L166.056 134.318H166.225L166.351 134.36H166.393L166.435 134.402L166.393 134.444L166.309 134.654L166.351 134.738V134.823V134.907L166.309 134.949L166.351 134.991H166.393L166.435 135.033V135.118L166.393 135.202V135.285L166.435 135.327V135.37H166.393V135.454V135.412V135.454L166.351 135.496V135.538V135.58H166.309L166.267 135.707L166.225 135.749V135.791H166.182V135.875H166.14L166.098 135.918V135.96V136.002V136.043V136.085L166.056 136.127H166.098V136.17L166.056 136.254H166.014H166.056V136.338L166.098 136.38L166.056 136.422H166.14L166.098 136.465V136.507H166.14V136.549V136.591H166.056L166.098 136.633V136.674V136.718H166.056V136.76V136.801V136.885V136.927V136.969H166.098V137.012H166.14V137.054H166.225V137.096H166.267V137.138L166.309 137.096L166.351 137.18H166.393V137.222H166.478L166.435 137.264H166.478V137.307H164.54H164.162L163.32 137.349H162.562H162.057H161.973H161.636H160.458V137.307L160.5 137.18V137.054L160.542 136.969L160.584 136.843L160.542 136.801L160.626 136.718V136.633V136.591L160.542 136.549L160.5 136.591L160.458 136.549V136.507H160.5V136.422H160.458V136.338V136.296L160.5 136.254L160.458 136.212L160.415 136.002V135.918Z"
							fill="#195386" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="PE" @mouseenter="e => hoverES(e, 'PE')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M203.353 90.3681H203.479L203.648 90.283L203.689 90.2411L203.815 90.0735H204.026L204.111 90.0303L204.153 89.9884H204.237L204.321 89.9046L204.279 89.779V89.6939H204.321L204.362 89.652H204.448L204.489 89.6101L204.531 89.5682L204.573 89.5263L204.658 89.3574V89.2736H204.742L204.784 89.3155H204.826L204.91 89.2736L204.953 89.1885H204.995L205.037 89.1466L205.079 89.0209V88.8939L205.247 88.9371L205.289 88.7263L205.331 88.5994L205.542 88.5575L205.584 88.4318H205.626L205.71 88.3899L205.795 88.4737V88.5156L205.837 88.5575L205.962 88.6412L206.047 88.7263L206.131 88.6412L206.173 88.5575V88.4737V88.3899L206.215 88.3467H206.257V88.221H206.215L206.257 88.1372H206.384L206.426 88.1791L206.468 88.2629V88.3048H206.595L206.72 88.1791L206.678 88.0102L206.72 87.9683V87.9264L206.889 87.8845V87.7994H206.931V87.7575V87.7156L206.973 87.6737L206.931 87.5049L207.015 87.463L207.057 87.4211L207.184 87.3792L207.226 87.3373L207.268 87.2954H207.393V87.2522L207.436 87.1684L207.478 87.1265L207.52 87.0427H207.604L207.646 87.0008V86.9157L207.689 86.8738H207.773L207.815 86.8319V86.79L207.857 86.7481L208.067 86.8319V86.79L208.109 86.7481V86.663L208.067 86.6211L208.026 86.5373L208.067 86.3685L208.151 86.1577L208.193 86.032L208.404 85.6536V85.5685V85.5266L208.446 85.0213V84.9375L208.404 84.8118V84.7686L208.32 84.6848L208.278 84.6429H208.236L207.899 84.5159L207.731 84.474L207.604 84.3483L207.562 84.0957L207.646 83.843L207.773 83.5903V83.5484V83.4214V83.3376V83.2957L207.731 83.2538V83.2119L207.52 82.9593L207.478 82.9174L207.351 82.5796V82.4958L207.393 82.412L207.604 82.3701L207.689 82.3269L207.731 82.2431L208.362 81.9905L208.657 81.9486H209.162H209.457L209.793 81.8648L209.962 81.9486H210.046L210.088 81.9905L210.256 82.2431L210.846 82.1174L211.309 82.0323H211.646L211.729 81.9486L211.898 81.9905L212.024 81.9486L212.319 81.6121H212.362L212.445 81.654L212.656 81.5702L212.698 81.5283L212.824 81.5702H212.909H212.993H213.077L213.287 81.5283L213.582 81.4851H213.709L213.835 81.4432H213.876L213.96 81.5283L214.087 81.6121H214.213L214.255 81.654H214.298L214.382 81.781L214.466 81.8648L214.593 81.9486L214.76 82.0756H214.802L214.887 82.1593L214.929 82.2431L215.013 82.3269L215.182 82.3701H215.224L215.393 82.4539L215.476 82.4958H215.518L215.687 82.6228L215.771 82.7066L215.94 82.8742L216.024 82.9174V82.9593L216.065 83.1269L216.149 83.2538L216.192 83.2957H216.234L216.276 83.3376H216.234L216.149 83.4214L216.107 83.4646V83.5903L216.065 83.6322V83.7173H216.234L216.276 83.6741L216.318 83.7173V83.7592L216.444 83.8011V83.8849V83.9268L216.402 83.9687H216.487L216.529 83.9268H216.613L216.697 83.8849L216.823 83.9268L216.907 84.0538H217.076L217.16 84.0957L217.202 84.2214L217.329 84.3064V84.3902L217.371 84.474L217.413 84.6429V84.7267L217.455 84.8118L217.371 84.8956L217.413 84.9375L217.582 84.8118L217.665 84.6848L217.834 84.7267L217.876 84.6848H217.918L217.96 84.8118V84.8537L218.086 84.8956L218.129 84.8537H218.171H218.213V84.8118V84.7686L218.254 84.7267L218.296 84.6429L218.338 84.5591L218.296 84.474L218.338 84.3902V84.3483V84.3064H218.38L218.423 84.2646L218.465 84.3064H218.507V84.2214H218.591L218.633 84.2646L218.718 84.2214V84.0957L218.802 84.0119L218.886 84.0538H218.929H219.012H219.096L219.138 83.9268V83.843L219.054 83.8011L219.096 83.7173H219.138V83.7592H219.223H219.307L219.349 83.7173V83.6741L219.391 83.7173L219.475 83.6741H219.518H219.56L219.602 83.5903L219.644 83.5484L219.602 83.5065L219.685 83.4646H219.727V83.4214H219.812L219.854 83.5065H219.938L220.023 83.6741H220.065L220.149 83.7592V83.8011H220.191V83.843L220.318 83.8849V84.0119H220.36L220.402 84.0957V84.1795L220.485 84.2214V84.3064H220.569L220.612 84.2214V84.3064L220.654 84.2646L220.696 84.3064L220.822 84.2646L220.907 84.3064L220.991 84.2646H221.118V84.1795L221.16 84.1376H221.285L221.369 84.0538H221.496L221.538 84.1376H221.622H221.664L221.707 84.0538L221.664 84.0119L221.833 83.9687L221.874 83.9268V83.8849L221.916 83.843L221.96 83.8011L222.043 83.9268L222.085 83.8849L222.127 83.9268L222.169 83.8849L222.212 83.9268V84.0119V84.0538H222.254L222.212 84.1376L222.254 84.1795L222.296 84.2214L222.212 84.3483H222.338L222.296 84.3902L222.338 84.4321L222.296 84.5159L222.338 84.6848L222.422 84.7686L222.464 84.8118L222.549 84.7686H222.591H222.716V84.7267H222.801L222.843 84.6848L222.885 84.6429L222.969 84.601L223.096 84.5159L223.18 84.4321L223.264 84.474H223.305L223.349 84.5591L223.391 84.601L223.432 84.6429V84.6848L223.474 84.7267L223.727 84.7686L223.769 84.7267V84.6848L223.727 84.601V84.5159V84.4321L223.769 84.3902L223.938 84.2646L224.063 84.3064L224.149 84.3483V84.4321H224.19H224.232L224.274 84.3902L224.358 84.4321L224.4 84.3902L224.443 84.3483L224.527 84.3064V84.2214L224.653 84.1376V84.0119H224.738H224.821H224.863L224.821 83.9687L224.78 83.9268L224.821 83.8849L224.905 83.843L225.032 83.6741L225.074 83.6322L225.158 83.5903H225.369L225.453 83.4646H225.494H225.538L225.58 83.5065V83.5903H225.621V83.6741L225.705 83.7592V83.7173L225.789 83.6741V83.5903L225.747 83.5484L225.663 83.5065L225.705 83.4646V83.4214L225.747 83.3795L225.789 83.2957H225.832L225.874 83.1701H225.916L226 83.1269V83.0431V83.0012L226.169 82.9593V82.8742L226.294 82.7904L226.336 82.8742L226.379 82.8323L226.463 82.8742L226.547 82.8323L226.589 82.7904V82.7066L226.716 82.6647L226.842 82.5796L226.969 82.5377L227.094 82.4958V82.4539V82.3269L227.136 82.285L227.179 82.2431V82.2012L227.221 82.1593H227.263L227.305 82.0323L227.347 81.9905V81.9067L227.305 81.8229L227.347 81.781L227.474 81.7378L227.642 81.781L227.683 81.7378H227.727L227.81 81.781L227.852 81.7378H227.978L228.231 81.6121L228.189 81.5283L228.231 81.4432L228.316 81.3175H228.441H228.483H228.61L228.652 81.2324H228.778H228.821H228.947L229.072 81.3175L229.158 81.3594L229.283 81.4432L229.325 81.5283L229.367 81.6121H229.41H229.494L229.536 81.6959L229.578 81.654L229.62 81.6959L229.705 81.7378H229.831L229.916 81.781V81.8229L229.958 81.9067H230.041V81.8648H230.083L230.21 81.9486L230.294 82.0323L230.21 82.1593H230.294V82.2012L230.252 82.2431L230.294 82.3269L230.336 82.3701L230.42 82.412V82.4539V82.4958H230.462V82.5377L230.378 82.6228L230.336 82.5796L230.21 82.6228V82.6647L230.041 82.7066L229.958 82.7904H229.831L229.747 82.8742H229.62L229.536 83.0012L229.41 83.085L229.325 83.1701L229.283 83.2957L229.241 83.4214L229.158 83.4646V83.5065V83.5484V83.6322L229.241 83.7173L229.283 83.7592V83.8011L229.325 83.8849L229.367 83.9268L229.452 84.0119V84.1376L229.536 84.2214L229.41 84.3902V84.4321H229.452L229.41 84.5159H229.367L229.325 84.5591V84.601L229.283 84.5591L229.241 84.5159H229.199L229.158 84.5591L229.031 84.6429L228.989 84.601L228.947 84.6429L228.863 84.6848L228.905 84.7267H228.989V84.8537L228.863 84.8956L228.821 84.9375L228.863 84.9794V85.0632L228.61 85.2321H228.483V85.274H228.4V85.3159H228.441H228.483L228.441 85.3591L228.483 85.4009V85.4428H228.441L228.4 85.4847L228.274 85.5266H228.231V85.5685L228.189 85.6955H228.274V85.7374L228.4 85.6536H228.483H228.568L228.652 85.6955L228.736 85.6536H228.863L228.905 85.6955L228.947 85.6536V85.6955H229.031V85.6104L229.116 85.5685L229.199 85.6104V85.7374L229.241 85.7793H229.283V85.8212H229.367L229.41 85.8631L229.452 85.9063V85.9901V86.0739L229.41 86.2009V86.2847L229.494 86.4104L229.452 86.4954L229.494 86.6211V86.663H229.452L229.41 86.7481L229.452 86.8319L229.367 86.8738V86.9157L229.41 86.9576L229.494 87.0008L229.62 86.9576V87.0427V87.1265V87.2103L229.789 87.3792L229.831 87.5049L230.083 87.5467H230.125L230.252 87.7156L230.42 87.7994L230.505 87.7575H230.63H230.672L230.714 87.7156V87.6318L230.841 87.59L230.967 87.463L231.01 87.3792H231.136L231.261 87.2954L231.556 87.1684L231.599 87.0846H231.683H231.767L231.852 87.1265L231.894 87.0846L231.936 87.0008L231.978 86.9576H232.105V86.9157H232.147L232.105 86.8738V86.8319L232.188 86.8738H232.314L232.272 86.7481L232.314 86.7049L232.441 86.663L232.609 86.6211L232.694 86.5792V86.4954L232.651 86.4522H232.567V86.3685H232.525V86.3266L232.567 86.2847L232.694 86.2009V85.9482V85.7793L232.736 85.7374V85.6536L232.778 85.5266L232.946 85.5685L232.988 85.6104L233.03 85.5685L232.988 85.5266L233.03 85.4428L232.988 85.3159L233.03 85.274L233.072 85.2321L233.156 85.1902L233.241 85.2321L233.494 85.3591L233.577 85.3159L233.619 85.3591L233.703 85.3159H233.83V85.274L233.872 85.1902H233.914V85.1064L233.872 85.0632L233.914 85.0213V84.8118V84.7267L233.956 84.6848H234.041L234.125 84.6429H234.25L234.336 84.601L234.377 84.6429H234.714H234.756L234.798 84.6848L234.925 84.7686H234.967H235.05L235.092 84.6848V84.6429L235.008 84.601V84.5591L235.05 84.5159L235.261 84.3483L235.303 84.3902L235.345 84.5159L235.472 84.474H235.683H235.808H235.85L235.934 84.4321L236.145 84.474L236.272 84.601L236.314 84.5591H236.356L236.439 84.6429H236.566L236.608 84.6848L236.65 84.601H236.692L236.777 84.5159H236.861H236.945L236.987 84.474L237.197 84.5159L237.323 84.4321V84.3483V84.3064L237.366 84.2646H237.45L237.576 84.2214L237.661 84.2646H237.703H237.745L237.87 84.1795H237.955L238.081 84.0957H238.123L238.166 84.0538V84.0119H238.208L238.334 83.9687H238.376V83.9268L238.461 83.8849L238.503 83.9268H238.545H238.587H238.714H238.755L238.839 83.843L238.881 83.8011L238.965 83.7173V83.6741L239.008 83.6322H239.092H239.134H239.218L239.303 83.6741L239.47 83.6322L239.512 83.5903H239.597L239.47 83.4214L239.512 83.3376H239.555V83.2957L239.597 83.2119L239.512 83.2538L239.47 83.2119V83.1701L239.512 83.1269L239.555 83.0012V82.8742L239.597 82.8323L239.639 82.7904L239.681 82.7485L239.639 82.6647V82.5796L239.681 82.3701L239.808 82.3269L239.976 82.3701H240.059L240.103 82.4539L240.186 82.4958H240.228L240.27 82.412L240.439 82.3269L240.481 82.285H240.523H240.607V82.2431V82.1593H240.65H240.734V82.1174L240.692 82.0756H240.776H240.817H240.859H240.903L241.028 81.9486L241.281 81.8648L241.365 81.9067L241.534 81.9486L241.617 81.9905H241.659L241.744 81.9486L241.828 81.9905H241.87L241.997 82.0323H242.039L242.165 82.0756L242.248 82.0323L242.292 81.9905H242.333L242.375 82.0323L242.501 82.1174L242.586 82.2012L242.754 82.3269L242.881 82.412V82.4958L242.839 82.5796L242.881 82.6647V82.7066L242.965 82.7904L243.048 82.9174H243.092L243.217 82.8323L243.259 82.8742L243.301 82.9174H243.343H243.386V82.9593H243.428L243.47 82.8742L243.596 82.9593L243.681 82.9174L243.764 82.9593H243.806L243.848 83.0012H243.806H243.764L243.806 83.085L243.848 83.1701L243.89 83.2119V83.2957L243.975 83.3795V83.4646L243.89 83.5903L243.806 83.843H243.764L243.723 83.8849L243.764 83.9268H243.848L243.806 84.0119L243.848 84.0957L243.89 84.2214L243.806 84.5159V84.6429H243.723V84.6848L243.764 84.7686V84.8118V84.8537H243.806V85.0632L243.89 85.1483V85.274V85.3159L243.848 85.6104L243.806 85.7793V85.9063L243.637 86.0739V86.1158V86.1577L243.512 86.4522L243.343 86.9157L243.301 87.0427V87.1684L243.259 87.2954H243.301L243.175 87.5049L243.133 87.6318L243.092 87.7156V87.7575L243.175 87.7994L243.092 88.0102V88.0521H243.133L243.175 88.0953L243.133 88.1372H243.048L243.006 88.1791L243.092 88.2629L242.923 88.6412L242.881 88.8101L242.839 88.8939L242.796 88.979V89.0209V89.1047L242.754 89.1466V89.2317L242.796 89.3155L242.754 89.3574V89.4412V89.4844H242.712L242.67 89.4412L242.628 89.4844L242.586 89.5263L242.543 89.6101L242.501 89.652V89.7357V89.779L242.375 89.9884L242.333 90.0303L242.375 90.1573L242.292 90.1992L242.248 90.283L242.292 90.3681V90.41L242.248 90.4519L242.206 90.5357L242.248 90.6208L242.123 90.7884V90.8735H242.165L242.123 90.9572H242.081L241.954 91.1248V91.2518L241.997 91.3775V91.4207L241.912 91.4626L241.828 91.7153V91.6302L241.701 91.5464H241.534H241.492H241.407L241.323 91.5045L241.239 91.5464L241.07 91.4626H240.986H240.944L240.607 91.3775L240.312 91.2937L240.27 91.2099H240.228H240.186H240.103V91.2518H239.976L239.934 91.2099V91.168H239.892L239.934 91.0829H239.892H239.85H239.808V91.1248H239.723V91.168L239.681 91.1248V91.0829L239.639 91.1248V91.0829H239.555L239.47 91.168V91.0829L239.428 91.1248L239.386 91.168H239.303L239.261 91.2518H239.218H239.176L239.134 91.2937L239.092 91.3775H238.965L238.881 91.4626L238.839 91.5045H238.797H238.755H238.714L238.628 91.5883H238.503L238.461 91.6734L238.376 91.6302L238.334 91.6734H238.292H238.25L238.166 91.7153L238.081 91.6734L237.997 91.6302L237.955 91.5883H237.914L237.955 91.5464L237.914 91.5045L237.955 91.4207V91.3356V91.3775L237.914 91.2937H237.87L237.787 91.3775L237.703 91.3356L237.661 91.4207H237.576H237.534L237.45 91.3356L237.281 91.3775L237.239 91.3356L237.197 91.3775H237.156H237.114V91.4207L237.072 91.5045H237.029H236.945L236.903 91.5464L236.819 91.5883V91.6302H236.777H236.734H236.65L236.566 91.7153L236.398 91.6734L236.187 91.7153L236.061 91.8829L235.808 91.968L235.766 92.0517L235.808 92.1355L235.892 92.1774L235.934 92.2625L235.892 92.3044V92.3463L235.808 92.4301L235.725 92.472V92.5152H235.683H235.639H235.556H235.514H235.472L235.43 92.5571H235.387H235.345L235.303 92.6828L235.261 92.7247H235.219V92.8098L235.135 92.8936H235.05H234.925V92.9774L234.967 93.0192V93.0625V93.1462H235.05L235.092 93.1881V93.2719L235.177 93.3138V93.357L235.05 93.3989L235.008 93.357V93.3989H234.967V93.357H234.925L234.883 93.3138L234.798 93.357H234.756V93.3989L234.714 93.357L234.672 93.3989V93.357L234.63 93.3989L234.588 93.4408L234.545 93.5246L234.503 93.5665H234.461L234.377 93.5246V93.5665L234.419 93.6097L234.377 93.6516L234.336 93.6935L234.25 93.6516L234.167 93.6935H234.083L234.041 93.6516L233.998 93.7354L233.956 93.6935V93.6097H233.872V93.6516L233.788 93.6935V93.7354H233.745L233.703 93.7773L233.661 93.8192L233.619 93.7773H233.577L233.536 93.8624V93.9043L233.494 93.9462L233.45 93.9881L233.03 94.1137V94.2826H233.072V94.3245V94.3664H233.03L232.946 94.4083H232.903L232.819 94.4515V94.4083V94.3664H232.778V94.3245L232.736 94.3664V94.3245L232.694 94.3664L232.651 94.3245V94.2826H232.609L232.567 94.2407V94.2826L232.483 94.2407L232.356 94.0719L232.272 94.03L231.894 93.9881L231.641 94.1137H231.388L231.347 94.03L231.305 93.9881H231.178L231.136 94.03H231.178L231.052 94.0719H231.01L230.925 94.157L230.841 94.3245L230.883 94.3664V94.4083L230.757 94.4934V94.5772L230.799 94.6191V94.661H230.757L230.714 94.7042H230.672L230.547 94.5772L230.378 94.4934L230.252 94.2826H230.083L230.041 94.1988V94.2826L229.999 94.1988L230.041 94.0719L229.916 93.9043L229.872 93.8624L229.705 93.7773H229.663L229.578 93.9043L229.494 93.9462L229.367 94.03L229.325 93.9881V93.9462V93.8624L229.41 93.7773L229.158 93.6097L229.072 93.6516L228.947 93.7773V93.7354V93.6935V93.6516V93.5665H228.905L228.863 93.4827V93.4408V93.3989L228.778 93.3138L228.736 93.2719L228.652 93.1881L228.525 93.0192L228.441 92.9355V92.8936V92.8517H228.358L228.316 92.7679L227.894 92.599L227.81 92.5152L227.683 92.4301H227.6H227.474L227.305 92.2625L227.347 92.2193V92.0936V92.0517H227.221L227.136 92.0098H227.094L227.01 91.968L226.883 92.0936L226.758 92.0517L226.674 92.0936L226.589 92.1774L226.547 92.2625L226.589 92.3044L226.547 92.3463H226.379L226.294 92.3044L226.252 92.2625L226.294 92.2193V92.1774L226.127 92.2625V92.1774L226.042 92.2193V92.1774L226.085 92.1355L226.127 92.0936V92.0517V91.968L226.042 91.9247L226 91.841V91.7991L225.916 91.7153L225.874 91.6302L225.832 91.5883V91.5464H225.789L225.747 91.5045V91.4207L225.663 91.3356L225.621 91.3775H225.58H225.538L225.411 91.5045H225.369L225.243 91.5883L225.285 91.6302V91.7153L225.2 91.7991L225.243 91.841L225.2 92.0936L225.158 92.1355L225.116 92.2193L225.032 92.3044L224.947 92.3463V92.3882L224.905 92.5152L224.863 92.472L224.78 92.5152L224.738 92.599L224.569 92.7679L224.527 92.8517L224.485 92.8936L224.443 92.9355V92.9774L224.358 93.0625L224.316 93.1881L224.232 93.23H224.19H224.105H224.022L223.98 93.3138H223.896H223.853L223.769 93.357H223.685H223.601L223.558 93.3989L223.432 93.5246L223.305 93.6516L223.222 93.8192V93.8624V93.9462L223.054 94.1137L222.927 94.157L222.716 94.3664L222.632 94.1137L222.422 93.6516L222.464 93.5665L222.38 93.357L222.296 93.23L222.254 93.1881L222.212 93.1462L222.169 92.9774L222.296 92.8517H222.212L222.169 92.7679L222.212 92.6828L222.338 92.599L222.38 92.5571V92.5152L222.338 92.3882L222.212 92.2625V92.1774H222.085L222.001 92.2193H221.96L221.791 92.3882L221.664 92.5152L221.538 92.472L221.454 92.4301L221.369 92.3882L221.201 92.2625L221.075 92.1355L220.991 92.0098L220.949 91.9247V91.8829L220.991 91.841V91.7991L221.033 91.7572L221.201 91.6302L221.243 91.5464L221.285 91.3775L221.201 91.2937L221.033 91.168L220.78 91.1248L220.654 91.168L220.443 91.5045L220.402 91.5883V91.968L220.318 92.1355H220.275L220.191 92.1774L220.023 92.0936L219.938 91.9247L219.896 91.841V91.7153L219.854 91.5045L219.812 91.3775L219.727 91.2937L219.602 91.2518L219.433 91.0829L219.265 90.9572L219.223 90.9153H219.18L218.886 90.8735H218.802L218.718 90.9153L218.465 90.9572L218.338 90.9991H218.296H218.254L218.213 90.9572L218.129 90.9153L218.044 90.7465L217.876 90.6627L217.791 90.5789H217.749L217.582 90.5357L217.413 90.4938L217.202 90.4519L217.034 90.41V90.3681L216.949 90.283L216.907 90.3262L216.865 90.3681L216.74 90.41L216.613 90.3681V90.41H216.571L216.529 90.3681L216.487 90.3262L216.444 90.2411V90.1992V89.9884L216.487 89.9465L216.444 89.8627L216.402 89.8208L216.318 89.779L216.276 89.652V89.6101V89.5682L216.234 89.4844L216.192 89.4412H216.107H215.94H215.855L215.771 89.3574L215.729 89.3155L215.687 89.2736H215.645H215.602L215.434 89.3155H215.393L215.349 89.4412H215.266H215.182L215.14 89.4844V89.5682L215.013 89.652L214.76 89.7357L214.718 89.779L214.551 89.8208L214.508 89.8627L214.466 89.9046V89.9465L214.213 90.0303H214.087L213.96 90.0735H213.876H213.709L213.666 90.1992L213.751 90.3681L213.793 90.5789V90.6208V90.7046L213.835 90.8302L213.793 90.8735L213.751 90.9153L213.709 90.9572H213.624L213.329 90.9153L213.077 91.0829H212.993L212.909 91.041L212.571 91.1248L212.445 91.168L212.404 91.2099V91.2937V91.3356V91.3775L212.529 91.6302L212.571 91.7991L212.445 92.0517L212.362 92.0936L212.319 92.2193L212.277 92.2625L212.024 92.5571L211.898 92.599L211.814 92.6409H211.771H211.562H211.393L211.309 92.7247L211.224 92.8098L210.973 92.9355H210.846H210.762L210.72 92.8517L210.593 92.7679L210.467 92.6409H210.425L210.382 92.599H210.34H210.256L210.215 92.6409L210.088 92.7679L210.004 93.0192L209.962 93.23L210.004 93.3989L209.962 93.5246L209.878 93.9881L209.793 94.0719L209.709 94.3245V94.3664V94.4934L209.54 94.661H209.498L209.373 94.6191L209.246 94.4934H209.162L209.078 94.5772L208.951 94.8299L208.867 94.9556L208.826 94.9137L208.699 94.8718H208.657H208.615L208.488 94.9137L208.446 94.9556L208.404 95.1245H208.362L208.278 95.2082L208.236 95.2515H208.193H208.109L207.899 95.3352L207.731 95.2933L207.562 95.2515L207.351 95.1245L207.309 95.0826H207.142L206.973 95.1664L207.015 95.0826L207.057 94.9988V94.8718L207.142 94.8299H207.184V94.788V94.7042L207.142 94.6191L207.226 94.5353L207.184 94.4515L207.226 94.4083L207.099 94.2407L207.142 94.1988H207.184V94.157L207.309 94.1988L207.393 94.157V94.1137V94.0719L207.52 94.03L207.562 93.9881V93.9043H207.52V93.8192L207.478 93.7354L207.562 93.6097V93.5665L207.604 93.4827V93.4408V93.357L207.646 93.2719L207.562 93.23L207.52 93.1462H207.393H207.351L207.226 93.0625L207.142 93.0192H207.099V92.9355H207.057L206.973 92.8936L206.889 92.9355V92.8936H206.804L206.762 92.8098L206.678 92.7679L206.72 92.6828L206.678 92.6409V92.5152L206.637 92.472V92.4301V92.3882L206.595 92.3044L206.551 92.2193L206.51 92.1355V91.9247H206.426V91.7572L206.299 91.7153V91.6302L206.215 91.5464V91.4207V91.3775H206.173L206.089 91.2937V91.2099L205.92 91.2518H205.837V91.168L205.71 91.1248L205.626 91.168H205.584L205.457 91.2518L205.373 91.2099L205.415 91.041L205.373 90.8735H205.331H205.247H205.162H205.12L205.079 90.9153V90.8735H204.953L204.91 90.7884L204.868 90.7465V90.7046L204.826 90.6627L204.784 90.5789V90.5357L204.826 90.4938V90.4519L204.868 90.3681L204.573 90.41L204.531 90.3681L204.489 90.41L204.448 90.3681L204.406 90.41L204.362 90.3681L204.321 90.41L204.195 90.3681H204.153L204.111 90.41V90.4519H203.984L203.9 90.5357L203.815 90.5789H203.773L203.648 90.4938H203.521L203.353 90.3681Z"
							fill="#3482cc" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="MA" @mouseenter="e => hoverES(e, 'MA')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M157.511 68.8997L158.731 67.889L159.32 67.4674L159.363 67.3836L159.489 67.2998L159.447 67.2147L159.489 67.1728H159.531L159.573 67.2147L159.7 67.1309L160.878 66.2053L160.962 66.1202L161.678 65.5311L161.805 65.4473L162.015 65.2784L162.52 64.8581L163.32 64.2271L163.404 64.1001L163.489 64.0163L163.614 64.0582H163.698L163.741 64.142L163.783 64.1001L163.867 64.142H163.951H164.036L164.162 64.1839L164.331 64.0582L164.414 63.9325L164.498 63.8893L164.583 63.8474L164.625 63.8055L164.793 63.5947L164.878 63.3421L165.087 63.1326L165.172 63.0056L165.256 62.8799V62.7948L165.34 62.711V62.6272L165.425 62.5421H165.383L165.425 62.4583V62.3746L165.467 62.3327L165.425 62.2908L165.593 62.2057L165.635 62.1219H165.678H165.72V62.0381L165.803 62.08L165.845 61.9949H165.887L165.972 61.8692H166.014H166.056L166.014 61.7003H166.056V61.6584L166.098 61.6165V61.5327L166.14 61.4908L166.098 61.4476L166.182 61.4057L166.225 61.4476L166.267 61.4057V61.3638L166.225 61.2801L166.267 61.2382L166.225 61.1963V61.1112L166.182 61.0274L166.225 60.9855V60.9436L166.309 60.8585V60.8166V60.7328H166.351V60.649L166.393 60.6058H166.478L166.434 60.649H166.478V60.6058H166.561V60.5639H166.603V60.522L166.645 60.4801H166.729V60.4382L166.856 60.3531L166.898 60.2693H166.982H167.025L167.067 60.1856H167.109L167.151 60.1018L167.192 60.1437V60.0586H167.234V60.0167V59.9329H167.276L167.319 59.891V59.764L167.403 59.7221L167.487 59.6383L167.529 59.6802V59.6383V59.5113H167.571H167.614H167.656H167.698L167.74 59.3856L167.824 59.3437L167.867 59.2586L167.824 59.1748L167.909 59.1329V59.0911V59.0073L167.992 58.9641V58.9222V58.8384V58.7546L168.034 58.6695V58.5857L167.992 58.5438L168.076 58.5019V58.4168L168.034 58.2492L168.161 58.1641L168.119 58.1222L168.076 58.1641V58.1222V58.0803L168.034 58.0384H168.076L168.119 57.9966L168.076 57.9547H168.119H168.076L168.119 57.9128L168.076 57.8696L168.119 57.8277L168.161 57.7439H168.203L168.161 57.6601L168.203 57.6182L168.161 57.575V57.5331V57.4912H168.203H168.245V57.4074L168.329 57.3655V57.3223H168.414L168.456 57.2804L168.54 57.2385L168.498 57.1966H168.582L168.498 57.0696V57.0277H168.582V57.0696H168.623L168.582 56.9021L168.709 56.9439V56.8602H168.665V56.8183H168.709L168.665 56.7751H168.75L168.709 56.6913H168.665V56.6075H168.709V56.5656V56.6075L168.75 56.5656L168.709 56.4805V56.4386V56.3967H168.75V56.271L168.792 56.3129L168.834 56.271L168.876 56.2278H168.834H168.876L168.918 56.1859L168.961 56.2278V56.1859H169.003V56.144H168.961L169.045 56.0602L169.087 56.0183L169.129 56.0602V56.1021L169.213 56.0602V56.0183L169.171 55.9751H169.213L169.256 56.0602H169.298V56.0183V55.9332L169.381 55.9751L169.423 55.8913H169.465H169.55V55.8076L169.465 55.7657L169.55 55.6806L169.465 55.5968H169.508H169.55H169.592V55.4292L169.634 55.386L169.676 55.4292H169.718L169.76 55.3441L169.718 55.3022L169.76 55.2603H169.845L169.887 55.3022V55.2603V55.2184L169.803 55.1765L169.887 55.1333V55.0914L169.76 55.0076H169.845L169.929 55.0914L169.971 55.0495L169.929 54.9238H170.013H170.056L170.098 54.8387L170.056 54.7968V54.7131L169.971 54.7549L169.929 54.6712H169.971H170.013H170.056L170.098 54.5861H170.14V54.7131H170.181L170.223 54.6712L170.181 54.5023L170.307 54.4604L170.35 54.5023V54.3766L170.392 54.3347L170.35 54.2496V54.1239L170.434 54.082L170.392 54.0401L170.476 53.955L170.392 53.9131V53.8712L170.434 53.8293L170.518 53.8712L170.56 53.7874L170.518 53.7442H170.476V53.7023H170.56V53.6604L170.518 53.6186H170.434V53.5348V53.4916L170.518 53.4497V53.4078L170.476 53.3659L170.434 53.2821H170.476L170.392 53.197H170.35V53.1551L170.434 53.1132H170.518L170.56 53.1551L170.603 53.1132L170.645 53.0713H170.603V53.0294L170.645 52.9875L170.603 52.9456H170.645L170.729 52.9875L170.812 52.9456L170.771 52.9024V52.8605H170.729L170.771 52.8186H170.854L170.939 52.9024L170.981 52.8605H171.023L170.939 52.8186H170.981V52.7767L170.898 52.8186V52.7767H170.939L170.898 52.7348H170.854V52.6929V52.5659V52.524H170.812V52.5659L170.771 52.6078L170.687 52.6497L170.645 52.5659V52.4822V52.3971V52.3133H170.603L170.56 52.3552L170.518 52.2295V52.1876V52.1457L170.434 52.1876V52.1457L170.392 52.0606L170.476 51.9349L170.56 51.893V51.8511L170.645 51.893V51.8511V51.8079L170.729 51.766V51.7241V51.6403L170.771 51.5984H170.812L170.898 51.766L170.939 51.7241V51.5552L171.023 51.5133H171.065H171.149L171.234 51.4714L171.445 51.4295L171.402 51.2607L171.487 51.2188H171.529L171.57 51.135L171.529 51.0931L171.487 51.0512V50.9661L171.529 50.9242H171.57L171.612 50.9661H171.697L171.992 50.8823V50.8404L171.907 50.7985L171.865 50.7566L171.907 50.6715L171.865 50.5877V50.5039L171.907 50.4188H171.865V50.3769V50.2513V50.1243L171.949 50.0405L171.992 49.9567L172.034 49.8716V49.8297L171.949 49.7878L171.823 49.9567H171.781L171.697 49.9135V49.8716V49.7878L171.865 49.6621L171.907 49.6189V49.5351V49.4094L171.949 49.3662L171.992 49.1568L171.907 49.0717V49.0298L172.034 48.9879L172.076 49.0717L172.16 49.1149L172.243 49.0717L172.287 48.946H172.37L172.454 48.9041V48.8622L172.539 48.6933L172.623 48.6095L172.749 48.5676L172.834 48.4825L172.749 48.4406V48.3987L172.876 48.2717L172.918 48.2298V48.1042L172.876 48.0204V47.8934L172.918 47.8096L172.96 47.7677L173.043 47.6407V47.515L173.128 47.3042L173.212 46.9259L173.17 46.757H173.087V46.7151L173.296 46.4205L173.254 46.3354L173.212 46.2935L173.17 46.2097L172.96 46.1678L172.834 46.2097H172.792L172.749 46.1678L172.665 46.2516L172.623 46.2097L172.581 45.9989L172.623 45.8314L172.665 45.7882L172.707 45.7463H172.792H172.96L173.087 45.7044L173.17 45.7463H173.212H173.254L173.296 45.7044V45.6625L173.338 45.6206H173.381L173.507 45.5787L173.591 45.4936L173.634 45.4098V45.326L173.591 45.2841V45.2409V45.1152L173.676 44.9882V44.9463L173.634 44.9044V44.8625L173.759 44.8207L173.676 44.4423V44.3572L173.591 44.2734L173.549 44.2315L173.465 44.1464L173.718 43.9369V43.8937L173.591 43.8099L173.759 43.6843L173.801 43.5154L173.843 43.4735L173.886 43.3478L173.928 43.2627V43.2208L173.759 43.2627V43.2208V43.0951H173.634L173.549 42.8843L173.718 42.7154L173.634 42.5479L173.759 42.4209L173.886 42.379H173.928V42.4209L174.096 42.379V42.1263L174.138 42.0844V42.1682L174.181 42.1263V42.0425L174.223 41.9587H174.265V42.0006V42.0844L174.349 42.2101V42.1682L174.307 42.0844V41.9587V41.8736L174.349 41.7898H174.391L174.476 41.6209V41.6628V41.579V41.5371H174.518L174.559 41.579V41.6628H174.601V41.4953V41.4534L174.643 41.4953V41.4102H174.812V41.4953H174.728V41.5371L174.77 41.4953L174.812 41.5371V41.6209H174.854V41.6628L174.77 41.706V41.6628H174.685H174.643H174.77V41.7898H174.728L174.685 41.8736L174.728 41.8317L174.812 41.7898H174.854V41.7479V41.7898V41.9155V41.9587H174.728L174.643 42.0006L174.685 42.0425L174.643 42.0844L174.601 42.1263L174.685 42.0844V42.1263V42.1682L174.728 42.1263L174.685 42.0844L174.728 42.0006H174.812V42.0425L174.854 42.0006H174.938L174.896 42.0844V42.1263H174.938L174.896 42.2101V42.3371L174.854 42.379L174.896 42.4209L174.854 42.5898L174.896 42.6317L174.938 42.5898L174.981 42.379V42.3371L175.149 42.0006L175.19 42.0425L175.149 42.0006L175.232 41.8317H175.276V41.7898L175.359 41.7479H175.317H175.276V41.706L175.401 41.579H175.443L175.401 41.5371L175.359 41.4953L175.401 41.4534L175.527 41.4102H175.485H175.527H175.57H175.527L175.57 41.4534L175.612 41.6628L175.57 41.7479V41.706V41.7479L175.485 41.8317V41.8736V41.9155L175.317 41.9587V42.0006L175.149 42.1682V42.2101L175.107 42.2533H175.149H175.19L175.149 42.3371H175.107V42.379L175.19 42.3371V42.2101L175.276 42.0844L175.359 42.0425H175.401L175.443 42.0844V42.1263L175.401 42.1682H175.359L175.317 42.2101H175.359V42.2533H175.276V42.2952L175.359 42.2533L175.401 42.2101L175.443 42.1682V42.2101L175.359 42.3371L175.443 42.2952L175.401 42.379L175.359 42.4209L175.317 42.4628L175.232 42.5479H175.149L175.232 42.5898V42.6317H175.149H175.107H175.149H175.19L175.149 42.7154L175.19 42.7573V42.7154V42.6735L175.232 42.6317V42.5898L175.276 42.5479H175.401L175.527 42.4628V42.5047L175.401 42.5898V42.6735L175.443 42.6317L175.527 42.5047V42.5898L175.317 42.7573V42.7992H175.485L175.443 42.8424L175.401 42.8843L175.443 42.9262V42.8424L175.485 42.7992L175.57 42.5898L175.612 42.379V42.3371L175.696 42.4209L175.738 42.5047L175.696 42.6317L175.654 42.7154L175.738 42.5047L175.654 42.2533L175.738 42.1682L175.823 42.1263L175.865 42.1682V42.2101L175.907 42.1682L175.865 42.2533L175.823 42.2952L175.78 42.4209V42.4628L175.865 42.5479L175.725 42.7573H175.738V42.7901L175.78 42.7573V42.7154H175.823H175.865L175.823 42.6735L175.865 42.5898L175.907 42.6317L175.865 42.7154H175.907L175.948 42.7992L175.823 42.8843L175.738 42.8424V42.8843L175.78 42.8424L175.865 42.8843L175.948 42.8424V42.8843L175.99 42.8424H175.948L175.907 42.6735L175.99 42.5047L176.032 42.3371V42.2952H176.074V42.3371V42.379L176.159 42.2101V42.1263H176.201V42.0844L176.243 42.0425L176.285 42.0006L176.201 41.9587L176.37 41.9155H176.496L176.538 41.9587L176.58 42.0006V42.0425H176.538L176.496 42.1263V42.0844V42.1263H176.454V42.1682L176.37 42.2533L176.327 42.3371L176.285 42.379V42.4628H176.243L176.285 42.5479L176.201 42.6317H176.159H176.201L176.243 42.5898H176.327L176.37 42.7154L176.454 42.8424V42.9262L176.412 43.01L176.454 43.0951H176.327L176.285 43.1789L176.243 43.3046L176.285 43.3478V43.3046L176.327 43.2208V43.137H176.37H176.412L176.454 43.0951L176.496 43.137V43.2627L176.58 43.3046L176.412 43.3897L176.37 43.4316H176.327V43.5154H176.243L176.201 43.5573L176.117 43.4735H176.159L176.117 43.5154H176.159L176.201 43.5573L176.243 43.5154H176.327L176.37 43.4735L176.454 43.3897L176.58 43.3478L176.621 43.3046L176.58 43.2627L176.538 43.2208V43.1789L176.58 43.137L176.621 43.0951L176.58 43.01V43.0951L176.538 43.137V43.0951L176.496 43.0519V42.9681L176.538 43.01H176.58L176.538 42.9681V42.8424L176.707 42.7154L176.748 42.8424V42.7992L176.832 42.6735H176.79V42.7154H176.748V42.6735H176.79H176.832V42.4209V42.2533L176.874 42.1263V42.0425L176.917 41.9587L176.959 42.0006V41.9587V41.9155H176.874L176.917 41.8736L176.959 41.8317L177.001 41.9155H177.043V42.0006V42.1682V42.2101L177.001 42.2533V42.2101L176.917 42.3371L176.874 42.5047V42.5898H176.917V42.6317V42.7154V42.7573L176.832 42.8424V42.9681V43.01V43.0519V43.0951V43.137L176.79 43.0951L176.832 43.2208H176.874V43.137V43.0951V43.137L176.917 43.1789L176.874 43.2627V43.3478L176.79 43.3897L176.832 43.4316H176.79H176.748H176.707H176.748V43.3949L176.454 43.4316V43.3897L176.412 43.5992L176.327 43.6843L176.285 43.768L176.327 43.6843L176.412 43.6424L176.454 43.5992L176.496 43.6424H176.538L176.454 43.5573V43.5154L176.496 43.4735H176.621L176.58 43.5154L176.665 43.4735H176.832L176.874 43.4316L176.959 43.3046V43.2208V43.1789L176.917 43.0951L176.959 42.8843L177.001 42.8424L177.127 42.7992V42.8424V42.7992L177.169 42.7573L177.212 42.7992L177.169 42.8424L177.212 42.8843L177.127 43.01H177.085L177.043 43.0519H177.001H177.043L177.085 43.01H177.127V43.2208L177.085 43.2627H177.043L177.001 43.3046H177.043V43.2627L177.085 43.3046L177.127 43.2208L177.169 43.2627V43.3046L177.212 43.3478L177.169 43.3046V43.2627L177.127 43.2208L177.169 43.1789L177.127 43.0951L177.169 43.01L177.254 42.8843L177.338 42.8424V42.8843L177.296 42.9262L177.465 42.7992H177.506L177.465 42.9681L177.379 42.9262L177.338 42.9681H177.379L177.421 43.01V43.0519L177.338 43.0951V43.137L177.296 43.2208H177.212V43.2627L177.254 43.2208H177.338L177.379 43.0951L177.465 43.0519V43.0951V43.137H177.506L177.465 43.1789L177.421 43.2208L177.379 43.1789L177.296 43.2208V43.3046L177.338 43.3478L177.296 43.3897L177.254 43.5154L177.296 43.4316L177.379 43.3478L177.338 43.2627V43.2208H177.379L177.421 43.2627H177.465L177.548 43.1789V43.0951L177.59 43.01L177.674 42.9681L177.632 43.0519V43.0951V43.137L177.59 43.2208L177.548 43.3046L177.506 43.3478L177.548 43.3046L177.59 43.2627V43.3478L177.548 43.3897V43.4316L177.421 43.4735H177.548L177.59 43.3897V43.4316L177.632 43.5154L177.506 43.6843L177.548 43.7262V43.6843L177.59 43.6424H177.632L177.716 43.5992H177.674L177.759 43.4316L177.801 43.3897V43.4316L177.885 43.3478V43.3046L177.843 43.3478L177.759 43.3897V43.3478L177.843 43.2627L177.885 43.3046V43.1789V43.137H177.969H178.012V43.0951H178.054V43.0519H178.012L178.054 43.01L178.221 42.9681L178.306 43.0951L178.263 43.2208L178.221 43.3046L178.179 43.3478L178.096 43.2208L178.137 43.3046V43.3478H178.096V43.3897L178.012 43.4316V43.3478V43.4316H177.969L177.885 43.4735V43.5992L177.801 43.768L177.843 43.8099V43.8937H177.801L177.759 43.8518L177.843 43.9788V44.0207L177.759 44.1464H177.843L177.885 44.2315L177.843 44.3153L177.885 44.2734H177.969V44.3991L177.927 44.4842L177.843 44.4423L177.801 44.5261L177.759 44.4842L177.801 44.5261V44.568V44.5261L177.843 44.4842L178.012 44.568V44.5261H177.969L178.012 44.4423V44.3153L177.927 44.1896V44.1464L178.012 44.0626V43.9788L178.137 43.8099H178.179V43.768L178.221 43.8099L178.179 43.8937V44.0207L178.137 44.0626L178.179 44.1045L178.221 44.1896L178.263 44.2315L178.137 44.0626L178.221 44.0207V43.9369L178.263 43.8937L178.306 43.9369V43.9788H178.263V44.0207L178.306 44.0626L178.263 44.0207V43.9788L178.306 44.0207L178.348 43.9788L178.263 43.8937L178.306 43.8099L178.348 43.768L178.39 43.8099H178.432L178.474 43.8518V43.8937L178.516 43.8518H178.558L178.516 43.8099H178.39L178.348 43.7262L178.432 43.6424L178.516 43.5992V43.5573L178.601 43.5992H178.558V43.6843V43.5992H178.643L178.601 43.5573L178.516 43.5154H178.474L178.516 43.5992H178.474V43.5154V43.4735V43.4316L178.558 43.3897L178.601 43.3046L178.685 43.3478H178.601V43.3897L178.685 43.3478L178.727 43.4316L178.685 43.3897L178.727 43.3478L178.685 43.3897L178.727 43.3478L178.685 43.3046V43.2627L178.558 43.1789V43.137L178.643 43.0951L178.81 43.137L178.854 43.2208V43.2627V43.3046L178.896 43.2627V43.3046V43.4316V43.4735V43.5573V43.6424V43.4735H178.937L178.979 43.8099H178.937H178.896V43.8518L178.854 43.8937V43.9369H178.769L178.601 44.0207L178.432 44.1045V44.1464L178.39 44.1896V44.2734L178.432 44.3991H178.474H178.432L178.39 44.1896H178.432L178.516 44.1045H178.601H178.643V44.2315L178.558 44.2734V44.3572L178.516 44.4423V44.4842L178.474 44.568V44.6099L178.432 44.568L178.39 44.5261L178.348 44.568V44.7369H178.306V44.7788L178.348 44.7369L178.39 44.568H178.432L178.474 44.6099L178.516 44.568V44.5261V44.4423L178.601 44.3572V44.3153L178.643 44.2315L178.685 44.1464L178.727 44.1896L178.769 44.2315L178.727 44.3153H178.685L178.769 44.3572V44.3991V44.3572V44.1464L178.854 44.1896L178.937 44.2734L178.854 44.3991V44.4842L178.81 44.568V44.6518L178.769 44.6937L178.685 44.8625V44.9044L178.643 44.9463L178.685 45.0733V45.1152L178.601 45.0314L178.558 45.0733H178.516L178.558 45.1152L178.601 45.0314L178.685 45.1152L178.558 45.3679V45.4098H178.474L178.432 45.4517H178.348V45.5368H178.306L178.263 45.6206L178.306 45.5368H178.348L178.39 45.4517L178.432 45.4936L178.474 45.4517L178.516 45.4098L178.432 45.5368L178.474 45.5787L178.39 45.6625L178.474 45.5787V45.4936L178.516 45.4517H178.558L178.516 45.6625L178.558 45.7463L178.601 45.8314V45.7882H178.685V45.6625V45.4936L178.727 45.4517L178.81 45.199V44.9882L178.854 44.9463L178.979 44.9044L179.063 45.0314V45.0733L179.106 45.0314L179.148 45.1152L179.232 45.0733V45.0314L179.19 44.9044L179.232 44.8625V44.8207V44.7788L179.316 44.6518V44.6099L179.485 44.4842L179.568 44.3991H179.61L179.652 44.4423L179.695 44.3572H179.737L179.695 44.2734L179.737 44.2315H179.779V44.1896L179.821 44.1045V44.0626H179.863V44.1045L179.905 44.0626H179.948V44.1045V44.1464H179.905L179.948 44.1896V44.2315V44.2734V44.2315V44.1896L179.905 44.2315L179.948 44.3153L179.99 44.3572L179.863 44.4423H179.905L179.99 44.3572V44.4842V44.568L180.032 44.6099H180.074H180.116L180.074 44.568L180.032 44.6099L179.99 44.568V44.4842L180.032 44.3991L179.99 44.2734V44.1464V44.0626L180.032 44.0207V43.9369L180.074 43.8937L180.116 43.768L180.158 43.7262L180.116 43.6424V43.6843V43.6424V43.6411L180.074 43.5992H180.095L180.074 43.5573L180.116 43.4735V43.4316H180.158L180.199 43.4735L180.158 43.5573L180.199 43.5992L180.158 43.6424L180.116 43.8518L180.199 44.0207L180.158 44.1045L180.116 44.1896V44.2315V44.2734H180.158H180.199V44.3153L180.158 44.3991H180.199V44.3153H180.243H180.199V44.2734L180.158 44.2315V44.1896L180.199 44.1464L180.285 44.1896L180.326 44.1464L180.199 44.1045L180.243 43.9788L180.326 44.0626V44.1045V44.1464L180.285 44.1896L180.199 44.2315L180.285 44.1896V44.2315L180.368 44.1464V44.0207L180.285 43.9369L180.243 43.8937V43.8518V43.8099L180.285 43.768V43.9369L180.326 43.8099L180.368 43.8518L180.41 43.9369L180.368 43.8937L180.326 43.9369H180.368L180.326 43.9788V44.0207L180.368 43.9788V44.0207V44.2315V44.3153L180.285 44.4423L180.368 44.3572L180.41 44.2315L180.368 44.1896L180.452 44.1464L180.537 44.2315V44.3153V44.2315H180.663L180.705 44.1896H180.747L180.79 44.2315L180.874 44.3153H180.958L180.999 44.3991H181.043L180.999 44.3153V44.2734L181.043 44.1896L181.126 44.1464L181.168 44.2315H181.085V44.2734V44.3572L181.126 44.3991L181.085 44.3153L181.126 44.2734L181.168 44.3572H181.252H181.168L181.126 44.2734L181.379 44.2315H181.337H181.252V44.1896L181.294 44.1464L181.421 43.9788L181.505 43.9369L181.59 44.0207L181.547 43.8937L181.632 43.9788L181.59 43.8937V43.8518H181.674H181.632L181.59 43.8099L181.674 43.768L181.757 43.8099V43.768H181.716H181.841H181.799H181.884H181.926L181.968 43.8518L181.884 43.8937V43.8518L181.799 43.9788L181.841 44.2315L181.757 44.1896V44.0207L181.716 44.1045V44.2315L181.59 44.1896H181.463H181.547L181.674 44.2734H181.716H181.674H181.59H181.547L181.632 44.3153L181.59 44.3572L181.547 44.3991L181.463 44.4423H181.547L181.505 44.5261V44.568L181.421 44.6099H181.337L181.379 44.6937L181.337 44.7788L181.379 44.8625V44.9882L181.421 45.0314V44.9882H181.505L181.59 44.9463L181.674 45.0314L181.716 45.1152V45.0733L181.841 44.9044V44.7788H181.884L182.01 44.9044V44.9882L182.052 45.0733L182.01 45.1152H182.052L182.094 45.0733L182.01 44.9463H182.052L182.179 45.1152L182.136 45.199L182.01 45.326L182.136 45.2841L182.179 45.1571V45.0733L182.136 45.0314L182.094 44.8625V44.8207H182.179L182.136 44.7788H182.179V44.8207L182.221 44.7788L182.263 44.6937V44.8625L182.221 45.0314H182.263V45.1152L182.305 45.0733L182.347 45.0314L182.221 44.9882L182.305 44.9463L182.388 45.0314L182.347 44.9044V44.8625L182.515 44.7369L182.557 44.6937H182.599L182.641 44.7369V44.6937V44.6518V44.8207L182.515 44.9463V45.0314V45.0733H182.432H182.515L182.557 44.9882L182.641 44.9044V44.8625H182.684V44.8207V44.8625V44.9044H182.641L182.684 44.9463L182.726 44.7788L182.768 44.6937L182.81 44.7369L182.852 44.8207V44.8625L182.894 44.9044L182.936 45.0314L182.979 45.1152V45.2409L182.894 45.3679L182.852 45.326L182.81 45.2409L182.768 45.2841L182.726 45.2409V45.2841H182.641V45.199L182.599 45.2841H182.388L182.347 45.2409H182.305H182.347L182.388 45.326L182.305 45.4517H182.263L182.221 45.4936L182.136 45.4098L182.052 45.4936L182.136 45.4098V45.4936H182.179V45.5368H182.136L182.052 45.6206H182.01V45.6625H182.094L182.136 45.7044H182.094H182.136L182.179 45.7463L182.305 45.7882L182.221 45.8733H182.094V45.9152L182.136 45.8733L182.221 45.9152L182.305 45.8733V45.7882V45.7463H182.221L182.179 45.7044V45.6625H182.305L182.347 45.7044L182.432 45.7463H182.557L182.599 45.7044H182.641V45.8314H182.599L182.557 45.9152H182.515H182.474H182.432H182.474L182.515 45.957L182.347 46.0827L182.305 46.1259L182.136 46.1678H182.094L182.052 46.2516H182.01H181.968H181.926L181.968 46.2935L182.01 46.2516V46.2935H181.926L181.884 46.3786H181.799L181.716 46.4205L181.884 46.3786L181.926 46.3354H182.01L182.094 46.2097H182.221L182.515 46.1259V46.1678L182.474 46.2516L182.388 46.2935H182.305L182.263 46.3354L182.347 46.2935H182.388L182.557 46.1678V46.2516H182.641H182.557L182.599 46.1678L182.641 46.0408H182.726L182.852 45.9989L182.894 45.8733L182.936 45.9152V45.9989L182.894 46.0408L182.852 46.2097H182.81H182.726V46.2516H182.684V46.3786L182.768 46.2097L182.81 46.2516L182.852 46.2097L182.894 46.0827L182.979 45.9989V46.0408L182.936 46.1259L182.979 46.1678L182.936 46.1259L182.979 45.9989L182.936 45.9152V45.8733H182.979V45.8314H183.021L182.936 45.7882V45.7044L183.021 45.7463H183.147L183.315 45.8733L183.274 45.9152L183.23 45.8733L183.063 46.1259L183.021 46.2097L183.105 46.3786L183.063 46.4205L183.147 46.3786L183.188 46.3354H183.147V46.2097V46.1678L183.315 46.0408L183.399 46.0827V46.1259L183.23 46.2097L183.274 46.2935L183.23 46.3354H183.188L183.274 46.4624V46.5043V46.5462L183.357 46.6313L183.441 46.5881L183.526 46.5043L183.568 46.4205L183.61 46.3786L183.694 46.4624V46.5462L183.568 46.6732L183.441 46.757H183.399L183.315 46.8408H183.274L183.23 46.8827L183.274 46.8408L183.315 46.8827L183.357 46.8408H183.399H183.441V46.8827V46.9259V46.9678L183.483 47.0097V46.9678L183.441 46.8827L183.61 46.7989V46.8827L183.652 46.8408V46.8827L183.694 46.9259V46.8827V46.757H183.736L183.779 46.7989L183.863 47.0515L183.905 47.0934L183.946 47.1353V47.3042L183.863 47.2623V47.1772L183.821 47.2204L183.779 47.1772L183.736 47.2204V47.2623L183.779 47.2204L183.821 47.2623L183.946 47.3461L183.905 47.4299L183.946 47.388H183.988V47.515L183.905 47.5569L183.988 47.6407H184.03L184.073 47.5988V47.6407L184.03 47.7677L183.905 47.8096L183.863 47.8515V48.146V48.3987L183.946 48.3568L184.073 48.3987L184.115 48.4406L184.283 48.5676L184.325 48.6514H184.283L184.241 48.7352L184.283 48.6933H184.325H184.368L184.452 48.819L184.536 48.8622L184.452 48.9041V48.946H184.41V48.9041V48.946V48.9879L184.494 48.946V48.9041L184.536 48.946V49.0717L184.621 49.2824L184.577 49.2405L184.536 49.3243L184.577 49.2824H184.663L184.788 49.577L184.746 49.6189L184.788 49.6621L184.746 49.704L184.704 49.7459L184.663 49.7878L184.621 49.7459L184.494 49.7878H184.621L184.704 49.8716V49.9135L184.663 49.9986L184.577 50.1243L184.494 50.1662V50.1243H184.452H184.41L184.663 50.4188H184.704L184.957 50.7134L185.041 50.6715L185.083 50.6296L185.168 50.5877H185.336H185.377L185.588 50.5458L185.63 50.5039L185.799 50.4607L185.883 50.4188L185.968 50.3769L186.052 50.335L186.135 50.2932L186.094 50.2513H186.177V50.2094L186.304 50.1662V50.2094V50.1662L186.346 50.1243L186.388 50.1662V50.1243L186.43 50.1662H186.388L186.43 50.2094L186.472 50.1662V50.2094L186.514 50.1662L186.472 50.1243H186.388V50.0824H186.557L186.81 50.1243V50.0824L186.852 50.0405V50.0824L186.81 50.1243L186.852 50.335V50.3769H186.81L186.766 50.335V50.3769H186.725L186.683 50.2932L186.641 50.2513L186.683 50.2932V50.335H186.599V50.2932L186.557 50.335L186.514 50.2932V50.335H186.599L186.557 50.3769L186.388 50.4188L186.346 50.4607L186.262 50.5039H186.304L186.388 50.4607V50.4188L186.472 50.4607H186.599H186.514L186.557 50.5039L186.599 50.5877L186.641 50.4607H186.766L187.104 50.5039L187.23 50.5877L187.104 51.008L186.977 51.2188L187.104 51.1769L187.23 50.9661L187.441 50.7566L187.608 50.4607L187.652 50.2932L187.819 50.0824L187.861 49.9986L188.072 49.8297L188.283 49.704H188.324V49.7459H188.366L188.408 49.7878L188.493 49.8297L188.535 49.8716L188.451 49.7878L188.661 49.3243L188.746 49.2824L189.041 49.1568L189.25 48.946L189.377 48.9041L189.546 48.9879L189.672 49.0717L189.966 49.704L190.05 49.8297L190.135 49.8716L190.177 49.7878L190.388 49.6621L190.472 49.6189H190.682L190.808 49.577H190.85V49.6189H190.892L191.061 49.6621H191.103H191.313L192.03 49.8716L192.155 49.9567L192.534 50.1243L193.081 50.4188L193.25 50.5039L193.502 50.5877L194.133 50.9242L194.47 51.0931H194.681L194.597 51.135H194.639H194.723L194.766 51.0931L194.723 51.008L194.681 51.0512V51.008L194.723 50.9661L194.808 51.135V51.1769V51.2188L194.891 51.2607H195.06L195.102 51.4295L195.06 51.4714L195.017 51.5984L195.102 51.6403L195.06 51.5984L195.144 51.4714L195.102 51.2607L195.017 51.1769L194.933 51.2188L194.891 51.1769V51.135H194.975V51.0931H194.933L194.891 51.0512L194.808 51.0931L194.766 51.0512L194.808 51.008H194.85L194.975 51.0512L195.397 51.5133L195.691 51.7241L195.86 51.8511H195.986V51.893L196.239 51.8511L196.364 52.0187L196.406 52.0606L196.364 51.9349H196.449L196.702 52.0187L197.08 52.0606L197.333 51.9349L197.375 51.893H197.417L197.501 51.9349H197.67H197.753L197.922 51.766H197.964H198.006V51.893L198.049 51.9768V51.9349H198.006L198.049 51.893L198.386 51.9349H198.68L198.848 51.893H198.975H199.059V51.9349H199.017V51.9768L199.186 52.2714L199.228 52.3552L199.269 52.2714L199.311 52.1876L199.269 52.1025L199.353 52.0606L199.522 52.1025H199.606H199.648H199.9H199.942H200.027H200.237H200.49V52.1457L200.448 52.1025L200.533 52.2295L200.448 52.3133L200.322 52.4403V52.6497L200.364 52.7348V52.7767L200.237 52.8186V52.9456L200.195 53.1132L200.28 53.197L200.364 53.324L200.406 53.3659L200.575 53.4916L200.617 53.5348L200.659 53.6604L200.533 53.7874V53.8293L200.49 54.0401L200.406 54.082L200.237 54.2077L200.195 54.2915L200.069 54.4604L199.986 54.5023L199.9 54.5442L199.859 54.5861V54.6293V54.7549L199.775 54.8387V54.8806V55.0914H199.733L199.648 55.0495H199.606L199.564 55.1333L199.522 55.2603V55.3022H199.48L199.395 55.4292L199.311 55.4711H199.186L198.975 55.513L198.891 55.5549H198.68L198.595 55.6387L198.553 55.6806V55.7657H198.722H198.764V55.8076V55.8494V55.8913H198.68L198.638 55.9332L198.595 56.0183V56.1021V56.144L198.511 56.1859L198.428 56.3548L198.217 56.3967V56.4386L198.133 56.4805L198.175 56.6075L198.133 56.6913V56.6494L198.091 56.6913L197.88 56.6494L197.67 56.7332L197.586 56.7751H197.544L197.375 56.6913L197.333 56.6494L197.164 56.7751H197.08L196.955 56.7332V56.8183L196.912 56.9021L196.828 56.9439L196.786 56.9021V56.8183H196.744H196.702L196.617 56.9439L196.533 56.9858H196.491H196.449L196.364 56.9021V56.7751H196.322L196.281 56.7332L196.239 56.8183V56.9439L196.112 57.0277L196.07 57.1128V57.1547V57.1966V57.2385L195.902 57.4493L195.817 57.5331L195.733 57.575L195.608 57.6601L195.564 57.7858V57.8277L195.522 57.9128H195.439L195.312 58.0803L195.186 58.2073L195.144 58.2911V58.333V58.3749L195.228 58.5438V58.6276L195.186 58.7127L195.144 58.7546L195.186 58.8803L195.228 58.9641L195.186 59.0073L195.144 59.0492L194.891 59.4694V59.5545V59.5964V59.7221L194.808 59.8059L194.513 60.0167L194.47 60.1437L194.428 60.2693H194.386L194.344 60.2274H194.26L194.175 60.4801L194.133 60.522L194.05 60.7747V60.9004L193.966 60.9855L193.839 61.0274L193.797 61.0693L193.755 61.1531L193.881 61.2382V61.2801H193.628L193.586 61.3219L193.544 61.3638L193.292 61.6584L193.25 61.7854V61.9111L193.292 62.1219V62.2057L193.419 62.4164V62.5421V62.711V62.7529H193.502L193.586 62.711H193.628V62.7529L193.881 62.9218L193.966 63.0056L193.923 63.1745L193.966 63.2583L194.092 63.3421V63.384V63.4272V63.4691H194.05V63.5947L193.966 63.7217L194.008 63.8893V63.9325L193.966 64.0163L193.923 64.1001L193.713 64.3947L193.671 64.4366V64.4785L193.586 64.5217L193.502 64.6054L193.46 64.6892L193.502 64.7743L193.544 64.8162L193.671 64.9V64.9838L193.628 65.0689L193.502 65.1946V65.3216L193.544 65.4473H193.586L193.797 65.6581L193.839 65.7837V65.9526V65.9945L194.008 66.1634V66.2053L194.092 66.2891L194.05 66.4999V66.5837L194.175 66.8782V67.0471V67.1309H194.217L194.302 67.2579L194.344 67.5106L194.386 67.6363L194.428 67.8471V67.9727L194.26 68.1835V68.2673L194.344 68.4781V68.52V68.6051L194.302 68.8146L194.26 68.8997L194.175 68.9416L194.008 69.0253V69.1091L193.923 69.151L193.755 69.1942L193.713 69.2361L193.671 69.4037L193.586 69.4888L193.419 69.5307L193.375 69.5726L193.333 69.7415V69.7834L193.208 69.9091L193.166 70.1617L193.039 70.2455L192.997 70.3725L192.955 70.4563H192.871L192.661 70.4982L192.619 70.5833L192.577 70.6252V70.709L192.619 70.7509L192.661 70.7941V70.836L192.619 71.0455L192.702 71.34V71.4251H192.577V71.467L192.534 71.5508L192.577 71.7616L192.619 71.8454L192.577 71.9724L192.702 72.2251L192.577 72.4345V72.5196L192.619 72.5615L192.661 72.7304V72.8142L192.744 72.898L192.828 72.9818L192.871 73.025V73.1507V73.1926L192.828 73.2345V73.2777L192.744 73.3196L192.702 73.3615V73.4033L192.828 73.529L192.871 73.6979L192.955 73.7817H193.124L193.208 73.8249L193.292 73.8668V73.9087L193.333 74.1614L193.375 74.2033L193.46 74.2871H193.586L193.713 74.456L193.839 74.4978L193.966 74.5397H194.008V74.5816L194.05 74.6667L194.092 74.7086V74.7924L194.133 74.8762L194.092 75.0451L194.05 75.1708L194.092 75.214L194.175 75.1708L194.217 75.214V75.2559L194.092 75.3816L194.05 75.4235V75.5505L193.923 75.7612V75.8031L194.008 75.9288L193.966 76.0558L194.008 76.1815L193.923 76.2234L193.881 76.2653V76.3085L193.966 76.3504L193.881 76.518V76.645V76.7287L193.755 76.8976L193.713 77.1503V77.1922V77.2341L193.671 77.3598L193.502 77.5706L193.292 77.6544L193.25 77.8232L193.166 77.907H193.124L192.955 77.9489H192.871L192.786 77.8651H192.661L192.534 77.9921L192.366 78.0759H192.281H192.239L192.113 77.9921L191.903 77.9489L191.65 77.9921H191.608L191.566 78.0759L191.439 78.1597L191.271 78.2016L191.019 78.1597L190.935 78.3286L190.766 78.2867V78.4124H190.724L190.639 78.4543H190.555L190.43 78.4124L190.345 78.4543V78.4975L190.177 78.4124L190.135 78.3286L190.093 78.2448L190.05 78.2016L189.841 78.1178L189.797 78.0759L189.755 77.9489V77.907L189.714 77.8651H189.672H189.63V77.907H189.588H189.546L189.461 77.8232L189.335 77.7814L189.208 77.6544L189.082 77.6125L188.999 77.5706L188.83 77.6125L188.788 77.5706V77.5287H188.746L188.661 77.5706H188.493H188.451L188.366 77.6544L188.241 77.5706L188.199 77.6125L188.156 77.6544L188.114 77.7395L187.904 77.7814L187.735 77.907L187.525 77.8651L187.483 77.907L187.441 77.9921H187.399L187.314 77.9489V77.8651L187.23 77.8232H187.146L187.061 77.907L186.766 77.9489L186.725 77.9921H186.641L186.599 78.0759V78.2448L186.557 78.3286H186.514L186.43 78.2016H186.304H186.262V78.2448V78.2867L186.388 78.4543L186.346 78.5394H186.304H186.262V78.4124H186.219L186.177 78.4543L186.135 78.5813L185.968 78.6651L185.883 78.7921V78.834V78.9596V79.0015H185.799L185.715 79.0434V79.2123L185.504 79.465H185.419H185.336V79.592L185.294 79.6758L185.252 79.7596L185.294 79.8866V79.9285L185.21 80.0122L185.083 80.223H185.041L184.915 80.1379L184.704 80.223H184.621L184.494 80.2649L184.41 80.3487L184.283 80.4757L184.115 80.5176L183.946 80.6014V80.6433H183.863L183.779 80.7284L183.736 80.896H183.694L183.483 80.9379L183.441 81.0649L183.399 81.1067L183.274 81.1905V81.2324L183.147 81.4432L183.021 81.4851L182.979 81.5283L182.894 81.5702H182.852L182.81 81.7378L182.768 81.781L182.726 81.9905H182.641H182.599H182.557L182.474 81.9486L182.388 81.781L182.136 81.8648L182.094 81.8229L181.926 81.781L181.884 81.8648L181.716 81.9486L181.674 81.9905V82.0324L181.632 82.0756L181.59 82.1594L181.505 82.2012L181.421 82.1594L181.379 82.2012L181.337 82.285L181.294 82.3701L181.252 82.4539L181.21 82.4958L181.168 82.4539L181.043 82.4958L180.958 82.5377H180.874H180.832L180.747 82.6228H180.663L180.495 82.7485L180.41 82.7066H180.368L180.243 82.6647L179.99 82.7485L179.948 82.7904H179.863L179.821 82.7485L179.695 82.8323L179.652 82.9593L179.527 83.0012L179.443 83.085H179.401V83.0431L179.316 83.0012H179.274L179.232 83.0431L179.148 83.1269L179.021 83.085L178.937 83.1269H178.896H178.769L178.685 83.1701L178.643 83.2539L178.474 83.4214L178.39 83.3795H178.348L178.306 83.4646V83.5484L178.263 83.5903H178.221V83.6322L178.179 83.6741H178.096L178.054 83.7173L178.096 83.8011H178.054L177.969 83.7592H177.927V83.8011L178.012 83.843L177.927 83.8849H177.885V83.9687V84.0119L177.801 84.0538L177.759 84.1376L177.801 84.2214V84.2646H177.759V84.2214L177.716 84.2646L177.759 84.3484L177.716 84.4321L177.759 84.474L177.716 84.5159L177.674 84.474V84.5591L177.59 84.601L177.632 84.7267L177.59 84.8118L177.506 84.8537V84.9375L177.465 84.9794H177.421L177.465 85.0632L177.548 85.1064V85.1483L177.421 85.1902L177.548 85.274V85.3159L177.465 85.3591H177.421V85.401V85.4847L177.379 85.5266L177.338 85.5685L177.379 85.6104V85.6536L177.338 85.6955L177.254 85.8212L177.379 85.9063V85.9482H177.338H177.296L177.212 86.032L177.296 86.1577L177.254 86.2009V86.3266L177.169 86.4955L177.212 86.5792L177.169 86.663L177.127 86.7481L177.169 86.8738L177.127 86.9576H177.043L177.001 87.0427L176.959 87.0846L177.001 87.1684L176.665 87.463V87.7156L176.58 87.7994V87.9264L176.496 88.0102V88.1372V88.1791L176.412 88.221L176.454 88.3048L176.412 88.3467H176.37L176.285 88.3899L176.327 88.4318L176.243 88.4737V88.5156V88.5575V88.5994L176.201 88.6845L176.159 88.7264L176.201 88.8939L176.159 89.0209L176.201 89.0628L176.117 89.1885L176.074 89.2317L176.117 89.3155L176.074 89.3574V89.4412L176.032 89.4844L175.865 89.6101V89.652L176.032 89.7358L175.948 89.8209L175.823 89.779V89.8209H175.78L175.738 89.9046L175.696 90.0303L175.738 90.0735L175.696 90.1154L175.57 90.41H175.485L175.401 90.4519L175.443 90.5357H175.359L175.276 90.5789L175.232 90.7465L175.149 90.7046L175.023 90.8303H174.981V90.8735L174.938 90.9573L174.854 90.9991L174.812 91.0829L174.854 91.1248L174.938 91.168V91.2099L174.896 91.2518H174.854L174.812 91.2937L174.77 91.3775L174.728 91.4207L174.77 91.4626L174.685 91.5045V91.5464V91.6302V91.6734V91.7153L174.601 91.7991L174.643 91.8829L174.685 92.0099V92.0518L174.77 92.1355L174.812 92.2625L174.938 92.3463V92.4301L174.981 92.5152L174.938 92.599L174.981 92.6409L175.023 92.6828V92.7679V92.8098H175.065V92.8936H175.023V92.9774V93.1463L175.065 93.1881L175.107 93.3138L175.149 93.357L175.232 93.4408L175.19 93.4827H175.149L175.19 93.6097V93.7354H175.232L175.19 93.8624V93.9462L175.232 94.03V94.1138H175.149V94.157L175.19 94.2408V94.2826H175.232V94.3664H175.276L175.232 94.4515L175.276 94.4934L175.317 94.4515L175.359 94.4934L175.443 94.5353H175.527L175.57 94.5772L175.654 94.661L175.696 94.7461L175.823 94.9137V94.9556V95.0407H175.865L175.823 95.0826H175.865V95.1245L175.907 95.1664L175.865 95.2083H175.907L175.865 95.2515L175.907 95.3353L175.823 95.3771V95.419L175.738 95.4609L175.696 95.5879V95.6298L175.612 95.6717L175.654 95.7555L175.57 95.8406V95.9244L175.612 96.0082L175.57 96.0501L175.612 96.0933L175.654 96.1352L175.696 96.219V96.2609H175.654V96.3028L175.612 96.4298L175.654 96.5973L175.57 96.7243L175.654 96.7662L175.612 96.8081L175.654 96.85V96.8932L175.696 96.977L175.654 97.0189L175.696 97.1027V97.1446V97.1878L175.654 97.3135L175.57 97.3554L175.527 97.3973V97.4405L175.485 97.608V97.6499L175.401 97.7769V97.8188L175.443 97.8607V97.9026V98.0715L175.485 98.1134L175.527 98.1553L175.57 98.2823L175.527 98.3661V98.408L175.485 98.5337V98.6188L175.401 98.7025V98.7444L175.359 98.9133V98.9971H175.317L175.401 99.0822L175.317 99.3336L175.276 99.3768L175.232 99.5025L175.19 99.6282L175.107 99.6714V99.7133L175.065 99.7552L175.023 99.8808H174.981H174.896V99.9659L174.854 100.05L174.896 100.302L174.728 100.219L174.601 100.261L174.559 100.302L174.476 100.175L174.432 99.797L174.391 99.7552H174.349L174.265 99.797L173.97 100.008L173.718 99.9659L173.549 100.008L173.423 99.8389L173.381 99.797L173.338 99.7552L173.254 99.7133L173.087 99.7552L172.876 99.797H172.707L172.623 99.7552L172.539 99.8389L172.412 99.7552L172.287 99.7133L172.202 99.4187L171.992 99.166H171.949L171.823 99.1241L171.781 98.9971L171.739 98.9552V98.7444L171.612 98.5769L171.654 98.4918L171.612 98.3242L171.697 98.2391L171.612 98.1553V98.0296L171.654 97.9877V97.8607L171.529 97.8188V97.7769L171.612 97.735L171.529 97.6499H171.487L171.529 97.5243L171.445 97.4405L171.402 97.3554L171.234 97.4405H171.107L170.981 97.3973V97.3554L171.023 97.2297L171.065 97.1878L171.023 97.1027L170.898 97.0189H170.687H170.603V96.977L170.56 96.9351V96.85L170.518 96.6824L170.771 96.5135L170.812 96.4298V96.2609L170.898 96.1352V96.0082L170.981 95.9663L171.234 95.7987V95.7555L171.107 95.7136V95.6717L171.023 95.546V95.5028L171.107 95.419V95.3353L171.023 95.2934L170.898 95.3353L170.854 95.2515L170.771 95.2083H170.687L170.603 95.1245L170.56 95.0826V94.9988L170.603 94.9137L170.645 94.8718L170.518 94.8299L170.434 94.7461H170.392L170.265 94.788H170.098L170.013 94.8299L169.971 94.8718V94.9137L169.845 94.8718V94.8299L169.887 94.7042L169.803 94.5772L169.76 94.5353L169.718 94.4934L169.634 94.4083L169.55 94.2826V94.1989H169.508L169.381 94.2408L169.34 94.157V94.1138V94.0719L169.423 94.03V93.9881L169.465 93.9462L169.508 93.9043L169.423 93.7773L169.465 93.6935L169.508 93.6097L169.465 93.5246V93.4827L169.381 93.5246L169.298 93.4827V93.4408L169.34 93.3138L169.298 93.23L169.256 93.1881L169.087 93.1463H169.045V93.0625V93.0193L169.003 93.0625L168.961 93.1044H168.876H168.834L168.792 93.0193H168.834L168.792 92.9355L168.834 92.8936L168.792 92.8517H168.834L168.792 92.8098H168.834H168.876L168.918 92.7679L168.876 92.6828H168.75L168.54 92.7679L168.456 92.7247H168.371V92.7679H168.329H168.287L168.329 92.6828L168.245 92.7247L168.161 92.6828H168.076V92.7247L167.951 92.6409V92.599H168.034L167.992 92.5571H168.034V92.5152V92.472L168.119 92.4301V92.3882H168.076V92.3463L168.034 92.3882L167.951 92.3463L167.992 92.3044H168.119V92.2625L168.161 92.1774V92.1355V92.1774H168.245V92.1355L168.287 92.0936V92.0518L168.245 91.968L168.287 91.9248H168.329L168.414 91.8829V91.841L168.498 91.7991V91.7572L168.582 91.7153L168.54 91.6302H168.498L168.456 91.5883V91.5464L168.414 91.4626L168.498 91.4207H168.54H168.582L168.623 91.4626L168.665 91.4207L168.75 91.3356H168.876L168.918 91.2937L168.876 91.2518V91.2099H168.918L168.961 91.168L168.918 91.1248L168.961 91.0829V90.9573L169.003 90.9154L168.961 90.7884H168.918V90.7465H168.876V90.6627L168.834 90.6208L168.792 90.4938H168.834H168.876H168.918V90.3681L169.003 90.283H169.045L169.087 90.2411L169.045 90.1573L169.003 90.1154L169.045 90.0735H168.961L169.003 90.0303H168.961L168.876 89.9884L168.918 89.9465L168.876 89.9046L168.918 89.8628V89.8209H168.961V89.779H169.003L168.961 89.7358H169.003V89.6939L168.961 89.652L168.918 89.6939V89.652H168.876H168.918V89.6101L168.961 89.652H169.003V89.6101V89.5682V89.5263L169.045 89.5682V89.4844V89.5263H169.087V89.4844L169.129 89.5263V89.4844H169.171L169.129 89.4412H169.171V89.3993L169.213 89.4412L169.256 89.3993V89.3574L169.298 89.3155V89.2736H169.34L169.298 89.2317L169.34 89.1885L169.298 89.1466L169.34 89.1047L169.298 89.0628H169.34L169.298 88.979V88.8939H169.381V88.852L169.423 88.8101L169.465 88.8939L169.508 88.852L169.634 88.7264L169.592 88.6845L169.634 88.5994V88.5575V88.5156L169.592 88.3899L169.634 88.4318L169.718 88.3899L169.676 88.3048H169.718V88.2629V88.221L169.845 88.2629H169.929H169.971H170.013L170.056 88.3048L170.098 88.221L170.14 88.1791L170.181 88.0953L170.307 88.0521L170.392 88.0102L170.476 87.9683L170.645 87.8845L170.812 87.9683H170.898L170.981 87.9264H171.107L171.192 87.8845L171.276 87.7994L171.36 87.7156L171.445 87.59L171.402 87.3792L171.445 87.2522L171.529 87.1684L171.57 87.1265L171.487 87.0427L171.402 87.0008V86.9576V86.9157L171.529 86.5792V86.4955L171.57 86.4104H171.654L171.697 86.3685V86.2847L171.612 86.2009V86.1158V85.9482V85.9063L171.57 85.8631V85.8212L171.529 85.7374L171.36 85.6104L171.192 85.5266L171.107 85.4847V85.401V85.3591L171.023 85.3159L170.981 85.274H170.898V85.2321L170.812 85.1902H170.687L170.603 85.274H170.56L170.476 85.2321H170.434L170.392 85.3159H170.307H170.265L170.181 85.274L170.14 85.3159H170.098L170.056 85.3591H170.013H169.971L169.929 85.401L169.887 85.3591L169.845 85.4847H169.803V85.4429L169.76 85.4847L169.718 85.5266V85.5685L169.676 85.5266V85.5685H169.634L169.592 85.5266L169.55 85.5685L169.423 85.6104H169.381V85.6536H169.34L169.298 85.5685L169.256 85.6104L169.213 85.6536L169.171 85.6104V85.5685L169.087 85.6104V85.6955H169.045L169.003 85.7793H168.961L168.918 85.7374H168.876V85.7793V85.8212H168.834H168.75L168.709 85.9063H168.665V85.9482V86.032L168.582 86.0739L168.623 86.1158L168.498 86.1577V86.2009L168.456 86.1577L168.414 86.2847H168.371V86.2428H168.329H168.287H168.245V86.2009H168.119V86.1577L168.034 86.1158L168.076 86.0739L167.992 86.032V85.9063L167.867 85.7793H167.698L167.782 85.7374L167.698 85.6536H167.74V85.6104V85.5685L167.698 85.6104L167.656 85.5685L167.698 85.4429L167.656 85.4847L167.614 85.3591H167.571L167.487 85.401V85.3159V85.1902H167.403V85.1483L167.361 85.1064L167.276 85.0213V84.9794V84.9375H167.234V84.8537L167.151 84.8956V84.8537H167.109V84.8118H167.025L166.982 84.7686L166.94 84.7267V84.6848H166.898H166.856V84.6429L166.94 84.601H166.856L166.898 84.5591L166.856 84.474L166.814 84.3484L166.856 84.3065H166.814H166.772L166.729 84.3484L166.772 84.2646V84.2214H166.687V84.1795V84.1376L166.645 84.1795L166.561 84.1376L166.52 84.1795L166.478 84.1376H166.434V84.0538L166.478 84.0119L166.434 83.9687V83.9268L166.478 83.9687H166.52V83.8849L166.309 83.843V83.8011V83.7592L166.267 83.7173H166.351H166.393L166.434 83.6741L166.393 83.6322L166.309 83.5484L166.225 83.5065L166.182 83.4214H166.14H166.056V83.4646L166.098 83.5484H166.182V83.5903L166.098 83.6741L166.014 83.6322L165.972 83.5484V83.5065L166.014 83.4214V83.2957L165.887 83.212L165.93 83.1269L165.887 83.085H165.845L165.762 83.0431H165.72H165.678V83.0012L165.72 82.9593L165.762 82.9174V82.8742L165.72 82.8323L165.678 82.7904H165.509L165.467 82.8742H165.425L165.383 82.8323V82.6228L165.298 82.5377L165.256 82.3269V82.2431H165.172H165.087L164.962 82.285L164.878 82.3269L164.709 82.285L164.793 82.1175L164.878 82.0756L165.214 81.9486V81.9067L165.383 81.8229L165.425 81.6121L165.383 81.5283L165.298 81.3594L165.045 81.1905L165.003 81.1486H164.709L164.625 81.1905L164.498 81.4013H164.414H164.372H164.331L164.204 81.1067L164.078 80.9811L163.825 80.8541L163.741 80.7703V80.6865V80.5595V80.5176L163.951 80.3906L163.993 80.3487H164.078L164.204 80.3906L164.289 80.4338L164.372 80.3906L164.498 80.223L164.54 80.0541L164.709 79.8434L164.793 79.8015L164.962 79.6339L165.003 79.5488V79.5069L165.045 79.3812L165.087 79.2961V79.1285L165.214 78.8759L165.256 78.7921L165.214 78.6651L165.13 78.4543V78.4124H165.087V78.3705L165.172 78.1178L165.298 77.907V77.6125V77.5287L165.34 77.4868L165.298 77.3598L165.425 77.1071L165.509 76.9814V76.9395V76.8125V76.645L165.551 76.6031V76.518L165.72 76.2653H165.762L165.803 76.1815L165.678 75.845L165.72 75.8031L165.762 75.6342L165.803 75.4654L165.845 75.2559V75.214L166.014 74.8762V74.7924V74.6667L165.972 74.5397L165.887 74.4141L165.803 74.2033L165.72 73.8249L165.678 73.656L165.72 73.4871V73.3615V73.3196L165.678 73.1507L165.593 73.025L165.72 72.6453V72.2251L165.678 72.1832L165.635 71.9724L165.467 71.5927L165.383 71.5089L165.298 71.34L165.34 71.2143L165.425 70.9198V70.7509V70.6671L165.383 70.4982V70.2887L165.298 70.0361L164.92 69.6564H164.878L164.793 69.6996L164.54 69.6145L164.245 69.3618L164.12 69.3199L163.783 69.1091H163.614L163.446 69.151H163.236L163.151 69.0672L162.983 68.8565V68.647V68.6051V68.5619L162.941 68.4362L162.9 68.3524L162.604 68.2254H162.562H162.436L162.225 68.1835H162.142H162.1L161.889 68.3943L161.678 68.4362L161.509 68.3943L161.089 68.3524L161.005 68.3092L160.878 68.2673L160.794 68.1835H160.752L160.667 68.1416L160.5 68.0565L160.373 67.9727H160.205L159.994 67.8052L159.911 67.762L159.278 67.8471L159.153 67.9308L158.942 67.889L158.816 67.9727L158.689 68.1416V68.2254L158.647 68.3524V68.4781L158.563 68.6889L158.436 68.8146L158.395 68.8565L158.269 68.8146L158.226 68.7308L158.142 68.6889L157.974 68.647L157.889 68.6889L157.847 68.7308L157.805 68.8997L157.764 68.9416L157.637 68.8997L157.595 68.9416L157.511 68.8997ZM175.696 42.1263V42.0844V42.1263ZM178.937 43.8099V43.768L178.896 43.6843L178.854 43.768L178.81 43.7262L178.854 43.768L178.896 43.7262V43.8099H178.937ZM180.452 43.3478V43.3046V43.2208L180.495 43.1789V43.2208V43.2627L180.452 43.3046H180.495L180.579 43.5992L180.537 43.6424V43.5992L180.495 43.4316V43.3478H180.452ZM180.495 43.3046H180.452V43.3478L180.495 43.3046ZM176.748 42.8424H176.79L176.748 42.7992V42.8424ZM176.79 42.8424L176.748 42.9262L176.707 42.9681V43.01V43.0951H176.748L176.707 42.9681L176.79 42.9262L176.832 42.8843L176.79 42.8424ZM182.347 45.4517H182.388V45.4805L182.432 45.4517L182.474 45.5368L182.388 45.5787L182.305 45.5368L182.368 45.4936H182.347V45.4517ZM182.305 44.9044H182.263L182.305 44.8625V44.9044ZM175.696 42.7992L175.612 42.8424L175.57 42.9262L175.612 43.01H175.696V43.0951L175.738 43.137L175.78 43.0951L175.823 43.1789V43.2627V43.3046V43.2627L175.865 43.1789L175.78 43.0951L175.738 43.137L175.696 43.0951V43.01L175.654 42.9681L175.57 42.9262L175.612 42.8843L175.725 42.7992H175.696ZM184.157 48.3568V48.3149V48.3568H184.199V48.3149V48.3568H184.157ZM181.505 43.3046V43.2627L181.463 43.2208H181.379L181.337 43.1789V43.2208L181.463 43.2627L181.294 43.3478H181.252V43.3046V43.2627V43.3478H181.294L181.421 43.3046H181.463L181.421 43.3478L181.252 43.4735V43.5154H181.21H181.126V43.4735V43.5992L181.043 43.6843H180.999V43.6424L180.958 43.7262H180.874L180.705 43.5992L180.663 43.3897V43.4316V43.3897L180.747 43.3046H180.663L180.621 43.2627L180.663 43.1789L180.747 43.137L180.79 43.1789L180.832 43.2208L180.958 43.2627V43.2208L180.999 43.1789L181.126 43.3046V43.2627L180.999 43.1789L181.043 43.137V43.0951V43.137H180.958L180.999 43.0519L180.916 43.0951L180.874 43.0519L180.958 42.9262L180.999 42.8843H181.085L181.126 42.9262H181.21L181.252 43.01V43.0519H181.294L181.252 42.9681V42.8843H181.379L181.505 42.9262L181.674 43.01L181.716 43.137V43.1789V43.2208L181.757 43.2627L181.632 43.3046L181.547 43.3897L181.59 43.1789L181.547 43.2627V43.3046H181.505ZM182.136 44.7369L182.179 44.6937V44.7369H182.136ZM175.443 42.7573V42.7154H175.485V42.7573H175.443ZM183.147 46.1259V46.0827H183.188L183.23 46.0408V46.0827H183.188V46.1259H183.147ZM176.832 43.01L176.79 43.0951H176.832V43.0519V43.01ZM177.254 42.8424L177.296 42.7992L177.338 42.7573L177.296 42.7992H177.338L177.296 42.8424H177.254ZM181.841 44.6937H181.884L181.841 44.568L181.884 44.5261L182.01 44.4423L182.052 44.3153V44.2734L182.179 44.1896H182.263L182.179 44.1045V44.0626L182.305 44.0207L182.388 44.1045V44.3991L182.347 44.4423H182.221L182.136 44.4842H182.094V44.5261H182.136L182.094 44.568V44.6099L182.052 44.6937L182.01 44.7369L181.884 44.6937L181.926 44.7369V44.7788L181.884 44.7369L181.841 44.6937ZM186.893 50.1243V50.0405H186.935L186.977 49.9986V50.0824L186.935 50.0405L186.893 50.1243ZM180.663 43.6424H180.705L180.79 43.6843V43.7262H180.747L180.663 43.6424ZM177.716 43.5992L177.759 43.5573L177.801 43.4735L177.716 43.5154V43.5992ZM183.063 46.2097V46.1678L183.105 46.2097V46.3354L183.063 46.2097ZM184.157 47.6826L184.199 47.5569L184.241 47.6407L184.199 47.6826H184.157ZM182.388 45.4098L182.432 45.3679L182.515 45.326V45.3679V45.4517L182.388 45.4098ZM178.221 43.7262L178.263 43.6424H178.306V43.7262L178.263 43.768L178.221 43.7262ZM183.988 47.9772L184.241 47.8515L184.199 47.9353L184.073 47.9772H183.988ZM183.946 48.2298H184.03L183.988 48.1879L184.03 48.146V48.1042L184.073 48.146H184.115L184.073 48.1879V48.2717V48.3149H184.03L184.073 48.2717L183.946 48.2298ZM180.158 43.768L180.243 43.6843L180.285 43.5154V43.4735H180.368V43.5154V43.5573L180.285 43.5992V43.6424L180.199 43.768V43.8518L180.158 43.768ZM175.823 42.379L175.865 42.2952H175.907L175.948 42.3371V42.379V42.4628L175.907 42.5479L175.823 42.4628V42.379ZM175.696 41.9155V41.8736L175.78 41.8317L175.865 41.8736V41.9155H175.823L175.865 42.0006L175.78 42.0844V42.0425L175.738 42.0844L175.696 42.0425V41.9155ZM183.188 46.4205L183.23 46.4624H183.274L183.23 46.4205H183.188ZM183.063 46.5632L183.021 46.5881L183.147 46.6732L183.23 46.6313L183.274 46.5462L183.23 46.5881L183.147 46.6313L183.063 46.5881V46.5632ZM182.305 44.7788V44.6518L182.347 44.6099L182.388 44.5261H182.432L182.515 44.6099V44.6518L182.474 44.6937L182.305 44.8207V44.7788ZM180.958 43.2627L180.916 43.3897L180.958 43.3046V43.2627ZM180.916 43.3897L180.79 43.3046H180.747L180.874 43.3897L180.958 43.5992H180.999L180.958 43.5573L180.916 43.3897ZM183.315 46.5462L183.274 46.4205L183.315 46.2935H183.357H183.399V46.2097H183.441L183.483 46.2516L183.441 46.2935L183.483 46.4205L183.441 46.5043L183.483 46.4624L183.441 46.5462L183.399 46.5881H183.357L183.315 46.5462ZM177.506 42.5898H177.465L177.421 42.5479H177.338L177.212 42.5898L177.127 42.6735H177.085L177.212 42.5479L177.254 42.4628H177.296L177.254 42.4209V42.379V42.3371L177.338 42.2952L177.421 42.3371V42.379L177.506 42.4209L177.548 42.5479H177.506V42.5047V42.5898ZM176.665 42.7154L176.538 42.7992L176.454 42.6735H176.496L176.454 42.5898V42.5047H176.496L176.454 42.4628L176.496 42.379L176.538 42.5047H176.58L176.621 42.5898L176.58 42.5047L176.538 42.4628V42.379L176.58 42.2952L176.665 42.4628L176.707 42.5047L176.665 42.6317L176.707 42.6735L176.665 42.7154ZM182.094 44.4842L182.136 44.3991L182.263 44.2315V44.1896L182.052 44.4842L181.968 44.5261L182.094 44.4842ZM181.337 43.1789L181.421 43.137V43.0951H181.379L181.337 43.1789ZM181.379 43.0951H181.337V43.137L181.379 43.0951ZM181.337 43.0951L181.379 43.0519H181.337V43.0951Z"
							fill="#6ba4da" />
						<path class="hover:!opacity-50 transition-all duration-300"
							d="M184.157 48.3568V48.3149V48.3568ZM184.157 48.3568H184.199V48.3149V48.3568H184.157ZM157.511 68.8997L158.731 67.889L159.32 67.4674L159.363 67.3836L159.489 67.2998L159.447 67.2147L159.489 67.1728H159.531L159.573 67.2147L159.7 67.1309L160.878 66.2053L160.962 66.1202L161.678 65.5311L161.805 65.4473L162.015 65.2784L162.52 64.8581L163.32 64.2271L163.404 64.1001L163.489 64.0163L163.614 64.0582H163.698L163.741 64.142L163.783 64.1001L163.867 64.142H163.951H164.036L164.162 64.1839L164.331 64.0582L164.414 63.9325L164.498 63.8893L164.583 63.8474L164.625 63.8055L164.793 63.5947L164.878 63.3421L165.087 63.1326L165.172 63.0056L165.256 62.8799V62.7948L165.34 62.711V62.6272L165.425 62.5421H165.383L165.425 62.4583V62.3746L165.467 62.3327L165.425 62.2908L165.593 62.2057L165.635 62.1219H165.678H165.72V62.0381L165.803 62.08L165.845 61.9949H165.887L165.972 61.8692H166.014H166.056L166.014 61.7003H166.056V61.6584L166.098 61.6165V61.5327L166.14 61.4908L166.098 61.4476L166.182 61.4057L166.225 61.4476L166.267 61.4057V61.3638L166.225 61.2801L166.267 61.2382L166.225 61.1963V61.1112L166.182 61.0274L166.225 60.9855V60.9436L166.309 60.8585V60.8166V60.7328H166.351V60.649L166.393 60.6058H166.478L166.434 60.649H166.478V60.6058H166.561V60.5639H166.603V60.522L166.645 60.4801H166.729V60.4382L166.856 60.3531L166.898 60.2693H166.982H167.025L167.067 60.1856H167.109L167.151 60.1018L167.192 60.1437V60.0586H167.234V60.0167V59.9329H167.276L167.319 59.891V59.764L167.403 59.7221L167.487 59.6383L167.529 59.6802V59.6383V59.5113H167.571H167.614H167.656H167.698L167.74 59.3856L167.824 59.3437L167.867 59.2586L167.824 59.1748L167.909 59.1329V59.0911V59.0073L167.992 58.9641V58.9222V58.8384V58.7546L168.034 58.6695V58.5857L167.992 58.5438L168.076 58.5019V58.4168L168.034 58.2492L168.161 58.1641L168.119 58.1222L168.076 58.1641V58.1222V58.0803L168.034 58.0384H168.076L168.119 57.9966L168.076 57.9547H168.119H168.076L168.119 57.9128L168.076 57.8696L168.119 57.8277L168.161 57.7439H168.203L168.161 57.6601L168.203 57.6182L168.161 57.575V57.5331V57.4912H168.203H168.245V57.4074L168.329 57.3655V57.3223H168.414L168.456 57.2804L168.54 57.2385L168.498 57.1966H168.582L168.498 57.0696V57.0277H168.582V57.0696H168.623L168.582 56.9021L168.709 56.9439V56.8602H168.665V56.8183H168.709L168.665 56.7751H168.75L168.709 56.6913H168.665V56.6075H168.709V56.5656V56.6075L168.75 56.5656L168.709 56.4805V56.4386V56.3967H168.75V56.271L168.792 56.3129L168.834 56.271L168.876 56.2278H168.834H168.876L168.918 56.1859L168.961 56.2278V56.1859H169.003V56.144H168.961L169.045 56.0602L169.087 56.0183L169.129 56.0602V56.1021L169.213 56.0602V56.0183L169.171 55.9751H169.213L169.256 56.0602H169.298V56.0183V55.9332L169.381 55.9751L169.423 55.8913H169.465H169.55V55.8076L169.465 55.7657L169.55 55.6806L169.465 55.5968H169.508H169.55H169.592V55.4292L169.634 55.386L169.676 55.4292H169.718L169.76 55.3441L169.718 55.3022L169.76 55.2603H169.845L169.887 55.3022V55.2603V55.2184L169.803 55.1765L169.887 55.1333V55.0914L169.76 55.0076H169.845L169.929 55.0914L169.971 55.0495L169.929 54.9238H170.013H170.056L170.098 54.8387L170.056 54.7968V54.7131L169.971 54.7549L169.929 54.6712H169.971H170.013H170.056L170.098 54.5861H170.14V54.7131H170.181L170.223 54.6712L170.181 54.5023L170.307 54.4604L170.35 54.5023V54.3766L170.392 54.3347L170.35 54.2496V54.1239L170.434 54.082L170.392 54.0401L170.476 53.955L170.392 53.9131V53.8712L170.434 53.8293L170.518 53.8712L170.56 53.7874L170.518 53.7442H170.476V53.7023H170.56V53.6604L170.518 53.6186H170.434V53.5348V53.4916L170.518 53.4497V53.4078L170.476 53.3659L170.434 53.2821H170.476L170.392 53.197H170.35V53.1551L170.434 53.1132H170.518L170.56 53.1551L170.603 53.1132L170.645 53.0713H170.603V53.0294L170.645 52.9875L170.603 52.9456H170.645L170.729 52.9875L170.812 52.9456L170.771 52.9024V52.8605H170.729L170.771 52.8186H170.854L170.939 52.9024L170.981 52.8605H171.023L170.939 52.8186H170.981V52.7767L170.898 52.8186V52.7767H170.939L170.898 52.7348H170.854V52.6929V52.5659V52.524H170.812V52.5659L170.771 52.6078L170.687 52.6497L170.645 52.5659V52.4822V52.3971V52.3133H170.603L170.56 52.3552L170.518 52.2295V52.1876V52.1457L170.434 52.1876V52.1457L170.392 52.0606L170.476 51.9349L170.56 51.893V51.8511L170.645 51.893V51.8511V51.8079L170.729 51.766V51.7241V51.6403L170.771 51.5984H170.812L170.898 51.766L170.939 51.7241V51.5552L171.023 51.5133H171.065H171.149L171.234 51.4714L171.445 51.4295L171.402 51.2607L171.487 51.2188H171.529L171.57 51.135L171.529 51.0931L171.487 51.0512V50.9661L171.529 50.9242H171.57L171.612 50.9661H171.697L171.992 50.8823V50.8404L171.907 50.7985L171.865 50.7566L171.907 50.6715L171.865 50.5877V50.5039L171.907 50.4188H171.865V50.3769V50.2513V50.1243L171.949 50.0405L171.992 49.9567L172.034 49.8716V49.8297L171.949 49.7878L171.823 49.9567H171.781L171.697 49.9135V49.8716V49.7878L171.865 49.6621L171.907 49.6189V49.5351V49.4094L171.949 49.3662L171.992 49.1568L171.907 49.0717V49.0298L172.034 48.9879L172.076 49.0717L172.16 49.1149L172.243 49.0717L172.287 48.946H172.37L172.454 48.9041V48.8622L172.539 48.6933L172.623 48.6095L172.749 48.5676L172.834 48.4825L172.749 48.4406V48.3987L172.876 48.2717L172.918 48.2298V48.1042L172.876 48.0204V47.8934L172.918 47.8096L172.96 47.7677L173.043 47.6407V47.515L173.128 47.3042L173.212 46.9259L173.17 46.757H173.087V46.7151L173.296 46.4205L173.254 46.3354L173.212 46.2935L173.17 46.2097L172.96 46.1678L172.834 46.2097H172.792L172.749 46.1678L172.665 46.2516L172.623 46.2097L172.581 45.9989L172.623 45.8314L172.665 45.7882L172.707 45.7463H172.792H172.96L173.087 45.7044L173.17 45.7463H173.212H173.254L173.296 45.7044V45.6625L173.338 45.6206H173.381L173.507 45.5787L173.591 45.4936L173.634 45.4098V45.326L173.591 45.2841V45.2409V45.1152L173.676 44.9882V44.9463L173.634 44.9044V44.8625L173.759 44.8207L173.676 44.4423V44.3572L173.591 44.2734L173.549 44.2315L173.465 44.1464L173.718 43.9369V43.8937L173.591 43.8099L173.759 43.6843L173.801 43.5154L173.843 43.4735L173.886 43.3478L173.928 43.2627V43.2208L173.759 43.2627V43.2208V43.0951H173.634L173.549 42.8843L173.718 42.7154L173.634 42.5479L173.759 42.4209L173.886 42.379H173.928V42.4209L174.096 42.379V42.1263L174.138 42.0844V42.1682L174.181 42.1263V42.0425L174.223 41.9587H174.265V42.0006V42.0844L174.349 42.2101V42.1682L174.307 42.0844V41.9587V41.8736L174.349 41.7898H174.391L174.476 41.6209V41.6628V41.579V41.5371H174.518L174.559 41.579V41.6628H174.601V41.4953V41.4534L174.643 41.4953V41.4102H174.812V41.4953H174.728V41.5371L174.77 41.4953L174.812 41.5371V41.6209H174.854V41.6628L174.77 41.706V41.6628H174.685H174.643H174.77V41.7898H174.728L174.685 41.8736L174.728 41.8317L174.812 41.7898H174.854V41.7479V41.7898V41.9155V41.9587H174.728L174.643 42.0006L174.685 42.0425L174.643 42.0844L174.601 42.1263L174.685 42.0844V42.1263V42.1682L174.728 42.1263L174.685 42.0844L174.728 42.0006H174.812V42.0425L174.854 42.0006H174.938L174.896 42.0844V42.1263H174.938L174.896 42.2101V42.3371L174.854 42.379L174.896 42.4209L174.854 42.5898L174.896 42.6317L174.938 42.5898L174.981 42.379V42.3371L175.149 42.0006L175.19 42.0425L175.149 42.0006L175.232 41.8317H175.276V41.7898L175.359 41.7479H175.317H175.276V41.706L175.401 41.579H175.443L175.401 41.5371L175.359 41.4953L175.401 41.4534L175.527 41.4102H175.485H175.527H175.57H175.527L175.57 41.4534L175.612 41.6628L175.57 41.7479V41.706V41.7479L175.485 41.8317V41.8736V41.9155L175.317 41.9587V42.0006L175.149 42.1682V42.2101L175.107 42.2533H175.149H175.19L175.149 42.3371H175.107V42.379L175.19 42.3371V42.2101L175.276 42.0844L175.359 42.0425H175.401L175.443 42.0844V42.1263L175.401 42.1682H175.359L175.317 42.2101H175.359V42.2533H175.276V42.2952L175.359 42.2533L175.401 42.2101L175.443 42.1682V42.2101L175.359 42.3371L175.443 42.2952L175.401 42.379L175.359 42.4209L175.317 42.4628L175.232 42.5479H175.149L175.232 42.5898V42.6317H175.149H175.107H175.149H175.19L175.149 42.7154L175.19 42.7573V42.7154V42.6735L175.232 42.6317V42.5898L175.276 42.5479H175.401L175.527 42.4628V42.5047L175.401 42.5898V42.6735L175.443 42.6317L175.527 42.5047V42.5898L175.317 42.7573V42.7992H175.485L175.443 42.8424L175.401 42.8843L175.443 42.9262V42.8424L175.485 42.7992L175.57 42.5898L175.612 42.379V42.3371L175.696 42.4209L175.738 42.5047L175.696 42.6317L175.654 42.7154L175.738 42.5047L175.654 42.2533L175.738 42.1682L175.823 42.1263L175.865 42.1682V42.2101L175.907 42.1682L175.865 42.2533L175.823 42.2952L175.78 42.4209V42.4628L175.865 42.5479L175.725 42.7573H175.738V42.7901L175.78 42.7573V42.7154H175.823H175.865L175.823 42.6735L175.865 42.5898L175.907 42.6317L175.865 42.7154H175.907L175.948 42.7992L175.823 42.8843L175.738 42.8424V42.8843L175.78 42.8424L175.865 42.8843L175.948 42.8424V42.8843L175.99 42.8424H175.948L175.907 42.6735L175.99 42.5047L176.032 42.3371V42.2952H176.074V42.3371V42.379L176.159 42.2101V42.1263H176.201V42.0844L176.243 42.0425L176.285 42.0006L176.201 41.9587L176.37 41.9155H176.496L176.538 41.9587L176.58 42.0006V42.0425H176.538L176.496 42.1263V42.0844V42.1263H176.454V42.1682L176.37 42.2533L176.327 42.3371L176.285 42.379V42.4628H176.243L176.285 42.5479L176.201 42.6317H176.159H176.201L176.243 42.5898H176.327L176.37 42.7154L176.454 42.8424V42.9262L176.412 43.01L176.454 43.0951H176.327L176.285 43.1789L176.243 43.3046L176.285 43.3478V43.3046L176.327 43.2208V43.137H176.37H176.412L176.454 43.0951L176.496 43.137V43.2627L176.58 43.3046L176.412 43.3897L176.37 43.4316H176.327V43.5154H176.243L176.201 43.5573L176.117 43.4735H176.159L176.117 43.5154H176.159L176.201 43.5573L176.243 43.5154H176.327L176.37 43.4735L176.454 43.3897L176.58 43.3478L176.621 43.3046L176.58 43.2627L176.538 43.2208V43.1789L176.58 43.137L176.621 43.0951L176.58 43.01V43.0951L176.538 43.137V43.0951L176.496 43.0519V42.9681L176.538 43.01H176.58L176.538 42.9681V42.8424L176.707 42.7154L176.748 42.8424V42.7992L176.832 42.6735H176.79V42.7154H176.748V42.6735H176.79H176.832V42.4209V42.2533L176.874 42.1263V42.0425L176.917 41.9587L176.959 42.0006V41.9587V41.9155H176.874L176.917 41.8736L176.959 41.8317L177.001 41.9155H177.043V42.0006V42.1682V42.2101L177.001 42.2533V42.2101L176.917 42.3371L176.874 42.5047V42.5898H176.917V42.6317V42.7154V42.7573L176.832 42.8424V42.9681V43.01V43.0519V43.0951V43.137L176.79 43.0951L176.832 43.2208H176.874V43.137V43.0951V43.137L176.917 43.1789L176.874 43.2627V43.3478L176.79 43.3897L176.832 43.4316H176.79H176.748H176.707H176.748V43.3949L176.454 43.4316V43.3897L176.412 43.5992L176.327 43.6843L176.285 43.768L176.327 43.6843L176.412 43.6424L176.454 43.5992L176.496 43.6424H176.538L176.454 43.5573V43.5154L176.496 43.4735H176.621L176.58 43.5154L176.665 43.4735H176.832L176.874 43.4316L176.959 43.3046V43.2208V43.1789L176.917 43.0951L176.959 42.8843L177.001 42.8424L177.127 42.7992V42.8424V42.7992L177.169 42.7573L177.212 42.7992L177.169 42.8424L177.212 42.8843L177.127 43.01H177.085L177.043 43.0519H177.001H177.043L177.085 43.01H177.127V43.2208L177.085 43.2627H177.043L177.001 43.3046H177.043V43.2627L177.085 43.3046L177.127 43.2208L177.169 43.2627V43.3046L177.212 43.3478L177.169 43.3046V43.2627L177.127 43.2208L177.169 43.1789L177.127 43.0951L177.169 43.01L177.254 42.8843L177.338 42.8424V42.8843L177.296 42.9262L177.465 42.7992H177.506L177.465 42.9681L177.379 42.9262L177.338 42.9681H177.379L177.421 43.01V43.0519L177.338 43.0951V43.137L177.296 43.2208H177.212V43.2627L177.254 43.2208H177.338L177.379 43.0951L177.465 43.0519V43.0951V43.137H177.506L177.465 43.1789L177.421 43.2208L177.379 43.1789L177.296 43.2208V43.3046L177.338 43.3478L177.296 43.3897L177.254 43.5154L177.296 43.4316L177.379 43.3478L177.338 43.2627V43.2208H177.379L177.421 43.2627H177.465L177.548 43.1789V43.0951L177.59 43.01L177.674 42.9681L177.632 43.0519V43.0951V43.137L177.59 43.2208L177.548 43.3046L177.506 43.3478L177.548 43.3046L177.59 43.2627V43.3478L177.548 43.3897V43.4316L177.421 43.4735H177.548L177.59 43.3897V43.4316L177.632 43.5154L177.506 43.6843L177.548 43.7262V43.6843L177.59 43.6424H177.632L177.716 43.5992H177.674L177.759 43.4316L177.801 43.3897V43.4316L177.885 43.3478V43.3046L177.843 43.3478L177.759 43.3897V43.3478L177.843 43.2627L177.885 43.3046V43.1789V43.137H177.969H178.012V43.0951H178.054V43.0519H178.012L178.054 43.01L178.221 42.9681L178.306 43.0951L178.263 43.2208L178.221 43.3046L178.179 43.3478L178.096 43.2208L178.137 43.3046V43.3478H178.096V43.3897L178.012 43.4316V43.3478V43.4316H177.969L177.885 43.4735V43.5992L177.801 43.768L177.843 43.8099V43.8937H177.801L177.759 43.8518L177.843 43.9788V44.0207L177.759 44.1464H177.843L177.885 44.2315L177.843 44.3153L177.885 44.2734H177.969V44.3991L177.927 44.4842L177.843 44.4423L177.801 44.5261L177.759 44.4842L177.801 44.5261V44.568V44.5261L177.843 44.4842L178.012 44.568V44.5261H177.969L178.012 44.4423V44.3153L177.927 44.1896V44.1464L178.012 44.0626V43.9788L178.137 43.8099H178.179V43.768L178.221 43.8099L178.179 43.8937V44.0207L178.137 44.0626L178.179 44.1045L178.221 44.1896L178.263 44.2315L178.137 44.0626L178.221 44.0207V43.9369L178.263 43.8937L178.306 43.9369V43.9788H178.263V44.0207L178.306 44.0626L178.263 44.0207V43.9788L178.306 44.0207L178.348 43.9788L178.263 43.8937L178.306 43.8099L178.348 43.768L178.39 43.8099H178.432L178.474 43.8518V43.8937L178.516 43.8518H178.558L178.516 43.8099H178.39L178.348 43.7262L178.432 43.6424L178.516 43.5992V43.5573L178.601 43.5992H178.558V43.6843V43.5992H178.643L178.601 43.5573L178.516 43.5154H178.474L178.516 43.5992H178.474V43.5154V43.4735V43.4316L178.558 43.3897L178.601 43.3046L178.685 43.3478H178.601V43.3897L178.685 43.3478L178.727 43.4316L178.685 43.3897L178.727 43.3478L178.685 43.3897L178.727 43.3478L178.685 43.3046V43.2627L178.558 43.1789V43.137L178.643 43.0951L178.81 43.137L178.854 43.2208V43.2627V43.3046L178.896 43.2627V43.3046V43.4316V43.4735V43.5573V43.6424V43.4735H178.937L178.979 43.8099H178.937H178.896V43.8518L178.854 43.8937V43.9369H178.769L178.601 44.0207L178.432 44.1045V44.1464L178.39 44.1896V44.2734L178.432 44.3991H178.474H178.432L178.39 44.1896H178.432L178.516 44.1045H178.601H178.643V44.2315L178.558 44.2734V44.3572L178.516 44.4423V44.4842L178.474 44.568V44.6099L178.432 44.568L178.39 44.5261L178.348 44.568V44.7369H178.306V44.7788L178.348 44.7369L178.39 44.568H178.432L178.474 44.6099L178.516 44.568V44.5261V44.4423L178.601 44.3572V44.3153L178.643 44.2315L178.685 44.1464L178.727 44.1896L178.769 44.2315L178.727 44.3153H178.685L178.769 44.3572V44.3991V44.3572V44.1464L178.854 44.1896L178.937 44.2734L178.854 44.3991V44.4842L178.81 44.568V44.6518L178.769 44.6937L178.685 44.8625V44.9044L178.643 44.9463L178.685 45.0733V45.1152L178.601 45.0314L178.558 45.0733H178.516L178.558 45.1152L178.601 45.0314L178.685 45.1152L178.558 45.3679V45.4098H178.474L178.432 45.4517H178.348V45.5368H178.306L178.263 45.6206L178.306 45.5368H178.348L178.39 45.4517L178.432 45.4936L178.474 45.4517L178.516 45.4098L178.432 45.5368L178.474 45.5787L178.39 45.6625L178.474 45.5787V45.4936L178.516 45.4517H178.558L178.516 45.6625L178.558 45.7463L178.601 45.8314V45.7882H178.685V45.6625V45.4936L178.727 45.4517L178.81 45.199V44.9882L178.854 44.9463L178.979 44.9044L179.063 45.0314V45.0733L179.106 45.0314L179.148 45.1152L179.232 45.0733V45.0314L179.19 44.9044L179.232 44.8625V44.8207V44.7788L179.316 44.6518V44.6099L179.485 44.4842L179.568 44.3991H179.61L179.652 44.4423L179.695 44.3572H179.737L179.695 44.2734L179.737 44.2315H179.779V44.1896L179.821 44.1045V44.0626H179.863V44.1045L179.905 44.0626H179.948V44.1045V44.1464H179.905L179.948 44.1896V44.2315V44.2734V44.2315V44.1896L179.905 44.2315L179.948 44.3153L179.99 44.3572L179.863 44.4423H179.905L179.99 44.3572V44.4842V44.568L180.032 44.6099H180.074H180.116L180.074 44.568L180.032 44.6099L179.99 44.568V44.4842L180.032 44.3991L179.99 44.2734V44.1464V44.0626L180.032 44.0207V43.9369L180.074 43.8937L180.116 43.768L180.158 43.7262L180.116 43.6424V43.6843V43.6424V43.6411L180.074 43.5992H180.095L180.074 43.5573L180.116 43.4735V43.4316H180.158L180.199 43.4735L180.158 43.5573L180.199 43.5992L180.158 43.6424L180.116 43.8518L180.199 44.0207L180.158 44.1045L180.116 44.1896V44.2315V44.2734H180.158H180.199V44.3153L180.158 44.3991H180.199V44.3153H180.243H180.199V44.2734L180.158 44.2315V44.1896L180.199 44.1464L180.285 44.1896L180.326 44.1464L180.199 44.1045L180.243 43.9788L180.326 44.0626V44.1045V44.1464L180.285 44.1896L180.199 44.2315L180.285 44.1896V44.2315L180.368 44.1464V44.0207L180.285 43.9369L180.243 43.8937V43.8518V43.8099L180.285 43.768V43.9369L180.326 43.8099L180.368 43.8518L180.41 43.9369L180.368 43.8937L180.326 43.9369H180.368L180.326 43.9788V44.0207L180.368 43.9788V44.0207V44.2315V44.3153L180.285 44.4423L180.368 44.3572L180.41 44.2315L180.368 44.1896L180.452 44.1464L180.537 44.2315V44.3153V44.2315H180.663L180.705 44.1896H180.747L180.79 44.2315L180.874 44.3153H180.958L180.999 44.3991H181.043L180.999 44.3153V44.2734L181.043 44.1896L181.126 44.1464L181.168 44.2315H181.085V44.2734V44.3572L181.126 44.3991L181.085 44.3153L181.126 44.2734L181.168 44.3572H181.252H181.168L181.126 44.2734L181.379 44.2315H181.337H181.252V44.1896L181.294 44.1464L181.421 43.9788L181.505 43.9369L181.59 44.0207L181.547 43.8937L181.632 43.9788L181.59 43.8937V43.8518H181.674H181.632L181.59 43.8099L181.674 43.768L181.757 43.8099V43.768H181.716H181.841H181.799H181.884H181.926L181.968 43.8518L181.884 43.8937V43.8518L181.799 43.9788L181.841 44.2315L181.757 44.1896V44.0207L181.716 44.1045V44.2315L181.59 44.1896H181.463H181.547L181.674 44.2734H181.716H181.674H181.59H181.547L181.632 44.3153L181.59 44.3572L181.547 44.3991L181.463 44.4423H181.547L181.505 44.5261V44.568L181.421 44.6099H181.337L181.379 44.6937L181.337 44.7788L181.379 44.8625V44.9882L181.421 45.0314V44.9882H181.505L181.59 44.9463L181.674 45.0314L181.716 45.1152V45.0733L181.841 44.9044V44.7788H181.884L182.01 44.9044V44.9882L182.052 45.0733L182.01 45.1152H182.052L182.094 45.0733L182.01 44.9463H182.052L182.179 45.1152L182.136 45.199L182.01 45.326L182.136 45.2841L182.179 45.1571V45.0733L182.136 45.0314L182.094 44.8625V44.8207H182.179L182.136 44.7788H182.179V44.8207L182.221 44.7788L182.263 44.6937V44.8625L182.221 45.0314H182.263V45.1152L182.305 45.0733L182.347 45.0314L182.221 44.9882L182.305 44.9463L182.388 45.0314L182.347 44.9044V44.8625L182.515 44.7369L182.557 44.6937H182.599L182.641 44.7369V44.6937V44.6518V44.8207L182.515 44.9463V45.0314V45.0733H182.432H182.515L182.557 44.9882L182.641 44.9044V44.8625H182.684V44.8207V44.8625V44.9044H182.641L182.684 44.9463L182.726 44.7788L182.768 44.6937L182.81 44.7369L182.852 44.8207V44.8625L182.894 44.9044L182.936 45.0314L182.979 45.1152V45.2409L182.894 45.3679L182.852 45.326L182.81 45.2409L182.768 45.2841L182.726 45.2409V45.2841H182.641V45.199L182.599 45.2841H182.388L182.347 45.2409H182.305H182.347L182.388 45.326L182.305 45.4517H182.263L182.221 45.4936L182.136 45.4098L182.052 45.4936L182.136 45.4098V45.4936H182.179V45.5368H182.136L182.052 45.6206H182.01V45.6625H182.094L182.136 45.7044H182.094H182.136L182.179 45.7463L182.305 45.7882L182.221 45.8733H182.094V45.9152L182.136 45.8733L182.221 45.9152L182.305 45.8733V45.7882V45.7463H182.221L182.179 45.7044V45.6625H182.305L182.347 45.7044L182.432 45.7463H182.557L182.599 45.7044H182.641V45.8314H182.599L182.557 45.9152H182.515H182.474H182.432H182.474L182.515 45.957L182.347 46.0827L182.305 46.1259L182.136 46.1678H182.094L182.052 46.2516H182.01H181.968H181.926L181.968 46.2935L182.01 46.2516V46.2935H181.926L181.884 46.3786H181.799L181.716 46.4205L181.884 46.3786L181.926 46.3354H182.01L182.094 46.2097H182.221L182.515 46.1259V46.1678L182.474 46.2516L182.388 46.2935H182.305L182.263 46.3354L182.347 46.2935H182.388L182.557 46.1678V46.2516H182.641H182.557L182.599 46.1678L182.641 46.0408H182.726L182.852 45.9989L182.894 45.8733L182.936 45.9152V45.9989L182.894 46.0408L182.852 46.2097H182.81H182.726V46.2516H182.684V46.3786L182.768 46.2097L182.81 46.2516L182.852 46.2097L182.894 46.0827L182.979 45.9989V46.0408L182.936 46.1259L182.979 46.1678L182.936 46.1259L182.979 45.9989L182.936 45.9152V45.8733H182.979V45.8314H183.021L182.936 45.7882V45.7044L183.021 45.7463H183.147L183.315 45.8733L183.274 45.9152L183.23 45.8733L183.063 46.1259L183.021 46.2097L183.105 46.3786L183.063 46.4205L183.147 46.3786L183.188 46.3354H183.147V46.2097V46.1678L183.315 46.0408L183.399 46.0827V46.1259L183.23 46.2097L183.274 46.2935L183.23 46.3354H183.188L183.274 46.4624V46.5043V46.5462L183.357 46.6313L183.441 46.5881L183.526 46.5043L183.568 46.4205L183.61 46.3786L183.694 46.4624V46.5462L183.568 46.6732L183.441 46.757H183.399L183.315 46.8408H183.274L183.23 46.8827L183.274 46.8408L183.315 46.8827L183.357 46.8408H183.399H183.441V46.8827V46.9259V46.9678L183.483 47.0097V46.9678L183.441 46.8827L183.61 46.7989V46.8827L183.652 46.8408V46.8827L183.694 46.9259V46.8827V46.757H183.736L183.779 46.7989L183.863 47.0515L183.905 47.0934L183.946 47.1353V47.3042L183.863 47.2623V47.1772L183.821 47.2204L183.779 47.1772L183.736 47.2204V47.2623L183.779 47.2204L183.821 47.2623L183.946 47.3461L183.905 47.4299L183.946 47.388H183.988V47.515L183.905 47.5569L183.988 47.6407H184.03L184.073 47.5988V47.6407L184.03 47.7677L183.905 47.8096L183.863 47.8515V48.146V48.3987L183.946 48.3568L184.073 48.3987L184.115 48.4406L184.283 48.5676L184.325 48.6514H184.283L184.241 48.7352L184.283 48.6933H184.325H184.368L184.452 48.819L184.536 48.8622L184.452 48.9041V48.946H184.41V48.9041V48.946V48.9879L184.494 48.946V48.9041L184.536 48.946V49.0717L184.621 49.2824L184.577 49.2405L184.536 49.3243L184.577 49.2824H184.663L184.788 49.577L184.746 49.6189L184.788 49.6621L184.746 49.704L184.704 49.7459L184.663 49.7878L184.621 49.7459L184.494 49.7878H184.621L184.704 49.8716V49.9135L184.663 49.9986L184.577 50.1243L184.494 50.1662V50.1243H184.452H184.41L184.663 50.4188H184.704L184.957 50.7134L185.041 50.6715L185.083 50.6296L185.168 50.5877H185.336H185.377L185.588 50.5458L185.63 50.5039L185.799 50.4607L185.883 50.4188L185.968 50.3769L186.052 50.335L186.135 50.2932L186.094 50.2513H186.177V50.2094L186.304 50.1662V50.2094V50.1662L186.346 50.1243L186.388 50.1662V50.1243L186.43 50.1662H186.388L186.43 50.2094L186.472 50.1662V50.2094L186.514 50.1662L186.472 50.1243H186.388V50.0824H186.557L186.81 50.1243V50.0824L186.852 50.0405V50.0824L186.81 50.1243L186.852 50.335V50.3769H186.81L186.766 50.335V50.3769H186.725L186.683 50.2932L186.641 50.2513L186.683 50.2932V50.335H186.599V50.2932L186.557 50.335L186.514 50.2932V50.335H186.599L186.557 50.3769L186.388 50.4188L186.346 50.4607L186.262 50.5039H186.304L186.388 50.4607V50.4188L186.472 50.4607H186.599H186.514L186.557 50.5039L186.599 50.5877L186.641 50.4607H186.766L187.104 50.5039L187.23 50.5877L187.104 51.008L186.977 51.2188L187.104 51.1769L187.23 50.9661L187.441 50.7566L187.608 50.4607L187.652 50.2932L187.819 50.0824L187.861 49.9986L188.072 49.8297L188.283 49.704H188.324V49.7459H188.366L188.408 49.7878L188.493 49.8297L188.535 49.8716L188.451 49.7878L188.661 49.3243L188.746 49.2824L189.041 49.1568L189.25 48.946L189.377 48.9041L189.546 48.9879L189.672 49.0717L189.966 49.704L190.05 49.8297L190.135 49.8716L190.177 49.7878L190.388 49.6621L190.472 49.6189H190.682L190.808 49.577H190.85V49.6189H190.892L191.061 49.6621H191.103H191.313L192.03 49.8716L192.155 49.9567L192.534 50.1243L193.081 50.4188L193.25 50.5039L193.502 50.5877L194.133 50.9242L194.47 51.0931H194.681L194.597 51.135H194.639H194.723L194.766 51.0931L194.723 51.008L194.681 51.0512V51.008L194.723 50.9661L194.808 51.135V51.1769V51.2188L194.891 51.2607H195.06L195.102 51.4295L195.06 51.4714L195.017 51.5984L195.102 51.6403L195.06 51.5984L195.144 51.4714L195.102 51.2607L195.017 51.1769L194.933 51.2188L194.891 51.1769V51.135H194.975V51.0931H194.933L194.891 51.0512L194.808 51.0931L194.766 51.0512L194.808 51.008H194.85L194.975 51.0512L195.397 51.5133L195.691 51.7241L195.86 51.8511H195.986V51.893L196.239 51.8511L196.364 52.0187L196.406 52.0606L196.364 51.9349H196.449L196.702 52.0187L197.08 52.0606L197.333 51.9349L197.375 51.893H197.417L197.501 51.9349H197.67H197.753L197.922 51.766H197.964H198.006V51.893L198.049 51.9768V51.9349H198.006L198.049 51.893L198.386 51.9349H198.68L198.848 51.893H198.975H199.059V51.9349H199.017V51.9768L199.186 52.2714L199.228 52.3552L199.269 52.2714L199.311 52.1876L199.269 52.1025L199.353 52.0606L199.522 52.1025H199.606H199.648H199.9H199.942H200.027H200.237H200.49V52.1457L200.448 52.1025L200.533 52.2295L200.448 52.3133L200.322 52.4403V52.6497L200.364 52.7348V52.7767L200.237 52.8186V52.9456L200.195 53.1132L200.28 53.197L200.364 53.324L200.406 53.3659L200.575 53.4916L200.617 53.5348L200.659 53.6604L200.533 53.7874V53.8293L200.49 54.0401L200.406 54.082L200.237 54.2077L200.195 54.2915L200.069 54.4604L199.986 54.5023L199.9 54.5442L199.859 54.5861V54.6293V54.7549L199.775 54.8387V54.8806V55.0914H199.733L199.648 55.0495H199.606L199.564 55.1333L199.522 55.2603V55.3022H199.48L199.395 55.4292L199.311 55.4711H199.186L198.975 55.513L198.891 55.5549H198.68L198.595 55.6387L198.553 55.6806V55.7657H198.722H198.764V55.8076V55.8494V55.8913H198.68L198.638 55.9332L198.595 56.0183V56.1021V56.144L198.511 56.1859L198.428 56.3548L198.217 56.3967V56.4386L198.133 56.4805L198.175 56.6075L198.133 56.6913V56.6494L198.091 56.6913L197.88 56.6494L197.67 56.7332L197.586 56.7751H197.544L197.375 56.6913L197.333 56.6494L197.164 56.7751H197.08L196.955 56.7332V56.8183L196.912 56.9021L196.828 56.9439L196.786 56.9021V56.8183H196.744H196.702L196.617 56.9439L196.533 56.9858H196.491H196.449L196.364 56.9021V56.7751H196.322L196.281 56.7332L196.239 56.8183V56.9439L196.112 57.0277L196.07 57.1128V57.1547V57.1966V57.2385L195.902 57.4493L195.817 57.5331L195.733 57.575L195.608 57.6601L195.564 57.7858V57.8277L195.522 57.9128H195.439L195.312 58.0803L195.186 58.2073L195.144 58.2911V58.333V58.3749L195.228 58.5438V58.6276L195.186 58.7127L195.144 58.7546L195.186 58.8803L195.228 58.9641L195.186 59.0073L195.144 59.0492L194.891 59.4694V59.5545V59.5964V59.7221L194.808 59.8059L194.513 60.0167L194.47 60.1437L194.428 60.2693H194.386L194.344 60.2274H194.26L194.175 60.4801L194.133 60.522L194.05 60.7747V60.9004L193.966 60.9855L193.839 61.0274L193.797 61.0693L193.755 61.1531L193.881 61.2382V61.2801H193.628L193.586 61.3219L193.544 61.3638L193.292 61.6584L193.25 61.7854V61.9111L193.292 62.1219V62.2057L193.419 62.4164V62.5421V62.711V62.7529H193.502L193.586 62.711H193.628V62.7529L193.881 62.9218L193.966 63.0056L193.923 63.1745L193.966 63.2583L194.092 63.3421V63.384V63.4272V63.4691H194.05V63.5947L193.966 63.7217L194.008 63.8893V63.9325L193.966 64.0163L193.923 64.1001L193.713 64.3947L193.671 64.4366V64.4785L193.586 64.5217L193.502 64.6054L193.46 64.6892L193.502 64.7743L193.544 64.8162L193.671 64.9V64.9838L193.628 65.0689L193.502 65.1946V65.3216L193.544 65.4473H193.586L193.797 65.6581L193.839 65.7837V65.9526V65.9945L194.008 66.1634V66.2053L194.092 66.2891L194.05 66.4999V66.5837L194.175 66.8782V67.0471V67.1309H194.217L194.302 67.2579L194.344 67.5106L194.386 67.6363L194.428 67.8471V67.9727L194.26 68.1835V68.2673L194.344 68.4781V68.52V68.6051L194.302 68.8146L194.26 68.8997L194.175 68.9416L194.008 69.0253V69.1091L193.923 69.151L193.755 69.1942L193.713 69.2361L193.671 69.4037L193.586 69.4888L193.419 69.5307L193.375 69.5726L193.333 69.7415V69.7834L193.208 69.9091L193.166 70.1617L193.039 70.2455L192.997 70.3725L192.955 70.4563H192.871L192.661 70.4982L192.619 70.5833L192.577 70.6252V70.709L192.619 70.7509L192.661 70.7941V70.836L192.619 71.0455L192.702 71.34V71.4251H192.577V71.467L192.534 71.5508L192.577 71.7616L192.619 71.8454L192.577 71.9724L192.702 72.2251L192.577 72.4345V72.5196L192.619 72.5615L192.661 72.7304V72.8142L192.744 72.898L192.828 72.9818L192.871 73.025V73.1507V73.1926L192.828 73.2345V73.2777L192.744 73.3196L192.702 73.3615V73.4033L192.828 73.529L192.871 73.6979L192.955 73.7817H193.124L193.208 73.8249L193.292 73.8668V73.9087L193.333 74.1614L193.375 74.2033L193.46 74.2871H193.586L193.713 74.456L193.839 74.4978L193.966 74.5397H194.008V74.5816L194.05 74.6667L194.092 74.7086V74.7924L194.133 74.8762L194.092 75.0451L194.05 75.1708L194.092 75.214L194.175 75.1708L194.217 75.214V75.2559L194.092 75.3816L194.05 75.4235V75.5505L193.923 75.7612V75.8031L194.008 75.9288L193.966 76.0558L194.008 76.1815L193.923 76.2234L193.881 76.2653V76.3085L193.966 76.3504L193.881 76.518V76.645V76.7287L193.755 76.8976L193.713 77.1503V77.1922V77.2341L193.671 77.3598L193.502 77.5706L193.292 77.6544L193.25 77.8232L193.166 77.907H193.124L192.955 77.9489H192.871L192.786 77.8651H192.661L192.534 77.9921L192.366 78.0759H192.281H192.239L192.113 77.9921L191.903 77.9489L191.65 77.9921H191.608L191.566 78.0759L191.439 78.1597L191.271 78.2016L191.019 78.1597L190.935 78.3286L190.766 78.2867V78.4124H190.724L190.639 78.4543H190.555L190.43 78.4124L190.345 78.4543V78.4975L190.177 78.4124L190.135 78.3286L190.093 78.2448L190.05 78.2016L189.841 78.1178L189.797 78.0759L189.755 77.9489V77.907L189.714 77.8651H189.672H189.63V77.907H189.588H189.546L189.461 77.8232L189.335 77.7814L189.208 77.6544L189.082 77.6125L188.999 77.5706L188.83 77.6125L188.788 77.5706V77.5287H188.746L188.661 77.5706H188.493H188.451L188.366 77.6544L188.241 77.5706L188.199 77.6125L188.156 77.6544L188.114 77.7395L187.904 77.7814L187.735 77.907L187.525 77.8651L187.483 77.907L187.441 77.9921H187.399L187.314 77.9489V77.8651L187.23 77.8232H187.146L187.061 77.907L186.766 77.9489L186.725 77.9921H186.641L186.599 78.0759V78.2448L186.557 78.3286H186.514L186.43 78.2016H186.304H186.262V78.2448V78.2867L186.388 78.4543L186.346 78.5394H186.304H186.262V78.4124H186.219L186.177 78.4543L186.135 78.5813L185.968 78.6651L185.883 78.7921V78.834V78.9596V79.0015H185.799L185.715 79.0434V79.2123L185.504 79.465H185.419H185.336V79.592L185.294 79.6758L185.252 79.7596L185.294 79.8866V79.9285L185.21 80.0122L185.083 80.223H185.041L184.915 80.1379L184.704 80.223H184.621L184.494 80.2649L184.41 80.3487L184.283 80.4757L184.115 80.5176L183.946 80.6014V80.6433H183.863L183.779 80.7284L183.736 80.896H183.694L183.483 80.9379L183.441 81.0649L183.399 81.1067L183.274 81.1905V81.2324L183.147 81.4432L183.021 81.4851L182.979 81.5283L182.894 81.5702H182.852L182.81 81.7378L182.768 81.781L182.726 81.9905H182.641H182.599H182.557L182.474 81.9486L182.388 81.781L182.136 81.8648L182.094 81.8229L181.926 81.781L181.884 81.8648L181.716 81.9486L181.674 81.9905V82.0324L181.632 82.0756L181.59 82.1594L181.505 82.2012L181.421 82.1594L181.379 82.2012L181.337 82.285L181.294 82.3701L181.252 82.4539L181.21 82.4958L181.168 82.4539L181.043 82.4958L180.958 82.5377H180.874H180.832L180.747 82.6228H180.663L180.495 82.7485L180.41 82.7066H180.368L180.243 82.6647L179.99 82.7485L179.948 82.7904H179.863L179.821 82.7485L179.695 82.8323L179.652 82.9593L179.527 83.0012L179.443 83.085H179.401V83.0431L179.316 83.0012H179.274L179.232 83.0431L179.148 83.1269L179.021 83.085L178.937 83.1269H178.896H178.769L178.685 83.1701L178.643 83.2539L178.474 83.4214L178.39 83.3795H178.348L178.306 83.4646V83.5484L178.263 83.5903H178.221V83.6322L178.179 83.6741H178.096L178.054 83.7173L178.096 83.8011H178.054L177.969 83.7592H177.927V83.8011L178.012 83.843L177.927 83.8849H177.885V83.9687V84.0119L177.801 84.0538L177.759 84.1376L177.801 84.2214V84.2646H177.759V84.2214L177.716 84.2646L177.759 84.3484L177.716 84.4321L177.759 84.474L177.716 84.5159L177.674 84.474V84.5591L177.59 84.601L177.632 84.7267L177.59 84.8118L177.506 84.8537V84.9375L177.465 84.9794H177.421L177.465 85.0632L177.548 85.1064V85.1483L177.421 85.1902L177.548 85.274V85.3159L177.465 85.3591H177.421V85.401V85.4847L177.379 85.5266L177.338 85.5685L177.379 85.6104V85.6536L177.338 85.6955L177.254 85.8212L177.379 85.9063V85.9482H177.338H177.296L177.212 86.032L177.296 86.1577L177.254 86.2009V86.3266L177.169 86.4955L177.212 86.5792L177.169 86.663L177.127 86.7481L177.169 86.8738L177.127 86.9576H177.043L177.001 87.0427L176.959 87.0846L177.001 87.1684L176.665 87.463V87.7156L176.58 87.7994V87.9264L176.496 88.0102V88.1372V88.1791L176.412 88.221L176.454 88.3048L176.412 88.3467H176.37L176.285 88.3899L176.327 88.4318L176.243 88.4737V88.5156V88.5575V88.5994L176.201 88.6845L176.159 88.7264L176.201 88.8939L176.159 89.0209L176.201 89.0628L176.117 89.1885L176.074 89.2317L176.117 89.3155L176.074 89.3574V89.4412L176.032 89.4844L175.865 89.6101V89.652L176.032 89.7358L175.948 89.8209L175.823 89.779V89.8209H175.78L175.738 89.9046L175.696 90.0303L175.738 90.0735L175.696 90.1154L175.57 90.41H175.485L175.401 90.4519L175.443 90.5357H175.359L175.276 90.5789L175.232 90.7465L175.149 90.7046L175.023 90.8303H174.981V90.8735L174.938 90.9573L174.854 90.9991L174.812 91.0829L174.854 91.1248L174.938 91.168V91.2099L174.896 91.2518H174.854L174.812 91.2937L174.77 91.3775L174.728 91.4207L174.77 91.4626L174.685 91.5045V91.5464V91.6302V91.6734V91.7153L174.601 91.7991L174.643 91.8829L174.685 92.0099V92.0518L174.77 92.1355L174.812 92.2625L174.938 92.3463V92.4301L174.981 92.5152L174.938 92.599L174.981 92.6409L175.023 92.6828V92.7679V92.8098H175.065V92.8936H175.023V92.9774V93.1463L175.065 93.1881L175.107 93.3138L175.149 93.357L175.232 93.4408L175.19 93.4827H175.149L175.19 93.6097V93.7354H175.232L175.19 93.8624V93.9462L175.232 94.03V94.1138H175.149V94.157L175.19 94.2408V94.2826H175.232V94.3664H175.276L175.232 94.4515L175.276 94.4934L175.317 94.4515L175.359 94.4934L175.443 94.5353H175.527L175.57 94.5772L175.654 94.661L175.696 94.7461L175.823 94.9137V94.9556V95.0407H175.865L175.823 95.0826H175.865V95.1245L175.907 95.1664L175.865 95.2083H175.907L175.865 95.2515L175.907 95.3353L175.823 95.3771V95.419L175.738 95.4609L175.696 95.5879V95.6298L175.612 95.6717L175.654 95.7555L175.57 95.8406V95.9244L175.612 96.0082L175.57 96.0501L175.612 96.0933L175.654 96.1352L175.696 96.219V96.2609H175.654V96.3028L175.612 96.4298L175.654 96.5973L175.57 96.7243L175.654 96.7662L175.612 96.8081L175.654 96.85V96.8932L175.696 96.977L175.654 97.0189L175.696 97.1027V97.1446V97.1878L175.654 97.3135L175.57 97.3554L175.527 97.3973V97.4405L175.485 97.608V97.6499L175.401 97.7769V97.8188L175.443 97.8607V97.9026V98.0715L175.485 98.1134L175.527 98.1553L175.57 98.2823L175.527 98.3661V98.408L175.485 98.5337V98.6188L175.401 98.7025V98.7444L175.359 98.9133V98.9971H175.317L175.401 99.0822L175.317 99.3336L175.276 99.3768L175.232 99.5025L175.19 99.6282L175.107 99.6714V99.7133L175.065 99.7552L175.023 99.8808H174.981H174.896V99.9659L174.854 100.05L174.896 100.302L174.728 100.219L174.601 100.261L174.559 100.302L174.476 100.175L174.432 99.797L174.391 99.7552H174.349L174.265 99.797L173.97 100.008L173.718 99.9659L173.549 100.008L173.423 99.8389L173.381 99.797L173.338 99.7552L173.254 99.7133L173.087 99.7552L172.876 99.797H172.707L172.623 99.7552L172.539 99.8389L172.412 99.7552L172.287 99.7133L172.202 99.4187L171.992 99.166H171.949L171.823 99.1241L171.781 98.9971L171.739 98.9552V98.7444L171.612 98.5769L171.654 98.4918L171.612 98.3242L171.697 98.2391L171.612 98.1553V98.0296L171.654 97.9877V97.8607L171.529 97.8188V97.7769L171.612 97.735L171.529 97.6499H171.487L171.529 97.5243L171.445 97.4405L171.402 97.3554L171.234 97.4405H171.107L170.981 97.3973V97.3554L171.023 97.2297L171.065 97.1878L171.023 97.1027L170.898 97.0189H170.687H170.603V96.977L170.56 96.9351V96.85L170.518 96.6824L170.771 96.5135L170.812 96.4298V96.2609L170.898 96.1352V96.0082L170.981 95.9663L171.234 95.7987V95.7555L171.107 95.7136V95.6717L171.023 95.546V95.5028L171.107 95.419V95.3353L171.023 95.2934L170.898 95.3353L170.854 95.2515L170.771 95.2083H170.687L170.603 95.1245L170.56 95.0826V94.9988L170.603 94.9137L170.645 94.8718L170.518 94.8299L170.434 94.7461H170.392L170.265 94.788H170.098L170.013 94.8299L169.971 94.8718V94.9137L169.845 94.8718V94.8299L169.887 94.7042L169.803 94.5772L169.76 94.5353L169.718 94.4934L169.634 94.4083L169.55 94.2826V94.1989H169.508L169.381 94.2408L169.34 94.157V94.1138V94.0719L169.423 94.03V93.9881L169.465 93.9462L169.508 93.9043L169.423 93.7773L169.465 93.6935L169.508 93.6097L169.465 93.5246V93.4827L169.381 93.5246L169.298 93.4827V93.4408L169.34 93.3138L169.298 93.23L169.256 93.1881L169.087 93.1463H169.045V93.0625V93.0193L169.003 93.0625L168.961 93.1044H168.876H168.834L168.792 93.0193H168.834L168.792 92.9355L168.834 92.8936L168.792 92.8517H168.834L168.792 92.8098H168.834H168.876L168.918 92.7679L168.876 92.6828H168.75L168.54 92.7679L168.456 92.7247H168.371V92.7679H168.329H168.287L168.329 92.6828L168.245 92.7247L168.161 92.6828H168.076V92.7247L167.951 92.6409V92.599H168.034L167.992 92.5571H168.034V92.5152V92.472L168.119 92.4301V92.3882H168.076V92.3463L168.034 92.3882L167.951 92.3463L167.992 92.3044H168.119V92.2625L168.161 92.1774V92.1355V92.1774H168.245V92.1355L168.287 92.0936V92.0518L168.245 91.968L168.287 91.9248H168.329L168.414 91.8829V91.841L168.498 91.7991V91.7572L168.582 91.7153L168.54 91.6302H168.498L168.456 91.5883V91.5464L168.414 91.4626L168.498 91.4207H168.54H168.582L168.623 91.4626L168.665 91.4207L168.75 91.3356H168.876L168.918 91.2937L168.876 91.2518V91.2099H168.918L168.961 91.168L168.918 91.1248L168.961 91.0829V90.9573L169.003 90.9154L168.961 90.7884H168.918V90.7465H168.876V90.6627L168.834 90.6208L168.792 90.4938H168.834H168.876H168.918V90.3681L169.003 90.283H169.045L169.087 90.2411L169.045 90.1573L169.003 90.1154L169.045 90.0735H168.961L169.003 90.0303H168.961L168.876 89.9884L168.918 89.9465L168.876 89.9046L168.918 89.8628V89.8209H168.961V89.779H169.003L168.961 89.7358H169.003V89.6939L168.961 89.652L168.918 89.6939V89.652H168.876H168.918V89.6101L168.961 89.652H169.003V89.6101V89.5682V89.5263L169.045 89.5682V89.4844V89.5263H169.087V89.4844L169.129 89.5263V89.4844H169.171L169.129 89.4412H169.171V89.3993L169.213 89.4412L169.256 89.3993V89.3574L169.298 89.3155V89.2736H169.34L169.298 89.2317L169.34 89.1885L169.298 89.1466L169.34 89.1047L169.298 89.0628H169.34L169.298 88.979V88.8939H169.381V88.852L169.423 88.8101L169.465 88.8939L169.508 88.852L169.634 88.7264L169.592 88.6845L169.634 88.5994V88.5575V88.5156L169.592 88.3899L169.634 88.4318L169.718 88.3899L169.676 88.3048H169.718V88.2629V88.221L169.845 88.2629H169.929H169.971H170.013L170.056 88.3048L170.098 88.221L170.14 88.1791L170.181 88.0953L170.307 88.0521L170.392 88.0102L170.476 87.9683L170.645 87.8845L170.812 87.9683H170.898L170.981 87.9264H171.107L171.192 87.8845L171.276 87.7994L171.36 87.7156L171.445 87.59L171.402 87.3792L171.445 87.2522L171.529 87.1684L171.57 87.1265L171.487 87.0427L171.402 87.0008V86.9576V86.9157L171.529 86.5792V86.4955L171.57 86.4104H171.654L171.697 86.3685V86.2847L171.612 86.2009V86.1158V85.9482V85.9063L171.57 85.8631V85.8212L171.529 85.7374L171.36 85.6104L171.192 85.5266L171.107 85.4847V85.401V85.3591L171.023 85.3159L170.981 85.274H170.898V85.2321L170.812 85.1902H170.687L170.603 85.274H170.56L170.476 85.2321H170.434L170.392 85.3159H170.307H170.265L170.181 85.274L170.14 85.3159H170.098L170.056 85.3591H170.013H169.971L169.929 85.401L169.887 85.3591L169.845 85.4847H169.803V85.4429L169.76 85.4847L169.718 85.5266V85.5685L169.676 85.5266V85.5685H169.634L169.592 85.5266L169.55 85.5685L169.423 85.6104H169.381V85.6536H169.34L169.298 85.5685L169.256 85.6104L169.213 85.6536L169.171 85.6104V85.5685L169.087 85.6104V85.6955H169.045L169.003 85.7793H168.961L168.918 85.7374H168.876V85.7793V85.8212H168.834H168.75L168.709 85.9063H168.665V85.9482V86.032L168.582 86.0739L168.623 86.1158L168.498 86.1577V86.2009L168.456 86.1577L168.414 86.2847H168.371V86.2428H168.329H168.287H168.245V86.2009H168.119V86.1577L168.034 86.1158L168.076 86.0739L167.992 86.032V85.9063L167.867 85.7793H167.698L167.782 85.7374L167.698 85.6536H167.74V85.6104V85.5685L167.698 85.6104L167.656 85.5685L167.698 85.4429L167.656 85.4847L167.614 85.3591H167.571L167.487 85.401V85.3159V85.1902H167.403V85.1483L167.361 85.1064L167.276 85.0213V84.9794V84.9375H167.234V84.8537L167.151 84.8956V84.8537H167.109V84.8118H167.025L166.982 84.7686L166.94 84.7267V84.6848H166.898H166.856V84.6429L166.94 84.601H166.856L166.898 84.5591L166.856 84.474L166.814 84.3484L166.856 84.3065H166.814H166.772L166.729 84.3484L166.772 84.2646V84.2214H166.687V84.1795V84.1376L166.645 84.1795L166.561 84.1376L166.52 84.1795L166.478 84.1376H166.434V84.0538L166.478 84.0119L166.434 83.9687V83.9268L166.478 83.9687H166.52V83.8849L166.309 83.843V83.8011V83.7592L166.267 83.7173H166.351H166.393L166.434 83.6741L166.393 83.6322L166.309 83.5484L166.225 83.5065L166.182 83.4214H166.14H166.056V83.4646L166.098 83.5484H166.182V83.5903L166.098 83.6741L166.014 83.6322L165.972 83.5484V83.5065L166.014 83.4214V83.2957L165.887 83.212L165.93 83.1269L165.887 83.085H165.845L165.762 83.0431H165.72H165.678V83.0012L165.72 82.9593L165.762 82.9174V82.8742L165.72 82.8323L165.678 82.7904H165.509L165.467 82.8742H165.425L165.383 82.8323V82.6228L165.298 82.5377L165.256 82.3269V82.2431H165.172H165.087L164.962 82.285L164.878 82.3269L164.709 82.285L164.793 82.1175L164.878 82.0756L165.214 81.9486V81.9067L165.383 81.8229L165.425 81.6121L165.383 81.5283L165.298 81.3594L165.045 81.1905L165.003 81.1486H164.709L164.625 81.1905L164.498 81.4013H164.414H164.372H164.331L164.204 81.1067L164.078 80.9811L163.825 80.8541L163.741 80.7703V80.6865V80.5595V80.5176L163.951 80.3906L163.993 80.3487H164.078L164.204 80.3906L164.289 80.4338L164.372 80.3906L164.498 80.223L164.54 80.0541L164.709 79.8434L164.793 79.8015L164.962 79.6339L165.003 79.5488V79.5069L165.045 79.3812L165.087 79.2961V79.1285L165.214 78.8759L165.256 78.7921L165.214 78.6651L165.13 78.4543V78.4124H165.087V78.3705L165.172 78.1178L165.298 77.907V77.6125V77.5287L165.34 77.4868L165.298 77.3598L165.425 77.1071L165.509 76.9814V76.9395V76.8125V76.645L165.551 76.6031V76.518L165.72 76.2653H165.762L165.803 76.1815L165.678 75.845L165.72 75.8031L165.762 75.6342L165.803 75.4654L165.845 75.2559V75.214L166.014 74.8762V74.7924V74.6667L165.972 74.5397L165.887 74.4141L165.803 74.2033L165.72 73.8249L165.678 73.656L165.72 73.4871V73.3615V73.3196L165.678 73.1507L165.593 73.025L165.72 72.6453V72.2251L165.678 72.1832L165.635 71.9724L165.467 71.5927L165.383 71.5089L165.298 71.34L165.34 71.2143L165.425 70.9198V70.7509V70.6671L165.383 70.4982V70.2887L165.298 70.0361L164.92 69.6564H164.878L164.793 69.6996L164.54 69.6145L164.245 69.3618L164.12 69.3199L163.783 69.1091H163.614L163.446 69.151H163.236L163.151 69.0672L162.983 68.8565V68.647V68.6051V68.5619L162.941 68.4362L162.9 68.3524L162.604 68.2254H162.562H162.436L162.225 68.1835H162.142H162.1L161.889 68.3943L161.678 68.4362L161.509 68.3943L161.089 68.3524L161.005 68.3092L160.878 68.2673L160.794 68.1835H160.752L160.667 68.1416L160.5 68.0565L160.373 67.9727H160.205L159.994 67.8052L159.911 67.762L159.278 67.8471L159.153 67.9308L158.942 67.889L158.816 67.9727L158.689 68.1416V68.2254L158.647 68.3524V68.4781L158.563 68.6889L158.436 68.8146L158.395 68.8565L158.269 68.8146L158.226 68.7308L158.142 68.6889L157.974 68.647L157.889 68.6889L157.847 68.7308L157.805 68.8997L157.764 68.9416L157.637 68.8997L157.595 68.9416L157.511 68.8997ZM175.696 42.1263V42.0844V42.1263ZM178.937 43.8099V43.768L178.896 43.6843L178.854 43.768L178.81 43.7262L178.854 43.768L178.896 43.7262V43.8099H178.937ZM180.452 43.3478V43.3046V43.2208L180.495 43.1789V43.2208V43.2627L180.452 43.3046H180.495L180.579 43.5992L180.537 43.6424V43.5992L180.495 43.4316V43.3478H180.452ZM180.495 43.3046H180.452V43.3478L180.495 43.3046ZM176.748 42.8424H176.79L176.748 42.7992V42.8424ZM176.79 42.8424L176.748 42.9262L176.707 42.9681V43.01V43.0951H176.748L176.707 42.9681L176.79 42.9262L176.832 42.8843L176.79 42.8424ZM182.347 45.4517H182.388V45.4805L182.432 45.4517L182.474 45.5368L182.388 45.5787L182.305 45.5368L182.368 45.4936H182.347V45.4517ZM182.305 44.9044H182.263L182.305 44.8625V44.9044ZM175.696 42.7992L175.612 42.8424L175.57 42.9262L175.612 43.01H175.696V43.0951L175.738 43.137L175.78 43.0951L175.823 43.1789V43.2627V43.3046V43.2627L175.865 43.1789L175.78 43.0951L175.738 43.137L175.696 43.0951V43.01L175.654 42.9681L175.57 42.9262L175.612 42.8843L175.725 42.7992H175.696ZM181.505 43.3046V43.2627L181.463 43.2208H181.379L181.337 43.1789V43.2208L181.463 43.2627L181.294 43.3478H181.252V43.3046V43.2627V43.3478H181.294L181.421 43.3046H181.463L181.421 43.3478L181.252 43.4735V43.5154H181.21H181.126V43.4735V43.5992L181.043 43.6843H180.999V43.6424L180.958 43.7262H180.874L180.705 43.5992L180.663 43.3897V43.4316V43.3897L180.747 43.3046H180.663L180.621 43.2627L180.663 43.1789L180.747 43.137L180.79 43.1789L180.832 43.2208L180.958 43.2627V43.2208L180.999 43.1789L181.126 43.3046V43.2627L180.999 43.1789L181.043 43.137V43.0951V43.137H180.958L180.999 43.0519L180.916 43.0951L180.874 43.0519L180.958 42.9262L180.999 42.8843H181.085L181.126 42.9262H181.21L181.252 43.01V43.0519H181.294L181.252 42.9681V42.8843H181.379L181.505 42.9262L181.674 43.01L181.716 43.137V43.1789V43.2208L181.757 43.2627L181.632 43.3046L181.547 43.3897L181.59 43.1789L181.547 43.2627V43.3046H181.505ZM182.136 44.7369L182.179 44.6937V44.7369H182.136ZM175.443 42.7573V42.7154H175.485V42.7573H175.443ZM183.147 46.1259V46.0827H183.188L183.23 46.0408V46.0827H183.188V46.1259H183.147ZM176.832 43.01L176.79 43.0951H176.832V43.0519V43.01ZM177.254 42.8424L177.296 42.7992L177.338 42.7573L177.296 42.7992H177.338L177.296 42.8424H177.254ZM181.841 44.6937H181.884L181.841 44.568L181.884 44.5261L182.01 44.4423L182.052 44.3153V44.2734L182.179 44.1896H182.263L182.179 44.1045V44.0626L182.305 44.0207L182.388 44.1045V44.3991L182.347 44.4423H182.221L182.136 44.4842H182.094V44.5261H182.136L182.094 44.568V44.6099L182.052 44.6937L182.01 44.7369L181.884 44.6937L181.926 44.7369V44.7788L181.884 44.7369L181.841 44.6937ZM186.893 50.1243V50.0405H186.935L186.977 49.9986V50.0824L186.935 50.0405L186.893 50.1243ZM180.663 43.6424H180.705L180.79 43.6843V43.7262H180.747L180.663 43.6424ZM177.716 43.5992L177.759 43.5573L177.801 43.4735L177.716 43.5154V43.5992ZM183.063 46.2097V46.1678L183.105 46.2097V46.3354L183.063 46.2097ZM184.157 47.6826L184.199 47.5569L184.241 47.6407L184.199 47.6826H184.157ZM182.388 45.4098L182.432 45.3679L182.515 45.326V45.3679V45.4517L182.388 45.4098ZM178.221 43.7262L178.263 43.6424H178.306V43.7262L178.263 43.768L178.221 43.7262ZM183.988 47.9772L184.241 47.8515L184.199 47.9353L184.073 47.9772H183.988ZM183.946 48.2298H184.03L183.988 48.1879L184.03 48.146V48.1042L184.073 48.146H184.115L184.073 48.1879V48.2717V48.3149H184.03L184.073 48.2717L183.946 48.2298ZM180.158 43.768L180.243 43.6843L180.285 43.5154V43.4735H180.368V43.5154V43.5573L180.285 43.5992V43.6424L180.199 43.768V43.8518L180.158 43.768ZM175.823 42.379L175.865 42.2952H175.907L175.948 42.3371V42.379V42.4628L175.907 42.5479L175.823 42.4628V42.379ZM175.696 41.9155V41.8736L175.78 41.8317L175.865 41.8736V41.9155H175.823L175.865 42.0006L175.78 42.0844V42.0425L175.738 42.0844L175.696 42.0425V41.9155ZM183.188 46.4205L183.23 46.4624H183.274L183.23 46.4205H183.188ZM183.063 46.5632L183.021 46.5881L183.147 46.6732L183.23 46.6313L183.274 46.5462L183.23 46.5881L183.147 46.6313L183.063 46.5881V46.5632ZM182.305 44.7788V44.6518L182.347 44.6099L182.388 44.5261H182.432L182.515 44.6099V44.6518L182.474 44.6937L182.305 44.8207V44.7788ZM180.958 43.2627L180.916 43.3897L180.958 43.3046V43.2627ZM180.916 43.3897L180.79 43.3046H180.747L180.874 43.3897L180.958 43.5992H180.999L180.958 43.5573L180.916 43.3897ZM183.315 46.5462L183.274 46.4205L183.315 46.2935H183.357H183.399V46.2097H183.441L183.483 46.2516L183.441 46.2935L183.483 46.4205L183.441 46.5043L183.483 46.4624L183.441 46.5462L183.399 46.5881H183.357L183.315 46.5462ZM177.506 42.5898H177.465L177.421 42.5479H177.338L177.212 42.5898L177.127 42.6735H177.085L177.212 42.5479L177.254 42.4628H177.296L177.254 42.4209V42.379V42.3371L177.338 42.2952L177.421 42.3371V42.379L177.506 42.4209L177.548 42.5479H177.506V42.5047V42.5898ZM176.665 42.7154L176.538 42.7992L176.454 42.6735H176.496L176.454 42.5898V42.5047H176.496L176.454 42.4628L176.496 42.379L176.538 42.5047H176.58L176.621 42.5898L176.58 42.5047L176.538 42.4628V42.379L176.58 42.2952L176.665 42.4628L176.707 42.5047L176.665 42.6317L176.707 42.6735L176.665 42.7154ZM182.094 44.4842L182.136 44.3991L182.263 44.2315V44.1896L182.052 44.4842L181.968 44.5261L182.094 44.4842ZM181.337 43.1789L181.421 43.137V43.0951H181.379L181.337 43.1789ZM181.379 43.0951H181.337V43.137L181.379 43.0951ZM181.337 43.0951L181.379 43.0519H181.337V43.0951Z"
							stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="PA" @mouseenter="e => hoverES(e, 'PA')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M94.6204 26.8476H94.7042L94.746 26.8908L94.7879 27.0165H94.8311L94.873 27.1434H94.9149L94.9987 27.1002L95.0406 27.1434V27.2272H95.0838L95.1676 27.1434L95.2095 27.1853L95.2514 27.1002H95.3352L95.3784 27.1434L95.4203 27.0583L95.5041 26.9746L95.5879 27.0583L95.7568 26.8057L95.7149 26.7638V26.68L95.7568 26.5111V26.4692L95.7987 26.4273H95.8824H95.9675V26.5111L96.0513 26.553L96.1351 26.4692L96.2202 26.5111L96.2621 26.4692L96.3459 26.5111L96.3878 26.553L96.5148 26.5962V26.6381H96.5567L96.5986 26.553V26.5111H96.6405L96.6824 26.4273V26.4692H96.7675H96.8094L96.8513 26.5962V26.6381L96.8932 26.5962L96.935 26.68V26.5962L96.9769 26.553L97.062 26.5962H97.1039V26.4273L97.1877 26.3854L97.2296 26.3435V26.3003V26.0908L97.3147 25.9638L97.2715 25.922V25.9638L97.1458 25.8801L97.1877 25.8382L97.0201 25.7531V25.7112L97.062 25.6693V25.6274L97.1039 25.5855L97.062 25.5017L97.0201 25.4585V25.3747L97.1039 25.3328L97.1458 25.3747H97.2296L97.3147 25.3328L97.3985 25.4166L97.4404 25.3328H97.5242H97.5674H97.7769L97.862 25.249L97.8201 25.2058H97.7769L97.735 25.122V25.0801L97.7769 25.0382L97.735 24.9963V24.9112L97.9039 24.8693L97.9458 24.8275V24.7856V24.7437L98.0295 24.7018V24.6586L98.0714 24.6167L98.1146 24.5329L98.1565 24.491L98.2403 24.5329L98.1984 24.7018H98.366V24.6586L98.493 24.7018L98.5349 24.6586L98.5768 24.7018V24.7437L98.6619 24.7856L98.7038 24.8275L98.8714 24.7018H98.9565V24.6586L99.0403 24.7018L99.1659 24.7437L99.2091 24.8275V24.8693V24.9544L99.251 25.0382V25.0801L99.3767 25.122H99.4605L99.5456 25.0382H99.6294V25.0801H99.7551V24.9963L99.7983 24.9544L99.924 24.9963L100.008 25.0801V25.0382L100.135 25.122V25.0382L100.177 24.9963V24.9544L100.26 24.8275L100.219 24.7856L100.26 24.7437L100.219 24.7018H100.26L100.304 24.6586L100.26 24.5748L100.304 24.491L100.26 24.364H100.304V24.2802L100.135 24.1964L100.177 24.1545H100.219V24.1113H100.304L100.346 24.1545L100.387 24.1113L100.429 24.1545L100.471 24.1964H100.64H100.724L100.766 24.1113V24.0694L100.808 24.0275H100.85H100.893H100.935V23.9856L101.102 24.0694V23.9856L101.145 23.9018V23.9437H101.187H101.271L101.355 23.9018L101.398 23.9437L101.44 23.9018L101.398 23.8167H101.44V23.6911L101.524 23.733L101.566 23.6492L101.608 23.6911H101.65V23.733L101.735 23.6911L101.818 23.733L101.902 23.6911L101.944 23.733H101.902H101.987L101.944 23.6492H101.987L102.029 23.733V23.7748L102.113 23.8167H102.197V23.7748L102.24 23.8599L102.282 23.9018H102.324V23.9437L102.449 23.9018V23.8599H102.535L102.618 23.9018L102.66 23.8599L102.744 23.8167H102.787V23.9018H102.829L102.871 23.8599L102.955 23.9018V23.8599H103.039V23.7748L102.997 23.733L103.082 23.6911L103.124 23.6492L103.166 23.6911V23.6492V23.5654L103.207 23.4803H103.249L103.291 23.4384L103.249 23.3127L103.291 23.2695H103.334L103.376 23.2276H103.418L103.587 23.1857V23.1438L103.629 23.06L103.671 23.0168L103.629 22.933L103.713 22.8492L103.671 22.7654L103.713 22.7222L103.671 22.6803V22.6385V22.5128H103.713L103.882 22.4709V22.4277L103.966 22.3858L104.049 22.4277H104.091L104.176 22.302V22.2601L104.091 22.2182L104.176 22.175V22.1331L104.218 22.0493L104.26 22.0912L104.344 22.0493L104.429 22.0912L104.471 21.9655L104.638 22.0493H104.724L104.68 22.0912L104.765 22.175L104.807 22.2601H104.849L104.891 22.302L104.933 22.3439V22.2182L105.06 22.175L105.144 22.0493H105.228L105.271 22.0074L105.313 21.9655L105.438 22.0074L105.48 21.9223L105.649 21.8804V21.8385V21.7547H105.691L105.775 21.7966L105.818 21.7547L105.86 21.7966V21.8804L105.902 21.9223L105.944 21.9655V22.1331L105.986 22.2182H106.028H106.071L106.155 22.2601L106.196 22.302L106.238 22.3858L106.28 22.4709H106.322L106.365 22.5128H106.491L106.533 22.5547L106.575 22.4709L106.618 22.4277H106.66H106.702L106.869 22.3858L106.954 22.4709V22.5128L107.038 22.5547L107.08 22.5966H107.207H107.249V22.6385L107.333 22.5966L107.375 22.6385H107.417V22.6803H107.46L107.502 22.7222H107.544L107.627 22.7654H107.585L107.627 22.8073V22.8492L107.669 22.8911V22.8492V22.8073L107.754 22.7654L107.796 22.7222L107.838 22.6385L107.88 22.5966L107.922 22.5547L108.007 22.5128V22.4709H108.049L108.091 22.3858L108.217 22.4277L108.344 22.4709V22.4277L108.385 22.4709H108.554V22.3858H108.596L108.68 22.302L108.722 22.2601L108.807 22.3439H108.849L108.891 22.3858L108.975 22.5128H109.102L109.143 22.4709H109.227L109.311 22.4277L109.353 22.3439H109.48L109.564 22.2182L109.649 22.2601L109.774 22.2182L109.816 22.2601H109.858H109.901H109.943V22.302L110.027 22.3858H110.069L110.111 22.4277H110.153V22.3439H110.28L110.364 22.302L110.447 22.3439H110.491L110.574 22.4277H110.658L110.7 22.5128H110.743H110.785L110.869 22.5966L110.953 22.6803L111.08 22.7222L111.122 22.5966L111.247 22.5547L111.291 22.5966H111.332H111.458L111.5 22.5547L111.542 22.6385H111.585H111.627L111.711 22.7222L111.753 22.7654V22.8492H111.836V22.8911L111.88 22.8492L111.963 22.8911L112.005 22.8492H112.047V22.933H112.089V22.8911H112.174H112.258H112.3H112.342L112.385 22.933H112.427L112.595 23.0168V22.9749H112.68L112.722 22.933L112.763 22.8911L112.847 22.933L112.974 22.7654L113.1 22.6803L113.184 22.6385V22.5128L113.058 22.4277V22.3439L113.016 22.302L113.058 22.2601L112.974 22.0074V21.9655H113.016H113.058L113.1 22.0074L113.142 21.9223V21.8804V21.8385V21.7966L113.184 21.7547V21.6709L113.142 21.6277L112.974 21.544L113.016 21.4602V21.4183H112.974L112.889 21.3332L112.763 21.3764L112.722 21.2494L112.763 21.2075H112.722V21.1237L112.68 21.0805H112.636L112.595 21.0386L112.636 20.9967L112.553 20.871H112.469H112.342L112.3 20.7859L112.258 20.744H112.216V20.7021L112.3 20.6602L112.342 20.5764V20.5332H112.3V20.4913L112.258 20.4495H112.216L112.132 20.3657L112.089 20.4076L112.047 20.3238L111.963 20.3657H111.88L111.836 20.3238L111.795 20.2819L111.711 20.2387V20.1968L111.795 20.1549V20.113L111.88 20.0292V19.9441L111.922 19.9022L112.005 19.8603V19.8184L111.963 19.7765L112.005 19.6914V19.6076V19.5657L112.047 19.5238H112.089V19.5657H112.132L112.174 19.6495L112.216 19.7333L112.258 19.7765L112.385 19.8184V19.7765L112.427 19.7333V19.6914V19.6495L112.385 19.6076H112.342V19.5238L112.427 19.4819V19.4387L112.469 19.355H112.511L112.553 19.2712L112.636 19.2293L112.68 19.1874V19.1442H112.636H112.595L112.553 19.0604L112.511 19.1023V19.0185L112.636 18.9347V18.8496L112.68 18.8077L112.722 18.7658L112.636 18.7239V18.6401L112.68 18.5969L112.722 18.555H112.763L112.974 18.5131L113.058 18.555V18.5969H113.142L113.184 18.6401L113.227 18.682L113.269 18.7239L113.311 18.8077H113.353L113.394 18.8496H113.48V18.9347L113.605 18.9766L113.9 19.0185L113.942 18.9766L114.025 19.0185L114.069 19.1023L114.025 19.1442L114.069 19.1874L114.152 19.3131L114.321 19.355H114.405L114.447 19.2293L114.574 19.2712L114.7 19.2293L114.784 19.2712H114.869L114.952 19.2293L114.994 19.1874H115.036L115.078 19.1442L115.12 19.1874L115.205 19.1442L115.247 19.2293L115.373 19.1874H115.5V19.1442L115.669 19.1023L115.794 19.1442H116.131L116.383 19.2712L116.636 19.0604L116.552 18.8928L116.805 18.6401H117.058L117.309 18.7239L117.478 18.5969L117.689 18.3442L118.025 18.3023L118.152 18.555L118.403 18.3874L118.741 18.1348L119.078 18.2186L119.162 18.5969L119.289 18.7239L119.583 19.1442L119.541 19.1874V19.2712L119.583 19.3131L119.625 19.355L119.961 19.7333L120.003 19.8184L120.045 19.9441H120.003L119.961 20.0292L120.003 20.0711L119.961 20.113V20.2387L120.003 20.3657L120.13 20.4913L120.172 20.5332L120.214 20.6183H120.256V20.7021L120.214 20.744V20.7859L120.13 20.8278V20.871L120.088 20.9129L120.003 20.9548V21.0386H119.961L120.003 21.0805L119.961 21.1656L120.003 21.2494L119.92 21.2913L119.961 21.4602H119.92V21.544L119.961 21.5858V21.6709L120.003 21.7547L120.045 21.8385L120.088 21.8804L120.13 21.9223L120.214 21.9655L120.172 22.0493H120.256L120.298 22.0912V22.1331V22.175H120.256V22.2182L120.214 22.302H120.172L120.214 22.5128L120.256 22.5547V22.5966V22.6385L120.298 22.7222V22.8911L120.34 22.933L120.383 22.9749V23.0168H120.425L120.298 23.1019L120.34 23.1857L120.298 23.2276V23.2695L120.34 23.3127V23.3546L120.509 23.3965H120.636V23.3546L120.678 23.3965H120.761L120.803 23.4384L120.93 23.3965H120.972L121.098 23.3127L121.183 23.3546L121.225 23.3127L121.351 23.3546L121.434 23.3127V23.3546L121.645 23.3965L121.687 23.4384L121.73 23.4803L121.814 23.5222H121.856L121.898 23.5654L121.983 23.5222V23.4803L122.067 23.5222V23.4803H122.109L122.277 23.5222L122.361 23.4803H122.403H122.487L122.572 23.5654L122.614 23.4384L122.781 23.5222V23.5654H122.825V23.6073H122.908L122.95 23.5654V23.6073H122.992H123.076L123.034 23.6492H123.076L123.119 23.6911H123.161V23.733L123.245 23.6911L123.203 23.733L123.161 23.7748L123.245 23.8167L123.287 23.7748L123.329 23.8167H123.287L123.329 23.8599L123.287 23.9018L123.329 23.9437V23.9856L123.414 23.9437L123.456 23.9856H123.54V24.0694L123.623 24.1113L123.708 24.1545L123.75 24.2802L123.792 24.3221V24.1964L123.834 24.1113H123.876V24.1964H123.918H124.003L124.045 24.2383V24.1964L124.087 24.2383V24.3221H124.171L124.129 24.364L124.214 24.4491V24.491H124.171V24.5329H124.214L124.256 24.6167L124.298 24.5748L124.339 24.5329V24.5748L124.298 24.6586L124.256 24.7437V24.7856H124.381L124.466 24.9544L124.423 25.0382L124.466 25.0801L124.423 25.1639V25.2058H124.508L124.466 25.1639L124.55 25.122L124.592 25.1639H124.634L124.718 25.0801L124.803 25.122L124.845 25.0801L124.803 25.0382H124.845L124.929 24.9963L124.97 25.0801V25.2058V25.2909L125.056 25.249L125.139 25.2909L125.181 25.2058L125.265 25.249V25.3328L125.308 25.2909L125.392 25.3328H125.434L125.392 25.4166V25.4585L125.35 25.5017V25.5436H125.392L125.476 25.5017V25.4166H125.603L125.645 25.5017H125.729V25.5436L125.687 25.7112V25.7531L125.729 25.7112L125.856 25.7531L125.939 25.7112V25.7531L125.897 25.7963V25.8382L126.023 25.7963L126.065 25.8382H126.15L126.192 25.7963L126.15 25.7531L126.065 25.6693L126.107 25.6274H126.192L126.276 25.6693L126.318 25.7531L126.36 25.7963H126.403L126.445 25.7112L126.487 25.7963L126.655 25.8382V25.7963L126.739 25.7112V25.6693L126.697 25.5855L126.739 25.5436L126.865 25.6274V25.6693L126.739 25.7963L126.781 25.8801L126.823 25.922L126.907 25.8382L126.95 25.8801V25.922H127.034L127.076 25.7531L127.159 25.7112L127.201 25.7963L127.159 25.8801L127.201 26.0057L127.159 26.0489L127.076 26.0908L127.118 26.1746H127.201L127.245 26.0908L127.497 26.0489L127.623 26.1746L127.665 26.1327V26.0908H127.792L127.834 26.1327L127.876 26.2584L127.792 26.3003L127.707 26.3435V26.5111H127.75L127.876 26.553L127.918 26.6381L127.876 26.7638L127.792 26.8476V26.8908L127.834 26.9746H127.918L128.254 26.8057L128.465 26.8476V26.8057L128.507 26.7638H128.549V26.8908L128.592 27.0165L128.676 27.1002L128.717 27.1853L128.676 27.311V27.3529L128.634 27.3948H128.549L128.465 27.3529H128.423L128.339 27.438V27.5218V27.6056V27.8164L128.381 27.8583L128.465 27.9421V28.0272H128.507L128.549 28.111V28.1528L128.507 28.1947V28.2366L128.549 28.3636L128.592 28.4055L128.634 28.4474V28.6163L128.592 28.6582L128.634 28.7852L128.928 28.9947L128.97 29.0366L129.307 29.2055L129.39 29.2892L129.475 29.4581L129.601 29.5419L129.854 29.7108L129.896 29.7527H129.938L129.981 29.7946L130.023 29.9216L130.19 30.0473L130.234 30.1311L130.275 30.2581L130.317 30.3L130.401 30.2581L130.528 30.3418V30.3837L130.485 30.4256L130.443 30.6783L130.275 30.8891L130.234 31.0161V31.0999L130.275 31.1837V31.2688L130.234 31.3107L130.148 31.3945L130.19 31.4363L130.107 31.5633L130.19 31.6052L130.234 31.6471L130.148 31.8579L130.19 32.0255V32.1106V32.1525L130.107 32.2782L130.148 32.4052L130.275 32.489L130.317 32.6146L130.359 32.7835L130.485 32.8673L130.612 33.0781L130.57 33.12L130.528 33.247L130.57 33.4578L130.654 33.4997L130.738 33.6253L130.865 33.7091L130.906 33.7942L130.948 33.8361V33.9618L130.99 34.0469L131.117 34.0888L131.075 34.3415L131.159 34.4253L131.285 34.5091L131.328 34.5523V34.7617L131.37 34.9725L131.412 35.1414L131.579 35.6036L131.623 35.6455L131.79 35.6887L131.959 35.6455L132.085 35.6887L132.127 35.7306L132.17 35.8143L132.212 35.8981L132.674 36.2359L132.717 36.4035L132.801 36.4886L132.927 36.5724H133.012L133.095 36.6562L133.137 36.74V36.9088L133.054 37.0777V37.2034L133.137 37.3723L133.179 37.4142L133.012 37.6669L133.095 37.7507L133.054 37.8777L133.137 38.0034L133.221 38.0871V38.1722V38.2141L133.39 38.4668L133.474 38.5087H133.559L133.685 38.4249L133.853 38.3817H134.063L134.148 38.4668L134.19 38.6776V38.8033V38.929V38.9722L134.232 39.056L134.274 39.1397V39.2667V39.3086V39.3505V39.3924V39.4762L134.148 39.687V39.7721V39.8559L134.232 39.8978L134.063 40.1086L134.021 40.1924H134.106H134.19L134.316 40.1505L134.443 40.1086H134.485L134.568 40.0235L134.61 40.0667L134.695 40.1505L134.779 40.1924L134.863 40.318L134.905 40.4031L134.863 40.5707H134.821H134.737L134.695 40.6139L134.653 40.6558V40.6977V40.7815L134.779 40.9085V41.118L134.821 41.1612L134.779 41.2869L134.695 41.3706L134.737 41.4125L134.779 41.4557L134.905 41.3706L134.99 41.4557L135.157 41.4976L135.201 41.5395L135.326 41.8341H135.495L135.663 41.9179H135.915L135.999 41.9611H136.295H136.379L136.463 42.0449H136.632V42.0868L136.715 42.2976L136.674 42.4232V42.507L136.715 42.5502H136.757L136.926 42.634L137.052 42.5921L137.094 42.507V42.4651L137.01 42.3814L136.968 42.3395V42.2976L137.052 42.2557L137.137 42.2125L137.305 42.1706L137.432 42.2125V42.1706L137.473 42.1287L137.432 41.9179L137.473 41.876H137.515L137.599 41.9179V41.9611V42.1287V42.1706H137.642L137.684 42.2125V42.1706L137.768 42.003L137.852 41.9611L138.021 42.1287L138.063 42.1706L138.568 42.1287L138.737 42.003L139.199 41.5395L139.283 41.4125L139.326 41.3287V41.2031L139.283 41.0761L139.241 40.6139H139.283V40.4031L139.326 39.9816V39.814V39.7721L139.368 39.7289L139.41 39.6451L139.452 39.6032L139.873 38.8871L140.041 38.7195L140.293 38.4249L140.377 38.3398L140.546 38.2141L140.757 38.0034L140.883 37.7507L140.968 37.4561L141.052 37.3723L141.346 37.0777L141.388 36.74V36.6981L141.43 36.6143L141.515 36.4886L141.557 36.4454L141.683 36.3197L141.768 36.1927L141.935 35.9832L142.019 35.8143L142.23 35.4779L142.482 35.3941L142.862 35.3509L142.988 35.2671H143.03L143.157 35.1833L143.282 35.0563L143.366 34.9306L143.408 34.8887L143.535 34.7198H143.577V34.678L143.704 34.5091L143.746 34.4672L143.999 34.2564L144.082 34.2145H144.166L144.713 34.0469L144.924 34.0037L145.177 33.878L145.64 33.5416L145.766 33.3727L145.893 33.247L146.061 33.12L146.188 32.9943L146.313 32.7416L146.44 32.489L146.524 32.3201L146.65 31.9417L146.777 31.7728L146.819 31.6471L146.86 31.3107L146.986 31.058L147.071 30.8891L147.239 30.7202H147.282L147.324 30.6783L147.619 30.4688L147.829 30.3837L148.25 30.3L148.333 30.2581L148.544 30.2162H148.797H149.175L149.218 30.5945L149.428 30.7634L149.513 31.058L149.555 31.4782L149.513 31.6052L149.471 32.1525V32.3201L149.386 32.5727H149.681L149.891 32.6578H149.933H149.975L150.018 32.6146L150.102 32.6578L150.186 32.6997V32.6578L150.313 32.6997L150.355 32.7416L150.733 32.5727L150.775 32.5308L150.86 32.6146L150.944 32.5727H151.028H151.113L151.238 32.489L151.322 32.5727L151.407 32.6578V32.6146L151.364 32.5308V32.489L151.407 32.4471V32.489H151.449L151.491 32.4471H151.533L151.575 32.4052L151.786 32.3633L151.828 32.4471H151.87L151.828 32.5308H151.87L151.911 32.489L151.955 32.5308H151.997L152.038 32.5727V32.6146L152.164 32.6997L152.249 32.9943L152.333 33.12L152.502 33.4146L152.755 33.7942L153.049 34.2145L153.091 34.2564L153.133 34.2996L153.175 34.2564L153.259 34.2996L153.302 34.3415H153.386V34.3834L153.553 34.4253V34.4672L153.596 34.5091V34.5523L153.553 34.5942H153.511V34.6361H153.638L153.68 34.7198L155.911 35.7306L155.995 35.8981L156.248 36.0251L156.416 36.1508L156.5 36.1927H156.584H156.627V36.1508L156.753 36.1089H156.922L157.006 36.1508L157.047 36.1089L157.131 36.1508L157.174 36.1089H157.258L157.3 36.1508L157.384 36.2359H157.427L157.553 36.3197H157.722L157.805 36.3616H157.889L157.974 36.3197L158.016 36.2778L158.226 36.1927H158.437L158.478 36.2359L158.522 36.1927L158.647 36.2359L158.689 36.2778L158.731 36.2359H158.858H158.942L159.026 36.2778L159.236 36.1927L159.447 36.2778L159.531 36.3616H159.616L159.658 36.4035L159.7 36.4454L159.742 36.4886L159.784 36.6562L159.742 37.0358V37.0777L159.489 37.2872L159.405 37.4142L159.363 37.7507L159.236 37.9196L160.711 38.4249L162.183 38.9722V39.056V39.1816V39.2235H162.225H162.267V39.1397H162.309V39.0979L162.351 39.0141L162.394 38.9722V38.8871V38.8033L162.478 38.7195L162.562 38.7614L162.647 38.6776L162.689 38.7195L162.731 38.6344V38.5506H162.773V38.5087L162.731 38.4668L162.773 38.4249L162.815 38.3817V38.3398L162.773 38.3817V38.2979L162.815 38.256H162.9H163.025L163.067 38.3817V38.4249V38.4668H163.151L163.109 38.5087L163.151 38.5506H163.109L163.151 38.6776L163.109 38.7614L163.067 38.8871L163.025 38.929V38.9722L162.983 39.056H163.025L163.067 39.0141L163.109 38.9722L163.151 39.056H163.194L163.278 38.9722V38.8452V38.8033L163.32 38.7614L163.278 38.6344V38.5506L163.362 38.5087L163.32 38.4668L163.362 38.3817L163.32 38.2979L163.404 38.2141L163.489 38.256V38.2979V38.3398L163.404 38.4249V38.4668H163.446L163.573 38.4249L163.614 38.4668L163.573 38.5087L163.656 38.6776L163.614 38.8033L163.656 38.7614L163.698 38.6776V38.5925L163.741 38.5506V38.5087L163.698 38.4249L163.656 38.3817V38.3398V38.2979L163.783 38.3398L163.825 38.256V38.2141L163.909 38.1722V38.1303H163.993L164.078 38.1722L164.036 38.2141L164.12 38.3817L164.078 38.4249L164.036 38.5087L164.12 38.5506V38.5087H164.162L164.289 38.4249L164.372 38.4668L164.414 38.5925L164.456 38.6776L164.498 38.7195V38.7614L164.456 38.8033V38.8452L164.414 38.8871L164.456 38.929V38.9722L164.414 39.1397H164.456L164.498 39.1816L164.54 39.1397L164.583 39.1816L164.793 38.8033L164.751 38.6776L164.793 38.5925L164.751 38.5087L164.793 38.4668V38.4249L164.92 38.4668V38.5506L165.004 38.5925L165.087 38.7195L165.045 38.8033V38.8452L165.087 38.8871H165.131L165.087 38.9722L165.131 39.0141L165.172 39.056V39.0979L165.214 39.1397L165.256 39.1816L165.383 39.4343V39.4762L165.34 39.6032L165.425 39.5613L165.467 39.6032V39.5194V39.3924V39.2235L165.425 38.929L165.467 38.7614L165.383 38.7195V38.6776L165.467 38.5506H165.425L165.635 38.4668L165.762 38.5087L165.803 38.5506L165.762 38.7195V38.7614L165.72 38.8033V38.8871L165.762 38.8033L165.803 38.8871V38.8452L165.845 38.929H165.887L165.972 38.8452V38.7614H166.098V38.7195L166.014 38.6776V38.6344V38.5925H166.182H166.225L166.351 38.5506L166.393 38.5087L166.52 38.5506L166.645 38.5925L166.603 38.6344V38.6776L166.562 38.5925V38.6344L166.603 38.7195H166.562V38.8033V38.8452L166.645 38.8033L166.687 38.8871L166.729 38.8452L166.772 38.8871L166.814 38.8452L166.729 38.7614L166.772 38.7195L166.814 38.7614V38.7195H166.898L167.067 38.8033L167.151 38.9722L167.067 39.056V39.0979H167.025L166.94 39.056L166.898 39.0979L166.856 39.2235L166.982 39.1816L166.94 39.2235H166.982L167.025 39.1816V39.1397H167.067H167.109L167.151 39.1816L167.193 39.1397H167.151V39.0979L167.234 39.0141V38.9722H167.276L167.234 39.0141L167.32 38.9722H167.361L167.403 39.0141H167.361H167.403L167.361 39.0979L167.32 39.1397L167.361 39.3924H167.32L167.276 39.4762L167.32 39.6451V39.687L167.361 39.6451L167.32 39.6032L167.361 39.5613L167.403 39.6451V39.5194H167.361V39.4762L167.445 39.2667L167.487 39.3505V39.3924V39.3505V39.2667V39.2235H167.529L167.487 39.1816V39.0979H167.529H167.571H167.614L167.698 39.056V39.0141L167.824 38.9722V39.0141V39.056L167.909 39.0979L167.951 39.2235L167.824 39.2667L167.867 39.3086L167.909 39.3505L167.951 39.3924H167.909L167.951 39.4343L167.824 39.5194L167.909 39.4762L167.951 39.5194L167.909 39.5613L167.951 39.6451V39.687H167.992L167.951 39.6451V39.6032H167.992V39.5194L168.034 39.3924L167.992 39.2235L168.076 39.2667L168.034 39.4343V39.687L167.992 39.814V39.8559H168.034L168.076 39.7721L168.161 39.8559H168.203L168.119 39.7721H168.076V39.687L168.119 39.6451V39.4762V39.3924H168.161V39.4343H168.203L168.245 39.3924V39.3505L168.371 39.2667L168.414 39.3086L168.498 39.2235H168.54H168.624V39.2667L168.709 39.4343H168.665V39.3924L168.624 39.4343V39.4762V39.5194L168.582 39.5613H168.624L168.582 39.6451L168.498 39.687V39.7289L168.54 39.7721L168.582 39.687L168.624 39.7289V39.7721H168.665V39.7289L168.709 39.7721V39.814L168.665 39.8559L168.709 39.8978L168.751 40.0667L168.792 40.1086V40.1924H168.751H168.665V40.2342L168.792 40.318H168.834H168.876V40.2761V40.1924H168.918V40.2342L168.961 40.1924H168.918V40.1505V40.1086V40.0235V39.9397L169.003 39.8978H169.087H169.129V39.8559L169.087 39.814V39.7721L169.129 39.814L169.087 39.7289V39.687V39.6451L169.171 39.5613L169.213 39.6032V39.6451H169.256V39.5194L169.34 39.4762H169.298H169.213V39.4343H169.256H169.34L169.423 39.5194V39.5613L169.382 39.6032V39.6451L169.423 39.6032V39.7721H169.256L169.382 39.814L169.423 39.8559L169.382 39.9397H169.34V39.9816L169.256 40.0667H169.298L169.382 39.9816L169.423 40.0235L169.382 40.0667L169.298 40.1505V40.2342H169.34V40.1505L169.382 40.1086V40.1505L169.465 40.1086V40.0235H169.509L169.55 40.1505L169.509 40.1924H169.55V40.2342V40.2761L169.465 40.318V40.4031V40.445L169.509 40.4869V40.4031L169.55 40.318L169.592 40.2342L169.718 40.3612L169.634 40.4031V40.445L169.676 40.4869V40.4031L169.718 40.3612V40.2761H169.676V40.2342H169.718H169.676L169.634 40.1086L169.718 40.0667H169.803L169.845 40.1505L169.803 40.0235L169.845 39.9397L169.887 39.9816L169.929 40.0235L169.971 40.2342L170.013 40.445V40.4869L169.971 40.5707V40.6139V40.5707L170.056 40.4869L170.098 40.445V40.3612L170.056 40.2342L170.098 40.0235L170.223 39.9816L170.265 40.0235L170.307 40.1505L170.392 40.1924L170.35 40.2342H170.392V40.1505H170.434V40.1924L170.476 40.1505L170.434 40.1086H170.35L170.307 39.9397V39.8559H170.392L170.434 39.9397L170.476 39.8978L170.392 39.814L170.476 39.7721V39.7289H170.518L170.603 39.7721V39.814H170.56V39.8559L170.603 39.8978L170.729 39.9397L170.771 39.9816L170.729 40.0235L170.771 40.0667L170.813 40.1086V40.1505L170.854 40.1924L170.813 40.2342V40.1924V40.1505L170.729 40.1924L170.687 40.1086V40.1505L170.729 40.2342H170.687V40.2761L170.645 40.318L170.603 40.2761H170.56L170.645 40.4031L170.518 40.445L170.56 40.4869H170.603L170.645 40.5707V40.6558L170.56 40.7396H170.518H170.476H170.434L170.476 40.7815L170.392 40.8234H170.35L170.307 40.8666L170.392 40.9504H170.434L170.392 40.9085H170.518L170.56 40.8234L170.518 40.9085H170.56H170.645L170.771 40.8234H170.813L170.854 40.7815V40.9085L170.898 40.9504H170.94H170.981L171.065 40.7815V40.7396L171.107 40.6977V40.6558V40.5707V40.5288L171.149 40.4869L171.234 40.5707L171.192 40.6139V40.6558V40.8234L171.234 40.9504V40.9923V40.9504L171.276 40.8234V40.8666V40.7815H171.318V40.8234L171.36 40.7396L171.276 40.6558L171.318 40.5707L171.36 40.6139V40.4869L171.402 40.445H171.445V40.4031H171.402V40.3612L171.487 40.318H171.571L171.654 40.3612V40.4031L171.698 40.445L171.739 40.318L171.781 40.2761H171.823V40.2342H171.781L171.949 40.1924L171.992 40.2761V40.3612L171.949 40.4031L171.865 40.4869H171.823L171.781 40.445L171.739 40.4869L171.654 40.5707V40.6139H171.612L171.571 40.6558L171.612 40.6977L171.654 40.6558V40.6977V40.7396H171.698L171.654 40.7815L171.612 40.7396L171.654 40.8234L171.698 40.8666H171.654H171.612L171.654 40.8234L171.571 40.8666H171.529L171.487 40.9504L171.654 40.9085L171.698 40.9504V41.118H171.654L171.612 41.0761L171.571 41.118L171.612 41.1612V41.245L171.654 41.2031V41.245L171.612 41.3287H171.571L171.612 41.3706L171.654 41.4557V41.3706L171.698 41.2869L171.781 41.3287V41.2869L171.739 41.245V41.2031L171.823 41.245L171.949 41.2031L172.034 41.245V41.3706L171.992 41.4125H171.949L171.907 41.4557V41.5395H171.949V41.4557L172.034 41.4976V41.4557L172.076 41.3706L172.034 41.2031L171.949 41.1612H171.992V41.0761H172.034L172.076 41.0342H172.16V41.2031L172.202 41.3287V41.4125L172.243 41.4557H172.287L172.243 41.3287V41.245L172.287 41.2869V41.2031L172.37 41.118L172.412 41.0761H172.454L172.412 41.118L172.496 41.2031V41.3287V41.4125L172.412 41.4976V41.5814H172.454H172.496H172.581L172.665 41.6652L172.707 41.6233L172.623 41.5395H172.496V41.4976L172.581 41.4557V41.3706V41.245L172.623 41.2031L172.707 41.245V41.2869L172.749 41.4125L172.707 41.4557H172.749V41.4125H172.834L172.749 41.3706L172.792 41.3287L172.749 41.245L172.665 41.1612L172.749 41.0761L172.792 41.118L172.876 41.0342L172.918 41.0761V40.9923L172.876 41.0342L172.792 40.9923L172.876 40.9085V40.8666L172.918 40.7396H172.96V40.6977L173.002 40.7815L172.96 40.6977L173.087 40.6558H173.002H172.96H172.918V40.5707L173.002 40.5288L173.043 40.5707V40.5288H173.087H173.17L173.254 40.445V40.4031H173.296L173.381 40.445L173.423 40.4869V40.6977L173.338 40.6558H173.296L173.254 40.7396L173.212 40.8234L173.338 40.7815L173.296 40.9085L173.212 40.9504L173.17 40.9085L173.212 40.9923L173.17 41.0342L173.129 40.9923V41.0761H173.002H173.129L173.212 41.0342V40.9923H173.254V41.0342L173.212 41.0761L173.254 41.2031L173.212 41.245H173.254L173.296 41.3706V41.4976H173.212L173.17 41.5814L173.043 41.7922L172.96 41.876V42.003L172.876 42.0868V42.1706V42.2125L172.918 42.1287L173.002 42.0868L173.043 42.003L173.087 41.9611V41.8341L173.17 41.7084L173.381 41.5395L173.423 41.4125V41.2031L173.465 41.118L173.507 41.0761H173.591L173.634 41.118L173.591 41.2031V41.245V41.3706V41.4125V41.4557V41.4976L173.507 41.5814L173.423 41.8341L173.296 41.9611H173.338L173.423 41.9179L173.507 42.0449V42.0868H173.549L173.465 41.876L173.507 41.8341L173.549 41.6233H173.591L173.634 41.6652L173.676 41.9179L173.634 41.9611H173.676V41.876H173.718L173.676 41.8341V41.7084L173.634 41.6233L173.676 41.5395L173.718 41.4976L173.928 41.3706H173.97L174.012 41.3287V41.2869L174.054 41.245V41.2031L174.138 41.245V41.3287L173.97 41.4557V41.5814L174.012 41.6652V41.7084H174.054L174.138 41.7922L174.054 41.9611V42.1287L174.012 42.2557L173.97 42.3814H173.928H173.887L173.76 42.4232L173.634 42.5502L173.718 42.7178L173.549 42.8867L173.634 43.0975H173.76V43.2232V43.2651L173.928 43.2232V43.2651L173.887 43.3502L173.843 43.4759L173.801 43.5177L173.76 43.6866L173.591 43.8123L173.718 43.8961V43.9393L173.465 44.1488L173.549 44.2339L173.591 44.2758L173.676 44.3596V44.4447L173.76 44.823L173.634 44.8649V44.9068L173.676 44.9487V44.9906L173.591 45.1176V45.2433V45.2865L173.634 45.3284V45.4122L173.591 45.496L173.507 45.5811L173.381 45.623H173.338L173.296 45.6649V45.7067L173.254 45.7486H173.212H173.17L173.087 45.7067L172.96 45.7486H172.792H172.707L172.665 45.7905L172.623 45.8337L172.581 46.0013L172.623 46.2121L172.665 46.254L172.749 46.1702L172.792 46.2121H172.834L172.96 46.1702L173.17 46.2121L173.212 46.2959L173.254 46.3378L173.296 46.4229L173.087 46.7175V46.7594H173.17L173.212 46.9282L173.129 47.3066L173.043 47.5174V47.6431L172.96 47.7701L172.918 47.812L172.876 47.8957V48.0227L172.918 48.1065V48.2322L172.876 48.2741L172.749 48.4011V48.443L172.834 48.4849L172.749 48.57L172.623 48.6119L172.539 48.6957L172.454 48.8646V48.9065L172.37 48.9484H172.287L172.243 49.074L172.16 49.1172L172.076 49.074L172.034 48.9902L171.907 49.0321V49.074L171.992 49.1591L171.949 49.3686L171.907 49.4118V49.5375V49.6213L171.865 49.6645L171.698 49.7902V49.874V49.9159L171.781 49.9591H171.823L171.949 49.7902L172.034 49.8321V49.874L171.992 49.9591L171.949 50.0429L171.865 50.1266V50.2536V50.3793V50.4212H171.907L171.865 50.5063V50.5901L171.907 50.6739L171.865 50.759L171.907 50.8009L171.992 50.8428V50.8847L171.698 50.9685H171.612L171.571 50.9266H171.529L171.487 50.9685V51.0536L171.529 51.0955L171.571 51.1374L171.529 51.2211H171.487L171.402 51.263L171.445 51.4319L171.234 51.4738L171.149 51.5157H171.065H171.023L170.94 51.5576V51.7265L170.898 51.7684L170.813 51.6008H170.771L170.729 51.6427V51.7265V51.7684L170.645 51.8103V51.8535V51.8954L170.56 51.8535V51.8954L170.476 51.9373L170.392 52.063L170.434 52.1481V52.19L170.518 52.1481V52.19V52.2319L170.56 52.3575L170.603 52.3156H170.645V52.3994V52.4845V52.5683L170.687 52.6521L170.771 52.6102L170.813 52.5683V52.5264H170.854V52.5683V52.6953V52.7372H170.898L170.94 52.7791H170.898V52.821L170.981 52.7791V52.821H170.94L171.023 52.8629H170.981L170.94 52.9048L170.854 52.821H170.771L170.729 52.8629H170.771V52.9048L170.813 52.948L170.729 52.9899L170.645 52.948H170.603L170.645 52.9899L170.603 53.0318V53.0737H170.645L170.603 53.1156L170.56 53.1575L170.518 53.1156H170.434L170.35 53.1575V53.1994H170.392L170.476 53.2845H170.434L170.476 53.3682L170.518 53.4101V53.452L170.434 53.4939V53.5371V53.6209H170.518L170.56 53.6628V53.7047H170.476V53.7466H170.518L170.56 53.7898L170.518 53.8736L170.434 53.8317L170.392 53.8736V53.9155L170.476 53.9574L170.392 54.0425L170.434 54.0844L170.35 54.1263V54.252L170.392 54.3371L170.35 54.379V54.5046L170.307 54.4627L170.181 54.5046L170.223 54.6735L170.181 54.7154H170.14V54.5884H170.098L170.056 54.6735H170.013H169.971H169.929L169.971 54.7573L170.056 54.7154V54.7992L170.098 54.8411L170.056 54.9262H170.013H169.929L169.971 55.0519L169.929 55.0938L169.845 55.01H169.76L169.887 55.0938V55.1357L169.803 55.1789L169.887 55.2208V55.2627V55.3046L169.845 55.2627H169.76L169.718 55.3046L169.76 55.3465L169.718 55.4316H169.676L169.634 55.3884L169.592 55.4316V55.5991H169.55H169.509H169.465L169.55 55.6829L169.465 55.768L169.55 55.8099V55.8937H169.465H169.423L169.382 55.9775L169.298 55.9356V56.0207V56.0626H169.256L169.213 55.9775H169.171L169.213 56.0207V56.0626L169.129 56.1045V56.0626L169.087 56.0207L169.045 56.0626L168.961 56.1464H169.003V56.1883H168.961V56.2302L168.918 56.1883L168.876 56.2302H168.834H168.876L168.834 56.2734L168.792 56.3153L168.751 56.2734V56.3991H168.709V56.441V56.4829L168.751 56.568L168.709 56.6099V56.568V56.6099H168.665V56.6936H168.709L168.751 56.7774H168.665L168.709 56.8206H168.665V56.8625H168.709V56.9463L168.582 56.9044L168.624 57.072H168.582V57.0301H168.498V57.072L168.582 57.199H168.498L168.54 57.2409L168.456 57.2828L168.414 57.3247H168.329V57.3679L168.245 57.4098V57.4936H168.203H168.161V57.5355V57.5774L168.203 57.6206L168.161 57.6625L168.203 57.7463H168.161L168.119 57.83L168.076 57.8719L168.119 57.9151L168.076 57.957H168.119H168.076L168.119 57.9989L168.076 58.0408H168.034L168.076 58.0827V58.1246V58.1665L168.119 58.1246L168.161 58.1665L168.034 58.2516L168.076 58.4192V58.5043L167.992 58.5462L168.034 58.5881V58.6719L167.992 58.757V58.8408V58.9245V58.9664L167.909 59.0096V59.0934V59.1353L167.824 59.1772L167.867 59.261L167.824 59.3461L167.74 59.388L167.698 59.5137H167.656H167.614H167.571H167.529V59.6407V59.6826L167.487 59.6407L167.403 59.7245L167.32 59.7664V59.8934L167.276 59.9353H167.234V60.019V60.0609H167.193V60.146L167.151 60.1041L167.109 60.1879H167.067L167.025 60.2717H166.982H166.898L166.856 60.3555L166.729 60.4406V60.4825H166.645L166.603 60.5244V60.5663H166.562V60.6082H166.478V60.6514H166.435L166.478 60.6082H166.393L166.351 60.6514V60.7352H166.309V60.819V60.8609L166.225 60.946V60.9879L166.182 61.0298L166.225 61.1135V61.1986L166.267 61.2405L166.225 61.2824L166.267 61.3662V61.4081L166.225 61.45L166.182 61.4081L166.098 61.45L166.14 61.4932L166.098 61.5351V61.6189L166.056 61.6608V61.7027H166.014L166.056 61.8716H166.014H165.972L165.887 61.9973H165.845L165.803 62.0824L165.72 62.0405V62.1243H165.678H165.635L165.593 62.208L165.425 62.2931L165.467 62.335L165.425 62.3769V62.4607L165.383 62.5445H165.425L165.34 62.6296V62.7134L165.256 62.7972V62.8823L165.172 63.008L165.087 63.135L164.878 63.3444L164.793 63.5971L164.625 63.8079L164.583 63.8498L164.498 63.8917L164.414 63.9349L164.331 64.0606L164.162 64.1863L164.036 64.1444H163.951H163.867L163.783 64.1025L163.741 64.1444L163.698 64.0606H163.614L163.489 64.0187L163.404 64.1025L163.32 64.2295L162.52 64.8605L162.015 65.2808L161.805 65.4496L161.678 65.5334L160.962 66.1226L160.878 66.2077L159.7 67.1333L159.573 67.2171L159.531 67.1752H159.489L159.447 67.2171L159.489 67.3022L159.363 67.386L159.32 67.4698L158.731 67.8913L157.511 68.902V68.9439V68.9858L157.553 69.0277L157.637 69.0696H157.722V69.1115H157.974L158.142 69.1534H158.184L158.269 69.3223L158.437 69.3642H158.522H158.731L159.026 69.4061H159.111L159.236 69.3642L159.278 69.3223H159.363L159.405 69.2804H159.447L159.573 69.2385L159.7 69.2804L159.742 69.1966H159.784L159.868 69.2385L159.911 69.3223L159.953 69.3642L160.036 69.4493V69.4912V69.575L160.078 69.6588L160.162 69.7858V69.8695V69.8276L160.205 69.8695L160.331 70.0384L160.373 70.0803L160.458 70.1222L160.542 70.1641L160.753 70.206H160.878L160.962 70.2911L161.005 70.333L161.089 70.3749L161.342 70.5438V70.6276V70.7533L161.3 70.8384L161.173 71.091L161.089 71.2167L161.005 71.2586L160.962 71.3005H160.92L160.794 71.3424L160.5 71.3005L160.415 71.3424L160.373 71.4275L160.331 71.5113V71.6802V71.7221L160.373 72.0166V72.0585L160.415 72.1004L160.5 72.2274L160.667 72.395V72.4369L160.753 72.5639V72.6058V72.7328L160.626 72.8166L160.373 72.8585L160.289 72.9004L160.205 72.9842L160.12 73.1111L160.078 73.1949V73.28L160.12 73.3219L160.289 73.3638L160.415 73.5314V73.6165L160.373 73.7422L160.289 73.8273L160.12 73.953L159.911 74.0368L159.742 73.9949L159.658 74.0368L159.573 74.1219L159.489 74.2057V74.3313V74.4583L159.531 74.584L159.573 74.7948L159.616 74.8786L159.573 74.9218V74.9637L159.616 75.0475L159.7 75.0894L159.784 75.1313L159.826 75.1732L159.868 75.3002L159.826 75.4677L159.784 75.5109L159.7 75.4677L159.531 75.342L159.405 75.3002H159.068L159.026 75.342L158.942 75.4677L158.9 75.5528L158.773 75.6785L158.689 75.7204L158.395 75.9731L158.311 76.142L158.269 76.1839L158.184 76.3109V76.4365L158.1 76.5203L158.058 76.6473V76.7311L158.142 76.9838V77.1527L158.1 77.2365L158.058 77.3203L157.931 77.4054L157.595 77.4892L157.469 77.6999L157.384 77.7837H157.342L157.131 77.8675H157.047H156.964H156.922H156.753L156.5 77.9094L156.416 77.9513L156.333 77.9945L156.164 78.0783H155.869L155.785 78.204L155.7 78.2891L155.448 78.4567L155.28 78.6255L155.027 78.7512L154.9 78.7944H154.858L154.817 78.8782L154.691 79.0039L154.648 79.089V79.2147V79.2985L154.691 79.3417L154.775 79.6363V79.72V79.8889V79.9308V80.3092L154.817 80.6889L154.858 80.8564L154.817 80.9834L154.691 81.1929L154.648 81.3618L154.522 81.5307L154.396 81.6983L154.311 81.8253V81.8672L154.227 81.9509L153.975 82.2036L153.806 82.4144L153.722 82.582L153.638 82.6252L153.596 82.9617V83.0873L153.722 83.34V83.3819L153.849 83.6765L153.891 83.7616L153.975 83.8454L154.144 83.9292L154.353 84.098L154.48 84.1818L154.606 84.3507L154.733 84.4345L154.9 84.4764L154.985 84.5183L155.027 84.6034V84.6453L154.985 84.7291L154.944 84.771V84.898V84.9399L154.985 85.2344L154.944 85.4033V85.5709L154.858 85.6979L154.9 85.9087V85.9925V86.2033L154.858 86.287L154.775 86.3289V86.3708L154.733 86.4127V86.5397L154.691 86.6235L154.733 86.7505L154.691 86.96L154.648 87.087L154.606 87.1708L154.522 87.3397L154.396 87.5923L154.353 87.9288L154.311 88.0545L154.227 88.2653L154.144 88.3491L154.017 88.4342L153.849 88.5179H153.806L153.638 88.7706L153.596 88.8963L153.553 88.9814L153.511 89.3598V89.4436L153.427 89.5705L153.175 89.7813L153.133 89.907L153.049 89.9908L153.006 90.1597L152.922 90.2854L152.628 90.7069L152.459 90.9596L152.333 91.1272L152.291 91.2123L152.164 91.2542H151.997L151.744 91.338L151.449 91.5907L151.364 91.6326L151.28 91.7595L151.197 91.8433L151.113 92.0122L151.07 92.1379L150.733 92.4325L150.691 92.5595V92.6433L150.649 92.7703L150.566 92.9378L150.397 93.1905L150.355 93.2324V93.3162V93.3594L150.144 93.527L149.975 93.7378H149.808L149.766 93.9904L149.639 94.0323L149.555 94.1161L149.471 94.2012V94.2431L149.428 94.4107V94.4539V94.6215V94.6634L149.386 94.8323L149.218 95.0012L149.133 95.2957V95.3795V95.4633H149.091V95.5052L149.175 95.6322L149.218 95.7579L149.133 95.843L149.091 95.9268V96.0525L149.049 96.1376L149.008 96.2213L148.924 96.2632V96.4321L148.839 96.5578V96.6848L148.797 96.7267V96.8105L148.544 97.1051L148.502 97.3158L148.46 97.4428L148.418 97.5685L148.377 97.6104L144.546 97.3577L143.199 97.2739L141.683 97.1902L140.715 97.1051L135.79 96.7686L133.516 96.5997H133.179L130.359 96.3902L127.539 96.1794L124.298 95.9268L121.183 95.6741L120.425 95.6322L118.783 95.4633L113.858 95.0849L111.585 94.8742L110.869 94.8323L108.427 94.6215L108.258 94.6634H108.175H108.133V94.7066L108.007 94.7904L107.88 94.8323H107.838L107.796 94.7485V94.6634L107.754 94.5796V94.3688V94.285H107.712L107.585 93.9486L107.502 93.8216L107.333 93.7797L107.249 93.7378L107.165 93.7797H107.122L106.744 93.7378L106.66 93.6959L106.407 93.7378L106.322 93.6959L106.238 93.654L106.155 93.6121L106.113 93.527L106.028 93.4432L105.986 93.4013V93.3594L106.028 93.2743L105.986 93.1486L106.113 92.9797V92.8959L106.071 92.8122L105.986 92.7703V92.6433L105.902 92.6014L105.818 92.4744L105.775 92.3487L105.523 92.2217L105.186 91.8014L105.144 91.7595L105.06 91.7177L104.933 91.6758L104.849 91.6326L104.807 91.6758L104.597 91.7177H104.513L104.471 91.6758L104.429 91.5488L104.218 91.5069H104.007L103.882 91.3799L103.797 91.338L103.755 91.2961L103.797 91.1272V90.9596L103.713 90.8758H103.587H103.502L103.376 90.7907L103.082 90.6232L102.871 90.7069H102.702L102.66 90.5813L102.702 90.3705L102.618 90.1178L102.535 89.9908L102.493 89.9489L102.535 89.6543L102.449 89.6124L102.366 89.5705V89.5287L102.324 89.4017L102.408 89.3179L102.449 89.1909L102.408 89.149L102.282 89.0652V89.0233L102.324 88.9395V88.8544L102.155 88.6436L102.113 88.5179V88.476L102.24 88.2653V88.2234V88.1815L102.155 88.0126V87.9288V87.8869L102.24 87.7599L102.282 87.5491L102.366 87.3397V87.2978V87.2127L102.24 87.0032L102.155 86.96L101.987 86.9181L101.944 86.8762L101.902 86.7924L101.86 86.4546L101.566 86.2033L101.398 85.8655L101.229 85.6979V85.5709L101.187 85.1088L101.145 84.9818L100.935 84.6034L100.893 84.3507L100.808 83.8035L100.766 83.7197L100.682 83.6765H100.598L100.555 83.6346L100.513 83.34V83.2981L100.346 82.8766L100.177 82.582L99.9659 82.3725L99.7983 82.0347L99.7551 81.9509L99.4186 81.7402L99.3348 81.6983V81.7402L99.251 81.6564L99.124 81.4875V81.4037L99.0822 81.1929L99.124 80.9402L99.0403 80.6038L98.9146 80.4781L98.8714 80.3092L98.7876 80.2673L98.7457 80.1835L98.6619 80.0146H98.6187L98.493 79.9727L98.366 79.8457L98.1565 79.4674L98.0714 79.3836L97.9877 79.2985L97.8201 79.2566H97.7769L97.735 79.1309L97.6512 79.089L97.4823 78.8782L97.3147 78.4148L97.2715 78.204L97.1877 78.0783V77.531L97.2715 77.3622L97.3985 77.2365L97.5242 77.0257L97.862 76.7311L97.9877 76.6892L98.0714 76.5622L98.1146 76.4784L98.1565 76.2677L98.1984 76.2258H98.366H98.4092V76.1839L98.493 76.142L98.5349 76.0582L101.018 70.5438L101.987 68.3548L102.535 67.1752L102.955 66.1658L104.807 62.1243L106.238 59.0096L106.66 58.0827L106.913 57.4936L107.08 57.072L107.544 56.0207L107.796 55.4316L107.838 55.3884L108.554 53.7898L109.016 52.7791L109.227 52.2319L109.564 51.5576L109.901 50.8009L110.069 50.4212L110.027 50.3793H109.943L109.858 50.3374L109.733 50.2955L109.691 50.2536V50.2117L109.943 49.874L109.985 49.7902V49.6645L110.027 49.5794L110.153 49.2848L110.196 49.2429L110.322 49.1591L110.533 49.1172L110.953 48.9065L111.205 48.7376L111.374 48.6119L111.542 48.443L111.711 48.1484L111.922 47.812L111.963 47.7269V47.685L111.669 47.7701H111.585H111.5H111.416L111.374 47.812L111.332 47.8539L111.291 47.8957L111.164 47.8539L110.996 48.0646L110.827 48.1065L110.743 48.1484L110.7 48.1903V48.2741H110.658L110.616 48.4011L110.533 48.443H110.406L110.28 48.4011L110.196 48.443L110.153 48.5268L110.027 48.6119H109.943L109.858 48.5268L109.816 48.4849L109.733 48.5268L109.649 48.57L109.606 48.6119L109.438 48.4011H109.353H109.311L109.227 48.4849L109.102 48.5268L109.058 48.6119L108.975 48.6538L108.933 48.6119H108.849V48.6538L108.807 48.8214L108.764 48.8646L108.722 48.8214H108.638L108.511 48.8646H108.344L108.217 48.7795L108.175 48.6957L108.049 48.6538L107.922 48.6119H107.838L107.796 48.57V48.4011L107.922 48.2322L108.049 48.1065L108.091 47.9795V47.9376V47.812L108.049 47.685L108.007 47.6431L107.922 47.5593H107.838L107.669 47.6431H107.417H107.333L107.249 47.6012L107.122 47.4323L106.996 47.3485L106.954 47.3066H106.913L106.66 47.2647L106.618 47.2228L106.575 47.0958L106.491 47.012L106.449 46.9282L106.196 46.9701L106.155 46.9282L106.028 46.6337L105.944 46.5486L105.902 46.4229L105.986 46.3378V46.2959L105.944 46.254L105.86 46.2121V46.1702V46.1283L105.775 46.0432L105.649 46.1702L105.565 46.0013H105.438H105.355V45.9594L105.313 45.9175L105.355 45.7486V45.7067L105.271 45.7905L105.228 45.7067L105.186 45.7486H105.144L105.102 45.6649L105.018 45.7067L104.976 45.7486H104.933L104.849 45.7067L104.807 45.6649L104.849 45.623L104.807 45.5811H104.765V45.623L104.724 45.7067H104.68V45.6649H104.513L104.471 45.7905L104.344 45.7067L104.218 45.6649L104.26 45.7486L104.176 45.7905L104.049 45.6649L103.924 45.7486L103.882 45.6649L103.966 45.623V45.5392H103.924L103.882 45.496V45.4122H103.797L103.713 45.5392L103.629 45.496L103.671 45.4122V45.3703L103.418 45.4541L103.376 45.3703V45.2865L103.291 45.3284L103.249 45.2865L103.207 45.2014L103.082 45.2865L103.124 45.1176H103.039L102.997 44.9906H102.955H102.871L102.744 44.9068L102.702 44.9487L102.66 44.8649L102.702 44.823L102.618 44.7392L102.576 44.7811V44.823L102.324 44.8649L102.282 44.823L102.155 44.9068L102.071 44.7811H101.987L102.029 44.696L101.987 44.6122L101.944 44.5285V44.3177L101.86 44.3596L101.735 44.3177V44.3596L101.65 44.3177L101.566 44.3596H101.524V44.3177V44.2339H101.482H101.44L101.398 44.1488L101.355 44.1069L101.313 43.9812H101.271V43.9393L101.145 43.8961V43.8542L101.018 43.8123H100.935L100.808 43.8961L100.766 43.8123L100.724 43.8542L100.682 43.8123L100.724 43.7285L100.682 43.6866L100.555 43.6447L100.471 43.6866H100.429V43.5596L100.304 43.5177V43.434L100.346 43.3921H100.26L100.177 43.307V43.2232V43.1394L100.219 43.0975V42.9705L100.346 42.5921L100.387 42.5502V42.4232L100.304 42.3395L100.346 42.2125V42.1287L100.304 42.0868L100.135 42.0449L100.093 41.9179V41.876L100.051 41.7922L99.9659 41.7503H99.924L99.6713 41.9179L99.6294 42.003L99.6713 42.0449L99.5875 42.1287L99.4186 42.1706V42.2976L99.3767 42.3395L99.2091 42.5502L99.1659 42.5921L99.0403 42.4232L98.9565 42.3814L98.8295 42.1706L98.6619 42.1287L98.5768 41.9611H98.493V42.003L98.1565 42.0449L98.1984 41.9611L98.0714 41.9179L98.0295 41.7922L97.9877 41.8341L97.9458 41.7922V41.7503L97.9039 41.7084V41.5395L97.7769 41.4125L97.735 41.3706H97.6931H97.6512H97.6093L97.5242 41.2869L97.5674 41.1612L97.5242 41.118L97.5674 41.0342L97.6093 40.9923V40.9504V40.9085L97.5242 40.8666V40.7815L97.3566 40.6558L97.3985 40.5288L97.3566 40.445L97.4823 40.4031V40.3612L97.3147 40.2342H97.2715V40.2761H97.2296L97.1877 40.1924H97.1458L97.1039 40.1086V40.0235L97.062 40.0667L97.0201 40.0235L96.9769 40.0667H96.935V40.0235L96.6824 39.8559V39.814L96.6405 39.7721V39.7289H96.5986L96.5148 39.6451V39.6032H96.4297L96.3459 39.5613L96.2202 39.3086L96.1351 39.2667L96.0932 39.3086L96.0513 39.2667V39.2235L95.9256 39.0979L95.7987 39.056V39.0141L95.7568 38.8452H95.7149V38.8033L95.6311 38.7195V38.6344L95.673 38.5925V38.4668L95.6311 38.4249V38.2979H95.7149L95.7568 38.2141V38.1722V38.0452L95.7149 37.9615L95.673 37.9196L95.6311 37.7507L95.673 37.5399L95.6311 37.498H95.5879L95.546 37.3723L95.4203 37.3304L95.3352 37.2034L95.2514 37.1615L95.2095 37.2034V37.1615H95.0838V37.1196L94.9149 37.0358L94.746 36.9088V36.6143L94.7879 36.5305V36.4886V36.4035H94.746L94.7042 36.1927V35.9832L94.8311 35.7306V35.6455L94.7879 35.6036L94.8311 35.2252L94.746 35.1414H94.7042L94.6623 35.0982V34.9306L94.6204 34.8468V34.8036V33.0362V26.8476ZM174.012 41.5814V41.5395V41.4976H174.054H174.138L174.096 41.5395H174.138L174.181 41.7084V41.7922L174.138 41.7503L174.054 41.6233L174.012 41.5814ZM168.287 39.2667L168.245 39.3086L168.287 39.2667ZM173.338 40.6977V40.7396H173.296V40.6977H173.338ZM168.119 39.3086H168.161H168.119V39.3505V39.3086ZM170.813 39.9816H170.854V40.0235H170.813V39.9816ZM172.581 40.8234L172.539 40.7815L172.581 40.7396L172.623 40.7815H172.581L172.623 40.8234H172.581ZM171.823 41.1612H171.781H171.823V41.118H171.865V41.1612H171.823ZM163.151 38.929L163.194 38.8871L163.236 38.929H163.194V38.9722L163.151 39.0141V38.9722V38.929ZM172.202 41.1612V41.0761L172.243 41.0342H172.287L172.243 41.0761V41.2031H172.202V41.1612ZM168.161 39.1397H168.245V39.1816L168.287 39.1397L168.329 39.1816L168.161 39.2235V39.1397ZM172.118 40.7815L172.076 40.8234H172.034V40.9085L171.865 41.0342L171.907 40.9085L171.992 40.7396V40.6977L172.034 40.6558L172.076 40.6977L172.118 40.7396V40.7815Z"
							fill="#6ba4da" />
						<path class="hover:!opacity-50 transition-all duration-300"
							d="M168.119 39.3086H168.161H168.119ZM168.119 39.3086V39.3505V39.3086ZM171.823 41.1612H171.781H171.823ZM171.823 41.1612V41.118H171.865V41.1612H171.823ZM94.6204 26.8476H94.7042L94.746 26.8908L94.7879 27.0165H94.8311L94.873 27.1434H94.9149L94.9987 27.1002L95.0406 27.1434V27.2272H95.0838L95.1676 27.1434L95.2095 27.1853L95.2514 27.1002H95.3352L95.3784 27.1434L95.4203 27.0583L95.5041 26.9746L95.5879 27.0583L95.7568 26.8057L95.7149 26.7638V26.68L95.7568 26.5111V26.4692L95.7987 26.4273H95.8824H95.9675V26.5111L96.0513 26.553L96.1351 26.4692L96.2202 26.5111L96.2621 26.4692L96.3459 26.5111L96.3878 26.553L96.5148 26.5962V26.6381H96.5567L96.5986 26.553V26.5111H96.6405L96.6824 26.4273V26.4692H96.7675H96.8094L96.8513 26.5962V26.6381L96.8932 26.5962L96.935 26.68V26.5962L96.9769 26.553L97.062 26.5962H97.1039V26.4273L97.1877 26.3854L97.2296 26.3435V26.3003V26.0908L97.3147 25.9638L97.2715 25.922V25.9638L97.1458 25.8801L97.1877 25.8382L97.0201 25.7531V25.7112L97.062 25.6693V25.6274L97.1039 25.5855L97.062 25.5017L97.0201 25.4585V25.3747L97.1039 25.3328L97.1458 25.3747H97.2296L97.3147 25.3328L97.3985 25.4166L97.4404 25.3328H97.5242H97.5674H97.7769L97.862 25.249L97.8201 25.2058H97.7769L97.735 25.122V25.0801L97.7769 25.0382L97.735 24.9963V24.9112L97.9039 24.8693L97.9458 24.8275V24.7856V24.7437L98.0295 24.7018V24.6586L98.0714 24.6167L98.1146 24.5329L98.1565 24.491L98.2403 24.5329L98.1984 24.7018H98.366V24.6586L98.493 24.7018L98.5349 24.6586L98.5768 24.7018V24.7437L98.6619 24.7856L98.7038 24.8275L98.8714 24.7018H98.9565V24.6586L99.0403 24.7018L99.1659 24.7437L99.2091 24.8275V24.8693V24.9544L99.251 25.0382V25.0801L99.3767 25.122H99.4605L99.5456 25.0382H99.6294V25.0801H99.7551V24.9963L99.7983 24.9544L99.924 24.9963L100.008 25.0801V25.0382L100.135 25.122V25.0382L100.177 24.9963V24.9544L100.26 24.8275L100.219 24.7856L100.26 24.7437L100.219 24.7018H100.26L100.304 24.6586L100.26 24.5748L100.304 24.491L100.26 24.364H100.304V24.2802L100.135 24.1964L100.177 24.1545H100.219V24.1113H100.304L100.346 24.1545L100.387 24.1113L100.429 24.1545L100.471 24.1964H100.64H100.724L100.766 24.1113V24.0694L100.808 24.0275H100.85H100.893H100.935V23.9856L101.102 24.0694V23.9856L101.145 23.9018V23.9437H101.187H101.271L101.355 23.9018L101.398 23.9437L101.44 23.9018L101.398 23.8167H101.44V23.6911L101.524 23.733L101.566 23.6492L101.608 23.6911H101.65V23.733L101.735 23.6911L101.818 23.733L101.902 23.6911L101.944 23.733H101.902H101.987L101.944 23.6492H101.987L102.029 23.733V23.7748L102.113 23.8167H102.197V23.7748L102.24 23.8599L102.282 23.9018H102.324V23.9437L102.449 23.9018V23.8599H102.535L102.618 23.9018L102.66 23.8599L102.744 23.8167H102.787V23.9018H102.829L102.871 23.8599L102.955 23.9018V23.8599H103.039V23.7748L102.997 23.733L103.082 23.6911L103.124 23.6492L103.166 23.6911V23.6492V23.5654L103.207 23.4803H103.249L103.291 23.4384L103.249 23.3127L103.291 23.2695H103.334L103.376 23.2276H103.418L103.587 23.1857V23.1438L103.629 23.06L103.671 23.0168L103.629 22.933L103.713 22.8492L103.671 22.7654L103.713 22.7222L103.671 22.6803V22.6385V22.5128H103.713L103.882 22.4709V22.4277L103.966 22.3858L104.049 22.4277H104.091L104.176 22.302V22.2601L104.091 22.2182L104.176 22.175V22.1331L104.218 22.0493L104.26 22.0912L104.344 22.0493L104.429 22.0912L104.471 21.9655L104.638 22.0493H104.724L104.68 22.0912L104.765 22.175L104.807 22.2601H104.849L104.891 22.302L104.933 22.3439V22.2182L105.06 22.175L105.144 22.0493H105.228L105.271 22.0074L105.313 21.9655L105.438 22.0074L105.48 21.9223L105.649 21.8804V21.8385V21.7547H105.691L105.775 21.7966L105.818 21.7547L105.86 21.7966V21.8804L105.902 21.9223L105.944 21.9655V22.1331L105.986 22.2182H106.028H106.071L106.155 22.2601L106.196 22.302L106.238 22.3858L106.28 22.4709H106.322L106.365 22.5128H106.491L106.533 22.5547L106.575 22.4709L106.618 22.4277H106.66H106.702L106.869 22.3858L106.954 22.4709V22.5128L107.038 22.5547L107.08 22.5966H107.207H107.249V22.6385L107.333 22.5966L107.375 22.6385H107.417V22.6803H107.46L107.502 22.7222H107.544L107.627 22.7654H107.585L107.627 22.8073V22.8492L107.669 22.8911V22.8492V22.8073L107.754 22.7654L107.796 22.7222L107.838 22.6385L107.88 22.5966L107.922 22.5547L108.007 22.5128V22.4709H108.049L108.091 22.3858L108.217 22.4277L108.344 22.4709V22.4277L108.385 22.4709H108.554V22.3858H108.596L108.68 22.302L108.722 22.2601L108.807 22.3439H108.849L108.891 22.3858L108.975 22.5128H109.102L109.143 22.4709H109.227L109.311 22.4277L109.353 22.3439H109.48L109.564 22.2182L109.649 22.2601L109.774 22.2182L109.816 22.2601H109.858H109.901H109.943V22.302L110.027 22.3858H110.069L110.111 22.4277H110.153V22.3439H110.28L110.364 22.302L110.447 22.3439H110.491L110.574 22.4277H110.658L110.7 22.5128H110.743H110.785L110.869 22.5966L110.953 22.6803L111.08 22.7222L111.122 22.5966L111.247 22.5547L111.291 22.5966H111.332H111.458L111.5 22.5547L111.542 22.6385H111.585H111.627L111.711 22.7222L111.753 22.7654V22.8492H111.836V22.8911L111.88 22.8492L111.963 22.8911L112.005 22.8492H112.047V22.933H112.089V22.8911H112.174H112.258H112.3H112.342L112.385 22.933H112.427L112.595 23.0168V22.9749H112.68L112.722 22.933L112.763 22.8911L112.847 22.933L112.974 22.7654L113.1 22.6803L113.184 22.6385V22.5128L113.058 22.4277V22.3439L113.016 22.302L113.058 22.2601L112.974 22.0074V21.9655H113.016H113.058L113.1 22.0074L113.142 21.9223V21.8804V21.8385V21.7966L113.184 21.7547V21.6709L113.142 21.6277L112.974 21.544L113.016 21.4602V21.4183H112.974L112.889 21.3332L112.763 21.3764L112.722 21.2494L112.763 21.2075H112.722V21.1237L112.68 21.0805H112.636L112.595 21.0386L112.636 20.9967L112.553 20.871H112.469H112.342L112.3 20.7859L112.258 20.744H112.216V20.7021L112.3 20.6602L112.342 20.5764V20.5332H112.3V20.4913L112.258 20.4495H112.216L112.132 20.3657L112.089 20.4076L112.047 20.3238L111.963 20.3657H111.88L111.836 20.3238L111.795 20.2819L111.711 20.2387V20.1968L111.795 20.1549V20.113L111.88 20.0292V19.9441L111.922 19.9022L112.005 19.8603V19.8184L111.963 19.7765L112.005 19.6914V19.6076V19.5657L112.047 19.5238H112.089V19.5657H112.132L112.174 19.6495L112.216 19.7333L112.258 19.7765L112.385 19.8184V19.7765L112.427 19.7333V19.6914V19.6495L112.385 19.6076H112.342V19.5238L112.427 19.4819V19.4387L112.469 19.355H112.511L112.553 19.2712L112.636 19.2293L112.68 19.1874V19.1442H112.636H112.595L112.553 19.0604L112.511 19.1023V19.0185L112.636 18.9347V18.8496L112.68 18.8077L112.722 18.7658L112.636 18.7239V18.6401L112.68 18.5969L112.722 18.555H112.763L112.974 18.5131L113.058 18.555V18.5969H113.142L113.184 18.6401L113.227 18.682L113.269 18.7239L113.311 18.8077H113.353L113.394 18.8496H113.48V18.9347L113.605 18.9766L113.9 19.0185L113.942 18.9766L114.025 19.0185L114.069 19.1023L114.025 19.1442L114.069 19.1874L114.152 19.3131L114.321 19.355H114.405L114.447 19.2293L114.574 19.2712L114.7 19.2293L114.784 19.2712H114.869L114.952 19.2293L114.994 19.1874H115.036L115.078 19.1442L115.12 19.1874L115.205 19.1442L115.247 19.2293L115.373 19.1874H115.5V19.1442L115.669 19.1023L115.794 19.1442H116.131L116.383 19.2712L116.636 19.0604L116.552 18.8928L116.805 18.6401H117.058L117.309 18.7239L117.478 18.5969L117.689 18.3442L118.025 18.3023L118.152 18.555L118.403 18.3874L118.741 18.1348L119.078 18.2186L119.162 18.5969L119.289 18.7239L119.583 19.1442L119.541 19.1874V19.2712L119.583 19.3131L119.625 19.355L119.961 19.7333L120.003 19.8184L120.045 19.9441H120.003L119.961 20.0292L120.003 20.0711L119.961 20.113V20.2387L120.003 20.3657L120.13 20.4913L120.172 20.5332L120.214 20.6183H120.256V20.7021L120.214 20.744V20.7859L120.13 20.8278V20.871L120.088 20.9129L120.003 20.9548V21.0386H119.961L120.003 21.0805L119.961 21.1656L120.003 21.2494L119.92 21.2913L119.961 21.4602H119.92V21.544L119.961 21.5858V21.6709L120.003 21.7547L120.045 21.8385L120.088 21.8804L120.13 21.9223L120.214 21.9655L120.172 22.0493H120.256L120.298 22.0912V22.1331V22.175H120.256V22.2182L120.214 22.302H120.172L120.214 22.5128L120.256 22.5547V22.5966V22.6385L120.298 22.7222V22.8911L120.34 22.933L120.383 22.9749V23.0168H120.425L120.298 23.1019L120.34 23.1857L120.298 23.2276V23.2695L120.34 23.3127V23.3546L120.509 23.3965H120.636V23.3546L120.678 23.3965H120.761L120.803 23.4384L120.93 23.3965H120.972L121.098 23.3127L121.183 23.3546L121.225 23.3127L121.351 23.3546L121.434 23.3127V23.3546L121.645 23.3965L121.687 23.4384L121.73 23.4803L121.814 23.5222H121.856L121.898 23.5654L121.983 23.5222V23.4803L122.067 23.5222V23.4803H122.109L122.277 23.5222L122.361 23.4803H122.403H122.487L122.572 23.5654L122.614 23.4384L122.781 23.5222V23.5654H122.825V23.6073H122.908L122.95 23.5654V23.6073H122.992H123.076L123.034 23.6492H123.076L123.119 23.6911H123.161V23.733L123.245 23.6911L123.203 23.733L123.161 23.7748L123.245 23.8167L123.287 23.7748L123.329 23.8167H123.287L123.329 23.8599L123.287 23.9018L123.329 23.9437V23.9856L123.414 23.9437L123.456 23.9856H123.54V24.0694L123.623 24.1113L123.708 24.1545L123.75 24.2802L123.792 24.3221V24.1964L123.834 24.1113H123.876V24.1964H123.918H124.003L124.045 24.2383V24.1964L124.087 24.2383V24.3221H124.171L124.129 24.364L124.214 24.4491V24.491H124.171V24.5329H124.214L124.256 24.6167L124.298 24.5748L124.339 24.5329V24.5748L124.298 24.6586L124.256 24.7437V24.7856H124.381L124.466 24.9544L124.423 25.0382L124.466 25.0801L124.423 25.1639V25.2058H124.508L124.466 25.1639L124.55 25.122L124.592 25.1639H124.634L124.718 25.0801L124.803 25.122L124.845 25.0801L124.803 25.0382H124.845L124.929 24.9963L124.97 25.0801V25.2058V25.2909L125.056 25.249L125.139 25.2909L125.181 25.2058L125.265 25.249V25.3328L125.308 25.2909L125.392 25.3328H125.434L125.392 25.4166V25.4585L125.35 25.5017V25.5436H125.392L125.476 25.5017V25.4166H125.603L125.645 25.5017H125.729V25.5436L125.687 25.7112V25.7531L125.729 25.7112L125.856 25.7531L125.939 25.7112V25.7531L125.897 25.7963V25.8382L126.023 25.7963L126.065 25.8382H126.15L126.192 25.7963L126.15 25.7531L126.065 25.6693L126.107 25.6274H126.192L126.276 25.6693L126.318 25.7531L126.36 25.7963H126.403L126.445 25.7112L126.487 25.7963L126.655 25.8382V25.7963L126.739 25.7112V25.6693L126.697 25.5855L126.739 25.5436L126.865 25.6274V25.6693L126.739 25.7963L126.781 25.8801L126.823 25.922L126.907 25.8382L126.95 25.8801V25.922H127.034L127.076 25.7531L127.159 25.7112L127.201 25.7963L127.159 25.8801L127.201 26.0057L127.159 26.0489L127.076 26.0908L127.118 26.1746H127.201L127.245 26.0908L127.497 26.0489L127.623 26.1746L127.665 26.1327V26.0908H127.792L127.834 26.1327L127.876 26.2584L127.792 26.3003L127.707 26.3435V26.5111H127.75L127.876 26.553L127.918 26.6381L127.876 26.7638L127.792 26.8476V26.8908L127.834 26.9746H127.918L128.254 26.8057L128.465 26.8476V26.8057L128.507 26.7638H128.549V26.8908L128.592 27.0165L128.676 27.1002L128.717 27.1853L128.676 27.311V27.3529L128.634 27.3948H128.549L128.465 27.3529H128.423L128.339 27.438V27.5218V27.6056V27.8164L128.381 27.8583L128.465 27.9421V28.0272H128.507L128.549 28.111V28.1528L128.507 28.1947V28.2366L128.549 28.3636L128.592 28.4055L128.634 28.4474V28.6163L128.592 28.6582L128.634 28.7852L128.928 28.9947L128.97 29.0366L129.307 29.2055L129.39 29.2892L129.475 29.4581L129.601 29.5419L129.854 29.7108L129.896 29.7527H129.938L129.981 29.7946L130.023 29.9216L130.19 30.0473L130.234 30.1311L130.275 30.2581L130.317 30.3L130.401 30.2581L130.528 30.3418V30.3837L130.485 30.4256L130.443 30.6783L130.275 30.8891L130.234 31.0161V31.0999L130.275 31.1837V31.2688L130.234 31.3107L130.148 31.3945L130.19 31.4363L130.107 31.5633L130.19 31.6052L130.234 31.6471L130.148 31.8579L130.19 32.0255V32.1106V32.1525L130.107 32.2782L130.148 32.4052L130.275 32.489L130.317 32.6146L130.359 32.7835L130.485 32.8673L130.612 33.0781L130.57 33.12L130.528 33.247L130.57 33.4578L130.654 33.4997L130.738 33.6253L130.865 33.7091L130.906 33.7942L130.948 33.8361V33.9618L130.99 34.0469L131.117 34.0888L131.075 34.3415L131.159 34.4253L131.285 34.5091L131.328 34.5523V34.7617L131.37 34.9725L131.412 35.1414L131.579 35.6036L131.623 35.6455L131.79 35.6887L131.959 35.6455L132.085 35.6887L132.127 35.7306L132.17 35.8143L132.212 35.8981L132.674 36.2359L132.717 36.4035L132.801 36.4886L132.927 36.5724H133.012L133.095 36.6562L133.137 36.74V36.9088L133.054 37.0777V37.2034L133.137 37.3723L133.179 37.4142L133.012 37.6669L133.095 37.7507L133.054 37.8777L133.137 38.0034L133.221 38.0871V38.1722V38.2141L133.39 38.4668L133.474 38.5087H133.559L133.685 38.4249L133.853 38.3817H134.063L134.148 38.4668L134.19 38.6776V38.8033V38.929V38.9722L134.232 39.056L134.274 39.1397V39.2667V39.3086V39.3505V39.3924V39.4762L134.148 39.687V39.7721V39.8559L134.232 39.8978L134.063 40.1086L134.021 40.1924H134.106H134.19L134.316 40.1505L134.443 40.1086H134.485L134.568 40.0235L134.61 40.0667L134.695 40.1505L134.779 40.1924L134.863 40.318L134.905 40.4031L134.863 40.5707H134.821H134.737L134.695 40.6139L134.653 40.6558V40.6977V40.7815L134.779 40.9085V41.118L134.821 41.1612L134.779 41.2869L134.695 41.3706L134.737 41.4125L134.779 41.4557L134.905 41.3706L134.99 41.4557L135.157 41.4976L135.201 41.5395L135.326 41.8341H135.495L135.663 41.9179H135.915L135.999 41.9611H136.295H136.379L136.463 42.0449H136.632V42.0868L136.715 42.2976L136.674 42.4232V42.507L136.715 42.5502H136.757L136.926 42.634L137.052 42.5921L137.094 42.507V42.4651L137.01 42.3814L136.968 42.3395V42.2976L137.052 42.2557L137.137 42.2125L137.305 42.1706L137.432 42.2125V42.1706L137.473 42.1287L137.432 41.9179L137.473 41.876H137.515L137.599 41.9179V41.9611V42.1287V42.1706H137.642L137.684 42.2125V42.1706L137.768 42.003L137.852 41.9611L138.021 42.1287L138.063 42.1706L138.568 42.1287L138.737 42.003L139.199 41.5395L139.283 41.4125L139.326 41.3287V41.2031L139.283 41.0761L139.241 40.6139H139.283V40.4031L139.326 39.9816V39.814V39.7721L139.368 39.7289L139.41 39.6451L139.452 39.6032L139.873 38.8871L140.041 38.7195L140.293 38.4249L140.377 38.3398L140.546 38.2141L140.757 38.0034L140.883 37.7507L140.968 37.4561L141.052 37.3723L141.346 37.0777L141.388 36.74V36.6981L141.43 36.6143L141.515 36.4886L141.557 36.4454L141.683 36.3197L141.768 36.1927L141.935 35.9832L142.019 35.8143L142.23 35.4779L142.482 35.3941L142.862 35.3509L142.988 35.2671H143.03L143.157 35.1833L143.282 35.0563L143.366 34.9306L143.408 34.8887L143.535 34.7198H143.577V34.678L143.704 34.5091L143.746 34.4672L143.999 34.2564L144.082 34.2145H144.166L144.713 34.0469L144.924 34.0037L145.177 33.878L145.64 33.5416L145.766 33.3727L145.893 33.247L146.061 33.12L146.188 32.9943L146.313 32.7416L146.44 32.489L146.524 32.3201L146.65 31.9417L146.777 31.7728L146.819 31.6471L146.86 31.3107L146.986 31.058L147.071 30.8891L147.239 30.7202H147.282L147.324 30.6783L147.619 30.4688L147.829 30.3837L148.25 30.3L148.333 30.2581L148.544 30.2162H148.797H149.175L149.218 30.5945L149.428 30.7634L149.513 31.058L149.555 31.4782L149.513 31.6052L149.471 32.1525V32.3201L149.386 32.5727H149.681L149.891 32.6578H149.933H149.975L150.018 32.6146L150.102 32.6578L150.186 32.6997V32.6578L150.313 32.6997L150.355 32.7416L150.733 32.5727L150.775 32.5308L150.86 32.6146L150.944 32.5727H151.028H151.113L151.238 32.489L151.322 32.5727L151.407 32.6578V32.6146L151.364 32.5308V32.489L151.407 32.4471V32.489H151.449L151.491 32.4471H151.533L151.575 32.4052L151.786 32.3633L151.828 32.4471H151.87L151.828 32.5308H151.87L151.911 32.489L151.955 32.5308H151.997L152.038 32.5727V32.6146L152.164 32.6997L152.249 32.9943L152.333 33.12L152.502 33.4146L152.755 33.7942L153.049 34.2145L153.091 34.2564L153.133 34.2996L153.175 34.2564L153.259 34.2996L153.302 34.3415H153.386V34.3834L153.553 34.4253V34.4672L153.596 34.5091V34.5523L153.553 34.5942H153.511V34.6361H153.638L153.68 34.7198L155.911 35.7306L155.995 35.8981L156.248 36.0251L156.416 36.1508L156.5 36.1927H156.584H156.627V36.1508L156.753 36.1089H156.922L157.006 36.1508L157.047 36.1089L157.131 36.1508L157.174 36.1089H157.258L157.3 36.1508L157.384 36.2359H157.427L157.553 36.3197H157.722L157.805 36.3616H157.889L157.974 36.3197L158.016 36.2778L158.226 36.1927H158.437L158.478 36.2359L158.522 36.1927L158.647 36.2359L158.689 36.2778L158.731 36.2359H158.858H158.942L159.026 36.2778L159.236 36.1927L159.447 36.2778L159.531 36.3616H159.616L159.658 36.4035L159.7 36.4454L159.742 36.4886L159.784 36.6562L159.742 37.0358V37.0777L159.489 37.2872L159.405 37.4142L159.363 37.7507L159.236 37.9196L160.711 38.4249L162.183 38.9722V39.056V39.1816V39.2235H162.225H162.267V39.1397H162.309V39.0979L162.351 39.0141L162.394 38.9722V38.8871V38.8033L162.478 38.7195L162.562 38.7614L162.647 38.6776L162.689 38.7195L162.731 38.6344V38.5506H162.773V38.5087L162.731 38.4668L162.773 38.4249L162.815 38.3817V38.3398L162.773 38.3817V38.2979L162.815 38.256H162.9H163.025L163.067 38.3817V38.4249V38.4668H163.151L163.109 38.5087L163.151 38.5506H163.109L163.151 38.6776L163.109 38.7614L163.067 38.8871L163.025 38.929V38.9722L162.983 39.056H163.025L163.067 39.0141L163.109 38.9722L163.151 39.056H163.194L163.278 38.9722V38.8452V38.8033L163.32 38.7614L163.278 38.6344V38.5506L163.362 38.5087L163.32 38.4668L163.362 38.3817L163.32 38.2979L163.404 38.2141L163.489 38.256V38.2979V38.3398L163.404 38.4249V38.4668H163.446L163.573 38.4249L163.614 38.4668L163.573 38.5087L163.656 38.6776L163.614 38.8033L163.656 38.7614L163.698 38.6776V38.5925L163.741 38.5506V38.5087L163.698 38.4249L163.656 38.3817V38.3398V38.2979L163.783 38.3398L163.825 38.256V38.2141L163.909 38.1722V38.1303H163.993L164.078 38.1722L164.036 38.2141L164.12 38.3817L164.078 38.4249L164.036 38.5087L164.12 38.5506V38.5087H164.162L164.289 38.4249L164.372 38.4668L164.414 38.5925L164.456 38.6776L164.498 38.7195V38.7614L164.456 38.8033V38.8452L164.414 38.8871L164.456 38.929V38.9722L164.414 39.1397H164.456L164.498 39.1816L164.54 39.1397L164.583 39.1816L164.793 38.8033L164.751 38.6776L164.793 38.5925L164.751 38.5087L164.793 38.4668V38.4249L164.92 38.4668V38.5506L165.004 38.5925L165.087 38.7195L165.045 38.8033V38.8452L165.087 38.8871H165.131L165.087 38.9722L165.131 39.0141L165.172 39.056V39.0979L165.214 39.1397L165.256 39.1816L165.383 39.4343V39.4762L165.34 39.6032L165.425 39.5613L165.467 39.6032V39.5194V39.3924V39.2235L165.425 38.929L165.467 38.7614L165.383 38.7195V38.6776L165.467 38.5506H165.425L165.635 38.4668L165.762 38.5087L165.803 38.5506L165.762 38.7195V38.7614L165.72 38.8033V38.8871L165.762 38.8033L165.803 38.8871V38.8452L165.845 38.929H165.887L165.972 38.8452V38.7614H166.098V38.7195L166.014 38.6776V38.6344V38.5925H166.182H166.225L166.351 38.5506L166.393 38.5087L166.52 38.5506L166.645 38.5925L166.603 38.6344V38.6776L166.562 38.5925V38.6344L166.603 38.7195H166.562V38.8033V38.8452L166.645 38.8033L166.687 38.8871L166.729 38.8452L166.772 38.8871L166.814 38.8452L166.729 38.7614L166.772 38.7195L166.814 38.7614V38.7195H166.898L167.067 38.8033L167.151 38.9722L167.067 39.056V39.0979H167.025L166.94 39.056L166.898 39.0979L166.856 39.2235L166.982 39.1816L166.94 39.2235H166.982L167.025 39.1816V39.1397H167.067H167.109L167.151 39.1816L167.193 39.1397H167.151V39.0979L167.234 39.0141V38.9722H167.276L167.234 39.0141L167.32 38.9722H167.361L167.403 39.0141H167.361H167.403L167.361 39.0979L167.32 39.1397L167.361 39.3924H167.32L167.276 39.4762L167.32 39.6451V39.687L167.361 39.6451L167.32 39.6032L167.361 39.5613L167.403 39.6451V39.5194H167.361V39.4762L167.445 39.2667L167.487 39.3505V39.3924V39.3505V39.2667V39.2235H167.529L167.487 39.1816V39.0979H167.529H167.571H167.614L167.698 39.056V39.0141L167.824 38.9722V39.0141V39.056L167.909 39.0979L167.951 39.2235L167.824 39.2667L167.867 39.3086L167.909 39.3505L167.951 39.3924H167.909L167.951 39.4343L167.824 39.5194L167.909 39.4762L167.951 39.5194L167.909 39.5613L167.951 39.6451V39.687H167.992L167.951 39.6451V39.6032H167.992V39.5194L168.034 39.3924L167.992 39.2235L168.076 39.2667L168.034 39.4343V39.687L167.992 39.814V39.8559H168.034L168.076 39.7721L168.161 39.8559H168.203L168.119 39.7721H168.076V39.687L168.119 39.6451V39.4762V39.3924H168.161V39.4343H168.203L168.245 39.3924V39.3505L168.371 39.2667L168.414 39.3086L168.498 39.2235H168.54H168.624V39.2667L168.709 39.4343H168.665V39.3924L168.624 39.4343V39.4762V39.5194L168.582 39.5613H168.624L168.582 39.6451L168.498 39.687V39.7289L168.54 39.7721L168.582 39.687L168.624 39.7289V39.7721H168.665V39.7289L168.709 39.7721V39.814L168.665 39.8559L168.709 39.8978L168.751 40.0667L168.792 40.1086V40.1924H168.751H168.665V40.2342L168.792 40.318H168.834H168.876V40.2761V40.1924H168.918V40.2342L168.961 40.1924H168.918V40.1505V40.1086V40.0235V39.9397L169.003 39.8978H169.087H169.129V39.8559L169.087 39.814V39.7721L169.129 39.814L169.087 39.7289V39.687V39.6451L169.171 39.5613L169.213 39.6032V39.6451H169.256V39.5194L169.34 39.4762H169.298H169.213V39.4343H169.256H169.34L169.423 39.5194V39.5613L169.382 39.6032V39.6451L169.423 39.6032V39.7721H169.256L169.382 39.814L169.423 39.8559L169.382 39.9397H169.34V39.9816L169.256 40.0667H169.298L169.382 39.9816L169.423 40.0235L169.382 40.0667L169.298 40.1505V40.2342H169.34V40.1505L169.382 40.1086V40.1505L169.465 40.1086V40.0235H169.509L169.55 40.1505L169.509 40.1924H169.55V40.2342V40.2761L169.465 40.318V40.4031V40.445L169.509 40.4869V40.4031L169.55 40.318L169.592 40.2342L169.718 40.3612L169.634 40.4031V40.445L169.676 40.4869V40.4031L169.718 40.3612V40.2761H169.676V40.2342H169.718H169.676L169.634 40.1086L169.718 40.0667H169.803L169.845 40.1505L169.803 40.0235L169.845 39.9397L169.887 39.9816L169.929 40.0235L169.971 40.2342L170.013 40.445V40.4869L169.971 40.5707V40.6139V40.5707L170.056 40.4869L170.098 40.445V40.3612L170.056 40.2342L170.098 40.0235L170.223 39.9816L170.265 40.0235L170.307 40.1505L170.392 40.1924L170.35 40.2342H170.392V40.1505H170.434V40.1924L170.476 40.1505L170.434 40.1086H170.35L170.307 39.9397V39.8559H170.392L170.434 39.9397L170.476 39.8978L170.392 39.814L170.476 39.7721V39.7289H170.518L170.603 39.7721V39.814H170.56V39.8559L170.603 39.8978L170.729 39.9397L170.771 39.9816L170.729 40.0235L170.771 40.0667L170.813 40.1086V40.1505L170.854 40.1924L170.813 40.2342V40.1924V40.1505L170.729 40.1924L170.687 40.1086V40.1505L170.729 40.2342H170.687V40.2761L170.645 40.318L170.603 40.2761H170.56L170.645 40.4031L170.518 40.445L170.56 40.4869H170.603L170.645 40.5707V40.6558L170.56 40.7396H170.518H170.476H170.434L170.476 40.7815L170.392 40.8234H170.35L170.307 40.8666L170.392 40.9504H170.434L170.392 40.9085H170.518L170.56 40.8234L170.518 40.9085H170.56H170.645L170.771 40.8234H170.813L170.854 40.7815V40.9085L170.898 40.9504H170.94H170.981L171.065 40.7815V40.7396L171.107 40.6977V40.6558V40.5707V40.5288L171.149 40.4869L171.234 40.5707L171.192 40.6139V40.6558V40.8234L171.234 40.9504V40.9923V40.9504L171.276 40.8234V40.8666V40.7815H171.318V40.8234L171.36 40.7396L171.276 40.6558L171.318 40.5707L171.36 40.6139V40.4869L171.402 40.445H171.445V40.4031H171.402V40.3612L171.487 40.318H171.571L171.654 40.3612V40.4031L171.698 40.445L171.739 40.318L171.781 40.2761H171.823V40.2342H171.781L171.949 40.1924L171.992 40.2761V40.3612L171.949 40.4031L171.865 40.4869H171.823L171.781 40.445L171.739 40.4869L171.654 40.5707V40.6139H171.612L171.571 40.6558L171.612 40.6977L171.654 40.6558V40.6977V40.7396H171.698L171.654 40.7815L171.612 40.7396L171.654 40.8234L171.698 40.8666H171.654H171.612L171.654 40.8234L171.571 40.8666H171.529L171.487 40.9504L171.654 40.9085L171.698 40.9504V41.118H171.654L171.612 41.0761L171.571 41.118L171.612 41.1612V41.245L171.654 41.2031V41.245L171.612 41.3287H171.571L171.612 41.3706L171.654 41.4557V41.3706L171.698 41.2869L171.781 41.3287V41.2869L171.739 41.245V41.2031L171.823 41.245L171.949 41.2031L172.034 41.245V41.3706L171.992 41.4125H171.949L171.907 41.4557V41.5395H171.949V41.4557L172.034 41.4976V41.4557L172.076 41.3706L172.034 41.2031L171.949 41.1612H171.992V41.0761H172.034L172.076 41.0342H172.16V41.2031L172.202 41.3287V41.4125L172.243 41.4557H172.287L172.243 41.3287V41.245L172.287 41.2869V41.2031L172.37 41.118L172.412 41.0761H172.454L172.412 41.118L172.496 41.2031V41.3287V41.4125L172.412 41.4976V41.5814H172.454H172.496H172.581L172.665 41.6652L172.707 41.6233L172.623 41.5395H172.496V41.4976L172.581 41.4557V41.3706V41.245L172.623 41.2031L172.707 41.245V41.2869L172.749 41.4125L172.707 41.4557H172.749V41.4125H172.834L172.749 41.3706L172.792 41.3287L172.749 41.245L172.665 41.1612L172.749 41.0761L172.792 41.118L172.876 41.0342L172.918 41.0761V40.9923L172.876 41.0342L172.792 40.9923L172.876 40.9085V40.8666L172.918 40.7396H172.96V40.6977L173.002 40.7815L172.96 40.6977L173.087 40.6558H173.002H172.96H172.918V40.5707L173.002 40.5288L173.043 40.5707V40.5288H173.087H173.17L173.254 40.445V40.4031H173.296L173.381 40.445L173.423 40.4869V40.6977L173.338 40.6558H173.296L173.254 40.7396L173.212 40.8234L173.338 40.7815L173.296 40.9085L173.212 40.9504L173.17 40.9085L173.212 40.9923L173.17 41.0342L173.129 40.9923V41.0761H173.002H173.129L173.212 41.0342V40.9923H173.254V41.0342L173.212 41.0761L173.254 41.2031L173.212 41.245H173.254L173.296 41.3706V41.4976H173.212L173.17 41.5814L173.043 41.7922L172.96 41.876V42.003L172.876 42.0868V42.1706V42.2125L172.918 42.1287L173.002 42.0868L173.043 42.003L173.087 41.9611V41.8341L173.17 41.7084L173.381 41.5395L173.423 41.4125V41.2031L173.465 41.118L173.507 41.0761H173.591L173.634 41.118L173.591 41.2031V41.245V41.3706V41.4125V41.4557V41.4976L173.507 41.5814L173.423 41.8341L173.296 41.9611H173.338L173.423 41.9179L173.507 42.0449V42.0868H173.549L173.465 41.876L173.507 41.8341L173.549 41.6233H173.591L173.634 41.6652L173.676 41.9179L173.634 41.9611H173.676V41.876H173.718L173.676 41.8341V41.7084L173.634 41.6233L173.676 41.5395L173.718 41.4976L173.928 41.3706H173.97L174.012 41.3287V41.2869L174.054 41.245V41.2031L174.138 41.245V41.3287L173.97 41.4557V41.5814L174.012 41.6652V41.7084H174.054L174.138 41.7922L174.054 41.9611V42.1287L174.012 42.2557L173.97 42.3814H173.928H173.887L173.76 42.4232L173.634 42.5502L173.718 42.7178L173.549 42.8867L173.634 43.0975H173.76V43.2232V43.2651L173.928 43.2232V43.2651L173.887 43.3502L173.843 43.4759L173.801 43.5177L173.76 43.6866L173.591 43.8123L173.718 43.8961V43.9393L173.465 44.1488L173.549 44.2339L173.591 44.2758L173.676 44.3596V44.4447L173.76 44.823L173.634 44.8649V44.9068L173.676 44.9487V44.9906L173.591 45.1176V45.2433V45.2865L173.634 45.3284V45.4122L173.591 45.496L173.507 45.5811L173.381 45.623H173.338L173.296 45.6649V45.7067L173.254 45.7486H173.212H173.17L173.087 45.7067L172.96 45.7486H172.792H172.707L172.665 45.7905L172.623 45.8337L172.581 46.0013L172.623 46.2121L172.665 46.254L172.749 46.1702L172.792 46.2121H172.834L172.96 46.1702L173.17 46.2121L173.212 46.2959L173.254 46.3378L173.296 46.4229L173.087 46.7175V46.7594H173.17L173.212 46.9282L173.129 47.3066L173.043 47.5174V47.6431L172.96 47.7701L172.918 47.812L172.876 47.8957V48.0227L172.918 48.1065V48.2322L172.876 48.2741L172.749 48.4011V48.443L172.834 48.4849L172.749 48.57L172.623 48.6119L172.539 48.6957L172.454 48.8646V48.9065L172.37 48.9484H172.287L172.243 49.074L172.16 49.1172L172.076 49.074L172.034 48.9902L171.907 49.0321V49.074L171.992 49.1591L171.949 49.3686L171.907 49.4118V49.5375V49.6213L171.865 49.6645L171.698 49.7902V49.874V49.9159L171.781 49.9591H171.823L171.949 49.7902L172.034 49.8321V49.874L171.992 49.9591L171.949 50.0429L171.865 50.1266V50.2536V50.3793V50.4212H171.907L171.865 50.5063V50.5901L171.907 50.6739L171.865 50.759L171.907 50.8009L171.992 50.8428V50.8847L171.698 50.9685H171.612L171.571 50.9266H171.529L171.487 50.9685V51.0536L171.529 51.0955L171.571 51.1374L171.529 51.2211H171.487L171.402 51.263L171.445 51.4319L171.234 51.4738L171.149 51.5157H171.065H171.023L170.94 51.5576V51.7265L170.898 51.7684L170.813 51.6008H170.771L170.729 51.6427V51.7265V51.7684L170.645 51.8103V51.8535V51.8954L170.56 51.8535V51.8954L170.476 51.9373L170.392 52.063L170.434 52.1481V52.19L170.518 52.1481V52.19V52.2319L170.56 52.3575L170.603 52.3156H170.645V52.3994V52.4845V52.5683L170.687 52.6521L170.771 52.6102L170.813 52.5683V52.5264H170.854V52.5683V52.6953V52.7372H170.898L170.94 52.7791H170.898V52.821L170.981 52.7791V52.821H170.94L171.023 52.8629H170.981L170.94 52.9048L170.854 52.821H170.771L170.729 52.8629H170.771V52.9048L170.813 52.948L170.729 52.9899L170.645 52.948H170.603L170.645 52.9899L170.603 53.0318V53.0737H170.645L170.603 53.1156L170.56 53.1575L170.518 53.1156H170.434L170.35 53.1575V53.1994H170.392L170.476 53.2845H170.434L170.476 53.3682L170.518 53.4101V53.452L170.434 53.4939V53.5371V53.6209H170.518L170.56 53.6628V53.7047H170.476V53.7466H170.518L170.56 53.7898L170.518 53.8736L170.434 53.8317L170.392 53.8736V53.9155L170.476 53.9574L170.392 54.0425L170.434 54.0844L170.35 54.1263V54.252L170.392 54.3371L170.35 54.379V54.5046L170.307 54.4627L170.181 54.5046L170.223 54.6735L170.181 54.7154H170.14V54.5884H170.098L170.056 54.6735H170.013H169.971H169.929L169.971 54.7573L170.056 54.7154V54.7992L170.098 54.8411L170.056 54.9262H170.013H169.929L169.971 55.0519L169.929 55.0938L169.845 55.01H169.76L169.887 55.0938V55.1357L169.803 55.1789L169.887 55.2208V55.2627V55.3046L169.845 55.2627H169.76L169.718 55.3046L169.76 55.3465L169.718 55.4316H169.676L169.634 55.3884L169.592 55.4316V55.5991H169.55H169.509H169.465L169.55 55.6829L169.465 55.768L169.55 55.8099V55.8937H169.465H169.423L169.382 55.9775L169.298 55.9356V56.0207V56.0626H169.256L169.213 55.9775H169.171L169.213 56.0207V56.0626L169.129 56.1045V56.0626L169.087 56.0207L169.045 56.0626L168.961 56.1464H169.003V56.1883H168.961V56.2302L168.918 56.1883L168.876 56.2302H168.834H168.876L168.834 56.2734L168.792 56.3153L168.751 56.2734V56.3991H168.709V56.441V56.4829L168.751 56.568L168.709 56.6099V56.568V56.6099H168.665V56.6936H168.709L168.751 56.7774H168.665L168.709 56.8206H168.665V56.8625H168.709V56.9463L168.582 56.9044L168.624 57.072H168.582V57.0301H168.498V57.072L168.582 57.199H168.498L168.54 57.2409L168.456 57.2828L168.414 57.3247H168.329V57.3679L168.245 57.4098V57.4936H168.203H168.161V57.5355V57.5774L168.203 57.6206L168.161 57.6625L168.203 57.7463H168.161L168.119 57.83L168.076 57.8719L168.119 57.9151L168.076 57.957H168.119H168.076L168.119 57.9989L168.076 58.0408H168.034L168.076 58.0827V58.1246V58.1665L168.119 58.1246L168.161 58.1665L168.034 58.2516L168.076 58.4192V58.5043L167.992 58.5462L168.034 58.5881V58.6719L167.992 58.757V58.8408V58.9245V58.9664L167.909 59.0096V59.0934V59.1353L167.824 59.1772L167.867 59.261L167.824 59.3461L167.74 59.388L167.698 59.5137H167.656H167.614H167.571H167.529V59.6407V59.6826L167.487 59.6407L167.403 59.7245L167.32 59.7664V59.8934L167.276 59.9353H167.234V60.019V60.0609H167.193V60.146L167.151 60.1041L167.109 60.1879H167.067L167.025 60.2717H166.982H166.898L166.856 60.3555L166.729 60.4406V60.4825H166.645L166.603 60.5244V60.5663H166.562V60.6082H166.478V60.6514H166.435L166.478 60.6082H166.393L166.351 60.6514V60.7352H166.309V60.819V60.8609L166.225 60.946V60.9879L166.182 61.0298L166.225 61.1135V61.1986L166.267 61.2405L166.225 61.2824L166.267 61.3662V61.4081L166.225 61.45L166.182 61.4081L166.098 61.45L166.14 61.4932L166.098 61.5351V61.6189L166.056 61.6608V61.7027H166.014L166.056 61.8716H166.014H165.972L165.887 61.9973H165.845L165.803 62.0824L165.72 62.0405V62.1243H165.678H165.635L165.593 62.208L165.425 62.2931L165.467 62.335L165.425 62.3769V62.4607L165.383 62.5445H165.425L165.34 62.6296V62.7134L165.256 62.7972V62.8823L165.172 63.008L165.087 63.135L164.878 63.3444L164.793 63.5971L164.625 63.8079L164.583 63.8498L164.498 63.8917L164.414 63.9349L164.331 64.0606L164.162 64.1863L164.036 64.1444H163.951H163.867L163.783 64.1025L163.741 64.1444L163.698 64.0606H163.614L163.489 64.0187L163.404 64.1025L163.32 64.2295L162.52 64.8605L162.015 65.2808L161.805 65.4496L161.678 65.5334L160.962 66.1226L160.878 66.2077L159.7 67.1333L159.573 67.2171L159.531 67.1752H159.489L159.447 67.2171L159.489 67.3022L159.363 67.386L159.32 67.4698L158.731 67.8913L157.511 68.902V68.9439V68.9858L157.553 69.0277L157.637 69.0696H157.722V69.1115H157.974L158.142 69.1534H158.184L158.269 69.3223L158.437 69.3642H158.522H158.731L159.026 69.4061H159.111L159.236 69.3642L159.278 69.3223H159.363L159.405 69.2804H159.447L159.573 69.2385L159.7 69.2804L159.742 69.1966H159.784L159.868 69.2385L159.911 69.3223L159.953 69.3642L160.036 69.4493V69.4912V69.575L160.078 69.6588L160.162 69.7858V69.8695V69.8276L160.205 69.8695L160.331 70.0384L160.373 70.0803L160.458 70.1222L160.542 70.1641L160.753 70.206H160.878L160.962 70.2911L161.005 70.333L161.089 70.3749L161.342 70.5438V70.6276V70.7533L161.3 70.8384L161.173 71.091L161.089 71.2167L161.005 71.2586L160.962 71.3005H160.92L160.794 71.3424L160.5 71.3005L160.415 71.3424L160.373 71.4275L160.331 71.5113V71.6802V71.7221L160.373 72.0166V72.0585L160.415 72.1004L160.5 72.2274L160.667 72.395V72.4369L160.753 72.5639V72.6058V72.7328L160.626 72.8166L160.373 72.8585L160.289 72.9004L160.205 72.9842L160.12 73.1111L160.078 73.1949V73.28L160.12 73.3219L160.289 73.3638L160.415 73.5314V73.6165L160.373 73.7422L160.289 73.8273L160.12 73.953L159.911 74.0368L159.742 73.9949L159.658 74.0368L159.573 74.1219L159.489 74.2057V74.3313V74.4583L159.531 74.584L159.573 74.7948L159.616 74.8786L159.573 74.9218V74.9637L159.616 75.0475L159.7 75.0894L159.784 75.1313L159.826 75.1732L159.868 75.3002L159.826 75.4677L159.784 75.5109L159.7 75.4677L159.531 75.342L159.405 75.3002H159.068L159.026 75.342L158.942 75.4677L158.9 75.5528L158.773 75.6785L158.689 75.7204L158.395 75.9731L158.311 76.142L158.269 76.1839L158.184 76.3109V76.4365L158.1 76.5203L158.058 76.6473V76.7311L158.142 76.9838V77.1527L158.1 77.2365L158.058 77.3203L157.931 77.4054L157.595 77.4892L157.469 77.6999L157.384 77.7837H157.342L157.131 77.8675H157.047H156.964H156.922H156.753L156.5 77.9094L156.416 77.9513L156.333 77.9945L156.164 78.0783H155.869L155.785 78.204L155.7 78.2891L155.448 78.4567L155.28 78.6255L155.027 78.7512L154.9 78.7944H154.858L154.817 78.8782L154.691 79.0039L154.648 79.089V79.2147V79.2985L154.691 79.3417L154.775 79.6363V79.72V79.8889V79.9308V80.3092L154.817 80.6889L154.858 80.8564L154.817 80.9834L154.691 81.1929L154.648 81.3618L154.522 81.5307L154.396 81.6983L154.311 81.8253V81.8672L154.227 81.9509L153.975 82.2036L153.806 82.4144L153.722 82.582L153.638 82.6252L153.596 82.9617V83.0873L153.722 83.34V83.3819L153.849 83.6765L153.891 83.7616L153.975 83.8454L154.144 83.9292L154.353 84.098L154.48 84.1818L154.606 84.3507L154.733 84.4345L154.9 84.4764L154.985 84.5183L155.027 84.6034V84.6453L154.985 84.7291L154.944 84.771V84.898V84.9399L154.985 85.2344L154.944 85.4033V85.5709L154.858 85.6979L154.9 85.9087V85.9925V86.2033L154.858 86.287L154.775 86.3289V86.3708L154.733 86.4127V86.5397L154.691 86.6235L154.733 86.7505L154.691 86.96L154.648 87.087L154.606 87.1708L154.522 87.3397L154.396 87.5923L154.353 87.9288L154.311 88.0545L154.227 88.2653L154.144 88.3491L154.017 88.4342L153.849 88.5179H153.806L153.638 88.7706L153.596 88.8963L153.553 88.9814L153.511 89.3598V89.4436L153.427 89.5705L153.175 89.7813L153.133 89.907L153.049 89.9908L153.006 90.1597L152.922 90.2854L152.628 90.7069L152.459 90.9596L152.333 91.1272L152.291 91.2123L152.164 91.2542H151.997L151.744 91.338L151.449 91.5907L151.364 91.6326L151.28 91.7595L151.197 91.8433L151.113 92.0122L151.07 92.1379L150.733 92.4325L150.691 92.5595V92.6433L150.649 92.7703L150.566 92.9378L150.397 93.1905L150.355 93.2324V93.3162V93.3594L150.144 93.527L149.975 93.7378H149.808L149.766 93.9904L149.639 94.0323L149.555 94.1161L149.471 94.2012V94.2431L149.428 94.4107V94.4539V94.6215V94.6634L149.386 94.8323L149.218 95.0012L149.133 95.2957V95.3795V95.4633H149.091V95.5052L149.175 95.6322L149.218 95.7579L149.133 95.843L149.091 95.9268V96.0525L149.049 96.1376L149.008 96.2213L148.924 96.2632V96.4321L148.839 96.5578V96.6848L148.797 96.7267V96.8105L148.544 97.1051L148.502 97.3158L148.46 97.4428L148.418 97.5685L148.377 97.6104L144.546 97.3577L143.199 97.2739L141.683 97.1902L140.715 97.1051L135.79 96.7686L133.516 96.5997H133.179L130.359 96.3902L127.539 96.1794L124.298 95.9268L121.183 95.6741L120.425 95.6322L118.783 95.4633L113.858 95.0849L111.585 94.8742L110.869 94.8323L108.427 94.6215L108.258 94.6634H108.175H108.133V94.7066L108.007 94.7904L107.88 94.8323H107.838L107.796 94.7485V94.6634L107.754 94.5796V94.3688V94.285H107.712L107.585 93.9486L107.502 93.8216L107.333 93.7797L107.249 93.7378L107.165 93.7797H107.122L106.744 93.7378L106.66 93.6959L106.407 93.7378L106.322 93.6959L106.238 93.654L106.155 93.6121L106.113 93.527L106.028 93.4432L105.986 93.4013V93.3594L106.028 93.2743L105.986 93.1486L106.113 92.9797V92.8959L106.071 92.8122L105.986 92.7703V92.6433L105.902 92.6014L105.818 92.4744L105.775 92.3487L105.523 92.2217L105.186 91.8014L105.144 91.7595L105.06 91.7177L104.933 91.6758L104.849 91.6326L104.807 91.6758L104.597 91.7177H104.513L104.471 91.6758L104.429 91.5488L104.218 91.5069H104.007L103.882 91.3799L103.797 91.338L103.755 91.2961L103.797 91.1272V90.9596L103.713 90.8758H103.587H103.502L103.376 90.7907L103.082 90.6232L102.871 90.7069H102.702L102.66 90.5813L102.702 90.3705L102.618 90.1178L102.535 89.9908L102.493 89.9489L102.535 89.6543L102.449 89.6124L102.366 89.5705V89.5287L102.324 89.4017L102.408 89.3179L102.449 89.1909L102.408 89.149L102.282 89.0652V89.0233L102.324 88.9395V88.8544L102.155 88.6436L102.113 88.5179V88.476L102.24 88.2653V88.2234V88.1815L102.155 88.0126V87.9288V87.8869L102.24 87.7599L102.282 87.5491L102.366 87.3397V87.2978V87.2127L102.24 87.0032L102.155 86.96L101.987 86.9181L101.944 86.8762L101.902 86.7924L101.86 86.4546L101.566 86.2033L101.398 85.8655L101.229 85.6979V85.5709L101.187 85.1088L101.145 84.9818L100.935 84.6034L100.893 84.3507L100.808 83.8035L100.766 83.7197L100.682 83.6765H100.598L100.555 83.6346L100.513 83.34V83.2981L100.346 82.8766L100.177 82.582L99.9659 82.3725L99.7983 82.0347L99.7551 81.9509L99.4186 81.7402L99.3348 81.6983V81.7402L99.251 81.6564L99.124 81.4875V81.4037L99.0822 81.1929L99.124 80.9402L99.0403 80.6038L98.9146 80.4781L98.8714 80.3092L98.7876 80.2673L98.7457 80.1835L98.6619 80.0146H98.6187L98.493 79.9727L98.366 79.8457L98.1565 79.4674L98.0714 79.3836L97.9877 79.2985L97.8201 79.2566H97.7769L97.735 79.1309L97.6512 79.089L97.4823 78.8782L97.3147 78.4148L97.2715 78.204L97.1877 78.0783V77.531L97.2715 77.3622L97.3985 77.2365L97.5242 77.0257L97.862 76.7311L97.9877 76.6892L98.0714 76.5622L98.1146 76.4784L98.1565 76.2677L98.1984 76.2258H98.366H98.4092V76.1839L98.493 76.142L98.5349 76.0582L101.018 70.5438L101.987 68.3548L102.535 67.1752L102.955 66.1658L104.807 62.1243L106.238 59.0096L106.66 58.0827L106.913 57.4936L107.08 57.072L107.544 56.0207L107.796 55.4316L107.838 55.3884L108.554 53.7898L109.016 52.7791L109.227 52.2319L109.564 51.5576L109.901 50.8009L110.069 50.4212L110.027 50.3793H109.943L109.858 50.3374L109.733 50.2955L109.691 50.2536V50.2117L109.943 49.874L109.985 49.7902V49.6645L110.027 49.5794L110.153 49.2848L110.196 49.2429L110.322 49.1591L110.533 49.1172L110.953 48.9065L111.205 48.7376L111.374 48.6119L111.542 48.443L111.711 48.1484L111.922 47.812L111.963 47.7269V47.685L111.669 47.7701H111.585H111.5H111.416L111.374 47.812L111.332 47.8539L111.291 47.8957L111.164 47.8539L110.996 48.0646L110.827 48.1065L110.743 48.1484L110.7 48.1903V48.2741H110.658L110.616 48.4011L110.533 48.443H110.406L110.28 48.4011L110.196 48.443L110.153 48.5268L110.027 48.6119H109.943L109.858 48.5268L109.816 48.4849L109.733 48.5268L109.649 48.57L109.606 48.6119L109.438 48.4011H109.353H109.311L109.227 48.4849L109.102 48.5268L109.058 48.6119L108.975 48.6538L108.933 48.6119H108.849V48.6538L108.807 48.8214L108.764 48.8646L108.722 48.8214H108.638L108.511 48.8646H108.344L108.217 48.7795L108.175 48.6957L108.049 48.6538L107.922 48.6119H107.838L107.796 48.57V48.4011L107.922 48.2322L108.049 48.1065L108.091 47.9795V47.9376V47.812L108.049 47.685L108.007 47.6431L107.922 47.5593H107.838L107.669 47.6431H107.417H107.333L107.249 47.6012L107.122 47.4323L106.996 47.3485L106.954 47.3066H106.913L106.66 47.2647L106.618 47.2228L106.575 47.0958L106.491 47.012L106.449 46.9282L106.196 46.9701L106.155 46.9282L106.028 46.6337L105.944 46.5486L105.902 46.4229L105.986 46.3378V46.2959L105.944 46.254L105.86 46.2121V46.1702V46.1283L105.775 46.0432L105.649 46.1702L105.565 46.0013H105.438H105.355V45.9594L105.313 45.9175L105.355 45.7486V45.7067L105.271 45.7905L105.228 45.7067L105.186 45.7486H105.144L105.102 45.6649L105.018 45.7067L104.976 45.7486H104.933L104.849 45.7067L104.807 45.6649L104.849 45.623L104.807 45.5811H104.765V45.623L104.724 45.7067H104.68V45.6649H104.513L104.471 45.7905L104.344 45.7067L104.218 45.6649L104.26 45.7486L104.176 45.7905L104.049 45.6649L103.924 45.7486L103.882 45.6649L103.966 45.623V45.5392H103.924L103.882 45.496V45.4122H103.797L103.713 45.5392L103.629 45.496L103.671 45.4122V45.3703L103.418 45.4541L103.376 45.3703V45.2865L103.291 45.3284L103.249 45.2865L103.207 45.2014L103.082 45.2865L103.124 45.1176H103.039L102.997 44.9906H102.955H102.871L102.744 44.9068L102.702 44.9487L102.66 44.8649L102.702 44.823L102.618 44.7392L102.576 44.7811V44.823L102.324 44.8649L102.282 44.823L102.155 44.9068L102.071 44.7811H101.987L102.029 44.696L101.987 44.6122L101.944 44.5285V44.3177L101.86 44.3596L101.735 44.3177V44.3596L101.65 44.3177L101.566 44.3596H101.524V44.3177V44.2339H101.482H101.44L101.398 44.1488L101.355 44.1069L101.313 43.9812H101.271V43.9393L101.145 43.8961V43.8542L101.018 43.8123H100.935L100.808 43.8961L100.766 43.8123L100.724 43.8542L100.682 43.8123L100.724 43.7285L100.682 43.6866L100.555 43.6447L100.471 43.6866H100.429V43.5596L100.304 43.5177V43.434L100.346 43.3921H100.26L100.177 43.307V43.2232V43.1394L100.219 43.0975V42.9705L100.346 42.5921L100.387 42.5502V42.4232L100.304 42.3395L100.346 42.2125V42.1287L100.304 42.0868L100.135 42.0449L100.093 41.9179V41.876L100.051 41.7922L99.9659 41.7503H99.924L99.6713 41.9179L99.6294 42.003L99.6713 42.0449L99.5875 42.1287L99.4186 42.1706V42.2976L99.3767 42.3395L99.2091 42.5502L99.1659 42.5921L99.0403 42.4232L98.9565 42.3814L98.8295 42.1706L98.6619 42.1287L98.5768 41.9611H98.493V42.003L98.1565 42.0449L98.1984 41.9611L98.0714 41.9179L98.0295 41.7922L97.9877 41.8341L97.9458 41.7922V41.7503L97.9039 41.7084V41.5395L97.7769 41.4125L97.735 41.3706H97.6931H97.6512H97.6093L97.5242 41.2869L97.5674 41.1612L97.5242 41.118L97.5674 41.0342L97.6093 40.9923V40.9504V40.9085L97.5242 40.8666V40.7815L97.3566 40.6558L97.3985 40.5288L97.3566 40.445L97.4823 40.4031V40.3612L97.3147 40.2342H97.2715V40.2761H97.2296L97.1877 40.1924H97.1458L97.1039 40.1086V40.0235L97.062 40.0667L97.0201 40.0235L96.9769 40.0667H96.935V40.0235L96.6824 39.8559V39.814L96.6405 39.7721V39.7289H96.5986L96.5148 39.6451V39.6032H96.4297L96.3459 39.5613L96.2202 39.3086L96.1351 39.2667L96.0932 39.3086L96.0513 39.2667V39.2235L95.9256 39.0979L95.7987 39.056V39.0141L95.7568 38.8452H95.7149V38.8033L95.6311 38.7195V38.6344L95.673 38.5925V38.4668L95.6311 38.4249V38.2979H95.7149L95.7568 38.2141V38.1722V38.0452L95.7149 37.9615L95.673 37.9196L95.6311 37.7507L95.673 37.5399L95.6311 37.498H95.5879L95.546 37.3723L95.4203 37.3304L95.3352 37.2034L95.2514 37.1615L95.2095 37.2034V37.1615H95.0838V37.1196L94.9149 37.0358L94.746 36.9088V36.6143L94.7879 36.5305V36.4886V36.4035H94.746L94.7042 36.1927V35.9832L94.8311 35.7306V35.6455L94.7879 35.6036L94.8311 35.2252L94.746 35.1414H94.7042L94.6623 35.0982V34.9306L94.6204 34.8468V34.8036V33.0362V26.8476ZM174.012 41.5814V41.5395V41.4976H174.054H174.138L174.096 41.5395H174.138L174.181 41.7084V41.7922L174.138 41.7503L174.054 41.6233L174.012 41.5814ZM168.287 39.2667L168.245 39.3086L168.287 39.2667ZM173.338 40.6977V40.7396H173.296V40.6977H173.338ZM170.813 39.9816H170.854V40.0235H170.813V39.9816ZM172.581 40.8234L172.539 40.7815L172.581 40.7396L172.623 40.7815H172.581L172.623 40.8234H172.581ZM163.151 38.929L163.194 38.8871L163.236 38.929H163.194V38.9722L163.151 39.0141V38.9722V38.929ZM172.202 41.1612V41.0761L172.243 41.0342H172.287L172.243 41.0761V41.2031H172.202V41.1612ZM168.161 39.1397H168.245V39.1816L168.287 39.1397L168.329 39.1816L168.161 39.2235V39.1397ZM172.118 40.7815L172.076 40.8234H172.034V40.9085L171.865 41.0342L171.907 40.9085L171.992 40.7396V40.6977L172.034 40.6558L172.076 40.6977L172.118 40.7396V40.7815Z"
							stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="SP" @mouseenter="e => hoverES(e, 'SP')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M130.528 179.317L130.485 179.275V179.232V179.19L130.528 179.106L130.654 178.937L130.781 178.812L130.823 178.77L131.075 178.685L131.117 178.643L131.201 178.517L131.454 178.39H131.496L131.537 178.348L131.875 178.264L132.043 178.18H132.085L132.17 178.012L132.379 177.843L132.421 177.759L132.759 177.548L132.885 177.506L133.054 177.381L133.306 177.295L133.432 177.212L133.516 177.17L133.643 177.086L133.768 176.959L133.979 176.917L134.148 176.833L134.274 176.79L134.316 176.748H134.359L134.401 176.664L134.526 176.539L134.568 176.496L134.863 176.286L134.905 176.159L134.948 176.117L135.032 176.033L135.243 175.739L135.41 175.192L135.453 175.065L135.663 174.812H135.748V174.77L135.832 174.728L135.915 174.601L136.21 174.392L136.252 174.265V174.181L136.379 173.886L136.505 173.802L136.757 173.717L136.799 173.634L136.884 173.55L137.052 173.255V173.212V173.086L136.968 172.917V172.792L136.757 172.623L136.715 172.539L136.799 172.412L136.884 172.245L136.968 172.203H137.01L137.263 172.245H137.39L137.557 172.161L137.599 172.118L137.684 171.992L137.81 171.866L137.852 171.739L137.894 171.613L137.937 171.445L138.188 171.234L138.231 171.192V171.15V171.108V171.066L138.273 170.897L138.315 170.687L138.273 170.645L138.231 170.392L138.146 170.266L138.104 170.224L138.146 170.139L138.104 169.929L138.146 169.845L138.188 169.803H138.357L138.484 169.761H138.526L138.568 169.677L138.694 169.634L138.779 169.424V169.297L138.863 169.172L138.904 169.045L139.073 168.834L139.157 168.792H139.41H139.452L139.704 168.625L139.746 168.539L139.788 168.245L139.704 168.161L139.662 168.035V167.825L139.704 167.614V167.572V167.53L139.621 167.403L139.662 167.194L139.873 166.73L139.915 166.688L139.957 166.646V166.603L139.999 166.561L140.041 166.519L140.335 166.35L140.462 166.225L140.504 166.099L140.715 165.761L140.799 165.678L140.968 165.552L141.052 165.509V165.467L141.262 165.088L141.346 165.046L141.388 164.878L141.43 164.836H141.472L141.599 164.752L141.724 164.667L142.104 164.583H142.357L142.524 164.541L142.651 164.499H142.693L142.777 164.457L142.862 164.372L142.946 164.33L143.157 164.163L143.199 164.078L143.282 163.825L143.408 163.53L143.577 163.194V163.11L143.788 162.816V162.772H143.872H143.913L143.999 162.689L144.124 162.605V162.52H144.208H144.293H144.377L144.503 162.394L144.546 162.352L144.713 162.31L144.84 162.225V162.183H144.924L145.261 162.099L145.555 162.016H145.597L145.682 161.974H145.724L145.85 161.763L145.935 161.678L146.019 161.636L146.144 161.468L146.188 161.383H146.271H146.397L146.482 161.3L146.566 161.258H146.692L146.777 161.216L146.86 161.174L146.944 161.216L147.071 161.258L147.197 161.3L147.45 161.594L147.577 161.636V161.721H147.702L147.786 161.763H147.829L147.997 161.721L148.25 161.805L148.418 161.721H148.544L148.713 161.763L148.755 161.805H148.797L148.924 161.763H149.133H149.175L149.218 161.805L149.302 161.847L149.471 162.016L149.513 162.058H149.597L149.681 162.099L150.018 162.058L150.355 162.183L150.439 162.225H150.566H150.691L150.818 162.141L151.07 162.099H151.113H151.322H151.364L151.575 162.141H151.997H152.08V162.099L152.207 162.058L152.375 162.016H152.502L152.544 161.974L152.711 162.016L152.838 162.058L152.922 162.225L152.964 162.268L153.133 162.436H153.259L153.764 162.478L153.891 162.436L154.017 162.352L154.144 162.31L154.353 162.352H154.396L154.438 162.394V162.478V162.563L154.353 162.605H154.227L154.144 162.689L154.059 163.025V163.194V163.236L154.1 163.32V163.657L154.311 164.036L154.353 164.163V164.247L154.522 164.499H154.564L154.775 164.541L154.858 164.583H154.9V164.541L155.153 164.372L155.238 164.288L155.406 163.91L155.575 163.572L155.616 163.53H155.785L155.869 163.572L156.038 163.614L156.08 163.699L156.164 163.91L156.206 164.247V164.372L156.164 165.088L156.206 165.13L156.584 165.383H156.669L156.711 165.341L156.795 165.172V165.13V165.046V165.005L156.711 164.794L156.753 164.583L156.669 164.457V164.414V164.288L156.753 164.12L156.837 164.036L156.88 163.994V163.952L156.837 163.867L156.88 163.741L156.922 163.699L157.047 163.614H157.089H157.342L157.511 163.572L157.637 163.53H157.678L157.889 163.614H158.016L158.058 163.657H158.184L158.311 163.614L158.478 163.447L158.564 163.405H158.731L158.858 163.447H158.984H159.153L159.363 163.363H159.447L159.658 163.32L159.826 163.363H159.867H159.953H159.994L160.078 163.32H160.205L160.331 163.363L160.415 163.447L160.458 163.489H160.5H160.542H160.667L160.753 163.447H160.794L160.836 163.363V163.32L160.626 163.11V163.068L160.667 162.857L160.626 162.816L160.667 162.772H160.794L160.836 162.816L160.92 162.857L161.047 163.068L161.089 163.194L161.131 163.236H161.173H161.215L161.257 163.363L161.384 163.405L161.467 163.489L161.594 163.53H161.72L161.889 163.447L161.931 163.32L162.056 163.363L162.142 163.236L162.183 163.152L162.225 163.068V162.857L162.267 162.816H162.309L162.478 162.941L162.52 163.152L162.604 163.278L162.773 163.363H162.815L162.942 163.236L162.983 163.152V163.068V162.983L163.025 162.899V162.857L162.983 162.816H162.942V162.772V162.73V162.689L162.983 162.647L163.067 162.52H163.109L163.194 162.563L163.404 162.478H163.614L163.741 162.52L163.825 162.478L163.951 162.436H163.993L164.204 162.605V162.647V162.689L164.289 162.772L164.331 162.816L164.414 162.899L164.498 162.857H164.583L164.709 162.73V162.605L164.793 162.563H164.962V162.52L165.045 162.478H165.214L165.298 162.394H165.383L165.425 162.352L165.467 162.31V162.352L165.593 162.478L165.678 162.563L165.72 162.647V162.689V162.73L165.635 162.772V162.816V162.899L165.803 162.983L165.845 163.11H165.887H166.056L166.14 163.236H166.225L166.309 163.32L166.478 163.363L166.561 163.53L166.687 163.572H166.729L166.772 163.657V163.783H166.814L166.856 163.867L166.94 163.994V164.036L166.856 164.247H166.814L166.729 164.372H166.687L166.645 164.457V164.583H166.603V164.667V164.709H166.561L166.603 164.752L166.52 164.794L166.561 164.919V164.961V165.005V165.046H166.603L166.561 165.13L166.603 165.172L166.561 165.214H166.603L166.561 165.256H166.603L166.561 165.299V165.341H166.603V165.383L166.561 165.425V165.467L166.687 165.552H166.772L166.814 165.636L166.94 165.678L167.067 165.803H167.151L167.234 165.846L167.403 165.888L167.445 165.972H167.487V166.056L167.529 166.141L167.487 166.183L167.571 166.35H167.614V166.394V166.436V166.477L167.698 166.519V166.561V166.646L167.782 166.688V166.73V166.772L167.74 166.856V166.941L167.698 167.025L167.656 167.067V167.108H167.445L167.361 167.067L167.32 167.108V167.15L167.234 167.235L167.276 167.319H167.234L167.193 167.488L167.151 167.53H167.109L167.067 167.656L166.982 167.698L167.067 167.867L166.982 168.035L166.898 168.245L166.982 168.414L167.067 168.498H167.193V168.583L167.234 168.666H167.32L167.361 168.75L167.445 168.792L167.487 168.834L167.445 168.961V169.045L167.403 169.087L167.445 169.214L167.487 169.339L167.529 169.424L167.487 169.55H167.529L167.571 169.592L167.698 169.634V169.677H167.614V169.719V169.761L167.529 169.803L167.656 169.929L167.614 170.056L167.656 170.097V170.139L167.74 170.266L167.782 170.35V170.308H167.824H167.951H167.992L167.951 170.35V170.392L167.909 170.434V170.519L167.992 170.476L168.034 170.561H168.076V170.603L168.119 170.687V170.772V170.814L168.203 170.897L168.161 170.939H168.203L168.245 171.023V171.066L168.287 171.15L168.371 171.192L168.414 171.234L168.371 171.276L168.329 171.319L168.371 171.403L168.329 171.486H168.287L168.329 171.57V171.613H168.287L168.329 171.655H168.371L168.414 171.697L168.456 171.655V171.697L168.54 171.655H168.582H168.623L168.665 171.697L168.709 171.655L168.792 171.697L168.834 171.655L168.876 171.697V171.655H168.961L169.003 171.613H169.045L169.087 171.57L169.213 171.528V171.486H169.256V171.445H169.34L169.382 171.403V171.361L169.423 171.319H169.509L169.676 171.361L169.718 171.319L169.76 171.276H169.845H169.887L169.845 171.361L169.887 171.403L170.013 171.486H170.098V171.445L170.14 171.486L170.181 171.57L170.265 171.445L170.307 171.403L170.35 171.361H170.392L170.434 171.276H170.476H170.56V171.361V171.403V171.445V171.486L170.603 171.528L170.645 171.613H170.687L170.729 171.655V171.697H170.771L170.729 171.739L170.771 171.781L170.854 171.823V171.781L171.023 171.697V171.739L171.107 171.781H171.192L171.276 171.823H171.318H171.36V171.866V171.908L171.402 171.95V172.034L171.445 172.076L171.36 172.161V172.245L171.318 172.286L171.36 172.37L171.402 172.412L171.487 172.497V172.539H171.445L171.402 172.581V172.623L171.36 172.708V172.75L171.318 172.792L171.36 172.834V172.876L171.276 172.917V173.003H171.192L171.149 173.044L171.192 173.128H171.149L171.065 173.17V173.297L170.981 173.339L170.729 173.297V173.381L170.687 173.423V173.465L170.729 173.55L170.687 173.634V173.675V173.717V173.844V173.886H170.603L170.56 173.928H170.518L170.56 174.012L170.434 174.139V174.181L170.35 174.223L170.307 174.307L170.35 174.392H170.392H170.434L170.518 174.517V174.559L170.56 174.601L170.518 174.686L170.476 174.728H170.434L170.392 174.77L170.476 174.854L170.434 174.939L170.518 174.981V175.065L170.603 175.192L170.645 175.233H170.687L170.729 175.317L170.771 175.359V175.401V175.444V175.486H170.729L170.603 175.401L170.56 175.444H170.518V175.486L170.476 175.528L170.392 175.486V175.528H170.35L170.307 175.612L170.392 175.696L170.476 175.739V175.781L170.35 175.823H170.265L170.181 175.864L170.14 175.823H170.098V175.864V175.906L170.14 175.948H170.181H170.223H170.265H170.307H170.35L170.434 175.991L170.56 175.948L170.645 176.033L170.729 176.075L170.771 176.201H170.854V176.244L170.771 176.328L170.603 176.37L170.56 176.496H170.476H170.434H170.392L170.434 176.539L170.35 176.748L170.392 176.79L170.265 176.875L170.307 176.959L170.265 176.917L170.223 177.001L170.181 177.043V177.086L170.223 177.128L170.181 177.17L170.223 177.254L170.14 177.337H170.098L170.14 177.381H170.181V177.422H170.223V177.464L170.265 177.506V177.548V177.59H170.307V177.633H170.35L170.392 177.717H170.476L170.434 177.801L170.476 177.843L170.434 177.97V178.012L170.56 178.053V178.095H170.603L170.645 178.137L170.771 178.18V178.137L170.854 178.18H170.898H170.981L171.023 178.222V178.264L171.065 178.222H171.149L171.192 178.264L171.149 178.306V178.348H171.192L171.276 178.39V178.475L171.234 178.517L171.445 178.601V178.685L171.529 178.643L171.571 178.685H171.698H171.781V178.77H171.865V178.812L171.949 178.853H171.992L172.034 178.812V178.895L171.907 179.022V179.106H172.034L171.949 179.19L172.076 179.317L171.949 179.359V179.401L171.992 179.443H172.076L172.118 179.484L172.16 179.526V179.611L172.076 179.653H172.034L172.076 179.611L172.034 179.57L171.992 179.611L171.907 179.57L171.865 179.611L171.739 179.653V179.695L171.654 179.653L171.612 179.695V179.737L171.654 179.779L171.612 179.822L171.654 179.864H171.739L171.781 179.99H171.865V180.032L171.949 180.074V180.032L172.076 180.117H172.16L172.202 180.074V180.117H172.243L172.329 180.242L172.37 180.201H172.496V180.242L172.454 180.284V180.326H172.412V180.368L172.329 180.411L172.243 180.579V180.664L172.287 180.706L172.243 180.748L172.287 180.874H172.202V180.915H172.243V180.959L172.287 181.001L172.329 181.084L172.454 181.126L172.496 181.084L172.623 181.042L172.749 181.084L172.834 180.959H172.918H172.96V181.042H173.043L173.087 181.084L173.128 181.001L173.338 180.915L173.381 180.874L173.423 180.915L173.634 180.874L173.676 180.832V180.874L173.718 181.001V181.042L173.676 181.168L173.634 181.211L173.718 181.253L173.801 181.168H173.887L173.97 181.084L174.096 181.042L174.265 181.084L174.391 181.001L174.518 181.042L174.559 181.001L174.643 180.959V180.915L174.728 180.874L174.812 180.832L174.854 180.79L174.896 180.748H174.981L175.065 180.664V180.621L175.149 180.579H175.19L175.149 180.664V180.706H175.232V180.748V180.832H175.276V180.874V180.959H175.317L175.401 180.915H175.443V180.874V180.79H175.485L175.527 180.706H175.57H175.654V180.664L175.738 180.706V180.664L175.823 180.706V180.79L175.865 180.832H175.907L175.99 180.79L176.032 180.748V180.706L175.99 180.495H176.074L176.117 180.411L176.159 180.453L176.201 180.537H176.243L176.285 180.579H176.37V180.537H176.327L176.285 180.495L176.243 180.453V180.411L176.285 180.326H176.327L176.37 180.284V180.201H176.327V180.117L176.243 179.99H176.285H176.243H176.117H176.074L175.949 180.032L175.823 180.074H175.78L175.696 179.99L175.738 179.822L175.907 179.779L175.949 179.737L176.074 179.695V179.653H176.117L176.159 179.611V179.57H176.243L176.327 179.611L176.37 179.57L176.496 179.526H176.454V179.484L176.37 179.443L176.327 179.317H176.243V179.275L176.201 179.232L176.243 179.19L176.285 179.148V179.106L176.327 179.064L176.454 179.106L176.58 179.022L176.665 179.064V179.106L176.707 179.19H176.665L176.621 179.275H176.665L176.58 179.359V179.401L176.538 179.443L176.621 179.526H176.665L176.748 179.484L176.959 179.443L177.043 179.317H177.127L177.169 179.275H177.127L177.212 179.19V179.275H177.296L177.338 179.359L177.212 179.443L177.169 179.484V179.526L177.212 179.57L177.379 179.526H177.421L177.465 179.484H177.506L177.674 179.359L177.759 179.401L177.843 179.19L177.801 179.148H177.843L177.969 179.232H178.012L178.054 179.275L178.096 179.317H178.179L178.221 179.359L178.263 179.401L178.221 179.526H178.306H178.348L178.474 179.443H178.558L178.601 179.359H178.685L178.727 179.317L178.937 179.275L179.063 179.317L179.106 179.275H179.148V179.232L179.19 179.148L179.148 179.106L179.358 178.979H179.401L179.485 178.937H179.527L179.695 178.895L179.779 178.812L179.737 178.77V178.728L179.779 178.685L179.863 178.601H179.905L179.99 178.559L180.032 178.517H180.074L180.158 178.475L180.2 178.432L180.285 178.475L180.41 178.39L180.537 178.348L180.621 178.306V178.348H180.705H180.79H180.832L180.999 178.39L181.043 178.348L181.168 178.264H181.337H181.421L181.463 178.137L181.547 178.095L181.59 178.053H181.632L181.674 178.095H181.757H181.799L181.884 178.053L181.968 178.012V177.97H182.136L182.221 178.012H182.305L182.389 178.095L182.474 178.18L182.516 178.348V178.39L182.474 178.475L182.516 178.517H182.557V178.559V178.643H182.641L182.684 178.685H182.726L182.768 178.728L182.81 178.812L182.768 178.853V178.937L182.894 178.895L182.936 178.937L182.979 178.895L183.021 178.937L182.979 179.064V179.106V179.232H183.021L183.063 179.275L183.105 179.232L183.188 179.317L183.23 179.275V179.232L183.274 179.275L183.315 179.359H183.357L183.441 179.19L183.483 179.275L183.568 179.232L183.652 179.317H183.694H183.736L183.652 179.401V179.443H183.694L183.652 179.401H183.694H183.779L183.821 179.443H183.863L183.988 179.275L183.946 179.232H183.988L184.03 179.275L184.115 179.317L184.157 179.275H184.199L184.241 179.232L184.325 179.19H184.41L184.452 179.232H184.494V179.19L184.452 179.148V179.106L184.536 179.064V179.022H184.578L184.663 179.064H184.705H184.746L184.705 179.148H184.746V179.275H184.788H184.83L184.788 179.19V179.148L184.83 179.19V179.148V179.106L184.873 179.148L184.957 179.106L184.999 179.19L185.041 179.148L185.083 179.19H185.125H185.168L185.21 179.275V179.232L185.294 179.19L185.419 179.275L185.463 179.232H185.546H185.588L185.63 179.317L185.672 179.275H185.715V179.359L185.757 179.401H185.799L185.841 179.443L185.799 179.484L185.883 179.57L185.968 179.653V179.695V179.737L185.925 179.779H185.883V179.864L185.841 179.906L185.757 179.948H185.715V179.99H185.757L185.715 180.032H185.588L185.463 180.159L185.504 180.201H185.419L185.377 180.284V180.326L185.419 180.368L185.377 180.411H185.463V180.453V180.495H185.377L185.294 180.664L185.21 180.706V180.664H185.125L184.999 180.748V180.79H184.957L184.999 180.748L184.957 180.706L184.663 180.832H184.578H184.536H184.494V180.79H184.41H184.368L184.325 180.832L184.283 180.915L184.241 180.959H184.199L184.073 181.001V180.959H184.03V180.915H183.988L184.03 180.832L183.988 180.79H183.905H183.863L183.779 180.874L183.694 180.915L183.61 181.001L183.526 181.042L183.399 180.959L183.274 181.042H183.23L183.063 181.126L183.021 181.168V181.211L182.894 181.295L182.81 181.211L182.726 181.337H182.684H182.641H182.599L182.557 181.295L182.516 181.337L182.389 181.421L182.305 181.506L182.347 181.548L182.305 181.59V181.632H182.263H182.221H182.136H182.094H182.052V181.673V181.715L182.01 181.759L182.052 181.8L182.01 181.884H182.052V181.926L182.01 181.968V182.053L181.968 182.095V182.137L181.926 182.179V182.221V182.263V182.306L181.884 182.348H181.926V182.39H181.968L181.926 182.473H181.968L181.926 182.515L181.968 182.557L181.884 182.6L181.926 182.642L181.841 182.684L181.884 182.768L181.841 182.81H181.757L181.716 182.853H181.674V182.895H181.632L181.547 182.937V182.979V183.021L181.505 183.063V183.148L181.463 183.19L181.505 183.231H181.547V183.357H181.674L181.799 183.4L181.757 183.442L181.841 183.484V183.526L181.884 183.568L181.841 183.61L181.968 183.568V183.61L182.094 183.652V183.695L182.136 183.779V183.821L182.179 183.904H182.136L182.263 183.948L182.347 184.031H182.389L182.432 184.073L182.474 184.115H182.432H182.347L182.136 184.157L182.094 184.115H182.052H182.01V184.157L181.968 184.199H181.884L181.841 184.242H181.757H181.716L181.757 184.199L181.799 184.115L181.674 184.073H181.59L181.463 184.157V184.073V184.031L181.505 183.989L181.463 183.904H181.337L181.294 183.989L181.252 184.031H181.126L181.085 184.073V184.157L181.043 184.199H180.999L180.958 184.242V184.284L180.916 184.326L180.874 184.284H180.832L180.747 184.368L180.705 184.41H180.579L180.495 184.493V184.452L180.452 184.41L180.41 184.452L180.368 184.493H180.41H180.368V184.537V184.62L180.41 184.662L180.452 184.704L180.537 184.62H180.579V184.704H180.663H180.579H180.495L180.452 184.746H180.41H180.368L180.327 184.873V184.915H180.368L180.285 184.999V185.084L180.243 185.042V184.915H180.158L180.116 184.957L180.158 184.873H180.116L180.074 184.915L179.99 184.957L180.116 184.999L180.074 185.042H180.116V185.084L180.074 185.126V185.084H180.032V185.042L179.948 184.999L179.905 185.042L179.948 184.957H179.863V184.915L179.779 184.957L179.737 184.915H179.695V184.957V184.999L179.779 185.042L179.737 185.126H179.779V185.21H179.737H179.695H179.652H179.61V185.168V185.126L179.568 185.084L179.443 185.126L179.358 185.21V185.252L179.443 185.293V185.252V185.293V185.379H179.485H179.443L179.485 185.42V185.462H179.443H179.316L179.274 185.546H179.19H179.232L179.19 185.504L179.148 185.588V185.504H179.063H179.021L179.063 185.462L179.021 185.42H178.979H178.937L178.81 185.462L178.685 185.546L178.558 185.715V185.757L178.474 185.799L178.432 185.757L178.348 185.799H178.306V185.757H178.263L178.179 185.799L178.096 185.926V186.137L178.138 186.262L178.179 186.388H178.221H178.306V186.473L178.221 186.557L178.306 186.726V186.851V186.935L178.263 186.893V186.935V186.978L178.179 187.02L178.096 187.062L178.054 187.02L178.012 187.062V187.02L177.885 186.978L177.801 187.062H177.759L177.716 187.104H177.674V187.146H177.59V187.062H177.465V186.978L177.421 186.935H177.338V186.851L177.296 186.809H177.127L177.085 186.851L176.959 186.893H176.917L176.874 186.851L176.917 186.768H176.832H176.79V186.726H176.707L176.665 186.768V186.726H176.621H176.538L176.496 186.768L176.454 186.682H176.412H176.37H176.327H176.243H176.074V186.641H176.032L175.823 186.682V186.641L175.738 186.599H175.527L175.19 186.641L174.728 186.768L174.643 186.809L174.601 186.893L174.518 186.851L174.391 186.935L174.349 186.978V187.02L174.307 187.062H174.265L174.307 187.02L174.265 186.978L174.223 186.935L174.096 186.978L173.843 187.104L173.76 187.146V187.231H173.718L173.676 187.273L173.801 187.231L173.76 187.273L173.718 187.357V187.441L173.634 187.482V187.526H173.676L173.634 187.568H173.591L173.465 187.651V187.735L173.507 187.777L173.549 187.735V187.777H173.591L173.549 187.82L173.507 187.862L173.423 187.904V187.988V188.073H173.465H173.381L173.338 188.115V188.157L173.296 188.115L173.338 188.073H173.254H173.043L172.96 188.157L172.918 188.199L172.96 188.24H172.918H172.876L172.834 188.282V188.367L172.792 188.451V188.409L172.834 188.326L172.792 188.282L172.749 188.24L172.707 188.282L172.665 188.326V188.282H172.623H172.581V188.157L172.665 188.115L172.623 188.03L172.581 187.988L172.454 187.946H172.37H172.287V187.988V188.03L172.243 187.946H172.202L172.16 187.988H172.202L172.243 188.073V188.115H172.16V188.157V188.199L172.202 188.24H172.16V188.282L172.118 188.367H172.076L172.118 188.282L171.992 188.24L171.739 188.282L171.487 188.409L170.812 188.704L170.181 189.082L169.676 189.335L169.592 189.419L169.465 189.462L169.045 189.757L168.75 189.924L168.371 190.262V190.304V190.429L168.329 190.471L168.245 190.556L168.287 190.598L168.329 190.64V190.682H168.371L168.329 190.724L168.371 190.766H168.329V190.809L168.287 190.766L168.245 190.809V190.851H168.203L168.076 190.893L167.909 190.977L167.824 191.06L167.529 191.271L167.276 191.44L167.234 191.482V191.566L167.151 191.608L166.982 191.735V191.777L166.814 191.819L165.93 192.366H165.887V192.408L165.678 192.535L165.635 192.618L165.34 192.702L165.087 192.871L164.54 193.208L164.331 193.376L163.573 193.966L163.151 194.387L162.942 194.639L162.9 194.766L162.856 194.891H162.731V194.934L162.773 195.06L162.815 195.102V195.144V195.229L162.731 195.313L162.689 195.482V195.524H162.731V195.565V195.607V195.565H162.689H162.647L162.52 195.649L162.351 195.818L162.015 196.071L161.594 196.533H161.552V196.449L161.636 196.365L162.015 196.029L161.973 195.986L162.015 195.944H161.973H161.931L161.889 195.986L161.805 195.944V195.986V196.029V196.071H161.72L161.678 196.113L161.636 196.071L161.552 196.113L161.467 196.155L161.257 195.986L161.215 195.944L161.173 195.86H161.089L161.005 195.818L160.962 195.733L161.089 195.691L161.131 195.607V195.524H161.173L161.215 195.482L161.131 195.438L161.047 195.397V195.355L160.962 195.271V195.229L160.878 195.102V195.06L160.836 195.018L160.878 194.934L160.836 194.807L160.878 194.766V194.724H160.836L160.753 194.682V194.639L160.794 194.597H160.753V194.555L160.711 194.513L160.667 194.471L160.626 194.387L160.584 194.429V194.471V194.513H160.542H160.5V194.555V194.597L160.458 194.639V194.682V194.766H160.415L160.373 194.682H160.331V194.724L160.247 194.807L160.205 194.891L160.12 194.976V194.891H160.162V194.766H160.12L160.078 194.807V194.766H159.994V194.724V194.682L159.867 194.555H159.826V194.513L159.742 194.471L159.616 194.429L159.573 194.471H159.489L159.236 194.639L159.195 194.807V194.891H159.111L159.068 194.934L158.984 195.06L158.942 195.102L158.9 195.186H158.858L158.773 195.102L158.731 195.06L158.689 195.018V194.934L158.647 194.891V194.849H158.564V194.766L158.522 194.724V194.682H158.478V194.639V194.597V194.555V194.513H158.522V194.471L158.605 194.429L158.647 194.344V194.302V194.26L158.689 194.218L158.647 194.176L158.689 194.135L158.647 194.091V194.049V194.008V193.924V193.882H158.689V193.924L158.731 193.84H158.689L158.731 193.797L158.773 193.755V193.713V193.671H158.647L158.689 193.629L158.647 193.544L158.689 193.46L158.731 193.418V193.376V193.293L158.858 193.208L158.9 193.166L158.984 193.124V193.04H159.026V192.955L159.068 192.913V192.871L159.026 192.829V192.871H158.942H158.9V192.829L158.858 192.787H158.816V192.745H158.773V192.702H158.689L158.647 192.618V192.577L158.605 192.535L158.564 192.45L158.522 192.493L158.478 192.45L158.437 192.408L158.395 192.45L158.353 192.408L158.269 192.493H158.184V192.535L158.1 192.577L158.058 192.66L157.974 192.618H158.016L157.974 192.577L158.016 192.535H157.974L158.016 192.493L157.974 192.45L157.889 192.408V192.45V192.493V192.577L157.847 192.535L157.805 192.493L157.637 192.535L157.553 192.577H157.511V192.493H157.469L157.427 192.577L157.342 192.618L157.3 192.493L157.216 192.45H157.131L157.089 192.366L157.047 192.324L156.964 192.408L156.88 192.324L156.837 192.366L156.922 192.45H156.88L156.795 192.408L156.584 192.45H156.542V192.493H156.5L156.458 192.45H156.416H156.333L156.248 192.535L156.206 192.45H156.122V192.408H156.038V192.324H155.995L155.911 192.366L155.953 192.24H155.995V192.198H155.953L155.869 192.24L155.785 192.198H155.742L155.7 192.24L155.742 192.282L155.785 192.24L155.742 192.282V192.324V192.366L155.7 192.408L155.658 192.493H155.616L155.575 192.535H155.533L155.489 192.45H155.448V192.493H155.364V192.45H155.322L155.28 192.535L155.195 192.493L155.153 192.45H154.985H154.944H154.9H154.817L154.775 192.493V192.535H154.691V192.618H154.522H154.48L154.396 192.577H154.353H154.269L154.144 192.45H154.1V192.408H154.059L154.1 192.324V192.282H154.059V192.24H154.017L154.059 192.113L154.017 192.071V192.029L154.059 191.987L154.1 191.946L154.017 191.904H154.059V191.86L154.017 191.777V191.735V191.693H154.059L154.1 191.651L154.144 191.693L154.186 191.608L154.227 191.566L154.186 191.524V191.44L154.144 191.355H154.186L154.311 191.313V191.229L154.353 191.187L154.396 191.146H154.438V191.104V191.06H154.396L154.438 190.977L154.396 190.935L154.48 190.851L154.522 190.766V190.724H154.48L154.438 190.809L154.396 190.766V190.724L154.48 190.598L154.564 190.471H154.606L154.733 190.346L154.691 190.304H154.606L154.564 190.262H154.438V190.177H154.396L154.311 190.093H154.269L154.227 190.135L154.186 190.093V190.051V190.009L154.144 189.966L154.1 189.924L154.144 189.84L154.1 189.798H154.059L154.1 189.757L154.059 189.715H153.975V189.671L153.806 189.546L153.764 189.504L153.849 189.462V189.377V189.251V189.167L153.933 189.124L153.891 189.082V189.04H153.849L153.722 188.957V188.915L153.68 188.871L153.638 188.915L153.596 188.871L153.553 188.915V188.871L153.427 188.83L153.469 188.788H153.427L153.469 188.746L153.344 188.704H153.302V188.662L153.259 188.62L153.302 188.577H153.259V188.535L153.175 188.493L153.133 188.451L153.091 188.409V188.326H153.049V188.282H153.006H152.964H152.922L152.964 188.24H152.922H152.964L153.006 188.199H152.964V188.157L152.922 188.115H152.88V188.073L152.922 188.03V187.988L152.838 187.946H152.796V187.904H152.88V187.862H152.838V187.82L152.796 187.777L152.755 187.82L152.711 187.735H152.796H152.838L152.796 187.693V187.651H152.755V187.609L152.669 187.651V187.693L152.586 187.651H152.544V187.609L152.502 187.568L152.459 187.526L152.417 187.482V187.357L152.333 187.441L152.291 187.357L152.249 187.315V187.231L152.207 187.188H152.249L152.291 187.146L152.207 187.104H152.249L152.333 187.146L152.291 187.104V187.062H152.333L152.417 187.02L152.502 186.978V186.935V186.893V186.809L152.459 186.726V186.682L152.502 186.641L152.417 186.599L152.459 186.557V186.515V186.473V186.431L152.544 186.473H152.586L152.544 186.388V186.346L152.586 186.262L152.544 186.22V186.178H152.502V186.137H152.459L152.417 186.093H152.375V186.051V186.01H152.333V185.968L152.249 185.926V185.884L152.164 185.841L152.207 185.799V185.757H152.164V185.715V185.673L152.122 185.631L152.164 185.546L152.249 185.462V185.42L152.207 185.379L152.249 185.293L152.207 185.21L152.249 185.168L152.122 185.084L152.08 185.042L152.122 184.999H152.164L152.122 184.915L152.164 184.873V184.789L152.249 184.831V184.789V184.746V184.662V184.62L152.291 184.579L152.333 184.537H152.375L152.417 184.579H152.459L152.417 184.537L152.459 184.493H152.375V184.41H152.333L152.291 184.368H152.249V184.326V184.284H152.207H152.164H152.122V184.242L152.249 184.199L152.291 184.242L152.333 184.199L152.291 184.157V184.115L152.164 184.031H152.038V183.989V183.904L152.08 183.948L152.122 183.862V183.779L152.08 183.695V183.568L151.997 183.4L151.955 183.357L151.997 183.273H151.955L151.911 183.231V183.19V183.104L151.786 182.895L151.744 182.853L151.786 182.81H151.66L151.617 182.768V182.726L151.575 182.768L151.533 182.684L151.449 182.642L151.407 182.6L151.491 182.473L151.449 182.431L151.407 182.39H151.322L151.238 182.431L151.155 182.39H151.07L151.028 182.348H150.986L150.944 182.306V182.263H150.902L150.86 182.221L150.818 182.179L150.691 182.221H150.607L150.566 182.179L150.522 182.137L150.48 182.179L150.397 182.095H150.313V181.968V181.926L150.355 181.842V181.8H150.397V181.759L150.27 181.673L150.186 181.632H150.06L149.933 181.506V181.463L149.975 181.421L150.018 181.295L149.975 181.211V181.168L149.849 181.084L149.808 181.126V181.168L149.849 181.253L149.808 181.295H149.766H149.724L149.681 181.168H149.597L149.471 181.126V181.168L149.344 181.295L149.26 181.253H149.175L149.091 181.379H149.049H148.966L148.839 181.337L148.755 181.421L148.629 181.463H148.502L148.418 181.421L148.333 181.463H148.291V181.421L148.25 181.379L148.081 181.295L147.997 181.337H147.913L147.871 181.421H147.786H147.66L147.619 181.337L147.535 181.253V181.211L147.408 181.126L147.324 181.168H147.239L147.197 181.211V181.337H147.155L147.113 181.421L146.986 181.379L146.902 181.421L146.777 181.337H146.735L146.65 181.421L146.566 181.379L146.524 181.337L146.482 181.253L146.44 181.211L146.355 181.168L146.188 181.126L146.102 181.211L146.019 181.253L145.935 181.211L145.808 181.168L145.766 181.084H145.682H145.64L145.597 181.126L145.555 181.168L145.388 181.463L145.261 181.506H145.219H145.177L145.135 181.463L145.093 181.421H144.966H144.84L144.798 181.379L144.84 181.126V181.084V181.042L144.713 181.001L144.671 180.874L144.63 180.832L144.546 180.664L144.293 180.495L144.251 180.453H144.082H144.04L143.957 180.495H143.913L143.83 180.368H143.704L143.619 180.411H143.535L143.199 180.242H142.862L142.609 180.159L142.482 180.074L142.399 180.032L142.272 179.99H142.23L142.104 179.906L142.062 179.737H142.019L141.935 179.653L141.851 179.611L141.724 179.653H141.683L141.515 179.611H141.43L141.262 179.57L141.177 179.611H141.093L140.925 179.526H140.799L140.673 179.695H140.63L140.462 179.779H140.377L140.335 179.737L140.168 179.779L140.126 179.822L140.041 179.779L139.915 179.737L139.746 179.611L139.662 179.57H139.452H139.368L139.241 179.653H139.115L139.073 179.57L139.031 179.401V179.359H138.946L138.904 179.317H138.863L138.779 179.275L138.315 179.401H138.273L138.146 179.359L138.063 179.275L138.021 179.232L137.979 179.19L137.726 178.979H137.599L137.39 178.853L137.221 178.812H137.179H137.01L136.799 178.685L136.715 178.643H136.674L136.59 178.685L136.548 178.728L136.463 178.853L136.421 178.979V179.022L136.379 179.19V179.232L136.421 179.484L136.252 179.526L136.168 179.57L135.999 179.653H135.957V179.611V179.443L135.874 179.317L135.832 179.275L135.663 179.317L135.579 179.359L135.495 179.443L135.368 179.401H135.074L134.863 179.317L134.779 179.275H134.737L134.695 179.232H134.61V179.275H134.526L134.316 179.401H134.274L134.148 179.317L134.063 179.275H134.021L133.853 179.106L133.768 178.979H133.726L133.643 179.022L133.264 179.275L133.012 179.359H132.885L132.717 179.275L132.548 179.232L132.506 179.19H132.464H132.337L132.127 179.275L132.043 179.232L131.748 179.022L131.623 178.979L131.328 179.022L131.285 179.064L131.201 179.106L131.117 179.148V179.19L131.032 179.232L130.948 179.317L130.865 179.401L130.696 179.443L130.612 179.57L130.57 179.443L130.528 179.317ZM181.716 184.326V184.368H181.674V184.326L181.716 184.284H181.674V184.326M180.621 186.515V186.473V186.515H180.663H180.705L180.663 186.557H180.705V186.599L180.663 186.641V186.599L180.621 186.557V186.515ZM174.432 187.062V187.02V187.062ZM179.443 185.168H179.485H179.443ZM180.537 185.084H180.495L180.537 185.042V185.084H180.495H180.537ZM181.379 184.031V183.989V184.031ZM178.854 185.504V185.462V185.504ZM178.937 187.651V187.609V187.651ZM181.337 184.452H181.379V184.493H181.337V184.452ZM178.769 187.651V187.609V187.651ZM179.063 187.231H179.021V187.273H178.979V187.315L179.106 187.357L179.063 187.399L179.106 187.441H179.148L179.232 187.526L179.274 187.441L179.316 187.482H179.358L179.401 187.526L179.358 187.568L179.316 187.526V187.568V187.651V187.693V187.735V187.777H179.358L179.316 187.82V187.862L179.232 187.946L179.106 187.904L179.021 187.777L179.063 187.693L178.979 187.568L178.896 187.609V187.568L178.854 187.609H178.81L178.769 187.568L178.727 187.609H178.685V187.651L178.601 187.609L178.558 187.693L178.306 187.735H178.263L178.138 187.777L178.012 187.735L177.927 187.609V187.441V187.399H177.969L178.054 187.315H178.096V187.273L178.179 187.231H178.221L178.179 187.188H178.221L178.432 186.978L178.516 186.935V186.768H178.558V186.726L178.601 186.682V186.641V186.599L178.643 186.473V186.388L178.727 186.346L178.81 186.388L178.854 186.431H178.979V186.473H179.063L179.106 186.515H179.148L179.19 186.557V186.599L179.232 186.641H179.274L179.316 186.726H179.358L179.316 186.768V186.851L179.274 186.935H179.316V186.978L179.232 187.02L179.274 187.062H179.316L179.274 187.104H179.316H179.358L179.316 187.146L179.19 187.104H179.106L179.021 187.188H179.063V187.231ZM180.579 185.252H180.621H180.579ZM179.358 186.978V186.935L179.401 186.978H179.358ZM168.498 190.513H168.54H168.498ZM181.379 184.157H181.421H181.379V184.199L181.337 184.157H181.379ZM181.126 184.242H181.085V184.199H181.126V184.242ZM176.327 186.809H176.37H176.327ZM177.506 187.231V187.188H177.548V187.146V187.188V187.231H177.506ZM168.918 190.556H168.961V190.598H168.918V190.556ZM168.961 190.682V190.64H169.003V190.682H168.961ZM181.632 184.452V184.493V184.452H181.674V184.41V184.452V184.493L181.632 184.452ZM176.285 186.893V186.851H176.327V186.893H176.285ZM178.937 185.588L178.979 185.546H179.021V185.588H178.937ZM175.907 187.273V187.231H175.949H175.99L175.949 187.273V187.315H175.907V187.273ZM179.779 185.379L179.821 185.337L179.863 185.379V185.42L179.821 185.379L179.779 185.42V185.379ZM179.779 186.893L179.863 186.851L179.905 186.809V186.851L180.074 186.935L180.032 186.978L179.948 186.935L179.863 187.02L179.821 186.935L179.779 186.893ZM180.41 185.168V185.126L180.537 185.168V185.21L180.41 185.252L180.285 185.379V185.293V185.252L180.243 185.21L180.285 185.168V185.126V185.168L180.327 185.21H180.368L180.41 185.168Z"
							fill="#6ba4da" />
						<path class="hover:!opacity-50 transition-all duration-300"
							d="M181.716 184.326V184.368H181.674V184.326L181.716 184.284H181.674V184.326M180.621 186.515V186.473V186.515ZM180.621 186.515H180.663H180.705L180.663 186.557H180.705V186.599L180.663 186.641V186.599L180.621 186.557V186.515ZM180.537 185.084H180.495L180.537 185.042V185.084ZM180.537 185.084H180.495H180.537ZM181.379 184.157H181.421H181.379ZM181.379 184.157V184.199L181.337 184.157H181.379ZM181.632 184.452V184.493V184.452ZM181.632 184.452H181.674V184.41V184.452V184.493L181.632 184.452ZM130.528 179.317L130.485 179.275V179.232V179.19L130.528 179.106L130.654 178.937L130.781 178.812L130.823 178.77L131.075 178.685L131.117 178.643L131.201 178.517L131.454 178.39H131.496L131.537 178.348L131.875 178.264L132.043 178.18H132.085L132.17 178.012L132.379 177.843L132.421 177.759L132.759 177.548L132.885 177.506L133.054 177.381L133.306 177.295L133.432 177.212L133.516 177.17L133.643 177.086L133.768 176.959L133.979 176.917L134.148 176.833L134.274 176.79L134.316 176.748H134.359L134.401 176.664L134.526 176.539L134.568 176.496L134.863 176.286L134.905 176.159L134.948 176.117L135.032 176.033L135.243 175.739L135.41 175.192L135.453 175.065L135.663 174.812H135.748V174.77L135.832 174.728L135.915 174.601L136.21 174.392L136.252 174.265V174.181L136.379 173.886L136.505 173.802L136.757 173.717L136.799 173.634L136.884 173.55L137.052 173.255V173.212V173.086L136.968 172.917V172.792L136.757 172.623L136.715 172.539L136.799 172.412L136.884 172.245L136.968 172.203H137.01L137.263 172.245H137.39L137.557 172.161L137.599 172.118L137.684 171.992L137.81 171.866L137.852 171.739L137.894 171.613L137.937 171.445L138.188 171.234L138.231 171.192V171.15V171.108V171.066L138.273 170.897L138.315 170.687L138.273 170.645L138.231 170.392L138.146 170.266L138.104 170.224L138.146 170.139L138.104 169.929L138.146 169.845L138.188 169.803H138.357L138.484 169.761H138.526L138.568 169.677L138.694 169.634L138.779 169.424V169.297L138.863 169.172L138.904 169.045L139.073 168.834L139.157 168.792H139.41H139.452L139.704 168.625L139.746 168.539L139.788 168.245L139.704 168.161L139.662 168.035V167.825L139.704 167.614V167.572V167.53L139.621 167.403L139.662 167.194L139.873 166.73L139.915 166.688L139.957 166.646V166.603L139.999 166.561L140.041 166.519L140.335 166.35L140.462 166.225L140.504 166.099L140.715 165.761L140.799 165.678L140.968 165.552L141.052 165.509V165.467L141.262 165.088L141.346 165.046L141.388 164.878L141.43 164.836H141.472L141.599 164.752L141.724 164.667L142.104 164.583H142.357L142.524 164.541L142.651 164.499H142.693L142.777 164.457L142.862 164.372L142.946 164.33L143.157 164.163L143.199 164.078L143.282 163.825L143.408 163.53L143.577 163.194V163.11L143.788 162.816V162.772H143.872H143.913L143.999 162.689L144.124 162.605V162.52H144.208H144.293H144.377L144.503 162.394L144.546 162.352L144.713 162.31L144.84 162.225V162.183H144.924L145.261 162.099L145.555 162.016H145.597L145.682 161.974H145.724L145.85 161.763L145.935 161.678L146.019 161.636L146.144 161.468L146.188 161.383H146.271H146.397L146.482 161.3L146.566 161.258H146.692L146.777 161.216L146.86 161.174L146.944 161.216L147.071 161.258L147.197 161.3L147.45 161.594L147.577 161.636V161.721H147.702L147.786 161.763H147.829L147.997 161.721L148.25 161.805L148.418 161.721H148.544L148.713 161.763L148.755 161.805H148.797L148.924 161.763H149.133H149.175L149.218 161.805L149.302 161.847L149.471 162.016L149.513 162.058H149.597L149.681 162.099L150.018 162.058L150.355 162.183L150.439 162.225H150.566H150.691L150.818 162.141L151.07 162.099H151.113H151.322H151.364L151.575 162.141H151.997H152.08V162.099L152.207 162.058L152.375 162.016H152.502L152.544 161.974L152.711 162.016L152.838 162.058L152.922 162.225L152.964 162.268L153.133 162.436H153.259L153.764 162.478L153.891 162.436L154.017 162.352L154.144 162.31L154.353 162.352H154.396L154.438 162.394V162.478V162.563L154.353 162.605H154.227L154.144 162.689L154.059 163.025V163.194V163.236L154.1 163.32V163.657L154.311 164.036L154.353 164.163V164.247L154.522 164.499H154.564L154.775 164.541L154.858 164.583H154.9V164.541L155.153 164.372L155.238 164.288L155.406 163.91L155.575 163.572L155.616 163.53H155.785L155.869 163.572L156.038 163.614L156.08 163.699L156.164 163.91L156.206 164.247V164.372L156.164 165.088L156.206 165.13L156.584 165.383H156.669L156.711 165.341L156.795 165.172V165.13V165.046V165.005L156.711 164.794L156.753 164.583L156.669 164.457V164.414V164.288L156.753 164.12L156.837 164.036L156.88 163.994V163.952L156.837 163.867L156.88 163.741L156.922 163.699L157.047 163.614H157.089H157.342L157.511 163.572L157.637 163.53H157.678L157.889 163.614H158.016L158.058 163.657H158.184L158.311 163.614L158.478 163.447L158.564 163.405H158.731L158.858 163.447H158.984H159.153L159.363 163.363H159.447L159.658 163.32L159.826 163.363H159.867H159.953H159.994L160.078 163.32H160.205L160.331 163.363L160.415 163.447L160.458 163.489H160.5H160.542H160.667L160.753 163.447H160.794L160.836 163.363V163.32L160.626 163.11V163.068L160.667 162.857L160.626 162.816L160.667 162.772H160.794L160.836 162.816L160.92 162.857L161.047 163.068L161.089 163.194L161.131 163.236H161.173H161.215L161.257 163.363L161.384 163.405L161.467 163.489L161.594 163.53H161.72L161.889 163.447L161.931 163.32L162.056 163.363L162.142 163.236L162.183 163.152L162.225 163.068V162.857L162.267 162.816H162.309L162.478 162.941L162.52 163.152L162.604 163.278L162.773 163.363H162.815L162.942 163.236L162.983 163.152V163.068V162.983L163.025 162.899V162.857L162.983 162.816H162.942V162.772V162.73V162.689L162.983 162.647L163.067 162.52H163.109L163.194 162.563L163.404 162.478H163.614L163.741 162.52L163.825 162.478L163.951 162.436H163.993L164.204 162.605V162.647V162.689L164.289 162.772L164.331 162.816L164.414 162.899L164.498 162.857H164.583L164.709 162.73V162.605L164.793 162.563H164.962V162.52L165.045 162.478H165.214L165.298 162.394H165.383L165.425 162.352L165.467 162.31V162.352L165.593 162.478L165.678 162.563L165.72 162.647V162.689V162.73L165.635 162.772V162.816V162.899L165.803 162.983L165.845 163.11H165.887H166.056L166.14 163.236H166.225L166.309 163.32L166.478 163.363L166.561 163.53L166.687 163.572H166.729L166.772 163.657V163.783H166.814L166.856 163.867L166.94 163.994V164.036L166.856 164.247H166.814L166.729 164.372H166.687L166.645 164.457V164.583H166.603V164.667V164.709H166.561L166.603 164.752L166.52 164.794L166.561 164.919V164.961V165.005V165.046H166.603L166.561 165.13L166.603 165.172L166.561 165.214H166.603L166.561 165.256H166.603L166.561 165.299V165.341H166.603V165.383L166.561 165.425V165.467L166.687 165.552H166.772L166.814 165.636L166.94 165.678L167.067 165.803H167.151L167.234 165.846L167.403 165.888L167.445 165.972H167.487V166.056L167.529 166.141L167.487 166.183L167.571 166.35H167.614V166.394V166.436V166.477L167.698 166.519V166.561V166.646L167.782 166.688V166.73V166.772L167.74 166.856V166.941L167.698 167.025L167.656 167.067V167.108H167.445L167.361 167.067L167.32 167.108V167.15L167.234 167.235L167.276 167.319H167.234L167.193 167.488L167.151 167.53H167.109L167.067 167.656L166.982 167.698L167.067 167.867L166.982 168.035L166.898 168.245L166.982 168.414L167.067 168.498H167.193V168.583L167.234 168.666H167.32L167.361 168.75L167.445 168.792L167.487 168.834L167.445 168.961V169.045L167.403 169.087L167.445 169.214L167.487 169.339L167.529 169.424L167.487 169.55H167.529L167.571 169.592L167.698 169.634V169.677H167.614V169.719V169.761L167.529 169.803L167.656 169.929L167.614 170.056L167.656 170.097V170.139L167.74 170.266L167.782 170.35V170.308H167.824H167.951H167.992L167.951 170.35V170.392L167.909 170.434V170.519L167.992 170.476L168.034 170.561H168.076V170.603L168.119 170.687V170.772V170.814L168.203 170.897L168.161 170.939H168.203L168.245 171.023V171.066L168.287 171.15L168.371 171.192L168.414 171.234L168.371 171.276L168.329 171.319L168.371 171.403L168.329 171.486H168.287L168.329 171.57V171.613H168.287L168.329 171.655H168.371L168.414 171.697L168.456 171.655V171.697L168.54 171.655H168.582H168.623L168.665 171.697L168.709 171.655L168.792 171.697L168.834 171.655L168.876 171.697V171.655H168.961L169.003 171.613H169.045L169.087 171.57L169.213 171.528V171.486H169.256V171.445H169.34L169.382 171.403V171.361L169.423 171.319H169.509L169.676 171.361L169.718 171.319L169.76 171.276H169.845H169.887L169.845 171.361L169.887 171.403L170.013 171.486H170.098V171.445L170.14 171.486L170.181 171.57L170.265 171.445L170.307 171.403L170.35 171.361H170.392L170.434 171.276H170.476H170.56V171.361V171.403V171.445V171.486L170.603 171.528L170.645 171.613H170.687L170.729 171.655V171.697H170.771L170.729 171.739L170.771 171.781L170.854 171.823V171.781L171.023 171.697V171.739L171.107 171.781H171.192L171.276 171.823H171.318H171.36V171.866V171.908L171.402 171.95V172.034L171.445 172.076L171.36 172.161V172.245L171.318 172.286L171.36 172.37L171.402 172.412L171.487 172.497V172.539H171.445L171.402 172.581V172.623L171.36 172.708V172.75L171.318 172.792L171.36 172.834V172.876L171.276 172.917V173.003H171.192L171.149 173.044L171.192 173.128H171.149L171.065 173.17V173.297L170.981 173.339L170.729 173.297V173.381L170.687 173.423V173.465L170.729 173.55L170.687 173.634V173.675V173.717V173.844V173.886H170.603L170.56 173.928H170.518L170.56 174.012L170.434 174.139V174.181L170.35 174.223L170.307 174.307L170.35 174.392H170.392H170.434L170.518 174.517V174.559L170.56 174.601L170.518 174.686L170.476 174.728H170.434L170.392 174.77L170.476 174.854L170.434 174.939L170.518 174.981V175.065L170.603 175.192L170.645 175.233H170.687L170.729 175.317L170.771 175.359V175.401V175.444V175.486H170.729L170.603 175.401L170.56 175.444H170.518V175.486L170.476 175.528L170.392 175.486V175.528H170.35L170.307 175.612L170.392 175.696L170.476 175.739V175.781L170.35 175.823H170.265L170.181 175.864L170.14 175.823H170.098V175.864V175.906L170.14 175.948H170.181H170.223H170.265H170.307H170.35L170.434 175.991L170.56 175.948L170.645 176.033L170.729 176.075L170.771 176.201H170.854V176.244L170.771 176.328L170.603 176.37L170.56 176.496H170.476H170.434H170.392L170.434 176.539L170.35 176.748L170.392 176.79L170.265 176.875L170.307 176.959L170.265 176.917L170.223 177.001L170.181 177.043V177.086L170.223 177.128L170.181 177.17L170.223 177.254L170.14 177.337H170.098L170.14 177.381H170.181V177.422H170.223V177.464L170.265 177.506V177.548V177.59H170.307V177.633H170.35L170.392 177.717H170.476L170.434 177.801L170.476 177.843L170.434 177.97V178.012L170.56 178.053V178.095H170.603L170.645 178.137L170.771 178.18V178.137L170.854 178.18H170.898H170.981L171.023 178.222V178.264L171.065 178.222H171.149L171.192 178.264L171.149 178.306V178.348H171.192L171.276 178.39V178.475L171.234 178.517L171.445 178.601V178.685L171.529 178.643L171.571 178.685H171.698H171.781V178.77H171.865V178.812L171.949 178.853H171.992L172.034 178.812V178.895L171.907 179.022V179.106H172.034L171.949 179.19L172.076 179.317L171.949 179.359V179.401L171.992 179.443H172.076L172.118 179.484L172.16 179.526V179.611L172.076 179.653H172.034L172.076 179.611L172.034 179.57L171.992 179.611L171.907 179.57L171.865 179.611L171.739 179.653V179.695L171.654 179.653L171.612 179.695V179.737L171.654 179.779L171.612 179.822L171.654 179.864H171.739L171.781 179.99H171.865V180.032L171.949 180.074V180.032L172.076 180.117H172.16L172.202 180.074V180.117H172.243L172.329 180.242L172.37 180.201H172.496V180.242L172.454 180.284V180.326H172.412V180.368L172.329 180.411L172.243 180.579V180.664L172.287 180.706L172.243 180.748L172.287 180.874H172.202V180.915H172.243V180.959L172.287 181.001L172.329 181.084L172.454 181.126L172.496 181.084L172.623 181.042L172.749 181.084L172.834 180.959H172.918H172.96V181.042H173.043L173.087 181.084L173.128 181.001L173.338 180.915L173.381 180.874L173.423 180.915L173.634 180.874L173.676 180.832V180.874L173.718 181.001V181.042L173.676 181.168L173.634 181.211L173.718 181.253L173.801 181.168H173.887L173.97 181.084L174.096 181.042L174.265 181.084L174.391 181.001L174.518 181.042L174.559 181.001L174.643 180.959V180.915L174.728 180.874L174.812 180.832L174.854 180.79L174.896 180.748H174.981L175.065 180.664V180.621L175.149 180.579H175.19L175.149 180.664V180.706H175.232V180.748V180.832H175.276V180.874V180.959H175.317L175.401 180.915H175.443V180.874V180.79H175.485L175.527 180.706H175.57H175.654V180.664L175.738 180.706V180.664L175.823 180.706V180.79L175.865 180.832H175.907L175.99 180.79L176.032 180.748V180.706L175.99 180.495H176.074L176.117 180.411L176.159 180.453L176.201 180.537H176.243L176.285 180.579H176.37V180.537H176.327L176.285 180.495L176.243 180.453V180.411L176.285 180.326H176.327L176.37 180.284V180.201H176.327V180.117L176.243 179.99H176.285H176.243H176.117H176.074L175.949 180.032L175.823 180.074H175.78L175.696 179.99L175.738 179.822L175.907 179.779L175.949 179.737L176.074 179.695V179.653H176.117L176.159 179.611V179.57H176.243L176.327 179.611L176.37 179.57L176.496 179.526H176.454V179.484L176.37 179.443L176.327 179.317H176.243V179.275L176.201 179.232L176.243 179.19L176.285 179.148V179.106L176.327 179.064L176.454 179.106L176.58 179.022L176.665 179.064V179.106L176.707 179.19H176.665L176.621 179.275H176.665L176.58 179.359V179.401L176.538 179.443L176.621 179.526H176.665L176.748 179.484L176.959 179.443L177.043 179.317H177.127L177.169 179.275H177.127L177.212 179.19V179.275H177.296L177.338 179.359L177.212 179.443L177.169 179.484V179.526L177.212 179.57L177.379 179.526H177.421L177.465 179.484H177.506L177.674 179.359L177.759 179.401L177.843 179.19L177.801 179.148H177.843L177.969 179.232H178.012L178.054 179.275L178.096 179.317H178.179L178.221 179.359L178.263 179.401L178.221 179.526H178.306H178.348L178.474 179.443H178.558L178.601 179.359H178.685L178.727 179.317L178.937 179.275L179.063 179.317L179.106 179.275H179.148V179.232L179.19 179.148L179.148 179.106L179.358 178.979H179.401L179.485 178.937H179.527L179.695 178.895L179.779 178.812L179.737 178.77V178.728L179.779 178.685L179.863 178.601H179.905L179.99 178.559L180.032 178.517H180.074L180.158 178.475L180.2 178.432L180.285 178.475L180.41 178.39L180.537 178.348L180.621 178.306V178.348H180.705H180.79H180.832L180.999 178.39L181.043 178.348L181.168 178.264H181.337H181.421L181.463 178.137L181.547 178.095L181.59 178.053H181.632L181.674 178.095H181.757H181.799L181.884 178.053L181.968 178.012V177.97H182.136L182.221 178.012H182.305L182.389 178.095L182.474 178.18L182.516 178.348V178.39L182.474 178.475L182.516 178.517H182.557V178.559V178.643H182.641L182.684 178.685H182.726L182.768 178.728L182.81 178.812L182.768 178.853V178.937L182.894 178.895L182.936 178.937L182.979 178.895L183.021 178.937L182.979 179.064V179.106V179.232H183.021L183.063 179.275L183.105 179.232L183.188 179.317L183.23 179.275V179.232L183.274 179.275L183.315 179.359H183.357L183.441 179.19L183.483 179.275L183.568 179.232L183.652 179.317H183.694H183.736L183.652 179.401V179.443H183.694L183.652 179.401H183.694H183.779L183.821 179.443H183.863L183.988 179.275L183.946 179.232H183.988L184.03 179.275L184.115 179.317L184.157 179.275H184.199L184.241 179.232L184.325 179.19H184.41L184.452 179.232H184.494V179.19L184.452 179.148V179.106L184.536 179.064V179.022H184.578L184.663 179.064H184.705H184.746L184.705 179.148H184.746V179.275H184.788H184.83L184.788 179.19V179.148L184.83 179.19V179.148V179.106L184.873 179.148L184.957 179.106L184.999 179.19L185.041 179.148L185.083 179.19H185.125H185.168L185.21 179.275V179.232L185.294 179.19L185.419 179.275L185.463 179.232H185.546H185.588L185.63 179.317L185.672 179.275H185.715V179.359L185.757 179.401H185.799L185.841 179.443L185.799 179.484L185.883 179.57L185.968 179.653V179.695V179.737L185.925 179.779H185.883V179.864L185.841 179.906L185.757 179.948H185.715V179.99H185.757L185.715 180.032H185.588L185.463 180.159L185.504 180.201H185.419L185.377 180.284V180.326L185.419 180.368L185.377 180.411H185.463V180.453V180.495H185.377L185.294 180.664L185.21 180.706V180.664H185.125L184.999 180.748V180.79H184.957L184.999 180.748L184.957 180.706L184.663 180.832H184.578H184.536H184.494V180.79H184.41H184.368L184.325 180.832L184.283 180.915L184.241 180.959H184.199L184.073 181.001V180.959H184.03V180.915H183.988L184.03 180.832L183.988 180.79H183.905H183.863L183.779 180.874L183.694 180.915L183.61 181.001L183.526 181.042L183.399 180.959L183.274 181.042H183.23L183.063 181.126L183.021 181.168V181.211L182.894 181.295L182.81 181.211L182.726 181.337H182.684H182.641H182.599L182.557 181.295L182.516 181.337L182.389 181.421L182.305 181.506L182.347 181.548L182.305 181.59V181.632H182.263H182.221H182.136H182.094H182.052V181.673V181.715L182.01 181.759L182.052 181.8L182.01 181.884H182.052V181.926L182.01 181.968V182.053L181.968 182.095V182.137L181.926 182.179V182.221V182.263V182.306L181.884 182.348H181.926V182.39H181.968L181.926 182.473H181.968L181.926 182.515L181.968 182.557L181.884 182.6L181.926 182.642L181.841 182.684L181.884 182.768L181.841 182.81H181.757L181.716 182.853H181.674V182.895H181.632L181.547 182.937V182.979V183.021L181.505 183.063V183.148L181.463 183.19L181.505 183.231H181.547V183.357H181.674L181.799 183.4L181.757 183.442L181.841 183.484V183.526L181.884 183.568L181.841 183.61L181.968 183.568V183.61L182.094 183.652V183.695L182.136 183.779V183.821L182.179 183.904H182.136L182.263 183.948L182.347 184.031H182.389L182.432 184.073L182.474 184.115H182.432H182.347L182.136 184.157L182.094 184.115H182.052H182.01V184.157L181.968 184.199H181.884L181.841 184.242H181.757H181.716L181.757 184.199L181.799 184.115L181.674 184.073H181.59L181.463 184.157V184.073V184.031L181.505 183.989L181.463 183.904H181.337L181.294 183.989L181.252 184.031H181.126L181.085 184.073V184.157L181.043 184.199H180.999L180.958 184.242V184.284L180.916 184.326L180.874 184.284H180.832L180.747 184.368L180.705 184.41H180.579L180.495 184.493V184.452L180.452 184.41L180.41 184.452L180.368 184.493H180.41H180.368V184.537V184.62L180.41 184.662L180.452 184.704L180.537 184.62H180.579V184.704H180.663H180.579H180.495L180.452 184.746H180.41H180.368L180.327 184.873V184.915H180.368L180.285 184.999V185.084L180.243 185.042V184.915H180.158L180.116 184.957L180.158 184.873H180.116L180.074 184.915L179.99 184.957L180.116 184.999L180.074 185.042H180.116V185.084L180.074 185.126V185.084H180.032V185.042L179.948 184.999L179.905 185.042L179.948 184.957H179.863V184.915L179.779 184.957L179.737 184.915H179.695V184.957V184.999L179.779 185.042L179.737 185.126H179.779V185.21H179.737H179.695H179.652H179.61V185.168V185.126L179.568 185.084L179.443 185.126L179.358 185.21V185.252L179.443 185.293V185.252V185.293V185.379H179.485H179.443L179.485 185.42V185.462H179.443H179.316L179.274 185.546H179.19H179.232L179.19 185.504L179.148 185.588V185.504H179.063H179.021L179.063 185.462L179.021 185.42H178.979H178.937L178.81 185.462L178.685 185.546L178.558 185.715V185.757L178.474 185.799L178.432 185.757L178.348 185.799H178.306V185.757H178.263L178.179 185.799L178.096 185.926V186.137L178.138 186.262L178.179 186.388H178.221H178.306V186.473L178.221 186.557L178.306 186.726V186.851V186.935L178.263 186.893V186.935V186.978L178.179 187.02L178.096 187.062L178.054 187.02L178.012 187.062V187.02L177.885 186.978L177.801 187.062H177.759L177.716 187.104H177.674V187.146H177.59V187.062H177.465V186.978L177.421 186.935H177.338V186.851L177.296 186.809H177.127L177.085 186.851L176.959 186.893H176.917L176.874 186.851L176.917 186.768H176.832H176.79V186.726H176.707L176.665 186.768V186.726H176.621H176.538L176.496 186.768L176.454 186.682H176.412H176.37H176.327H176.243H176.074V186.641H176.032L175.823 186.682V186.641L175.738 186.599H175.527L175.19 186.641L174.728 186.768L174.643 186.809L174.601 186.893L174.518 186.851L174.391 186.935L174.349 186.978V187.02L174.307 187.062H174.265L174.307 187.02L174.265 186.978L174.223 186.935L174.096 186.978L173.843 187.104L173.76 187.146V187.231H173.718L173.676 187.273L173.801 187.231L173.76 187.273L173.718 187.357V187.441L173.634 187.482V187.526H173.676L173.634 187.568H173.591L173.465 187.651V187.735L173.507 187.777L173.549 187.735V187.777H173.591L173.549 187.82L173.507 187.862L173.423 187.904V187.988V188.073H173.465H173.381L173.338 188.115V188.157L173.296 188.115L173.338 188.073H173.254H173.043L172.96 188.157L172.918 188.199L172.96 188.24H172.918H172.876L172.834 188.282V188.367L172.792 188.451V188.409L172.834 188.326L172.792 188.282L172.749 188.24L172.707 188.282L172.665 188.326V188.282H172.623H172.581V188.157L172.665 188.115L172.623 188.03L172.581 187.988L172.454 187.946H172.37H172.287V187.988V188.03L172.243 187.946H172.202L172.16 187.988H172.202L172.243 188.073V188.115H172.16V188.157V188.199L172.202 188.24H172.16V188.282L172.118 188.367H172.076L172.118 188.282L171.992 188.24L171.739 188.282L171.487 188.409L170.812 188.704L170.181 189.082L169.676 189.335L169.592 189.419L169.465 189.462L169.045 189.757L168.75 189.924L168.371 190.262V190.304V190.429L168.329 190.471L168.245 190.556L168.287 190.598L168.329 190.64V190.682H168.371L168.329 190.724L168.371 190.766H168.329V190.809L168.287 190.766L168.245 190.809V190.851H168.203L168.076 190.893L167.909 190.977L167.824 191.06L167.529 191.271L167.276 191.44L167.234 191.482V191.566L167.151 191.608L166.982 191.735V191.777L166.814 191.819L165.93 192.366H165.887V192.408L165.678 192.535L165.635 192.618L165.34 192.702L165.087 192.871L164.54 193.208L164.331 193.376L163.573 193.966L163.151 194.387L162.942 194.639L162.9 194.766L162.856 194.891H162.731V194.934L162.773 195.06L162.815 195.102V195.144V195.229L162.731 195.313L162.689 195.482V195.524H162.731V195.565V195.607V195.565H162.689H162.647L162.52 195.649L162.351 195.818L162.015 196.071L161.594 196.533H161.552V196.449L161.636 196.365L162.015 196.029L161.973 195.986L162.015 195.944H161.973H161.931L161.889 195.986L161.805 195.944V195.986V196.029V196.071H161.72L161.678 196.113L161.636 196.071L161.552 196.113L161.467 196.155L161.257 195.986L161.215 195.944L161.173 195.86H161.089L161.005 195.818L160.962 195.733L161.089 195.691L161.131 195.607V195.524H161.173L161.215 195.482L161.131 195.438L161.047 195.397V195.355L160.962 195.271V195.229L160.878 195.102V195.06L160.836 195.018L160.878 194.934L160.836 194.807L160.878 194.766V194.724H160.836L160.753 194.682V194.639L160.794 194.597H160.753V194.555L160.711 194.513L160.667 194.471L160.626 194.387L160.584 194.429V194.471V194.513H160.542H160.5V194.555V194.597L160.458 194.639V194.682V194.766H160.415L160.373 194.682H160.331V194.724L160.247 194.807L160.205 194.891L160.12 194.976V194.891H160.162V194.766H160.12L160.078 194.807V194.766H159.994V194.724V194.682L159.867 194.555H159.826V194.513L159.742 194.471L159.616 194.429L159.573 194.471H159.489L159.236 194.639L159.195 194.807V194.891H159.111L159.068 194.934L158.984 195.06L158.942 195.102L158.9 195.186H158.858L158.773 195.102L158.731 195.06L158.689 195.018V194.934L158.647 194.891V194.849H158.564V194.766L158.522 194.724V194.682H158.478V194.639V194.597V194.555V194.513H158.522V194.471L158.605 194.429L158.647 194.344V194.302V194.26L158.689 194.218L158.647 194.176L158.689 194.135L158.647 194.091V194.049V194.008V193.924V193.882H158.689V193.924L158.731 193.84H158.689L158.731 193.797L158.773 193.755V193.713V193.671H158.647L158.689 193.629L158.647 193.544L158.689 193.46L158.731 193.418V193.376V193.293L158.858 193.208L158.9 193.166L158.984 193.124V193.04H159.026V192.955L159.068 192.913V192.871L159.026 192.829V192.871H158.942H158.9V192.829L158.858 192.787H158.816V192.745H158.773V192.702H158.689L158.647 192.618V192.577L158.605 192.535L158.564 192.45L158.522 192.493L158.478 192.45L158.437 192.408L158.395 192.45L158.353 192.408L158.269 192.493H158.184V192.535L158.1 192.577L158.058 192.66L157.974 192.618H158.016L157.974 192.577L158.016 192.535H157.974L158.016 192.493L157.974 192.45L157.889 192.408V192.45V192.493V192.577L157.847 192.535L157.805 192.493L157.637 192.535L157.553 192.577H157.511V192.493H157.469L157.427 192.577L157.342 192.618L157.3 192.493L157.216 192.45H157.131L157.089 192.366L157.047 192.324L156.964 192.408L156.88 192.324L156.837 192.366L156.922 192.45H156.88L156.795 192.408L156.584 192.45H156.542V192.493H156.5L156.458 192.45H156.416H156.333L156.248 192.535L156.206 192.45H156.122V192.408H156.038V192.324H155.995L155.911 192.366L155.953 192.24H155.995V192.198H155.953L155.869 192.24L155.785 192.198H155.742L155.7 192.24L155.742 192.282L155.785 192.24L155.742 192.282V192.324V192.366L155.7 192.408L155.658 192.493H155.616L155.575 192.535H155.533L155.489 192.45H155.448V192.493H155.364V192.45H155.322L155.28 192.535L155.195 192.493L155.153 192.45H154.985H154.944H154.9H154.817L154.775 192.493V192.535H154.691V192.618H154.522H154.48L154.396 192.577H154.353H154.269L154.144 192.45H154.1V192.408H154.059L154.1 192.324V192.282H154.059V192.24H154.017L154.059 192.113L154.017 192.071V192.029L154.059 191.987L154.1 191.946L154.017 191.904H154.059V191.86L154.017 191.777V191.735V191.693H154.059L154.1 191.651L154.144 191.693L154.186 191.608L154.227 191.566L154.186 191.524V191.44L154.144 191.355H154.186L154.311 191.313V191.229L154.353 191.187L154.396 191.146H154.438V191.104V191.06H154.396L154.438 190.977L154.396 190.935L154.48 190.851L154.522 190.766V190.724H154.48L154.438 190.809L154.396 190.766V190.724L154.48 190.598L154.564 190.471H154.606L154.733 190.346L154.691 190.304H154.606L154.564 190.262H154.438V190.177H154.396L154.311 190.093H154.269L154.227 190.135L154.186 190.093V190.051V190.009L154.144 189.966L154.1 189.924L154.144 189.84L154.1 189.798H154.059L154.1 189.757L154.059 189.715H153.975V189.671L153.806 189.546L153.764 189.504L153.849 189.462V189.377V189.251V189.167L153.933 189.124L153.891 189.082V189.04H153.849L153.722 188.957V188.915L153.68 188.871L153.638 188.915L153.596 188.871L153.553 188.915V188.871L153.427 188.83L153.469 188.788H153.427L153.469 188.746L153.344 188.704H153.302V188.662L153.259 188.62L153.302 188.577H153.259V188.535L153.175 188.493L153.133 188.451L153.091 188.409V188.326H153.049V188.282H153.006H152.964H152.922L152.964 188.24H152.922H152.964L153.006 188.199H152.964V188.157L152.922 188.115H152.88V188.073L152.922 188.03V187.988L152.838 187.946H152.796V187.904H152.88V187.862H152.838V187.82L152.796 187.777L152.755 187.82L152.711 187.735H152.796H152.838L152.796 187.693V187.651H152.755V187.609L152.669 187.651V187.693L152.586 187.651H152.544V187.609L152.502 187.568L152.459 187.526L152.417 187.482V187.357L152.333 187.441L152.291 187.357L152.249 187.315V187.231L152.207 187.188H152.249L152.291 187.146L152.207 187.104H152.249L152.333 187.146L152.291 187.104V187.062H152.333L152.417 187.02L152.502 186.978V186.935V186.893V186.809L152.459 186.726V186.682L152.502 186.641L152.417 186.599L152.459 186.557V186.515V186.473V186.431L152.544 186.473H152.586L152.544 186.388V186.346L152.586 186.262L152.544 186.22V186.178H152.502V186.137H152.459L152.417 186.093H152.375V186.051V186.01H152.333V185.968L152.249 185.926V185.884L152.164 185.841L152.207 185.799V185.757H152.164V185.715V185.673L152.122 185.631L152.164 185.546L152.249 185.462V185.42L152.207 185.379L152.249 185.293L152.207 185.21L152.249 185.168L152.122 185.084L152.08 185.042L152.122 184.999H152.164L152.122 184.915L152.164 184.873V184.789L152.249 184.831V184.789V184.746V184.662V184.62L152.291 184.579L152.333 184.537H152.375L152.417 184.579H152.459L152.417 184.537L152.459 184.493H152.375V184.41H152.333L152.291 184.368H152.249V184.326V184.284H152.207H152.164H152.122V184.242L152.249 184.199L152.291 184.242L152.333 184.199L152.291 184.157V184.115L152.164 184.031H152.038V183.989V183.904L152.08 183.948L152.122 183.862V183.779L152.08 183.695V183.568L151.997 183.4L151.955 183.357L151.997 183.273H151.955L151.911 183.231V183.19V183.104L151.786 182.895L151.744 182.853L151.786 182.81H151.66L151.617 182.768V182.726L151.575 182.768L151.533 182.684L151.449 182.642L151.407 182.6L151.491 182.473L151.449 182.431L151.407 182.39H151.322L151.238 182.431L151.155 182.39H151.07L151.028 182.348H150.986L150.944 182.306V182.263H150.902L150.86 182.221L150.818 182.179L150.691 182.221H150.607L150.566 182.179L150.522 182.137L150.48 182.179L150.397 182.095H150.313V181.968V181.926L150.355 181.842V181.8H150.397V181.759L150.27 181.673L150.186 181.632H150.06L149.933 181.506V181.463L149.975 181.421L150.018 181.295L149.975 181.211V181.168L149.849 181.084L149.808 181.126V181.168L149.849 181.253L149.808 181.295H149.766H149.724L149.681 181.168H149.597L149.471 181.126V181.168L149.344 181.295L149.26 181.253H149.175L149.091 181.379H149.049H148.966L148.839 181.337L148.755 181.421L148.629 181.463H148.502L148.418 181.421L148.333 181.463H148.291V181.421L148.25 181.379L148.081 181.295L147.997 181.337H147.913L147.871 181.421H147.786H147.66L147.619 181.337L147.535 181.253V181.211L147.408 181.126L147.324 181.168H147.239L147.197 181.211V181.337H147.155L147.113 181.421L146.986 181.379L146.902 181.421L146.777 181.337H146.735L146.65 181.421L146.566 181.379L146.524 181.337L146.482 181.253L146.44 181.211L146.355 181.168L146.188 181.126L146.102 181.211L146.019 181.253L145.935 181.211L145.808 181.168L145.766 181.084H145.682H145.64L145.597 181.126L145.555 181.168L145.388 181.463L145.261 181.506H145.219H145.177L145.135 181.463L145.093 181.421H144.966H144.84L144.798 181.379L144.84 181.126V181.084V181.042L144.713 181.001L144.671 180.874L144.63 180.832L144.546 180.664L144.293 180.495L144.251 180.453H144.082H144.04L143.957 180.495H143.913L143.83 180.368H143.704L143.619 180.411H143.535L143.199 180.242H142.862L142.609 180.159L142.482 180.074L142.399 180.032L142.272 179.99H142.23L142.104 179.906L142.062 179.737H142.019L141.935 179.653L141.851 179.611L141.724 179.653H141.683L141.515 179.611H141.43L141.262 179.57L141.177 179.611H141.093L140.925 179.526H140.799L140.673 179.695H140.63L140.462 179.779H140.377L140.335 179.737L140.168 179.779L140.126 179.822L140.041 179.779L139.915 179.737L139.746 179.611L139.662 179.57H139.452H139.368L139.241 179.653H139.115L139.073 179.57L139.031 179.401V179.359H138.946L138.904 179.317H138.863L138.779 179.275L138.315 179.401H138.273L138.146 179.359L138.063 179.275L138.021 179.232L137.979 179.19L137.726 178.979H137.599L137.39 178.853L137.221 178.812H137.179H137.01L136.799 178.685L136.715 178.643H136.674L136.59 178.685L136.548 178.728L136.463 178.853L136.421 178.979V179.022L136.379 179.19V179.232L136.421 179.484L136.252 179.526L136.168 179.57L135.999 179.653H135.957V179.611V179.443L135.874 179.317L135.832 179.275L135.663 179.317L135.579 179.359L135.495 179.443L135.368 179.401H135.074L134.863 179.317L134.779 179.275H134.737L134.695 179.232H134.61V179.275H134.526L134.316 179.401H134.274L134.148 179.317L134.063 179.275H134.021L133.853 179.106L133.768 178.979H133.726L133.643 179.022L133.264 179.275L133.012 179.359H132.885L132.717 179.275L132.548 179.232L132.506 179.19H132.464H132.337L132.127 179.275L132.043 179.232L131.748 179.022L131.623 178.979L131.328 179.022L131.285 179.064L131.201 179.106L131.117 179.148V179.19L131.032 179.232L130.948 179.317L130.865 179.401L130.696 179.443L130.612 179.57L130.57 179.443L130.528 179.317ZM174.432 187.062V187.02V187.062ZM179.443 185.168H179.485H179.443ZM181.379 184.031V183.989V184.031ZM178.854 185.504V185.462V185.504ZM178.937 187.651V187.609V187.651ZM181.337 184.452H181.379V184.493H181.337V184.452ZM178.769 187.651V187.609V187.651ZM179.063 187.231H179.021V187.273H178.979V187.315L179.106 187.357L179.063 187.399L179.106 187.441H179.148L179.232 187.526L179.274 187.441L179.316 187.482H179.358L179.401 187.526L179.358 187.568L179.316 187.526V187.568V187.651V187.693V187.735V187.777H179.358L179.316 187.82V187.862L179.232 187.946L179.106 187.904L179.021 187.777L179.063 187.693L178.979 187.568L178.896 187.609V187.568L178.854 187.609H178.81L178.769 187.568L178.727 187.609H178.685V187.651L178.601 187.609L178.558 187.693L178.306 187.735H178.263L178.138 187.777L178.012 187.735L177.927 187.609V187.441V187.399H177.969L178.054 187.315H178.096V187.273L178.179 187.231H178.221L178.179 187.188H178.221L178.432 186.978L178.516 186.935V186.768H178.558V186.726L178.601 186.682V186.641V186.599L178.643 186.473V186.388L178.727 186.346L178.81 186.388L178.854 186.431H178.979V186.473H179.063L179.106 186.515H179.148L179.19 186.557V186.599L179.232 186.641H179.274L179.316 186.726H179.358L179.316 186.768V186.851L179.274 186.935H179.316V186.978L179.232 187.02L179.274 187.062H179.316L179.274 187.104H179.316H179.358L179.316 187.146L179.19 187.104H179.106L179.021 187.188H179.063V187.231ZM180.579 185.252H180.621H180.579ZM179.358 186.978V186.935L179.401 186.978H179.358ZM168.498 190.513H168.54H168.498ZM181.126 184.242H181.085V184.199H181.126V184.242ZM176.327 186.809H176.37H176.327ZM177.506 187.231V187.188H177.548V187.146V187.188V187.231H177.506ZM168.918 190.556H168.961V190.598H168.918V190.556ZM168.961 190.682V190.64H169.003V190.682H168.961ZM176.285 186.893V186.851H176.327V186.893H176.285ZM178.937 185.588L178.979 185.546H179.021V185.588H178.937ZM175.907 187.273V187.231H175.949H175.99L175.949 187.273V187.315H175.907V187.273ZM179.779 185.379L179.821 185.337L179.863 185.379V185.42L179.821 185.379L179.779 185.42V185.379ZM179.779 186.893L179.863 186.851L179.905 186.809V186.851L180.074 186.935L180.032 186.978L179.948 186.935L179.863 187.02L179.821 186.935L179.779 186.893ZM180.41 185.168V185.126L180.537 185.168V185.21L180.41 185.252L180.285 185.379V185.293V185.252L180.243 185.21L180.285 185.168V185.126V185.168L180.327 185.21H180.368L180.41 185.168Z"
							stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="RJ" @mouseenter="e => hoverES(e, 'RJ')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M181.505 183.061L181.547 183.019V182.977V182.935L181.632 182.893H181.674V182.851H181.716L181.757 182.808H181.841L181.884 182.766L181.841 182.683L181.926 182.641L181.884 182.599L181.968 182.556L181.926 182.514L181.968 182.472H181.926L181.968 182.388H181.926V182.346H181.884L181.926 182.304V182.261V182.219V182.177L181.968 182.135V182.093L182.01 182.052V181.966L182.052 181.925V181.883H182.01L182.052 181.799L182.01 181.757L182.052 181.714V181.672V181.63H182.094H182.136H182.221H182.263H182.305V181.588L182.347 181.546L182.305 181.504L182.389 181.419L182.515 181.335L182.557 181.294L182.599 181.335H182.641H182.684H182.726L182.81 181.21L182.894 181.294L183.021 181.21V181.167L183.063 181.125L183.23 181.041H183.274L183.399 180.957L183.526 181.041L183.61 180.999L183.694 180.914L183.779 180.872L183.863 180.788H183.905H183.988L184.03 180.83L183.988 180.914H184.03V180.957H184.073V180.999L184.199 180.957H184.241L184.283 180.914L184.325 180.83L184.368 180.788H184.41H184.494V180.83H184.536H184.578H184.663L184.957 180.704L184.999 180.746L184.957 180.788H184.999V180.746L185.125 180.662H185.21V180.704L185.294 180.662L185.377 180.494H185.463V180.452V180.41H185.377L185.419 180.367L185.377 180.325V180.283L185.419 180.199H185.504L185.463 180.157L185.588 180.03H185.715L185.757 179.988H185.715V179.946H185.757L185.841 179.904L185.883 179.863V179.777H185.925L185.968 179.736V179.694V179.652L185.883 179.568L185.799 179.483L185.841 179.441L185.799 179.399H185.757L185.715 179.357V179.273H185.672L185.63 179.315L185.588 179.23H185.546H185.463L185.419 179.273L185.294 179.188L185.21 179.23V179.273L185.168 179.188H185.125H185.083L185.041 179.146L184.999 179.188L184.957 179.105L184.873 179.146L184.83 179.105V179.146V179.188L184.788 179.146V179.188L184.83 179.273H184.788H184.746V179.146H184.704L184.746 179.063H184.704H184.663L184.578 179.021H184.536V179.063L184.452 179.105V179.146L184.494 179.188V179.23H184.452L184.41 179.188H184.325L184.241 179.23L184.199 179.273H184.157L184.115 179.315L184.03 179.273L183.988 179.23H183.946L183.988 179.273L183.863 179.441H183.821L183.779 179.399H183.694H183.652L183.694 179.441H183.652V179.399L183.736 179.315H183.694H183.652L183.568 179.23L183.483 179.273L183.441 179.188L183.357 179.357H183.315L183.274 179.273L183.23 179.23V179.273L183.188 179.315L183.105 179.23L183.063 179.273L183.021 179.23H182.979V179.105V179.063L183.021 178.936L182.979 178.894L182.936 178.936L182.894 178.894L182.768 178.936V178.852L182.81 178.81L182.768 178.726L182.726 178.683H182.684L182.641 178.641H182.557V178.557V178.515H182.515L182.474 178.473L182.515 178.388V178.346L182.474 178.179L182.389 178.094L182.305 178.01H182.221L182.136 177.968H181.968L182.01 177.883L182.052 177.841H182.094L182.136 177.799H182.179L182.263 177.757H182.347L182.432 177.674H182.474L182.599 177.757L182.684 177.715L182.768 177.757H182.852L182.894 177.799V177.757L182.979 177.674V177.632L183.105 177.588V177.505L183.147 177.463L183.274 177.421H183.315L183.357 177.463L183.441 177.421L183.483 177.463L183.61 177.421V177.463H183.694V177.421L183.779 177.379V177.336L183.905 177.294L184.073 177.126L184.115 177.168V177.126V177.084L184.157 176.999H184.199H184.241L184.283 176.957L184.368 176.999H184.41H184.536V177.084H184.578H184.621L184.663 177.041L184.746 176.957L184.788 176.999H184.873H184.957L184.999 177.041L185.041 176.999H185.125L185.168 176.916V176.957L185.21 176.916H185.252H185.294L185.336 176.957V176.916L185.377 177.084L185.419 177.041L185.463 177.084L185.504 177.041L185.588 176.999V176.957L185.672 176.916V176.957H185.715L185.799 176.916L185.841 176.832H185.883H185.925H185.968L186.01 176.789L186.052 176.705L186.094 176.747L186.135 176.705H186.177H186.219V176.621V176.579V176.537L186.262 176.579L186.346 176.537V176.494V176.452L186.43 176.494V176.537L186.472 176.494H186.514V176.41H186.557L186.725 176.368V176.326H186.852L186.935 176.41L186.977 176.368H187.019L187.061 176.326H187.104V176.284L187.23 176.243H187.272L187.357 176.199L187.608 176.116L187.652 176.074H187.735V175.99L187.777 176.032V175.99H187.819L187.861 175.947L187.946 175.99L188.03 175.947L188.114 175.905H188.156H188.199L188.366 175.779H188.408H188.451V175.821L188.493 175.863H188.451L188.535 175.905V175.947H188.577L188.619 175.99L188.703 175.863H188.788H188.83L188.872 175.821H188.956L188.999 175.905V175.947L189.041 175.905V175.821H189.124V175.779H189.166H189.208L189.293 175.863L189.335 175.821V175.905H189.377V175.863V175.821H189.419L189.461 175.737H189.503L189.546 175.694V175.821L189.63 175.863L189.672 175.905L189.714 175.863L189.924 175.821L189.966 175.737H190.008L190.05 175.779V175.821H190.135H190.219H190.303L190.472 175.737L190.513 175.694H190.597L190.766 175.568L190.892 175.485V175.443L190.977 175.399H191.019L191.061 175.443H191.145L191.186 175.399L191.23 175.443L191.313 175.485L191.439 175.443H191.524L191.566 175.399L191.608 175.443L191.65 175.399L191.692 175.443V175.485L191.734 175.526H191.777L191.819 175.568H191.861L191.903 175.526V175.568L191.944 175.61L192.113 175.485H192.155V175.526L192.239 175.568H192.281H192.366V175.652V175.737L192.239 175.821V175.863L192.281 175.99L192.324 176.074L192.408 176.032V175.947L192.534 175.905H192.619H192.702V175.947L192.871 175.905L192.955 175.779L192.997 175.737L192.955 175.694V175.652L193.039 175.61L193.166 175.568H193.208L193.375 175.443H193.419L193.502 175.399L193.755 175.316L193.923 175.148V175.105L194.133 175.021L194.47 174.937L194.639 174.852L194.681 174.81L194.933 174.685L195.186 174.6L195.228 174.558L195.355 174.516L195.523 174.474L195.608 174.432H195.649H195.691L195.775 174.39V174.305L196.07 174.179L196.491 174.01L196.533 173.968L196.955 173.843L196.997 173.758H197.039L197.164 173.716H197.291L197.459 173.674V173.632L197.712 173.548V173.505V173.463V173.421V173.337L197.67 173.296L197.628 173.337L197.586 173.254H197.628L197.586 173.21L197.501 173.169H197.459H197.417H197.375L197.333 173.21H197.291L197.249 173.169V173.085H197.164H197.122L197.08 173.043L197.164 172.959H197.122L197.08 172.916L197.206 172.748L197.249 172.706L197.375 172.621L197.333 172.579V172.537L197.459 172.496V172.454L197.501 172.411V172.369L197.544 172.327H197.628L197.67 172.201L197.753 172.159L197.797 172.116L197.712 171.99V171.948L197.586 171.906L197.628 171.821V171.779V171.738L197.67 171.696V171.569L197.712 171.527L197.753 171.569H197.839L197.88 171.527L197.922 171.485L197.839 171.443H197.797L197.88 171.401V171.359L197.964 171.317L197.922 171.232L197.964 171.19L197.922 171.148L198.006 171.107L197.964 171.065H197.922V171.021L197.964 170.938V170.77L198.006 170.727L198.049 170.685L198.133 170.643L198.175 170.601L198.217 170.559L198.175 170.517L198.217 170.432L198.175 170.39V170.432L198.133 170.39V170.307L198.175 170.265L198.091 170.096H198.133V170.054L198.175 170.012V169.97L198.217 169.927L198.259 169.885L198.301 169.801H198.344V169.717V169.632H198.511V169.59L198.553 169.549V169.465H198.638V169.423L198.764 169.296V169.254V169.212V169.17L198.806 169.212H198.891V169.17L198.848 169.128L198.764 169.043H198.722H198.68L198.638 169.001H198.595L198.511 168.918V168.876L198.428 168.832V168.791L198.511 168.707L198.595 168.665L198.638 168.707H198.68V168.665L198.722 168.623L198.806 168.538L198.848 168.581H198.975L199.101 168.538L199.142 168.496H199.228L199.353 168.538L199.395 168.496L199.522 168.538V168.454L199.564 168.412V168.454L199.606 168.37L199.564 168.328L199.606 168.285V168.201L199.69 168.159L199.648 168.118L199.69 168.076L199.775 168.034L199.817 167.991L199.859 167.949L199.775 167.865L199.859 167.696L199.817 167.654H199.901H199.942H199.986L200.028 167.612H200.111L200.153 167.57L200.111 167.528L200.153 167.487H200.195L200.28 167.443L200.322 167.528L200.406 167.57L200.448 167.612V167.654L200.533 167.696L200.575 167.654L200.533 167.739H200.617L200.659 167.696H200.784H200.827V167.739H200.911V167.823L200.953 167.781L200.995 167.823V167.865V167.907L200.953 168.034L200.995 168.118V168.159L201.08 168.118L201.164 168.159H201.122L201.08 168.285V168.328H201.122L201.08 168.454L201.037 168.496H200.995L201.037 168.623L201.122 168.665V168.832H201.164V168.918H201.122V169.001L201.08 169.043L201.164 169.085L201.122 169.128H201.08V169.17L201.122 169.254V169.338H201.08V169.296H201.037V169.38H201.08V169.423H201.122L201.037 169.59V169.632H201.08H201.122H201.206V169.676L201.122 169.717V169.759H201.206V169.717H201.29L201.331 169.759H201.375V169.801L201.417 169.759H201.458V169.801L201.542 169.843V169.885H201.584H201.627H201.669L201.795 169.97L201.922 169.927L201.964 170.012L202.048 170.054V170.096L202.09 170.138L202.131 170.054L202.175 170.138L202.3 170.096L202.384 170.18V170.096H202.426L202.469 170.138H202.553H202.595V170.223L202.679 170.265L202.764 170.307L202.806 170.348H202.889L202.973 170.265H203.016V170.223L203.058 170.265L203.1 170.223L203.142 170.265H203.184H203.226V170.223L203.268 170.265H203.311L203.479 170.307H203.52L203.564 170.348H203.606V170.39L203.647 170.348L203.731 170.474H203.773H203.815L203.858 170.517V170.474H203.9H203.942L203.984 170.39H204.068H204.111H204.153V170.432H204.195V170.474H204.279L204.32 170.517H204.362H204.406V170.559V170.517H204.447V170.474V170.517L204.489 170.474L204.447 170.517H204.489H204.573H204.615L204.7 170.474L204.742 170.432H204.826L204.953 170.39L204.995 170.348L205.037 170.39H205.078L205.12 170.432H205.162L205.247 170.474L205.331 170.601L205.415 170.559H205.5H205.542L205.584 170.685V170.77L205.626 170.812H205.668L205.709 170.77V170.812H205.753V170.854H205.795V170.896H205.836V170.98L205.795 171.148L205.836 171.274H205.795L205.709 171.485H205.668L205.584 171.527L205.542 171.654L205.415 171.821L205.331 171.906L205.289 171.948L205.162 172.074L205.12 172.243V172.454L205.247 172.706L205.289 172.79L205.373 172.832H205.457L205.5 172.874V172.832V172.874L205.415 173.337V173.59L205.542 174.054L205.709 174.81L205.753 175.021V175.19L205.668 175.358L205.626 175.443L205.542 175.485L205.289 175.61L205.078 175.737L204.784 175.947L204.615 176.074L204.32 176.199L204.068 176.284L203.773 176.41L202.931 176.621L202.595 176.705L202.258 176.832L202.006 176.957L201.837 176.999L201.711 177.084L201.29 177.294L200.995 177.547H200.911L200.827 177.632L200.784 177.674V177.757H200.827L200.784 177.799L200.827 177.841L200.7 177.926H200.659L200.49 178.01L200.364 178.136L200.28 178.221V178.305L200.237 178.43H200.195L200.153 178.473H200.069L199.986 178.515L199.901 178.683L199.859 178.726L199.817 178.81H199.775L199.733 178.726L199.648 178.768L199.564 178.852L199.522 178.936L199.438 179.188L199.395 179.273V179.525V179.568V179.61L199.48 179.946L199.522 180.03H199.648V180.072L199.733 180.199L199.817 180.283H199.901L199.942 180.241L199.901 180.199H199.986V180.157L200.069 180.199L200.111 180.157V180.072L200.153 180.115V180.072L200.195 180.115L200.153 180.157L200.237 180.199L200.195 180.241H200.153L200.111 180.325V180.283H200.069L200.111 180.367L200.069 180.325L200.028 180.367H199.986L199.942 180.325L199.859 180.367L199.817 180.452V180.494V180.535V180.577L199.733 180.535V180.577L199.564 180.619L199.48 180.788V180.872V180.914L199.522 180.872L199.48 180.914V180.957L199.438 180.999H199.395L199.353 181.041V180.999H199.311L199.228 181.083L199.186 181.125L199.142 181.252V181.335L199.186 181.419H199.228V181.461L199.269 181.504L199.311 181.461L199.353 181.419V181.461L199.311 181.504H199.353H199.395L199.353 181.546L199.311 181.504L199.269 181.546H199.311L199.269 181.588V181.63H199.311V181.672V181.757L199.269 181.672L199.142 181.63L199.186 181.588L199.101 181.546L198.891 181.461L197.586 181.377L197.122 181.335H196.744H196.406L196.322 181.377L196.197 181.335H195.733H195.439L195.186 181.377L195.144 181.419V181.504H195.102H195.06L194.933 181.461L194.344 181.504L193.966 181.546L193.671 181.588L193.46 181.546H193.208L193.124 181.588H193.081H193.039L192.997 181.63L192.955 181.588H192.913L192.871 181.63V181.588H192.913L192.828 181.504L192.661 181.461H192.492L192.45 181.419V181.377H192.324L192.408 181.335V181.252L192.45 181.294H192.492L192.45 181.335H192.492H192.534L192.577 181.294V181.21H192.492L192.45 181.167H192.408L192.366 181.21L192.324 181.125L192.408 181.083V181.041L192.324 180.999L192.366 180.957H192.408L192.45 180.999L192.492 180.914L192.534 180.83L192.619 180.746L192.577 180.704V180.662L192.661 180.577L192.786 180.494L192.702 180.452L192.661 180.41L192.744 180.325V180.283L192.786 180.241L192.997 180.115V180.03V179.988L192.955 179.946V179.904L192.997 179.863L192.955 179.821L192.997 179.777H192.955H192.913V179.736L192.871 179.777L192.828 179.736H192.786L192.661 179.694L192.619 179.736H192.534H192.492L192.534 179.821L192.492 179.777L192.45 179.821V179.863L192.408 179.904L192.366 179.946L192.281 179.904L192.239 179.863L192.155 179.904V179.946H192.071L191.861 179.988V180.03L191.819 180.072H191.777H191.734L191.692 180.115H191.65L191.692 180.157L191.608 180.199H191.566H191.608L191.482 180.283V180.325L191.439 180.367H191.482L191.397 180.494V180.535L191.439 180.577L191.482 180.535V180.577L191.524 180.619L191.608 180.704L191.65 180.746L191.692 180.872L191.734 180.83L191.692 180.704L191.65 180.662V180.619H191.566L191.524 180.535L191.566 180.494L191.608 180.535H191.65V180.494L191.734 180.41L191.777 180.367H191.819L191.903 180.452H191.986H192.03L191.986 180.41L192.03 180.367H192.071L192.113 180.325V180.367L192.155 180.325H192.197V180.367L192.155 180.41L192.071 180.494V180.535L192.113 180.619H192.155L192.113 180.662L192.071 180.619L192.03 180.704L191.986 180.619H191.903L191.861 180.577L191.777 180.619L191.692 180.704L191.734 180.746L191.777 180.704V180.746L191.819 180.788L191.777 180.746H191.734V180.788L191.777 180.83H191.903L191.819 180.872L191.861 180.914H191.819H191.734L191.777 180.957H191.819L191.903 180.914L191.944 180.957L191.861 181.041L191.903 181.083L191.986 181.041H192.071V181.083V181.041V181.083H192.113H192.155H192.113H192.071L192.113 181.125H192.197V181.21H192.113V181.252V181.21L192.155 181.252L192.113 181.335L192.155 181.377H192.113H192.071V181.419L192.113 181.461L192.155 181.377H192.239H192.197L192.239 181.419L192.155 181.461H192.197V181.504H192.155L192.03 181.588V181.63L192.071 181.672H192.03H191.986H191.819L191.65 181.757H191.482L191.397 181.799V181.841H191.355L191.313 181.799L191.271 181.757L191.186 181.714V181.672H191.103L191.061 181.63L190.935 181.588H190.85H190.808L190.724 181.63L190.682 181.588L190.639 181.63L190.682 181.672L190.639 181.63L190.597 181.672H190.639V181.714L190.766 181.672V181.714L190.808 181.672L190.766 181.63H190.808H190.977L191.061 181.672H190.977H191.019V181.714L190.977 181.672L190.935 181.714H191.103H191.186V181.757H191.23L191.271 181.799L191.355 181.841H191.271H190.977L190.43 181.883L190.303 181.925L190.261 181.966V182.008V181.966H190.135L190.05 182.008L190.008 182.052L189.841 182.093L189.755 182.135V182.219V182.261V182.219H189.672H189.63H189.672V182.177L189.588 182.135L189.503 182.093H189.041L188.366 182.135L187.861 182.219L187.272 182.304L187.061 182.388H187.019H186.977L186.935 182.346V182.261H186.893L186.935 182.219H186.977L187.019 182.177V182.135H187.061L187.146 182.052L187.272 182.008L187.314 182.052L187.399 182.135H187.483L187.608 182.177H187.693L187.735 182.135V182.052V182.008L187.652 181.966L187.566 181.925L187.525 181.883L187.566 181.925L187.652 181.966L187.819 182.052L188.03 182.135H188.241L188.788 182.093L189.041 182.008L189.377 181.966H189.419L189.461 182.008L189.672 182.093V182.177L189.714 182.093V182.052H189.672V182.093L189.63 182.052L189.588 182.008L189.546 181.966H189.503L189.461 181.883L189.335 181.841L189.293 181.799H189.208V181.757H189.124L189.041 181.672L188.999 181.63L188.914 181.672V181.714L188.872 181.672H188.83L188.746 181.546L188.703 181.588V181.546L188.661 181.461L188.451 181.335V181.294L188.408 181.335L188.366 181.294V181.252H188.324L188.241 181.21H188.199L188.114 181.252V181.21L188.072 181.167L188.114 181.252L188.03 181.294H187.946L187.904 181.252L187.988 181.21L188.03 181.167L187.988 181.125H187.861L187.777 181.167L187.735 181.21L187.693 181.252L187.777 181.294L187.735 181.377V181.419H187.777H187.735H187.693L187.608 181.504H187.566L187.525 181.461L187.566 181.419L187.525 181.377H187.483V181.419V181.377H187.525V181.335L187.608 181.294L187.652 181.335V181.294H187.693V181.252H187.652L187.525 181.294H187.399H187.357H187.272L187.188 181.335H187.104H187.061L187.019 181.377H186.977L186.893 181.419L186.852 181.461V181.504H186.81L186.767 181.63L186.683 181.672L186.641 181.63L186.725 181.504L186.683 181.461L186.725 181.419L186.683 181.377L186.599 181.419L186.514 181.461L186.472 181.504V181.546L186.514 181.588L186.472 181.714H186.388V181.799L186.262 181.883L186.094 181.966H186.052V182.008L186.01 181.966V182.008H185.968L186.01 181.966H185.968L185.883 182.008H185.925V182.052L185.883 182.093L185.841 182.052V182.093H185.757L185.799 182.008H185.757L185.546 182.093L185.504 182.135L185.463 182.093V182.052L185.419 182.093V182.052H185.463L185.504 181.925L185.588 181.883V181.841H185.546L185.463 181.757H185.419V181.714L185.377 181.799L185.336 181.757L185.294 181.799L185.252 181.841V181.883L185.21 181.841L185.168 181.883V181.925H185.125L185.083 181.883L185.125 181.799L185.083 181.757V181.799H184.999V181.841V181.799L184.957 181.841V181.883H184.915V181.925L184.873 181.883L184.788 181.966V181.883H184.746V181.799L184.788 181.757L184.83 181.714H184.957V181.63L184.999 181.672L185.041 181.63V181.588L185.083 181.504H185.125V181.461L185.041 181.504L184.999 181.461L184.915 181.504V181.546V181.504L184.873 181.461H184.957H184.915V181.419L184.957 181.377L184.999 181.335H184.957V181.294V181.252L184.915 181.294L184.873 181.252H184.83L184.788 181.294L184.746 181.252H184.704L184.746 181.294H184.704L184.746 181.335H184.663L184.704 181.419V181.377L184.83 181.419L184.746 181.461L184.704 181.504H184.663V181.546H184.621V181.588L184.578 181.546L184.621 181.504L184.536 181.419L184.452 181.461L184.41 181.377V181.419H184.368V181.504L184.325 181.461V181.504H184.283V181.588L184.325 181.63H184.283V181.672L184.241 181.714H184.325V181.757H184.241L184.199 181.841L184.241 181.883H184.325L184.241 181.925L184.157 181.841L184.115 181.883V181.841V181.799H184.073V181.841L184.03 181.799H183.988L183.946 181.883L183.863 181.966L183.821 181.925H183.779H183.694L183.568 182.008H183.526L183.441 182.052H183.399V182.093L183.357 182.135L183.274 182.177L183.315 182.093V182.052H183.274L183.188 182.093V182.052V182.093V182.052H183.147L183.021 182.093V182.052H182.979L182.936 182.135L182.894 182.093V182.135L182.852 182.093L182.768 182.177V182.219H182.726V182.261L182.684 182.304L182.726 182.346H182.684L182.641 182.388V182.514L182.726 182.556V182.599V182.556L182.684 182.599H182.641V182.641V182.683H182.684L182.641 182.766H182.599V182.808L182.641 182.851L182.557 182.893V182.935H182.515H182.557H182.599L182.557 182.977H182.515V183.061L182.557 183.103L182.599 183.146L182.557 183.188H182.599L182.557 183.23H182.599H182.641H182.684V183.188H182.726L182.768 183.146H182.81L182.768 183.103H182.81V183.061L182.852 183.103V183.061H182.894L182.936 182.935H182.979V183.019H183.105V183.061H183.147L183.105 183.103V183.188H183.063H183.021V183.23H182.979H182.936H182.979V183.188L183.021 183.23V183.188H183.063V183.146H183.021V183.103L182.936 183.188V183.146L182.852 183.103L182.894 183.188L182.852 183.23L182.894 183.188H182.936L182.852 183.272H182.81L182.768 183.314V183.272L182.726 183.314H182.768L182.684 183.356H182.768L182.81 183.314V183.356H182.852L182.894 183.272H182.936H183.021H183.063L183.188 183.23L183.105 183.314L183.021 183.524L182.894 183.608V183.65L183.021 183.693L182.979 183.65V183.608H183.021L183.063 183.566L183.147 183.399L183.274 183.314V183.272L183.399 183.23L183.526 183.188V183.146V183.188L183.483 183.23L183.399 183.314V183.356L183.357 183.441L183.399 183.483L183.526 183.524L183.568 183.483V183.524L183.652 183.483L183.779 183.566H183.736H183.779L183.821 183.608H183.863V183.65L183.821 183.693L183.779 183.608H183.694H183.652L183.61 183.693L183.568 183.735L183.526 183.693L183.483 183.819V183.861L183.357 184.03L183.315 184.072H183.274L183.23 184.114V183.988H183.188H183.147V183.946H183.105L183.063 183.988V184.03V183.903L183.021 183.861L182.979 183.903L182.936 183.946H182.852L182.894 183.988L182.81 183.946L182.768 183.903V183.946V183.988H182.726L182.641 183.946L182.515 183.988V184.03V184.072V184.03H182.474L182.432 184.072L182.474 184.114L182.432 184.072L182.389 184.03H182.347L182.263 183.946L182.136 183.903H182.179L182.136 183.819V183.777L182.094 183.693V183.65L181.968 183.608V183.566L181.841 183.608L181.884 183.566L181.841 183.524V183.483L181.757 183.441L181.799 183.399L181.674 183.356H181.547V183.23H181.505L181.463 183.188L181.505 183.146V183.061ZM201.29 177.926V177.883H201.331V177.926H201.29ZM201.206 177.968L201.248 177.926L201.29 177.968H201.248L201.29 178.01H201.206V177.968ZM191.986 181.966V181.925V181.966ZM190.008 182.093H190.05H190.008ZM186.304 181.883V181.925V181.883ZM182.768 182.43V182.472H182.81H182.768V182.43ZM187.819 181.419V181.377V181.419H187.861V181.461H187.819H187.861H187.819V181.419ZM187.188 181.419V181.377H187.23L187.188 181.419ZM191.482 181.966H191.439V181.925H191.482V181.966ZM182.726 182.43V182.472V182.43ZM182.852 183.272L182.81 183.23L182.768 183.272H182.81H182.852ZM182.726 182.893H182.768H182.726ZM183.441 183.483V183.441V183.483ZM183.274 182.304H183.315H183.274V182.346V182.304ZM183.483 182.093H183.526H183.568V182.135H183.526V182.177V182.135V182.177H183.483V182.135H183.526V182.093H183.483ZM187.272 181.504H187.314H187.272ZM183.063 182.135H183.105H183.147H183.105V182.177H183.063V182.219V182.177V182.135ZM189.672 182.261H189.714H189.672ZM186.135 182.008V182.052V182.008V182.052V182.008ZM191.271 182.008V181.966H191.313V182.008H191.271ZM187.272 181.925V181.883V181.925ZM191.903 181.925H191.944H191.903ZM183.441 184.03V183.988H183.483H183.441V184.03ZM182.852 182.808V182.766H182.894H182.852V182.808ZM187.314 181.883V181.925V181.883ZM187.525 181.714V181.672H187.566V181.714H187.525ZM191.903 182.008H191.944V181.966V182.008H191.903ZM182.894 182.935V182.893V182.935V182.977V182.935ZM183.357 183.019H183.399V183.061H183.357V183.103L183.274 183.146L183.23 183.188H183.147L183.23 183.146L183.315 183.061H183.357V183.019ZM183.188 182.177V182.135H183.23V182.093H183.274L183.23 182.135V182.177H183.188ZM190.008 182.177V182.135V182.177ZM183.399 182.977V182.935H183.441V182.977H183.399ZM192.239 182.135H192.281V182.177V182.135H192.239ZM187.525 181.63H187.566H187.525ZM186.177 182.008V181.966L186.219 182.008H186.177ZM191.944 182.177H191.986V182.219H191.944V182.177ZM182.979 182.219V182.177H183.021V182.219V182.177V182.219H182.979ZM192.492 180.283V180.199V180.157H192.534L192.492 180.199L192.534 180.241L192.492 180.283ZM182.684 182.766L182.726 182.724L182.768 182.766L182.684 182.851V182.766ZM186.641 181.799L186.683 181.757L186.767 181.714L186.81 181.799L186.725 181.841V181.799L186.683 181.841L186.641 181.799ZM187.357 181.799V181.757L187.399 181.714L187.441 181.672H187.483V181.714L187.441 181.757L187.399 181.841L187.357 181.799ZM191.692 180.872V180.914V180.957L191.734 180.914V180.872H191.692ZM185.419 183.061H185.377L185.419 183.019L185.377 182.977L185.294 183.019L185.336 182.935L185.294 182.893H185.21H185.083L184.999 182.935L185.041 182.977L184.915 183.103V183.188H184.83L184.873 183.146H184.788V183.103L184.83 183.061L184.873 182.977V182.935L184.83 182.893L184.746 182.977V182.893L184.663 182.935L184.621 182.893V182.851L184.704 182.808H184.746L184.788 182.766H184.83L184.873 182.724H184.957L184.999 182.683L184.957 182.641L184.999 182.599L185.041 182.641V182.599V182.556L185.168 182.472L185.125 182.599H185.168V182.641H185.21L185.252 182.556H185.294L185.252 182.514H185.377V182.472H185.419V182.388H185.377L185.504 182.346V182.304H185.546V182.346H185.672V182.388H185.757V182.43H185.799H185.757H185.715H185.63V182.472H185.672L185.715 182.43V182.514H185.757H185.883H185.925V182.599V182.641H185.968H186.01V182.599H186.052V182.556L186.177 182.514L186.219 182.556L186.177 182.599L186.094 182.641L186.135 182.683L186.094 182.766H186.135H186.177L186.262 182.683V182.724L186.304 182.808H186.43L186.388 182.893H186.304L186.262 182.935H186.177L186.219 182.893L186.177 182.851L186.135 182.808L186.01 182.851L185.925 182.935L185.883 182.893H185.841L185.799 182.977H185.841V183.019L185.757 183.061V183.019L185.715 182.977L185.588 183.019H185.546H185.463L185.419 183.061Z"
							fill="#195386" />
						<path class="hover:!opacity-50 transition-all duration-300"
							d="M187.819 181.419V181.377V181.419ZM187.819 181.419H187.861V181.461H187.819H187.861H187.819V181.419ZM183.274 182.304H183.315H183.274ZM183.274 182.304V182.346V182.304ZM186.135 182.008V182.052V182.008ZM186.135 182.008V182.052V182.008ZM182.894 182.935V182.893V182.935ZM182.894 182.935V182.977V182.935ZM181.505 183.061L181.547 183.019V182.977V182.935L181.632 182.893H181.674V182.851H181.716L181.757 182.808H181.841L181.884 182.766L181.841 182.683L181.926 182.641L181.884 182.599L181.968 182.556L181.926 182.514L181.968 182.472H181.926L181.968 182.388H181.926V182.346H181.884L181.926 182.304V182.261V182.219V182.177L181.968 182.135V182.093L182.01 182.052V181.966L182.052 181.925V181.883H182.01L182.052 181.799L182.01 181.757L182.052 181.714V181.672V181.63H182.094H182.136H182.221H182.263H182.305V181.588L182.347 181.546L182.305 181.504L182.389 181.419L182.515 181.335L182.557 181.294L182.599 181.335H182.641H182.684H182.726L182.81 181.21L182.894 181.294L183.021 181.21V181.167L183.063 181.125L183.23 181.041H183.274L183.399 180.957L183.526 181.041L183.61 180.999L183.694 180.914L183.779 180.872L183.863 180.788H183.905H183.988L184.03 180.83L183.988 180.914H184.03V180.957H184.073V180.999L184.199 180.957H184.241L184.283 180.914L184.325 180.83L184.368 180.788H184.41H184.494V180.83H184.536H184.578H184.663L184.957 180.704L184.999 180.746L184.957 180.788H184.999V180.746L185.125 180.662H185.21V180.704L185.294 180.662L185.377 180.494H185.463V180.452V180.41H185.377L185.419 180.367L185.377 180.325V180.283L185.419 180.199H185.504L185.463 180.157L185.588 180.03H185.715L185.757 179.988H185.715V179.946H185.757L185.841 179.904L185.883 179.863V179.777H185.925L185.968 179.736V179.694V179.652L185.883 179.568L185.799 179.483L185.841 179.441L185.799 179.399H185.757L185.715 179.357V179.273H185.672L185.63 179.315L185.588 179.23H185.546H185.463L185.419 179.273L185.294 179.188L185.21 179.23V179.273L185.168 179.188H185.125H185.083L185.041 179.146L184.999 179.188L184.957 179.105L184.873 179.146L184.83 179.105V179.146V179.188L184.788 179.146V179.188L184.83 179.273H184.788H184.746V179.146H184.704L184.746 179.063H184.704H184.663L184.578 179.021H184.536V179.063L184.452 179.105V179.146L184.494 179.188V179.23H184.452L184.41 179.188H184.325L184.241 179.23L184.199 179.273H184.157L184.115 179.315L184.03 179.273L183.988 179.23H183.946L183.988 179.273L183.863 179.441H183.821L183.779 179.399H183.694H183.652L183.694 179.441H183.652V179.399L183.736 179.315H183.694H183.652L183.568 179.23L183.483 179.273L183.441 179.188L183.357 179.357H183.315L183.274 179.273L183.23 179.23V179.273L183.188 179.315L183.105 179.23L183.063 179.273L183.021 179.23H182.979V179.105V179.063L183.021 178.936L182.979 178.894L182.936 178.936L182.894 178.894L182.768 178.936V178.852L182.81 178.81L182.768 178.726L182.726 178.683H182.684L182.641 178.641H182.557V178.557V178.515H182.515L182.474 178.473L182.515 178.388V178.346L182.474 178.179L182.389 178.094L182.305 178.01H182.221L182.136 177.968H181.968L182.01 177.883L182.052 177.841H182.094L182.136 177.799H182.179L182.263 177.757H182.347L182.432 177.674H182.474L182.599 177.757L182.684 177.715L182.768 177.757H182.852L182.894 177.799V177.757L182.979 177.674V177.632L183.105 177.588V177.505L183.147 177.463L183.274 177.421H183.315L183.357 177.463L183.441 177.421L183.483 177.463L183.61 177.421V177.463H183.694V177.421L183.779 177.379V177.336L183.905 177.294L184.073 177.126L184.115 177.168V177.126V177.084L184.157 176.999H184.199H184.241L184.283 176.957L184.368 176.999H184.41H184.536V177.084H184.578H184.621L184.663 177.041L184.746 176.957L184.788 176.999H184.873H184.957L184.999 177.041L185.041 176.999H185.125L185.168 176.916V176.957L185.21 176.916H185.252H185.294L185.336 176.957V176.916L185.377 177.084L185.419 177.041L185.463 177.084L185.504 177.041L185.588 176.999V176.957L185.672 176.916V176.957H185.715L185.799 176.916L185.841 176.832H185.883H185.925H185.968L186.01 176.789L186.052 176.705L186.094 176.747L186.135 176.705H186.177H186.219V176.621V176.579V176.537L186.262 176.579L186.346 176.537V176.494V176.452L186.43 176.494V176.537L186.472 176.494H186.514V176.41H186.557L186.725 176.368V176.326H186.852L186.935 176.41L186.977 176.368H187.019L187.061 176.326H187.104V176.284L187.23 176.243H187.272L187.357 176.199L187.608 176.116L187.652 176.074H187.735V175.99L187.777 176.032V175.99H187.819L187.861 175.947L187.946 175.99L188.03 175.947L188.114 175.905H188.156H188.199L188.366 175.779H188.408H188.451V175.821L188.493 175.863H188.451L188.535 175.905V175.947H188.577L188.619 175.99L188.703 175.863H188.788H188.83L188.872 175.821H188.956L188.999 175.905V175.947L189.041 175.905V175.821H189.124V175.779H189.166H189.208L189.293 175.863L189.335 175.821V175.905H189.377V175.863V175.821H189.419L189.461 175.737H189.503L189.546 175.694V175.821L189.63 175.863L189.672 175.905L189.714 175.863L189.924 175.821L189.966 175.737H190.008L190.05 175.779V175.821H190.135H190.219H190.303L190.472 175.737L190.513 175.694H190.597L190.766 175.568L190.892 175.485V175.443L190.977 175.399H191.019L191.061 175.443H191.145L191.186 175.399L191.23 175.443L191.313 175.485L191.439 175.443H191.524L191.566 175.399L191.608 175.443L191.65 175.399L191.692 175.443V175.485L191.734 175.526H191.777L191.819 175.568H191.861L191.903 175.526V175.568L191.944 175.61L192.113 175.485H192.155V175.526L192.239 175.568H192.281H192.366V175.652V175.737L192.239 175.821V175.863L192.281 175.99L192.324 176.074L192.408 176.032V175.947L192.534 175.905H192.619H192.702V175.947L192.871 175.905L192.955 175.779L192.997 175.737L192.955 175.694V175.652L193.039 175.61L193.166 175.568H193.208L193.375 175.443H193.419L193.502 175.399L193.755 175.316L193.923 175.148V175.105L194.133 175.021L194.47 174.937L194.639 174.852L194.681 174.81L194.933 174.685L195.186 174.6L195.228 174.558L195.355 174.516L195.523 174.474L195.608 174.432H195.649H195.691L195.775 174.39V174.305L196.07 174.179L196.491 174.01L196.533 173.968L196.955 173.843L196.997 173.758H197.039L197.164 173.716H197.291L197.459 173.674V173.632L197.712 173.548V173.505V173.463V173.421V173.337L197.67 173.296L197.628 173.337L197.586 173.254H197.628L197.586 173.21L197.501 173.169H197.459H197.417H197.375L197.333 173.21H197.291L197.249 173.169V173.085H197.164H197.122L197.08 173.043L197.164 172.959H197.122L197.08 172.916L197.206 172.748L197.249 172.706L197.375 172.621L197.333 172.579V172.537L197.459 172.496V172.454L197.501 172.411V172.369L197.544 172.327H197.628L197.67 172.201L197.753 172.159L197.797 172.116L197.712 171.99V171.948L197.586 171.906L197.628 171.821V171.779V171.738L197.67 171.696V171.569L197.712 171.527L197.753 171.569H197.839L197.88 171.527L197.922 171.485L197.839 171.443H197.797L197.88 171.401V171.359L197.964 171.317L197.922 171.232L197.964 171.19L197.922 171.148L198.006 171.107L197.964 171.065H197.922V171.021L197.964 170.938V170.77L198.006 170.727L198.049 170.685L198.133 170.643L198.175 170.601L198.217 170.559L198.175 170.517L198.217 170.432L198.175 170.39V170.432L198.133 170.39V170.307L198.175 170.265L198.091 170.096H198.133V170.054L198.175 170.012V169.97L198.217 169.927L198.259 169.885L198.301 169.801H198.344V169.717V169.632H198.511V169.59L198.553 169.549V169.465H198.638V169.423L198.764 169.296V169.254V169.212V169.17L198.806 169.212H198.891V169.17L198.848 169.128L198.764 169.043H198.722H198.68L198.638 169.001H198.595L198.511 168.918V168.876L198.428 168.832V168.791L198.511 168.707L198.595 168.665L198.638 168.707H198.68V168.665L198.722 168.623L198.806 168.538L198.848 168.581H198.975L199.101 168.538L199.142 168.496H199.228L199.353 168.538L199.395 168.496L199.522 168.538V168.454L199.564 168.412V168.454L199.606 168.37L199.564 168.328L199.606 168.285V168.201L199.69 168.159L199.648 168.118L199.69 168.076L199.775 168.034L199.817 167.991L199.859 167.949L199.775 167.865L199.859 167.696L199.817 167.654H199.901H199.942H199.986L200.028 167.612H200.111L200.153 167.57L200.111 167.528L200.153 167.487H200.195L200.28 167.443L200.322 167.528L200.406 167.57L200.448 167.612V167.654L200.533 167.696L200.575 167.654L200.533 167.739H200.617L200.659 167.696H200.784H200.827V167.739H200.911V167.823L200.953 167.781L200.995 167.823V167.865V167.907L200.953 168.034L200.995 168.118V168.159L201.08 168.118L201.164 168.159H201.122L201.08 168.285V168.328H201.122L201.08 168.454L201.037 168.496H200.995L201.037 168.623L201.122 168.665V168.832H201.164V168.918H201.122V169.001L201.08 169.043L201.164 169.085L201.122 169.128H201.08V169.17L201.122 169.254V169.338H201.08V169.296H201.037V169.38H201.08V169.423H201.122L201.037 169.59V169.632H201.08H201.122H201.206V169.676L201.122 169.717V169.759H201.206V169.717H201.29L201.331 169.759H201.375V169.801L201.417 169.759H201.458V169.801L201.542 169.843V169.885H201.584H201.627H201.669L201.795 169.97L201.922 169.927L201.964 170.012L202.048 170.054V170.096L202.09 170.138L202.131 170.054L202.175 170.138L202.3 170.096L202.384 170.18V170.096H202.426L202.469 170.138H202.553H202.595V170.223L202.679 170.265L202.764 170.307L202.806 170.348H202.889L202.973 170.265H203.016V170.223L203.058 170.265L203.1 170.223L203.142 170.265H203.184H203.226V170.223L203.268 170.265H203.311L203.479 170.307H203.52L203.564 170.348H203.606V170.39L203.647 170.348L203.731 170.474H203.773H203.815L203.858 170.517V170.474H203.9H203.942L203.984 170.39H204.068H204.111H204.153V170.432H204.195V170.474H204.279L204.32 170.517H204.362H204.406V170.559V170.517H204.447V170.474V170.517L204.489 170.474L204.447 170.517H204.489H204.573H204.615L204.7 170.474L204.742 170.432H204.826L204.953 170.39L204.995 170.348L205.037 170.39H205.078L205.12 170.432H205.162L205.247 170.474L205.331 170.601L205.415 170.559H205.5H205.542L205.584 170.685V170.77L205.626 170.812H205.668L205.709 170.77V170.812H205.753V170.854H205.795V170.896H205.836V170.98L205.795 171.148L205.836 171.274H205.795L205.709 171.485H205.668L205.584 171.527L205.542 171.654L205.415 171.821L205.331 171.906L205.289 171.948L205.162 172.074L205.12 172.243V172.454L205.247 172.706L205.289 172.79L205.373 172.832H205.457L205.5 172.874V172.832V172.874L205.415 173.337V173.59L205.542 174.054L205.709 174.81L205.753 175.021V175.19L205.668 175.358L205.626 175.443L205.542 175.485L205.289 175.61L205.078 175.737L204.784 175.947L204.615 176.074L204.32 176.199L204.068 176.284L203.773 176.41L202.931 176.621L202.595 176.705L202.258 176.832L202.006 176.957L201.837 176.999L201.711 177.084L201.29 177.294L200.995 177.547H200.911L200.827 177.632L200.784 177.674V177.757H200.827L200.784 177.799L200.827 177.841L200.7 177.926H200.659L200.49 178.01L200.364 178.136L200.28 178.221V178.305L200.237 178.43H200.195L200.153 178.473H200.069L199.986 178.515L199.901 178.683L199.859 178.726L199.817 178.81H199.775L199.733 178.726L199.648 178.768L199.564 178.852L199.522 178.936L199.438 179.188L199.395 179.273V179.525V179.568V179.61L199.48 179.946L199.522 180.03H199.648V180.072L199.733 180.199L199.817 180.283H199.901L199.942 180.241L199.901 180.199H199.986V180.157L200.069 180.199L200.111 180.157V180.072L200.153 180.115V180.072L200.195 180.115L200.153 180.157L200.237 180.199L200.195 180.241H200.153L200.111 180.325V180.283H200.069L200.111 180.367L200.069 180.325L200.028 180.367H199.986L199.942 180.325L199.859 180.367L199.817 180.452V180.494V180.535V180.577L199.733 180.535V180.577L199.564 180.619L199.48 180.788V180.872V180.914L199.522 180.872L199.48 180.914V180.957L199.438 180.999H199.395L199.353 181.041V180.999H199.311L199.228 181.083L199.186 181.125L199.142 181.252V181.335L199.186 181.419H199.228V181.461L199.269 181.504L199.311 181.461L199.353 181.419V181.461L199.311 181.504H199.353H199.395L199.353 181.546L199.311 181.504L199.269 181.546H199.311L199.269 181.588V181.63H199.311V181.672V181.757L199.269 181.672L199.142 181.63L199.186 181.588L199.101 181.546L198.891 181.461L197.586 181.377L197.122 181.335H196.744H196.406L196.322 181.377L196.197 181.335H195.733H195.439L195.186 181.377L195.144 181.419V181.504H195.102H195.06L194.933 181.461L194.344 181.504L193.966 181.546L193.671 181.588L193.46 181.546H193.208L193.124 181.588H193.081H193.039L192.997 181.63L192.955 181.588H192.913L192.871 181.63V181.588H192.913L192.828 181.504L192.661 181.461H192.492L192.45 181.419V181.377H192.324L192.408 181.335V181.252L192.45 181.294H192.492L192.45 181.335H192.492H192.534L192.577 181.294V181.21H192.492L192.45 181.167H192.408L192.366 181.21L192.324 181.125L192.408 181.083V181.041L192.324 180.999L192.366 180.957H192.408L192.45 180.999L192.492 180.914L192.534 180.83L192.619 180.746L192.577 180.704V180.662L192.661 180.577L192.786 180.494L192.702 180.452L192.661 180.41L192.744 180.325V180.283L192.786 180.241L192.997 180.115V180.03V179.988L192.955 179.946V179.904L192.997 179.863L192.955 179.821L192.997 179.777H192.955H192.913V179.736L192.871 179.777L192.828 179.736H192.786L192.661 179.694L192.619 179.736H192.534H192.492L192.534 179.821L192.492 179.777L192.45 179.821V179.863L192.408 179.904L192.366 179.946L192.281 179.904L192.239 179.863L192.155 179.904V179.946H192.071L191.861 179.988V180.03L191.819 180.072H191.777H191.734L191.692 180.115H191.65L191.692 180.157L191.608 180.199H191.566H191.608L191.482 180.283V180.325L191.439 180.367H191.482L191.397 180.494V180.535L191.439 180.577L191.482 180.535V180.577L191.524 180.619L191.608 180.704L191.65 180.746L191.692 180.872L191.734 180.83L191.692 180.704L191.65 180.662V180.619H191.566L191.524 180.535L191.566 180.494L191.608 180.535H191.65V180.494L191.734 180.41L191.777 180.367H191.819L191.903 180.452H191.986H192.03L191.986 180.41L192.03 180.367H192.071L192.113 180.325V180.367L192.155 180.325H192.197V180.367L192.155 180.41L192.071 180.494V180.535L192.113 180.619H192.155L192.113 180.662L192.071 180.619L192.03 180.704L191.986 180.619H191.903L191.861 180.577L191.777 180.619L191.692 180.704L191.734 180.746L191.777 180.704V180.746L191.819 180.788L191.777 180.746H191.734V180.788L191.777 180.83H191.903L191.819 180.872L191.861 180.914H191.819H191.734L191.777 180.957H191.819L191.903 180.914L191.944 180.957L191.861 181.041L191.903 181.083L191.986 181.041H192.071V181.083V181.041V181.083H192.113H192.155H192.113H192.071L192.113 181.125H192.197V181.21H192.113V181.252V181.21L192.155 181.252L192.113 181.335L192.155 181.377H192.113H192.071V181.419L192.113 181.461L192.155 181.377H192.239H192.197L192.239 181.419L192.155 181.461H192.197V181.504H192.155L192.03 181.588V181.63L192.071 181.672H192.03H191.986H191.819L191.65 181.757H191.482L191.397 181.799V181.841H191.355L191.313 181.799L191.271 181.757L191.186 181.714V181.672H191.103L191.061 181.63L190.935 181.588H190.85H190.808L190.724 181.63L190.682 181.588L190.639 181.63L190.682 181.672L190.639 181.63L190.597 181.672H190.639V181.714L190.766 181.672V181.714L190.808 181.672L190.766 181.63H190.808H190.977L191.061 181.672H190.977H191.019V181.714L190.977 181.672L190.935 181.714H191.103H191.186V181.757H191.23L191.271 181.799L191.355 181.841H191.271H190.977L190.43 181.883L190.303 181.925L190.261 181.966V182.008V181.966H190.135L190.05 182.008L190.008 182.052L189.841 182.093L189.755 182.135V182.219V182.261V182.219H189.672H189.63H189.672V182.177L189.588 182.135L189.503 182.093H189.041L188.366 182.135L187.861 182.219L187.272 182.304L187.061 182.388H187.019H186.977L186.935 182.346V182.261H186.893L186.935 182.219H186.977L187.019 182.177V182.135H187.061L187.146 182.052L187.272 182.008L187.314 182.052L187.399 182.135H187.483L187.608 182.177H187.693L187.735 182.135V182.052V182.008L187.652 181.966L187.566 181.925L187.525 181.883L187.566 181.925L187.652 181.966L187.819 182.052L188.03 182.135H188.241L188.788 182.093L189.041 182.008L189.377 181.966H189.419L189.461 182.008L189.672 182.093V182.177L189.714 182.093V182.052H189.672V182.093L189.63 182.052L189.588 182.008L189.546 181.966H189.503L189.461 181.883L189.335 181.841L189.293 181.799H189.208V181.757H189.124L189.041 181.672L188.999 181.63L188.914 181.672V181.714L188.872 181.672H188.83L188.746 181.546L188.703 181.588V181.546L188.661 181.461L188.451 181.335V181.294L188.408 181.335L188.366 181.294V181.252H188.324L188.241 181.21H188.199L188.114 181.252V181.21L188.072 181.167L188.114 181.252L188.03 181.294H187.946L187.904 181.252L187.988 181.21L188.03 181.167L187.988 181.125H187.861L187.777 181.167L187.735 181.21L187.693 181.252L187.777 181.294L187.735 181.377V181.419H187.777H187.735H187.693L187.608 181.504H187.566L187.525 181.461L187.566 181.419L187.525 181.377H187.483V181.419V181.377H187.525V181.335L187.608 181.294L187.652 181.335V181.294H187.693V181.252H187.652L187.525 181.294H187.399H187.357H187.272L187.188 181.335H187.104H187.061L187.019 181.377H186.977L186.893 181.419L186.852 181.461V181.504H186.81L186.767 181.63L186.683 181.672L186.641 181.63L186.725 181.504L186.683 181.461L186.725 181.419L186.683 181.377L186.599 181.419L186.514 181.461L186.472 181.504V181.546L186.514 181.588L186.472 181.714H186.388V181.799L186.262 181.883L186.094 181.966H186.052V182.008L186.01 181.966V182.008H185.968L186.01 181.966H185.968L185.883 182.008H185.925V182.052L185.883 182.093L185.841 182.052V182.093H185.757L185.799 182.008H185.757L185.546 182.093L185.504 182.135L185.463 182.093V182.052L185.419 182.093V182.052H185.463L185.504 181.925L185.588 181.883V181.841H185.546L185.463 181.757H185.419V181.714L185.377 181.799L185.336 181.757L185.294 181.799L185.252 181.841V181.883L185.21 181.841L185.168 181.883V181.925H185.125L185.083 181.883L185.125 181.799L185.083 181.757V181.799H184.999V181.841V181.799L184.957 181.841V181.883H184.915V181.925L184.873 181.883L184.788 181.966V181.883H184.746V181.799L184.788 181.757L184.83 181.714H184.957V181.63L184.999 181.672L185.041 181.63V181.588L185.083 181.504H185.125V181.461L185.041 181.504L184.999 181.461L184.915 181.504V181.546V181.504L184.873 181.461H184.957H184.915V181.419L184.957 181.377L184.999 181.335H184.957V181.294V181.252L184.915 181.294L184.873 181.252H184.83L184.788 181.294L184.746 181.252H184.704L184.746 181.294H184.704L184.746 181.335H184.663L184.704 181.419V181.377L184.83 181.419L184.746 181.461L184.704 181.504H184.663V181.546H184.621V181.588L184.578 181.546L184.621 181.504L184.536 181.419L184.452 181.461L184.41 181.377V181.419H184.368V181.504L184.325 181.461V181.504H184.283V181.588L184.325 181.63H184.283V181.672L184.241 181.714H184.325V181.757H184.241L184.199 181.841L184.241 181.883H184.325L184.241 181.925L184.157 181.841L184.115 181.883V181.841V181.799H184.073V181.841L184.03 181.799H183.988L183.946 181.883L183.863 181.966L183.821 181.925H183.779H183.694L183.568 182.008H183.526L183.441 182.052H183.399V182.093L183.357 182.135L183.274 182.177L183.315 182.093V182.052H183.274L183.188 182.093V182.052V182.093V182.052H183.147L183.021 182.093V182.052H182.979L182.936 182.135L182.894 182.093V182.135L182.852 182.093L182.768 182.177V182.219H182.726V182.261L182.684 182.304L182.726 182.346H182.684L182.641 182.388V182.514L182.726 182.556V182.599V182.556L182.684 182.599H182.641V182.641V182.683H182.684L182.641 182.766H182.599V182.808L182.641 182.851L182.557 182.893V182.935H182.515H182.557H182.599L182.557 182.977H182.515V183.061L182.557 183.103L182.599 183.146L182.557 183.188H182.599L182.557 183.23H182.599H182.641H182.684V183.188H182.726L182.768 183.146H182.81L182.768 183.103H182.81V183.061L182.852 183.103V183.061H182.894L182.936 182.935H182.979V183.019H183.105V183.061H183.147L183.105 183.103V183.188H183.063H183.021V183.23H182.979H182.936H182.979V183.188L183.021 183.23V183.188H183.063V183.146H183.021V183.103L182.936 183.188V183.146L182.852 183.103L182.894 183.188L182.852 183.23L182.894 183.188H182.936L182.852 183.272H182.81L182.768 183.314V183.272L182.726 183.314H182.768L182.684 183.356H182.768L182.81 183.314V183.356H182.852L182.894 183.272H182.936H183.021H183.063L183.188 183.23L183.105 183.314L183.021 183.524L182.894 183.608V183.65L183.021 183.693L182.979 183.65V183.608H183.021L183.063 183.566L183.147 183.399L183.274 183.314V183.272L183.399 183.23L183.526 183.188V183.146V183.188L183.483 183.23L183.399 183.314V183.356L183.357 183.441L183.399 183.483L183.526 183.524L183.568 183.483V183.524L183.652 183.483L183.779 183.566H183.736H183.779L183.821 183.608H183.863V183.65L183.821 183.693L183.779 183.608H183.694H183.652L183.61 183.693L183.568 183.735L183.526 183.693L183.483 183.819V183.861L183.357 184.03L183.315 184.072H183.274L183.23 184.114V183.988H183.188H183.147V183.946H183.105L183.063 183.988V184.03V183.903L183.021 183.861L182.979 183.903L182.936 183.946H182.852L182.894 183.988L182.81 183.946L182.768 183.903V183.946V183.988H182.726L182.641 183.946L182.515 183.988V184.03V184.072V184.03H182.474L182.432 184.072L182.474 184.114L182.432 184.072L182.389 184.03H182.347L182.263 183.946L182.136 183.903H182.179L182.136 183.819V183.777L182.094 183.693V183.65L181.968 183.608V183.566L181.841 183.608L181.884 183.566L181.841 183.524V183.483L181.757 183.441L181.799 183.399L181.674 183.356H181.547V183.23H181.505L181.463 183.188L181.505 183.146V183.061ZM201.29 177.926V177.883H201.331V177.926H201.29ZM201.206 177.968L201.248 177.926L201.29 177.968H201.248L201.29 178.01H201.206V177.968ZM191.986 181.966V181.925V181.966ZM190.008 182.093H190.05H190.008ZM186.304 181.883V181.925V181.883ZM182.768 182.43V182.472H182.81H182.768V182.43ZM187.188 181.419V181.377H187.23L187.188 181.419ZM191.482 181.966H191.439V181.925H191.482V181.966ZM182.726 182.43V182.472V182.43ZM182.852 183.272L182.81 183.23L182.768 183.272H182.81H182.852ZM182.726 182.893H182.768H182.726ZM183.441 183.483V183.441V183.483ZM183.483 182.093H183.526H183.568V182.135H183.526V182.177V182.135V182.177H183.483V182.135H183.526V182.093H183.483ZM187.272 181.504H187.314H187.272ZM183.063 182.135H183.105H183.147H183.105V182.177H183.063V182.219V182.177V182.135ZM189.672 182.261H189.714H189.672ZM191.271 182.008V181.966H191.313V182.008H191.271ZM187.272 181.925V181.883V181.925ZM191.903 181.925H191.944H191.903ZM183.441 184.03V183.988H183.483H183.441V184.03ZM182.852 182.808V182.766H182.894H182.852V182.808ZM187.314 181.883V181.925V181.883ZM187.525 181.714V181.672H187.566V181.714H187.525ZM191.903 182.008H191.944V181.966V182.008H191.903ZM183.357 183.019H183.399V183.061H183.357V183.103L183.274 183.146L183.23 183.188H183.147L183.23 183.146L183.315 183.061H183.357V183.019ZM183.188 182.177V182.135H183.23V182.093H183.274L183.23 182.135V182.177H183.188ZM190.008 182.177V182.135V182.177ZM183.399 182.977V182.935H183.441V182.977H183.399ZM192.239 182.135H192.281V182.177V182.135H192.239ZM187.525 181.63H187.566H187.525ZM186.177 182.008V181.966L186.219 182.008H186.177ZM191.944 182.177H191.986V182.219H191.944V182.177ZM182.979 182.219V182.177H183.021V182.219V182.177V182.219H182.979ZM192.492 180.283V180.199V180.157H192.534L192.492 180.199L192.534 180.241L192.492 180.283ZM182.684 182.766L182.726 182.724L182.768 182.766L182.684 182.851V182.766ZM186.641 181.799L186.683 181.757L186.767 181.714L186.81 181.799L186.725 181.841V181.799L186.683 181.841L186.641 181.799ZM187.357 181.799V181.757L187.399 181.714L187.441 181.672H187.483V181.714L187.441 181.757L187.399 181.841L187.357 181.799ZM191.692 180.872V180.914V180.957L191.734 180.914V180.872H191.692ZM185.419 183.061H185.377L185.419 183.019L185.377 182.977L185.294 183.019L185.336 182.935L185.294 182.893H185.21H185.083L184.999 182.935L185.041 182.977L184.915 183.103V183.188H184.83L184.873 183.146H184.788V183.103L184.83 183.061L184.873 182.977V182.935L184.83 182.893L184.746 182.977V182.893L184.663 182.935L184.621 182.893V182.851L184.704 182.808H184.746L184.788 182.766H184.83L184.873 182.724H184.957L184.999 182.683L184.957 182.641L184.999 182.599L185.041 182.641V182.599V182.556L185.168 182.472L185.125 182.599H185.168V182.641H185.21L185.252 182.556H185.294L185.252 182.514H185.377V182.472H185.419V182.388H185.377L185.504 182.346V182.304H185.546V182.346H185.672V182.388H185.757V182.43H185.799H185.757H185.715H185.63V182.472H185.672L185.715 182.43V182.514H185.757H185.883H185.925V182.599V182.641H185.968H186.01V182.599H186.052V182.556L186.177 182.514L186.219 182.556L186.177 182.599L186.094 182.641L186.135 182.683L186.094 182.766H186.135H186.177L186.262 182.683V182.724L186.304 182.808H186.43L186.388 182.893H186.304L186.262 182.935H186.177L186.219 182.893L186.177 182.851L186.135 182.808L186.01 182.851L185.925 182.935L185.883 182.893H185.841L185.799 182.977H185.841V183.019L185.757 183.061V183.019L185.715 182.977L185.588 183.019H185.546H185.463L185.419 183.061Z"
							stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="ES" @mouseenter="e => hoverES(e, 'ES')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M200.153 167.488V167.444V167.402V167.319H200.237V167.361H200.28L200.237 167.235L200.195 167.193H200.237L200.28 167.15L200.237 167.108L200.28 167.066L200.322 167.024V166.982L200.364 166.94L200.406 166.855L200.49 166.813L200.448 166.771H200.49L200.533 166.729L200.575 166.688L200.533 166.646V166.688L200.49 166.646L200.533 166.561H200.448H200.322L200.28 166.519V166.477L200.322 166.435L200.364 166.393V166.308L200.448 166.182V166.14L200.49 166.098H200.575V166.055V166.013L200.533 165.888L200.575 165.846V165.719L200.617 165.635V165.424V165.34V165.255L200.406 165.213L200.322 165.004V164.961H200.237L200.28 164.835V164.793L200.364 164.751L200.322 164.666H200.364H200.406L200.448 164.624L200.49 164.582L200.575 164.54L200.617 164.499V164.457H200.742L200.784 164.413L200.742 164.372L200.784 164.246L200.828 164.204V164.035V163.993L200.869 163.951V163.909H201.459H202.764H203.017V163.866L203.058 163.824L203.1 163.866L203.226 163.782L203.268 163.657V163.614L203.311 163.572L203.353 163.488L203.395 163.446H203.353L203.437 163.362L203.395 163.319L203.437 163.235V163.151L203.479 163.11L203.521 162.983V162.941L203.564 162.899L203.606 162.857V162.73L203.689 162.646L203.648 162.562V162.519L203.606 162.435L203.648 162.393L203.689 162.224L203.731 162.183H203.9L203.984 162.141L204.026 162.183H204.068L204.153 162.057V161.973L204.279 161.93L204.321 161.973L204.406 161.888L204.448 161.846V161.593H204.489V161.552L204.448 161.468H204.489L204.531 161.341L204.573 161.257L204.489 161.215V161.173H204.531L204.489 161.088L204.406 161.046V160.962L204.489 160.921L204.448 160.879L204.489 160.794V160.752V160.668L204.531 160.626L204.489 160.583L204.531 160.457L204.573 160.415H204.658L204.742 160.373L204.784 160.288H204.826H204.868L204.91 160.246L204.953 160.035H204.995L205.037 159.994H205.079H205.12V159.91H205.247V159.868L205.373 159.826V159.784L205.331 159.699L205.289 159.615L205.331 159.488L205.289 159.404V159.321L205.415 159.363L205.542 159.404H205.753V159.363L205.878 159.194V159.152L205.92 159.11L205.837 159.068V158.984L205.795 158.941V158.899L205.837 158.857V158.773V158.732L206.004 158.605V158.563L206.047 158.521L205.962 158.479V158.394L206.004 158.268H206.047L206.089 158.226H206.131L206.173 158.142L206.131 158.099H206.089H206.047H206.004V158.057L206.047 158.015H205.962L205.92 157.973L206.004 157.932H206.089V157.805L206.004 157.763H205.962L206.004 157.721L205.962 157.679V157.595H206.004L206.047 157.552V157.468L206.004 157.426L206.047 157.384H206.004V157.342H205.962V157.257L205.92 157.215L205.878 157.174L205.92 157.09H205.837V157.005L205.795 156.963H205.753V156.921L205.71 156.879L205.668 156.837H205.584H205.542V156.795V156.71L205.5 156.753V156.668H205.457L205.415 156.71L205.373 156.626H205.247V156.543H205.206L205.162 156.501L205.206 156.416L205.12 156.332L205.162 156.29V156.206H205.247L205.415 156.079H205.457V156.037V155.995L205.415 156.037H205.373H205.331H205.289L205.247 155.995V155.953H205.206L205.162 155.868V155.826H205.079V155.784L204.953 155.743L204.91 155.701H204.868V155.616L204.826 155.574L204.784 155.49L204.7 155.448H204.658H204.615V155.406L204.573 155.321L204.531 155.279L204.406 155.321H204.362L204.279 155.237V155.321V155.363L204.237 155.406L204.153 155.279H204.111L204.068 155.237L204.111 155.195H204.068L204.111 155.112L204.068 155.026L204.153 154.901H204.531H204.573H204.658L204.742 154.859L204.784 154.943L204.826 154.985V155.026L204.91 155.153H204.995H205.079H205.289H205.415H205.795L205.878 155.112L205.92 155.068L205.962 155.112L206.004 155.068L206.047 155.026L206.089 154.985V154.943V154.901L206.004 154.859L206.047 154.816L205.962 154.732V154.479V154.437L205.92 154.185L205.878 154.143L205.668 154.101L205.626 154.059H205.542L205.457 153.974H205.373L205.415 153.932H205.373V153.89L205.289 153.932L205.331 153.89L205.247 153.848V153.806H205.289L205.331 153.764L205.373 153.721V153.679L205.331 153.637L205.373 153.301H205.415V153.175L205.457 152.796V152.754V152.712H205.415L205.206 152.67H205.037L204.489 152.627L204.448 152.585L204.531 152.459L204.615 152.417L204.7 152.375H204.573V152.29V152.206H204.658V152.165V152.081V151.954L204.615 151.912V151.743L204.658 151.701L204.784 151.575L204.995 151.406L204.953 151.365V151.323V151.281H204.995V151.238L204.953 151.196V151.154L204.995 151.112V151.028L205.162 150.943H205.247V150.901V150.859L205.373 150.817L205.331 150.901H205.373L205.415 150.775H205.5V150.859H205.626L205.668 150.734L205.71 150.69L205.795 150.734L205.837 150.775H205.878V150.734V150.69V150.607H205.92L205.962 150.648H206.004L206.089 150.565L206.131 150.523H206.173V150.481L206.215 150.523L206.257 150.481V150.565H206.342L206.426 150.607V150.69H206.468L206.51 150.734H206.551H206.637H206.678L206.804 150.775L206.847 150.817L207.015 150.775L206.973 150.481L206.173 149.723L206.215 149.681H206.257L206.299 149.596L206.342 149.681H206.384L206.426 149.723L206.468 149.681L206.595 149.512H206.637L206.678 149.554L206.72 149.512L206.762 149.47L206.804 149.512H206.847L206.889 149.596L206.847 149.681L206.931 149.639H206.973V149.681H207.015L206.973 149.807H207.015H207.057L207.142 149.849L207.184 149.807H207.268H207.351V149.892L207.393 149.934L207.52 149.849L207.562 149.892L207.604 149.849L207.689 149.892L207.731 149.849L207.773 149.765L207.899 149.723V149.639L207.984 149.596L207.942 149.554L207.984 149.47V149.428V149.386H208.068H208.151V149.259H208.278L208.404 149.176L208.531 149.092H208.573L208.657 149.217H208.784L208.909 149.343L208.951 149.259L209.12 149.301H209.204H209.373V149.343H209.457L209.498 149.301L209.582 149.343L209.625 149.301H209.709L209.793 149.386H209.835L209.878 149.47L209.962 149.428V149.47L210.088 149.554H210.131L210.215 149.596L210.382 149.681L211.393 150.312L212.109 150.775L212.277 150.901L212.319 150.943L213.709 151.828L213.793 151.87L213.835 151.912V151.996V152.038L213.624 152.459V152.501L213.54 152.796L213.456 153.006V153.301V153.343V153.554L213.498 153.637L213.413 153.89L213.371 154.312L213.329 154.816V155.153L213.413 155.868L213.54 156.795L213.582 157.257L213.666 157.721L213.709 158.142L213.666 158.521L213.456 159.152L213.204 159.741L212.993 160.204V160.33L212.909 160.373H212.866H212.782L212.571 160.457L212.319 160.583L212.193 160.668L211.898 160.921L211.646 161.173L211.477 161.341L211.435 161.425V161.51L211.393 161.635L211.309 161.762L211.267 161.846L211.224 161.888V161.93L211.182 161.973V162.057L211.056 162.141L210.973 162.183L210.929 162.268V162.31L210.973 162.351L210.929 162.393L210.888 162.477V162.519L210.846 162.604V162.646L210.804 162.815L210.635 162.857L210.593 162.941L210.72 163.068V163.277L210.635 163.572V163.699L210.593 163.741V163.866L210.551 163.951L210.467 164.119L210.34 164.246L210.298 164.372V164.413L210.215 164.457V164.413V164.372L210.173 164.288H210.088L210.004 164.33L209.962 164.413L210.004 164.457L209.962 164.499H210.046V164.54H209.962H210.004H210.046V164.582H210.004V164.624V164.666L210.088 164.624H210.131H210.088V164.666H210.131H210.088V164.708H210.131H210.088H210.046L210.004 164.835L209.962 164.877L209.835 165.088L209.793 165.255V165.299L209.625 165.635L209.54 165.846V165.888H209.498L209.457 166.013L209.288 166.266V166.393L209.162 166.561L209.12 166.646H209.162H209.12L209.078 166.688V166.646H208.993L209.036 166.602H208.993L208.909 166.561V166.602L208.867 166.646L208.909 166.688H208.867V166.729V166.771L208.909 166.729L208.867 166.813H208.826V166.771L208.784 166.729L208.74 166.771L208.699 166.813H208.657V166.855L208.74 166.813L208.699 166.855H208.74H208.699V166.897H208.657L208.615 167.024L208.531 167.193L208.573 167.235H208.531V167.277H208.488V167.319H208.446H208.362L208.236 167.488L208.193 167.571V167.613L208.151 167.697H208.193L208.151 167.74L208.109 167.697L208.026 167.74L207.942 167.908H207.899V167.95H207.857V167.866L207.899 167.824L207.857 167.782L207.731 167.697L207.773 167.613L207.815 167.571L207.773 167.613H207.731V167.655L207.689 167.697L207.731 167.74L207.646 167.782H207.604V167.824H207.562V167.866H207.52L207.478 167.908H207.436L207.351 167.95H207.309V167.908H207.268V167.95V167.908L207.309 167.95V167.992H207.268L207.309 167.95H207.268L207.184 167.992L207.142 168.035L207.057 168.119V168.16V168.202V168.244L206.973 168.286V168.371L206.847 168.497L206.804 168.582V168.624L206.762 168.75V168.918L206.804 169.002H206.762V169.044L206.72 169.213L206.637 169.255L206.468 169.802L206.299 169.886L206.257 169.971L206.131 170.055L206.047 170.181L205.878 170.475L205.837 170.602V170.771V170.897H205.795V170.855H205.753V170.813H205.71V170.771L205.668 170.813H205.626L205.584 170.771V170.686L205.542 170.56H205.5H205.415L205.331 170.602L205.247 170.475L205.162 170.433H205.12L205.079 170.391H205.037L204.995 170.349L204.953 170.391L204.826 170.433H204.742L204.7 170.475L204.615 170.518H204.573H204.489H204.448L204.489 170.475L204.448 170.518V170.475V170.518H204.406V170.56V170.518H204.362H204.321L204.279 170.475H204.195V170.433H204.153V170.391H204.111H204.068H203.984L203.942 170.475H203.9H203.858V170.518L203.815 170.475H203.773H203.731L203.648 170.349L203.606 170.391V170.349H203.564L203.521 170.308H203.479L203.311 170.266H203.268L203.226 170.224V170.266H203.184H203.142L203.1 170.224L203.058 170.266L203.017 170.224V170.266H202.973L202.89 170.349H202.806L202.764 170.308L202.679 170.266L202.595 170.224V170.139H202.553H202.469L202.426 170.097H202.384V170.181L202.3 170.097L202.175 170.139L202.132 170.055L202.09 170.139L202.048 170.097V170.055L201.964 170.013L201.922 169.928L201.795 169.971L201.669 169.886H201.627H201.584H201.542V169.844L201.459 169.802V169.76H201.417L201.375 169.802V169.76H201.332L201.29 169.718H201.206V169.76H201.122V169.718L201.206 169.677V169.633H201.122H201.08H201.037V169.591L201.122 169.424H201.08V169.381H201.037V169.297H201.08V169.339H201.122V169.255L201.08 169.171V169.129H201.122L201.164 169.086L201.08 169.044L201.122 169.002V168.918H201.164V168.833H201.122V168.666L201.037 168.624L200.995 168.497H201.037L201.08 168.455L201.122 168.329H201.08V168.286L201.122 168.16H201.164L201.08 168.119L200.995 168.16V168.119L200.953 168.035L200.995 167.908V167.866V167.824L200.953 167.782L200.911 167.824V167.74H200.828V167.697H200.784H200.659L200.617 167.74H200.533L200.575 167.655L200.533 167.697L200.448 167.655V167.613L200.406 167.571L200.322 167.529L200.28 167.444L200.195 167.488H200.153ZM209.54 165.93H209.582H209.54ZM209.457 166.519V166.477V166.519ZM209.373 166.393H209.331H209.373ZM208.657 166.813H208.573H208.531V166.771L208.488 166.897H208.446L208.404 166.855V166.897H208.446H208.488L208.446 166.94L208.531 166.982L208.573 166.94H208.488L208.531 166.855L208.573 166.813L208.657 166.855V166.813ZM209.415 166.519V166.477V166.519ZM209.92 165.004H209.962H209.92Z"
							fill="#195386" stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="SC" @mouseenter="e => hoverES(e, 'SC')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M126.023 208.403V208.36L125.981 208.318L126.023 208.276L126.234 208.234V208.192L126.107 208.234L126.065 208.15H126.107L126.192 208.108V208.065V208.023L126.107 207.981V207.939H126.15L126.192 208.023H126.234L126.36 207.981L126.192 207.856V207.812L126.234 207.729L126.318 207.812H126.403L126.36 207.771H126.318L126.234 207.687L126.192 207.603H126.276L126.36 207.687L126.403 207.771L126.487 207.729L126.445 207.687L126.36 207.645L126.318 207.476L126.36 207.518L126.445 207.603L126.487 207.56L126.528 207.518V207.476L126.487 207.434L126.445 207.35H126.528L126.57 207.434L126.655 207.35L126.57 207.265H126.697H126.739V207.223L126.612 207.139H126.655V207.056L126.739 207.098L126.823 207.056V207.014L126.781 206.929V206.887L126.95 206.971H126.992H127.034L126.95 206.929L126.865 206.845L126.95 206.803L126.992 206.761L126.95 206.718L126.992 206.634L126.865 206.592L126.907 206.55L126.95 206.467H126.865V206.423L127.076 206.467V206.423L127.034 206.381L126.992 206.34H126.865V206.298H126.907L126.865 206.256L126.823 206.171L126.781 206.129V206.087L126.823 206.129H126.865L126.823 206.045H126.781L126.739 205.961V205.919L126.823 205.876V205.834H126.739V205.876H126.655L126.57 205.792L126.655 205.834L126.697 205.792H126.739V205.708L126.697 205.667L126.655 205.582L126.612 205.667H126.528L126.57 205.582L126.487 205.54V205.456L126.528 205.54L126.612 205.498L126.655 205.414L126.57 205.329V205.287H126.612L126.655 205.372L126.739 205.287L126.655 205.245V205.203H126.739L126.697 205.119V205.076V205.119H126.612V205.076H126.57L126.487 205.034L126.528 204.992L126.57 205.034V204.95H126.612L126.655 204.867L126.612 204.825H126.655V204.782V204.74V204.698H126.697V204.529H126.781V204.487H126.739L126.655 204.529H126.612L126.697 204.487L126.655 204.445L126.57 204.403L126.655 204.361L126.697 204.403V204.361L126.739 204.278H126.655V204.151H126.697V204.192L126.739 204.151L126.823 204.192L126.781 204.109L126.823 204.067H126.865L126.823 203.982H126.865L126.823 203.94L126.781 204.025V203.94H126.739L126.823 203.898L126.865 203.94V203.856L126.823 203.814V203.772L126.865 203.73V203.772H126.907V203.687H126.865V203.603H126.823L126.781 203.561H126.823L126.865 203.519L126.781 203.478V203.393H126.823L126.865 203.351L126.823 203.309V203.267L126.907 203.225L126.865 203.183H126.907V203.098L126.992 203.056H127.034L126.992 203.014H127.034V202.972L127.118 202.845L127.159 202.761L127.201 202.678V202.593V202.551L127.286 202.593H127.328H127.412L127.539 202.551L127.581 202.678H127.623L127.75 202.761V202.803H127.918L128.086 202.845L128.212 202.803H128.254H128.296L128.423 202.72H128.507L128.549 202.678L128.801 202.509L128.843 202.467L128.928 202.551L128.97 202.509L129.012 202.551V202.509H129.054H129.096V202.551H129.181L129.223 202.593H129.265L129.434 202.509V202.593H129.475L129.559 202.72V202.761L129.601 202.803V202.845H129.643L129.728 202.93L129.896 203.014V203.056H129.938L130.023 203.14H130.107L130.148 203.183H130.19L130.234 203.14H130.275L130.317 203.225L130.359 203.267L130.401 203.309L130.485 203.351H130.528L130.57 203.393L130.612 203.434H130.696L130.865 203.351L130.99 203.309L131.243 203.14L131.496 203.267L131.579 203.225H131.623L131.706 203.183L131.748 203.225H131.832H131.875H131.917H131.959L132.127 203.14H132.17H132.254H132.337H132.379L132.421 203.183H132.464L132.548 203.14L132.632 203.183H132.674L132.717 203.14H132.759L132.801 203.098L132.885 203.14L132.927 203.225L132.97 203.183L133.012 203.225H133.054L133.179 203.183L133.306 203.309L133.39 203.351L133.432 203.393V203.434L133.516 203.478L133.559 203.519V203.561H133.601H133.643L133.685 203.603L133.768 203.519L133.853 203.561L133.895 203.519L133.937 203.561L134.021 203.519L134.148 203.478L134.316 203.603H134.401L134.485 203.73H134.526H134.568H134.61H134.737H134.779L134.863 203.687L134.905 203.645L134.948 203.687L134.99 203.73H135.032L135.116 203.687L135.201 203.772L135.243 203.687L135.284 203.772L135.368 203.73H135.495L135.621 203.856V203.898H135.663L135.748 203.856H135.79H135.832L135.874 203.898H135.999L136.126 203.856L136.21 203.772L136.379 203.94H136.463H136.548L136.59 203.982H136.674L136.757 204.025V204.151L136.799 204.192H136.842L136.884 204.278H136.968L137.01 204.319H137.052L137.094 204.361L137.179 204.403V204.445H137.263V204.487L137.305 204.572L137.473 204.529V204.572H137.557L137.642 204.614L137.684 204.572L137.81 204.656H137.979L138.104 204.698V204.74L138.146 204.782H138.188L138.273 204.698L138.357 204.74L138.484 204.656L138.61 204.698H138.694L139.031 204.614L139.199 204.656H139.283L139.452 204.529L139.579 204.614L139.662 204.698H139.746H139.873H139.957H140.293L140.42 204.656L140.504 204.698L140.546 204.782L140.588 204.825L140.546 204.909H140.63H140.673L140.715 204.95L140.757 205.034V205.119L140.841 205.203L140.883 205.329L141.052 205.414L141.01 205.498L141.093 205.456L141.135 205.414V205.329L141.052 205.245L141.135 205.161H141.22L141.304 205.119H141.388L141.515 205.076H141.557V205.119L141.641 205.076L141.683 205.119H141.81V205.034H141.851V204.992H141.935L141.977 204.95H142.104V204.909L142.146 204.867L142.104 204.782L142.188 204.74V204.656V204.614L142.23 204.572L142.146 204.529V204.487L142.188 204.445L142.104 204.403V204.361H142.062L142.019 204.278H141.977L141.935 204.192L141.893 204.151V204.109V204.067H141.935V204.025L142.019 203.982L141.977 203.94L142.019 203.898L141.935 203.856H141.893H141.851V203.814L141.893 203.772L141.768 203.73L141.724 203.645V203.603L141.81 203.561L141.768 203.519V203.478L141.851 203.519V203.434L141.893 203.393L142.019 203.351L141.977 203.309L141.935 203.267L142.019 203.183V203.14H141.977L142.019 203.056H142.062V203.014L142.188 202.972L142.23 202.93L142.272 202.845H142.315H142.357H142.441L142.524 202.803H142.566V202.761L142.651 202.72L142.693 202.761H142.735V202.72H142.819L142.904 202.678L142.946 202.636L142.988 202.593V202.509H143.03L143.072 202.383L143.199 202.467L143.241 202.509L143.577 202.383L143.619 202.425L143.746 202.509V202.636H143.872L143.913 202.72H143.957L143.999 202.636L143.913 202.467L143.957 202.425H143.999L144.124 202.551V202.761H144.208H144.251L144.293 202.72L144.335 202.593L144.377 202.467H144.419L144.546 202.636L144.588 202.678L144.63 202.636L144.671 202.509L144.755 202.467L144.798 202.425L144.84 202.383L145.093 202.341L145.135 202.383V202.509H145.219H145.303L145.346 202.467L145.219 202.214L145.388 202.13L145.43 202.089L145.513 201.962L145.555 201.878L145.597 201.836L145.682 201.794L145.724 201.751H145.766L145.682 201.583L145.766 201.498L145.808 201.414L145.893 201.33L146.061 201.372H146.144L146.271 201.33H146.313L146.355 201.289V201.204H146.313H146.271L146.188 201.247H146.144L146.102 201.204V201.078L146.229 200.951H146.271L146.313 201.078H146.355V201.162V201.204L146.524 201.12L146.608 201.078L146.65 201.12L146.692 201.078L146.735 201.12H146.819H146.777L146.819 201.162V201.078H146.86V201.12H146.944V201.162V201.12L147.029 201.162L146.986 201.204L147.029 201.247L147.071 201.33H147.155H147.197H147.239L147.282 201.289V201.33L147.492 201.456L147.535 201.541L147.492 201.625V201.667L147.535 201.625V201.667L147.577 201.709L147.66 201.751L147.702 201.794L147.744 201.751L147.786 201.794V201.751H147.702V201.709H147.744V201.667L147.702 201.625L147.744 201.583V201.541L147.702 201.456H147.786V201.372L147.913 201.289L148.039 201.247L148.124 201.204L148.208 201.247V201.162V201.12L148.333 201.162V201.247L148.377 201.33L148.418 201.289H148.46L148.502 201.33H148.586V201.372L148.629 201.414L148.671 201.372L148.713 201.33L148.755 201.289L148.797 201.204L148.755 201.162V201.204H148.713L148.671 201.162H148.629L148.671 201.12L148.713 201.078L148.755 201.12L148.839 201.078L148.881 201.12L148.839 201.247V201.289L148.924 201.204L149.008 201.33L149.049 201.247L149.091 201.289L149.218 201.204L149.26 201.078L149.302 201.204V201.247V201.204L149.344 201.162H149.386H149.428L149.513 201.12H149.555H149.597L149.724 201.204L149.766 201.162L149.724 201.078V201.036H149.808V200.994L149.933 201.036L149.975 201.078V201.204L149.933 201.289L150.102 201.12L150.018 201.078L150.06 201.036L150.144 200.994L150.186 201.036L150.144 201.078L150.186 201.12L150.313 201.078L150.355 201.12L150.397 201.162L150.439 201.12L150.607 201.162L150.566 201.204L150.607 201.247L150.649 201.289H150.691L150.733 201.33H150.775V201.247L150.818 201.289V201.372L150.733 201.414H150.775L150.818 201.372V201.456L150.86 201.541H150.902L150.944 201.498L150.986 201.625L151.07 201.667V201.625L151.113 201.583L151.155 201.709H151.197V201.625H151.155V201.583H151.197L151.238 201.667L151.322 201.709V201.836H151.407H151.491L151.407 201.92L151.449 202.003H151.491L151.575 201.92L151.66 201.962L151.702 202.045H151.786L151.702 202.13H151.744L151.786 202.172L151.828 202.13L151.87 202.172V202.13H151.911V202.172H151.955V202.214V202.256L152.038 202.214V202.13H152.08V202.214L152.038 202.256L152.122 202.298H152.164V202.256V202.298H152.207L152.249 202.383V202.341H152.291H152.333V202.383H152.375V202.298L152.459 202.425L152.544 202.467L152.586 202.383H152.544H152.586H152.628H152.669L152.628 202.341V202.298H152.669L152.711 202.383V202.341L152.755 202.383L152.796 202.341L152.838 202.383V202.341H152.88L152.922 202.298V202.256V202.298L152.88 202.214H152.922L152.964 202.172H152.922L152.964 202.13V202.089L153.006 202.13L153.091 202.045L153.133 201.962H153.217H153.259V202.045L153.302 202.003H153.344L153.386 201.962V202.003V201.92L153.469 201.962L153.511 201.878V201.92L153.553 201.962V201.92H153.596H153.68V201.878H153.722V201.836H153.764L153.722 201.794L153.764 201.836V201.794H153.806V201.751H153.849L153.891 201.709L154.017 201.625H154.059H154.1V201.667L154.144 201.625L154.1 201.583H154.186V201.541H154.144H154.186L154.144 201.498V201.456L154.186 201.414H154.227L154.269 201.456V201.414L154.311 201.456V201.414L154.353 201.372H154.311H154.396V201.33V201.289V201.247L154.48 201.204L154.522 201.162L154.48 201.12H154.522H154.564L154.648 201.078L154.691 201.036H154.775V200.994H154.858L154.9 200.951H154.944L154.985 200.994H155.027L155.069 201.036V200.994H155.111V201.036L155.153 200.951H155.195H155.153L155.195 200.909L155.28 200.951L155.322 200.909L155.364 200.994H155.406V200.951H155.49L155.533 200.909V200.994L155.616 201.078L155.658 201.036H155.7L155.742 200.951H155.785L155.827 201.036H155.869H155.953V200.994H155.995L156.038 200.951H156.08V200.909L156.122 200.867L156.164 200.825H156.206V200.867H156.248H156.289L156.206 200.825H157.089H157.764H157.974V200.783H158.016H158.058V200.741L158.184 200.656L158.226 200.699L158.269 200.741V200.783H158.311V200.825H158.353H158.395V200.783L158.437 200.825L158.478 200.783V200.909L158.395 201.289L158.437 201.372L158.478 201.414V201.709L158.564 202.003H158.647H158.689H158.858L158.9 201.962L158.942 202.003L158.9 202.214L158.984 202.341L159.068 202.383V202.341L159.111 202.298V202.341L159.068 202.425L159.026 202.467L158.858 202.761L158.731 203.014L158.689 203.225L158.522 203.519L158.478 203.687V203.814L158.353 203.982L158.269 204.192L158.142 204.445L158.1 204.572L158.058 204.614L157.974 204.867L157.931 205.203V205.329L157.974 205.414L157.931 205.54L157.974 205.75L158.016 205.792L158.058 205.834L158.142 205.876V205.792L158.226 205.834L158.269 205.919L158.311 205.961H158.437L158.478 205.876V205.919H158.564L158.522 206.003H158.564H158.522L158.478 206.045L158.437 206.214H158.311L158.269 206.256L158.226 206.508L158.184 206.676L158.226 206.761L158.184 206.803L158.269 206.887L158.311 206.845L158.269 206.929V207.056H158.311L158.269 207.098L158.311 207.139H158.269L158.226 207.181L158.311 207.308L158.395 207.35H158.437V207.308L158.478 207.265L158.522 207.308V207.265H158.564V207.308L158.605 207.392H158.647L158.605 207.434L158.647 207.476H158.605V207.56L158.564 207.603L158.522 207.729L158.478 207.771L158.522 207.856H158.478V207.897L158.437 207.939V207.897H158.395V207.981L158.437 208.108L158.564 208.234L158.647 208.318H158.731H158.773L158.858 208.276V208.234L158.9 208.15V208.108L158.942 208.065L158.984 208.108L159.026 208.023L159.068 208.065L158.984 208.15L159.068 208.276H159.153H159.195V208.234V208.192L159.236 208.276L159.278 208.234L159.236 208.318H159.195L159.153 208.36L159.111 208.403L159.068 208.487L159.111 208.612H159.153H159.236L159.195 208.654H159.153L159.111 208.697H159.068L158.984 208.739V208.697L159.068 208.654V208.612L158.984 208.529L158.9 208.487L158.773 208.529L158.731 208.57L158.647 208.612L158.564 208.697V208.654L158.478 208.739H158.437H158.395V208.907L158.353 208.95V209.076L158.437 209.245L158.478 209.328L158.564 209.37V209.328H158.605L158.647 209.287H158.689V209.328H158.731V209.287H158.773L158.816 209.245V209.412L158.858 209.454H158.942L158.9 209.497V209.539H158.858V209.581V209.623L158.9 209.707L158.858 209.792V209.749L158.816 209.707V209.665H158.773H158.731L158.689 209.834V209.876L158.731 209.918H158.647V209.96H158.689L158.647 210.045H158.605L158.564 210.086H158.522L158.478 210.045H158.437L158.311 210.086L158.269 210.17L158.226 210.254V210.381L158.184 210.423L158.269 210.634V210.718L158.395 210.801L158.353 210.886L158.437 210.97L158.605 211.012V211.054L158.647 211.139L158.605 211.181H158.647L158.605 211.223L158.564 211.265H158.522H158.478V211.181H158.437H158.353L158.269 211.223H158.311L158.269 211.307V211.392L158.226 211.434L158.184 211.392V211.434L158.226 211.476L158.311 211.517L158.437 211.559V211.643V211.686L158.478 211.77V211.854L158.437 211.938L158.478 212.023L158.522 212.107L158.478 212.19V212.234L158.437 212.275L158.522 212.359L158.478 212.485L158.564 212.57L158.605 212.738L158.564 212.781V212.738H158.522L158.478 212.781L158.437 212.865L158.478 212.948L158.522 212.99V212.948H158.605V213.032L158.564 213.117H158.522L158.478 213.201L158.353 213.285V213.37L158.311 213.412V213.454L158.353 213.496L158.311 213.538L158.269 213.665V213.79L158.353 213.875L158.395 213.832L158.478 213.917L158.437 213.959V213.917L158.395 213.959V214.043V214.127H158.353L158.311 214.212L158.269 214.254V214.296L158.226 214.379V214.421H158.269H158.226V214.464H158.269V214.506H158.226L158.184 214.548V214.59H158.226L158.184 214.632L158.142 214.674V214.717L158.058 214.885V214.927H158.1V214.97L158.058 215.012V215.054V215.096V215.179L158.142 215.221V215.179L158.184 215.221L157.974 215.348L157.805 215.643L157.764 215.812L157.805 215.854H157.847L157.805 215.895L157.679 216.063L157.595 216.19L157.553 216.359V216.401H157.595L157.553 216.443L157.469 216.568L157.427 216.695V216.863H157.553V216.906L157.595 216.948H157.553L157.469 217.032V217.074H157.511L157.469 217.158L157.384 217.201L157.3 217.285L157.342 217.326L157.3 217.368H157.258L157.131 217.453V217.537L157.174 217.579L157.089 217.621L157.047 217.579L157.006 217.621H156.964L156.88 217.663L156.542 217.79L155.995 218.084L155.49 218.421L154.817 218.843L154.186 219.347L154.017 219.515L153.933 219.557L153.638 219.81L153.344 220.105L152.838 220.652L152.796 220.694L151.997 221.621L151.575 222.21H151.449H151.407H151.364V222.168L151.449 222.126H151.407V222.083V222.126L151.364 222.083V222.041L151.322 221.999L151.238 222.041H151.197L151.07 221.957H151.028H150.944V221.915L150.902 221.957V221.915L150.86 221.873H150.818H150.775H150.733V221.83L150.775 221.788L150.691 221.746V221.704H150.733L150.691 221.663H150.649V221.621L150.607 221.536H150.522L150.397 221.494L150.313 221.452H150.228L150.186 221.41H150.144H150.102V221.368H150.018L149.975 221.41L149.933 221.494L149.849 221.536L149.766 221.579L149.724 221.536L149.555 221.621L149.513 221.663H149.386V221.704H149.344L149.218 221.746H149.133H149.091H149.049L149.091 221.915H149.133L149.218 221.999L149.302 222.083H149.386L149.555 222.335L149.471 222.294H149.386L149.428 222.252V222.21H149.302L149.344 222.168H149.302H149.26V222.126L149.218 222.083H149.133L149.091 222.041H149.133L149.049 221.999V221.957H149.008V221.915L148.966 221.957V222.041H148.924V221.999L148.881 221.957V221.915H148.839L148.881 221.873V221.746H148.924H148.839V221.704H148.797H148.755L148.881 221.621H148.924L148.881 221.579H148.839L148.881 221.536H148.839L148.966 221.494V221.452L148.924 221.41H148.839L148.924 221.326V221.368H149.008L148.966 221.41H149.049V221.452H149.175L149.133 221.536H149.091V221.579V221.621L149.218 221.536L149.175 221.621L149.26 221.579L149.218 221.536L149.26 221.494L149.218 221.536V221.41V221.368H149.26H149.218V221.284H149.175V221.241V221.199V221.157L149.26 221.115H149.344H149.302V221.157L149.218 221.199V221.241H149.302H149.26L149.302 221.284V221.326L149.386 221.241V221.326L149.428 221.284H149.471H149.513L149.555 221.241L149.597 221.284H149.681L149.639 221.241L149.597 221.199L149.639 221.157V221.115H149.724V221.073V220.988L149.681 220.946H149.808H149.849V220.988L149.891 220.946L149.849 220.863H149.891H149.975H150.018H149.975V220.779L150.018 220.736H149.975V220.652H150.06V220.61L150.018 220.568H150.06H150.102L150.06 220.526H150.144V220.484H150.102L150.06 220.526H150.018H149.975L149.849 220.568V220.61V220.568H149.724L150.018 220.441V220.399L150.06 220.357V220.315H150.102V220.273H150.144V220.232H150.102L149.975 220.273L150.06 220.19V220.105L150.102 220.063L150.144 220.105V220.021V219.979L150.186 220.021L150.27 219.979L150.186 219.937L150.144 219.894L150.06 219.852V219.726H150.102V219.641H150.144H150.018L149.975 219.599L150.06 219.557L150.018 219.515L150.102 219.474V219.432V219.39H150.144V219.347H150.186V219.305H150.228H150.144L150.102 219.347V219.263L149.975 219.305L150.018 219.263L150.06 219.221V219.179H150.102V219.137L150.018 219.179L150.06 219.01H150.018V218.968V218.843L150.102 218.884V218.799H150.06V218.757V218.716H150.018L150.06 218.674V218.632V218.59L150.102 218.548V218.59V218.548L150.186 218.59L150.228 218.548V218.505H150.27L150.186 218.463V218.379L150.228 218.295H150.313L150.355 218.252V218.295L150.397 218.337H150.439L150.48 218.295L150.522 218.337L150.439 218.463H150.48V218.505L150.566 218.463L150.522 218.421L150.566 218.337V218.252V218.21H150.649H150.607H150.733V218.295H150.775V218.252V218.21L150.818 218.168H150.902L150.86 218.126H150.818V218.043H150.775V218.001H150.818L150.86 217.957L150.944 217.916H150.902L150.944 217.874L150.902 217.832L150.944 217.79L150.986 217.748L151.028 217.663H151.07L151.113 217.621V217.705L151.155 217.748H151.197L151.28 217.663V217.748L151.449 217.705H151.533H151.575V217.748H151.617L151.66 217.705L151.702 217.663L151.66 217.579H151.575V217.495V217.453V217.41V217.368L151.533 217.41L151.491 217.368L151.449 217.243L151.364 217.201H151.322L151.364 217.116L151.449 217.032L151.364 216.948L151.407 216.906H151.364V216.863L151.238 216.906L151.197 216.863L151.238 216.821V216.653H151.197V216.695L151.113 216.737H151.155L151.113 216.821L151.155 216.863L151.113 216.906L151.07 216.863L151.028 216.821H150.986L150.944 216.695H150.902V216.779L150.944 216.821L150.86 216.779L150.775 216.906L150.733 216.863L150.775 216.821H150.607V216.779V216.737V216.653L150.522 216.61L150.649 216.568H150.691H150.649L150.566 216.527L150.522 216.568L150.439 216.527V216.568L150.48 216.653H150.439L150.397 216.695H150.355L150.228 216.61H150.186L150.144 216.653L150.186 216.695L150.228 216.737L150.144 216.779L150.102 216.695L150.06 216.61H150.018H149.975L149.933 216.527H149.891L149.849 216.568V216.61L149.766 216.653L149.681 216.61L149.639 216.653L149.597 216.737L149.555 216.779H149.386H149.344L149.26 216.737L149.175 216.821L149.091 216.737H149.008V216.695L149.049 216.61L149.091 216.568V216.527L149.008 216.485V216.443L148.966 216.485V216.527L148.881 216.568L148.839 216.653H148.797L148.881 216.779L148.924 216.863L148.797 216.906L148.755 216.863V216.737L148.671 216.61H148.629H148.586L148.544 216.568H148.502L148.418 216.653L148.377 216.695L148.333 216.653L148.25 216.485V216.443L148.124 216.527L148.166 216.568H148.208V216.61L148.081 216.653L147.997 216.61H147.955V216.568L147.913 216.527L147.829 216.485H147.744L147.702 216.527H147.66L147.702 216.653H147.66L147.619 216.695V216.61V216.443L147.577 216.401H147.535L147.492 216.443L147.45 216.568H147.408H147.366L147.324 216.485H147.155H147.071L147.029 216.443L146.944 216.359H146.86H146.692L146.566 216.316H146.524H146.482V216.443H146.44H146.397L146.355 216.401L146.271 216.359L146.188 216.232L146.102 216.148H146.061L145.977 216.232H145.893L145.85 216.148L145.893 216.063L145.766 215.937L145.64 215.895L145.682 215.768L145.597 215.643L145.555 215.601L145.471 215.559V215.432H145.43H145.346L145.135 215.306H145.093V215.179V215.054L145.051 215.012V214.97L145.008 214.927L144.966 215.012L144.882 214.97V214.927L144.924 214.843L144.882 214.717L144.924 214.632H144.882V214.59L144.713 214.632V214.59L144.63 214.464H144.588L144.461 214.59H144.419H144.377L144.335 214.548L144.377 214.421L144.335 214.338L144.293 214.296L144.166 214.254L144.208 214.212L144.293 214.17L144.335 214.085V214.001V213.959V213.917L144.251 213.832L144.04 213.79L144.082 213.748L143.999 213.665L144.04 213.579L143.999 213.538H143.913L143.746 213.454L143.704 213.37L143.661 213.328L143.619 213.37L143.577 213.496H143.493V213.454L143.451 213.412V213.37V213.243L143.324 213.159L143.241 213.075V212.99V212.907V212.865H143.114L143.072 212.823L143.114 212.696L143.072 212.654L142.988 212.612H142.946L142.819 212.654H142.777V212.612L142.735 212.485V212.443H142.609L142.482 212.359L142.399 212.275H142.272L142.188 212.234L142.146 212.275L142.104 212.317L142.062 212.275L142.019 212.19L141.893 212.107V212.023L141.851 211.938L141.768 211.981L141.641 211.938V211.854L141.683 211.812L141.641 211.77V211.686V211.643H141.599L141.515 211.601L141.388 211.686L141.304 211.601L141.22 211.559L141.262 211.392V211.349L141.177 211.307L141.093 211.349L141.052 211.392L141.01 211.434L140.968 211.517H140.883V211.476V211.392L140.757 211.265V211.223H140.715L140.673 211.181L140.63 211.139V210.97H140.588L140.546 210.886H140.42L140.252 210.928L140.168 210.886V210.928H140.126V210.97L140.083 211.054H140.041L139.999 211.012L139.957 210.928L139.999 210.759V210.718V210.676H139.957H139.873L139.788 210.801H139.704L139.662 210.759L139.746 210.507H139.704V210.465H139.662H139.579V210.592L139.535 210.634H139.494H139.452H139.41L139.368 210.549L139.41 210.465V210.423L139.326 210.381H139.241L139.199 210.423L139.157 210.549L139.115 210.592H139.073L138.988 210.507L138.904 210.465V210.423L138.694 210.465H138.61V210.549L138.694 210.634V210.676V210.718H138.652H138.61L138.484 210.592L138.399 210.634L138.315 210.676L138.273 210.634L138.357 210.423V210.381H138.273H138.146V210.423L138.104 210.465L138.146 210.592V210.634H138.063L137.979 210.507V210.297L137.937 210.254H137.894L137.81 210.297L137.726 210.339H137.642L137.599 210.297L137.768 210.17V210.128V210.086L137.642 209.96H137.515H137.432L137.346 209.918V209.876V209.834H137.39H137.432H137.642H137.684V209.749L137.599 209.707H137.473L137.39 209.749L137.346 209.707L137.263 209.665V209.623L137.221 209.581L137.305 209.539V209.454H137.263L137.137 209.539H137.094H137.052L136.926 209.497L136.842 209.539H136.757L136.715 209.497V209.412V209.328V209.287L136.632 209.245L136.59 209.287H136.505L136.421 209.328H136.379H136.337L136.379 209.118L136.337 209.076H136.295L136.252 209.118L136.168 209.203L136.126 209.328L136.084 209.412L136.042 209.454H135.999V209.412H135.957L135.874 209.287H135.832L135.663 209.245V209.203L135.748 209.118L135.874 209.076L135.915 209.034L135.79 208.95L135.748 208.992H135.663H135.537H135.495V209.034V209.118L135.537 209.203L135.579 209.287L135.537 209.328V209.37H135.495L135.41 209.287L135.326 209.245L135.243 209.16H135.201L135.116 209.245L135.032 209.287L134.99 209.16L135.032 208.992H134.99V208.95H134.948H134.905V208.992L134.948 209.16L134.905 209.203H134.863L134.821 209.16L134.779 209.118L134.653 208.992V208.907V208.865L134.695 208.739V208.697H134.653H134.61L134.401 208.823V208.865V208.907V208.992V209.034H134.274L134.063 208.992L133.979 208.865L133.895 208.907H133.853H133.726L133.685 208.95L133.559 208.992L133.516 209.034H133.474L133.39 208.992L133.306 208.865H133.264H133.221L133.179 208.907V209.034L133.095 209.118H133.054L133.012 209.076V209.034L132.97 208.907L132.927 208.823H132.885L132.843 208.865L132.759 208.95L132.717 208.992V208.95L132.632 208.907V208.865L132.674 208.739V208.697H132.632V208.654H132.59H132.506L132.464 208.612H132.421H132.337H132.296L132.212 208.654H132.17H132.127V208.612V208.445L132.085 208.403H132.043L131.875 208.487V208.529L131.79 208.57L131.664 208.612H131.623L131.579 208.57V208.403L131.454 208.36H131.412L131.37 208.487V208.697L131.328 208.739L131.243 208.697L131.201 208.654H131.159V208.529L131.201 208.487L131.285 208.36V208.276H131.243L131.201 208.192H131.159L130.99 208.318H130.948L130.906 208.276V208.15L131.032 207.981L131.075 207.897L131.032 207.856H130.99H130.865H130.823L130.696 207.981V208.023V208.065L130.738 208.192V208.234V208.318L130.485 208.403L130.359 208.445H130.317V208.403L130.234 208.234L130.19 208.192L130.148 208.234H130.107V208.276L130.065 208.487L130.023 208.529H129.938L129.728 208.403H129.686L129.601 208.445L129.348 208.57L129.265 208.697H129.223H129.181V208.654V208.612V208.57L129.307 208.36L129.348 208.276V208.234V208.192V208.15H129.307L129.265 208.108V208.065H129.139H129.096H129.054H129.012L128.97 208.023L128.928 207.939L128.886 207.897L128.843 207.939H128.801L128.717 208.023L128.676 208.15L128.634 208.234L128.339 208.318L128.254 208.276L128.212 208.192H128.128H128.086H128.045V208.276V208.318V208.36L128.128 208.445V208.487V208.57V208.612H128.045H128.001L127.918 208.57L127.792 208.445H127.75H127.665L127.497 208.529H127.454H127.37H127.328L127.245 208.739H127.201L127.159 208.697V208.57V208.487L127.118 208.445V208.403L127.034 208.36H126.992H126.907L126.865 208.403L126.781 208.445L126.739 208.487H126.697L126.612 208.529H126.528L126.445 208.318L126.36 208.276L126.192 208.403L126.15 208.445H126.107H126.065L126.023 208.403ZM158.647 210.507V210.465V210.507ZM158.647 211.812V211.77H158.689L158.647 211.728V211.686V211.643V211.601L158.731 211.476L158.816 211.434L158.942 211.476L158.9 211.265L158.858 211.223L158.816 211.265L158.773 211.223V211.181L158.689 211.139V211.096L158.773 211.054L158.816 211.012L158.858 210.97L158.984 211.012V210.97L158.942 210.928L158.984 210.886L159.026 210.843L158.942 210.801L158.9 210.759L158.942 210.718L158.9 210.676L158.984 210.634V210.592L158.942 210.549L158.9 210.507L158.858 210.465H158.816V210.381L158.858 210.339H158.9V210.297H158.942V210.212H158.816L158.773 210.254L158.816 210.212L158.9 210.17L158.942 210.086L159.068 210.128H159.195L159.236 210.086L159.405 210.045L159.531 210.001V209.918L159.489 209.876L159.531 209.96L159.489 209.834V209.792L159.531 209.834L159.573 209.792L159.616 209.749V209.792V209.918H159.658L159.7 210.045L159.742 210.128L159.868 210.17L159.911 210.086L159.953 210.128V210.17L159.868 210.212V210.297V210.423L159.742 210.465L159.616 210.676L159.531 210.801V210.928V210.97V211.012L159.573 210.97H159.616L159.573 211.054V211.096L159.531 211.139L159.489 211.223V211.265H159.447L159.405 211.307V211.349L159.278 211.476L159.236 211.559L159.195 211.728L159.068 211.896V211.938L159.026 212.023V212.107H159.068V212.149H159.111H159.153V212.19H159.236V212.234H159.195L159.153 212.275V212.317H159.195L159.153 212.359L159.068 212.401L159.026 212.359V212.317H158.984L158.9 212.359L158.858 212.401L158.816 212.57V212.612L158.689 212.696V212.654H158.647L158.689 212.57L158.731 212.528L158.647 212.443L158.689 212.401L158.647 212.359L158.605 212.317V212.234L158.564 212.19H158.647L158.689 212.107L158.731 212.065L158.689 211.896L158.773 211.77H158.731H158.689V211.812H158.647ZM158.689 210.381H158.647H158.689V210.339V210.381V210.423V210.381Z"
							fill="#52a8ff" />
						<path class="hover:!opacity-50 transition-all duration-300"
							d="M158.689 210.381H158.647H158.689ZM158.689 210.381V210.339V210.381ZM158.689 210.381V210.423V210.381ZM126.023 208.403V208.36L125.981 208.318L126.023 208.276L126.234 208.234V208.192L126.107 208.234L126.065 208.15H126.107L126.192 208.108V208.065V208.023L126.107 207.981V207.939H126.15L126.192 208.023H126.234L126.36 207.981L126.192 207.856V207.812L126.234 207.729L126.318 207.812H126.403L126.36 207.771H126.318L126.234 207.687L126.192 207.603H126.276L126.36 207.687L126.403 207.771L126.487 207.729L126.445 207.687L126.36 207.645L126.318 207.476L126.36 207.518L126.445 207.603L126.487 207.56L126.528 207.518V207.476L126.487 207.434L126.445 207.35H126.528L126.57 207.434L126.655 207.35L126.57 207.265H126.697H126.739V207.223L126.612 207.139H126.655V207.056L126.739 207.098L126.823 207.056V207.014L126.781 206.929V206.887L126.95 206.971H126.992H127.034L126.95 206.929L126.865 206.845L126.95 206.803L126.992 206.761L126.95 206.718L126.992 206.634L126.865 206.592L126.907 206.55L126.95 206.467H126.865V206.423L127.076 206.467V206.423L127.034 206.381L126.992 206.34H126.865V206.298H126.907L126.865 206.256L126.823 206.171L126.781 206.129V206.087L126.823 206.129H126.865L126.823 206.045H126.781L126.739 205.961V205.919L126.823 205.876V205.834H126.739V205.876H126.655L126.57 205.792L126.655 205.834L126.697 205.792H126.739V205.708L126.697 205.667L126.655 205.582L126.612 205.667H126.528L126.57 205.582L126.487 205.54V205.456L126.528 205.54L126.612 205.498L126.655 205.414L126.57 205.329V205.287H126.612L126.655 205.372L126.739 205.287L126.655 205.245V205.203H126.739L126.697 205.119V205.076V205.119H126.612V205.076H126.57L126.487 205.034L126.528 204.992L126.57 205.034V204.95H126.612L126.655 204.867L126.612 204.825H126.655V204.782V204.74V204.698H126.697V204.529H126.781V204.487H126.739L126.655 204.529H126.612L126.697 204.487L126.655 204.445L126.57 204.403L126.655 204.361L126.697 204.403V204.361L126.739 204.278H126.655V204.151H126.697V204.192L126.739 204.151L126.823 204.192L126.781 204.109L126.823 204.067H126.865L126.823 203.982H126.865L126.823 203.94L126.781 204.025V203.94H126.739L126.823 203.898L126.865 203.94V203.856L126.823 203.814V203.772L126.865 203.73V203.772H126.907V203.687H126.865V203.603H126.823L126.781 203.561H126.823L126.865 203.519L126.781 203.478V203.393H126.823L126.865 203.351L126.823 203.309V203.267L126.907 203.225L126.865 203.183H126.907V203.098L126.992 203.056H127.034L126.992 203.014H127.034V202.972L127.118 202.845L127.159 202.761L127.201 202.678V202.593V202.551L127.286 202.593H127.328H127.412L127.539 202.551L127.581 202.678H127.623L127.75 202.761V202.803H127.918L128.086 202.845L128.212 202.803H128.254H128.296L128.423 202.72H128.507L128.549 202.678L128.801 202.509L128.843 202.467L128.928 202.551L128.97 202.509L129.012 202.551V202.509H129.054H129.096V202.551H129.181L129.223 202.593H129.265L129.434 202.509V202.593H129.475L129.559 202.72V202.761L129.601 202.803V202.845H129.643L129.728 202.93L129.896 203.014V203.056H129.938L130.023 203.14H130.107L130.148 203.183H130.19L130.234 203.14H130.275L130.317 203.225L130.359 203.267L130.401 203.309L130.485 203.351H130.528L130.57 203.393L130.612 203.434H130.696L130.865 203.351L130.99 203.309L131.243 203.14L131.496 203.267L131.579 203.225H131.623L131.706 203.183L131.748 203.225H131.832H131.875H131.917H131.959L132.127 203.14H132.17H132.254H132.337H132.379L132.421 203.183H132.464L132.548 203.14L132.632 203.183H132.674L132.717 203.14H132.759L132.801 203.098L132.885 203.14L132.927 203.225L132.97 203.183L133.012 203.225H133.054L133.179 203.183L133.306 203.309L133.39 203.351L133.432 203.393V203.434L133.516 203.478L133.559 203.519V203.561H133.601H133.643L133.685 203.603L133.768 203.519L133.853 203.561L133.895 203.519L133.937 203.561L134.021 203.519L134.148 203.478L134.316 203.603H134.401L134.485 203.73H134.526H134.568H134.61H134.737H134.779L134.863 203.687L134.905 203.645L134.948 203.687L134.99 203.73H135.032L135.116 203.687L135.201 203.772L135.243 203.687L135.284 203.772L135.368 203.73H135.495L135.621 203.856V203.898H135.663L135.748 203.856H135.79H135.832L135.874 203.898H135.999L136.126 203.856L136.21 203.772L136.379 203.94H136.463H136.548L136.59 203.982H136.674L136.757 204.025V204.151L136.799 204.192H136.842L136.884 204.278H136.968L137.01 204.319H137.052L137.094 204.361L137.179 204.403V204.445H137.263V204.487L137.305 204.572L137.473 204.529V204.572H137.557L137.642 204.614L137.684 204.572L137.81 204.656H137.979L138.104 204.698V204.74L138.146 204.782H138.188L138.273 204.698L138.357 204.74L138.484 204.656L138.61 204.698H138.694L139.031 204.614L139.199 204.656H139.283L139.452 204.529L139.579 204.614L139.662 204.698H139.746H139.873H139.957H140.293L140.42 204.656L140.504 204.698L140.546 204.782L140.588 204.825L140.546 204.909H140.63H140.673L140.715 204.95L140.757 205.034V205.119L140.841 205.203L140.883 205.329L141.052 205.414L141.01 205.498L141.093 205.456L141.135 205.414V205.329L141.052 205.245L141.135 205.161H141.22L141.304 205.119H141.388L141.515 205.076H141.557V205.119L141.641 205.076L141.683 205.119H141.81V205.034H141.851V204.992H141.935L141.977 204.95H142.104V204.909L142.146 204.867L142.104 204.782L142.188 204.74V204.656V204.614L142.23 204.572L142.146 204.529V204.487L142.188 204.445L142.104 204.403V204.361H142.062L142.019 204.278H141.977L141.935 204.192L141.893 204.151V204.109V204.067H141.935V204.025L142.019 203.982L141.977 203.94L142.019 203.898L141.935 203.856H141.893H141.851V203.814L141.893 203.772L141.768 203.73L141.724 203.645V203.603L141.81 203.561L141.768 203.519V203.478L141.851 203.519V203.434L141.893 203.393L142.019 203.351L141.977 203.309L141.935 203.267L142.019 203.183V203.14H141.977L142.019 203.056H142.062V203.014L142.188 202.972L142.23 202.93L142.272 202.845H142.315H142.357H142.441L142.524 202.803H142.566V202.761L142.651 202.72L142.693 202.761H142.735V202.72H142.819L142.904 202.678L142.946 202.636L142.988 202.593V202.509H143.03L143.072 202.383L143.199 202.467L143.241 202.509L143.577 202.383L143.619 202.425L143.746 202.509V202.636H143.872L143.913 202.72H143.957L143.999 202.636L143.913 202.467L143.957 202.425H143.999L144.124 202.551V202.761H144.208H144.251L144.293 202.72L144.335 202.593L144.377 202.467H144.419L144.546 202.636L144.588 202.678L144.63 202.636L144.671 202.509L144.755 202.467L144.798 202.425L144.84 202.383L145.093 202.341L145.135 202.383V202.509H145.219H145.303L145.346 202.467L145.219 202.214L145.388 202.13L145.43 202.089L145.513 201.962L145.555 201.878L145.597 201.836L145.682 201.794L145.724 201.751H145.766L145.682 201.583L145.766 201.498L145.808 201.414L145.893 201.33L146.061 201.372H146.144L146.271 201.33H146.313L146.355 201.289V201.204H146.313H146.271L146.188 201.247H146.144L146.102 201.204V201.078L146.229 200.951H146.271L146.313 201.078H146.355V201.162V201.204L146.524 201.12L146.608 201.078L146.65 201.12L146.692 201.078L146.735 201.12H146.819H146.777L146.819 201.162V201.078H146.86V201.12H146.944V201.162V201.12L147.029 201.162L146.986 201.204L147.029 201.247L147.071 201.33H147.155H147.197H147.239L147.282 201.289V201.33L147.492 201.456L147.535 201.541L147.492 201.625V201.667L147.535 201.625V201.667L147.577 201.709L147.66 201.751L147.702 201.794L147.744 201.751L147.786 201.794V201.751H147.702V201.709H147.744V201.667L147.702 201.625L147.744 201.583V201.541L147.702 201.456H147.786V201.372L147.913 201.289L148.039 201.247L148.124 201.204L148.208 201.247V201.162V201.12L148.333 201.162V201.247L148.377 201.33L148.418 201.289H148.46L148.502 201.33H148.586V201.372L148.629 201.414L148.671 201.372L148.713 201.33L148.755 201.289L148.797 201.204L148.755 201.162V201.204H148.713L148.671 201.162H148.629L148.671 201.12L148.713 201.078L148.755 201.12L148.839 201.078L148.881 201.12L148.839 201.247V201.289L148.924 201.204L149.008 201.33L149.049 201.247L149.091 201.289L149.218 201.204L149.26 201.078L149.302 201.204V201.247V201.204L149.344 201.162H149.386H149.428L149.513 201.12H149.555H149.597L149.724 201.204L149.766 201.162L149.724 201.078V201.036H149.808V200.994L149.933 201.036L149.975 201.078V201.204L149.933 201.289L150.102 201.12L150.018 201.078L150.06 201.036L150.144 200.994L150.186 201.036L150.144 201.078L150.186 201.12L150.313 201.078L150.355 201.12L150.397 201.162L150.439 201.12L150.607 201.162L150.566 201.204L150.607 201.247L150.649 201.289H150.691L150.733 201.33H150.775V201.247L150.818 201.289V201.372L150.733 201.414H150.775L150.818 201.372V201.456L150.86 201.541H150.902L150.944 201.498L150.986 201.625L151.07 201.667V201.625L151.113 201.583L151.155 201.709H151.197V201.625H151.155V201.583H151.197L151.238 201.667L151.322 201.709V201.836H151.407H151.491L151.407 201.92L151.449 202.003H151.491L151.575 201.92L151.66 201.962L151.702 202.045H151.786L151.702 202.13H151.744L151.786 202.172L151.828 202.13L151.87 202.172V202.13H151.911V202.172H151.955V202.214V202.256L152.038 202.214V202.13H152.08V202.214L152.038 202.256L152.122 202.298H152.164V202.256V202.298H152.207L152.249 202.383V202.341H152.291H152.333V202.383H152.375V202.298L152.459 202.425L152.544 202.467L152.586 202.383H152.544H152.586H152.628H152.669L152.628 202.341V202.298H152.669L152.711 202.383V202.341L152.755 202.383L152.796 202.341L152.838 202.383V202.341H152.88L152.922 202.298V202.256V202.298L152.88 202.214H152.922L152.964 202.172H152.922L152.964 202.13V202.089L153.006 202.13L153.091 202.045L153.133 201.962H153.217H153.259V202.045L153.302 202.003H153.344L153.386 201.962V202.003V201.92L153.469 201.962L153.511 201.878V201.92L153.553 201.962V201.92H153.596H153.68V201.878H153.722V201.836H153.764L153.722 201.794L153.764 201.836V201.794H153.806V201.751H153.849L153.891 201.709L154.017 201.625H154.059H154.1V201.667L154.144 201.625L154.1 201.583H154.186V201.541H154.144H154.186L154.144 201.498V201.456L154.186 201.414H154.227L154.269 201.456V201.414L154.311 201.456V201.414L154.353 201.372H154.311H154.396V201.33V201.289V201.247L154.48 201.204L154.522 201.162L154.48 201.12H154.522H154.564L154.648 201.078L154.691 201.036H154.775V200.994H154.858L154.9 200.951H154.944L154.985 200.994H155.027L155.069 201.036V200.994H155.111V201.036L155.153 200.951H155.195H155.153L155.195 200.909L155.28 200.951L155.322 200.909L155.364 200.994H155.406V200.951H155.49L155.533 200.909V200.994L155.616 201.078L155.658 201.036H155.7L155.742 200.951H155.785L155.827 201.036H155.869H155.953V200.994H155.995L156.038 200.951H156.08V200.909L156.122 200.867L156.164 200.825H156.206V200.867H156.248H156.289L156.206 200.825H157.089H157.764H157.974V200.783H158.016H158.058V200.741L158.184 200.656L158.226 200.699L158.269 200.741V200.783H158.311V200.825H158.353H158.395V200.783L158.437 200.825L158.478 200.783V200.909L158.395 201.289L158.437 201.372L158.478 201.414V201.709L158.564 202.003H158.647H158.689H158.858L158.9 201.962L158.942 202.003L158.9 202.214L158.984 202.341L159.068 202.383V202.341L159.111 202.298V202.341L159.068 202.425L159.026 202.467L158.858 202.761L158.731 203.014L158.689 203.225L158.522 203.519L158.478 203.687V203.814L158.353 203.982L158.269 204.192L158.142 204.445L158.1 204.572L158.058 204.614L157.974 204.867L157.931 205.203V205.329L157.974 205.414L157.931 205.54L157.974 205.75L158.016 205.792L158.058 205.834L158.142 205.876V205.792L158.226 205.834L158.269 205.919L158.311 205.961H158.437L158.478 205.876V205.919H158.564L158.522 206.003H158.564H158.522L158.478 206.045L158.437 206.214H158.311L158.269 206.256L158.226 206.508L158.184 206.676L158.226 206.761L158.184 206.803L158.269 206.887L158.311 206.845L158.269 206.929V207.056H158.311L158.269 207.098L158.311 207.139H158.269L158.226 207.181L158.311 207.308L158.395 207.35H158.437V207.308L158.478 207.265L158.522 207.308V207.265H158.564V207.308L158.605 207.392H158.647L158.605 207.434L158.647 207.476H158.605V207.56L158.564 207.603L158.522 207.729L158.478 207.771L158.522 207.856H158.478V207.897L158.437 207.939V207.897H158.395V207.981L158.437 208.108L158.564 208.234L158.647 208.318H158.731H158.773L158.858 208.276V208.234L158.9 208.15V208.108L158.942 208.065L158.984 208.108L159.026 208.023L159.068 208.065L158.984 208.15L159.068 208.276H159.153H159.195V208.234V208.192L159.236 208.276L159.278 208.234L159.236 208.318H159.195L159.153 208.36L159.111 208.403L159.068 208.487L159.111 208.612H159.153H159.236L159.195 208.654H159.153L159.111 208.697H159.068L158.984 208.739V208.697L159.068 208.654V208.612L158.984 208.529L158.9 208.487L158.773 208.529L158.731 208.57L158.647 208.612L158.564 208.697V208.654L158.478 208.739H158.437H158.395V208.907L158.353 208.95V209.076L158.437 209.245L158.478 209.328L158.564 209.37V209.328H158.605L158.647 209.287H158.689V209.328H158.731V209.287H158.773L158.816 209.245V209.412L158.858 209.454H158.942L158.9 209.497V209.539H158.858V209.581V209.623L158.9 209.707L158.858 209.792V209.749L158.816 209.707V209.665H158.773H158.731L158.689 209.834V209.876L158.731 209.918H158.647V209.96H158.689L158.647 210.045H158.605L158.564 210.086H158.522L158.478 210.045H158.437L158.311 210.086L158.269 210.17L158.226 210.254V210.381L158.184 210.423L158.269 210.634V210.718L158.395 210.801L158.353 210.886L158.437 210.97L158.605 211.012V211.054L158.647 211.139L158.605 211.181H158.647L158.605 211.223L158.564 211.265H158.522H158.478V211.181H158.437H158.353L158.269 211.223H158.311L158.269 211.307V211.392L158.226 211.434L158.184 211.392V211.434L158.226 211.476L158.311 211.517L158.437 211.559V211.643V211.686L158.478 211.77V211.854L158.437 211.938L158.478 212.023L158.522 212.107L158.478 212.19V212.234L158.437 212.275L158.522 212.359L158.478 212.485L158.564 212.57L158.605 212.738L158.564 212.781V212.738H158.522L158.478 212.781L158.437 212.865L158.478 212.948L158.522 212.99V212.948H158.605V213.032L158.564 213.117H158.522L158.478 213.201L158.353 213.285V213.37L158.311 213.412V213.454L158.353 213.496L158.311 213.538L158.269 213.665V213.79L158.353 213.875L158.395 213.832L158.478 213.917L158.437 213.959V213.917L158.395 213.959V214.043V214.127H158.353L158.311 214.212L158.269 214.254V214.296L158.226 214.379V214.421H158.269H158.226V214.464H158.269V214.506H158.226L158.184 214.548V214.59H158.226L158.184 214.632L158.142 214.674V214.717L158.058 214.885V214.927H158.1V214.97L158.058 215.012V215.054V215.096V215.179L158.142 215.221V215.179L158.184 215.221L157.974 215.348L157.805 215.643L157.764 215.812L157.805 215.854H157.847L157.805 215.895L157.679 216.063L157.595 216.19L157.553 216.359V216.401H157.595L157.553 216.443L157.469 216.568L157.427 216.695V216.863H157.553V216.906L157.595 216.948H157.553L157.469 217.032V217.074H157.511L157.469 217.158L157.384 217.201L157.3 217.285L157.342 217.326L157.3 217.368H157.258L157.131 217.453V217.537L157.174 217.579L157.089 217.621L157.047 217.579L157.006 217.621H156.964L156.88 217.663L156.542 217.79L155.995 218.084L155.49 218.421L154.817 218.843L154.186 219.347L154.017 219.515L153.933 219.557L153.638 219.81L153.344 220.105L152.838 220.652L152.796 220.694L151.997 221.621L151.575 222.21H151.449H151.407H151.364V222.168L151.449 222.126H151.407V222.083V222.126L151.364 222.083V222.041L151.322 221.999L151.238 222.041H151.197L151.07 221.957H151.028H150.944V221.915L150.902 221.957V221.915L150.86 221.873H150.818H150.775H150.733V221.83L150.775 221.788L150.691 221.746V221.704H150.733L150.691 221.663H150.649V221.621L150.607 221.536H150.522L150.397 221.494L150.313 221.452H150.228L150.186 221.41H150.144H150.102V221.368H150.018L149.975 221.41L149.933 221.494L149.849 221.536L149.766 221.579L149.724 221.536L149.555 221.621L149.513 221.663H149.386V221.704H149.344L149.218 221.746H149.133H149.091H149.049L149.091 221.915H149.133L149.218 221.999L149.302 222.083H149.386L149.555 222.335L149.471 222.294H149.386L149.428 222.252V222.21H149.302L149.344 222.168H149.302H149.26V222.126L149.218 222.083H149.133L149.091 222.041H149.133L149.049 221.999V221.957H149.008V221.915L148.966 221.957V222.041H148.924V221.999L148.881 221.957V221.915H148.839L148.881 221.873V221.746H148.924H148.839V221.704H148.797H148.755L148.881 221.621H148.924L148.881 221.579H148.839L148.881 221.536H148.839L148.966 221.494V221.452L148.924 221.41H148.839L148.924 221.326V221.368H149.008L148.966 221.41H149.049V221.452H149.175L149.133 221.536H149.091V221.579V221.621L149.218 221.536L149.175 221.621L149.26 221.579L149.218 221.536L149.26 221.494L149.218 221.536V221.41V221.368H149.26H149.218V221.284H149.175V221.241V221.199V221.157L149.26 221.115H149.344H149.302V221.157L149.218 221.199V221.241H149.302H149.26L149.302 221.284V221.326L149.386 221.241V221.326L149.428 221.284H149.471H149.513L149.555 221.241L149.597 221.284H149.681L149.639 221.241L149.597 221.199L149.639 221.157V221.115H149.724V221.073V220.988L149.681 220.946H149.808H149.849V220.988L149.891 220.946L149.849 220.863H149.891H149.975H150.018H149.975V220.779L150.018 220.736H149.975V220.652H150.06V220.61L150.018 220.568H150.06H150.102L150.06 220.526H150.144V220.484H150.102L150.06 220.526H150.018H149.975L149.849 220.568V220.61V220.568H149.724L150.018 220.441V220.399L150.06 220.357V220.315H150.102V220.273H150.144V220.232H150.102L149.975 220.273L150.06 220.19V220.105L150.102 220.063L150.144 220.105V220.021V219.979L150.186 220.021L150.27 219.979L150.186 219.937L150.144 219.894L150.06 219.852V219.726H150.102V219.641H150.144H150.018L149.975 219.599L150.06 219.557L150.018 219.515L150.102 219.474V219.432V219.39H150.144V219.347H150.186V219.305H150.228H150.144L150.102 219.347V219.263L149.975 219.305L150.018 219.263L150.06 219.221V219.179H150.102V219.137L150.018 219.179L150.06 219.01H150.018V218.968V218.843L150.102 218.884V218.799H150.06V218.757V218.716H150.018L150.06 218.674V218.632V218.59L150.102 218.548V218.59V218.548L150.186 218.59L150.228 218.548V218.505H150.27L150.186 218.463V218.379L150.228 218.295H150.313L150.355 218.252V218.295L150.397 218.337H150.439L150.48 218.295L150.522 218.337L150.439 218.463H150.48V218.505L150.566 218.463L150.522 218.421L150.566 218.337V218.252V218.21H150.649H150.607H150.733V218.295H150.775V218.252V218.21L150.818 218.168H150.902L150.86 218.126H150.818V218.043H150.775V218.001H150.818L150.86 217.957L150.944 217.916H150.902L150.944 217.874L150.902 217.832L150.944 217.79L150.986 217.748L151.028 217.663H151.07L151.113 217.621V217.705L151.155 217.748H151.197L151.28 217.663V217.748L151.449 217.705H151.533H151.575V217.748H151.617L151.66 217.705L151.702 217.663L151.66 217.579H151.575V217.495V217.453V217.41V217.368L151.533 217.41L151.491 217.368L151.449 217.243L151.364 217.201H151.322L151.364 217.116L151.449 217.032L151.364 216.948L151.407 216.906H151.364V216.863L151.238 216.906L151.197 216.863L151.238 216.821V216.653H151.197V216.695L151.113 216.737H151.155L151.113 216.821L151.155 216.863L151.113 216.906L151.07 216.863L151.028 216.821H150.986L150.944 216.695H150.902V216.779L150.944 216.821L150.86 216.779L150.775 216.906L150.733 216.863L150.775 216.821H150.607V216.779V216.737V216.653L150.522 216.61L150.649 216.568H150.691H150.649L150.566 216.527L150.522 216.568L150.439 216.527V216.568L150.48 216.653H150.439L150.397 216.695H150.355L150.228 216.61H150.186L150.144 216.653L150.186 216.695L150.228 216.737L150.144 216.779L150.102 216.695L150.06 216.61H150.018H149.975L149.933 216.527H149.891L149.849 216.568V216.61L149.766 216.653L149.681 216.61L149.639 216.653L149.597 216.737L149.555 216.779H149.386H149.344L149.26 216.737L149.175 216.821L149.091 216.737H149.008V216.695L149.049 216.61L149.091 216.568V216.527L149.008 216.485V216.443L148.966 216.485V216.527L148.881 216.568L148.839 216.653H148.797L148.881 216.779L148.924 216.863L148.797 216.906L148.755 216.863V216.737L148.671 216.61H148.629H148.586L148.544 216.568H148.502L148.418 216.653L148.377 216.695L148.333 216.653L148.25 216.485V216.443L148.124 216.527L148.166 216.568H148.208V216.61L148.081 216.653L147.997 216.61H147.955V216.568L147.913 216.527L147.829 216.485H147.744L147.702 216.527H147.66L147.702 216.653H147.66L147.619 216.695V216.61V216.443L147.577 216.401H147.535L147.492 216.443L147.45 216.568H147.408H147.366L147.324 216.485H147.155H147.071L147.029 216.443L146.944 216.359H146.86H146.692L146.566 216.316H146.524H146.482V216.443H146.44H146.397L146.355 216.401L146.271 216.359L146.188 216.232L146.102 216.148H146.061L145.977 216.232H145.893L145.85 216.148L145.893 216.063L145.766 215.937L145.64 215.895L145.682 215.768L145.597 215.643L145.555 215.601L145.471 215.559V215.432H145.43H145.346L145.135 215.306H145.093V215.179V215.054L145.051 215.012V214.97L145.008 214.927L144.966 215.012L144.882 214.97V214.927L144.924 214.843L144.882 214.717L144.924 214.632H144.882V214.59L144.713 214.632V214.59L144.63 214.464H144.588L144.461 214.59H144.419H144.377L144.335 214.548L144.377 214.421L144.335 214.338L144.293 214.296L144.166 214.254L144.208 214.212L144.293 214.17L144.335 214.085V214.001V213.959V213.917L144.251 213.832L144.04 213.79L144.082 213.748L143.999 213.665L144.04 213.579L143.999 213.538H143.913L143.746 213.454L143.704 213.37L143.661 213.328L143.619 213.37L143.577 213.496H143.493V213.454L143.451 213.412V213.37V213.243L143.324 213.159L143.241 213.075V212.99V212.907V212.865H143.114L143.072 212.823L143.114 212.696L143.072 212.654L142.988 212.612H142.946L142.819 212.654H142.777V212.612L142.735 212.485V212.443H142.609L142.482 212.359L142.399 212.275H142.272L142.188 212.234L142.146 212.275L142.104 212.317L142.062 212.275L142.019 212.19L141.893 212.107V212.023L141.851 211.938L141.768 211.981L141.641 211.938V211.854L141.683 211.812L141.641 211.77V211.686V211.643H141.599L141.515 211.601L141.388 211.686L141.304 211.601L141.22 211.559L141.262 211.392V211.349L141.177 211.307L141.093 211.349L141.052 211.392L141.01 211.434L140.968 211.517H140.883V211.476V211.392L140.757 211.265V211.223H140.715L140.673 211.181L140.63 211.139V210.97H140.588L140.546 210.886H140.42L140.252 210.928L140.168 210.886V210.928H140.126V210.97L140.083 211.054H140.041L139.999 211.012L139.957 210.928L139.999 210.759V210.718V210.676H139.957H139.873L139.788 210.801H139.704L139.662 210.759L139.746 210.507H139.704V210.465H139.662H139.579V210.592L139.535 210.634H139.494H139.452H139.41L139.368 210.549L139.41 210.465V210.423L139.326 210.381H139.241L139.199 210.423L139.157 210.549L139.115 210.592H139.073L138.988 210.507L138.904 210.465V210.423L138.694 210.465H138.61V210.549L138.694 210.634V210.676V210.718H138.652H138.61L138.484 210.592L138.399 210.634L138.315 210.676L138.273 210.634L138.357 210.423V210.381H138.273H138.146V210.423L138.104 210.465L138.146 210.592V210.634H138.063L137.979 210.507V210.297L137.937 210.254H137.894L137.81 210.297L137.726 210.339H137.642L137.599 210.297L137.768 210.17V210.128V210.086L137.642 209.96H137.515H137.432L137.346 209.918V209.876V209.834H137.39H137.432H137.642H137.684V209.749L137.599 209.707H137.473L137.39 209.749L137.346 209.707L137.263 209.665V209.623L137.221 209.581L137.305 209.539V209.454H137.263L137.137 209.539H137.094H137.052L136.926 209.497L136.842 209.539H136.757L136.715 209.497V209.412V209.328V209.287L136.632 209.245L136.59 209.287H136.505L136.421 209.328H136.379H136.337L136.379 209.118L136.337 209.076H136.295L136.252 209.118L136.168 209.203L136.126 209.328L136.084 209.412L136.042 209.454H135.999V209.412H135.957L135.874 209.287H135.832L135.663 209.245V209.203L135.748 209.118L135.874 209.076L135.915 209.034L135.79 208.95L135.748 208.992H135.663H135.537H135.495V209.034V209.118L135.537 209.203L135.579 209.287L135.537 209.328V209.37H135.495L135.41 209.287L135.326 209.245L135.243 209.16H135.201L135.116 209.245L135.032 209.287L134.99 209.16L135.032 208.992H134.99V208.95H134.948H134.905V208.992L134.948 209.16L134.905 209.203H134.863L134.821 209.16L134.779 209.118L134.653 208.992V208.907V208.865L134.695 208.739V208.697H134.653H134.61L134.401 208.823V208.865V208.907V208.992V209.034H134.274L134.063 208.992L133.979 208.865L133.895 208.907H133.853H133.726L133.685 208.95L133.559 208.992L133.516 209.034H133.474L133.39 208.992L133.306 208.865H133.264H133.221L133.179 208.907V209.034L133.095 209.118H133.054L133.012 209.076V209.034L132.97 208.907L132.927 208.823H132.885L132.843 208.865L132.759 208.95L132.717 208.992V208.95L132.632 208.907V208.865L132.674 208.739V208.697H132.632V208.654H132.59H132.506L132.464 208.612H132.421H132.337H132.296L132.212 208.654H132.17H132.127V208.612V208.445L132.085 208.403H132.043L131.875 208.487V208.529L131.79 208.57L131.664 208.612H131.623L131.579 208.57V208.403L131.454 208.36H131.412L131.37 208.487V208.697L131.328 208.739L131.243 208.697L131.201 208.654H131.159V208.529L131.201 208.487L131.285 208.36V208.276H131.243L131.201 208.192H131.159L130.99 208.318H130.948L130.906 208.276V208.15L131.032 207.981L131.075 207.897L131.032 207.856H130.99H130.865H130.823L130.696 207.981V208.023V208.065L130.738 208.192V208.234V208.318L130.485 208.403L130.359 208.445H130.317V208.403L130.234 208.234L130.19 208.192L130.148 208.234H130.107V208.276L130.065 208.487L130.023 208.529H129.938L129.728 208.403H129.686L129.601 208.445L129.348 208.57L129.265 208.697H129.223H129.181V208.654V208.612V208.57L129.307 208.36L129.348 208.276V208.234V208.192V208.15H129.307L129.265 208.108V208.065H129.139H129.096H129.054H129.012L128.97 208.023L128.928 207.939L128.886 207.897L128.843 207.939H128.801L128.717 208.023L128.676 208.15L128.634 208.234L128.339 208.318L128.254 208.276L128.212 208.192H128.128H128.086H128.045V208.276V208.318V208.36L128.128 208.445V208.487V208.57V208.612H128.045H128.001L127.918 208.57L127.792 208.445H127.75H127.665L127.497 208.529H127.454H127.37H127.328L127.245 208.739H127.201L127.159 208.697V208.57V208.487L127.118 208.445V208.403L127.034 208.36H126.992H126.907L126.865 208.403L126.781 208.445L126.739 208.487H126.697L126.612 208.529H126.528L126.445 208.318L126.36 208.276L126.192 208.403L126.15 208.445H126.107H126.065L126.023 208.403ZM158.647 210.507V210.465V210.507ZM158.647 211.812V211.77H158.689L158.647 211.728V211.686V211.643V211.601L158.731 211.476L158.816 211.434L158.942 211.476L158.9 211.265L158.858 211.223L158.816 211.265L158.773 211.223V211.181L158.689 211.139V211.096L158.773 211.054L158.816 211.012L158.858 210.97L158.984 211.012V210.97L158.942 210.928L158.984 210.886L159.026 210.843L158.942 210.801L158.9 210.759L158.942 210.718L158.9 210.676L158.984 210.634V210.592L158.942 210.549L158.9 210.507L158.858 210.465H158.816V210.381L158.858 210.339H158.9V210.297H158.942V210.212H158.816L158.773 210.254L158.816 210.212L158.9 210.17L158.942 210.086L159.068 210.128H159.195L159.236 210.086L159.405 210.045L159.531 210.001V209.918L159.489 209.876L159.531 209.96L159.489 209.834V209.792L159.531 209.834L159.573 209.792L159.616 209.749V209.792V209.918H159.658L159.7 210.045L159.742 210.128L159.868 210.17L159.911 210.086L159.953 210.128V210.17L159.868 210.212V210.297V210.423L159.742 210.465L159.616 210.676L159.531 210.801V210.928V210.97V211.012L159.573 210.97H159.616L159.573 211.054V211.096L159.531 211.139L159.489 211.223V211.265H159.447L159.405 211.307V211.349L159.278 211.476L159.236 211.559L159.195 211.728L159.068 211.896V211.938L159.026 212.023V212.107H159.068V212.149H159.111H159.153V212.19H159.236V212.234H159.195L159.153 212.275V212.317H159.195L159.153 212.359L159.068 212.401L159.026 212.359V212.317H158.984L158.9 212.359L158.858 212.401L158.816 212.57V212.612L158.689 212.696V212.654H158.647L158.689 212.57L158.731 212.528L158.647 212.443L158.689 212.401L158.647 212.359L158.605 212.317V212.234L158.564 212.19H158.647L158.689 212.107L158.731 212.065L158.689 211.896L158.773 211.77H158.731H158.689V211.812H158.647Z"
							stroke="white" stroke-width="0.509294" />
						<path class="hover:!opacity-50 transition-all duration-300" data-es="PB" @mouseenter="e => hoverES(e, 'PB')"
							@mouseleave="hoverLeave" fill-rule="evenodd" clip-rule="evenodd"
							d="M219.433 78.8777L219.475 78.8358L219.643 78.7939V78.7507H219.685H219.77V78.6669H219.854L219.938 78.625L219.98 78.5831V78.5412L220.023 78.4994V78.4562L219.98 78.4143L220.065 78.3305L220.107 78.2886L220.149 78.2467L220.233 78.2035V78.1616L220.191 78.1197H220.274L220.36 78.1616V78.0778L220.274 78.0359L220.233 77.9508H220.149V77.9089V77.867L220.107 77.8251V77.7413L220.065 77.6994L220.023 77.5724V77.5305L220.065 77.4049H220.107H220.065L220.149 77.3617L220.191 77.3198V77.236L220.107 77.1941V77.109L220.149 77.0671L220.191 77.0252L220.274 76.9414V76.8576L220.191 76.7725L220.274 76.7306V76.6887L220.318 76.6468V76.6049L220.401 76.4779L220.36 76.436L220.401 76.3522L220.485 76.2672L220.654 76.0996V75.9726L220.738 75.9307V75.8888V75.8469L220.949 75.678H220.991L220.907 75.5942L220.822 75.6361H220.78H220.612H220.569V75.5942H220.527H220.485L220.443 75.5523H220.485L220.527 75.5104V75.4672H220.612V75.3834H220.654L220.696 75.3415H220.822L220.78 75.2996L220.822 75.2577H220.865L220.949 75.2996H220.991L221.032 75.3415L221.118 75.2577H221.159L221.243 75.2159L221.327 75.1727L221.243 75.2996L221.159 75.4253L221.201 75.5104L221.159 75.6361L221.285 75.5942H221.369L221.412 75.6361L221.538 75.7199L221.664 75.678H221.707L221.749 75.7199L221.791 75.7631L221.832 75.8469L221.874 75.8888V75.9726H221.916L221.959 76.0158H222.001H222.043H222.085H222.127L222.212 76.0996L222.254 76.1834H222.38V76.3104L222.59 76.1834H222.632L222.716 76.1415L222.758 76.1834H222.927L223.011 76.2672H223.18L223.263 76.2253L223.348 76.3941H223.432H223.474L223.558 76.3104L223.601 76.2253L223.685 76.1834L223.727 76.0577L223.769 76.0158H223.811V75.9726H223.853V75.8888H223.896V75.9726L223.98 76.0158L223.938 76.0996H223.98H224.021L224.063 76.0577H224.105L224.063 75.9307L224.148 75.8469L224.105 75.805H224.316L224.358 75.7631L224.4 75.678L224.443 75.6361V75.678L224.527 75.7631H224.611L224.696 75.7199L224.779 75.6361H224.863L224.905 75.5942L224.863 75.5523V75.3834L225.032 75.4672L225.074 75.4253L225.158 75.3834V75.3415L225.2 75.2577L225.158 75.2159L225.2 75.1308L225.285 75.0889H225.327L225.285 75.047L225.369 74.9213H225.452H225.579H225.705H225.663L225.621 74.8362V74.7524L225.663 74.7105L225.579 74.6254L225.663 74.5835L225.579 74.5416L225.663 74.4578H225.705V74.3727L225.747 74.3308L225.958 74.2051H226L226.042 74.247L226.169 74.2889H226.379L226.421 74.2051H226.547H226.674L226.758 74.1214L226.841 74.0782L226.927 74.1214H227.052V74.0363H227.136H227.263V73.9944H227.347L227.389 74.0363L227.558 73.9944V73.8268L227.599 73.7836H227.726H227.852H227.936L228.021 73.616H228.063H228.189L228.316 73.489L228.483 73.4471L228.525 73.4052L228.61 73.4471H228.694L228.736 73.3633L228.778 73.2795L228.821 73.2363H228.863L228.947 73.2795L228.989 73.3633L229.116 73.3214L229.199 73.3633H229.325L229.283 73.4052L229.325 73.616V73.6998L229.367 73.7836L229.283 73.9944L229.367 74.0363H229.41L229.367 74.1632L229.325 74.2051L229.199 74.247V74.3308L229.116 74.3727L228.989 74.4159L228.947 74.4578H228.905L228.821 74.5416L228.694 74.6686V74.8781H228.61L228.483 74.8362L228.399 74.8781L228.358 75.0051L228.316 75.047L228.147 75.1308H228.105L228.063 75.2577V75.4253L227.978 75.5104V75.5523V75.5942L227.936 75.6361V75.7199L227.978 75.805L228.021 75.8469L227.978 75.9726L227.936 76.3522L227.81 76.4779H227.683H227.641H227.516H227.474L227.389 76.6049V76.6468L227.431 76.6887L227.389 76.8576V76.9414H227.431V77.0252V77.1941L227.474 77.2779L227.431 77.3617L227.474 77.4049L227.389 77.6143L227.852 77.5305H227.936L228.274 77.5724L228.441 77.4886L228.61 77.5305L228.568 77.6143L228.652 77.6994L228.736 77.7413V77.9089L228.694 77.994L228.778 78.0778V78.1197L228.821 78.1616V78.2467L228.947 78.3305H229.199L229.452 78.1616L229.578 77.994H229.62L229.915 77.9089L229.999 77.867L230.125 77.8251L230.167 77.7832L230.378 77.6143H230.461L230.505 77.6994L230.547 77.8251V77.9089L230.588 77.994V78.0359H230.672L230.63 78.0778V78.1197L230.757 77.994L230.925 77.9089H230.967L231.178 77.8251L231.388 77.7413L231.809 78.1197V78.4562L232.061 78.4143L231.977 78.7088L231.894 78.8358V78.9196L231.852 79.0453L231.977 79.2561L232.146 79.3412H232.188L232.314 79.0034H232.525L232.65 79.0453H232.777H232.819L233.072 78.6669V78.625L233.03 78.5412L233.072 78.4994L233.114 78.4562H233.199L233.283 78.3724L233.408 78.3305L233.45 78.2886L233.494 78.0359L233.45 77.9089L233.408 77.867L233.367 77.8251H233.325V77.7832H233.283L233.199 77.7413L233.114 77.6143L233.199 77.5305L233.241 77.236L233.367 76.9833L233.325 76.8995L233.408 76.8576L233.45 76.8995L233.661 76.9833L233.745 77.109L233.788 77.0671L233.872 77.109V77.0671L233.83 76.8995V76.6468L233.788 76.6049H233.745L233.661 76.5617L233.619 76.5198L233.577 76.3941L233.494 76.3522L233.367 76.2672H233.325V76.1415L233.283 76.0158V75.9307L233.325 75.8469L233.45 75.6361V75.5523L233.494 75.3415L233.745 75.3834H233.914L234.125 74.9632L234.335 75.047L234.461 75.0051L234.672 74.8781L234.756 74.9632L234.839 75.047V75.0889V75.2996L234.756 75.4253V75.4672V75.5104V75.5942H234.798L234.925 75.6361L235.008 75.678L235.05 75.8888L235.219 75.8469H235.261H235.514L235.683 75.805H235.766H235.808H235.892L235.934 75.7631H235.977L236.061 75.7199L236.103 75.678H236.145V75.7199H236.187V75.678L236.272 75.8469L236.355 75.9307L236.524 75.9726V76.0577V76.0996L236.566 76.1415L236.734 76.1834H236.819L236.945 76.2253L237.492 76.1834H237.955L237.997 76.1415L238.292 76.0996H238.334H238.376L238.417 76.0577L238.544 75.9307L238.628 75.9726H238.67V75.9307H238.713L238.839 75.9726L238.923 76.0158H238.965H239.05L239.134 76.0996V76.1415L239.176 76.1834H239.303V76.2253H239.344L239.386 76.1415H239.428H239.47H239.512V76.0996L239.555 76.1415H239.597H239.681L239.723 76.1834V76.1415L239.765 76.1834H239.808H239.85L239.892 76.1415H239.934L240.017 76.1834L240.059 76.1415V76.1834H240.144L240.27 76.2253H240.312L240.439 76.3104L240.523 76.3522L240.65 76.5198L240.733 76.5617H241.07L241.197 76.4779H241.365L241.406 76.3941H241.448L241.492 76.5198L241.533 76.6049H241.575L241.744 76.6468L241.828 76.6049H241.87L241.954 76.4779H242.039L242.081 76.3104H242.123L242.164 76.2672H242.206L242.375 76.436H242.417L242.543 76.3941L242.628 76.3104H242.67H242.712L242.839 76.2672L242.922 76.2253L242.964 76.1834L243.006 76.2253V76.9414V77.1522L243.091 77.3617L243.133 77.4467L243.217 77.4886L243.175 77.5305V77.6143L243.217 77.6994L243.175 77.7413L243.217 77.7832L243.175 77.9089H243.217V77.994H243.175H243.259H243.301V78.1197V78.3305L243.386 78.5412V78.625L243.512 78.7507L243.595 78.7939L243.681 78.8358L243.637 78.9196L243.595 79.0034V79.0453L243.637 79.1723L243.722 79.2561L243.681 79.298L243.595 79.3412H243.637V79.3831H243.681V79.3412H243.722V79.3831V79.4669V79.5088H243.681V79.5507H243.637V79.5088L243.595 79.4669V79.5088L243.637 79.6357H243.681L243.722 79.5507L243.806 79.4669V79.3412L243.764 79.2561H243.848V79.5088V79.6776L243.764 79.7195V79.8033L243.806 79.8884L243.848 79.9303L243.806 80.0979L243.89 80.183V80.3087L243.975 80.3925H244.059V80.4357V80.7302L244.017 80.814L243.975 80.9829L244.017 81.1505V81.2775V81.3613L244.059 81.4032L244.017 81.487L244.059 81.5721L244.017 81.7397L244.059 81.8248L244.017 81.9085L243.975 82.0342V82.4139V82.4558L244.017 82.4977L243.975 82.5396L243.933 82.5815L243.975 82.7504L243.89 82.8342L243.848 82.9611H243.806H243.764L243.681 82.9193L243.595 82.9611L243.47 82.876L243.428 82.9611H243.386V82.9193H243.343H243.301L243.259 82.876L243.217 82.8342L243.091 82.9193H243.048L242.964 82.7923L242.881 82.7085V82.6666L242.839 82.5815L242.881 82.4977V82.4139L242.754 82.3288L242.586 82.2031L242.501 82.1193L242.375 82.0342L242.333 81.9923H242.291L242.248 82.0342L242.164 82.0774L242.039 82.0342H241.997L241.87 81.9923H241.828L241.744 81.9504L241.659 81.9923H241.617L241.533 81.9504L241.365 81.9085L241.281 81.8666L241.028 81.9504L240.902 82.0774H240.859H240.817H240.775H240.692L240.733 82.1193V82.1612H240.65H240.606V82.245V82.2869H240.523H240.481L240.439 82.3288L240.27 82.4139L240.228 82.4977H240.186L240.102 82.4558L240.059 82.372H239.975L239.808 82.3288L239.681 82.372L239.639 82.5815V82.6666L239.681 82.7504L239.639 82.7923L239.597 82.8342L239.555 82.876V83.003L239.512 83.1287L239.47 83.1719V83.2138L239.512 83.2557L239.597 83.2138L239.555 83.2976V83.3395H239.512L239.47 83.4233L239.597 83.5922H239.512L239.47 83.6341L239.303 83.676L239.217 83.6341H239.134H239.092H239.008L238.965 83.676V83.7192L238.881 83.803L238.839 83.8449L238.755 83.9287H238.713H238.586H238.544H238.503L238.461 83.8868L238.376 83.9287V83.9705H238.334L238.208 84.0138H238.166V84.0556L238.123 84.0975H238.081L237.955 84.1813H237.87L237.745 84.2664H237.703H237.661L237.576 84.2232L237.45 84.2664H237.366L237.323 84.3083V84.3502V84.434L237.197 84.5178L236.987 84.4759L236.945 84.5178H236.861H236.777L236.692 84.6029H236.65L236.608 84.6867L236.566 84.6448H236.439L236.355 84.561H236.314L236.272 84.6029L236.145 84.4759L235.934 84.434L235.85 84.4759H235.808H235.683H235.472L235.345 84.5178L235.303 84.3921L235.261 84.3502L235.05 84.5178L235.008 84.561V84.6029L235.092 84.6448V84.6867L235.05 84.7705H234.966H234.925L234.798 84.6867L234.756 84.6448H234.714H234.377L234.335 84.6029L234.25 84.6448H234.125L234.041 84.6867H233.956L233.914 84.7286V84.8137V85.0232L233.872 85.065L233.914 85.1083V85.192H233.872L233.83 85.2758V85.3177H233.703L233.619 85.3609L233.577 85.3177L233.494 85.3609L233.241 85.2339L233.156 85.192L233.072 85.2339L233.03 85.2758L232.988 85.3177L233.03 85.4447L232.988 85.5285L233.03 85.5704L232.988 85.6123L232.946 85.5704L232.777 85.5285L232.736 85.6555V85.7393L232.694 85.7812V85.9501V86.2028L232.567 86.2865L232.525 86.3284V86.3703H232.567V86.4541H232.65L232.694 86.4973V86.5811L232.609 86.623L232.441 86.6649L232.314 86.7068L232.272 86.75L232.314 86.8757H232.188L232.104 86.8338V86.8757L232.146 86.9176H232.104V86.9595H231.977L231.936 87.0027L231.894 87.0865L231.852 87.1284L231.767 87.0865H231.683H231.599L231.556 87.1703L231.261 87.2973L231.136 87.381H231.01L230.967 87.4648L230.841 87.5918L230.714 87.6337V87.7175L230.672 87.7594H230.63H230.505L230.42 87.8013L230.252 87.7175L230.125 87.5486H230.083L229.83 87.5067L229.788 87.381L229.62 87.2122V87.1284V87.0446V86.9595L229.494 87.0027L229.41 86.9595L229.367 86.9176V86.8757L229.452 86.8338L229.41 86.75L229.452 86.6649H229.494V86.623L229.452 86.4973L229.494 86.4122L229.41 86.2865V86.2028L229.452 86.0758V85.992V85.9082L229.41 85.865L229.367 85.8231H229.283V85.7812H229.241L229.199 85.7393V85.6123L229.116 85.5704L229.03 85.6123V85.6974H228.947V85.6555L228.905 85.6974L228.863 85.6555H228.736L228.652 85.6974L228.568 85.6555H228.483H228.399L228.274 85.7393V85.6974H228.189L228.231 85.5704V85.5285H228.274L228.399 85.4866L228.441 85.4447H228.483V85.4028L228.441 85.3609L228.483 85.3177H228.441H228.399V85.2758H228.483V85.2339H228.61L228.863 85.065V84.9813L228.821 84.9394L228.863 84.8975L228.989 84.8556V84.7286H228.905L228.863 84.6867L228.947 84.6448L228.989 84.6029L229.03 84.6448L229.157 84.561L229.199 84.5178H229.241L229.283 84.561L229.325 84.6029V84.561L229.367 84.5178H229.41L229.452 84.434H229.41V84.3921L229.536 84.2232L229.452 84.1394V84.0138L229.367 83.9287L229.325 83.8868L229.283 83.803V83.7611L229.241 83.7192L229.157 83.6341V83.5503V83.5084V83.4665L229.241 83.4233L229.283 83.2976L229.325 83.1719L229.41 83.0868L229.536 83.003L229.62 82.876H229.747L229.83 82.7923H229.957L230.041 82.7085L230.21 82.6666V82.6247L230.336 82.5815L230.378 82.6247L230.461 82.5396V82.4977H230.42V82.4558V82.4139L230.336 82.372L230.294 82.3288L230.252 82.245L230.294 82.2031V82.1612H230.21L230.294 82.0342L230.21 81.9504L230.083 81.8666H230.041V81.9085H229.957L229.915 81.8248V81.7829L229.83 81.7397H229.705L229.62 81.6978L229.578 81.6559L229.536 81.6978L229.494 81.614H229.41H229.367L229.325 81.5302L229.283 81.4451L229.157 81.3613L229.072 81.3194L228.947 81.2343H228.821H228.778H228.652L228.61 81.3194H228.483H228.441H228.316L228.231 81.4451L228.189 81.5302L228.231 81.614L227.978 81.7397H227.852L227.81 81.7829L227.726 81.7397H227.683L227.641 81.7829L227.474 81.7397L227.347 81.7829L227.305 81.8248L227.347 81.9085V81.9923L227.305 82.0342L227.263 82.1612H227.221L227.179 82.2031V82.245L227.136 82.2869L227.094 82.3288V82.4558V82.4977L226.968 82.5396L226.841 82.5815L226.716 82.6666L226.589 82.7085V82.7923L226.547 82.8342L226.463 82.876L226.379 82.8342L226.336 82.876L226.294 82.7923L226.169 82.876V82.9611L226 83.003V83.0449V83.1287L225.916 83.1719H225.874L225.832 83.2976H225.789L225.747 83.3814L225.705 83.4233V83.4665L225.663 83.5084L225.747 83.5503L225.789 83.5922V83.676L225.705 83.7192V83.7611L225.621 83.676V83.5922H225.579V83.5084L225.537 83.4665H225.494H225.452L225.369 83.5922H225.158L225.074 83.6341L225.032 83.676L224.905 83.8449L224.821 83.8868L224.779 83.9287L224.821 83.9705L224.863 84.0138H224.821H224.738H224.652V84.1394L224.527 84.2232V84.3083L224.443 84.3502L224.4 84.3921L224.358 84.434L224.274 84.3921L224.232 84.434H224.19H224.148V84.3502L224.063 84.3083L223.938 84.2664L223.769 84.3921L223.727 84.434V84.5178V84.6029L223.769 84.6867V84.7286L223.727 84.7705L223.474 84.7286L223.432 84.6867V84.6448L223.39 84.6029L223.348 84.561L223.305 84.4759H223.263L223.18 84.434L223.096 84.5178L222.969 84.6029L222.885 84.6448L222.843 84.6867L222.801 84.7286H222.716V84.7705H222.59H222.549L222.463 84.8137L222.422 84.7705L222.338 84.6867L222.296 84.5178L222.338 84.434L222.296 84.3921L222.338 84.3502H222.212L222.296 84.2232L222.254 84.1813L222.212 84.1394L222.254 84.0556H222.212V84.0138V83.9287L222.169 83.8868L222.127 83.9287L222.085 83.8868L222.043 83.9287L221.959 83.803L221.916 83.8449L221.874 83.8868V83.9287L221.832 83.9705L221.664 84.0138L221.707 84.0556L221.664 84.1394H221.622H221.538L221.496 84.0556H221.369L221.285 84.1394H221.159L221.118 84.1813V84.2664H220.991L220.907 84.3083L220.822 84.2664L220.696 84.3083L220.654 84.2664L220.612 84.3083V84.2232L220.569 84.3083H220.485V84.2232L220.401 84.1813V84.0975L220.36 84.0138H220.318V83.8868L220.191 83.8449V83.803H220.149V83.7611L220.065 83.676H220.023L219.938 83.5084H219.854L219.812 83.4233H219.727V83.3814L219.77 83.3395V83.2138L219.812 83.1719H219.938L219.98 83.1287L220.107 83.0868V83.0449L220.149 83.003L220.107 82.9611L220.149 82.9193V82.8342L220.107 82.7923H220.191L220.149 82.7504L220.191 82.6666L220.274 82.5815L220.233 82.4977L220.191 82.4558V82.4139L220.443 82.372V82.3288L220.485 82.2869V82.245H220.569V82.1193H220.485L220.527 82.0342L220.569 81.9923L220.612 81.8666L220.696 81.7397L220.78 81.6559V81.614V81.5721V81.487L220.822 81.4451L220.865 81.3613L220.822 81.2343V81.1505H220.78L220.738 81.0667L220.78 81.0248L220.738 80.9829L220.569 81.0667L220.485 81.0248L220.443 80.9829L220.36 80.9397V80.8559L220.318 80.814L220.36 80.7302L220.318 80.6884H220.233L220.191 80.6452H220.065L219.938 80.6884V80.6033L219.98 80.5614L219.938 80.5195L219.98 80.4776V80.3087L220.023 80.2668L220.065 80.183L220.107 80.056V80.0141L220.065 79.9722L220.023 79.9303L219.98 79.8884L220.023 79.8033V79.7614L219.896 79.7195V79.6357L219.77 79.5939H219.727L219.643 79.5507L219.518 79.4669H219.475L219.433 79.425L219.475 79.3831H219.518L219.56 79.298H219.602L219.56 79.2561V79.2142H219.475L219.433 79.1304L219.518 79.0885L219.475 79.0034V78.9196L219.433 78.8777Z"
							fill="#52a8ff" stroke="white" stroke-width="0.509294" />
					</svg>
					<div
						class="tooltip-es flex  justify-center flex-col opacity-0 transition-all my-16 duration-300 max-h-[70px] min-h-[70px] p-16 shadow-md rounded-md ">
						<p><span>{* es?.sigla.trim() *} {* es?.fullName *}</span></p>
						<p>{* es?.value *}</p>
					</div>

				</div>
    
    `,
    delimiters: [
        '{*',
        '*}'
    ]
};

});

parcelRegister("lDrXI", function(module, exports) {

$parcel$export(module.exports, "participacaoOptions", function () { return $fc02ee35ed881a60$export$627bd77d5a3d86ed; });
const $fc02ee35ed881a60$export$627bd77d5a3d86ed = {
    series: [],
    chart: {
        type: "donut",
        width: '100%',
        height: 300,
        redrawOnParentResize: true,
        redrawOnWindowResize: true
    },
    noData: {
        text: 'Sem Dados',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
        }
    },
    tooltip: {
        custom: (seriesName)=>{
            const totalVal = seriesName.series.reduce((ac, val)=>{
                ac += val;
                return ac;
            });
            const innerValue = GLOBAL.FormatREAL(`${seriesName.series[seriesName.seriesIndex]}`);
            const currentValue = seriesName.series[seriesName.seriesIndex];
            const currentIndex = seriesName.seriesIndex;
            const colorsChart = seriesName.w.globals.fill.colors;
            return `<div class="p-12 bg-white">
                        <p class="flex items-center gap-4 font-semibold text-neutral-80"><span class="block w-10 h-10 rounded-full " style="background: ${colorsChart[currentIndex]}"></span> ${seriesName.w?.config?.labels[seriesName.seriesIndex]}</p>
                        <span class="text-neutral-70">${Number(currentValue / totalVal * 100).toFixed(1)}% - R$ ${innerValue}</span>
                    </div>`;
        },
        y: {
            formatter: undefined,
            title: {
                formatter: (seriesName)=>seriesName
            }
        }
    },
    dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
            //console.log(val, opts);
            return new Intl.NumberFormat('pt-br').format(opts.w.config.series[opts.seriesIndex]);
        // return new Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(opts.w.config.series[opts.seriesIndex])
        }
    },
    colors: [
        '#D2E2F3',
        '#93C7FF',
        '#83BFFF',
        '#75B5F0',
        '#74B7FF',
        '#71B5FF',
        '#6BA4D4',
        '#639DD4',
        '#59A9FF',
        '#55A7FF',
        '#52A8FF',
        '#4FA7FF',
        '#46A3FF',
        '#459EF6',
        '#2D90ED',
        '#2A94FF',
        '#2793FF',
        '#0080FF',
        '#448FD6',
        '#3482CC',
        '#3A7DB8',
        '#74B7FF',
        '#437199',
        '#186EBF',
        '#195386',
        '#164A78',
        '#164269',
        '#173C5E',
        '#153654',
        '#153047'
    ].reverse(),
    legend: {
        show: true,
        formatter: function(seriesName, opts) {
            //console.log(seriesName, opts);
            return `<div style="display:flex; align-items:center; gap: 4px">
						<span style="display: block; width: 8px; height: 8px; border-radius: 8px; background:${opts.w?.config?.colors[opts.seriesIndex]}"></span>
						<div style="width:200px; overflow:hidden;  	display:-webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;"">${seriesName}</div>
					</div>`;
        // return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex]]
        },
        markers: {
            width: 0,
            height: 0,
            strokeWidth: 0,
            strokeColor: "#fff"
        }
    },
    responsive: [
        {
            breakpoint: 480,
            options: {
                chart: {
                    type: "donut",
                    height: 550
                },
                legend: {
                    position: "bottom",
                    horizontalAlign: "left",
                    offsetY: 8,
                    formatter: function(seriesName, opts) {
                        return `<div style="width:100%; overflow:hidden;  	display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;"">${seriesName}q/div>`;
                    // return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex]]
                    }
                },
                subtitle: {
                    offsetY: 0
                }
            }
        }
    ],
    subtitle: {
        text: "PARTICIPA\xc7\xc3O POR FUNDO",
        offsetY: 0,
        style: {
            fontSize: "12px",
            fontWeight: "600",
            fontFamily: undefined,
            color: "#949799"
        }
    },
    stroke: {
        show: true,
        width: 0
    },
    donut: {
        size: "10%"
    },
    fill: {
        colors: [
            '#D2E2F3',
            '#93C7FF',
            '#83BFFF',
            '#75B5F0',
            '#74B7FF',
            '#71B5FF',
            '#6BA4D4',
            '#639DD4',
            '#59A9FF',
            '#55A7FF',
            '#52A8FF',
            '#4FA7FF',
            '#46A3FF',
            '#459EF6',
            '#2D90ED',
            '#2A94FF',
            '#2793FF',
            '#0080FF',
            '#448FD6',
            '#3482CC',
            '#3A7DB8',
            '#74B7FF',
            '#437199',
            '#186EBF',
            '#195386',
            '#164A78',
            '#164269',
            '#173C5E',
            '#153654',
            '#153047'
        ].reverse()
    },
    plotOptions: {
        pie: {
            donut: {
                size: "30%"
            }
        }
    }
};

});

parcelRegister("bX0Y4", function(module, exports) {

$parcel$export(module.exports, "captacaoSemestralOptions", function () { return $8b35f49f831a301c$export$c00b461ea310c085; });
const $8b35f49f831a301c$export$c00b461ea310c085 = {
    series: [
        {
            name: 'Ajustado',
            type: 'column',
            data: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            name: 'Total',
            type: 'column',
            data: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            name: 'Meta',
            type: 'line',
            data: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        }
    ],
    chart: {
        animations: {
            enabled: false
        },
        fontFamily: 'Roboto Flex, sans-serif',
        height: 350,
        width: '100%',
        type: 'line',
        toolbar: {
            show: false
        }
    },
    noData: {
        text: 'Sem Dados',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
        }
    },
    subtitle: {
        text: "CAPTA\xc7\xc3O DO SEMESTRAL VS META",
        offsetY: 5,
        style: {
            fontSize: '12px',
            fontWeight: '600',
            fontFamily: undefined,
            color: '#949799'
        }
    },
    responsive: [
        {
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }
    ],
    plotOptions: {
        //bar
        bar: {
            borderRadius: 6,
            colors: {}
        },
        //line
        line: {
            dataLabels: {
                enabled: false
            }
        }
    },
    fill: {
        opacity: 1
    },
    grid: {
        borderColor: '#E9ECEF',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        }
    },
    stroke: {
        width: [
            0,
            0,
            2
        ],
        curve: 'straight'
    },
    dataLabels: {
        enabled: false,
        offsetY: -12,
        style: {
            fontSize: '10px',
            colors: [
                '#E91E63'
            ]
        },
        background: {
            enabled: false
        },
        formatter: function(val, opts) {
            if (opts.seriesIndex === 1) return 'R$ ' + GLOBAL.FMoneyK(val);
            else return '';
        }
    },
    labels: [
        '01/05',
        '02/05',
        '03/05',
        '04/05',
        '05/05',
        '06/05',
        '07/05',
        '08/05',
        '09/05',
        '10/05',
        '11/05',
        '12/05'
    ],
    xaxis: {
        // type: "datetime",
        labels: {
            // format: "dd/MM",
            rotate: 0,
            //rotateAlways: true,
            style: {
                fontSize: '10px',
                fontWeight: 500
            }
        },
        crosshairs: {
            show: false
        },
        tooltip: {
            enabled: true
        }
    },
    yaxis: {
        forceNiceScale: true,
        labels: {
            formatter: (value, i)=>{
                return GLOBAL.FormatREAL(String(value));
            },
            style: {
                fontSize: '10px',
                fontWeight: 500
            }
        }
    },
    legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'right',
        offsetY: -25,
        onItemClick: {
            toggleDataSeries: true
        },
        onItemHover: {
            highlightDataSeries: true
        }
    },
    colors: [
        '#6D6F71',
        '#003769',
        '#C11F39'
    ]
};
const $8b35f49f831a301c$var$barOptions2 = {
    series: [
        {
            name: 'Previsto',
            data: [
                44,
                55,
                41,
                67,
                22,
                43
            ]
        },
        {
            name: 'Realizado',
            data: [
                13,
                23,
                20,
                8,
                13,
                27
            ]
        }
    ],
    chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
            show: false
        },
        zoom: {
            enabled: true
        }
    },
    responsive: [
        {
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }
    ],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 6,
            borderRadiusApplication: 'end',
            borderRadiusWhenStacked: 'last',
            dataLabels: {
                total: {
                    enabled: false
                }
            }
        }
    },
    colors: [
        '#6D6F71',
        '#003769'
    ],
    xaxis: {
        type: 'text',
        categories: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun'
        ]
    },
    subtitle: {
        text: "CAPTA\xc7\xc3O DO SEMESTRAL VS META",
        offsetY: 5,
        style: {
            fontSize: '12px',
            fontWeight: '600',
            fontFamily: undefined,
            color: '#949799'
        }
    },
    legend: {
        position: 'top',
        horizontalAlign: 'right',
        offsetY: -25
    },
    fill: {
        opacity: 1
    },
    grid: {
        show: true,
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        }
    }
};

});

parcelRegister("gNUk4", function(module, exports) {

$parcel$export(module.exports, "captacaoMensalOptions", function () { return $c3bce97180784e6c$export$f6b956d71192d798; });
$parcel$export(module.exports, "captacaoSemestralBarraOptions", function () { return $c3bce97180784e6c$export$d7a4b3f6bcdbd061; });
const $c3bce97180784e6c$export$f6b956d71192d798 = {
    series: [
        {
            name: '1',
            data: [
                44,
                55,
                41,
                67,
                22,
                43,
                14,
                105,
                221,
                17,
                2,
                83
            ]
        },
        {
            name: '2',
            data: [
                13,
                23,
                20,
                8,
                13,
                27,
                67,
                22,
                43,
                14,
                105,
                221
            ]
        },
        {
            name: '3',
            data: [
                13,
                23,
                20,
                8,
                13,
                27,
                67,
                22,
                43,
                14,
                105,
                221
            ]
        },
        {
            name: '4',
            data: [
                13,
                23,
                20,
                8,
                13,
                27,
                67,
                22,
                43,
                14,
                105,
                221
            ]
        },
        {
            name: '5',
            data: [
                13,
                23,
                20,
                8,
                13,
                27,
                67,
                22,
                43,
                14,
                105,
                221
            ]
        },
        {
            name: '6',
            data: [
                13,
                23,
                20,
                8,
                13,
                27,
                67,
                22,
                43,
                14,
                105,
                221
            ]
        },
        {
            name: '7',
            data: [
                13,
                23,
                20,
                8,
                13,
                27,
                67,
                22,
                43,
                14,
                105,
                221
            ]
        },
        {
            name: '8',
            data: [
                13,
                23,
                20,
                8,
                13,
                27,
                67,
                22,
                43,
                14,
                105,
                221
            ]
        }
    ],
    chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
            show: false
        },
        zoom: {
            enabled: true
        }
    },
    noData: {
        text: 'Sem Dados',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
        }
    },
    responsive: [
        {
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }
    ],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 6,
            borderRadiusApplication: 'end',
            borderRadiusWhenStacked: 'last',
            dataLabels: {
                enabled: false
            }
        }
    },
    dataLabels: {
        enabled: false
    },
    colors: [
        '#D2E2F3',
        '#93C7FF',
        '#83BFFF',
        '#75B5F0',
        '#74B7FF',
        '#71B5FF',
        '#6BA4D4',
        '#639DD4',
        '#59A9FF',
        '#55A7FF',
        '#52A8FF',
        '#4FA7FF',
        '#46A3FF',
        '#459EF6',
        '#2D90ED',
        '#2A94FF',
        '#2793FF',
        '#0080FF',
        '#448FD6',
        '#3482CC',
        '#3A7DB8',
        '#74B7FF',
        '#437199',
        '#186EBF',
        '#195386',
        '#164A78',
        '#164269',
        '#173C5E',
        '#153654',
        '#153047'
    ].reverse(),
    xaxis: {
        type: 'text',
        categories: [],
        labels: {}
    },
    yaxis: {
        forceNiceScale: true,
        labels: {
            formatter: (value, i)=>{
                return GLOBAL.FormatREAL(String(value));
            },
            style: {
                fontSize: '10px',
                fontWeight: 500
            }
        }
    },
    subtitle: {
        text: "CAPTA\xc7\xc3O SEMESTRAL POR FUNDO",
        offsetY: 5,
        style: {
            fontSize: '12px',
            fontWeight: '600',
            fontFamily: undefined,
            color: '#949799'
        }
    },
    legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        offsetY: 7
    },
    fill: {
        opacity: 1
    },
    grid: {
        show: true,
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        }
    }
};
const $c3bce97180784e6c$export$d7a4b3f6bcdbd061 = {
    chart: {
        type: 'bar',
        stacked: false,
        toolbar: {
            show: false
        }
    },
    plotOptions: {
        bar: {
            borderRadius: 6,
            dataLabels: {
                position: 'top'
            }
        }
    },
    xaxis: {
        type: 'category'
    },
    dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
            fontSize: '10px',
            colors: [
                function(params) {
                    const barraIndex = params.seriesIndex;
                    const valor = params.series[barraIndex][0];
                    return valor < 0 ? '#C11F39' : '#003769';
                }
            ]
        },
        background: {
            enabled: false
        },
        formatter: function(val) {
            return val != null ? 'R$ ' + GLOBAL.FMoneyK(val) : '';
        }
    },
    tooltip: {
        x: {
            formatter: (value)=>{
                return value;
            }
        },
        y: {
            formatter: (val)=>{
                return 'R$ ' + GLOBAL.FMoneyK(val);
            }
        }
    },
    grid: {
        borderColor: '#E9ECEF',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        }
    }
};

});

parcelRegister("ija2p", function(module, exports) {

$parcel$export(module.exports, "pleOptions", function () { return $d541c9ac93576329$export$62c7b91ee0aa401d; });
const $d541c9ac93576329$export$62c7b91ee0aa401d = {
    series: [
        {
            name: '1',
            data: [
                44,
                55,
                41,
                67,
                22,
                43,
                14,
                105,
                221,
                17,
                2,
                83
            ]
        }
    ],
    chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
            show: false
        },
        zoom: {
            enabled: true
        }
    },
    noData: {
        text: 'Sem Dados',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
        }
    },
    responsive: [
        {
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                },
                yaxis: {
                    show: false
                }
            }
        }
    ],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 6,
            borderRadiusApplication: 'end',
            borderRadiusWhenStacked: 'last',
            dataLabels: {
                total: {
                    enabled: false
                }
            }
        }
    },
    dataLabels: {
        enabled: false
    },
    colors: [
        '#4D82E9'
    ],
    xaxis: {
        type: 'text'
    },
    yaxis: {
        show: true,
        floating: false,
        labels: {
            formatter: function(val, index) {
                let value = GLOBAL.FormatREALVirgula(String(val));
                return `R$ ${value.split(',')[0]}`;
            }
        }
    },
    subtitle: {
        text: 'PLE',
        offsetY: 5,
        style: {
            fontSize: '12px',
            fontWeight: '600',
            fontFamily: undefined,
            color: '#949799'
        }
    },
    legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        offsetY: 7
    },
    fill: {
        opacity: 1
    },
    grid: {
        show: true,
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        }
    }
};

});

parcelRegister("8ZGCf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68c513de800b52f6$export$2e2bcd8739ae039; });

var $diqzg = parcelRequire("diqzg");

var $26SB8 = parcelRequire("26SB8");
parcelRequire("7h4Zs");
parcelRequire("4nzoT");

var $2m7Ys = parcelRequire("2m7Ys");
parcelRequire("94JCq");
parcelRequire("6crX0");

var $415wX = parcelRequire("415wX");
const $68c513de800b52f6$var$URL = {
    reunioes_realizadas_sai: '/atendimento/atendimento_sequoia/'
};
var $68c513de800b52f6$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $diqzg.default)
    ],
    emits: [
        'clickFundacaoAtendimentoRapido',
        'clickFundacaoNome'
    ],
    props: {
        query: {
            type: Object,
            default: ()=>({
                    user: [],
                    tem_atendimento: 'true',
                    ano_inicio: '',
                    mes_inicio_ano_inicial: '',
                    mes_fim_ano_inicial: 12,
                    ano_fim: '',
                    mes_inicio_ano_final: 1,
                    mes_fim_ano_final: ''
                }),
            required: true
        },
        az: {
            type: Number,
            default: 4,
            required: true
        }
    },
    data () {
        return {
            tableReunioesRealizadas: null,
            usuariosComReuniaoRealizadas: [],
            fundacoes_sequoia: [],
            mesesClientesSemReuniao: [],
            columns: [],
            usuarios: [],
            atendimentos_por_fundacao: []
        };
    },
    methods: {
        onClickFundacaoAtendimentRapido (id) {
            this.$emit('clickFundacaoAtendimentoRapido', {
                id: id
            });
        },
        onClickFundacaoInfo (id) {
            const atendimentosFundacao = this.atendimentos_por_fundacao.find((item)=>item.fundacao_id === Number(id));
            this.$emit('clickFundacaoNome', {
                atendimentosFundacao: atendimentosFundacao
            });
        },
        parseBrDateToDate (dateBrStr) {
            const [day, month, year] = dateBrStr.split('/');
            return new Date(`${year}-${month}-${day}T00:00:00`);
        },
        normalizeDate (date) {
            const normalized = new Date(date);
            normalized.setHours(0, 0, 0, 0);
            return normalized;
        },
        areDatesEqual (isoDateStr, brDateStr) {
            const isoDate = this.normalizeDate(new Date(isoDateStr));
            const brDate = this.normalizeDate(this.parseBrDateToDate(brDateStr));
            return isoDate.getTime() === brDate.getTime();
        },
        async init () {
            const data = await this.getDados();
            setTimeout(()=>{
                this.iniciartableReunioesRealizadas();
            }, 1000);
        },
        iniciartableReunioesRealizadas () {
            const resultado = [];
            const tabela = document.getElementById('table_gerencial_sai');
            this.tableReunioesRealizadas = this.iniciarTabelaGenerica(this.columns, `${window.origin}${$68c513de800b52f6$var$URL.reunioes_realizadas_sai}`, (data)=>{
                const { meses_clientes_sem_reuniao: meses_clientes_sem_reuniao, meses_clientes_sem_reuniao_ano_atual: meses_clientes_sem_reuniao_ano_atual, results: results } = data;
                this.mesesClientesSemReuniao = [
                    ...meses_clientes_sem_reuniao,
                    ...meses_clientes_sem_reuniao_ano_atual
                ];
                this.atendimentos_por_fundacao = data.atendimentos_por_fundacao || [];
                return this.formataResultsForGrid(data, resultado);
            }, (data)=>{
                const { meses_clientes_sem_reuniao: meses_clientes_sem_reuniao, meses_clientes_sem_reuniao_ano_atual: meses_clientes_sem_reuniao_ano_atual, results: results } = data;
                this.mesesClientesSemReuniao = [
                    ...meses_clientes_sem_reuniao,
                    ...meses_clientes_sem_reuniao_ano_atual
                ];
                return this.formataResultsForGrid(data, resultado);
            });
            if (this.tableReunioesRealizadas && tabela) {
                this.tableReunioesRealizadas.on('ready', ()=>{
                    this.paintMesesAtrasados();
                    document.getElementById('table_gerencial_sai').addEventListener('click', (e)=>{
                        const atendimentoId = e.target.closest('[data-atendimento-id]');
                        if (atendimentoId) {
                            const idFundacao = atendimentoId.getAttribute('data-atendimento-id');
                            this.onClickFundacaoAtendimentRapido(Number(idFundacao));
                        } else {
                            const infoId = e.target.closest('[data-info-id]');
                            if (infoId) {
                                const idFundacao = infoId.getAttribute('data-info-id');
                                this.onClickFundacaoInfo(idFundacao);
                            }
                        }
                    });
                });
                this.tableReunioesRealizadas.render(tabela);
            }
        },
        async getDados () {
            const { getAtendimentos: getAtendimentos } = (0, $415wX.default)();
            const data = await getAtendimentos();
            this.fundacoes_sequoia = data.fundacoes_sequoia;
            this.usuariosComReuniaoRealizadas = (0, $2m7Ys.uniqBy)([
                ...data.meses_filtrados_ano_final.flat(),
                ...data.meses_filtrados_ano_inicial.flat()
            ], 'fundacao_id');
            this.columns = this.buildColumns(data);
            this.mesesClientesSemReuniao = [
                ...data.meses_clientes_sem_reuniao,
                ...data.meses_clientes_sem_reuniao_ano_atual
            ];
            /* 	this.usuarios = data.todos_users.map((user) => ({
				label: user.username,
				value: user.id,
			})) */ return data;
        },
        buildQuery () {
            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = today.getMonth() + 1;
            const twoDigits = (n)=>n < 10 ? '0' + n : String(n);
            const defaults = {
                ano_inicio: String(currentYear - 1),
                ano_fim: String(currentYear),
                mes_inicio_ano_inicial: twoDigits(currentMonth),
                mes_fim_ano_inicial: '12',
                mes_inicio_ano_final: '01',
                mes_fim_ano_final: twoDigits(currentMonth),
                tem_atendimento: 'false',
                az: 4
            };
            const { user: user, tem_atendimento: tem_atendimento, ano_inicio: ano_inicio, mes_inicio_ano_inicial: mes_inicio_ano_inicial, mes_fim_ano_inicial: mes_fim_ano_inicial, ano_fim: ano_fim, mes_inicio_ano_final: mes_inicio_ano_final, mes_fim_ano_final: mes_fim_ano_final } = this.query;
            const finalParams = {
                ano_inicio: ano_inicio && ano_inicio !== '' ? ano_inicio : defaults.ano_inicio,
                ano_fim: ano_fim && ano_fim !== '' ? ano_fim : defaults.ano_fim,
                mes_inicio_ano_inicial: mes_inicio_ano_inicial && mes_inicio_ano_inicial !== '' ? twoDigits(Number(mes_inicio_ano_inicial)) : defaults.mes_inicio_ano_inicial,
                mes_fim_ano_inicial: mes_fim_ano_inicial && String(mes_fim_ano_inicial) !== '' ? twoDigits(Number(mes_fim_ano_inicial)) : defaults.mes_fim_ano_inicial,
                mes_inicio_ano_final: mes_inicio_ano_final && String(mes_inicio_ano_final) !== '' ? twoDigits(Number(mes_inicio_ano_final)) : defaults.mes_inicio_ano_final,
                mes_fim_ano_final: mes_fim_ano_final && mes_fim_ano_final !== '' ? twoDigits(Number(mes_fim_ano_final)) : defaults.mes_fim_ano_final,
                tem_atendimento: tem_atendimento && tem_atendimento !== '' ? tem_atendimento : defaults.tem_atendimento,
                az: this.az ? this.az : defaults.az
            };
            const params = new URLSearchParams();
            for (const [key, value] of Object.entries(finalParams))if (value !== '' && value != null) params.append(key, value);
            if (Array.isArray(user) && user.length > 0) params.append('user', user.join(','));
            return params.toString();
        },
        buildColumns (data) {
            const base = [
                {
                    id: 'id',
                    name: 'ID',
                    hidden: true
                },
                {
                    id: 'politica_sequoia',
                    name: 'Politica Sequoia',
                    hidden: true
                },
                {
                    id: 'nome',
                    name: "Funda\xe7\xe3os",
                    attributes: {
                        'sticky-column-1': true,
                        'sticky-header': true
                    },
                    width: '180px',
                    formatter: (cell, row)=>{
                        const id = row.cells[0].data;
                        const politicaSequoia = row.cells[1].data;
                        return (0, $26SB8.html)(`
							<div data-info-id="${id}" class="inline-flex justify-between items-center w-full" style="cursor: pointer;">
								<div  class="inline-flex items-center max-w-[180px]">
									<svg class="h-40 w-40 shrink-0" style="${GLOBAL.generateAvatarColor(politicaSequoia)}"><use xlink:href="#icon_person"></use></svg>
									<span class="one-line max-w-[180px]" title="${cell}">${cell}</span>
								</div>
								<button data-atendimento-id="${id}" href="#" 
									class="btn bg-transparent text-white hover:text-white hover:!bg-white/10 !border-transparent">
									<svg class="w-16 h-16 text-primary-pure !border-transparent">
										<use xlink:href="#icon_pencil"></use>
									</svg>
								</button>
							</div>
							`);
                    },
                    sort: {
                        compare: (a, b)=>{
                            const fundA = this.fundacoes_sequoia?.find((i)=>i.sigla === a);
                            const fundB = this.fundacoes_sequoia?.find((i)=>i.sigla === b);
                            if (fundA?.politica_sequoia && fundB?.politica_sequoia) {
                                if (fundA.politica_sequoia !== fundB.politica_sequoia) return fundA.politica_sequoia.localeCompare(fundB.politica_sequoia);
                            }
                            return parseFloat(fundB?.patrimonio || 0) - parseFloat(fundA?.patrimonio || 0);
                        }
                    }
                },
                {
                    id: 'usuario_responsavel_atendimento',
                    name: 'Officer',
                    attributes: {
                        'sticky-column-2': true,
                        'sticky-header': true,
                        center: true
                    },
                    width: '85px',
                    formatter: (cell)=>{
                        const nomesFundacoes = (0, $2m7Ys.uniqBy)(cell, 'id');
                        return (0, $26SB8.html)(`
								<div style="display:flex;flex-direction:column;gap:2px;max-width:85px;width:100%;align-items: center;">
								${nomesFundacoes.map((item)=>`<span class="">${(0, $2m7Ys.capitalize)(item.name)}</span>`).join('')}
								</div>
								`);
                    }
                }
            ];
            const meses = [
                ...data.meses_filtrados_ano_final,
                ...data.meses_filtrados_ano_inicial
            ];
            meses.forEach((item, idx)=>{
                base.push({
                    id: item.nome,
                    name: (0, $26SB8.html)(`<div style="white-space:normal;">${(0, $2m7Ys.capitalize)(item.nome.replace(/_final|_inicial/g, ''))}</div>`),
                    width: '70px',
                    formatter: (cell, row)=>this.formatMesCell(cell, row, idx + 3)
                });
            });
            return base;
        },
        formatMesCell (cell, row, colIndex) {
            const idFundacao = row.cells[0].data;
            const ultimo = row.cells.findIndex((c, index)=>index >= 4 && Array.isArray(c.data) && this.isValidDate(c.data[1]));
            const classe = this.getAtrasoClass(ultimo - 1, colIndex);
            return (0, $26SB8.html)(`
							<div class="${classe}" style="display:flex;flex-direction:column;gap:2px;">
							<span style="font-weight:600;">${cell ? cell[0] : ''}</span>
							<span>${cell ? cell[1] : ''}</span>
							</div>
							`);
        },
        isValidDate (val) {
            if (!val) return false;
            const [d, m, y] = val.split('/');
            const iso = `${y}-${m}-${d}`;
            return !isNaN(new Date(iso).getTime());
        },
        getAtrasoClass (ultimoIdx, colIdx) {
            if (colIdx >= ultimoIdx) return '';
            const diff = ultimoIdx - 3;
            if (diff >= 1 && diff <= 6) return 'atraso_entre_1_6';
            if (diff > 6) return 'atraso_maior_6';
            return '';
        },
        formataObjectsInicialFinal (lista_inicial, lista_final) {
            const objectReunioes = {
                ...Object.fromEntries(Object.entries(lista_inicial).map(([key, value])=>[
                        `${key}_inicial`,
                        value
                    ])),
                ...Object.fromEntries(Object.entries(lista_final).map(([key, value])=>[
                        `${key}_final`,
                        value
                    ]))
            };
            return objectReunioes;
        },
        // Reaproveita lógica original de formatação
        formataResultsForGrid (results, resultado = []) {
            const formatoFinal = [];
            const fundacoes = results.fundacoes_sequoia;
            const dadosReuniao = this.formataObjectsInicialFinal(results?.reunioes_ano_inicial, results?.reunioes_ano_final);
            fundacoes.forEach((itemFundacao)=>{
                const atendimentosPorCliente = [];
                let politicaFundacao = itemFundacao.politica_sequoia // ← Inicializa com o valor da fundação
                ;
                Object.entries(dadosReuniao).forEach(([mes, atendimentoMes])=>{
                    const atendimentos = atendimentoMes.filter((atendimento)=>atendimento.fundacao_id === itemFundacao.id);
                    atendimentos.forEach((atendimento)=>{
                        const { usuario_responsavel_atendimento: usuario_responsavel_atendimento, data_atendimento: data_atendimento, qtd_reunioes: qtd_reunioes, politica: politica } = atendimento;
                        atendimentosPorCliente.push({
                            usuario_responsavel_atendimento: usuario_responsavel_atendimento,
                            mes: mes,
                            data_atendimento: data_atendimento,
                            qtd_reunioes: qtd_reunioes
                        });
                    });
                });
                const resultado = [
                    itemFundacao.id,
                    politicaFundacao,
                    itemFundacao.sigla
                ];
                if (atendimentosPorCliente && atendimentosPorCliente.length > 0) {
                    const arrayOfficers = atendimentosPorCliente.map((itemAtendimento)=>itemAtendimento.usuario_responsavel_atendimento);
                    const arrayUnico = [
                        ...new Set(arrayOfficers.flat())
                    ];
                    const user = (0, $2m7Ys.uniqBy)(arrayUnico, 'id');
                    resultado.push(user);
                } else resultado.push('');
                const novoArrayInicial = results?.meses_filtrados_ano_inicial.map((item)=>({
                        ...item,
                        nome: item.nome + '_inicial'
                    }));
                const novoArrayFinal = results?.meses_filtrados_ano_final.map((item)=>({
                        ...item,
                        nome: item.nome + '_final'
                    }));
                const mesesAtendimentoTotal = [
                    ...novoArrayFinal,
                    ...novoArrayInicial
                ];
                const auxDiasReuniaoAtendimento = [];
                mesesAtendimentoTotal.forEach((item)=>{
                    const atendimentoEncontrado = atendimentosPorCliente.find((a)=>{
                        return a.mes.toLowerCase() === item.nome.toLowerCase();
                    });
                    auxDiasReuniaoAtendimento.push(atendimentoEncontrado && atendimentoEncontrado.data_atendimento ? [
                        `Qtd: ${atendimentoEncontrado.qtd_reunioes}`,
                        GLOBAL.formatDateObject(new Date(atendimentoEncontrado.data_atendimento))
                    ] : '');
                });
                formatoFinal.push([
                    ...resultado,
                    ...auxDiasReuniaoAtendimento
                ]);
            });
            const auxReunioaoMesesInicial = Object.values(results.reunioes_ano_inicial).flatMap((itemReunoiaoRealizada)=>[
                    ...itemReunoiaoRealizada
                ]);
            const auxReuniaoMesesFinal = Object.values(results.reunioes_ano_final).flatMap((itemReunoiaoRealizada)=>[
                    ...itemReunoiaoRealizada
                ]);
            this.usuariosComReuniaoRelaizadas = [
                ...auxReuniaoMesesFinal,
                ...auxReunioaoMesesInicial
            ];
            this.usuariosComReuniaoRelaizadas = (0, $2m7Ys.uniqBy)(this.usuariosComReuniaoRelaizadas, 'fundacao_id');
            return formatoFinal;
        },
        paintMesesAtrasados () {
            let timeout = 10;
            let timeCount = 0;
            const checkIdInterval = setInterval(()=>{
                timeCount++;
                const isTableRender = document.querySelector('.gridjs-td');
                if (isTableRender !== null && isTableRender.hasChildNodes()) {
                    this.$nextTick(()=>{
                        document.querySelectorAll('.gridjs-td').forEach((td)=>{
                            if (td.querySelector('.atraso_entre_1_6')) td.style.backgroundColor = 'rgba(28, 159, 105, 0.3)';
                            /* 							if (td.querySelector('.atraso_maior_4_6')) {
								td.style.backgroundColor = 'rgba(253, 212, 38, 0.3)'
							} */ if (td.querySelector('.atraso_maior_6')) td.style.backgroundColor = 'rgba(236, 53, 57, 0.3)';
                        });
                    });
                    clearInterval(checkIdInterval);
                } else if (timeCount >= timeout) clearInterval(checkIdInterval);
            }, 1500);
        }
    },
    mounted () {
        this.init();
    },
    template: `
				<div id="table_gerencial_sai">
				  
				</div>
			  `
};

});
parcelRegister("94JCq", function(module, exports) {

$parcel$export(module.exports, "reuniaoService", function () { return $69b7dfb67e46f62d$export$23089ef64489d902; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $69b7dfb67e46f62d$export$23089ef64489d902() {
    const api = (0, $c8Lpu.useApi)();
    async function fetchMeetingData(query) {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).atendimento_reuniao_sai}${query}`, {
            forceCache: true
        });
    }
    async function getAtendimentoReuniaoSai(query) {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).atendimento_reuniao_sai}`, query, {
            forceCache: true
        });
    }
    return {
        fetchMeetingData: fetchMeetingData,
        getAtendimentoReuniaoSai: getAtendimentoReuniaoSai
    };
}

});

parcelRegister("6crX0", function(module, exports) {

$parcel$export(module.exports, "MONTHS_LIST", function () { return $48398b82c2a77a55$export$8fde99d65636e869; });
const $48398b82c2a77a55$export$8fde99d65636e869 = [
    {
        id: 1,
        nome: 'Janeiro'
    },
    {
        id: 2,
        nome: 'Fevereiro'
    },
    {
        id: 3,
        nome: "Mar\xe7o"
    },
    {
        id: 4,
        nome: 'Abril'
    },
    {
        id: 5,
        nome: 'Maio'
    },
    {
        id: 6,
        nome: 'Junho'
    },
    {
        id: 7,
        nome: 'Julho'
    },
    {
        id: 8,
        nome: 'Agosto'
    },
    {
        id: 9,
        nome: 'Setembro'
    },
    {
        id: 10,
        nome: 'Outubro'
    },
    {
        id: 11,
        nome: 'Novembro'
    },
    {
        id: 12,
        nome: 'Dezembro'
    }
];
const $48398b82c2a77a55$export$6c4fd4d88949050d = {
    search: false,
    resizable: true,
    data: [],
    autoWidth: true,
    width: '100%',
    sort: false,
    style: {
        container: {
            border: 'none'
        },
        table: {
            border: 'none'
        },
        tr: {
            border: 'none'
        },
        th: {
            'border-bottom': '1px solid #e9ecef',
            padding: '8px'
        },
        td: {
            'border-bottom': '1px solid #e9ecef',
            cursor: 'pointer',
            color: '#495057',
            'font-family': 'Roboto Flex',
            'font-size': '14px',
            'font-weight': 500,
            'line-height': '150%',
            'letter-spacing': '-0.28px',
            padding: '8px'
        },
        footer: {
            border: 'none'
        }
    },
    language: {
        search: {
            placeholder: 'Busque aqui...'
        },
        pagination: {
            previous: ' Anterior',
            next: "Pr\xf3ximo "
        }
    }
};

});


parcelRegister("geOYu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd257ea27fff9f29$export$2e2bcd8739ae039; });
var $bd257ea27fff9f29$export$2e2bcd8739ae039 = {
    props: {
        isModoEditar: {
            type: Boolean,
            default: false
        },
        atendimentoDataEditar: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'clickCancelAtendimento',
        'clickEnviarAtendimento',
        'clickEditarAtendimento'
    ],
    data () {
        return {
            modelTituloAtendimento: '',
            modelTextoAtendimento: '',
            modelDataAtendimento: null
        };
    },
    methods: {
        onClickCloseModal () {
            this.$emit('clickCancelAtendimento');
            this.closeModal();
        },
        onSubmit () {
            let atendimentoData = {
                tituloAtendimento: this.modelTituloAtendimento,
                textoAtendimento: this.modelTextoAtendimento,
                dataAtendimento: this.modelDataAtendimento ? this.formatToISOString(this.modelDataAtendimento) : null
            };
            if (this.isModoEditar) {
                atendimentoData = {
                    ...atendimentoData,
                    idAtendimento: this.atendimentoDataEditar.id
                };
                this.$emit('clickEditarAtendimento', atendimentoData);
                this.clearModal();
                this.closeModal();
            } else this.$emit('clickEnviarAtendimento', atendimentoData);
            this.clearModal();
        },
        clearModal () {
            this.modelTituloAtendimento = '';
            this.modelTextoAtendimento = '';
            this.modelDataAtendimento = null;
        },
        closeModal () {
            this.clearModal();
            modal_padrao_vue.closeModal('modal_atendimento_gerencial_sai');
        },
        formatDate (date) {
            if (this[date]) {
                const [year, month, day] = this[date].split('/');
                this.modelDataAtendimento = `${day}/${month}/${year}`;
            } else this.modelDataAtendimento = '';
        },
        formatToISOString (dateStr) {
            const [day, month, year] = dateStr.split('/').map(Number);
            const date = new Date(Date.UTC(year, month - 1, day));
            return date.toISOString();
        }
    },
    watch: {
        modelDataAtendimento () {
        /* if(this.modelDataAtendimento){
				this.formatDate(this.modelDataAtendimento)
			} */ },
        isModoEditar () {
            if (this.isModoEditar && this.atendimentoDataEditar) {
                this.modelTituloAtendimento = this.atendimentoDataEditar.titulo_atendimento;
                this.modelTextoAtendimento = this.atendimentoDataEditar.descricao_atendimento;
                this.modelDataAtendimento = GLOBAL.formatDateObject(new Date(this.atendimentoDataEditar.data_atendimento));
            }
        }
    },
    mounted () {},
    template: html`
		<section
			class="modal--content rounded-md  flex-1 w-auto !overflow-[initial] relative"
			data-id="modal_atendimento_gerencial_sai"
			id="modal_atendimento_gerencial_sai">
			<header
				class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
				<h2 class="text-lg font-medium text-white">
					{{isModoEditar ? 'Edita': 'Novo'}} atendimento sequóia
				</h2>
				<button
					type="button"
					class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
					data-xclose="modal_padrao"
					@click="onClickCloseModal">
					<svg class="w-32 h-32">
						<use xlink:href="#icon_close"></use>
					</svg>
				</button>
			</header>
			<form
				class="flex flex-col gap-16 !p-20 w-full h-full"
				@submit.prevent="onSubmit">
				<div class="flex-1 flex flex-col w-full">
					<label class="label text-base">Titulo</label>
					<q-input
						v-model="modelTituloAtendimento"
						outlined
						type="text"
						name="titulo_atendimento"
						id="titulo_atendimento"
						placeholder="Titulo atendimento..."
						class="w-full" />
				</div>
				<div class="flex-1 flex flex-col w-full max-w-max">
					<label class="label text-base">Data atendimento</label>
					<q-input
						v-model="modelDataAtendimento"
						outlined
						placeholder="Data atendimento..."
						size="sm">
						<template v-slot:append>
							<q-icon name="event" class="cursor-pointer">
								<q-popup-proxy
									cover
									transition-show="scale"
									transition-hide="scale">
									<q-date v-model="modelDataAtendimento" mask="DD/MM/YYYY">
										<div class="row items-center justify-end">
											<q-btn v-close-popup label="Close" color="primary" flat />
										</div>
									</q-date>
								</q-popup-proxy>
							</q-icon>
						</template>
					</q-input>
				</div>
				<div class="flex-1 flex flex-col w-full">
					<label class="label text-base">Descrição</label>
					<q-input
						v-model="modelTextoAtendimento"
						outlined
						type="textarea"
						name="atendimento"
						placeholder="Conteudo do atendimento..."
						class="w-full"
						input-class="h-full !max-h-[100px]"></q-input>
				</div>
				<div class="absolute bottom-24 flex justify-evenly mt-8 w-full">
					<button
						type="button"
						class="btn secondary"
						:disabled="isLoading"
						@click="onClickCloseModal">
						Cancelar
					</button>
					<button type="submit" class="btn" :disabled="isLoading">
						{{isModoEditar ? 'Editar': 'Enviar'}}
					</button>
				</div>
			</form>
		</section>
	`
};

});

parcelRegister("b6Cs4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $815e14f367ade958$export$2e2bcd8739ae039; });

var $kIiuq = parcelRequire("kIiuq");
var $815e14f367ade958$export$2e2bcd8739ae039 = {
    components: {
        InfoAtendimento: $kIiuq.default
    },
    props: {
        atendimento: null
    },
    emits: [
        'clickCancelAtendimento',
        'clickEditarAtendimento'
    ],
    data () {},
    methods: {
        onClickCloseModal () {
            this.$emit('clickCancelAtendimento');
            this.closeModal();
        },
        onClickEditarAtendimento (idAtendimento) {
            this.$emit('clickEditarAtendimento', idAtendimento);
        /* this.closeModal() */ },
        closeModal () {
            modal_padrao_vue.closeModal('modal_info_gerencial_sai');
        }
    },
    computed: {
        atendimentosModalView () {
            return this.atendimento?.atendimentos?.map((item)=>{
                return {
                    id: item.id,
                    data_atendimento: item.data_atendimento,
                    titulo_atendimento: item.titulo_atendimento,
                    descricao_atendimento: item.descricao_atendimento,
                    data_criacao: item.data_criacao
                };
            });
        }
    },
    watch: {
        atendimento () {
        /* console.log(this.atendimento) */ }
    },
    template: html`
		<section
			class="modal--content rounded-md  flex-1 w-auto !overflow-[initial] relative "
			data-id="modal_info_gerencial_sai"
			id="modal_info_gerencial_sai">
			<header
				class="flex items-center justify-between w-full px-24 pt-24 pb-16 bg-primary-pure ">
				<h2 class="text-lg font-medium text-white">Atendimento sequóia</h2>
				<button
					type="button"
					class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
					data-xclose="modal_padrao"
					@click="onClickCloseModal">
					<svg class="w-32 h-32">
						<use xlink:href="#icon_close"></use>
					</svg>
				</button>
			</header>
			<div class="w-full !h-[32rem]  !bg-[#FAFAFB]">
				<div
					v-if="atendimento && atendimento?.atendimentos.length <=0"
					class="flex flex-col items-center justify-center w-full h-full gap-y-40 max-h-full pt-72">
					<q-icon name="search_off" size="6rem" class="text-neutral-100" />
					<p class="text-title-2 text-neutral-70">
						Nenhum atendimento sequóia encontrado.
					</p>
				</div>
				<div
					v-else
					class="p-16 flex flex-col gap-16 flex-1 overflow-y-auto !bg-[#FAFAFB] max-h-[38rem] 2xl:max-h-[33rem] ">
					<info-atendimento
						v-for="(atendimento,index) of atendimentosModalView"
						:atendimento="atendimento"
						:key="index"
						@click-editar-atendimento="onClickEditarAtendimento">
					</info-atendimento>
				</div>
			</div>
		</section>
	`
};

});
parcelRegister("kIiuq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1464264ca32d1b0$export$2e2bcd8739ae039; });
var $f1464264ca32d1b0$export$2e2bcd8739ae039 = {
    // 1) Declare a prop com type/default
    props: {
        atendimento: {
            type: Object,
            default: null
        }
    },
    emits: [
        'clickEditarAtendimento'
    ],
    methods: {
        formatIsoToBrDate (isoDateStr) {
            const date = new Date(isoDateStr);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        onClickEditarAtendimento () {
            if (this.atendimento && this.atendimento.id != null) this.$emit('clickEditarAtendimento', this.atendimento.id);
        }
    },
    template: html`
		<div class="info-atendimento">
			<q-expansion-item expand-separator group="info_atendimento_group">
				<template v-slot:header>
					<div class="row items-center gap-18 w-full h-full">
						<svg class="w-28 h-28">
							<use xlink:href="#icon_atendimento_menssagem"></use>
						</svg>
						<span>
							{{ atendimento?.data_atendimento ?
							formatIsoToBrDate(atendimento.data_atendimento) : '' }}
						</span>
						<div
							class="inline-block font-bold truncate max-w-[14rem] text-text-title-1">
							<span> {{ atendimento?.titulo_atendimento }} </span>

							<q-tooltip :delay="500"> {{ atendimento?.titulo_atendimento }} </q-tooltip>
						</div>

						<div class="inline-flex justify-end flex-1">
							<span
								class="mr-10 text-blue-10 cursor-pointer"
								@click="onClickEditarAtendimento">
								Editar
							</span>
						</div>
					</div>
				</template>

				<q-card>
					<q-card-section>
						<div v-html="atendimento?.descricao_atendimento" class="pl-1"></div>
					</q-card-section>
				</q-card>
			</q-expansion-item>
		</div>
	`
};

});


parcelRegister("6Bddm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ce072e52c545dff$export$2e2bcd8739ae039; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $4ce072e52c545dff$export$2e2bcd8739ae039() {
    const api = (0, $c8Lpu.useApi)();
    async function getProcessoSeletivo() {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).processo_seletivo}`);
    }
    async function createProcessoSeletivo(data) {
        return api.mutation(`${window.origin}${(0, $9YhWF.URLS).processo_seletivo}`, 'post', data);
    }
    async function deleteProcessoSeletivo(id) {
        return api.mutation(`${window.origin}${(0, $9YhWF.URLS).processo_seletivo}${id}/`, 'delete');
    }
    return {
        getProcessoSeletivo: getProcessoSeletivo,
        createProcessoSeletivo: createProcessoSeletivo,
        deleteProcessoSeletivo: deleteProcessoSeletivo,
        ...api
    };
}

});


parcelRegister("bl2p3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8413851b1f181083$export$2e2bcd8739ae039; });
parcelRequire("jbwpo");
var $4kVDe = parcelRequire("4kVDe");

var $1fBE3 = parcelRequire("1fBE3");

var $92Iq6 = parcelRequire("92Iq6");


var $5Zscv = parcelRequire("5Zscv");
parcelRequire("hFwHf");
var $kQ8rI = parcelRequire("kQ8rI");

var $amUiM = parcelRequire("amUiM");



const { api: $8413851b1f181083$var$api, errorDefault: $8413851b1f181083$var$errorDefault, getTipoPaginaAtual: $8413851b1f181083$var$getTipoPaginaAtual } = GLOBAL;
const { getAllNotifications: $8413851b1f181083$var$getAllNotifications } = (0, $92Iq6.default)();
let $8413851b1f181083$var$intervalAgendaNotificacoes = null;
const $8413851b1f181083$var$notificacoesOpcoes = {
    todas: null,
    "opera\xe7\xf5es_internas": [
        'Prospect',
        "Efetiva\xe7\xe3o de prospect",
        'Ativos sem categoria',
        "Finaliza\xe7\xe3o de Atendimento",
        "Finaliza\xe7\xe3o de Tarefa"
    ],
    atendimento: [
        'Cliente sem atendimento recente',
        "Funda\xe7\xe3o sem atendimento recente"
    ],
    alertas_financeiros: [
        "Cliente n\xe3o coberto pelo FGC",
        "Cliente com emissores n\xe3o cobertos pelo FGC",
        'Queda de rentabilidade',
        'Rentabilidade abaixo do benchmark'
    ],
    agenda_outlook: [
        'Lembrete de Evento no Outlook'
    ]
};
var $8413851b1f181083$export$2e2bcd8739ae039 = {
    props: [
        'open',
        'js-tab'
    ],
    emits: [
        'close',
        'update',
        'add-notification'
    ],
    components: {
        NotificationItem: $5Zscv.default,
        EmptyItem: $amUiM.default
    },
    // Estados reativos (ou iniciais)
    data () {
        return {
            totalNotificationsTab: 0,
            activeTabAtendimento: 'todas',
            swiperTabsFiltro: null,
            animation: null,
            notifications: {
                data: [],
                loading: false
            },
            idLastNotification: null,
            tabsNotificacao: [
                {
                    id: 'todas',
                    title: 'Todas'
                },
                {
                    id: 'atendimento',
                    title: 'Atendimento'
                },
                {
                    id: "opera\xe7\xf5es_internas",
                    title: "Opera\xe7\xf5es Internas"
                },
                {
                    id: 'alertas_financeiros',
                    title: 'Alertas Financeiros'
                },
                {
                    id: 'agenda_outlook',
                    title: 'Agenda Outlook'
                }
            ],
            queryNotification: {
                tipo_notificacao: null,
                page: 1,
                page_size: 10,
                total_items: 0,
                has_next: false
            }
        };
    },
    // metodo que observa mudanças (onchange)
    watch: {
        open () {
            if (!this.open) {
                console.log("ta fechado \uD83C\uDF43");
                this.notifications.data = this.notifications.data.map((i)=>(i.visto = true, i));
                const ids = this.notifications.data.map((i)=>i.id);
                axios.post('core/limpar_notificacoes/', ids);
                this.$emit('update', false);
                this.agendarNotification(15000);
            } else if ($8413851b1f181083$var$intervalAgendaNotificacoes) clearInterval($8413851b1f181083$var$intervalAgendaNotificacoes);
        },
        notifications () {
            if (this.notifications.data.filter((i)=>!i.visto)?.length) this.$emit('update', true);
            else this.$emit('update', false);
        }
    },
    // Métodos do componente
    methods: {
        handleClose () {
            this.activeTabAtendimento = 'todas';
            this.resetQueryNotification();
            this.$emit('close', false);
        },
        // async getLastNotification() {
        // 	const { data } = await api.get('/api/notificacao/?ultima=1')
        // 	return data[0];
        // },
        async updateStatusViewedNotifications (arr) {
            try {
                const update = await axios.put('/api/notificacao/', arr);
                this.compareStateWithLastNotification();
            } catch (err) {
                console.log(err);
            }
        },
        async fetchNotifications ({ reset: reset = false, interval: interval = false } = {}) {
            this.notifications.loading = true;
            try {
                let { tipo_notificacao: tipo_notificacao, page: page, page_size: page_size } = this.queryNotification;
                if (Array.isArray(tipo_notificacao)) tipo_notificacao = tipo_notificacao.join(',');
                const tipoPagina = GLOBAL.getTipoPaginaAtual?.();
                const tipo_cliente = tipoPagina === 'fundacao' ? 'sai' : tipoPagina === 'cliente_pf' ? 'sap' : null;
                const response = await $8413851b1f181083$var$getAllNotifications({
                    tipo_notificacao: tipo_notificacao,
                    page: page,
                    page_size: page_size,
                    tipo_cliente: tipo_cliente
                });
                if (interval && this.notifications.data !== response.results) console.log('Tem, notificacao ai ');
                this.queryNotification = response?.pagination ? {
                    page: response.pagination.page,
                    page_size: response.pagination.page_size,
                    total_items: response.pagination.total_items,
                    has_next: response.pagination.has_next,
                    tipo_notificacao: this.queryNotification.tipo_notificacao
                } : this.queryNotification;
                if (reset) this.notifications.data = response?.results || [];
                else this.notifications.data.push(...response?.results || []);
                this.$nextTick(()=>{
                    this.totalNotificationsTab = response?.count || 0;
                });
            } catch (e) {
                console.error(e);
            } finally{
                this.notifications.loading = false;
            }
        },
        async getTodasNotificacoes (interval) {
            // Mantido para compatibilidade, mas agora chama o método novo
            await this.fetchNotifications({
                reset: true,
                interval: interval
            });
        },
        async onloadMoreNotification (index, done) {
            if (!this.queryNotification.has_next) {
                if (done) done();
                return;
            }
            this.queryNotification.page += 1;
            await this.fetchNotifications({
                reset: false
            });
            if (done) done();
        },
        isNotificacaoDaPaginaAtual (notificacao) {
            const tipoPagina = $8413851b1f181083$var$getTipoPaginaAtual();
            if (notificacao.fundacao_id && tipoPagina === 'fundacao') return true;
            if (notificacao.cliente_pf_id && tipoPagina === 'cliente_pf') return true;
            if (!notificacao.fundacao_id && !notificacao.cliente_pf_id && tipoPagina === 'geral') return true;
            return false;
        },
        onEnter (el, done) {
            //Executando animação no modal
            this.initSwiperTabsFiltro();
            this.animation = gsap.timeline().set(el, {
                opacity: 0,
                translateY: -25
            }).set(document.querySelector('.background-deep'), {
                opacity: 0
            }).to(el, {
                opacity: 1,
                translateY: 0,
                duration: 0.35
            }, 'rodaJunto').to(document.querySelector('.background-deep'), {
                opacity: 1
            }, 'rodaJunto').add(()=>(0, $1fBE3.default)());
            done();
        },
        leave (el, done) {
            this.resetQueryNotification();
            this.getTodasNotificacoes();
            this.animation.timeScale(2).reverse().then((result)=>done());
        },
        async compareStateWithLastNotification () {
            const lastNotification = await this.getLastNotification();
            if (lastNotification.id !== this.$data.idLastNotification.id) {
                document.body.style.setProperty('--notificacao', '#C11F39');
                this.getTodasNotificacoes();
            }
        },
        onUpdateStateNotificationWithApi (data) {
            let pagination = {
                ...data.pagination
            };
            pagination.total_items = data?.results?.length;
            pagination.num_pages = Math.ceil(data?.results?.length / data.pagination.page_size);
            pagination.has_next = data.pagination.page < pagination.num_pages ? true : false;
            return {
                data: data?.results || [],
                pagination: {
                    ...pagination
                }
            };
        },
        agendarNotification (interval) {
            if ($8413851b1f181083$var$intervalAgendaNotificacoes) clearInterval($8413851b1f181083$var$intervalAgendaNotificacoes);
            $8413851b1f181083$var$intervalAgendaNotificacoes = setInterval(()=>{
                this.getTodasNotificacoes();
            }, interval);
        },
        onClickNotification (notification) {
            this.$emit('add-notification', notification);
            this.$emit('close', false);
        },
        async onClickTabNotificationFilter (tabId) {
            const tabName = tabId.toLowerCase();
            if (this.activeTabAtendimento.toLowerCase() === tabName) return;
            this.activeTabAtendimento = tabId;
            const abaNotificacaoSelect = Object.keys($8413851b1f181083$var$notificacoesOpcoes).some((key)=>key.toLowerCase() === tabName);
            if (!abaNotificacaoSelect) {
                $8413851b1f181083$var$errorDefault("Filtro de notifica\xe7\xe3o inv\xe1lido");
                return;
            }
            this.queryNotification.tipo_notificacao = $8413851b1f181083$var$notificacoesOpcoes[tabName];
            this.queryNotification.page = 1;
            this.queryNotification.page_size = 10;
            await this.getTodasNotificacoes();
            this.$nextTick(()=>{
                const container = document.querySelector('.tabs-content');
                if (container) container.scrollTop = 0;
            });
        },
        initSwiperTabsFiltro () {
            this.$nextTick(()=>{
                this.swiperTabsFiltro = new (0, $kQ8rI.S)('.swiper', {
                    modules: [
                        (0, $4kVDe.default)
                    ],
                    freeMode: {
                        enabled: true,
                        sticky: true,
                        momentum: true,
                        momentumBounce: true
                    },
                    spaceBetween: 16,
                    slidesPerView: 'auto',
                    slideToClickedSlide: true
                });
            });
        },
        resetQueryNotification () {
            this.queryNotification = {
                tipo_notificacao: null,
                page: 1,
                page_size: 10,
                total_items: 0,
                has_next: false
            };
        }
    },
    // utils do componente
    computed: {
        get () {},
        textTooltipButtoneEdit () {},
        totalItemsByTab () {
            return this.queryNotification?.total_items || 0;
        }
    },
    // Executa assim que o componenete é criado no dom
    // Executa um cado antes do mounted
    created () {},
    // Executa assim que o componente é montado
    async mounted () {
        await this.getTodasNotificacoes();
        this.agendarNotification(15000);
    /* interval = setInterval(() => {
			this.getTodasNotificacoes(true)
		}, 15000) */ // this.idLastNotification = await this.getLastNotification();
    // this.compareStateWithLastNotification();
    // const callNotification = () => {
    // 	setTimeout(async () => {
    // 		await this.compareStateWithLastNotification();
    // 		callNotification();
    // 	}, 10000);
    // }
    // callNotification();
    // 1ounce que vai bater nessa rota de notificacao
    // com um filtro
    // dentro da resposta vc vai pegar e salvar o dado
    // no proximo request vc vai verificar se a dado é igual a dado anterior
    // se nao for vc roda get all notifications
    // e roda tambem uma funcao pra deixar o icone vermelho
    // quando abrir a notificacao, vc vai setar tudo como visto
    // enviar em um patch
    // observar o array pra ver se tem algum nao lido e deixar vermelho
    },
    //Executa um pouco antes de desmontar o componente
    beforeUnmounted () {},
    // Executa ao desmontar o componente
    unmounted () {},
    template: /* html */ `
    <Transition @enter="onEnter" @leave="leave">
        <section v-if="open" class="w-[39.75rem]  h-[calc(100vh-4rem-18px)] rounded-md absolute overflow-hidden z-[9999999999999999999999] top-[4rem] right-64">
            <header
                class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure relative z-[9999]"
            >
            <h2 class="text-lg font-medium text-white">Notifica\xe7\xf5es</h2>
                <button
                    type="button"
                    class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10"
                    data-xclose="modal_padrao"
                    @click="handleClose"
                >
                    <svg class="w-32 h-32">
                        <use xlink:href="#icon_close"></use>
                    </svg>
                </button>
            </header>
            <div class="p-24 bg-white h-full relative z-[9999]">
                <div class="flex flex-col !w-full h-full">
					<div class="swiper flex flex-col !w-full">
						<ul class="swiper-wrapper flex border-b !border-none max-h-max">
							<li 
								v-for="tab in tabsNotificacao" 
								:key="tab.id" 
								data-tab="tab-modal-1" 
								:data-notification-filter="tab.id"	
								class="swiper-slide relative gap-8 tab-item !flex-[0] whitespace-nowrap tab-item-primary"
								:class="{'active': activeTabAtendimento.toLowerCase() === tab.id.toLowerCase() }" 
								@click="onClickTabNotificationFilter(tab.id)">
								{{ tab.title }} <span v-if="activeTabAtendimento === tab.id" class="block px-8 ml-6 text-sm font-medium rounded-full badge-container bg-neutral-30 text-neutral-70">{{totalNotificationsTab || 0}}</span>
							</li>
						</ul>
					</div>
                    <div class="flex flex-col h-full overflow-auto tabs-content !mt-24">
                        <div class="tab-collapse active" data-tab="tab-modal-1">
                            <div class="relative flex-1 tab-container pb-80" >
							<!--Temporario-->
							<q-infinite-scroll  :offset="10" debounce="300" @load="onloadMoreNotification">
                                <div class="flex flex-col gap-8 mt-8" :value="notification.id" v-for="notification in notifications.data"  :class="{'nao-visto': !notification.visto}">
									<NotificationItem
										:key="notification.id"
										:notification="notification"
										@onClickNotification="onClickNotification"
									/>
                                </div>
								 
								
								 <template v-slot:loading>
									<div class="row justify-center q-my-md">
									<q-spinner-dots color="primary" size="40px" />
									</div>
								</template>
								
							</q-infinite-scroll>

							<div v-if="notifications?.data?.length === 0 && !notifications.loading" class="flex flex-1 items-center justify-center h-full">
								<EmptyItem text="Nenhuma notifica\xe7\xe3o encontrada." classP="text-xl"/>
							</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </Transition>

		<Teleport to="body" v-if="open" >
				<div class="background-deep fixed left-0 top-0 bg-[rgba(0,0,0,0.25)] w-[100vw] h-[100vh] z-[999]"
						@click="handleClose"
				></div>
		</Teleport>

    `
};

});
parcelRegister("jbwpo", function(module, exports) {

$parcel$export(module.exports, "FreeMode", function () { return (parcelRequire("4kVDe")).default; });

var $12oN4 = parcelRequire("12oN4");

var $fn5OX = parcelRequire("fn5OX");

var $bFhoE = parcelRequire("bFhoE");

var $8zuch = parcelRequire("8zuch");

var $6RVKd = parcelRequire("6RVKd");

var $62Fw1 = parcelRequire("62Fw1");

var $45iqD = parcelRequire("45iqD");

var $cgTHK = parcelRequire("cgTHK");

var $kXxKU = parcelRequire("kXxKU");

var $XhXef = parcelRequire("XhXef");

var $5mOEe = parcelRequire("5mOEe");

var $46JbT = parcelRequire("46JbT");

var $fHSvM = parcelRequire("fHSvM");

var $1dypM = parcelRequire("1dypM");

var $4kVDe = parcelRequire("4kVDe");

var $aoYXk = parcelRequire("aoYXk");

var $13JcC = parcelRequire("13JcC");

var $8p3Ia = parcelRequire("8p3Ia");

var $fcuA5 = parcelRequire("fcuA5");

var $8cIYp = parcelRequire("8cIYp");

var $hUQbR = parcelRequire("hUQbR");

var $1mKzS = parcelRequire("1mKzS");

var $dofT8 = parcelRequire("dofT8");

});
parcelRegister("12oN4", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");

var $2YQ2i = parcelRequire("2YQ2i");
function $2eeb57db3e05ebbf$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $kfJyf.g)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $2YQ2i.s)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $2YQ2i.c)('swiper-slide');
        else slideEl = (0, $2YQ2i.c)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $2YQ2i.s)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $2YQ2i.e)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $2YQ2i.b)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}

});
parcelRegister("kfJyf", function(module, exports) {

$parcel$export(module.exports, "g", function () { return $498c970719ee4bd9$export$39b482c5e57630a8; });
$parcel$export(module.exports, "a", function () { return $498c970719ee4bd9$export$407448d2b89b1813; });
/**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $498c970719ee4bd9$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $498c970719ee4bd9$var$extend(target = {}, src = {}) {
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($498c970719ee4bd9$var$isObject(src[key]) && $498c970719ee4bd9$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $498c970719ee4bd9$var$extend(target[key], src[key]);
    });
}
const $498c970719ee4bd9$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $498c970719ee4bd9$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $498c970719ee4bd9$var$extend(doc, $498c970719ee4bd9$var$ssrDocument);
    return doc;
}
const $498c970719ee4bd9$var$ssrWindow = {
    document: $498c970719ee4bd9$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $498c970719ee4bd9$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $498c970719ee4bd9$var$extend(win, $498c970719ee4bd9$var$ssrWindow);
    return win;
}

});

parcelRegister("2YQ2i", function(module, exports) {

$parcel$export(module.exports, "k", function () { return $17ec85311a98ab59$export$342063e11d6c3cad; });
$parcel$export(module.exports, "y", function () { return $17ec85311a98ab59$export$4a5767248b18ef41; });
$parcel$export(module.exports, "n", function () { return $17ec85311a98ab59$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "h", function () { return $17ec85311a98ab59$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $17ec85311a98ab59$export$882b5998b3b9117c; });
$parcel$export(module.exports, "p", function () { return $17ec85311a98ab59$export$ffb5f4729a158638; });
$parcel$export(module.exports, "x", function () { return $17ec85311a98ab59$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "b", function () { return $17ec85311a98ab59$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "u", function () { return $17ec85311a98ab59$export$3b14a55fb2447963; });
$parcel$export(module.exports, "g", function () { return $17ec85311a98ab59$export$39b482c5e57630a8; });
$parcel$export(module.exports, "e", function () { return $17ec85311a98ab59$export$f1e1789686576879; });
$parcel$export(module.exports, "w", function () { return $17ec85311a98ab59$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "v", function () { return $17ec85311a98ab59$export$90a7f3efeed30595; });
$parcel$export(module.exports, "c", function () { return $17ec85311a98ab59$export$db3b6bfb95261072; });
$parcel$export(module.exports, "f", function () { return $17ec85311a98ab59$export$2d1720544b23b823; });
$parcel$export(module.exports, "t", function () { return $17ec85311a98ab59$export$625550452a3fa3ec; });
$parcel$export(module.exports, "r", function () { return $17ec85311a98ab59$export$43caf9889c228507; });
$parcel$export(module.exports, "q", function () { return $17ec85311a98ab59$export$9e5f44173e64f162; });
$parcel$export(module.exports, "j", function () { return $17ec85311a98ab59$export$35e795649ee09318; });
$parcel$export(module.exports, "d", function () { return $17ec85311a98ab59$export$4368d992c4eafac0; });
$parcel$export(module.exports, "o", function () { return $17ec85311a98ab59$export$ae1af26003f05816; });
$parcel$export(module.exports, "i", function () { return $17ec85311a98ab59$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "m", function () { return $17ec85311a98ab59$export$953cecd6e717a553; });
$parcel$export(module.exports, "a", function () { return $17ec85311a98ab59$export$407448d2b89b1813; });
$parcel$export(module.exports, "s", function () { return $17ec85311a98ab59$export$2408f22a0fab9ae5; });

var $kfJyf = parcelRequire("kfJyf");
function $17ec85311a98ab59$export$342063e11d6c3cad(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $17ec85311a98ab59$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $17ec85311a98ab59$export$7ccc53e8f1e7dfc5(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $17ec85311a98ab59$export$dda1d9f60106f0e9() {
    return Date.now();
}
function $17ec85311a98ab59$var$getComputedStyle(el) {
    const window1 = (0, $kfJyf.a)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $17ec85311a98ab59$export$882b5998b3b9117c(el, axis = 'x') {
    const window1 = (0, $kfJyf.a)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $17ec85311a98ab59$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $17ec85311a98ab59$export$ffb5f4729a158638(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $17ec85311a98ab59$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $17ec85311a98ab59$export$d141bba7fdc215a3(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$17ec85311a98ab59$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($17ec85311a98ab59$export$ffb5f4729a158638(to[nextKey]) && $17ec85311a98ab59$export$ffb5f4729a158638(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $17ec85311a98ab59$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$17ec85311a98ab59$export$ffb5f4729a158638(to[nextKey]) && $17ec85311a98ab59$export$ffb5f4729a158638(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $17ec85311a98ab59$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $17ec85311a98ab59$export$8b22cf2602fb60ce(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $17ec85311a98ab59$export$3b14a55fb2447963({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $kfJyf.a)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $17ec85311a98ab59$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $17ec85311a98ab59$export$f1e1789686576879(element, selector = '') {
    const window1 = (0, $kfJyf.a)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $17ec85311a98ab59$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $17ec85311a98ab59$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $kfJyf.a)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $17ec85311a98ab59$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $17ec85311a98ab59$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $17ec85311a98ab59$export$db3b6bfb95261072(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $17ec85311a98ab59$export$342063e11d6c3cad(classes));
    return el;
}
function $17ec85311a98ab59$export$2d1720544b23b823(el) {
    const window1 = (0, $kfJyf.a)();
    const document1 = (0, $kfJyf.g)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $17ec85311a98ab59$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $17ec85311a98ab59$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $17ec85311a98ab59$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $kfJyf.a)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $17ec85311a98ab59$export$35e795649ee09318(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $17ec85311a98ab59$export$4368d992c4eafac0(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $17ec85311a98ab59$export$ae1af26003f05816(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $17ec85311a98ab59$export$23f2a1d2818174ef(el, size, includeMargins) {
    const window1 = (0, $kfJyf.a)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $17ec85311a98ab59$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $17ec85311a98ab59$export$407448d2b89b1813(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $17ec85311a98ab59$export$2408f22a0fab9ae5(el, html = '') {
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}

});


parcelRegister("fn5OX", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");

var $2YQ2i = parcelRequire("2YQ2i");
/* eslint-disable consistent-return */ function $f6be36fa6fe2fdc2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $kfJyf.g)();
    const window = (0, $kfJyf.a)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $2YQ2i.d)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $2YQ2i.d)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $2YQ2i.f)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("bFhoE", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");

var $2YQ2i = parcelRequire("2YQ2i");
/* eslint-disable consistent-return */ function $e1bb4d0aab2c1775$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $kfJyf.a)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $2YQ2i.h)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $2YQ2i.h)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $2YQ2i.h)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $2YQ2i.h)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $2YQ2i.h)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $2YQ2i.n)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $2YQ2i.n)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("8zuch", function(module, exports) {

var $bwQ7G = parcelRequire("bwQ7G");

var $2YQ2i = parcelRequire("2YQ2i");
const $88abe10817b2bb4e$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
function $88abe10817b2bb4e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $88abe10817b2bb4e$var$arrowSvg
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $bwQ7G.c)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $2YQ2i.m)(nextEl);
        prevEl = (0, $2YQ2i.m)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $2YQ2i.s)(tempEl, $88abe10817b2bb4e$var$arrowSvg);
                    el.appendChild(tempEl.querySelector('svg'));
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2YQ2i.m)(nextEl);
        prevEl = (0, $2YQ2i.m)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2YQ2i.m)(nextEl);
        prevEl = (0, $2YQ2i.m)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2YQ2i.m)(nextEl);
        prevEl = (0, $2YQ2i.m)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("bwQ7G", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $ee2256cb7c19c6e6$export$db3b6bfb95261072; });

var $2YQ2i = parcelRequire("2YQ2i");
function $ee2256cb7c19c6e6$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $2YQ2i.e)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $2YQ2i.c)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

});


parcelRegister("6RVKd", function(module, exports) {

var $kuBt8 = parcelRequire("kuBt8");

var $bwQ7G = parcelRequire("bwQ7G");

var $2YQ2i = parcelRequire("2YQ2i");
function $067cbf5022058585$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $kuBt8.c)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $2YQ2i.j)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $2YQ2i.m)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $2YQ2i.i)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $2YQ2i.j)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $kuBt8.c)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $kuBt8.c)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $kuBt8.c)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $2YQ2i.s)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $2YQ2i.m)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $2YQ2i.s)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $kuBt8.c)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $bwQ7G.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $2YQ2i.d)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $2YQ2i.m)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2YQ2i.m)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $2YQ2i.m)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2YQ2i.m)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2YQ2i.m)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("kuBt8", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $3d759736442c3cb9$export$db3b6bfb95261072; });
function $3d759736442c3cb9$export$db3b6bfb95261072(classes = '') {
    return `.${classes.trim().replace(/([\.:!+\/()[\]])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}

});


parcelRegister("62Fw1", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");

var $2YQ2i = parcelRequire("2YQ2i");

var $bwQ7G = parcelRequire("bwQ7G");

var $kuBt8 = parcelRequire("kuBt8");
function $82c7fe0e2547cf56$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $kfJyf.g)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $2YQ2i.f)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $2YQ2i.n)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $bwQ7G.c)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $kuBt8.c)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $2YQ2i.c)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $2YQ2i.k)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $2YQ2i.k)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $2YQ2i.k)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $2YQ2i.k)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $2YQ2i.k)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $2YQ2i.k)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $2YQ2i.k)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}

});

parcelRegister("45iqD", function(module, exports) {

var $2YQ2i = parcelRequire("2YQ2i");
function $7e1fc2c5c1a02bd2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $2YQ2i.e)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $2YQ2i.e)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

});

parcelRegister("cgTHK", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");

var $2YQ2i = parcelRequire("2YQ2i");
function $b7771b80c6924fc9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $kfJyf.a)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2YQ2i.d)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $2YQ2i.l)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $2YQ2i.l)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $2YQ2i.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2YQ2i.d)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $2YQ2i.f)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $2YQ2i.f)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $2YQ2i.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2YQ2i.d)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

});

parcelRegister("kXxKU", function(module, exports) {

var $2YQ2i = parcelRequire("2YQ2i");
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $914c5b0f6cf52218$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $2YQ2i.n)(()=>{
                    c.updateAutoHeight();
                });
                (0, $2YQ2i.o)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}

});

parcelRegister("XhXef", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");

var $kuBt8 = parcelRequire("kuBt8");

var $2YQ2i = parcelRequire("2YQ2i");
function $f2a62cc44a2f1658$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $2YQ2i.s)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $2YQ2i.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $kuBt8.c)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $2YQ2i.m)(swiper.navigation.prevEl);
            const nextEls = (0, $2YQ2i.m)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $kuBt8.c)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $2YQ2i.j)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $kuBt8.c)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $2YQ2i.m)(nextEl);
        prevEl = (0, $2YQ2i.m)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $2YQ2i.m)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $kfJyf.g)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $2YQ2i.m)(nextEl);
        prevEl = (0, $2YQ2i.m)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $2YQ2i.m)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $kfJyf.g)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $2YQ2i.c)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

});

parcelRegister("5mOEe", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");
function $635a82d868cf5f8d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $kfJyf.a)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $kfJyf.a)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $kfJyf.a)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $kfJyf.a)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

});

parcelRegister("46JbT", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");

var $2YQ2i = parcelRequire("2YQ2i");
function $2a01bbb152f57d5e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $kfJyf.g)();
    const window = (0, $kfJyf.a)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $2YQ2i.e)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

});

parcelRegister("fHSvM", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $b4cd074d80730cb6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params }) {
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $kfJyf.g)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $kfJyf.g)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $kfJyf.g)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}

});

parcelRegister("1dypM", function(module, exports) {

var $kfJyf = parcelRequire("kfJyf");

var $2YQ2i = parcelRequire("2YQ2i");
function $d520fda35eca9092$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $2YQ2i.p)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $2YQ2i.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $kfJyf.g)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}

});

parcelRegister("4kVDe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19cd03ebfce006f2$export$2e2bcd8739ae039; });

var $2YQ2i = parcelRequire("2YQ2i");
function $19cd03ebfce006f2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $2YQ2i.h)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $2YQ2i.h)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $2YQ2i.h)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $2YQ2i.o)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $2YQ2i.o)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $2YQ2i.o)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}

});

parcelRegister("aoYXk", function(module, exports) {
function $1a02234335d43bc1$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}

});

parcelRegister("13JcC", function(module, exports) {

var $2YQ2i = parcelRequire("2YQ2i");
function $a6d2c9fc1b364478$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $2YQ2i.s)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $2YQ2i.s)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $a6d2c9fc1b364478$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $2YQ2i.s)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $2YQ2i.s)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $a6d2c9fc1b364478$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $a6d2c9fc1b364478$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $a6d2c9fc1b364478$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $a6d2c9fc1b364478$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: $a6d2c9fc1b364478$var$appendSlide.bind(swiper),
        prependSlide: $a6d2c9fc1b364478$var$prependSlide.bind(swiper),
        addSlide: $a6d2c9fc1b364478$var$addSlide.bind(swiper),
        removeSlide: $a6d2c9fc1b364478$var$removeSlide.bind(swiper),
        removeAllSlides: $a6d2c9fc1b364478$var$removeAllSlides.bind(swiper)
    });
}

});

parcelRegister("8p3Ia", function(module, exports) {

var $bhpy9 = parcelRequire("bhpy9");

var $lbPWx = parcelRequire("lbPWx");

var $kTqKY = parcelRequire("kTqKY");

var $2YQ2i = parcelRequire("2YQ2i");
function $9574975526659ece$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $lbPWx.e)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2YQ2i.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $kTqKY.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $bhpy9.e)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("bhpy9", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $099ed9e45542eb53$export$f1e1789686576879; });
function $099ed9e45542eb53$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

});

parcelRegister("lbPWx", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $4bc2f860b25b9531$export$f1e1789686576879; });

var $2YQ2i = parcelRequire("2YQ2i");
function $4bc2f860b25b9531$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $2YQ2i.g)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}

});

parcelRegister("kTqKY", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $d4cfa568f6893a15$export$f1e1789686576879; });

var $2YQ2i = parcelRequire("2YQ2i");
function $d4cfa568f6893a15$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $2YQ2i.o)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}

});


parcelRegister("fcuA5", function(module, exports) {

var $bhpy9 = parcelRequire("bhpy9");

var $2YQ2i = parcelRequire("2YQ2i");
function $58eefdcbb981d17a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $2YQ2i.c)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $2YQ2i.c)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $2YQ2i.a)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $2YQ2i.c)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $2YQ2i.c)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $bhpy9.e)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

});

parcelRegister("8cIYp", function(module, exports) {

var $ienij = parcelRequire("ienij");

var $bhpy9 = parcelRequire("bhpy9");

var $lbPWx = parcelRequire("lbPWx");

var $kTqKY = parcelRequire("kTqKY");

var $2YQ2i = parcelRequire("2YQ2i");
function $349d2345d7d92b5b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $ienij.c)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $ienij.c)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $2YQ2i.a)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $lbPWx.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2YQ2i.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $kTqKY.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $bhpy9.e)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("ienij", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $8bda3237354cf1af$export$db3b6bfb95261072; });

var $2YQ2i = parcelRequire("2YQ2i");
function $8bda3237354cf1af$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $2YQ2i.g)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $2YQ2i.c)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}

});


parcelRegister("hUQbR", function(module, exports) {

var $ienij = parcelRequire("ienij");

var $bhpy9 = parcelRequire("bhpy9");

var $lbPWx = parcelRequire("lbPWx");

var $2YQ2i = parcelRequire("2YQ2i");
function $9c7f514797cff4b3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $2YQ2i.a)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $lbPWx.e)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $ienij.c)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $ienij.c)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2YQ2i.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $bhpy9.e)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

});

parcelRegister("1mKzS", function(module, exports) {

var $ienij = parcelRequire("ienij");

var $bhpy9 = parcelRequire("bhpy9");

var $lbPWx = parcelRequire("lbPWx");

var $kTqKY = parcelRequire("kTqKY");

var $2YQ2i = parcelRequire("2YQ2i");
function $33cb88d5aeb2b1c8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $2YQ2i.a)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $ienij.c)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $lbPWx.e)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2YQ2i.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $kTqKY.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $bhpy9.e)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});

parcelRegister("dofT8", function(module, exports) {

var $ienij = parcelRequire("ienij");

var $bhpy9 = parcelRequire("bhpy9");

var $lbPWx = parcelRequire("lbPWx");

var $kTqKY = parcelRequire("kTqKY");

var $2YQ2i = parcelRequire("2YQ2i");
function $8602ba8cece06f8c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $ienij.c)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $lbPWx.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2YQ2i.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $kTqKY.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $bhpy9.e)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});


parcelRegister("1fBE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e9464acf29c4d03$export$2e2bcd8739ae039; });
function $0e9464acf29c4d03$export$2e2bcd8739ae039() {
    const attr = "[js-tab]";
    const tabs = document.querySelectorAll(`.tabs${attr}`);
    if (!tabs.length) return;
    tabs.forEach((t)=>initTab(t));
    function initTab(tab) {
        const collapses = tab.querySelectorAll(".tab-collapse");
        const tabItens = tab.querySelectorAll(".tabs-wrapper .tab-item");
        tabItens.forEach((t)=>{
            t.addEventListener("click", (e)=>{
                collapses.forEach((c)=>c.classList.remove("active"));
                tabItens.forEach((c)=>c.classList.remove("active"));
                t.classList.add("active");
                const att = e.currentTarget.dataset.tab;
                collapses.forEach((c)=>{
                    const attCollapse = c.getAttribute("data-tab");
                    if (attCollapse == att) c.classList.add("active");
                });
            });
        });
    }
}

});

parcelRegister("92Iq6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6956c1da1305ab13$export$2e2bcd8739ae039; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $6956c1da1305ab13$export$2e2bcd8739ae039() {
    const api = (0, $c8Lpu.useApi)();
    async function getAllNotifications(params) {
        return await api.query((0, $9YhWF.URLS).api_notificacao, params, {
            cache: false
        });
    }
    return {
        getAllNotifications: getAllNotifications,
        ...api
    };
}

});

parcelRegister("5Zscv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45c88659a6dc7b3d$export$2e2bcd8739ae039; });

var $g8vIm = parcelRequire("g8vIm");

var $5q0Z8 = parcelRequire("5q0Z8");

var $YrtCO = parcelRequire("YrtCO");
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5q0Z8))));
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($YrtCO))));
var $45c88659a6dc7b3d$export$2e2bcd8739ae039 = {
    props: [
        'notification'
    ],
    emits: [
        'onClickNotification'
    ],
    data () {},
    computed: {
        isAtendimentoValido () {
            return this.notification.fundacao_id || this.notification.cliente_pf_id ? true : false;
        },
        iconName () {
            console.log(this.isAtendimentoValido);
            return this.isAtendimentoValido ? 'edit' : 'edit_off';
        },
        dataFormatada () {
            return (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(this.notification.data_criacao).format('DD/MM/YYYY HH:mm');
        }
    },
    methods: {
        onClickNotification () {
            if (!this.isAtendimentoValido) return;
            this.$emit('onClickNotification', this.notification);
        }
    },
    template: `
        <div class="relative flex items-center gap-8 p-16 border rounded-md border-neutral-30"  >
            <span class="grid w-40 h-40 text-white rounded-full bg-primary-10 place-items-center shrink-0 !self-baseline">
				<svg class="h-24 w-24 !text-primary-pure"  >
					<use xlink:href="#icon_notification_person"></use>
				</svg>
            </span>
            <div class="flex-1">
                    <p class="text-paragraph-1 font-bold text-neutral-100">{{notification.titulo}}</p>
					<p class="text-sm font-medium text-neutral-70 mt-4">Data da Notifica\xe7\xe3o: {{dataFormatada}}</p>
                    <p v-html="notification.descricao" class="mt-16"></p>
            </div>
			<div class="">
				<q-btn :icon="iconName" size="sm" flat color="primary" class="cursor-pointer bg-transparent text-primary-pure" @click="onClickNotification">
                    <q-tooltip v-if="!isAtendimentoValido" class="z-9999 w-max">
                        <q-card class="p-16 shadow-md rounded-md w-max">
                            <span class="text-paragraph-1 text-alert-red-100">
                                Criar tarefa n\xe3o se aplica para essa notifica\xe7\xe3o.
                            </span>
                            <q-icon name="warning" size="1.5rem" color="alert-red-100"/>
                        </q-card>
                    </q-tooltip>
                </q-btn>	
			</div>																
        </div>
    `
};

});
parcelRegister("g8vIm", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("5q0Z8", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var r = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), r.call(this, t);
        };
        var o = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s;
            if (0 === u) return this.utc(f);
            var r = this.clone();
            if (f) return r.$offset = u, r.$u = !1, r;
            var o = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            return (r = this.local().add(u + o, t)).$offset = u, r.$x.$localOffset = o, r;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});

parcelRegister("YrtCO", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});

});


parcelRegister("hFwHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("kQ8rI")).S; });
/**
 * Swiper 12.0.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: October 21, 2025
 */ 
var $kQ8rI = parcelRequire("kQ8rI");

});
parcelRegister("kQ8rI", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $8bd999da031fad25$export$25ce5a424b770e84; });

var $kfJyf = parcelRequire("kfJyf");

var $2YQ2i = parcelRequire("2YQ2i");
let $8bd999da031fad25$var$support;
function $8bd999da031fad25$var$calcSupport() {
    const window1 = (0, $kfJyf.a)();
    const document1 = (0, $kfJyf.g)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $8bd999da031fad25$var$getSupport() {
    if (!$8bd999da031fad25$var$support) $8bd999da031fad25$var$support = $8bd999da031fad25$var$calcSupport();
    return $8bd999da031fad25$var$support;
}
let $8bd999da031fad25$var$deviceCached;
function $8bd999da031fad25$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = $8bd999da031fad25$var$getSupport();
    const window1 = (0, $kfJyf.a)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $8bd999da031fad25$var$getDevice(overrides = {}) {
    if (!$8bd999da031fad25$var$deviceCached) $8bd999da031fad25$var$deviceCached = $8bd999da031fad25$var$calcDevice(overrides);
    return $8bd999da031fad25$var$deviceCached;
}
let $8bd999da031fad25$var$browser;
function $8bd999da031fad25$var$calcBrowser() {
    const window1 = (0, $kfJyf.a)();
    const device = $8bd999da031fad25$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $8bd999da031fad25$var$getBrowser() {
    if (!$8bd999da031fad25$var$browser) $8bd999da031fad25$var$browser = $8bd999da031fad25$var$calcBrowser();
    return $8bd999da031fad25$var$browser;
}
function $8bd999da031fad25$var$Resize({ swiper: swiper, on: on, emit: emit }) {
    const window1 = (0, $kfJyf.a)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $8bd999da031fad25$var$Observer({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window1 = (0, $kfJyf.a)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $2YQ2i.d)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $8bd999da031fad25$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $8bd999da031fad25$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $2YQ2i.q)(el, 'padding-left') || 0, 10) - parseInt((0, $2YQ2i.q)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $2YQ2i.q)(el, 'padding-top') || 0, 10) - parseInt((0, $2YQ2i.q)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $8bd999da031fad25$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $2YQ2i.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $2YQ2i.b)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $2YQ2i.b)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $2YQ2i.q)(slide, 'display') === 'none') continue; // eslint-disable-line
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $2YQ2i.i)(slide, 'width', true) : (0, $2YQ2i.i)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (offsetBefore || 0) + (offsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $2YQ2i.b)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $2YQ2i.b)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $8bd999da031fad25$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $8bd999da031fad25$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $8bd999da031fad25$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $8bd999da031fad25$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $8bd999da031fad25$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $8bd999da031fad25$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $8bd999da031fad25$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $8bd999da031fad25$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $8bd999da031fad25$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $2YQ2i.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $2YQ2i.r)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $2YQ2i.t)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $8bd999da031fad25$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $8bd999da031fad25$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $8bd999da031fad25$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $8bd999da031fad25$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $8bd999da031fad25$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $8bd999da031fad25$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $8bd999da031fad25$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $8bd999da031fad25$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $8bd999da031fad25$var$unlazy(swiper, i);
    }
};
function $8bd999da031fad25$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $8bd999da031fad25$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $8bd999da031fad25$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $8bd999da031fad25$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $8bd999da031fad25$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $8bd999da031fad25$var$update = {
    updateSize: $8bd999da031fad25$var$updateSize,
    updateSlides: $8bd999da031fad25$var$updateSlides,
    updateAutoHeight: $8bd999da031fad25$var$updateAutoHeight,
    updateSlidesOffset: $8bd999da031fad25$var$updateSlidesOffset,
    updateSlidesProgress: $8bd999da031fad25$var$updateSlidesProgress,
    updateProgress: $8bd999da031fad25$var$updateProgress,
    updateSlidesClasses: $8bd999da031fad25$var$updateSlidesClasses,
    updateActiveIndex: $8bd999da031fad25$var$updateActiveIndex,
    updateClickedSlide: $8bd999da031fad25$var$updateClickedSlide
};
function $8bd999da031fad25$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $2YQ2i.l)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $8bd999da031fad25$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $8bd999da031fad25$var$minTranslate() {
    return -this.snapGrid[0];
}
function $8bd999da031fad25$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $8bd999da031fad25$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $2YQ2i.u)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $8bd999da031fad25$var$translate = {
    getTranslate: $8bd999da031fad25$var$getSwiperTranslate,
    setTranslate: $8bd999da031fad25$var$setTranslate,
    minTranslate: $8bd999da031fad25$var$minTranslate,
    maxTranslate: $8bd999da031fad25$var$maxTranslate,
    translateTo: $8bd999da031fad25$var$translateTo
};
function $8bd999da031fad25$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $8bd999da031fad25$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $8bd999da031fad25$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $8bd999da031fad25$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $8bd999da031fad25$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $8bd999da031fad25$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $8bd999da031fad25$var$transition = {
    setTransition: $8bd999da031fad25$var$setTransition,
    transitionStart: $8bd999da031fad25$var$transitionStart,
    transitionEnd: $8bd999da031fad25$var$transitionEnd
};
function $8bd999da031fad25$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $2YQ2i.u)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $8bd999da031fad25$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $8bd999da031fad25$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $8bd999da031fad25$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $8bd999da031fad25$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $8bd999da031fad25$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $8bd999da031fad25$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $8bd999da031fad25$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $2YQ2i.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $2YQ2i.n)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $8bd999da031fad25$var$slide = {
    slideTo: $8bd999da031fad25$var$slideTo,
    slideToLoop: $8bd999da031fad25$var$slideToLoop,
    slideNext: $8bd999da031fad25$var$slideNext,
    slidePrev: $8bd999da031fad25$var$slidePrev,
    slideReset: $8bd999da031fad25$var$slideReset,
    slideToClosest: $8bd999da031fad25$var$slideToClosest,
    slideToClickedSlide: $8bd999da031fad25$var$slideToClickedSlide
};
function $8bd999da031fad25$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $2YQ2i.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $2YQ2i.e)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $2YQ2i.c)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $2YQ2i.c)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $2YQ2i.v)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $2YQ2i.v)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $8bd999da031fad25$var$loopFix({ slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $2YQ2i.v)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $2YQ2i.v)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $8bd999da031fad25$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $8bd999da031fad25$var$loop = {
    loopCreate: $8bd999da031fad25$var$loopCreate,
    loopFix: $8bd999da031fad25$var$loopFix,
    loopDestroy: $8bd999da031fad25$var$loopDestroy
};
function $8bd999da031fad25$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $8bd999da031fad25$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $8bd999da031fad25$var$grabCursor = {
    setGrabCursor: $8bd999da031fad25$var$setGrabCursor,
    unsetGrabCursor: $8bd999da031fad25$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $8bd999da031fad25$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $kfJyf.g)() || el === (0, $kfJyf.a)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $8bd999da031fad25$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $kfJyf.a)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $8bd999da031fad25$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $kfJyf.g)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $8bd999da031fad25$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $2YQ2i.w)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $8bd999da031fad25$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$8bd999da031fad25$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $2YQ2i.h)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $8bd999da031fad25$var$onTouchMove(event) {
    const document1 = (0, $kfJyf.g)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $2YQ2i.h)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $8bd999da031fad25$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $2YQ2i.h)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $2YQ2i.h)();
    (0, $2YQ2i.n)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $8bd999da031fad25$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $8bd999da031fad25$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $8bd999da031fad25$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $8bd999da031fad25$var$onLoad(e) {
    const swiper = this;
    $8bd999da031fad25$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $8bd999da031fad25$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $8bd999da031fad25$var$events = (swiper, method)=>{
    const document1 = (0, $kfJyf.g)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $8bd999da031fad25$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $8bd999da031fad25$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $8bd999da031fad25$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $8bd999da031fad25$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $8bd999da031fad25$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $8bd999da031fad25$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $8bd999da031fad25$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $8bd999da031fad25$var$onScroll.bind(swiper);
    swiper.onClick = $8bd999da031fad25$var$onClick.bind(swiper);
    swiper.onLoad = $8bd999da031fad25$var$onLoad.bind(swiper);
    $8bd999da031fad25$var$events(swiper, 'on');
}
function $8bd999da031fad25$var$detachEvents() {
    const swiper = this;
    $8bd999da031fad25$var$events(swiper, 'off');
}
var $8bd999da031fad25$var$events$1 = {
    attachEvents: $8bd999da031fad25$var$attachEvents,
    detachEvents: $8bd999da031fad25$var$detachEvents
};
const $8bd999da031fad25$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $8bd999da031fad25$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $kfJyf.g)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $8bd999da031fad25$var$isGridEnabled(swiper, params);
    const isMultiRow = $8bd999da031fad25$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $2YQ2i.x)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $8bd999da031fad25$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $kfJyf.a)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $8bd999da031fad25$var$breakpoints = {
    setBreakpoint: $8bd999da031fad25$var$setBreakpoint,
    getBreakpoint: $8bd999da031fad25$var$getBreakpoint
};
function $8bd999da031fad25$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $8bd999da031fad25$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $8bd999da031fad25$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $8bd999da031fad25$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $8bd999da031fad25$var$classes = {
    addClasses: $8bd999da031fad25$var$addClasses,
    removeClasses: $8bd999da031fad25$var$removeClasses
};
function $8bd999da031fad25$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $8bd999da031fad25$var$checkOverflow$1 = {
    checkOverflow: $8bd999da031fad25$var$checkOverflow
};
var $8bd999da031fad25$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $8bd999da031fad25$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $2YQ2i.x)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $2YQ2i.x)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $2YQ2i.x)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $8bd999da031fad25$var$prototypes = {
    eventsEmitter: $8bd999da031fad25$var$eventsEmitter,
    update: $8bd999da031fad25$var$update,
    translate: $8bd999da031fad25$var$translate,
    transition: $8bd999da031fad25$var$transition,
    slide: $8bd999da031fad25$var$slide,
    loop: $8bd999da031fad25$var$loop,
    grabCursor: $8bd999da031fad25$var$grabCursor,
    events: $8bd999da031fad25$var$events$1,
    breakpoints: $8bd999da031fad25$var$breakpoints,
    checkOverflow: $8bd999da031fad25$var$checkOverflow$1,
    classes: $8bd999da031fad25$var$classes
};
const $8bd999da031fad25$var$extendedDefaults = {};
class $8bd999da031fad25$export$25ce5a424b770e84 {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $2YQ2i.x)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $kfJyf.g)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $2YQ2i.x)({}, params, {
                    el: containerEl
                });
                swipers.push(new $8bd999da031fad25$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $8bd999da031fad25$var$getSupport();
        swiper.device = $8bd999da031fad25$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $8bd999da031fad25$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $8bd999da031fad25$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $2YQ2i.x)({}, $8bd999da031fad25$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $2YQ2i.x)({}, swiperParams, $8bd999da031fad25$var$extendedDefaults, params);
        swiper.originalParams = (0, $2YQ2i.x)({}, swiper.params);
        swiper.passedParams = (0, $2YQ2i.x)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $2YQ2i.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $2YQ2i.j)(slides[0]);
        return (0, $2YQ2i.j)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $2YQ2i.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $8bd999da031fad25$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $2YQ2i.e)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $2YQ2i.c)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $2YQ2i.e)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $2YQ2i.q)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $2YQ2i.q)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $2YQ2i.q)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $8bd999da031fad25$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $8bd999da031fad25$var$processLazyPreloader(swiper, e.target);
            });
        });
        $8bd999da031fad25$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $8bd999da031fad25$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $2YQ2i.y)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $2YQ2i.x)($8bd999da031fad25$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $8bd999da031fad25$var$extendedDefaults;
    }
    static get defaults() {
        return $8bd999da031fad25$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$8bd999da031fad25$export$25ce5a424b770e84.prototype.__modules__) $8bd999da031fad25$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $8bd999da031fad25$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$8bd999da031fad25$export$25ce5a424b770e84.installModule(m));
            return $8bd999da031fad25$export$25ce5a424b770e84;
        }
        $8bd999da031fad25$export$25ce5a424b770e84.installModule(module);
        return $8bd999da031fad25$export$25ce5a424b770e84;
    }
}
Object.keys($8bd999da031fad25$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($8bd999da031fad25$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $8bd999da031fad25$export$25ce5a424b770e84.prototype[protoMethod] = $8bd999da031fad25$var$prototypes[prototypeGroup][protoMethod];
    });
});
$8bd999da031fad25$export$25ce5a424b770e84.use([
    $8bd999da031fad25$var$Resize,
    $8bd999da031fad25$var$Observer
]);

});


parcelRegister("amUiM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c7a1d8efc978b0$export$2e2bcd8739ae039; });
var $78c7a1d8efc978b0$export$2e2bcd8739ae039 = {
    name: 'EmptyItem',
    props: {
        text: {
            type: String,
            default: 'Nada aqui.'
        },
        classP: {
            type: String,
            default: ''
        },
        icons: {
            type: Array,
            default: ()=>[
                    'fluorescent',
                    'spa',
                    'light'
                ]
        }
    },
    data () {
        return {
            randomIndex: Math.floor(Math.random() * this.icons.length)
        };
    },
    computed: {
        iconName () {
            return this.icons[this.randomIndex];
        }
    },
    mounted () {},
    template: `
        <div class="text-paragraph-2 text-center m-auto !h-full flex-1 flex flex-col justify-center">
            <q-icon
                class="block mx-auto opacity-30 "
                :name="iconName"
                size="2.5rem"
                :class="classP"
            ></q-icon>
            <p class="opacity-40 " :class="classP">{{ text }}</p>
        </div>
    `
};

});


parcelRegister("M3yYZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09073f64e5191484$export$2e2bcd8739ae039; });
var $09073f64e5191484$export$2e2bcd8739ae039 = {
    data () {
        return {
            isOpen: false,
            haveNotification: false
        };
    },
    // updated() {
    // 	console.log(this.haveNotification, "haveNotification");
    // },
    methods: {
        openNotifications () {
            this.isOpen = true;
        },
        closeNotifications () {
            this.isOpen = false;
        },
        updatedNotification (param) {
            // console.log("ai meu deus", param)
            this.haveNotification = param;
        }
    }
};

});

parcelRegister("3akwj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24e2392a903288ee$export$2e2bcd8739ae039; });

var $9pxQa = parcelRequire("9pxQa");

var $1RCBx = parcelRequire("1RCBx");

var $i5cs0 = parcelRequire("i5cs0");

var $bF0nE = parcelRequire("bF0nE");

var $4Fazw = parcelRequire("4Fazw");

var $4nzoT = parcelRequire("4nzoT");

var $8Pv07 = parcelRequire("8Pv07");

var $iIWBq = parcelRequire("iIWBq");
const { api: $24e2392a903288ee$var$api, formatReal2: $24e2392a903288ee$var$formatReal2 } = GLOBAL;
const { createPatrimonioClienteTable: $24e2392a903288ee$var$createPatrimonioClienteTable, calculaSomaTotal: $24e2392a903288ee$var$calculaSomaTotal, formatColumnsToTable: $24e2392a903288ee$var$formatColumnsToTable, onTableFetchServer: $24e2392a903288ee$var$onTableFetchServer } = (0, $9pxQa.useClientes)();
NProgress.configure({
    trickleSpeed: 40,
    trickle: true,
    minimum: 0.65
});
var $24e2392a903288ee$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $i5cs0.default)
    ],
    components: {
        TableAtendimento: $bF0nE.default,
        AvatarPersona: $4Fazw.default,
        ModalResumo: $4nzoT.default,
        ModalFiltros: $8Pv07.default,
        ModalEmissorFGCAtivos: $iIWBq.default
    },
    data () {
        return {
            principais_clientes_cliente_pf: global_tables.principais_clientes_cliente_pf,
            dados_semestre_clientes: global_tables.dados_semestre_clientes,
            dados_semestre_pl: global_tables.dados_semestre_pl,
            lista_segmentos: global_tables.lista_segmentos,
            segmentos: [],
            total: {},
            maxNumClientes: null,
            maxPl: null,
            haveModalResumo: true,
            haveFilterEmissor: false,
            urlParams: new URLSearchParams(window.location.search),
            url_filters: '',
            tabela: null,
            limpar: false,
            somaTotal: [],
            somaTotalEmissores: [],
            temAtivos: false,
            chartSemestral: undefined,
            chartNumClientes: undefined
        };
    },
    methods: {
        geraTemplateTablePatrimonioCliente (search) {
            console.log({
                params: this.urlParams
            });
            console.log({
                somaTotal: this.somaTotal,
                somaTotalEmissores: this.somaTotalEmissores
            });
            this.tabela = $24e2392a903288ee$var$createPatrimonioClienteTable(search, {
                foraFGC: this.urlParams.get('fora_fgc') == 'Fora do FGC hoje',
                foraFgcGeral: this.urlParams.get('fora_fgc') == 'Sim',
                foraFgcNao: this.urlParams.get('fora_fgc') == "N\xe3o",
                ativos: this.urlParams.get('ativos'),
                emissores: this.urlParams.get('emissores'),
                by: document.querySelector('.select-paginate-by').value,
                somaTotal: this.somaTotal,
                somaTotalEmissores: this.somaTotalEmissores,
                isFilter: this.urlParams.size > 1
            });
            this.tabela.on('rowClick', (...args)=>{
                const dados = args[1];
                const id = dados.cells[0].data;
                const politica = dados.cells[1].data;
                this.openModal({}, id, politica);
            });
            this.tabela.render(document.querySelector('#table_clientes_patrimonio'));
            return this.tabela;
        },
        handleChangeSemestres () {
            const form = document.querySelector('#form_selects_novo_gerencial_sap');
            form.submit();
        },
        openModal ({ currentTarget: currentTarget }, idActive, politicaActive) {
            const id = idActive || currentTarget?.getAttribute('data-id');
            const politica = politicaActive || currentTarget?.getAttribute('data-politica');
            console.log({
                currentTarget: currentTarget
            });
            this.$refs.modalResumo.OpenModalResumo({
                id: id,
                politica: politica,
                atendimentoID: null
            });
        },
        generateColor (typeUser, type) {
            switch(typeUser){
                case 0:
                    return `${type}: #840505`;
                case 1:
                    return `${type}: #D83232`;
                case 2:
                    return `${type}: #FF8787`;
                case 3:
                    return `${type}: #6D6F71`;
                default:
                    return `${type}: #B8BCBF`;
            }
        },
        fillNumClientsChart (data) {
            let current = (0, $1RCBx.SEMESTRAL_CHART_CURRENT_DEFAULT_VALUE);
            if (data[0]) current = {
                ...data[0]
            };
            const numbers = [];
            numbers.push(current.num_clientes_distribuicao);
            numbers.push(current.num_clientes_private);
            numbers.push(current.num_clientes_ultra_high);
            numbers.push(current.num_clientes_premium);
            numbers.push(current.num_clientes_na);
            numbers.push(...this.segmentos.map((numClientes)=>numClientes?.n_clientes));
            this.maxNumClientes = numbers.sort((a, b)=>b - a)[0];
            const series = [
                {
                    name: `Semestre ${current.semestre}`,
                    data: [
                        current.num_clientes_ultra_high,
                        current.num_clientes_private,
                        current.num_clientes_premium,
                        current.num_clientes_distribuicao,
                        current.num_clientes_na
                    ]
                },
                {
                    name: 'Atual',
                    data: this.segmentos.map((numClientes)=>numClientes.n_clientes)
                }
            ];
            series.forEach((itemSerie)=>{
                itemSerie.data = itemSerie.data.length > 4 ? itemSerie.data.slice(0, 4) : itemSerie.data;
            });
            this.chartNumClientes.updateOptions({
                series: series,
                yaxis: {
                    tickAmount: 4
                }
            });
        },
        fillSemestralChart (data) {
            let current = (0, $1RCBx.SEMESTRAL_CHART_CURRENT_DEFAULT_VALUE);
            if (data[0]) current = {
                ...data[0]
            };
            const series = [
                {
                    name: `Semestre ${current.semestre}`,
                    data: [
                        current.pl_ultra_high,
                        current.pl_private,
                        current.pl_premium,
                        current.pl_distribuicao,
                        current.pl_na
                    ]
                },
                {
                    name: 'Atual',
                    data: this.segmentos.map((segmento)=>segmento.patrimonio.replaceAll('.', ''))
                }
            ];
            this.chartSemestral.updateOptions({
                series: series,
                yaxis: {
                    tickAmount: 4,
                    labels: {
                        formatter: (value)=>$24e2392a903288ee$var$formatReal2(value)
                    }
                }
            });
        },
        async downloadGerencialSapTable () {
            try {
                window.myLoader().show();
                const initSearch = window.location.search.replace('?', '');
                this.urlParams = new URLSearchParams(initSearch);
                let search = '?';
                search += initSearch;
                search = search.replaceAll('paginate_by', 'nada');
                search = search.replaceAll('page', 'nada');
                search += '&paginate_by=9999';
                const ativos = this.urlParams.get('ativos');
                const emissores = this.urlParams.get('emissores');
                const fora_fgc = this.urlParams.get('fora_fgc');
                if (ativos) this.temAtivos = true;
                else this.temAtivos = false;
                const request = await $24e2392a903288ee$var$api.get(`api/tabela_clientepf/principais_clientes/${search}`);
                const arr = request.data?.results.map((item)=>{
                    const modelos = [];
                    const officers = item.usuario_responsavel.join(', ');
                    if (item.consultoria) modelos.push('Consultoria');
                    if (item.gestao) modelos.push("Gest\xe3o");
                    if (item.distribuicao) modelos.push("Distribui\xe7\xe3o");
                    let modelo_negocio = modelos?.join(', ');
                    let obj = {
                        nome: item.nome,
                        patrimonio_interno: GLOBAL.formatReal2(item.patrimonio_interno),
                        patrimonio_externo: GLOBAL.formatReal2(item.patrimonio_externo),
                        modelo_negocio: modelo_negocio,
                        officers: officers
                    };
                    if (fora_fgc) {
                        if (fora_fgc === 'Sim') obj = {
                            ...obj,
                            emissores_fora_fgc_geral: item.emissores_fora_fgc_geral.map((i)=>i[0]).join(', '),
                            emissores_fora_fgc_geral_valor: item.emissores_fora_fgc_geral.map((i)=>GLOBAL.formatReal2(i[1])).join(', ')
                        };
                        else if (fora_fgc === 'Fora do FGC hoje') obj = {
                            ...obj,
                            emissores_fora_fgc_hj: item.emissores_fora_fgc_hj.map((i)=>i[0]).join(', '),
                            emissores_fora_fgc_hj_valor: item.emissores_fora_fgc_hj.map((i)=>GLOBAL.formatReal2(i[1])).join(', ')
                        };
                    } else {
                        if (ativos) obj = {
                            ...obj,
                            ativos: item.ativo_nome.join(','),
                            porcentagem_ativo: item.ativo_nome_porcentagem.join(', '),
                            porcentagem_ativo_rf: item.ativo_nome_porcentagem_rf.join(', '),
                            valor_ativo: item.ativo_nome_valor.map((i)=>GLOBAL.formatReal2(i)).join(',')
                        };
                        if (emissores) obj = {
                            ...obj,
                            emissores: item.ativo_emissor.join(', '),
                            porcentagem_emissor: item.ativo_emissor_porcentagem.join(', '),
                            porcentagem_emissor_rf: item.ativo_emissor_porcentagem_rf.join(', '),
                            valor_emissor: item.ativo_emissor_valor.map((i)=>GLOBAL.formatReal2(i)).join(', ')
                        };
                    }
                    return obj;
                });
                GLOBAL.tableToExcel('', 'teste', arr);
                window.myLoader().hide();
            } catch (error) {
                console.error(error);
            }
        },
        openFiltros () {
            modal_padrao_vue.openModal('criar_filtros');
        },
        async getBigNumbers (search) {
            try {
                const { data: data } = await $24e2392a903288ee$var$api.get('/api/clientepf/dados_politica/?' + search.replace('?', ''));
                if (!data) return;
                this.segmentos = data?.map((i, index)=>{
                    if (index !== 0) return {
                        ...i,
                        patrimonio: GLOBAL.FormatREAL(String(i.patrimonio))
                    };
                }).filter((i)=>i !== undefined);
                this.total = {
                    ...data[0],
                    patrimonio: GLOBAL.FormatREAL(String(data[0].patrimonio))
                };
            } catch (error) {
                console.error(error);
            }
        },
        generateSemestralChart () {
            const semestralOptions = {
                ...(0, $1RCBx.SEMESTRAL_CHART_DEFAULT_OPTIONS),
                dataLabels: {
                    enabled: false
                },
                yaxis: {
                    show: true,
                    decimalsInFloat: 2,
                    labels: {
                        formatter: (value, i)=>{
                            return GLOBAL.FormatREAL(String(value));
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        borderRadius: 6,
                        borderRadiusApplication: 'end',
                        borderRadiusWhenStacked: 'last',
                        columnWidth: '75%'
                    }
                }
            };
            this.chartSemestral = new ApexCharts(document.querySelector('#chart_semestral'), semestralOptions);
            this.chartSemestral.render();
        },
        generateNumClientsChart () {
            const numClientesOptions = {
                ...(0, $1RCBx.SEMESTRAL_CHART_DEFAULT_OPTIONS),
                dataLabels: {
                    enabled: false,
                    textAnchor: 'middle',
                    formatter: function(val) {
                        if (val <= 0) return;
                        return val;
                    },
                    background: {
                        enabled: true,
                        foreColor: '#840505',
                        dropShadow: {
                            enabled: true,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: '#000',
                            opacity: 0.1
                        }
                    },
                    offsetY: 15
                },
                yaxis: {
                    max: 150
                },
                plotOptions: {
                    bar: {
                        borderRadius: 6,
                        borderRadiusApplication: 'end',
                        borderRadiusWhenStacked: 'last',
                        columnWidth: '60%'
                    }
                }
            };
            this.chartNumClientes = new ApexCharts(document.querySelector('#chart_numClientes1'), numClientesOptions);
            this.chartNumClientes.render();
        }
    },
    async mounted () {
        this.url_filters = window.location.search;
        this.urlParams = new URLSearchParams(this.url_filters);
        const elPl = document.querySelector('#select_semestre_pl');
        const isSuperUser = document.querySelector('#superusuario').value;
        const params = isSuperUser === 'True' ? '?usuario_responsavel=todos' : '?';
        const search = this.url_filters?.length ? this.url_filters : params;
        const table = document.querySelector('#table_clientes_patrimonio');
        const paginatedBySelect = document.querySelector('.select-paginate-by');
        if (elPl) {
            const dataSelectSemestral = this.urlParams.get('semestre_pl');
            if (dataSelectSemestral) elPl.value = dataSelectSemestral;
            else {
                const optionDataAtual = Array.from(elPl.options).reduce((acc, item)=>{
                    if (acc) acc = new Date(item.value) > new Date(acc.value) ? item : acc;
                    else acc = item;
                    return acc;
                }, null);
                optionDataAtual.selected = true;
            }
        }
        if (document.querySelector('#select_semestre_clientes')) document.querySelector('#select_semestre_clientes').value = this.urlParams.get('semestre_clientes');
        if (document.querySelector('select[name="politica"]')) document.querySelector('select[name="politica"]').value = this.urlParams.get('politica');
        if (document.querySelector('select[name="faixa_ple"]')) document.querySelector('select[name="faixa_ple"]').value = this.urlParams.get('faixa_ple');
        this.generateSemestralChart();
        this.generateNumClientsChart();
        if (this.urlParams.get('ativos')) this.somaTotal = await $24e2392a903288ee$var$calculaSomaTotal(search);
        if (this.urlParams.get('emissores')) this.somaTotalEmissores = await $24e2392a903288ee$var$calculaSomaTotal(search, 'ativo_emissor_valor');
        window.tabela = this.geraTemplateTablePatrimonioCliente(search);
        await this.getBigNumbers(search);
        this.fillNumClientsChart(this.dados_semestre_clientes);
        this.fillSemestralChart(this.dados_semestre_pl);
        const gridSearch = document.querySelector('.gridjs-search');
        if (gridSearch) {
            document.querySelector('.gridjs-search-input').style.paddingLeft = '10px !important';
            gridSearch.insertAdjacentHTML('afterbegin', '<div class="absolute bottom-0 top-0 left-8 mx-0 my-auto h-fit"><svg class="w-24 h-20"><use xlink:href="#icon_search"></use></svg></div>');
        }
        if (this.urlParams.get('ativos')) {
            this.somaTotal = await $24e2392a903288ee$var$calculaSomaTotal(search);
            table.classList.add('ativos');
        } else table.classList.remove('ativos');
        if (this.urlParams.get('emissores')) {
            this.somaTotalEmissores = await $24e2392a903288ee$var$calculaSomaTotal(search, 'ativo_emissor_valor');
            table.classList.add('emissores');
        } else table.classList.remove('emissores');
        paginatedBySelect.addEventListener('change', async (e)=>{
            await window.tabela?.config.plugin.remove('pagination');
            await window.tabela?.config.plugin.remove('search');
            window.tabela?.updateConfig({
                pagination: {
                    enabled: true,
                    limit: e.target.value,
                    server: {
                        url: (urlApi, page, limit)=>{
                            return `${urlApi}&page=${++page}&paginate_by=${limit}${search.replace('?', '&')}`;
                        }
                    }
                }
            }).forceRender();
        });
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("9pxQa", function(module, exports) {

$parcel$export(module.exports, "useClientes", function () { return $6da0b2d771b9de56$export$64e4ca517aeb5cc3; });

var $26SB8 = parcelRequire("26SB8");

var $2m7Ys = parcelRequire("2m7Ys");
const { generateAvatarColor: $6da0b2d771b9de56$var$generateAvatarColor, formatReal2: $6da0b2d771b9de56$var$formatReal2, api: $6da0b2d771b9de56$var$api, convertDecimalInHexadecimal: $6da0b2d771b9de56$var$convertDecimalInHexadecimal, realToNumber: $6da0b2d771b9de56$var$realToNumber } = GLOBAL;
function $6da0b2d771b9de56$export$64e4ca517aeb5cc3() {
    let emissorFGCChart;
    function formatEmissorCell(cell, isEmissorName, clientId) {
        return cell ? (0, $26SB8.html)(html`
					<ul class="flex flex-col gap-8">
						${cell.map((i)=>`<li style="height: 22px;
									overflow: hidden;" title="${i}"><button class="text-left hover:bg-primary" ${isEmissorName ? `data-emissor="${i}" data-client="${clientId}"` : ''}>${i}</button></li>`).join('')}
					</ul>
			  `) : (0, $26SB8.html)(html``);
    }
    function formatOfficerCell(cell) {
        return cell ? (0, $26SB8.html)(html`
					<ul class="flex flex-col gap-8">
						${cell.filter((i)=>i != null && i !== '').map((i)=>`<li style="height: 22px;
									overflow: hidden;">
									${i.split('.').map((word)=>(0, $2m7Ys.capitalize)(word)).join(' ')}
									</li>`).join(' ')}
					</ul>
			  `) : (0, $26SB8.html)(html``);
    }
    function formatColumnsToTable({ foraFGC: foraFGC, foraFgcGeral: foraFgcGeral, foraFgcNao: foraFgcNao, emissores: emissores, ativos: ativos } = {
        foraFGC: false,
        foraFgcGeral: false,
        foraFgcNao: false,
        emissores: false,
        ativos: false
    }) {
        const urlParams = new URLSearchParams(window.location.search);
        const isFilter = urlParams.size > 1 || urlParams.size === 1 && !urlParams.has('usuario_responsavel');
        const columns = [
            {
                id: 'id',
                name: 'id',
                hidden: true
            },
            {
                id: 'politica',
                name: 'politica',
                hidden: true
            },
            {
                id: 'Nomes',
                name: 'Nomes',
                width: '320px',
                formatter: (cell, row)=>{
                    if (cell === 'Totalizador') return (0, $26SB8.html)(html`<div class="flex gap-4 items-center">
							${cell}
						</div>`);
                    else return cell ? (0, $26SB8.html)(html`<div class="flex gap-4 items-center">
									<div class="cursor-pointer">
										<div class="inline-flex justify-center">
											<svg
												class="h-40 w-40"
												style="${$6da0b2d771b9de56$var$generateAvatarColor(row.cells[1].data)}">
												<use xlink:href="#icon_person"></use>
											</svg>
										</div>
									</div>
									${cell}
							  </div>`) : (0, $26SB8.html)(html`<div class="flex gap-4 items-center"></div>`);
                }
            },
            {
                id: 'patrimonio',
                name: "Patrim\xf4nio",
                width: '150px',
                formatter: (cell)=>{
                    return cell ? `${$6da0b2d771b9de56$var$formatReal2(cell)}` : '';
                },
                sort: {
                    compare: (a, b)=>{
                        const numAConvert = Number(a);
                        const numBConvert = Number(b);
                        if (numAConvert > numBConvert) return 1;
                        else if (numBConvert > numAConvert) return -1;
                        else return 0;
                    }
                }
            },
            {
                id: 'ple',
                name: 'PLE',
                width: '150px',
                hidden: isFilter,
                formatter: (cell)=>{
                    return cell ? `${$6da0b2d771b9de56$var$formatReal2(cell)}` : '';
                },
                sort: {
                    compare: (a, b)=>{
                        const numAConvert = Number(a);
                        const numBConvert = Number(b);
                        if (numAConvert > numBConvert) return 1;
                        else if (numBConvert > numAConvert) return -1;
                        else return 0;
                    }
                }
            },
            {
                id: 'modelo_negocio',
                name: (0, $26SB8.html)('<div style="white-space: normal;">Modelo de neg\xf3cio</div>'),
                width: '150px',
                formatter: (cell)=>{
                    return cell;
                }
            },
            {
                id: 'officers',
                name: 'Officers',
                width: '150px',
                formatter: (cell)=>{
                    return cell ? formatOfficerCell(cell) : '';
                }
            }
        ];
        if (foraFGC) columns.push({
            id: 'emissores_hoje',
            name: 'Emissores fora do FGC hoje',
            width: '200px',
            formatter: (cell, row)=>formatEmissorCell(cell, true, row.cells[0].data)
        }, {
            id: 'excedente_hoje',
            name: 'Valor Excedente do FGC hoje',
            width: '200px',
            formatter: (cell)=>formatEmissorCell(cell),
            sort: {
                compare: (a, b)=>{
                    const totalNumA = a.reduce((acc, curr)=>acc + $6da0b2d771b9de56$var$realToNumber(curr), 0);
                    const totalNumB = b.reduce((acc, curr)=>acc + $6da0b2d771b9de56$var$realToNumber(curr), 0);
                    if (totalNumA > totalNumB) return 1;
                    else if (totalNumB > totalNumA) return -1;
                    return 0;
                }
            }
        });
        else if (foraFgcGeral) columns.push({
            id: 'emissores_fgc',
            name: 'Emissores fora do FGC',
            width: '200px',
            formatter: (cell, row)=>formatEmissorCell(cell, true, row.cells[0].data)
        }, {
            id: 'excedente_fgc',
            name: 'Valor Excedente do FGC',
            width: '200px',
            formatter: (cell)=>formatEmissorCell(cell),
            sort: {
                compare: (a, b)=>{
                    const totalNumA = a.reduce((acc, curr)=>acc + $6da0b2d771b9de56$var$realToNumber(curr), 0);
                    const totalNumB = b.reduce((acc, curr)=>acc + $6da0b2d771b9de56$var$realToNumber(curr), 0);
                    if (totalNumA > totalNumB) return 1;
                    else if (totalNumB > totalNumA) return -1;
                    return 0;
                }
            }
        });
        else if (!foraFgcNao) {
            if (ativos) columns.push({
                id: 'ativos',
                name: 'Ativos',
                width: '200px',
                formatter: (cell)=>{
                    return cell ? cell.join(', ') : '';
                }
            }, {
                id: 'patrimonio_ativo',
                name: "Patrim\xf4nio por ativo",
                width: '200px',
                sort: {
                    compare: (a, b)=>{
                        if (a[0] > b[0]) return 1;
                        else if (b[0] > a[0]) return -1;
                        else return 0;
                    }
                },
                formatter: (cell)=>{
                    let list = cell && cell?.map((i)=>{
                        return $6da0b2d771b9de56$var$formatReal2(i);
                    });
                    return list ? list.join(', ') : '';
                }
            }, {
                id: 'pr_carteira',
                name: 'Pr. carteira',
                width: '150px',
                formatter: (cell)=>{
                    return cell ? cell.join(', ') : '';
                },
                sort: {
                    compare: (a, b)=>{
                        if (a[0] > b[0]) return 1;
                        else if (b[0] > a[0]) return -1;
                        else return 0;
                    }
                }
            }, {
                id: 'pr_ativo',
                name: 'Pr. ativo por categoria',
                width: '220px',
                formatter: (cell)=>{
                    return cell ? cell.join(', ') : '';
                },
                sort: {
                    compare: (a, b)=>{
                        if (a[0] > b[0]) return 1;
                        else if (b[0] > a[0]) return -1;
                        else return 0;
                    }
                }
            });
            if (emissores) columns.push({
                id: 'emissores',
                name: 'Emissores',
                width: '200px',
                formatter: (cell)=>{
                    return cell ? cell.join(', ') : '';
                },
                sort: {
                    compare: (a, b)=>{
                        if (a > b) return 1;
                        else if (b > a) return -1;
                        return 0;
                    }
                }
            }, {
                id: 'patrimonio_emissor',
                name: "Patrim\xf4nio por emissor",
                width: '250px',
                formatter: (cell)=>{
                    let list = cell && cell?.map((i)=>{
                        return $6da0b2d771b9de56$var$formatReal2(i);
                    });
                    return list ? list.join(', ') : '';
                },
                sort: {
                    compare: (a, b)=>{
                        const numAConvert = Number(a[0]);
                        const numBConvert = Number(b[0]);
                        if (numAConvert > numBConvert) return 1;
                        else if (numBConvert > numAConvert) return -1;
                        else return 0;
                    }
                }
            }, {
                id: 'emissor_rf',
                name: (0, $26SB8.html)('<div style="white-space: normal;">Percentual emissor RF (%)</div>'),
                width: '180px',
                formatter: (cell)=>{
                    return cell ? cell.join(', ') : '';
                },
                sort: {
                    compare: (a, b)=>{
                        const numAConvert = Number(a[0]);
                        const numBConvert = Number(b[0]);
                        if (numAConvert > numBConvert) return 1;
                        else if (numBConvert > numAConvert) return -1;
                        else return 0;
                    }
                }
            }, {
                id: 'emissor_global',
                name: (0, $26SB8.html)('<div style="white-space: normal;">Percentual emissor Global (%)</div>'),
                width: '215px',
                formatter: (cell)=>{
                    return cell ? cell.join(', ') : '';
                },
                sort: {
                    compare: (a, b)=>{
                        const numAConvert = Number(a[0]);
                        const numBConvert = Number(b[0]);
                        if (numAConvert > numBConvert) return 1;
                        else if (numBConvert > numAConvert) return -1;
                        else return 0;
                    }
                }
            });
        }
        return columns;
    }
    function onTableFetchServer(search, { foraFGC: foraFGC, ativos: ativos, emissores: emissores, foraFgcGeral: foraFgcGeral, foraFgcNao: foraFgcNao, somaTotal: somaTotal, somaTotalEmissores: somaTotalEmissores }) {
        return {
            url: `${window.origin}/api/tabela_clientepf/principais_clientes/${search}`,
            then: (data)=>{
                let list = [];
                if (foraFGC) list = data?.results?.map((item)=>({
                        ...item,
                        emissores_fora_fgc_hj: item?.emissores_fora_fgc_hj ? item.emissores_fora_fgc_hj.map((i)=>i[0]) : [],
                        emissores_fora_fgc_hj_valor: item.emissores_fora_fgc_hj ? item.emissores_fora_fgc_hj.map((i)=>$6da0b2d771b9de56$var$formatReal2(i[1])) : []
                    }));
                else if (foraFgcGeral) list = data?.results?.map((item)=>({
                        ...item,
                        emissores_fora_fgc_geral: item?.emissores_fora_fgc_geral ? item.emissores_fora_fgc_geral.map((i)=>i[0]) : [],
                        emissores_fora_fgc_geral_valor: item?.emissores_fora_fgc_geral ? item.emissores_fora_fgc_geral.map((i)=>$6da0b2d771b9de56$var$formatReal2(i[1])) : []
                    }));
                else list = data?.results;
                setTimeout(()=>{
                    const emissoresBtns = Array.from(document.querySelectorAll('[data-emissor]'));
                    emissoresBtns.forEach((btn)=>{
                        btn.addEventListener('click', (event)=>openEmissorFGCAtivosModal(event, btn.dataset.emissor, Number(btn.dataset.client)));
                    });
                }, 1000);
                list = list.map((itemList)=>{
                    const modelos = [];
                    if (itemList.consultoria) modelos.push('Consultoria');
                    if (itemList.gestao) modelos.push("Gest\xe3o");
                    if (itemList.distribuicao) modelos.push("Distribui\xe7\xe3o");
                    let modelo_negocio = modelos?.join(', ');
                    return {
                        ...itemList,
                        modelo_negocio: modelo_negocio
                    };
                });
                return generateArrayDataForTable(list, ativos, emissores, foraFGC, foraFgcGeral, foraFgcNao, somaTotal, somaTotalEmissores);
            },
            total: (data)=>data.count
        };
    }
    async function openEmissorFGCAtivosModal(event, emissorName, clientId) {
        event.stopPropagation();
        if (emissorFGCChart && emissorFGCChart instanceof ApexCharts) emissorFGCChart.destroy();
        modal_padrao_vue.openModal('emissor_fgc_ativos');
        const response = await $6da0b2d771b9de56$var$api.get(`/api/tabela_clientepf/detalhes_emissor_fora_fgc/?cliente=${clientId}&emissor=${emissorName}`);
        const { emissor: emissor, faixa_fgc: faixa_fgc, ativos: ativos } = response.data;
        let ativosFormatted = {};
        ativos.forEach((ativo)=>ativo.detalhes.forEach((ativoDetalhe)=>{
                if (!ativosFormatted[ativoDetalhe.ativo]) ativosFormatted[ativoDetalhe.ativo] = [];
                ativosFormatted[ativoDetalhe.ativo].push(ativoDetalhe.valor_rentabilizado);
            }));
        emissorFGCChart = new ApexCharts(document.getElementById('chart-emissor-fgc-ativos'), {
            title: {
                text: emissor,
                align: 'center',
                style: {
                    marginBottom: '16px',
                    color: '#000'
                }
            },
            chart: {
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                }
            },
            series: Object.entries(ativosFormatted).map(([key, value])=>({
                    name: key,
                    data: value
                })),
            xaxis: {
                type: 'category',
                categories: ativos.map((ativo)=>ativo.vencimento)
            },
            yaxis: {
                labels: {
                    formatter: (value)=>{
                        return $6da0b2d771b9de56$var$formatReal2(value);
                    }
                }
            },
            dataLabels: {
                enabled: false,
                background: {
                    borderWidth: 0
                }
            },
            colors: Object.keys(ativosFormatted).map((_, index)=>`#0E4A65${$6da0b2d771b9de56$var$convertDecimalInHexadecimal(255 - index * 15)}`),
            annotations: {
                yaxis: [
                    {
                        y: faixa_fgc,
                        strokeDashArray: 10,
                        borderColor: '#222222',
                        borderWidth: 2,
                        borderRadius: 4,
                        fillColor: '#222',
                        label: {
                            text: 'Faixa FGC'
                        }
                    }
                ]
            },
            legend: {
                show: true,
                showForSingleSeries: true,
                showForNullSeries: true,
                showForZeroSeries: true,
                fontSize: '10px',
                fontFamily: 'Roboto Flex, sans-serif',
                fontWeight: 400
            }
        });
        emissorFGCChart.render();
    }
    function generateArrayDataForTable(list, ativos, emissores, fora_fgc, fora_fgc_geral, fora_fgc_nao, soma_total, soma_total_emissores) {
        const array = list.map(({ id: id, politica: politica, nome: nome, patrimonio_interno: patrimonio_interno, patrimonio_externo: patrimonio_externo, modelo_negocio: modelo_negocio, usuario_responsavel: usuario_responsavel, emissores_fora_fgc_hj: emissores_fora_fgc_hj, emissores_fora_fgc_hj_valor: emissores_fora_fgc_hj_valor, emissores_fora_fgc_geral: emissores_fora_fgc_geral, emissores_fora_fgc_geral_valor: emissores_fora_fgc_geral_valor, ativo_nome: ativo_nome, ativo_emissor_porcentagem: ativo_emissor_porcentagem, ativo_emissor_valor: ativo_emissor_valor, ativo_emissor_porcentagem_rf: ativo_emissor_porcentagem_rf, ativo_emissor: ativo_emissor, ativo_nome_valor: ativo_nome_valor, ativo_nome_porcentagem: ativo_nome_porcentagem, ativo_nome_porcentagem_rf: ativo_nome_porcentagem_rf })=>{
            if (fora_fgc_nao) return [
                id,
                politica,
                nome,
                patrimonio_interno,
                patrimonio_externo,
                modelo_negocio,
                usuario_responsavel
            ];
            else if (fora_fgc) return [
                id,
                politica,
                nome,
                patrimonio_interno,
                patrimonio_externo,
                modelo_negocio,
                usuario_responsavel,
                emissores_fora_fgc_hj,
                emissores_fora_fgc_hj_valor
            ];
            else if (fora_fgc_geral) return [
                id,
                politica,
                nome,
                patrimonio_interno,
                patrimonio_externo,
                modelo_negocio,
                usuario_responsavel,
                emissores_fora_fgc_geral,
                emissores_fora_fgc_geral_valor
            ];
            else if (ativos && emissores) return [
                id,
                politica,
                nome,
                patrimonio_interno,
                patrimonio_externo,
                modelo_negocio,
                usuario_responsavel,
                ativo_nome,
                ativo_emissor_porcentagem,
                ativo_emissor_porcentagem_rf,
                ativo_emissor_valor,
                ativo_emissor,
                ativo_nome_valor,
                ativo_nome_porcentagem,
                ativo_nome_porcentagem_rf
            ];
            else if (ativos) return [
                id,
                politica,
                nome,
                patrimonio_interno,
                patrimonio_externo,
                modelo_negocio,
                usuario_responsavel,
                ativo_nome,
                ativo_nome_valor,
                ativo_nome_porcentagem,
                ativo_nome_porcentagem_rf
            ];
            else if (emissores) return [
                id,
                politica,
                nome,
                patrimonio_interno,
                patrimonio_externo,
                modelo_negocio,
                usuario_responsavel,
                ativo_emissor,
                ativo_emissor_valor,
                ativo_emissor_porcentagem,
                ativo_emissor_porcentagem_rf
            ];
            else return [
                id,
                politica,
                nome,
                patrimonio_interno,
                patrimonio_externo,
                modelo_negocio,
                usuario_responsavel
            ];
        });
        if (ativos && soma_total.length >= 0 && emissores && soma_total_emissores.length >= 0) array.push([
            '',
            '',
            'Totalizador',
            '',
            '',
            '',
            '',
            '',
            soma_total,
            '',
            '',
            '',
            soma_total_emissores
        ]);
        else if (ativos && soma_total.length >= 0 && !emissores) array.push([
            12222,
            '',
            'Totalizador',
            '',
            '',
            '',
            '',
            '',
            soma_total,
            '',
            '',
            ''
        ]);
        else if (!ativos && emissores && soma_total_emissores.length >= 0) array.push([
            '',
            '',
            'Totalizador',
            '',
            '',
            '',
            '',
            '',
            soma_total_emissores,
            '',
            '',
            ''
        ]);
        return array;
    }
    async function getDadosTablePatrimonioCliente(params) {
        try {
            const request = await $6da0b2d771b9de56$var$api.get(`api/tabela_clientepf/principais_clientes/${params}`);
            return request.data?.results;
        } catch (error) {
            console.error(error);
        }
    }
    function createPatrimonioClienteTable(search, { foraFGC: foraFGC, foraFgcGeral: foraFgcGeral, foraFgcNao: foraFgcNao, emissores: emissores, ativos: ativos, somaTotal: somaTotal, somaTotalEmissores: somaTotalEmissores, by: by }) {
        return new (0, $26SB8.Grid)({
            resizable: true,
            columns: formatColumnsToTable({
                foraFGC: foraFGC,
                foraFgcGeral: foraFgcGeral,
                foraFgcNao: foraFgcNao,
                emissores: emissores,
                ativos: ativos
            }),
            autoWidth: true,
            width: '100%',
            sort: true,
            server: onTableFetchServer(search, {
                foraFGC: foraFGC,
                foraFgcNao: foraFgcNao,
                foraFgcGeral: foraFgcGeral,
                ativos: ativos,
                emissores: emissores,
                somaTotal: somaTotal,
                somaTotalEmissores: somaTotalEmissores
            }),
            search: {
                debounceTimeout: 500,
                server: {
                    url: (prev, keyword)=>{
                        return `${prev}&search=${keyword}&paginate_by=9999`;
                    }
                }
            },
            pagination: {
                enabled: true,
                limit: by ?? 10,
                server: {
                    url: (urlApi, page, limit)=>{
                        return `${urlApi}&page=${++page}&paginate_by=${limit}`;
                    }
                }
            },
            style: {
                container: {
                    border: 'none'
                },
                table: {
                    border: 'none'
                },
                tr: {
                    border: 'none'
                },
                th: {
                    'border-bottom': '1px solid #e9ecef'
                },
                td: {
                    'border-bottom': '1px solid #e9ecef',
                    cursor: 'pointer'
                },
                footer: {
                    border: 'none'
                }
            },
            language: {
                search: {
                    placeholder: 'Busque aqui...'
                },
                pagination: {
                    previous: '<',
                    next: '>',
                    to: '/',
                    of: 'de',
                    showing: 'Mostrando',
                    results: ()=>'Resultados'
                }
            }
        });
    }
    async function calculaSomaTotal(params, tipo = 'ativo_nome_valor') {
        const list = await getDadosTablePatrimonioCliente(`?${params}&paginate_by=99999`);
        let somaTotal = [];
        for(let i = 0; i <= list.length - 1; i++){
            let valores = [];
            let soma = 0;
            list?.forEach((item)=>{
                if (item[tipo][i]) valores.push(item[tipo][i]);
            });
            valores.forEach((item)=>{
                soma += Number(item);
            });
            if (soma !== 0) somaTotal.push(soma);
        }
        return somaTotal;
    }
    return {
        createPatrimonioClienteTable: createPatrimonioClienteTable,
        formatColumnsToTable: formatColumnsToTable,
        generateArrayDataForTable: generateArrayDataForTable,
        getDadosTablePatrimonioCliente: getDadosTablePatrimonioCliente,
        onTableFetchServer: onTableFetchServer,
        calculaSomaTotal: calculaSomaTotal
    };
}

});

parcelRegister("1RCBx", function(module, exports) {

$parcel$export(module.exports, "SEMESTRAL_CHART_CURRENT_DEFAULT_VALUE", function () { return $15b8afb8ddb4ae36$export$e8423b596d1767b1; });
$parcel$export(module.exports, "SEMESTRAL_CHART_DEFAULT_OPTIONS", function () { return $15b8afb8ddb4ae36$export$ed5330d7ee7407b8; });
function $15b8afb8ddb4ae36$var$getSemestralChartColors({ dataPointIndex: dataPointIndex }) {
    switch(dataPointIndex){
        case 0:
            return '#840505';
        case 1:
            return '#D83232';
        case 2:
            return '#FF8787';
        case 3:
            return '#6D6F71';
        case 4:
            return '#B8BCBF';
    }
}
const $15b8afb8ddb4ae36$export$e8423b596d1767b1 = {
    num_clientes_ultra_high: 0,
    num_clientes_private: 0,
    num_clientes_premium: 0,
    num_clientes_na: 0,
    num_clientes_distribuicao: 0,
    semestre: ''
};
const $15b8afb8ddb4ae36$export$ed5330d7ee7407b8 = {
    series: [
        {
            name: 'Atual',
            data: []
        },
        {
            name: 'Sel.',
            data: []
        }
    ],
    chart: {
        type: 'bar',
        height: 180,
        toolbar: {
            show: false
        },
        zoom: {
            enabled: false
        }
    },
    stroke: {
        curve: 'straight'
    },
    xaxis: {
        labels: {
            show: true
        },
        type: 'category',
        categories: [
            'Sel. - Atual',
            'Sel. - Atual',
            'Sel. - Atual',
            'Sel. - Atual'
        ]
    },
    colors: [
        $15b8afb8ddb4ae36$var$getSemestralChartColors
    ],
    legend: {
        show: false
    }
};

});

parcelRegister("8Pv07", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66db224395bf9389$export$2e2bcd8739ae039; });

var $9pxQa = parcelRequire("9pxQa");

var $7h4Zs = parcelRequire("7h4Zs");
const { api: $66db224395bf9389$var$api } = GLOBAL;
const { formatColumnsToTable: $66db224395bf9389$var$formatColumnsToTable, onTableFetchServer: $66db224395bf9389$var$onTableFetchServer, generateArrayDataForTable: $66db224395bf9389$var$generateArrayDataForTable, calculaSomaTotal: $66db224395bf9389$var$calculaSomaTotal } = (0, $9pxQa.useClientes)();
NProgress.configure({
    trickleSpeed: 40,
    trickle: true,
    minimum: 0.65
});
var $66db224395bf9389$export$2e2bcd8739ae039 = {
    props: [
        'text',
        'limpar',
        'submit'
    ],
    emits: [
        'get:big'
    ],
    data () {
        return {
            MODEL_DEFAULT_VALUE: {
                ple: '',
                modelo_negocio: '',
                tags: [],
                ativos: [],
                emissores: [],
                d_perfil: '',
                d_perfil_quantitativo: [],
                d_perfil_quantitativo_simples: [],
                perfil_liquidez: '',
                perfil_volatilidade: '',
                vencimento: '',
                fora_fgc: '',
                usuario_responsavel: ''
            },
            filters_url: '',
            dataSelectFilterAtivo: [],
            dataSelectFilterEmissor: [],
            ativos: [],
            emissores: [],
            usuarios: [],
            usuariosCopy: [],
            usuario_responsavel: '',
            model: {
                ple: '',
                modelo_negocio: '',
                tags: [],
                ativos: [],
                emissores: [],
                d_perfil: '',
                d_perfil_quantitativo: [],
                d_perfil_quantitativo_simples: [],
                perfil_liquidez: '',
                perfil_volatilidade: '',
                vencimento: '',
                fora_fgc: '',
                usuario_responsavel: ''
            },
            somaTotal: [],
            somaTotalEmissores: [],
            options: {
                ple: [],
                modelo_negocio: [
                    {
                        id: 'consultoria',
                        nome: 'consultoria'
                    },
                    {
                        id: 'gestao',
                        nome: 'gestao'
                    },
                    {
                        id: 'distribuicao',
                        nome: 'distribuicao'
                    }
                ],
                tags: [],
                d_perfil: [
                    {
                        id: 'True',
                        nome: 'Sim'
                    },
                    {
                        id: 'False',
                        nome: "N\xe3o"
                    }
                ],
                d_perfil_quantitativo: [],
                d_perfil_quantitativo_simples: [],
                foraFGC: [],
                perfil_liquidez: [
                    {
                        id: 'False',
                        nome: 'Enquadrado'
                    },
                    {
                        id: 'True',
                        nome: 'Desenquadrado'
                    }
                ],
                perfil_volatilidade: [
                    {
                        id: 'False',
                        nome: 'Enquadrado'
                    },
                    {
                        id: 'True',
                        nome: 'Desenquadrado'
                    }
                ],
                perfil_rentabilidade: [
                    {
                        id: 'True',
                        nome: 'Enquadrado'
                    },
                    {
                        id: 'False',
                        nome: 'Desenquadrado'
                    }
                ]
            },
            optionsCopy: {}
        };
    },
    components: {
        SelectMultiple: $7h4Zs.default
    },
    methods: {
        async onCleanFilter () {
            this.model = {
                ...this.MODEL_DEFAULT_VALUE
            };
            this.ativos = [];
            this.emissores = [];
            const superUsuario = document.querySelector('#superusuario').value;
            const usuarioLogado = document.querySelector('#usuario-logado').value;
            this.usuario_responsavel = superUsuario === 'True' ? 'todos' : usuarioLogado;
            const form = document.querySelector('#form-create-filtros');
            form.querySelectorAll('input').forEach((i)=>{
                i.value = '';
            });
            const url = new URL(location);
            url.search = superUsuario === 'True' ? '&usuario_responsavel=todos' : `?usuario_responsavel=${usuarioLogado}`;
            history.pushState({}, '', url);
            const by = document.querySelector('.select-paginate-by').value;
            await window.tabela.config.plugin.remove('pagination');
            await window.tabela.config.plugin.remove('search');
            this.$emit('get:big', url.search);
            const table = document.querySelector('#table_clientes_patrimonio');
            table.classList.remove('ativos');
            const tableUpdateOptions = {
                columns: $66db224395bf9389$var$formatColumnsToTable(),
                server: {
                    url: `${window.origin}/api/tabela_clientepf/principais_clientes/${url.search}`,
                    then: (data)=>{
                        let listWithModeloNegocio = data.results.map((itemList)=>{
                            const modelos = [];
                            if (itemList.consultoria) modelos.push('Consultoria');
                            if (itemList.gestao) modelos.push("Gest\xe3o");
                            if (itemList.distribuicao) modelos.push("Distribui\xe7\xe3o");
                            let modelo_negocio = modelos?.join(', ');
                            return {
                                ...itemList,
                                modelo_negocio: modelo_negocio
                            };
                        });
                        const list = $66db224395bf9389$var$generateArrayDataForTable(listWithModeloNegocio);
                        return list;
                    },
                    total: (data)=>data.count
                },
                pagination: {
                    enabled: true,
                    limit: by,
                    server: {
                        url: (urlApi, page, limit)=>{
                            return `${urlApi}&page=${++page}&paginate_by=${limit}`;
                        }
                    }
                }
            };
            window.tabela.updateConfig(tableUpdateOptions)?.forceRender();
        },
        async limparFiltros () {
            const btnLimparFiltros = document.querySelector('.limpar-filtros');
            btnLimparFiltros?.addEventListener('click', this.onCleanFilter);
        },
        async getDataFilter () {
            NProgress.start();
            try {
                const { data: data } = await $66db224395bf9389$var$api.get('api/tabela_clientepf/filtros_principais_clientes/?x=');
                NProgress.done();
                return data;
            } catch (error) {
                console.error(error);
            }
        },
        async popularSelectsFilter () {
            const urlParams = new URLSearchParams(window.location.search);
            const idsAtivos = urlParams.get('ativos')?.trim().split(',');
            const idsEmissores = urlParams.get('emissores')?.trim().split(',');
            const filtersPerfilQtd = urlParams.get('d_perfil_quantitativo')?.trim().split(',');
            const filtersPerfilSimplesQtd = urlParams.get('d_perfil_simples_quantitativo')?.trim().split(',');
            const idsTags = urlParams.get('tag')?.trim().split(',');
            this.ativos = this.dataSelectFilterAtivo.filter((item)=>{
                return idsAtivos?.some((i)=>i == item.value);
            });
            this.emissores = this.dataSelectFilterEmissor.filter((item)=>{
                return idsEmissores?.some((i)=>i == item.value);
            });
            this.model.d_perfil_quantitativo = this.options.d_perfil_quantitativo.filter((item)=>{
                return filtersPerfilQtd?.some((i)=>i == item.value);
            });
            this.model.d_perfil_quantitativo = this.options.d_perfil_quantitativo_simples.filter((item)=>{
                return filtersPerfilSimplesQtd?.some((i)=>i == item.value);
            });
            this.usuario_responsavel = urlParams.get('usuario_responsavel') ?? '';
            this.model.ple = urlParams.get('faixa_ple') ?? '';
            this.model.modelo_negocio = urlParams.get('modelo_negocio') ?? '';
            this.model.fora_fgc = urlParams.get('fora_fgc') ?? '';
            this.model.perfil_liquidez = urlParams.get('perfil_liquidez') ?? '';
            this.model.perfil_volatilidade = urlParams.get('perfil_volatilidade') ?? '';
            this.model.d_perfil = urlParams.get('d_perfil') ?? '';
            this.model.d_perfil_simples = urlParams.get('d_perfil_simples') ?? '';
            this.model.tags = this.options.tags.filter((item)=>{
                return idsTags?.some((i)=>i == item.value);
            });
        },
        async submitDropdown (e) {
            e.preventDefault();
            e.stopPropagation();
            // const superUsuario = document.querySelector('#superusuario').value
            // const usuarioLogado = document.querySelector('#usuario-logado').value
            // this.usuario_responsavel = superUsuario === 'True' ? 'todos' : usuarioLogado
            let search = '';
            search += `&faixa_ple=${this.model.ple ?? ''}`;
            search += `&modelo_negocio=${this.model?.modelo_negocio ?? ''}`;
            search += `&fora_fgc=${this.model?.fora_fgc ?? ''}`;
            search += `&perfil_liquidez=${this.model?.perfil_liquidez ?? ''}`;
            search += `&perfil_volatilidade=${this.model?.perfil_volatilidade ?? ''}`;
            search += `&d_perfil=${this.model?.d_perfil ?? ''}`;
            search += `&d_perfil_simples=${this.model?.d_perfil_simples ?? ''}`;
            search += `&d_perfil_quantitativo=${this.model?.d_perfil_quantitativo.map((item)=>item.value).join(',')}`;
            search += `&d_perfil_simples_quantitativo=${this.model?.d_perfil_quantitativo_simples.map((item)=>item.value).join(',')}`;
            search += `&usuario_responsavel=${this.usuario_responsavel}`;
            search += `&ativos=${this.ativos.map((ativo)=>ativo.value).join(',')}`;
            search += `&emissores=${this.emissores.map((emissor)=>emissor.value).join(',')}`;
            search += `&tag=${this.model.tags.map((ativo)=>ativo.value).join(',')}`;
            const url = new URL(location);
            this.filters_url = `?${search}`;
            url.search = search;
            history.pushState({}, '', url);
            const by = document.querySelector('.select-paginate-by')?.value;
            const urlParams = new URLSearchParams(window.location.search);
            const foraFGC = urlParams.get('fora_fgc') == 'Fora do FGC hoje';
            const foraFgcGeral = urlParams.get('fora_fgc') == 'Sim';
            const foraFgcNao = urlParams.get('fora_fgc') == "N\xe3o";
            if (foraFgcGeral || foraFGC) {
                search += `&emissores_fora_fgc_geral=${this.emissores.map((emissor)=>emissor.value).join(',')}`;
                this.filters_url = `?${search}`;
                url.search = search;
                history.pushState({}, '', url);
            }
            const hasEmissor = this.emissores.length > 0;
            const hasAtivo = this.ativos.length > 0;
            const table = document.querySelector('#table_clientes_patrimonio');
            this.$emit('get:big', search);
            await window.tabela?.config.plugin.remove('pagination');
            await window.tabela?.config.plugin.remove('search');
            if (hasAtivo) {
                this.somaTotal = await $66db224395bf9389$var$calculaSomaTotal(search);
                table.classList.add('ativos');
            } else table.classList.remove('ativos');
            if (hasEmissor) {
                this.somaTotalEmissores = await $66db224395bf9389$var$calculaSomaTotal(search, 'ativo_emissor_valor');
                table.classList.add('emissores');
            } else table.classList.remove('emissores');
            const tableUpdateOptions = {
                columns: $66db224395bf9389$var$formatColumnsToTable({
                    foraFGC: foraFGC,
                    foraFgcGeral: foraFgcGeral,
                    foraFgcNao: foraFgcNao,
                    emissores: hasEmissor,
                    ativos: hasAtivo
                }),
                server: $66db224395bf9389$var$onTableFetchServer(this.filters_url, {
                    foraFGC: foraFGC,
                    emissores: hasEmissor,
                    ativos: hasAtivo,
                    foraFgcGeral: foraFgcGeral,
                    foraFgcNao: foraFgcNao,
                    somaTotal: this.somaTotal,
                    somaTotalEmissores: this.somaTotalEmissores
                }),
                pagination: {
                    enabled: true,
                    limit: by,
                    server: {
                        url: (urlApi, page, limit)=>{
                            return `${urlApi}&page=${++page}&paginate_by=${limit}${search}`;
                        }
                    }
                }
            };
            window.tabela?.updateConfig(tableUpdateOptions).forceRender();
            this.closeModalFiltros();
        },
        closeModalFiltros () {
            modal_padrao_vue.closeModal('criar_filtros');
        },
        addFlatPickerInputs () {
            const inputs = document.querySelectorAll('[type=date]:not([type=hidden])');
            inputs.forEach((i)=>{
                GLOBAL.initFlatpickr(i, {
                    position: 'above',
                    mode: 'range'
                });
            });
        },
        setOptionsSelectsFilter (data) {
            this.dataSelectFilterAtivo = data.ativos.map((ativo)=>({
                    value: ativo.id,
                    label: ativo.nome
                }));
            this.dataSelectFilterEmissor = data.emissores.map(({ emissor: emissor })=>({
                    value: emissor,
                    label: emissor
                }));
            this.usuarios = data.responsaveis;
            this.usuariosCopy = data.responsaveis;
            this.options.ple = data.range_ple;
            this.options.fora_fgc = data.ativos_fora_fgc;
            this.options.tags = data.tags.map(({ id: id, titulo: titulo })=>({
                    value: id,
                    label: titulo
                }));
            this.options.d_perfil_qualitativo = data.desenquadrado_perfil.map(([value, label])=>({
                    id: value,
                    nome: label
                }));
            this.options.d_perfil_quantitativo = data.desenquadramentos_quantitativos.map((item)=>{
                return {
                    value: item,
                    label: item.includes('(Anual)') ? item.replace('(Anual)', '(12 meses)') : item
                };
            });
            this.options.d_perfil_quantitativo_simples = data.desenquadramentos_quantitativos.map((item)=>{
                return {
                    value: item,
                    label: item.includes('(Anual)') ? item.replace('(Anual)', '(12 meses)') : item
                };
            });
            this.optionsCopy = structuredClone(Vue.toRaw(this.options));
        },
        filterSelectUsuariosInput (val, update, abort) {
            if (!val || val?.length < 1) {
                update(()=>{
                    this.usuariosCopy = this.usuarios;
                });
                return;
            }
            const usuariosFiltered = this.usuarios.filter((item)=>{
                return item.nome.toLowerCase().includes(val.toLowerCase());
            });
            update(()=>{
                this.usuariosCopy = usuariosFiltered;
            });
        },
        filterSelectChangeInput (val, update, abort, fieldTarget) {
            if (!val || val?.length < 1) {
                update(()=>{
                    this.optionsCopy[fieldTarget] = this.options[fieldTarget];
                });
                return;
            }
            const filterTarget = this.options[fieldTarget];
            const filterFlatFields = filterTarget?.filter((item)=>{
                if (typeof item === 'object') return Object.values(item).some((value)=>typeof value === 'string' && value.toLowerCase().includes(val.toLowerCase()));
                else if (typeof item === 'string') return item.toLowerCase().includes(val.toLowerCase());
                return true;
            });
            update(()=>{
                this.optionsCopy[fieldTarget] = filterFlatFields;
            });
        }
    },
    async mounted () {
        const data = await this.getDataFilter();
        this.setOptionsSelectsFilter(data);
        this.limparFiltros();
        const urlParams = new URLSearchParams(window.location.search);
        this.filters_url = window.location.search;
        this.addFlatPickerInputs();
        await this.popularSelectsFilter(data);
        const superUsuario = document.querySelector('#superusuario').value;
        const usuarioLogado = document.querySelector('#usuario-logado').value;
        this.usuario_responsavel = superUsuario === 'True' ? 'todos' : usuarioLogado;
        if (superUsuario === 'True' && !urlParams.get('usuario_responsavel')) this.usuario_responsavel = 'todos';
        else if (urlParams.get('usuario_responsavel') === 'todos') this.usuario_responsavel = urlParams.get('usuario_responsavel');
        else this.usuario_responsavel = Number(usuarioLogado);
    },
    template: html`
		<section
			class="modal--content rounded-md flex-1 !h-max overflow-[initial] modal_filtros "
			data-id="criar_filtros">
			<header
				class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
				<h2 class="text-lg font-medium text-white">Filtros</h2>
				<button
					type="button"
					class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
					data-xclose="modal_padrao_vue">
					<svg class="w-32 h-32">
						<use xlink:href="#icon_close"></use>
					</svg>
				</button>
			</header>

			<form
				class="w-full flex-wrap grid grid-cols-2 gap-24  !h-[500px] overflow-y-scroll px-24 pt-24 items-start filter-novo-dashboard-sap radio-container round size-16 "
				id="form-create-filtros">
				<div class="flex flex-col gap-16">
					<div>
						<p class="text-sm text-neutral-100 font-medium">Gerais</p>
						<hr class="text-neutral-80" />
					</div>
					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Usuário responsável
						</label>

						<q-select
							dense
							id="usuario_responsavel"
							name="usuario_responsavel"
							outlined
							use-input
							map-options
							emit-value
							option-label="nome"
							option-value="id"
							v-model="usuario_responsavel"
							:options="usuariosCopy"
							input-debounce="1000"
							@filter="filterSelectUsuariosInput">
						</q-select>
					</div>

					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium"> PLE </label>

						<q-select
							id="faixa_ple"
							name="faixa_ple"
							input-debounce="300"
							dense
							outlined
							use-input
							map-options
							emit-value
							option-label="nome"
							option-value="id"
							v-model="model.ple"
							:options="optionsCopy.ple"
							@filter="(val, update, abort) => filterSelectChangeInput(val, update, abort, 'ple')">
						</q-select>
					</div>
					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Modelo de negócio
						</label>

						<q-select
							id="modelo_negocio"
							name="modelo_negocio"
							input-debounce="300"
							dense
							outlined
							use-input
							map-options
							emit-value
							option-label="nome"
							option-value="id"
							v-model="model.modelo_negocio"
							:options="optionsCopy.modelo_negocio"
							@filter="(val, update, abort) => filterSelectChangeInput(val, update, abort, 'modelo_negocio')">
						</q-select>
					</div>
					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Fora do FGC
						</label>

						<q-select
							id="fora_fgc"
							name="fora_fgc"
							input-debounce="300"
							dense
							outlined
							use-input
							map-options
							emit-value
							option-label="nome"
							option-value="id"
							v-model="model.fora_fgc"
							:options="optionsCopy.fora_fgc"
							@filter="(val, update, abort) => filterSelectChangeInput(val, update, abort, 'fora_fgc')">
						</q-select>
					</div>

					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Desenquadrado Quantitativo
						</label>
						<select-multiple
							:model="model.d_perfil_quantitativo_simples"
							:options="options.d_perfil_quantitativo_simples"
							@changed="(val) => model.d_perfil_quantitativo_simples = val"
							:submitfc="() => {}">
						</select-multiple>
					</div>

					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Selecione as tags
						</label>
						<select-multiple
							:model="model.tags"
							:options="options.tags"
							@changed="(val) => model.tags = val"
							:submitfc="() => {}">
						</select-multiple>
					</div>

					<input type="hidden" class="invisible" name="tag" value="" />
					<!-- <div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Selecione o intervalo de vencimento
						</label>
						<input
							ref="data"
							type="date"
							name="vencimento"
							placeholder="DD/MM/AAAA - DD/MM/AAAA"
							class="w-full p-10 input-text h-48" />
					</div> -->

					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Selecione os ativos
						</label>
						<select-multiple
							:model="ativos"
							:options="dataSelectFilterAtivo"
							@changed="(val) => ativos = val"
							:submitfc="() => {}">
						</select-multiple>
					</div>

					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Selecione os emissores
						</label>
						<select-multiple
							:model="emissores"
							:options="dataSelectFilterEmissor"
							@changed="(val) => emissores = val"
							:submitfc="() => {}">
						</select-multiple>
					</div>
				</div>
				<div class="flex flex-col gap-16">
					<div>
						<p class="text-sm text-neutral-100 font-medium">
							Perfil do Investidor
						</p>
						<hr class="text-neutral-80" />
					</div>
					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Concentração
						</label>

						<q-select
							id="d_perfil"
							name="d_perfil"
							input-debounce="300"
							dense
							outlined
							use-input
							map-options
							emit-value
							option-label="nome"
							option-value="id"
							v-model="model.d_perfil"
							:options="optionsCopy.d_perfil_qualitativo"
							@filter="(val, update, abort) => filterSelectChangeInput(val, update, abort, 'd_perfil_qualitativo')">
						</q-select>
					</div>
					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Liquidez
						</label>
						<q-select
							id="perfil_liquidez"
							name="perfil_liquidez"
							input-debounce="300"
							dense
							outlined
							use-input
							map-options
							emit-value
							option-label="nome"
							option-value="id"
							v-model="model.perfil_liquidez"
							:options="optionsCopy.perfil_liquidez"
							@filter="(val, update, abort) => filterSelectChangeInput(val, update, abort, 'perfil_liquidez')">
						</q-select>
					</div>
					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Volatilidade
						</label>

						<q-select
							id="perfil_volatilidade"
							name="perfil_volatilidade"
							input-debounce="300"
							dense
							outlined
							use-input
							map-options
							emit-value
							option-label="nome"
							option-value="id"
							v-model="model.perfil_volatilidade"
							:options="optionsCopy.perfil_volatilidade"
							@filter="(val, update, abort) => filterSelectChangeInput(val, update, abort, 'perfil_volatilidade')">
						</q-select>
					</div>
					<div class="flex flex-col gap-4 w-full">
						<label class="text-sm text-neutral-80 font-medium">
							Rentabilidade
						</label>

						<q-select
							id="d_perfil_simples"
							name="d_perfil_simples"
							input-debounce="300"
							dense
							outlined
							use-input
							map-options
							emit-value
							option-label="nome"
							option-value="id"
							v-model="model.d_perfil_simples"
							:options="optionsCopy.perfil_rentabilidade"
							@filter="(val, update, abort) => filterSelectChangeInput(val, update, abort, 'perfil_rentabilidade')">
						</q-select>
					</div>
				</div>

				<div
					class="flex col-span-full bg-white justify-center w-full gap-24 py-24 sticky bottom-0 z-20">
					<button
						type="button"
						class="btn secondary !min-w-160 h-48"
						data-xclose="modal_padrao_vue">
						Cancelar
					</button>

					<button
						type="button"
						class="btn !min-w-160   h-48"
						@click="submitDropdown">
						Consultar
					</button>
				</div>
			</form>
		</section>
	`,
    delimiters: [
        '{*',
        '*}'
    ]
};

});

parcelRegister("iIWBq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da19cb53c359f878$export$2e2bcd8739ae039; });

var $26SB8 = parcelRequire("26SB8");
var $da19cb53c359f878$export$2e2bcd8739ae039 = {
    template: (0, $26SB8.html)`
		<section
			class="modal--content rounded-md flex-1 !h-max overflow-[initial]"
			data-id="emissor_fgc_ativos">
			<h1>Hello World</h1>
		</section>
	`
};

});


parcelRegister("i2a3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d210376790eb42bd$export$2e2bcd8739ae039; });

var $26SB8 = parcelRequire("26SB8");

var $2m7Ys = parcelRequire("2m7Ys");

var $1UZGW = parcelRequire("1UZGW");

var $gYCWk = parcelRequire("gYCWk");
const { ref: $d210376790eb42bd$var$ref } = Vue;
var $d210376790eb42bd$export$2e2bcd8739ae039 = {
    emits: [],
    props: {},
    components: {
        ModalAprovacao: $gYCWk.default,
        ConfirmModal: $1UZGW.default
    },
    data () {
        return {
            tableSolicitacoesAprovacoes: null,
            tableHistoricoAprovacoes: null,
            solicitacoes: [],
            modalConfirm: {},
            solicitacao: {},
            countAguardando: 0,
            countAprovado: 0,
            tipos_atendimentos: {
                edita_atendimento: "Edi\xe7\xe3o de atendimento",
                edita_contato: "Edi\xe7\xe3o de ponto de contato",
                deleta_atendimento: "Exclus\xe3o de atendimento"
            }
        };
    },
    methods: {
        openModalHistorico (row) {
            const tipoSolicitacao = row?.cells[2].data;
            const index = row?.cells[4].data;
            const itemClicked = this.solicitacoes?.find((solicitacao)=>{
                return solicitacao.id_index === index;
            });
            const dataSolicitacao = new Date(itemClicked.data_solicitacao);
            this.solicitacao = {
                tipo: tipoSolicitacao,
                header: this.tipos_atendimentos[tipoSolicitacao],
                ...itemClicked,
                data_solicitacao: GLOBAL.formatDateObject(dataSolicitacao)
            };
            modal_padrao_vue.openModal(`modal_aprovacao`);
        },
        async postSolicitacao (url) {
            try {
                NProgress.start();
                const { data: data } = await axios.get(url);
            } catch (e) {
                errorDefault(e);
            } finally{
                NProgress.done();
            }
        },
        openModalSolicitacao (row, acao) {
            const isAprovar = acao === 'aprovar';
            this.modalConfirm = {
                open: true,
                rowClick: row,
                text: `Deseja ${isAprovar ? 'aprovar' : 'recusar'} esta solicita\xe7\xe3o?`,
                id: acao,
                botao: 'Confirmar',
                header: `${isAprovar ? 'Aprovar' : 'Recusar'} Solicita\xe7\xe3o`
            };
        },
        setUrlSolicitacao (row, acao) {
            let url = `${window.location.origin}/`;
            const isAtendimento = row.cells[1].data;
            const id = row.cells[0].data;
            const tipoSolicitacao = row.cells[2].data;
            const acaoUrl = acao === 'aprovar' ? 'aprovado' : 'recusado';
            if (isAtendimento) {
                const isDeletaAtendimento = tipoSolicitacao === 'deleta_atendimento';
                const isEditaAtendimento = tipoSolicitacao === 'edita_atendimento';
                if (isDeletaAtendimento) url += `atendimento/${acaoUrl}_delete/${id}`;
                else if (isEditaAtendimento) url += `atendimento/${acaoUrl}/${id}`;
            } else url += `clientes/${acaoUrl}_editar_ponto_contato/${id}/`;
            return url;
        },
        async processarSolicitacao (row, acao) {
            try {
                const url = this.setUrlSolicitacao(row, acao);
                await this.postSolicitacao(url);
                this.modalConfirm = {};
                this.tableSolicitacoesAprovacoes.forceRender();
                this.tableHistoricoAprovacoes.forceRender();
            } catch (error) {
                console.log(error);
            }
        },
        async confirmAction () {
            await this.processarSolicitacao(this.modalConfirm.rowClick, this.modalConfirm.id);
        },
        formatOfficersNames (officers) {
            return officers?.map(({ nome: nome })=>nome.split('.').map((word)=>(0, $2m7Ys.capitalize)(word)).join(' ')).join(', ');
        },
        mapSolicitacao (item, index, exclude) {
            const isDateAlteracao = (item.status_exclusao !== 'Aguardando' || item.status_edicao !== 'Aguardando') && item.data_alteracao;
            const isAtendimento = item.tipo_solicitacao === 'edita_atendimento' || item.tipo_solicitacao === 'deleta_atendimento';
            const objTable = {
                id: item.atendimento || item.contato,
                'is-atendimento': isAtendimento,
                'tipo-solicitacao': item.tipo_solicitacao,
                'conteudo-editado': item.conteudo_editado,
                'index': index,
                cliente: item.cliente_pf,
                officer: item.usuario_solicitante,
                tipo_atendimento: this.tipos_atendimentos[item.tipo_solicitacao],
                data_solicitacao: isDateAlteracao ? item.data_alteracao : item.data_solicitacao,
                usuario_aprovador: item.usuario_aprovador,
                status_acao: item.status_exclusao || item.status_edicao
            };
            if (!exclude) delete objTable.usuario_aprovador;
            return objTable;
        },
        filterSolicitacoes (solicitacoes, filterStatus, exclude) {
            return solicitacoes.filter((solicitacao)=>exclude ? solicitacao.status_acao !== filterStatus : solicitacao.status_acao === filterStatus);
        },
        mapAndFilterSolicitations (solicitacoes, filterStatus = 'Aguardando', exclude = true) {
            this.solicitacoes = solicitacoes?.map((solicitacao, index)=>({
                    id_index: index,
                    ...solicitacao
                }));
            const _arrData = solicitacoes?.map((item, index)=>this.mapSolicitacao(item, index, exclude));
            const solicitacoesFiltradas = this.filterSolicitacoes(_arrData, filterStatus, exclude);
            if (exclude) this.countAprovado = solicitacoesFiltradas.length;
            else this.countAguardando = solicitacoesFiltradas.length;
            return solicitacoesFiltradas.map((item)=>Object.values(item));
        },
        iniciarTabelaGenerica (tableSelector, columns, url, customThenCallback, customTotalCallback) {
            const table = document.querySelector(tableSelector);
            const gridInstance = new (0, $26SB8.Grid)({
                search: false,
                resizable: true,
                columns: columns,
                data: [],
                autoWidth: true,
                width: '100%',
                sort: false,
                server: {
                    url: url,
                    then: (data)=>customThenCallback(data),
                    total: (data)=>customTotalCallback(data).length
                },
                pagination: {
                    enabled: false,
                    limit: 10,
                    summary: false,
                    server: {
                        url: (urlApi, page, limit)=>`${urlApi}&page=${++page}&paginate_by=${limit}`
                    }
                },
                style: {
                    container: {
                        border: 'none'
                    },
                    table: {
                        border: 'none'
                    },
                    tr: {
                        border: 'none'
                    },
                    th: {
                        'border-bottom': '1px solid #e9ecef'
                    },
                    td: {
                        'border-bottom': '1px solid #e9ecef',
                        cursor: 'pointer',
                        color: '#495057',
                        'font-family': "Roboto Flex",
                        'font-size': '14px',
                        'font-weight': 500,
                        'line-height': '150%',
                        'letter-spacing': '-0.28px'
                    },
                    footer: {
                        border: 'none'
                    }
                },
                language: {
                    search: {
                        placeholder: 'Busque aqui...'
                    },
                    pagination: {
                        previous: ' Anterior',
                        next: "Pr\xf3ximo "
                    }
                }
            });
            gridInstance.render(table);
            return gridInstance;
        },
        iniciartableSolicitacoesAprovacoes () {
            const columns = [
                {
                    name: 'ID',
                    hidden: false,
                    width: '100px'
                },
                {
                    name: 'is-atendimento',
                    hidden: true
                },
                {
                    name: 'tipo-solicitacao',
                    hidden: true
                },
                {
                    name: 'conteudo-editado',
                    hidden: true
                },
                {
                    name: 'index',
                    hidden: true
                },
                {
                    name: 'Cliente_pf',
                    hidden: false
                },
                {
                    name: 'Officer',
                    formatter: (cell)=>this.formatOfficersNames([
                            {
                                nome: cell
                            }
                        ])
                },
                {
                    name: (0, $26SB8.html)('<div style="white-space: normal;">Tipo de solicita\xe7\xe3o</div>')
                },
                {
                    name: (0, $26SB8.html)('<div style="white-space: normal;">Data de Solicita\xe7\xe3o</div>'),
                    formatter: (cell)=>GLOBAL.formatDateObject(new Date(cell))
                },
                {
                    name: 'Status'
                },
                {
                    name: '',
                    width: '120px',
                    formatter: (cell, row)=>this.renderAcoes(row)
                }
            ];
            this.tableSolicitacoesAprovacoes = this.iniciarTabelaGenerica('#table_solicitacoes_aprovacoes', columns, `${window.origin}/atendimento/solicitacoes/?`, (data)=>this.mapAndFilterSolicitations(data, 'Aguardando', false), (data)=>this.mapAndFilterSolicitations(data, 'Aguardando', false));
        },
        iniciartableSHistoricoAprovacoes () {
            const columns = [
                {
                    name: 'ID',
                    hidden: false,
                    width: '100px'
                },
                {
                    name: 'is-atendimento',
                    hidden: true
                },
                {
                    name: 'tipo-solicitacao',
                    hidden: true
                },
                {
                    name: 'conteudo-editado',
                    hidden: true
                },
                {
                    name: 'index',
                    hidden: true
                },
                {
                    name: 'Cliente_pf',
                    hidden: false
                },
                {
                    name: 'Officer',
                    formatter: (cell)=>this.formatOfficersNames([
                            {
                                nome: cell
                            }
                        ])
                },
                {
                    name: (0, $26SB8.html)('<div style="white-space: normal;">Tipo de solicita\xe7\xe3o</div>')
                },
                {
                    name: (0, $26SB8.html)('<div style="white-space: normal;">Data de Altera\xe7\xe3o</div>'),
                    formatter: (cell)=>GLOBAL.formatDateObject(new Date(cell))
                },
                {
                    name: 'Aprovador'
                },
                {
                    name: 'Status'
                },
                {
                    name: '',
                    width: '80px',
                    formatter: (cell, row)=>this.renderHistoricoAcoes(row)
                }
            ];
            this.tableHistoricoAprovacoes = this.iniciarTabelaGenerica('#table_historico_aprovacoes', columns, `${window.origin}/atendimento/solicitacoes/?`, (data)=>this.mapAndFilterSolicitations(data), (data)=>this.mapAndFilterSolicitations(data));
        },
        renderAcoes (row) {
            return (0, $26SB8.h)('div', {
                className: 'flex gap-2 justify-between'
            }, [
                (0, $26SB8.h)('ion-icon', {
                    name: 'checkmark-outline',
                    className: 'success',
                    onClick: ()=>this.openModalSolicitacao(row, 'aprovar')
                }),
                (0, $26SB8.h)('ion-icon', {
                    name: 'close-outline',
                    className: 'error',
                    onClick: ()=>this.openModalSolicitacao(row, 'recusar')
                })
            ]);
        },
        renderHistoricoAcoes (row) {
            return (0, $26SB8.h)('ion-icon', {
                name: 'search-outline',
                onClick: ()=>this.openModalHistorico(row)
            });
        }
    },
    async mounted () {
        this.iniciartableSolicitacoesAprovacoes();
        this.iniciartableSHistoricoAprovacoes();
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("gYCWk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5c0749735315d5b$export$2e2bcd8739ae039; });
NProgress.configure({
    trickleSpeed: 40,
    trickle: true,
    minimum: 0.65
});
var $c5c0749735315d5b$export$2e2bcd8739ae039 = {
    props: [
        "solicitacao"
    ],
    methods: {},
    mounted () {},
    template: html`<section
			class="modal--content rounded-md flex-1 !h-max overflow-[initial]"
			data-id="modal_aprovacao">
			<header
				class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
				<h2 class="text-lg font-medium text-white">{{solicitacao.header}} </h2>
				<button
					type="button"
					class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
					data-xclose="modal_padrao_vue">
					<svg class="w-32 h-32">
						<use xlink:href="#icon_close"></use>
					</svg>
				</button>
			</header>

			<section v-show="solicitacao.tipo === 'deleta_atendimento'" class="p-24 flex flex-col gap-16">
					<div class="flex flex-col gap-4" >
						<span class="text-neutral-70 text-sm">Cliente PF</span>
						<span class="text-neutral-100 text-sm" v-html="solicitacao?.cliente_pf || '-'"></span>
				</div>
				<div class="grid grid-cols-2  gap-16" >

					<div class="flex flex-col gap-4" >
							<span class="text-neutral-70 text-sm">Usuário solicitante</span>
							<span class="text-neutral-100 text-sm" v-html="solicitacao?.usuario_solicitante || '-'"></span>
					</div>
					<div class="flex flex-col gap-4" >
							<span class="text-neutral-70 text-sm">Usuário aprovador</span>
							<span class="text-neutral-100 text-sm" v-html="solicitacao?.usuario_aprovador || '-'"></span>
					</div>
				</div>
				<div class="grid grid-cols-2  gap-16" >

					<div class="flex flex-col gap-4" >
							<span class="text-neutral-70 text-sm">Status</span>
							<span class="text-neutral-100 text-sm" v-html="solicitacao?.status_exclusao || '-'"></span>
					</div>
					<div class="flex flex-col gap-4" >
							<span class="text-neutral-70 text-sm">Data de solicitação</span>
							<span class="text-neutral-100 text-sm" v-html="solicitacao?.data_solicitacao || '-'"></span>
					</div>
				</div>
				<div class="flex flex-col gap-4" >
						<span class="text-neutral-70 text-sm">Descrição</span>
						<span class="text-neutral-100 text-sm" v-html="solicitacao?.descricao || '-'"></span>
				</div>
			</section>

			<section v-show="solicitacao.tipo ===  'edita_atendimento'" class="p-24">
				
				<div v-if="solicitacao" class="flex flex-col gap-4">
					<span class="text-neutral-70 text-sm">Nova Descrição</span>
					<span class="text-neutral-100 text-sm" v-html="solicitacao?.conteudo_editado || '-'"></span>
				</div>

			</section>

			<section v-show="solicitacao.tipo === 'edita_contato'" class="p-24 flex flex-col gap-16">
				
				<div class="flex flex-col gap-4" >
						<span class="text-neutral-70 text-sm">Email</span>
						<span class="text-neutral-100 text-sm" v-html="solicitacao?.email || '-'"></span>
				</div>
				<div class="flex flex-col gap-4" >
						<span class="text-neutral-70 text-sm">Celular</span>
						<span class="text-neutral-100 text-sm" v-html="solicitacao?.celular || '-'"></span>
				</div>
				<div class="flex flex-col gap-4" >
						<span class="text-neutral-70 text-sm">Descrição</span>
						<span class="text-neutral-100 text-sm" v-html="solicitacao?.descricao || '-'"></span>
				</div>
				<div class="flex flex-col gap-4" >
						<span class="text-neutral-70 text-sm">Email</span>
						<span class="text-neutral-100 text-sm" v-html="solicitacao?.email || '-'"></span>
				</div>

			</section>
		</section>
	
	`
};

});


parcelRegister("3CnuR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2725b2faa47ca9$export$2e2bcd8739ae039; });

var $4nzoT = parcelRequire("4nzoT");

var $eyBdF = parcelRequire("eyBdF");
var $2a2725b2faa47ca9$export$2e2bcd8739ae039 = {
    inject: [
        'GLOBAL'
    ],
    data () {
        return {
            arrayOfSteps: globalData.steps,
            currentStep: null,
            isCurrentStep: false,
            steps: {
                step1: {
                    valid: false
                }
            },
            isConjuge: false,
            haveModalResumo: true,
            dataForm: {
                nome: '',
                sobrenome: ''
            },
            cepMapFields: {
                state: 'estado',
                city: 'cidade',
                street: 'rua',
                neighborhood: 'bairro'
            }
        };
    },
    components: {
        StepTimeLine: $eyBdF.default,
        ModalResumo: $4nzoT.default
    },
    methods: {
        /**
		 * Limpa todos os campos que tem o atributo address-fields
		 */ clearAddressValues () {
            const addressFields = document.querySelectorAll('[address-fields] input');
            addressFields.forEach((field)=>field.value = '');
        },
        /**
		 * Atualiza os campos referente ao endereco
		 * @param { object } data - Objeto com dados do cep
		 * @param { string } str - string complementar para id
		 */ fillAddressValues (data, str = '') {
            const arrayOfData = Object.keys(data).map((key)=>[
                    key,
                    data[key]
                ]);
            arrayOfData.map((arr)=>{
                const suffixId = this.cepMapFields[arr[0]];
                const fieldElement = document.querySelector(`[id$=${suffixId}${str}]`);
                if (fieldElement) fieldElement.value = arr[1];
            });
            const pais = document.querySelector(`[id$=pais${str}]`);
            pais.value = 'Brasil';
        },
        /**
		 * Busca o cep usando a api BrasilAPI
		 */ handleFetchCEP (id, str = '') {
            const cepFieldElement = document.querySelector(id);
            const apiUrl = (cep)=>`https://brasilapi.com.br/api/cep/v1/${cep.replace('-', '')}`;
            cepFieldElement.addEventListener('input', async ({ target: target })=>{
                if (target.value.length == 0) this.clearAddressValues();
                if (target.value.length < 9 || this.cepValue == target.value) return;
                try {
                    const res = await fetch(apiUrl(target.value));
                    const data = await res.json();
                    if (data.errors) GLOBAL.showToastify("CEP n\xe3o encontrado");
                    else this.fillAddressValues(data, str);
                } catch (err) {
                    console.log(err);
                }
                this.cepValue = target.value;
            });
        },
        validateIsVazio (form) {
            return form.checkValidity();
        },
        submitGeral () {
            const btn = document.querySelector('[etapa]');
            const form = document.querySelector('form');
            btn?.addEventListener('click', (e)=>{
                e.preventDefault();
                if (!this.validateIsVazio(form)) {
                    GLOBAL.showToastify(" \u26A0\uFE0F Preencha todos os campos obrigat\xf3rios antes de continuar");
                    return;
                } else form.submit();
            });
        },
        getCurrentStep () {
            const mainElement = document.querySelector("[id^='step']");
            const stepId = mainElement?.getAttribute('id').slice(-1);
            return Number(stepId);
        },
        openModal () {
            modal_padrao.openModal('modal_teste');
        },
        finalizar () {
            const btn = document.querySelector('.finalizar');
            btn.addEventListener('click', ()=>{
                btn.classList.add('disabled');
                btn.setAttribute('disabled', '');
                this.submitUltimoStep(true);
            });
        },
        /**
		 * @summary Adiciona uma * vermelha na label de uma div com atributo [js-field]
		 * @param {HTMLFormElement} form -
		 */ addRequiredLabel (form) {
            if (!form instanceof HTMLElement) return;
            const fields = form.querySelectorAll('[js-field]');
            if (!fields.length) return;
            fields.forEach((f)=>{
                if (f.querySelector('[name]')?.required) f.querySelector('label').innerHTML = `${f.querySelector('label').textContent}` + `<span style="color: rgba(247, 65, 65, 1)"> *</span>`;
            });
        },
        stopEnter () {
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            });
        },
        addFlatPickerInputs () {
            const inputs = document.querySelectorAll('[type=date]:not([data-nascimento])');
            inputs.forEach((i)=>{
                GLOBAL.initFlatpickr(i, {
                    position: 'above'
                });
            });
        },
        // ====================== FUNÇÔES SEPARADAS POR STEPS ======================
        // Step 3
        submitStep3 () {
            const btn = document.querySelector('[etapa]');
            const form = document.querySelector('form');
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                if (!this.validateIsVazio(form)) {
                    GLOBAL.showToastify(" \u26A0\uFE0F Preencha todos os campos obrigat\xf3rios antes de continuar");
                    return;
                } else if (!this.verificaPorcentagem()) GLOBAL.showToastify(" \u26A0\uFE0F A soma das porcentagens deve ser igual a 100");
                else form.submit();
            });
        },
        verificaPorcentagem () {
            const container = document.querySelector('[js-field-porc]');
            const selects = container.querySelectorAll('select');
            let total = 0;
            selects.forEach((select)=>{
                let value = select.value;
                if (value) total += Number(value.split('%')[0]);
            });
            return total == 100;
        },
        // Step 4 e 6
        submitStepPossuiRadio () {
            const btn = document.querySelector('[etapa]');
            const form = document.querySelector('form');
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                if (this.validaStepRadio(form)) {
                    GLOBAL.showToastify(" \u26A0\uFE0F Preencha todos os campos obrigat\xf3rios antes de continuar");
                    return;
                } else form.submit();
            });
        },
        /**
		 * Valida etapas que possuem inputs do tipo radio, verificando se a quantidade de inputs com checked corresponde a quantidade de perguntas  obrigatórias
		 * @param { HTMLFormElement} form - formulario a ser validado
		 * @return {Boolean} retorna true ou false
		 */ validaStepRadio (form) {
            let isVazio = true;
            const fields = form.querySelectorAll('[js-field-radio]');
            let check = 0;
            fields.forEach((f)=>{
                const inputs = f.querySelectorAll('input');
                inputs.forEach((i)=>{
                    if (i.checked) check++;
                });
            });
            if (fields.length === check) isVazio = false;
            return isVazio;
        },
        // STEP 8
        changeSelectEstadoCivil () {
            const select = document.querySelector('[id$=estado_civil]');
            if (select) select.addEventListener('change', (e)=>{
                this.isConjuge = e.target.value == 'Casado(a)';
            });
        },
        submitUltimoStep (finalizar = false) {
            const btn = document.querySelector('[etapa]');
            const checkAutorizar = document.querySelector('[name="8-autoriza_revelar"]');
            const form = document.querySelector('form');
            if (!finalizar) btn.addEventListener('click', (e)=>{
                console.log(checkAutorizar.checked, 'check');
                e.preventDefault();
                if (!this.validateIsVazio(form)) {
                    GLOBAL.showToastify(" \u26A0\uFE0F Preencha todos os campos obrigat\xf3rios antes de continuar");
                    return;
                } else if (!checkAutorizar.checked) {
                    GLOBAL.showToastify(" \u26A0\uFE0F Para continuar \xe9 necess\xe1rio autorizar ");
                    return;
                } else this.openModal();
            });
            else form.submit();
        }
    },
    mounted () {
        const form = document.querySelector('form');
        this.currentStep = this.getCurrentStep();
        this.stopEnter();
        this.addFlatPickerInputs();
        this.addRequiredLabel(form);
        this.finalizar();
        if (this.currentStep === 0) {
            this.handleFetchCEP('#id_0-cep');
            this.submitGeral();
        } else if (this.currentStep === 3) this.submitStep3();
        else if (this.currentStep == 6 || this.currentStep == 4) this.submitStepPossuiRadio(form);
        else if (this.currentStep == 8) {
            this.handleFetchCEP('#id_8-cep_comercial', '_comercial');
            this.changeSelectEstadoCivil();
            this.submitUltimoStep();
        } else this.submitGeral();
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("eyBdF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9911caeebfc046e$export$2e2bcd8739ae039; });

var $x4m53 = parcelRequire("x4m53");
var $a9911caeebfc046e$export$2e2bcd8739ae039 = {
    props: {
        arrayOfSteps: Array,
        currentStep: Number
    },
    components: {
        StepHeaderItem: $x4m53.default
    },
    data () {
        return {
            isMobile: window.innerWidth < 992,
            prevStep: Number,
            nextStep: Number
        };
    },
    computed: {
        steps () {
            const [prev, next] = this.setSteps();
            if (this.isMobile) {
                console.log(next);
                if (next === 10) return this.arrayOfSteps.slice(prev - 1, next);
                else if (next === 1) return this.arrayOfSteps.slice(prev + 1, next + 2);
                else return this.arrayOfSteps.slice(prev, next + 1);
            } else {
                console.log(this.arrayOfSteps, 'else');
                return this.arrayOfSteps;
            }
        }
    },
    methods: {
        setSteps () {
            return [
                this.currentStep - 1,
                this.currentStep + 1
            ];
        }
    },
    created () {
        this.setSteps();
    },
    template: html`
		<div
			class="container step-line-container items-center h-full justify-center"
			:class="{'mobile': isMobile}">
			<template v-for="step in steps" :key="step.id">
				<step-header-item
					:link="step.link"
					:step-id="step.id"
					:title="step.title"
					:current-step="currentStep"></step-header-item>
			</template>
		</div>
	`
};

});
parcelRegister("x4m53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06367605791fc0f9$export$2e2bcd8739ae039; });
var $06367605791fc0f9$export$2e2bcd8739ae039 = {
    props: [
        'link',
        'stepId',
        'currentStep',
        'title'
    ],
    template: html`
		<div
			class="relative step-line"
			:class="{'active': currentStep > stepId,  'metade': stepId == 7, 'isLast': currentStep > 8 && stepId == 9} ">
			<svg
				v-if="currentStep == stepId"
				width="13"
				height="12"
				viewBox="0 0 13 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect
					x="0.833008"
					y="0.5"
					width="11"
					height="11"
					rx="5.5"
					fill="#FFF" />
				<circle cx="6.33281" cy="5.99981" r="4.2" fill="#C11F39" />
				<rect
					x="0.833008"
					y="0.5"
					width="11"
					height="11"
					rx="5.5"
					stroke="#C11F39" />
			</svg>
			<svg
				v-else-if="currentStep > stepId"
				width="12"
				height="12"
				viewBox="0 0 12 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect width="12" height="12" rx="6" fill="#C11F39" />
			</svg>
			<svg
				v-else
				width="12"
				height="12"
				viewBox="0 0 12 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect width="12" height="12" rx="6" fill="white" />
				<rect
					x="0.5"
					y="0.5"
					width="11"
					height="11"
					rx="5.5"
					stroke="#09121C"
					stroke-opacity="0.1" />
			</svg>

			<a
				v-if="currentStep == stepId"
				:href="link"
				class="paragraph-2 text-neutral-100  w-full min-w-[200px] text-sm font-normal absolute"
				:class="{'font-medium': currentStep == stepId, 'pointer-events-none': currentStep <= stepId}">
				{{title}}
			</a>
			<a
				v-else
				:href="link"
				class="paragraph-2 text-neutral-100 mt-8 w-full text-sm font-normal"
				:class="{'font-medium': currentStep == stepId, 'pointer-events-none': currentStep <= stepId}">
			</a>
		</div>
	`
};

});



parcelRegister("54lXz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b0e5c36cff4f7b6$export$2e2bcd8739ae039; });

var $26SB8 = parcelRequire("26SB8");

var $2m7Ys = parcelRequire("2m7Ys");

var $6crX0 = parcelRequire("6crX0");

var $7h4Zs = parcelRequire("7h4Zs");

var $4nzoT = parcelRequire("4nzoT");
const { ref: $3b0e5c36cff4f7b6$var$ref } = Vue;
const $3b0e5c36cff4f7b6$var$regrasPolitica = {
    0: {
        amarelo: 3,
        vermelho: 4
    },
    1: {
        amarelo: 3,
        vermelho: 4
    },
    2: {
        amarelo: 4,
        vermelho: 5
    },
    3: {
        amarelo: 5,
        vermelho: 6
    }
};
var $3b0e5c36cff4f7b6$export$2e2bcd8739ae039 = {
    emits: [],
    props: {},
    data () {
        return {
            tableReunioesRealizadas: null,
            usuariosComReuniaoRelaizadas: [],
            haveModalResumo: true,
            columns: [
                {
                    id: 'id',
                    name: 'ID',
                    hidden: true
                },
                {
                    id: 'politica',
                    name: 'Politica',
                    hidden: true
                },
                {
                    id: 'nome',
                    name: 'Cliente PF',
                    attributes: {
                        'sticky-column-1': true,
                        'sticky-header': true
                    },
                    hidden: false,
                    width: '180px',
                    formatter: (cell, row)=>{
                        const politica = row?.cells[1]?.data;
                        return (0, $26SB8.html)(`<div class="inline-flex items-center max-w-[180px] "  >
							<svg class="h-40 w-40 shrink-0" style="${GLOBAL.generateAvatarColor(politica)}">
									<use xlink:href="#icon_person"></use>
								</svg>
							<span class="one-line max-w-[180px]" title="${cell}">${cell || ''}</span>
						</div>`);
                    },
                    sort: {
                        compare: (a, b)=>{
                            if (a > b) return 1;
                            else if (a < b) return -1;
                            else return 0;
                        }
                    }
                },
                {
                    id: 'usuario_responsavel_atendimento',
                    name: 'Officer',
                    hidden: false,
                    width: '85px',
                    attributes: {
                        'sticky-column-2': true,
                        'sticky-header': true,
                        center: true
                    },
                    formatter: (cell, row)=>{
                        return (0, $26SB8.html)(`<div style="display:flex; flex-direction:column; gap:2px; max-width:85px; " >
							${cell?.map((item)=>{
                            const nameFormated = item.split('.').map((word)=>(0, $2m7Ys.capitalize)(word)).join(' ');
                            return `<span>${nameFormated || ''}</span>`;
                        }).join(' ')}
						</div>`);
                    }
                }
            ],
            sort: true,
            usuarios: [],
            anos: [],
            meses: (0, $6crX0.MONTHS_LIST),
            mesesClientesSemReuniao: [],
            inicio: '',
            fim: '',
            model: {
                ano: '',
                user: [],
                tem_atendimento: 'false',
                mes_inicio: '',
                mes_fim: 12,
                ano: '',
                ano_fim: '',
                mes_inicio2: 1,
                mes_fim2: ''
            },
            query: ''
        };
    },
    watch: {
        inicio (value) {
            if (!value) return;
            const [mes, ano] = value.split('/');
            this.model.mes_inicio = mes;
            this.model.ano = ano;
        },
        fim (value) {
            if (!value) return;
            const [mes, ano] = value.split('/');
            this.model.mes_fim2 = mes;
            this.model.ano_fim = ano;
        }
    },
    components: {
        SelectMultiple: $7h4Zs.default,
        ModalResumo: $4nzoT.default
    },
    methods: {
        openModal (id, politica) {
            this.$refs.modalResumo.OpenModalResumo({
                id: id,
                politica: politica,
                atendimentoID: null
            });
        },
        async getDados (query) {
            try {
                const { data: data } = await axios.get(`${window.origin}/atendimento/reunioes_realizadas/${query}`);
                return data;
            } catch (error) {
                console.log({
                    error: error
                });
            }
        },
        openFiltros () {
            modal_padrao_vue.openModal('reunioes_filtros');
        },
        formataObjectsInicialFinal (lista_inicial, lista_final) {
            const objectReunioes = {
                ...Object.fromEntries(Object.entries(lista_inicial).map(([key, value])=>[
                        `${key}_inicial`,
                        value
                    ])),
                ...Object.fromEntries(Object.entries(lista_final).map(([key, value])=>[
                        `${key}_final`,
                        value
                    ]))
            };
            return objectReunioes;
        },
        formataResultsForGrid (results, resultado = []) {
            const atendimentosPorCliente = {};
            const idCliente = {};
            const temAtendimento = this.model.tem_atendimento;
            const dadosReuniao = this.formataObjectsInicialFinal(results?.reunioes_ano_inicial, results?.reunioes_ano_final);
            Object.keys(dadosReuniao)?.forEach((mes)=>{
                dadosReuniao[mes]?.forEach((atendimento)=>{
                    const { nome_cliente: nome_cliente, usuario_responsavel_atendimento: usuario_responsavel_atendimento, cliente_pf_id: cliente_pf_id, concluido: concluido, data_atendimento: data_atendimento, politica: politica, qtd_reunioes: qtd_reunioes } = atendimento;
                    if (temAtendimento === 'true' || temAtendimento === 'false' && !concluido) {
                        if (!atendimentosPorCliente[nome_cliente]) {
                            atendimentosPorCliente[nome_cliente] = [];
                            idCliente[nome_cliente] = {
                                cliente_pf_id: cliente_pf_id,
                                politica: politica
                            };
                        }
                        atendimentosPorCliente[nome_cliente].push({
                            usuario_responsavel_atendimento: usuario_responsavel_atendimento,
                            mes: mes,
                            data_atendimento: data_atendimento,
                            qtd_reunioes: qtd_reunioes
                        });
                    }
                });
            });
            for(let cliente in atendimentosPorCliente)resultado.push([
                cliente,
                atendimentosPorCliente[cliente]
            ]);
            const formatoFinal = resultado.map(([nome_cliente, atendimentos])=>{
                const dadosCliente = idCliente[nome_cliente];
                const arrayOfficers = atendimentos.map((atendimento)=>atendimento.usuario_responsavel_atendimento);
                const arrayUnico = [
                    ...new Set(arrayOfficers.flat())
                ];
                const user = arrayUnico;
                const resultado = [
                    dadosCliente.cliente_pf_id,
                    dadosCliente.politica,
                    nome_cliente,
                    user
                ];
                const novoArrayInicial = results?.meses_filtrados.map((item)=>({
                        ...item,
                        nome: item.nome + '_inicial'
                    }));
                const novoArrayFinal = results?.meses_filtrados2.map((item)=>({
                        ...item,
                        nome: item.nome + '_final'
                    }));
                const dadosReuniao = [
                    ...novoArrayInicial,
                    ...novoArrayFinal
                ];
                dadosReuniao.forEach((item)=>{
                    const atendimentoEncontrado = atendimentos.find((a)=>{
                        return a.mes === item.nome;
                    });
                    resultado.push(atendimentoEncontrado && atendimentoEncontrado.data_atendimento ? [
                        `Qtd: ${atendimentoEncontrado.qtd_reunioes}`,
                        GLOBAL.formatDateObject(new Date(atendimentoEncontrado.data_atendimento))
                    ] : '');
                });
                return resultado;
            });
            this.usuariosComReuniaoRelaizadas = Object.values(results.reunioes_ano_inicial).flatMap((itemReunoiaoRealizada)=>[
                    ...itemReunoiaoRealizada
                ]);
            this.usuariosComReuniaoRelaizadas = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).uniqBy(this.usuariosComReuniaoRelaizadas, 'cliente_pf_id');
            return formatoFinal;
        },
        valuesDatasSemFiltro () {
            let newDate = new Date();
            const mesAnterior = Quasar.date.formatDate(newDate, 'MM');
            const anoAtual = Quasar.date.formatDate(newDate, 'YYYY');
            newDate = Quasar.date.subtractFromDate(new Date(), {
                month: 12
            });
            const mes_12_anterior = Quasar.date.formatDate(newDate, 'MM');
            const ano_12_anterior = Quasar.date.formatDate(newDate, 'YYYY');
            return {
                mesAnterior: mesAnterior,
                anoAtual: anoAtual,
                mes_12_anterior: mes_12_anterior,
                ano_12_anterior: ano_12_anterior
            };
        },
        async setValuesReunioes () {
            const urlParams = new URLSearchParams(window.location.search);
            const users = urlParams.get('user')?.trim().split(',');
            const { mesAnterior: mesAnterior, anoAtual: anoAtual, mes_12_anterior: mes_12_anterior, ano_12_anterior: ano_12_anterior } = this.valuesDatasSemFiltro();
            this.model = {
                user: this.usuarios.filter((item)=>{
                    return users?.some((i)=>i == item.value);
                }) || [],
                ano: Number(urlParams.get('ano')) || ano_12_anterior,
                mes_inicio2: Number(urlParams.get('mes_inicio2')) || 1,
                mes_fim2: Number(urlParams.get('mes_fim2')) || mesAnterior,
                ano_fim: Number(urlParams.get('ano_fim')) || anoAtual,
                mes_inicio: Number(urlParams.get('mes_inicio')) || mes_12_anterior,
                mes_fim: Number(urlParams.get('mes_fim')) || 12,
                tem_atendimento: urlParams.get('tem_atendimento') || 'true'
            };
            this.inicio = `${this.model.mes_inicio}/${this.model.ano}`;
            this.fim = `${this.model.mes_fim2}/${this.model.ano_fim}`;
            this.setQueryUrl();
            let responseReunioesRealizadas = await this.getDados(window.location.search || this.query);
            const novoArrayInicial = responseReunioesRealizadas?.results?.meses_filtrados.map((item)=>({
                    ...item,
                    nome: item.nome + '_inicial'
                }));
            const novoArrayFinal = responseReunioesRealizadas?.results?.meses_filtrados2.map((item)=>({
                    ...item,
                    nome: item.nome + '_final'
                }));
            const dadosReuniao = [
                ...novoArrayInicial,
                ...novoArrayFinal
            ];
            // const dadosReuniao = this.formataObjectsInicialFinal(
            // 	responseReunioesRealizadas?.results?.reunioes_ano_inicial,
            // 	responseReunioesRealizadas?.results?.reunioes_ano_
            // )
            dadosReuniao?.forEach((item, index)=>{
                this.columns.push({
                    attributes: {
                        'pointer-events-none': true,
                        center: true
                    },
                    id: item?.nome,
                    name: (0, $26SB8.html)(`<div style="white-space: normal;  ">${(0, $2m7Ys.capitalize)(item?.nome?.replace('_final', '')?.replace('_inicial', ''))}</div>`),
                    formatter: (cell, row, column)=>{
                        /* console.log(row?.cells) */ const id = row?.cells[0]?.data;
                        const mesSemReuniao = this.mesesClientesSemReuniao.find((item)=>item.id_cliente == id);
                        const dataFormated = GLOBAL.formatDateObject(new Date(mesSemReuniao?.data_reuniao));
                        const [_, mes_, __] = dataFormated?.split('/');
                        // const ultimoAtendimento = dataFormated
                        /*
						let valorEncontrado = false
							for (let i = 0; i < column.index; i++) {
							if (row.cells[i]?.data[1] === ultimoAtendimento) {
								valorEncontrado = true
								console.log(row.cells[i]?.data[1])
								break
							}
						}

						*/ const ultimoAtendimentoIndice = row.cells.reduce((ultimaData, cellAtual, indexCell)=>{
                            if (cellAtual.data[1]) return indexCell;
                            return ultimaData;
                        }, -1);
                        /* console.log('clientes dados: ', row.cells) */ const validaDiasSemReuniao = ()=>{
                            const restantesMeses = row.cells.length - ultimoAtendimentoIndice - 1;
                            const atualIndex = index + 4;
                            if (atualIndex <= ultimoAtendimentoIndice) return '';
                            const atualClientePf = this.usuariosComReuniaoRelaizadas.find((itemUsuario)=>itemUsuario.cliente_pf_id === id);
                            if (!atualClientePf) return '';
                            const { politica: politica } = atualClientePf;
                            const regra = $3b0e5c36cff4f7b6$var$regrasPolitica[politica];
                            if (!regra) return '';
                            if (restantesMeses === regra.amarelo) return 'atraso_entre_2_3';
                            if (restantesMeses >= regra.vermelho) return 'atraso_maior_3';
                            return '';
                        };
                        validaDiasSemReuniao();
                        return (0, $26SB8.html)(`<div style="display:flex; flex-direction:column; gap:2px;" class="${validaDiasSemReuniao()}">
							<span style="font-weight:600;">${cell ? cell[0] : ''}</span>
   						<span>${cell ? cell[1] : ''}</span>
						</div>`);
                    },
                    width: '70px'
                });
            });
            this.usuarios = responseReunioesRealizadas?.results?.todos_users?.map((user)=>({
                    label: user.username,
                    value: user.id
                }));
            this.anos = [
                ...responseReunioesRealizadas?.results?.anos
            ];
            this.model = {
                ...this.model,
                user: this.usuarios.filter((item)=>{
                    return users?.some((i)=>i == item.value);
                }) || []
            };
        },
        iniciarTabelaGenerica (tableSelector, columns, url, customThenCallback, customTotalCallback) {
            const table = document.querySelector(tableSelector);
            const gridInstance = new (0, $26SB8.Grid)({
                search: false,
                resizable: true,
                columns: columns,
                data: [],
                autoWidth: true,
                width: '100%',
                sort: false,
                server: {
                    url: url,
                    then: (data)=>customThenCallback(data),
                    total: (data)=>customTotalCallback(data).length
                },
                pagination: {
                    enabled: false,
                    limit: 10,
                    summary: false,
                    server: {
                        url: (urlApi, page, limit)=>`${urlApi}&page=${++page}&paginate_by=${limit}`
                    }
                },
                style: {
                    container: {
                        border: 'none'
                    },
                    table: {
                        border: 'none'
                    },
                    tr: {
                        border: 'none'
                    },
                    th: {
                        'border-bottom': '1px solid #e9ecef',
                        padding: '8px 8px'
                    },
                    td: {
                        'border-bottom': '1px solid #e9ecef',
                        color: '#495057',
                        'font-family': 'Roboto Flex',
                        'font-size': '13px',
                        'font-weight': 500,
                        'line-height': '150%',
                        'letter-spacing': '-0.28px',
                        padding: '4px'
                    },
                    footer: {
                        border: ''
                    }
                },
                language: {
                    search: {
                        placeholder: 'Busque aqui...'
                    },
                    pagination: {
                        previous: ' Anterior',
                        next: "Pr\xf3ximo "
                    }
                }
            });
            gridInstance.on('rowClick', (...args)=>{
                const dados = args[1];
                const id = dados.cells[0].data;
                const politica = dados.cells[1].data;
                this.openModal(id, politica);
            });
            gridInstance.on('ready', ()=>{
                this.paintMesesAtrasados();
            });
            gridInstance?.render(table);
            return gridInstance;
        },
        openModalOnBotton (dados) {
            const id = dados.id;
            const politica = dados.politica;
            this.openModal(id, politica);
        },
        iniciartableReunioesRealizadas (query) {
            const resultado = [];
            let newQuery = query;
            const mes_fim = 12;
            const mes_inicio2 = 1;
            const { mesAnterior: mesAnterior, anoAtual: anoAtual, mes_12_anterior: mes_12_anterior, ano_12_anterior: ano_12_anterior } = this.valuesDatasSemFiltro();
            if (query === '?') newQuery = `?ano=${ano_12_anterior}&mes_inicio=${mes_12_anterior}&mes_fim=${mes_fim}&tem_atendimento=true&ano_fim=${anoAtual}&mes_inicio2=${mes_inicio2}&mes_fim2=${mesAnterior}`;
            else if (!query.includes('tem_atendimento')) newQuery = `${query}&tem_atendimento=true`;
            else if (!query.includes('ano')) newQuery = `${query}&ano=${ano_12_anterior}`;
            else if (!query.includes('mes_fim')) newQuery = `${query}&mes_fim=${mes_fim}`;
            else if (!query.includes('mes_inicio2')) newQuery = `${query}&mes_inicio2=${mes_inicio2}`;
            else if (!query.includes('ano_fim')) newQuery = `${query}&ano_fim=${anoAtual}`;
            this.tableReunioesRealizadas = this.iniciarTabelaGenerica('#table_reuniao', this.columns, `${window.origin}/atendimento/reunioes_realizadas/${newQuery}`, (data)=>{
                const { meses_clientes_sem_reuniao: meses_clientes_sem_reuniao, meses_clientes_sem_reuniao_ano_atual: meses_clientes_sem_reuniao_ano_atual, results: results } = data;
                this.mesesClientesSemReuniao = [
                    ...meses_clientes_sem_reuniao,
                    ...meses_clientes_sem_reuniao_ano_atual
                ];
                return this.formataResultsForGrid(results, resultado);
            }, (data)=>{
                const { results: results } = data;
                return this.formataResultsForGrid(results, resultado);
            });
        },
        limparFiltroReunioesRealizadas () {
            const { mesAnterior: mesAnterior, anoAtual: anoAtual, mes_12_anterior: mes_12_anterior, ano_12_anterior: ano_12_anterior } = this.valuesDatasSemFiltro();
            this.model = {
                ano: ano_12_anterior,
                ano_fim: anoAtual,
                user: [],
                mes_fim2: mesAnterior,
                mes_inicio2: mes_12_anterior,
                mes_fim: 12,
                mes_inicio2: 1,
                tem_atendimento: 'true'
            };
            window.location.href = `${window.location.origin}/clientes/reunioes/cliente_pf/`;
        },
        setQueryUrl () {
            this.query = '?';
            const idUsers = this.model?.user?.map((user)=>user.value || user);
            const userJoin = idUsers.filter((idUser)=>idUser)?.join(',');
            if (userJoin) this.query += `&user=${userJoin}`;
            if (this.model.ano) this.query += `&ano=${this.model.ano}`;
            if (this.model.ano_fim) this.query += `&ano_fim=${this.model.ano_fim}`;
            if (this.model.mes_inicio2) this.query += `&mes_inicio2=${this.model.mes_inicio2}`;
            if (this.model.mes_inicio) this.query += `&mes_inicio=${this.model.mes_inicio}`;
            if (this.model.mes_fim2) this.query += `&mes_fim2=${this.model.mes_fim2}`;
            if (this.model.mes_fim) this.query += `&mes_fim=${this.model.mes_fim}`;
            if (this.model.tem_atendimento) {
                if (this.model.tem_atendimento === 'ver_todos') this.query += `&ver_todos=true`;
                else this.query += `&tem_atendimento=${this.model.tem_atendimento}`;
            }
        },
        filtrarReunioesRealizadas () {
            this.setQueryUrl();
            window.location.href = `${window.location.origin}/clientes/reunioes/cliente_pf/${this.query}`;
            this.paintMesesAtrasados();
        },
        getScrollElement () {
            return this.$refs.gridContainer?.querySelector('.gridjs-wrapper');
        },
        scrollUp () {
            window.scrollBy({
                top: -50,
                behavior: 'smooth'
            });
        },
        scrollDown () {
            window.scrollBy({
                top: 50,
                behavior: 'smooth'
            });
        },
        scrollLeft () {
            const container = this.getScrollElement();
            if (container) container.scrollBy({
                left: -50,
                behavior: 'smooth'
            });
        },
        scrollRight () {
            const container = this.getScrollElement();
            if (container) container.scrollBy({
                left: 50,
                behavior: 'smooth'
            });
        },
        paintMesesAtrasados () {
            let timeout = 10;
            let timeCount = 0;
            const checkIdInterval = setInterval(()=>{
                timeCount++;
                const isTableRender = document.querySelector('.gridjs-td');
                if (isTableRender !== null && isTableRender.hasChildNodes()) {
                    this.$nextTick(()=>{
                        document.querySelectorAll('.gridjs-td').forEach((td)=>{
                            if (td.querySelector('.atraso_entre_2_3')) td.style.backgroundColor = 'rgba(253, 212, 38, 0.3)';
                            if (td.querySelector('.atraso_maior_3')) td.style.backgroundColor = 'rgba(236, 53, 57, 0.3)';
                        });
                    });
                    clearInterval(checkIdInterval);
                } else if (timeCount >= timeout) clearInterval(checkIdInterval);
            }, 1500);
        }
    },
    async mounted () {
        const inputs = document.querySelectorAll('.input-date');
        inputs.forEach((i)=>{
            GLOBAL.initFlatpickr(i, {
                position: 'above',
                mode: 'single',
                format: 'm/Y',
                plugins: [
                    new monthSelectPlugin({
                        shorthand: true,
                        dateFormat: 'm/Y'
                    })
                ]
            });
        });
        await this.setValuesReunioes();
        this.setQueryUrl();
        setTimeout(()=>{
            this.iniciartableReunioesRealizadas(this.query);
        }, 300);
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});

parcelRegister("8IO0M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65993a083331ab2d$export$2e2bcd8739ae039; });
parcelRequire("26SB8");

var $7h4Zs = parcelRequire("7h4Zs");

var $4nzoT = parcelRequire("4nzoT");
parcelRequire("2m7Ys");
parcelRequire("6crX0");

var $lOXRB = parcelRequire("lOXRB");

var $3EnNF = parcelRequire("3EnNF");

var $94JCq = parcelRequire("94JCq");
parcelRequire("9YhWF");

var $22Usp = parcelRequire("22Usp");

var $4Jsmc = parcelRequire("4Jsmc");
parcelRequire("bF0nE");

var $bLcT0 = parcelRequire("bLcT0");

var $DhNZ3 = parcelRequire("DhNZ3");

var $9mPML = parcelRequire("9mPML");

var $lY3Fi = parcelRequire("lY3Fi");
const { getAtendimentoReuniaoSai: $65993a083331ab2d$var$getAtendimentoReuniaoSai } = (0, $94JCq.reuniaoService)();
var $65993a083331ab2d$export$2e2bcd8739ae039 = {
    emits: [],
    props: {},
    components: {
        GraficoFundacoesReuniaoPeriodo: $22Usp.default,
        GraficoFundacoesReuniaoAtendimento: $4Jsmc.default,
        SelectMultiple: $7h4Zs.default,
        ModalResumo: $4nzoT.default,
        ModalFiltroCalendarioSai: $3EnNF.default,
        TableCalendarioReuniaoSai: $lOXRB.default,
        TableDistribuicaoAtendimento: $bLcT0.default,
        DrawerAtendimentoRapido: $DhNZ3.default,
        Loader: $9mPML.default
    },
    mixins: [
        (0, $lY3Fi.default)
    ],
    data () {
        return {
            isChangeChartReuniaoPeriodo: false,
            filtroQuery: {
                distribuicao: null
            },
            filtroModalCalendarioSai: {
                officers: []
            },
            clientesSelecionados: new Set(),
            limparCheckboxesTimestamp: 0,
            reuniaoAtendimento: {
                data: [],
                isLoading: false,
                error: null
            },
            queryTabelaPorPeriodo: {}
        };
    },
    computed: {
        periodoFormatado () {
            return this.filtroQuery.distribuicao || "";
        },
        labelInfoGraficoPeriodo () {
            if (this.isChangeChartReuniaoPeriodo) return;
        },
        officersOptions () {
            // Extrai e formata os officers vindos da API para o select do modal
            const users = this.reuniaoAtendimento?.data?.results?.todos_users || [];
            return users.map((user)=>({
                    value: user.id,
                    label: user.username
                }));
        },
        totalSelecionado () {
            return this.clientesSelecionados.size;
        },
        mostrarDrawer () {
            return this.totalSelecionado > 0;
        },
        dadosPeriodoSelecionado () {
            if (!this.filtroQuery.distribuicao || !this.reuniaoAtendimento.data?.clientes_sem_reuniao_por_periodo) return null;
            const periodo = this.filtroQuery.distribuicao;
            const dadosPeriodo = this.reuniaoAtendimento.data.clientes_sem_reuniao_por_periodo[periodo];
            return dadosPeriodo || null;
        },
        totalPeriodoSelecionado () {
            return this.dadosPeriodoSelecionado?.total || 0;
        },
        corPeriodoSelecionado () {
            const coresPorPeriodo = {
                '1-3 meses': '#18b25d',
                '4-6 meses': '#ffc107',
                '7-9 meses': '#ec3539',
                '10+ meses': '#ec3539'
            };
            return coresPorPeriodo[this.filtroQuery.distribuicao] || '#18b25d';
        },
        getParamsAPI () {
            const anoAtual = new Date().getFullYear();
            const params = {
                ano_inicio: 2024,
                mes_inicio_ano_inicial: '01',
                tem_atendimento: 'true',
                ano_fim: anoAtual,
                mes_fim_ano_final: '12',
                mes_inicio_ano_final: '1',
                mes_fim_ano_inicial: '12',
                page: 1,
                per_page: 999999
            };
            // Período
            if (this.filtroQuery.distribuicao) {
                const mapeamentoPeriodos = {
                    '1-3 meses': '1,3',
                    '4-6 meses': '4,6',
                    '7-9 meses': '7,9',
                    '10+ meses': '10,9999'
                };
                params.meses = mapeamentoPeriodos[this.filtroQuery.distribuicao];
            }
            // Officers
            const officers = (this.filtroModalCalendarioSai.officers || []).map((o)=>o.value);
            if (officers.length === 1) params.user = officers[0];
            else if (officers.length > 1) params.user = officers.join(',');
            return params;
        }
    },
    watch: {
        isChangeChartReuniaoPeriodo (newValue) {
            if (!newValue) // Resetar filtro quando sair do modo detalhado
            this.filtroQuery.distribuicao = null;
            else this.aplicaFiltrosTabelaDistribuicao();
        }
    },
    methods: {
        aplicaFiltrosTabelaDistribuicao () {
            const query = {};
            // Filtro por período (meses)
            if (this.filtroQuery.distribuicao) {
                const mapeamentoPeriodos = {
                    '1-3 meses': '1,3',
                    '4-6 meses': '4,6',
                    '7-9 meses': '7,9',
                    '10+ meses': '10,999'
                };
                query.meses = mapeamentoPeriodos[this.filtroQuery.distribuicao];
            }
            // Filtro por officers (user)
            const officers = (this.filtroModalCalendarioSai.officers || []).map((o)=>o.value);
            if (officers.length === 1) query.user = officers[0];
            else if (officers.length > 1) query.user = officers.join(',');
            this.queryTabelaPorPeriodo = query;
        },
        async limparFiltrosCalendarioSai () {
            this.filtroModalCalendarioSai = {
                officers: []
            };
            this.aplicaFiltrosTabelaDistribuicao();
            // Requisição SEM officers, mas mantém período se estiver ativo
            this.reuniaoAtendimento.isLoading = true;
            try {
                const { user: user, ...restoQuery } = this.queryTabelaPorPeriodo;
                this.queryTabelaPorPeriodo = {
                    ...restoQuery
                };
                const response = await $65993a083331ab2d$var$getAtendimentoReuniaoSai(this.getParamsAPI);
                this.reuniaoAtendimento.data = response || response?.data || [];
            } catch (error) {
                console.error('Erro ao limpar filtros:', error);
                this.reuniaoAtendimento.error = error;
                this.reuniaoAtendimento.data = [];
            } finally{
                this.reuniaoAtendimento.isLoading = false;
            }
        },
        openModalFiltroCalendarioSai () {
            modal_padrao_vue.openModal('reunioes_calendario_sai');
        },
        async aplicarFiltrosCalendarioSai () {
            this.aplicaFiltrosTabelaDistribuicao();
            this.reuniaoAtendimento.isLoading = true;
            try {
                const response = await $65993a083331ab2d$var$getAtendimentoReuniaoSai(this.getParamsAPI);
                this.reuniaoAtendimento.data = response || response?.data || [];
            } catch (error) {
                console.error('Erro ao aplicar filtros:', error);
                this.reuniaoAtendimento.error = error;
                this.reuniaoAtendimento.data = [];
            } finally{
                this.reuniaoAtendimento.isLoading = false;
            }
        },
        async carregarReuniaoAtendimento (filtros = {}) {
            this.reuniaoAtendimento.isLoading = true;
            this.reuniaoAtendimento.error = null;
            try {
                const response = await $65993a083331ab2d$var$getAtendimentoReuniaoSai(this.getParamsAPI);
                this.reuniaoAtendimento.data = response || response?.data || [];
            } catch (error) {
                console.error("Erro ao carregar reuni\xe3o atendimento:", error);
                this.reuniaoAtendimento.error = error;
                this.reuniaoAtendimento.data = [];
            } finally{
                this.reuniaoAtendimento.isLoading = false;
            }
        },
        async toggleChangeChartReuniaoPeriodo (chartEventoInfo) {
            this.isChangeChartReuniaoPeriodo = !this.isChangeChartReuniaoPeriodo;
            if (this.isChangeChartReuniaoPeriodo) {
                this.filtroQuery.distribuicao = chartEventoInfo?.categoria || this.filtroQuery?.distribuicao || '4-6 meses';
                try {
                    this.reuniaoAtendimento.isLoading = true;
                    const response = await $65993a083331ab2d$var$getAtendimentoReuniaoSai(this.getParamsAPI);
                    if (this.reuniaoAtendimento.data && response && response.meses_clientes_sem_reuniao) this.reuniaoAtendimento.data = {
                        ...this.reuniaoAtendimento.data,
                        meses_clientes_sem_reuniao: response.meses_clientes_sem_reuniao
                    };
                } catch (error) {
                    console.error("Erro ao filtrar gr\xe1fico de atendimento:", error);
                } finally{
                    this.reuniaoAtendimento.isLoading = false;
                }
            } else {
                this.filtroQuery.distribuicao = null;
                const { meses: meses, ...restoQuery } = this.queryTabelaPorPeriodo;
                this.queryTabelaPorPeriodo = {
                    ...restoQuery
                };
                await this.carregarReuniaoAtendimento();
            }
        },
        handleClienteChecked (idCliente) {
            this.clientesSelecionados.add(idCliente);
        },
        handleClienteUnchecked (idCliente) {
            this.clientesSelecionados.delete(idCliente);
        },
        handleClearClientes () {
            this.clientesSelecionados.clear();
            this.limparCheckboxesTimestamp = Date.now();
        },
        async criarAtendimentoRapido (politicaId, mensagem) {
            if (!politicaId || this.clientesSelecionados.size === 0) return;
            this.loadingAtendimentoRapido = true;
            try {
                // Adiciona os clientes selecionados ao mixin
                this.clearClienteAtendimentoRapido();
                Array.from(this.clientesSelecionados).forEach((id)=>this.addClienteAtendimentoRapido(id));
                // Chama o método do mixin para criar o atendimento rápido
                await this.createAtendimentoRapido(politicaId, mensagem, "Atendimento R\xe1pido", null // data opcional
                );
                // Limpa seleção após sucesso
                this.handleClearClientes();
            } catch (error) {
                console.error('Erro ao criar atendimento:', error);
            } finally{
                this.loadingAtendimentoRapido = false;
            }
        }
    },
    async mounted () {
        await this.carregarReuniaoAtendimento();
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("lOXRB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe2cb41e427dc64e$export$2e2bcd8739ae039; });

var $diqzg = parcelRequire("diqzg");

var $9YhWF = parcelRequire("9YhWF");

var $26SB8 = parcelRequire("26SB8");
var $fe2cb41e427dc64e$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $diqzg.default)
    ],
    props: {
        query: ''
    },
    data () {
        return {
            _gridThenCallback: null,
            _gridTotalCallback: null,
            listaFundacaoAtendimentoSai: [],
            tabelaCalendarioReuniaoSai: null,
            columns: [
                {
                    id: 'id',
                    name: 'ID',
                    hidden: true
                },
                {
                    id: 'politica',
                    name: 'Politica',
                    hidden: true
                },
                {
                    id: 'nome',
                    name: "Nome da Funda\xe7\xe3o",
                    attributes: {
                        'sticky-column-1': true,
                        'sticky-header': true
                    },
                    hidden: false,
                    width: '140px',
                    formatter: (cell, row)=>{
                        const politica = row?.cells[1]?.data;
                        return (0, $26SB8.html)(`<div class="inline-flex items-center max-w-[180px] "  >
							<svg class="h-40 w-40 shrink-0" style="${GLOBAL.generateAvatarColor(politica)}">
									<use xlink:href="#icon_person"></use>
								</svg>
							<span class="one-line max-w-[180px]" title="${cell}">${cell || ''}</span>
						</div>`);
                    },
                    /* 			sort: {
						compare: (a, b) => {
							const fundacaoA = this.listaFundacaoAtendimentoSai.find(
								(itemFundacao) => itemFundacao.nome_fundacao === a
							)
							const fundacaoB = this.listaFundacaoAtendimentoSai.find(
								(itemFundacao) => itemFundacao.nome_fundacao === b
							)

							if (
								parseInt(fundacaoA.politica) !== parseInt(fundacaoB.politica)
							) {
								return (
									parseInt(fundacaoA.politica) - parseInt(fundacaoB.politica)
								)
							}
						},
					}, */ sort: false
                },
                {
                    id: 'ultimo_atendimento',
                    name: 'Ultimo Atendimento',
                    hidden: false,
                    width: '70px',
                    formatter: (cell, row)=>{
                        return (0, $26SB8.html)(`<div class="inline-flex items-center max-w-[180px] "  >
							<span class="one-line max-w-[180px]">H\xe1 ${cell || '0'} meses</span>
						</div>`);
                    }
                },
                {
                    id: 'fundos',
                    name: 'Fundos',
                    hidden: false,
                    width: '95px',
                    sort: false,
                    formatter: (cell, row)=>{
                        return (0, $26SB8.html)(`<div class="inline-flex items-center max-w-[180px] "  >
							<span class="one-line max-w-[180px]" title="${cell}">${cell?.join(', ') || ''}</span>
						</div>`);
                    }
                }
            ]
        };
    },
    methods: {
        iniciaTabelaCalendarioReuniaoSai () {
            const tabela = document.querySelector('#tabela_reuniao_calendario_sai');
            /* 	let sortColumn = null
			let sortOrder = 'asc' */ // Guarda localmente essas duas callbacks para podermos reaplicá‐las depois
            this._gridThenCallback = (responseAtendimentos)=>{
                const { meses_clientes_sem_reuniao: meses_clientes_sem_reuniao, meses_clientes_sem_reuniao_ano_atual: meses_clientes_sem_reuniao_ano_atual } = responseAtendimentos;
                const listaAtendimentos = [
                    ...meses_clientes_sem_reuniao,
                    ...meses_clientes_sem_reuniao_ano_atual
                ];
                this.listaFundacaoAtendimentoSai = listaAtendimentos;
                return this.transformDataAtendimentoFundacao(listaAtendimentos);
            };
            this._gridTotalCallback = (responseAtendimentos)=>{
                return responseAtendimentos.pagination?.total_items || 0;
            };
            const optionsPaginacao = {
                pagination: {
                    enabled: true,
                    limit: 10,
                    summary: true,
                    server: {
                        url: (urlApi, page, limit)=>{
                            return `${urlApi}&page=${page + 1}&per_page=${limit}`;
                        }
                    }
                },
                language: {
                    pagination: {
                        previous: 'Anterior',
                        next: "Pr\xf3ximo",
                        navigate: (page, pages)=>`P\xe1gina ${page} de ${pages}`,
                        page: (page)=>`P\xe1gina ${page}`,
                        showing: 'Mostrando',
                        of: 'de',
                        to: 'a',
                        results: 'resultados'
                    }
                }
            };
            const optionsSort = {
                sort: {
                    multiColumn: false,
                    server: {
                        url: (prev, columns)=>{
                            if (!columns.length || columns[0].index !== 3) return prev;
                            const col = columns[0];
                            const dir = col.direction === 1 ? 'asc' : 'desc';
                            return `${prev}&sort_order=${dir}`;
                        }
                    }
                }
            };
            const optionsSearch = {
                search: {
                    server: {
                        url: (prev, keyword)=>`${prev}&search=${keyword}`
                    }
                }
            };
            this.tabelaCalendarioReuniaoSai = this.iniciarTabelaGenerica(this.columns, `${window.origin}${(0, $9YhWF.URLS).atendimento_reuniao_sai}${this.query}`, this._gridThenCallback, this._gridTotalCallback, {
                ...optionsPaginacao,
                ...optionsSort,
                ...optionsSearch
            });
            /* 	this.tabelaCalendarioReuniaoSai.on('sort', (column, direction) => {
				// Só permite ordenação server-side para 'ultimo_atendimento'
				if (column.id === 'ultimo_atendimento') {
					sortColumn = column.id
					sortOrder = direction
				} else {
					sortColumn = null
					sortOrder = 'asc'
				}
				this.tabelaCalendarioReuniaoSai
					.updateConfig({
						server: {
							url: (urlApi, page, limit) => {
								let url = `${urlApi}&page=${page + 1}&per_page=${limit}`
								if (sortColumn) {
									url += `&sort_by=${sortColumn}&sort_order=${sortOrder}`
								}
								return url
							},
							then: this._gridThenCallback,
							total: this._gridTotalCallback,
						},
					})
					.forceRender()
			}) */ this.tabelaCalendarioReuniaoSai.render(tabela);
        },
        transformDataAtendimentoFundacao (atendimentos) {
            return atendimentos.map((itemAtendimento)=>{
                const dataAtendimento = new Date(itemAtendimento.data_reuniao);
                return {
                    id: itemAtendimento.id_fundacao,
                    politica: itemAtendimento.politica || '0',
                    nome: itemAtendimento.nome_fundacao,
                    ultimo_atendimento: Quasar.date.getDateDiff(new Date(), dataAtendimento, 'months'),
                    fundos: itemAtendimento.fundos_fundacao
                };
            });
        },
        atualizarTabelaComNovaQuery () {
            if (!this.tabelaCalendarioReuniaoSai) return;
            const novaUrl = window.origin + (0, $9YhWF.URLS).atendimento_reuniao_sai + this.query;
            this.tabelaCalendarioReuniaoSai.updateConfig({
                server: {
                    url: novaUrl,
                    then: this._gridThenCallback,
                    total: this._gridTotalCallback
                }
            }).forceRender();
        }
    },
    watch: {
        query (newVal, oldVal) {
            if (newVal !== oldVal) this.atualizarTabelaComNovaQuery();
        }
    },
    mounted () {
        this.iniciaTabelaCalendarioReuniaoSai();
    },
    template: `
        <table
			id="tabela_reuniao_calendario_sai"
			class="!flex"
			js-table-ordenation
			style="margin-inline: 1rem"></table>
    `
};

});

parcelRegister("3EnNF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a8791b767361694$export$2e2bcd8739ae039; });
parcelRequire("94JCq");

var $7h4Zs = parcelRequire("7h4Zs");
var $2a8791b767361694$export$2e2bcd8739ae039 = {
    name: 'ModalFiltroCalendarioSai',
    props: {
        modelValue: {
            type: Object,
            default: ()=>({
                    officers: []
                })
        },
        faixaMesesSemAtendimentoOptions: [],
        officersOptions: []
    },
    components: {
        SelectMultiple: $7h4Zs.default
    },
    data () {
        return {
            usuariosOptions: []
        };
    },
    watch: {
        'modelValue.faixa_meses_sem_atendimento': {
            immediate: true,
            handler (novo) {
                if (!novo) this.$emit('update:modelValue', {
                    ...this.modelValue,
                    faixa_meses_sem_atendimento: '1,3'
                });
            }
        }
    },
    emits: [
        'update:modelValue',
        'onClickAplicarFiltros',
        'onClickLimparFiltros'
    ],
    computed: {
        filtrosCalendarioFundacao: {
            get () {
                return this.modelValue;
            },
            set (novoObjeto) {
                this.$emit('update:modelValue', {
                    ...novoObjeto
                });
            }
        }
    },
    methods: {
        aplicarFiltros () {
            this.$emit('onClickAplicarFiltros');
        },
        limparFiltros () {
            this.$emit('onClickLimparFiltros');
        }
    },
    template: `
       <section
        class="modal--content rounded-md w-full !overflow-visible"
        data-id="reunioes_calendario_sai"
		id="reunioes_calendario_sai">
	<header
		class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
		<h2 class="text-lg font-medium text-white">Filtros</h2>
		<button
			type="button"
			class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
			data-xclose="modal_padrao_vue">
			<svg class="w-32 h-32">
				<use xlink:href="#icon_close"></use>
			</svg>
		</button>
	</header>
	<div class="flex flex-col gap-24 !p-24 w-full">
		<div class="flex flex-col gap-4 w-full">
			<label class="text-sm text-neutral-80 font-medium"> Officer: </label>

			<select-multiple
                :model="modelValue.officers"
				:options="officersOptions"
                @changed="(val) => modelValue.officers = val"
				:submitfc="() => {}">
			</select-multiple>
		</div>
		<div v-show="false" class="w-full grid grid-cols-2 gap-24 justify-between items-center">
			<div class="flex flex-col gap-4">
				<label class="text-sm text-neutral-80 font-medium"> De: </label>
				<input
					v-model="modelValue.ano_inicio"
					type="text"
					class="input-date border-2 rounded-[3px] !border-neutral-30 h-48 px-8"
					placeholder="MM/YYYY" />
			</div>
			<div class="flex flex-col gap-4">
				<label class="text-sm text-neutral-80 font-medium"> At\xe9: </label>
				<input
					v-model="modelValue.mes_fim_ano_inicial"
					type="text"
					class="input-date border-2 rounded-[3px] !border-neutral-30 h-48 px-8"
					placeholder="MM/YYYY" />
			</div>
		</div>

		<div class="flex flex-col gap-4 w-full">
			<div v-if="false" class="inline-flex">
				<label class="text-sm text-neutral-80 font-medium mr-10">
					Possui Atendimento?
				</label>
				<div  class="text-sm text-neutral-80 font-medium">
					<q-radio v-model="modelValue.tem_atendimento" val="true" label="Sim" />
					<q-radio
						v-model="modelValue.tem_atendimento"
						val="false"
						class="ml-10"
						label="N\xe3o" />
				</div>
			</div>
		</div>

		<div v-if="false" class="flex flex-col gap-4 w-full">
			<label class="text-sm text-neutral-80 font-medium"> Per\xedodo \xdaltimo Atendimento: </label>

			 <q-select  
			 	v-model="modelValue.faixa_meses_sem_atendimento"  
				:options="faixaMesesSemAtendimentoOptions"  
				emit-value
				map-options
				outlined   />
		</div>
	</div>
	<div class="w-full flex gap-24 justify-between items-center p-24">
		<button
			type="button"
			class="btn h-48 secondary"
            @click="limparFiltros"
			>
			Limpar Filtros
		</button>
		<button
			type="button"
			class="btn h-48 primary"
            @click="aplicarFiltros"
			>
			Aplicar Filtros
		</button>
	</div>
</section>
    `
};

});

parcelRegister("22Usp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17d78fe1b86dc944$export$2e2bcd8739ae039; });
var $17d78fe1b86dc944$export$2e2bcd8739ae039 = {
    emits: [
        'clickBarraChart'
    ],
    props: {
        clientes_sem_reuniao_por_periodo: {
            type: Object,
            required: false,
            default: ()=>({
                    '1-3 meses': {
                        politicas: {
                            'SAI/Cliente': 0,
                            SAI: 0,
                            'N/A': 0,
                            'Consultor/Gestor': 0
                        },
                        total: 0,
                        porcentagem: 0
                    },
                    '4-6 meses': {
                        politicas: {
                            'SAI/Cliente': 0,
                            SAI: 0,
                            'N/A': 0,
                            'Consultor/Gestor': 0
                        },
                        total: 0,
                        porcentagem: 0
                    },
                    '7-9 meses': {
                        politicas: {
                            'SAI/Cliente': 0,
                            SAI: 0,
                            'N/A': 0,
                            'Consultor/Gestor': 0
                        },
                        total: 0,
                        porcentagem: 0
                    },
                    '10+ meses': {
                        politicas: {
                            'SAI/Cliente': 0,
                            SAI: 0,
                            'N/A': 0,
                            'Consultor/Gestor': 0
                        },
                        total: 0,
                        porcentagem: 0
                    }
                })
        }
    },
    data () {
        return {
            chart: null
        };
    },
    computed: {
        chartData () {
            if (!this.clientes_sem_reuniao_por_periodo) return [];
            const periodos = [
                '1-3 meses',
                '4-6 meses',
                '7-9 meses',
                '10+ meses'
            ];
            const dadosProcessados = periodos.map((periodo)=>{
                const dados = this.clientes_sem_reuniao_por_periodo[periodo] || {
                    total: 0,
                    porcentagem: 0,
                    politicas: {}
                };
                return {
                    periodo: periodo,
                    total: dados.total,
                    porcentagem: dados.porcentagem,
                    politicas: dados.politicas || {}
                };
            });
            return dadosProcessados;
        },
        chartOptions () {
            return {
                series: [
                    {
                        name: "Percentual de Funda\xe7\xf5es",
                        data: this.chartData.map((d)=>d.porcentagem)
                    }
                ],
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: false
                    }
                },
                colors: [
                    '#18b25d',
                    '#ffc107',
                    '#ec3539',
                    '#ec3539'
                ],
                plotOptions: {
                    bar: {
                        borderRadius: 6,
                        columnWidth: '50%',
                        dataLabels: {
                            position: 'top'
                        },
                        distributed: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val)=>`${val.toFixed(1)}%`,
                    offsetY: -30,
                    style: {
                        fontSize: '13px',
                        colors: [
                            '#304758'
                        ]
                    }
                },
                xaxis: {
                    categories: this.chartData.map((d)=>d.periodo),
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    labels: {
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                yaxis: {
                    min: 0,
                    max: 100,
                    tickAmount: 5,
                    labels: {
                        formatter: (val)=>`${val}%`,
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                grid: {
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },
                    xaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                title: {
                    text: "Distribui\xe7\xe3o das Funda\xe7\xf5es por Tempo sem Atendimento (Pol\xedticas)",
                    align: 'center',
                    style: {
                        fontSize: '16px',
                        color: '#444'
                    }
                },
                tooltip: {
                    custom: ({ seriesIndex: seriesIndex, dataPointIndex: dataPointIndex, w: w })=>{
                        const dados = this.chartData[dataPointIndex];
                        const politicas = dados.politicas;
                        const totalPoliticas = Object.values(politicas).reduce((sum, val)=>sum + val, 0);
                        // Calcular percentuais por política
                        const percentuaisPoliticas = {};
                        Object.keys(politicas).forEach((key)=>{
                            percentuaisPoliticas[key] = totalPoliticas > 0 ? (politicas[key] / totalPoliticas * 100).toFixed(1) : 0;
                        });
                        return `
							<div style="padding: 12px; background: white; border: 1px solid #e3e3e3; border-radius: 4px; font-family: Arial, sans-serif;">
								<div style="margin-bottom: 8px;">
									<strong>Faixa:</strong> ${dados.periodo}
								</div>
								<div style="margin-bottom: 8px;">
									<strong>Total de funda\xe7\xf5es:</strong> ${dados.total}
								</div>
								<div style="margin-bottom: 8px;">
									<strong>Percentual do total:</strong> ${dados.porcentagem.toFixed(1)}%
								</div>
								<div style="margin-top: 12px; padding-top: 8px; border-top: 1px solid #e3e3e3;">
									<div style="font-weight: bold; margin-bottom: 6px;">Distribui\xe7\xe3o por pol\xedtica:</div>
									${politicas['SAI/Cliente'] !== undefined ? `<div style="margin-bottom: 4px;">SAI/Cliente: ${percentuaisPoliticas['SAI/Cliente']}%</div>` : ''}
									${politicas['SAI'] !== undefined ? `<div style="margin-bottom: 4px;">SAI: ${percentuaisPoliticas['SAI']}%</div>` : ''}
									${politicas['N/A'] !== undefined ? `<div style="margin-bottom: 4px;">N/A: ${percentuaisPoliticas['N/A']}%</div>` : ''}
									${politicas['Consultor/Gestor'] !== undefined ? `<div style="margin-bottom: 4px;">Consultor/Gestor: ${percentuaisPoliticas['Consultor/Gestor']}%</div>` : ''}
								</div>
							</div>
						`;
                    }
                }
            };
        }
    },
    methods: {
        renderChart () {
            if (this.chart) this.chart.destroy();
            this.chart = new ApexCharts(this.$refs.chartFundacaoPeriodoContainer, this.chartOptions);
            this.chart.render();
            this.chart.addEventListener('dataPointSelection', (event, chartContext, config)=>{
                const dados = this.chartData[config.dataPointIndex];
                this.$emit('clickBarraChart', {
                    index: config.dataPointIndex,
                    categoria: dados.periodo,
                    valor: dados.porcentagem,
                    total: dados.total,
                    politicas: dados.politicas
                });
            });
        }
    },
    watch: {
        clientes_sem_reuniao_por_periodo: {
            handler () {
                this.renderChart();
            },
            deep: true
        }
    },
    mounted () {
        this.renderChart();
    },
    beforeUnmount () {
        if (this.chart) this.chart.destroy();
    },
    template: `
        <div ref="chartFundacaoPeriodoContainer"></div>
    `
};

});

parcelRegister("4Jsmc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37215c854f3af348$export$2e2bcd8739ae039; });
var $37215c854f3af348$export$2e2bcd8739ae039 = {
    emits: [
        'clickBarraChart'
    ],
    props: {
        meses_clientes_sem_reuniao: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        cor: {
            type: String,
            required: false,
            default: '#18b25d'
        }
    },
    data () {
        return {
            chart: null,
            customTooltip: {
                show: false,
                x: 0,
                y: 0,
                content: ''
            }
        };
    },
    computed: {
        dadosProcessados () {
            if (!this.meses_clientes_sem_reuniao || this.meses_clientes_sem_reuniao.length === 0) return {
                data: [],
                categories: [],
                fundacoes: []
            };
            // Ordenar decrescente por meses_sem_reuniao
            const fundacoesOrdenadas = [
                ...this.meses_clientes_sem_reuniao
            ].sort((a, b)=>b.meses_sem_reuniao - a.meses_sem_reuniao);
            return {
                data: fundacoesOrdenadas.map((f)=>f.meses_sem_reuniao),
                categories: fundacoesOrdenadas.map((f)=>f.nome_fundacao),
                fundacoes: fundacoesOrdenadas
            };
        },
        chartOptions () {
            const alturaPorBarra = 40 // px
            ;
            const alturaGrafico = Math.max(this.dadosProcessados.categories.length * alturaPorBarra, 300);
            return {
                series: [
                    {
                        name: "Meses desde \xfaltimo atendimento",
                        data: this.dadosProcessados.data
                    }
                ],
                chart: {
                    type: 'bar',
                    height: alturaGrafico,
                    toolbar: {
                        show: false
                    }
                },
                colors: [
                    this.cor
                ],
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        borderRadiusApplication: 'end',
                        horizontal: true,
                        dataLabels: {
                            position: 'top'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val)=>`${val} meses`,
                    offsetX: 40,
                    style: {
                        fontSize: '13px',
                        colors: [
                            '#304758'
                        ]
                    }
                },
                xaxis: {
                    categories: this.dadosProcessados.categories,
                    title: {
                        text: 'Meses sem atendimento'
                    },
                    labels: {
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: "Funda\xe7\xf5es"
                    },
                    labels: {
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                tooltip: {
                    enabled: false
                }
            };
        }
    },
    methods: {
        renderChart () {
            if (this.chart) this.chart.destroy();
            this.chart = new ApexCharts(this.$refs.chartPeriodoAtendimentoContainer, this.chartOptions);
            this.chart.render();
            this.chart.addEventListener('dataPointSelection', (event, chartContext, config)=>{
                const fundacao = this.dadosProcessados.fundacoes[config.dataPointIndex];
                this.$emit('clickBarraChart', {
                    index: config.dataPointIndex,
                    fundacao: fundacao,
                    meses_sem_reuniao: fundacao.meses_sem_reuniao
                });
            });
            this.chart.addEventListener('dataPointMouseEnter', (event, chartContext, config)=>{
                const fundacao = this.dadosProcessados.fundacoes[config.dataPointIndex];
                if (!fundacao) return;
                // Pega posição do mouse
                const mouseX = event.clientX;
                const mouseY = event.clientY;
                // Monta o conteúdo do tooltip
                const politicaNomes = {
                    0: 'N/A',
                    1: 'SAI',
                    2: 'SAI/Cliente',
                    3: 'Consultor/Gestor'
                };
                const fundosList = Array.isArray(fundacao.fundos_fundacao) && fundacao.fundos_fundacao.length ? `<ul style="margin: 8px 0 0 0; padding-left: 18px;">
								${fundacao?.fundos_fundacao.map((fundo)=>`<li style="list-style-type: disc;">${fundo}</li>`).join('')}
							</ul>` : '<span style="color: #888;">Nenhum fundo</span>';
                const reunioesPendentesList = Array.isArray(fundacao.reunioes_pendentes) && fundacao.reunioes_pendentes.length ? `<ul style="margin: 8px 0 0 0; padding-left: 18px;">
								${fundacao.reunioes_pendentes.map((reuniao)=>`<li style="list-style-type: disc;">${reuniao}</li>`).join('')}
							</ul>` : '<span style="color: #888;">Nenhuma reuni\xe3o pendente</span>';
                const content = `
						<div style="padding: 12px; background: white; border: 1px solid #e3e3e3; border-radius: 4px; font-family: Arial, sans-serif; height: max-content;">
							<div><strong>${fundacao.nome_fundacao}</strong></div>
							<div>Meses sem atendimento: <strong>${fundacao.meses_sem_reuniao}</strong></div>
							<div>Pol\xedtica: <strong>${politicaNomes[fundacao.politica] || 'N/A'}</strong></div>
							<div style="margin-top: 6px;"><strong>Fundos:</strong></div>
							${fundosList}
							<div style="margin-top: 6px;"><strong>Reuni\xf5es Pendentes:</strong></div>
							${reunioesPendentesList}
						</div>
					`;
                // Atualiza dados do tooltip customizado
                this.customTooltip = {
                    show: true,
                    x: mouseX + 10,
                    y: mouseY + 10,
                    content: content
                };
            });
            // Evento de sair do hover
            this.chart.addEventListener('dataPointMouseLeave', ()=>{
                this.customTooltip.show = false;
            });
        }
    },
    watch: {
        meses_clientes_sem_reuniao: {
            handler () {
                this.renderChart();
            },
            deep: true
        }
    },
    mounted () {
        this.renderChart();
    },
    beforeUnmount () {
        if (this.chart) this.chart.destroy();
    },
    template: `
        <div ref="chartPeriodoAtendimentoContainer"></div>
		 <div
			v-if="customTooltip.show"
			v-html="customTooltip.content"
			:style="{
			position: 'fixed',
			left: customTooltip.x + 'px',
			top: customTooltip.y + 'px',
			zIndex: 99999999999999999999,
			pointerEvents: 'none'
			}"
		></div>
    `
};

});

parcelRegister("bLcT0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88fe146a1ee7e16d$export$2e2bcd8739ae039; });

var $diqzg = parcelRequire("diqzg");

var $26SB8 = parcelRequire("26SB8");

var $9YhWF = parcelRequire("9YhWF");
const { isFundacao: $88fe146a1ee7e16d$var$isFundacao } = GLOBAL;
let $88fe146a1ee7e16d$var$isActivateCheckboxHeader = false;
var $88fe146a1ee7e16d$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $diqzg.default)
    ],
    props: {
        query: {
            type: Object,
            default: ()=>({}),
            required: false
        },
        limparCheckboxesExterno: {
            type: Number,
            default: 0
        }
    },
    emits: [
        'click-checked-cliente',
        'click-unchecked-cliente',
        'clear-clientes'
    ],
    data () {
        return {
            isFundacao: $88fe146a1ee7e16d$var$isFundacao(),
            tabelaAtendimento: null,
            atendimentos: [],
            controllerCheckbox: null,
            clientesSelecionadosInternos: new Set()
        };
    },
    computed: {
        urlCompleta () {
            const anoAtual = new Date().getFullYear();
            const params = new URLSearchParams({
                ano_inicio: 2024,
                mes_inicio_ano_inicial: '01',
                tem_atendimento: 'true',
                ano_fim: anoAtual,
                mes_fim_ano_final: '12',
                mes_inicio_ano_final: '1',
                mes_fim_ano_inicial: '12',
                ...this.query
            });
            return `${(0, $9YhWF.URLS).atendimento_reuniao_sai}?${params.toString()}`;
        },
        columns () {
            return [
                {
                    id: 'id_fundacao',
                    name: 'ID',
                    hidden: true
                },
                {
                    id: 'checkbox',
                    name: this.headerCheckboxHTML(),
                    width: '1rem',
                    formatter: (cell, row)=>this.bodyCheckboxHTML(row),
                    sort: false
                },
                {
                    id: 'nome_fundacao',
                    name: "Nome da Funda\xe7\xe3o",
                    width: '300px',
                    formatter: (cell, row)=>this.formatarNome(cell, row)
                },
                {
                    id: 'meses_sem_reuniao',
                    name: 'Meses sem Atendimento',
                    width: '180px',
                    formatter: (cell)=>this.formatarMesesSemReuniao(cell),
                    sort: {
                        compare: (a, b)=>{
                            if (a > b) return 1;
                            else if (a < b) return -1;
                            else return 0;
                        }
                    }
                }
            ];
        }
    },
    watch: {
        query: {
            handler () {
                this.atualizarTabela();
            },
            deep: true
        },
        limparCheckboxesExterno () {
            this.limparCheckboxes();
        }
    },
    methods: {
        iniciarTabela () {
            const optionsPaginacao = {
                pagination: {
                    enabled: true,
                    limit: 30,
                    summary: true,
                    server: {
                        url: (urlApi, page, limit)=>{
                            return `${urlApi}&page=${++page}&per_page=${limit}`;
                        }
                    }
                },
                search: {
                    server: {
                        url: (prev, keyword)=>`${prev}&search=${encodeURIComponent(keyword)}`
                    }
                },
                sort: true
            };
            this._gridThenCallback = (response)=>{
                const fundacoes = response?.meses_clientes_sem_reuniao || [];
                this.atendimentos = fundacoes;
                return this.formatarDadosTabela(fundacoes);
            };
            this._gridTotalCallback = (response)=>{
                return response?.pagination?.total_items || 0;
            };
            this.tabelaAtendimento = this.iniciarTabelaGenerica(this.columns, this.urlCompleta, this._gridThenCallback, this._gridTotalCallback, optionsPaginacao);
            this.tabelaAtendimento.render(document.querySelector('#tabela_atendimento_simplificada'));
            this.tabelaAtendimento.on('ready', ()=>{
                this.configurarEventosCheckbox();
            });
        },
        atualizarTabela () {
            if (!this.tabelaAtendimento) return;
            this.resetarController();
            this.tabelaAtendimento.updateConfig({
                server: {
                    url: this.urlCompleta,
                    then: this._gridThenCallback,
                    total: this._gridTotalCallback
                }
            }).forceRender();
        },
        formatarDadosTabela (fundacoes) {
            return fundacoes.map((fundacao)=>{
                return [
                    fundacao.id_fundacao,
                    null,
                    fundacao.nome_fundacao,
                    fundacao.meses_sem_reuniao
                ];
            });
        },
        headerCheckboxHTML () {
            return (0, $26SB8.html)(html`
				<label data-type="header-fundacao-checkbox" class="fundacao-checkbox">
					<input type="checkbox" />
					<span class="checkmark"></span>
				</label>
			`);
        },
        bodyCheckboxHTML (row) {
            const idFundacao = row._cells[0]?.data;
            const isChecked = this.clientesSelecionadosInternos.has(idFundacao);
            return (0, $26SB8.html)(html`
				<label data-type="body-fundacao-checkbox" class="fundacao-checkbox">
					<input
						type="checkbox"
						value="${idFundacao}"
						${isChecked ? 'checked' : ''} />
					<span class="checkmark"></span>
				</label>
			`);
        },
        formatarNome (cell, row) {
            const idFundacao = row._cells[0]?.data;
            const fundacao = this.atendimentos.find((item)=>item.id_fundacao === idFundacao);
            const politica = fundacao?.politica;
            const nomeCompleto = fundacao?.nome_completo_fundacao || cell;
            return (0, $26SB8.html)(html`
				<div
					class="inline-flex items-center gap-8"
					data-tippy-content="${nomeCompleto}">
					<svg
						class="h-40 w-40 shrink-0"
						style="${GLOBAL.generateAvatarColor(politica)}">
						<use xlink:href="#icon_person"></use>
					</svg>
					<span class="one-line">${cell}</span>
				</div>
			`);
        },
        formatarMesesSemReuniao (meses) {
            if (!meses && meses !== 0) return '-';
            const cor = meses >= 10 ? '#ec3539' : meses >= 7 ? '#ec3539' : meses >= 4 ? '#ffc107' : '#18b25d';
            return (0, $26SB8.html)(html`
				<div style="color: ${cor}; font-weight: 500;">
					${meses} ${meses === 1 ? "m\xeas" : 'meses'}
				</div>
			`);
        },
        configurarEventosCheckbox () {
            let tentativa = 1;
            const maxTentativas = 5;
            const intervalo = setInterval(()=>{
                const checkboxes = document.querySelectorAll('label[data-type="body-fundacao-checkbox"] span.checkmark');
                if (checkboxes.length > 0) {
                    this.adicionarEventosCheckbox();
                    clearInterval(intervalo);
                } else if (tentativa >= maxTentativas) clearInterval(intervalo);
                else tentativa++;
            }, 500);
        },
        adicionarEventosCheckbox () {
            // Inicializar controller se não existir
            if (!this.controllerCheckbox) this.controllerCheckbox = new AbortController();
            const checkboxHeader = document.querySelector('label[data-type="header-fundacao-checkbox"]');
            const checkboxesBody = document.querySelectorAll('label[data-type="body-fundacao-checkbox"]');
            checkboxesBody.forEach((labelCheckbox)=>{
                labelCheckbox.addEventListener('click', ()=>{
                    setTimeout(()=>{
                        const input = labelCheckbox.querySelector('input[type="checkbox"]');
                        const inputHeader = checkboxHeader.querySelector('input[type="checkbox"]');
                        const todosChecked = document.querySelectorAll('label[data-type="body-fundacao-checkbox"] input[type="checkbox"]:checked');
                        if (input.checked) {
                            this.clientesSelecionadosInternos.add(input.value);
                            this.$emit('click-checked-cliente', input.value);
                        } else {
                            this.clientesSelecionadosInternos.delete(input.value);
                            this.$emit('click-unchecked-cliente', input.value);
                        }
                        // Atualizar estado do header
                        const checkboxesBodyAll = document.querySelectorAll('label[data-type="body-fundacao-checkbox"] input[type="checkbox"]');
                        if (!$88fe146a1ee7e16d$var$isActivateCheckboxHeader && todosChecked.length >= 1) {
                            inputHeader.indeterminate = true;
                            inputHeader.checked = false;
                            $88fe146a1ee7e16d$var$isActivateCheckboxHeader = true;
                        } else if (todosChecked.length === checkboxesBodyAll.length && checkboxesBodyAll.length > 0) {
                            inputHeader.indeterminate = false;
                            inputHeader.checked = true;
                            $88fe146a1ee7e16d$var$isActivateCheckboxHeader = true;
                        } else if (todosChecked.length === 0) {
                            inputHeader.indeterminate = false;
                            inputHeader.checked = false;
                            $88fe146a1ee7e16d$var$isActivateCheckboxHeader = false;
                        }
                    }, 0);
                }, {
                    signal: this.controllerCheckbox.signal
                });
            });
            // Evento do header para selecionar/desmarcar todos
            checkboxHeader?.addEventListener('click', ()=>{
                setTimeout(()=>{
                    const inputHeader = checkboxHeader.querySelector('input[type="checkbox"]');
                    const checkboxesBodyAll = document.querySelectorAll('label[data-type="body-fundacao-checkbox"] input[type="checkbox"]');
                    // Se estava indeterminado ou desmarcado, marcar todos
                    if (inputHeader.indeterminate || !inputHeader.checked) {
                        inputHeader.indeterminate = false;
                        inputHeader.checked = true;
                        $88fe146a1ee7e16d$var$isActivateCheckboxHeader = true;
                        checkboxesBodyAll.forEach((checkbox)=>{
                            if (!checkbox.checked) {
                                checkbox.checked = true;
                                this.clientesSelecionadosInternos.add(checkbox.value);
                                this.$emit('click-checked-cliente', checkbox.value);
                            }
                        });
                    } else {
                        // Se estava marcado, desmarcar todos
                        this.limparCheckboxes();
                        this.$emit('clear-clientes');
                    }
                }, 0);
            }, {
                signal: this.controllerCheckbox.signal
            });
        },
        limparCheckboxes () {
            const checkboxHeader = document.querySelector('label[data-type="header-fundacao-checkbox"] input[type="checkbox"]');
            const checkboxesChecked = document.querySelectorAll('label[data-type="body-fundacao-checkbox"] input[type="checkbox"]:checked');
            checkboxesChecked.forEach((checkbox)=>{
                checkbox.checked = false;
                this.clientesSelecionadosInternos.delete(checkbox.value);
            });
            if (checkboxHeader) {
                checkboxHeader.indeterminate = false;
                checkboxHeader.checked = false;
            }
            $88fe146a1ee7e16d$var$isActivateCheckboxHeader = false;
        },
        resetarController () {
            if (this.controllerCheckbox) this.controllerCheckbox.abort();
            this.controllerCheckbox = new AbortController();
        }
    },
    mounted () {
        this.iniciarTabela();
        setTimeout(()=>{
            tippy('[data-tippy-content]', {
                allowHTML: true,
                placement: 'top',
                boundary: 'HTMLElement'
            });
        }, 1000);
    },
    beforeUnmount () {
        if (this.controllerCheckbox) this.controllerCheckbox.abort();
    },
    template: html`
		<div
			class="w-full !max-h-[44rem] overflow-y-auto overflow-x-scroll flex-1 table-wrapper">
			<table
				id="tabela_atendimento_simplificada"
				class="!flex"
				js-table-ordenation></table>
		</div>
	`
};

});

parcelRegister("9mPML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d1e56aceae252b7$export$2e2bcd8739ae039; });
var $6d1e56aceae252b7$export$2e2bcd8739ae039 = {
    template: `
        <q-spinner
        color="primary"
        size="4rem"/>

    `
};

});


parcelRegister("1IXAI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $141820195f8b5384$export$2e2bcd8739ae039; });

var $bSQYW = parcelRequire("bSQYW");

var $amUiM = parcelRequire("amUiM");

var $4XAWe = parcelRequire("4XAWe");

var $1kBYF = parcelRequire("1kBYF");

var $fM5UL = parcelRequire("fM5UL");

var $5Bb8e = parcelRequire("5Bb8e");

var $1RCBx = parcelRequire("1RCBx");

var $7UMv2 = parcelRequire("7UMv2");
const { getTopBottomSai: $141820195f8b5384$var$getTopBottomSai, getTopBottomSap: $141820195f8b5384$var$getTopBottomSap, getRelatorioPoliticaAgendamento: $141820195f8b5384$var$getRelatorioPoliticaAgendamento } = (0, $7UMv2.default)();
const { getChoicesActive: $141820195f8b5384$var$getChoicesActive, FMoneyK: $141820195f8b5384$var$FMoneyK, formatReal2: $141820195f8b5384$var$formatReal2 } = GLOBAL;
const $141820195f8b5384$var$totaisPorBarraFundacaoTotal = [];
const $141820195f8b5384$var$DEFAULT_MAX_MIN = 5;
const $141820195f8b5384$var$politicaOpcoes = {
    0: 'ULTRA HIGH',
    1: 'PRIVATE',
    2: 'PREMIUM',
    3: "DISTRIBUI\xc7\xc3O"
};
const $141820195f8b5384$var$politicaOpcoesCores = {
    0: '#840505',
    1: '#d83232',
    2: '#e84f68b3',
    3: '#6d6f71'
};
const $141820195f8b5384$var$dataGastosVazio = [
    {
        name: 'ULTRA HIGH',
        color: '#840505',
        data: []
    },
    {
        name: 'PRIVATE',
        color: '#d83232',
        data: []
    },
    {
        name: 'PREMIUM',
        color: '#e84f68b3',
        data: []
    },
    {
        name: "DISTRIBUI\xc7\xc3O",
        color: '#6d6f71',
        data: []
    }
];
const $141820195f8b5384$var$colorTypeOptiosnCaptcaoBar = [
    '#003769',
    '#C11F39',
    '#6d6f71'
];
const $141820195f8b5384$var$colorTypeOptionsCaptacaoTotal = [
    '#003769',
    '#C11F39',
    ,
    '#6d6f71'
];
// const selectSemestres = GLOBAL.getChoicesActive('semestre', window.listOfChoices)
const $141820195f8b5384$var$URLS = {
    fundo_captacao_pf: '/api/clientepf/dados_totais/',
    fundo_captacao: '/clientes/captacao/',
    total_captacao: '/clientes/captacao_total/',
    total_captacao_sai: '/clientes/captacao_sai/',
    patrimonio_rentabilidade: '/clientes/gastos/'
};
var /* const optionsGestao = [
	{
		label: 'Sap',
		value: 'sap',
	},
	{
		label: 'Sai',
		value: 'sai',
	},
	{
		label: 'Ambos',
		value: 'ambos',
	},
] */ $141820195f8b5384$export$2e2bcd8739ae039 = {
    emits: [],
    components: {
        CardInfoCaptacao: $bSQYW.default,
        EmptyItem: $amUiM.default,
        GraficoFundacoesSaiRanking: $4XAWe.default,
        GraficoFundacoesSapRanking: $1kBYF.default,
        TablePoliticaAgendamento: $5Bb8e.default,
        GraficoMedidorAgendamento: $fM5UL.default
    },
    data () {
        return {
            optionsGestao: [
                {
                    label: 'Sap',
                    value: 'sap'
                },
                {
                    label: 'Sai',
                    value: 'sai'
                }
            ],
            filterFaixaMesesPatrimonio: 0,
            filterCaptacao: null,
            filterUsuario: null,
            filterMax: null,
            filterMin: null,
            filterPolitica: null,
            filterSemestreCaptacaoTotal: null,
            filterFaixaPatrimonio: null,
            filterRelatorioPoliticaAgendamento: {
                data_inicio: '',
                data_final: '',
                tipo_gestao: null,
                search: ''
            },
            chartCaptacao: null,
            chartGastos: null,
            chartCaptacaoBarra: null,
            chartCaptacaoTotal: null,
            dataCaptacao: null,
            dataCaptacaoBarra: null,
            dataCaptacaoTotal: {},
            dataCaptacaoTopBottomSap: [],
            dataCaptacaoTopBottomSai: [],
            dataRelatorioPoliticaAgendamento: [],
            labelCaptacaoBarra: [],
            dadosGeraisCaptacaoTotal: {
                patrimonio: 0,
                clientes: 0,
                captacao_ultimo_ano_geral: 0,
                captacao_ultimo_semestre_geral: 0
            },
            mediaRentabilidade: null,
            todosUsuarios: [],
            captacaoPatrimonioOptions: [
                {
                    label: '12 meses',
                    value: 12
                },
                {
                    label: '24 meses',
                    value: 24
                },
                {
                    label: '36 meses',
                    value: 36
                }
            ],
            dataGastos: [
                {
                    name: 'ULTRA HIGH',
                    color: '#840505',
                    data: []
                },
                {
                    name: 'PRIVATE',
                    color: '#d83232',
                    data: []
                },
                {
                    name: 'PREMIUM',
                    color: '#e84f68b3',
                    data: []
                },
                {
                    name: "DISTRIBUI\xc7\xc3O",
                    color: '#6d6f71',
                    data: []
                }
            ],
            optionsGastos: {
                chart: {
                    height: 400,
                    width: '100%',
                    type: 'scatter'
                },
                series: [],
                yaxis: {
                    type: 'numeric',
                    labels: {
                        formatter: function(value) {
                            return `${value.toFixed(2).replace('.', ',')}%`;
                        }
                    },
                    title: {
                        text: 'Rentabilidade (%)'
                    },
                    // forceNiceScale: true,
                    min: -50,
                    max: 50
                },
                xaxis: {
                    labels: {
                        formatter: function(value) {
                            const money = new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(value);
                            return money;
                        }
                    },
                    title: {
                        text: "Patrim\xf4nio (R$)"
                    },
                    min: 0,
                    max: 13000000,
                    tickAmount: 10
                },
                annotations: {
                    xaxis: [
                        {
                            x: 0,
                            borderColor: '#000',
                            strokeDashArray: 5,
                            label: {
                                text: '',
                                position: 'right',
                                orientation: 'horizontal'
                            }
                        }
                    ],
                    yaxis: [
                        {
                            y: 0,
                            borderColor: '#000',
                            strokeDashArray: 5,
                            label: {
                                text: '',
                                position: 'right'
                            }
                        },
                        {
                            y: 5,
                            borderColor: '#fdd426',
                            strokeDashArray: 5,
                            label: {
                                text: '',
                                textAnchor: 'start',
                                position: 'left'
                            }
                        }
                    ]
                },
                tooltip: {
                    custom: function({ seriesIndex: seriesIndex, dataPointIndex: dataPointIndex, w: w }) {
                        const point = w.config.series[seriesIndex]?.data[dataPointIndex];
                        // Validação de segurança
                        if (!point) return '<div class="apexcharts-custom-tooltip">Dados n\xe3o dispon\xedveis</div>';
                        // Função auxiliar para formatação de valores
                        const formatValue = (value, suffix = '%')=>{
                            if (value === null || value === undefined || isNaN(value)) return 'N/A';
                            return `${value.toFixed(2).replace('.', ',')}${suffix}`;
                        };
                        const formatCurrency = (value)=>{
                            if (value === null || value === undefined || isNaN(value)) return 'N/A';
                            return new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(value);
                        };
                        // Construção dos tipos de investimentos
                        const tiposInvestimentosHTML = point.tipos_investimentos && Array.isArray(point.tipos_investimentos) ? point.tipos_investimentos.filter((item)=>item.percentual && item.percentual > 0).map((item)=>`
                        <div>
                            <strong>${item.tipo_investimento}:</strong> 
                            <span>${formatValue(item.percentual)}</span>
                        </div>
                    `).join('') : '';
                        return `
                <div class="apexcharts-custom-tooltip" style="border-color: ${point.color || '#ccc'};">
                    <div class="tooltip-header">
                        <span class="dot" style="background: ${point.color || '#ccc'};"></span>
                        <strong>${point.label || 'Cliente'}</strong>
                    </div>
                    
                    <div class="tooltip-content">
                        <div class="tooltip-row">
                            <strong>Patrim\xf4nio:</strong> 
                            <span>${formatCurrency(point.x)}</span>
                        </div>
                        
                        <div class="tooltip-row">
                            <strong>Rentabilidade:</strong> 
                            <span>${formatValue(point.y)}</span>
                        </div>
                        
                        <div class="tooltip-divider"></div>
                        
                        <div class="tooltip-row">
                            <strong>Volatilidade 1M:</strong> 
                            <span>${formatValue(point.volatilidade_media_1M)}</span>
                        </div>
                        
                        <div class="tooltip-row">
                            <strong>Volatilidade 3M:</strong> 
                            <span>${formatValue(point.volatilidade_media_3M)}</span>
                        </div>
                        
                        <div class="tooltip-divider"></div>
                        
                        <div class="tooltip-row">
                            <strong>% CDI 12 meses:</strong> 
                            <span>${formatValue(point.rentabilidade_bm_12_meses)}</span>
                        </div>
                        
                        <div class="tooltip-row">
                            <strong>% CDI ano:</strong> 
                            <span>${formatValue(point.rentabilidade_bm_ano)}</span>
                        </div>
                        
                        ${tiposInvestimentosHTML ? `
                            <div class="tooltip-section">
                                ${tiposInvestimentosHTML}
                            </div>
                        ` : ''}
                    </div>
                </div>
            `;
                    }
                }
            },
            optionsCaptacao: {
                series: [],
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    }
                },
                colors: [
                    '#949799',
                    '#C11F39'
                ],
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'straight',
                    width: 2
                },
                markers: {
                    size: 4
                },
                title: {
                    text: undefined,
                    align: 'left'
                },
                grid: {
                    show: true,
                    borderColor: '#EDEEF0',
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    yaxis: {
                        lines: {
                            show: true
                        }
                    }
                },
                xaxis: {
                    labels: {
                        show: true,
                        maxHeight: 50,
                        styles: {
                            cssClass: 'apexcharts-xaxis-label'
                        },
                        formatter: function(value) {
                            // Exibe a label personalizada ou o valor padrão
                            return value ? captacaoXLabel[value] : value;
                        }
                    }
                },
                yaxis: {
                    labels: {
                        show: true,
                        styles: {
                            cssClass: 'apexcharts-yaxis-label'
                        },
                        formatter: function(value) {
                            const money = new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(value);
                            return money;
                        }
                    }
                },
                legend: {
                    fontFamily: 'Roboto Flex',
                    fontWeight: 500,
                    labels: {
                        colors: [
                            '#252526'
                        ],
                        useSeriesColors: false
                    },
                    markers: {
                        width: 20,
                        height: 4,
                        strokeColor: '#fff',
                        radius: 8
                    },
                    itemMargin: {
                        horizontal: 8,
                        vertical: 24
                    }
                },
                tooltip: {
                    custom: function({ seriesIndex: seriesIndex, dataPointIndex: dataPointIndex, w: w }) {
                        const point = w.config.series[seriesIndex].data[dataPointIndex];
                        const formatReal2 = (v, style = 'currency')=>new Intl.NumberFormat('pt-BR', {
                                style: style,
                                currency: 'BRL'
                            }).format(v);
                        const meta_acumulado = formatReal2(point.meta_acumulado);
                        const acumulado = formatReal2(point.acumulado);
                        const dinheiro_novo = formatReal2(point.dinheiro_novo);
                        const dinheiro_resgatado = formatReal2(point.dinheiro_resgatado);
                        const saldo_liquido = formatReal2(point.saldo_liquido);
                        return `
							<div class="apexcharts-custom-tooltip">
								<div>
									<span class="dot" style="background: #949799;"></span>
									<strong>Previsto Acumulado: </strong>
									<span> ${meta_acumulado}</span>
								</div>
								<div>
									<span class="dot" style="background: #C11F39;"></span>
									<strong>Real Acumulado: </strong>
									<span> ${acumulado}</span>
								</div>
								<div><strong>Dinheiro Novo: </strong> <span> ${dinheiro_novo}</span></div>
								<div><strong>Resgate: </strong> <span> ${dinheiro_resgatado}</span></div>
								<div><strong>Saldo Liquido: </strong> <span> ${saldo_liquido}</span></div>
							</div>
						`;
                    }
                }
            },
            optionsCaptacaoBarra: {
                ...(0, $1RCBx.SEMESTRAL_CHART_DEFAULT_OPTIONS),
                series: [],
                chart: {
                    type: 'bar',
                    height: 490,
                    stacked: true
                },
                title: {
                    text: 'PLE Unificado'
                },
                legend: {
                    fontFamily: 'Roboto Flex',
                    fontWeight: 500,
                    labels: {
                        colors: [
                            '#252526'
                        ],
                        useSeriesColors: false
                    },
                    markers: {
                        width: 20,
                        height: 4,
                        strokeColor: '#fff',
                        radius: 8
                    },
                    itemMargin: {
                        horizontal: 8,
                        vertical: 24
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 6,
                        borderRadiusApplication: 'end',
                        borderRadiusWhenStacked: 'last',
                        barHeight: '100%',
                        dataLabels: {
                            position: 'top',
                            total: {
                                enabled: true,
                                style: {
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#373D3F'
                                },
                                formatter: function(val, opts) {
                                    return GLOBAL.FMoneyK(val);
                                },
                                offsetY: -20
                            }
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                /* 				plotOptions: {
					bar: { dataLabels: { total: { enabled: true } } },
				}, */ stroke: {
                    width: 1,
                    colors: [
                        '#fff'
                    ]
                },
                fill: {
                    opacity: 1
                },
                colors: $141820195f8b5384$var$colorTypeOptiosnCaptcaoBar,
                yaxis: {
                    labels: {
                        formatter: (val)=>{
                            return GLOBAL.FMoneyK(val);
                        }
                    }
                },
                tooltip: {
                    shared: false,
                    intersect: true,
                    custom: function({ seriesIndex: seriesIndex, dataPointIndex: dataPointIndex, w: w }) {
                        const series = w.config.series;
                        const categories = w.config.xaxis.categories;
                        const ano = categories[dataPointIndex];
                        // Pegar apenas o valor da série específica onde o mouse está
                        const valorSerie = series[seriesIndex].data[dataPointIndex];
                        const nomeSerie = series[seriesIndex].name;
                        return `
            <div class="apexcharts-custom-tooltip">
                <div>
                    <strong>${nomeSerie}: </strong>
                    <span>${GLOBAL.formatReal2(valorSerie)}</span>
                </div>
            </div>
        `;
                    }
                }
            },
            optionsFundacaoTotal: {
                series: [],
                chart: {
                    height: 350,
                    type: 'bar',
                    stacked: true,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    }
                },
                tooltip: {
                    enabled: true,
                    shared: false,
                    intersect: true,
                    custom: function({ series: series, seriesIndex: seriesIndex, dataPointIndex: dataPointIndex, w: w }) {
                        if (w.config.series[seriesIndex]?.name === 'Total Fantasma') return '';
                        const valor = series[seriesIndex][dataPointIndex];
                        const nome = w.config.series[seriesIndex].name;
                        return `
      <div class="apexcharts-custom-tooltip">
        <strong>${nome}:</strong> <span>${GLOBAL.FMoneyK(valor)}</span>
      </div>
    `;
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 6,
                        columnWidth: '90%',
                        borderRadiusApplication: 'end',
                        borderRadiusWhenStacked: 'all',
                        dataLabels: {
                            hideOverflowingLabels: true,
                            total: {
                                enabled: true,
                                showAlways: true,
                                style: {
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#373D3F'
                                },
                                formatter: function(val, opts) {
                                    const idx = opts.dataPointIndex;
                                    // Usa o valor real guardado
                                    return GLOBAL.FMoneyK($141820195f8b5384$var$totaisPorBarraFundacaoTotal[idx] || 0);
                                },
                                offsetY: -20,
                                position: 'top'
                            }
                        }
                    }
                },
                colors: $141820195f8b5384$var$colorTypeOptionsCaptacaoTotal,
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'straight',
                    width: 2
                },
                markers: {
                    size: 4
                },
                title: {
                    text: "Relat\xf3rio unificado",
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: [
                            '#f3f3f3',
                            'transparent'
                        ],
                        opacity: 0.5
                    }
                },
                xaxis: {
                    labels: {
                        show: true,
                        maxHeight: 50,
                        styles: {
                            cssClass: 'apexcharts-xaxis-label'
                        },
                        formatter: function(value) {
                            return 'Sem ' + value;
                        }
                    }
                },
                yaxis: {
                    labels: {
                        show: true,
                        styles: {
                            cssClass: 'apexcharts-yaxis-label'
                        },
                        formatter: function(value) {
                            const money = new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(value);
                            return money;
                        }
                    }
                },
                legend: {
                    fontFamily: 'Roboto Flex',
                    fontWeight: 500,
                    labels: {
                        colors: [
                            '#252526'
                        ],
                        useSeriesColors: false
                    },
                    markers: {
                        width: 20,
                        height: 4,
                        strokeColor: '#fff',
                        radius: 8
                    },
                    itemMargin: {
                        horizontal: 8,
                        vertical: 24
                    },
                    formatter: function(seriesName, opts) {
                        if (seriesName === 'Total Fantasma') return '';
                        return seriesName;
                    }
                }
            }
        };
    },
    computed: {
        dataRelatorioPoliticaAgendamentoInicial () {
            return this.convertStringDateToISO(this.filterRelatorioPoliticaAgendamento.data_inicio);
        },
        dataRelatorioPoliticaAgendamentoFinal () {
            return this.convertStringDateToISO(this.filterRelatorioPoliticaAgendamento.data_final);
        },
        faixaMeses () {
            return [
                12,
                24,
                36
            ];
        },
        porcentagemAgendamentoRelatorioFormat () {
            return this.dataRelatorioPoliticaAgendamento?.percentual_geral / 100;
        },
        queryTabelaPoliticaAgendamento () {
            const { data_inicio: data_inicio, data_final: data_final, tipo_gestao: tipo_gestao } = this.filterRelatorioPoliticaAgendamento;
            const params = [];
            if (data_inicio) params.push(`data_inicial=${this.dataRelatorioPoliticaAgendamentoInicial}`);
            if (data_final) params.push(`data_final=${this.dataRelatorioPoliticaAgendamentoFinal}`);
            if (tipo_gestao) params.push(`tipo_gestao=${encodeURIComponent(tipo_gestao)}`);
            return params.join('&');
        }
    },
    watch: {
        filterRelatorioPoliticaAgendamento: {
            handler () {
                if (this.filterRelatorioPoliticaAgendamento) this.setRelatorioAgendamento();
            },
            deep: true
        }
    },
    methods: {
        initFilterRelatorioPoliticaAgendamentoDates () {
            const now = new Date();
            const year = now.getFullYear();
            const data_inicio = `01/01/${year}`;
            const data_final = `31/12/${year}`;
            this.filterRelatorioPoliticaAgendamento.data_inicio = data_inicio;
            this.filterRelatorioPoliticaAgendamento.data_final = data_final;
        },
        convertStringDateToISO (stringDate) {
            if (!stringDate) return '';
            const [day, month, year] = stringDate.split('/');
            return `${year}-${month}-${day}`;
        },
        formatReal2: (v, style = 'currency')=>new Intl.NumberFormat('pt-BR', {
                style: style,
                currency: 'BRL'
            }).format(v),
        maiorValorProximoRedondo (numero) {
            const magnitude = Math.pow(10, Math.floor(numero).toString().length - 1) / 10;
            return Math.ceil(numero / magnitude) * magnitude;
        },
        openFiltros () {
            modal_padrao_vue.openModal('filtro_rentabilidade');
        },
        async cancelFilter () {
            this.filterFaixaMesesPatrimonio = 0;
            this.filterPolitica = '';
            this.filterUsuario = '';
            this.filterMin = '';
            this.filterMax = '';
            modal_padrao_vue.closeModal('filtro_rentabilidade');
            const selectPoliticas = $141820195f8b5384$var$getChoicesActive('politica', window.listOfChoices);
            selectPoliticas.setChoiceByValue('');
            const selectUsuarios = $141820195f8b5384$var$getChoicesActive('usuarios_select', window.listOfChoices);
            selectUsuarios.setChoiceByValue('');
            const selectFaixaMeses = $141820195f8b5384$var$getChoicesActive('faixa_meses_patrimonio', window.listOfChoices);
            selectFaixaMeses.setChoiceByValue('');
            const max = document.querySelector('#max');
            const min = document.querySelector('#min');
            min.value = '';
            max.value = '';
            await this.iniciarTabelaGastos();
            this.setTabelaGastosValues();
        },
        setSelectFaixaMesesPatrimonio () {
            const selectFaixaMeses = $141820195f8b5384$var$getChoicesActive('faixa_meses_patrimonio', window.listOfChoices);
            selectFaixaMeses.setChoices([
                {
                    value: '',
                    label: 'Ano corrente'
                },
                ...this.captacaoPatrimonioOptions
            ]);
            selectFaixaMeses.setChoiceByValue('');
            this.filterFaixaMesesPatrimonio = 0;
        },
        async setFilterFaixaMesesPatrimonio (mes) {
            this.filterFaixaMesesPatrimonio = mes;
            const selectFaixaMeses = $141820195f8b5384$var$getChoicesActive('faixa_meses_patrimonio', window.listOfChoices);
            if (selectFaixaMeses) {
                // Sincroniza o select com o botão clicado
                const valorSelect = mes === 0 ? '' : mes.toString();
                selectFaixaMeses.setChoiceByValue(valorSelect);
            }
            await this.iniciarTabelaGastos();
            this.setTabelaGastosValues();
        },
        setSelectEvents () {
            document.querySelector('#semestre_select')?.addEventListener('change', ()=>{
                const selectSemestres = $141820195f8b5384$var$getChoicesActive('semestre_select', window.listOfChoices);
                this.filterCaptacao = selectSemestres.getValue().value;
                this.setTabelaCaptacaoValues();
            });
            document.querySelector('#usuarios_select')?.addEventListener('change', async ()=>{
                const selectUsuarios = $141820195f8b5384$var$getChoicesActive('usuarios_select', window.listOfChoices);
                this.filterUsuario = selectUsuarios.getValue().value;
            // await this.iniciarTabelaGastos()
            // this.updateTabelaGastosValues()
            });
            document.querySelector('#politica')?.addEventListener('change', async ()=>{
                const selectPoliticas = $141820195f8b5384$var$getChoicesActive('politica', window.listOfChoices);
                this.filterPolitica = selectPoliticas.getValue().value;
            // await this.iniciarTabelaGastos()
            // this.updateTabelaGastosValues()
            });
            document.querySelector('#semestre_captacao_select')?.addEventListener('change', async ()=>{
                const selectCaptacaoTotal = $141820195f8b5384$var$getChoicesActive('semestre_captacao_select', window.listOfChoices);
                this.filterSemestreCaptacaoTotal = selectCaptacaoTotal.getValue().value;
                this.setTabelaCaptacaoTotalValues();
            });
            document.querySelector('#faixa_meses_patrimonio')?.addEventListener('change', async (e)=>{
                const selectFaixaMeses = $141820195f8b5384$var$getChoicesActive('faixa_meses_patrimonio', window.listOfChoices);
                const valorSelect = selectFaixaMeses.getValue().value;
                this.filterFaixaMesesPatrimonio = valorSelect === '' ? 0 : parseInt(valorSelect);
            });
        },
        async submitFilters () {
            const selectFaixaMeses = $141820195f8b5384$var$getChoicesActive('faixa_meses_patrimonio', window.listOfChoices);
            const valorSelect = selectFaixaMeses.getValue().value;
            this.filterFaixaMesesPatrimonio = valorSelect === '' ? 0 : parseInt(valorSelect);
            // Pegar outros valores do modal
            const selectPoliticas = $141820195f8b5384$var$getChoicesActive('politica', window.listOfChoices);
            this.filterPolitica = selectPoliticas.getValue().value;
            const selectUsuarios = $141820195f8b5384$var$getChoicesActive('usuarios_select', window.listOfChoices);
            this.filterUsuario = selectUsuarios.getValue().value;
            const min = document.querySelector('#min').value;
            const max = document.querySelector('#max').value;
            this.filterMin = min;
            this.filterMax = max;
            // Fechar modal
            modal_padrao_vue.closeModal('filtro_rentabilidade');
            // Atualizar gráfico
            await this.iniciarTabelaGastos();
            this.setTabelaGastosValues();
        },
        async iniciarTabelas () {
            await this.iniciarTabelaCaptacao();
            await this.iniciarTabelaGastos();
            await this.iniciarTabelaCaptacaoTotalBarra();
            await this.iniciaTabelaCaptacaoTotal();
            this.setTabelasValues();
        },
        setSelectSemestres () {
            const selectSemestres = $141820195f8b5384$var$getChoicesActive('semestre_select', window.listOfChoices);
            if (this.dataCaptacao) {
                const semestresKey = Object.keys(this.dataCaptacao);
                const options = semestresKey.map((f)=>{
                    return {
                        value: f,
                        label: f
                    };
                });
                selectSemestres.setChoices([
                    ...options
                ]);
                selectSemestres.setChoiceByValue(semestresKey[0]);
                this.filterCaptacao = semestresKey[0];
            } else {
                selectSemestres.setChoices([
                    {
                        value: '',
                        label: "N\xe3o h\xe1 dados dispon\xedveis"
                    }
                ]);
                selectSemestres.setChoiceByValue('');
                this.filterCaptacao = '';
            }
        },
        setSelectUsuarios () {
            if (this.todosUsuarios.length === 0) return;
            const selectUsuarios = $141820195f8b5384$var$getChoicesActive('usuarios_select', window.listOfChoices);
            const options = this.todosUsuarios.map((v)=>{
                return {
                    value: v.id,
                    label: v.name && v.name.trim().length > 0 ? v.name : v.username
                };
            });
            selectUsuarios.setChoices([
                {
                    value: '',
                    label: "Selecione um usu\xe1rio"
                },
                ...options
            ]);
            selectUsuarios.setChoiceByValue('');
            this.filterUsuario = '';
        },
        setSelectPoliticas () {
            const opcoes = Object.entries($141820195f8b5384$var$politicaOpcoes).map(([value, label])=>({
                    value: value,
                    label: label
                }));
            if (opcoes.length === 0) return;
            const selectPoliticas = $141820195f8b5384$var$getChoicesActive('politica', window.listOfChoices);
            selectPoliticas.setChoices([
                {
                    value: '',
                    label: 'Selecione uma politica'
                },
                ...opcoes
            ]);
            selectPoliticas.setChoiceByValue('');
            this.filterPolitica = '';
        },
        setSelectSemestreCaptacao () {
            const semestres = Object.keys(this.dataCaptacaoTotal.totalCaptacao).map((itemFundoCaptacao)=>({
                    label: itemFundoCaptacao,
                    value: itemFundoCaptacao
                }));
            const semestreCaptacao = $141820195f8b5384$var$getChoicesActive('semestre_captacao_select', window.listOfChoices);
            semestreCaptacao.setChoices([
                ...semestres
            ]);
            semestreCaptacao.setChoiceByValue(semestres[0].value);
            this.filterSemestreCaptacaoTotal = semestres[0].value;
        },
        async iniciarTabelaCaptacaoTotalBarra () {
            const { data: data } = await axios.get(`${window.origin}${$141820195f8b5384$var$URLS.fundo_captacao_pf}`);
            const labelCaptacaoPf = 'Cliente PF';
            const labelCaptacaoPj = "Funda\xe7\xe3o";
            const labelCaptacaoSequoia = 'Sequoia';
            const periodoCaptacaoAnual = {};
            const auxPeriodosCaptacao = [];
            this.dadosGeraisCaptacaoTotal.patrimonio = $141820195f8b5384$var$formatReal2(data.dados_gerais.patrimonio);
            this.dadosGeraisCaptacaoTotal.clientes = data.dados_gerais.clientes;
            this.dadosGeraisCaptacaoTotal.captacao_ultimo_ano_geral = $141820195f8b5384$var$formatReal2(data.dados_gerais.captacao_ultimo_ano_geral);
            this.dadosGeraisCaptacaoTotal.captacao_ultimo_semestre_geral = $141820195f8b5384$var$formatReal2(data.dados_gerais.captacao_ultimo_semestre_geral);
            data.dados_individuais.PJ.captacao_patrimonio_anual.forEach((itemCaptacaoPatrimonio)=>{
                if (!periodoCaptacaoAnual[labelCaptacaoPj]) periodoCaptacaoAnual[labelCaptacaoPj] = [];
                periodoCaptacaoAnual[labelCaptacaoPj].push(itemCaptacaoPatrimonio.value);
                if (!auxPeriodosCaptacao.includes(itemCaptacaoPatrimonio.name)) auxPeriodosCaptacao.push(itemCaptacaoPatrimonio.name);
            });
            data.dados_individuais.PF.captacao_patrimonio_anual.forEach((itemCaptacaoPatrimonio)=>{
                if (!periodoCaptacaoAnual[labelCaptacaoPf]) periodoCaptacaoAnual[labelCaptacaoPf] = [];
                periodoCaptacaoAnual[labelCaptacaoPf].push(itemCaptacaoPatrimonio.total);
            /* if (!auxPeriodosCaptacao.includes(itemCaptacaoPatrimonio.ano)) {
						auxPeriodosCaptacao.push(itemCaptacaoPatrimonio.ano)
					} */ });
            data.dados_individuais.sequoia.captacao_patrimonio_anual.forEach((itemCaptacaoPatrimonio)=>{
                if (!periodoCaptacaoAnual[labelCaptacaoSequoia]) periodoCaptacaoAnual[labelCaptacaoSequoia] = [];
                periodoCaptacaoAnual[labelCaptacaoSequoia].push(itemCaptacaoPatrimonio.total);
            /* if (!auxPeriodosCaptacao.includes(itemCaptacaoPatrimonio.ano)) {
						auxPeriodosCaptacao.push(itemCaptacaoPatrimonio.ano)
					} */ });
            this.dataCaptacaoBarra = Object.entries(periodoCaptacaoAnual).map(([periodo, valor])=>{
                return {
                    name: periodo,
                    data: valor.reverse()
                };
            });
            this.labelCaptacaoBarra = auxPeriodosCaptacao.reverse();
        /* console.log(this.dataCaptacaoBarra) */ },
        async iniciaTabelaCaptacaoTotal () {
            const { data: fundoCaptacao } = await axios.get(`${window.origin}${$141820195f8b5384$var$URLS.fundo_captacao}`);
            const { data: totalCaptacao } = await axios.get(`${window.origin}${$141820195f8b5384$var$URLS.total_captacao}`);
            const { data: totalCaptacaoSai } = await axios.get(`${window.origin}${$141820195f8b5384$var$URLS.total_captacao_sai}`);
            this.dataCaptacaoTotal.fundoCaptacao = fundoCaptacao;
            this.dataCaptacaoTotal.totalCaptacao = totalCaptacao;
            this.dataCaptacaoTotal.totalCaptacaoSai = totalCaptacaoSai;
            this.setSelectSemestreCaptacao();
        },
        async iniciarTabelaCaptacao () {
            const { data: data } = await axios.get(`${window.origin}/clientes/captacao/`);
            this.dataCaptacao = Object.keys(data).length === 0 ? null : data;
            // this.dataCaptacao = null
            this.setSelectSemestres();
        },
        async iniciarTabelaGastos () {
            let filter = '?q=';
            filter += !this.filterUsuario ? '' : `&user=${this.filterUsuario}`;
            filter += !this.filterPolitica ? '' : `&politica=${this.filterPolitica}`;
            filter += !this.filterMin ? '' : `&min=${this.filterMin}`;
            filter += !this.filterMax ? '' : `&max=${this.filterMax}`;
            const mesesMap = {
                12: 'mes_12',
                24: 'mes_24',
                36: 'mes_36'
            };
            if (this.filterFaixaMesesPatrimonio && this.filterFaixaMesesPatrimonio !== 0) filter += `&${mesesMap[this.filterFaixaMesesPatrimonio]}=true`;
            const { data: data } = await axios.get(`${window.origin}${$141820195f8b5384$var$URLS.patrimonio_rentabilidade}${filter}`);
            this.todosUsuarios = data.todos_users || [];
            // this.setSelectUsuarios()
            this.dataGastos.forEach((v, index)=>{
                this.dataGastos[index].data = [];
            });
            if (!data.results || data.results.length === 0) {
                this.optionsGastos.xaxis.min = 0;
                this.optionsGastos.xaxis.max = 13000000;
                this.optionsGastos.yaxis.min = -50;
                this.optionsGastos.yaxis.max = 50;
                this.optionsGastos.annotations.xaxis[0].x = 0;
                this.optionsGastos.annotations.xaxis[0].label.text = '';
                this.optionsGastos.annotations.yaxis[0].y = 0;
                this.optionsGastos.annotations.yaxis[0].label.text = '';
                this.optionsGastos.annotations.yaxis[1].y = 5;
                this.optionsGastos.annotations.yaxis[1].label.text = '';
                return;
            }
            const maior_valor = data.results.map((v)=>v.patrimonio_interno).reduce((max, atual)=>Math.max(max, atual), -Infinity);
            this.optionsGastos.xaxis.max = this.maiorValorProximoRedondo(maior_valor);
            if (this.optionsGastos.yaxis.length) {
                this.optionsGastos.yaxis[0].min = parseFloat(data.menor_rentabilidade_12_meses_y) - $141820195f8b5384$var$DEFAULT_MAX_MIN;
                this.optionsGastos.yaxis[0].max = parseFloat(data.maior_rentabilidade_12_meses_y) + $141820195f8b5384$var$DEFAULT_MAX_MIN;
            } else {
                this.optionsGastos.yaxis.min = parseFloat(data.menor_rentabilidade_12_meses_y) - $141820195f8b5384$var$DEFAULT_MAX_MIN;
                this.optionsGastos.yaxis.max = parseFloat(data.maior_rentabilidade_12_meses_y) + $141820195f8b5384$var$DEFAULT_MAX_MIN;
            }
            this.optionsGastos.annotations.yaxis[0].y = data.media_rentabilidade_12_meses;
            this.optionsGastos.annotations.yaxis[0].label.text = `Mediana: ${data.media_rentabilidade_12_meses.toFixed(2).replace('.', ',')}%`;
            this.optionsGastos.annotations.xaxis[0].x = data.media_patrimonio_interno;
            this.optionsGastos.annotations.xaxis[0].label.text = `M\xe9dia: ${this.formatReal2(data.media_patrimonio_interno)}`;
            this.optionsGastos.annotations.yaxis[1].y = data.cdi_12_meses;
            this.optionsGastos.annotations.yaxis[1].label.text = `CDI: ${data.cdi_12_meses.toFixed(2).replace('.', ',')}%`;
            data.results.forEach((v, index)=>{
                const politicaKey = Number(v.politica);
                const serie = this.dataGastos.find((w)=>w.name === $141820195f8b5384$var$politicaOpcoes[politicaKey]);
                if (serie) serie.data.push({
                    x: Number(v.patrimonio_interno),
                    y: Number(v.rentabilidade_12_meses) || Number(v.rentabilidade_ano),
                    label: v.nome,
                    color: $141820195f8b5384$var$politicaOpcoesCores[politicaKey],
                    volatilidade_media_1M: Number(v.medias.volatilidade_media_1M) || 0,
                    volatilidade_media_3M: Number(v.medias.volatilidade_media_3M) || 0,
                    rentabilidade_bm_12_meses: Number(v.bm_cdi[0].rentabilidade_bm_12_meses),
                    rentabilidade_bm_ano: Number(v.bm_cdi[0].rentabilidade_bm_ano),
                    tipos_investimentos: v.investimentos.tipos_investimento
                });
            });
        },
        setTabelaCaptacaoValues () {
            if (this.chartCaptacao) this.chartCaptacao.destroy();
            const metaAcumulado = !this.dataCaptacao ? [] : this.dataCaptacao[this.filterCaptacao].map((v, index)=>{
                return {
                    x: index + 1,
                    y: Number(v.meta_acumulado),
                    label: `Sem ${v.semana}`,
                    dinheiro_novo: Number(v.dinheiro_novo),
                    dinheiro_resgatado: Number(v.dinheiro_resgatado),
                    saldo_liquido: Number(v.saldo_liquido),
                    meta_acumulado: Number(v.meta_acumulado),
                    acumulado: Number(v.acumulado)
                };
            });
            const acumulado = !this.dataCaptacao ? [] : this.dataCaptacao[this.filterCaptacao].map((v, index)=>{
                return {
                    x: index + 1,
                    y: Number(v.acumulado),
                    label: `Sem ${v.semana}`,
                    dinheiro_novo: Number(v.dinheiro_novo),
                    dinheiro_resgatado: Number(v.dinheiro_resgatado),
                    saldo_liquido: Number(v.saldo_liquido),
                    meta_acumulado: Number(v.meta_acumulado),
                    acumulado: Number(v.acumulado)
                };
            });
            captacaoXLabel = Object.fromEntries(metaAcumulado.map((point)=>[
                    point.x,
                    point.label
                ]));
            const seriesSemestre = [
                {
                    name: 'Meta',
                    data: metaAcumulado
                },
                {
                    name: 'Realizado',
                    data: acumulado
                }
            ];
            this.optionsCaptacao.series = seriesSemestre;
            this.chartCaptacao = new ApexCharts(document.querySelector('#chart_captacao'), this.optionsCaptacao);
            this.chartCaptacao.render();
        },
        setTabelaGastosValues () {
            if (this.chartGastos) this.chartGastos.destroy();
            this.optionsGastos.series = this.dataGastos;
            const el = document.querySelector('#chart_gastos');
            if (!el) {
                console.error("Elemento #chart_gastos n\xe3o encontrado!");
                return;
            }
            this.chartGastos = new ApexCharts(document.querySelector('#chart_gastos'), this.optionsGastos);
            this.chartGastos.render();
        },
        setTabelaCaptacaoBarValues () {
            if (this.chartCaptacaoBarra) this.chartCaptacaoBarra.destroy();
            // Calcula o valor máximo de todas as séries
            const calcularValorMaximo = ()=>{
                let maxValue = 0;
                this.dataCaptacaoBarra.forEach((serie)=>{
                    serie.data.forEach((valor, index)=>{
                        // Soma todos os valores do mesmo índice (barras empilhadas)
                        const somaEmpilhada = this.dataCaptacaoBarra.reduce((total, s)=>{
                            return total + (s.data[index] || 0);
                        }, 0);
                        if (somaEmpilhada > maxValue) maxValue = somaEmpilhada;
                    });
                });
                return maxValue;
            };
            const valorMaximo = calcularValorMaximo();
            const margemSuperior = valorMaximo;
            this.optionsCaptacaoBarra.series = this.dataCaptacaoBarra;
            this.optionsCaptacaoBarra.xaxis.categories = this.labelCaptacaoBarra;
            this.optionsCaptacaoBarra.yaxis.max = margemSuperior;
            this.optionsCaptacaoBarra.yaxis.min = 0;
            this.chartCaptacaoBarra = new ApexCharts(document.querySelector('#chart_captacao_barra'), this.optionsCaptacaoBarra);
            this.chartCaptacaoBarra.render();
        },
        setTabelaCaptacaoTotalValues () {
            if (this.chartCaptacaoTotal) this.chartCaptacaoTotal.destroy();
            const captacaoFundoMeta = {
                name: "Capta\xe7\xe3o SAP",
                data: this.dataCaptacaoTotal.fundoCaptacao[this.filterSemestreCaptacaoTotal].map((itemFundoCaptacao)=>{
                    return parseFloat(itemFundoCaptacao.acumulado);
                })
            };
            const captacaoTotalMeta = {
                name: "Capta\xe7\xe3o SAI",
                data: this.dataCaptacaoTotal.totalCaptacaoSai[this.filterSemestreCaptacaoTotal].map((itemTotalCaptacao)=>{
                    return parseFloat(itemTotalCaptacao.total_captacao);
                })
            };
            const captacaoTotalSaiMeta = {
                name: "Capta\xe7\xe3o TOTAL",
                data: this.dataCaptacaoTotal.totalCaptacao[this.filterSemestreCaptacaoTotal].map((itemTotalCaptacaoSai)=>{
                    return parseFloat(itemTotalCaptacaoSai.total_captacao);
                })
            };
            const seriesOriginais = [
                captacaoTotalMeta,
                captacaoFundoMeta
            ];
            const tamanho = Math.max(captacaoTotalMeta.data.length, captacaoFundoMeta.data.length);
            const serieFantasma = {
                name: 'Total Fantasma',
                data: [],
                color: 'transparent',
                tooltip: {
                    enabled: false
                },
                showInLegend: false,
                legendIcon: 'none',
                legend: {
                    show: false
                },
                events: {}
            };
            for(let i = 0; i < tamanho; i++){
                const valores = seriesOriginais.map((serie)=>serie.data[i] || 0);
                const valoresPositivos = valores.filter((v)=>v > 0);
                const valoresAbsolutos = valores.map((v)=>Math.abs(v));
                const maiorAbsoluto = valoresAbsolutos.length ? Math.max(...valoresAbsolutos) : 0;
                const totalReal = valores.reduce((acc, v)=>acc + v, 0);
                const valorFantasma = 2;
                $141820195f8b5384$var$totaisPorBarraFundacaoTotal[i] = totalReal;
                serieFantasma.data.push(valorFantasma);
            }
            if (captacaoTotalMeta.data.length !== captacaoFundoMeta.data.length) {
                const maxLenght = Math.max(captacaoTotalMeta.data.length, captacaoFundoMeta.data.length);
                for(let i = 0; i < maxLenght; i++){
                    if (!captacaoTotalMeta.data[i]) captacaoTotalMeta.data[i] = null;
                    if (!captacaoFundoMeta.data[i]) captacaoFundoMeta.data[i] = null;
                }
            }
            this.optionsFundacaoTotal.series = [
                captacaoTotalMeta,
                captacaoFundoMeta,
                serieFantasma
            ];
            this.optionsFundacaoTotal.xaxis.categories = this.dataCaptacaoTotal.fundoCaptacao[this.filterSemestreCaptacaoTotal].map((itemFundoCaptacao)=>itemFundoCaptacao.semana);
            this.chartCaptacaoTotal = new ApexCharts(document.querySelector('#chart_fundacao_total'), this.optionsFundacaoTotal);
            this.chartCaptacaoTotal.render();
        },
        updateTabelaGastosValues () {
            this.chartGastos.updateOptions(this.optionsGastos);
            this.chartGastos.updateSeries(this.dataGastos);
        },
        setTabelasValues () {
            this.setTabelaCaptacaoValues();
            this.setTabelaGastosValues();
            this.setTabelaCaptacaoBarValues();
            this.setTabelaCaptacaoTotalValues();
        },
        async setDataCaptacaoTopBottomSap () {
            this.dataCaptacaoTopBottomSap = await $141820195f8b5384$var$getTopBottomSap();
        },
        async setDataCaptacaoTopBottomSai () {
            this.dataCaptacaoTopBottomSai = await $141820195f8b5384$var$getTopBottomSai();
        },
        async setRelatorioAgendamento () {
            let params = {};
            if (this.dataRelatorioPoliticaAgendamentoInicial) params.data_inicial = this.dataRelatorioPoliticaAgendamentoInicial;
            if (this.dataRelatorioPoliticaAgendamentoFinal) params.data_final = this.dataRelatorioPoliticaAgendamentoFinal;
            if (this.filterRelatorioPoliticaAgendamento.tipo_gestao) params.tipo_gestao = this.filterRelatorioPoliticaAgendamento.tipo_gestao;
            const responseRelatorioAgendamento = await $141820195f8b5384$var$getRelatorioPoliticaAgendamento(params);
            this.dataRelatorioPoliticaAgendamento = responseRelatorioAgendamento?.dados_gerais || 0.0;
        },
        formatDataPeriodoAgendamento (data) {
            if (!data) return '';
            return data;
        }
    },
    mounted () {
        // GLOBAL.formatReal2
        setTimeout(async ()=>{
            await this.iniciarTabelas();
            this.setSelectUsuarios();
            this.setSelectPoliticas();
            this.setSelectEvents();
            this.setSelectFaixaMesesPatrimonio();
            this.initFilterRelatorioPoliticaAgendamentoDates();
            await this.setDataCaptacaoTopBottomSap();
            await this.setDataCaptacaoTopBottomSai();
            await this.setRelatorioAgendamento();
        }, 300);
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("bSQYW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a6dd5f8242f5d78$export$2e2bcd8739ae039; });
var $8a6dd5f8242f5d78$export$2e2bcd8739ae039 = {
    props: [
        'titulo',
        'info',
        'simbulo'
    ],
    template: `
		<div
			class="flex-1 max-w-[21.25rem] flex flex-col justify-center !h-[8rem] md2:flex-auto md2:max-w-full rounded-md p-16 border border-neutral-30 relative">
			<div class="flex items-start justify-between">
				<p class="text-xs font-medium tracking-widest text-neutral-70">
					{{titulo}}
				</p>

			</div>
			<p class="flex items-start gap-4 mt-10 text-2xl text-neutral-90">
				<span class="text-sm text-neutral-70">{{simbulo}}</span>
                {{info}}
			</p>

		</div>
	`
};

});

parcelRegister("4XAWe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c9533fe4ce9bfa$export$2e2bcd8739ae039; });
const $39c9533fe4ce9bfa$var$colorTypeOptionsRanking = [
    '#003769',
    '#003769',
    '#003769',
    '#003769',
    '#003769',
    '#003769',
    '#003769',
    '#003769',
    '#003769',
    '#003769'
];
var $39c9533fe4ce9bfa$export$2e2bcd8739ae039 = {
    name: 'GraficoFundacoesSaiRanking',
    props: {
        data: {
            type: Array,
            default: ()=>[]
        }
    },
    data () {},
    methods: {
        processCategories (data) {
            const dadosOrdenados = this.processDataValues(data);
            return dadosOrdenados.map((item)=>item.x);
        },
        processDataValues (data) {
            return data.map((item)=>{
                const valorCaptacao = typeof item.valor_captacao === 'string' ? Number(item.valor_captacao) : item.valor_captacao;
                return {
                    ...item,
                    y: valorCaptacao,
                    x: item.sigla || 'Desconhecido',
                    total: valorCaptacao,
                    fundacoes_vinculadas: item.fundos?.map((f)=>f.nome)
                };
            }).sort((a, b)=>a.y - b.y);
        }
    },
    watch: {
        data () {
            const novaSerie = this.processDataValues(this.data);
            const novasCategorias = this.processCategories(this.data);
            if (this.chartInstance) {
                this.chartInstance.updateOptions({
                    xaxis: {
                        categories: novasCategorias
                    }
                });
                this.chartInstance.updateSeries([
                    {
                        name: '',
                        data: novaSerie
                    }
                ]);
            }
        }
    },
    data () {
        return {
            chartInstance: null,
            optionsFundacoesRanking: {
                series: [
                    {
                        name: '',
                        data: this.processDataValues(this.data)
                    }
                ],
                chart: {
                    type: 'bar',
                    height: 350
                },
                title: {
                    text: 'Top/Bottom SAI (Ajustado)'
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '60%',
                        dataLabels: {
                            position: 'top',
                            maxItems: 100,
                            hideOverflowingLabels: false,
                            orientation: 'horizontal'
                        }
                    }
                },
                colors: $39c9533fe4ce9bfa$var$colorTypeOptionsRanking,
                dataLabels: {
                    enabled: true,
                    textAnchor: 'middle',
                    distributed: false,
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        fontWeight: 600,
                        colors: [
                            '#373D3F'
                        ]
                    },
                    formatter: function(val, opts) {
                        const dataPoint = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
                        const absoluteValue = Math.abs(dataPoint.total || val);
                        return GLOBAL.FMoneyK(val || dataPoint.total);
                    },
                    dropShadow: {
                        enabled: false
                    }
                },
                tooltip: {
                    marker: {
                        show: false
                    },
                    y: {
                        formatter: function(val, opts) {
                            const data = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
                            const vinculadas = data.fundacoes_vinculadas?.length ? `<br><span class="text-neutral-75">Fundos Vinculados:<br/> ${data.fundacoes_vinculadas.join('<br/>')}</span>` : '';
                            return `Funda\xe7\xe3o: <span class="text-neutral-75"> ${data.x} </span>
							 	<br><span class="text-neutral-75">Capta\xe7\xe3o Ajustada: ${data.y.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 0
                            })} 
							</span>${vinculadas}`;
                        }
                    }
                },
                xaxis: {},
                yaxis: {
                    labels: {
                        formatter: function(val) {
                            return val.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 0
                            });
                        }
                    }
                }
            }
        };
    },
    mounted () {
        const el = document.querySelector('#chart_fundacoes_sai_ranking');
        if (!el) {
            console.error("Elemento #chart_fundacoes_sai_ranking n\xe3o encontrado!");
            return;
        }
        this.chartInstance = new ApexCharts(el, this.optionsFundacoesRanking);
        this.chartInstance.render();
    },
    beforeUnmount () {
        if (this.chartInstance) this.chartInstance.destroy();
    },
    template: `
        <div id="chart_fundacoes_sai_ranking" class="w-full"></div>
    `
};

});

parcelRegister("1kBYF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f851e448ea94851$export$2e2bcd8739ae039; });
const $0f851e448ea94851$var$colorTypeOptionsRanking = [
    '#C11F39',
    '#C11F39',
    '#C11F39',
    '#C11F39',
    '#C11F39',
    '#C11F39',
    '#C11F39',
    '#C11F39',
    '#C11F39',
    '#C11F39'
];
function $0f851e448ea94851$var$convertUnderscoreToNumber(value) {
    if (typeof value === 'string') return parseFloat(value.replace(/_/g, ''));
    else if (typeof value === 'number') return value;
    return 0;
}
var $0f851e448ea94851$export$2e2bcd8739ae039 = {
    name: 'GraficoFundacoesSapRanking',
    props: {
        data: {
            type: Array,
            default: ()=>[]
        }
    },
    methods: {
        processDataValues (data) {
            return data.map((item)=>{
                const valorCaptacao = typeof item.valor_captacao === 'string' ? Number(item.valor_captacao) : item.valor_captacao;
                return {
                    ...item,
                    x: item.nome_cliente_pf || 'Desconhecido',
                    y: valorCaptacao,
                    total: valorCaptacao
                };
            }).sort((a, b)=>{
                return a.y - b.y;
            });
        }
    },
    watch: {
        data () {
            if (this.chartInstance) this.chartInstance.updateSeries([
                {
                    name: '',
                    data: this.processDataValues(this.data)
                }
            ]);
        }
    },
    data () {
        return {
            chartInstance: null,
            optionsFundacoesRanking: {
                series: [
                    {
                        name: '',
                        data: this.processDataValues(this.data)
                    }
                ],
                chart: {
                    type: 'bar',
                    height: 350
                },
                title: {
                    text: 'Top/Bottom SAP'
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '60%',
                        dataLabels: {
                            position: 'top',
                            maxItems: 100,
                            hideOverflowingLabels: false,
                            orientation: 'horizontal'
                        }
                    }
                },
                colors: $0f851e448ea94851$var$colorTypeOptionsRanking,
                dataLabels: {
                    enabled: true,
                    textAnchor: 'middle',
                    distributed: false,
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        fontWeight: 600,
                        colors: [
                            '#373D3F'
                        ]
                    },
                    formatter: function(val, opts) {
                        const dataPoint = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
                        const absoluteValue = Math.abs(dataPoint.total || val);
                        return GLOBAL.FMoneyK(val || dataPoint.total);
                    },
                    dropShadow: {
                        enabled: false
                    }
                },
                tooltip: {
                    y: {
                        formatter: function(val, opts) {
                            const data = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
                            return `Cliente: ${data.x}<br>Capta\xe7\xe3o: ${data.y.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 2
                            })}`;
                        }
                    }
                },
                xaxis: {},
                yaxis: {
                    labels: {
                        formatter: function(val) {
                            return val.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 2
                            });
                        }
                    }
                }
            }
        };
    },
    mounted () {
        const el = document.querySelector('#chart_fundacoes_sap_ranking');
        if (!el) {
            console.error("Elemento #chart_fundacoes_sap_ranking n\xe3o encontrado!");
            return;
        }
        this.chartInstance = new ApexCharts(el, this.optionsFundacoesRanking);
        this.chartInstance.render();
    },
    beforeUnmount () {
        if (this.chartInstance) this.chartInstance.destroy();
    },
    template: `
        <div id="chart_fundacoes_sap_ranking"></div>
    `
};

});

parcelRegister("fM5UL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7bfed3a812a781b$export$2e2bcd8739ae039; });
parcelRequire("kz1MM");
var $2N0NF = parcelRequire("2N0NF");
var $b7bfed3a812a781b$export$2e2bcd8739ae039 = {
    props: {
        dataAtual: 0.0
    },
    data () {
        return {
            optionsMedidorAgendamento: {
                series: [
                    {
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        center: [
                            '50%',
                            '75%'
                        ],
                        radius: '90%',
                        min: 0,
                        max: 1,
                        splitNumber: 6,
                        axisLine: {
                            lineStyle: {
                                width: 6,
                                color: [
                                    [
                                        0.167,
                                        '#fc5655'
                                    ],
                                    [
                                        0.333,
                                        '#fd8888'
                                    ],
                                    [
                                        0.5,
                                        '#fee115'
                                    ],
                                    [
                                        0.667,
                                        '#d1d80f'
                                    ],
                                    [
                                        0.833,
                                        '#83bd32'
                                    ],
                                    [
                                        1,
                                        '#30ad43'
                                    ]
                                ]
                            }
                        },
                        pointer: {
                            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                            length: '12%',
                            width: 20,
                            offsetCenter: [
                                0,
                                '-60%'
                            ],
                            itemStyle: {
                                color: 'auto'
                            }
                        },
                        axisTick: {
                            length: 12,
                            lineStyle: {
                                color: 'auto',
                                width: 2
                            }
                        },
                        splitLine: {
                            length: 20,
                            lineStyle: {
                                color: 'auto',
                                width: 5
                            }
                        },
                        axisLabel: {
                            color: '#464646',
                            fontSize: 16,
                            distance: -60,
                            align: 'center',
                            rotate: 'tangential',
                            formatter: function(value) {
                                const v = Number(value.toFixed(4));
                                const labels = {
                                    0.1667: 'MUITO BAIXO',
                                    0.3333: 'ABAIXO\nESPERADO',
                                    0.5: 'PARCIAL\nBAIXO',
                                    0.6667: 'PARCIAL\nBOM',
                                    0.8333: 'BOM',
                                    1: 'EXCELENTE'
                                };
                                return labels[v] || '';
                            }
                        },
                        title: {
                            offsetCenter: [
                                0,
                                '-10%'
                            ],
                            fontSize: 20
                        },
                        detail: {
                            fontSize: 30,
                            offsetCenter: [
                                0,
                                '-35%'
                            ],
                            valueAnimation: true,
                            formatter: function(value) {
                                return Math.round(value * 100) + '%';
                            },
                            color: 'inherit'
                        },
                        data: [
                            {
                                value: 0.2,
                                name: 'txt'
                            }
                        ]
                    }
                ]
            },
            chartMedidor: null
        };
    },
    watch: {
        dataAtual (newValue) {
            this.updateGauge(newValue);
        }
    },
    methods: {
        initMedidorChart () {
            const chartDom = document.getElementById('chart_medidor_politica_agendamento');
            this.chartMedidor = $2N0NF.init(chartDom);
            this.updateGauge(this.dataAtual);
        /* chartMedidor.setOption(this.optionsMedidorAgendamento) */ },
        updateGauge (value) {
            const labels = [
                {
                    lim: 0.1667,
                    txt: 'MUITO BAIXO'
                },
                {
                    lim: 0.3333,
                    txt: 'ABAIXO DO ESPERADO'
                },
                {
                    lim: 0.5,
                    txt: 'PARCIAL BAIXO'
                },
                {
                    lim: 0.6667,
                    txt: 'PARCIAL BOM'
                },
                {
                    lim: 0.8333,
                    txt: 'BOM'
                },
                {
                    lim: 1,
                    txt: 'EXCELENTE'
                }
            ];
            const labelObj = labels.find((l)=>value <= l.lim) || {
                txt: '',
                cor: '#464646'
            };
            this.optionsMedidorAgendamento.series[0].data[0].value = value;
            this.optionsMedidorAgendamento.series[0].data[0].name = labelObj.txt;
            this.optionsMedidorAgendamento.series[0].detail.color = labelObj.cor;
            this.optionsMedidorAgendamento.series[0].title.color = labelObj.cor;
            this.chartMedidor.setOption(this.optionsMedidorAgendamento, true);
        }
    },
    mounted () {
        this.initMedidorChart();
    },
    template: `
        <div id="chart_medidor_politica_agendamento" style="width: 100%; height: 400px;"></div>
    `
};

});
parcelRegister("kz1MM", function(module, exports) {
$parcel$export(module.exports, "init", function () { return (parcelRequire("2N0NF")).init; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");
parcelRequire("2N0NF");

var $25hpb = parcelRequire("25hpb");
var $fB4Lq = parcelRequire("fB4Lq");

var $hAJpt = parcelRequire("hAJpt");
var $eZwvb = parcelRequire("eZwvb");
var $8NOzx = parcelRequire("8NOzx");
var $2pvXX = parcelRequire("2pvXX");
var $cJrP8 = parcelRequire("cJrP8");
var $9KAgp = parcelRequire("9KAgp");
var $gpiX5 = parcelRequire("gpiX5");
var $gN6fY = parcelRequire("gN6fY");
var $7Zi7T = parcelRequire("7Zi7T");
var $ecVCx = parcelRequire("ecVCx");
var $icheD = parcelRequire("icheD");
var $ejMXD = parcelRequire("ejMXD");
var $1O53J = parcelRequire("1O53J");
var $3vGAD = parcelRequire("3vGAD");
var $9vbiM = parcelRequire("9vbiM");
var $2UWtH = parcelRequire("2UWtH");
var $fFnzG = parcelRequire("fFnzG");
var $a8yRU = parcelRequire("a8yRU");
var $12OmF = parcelRequire("12OmF");
var $4qhWn = parcelRequire("4qhWn");
var $acrul = parcelRequire("acrul");
var $3uFX3 = parcelRequire("3uFX3");
var $24giI = parcelRequire("24giI");

var $9PcLo = parcelRequire("9PcLo");
var $24qes = parcelRequire("24qes");
var $2bUOy = parcelRequire("2bUOy");
var $dwDVV = parcelRequire("dwDVV");
var $VrLle = parcelRequire("VrLle");
var $7hZHl = parcelRequire("7hZHl");
var $bMKXt = parcelRequire("bMKXt");
var $4XAdJ = parcelRequire("4XAdJ");
var $enNfu = parcelRequire("enNfu");
var $czhcC = parcelRequire("czhcC");
var $gQxzG = parcelRequire("gQxzG");
var $2MEiy = parcelRequire("2MEiy");
var $aQjTt = parcelRequire("aQjTt");
var $6S8Qg = parcelRequire("6S8Qg");
var $jyMuy = parcelRequire("jyMuy");
var $flmBj = parcelRequire("flmBj");
var $2RBC6 = parcelRequire("2RBC6");
var $86pGl = parcelRequire("86pGl");
var $brswz = parcelRequire("brswz");
var $G1KlT = parcelRequire("G1KlT");
var $gRi3p = parcelRequire("gRi3p");
var $hoKvC = parcelRequire("hoKvC");
var $lDgOb = parcelRequire("lDgOb");
var $aVImd = parcelRequire("aVImd");
var $kMkRM = parcelRequire("kMkRM");
var $7Ink0 = parcelRequire("7Ink0");
var $1tYID = parcelRequire("1tYID");
var $hpw8u = parcelRequire("hpw8u");

var $atXbX = parcelRequire("atXbX");
var $eahBS = parcelRequire("eahBS");
var $5InMz = parcelRequire("5InMz");
var $12OmF = parcelRequire("12OmF");
var $3xe2J = parcelRequire("3xe2J");
// -----------------
// Render engines
// -----------------
// Render via Canvas.
// echarts.init(dom, null, { renderer: 'canvas' })
(0, $gX19P.use)([
    (0, $25hpb.install)
]);
// Render via SVG.
// echarts.init(dom, null, { renderer: 'svg' })
(0, $gX19P.use)([
    (0, $fB4Lq.install)
]);
// ----------------
// Charts (series)
// ----------------
// All of the series types, for example:
// chart.setOption({
//     series: [{
//         type: 'line' // or 'bar', 'pie', ...
//     }]
// });
(0, $gX19P.use)([
    (0, $icheD.install),
    (0, $hAJpt.install),
    (0, $2UWtH.install),
    (0, $12OmF.install),
    (0, $fFnzG.install),
    (0, $1O53J.install),
    (0, $3uFX3.install),
    (0, $24giI.install),
    (0, $7Zi7T.install),
    (0, $2pvXX.install),
    (0, $gN6fY.install),
    (0, $gpiX5.install),
    (0, $3vGAD.install),
    (0, $a8yRU.install),
    (0, $eZwvb.install),
    (0, $8NOzx.install),
    (0, $9KAgp.install),
    (0, $ejMXD.install),
    (0, $ecVCx.install),
    (0, $9vbiM.install),
    (0, $acrul.install),
    (0, $4qhWn.install),
    (0, $cJrP8.install)
]);
// -------------------
// Coordinate systems
// -------------------
// All of the axis modules have been included in the
// coordinate system module below, do not need to
// make extra import.
// `cartesian` coordinate system. For some historical
// reasons, it is named as grid, for example:
// chart.setOption({
//     grid: {...},
//     xAxis: {...},
//     yAxis: {...},
//     series: [{...}]
// });
(0, $gX19P.use)((0, $gQxzG.install));
// `polar` coordinate system, for example:
// chart.setOption({
//     polar: {...},
//     radiusAxis: {...},
//     angleAxis: {...},
//     series: [{
//         coordinateSystem: 'polar'
//     }]
// });
(0, $gX19P.use)((0, $86pGl.install));
// `geo` coordinate system, for example:
// chart.setOption({
//     geo: {...},
//     series: [{
//         coordinateSystem: 'geo'
//     }]
// });
(0, $gX19P.use)((0, $enNfu.install));
// `singleAxis` coordinate system (notice, it is a coordinate system
// with only one axis, work for chart like theme river), for example:
// chart.setOption({
//     singleAxis: {...}
//     series: [{type: 'themeRiver', ...}]
// });
(0, $gX19P.use)((0, $brswz.install));
// `parallel` coordinate system, only work for parallel series, for example:
// chart.setOption({
//     parallel: {...},
//     parallelAxis: [{...}, ...],
//     series: [{
//         type: 'parallel'
//     }]
// });
(0, $gX19P.use)((0, $2RBC6.install));
// `calendar` coordinate system. for example,
// chart.setOption({
//     calendar: {...},
//     series: [{
//         coordinateSystem: 'calendar'
//     }]
// );
(0, $gX19P.use)((0, $dwDVV.install));
// `matrix` coordinate system. for example,
// chart.setOption({
//     matrix: {...},
//     series: [{
//         coordinateSystem: 'matrix'
//     }]
// );
(0, $gX19P.use)((0, $flmBj.install));
// ------------------
// Other components
// ------------------
// `graphic` component, for example:
// chart.setOption({
//     graphic: {...}
// });
(0, $gX19P.use)((0, $czhcC.install));
// `toolbox` component, for example:
// chart.setOption({
//     toolbox: {...}
// });
(0, $gX19P.use)((0, $lDgOb.install));
// `tooltip` component, for example:
// chart.setOption({
//     tooltip: {...}
// });
(0, $gX19P.use)((0, $aVImd.install));
// `axisPointer` component, for example:
// chart.setOption({
//     tooltip: {axisPointer: {...}, ...}
// });
// Or
// chart.setOption({
//     axisPointer: {...}
// });
(0, $gX19P.use)((0, $24qes.install));
// `brush` component, for example:
// chart.setOption({
//     brush: {...}
// });
// Or
// chart.setOption({
//     tooltip: {feature: {brush: {...}}
// })
(0, $gX19P.use)((0, $2bUOy.install));
// `title` component, for example:
// chart.setOption({
//     title: {...}
// });
(0, $gX19P.use)((0, $hoKvC.install));
// `timeline` component, for example:
// chart.setOption({
//     timeline: {...}
// });
(0, $gX19P.use)((0, $gRi3p.install));
// `markPoint` component, for example:
// chart.setOption({
//     series: [{markPoint: {...}}]
// });
(0, $gX19P.use)((0, $jyMuy.install));
// `markLine` component, for example:
// chart.setOption({
//     series: [{markLine: {...}}]
// });
(0, $gX19P.use)((0, $6S8Qg.install));
// `markArea` component, for example:
// chart.setOption({
//     series: [{markArea: {...}}]
// });
(0, $gX19P.use)((0, $aQjTt.install));
// `legend` component not scrollable. for example:
// chart.setOption({
//     legend: {...}
// });
(0, $gX19P.use)((0, $2MEiy.install));
// `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.
(0, $gX19P.use)((0, $7hZHl.install));
// `dataZoom` component providing drag, pinch, wheel behaviors
// inside coordinate system, for example:
// chart.setOption({
//     dataZoom: {type: 'inside'}
// });
(0, $gX19P.use)((0, $bMKXt.install));
// `dataZoom` component providing a slider bar, for example:
// chart.setOption({
//     dataZoom: {type: 'slider'}
// });
(0, $gX19P.use)((0, $4XAdJ.install));
// `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.
(0, $gX19P.use)((0, $7Ink0.install));
// `visualMap` component providing continuous bar, for example:
// chart.setOption({
//     visualMap: {type: 'continuous'}
// });
(0, $gX19P.use)((0, $1tYID.install));
// `visualMap` component providing pieces bar, for example:
// chart.setOption({
//     visualMap: {type: 'piecewise'}
// });
(0, $gX19P.use)((0, $hpw8u.install));
(0, $gX19P.use)((0, $G1KlT.install));
// `aria` component providing aria, for example:
// chart.setOption({
//     aria: {...}
// });
(0, $gX19P.use)((0, $9PcLo.install));
// dataset transform
// chart.setOption({
//     dataset: {
//          transform: []
//     }
// });
(0, $gX19P.use)((0, $kMkRM.install));
(0, $gX19P.use)((0, $VrLle.install));
// universal transition
// chart.setOption({
//     series: {
//         universalTransition: { enabled: true }
//     }
// })
(0, $gX19P.use)((0, $3xe2J.installUniversalTransition));
// label layout
// chart.setOption({
//     series: {
//         labelLayout: { hideOverlap: true }
//     }
// })
(0, $gX19P.use)((0, $eahBS.installLabelLayout));
(0, $gX19P.use)((0, $atXbX.installAxisBreak));
(0, $gX19P.use)((0, $5InMz.installLegacyGridContainLabel));
(0, $gX19P.use)((0, $12OmF.installScatterJitter));

});
parcelRegister("gX19P", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $c5730de26b8ab3fa$export$1f96ae73734a86cc; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N0NF = parcelRequire("2N0NF");

var $bpyST = parcelRequire("bpyST");

var $cWIrM = parcelRequire("cWIrM");

var $eLD2b = parcelRequire("eLD2b");

var $49X8G = parcelRequire("49X8G");

var $2N6Uo = parcelRequire("2N6Uo");

var $dDyjB = parcelRequire("dDyjB");

var $8rOrp = parcelRequire("8rOrp");

var $jHMox = parcelRequire("jHMox");
var $c5730de26b8ab3fa$var$extensions = [];
var $c5730de26b8ab3fa$var$extensionRegisters = {
    registerPreprocessor: (0, $2N0NF.registerPreprocessor),
    registerProcessor: (0, $2N0NF.registerProcessor),
    registerPostInit: (0, $2N0NF.registerPostInit),
    registerPostUpdate: (0, $2N0NF.registerPostUpdate),
    registerUpdateLifecycle: (0, $2N0NF.registerUpdateLifecycle),
    registerAction: (0, $2N0NF.registerAction),
    registerCoordinateSystem: (0, $2N0NF.registerCoordinateSystem),
    registerLayout: (0, $2N0NF.registerLayout),
    registerVisual: (0, $2N0NF.registerVisual),
    registerTransform: (0, $2N0NF.registerTransform),
    registerLoading: (0, $2N0NF.registerLoading),
    registerMap: (0, $2N0NF.registerMap),
    registerImpl: (0, $dDyjB.registerImpl),
    PRIORITY: (0, $2N0NF.PRIORITY),
    ComponentModel: (0, $eLD2b.default),
    ComponentView: (0, $bpyST.default),
    SeriesModel: (0, $49X8G.default),
    ChartView: (0, $cWIrM.default),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $eLD2b.default).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $bpyST.default).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $49X8G.default).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $cWIrM.default).registerClass(ChartViewClass);
    },
    registerCustomSeries: function(seriesType, renderItem) {
        (0, $jHMox.registerCustomSeries)(seriesType, renderItem);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $eLD2b.default).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $8rOrp.registerPainter)(painterType, PainterCtor);
    }
};
function $c5730de26b8ab3fa$export$1f96ae73734a86cc(ext) {
    if ((0, $2N6Uo.isArray)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $2N6Uo.each)(ext, function(singleExt) {
            $c5730de26b8ab3fa$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $2N6Uo.indexOf)($c5730de26b8ab3fa$var$extensions, ext) >= 0) return;
    $c5730de26b8ab3fa$var$extensions.push(ext);
    if ((0, $2N6Uo.isFunction)(ext)) ext = {
        install: ext
    };
    ext.install($c5730de26b8ab3fa$var$extensionRegisters);
}

});
parcelRegister("2N0NF", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", function () { return $2080c747322ae901$export$bb34f3538ba26c7e; });
$parcel$export(module.exports, "init", function () { return $2080c747322ae901$export$2cd8252107eb640b; });
$parcel$export(module.exports, "registerPreprocessor", function () { return $2080c747322ae901$export$77095792a057b768; });
$parcel$export(module.exports, "registerProcessor", function () { return $2080c747322ae901$export$d575e6557ac1729f; });
$parcel$export(module.exports, "registerPostInit", function () { return $2080c747322ae901$export$c8c249911ee8c1ed; });
$parcel$export(module.exports, "registerUpdateLifecycle", function () { return $2080c747322ae901$export$c9ec4b5faef04865; });
$parcel$export(module.exports, "registerPostUpdate", function () { return $2080c747322ae901$export$99560909c18c76bb; });
$parcel$export(module.exports, "registerAction", function () { return $2080c747322ae901$export$408c24786cd729c6; });
$parcel$export(module.exports, "registerCoordinateSystem", function () { return $2080c747322ae901$export$1dd5e025a8a37dd; });
$parcel$export(module.exports, "registerLayout", function () { return $2080c747322ae901$export$d768f97700ca6bea; });
$parcel$export(module.exports, "registerVisual", function () { return $2080c747322ae901$export$5f32c1eb94c381bb; });
$parcel$export(module.exports, "registerLoading", function () { return $2080c747322ae901$export$e06b68a82007c015; });
$parcel$export(module.exports, "registerMap", function () { return $2080c747322ae901$export$d456de060be2dba1; });
$parcel$export(module.exports, "registerTransform", function () { return $2080c747322ae901$export$f01d71dd0389d7e4; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $9nEce = parcelRequire("9nEce");

var $8rOrp = parcelRequire("8rOrp");

var $2N6Uo = parcelRequire("2N6Uo");

var $cirKE = parcelRequire("cirKE");

var $bPBpF = parcelRequire("bPBpF");

var $5Uet9 = parcelRequire("5Uet9");

var $jyf7V = parcelRequire("jyf7V");

var $lCOOS = parcelRequire("lCOOS");

var $hIXrb = parcelRequire("hIXrb");

var $9voWY = parcelRequire("9voWY");

var $2D3oR = parcelRequire("2D3oR");

var $aOkQp = parcelRequire("aOkQp");

var $49X8G = parcelRequire("49X8G");

var $bpyST = parcelRequire("bpyST");

var $cWIrM = parcelRequire("cWIrM");
parcelRequire("h9U3p");
var $lQsZt = parcelRequire("lQsZt");
var $4oDJM = parcelRequire("4oDJM");
var $aH2k0 = parcelRequire("aH2k0");
var $h9U3p = parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $6TSUP = parcelRequire("6TSUP");

var $bwPbQ = parcelRequire("bwPbQ");

var $bx3T8 = parcelRequire("bx3T8");

var $99VtN = parcelRequire("99VtN");

var $lbln3 = parcelRequire("lbln3");

var $2QF9O = parcelRequire("2QF9O");

var $fcGJo = parcelRequire("fcGJo");

var $e0Ss6 = parcelRequire("e0Ss6");

var $I7Ovw = parcelRequire("I7Ovw");

var $9vGpS = parcelRequire("9vGpS");

var $gvC19 = parcelRequire("gvC19");

var $csdCr = parcelRequire("csdCr");

var $byzwF = parcelRequire("byzwF");

var $eHA3F = parcelRequire("eHA3F");

var $34jNS = parcelRequire("34jNS");

var $2FU9b = parcelRequire("2FU9b");

var $cQG2W = parcelRequire("cQG2W");

var $8Ysvi = parcelRequire("8Ysvi");

var $hHu50 = parcelRequire("hHu50");

var $3WHoM = parcelRequire("3WHoM");

var $dDyjB = parcelRequire("dDyjB");

var $jHMox = parcelRequire("jHMox");
var $2080c747322ae901$export$83d89fbfd8236492 = '6.0.0';
var $2080c747322ae901$export$b74ff737e0e298b5 = {
    zrender: '6.0.0'
};
var $2080c747322ae901$var$TEST_FRAME_REMAIN_TIME = 1;
var $2080c747322ae901$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $2080c747322ae901$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// "Data filter" will block the stream, so it should be
// put at the beginning of data processing.
var $2080c747322ae901$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $2080c747322ae901$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $2080c747322ae901$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $2080c747322ae901$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $2080c747322ae901$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $2080c747322ae901$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $2080c747322ae901$var$PRIORITY_VISUAL_CHART = 3000;
var $2080c747322ae901$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $2080c747322ae901$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $2080c747322ae901$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $2080c747322ae901$var$PRIORITY_VISUAL_BRUSH = 5000;
var $2080c747322ae901$var$PRIORITY_VISUAL_ARIA = 6000;
var $2080c747322ae901$var$PRIORITY_VISUAL_DECAL = 7000;
var $2080c747322ae901$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $2080c747322ae901$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $2080c747322ae901$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $2080c747322ae901$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $2080c747322ae901$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $2080c747322ae901$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $2080c747322ae901$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $2080c747322ae901$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $2080c747322ae901$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $2080c747322ae901$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $2080c747322ae901$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $2080c747322ae901$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $2080c747322ae901$var$PRIORITY_VISUAL_ARIA,
        DECAL: $2080c747322ae901$var$PRIORITY_VISUAL_DECAL
    }
};
// Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $2080c747322ae901$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
// Useful for detecting outdated rendering results in scenarios that these issues are involved:
//  - Use shortcut (such as, updateTransform, or no update) to start a main process.
//  - Asynchronously update rendered view (e.g., graph force layout).
//  - Multiple ChartView/ComponentView render to one group cooperatively.
var $2080c747322ae901$var$MAIN_PROCESS_VERSION_KEY = '__mainProcessVersion';
var $2080c747322ae901$var$PENDING_UPDATE = '__pendingUpdate';
var $2080c747322ae901$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $2080c747322ae901$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $2080c747322ae901$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $2080c747322ae901$var$CONNECT_STATUS_PENDING = 0;
var $2080c747322ae901$var$CONNECT_STATUS_UPDATING = 1;
var $2080c747322ae901$var$CONNECT_STATUS_UPDATED = 2;
function $2080c747322ae901$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        return $2080c747322ae901$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $2080c747322ae901$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $2080c747322ae901$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $2080c747322ae901$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $5Uet9.default).prototype[method].apply(host, args);
}
var $2080c747322ae901$var$MessageCenter = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $5Uet9.default));
var $2080c747322ae901$var$messageCenterProto = $2080c747322ae901$var$MessageCenter.prototype;
$2080c747322ae901$var$messageCenterProto.on = $2080c747322ae901$var$createRegisterEventWithLowercaseMessageCenter('on');
$2080c747322ae901$var$messageCenterProto.off = $2080c747322ae901$var$createRegisterEventWithLowercaseMessageCenter('off');
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $2080c747322ae901$var$prepare;
var $2080c747322ae901$var$prepareView;
var $2080c747322ae901$var$updateDirectly;
var $2080c747322ae901$var$updateMethods;
var $2080c747322ae901$var$doConvertPixel;
var $2080c747322ae901$var$updateStreamModes;
var $2080c747322ae901$var$doDispatchAction;
var $2080c747322ae901$var$flushPendingActions;
var $2080c747322ae901$var$triggerUpdatedEvent;
var $2080c747322ae901$var$bindRenderedEvent;
var $2080c747322ae901$var$bindMouseEvent;
var $2080c747322ae901$var$render;
var $2080c747322ae901$var$renderComponents;
var $2080c747322ae901$var$renderSeries;
var $2080c747322ae901$var$createExtensionAPI;
var $2080c747322ae901$var$enableConnect;
var $2080c747322ae901$var$markStatusToUpdate;
var $2080c747322ae901$var$applyChangedStates;
var $2080c747322ae901$var$updateMainProcessVersion;
var $2080c747322ae901$var$ECharts = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $9vGpS.ECEventProcessor)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultCoarsePointer = 'auto';
        var defaultUseDirtyRect = false;
        _this[$2080c747322ae901$var$MAIN_PROCESS_VERSION_KEY] = 1;
        var root;
        if (opts.ssr) $8rOrp.registerSSRDataGetter(function(el) {
            var ecData = (0, $6TSUP.getECData)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $2N6Uo.createHashMap)();
            hashMap.set('series_index', ecData.seriesIndex);
            hashMap.set('data_index', dataIndex);
            ecData.ssrType && hashMap.set('ssr_type', ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $8rOrp.init(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $2N6Uo.retrieve2)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $2N6Uo.retrieve2)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $99VtN.throttle)((0, $2N6Uo.bind)(zr.flush, zr), 17);
        _this._updateTheme(theme);
        _this._locale = (0, $2FU9b.createLocaleObject)(opts.locale || (0, $2FU9b.SYSTEM_LANG));
        _this._coordSysMgr = new (0, $hIXrb.default)();
        var api = _this._api = $2080c747322ae901$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $bPBpF.default)($2080c747322ae901$var$visualFuncs, prioritySortFunc);
        (0, $bPBpF.default)($2080c747322ae901$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $fcGJo.default)(_this, api, $2080c747322ae901$var$dataProcessorFuncs, $2080c747322ae901$var$visualFuncs);
        _this._messageCenter = new $2080c747322ae901$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $2N6Uo.bind)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $2080c747322ae901$var$bindRenderedEvent(zr, _this);
        $2080c747322ae901$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $2N6Uo.setAsPrimitive)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $2080c747322ae901$var$applyChangedStates(this);
        var scheduler = this._scheduler;
        // Lazy update
        if (this[$2080c747322ae901$var$PENDING_UPDATE]) {
            var silent = this[$2080c747322ae901$var$PENDING_UPDATE].silent;
            this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = true;
            $2080c747322ae901$var$updateMainProcessVersion(this);
            try {
                $2080c747322ae901$var$prepare(this);
                $2080c747322ae901$var$updateMethods.update.call(this, null, this[$2080c747322ae901$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
                this[$2080c747322ae901$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
            this[$2080c747322ae901$var$PENDING_UPDATE] = null;
            $2080c747322ae901$var$flushPendingActions.call(this, silent);
            $2080c747322ae901$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $2080c747322ae901$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $2080c747322ae901$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $2080c747322ae901$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $2N6Uo.isObject)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = true;
        $2080c747322ae901$var$updateMainProcessVersion(this);
        if (!this._model || notMerge) {
            var optionManager = new (0, $9voWY.default)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $jyf7V.default)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $2080c747322ae901$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$2080c747322ae901$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $2080c747322ae901$var$prepare(this);
                $2080c747322ae901$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$2080c747322ae901$var$PENDING_UPDATE] = null;
                this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$2080c747322ae901$var$PENDING_UPDATE] = null;
            this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
            $2080c747322ae901$var$flushPendingActions.call(this, silent);
            $2080c747322ae901$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * Update theme with name or theme option and repaint the chart.
   * @param theme Theme name or theme option.
   * @param opts Optional settings
   */ ECharts.prototype.setTheme = function(theme, opts) {
        if (this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        if (!ecModel) return;
        var silent = opts && opts.silent;
        var updateParams = null;
        if (this[$2080c747322ae901$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$2080c747322ae901$var$PENDING_UPDATE].silent;
            updateParams = this[$2080c747322ae901$var$PENDING_UPDATE].updateParams;
            this[$2080c747322ae901$var$PENDING_UPDATE] = null;
        }
        this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = true;
        $2080c747322ae901$var$updateMainProcessVersion(this);
        try {
            this._updateTheme(theme);
            ecModel.setTheme(this._theme);
            $2080c747322ae901$var$prepare(this);
            $2080c747322ae901$var$updateMethods.update.call(this, {
                type: 'setTheme'
            }, updateParams);
        } catch (e) {
            this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
        $2080c747322ae901$var$flushPendingActions.call(this, silent);
        $2080c747322ae901$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype._updateTheme = function(theme) {
        if ((0, $2N6Uo.isString)(theme)) theme = $2080c747322ae901$var$themeStorage[theme];
        if (theme) {
            theme = (0, $2N6Uo.clone)(theme);
            theme && (0, $2D3oR.default)(theme, true);
            this._theme = theme;
        }
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $cirKE.default).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $2N6Uo.each)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $2N6Uo.each)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $2N6Uo.each)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($2080c747322ae901$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $2N6Uo.each)($2080c747322ae901$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $2N6Uo.clone)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $3WHoM.platformApi).createCanvas();
            var zr_1 = $8rOrp.init(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $2N6Uo.each)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $aH2k0.default({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $2N6Uo.each)(canvasList_1, function(item) {
                    var img = new $lQsZt.default({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value, opt) {
        return $2080c747322ae901$var$doConvertPixel(this, 'convertToPixel', finder, value, opt);
    };
    /**
   * Convert from logical coordinate system to pixel coordinate system.
   * See CoordinateSystem#convertToPixel.
   *
   * @see CoordinateSystem['dataToLayout'] for parameters and return.
   * @see CoordinateSystemDataCoord
   */ ECharts.prototype.convertToLayout = function(finder, value, opt) {
        return $2080c747322ae901$var$doConvertPixel(this, 'convertToLayout', finder, value, opt);
    };
    // The above are signatures from before v6, thus they should be preserved for backward compat.
    ECharts.prototype.convertFromPixel = function(finder, value, opt) {
        return $2080c747322ae901$var$doConvertPixel(this, 'convertFromPixel', finder, value, opt);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $bx3T8.parseFinder(ecModel, finder);
        (0, $2N6Uo.each)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $2N6Uo.each)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $bx3T8.parseFinder(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $csdCr.getItemVisualFromData)(data, dataIndexInside, visualType) : (0, $csdCr.getVisualFromData)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $2N6Uo.each)($2080c747322ae901$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout';
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $cQG2W.findEventDispatcher)(el, function(parent) {
                    var ecData = (0, $6TSUP.getECData)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $2N6Uo.extend)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        var messageCenter = this._messageCenter;
        (0, $2N6Uo.each)($2080c747322ae901$var$publicEventTypeMap, function(_, eventType) {
            messageCenter.on(eventType, function(event) {
                _this.trigger(eventType, event);
            });
        });
        (0, $eHA3F.handleLegacySelectEvents)(messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $bx3T8.setAttribute(this.getDom(), $2080c747322ae901$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $2N6Uo.each)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $2N6Uo.each)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $2080c747322ae901$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$2080c747322ae901$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$2080c747322ae901$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$2080c747322ae901$var$PENDING_UPDATE] = null;
        }
        this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = true;
        $2080c747322ae901$var$updateMainProcessVersion(this);
        try {
            needPrepare && $2080c747322ae901$var$prepare(this);
            $2080c747322ae901$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, $2N6Uo.extend)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
        $2080c747322ae901$var$flushPendingActions.call(this, silent);
        $2080c747322ae901$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        if ((0, $2N6Uo.isObject)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$2080c747322ae901$var$loadingEffects[name]) return;
        var el = $2080c747322ae901$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $2N6Uo.extend)({}, eventObj);
        payload.type = $2080c747322ae901$var$connectionEventRevertMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $2N6Uo.isObject)(opt)) opt = {
            silent: !!opt
        };
        if (!$2080c747322ae901$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $2080c747322ae901$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $cirKE.default).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $2080c747322ae901$var$flushPendingActions.call(this, silent);
        $2080c747322ae901$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $hHu50.default).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $2080c747322ae901$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $2080c747322ae901$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $2080c747322ae901$var$prepareView(ecIns, true);
            $2080c747322ae901$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $2080c747322ae901$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $I7Ovw.parseClassType)(model.type);
                    var Clazz = isComponent ? (0, $bpyST.default).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $cWIrM.default).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $2080c747322ae901$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $2N6Uo.each)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + 'Id'] = payload[mainType + 'Id'];
            query[mainType + 'Index'] = payload[mainType + 'Index'];
            query[mainType + 'Name'] = payload[mainType + 'Name'];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $2N6Uo.createHashMap)();
                (0, $2N6Uo.each)($bx3T8.normalizeToArray(excludeSeriesId), function(id) {
                    var modelId = $bx3T8.convertOptionIdName(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $bwPbQ.isHighDownPayload)(payload)) {
                    if (model instanceof (0, $49X8G.default)) {
                        if (payload.type === (0, $bwPbQ.HIGHLIGHT_ACTION_TYPE) && !payload.notBlur && !model.get([
                            'emphasis',
                            'disabled'
                        ])) (0, $bwPbQ.blurSeriesFromHighlightPayload)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $bwPbQ.findComponentHighDownDispatchers)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $bwPbQ.HIGHLIGHT_ACTION_TYPE) && focusSelf && !payload.notBlur) (0, $bwPbQ.blurComponent)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $2N6Uo.each)(dispatchers, function(dispatcher) {
                            payload.type === (0, $bwPbQ.HIGHLIGHT_ACTION_TYPE) ? (0, $bwPbQ.enterEmphasis)(dispatcher) : (0, $bwPbQ.leaveEmphasis)(dispatcher);
                        });
                    }
                } else if ((0, $bwPbQ.isSelectChangePayload)(payload)) // TODO geo
                {
                    if (model instanceof (0, $49X8G.default)) {
                        (0, $bwPbQ.toggleSelectionFromPayload)(model, payload, ecIns._api);
                        (0, $bwPbQ.updateSeriesElementSelection)(model);
                        $2080c747322ae901$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $2080c747322ae901$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $2080c747322ae901$var$prepare(this);
                $2080c747322ae901$var$updateMethods.update.call(this, payload, payload && {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $2080c747322ae901$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                // Set background and dark mode before rendering, because they affect auto-color-determination
                // in zrender Text, and consequently affect the bounding rect if stroke is added.
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                var darkMode = ecModel.get('darkMode');
                if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                $2080c747322ae901$var$render(this, ecModel, api, payload, updateParams);
                (0, $hHu50.default).trigger('afterupdate', ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === 'series') return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $2N6Uo.createHashMap)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $2080c747322ae901$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $hHu50.default).trigger('afterupdate', ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $cWIrM.default).markUpdateMethod(payload, 'updateView');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $2080c747322ae901$var$render(this, ecModel, this._api, payload, {});
                (0, $hHu50.default).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $cWIrM.default).markUpdateMethod(payload, 'updateVisual');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $hHu50.default).trigger('afterupdate', ecModel, this._api);
            },
            updateLayout: function(payload) {
                $2080c747322ae901$var$updateMethods.update.call(this, payload);
            }
        };
        function doConvertPixelImpl(ecIns, methodName, finder, value, opt) {
            if (ecIns._disposed) {
                $2080c747322ae901$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $bx3T8.parseFinder(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value, opt)) != null) return result;
            }
        }
        $2080c747322ae901$var$doConvertPixel = doConvertPixelImpl;
        $2080c747322ae901$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $2080c747322ae901$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionInfo = $2080c747322ae901$var$actions[payloadType];
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $I7Ovw.parseClassType)(cptTypeTmp[0]);
            this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = true;
            $2080c747322ae901$var$updateMainProcessVersion(this);
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $2N6Uo.map)(payload.batch, function(item) {
                    item = (0, $2N6Uo.defaults)((0, $2N6Uo.extend)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var actionResultBatch = [];
            var nonRefinedEventType = actionInfo.nonRefinedEventType;
            var isSelectChange = (0, $bwPbQ.isSelectChangePayload)(payload);
            var isHighDown = (0, $bwPbQ.isHighDownPayload)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $bwPbQ.allLeaveBlur)(this._api);
            (0, $2N6Uo.each)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                var actionResult = actionInfo.action(batchItem, ecModel, _this._api);
                if (actionInfo.refineEvent) actionResultBatch.push(actionResult);
                else eventObj = actionResult;
                eventObj = eventObj || (0, $2N6Uo.extend)({}, batchItem);
                eventObj.type = nonRefinedEventType;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $bx3T8.preParseFinder(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $2080c747322ae901$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $2080c747322ae901$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $2080c747322ae901$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $2080c747322ae901$var$markStatusToUpdate(_this);
                } else if (cptType) $2080c747322ae901$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$2080c747322ae901$var$PENDING_UPDATE]) {
                    $2080c747322ae901$var$prepare(this);
                    $2080c747322ae901$var$updateMethods.update.call(this, payload);
                    this[$2080c747322ae901$var$PENDING_UPDATE] = null;
                } else $2080c747322ae901$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: nonRefinedEventType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$2080c747322ae901$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var refinedEvent = void 0;
                if (actionInfo.refineEvent) {
                    var eventContent = actionInfo.refineEvent(actionResultBatch, payload, ecModel, this._api).eventContent;
                    (0, $2N6Uo.assert)((0, $2N6Uo.isObject)(eventContent));
                    refinedEvent = (0, $2N6Uo.defaults)({
                        type: actionInfo.refinedEventType
                    }, eventContent);
                    refinedEvent.fromAction = payload.type;
                    refinedEvent.fromActionPayload = payload;
                    refinedEvent.escapeConnect = true;
                }
                var messageCenter = this._messageCenter;
                // - If `refineEvent` created a `refinedEvent`, `eventObj` (replicated from the original payload)
                //  is still needed to be triggered for the feature `connect`. But it will not be triggered to
                //  users in this case.
                // - If no `refineEvent` used, `eventObj` will be triggered for both `connect` and users.
                messageCenter.trigger(eventObj.type, eventObj);
                if (refinedEvent) messageCenter.trigger(refinedEvent.type, refinedEvent);
            }
        };
        $2080c747322ae901$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $2080c747322ae901$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $2080c747322ae901$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $2080c747322ae901$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$2080c747322ae901$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
            });
        };
        $2080c747322ae901$var$bindMouseEvent = function(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $cQG2W.findEventDispatcher)(el, (0, $bwPbQ.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $bwPbQ.handleGlobalMouseOverForHighDown)(dispatcher, e, ecIns._api);
                    $2080c747322ae901$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $cQG2W.findEventDispatcher)(el, (0, $bwPbQ.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $bwPbQ.handleGlobalMouseOutForHighDown)(dispatcher, e, ecIns._api);
                    $2080c747322ae901$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $cQG2W.findEventDispatcher)(el, function(target) {
                    return (0, $6TSUP.getECData)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $6TSUP.getECData)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get('zlevel') || 0;
                var z = componentModel.get('z') || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === 'series' ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $bPBpF.default)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $2N6Uo.each)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = '';
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $2080c747322ae901$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $2080c747322ae901$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $2N6Uo.each)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $2080c747322ae901$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $2N6Uo.each)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $2080c747322ae901$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $2N6Uo.each)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $2080c747322ae901$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $2N6Uo.extend)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $hHu50.default).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent');
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $bwPbQ.updateSeriesElementSelection)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $hHu50.default).trigger('series:layoutlabels', ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $hHu50.default).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $hHu50.default).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $2080c747322ae901$var$markStatusToUpdate = function(ecIns) {
            ecIns[$2080c747322ae901$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $2080c747322ae901$var$updateMainProcessVersion = function(ecIns) {
            ecIns[$2080c747322ae901$var$MAIN_PROCESS_VERSION_KEY] = (ecIns[$2080c747322ae901$var$MAIN_PROCESS_VERSION_KEY] + 1) % 1000;
        };
        $2080c747322ae901$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$2080c747322ae901$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($ipprj.isElementRemoved(el)) return;
                applyElementStates(el);
            });
            ecIns[$2080c747322ae901$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $bwPbQ.HOVER_STATE_EMPHASIS) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $bwPbQ.HOVER_STATE_BLUR) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get('hoverLayerThreshold') && !(0, $cirKE.default).node && !(0, $cirKE.default).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.eachRendered(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.eachRendered(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var zInfo = $h9U3p.retrieveZInfo(model);
            // Set z and zlevel
            view.eachRendered(function(el) {
                $h9U3p.traverseUpdateZ(el, zInfo.z, zInfo.zlevel);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($ipprj.isElementRemoved(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing')
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($ipprj.isElementRemoved(el)) return;
                    if (el instanceof $4oDJM.default) (0, $bwPbQ.savePathStates)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $2080c747322ae901$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $9nEce.__extends)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $bwPbQ.enterEmphasis)(el, highlightDigit);
                    $2080c747322ae901$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $bwPbQ.leaveEmphasis)(el, highlightDigit);
                    $2080c747322ae901$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $bwPbQ.enterBlur)(el);
                    $2080c747322ae901$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $bwPbQ.leaveBlur)(el);
                    $2080c747322ae901$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $bwPbQ.enterSelect)(el);
                    $2080c747322ae901$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $bwPbQ.leaveSelect)(el);
                    $2080c747322ae901$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                class_1.prototype.getMainProcessVersion = function() {
                    return ecIns[$2080c747322ae901$var$MAIN_PROCESS_VERSION_KEY];
                };
                return class_1;
            }((0, $lCOOS.default)))(ecIns);
        };
        $2080c747322ae901$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$2080c747322ae901$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $2N6Uo.each)($2080c747322ae901$var$connectionEventRevertMap, function(_, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($2080c747322ae901$var$connectedGroups[chart.group] && chart[$2080c747322ae901$var$CONNECT_STATUS_KEY] !== $2080c747322ae901$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $2N6Uo.each)($2080c747322ae901$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $2080c747322ae901$var$CONNECT_STATUS_PENDING);
                        (0, $2N6Uo.each)(otherCharts_1, function(otherChart) {
                            if (otherChart[$2080c747322ae901$var$CONNECT_STATUS_KEY] !== $2080c747322ae901$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $2080c747322ae901$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $5Uet9.default));
var $2080c747322ae901$var$echartsProto = $2080c747322ae901$var$ECharts.prototype;
$2080c747322ae901$var$echartsProto.on = $2080c747322ae901$var$createRegisterEventWithLowercaseECharts('on');
$2080c747322ae901$var$echartsProto.off = $2080c747322ae901$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$2080c747322ae901$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $byzwF.deprecateLog)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $2080c747322ae901$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $2080c747322ae901$var$disposedWarning(id) {}
var $2080c747322ae901$var$actions = {};
/**
 * Map event type to action type for reproducing action from event for `connect`.
 */ var $2080c747322ae901$var$connectionEventRevertMap = {};
/**
 * To remove duplication.
 */ var $2080c747322ae901$var$publicEventTypeMap = {};
var $2080c747322ae901$var$dataProcessorFuncs = [];
var $2080c747322ae901$var$optionPreprocessorFuncs = [];
var $2080c747322ae901$var$visualFuncs = [];
var $2080c747322ae901$var$themeStorage = {};
var $2080c747322ae901$var$loadingEffects = {};
var $2080c747322ae901$var$instances = {};
var $2080c747322ae901$var$connectedGroups = {};
var $2080c747322ae901$var$idBase = +new Date() - 0;
var $2080c747322ae901$var$groupIdBase = +new Date() - 0;
var $2080c747322ae901$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $2080c747322ae901$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $2080c747322ae901$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $2080c747322ae901$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $2080c747322ae901$var$idBase++;
    $2080c747322ae901$var$instances[chart.id] = chart;
    isClient && $bx3T8.setAttribute(dom, $2080c747322ae901$var$DOM_ATTRIBUTE_KEY, chart.id);
    $2080c747322ae901$var$enableConnect(chart);
    (0, $hHu50.default).trigger('afterinit', chart);
    return chart;
}
function $2080c747322ae901$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $2N6Uo.isArray)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $2N6Uo.each)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $2080c747322ae901$var$groupIdBase++;
        (0, $2N6Uo.each)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $2080c747322ae901$var$connectedGroups[groupId] = true;
    return groupId;
}
function $2080c747322ae901$export$37dfea93db2e14ed(groupId) {
    $2080c747322ae901$var$connectedGroups[groupId] = false;
}
var $2080c747322ae901$export$87cd6834112ecb52 = $2080c747322ae901$export$37dfea93db2e14ed;
function $2080c747322ae901$export$fcfbbcec2cb820d5(chart) {
    if ((0, $2N6Uo.isString)(chart)) chart = $2080c747322ae901$var$instances[chart];
    else if (!(chart instanceof $2080c747322ae901$var$ECharts)) // Try to treat as dom
    chart = $2080c747322ae901$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $2080c747322ae901$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $2080c747322ae901$export$33b6fbccd4f643f8(dom) {
    return $2080c747322ae901$var$instances[$bx3T8.getAttribute(dom, $2080c747322ae901$var$DOM_ATTRIBUTE_KEY)];
}
function $2080c747322ae901$export$89b4be35062c4a3f(key) {
    return $2080c747322ae901$var$instances[key];
}
function $2080c747322ae901$export$f9c59eed5de5ff80(name, theme) {
    $2080c747322ae901$var$themeStorage[name] = theme;
}
function $2080c747322ae901$export$77095792a057b768(preprocessorFunc) {
    if ((0, $2N6Uo.indexOf)($2080c747322ae901$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $2080c747322ae901$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $2080c747322ae901$export$d575e6557ac1729f(priority, processor) {
    $2080c747322ae901$var$normalizeRegister($2080c747322ae901$var$dataProcessorFuncs, priority, processor, $2080c747322ae901$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $2080c747322ae901$export$c8c249911ee8c1ed(postInitFunc) {
    $2080c747322ae901$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $2080c747322ae901$export$99560909c18c76bb(postUpdateFunc) {
    $2080c747322ae901$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $2080c747322ae901$export$c9ec4b5faef04865(name, cb) {
    (0, $hHu50.default).on(name, cb);
}
function $2080c747322ae901$export$408c24786cd729c6(arg0, arg1, action) {
    var actionType;
    var publicEventType;
    var refineEvent;
    var update;
    var publishNonRefinedEvent;
    if ((0, $2N6Uo.isFunction)(arg1)) {
        action = arg1;
        arg1 = '';
    }
    if ((0, $2N6Uo.isObject)(arg0)) {
        actionType = arg0.type;
        publicEventType = arg0.event;
        update = arg0.update;
        publishNonRefinedEvent = arg0.publishNonRefinedEvent;
        if (!action) action = arg0.action;
        refineEvent = arg0.refineEvent;
    } else {
        actionType = arg0;
        publicEventType = arg1;
    }
    function createEventType(actionOrEventType) {
        // Event type should be all lowercase
        return actionOrEventType.toLowerCase();
    }
    publicEventType = createEventType(publicEventType || actionType);
    // See comments on {ActionInfo} for the reason.
    var nonRefinedEventType = refineEvent ? createEventType(actionType) : publicEventType;
    // Support calling `registerAction` multiple times with the same action
    // type; subsequent calls have no effect.
    if ($2080c747322ae901$var$actions[actionType]) return;
    // Validate action type and event name.
    (0, $2N6Uo.assert)($2080c747322ae901$var$ACTION_REG.test(actionType) && $2080c747322ae901$var$ACTION_REG.test(publicEventType));
    if (refineEvent) // An event replicated from the action will be triggered internally for `connect` in this case.
    (0, $2N6Uo.assert)(publicEventType !== actionType);
    $2080c747322ae901$var$actions[actionType] = {
        actionType: actionType,
        refinedEventType: publicEventType,
        nonRefinedEventType: nonRefinedEventType,
        update: update,
        action: action,
        refineEvent: refineEvent
    };
    $2080c747322ae901$var$publicEventTypeMap[publicEventType] = 1;
    if (refineEvent && publishNonRefinedEvent) $2080c747322ae901$var$publicEventTypeMap[nonRefinedEventType] = 1;
    $2080c747322ae901$var$connectionEventRevertMap[nonRefinedEventType] = actionType;
}
function $2080c747322ae901$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $hIXrb.default).register(type, coordSysCreator);
}
function $2080c747322ae901$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $hIXrb.default).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $2080c747322ae901$export$c3e61191887968da(seriesType, renderItem) {
    (0, $jHMox.registerCustomSeries)(seriesType, renderItem);
}
function $2080c747322ae901$export$d768f97700ca6bea(priority, layoutTask) {
    $2080c747322ae901$var$normalizeRegister($2080c747322ae901$var$visualFuncs, priority, layoutTask, $2080c747322ae901$var$PRIORITY_VISUAL_LAYOUT, 'layout');
}
function $2080c747322ae901$export$5f32c1eb94c381bb(priority, visualTask) {
    $2080c747322ae901$var$normalizeRegister($2080c747322ae901$var$visualFuncs, priority, visualTask, $2080c747322ae901$var$PRIORITY_VISUAL_CHART, 'visual');
}
var $2080c747322ae901$var$registeredTasks = [];
function $2080c747322ae901$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $2N6Uo.isFunction)(priority) || (0, $2N6Uo.isObject)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $2N6Uo.indexOf)($2080c747322ae901$var$registeredTasks, fn) >= 0) return;
    $2080c747322ae901$var$registeredTasks.push(fn);
    var stageHandler = (0, $fcGJo.default).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $2080c747322ae901$export$e06b68a82007c015(name, loadingFx) {
    $2080c747322ae901$var$loadingEffects[name] = loadingFx;
}
function $2080c747322ae901$export$10425ea7a243b114(creator) {
    (0, $3WHoM.setPlatformAPI)({
        createCanvas: creator
    });
}
function $2080c747322ae901$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $dDyjB.getImpl)('registerMap');
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $2080c747322ae901$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $dDyjB.getImpl)('getMap');
    return getMap && getMap(mapName);
}
var $2080c747322ae901$export$f01d71dd0389d7e4 = (0, $34jNS.registerExternalTransform);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$2080c747322ae901$export$5f32c1eb94c381bb($2080c747322ae901$var$PRIORITY_VISUAL_GLOBAL, (0, $lbln3.seriesStyleTask));
$2080c747322ae901$export$5f32c1eb94c381bb($2080c747322ae901$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $lbln3.dataStyleTask));
$2080c747322ae901$export$5f32c1eb94c381bb($2080c747322ae901$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $lbln3.dataColorPaletteTask));
$2080c747322ae901$export$5f32c1eb94c381bb($2080c747322ae901$var$PRIORITY_VISUAL_GLOBAL, (0, $gvC19.seriesSymbolTask));
$2080c747322ae901$export$5f32c1eb94c381bb($2080c747322ae901$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $gvC19.dataSymbolTask));
$2080c747322ae901$export$5f32c1eb94c381bb($2080c747322ae901$var$PRIORITY_VISUAL_DECAL, (0, $8Ysvi.default));
$2080c747322ae901$export$77095792a057b768((0, $2D3oR.default));
$2080c747322ae901$export$d575e6557ac1729f($2080c747322ae901$var$PRIORITY_PROCESSOR_DATASTACK, (0, $aOkQp.default));
$2080c747322ae901$export$e06b68a82007c015('default', (0, $2QF9O.default));
// Default actions
$2080c747322ae901$export$408c24786cd729c6({
    type: (0, $bwPbQ.HIGHLIGHT_ACTION_TYPE),
    event: (0, $bwPbQ.HIGHLIGHT_ACTION_TYPE),
    update: (0, $bwPbQ.HIGHLIGHT_ACTION_TYPE)
}, (0, $2N6Uo.noop));
$2080c747322ae901$export$408c24786cd729c6({
    type: (0, $bwPbQ.DOWNPLAY_ACTION_TYPE),
    event: (0, $bwPbQ.DOWNPLAY_ACTION_TYPE),
    update: (0, $bwPbQ.DOWNPLAY_ACTION_TYPE)
}, (0, $2N6Uo.noop));
$2080c747322ae901$export$408c24786cd729c6({
    type: (0, $bwPbQ.SELECT_ACTION_TYPE),
    event: (0, $bwPbQ.SELECT_CHANGED_EVENT_TYPE),
    update: (0, $bwPbQ.SELECT_ACTION_TYPE),
    action: (0, $2N6Uo.noop),
    refineEvent: $2080c747322ae901$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$2080c747322ae901$export$408c24786cd729c6({
    type: (0, $bwPbQ.UNSELECT_ACTION_TYPE),
    event: (0, $bwPbQ.SELECT_CHANGED_EVENT_TYPE),
    update: (0, $bwPbQ.UNSELECT_ACTION_TYPE),
    action: (0, $2N6Uo.noop),
    refineEvent: $2080c747322ae901$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$2080c747322ae901$export$408c24786cd729c6({
    type: (0, $bwPbQ.TOGGLE_SELECT_ACTION_TYPE),
    event: (0, $bwPbQ.SELECT_CHANGED_EVENT_TYPE),
    update: (0, $bwPbQ.TOGGLE_SELECT_ACTION_TYPE),
    action: (0, $2N6Uo.noop),
    refineEvent: $2080c747322ae901$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
function $2080c747322ae901$var$makeSelectChangedEvent(actionResultBatch, payload, ecModel, api) {
    return {
        eventContent: {
            selected: (0, $bwPbQ.getAllSelectedIndices)(ecModel),
            isFromClick: payload.isFromClick || false
        }
    };
}
// Default theme, so that we can use `chart.setTheme('default')` to revert to
// the default theme after changing to other themes.
$2080c747322ae901$export$f9c59eed5de5ff80('default', {});
$2080c747322ae901$export$f9c59eed5de5ff80('dark', (0, $e0Ss6.default));
var $2080c747322ae901$export$73cae5e090579589 = {};

});
parcelRegister("9nEce", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $6d457130549a321b$export$a8ba968b8961cb8a; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6d457130549a321b$var$extendStatics = function(d, b) {
    $6d457130549a321b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6d457130549a321b$var$extendStatics(d, b);
};
function $6d457130549a321b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6d457130549a321b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6d457130549a321b$export$18ce0697a983be9b = function() {
    $6d457130549a321b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6d457130549a321b$export$18ce0697a983be9b.apply(this, arguments);
};
function $6d457130549a321b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6d457130549a321b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6d457130549a321b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6d457130549a321b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6d457130549a321b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6d457130549a321b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6d457130549a321b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6d457130549a321b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6d457130549a321b$export$45d3717a4c69092e(o, m, p);
}
function $6d457130549a321b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6d457130549a321b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6d457130549a321b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6d457130549a321b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6d457130549a321b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6d457130549a321b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $6d457130549a321b$export$10c90e4f7922046c(v) {
    return this instanceof $6d457130549a321b$export$10c90e4f7922046c ? (this.v = v, this) : new $6d457130549a321b$export$10c90e4f7922046c(v);
}
function $6d457130549a321b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6d457130549a321b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6d457130549a321b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6d457130549a321b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6d457130549a321b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6d457130549a321b$export$19a8beecd37a4c45 === "function" ? $6d457130549a321b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6d457130549a321b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6d457130549a321b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $6d457130549a321b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6d457130549a321b$export$45d3717a4c69092e(result, mod, k);
    }
    $6d457130549a321b$var$__setModuleDefault(result, mod);
    return result;
}
function $6d457130549a321b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6d457130549a321b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6d457130549a321b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}

});

parcelRegister("8rOrp", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $6267f8e1d7db9d52$export$2cd8252107eb640b; });
$parcel$export(module.exports, "registerPainter", function () { return $6267f8e1d7db9d52$export$a3e793ccb11823a5; });
$parcel$export(module.exports, "getElementSSRData", function () { return $6267f8e1d7db9d52$export$dd7015a5412ca583; });
$parcel$export(module.exports, "registerSSRDataGetter", function () { return $6267f8e1d7db9d52$export$e7a09d7fe68a4f7; });
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ 
var $cirKE = parcelRequire("cirKE");

var $2N6Uo = parcelRequire("2N6Uo");

var $fMnKO = parcelRequire("fMnKO");

var $7KlJD = parcelRequire("7KlJD");

var $k6F7i = parcelRequire("k6F7i");

var $8Dh3c = parcelRequire("8Dh3c");

var $3UxDF = parcelRequire("3UxDF");

var $4cadX = parcelRequire("4cadX");

var $iQonF = parcelRequire("iQonF");
var $6267f8e1d7db9d52$var$painterCtors = {};
var $6267f8e1d7db9d52$var$instances = {};
function $6267f8e1d7db9d52$var$delInstance(id) {
    delete $6267f8e1d7db9d52$var$instances[id];
}
function $6267f8e1d7db9d52$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $3UxDF.lum)(backgroundColor, 1) < (0, $4cadX.DARK_MODE_THRESHOLD);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $3UxDF.lum)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $4cadX.DARK_MODE_THRESHOLD);
    }
    return false;
}
var $6267f8e1d7db9d52$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $7KlJD.default)();
        var rendererType = opts.renderer || 'canvas';
        if (!$6267f8e1d7db9d52$var$painterCtors[rendererType]) rendererType = $2N6Uo.keys($6267f8e1d7db9d52$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $6267f8e1d7db9d52$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $cirKE.default).node && !(0, $cirKE.default).worker && !ssrMode ? new (0, $8Dh3c.default)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === 'auto' ? (0, $cirKE.default).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $2N6Uo.retrieve2(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $fMnKO.default)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $k6F7i.default)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(true);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $6267f8e1d7db9d52$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (this._disposed) return;
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = (0, $k6F7i.getTime)();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = (0, $k6F7i.getTime)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $iQonF.default)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $6267f8e1d7db9d52$var$delInstance(this.id);
    };
    return ZRender;
}();
function $6267f8e1d7db9d52$export$2cd8252107eb640b(dom, opts) {
    var zr = new $6267f8e1d7db9d52$var$ZRender($2N6Uo.guid(), dom, opts);
    $6267f8e1d7db9d52$var$instances[zr.id] = zr;
    return zr;
}
function $6267f8e1d7db9d52$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $6267f8e1d7db9d52$export$825f692fb04800ef() {
    for(var key in $6267f8e1d7db9d52$var$instances)if ($6267f8e1d7db9d52$var$instances.hasOwnProperty(key)) $6267f8e1d7db9d52$var$instances[key].dispose();
    $6267f8e1d7db9d52$var$instances = {};
}
function $6267f8e1d7db9d52$export$8bedcca5bbd73999(id) {
    return $6267f8e1d7db9d52$var$instances[id];
}
function $6267f8e1d7db9d52$export$a3e793ccb11823a5(name, Ctor) {
    $6267f8e1d7db9d52$var$painterCtors[name] = Ctor;
}
var $6267f8e1d7db9d52$var$ssrDataGetter;
function $6267f8e1d7db9d52$export$dd7015a5412ca583(el) {
    if (typeof $6267f8e1d7db9d52$var$ssrDataGetter === 'function') return $6267f8e1d7db9d52$var$ssrDataGetter(el);
}
function $6267f8e1d7db9d52$export$e7a09d7fe68a4f7(getter) {
    $6267f8e1d7db9d52$var$ssrDataGetter = getter;
}
var $6267f8e1d7db9d52$export$83d89fbfd8236492 = '6.0.0';

});
parcelRegister("cirKE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f3cb1576934e9ef$export$2e2bcd8739ae039; });
var $8f3cb1576934e9ef$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $8f3cb1576934e9ef$var$Env = function() {
    function Env() {
        this.browser = new $8f3cb1576934e9ef$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== 'undefined';
    }
    return Env;
}();
var $8f3cb1576934e9ef$var$env = new $8f3cb1576934e9ef$var$Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $8f3cb1576934e9ef$var$env.wxa = true;
    $8f3cb1576934e9ef$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') $8f3cb1576934e9ef$var$env.worker = true;
else if (!$8f3cb1576934e9ef$var$env.hasGlobalWindow || 'Deno' in window || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Node.js') > -1) {
    $8f3cb1576934e9ef$var$env.node = true;
    $8f3cb1576934e9ef$var$env.svgSupported = true;
} else $8f3cb1576934e9ef$var$detect(navigator.userAgent, $8f3cb1576934e9ef$var$env);
function $8f3cb1576934e9ef$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    var domSupported = env.domSupported = typeof document !== 'undefined';
    if (domSupported) {
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
}
var $8f3cb1576934e9ef$export$2e2bcd8739ae039 = $8f3cb1576934e9ef$var$env;

});

parcelRegister("2N6Uo", function(module, exports) {

$parcel$export(module.exports, "reduce", function () { return $20858445ad342068$export$533b26079ad0b4b; });
$parcel$export(module.exports, "guid", function () { return $20858445ad342068$export$46e8f25c7328f77e; });
$parcel$export(module.exports, "logError", function () { return $20858445ad342068$export$58da9968c3170cb1; });
$parcel$export(module.exports, "clone", function () { return $20858445ad342068$export$9cd59f9826255e47; });
$parcel$export(module.exports, "isDom", function () { return $20858445ad342068$export$9f57505b7bd8dae; });
$parcel$export(module.exports, "merge", function () { return $20858445ad342068$export$4950aa0f605343fb; });
$parcel$export(module.exports, "isObject", function () { return $20858445ad342068$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isArray", function () { return $20858445ad342068$export$43bee75e5e14138e; });
$parcel$export(module.exports, "mergeAll", function () { return $20858445ad342068$export$18aef43295bbe906; });
$parcel$export(module.exports, "extend", function () { return $20858445ad342068$export$8b58be045bf06082; });
$parcel$export(module.exports, "defaults", function () { return $20858445ad342068$export$ebe90cb607ad99e; });
$parcel$export(module.exports, "keys", function () { return $20858445ad342068$export$ed97f33186d4b816; });
$parcel$export(module.exports, "indexOf", function () { return $20858445ad342068$export$305f7d4e9d4624f2; });
$parcel$export(module.exports, "inherits", function () { return $20858445ad342068$export$69f1b2dcda23c5f8; });
$parcel$export(module.exports, "mixin", function () { return $20858445ad342068$export$e36fc9d62a853069; });
$parcel$export(module.exports, "isArrayLike", function () { return $20858445ad342068$export$1e2f57719e155213; });
$parcel$export(module.exports, "each", function () { return $20858445ad342068$export$79b2f7037acddd43; });
$parcel$export(module.exports, "map", function () { return $20858445ad342068$export$871de8747c9eaa88; });
$parcel$export(module.exports, "slice", function () { return $20858445ad342068$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "filter", function () { return $20858445ad342068$export$3dea766d36a8935f; });
$parcel$export(module.exports, "find", function () { return $20858445ad342068$export$71aa6c912b956294; });
$parcel$export(module.exports, "bind", function () { return $20858445ad342068$export$2385a24977818dd0; });
$parcel$export(module.exports, "isFunction", function () { return $20858445ad342068$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "curry", function () { return $20858445ad342068$export$c3095a23b368d1f2; });
$parcel$export(module.exports, "isString", function () { return $20858445ad342068$export$844ec244b1367d54; });
$parcel$export(module.exports, "isStringSafe", function () { return $20858445ad342068$export$29d0bb2a4e07b252; });
$parcel$export(module.exports, "isNumber", function () { return $20858445ad342068$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isTypedArray", function () { return $20858445ad342068$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "isGradientObject", function () { return $20858445ad342068$export$fa2c283003ed971c; });
$parcel$export(module.exports, "isImagePatternObject", function () { return $20858445ad342068$export$a49bbf3a55dcef7b; });
$parcel$export(module.exports, "isRegExp", function () { return $20858445ad342068$export$49841c62b9eff15; });
$parcel$export(module.exports, "eqNaN", function () { return $20858445ad342068$export$7d667b9a0c48c975; });
$parcel$export(module.exports, "retrieve", function () { return $20858445ad342068$export$8a4d17b6e8486e66; });
$parcel$export(module.exports, "retrieve2", function () { return $20858445ad342068$export$995e01f2f5c9d030; });
$parcel$export(module.exports, "retrieve3", function () { return $20858445ad342068$export$2e94551289abb95b; });
$parcel$export(module.exports, "normalizeCssArray", function () { return $20858445ad342068$export$f3a38102c49f4268; });
$parcel$export(module.exports, "assert", function () { return $20858445ad342068$export$a7a9523472993e97; });
$parcel$export(module.exports, "trim", function () { return $20858445ad342068$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "setAsPrimitive", function () { return $20858445ad342068$export$112e66431016387b; });
$parcel$export(module.exports, "createHashMap", function () { return $20858445ad342068$export$55f8aa7ef875b0a4; });
$parcel$export(module.exports, "concatArray", function () { return $20858445ad342068$export$4fd8af2c48c43416; });
$parcel$export(module.exports, "createObject", function () { return $20858445ad342068$export$79c7e160a7743efd; });
$parcel$export(module.exports, "disableUserSelect", function () { return $20858445ad342068$export$23a5d775868fdd2c; });
$parcel$export(module.exports, "hasOwn", function () { return $20858445ad342068$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "noop", function () { return $20858445ad342068$export$8793edee2d425525; });
$parcel$export(module.exports, "RADIAN_TO_DEGREE", function () { return $20858445ad342068$export$bce8e055322a0ce6; });

var $3WHoM = parcelRequire("3WHoM");
var $20858445ad342068$var$BUILTIN_OBJECT = $20858445ad342068$export$533b26079ad0b4b([
    'Function',
    'RegExp',
    'Date',
    'Error',
    'CanvasGradient',
    'CanvasPattern',
    'Image',
    'Canvas'
], function(obj, val) {
    obj['[object ' + val + ']'] = true;
    return obj;
}, {});
var $20858445ad342068$var$TYPED_ARRAY = $20858445ad342068$export$533b26079ad0b4b([
    'Int8',
    'Uint8',
    'Uint8Clamped',
    'Int16',
    'Uint16',
    'Int32',
    'Uint32',
    'Float32',
    'Float64'
], function(obj, val) {
    obj['[object ' + val + 'Array]'] = true;
    return obj;
}, {});
var $20858445ad342068$var$objToString = Object.prototype.toString;
var $20858445ad342068$var$arrayProto = Array.prototype;
var $20858445ad342068$var$nativeForEach = $20858445ad342068$var$arrayProto.forEach;
var $20858445ad342068$var$nativeFilter = $20858445ad342068$var$arrayProto.filter;
var $20858445ad342068$var$nativeSlice = $20858445ad342068$var$arrayProto.slice;
var $20858445ad342068$var$nativeMap = $20858445ad342068$var$arrayProto.map;
var $20858445ad342068$var$ctorFunction = (function() {}).constructor;
var $20858445ad342068$var$protoFunction = $20858445ad342068$var$ctorFunction ? $20858445ad342068$var$ctorFunction.prototype : null;
var $20858445ad342068$var$protoKey = '__proto__';
var $20858445ad342068$var$idStart = 0x0907;
function $20858445ad342068$export$46e8f25c7328f77e() {
    return $20858445ad342068$var$idStart++;
}
function $20858445ad342068$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $20858445ad342068$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== 'object') return source;
    var result = source;
    var typeStr = $20858445ad342068$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$20858445ad342068$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $20858445ad342068$export$9cd59f9826255e47(source[i]);
        }
    } else if ($20858445ad342068$var$TYPED_ARRAY[typeStr]) {
        if (!$20858445ad342068$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$20858445ad342068$var$BUILTIN_OBJECT[typeStr] && !$20858445ad342068$export$c3825b437cbdea5c(source) && !$20858445ad342068$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $20858445ad342068$var$protoKey) result[key] = $20858445ad342068$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $20858445ad342068$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$20858445ad342068$export$a6cdc56e425d0d0a(source) || !$20858445ad342068$export$a6cdc56e425d0d0a(target)) return overwrite ? $20858445ad342068$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $20858445ad342068$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($20858445ad342068$export$a6cdc56e425d0d0a(sourceProp) && $20858445ad342068$export$a6cdc56e425d0d0a(targetProp) && !$20858445ad342068$export$43bee75e5e14138e(sourceProp) && !$20858445ad342068$export$43bee75e5e14138e(targetProp) && !$20858445ad342068$export$9f57505b7bd8dae(sourceProp) && !$20858445ad342068$export$9f57505b7bd8dae(targetProp) && !$20858445ad342068$export$fa523b2c4941fd4f(sourceProp) && !$20858445ad342068$export$fa523b2c4941fd4f(targetProp) && !$20858445ad342068$export$c3825b437cbdea5c(sourceProp) && !$20858445ad342068$export$c3825b437cbdea5c(targetProp)) $20858445ad342068$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $20858445ad342068$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $20858445ad342068$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $20858445ad342068$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $20858445ad342068$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $20858445ad342068$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $20858445ad342068$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $20858445ad342068$export$ed97f33186d4b816(source);
    for(var i = 0, len = keysArr.length; i < len; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $20858445ad342068$export$cd3d1f114b139967 = (0, $3WHoM.platformApi).createCanvas;
function $20858445ad342068$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $20858445ad342068$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $20858445ad342068$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $20858445ad342068$export$ebe90cb607ad99e(target, source, override);
}
function $20858445ad342068$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $20858445ad342068$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $20858445ad342068$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $20858445ad342068$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $20858445ad342068$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $20858445ad342068$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $20858445ad342068$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $20858445ad342068$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $20858445ad342068$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $20858445ad342068$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $20858445ad342068$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $20858445ad342068$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $20858445ad342068$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($20858445ad342068$var$nativeSlice.call(arguments)));
    };
}
var $20858445ad342068$export$2385a24977818dd0 = $20858445ad342068$var$protoFunction && $20858445ad342068$export$f6e2535fb5126e54($20858445ad342068$var$protoFunction.bind) ? $20858445ad342068$var$protoFunction.call.bind($20858445ad342068$var$protoFunction.bind) : $20858445ad342068$var$bindPolyfill;
function $20858445ad342068$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($20858445ad342068$var$nativeSlice.call(arguments)));
    };
}
function $20858445ad342068$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $20858445ad342068$var$objToString.call(value) === '[object Array]';
}
function $20858445ad342068$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $20858445ad342068$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $20858445ad342068$export$29d0bb2a4e07b252(value) {
    return $20858445ad342068$var$objToString.call(value) === '[object String]';
}
function $20858445ad342068$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $20858445ad342068$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === 'function' || !!value && type === 'object';
}
function $20858445ad342068$export$fa523b2c4941fd4f(value) {
    return !!$20858445ad342068$var$BUILTIN_OBJECT[$20858445ad342068$var$objToString.call(value)];
}
function $20858445ad342068$export$b119cc7e1840e59c(value) {
    return !!$20858445ad342068$var$TYPED_ARRAY[$20858445ad342068$var$objToString.call(value)];
}
function $20858445ad342068$export$9f57505b7bd8dae(value) {
    return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
function $20858445ad342068$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $20858445ad342068$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $20858445ad342068$export$49841c62b9eff15(value) {
    return $20858445ad342068$var$objToString.call(value) === '[object RegExp]';
}
function $20858445ad342068$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $20858445ad342068$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $20858445ad342068$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $20858445ad342068$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $20858445ad342068$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $20858445ad342068$var$nativeSlice.apply(arr, args);
}
function $20858445ad342068$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $20858445ad342068$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $20858445ad342068$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $20858445ad342068$var$primitiveKey = '__ec_primitive__';
function $20858445ad342068$export$112e66431016387b(obj) {
    obj[$20858445ad342068$var$primitiveKey] = true;
}
function $20858445ad342068$export$c3825b437cbdea5c(obj) {
    return obj[$20858445ad342068$var$primitiveKey];
}
var $20858445ad342068$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $20858445ad342068$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $20858445ad342068$var$isNativeMapSupported = typeof Map === 'function';
function $20858445ad342068$var$maybeNativeMap() {
    return $20858445ad342068$var$isNativeMapSupported ? new Map() : new $20858445ad342068$var$MapPolyfill();
}
var $20858445ad342068$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $20858445ad342068$export$43bee75e5e14138e(obj);
        this.data = $20858445ad342068$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $20858445ad342068$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $20858445ad342068$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $20858445ad342068$export$55f8aa7ef875b0a4(obj) {
    return new $20858445ad342068$export$60ef0b43d585640a(obj);
}
function $20858445ad342068$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $20858445ad342068$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $20858445ad342068$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $20858445ad342068$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = 'none';
    domStyle.userSelect = 'none';
    domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
    domStyle['-webkit-touch-callout'] = 'none';
}
function $20858445ad342068$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $20858445ad342068$export$8793edee2d425525() {}
var $20858445ad342068$export$bce8e055322a0ce6 = 180 / Math.PI;
var $20858445ad342068$export$fd293b15f47e270 = Number.EPSILON || Math.pow(2, -52);

});
parcelRegister("3WHoM", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FONT_SIZE", function () { return $2df873f12d530033$export$b1461457ea2c1179; });
$parcel$export(module.exports, "DEFAULT_FONT_FAMILY", function () { return $2df873f12d530033$export$2653e0d5dd45b294; });
$parcel$export(module.exports, "DEFAULT_FONT", function () { return $2df873f12d530033$export$7d7a232b6d2cc80c; });
$parcel$export(module.exports, "platformApi", function () { return $2df873f12d530033$export$ef5e599365494451; });
$parcel$export(module.exports, "setPlatformAPI", function () { return $2df873f12d530033$export$61bcfd79465c1b7c; });
var $2df873f12d530033$export$b1461457ea2c1179 = 12;
var $2df873f12d530033$export$2653e0d5dd45b294 = 'sans-serif';
var $2df873f12d530033$export$7d7a232b6d2cc80c = $2df873f12d530033$export$b1461457ea2c1179 + "px " + $2df873f12d530033$export$2653e0d5dd45b294;
var $2df873f12d530033$var$OFFSET = 20;
var $2df873f12d530033$var$SCALE = 100;
var $2df873f12d530033$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $2df873f12d530033$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === 'undefined') return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $2df873f12d530033$var$OFFSET) / $2df873f12d530033$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $2df873f12d530033$export$69462fcc6bf851a4 = $2df873f12d530033$var$getTextWidthMap($2df873f12d530033$var$defaultWidthMapStr);
var $2df873f12d530033$export$ef5e599365494451 = {
    createCanvas: function() {
        return typeof document !== 'undefined' && document.createElement('canvas');
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $2df873f12d530033$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext('2d');
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $2df873f12d530033$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || '';
                font = font || $2df873f12d530033$export$7d7a232b6d2cc80c;
                var res = /((?:\d+)?\.?\d*)px/.exec(font);
                var fontSize = res && +res[1] || $2df873f12d530033$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf('mono') >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $2df873f12d530033$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function $2df873f12d530033$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $2df873f12d530033$export$ef5e599365494451)if (newPlatformApis[key]) $2df873f12d530033$export$ef5e599365494451[key] = newPlatformApis[key];
}

});


parcelRegister("fMnKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7cdc3c4a9a4b5bd$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $U1aqY = parcelRequire("U1aqY");

var $dFHOQ = parcelRequire("dFHOQ");

var $5Uet9 = parcelRequire("5Uet9");

var $pGNPI = parcelRequire("pGNPI");

var $9isZy = parcelRequire("9isZy");

var $67W72 = parcelRequire("67W72");
var $b7cdc3c4a9a4b5bd$var$SILENT = 'silent';
function $b7cdc3c4a9a4b5bd$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $b7cdc3c4a9a4b5bd$var$stopEvent
    };
}
function $b7cdc3c4a9a4b5bd$var$stopEvent() {
    $pGNPI.stop(this.event);
}
var $b7cdc3c4a9a4b5bd$var$EmptyProxy = function(_super) {
    (0, $9nEce.__extends)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $5Uet9.default));
var $b7cdc3c4a9a4b5bd$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $b7cdc3c4a9a4b5bd$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $b7cdc3c4a9a4b5bd$var$tmpRect = new (0, $67W72.default)(0, 0, 0, 0);
var $b7cdc3c4a9a4b5bd$var$Handler = function(_super) {
    (0, $9nEce.__extends)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $b7cdc3c4a9a4b5bd$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $b7cdc3c4a9a4b5bd$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $dFHOQ.default)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $2N6Uo.each($b7cdc3c4a9a4b5bd$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b7cdc3c4a9a4b5bd$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $b7cdc3c4a9a4b5bd$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $b7cdc3c4a9a4b5bd$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $b7cdc3c4a9a4b5bd$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $b7cdc3c4a9a4b5bd$var$HoveredResult(x, y);
        $b7cdc3c4a9a4b5bd$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $67W72.default)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $b7cdc3c4a9a4b5bd$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $b7cdc3c4a9a4b5bd$var$tmpRect.applyTransform(el.transform);
                    if ($b7cdc3c4a9a4b5bd$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $b7cdc3c4a9a4b5bd$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $9isZy.GestureMgr)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $b7cdc3c4a9a4b5bd$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $5Uet9.default));
$2N6Uo.each([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $b7cdc3c4a9a4b5bd$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b7cdc3c4a9a4b5bd$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $U1aqY.dist(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $b7cdc3c4a9a4b5bd$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return isSilent ? $b7cdc3c4a9a4b5bd$var$SILENT : true;
    }
    return false;
}
function $b7cdc3c4a9a4b5bd$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $b7cdc3c4a9a4b5bd$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $b7cdc3c4a9a4b5bd$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $b7cdc3c4a9a4b5bd$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $b7cdc3c4a9a4b5bd$export$2e2bcd8739ae039 = $b7cdc3c4a9a4b5bd$var$Handler;

});
parcelRegister("U1aqY", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $0a8622e0831bdea3$export$185802fd694ee1f5; });
$parcel$export(module.exports, "copy", function () { return $0a8622e0831bdea3$export$784d13d8ee351f07; });
$parcel$export(module.exports, "clone", function () { return $0a8622e0831bdea3$export$9cd59f9826255e47; });
$parcel$export(module.exports, "set", function () { return $0a8622e0831bdea3$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "add", function () { return $0a8622e0831bdea3$export$e16d8520af44a096; });
$parcel$export(module.exports, "scaleAndAdd", function () { return $0a8622e0831bdea3$export$19cedf1da84ba854; });
$parcel$export(module.exports, "sub", function () { return $0a8622e0831bdea3$export$f93b5905241a7cca; });
$parcel$export(module.exports, "len", function () { return $0a8622e0831bdea3$export$fc1400facf92c78; });
$parcel$export(module.exports, "scale", function () { return $0a8622e0831bdea3$export$dcdf75081b88279d; });
$parcel$export(module.exports, "normalize", function () { return $0a8622e0831bdea3$export$a3295358bff77e; });
$parcel$export(module.exports, "distance", function () { return $0a8622e0831bdea3$export$9f17032d917177de; });
$parcel$export(module.exports, "dist", function () { return $0a8622e0831bdea3$export$6c4a311cc157c764; });
$parcel$export(module.exports, "distSquare", function () { return $0a8622e0831bdea3$export$c68db45a034c13b0; });
$parcel$export(module.exports, "lerp", function () { return $0a8622e0831bdea3$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "applyTransform", function () { return $0a8622e0831bdea3$export$9f9dcb98c894b623; });
$parcel$export(module.exports, "min", function () { return $0a8622e0831bdea3$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $0a8622e0831bdea3$export$8960430cfd85939f; });
function $0a8622e0831bdea3$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $0a8622e0831bdea3$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $0a8622e0831bdea3$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $0a8622e0831bdea3$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $0a8622e0831bdea3$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $0a8622e0831bdea3$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $0a8622e0831bdea3$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $0a8622e0831bdea3$export$fc1400facf92c78(v) {
    return Math.sqrt($0a8622e0831bdea3$export$48e33bc611e4c25a(v));
}
var $0a8622e0831bdea3$export$f24224f1c91d8156 = $0a8622e0831bdea3$export$fc1400facf92c78;
function $0a8622e0831bdea3$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $0a8622e0831bdea3$export$2f106540dd9a5136 = $0a8622e0831bdea3$export$48e33bc611e4c25a;
function $0a8622e0831bdea3$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $0a8622e0831bdea3$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $0a8622e0831bdea3$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $0a8622e0831bdea3$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $0a8622e0831bdea3$export$a3295358bff77e(out, v) {
    var d = $0a8622e0831bdea3$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $0a8622e0831bdea3$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $0a8622e0831bdea3$export$6c4a311cc157c764 = $0a8622e0831bdea3$export$9f17032d917177de;
function $0a8622e0831bdea3$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $0a8622e0831bdea3$export$c68db45a034c13b0 = $0a8622e0831bdea3$export$137c0a69d1ff4a79;
function $0a8622e0831bdea3$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $0a8622e0831bdea3$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $0a8622e0831bdea3$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $0a8622e0831bdea3$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $0a8622e0831bdea3$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}

});

parcelRegister("dFHOQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f41183f1f64140b$export$2e2bcd8739ae039; });
var $9f41183f1f64140b$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $9f41183f1f64140b$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $9f41183f1f64140b$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $9f41183f1f64140b$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $9f41183f1f64140b$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $9f41183f1f64140b$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $9f41183f1f64140b$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $9f41183f1f64140b$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $9f41183f1f64140b$export$2e2bcd8739ae039 = $9f41183f1f64140b$var$Draggable;

});

parcelRegister("5Uet9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44cd67f850df1a1f$export$2e2bcd8739ae039; });
var $44cd67f850df1a1f$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $44cd67f850df1a1f$export$2e2bcd8739ae039 = $44cd67f850df1a1f$var$Eventful;

});

parcelRegister("pGNPI", function(module, exports) {

$parcel$export(module.exports, "clientToLocal", function () { return $04d389a6a5d24cfa$export$7d5fecde839eee88; });
$parcel$export(module.exports, "getNativeEvent", function () { return $04d389a6a5d24cfa$export$4abe0e945399ac1d; });
$parcel$export(module.exports, "normalizeEvent", function () { return $04d389a6a5d24cfa$export$40fadb093aebad71; });
$parcel$export(module.exports, "addEventListener", function () { return $04d389a6a5d24cfa$export$3f65cefe8380dbea; });
$parcel$export(module.exports, "removeEventListener", function () { return $04d389a6a5d24cfa$export$8ff9f68337b520c0; });
$parcel$export(module.exports, "stop", function () { return $04d389a6a5d24cfa$export$fa6813432f753b0d; });
$parcel$export(module.exports, "isMiddleOrRightButtonOnMouseUpDown", function () { return $04d389a6a5d24cfa$export$b7ae4cded3e71bd2; });


var $cirKE = parcelRequire("cirKE");

var $dhQnW = parcelRequire("dhQnW");
var $04d389a6a5d24cfa$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $04d389a6a5d24cfa$var$_calcOut = [];
var $04d389a6a5d24cfa$var$firefoxNotSupportOffsetXY = (0, $cirKE.default).browser.firefox && +(0, $cirKE.default).browser.version.split('.')[0] < 39;
function $04d389a6a5d24cfa$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $04d389a6a5d24cfa$var$calculateZrXY(el, e, out);
    else if ($04d389a6a5d24cfa$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $04d389a6a5d24cfa$var$calculateZrXY(el, e, out);
    return out;
}
function $04d389a6a5d24cfa$var$calculateZrXY(el, e, out) {
    if ((0, $cirKE.default).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $dhQnW.isCanvasEl)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $dhQnW.transformCoordWithViewport)($04d389a6a5d24cfa$var$_calcOut, el, ex, ey)) {
            out.zrX = $04d389a6a5d24cfa$var$_calcOut[0];
            out.zrY = $04d389a6a5d24cfa$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $04d389a6a5d24cfa$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $04d389a6a5d24cfa$export$40fadb093aebad71(el, e, calculate) {
    e = $04d389a6a5d24cfa$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $04d389a6a5d24cfa$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $04d389a6a5d24cfa$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $04d389a6a5d24cfa$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $04d389a6a5d24cfa$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $04d389a6a5d24cfa$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $04d389a6a5d24cfa$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $04d389a6a5d24cfa$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $04d389a6a5d24cfa$export$fa6813432f753b0d = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $04d389a6a5d24cfa$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}

});
parcelRegister("dhQnW", function(module, exports) {

$parcel$export(module.exports, "transformLocalCoord", function () { return $9ac57f7da44c0b7d$export$8c5c02e118307e20; });
$parcel$export(module.exports, "transformCoordWithViewport", function () { return $9ac57f7da44c0b7d$export$1219648acc517df4; });
$parcel$export(module.exports, "transformLocalCoordClear", function () { return $9ac57f7da44c0b7d$export$a29dbe4b7d3cd586; });
$parcel$export(module.exports, "isCanvasEl", function () { return $9ac57f7da44c0b7d$export$1b92e4fe606eff6d; });
$parcel$export(module.exports, "encodeHTML", function () { return $9ac57f7da44c0b7d$export$f9d6449b9af28dc1; });

var $cirKE = parcelRequire("cirKE");

var $fVtfL = parcelRequire("fVtfL");

var $2N6Uo = parcelRequire("2N6Uo");
var $9ac57f7da44c0b7d$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $9ac57f7da44c0b7d$var$_calcOut = [];
function $9ac57f7da44c0b7d$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $9ac57f7da44c0b7d$export$1219648acc517df4($9ac57f7da44c0b7d$var$_calcOut, elFrom, inX, inY, true) && $9ac57f7da44c0b7d$export$1219648acc517df4(out, elTarget, $9ac57f7da44c0b7d$var$_calcOut[0], $9ac57f7da44c0b7d$var$_calcOut[1]);
}
function $9ac57f7da44c0b7d$export$a29dbe4b7d3cd586(elFrom, elTarget) {
    elFrom && dealClear(elFrom);
    elTarget && dealClear(elTarget);
    function dealClear(el) {
        var saved = el[$9ac57f7da44c0b7d$var$EVENT_SAVED_PROP];
        if (saved) {
            saved.clearMarkers && saved.clearMarkers();
            delete el[$9ac57f7da44c0b7d$var$EVENT_SAVED_PROP];
        }
    }
}
function $9ac57f7da44c0b7d$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $cirKE.default).domSupported && !$9ac57f7da44c0b7d$export$1b92e4fe606eff6d(el)) {
        var saved = el[$9ac57f7da44c0b7d$var$EVENT_SAVED_PROP] || (el[$9ac57f7da44c0b7d$var$EVENT_SAVED_PROP] = {});
        var markers = $9ac57f7da44c0b7d$var$prepareCoordMarkers(el, saved);
        var transformer = $9ac57f7da44c0b7d$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $9ac57f7da44c0b7d$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    saved.clearMarkers = function() {
        (0, $2N6Uo.each)(markers, function(marker) {
            marker.parentNode && marker.parentNode.removeChild(marker);
        });
    };
    return markers;
}
function $9ac57f7da44c0b7d$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $fVtfL.buildTransformer)(destCoords, srcCoords) : (0, $fVtfL.buildTransformer)(srcCoords, destCoords));
}
function $9ac57f7da44c0b7d$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}
var $9ac57f7da44c0b7d$var$replaceReg = /([&<>"'])/g;
var $9ac57f7da44c0b7d$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $9ac57f7da44c0b7d$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($9ac57f7da44c0b7d$var$replaceReg, function(str, c) {
        return $9ac57f7da44c0b7d$var$replaceMap[c];
    });
}

});
parcelRegister("fVtfL", function(module, exports) {

$parcel$export(module.exports, "buildTransformer", function () { return $b982def3732116e3$export$fbdb2748a8171a7e; });
var $b982def3732116e3$var$LN2 = Math.log(2);
function $b982def3732116e3$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $b982def3732116e3$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $b982def3732116e3$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $b982def3732116e3$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $b982def3732116e3$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $b982def3732116e3$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}

});



parcelRegister("9isZy", function(module, exports) {

$parcel$export(module.exports, "GestureMgr", function () { return $6c4c48a6a369c2a3$export$f7557d6f27e9503; });

var $pGNPI = parcelRequire("pGNPI");
var $6c4c48a6a369c2a3$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $pGNPI.clientToLocal(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $6c4c48a6a369c2a3$var$recognizers)if ($6c4c48a6a369c2a3$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $6c4c48a6a369c2a3$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $6c4c48a6a369c2a3$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $6c4c48a6a369c2a3$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $6c4c48a6a369c2a3$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $6c4c48a6a369c2a3$var$dist(pinchEnd) / $6c4c48a6a369c2a3$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $6c4c48a6a369c2a3$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};

});

parcelRegister("67W72", function(module, exports) {

$parcel$export(module.exports, "createIntersectContext", function () { return $4760797be1329c87$export$a0be2bdbd2369e0e; });
$parcel$export(module.exports, "default", function () { return $4760797be1329c87$export$2e2bcd8739ae039; });

var $19Ywy = parcelRequire("19Ywy");

var $9KN3M = parcelRequire("9KN3M");
var $4760797be1329c87$var$mathMin = Math.min;
var $4760797be1329c87$var$mathMax = Math.max;
var $4760797be1329c87$var$mathAbs = Math.abs;
var $4760797be1329c87$var$XY = [
    'x',
    'y'
];
var $4760797be1329c87$var$WH = [
    'width',
    'height'
];
var $4760797be1329c87$var$lt = new (0, $9KN3M.default)();
var $4760797be1329c87$var$rb = new (0, $9KN3M.default)();
var $4760797be1329c87$var$lb = new (0, $9KN3M.default)();
var $4760797be1329c87$var$rt = new (0, $9KN3M.default)();
var $4760797be1329c87$var$_intersectCtx = $4760797be1329c87$export$a0be2bdbd2369e0e();
var $4760797be1329c87$var$_minTv = $4760797be1329c87$var$_intersectCtx.minTv;
var $4760797be1329c87$var$_maxTv = $4760797be1329c87$var$_intersectCtx.maxTv;
var $4760797be1329c87$var$_lenMinMax = [
    0,
    0
];
var $4760797be1329c87$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        BoundingRect.set(this, x, y, width, height);
    }
    BoundingRect.set = function(target, x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        target.x = x;
        target.y = y;
        target.width = width;
        target.height = height;
        return target;
    };
    BoundingRect.prototype.union = function(other) {
        var x = $4760797be1329c87$var$mathMin(other.x, this.x);
        var y = $4760797be1329c87$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $4760797be1329c87$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $4760797be1329c87$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $19Ywy.create();
        $19Ywy.translate(m, m, [
            -a.x,
            -a.y
        ]);
        $19Ywy.scale(m, m, [
            sx,
            sy
        ]);
        $19Ywy.translate(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv, opt) {
        return BoundingRect.intersect(this, b, mtv, opt);
    };
    BoundingRect.intersect = function(a, b, mtv, opt) {
        if (mtv) (0, $9KN3M.default).set(mtv, 0, 0);
        var outIntersectRect = opt && opt.outIntersectRect || null;
        var clamp = opt && opt.clamp;
        if (outIntersectRect) outIntersectRect.x = outIntersectRect.y = outIntersectRect.width = outIntersectRect.height = NaN;
        if (!a || !b) return false;
        if (!(a instanceof BoundingRect)) a = BoundingRect.set($4760797be1329c87$var$_tmpIntersectA, a.x, a.y, a.width, a.height);
        if (!(b instanceof BoundingRect)) b = BoundingRect.set($4760797be1329c87$var$_tmpIntersectB, b.x, b.y, b.width, b.height);
        var useMTV = !!mtv;
        $4760797be1329c87$var$_intersectCtx.reset(opt, useMTV);
        var touchThreshold = $4760797be1329c87$var$_intersectCtx.touchThreshold;
        var ax0 = a.x + touchThreshold;
        var ax1 = a.x + a.width - touchThreshold;
        var ay0 = a.y + touchThreshold;
        var ay1 = a.y + a.height - touchThreshold;
        var bx0 = b.x + touchThreshold;
        var bx1 = b.x + b.width - touchThreshold;
        var by0 = b.y + touchThreshold;
        var by1 = b.y + b.height - touchThreshold;
        if (ax0 > ax1 || ay0 > ay1 || bx0 > bx1 || by0 > by1) return false;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (useMTV || outIntersectRect) {
            $4760797be1329c87$var$_lenMinMax[0] = Infinity;
            $4760797be1329c87$var$_lenMinMax[1] = 0;
            $4760797be1329c87$var$intersectOneDim(ax0, ax1, bx0, bx1, 0, useMTV, outIntersectRect, clamp);
            $4760797be1329c87$var$intersectOneDim(ay0, ay1, by0, by1, 1, useMTV, outIntersectRect, clamp);
            if (useMTV) (0, $9KN3M.default).copy(mtv, overlap ? $4760797be1329c87$var$_intersectCtx.useDir ? $4760797be1329c87$var$_intersectCtx.dirMinTv : $4760797be1329c87$var$_minTv : $4760797be1329c87$var$_maxTv);
        }
        return overlap;
    };
    BoundingRect.contain = function(rect, x, y) {
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.contain = function(x, y) {
        return BoundingRect.contain(this, x, y);
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
        return target;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $4760797be1329c87$var$lt.x = $4760797be1329c87$var$lb.x = source.x;
        $4760797be1329c87$var$lt.y = $4760797be1329c87$var$rt.y = source.y;
        $4760797be1329c87$var$rb.x = $4760797be1329c87$var$rt.x = source.x + source.width;
        $4760797be1329c87$var$rb.y = $4760797be1329c87$var$lb.y = source.y + source.height;
        $4760797be1329c87$var$lt.transform(m);
        $4760797be1329c87$var$rt.transform(m);
        $4760797be1329c87$var$rb.transform(m);
        $4760797be1329c87$var$lb.transform(m);
        target.x = $4760797be1329c87$var$mathMin($4760797be1329c87$var$lt.x, $4760797be1329c87$var$rb.x, $4760797be1329c87$var$lb.x, $4760797be1329c87$var$rt.x);
        target.y = $4760797be1329c87$var$mathMin($4760797be1329c87$var$lt.y, $4760797be1329c87$var$rb.y, $4760797be1329c87$var$lb.y, $4760797be1329c87$var$rt.y);
        var maxX = $4760797be1329c87$var$mathMax($4760797be1329c87$var$lt.x, $4760797be1329c87$var$rb.x, $4760797be1329c87$var$lb.x, $4760797be1329c87$var$rt.x);
        var maxY = $4760797be1329c87$var$mathMax($4760797be1329c87$var$lt.y, $4760797be1329c87$var$rb.y, $4760797be1329c87$var$lb.y, $4760797be1329c87$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $4760797be1329c87$var$_tmpIntersectA = new $4760797be1329c87$var$BoundingRect(0, 0, 0, 0);
var $4760797be1329c87$var$_tmpIntersectB = new $4760797be1329c87$var$BoundingRect(0, 0, 0, 0);
function $4760797be1329c87$var$intersectOneDim(a0, a1, b0, b1, updateDimIdx, useMTV, outIntersectRect, clamp) {
    var d0 = $4760797be1329c87$var$mathAbs(a1 - b0);
    var d1 = $4760797be1329c87$var$mathAbs(b1 - a0);
    var d01min = $4760797be1329c87$var$mathMin(d0, d1);
    var updateDim = $4760797be1329c87$var$XY[updateDimIdx];
    var zeroDim = $4760797be1329c87$var$XY[1 - updateDimIdx];
    var wh = $4760797be1329c87$var$WH[updateDimIdx];
    if (a1 < b0 || b1 < a0) {
        if (d0 < d1) {
            if (useMTV) $4760797be1329c87$var$_maxTv[updateDim] = -d0;
            if (clamp) {
                outIntersectRect[updateDim] = a1;
                outIntersectRect[wh] = 0;
            }
        } else {
            if (useMTV) $4760797be1329c87$var$_maxTv[updateDim] = d1;
            if (clamp) {
                outIntersectRect[updateDim] = a0;
                outIntersectRect[wh] = 0;
            }
        }
    } else {
        if (outIntersectRect) {
            outIntersectRect[updateDim] = $4760797be1329c87$var$mathMax(a0, b0);
            outIntersectRect[wh] = $4760797be1329c87$var$mathMin(a1, b1) - outIntersectRect[updateDim];
        }
        if (useMTV) {
            if (d01min < $4760797be1329c87$var$_lenMinMax[0] || $4760797be1329c87$var$_intersectCtx.useDir) {
                $4760797be1329c87$var$_lenMinMax[0] = $4760797be1329c87$var$mathMin(d01min, $4760797be1329c87$var$_lenMinMax[0]);
                if (d0 < d1 || !$4760797be1329c87$var$_intersectCtx.bidirectional) {
                    $4760797be1329c87$var$_minTv[updateDim] = d0;
                    $4760797be1329c87$var$_minTv[zeroDim] = 0;
                    if ($4760797be1329c87$var$_intersectCtx.useDir) $4760797be1329c87$var$_intersectCtx.calcDirMTV();
                }
                if (d0 >= d1 || !$4760797be1329c87$var$_intersectCtx.bidirectional) {
                    $4760797be1329c87$var$_minTv[updateDim] = -d1;
                    $4760797be1329c87$var$_minTv[zeroDim] = 0;
                    if ($4760797be1329c87$var$_intersectCtx.useDir) $4760797be1329c87$var$_intersectCtx.calcDirMTV();
                }
            }
        }
    }
}
function $4760797be1329c87$export$a0be2bdbd2369e0e() {
    var _direction = 0;
    var _dirCheckVec = new (0, $9KN3M.default)();
    var _dirTmp = new (0, $9KN3M.default)();
    var _ctx = {
        minTv: new (0, $9KN3M.default)(),
        maxTv: new (0, $9KN3M.default)(),
        useDir: false,
        dirMinTv: new (0, $9KN3M.default)(),
        touchThreshold: 0,
        bidirectional: true,
        negativeSize: false,
        reset: function(opt, useMTV) {
            _ctx.touchThreshold = 0;
            if (opt && opt.touchThreshold != null) _ctx.touchThreshold = $4760797be1329c87$var$mathMax(0, opt.touchThreshold);
            _ctx.negativeSize = false;
            if (!useMTV) return;
            _ctx.minTv.set(Infinity, Infinity);
            _ctx.maxTv.set(0, 0);
            _ctx.useDir = false;
            if (opt && opt.direction != null) {
                _ctx.useDir = true;
                _ctx.dirMinTv.copy(_ctx.minTv);
                _dirTmp.copy(_ctx.minTv);
                _direction = opt.direction;
                _ctx.bidirectional = opt.bidirectional == null || !!opt.bidirectional;
                if (!_ctx.bidirectional) _dirCheckVec.set(Math.cos(_direction), Math.sin(_direction));
            }
        },
        calcDirMTV: function() {
            var minTv = _ctx.minTv;
            var dirMinTv = _ctx.dirMinTv;
            var squareMag = minTv.y * minTv.y + minTv.x * minTv.x;
            var dirSin = Math.sin(_direction);
            var dirCos = Math.cos(_direction);
            var dotProd = dirSin * minTv.y + dirCos * minTv.x;
            if (nearZero(dotProd)) {
                if (nearZero(minTv.x) && nearZero(minTv.y)) dirMinTv.set(0, 0);
                return;
            }
            _dirTmp.x = squareMag * dirCos / dotProd;
            _dirTmp.y = squareMag * dirSin / dotProd;
            if (nearZero(_dirTmp.x) && nearZero(_dirTmp.y)) {
                dirMinTv.set(0, 0);
                return;
            }
            if ((_ctx.bidirectional || _dirCheckVec.dot(_dirTmp) > 0) && _dirTmp.len() < dirMinTv.len()) dirMinTv.copy(_dirTmp);
        }
    };
    function nearZero(val) {
        return $4760797be1329c87$var$mathAbs(val) < 1e-10;
    }
    return _ctx;
}
var $4760797be1329c87$export$2e2bcd8739ae039 = $4760797be1329c87$var$BoundingRect;

});
parcelRegister("19Ywy", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $0d859480eda428f4$export$185802fd694ee1f5; });
$parcel$export(module.exports, "identity", function () { return $0d859480eda428f4$export$f0954fd7d5368655; });
$parcel$export(module.exports, "copy", function () { return $0d859480eda428f4$export$784d13d8ee351f07; });
$parcel$export(module.exports, "mul", function () { return $0d859480eda428f4$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "translate", function () { return $0d859480eda428f4$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "rotate", function () { return $0d859480eda428f4$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "scale", function () { return $0d859480eda428f4$export$dcdf75081b88279d; });
$parcel$export(module.exports, "invert", function () { return $0d859480eda428f4$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "clone", function () { return $0d859480eda428f4$export$9cd59f9826255e47; });
function $0d859480eda428f4$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $0d859480eda428f4$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $0d859480eda428f4$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $0d859480eda428f4$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $0d859480eda428f4$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $0d859480eda428f4$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $0d859480eda428f4$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $0d859480eda428f4$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $0d859480eda428f4$export$9cd59f9826255e47(a) {
    var b = $0d859480eda428f4$export$185802fd694ee1f5();
    $0d859480eda428f4$export$784d13d8ee351f07(b, a);
    return b;
}

});

parcelRegister("9KN3M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $719e773efa9de340$export$2e2bcd8739ae039; });
var $719e773efa9de340$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $719e773efa9de340$export$2e2bcd8739ae039 = $719e773efa9de340$var$Point;

});



parcelRegister("7KlJD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a3db0698ac79afb$export$2e2bcd8739ae039; });

var $2N6Uo = parcelRequire("2N6Uo");

var $bPBpF = parcelRequire("bPBpF");

var $fde2h = parcelRequire("fde2h");
var $5a3db0698ac79afb$var$invalidZErrorLogged = false;
function $5a3db0698ac79afb$var$logInvalidZError() {
    if ($5a3db0698ac79afb$var$invalidZErrorLogged) return;
    $5a3db0698ac79afb$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $5a3db0698ac79afb$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $5a3db0698ac79afb$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $5a3db0698ac79afb$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $bPBpF.default)(displayList, $5a3db0698ac79afb$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, parentClipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        var parentHasClipPaths = parentClipPaths && parentClipPaths.length;
        var clipPathIdx = 0;
        var thisClipPaths = el.__clipPaths;
        if (!el.ignoreClip && (parentHasClipPaths || userSetClipPath)) {
            if (!thisClipPaths) thisClipPaths = el.__clipPaths = [];
            if (parentHasClipPaths) for(var idx = 0; idx < parentClipPaths.length; idx++)thisClipPaths[clipPathIdx++] = parentClipPaths[idx];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                thisClipPaths[clipPathIdx++] = currentClipPath;
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (thisClipPaths) thisClipPaths.length = clipPathIdx;
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $fde2h.REDRAW_BIT);
                this._updateAndAddDisplayable(child, thisClipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (isNaN(disp.z)) {
                $5a3db0698ac79afb$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $5a3db0698ac79afb$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $5a3db0698ac79afb$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, thisClipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, thisClipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, thisClipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $2N6Uo.indexOf(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $5a3db0698ac79afb$export$2e2bcd8739ae039 = $5a3db0698ac79afb$var$Storage;

});
parcelRegister("bPBpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89d17a9617e3c833$export$2e2bcd8739ae039; });
var $89d17a9617e3c833$var$DEFAULT_MIN_MERGE = 32;
var $89d17a9617e3c833$var$DEFAULT_MIN_GALLOPING = 7;
function $89d17a9617e3c833$var$minRunLength(n) {
    var r = 0;
    while(n >= $89d17a9617e3c833$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $89d17a9617e3c833$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $89d17a9617e3c833$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $89d17a9617e3c833$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $89d17a9617e3c833$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $89d17a9617e3c833$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $89d17a9617e3c833$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $89d17a9617e3c833$var$TimSort(array, compare) {
    var minGallop = $89d17a9617e3c833$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $89d17a9617e3c833$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $89d17a9617e3c833$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $89d17a9617e3c833$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $89d17a9617e3c833$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $89d17a9617e3c833$var$DEFAULT_MIN_GALLOPING || count2 >= $89d17a9617e3c833$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $89d17a9617e3c833$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $89d17a9617e3c833$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $89d17a9617e3c833$var$DEFAULT_MIN_GALLOPING || count2 >= $89d17a9617e3c833$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $89d17a9617e3c833$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $89d17a9617e3c833$var$DEFAULT_MIN_MERGE) {
        runLength = $89d17a9617e3c833$var$makeAscendingRun(array, lo, hi, compare);
        $89d17a9617e3c833$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $89d17a9617e3c833$var$TimSort(array, compare);
    var minRun = $89d17a9617e3c833$var$minRunLength(remaining);
    do {
        runLength = $89d17a9617e3c833$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $89d17a9617e3c833$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}

});

parcelRegister("fde2h", function(module, exports) {

$parcel$export(module.exports, "REDRAW_BIT", function () { return $b132f520628e1a11$export$a7b6db622c6c7dbd; });
$parcel$export(module.exports, "STYLE_CHANGED_BIT", function () { return $b132f520628e1a11$export$ada8b2beb3d76671; });
$parcel$export(module.exports, "SHAPE_CHANGED_BIT", function () { return $b132f520628e1a11$export$f75fe89a33ebe115; });
var $b132f520628e1a11$export$a7b6db622c6c7dbd = 1;
var $b132f520628e1a11$export$ada8b2beb3d76671 = 2;
var $b132f520628e1a11$export$f75fe89a33ebe115 = 4;

});


parcelRegister("k6F7i", function(module, exports) {

$parcel$export(module.exports, "getTime", function () { return $ea344319137218f9$export$1428f42a7de81803; });
$parcel$export(module.exports, "default", function () { return $ea344319137218f9$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $5Uet9 = parcelRequire("5Uet9");

var $hvm9a = parcelRequire("hvm9a");

var $GuYp4 = parcelRequire("GuYp4");
function $ea344319137218f9$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $ea344319137218f9$var$Animation = function(_super) {
    (0, $9nEce.__extends)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $ea344319137218f9$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $hvm9a.default)(step);
                !self._paused && self.update();
            }
        }
        (0, $hvm9a.default)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $ea344319137218f9$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $ea344319137218f9$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $ea344319137218f9$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $GuYp4.default)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $5Uet9.default));
var $ea344319137218f9$export$2e2bcd8739ae039 = $ea344319137218f9$var$Animation;

});
parcelRegister("hvm9a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbe682d1e547cf9e$export$2e2bcd8739ae039; });

var $cirKE = parcelRequire("cirKE");
var $cbe682d1e547cf9e$var$requestAnimationFrame;
$cbe682d1e547cf9e$var$requestAnimationFrame = (0, $cirKE.default).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $cbe682d1e547cf9e$export$2e2bcd8739ae039 = $cbe682d1e547cf9e$var$requestAnimationFrame;

});

parcelRegister("GuYp4", function(module, exports) {

$parcel$export(module.exports, "cloneValue", function () { return $07fbf3001b6ebb43$export$c5e92b7f105af84e; });
$parcel$export(module.exports, "default", function () { return $07fbf3001b6ebb43$export$2e2bcd8739ae039; });

var $2No9p = parcelRequire("2No9p");

var $3UxDF = parcelRequire("3UxDF");

var $2N6Uo = parcelRequire("2N6Uo");

var $kVk7L = parcelRequire("kVk7L");

var $8n2Ny = parcelRequire("8n2Ny");

var $hefUp = parcelRequire("hefUp");
var $07fbf3001b6ebb43$var$arraySlice = Array.prototype.slice;
function $07fbf3001b6ebb43$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $07fbf3001b6ebb43$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $07fbf3001b6ebb43$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $07fbf3001b6ebb43$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $07fbf3001b6ebb43$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $07fbf3001b6ebb43$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $07fbf3001b6ebb43$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $07fbf3001b6ebb43$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $07fbf3001b6ebb43$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $07fbf3001b6ebb43$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $07fbf3001b6ebb43$export$c5e92b7f105af84e(value) {
    if ((0, $2N6Uo.isArrayLike)(value)) {
        var len = value.length;
        if ((0, $2N6Uo.isArrayLike)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($07fbf3001b6ebb43$var$arraySlice.call(value[i]));
            return ret;
        }
        return $07fbf3001b6ebb43$var$arraySlice.call(value);
    }
    return value;
}
function $07fbf3001b6ebb43$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return 'rgba(' + rgba.join(',') + ')';
}
function $07fbf3001b6ebb43$var$guessArrayDim(value) {
    return (0, $2N6Uo.isArrayLike)(value && value[0]) ? 2 : 1;
}
var $07fbf3001b6ebb43$var$VALUE_TYPE_NUMBER = 0;
var $07fbf3001b6ebb43$var$VALUE_TYPE_1D_ARRAY = 1;
var $07fbf3001b6ebb43$var$VALUE_TYPE_2D_ARRAY = 2;
var $07fbf3001b6ebb43$var$VALUE_TYPE_COLOR = 3;
var $07fbf3001b6ebb43$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $07fbf3001b6ebb43$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $07fbf3001b6ebb43$var$VALUE_TYPE_UNKOWN = 6;
function $07fbf3001b6ebb43$var$isGradientValueType(valType) {
    return valType === $07fbf3001b6ebb43$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $07fbf3001b6ebb43$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $07fbf3001b6ebb43$var$isArrayValueType(valType) {
    return valType === $07fbf3001b6ebb43$var$VALUE_TYPE_1D_ARRAY || valType === $07fbf3001b6ebb43$var$VALUE_TYPE_2D_ARRAY;
}
var $07fbf3001b6ebb43$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $07fbf3001b6ebb43$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $07fbf3001b6ebb43$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $2N6Uo.isArrayLike)(rawValue)) {
            var arrayDim = $07fbf3001b6ebb43$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $2N6Uo.isNumber)(rawValue[0]) || arrayDim === 2 && !(0, $2N6Uo.isNumber)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $2N6Uo.isNumber)(rawValue) && !(0, $2N6Uo.eqNaN)(rawValue)) valType = $07fbf3001b6ebb43$var$VALUE_TYPE_NUMBER;
            else if ((0, $2N6Uo.isString)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $07fbf3001b6ebb43$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $3UxDF.parse(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $07fbf3001b6ebb43$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $2N6Uo.isGradientObject)(rawValue)) {
                var parsedGradient = (0, $2N6Uo.extend)({}, value);
                parsedGradient.colorStops = (0, $2N6Uo.map)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $3UxDF.parse(colorStop.color)
                    };
                });
                if ((0, $hefUp.isLinearGradient)(rawValue)) valType = $07fbf3001b6ebb43$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $hefUp.isRadialGradient)(rawValue)) valType = $07fbf3001b6ebb43$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $07fbf3001b6ebb43$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $2N6Uo.isFunction)(easing) ? easing : (0, $kVk7L.default)[easing] || (0, $8n2Ny.createCubicEasingFunc)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $07fbf3001b6ebb43$var$isArrayValueType(valType);
        var isGradient = $07fbf3001b6ebb43$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $07fbf3001b6ebb43$var$fillArray(value, lastValue, valType);
                else if (isGradient) $07fbf3001b6ebb43$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $07fbf3001b6ebb43$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $07fbf3001b6ebb43$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $07fbf3001b6ebb43$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $07fbf3001b6ebb43$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($07fbf3001b6ebb43$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $07fbf3001b6ebb43$var$VALUE_TYPE_1D_ARRAY ? $07fbf3001b6ebb43$var$add1DArray([], kfs[i].value, startValue, -1) : $07fbf3001b6ebb43$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $07fbf3001b6ebb43$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $07fbf3001b6ebb43$var$tmpRgba : target[propName];
        if (($07fbf3001b6ebb43$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($07fbf3001b6ebb43$var$isArrayValueType(valType)) valType === $07fbf3001b6ebb43$var$VALUE_TYPE_1D_ARRAY ? $07fbf3001b6ebb43$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $07fbf3001b6ebb43$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($07fbf3001b6ebb43$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $07fbf3001b6ebb43$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? 'linear' : 'radial',
                x: $07fbf3001b6ebb43$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $07fbf3001b6ebb43$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $2N6Uo.map)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $07fbf3001b6ebb43$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $07fbf3001b6ebb43$var$rgba2String($07fbf3001b6ebb43$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $07fbf3001b6ebb43$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $07fbf3001b6ebb43$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $07fbf3001b6ebb43$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $07fbf3001b6ebb43$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $07fbf3001b6ebb43$var$rgba2String(targetArr);
        } else {
            var value = $07fbf3001b6ebb43$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $07fbf3001b6ebb43$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $07fbf3001b6ebb43$var$VALUE_TYPE_COLOR) {
            $3UxDF.parse(target[propName], $07fbf3001b6ebb43$var$tmpRgba);
            $07fbf3001b6ebb43$var$add1DArray($07fbf3001b6ebb43$var$tmpRgba, $07fbf3001b6ebb43$var$tmpRgba, additiveValue, 1);
            target[propName] = $07fbf3001b6ebb43$var$rgba2String($07fbf3001b6ebb43$var$tmpRgba);
        } else if (valType === $07fbf3001b6ebb43$var$VALUE_TYPE_1D_ARRAY) $07fbf3001b6ebb43$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $07fbf3001b6ebb43$var$VALUE_TYPE_2D_ARRAY) $07fbf3001b6ebb43$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $07fbf3001b6ebb43$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $2N6Uo.logError)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $2N6Uo.keys)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $07fbf3001b6ebb43$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $07fbf3001b6ebb43$var$VALUE_TYPE_COLOR && initialValue) initialValue = $07fbf3001b6ebb43$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $07fbf3001b6ebb43$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $07fbf3001b6ebb43$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $2No9p.default)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $2N6Uo.map)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $07fbf3001b6ebb43$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $2N6Uo.keys)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $07fbf3001b6ebb43$export$2e2bcd8739ae039 = $07fbf3001b6ebb43$var$Animator;

});
parcelRegister("2No9p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2092e4351d43284a$export$2e2bcd8739ae039; });

var $kVk7L = parcelRequire("kVk7L");

var $2N6Uo = parcelRequire("2N6Uo");

var $8n2Ny = parcelRequire("8n2Ny");
var $2092e4351d43284a$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $2N6Uo.noop);
        this.ondestroy = opts.ondestroy || (0, $2N6Uo.noop);
        this.onrestart = opts.onrestart || (0, $2N6Uo.noop);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $2N6Uo.isFunction)(easing) ? easing : (0, $kVk7L.default)[easing] || (0, $8n2Ny.createCubicEasingFunc)(easing);
    };
    return Clip;
}();
var $2092e4351d43284a$export$2e2bcd8739ae039 = $2092e4351d43284a$var$Clip;

});
parcelRegister("kVk7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3b8bdca10930e72$export$2e2bcd8739ae039; });
var $f3b8bdca10930e72$var$easingFuncs = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $f3b8bdca10930e72$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $f3b8bdca10930e72$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $f3b8bdca10930e72$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $f3b8bdca10930e72$export$2e2bcd8739ae039 = $f3b8bdca10930e72$var$easingFuncs;

});

parcelRegister("8n2Ny", function(module, exports) {

$parcel$export(module.exports, "createCubicEasingFunc", function () { return $6182a461ecff84a6$export$ec0863d806fd857e; });

var $1kxDI = parcelRequire("1kxDI");

var $2N6Uo = parcelRequire("2N6Uo");
var $6182a461ecff84a6$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $6182a461ecff84a6$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $6182a461ecff84a6$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(',');
        var a_1 = +(0, $2N6Uo.trim)(points[0]);
        var b_1 = +(0, $2N6Uo.trim)(points[1]);
        var c_1 = +(0, $2N6Uo.trim)(points[2]);
        var d_1 = +(0, $2N6Uo.trim)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $1kxDI.cubicRootAt)(0, a_1, c_1, 1, p, roots_1) && (0, $1kxDI.cubicAt)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}

});
parcelRegister("1kxDI", function(module, exports) {

$parcel$export(module.exports, "cubicAt", function () { return $0f81c0cf2d658da0$export$547c21de482bbcb2; });
$parcel$export(module.exports, "cubicDerivativeAt", function () { return $0f81c0cf2d658da0$export$55fce925c60b6271; });
$parcel$export(module.exports, "cubicRootAt", function () { return $0f81c0cf2d658da0$export$ca5d13faa10b167e; });
$parcel$export(module.exports, "cubicExtrema", function () { return $0f81c0cf2d658da0$export$df1a172f100d0457; });
$parcel$export(module.exports, "cubicSubdivide", function () { return $0f81c0cf2d658da0$export$a2ee23a0567039da; });
$parcel$export(module.exports, "cubicProjectPoint", function () { return $0f81c0cf2d658da0$export$dbaa3801d1284367; });
$parcel$export(module.exports, "cubicLength", function () { return $0f81c0cf2d658da0$export$af1875d576f60d7c; });
$parcel$export(module.exports, "quadraticAt", function () { return $0f81c0cf2d658da0$export$af17094a950f5073; });
$parcel$export(module.exports, "quadraticDerivativeAt", function () { return $0f81c0cf2d658da0$export$7e161e77e6fff8cb; });
$parcel$export(module.exports, "quadraticRootAt", function () { return $0f81c0cf2d658da0$export$fd895ac7ee764967; });
$parcel$export(module.exports, "quadraticExtremum", function () { return $0f81c0cf2d658da0$export$752e1f8c6e7f7e11; });
$parcel$export(module.exports, "quadraticSubdivide", function () { return $0f81c0cf2d658da0$export$117c659e21a7a060; });
$parcel$export(module.exports, "quadraticProjectPoint", function () { return $0f81c0cf2d658da0$export$81915a594fe10dee; });
$parcel$export(module.exports, "quadraticLength", function () { return $0f81c0cf2d658da0$export$8a68adee46f3cf55; });

var $U1aqY = parcelRequire("U1aqY");
var $0f81c0cf2d658da0$var$mathPow = Math.pow;
var $0f81c0cf2d658da0$var$mathSqrt = Math.sqrt;
var $0f81c0cf2d658da0$var$EPSILON = 1e-8;
var $0f81c0cf2d658da0$var$EPSILON_NUMERIC = 1e-4;
var $0f81c0cf2d658da0$var$THREE_SQRT = $0f81c0cf2d658da0$var$mathSqrt(3);
var $0f81c0cf2d658da0$var$ONE_THIRD = 1 / 3;
var $0f81c0cf2d658da0$var$_v0 = (0, $U1aqY.create)();
var $0f81c0cf2d658da0$var$_v1 = (0, $U1aqY.create)();
var $0f81c0cf2d658da0$var$_v2 = (0, $U1aqY.create)();
function $0f81c0cf2d658da0$var$isAroundZero(val) {
    return val > -$0f81c0cf2d658da0$var$EPSILON && val < $0f81c0cf2d658da0$var$EPSILON;
}
function $0f81c0cf2d658da0$var$isNotAroundZero(val) {
    return val > $0f81c0cf2d658da0$var$EPSILON || val < -$0f81c0cf2d658da0$var$EPSILON;
}
function $0f81c0cf2d658da0$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $0f81c0cf2d658da0$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $0f81c0cf2d658da0$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($0f81c0cf2d658da0$var$isAroundZero(A) && $0f81c0cf2d658da0$var$isAroundZero(B)) {
        if ($0f81c0cf2d658da0$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($0f81c0cf2d658da0$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $0f81c0cf2d658da0$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$0f81c0cf2d658da0$var$mathPow(-Y1, $0f81c0cf2d658da0$var$ONE_THIRD);
            else Y1 = $0f81c0cf2d658da0$var$mathPow(Y1, $0f81c0cf2d658da0$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$0f81c0cf2d658da0$var$mathPow(-Y2, $0f81c0cf2d658da0$var$ONE_THIRD);
            else Y2 = $0f81c0cf2d658da0$var$mathPow(Y2, $0f81c0cf2d658da0$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $0f81c0cf2d658da0$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $0f81c0cf2d658da0$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $0f81c0cf2d658da0$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $0f81c0cf2d658da0$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $0f81c0cf2d658da0$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($0f81c0cf2d658da0$var$isAroundZero(a)) {
        if ($0f81c0cf2d658da0$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($0f81c0cf2d658da0$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $0f81c0cf2d658da0$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $0f81c0cf2d658da0$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $0f81c0cf2d658da0$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $0f81c0cf2d658da0$var$_v0[0] = x;
    $0f81c0cf2d658da0$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $0f81c0cf2d658da0$var$_v1[0] = $0f81c0cf2d658da0$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $0f81c0cf2d658da0$var$_v1[1] = $0f81c0cf2d658da0$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $U1aqY.distSquare)($0f81c0cf2d658da0$var$_v0, $0f81c0cf2d658da0$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $0f81c0cf2d658da0$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $0f81c0cf2d658da0$var$_v1[0] = $0f81c0cf2d658da0$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $0f81c0cf2d658da0$var$_v1[1] = $0f81c0cf2d658da0$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $U1aqY.distSquare)($0f81c0cf2d658da0$var$_v1, $0f81c0cf2d658da0$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $0f81c0cf2d658da0$var$_v2[0] = $0f81c0cf2d658da0$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $0f81c0cf2d658da0$var$_v2[1] = $0f81c0cf2d658da0$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $U1aqY.distSquare)($0f81c0cf2d658da0$var$_v2, $0f81c0cf2d658da0$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $0f81c0cf2d658da0$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $0f81c0cf2d658da0$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $0f81c0cf2d658da0$var$mathSqrt(d);
}
function $0f81c0cf2d658da0$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $0f81c0cf2d658da0$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $0f81c0cf2d658da0$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $0f81c0cf2d658da0$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $0f81c0cf2d658da0$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $0f81c0cf2d658da0$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($0f81c0cf2d658da0$var$isAroundZero(a)) {
        if ($0f81c0cf2d658da0$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($0f81c0cf2d658da0$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $0f81c0cf2d658da0$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $0f81c0cf2d658da0$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $0f81c0cf2d658da0$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $0f81c0cf2d658da0$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $0f81c0cf2d658da0$var$_v0[0] = x;
    $0f81c0cf2d658da0$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $0f81c0cf2d658da0$var$_v1[0] = $0f81c0cf2d658da0$export$af17094a950f5073(x0, x1, x2, _t);
        $0f81c0cf2d658da0$var$_v1[1] = $0f81c0cf2d658da0$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $U1aqY.distSquare)($0f81c0cf2d658da0$var$_v0, $0f81c0cf2d658da0$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $0f81c0cf2d658da0$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $0f81c0cf2d658da0$var$_v1[0] = $0f81c0cf2d658da0$export$af17094a950f5073(x0, x1, x2, prev);
        $0f81c0cf2d658da0$var$_v1[1] = $0f81c0cf2d658da0$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $U1aqY.distSquare)($0f81c0cf2d658da0$var$_v1, $0f81c0cf2d658da0$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $0f81c0cf2d658da0$var$_v2[0] = $0f81c0cf2d658da0$export$af17094a950f5073(x0, x1, x2, next);
            $0f81c0cf2d658da0$var$_v2[1] = $0f81c0cf2d658da0$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $U1aqY.distSquare)($0f81c0cf2d658da0$var$_v2, $0f81c0cf2d658da0$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $0f81c0cf2d658da0$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $0f81c0cf2d658da0$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $0f81c0cf2d658da0$var$mathSqrt(d);
}
function $0f81c0cf2d658da0$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $0f81c0cf2d658da0$export$af17094a950f5073(x0, x1, x2, t);
        var y = $0f81c0cf2d658da0$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}

});



parcelRegister("3UxDF", function(module, exports) {

$parcel$export(module.exports, "parseCssFloat", function () { return $2d90b200fabc9955$export$7638a67891c3b497; });
$parcel$export(module.exports, "parse", function () { return $2d90b200fabc9955$export$98e6a39c04603d36; });
$parcel$export(module.exports, "lift", function () { return $2d90b200fabc9955$export$590e8b2c435046d9; });
$parcel$export(module.exports, "stringify", function () { return $2d90b200fabc9955$export$fac44ee5b035f737; });
$parcel$export(module.exports, "fastLerp", function () { return $2d90b200fabc9955$export$66cb3c0e9efc61c8; });
$parcel$export(module.exports, "lerp", function () { return $2d90b200fabc9955$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "modifyHSL", function () { return $2d90b200fabc9955$export$d898ae866e27bf18; });
$parcel$export(module.exports, "modifyAlpha", function () { return $2d90b200fabc9955$export$ab4754bf42583a26; });
$parcel$export(module.exports, "lum", function () { return $2d90b200fabc9955$export$16c0ec21a6f9ef95; });
$parcel$export(module.exports, "liftColor", function () { return $2d90b200fabc9955$export$2b47e247dfb87a73; });

var $aceTf = parcelRequire("aceTf");

var $2N6Uo = parcelRequire("2N6Uo");
var $2d90b200fabc9955$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $2d90b200fabc9955$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $2d90b200fabc9955$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $2d90b200fabc9955$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $2d90b200fabc9955$export$e6be818e738239a(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $2d90b200fabc9955$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $2d90b200fabc9955$var$clampCssByte(parseInt(str, 10));
}
function $2d90b200fabc9955$export$7638a67891c3b497(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $2d90b200fabc9955$var$clampCssFloat(parseFloat(str) / 100);
    return $2d90b200fabc9955$var$clampCssFloat(parseFloat(str));
}
function $2d90b200fabc9955$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $2d90b200fabc9955$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $2d90b200fabc9955$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $2d90b200fabc9955$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $2d90b200fabc9955$var$colorCache = new (0, $aceTf.default)(20);
var $2d90b200fabc9955$var$lastRemovedArr = null;
function $2d90b200fabc9955$var$putToCache(colorStr, rgbaArr) {
    if ($2d90b200fabc9955$var$lastRemovedArr) $2d90b200fabc9955$var$copyRgba($2d90b200fabc9955$var$lastRemovedArr, rgbaArr);
    $2d90b200fabc9955$var$lastRemovedArr = $2d90b200fabc9955$var$colorCache.put(colorStr, $2d90b200fabc9955$var$lastRemovedArr || rgbaArr.slice());
}
function $2d90b200fabc9955$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $2d90b200fabc9955$var$colorCache.get(colorStr);
    if (cached) return $2d90b200fabc9955$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $2d90b200fabc9955$var$kCSSColorTable) {
        $2d90b200fabc9955$var$copyRgba(rgbaArr, $2d90b200fabc9955$var$kCSSColorTable[str]);
        $2d90b200fabc9955$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $2d90b200fabc9955$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2d90b200fabc9955$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $2d90b200fabc9955$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $2d90b200fabc9955$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2d90b200fabc9955$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $2d90b200fabc9955$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $2d90b200fabc9955$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $2d90b200fabc9955$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $2d90b200fabc9955$export$7638a67891c3b497(params.pop());
            case 'rgb':
                if (params.length >= 3) {
                    $2d90b200fabc9955$var$setRgba(rgbaArr, $2d90b200fabc9955$export$e6be818e738239a(params[0]), $2d90b200fabc9955$export$e6be818e738239a(params[1]), $2d90b200fabc9955$export$e6be818e738239a(params[2]), params.length === 3 ? alpha : $2d90b200fabc9955$export$7638a67891c3b497(params[3]));
                    $2d90b200fabc9955$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $2d90b200fabc9955$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case 'hsla':
                if (params.length !== 4) {
                    $2d90b200fabc9955$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $2d90b200fabc9955$export$7638a67891c3b497(params[3]);
                $2d90b200fabc9955$var$hsla2rgba(params, rgbaArr);
                $2d90b200fabc9955$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $2d90b200fabc9955$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $2d90b200fabc9955$var$hsla2rgba(params, rgbaArr);
                $2d90b200fabc9955$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $2d90b200fabc9955$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $2d90b200fabc9955$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $2d90b200fabc9955$export$7638a67891c3b497(hsla[1]);
    var l = $2d90b200fabc9955$export$7638a67891c3b497(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $2d90b200fabc9955$var$setRgba(rgba, $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$cssHueToRgb(m1, m2, h) * 255), $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $2d90b200fabc9955$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $2d90b200fabc9955$export$590e8b2c435046d9(color, level) {
    var colorArr = $2d90b200fabc9955$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $2d90b200fabc9955$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $2d90b200fabc9955$export$7ea66e3774a60b67(color) {
    var colorArr = $2d90b200fabc9955$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $2d90b200fabc9955$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $2d90b200fabc9955$var$clampCssFloat($2d90b200fabc9955$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $2d90b200fabc9955$export$daa5a65daad5df58 = $2d90b200fabc9955$export$66cb3c0e9efc61c8;
function $2d90b200fabc9955$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $2d90b200fabc9955$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $2d90b200fabc9955$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $2d90b200fabc9955$export$fac44ee5b035f737([
        $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $2d90b200fabc9955$var$clampCssByte($2d90b200fabc9955$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $2d90b200fabc9955$var$clampCssFloat($2d90b200fabc9955$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $2d90b200fabc9955$export$296e08242b78a3ec = $2d90b200fabc9955$export$3a89f8d6f6bf6c9f;
function $2d90b200fabc9955$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $2d90b200fabc9955$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $2d90b200fabc9955$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $2d90b200fabc9955$var$clampCssAngle((0, $2N6Uo.isFunction)(h) ? h(colorArr[0]) : h));
        s != null && (colorArr[1] = $2d90b200fabc9955$export$7638a67891c3b497((0, $2N6Uo.isFunction)(s) ? s(colorArr[1]) : s));
        l != null && (colorArr[2] = $2d90b200fabc9955$export$7638a67891c3b497((0, $2N6Uo.isFunction)(l) ? l(colorArr[2]) : l));
        return $2d90b200fabc9955$export$fac44ee5b035f737($2d90b200fabc9955$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $2d90b200fabc9955$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $2d90b200fabc9955$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $2d90b200fabc9955$var$clampCssFloat(alpha);
        return $2d90b200fabc9955$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $2d90b200fabc9955$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $2d90b200fabc9955$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $2d90b200fabc9955$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $2d90b200fabc9955$export$4385e60b38654f68() {
    return $2d90b200fabc9955$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], 'rgb');
}
var $2d90b200fabc9955$var$liftedColorCache = new (0, $aceTf.default)(100);
function $2d90b200fabc9955$export$2b47e247dfb87a73(color) {
    if ((0, $2N6Uo.isString)(color)) {
        var liftedColor = $2d90b200fabc9955$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $2d90b200fabc9955$export$590e8b2c435046d9(color, -0.1);
            $2d90b200fabc9955$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $2N6Uo.isGradientObject)(color)) {
        var ret = (0, $2N6Uo.extend)({}, color);
        ret.colorStops = (0, $2N6Uo.map)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $2d90b200fabc9955$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}

});
parcelRegister("aceTf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76c69338f8226a85$export$2e2bcd8739ae039; });
var $76c69338f8226a85$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $76c69338f8226a85$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $76c69338f8226a85$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $76c69338f8226a85$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $76c69338f8226a85$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $76c69338f8226a85$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $76c69338f8226a85$export$2e2bcd8739ae039 = $76c69338f8226a85$var$LRU;

});


parcelRegister("hefUp", function(module, exports) {

$parcel$export(module.exports, "normalizeColor", function () { return $c8b0159d2d049bca$export$4cde5df63f53f473; });
$parcel$export(module.exports, "isAroundZero", function () { return $c8b0159d2d049bca$export$4701367f5b4de464; });
$parcel$export(module.exports, "round4", function () { return $c8b0159d2d049bca$export$52bfc6d3e2ff0fc2; });
$parcel$export(module.exports, "getMatrixStr", function () { return $c8b0159d2d049bca$export$f29a4456cf56ff21; });
$parcel$export(module.exports, "TEXT_ALIGN_TO_ANCHOR", function () { return $c8b0159d2d049bca$export$4062150f0600d971; });
$parcel$export(module.exports, "adjustTextY", function () { return $c8b0159d2d049bca$export$bf7d6802d2badd9; });
$parcel$export(module.exports, "hasShadow", function () { return $c8b0159d2d049bca$export$c62076b3a966c94b; });
$parcel$export(module.exports, "getShadowKey", function () { return $c8b0159d2d049bca$export$9e4c657be710688a; });
$parcel$export(module.exports, "isImagePattern", function () { return $c8b0159d2d049bca$export$2ade673ac4f85dfe; });
$parcel$export(module.exports, "isPattern", function () { return $c8b0159d2d049bca$export$41a28f5a000a9d0f; });
$parcel$export(module.exports, "isLinearGradient", function () { return $c8b0159d2d049bca$export$7d961bca9d3b47d0; });
$parcel$export(module.exports, "isRadialGradient", function () { return $c8b0159d2d049bca$export$2a9cca6692a0ce3a; });
$parcel$export(module.exports, "isGradient", function () { return $c8b0159d2d049bca$export$545e02bbd5f8fe95; });
$parcel$export(module.exports, "getIdURL", function () { return $c8b0159d2d049bca$export$bb094196179998a5; });
$parcel$export(module.exports, "getPathPrecision", function () { return $c8b0159d2d049bca$export$93fa1ae8a509371c; });
$parcel$export(module.exports, "getSRTTransformString", function () { return $c8b0159d2d049bca$export$3fe07c0888ff6164; });
$parcel$export(module.exports, "encodeBase64", function () { return $c8b0159d2d049bca$export$8fb536984ec8b4d7; });

var $2N6Uo = parcelRequire("2N6Uo");

var $3UxDF = parcelRequire("3UxDF");

var $cirKE = parcelRequire("cirKE");

var $7ulbJ = parcelRequire("7ulbJ");
var $c8b0159d2d049bca$require$Buffer = $7ulbJ.Buffer;
var $c8b0159d2d049bca$var$mathRound = Math.round;
function $c8b0159d2d049bca$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === 'transparent') color = 'none';
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = (0, $3UxDF.parse)(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $c8b0159d2d049bca$var$EPSILON = 1e-4;
function $c8b0159d2d049bca$export$4701367f5b4de464(transform) {
    return transform < $c8b0159d2d049bca$var$EPSILON && transform > -$c8b0159d2d049bca$var$EPSILON;
}
function $c8b0159d2d049bca$export$4b9074ac37ee5a23(transform) {
    return $c8b0159d2d049bca$var$mathRound(transform * 1e3) / 1e3;
}
function $c8b0159d2d049bca$export$52bfc6d3e2ff0fc2(transform) {
    return $c8b0159d2d049bca$var$mathRound(transform * 1e4) / 1e4;
}
function $c8b0159d2d049bca$export$19676ab5cb1de150(transform) {
    return $c8b0159d2d049bca$var$mathRound(transform * 10) / 10;
}
function $c8b0159d2d049bca$export$f29a4456cf56ff21(m) {
    return 'matrix(' + $c8b0159d2d049bca$export$4b9074ac37ee5a23(m[0]) + ',' + $c8b0159d2d049bca$export$4b9074ac37ee5a23(m[1]) + ',' + $c8b0159d2d049bca$export$4b9074ac37ee5a23(m[2]) + ',' + $c8b0159d2d049bca$export$4b9074ac37ee5a23(m[3]) + ',' + $c8b0159d2d049bca$export$52bfc6d3e2ff0fc2(m[4]) + ',' + $c8b0159d2d049bca$export$52bfc6d3e2ff0fc2(m[5]) + ')';
}
var $c8b0159d2d049bca$export$4062150f0600d971 = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function $c8b0159d2d049bca$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') y += lineHeight / 2;
    else if (textBaseline === 'bottom') y -= lineHeight / 2;
    return y;
}
function $c8b0159d2d049bca$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $c8b0159d2d049bca$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}
function $c8b0159d2d049bca$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(',');
}
function $c8b0159d2d049bca$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $c8b0159d2d049bca$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $c8b0159d2d049bca$export$41a28f5a000a9d0f(val) {
    return $c8b0159d2d049bca$export$2ade673ac4f85dfe(val) || $c8b0159d2d049bca$export$30352f47600a13cd(val);
}
function $c8b0159d2d049bca$export$7d961bca9d3b47d0(val) {
    return val.type === 'linear';
}
function $c8b0159d2d049bca$export$2a9cca6692a0ce3a(val) {
    return val.type === 'radial';
}
function $c8b0159d2d049bca$export$545e02bbd5f8fe95(val) {
    return val && (val.type === 'linear' || val.type === 'radial');
}
function $c8b0159d2d049bca$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $c8b0159d2d049bca$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $c8b0159d2d049bca$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $2N6Uo.RADIAN_TO_DEGREE);
    var scaleX = (0, $2N6Uo.retrieve2)(transform.scaleX, 1);
    var scaleY = (0, $2N6Uo.retrieve2)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $c8b0159d2d049bca$var$mathRound(skewX * (0, $2N6Uo.RADIAN_TO_DEGREE)) + "deg, " + $c8b0159d2d049bca$var$mathRound(skewY * (0, $2N6Uo.RADIAN_TO_DEGREE)) + "deg)");
    return res.join(' ');
}
var $c8b0159d2d049bca$export$8fb536984ec8b4d7 = function() {
    if ((0, $cirKE.default).hasGlobalWindow && (0, $2N6Uo.isFunction)(window.btoa)) return function(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    if (typeof $c8b0159d2d049bca$require$Buffer !== 'undefined') return function(str) {
        return $c8b0159d2d049bca$require$Buffer.from(str).toString('base64');
    };
    return function(str) {
        return null;
    };
}();

});
parcelRegister("7ulbJ", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $573bc54e9e97125d$export$a143d493d941bafc; }, function (v) { return $573bc54e9e97125d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $573bc54e9e97125d$export$f99ded8fe4b79145; }, function (v) { return $573bc54e9e97125d$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $573bc54e9e97125d$export$a143d493d941bafc;
var $573bc54e9e97125d$export$e4cf37d7f6fb9e0a;
var $573bc54e9e97125d$export$f99ded8fe4b79145;
var $573bc54e9e97125d$export$599f31c3813fae4d;
'use strict';

var $gaa8e = parcelRequire("gaa8e");

var $jSbqZ = parcelRequire("jSbqZ");
const $573bc54e9e97125d$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$573bc54e9e97125d$export$a143d493d941bafc = $573bc54e9e97125d$var$Buffer;
$573bc54e9e97125d$export$e4cf37d7f6fb9e0a = $573bc54e9e97125d$var$SlowBuffer;
$573bc54e9e97125d$export$f99ded8fe4b79145 = 50;
const $573bc54e9e97125d$var$K_MAX_LENGTH = 0x7fffffff;
$573bc54e9e97125d$export$599f31c3813fae4d = $573bc54e9e97125d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $573bc54e9e97125d$var$Buffer.TYPED_ARRAY_SUPPORT = $573bc54e9e97125d$var$typedArraySupport();
if (!$573bc54e9e97125d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $573bc54e9e97125d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($573bc54e9e97125d$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$573bc54e9e97125d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($573bc54e9e97125d$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$573bc54e9e97125d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $573bc54e9e97125d$var$createBuffer(length) {
    if (length > $573bc54e9e97125d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $573bc54e9e97125d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $573bc54e9e97125d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $573bc54e9e97125d$var$allocUnsafe(arg);
    }
    return $573bc54e9e97125d$var$from(arg, encodingOrOffset, length);
}
$573bc54e9e97125d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $573bc54e9e97125d$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $573bc54e9e97125d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $573bc54e9e97125d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($573bc54e9e97125d$var$isInstance(value, ArrayBuffer) || value && $573bc54e9e97125d$var$isInstance(value.buffer, ArrayBuffer)) return $573bc54e9e97125d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($573bc54e9e97125d$var$isInstance(value, SharedArrayBuffer) || value && $573bc54e9e97125d$var$isInstance(value.buffer, SharedArrayBuffer))) return $573bc54e9e97125d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $573bc54e9e97125d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $573bc54e9e97125d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $573bc54e9e97125d$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $573bc54e9e97125d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $573bc54e9e97125d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($573bc54e9e97125d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($573bc54e9e97125d$var$Buffer, Uint8Array);
function $573bc54e9e97125d$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $573bc54e9e97125d$var$alloc(size, fill, encoding) {
    $573bc54e9e97125d$var$assertSize(size);
    if (size <= 0) return $573bc54e9e97125d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $573bc54e9e97125d$var$createBuffer(size).fill(fill, encoding) : $573bc54e9e97125d$var$createBuffer(size).fill(fill);
    return $573bc54e9e97125d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $573bc54e9e97125d$var$Buffer.alloc = function(size, fill, encoding) {
    return $573bc54e9e97125d$var$alloc(size, fill, encoding);
};
function $573bc54e9e97125d$var$allocUnsafe(size) {
    $573bc54e9e97125d$var$assertSize(size);
    return $573bc54e9e97125d$var$createBuffer(size < 0 ? 0 : $573bc54e9e97125d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $573bc54e9e97125d$var$Buffer.allocUnsafe = function(size) {
    return $573bc54e9e97125d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $573bc54e9e97125d$var$Buffer.allocUnsafeSlow = function(size) {
    return $573bc54e9e97125d$var$allocUnsafe(size);
};
function $573bc54e9e97125d$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$573bc54e9e97125d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $573bc54e9e97125d$var$byteLength(string, encoding) | 0;
    let buf = $573bc54e9e97125d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $573bc54e9e97125d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $573bc54e9e97125d$var$checked(array.length) | 0;
    const buf = $573bc54e9e97125d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $573bc54e9e97125d$var$fromArrayView(arrayView) {
    if ($573bc54e9e97125d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $573bc54e9e97125d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $573bc54e9e97125d$var$fromArrayLike(arrayView);
}
function $573bc54e9e97125d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $573bc54e9e97125d$var$Buffer.prototype);
    return buf;
}
function $573bc54e9e97125d$var$fromObject(obj) {
    if ($573bc54e9e97125d$var$Buffer.isBuffer(obj)) {
        const len = $573bc54e9e97125d$var$checked(obj.length) | 0;
        const buf = $573bc54e9e97125d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $573bc54e9e97125d$var$numberIsNaN(obj.length)) return $573bc54e9e97125d$var$createBuffer(0);
        return $573bc54e9e97125d$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $573bc54e9e97125d$var$fromArrayLike(obj.data);
}
function $573bc54e9e97125d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $573bc54e9e97125d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $573bc54e9e97125d$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $573bc54e9e97125d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $573bc54e9e97125d$var$Buffer.alloc(+length);
}
$573bc54e9e97125d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $573bc54e9e97125d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$573bc54e9e97125d$var$Buffer.compare = function compare(a, b) {
    if ($573bc54e9e97125d$var$isInstance(a, Uint8Array)) a = $573bc54e9e97125d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($573bc54e9e97125d$var$isInstance(b, Uint8Array)) b = $573bc54e9e97125d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(a) || !$573bc54e9e97125d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$573bc54e9e97125d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$573bc54e9e97125d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $573bc54e9e97125d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $573bc54e9e97125d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($573bc54e9e97125d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$573bc54e9e97125d$var$Buffer.isBuffer(buf)) buf = $573bc54e9e97125d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$573bc54e9e97125d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $573bc54e9e97125d$var$byteLength(string, encoding) {
    if ($573bc54e9e97125d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $573bc54e9e97125d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $573bc54e9e97125d$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $573bc54e9e97125d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $573bc54e9e97125d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$573bc54e9e97125d$var$Buffer.byteLength = $573bc54e9e97125d$var$byteLength;
function $573bc54e9e97125d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $573bc54e9e97125d$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $573bc54e9e97125d$var$utf8Slice(this, start, end);
        case 'ascii':
            return $573bc54e9e97125d$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $573bc54e9e97125d$var$latin1Slice(this, start, end);
        case 'base64':
            return $573bc54e9e97125d$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $573bc54e9e97125d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$573bc54e9e97125d$var$Buffer.prototype._isBuffer = true;
function $573bc54e9e97125d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$573bc54e9e97125d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$573bc54e9e97125d$var$swap(this, i, i + 1);
    return this;
};
$573bc54e9e97125d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $573bc54e9e97125d$var$swap(this, i, i + 3);
        $573bc54e9e97125d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$573bc54e9e97125d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $573bc54e9e97125d$var$swap(this, i, i + 7);
        $573bc54e9e97125d$var$swap(this, i + 1, i + 6);
        $573bc54e9e97125d$var$swap(this, i + 2, i + 5);
        $573bc54e9e97125d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$573bc54e9e97125d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $573bc54e9e97125d$var$utf8Slice(this, 0, length);
    return $573bc54e9e97125d$var$slowToString.apply(this, arguments);
};
$573bc54e9e97125d$var$Buffer.prototype.toLocaleString = $573bc54e9e97125d$var$Buffer.prototype.toString;
$573bc54e9e97125d$var$Buffer.prototype.equals = function equals(b) {
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $573bc54e9e97125d$var$Buffer.compare(this, b) === 0;
};
$573bc54e9e97125d$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $573bc54e9e97125d$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($573bc54e9e97125d$var$customInspectSymbol) $573bc54e9e97125d$var$Buffer.prototype[$573bc54e9e97125d$var$customInspectSymbol] = $573bc54e9e97125d$var$Buffer.prototype.inspect;
$573bc54e9e97125d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($573bc54e9e97125d$var$isInstance(target, Uint8Array)) target = $573bc54e9e97125d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $573bc54e9e97125d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($573bc54e9e97125d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $573bc54e9e97125d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($573bc54e9e97125d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $573bc54e9e97125d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $573bc54e9e97125d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $573bc54e9e97125d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$573bc54e9e97125d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$573bc54e9e97125d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $573bc54e9e97125d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$573bc54e9e97125d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $573bc54e9e97125d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $573bc54e9e97125d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($573bc54e9e97125d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $573bc54e9e97125d$var$utf8Write(buf, string, offset, length) {
    return $573bc54e9e97125d$var$blitBuffer($573bc54e9e97125d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $573bc54e9e97125d$var$asciiWrite(buf, string, offset, length) {
    return $573bc54e9e97125d$var$blitBuffer($573bc54e9e97125d$var$asciiToBytes(string), buf, offset, length);
}
function $573bc54e9e97125d$var$base64Write(buf, string, offset, length) {
    return $573bc54e9e97125d$var$blitBuffer($573bc54e9e97125d$var$base64ToBytes(string), buf, offset, length);
}
function $573bc54e9e97125d$var$ucs2Write(buf, string, offset, length) {
    return $573bc54e9e97125d$var$blitBuffer($573bc54e9e97125d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$573bc54e9e97125d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $573bc54e9e97125d$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $573bc54e9e97125d$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $573bc54e9e97125d$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $573bc54e9e97125d$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $573bc54e9e97125d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$573bc54e9e97125d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $573bc54e9e97125d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gaa8e.fromByteArray(buf);
    else return $gaa8e.fromByteArray(buf.slice(start, end));
}
function $573bc54e9e97125d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $573bc54e9e97125d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $573bc54e9e97125d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $573bc54e9e97125d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $573bc54e9e97125d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $573bc54e9e97125d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $573bc54e9e97125d$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $573bc54e9e97125d$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $573bc54e9e97125d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $573bc54e9e97125d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $573bc54e9e97125d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$573bc54e9e97125d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $573bc54e9e97125d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $573bc54e9e97125d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$573bc54e9e97125d$var$Buffer.prototype.readUintLE = $573bc54e9e97125d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$573bc54e9e97125d$var$Buffer.prototype.readUintBE = $573bc54e9e97125d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$573bc54e9e97125d$var$Buffer.prototype.readUint8 = $573bc54e9e97125d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$573bc54e9e97125d$var$Buffer.prototype.readUint16LE = $573bc54e9e97125d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$573bc54e9e97125d$var$Buffer.prototype.readUint16BE = $573bc54e9e97125d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$573bc54e9e97125d$var$Buffer.prototype.readUint32LE = $573bc54e9e97125d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$573bc54e9e97125d$var$Buffer.prototype.readUint32BE = $573bc54e9e97125d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$573bc54e9e97125d$var$Buffer.prototype.readBigUInt64LE = $573bc54e9e97125d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $573bc54e9e97125d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $573bc54e9e97125d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$573bc54e9e97125d$var$Buffer.prototype.readBigUInt64BE = $573bc54e9e97125d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $573bc54e9e97125d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $573bc54e9e97125d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$573bc54e9e97125d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$573bc54e9e97125d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$573bc54e9e97125d$var$Buffer.prototype.readBigInt64LE = $573bc54e9e97125d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $573bc54e9e97125d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $573bc54e9e97125d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$573bc54e9e97125d$var$Buffer.prototype.readBigInt64BE = $573bc54e9e97125d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $573bc54e9e97125d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $573bc54e9e97125d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$573bc54e9e97125d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return $jSbqZ.read(this, offset, true, 23, 4);
};
$573bc54e9e97125d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return $jSbqZ.read(this, offset, false, 23, 4);
};
$573bc54e9e97125d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 8, this.length);
    return $jSbqZ.read(this, offset, true, 52, 8);
};
$573bc54e9e97125d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 8, this.length);
    return $jSbqZ.read(this, offset, false, 52, 8);
};
function $573bc54e9e97125d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$573bc54e9e97125d$var$Buffer.prototype.writeUintLE = $573bc54e9e97125d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $573bc54e9e97125d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUintBE = $573bc54e9e97125d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $573bc54e9e97125d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint8 = $573bc54e9e97125d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint16LE = $573bc54e9e97125d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint16BE = $573bc54e9e97125d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint32LE = $573bc54e9e97125d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint32BE = $573bc54e9e97125d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $573bc54e9e97125d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $573bc54e9e97125d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $573bc54e9e97125d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $573bc54e9e97125d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$573bc54e9e97125d$var$Buffer.prototype.writeBigUInt64LE = $573bc54e9e97125d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $573bc54e9e97125d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$573bc54e9e97125d$var$Buffer.prototype.writeBigUInt64BE = $573bc54e9e97125d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $573bc54e9e97125d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$573bc54e9e97125d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $573bc54e9e97125d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$573bc54e9e97125d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $573bc54e9e97125d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$573bc54e9e97125d$var$Buffer.prototype.writeBigInt64LE = $573bc54e9e97125d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $573bc54e9e97125d$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$573bc54e9e97125d$var$Buffer.prototype.writeBigInt64BE = $573bc54e9e97125d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $573bc54e9e97125d$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $573bc54e9e97125d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $573bc54e9e97125d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $jSbqZ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$573bc54e9e97125d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $573bc54e9e97125d$var$writeFloat(this, value, offset, true, noAssert);
};
$573bc54e9e97125d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $573bc54e9e97125d$var$writeFloat(this, value, offset, false, noAssert);
};
function $573bc54e9e97125d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $jSbqZ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$573bc54e9e97125d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $573bc54e9e97125d$var$writeDouble(this, value, offset, true, noAssert);
};
$573bc54e9e97125d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $573bc54e9e97125d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$573bc54e9e97125d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$573bc54e9e97125d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$573bc54e9e97125d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $573bc54e9e97125d$var$Buffer.isBuffer(val) ? val : $573bc54e9e97125d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $573bc54e9e97125d$var$errors = {};
function $573bc54e9e97125d$var$E(sym, getMessage, Base) {
    $573bc54e9e97125d$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$573bc54e9e97125d$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$573bc54e9e97125d$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$573bc54e9e97125d$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $573bc54e9e97125d$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $573bc54e9e97125d$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $573bc54e9e97125d$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $573bc54e9e97125d$var$checkBounds(buf, offset, byteLength) {
    $573bc54e9e97125d$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $573bc54e9e97125d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $573bc54e9e97125d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $573bc54e9e97125d$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $573bc54e9e97125d$var$checkBounds(buf, offset, byteLength);
}
function $573bc54e9e97125d$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $573bc54e9e97125d$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $573bc54e9e97125d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $573bc54e9e97125d$var$validateNumber(value, type);
        throw new $573bc54e9e97125d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $573bc54e9e97125d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $573bc54e9e97125d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $573bc54e9e97125d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $573bc54e9e97125d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($573bc54e9e97125d$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $573bc54e9e97125d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $573bc54e9e97125d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $573bc54e9e97125d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $573bc54e9e97125d$var$base64ToBytes(str) {
    return $gaa8e.toByteArray($573bc54e9e97125d$var$base64clean(str));
}
function $573bc54e9e97125d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $573bc54e9e97125d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $573bc54e9e97125d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $573bc54e9e97125d$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $573bc54e9e97125d$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $573bc54e9e97125d$var$BufferBigIntNotDefined : fn;
}
function $573bc54e9e97125d$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("gaa8e", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $bc4570760301b666$export$d622b2ad8d90c771; }, function (v) { return $bc4570760301b666$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $bc4570760301b666$export$6100ba28696e12de; }, function (v) { return $bc4570760301b666$export$6100ba28696e12de = v; });
var $bc4570760301b666$export$a48f0734ac7c2329;
var $bc4570760301b666$export$d622b2ad8d90c771;
var $bc4570760301b666$export$6100ba28696e12de;
'use strict';
$bc4570760301b666$export$a48f0734ac7c2329 = $bc4570760301b666$var$byteLength;
$bc4570760301b666$export$d622b2ad8d90c771 = $bc4570760301b666$var$toByteArray;
$bc4570760301b666$export$6100ba28696e12de = $bc4570760301b666$var$fromByteArray;
var $bc4570760301b666$var$lookup = [];
var $bc4570760301b666$var$revLookup = [];
var $bc4570760301b666$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $bc4570760301b666$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $bc4570760301b666$var$i = 0, $bc4570760301b666$var$len = $bc4570760301b666$var$code.length; $bc4570760301b666$var$i < $bc4570760301b666$var$len; ++$bc4570760301b666$var$i){
    $bc4570760301b666$var$lookup[$bc4570760301b666$var$i] = $bc4570760301b666$var$code[$bc4570760301b666$var$i];
    $bc4570760301b666$var$revLookup[$bc4570760301b666$var$code.charCodeAt($bc4570760301b666$var$i)] = $bc4570760301b666$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bc4570760301b666$var$revLookup['-'.charCodeAt(0)] = 62;
$bc4570760301b666$var$revLookup['_'.charCodeAt(0)] = 63;
function $bc4570760301b666$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bc4570760301b666$var$byteLength(b64) {
    var lens = $bc4570760301b666$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bc4570760301b666$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bc4570760301b666$var$toByteArray(b64) {
    var tmp;
    var lens = $bc4570760301b666$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bc4570760301b666$var$Arr($bc4570760301b666$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bc4570760301b666$var$revLookup[b64.charCodeAt(i)] << 18 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bc4570760301b666$var$revLookup[b64.charCodeAt(i)] << 2 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bc4570760301b666$var$revLookup[b64.charCodeAt(i)] << 10 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bc4570760301b666$var$tripletToBase64(num) {
    return $bc4570760301b666$var$lookup[num >> 18 & 0x3F] + $bc4570760301b666$var$lookup[num >> 12 & 0x3F] + $bc4570760301b666$var$lookup[num >> 6 & 0x3F] + $bc4570760301b666$var$lookup[num & 0x3F];
}
function $bc4570760301b666$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bc4570760301b666$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $bc4570760301b666$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bc4570760301b666$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bc4570760301b666$var$lookup[tmp >> 2] + $bc4570760301b666$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bc4570760301b666$var$lookup[tmp >> 10] + $bc4570760301b666$var$lookup[tmp >> 4 & 0x3F] + $bc4570760301b666$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("jSbqZ", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $e77bee13fbc24763$export$aafa59e2e03f2942; }, function (v) { return $e77bee13fbc24763$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $e77bee13fbc24763$export$68d8715fc104d294; }, function (v) { return $e77bee13fbc24763$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $e77bee13fbc24763$export$aafa59e2e03f2942;
var $e77bee13fbc24763$export$68d8715fc104d294;
$e77bee13fbc24763$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$e77bee13fbc24763$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("8Dh3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $648f31283277cbcf$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $pGNPI = parcelRequire("pGNPI");

var $2N6Uo = parcelRequire("2N6Uo");

var $5Uet9 = parcelRequire("5Uet9");

var $cirKE = parcelRequire("cirKE");
var $648f31283277cbcf$var$TOUCH_CLICK_DELAY = 300;
var $648f31283277cbcf$var$globalEventSupported = (0, $cirKE.default).domSupported;
var $648f31283277cbcf$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $2N6Uo.map(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $648f31283277cbcf$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $648f31283277cbcf$var$wheelEventSupported = false;
function $648f31283277cbcf$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $648f31283277cbcf$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $648f31283277cbcf$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $648f31283277cbcf$var$normalizeGlobalEvent(instance, event) {
    return (0, $pGNPI.normalizeEvent)(instance.dom, new $648f31283277cbcf$var$FakeGlobalEvent(instance, event), true);
}
function $648f31283277cbcf$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $648f31283277cbcf$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $2N6Uo.noop;
        this.stopImmediatePropagation = $2N6Uo.noop;
        this.preventDefault = $2N6Uo.noop;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $648f31283277cbcf$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function(event) {
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function(event) {
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$648f31283277cbcf$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function(event) {
        $648f31283277cbcf$var$wheelEventSupported = true;
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function(event) {
        if ($648f31283277cbcf$var$wheelEventSupported) return;
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function(event) {
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        $648f31283277cbcf$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $648f31283277cbcf$var$localDOMHandlers.mousemove.call(this, event);
        $648f31283277cbcf$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        $648f31283277cbcf$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $648f31283277cbcf$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        $648f31283277cbcf$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $648f31283277cbcf$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $648f31283277cbcf$var$TOUCH_CLICK_DELAY) $648f31283277cbcf$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $648f31283277cbcf$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$648f31283277cbcf$var$isPointerFromTouch(event)) $648f31283277cbcf$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $648f31283277cbcf$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$648f31283277cbcf$var$isPointerFromTouch(event)) $648f31283277cbcf$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$2N6Uo.each([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $648f31283277cbcf$var$localDOMHandlers[name] = function(event) {
        event = (0, $pGNPI.normalizeEvent)(this.dom, event);
        this.trigger(name, event);
    };
});
var $648f31283277cbcf$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$648f31283277cbcf$var$isPointerFromTouch(event)) $648f31283277cbcf$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $648f31283277cbcf$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $648f31283277cbcf$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $cirKE.default).pointerEventsSupported) $2N6Uo.each($648f31283277cbcf$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $648f31283277cbcf$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $cirKE.default).touchEventsSupported) $2N6Uo.each($648f31283277cbcf$var$localNativeListenerNames.touch, function(nativeEventName) {
            $648f31283277cbcf$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $648f31283277cbcf$var$setTouchTimer(scope);
            });
        });
        $2N6Uo.each($648f31283277cbcf$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $648f31283277cbcf$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $pGNPI.getNativeEvent)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $648f31283277cbcf$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $cirKE.default).pointerEventsSupported) $2N6Uo.each($648f31283277cbcf$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $cirKE.default).touchEventsSupported) $2N6Uo.each($648f31283277cbcf$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $pGNPI.getNativeEvent)(event);
            if (!$648f31283277cbcf$var$isLocalEl(instance, event.target)) {
                event = $648f31283277cbcf$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $648f31283277cbcf$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $648f31283277cbcf$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $pGNPI.addEventListener)(scope.domTarget, nativeEventName, listener, opt);
}
function $648f31283277cbcf$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $pGNPI.removeEventListener)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $648f31283277cbcf$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $648f31283277cbcf$var$HandlerDomProxy = function(_super) {
    (0, $9nEce.__extends)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $648f31283277cbcf$var$DOMHandlerScope(dom, $648f31283277cbcf$var$localDOMHandlers);
        if ($648f31283277cbcf$var$globalEventSupported) _this._globalHandlerScope = new $648f31283277cbcf$var$DOMHandlerScope(document, $648f31283277cbcf$var$globalDOMHandlers);
        $648f31283277cbcf$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $648f31283277cbcf$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($648f31283277cbcf$var$globalEventSupported) $648f31283277cbcf$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($648f31283277cbcf$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $648f31283277cbcf$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $648f31283277cbcf$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $5Uet9.default));
var $648f31283277cbcf$export$2e2bcd8739ae039 = $648f31283277cbcf$var$HandlerDomProxy;

});

parcelRegister("4cadX", function(module, exports) {

$parcel$export(module.exports, "devicePixelRatio", function () { return $30e036b4bfd1cb50$export$508f096bfcdaac40; });
$parcel$export(module.exports, "DARK_MODE_THRESHOLD", function () { return $30e036b4bfd1cb50$export$fd81e7ebc7dae256; });
$parcel$export(module.exports, "DARK_LABEL_COLOR", function () { return $30e036b4bfd1cb50$export$f8ce94761f39398d; });
$parcel$export(module.exports, "LIGHT_LABEL_COLOR", function () { return $30e036b4bfd1cb50$export$3c6e95f318c8369b; });
$parcel$export(module.exports, "LIGHTER_LABEL_COLOR", function () { return $30e036b4bfd1cb50$export$27682248795c3c6b; });

var $cirKE = parcelRequire("cirKE");
var $30e036b4bfd1cb50$var$dpr = 1;
if ((0, $cirKE.default).hasGlobalWindow) $30e036b4bfd1cb50$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $30e036b4bfd1cb50$export$7cdcde344c85339c = 0;
var $30e036b4bfd1cb50$export$508f096bfcdaac40 = $30e036b4bfd1cb50$var$dpr;
var $30e036b4bfd1cb50$export$fd81e7ebc7dae256 = 0.4;
var $30e036b4bfd1cb50$export$f8ce94761f39398d = '#333';
var $30e036b4bfd1cb50$export$3c6e95f318c8369b = '#ccc';
var $30e036b4bfd1cb50$export$27682248795c3c6b = '#eee';

});

parcelRegister("iQonF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db7ffed2fe8c11ab$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $eNN5M = parcelRequire("eNN5M");

var $67W72 = parcelRequire("67W72");
var $db7ffed2fe8c11ab$var$Group = function(_super) {
    (0, $9nEce.__extends)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $2N6Uo.indexOf(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $2N6Uo.indexOf(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $67W72.default)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $67W72.default).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $eNN5M.default));
$db7ffed2fe8c11ab$var$Group.prototype.type = 'group';
var $db7ffed2fe8c11ab$export$2e2bcd8739ae039 = $db7ffed2fe8c11ab$var$Group;

});
parcelRegister("eNN5M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac6bb90122402ba5$export$2e2bcd8739ae039; });

var $erz95 = parcelRequire("erz95");

var $GuYp4 = parcelRequire("GuYp4");

var $67W72 = parcelRequire("67W72");

var $5Uet9 = parcelRequire("5Uet9");

var $eVwLk = parcelRequire("eVwLk");

var $2N6Uo = parcelRequire("2N6Uo");

var $4cadX = parcelRequire("4cadX");

var $3UxDF = parcelRequire("3UxDF");

var $fde2h = parcelRequire("fde2h");

var $19Ywy = parcelRequire("19Ywy");
var $ac6bb90122402ba5$export$97b5e845c7286801 = '__zr_normal__';
var $ac6bb90122402ba5$var$PRIMARY_STATES_KEYS = (0, $erz95.TRANSFORMABLE_PROPS).concat([
    'ignore'
]);
var $ac6bb90122402ba5$var$DEFAULT_ANIMATABLE_MAP = (0, $2N6Uo.reduce)((0, $erz95.TRANSFORMABLE_PROPS), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $ac6bb90122402ba5$var$tmpTextPosCalcRes = {};
var $ac6bb90122402ba5$var$tmpBoundingRect = new (0, $67W72.default)(0, 0, 0, 0);
var $ac6bb90122402ba5$var$tmpInnerTextTrans = [];
var $ac6bb90122402ba5$var$Element = function() {
    function Element(props) {
        this.id = (0, $2N6Uo.guid)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            var hasPosition = textConfig.position != null;
            var autoOverflowArea = textConfig.autoOverflowArea;
            var layoutRect = void 0;
            if (autoOverflowArea || hasPosition) {
                layoutRect = $ac6bb90122402ba5$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
            }
            if (hasPosition) {
                if (this.calculateTextPosition) this.calculateTextPosition($ac6bb90122402ba5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $eVwLk.calculateTextPosition)($ac6bb90122402ba5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $ac6bb90122402ba5$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $ac6bb90122402ba5$var$tmpTextPosCalcRes.y;
                textAlign = $ac6bb90122402ba5$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $ac6bb90122402ba5$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $eVwLk.parsePercent)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $eVwLk.parsePercent)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            if (autoOverflowArea) {
                var overflowRect = innerTextDefaultStyle.overflowRect = innerTextDefaultStyle.overflowRect || new (0, $67W72.default)(0, 0, 0, 0);
                innerTransformable.getLocalTransform($ac6bb90122402ba5$var$tmpInnerTextTrans);
                (0, $19Ywy.invert)($ac6bb90122402ba5$var$tmpInnerTextTrans, $ac6bb90122402ba5$var$tmpInnerTextTrans);
                (0, $67W72.default).copy(overflowRect, layoutRect);
                overflowRect.applyTransform($ac6bb90122402ba5$var$tmpInnerTextTrans);
            } else innerTextDefaultStyle.overflowRect = null;
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $fde2h.REDRAW_BIT);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $4cadX.LIGHT_LABEL_COLOR) : (0, $4cadX.DARK_LABEL_COLOR);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $3UxDF.parse)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $3UxDF.stringify)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $2N6Uo.extend)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $2N6Uo.isObject)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $2N6Uo.keys)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $ac6bb90122402ba5$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $ac6bb90122402ba5$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($ac6bb90122402ba5$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $ac6bb90122402ba5$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $2N6Uo.indexOf)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $2N6Uo.logError)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $fde2h.REDRAW_BIT);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $fde2h.REDRAW_BIT);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var el = this;
        while(el){
            if (el.silent) return true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return false;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $2N6Uo.indexOf)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $2N6Uo.indexOf)(currentStates, oldState);
        var newStateExists = (0, $2N6Uo.indexOf)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $2N6Uo.extend)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $2N6Uo.extend)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $2N6Uo.extend)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $2N6Uo.extend)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $ac6bb90122402ba5$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $ac6bb90122402ba5$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $ac6bb90122402ba5$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $erz95.default)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $2N6Uo.extend)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $fde2h.REDRAW_BIT);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $GuYp4.default)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $2N6Uo.indexOf)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $ac6bb90122402ba5$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $ac6bb90122402ba5$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $ac6bb90122402ba5$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = elProto.silent = elProto.ignoreHostSilent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = elProto.__inHover = false;
        elProto.__dirty = (0, $fde2h.REDRAW_BIT);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $2N6Uo.mixin)($ac6bb90122402ba5$var$Element, (0, $5Uet9.default));
(0, $2N6Uo.mixin)($ac6bb90122402ba5$var$Element, (0, $erz95.default));
function $ac6bb90122402ba5$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $ac6bb90122402ba5$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $ac6bb90122402ba5$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $ac6bb90122402ba5$var$is2DArray(value) {
    return (0, $2N6Uo.isArrayLike)(value[0]);
}
function $ac6bb90122402ba5$var$copyValue(target, source, key) {
    if ((0, $2N6Uo.isArrayLike)(source[key])) {
        if (!(0, $2N6Uo.isArrayLike)(target[key])) target[key] = [];
        if ((0, $2N6Uo.isTypedArray)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $ac6bb90122402ba5$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($ac6bb90122402ba5$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $ac6bb90122402ba5$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $ac6bb90122402ba5$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $ac6bb90122402ba5$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $2N6Uo.isArrayLike)(val1) && (0, $2N6Uo.isArrayLike)(val2) && $ac6bb90122402ba5$var$is1DArraySame(val1, val2);
}
function $ac6bb90122402ba5$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $ac6bb90122402ba5$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $2N6Uo.keys)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $2N6Uo.isObject)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $2N6Uo.isObject)(targetVal) && !(0, $2N6Uo.isArrayLike)(targetVal) && !(0, $2N6Uo.isGradientObject)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $ac6bb90122402ba5$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $2N6Uo.indexOf)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $2N6Uo.filter)(animationKeys, function(key) {
            return !$ac6bb90122402ba5$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $GuYp4.cloneValue)(animateObj[innerKey]);
                $ac6bb90122402ba5$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $GuYp4.default)(animateObj, false, false, additive ? (0, $2N6Uo.filter)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $ac6bb90122402ba5$export$2e2bcd8739ae039 = $ac6bb90122402ba5$var$Element;

});
parcelRegister("erz95", function(module, exports) {

$parcel$export(module.exports, "copyTransform", function () { return $a83ed98120044121$export$234b1c16dfa57d6a; });
$parcel$export(module.exports, "TRANSFORMABLE_PROPS", function () { return $a83ed98120044121$export$98ab6203ec3396e2; });
$parcel$export(module.exports, "default", function () { return $a83ed98120044121$export$2e2bcd8739ae039; });

var $19Ywy = parcelRequire("19Ywy");

var $U1aqY = parcelRequire("U1aqY");
var $a83ed98120044121$var$mIdentity = $19Ywy.identity;
var $a83ed98120044121$var$EPSILON = 5e-5;
function $a83ed98120044121$var$isNotAroundZero(val) {
    return val > $a83ed98120044121$var$EPSILON || val < -$a83ed98120044121$var$EPSILON;
}
var $a83ed98120044121$var$scaleTmp = [];
var $a83ed98120044121$var$tmpTransform = [];
var $a83ed98120044121$var$originTransform = $19Ywy.create();
var $a83ed98120044121$var$abs = Math.abs;
var $a83ed98120044121$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $a83ed98120044121$var$isNotAroundZero(this.rotation) || $a83ed98120044121$var$isNotAroundZero(this.x) || $a83ed98120044121$var$isNotAroundZero(this.y) || $a83ed98120044121$var$isNotAroundZero(this.scaleX - 1) || $a83ed98120044121$var$isNotAroundZero(this.scaleY - 1) || $a83ed98120044121$var$isNotAroundZero(this.skewX) || $a83ed98120044121$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $a83ed98120044121$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $19Ywy.create();
        if (needLocalTransform) this.getLocalTransform(m);
        else $a83ed98120044121$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $19Ywy.mul(m, parentTransform, m);
            else $19Ywy.copy(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($a83ed98120044121$var$scaleTmp);
            var relX = $a83ed98120044121$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $a83ed98120044121$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($a83ed98120044121$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $a83ed98120044121$var$scaleTmp[0] || 0;
            var sy = (($a83ed98120044121$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $a83ed98120044121$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $19Ywy.create();
        $19Ywy.invert(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $19Ywy.create();
            $19Ywy.mul($a83ed98120044121$var$tmpTransform, parent.invTransform, m);
            m = $a83ed98120044121$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $a83ed98120044121$var$originTransform[4] = ox;
            $a83ed98120044121$var$originTransform[5] = oy;
            $19Ywy.mul($a83ed98120044121$var$tmpTransform, m, $a83ed98120044121$var$originTransform);
            $a83ed98120044121$var$tmpTransform[4] -= ox;
            $a83ed98120044121$var$tmpTransform[5] -= oy;
            m = $a83ed98120044121$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $U1aqY.applyTransform(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $U1aqY.applyTransform(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $a83ed98120044121$var$abs(m[0] - 1) > 1e-10 && $a83ed98120044121$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($a83ed98120044121$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $a83ed98120044121$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $19Ywy.rotate(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $a83ed98120044121$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'anchorX',
    'anchorY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
function $a83ed98120044121$export$234b1c16dfa57d6a(target, source) {
    for(var i = 0; i < $a83ed98120044121$export$98ab6203ec3396e2.length; i++){
        var propName = $a83ed98120044121$export$98ab6203ec3396e2[i];
        target[propName] = source[propName];
    }
}
var $a83ed98120044121$export$2e2bcd8739ae039 = $a83ed98120044121$var$Transformable;

});

parcelRegister("eVwLk", function(module, exports) {

$parcel$export(module.exports, "measureWidth", function () { return $addfcd7c4d2b6277$export$e6849d91c2a0b61f; });
$parcel$export(module.exports, "ensureFontMeasureInfo", function () { return $addfcd7c4d2b6277$export$23ef3ef10b010856; });
$parcel$export(module.exports, "measureCharWidth", function () { return $addfcd7c4d2b6277$export$4e92f5603b5c7bb3; });
$parcel$export(module.exports, "getLineHeight", function () { return $addfcd7c4d2b6277$export$56204a27a2958a55; });
$parcel$export(module.exports, "adjustTextX", function () { return $addfcd7c4d2b6277$export$eb5a525ef00ef9a4; });
$parcel$export(module.exports, "adjustTextY", function () { return $addfcd7c4d2b6277$export$bf7d6802d2badd9; });
$parcel$export(module.exports, "getBoundingRect", function () { return $addfcd7c4d2b6277$export$c381147bfed79d9f; });
$parcel$export(module.exports, "parsePercent", function () { return $addfcd7c4d2b6277$export$e8514cb5a5e2b40f; });
$parcel$export(module.exports, "calculateTextPosition", function () { return $addfcd7c4d2b6277$export$eee3603b512feab7; });

var $67W72 = parcelRequire("67W72");

var $aceTf = parcelRequire("aceTf");

var $3WHoM = parcelRequire("3WHoM");
function $addfcd7c4d2b6277$export$3c49c185de0c2bfc(text, font) {
    return $addfcd7c4d2b6277$export$e6849d91c2a0b61f($addfcd7c4d2b6277$export$23ef3ef10b010856(font), text);
}
function $addfcd7c4d2b6277$export$23ef3ef10b010856(font) {
    if (!$addfcd7c4d2b6277$var$_fontMeasureInfoCache) $addfcd7c4d2b6277$var$_fontMeasureInfoCache = new (0, $aceTf.default)(100);
    font = font || (0, $3WHoM.DEFAULT_FONT);
    var measureInfo = $addfcd7c4d2b6277$var$_fontMeasureInfoCache.get(font);
    if (!measureInfo) {
        measureInfo = {
            font: font,
            strWidthCache: new (0, $aceTf.default)(500),
            asciiWidthMap: null,
            asciiWidthMapTried: false,
            stWideCharWidth: (0, $3WHoM.platformApi).measureText("\u56FD", font).width,
            asciiCharWidth: (0, $3WHoM.platformApi).measureText('a', font).width
        };
        $addfcd7c4d2b6277$var$_fontMeasureInfoCache.put(font, measureInfo);
    }
    return measureInfo;
}
var $addfcd7c4d2b6277$var$_fontMeasureInfoCache;
function $addfcd7c4d2b6277$var$tryCreateASCIIWidthMap(font) {
    if ($addfcd7c4d2b6277$var$_getASCIIWidthMapLongCount >= $addfcd7c4d2b6277$var$GET_ASCII_WIDTH_LONG_COUNT_MAX) return;
    font = font || (0, $3WHoM.DEFAULT_FONT);
    var asciiWidthMap = [];
    var start = +new Date();
    for(var code = 0; code <= 127; code++)asciiWidthMap[code] = (0, $3WHoM.platformApi).measureText(String.fromCharCode(code), font).width;
    var cost = +new Date() - start;
    if (cost > 16) $addfcd7c4d2b6277$var$_getASCIIWidthMapLongCount = $addfcd7c4d2b6277$var$GET_ASCII_WIDTH_LONG_COUNT_MAX;
    else if (cost > 2) $addfcd7c4d2b6277$var$_getASCIIWidthMapLongCount++;
    return asciiWidthMap;
}
var $addfcd7c4d2b6277$var$_getASCIIWidthMapLongCount = 0;
var $addfcd7c4d2b6277$var$GET_ASCII_WIDTH_LONG_COUNT_MAX = 5;
function $addfcd7c4d2b6277$export$4e92f5603b5c7bb3(fontMeasureInfo, charCode) {
    if (!fontMeasureInfo.asciiWidthMapTried) {
        fontMeasureInfo.asciiWidthMap = $addfcd7c4d2b6277$var$tryCreateASCIIWidthMap(fontMeasureInfo.font);
        fontMeasureInfo.asciiWidthMapTried = true;
    }
    return 0 <= charCode && charCode <= 127 ? fontMeasureInfo.asciiWidthMap != null ? fontMeasureInfo.asciiWidthMap[charCode] : fontMeasureInfo.asciiCharWidth : fontMeasureInfo.stWideCharWidth;
}
function $addfcd7c4d2b6277$export$e6849d91c2a0b61f(fontMeasureInfo, text) {
    var strWidthCache = fontMeasureInfo.strWidthCache;
    var width = strWidthCache.get(text);
    if (width == null) {
        width = (0, $3WHoM.platformApi).measureText(text, fontMeasureInfo.font).width;
        strWidthCache.put(text, width);
    }
    return width;
}
function $addfcd7c4d2b6277$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $addfcd7c4d2b6277$export$e6849d91c2a0b61f($addfcd7c4d2b6277$export$23ef3ef10b010856(font), text);
    var height = $addfcd7c4d2b6277$export$56204a27a2958a55(font);
    var x = $addfcd7c4d2b6277$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $addfcd7c4d2b6277$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $67W72.default)(x, y, width, height);
    return rect;
}
function $addfcd7c4d2b6277$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $addfcd7c4d2b6277$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $67W72.default)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $addfcd7c4d2b6277$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $addfcd7c4d2b6277$export$eb5a525ef00ef9a4(x, width, textAlign, inverse) {
    if (textAlign === 'right') !inverse ? x -= width : x += width;
    else if (textAlign === 'center') !inverse ? x -= width / 2 : x += width / 2;
    return x;
}
function $addfcd7c4d2b6277$export$bf7d6802d2badd9(y, height, verticalAlign, inverse) {
    if (verticalAlign === 'middle') !inverse ? y -= height / 2 : y += height / 2;
    else if (verticalAlign === 'bottom') !inverse ? y -= height : y += height;
    return y;
}
function $addfcd7c4d2b6277$export$56204a27a2958a55(font) {
    return $addfcd7c4d2b6277$export$23ef3ef10b010856(font).stWideCharWidth;
}
function $addfcd7c4d2b6277$export$866cc30a33805630(text, font) {
    return (0, $3WHoM.platformApi).measureText(text, font);
}
function $addfcd7c4d2b6277$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $addfcd7c4d2b6277$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $addfcd7c4d2b6277$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $addfcd7c4d2b6277$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}

});




parcelRegister("jyf7V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3bced2cce782084$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $b8YKU = parcelRequire("b8YKU");

var $eLD2b = parcelRequire("eLD2b");

var $5eOMx = parcelRequire("5eOMx");

var $6VFOB = parcelRequire("6VFOB");

var $c69Sq = parcelRequire("c69Sq");

var $1E7rO = parcelRequire("1E7rO");

var $byzwF = parcelRequire("byzwF");
// -----------------------
// Internal method names:
// -----------------------
var $e3bced2cce782084$var$reCreateSeriesIndices;
var $e3bced2cce782084$var$assertSeriesInitialized;
var $e3bced2cce782084$var$initBase;
var $e3bced2cce782084$var$OPTION_INNER_KEY = '\0_ec_inner';
var $e3bced2cce782084$var$OPTION_INNER_VALUE = 1;
var $e3bced2cce782084$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    matrix: 'MatrixComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $e3bced2cce782084$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    chord: 'ChordChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $e3bced2cce782084$var$componetsMissingLogPrinted = {};
function $e3bced2cce782084$var$checkMissingComponents(option) {
    (0, $2N6Uo.each)(option, function(componentOption, mainType) {
        if (!(0, $eLD2b.default).hasClass(mainType)) {
            var componentImportName = $e3bced2cce782084$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$e3bced2cce782084$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $byzwF.error)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $e3bced2cce782084$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $e3bced2cce782084$var$GlobalModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $b8YKU.default)(theme);
        this._locale = new (0, $b8YKU.default)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $e3bced2cce782084$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $e3bced2cce782084$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $e3bced2cce782084$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $2N6Uo.each)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $2N6Uo.createHashMap)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $6VFOB.resetSourceDefaulter)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $2N6Uo.each)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $eLD2b.default).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $2N6Uo.clone)(componentOption) : (0, $2N6Uo.merge)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $eLD2b.default).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $eLD2b.default).topologicalTravel(newCmptTypes, (0, $eLD2b.default).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $c69Sq.concatInternalOptions)(this, mainType, $bx3T8.normalizeToArray(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $bx3T8.mappingToExists(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $bx3T8.setComponentTypeToKeyInfo(mappingResult, mainType, (0, $eLD2b.default));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $2N6Uo.each)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $eLD2b.default).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === 'tooltip') {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $2N6Uo.extend)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $2N6Uo.extend)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === 'series') $e3bced2cce782084$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $e3bced2cce782084$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $2N6Uo.clone)(this.option);
        (0, $2N6Uo.each)(option, function(optInMainType, mainType) {
            if ((0, $eLD2b.default).hasClass(mainType)) {
                var opts = $bx3T8.normalizeToArray(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$bx3T8.isComponentIdInternal(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$e3bced2cce782084$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.setTheme = function(theme) {
        this._theme = new (0, $b8YKU.default)(theme);
        this._resetOption('recreate', null);
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $2N6Uo.each)($bx3T8.normalizeToArray(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $e3bced2cce782084$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $e3bced2cce782084$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $2N6Uo.filter)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $e3bced2cce782084$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $2N6Uo.filter)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($e3bced2cce782084$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $2N6Uo.filter)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $2N6Uo.isFunction)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $2N6Uo.isString)(mainType) ? componentsMap.get(mainType) : (0, $2N6Uo.isObject)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $bx3T8.convertOptionIdName(name, null);
        return (0, $2N6Uo.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $2N6Uo.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $2N6Uo.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $e3bced2cce782084$var$assertSeriesInitialized(this);
        (0, $2N6Uo.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $2N6Uo.each)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $e3bced2cce782084$var$assertSeriesInitialized(this);
        (0, $2N6Uo.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $2N6Uo.each)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $e3bced2cce782084$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $e3bced2cce782084$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $2N6Uo.each)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $2N6Uo.createHashMap)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $e3bced2cce782084$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $eLD2b.default).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $eLD2b.default).topologicalTravel(componentTypes, (0, $eLD2b.default).getAllClassMainTypes(), function(componentType) {
            (0, $2N6Uo.each)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$e3bced2cce782084$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $e3bced2cce782084$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $2N6Uo.each)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $2N6Uo.createHashMap)(seriesIndices);
        };
        $e3bced2cce782084$var$assertSeriesInitialized = function(ecModel) {};
        $e3bced2cce782084$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$e3bced2cce782084$var$OPTION_INNER_KEY] = $e3bced2cce782084$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $2N6Uo.createHashMap)({
                series: []
            });
            ecModel._componentsCount = (0, $2N6Uo.createHashMap)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $2N6Uo.isObject)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $e3bced2cce782084$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $2N6Uo.merge)(baseOption, (0, $5eOMx.default), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $b8YKU.default));
function $e3bced2cce782084$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $e3bced2cce782084$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $2N6Uo.each)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer || name === 'color' && option.color) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $eLD2b.default).hasClass(name)) {
            if (typeof themeItem === 'object') option[name] = !option[name] ? (0, $2N6Uo.clone)(themeItem) : (0, $2N6Uo.merge)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $e3bced2cce782084$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $2N6Uo.isArray)(idOrName)) {
        var keyMap_1 = (0, $2N6Uo.createHashMap)();
        (0, $2N6Uo.each)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $bx3T8.convertOptionIdName(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $2N6Uo.filter)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $bx3T8.convertOptionIdName(idOrName, null);
        return (0, $2N6Uo.filter)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $e3bced2cce782084$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $2N6Uo.filter)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $e3bced2cce782084$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $2N6Uo.createHashMap)();
    opts && (0, $2N6Uo.each)($bx3T8.normalizeToArray(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $2N6Uo.mixin)($e3bced2cce782084$var$GlobalModel, (0, $1E7rO.PaletteMixin));
var $e3bced2cce782084$export$2e2bcd8739ae039 = $e3bced2cce782084$var$GlobalModel;

});
parcelRegister("bx3T8", function(module, exports) {

$parcel$export(module.exports, "normalizeToArray", function () { return $8655caeebb35c2c2$export$4f07b212a02c8051; });
$parcel$export(module.exports, "defaultEmphasis", function () { return $8655caeebb35c2c2$export$abdcc6a26372f94b; });
$parcel$export(module.exports, "TEXT_STYLE_OPTIONS", function () { return $8655caeebb35c2c2$export$df45610347a602ad; });
$parcel$export(module.exports, "getDataItemValue", function () { return $8655caeebb35c2c2$export$2c944e12edb48d4b; });
$parcel$export(module.exports, "isDataItemOption", function () { return $8655caeebb35c2c2$export$3e1a543f33ef6883; });
$parcel$export(module.exports, "mappingToExists", function () { return $8655caeebb35c2c2$export$574f818966e4da87; });
$parcel$export(module.exports, "isComponentIdInternal", function () { return $8655caeebb35c2c2$export$feece3e7d52a102b; });
$parcel$export(module.exports, "convertOptionIdName", function () { return $8655caeebb35c2c2$export$fb1a222ba5dd6e51; });
$parcel$export(module.exports, "isNameSpecified", function () { return $8655caeebb35c2c2$export$beae19a2652b3368; });
$parcel$export(module.exports, "makeInternalComponentId", function () { return $8655caeebb35c2c2$export$1753133c42e665e8; });
$parcel$export(module.exports, "setComponentTypeToKeyInfo", function () { return $8655caeebb35c2c2$export$5ac61aca2ba0282d; });
$parcel$export(module.exports, "compressBatches", function () { return $8655caeebb35c2c2$export$6d12cabb0c9bf8e3; });
$parcel$export(module.exports, "queryDataIndex", function () { return $8655caeebb35c2c2$export$42b26cae8b8d10; });
$parcel$export(module.exports, "makeInner", function () { return $8655caeebb35c2c2$export$64df9f8d92ae083f; });
$parcel$export(module.exports, "parseFinder", function () { return $8655caeebb35c2c2$export$95de80076abac814; });
$parcel$export(module.exports, "preParseFinder", function () { return $8655caeebb35c2c2$export$fe600815775d9400; });
$parcel$export(module.exports, "queryReferringComponents", function () { return $8655caeebb35c2c2$export$dc741340f7e5f186; });
$parcel$export(module.exports, "SINGLE_REFERRING", function () { return $8655caeebb35c2c2$export$f076738ec84e693c; });
$parcel$export(module.exports, "MULTIPLE_REFERRING", function () { return $8655caeebb35c2c2$export$48d598924ce4892c; });
$parcel$export(module.exports, "setAttribute", function () { return $8655caeebb35c2c2$export$9fec4d97f1922e0b; });
$parcel$export(module.exports, "getAttribute", function () { return $8655caeebb35c2c2$export$735ee1799fd02602; });
$parcel$export(module.exports, "getTooltipRenderMode", function () { return $8655caeebb35c2c2$export$cc0a17a5d27b4e17; });
$parcel$export(module.exports, "groupData", function () { return $8655caeebb35c2c2$export$7ab5bda43e13168f; });
$parcel$export(module.exports, "interpolateRawValues", function () { return $8655caeebb35c2c2$export$bd0439821a1869f3; });
$parcel$export(module.exports, "ListIterator", function () { return $8655caeebb35c2c2$export$4e38036c4470d56c; });
$parcel$export(module.exports, "clearTmpModel", function () { return $8655caeebb35c2c2$export$be44d6593b016f3e; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $cirKE = parcelRequire("cirKE");

var $iCU10 = parcelRequire("iCU10");

function $8655caeebb35c2c2$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $8655caeebb35c2c2$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $8655caeebb35c2c2$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $8655caeebb35c2c2$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $8655caeebb35c2c2$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $8655caeebb35c2c2$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
];
function $8655caeebb35c2c2$export$2c944e12edb48d4b(dataItem) {
    return (0, $2N6Uo.isObject)(dataItem) && !(0, $2N6Uo.isArray)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $8655caeebb35c2c2$export$3e1a543f33ef6883(dataItem) {
    return (0, $2N6Uo.isObject)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $8655caeebb35c2c2$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $2N6Uo.createHashMap)();
    // Validate id and name on user input option.
    (0, $2N6Uo.each)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $2N6Uo.isObject)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $8655caeebb35c2c2$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $8655caeebb35c2c2$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $8655caeebb35c2c2$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $8655caeebb35c2c2$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $8655caeebb35c2c2$var$mappingInReplaceAllMode(result, newCmptOptions);
    $8655caeebb35c2c2$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $8655caeebb35c2c2$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $8655caeebb35c2c2$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $8655caeebb35c2c2$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $2N6Uo.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $8655caeebb35c2c2$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $2N6Uo.assert)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $8655caeebb35c2c2$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $2N6Uo.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$8655caeebb35c2c2$export$feece3e7d52a102b(cmptOption) && !$8655caeebb35c2c2$export$feece3e7d52a102b(existing) && $8655caeebb35c2c2$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $8655caeebb35c2c2$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $2N6Uo.each)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $8655caeebb35c2c2$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$8655caeebb35c2c2$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $8655caeebb35c2c2$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $2N6Uo.each)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $8655caeebb35c2c2$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $2N6Uo.createHashMap)();
    (0, $2N6Uo.each)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $2N6Uo.each)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $2N6Uo.assert)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $2N6Uo.each)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $2N6Uo.isObject)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $8655caeebb35c2c2$var$makeComparableKey(opt.name) : existing ? existing.name : $8655caeebb35c2c2$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $8655caeebb35c2c2$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $8655caeebb35c2c2$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $8655caeebb35c2c2$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $8655caeebb35c2c2$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $8655caeebb35c2c2$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $8655caeebb35c2c2$var$makeComparableKey(val) {
    return $8655caeebb35c2c2$export$fb1a222ba5dd6e51(val, '');
}
function $8655caeebb35c2c2$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $2N6Uo.isString)(idOrName) ? idOrName : (0, $2N6Uo.isNumber)(idOrName) || (0, $2N6Uo.isStringSafe)(idOrName) ? idOrName + '' : defaultValue;
}
function $8655caeebb35c2c2$var$warnInvalidateIdOrName(idOrName) {}
function $8655caeebb35c2c2$var$isValidIdOrName(idOrName) {
    return (0, $2N6Uo.isStringSafe)(idOrName) || (0, $iCU10.isNumeric)(idOrName);
}
function $8655caeebb35c2c2$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($8655caeebb35c2c2$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $8655caeebb35c2c2$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $8655caeebb35c2c2$var$makeComparableKey(cmptOption.id).indexOf($8655caeebb35c2c2$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $8655caeebb35c2c2$export$1753133c42e665e8(idSuffix) {
    return $8655caeebb35c2c2$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $8655caeebb35c2c2$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $2N6Uo.each)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $2N6Uo.isObject)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $8655caeebb35c2c2$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $8655caeebb35c2c2$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $8655caeebb35c2c2$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $8655caeebb35c2c2$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $8655caeebb35c2c2$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $8655caeebb35c2c2$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $2N6Uo.isArray)(payload.dataIndex) ? (0, $2N6Uo.map)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $2N6Uo.isArray)(payload.name) ? (0, $2N6Uo.map)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $8655caeebb35c2c2$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $8655caeebb35c2c2$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $8655caeebb35c2c2$var$innerUniqueIndex = (0, $iCU10.getRandomIdBase)();
function $8655caeebb35c2c2$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $8655caeebb35c2c2$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $8655caeebb35c2c2$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $8655caeebb35c2c2$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $2N6Uo.isString)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $2N6Uo.createHashMap)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $2N6Uo.each)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illegal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $2N6Uo.indexOf)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $8655caeebb35c2c2$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $8655caeebb35c2c2$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $8655caeebb35c2c2$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $8655caeebb35c2c2$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        if (opt.enableNone) {
            result.models = [];
            return result;
        } else indexOption = -1; // Can not query by index but may still query by id/name if specified.
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        if (opt.enableAll) indexOption = idOption = nameOption = null;
        else indexOption = -1;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $8655caeebb35c2c2$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $8655caeebb35c2c2$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $8655caeebb35c2c2$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $cirKE.default).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $8655caeebb35c2c2$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $2N6Uo.createHashMap)();
    var keys = [];
    (0, $2N6Uo.each)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $8655caeebb35c2c2$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if ((0, $2N6Uo.isNumber)(targetValue)) {
        var value = $8655caeebb35c2c2$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $iCU10.round)(value, isAutoPrecision ? Math.max((0, $iCU10.getPrecision)(sourceValue || 0), (0, $iCU10.getPrecision)(targetValue)) : precision);
    } else if ((0, $2N6Uo.isString)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $8655caeebb35c2c2$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $iCU10.round)(value, isAutoPrecision ? Math.max((0, $iCU10.getPrecision)(leftVal), (0, $iCU10.getPrecision)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}
/**
 * Use an iterator to avoid exposing the internal list or duplicating it
 * for the outside traveller, and no extra heap allocation.
 * @usage
 *  for (const it = resetIterator(); it.next();) {
 *      const item = it.item;
 *      const key = it.key;
 *      const itIdx = it.itIdx;
 *      // ...
 *  }
 * @usage
 *  const it = resetIterator();
 *  while (it.next()) { ... }
 * @usage
 *  for (resetIterator(it); it.next();) { ... }
 */ var $8655caeebb35c2c2$export$4e38036c4470d56c = /** @class */ function() {
    function ListIterator() {}
    /**
   * The loop condition is `idx < end` if `step > 0`;
   * The loop condition is `idx >= end` if `step < 0`.
   *
   * @param end By default `list.length` if `step > 0`; `0` if `step < 0`.
   * @param step By default `1`.
   */ ListIterator.prototype.reset = function(list, start, end, step) {
        this._list = list;
        this._step = step = step || 1;
        this._idx = start;
        this._end = end != null ? end : step > 0 ? list.length : 0;
        this.item = null;
        this.key = NaN;
        return this;
    };
    ListIterator.prototype.next = function() {
        if (this._step > 0 ? this._idx < this._end : this._idx >= this._end) {
            this.item = this._list[this._idx];
            this.key = this._idx = this._idx + this._step;
            return true;
        }
        return false;
    };
    return ListIterator;
}();
function $8655caeebb35c2c2$export$be44d6593b016f3e(model) {
    // Clear to avoid memory leak.
    model.option = model.parentModel = model.ecModel = null;
}

});
parcelRegister("iCU10", function(module, exports) {

$parcel$export(module.exports, "mathMin", function () { return $d8f73a0d638c9805$export$e411eeaf23dccbe8; });
$parcel$export(module.exports, "mathMax", function () { return $d8f73a0d638c9805$export$2ca8010d037f830f; });
$parcel$export(module.exports, "mathAbs", function () { return $d8f73a0d638c9805$export$5860c226b237d9a6; });
$parcel$export(module.exports, "linearMap", function () { return $d8f73a0d638c9805$export$d3f68fbaa670562; });
$parcel$export(module.exports, "parsePercent", function () { return $d8f73a0d638c9805$export$e8514cb5a5e2b40f; });
$parcel$export(module.exports, "parsePositionSizeOption", function () { return $d8f73a0d638c9805$export$6b392db7c2374a1a; });
$parcel$export(module.exports, "round", function () { return $d8f73a0d638c9805$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "asc", function () { return $d8f73a0d638c9805$export$debe6e778e0a6d32; });
$parcel$export(module.exports, "getPrecision", function () { return $d8f73a0d638c9805$export$e0c74b50bbd10f68; });
$parcel$export(module.exports, "getPixelPrecision", function () { return $d8f73a0d638c9805$export$666260d9a2dda8a7; });
$parcel$export(module.exports, "getPercentSeats", function () { return $d8f73a0d638c9805$export$222dabb13d5320df; });
$parcel$export(module.exports, "addSafe", function () { return $d8f73a0d638c9805$export$d3389a301c3a5706; });
$parcel$export(module.exports, "MAX_SAFE_INTEGER", function () { return $d8f73a0d638c9805$export$18510406f204a1b9; });
$parcel$export(module.exports, "remRadian", function () { return $d8f73a0d638c9805$export$2ca6dd70a288b1c3; });
$parcel$export(module.exports, "isRadianAroundZero", function () { return $d8f73a0d638c9805$export$d1df570aea2868f; });
$parcel$export(module.exports, "parseDate", function () { return $d8f73a0d638c9805$export$6b862160d295c8e; });
$parcel$export(module.exports, "quantity", function () { return $d8f73a0d638c9805$export$82dd68b83a44b253; });
$parcel$export(module.exports, "quantityExponent", function () { return $d8f73a0d638c9805$export$97256a17b20a0c24; });
$parcel$export(module.exports, "nice", function () { return $d8f73a0d638c9805$export$7a695fe44258210b; });
$parcel$export(module.exports, "quantile", function () { return $d8f73a0d638c9805$export$651fb4afdb6caa4b; });
$parcel$export(module.exports, "reformIntervals", function () { return $d8f73a0d638c9805$export$12f7386070bc380a; });
$parcel$export(module.exports, "numericToNumber", function () { return $d8f73a0d638c9805$export$8b4007b942b45a96; });
$parcel$export(module.exports, "isNumeric", function () { return $d8f73a0d638c9805$export$e90fb89750dba83f; });
$parcel$export(module.exports, "getRandomIdBase", function () { return $d8f73a0d638c9805$export$474d2ec9aa44a22; });
$parcel$export(module.exports, "getLeastCommonMultiple", function () { return $d8f73a0d638c9805$export$680a45b749323f49; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $d8f73a0d638c9805$var$RADIAN_EPSILON = 1e-4;
// Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $d8f73a0d638c9805$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $d8f73a0d638c9805$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
var $d8f73a0d638c9805$export$e411eeaf23dccbe8 = Math.min;
var $d8f73a0d638c9805$export$2ca8010d037f830f = Math.max;
var $d8f73a0d638c9805$export$5860c226b237d9a6 = Math.abs;
function $d8f73a0d638c9805$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
var $d8f73a0d638c9805$export$e8514cb5a5e2b40f = $d8f73a0d638c9805$export$249e1c100b47bcef;
function $d8f73a0d638c9805$export$249e1c100b47bcef(option, percentBase, percentOffset) {
    switch(option){
        case 'center':
        case 'middle':
            option = '50%';
            break;
        case 'left':
        case 'top':
            option = '0%';
            break;
        case 'right':
        case 'bottom':
            option = '100%';
            break;
    }
    return $d8f73a0d638c9805$export$6b392db7c2374a1a(option, percentBase, percentOffset);
}
function $d8f73a0d638c9805$export$6b392db7c2374a1a(option, percentBase, percentOffset) {
    if ($2N6Uo.isString(option)) {
        if ($d8f73a0d638c9805$var$_trim(option).match(/%$/)) return parseFloat(option) / 100 * percentBase + (percentOffset || 0);
        return parseFloat(option);
    }
    // Allow flexible input due to backward compatibility.
    return option == null ? NaN : +option;
}
function $d8f73a0d638c9805$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) // FIXME: the default precision should not be provided, since there is no universally adaptable
    //  precision. The caller need to input a precision according to the scenarios.
    precision = 10;
    // Avoid range error
    precision = Math.min(Math.max(0, precision), $d8f73a0d638c9805$var$ROUND_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $d8f73a0d638c9805$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $d8f73a0d638c9805$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $d8f73a0d638c9805$export$6d86ba4ca4984d31(val);
}
function $d8f73a0d638c9805$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $d8f73a0d638c9805$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log($d8f73a0d638c9805$export$5860c226b237d9a6(pixelExtent[1] - pixelExtent[0])) / LN10);
    // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $d8f73a0d638c9805$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $d8f73a0d638c9805$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $d8f73a0d638c9805$export$222dabb13d5320df(valueList, precision) {
    var sum = $2N6Uo.reduce(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = Math.pow(10, precision);
    var votesPerQuota = $2N6Uo.map(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $2N6Uo.map(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $2N6Uo.reduce(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $2N6Uo.map(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $2N6Uo.map(seats, function(seat) {
        return seat / digits;
    });
}
function $d8f73a0d638c9805$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($d8f73a0d638c9805$export$e0c74b50bbd10f68(val0), $d8f73a0d638c9805$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $d8f73a0d638c9805$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $d8f73a0d638c9805$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $d8f73a0d638c9805$export$18510406f204a1b9 = 9007199254740991;
function $d8f73a0d638c9805$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $d8f73a0d638c9805$export$d1df570aea2868f(val) {
    return val > -$d8f73a0d638c9805$var$RADIAN_EPSILON && val < $d8f73a0d638c9805$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $d8f73a0d638c9805$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $d8f73a0d638c9805$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($2N6Uo.isString(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $d8f73a0d638c9805$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $d8f73a0d638c9805$export$82dd68b83a44b253(val) {
    return Math.pow(10, $d8f73a0d638c9805$export$97256a17b20a0c24(val));
}
function $d8f73a0d638c9805$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $d8f73a0d638c9805$export$7a695fe44258210b(val, round) {
    var exponent = $d8f73a0d638c9805$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $d8f73a0d638c9805$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $d8f73a0d638c9805$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $d8f73a0d638c9805$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$2N6Uo.isString(val) || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $d8f73a0d638c9805$export$e90fb89750dba83f(val) {
    return !isNaN($d8f73a0d638c9805$export$8b4007b942b45a96(val));
}
function $d8f73a0d638c9805$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $d8f73a0d638c9805$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $d8f73a0d638c9805$export$a368fd580c0d0fe4(b, a % b);
}
function $d8f73a0d638c9805$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $d8f73a0d638c9805$export$a368fd580c0d0fe4(a, b);
}

});


parcelRegister("b8YKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81cf91e0dc7db0ea$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cirKE = parcelRequire("cirKE");

var $I7Ovw = parcelRequire("I7Ovw");

var $6APHY = parcelRequire("6APHY");

var $cFT3k = parcelRequire("cFT3k");

var $3KFvW = parcelRequire("3KFvW");

var $fqEWa = parcelRequire("fqEWa");

var $2N6Uo = parcelRequire("2N6Uo");
var $81cf91e0dc7db0ea$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $2N6Uo.merge)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $2N6Uo.clone)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $cirKE.default).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $I7Ovw.enableClassExtend)($81cf91e0dc7db0ea$var$Model);
(0, $I7Ovw.enableClassCheck)($81cf91e0dc7db0ea$var$Model);
(0, $2N6Uo.mixin)($81cf91e0dc7db0ea$var$Model, (0, $3KFvW.LineStyleMixin));
(0, $2N6Uo.mixin)($81cf91e0dc7db0ea$var$Model, (0, $fqEWa.ItemStyleMixin));
(0, $2N6Uo.mixin)($81cf91e0dc7db0ea$var$Model, (0, $6APHY.AreaStyleMixin));
(0, $2N6Uo.mixin)($81cf91e0dc7db0ea$var$Model, (0, $cFT3k.default));
var $81cf91e0dc7db0ea$export$2e2bcd8739ae039 = $81cf91e0dc7db0ea$var$Model;

});
parcelRegister("I7Ovw", function(module, exports) {

$parcel$export(module.exports, "parseClassType", function () { return $084a2bcce756756f$export$fbe18865d303bf01; });
$parcel$export(module.exports, "isExtendedClass", function () { return $084a2bcce756756f$export$4f3b818f3dd2d182; });
$parcel$export(module.exports, "enableClassExtend", function () { return $084a2bcce756756f$export$cd4c3a4dca301c70; });
$parcel$export(module.exports, "mountExtend", function () { return $084a2bcce756756f$export$c9c2d87774f1275d; });
$parcel$export(module.exports, "enableClassCheck", function () { return $084a2bcce756756f$export$e1aac4552ae82081; });
$parcel$export(module.exports, "enableClassManagement", function () { return $084a2bcce756756f$export$241315e45585454d; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");
var $084a2bcce756756f$var$TYPE_DELIMITER = '.';
var $084a2bcce756756f$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $084a2bcce756756f$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $084a2bcce756756f$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($084a2bcce756756f$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $084a2bcce756756f$var$checkClassType(componentType) {
    $2N6Uo.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $084a2bcce756756f$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$084a2bcce756756f$var$IS_EXTENDED_CLASS]);
}
function $084a2bcce756756f$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($084a2bcce756756f$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $9nEce.__extends)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $2N6Uo.inherits(ExtendedClass, this);
        }
        $2N6Uo.extend(ExtendedClass.prototype, proto);
        ExtendedClass[$084a2bcce756756f$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $084a2bcce756756f$var$superCall;
        ExtendedClass.superApply = $084a2bcce756756f$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $084a2bcce756756f$var$isESClass(fn) {
    return $2N6Uo.isFunction(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $084a2bcce756756f$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $084a2bcce756756f$var$classBase = Math.round(Math.random() * 10);
function $084a2bcce756756f$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $084a2bcce756756f$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $084a2bcce756756f$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $084a2bcce756756f$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $084a2bcce756756f$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $084a2bcce756756f$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $084a2bcce756756f$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $084a2bcce756756f$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$084a2bcce756756f$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $084a2bcce756756f$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$084a2bcce756756f$var$IS_CONTAINER]) $2N6Uo.each(obj, function(o, type) {
            type !== $084a2bcce756756f$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $084a2bcce756756f$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $2N6Uo.each(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $084a2bcce756756f$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$084a2bcce756756f$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$084a2bcce756756f$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$084a2bcce756756f$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }

});

parcelRegister("6APHY", function(module, exports) {

$parcel$export(module.exports, "AreaStyleMixin", function () { return $4cce3707aa96f329$export$a3a0ed7e2dd84c9e; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4jA7C = parcelRequire("4jA7C");
var $4cce3707aa96f329$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ]
];
var $4cce3707aa96f329$var$getAreaStyle = (0, $4jA7C.default)($4cce3707aa96f329$export$52de6e304d934d85);
var $4cce3707aa96f329$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $4cce3707aa96f329$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();

});
parcelRegister("4jA7C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3244f4d394ea8aaa$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

var $2N6Uo = parcelRequire("2N6Uo");
function $3244f4d394ea8aaa$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $2N6Uo.indexOf(excludes, propName) >= 0 || includes && $2N6Uo.indexOf(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}

});


parcelRegister("cFT3k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93a404ac30f0f1e7$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bysmE = parcelRequire("bysmE");

var $kBKw3 = parcelRequire("kBKw3");
var $93a404ac30f0f1e7$var$PATH_COLOR = [
    'textStyle',
    'color'
];
var $93a404ac30f0f1e7$var$textStyleParams = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'padding',
    'lineHeight',
    'rich',
    'width',
    'height',
    'overflow'
];
// TODO Performance improvement?
var $93a404ac30f0f1e7$var$tmpText = new (0, $kBKw3.default)();
var $93a404ac30f0f1e7$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($93a404ac30f0f1e7$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $bysmE.getFont)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
        };
        for(var i = 0; i < $93a404ac30f0f1e7$var$textStyleParams.length; i++)style[$93a404ac30f0f1e7$var$textStyleParams[i]] = this.getShallow($93a404ac30f0f1e7$var$textStyleParams[i]);
        $93a404ac30f0f1e7$var$tmpText.useStyle(style);
        $93a404ac30f0f1e7$var$tmpText.update();
        return $93a404ac30f0f1e7$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $93a404ac30f0f1e7$export$2e2bcd8739ae039 = $93a404ac30f0f1e7$var$TextStyleMixin;

});
parcelRegister("bysmE", function(module, exports) {

$parcel$export(module.exports, "setLabelStyle", function () { return $8698df3a77bcc4c4$export$9a13992917966657; });
$parcel$export(module.exports, "createTextStyle", function () { return $8698df3a77bcc4c4$export$f8998c3d0a13de59; });
$parcel$export(module.exports, "createTextConfig", function () { return $8698df3a77bcc4c4$export$e149afab8df6e053; });
$parcel$export(module.exports, "labelInner", function () { return $8698df3a77bcc4c4$export$f62786d3261ab0f4; });
$parcel$export(module.exports, "getLabelStatesModels", function () { return $8698df3a77bcc4c4$export$9739a32674be5893; });
$parcel$export(module.exports, "LabelMarginType", function () { return $8698df3a77bcc4c4$export$2b18df2bc75ae422; });
$parcel$export(module.exports, "getFont", function () { return $8698df3a77bcc4c4$export$155316a870a9d61e; });
$parcel$export(module.exports, "setLabelValueAnimation", function () { return $8698df3a77bcc4c4$export$7bdbceaf9ab378f2; });
$parcel$export(module.exports, "animateLabelValue", function () { return $8698df3a77bcc4c4$export$dd6101605f5c186; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kBKw3 = parcelRequire("kBKw3");

var $2N6Uo = parcelRequire("2N6Uo");

var $bwPbQ = parcelRequire("bwPbQ");


var $bx3T8 = parcelRequire("bx3T8");

var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");
var $8698df3a77bcc4c4$var$EMPTY_OBJ = {};
function $8698df3a77bcc4c4$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $bwPbQ.SPECIAL_STATES).length; i++){
        var stateName = (0, $bwPbQ.SPECIAL_STATES)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $8698df3a77bcc4c4$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $2N6Uo.isFunction)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $bwPbQ.SPECIAL_STATES).length; i++){
        var stateName = (0, $bwPbQ.SPECIAL_STATES)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $2N6Uo.retrieve2)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $8698df3a77bcc4c4$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $8698df3a77bcc4c4$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $kBKw3.default);
    var needsCreateText = false;
    for(var i = 0; i < (0, $bwPbQ.DISPLAY_STATES).length; i++){
        var stateModel = labelStatesModels[(0, $bwPbQ.DISPLAY_STATES)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $kBKw3.default)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $8698df3a77bcc4c4$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $8698df3a77bcc4c4$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($8698df3a77bcc4c4$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $bwPbQ.SPECIAL_STATES).length; i++){
            var stateName = (0, $bwPbQ.SPECIAL_STATES)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $2N6Uo.retrieve2)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $8698df3a77bcc4c4$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $8698df3a77bcc4c4$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow('silent');
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $8698df3a77bcc4c4$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $8698df3a77bcc4c4$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $8698df3a77bcc4c4$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $8698df3a77bcc4c4$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $bwPbQ.SPECIAL_STATES).length; i++){
        var stateName = (0, $bwPbQ.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $8698df3a77bcc4c4$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $8698df3a77bcc4c4$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $2N6Uo.extend)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $8698df3a77bcc4c4$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $2N6Uo.retrieve2)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magic type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    if (opt.autoOverflowArea != null) textConfig.autoOverflowArea = opt.autoOverflowArea;
    if (opt.layoutRect != null) textConfig.layoutRect = opt.layoutRect;
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $8698df3a77bcc4c4$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $8698df3a77bcc4c4$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $8698df3a77bcc4c4$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        var richInheritPlainLabelOptionName = 'richInheritPlainLabel';
        var richInheritPlainLabel = (0, $2N6Uo.retrieve2)(textStyleModel.get(richInheritPlainLabelOptionName), ecModel ? ecModel.get(richInheritPlainLabelOptionName) : undefined);
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]);
            // In rich, never `disableBox`.
            // consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            // Since v6, the rich style inherits plain label by default
            // but this behavior can be disabled by setting `richInheritPlainLabel` to `false`.
            $8698df3a77bcc4c4$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, textStyleModel, richInheritPlainLabel, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var lineOverflow = textStyleModel.get('lineOverflow');
    if (lineOverflow) textStyle.lineOverflow = lineOverflow;
    var labelTextStyle = textStyle;
    // `minMargin` has a higher precedence than `textMargin`, because `textMargin` is allowed
    // to be set in `defaultOption`.
    var minMargin = textStyleModel.get('minMargin');
    if (minMargin != null) {
        // `minMargin` only support number value.
        minMargin = !(0, $2N6Uo.isNumber)(minMargin) ? 0 : minMargin / 2;
        labelTextStyle.margin = [
            minMargin,
            minMargin,
            minMargin,
            minMargin
        ];
        labelTextStyle.__marginType = $8698df3a77bcc4c4$export$2b18df2bc75ae422.minMargin;
    } else {
        var textMargin = textStyleModel.get('textMargin');
        if (textMargin != null) {
            labelTextStyle.margin = (0, $2N6Uo.normalizeCssArray)(textMargin);
            labelTextStyle.__marginType = $8698df3a77bcc4c4$export$2b18df2bc75ae422.textMargin;
        }
    }
    $8698df3a77bcc4c4$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, null, null, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $8698df3a77bcc4c4$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $8698df3a77bcc4c4$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $2N6Uo.keys)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $8698df3a77bcc4c4$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $8698df3a77bcc4c4$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign',
    'ellipsis'
];
var $8698df3a77bcc4c4$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $8698df3a77bcc4c4$var$setTokenTextStyle(textStyle, // FIXME: check/refactor for ellipsis handling of rich text.
textStyleModel, globalTextStyle, plainTextModel, richInheritPlainLabel, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $8698df3a77bcc4c4$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $2N6Uo.retrieve2)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) // Might not be a string, e.g, it's a function in axisLabel case; but assume that it will
    // be erased by a correct value outside.
    textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $2N6Uo.retrieve2)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $2N6Uo.retrieve2)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $2N6Uo.retrieve2)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $8698df3a77bcc4c4$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $8698df3a77bcc4c4$var$TEXT_PROPS_WITH_GLOBAL[i];
        // props width, height, padding, margin, tag, backgroundColor, borderColor,
        // borderWidth, borderRadius, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY
        // may inappropriate to inherit from plainTextStyle.
        // And if some props is specified in default options, users may have to reset them one by one.
        // Therefore, we only allow these props to inherit from plainTextStyle.
        // `richInheritPlainLabel` is switch for backward compatibility
        var val = richInheritPlainLabel !== false && plainTextModel ? (0, $2N6Uo.retrieve3)(textStyleModel.getShallow(key), plainTextModel.getShallow(key), globalTextStyle[key]) : (0, $2N6Uo.retrieve2)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $8698df3a77bcc4c4$var$TEXT_PROPS_SELF.length; i++){
        var key = $8698df3a77bcc4c4$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $8698df3a77bcc4c4$var$TEXT_PROPS_BOX.length; i++){
            var key = $8698df3a77bcc4c4$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $8698df3a77bcc4c4$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $2N6Uo.trim)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $8698df3a77bcc4c4$export$f62786d3261ab0f4 = (0, $bx3T8.makeInner)();
function $8698df3a77bcc4c4$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $8698df3a77bcc4c4$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $8698df3a77bcc4c4$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $8698df3a77bcc4c4$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $2N6Uo.retrieve2)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $bx3T8.interpolateRawValues)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $8698df3a77bcc4c4$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $8698df3a77bcc4c4$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $ipprj.initProps) : (0, $ipprj.updateProps))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}
var $8698df3a77bcc4c4$export$2b18df2bc75ae422 = {
    minMargin: 1,
    textMargin: 2
};

});
parcelRegister("kBKw3", function(module, exports) {

$parcel$export(module.exports, "hasSeparateFont", function () { return $f00b5873d4ee286c$export$4685c95d5118e76a; });
$parcel$export(module.exports, "parseFontSize", function () { return $f00b5873d4ee286c$export$51b066d9cfc2578e; });
$parcel$export(module.exports, "default", function () { return $f00b5873d4ee286c$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $1TNic = parcelRequire("1TNic");

var $arPnl = parcelRequire("arPnl");

var $2N6Uo = parcelRequire("2N6Uo");

var $eVwLk = parcelRequire("eVwLk");

var $lQsZt = parcelRequire("lQsZt");

var $aH2k0 = parcelRequire("aH2k0");

var $67W72 = parcelRequire("67W72");

var $6Ekel = parcelRequire("6Ekel");

var $3WHoM = parcelRequire("3WHoM");
var $f00b5873d4ee286c$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $f00b5873d4ee286c$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $f00b5873d4ee286c$var$tmpCITOverflowAreaOut = {};
var $f00b5873d4ee286c$export$21aaaa0607ee0e2b = {
    style: (0, $2N6Uo.defaults)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $6Ekel.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $f00b5873d4ee286c$var$ZRText = function(_super) {
    (0, $9nEce.__extends)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $f00b5873d4ee286c$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $f00b5873d4ee286c$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $67W72.default)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $f00b5873d4ee286c$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $2N6Uo.extend)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $2N6Uo.keys)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $2N6Uo.extend)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $f00b5873d4ee286c$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $3WHoM.DEFAULT_FONT);
        var textPadding = style.padding;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        (0, $1TNic.calcInnerTextOverflowArea)($f00b5873d4ee286c$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $f00b5873d4ee286c$var$tmpCITOverflowAreaOut.baseX;
        baseY = $f00b5873d4ee286c$var$tmpCITOverflowAreaOut.baseY;
        var text = $f00b5873d4ee286c$var$getStyleText(style);
        var contentBlock = (0, $1TNic.parsePlainText)(text, style, $f00b5873d4ee286c$var$tmpCITOverflowAreaOut.outerWidth, $f00b5873d4ee286c$var$tmpCITOverflowAreaOut.outerHeight);
        var needDrawBg = $f00b5873d4ee286c$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        this.isTruncated = !!contentBlock.isTruncated;
        var textX = baseX;
        var textY = (0, $eVwLk.adjustTextY)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $eVwLk.adjustTextX)(baseX, outerWidth, textAlign);
            var boxY = (0, $eVwLk.adjustTextY)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $f00b5873d4ee286c$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var useDefaultFill = false;
        var textFill = $f00b5873d4ee286c$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $f00b5873d4ee286c$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $f00b5873d4ee286c$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $arPnl.default));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $f00b5873d4ee286c$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            el.setBoundingRect((0, $1TNic.tSpanCreateBoundingRect2)(subElStyle, contentBlock.contentWidth, contentBlock.calculatedLineHeight, usingDefaultStroke ? 0 : null));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        (0, $1TNic.calcInnerTextOverflowArea)($f00b5873d4ee286c$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $f00b5873d4ee286c$var$tmpCITOverflowAreaOut.baseX;
        baseY = $f00b5873d4ee286c$var$tmpCITOverflowAreaOut.baseY;
        var text = $f00b5873d4ee286c$var$getStyleText(style);
        var contentBlock = (0, $1TNic.parseRichText)(text, style, $f00b5873d4ee286c$var$tmpCITOverflowAreaOut.outerWidth, $f00b5873d4ee286c$var$tmpCITOverflowAreaOut.outerHeight, textAlign);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        this.isTruncated = !!contentBlock.isTruncated;
        var boxX = (0, $eVwLk.adjustTextX)(baseX, outerWidth, textAlign);
        var boxY = (0, $eVwLk.adjustTextY)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($f00b5873d4ee286c$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $f00b5873d4ee286c$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $f00b5873d4ee286c$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $arPnl.default));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var textFill = $f00b5873d4ee286c$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $f00b5873d4ee286c$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $f00b5873d4ee286c$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $3WHoM.DEFAULT_FONT);
        subElStyle.opacity = (0, $2N6Uo.retrieve3)(tokenStyle.opacity, style.opacity, 1);
        $f00b5873d4ee286c$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $2N6Uo.retrieve3)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $2N6Uo.retrieve2)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        el.setBoundingRect((0, $1TNic.tSpanCreateBoundingRect2)(subElStyle, token.contentWidth, token.contentHeight, usingDefaultStroke ? 0 : null));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $aH2k0.default));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $2N6Uo.retrieve2)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $lQsZt.default));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $2N6Uo.retrieve2)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $2N6Uo.retrieve3)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if ($f00b5873d4ee286c$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $f00b5873d4ee286c$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || 'sans-serif'
        ].join(' ');
        return font && (0, $2N6Uo.trim)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $6Ekel.default));
var $f00b5873d4ee286c$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $f00b5873d4ee286c$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $f00b5873d4ee286c$var$FONT_PARTS = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily'
];
function $f00b5873d4ee286c$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === 'string' && (fontSize.indexOf('px') !== -1 || fontSize.indexOf('rem') !== -1 || fontSize.indexOf('em') !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + 'px';
    else return (0, $3WHoM.DEFAULT_FONT_SIZE) + 'px';
}
function $f00b5873d4ee286c$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $f00b5873d4ee286c$var$FONT_PARTS.length; i++){
        var fontProp = $f00b5873d4ee286c$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $f00b5873d4ee286c$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $f00b5873d4ee286c$export$176336068cc5371f(style) {
    $f00b5873d4ee286c$var$normalizeStyle(style);
    (0, $2N6Uo.each)(style.rich, $f00b5873d4ee286c$var$normalizeStyle);
    return style;
}
function $f00b5873d4ee286c$var$normalizeStyle(style) {
    if (style) {
        style.font = $f00b5873d4ee286c$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $f00b5873d4ee286c$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $f00b5873d4ee286c$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $2N6Uo.normalizeCssArray)(style.padding);
    }
}
function $f00b5873d4ee286c$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $f00b5873d4ee286c$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $f00b5873d4ee286c$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $f00b5873d4ee286c$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $f00b5873d4ee286c$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $f00b5873d4ee286c$export$2e2bcd8739ae039 = $f00b5873d4ee286c$var$ZRText;

});
parcelRegister("1TNic", function(module, exports) {

$parcel$export(module.exports, "parsePlainText", function () { return $162129f5bfc9931d$export$5772575e34ef80f9; });
$parcel$export(module.exports, "parseRichText", function () { return $162129f5bfc9931d$export$15ec9472ff2d721; });
$parcel$export(module.exports, "calcInnerTextOverflowArea", function () { return $162129f5bfc9931d$export$9a4428591d825b14; });
$parcel$export(module.exports, "tSpanCreateBoundingRect", function () { return $162129f5bfc9931d$export$d79289ac0f53b974; });
$parcel$export(module.exports, "tSpanCreateBoundingRect2", function () { return $162129f5bfc9931d$export$bd5d12d7bf7c9027; });
$parcel$export(module.exports, "tSpanHasStroke", function () { return $162129f5bfc9931d$export$c7aae0ffd99a8643; });

var $58ik8 = parcelRequire("58ik8");

var $2N6Uo = parcelRequire("2N6Uo");

var $eVwLk = parcelRequire("eVwLk");

var $67W72 = parcelRequire("67W72");
var $162129f5bfc9931d$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $162129f5bfc9931d$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    var out = {};
    $162129f5bfc9931d$var$truncateText2(out, text, containerWidth, font, ellipsis, options);
    return out.text;
}
function $162129f5bfc9931d$var$truncateText2(out, text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        out.text = '';
        out.isTruncated = false;
        return;
    }
    var textLines = (text + '').split('\n');
    options = $162129f5bfc9931d$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    var isTruncated = false;
    var truncateOut = {};
    for(var i = 0, len = textLines.length; i < len; i++){
        $162129f5bfc9931d$var$truncateSingleLine(truncateOut, textLines[i], options);
        textLines[i] = truncateOut.textLine;
        isTruncated = isTruncated || truncateOut.isTruncated;
    }
    out.text = textLines.join('\n');
    out.isTruncated = isTruncated;
}
function $162129f5bfc9931d$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $2N6Uo.extend)({}, options);
    ellipsis = (0, $2N6Uo.retrieve2)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $2N6Uo.retrieve2)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $2N6Uo.retrieve2)(options.minChar, 0);
    var fontMeasureInfo = preparedOpts.fontMeasureInfo = (0, $eVwLk.ensureFontMeasureInfo)(font);
    var ascCharWidth = fontMeasureInfo.asciiCharWidth;
    preparedOpts.placeholder = (0, $2N6Uo.retrieve2)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $eVwLk.measureWidth)(fontMeasureInfo, ellipsis);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $162129f5bfc9931d$var$truncateSingleLine(out, textLine, options) {
    var containerWidth = options.containerWidth;
    var contentWidth = options.contentWidth;
    var fontMeasureInfo = options.fontMeasureInfo;
    if (!containerWidth) {
        out.textLine = '';
        out.isTruncated = false;
        return;
    }
    var lineWidth = (0, $eVwLk.measureWidth)(fontMeasureInfo, textLine);
    if (lineWidth <= containerWidth) {
        out.textLine = textLine;
        out.isTruncated = false;
        return;
    }
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $162129f5bfc9931d$var$estimateLength(textLine, contentWidth, fontMeasureInfo) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $eVwLk.measureWidth)(fontMeasureInfo, textLine);
    }
    if (textLine === '') textLine = options.placeholder;
    out.textLine = textLine;
    out.isTruncated = true;
}
function $162129f5bfc9931d$var$estimateLength(text, contentWidth, fontMeasureInfo) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++)width += (0, $eVwLk.measureCharWidth)(fontMeasureInfo, text.charCodeAt(i));
    return i;
}
function $162129f5bfc9931d$export$5772575e34ef80f9(rawText, style, defaultOuterWidth, defaultOuterHeight) {
    var text = $162129f5bfc9931d$var$formatText(rawText);
    var overflow = style.overflow;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var paddingV = padding ? padding[0] + padding[2] : 0;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $eVwLk.getLineHeight)(font);
    var lineHeight = (0, $2N6Uo.retrieve2)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var isTruncated = false;
    var width = style.width;
    if (width == null && defaultOuterWidth != null) width = defaultOuterWidth - paddingH;
    var height = style.height;
    if (height == null && defaultOuterHeight != null) height = defaultOuterHeight - paddingV;
    var lines;
    if (width != null && (overflow === 'break' || overflow === 'breakAll')) lines = text ? $162129f5bfc9931d$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    if (height == null) height = contentHeight;
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        isTruncated = isTruncated || lines.length > lineCount;
        lines = lines.slice(0, lineCount);
        contentHeight = lines.length * lineHeight;
    }
    if (text && truncate && width != null) {
        var options = $162129f5bfc9931d$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        var singleOut = {};
        for(var i = 0; i < lines.length; i++){
            $162129f5bfc9931d$var$truncateSingleLine(singleOut, lines[i], options);
            lines[i] = singleOut.textLine;
            isTruncated = isTruncated || singleOut.isTruncated;
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    var fontMeasureInfo = (0, $eVwLk.ensureFontMeasureInfo)(font);
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $eVwLk.measureWidth)(fontMeasureInfo, lines[i]), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = width;
    outerHeight += paddingV;
    outerWidth += paddingH;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width,
        isTruncated: isTruncated
    };
}
var $162129f5bfc9931d$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $162129f5bfc9931d$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $162129f5bfc9931d$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
        this.isTruncated = false;
    }
    return RichTextContentBlock;
}();
function $162129f5bfc9931d$export$15ec9472ff2d721(rawText, style, defaultOuterWidth, defaultOuterHeight, topTextAlign) {
    var contentBlock = new $162129f5bfc9931d$export$ca607d3c98caaf7e();
    var text = $162129f5bfc9931d$var$formatText(rawText);
    if (!text) return contentBlock;
    var stlPadding = style.padding;
    var stlPaddingH = stlPadding ? stlPadding[1] + stlPadding[3] : 0;
    var stlPaddingV = stlPadding ? stlPadding[0] + stlPadding[2] : 0;
    var topWidth = style.width;
    if (topWidth == null && defaultOuterWidth != null) topWidth = defaultOuterWidth - stlPaddingH;
    var topHeight = style.height;
    if (topHeight == null && defaultOuterHeight != null) topHeight = defaultOuterHeight - stlPaddingV;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $162129f5bfc9931d$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $162129f5bfc9931d$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $162129f5bfc9931d$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $162129f5bfc9931d$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $162129f5bfc9931d$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $162129f5bfc9931d$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    var tmpTruncateOut = {};
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $eVwLk.getLineHeight)(font);
            var tokenHeight = (0, $2N6Uo.retrieve2)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $2N6Uo.retrieve3)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || topTextAlign;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                var originalLength = contentBlock.lines.length;
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                contentBlock.isTruncated = contentBlock.isTruncated || contentBlock.lines.length < originalLength;
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $eVwLk.measureWidth)((0, $eVwLk.ensureFontMeasureInfo)(font), token.text);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $58ik8.findExistImage(bgImg);
                        if ($58ik8.isImageReady(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        $162129f5bfc9931d$var$truncateText2(tmpTruncateOut, token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.text = tmpTruncateOut.text;
                        contentBlock.isTruncated = contentBlock.isTruncated || tmpTruncateOut.isTruncated;
                        token.width = token.contentWidth = (0, $eVwLk.measureWidth)((0, $eVwLk.ensureFontMeasureInfo)(font), token.text);
                    }
                } else token.contentWidth = (0, $eVwLk.measureWidth)((0, $eVwLk.ensureFontMeasureInfo)(font), token.text);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $2N6Uo.retrieve2)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $2N6Uo.retrieve2)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    contentBlock.outerWidth += stlPaddingH;
    contentBlock.outerHeight += stlPaddingV;
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $162129f5bfc9931d$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $eVwLk.parsePercent)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $162129f5bfc9931d$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    }
    if (!strLines) strLines = str.split('\n');
    var fontMeasureInfo = (0, $eVwLk.ensureFontMeasureInfo)(font);
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $162129f5bfc9931d$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $eVwLk.measureWidth)(fontMeasureInfo, text);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $162129f5bfc9931d$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $162129f5bfc9931d$var$RichTextLine([
            token
        ]));
    }
}
function $162129f5bfc9931d$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $162129f5bfc9931d$var$breakCharMap = (0, $2N6Uo.reduce)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $162129f5bfc9931d$var$isWordBreakChar(ch) {
    if ($162129f5bfc9931d$var$isAlphabeticLetter(ch)) {
        if ($162129f5bfc9931d$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $162129f5bfc9931d$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    var fontMeasureInfo = (0, $eVwLk.ensureFontMeasureInfo)(font);
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $eVwLk.measureCharWidth)(fontMeasureInfo, ch.charCodeAt(0));
        var inWord = isBreakAll ? false : !$162129f5bfc9931d$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}
function $162129f5bfc9931d$export$9a4428591d825b14(out, overflowRect, baseX, baseY, textAlign, textVerticalAlign) {
    out.baseX = baseX;
    out.baseY = baseY;
    out.outerWidth = out.outerHeight = null;
    if (!overflowRect) return;
    var textWidth = overflowRect.width * 2;
    var textHeight = overflowRect.height * 2;
    (0, $67W72.default).set($162129f5bfc9931d$var$tmpCITCTextRect, (0, $eVwLk.adjustTextX)(baseX, textWidth, textAlign), (0, $eVwLk.adjustTextY)(baseY, textHeight, textVerticalAlign), textWidth, textHeight);
    (0, $67W72.default).intersect(overflowRect, $162129f5bfc9931d$var$tmpCITCTextRect, null, $162129f5bfc9931d$var$tmpCITCIntersectRectOpt);
    var outIntersectRect = $162129f5bfc9931d$var$tmpCITCIntersectRectOpt.outIntersectRect;
    out.outerWidth = outIntersectRect.width;
    out.outerHeight = outIntersectRect.height;
    out.baseX = (0, $eVwLk.adjustTextX)(outIntersectRect.x, outIntersectRect.width, textAlign, true);
    out.baseY = (0, $eVwLk.adjustTextY)(outIntersectRect.y, outIntersectRect.height, textVerticalAlign, true);
}
var $162129f5bfc9931d$var$tmpCITCTextRect = new (0, $67W72.default)(0, 0, 0, 0);
var $162129f5bfc9931d$var$tmpCITCIntersectRectOpt = {
    outIntersectRect: {},
    clamp: true
};
function $162129f5bfc9931d$var$formatText(text) {
    return text != null ? text += '' : text = '';
}
function $162129f5bfc9931d$export$d79289ac0f53b974(style) {
    var text = $162129f5bfc9931d$var$formatText(style.text);
    var font = style.font;
    var contentWidth = (0, $eVwLk.measureWidth)((0, $eVwLk.ensureFontMeasureInfo)(font), text);
    var contentHeight = (0, $eVwLk.getLineHeight)(font);
    return $162129f5bfc9931d$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, null);
}
function $162129f5bfc9931d$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, forceLineWidth) {
    var rect = new (0, $67W72.default)((0, $eVwLk.adjustTextX)(style.x || 0, contentWidth, style.textAlign), (0, $eVwLk.adjustTextY)(style.y || 0, contentHeight, style.textBaseline), contentWidth, contentHeight);
    var lineWidth = forceLineWidth != null ? forceLineWidth : $162129f5bfc9931d$export$c7aae0ffd99a8643(style) ? style.lineWidth : 0;
    if (lineWidth > 0) {
        rect.x -= lineWidth / 2;
        rect.y -= lineWidth / 2;
        rect.width += lineWidth;
        rect.height += lineWidth;
    }
    return rect;
}
function $162129f5bfc9931d$export$c7aae0ffd99a8643(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== 'none' && style.lineWidth > 0;
}

});
parcelRegister("58ik8", function(module, exports) {

$parcel$export(module.exports, "findExistImage", function () { return $3bcbe9d467185337$export$1b614f30ac2c8867; });
$parcel$export(module.exports, "createOrUpdateImage", function () { return $3bcbe9d467185337$export$46c791b69ff9a0f; });
$parcel$export(module.exports, "isImageReady", function () { return $3bcbe9d467185337$export$37ca7dd901d0236d; });

var $aceTf = parcelRequire("aceTf");

var $3WHoM = parcelRequire("3WHoM");
var $3bcbe9d467185337$var$globalImageCache = new (0, $aceTf.default)(50);
function $3bcbe9d467185337$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $3bcbe9d467185337$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $3bcbe9d467185337$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $3bcbe9d467185337$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$3bcbe9d467185337$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $3WHoM.platformApi).loadImage(newImageOrSrc, $3bcbe9d467185337$var$imageOnLoad, $3bcbe9d467185337$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $3bcbe9d467185337$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $3bcbe9d467185337$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $3bcbe9d467185337$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}

});


parcelRegister("arPnl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79b4471eb253b301$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $6Ekel = parcelRequire("6Ekel");

var $4oDJM = parcelRequire("4oDJM");

var $2N6Uo = parcelRequire("2N6Uo");

var $3WHoM = parcelRequire("3WHoM");

var $1TNic = parcelRequire("1TNic");
var $79b4471eb253b301$export$5fbb6d98091bcb56 = (0, $2N6Uo.defaults)({
    strokeFirst: true,
    font: (0, $3WHoM.DEFAULT_FONT),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $4oDJM.DEFAULT_PATH_STYLE));
var $79b4471eb253b301$var$TSpan = function(_super) {
    (0, $9nEce.__extends)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        return (0, $1TNic.tSpanHasStroke)(this.style);
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $2N6Uo.createObject)($79b4471eb253b301$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        if (!this._rect) this._rect = (0, $1TNic.tSpanCreateBoundingRect)(this.style);
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $6Ekel.default));
$79b4471eb253b301$var$TSpan.prototype.type = 'tspan';
var $79b4471eb253b301$export$2e2bcd8739ae039 = $79b4471eb253b301$var$TSpan;

});
parcelRegister("6Ekel", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COMMON_STYLE", function () { return $4d762bdadc909af1$export$737672163db00fe3; });
$parcel$export(module.exports, "DEFAULT_COMMON_ANIMATION_PROPS", function () { return $4d762bdadc909af1$export$9908943fb57fbe51; });
$parcel$export(module.exports, "default", function () { return $4d762bdadc909af1$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $eNN5M = parcelRequire("eNN5M");

var $67W72 = parcelRequire("67W72");

var $2N6Uo = parcelRequire("2N6Uo");

var $fde2h = parcelRequire("fde2h");
var $4d762bdadc909af1$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $4d762bdadc909af1$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $4d762bdadc909af1$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$4d762bdadc909af1$export$737672163db00fe3[$4d762bdadc909af1$var$STYLE_MAGIC_KEY] = true;
var $4d762bdadc909af1$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $4d762bdadc909af1$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $4d762bdadc909af1$var$Displayable = function(_super) {
    (0, $9nEce.__extends)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $2N6Uo.keys)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $4d762bdadc909af1$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths && this.__clipPaths.length) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $67W72.default)(0, 0, 0, 0));
            if (transform) (0, $67W72.default).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $67W72.default)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $2N6Uo.extend)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $fde2h.STYLE_CHANGED_BIT);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $fde2h.STYLE_CHANGED_BIT));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $fde2h.STYLE_CHANGED_BIT);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $2N6Uo.createObject)($4d762bdadc909af1$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$4d762bdadc909af1$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$4d762bdadc909af1$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $4d762bdadc909af1$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $2N6Uo.keys)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $2N6Uo.keys)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $4d762bdadc909af1$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $4d762bdadc909af1$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $2N6Uo.extend)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $4d762bdadc909af1$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $fde2h.REDRAW_BIT) | (0, $fde2h.STYLE_CHANGED_BIT);
    }();
    return Displayable;
}((0, $eNN5M.default));
var $4d762bdadc909af1$var$tmpRect = new (0, $67W72.default)(0, 0, 0, 0);
var $4d762bdadc909af1$var$viewRect = new (0, $67W72.default)(0, 0, 0, 0);
function $4d762bdadc909af1$var$isDisplayableCulled(el, width, height) {
    $4d762bdadc909af1$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $4d762bdadc909af1$var$tmpRect.applyTransform(el.transform);
    $4d762bdadc909af1$var$viewRect.width = width;
    $4d762bdadc909af1$var$viewRect.height = height;
    return !$4d762bdadc909af1$var$tmpRect.intersect($4d762bdadc909af1$var$viewRect);
}
var $4d762bdadc909af1$export$2e2bcd8739ae039 = $4d762bdadc909af1$var$Displayable;

});

parcelRegister("4oDJM", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PATH_STYLE", function () { return $33383a55b1cc1633$export$deade517576e293a; });
$parcel$export(module.exports, "default", function () { return $33383a55b1cc1633$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $6Ekel = parcelRequire("6Ekel");

var $eAFw0 = parcelRequire("eAFw0");

var $kB2Mq = parcelRequire("kB2Mq");

var $2N6Uo = parcelRequire("2N6Uo");

var $3UxDF = parcelRequire("3UxDF");

var $4cadX = parcelRequire("4cadX");

var $fde2h = parcelRequire("fde2h");

var $erz95 = parcelRequire("erz95");
var $33383a55b1cc1633$export$deade517576e293a = (0, $2N6Uo.defaults)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $6Ekel.DEFAULT_COMMON_STYLE));
var $33383a55b1cc1633$export$71bb6c3c6862c6a5 = {
    style: (0, $2N6Uo.defaults)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $6Ekel.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $33383a55b1cc1633$var$pathCopyParams = (0, $erz95.TRANSFORMABLE_PROPS).concat([
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
]);
var $33383a55b1cc1633$var$Path = function(_super) {
    (0, $9nEce.__extends)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $33383a55b1cc1633$var$pathCopyParams.length; ++i)decalEl[$33383a55b1cc1633$var$pathCopyParams[i]] = this[$33383a55b1cc1633$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $fde2h.REDRAW_BIT);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $2N6Uo.keys)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $2N6Uo.extend)(this.style, value);
            } else if (key === 'shape') (0, $2N6Uo.extend)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $2N6Uo.isString)(pathFill)) {
                var fillLum = (0, $3UxDF.lum)(pathFill, 0);
                if (fillLum > 0.5) return 0, $4cadX.DARK_LABEL_COLOR;
                else if (fillLum > 0.2) return 0, $4cadX.LIGHTER_LABEL_COLOR;
                return 0, $4cadX.LIGHT_LABEL_COLOR;
            } else if (pathFill) return 0, $4cadX.LIGHT_LABEL_COLOR;
        }
        return 0, $4cadX.DARK_LABEL_COLOR;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $2N6Uo.isString)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $3UxDF.lum)(textFill, 0) < (0, $4cadX.DARK_MODE_THRESHOLD);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $fde2h.SHAPE_CHANGED_BIT);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $eAFw0.default)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $fde2h.SHAPE_CHANGED_BIT)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($kB2Mq.containStroke(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $kB2Mq.contain(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $fde2h.SHAPE_CHANGED_BIT);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $2N6Uo.extend)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $fde2h.SHAPE_CHANGED_BIT));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $2N6Uo.createObject)($33383a55b1cc1633$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $2N6Uo.extend)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $2N6Uo.extend)({}, normalState.shape);
                    (0, $2N6Uo.extend)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $2N6Uo.extend)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $2N6Uo.extend)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $2N6Uo.extend)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $2N6Uo.keys)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $33383a55b1cc1633$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $9nEce.__extends)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $2N6Uo.clone)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $2N6Uo.clone)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $fde2h.REDRAW_BIT) | (0, $fde2h.STYLE_CHANGED_BIT) | (0, $fde2h.SHAPE_CHANGED_BIT);
    }();
    return Path;
}((0, $6Ekel.default));
var $33383a55b1cc1633$export$2e2bcd8739ae039 = $33383a55b1cc1633$var$Path;

});
parcelRegister("eAFw0", function(module, exports) {

$parcel$export(module.exports, "normalizeArcAngles", function () { return $a9f4a188ab45105f$export$bc668021e937022a; });
$parcel$export(module.exports, "default", function () { return $a9f4a188ab45105f$export$2e2bcd8739ae039; });

var $U1aqY = parcelRequire("U1aqY");

var $67W72 = parcelRequire("67W72");

var $4cadX = parcelRequire("4cadX");

var $kK0Aj = parcelRequire("kK0Aj");

var $1kxDI = parcelRequire("1kxDI");
var $a9f4a188ab45105f$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $a9f4a188ab45105f$var$tmpOutX = [];
var $a9f4a188ab45105f$var$tmpOutY = [];
var $a9f4a188ab45105f$var$min = [];
var $a9f4a188ab45105f$var$max = [];
var $a9f4a188ab45105f$var$min2 = [];
var $a9f4a188ab45105f$var$max2 = [];
var $a9f4a188ab45105f$var$mathMin = Math.min;
var $a9f4a188ab45105f$var$mathMax = Math.max;
var $a9f4a188ab45105f$var$mathCos = Math.cos;
var $a9f4a188ab45105f$var$mathSin = Math.sin;
var $a9f4a188ab45105f$var$mathAbs = Math.abs;
var $a9f4a188ab45105f$var$PI = Math.PI;
var $a9f4a188ab45105f$var$PI2 = $a9f4a188ab45105f$var$PI * 2;
var $a9f4a188ab45105f$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $a9f4a188ab45105f$var$tmpAngles = [];
function $a9f4a188ab45105f$var$modPI2(radian) {
    var n = Math.round(radian / $a9f4a188ab45105f$var$PI * 1e8) / 1e8;
    return n % 2 * $a9f4a188ab45105f$var$PI;
}
function $a9f4a188ab45105f$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $a9f4a188ab45105f$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $a9f4a188ab45105f$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $a9f4a188ab45105f$var$PI2) newEndAngle = newStartAngle + $a9f4a188ab45105f$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $a9f4a188ab45105f$var$PI2) newEndAngle = newStartAngle - $a9f4a188ab45105f$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($a9f4a188ab45105f$var$PI2 - $a9f4a188ab45105f$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($a9f4a188ab45105f$var$PI2 - $a9f4a188ab45105f$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $a9f4a188ab45105f$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $a9f4a188ab45105f$var$mathAbs(segmentIgnoreThreshold / (0, $4cadX.devicePixelRatio) / sx) || 0;
            this._uy = $a9f4a188ab45105f$var$mathAbs(segmentIgnoreThreshold / (0, $4cadX.devicePixelRatio) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($a9f4a188ab45105f$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $a9f4a188ab45105f$var$mathAbs(x - this._xi);
        var dy = $a9f4a188ab45105f$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($a9f4a188ab45105f$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($a9f4a188ab45105f$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($a9f4a188ab45105f$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $a9f4a188ab45105f$var$tmpAngles[0] = startAngle;
        $a9f4a188ab45105f$var$tmpAngles[1] = endAngle;
        $a9f4a188ab45105f$export$bc668021e937022a($a9f4a188ab45105f$var$tmpAngles, anticlockwise);
        startAngle = $a9f4a188ab45105f$var$tmpAngles[0];
        endAngle = $a9f4a188ab45105f$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($a9f4a188ab45105f$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $a9f4a188ab45105f$var$mathCos(endAngle) * r + cx;
        this._yi = $a9f4a188ab45105f$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($a9f4a188ab45105f$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($a9f4a188ab45105f$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        if (!this._saveData) return;
        var len = data.length;
        if (!(this.data && this.data.length === len) && $a9f4a188ab45105f$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!this._saveData) return;
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        var oldData = this.data;
        if ($a9f4a188ab45105f$var$hasTypedArray && (oldData instanceof Float32Array || !oldData)) {
            this.data = new Float32Array(offset + appendSize);
            if (offset > 0 && oldData) for(var k = 0; k < offset; k++)this.data[k] = oldData[k];
        }
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($a9f4a188ab45105f$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $a9f4a188ab45105f$var$min[0] = $a9f4a188ab45105f$var$min[1] = $a9f4a188ab45105f$var$min2[0] = $a9f4a188ab45105f$var$min2[1] = Number.MAX_VALUE;
        $a9f4a188ab45105f$var$max[0] = $a9f4a188ab45105f$var$max[1] = $a9f4a188ab45105f$var$max2[0] = $a9f4a188ab45105f$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $a9f4a188ab45105f$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $a9f4a188ab45105f$var$min2[0] = x0;
                    $a9f4a188ab45105f$var$min2[1] = y0;
                    $a9f4a188ab45105f$var$max2[0] = x0;
                    $a9f4a188ab45105f$var$max2[1] = y0;
                    break;
                case $a9f4a188ab45105f$var$CMD.L:
                    (0, $kK0Aj.fromLine)(xi, yi, data[i], data[i + 1], $a9f4a188ab45105f$var$min2, $a9f4a188ab45105f$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $a9f4a188ab45105f$var$CMD.C:
                    (0, $kK0Aj.fromCubic)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $a9f4a188ab45105f$var$min2, $a9f4a188ab45105f$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $a9f4a188ab45105f$var$CMD.Q:
                    (0, $kK0Aj.fromQuadratic)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $a9f4a188ab45105f$var$min2, $a9f4a188ab45105f$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $a9f4a188ab45105f$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $a9f4a188ab45105f$var$mathCos(startAngle) * rx + cx;
                        y0 = $a9f4a188ab45105f$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $kK0Aj.fromArc)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $a9f4a188ab45105f$var$min2, $a9f4a188ab45105f$var$max2);
                    xi = $a9f4a188ab45105f$var$mathCos(endAngle) * rx + cx;
                    yi = $a9f4a188ab45105f$var$mathSin(endAngle) * ry + cy;
                    break;
                case $a9f4a188ab45105f$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $kK0Aj.fromLine)(x0, y0, x0 + width, y0 + height, $a9f4a188ab45105f$var$min2, $a9f4a188ab45105f$var$max2);
                    break;
                case $a9f4a188ab45105f$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $U1aqY.min($a9f4a188ab45105f$var$min, $a9f4a188ab45105f$var$min, $a9f4a188ab45105f$var$min2);
            $U1aqY.max($a9f4a188ab45105f$var$max, $a9f4a188ab45105f$var$max, $a9f4a188ab45105f$var$max2);
        }
        if (i === 0) $a9f4a188ab45105f$var$min[0] = $a9f4a188ab45105f$var$min[1] = $a9f4a188ab45105f$var$max[0] = $a9f4a188ab45105f$var$max[1] = 0;
        return new (0, $67W72.default)($a9f4a188ab45105f$var$min[0], $a9f4a188ab45105f$var$min[1], $a9f4a188ab45105f$var$max[0] - $a9f4a188ab45105f$var$min[0], $a9f4a188ab45105f$var$max[1] - $a9f4a188ab45105f$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $a9f4a188ab45105f$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $a9f4a188ab45105f$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($a9f4a188ab45105f$var$mathAbs(dx) > ux || $a9f4a188ab45105f$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $a9f4a188ab45105f$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $1kxDI.cubicLength)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $a9f4a188ab45105f$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $1kxDI.quadraticLength)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $a9f4a188ab45105f$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $a9f4a188ab45105f$var$mathCos(startAngle) * rx + cx;
                        y0 = $a9f4a188ab45105f$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $a9f4a188ab45105f$var$mathMax(rx, ry) * $a9f4a188ab45105f$var$mathMin($a9f4a188ab45105f$var$PI2, Math.abs(delta));
                    xi = $a9f4a188ab45105f$var$mathCos(endAngle) * rx + cx;
                    yi = $a9f4a188ab45105f$var$mathSin(endAngle) * ry + cy;
                    break;
                case $a9f4a188ab45105f$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $a9f4a188ab45105f$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $a9f4a188ab45105f$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $a9f4a188ab45105f$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $a9f4a188ab45105f$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $a9f4a188ab45105f$var$mathAbs(x - xi);
                    var dy = $a9f4a188ab45105f$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $a9f4a188ab45105f$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $1kxDI.cubicSubdivide)(xi, x1, x2, x3, t, $a9f4a188ab45105f$var$tmpOutX);
                            (0, $1kxDI.cubicSubdivide)(yi, y1, y2, y3, t, $a9f4a188ab45105f$var$tmpOutY);
                            ctx.bezierCurveTo($a9f4a188ab45105f$var$tmpOutX[1], $a9f4a188ab45105f$var$tmpOutY[1], $a9f4a188ab45105f$var$tmpOutX[2], $a9f4a188ab45105f$var$tmpOutY[2], $a9f4a188ab45105f$var$tmpOutX[3], $a9f4a188ab45105f$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $a9f4a188ab45105f$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $1kxDI.quadraticSubdivide)(xi, x1, x2, t, $a9f4a188ab45105f$var$tmpOutX);
                            (0, $1kxDI.quadraticSubdivide)(yi, y1, y2, t, $a9f4a188ab45105f$var$tmpOutY);
                            ctx.quadraticCurveTo($a9f4a188ab45105f$var$tmpOutX[1], $a9f4a188ab45105f$var$tmpOutY[1], $a9f4a188ab45105f$var$tmpOutX[2], $a9f4a188ab45105f$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $a9f4a188ab45105f$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $a9f4a188ab45105f$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $a9f4a188ab45105f$var$mathCos(startAngle) * rx + cx;
                        y0 = $a9f4a188ab45105f$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $a9f4a188ab45105f$var$mathCos(endAngle) * rx + cx;
                    yi = $a9f4a188ab45105f$var$mathSin(endAngle) * ry + cy;
                    break;
                case $a9f4a188ab45105f$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $a9f4a188ab45105f$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $a9f4a188ab45105f$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $a9f4a188ab45105f$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $a9f4a188ab45105f$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $a9f4a188ab45105f$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.prototype.canSave = function() {
        return !!this._saveData;
    };
    PathProxy.CMD = $a9f4a188ab45105f$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $a9f4a188ab45105f$export$2e2bcd8739ae039 = $a9f4a188ab45105f$var$PathProxy;

});
parcelRegister("kK0Aj", function(module, exports) {

$parcel$export(module.exports, "fromPoints", function () { return $f1988ea58cb36c0a$export$188c3cd07b4129dd; });
$parcel$export(module.exports, "fromLine", function () { return $f1988ea58cb36c0a$export$d2b1491e4450bf2c; });
$parcel$export(module.exports, "fromCubic", function () { return $f1988ea58cb36c0a$export$c1bc6be456bb6609; });
$parcel$export(module.exports, "fromQuadratic", function () { return $f1988ea58cb36c0a$export$16fbe795323a1f4c; });
$parcel$export(module.exports, "fromArc", function () { return $f1988ea58cb36c0a$export$161c8bb0e1d9ef49; });

var $U1aqY = parcelRequire("U1aqY");

var $1kxDI = parcelRequire("1kxDI");
var $f1988ea58cb36c0a$var$mathMin = Math.min;
var $f1988ea58cb36c0a$var$mathMax = Math.max;
var $f1988ea58cb36c0a$var$mathSin = Math.sin;
var $f1988ea58cb36c0a$var$mathCos = Math.cos;
var $f1988ea58cb36c0a$var$PI2 = Math.PI * 2;
var $f1988ea58cb36c0a$var$start = $U1aqY.create();
var $f1988ea58cb36c0a$var$end = $U1aqY.create();
var $f1988ea58cb36c0a$var$extremity = $U1aqY.create();
function $f1988ea58cb36c0a$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $f1988ea58cb36c0a$var$mathMin(left, p[0]);
        right = $f1988ea58cb36c0a$var$mathMax(right, p[0]);
        top = $f1988ea58cb36c0a$var$mathMin(top, p[1]);
        bottom = $f1988ea58cb36c0a$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $f1988ea58cb36c0a$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $f1988ea58cb36c0a$var$mathMin(x0, x1);
    min[1] = $f1988ea58cb36c0a$var$mathMin(y0, y1);
    max[0] = $f1988ea58cb36c0a$var$mathMax(x0, x1);
    max[1] = $f1988ea58cb36c0a$var$mathMax(y0, y1);
}
var $f1988ea58cb36c0a$var$xDim = [];
var $f1988ea58cb36c0a$var$yDim = [];
function $f1988ea58cb36c0a$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $1kxDI.cubicExtrema;
    var cubicAt = $1kxDI.cubicAt;
    var n = cubicExtrema(x0, x1, x2, x3, $f1988ea58cb36c0a$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $f1988ea58cb36c0a$var$xDim[i]);
        min[0] = $f1988ea58cb36c0a$var$mathMin(x, min[0]);
        max[0] = $f1988ea58cb36c0a$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $f1988ea58cb36c0a$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $f1988ea58cb36c0a$var$yDim[i]);
        min[1] = $f1988ea58cb36c0a$var$mathMin(y, min[1]);
        max[1] = $f1988ea58cb36c0a$var$mathMax(y, max[1]);
    }
    min[0] = $f1988ea58cb36c0a$var$mathMin(x0, min[0]);
    max[0] = $f1988ea58cb36c0a$var$mathMax(x0, max[0]);
    min[0] = $f1988ea58cb36c0a$var$mathMin(x3, min[0]);
    max[0] = $f1988ea58cb36c0a$var$mathMax(x3, max[0]);
    min[1] = $f1988ea58cb36c0a$var$mathMin(y0, min[1]);
    max[1] = $f1988ea58cb36c0a$var$mathMax(y0, max[1]);
    min[1] = $f1988ea58cb36c0a$var$mathMin(y3, min[1]);
    max[1] = $f1988ea58cb36c0a$var$mathMax(y3, max[1]);
}
function $f1988ea58cb36c0a$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $1kxDI.quadraticExtremum;
    var quadraticAt = $1kxDI.quadraticAt;
    var tx = $f1988ea58cb36c0a$var$mathMax($f1988ea58cb36c0a$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $f1988ea58cb36c0a$var$mathMax($f1988ea58cb36c0a$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $f1988ea58cb36c0a$var$mathMin(x0, x2, x);
    min[1] = $f1988ea58cb36c0a$var$mathMin(y0, y2, y);
    max[0] = $f1988ea58cb36c0a$var$mathMax(x0, x2, x);
    max[1] = $f1988ea58cb36c0a$var$mathMax(y0, y2, y);
}
function $f1988ea58cb36c0a$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $U1aqY.min;
    var vec2Max = $U1aqY.max;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $f1988ea58cb36c0a$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $f1988ea58cb36c0a$var$start[0] = $f1988ea58cb36c0a$var$mathCos(startAngle) * rx + x;
    $f1988ea58cb36c0a$var$start[1] = $f1988ea58cb36c0a$var$mathSin(startAngle) * ry + y;
    $f1988ea58cb36c0a$var$end[0] = $f1988ea58cb36c0a$var$mathCos(endAngle) * rx + x;
    $f1988ea58cb36c0a$var$end[1] = $f1988ea58cb36c0a$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $f1988ea58cb36c0a$var$start, $f1988ea58cb36c0a$var$end);
    vec2Max(max, $f1988ea58cb36c0a$var$start, $f1988ea58cb36c0a$var$end);
    startAngle = startAngle % $f1988ea58cb36c0a$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $f1988ea58cb36c0a$var$PI2;
    endAngle = endAngle % $f1988ea58cb36c0a$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $f1988ea58cb36c0a$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $f1988ea58cb36c0a$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $f1988ea58cb36c0a$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $f1988ea58cb36c0a$var$extremity[0] = $f1988ea58cb36c0a$var$mathCos(angle) * rx + x;
        $f1988ea58cb36c0a$var$extremity[1] = $f1988ea58cb36c0a$var$mathSin(angle) * ry + y;
        vec2Min(min, $f1988ea58cb36c0a$var$extremity, min);
        vec2Max(max, $f1988ea58cb36c0a$var$extremity, max);
    }
}

});


parcelRegister("kB2Mq", function(module, exports) {

$parcel$export(module.exports, "contain", function () { return $efe96b62807ac29d$export$8893e2b90ba10d92; });
$parcel$export(module.exports, "containStroke", function () { return $efe96b62807ac29d$export$8d36b1b5d19157c5; });

var $eAFw0 = parcelRequire("eAFw0");

var $luMyO = parcelRequire("luMyO");

var $l14xh = parcelRequire("l14xh");

var $bQJka = parcelRequire("bQJka");

var $iaKMo = parcelRequire("iaKMo");

var $1kxDI = parcelRequire("1kxDI");

var $lM2rq = parcelRequire("lM2rq");
var $efe96b62807ac29d$var$CMD = (0, $eAFw0.default).CMD;
var $efe96b62807ac29d$var$PI2 = Math.PI * 2;
var $efe96b62807ac29d$var$EPSILON = 1e-4;
function $efe96b62807ac29d$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $efe96b62807ac29d$var$EPSILON;
}
var $efe96b62807ac29d$var$roots = [
    -1,
    -1,
    -1
];
var $efe96b62807ac29d$var$extrema = [
    -1,
    -1
];
function $efe96b62807ac29d$var$swapExtrema() {
    var tmp = $efe96b62807ac29d$var$extrema[0];
    $efe96b62807ac29d$var$extrema[0] = $efe96b62807ac29d$var$extrema[1];
    $efe96b62807ac29d$var$extrema[1] = tmp;
}
function $efe96b62807ac29d$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $1kxDI.cubicRootAt(y0, y1, y2, y3, y, $efe96b62807ac29d$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $efe96b62807ac29d$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $1kxDI.cubicAt(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $1kxDI.cubicExtrema(y0, y1, y2, y3, $efe96b62807ac29d$var$extrema);
                if ($efe96b62807ac29d$var$extrema[1] < $efe96b62807ac29d$var$extrema[0] && nExtrema > 1) $efe96b62807ac29d$var$swapExtrema();
                y0_ = $1kxDI.cubicAt(y0, y1, y2, y3, $efe96b62807ac29d$var$extrema[0]);
                if (nExtrema > 1) y1_ = $1kxDI.cubicAt(y0, y1, y2, y3, $efe96b62807ac29d$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $efe96b62807ac29d$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $efe96b62807ac29d$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $efe96b62807ac29d$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $efe96b62807ac29d$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $1kxDI.quadraticRootAt(y0, y1, y2, y, $efe96b62807ac29d$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $1kxDI.quadraticExtremum(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $1kxDI.quadraticAt(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $efe96b62807ac29d$var$roots[i] === 0 || $efe96b62807ac29d$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $1kxDI.quadraticAt(x0, x1, x2, $efe96b62807ac29d$var$roots[i]);
                if (x_ < x) continue;
                if ($efe96b62807ac29d$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $efe96b62807ac29d$var$roots[0] === 0 || $efe96b62807ac29d$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $1kxDI.quadraticAt(x0, x1, x2, $efe96b62807ac29d$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $efe96b62807ac29d$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $efe96b62807ac29d$var$roots[0] = -tmp;
    $efe96b62807ac29d$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $efe96b62807ac29d$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $efe96b62807ac29d$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $efe96b62807ac29d$var$roots[0] + cx && x <= $efe96b62807ac29d$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $efe96b62807ac29d$var$PI2;
        endAngle += $efe96b62807ac29d$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $efe96b62807ac29d$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $efe96b62807ac29d$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $efe96b62807ac29d$var$PI2 >= startAngle && angle + $efe96b62807ac29d$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $efe96b62807ac29d$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $efe96b62807ac29d$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $lM2rq.default)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $efe96b62807ac29d$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $efe96b62807ac29d$var$CMD.L:
                if (isStroke) {
                    if ($luMyO.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $lM2rq.default)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $efe96b62807ac29d$var$CMD.C:
                if (isStroke) {
                    if ($l14xh.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $efe96b62807ac29d$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $efe96b62807ac29d$var$CMD.Q:
                if (isStroke) {
                    if ($bQJka.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $efe96b62807ac29d$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $efe96b62807ac29d$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $lM2rq.default)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($iaKMo.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $efe96b62807ac29d$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $efe96b62807ac29d$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($luMyO.containStroke(x0, y0, x1, y0, lineWidth, x, y) || $luMyO.containStroke(x1, y0, x1, y1, lineWidth, x, y) || $luMyO.containStroke(x1, y1, x0, y1, lineWidth, x, y) || $luMyO.containStroke(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $lM2rq.default)(x1, y0, x1, y1, x, y);
                    w += (0, $lM2rq.default)(x0, y1, x0, y0, x, y);
                }
                break;
            case $efe96b62807ac29d$var$CMD.Z:
                if (isStroke) {
                    if ($luMyO.containStroke(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $lM2rq.default)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$efe96b62807ac29d$var$isAroundEqual(yi, y0)) w += (0, $lM2rq.default)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $efe96b62807ac29d$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $efe96b62807ac29d$var$containPath(pathProxy, 0, false, x, y);
}
function $efe96b62807ac29d$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $efe96b62807ac29d$var$containPath(pathProxy, lineWidth, true, x, y);
}

});
parcelRegister("luMyO", function(module, exports) {

$parcel$export(module.exports, "containStroke", function () { return $fa62116b83dc7085$export$8d36b1b5d19157c5; });
function $fa62116b83dc7085$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}

});

parcelRegister("l14xh", function(module, exports) {

$parcel$export(module.exports, "containStroke", function () { return $f4cd35a8e1f6e844$export$8d36b1b5d19157c5; });

var $1kxDI = parcelRequire("1kxDI");
function $f4cd35a8e1f6e844$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $1kxDI.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("bQJka", function(module, exports) {

$parcel$export(module.exports, "containStroke", function () { return $8a07b57cc99615d4$export$8d36b1b5d19157c5; });

var $1kxDI = parcelRequire("1kxDI");
function $8a07b57cc99615d4$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $1kxDI.quadraticProjectPoint)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("iaKMo", function(module, exports) {

$parcel$export(module.exports, "containStroke", function () { return $d3ad729c1f6b4096$export$8d36b1b5d19157c5; });

var $3HvzJ = parcelRequire("3HvzJ");
var $d3ad729c1f6b4096$var$PI2 = Math.PI * 2;
function $d3ad729c1f6b4096$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $d3ad729c1f6b4096$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $3HvzJ.normalizeRadian)(endAngle);
        endAngle = (0, $3HvzJ.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $3HvzJ.normalizeRadian)(startAngle);
        endAngle = (0, $3HvzJ.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $d3ad729c1f6b4096$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $d3ad729c1f6b4096$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $d3ad729c1f6b4096$var$PI2 >= startAngle && angle + $d3ad729c1f6b4096$var$PI2 <= endAngle;
}

});
parcelRegister("3HvzJ", function(module, exports) {

$parcel$export(module.exports, "normalizeRadian", function () { return $2b1de17220478b98$export$d44861331f213635; });
var $2b1de17220478b98$var$PI2 = Math.PI * 2;
function $2b1de17220478b98$export$d44861331f213635(angle) {
    angle %= $2b1de17220478b98$var$PI2;
    if (angle < 0) angle += $2b1de17220478b98$var$PI2;
    return angle;
}

});


parcelRegister("lM2rq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd9ff9797c80c917$export$2e2bcd8739ae039; });
function $fd9ff9797c80c917$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}

});




parcelRegister("lQsZt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe74f13baffa3a8f$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $6Ekel = parcelRequire("6Ekel");

var $67W72 = parcelRequire("67W72");

var $2N6Uo = parcelRequire("2N6Uo");
var $fe74f13baffa3a8f$export$8993f922aeeac642 = (0, $2N6Uo.defaults)({
    x: 0,
    y: 0
}, (0, $6Ekel.DEFAULT_COMMON_STYLE));
var $fe74f13baffa3a8f$export$4aba8ad70847a488 = {
    style: (0, $2N6Uo.defaults)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $6Ekel.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
function $fe74f13baffa3a8f$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $fe74f13baffa3a8f$var$ZRImage = function(_super) {
    (0, $9nEce.__extends)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $2N6Uo.createObject)($fe74f13baffa3a8f$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $fe74f13baffa3a8f$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $fe74f13baffa3a8f$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $67W72.default)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $6Ekel.default));
$fe74f13baffa3a8f$var$ZRImage.prototype.type = 'image';
var $fe74f13baffa3a8f$export$2e2bcd8739ae039 = $fe74f13baffa3a8f$var$ZRImage;

});

parcelRegister("aH2k0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c8fb890f94b58af$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $cvuMr = parcelRequire("cvuMr");

var $fcwet = parcelRequire("fcwet");
var $7c8fb890f94b58af$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $7c8fb890f94b58af$var$subPixelOptimizeOutputShape = {};
var $7c8fb890f94b58af$var$Rect = function(_super) {
    (0, $9nEce.__extends)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $7c8fb890f94b58af$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $fcwet.subPixelOptimizeRect)($7c8fb890f94b58af$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $cvuMr.buildPath(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $4oDJM.default));
$7c8fb890f94b58af$var$Rect.prototype.type = 'rect';
var $7c8fb890f94b58af$export$2e2bcd8739ae039 = $7c8fb890f94b58af$var$Rect;

});
parcelRegister("cvuMr", function(module, exports) {

$parcel$export(module.exports, "buildPath", function () { return $91b0419b8eef08fb$export$5cc7f731b5937e99; });
function $91b0419b8eef08fb$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}

});

parcelRegister("fcwet", function(module, exports) {

$parcel$export(module.exports, "subPixelOptimizeLine", function () { return $b110fab15faa13f9$export$8b4b620d7f4aad1b; });
$parcel$export(module.exports, "subPixelOptimize", function () { return $b110fab15faa13f9$export$72c4fd4c1b8fcb10; });
$parcel$export(module.exports, "subPixelOptimizeRect", function () { return $b110fab15faa13f9$export$60e2aa74957d0b9d; });
var $b110fab15faa13f9$var$round = Math.round;
function $b110fab15faa13f9$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($b110fab15faa13f9$var$round(x1 * 2) === $b110fab15faa13f9$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $b110fab15faa13f9$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($b110fab15faa13f9$var$round(y1 * 2) === $b110fab15faa13f9$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $b110fab15faa13f9$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $b110fab15faa13f9$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $b110fab15faa13f9$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $b110fab15faa13f9$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($b110fab15faa13f9$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($b110fab15faa13f9$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $b110fab15faa13f9$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $b110fab15faa13f9$var$round(position * 2);
    return (doubledPosition + $b110fab15faa13f9$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

});



parcelRegister("bwPbQ", function(module, exports) {

$parcel$export(module.exports, "HOVER_STATE_BLUR", function () { return $864a642045760c38$export$1307d6a87d56baa; });
$parcel$export(module.exports, "HOVER_STATE_EMPHASIS", function () { return $864a642045760c38$export$f0f2bee145debb31; });
$parcel$export(module.exports, "SPECIAL_STATES", function () { return $864a642045760c38$export$151308dceb52d5b; });
$parcel$export(module.exports, "DISPLAY_STATES", function () { return $864a642045760c38$export$57ee5306b85ad7d5; });
$parcel$export(module.exports, "Z2_EMPHASIS_LIFT", function () { return $864a642045760c38$export$1cb9fc6ed5b9836c; });
$parcel$export(module.exports, "HIGHLIGHT_ACTION_TYPE", function () { return $864a642045760c38$export$df035d873a9de64f; });
$parcel$export(module.exports, "DOWNPLAY_ACTION_TYPE", function () { return $864a642045760c38$export$f8a2f7807cc185ea; });
$parcel$export(module.exports, "SELECT_ACTION_TYPE", function () { return $864a642045760c38$export$89616263e7d38fe9; });
$parcel$export(module.exports, "UNSELECT_ACTION_TYPE", function () { return $864a642045760c38$export$7636ad95c0f68a79; });
$parcel$export(module.exports, "TOGGLE_SELECT_ACTION_TYPE", function () { return $864a642045760c38$export$1e90ed8a25542516; });
$parcel$export(module.exports, "SELECT_CHANGED_EVENT_TYPE", function () { return $864a642045760c38$export$67f8c62bcdfbd39f; });
$parcel$export(module.exports, "setStatesFlag", function () { return $864a642045760c38$export$868ba38adffa9e39; });
$parcel$export(module.exports, "setDefaultStateProxy", function () { return $864a642045760c38$export$20f39bbe322fb9ab; });
$parcel$export(module.exports, "enterEmphasis", function () { return $864a642045760c38$export$b2d02638cc34c042; });
$parcel$export(module.exports, "leaveEmphasis", function () { return $864a642045760c38$export$11be6f716239ac55; });
$parcel$export(module.exports, "enterBlur", function () { return $864a642045760c38$export$207f9cb3e1099375; });
$parcel$export(module.exports, "leaveBlur", function () { return $864a642045760c38$export$fd4a9ec75456d3c1; });
$parcel$export(module.exports, "enterSelect", function () { return $864a642045760c38$export$252d028dda8ef765; });
$parcel$export(module.exports, "leaveSelect", function () { return $864a642045760c38$export$ea9a904bd6e32bd3; });
$parcel$export(module.exports, "allLeaveBlur", function () { return $864a642045760c38$export$b2a593c7b5243584; });
$parcel$export(module.exports, "blurComponent", function () { return $864a642045760c38$export$569da03256c8a55f; });
$parcel$export(module.exports, "blurSeriesFromHighlightPayload", function () { return $864a642045760c38$export$64f1fd4daefef21b; });
$parcel$export(module.exports, "findComponentHighDownDispatchers", function () { return $864a642045760c38$export$f31a644ccca0ef23; });
$parcel$export(module.exports, "handleGlobalMouseOverForHighDown", function () { return $864a642045760c38$export$416765b6198234ff; });
$parcel$export(module.exports, "handleGlobalMouseOutForHighDown", function () { return $864a642045760c38$export$bb1c7b62436282a; });
$parcel$export(module.exports, "toggleSelectionFromPayload", function () { return $864a642045760c38$export$1c7d489f62372d73; });
$parcel$export(module.exports, "isSelectChangePayload", function () { return $864a642045760c38$export$72aea10e60e45351; });
$parcel$export(module.exports, "updateSeriesElementSelection", function () { return $864a642045760c38$export$e4ea08ef52e0a73; });
$parcel$export(module.exports, "getAllSelectedIndices", function () { return $864a642045760c38$export$c529643b619af6b3; });
$parcel$export(module.exports, "enableHoverEmphasis", function () { return $864a642045760c38$export$5f393df0b5aee2e7; });
$parcel$export(module.exports, "setAsHighDownDispatcher", function () { return $864a642045760c38$export$9ba15aea1e048d48; });
$parcel$export(module.exports, "enableHoverFocus", function () { return $864a642045760c38$export$24972466b2b62ac2; });
$parcel$export(module.exports, "toggleHoverEmphasis", function () { return $864a642045760c38$export$e51187539ff11209; });
$parcel$export(module.exports, "setStatesStylesFromModel", function () { return $864a642045760c38$export$48b68047d330bbc9; });
$parcel$export(module.exports, "isHighDownDispatcher", function () { return $864a642045760c38$export$77d1445f699c58b5; });
$parcel$export(module.exports, "enableComponentHighDownFeatures", function () { return $864a642045760c38$export$4da05a9639f01954; });
$parcel$export(module.exports, "getHighlightDigit", function () { return $864a642045760c38$export$824af40eb714530d; });
$parcel$export(module.exports, "isHighDownPayload", function () { return $864a642045760c38$export$aebe71265c1b77bf; });
$parcel$export(module.exports, "savePathStates", function () { return $864a642045760c38$export$9fe78019e6f395b6; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $6TSUP = parcelRequire("6TSUP");

var $3UxDF = parcelRequire("3UxDF");

var $bx3T8 = parcelRequire("bx3T8");

var $4oDJM = parcelRequire("4oDJM");

// Reserve 0 as default.
var $864a642045760c38$var$_highlightNextDigit = 1;
var $864a642045760c38$var$_highlightKeyMap = {};
var $864a642045760c38$var$getSavedStates = (0, $bx3T8.makeInner)();
var $864a642045760c38$var$getComponentStates = (0, $bx3T8.makeInner)();
var $864a642045760c38$export$5542daa30722333e = 0;
var $864a642045760c38$export$1307d6a87d56baa = 1;
var $864a642045760c38$export$f0f2bee145debb31 = 2;
var $864a642045760c38$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $864a642045760c38$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $864a642045760c38$export$1cb9fc6ed5b9836c = 10;
var $864a642045760c38$export$3a2f97d39514bbc = 9;
var $864a642045760c38$export$df035d873a9de64f = 'highlight';
var $864a642045760c38$export$f8a2f7807cc185ea = 'downplay';
var $864a642045760c38$export$89616263e7d38fe9 = 'select';
var $864a642045760c38$export$7636ad95c0f68a79 = 'unselect';
var $864a642045760c38$export$1e90ed8a25542516 = 'toggleSelect';
var $864a642045760c38$export$67f8c62bcdfbd39f = 'selectchanged';
function $864a642045760c38$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
}
function $864a642045760c38$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $864a642045760c38$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $864a642045760c38$var$doChangeHoverState(el, 'emphasis', $864a642045760c38$export$f0f2bee145debb31);
}
function $864a642045760c38$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $864a642045760c38$export$f0f2bee145debb31) $864a642045760c38$var$doChangeHoverState(el, 'normal', $864a642045760c38$export$5542daa30722333e);
}
function $864a642045760c38$var$singleEnterBlur(el) {
    $864a642045760c38$var$doChangeHoverState(el, 'blur', $864a642045760c38$export$1307d6a87d56baa);
}
function $864a642045760c38$var$singleLeaveBlur(el) {
    if (el.hoverState === $864a642045760c38$export$1307d6a87d56baa) $864a642045760c38$var$doChangeHoverState(el, 'normal', $864a642045760c38$export$5542daa30722333e);
}
function $864a642045760c38$var$singleEnterSelect(el) {
    el.selected = true;
}
function $864a642045760c38$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $864a642045760c38$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $864a642045760c38$var$traverseUpdateState(el, updater, commonParam) {
    $864a642045760c38$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $864a642045760c38$var$updateElementState(child, updater, commonParam);
    });
}
function $864a642045760c38$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $864a642045760c38$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $864a642045760c38$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $864a642045760c38$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $864a642045760c38$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $864a642045760c38$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveTo(fromState, props);
    }
    return fromState;
}
function $864a642045760c38$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $2N6Uo.indexOf)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $4oDJM.default)) {
        var store = $864a642045760c38$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($864a642045760c38$var$hasFillOrStroke(fromFill) || $864a642045760c38$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $2N6Uo.extend)({}, state);
                emphasisStyle = (0, $2N6Uo.extend)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$864a642045760c38$var$hasFillOrStroke(emphasisStyle.fill) && $864a642045760c38$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $2N6Uo.extend)({}, state);
                emphasisStyle = (0, $2N6Uo.extend)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $3UxDF.liftColor)(fromFill);
            } else if (!$864a642045760c38$var$hasFillOrStroke(emphasisStyle.stroke) && $864a642045760c38$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $2N6Uo.extend)({}, state);
                    emphasisStyle = (0, $2N6Uo.extend)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $3UxDF.liftColor)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $2N6Uo.extend)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $864a642045760c38$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $864a642045760c38$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $2N6Uo.extend)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $864a642045760c38$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $864a642045760c38$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $2N6Uo.indexOf)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $864a642045760c38$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $2N6Uo.extend)({}, state);
        blurStyle = (0, $2N6Uo.extend)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $864a642045760c38$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $864a642045760c38$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $864a642045760c38$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $864a642045760c38$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $864a642045760c38$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $864a642045760c38$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $864a642045760c38$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $864a642045760c38$var$elementStateProxy;
}
function $864a642045760c38$export$d899507e2598e4ae(el, e) {
    !$864a642045760c38$var$shouldSilent(el, e) && !el.__highByOuter && $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$var$singleEnterEmphasis);
}
function $864a642045760c38$export$784cba1f7fe58cca(el, e) {
    !$864a642045760c38$var$shouldSilent(el, e) && !el.__highByOuter && $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$var$singleLeaveEmphasis);
}
function $864a642045760c38$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$var$singleEnterEmphasis);
}
function $864a642045760c38$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$var$singleLeaveEmphasis);
}
function $864a642045760c38$export$207f9cb3e1099375(el) {
    $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$var$singleEnterBlur);
}
function $864a642045760c38$export$fd4a9ec75456d3c1(el) {
    $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$var$singleLeaveBlur);
}
function $864a642045760c38$export$252d028dda8ef765(el) {
    $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$var$singleEnterSelect);
}
function $864a642045760c38$export$ea9a904bd6e32bd3(el) {
    $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$var$singleLeaveSelect);
}
function $864a642045760c38$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $864a642045760c38$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $864a642045760c38$var$getComponentStates(componentModel);
        var isSeries = componentType === 'series';
        var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $864a642045760c38$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $2N6Uo.each)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $864a642045760c38$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $864a642045760c38$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === 'self') return;
                $864a642045760c38$var$singleEnterBlur(child);
            });
            if ((0, $2N6Uo.isArrayLike)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $2N6Uo.isObject)(focus)) {
                var dataTypes = (0, $2N6Uo.keys)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $864a642045760c38$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $864a642045760c38$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $864a642045760c38$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $864a642045760c38$var$singleEnterBlur(child);
    });
}
function $864a642045760c38$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $bx3T8.queryDataIndex)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $2N6Uo.isArray)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $6TSUP.getECData)(el);
        $864a642045760c38$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $864a642045760c38$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $864a642045760c38$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $6TSUP.getECData)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $864a642045760c38$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $6TSUP.getECData)(dispatcher);
    var _a = $864a642045760c38$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $864a642045760c38$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $2N6Uo.each)(dispatchers, function(dispatcher) {
            return $864a642045760c38$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $864a642045760c38$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $864a642045760c38$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $864a642045760c38$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $864a642045760c38$export$bb1c7b62436282a(dispatcher, e, api) {
    $864a642045760c38$export$b2a593c7b5243584(api);
    var ecData = (0, $6TSUP.getECData)(dispatcher);
    var dispatchers = $864a642045760c38$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $2N6Uo.each)(dispatchers, function(dispatcher) {
        return $864a642045760c38$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $864a642045760c38$export$784cba1f7fe58cca(dispatcher, e);
}
function $864a642045760c38$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$864a642045760c38$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $bx3T8.queryDataIndex)(data, payload);
    if (!(0, $2N6Uo.isArray)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $864a642045760c38$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $864a642045760c38$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $864a642045760c38$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $2N6Uo.each)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $864a642045760c38$export$252d028dda8ef765(el) : $864a642045760c38$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $864a642045760c38$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $2N6Uo.each)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $864a642045760c38$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $864a642045760c38$export$9ba15aea1e048d48(el, true);
    $864a642045760c38$var$traverseUpdateState(el, $864a642045760c38$export$20f39bbe322fb9ab);
    $864a642045760c38$export$24972466b2b62ac2(el, focus, blurScope);
}
function $864a642045760c38$export$912cae7b47c8e437(el) {
    $864a642045760c38$export$9ba15aea1e048d48(el, false);
}
function $864a642045760c38$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $864a642045760c38$export$912cae7b47c8e437(el) : $864a642045760c38$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $864a642045760c38$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $6TSUP.getECData)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $864a642045760c38$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $864a642045760c38$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $864a642045760c38$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $864a642045760c38$var$OTHER_STATES.length; i++){
        var stateName = $864a642045760c38$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$864a642045760c38$var$defaultStyleGetterMap[styleType]]();
    }
}
function $864a642045760c38$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $864a642045760c38$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $864a642045760c38$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $6TSUP.getECData)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $864a642045760c38$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $864a642045760c38$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $864a642045760c38$var$_highlightNextDigit <= 32) highlightDigit = $864a642045760c38$var$_highlightKeyMap[highlightKey] = $864a642045760c38$var$_highlightNextDigit++;
    return highlightDigit;
}
function $864a642045760c38$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $864a642045760c38$export$89616263e7d38fe9 || payloadType === $864a642045760c38$export$7636ad95c0f68a79 || payloadType === $864a642045760c38$export$1e90ed8a25542516;
}
function $864a642045760c38$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $864a642045760c38$export$df035d873a9de64f || payloadType === $864a642045760c38$export$f8a2f7807cc185ea;
}
function $864a642045760c38$export$9fe78019e6f395b6(el) {
    var store = $864a642045760c38$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}

});
parcelRegister("6TSUP", function(module, exports) {

$parcel$export(module.exports, "getECData", function () { return $50627a34c8882247$export$b1c39b2bacd1ddc2; });
$parcel$export(module.exports, "setCommonECData", function () { return $50627a34c8882247$export$30d6736ebb8e18d5; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");
var $50627a34c8882247$export$b1c39b2bacd1ddc2 = (0, $bx3T8.makeInner)();
var $50627a34c8882247$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $50627a34c8882247$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = 'chart';
        // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $50627a34c8882247$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = 'chart';
        });
    }
};

});


parcelRegister("ipprj", function(module, exports) {

$parcel$export(module.exports, "getAnimationConfig", function () { return $d66e4b9208b81ae1$export$5cc7add7ab591d0a; });
$parcel$export(module.exports, "updateProps", function () { return $d66e4b9208b81ae1$export$c8dce3c08436e91e; });
$parcel$export(module.exports, "initProps", function () { return $d66e4b9208b81ae1$export$a121566aadcfe021; });
$parcel$export(module.exports, "isElementRemoved", function () { return $d66e4b9208b81ae1$export$5b89d4b643713034; });
$parcel$export(module.exports, "removeElement", function () { return $d66e4b9208b81ae1$export$f883456a56996078; });
$parcel$export(module.exports, "removeElementWithFadeOut", function () { return $d66e4b9208b81ae1$export$6d0fd725cb4aee8a; });
$parcel$export(module.exports, "saveOldStyle", function () { return $d66e4b9208b81ae1$export$bca7290a9faf0ec9; });
$parcel$export(module.exports, "getOldStyle", function () { return $d66e4b9208b81ae1$export$ccb1f1e4d2fa86ac; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");
var $d66e4b9208b81ae1$export$ae7433df314f6ec3 = (0, $bx3T8.makeInner)();
function $d66e4b9208b81ae1$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $2N6Uo.retrieve2)(extraOpts.duration, 200);
            easing = (0, $2N6Uo.retrieve2)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $2N6Uo.isFunction)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $2N6Uo.isFunction)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $d66e4b9208b81ae1$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $2N6Uo.isFunction)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $2N6Uo.isObject)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'leave';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('leave');
    var animationConfig = $d66e4b9208b81ae1$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $d66e4b9208b81ae1$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $d66e4b9208b81ae1$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $d66e4b9208b81ae1$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $d66e4b9208b81ae1$var$animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
}
function $d66e4b9208b81ae1$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'leave') return true;
    }
    return false;
}
function $d66e4b9208b81ae1$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($d66e4b9208b81ae1$export$5b89d4b643713034(el)) return;
    $d66e4b9208b81ae1$var$animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
}
function $d66e4b9208b81ae1$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $d66e4b9208b81ae1$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $d66e4b9208b81ae1$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $d66e4b9208b81ae1$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $d66e4b9208b81ae1$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $d66e4b9208b81ae1$export$bca7290a9faf0ec9(el) {
    $d66e4b9208b81ae1$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $d66e4b9208b81ae1$export$ccb1f1e4d2fa86ac(el) {
    return $d66e4b9208b81ae1$export$ae7433df314f6ec3(el).oldStyle;
}

});

parcelRegister("h9U3p", function(module, exports) {

$parcel$export(module.exports, "XY", function () { return $c7dec214544dd0ea$export$cb4c12294149dd2d; });
$parcel$export(module.exports, "WH", function () { return $c7dec214544dd0ea$export$a3fe6d967173a3ac; });
$parcel$export(module.exports, "extendShape", function () { return $c7dec214544dd0ea$export$d0d5398c9d612037; });
$parcel$export(module.exports, "extendPath", function () { return $c7dec214544dd0ea$export$53b54a3137026af0; });
$parcel$export(module.exports, "registerShape", function () { return $c7dec214544dd0ea$export$2b95b62e3aaf6fdd; });
$parcel$export(module.exports, "getShapeClass", function () { return $c7dec214544dd0ea$export$51df4b5565a58189; });
$parcel$export(module.exports, "makePath", function () { return $c7dec214544dd0ea$export$aa9bab72412f5613; });
$parcel$export(module.exports, "resizePath", function () { return $c7dec214544dd0ea$export$566dbf1c62b04fc7; });
$parcel$export(module.exports, "makeImage", function () { return $c7dec214544dd0ea$export$7a2bdede98851ac5; });
$parcel$export(module.exports, "mergePath", function () { return $c7dec214544dd0ea$export$7b1dd269fbc4e903; });
$parcel$export(module.exports, "subPixelOptimizeLine", function () { return $c7dec214544dd0ea$export$8b4b620d7f4aad1b; });
$parcel$export(module.exports, "subPixelOptimizeRect", function () { return $c7dec214544dd0ea$export$60e2aa74957d0b9d; });
$parcel$export(module.exports, "subPixelOptimize", function () { return $c7dec214544dd0ea$export$72c4fd4c1b8fcb10; });
$parcel$export(module.exports, "getTransform", function () { return $c7dec214544dd0ea$export$fce0c6cfca85ed96; });
$parcel$export(module.exports, "applyTransform", function () { return $c7dec214544dd0ea$export$9f9dcb98c894b623; });
$parcel$export(module.exports, "transformDirection", function () { return $c7dec214544dd0ea$export$fff94e9792354cfa; });
$parcel$export(module.exports, "groupTransition", function () { return $c7dec214544dd0ea$export$64fcab7860c216ae; });
$parcel$export(module.exports, "clipPointsByRect", function () { return $c7dec214544dd0ea$export$e2f409471bbbc1dc; });
$parcel$export(module.exports, "clipRectByRect", function () { return $c7dec214544dd0ea$export$d0d3709202b8b2a; });
$parcel$export(module.exports, "createIcon", function () { return $c7dec214544dd0ea$export$274edc73af1ae9c8; });
$parcel$export(module.exports, "linePolygonIntersect", function () { return $c7dec214544dd0ea$export$4f47c855a5e9ae9; });
$parcel$export(module.exports, "lineLineIntersect", function () { return $c7dec214544dd0ea$export$6c0a70ea1d8d158b; });
$parcel$export(module.exports, "expandOrShrinkRect", function () { return $c7dec214544dd0ea$export$81ed941fdeb91c7c; });
$parcel$export(module.exports, "setTooltipConfig", function () { return $c7dec214544dd0ea$export$fc6410d97fab306c; });
$parcel$export(module.exports, "traverseElements", function () { return $c7dec214544dd0ea$export$3e564442729bf048; });
$parcel$export(module.exports, "isBoundingRectAxisAligned", function () { return $c7dec214544dd0ea$export$576610ccf2234b72; });
$parcel$export(module.exports, "ensureCopyRect", function () { return $c7dec214544dd0ea$export$38128dfd9a498e1; });
$parcel$export(module.exports, "ensureCopyTransform", function () { return $c7dec214544dd0ea$export$4d61283a070e0362; });
$parcel$export(module.exports, "retrieveZInfo", function () { return $c7dec214544dd0ea$export$1500a631bea5adda; });
$parcel$export(module.exports, "calcZ2Range", function () { return $c7dec214544dd0ea$export$8215ea00957327f2; });
$parcel$export(module.exports, "traverseUpdateZ", function () { return $c7dec214544dd0ea$export$d31cf465bf5e8879; });
$parcel$export(module.exports, "updateProps", function () { return (parcelRequire("ipprj")).updateProps; });
$parcel$export(module.exports, "initProps", function () { return (parcelRequire("ipprj")).initProps; });
$parcel$export(module.exports, "removeElement", function () { return (parcelRequire("ipprj")).removeElement; });
$parcel$export(module.exports, "removeElementWithFadeOut", function () { return (parcelRequire("ipprj")).removeElementWithFadeOut; });
$parcel$export(module.exports, "isElementRemoved", function () { return (parcelRequire("ipprj")).isElementRemoved; });
$parcel$export(module.exports, "Group", function () { return (parcelRequire("iQonF")).default; });
$parcel$export(module.exports, "Image", function () { return (parcelRequire("lQsZt")).default; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("kBKw3")).default; });
$parcel$export(module.exports, "Circle", function () { return (parcelRequire("6Utk3")).default; });
$parcel$export(module.exports, "Ellipse", function () { return (parcelRequire("3jYPd")).default; });
$parcel$export(module.exports, "Sector", function () { return (parcelRequire("60Kbk")).default; });
$parcel$export(module.exports, "Ring", function () { return (parcelRequire("iqf4i")).default; });
$parcel$export(module.exports, "Polygon", function () { return (parcelRequire("hXTRG")).default; });
$parcel$export(module.exports, "Polyline", function () { return (parcelRequire("ewDYK")).default; });
$parcel$export(module.exports, "Rect", function () { return (parcelRequire("aH2k0")).default; });
$parcel$export(module.exports, "Line", function () { return (parcelRequire("c3CaY")).default; });
$parcel$export(module.exports, "BezierCurve", function () { return (parcelRequire("1y8oO")).default; });
$parcel$export(module.exports, "Arc", function () { return (parcelRequire("2ClTb")).default; });
$parcel$export(module.exports, "IncrementalDisplayable", function () { return (parcelRequire("lMxou")).default; });
$parcel$export(module.exports, "CompoundPath", function () { return (parcelRequire("5JZmf")).default; });
$parcel$export(module.exports, "LinearGradient", function () { return (parcelRequire("ftfXE")).default; });
$parcel$export(module.exports, "RadialGradient", function () { return (parcelRequire("fv6es")).default; });
$parcel$export(module.exports, "BoundingRect", function () { return (parcelRequire("67W72")).default; });
$parcel$export(module.exports, "OrientedBoundingRect", function () { return (parcelRequire("183nE")).default; });
$parcel$export(module.exports, "Point", function () { return (parcelRequire("9KN3M")).default; });
$parcel$export(module.exports, "Path", function () { return (parcelRequire("4oDJM")).default; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hI0Jj = parcelRequire("hI0Jj");

var $19Ywy = parcelRequire("19Ywy");

var $U1aqY = parcelRequire("U1aqY");

var $4oDJM = parcelRequire("4oDJM");

var $erz95 = parcelRequire("erz95");

var $lQsZt = parcelRequire("lQsZt");

var $iQonF = parcelRequire("iQonF");

var $kBKw3 = parcelRequire("kBKw3");

var $6Utk3 = parcelRequire("6Utk3");

var $3jYPd = parcelRequire("3jYPd");

var $60Kbk = parcelRequire("60Kbk");

var $iqf4i = parcelRequire("iqf4i");

var $hXTRG = parcelRequire("hXTRG");

var $ewDYK = parcelRequire("ewDYK");

var $aH2k0 = parcelRequire("aH2k0");

var $c3CaY = parcelRequire("c3CaY");

var $1y8oO = parcelRequire("1y8oO");

var $2ClTb = parcelRequire("2ClTb");

var $5JZmf = parcelRequire("5JZmf");

var $ftfXE = parcelRequire("ftfXE");

var $fv6es = parcelRequire("fv6es");

var $67W72 = parcelRequire("67W72");

var $183nE = parcelRequire("183nE");

var $9KN3M = parcelRequire("9KN3M");

var $lMxou = parcelRequire("lMxou");

var $fcwet = parcelRequire("fcwet");

var $2N6Uo = parcelRequire("2N6Uo");

var $6TSUP = parcelRequire("6TSUP");

var $ipprj = parcelRequire("ipprj");

var $iCU10 = parcelRequire("iCU10");
var $c7dec214544dd0ea$var$_customShapeMap = {};
var $c7dec214544dd0ea$export$cb4c12294149dd2d = [
    'x',
    'y'
];
var $c7dec214544dd0ea$export$a3fe6d967173a3ac = [
    'width',
    'height'
];
function $c7dec214544dd0ea$export$d0d5398c9d612037(opts) {
    return (0, $4oDJM.default).extend(opts);
}
var $c7dec214544dd0ea$var$extendPathFromString = $hI0Jj.extendFromString;
function $c7dec214544dd0ea$export$53b54a3137026af0(pathData, opts) {
    return $c7dec214544dd0ea$var$extendPathFromString(pathData, opts);
}
function $c7dec214544dd0ea$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $c7dec214544dd0ea$var$_customShapeMap[name] = ShapeClass;
}
function $c7dec214544dd0ea$export$51df4b5565a58189(name) {
    if ($c7dec214544dd0ea$var$_customShapeMap.hasOwnProperty(name)) return $c7dec214544dd0ea$var$_customShapeMap[name];
}
function $c7dec214544dd0ea$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $hI0Jj.createFromString(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $c7dec214544dd0ea$var$centerGraphic(rect, path.getBoundingRect());
        $c7dec214544dd0ea$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $c7dec214544dd0ea$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $lQsZt.default)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($c7dec214544dd0ea$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $c7dec214544dd0ea$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $c7dec214544dd0ea$export$7b1dd269fbc4e903 = $hI0Jj.mergePath;
function $c7dec214544dd0ea$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $c7dec214544dd0ea$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $fcwet.subPixelOptimizeLine(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $c7dec214544dd0ea$export$60e2aa74957d0b9d(shape, style) {
    $fcwet.subPixelOptimizeRect(shape, shape, style);
    return shape;
}
var $c7dec214544dd0ea$export$72c4fd4c1b8fcb10 = $fcwet.subPixelOptimize;
function $c7dec214544dd0ea$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $19Ywy.identity([]);
    while(target && target !== ancestor){
        $19Ywy.mul(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $c7dec214544dd0ea$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $2N6Uo.isArrayLike)(transform)) transform = (0, $erz95.default).getLocalTransform(transform);
    if (invert) transform = $19Ywy.invert([], transform);
    return $U1aqY.applyTransform([], target, transform);
}
function $c7dec214544dd0ea$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : (0, $iCU10.mathAbs)(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : (0, $iCU10.mathAbs)(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $c7dec214544dd0ea$export$9f9dcb98c894b623(vertex, transform, invert);
    return (0, $iCU10.mathAbs)(vertex[0]) > (0, $iCU10.mathAbs)(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $c7dec214544dd0ea$var$isNotGroup(el) {
    return !el.isGroup;
}
function $c7dec214544dd0ea$var$isPath(el) {
    return el.shape != null;
}
function $c7dec214544dd0ea$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($c7dec214544dd0ea$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($c7dec214544dd0ea$var$isPath(el)) obj.shape = (0, $2N6Uo.clone)(el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($c7dec214544dd0ea$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $ipprj.updateProps)(el, newProp, animatableModel, (0, $6TSUP.getECData)(el).dataIndex);
            }
        }
    });
}
function $c7dec214544dd0ea$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $2N6Uo.map)(points, function(point) {
        var x = point[0];
        x = (0, $iCU10.mathMax)(x, rect.x);
        x = (0, $iCU10.mathMin)(x, rect.x + rect.width);
        var y = point[1];
        y = (0, $iCU10.mathMax)(y, rect.y);
        y = (0, $iCU10.mathMin)(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $c7dec214544dd0ea$export$d0d3709202b8b2a(targetRect, rect) {
    var x = (0, $iCU10.mathMax)(targetRect.x, rect.x);
    var x2 = (0, $iCU10.mathMin)(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = (0, $iCU10.mathMax)(targetRect.y, rect.y);
    var y2 = (0, $iCU10.mathMin)(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $c7dec214544dd0ea$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $2N6Uo.extend)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $2N6Uo.defaults)(style, rect), new (0, $lQsZt.default)(innerOpts)) : $c7dec214544dd0ea$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $c7dec214544dd0ea$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($c7dec214544dd0ea$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $c7dec214544dd0ea$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $c7dec214544dd0ea$var$crossProduct2d(nx, ny, mx, my);
    if ($c7dec214544dd0ea$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $c7dec214544dd0ea$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $c7dec214544dd0ea$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $c7dec214544dd0ea$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $c7dec214544dd0ea$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $c7dec214544dd0ea$export$81ed941fdeb91c7c(rect, delta, shrinkOrExpand, noNegative, minSize // by default [0, 0].
) {
    if (delta == null) return rect;
    else if ((0, $2N6Uo.isNumber)(delta)) $c7dec214544dd0ea$var$_tmpExpandRectDelta[0] = $c7dec214544dd0ea$var$_tmpExpandRectDelta[1] = $c7dec214544dd0ea$var$_tmpExpandRectDelta[2] = $c7dec214544dd0ea$var$_tmpExpandRectDelta[3] = delta;
    else {
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[0] = delta[0];
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[1] = delta[1];
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[2] = delta[2];
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[3] = delta[3];
    }
    if (noNegative) {
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[0] = (0, $iCU10.mathMax)(0, $c7dec214544dd0ea$var$_tmpExpandRectDelta[0]);
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[1] = (0, $iCU10.mathMax)(0, $c7dec214544dd0ea$var$_tmpExpandRectDelta[1]);
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[2] = (0, $iCU10.mathMax)(0, $c7dec214544dd0ea$var$_tmpExpandRectDelta[2]);
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[3] = (0, $iCU10.mathMax)(0, $c7dec214544dd0ea$var$_tmpExpandRectDelta[3]);
    }
    if (shrinkOrExpand) {
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[0] = -$c7dec214544dd0ea$var$_tmpExpandRectDelta[0];
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[1] = -$c7dec214544dd0ea$var$_tmpExpandRectDelta[1];
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[2] = -$c7dec214544dd0ea$var$_tmpExpandRectDelta[2];
        $c7dec214544dd0ea$var$_tmpExpandRectDelta[3] = -$c7dec214544dd0ea$var$_tmpExpandRectDelta[3];
    }
    $c7dec214544dd0ea$var$expandRectOnOneDimension(rect, $c7dec214544dd0ea$var$_tmpExpandRectDelta, 'x', 'width', 3, 1, minSize && minSize[0] || 0);
    $c7dec214544dd0ea$var$expandRectOnOneDimension(rect, $c7dec214544dd0ea$var$_tmpExpandRectDelta, 'y', 'height', 0, 2, minSize && minSize[1] || 0);
    return rect;
}
var $c7dec214544dd0ea$var$_tmpExpandRectDelta = [
    0,
    0,
    0,
    0
];
function $c7dec214544dd0ea$var$expandRectOnOneDimension(rect, delta, xy, wh, ltIdx, rbIdx, minSize) {
    var deltaSum = delta[rbIdx] + delta[ltIdx];
    var oldSize = rect[wh];
    rect[wh] += deltaSum;
    minSize = (0, $iCU10.mathMax)(0, (0, $iCU10.mathMin)(minSize, oldSize));
    if (rect[wh] < minSize) {
        rect[wh] = minSize;
        // Try to make the position of the zero rect reasonable in most visual cases.
        rect[xy] += delta[ltIdx] >= 0 ? -delta[ltIdx] : delta[rbIdx] >= 0 ? oldSize + delta[rbIdx] : (0, $iCU10.mathAbs)(deltaSum) > 1e-8 ? (oldSize - minSize) * delta[ltIdx] / deltaSum : 0;
    } else rect[xy] -= delta[ltIdx];
}
function $c7dec214544dd0ea$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $2N6Uo.isString)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $2N6Uo.each)((0, $2N6Uo.keys)(formatterParamsExtra), function(key) {
        if (!(0, $2N6Uo.hasOwn)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $6TSUP.getECData)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $2N6Uo.defaults)({
            content: itemName,
            encodeHTMLContent: true,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $c7dec214544dd0ea$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $c7dec214544dd0ea$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $2N6Uo.isArray)(els)) for(var i = 0; i < els.length; i++)$c7dec214544dd0ea$var$traverseElement(els[i], cb);
        else $c7dec214544dd0ea$var$traverseElement(els, cb);
    }
}
function $c7dec214544dd0ea$export$576610ccf2234b72(transform) {
    return !transform || (0, $iCU10.mathAbs)(transform[1]) < $c7dec214544dd0ea$var$AXIS_ALIGN_EPSILON && (0, $iCU10.mathAbs)(transform[2]) < $c7dec214544dd0ea$var$AXIS_ALIGN_EPSILON || (0, $iCU10.mathAbs)(transform[0]) < $c7dec214544dd0ea$var$AXIS_ALIGN_EPSILON && (0, $iCU10.mathAbs)(transform[3]) < $c7dec214544dd0ea$var$AXIS_ALIGN_EPSILON;
}
var $c7dec214544dd0ea$var$AXIS_ALIGN_EPSILON = 1e-5;
function $c7dec214544dd0ea$export$38128dfd9a498e1(target, source) {
    return target ? (0, $67W72.default).copy(target, source) : source.clone();
}
function $c7dec214544dd0ea$export$4d61283a070e0362(target, source) {
    return source ? $19Ywy.copy(target || $19Ywy.create(), source) : undefined;
}
function $c7dec214544dd0ea$export$1500a631bea5adda(model) {
    return {
        z: model.get('z') || 0,
        zlevel: model.get('zlevel') || 0
    };
}
function $c7dec214544dd0ea$export$8215ea00957327f2(el) {
    var max = -Infinity;
    var min = Infinity;
    $c7dec214544dd0ea$var$traverseElement(el, function(el) {
        visitEl(el);
        visitEl(el.getTextContent());
        visitEl(el.getTextGuideLine());
    });
    function visitEl(el) {
        if (!el || el.isGroup) return;
        var currentStates = el.currentStates;
        if (currentStates.length) for(var idx = 0; idx < currentStates.length; idx++)calcZ2(el.states[currentStates[idx]]);
        calcZ2(el);
    }
    function calcZ2(entity) {
        if (entity) {
            var z2 = entity.z2;
            // Consider z2 may be NullUndefined
            if (z2 > max) max = z2;
            if (z2 < min) min = z2;
        }
    }
    if (min > max) min = max = 0;
    return {
        min: min,
        max: max
    };
}
function $c7dec214544dd0ea$export$d31cf465bf5e8879(el, z, zlevel) {
    $c7dec214544dd0ea$var$doUpdateZ(el, z, zlevel, -Infinity);
}
function $c7dec214544dd0ea$var$doUpdateZ(el, z, zlevel, // FIXME: Ideally all the labels should be above all the glyphs by default,
//  e.g. in graph, edge labels should be above node elements.
//  Currently impl does not guarantee that.
maxZ2) {
    // `ignoreModelZ` is used to intentionally lift elements to cover other elements,
    // where maxZ2 (for label.z2) should also not be counted for its parents.
    if (el.ignoreModelZ) return maxZ2;
    // Group may also have textContent
    var label = el.getTextContent();
    var labelLine = el.getTextGuideLine();
    var isGroup = el.isGroup;
    if (isGroup) {
        // set z & zlevel of children elements of Group
        var children = el.childrenRef();
        for(var i = 0; i < children.length; i++)maxZ2 = (0, $iCU10.mathMax)($c7dec214544dd0ea$var$doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
    } else {
        // not Group
        el.z = z;
        el.zlevel = zlevel;
        maxZ2 = (0, $iCU10.mathMax)(el.z2 || 0, maxZ2);
    }
    // always set z and zlevel if label/labelLine exists
    if (label) {
        label.z = z;
        label.zlevel = zlevel;
        // lift z2 of text content
        // TODO if el.emphasis.z2 is spcefied, what about textContent.
        isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
    }
    if (labelLine) {
        var textGuideLineConfig = el.textGuideLineConfig;
        labelLine.z = z;
        labelLine.zlevel = zlevel;
        isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
    }
    return maxZ2;
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('circle', (0, $6Utk3.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('ellipse', (0, $3jYPd.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('sector', (0, $60Kbk.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('ring', (0, $iqf4i.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('polygon', (0, $hXTRG.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('polyline', (0, $ewDYK.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('rect', (0, $aH2k0.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('line', (0, $c3CaY.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('bezierCurve', (0, $1y8oO.default));
$c7dec214544dd0ea$export$2b95b62e3aaf6fdd('arc', (0, $2ClTb.default));

});
parcelRegister("hI0Jj", function(module, exports) {

$parcel$export(module.exports, "createFromString", function () { return $ce471ca7902b5700$export$ae5b259626f00aeb; });
$parcel$export(module.exports, "extendFromString", function () { return $ce471ca7902b5700$export$68e3a51ba2ed417c; });
$parcel$export(module.exports, "mergePath", function () { return $ce471ca7902b5700$export$7b1dd269fbc4e903; });
$parcel$export(module.exports, "clonePath", function () { return $ce471ca7902b5700$export$18711d956bf1c3eb; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $eAFw0 = parcelRequire("eAFw0");

var $kkzku = parcelRequire("kkzku");

var $2N6Uo = parcelRequire("2N6Uo");
var $ce471ca7902b5700$var$mathSqrt = Math.sqrt;
var $ce471ca7902b5700$var$mathSin = Math.sin;
var $ce471ca7902b5700$var$mathCos = Math.cos;
var $ce471ca7902b5700$var$PI = Math.PI;
function $ce471ca7902b5700$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $ce471ca7902b5700$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($ce471ca7902b5700$var$vMag(u) * $ce471ca7902b5700$var$vMag(v));
}
function $ce471ca7902b5700$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($ce471ca7902b5700$var$vRatio(u, v));
}
function $ce471ca7902b5700$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($ce471ca7902b5700$var$PI / 180.0);
    var xp = $ce471ca7902b5700$var$mathCos(psi) * (x1 - x2) / 2.0 + $ce471ca7902b5700$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $ce471ca7902b5700$var$mathSin(psi) * (x1 - x2) / 2.0 + $ce471ca7902b5700$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $ce471ca7902b5700$var$mathSqrt(lambda);
        ry *= $ce471ca7902b5700$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $ce471ca7902b5700$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $ce471ca7902b5700$var$mathCos(psi) * cxp - $ce471ca7902b5700$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $ce471ca7902b5700$var$mathSin(psi) * cxp + $ce471ca7902b5700$var$mathCos(psi) * cyp;
    var theta = $ce471ca7902b5700$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $ce471ca7902b5700$var$vAngle(u, v);
    if ($ce471ca7902b5700$var$vRatio(u, v) <= -1) dTheta = $ce471ca7902b5700$var$PI;
    if ($ce471ca7902b5700$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $ce471ca7902b5700$var$PI * 1e6) / 1e6;
        dTheta = $ce471ca7902b5700$var$PI * 2 + n % 2 * $ce471ca7902b5700$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $ce471ca7902b5700$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $ce471ca7902b5700$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $ce471ca7902b5700$var$createPathProxyFromString(data) {
    var path = new (0, $eAFw0.default)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $eAFw0.default).CMD;
    var cmdList = data.match($ce471ca7902b5700$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($ce471ca7902b5700$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $ce471ca7902b5700$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $ce471ca7902b5700$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $ce471ca7902b5700$var$SVGPath = function(_super) {
    (0, $9nEce.__extends)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $4oDJM.default));
function $ce471ca7902b5700$var$isPathProxy(path) {
    return path.setData != null;
}
function $ce471ca7902b5700$var$createPathOptions(str, opts) {
    var pathProxy = $ce471ca7902b5700$var$createPathProxyFromString(str);
    var innerOpts = (0, $2N6Uo.extend)({}, opts);
    innerOpts.buildPath = function(path) {
        var beProxy = $ce471ca7902b5700$var$isPathProxy(path);
        if (beProxy && path.canSave()) {
            path.appendPath(pathProxy);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = beProxy ? path.getContext() : path;
            if (ctx) pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $kkzku.default)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $ce471ca7902b5700$export$ae5b259626f00aeb(str, opts) {
    return new $ce471ca7902b5700$var$SVGPath($ce471ca7902b5700$var$createPathOptions(str, opts));
}
function $ce471ca7902b5700$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $ce471ca7902b5700$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $9nEce.__extends)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($ce471ca7902b5700$var$SVGPath);
    return Sub;
}
function $ce471ca7902b5700$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $4oDJM.default)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($ce471ca7902b5700$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $ce471ca7902b5700$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $4oDJM.default)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $kkzku.default)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}

});
parcelRegister("kkzku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecd1149a663e193a$export$2e2bcd8739ae039; });

var $eAFw0 = parcelRequire("eAFw0");

var $U1aqY = parcelRequire("U1aqY");
var $ecd1149a663e193a$var$CMD = (0, $eAFw0.default).CMD;
var $ecd1149a663e193a$var$points = [
    [],
    [],
    []
];
var $ecd1149a663e193a$var$mathSqrt = Math.sqrt;
var $ecd1149a663e193a$var$mathAtan2 = Math.atan2;
function $ecd1149a663e193a$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $ecd1149a663e193a$var$CMD.M;
    var C = $ecd1149a663e193a$var$CMD.C;
    var L = $ecd1149a663e193a$var$CMD.L;
    var R = $ecd1149a663e193a$var$CMD.R;
    var A = $ecd1149a663e193a$var$CMD.A;
    var Q = $ecd1149a663e193a$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $ecd1149a663e193a$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $ecd1149a663e193a$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $ecd1149a663e193a$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $U1aqY.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $U1aqY.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $ecd1149a663e193a$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $U1aqY.applyTransform)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}

});


parcelRegister("6Utk3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $507eb7e27146f0b0$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");
var $507eb7e27146f0b0$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $507eb7e27146f0b0$var$Circle = function(_super) {
    (0, $9nEce.__extends)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $507eb7e27146f0b0$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $4oDJM.default));
$507eb7e27146f0b0$var$Circle.prototype.type = 'circle';
var $507eb7e27146f0b0$export$2e2bcd8739ae039 = $507eb7e27146f0b0$var$Circle;

});

parcelRegister("3jYPd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b2540283dac1f0$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");
var $26b2540283dac1f0$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $26b2540283dac1f0$var$Ellipse = function(_super) {
    (0, $9nEce.__extends)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $26b2540283dac1f0$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $4oDJM.default));
$26b2540283dac1f0$var$Ellipse.prototype.type = 'ellipse';
var $26b2540283dac1f0$export$2e2bcd8739ae039 = $26b2540283dac1f0$var$Ellipse;

});

parcelRegister("60Kbk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $460690e27cd08416$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $luRsU = parcelRequire("luRsU");
var $460690e27cd08416$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $460690e27cd08416$var$Sector = function(_super) {
    (0, $9nEce.__extends)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $460690e27cd08416$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $luRsU.buildPath(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $4oDJM.default));
$460690e27cd08416$var$Sector.prototype.type = 'sector';
var $460690e27cd08416$export$2e2bcd8739ae039 = $460690e27cd08416$var$Sector;

});
parcelRegister("luRsU", function(module, exports) {

$parcel$export(module.exports, "buildPath", function () { return $fa65df6be38993b5$export$5cc7f731b5937e99; });

var $2N6Uo = parcelRequire("2N6Uo");
var $fa65df6be38993b5$var$PI = Math.PI;
var $fa65df6be38993b5$var$PI2 = $fa65df6be38993b5$var$PI * 2;
var $fa65df6be38993b5$var$mathSin = Math.sin;
var $fa65df6be38993b5$var$mathCos = Math.cos;
var $fa65df6be38993b5$var$mathACos = Math.acos;
var $fa65df6be38993b5$var$mathATan2 = Math.atan2;
var $fa65df6be38993b5$var$mathAbs = Math.abs;
var $fa65df6be38993b5$var$mathSqrt = Math.sqrt;
var $fa65df6be38993b5$var$mathMax = Math.max;
var $fa65df6be38993b5$var$mathMin = Math.min;
var $fa65df6be38993b5$var$e = 1e-4;
function $fa65df6be38993b5$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $fa65df6be38993b5$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $fa65df6be38993b5$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $fa65df6be38993b5$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $fa65df6be38993b5$var$mathSqrt($fa65df6be38993b5$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $fa65df6be38993b5$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $2N6Uo.isArray)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $fa65df6be38993b5$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $fa65df6be38993b5$var$mathMax(shape.r, 0);
    var innerRadius = $fa65df6be38993b5$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $fa65df6be38993b5$var$mathAbs(endAngle - startAngle);
    var mod = arc > $fa65df6be38993b5$var$PI2 && arc % $fa65df6be38993b5$var$PI2;
    mod > $fa65df6be38993b5$var$e && (arc = mod);
    if (!(radius > $fa65df6be38993b5$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $fa65df6be38993b5$var$PI2 - $fa65df6be38993b5$var$e) {
        ctx.moveTo(cx + radius * $fa65df6be38993b5$var$mathCos(startAngle), cy + radius * $fa65df6be38993b5$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $fa65df6be38993b5$var$e) {
            ctx.moveTo(cx + innerRadius * $fa65df6be38993b5$var$mathCos(endAngle), cy + innerRadius * $fa65df6be38993b5$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $fa65df6be38993b5$var$mathCos(startAngle);
        var yrs = radius * $fa65df6be38993b5$var$mathSin(startAngle);
        var xire = innerRadius * $fa65df6be38993b5$var$mathCos(endAngle);
        var yire = innerRadius * $fa65df6be38993b5$var$mathSin(endAngle);
        var hasArc = arc > $fa65df6be38993b5$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $fa65df6be38993b5$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $fa65df6be38993b5$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $fa65df6be38993b5$var$mathMin(halfRd, ocrStart);
            ocre = $fa65df6be38993b5$var$mathMin(halfRd, ocrEnd);
            icrs = $fa65df6be38993b5$var$mathMin(halfRd, icrStart);
            icre = $fa65df6be38993b5$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $fa65df6be38993b5$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $fa65df6be38993b5$var$mathMax(icrs, icre);
            if (ocrMax > $fa65df6be38993b5$var$e || icrMax > $fa65df6be38993b5$var$e) {
                xre = radius * $fa65df6be38993b5$var$mathCos(endAngle);
                yre = radius * $fa65df6be38993b5$var$mathSin(endAngle);
                xirs = innerRadius * $fa65df6be38993b5$var$mathCos(startAngle);
                yirs = innerRadius * $fa65df6be38993b5$var$mathSin(startAngle);
                if (arc < $fa65df6be38993b5$var$PI) {
                    var it_1 = $fa65df6be38993b5$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $fa65df6be38993b5$var$mathSin($fa65df6be38993b5$var$mathACos((x0 * x1 + y0 * y1) / ($fa65df6be38993b5$var$mathSqrt(x0 * x0 + y0 * y0) * $fa65df6be38993b5$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $fa65df6be38993b5$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $fa65df6be38993b5$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $fa65df6be38993b5$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $fa65df6be38993b5$var$e) {
            var crStart = $fa65df6be38993b5$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $fa65df6be38993b5$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $fa65df6be38993b5$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $fa65df6be38993b5$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $fa65df6be38993b5$var$mathATan2(ct0.y0, ct0.x0), $fa65df6be38993b5$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $fa65df6be38993b5$var$mathATan2(ct0.y0, ct0.x0), $fa65df6be38993b5$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $fa65df6be38993b5$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $fa65df6be38993b5$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $fa65df6be38993b5$var$mathATan2(ct1.y1, ct1.x1), $fa65df6be38993b5$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $fa65df6be38993b5$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $fa65df6be38993b5$var$e) {
            var crStart = $fa65df6be38993b5$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $fa65df6be38993b5$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $fa65df6be38993b5$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $fa65df6be38993b5$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $fa65df6be38993b5$var$mathATan2(ct0.y0, ct0.x0), $fa65df6be38993b5$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $fa65df6be38993b5$var$mathATan2(ct0.y0, ct0.x0), $fa65df6be38993b5$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $fa65df6be38993b5$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $fa65df6be38993b5$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $fa65df6be38993b5$var$mathATan2(ct1.y1, ct1.x1), $fa65df6be38993b5$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}

});


parcelRegister("iqf4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d69657f633e10243$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");
var $d69657f633e10243$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $d69657f633e10243$var$Ring = function(_super) {
    (0, $9nEce.__extends)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $d69657f633e10243$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $4oDJM.default));
$d69657f633e10243$var$Ring.prototype.type = 'ring';
var $d69657f633e10243$export$2e2bcd8739ae039 = $d69657f633e10243$var$Ring;

});

parcelRegister("hXTRG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d14347f95308e0b6$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $j4JQs = parcelRequire("j4JQs");
var $d14347f95308e0b6$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $d14347f95308e0b6$var$Polygon = function(_super) {
    (0, $9nEce.__extends)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $d14347f95308e0b6$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $j4JQs.buildPath(ctx, shape, true);
    };
    return Polygon;
}((0, $4oDJM.default));
$d14347f95308e0b6$var$Polygon.prototype.type = 'polygon';
var $d14347f95308e0b6$export$2e2bcd8739ae039 = $d14347f95308e0b6$var$Polygon;

});
parcelRegister("j4JQs", function(module, exports) {

$parcel$export(module.exports, "buildPath", function () { return $de31f3f13b7360f2$export$5cc7f731b5937e99; });

var $3wYaT = parcelRequire("3wYaT");
function $de31f3f13b7360f2$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $3wYaT.default)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}

});
parcelRegister("3wYaT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $292309acd829936a$export$2e2bcd8739ae039; });

var $U1aqY = parcelRequire("U1aqY");
function $292309acd829936a$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $U1aqY.min)(min, min, points[i]);
            (0, $U1aqY.max)(max, max, points[i]);
        }
        (0, $U1aqY.min)(min, min, constraint[0]);
        (0, $U1aqY.max)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $U1aqY.clone)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $U1aqY.sub)(v, nextPoint, prevPoint);
        (0, $U1aqY.scale)(v, v, smooth);
        var d0 = (0, $U1aqY.distance)(point, prevPoint);
        var d1 = (0, $U1aqY.distance)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $U1aqY.scale)(v1, v, -d0);
        (0, $U1aqY.scale)(v2, v, d1);
        var cp0 = (0, $U1aqY.add)([], point, v1);
        var cp1 = (0, $U1aqY.add)([], point, v2);
        if (constraint) {
            (0, $U1aqY.max)(cp0, cp0, min);
            (0, $U1aqY.min)(cp0, cp0, max);
            (0, $U1aqY.max)(cp1, cp1, min);
            (0, $U1aqY.min)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}

});



parcelRegister("ewDYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a93310cf5e68fe47$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $j4JQs = parcelRequire("j4JQs");
var $a93310cf5e68fe47$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $a93310cf5e68fe47$var$Polyline = function(_super) {
    (0, $9nEce.__extends)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $a93310cf5e68fe47$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $j4JQs.buildPath(ctx, shape, false);
    };
    return Polyline;
}((0, $4oDJM.default));
$a93310cf5e68fe47$var$Polyline.prototype.type = 'polyline';
var $a93310cf5e68fe47$export$2e2bcd8739ae039 = $a93310cf5e68fe47$var$Polyline;

});

parcelRegister("c3CaY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7360cee771a072$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $fcwet = parcelRequire("fcwet");
var $8c7360cee771a072$var$subPixelOptimizeOutputShape = {};
var $8c7360cee771a072$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $8c7360cee771a072$var$Line = function(_super) {
    (0, $9nEce.__extends)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $8c7360cee771a072$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $fcwet.subPixelOptimizeLine)($8c7360cee771a072$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $4oDJM.default));
$8c7360cee771a072$var$Line.prototype.type = 'line';
var $8c7360cee771a072$export$2e2bcd8739ae039 = $8c7360cee771a072$var$Line;

});

parcelRegister("1y8oO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $120f7b53644f47f9$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $U1aqY = parcelRequire("U1aqY");

var $1kxDI = parcelRequire("1kxDI");
var $120f7b53644f47f9$var$out = [];
var $120f7b53644f47f9$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $120f7b53644f47f9$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $1kxDI.cubicDerivativeAt) : (0, $1kxDI.cubicAt))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $1kxDI.cubicDerivativeAt) : (0, $1kxDI.cubicAt))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $1kxDI.quadraticDerivativeAt) : (0, $1kxDI.quadraticAt))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $1kxDI.quadraticDerivativeAt) : (0, $1kxDI.quadraticAt))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $120f7b53644f47f9$var$BezierCurve = function(_super) {
    (0, $9nEce.__extends)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $120f7b53644f47f9$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $1kxDI.quadraticSubdivide)(x1, cpx1, x2, percent, $120f7b53644f47f9$var$out);
                cpx1 = $120f7b53644f47f9$var$out[1];
                x2 = $120f7b53644f47f9$var$out[2];
                (0, $1kxDI.quadraticSubdivide)(y1, cpy1, y2, percent, $120f7b53644f47f9$var$out);
                cpy1 = $120f7b53644f47f9$var$out[1];
                y2 = $120f7b53644f47f9$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $1kxDI.cubicSubdivide)(x1, cpx1, cpx2, x2, percent, $120f7b53644f47f9$var$out);
                cpx1 = $120f7b53644f47f9$var$out[1];
                cpx2 = $120f7b53644f47f9$var$out[2];
                x2 = $120f7b53644f47f9$var$out[3];
                (0, $1kxDI.cubicSubdivide)(y1, cpy1, cpy2, y2, percent, $120f7b53644f47f9$var$out);
                cpy1 = $120f7b53644f47f9$var$out[1];
                cpy2 = $120f7b53644f47f9$var$out[2];
                y2 = $120f7b53644f47f9$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $120f7b53644f47f9$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $120f7b53644f47f9$var$someVectorAt(this.shape, t, true);
        return $U1aqY.normalize(p, p);
    };
    return BezierCurve;
}((0, $4oDJM.default));
$120f7b53644f47f9$var$BezierCurve.prototype.type = 'bezier-curve';
var $120f7b53644f47f9$export$2e2bcd8739ae039 = $120f7b53644f47f9$var$BezierCurve;

});

parcelRegister("2ClTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e801c15e18abc30$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");
var $1e801c15e18abc30$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $1e801c15e18abc30$var$Arc = function(_super) {
    (0, $9nEce.__extends)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $1e801c15e18abc30$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $4oDJM.default));
$1e801c15e18abc30$var$Arc.prototype.type = 'arc';
var $1e801c15e18abc30$export$2e2bcd8739ae039 = $1e801c15e18abc30$var$Arc;

});

parcelRegister("5JZmf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42e0c021116a1616$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");
var $42e0c021116a1616$var$CompoundPath = function(_super) {
    (0, $9nEce.__extends)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $4oDJM.default).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $4oDJM.default));
var $42e0c021116a1616$export$2e2bcd8739ae039 = $42e0c021116a1616$var$CompoundPath;

});

parcelRegister("ftfXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b435f1fe86b2bfcc$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $7rHG8 = parcelRequire("7rHG8");
var $b435f1fe86b2bfcc$var$LinearGradient = function(_super) {
    (0, $9nEce.__extends)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $7rHG8.default));
var $b435f1fe86b2bfcc$export$2e2bcd8739ae039 = $b435f1fe86b2bfcc$var$LinearGradient;

});
parcelRegister("7rHG8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56bcefa8651aef79$export$2e2bcd8739ae039; });
var $56bcefa8651aef79$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $56bcefa8651aef79$export$2e2bcd8739ae039 = $56bcefa8651aef79$var$Gradient;

});


parcelRegister("fv6es", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48e95dc01ce909b$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $7rHG8 = parcelRequire("7rHG8");
var $b48e95dc01ce909b$var$RadialGradient = function(_super) {
    (0, $9nEce.__extends)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $7rHG8.default));
var $b48e95dc01ce909b$export$2e2bcd8739ae039 = $b48e95dc01ce909b$var$RadialGradient;

});

parcelRegister("183nE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d292910b175564b$export$2e2bcd8739ae039; });

var $9KN3M = parcelRequire("9KN3M");

var $67W72 = parcelRequire("67W72");
var $0d292910b175564b$var$mathMin = Math.min;
var $0d292910b175564b$var$mathMax = Math.max;
var $0d292910b175564b$var$mathAbs = Math.abs;
var $0d292910b175564b$var$_extent = [
    0,
    0
];
var $0d292910b175564b$var$_extent2 = [
    0,
    0
];
var $0d292910b175564b$var$_intersectCtx = (0, $67W72.createIntersectContext)();
var $0d292910b175564b$var$_minTv = $0d292910b175564b$var$_intersectCtx.minTv;
var $0d292910b175564b$var$_maxTv = $0d292910b175564b$var$_intersectCtx.maxTv;
var $0d292910b175564b$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $9KN3M.default)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $9KN3M.default)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $9KN3M.default).sub(axes[0], corners[1], corners[0]);
        (0, $9KN3M.default).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv, opt) {
        var overlapped = true;
        var noMtv = !mtv;
        if (mtv) (0, $9KN3M.default).set(mtv, 0, 0);
        $0d292910b175564b$var$_intersectCtx.reset(opt, !noMtv);
        if (!this._intersectCheckOneSide(this, other, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv && !$0d292910b175564b$var$_intersectCtx.negativeSize) (0, $9KN3M.default).copy(mtv, overlapped ? $0d292910b175564b$var$_intersectCtx.useDir ? $0d292910b175564b$var$_intersectCtx.dirMinTv : $0d292910b175564b$var$_minTv : $0d292910b175564b$var$_maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = self._axes[i];
            self._getProjMinMaxOnAxis(i, self._corners, $0d292910b175564b$var$_extent);
            self._getProjMinMaxOnAxis(i, other._corners, $0d292910b175564b$var$_extent2);
            if ($0d292910b175564b$var$_intersectCtx.negativeSize || $0d292910b175564b$var$_extent[1] < $0d292910b175564b$var$_extent2[0] || $0d292910b175564b$var$_extent[0] > $0d292910b175564b$var$_extent2[1]) {
                overlapped = false;
                if ($0d292910b175564b$var$_intersectCtx.negativeSize || noMtv) return overlapped;
                var dist0 = $0d292910b175564b$var$mathAbs($0d292910b175564b$var$_extent2[0] - $0d292910b175564b$var$_extent[1]);
                var dist1 = $0d292910b175564b$var$mathAbs($0d292910b175564b$var$_extent[0] - $0d292910b175564b$var$_extent2[1]);
                if ($0d292910b175564b$var$mathMin(dist0, dist1) > $0d292910b175564b$var$_maxTv.len()) {
                    if (dist0 < dist1) (0, $9KN3M.default).scale($0d292910b175564b$var$_maxTv, axis, -dist0 * inverse);
                    else (0, $9KN3M.default).scale($0d292910b175564b$var$_maxTv, axis, dist1 * inverse);
                }
            } else if (!noMtv) {
                var dist0 = $0d292910b175564b$var$mathAbs($0d292910b175564b$var$_extent2[0] - $0d292910b175564b$var$_extent[1]);
                var dist1 = $0d292910b175564b$var$mathAbs($0d292910b175564b$var$_extent[0] - $0d292910b175564b$var$_extent2[1]);
                if ($0d292910b175564b$var$_intersectCtx.useDir || $0d292910b175564b$var$mathMin(dist0, dist1) < $0d292910b175564b$var$_minTv.len()) {
                    if (dist0 < dist1 || !$0d292910b175564b$var$_intersectCtx.bidirectional) {
                        (0, $9KN3M.default).scale($0d292910b175564b$var$_minTv, axis, dist0 * inverse);
                        if ($0d292910b175564b$var$_intersectCtx.useDir) $0d292910b175564b$var$_intersectCtx.calcDirMTV();
                    }
                    if (dist0 >= dist1 || !$0d292910b175564b$var$_intersectCtx.bidirectional) {
                        (0, $9KN3M.default).scale($0d292910b175564b$var$_minTv, axis, -dist1 * inverse);
                        if ($0d292910b175564b$var$_intersectCtx.useDir) $0d292910b175564b$var$_intersectCtx.calcDirMTV();
                    }
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = $0d292910b175564b$var$mathMin(proj_1, min);
            max = $0d292910b175564b$var$mathMax(proj_1, max);
        }
        out[0] = min + $0d292910b175564b$var$_intersectCtx.touchThreshold;
        out[1] = max - $0d292910b175564b$var$_intersectCtx.touchThreshold;
        $0d292910b175564b$var$_intersectCtx.negativeSize = out[1] < out[0];
    };
    return OrientedBoundingRect;
}();
var $0d292910b175564b$export$2e2bcd8739ae039 = $0d292910b175564b$var$OrientedBoundingRect;

});

parcelRegister("lMxou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdb7fc0015573a5a$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $6Ekel = parcelRequire("6Ekel");

var $67W72 = parcelRequire("67W72");
var $fdb7fc0015573a5a$var$m = [];
var $fdb7fc0015573a5a$var$IncrementalDisplayable = function(_super) {
    (0, $9nEce.__extends)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $67W72.default)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($fdb7fc0015573a5a$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $6Ekel.default));
var $fdb7fc0015573a5a$export$2e2bcd8739ae039 = $fdb7fc0015573a5a$var$IncrementalDisplayable;

});




parcelRegister("3KFvW", function(module, exports) {

$parcel$export(module.exports, "LINE_STYLE_KEY_MAP", function () { return $2bb5ded0a6280fb2$export$9f34de5b59222949; });
$parcel$export(module.exports, "LineStyleMixin", function () { return $2bb5ded0a6280fb2$export$91eeeeed4a69a7e7; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4jA7C = parcelRequire("4jA7C");
var $2bb5ded0a6280fb2$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ]
];
var $2bb5ded0a6280fb2$var$getLineStyle = (0, $4jA7C.default)($2bb5ded0a6280fb2$export$9f34de5b59222949);
var $2bb5ded0a6280fb2$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $2bb5ded0a6280fb2$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();

});

parcelRegister("fqEWa", function(module, exports) {

$parcel$export(module.exports, "ITEM_STYLE_KEY_MAP", function () { return $b3b909fe12f0951b$export$ffb0bba5dde0130b; });
$parcel$export(module.exports, "ItemStyleMixin", function () { return $b3b909fe12f0951b$export$e4f01e48d6fda412; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4jA7C = parcelRequire("4jA7C");
var $b3b909fe12f0951b$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ]
];
var $b3b909fe12f0951b$var$getItemStyle = (0, $4jA7C.default)($b3b909fe12f0951b$export$ffb0bba5dde0130b);
var $b3b909fe12f0951b$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $b3b909fe12f0951b$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();

});


parcelRegister("eLD2b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac03bbdf8fc400a1$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $b8YKU = parcelRequire("b8YKU");

var $cKPmR = parcelRequire("cKPmR");

var $I7Ovw = parcelRequire("I7Ovw");

var $bx3T8 = parcelRequire("bx3T8");

var $a35Wn = parcelRequire("a35Wn");
var $ac03bbdf8fc400a1$var$inner = (0, $bx3T8.makeInner)();
var $ac03bbdf8fc400a1$var$ComponentModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $cKPmR.getUID('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $a35Wn.fetchLayoutMode(this);
        var inputPositionParams = layoutMode ? $a35Wn.getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        $2N6Uo.merge(option, themeModel.get(this.mainType));
        $2N6Uo.merge(option, this.getDefaultOption());
        if (layoutMode) $a35Wn.mergeLayoutParam(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $2N6Uo.merge(this.option, option, true);
        var layoutMode = $a35Wn.fetchLayoutMode(this);
        if (layoutMode) $a35Wn.mergeLayoutParam(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        if (!(0, $I7Ovw.isExtendedClass)(ctor)) // When using ES class declaration, defaultOption must be declared as static.
        // And manually inherit the defaultOption from its parent class if needed, such as,
        //  ```ts
        //  static defaultOption = inheritDefaultOption(ParentModel.defaultOption, {...});
        //  ```
        return ctor.defaultOption;
        // FIXME: remove this approach?
        // Legacy: auto merge defaultOption from ancestor classes if using ParentClass.extend(subProto)
        var fields = $ac03bbdf8fc400a1$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $2N6Uo.merge(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $bx3T8.queryReferringComponents)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        // For backward compatibility, by default do not `ignoreParent`.
        return $a35Wn.getBoxLayoutParams(this, false);
    };
    /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */ ComponentModel.prototype.getZLevelKey = function() {
        return '';
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $b8YKU.default));
(0, $I7Ovw.mountExtend)($ac03bbdf8fc400a1$var$ComponentModel, (0, $b8YKU.default));
(0, $I7Ovw.enableClassManagement)($ac03bbdf8fc400a1$var$ComponentModel);
$cKPmR.enableSubTypeDefaulter($ac03bbdf8fc400a1$var$ComponentModel);
$cKPmR.enableTopologicalTravel($ac03bbdf8fc400a1$var$ComponentModel, $ac03bbdf8fc400a1$var$getDependencies);
function $ac03bbdf8fc400a1$var$getDependencies(componentType) {
    var deps = [];
    $2N6Uo.each($ac03bbdf8fc400a1$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $2N6Uo.map(deps, function(type) {
        return (0, $I7Ovw.parseClassType)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== 'dataset' && $2N6Uo.indexOf(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $ac03bbdf8fc400a1$export$2e2bcd8739ae039 = $ac03bbdf8fc400a1$var$ComponentModel;

});
parcelRegister("cKPmR", function(module, exports) {

$parcel$export(module.exports, "getUID", function () { return $9491a07e0c245e37$export$6d2b3473b0986646; });
$parcel$export(module.exports, "enableSubTypeDefaulter", function () { return $9491a07e0c245e37$export$b9faf30b7d655a6f; });
$parcel$export(module.exports, "enableTopologicalTravel", function () { return $9491a07e0c245e37$export$ce592d345a3ec040; });
$parcel$export(module.exports, "inheritDefaultOption", function () { return $9491a07e0c245e37$export$68acc510e46fef2; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $I7Ovw = parcelRequire("I7Ovw");

// A random offset
var $9491a07e0c245e37$var$base = Math.round(Math.random() * 10);
function $9491a07e0c245e37$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $9491a07e0c245e37$var$base++
    ].join('_');
}
function $9491a07e0c245e37$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $I7Ovw.parseClassType)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $I7Ovw.parseClassType)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $9491a07e0c245e37$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $2N6Uo.each(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $2N6Uo.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $2N6Uo.each(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $2N6Uo.each(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $2N6Uo.each(availableDeps, function(dependentName) {
                if ($2N6Uo.indexOf(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($2N6Uo.indexOf(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $2N6Uo.each(originalDeps, function(dep) {
            $2N6Uo.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $9491a07e0c245e37$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $2N6Uo.merge($2N6Uo.merge({}, superOption, true), subOption, true);
}

});

parcelRegister("a35Wn", function(module, exports) {

$parcel$export(module.exports, "LOCATION_PARAMS", function () { return $750ecae2ab8c8dc5$export$a9aa2cc018afbed; });
$parcel$export(module.exports, "box", function () { return $750ecae2ab8c8dc5$export$827f4ee28efc37; });
$parcel$export(module.exports, "getBoxLayoutParams", function () { return $750ecae2ab8c8dc5$export$22344244a123da8; });
$parcel$export(module.exports, "createBoxLayoutReference", function () { return $750ecae2ab8c8dc5$export$5aec1e94f566e59f; });
$parcel$export(module.exports, "getLayoutRect", function () { return $750ecae2ab8c8dc5$export$4517a5ca639a7293; });
$parcel$export(module.exports, "getCircleLayout", function () { return $750ecae2ab8c8dc5$export$3101c00baac0ee1f; });
$parcel$export(module.exports, "applyPreserveAspect", function () { return $750ecae2ab8c8dc5$export$9fec79e40d579ea7; });
$parcel$export(module.exports, "positionElement", function () { return $750ecae2ab8c8dc5$export$74054bd96b5eeef1; });
$parcel$export(module.exports, "sizeCalculable", function () { return $750ecae2ab8c8dc5$export$7ede609e8ebc9650; });
$parcel$export(module.exports, "fetchLayoutMode", function () { return $750ecae2ab8c8dc5$export$3968a28a7cbd6063; });
$parcel$export(module.exports, "mergeLayoutParam", function () { return $750ecae2ab8c8dc5$export$1754cb91f16ca028; });
$parcel$export(module.exports, "getLayoutParams", function () { return $750ecae2ab8c8dc5$export$4b0d20af19c9875e; });
$parcel$export(module.exports, "copyLayoutParams", function () { return $750ecae2ab8c8dc5$export$7438999faea9b6cc; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning

var $2N6Uo = parcelRequire("2N6Uo");

var $67W72 = parcelRequire("67W72");

var $iCU10 = parcelRequire("iCU10");

var $hrphB = parcelRequire("hrphB");


var $hIXrb = parcelRequire("hIXrb");
var $750ecae2ab8c8dc5$var$each = $2N6Uo.each;
var $750ecae2ab8c8dc5$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $750ecae2ab8c8dc5$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $750ecae2ab8c8dc5$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $750ecae2ab8c8dc5$export$827f4ee28efc37 = $750ecae2ab8c8dc5$var$boxLayout;
var $750ecae2ab8c8dc5$export$be20d9158c17374c = $2N6Uo.curry($750ecae2ab8c8dc5$var$boxLayout, 'vertical');
var $750ecae2ab8c8dc5$export$ae65a483d943e7a7 = $2N6Uo.curry($750ecae2ab8c8dc5$var$boxLayout, 'horizontal');
function $750ecae2ab8c8dc5$export$22344244a123da8(boxLayoutModel, ignoreParent) {
    return {
        left: boxLayoutModel.getShallow('left', ignoreParent),
        top: boxLayoutModel.getShallow('top', ignoreParent),
        right: boxLayoutModel.getShallow('right', ignoreParent),
        bottom: boxLayoutModel.getShallow('bottom', ignoreParent),
        width: boxLayoutModel.getShallow('width', ignoreParent),
        height: boxLayoutModel.getShallow('height', ignoreParent)
    };
}
function $750ecae2ab8c8dc5$var$getViewRectAndCenterForCircleLayout(seriesModel, api) {
    var layoutRef = $750ecae2ab8c8dc5$export$5aec1e94f566e59f(seriesModel, api, {
        enableLayoutOnlyByCenter: true
    });
    var boxLayoutParams = seriesModel.getBoxLayoutParams();
    var viewRect;
    var center;
    if (layoutRef.type === $750ecae2ab8c8dc5$export$953b11ffc6912560.point) {
        center = layoutRef.refPoint;
        // `viewRect` is required in `pie/labelLayout.ts`.
        viewRect = $750ecae2ab8c8dc5$export$4517a5ca639a7293(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
    } else {
        // layoutRef.type === layout.BoxLayoutReferenceType.rect
        var centerOption = seriesModel.get('center');
        var centerOptionArr = $2N6Uo.isArray(centerOption) ? centerOption : [
            centerOption,
            centerOption
        ];
        viewRect = $750ecae2ab8c8dc5$export$4517a5ca639a7293(boxLayoutParams, layoutRef.refContainer);
        center = layoutRef.boxCoordFrom === (0, $hIXrb.BoxCoordinateSystemCoordFrom).coord2 ? layoutRef.refPoint // option `series.center` has been used as coord.
         : [
            (0, $iCU10.parsePercent)(centerOptionArr[0], viewRect.width) + viewRect.x,
            (0, $iCU10.parsePercent)(centerOptionArr[1], viewRect.height) + viewRect.y
        ];
    }
    return {
        viewRect: viewRect,
        center: center
    };
}
function $750ecae2ab8c8dc5$export$3101c00baac0ee1f(seriesModel, api) {
    // center can be string or number when coordinateSystem is specified
    var _a = $750ecae2ab8c8dc5$var$getViewRectAndCenterForCircleLayout(seriesModel, api), viewRect = _a.viewRect, center = _a.center;
    var radius = seriesModel.get('radius');
    if (!$2N6Uo.isArray(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $iCU10.parsePercent)(viewRect.width, api.getWidth());
    var height = (0, $iCU10.parsePercent)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $iCU10.parsePercent)(radius[0], size / 2);
    var r = (0, $iCU10.parsePercent)(radius[1], size / 2);
    return {
        cx: center[0],
        cy: center[1],
        r0: r0,
        r: r,
        viewRect: viewRect
    };
}
function $750ecae2ab8c8dc5$export$4517a5ca639a7293(positionInfo, containerRect, // This is the space from the `containerRect` to the returned bounding rect.
// Commonly used in option `legend.padding`, `timeline.padding`, `title.padding`,
//  `visualMap.padding`, ...
// [NOTICE]:
//  It's named `margin`, because it's the space that outside the bounding rect. But from
//  the perspective of the the caller, it's commonly used as the `padding` of a component,
//  because conventionally background color covers this space.
// [BEHAVIOR]:
//  - If width/height is specified, `margin` does not effect them.
//  - Otherwise, they are calculated based on the rect that `containerRect` shrinked by `margin`.
//  - left/right/top/bottom are based on the rect that `containerRect` shrinked by `margin`.
margin) {
    margin = $hrphB.normalizeCssArray(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $iCU10.parsePercent)(positionInfo.left, containerWidth);
    var top = (0, $iCU10.parsePercent)(positionInfo.top, containerHeight);
    var right = (0, $iCU10.parsePercent)(positionInfo.right, containerWidth);
    var bottom = (0, $iCU10.parsePercent)(positionInfo.bottom, containerHeight);
    var width = (0, $iCU10.parsePercent)(positionInfo.width, containerWidth);
    var height = (0, $iCU10.parsePercent)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            // PENDING: if only `left` or `right` is defined, perhaps it's more preferable to
            // calculate size based on `containerWidth - left` or `containerWidth - left` here,
            // but for backward compatibility we do not change it.
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $67W72.default)((containerRect.x || 0) + left + margin[3], (containerRect.y || 0) + top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $750ecae2ab8c8dc5$export$9fec79e40d579ea7(component, layoutRect, // That is, `width / height`.
// Assume `aspect` is positive.
aspect) {
    var preserveAspect = component.getShallow('preserveAspect', true);
    if (!preserveAspect) return layoutRect;
    var actualAspect = layoutRect.width / layoutRect.height;
    if (Math.abs(Math.atan(aspect) - Math.atan(actualAspect)) < 1e-9) return layoutRect;
    var preserveAspectAlign = component.getShallow('preserveAspectAlign', true);
    var preserveAspectVerticalAlign = component.getShallow('preserveAspectVerticalAlign', true);
    var layoutOptInner = {
        width: layoutRect.width,
        height: layoutRect.height
    };
    var isCover = preserveAspect === 'cover';
    if (actualAspect > aspect && !isCover || actualAspect < aspect && isCover) {
        layoutOptInner.width = layoutRect.height * aspect;
        preserveAspectAlign === 'left' ? layoutOptInner.left = 0 : preserveAspectAlign === 'right' ? layoutOptInner.right = 0 : layoutOptInner.left = 'center';
    } else {
        layoutOptInner.height = layoutRect.width / aspect;
        preserveAspectVerticalAlign === 'top' ? layoutOptInner.top = 0 : preserveAspectVerticalAlign === 'bottom' ? layoutOptInner.bottom = 0 : layoutOptInner.top = 'middle';
    }
    return $750ecae2ab8c8dc5$export$4517a5ca639a7293(layoutOptInner, layoutRect);
}
var $750ecae2ab8c8dc5$export$953b11ffc6912560 = {
    rect: 1,
    point: 2
};
function $750ecae2ab8c8dc5$export$5aec1e94f566e59f(model, api, opt) {
    var refContainer;
    var refPoint;
    var layoutRefType;
    var boxCoordSys = model.boxCoordinateSystem;
    var boxCoordFrom;
    if (boxCoordSys) {
        var _a = (0, $hIXrb.getCoordForBoxCoordSys)(model), coord = _a.coord, from = _a.from;
        // Do not use `clamp` in `dataToLayout` and `dataToPoint`, because:
        //  1. Should support overflow (such as, by dataZoom), where NaN should be in the result.
        //  2. Be consistent with the way used in `series.data`
        if (boxCoordSys.dataToLayout) {
            layoutRefType = $750ecae2ab8c8dc5$export$953b11ffc6912560.rect;
            boxCoordFrom = from;
            var result = boxCoordSys.dataToLayout(coord);
            refContainer = result.contentRect || result.rect;
        } else if (opt && opt.enableLayoutOnlyByCenter && boxCoordSys.dataToPoint) {
            layoutRefType = $750ecae2ab8c8dc5$export$953b11ffc6912560.point;
            boxCoordFrom = from;
            refPoint = boxCoordSys.dataToPoint(coord);
        }
    }
    if (layoutRefType == null) layoutRefType = $750ecae2ab8c8dc5$export$953b11ffc6912560.rect;
    if (layoutRefType === $750ecae2ab8c8dc5$export$953b11ffc6912560.rect) {
        if (!refContainer) refContainer = {
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        };
        refPoint = [
            refContainer.x + refContainer.width / 2,
            refContainer.y + refContainer.height / 2
        ];
    }
    return {
        type: layoutRefType,
        refContainer: refContainer,
        refPoint: refPoint,
        boxCoordFrom: boxCoordFrom
    };
}
function $750ecae2ab8c8dc5$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $67W72.default)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $750ecae2ab8c8dc5$export$4517a5ca639a7293($2N6Uo.defaults({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $750ecae2ab8c8dc5$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$750ecae2ab8c8dc5$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$750ecae2ab8c8dc5$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$750ecae2ab8c8dc5$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $750ecae2ab8c8dc5$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $2N6Uo.isObject(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $750ecae2ab8c8dc5$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$2N6Uo.isArray(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($750ecae2ab8c8dc5$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($750ecae2ab8c8dc5$export$d7fd4338c7b20804[1], 1);
    copy($750ecae2ab8c8dc5$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($750ecae2ab8c8dc5$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $750ecae2ab8c8dc5$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $750ecae2ab8c8dc5$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            $2N6Uo.hasOwn(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!$2N6Uo.hasOwn(newParams, name_1) && $2N6Uo.hasOwn(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $750ecae2ab8c8dc5$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $750ecae2ab8c8dc5$export$4b0d20af19c9875e(source) {
    return $750ecae2ab8c8dc5$export$7438999faea9b6cc({}, source);
}
function $750ecae2ab8c8dc5$export$7438999faea9b6cc(target, source) {
    source && target && $750ecae2ab8c8dc5$var$each($750ecae2ab8c8dc5$export$a9aa2cc018afbed, function(name) {
        $2N6Uo.hasOwn(source, name) && (target[name] = source[name]);
    });
    return target;
}

});
parcelRegister("hrphB", function(module, exports) {

$parcel$export(module.exports, "addCommas", function () { return $cb2891f52d37c85d$export$b6fe44657ce35c42; });
$parcel$export(module.exports, "toCamelCase", function () { return $cb2891f52d37c85d$export$86f54f62aa7a7514; });
$parcel$export(module.exports, "normalizeCssArray", function () { return $cb2891f52d37c85d$export$f3a38102c49f4268; });
$parcel$export(module.exports, "makeValueReadable", function () { return $cb2891f52d37c85d$export$3cd8db88714decfc; });
$parcel$export(module.exports, "formatTpl", function () { return $cb2891f52d37c85d$export$2028496a35766e41; });
$parcel$export(module.exports, "formatTplSimple", function () { return $cb2891f52d37c85d$export$2fa08233ee42f8e1; });
$parcel$export(module.exports, "getTooltipMarker", function () { return $cb2891f52d37c85d$export$1987a3dbdf3c45ca; });
$parcel$export(module.exports, "convertToColorString", function () { return $cb2891f52d37c85d$export$cda04d03233e5555; });
$parcel$export(module.exports, "windowOpen", function () { return $cb2891f52d37c85d$export$13e13f9b96dbe8fa; });
$parcel$export(module.exports, "encodeHTML", function () { return (parcelRequire("dhQnW")).encodeHTML; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $dhQnW = parcelRequire("dhQnW");

var $iCU10 = parcelRequire("iCU10");

var $7Mt3p = parcelRequire("7Mt3p");



function $cb2891f52d37c85d$export$b6fe44657ce35c42(x) {
    if (!(0, $iCU10.isNumeric)(x)) return $2N6Uo.isString(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $cb2891f52d37c85d$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $cb2891f52d37c85d$export$f3a38102c49f4268 = $2N6Uo.normalizeCssArray;
function $cb2891f52d37c85d$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $2N6Uo.trim(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $iCU10.parseDate)(value) : value;
        if (!isNaN(+date)) return (0, $7Mt3p.format)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $2N6Uo.isStringSafe(value) ? stringToUserReadable(value) : $2N6Uo.isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
    // By default.
    var numericResult = (0, $iCU10.numericToNumber)(value);
    return isNumberUserReadable(numericResult) ? $cb2891f52d37c85d$export$b6fe44657ce35c42(numericResult) : $2N6Uo.isStringSafe(value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
}
var $cb2891f52d37c85d$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $cb2891f52d37c85d$var$wrapVar = function(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $cb2891f52d37c85d$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$2N6Uo.isArray(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $cb2891f52d37c85d$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($cb2891f52d37c85d$var$wrapVar(alias), $cb2891f52d37c85d$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($cb2891f52d37c85d$var$wrapVar($cb2891f52d37c85d$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $dhQnW.encodeHTML)(val) : val);
    }
    return tpl;
}
function $cb2891f52d37c85d$export$2fa08233ee42f8e1(tpl, param, encode) {
    $2N6Uo.each(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? (0, $dhQnW.encodeHTML)(value) : value);
    });
    return tpl;
}
function $cb2891f52d37c85d$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $2N6Uo.isString(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $dhQnW.encodeHTML)(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $dhQnW.encodeHTML)(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $cb2891f52d37c85d$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $iCU10.parseDate)(value);
    var getUTC = isUTC ? 'getUTC' : 'get';
    var y = date[getUTC + 'FullYear']();
    var M = date[getUTC + 'Month']() + 1;
    var d = date[getUTC + 'Date']();
    var h = date[getUTC + 'Hours']();
    var m = date[getUTC + 'Minutes']();
    var s = date[getUTC + 'Seconds']();
    var S = date[getUTC + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $7Mt3p.pad)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', (0, $7Mt3p.pad)(y % 100 + '', 2)).replace('dd', (0, $7Mt3p.pad)(d, 2)).replace('d', d).replace('hh', (0, $7Mt3p.pad)(h, 2)).replace('h', h).replace('mm', (0, $7Mt3p.pad)(m, 2)).replace('m', m).replace('ss', (0, $7Mt3p.pad)(s, 2)).replace('s', s).replace('SSS', (0, $7Mt3p.pad)(S, 3));
    return tpl;
}
function $cb2891f52d37c85d$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $cb2891f52d37c85d$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $2N6Uo.isString(color) ? color : $2N6Uo.isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $cb2891f52d37c85d$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}

});
parcelRegister("7Mt3p", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", function () { return $5aa38da02d914b55$export$32c0454ceff7f92d; });
$parcel$export(module.exports, "ONE_MINUTE", function () { return $5aa38da02d914b55$export$35acaebf644db34e; });
$parcel$export(module.exports, "ONE_HOUR", function () { return $5aa38da02d914b55$export$82541edf19e5e3b0; });
$parcel$export(module.exports, "ONE_DAY", function () { return $5aa38da02d914b55$export$a97a1358cbb650ab; });
$parcel$export(module.exports, "ONE_YEAR", function () { return $5aa38da02d914b55$export$99cafda57477293d; });
$parcel$export(module.exports, "fullLeveledFormatter", function () { return $5aa38da02d914b55$export$445bdbd8d2334e40; });
$parcel$export(module.exports, "primaryTimeUnits", function () { return $5aa38da02d914b55$export$87100da04d711986; });
$parcel$export(module.exports, "timeUnits", function () { return $5aa38da02d914b55$export$833c398a55654bb7; });
$parcel$export(module.exports, "parseTimeAxisLabelFormatter", function () { return $5aa38da02d914b55$export$f16a827770bdffb5; });
$parcel$export(module.exports, "pad", function () { return $5aa38da02d914b55$export$5d04458e2a6c373e; });
$parcel$export(module.exports, "getPrimaryTimeUnit", function () { return $5aa38da02d914b55$export$1da4b91a25d7e1c8; });
$parcel$export(module.exports, "isPrimaryTimeUnit", function () { return $5aa38da02d914b55$export$beb5920b69c13da; });
$parcel$export(module.exports, "getDefaultFormatPrecisionOfInterval", function () { return $5aa38da02d914b55$export$124c820721c4f66b; });
$parcel$export(module.exports, "format", function () { return $5aa38da02d914b55$export$d9468344d3651243; });
$parcel$export(module.exports, "fullYearGetterName", function () { return $5aa38da02d914b55$export$8d046fefed9a548e; });
$parcel$export(module.exports, "monthGetterName", function () { return $5aa38da02d914b55$export$5c242a801a23eec7; });
$parcel$export(module.exports, "dateGetterName", function () { return $5aa38da02d914b55$export$4189e6cbc9753260; });
$parcel$export(module.exports, "hoursGetterName", function () { return $5aa38da02d914b55$export$8b40b55b3c06cbe2; });
$parcel$export(module.exports, "minutesGetterName", function () { return $5aa38da02d914b55$export$8807847c5c71eded; });
$parcel$export(module.exports, "secondsGetterName", function () { return $5aa38da02d914b55$export$8f49e73e2eebd168; });
$parcel$export(module.exports, "millisecondsGetterName", function () { return $5aa38da02d914b55$export$312207a92d041116; });
$parcel$export(module.exports, "leveledFormat", function () { return $5aa38da02d914b55$export$fe777b6293828b5d; });
$parcel$export(module.exports, "getUnitFromValue", function () { return $5aa38da02d914b55$export$4dfb0417ad6555b7; });
$parcel$export(module.exports, "roundTime", function () { return $5aa38da02d914b55$export$2ed3384313b02c28; });
$parcel$export(module.exports, "monthSetterName", function () { return $5aa38da02d914b55$export$233f59998ed71c09; });
$parcel$export(module.exports, "dateSetterName", function () { return $5aa38da02d914b55$export$82fd379a67f37fa0; });
$parcel$export(module.exports, "hoursSetterName", function () { return $5aa38da02d914b55$export$b6f943e8d23c15bb; });
$parcel$export(module.exports, "minutesSetterName", function () { return $5aa38da02d914b55$export$50303078793fc7d; });
$parcel$export(module.exports, "secondsSetterName", function () { return $5aa38da02d914b55$export$a4a908acda9c3118; });
$parcel$export(module.exports, "millisecondsSetterName", function () { return $5aa38da02d914b55$export$c047afab75f6d84; });
$parcel$export(module.exports, "fullYearSetterName", function () { return $5aa38da02d914b55$export$43fbeac90913b151; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");

var $2FU9b = parcelRequire("2FU9b");

var $b8YKU = parcelRequire("b8YKU");

var $bjlCM = parcelRequire("bjlCM");
var $5aa38da02d914b55$export$32c0454ceff7f92d = 1000;
var $5aa38da02d914b55$export$35acaebf644db34e = $5aa38da02d914b55$export$32c0454ceff7f92d * 60;
var $5aa38da02d914b55$export$82541edf19e5e3b0 = $5aa38da02d914b55$export$35acaebf644db34e * 60;
var $5aa38da02d914b55$export$a97a1358cbb650ab = $5aa38da02d914b55$export$82541edf19e5e3b0 * 24;
var $5aa38da02d914b55$export$99cafda57477293d = $5aa38da02d914b55$export$a97a1358cbb650ab * 365;
var $5aa38da02d914b55$var$primaryTimeUnitFormatterMatchers = {
    year: /({yyyy}|{yy})/,
    month: /({MMMM}|{MMM}|{MM}|{M})/,
    day: /({dd}|{d})/,
    hour: /({HH}|{H}|{hh}|{h})/,
    minute: /({mm}|{m})/,
    second: /({ss}|{s})/,
    millisecond: /({SSS}|{S})/
};
var $5aa38da02d914b55$var$defaultFormatterSeed = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}'
};
var $5aa38da02d914b55$var$defaultFullFormatter = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}';
var $5aa38da02d914b55$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $5aa38da02d914b55$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $5aa38da02d914b55$var$fullDayFormatter,
    hour: $5aa38da02d914b55$var$fullDayFormatter + ' ' + $5aa38da02d914b55$var$defaultFormatterSeed.hour,
    minute: $5aa38da02d914b55$var$fullDayFormatter + ' ' + $5aa38da02d914b55$var$defaultFormatterSeed.minute,
    second: $5aa38da02d914b55$var$fullDayFormatter + ' ' + $5aa38da02d914b55$var$defaultFormatterSeed.second,
    millisecond: $5aa38da02d914b55$var$defaultFullFormatter
};
var $5aa38da02d914b55$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $5aa38da02d914b55$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $5aa38da02d914b55$export$f16a827770bdffb5(formatter) {
    // Keep the logic the same with function `leveledFormat`.
    return !$2N6Uo.isString(formatter) && !$2N6Uo.isFunction(formatter) ? $5aa38da02d914b55$var$parseTimeAxisLabelFormatterDictionary(formatter) : formatter;
}
/**
 * The final generated dictionary is like:
 *  generated_dict = {
 *      year: {
 *          year: ['{yyyy}', ...<higher_levels_if_any>]
 *      },
 *      month: {
 *          year: ['{yyyy} {MMM}', ...<higher_levels_if_any>],
 *          month: ['{MMM}', ...<higher_levels_if_any>]
 *      },
 *      day: {
 *          year: ['{yyyy} {MMM} {d}', ...<higher_levels_if_any>],
 *          month: ['{MMM} {d}', ...<higher_levels_if_any>],
 *          day: ['{d}', ...<higher_levels_if_any>]
 *      },
 *      ...
 *  }
 *
 * In echarts option, users can specify the entire dictionary or typically just:
 *  {formatter: {
 *      year: '{yyyy}', // Or an array of leveled templates: `['{yyyy}', '{bold1|{yyyy}}', ...]`,
 *                      // corresponding to `[level0, level1, level2, ...]`.
 *      month: '{MMM}',
 *      day: '{d}',
 *      hour: '{HH}:{mm}',
 *      second: '{HH}:{mm}',
 *      ...
 *  }}
 *  If any time unit is not specified in echarts option, the default template is used,
 *  such as `['{yyyy}', {primary|{yyyy}']`.
 *
 * The `tick.level` is only used to read string from each array, meaning the style type.
 *
 * Let `lowerUnit = getUnitFromValue(tick.value)`.
 * The non-break axis ticks only use `generated_dict[lowerUnit][lowerUnit][level]`.
 * The break axis ticks may use `generated_dict[lowerUnit][upperUnit][level]`, because:
 *  Consider the case: the non-break ticks are `16th, 23th, Feb, 7th, ...`, where `Feb` is in the break
 *  range and pruned by breaks, and the break ends might be in lower time unit than day. e.g., break start
 *  is `Jan 25th 18:00`(in unit `hour`) and break end is `Feb 6th 18:30` (in unit `minute`). Thus the break
 *  label prefers `Jan 25th 18:00` and `Feb 6th 18:30` rather than only `18:00` and `18:30`, otherwise it
 *  causes misleading.
 *  In this case, the tick of the break start and end will both be:
 *      `{level: 1, lowerTimeUnit: 'minute', upperTimeUnit: 'month'}`
 *  And get the final template by `generated_dict[lowerTimeUnit][upperTimeUnit][level]`.
 *  Note that the time unit can not be calculated directly by a single tick value, since the two breaks have
 *  to be at the same time unit to avoid awkward appearance. i.e., `Jan 25th 18:00` is in the time unit "hour"
 *  but we need it to be "minute", following `Feb 6th 18:30`.
 */ function $5aa38da02d914b55$var$parseTimeAxisLabelFormatterDictionary(dictOption) {
    dictOption = dictOption || {};
    var dict = {};
    // Currently if any template is specified by user, it may contain rich text tag,
    // such as `'{my_bold|{YYYY}}'`, thus we do add highlight style to it.
    // (Note that nested tag (`'{some|{some2|xxx}}'`) in rich text is not supported yet.)
    var canAddHighlight = true;
    $2N6Uo.each($5aa38da02d914b55$export$87100da04d711986, function(lowestUnit) {
        canAddHighlight && (canAddHighlight = dictOption[lowestUnit] == null);
    });
    $2N6Uo.each($5aa38da02d914b55$export$87100da04d711986, function(lowestUnit, lowestUnitIdx) {
        var upperDictOption = dictOption[lowestUnit];
        dict[lowestUnit] = {};
        var lowerTpl = null;
        for(var upperUnitIdx = lowestUnitIdx; upperUnitIdx >= 0; upperUnitIdx--){
            var upperUnit = $5aa38da02d914b55$export$87100da04d711986[upperUnitIdx];
            var upperDictItemOption = $2N6Uo.isObject(upperDictOption) && !$2N6Uo.isArray(upperDictOption) ? upperDictOption[upperUnit] : upperDictOption;
            var tplArr = void 0;
            if ($2N6Uo.isArray(upperDictItemOption)) {
                tplArr = upperDictItemOption.slice();
                lowerTpl = tplArr[0] || '';
            } else if ($2N6Uo.isString(upperDictItemOption)) {
                lowerTpl = upperDictItemOption;
                tplArr = [
                    lowerTpl
                ];
            } else {
                if (lowerTpl == null) lowerTpl = $5aa38da02d914b55$var$defaultFormatterSeed[lowestUnit];
                else if (!$5aa38da02d914b55$var$primaryTimeUnitFormatterMatchers[upperUnit].test(lowerTpl)) lowerTpl = dict[upperUnit][upperUnit][0] + " " + lowerTpl;
                tplArr = [
                    lowerTpl
                ];
                if (canAddHighlight) tplArr[1] = "{primary|" + lowerTpl + "}";
            }
            dict[lowestUnit][upperUnit] = tplArr;
        }
    });
    return dict;
}
function $5aa38da02d914b55$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $5aa38da02d914b55$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $5aa38da02d914b55$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $5aa38da02d914b55$export$1da4b91a25d7e1c8(timeUnit);
}
function $5aa38da02d914b55$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $5aa38da02d914b55$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $iCU10.parseDate(time);
    var y = date[$5aa38da02d914b55$export$8d046fefed9a548e(isUTC)]();
    var M = date[$5aa38da02d914b55$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$5aa38da02d914b55$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$5aa38da02d914b55$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$5aa38da02d914b55$export$8807847c5c71eded(isUTC)]();
    var s = date[$5aa38da02d914b55$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$5aa38da02d914b55$export$312207a92d041116(isUTC)]();
    var a = H >= 12 ? 'pm' : 'am';
    var A = a.toUpperCase();
    var localeModel = lang instanceof (0, $b8YKU.default) ? lang : (0, $2FU9b.getLocaleModel)(lang || (0, $2FU9b.SYSTEM_LANG)) || (0, $2FU9b.getDefaultLocaleModel)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{a}/g, a + '').replace(/{A}/g, A + '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, $5aa38da02d914b55$export$5d04458e2a6c373e(y % 100 + '', 2)).replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $5aa38da02d914b55$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $5aa38da02d914b55$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $5aa38da02d914b55$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $5aa38da02d914b55$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $5aa38da02d914b55$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $5aa38da02d914b55$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $5aa38da02d914b55$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $5aa38da02d914b55$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($2N6Uo.isString(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($2N6Uo.isFunction(formatter)) {
        var extra = {
            time: tick.time,
            level: tick.time.level
        };
        var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
        if (scaleBreakHelper) scaleBreakHelper.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
        template = formatter(tick.value, idx, extra);
    } else {
        var tickTime = tick.time;
        if (tickTime) {
            var leveledTplArr = formatter[tickTime.lowerTimeUnit][tickTime.upperTimeUnit];
            template = leveledTplArr[Math.min(tickTime.level, leveledTplArr.length - 1)] || '';
        } else {
            // tick may be from customTicks or timeline therefore no tick.time.
            var unit = $5aa38da02d914b55$export$4dfb0417ad6555b7(tick.value, isUTC);
            template = formatter[unit][unit][0];
        }
    }
    return $5aa38da02d914b55$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $5aa38da02d914b55$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $iCU10.parseDate(value);
    var M = date[$5aa38da02d914b55$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$5aa38da02d914b55$export$4189e6cbc9753260(isUTC)]();
    var h = date[$5aa38da02d914b55$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$5aa38da02d914b55$export$8807847c5c71eded(isUTC)]();
    var s = date[$5aa38da02d914b55$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$5aa38da02d914b55$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $5aa38da02d914b55$export$2ed3384313b02c28(date, timeUnit, isUTC) {
    switch(timeUnit){
        case 'year':
            date[$5aa38da02d914b55$export$233f59998ed71c09(isUTC)](0);
        case 'month':
            date[$5aa38da02d914b55$export$82fd379a67f37fa0(isUTC)](1);
        case 'day':
            date[$5aa38da02d914b55$export$b6f943e8d23c15bb(isUTC)](0);
        case 'hour':
            date[$5aa38da02d914b55$export$50303078793fc7d(isUTC)](0);
        case 'minute':
            date[$5aa38da02d914b55$export$a4a908acda9c3118(isUTC)](0);
        case 'second':
            date[$5aa38da02d914b55$export$c047afab75f6d84(isUTC)](0);
    }
    return date;
}
function $5aa38da02d914b55$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $5aa38da02d914b55$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $5aa38da02d914b55$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $5aa38da02d914b55$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $5aa38da02d914b55$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $5aa38da02d914b55$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $5aa38da02d914b55$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $5aa38da02d914b55$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $5aa38da02d914b55$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $5aa38da02d914b55$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $5aa38da02d914b55$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $5aa38da02d914b55$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $5aa38da02d914b55$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $5aa38da02d914b55$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}

});
parcelRegister("2FU9b", function(module, exports) {

$parcel$export(module.exports, "SYSTEM_LANG", function () { return $1f2af6bd40c3c89a$export$9a2147b3808d4c6b; });
$parcel$export(module.exports, "createLocaleObject", function () { return $1f2af6bd40c3c89a$export$ddc371781a6af754; });
$parcel$export(module.exports, "getLocaleModel", function () { return $1f2af6bd40c3c89a$export$37cc638e0e11865f; });
$parcel$export(module.exports, "getDefaultLocaleModel", function () { return $1f2af6bd40c3c89a$export$1188f179b2597821; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b8YKU = parcelRequire("b8YKU");

var $cirKE = parcelRequire("cirKE");

var $6ahxt = parcelRequire("6ahxt");

var $5hb6v = parcelRequire("5hb6v");

var $2N6Uo = parcelRequire("2N6Uo");
var $1f2af6bd40c3c89a$var$LOCALE_ZH = 'ZH';
var $1f2af6bd40c3c89a$var$LOCALE_EN = 'EN';
var $1f2af6bd40c3c89a$var$DEFAULT_LOCALE = $1f2af6bd40c3c89a$var$LOCALE_EN;
var $1f2af6bd40c3c89a$var$localeStorage = {};
var $1f2af6bd40c3c89a$var$localeModels = {};
var $1f2af6bd40c3c89a$export$9a2147b3808d4c6b = !(0, $cirKE.default).domSupported ? $1f2af6bd40c3c89a$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage || $1f2af6bd40c3c89a$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($1f2af6bd40c3c89a$var$LOCALE_ZH) > -1 ? $1f2af6bd40c3c89a$var$LOCALE_ZH : $1f2af6bd40c3c89a$var$DEFAULT_LOCALE;
}();
function $1f2af6bd40c3c89a$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $1f2af6bd40c3c89a$var$localeModels[locale] = new (0, $b8YKU.default)(localeObj);
    $1f2af6bd40c3c89a$var$localeStorage[locale] = localeObj;
}
function $1f2af6bd40c3c89a$export$ddc371781a6af754(locale) {
    if ((0, $2N6Uo.isString)(locale)) {
        var localeObj = $1f2af6bd40c3c89a$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $1f2af6bd40c3c89a$var$LOCALE_ZH || locale === $1f2af6bd40c3c89a$var$LOCALE_EN) return (0, $2N6Uo.clone)(localeObj);
        else return (0, $2N6Uo.merge)((0, $2N6Uo.clone)(localeObj), (0, $2N6Uo.clone)($1f2af6bd40c3c89a$var$localeStorage[$1f2af6bd40c3c89a$var$DEFAULT_LOCALE]), false);
    } else return (0, $2N6Uo.merge)((0, $2N6Uo.clone)(locale), (0, $2N6Uo.clone)($1f2af6bd40c3c89a$var$localeStorage[$1f2af6bd40c3c89a$var$DEFAULT_LOCALE]), false);
}
function $1f2af6bd40c3c89a$export$37cc638e0e11865f(lang) {
    return $1f2af6bd40c3c89a$var$localeModels[lang];
}
function $1f2af6bd40c3c89a$export$1188f179b2597821() {
    return $1f2af6bd40c3c89a$var$localeModels[$1f2af6bd40c3c89a$var$DEFAULT_LOCALE];
}
// Default locale
$1f2af6bd40c3c89a$export$bab6a7822cc1e2cd($1f2af6bd40c3c89a$var$LOCALE_EN, (0, $6ahxt.default));
$1f2af6bd40c3c89a$export$bab6a7822cc1e2cd($1f2af6bd40c3c89a$var$LOCALE_ZH, (0, $5hb6v.default));

});
parcelRegister("6ahxt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d1481a6518ba5a$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $47d1481a6518ba5a$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst',
            custom: 'Custom chart',
            chart: 'Chart'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};

});

parcelRegister("5hb6v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d772747850d3cf3$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $3d772747850d3cf3$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};

});


parcelRegister("bjlCM", function(module, exports) {

$parcel$export(module.exports, "registerScaleBreakHelperImpl", function () { return $83c23e3677614e86$export$11977f1e90ef55cf; });
$parcel$export(module.exports, "getScaleBreakHelper", function () { return $83c23e3677614e86$export$e79b20ac82c2d660; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $83c23e3677614e86$var$_impl = null;
function $83c23e3677614e86$export$11977f1e90ef55cf(impl) {
    if (!$83c23e3677614e86$var$_impl) $83c23e3677614e86$var$_impl = impl;
}
function $83c23e3677614e86$export$e79b20ac82c2d660() {
    return $83c23e3677614e86$var$_impl;
}

});



parcelRegister("hIXrb", function(module, exports) {

$parcel$export(module.exports, "BoxCoordinateSystemCoordFrom", function () { return $ce74a6c72c1944b2$export$b0f4b35a5e5703d9; });
$parcel$export(module.exports, "registerLayOutOnCoordSysUsage", function () { return $ce74a6c72c1944b2$export$b8fb890203e861d5; });
$parcel$export(module.exports, "getCoordForBoxCoordSys", function () { return $ce74a6c72c1944b2$export$86c4e85e47608a23; });
$parcel$export(module.exports, "CoordinateSystemUsageKind", function () { return $ce74a6c72c1944b2$export$20673ff3ebf85e08; });
$parcel$export(module.exports, "decideCoordSysUsageKind", function () { return $ce74a6c72c1944b2$export$29cb72d70b6b3a71; });
$parcel$export(module.exports, "injectCoordSysByOption", function () { return $ce74a6c72c1944b2$export$7ed0c09d4f5c932e; });
$parcel$export(module.exports, "simpleCoordSysInjectionProvider", function () { return $ce74a6c72c1944b2$export$33b06c851894cd19; });
$parcel$export(module.exports, "default", function () { return $ce74a6c72c1944b2$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

/**
 * FIXME:
 * `nonSeriesBoxCoordSysCreators` and `_nonSeriesBoxMasterList` are hardcoded implementations.
 * Regarding "coord sys layout based on another coord sys", currently we only exprimentally support one level
 * dpendency, such as, "grid(cartesian)s can be laid out based on matrix/calendar coord sys."
 * But a comprehensive implementation may need to support:
 *  - Recursive dependencies. e.g., a matrix coord sys lays out based on another matrix coord sys.
 *    That requires in the implementation `create` and `update` of coord sys are called by a dependency graph.
 *    (@see enableTopologicalTravel in `util/component.ts`)
 */ var $ce74a6c72c1944b2$var$nonSeriesBoxCoordSysCreators = {};
var $ce74a6c72c1944b2$var$normalCoordSysCreators = {};
var $ce74a6c72c1944b2$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._normalMasterList = [];
        this._nonSeriesBoxMasterList = [];
    }
    /**
   * Typically,
   *  - in `create`, a coord sys lays out based on a given rect;
   *  - in `update`, update the pixel and data extent of there axes (if any) based on processed `series.data`.
   * After that, a coord sys can serve (typically by `dataToPoint`/`dataToLayout`/`pointToData`).
   * If the coordinate system do not lay out based on `series.data`, `update` is not needed.
   */ CoordinateSystemManager.prototype.create = function(ecModel, api) {
        this._nonSeriesBoxMasterList = dealCreate($ce74a6c72c1944b2$var$nonSeriesBoxCoordSysCreators, true);
        this._normalMasterList = dealCreate($ce74a6c72c1944b2$var$normalCoordSysCreators, false);
        function dealCreate(creatorMap, canBeNonSeriesBox) {
            var coordinateSystems = [];
            $2N6Uo.each(creatorMap, function(creator, type) {
                var list = creator.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            return coordinateSystems;
        }
    };
    /**
   * @see CoordinateSystem['create']
   */ CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $2N6Uo.each(this._normalMasterList, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._normalMasterList.concat(this._nonSeriesBoxMasterList);
    };
    CoordinateSystemManager.register = function(type, creator) {
        if (type === 'matrix' || type === 'calendar') {
            // FIXME: hardcode, @see nonSeriesBoxCoordSysCreators
            $ce74a6c72c1944b2$var$nonSeriesBoxCoordSysCreators[type] = creator;
            return;
        }
        $ce74a6c72c1944b2$var$normalCoordSysCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $ce74a6c72c1944b2$var$normalCoordSysCreators[type] || $ce74a6c72c1944b2$var$nonSeriesBoxCoordSysCreators[type];
    };
    return CoordinateSystemManager;
}();
function $ce74a6c72c1944b2$var$canBeNonSeriesBoxCoordSys(coordSysType) {
    return !!$ce74a6c72c1944b2$var$nonSeriesBoxCoordSysCreators[coordSysType];
}
var $ce74a6c72c1944b2$export$b0f4b35a5e5703d9 = {
    // By default fetch coord from `model.get('coord')`.
    coord: 1,
    // Some model/series, such as pie, is allowed to also get coord from `model.get('center')`,
    // if cannot get from `model.get('coord')`. But historically pie use `center` option, but
    // geo use `layoutCenter` option to specify layout center; they are not able to be unified.
    // Therefor it is not recommended.
    coord2: 2
};
function $ce74a6c72c1944b2$export$b8fb890203e861d5(opt) {
    $ce74a6c72c1944b2$var$coordSysUseMap.set(opt.fullType, {
        getCoord2: undefined
    }).getCoord2 = opt.getCoord2;
}
var $ce74a6c72c1944b2$var$coordSysUseMap = $2N6Uo.createHashMap();
function $ce74a6c72c1944b2$export$86c4e85e47608a23(model) {
    var coord = model.getShallow('coord', true);
    var from = $ce74a6c72c1944b2$export$b0f4b35a5e5703d9.coord;
    if (coord == null) {
        var store = $ce74a6c72c1944b2$var$coordSysUseMap.get(model.type);
        if (store && store.getCoord2) {
            from = $ce74a6c72c1944b2$export$b0f4b35a5e5703d9.coord2;
            coord = store.getCoord2(model);
        }
    }
    return {
        coord: coord,
        from: from
    };
}
var $ce74a6c72c1944b2$export$20673ff3ebf85e08 = {
    none: 0,
    dataCoordSys: 1,
    boxCoordSys: 2
};
function $ce74a6c72c1944b2$export$29cb72d70b6b3a71(// Component or series
model, printError) {
    // For backward compat, still not use `true` in model.get.
    var coordSysType = model.getShallow('coordinateSystem');
    var coordSysUsageOption = model.getShallow('coordinateSystemUsage', true);
    var isDeclaredExplicitly = coordSysUsageOption != null;
    var kind = $ce74a6c72c1944b2$export$20673ff3ebf85e08.none;
    if (coordSysType) {
        var isSeries = model.mainType === 'series';
        if (coordSysUsageOption == null) coordSysUsageOption = isSeries ? 'data' : 'box';
        if (coordSysUsageOption === 'data') {
            kind = $ce74a6c72c1944b2$export$20673ff3ebf85e08.dataCoordSys;
            if (!isSeries) kind = $ce74a6c72c1944b2$export$20673ff3ebf85e08.none;
        } else if (coordSysUsageOption === 'box') {
            kind = $ce74a6c72c1944b2$export$20673ff3ebf85e08.boxCoordSys;
            if (!isSeries && !$ce74a6c72c1944b2$var$canBeNonSeriesBoxCoordSys(coordSysType)) kind = $ce74a6c72c1944b2$export$20673ff3ebf85e08.none;
        }
    }
    return {
        coordSysType: coordSysType,
        kind: kind
    };
}
function $ce74a6c72c1944b2$export$7ed0c09d4f5c932e(opt) {
    var targetModel = opt.targetModel, coordSysType = opt.coordSysType, coordSysProvider = opt.coordSysProvider, isDefaultDataCoordSys = opt.isDefaultDataCoordSys, allowNotFound = opt.allowNotFound;
    var _a = $ce74a6c72c1944b2$export$29cb72d70b6b3a71(targetModel, true), kind = _a.kind, declaredType = _a.coordSysType;
    if (isDefaultDataCoordSys && kind !== $ce74a6c72c1944b2$export$20673ff3ebf85e08.dataCoordSys) {
        // If both dataCoordSys and boxCoordSys declared in one model.
        // There is the only case in series-graph, and no other cases yet.
        kind = $ce74a6c72c1944b2$export$20673ff3ebf85e08.dataCoordSys;
        declaredType = coordSysType;
    }
    if (kind === $ce74a6c72c1944b2$export$20673ff3ebf85e08.none || declaredType !== coordSysType) return false;
    var coordSys = coordSysProvider(coordSysType, targetModel);
    if (!coordSys) return false;
    if (kind === $ce74a6c72c1944b2$export$20673ff3ebf85e08.dataCoordSys) targetModel.coordinateSystem = coordSys;
    else // kind === 'boxCoordSys'
    targetModel.boxCoordinateSystem = coordSys;
    return true;
}
var $ce74a6c72c1944b2$export$33b06c851894cd19 = function(coordSysType, injectTargetModel) {
    var coordSysModel = injectTargetModel.getReferringComponents(coordSysType, (0, $bx3T8.SINGLE_REFERRING)).models[0];
    return coordSysModel && coordSysModel.coordinateSystem;
};
var $ce74a6c72c1944b2$export$2e2bcd8739ae039 = $ce74a6c72c1944b2$var$CoordinateSystemManager;

});



parcelRegister("5eOMx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d05a6cc401d3956$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3UxDF = parcelRequire("3UxDF");

var $6aXXD = parcelRequire("6aXXD");
var $3d05a6cc401d3956$var$platform = '';
// Navigator not exists in node
if (typeof navigator !== 'undefined') /* global navigator */ $3d05a6cc401d3956$var$platform = navigator.platform || '';
var $3d05a6cc401d3956$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $3d05a6cc401d3956$var$themeColor = (0, $6aXXD.default).color.theme[0];
var $3d05a6cc401d3956$var$lightThemeColor = (0, $3UxDF.modifyHSL)($3d05a6cc401d3956$var$themeColor, null, null, 0.9);
var $3d05a6cc401d3956$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: (0, $6aXXD.default).color.theme,
    gradientColor: [
        $3d05a6cc401d3956$var$lightThemeColor,
        $3d05a6cc401d3956$var$themeColor
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $3d05a6cc401d3956$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $3d05a6cc401d3956$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $3d05a6cc401d3956$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $3d05a6cc401d3956$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $3d05a6cc401d3956$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $3d05a6cc401d3956$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $3d05a6cc401d3956$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};

});
parcelRegister("6aXXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47f2303f51081e56$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $3UxDF = parcelRequire("3UxDF");
var $47f2303f51081e56$var$tokens = {
    color: {},
    darkColor: {},
    size: {}
};
var $47f2303f51081e56$var$color = $47f2303f51081e56$var$tokens.color = {
    theme: [
        '#5070dd',
        '#b6d634',
        '#505372',
        '#ff994d',
        '#0ca8df',
        '#ffd10a',
        '#fb628b',
        '#785db0',
        '#3fbe95'
    ],
    neutral00: '#fff',
    neutral05: '#f4f7fd',
    neutral10: '#e8ebf0',
    neutral15: '#dbdee4',
    neutral20: '#cfd2d7',
    neutral25: '#c3c5cb',
    neutral30: '#b7b9be',
    neutral35: '#aaacb2',
    neutral40: '#9ea0a5',
    neutral45: '#929399',
    neutral50: '#86878c',
    neutral55: '#797b7f',
    neutral60: '#6d6e73',
    neutral65: '#616266',
    neutral70: '#54555a',
    neutral75: '#48494d',
    neutral80: '#3c3c41',
    neutral85: '#303034',
    neutral90: '#232328',
    neutral95: '#17171b',
    neutral99: '#000',
    accent05: '#eff1f9',
    accent10: '#e0e4f2',
    accent15: '#d0d6ec',
    accent20: '#c0c9e6',
    accent25: '#b1bbdf',
    accent30: '#a1aed9',
    accent35: '#91a0d3',
    accent40: '#8292cc',
    accent45: '#7285c6',
    accent50: '#6578ba',
    accent55: '#5c6da9',
    accent60: '#536298',
    accent65: '#4a5787',
    accent70: '#404c76',
    accent75: '#374165',
    accent80: '#2e3654',
    accent85: '#252b43',
    accent90: '#1b2032',
    accent95: '#121521',
    transparent: 'rgba(0,0,0,0)',
    highlight: 'rgba(255,231,130,0.8)'
};
(0, $2N6Uo.extend)($47f2303f51081e56$var$color, {
    primary: $47f2303f51081e56$var$color.neutral80,
    secondary: $47f2303f51081e56$var$color.neutral70,
    tertiary: $47f2303f51081e56$var$color.neutral60,
    quaternary: $47f2303f51081e56$var$color.neutral50,
    disabled: $47f2303f51081e56$var$color.neutral20,
    border: $47f2303f51081e56$var$color.neutral30,
    borderTint: $47f2303f51081e56$var$color.neutral20,
    borderShade: $47f2303f51081e56$var$color.neutral40,
    background: $47f2303f51081e56$var$color.neutral05,
    backgroundTint: 'rgba(234,237,245,0.5)',
    backgroundTransparent: 'rgba(255,255,255,0)',
    backgroundShade: $47f2303f51081e56$var$color.neutral10,
    shadow: 'rgba(0,0,0,0.2)',
    shadowTint: 'rgba(129,130,136,0.2)',
    axisLine: $47f2303f51081e56$var$color.neutral70,
    axisLineTint: $47f2303f51081e56$var$color.neutral40,
    axisTick: $47f2303f51081e56$var$color.neutral70,
    axisTickMinor: $47f2303f51081e56$var$color.neutral60,
    axisLabel: $47f2303f51081e56$var$color.neutral70,
    axisSplitLine: $47f2303f51081e56$var$color.neutral15,
    axisMinorSplitLine: $47f2303f51081e56$var$color.neutral05
});
for(var $47f2303f51081e56$var$key in $47f2303f51081e56$var$color)if ($47f2303f51081e56$var$color.hasOwnProperty($47f2303f51081e56$var$key)) {
    var $47f2303f51081e56$var$hex = $47f2303f51081e56$var$color[$47f2303f51081e56$var$key];
    if ($47f2303f51081e56$var$key === 'theme') // Don't modify theme colors.
    $47f2303f51081e56$var$tokens.darkColor.theme = $47f2303f51081e56$var$color.theme.slice();
    else if ($47f2303f51081e56$var$key === 'highlight') $47f2303f51081e56$var$tokens.darkColor.highlight = 'rgba(255,231,130,0.4)';
    else if ($47f2303f51081e56$var$key.indexOf('accent') === 0) // Desaturate and lighten accent colors.
    $47f2303f51081e56$var$tokens.darkColor[$47f2303f51081e56$var$key] = (0, $3UxDF.modifyHSL)($47f2303f51081e56$var$hex, null, function(s) {
        return s * 0.5;
    }, function(l) {
        return Math.min(1, 1.3 - l);
    });
    else $47f2303f51081e56$var$tokens.darkColor[$47f2303f51081e56$var$key] = (0, $3UxDF.modifyHSL)($47f2303f51081e56$var$hex, null, function(s) {
        return s * 0.9;
    }, function(l) {
        return 1 - Math.pow(l, 1.5);
    });
}
$47f2303f51081e56$var$tokens.size = {
    xxs: 2,
    xs: 5,
    s: 10,
    m: 15,
    l: 20,
    xl: 30,
    xxl: 40,
    xxxl: 50
};
var $47f2303f51081e56$export$2e2bcd8739ae039 = $47f2303f51081e56$var$tokens;

});


parcelRegister("6VFOB", function(module, exports) {

$parcel$export(module.exports, "BE_ORDINAL", function () { return $50b88096b5b31965$export$328749e9c5b40760; });
$parcel$export(module.exports, "resetSourceDefaulter", function () { return $50b88096b5b31965$export$b30cdea50aa00e6; });
$parcel$export(module.exports, "makeSeriesEncodeForAxisCoordSys", function () { return $50b88096b5b31965$export$37682b8fdd2e83d; });
$parcel$export(module.exports, "querySeriesUpstreamDatasetModel", function () { return $50b88096b5b31965$export$8da66f73a1eda454; });
$parcel$export(module.exports, "makeSeriesEncodeForNameBased", function () { return $50b88096b5b31965$export$60b8a57d1f2fed26; });
$parcel$export(module.exports, "queryDatasetUpstreamDatasetModels", function () { return $50b88096b5b31965$export$397ba553479711e7; });
$parcel$export(module.exports, "guessOrdinal", function () { return $50b88096b5b31965$export$c51adf1a2be01b9c; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $eKQ6A = parcelRequire("eKQ6A");
var $50b88096b5b31965$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $50b88096b5b31965$var$innerGlobalModel = (0, $bx3T8.makeInner)();
function $50b88096b5b31965$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $50b88096b5b31965$var$innerGlobalModel(ecModel).datasetMap = (0, $2N6Uo.createHashMap)();
}
function $50b88096b5b31965$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $50b88096b5b31965$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $50b88096b5b31965$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $2N6Uo.each)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $2N6Uo.isObject)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $2N6Uo.each)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $50b88096b5b31965$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $50b88096b5b31965$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS)) (0, $2N6Uo.each)(dimensionsDefine, function(dim, idx) {
        if (((0, $2N6Uo.isObject)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $50b88096b5b31965$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $50b88096b5b31965$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $50b88096b5b31965$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $50b88096b5b31965$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $50b88096b5b31965$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $50b88096b5b31965$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $bx3T8.queryReferringComponents)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $bx3T8.SINGLE_REFERRING)).models[0];
}
function $50b88096b5b31965$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $bx3T8.queryReferringComponents)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $bx3T8.SINGLE_REFERRING)).models;
}
function $50b88096b5b31965$export$c51adf1a2be01b9c(source, dimIndex) {
    return $50b88096b5b31965$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $50b88096b5b31965$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $2N6Uo.isTypedArray)(data)) return $50b88096b5b31965$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $2N6Uo.isObject)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $2N6Uo.isString)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $50b88096b5b31965$export$328749e9c5b40760.Must : $50b88096b5b31965$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $eKQ6A.SERIES_LAYOUT_BY_ROW)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS)) {
        var dataObjectRows = data;
        if (!dimName) return $50b88096b5b31965$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS)) {
        var dataKeyedColumns = data;
        if (!dimName) return $50b88096b5b31965$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $2N6Uo.isTypedArray)(sample)) return $50b88096b5b31965$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $bx3T8.getDataItemValue)(item);
            if (!(0, $2N6Uo.isArray)(val)) return $50b88096b5b31965$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $2N6Uo.isString)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `Number('')` (or any whitespace) is `0`.
        if (val != null && Number.isFinite(Number(val)) && val !== '') return beStr ? $50b88096b5b31965$export$328749e9c5b40760.Might : $50b88096b5b31965$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $50b88096b5b31965$export$328749e9c5b40760.Must;
    }
    return $50b88096b5b31965$export$328749e9c5b40760.Not;
}

});
parcelRegister("eKQ6A", function(module, exports) {

$parcel$export(module.exports, "VISUAL_DIMENSIONS", function () { return $abddc78fa7839dc1$export$cd51b5ca77f6f0e4; });
$parcel$export(module.exports, "SOURCE_FORMAT_ORIGINAL", function () { return $abddc78fa7839dc1$export$2823037fb9d8f0c6; });
$parcel$export(module.exports, "SOURCE_FORMAT_ARRAY_ROWS", function () { return $abddc78fa7839dc1$export$fcd62ebf51387903; });
$parcel$export(module.exports, "SOURCE_FORMAT_OBJECT_ROWS", function () { return $abddc78fa7839dc1$export$703ae8a2d83f441; });
$parcel$export(module.exports, "SOURCE_FORMAT_KEYED_COLUMNS", function () { return $abddc78fa7839dc1$export$6a32b42c754a3cb8; });
$parcel$export(module.exports, "SOURCE_FORMAT_TYPED_ARRAY", function () { return $abddc78fa7839dc1$export$a918cb016a382d45; });
$parcel$export(module.exports, "SOURCE_FORMAT_UNKNOWN", function () { return $abddc78fa7839dc1$export$c78f1330778d30d; });
$parcel$export(module.exports, "SERIES_LAYOUT_BY_COLUMN", function () { return $abddc78fa7839dc1$export$7b3f3c6551b4949b; });
$parcel$export(module.exports, "SERIES_LAYOUT_BY_ROW", function () { return $abddc78fa7839dc1$export$d55da1467cdf7804; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $abddc78fa7839dc1$export$cd51b5ca77f6f0e4 = (0, $2N6Uo.createHashMap)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'itemChildGroupId',
    'seriesName'
]);
var $abddc78fa7839dc1$export$2823037fb9d8f0c6 = 'original';
var $abddc78fa7839dc1$export$fcd62ebf51387903 = 'arrayRows';
var $abddc78fa7839dc1$export$703ae8a2d83f441 = 'objectRows';
var $abddc78fa7839dc1$export$6a32b42c754a3cb8 = 'keyedColumns';
var $abddc78fa7839dc1$export$a918cb016a382d45 = 'typedArray';
var $abddc78fa7839dc1$export$c78f1330778d30d = 'unknown';
var $abddc78fa7839dc1$export$7b3f3c6551b4949b = 'column';
var $abddc78fa7839dc1$export$d55da1467cdf7804 = 'row';

});


parcelRegister("c69Sq", function(module, exports) {

$parcel$export(module.exports, "registerInternalOptionCreator", function () { return $8cedb4eac93fac3d$export$5a90be4668898d38; });
$parcel$export(module.exports, "concatInternalOptions", function () { return $8cedb4eac93fac3d$export$c713a6a3b43f401d; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $8cedb4eac93fac3d$var$internalOptionCreatorMap = (0, $2N6Uo.createHashMap)();
function $8cedb4eac93fac3d$export$5a90be4668898d38(mainType, creator) {
    (0, $2N6Uo.assert)($8cedb4eac93fac3d$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $8cedb4eac93fac3d$var$internalOptionCreatorMap.set(mainType, creator);
}
function $8cedb4eac93fac3d$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $8cedb4eac93fac3d$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}

});

parcelRegister("1E7rO", function(module, exports) {

$parcel$export(module.exports, "PaletteMixin", function () { return $132f4dcdc504815a$export$55a3c39e852b90f4; });
$parcel$export(module.exports, "getDecalFromPalette", function () { return $132f4dcdc504815a$export$e4d892222945a227; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");
var $132f4dcdc504815a$var$innerColor = (0, $bx3T8.makeInner)();
var $132f4dcdc504815a$var$innerDecal = (0, $bx3T8.makeInner)();
var $132f4dcdc504815a$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $bx3T8.normalizeToArray)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $132f4dcdc504815a$var$getFromPalette(this, $132f4dcdc504815a$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $132f4dcdc504815a$var$clearPalette(this, $132f4dcdc504815a$var$innerColor);
    };
    return PaletteMixin;
}();
function $132f4dcdc504815a$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $bx3T8.normalizeToArray)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $132f4dcdc504815a$var$getFromPalette(ecModel, $132f4dcdc504815a$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $132f4dcdc504815a$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $132f4dcdc504815a$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $132f4dcdc504815a$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $132f4dcdc504815a$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}

});

parcelRegister("byzwF", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $869e6d6489290668$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "error", function () { return $869e6d6489290668$export$a3bc9b8ed74fc; });
$parcel$export(module.exports, "deprecateLog", function () { return $869e6d6489290668$export$4a9c0b74eb885aa1; });
$parcel$export(module.exports, "throwError", function () { return $869e6d6489290668$export$8bf7aba4a9e09055; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $869e6d6489290668$var$ECHARTS_PREFIX = '[ECharts] ';
var $869e6d6489290668$var$storedLogs = {};
var $869e6d6489290668$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
function $869e6d6489290668$var$outputLog(type, str, onlyOnce) {
    if ($869e6d6489290668$var$hasConsole) {
        if (onlyOnce) {
            if ($869e6d6489290668$var$storedLogs[str]) return;
            $869e6d6489290668$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($869e6d6489290668$var$ECHARTS_PREFIX + str);
    }
}
function $869e6d6489290668$export$bef1f36f5486a6a3(str, onlyOnce) {
    $869e6d6489290668$var$outputLog('log', str, onlyOnce);
}
function $869e6d6489290668$export$c106dd0671a0fc2d(str, onlyOnce) {
    $869e6d6489290668$var$outputLog('warn', str, onlyOnce);
}
function $869e6d6489290668$export$a3bc9b8ed74fc(str, onlyOnce) {
    $869e6d6489290668$var$outputLog('error', str, onlyOnce);
}
function $869e6d6489290668$export$4a9c0b74eb885aa1(str) {}
function $869e6d6489290668$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $869e6d6489290668$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $869e6d6489290668$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}

});


parcelRegister("lCOOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbe4914971f85e63$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $fbe4914971f85e63$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isSSR',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    // 'getModel',
    'getOption',
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $fbe4914971f85e63$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $2N6Uo.each($fbe4914971f85e63$var$availableMethods, function(methodName) {
            this[methodName] = $2N6Uo.bind(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $fbe4914971f85e63$export$2e2bcd8739ae039 = $fbe4914971f85e63$var$ExtensionAPI;

});

parcelRegister("9voWY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eba5ce8ef8d6884$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $6eba5ce8ef8d6884$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $6eba5ce8ef8d6884$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $2N6Uo.each)((0, $bx3T8.normalizeToArray)(rawOption.series), function(series) {
                series && series.data && (0, $2N6Uo.isTypedArray)(series.data) && (0, $2N6Uo.setAsPrimitive)(series.data);
            });
            (0, $2N6Uo.each)((0, $bx3T8.normalizeToArray)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $2N6Uo.isTypedArray)(dataset.source) && (0, $2N6Uo.setAsPrimitive)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $2N6Uo.clone)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $6eba5ce8ef8d6884$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $2N6Uo.clone)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $2N6Uo.clone)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($6eba5ce8ef8d6884$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$6eba5ce8ef8d6884$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $2N6Uo.map)(indices, function(index) {
            return (0, $2N6Uo.clone)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $6eba5ce8ef8d6884$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $2N6Uo.isArray)(mediaOnRoot)) (0, $2N6Uo.each)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $2N6Uo.each)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $2N6Uo.each)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $2N6Uo.each)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $6eba5ce8ef8d6884$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $2N6Uo.each)(query, function(value, attr) {
        var matched = attr.match($6eba5ce8ef8d6884$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$6eba5ce8ef8d6884$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $6eba5ce8ef8d6884$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $6eba5ce8ef8d6884$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$6eba5ce8ef8d6884$export$2e2bcd8739ae039 = $6eba5ce8ef8d6884$var$OptionManager;

});

parcelRegister("2D3oR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ea1dc7593866e3a$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $6calU = parcelRequire("6calU");

var $bx3T8 = parcelRequire("bx3T8");

function $1ea1dc7593866e3a$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $1ea1dc7593866e3a$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $1ea1dc7593866e3a$var$compatLayoutProperties(option) {
    option && (0, $2N6Uo.each)($1ea1dc7593866e3a$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $1ea1dc7593866e3a$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $1ea1dc7593866e3a$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $1ea1dc7593866e3a$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $1ea1dc7593866e3a$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $1ea1dc7593866e3a$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $1ea1dc7593866e3a$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $1ea1dc7593866e3a$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $1ea1dc7593866e3a$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $1ea1dc7593866e3a$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $1ea1dc7593866e3a$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $1ea1dc7593866e3a$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $1ea1dc7593866e3a$var$traverseTree(data[i].children, cb);
    }
}
function $1ea1dc7593866e3a$export$2e2bcd8739ae039(option, isTheme) {
    (0, $6calU.default)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $bx3T8.normalizeToArray)(option.series);
    (0, $2N6Uo.each)(option.series, function(seriesOpt) {
        if (!(0, $2N6Uo.isObject)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $1ea1dc7593866e3a$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $2N6Uo.isTypedArray)(data)) for(var i = 0; i < data.length; i++)$1ea1dc7593866e3a$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $1ea1dc7593866e3a$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $1ea1dc7593866e3a$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $1ea1dc7593866e3a$var$compatBarItemStyle(seriesOpt);
            $1ea1dc7593866e3a$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $1ea1dc7593866e3a$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $2N6Uo.isTypedArray)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                    $1ea1dc7593866e3a$var$compatBarItemStyle(data[i]);
                    $1ea1dc7593866e3a$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $1ea1dc7593866e3a$var$compatSunburstState(seriesOpt);
            $1ea1dc7593866e3a$var$traverseTree(seriesOpt.data, $1ea1dc7593866e3a$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $1ea1dc7593866e3a$var$compatGraphFocus(seriesOpt);
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $2N6Uo.defaults)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $1ea1dc7593866e3a$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $2N6Uo.each)($1ea1dc7593866e3a$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $2N6Uo.isArray)(options)) options = [
                options
            ];
            (0, $2N6Uo.each)(options, function(option) {
                $1ea1dc7593866e3a$var$compatLayoutProperties(option);
            });
        }
    });
}

});
parcelRegister("6calU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $482be4d5327013a0$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $482be4d5327013a0$var$each = $2N6Uo.each;
var $482be4d5327013a0$var$isObject = $2N6Uo.isObject;
var $482be4d5327013a0$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $482be4d5327013a0$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $482be4d5327013a0$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $482be4d5327013a0$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $2N6Uo.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $2N6Uo.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $482be4d5327013a0$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $2N6Uo.defaults(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $482be4d5327013a0$var$removeEC3NormalStatus(opt) {
    $482be4d5327013a0$var$convertNormalEmphasis(opt, 'itemStyle');
    $482be4d5327013a0$var$convertNormalEmphasis(opt, 'lineStyle');
    $482be4d5327013a0$var$convertNormalEmphasis(opt, 'areaStyle');
    $482be4d5327013a0$var$convertNormalEmphasis(opt, 'label');
    $482be4d5327013a0$var$convertNormalEmphasis(opt, 'labelLine');
    // treemap
    $482be4d5327013a0$var$convertNormalEmphasis(opt, 'upperLabel');
    // graph
    $482be4d5327013a0$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $482be4d5327013a0$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $482be4d5327013a0$var$isObject(opt) && opt[propName];
    var textStyle = $482be4d5327013a0$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $bx3T8.TEXT_STYLE_OPTIONS.length; i < len; i++){
        var textPropName = $bx3T8.TEXT_STYLE_OPTIONS[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $482be4d5327013a0$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $482be4d5327013a0$var$removeEC3NormalStatus(opt);
        $482be4d5327013a0$var$compatTextStyle(opt, 'label');
        opt.emphasis && $482be4d5327013a0$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $482be4d5327013a0$var$processSeries(seriesOpt) {
    if (!$482be4d5327013a0$var$isObject(seriesOpt)) return;
    $482be4d5327013a0$var$compatEC2ItemStyle(seriesOpt);
    $482be4d5327013a0$var$removeEC3NormalStatus(seriesOpt);
    $482be4d5327013a0$var$compatTextStyle(seriesOpt, 'label');
    // treemap
    $482be4d5327013a0$var$compatTextStyle(seriesOpt, 'upperLabel');
    // graph
    $482be4d5327013a0$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $482be4d5327013a0$var$compatTextStyle(seriesOpt.emphasis, 'label');
        // treemap
        $482be4d5327013a0$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
        // graph
        $482be4d5327013a0$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $482be4d5327013a0$var$compatEC2ItemStyle(markPoint);
        $482be4d5327013a0$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $482be4d5327013a0$var$compatEC2ItemStyle(markLine);
        $482be4d5327013a0$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $482be4d5327013a0$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$2N6Uo.isTypedArray(edgeData)) for(var i = 0; i < edgeData.length; i++)$482be4d5327013a0$var$compatEC3CommonStyles(edgeData[i]);
        $2N6Uo.each(seriesOpt.categories, function(opt) {
            $482be4d5327013a0$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$2N6Uo.isTypedArray(data)) for(var i = 0; i < data.length; i++)$482be4d5327013a0$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$482be4d5327013a0$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($2N6Uo.isArray(mlData[i])) {
            $482be4d5327013a0$var$compatEC3CommonStyles(mlData[i][0]);
            $482be4d5327013a0$var$compatEC3CommonStyles(mlData[i][1]);
        } else $482be4d5327013a0$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === 'gauge') {
        $482be4d5327013a0$var$compatTextStyle(seriesOpt, 'axisLabel');
        $482be4d5327013a0$var$compatTextStyle(seriesOpt, 'title');
        $482be4d5327013a0$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $482be4d5327013a0$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $2N6Uo.each(seriesOpt.levels, function(opt) {
            $482be4d5327013a0$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $482be4d5327013a0$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $482be4d5327013a0$var$toArr(o) {
    return $2N6Uo.isArray(o) ? o : o ? [
        o
    ] : [];
}
function $482be4d5327013a0$var$toObj(o) {
    return ($2N6Uo.isArray(o) ? o[0] : o) || {};
}
function $482be4d5327013a0$export$2e2bcd8739ae039(option, isTheme) {
    $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(option.series), function(seriesOpt) {
        $482be4d5327013a0$var$isObject(seriesOpt) && $482be4d5327013a0$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $482be4d5327013a0$var$each(axes, function(axisName) {
        $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $482be4d5327013a0$var$compatTextStyle(axisOpt, 'axisLabel');
                $482be4d5327013a0$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $482be4d5327013a0$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $482be4d5327013a0$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(option.calendar), function(calendarOpt) {
        $482be4d5327013a0$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $482be4d5327013a0$var$compatTextStyle(calendarOpt, 'dayLabel');
        $482be4d5327013a0$var$compatTextStyle(calendarOpt, 'monthLabel');
        $482be4d5327013a0$var$compatTextStyle(calendarOpt, 'yearLabel');
    });
    // radar.name.textStyle
    $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(option.radar), function(radarOpt) {
        $482be4d5327013a0$var$compatTextStyle(radarOpt, 'name');
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(option.geo), function(geoOpt) {
        if ($482be4d5327013a0$var$isObject(geoOpt)) {
            $482be4d5327013a0$var$compatEC3CommonStyles(geoOpt);
            $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(geoOpt.regions), function(regionObj) {
                $482be4d5327013a0$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(option.timeline), function(timelineOpt) {
        $482be4d5327013a0$var$compatEC3CommonStyles(timelineOpt);
        $482be4d5327013a0$var$convertNormalEmphasis(timelineOpt, 'label');
        $482be4d5327013a0$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $482be4d5327013a0$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $2N6Uo.isArray(data) && $2N6Uo.each(data, function(item) {
            if ($2N6Uo.isObject(item)) {
                $482be4d5327013a0$var$convertNormalEmphasis(item, 'label');
                $482be4d5327013a0$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $482be4d5327013a0$var$each($482be4d5327013a0$var$toArr(option.toolbox), function(toolboxOpt) {
        $482be4d5327013a0$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $482be4d5327013a0$var$each(toolboxOpt.feature, function(featureOpt) {
            $482be4d5327013a0$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $482be4d5327013a0$var$compatTextStyle($482be4d5327013a0$var$toObj(option.axisPointer), 'label');
    $482be4d5327013a0$var$compatTextStyle($482be4d5327013a0$var$toObj(option.tooltip).axisPointer, 'label');
// Clean logs
// storedLogs = {};
}

});


parcelRegister("aOkQp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7deebe25f9c6e0ff$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");
function $7deebe25f9c6e0ff$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $2N6Uo.createHashMap)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack');
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.push(stackInfo);
        }
    });
    // Process each stack group
    stackInfoMap.each(function(stackInfoList) {
        if (stackInfoList.length === 0) return;
        // Check if stack order needs to be reversed
        var firstSeries = stackInfoList[0].seriesModel;
        var stackOrder = firstSeries.get('stackOrder') || 'seriesAsc';
        if (stackOrder === 'seriesDesc') stackInfoList.reverse();
        // Set stackedOnSeries for each series in the final order
        (0, $2N6Uo.each)(stackInfoList, function(stackInfo, index) {
            stackInfo.data.setCalculationInfo('stackedOnSeries', index > 0 ? stackInfoList[index - 1].seriesModel : null);
        });
        // Calculate stack values
        $7deebe25f9c6e0ff$var$calculateStack(stackInfoList);
    });
}
function $7deebe25f9c6e0ff$var$calculateStack(stackInfoList) {
    (0, $2N6Uo.each)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get('stackStrategy') || 'samesign';
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === 'all' // single stack group
                     || stackStrategy === 'positive' && val > 0 || stackStrategy === 'negative' && val < 0 || stackStrategy === 'samesign' && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === 'samesign' && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $iCU10.addSafe)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}

});

parcelRegister("49X8G", function(module, exports) {

$parcel$export(module.exports, "SERIES_UNIVERSAL_TRANSITION_PROP", function () { return $3075e07f04e7ce89$export$e960441116ae2799; });
$parcel$export(module.exports, "default", function () { return $3075e07f04e7ce89$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $cirKE = parcelRequire("cirKE");

var $bx3T8 = parcelRequire("bx3T8");

var $eLD2b = parcelRequire("eLD2b");

var $1E7rO = parcelRequire("1E7rO");

var $7NPXc = parcelRequire("7NPXc");

var $a35Wn = parcelRequire("a35Wn");

var $4XoTU = parcelRequire("4XoTU");

var $I7Ovw = parcelRequire("I7Ovw");

var $8zxSQ = parcelRequire("8zxSQ");

var $1Z9ox = parcelRequire("1Z9ox");
var $3075e07f04e7ce89$var$inner = $bx3T8.makeInner();
function $3075e07f04e7ce89$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $3075e07f04e7ce89$export$e960441116ae2799 = '__universalTransitionEnabled';
var $3075e07f04e7ce89$var$SeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $4XoTU.createTask)({
            count: $3075e07f04e7ce89$var$dataTaskCount,
            reset: $3075e07f04e7ce89$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $3075e07f04e7ce89$var$inner(this).sourceManager = new (0, $8zxSQ.SourceManager)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $3075e07f04e7ce89$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $3075e07f04e7ce89$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $3075e07f04e7ce89$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $a35Wn.fetchLayoutMode)(this);
        var inputPositionParams = layoutMode ? (0, $a35Wn.getLayoutParams)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $eLD2b.default).hasClass(themeSubType)) themeSubType += 'Series';
        $2N6Uo.merge(option, ecModel.getTheme().get(this.subType));
        $2N6Uo.merge(option, this.getDefaultOption());
        // Default label emphasis `show`
        $bx3T8.defaultEmphasis(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $a35Wn.mergeLayoutParam)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $2N6Uo.merge(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $a35Wn.fetchLayoutMode)(this);
        if (layoutMode) (0, $a35Wn.mergeLayoutParam)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $3075e07f04e7ce89$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $3075e07f04e7ce89$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $3075e07f04e7ce89$var$inner(this).dataBeforeProcessed = data;
        $3075e07f04e7ce89$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$2N6Uo.isTypedArray(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $bx3T8.defaultEmphasis(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $3075e07f04e7ce89$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null || !data.getLinkedData ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $3075e07f04e7ce89$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $3075e07f04e7ce89$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $3075e07f04e7ce89$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $2N6Uo.createHashMap(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $3075e07f04e7ce89$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $3075e07f04e7ce89$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Retrieve the index of nearest value in the view coordinate.
   * Data position is compared with each axis's dataToCoord.
   *
   * @param axisDim axis dimension
   * @param dim data dimension
   * @param value
   * @param [maxDistance=Infinity] The maximum distance in view coordinate space
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesModel.prototype.indicesOfNearest = function(axisDim, dim, value, maxDistance) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var axis = coordSys && coordSys.getAxis(axisDim);
        if (!coordSys || !axis) return [];
        var targetCoord = axis.dataToCoord(value);
        if (maxDistance == null) maxDistance = Infinity;
        var nearestIndices = [];
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        data.each(dim, function(dimValue, idx) {
            var dataCoord = axis.dataToCoord(dimValue);
            var diff = targetCoord - dataCoord;
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = idx;
            }
        });
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $1Z9ox.defaultSeriesFormatTooltip)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $cirKE.default).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $1E7rO.PaletteMixin).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === 'series' || selectedMap === 'all') {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $3075e07f04e7ce89$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === 'all') return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $2N6Uo.keys(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === 'all' || selectedMap[$3075e07f04e7ce89$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            'select',
            'disabled'
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$3075e07f04e7ce89$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'series') option.selectedMap = 'all';
        else if (selectedMode === 'multiple') {
            if (!$2N6Uo.isObject(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $3075e07f04e7ce89$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $3075e07f04e7ce89$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $eLD2b.default).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle';
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $eLD2b.default));
$2N6Uo.mixin($3075e07f04e7ce89$var$SeriesModel, (0, $7NPXc.DataFormatMixin));
$2N6Uo.mixin($3075e07f04e7ce89$var$SeriesModel, (0, $1E7rO.PaletteMixin));
(0, $I7Ovw.mountExtend)($3075e07f04e7ce89$var$SeriesModel, (0, $eLD2b.default));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $3075e07f04e7ce89$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$bx3T8.isNameSpecified(seriesModel)) seriesModel.name = $3075e07f04e7ce89$var$getSeriesAutoName(seriesModel) || name;
}
function $3075e07f04e7ce89$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $2N6Uo.each(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $3075e07f04e7ce89$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $3075e07f04e7ce89$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $3075e07f04e7ce89$var$dataTaskProgress;
}
function $3075e07f04e7ce89$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $3075e07f04e7ce89$var$wrapData(data, seriesModel) {
    $2N6Uo.each($2N6Uo.concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $2N6Uo.curry($3075e07f04e7ce89$var$onDataChange, seriesModel));
    });
}
function $3075e07f04e7ce89$var$onDataChange(seriesModel, newList) {
    var task = $3075e07f04e7ce89$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $3075e07f04e7ce89$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $3075e07f04e7ce89$export$2e2bcd8739ae039 = $3075e07f04e7ce89$var$SeriesModel;

});
parcelRegister("7NPXc", function(module, exports) {

$parcel$export(module.exports, "DataFormatMixin", function () { return $5ae568f4e19a11b8$export$f23396ae04ea95a7; });
$parcel$export(module.exports, "normalizeTooltipFormatResult", function () { return $5ae568f4e19a11b8$export$2d16fa82a50c4741; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bA99G = parcelRequire("bA99G");

var $hrphB = parcelRequire("hrphB");

var $5ae568f4e19a11b8$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $5ae568f4e19a11b8$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $2N6Uo.isArray(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if ($2N6Uo.isFunction(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($2N6Uo.isString(formatter)) {
            var str = (0, $hrphB.formatTpl)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($5ae568f4e19a11b8$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $bA99G.retrieveRawValue)(data, dataIndex, dimLoose);
                if (extendParams && $2N6Uo.isArray(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $bA99G.retrieveRawValue)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $5ae568f4e19a11b8$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($2N6Uo.isObject(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}

});
parcelRegister("bA99G", function(module, exports) {

$parcel$export(module.exports, "DefaultDataProvider", function () { return $86ea2885c4ff943d$export$b900d7c4c3952a40; });
$parcel$export(module.exports, "getRawSourceItemGetter", function () { return $86ea2885c4ff943d$export$92c8ea8642b3957d; });
$parcel$export(module.exports, "getRawSourceDataCounter", function () { return $86ea2885c4ff943d$export$803742e832f4b52c; });
$parcel$export(module.exports, "getRawSourceValueGetter", function () { return $86ea2885c4ff943d$export$1752de8084789a14; });
$parcel$export(module.exports, "retrieveRawValue", function () { return $86ea2885c4ff943d$export$cde9373da9aad801; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $9Pasn = parcelRequire("9Pasn");

var $eKQ6A = parcelRequire("eKQ6A");

var $byzwF = parcelRequire("byzwF");
var $86ea2885c4ff943d$var$_a, $86ea2885c4ff943d$var$_b, $86ea2885c4ff943d$var$_c, $86ea2885c4ff943d$var$_d;
var $86ea2885c4ff943d$var$providerMethods;
var $86ea2885c4ff943d$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $86ea2885c4ff943d$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $9Pasn.isSourceInstance)(sourceParam) ? (0, $9Pasn.createSourceFromSeriesDataOption)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        var sourceFormat = source.sourceFormat;
        var seriesLayoutBy = source.seriesLayoutBy;
        // Typed array. TODO IE10+?
        if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_TYPED_ARRAY)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        var validator;
        $86ea2885c4ff943d$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $86ea2885c4ff943d$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $86ea2885c4ff943d$var$providerMethods[$86ea2885c4ff943d$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $2N6Uo.extend)(provider, methods);
            if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_TYPED_ARRAY)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $86ea2885c4ff943d$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $2N6Uo.bind)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $86ea2885c4ff943d$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $2N6Uo.bind)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $86ea2885c4ff943d$var$providerMethods = (_a = {}, _a[(0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $eKQ6A.SERIES_LAYOUT_BY_ROW)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $2N6Uo.each)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $eKQ6A.SOURCE_FORMAT_ORIGINAL] = {
            appendData: appendDataSimply
        }, _a[0, $eKQ6A.SOURCE_FORMAT_TYPED_ARRAY] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $86ea2885c4ff943d$var$validateSimply = function(rawData) {
    if (!(0, $2N6Uo.isArray)(rawData)) (0, $byzwF.error)('series.data or dataset.source must be an array.');
};
/**
 * Only run in dev mode - hint users for debug.
 */ var $86ea2885c4ff943d$var$rawSourceDataValidatorMap = ($86ea2885c4ff943d$var$_a = {}, $86ea2885c4ff943d$var$_a[(0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN)] = $86ea2885c4ff943d$var$validateSimply, $86ea2885c4ff943d$var$_a[(0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $eKQ6A.SERIES_LAYOUT_BY_ROW)] = $86ea2885c4ff943d$var$validateSimply, $86ea2885c4ff943d$var$_a[0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS] = $86ea2885c4ff943d$var$validateSimply, $86ea2885c4ff943d$var$_a[0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, dimsDef) {
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        if (dimName == null) (0, $byzwF.error)('dimension name must not be null/undefined.');
    }
}, $86ea2885c4ff943d$var$_a[0, $eKQ6A.SOURCE_FORMAT_ORIGINAL] = $86ea2885c4ff943d$var$validateSimply, $86ea2885c4ff943d$var$_a);
var $86ea2885c4ff943d$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $86ea2885c4ff943d$var$rawSourceItemGetterMap = ($86ea2885c4ff943d$var$_b = {}, $86ea2885c4ff943d$var$_b[(0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $86ea2885c4ff943d$var$_b[(0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $eKQ6A.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $86ea2885c4ff943d$var$_b[0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS] = $86ea2885c4ff943d$var$getItemSimply, $86ea2885c4ff943d$var$_b[0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = dimName != null ? rawData[dimName] : null;
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $86ea2885c4ff943d$var$_b[0, $eKQ6A.SOURCE_FORMAT_ORIGINAL] = $86ea2885c4ff943d$var$getItemSimply, $86ea2885c4ff943d$var$_b);
function $86ea2885c4ff943d$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $86ea2885c4ff943d$var$rawSourceItemGetterMap[$86ea2885c4ff943d$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $86ea2885c4ff943d$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $86ea2885c4ff943d$var$rawSourceDataCounterMap = ($86ea2885c4ff943d$var$_c = {}, $86ea2885c4ff943d$var$_c[(0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $86ea2885c4ff943d$var$_c[(0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $eKQ6A.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $86ea2885c4ff943d$var$_c[0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS] = $86ea2885c4ff943d$var$countSimply, $86ea2885c4ff943d$var$_c[0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = dimName != null ? rawData[dimName] : null;
    return col ? col.length : 0;
}, $86ea2885c4ff943d$var$_c[0, $eKQ6A.SOURCE_FORMAT_ORIGINAL] = $86ea2885c4ff943d$var$countSimply, $86ea2885c4ff943d$var$_c);
function $86ea2885c4ff943d$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $86ea2885c4ff943d$var$rawSourceDataCounterMap[$86ea2885c4ff943d$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $86ea2885c4ff943d$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $86ea2885c4ff943d$var$rawSourceValueGetterMap = ($86ea2885c4ff943d$var$_d = {}, $86ea2885c4ff943d$var$_d[0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS] = $86ea2885c4ff943d$var$getRawValueSimply, $86ea2885c4ff943d$var$_d[0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $86ea2885c4ff943d$var$_d[0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS] = $86ea2885c4ff943d$var$getRawValueSimply, $86ea2885c4ff943d$var$_d[0, $eKQ6A.SOURCE_FORMAT_ORIGINAL] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $bx3T8.getDataItemValue)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $86ea2885c4ff943d$var$_d[0, $eKQ6A.SOURCE_FORMAT_TYPED_ARRAY] = $86ea2885c4ff943d$var$getRawValueSimply, $86ea2885c4ff943d$var$_d);
function $86ea2885c4ff943d$export$1752de8084789a14(sourceFormat) {
    var method = $86ea2885c4ff943d$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $86ea2885c4ff943d$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
}
function $86ea2885c4ff943d$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $86ea2885c4ff943d$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL)) result = (0, $bx3T8.getDataItemValue)(dataItem);
        return result;
    }
}
function $86ea2885c4ff943d$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL) && sourceFormat !== (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL) && !(0, $2N6Uo.isObject)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}

});
parcelRegister("9Pasn", function(module, exports) {

$parcel$export(module.exports, "isSourceInstance", function () { return $7270fcf70cd48f5e$export$22b808bc02a60488; });
$parcel$export(module.exports, "createSource", function () { return $7270fcf70cd48f5e$export$1921362e86c73c88; });
$parcel$export(module.exports, "detectSourceFormat", function () { return $7270fcf70cd48f5e$export$52a469afa4653e57; });
$parcel$export(module.exports, "createSourceFromSeriesDataOption", function () { return $7270fcf70cd48f5e$export$75aef3f97c0a5edf; });
$parcel$export(module.exports, "cloneSourceShallow", function () { return $7270fcf70cd48f5e$export$e0365e7e3555ddd4; });
$parcel$export(module.exports, "shouldRetrieveDataByName", function () { return $7270fcf70cd48f5e$export$8911336b527f8517; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $eKQ6A = parcelRequire("eKQ6A");

var $bx3T8 = parcelRequire("bx3T8");

var $6VFOB = parcelRequire("6VFOB");
// @inner
var $7270fcf70cd48f5e$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $eKQ6A.SOURCE_FORMAT_UNKNOWN);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $6VFOB.guessOrdinal)(this, i) === (0, $6VFOB.BE_ORDINAL).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $7270fcf70cd48f5e$export$22b808bc02a60488(val) {
    return val instanceof $7270fcf70cd48f5e$var$SourceImpl;
}
function $7270fcf70cd48f5e$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $7270fcf70cd48f5e$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $7270fcf70cd48f5e$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $7270fcf70cd48f5e$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $2N6Uo.clone)(thisMetaRawOption)
    });
    return source;
}
function $7270fcf70cd48f5e$export$75aef3f97c0a5edf(data) {
    return new $7270fcf70cd48f5e$var$SourceImpl({
        data: data,
        sourceFormat: (0, $2N6Uo.isTypedArray)(data) ? (0, $eKQ6A.SOURCE_FORMAT_TYPED_ARRAY) : (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL)
    });
}
function $7270fcf70cd48f5e$export$e0365e7e3555ddd4(source) {
    return new $7270fcf70cd48f5e$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $2N6Uo.clone)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $7270fcf70cd48f5e$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $eKQ6A.SOURCE_FORMAT_UNKNOWN);
    if ((0, $2N6Uo.isTypedArray)(data)) sourceFormat = (0, $eKQ6A.SOURCE_FORMAT_TYPED_ARRAY);
    else if ((0, $2N6Uo.isArray)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $2N6Uo.isArray)(item) || (0, $2N6Uo.isTypedArray)(item)) {
                sourceFormat = (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS);
                break;
            } else if ((0, $2N6Uo.isObject)(item)) {
                sourceFormat = (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS);
                break;
            }
        }
    } else if ((0, $2N6Uo.isObject)(data)) {
        for(var key in data)if ((0, $2N6Uo.hasOwn)(data, key) && (0, $2N6Uo.isArrayLike)(data[key])) {
            sourceFormat = (0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $7270fcf70cd48f5e$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $7270fcf70cd48f5e$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $7270fcf70cd48f5e$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $2N6Uo.isString)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $2N6Uo.isNumber)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $7270fcf70cd48f5e$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $eKQ6A.SERIES_LAYOUT_BY_ROW) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS)) {
        if (!dimensionsDefine) dimensionsDefine = $7270fcf70cd48f5e$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $2N6Uo.each)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL)) {
        var value0 = (0, $bx3T8.getDataItemValue)(data[0]);
        dimensionsDetectedCount = (0, $2N6Uo.isArray)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $7270fcf70cd48f5e$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $7270fcf70cd48f5e$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $2N6Uo.keys)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $7270fcf70cd48f5e$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $2N6Uo.createHashMap)();
    return (0, $2N6Uo.map)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $2N6Uo.isObject)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += '';
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $7270fcf70cd48f5e$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $eKQ6A.SERIES_LAYOUT_BY_ROW)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $7270fcf70cd48f5e$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_KEYED_COLUMNS);
}

});



parcelRegister("4XoTU", function(module, exports) {

$parcel$export(module.exports, "createTask", function () { return $39bffce7e00e533d$export$f7292ab7796be73c; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $39bffce7e00e533d$export$f7292ab7796be73c(define) {
    return new $39bffce7e00e533d$export$2dea7024bcdd7731(define);
}
var $39bffce7e00e533d$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $2N6Uo.isArray)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $39bffce7e00e533d$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $39bffce7e00e533d$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $2N6Uo.isArray)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $39bffce7e00e533d$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };

});

parcelRegister("8zxSQ", function(module, exports) {

$parcel$export(module.exports, "SourceManager", function () { return $63dbe03544d42fcb$export$af4db9ec7e200ea2; });
$parcel$export(module.exports, "disableTransformOptionMerge", function () { return $63dbe03544d42fcb$export$9451f4e9047441ec; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $9Pasn = parcelRequire("9Pasn");

var $eKQ6A = parcelRequire("eKQ6A");

var $6VFOB = parcelRequire("6VFOB");

var $34jNS = parcelRequire("34jNS");

var $4ToKq = parcelRequire("4ToKq");

var $bA99G = parcelRequire("bA99G");
/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $63dbe03544d42fcb$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($63dbe03544d42fcb$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $2N6Uo.isTypedArray)(data) ? (0, $eKQ6A.SOURCE_FORMAT_TYPED_ARRAY) : (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $2N6Uo.retrieve2)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $2N6Uo.retrieve2)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $2N6Uo.retrieve2)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $9Pasn.createSource)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $9Pasn.createSource)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $63dbe03544d42fcb$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $2N6Uo.each)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $63dbe03544d42fcb$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $34jNS.applyDataTransform)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $9Pasn.cloneSourceShallow)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($63dbe03544d42fcb$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $4ToKq.default)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $bA99G.DefaultDataProvider)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($63dbe03544d42fcb$var$isSeries(sourceHost)) {
            var datasetModel = (0, $6VFOB.querySeriesUpstreamDatasetModel)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $2N6Uo.map)((0, $6VFOB.queryDatasetUpstreamDatasetModels)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($63dbe03544d42fcb$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $63dbe03544d42fcb$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $2N6Uo.setAsPrimitive)(datasetModel.option.transform);
}
function $63dbe03544d42fcb$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $63dbe03544d42fcb$var$doThrow(errMsg) {
    throw new Error(errMsg);
}

});
parcelRegister("34jNS", function(module, exports) {

$parcel$export(module.exports, "registerExternalTransform", function () { return $23c11b5c30ddebe9$export$92c96c6d8b255b7d; });
$parcel$export(module.exports, "applyDataTransform", function () { return $23c11b5c30ddebe9$export$42a68f09db16803f; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eKQ6A = parcelRequire("eKQ6A");

var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $bA99G = parcelRequire("bA99G");

var $irvLa = parcelRequire("irvLa");

var $byzwF = parcelRequire("byzwF");

var $9Pasn = parcelRequire("9Pasn");
/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $23c11b5c30ddebe9$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $irvLa.parseDataValue)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $23c11b5c30ddebe9$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $23c11b5c30ddebe9$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN)) (0, $byzwF.throwError)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $2N6Uo.each)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $2N6Uo.hasOwn)(dimsByName, name)) (0, $byzwF.throwError)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $bA99G.getRawSourceItemGetter)(sourceFormat, (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $2N6Uo.bind)($23c11b5c30ddebe9$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $2N6Uo.bind)($23c11b5c30ddebe9$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $bA99G.getRawSourceDataCounter)(sourceFormat, (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN));
    extSource.count = (0, $2N6Uo.bind)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $bA99G.getRawSourceValueGetter)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $2N6Uo.bind)($23c11b5c30ddebe9$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $2N6Uo.bind)($23c11b5c30ddebe9$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $23c11b5c30ddebe9$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$23c11b5c30ddebe9$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $byzwF.throwError)(errMsg);
    }
    return upstream.data;
}
function $23c11b5c30ddebe9$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$23c11b5c30ddebe9$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $byzwF.throwError)(errMsg);
    }
    if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $2N6Uo.extend)({}, data[i]));
        return result;
    }
}
function $23c11b5c30ddebe9$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $2N6Uo.isNumber)(dim) || !isNaN(dim) && !(0, $2N6Uo.hasOwn)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $2N6Uo.hasOwn)(dimsByName, dim)) return dimsByName[dim];
}
function $23c11b5c30ddebe9$var$cloneAllDimensionInfo(dimensions) {
    return (0, $2N6Uo.clone)(dimensions);
}
var $23c11b5c30ddebe9$var$externalTransformMap = (0, $2N6Uo.createHashMap)();
function $23c11b5c30ddebe9$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $2N6Uo.clone)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $byzwF.throwError)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $byzwF.throwError)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $23c11b5c30ddebe9$var$externalTransformMap.set(type, externalTransform);
}
function $23c11b5c30ddebe9$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $bx3T8.normalizeToArray)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $byzwF.throwError)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $23c11b5c30ddebe9$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $23c11b5c30ddebe9$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $byzwF.throwError)(errMsg);
    if (!(0, $2N6Uo.isObject)(transOption)) (0, $byzwF.throwError)(errMsg);
    var transType = transOption.type;
    var externalTransform = $23c11b5c30ddebe9$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $byzwF.throwError)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $2N6Uo.map)(upSourceList, function(upSource) {
        return $23c11b5c30ddebe9$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $bx3T8.normalizeToArray)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $2N6Uo.clone)(transOption.config)
    }));
    var printStrArr;
    return (0, $2N6Uo.map)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $2N6Uo.isObject)(result)) (0, $byzwF.throwError)(errMsg);
        if (!result.data) (0, $byzwF.throwError)(errMsg);
        var sourceFormat = (0, $9Pasn.detectSourceFormat)(result.data);
        if (!$23c11b5c30ddebe9$var$isSupportedSourceFormat(sourceFormat)) (0, $byzwF.throwError)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $9Pasn.createSource)(result.data, resultMetaRawOption, null);
    });
}
function $23c11b5c30ddebe9$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) || sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS);
}

});
parcelRegister("irvLa", function(module, exports) {

$parcel$export(module.exports, "parseDataValue", function () { return $d6d3626c588ea53e$export$cc7175145baad076; });
$parcel$export(module.exports, "getRawValueParser", function () { return $d6d3626c588ea53e$export$c88237b7c265b36b; });
$parcel$export(module.exports, "SortOrderComparator", function () { return $d6d3626c588ea53e$export$ed75a5d7b0144167; });
$parcel$export(module.exports, "createFilterComparator", function () { return $d6d3626c588ea53e$export$f2644c3485f94c4e; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");

var $byzwF = parcelRequire("byzwF");
function $d6d3626c588ea53e$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' && !(0, $2N6Uo.isNumber)(value) && value != null && value !== '-') value = +(0, $iCU10.parseDate)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN : Number(value);
}
var $d6d3626c588ea53e$var$valueParserMap = (0, $2N6Uo.createHashMap)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $iCU10.parseDate)(val);
    },
    'trim': function(val) {
        return (0, $2N6Uo.isString)(val) ? (0, $2N6Uo.trim)(val) : val;
    }
});
function $d6d3626c588ea53e$export$c88237b7c265b36b(type) {
    return $d6d3626c588ea53e$var$valueParserMap.get(type);
}
var $d6d3626c588ea53e$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $d6d3626c588ea53e$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $2N6Uo.isNumber)(rval)) {
            var errMsg = '';
            (0, $byzwF.throwError)(errMsg);
        }
        this._opFn = $d6d3626c588ea53e$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $iCU10.numericToNumber)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $2N6Uo.isNumber)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $iCU10.numericToNumber)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $d6d3626c588ea53e$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $2N6Uo.isNumber)(lval) ? lval : (0, $iCU10.numericToNumber)(lval);
        var rvalFloat = (0, $2N6Uo.isNumber)(rval) ? rval : (0, $iCU10.numericToNumber)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $2N6Uo.isString)(lval);
            var rvalIsStr = (0, $2N6Uo.isString)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $d6d3626c588ea53e$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $iCU10.numericToNumber)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $iCU10.numericToNumber)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $d6d3626c588ea53e$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $d6d3626c588ea53e$var$FilterEqualityComparator(op === 'eq', rval) : (0, $2N6Uo.hasOwn)($d6d3626c588ea53e$var$ORDER_COMPARISON_OP_MAP, op) ? new $d6d3626c588ea53e$var$FilterOrderComparator(op, rval) : null;
}

});


parcelRegister("4ToKq", function(module, exports) {

$parcel$export(module.exports, "CtorInt32Array", function () { return $38ff7edf8b5e391f$export$b60d945128546f53; });
$parcel$export(module.exports, "default", function () { return $38ff7edf8b5e391f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $irvLa = parcelRequire("irvLa");

var $9Pasn = parcelRequire("9Pasn");
var $38ff7edf8b5e391f$var$UNDEFINED = 'undefined';
var $38ff7edf8b5e391f$export$859a1fa4f1106aa0 = typeof Uint32Array === $38ff7edf8b5e391f$var$UNDEFINED ? Array : Uint32Array;
var $38ff7edf8b5e391f$export$78cf73566f32c185 = typeof Uint16Array === $38ff7edf8b5e391f$var$UNDEFINED ? Array : Uint16Array;
var $38ff7edf8b5e391f$export$b60d945128546f53 = typeof Int32Array === $38ff7edf8b5e391f$var$UNDEFINED ? Array : Int32Array;
var $38ff7edf8b5e391f$export$365b104db51a490a = typeof Float64Array === $38ff7edf8b5e391f$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $38ff7edf8b5e391f$var$dataCtors = {
    'float': $38ff7edf8b5e391f$export$365b104db51a490a,
    'int': $38ff7edf8b5e391f$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $38ff7edf8b5e391f$export$365b104db51a490a
};
var $38ff7edf8b5e391f$var$defaultDimValueGetters;
function $38ff7edf8b5e391f$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $38ff7edf8b5e391f$export$859a1fa4f1106aa0 : $38ff7edf8b5e391f$export$78cf73566f32c185;
}
function $38ff7edf8b5e391f$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $38ff7edf8b5e391f$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $38ff7edf8b5e391f$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $38ff7edf8b5e391f$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $38ff7edf8b5e391f$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $2N6Uo.createHashMap)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $38ff7edf8b5e391f$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $9Pasn.shouldRetrieveDataByName)(source);
        this._dimensions = (0, $2N6Uo.map)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $38ff7edf8b5e391f$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = $38ff7edf8b5e391f$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $38ff7edf8b5e391f$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $38ff7edf8b5e391f$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $38ff7edf8b5e391f$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $2N6Uo.map)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $38ff7edf8b5e391f$var$getInitialExtent();
            $38ff7edf8b5e391f$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $38ff7edf8b5e391f$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $38ff7edf8b5e391f$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $2N6Uo.keys)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $38ff7edf8b5e391f$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $38ff7edf8b5e391f$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($38ff7edf8b5e391f$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ DataStore.prototype.minmaxDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        // Each frame results in 2 data points, one for min and one for max
        var newIndices = new ($38ff7edf8b5e391f$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) * 2);
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            var minIndex = i;
            var minValue = dimStore[this.getRawIndex(minIndex)];
            var maxIndex = i;
            var maxValue = dimStore[this.getRawIndex(maxIndex)];
            var thisFrameSize = frameSize;
            // Handle final smaller frame
            if (i + frameSize > len) thisFrameSize = len - i;
            // Determine min and max within the current frame
            for(var k = 0; k < thisFrameSize; k++){
                var rawIndex = this.getRawIndex(i + k);
                var value = dimStore[rawIndex];
                if (value < minValue) {
                    minValue = value;
                    minIndex = i + k;
                }
                if (value > maxValue) {
                    maxValue = value;
                    maxIndex = i + k;
                }
            }
            var rawMinIndex = this.getRawIndex(minIndex);
            var rawMaxIndex = this.getRawIndex(maxIndex);
            // Set the order of the min and max values, based on their ordering in the frame
            if (minIndex < maxIndex) {
                newIndices[offset++] = rawMinIndex;
                newIndices[offset++] = rawMaxIndex;
            } else {
                newIndices[offset++] = rawMaxIndex;
                newIndices[offset++] = rawMinIndex;
            }
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $38ff7edf8b5e391f$var$getInitialExtent();
        var newIndices = new ($38ff7edf8b5e391f$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $38ff7edf8b5e391f$var$getInitialExtent();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $2N6Uo.reduce)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $38ff7edf8b5e391f$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $2N6Uo.clone)(this._extent);
        target._rawExtent = (0, $2N6Uo.clone)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $irvLa.parseDataValue)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $38ff7edf8b5e391f$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $irvLa.parseDataValue)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $irvLa.parseDataValue)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $38ff7edf8b5e391f$export$2e2bcd8739ae039 = $38ff7edf8b5e391f$var$DataStore;

});


parcelRegister("1Z9ox", function(module, exports) {

$parcel$export(module.exports, "defaultSeriesFormatTooltip", function () { return $1722c68997fb551f$export$3a110b9fb5c88b34; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $5KdhI = parcelRequire("5KdhI");

var $bA99G = parcelRequire("bA99G");

var $bx3T8 = parcelRequire("bx3T8");
function $1722c68997fb551f$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $2N6Uo.isArray)(value);
    var markerColor = (0, $5KdhI.retrieveVisualColorForTooltipMarker)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $1722c68997fb551f$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $bA99G.retrieveRawValue)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $bx3T8.isNameSpecified)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $5KdhI.createTooltipMarkup)('section', {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $5KdhI.createTooltipMarkup)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $2N6Uo.trim)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                dataIndex: dataIndex
            })
        ].concat(subBlocks || [])
    });
}
function $1722c68997fb551f$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $2N6Uo.reduce)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $2N6Uo.each)(tooltipDims, function(dim) {
        setEachItem((0, $bA99G.retrieveRawValue)(data, dataIndex, dim), dim);
    }) : (0, $2N6Uo.each)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $5KdhI.createTooltipMarkup)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}

});
parcelRegister("5KdhI", function(module, exports) {

$parcel$export(module.exports, "createTooltipMarkup", function () { return $42eb8db0d9a748a8$export$cf63b23ce77d1921; });
$parcel$export(module.exports, "buildTooltipMarkup", function () { return $42eb8db0d9a748a8$export$6969ffb02c1cb49a; });
$parcel$export(module.exports, "retrieveVisualColorForTooltipMarker", function () { return $42eb8db0d9a748a8$export$ea15628039c0fa93; });
$parcel$export(module.exports, "getPaddingFromTooltipModel", function () { return $42eb8db0d9a748a8$export$3048212c802df496; });
$parcel$export(module.exports, "TooltipMarkupStyleCreator", function () { return $42eb8db0d9a748a8$export$2fba3afbcdcf3e18; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hrphB = parcelRequire("hrphB");
var $dhQnW = parcelRequire("dhQnW");

var $2N6Uo = parcelRequire("2N6Uo");

var $irvLa = parcelRequire("irvLa");

var $iCU10 = parcelRequire("iCU10");

var $6aXXD = parcelRequire("6aXXD");
var $42eb8db0d9a748a8$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
function $42eb8db0d9a748a8$var$getTooltipLineHeight(textStyle) {
    var lineHeight = textStyle.lineHeight;
    if (lineHeight == null) return $42eb8db0d9a748a8$var$TOOLTIP_LINE_HEIGHT_CSS;
    else return "line-height:" + (0, $dhQnW.encodeHTML)(lineHeight + '') + "px";
}
// TODO: more textStyle option
function $42eb8db0d9a748a8$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || (0, $6aXXD.default).color.tertiary;
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || (0, $6aXXD.default).color.secondary;
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $dhQnW.encodeHTML)(nameFontSize + '') + "px;color:" + (0, $dhQnW.encodeHTML)(nameFontColor) + ";font-weight:" + (0, $dhQnW.encodeHTML)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $dhQnW.encodeHTML)(valueFontSize + '') + "px;color:" + (0, $dhQnW.encodeHTML)(valueFontColor) + ";font-weight:" + (0, $dhQnW.encodeHTML)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $42eb8db0d9a748a8$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $42eb8db0d9a748a8$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
];
function $42eb8db0d9a748a8$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $42eb8db0d9a748a8$var$isSectionFragment(frag) {
    return frag.type === 'section';
}
function $42eb8db0d9a748a8$var$getBuilder(frag) {
    return $42eb8db0d9a748a8$var$isSectionFragment(frag) ? $42eb8db0d9a748a8$var$buildSection : $42eb8db0d9a748a8$var$buildNameValue;
}
function $42eb8db0d9a748a8$var$getBlockGapLevel(frag) {
    if ($42eb8db0d9a748a8$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $2N6Uo.each)(frag.blocks, function(subBlock) {
            var subGapLevel = $42eb8db0d9a748a8$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $42eb8db0d9a748a8$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $42eb8db0d9a748a8$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $42eb8db0d9a748a8$var$getGap($42eb8db0d9a748a8$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $2N6Uo.assert)(!subBlocks || (0, $2N6Uo.isArray)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $2N6Uo.hasOwn)(orderMap, orderMode)) {
            var comparator_1 = new (0, $irvLa.SortOrderComparator)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    (0, $2N6Uo.each)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $42eb8db0d9a748a8$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $2N6Uo.extend)((0, $2N6Uo.extend)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $42eb8db0d9a748a8$var$wrapBlockHTML(toolTipTextStyle, subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $hrphB.makeValueReadable)(fragment.header, 'ordinal', ctx.useUTC);
    var nameStyle = $42eb8db0d9a748a8$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    var tooltipLineHeight = $42eb8db0d9a748a8$var$getTooltipLineHeight(toolTipTextStyle);
    if (ctx.renderMode === 'richText') return $42eb8db0d9a748a8$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $42eb8db0d9a748a8$var$wrapBlockHTML(toolTipTextStyle, "<div style=\"" + nameStyle + ";" + tooltipLineHeight + ";\">" + (0, $dhQnW.encodeHTML)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
}
function $42eb8db0d9a748a8$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $2N6Uo.isArray)(value) ? value : [
            value
        ];
        return (0, $2N6Uo.map)(value, function(val, idx) {
            return (0, $hrphB.makeValueReadable)(val, (0, $2N6Uo.isArray)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || (0, $6aXXD.default).color.secondary, renderMode);
    var readableName = noName ? '' : (0, $hrphB.makeValueReadable)(name, 'ordinal', useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.dataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $42eb8db0d9a748a8$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $42eb8db0d9a748a8$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $42eb8db0d9a748a8$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $42eb8db0d9a748a8$var$wrapBlockHTML(toolTipTextStyle, (noMarker ? '' : markerStr) + (noName ? '' : $42eb8db0d9a748a8$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $42eb8db0d9a748a8$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $42eb8db0d9a748a8$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $42eb8db0d9a748a8$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $42eb8db0d9a748a8$var$getGap(gapLevel) {
    return {
        html: $42eb8db0d9a748a8$var$HTML_GAPS[gapLevel],
        richText: $42eb8db0d9a748a8$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $42eb8db0d9a748a8$var$wrapBlockHTML(textStyle, encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    var tooltipLineHeight = $42eb8db0d9a748a8$var$getTooltipLineHeight(textStyle);
    return "<div style=\"" + marginCSS + ";" + tooltipLineHeight + ";\">" + encodedContent + clearfix + '</div>';
}
function $42eb8db0d9a748a8$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $dhQnW.encodeHTML)(name) + '</span>';
}
function $42eb8db0d9a748a8$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    valueList = (0, $2N6Uo.isArray)(valueList) ? valueList : [
        valueList
    ];
    return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, $2N6Uo.map)(valueList, function(value) {
        return (0, $dhQnW.encodeHTML)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $42eb8db0d9a748a8$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $42eb8db0d9a748a8$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $2N6Uo.isArray)(values) ? values.join('  ') : values, styles);
}
function $42eb8db0d9a748a8$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $hrphB.convertToColorString)(color);
}
function $42eb8db0d9a748a8$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $42eb8db0d9a748a8$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $iCU10.getRandomIdBase)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $hrphB.getTooltipMarker)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $2N6Uo.isString)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $2N6Uo.isArray)(styles)) (0, $2N6Uo.each)(styles, function(stl) {
            return (0, $2N6Uo.extend)(finalStl, stl);
        });
        else (0, $2N6Uo.extend)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();

});



parcelRegister("bpyST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84ed16cb438863a2$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iQonF = parcelRequire("iQonF");

var $cKPmR = parcelRequire("cKPmR");

var $I7Ovw = parcelRequire("I7Ovw");
var $84ed16cb438863a2$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $iQonF.default)();
        this.uid = $cKPmR.getUID('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$I7Ovw.enableClassExtend($84ed16cb438863a2$var$ComponentView);
$I7Ovw.enableClassManagement($84ed16cb438863a2$var$ComponentView);
var $84ed16cb438863a2$export$2e2bcd8739ae039 = $84ed16cb438863a2$var$ComponentView;

});

parcelRegister("cWIrM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96cd611608757ba0$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iQonF = parcelRequire("iQonF");

var $cKPmR = parcelRequire("cKPmR");

var $I7Ovw = parcelRequire("I7Ovw");

var $bx3T8 = parcelRequire("bx3T8");

var $bwPbQ = parcelRequire("bwPbQ");

var $4XoTU = parcelRequire("4XoTU");

var $Uomg7 = parcelRequire("Uomg7");

var $h9U3p = parcelRequire("h9U3p");

var $96cd611608757ba0$var$inner = $bx3T8.makeInner();
var $96cd611608757ba0$var$renderPlanner = (0, $Uomg7.default)();
var $96cd611608757ba0$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $iQonF.default)();
        this.uid = $cKPmR.getUID('viewChart');
        this.renderTask = (0, $4XoTU.createTask)({
            plan: $96cd611608757ba0$var$renderTaskPlan,
            reset: $96cd611608757ba0$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $96cd611608757ba0$var$toggleHighlight(data, payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $96cd611608757ba0$var$toggleHighlight(data, payload, 'normal');
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $h9U3p.traverseElements)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $96cd611608757ba0$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $96cd611608757ba0$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $bwPbQ.isHighDownDispatcher)(el)) (state === 'emphasis' ? (0, $bwPbQ.enterEmphasis) : (0, $bwPbQ.leaveEmphasis))(el, highlightDigit);
}
function $96cd611608757ba0$var$toggleHighlight(data, payload, state) {
    var dataIndex = $bx3T8.queryDataIndex(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $bwPbQ.getHighlightDigit)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $2N6Uo.each)($bx3T8.normalizeToArray(dataIndex), function(dataIdx) {
        $96cd611608757ba0$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $96cd611608757ba0$var$elSetState(el, state, highlightDigit);
    });
}
$I7Ovw.enableClassExtend($96cd611608757ba0$var$ChartView, [
    'dispose'
]);
$I7Ovw.enableClassManagement($96cd611608757ba0$var$ChartView);
function $96cd611608757ba0$var$renderTaskPlan(context) {
    return $96cd611608757ba0$var$renderPlanner(context.model);
}
function $96cd611608757ba0$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $96cd611608757ba0$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $96cd611608757ba0$var$progressMethodMap[methodName];
}
var $96cd611608757ba0$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $96cd611608757ba0$export$2e2bcd8739ae039 = $96cd611608757ba0$var$ChartView;

});
parcelRegister("Uomg7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a9820125683e986$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");
function $0a9820125683e986$export$2e2bcd8739ae039() {
    var inner = (0, $bx3T8.makeInner)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}

});


parcelRegister("99VtN", function(module, exports) {

$parcel$export(module.exports, "throttle", function () { return $6ab18a8e3cc9216f$export$de363e709c412c8a; });
$parcel$export(module.exports, "createOrUpdate", function () { return $6ab18a8e3cc9216f$export$958e3e1a02eac4b6; });
$parcel$export(module.exports, "clear", function () { return $6ab18a8e3cc9216f$export$42ffd38884aecdac; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6ab18a8e3cc9216f$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $6ab18a8e3cc9216f$var$RATE = '\0__throttleRate';
var $6ab18a8e3cc9216f$var$THROTTLE_TYPE = '\0__throttleType';
function $6ab18a8e3cc9216f$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $6ab18a8e3cc9216f$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$6ab18a8e3cc9216f$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$6ab18a8e3cc9216f$var$THROTTLE_TYPE];
    var lastRate = fn[$6ab18a8e3cc9216f$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $6ab18a8e3cc9216f$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$6ab18a8e3cc9216f$var$ORIGIN_METHOD] = originFn;
        fn[$6ab18a8e3cc9216f$var$THROTTLE_TYPE] = throttleType;
        fn[$6ab18a8e3cc9216f$var$RATE] = rate;
    }
    return fn;
}
function $6ab18a8e3cc9216f$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$6ab18a8e3cc9216f$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$6ab18a8e3cc9216f$var$ORIGIN_METHOD];
    }
}

});

parcelRegister("lbln3", function(module, exports) {

$parcel$export(module.exports, "seriesStyleTask", function () { return $f6bb33d85cb13f3e$export$7ce4d65f9b69240; });
$parcel$export(module.exports, "dataStyleTask", function () { return $f6bb33d85cb13f3e$export$f7dcb66a065003d1; });
$parcel$export(module.exports, "dataColorPaletteTask", function () { return $f6bb33d85cb13f3e$export$cf9758b0d6dc0aa9; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $4jA7C = parcelRequire("4jA7C");

var $fqEWa = parcelRequire("fqEWa");

var $3KFvW = parcelRequire("3KFvW");

var $b8YKU = parcelRequire("b8YKU");

var $bx3T8 = parcelRequire("bx3T8");
var $f6bb33d85cb13f3e$var$inner = (0, $bx3T8.makeInner)();
var $f6bb33d85cb13f3e$var$defaultStyleMappers = {
    itemStyle: (0, $4jA7C.default)((0, $fqEWa.ITEM_STYLE_KEY_MAP), true),
    lineStyle: (0, $4jA7C.default)((0, $3KFvW.LINE_STYLE_KEY_MAP), true)
};
var $f6bb33d85cb13f3e$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $f6bb33d85cb13f3e$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $f6bb33d85cb13f3e$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $f6bb33d85cb13f3e$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $f6bb33d85cb13f3e$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $f6bb33d85cb13f3e$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $f6bb33d85cb13f3e$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $f6bb33d85cb13f3e$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $f6bb33d85cb13f3e$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $2N6Uo.isFunction)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || (0, $2N6Uo.isFunction)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || (0, $2N6Uo.isFunction)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $2N6Uo.extend)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $f6bb33d85cb13f3e$var$sharedModel = new (0, $b8YKU.default)();
var $f6bb33d85cb13f3e$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var getStyle = $f6bb33d85cb13f3e$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $f6bb33d85cb13f3e$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($f6bb33d85cb13f3e$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $2N6Uo.extend)(existsStyle, style);
                    if ($f6bb33d85cb13f3e$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $f6bb33d85cb13f3e$var$sharedModel.option.decal);
                        $f6bb33d85cb13f3e$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $f6bb33d85cb13f3e$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $2N6Uo.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + '-' + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $f6bb33d85cb13f3e$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $f6bb33d85cb13f3e$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $f6bb33d85cb13f3e$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};

});

parcelRegister("2QF9O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21305d0f0d8dee2f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
parcelRequire("h9U3p");
var $2ClTb = parcelRequire("2ClTb");
var $aH2k0 = parcelRequire("aH2k0");
var $iQonF = parcelRequire("iQonF");
var $kBKw3 = parcelRequire("kBKw3");

var $6aXXD = parcelRequire("6aXXD");
var $21305d0f0d8dee2f$var$PI = Math.PI;
function $21305d0f0d8dee2f$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $2N6Uo.defaults(opts, {
        text: 'loading',
        textColor: (0, $6aXXD.default).color.primary,
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255,255,255,0.8)',
        showSpinner: true,
        color: (0, $6aXXD.default).color.theme[0],
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $iQonF.default();
    var mask = new $aH2k0.default({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $kBKw3.default({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $aH2k0.default({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $2ClTb.default({
            shape: {
                startAngle: -$21305d0f0d8dee2f$var$PI / 2,
                endAngle: -$21305d0f0d8dee2f$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $21305d0f0d8dee2f$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $21305d0f0d8dee2f$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}

});

parcelRegister("fcGJo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1191f8053da6cbb$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $4XoTU = parcelRequire("4XoTU");

var $cKPmR = parcelRequire("cKPmR");

var $jyf7V = parcelRequire("jyf7V");

var $lCOOS = parcelRequire("lCOOS");

var $bx3T8 = parcelRequire("bx3T8");
var $b1191f8053da6cbb$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $2N6Uo.createHashMap)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count();
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold');
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $2N6Uo.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $2N6Uo.each)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $2N6Uo.assert)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $2N6Uo.each)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $2N6Uo.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $4XoTU.createTask)({
                plan: $b1191f8053da6cbb$var$seriesTaskPlan,
                reset: $b1191f8053da6cbb$var$seriesTaskReset,
                count: $b1191f8053da6cbb$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $4XoTU.createTask)({
            reset: $b1191f8053da6cbb$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $2N6Uo.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = '';
        (0, $2N6Uo.assert)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $2N6Uo.each)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $4XoTU.createTask)({
                reset: $b1191f8053da6cbb$var$stubReset,
                onDirty: $b1191f8053da6cbb$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $2N6Uo.isFunction)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $b1191f8053da6cbb$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $cKPmR.getUID)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $b1191f8053da6cbb$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $b1191f8053da6cbb$var$stubReset(context) {
    return context.overallProgress && $b1191f8053da6cbb$var$stubProgress;
}
function $b1191f8053da6cbb$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $b1191f8053da6cbb$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $b1191f8053da6cbb$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $b1191f8053da6cbb$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $bx3T8.normalizeToArray)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $2N6Uo.map)(resetDefines, function(v, idx) {
        return $b1191f8053da6cbb$var$makeSeriesTaskProgress(idx);
    }) : $b1191f8053da6cbb$var$singleSeriesTaskProgress;
}
var $b1191f8053da6cbb$var$singleSeriesTaskProgress = $b1191f8053da6cbb$var$makeSeriesTaskProgress(0);
function $b1191f8053da6cbb$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $b1191f8053da6cbb$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $b1191f8053da6cbb$var$detectSeriseType(legacyFunc) {
    $b1191f8053da6cbb$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($b1191f8053da6cbb$var$ecModelMock, $b1191f8053da6cbb$var$apiMock);
    } catch (e) {}
    return $b1191f8053da6cbb$var$seriesType;
}
var $b1191f8053da6cbb$var$ecModelMock = {};
var $b1191f8053da6cbb$var$apiMock = {};
var $b1191f8053da6cbb$var$seriesType;
$b1191f8053da6cbb$var$mockMethods($b1191f8053da6cbb$var$ecModelMock, (0, $jyf7V.default));
$b1191f8053da6cbb$var$mockMethods($b1191f8053da6cbb$var$apiMock, (0, $lCOOS.default));
$b1191f8053da6cbb$var$ecModelMock.eachSeriesByType = $b1191f8053da6cbb$var$ecModelMock.eachRawSeriesByType = function(type) {
    $b1191f8053da6cbb$var$seriesType = type;
};
$b1191f8053da6cbb$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $b1191f8053da6cbb$var$seriesType = cond.subType;
};
function $b1191f8053da6cbb$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $2N6Uo.noop);
/* eslint-enable */ }
var $b1191f8053da6cbb$export$2e2bcd8739ae039 = $b1191f8053da6cbb$var$Scheduler;

});

parcelRegister("e0Ss6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33b4ddf6750cdd3$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6aXXD = parcelRequire("6aXXD");
var $a33b4ddf6750cdd3$var$color = (0, $6aXXD.default).darkColor;
var $a33b4ddf6750cdd3$var$backgroundColor = $a33b4ddf6750cdd3$var$color.background;
var $a33b4ddf6750cdd3$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $a33b4ddf6750cdd3$var$color.axisLine
            }
        },
        splitLine: {
            lineStyle: {
                color: $a33b4ddf6750cdd3$var$color.axisSplitLine
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    $a33b4ddf6750cdd3$var$color.backgroundTint,
                    $a33b4ddf6750cdd3$var$color.backgroundTransparent
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: $a33b4ddf6750cdd3$var$color.axisMinorSplitLine
            }
        },
        axisLabel: {
            color: $a33b4ddf6750cdd3$var$color.axisLabel
        },
        axisName: {}
    };
};
var $a33b4ddf6750cdd3$var$matrixAxis = {
    label: {
        color: $a33b4ddf6750cdd3$var$color.secondary
    },
    itemStyle: {
        borderColor: $a33b4ddf6750cdd3$var$color.borderTint
    },
    dividerLineStyle: {
        color: $a33b4ddf6750cdd3$var$color.border
    }
};
var $a33b4ddf6750cdd3$var$theme = {
    darkMode: true,
    color: $a33b4ddf6750cdd3$var$color.theme,
    backgroundColor: $a33b4ddf6750cdd3$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: $a33b4ddf6750cdd3$var$color.border
        },
        crossStyle: {
            color: $a33b4ddf6750cdd3$var$color.borderShade
        },
        label: {
            color: $a33b4ddf6750cdd3$var$color.tertiary
        }
    },
    legend: {
        textStyle: {
            color: $a33b4ddf6750cdd3$var$color.secondary
        },
        pageTextStyle: {
            color: $a33b4ddf6750cdd3$var$color.tertiary
        }
    },
    textStyle: {
        color: $a33b4ddf6750cdd3$var$color.secondary
    },
    title: {
        textStyle: {
            color: $a33b4ddf6750cdd3$var$color.primary
        },
        subtextStyle: {
            color: $a33b4ddf6750cdd3$var$color.quaternary
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $a33b4ddf6750cdd3$var$color.accent50
        }
    },
    tooltip: {
        backgroundColor: $a33b4ddf6750cdd3$var$color.neutral20,
        defaultBorderColor: $a33b4ddf6750cdd3$var$color.border,
        textStyle: {
            color: $a33b4ddf6750cdd3$var$color.tertiary
        }
    },
    dataZoom: {
        borderColor: $a33b4ddf6750cdd3$var$color.accent10,
        textStyle: {
            color: $a33b4ddf6750cdd3$var$color.tertiary
        },
        brushStyle: {
            color: $a33b4ddf6750cdd3$var$color.backgroundTint
        },
        handleStyle: {
            color: $a33b4ddf6750cdd3$var$color.neutral00,
            borderColor: $a33b4ddf6750cdd3$var$color.accent20
        },
        moveHandleStyle: {
            color: $a33b4ddf6750cdd3$var$color.accent40
        },
        emphasis: {
            handleStyle: {
                borderColor: $a33b4ddf6750cdd3$var$color.accent50
            }
        },
        dataBackground: {
            lineStyle: {
                color: $a33b4ddf6750cdd3$var$color.accent30
            },
            areaStyle: {
                color: $a33b4ddf6750cdd3$var$color.accent20
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: $a33b4ddf6750cdd3$var$color.accent50
            },
            areaStyle: {
                color: $a33b4ddf6750cdd3$var$color.accent30
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $a33b4ddf6750cdd3$var$color.secondary
        },
        handleStyle: {
            borderColor: $a33b4ddf6750cdd3$var$color.neutral30
        }
    },
    timeline: {
        lineStyle: {
            color: $a33b4ddf6750cdd3$var$color.accent10
        },
        label: {
            color: $a33b4ddf6750cdd3$var$color.tertiary
        },
        controlStyle: {
            color: $a33b4ddf6750cdd3$var$color.accent30,
            borderColor: $a33b4ddf6750cdd3$var$color.accent30
        }
    },
    calendar: {
        itemStyle: {
            color: $a33b4ddf6750cdd3$var$color.neutral00,
            borderColor: $a33b4ddf6750cdd3$var$color.neutral20
        },
        dayLabel: {
            color: $a33b4ddf6750cdd3$var$color.tertiary
        },
        monthLabel: {
            color: $a33b4ddf6750cdd3$var$color.secondary
        },
        yearLabel: {
            color: $a33b4ddf6750cdd3$var$color.secondary
        }
    },
    matrix: {
        x: $a33b4ddf6750cdd3$var$matrixAxis,
        y: $a33b4ddf6750cdd3$var$matrixAxis,
        backgroundColor: {
            borderColor: $a33b4ddf6750cdd3$var$color.axisLine
        },
        body: {
            itemStyle: {
                borderColor: $a33b4ddf6750cdd3$var$color.borderTint
            }
        }
    },
    timeAxis: $a33b4ddf6750cdd3$var$axisCommon(),
    logAxis: $a33b4ddf6750cdd3$var$axisCommon(),
    valueAxis: $a33b4ddf6750cdd3$var$axisCommon(),
    categoryAxis: $a33b4ddf6750cdd3$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $a33b4ddf6750cdd3$var$color.theme
    },
    gauge: {
        title: {
            color: $a33b4ddf6750cdd3$var$color.secondary
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        $a33b4ddf6750cdd3$var$color.neutral05
                    ]
                ]
            }
        },
        axisLabel: {
            color: $a33b4ddf6750cdd3$var$color.axisLabel
        },
        detail: {
            color: $a33b4ddf6750cdd3$var$color.primary
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92'
        }
    },
    funnel: {
        itemStyle: {
            borderColor: $a33b4ddf6750cdd3$var$color.background
        }
    },
    radar: function() {
        var radar = $a33b4ddf6750cdd3$var$axisCommon();
        radar.axisName = {
            color: $a33b4ddf6750cdd3$var$color.axisLabel
        };
        radar.axisLine.lineStyle.color = $a33b4ddf6750cdd3$var$color.neutral20;
        return radar;
    }(),
    treemap: {
        breadcrumb: {
            itemStyle: {
                color: $a33b4ddf6750cdd3$var$color.neutral20,
                textStyle: {
                    color: $a33b4ddf6750cdd3$var$color.secondary
                }
            },
            emphasis: {
                itemStyle: {
                    color: $a33b4ddf6750cdd3$var$color.neutral30
                }
            }
        }
    },
    sunburst: {
        itemStyle: {
            borderColor: $a33b4ddf6750cdd3$var$color.background
        }
    },
    map: {
        itemStyle: {
            borderColor: $a33b4ddf6750cdd3$var$color.border,
            areaColor: $a33b4ddf6750cdd3$var$color.neutral10
        },
        label: {
            color: $a33b4ddf6750cdd3$var$color.tertiary
        },
        emphasis: {
            label: {
                color: $a33b4ddf6750cdd3$var$color.primary
            },
            itemStyle: {
                areaColor: $a33b4ddf6750cdd3$var$color.highlight
            }
        },
        select: {
            label: {
                color: $a33b4ddf6750cdd3$var$color.primary
            },
            itemStyle: {
                areaColor: $a33b4ddf6750cdd3$var$color.highlight
            }
        }
    },
    geo: {
        itemStyle: {
            borderColor: $a33b4ddf6750cdd3$var$color.border,
            areaColor: $a33b4ddf6750cdd3$var$color.neutral10
        },
        emphasis: {
            label: {
                color: $a33b4ddf6750cdd3$var$color.primary
            },
            itemStyle: {
                areaColor: $a33b4ddf6750cdd3$var$color.highlight
            }
        },
        select: {
            label: {
                color: $a33b4ddf6750cdd3$var$color.primary
            },
            itemStyle: {
                color: $a33b4ddf6750cdd3$var$color.highlight
            }
        }
    }
};
$a33b4ddf6750cdd3$var$theme.categoryAxis.splitLine.show = false;
var $a33b4ddf6750cdd3$export$2e2bcd8739ae039 = $a33b4ddf6750cdd3$var$theme;

});

parcelRegister("9vGpS", function(module, exports) {

$parcel$export(module.exports, "ECEventProcessor", function () { return $6ec7e94daa01d748$export$d0fd09f950257b52; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $I7Ovw = parcelRequire("I7Ovw");
/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $6ec7e94daa01d748$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($2N6Uo.isString(query)) {
            var condCptType = (0, $I7Ovw.parseClassType)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $2N6Uo.each(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();

});

parcelRegister("gvC19", function(module, exports) {

$parcel$export(module.exports, "seriesSymbolTask", function () { return $c04d08148167adbb$export$144ac3beded415d9; });
$parcel$export(module.exports, "dataSymbolTask", function () { return $c04d08148167adbb$export$435b956f7f1071fb; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $c04d08148167adbb$var$SYMBOL_PROPS_WITH_CB = [
    'symbol',
    'symbolSize',
    'symbolRotate',
    'symbolOffset'
];
var $c04d08148167adbb$var$SYMBOL_PROPS = $c04d08148167adbb$var$SYMBOL_PROPS_WITH_CB.concat([
    'symbolKeepAspect'
]);
// Encoding visual for all series include which is filtered for legend drawing
var $c04d08148167adbb$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $c04d08148167adbb$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $c04d08148167adbb$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $2N6Uo.isFunction)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $2N6Uo.extend)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get('symbolKeepAspect')
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $2N6Uo.keys)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $c04d08148167adbb$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $c04d08148167adbb$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $c04d08148167adbb$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};

});

parcelRegister("csdCr", function(module, exports) {

$parcel$export(module.exports, "getItemVisualFromData", function () { return $9112aa0860c44612$export$91d919a86b2df624; });
$parcel$export(module.exports, "getVisualFromData", function () { return $9112aa0860c44612$export$d76e333a86ea1a2; });
$parcel$export(module.exports, "setItemVisualFromData", function () { return $9112aa0860c44612$export$3aab879e9d0e7c75; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $9112aa0860c44612$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $9112aa0860c44612$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $9112aa0860c44612$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}

});

parcelRegister("eHA3F", function(module, exports) {

$parcel$export(module.exports, "createLegacyDataSelectAction", function () { return $ab410d3aec62f6fd$export$62942ba95693dbfc; });
$parcel$export(module.exports, "handleLegacySelectEvents", function () { return $ab410d3aec62f6fd$export$2575c83262e49d0c; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");


var $bx3T8 = parcelRequire("bx3T8");
function $ab410d3aec62f6fd$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $2N6Uo.each)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $2N6Uo.extend)({}, payload);
            api.dispatchAction((0, $2N6Uo.extend)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $ab410d3aec62f6fd$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $bx3T8.queryDataIndex)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $2N6Uo.isArray)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $2N6Uo.isString)(selectedMap) ? selectedMap : (0, $2N6Uo.extend)({}, selectedMap)
            });
        }
    });
}
function $ab410d3aec62f6fd$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $ab410d3aec62f6fd$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $ab410d3aec62f6fd$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $ab410d3aec62f6fd$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $ab410d3aec62f6fd$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $ab410d3aec62f6fd$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $ab410d3aec62f6fd$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}

});

parcelRegister("cQG2W", function(module, exports) {

$parcel$export(module.exports, "findEventDispatcher", function () { return $95aaf4ebfae86ddc$export$8a4fca9e04eb4df6; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $95aaf4ebfae86ddc$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}

});

parcelRegister("8Ysvi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $688a099665e5c380$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9gUBZ = parcelRequire("9gUBZ");
function $688a099665e5c380$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $9gUBZ.createOrUpdatePatternFromDecal)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $9gUBZ.createOrUpdatePatternFromDecal)(decal, api);
        }
    });
}

});
parcelRegister("9gUBZ", function(module, exports) {

$parcel$export(module.exports, "createOrUpdatePatternFromDecal", function () { return $6c018594fbfd2c29$export$a3ba048e1a648972; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jPb1v = parcelRequire("jPb1v");

var $aceTf = parcelRequire("aceTf");

var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");

var $k0QDS = parcelRequire("k0QDS");

var $1zzSj = parcelRequire("1zzSj");

var $3WHoM = parcelRequire("3WHoM");
var $6c018594fbfd2c29$var$decalMap = new (0, $jPb1v.default)();
var $6c018594fbfd2c29$var$decalCache = new (0, $aceTf.default)(100);
var $6c018594fbfd2c29$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $6c018594fbfd2c29$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $6c018594fbfd2c29$var$decalMap["delete"](decalObject);
    var oldPattern = $6c018594fbfd2c29$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $2N6Uo.defaults)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $6c018594fbfd2c29$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $6c018594fbfd2c29$var$decalKeys.length; ++i){
            var value = decalOpt[$6c018594fbfd2c29$var$decalKeys[i]];
            if (value != null && !(0, $2N6Uo.isArray)(value) && !(0, $2N6Uo.isString)(value) && !(0, $2N6Uo.isNumber)(value) && typeof value !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $6c018594fbfd2c29$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $6c018594fbfd2c29$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $6c018594fbfd2c29$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $6c018594fbfd2c29$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $6c018594fbfd2c29$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $6c018594fbfd2c29$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $3WHoM.platformApi).createCanvas();
        var svgRoot = isSVG && {
            tag: 'g',
            attrs: {},
            key: 'dcl',
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $6c018594fbfd2c29$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $iCU10.getLeastCommonMultiple)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $iCU10.getLeastCommonMultiple)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $k0QDS.createSymbol)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $1zzSj.brushSingle)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $6c018594fbfd2c29$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if ((0, $2N6Uo.isString)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $2N6Uo.isString)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $6c018594fbfd2c29$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $2N6Uo.isString)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $6c018594fbfd2c29$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $2N6Uo.isNumber)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $2N6Uo.isNumber)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $6c018594fbfd2c29$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $2N6Uo.isNumber)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $2N6Uo.map)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $6c018594fbfd2c29$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $2N6Uo.isNumber)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $2N6Uo.map)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $6c018594fbfd2c29$var$getLineBlockLengthX(dash) {
    return (0, $2N6Uo.map)(dash, function(line) {
        return $6c018594fbfd2c29$var$getLineBlockLengthY(line);
    });
}
function $6c018594fbfd2c29$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}

});
parcelRegister("jPb1v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6eb54be2b833d5c$export$2e2bcd8739ae039; });
var $e6eb54be2b833d5c$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $e6eb54be2b833d5c$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $e6eb54be2b833d5c$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $e6eb54be2b833d5c$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($e6eb54be2b833d5c$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $e6eb54be2b833d5c$export$2e2bcd8739ae039 = $e6eb54be2b833d5c$var$WeakMap;

});

parcelRegister("k0QDS", function(module, exports) {

$parcel$export(module.exports, "symbolBuildProxies", function () { return $e91ca45ce050fd25$export$33fc3b478d332725; });
$parcel$export(module.exports, "createSymbol", function () { return $e91ca45ce050fd25$export$af050e04da3a02e8; });
$parcel$export(module.exports, "normalizeSymbolSize", function () { return $e91ca45ce050fd25$export$a84524f03e8e8dfb; });
$parcel$export(module.exports, "normalizeSymbolOffset", function () { return $e91ca45ce050fd25$export$e3e292895c033f6d; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory

var $2N6Uo = parcelRequire("2N6Uo");
parcelRequire("h9U3p");
var $6Utk3 = parcelRequire("6Utk3");
var $c3CaY = parcelRequire("c3CaY");
var $h9U3p = parcelRequire("h9U3p");
var $4oDJM = parcelRequire("4oDJM");
var $aH2k0 = parcelRequire("aH2k0");

var $67W72 = parcelRequire("67W72");

var $eVwLk = parcelRequire("eVwLk");

var $iCU10 = parcelRequire("iCU10");

var $6aXXD = parcelRequire("6aXXD");
/**
 * Triangle shape
 * @inner
 */ var $e91ca45ce050fd25$var$Triangle = $4oDJM.default.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $e91ca45ce050fd25$var$Diamond = $4oDJM.default.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $e91ca45ce050fd25$var$Pin = $4oDJM.default.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $e91ca45ce050fd25$var$Arrow = $4oDJM.default.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $e91ca45ce050fd25$var$symbolCtors = {
    line: $c3CaY.default,
    rect: $aH2k0.default,
    roundRect: $aH2k0.default,
    square: $aH2k0.default,
    circle: $6Utk3.default,
    diamond: $e91ca45ce050fd25$var$Diamond,
    pin: $e91ca45ce050fd25$var$Pin,
    arrow: $e91ca45ce050fd25$var$Arrow,
    triangle: $e91ca45ce050fd25$var$Triangle
};
var $e91ca45ce050fd25$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $e91ca45ce050fd25$export$33fc3b478d332725 = {};
(0, $2N6Uo.each)($e91ca45ce050fd25$var$symbolCtors, function(Ctor, name) {
    $e91ca45ce050fd25$export$33fc3b478d332725[name] = new Ctor();
});
var $e91ca45ce050fd25$var$SymbolClz = $4oDJM.default.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $eVwLk.calculateTextPosition)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $e91ca45ce050fd25$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $e91ca45ce050fd25$export$33fc3b478d332725[symbolType];
            }
            $e91ca45ce050fd25$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $e91ca45ce050fd25$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || (0, $6aXXD.default).color.neutral00;
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $e91ca45ce050fd25$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $h9U3p.makeImage(symbolType.slice(8), new (0, $67W72.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $h9U3p.makePath(symbolType.slice(7), {}, new (0, $67W72.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $e91ca45ce050fd25$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $e91ca45ce050fd25$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $e91ca45ce050fd25$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $2N6Uo.isArray)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $e91ca45ce050fd25$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $2N6Uo.isArray)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $iCU10.parsePercent)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $iCU10.parsePercent)((0, $2N6Uo.retrieve2)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}

});

parcelRegister("1zzSj", function(module, exports) {

$parcel$export(module.exports, "createCanvasPattern", function () { return $1254e35aaedc3818$export$8eb5db6b7bc27903; });
$parcel$export(module.exports, "brushSingle", function () { return $1254e35aaedc3818$export$567881adfc3eb7f3; });
$parcel$export(module.exports, "brush", function () { return $1254e35aaedc3818$export$da5d6544e8c27bc1; });

var $6Ekel = parcelRequire("6Ekel");

var $eAFw0 = parcelRequire("eAFw0");

var $58ik8 = parcelRequire("58ik8");

var $1AEzH = parcelRequire("1AEzH");

var $4oDJM = parcelRequire("4oDJM");

var $lQsZt = parcelRequire("lQsZt");

var $arPnl = parcelRequire("arPnl");

var $2N6Uo = parcelRequire("2N6Uo");

var $7c6cW = parcelRequire("7c6cW");

var $fde2h = parcelRequire("fde2h");

var $3WHoM = parcelRequire("3WHoM");
var $1254e35aaedc3818$var$pathProxyForDraw = new (0, $eAFw0.default)(true);
function $1254e35aaedc3818$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $1254e35aaedc3818$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $1254e35aaedc3818$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $1254e35aaedc3818$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $1254e35aaedc3818$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $1254e35aaedc3818$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $58ik8.createOrUpdateImage)(pattern.image, pattern.__image, el);
    if ((0, $58ik8.isImageReady)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $2N6Uo.RADIAN_TO_DEGREE));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $1254e35aaedc3818$var$brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = $1254e35aaedc3818$var$styleHasStroke(style);
    var hasFill = $1254e35aaedc3818$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $1254e35aaedc3818$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $1AEzH.getCanvasGradient)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $1AEzH.getCanvasGradient)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $1254e35aaedc3818$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $1254e35aaedc3818$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = strokePattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $7c6cW.getLineDash)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $fde2h.SHAPE_CHANGED_BIT)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $1254e35aaedc3818$var$doStrokePath(ctx, style);
            if (hasFill) $1254e35aaedc3818$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $1254e35aaedc3818$var$doFillPath(ctx, style);
            if (hasStroke) $1254e35aaedc3818$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash) ctx.setLineDash([]);
}
function $1254e35aaedc3818$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $58ik8.createOrUpdateImage)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $58ik8.isImageReady)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $1254e35aaedc3818$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $3WHoM.DEFAULT_FONT);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $7c6cW.getLineDash)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($1254e35aaedc3818$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($1254e35aaedc3818$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($1254e35aaedc3818$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($1254e35aaedc3818$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $1254e35aaedc3818$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $1254e35aaedc3818$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $1254e35aaedc3818$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $6Ekel.DEFAULT_COMMON_STYLE).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $6Ekel.DEFAULT_COMMON_STYLE).blend;
    }
    for(var i = 0; i < $1254e35aaedc3818$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $1254e35aaedc3818$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $6Ekel.DEFAULT_COMMON_STYLE).shadowColor;
    }
    return styleChanged;
}
function $1254e35aaedc3818$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $1254e35aaedc3818$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $1254e35aaedc3818$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $1254e35aaedc3818$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $1254e35aaedc3818$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $1254e35aaedc3818$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $1254e35aaedc3818$var$STROKE_PROPS.length; i++){
        var prop = $1254e35aaedc3818$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $1254e35aaedc3818$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $1254e35aaedc3818$var$bindCommonProps(ctx, $1254e35aaedc3818$var$getStyle(el, scope.inHover), prevEl && $1254e35aaedc3818$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $1254e35aaedc3818$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $1254e35aaedc3818$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $1254e35aaedc3818$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $1254e35aaedc3818$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $1254e35aaedc3818$var$DRAW_TYPE_PATH = 1;
var $1254e35aaedc3818$var$DRAW_TYPE_IMAGE = 2;
var $1254e35aaedc3818$var$DRAW_TYPE_TEXT = 3;
var $1254e35aaedc3818$var$DRAW_TYPE_INCREMENTAL = 4;
function $1254e35aaedc3818$var$canPathBatch(style) {
    var hasFill = $1254e35aaedc3818$var$styleHasFill(style);
    var hasStroke = $1254e35aaedc3818$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $1254e35aaedc3818$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function $1254e35aaedc3818$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $1254e35aaedc3818$export$567881adfc3eb7f3(ctx, el) {
    $1254e35aaedc3818$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $1254e35aaedc3818$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $fde2h.REDRAW_BIT);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $1AEzH.isClipPathChanged)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $1254e35aaedc3818$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $4oDJM.default) && el.autoBatch && $1254e35aaedc3818$var$canPathBatch(el.style);
    if (forceSetTransform || $1254e35aaedc3818$var$isTransformChanged(m, prevEl.transform)) {
        $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
        $1254e35aaedc3818$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
    var style = $1254e35aaedc3818$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $4oDJM.default)) {
        if (scope.lastDrawType !== $1254e35aaedc3818$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $1254e35aaedc3818$var$DRAW_TYPE_PATH;
        }
        $1254e35aaedc3818$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $1254e35aaedc3818$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    } else {
        if (el instanceof (0, $arPnl.default)) {
            if (scope.lastDrawType !== $1254e35aaedc3818$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $1254e35aaedc3818$var$DRAW_TYPE_TEXT;
            }
            $1254e35aaedc3818$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $1254e35aaedc3818$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $lQsZt.default)) {
            if (scope.lastDrawType !== $1254e35aaedc3818$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $1254e35aaedc3818$var$DRAW_TYPE_IMAGE;
            }
            $1254e35aaedc3818$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $1254e35aaedc3818$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $1254e35aaedc3818$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $1254e35aaedc3818$var$DRAW_TYPE_INCREMENTAL;
            }
            $1254e35aaedc3818$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $1254e35aaedc3818$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $1254e35aaedc3818$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $1254e35aaedc3818$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $1254e35aaedc3818$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}

});
parcelRegister("1AEzH", function(module, exports) {

$parcel$export(module.exports, "getCanvasGradient", function () { return $1288a0905cebf9c5$export$3dab6afd018d48c7; });
$parcel$export(module.exports, "isClipPathChanged", function () { return $1288a0905cebf9c5$export$beeddc5150cb2e83; });
$parcel$export(module.exports, "getSize", function () { return $1288a0905cebf9c5$export$31b21d0167753bb4; });
function $1288a0905cebf9c5$var$isSafeNum(num) {
    return isFinite(num);
}
function $1288a0905cebf9c5$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $1288a0905cebf9c5$var$isSafeNum(x) ? x : 0;
    x2 = $1288a0905cebf9c5$var$isSafeNum(x2) ? x2 : 1;
    y = $1288a0905cebf9c5$var$isSafeNum(y) ? y : 0;
    y2 = $1288a0905cebf9c5$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $1288a0905cebf9c5$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $1288a0905cebf9c5$var$isSafeNum(x) ? x : 0.5;
    y = $1288a0905cebf9c5$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $1288a0905cebf9c5$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $1288a0905cebf9c5$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $1288a0905cebf9c5$export$57f098206d57a443(ctx, obj, rect) : $1288a0905cebf9c5$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $1288a0905cebf9c5$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $1288a0905cebf9c5$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $1288a0905cebf9c5$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        'width',
        'height'
    ][whIdx];
    var cwh = [
        'clientWidth',
        'clientHeight'
    ][whIdx];
    var plt = [
        'paddingLeft',
        'paddingTop'
    ][whIdx];
    var prb = [
        'paddingRight',
        'paddingBottom'
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $1288a0905cebf9c5$var$parseInt10(stl[wh]) || $1288a0905cebf9c5$var$parseInt10(root.style[wh])) - ($1288a0905cebf9c5$var$parseInt10(stl[plt]) || 0) - ($1288a0905cebf9c5$var$parseInt10(stl[prb]) || 0) | 0;
}

});

parcelRegister("7c6cW", function(module, exports) {

$parcel$export(module.exports, "getLineDash", function () { return $53ce7818b7a0fa48$export$9d315911f153b3b2; });

var $2N6Uo = parcelRequire("2N6Uo");
function $53ce7818b7a0fa48$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $2N6Uo.isNumber)(lineType) ? [
        lineType
    ] : (0, $2N6Uo.isArray)(lineType) ? lineType : null;
}
function $53ce7818b7a0fa48$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $53ce7818b7a0fa48$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $2N6Uo.map)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}

});




parcelRegister("hHu50", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce2dc9077cdf0993$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5Uet9 = parcelRequire("5Uet9");
var $ce2dc9077cdf0993$var$lifecycle = new (0, $5Uet9.default)();
var $ce2dc9077cdf0993$export$2e2bcd8739ae039 = $ce2dc9077cdf0993$var$lifecycle;

});

parcelRegister("dDyjB", function(module, exports) {

$parcel$export(module.exports, "registerImpl", function () { return $9ed9892f2971da62$export$9b808fd12256ddd3; });
$parcel$export(module.exports, "getImpl", function () { return $9ed9892f2971da62$export$73333eb8a09d5f61; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $9ed9892f2971da62$var$implsStore = {};
function $9ed9892f2971da62$export$9b808fd12256ddd3(name, impl) {
    $9ed9892f2971da62$var$implsStore[name] = impl;
}
function $9ed9892f2971da62$export$73333eb8a09d5f61(name) {
    return $9ed9892f2971da62$var$implsStore[name];
}

});

parcelRegister("jHMox", function(module, exports) {

$parcel$export(module.exports, "registerCustomSeries", function () { return $e58792ae41f9b753$export$c3e61191887968da; });
$parcel$export(module.exports, "getCustomSeries", function () { return $e58792ae41f9b753$export$2b5db8e5650e8d15; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e58792ae41f9b753$var$customRenderers = {};
function $e58792ae41f9b753$export$c3e61191887968da(type, renderItem) {
    $e58792ae41f9b753$var$customRenderers[type] = renderItem;
}
function $e58792ae41f9b753$export$2b5db8e5650e8d15(type) {
    return $e58792ae41f9b753$var$customRenderers[type];
}

});



parcelRegister("25hpb", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $18498cb2496195ca$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $etQGc = parcelRequire("etQGc");
function $18498cb2496195ca$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('canvas', (0, $etQGc.default));
}

});
parcelRegister("etQGc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8aca332548e6fe1$export$2e2bcd8739ae039; });

var $4cadX = parcelRequire("4cadX");

var $2N6Uo = parcelRequire("2N6Uo");

var $4Kgq4 = parcelRequire("4Kgq4");

var $hvm9a = parcelRequire("hvm9a");

var $cirKE = parcelRequire("cirKE");

var $1zzSj = parcelRequire("1zzSj");

var $fde2h = parcelRequire("fde2h");

var $1AEzH = parcelRequire("1AEzH");
var $a8aca332548e6fe1$var$HOVER_LAYER_ZLEVEL = 1e5;
var $a8aca332548e6fe1$var$CANVAS_ZLEVEL = 314159;
var $a8aca332548e6fe1$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $a8aca332548e6fe1$var$INCREMENTAL_INC = 0.001;
function $a8aca332548e6fe1$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') return false;
    return true;
}
function $a8aca332548e6fe1$var$createRoot(width, height) {
    var domRoot = document.createElement('div');
    domRoot.style.cssText = [
        'position:relative',
        'width:' + width + 'px',
        'height:' + height + 'px',
        'padding:0',
        'margin:0',
        'border-width:0'
    ].join(';') + ';';
    return domRoot;
}
var $a8aca332548e6fe1$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = 'canvas';
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = 'canvas';
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === 'CANVAS';
        this._opts = opts = $2N6Uo.extend({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $4cadX.devicePixelRatio);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            $2N6Uo.disableUserSelect(root);
            root.innerHTML = '';
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = (0, $1AEzH.getSize)(root, 0, opts);
            this._height = (0, $1AEzH.getSize)(root, 1, opts);
            var domRoot = this._domRoot = $a8aca332548e6fe1$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new (0, $4Kgq4.default)(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[$a8aca332548e6fe1$var$CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = $a8aca332548e6fe1$var$CANVAS_ZLEVEL;
            zlevelList.push($a8aca332548e6fe1$var$CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return 'canvas';
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype.refreshHover = function() {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for(var i = 0; i < len; i++){
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($a8aca332548e6fe1$var$HOVER_LAYER_ZLEVEL);
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                (0, $1zzSj.brush)(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) ctx.restore();
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this.getLayer($a8aca332548e6fe1$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $1zzSj.brushSingle)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) this._compositeManually();
        if (needsRefreshHover) this._paintHoverList(list);
        if (!finished) {
            var self_1 = this;
            (0, $hvm9a.default)(function() {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        } else this.eachLayer(function(layer) {
            layer.afterBrush && layer.afterBrush();
        });
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this.getLayer($a8aca332548e6fe1$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function(k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
            }
            if (start === -1) {
                console.error('For some unknown reason. drawIndex is -1');
                start = layer.__startIndex;
            }
            var i;
            var repaint = function(repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for(i = start; i < layer.__endIndex; i++){
                    var el = list[i];
                    if (el.__inHover) needsRefreshHover = true;
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) break;
                    }
                }
                if (scope.prevElClipPaths) ctx.restore();
            };
            if (repaintRects) {
                if (repaintRects.length === 0) i = layer.__endIndex;
                else {
                    var dpr = this_1.dpr;
                    for(var r = 0; r < repaintRects.length; ++r){
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            } else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
        };
        var this_1 = this;
        for(var k = 0; k < layerList.length; k++)_loop_1(k);
        if ((0, $cirKE.default).wxa) $2N6Uo.each(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                (0, $1zzSj.brush)(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        } else (0, $1zzSj.brush)(ctx, el, scope, isLast);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $a8aca332548e6fe1$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new (0, $4Kgq4.default)('zr_' + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $2N6Uo.merge(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $a8aca332548e6fe1$var$EL_AFTER_INCREMENTAL_INC]) $2N6Uo.merge(layer, this._layerConfig[zlevel - $a8aca332548e6fe1$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) return;
        if (!$a8aca332548e6fe1$var$isLayerValid(layer)) return;
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.painter || (layer.painter = this);
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.getLayers = function() {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
            var el = list[i_1];
            if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for(i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + $a8aca332548e6fe1$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $a8aca332548e6fe1$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $2N6Uo.logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty & (0, $fde2h.REDRAW_BIT) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    };
    CanvasPainter.prototype.clear = function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function(layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $2N6Uo.each(this._layers, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $2N6Uo.merge(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + $a8aca332548e6fe1$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $2N6Uo.merge(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($2N6Uo.indexOf(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($a8aca332548e6fe1$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = 'none';
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = (0, $1AEzH.getSize)(root, 0, opts);
            height = (0, $1AEzH.getSize)(root, 1, opts);
            domRoot.style.display = '';
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + 'px';
                domRoot.style.height = height + 'px';
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = '';
        this.root = this.storage = this._domRoot = this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$a8aca332548e6fe1$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new (0, $4Kgq4.default)('image', this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $1zzSj.brush)(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    return CanvasPainter;
}();
var $a8aca332548e6fe1$export$2e2bcd8739ae039 = $a8aca332548e6fe1$var$CanvasPainter;

});
parcelRegister("4Kgq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $374831de8652c102$export$2e2bcd8739ae039; });

var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $4cadX = parcelRequire("4cadX");

var $5Uet9 = parcelRequire("5Uet9");

var $1AEzH = parcelRequire("1AEzH");

var $1zzSj = parcelRequire("1zzSj");

var $67W72 = parcelRequire("67W72");

var $fde2h = parcelRequire("fde2h");

var $3WHoM = parcelRequire("3WHoM");
function $374831de8652c102$var$createDom(id, painter, dpr) {
    var newDom = (0, $3WHoM.platformApi).createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = 'absolute';
        newDomStyle.left = '0';
        newDomStyle.top = '0';
        newDomStyle.width = width + 'px';
        newDomStyle.height = height + 'px';
        newDom.setAttribute('data-zr-dom-id', id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var $374831de8652c102$var$Layer = function(_super) {
    (0, $9nEce.__extends)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || (0, $4cadX.devicePixelRatio);
        if (typeof id === 'string') dom = $374831de8652c102$var$createDom(id, painter, dpr);
        else if ($2N6Uo.isObject(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            $2N6Uo.disableUserSelect(dom);
            dom.onselectstart = function() {
                return false;
            };
            domStyle.padding = '0';
            domStyle.margin = '0';
            domStyle.borderWidth = '0';
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function() {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function() {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext('2d');
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $374831de8652c102$var$createDom('back-' + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext('2d');
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $67W72.default)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $67W72.default)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $67W72.default)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $67W72.default)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        for(var i = this.__startIndex; i < this.__endIndex; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $fde2h.REDRAW_BIT) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $fde2h.REDRAW_BIT) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
            var el = prevList[i];
            var shouldPaint = el && el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + 'px';
            domStyle.height = height + 'px';
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = 'copy';
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== 'transparent') {
                var clearColorGradientOrPattern = void 0;
                if ($2N6Uo.isGradientObject(clearColor)) {
                    var shouldCache = clearColor.global || clearColor.__width === width && clearColor.__height === height;
                    clearColorGradientOrPattern = shouldCache && clearColor.__canvasGradient || (0, $1AEzH.getCanvasGradient)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                    clearColor.__width = width;
                    clearColor.__height = height;
                } else if ($2N6Uo.isImagePatternObject(clearColor)) {
                    clearColor.scaleX = clearColor.scaleX || dpr;
                    clearColor.scaleY = clearColor.scaleY || dpr;
                    clearColorGradientOrPattern = (0, $1zzSj.createCanvasPattern)(ctx, clearColor, {
                        dirty: function() {
                            self.setUnpainted();
                            self.painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $2N6Uo.each(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $5Uet9.default));
var $374831de8652c102$export$2e2bcd8739ae039 = $374831de8652c102$var$Layer;

});



parcelRegister("fB4Lq", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $b5ae01be1921a76d$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $aYEBl = parcelRequire("aYEBl");
function $b5ae01be1921a76d$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('svg', (0, $aYEBl.default));
}

});
parcelRegister("aYEBl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fdf009131739b39$export$2e2bcd8739ae039; });

var $9V5ol = parcelRequire("9V5ol");

var $4ugug = parcelRequire("4ugug");

var $hefUp = parcelRequire("hefUp");

var $2N6Uo = parcelRequire("2N6Uo");

var $84rBJ = parcelRequire("84rBJ");

var $1AEzH = parcelRequire("1AEzH");
var $7fdf009131739b39$var$svgId = 0;
var $7fdf009131739b39$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = 'svg';
        this.refreshHover = $7fdf009131739b39$var$createMethodNotSupport('refreshHover');
        this.configLayer = $7fdf009131739b39$var$createMethodNotSupport('configLayer');
        this.storage = storage;
        this._opts = opts = (0, $2N6Uo.extend)({}, opts);
        this.root = root;
        this._id = 'zr' + $7fdf009131739b39$var$svgId++;
        this._oldVNode = (0, $4ugug.createSVGVNode)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement('div');
            viewport.style.cssText = 'position:relative;overflow:hidden';
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $4ugug.createElement)('svg');
            (0, $84rBJ.updateAttrs)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
            (0, $84rBJ.default)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $9V5ol.brush)(el, (0, $4ugug.createBrushScope)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $4ugug.createBrushScope)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        scope.ssr = this._opts.ssr;
        var children = [];
        var bgVNode = this._bgVNode = $7fdf009131739b39$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $4ugug.createVNode)('g', 'main', {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $2N6Uo.map)((0, $2N6Uo.keys)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $4ugug.createVNode)('defs', 'defs', {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $4ugug.getCssString)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $4ugug.createVNode)('style', 'stl', {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $4ugug.createSVGVNode)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $4ugug.vNodeToString)(this.renderToVNode({
            animation: (0, $2N6Uo.retrieve2)(opts.cssAnimation, true),
            emphasis: (0, $2N6Uo.retrieve2)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $2N6Uo.retrieve2)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $9V5ol.setClipPath)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $4ugug.createVNode)('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $9V5ol.brush)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = 'none';
            width = (0, $1AEzH.getSize)(root, 0, opts);
            height = (0, $1AEzH.getSize)(root, 1, opts);
            viewport.style.display = '';
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
            }
            if (!(0, $hefUp.isPattern)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute('width', width);
                    svgDom.setAttribute('height', height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute('width', width);
                    bgEl.setAttribute('height', height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = '';
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = 'data:image/svg+xml;';
        if (base64) {
            str = (0, $hefUp.encodeBase64)(str);
            return str && prefix + 'base64,' + str;
        }
        return prefix + 'charset=UTF-8,' + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $7fdf009131739b39$var$createMethodNotSupport(method) {
    return function() {};
}
function $7fdf009131739b39$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== 'none') {
        bgVNode = (0, $4ugug.createVNode)('rect', 'bg', {
            width: width,
            height: height,
            x: '0',
            y: '0'
        });
        if ((0, $hefUp.isGradient)(backgroundColor)) (0, $9V5ol.setGradient)({
            fill: backgroundColor
        }, bgVNode.attrs, 'fill', scope);
        else if ((0, $hefUp.isPattern)(backgroundColor)) (0, $9V5ol.setPattern)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $2N6Uo.noop),
            getBoundingRect: function() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, 'fill', scope);
        else {
            var _a = (0, $hefUp.normalizeColor)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs['fill-opacity'] = opacity);
        }
    }
    return bgVNode;
}
var $7fdf009131739b39$export$2e2bcd8739ae039 = $7fdf009131739b39$var$SVGPainter;

});
parcelRegister("9V5ol", function(module, exports) {

$parcel$export(module.exports, "setGradient", function () { return $738d9e9893945211$export$afaa8352c6a43a44; });
$parcel$export(module.exports, "setPattern", function () { return $738d9e9893945211$export$faed90dbedc3b6d5; });
$parcel$export(module.exports, "brush", function () { return $738d9e9893945211$export$da5d6544e8c27bc1; });
$parcel$export(module.exports, "setClipPath", function () { return $738d9e9893945211$export$8f1d80b445d4fc; });

var $hefUp = parcelRequire("hefUp");

var $4oDJM = parcelRequire("4oDJM");

var $lQsZt = parcelRequire("lQsZt");

var $eVwLk = parcelRequire("eVwLk");

var $arPnl = parcelRequire("arPnl");

var $kiRIg = parcelRequire("kiRIg");

var $h9u2p = parcelRequire("h9u2p");

var $4ugug = parcelRequire("4ugug");

var $2N6Uo = parcelRequire("2N6Uo");

var $58ik8 = parcelRequire("58ik8");

var $5jsNO = parcelRequire("5jsNO");

var $kBKw3 = parcelRequire("kBKw3");

var $3WHoM = parcelRequire("3WHoM");

var $g7tyf = parcelRequire("g7tyf");

var $8rOrp = parcelRequire("8rOrp");
var $738d9e9893945211$var$round = Math.round;
function $738d9e9893945211$var$isImageLike(val) {
    return val && (0, $2N6Uo.isString)(val.src);
}
function $738d9e9893945211$var$isCanvasLike(val) {
    return val && (0, $2N6Uo.isFunction)(val.toDataURL);
}
function $738d9e9893945211$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $h9u2p.default)(function(key, val) {
        var isFillStroke = key === 'fill' || key === 'stroke';
        if (isFillStroke && (0, $hefUp.isGradient)(val)) $738d9e9893945211$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $hefUp.isPattern)(val)) $738d9e9893945211$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else attrs[key] = val;
        if (isFillStroke && scope.ssr && val === 'none') attrs['pointer-events'] = 'visible';
    }, style, el, false);
    $738d9e9893945211$var$setShadow(el, attrs, scope);
}
function $738d9e9893945211$var$setMetaData(attrs, el) {
    var metaData = (0, $8rOrp.getElementSSRData)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $4ugug.META_DATA_PREFIX) + key).toLowerCase()] = val + '');
        });
        if (el.isSilent()) attrs[(0, $4ugug.META_DATA_PREFIX) + 'silent'] = 'true';
    }
}
function $738d9e9893945211$var$noRotateScale(m) {
    return (0, $hefUp.isAroundZero)(m[0] - 1) && (0, $hefUp.isAroundZero)(m[1]) && (0, $hefUp.isAroundZero)(m[2]) && (0, $hefUp.isAroundZero)(m[3] - 1);
}
function $738d9e9893945211$var$noTranslate(m) {
    return (0, $hefUp.isAroundZero)(m[4]) && (0, $hefUp.isAroundZero)(m[5]);
}
function $738d9e9893945211$var$setTransform(attrs, m, compress) {
    if (m && !($738d9e9893945211$var$noTranslate(m) && $738d9e9893945211$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $738d9e9893945211$var$noRotateScale(m) ? "translate(" + $738d9e9893945211$var$round(m[4] * mul) / mul + " " + $738d9e9893945211$var$round(m[5] * mul) / mul + ")" : (0, $hefUp.getMatrixStr)(m);
    }
}
function $738d9e9893945211$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($738d9e9893945211$var$round(points[i][0] * mul) / mul);
        strArr.push($738d9e9893945211$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(' ');
}
function $738d9e9893945211$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $738d9e9893945211$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $2N6Uo.map)(desc, function(item) {
        return typeof item === 'string' ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $738d9e9893945211$var$round(val * mul) / mul;
        }
    };
}
var $738d9e9893945211$var$builtinShapesDef = {
    circle: [
        $738d9e9893945211$var$createAttrsConvert([
            'cx',
            'cy',
            'r'
        ])
    ],
    polyline: [
        $738d9e9893945211$var$convertPolyShape,
        $738d9e9893945211$var$validatePolyShape
    ],
    polygon: [
        $738d9e9893945211$var$convertPolyShape,
        $738d9e9893945211$var$validatePolyShape
    ]
};
function $738d9e9893945211$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === 'shape') return true;
    }
    return false;
}
function $738d9e9893945211$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $738d9e9893945211$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = 'path';
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $hefUp.getPathPrecision)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $738d9e9893945211$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $kiRIg.default)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $738d9e9893945211$var$setTransform(attrs, el.transform);
    $738d9e9893945211$var$setStyleAttrs(attrs, style, el, scope);
    $738d9e9893945211$var$setMetaData(attrs, el);
    scope.animation && (0, $5jsNO.createCSSAnimation)(el, attrs, scope);
    scope.emphasis && (0, $g7tyf.createCSSEmphasis)(el, attrs, scope);
    return (0, $4ugug.createVNode)(svgElType, el.id + '', attrs);
}
function $738d9e9893945211$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $2N6Uo.isString)(image)) {
        if ($738d9e9893945211$var$isImageLike(image)) image = image.src;
        else if ($738d9e9893945211$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $738d9e9893945211$var$setTransform(attrs, el.transform);
    $738d9e9893945211$var$setStyleAttrs(attrs, style, el, scope);
    $738d9e9893945211$var$setMetaData(attrs, el);
    scope.animation && (0, $5jsNO.createCSSAnimation)(el, attrs, scope);
    return (0, $4ugug.createVNode)('image', el.id + '', attrs);
}
function $738d9e9893945211$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += '');
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $3WHoM.DEFAULT_FONT);
    var x = style.x || 0;
    var y = (0, $hefUp.adjustTextY)(style.y || 0, (0, $eVwLk.getLineHeight)(font), style.textBaseline);
    var textAlign = (0, $hefUp.TEXT_ALIGN_TO_ANCHOR)[style.textAlign] || style.textAlign;
    var attrs = {
        'dominant-baseline': 'central',
        'text-anchor': textAlign
    };
    if ((0, $kBKw3.hasSeparateFont)(style)) {
        var separatedFontStr = '';
        var fontStyle = style.fontStyle;
        var fontSize = (0, $kBKw3.parseFontSize)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $3WHoM.DEFAULT_FONT_FAMILY);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== 'normal') separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== 'normal') separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs['xml:space'] = 'preserve';
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $738d9e9893945211$var$setTransform(attrs, el.transform);
    $738d9e9893945211$var$setStyleAttrs(attrs, style, el, scope);
    $738d9e9893945211$var$setMetaData(attrs, el);
    scope.animation && (0, $5jsNO.createCSSAnimation)(el, attrs, scope);
    return (0, $4ugug.createVNode)('text', el.id + '', attrs, undefined, text);
}
function $738d9e9893945211$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $4oDJM.default)) return $738d9e9893945211$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $lQsZt.default)) return $738d9e9893945211$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $arPnl.default)) return $738d9e9893945211$export$d506f5385e62a84a(el, scope);
}
function $738d9e9893945211$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $hefUp.hasShadow)(style)) {
        var shadowKey = (0, $hefUp.getShadowKey)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $hefUp.normalizeColor)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            shadowId = scope.zrId + '-s' + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $4ugug.createVNode)('filter', shadowId, {
                'id': shadowId,
                'x': '-100%',
                'y': '-100%',
                'width': '300%',
                'height': '300%'
            }, [
                (0, $4ugug.createVNode)('feDropShadow', '', {
                    'dx': offsetX / scaleX,
                    'dy': offsetY / scaleY,
                    'stdDeviation': stdDeviation,
                    'flood-color': color,
                    'flood-opacity': opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $hefUp.getIdURL)(shadowId);
    }
}
function $738d9e9893945211$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        'gradientUnits': val.global ? 'userSpaceOnUse' : 'objectBoundingBox'
    };
    if ((0, $hefUp.isLinearGradient)(val)) {
        gradientTag = 'linearGradient';
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $hefUp.isRadialGradient)(val)) {
        gradientTag = 'radialGradient';
        gradientAttrs.cx = (0, $2N6Uo.retrieve2)(val.x, 0.5);
        gradientAttrs.cy = (0, $2N6Uo.retrieve2)(val.y, 0.5);
        gradientAttrs.r = (0, $2N6Uo.retrieve2)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $hefUp.round4)(colors[i].offset) * 100 + '%';
        var stopColor = colors[i].color;
        var _a = (0, $hefUp.normalizeColor)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            'offset': offset
        };
        stopsAttrs['stop-color'] = color;
        if (opacity < 1) stopsAttrs['stop-opacity'] = opacity;
        colorStops.push((0, $4ugug.createVNode)('stop', i + '', stopsAttrs));
    }
    var gradientVNode = (0, $4ugug.createVNode)(gradientTag, '', gradientAttrs, colorStops);
    var gradientKey = (0, $4ugug.vNodeToString)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + '-g' + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $4ugug.createVNode)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $hefUp.getIdURL)(gradientId);
}
function $738d9e9893945211$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === 'no-repeat';
    var repeatX = repeat === 'repeat-x';
    var repeatY = repeat === 'repeat-y';
    var child;
    if ((0, $hefUp.isImagePattern)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $2N6Uo.isString)(patternImage)) imageSrc = patternImage;
        else if ($738d9e9893945211$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($738d9e9893945211$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === 'undefined') {
            var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
            (0, $2N6Uo.assert)(imageWidth_1, errMsg);
            (0, $2N6Uo.assert)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === 'pattern') {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute('width', width);
                        svgEl.setAttribute('height', height);
                    }
                }
            };
            var createdImage = (0, $58ik8.createOrUpdateImage)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $4ugug.createVNode)('image', 'img', {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $2N6Uo.clone)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = 'userSpaceOnUse';
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $hefUp.getSRTTransformString)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $4ugug.createVNode)('pattern', '', patternAttrs, [
        child
    ]);
    var patternKey = (0, $4ugug.vNodeToString)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + '-p' + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $4ugug.createVNode)('pattern', patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $hefUp.getIdURL)(patternId);
}
function $738d9e9893945211$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $4ugug.createVNode)('clipPath', clipPathId, clipPathAttrs, [
            $738d9e9893945211$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs['clip-path'] = (0, $hefUp.getIdURL)(clipPathId);
}

});
parcelRegister("kiRIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec7f275c195644e3$export$2e2bcd8739ae039; });

var $hefUp = parcelRequire("hefUp");
var $ec7f275c195644e3$var$mathSin = Math.sin;
var $ec7f275c195644e3$var$mathCos = Math.cos;
var $ec7f275c195644e3$var$PI = Math.PI;
var $ec7f275c195644e3$var$PI2 = Math.PI * 2;
var $ec7f275c195644e3$var$degree = 180 / $ec7f275c195644e3$var$PI;
var $ec7f275c195644e3$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = '';
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $hefUp.isAroundZero)(dThetaPositive - $ec7f275c195644e3$var$PI2) || (clockwise ? dTheta >= $ec7f275c195644e3$var$PI2 : -dTheta >= $ec7f275c195644e3$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $ec7f275c195644e3$var$PI2 : dTheta % $ec7f275c195644e3$var$PI2 + $ec7f275c195644e3$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $hefUp.isAroundZero)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $ec7f275c195644e3$var$PI === !!clockwise;
        var x0 = cx + rx * $ec7f275c195644e3$var$mathCos(startAngle);
        var y0 = cy + ry * $ec7f275c195644e3$var$mathSin(startAngle);
        if (this._start) this._add('M', x0, y0);
        var xRot = Math.round(psi * $ec7f275c195644e3$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($ec7f275c195644e3$var$PI2 - p);
            this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * $ec7f275c195644e3$var$mathCos(startAngle + dTheta_1), cy + ry * $ec7f275c195644e3$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $ec7f275c195644e3$var$mathCos(endAngle);
            var y = cy + ry * $ec7f275c195644e3$var$mathSin(endAngle);
            this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add('M', x, y);
        this._add('l', w, 0);
        this._add('l', 0, h);
        this._add('l', -w, 0);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add('Z');
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(' '));
        this._start = cmd === 'Z';
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? '' : this._d.join('');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $ec7f275c195644e3$export$2e2bcd8739ae039 = $ec7f275c195644e3$var$SVGPathRebuilder;

});

parcelRegister("h9u2p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7ca93d324b4d010$export$2e2bcd8739ae039; });

var $4oDJM = parcelRequire("4oDJM");

var $lQsZt = parcelRequire("lQsZt");

var $7c6cW = parcelRequire("7c6cW");

var $2N6Uo = parcelRequire("2N6Uo");

var $hefUp = parcelRequire("hefUp");
var $c7ca93d324b4d010$var$NONE = 'none';
var $c7ca93d324b4d010$var$mathRound = Math.round;
function $c7ca93d324b4d010$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $c7ca93d324b4d010$var$NONE;
}
function $c7ca93d324b4d010$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $c7ca93d324b4d010$var$NONE;
}
var $c7ca93d324b4d010$var$strokeProps = [
    'lineCap',
    'miterLimit',
    'lineJoin'
];
var $c7ca93d324b4d010$var$svgStrokeProps = (0, $2N6Uo.map)($c7ca93d324b4d010$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $c7ca93d324b4d010$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $lQsZt.default)) {
        updateAttr('opacity', opacity);
        return;
    }
    if ($c7ca93d324b4d010$var$pathHasFill(style)) {
        var fill = (0, $hefUp.normalizeColor)(style.fill);
        updateAttr('fill', fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr('fill-opacity', fillOpacity);
    } else updateAttr('fill', $c7ca93d324b4d010$var$NONE);
    if ($c7ca93d324b4d010$var$pathHasStroke(style)) {
        var stroke = (0, $hefUp.normalizeColor)(style.stroke);
        updateAttr('stroke', stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr('stroke-width', strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
        if (forceUpdate || strokeOpacity < 1) updateAttr('stroke-opacity', strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $7c6cW.getLineDash)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $c7ca93d324b4d010$var$mathRound(lineDashOffset || 0);
                updateAttr('stroke-dasharray', lineDash.join(','));
                if (lineDashOffset || forceUpdate) updateAttr('stroke-dashoffset', lineDashOffset);
            }
        } else if (forceUpdate) updateAttr('stroke-dasharray', $c7ca93d324b4d010$var$NONE);
        for(var i = 0; i < $c7ca93d324b4d010$var$strokeProps.length; i++){
            var propName = $c7ca93d324b4d010$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $4oDJM.DEFAULT_PATH_STYLE)[propName]) {
                var val = style[propName] || (0, $4oDJM.DEFAULT_PATH_STYLE)[propName];
                val && updateAttr($c7ca93d324b4d010$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr('stroke', $c7ca93d324b4d010$var$NONE);
}

});

parcelRegister("4ugug", function(module, exports) {

$parcel$export(module.exports, "XLINKNS", function () { return $3446c0c6ff80943d$export$b22c6da1792ecec8; });
$parcel$export(module.exports, "XMLNS", function () { return $3446c0c6ff80943d$export$fac09d762d15fa3b; });
$parcel$export(module.exports, "XML_NAMESPACE", function () { return $3446c0c6ff80943d$export$ad4c4fdecd3b4156; });
$parcel$export(module.exports, "META_DATA_PREFIX", function () { return $3446c0c6ff80943d$export$d3f79611f155197c; });
$parcel$export(module.exports, "createElement", function () { return $3446c0c6ff80943d$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createVNode", function () { return $3446c0c6ff80943d$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "vNodeToString", function () { return $3446c0c6ff80943d$export$f5c4a9a0e027f2b; });
$parcel$export(module.exports, "getCssString", function () { return $3446c0c6ff80943d$export$e2b4f3597c7a7dcb; });
$parcel$export(module.exports, "createBrushScope", function () { return $3446c0c6ff80943d$export$96fee5f38ed01741; });
$parcel$export(module.exports, "createSVGVNode", function () { return $3446c0c6ff80943d$export$5529a6aad332ee75; });

var $2N6Uo = parcelRequire("2N6Uo");

var $dhQnW = parcelRequire("dhQnW");
var $3446c0c6ff80943d$export$a690ad4c9a38f86e = 'http://www.w3.org/2000/svg';
var $3446c0c6ff80943d$export$b22c6da1792ecec8 = 'http://www.w3.org/1999/xlink';
var $3446c0c6ff80943d$export$fac09d762d15fa3b = 'http://www.w3.org/2000/xmlns/';
var $3446c0c6ff80943d$export$ad4c4fdecd3b4156 = 'http://www.w3.org/XML/1998/namespace';
var $3446c0c6ff80943d$export$d3f79611f155197c = 'ecmeta_';
function $3446c0c6ff80943d$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($3446c0c6ff80943d$export$a690ad4c9a38f86e, name);
}
function $3446c0c6ff80943d$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $3446c0c6ff80943d$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += "=\"" + val + "\"";
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(' ') + ">";
}
function $3446c0c6ff80943d$var$createElementClose(name) {
    return "</" + name + ">";
}
function $3446c0c6ff80943d$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $3446c0c6ff80943d$var$createElementOpen(tag, attrs) + (tag !== 'style' ? (0, $dhQnW.encodeHTML)(text) : text || '') + (children ? "" + S + (0, $2N6Uo.map)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : '') + $3446c0c6ff80943d$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $3446c0c6ff80943d$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $2N6Uo.map)((0, $2N6Uo.keys)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $2N6Uo.map)((0, $2N6Uo.keys)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $2N6Uo.map)((0, $2N6Uo.keys)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $2N6Uo.map)((0, $2N6Uo.keys)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $2N6Uo.map)((0, $2N6Uo.keys)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === 'd') val = "path(\"" + val + "\")";
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return '';
    return [
        '<![CDATA[',
        selectors,
        animations,
        ']]>'
    ].join(S);
}
function $3446c0c6ff80943d$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $3446c0c6ff80943d$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $3446c0c6ff80943d$export$bf5c4cf060303d58('svg', 'root', {
        'width': width,
        'height': height,
        'xmlns': $3446c0c6ff80943d$export$a690ad4c9a38f86e,
        'xmlns:xlink': $3446c0c6ff80943d$export$b22c6da1792ecec8,
        'version': '1.1',
        'baseProfile': 'full',
        'viewBox': useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}

});

parcelRegister("5jsNO", function(module, exports) {

$parcel$export(module.exports, "createCSSAnimation", function () { return $3de511a6b06b1526$export$dc9722e37397d426; });

var $erz95 = parcelRequire("erz95");

var $4ugug = parcelRequire("4ugug");

var $kiRIg = parcelRequire("kiRIg");

var $eAFw0 = parcelRequire("eAFw0");

var $hefUp = parcelRequire("hefUp");

var $2N6Uo = parcelRequire("2N6Uo");

var $5JZmf = parcelRequire("5JZmf");

var $8n2Ny = parcelRequire("8n2Ny");

var $jaHHm = parcelRequire("jaHHm");
var $3de511a6b06b1526$export$54ee1847795bcf37 = {
    cubicIn: '0.32,0,0.67,0',
    cubicOut: '0.33,1,0.68,1',
    cubicInOut: '0.65,0,0.35,1',
    quadraticIn: '0.11,0,0.5,0',
    quadraticOut: '0.5,1,0.89,1',
    quadraticInOut: '0.45,0,0.55,1',
    quarticIn: '0.5,0,0.75,0',
    quarticOut: '0.25,1,0.5,1',
    quarticInOut: '0.76,0,0.24,1',
    quinticIn: '0.64,0,0.78,0',
    quinticOut: '0.22,1,0.36,1',
    quinticInOut: '0.83,0,0.17,1',
    sinusoidalIn: '0.12,0,0.39,0',
    sinusoidalOut: '0.61,1,0.88,1',
    sinusoidalInOut: '0.37,0,0.63,1',
    exponentialIn: '0.7,0,0.84,0',
    exponentialOut: '0.16,1,0.3,1',
    exponentialInOut: '0.87,0,0.13,1',
    circularIn: '0.55,0,1,0.45',
    circularOut: '0,0.55,0.45,1',
    circularInOut: '0.85,0,0.15,1'
};
var $3de511a6b06b1526$var$transformOriginKey = 'transform-origin';
function $3de511a6b06b1526$var$buildPathString(el, kfShape, path) {
    var shape = (0, $2N6Uo.extend)({}, el.shape);
    (0, $2N6Uo.extend)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $kiRIg.default)();
    svgPathBuilder.reset((0, $hefUp.getPathPrecision)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $3de511a6b06b1526$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$3de511a6b06b1526$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $3de511a6b06b1526$export$f0dede2064ee89d7 = {
    fill: 'fill',
    opacity: 'opacity',
    lineWidth: 'stroke-width',
    lineDashOffset: 'stroke-dashoffset'
};
function $3de511a6b06b1526$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $3de511a6b06b1526$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $2N6Uo.each)(paths, function(path) {
        var subScope = (0, $4ugug.createBrushScope)(scope.zrId);
        subScope.animation = true;
        $3de511a6b06b1526$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $2N6Uo.keys)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ''
            };
            composedAnim[percent].d += kf.d || '';
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $3de511a6b06b1526$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $3de511a6b06b1526$var$getEasingFunc(easing) {
    return (0, $2N6Uo.isString)(easing) ? $3de511a6b06b1526$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $3de511a6b06b1526$export$54ee1847795bcf37[easing] + ")" : (0, $8n2Ny.createCubicEasingFunc)(easing) ? easing : '' : '';
}
function $3de511a6b06b1526$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $5JZmf.default)) {
        var animationCfg = $3de511a6b06b1526$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + 's'
        ];
        var easing = $3de511a6b06b1526$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push('linear');
        if (delay) cfgArr.push(delay / 1000 + 's');
        if (animator.getLoop()) cfgArr.push('infinite');
        var cfg = cfgArr.join(' ');
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = 'animation-timing-function';
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + '%';
                        var kfEasing = $3de511a6b06b1526$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $2N6Uo.isString)(rawValue) || (0, $2N6Uo.isNumber)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === 'shape') saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $erz95.copyTransform)(transform, el);
            (0, $2N6Uo.extend)(transform, transformKfs[percent]);
            var str = (0, $hefUp.getSRTTransformString)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $3de511a6b06b1526$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $eAFw0.default)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $3de511a6b06b1526$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === 'style') saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $3de511a6b06b1526$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $2N6Uo.keys)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$3de511a6b06b1526$var$transformOriginKey] !== finalKfs[p1][$3de511a6b06b1526$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$3de511a6b06b1526$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$3de511a6b06b1526$var$transformOriginKey]) delete finalKfs[percent][$3de511a6b06b1526$var$transformOriginKey];
            attrs[$3de511a6b06b1526$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $2N6Uo.filter)(percents, function(percent) {
            return (0, $2N6Uo.keys)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $3de511a6b06b1526$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + '-cls-' + (0, $jaHHm.getClassId)();
        scope.cssNodes['.' + className] = {
            animation: cssAnimations.join(',')
        };
        attrs["class"] = className;
    }
}

});
parcelRegister("jaHHm", function(module, exports) {

$parcel$export(module.exports, "getClassId", function () { return $df50d90f2ff4dae6$export$9c80c36b7367fb56; });
var $df50d90f2ff4dae6$var$cssClassIdx = 0;
function $df50d90f2ff4dae6$export$9c80c36b7367fb56() {
    return $df50d90f2ff4dae6$var$cssClassIdx++;
}

});


parcelRegister("g7tyf", function(module, exports) {

$parcel$export(module.exports, "createCSSEmphasis", function () { return $bbc43915a9c9827b$export$b4c8f742d3cb22ba; });

var $3UxDF = parcelRequire("3UxDF");

var $jaHHm = parcelRequire("jaHHm");
function $bbc43915a9c9827b$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                'pointer-events': 'none'
            };
            $bbc43915a9c9827b$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf('select') >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $3UxDF.liftColor)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: 'pointer'
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style['stroke-width'] = lineWidth;
            $bbc43915a9c9827b$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $bbc43915a9c9827b$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + '-cls-' + (0, $jaHHm.getClassId)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes['.' + className + (withHover ? ':hover' : '')] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + ' ' + className : className;
}

});


parcelRegister("84rBJ", function(module, exports) {

$parcel$export(module.exports, "updateAttrs", function () { return $5e041cbbe7d6a25e$export$277dcc6f06048f24; });
$parcel$export(module.exports, "default", function () { return $5e041cbbe7d6a25e$export$2e2bcd8739ae039; });

var $2N6Uo = parcelRequire("2N6Uo");

var $4ugug = parcelRequire("4ugug");

var $4khq1 = parcelRequire("4khq1");
var $5e041cbbe7d6a25e$var$colonChar = 58;
var $5e041cbbe7d6a25e$var$xChar = 120;
var $5e041cbbe7d6a25e$var$emptyNode = (0, $4ugug.createVNode)('', '');
function $5e041cbbe7d6a25e$var$isUndef(s) {
    return s === undefined;
}
function $5e041cbbe7d6a25e$var$isDef(s) {
    return s !== undefined;
}
function $5e041cbbe7d6a25e$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $5e041cbbe7d6a25e$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $5e041cbbe7d6a25e$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($5e041cbbe7d6a25e$var$isDef(tag)) {
        var elm = vnode.elm = (0, $4ugug.createElement)(tag);
        $5e041cbbe7d6a25e$export$277dcc6f06048f24($5e041cbbe7d6a25e$var$emptyNode, vnode);
        if ((0, $2N6Uo.isArray)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $4khq1.appendChild(elm, $5e041cbbe7d6a25e$var$createElm(ch));
        }
        else if ($5e041cbbe7d6a25e$var$isDef(vnode.text) && !(0, $2N6Uo.isObject)(vnode.text)) $4khq1.appendChild(elm, $4khq1.createTextNode(vnode.text));
    } else vnode.elm = $4khq1.createTextNode(vnode.text);
    return vnode.elm;
}
function $5e041cbbe7d6a25e$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $4khq1.insertBefore(parentElm, $5e041cbbe7d6a25e$var$createElm(ch), before);
    }
}
function $5e041cbbe7d6a25e$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($5e041cbbe7d6a25e$var$isDef(ch.tag)) {
                var parent_1 = $4khq1.parentNode(ch.elm);
                $4khq1.removeChild(parent_1, ch.elm);
            } else $4khq1.removeChild(parentElm, ch.elm);
        }
    }
}
function $5e041cbbe7d6a25e$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, '');
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === 'style') elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $5e041cbbe7d6a25e$var$xChar) elm.setAttribute(key, cur);
                else if (key === 'xmlns:xlink' || key === 'xmlns') elm.setAttributeNS((0, $4ugug.XMLNS), key, cur);
                else if (key.charCodeAt(3) === $5e041cbbe7d6a25e$var$colonChar) elm.setAttributeNS((0, $4ugug.XML_NAMESPACE), key, cur);
                else if (key.charCodeAt(5) === $5e041cbbe7d6a25e$var$colonChar) elm.setAttributeNS((0, $4ugug.XLINKNS), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $5e041cbbe7d6a25e$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($5e041cbbe7d6a25e$var$sameVnode(oldStartVnode, newStartVnode)) {
            $5e041cbbe7d6a25e$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($5e041cbbe7d6a25e$var$sameVnode(oldEndVnode, newEndVnode)) {
            $5e041cbbe7d6a25e$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($5e041cbbe7d6a25e$var$sameVnode(oldStartVnode, newEndVnode)) {
            $5e041cbbe7d6a25e$var$patchVnode(oldStartVnode, newEndVnode);
            $4khq1.insertBefore(parentElm, oldStartVnode.elm, $4khq1.nextSibling(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($5e041cbbe7d6a25e$var$sameVnode(oldEndVnode, newStartVnode)) {
            $5e041cbbe7d6a25e$var$patchVnode(oldEndVnode, newStartVnode);
            $4khq1.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($5e041cbbe7d6a25e$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $5e041cbbe7d6a25e$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($5e041cbbe7d6a25e$var$isUndef(idxInOld)) $4khq1.insertBefore(parentElm, $5e041cbbe7d6a25e$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $4khq1.insertBefore(parentElm, $5e041cbbe7d6a25e$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $5e041cbbe7d6a25e$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $4khq1.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $5e041cbbe7d6a25e$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $5e041cbbe7d6a25e$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $5e041cbbe7d6a25e$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $5e041cbbe7d6a25e$export$277dcc6f06048f24(oldVnode, vnode);
    if ($5e041cbbe7d6a25e$var$isUndef(vnode.text)) {
        if ($5e041cbbe7d6a25e$var$isDef(oldCh) && $5e041cbbe7d6a25e$var$isDef(ch)) {
            if (oldCh !== ch) $5e041cbbe7d6a25e$var$updateChildren(elm, oldCh, ch);
        } else if ($5e041cbbe7d6a25e$var$isDef(ch)) {
            if ($5e041cbbe7d6a25e$var$isDef(oldVnode.text)) $4khq1.setTextContent(elm, '');
            $5e041cbbe7d6a25e$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($5e041cbbe7d6a25e$var$isDef(oldCh)) $5e041cbbe7d6a25e$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($5e041cbbe7d6a25e$var$isDef(oldVnode.text)) $4khq1.setTextContent(elm, '');
    } else if (oldVnode.text !== vnode.text) {
        if ($5e041cbbe7d6a25e$var$isDef(oldCh)) $5e041cbbe7d6a25e$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $4khq1.setTextContent(elm, vnode.text);
    }
}
function $5e041cbbe7d6a25e$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($5e041cbbe7d6a25e$var$sameVnode(oldVnode, vnode)) $5e041cbbe7d6a25e$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $4khq1.parentNode(elm);
        $5e041cbbe7d6a25e$var$createElm(vnode);
        if (parent_2 !== null) {
            $4khq1.insertBefore(parent_2, vnode.elm, $4khq1.nextSibling(elm));
            $5e041cbbe7d6a25e$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}

});
parcelRegister("4khq1", function(module, exports) {

$parcel$export(module.exports, "createTextNode", function () { return $32668aa93835beef$export$b2ce9ad90858ed7a; });
$parcel$export(module.exports, "insertBefore", function () { return $32668aa93835beef$export$86b68c7dbeb53c22; });
$parcel$export(module.exports, "removeChild", function () { return $32668aa93835beef$export$7ae609f7af59e4f7; });
$parcel$export(module.exports, "appendChild", function () { return $32668aa93835beef$export$1b8e57c9ea42f1d2; });
$parcel$export(module.exports, "parentNode", function () { return $32668aa93835beef$export$b54be7ce267a037b; });
$parcel$export(module.exports, "nextSibling", function () { return $32668aa93835beef$export$335219007e689d29; });
$parcel$export(module.exports, "setTextContent", function () { return $32668aa93835beef$export$94b0296cab6203e; });
function $32668aa93835beef$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $32668aa93835beef$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $32668aa93835beef$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $32668aa93835beef$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $32668aa93835beef$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $32668aa93835beef$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $32668aa93835beef$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $32668aa93835beef$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $32668aa93835beef$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $32668aa93835beef$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $32668aa93835beef$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $32668aa93835beef$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $32668aa93835beef$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}

});




parcelRegister("hAJpt", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $cce905e596e4a23e$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $5qNR7 = parcelRequire("5qNR7");

var $dx8xl = parcelRequire("dx8xl");

var $64KHP = parcelRequire("64KHP");

var $5wQh9 = parcelRequire("5wQh9");
function $cce905e596e4a23e$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $5wQh9.default));
    registers.registerSeriesModel((0, $64KHP.default));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $2N6Uo.curry((0, $5qNR7.layout), 'bar'));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $5qNR7.createProgressiveLayout)('bar'));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $dx8xl.default)('bar'));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'changeAxisOrder',
        event: 'changeAxisOrder',
        update: 'update'
    }, function(payload, ecModel) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}

});
parcelRegister("5qNR7", function(module, exports) {

$parcel$export(module.exports, "getLayoutOnAxis", function () { return $3f460dc3f428589c$export$658df087977b9e84; });
$parcel$export(module.exports, "prepareLayoutBarSeries", function () { return $3f460dc3f428589c$export$efbd0c3f5ab0d5e4; });
$parcel$export(module.exports, "makeColumnLayout", function () { return $3f460dc3f428589c$export$20769dafc84e0299; });
$parcel$export(module.exports, "retrieveColumnLayout", function () { return $3f460dc3f428589c$export$35920bb6556da1c2; });
$parcel$export(module.exports, "layout", function () { return $3f460dc3f428589c$export$b3219800bda33a1f; });
$parcel$export(module.exports, "createProgressiveLayout", function () { return $3f460dc3f428589c$export$16e8685758531cb6; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");

var $a1eW0 = parcelRequire("a1eW0");

var $Uomg7 = parcelRequire("Uomg7");

var $hp8dQ = parcelRequire("hp8dQ");
var $3f460dc3f428589c$var$STACK_PREFIX = '__ec_stack_';
function $3f460dc3f428589c$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $3f460dc3f428589c$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $3f460dc3f428589c$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $3f460dc3f428589c$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = 'axis0';
    if (baseAxis.type !== 'category') return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $2N6Uo.defaults)({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $3f460dc3f428589c$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $3f460dc3f428589c$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$3f460dc3f428589c$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $3f460dc3f428589c$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($3f460dc3f428589c$var$isOnCartesian(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $3f460dc3f428589c$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    (0, $2N6Uo.each)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + '_' + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
        // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            }
            // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $3f460dc3f428589c$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $3f460dc3f428589c$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    (0, $2N6Uo.each)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
            var key = baseAxis.dim + '_' + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $iCU10.parsePercent)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $iCU10.parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
        var barMinWidth = (0, $iCU10.parsePercent)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
        // the auto-calculated bar width might be less than 0.5 / 1.
        seriesModel.get('barMinWidth') || ($3f460dc3f428589c$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        var defaultBarGap = seriesModel.get('defaultBarGap');
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            defaultBarGap: defaultBarGap,
            axisKey: $3f460dc3f428589c$var$getAxisKey(baseAxis),
            stackId: $3f460dc3f428589c$var$getSeriesStackId(seriesModel)
        });
    });
    return $3f460dc3f428589c$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $3f460dc3f428589c$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    (0, $2N6Uo.each)(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: seriesInfo.defaultBarGap || 0,
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    (0, $2N6Uo.each)(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = (0, $2N6Uo.keys)(stacks).length;
            // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
        }
        var categoryGap = (0, $iCU10.parsePercent)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $iCU10.parsePercent)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        (0, $2N6Uo.each)(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                // `minWidth` has higher priority. `minWidth` decide that whether the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Because barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        (0, $2N6Uo.each)(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        (0, $2N6Uo.each)(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $3f460dc3f428589c$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$3f460dc3f428589c$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$3f460dc3f428589c$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $3f460dc3f428589c$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $3f460dc3f428589c$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $3f460dc3f428589c$export$20769dafc84e0299(seriesModels);
    (0, $2N6Uo.each)(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $3f460dc3f428589c$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$3f460dc3f428589c$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
    });
}
function $3f460dc3f428589c$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $Uomg7.default)(),
        reset: function(seriesModel) {
            if (!$3f460dc3f428589c$var$isOnCartesian(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get('showBackground', true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            var stacked = (0, $a1eW0.isDimensionStacked)(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $3f460dc3f428589c$var$getValueAxisStart(baseAxis, valueAxis);
            var isLarge = $3f460dc3f428589c$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout('size');
            var columnOffset = data.getLayout('offset');
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $hp8dQ.createFloat32Array)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $hp8dQ.createFloat32Array)(count * 3);
                    var largeDataIndices = isLarge && (0, $hp8dQ.createFloat32Array)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var stackStartValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) stackStartValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    stackStartValue,
                                    baseValue
                                ]);
                                baseCoord = startCoord[0];
                            }
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    baseValue,
                                    stackStartValue
                                ]);
                                baseCoord = startCoord[1];
                            }
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $3f460dc3f428589c$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $3f460dc3f428589c$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
// See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $3f460dc3f428589c$var$getValueAxisStart(baseAxis, valueAxis) {
    var startValue = valueAxis.model.get('startValue');
    if (!startValue) startValue = 0;
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? startValue > 0 ? startValue : 1 : startValue));
}

});
parcelRegister("a1eW0", function(module, exports) {

$parcel$export(module.exports, "enableDataStack", function () { return $74b59510214518ce$export$f2165f9e8499b278; });
$parcel$export(module.exports, "isDimensionStacked", function () { return $74b59510214518ce$export$1dedc39359ae35c; });
$parcel$export(module.exports, "getStackedDimension", function () { return $74b59510214518ce$export$909db2be4938fbdf; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bBWDH = parcelRequire("bBWDH");
function $74b59510214518ce$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($74b59510214518ce$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $2N6Uo.each)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $2N6Uo.isString)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
    // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $2N6Uo.each)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $74b59510214518ce$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $bBWDH.isSeriesDataSchema)(dimensionsInput.schema);
}
function $74b59510214518ce$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $74b59510214518ce$export$909db2be4938fbdf(data, targetDim) {
    return $74b59510214518ce$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

});
parcelRegister("bBWDH", function(module, exports) {

$parcel$export(module.exports, "SeriesDataSchema", function () { return $8740a2f924721ad9$export$a1ef064685775f3e; });
$parcel$export(module.exports, "ensureSourceDimNameMap", function () { return $8740a2f924721ad9$export$be39ae17310c33f7; });
$parcel$export(module.exports, "shouldOmitUnusedDimensions", function () { return $8740a2f924721ad9$export$238b87930d825d87; });
$parcel$export(module.exports, "isSeriesDataSchema", function () { return $8740a2f924721ad9$export$fafbc856132a3a0e; });
$parcel$export(module.exports, "createDimNameMap", function () { return $8740a2f924721ad9$export$a477f5bebfd07944; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $9Pasn = parcelRequire("9Pasn");
var $8740a2f924721ad9$var$inner = (0, $bx3T8.makeInner)();
var $8740a2f924721ad9$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $8740a2f924721ad9$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $8740a2f924721ad9$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $2N6Uo.retrieve2)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $9Pasn.shouldRetrieveDataByName)(this.source);
        var makeHashStrict = !$8740a2f924721ad9$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
            dimHash += '$';
            dimHash += $8740a2f924721ad9$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $8740a2f924721ad9$export$fafbc856132a3a0e(schema) {
    return schema instanceof $8740a2f924721ad9$export$a1ef064685775f3e;
}
function $8740a2f924721ad9$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $2N6Uo.createHashMap)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $2N6Uo.isObject)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $8740a2f924721ad9$export$be39ae17310c33f7(source) {
    var innerSource = $8740a2f924721ad9$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $8740a2f924721ad9$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $8740a2f924721ad9$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}

});


parcelRegister("hp8dQ", function(module, exports) {

$parcel$export(module.exports, "createFloat32Array", function () { return $cabb2640dd0ab8ed$export$21d2298f3f56bbaf; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
/* global Float32Array */ var $cabb2640dd0ab8ed$var$supportFloat32Array = typeof Float32Array !== 'undefined';
var $cabb2640dd0ab8ed$var$Float32ArrayCtor = !$cabb2640dd0ab8ed$var$supportFloat32Array ? Array : Float32Array;
function $cabb2640dd0ab8ed$export$21d2298f3f56bbaf(arg) {
    if ((0, $2N6Uo.isArray)(arg)) // Return self directly if don't support TypedArray.
    return $cabb2640dd0ab8ed$var$supportFloat32Array ? new Float32Array(arg) : arg;
    // Else is number
    return new $cabb2640dd0ab8ed$var$Float32ArrayCtor(arg);
}

});


parcelRegister("dx8xl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9da4faae28403aa4$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $9da4faae28403aa4$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $9da4faae28403aa4$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $9da4faae28403aa4$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    else if (sampling === 'minmax') seriesModel.setData(data.minmaxDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $2N6Uo.isString)(sampling)) sampler = $9da4faae28403aa4$var$samplers[sampling];
                    else if ((0, $2N6Uo.isFunction)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $9da4faae28403aa4$var$indexSampler));
                }
            }
        }
    };
}

});

parcelRegister("64KHP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46c758a4673c7621$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $3tTpJ = parcelRequire("3tTpJ");

var $dOrFN = parcelRequire("dOrFN");

var $cKPmR = parcelRequire("cKPmR");

var $6aXXD = parcelRequire("6aXXD");
var $46c758a4673c7621$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $dOrFN.default)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get('realtimeSort', true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get('large') ? this.get('progressive') : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get('progressiveThreshold');
        var largeThreshold = this.get('largeThreshold');
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = 'series.bar';
    BarSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    BarSeriesModel.defaultOption = (0, $cKPmR.inheritDefaultOption)((0, $3tTpJ.default).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            borderColor: null,
            borderWidth: 0,
            borderType: 'solid',
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: (0, $6aXXD.default).color.primary,
                borderWidth: 2
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $3tTpJ.default));
var $46c758a4673c7621$export$2e2bcd8739ae039 = $46c758a4673c7621$var$BarSeriesModel;

});
parcelRegister("3tTpJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $288f109a2e56bd65$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $dOrFN = parcelRequire("dOrFN");

var $2N6Uo = parcelRequire("2N6Uo");
var $288f109a2e56bd65$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $dOrFN.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $2N6Uo.each)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === 'category' && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get('alignWithLabel');
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === 'x1' || dims[idx] === 'y1';
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout('offset');
                var size = data.getLayout('size');
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = 'series.__base_bar__';
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: 'mod',
        defaultBarGap: '10%'
    };
    return BaseBarSeriesModel;
}((0, $49X8G.default));
(0, $49X8G.default).registerClass($288f109a2e56bd65$var$BaseBarSeriesModel);
var $288f109a2e56bd65$export$2e2bcd8739ae039 = $288f109a2e56bd65$var$BaseBarSeriesModel;

});
parcelRegister("dOrFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0e56933b90840ad$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $2kN4z = parcelRequire("2kN4z");

var $59bDW = parcelRequire("59bDW");

var $fmOlY = parcelRequire("fmOlY");

var $bx3T8 = parcelRequire("bx3T8");

var $hIXrb = parcelRequire("hIXrb");

var $8jIky = parcelRequire("8jIky");

var $9Pasn = parcelRequire("9Pasn");

var $a1eW0 = parcelRequire("a1eW0");

var $6VFOB = parcelRequire("6VFOB");

var $eKQ6A = parcelRequire("eKQ6A");
function $a0e56933b90840ad$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $hIXrb.default).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $2N6Uo.map(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $fmOlY.getDimensionTypeByAxis)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $a0e56933b90840ad$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $2N6Uo.each(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $a0e56933b90840ad$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $9Pasn.createSourceFromSeriesDataOption)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL);
    }
    var coordSysInfo = (0, $8jIky.getCoordSysInfoBySeries)(seriesModel);
    var coordSysDimDefs = $a0e56933b90840ad$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $2N6Uo.isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $2N6Uo.curry((0, $6VFOB.makeSeriesEncodeForAxisCoordSys), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $59bDW.default)(source, createDimensionOptions);
    var firstCategoryDimIndex = $a0e56933b90840ad$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $a1eW0.enableDataStack)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $2kN4z.default)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $a0e56933b90840ad$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $a0e56933b90840ad$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL)) {
        var sampleItem = $a0e56933b90840ad$var$firstDataNotNull(source.data || []);
        return !$2N6Uo.isArray((0, $bx3T8.getDataItemValue)(sampleItem));
    }
}
function $a0e56933b90840ad$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $a0e56933b90840ad$export$2e2bcd8739ae039 = $a0e56933b90840ad$var$createSeriesData;

});
parcelRegister("2kN4z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b3383debd740561$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 
var $2N6Uo = parcelRequire("2N6Uo");

var $b8YKU = parcelRequire("b8YKU");

var $chf3v = parcelRequire("chf3v");

var $bA99G = parcelRequire("bA99G");

var $fmOlY = parcelRequire("fmOlY");

var $hzkG7 = parcelRequire("hzkG7");

var $eKQ6A = parcelRequire("eKQ6A");

var $bx3T8 = parcelRequire("bx3T8");

var $6TSUP = parcelRequire("6TSUP");

var $9Pasn = parcelRequire("9Pasn");

var $4ToKq = parcelRequire("4ToKq");

var $bBWDH = parcelRequire("bBWDH");
var $1b3383debd740561$var$isObject = $2N6Uo.isObject;
var $1b3383debd740561$var$map = $2N6Uo.map;
var $1b3383debd740561$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $1b3383debd740561$var$ID_PREFIX = 'e\0\0';
var $1b3383debd740561$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $1b3383debd740561$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $1b3383debd740561$var$CLONE_PROPERTIES = [
    '_approximateExtent'
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $1b3383debd740561$var$prepareInvertedIndex;
var $1b3383debd740561$var$getId;
var $1b3383debd740561$var$getIdNameFromStore;
var $1b3383debd740561$var$normalizeDimensions;
var $1b3383debd740561$var$transferProperties;
var $1b3383debd740561$var$cloneListForMapAndSample;
var $1b3383debd740561$var$makeIdFromName;
var $1b3383debd740561$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'minmaxDownSample',
            'lttbDownSample',
            'map'
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'minmaxDownSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $bBWDH.isSeriesDataSchema)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $2N6Uo.isString(dimInfoInput) ? new (0, $hzkG7.default)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $hzkG7.default)) ? new (0, $hzkG7.default)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            var dimIdx = i;
            if ($2N6Uo.isNumber(dimensionInfo.storeDimIndex)) dimIdx = dimensionInfo.storeDimIndex;
            if (otherDims.itemName === 0) this._nameDimIdx = dimIdx;
            if (otherDims.itemId === 0) this._idDimIdx = dimIdx;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $2N6Uo.createHashMap();
            $2N6Uo.each(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($2N6Uo.isNumber(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $4ToKq.default)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $9Pasn.isSourceInstance)(data) || $2N6Uo.isArrayLike(data) ? new (0, $bA99G.DefaultDataProvider)(data, dimensions.length) : data;
            store = new (0, $4ToKq.default)();
            var dimensionInfos = $1b3383debd740561$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $fmOlY.summarizeDimensions)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names && names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $1b3383debd740561$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $eKQ6A.SOURCE_FORMAT_TYPED_ARRAY) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $eKQ6A.SOURCE_FORMAT_ORIGINAL);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $bx3T8.isDataItemOption)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $bx3T8.convertOptionIdName)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $bx3T8.convertOptionIdName)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$1b3383debd740561$var$makeIdFromName(this, idx);
        $1b3383debd740561$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $1b3383debd740561$var$isObject(key) ? $2N6Uo.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $1b3383debd740561$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $1b3383debd740561$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $2N6Uo.isArray(dimensions) ? store.getValues($1b3383debd740561$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices && invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $1b3383debd740561$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if ($2N6Uo.isFunction(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $1b3383debd740561$var$map($1b3383debd740561$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $2N6Uo.bind(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if ($2N6Uo.isFunction(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $1b3383debd740561$var$map($1b3383debd740561$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $2N6Uo.bind(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $2N6Uo.keys(range);
        var dimIndices = [];
        $2N6Uo.each(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if ($2N6Uo.isFunction(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict';
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $1b3383debd740561$var$map($1b3383debd740561$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $1b3383debd740561$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $2N6Uo.bind(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $1b3383debd740561$var$map($1b3383debd740561$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $2N6Uo.bind(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $1b3383debd740561$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ SeriesData.prototype.minmaxDownSample = function(valueDimension, rate) {
        var list = $1b3383debd740561$var$cloneListForMapAndSample(this);
        list._store = this._store.minmaxDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $1b3383debd740561$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $b8YKU.default)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $chf3v.default)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $1b3383debd740561$var$getId(otherList, idx);
        }, function(idx) {
            return $1b3383debd740561$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($1b3383debd740561$var$isObject(kvObj)) $2N6Uo.extend(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($2N6Uo.isArray(val)) val = val.slice();
            else if ($1b3383debd740561$var$isObject(val)) val = $2N6Uo.extend({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($1b3383debd740561$var$isObject(key)) $2N6Uo.extend(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $1b3383debd740561$var$isObject(key) ? $2N6Uo.extend(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $2N6Uo.extend(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $6TSUP.setCommonECData)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $2N6Uo.each(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $1b3383debd740561$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $1b3383debd740561$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$2N6Uo.isFunction(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($2N6Uo.slice(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $1b3383debd740561$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $2N6Uo.each(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $1b3383debd740561$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $1b3383debd740561$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $1b3383debd740561$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $bx3T8.convertOptionIdName)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $1b3383debd740561$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $1b3383debd740561$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $1b3383debd740561$var$ID_PREFIX + rawIndex;
            return id;
        };
        $1b3383debd740561$var$normalizeDimensions = function(dimensions) {
            if (!$2N6Uo.isArray(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $1b3383debd740561$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $1b3383debd740561$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $1b3383debd740561$var$transferProperties(list, original);
            return list;
        };
        $1b3383debd740561$var$transferProperties = function(target, source) {
            $2N6Uo.each($1b3383debd740561$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $2N6Uo.each($1b3383debd740561$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $2N6Uo.clone(source[propName]);
            });
            target._calculationInfo = $2N6Uo.extend({}, source._calculationInfo);
        };
        $1b3383debd740561$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $1b3383debd740561$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $1b3383debd740561$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $1b3383debd740561$export$2e2bcd8739ae039 = $1b3383debd740561$var$SeriesData;

});
parcelRegister("chf3v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f02c044a27b3a1c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8f02c044a27b3a1c$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $8f02c044a27b3a1c$var$defaultKeyGetter(item) {
    return item;
}
var $8f02c044a27b3a1c$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $8f02c044a27b3a1c$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $8f02c044a27b3a1c$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $8f02c044a27b3a1c$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $8f02c044a27b3a1c$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $8f02c044a27b3a1c$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $8f02c044a27b3a1c$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $8f02c044a27b3a1c$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $8f02c044a27b3a1c$export$2e2bcd8739ae039 = $8f02c044a27b3a1c$var$DataDiffer;

});

parcelRegister("fmOlY", function(module, exports) {

$parcel$export(module.exports, "summarizeDimensions", function () { return $b2fff83e9fa64942$export$505a22c3734846f1; });
$parcel$export(module.exports, "getDimensionTypeByAxis", function () { return $b2fff83e9fa64942$export$af1622903e71278e; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $eKQ6A = parcelRequire("eKQ6A");
var $b2fff83e9fa64942$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $b2fff83e9fa64942$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $2N6Uo.createHashMap)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $2N6Uo.each)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $b2fff83e9fa64942$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($b2fff83e9fa64942$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $b2fff83e9fa64942$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $eKQ6A.VISUAL_DIMENSIONS).each(function(v, otherDim) {
            var encodeArr = $b2fff83e9fa64942$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $2N6Uo.map)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $b2fff83e9fa64942$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $b2fff83e9fa64942$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $b2fff83e9fa64942$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $b2fff83e9fa64942$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }

});

parcelRegister("hzkG7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cca5bedc91db3272$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $cca5bedc91db3272$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $2N6Uo.extend(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $cca5bedc91db3272$export$2e2bcd8739ae039 = $cca5bedc91db3272$var$SeriesDimensionDefine;

});


parcelRegister("59bDW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bf6d31f9dfde460$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eKQ6A = parcelRequire("eKQ6A");

var $hzkG7 = parcelRequire("hzkG7");

var $2N6Uo = parcelRequire("2N6Uo");

var $9Pasn = parcelRequire("9Pasn");

var $4ToKq = parcelRequire("4ToKq");

var $bx3T8 = parcelRequire("bx3T8");

var $6VFOB = parcelRequire("6VFOB");

var $bBWDH = parcelRequire("bBWDH");
function $3bf6d31f9dfde460$export$8066c1b52b2e9504(source, opt) {
    return $3bf6d31f9dfde460$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $3bf6d31f9dfde460$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $9Pasn.isSourceInstance)(source)) source = (0, $9Pasn.createSourceFromSeriesDataOption)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $2N6Uo.createHashMap)();
    var resultList = [];
    var dimCount = $3bf6d31f9dfde460$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $bBWDH.shouldOmitUnusedDimensions)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $bBWDH.ensureSourceDimNameMap)(source) : (0, $bBWDH.createDimNameMap)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $2N6Uo.createHashMap)(encodeDef);
    var indicesMap = new (0, $4ToKq.CtorInt32Array)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $2N6Uo.isObject)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $hzkG7.default)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $bx3T8.normalizeToArray)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $2N6Uo.isString)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $2N6Uo.each)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $2N6Uo.isString)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $2N6Uo.each)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $2N6Uo.isString)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $2N6Uo.extend)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $bx3T8.normalizeToArray)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $2N6Uo.each)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $2N6Uo.defaults)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $2N6Uo.isObject)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $2N6Uo.defaults)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $eKQ6A.VISUAL_DIMENSIONS).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $3bf6d31f9dfde460$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $6VFOB.guessOrdinal)(source, resultDimIdx) === (0, $6VFOB.BE_ORDINAL).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $2N6Uo.each)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $3bf6d31f9dfde460$var$removeDuplication(resultList);
    return new (0, $bBWDH.SeriesDataSchema)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $3bf6d31f9dfde460$var$removeDuplication(result) {
    var duplicationMap = (0, $2N6Uo.createHashMap)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $3bf6d31f9dfde460$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $2N6Uo.each)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $2N6Uo.isObject)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $3bf6d31f9dfde460$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}

});

parcelRegister("8jIky", function(module, exports) {

$parcel$export(module.exports, "getCoordSysInfoBySeries", function () { return $60e27c35053fc535$export$f2befeb2f4933656; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");
/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $60e27c35053fc535$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $2N6Uo.createHashMap)();
        this.categoryAxisMap = (0, $2N6Uo.createHashMap)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $60e27c35053fc535$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $60e27c35053fc535$var$CoordSysInfo(coordSysName);
    var fetch = $60e27c35053fc535$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
// TODO: refactor them to static member of each coord sys, rather than hard code here.
var $60e27c35053fc535$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $bx3T8.SINGLE_REFERRING)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $bx3T8.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($60e27c35053fc535$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($60e27c35053fc535$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $bx3T8.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($60e27c35053fc535$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $bx3T8.SINGLE_REFERRING)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($60e27c35053fc535$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($60e27c35053fc535$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $2N6Uo.each)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($60e27c35053fc535$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    },
    matrix: function(seriesModel, result, axisMap, categoryAxisMap) {
        var matrixModel = seriesModel.getReferringComponents('matrix', (0, $bx3T8.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        var xModel = matrixModel.getDimensionModel('x');
        var yModel = matrixModel.getDimensionModel('y');
        axisMap.set('x', xModel);
        axisMap.set('y', yModel);
        categoryAxisMap.set('x', xModel);
        categoryAxisMap.set('y', yModel);
    }
};
function $60e27c35053fc535$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}

});




parcelRegister("5wQh9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40687dbc21ca7f4a$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $iQonF = parcelRequire("iQonF");

var $2N6Uo = parcelRequire("2N6Uo");

var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");
var $60Kbk = parcelRequire("60Kbk");
var $h9U3p = parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $6TSUP = parcelRequire("6TSUP");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");

var $99VtN = parcelRequire("99VtN");

var $dTvcN = parcelRequire("dTvcN");

var $hdNsB = parcelRequire("hdNsB");

var $cWIrM = parcelRequire("cWIrM");

var $kXNP6 = parcelRequire("kXNP6");

var $d8wDg = parcelRequire("d8wDg");


var $baPVy = parcelRequire("baPVy");

var $ipprj = parcelRequire("ipprj");

var $erB8T = parcelRequire("erB8T");
var $40687dbc21ca7f4a$var$mathMax = Math.max;
var $40687dbc21ca7f4a$var$mathMin = Math.min;
function $40687dbc21ca7f4a$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $kXNP6.isCoordinateSystemType)(coord, 'cartesian2d')) {
        var baseAxis = coord.getBaseAxis();
        // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== 'category' || !baseAxis.onBand) {
            var expandWidth = data.getLayout('bandWidth');
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $40687dbc21ca7f4a$var$BarView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get('coordinateSystem');
        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $h9U3p.traverseElements)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $40687dbc21ca7f4a$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
        var coordSysClipArea = $40687dbc21ca7f4a$var$getClipArea(coord, data);
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get('roundCap', true);
        var drawBackground = seriesModel.get('showBackground', true);
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
        function createBackground(dataIndex) {
            var bgLayout = $40687dbc21ca7f4a$var$getLayout[coord.type](data, dataIndex);
            if (!bgLayout) return null;
            var bgEl = $40687dbc21ca7f4a$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
            else bgEl.setShape('cornerRadius', barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $40687dbc21ca7f4a$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (!layout) return;
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$40687dbc21ca7f4a$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $40687dbc21ca7f4a$var$clip[coord.type](coordSysClipArea, layout);
            var el = $40687dbc21ca7f4a$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $40687dbc21ca7f4a$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $40687dbc21ca7f4a$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $ipprj.initProps)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $40687dbc21ca7f4a$var$getLayout[coord.type](data, newIndex, itemModel);
            if (!layout) return;
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                    else bgEl.setShape('cornerRadius', barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $40687dbc21ca7f4a$var$getLayout[coord.type](data, newIndex);
                var shape = $40687dbc21ca7f4a$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $ipprj.updateProps)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$40687dbc21ca7f4a$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $40687dbc21ca7f4a$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            var roundCapChanged = el && (el.type === 'sector' && roundCap || el.type === 'sausage' && !roundCap);
            if (roundCapChanged) {
                // roundCap changed, there is no way to use animation from a `sector` to a `sausage` shape,
                // so remove the old one and create a new shape
                el && (0, $ipprj.removeElementWithFadeOut)(el, seriesModel, oldIndex);
                el = null;
            }
            if (!el) el = $40687dbc21ca7f4a$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, true, roundCap);
            else (0, $ipprj.saveOldStyle)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $bysmE.labelInner)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $40687dbc21ca7f4a$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $40687dbc21ca7f4a$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $ipprj.updateProps)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $ipprj.removeElementWithFadeOut)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $iQonF.default)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $40687dbc21ca7f4a$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $40687dbc21ca7f4a$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get('clip', true) && (0, $dTvcN.createClipPath)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on('rendered', this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $2N6Uo.map)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: 'changeAxisOrder',
            componentType: baseAxis.dim + 'Axis',
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off('rendered', this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $ipprj.removeElementWithFadeOut)(el, model, (0, $6TSUP.getECData)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = 'bar';
    return BarView;
}((0, $cWIrM.default));
var $40687dbc21ca7f4a$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $40687dbc21ca7f4a$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $40687dbc21ca7f4a$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $40687dbc21ca7f4a$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $40687dbc21ca7f4a$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $40687dbc21ca7f4a$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $40687dbc21ca7f4a$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $40687dbc21ca7f4a$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $aH2k0.default)({
            shape: (0, $2N6Uo.extend)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = 'item';
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? 'height' : 'width';
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $hdNsB.default) : (0, $60Kbk.default);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = 'item';
        var positionMap = $40687dbc21ca7f4a$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $baPVy.createSectorCalculateTextPosition)(positionMap, {
            isRoundCap: ShapeClass === (0, $hdNsB.default)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? 'r' : 'endAngle';
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $ipprj.updateProps) : (0, $ipprj.initProps))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $40687dbc21ca7f4a$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get('realtimeSort', true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $40687dbc21ca7f4a$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $ipprj.updateProps) : (0, $ipprj.initProps))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $ipprj.updateProps) : (0, $ipprj.initProps))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $40687dbc21ca7f4a$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $40687dbc21ca7f4a$var$rectPropties = [
    'x',
    'y',
    'width',
    'height'
];
var $40687dbc21ca7f4a$var$polarPropties = [
    'cx',
    'cy',
    'r',
    'startAngle',
    'endAngle'
];
var $40687dbc21ca7f4a$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$40687dbc21ca7f4a$var$checkPropertiesNotValid(layout, $40687dbc21ca7f4a$var$rectPropties);
    },
    polar: function(layout) {
        return !$40687dbc21ca7f4a$var$checkPropertiesNotValid(layout, $40687dbc21ca7f4a$var$polarPropties);
    }
};
var $40687dbc21ca7f4a$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        if (!layout) return null;
        var fixedLineWidth = itemModel ? $40687dbc21ca7f4a$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $40687dbc21ca7f4a$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $40687dbc21ca7f4a$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
        return function(position) {
            switch(position){
                case 'start':
                case 'insideStart':
                case 'end':
                case 'insideEnd':
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $40687dbc21ca7f4a$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, 'style');
    if (!isPolar) {
        var borderRadius = itemModel.get([
            'itemStyle',
            'borderRadius'
        ]) || 0;
        el.setShape('r', borderRadius);
    } else if (!seriesModel.get('roundCap')) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $erB8T.getSectorCornerRadius)(itemModel.getModel('itemStyle'), sectorShape, true);
        (0, $2N6Uo.extend)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && el.attr('cursor', cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
    var labelStatesModels = (0, $bysmE.getLabelStatesModels)(itemModel);
    (0, $bysmE.setLabelStyle)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $d8wDg.getDefaultLabel)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            'label',
            'position'
        ]);
        el.textConfig.inside = position === 'middle' ? true : null;
        (0, $baPVy.setSectorTextRotation)(el, position === 'outside' ? labelPositionOutside : position, $40687dbc21ca7f4a$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            'label',
            'rotate'
        ]));
    }
    (0, $bysmE.setLabelValueAnimation)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $d8wDg.getDefaultInterpolatedLabel)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        'emphasis'
    ]);
    (0, $bwPbQ.toggleHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    (0, $bwPbQ.setStatesStylesFromModel)(el, itemModel);
    if ($40687dbc21ca7f4a$var$isZeroOnPolar(layout)) {
        el.style.fill = 'none';
        el.style.stroke = 'none';
        (0, $2N6Uo.each)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = 'none';
        });
    }
}
// In case width or height are too small.
function $40687dbc21ca7f4a$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        'itemStyle',
        'borderColor'
    ]);
    if (!borderColor || borderColor === 'none') return 0;
    var lineWidth = itemModel.get([
        'itemStyle',
        'borderWidth'
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $40687dbc21ca7f4a$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $40687dbc21ca7f4a$var$LargePath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeBar';
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $40687dbc21ca7f4a$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $4oDJM.default));
function $40687dbc21ca7f4a$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
    var largeDataIndices = data.getLayout('largeDataIndices');
    var barWidth = data.getLayout('size');
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var bgPoints = data.getLayout('largeBackgroundPoints');
    if (bgPoints) {
        var bgEl = new $40687dbc21ca7f4a$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $40687dbc21ca7f4a$var$LargePath({
        shape: {
            points: data.getLayout('largePoints')
        },
        incremental: !!incremental,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual('style'));
    // Stroke is rendered first to avoid overlapping with fill
    el.style.stroke = null;
    // Enable tooltip and user mouse/touch event handlers.
    (0, $6TSUP.getECData)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get('silent')) {
        el.on('mousedown', $40687dbc21ca7f4a$var$largePathUpdateDataIndex);
        el.on('mousemove', $40687dbc21ca7f4a$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $40687dbc21ca7f4a$var$largePathUpdateDataIndex = (0, $99VtN.throttle)(function(event) {
    var largePath = this;
    var dataIndex = $40687dbc21ca7f4a$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $6TSUP.getECData)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $40687dbc21ca7f4a$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $40687dbc21ca7f4a$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $kXNP6.isCoordinateSystemType)(coord, 'cartesian2d')) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $40687dbc21ca7f4a$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === 'polar' ? (0, $60Kbk.default) : (0, $aH2k0.default);
    return new ElementClz({
        shape: $40687dbc21ca7f4a$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $40687dbc21ca7f4a$export$2e2bcd8739ae039 = $40687dbc21ca7f4a$var$BarView;

});
parcelRegister("dTvcN", function(module, exports) {

$parcel$export(module.exports, "createGridClipPath", function () { return $a1d89e236c0a97e8$export$83958787eb658d14; });
$parcel$export(module.exports, "createPolarClipPath", function () { return $a1d89e236c0a97e8$export$13dc2b2230df3cb5; });
$parcel$export(module.exports, "createClipPath", function () { return $a1d89e236c0a97e8$export$e0fe5081209d01c9; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");
var $60Kbk = parcelRequire("60Kbk");

var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");
function $a1d89e236c0a97e8$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 0;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $aH2k0.default({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $2N6Uo.isFunction)(during) ? function(percent) {
            during(percent, clipPath);
        } : null;
        $ipprj.initProps(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $a1d89e236c0a97e8$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $iCU10.round)(sectorArea.r0, 1);
    var r = (0, $iCU10.round)(sectorArea.r, 1);
    var clipPath = new $60Kbk.default({
        shape: {
            cx: (0, $iCU10.round)(polar.cx, 1),
            cy: (0, $iCU10.round)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $ipprj.initProps(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $a1d89e236c0a97e8$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $a1d89e236c0a97e8$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $a1d89e236c0a97e8$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}

});

parcelRegister("hdNsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c89a0459e89a5a5e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");
parcelRequire("h9U3p");
var $4oDJM = parcelRequire("4oDJM");
/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $c89a0459e89a5a5e$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $c89a0459e89a5a5e$var$SausagePath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sausage';
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $c89a0459e89a5a5e$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $4oDJM.default));
var $c89a0459e89a5a5e$export$2e2bcd8739ae039 = $c89a0459e89a5a5e$var$SausagePath;

});

parcelRegister("kXNP6", function(module, exports) {

$parcel$export(module.exports, "isCoordinateSystemType", function () { return $f42ff736f7d0e36a$export$8567506e6336616; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $f42ff736f7d0e36a$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}

});

parcelRegister("d8wDg", function(module, exports) {

$parcel$export(module.exports, "getDefaultLabel", function () { return $990555ccec284750$export$5ff20667590927ed; });
$parcel$export(module.exports, "getDefaultInterpolatedLabel", function () { return $990555ccec284750$export$5f84815e91ca6775; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bA99G = parcelRequire("bA99G");

var $2N6Uo = parcelRequire("2N6Uo");
function $990555ccec284750$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $bA99G.retrieveRawValue)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $bA99G.retrieveRawValue)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $990555ccec284750$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $2N6Uo.isArray)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}

});

parcelRegister("baPVy", function(module, exports) {

$parcel$export(module.exports, "createSectorCalculateTextPosition", function () { return $8228e88c08d226c4$export$359a1e2d210ed734; });
$parcel$export(module.exports, "setSectorTextRotation", function () { return $8228e88c08d226c4$export$672ce504c0db395a; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eVwLk = parcelRequire("eVwLk");

var $2N6Uo = parcelRequire("2N6Uo");
function $8228e88c08d226c4$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $eVwLk.calculateTextPosition)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        switch(mappedSectorPosition){
            case 'startArc':
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'insideStartArc':
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'startAngle':
                x = cx + middleR * mathCos(startAngle) + $8228e88c08d226c4$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $8228e88c08d226c4$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideStartAngle':
                x = cx + middleR * mathCos(startAngle) + $8228e88c08d226c4$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $8228e88c08d226c4$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'middle':
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'endArc':
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideEndArc':
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'endAngle':
                x = cx + middleR * mathCos(endAngle) + $8228e88c08d226c4$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $8228e88c08d226c4$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'insideEndAngle':
                x = cx + middleR * mathCos(endAngle) + $8228e88c08d226c4$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $8228e88c08d226c4$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            default:
                return (0, $eVwLk.calculateTextPosition)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $8228e88c08d226c4$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $2N6Uo.isNumber)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $2N6Uo.isArray)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case 'startArc':
        case 'insideStartArc':
        case 'middle':
        case 'insideEndArc':
        case 'endArc':
            anchorAngle = middleAngle;
            break;
        case 'startAngle':
        case 'insideStartAngle':
            anchorAngle = startAngle;
            break;
        case 'endAngle':
        case 'insideEndAngle':
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $8228e88c08d226c4$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $8228e88c08d226c4$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}

});

parcelRegister("erB8T", function(module, exports) {

$parcel$export(module.exports, "getSectorCornerRadius", function () { return $a840660ab9a4ca4e$export$b395eeeb2ad7cce5; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $eVwLk = parcelRequire("eVwLk");
function $a840660ab9a4ca4e$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get('borderRadius');
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $2N6Uo.isArray)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $2N6Uo.map)(cornerRadius, function(cr) {
            return (0, $eVwLk.parsePercent)(cr, dr);
        })
    };
}

});



parcelRegister("eZwvb", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $ae9ff96269b4e613$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kr7T6 = parcelRequire("kr7T6");

var $iyEdE = parcelRequire("iyEdE");

var $p8JRe = parcelRequire("p8JRe");

var $8zG8w = parcelRequire("8zG8w");
function $ae9ff96269b4e613$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $kr7T6.default));
    registers.registerChartView((0, $iyEdE.default));
    registers.registerLayout((0, $p8JRe.default));
    registers.registerTransform((0, $8zG8w.boxplotTransform));
}

});
parcelRegister("kr7T6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee0c72999f06c093$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $8lL03 = parcelRequire("8lL03");

var $2N6Uo = parcelRequire("2N6Uo");

var $6aXXD = parcelRequire("6aXXD");
var $ee0c72999f06c093$var$BoxplotSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BoxplotSeriesModel, _super);
    function BoxplotSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotSeriesModel.type;
        // TODO
        // box width represents group size, so dimension should have 'size'.
        /**
     * @see <https://en.wikipedia.org/wiki/Box_plot>
     * The meanings of 'min' and 'max' depend on user,
     * and echarts do not need to know it.
     * @readOnly
     */ _this.defaultValueDimensions = [
            {
                name: 'min',
                defaultTooltip: true
            },
            {
                name: 'Q1',
                defaultTooltip: true
            },
            {
                name: 'median',
                defaultTooltip: true
            },
            {
                name: 'Q3',
                defaultTooltip: true
            },
            {
                name: 'max',
                defaultTooltip: true
            }
        ];
        _this.visualDrawType = 'stroke';
        return _this;
    }
    BoxplotSeriesModel.type = 'series.boxplot';
    BoxplotSeriesModel.dependencies = [
        'xAxis',
        'yAxis',
        'grid'
    ];
    BoxplotSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        layout: null,
        boxWidth: [
            7,
            50
        ],
        itemStyle: {
            color: (0, $6aXXD.default).color.neutral00,
            borderWidth: 1
        },
        emphasis: {
            scale: true,
            itemStyle: {
                borderWidth: 2,
                shadowBlur: 5,
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowColor: (0, $6aXXD.default).color.shadow
            }
        },
        animationDuration: 800
    };
    return BoxplotSeriesModel;
}((0, $49X8G.default));
(0, $2N6Uo.mixin)($ee0c72999f06c093$var$BoxplotSeriesModel, (0, $8lL03.WhiskerBoxCommonMixin), true);
var $ee0c72999f06c093$export$2e2bcd8739ae039 = $ee0c72999f06c093$var$BoxplotSeriesModel;

});
parcelRegister("8lL03", function(module, exports) {

$parcel$export(module.exports, "WhiskerBoxCommonMixin", function () { return $6144be1ce2049a29$export$ccfed902f8630510; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1rIDm = parcelRequire("1rIDm");

var $2N6Uo = parcelRequire("2N6Uo");

var $fmOlY = parcelRequire("fmOlY");

var $6VFOB = parcelRequire("6VFOB");
var $6144be1ce2049a29$export$ccfed902f8630510 = /** @class */ function() {
    function WhiskerBoxCommonMixin() {}
    /**
   * @private
   */ WhiskerBoxCommonMixin.prototype._hasEncodeRule = function(key) {
        var encodeRules = this.getEncode();
        return encodeRules && encodeRules.get(key) != null;
    };
    /**
   * @override
   */ WhiskerBoxCommonMixin.prototype.getInitialData = function(option, ecModel) {
        // When both types of xAxis and yAxis are 'value', layout is
        // needed to be specified by user. Otherwise, layout can be
        // judged by which axis is category.
        var ordinalMeta;
        var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
        var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
        var xAxisType = xAxisModel.get('type');
        var yAxisType = yAxisModel.get('type');
        var addOrdinal;
        // FIXME
        // Consider time axis.
        if (xAxisType === 'category') {
            option.layout = 'horizontal';
            ordinalMeta = xAxisModel.getOrdinalMeta();
            addOrdinal = !this._hasEncodeRule('x');
        } else if (yAxisType === 'category') {
            option.layout = 'vertical';
            ordinalMeta = yAxisModel.getOrdinalMeta();
            addOrdinal = !this._hasEncodeRule('y');
        } else option.layout = option.layout || 'horizontal';
        var coordDims = [
            'x',
            'y'
        ];
        var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
        var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
        var otherAxisDim = coordDims[1 - baseAxisDimIndex];
        var axisModels = [
            xAxisModel,
            yAxisModel
        ];
        var baseAxisType = axisModels[baseAxisDimIndex].get('type');
        var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
        var data = option.data;
        // Clone a new data for next setOption({}) usage.
        // Avoid modifying current data will affect further update.
        if (data && addOrdinal) {
            var newOptionData_1 = [];
            $2N6Uo.each(data, function(item, index) {
                var newItem;
                if ($2N6Uo.isArray(item)) {
                    newItem = item.slice();
                    // Modify current using data.
                    item.unshift(index);
                } else if ($2N6Uo.isArray(item.value)) {
                    newItem = $2N6Uo.extend({}, item);
                    newItem.value = newItem.value.slice();
                    // Modify current using data.
                    item.value.unshift(index);
                } else newItem = item;
                newOptionData_1.push(newItem);
            });
            option.data = newOptionData_1;
        }
        var defaultValueDimensions = this.defaultValueDimensions;
        var coordDimensions = [
            {
                name: baseAxisDim,
                type: (0, $fmOlY.getDimensionTypeByAxis)(baseAxisType),
                ordinalMeta: ordinalMeta,
                otherDims: {
                    tooltip: false,
                    itemName: 0
                },
                dimsDef: [
                    'base'
                ]
            },
            {
                name: otherAxisDim,
                type: (0, $fmOlY.getDimensionTypeByAxis)(otherAxisType),
                dimsDef: defaultValueDimensions.slice()
            }
        ];
        return (0, $1rIDm.default)(this, {
            coordDimensions: coordDimensions,
            dimensionsCount: defaultValueDimensions.length + 1,
            encodeDefaulter: $2N6Uo.curry((0, $6VFOB.makeSeriesEncodeForAxisCoordSys), coordDimensions, this)
        });
    };
    /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */ WhiskerBoxCommonMixin.prototype.getBaseAxis = function() {
        var dim = this._baseAxisDim;
        return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
    };
    return WhiskerBoxCommonMixin;
}();

});
parcelRegister("1rIDm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10daef6379d6bc9c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $59bDW = parcelRequire("59bDW");

var $2kN4z = parcelRequire("2kN4z");

var $2N6Uo = parcelRequire("2N6Uo");
function $10daef6379d6bc9c$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $2N6Uo.isArray)(opt) && {
        coordDimensions: opt
    } || (0, $2N6Uo.extend)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $59bDW.default)(source, opt).dimensions;
    var list = new (0, $2kN4z.default)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}

});



parcelRegister("iyEdE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d82a99aaefb4f4b8$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $cWIrM = parcelRequire("cWIrM");

var $h9U3p = parcelRequire("h9U3p");

var $bwPbQ = parcelRequire("bwPbQ");

var $4oDJM = parcelRequire("4oDJM");

var $ipprj = parcelRequire("ipprj");
var $d82a99aaefb4f4b8$var$BoxplotView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BoxplotView, _super);
    function BoxplotView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotView.type;
        return _this;
    }
    BoxplotView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var group = this.group;
        var oldData = this._data;
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                var symbolEl = $d82a99aaefb4f4b8$var$createNormalBox(itemLayout, data, newIdx, constDim, true);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(symbolEl);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (!symbolEl) symbolEl = $d82a99aaefb4f4b8$var$createNormalBox(itemLayout, data, newIdx, constDim);
            else {
                (0, $ipprj.saveOldStyle)(symbolEl);
                $d82a99aaefb4f4b8$var$updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
            }
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    BoxplotView.prototype.remove = function(ecModel) {
        var group = this.group;
        var data = this._data;
        this._data = null;
        data && data.eachItemGraphicEl(function(el) {
            el && group.remove(el);
        });
    };
    BoxplotView.type = 'boxplot';
    return BoxplotView;
}((0, $cWIrM.default));
var $d82a99aaefb4f4b8$var$BoxPathShape = /** @class */ function() {
    function BoxPathShape() {}
    return BoxPathShape;
}();
var $d82a99aaefb4f4b8$var$BoxPath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BoxPath, _super);
    function BoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'boxplotBoxPath';
        return _this;
    }
    BoxPath.prototype.getDefaultShape = function() {
        return new $d82a99aaefb4f4b8$var$BoxPathShape();
    };
    BoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        var i = 0;
        ctx.moveTo(ends[i][0], ends[i][1]);
        i++;
        for(; i < 4; i++)ctx.lineTo(ends[i][0], ends[i][1]);
        ctx.closePath();
        for(; i < ends.length; i++){
            ctx.moveTo(ends[i][0], ends[i][1]);
            i++;
            ctx.lineTo(ends[i][0], ends[i][1]);
        }
    };
    return BoxPath;
}((0, $4oDJM.default));
function $d82a99aaefb4f4b8$var$createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
    var ends = itemLayout.ends;
    var el = new $d82a99aaefb4f4b8$var$BoxPath({
        shape: {
            points: isInit ? $d82a99aaefb4f4b8$var$transInit(ends, constDim, itemLayout) : ends
        }
    });
    $d82a99aaefb4f4b8$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
    return el;
}
function $d82a99aaefb4f4b8$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
    var seriesModel = data.hostModel;
    var updateMethod = $h9U3p[isInit ? 'initProps' : 'updateProps'];
    updateMethod(el, {
        shape: {
            points: itemLayout.ends
        }
    }, seriesModel, dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.strokeNoScale = true;
    el.z2 = 100;
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $bwPbQ.setStatesStylesFromModel)(el, itemModel);
    (0, $bwPbQ.toggleHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
function $d82a99aaefb4f4b8$var$transInit(points, dim, itemLayout) {
    return $2N6Uo.map(points, function(point) {
        point = point.slice();
        point[dim] = itemLayout.initBaseline;
        return point;
    });
}
var $d82a99aaefb4f4b8$export$2e2bcd8739ae039 = $d82a99aaefb4f4b8$var$BoxplotView;

});

parcelRegister("p8JRe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04b91d39bdff6386$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");
var $04b91d39bdff6386$var$each = $2N6Uo.each;
function $04b91d39bdff6386$export$2e2bcd8739ae039(ecModel) {
    var groupResult = $04b91d39bdff6386$var$groupSeriesByAxis(ecModel);
    $04b91d39bdff6386$var$each(groupResult, function(groupItem) {
        var seriesModels = groupItem.seriesModels;
        if (!seriesModels.length) return;
        $04b91d39bdff6386$var$calculateBase(groupItem);
        $04b91d39bdff6386$var$each(seriesModels, function(seriesModel, idx) {
            $04b91d39bdff6386$var$layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
        });
    });
}
/**
 * Group series by axis.
 */ function $04b91d39bdff6386$var$groupSeriesByAxis(ecModel) {
    var result = [];
    var axisList = [];
    ecModel.eachSeriesByType('boxplot', function(seriesModel) {
        var baseAxis = seriesModel.getBaseAxis();
        var idx = $2N6Uo.indexOf(axisList, baseAxis);
        if (idx < 0) {
            idx = axisList.length;
            axisList[idx] = baseAxis;
            result[idx] = {
                axis: baseAxis,
                seriesModels: []
            };
        }
        result[idx].seriesModels.push(seriesModel);
    });
    return result;
}
/**
 * Calculate offset and box width for each series.
 */ function $04b91d39bdff6386$var$calculateBase(groupItem) {
    var baseAxis = groupItem.axis;
    var seriesModels = groupItem.seriesModels;
    var seriesCount = seriesModels.length;
    var boxWidthList = groupItem.boxWidthList = [];
    var boxOffsetList = groupItem.boxOffsetList = [];
    var boundList = [];
    var bandWidth;
    if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
    else {
        var maxDataCount_1 = 0;
        $04b91d39bdff6386$var$each(seriesModels, function(seriesModel) {
            maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
        });
        var extent = baseAxis.getExtent();
        bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
    }
    $04b91d39bdff6386$var$each(seriesModels, function(seriesModel) {
        var boxWidthBound = seriesModel.get('boxWidth');
        if (!$2N6Uo.isArray(boxWidthBound)) boxWidthBound = [
            boxWidthBound,
            boxWidthBound
        ];
        boundList.push([
            (0, $iCU10.parsePercent)(boxWidthBound[0], bandWidth) || 0,
            (0, $iCU10.parsePercent)(boxWidthBound[1], bandWidth) || 0
        ]);
    });
    var availableWidth = bandWidth * 0.8 - 2;
    var boxGap = availableWidth / seriesCount * 0.3;
    var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
    var base = boxWidth / 2 - availableWidth / 2;
    $04b91d39bdff6386$var$each(seriesModels, function(seriesModel, idx) {
        boxOffsetList.push(base);
        base += boxGap + boxWidth;
        boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
    });
}
/**
 * Calculate points location for each series.
 */ function $04b91d39bdff6386$var$layoutSingleSeries(seriesModel, offset, boxWidth) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var halfWidth = boxWidth / 2;
    var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
    var vDimIdx = 1 - cDimIdx;
    var coordDims = [
        'x',
        'y'
    ];
    var cDim = data.mapDimension(coordDims[cDimIdx]);
    var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);
    if (cDim == null || vDims.length < 5) return;
    for(var dataIndex = 0; dataIndex < data.count(); dataIndex++){
        var axisDimVal = data.get(cDim, dataIndex);
        var median = getPoint(axisDimVal, vDims[2], dataIndex);
        var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
        var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
        var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
        var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
        var ends = [];
        addBodyEnd(ends, end2, false);
        addBodyEnd(ends, end4, true);
        ends.push(end1, end2, end5, end4);
        layEndLine(ends, end1);
        layEndLine(ends, end5);
        layEndLine(ends, median);
        data.setItemLayout(dataIndex, {
            initBaseline: median[vDimIdx],
            ends: ends
        });
    }
    function getPoint(axisDimVal, dim, dataIndex) {
        var val = data.get(dim, dataIndex);
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        var point;
        if (isNaN(axisDimVal) || isNaN(val)) point = [
            NaN,
            NaN
        ];
        else {
            point = coordSys.dataToPoint(p);
            point[cDimIdx] += offset;
        }
        return point;
    }
    function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] += halfWidth;
        point2[cDimIdx] -= halfWidth;
        start ? ends.push(point1, point2) : ends.push(point2, point1);
    }
    function layEndLine(ends, endCenter) {
        var from = endCenter.slice();
        var to = endCenter.slice();
        from[cDimIdx] -= halfWidth;
        to[cDimIdx] += halfWidth;
        ends.push(from, to);
    }
}

});

parcelRegister("8zG8w", function(module, exports) {

$parcel$export(module.exports, "boxplotTransform", function () { return $63e247090f4b1c58$export$e0915fae26dedefc; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7iCEA = parcelRequire("7iCEA");

var $byzwF = parcelRequire("byzwF");

var $eKQ6A = parcelRequire("eKQ6A");
var $63e247090f4b1c58$export$e0915fae26dedefc = {
    type: 'echarts:boxplot',
    transform: function transform(params) {
        var upstream = params.upstream;
        if (upstream.sourceFormat !== (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS)) {
            var errMsg = '';
            (0, $byzwF.throwError)(errMsg);
        }
        var result = (0, $7iCEA.default)(upstream.getRawData(), params.config);
        return [
            {
                dimensions: [
                    'ItemName',
                    'Low',
                    'Q1',
                    'Q2',
                    'Q3',
                    'High'
                ],
                data: result.boxData
            },
            {
                data: result.outliers
            }
        ];
    }
};

});
parcelRegister("7iCEA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $550832ab5ae51673$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");
function $550832ab5ae51673$export$2e2bcd8739ae039(rawData, opt) {
    opt = opt || {};
    var boxData = [];
    var outliers = [];
    var boundIQR = opt.boundIQR;
    var useExtreme = boundIQR === 'none' || boundIQR === 0;
    for(var i = 0; i < rawData.length; i++){
        var ascList = (0, $iCU10.asc)(rawData[i].slice());
        var Q1 = (0, $iCU10.quantile)(ascList, 0.25);
        var Q2 = (0, $iCU10.quantile)(ascList, 0.5);
        var Q3 = (0, $iCU10.quantile)(ascList, 0.75);
        var min = ascList[0];
        var max = ascList[ascList.length - 1];
        var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
        var low = useExtreme ? min : Math.max(min, Q1 - bound);
        var high = useExtreme ? max : Math.min(max, Q3 + bound);
        var itemNameFormatter = opt.itemNameFormatter;
        var itemName = (0, $2N6Uo.isFunction)(itemNameFormatter) ? itemNameFormatter({
            value: i
        }) : (0, $2N6Uo.isString)(itemNameFormatter) ? itemNameFormatter.replace('{value}', i + '') : i + '';
        boxData.push([
            itemName,
            low,
            Q1,
            Q2,
            Q3,
            high
        ]);
        for(var j = 0; j < ascList.length; j++){
            var dataItem = ascList[j];
            if (dataItem < low || dataItem > high) {
                var outlier = [
                    itemName,
                    dataItem
                ];
                outliers.push(outlier);
            }
        }
    }
    return {
        boxData: boxData,
        outliers: outliers
    };
}

});



parcelRegister("8NOzx", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $668a20efcba7b3f4$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dLQJv = parcelRequire("dLQJv");

var $7VF15 = parcelRequire("7VF15");

var $iRq5m = parcelRequire("iRq5m");

var $inmFZ = parcelRequire("inmFZ");

var $6ae8S = parcelRequire("6ae8S");
function $668a20efcba7b3f4$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $dLQJv.default));
    registers.registerSeriesModel((0, $7VF15.default));
    registers.registerPreprocessor((0, $iRq5m.default));
    registers.registerVisual((0, $inmFZ.default));
    registers.registerLayout((0, $6ae8S.default));
}

});
parcelRegister("dLQJv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a06891d5ff3cc254$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $cWIrM = parcelRequire("cWIrM");

var $ipprj = parcelRequire("ipprj");
var $h9U3p = parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $bwPbQ = parcelRequire("bwPbQ");

var $4oDJM = parcelRequire("4oDJM");

var $dTvcN = parcelRequire("dTvcN");

var $ipprj = parcelRequire("ipprj");

var $inmFZ = parcelRequire("inmFZ");
var $a06891d5ff3cc254$var$SKIP_PROPS = [
    'color',
    'borderColor'
];
var $a06891d5ff3cc254$var$CandlestickView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CandlestickView, _super);
    function CandlestickView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickView.type;
        return _this;
    }
    CandlestickView.prototype.render = function(seriesModel, ecModel, api) {
        // If there is clipPath created in large mode. Remove it.
        this.group.removeClipPath();
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this._updateDrawMode(seriesModel);
        this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
    };
    CandlestickView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._clear();
        this._updateDrawMode(seriesModel);
    };
    CandlestickView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        this._progressiveEls = [];
        this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
    };
    CandlestickView.prototype.eachRendered = function(cb) {
        $h9U3p.traverseElements(this._progressiveEls || this.group, cb);
    };
    CandlestickView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    CandlestickView.prototype._renderNormal = function(seriesModel) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var isSimpleBox = data.getLayout('isSimpleBox');
        var needsClip = seriesModel.get('clip', true);
        var coord = seriesModel.coordinateSystem;
        var clipArea = coord.getArea && coord.getArea();
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                if (needsClip && $a06891d5ff3cc254$var$isNormalBoxClipped(clipArea, itemLayout)) return;
                var el = $a06891d5ff3cc254$var$createNormalBox(itemLayout, newIdx, true);
                $ipprj.initProps(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                $a06891d5ff3cc254$var$setBoxCommon(el, data, newIdx, isSimpleBox);
                group.add(el);
                data.setItemGraphicEl(newIdx, el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(el);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (needsClip && $a06891d5ff3cc254$var$isNormalBoxClipped(clipArea, itemLayout)) {
                group.remove(el);
                return;
            }
            if (!el) el = $a06891d5ff3cc254$var$createNormalBox(itemLayout, newIdx);
            else {
                $ipprj.updateProps(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                (0, $ipprj.saveOldStyle)(el);
            }
            $a06891d5ff3cc254$var$setBoxCommon(el, data, newIdx, isSimpleBox);
            group.add(el);
            data.setItemGraphicEl(newIdx, el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    CandlestickView.prototype._renderLarge = function(seriesModel) {
        this._clear();
        $a06891d5ff3cc254$var$createLarge(seriesModel, this.group);
        var clipPath = seriesModel.get('clip', true) ? (0, $dTvcN.createClipPath)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    };
    CandlestickView.prototype._incrementalRenderNormal = function(params, seriesModel) {
        var data = seriesModel.getData();
        var isSimpleBox = data.getLayout('isSimpleBox');
        var dataIndex;
        while((dataIndex = params.next()) != null){
            var itemLayout = data.getItemLayout(dataIndex);
            var el = $a06891d5ff3cc254$var$createNormalBox(itemLayout, dataIndex);
            $a06891d5ff3cc254$var$setBoxCommon(el, data, dataIndex, isSimpleBox);
            el.incremental = true;
            this.group.add(el);
            this._progressiveEls.push(el);
        }
    };
    CandlestickView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        $a06891d5ff3cc254$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    CandlestickView.prototype.remove = function(ecModel) {
        this._clear();
    };
    CandlestickView.prototype._clear = function() {
        this.group.removeAll();
        this._data = null;
    };
    CandlestickView.type = 'candlestick';
    return CandlestickView;
}((0, $cWIrM.default));
var $a06891d5ff3cc254$var$NormalBoxPathShape = /** @class */ function() {
    function NormalBoxPathShape() {}
    return NormalBoxPathShape;
}();
var $a06891d5ff3cc254$var$NormalBoxPath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(NormalBoxPath, _super);
    function NormalBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'normalCandlestickBox';
        return _this;
    }
    NormalBoxPath.prototype.getDefaultShape = function() {
        return new $a06891d5ff3cc254$var$NormalBoxPathShape();
    };
    NormalBoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        if (this.__simpleBox) {
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[6][0], ends[6][1]);
        } else {
            ctx.moveTo(ends[0][0], ends[0][1]);
            ctx.lineTo(ends[1][0], ends[1][1]);
            ctx.lineTo(ends[2][0], ends[2][1]);
            ctx.lineTo(ends[3][0], ends[3][1]);
            ctx.closePath();
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[5][0], ends[5][1]);
            ctx.moveTo(ends[6][0], ends[6][1]);
            ctx.lineTo(ends[7][0], ends[7][1]);
        }
    };
    return NormalBoxPath;
}((0, $4oDJM.default));
function $a06891d5ff3cc254$var$createNormalBox(itemLayout, dataIndex, isInit) {
    var ends = itemLayout.ends;
    return new $a06891d5ff3cc254$var$NormalBoxPath({
        shape: {
            points: isInit ? $a06891d5ff3cc254$var$transInit(ends, itemLayout) : ends
        },
        z2: 100
    });
}
function $a06891d5ff3cc254$var$isNormalBoxClipped(clipArea, itemLayout) {
    var clipped = true;
    for(var i = 0; i < itemLayout.ends.length; i++)// If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
        clipped = false;
        break;
    }
    return clipped;
}
function $a06891d5ff3cc254$var$setBoxCommon(el, data, dataIndex, isSimpleBox) {
    var itemModel = data.getItemModel(dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.strokeNoScale = true;
    el.__simpleBox = isSimpleBox;
    (0, $bwPbQ.setStatesStylesFromModel)(el, itemModel);
    var sign = data.getItemLayout(dataIndex).sign;
    $2N6Uo.each(el.states, function(state, stateName) {
        var stateModel = itemModel.getModel(stateName);
        var color = (0, $inmFZ.getColor)(sign, stateModel);
        var borderColor = (0, $inmFZ.getBorderColor)(sign, stateModel) || color;
        var stateStyle = state.style || (state.style = {});
        color && (stateStyle.fill = color);
        borderColor && (stateStyle.stroke = borderColor);
    });
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $bwPbQ.toggleHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
function $a06891d5ff3cc254$var$transInit(points, itemLayout) {
    return $2N6Uo.map(points, function(point) {
        point = point.slice();
        point[1] = itemLayout.initBaseline;
        return point;
    });
}
var $a06891d5ff3cc254$var$LargeBoxPathShape = /** @class */ function() {
    function LargeBoxPathShape() {}
    return LargeBoxPathShape;
}();
var $a06891d5ff3cc254$var$LargeBoxPath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LargeBoxPath, _super);
    function LargeBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeCandlestickBox';
        return _this;
    }
    LargeBoxPath.prototype.getDefaultShape = function() {
        return new $a06891d5ff3cc254$var$LargeBoxPathShape();
    };
    LargeBoxPath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        for(var i = 0; i < points.length;)if (this.__sign === points[i++]) {
            var x = points[i++];
            ctx.moveTo(x, points[i++]);
            ctx.lineTo(x, points[i++]);
        } else i += 3;
    };
    return LargeBoxPath;
}((0, $4oDJM.default));
function $a06891d5ff3cc254$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    var data = seriesModel.getData();
    var largePoints = data.getLayout('largePoints');
    var elP = new $a06891d5ff3cc254$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 1,
        ignoreCoarsePointer: true
    });
    group.add(elP);
    var elN = new $a06891d5ff3cc254$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: -1,
        ignoreCoarsePointer: true
    });
    group.add(elN);
    var elDoji = new $a06891d5ff3cc254$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 0,
        ignoreCoarsePointer: true
    });
    group.add(elDoji);
    $a06891d5ff3cc254$var$setLargeStyle(1, elP, seriesModel, data);
    $a06891d5ff3cc254$var$setLargeStyle(-1, elN, seriesModel, data);
    $a06891d5ff3cc254$var$setLargeStyle(0, elDoji, seriesModel, data);
    if (incremental) {
        elP.incremental = true;
        elN.incremental = true;
    }
    if (progressiveEls) progressiveEls.push(elP, elN);
}
function $a06891d5ff3cc254$var$setLargeStyle(sign, el, seriesModel, data) {
    // TODO put in visual?
    var borderColor = (0, $inmFZ.getBorderColor)(sign, seriesModel) || (0, $inmFZ.getColor)(sign, seriesModel);
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var itemStyle = seriesModel.getModel('itemStyle').getItemStyle($a06891d5ff3cc254$var$SKIP_PROPS);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
}
var $a06891d5ff3cc254$export$2e2bcd8739ae039 = $a06891d5ff3cc254$var$CandlestickView;

});
parcelRegister("inmFZ", function(module, exports) {

$parcel$export(module.exports, "getColor", function () { return $d60bf704b31d60ad$export$5551a2d24ff40153; });
$parcel$export(module.exports, "getBorderColor", function () { return $d60bf704b31d60ad$export$dbc6cfecd630bcea; });
$parcel$export(module.exports, "default", function () { return $d60bf704b31d60ad$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $Uomg7 = parcelRequire("Uomg7");

var $2N6Uo = parcelRequire("2N6Uo");
var $d60bf704b31d60ad$var$positiveBorderColorQuery = [
    'itemStyle',
    'borderColor'
];
var $d60bf704b31d60ad$var$negativeBorderColorQuery = [
    'itemStyle',
    'borderColor0'
];
var $d60bf704b31d60ad$var$dojiBorderColorQuery = [
    'itemStyle',
    'borderColorDoji'
];
var $d60bf704b31d60ad$var$positiveColorQuery = [
    'itemStyle',
    'color'
];
var $d60bf704b31d60ad$var$negativeColorQuery = [
    'itemStyle',
    'color0'
];
function $d60bf704b31d60ad$export$5551a2d24ff40153(sign, model) {
    return model.get(sign > 0 ? $d60bf704b31d60ad$var$positiveColorQuery : $d60bf704b31d60ad$var$negativeColorQuery);
}
function $d60bf704b31d60ad$export$dbc6cfecd630bcea(sign, model) {
    return model.get(sign === 0 ? $d60bf704b31d60ad$var$dojiBorderColorQuery : sign > 0 ? $d60bf704b31d60ad$var$positiveBorderColorQuery : $d60bf704b31d60ad$var$negativeBorderColorQuery);
}
var $d60bf704b31d60ad$var$candlestickVisual = {
    seriesType: 'candlestick',
    plan: (0, $Uomg7.default)(),
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var isLargeRender = seriesModel.pipelineContext.large;
        return !isLargeRender && {
            progress: function(params, data) {
                var dataIndex;
                while((dataIndex = params.next()) != null){
                    var itemModel = data.getItemModel(dataIndex);
                    var sign = data.getItemLayout(dataIndex).sign;
                    var style = itemModel.getItemStyle();
                    style.fill = $d60bf704b31d60ad$export$5551a2d24ff40153(sign, itemModel);
                    style.stroke = $d60bf704b31d60ad$export$dbc6cfecd630bcea(sign, itemModel) || style.fill;
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
                    (0, $2N6Uo.extend)(existsStyle, style);
                }
            }
        };
    }
};
var $d60bf704b31d60ad$export$2e2bcd8739ae039 = $d60bf704b31d60ad$var$candlestickVisual;

});


parcelRegister("7VF15", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c5dac4cceb4c18e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $8lL03 = parcelRequire("8lL03");

var $2N6Uo = parcelRequire("2N6Uo");
var $5c5dac4cceb4c18e$var$CandlestickSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CandlestickSeriesModel, _super);
    function CandlestickSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickSeriesModel.type;
        _this.defaultValueDimensions = [
            {
                name: 'open',
                defaultTooltip: true
            },
            {
                name: 'close',
                defaultTooltip: true
            },
            {
                name: 'lowest',
                defaultTooltip: true
            },
            {
                name: 'highest',
                defaultTooltip: true
            }
        ];
        return _this;
    }
    /**
   * Get dimension for shadow in dataZoom
   * @return dimension name
   */ CandlestickSeriesModel.prototype.getShadowDim = function() {
        return 'open';
    };
    CandlestickSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        var itemLayout = data.getItemLayout(dataIndex);
        return itemLayout && selectors.rect(itemLayout.brushRect);
    };
    CandlestickSeriesModel.type = 'series.candlestick';
    CandlestickSeriesModel.dependencies = [
        'xAxis',
        'yAxis',
        'grid'
    ];
    CandlestickSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        layout: null,
        clip: true,
        itemStyle: {
            color: '#eb5454',
            color0: '#47b262',
            borderColor: '#eb5454',
            borderColor0: '#47b262',
            borderColorDoji: null,
            // borderColor: '#d24040',
            // borderColor0: '#398f4f',
            borderWidth: 1
        },
        emphasis: {
            itemStyle: {
                borderWidth: 2
            }
        },
        barMaxWidth: null,
        barMinWidth: null,
        barWidth: null,
        large: true,
        largeThreshold: 600,
        progressive: 3e3,
        progressiveThreshold: 1e4,
        progressiveChunkMode: 'mod',
        animationEasing: 'linear',
        animationDuration: 300
    };
    return CandlestickSeriesModel;
}((0, $49X8G.default));
(0, $2N6Uo.mixin)($5c5dac4cceb4c18e$var$CandlestickSeriesModel, (0, $8lL03.WhiskerBoxCommonMixin), true);
var $5c5dac4cceb4c18e$export$2e2bcd8739ae039 = $5c5dac4cceb4c18e$var$CandlestickSeriesModel;

});

parcelRegister("iRq5m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbb1693d567db907$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $dbb1693d567db907$export$2e2bcd8739ae039(option) {
    if (!option || !$2N6Uo.isArray(option.series)) return;
    // Translate 'k' to 'candlestick'.
    $2N6Uo.each(option.series, function(seriesItem) {
        if ($2N6Uo.isObject(seriesItem) && seriesItem.type === 'k') seriesItem.type = 'candlestick';
    });
}

});

parcelRegister("6ae8S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47cea5965f200327$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $h9U3p = parcelRequire("h9U3p");

var $Uomg7 = parcelRequire("Uomg7");

var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");

var $hp8dQ = parcelRequire("hp8dQ");
var $47cea5965f200327$var$candlestickLayout = {
    seriesType: 'candlestick',
    plan: (0, $Uomg7.default)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        var candleWidth = $47cea5965f200327$var$calculateCandleWidth(seriesModel, data);
        var cDimIdx = 0;
        var vDimIdx = 1;
        var coordDims = [
            'x',
            'y'
        ];
        var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
        var vDimsI = (0, $2N6Uo.map)(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
        var openDimI = vDimsI[0];
        var closeDimI = vDimsI[1];
        var lowestDimI = vDimsI[2];
        var highestDimI = vDimsI[3];
        data.setLayout({
            candleWidth: candleWidth,
            // The value is experimented visually.
            isSimpleBox: candleWidth <= 1.3
        });
        if (cDimI < 0 || vDimsI.length < 4) return;
        return {
            progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
        };
        function normalProgress(params, data) {
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                var ocLow = Math.min(openVal, closeVal);
                var ocHigh = Math.max(openVal, closeVal);
                var ocLowPoint = getPoint(ocLow, axisDimVal);
                var ocHighPoint = getPoint(ocHigh, axisDimVal);
                var lowestPoint = getPoint(lowestVal, axisDimVal);
                var highestPoint = getPoint(highestVal, axisDimVal);
                var ends = [];
                addBodyEnd(ends, ocHighPoint, 0);
                addBodyEnd(ends, ocLowPoint, 1);
                ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
                var itemModel = data.getItemModel(dataIndex);
                var hasDojiColor = !!itemModel.get([
                    'itemStyle',
                    'borderColorDoji'
                ]);
                data.setItemLayout(dataIndex, {
                    sign: $47cea5965f200327$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor),
                    initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
                    ends: ends,
                    brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
                });
            }
            function getPoint(val, axisDimVal) {
                var p = [];
                p[cDimIdx] = axisDimVal;
                p[vDimIdx] = val;
                return isNaN(axisDimVal) || isNaN(val) ? [
                    NaN,
                    NaN
                ] : coordSys.dataToPoint(p);
            }
            function addBodyEnd(ends, point, start) {
                var point1 = point.slice();
                var point2 = point.slice();
                point1[cDimIdx] = (0, $h9U3p.subPixelOptimize)(point1[cDimIdx] + candleWidth / 2, 1, false);
                point2[cDimIdx] = (0, $h9U3p.subPixelOptimize)(point2[cDimIdx] - candleWidth / 2, 1, true);
                start ? ends.push(point1, point2) : ends.push(point2, point1);
            }
            function makeBrushRect(lowestVal, highestVal, axisDimVal) {
                var pmin = getPoint(lowestVal, axisDimVal);
                var pmax = getPoint(highestVal, axisDimVal);
                pmin[cDimIdx] -= candleWidth / 2;
                pmax[cDimIdx] -= candleWidth / 2;
                return {
                    x: pmin[0],
                    y: pmin[1],
                    width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
                    height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
                };
            }
            function subPixelOptimizePoint(point) {
                point[cDimIdx] = (0, $h9U3p.subPixelOptimize)(point[cDimIdx], 1);
                return point;
            }
        }
        function largeProgress(params, data) {
            // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
            var points = (0, $hp8dQ.createFloat32Array)(params.count * 4);
            var offset = 0;
            var point;
            var tmpIn = [];
            var tmpOut = [];
            var dataIndex;
            var store = data.getStore();
            var hasDojiColor = !!seriesModel.get([
                'itemStyle',
                'borderColorDoji'
            ]);
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
                    points[offset++] = NaN;
                    offset += 3;
                    continue;
                }
                points[offset++] = $47cea5965f200327$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor);
                tmpIn[cDimIdx] = axisDimVal;
                tmpIn[vDimIdx] = lowestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[0] : NaN;
                points[offset++] = point ? point[1] : NaN;
                tmpIn[vDimIdx] = highestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[1] : NaN;
            }
            data.setLayout('largePoints', points);
        }
    }
};
/**
 * Get the sign of a single data.
 *
 * @returns 0 for doji with hasDojiColor: true,
 *          1 for positive,
 *          -1 for negative.
 */ function $47cea5965f200327$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor) {
    var sign;
    if (openVal > closeVal) sign = -1;
    else if (openVal < closeVal) sign = 1;
    else sign = hasDojiColor ? 0 : dataIndex > 0 ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : 1;
    return sign;
}
function $47cea5965f200327$var$calculateCandleWidth(seriesModel, data) {
    var baseAxis = seriesModel.getBaseAxis();
    var extent;
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
    var barMaxWidth = (0, $iCU10.parsePercent)((0, $2N6Uo.retrieve2)(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
    var barMinWidth = (0, $iCU10.parsePercent)((0, $2N6Uo.retrieve2)(seriesModel.get('barMinWidth'), 1), bandWidth);
    var barWidth = seriesModel.get('barWidth');
    return barWidth != null ? (0, $iCU10.parsePercent)(barWidth, bandWidth) : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}
var $47cea5965f200327$export$2e2bcd8739ae039 = $47cea5965f200327$var$candlestickLayout;

});


parcelRegister("2pvXX", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $1c16b65750594bec$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1satv = parcelRequire("1satv");

var $hL2RB = parcelRequire("hL2RB");

var $hSIK5 = parcelRequire("hSIK5");

var $impUY = parcelRequire("impUY");
function $1c16b65750594bec$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $1satv.default));
    registers.registerSeriesModel((0, $hL2RB.default));
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $hSIK5.default));
    // Add data filter processor
    registers.registerProcessor((0, $impUY.default)('chord'));
}

});
parcelRegister("1satv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10f0880b706627aa$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $ipprj = parcelRequire("ipprj");

var $cWIrM = parcelRequire("cWIrM");

var $a3Ffi = parcelRequire("a3Ffi");

var $3vqMo = parcelRequire("3vqMo");

var $iCU10 = parcelRequire("iCU10");

var $6TSUP = parcelRequire("6TSUP");
var $10f0880b706627aa$var$RADIAN = Math.PI / 180;
var $10f0880b706627aa$var$ChordView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ChordView, _super);
    function ChordView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ChordView.type;
        return _this;
    }
    ChordView.prototype.init = function(ecModel, api) {};
    ChordView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle = -seriesModel.get('startAngle') * $10f0880b706627aa$var$RADIAN;
        data.diff(oldData).add(function(newIdx) {
            /* Consider the case when there are only two nodes A and B,
       * and there is a link between A and B.
       * At first, they are both disselected from legend. And then
       * when A is selected, A will go into `add` method. But since
       * there are no edges to be displayed, A should not be added.
       * So we should only add A when layout is defined.
       */ var layout = data.getItemLayout(newIdx);
            if (layout) {
                var el = new (0, $a3Ffi.default)(data, newIdx, startAngle);
                (0, $6TSUP.getECData)(el).dataIndex = newIdx;
                group.add(el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            var layout = data.getItemLayout(newIdx);
            /* Consider the case when there are only two nodes A and B,
       * and there is a link between A and B.
       * and when A is disselected from legend, there should be
       * nothing to display. But in the `data.diff` method, B will go
       * into `update` method and having no layout.
       * In this case, we need to remove B.
       */ if (!layout) {
                el && $ipprj.removeElementWithFadeOut(el, seriesModel, oldIdx);
                return;
            }
            if (!el) el = new (0, $a3Ffi.default)(data, newIdx, startAngle);
            else el.updateData(data, newIdx, startAngle);
            group.add(el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && $ipprj.removeElementWithFadeOut(el, seriesModel, oldIdx);
        }).execute();
        if (!oldData) {
            var center = seriesModel.get('center');
            this.group.scaleX = 0.01;
            this.group.scaleY = 0.01;
            this.group.originX = (0, $iCU10.parsePercent)(center[0], api.getWidth());
            this.group.originY = (0, $iCU10.parsePercent)(center[1], api.getHeight());
            $ipprj.initProps(this.group, {
                scaleX: 1,
                scaleY: 1
            }, seriesModel);
        }
        this._data = data;
        this.renderEdges(seriesModel, startAngle);
    };
    ChordView.prototype.renderEdges = function(seriesModel, startAngle) {
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getEdgeData();
        var oldData = this._edgeData;
        var group = this.group;
        edgeData.diff(oldData).add(function(newIdx) {
            var el = new (0, $3vqMo.ChordEdge)(nodeData, edgeData, newIdx, startAngle);
            (0, $6TSUP.getECData)(el).dataIndex = newIdx;
            group.add(el);
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el.updateData(nodeData, edgeData, newIdx, startAngle);
            group.add(el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && $ipprj.removeElementWithFadeOut(el, seriesModel, oldIdx);
        }).execute();
        this._edgeData = edgeData;
    };
    ChordView.prototype.dispose = function() {};
    ChordView.type = 'chord';
    return ChordView;
}((0, $cWIrM.default));
var $10f0880b706627aa$export$2e2bcd8739ae039 = $10f0880b706627aa$var$ChordView;

});
parcelRegister("a3Ffi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $752a2db608bb5661$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");
parcelRequire("h9U3p");
var $60Kbk = parcelRequire("60Kbk");
var $ipprj = parcelRequire("ipprj");
var $kBKw3 = parcelRequire("kBKw3");

var $erB8T = parcelRequire("erB8T");

var $bysmE = parcelRequire("bysmE");

var $bwPbQ = parcelRequire("bwPbQ");

var $6TSUP = parcelRequire("6TSUP");
var $752a2db608bb5661$var$ChordPiece = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ChordPiece, _super);
    function ChordPiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        (0, $6TSUP.getECData)(_this).dataType = 'node';
        _this.z2 = 2;
        var text = new $kBKw3.default();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    ChordPiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var node = data.graph.getNodeByIndex(idx);
        var seriesModel = data.hostModel;
        var itemModel = node.getModel();
        var emphasisModel = itemModel.getModel('emphasis');
        // layout position is the center of the sector
        var layout = data.getItemLayout(idx);
        var shape = (0, $2N6Uo.extend)((0, $erB8T.getSectorCornerRadius)(itemModel.getModel('itemStyle'), layout, true), layout);
        var el = this;
        // Ignore NaN data.
        if (isNaN(shape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            el.setShape(shape);
            return;
        }
        if (firstCreate) el.setShape(shape);
        else $ipprj.updateProps(el, {
            shape: shape
        }, seriesModel, idx);
        var sectorShape = (0, $2N6Uo.extend)((0, $erB8T.getSectorCornerRadius)(itemModel.getModel('itemStyle'), layout, true), layout);
        sector.setShape(sectorShape);
        sector.useStyle(data.getItemVisual(idx, 'style'));
        (0, $bwPbQ.setStatesStylesFromModel)(sector, itemModel);
        this._updateLabel(seriesModel, itemModel, node);
        data.setItemGraphicEl(idx, el);
        (0, $bwPbQ.setStatesStylesFromModel)(el, itemModel, 'itemStyle');
        // Add focus/blur states handling
        var focus = emphasisModel.get('focus');
        (0, $bwPbQ.toggleHoverEmphasis)(this, focus === 'adjacency' ? node.getAdjacentDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    ChordPiece.prototype._updateLabel = function(seriesModel, itemModel, node) {
        var label = this.getTextContent();
        var layout = node.getLayout();
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var normalLabelModel = itemModel.getModel('label');
        label.ignore = !normalLabelModel.get('show');
        // Set label style
        var labelStateModels = (0, $bysmE.getLabelStatesModels)(itemModel);
        var style = node.getVisual('style');
        (0, $bysmE.setLabelStyle)(label, labelStateModels, {
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, 'node', labelDimIndex, // ensure edgeLabel formatter is provided
                    // to prevent the inheritance from `label.formatter` of the series
                    (0, $2N6Uo.retrieve3)(formatter, labelStateModels.normal && labelStateModels.normal.get('formatter'), itemModel.get('name')), extendParams);
                }
            },
            labelDataIndex: node.dataIndex,
            defaultText: node.dataIndex + '',
            inheritColor: style.fill,
            defaultOpacity: style.opacity,
            defaultOutsidePosition: 'startArc'
        });
        // Set label position
        var labelPosition = normalLabelModel.get('position') || 'outside';
        var labelPadding = normalLabelModel.get('distance') || 0;
        var r;
        if (labelPosition === 'outside') r = layout.r + labelPadding;
        else r = (layout.r + layout.r0) / 2;
        this.textConfig = {
            inside: labelPosition !== 'outside'
        };
        var align = labelPosition !== 'outside' ? normalLabelModel.get('align') || 'center' : dx > 0 ? 'left' : 'right';
        var verticalAlign = labelPosition !== 'outside' ? normalLabelModel.get('verticalAlign') || 'middle' : dy > 0 ? 'top' : 'bottom';
        label.attr({
            x: dx * r + layout.cx,
            y: dy * r + layout.cy,
            rotation: 0,
            style: {
                align: align,
                verticalAlign: verticalAlign
            }
        });
    };
    return ChordPiece;
}($60Kbk.default);
var $752a2db608bb5661$export$2e2bcd8739ae039 = $752a2db608bb5661$var$ChordPiece;

});

parcelRegister("3vqMo", function(module, exports) {

$parcel$export(module.exports, "ChordEdge", function () { return $28d90a3abb5f7cea$export$468595ff2cf80854; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $ftfXE = parcelRequire("ftfXE");parcelRequire("h9U3p");
var $4oDJM = parcelRequire("4oDJM");
var $ipprj = parcelRequire("ipprj");

var $erB8T = parcelRequire("erB8T");

var $ipprj = parcelRequire("ipprj");

var $bwPbQ = parcelRequire("bwPbQ");

var $6TSUP = parcelRequire("6TSUP");
var $28d90a3abb5f7cea$export$aba8cafb87a78113 = /** @class */ function() {
    function ChordPathShape() {
        // Souce node, two points forming an arc
        this.s1 = [
            0,
            0
        ];
        this.s2 = [
            0,
            0
        ];
        this.sStartAngle = 0;
        this.sEndAngle = 0;
        // Target node, two points forming an arc
        this.t1 = [
            0,
            0
        ];
        this.t2 = [
            0,
            0
        ];
        this.tStartAngle = 0;
        this.tEndAngle = 0;
        this.cx = 0;
        this.cy = 0;
        // series.r0 of ChordSeries
        this.r = 0;
        this.clockwise = true;
    }
    return ChordPathShape;
}();
var $28d90a3abb5f7cea$export$468595ff2cf80854 = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ChordEdge, _super);
    function ChordEdge(nodeData, edgeData, edgeIdx, startAngle) {
        var _this = _super.call(this) || this;
        (0, $6TSUP.getECData)(_this).dataType = 'edge';
        _this.updateData(nodeData, edgeData, edgeIdx, startAngle, true);
        return _this;
    }
    ChordEdge.prototype.buildPath = function(ctx, shape) {
        // Start from n11
        ctx.moveTo(shape.s1[0], shape.s1[1]);
        var ratio = 0.7;
        var clockwise = shape.clockwise;
        // Draw the arc from n11 to n12
        ctx.arc(shape.cx, shape.cy, shape.r, shape.sStartAngle, shape.sEndAngle, !clockwise);
        // Bezier curve to cp1 and then to n21
        ctx.bezierCurveTo((shape.cx - shape.s2[0]) * ratio + shape.s2[0], (shape.cy - shape.s2[1]) * ratio + shape.s2[1], (shape.cx - shape.t1[0]) * ratio + shape.t1[0], (shape.cy - shape.t1[1]) * ratio + shape.t1[1], shape.t1[0], shape.t1[1]);
        // Draw the arc from n21 to n22
        ctx.arc(shape.cx, shape.cy, shape.r, shape.tStartAngle, shape.tEndAngle, !clockwise);
        // Bezier curve back to cp2 and then to n11
        ctx.bezierCurveTo((shape.cx - shape.t2[0]) * ratio + shape.t2[0], (shape.cy - shape.t2[1]) * ratio + shape.t2[1], (shape.cx - shape.s1[0]) * ratio + shape.s1[0], (shape.cy - shape.s1[1]) * ratio + shape.s1[1], shape.s1[0], shape.s1[1]);
        ctx.closePath();
    };
    ChordEdge.prototype.updateData = function(nodeData, edgeData, edgeIdx, startAngle, firstCreate) {
        var seriesModel = nodeData.hostModel;
        var edge = edgeData.graph.getEdgeByIndex(edgeIdx);
        var layout = edge.getLayout();
        var itemModel = edge.node1.getModel();
        var edgeModel = edgeData.getItemModel(edge.dataIndex);
        var lineStyle = edgeModel.getModel('lineStyle');
        var emphasisModel = edgeModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var shape = (0, $2N6Uo.extend)((0, $erB8T.getSectorCornerRadius)(itemModel.getModel('itemStyle'), layout, true), layout);
        var el = this;
        // Ignore NaN data.
        if (isNaN(shape.sStartAngle) || isNaN(shape.tStartAngle)) {
            // Use NaN shape to avoid drawing shape.
            el.setShape(shape);
            return;
        }
        if (firstCreate) {
            el.setShape(shape);
            $28d90a3abb5f7cea$var$applyEdgeFill(el, edge, nodeData, lineStyle);
        } else {
            (0, $ipprj.saveOldStyle)(el);
            $28d90a3abb5f7cea$var$applyEdgeFill(el, edge, nodeData, lineStyle);
            $ipprj.updateProps(el, {
                shape: shape
            }, seriesModel, edgeIdx);
        }
        (0, $bwPbQ.toggleHoverEmphasis)(this, focus === 'adjacency' ? edge.getAdjacentDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        (0, $bwPbQ.setStatesStylesFromModel)(el, edgeModel, 'lineStyle');
        edgeData.setItemGraphicEl(edge.dataIndex, el);
    };
    return ChordEdge;
}($4oDJM.default);
function $28d90a3abb5f7cea$var$applyEdgeFill(edgeShape, edge, nodeData, lineStyleModel) {
    var node1 = edge.node1;
    var node2 = edge.node2;
    var edgeStyle = edgeShape.style;
    edgeShape.setStyle(lineStyleModel.getLineStyle());
    var color = lineStyleModel.get('color');
    switch(color){
        case 'source':
            // TODO: use visual and node1.getVisual('color');
            edgeStyle.fill = nodeData.getItemVisual(node1.dataIndex, 'style').fill;
            edgeStyle.decal = node1.getVisual('style').decal;
            break;
        case 'target':
            edgeStyle.fill = nodeData.getItemVisual(node2.dataIndex, 'style').fill;
            edgeStyle.decal = node2.getVisual('style').decal;
            break;
        case 'gradient':
            var sourceColor = nodeData.getItemVisual(node1.dataIndex, 'style').fill;
            var targetColor = nodeData.getItemVisual(node2.dataIndex, 'style').fill;
            if ((0, $2N6Uo.isString)(sourceColor) && (0, $2N6Uo.isString)(targetColor)) {
                // Gradient direction is perpendicular to the mid-angles
                // of source and target nodes.
                var shape = edgeShape.shape;
                var sMidX = (shape.s1[0] + shape.s2[0]) / 2;
                var sMidY = (shape.s1[1] + shape.s2[1]) / 2;
                var tMidX = (shape.t1[0] + shape.t2[0]) / 2;
                var tMidY = (shape.t1[1] + shape.t2[1]) / 2;
                edgeStyle.fill = new $ftfXE.default(sMidX, sMidY, tMidX, tMidY, [
                    {
                        offset: 0,
                        color: sourceColor
                    },
                    {
                        offset: 1,
                        color: targetColor
                    }
                ], true);
            }
            break;
    }
}

});


parcelRegister("hL2RB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ced90c13e5beb74c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $b8YKU = parcelRequire("b8YKU");

var $49X8G = parcelRequire("49X8G");

var $elq2d = parcelRequire("elq2d");

var $5KdhI = parcelRequire("5KdhI");

var $jP9NX = parcelRequire("jP9NX");

var $2N6Uo = parcelRequire("2N6Uo");
var $ced90c13e5beb74c$var$ChordSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ChordSeriesModel, _super);
    function ChordSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ChordSeriesModel.type;
        return _this;
    }
    ChordSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
        // Enable legend selection for each data item
        this.legendVisualProvider = new (0, $jP9NX.default)($2N6Uo.bind(this.getData, this), $2N6Uo.bind(this.getRawData, this));
    };
    ChordSeriesModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
    };
    ChordSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        if (nodes && edges) {
            var graph = (0, $elq2d.default)(nodes, edges, this, true, beforeLink);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // TODO Inherit resolveParentPath by default in Model#getModel?
            var oldGetModel = (0, $b8YKU.default).prototype.getModel;
            function newGetModel(path, parentModel) {
                var model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod('getItemModel', function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === 'label' || pathArr[1] === 'label')) {
                    var newPathArr = pathArr.slice();
                    if (pathArr[0] === 'label') newPathArr[0] = 'edgeLabel';
                    else if (pathArr[1] === 'label') newPathArr[1] = 'edgeLabel';
                    return newPathArr;
                }
                return pathArr;
            }
        }
    };
    ChordSeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    ChordSeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    ChordSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var params = this.getDataParams(dataIndex, dataType);
        if (dataType === 'edge') {
            var nodeData = this.getData();
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var nameArr = [];
            sourceName != null && nameArr.push(sourceName);
            targetName != null && nameArr.push(targetName);
            return (0, $5KdhI.createTooltipMarkup)('nameValue', {
                name: nameArr.join(' > '),
                value: params.value,
                noValue: params.value == null
            });
        }
        // dataType === 'node' or empty
        return (0, $5KdhI.createTooltipMarkup)('nameValue', {
            name: params.name,
            value: params.value,
            noValue: params.value == null
        });
    };
    ChordSeriesModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        if (dataType === 'node') {
            var nodeData = this.getData();
            var node = this.getGraph().getNodeByIndex(dataIndex);
            // Set name if not already set
            if (params.name == null) params.name = nodeData.getName(dataIndex);
            // Set value if not already set
            if (params.value == null) {
                var nodeValue = node.getLayout().value;
                params.value = nodeValue;
            }
        }
        return params;
    };
    ChordSeriesModel.type = 'series.chord';
    ChordSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'none',
        legendHoverLink: true,
        colorBy: 'data',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        center: [
            '50%',
            '50%'
        ],
        radius: [
            '70%',
            '80%'
        ],
        clockwise: true,
        startAngle: 90,
        endAngle: 'auto',
        minAngle: 0,
        padAngle: 3,
        itemStyle: {
            borderRadius: [
                0,
                0,
                5,
                5
            ]
        },
        lineStyle: {
            width: 0,
            color: 'source',
            opacity: 0.2
        },
        label: {
            show: true,
            position: 'outside',
            distance: 5
        },
        emphasis: {
            focus: 'adjacency',
            lineStyle: {
                opacity: 0.5
            }
        }
    };
    return ChordSeriesModel;
}((0, $49X8G.default));
var $ced90c13e5beb74c$export$2e2bcd8739ae039 = $ced90c13e5beb74c$var$ChordSeriesModel;

});
parcelRegister("elq2d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a71738cbe4692ebf$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $2kN4z = parcelRequire("2kN4z");

var $iocht = parcelRequire("iocht");

var $5CKLS = parcelRequire("5CKLS");

var $59bDW = parcelRequire("59bDW");

var $hIXrb = parcelRequire("hIXrb");

var $dOrFN = parcelRequire("dOrFN");

var $bx3T8 = parcelRequire("bx3T8");
function $a71738cbe4692ebf$export$2e2bcd8739ae039(nodes, edges, seriesModel, directed, beforeLink) {
    // ??? TODO
    // support dataset?
    var graph = new (0, $iocht.default)(directed);
    for(var i = 0; i < nodes.length; i++)graph.addNode($2N6Uo.retrieve(// Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
    var linkNameList = [];
    var validEdges = [];
    var linkCount = 0;
    for(var i = 0; i < edges.length; i++){
        var link = edges[i];
        var source = link.source;
        var target = link.target;
        // addEdge may fail when source or target not exists
        if (graph.addEdge(source, target, linkCount)) {
            validEdges.push(link);
            linkNameList.push($2N6Uo.retrieve((0, $bx3T8.convertOptionIdName)(link.id, null), source + ' > ' + target));
            linkCount++;
        }
    }
    var coordSys = seriesModel.get('coordinateSystem');
    var nodeData;
    if (coordSys === 'cartesian2d' || coordSys === 'polar' || coordSys === 'matrix') nodeData = (0, $dOrFN.default)(nodes, seriesModel);
    else {
        var coordSysCtor = (0, $hIXrb.default).get(coordSys);
        var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : [];
        // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
        // `value` dimension, but graph need `value` dimension. It's better to
        // uniform this behavior.
        if ($2N6Uo.indexOf(coordDimensions, 'value') < 0) coordDimensions.concat([
            'value'
        ]);
        var dimensions = (0, $59bDW.default)(nodes, {
            coordDimensions: coordDimensions,
            encodeDefine: seriesModel.getEncode()
        }).dimensions;
        nodeData = new (0, $2kN4z.default)(dimensions, seriesModel);
        nodeData.initData(nodes);
    }
    var edgeData = new (0, $2kN4z.default)([
        'value'
    ], seriesModel);
    edgeData.initData(validEdges, linkNameList);
    beforeLink && beforeLink(nodeData, edgeData);
    (0, $5CKLS.default)({
        mainData: nodeData,
        struct: graph,
        structAttr: 'graph',
        datas: {
            node: nodeData,
            edge: edgeData
        },
        datasAttr: {
            node: 'data',
            edge: 'edgeData'
        }
    });
    // Update dataIndex of nodes and edges because invalid edge may be removed
    graph.update();
    return graph;
}

});
parcelRegister("iocht", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d633fe945752fd9d$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
// id may be function name of Object, add a prefix to avoid this problem.
function $d633fe945752fd9d$var$generateNodeKey(id) {
    return '_EC_' + id;
}
var $d633fe945752fd9d$var$Graph = /** @class */ function() {
    function Graph(directed) {
        this.type = 'graph';
        this.nodes = [];
        this.edges = [];
        this._nodesMap = {};
        /**
     * @type {Object.<string, module:echarts/data/Graph.Edge>}
     * @private
     */ this._edgesMap = {};
        this._directed = directed || false;
    }
    /**
   * If is directed graph
   */ Graph.prototype.isDirected = function() {
        return this._directed;
    };
    /**
   * Add a new node
   */ Graph.prototype.addNode = function(id, dataIndex) {
        id = id == null ? '' + dataIndex : '' + id;
        var nodesMap = this._nodesMap;
        if (nodesMap[$d633fe945752fd9d$var$generateNodeKey(id)]) return;
        var node = new $d633fe945752fd9d$export$32866653dfc29d0d(id, dataIndex);
        node.hostGraph = this;
        this.nodes.push(node);
        nodesMap[$d633fe945752fd9d$var$generateNodeKey(id)] = node;
        return node;
    };
    /**
   * Get node by data index
   */ Graph.prototype.getNodeByIndex = function(dataIndex) {
        var rawIdx = this.data.getRawIndex(dataIndex);
        return this.nodes[rawIdx];
    };
    /**
   * Get node by id
   */ Graph.prototype.getNodeById = function(id) {
        return this._nodesMap[$d633fe945752fd9d$var$generateNodeKey(id)];
    };
    /**
   * Add a new edge
   */ Graph.prototype.addEdge = function(n1, n2, dataIndex) {
        var nodesMap = this._nodesMap;
        var edgesMap = this._edgesMap;
        // PENDING
        if ($2N6Uo.isNumber(n1)) n1 = this.nodes[n1];
        if ($2N6Uo.isNumber(n2)) n2 = this.nodes[n2];
        if (!(n1 instanceof $d633fe945752fd9d$export$32866653dfc29d0d)) n1 = nodesMap[$d633fe945752fd9d$var$generateNodeKey(n1)];
        if (!(n2 instanceof $d633fe945752fd9d$export$32866653dfc29d0d)) n2 = nodesMap[$d633fe945752fd9d$var$generateNodeKey(n2)];
        if (!n1 || !n2) return;
        var key = n1.id + '-' + n2.id;
        var edge = new $d633fe945752fd9d$export$87f150720cc8d165(n1, n2, dataIndex);
        edge.hostGraph = this;
        if (this._directed) {
            n1.outEdges.push(edge);
            n2.inEdges.push(edge);
        }
        n1.edges.push(edge);
        if (n1 !== n2) n2.edges.push(edge);
        this.edges.push(edge);
        edgesMap[key] = edge;
        return edge;
    };
    /**
   * Get edge by data index
   */ Graph.prototype.getEdgeByIndex = function(dataIndex) {
        var rawIdx = this.edgeData.getRawIndex(dataIndex);
        return this.edges[rawIdx];
    };
    /**
   * Get edge by two linked nodes
   */ Graph.prototype.getEdge = function(n1, n2) {
        if (n1 instanceof $d633fe945752fd9d$export$32866653dfc29d0d) n1 = n1.id;
        if (n2 instanceof $d633fe945752fd9d$export$32866653dfc29d0d) n2 = n2.id;
        var edgesMap = this._edgesMap;
        if (this._directed) return edgesMap[n1 + '-' + n2];
        else return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
    };
    /**
   * Iterate all nodes
   */ Graph.prototype.eachNode = function(cb, context) {
        var nodes = this.nodes;
        var len = nodes.length;
        for(var i = 0; i < len; i++)if (nodes[i].dataIndex >= 0) cb.call(context, nodes[i], i);
    };
    /**
   * Iterate all edges
   */ Graph.prototype.eachEdge = function(cb, context) {
        var edges = this.edges;
        var len = edges.length;
        for(var i = 0; i < len; i++)if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) cb.call(context, edges[i], i);
    };
    /**
   * Breadth first traverse
   * Return true to stop traversing
   */ Graph.prototype.breadthFirstTraverse = function(cb, startNode, direction, context) {
        if (!(startNode instanceof $d633fe945752fd9d$export$32866653dfc29d0d)) startNode = this._nodesMap[$d633fe945752fd9d$var$generateNodeKey(startNode)];
        if (!startNode) return;
        var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
        for(var i = 0; i < this.nodes.length; i++)this.nodes[i].__visited = false;
        if (cb.call(context, startNode, null)) return;
        var queue = [
            startNode
        ];
        while(queue.length){
            var currentNode = queue.shift();
            var edges = currentNode[edgeType];
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
                if (!otherNode.__visited) {
                    if (cb.call(context, otherNode, currentNode)) // Stop traversing
                    return;
                    queue.push(otherNode);
                    otherNode.__visited = true;
                }
            }
        }
    };
    // TODO
    // depthFirstTraverse(
    //     cb, startNode, direction, context
    // ) {
    // };
    // Filter update
    Graph.prototype.update = function() {
        var data = this.data;
        var edgeData = this.edgeData;
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
        edgeData.filterSelf(function(idx) {
            var edge = edges[edgeData.getRawIndex(idx)];
            return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
        });
        // Update edge
        for(var i = 0, len = edges.length; i < len; i++)edges[i].dataIndex = -1;
        for(var i = 0, len = edgeData.count(); i < len; i++)edges[edgeData.getRawIndex(i)].dataIndex = i;
    };
    /**
   * @return {module:echarts/data/Graph}
   */ Graph.prototype.clone = function() {
        var graph = new Graph(this._directed);
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0; i < nodes.length; i++)graph.addNode(nodes[i].id, nodes[i].dataIndex);
        for(var i = 0; i < edges.length; i++){
            var e = edges[i];
            graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
        }
        return graph;
    };
    return Graph;
}();
var $d633fe945752fd9d$export$32866653dfc29d0d = /** @class */ function() {
    function GraphNode(id, dataIndex) {
        this.inEdges = [];
        this.outEdges = [];
        this.edges = [];
        this.dataIndex = -1;
        this.id = id == null ? '' : id;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    /**
   * @return {number}
   */ GraphNode.prototype.degree = function() {
        return this.edges.length;
    };
    /**
   * @return {number}
   */ GraphNode.prototype.inDegree = function() {
        return this.inEdges.length;
    };
    /**
  * @return {number}
  */ GraphNode.prototype.outDegree = function() {
        return this.outEdges.length;
    };
    GraphNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphNode.prototype.getAdjacentDataIndices = function() {
        var dataIndices = {
            edge: [],
            node: []
        };
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            dataIndices.edge.push(adjacentEdge.dataIndex);
            dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
        }
        return dataIndices;
    };
    GraphNode.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $2N6Uo.createHashMap();
        var connectedNodesMap = $2N6Uo.createHashMap();
        for(var i = 0, len = this.edges.length; i < len; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            connectedEdgesMap.set(adjacentEdge.dataIndex, true);
            var sourceNodesQueue = [
                adjacentEdge.node1
            ];
            var targetNodesQueue = [
                adjacentEdge.node2
            ];
            var nodeIteratorIndex = 0;
            while(nodeIteratorIndex < sourceNodesQueue.length){
                var sourceNode = sourceNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(sourceNode.dataIndex, true);
                var sourceNodeInEdges = sourceNode.inEdges;
                for(var j = 0, len_1 = sourceNodeInEdges.length, inEdge = void 0, inEdgeDataIndex = void 0; j < len_1; j++){
                    inEdge = sourceNodeInEdges[j];
                    inEdgeDataIndex = inEdge.dataIndex;
                    if (inEdgeDataIndex >= 0 && !connectedEdgesMap.hasKey(inEdgeDataIndex)) {
                        connectedEdgesMap.set(inEdgeDataIndex, true);
                        sourceNodesQueue.push(inEdge.node1);
                    }
                }
            }
            nodeIteratorIndex = 0;
            while(nodeIteratorIndex < targetNodesQueue.length){
                var targetNode = targetNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(targetNode.dataIndex, true);
                var targetNodeOutEdges = targetNode.outEdges;
                for(var j = 0, len_2 = targetNodeOutEdges.length, outEdge = void 0, outEdgeDataIndex = void 0; j < len_2; j++){
                    outEdge = targetNodeOutEdges[j];
                    outEdgeDataIndex = outEdge.dataIndex;
                    if (outEdgeDataIndex >= 0 && !connectedEdgesMap.hasKey(outEdgeDataIndex)) {
                        connectedEdgesMap.set(outEdgeDataIndex, true);
                        targetNodesQueue.push(outEdge.node2);
                    }
                }
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphNode;
}();
var $d633fe945752fd9d$export$87f150720cc8d165 = /** @class */ function() {
    function GraphEdge(n1, n2, dataIndex) {
        this.dataIndex = -1;
        this.node1 = n1;
        this.node2 = n2;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    GraphEdge.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.edgeData.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphEdge.prototype.getAdjacentDataIndices = function() {
        return {
            edge: [
                this.dataIndex
            ],
            node: [
                this.node1.dataIndex,
                this.node2.dataIndex
            ]
        };
    };
    GraphEdge.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $2N6Uo.createHashMap();
        var connectedNodesMap = $2N6Uo.createHashMap();
        connectedEdgesMap.set(this.dataIndex, true);
        var sourceNodes = [
            this.node1
        ];
        var targetNodes = [
            this.node2
        ];
        var nodeIteratorIndex = 0;
        while(nodeIteratorIndex < sourceNodes.length){
            var sourceNode = sourceNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(sourceNode.dataIndex, true);
            var sourceNodeInEdges = sourceNode.inEdges;
            for(var j = 0, len = sourceNodeInEdges.length, inEdge = void 0, inEdgeDataIndex = void 0; j < len; j++){
                inEdge = sourceNode.inEdges[j];
                inEdgeDataIndex = inEdge.dataIndex;
                if (inEdgeDataIndex >= 0 && !connectedEdgesMap.hasKey(inEdgeDataIndex)) {
                    connectedEdgesMap.set(inEdgeDataIndex, true);
                    sourceNodes.push(inEdge.node1);
                }
            }
        }
        nodeIteratorIndex = 0;
        while(nodeIteratorIndex < targetNodes.length){
            var targetNode = targetNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(targetNode.dataIndex, true);
            var targetNodeOutEdges = targetNode.outEdges;
            for(var j = 0, len = targetNodeOutEdges.length, outEdge = void 0, outEdgeDataIndex = void 0; j < len; j++){
                outEdge = targetNode.outEdges[j];
                outEdgeDataIndex = outEdge.dataIndex;
                if (outEdgeDataIndex >= 0 && !connectedEdgesMap.hasKey(outEdgeDataIndex)) {
                    connectedEdgesMap.set(outEdgeDataIndex, true);
                    targetNodes.push(outEdge.node2);
                }
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphEdge;
}();
function $d633fe945752fd9d$var$createGraphDataProxyMixin(hostName, dataName) {
    return {
        /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */ getValue: function(dimension) {
            var data = this[hostName][dataName];
            return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
        },
        // TODO: TYPE stricter type.
        setVisual: function(key, value) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
        },
        getVisual: function(key) {
            return this[hostName][dataName].getItemVisual(this.dataIndex, key);
        },
        setLayout: function(layout, merge) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
        },
        getLayout: function() {
            return this[hostName][dataName].getItemLayout(this.dataIndex);
        },
        getGraphicEl: function() {
            return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
        },
        getRawIndex: function() {
            return this[hostName][dataName].getRawIndex(this.dataIndex);
        }
    };
}
$2N6Uo.mixin($d633fe945752fd9d$export$32866653dfc29d0d, $d633fe945752fd9d$var$createGraphDataProxyMixin('hostGraph', 'data'));
$2N6Uo.mixin($d633fe945752fd9d$export$87f150720cc8d165, $d633fe945752fd9d$var$createGraphDataProxyMixin('hostGraph', 'edgeData'));
var $d633fe945752fd9d$export$2e2bcd8739ae039 = $d633fe945752fd9d$var$Graph;

});

parcelRegister("5CKLS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4184c824708fdd87$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Link lists and struct (graph or tree)
 */ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");
var $4184c824708fdd87$var$inner = (0, $bx3T8.makeInner)();
function $4184c824708fdd87$var$linkSeriesData(opt) {
    var mainData = opt.mainData;
    var datas = opt.datas;
    if (!datas) {
        datas = {
            main: mainData
        };
        opt.datasAttr = {
            main: 'data'
        };
    }
    opt.datas = opt.mainData = null;
    $4184c824708fdd87$var$linkAll(mainData, datas, opt);
    // Porxy data original methods.
    (0, $2N6Uo.each)(datas, function(data) {
        (0, $2N6Uo.each)(mainData.TRANSFERABLE_METHODS, function(methodName) {
            data.wrapMethod(methodName, (0, $2N6Uo.curry)($4184c824708fdd87$var$transferInjection, opt));
        });
    });
    // Beyond transfer, additional features should be added to `cloneShallow`.
    mainData.wrapMethod('cloneShallow', (0, $2N6Uo.curry)($4184c824708fdd87$var$cloneShallowInjection, opt));
    // Only mainData trigger change, because struct.update may trigger
    // another changable methods, which may bring about dead lock.
    (0, $2N6Uo.each)(mainData.CHANGABLE_METHODS, function(methodName) {
        mainData.wrapMethod(methodName, (0, $2N6Uo.curry)($4184c824708fdd87$var$changeInjection, opt));
    });
    // Make sure datas contains mainData.
    (0, $2N6Uo.assert)(datas[mainData.dataType] === mainData);
}
function $4184c824708fdd87$var$transferInjection(opt, res) {
    if ($4184c824708fdd87$var$isMainData(this)) {
        // Transfer datas to new main data.
        var datas = (0, $2N6Uo.extend)({}, $4184c824708fdd87$var$inner(this).datas);
        datas[this.dataType] = res;
        $4184c824708fdd87$var$linkAll(res, datas, opt);
    } else // Modify the reference in main data to point newData.
    $4184c824708fdd87$var$linkSingle(res, this.dataType, $4184c824708fdd87$var$inner(this).mainData, opt);
    return res;
}
function $4184c824708fdd87$var$changeInjection(opt, res) {
    opt.struct && opt.struct.update();
    return res;
}
function $4184c824708fdd87$var$cloneShallowInjection(opt, res) {
    // cloneShallow, which brings about some fragilities, may be inappropriate
    // to be exposed as an API. So for implementation simplicity we can make
    // the restriction that cloneShallow of not-mainData should not be invoked
    // outside, but only be invoked here.
    (0, $2N6Uo.each)($4184c824708fdd87$var$inner(res).datas, function(data, dataType) {
        data !== res && $4184c824708fdd87$var$linkSingle(data.cloneShallow(), dataType, res, opt);
    });
    return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param [dataType] If not specified, return mainData.
 */ function $4184c824708fdd87$var$getLinkedData(dataType) {
    var mainData = $4184c824708fdd87$var$inner(this).mainData;
    return dataType == null || mainData == null ? mainData : $4184c824708fdd87$var$inner(mainData).datas[dataType];
}
/**
 * Get list of all linked data
 */ function $4184c824708fdd87$var$getLinkedDataAll() {
    var mainData = $4184c824708fdd87$var$inner(this).mainData;
    return mainData == null ? [
        {
            data: mainData
        }
    ] : (0, $2N6Uo.map)((0, $2N6Uo.keys)($4184c824708fdd87$var$inner(mainData).datas), function(type) {
        return {
            type: type,
            data: $4184c824708fdd87$var$inner(mainData).datas[type]
        };
    });
}
function $4184c824708fdd87$var$isMainData(data) {
    return $4184c824708fdd87$var$inner(data).mainData === data;
}
function $4184c824708fdd87$var$linkAll(mainData, datas, opt) {
    $4184c824708fdd87$var$inner(mainData).datas = {};
    (0, $2N6Uo.each)(datas, function(data, dataType) {
        $4184c824708fdd87$var$linkSingle(data, dataType, mainData, opt);
    });
}
function $4184c824708fdd87$var$linkSingle(data, dataType, mainData, opt) {
    $4184c824708fdd87$var$inner(mainData).datas[dataType] = data;
    $4184c824708fdd87$var$inner(data).mainData = mainData;
    data.dataType = dataType;
    if (opt.struct) {
        data[opt.structAttr] = opt.struct;
        opt.struct[opt.datasAttr[dataType]] = data;
    }
    // Supplement method.
    data.getLinkedData = $4184c824708fdd87$var$getLinkedData;
    data.getLinkedDataAll = $4184c824708fdd87$var$getLinkedDataAll;
}
var $4184c824708fdd87$export$2e2bcd8739ae039 = $4184c824708fdd87$var$linkSeriesData;

});


parcelRegister("jP9NX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6ea62c5d32b765c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $e6ea62c5d32b765c$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(// Function to get data after filtered. It stores all the encoding info
    getDataWithEncodedVisual, // Function to get raw data before filtered.
    getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData();
        // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $e6ea62c5d32b765c$export$2e2bcd8739ae039 = $e6ea62c5d32b765c$var$LegendVisualProvider;

});


parcelRegister("hSIK5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d04a2fb7c39c9309$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eAFw0 = parcelRequire("eAFw0");

var $a35Wn = parcelRequire("a35Wn");
var $d04a2fb7c39c9309$var$RADIAN = Math.PI / 180;
function $d04a2fb7c39c9309$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('chord', function(seriesModel) {
        $d04a2fb7c39c9309$var$chordLayout(seriesModel, api);
    });
}
function $d04a2fb7c39c9309$var$chordLayout(seriesModel, api) {
    var nodeData = seriesModel.getData();
    var nodeGraph = nodeData.graph;
    var edgeData = seriesModel.getEdgeData();
    var edgeCount = edgeData.count();
    if (!edgeCount) return;
    var _a = (0, $a35Wn.getCircleLayout)(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0;
    var padAngle = Math.max((seriesModel.get('padAngle') || 0) * $d04a2fb7c39c9309$var$RADIAN, 0);
    var minAngle = Math.max((seriesModel.get('minAngle') || 0) * $d04a2fb7c39c9309$var$RADIAN, 0);
    var startAngle = -seriesModel.get('startAngle') * $d04a2fb7c39c9309$var$RADIAN;
    var endAngle = startAngle + Math.PI * 2;
    var clockwise = seriesModel.get('clockwise');
    var dir = clockwise ? 1 : -1;
    // Normalize angles
    var angles = [
        startAngle,
        endAngle
    ];
    (0, $eAFw0.normalizeArcAngles)(angles, !clockwise);
    var normalizedStartAngle = angles[0], normalizedEndAngle = angles[1];
    var totalAngle = normalizedEndAngle - normalizedStartAngle;
    var allZero = nodeData.getSum('value') === 0 && edgeData.getSum('value') === 0;
    // Sum of each node's edge values
    var nodeValues = [];
    var renderedNodeCount = 0;
    nodeGraph.eachEdge(function(edge) {
        // All links use the same value 1 when allZero is true
        var value = allZero ? 1 : edge.getValue('value');
        if (allZero && (value > 0 || minAngle)) // When allZero is true, angle is in direct proportion to number
        // of links both in and out of the node.
        renderedNodeCount += 2;
        var node1Index = edge.node1.dataIndex;
        var node2Index = edge.node2.dataIndex;
        nodeValues[node1Index] = (nodeValues[node1Index] || 0) + value;
        nodeValues[node2Index] = (nodeValues[node2Index] || 0) + value;
    });
    // Update nodeValues with data.value if exists
    var nodeValueSum = 0;
    nodeGraph.eachNode(function(node) {
        var dataValue = node.getValue('value');
        if (!isNaN(dataValue)) nodeValues[node.dataIndex] = Math.max(dataValue, nodeValues[node.dataIndex] || 0);
        if (!allZero && (nodeValues[node.dataIndex] > 0 || minAngle)) // When allZero is false, angle is in direct proportion to node's
        // value
        renderedNodeCount++;
        nodeValueSum += nodeValues[node.dataIndex] || 0;
    });
    if (renderedNodeCount === 0 || nodeValueSum === 0) return;
    if (padAngle * renderedNodeCount >= Math.abs(totalAngle)) // Not enough angle to render the pad, minAngle has higher priority, and padAngle takes the rest
    padAngle = Math.max(0, (Math.abs(totalAngle) - minAngle * renderedNodeCount) / renderedNodeCount);
    if ((padAngle + minAngle) * renderedNodeCount >= Math.abs(totalAngle)) // Not enough angle to render the minAngle, so ignore the minAngle
    minAngle = (Math.abs(totalAngle) - padAngle * renderedNodeCount) / renderedNodeCount;
    var unitAngle = (totalAngle - padAngle * renderedNodeCount * dir) / nodeValueSum;
    var totalDeficit = 0; // sum of deficits of nodes with span < minAngle
    var totalSurplus = 0; // sum of (spans - minAngle) of nodes with span > minAngle
    var totalSurplusSpan = 0; // sum of spans of nodes with span > minAngle
    var minSurplus = Infinity; // min of (spans - minAngle) of nodes with span > minAngle
    nodeGraph.eachNode(function(node) {
        var value = nodeValues[node.dataIndex] || 0;
        var spanAngle = unitAngle * (nodeValueSum ? value : 1) * dir;
        if (Math.abs(spanAngle) < minAngle) totalDeficit += minAngle - Math.abs(spanAngle);
        else {
            minSurplus = Math.min(minSurplus, Math.abs(spanAngle) - minAngle);
            totalSurplus += Math.abs(spanAngle) - minAngle;
            totalSurplusSpan += Math.abs(spanAngle);
        }
        node.setLayout({
            angle: spanAngle,
            value: value
        });
    });
    var surplusAsMuchAsPossible = false;
    if (totalDeficit > totalSurplus) {
        // Not enough angle to spread the nodes, scale all
        var scale_1 = totalDeficit / totalSurplus;
        nodeGraph.eachNode(function(node) {
            var spanAngle = node.getLayout().angle;
            if (Math.abs(spanAngle) >= minAngle) node.setLayout({
                angle: spanAngle * scale_1,
                ratio: scale_1
            }, true);
            else node.setLayout({
                angle: minAngle,
                ratio: minAngle === 0 ? 1 : spanAngle / minAngle
            }, true);
        });
    } else // For example, if totalDeficit is 60 degrees and totalSurplus is 70
    // degrees but one of the sector can only reduced by 1 degree,
    // if we decrease it with the ratio of value to other surplused nodes,
    // it will have smaller angle than minAngle itself.
    // So we need to borrow some angle from other nodes.
    nodeGraph.eachNode(function(node) {
        if (surplusAsMuchAsPossible) return;
        var spanAngle = node.getLayout().angle;
        var borrowRatio = Math.min(spanAngle / totalSurplusSpan, 1);
        var borrowAngle = borrowRatio * totalDeficit;
        if (spanAngle - borrowAngle < minAngle) // It will have less than minAngle after borrowing
        surplusAsMuchAsPossible = true;
    });
    var restDeficit = totalDeficit;
    nodeGraph.eachNode(function(node) {
        if (restDeficit <= 0) return;
        var spanAngle = node.getLayout().angle;
        if (spanAngle > minAngle && minAngle > 0) {
            var borrowRatio = surplusAsMuchAsPossible ? 1 : Math.min(spanAngle / totalSurplusSpan, 1);
            var maxBorrowAngle = spanAngle - minAngle;
            var borrowAngle = Math.min(maxBorrowAngle, Math.min(restDeficit, totalDeficit * borrowRatio));
            restDeficit -= borrowAngle;
            node.setLayout({
                angle: spanAngle - borrowAngle,
                ratio: (spanAngle - borrowAngle) / spanAngle
            }, true);
        } else if (minAngle > 0) node.setLayout({
            angle: minAngle,
            ratio: spanAngle === 0 ? 1 : minAngle / spanAngle
        }, true);
    });
    var angle = normalizedStartAngle;
    var edgeAccAngle = [];
    nodeGraph.eachNode(function(node) {
        var spanAngle = Math.max(node.getLayout().angle, minAngle);
        node.setLayout({
            cx: cx,
            cy: cy,
            r0: r0,
            r: r,
            startAngle: angle,
            endAngle: angle + spanAngle * dir,
            clockwise: clockwise
        }, true);
        edgeAccAngle[node.dataIndex] = angle;
        angle += (spanAngle + padAngle) * dir;
    });
    nodeGraph.eachEdge(function(edge) {
        var value = allZero ? 1 : edge.getValue('value');
        var spanAngle = unitAngle * (nodeValueSum ? value : 1) * dir;
        var node1Index = edge.node1.dataIndex;
        var sStartAngle = edgeAccAngle[node1Index] || 0;
        var sSpan = Math.abs((edge.node1.getLayout().ratio || 1) * spanAngle);
        var sEndAngle = sStartAngle + sSpan * dir;
        var s1 = [
            cx + r0 * Math.cos(sStartAngle),
            cy + r0 * Math.sin(sStartAngle)
        ];
        var s2 = [
            cx + r0 * Math.cos(sEndAngle),
            cy + r0 * Math.sin(sEndAngle)
        ];
        var node2Index = edge.node2.dataIndex;
        var tStartAngle = edgeAccAngle[node2Index] || 0;
        var tSpan = Math.abs((edge.node2.getLayout().ratio || 1) * spanAngle);
        var tEndAngle = tStartAngle + tSpan * dir;
        var t1 = [
            cx + r0 * Math.cos(tStartAngle),
            cy + r0 * Math.sin(tStartAngle)
        ];
        var t2 = [
            cx + r0 * Math.cos(tEndAngle),
            cy + r0 * Math.sin(tEndAngle)
        ];
        edge.setLayout({
            s1: s1,
            s2: s2,
            sStartAngle: sStartAngle,
            sEndAngle: sEndAngle,
            t1: t1,
            t2: t2,
            tStartAngle: tStartAngle,
            tEndAngle: tEndAngle,
            cx: cx,
            cy: cy,
            r: r0,
            value: value,
            clockwise: clockwise
        });
        edgeAccAngle[node1Index] = sEndAngle;
        edgeAccAngle[node2Index] = tEndAngle;
    });
}

});

parcelRegister("impUY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5de62d4ad2a7303$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $d5de62d4ad2a7303$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: 'legend'
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx);
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}

});


parcelRegister("cJrP8", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $944f4537abdd61b5$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fcmvO = parcelRequire("fcmvO");

var $3cXBJ = parcelRequire("3cXBJ");
function $944f4537abdd61b5$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $3cXBJ.default));
    registers.registerSeriesModel((0, $fcmvO.default));
}

});
parcelRegister("fcmvO", function(module, exports) {

$parcel$export(module.exports, "STYLE_VISUAL_TYPE", function () { return $b109706a0d35a04b$export$84369c8e2229fa7f; });
$parcel$export(module.exports, "NON_STYLE_VISUAL_PROPS", function () { return $b109706a0d35a04b$export$734d775a14929701; });
$parcel$export(module.exports, "customInnerStore", function () { return $b109706a0d35a04b$export$dd5c3cc86073562f; });
$parcel$export(module.exports, "default", function () { return $b109706a0d35a04b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $dOrFN = parcelRequire("dOrFN");

var $bx3T8 = parcelRequire("bx3T8");

var $49X8G = parcelRequire("49X8G");
var $b109706a0d35a04b$export$84369c8e2229fa7f = {
    color: 'fill',
    borderColor: 'stroke'
};
var $b109706a0d35a04b$export$734d775a14929701 = {
    symbol: 1,
    symbolSize: 1,
    symbolKeepAspect: 1,
    legendIcon: 1,
    visualMeta: 1,
    liftZ: 1,
    decal: 1
};
var $b109706a0d35a04b$export$dd5c3cc86073562f = (0, $bx3T8.makeInner)();
var $b109706a0d35a04b$var$CustomSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CustomSeriesModel, _super);
    function CustomSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomSeriesModel.type;
        return _this;
    }
    CustomSeriesModel.prototype.optionUpdated = function() {
        this.currentZLevel = this.get('zlevel', true);
        this.currentZ = this.get('z', true);
    };
    CustomSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $dOrFN.default)(null, this);
    };
    CustomSeriesModel.prototype.getDataParams = function(dataIndex, dataType, el) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        el && (params.info = $b109706a0d35a04b$export$dd5c3cc86073562f(el).info);
        return params;
    };
    CustomSeriesModel.type = 'series.custom';
    CustomSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar',
        'matrix'
    ];
    CustomSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Custom series will not clip by default.
        // Some case will use custom series to draw label
        // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
        clip: false
    };
    return CustomSeriesModel;
}((0, $49X8G.default));
var $b109706a0d35a04b$export$2e2bcd8739ae039 = $b109706a0d35a04b$var$CustomSeriesModel;

});

parcelRegister("3cXBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2560baebf6b9d1f1$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $5JZmf = parcelRequire("5JZmf");
var $h9U3p = parcelRequire("h9U3p");
var $lQsZt = parcelRequire("lQsZt");
var $4oDJM = parcelRequire("4oDJM");
var $iQonF = parcelRequire("iQonF");
var $kBKw3 = parcelRequire("kBKw3");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");

var $d8wDg = parcelRequire("d8wDg");

var $5qNR7 = parcelRequire("5qNR7");

var $chf3v = parcelRequire("chf3v");

var $cWIrM = parcelRequire("cWIrM");

var $dTvcN = parcelRequire("dTvcN");

var $4ObQ5 = parcelRequire("4ObQ5");

var $iidqj = parcelRequire("iidqj");

var $VSMXI = parcelRequire("VSMXI");

var $28M2F = parcelRequire("28M2F");

var $5Jh1o = parcelRequire("5Jh1o");

var $cPztD = parcelRequire("cPztD");

var $6Ekel = parcelRequire("6Ekel");

var $3ceD0 = parcelRequire("3ceD0");

var $byzwF = parcelRequire("byzwF");

var $9gUBZ = parcelRequire("9gUBZ");

var $fcmvO = parcelRequire("fcmvO");

var $0r1IS = parcelRequire("0r1IS");

var $bwI2M = parcelRequire("bwI2M");

var $jHMox = parcelRequire("jHMox");

var $6aXXD = parcelRequire("6aXXD");
var $2560baebf6b9d1f1$var$EMPHASIS = 'emphasis';
var $2560baebf6b9d1f1$var$NORMAL = 'normal';
var $2560baebf6b9d1f1$var$BLUR = 'blur';
var $2560baebf6b9d1f1$var$SELECT = 'select';
var $2560baebf6b9d1f1$var$STATES = [
    $2560baebf6b9d1f1$var$NORMAL,
    $2560baebf6b9d1f1$var$EMPHASIS,
    $2560baebf6b9d1f1$var$BLUR,
    $2560baebf6b9d1f1$var$SELECT
];
var $2560baebf6b9d1f1$var$PATH_ITEM_STYLE = {
    normal: [
        'itemStyle'
    ],
    emphasis: [
        $2560baebf6b9d1f1$var$EMPHASIS,
        'itemStyle'
    ],
    blur: [
        $2560baebf6b9d1f1$var$BLUR,
        'itemStyle'
    ],
    select: [
        $2560baebf6b9d1f1$var$SELECT,
        'itemStyle'
    ]
};
var $2560baebf6b9d1f1$var$PATH_LABEL = {
    normal: [
        'label'
    ],
    emphasis: [
        $2560baebf6b9d1f1$var$EMPHASIS,
        'label'
    ],
    blur: [
        $2560baebf6b9d1f1$var$BLUR,
        'label'
    ],
    select: [
        $2560baebf6b9d1f1$var$SELECT,
        'label'
    ]
};
var $2560baebf6b9d1f1$var$DEFAULT_TRANSITION = [
    'x',
    'y'
];
// Use prefix to avoid index to be the same as el.name,
// which will cause weird update animation.
var $2560baebf6b9d1f1$var$GROUP_DIFF_PREFIX = 'e\0\0';
var $2560baebf6b9d1f1$var$attachedTxInfoTmp = {
    normal: {},
    emphasis: {},
    blur: {},
    select: {}
};
/**
 * FIXME: register rather than import directly, for size.
 *
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */ var $2560baebf6b9d1f1$var$prepareCustoms = {
    cartesian2d: (0, $4ObQ5.default),
    geo: (0, $iidqj.default),
    single: (0, $VSMXI.default),
    polar: (0, $28M2F.default),
    calendar: (0, $5Jh1o.default),
    matrix: (0, $cPztD.default)
};
function $2560baebf6b9d1f1$var$isPath(el) {
    return el instanceof $4oDJM.default;
}
function $2560baebf6b9d1f1$var$isDisplayable(el) {
    return el instanceof (0, $6Ekel.default);
}
function $2560baebf6b9d1f1$var$copyElement(sourceEl, targetEl) {
    targetEl.copyTransform(sourceEl);
    if ($2560baebf6b9d1f1$var$isDisplayable(targetEl) && $2560baebf6b9d1f1$var$isDisplayable(sourceEl)) {
        targetEl.setStyle(sourceEl.style);
        targetEl.z = sourceEl.z;
        targetEl.z2 = sourceEl.z2;
        targetEl.zlevel = sourceEl.zlevel;
        targetEl.invisible = sourceEl.invisible;
        targetEl.ignore = sourceEl.ignore;
        if ($2560baebf6b9d1f1$var$isPath(targetEl) && $2560baebf6b9d1f1$var$isPath(sourceEl)) targetEl.setShape(sourceEl.shape);
    }
}
var $2560baebf6b9d1f1$var$CustomChartView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CustomChartView, _super);
    function CustomChartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomChartView.type;
        return _this;
    }
    CustomChartView.prototype.render = function(customSeries, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var oldData = this._data;
        var data = customSeries.getData();
        var group = this.group;
        var renderItem = $2560baebf6b9d1f1$var$makeRenderItem(customSeries, data, ecModel, api);
        if (!oldData) // Previous render is incremental render or first render.
        // Needs remove the incremental rendered elements.
        group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            $2560baebf6b9d1f1$var$createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && (0, $0r1IS.applyLeaveTransition)(el, (0, $fcmvO.customInnerStore)(el).option, customSeries);
        }).update(function(newIdx, oldIdx) {
            var oldEl = oldData.getItemGraphicEl(oldIdx);
            $2560baebf6b9d1f1$var$createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).execute();
        // Do clipping
        var clipPath = customSeries.get('clip', true) ? (0, $dTvcN.createClipPath)(customSeries.coordinateSystem, false, customSeries) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
    };
    CustomChartView.prototype.incrementalPrepareRender = function(customSeries, ecModel, api) {
        this.group.removeAll();
        this._data = null;
    };
    CustomChartView.prototype.incrementalRender = function(params, customSeries, ecModel, api, payload) {
        var data = customSeries.getData();
        var renderItem = $2560baebf6b9d1f1$var$makeRenderItem(customSeries, data, ecModel, api);
        var progressiveEls = this._progressiveEls = [];
        function setIncrementalAndHoverLayer(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = params.start; idx < params.end; idx++){
            var el = $2560baebf6b9d1f1$var$createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);
            if (el) {
                el.traverse(setIncrementalAndHoverLayer);
                progressiveEls.push(el);
            }
        }
    };
    CustomChartView.prototype.eachRendered = function(cb) {
        $h9U3p.traverseElements(this._progressiveEls || this.group, cb);
    };
    CustomChartView.prototype.filterForExposedEvent = function(eventType, query, targetEl, packedEvent) {
        var elementName = query.element;
        if (elementName == null || targetEl.name === elementName) return true;
        // Enable to give a name on a group made by `renderItem`, and listen
        // events that are triggered by its descendents.
        while((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group){
            if (targetEl.name === elementName) return true;
        }
        return false;
    };
    CustomChartView.type = 'custom';
    return CustomChartView;
}((0, $cWIrM.default));
var $2560baebf6b9d1f1$export$2e2bcd8739ae039 = $2560baebf6b9d1f1$var$CustomChartView;
function $2560baebf6b9d1f1$var$createEl(elOption) {
    var graphicType = elOption.type;
    var el;
    // Those graphic elements are not shapes. They should not be
    // overwritten by users, so do them first.
    if (graphicType === 'path') {
        var shape = elOption.shape;
        // Using pathRect brings convenience to users sacle svg path.
        var pathRect = shape.width != null && shape.height != null ? {
            x: shape.x || 0,
            y: shape.y || 0,
            width: shape.width,
            height: shape.height
        } : null;
        var pathData = $2560baebf6b9d1f1$var$getPathData(shape);
        // Path is also used for icon, so layout 'center' by default.
        el = $h9U3p.makePath(pathData, null, pathRect, shape.layout || 'center');
        (0, $fcmvO.customInnerStore)(el).customPathData = pathData;
    } else if (graphicType === 'image') {
        el = new $lQsZt.default({});
        (0, $fcmvO.customInnerStore)(el).customImagePath = elOption.style.image;
    } else if (graphicType === 'text') el = new $kBKw3.default({});
    else if (graphicType === 'group') el = new $iQonF.default();
    else if (graphicType === 'compoundPath') {
        var shape = elOption.shape;
        if (!shape || !shape.paths) {
            var errMsg = '';
            (0, $byzwF.throwError)(errMsg);
        }
        var paths = (0, $2N6Uo.map)(shape.paths, function(path) {
            if (path.type === 'path') return $h9U3p.makePath(path.shape.pathData, path, null);
            var Clz = $h9U3p.getShapeClass(path.type);
            if (!Clz) {
                var errMsg = '';
                (0, $byzwF.throwError)(errMsg);
            }
            return new Clz();
        });
        el = new $5JZmf.default({
            shape: {
                paths: paths
            }
        });
    } else {
        var Clz = $h9U3p.getShapeClass(graphicType);
        if (!Clz) {
            var errMsg = '';
            (0, $byzwF.throwError)(errMsg);
        }
        el = new Clz();
    }
    (0, $fcmvO.customInnerStore)(el).customGraphicType = graphicType;
    el.name = elOption.name;
    // Compat ec4: the default z2 lift is 1. If changing the number,
    // some cases probably be broken: hierarchy layout along z, like circle packing,
    // where emphasis only intending to modify color/border rather than lift z2.
    el.z2EmphasisLift = 1;
    el.z2SelectLift = 1;
    return el;
}
function $2560baebf6b9d1f1$var$updateElNormal(// Can be null/undefined
api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
    // Stop and restore before update any other attributes.
    (0, $bwI2M.stopPreviousKeyframeAnimationAndRestore)(el);
    var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;
    if (txCfgOpt) // PENDING: whether use user object directly rather than clone?
    // TODO:5.0 textConfig transition animation?
    el.setTextConfig(txCfgOpt);
    // Default transition ['x', 'y']
    if (elOption && elOption.transition == null) elOption.transition = $2560baebf6b9d1f1$var$DEFAULT_TRANSITION;
    // Do some normalization on style.
    var styleOpt = elOption && elOption.style;
    if (styleOpt) {
        if (el.type === 'text') {
            var textOptionStyle = styleOpt;
            // Compatible with ec4: if `textFill` or `textStroke` exists use them.
            (0, $2N6Uo.hasOwn)(textOptionStyle, 'textFill') && (textOptionStyle.fill = textOptionStyle.textFill);
            (0, $2N6Uo.hasOwn)(textOptionStyle, 'textStroke') && (textOptionStyle.stroke = textOptionStyle.textStroke);
        }
        var decalPattern = void 0;
        var decalObj = $2560baebf6b9d1f1$var$isPath(el) ? styleOpt.decal : null;
        if (api && decalObj) {
            decalObj.dirty = true;
            decalPattern = (0, $9gUBZ.createOrUpdatePatternFromDecal)(decalObj, api);
        }
        // Always overwrite in case user specify this prop.
        styleOpt.__decalPattern = decalPattern;
    }
    if ($2560baebf6b9d1f1$var$isDisplayable(el)) {
        if (styleOpt) {
            var decalPattern = styleOpt.__decalPattern;
            if (decalPattern) styleOpt.decal = decalPattern;
        }
    }
    (0, $0r1IS.applyUpdateTransition)(el, elOption, seriesModel, {
        dataIndex: dataIndex,
        isInit: isInit,
        clearStyle: true
    });
    (0, $bwI2M.applyKeyframeAnimation)(el, elOption.keyframeAnimation, seriesModel);
}
function $2560baebf6b9d1f1$var$updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
    var elDisplayable = el.isGroup ? null : el;
    var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg;
    // PENDING:5.0 support customize scale change and transition animation?
    if (elDisplayable) {
        // By default support auto lift color when hover whether `emphasis` specified.
        var stateObj = elDisplayable.ensureState(state);
        if (styleOpt === false) {
            var existingEmphasisState = elDisplayable.getState(state);
            if (existingEmphasisState) existingEmphasisState.style = null;
        } else // style is needed to enable default emphasis.
        stateObj.style = styleOpt || null;
        // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
        // remove hover style.
        // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
        // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.
        if (txCfgOpt) stateObj.textConfig = txCfgOpt;
        (0, $bwPbQ.setDefaultStateProxy)(elDisplayable);
    }
}
function $2560baebf6b9d1f1$var$updateZ(el, elOption, seriesModel) {
    // Group not support textContent and not support z yet.
    if (el.isGroup) return;
    var elDisplayable = el;
    var currentZ = seriesModel.currentZ;
    var currentZLevel = seriesModel.currentZLevel;
    // Always erase.
    elDisplayable.z = currentZ;
    elDisplayable.zlevel = currentZLevel;
    // z2 must not be null/undefined, otherwise sort error may occur.
    var optZ2 = elOption.z2;
    optZ2 != null && (elDisplayable.z2 = optZ2 || 0);
    for(var i = 0; i < $2560baebf6b9d1f1$var$STATES.length; i++)$2560baebf6b9d1f1$var$updateZForEachState(elDisplayable, elOption, $2560baebf6b9d1f1$var$STATES[i]);
}
function $2560baebf6b9d1f1$var$updateZForEachState(elDisplayable, elOption, state) {
    var isNormal = state === $2560baebf6b9d1f1$var$NORMAL;
    var elStateOpt = isNormal ? elOption : $2560baebf6b9d1f1$var$retrieveStateOption(elOption, state);
    var optZ2 = elStateOpt ? elStateOpt.z2 : null;
    var stateObj;
    if (optZ2 != null) {
        // Do not `ensureState` until required.
        stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
        stateObj.z2 = optZ2 || 0;
    }
}
function $2560baebf6b9d1f1$var$makeRenderItem(customSeries, data, ecModel, api) {
    var renderItem = customSeries.get('renderItem');
    if (typeof renderItem === 'string') {
        // Find renderItem in registered custom series
        var registeredRenderItem = (0, $jHMox.getCustomSeries)(renderItem);
        if (registeredRenderItem) renderItem = registeredRenderItem;
    }
    var coordSys = customSeries.coordinateSystem;
    var prepareResult = {};
    if (coordSys) // `coordSys.prepareCustoms` is used for external coord sys like bmap.
    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : $2560baebf6b9d1f1$var$prepareCustoms[coordSys.type](coordSys);
    var userAPI = (0, $2N6Uo.defaults)({
        getWidth: api.getWidth,
        getHeight: api.getHeight,
        getZr: api.getZr,
        getDevicePixelRatio: api.getDevicePixelRatio,
        value: value,
        style: style,
        ordinalRawValue: ordinalRawValue,
        styleEmphasis: styleEmphasis,
        visual: visual,
        barLayout: barLayout,
        currentSeriesIndices: currentSeriesIndices,
        font: font
    }, prepareResult.api || {});
    var userParams = {
        // The life cycle of context: current round of rendering.
        // The global life cycle is probably not necessary, because
        // user can store global status by themselves.
        context: {},
        seriesId: customSeries.id,
        seriesName: customSeries.name,
        seriesIndex: customSeries.seriesIndex,
        coordSys: prepareResult.coordSys,
        dataInsideLength: data.count(),
        encode: $2560baebf6b9d1f1$var$wrapEncodeDef(customSeries.getData()),
        itemPayload: customSeries.get('itemPayload') || {}
    };
    // If someday intending to refactor them to a class, should consider do not
    // break change: currently these attribute member are encapsulated in a closure
    // so that do not need to force user to call these method with a scope.
    // Do not support call `api` asynchronously without dataIndexInside input.
    var currDataIndexInside;
    var currItemModel;
    var currItemStyleModels = {};
    var currLabelModels = {};
    var seriesItemStyleModels = {};
    var seriesLabelModels = {};
    for(var i = 0; i < $2560baebf6b9d1f1$var$STATES.length; i++){
        var stateName = $2560baebf6b9d1f1$var$STATES[i];
        seriesItemStyleModels[stateName] = customSeries.getModel($2560baebf6b9d1f1$var$PATH_ITEM_STYLE[stateName]);
        seriesLabelModels[stateName] = customSeries.getModel($2560baebf6b9d1f1$var$PATH_LABEL[stateName]);
    }
    function getItemModel(dataIndexInside) {
        return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
    }
    function getItemStyleModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel($2560baebf6b9d1f1$var$PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel($2560baebf6b9d1f1$var$PATH_ITEM_STYLE[state]);
    }
    function getLabelModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel($2560baebf6b9d1f1$var$PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel($2560baebf6b9d1f1$var$PATH_LABEL[state]);
    }
    return function(dataIndexInside, payload) {
        currDataIndexInside = dataIndexInside;
        currItemModel = null;
        currItemStyleModels = {};
        currLabelModels = {};
        return renderItem && renderItem((0, $2N6Uo.defaults)({
            dataIndexInside: dataIndexInside,
            dataIndex: data.getRawIndex(dataIndexInside),
            // Can be used for optimization when zoom or roam.
            actionType: payload ? payload.type : null
        }, userParams), userAPI);
    };
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function value(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
    }
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function ordinalRawValue(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        dim = dim || 0;
        var dimInfo = data.getDimensionInfo(dim);
        if (!dimInfo) {
            var dimIndex = data.getDimensionIndex(dim);
            return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
        }
        var val = data.get(dimInfo.name, dataIndexInside);
        var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
        return ordinalMeta ? ordinalMeta.categories[val] : val;
    }
    /**
   * @deprecated The original intention of `api.style` is enable to set itemStyle
   * like other series. But it is not necessary and not easy to give a strict definition
   * of what it returns. And since echarts5 it needs to be make compat work. So
   * deprecates it since echarts5.
   *
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   *
   * [Compat]: since ec5, RectText has been separated from its hosts el.
   * so `api.style()` will only return the style from `itemStyle` but not handle `label`
   * any more. But `series.label` config is never published in doc.
   * We still compat it in `api.style()`. But not encourage to use it and will still not
   * to pulish it to doc.
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function style(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var style = data.getItemVisual(dataIndexInside, 'style');
        var visualColor = style && style.fill;
        var opacity = style && style.opacity;
        var itemStyle = getItemStyleModel(dataIndexInside, $2560baebf6b9d1f1$var$NORMAL).getItemStyle();
        visualColor != null && (itemStyle.fill = visualColor);
        opacity != null && (itemStyle.opacity = opacity);
        var opt = {
            inheritColor: (0, $2N6Uo.isString)(visualColor) ? visualColor : (0, $6aXXD.default).color.neutral99
        };
        var labelModel = getLabelModel(dataIndexInside, $2560baebf6b9d1f1$var$NORMAL);
        // Now that the feature of "auto adjust text fill/stroke" has been migrated to zrender
        // since ec5, we should set `isAttached` as `false` here and make compat in
        // `convertToEC4StyleForCustomSerise`.
        var textStyle = $bysmE.createTextStyle(labelModel, null, opt, false, true);
        textStyle.text = labelModel.getShallow('show') ? (0, $2N6Uo.retrieve2)(customSeries.getFormattedLabel(dataIndexInside, $2560baebf6b9d1f1$var$NORMAL), (0, $d8wDg.getDefaultLabel)(data, dataIndexInside)) : null;
        var textConfig = $bysmE.createTextConfig(labelModel, opt, false);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $3ceD0.convertToEC4StyleForCustomSerise)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    /**
   * @deprecated The reason see `api.style()`
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function styleEmphasis(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var itemStyle = getItemStyleModel(dataIndexInside, $2560baebf6b9d1f1$var$EMPHASIS).getItemStyle();
        var labelModel = getLabelModel(dataIndexInside, $2560baebf6b9d1f1$var$EMPHASIS);
        var textStyle = $bysmE.createTextStyle(labelModel, null, null, true, true);
        textStyle.text = labelModel.getShallow('show') ? (0, $2N6Uo.retrieve3)(customSeries.getFormattedLabel(dataIndexInside, $2560baebf6b9d1f1$var$EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, $2560baebf6b9d1f1$var$NORMAL), (0, $d8wDg.getDefaultLabel)(data, dataIndexInside)) : null;
        var textConfig = $bysmE.createTextConfig(labelModel, null, true);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $3ceD0.convertToEC4StyleForCustomSerise)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    function applyUserPropsAfter(itemStyle, extra) {
        for(var key in extra)if ((0, $2N6Uo.hasOwn)(extra, key)) itemStyle[key] = extra[key];
    }
    function preFetchFromExtra(extra, itemStyle) {
        // A trick to retrieve those props firstly, which are used to
        // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
        // (It's not reasonable but only for a degree of compat)
        if (extra) {
            extra.textFill && (itemStyle.textFill = extra.textFill);
            extra.textPosition && (itemStyle.textPosition = extra.textPosition);
        }
    }
    /**
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function visual(visualType, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        if ((0, $2N6Uo.hasOwn)((0, $fcmvO.STYLE_VISUAL_TYPE), visualType)) {
            var style_1 = data.getItemVisual(dataIndexInside, 'style');
            return style_1 ? style_1[(0, $fcmvO.STYLE_VISUAL_TYPE)[visualType]] : null;
        }
        // Only support these visuals. Other visual might be inner tricky
        // for performance (like `style`), do not expose to users.
        if ((0, $2N6Uo.hasOwn)((0, $fcmvO.NON_STYLE_VISUAL_PROPS), visualType)) return data.getItemVisual(dataIndexInside, visualType);
    }
    /**
   * @public
   * @return If not support, return undefined.
   */ function barLayout(opt) {
        if (coordSys.type === 'cartesian2d') {
            var baseAxis = coordSys.getBaseAxis();
            return (0, $5qNR7.getLayoutOnAxis)((0, $2N6Uo.defaults)({
                axis: baseAxis
            }, opt));
        }
    }
    /**
   * @public
   */ function currentSeriesIndices() {
        return ecModel.getCurrentSeriesIndices();
    }
    /**
   * @public
   * @return font string
   */ function font(opt) {
        return $bysmE.getFont(opt, ecModel);
    }
}
function $2560baebf6b9d1f1$var$wrapEncodeDef(data) {
    var encodeDef = {};
    (0, $2N6Uo.each)(data.dimensions, function(dimName) {
        var dimInfo = data.getDimensionInfo(dimName);
        if (!dimInfo.isExtraCoord) {
            var coordDim = dimInfo.coordDim;
            var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
            dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
        }
    });
    return encodeDef;
}
function $2560baebf6b9d1f1$var$createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
    // [Rule]
    // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
    //     (It seems that violate the "merge" principle, but most of users probably intuitively
    //     regard "return;" as "show nothing element whatever", so make a exception to meet the
    //     most cases.)
    // The rule or "merge" see [STRATEGY_MERGE].
    // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
    if (!elOption) {
        group.remove(existsEl);
        return;
    }
    var el = $2560baebf6b9d1f1$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
    el && data.setItemGraphicEl(dataIndex, el);
    el && (0, $bwPbQ.toggleHoverEmphasis)(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
    return el;
}
function $2560baebf6b9d1f1$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
    var toBeReplacedIdx = -1;
    var oldEl = existsEl;
    if (existsEl && $2560baebf6b9d1f1$var$doesElNeedRecreate(existsEl, elOption, seriesModel)) {
        // Should keep at the original index, otherwise "merge by index" will be incorrect.
        toBeReplacedIdx = (0, $2N6Uo.indexOf)(group.childrenRef(), existsEl);
        existsEl = null;
    }
    var isInit = !existsEl;
    var el = existsEl;
    if (!el) {
        el = $2560baebf6b9d1f1$var$createEl(elOption);
        if (oldEl) $2560baebf6b9d1f1$var$copyElement(oldEl, el);
    } else // FIMXE:NEXT unified clearState?
    // If in some case the performance issue arised, consider
    // do not clearState but update cached normal state directly.
    el.clearStates();
    // Need to set morph: false explictly to disable automatically morphing.
    if (elOption.morph === false) el.disableMorphing = true;
    else if (el.disableMorphing) el.disableMorphing = false;
    if (elOption.tooltipDisabled) el.tooltipDisabled = true;
    $2560baebf6b9d1f1$var$attachedTxInfoTmp.normal.cfg = $2560baebf6b9d1f1$var$attachedTxInfoTmp.normal.conOpt = $2560baebf6b9d1f1$var$attachedTxInfoTmp.emphasis.cfg = $2560baebf6b9d1f1$var$attachedTxInfoTmp.emphasis.conOpt = $2560baebf6b9d1f1$var$attachedTxInfoTmp.blur.cfg = $2560baebf6b9d1f1$var$attachedTxInfoTmp.blur.conOpt = $2560baebf6b9d1f1$var$attachedTxInfoTmp.select.cfg = $2560baebf6b9d1f1$var$attachedTxInfoTmp.select.conOpt = null;
    $2560baebf6b9d1f1$var$attachedTxInfoTmp.isLegacy = false;
    $2560baebf6b9d1f1$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, $2560baebf6b9d1f1$var$attachedTxInfoTmp);
    $2560baebf6b9d1f1$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
    $2560baebf6b9d1f1$var$updateElNormal(api, el, dataIndex, elOption, $2560baebf6b9d1f1$var$attachedTxInfoTmp, seriesModel, isInit);
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    // Update them only when user specified, otherwise, remain.
    (0, $2N6Uo.hasOwn)(elOption, 'info') && ((0, $fcmvO.customInnerStore)(el).info = elOption.info);
    for(var i = 0; i < $2560baebf6b9d1f1$var$STATES.length; i++){
        var stateName = $2560baebf6b9d1f1$var$STATES[i];
        if (stateName !== $2560baebf6b9d1f1$var$NORMAL) {
            var otherStateOpt = $2560baebf6b9d1f1$var$retrieveStateOption(elOption, stateName);
            var otherStyleOpt = $2560baebf6b9d1f1$var$retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
            $2560baebf6b9d1f1$var$updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, $2560baebf6b9d1f1$var$attachedTxInfoTmp);
        }
    }
    $2560baebf6b9d1f1$var$updateZ(el, elOption, seriesModel);
    if (elOption.type === 'group') $2560baebf6b9d1f1$var$mergeChildren(api, el, dataIndex, elOption, seriesModel);
    if (toBeReplacedIdx >= 0) group.replaceAt(el, toBeReplacedIdx);
    else group.add(el);
    return el;
}
// `el` must not be null/undefined.
function $2560baebf6b9d1f1$var$doesElNeedRecreate(el, elOption, seriesModel) {
    var elInner = (0, $fcmvO.customInnerStore)(el);
    var elOptionType = elOption.type;
    var elOptionShape = elOption.shape;
    var elOptionStyle = elOption.style;
    return(// Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    seriesModel.isUniversalTransitionEnabled() || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === 'path' && $2560baebf6b9d1f1$var$hasOwnPathData(elOptionShape) && $2560baebf6b9d1f1$var$getPathData(elOptionShape) !== elInner.customPathData || elOptionType === 'image' && (0, $2N6Uo.hasOwn)(elOptionStyle, 'image') && elOptionStyle.image !== elInner.customImagePath);
}
function $2560baebf6b9d1f1$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
    // Based on the "merge" principle, if no clipPath provided,
    // do nothing. The exists clip will be totally removed only if
    // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
    var clipPathOpt = elOption.clipPath;
    if (clipPathOpt === false) {
        if (el && el.getClipPath()) el.removeClipPath();
    } else if (clipPathOpt) {
        var clipPath = el.getClipPath();
        if (clipPath && $2560baebf6b9d1f1$var$doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) clipPath = null;
        if (!clipPath) {
            clipPath = $2560baebf6b9d1f1$var$createEl(clipPathOpt);
            el.setClipPath(clipPath);
        }
        $2560baebf6b9d1f1$var$updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
    }
// If not define `clipPath` in option, do nothing unnecessary.
}
function $2560baebf6b9d1f1$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
    // Group does not support textContent temporarily until necessary.
    if (el.isGroup || el.type === 'compoundPath') return;
    // Normal must be called before emphasis, for `isLegacy` detection.
    $2560baebf6b9d1f1$var$processTxInfo(elOption, null, attachedTxInfo);
    $2560baebf6b9d1f1$var$processTxInfo(elOption, $2560baebf6b9d1f1$var$EMPHASIS, attachedTxInfo);
    // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sense.
    // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
    // trade them as set to null to el.
    // Especially:
    // `elOption.textContent: false` means remove textContent.
    // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.
    var txConOptNormal = attachedTxInfo.normal.conOpt;
    var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
    var txConOptBlur = attachedTxInfo.blur.conOpt;
    var txConOptSelect = attachedTxInfo.select.conOpt;
    if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
        var textContent = el.getTextContent();
        if (txConOptNormal === false) textContent && el.removeTextContent();
        else {
            txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
                type: 'text'
            };
            if (!textContent) {
                textContent = $2560baebf6b9d1f1$var$createEl(txConOptNormal);
                el.setTextContent(textContent);
            } else // If in some case the performance issue arised, consider
            // do not clearState but update cached normal state directly.
            textContent.clearStates();
            $2560baebf6b9d1f1$var$updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
            var txConStlOptNormal = txConOptNormal && txConOptNormal.style;
            for(var i = 0; i < $2560baebf6b9d1f1$var$STATES.length; i++){
                var stateName = $2560baebf6b9d1f1$var$STATES[i];
                if (stateName !== $2560baebf6b9d1f1$var$NORMAL) {
                    var txConOptOtherState = attachedTxInfo[stateName].conOpt;
                    $2560baebf6b9d1f1$var$updateElOnState(stateName, textContent, txConOptOtherState, $2560baebf6b9d1f1$var$retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
                }
            }
            txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
        }
    }
}
function $2560baebf6b9d1f1$var$processTxInfo(elOption, state, attachedTxInfo) {
    var stateOpt = !state ? elOption : $2560baebf6b9d1f1$var$retrieveStateOption(elOption, state);
    var styleOpt = !state ? elOption.style : $2560baebf6b9d1f1$var$retrieveStyleOptionOnState(elOption, stateOpt, $2560baebf6b9d1f1$var$EMPHASIS);
    var elType = elOption.type;
    var txCfg = stateOpt ? stateOpt.textConfig : null;
    var txConOptNormal = elOption.textContent;
    var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : $2560baebf6b9d1f1$var$retrieveStateOption(txConOptNormal, state);
    if (styleOpt && // Because emphasis style has little info to detect legacy,
    // if normal is legacy, emphasis is trade as legacy.
    (attachedTxInfo.isLegacy || (0, $3ceD0.isEC4CompatibleStyle)(styleOpt, elType, !!txCfg, !!txConOpt))) {
        attachedTxInfo.isLegacy = true;
        var convertResult = (0, $3ceD0.convertFromEC4CompatibleStyle)(styleOpt, elType, !state);
        // Explicitly specified `textConfig` and `textContent` has higher priority than
        // the ones generated by legacy style. Otherwise if users use them and `api.style`
        // at the same time, they not both work and hardly to known why.
        if (!txCfg && convertResult.textConfig) txCfg = convertResult.textConfig;
        if (!txConOpt && convertResult.textContent) txConOpt = convertResult.textContent;
    }
    if (!state && txConOpt) {
        var txConOptNormal_1 = txConOpt;
        // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.
        !txConOptNormal_1.type && (txConOptNormal_1.type = 'text');
    }
    var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
    info.cfg = txCfg;
    info.conOpt = txConOpt;
}
function $2560baebf6b9d1f1$var$retrieveStateOption(elOption, state) {
    return !state ? elOption : elOption ? elOption[state] : null;
}
function $2560baebf6b9d1f1$var$retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
    var style = stateOption && stateOption.style;
    if (style == null && state === $2560baebf6b9d1f1$var$EMPHASIS && stateOptionNormal) style = stateOptionNormal.styleEmphasis;
    return style;
}
// Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates
//     that the existing children will not be removed, and enables the feature
//     that update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will
//     happen.
// (5) If `elOption.$mergeChildren` is not `false` neither `'byName'` and the
//     `el` is a group, and if any of the new child is null, it means to remove
//     the element at the same index, if exists. On the other hand, if the new
//     child is and empty object `{}`, it means to keep the element not changed.
//
// For implementation simpleness, do not provide a direct way to remove single
// child (otherwise the total indices of the children array have to be modified).
// User can remove a single child by setting its `ignore` to `true`.
function $2560baebf6b9d1f1$var$mergeChildren(api, el, dataIndex, elOption, seriesModel) {
    var newChildren = elOption.children;
    var newLen = newChildren ? newChildren.length : 0;
    var mergeChildren = elOption.$mergeChildren;
    // `diffChildrenByName` has been deprecated.
    var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
    var notMerge = mergeChildren === false;
    // For better performance on roam update, only enter if necessary.
    if (!newLen && !byName && !notMerge) return;
    if (byName) {
        $2560baebf6b9d1f1$var$diffGroupChildren({
            api: api,
            oldChildren: el.children() || [],
            newChildren: newChildren || [],
            dataIndex: dataIndex,
            seriesModel: seriesModel,
            group: el
        });
        return;
    }
    notMerge && el.removeAll();
    // Mapping children of a group simply by index, which
    // might be better performance.
    var index = 0;
    for(; index < newLen; index++){
        var newChild = newChildren[index];
        var oldChild = el.childAt(index);
        if (newChild) {
            if (newChild.ignore == null) // The old child is set to be ignored if null (see comments
            // below). So we need to set ignore to be false back.
            newChild.ignore = false;
            $2560baebf6b9d1f1$var$doCreateOrUpdateEl(api, oldChild, dataIndex, newChild, seriesModel, el);
        } else // If the new element option is null, it means to remove the old
        // element. But we cannot really remove the element from the group
        // directly, because the element order may not be stable when this
        // element is added back. So we set the element to be ignored.
        oldChild.ignore = true;
    }
    for(var i = el.childCount() - 1; i >= index; i--){
        var child = el.childAt(i);
        $2560baebf6b9d1f1$var$removeChildFromGroup(el, child, seriesModel);
    }
}
function $2560baebf6b9d1f1$var$removeChildFromGroup(group, child, seriesModel) {
    // Do not support leave elements that are not mentioned in the latest
    // `renderItem` return. Otherwise users may not have a clear and simple
    // concept that how to control all of the elements.
    child && (0, $0r1IS.applyLeaveTransition)(child, (0, $fcmvO.customInnerStore)(group).option, seriesModel);
}
function $2560baebf6b9d1f1$var$diffGroupChildren(context) {
    new (0, $chf3v.default)(context.oldChildren, context.newChildren, $2560baebf6b9d1f1$var$getKey, $2560baebf6b9d1f1$var$getKey, context).add($2560baebf6b9d1f1$var$processAddUpdate).update($2560baebf6b9d1f1$var$processAddUpdate).remove($2560baebf6b9d1f1$var$processRemove).execute();
}
function $2560baebf6b9d1f1$var$getKey(item, idx) {
    var name = item && item.name;
    return name != null ? name : $2560baebf6b9d1f1$var$GROUP_DIFF_PREFIX + idx;
}
function $2560baebf6b9d1f1$var$processAddUpdate(newIndex, oldIndex) {
    var context = this.context;
    var childOption = newIndex != null ? context.newChildren[newIndex] : null;
    var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
    $2560baebf6b9d1f1$var$doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
}
function $2560baebf6b9d1f1$var$processRemove(oldIndex) {
    var context = this.context;
    var child = context.oldChildren[oldIndex];
    child && (0, $0r1IS.applyLeaveTransition)(child, (0, $fcmvO.customInnerStore)(child).option, context.seriesModel);
}
/**
 * @return SVG Path data.
 */ function $2560baebf6b9d1f1$var$getPathData(shape) {
    // "d" follows the SVG convention.
    return shape && (shape.pathData || shape.d);
}
function $2560baebf6b9d1f1$var$hasOwnPathData(shape) {
    return shape && ((0, $2N6Uo.hasOwn)(shape, 'pathData') || (0, $2N6Uo.hasOwn)(shape, 'd'));
}

});
parcelRegister("4ObQ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $380503ef53248abc$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $380503ef53248abc$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $2N6Uo.map([
        'x',
        'y'
    ], function(dim, dimIdx) {
        var axis = this.getAxis(dim);
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
    }, this);
}
function $380503ef53248abc$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.master.getRect();
    return {
        coordSys: {
            // The name exposed to user is always 'cartesian2d' but not 'grid'.
            type: 'cartesian2d',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data) {
                // do not provide "out" param
                return coordSys.dataToPoint(data);
            },
            size: $2N6Uo.bind($380503ef53248abc$var$dataToCoordSize, coordSys)
        }
    };
}

});

parcelRegister("iidqj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d514520fa696498a$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $d514520fa696498a$var$dataToCoordSize(dataSize, dataItem) {
    dataItem = dataItem || [
        0,
        0
    ];
    return $2N6Uo.map([
        0,
        1
    ], function(dimIdx) {
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var p1 = [];
        var p2 = [];
        p1[dimIdx] = val - halfSize;
        p2[dimIdx] = val + halfSize;
        p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
        return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
    }, this);
}
function $d514520fa696498a$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getBoundingRect();
    return {
        coordSys: {
            type: 'geo',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            zoom: coordSys.getZoom()
        },
        api: {
            coord: function(data) {
                // do not provide "out" and noRoam param,
                // Compatible with this usage:
                // echarts.util.map(item.points, api.coord)
                return coordSys.dataToPoint(data);
            },
            size: $2N6Uo.bind($d514520fa696498a$var$dataToCoordSize, coordSys)
        }
    };
}

});

parcelRegister("VSMXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0adfd2e1f46c0234$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $0adfd2e1f46c0234$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    var axis = this.getAxis();
    var val = dataItem instanceof Array ? dataItem[0] : dataItem;
    var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}
function $0adfd2e1f46c0234$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: 'singleAxis',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(val) {
                // do not provide "out" param
                return coordSys.dataToPoint(val);
            },
            size: (0, $2N6Uo.bind)($0adfd2e1f46c0234$var$dataToCoordSize, coordSys)
        }
    };
}

});

parcelRegister("28M2F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18f1984886e8058e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
// import AngleAxis from './AngleAxis.js';
function $18f1984886e8058e$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $2N6Uo.map([
        'Radius',
        'Angle'
    ], function(dim, dimIdx) {
        var getterName = 'get' + dim + 'Axis';
        // TODO: TYPE Check Angle Axis
        var axis = this[getterName]();
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
        if (dim === 'Angle') result = result * Math.PI / 180;
        return result;
    }, this);
}
function $18f1984886e8058e$export$2e2bcd8739ae039(coordSys) {
    var radiusAxis = coordSys.getRadiusAxis();
    var angleAxis = coordSys.getAngleAxis();
    var radius = radiusAxis.getExtent();
    radius[0] > radius[1] && radius.reverse();
    return {
        coordSys: {
            type: 'polar',
            cx: coordSys.cx,
            cy: coordSys.cy,
            r: radius[1],
            r0: radius[0]
        },
        api: {
            coord: function(data) {
                var radius = radiusAxis.dataToRadius(data[0]);
                var angle = angleAxis.dataToAngle(data[1]);
                var coord = coordSys.coordToPoint([
                    radius,
                    angle
                ]);
                coord.push(radius, angle * Math.PI / 180);
                return coord;
            },
            size: $2N6Uo.bind($18f1984886e8058e$var$dataToCoordSize, coordSys)
        }
    };
}

});

parcelRegister("5Jh1o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42be5bce4902efba$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $42be5bce4902efba$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    var rangeInfo = coordSys.getRangeInfo();
    return {
        coordSys: {
            type: 'calendar',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            cellWidth: coordSys.getCellWidth(),
            cellHeight: coordSys.getCellHeight(),
            rangeInfo: {
                start: rangeInfo.start,
                end: rangeInfo.end,
                weeks: rangeInfo.weeks,
                dayCount: rangeInfo.allDay
            }
        },
        api: {
            coord: function(data, clamp) {
                return coordSys.dataToPoint(data, clamp);
            },
            layout: function(data, clamp) {
                return coordSys.dataToLayout(data, clamp);
            }
        }
    };
}

});

parcelRegister("cPztD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9575c47429983a73$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $9575c47429983a73$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: 'matrix',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data, opt) {
                return coordSys.dataToPoint(data, opt);
            },
            layout: function(data, opt) {
                return coordSys.dataToLayout(data, opt);
            }
        }
    };
}

});

parcelRegister("3ceD0", function(module, exports) {

$parcel$export(module.exports, "isEC4CompatibleStyle", function () { return $253dd6e77226b688$export$3b868abde5eae7d1; });
$parcel$export(module.exports, "convertFromEC4CompatibleStyle", function () { return $253dd6e77226b688$export$7748133eaaa8aecc; });
$parcel$export(module.exports, "convertToEC4StyleForCustomSerise", function () { return $253dd6e77226b688$export$b8ddb75bd1b9b791; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $6aXXD = parcelRequire("6aXXD");
var $253dd6e77226b688$var$deprecatedLogs = {};
function $253dd6e77226b688$export$3b868abde5eae7d1(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
    // Since echarts5, `RectText` is separated from its host element and style.text
    // does not exist any more. The compat work brings some extra burden on performance.
    // So we provide:
    // `legacy: true` force make compat.
    // `legacy: false`, force do not compat.
    // `legacy` not set: auto detect whether legacy.
    //     But in this case we do not compat (difficult to detect and rare case):
    //     Because custom series and graphic component support "merge", users may firstly
    //     only set `textStrokeWidth` style or secondly only set `text`.
    return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== 'tspan' && (elType === 'text' || (0, $2N6Uo.hasOwn)(style, 'text')));
}
function $253dd6e77226b688$export$7748133eaaa8aecc(hostStyle, elType, isNormal) {
    var srcStyle = hostStyle;
    var textConfig;
    var textContent;
    var textContentStyle;
    if (elType === 'text') textContentStyle = srcStyle;
    else {
        textContentStyle = {};
        (0, $2N6Uo.hasOwn)(srcStyle, 'text') && (textContentStyle.text = srcStyle.text);
        (0, $2N6Uo.hasOwn)(srcStyle, 'rich') && (textContentStyle.rich = srcStyle.rich);
        (0, $2N6Uo.hasOwn)(srcStyle, 'textFill') && (textContentStyle.fill = srcStyle.textFill);
        (0, $2N6Uo.hasOwn)(srcStyle, 'textStroke') && (textContentStyle.stroke = srcStyle.textStroke);
        (0, $2N6Uo.hasOwn)(srcStyle, 'fontFamily') && (textContentStyle.fontFamily = srcStyle.fontFamily);
        (0, $2N6Uo.hasOwn)(srcStyle, 'fontSize') && (textContentStyle.fontSize = srcStyle.fontSize);
        (0, $2N6Uo.hasOwn)(srcStyle, 'fontStyle') && (textContentStyle.fontStyle = srcStyle.fontStyle);
        (0, $2N6Uo.hasOwn)(srcStyle, 'fontWeight') && (textContentStyle.fontWeight = srcStyle.fontWeight);
        textContent = {
            type: 'text',
            style: textContentStyle,
            // ec4 does not support rectText trigger.
            // And when text position is different in normal and emphasis
            // => hover text trigger emphasis;
            // => text position changed, leave mouse pointer immediately;
            // That might cause incorrect state.
            silent: true
        };
        textConfig = {};
        var hasOwnPos = (0, $2N6Uo.hasOwn)(srcStyle, 'textPosition');
        if (isNormal) textConfig.position = hasOwnPos ? srcStyle.textPosition : 'inside';
        else hasOwnPos && (textConfig.position = srcStyle.textPosition);
        (0, $2N6Uo.hasOwn)(srcStyle, 'textPosition') && (textConfig.position = srcStyle.textPosition);
        (0, $2N6Uo.hasOwn)(srcStyle, 'textOffset') && (textConfig.offset = srcStyle.textOffset);
        (0, $2N6Uo.hasOwn)(srcStyle, 'textRotation') && (textConfig.rotation = srcStyle.textRotation);
        (0, $2N6Uo.hasOwn)(srcStyle, 'textDistance') && (textConfig.distance = srcStyle.textDistance);
    }
    $253dd6e77226b688$var$convertEC4CompatibleRichItem(textContentStyle, hostStyle);
    (0, $2N6Uo.each)(textContentStyle.rich, function(richItem) {
        $253dd6e77226b688$var$convertEC4CompatibleRichItem(richItem, richItem);
    });
    return {
        textConfig: textConfig,
        textContent: textContent
    };
}
/**
 * The result will be set to `out`.
 */ function $253dd6e77226b688$var$convertEC4CompatibleRichItem(out, richItem) {
    if (!richItem) return;
    // (1) For simplicity, make textXXX properties (deprecated since ec5) has
    // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
    // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
    // richText in ec5.
    // (2) `out === richItem` if and only if `out` is text el or rich item.
    // So we can overwrite existing props in `out` since textXXX has higher priority.
    richItem.font = richItem.textFont || richItem.font;
    (0, $2N6Uo.hasOwn)(richItem, 'textStrokeWidth') && (out.lineWidth = richItem.textStrokeWidth);
    (0, $2N6Uo.hasOwn)(richItem, 'textAlign') && (out.align = richItem.textAlign);
    (0, $2N6Uo.hasOwn)(richItem, 'textVerticalAlign') && (out.verticalAlign = richItem.textVerticalAlign);
    (0, $2N6Uo.hasOwn)(richItem, 'textLineHeight') && (out.lineHeight = richItem.textLineHeight);
    (0, $2N6Uo.hasOwn)(richItem, 'textWidth') && (out.width = richItem.textWidth);
    (0, $2N6Uo.hasOwn)(richItem, 'textHeight') && (out.height = richItem.textHeight);
    (0, $2N6Uo.hasOwn)(richItem, 'textBackgroundColor') && (out.backgroundColor = richItem.textBackgroundColor);
    (0, $2N6Uo.hasOwn)(richItem, 'textPadding') && (out.padding = richItem.textPadding);
    (0, $2N6Uo.hasOwn)(richItem, 'textBorderColor') && (out.borderColor = richItem.textBorderColor);
    (0, $2N6Uo.hasOwn)(richItem, 'textBorderWidth') && (out.borderWidth = richItem.textBorderWidth);
    (0, $2N6Uo.hasOwn)(richItem, 'textBorderRadius') && (out.borderRadius = richItem.textBorderRadius);
    (0, $2N6Uo.hasOwn)(richItem, 'textBoxShadowColor') && (out.shadowColor = richItem.textBoxShadowColor);
    (0, $2N6Uo.hasOwn)(richItem, 'textBoxShadowBlur') && (out.shadowBlur = richItem.textBoxShadowBlur);
    (0, $2N6Uo.hasOwn)(richItem, 'textBoxShadowOffsetX') && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
    (0, $2N6Uo.hasOwn)(richItem, 'textBoxShadowOffsetY') && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
}
function $253dd6e77226b688$export$b8ddb75bd1b9b791(itemStl, txStl, txCfg) {
    var out = itemStl;
    // See `custom.ts`, a trick to set extra `textPosition` firstly.
    out.textPosition = out.textPosition || txCfg.position || 'inside';
    txCfg.offset != null && (out.textOffset = txCfg.offset);
    txCfg.rotation != null && (out.textRotation = txCfg.rotation);
    txCfg.distance != null && (out.textDistance = txCfg.distance);
    var isInside = out.textPosition.indexOf('inside') >= 0;
    var hostFill = itemStl.fill || (0, $6aXXD.default).color.neutral99;
    $253dd6e77226b688$var$convertToEC4RichItem(out, txStl);
    var textFillNotSet = out.textFill == null;
    if (isInside) {
        if (textFillNotSet) {
            out.textFill = txCfg.insideFill || (0, $6aXXD.default).color.neutral00;
            !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
            !out.textStroke && (out.textStroke = hostFill);
            out.textStrokeWidth == null && (out.textStrokeWidth = 2);
        }
    } else {
        if (textFillNotSet) out.textFill = itemStl.fill || txCfg.outsideFill || (0, $6aXXD.default).color.neutral00;
        !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
    }
    out.text = txStl.text;
    out.rich = txStl.rich;
    (0, $2N6Uo.each)(txStl.rich, function(richItem) {
        $253dd6e77226b688$var$convertToEC4RichItem(richItem, richItem);
    });
    return out;
}
function $253dd6e77226b688$var$convertToEC4RichItem(out, richItem) {
    if (!richItem) return;
    (0, $2N6Uo.hasOwn)(richItem, 'fill') && (out.textFill = richItem.fill);
    (0, $2N6Uo.hasOwn)(richItem, 'stroke') && (out.textStroke = richItem.fill);
    (0, $2N6Uo.hasOwn)(richItem, 'lineWidth') && (out.textStrokeWidth = richItem.lineWidth);
    (0, $2N6Uo.hasOwn)(richItem, 'font') && (out.font = richItem.font);
    (0, $2N6Uo.hasOwn)(richItem, 'fontStyle') && (out.fontStyle = richItem.fontStyle);
    (0, $2N6Uo.hasOwn)(richItem, 'fontWeight') && (out.fontWeight = richItem.fontWeight);
    (0, $2N6Uo.hasOwn)(richItem, 'fontSize') && (out.fontSize = richItem.fontSize);
    (0, $2N6Uo.hasOwn)(richItem, 'fontFamily') && (out.fontFamily = richItem.fontFamily);
    (0, $2N6Uo.hasOwn)(richItem, 'align') && (out.textAlign = richItem.align);
    (0, $2N6Uo.hasOwn)(richItem, 'verticalAlign') && (out.textVerticalAlign = richItem.verticalAlign);
    (0, $2N6Uo.hasOwn)(richItem, 'lineHeight') && (out.textLineHeight = richItem.lineHeight);
    (0, $2N6Uo.hasOwn)(richItem, 'width') && (out.textWidth = richItem.width);
    (0, $2N6Uo.hasOwn)(richItem, 'height') && (out.textHeight = richItem.height);
    (0, $2N6Uo.hasOwn)(richItem, 'backgroundColor') && (out.textBackgroundColor = richItem.backgroundColor);
    (0, $2N6Uo.hasOwn)(richItem, 'padding') && (out.textPadding = richItem.padding);
    (0, $2N6Uo.hasOwn)(richItem, 'borderColor') && (out.textBorderColor = richItem.borderColor);
    (0, $2N6Uo.hasOwn)(richItem, 'borderWidth') && (out.textBorderWidth = richItem.borderWidth);
    (0, $2N6Uo.hasOwn)(richItem, 'borderRadius') && (out.textBorderRadius = richItem.borderRadius);
    (0, $2N6Uo.hasOwn)(richItem, 'shadowColor') && (out.textBoxShadowColor = richItem.shadowColor);
    (0, $2N6Uo.hasOwn)(richItem, 'shadowBlur') && (out.textBoxShadowBlur = richItem.shadowBlur);
    (0, $2N6Uo.hasOwn)(richItem, 'shadowOffsetX') && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
    (0, $2N6Uo.hasOwn)(richItem, 'shadowOffsetY') && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
    (0, $2N6Uo.hasOwn)(richItem, 'textShadowColor') && (out.textShadowColor = richItem.textShadowColor);
    (0, $2N6Uo.hasOwn)(richItem, 'textShadowBlur') && (out.textShadowBlur = richItem.textShadowBlur);
    (0, $2N6Uo.hasOwn)(richItem, 'textShadowOffsetX') && (out.textShadowOffsetX = richItem.textShadowOffsetX);
    (0, $2N6Uo.hasOwn)(richItem, 'textShadowOffsetY') && (out.textShadowOffsetY = richItem.textShadowOffsetY);
}
function $253dd6e77226b688$export$606a5c06d13e04b6(deprecated, insteadApproach) {
    var key;
}

});

parcelRegister("0r1IS", function(module, exports) {

$parcel$export(module.exports, "ELEMENT_ANIMATABLE_PROPS", function () { return $0014f72894402f77$export$9a911ad86e905b13; });
$parcel$export(module.exports, "applyUpdateTransition", function () { return $0014f72894402f77$export$4342b281b9b5d77e; });
$parcel$export(module.exports, "updateLeaveTo", function () { return $0014f72894402f77$export$a6f11bb1cb100e2a; });
$parcel$export(module.exports, "applyLeaveTransition", function () { return $0014f72894402f77$export$15575b6d82d35bb3; });
$parcel$export(module.exports, "isTransitionAll", function () { return $0014f72894402f77$export$6f3361b4b8d7a8ba; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $GuYp4 = parcelRequire("GuYp4");

var $6Ekel = parcelRequire("6Ekel");

var $ipprj = parcelRequire("ipprj");
parcelRequire("h9U3p");
var $4oDJM = parcelRequire("4oDJM");


var $erz95 = parcelRequire("erz95");
var $0014f72894402f77$var$LEGACY_TRANSFORM_PROPS_MAP = {
    position: [
        'x',
        'y'
    ],
    scale: [
        'scaleX',
        'scaleY'
    ],
    origin: [
        'originX',
        'originY'
    ]
};
var $0014f72894402f77$var$LEGACY_TRANSFORM_PROPS = (0, $2N6Uo.keys)($0014f72894402f77$var$LEGACY_TRANSFORM_PROPS_MAP);
var $0014f72894402f77$var$TRANSFORM_PROPS_MAP = (0, $2N6Uo.reduce)((0, $erz95.TRANSFORMABLE_PROPS), function(obj, key) {
    obj[key] = 1;
    return obj;
}, {});
var $0014f72894402f77$var$transformPropNamesStr = (0, $erz95.TRANSFORMABLE_PROPS).join(', ');
var $0014f72894402f77$export$9a911ad86e905b13 = [
    '',
    'style',
    'shape',
    'extra'
];
var $0014f72894402f77$var$transitionInnerStore = (0, $bx3T8.makeInner)();
function $0014f72894402f77$var$getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
    var animationProp = animationType + "Animation";
    var config = (0, $ipprj.getAnimationConfig)(animationType, parentModel, dataIndex) || {};
    var userDuring = $0014f72894402f77$var$transitionInnerStore(el).userDuring;
    // Only set when duration is > 0 and it's need to be animated.
    if (config.duration > 0) {
        // For simplicity, if during not specified, the previous during will not work any more.
        config.during = userDuring ? (0, $2N6Uo.bind)($0014f72894402f77$var$duringCall, {
            el: el,
            userDuring: userDuring
        }) : null;
        config.setToFinal = true;
        config.scope = animationType;
    }
    (0, $2N6Uo.extend)(config, elOption[animationProp]);
    return config;
}
function $0014f72894402f77$export$4342b281b9b5d77e(el, elOption, animatableModel, opts) {
    opts = opts || {};
    var dataIndex = opts.dataIndex, isInit = opts.isInit, clearStyle = opts.clearStyle;
    var hasAnimation = animatableModel.isAnimationEnabled();
    // Save the meta info for further morphing. Like apply on the sub morphing elements.
    var store = $0014f72894402f77$var$transitionInnerStore(el);
    var styleOpt = elOption.style;
    store.userDuring = elOption.during;
    var transFromProps = {};
    var propsToSet = {};
    $0014f72894402f77$var$prepareTransformAllPropsFinal(el, elOption, propsToSet);
    if (el.type === 'compound') {
        /**
     * We cannot directly clone shape for compoundPath,
     * because it makes the path to be an object instead of a Path instance,
     * and thus missing `buildPath` method.
     */ var paths = el.shape.paths;
        var optionPaths = elOption.shape.paths;
        for(var i = 0; i < optionPaths.length; i++){
            var path = optionPaths[i];
            $0014f72894402f77$var$prepareShapeOrExtraAllPropsFinal('shape', path, paths[i]);
        }
    } else {
        $0014f72894402f77$var$prepareShapeOrExtraAllPropsFinal('shape', elOption, propsToSet);
        $0014f72894402f77$var$prepareShapeOrExtraAllPropsFinal('extra', elOption, propsToSet);
    }
    if (!isInit && hasAnimation) {
        $0014f72894402f77$var$prepareTransformTransitionFrom(el, elOption, transFromProps);
        $0014f72894402f77$var$prepareShapeOrExtraTransitionFrom('shape', el, elOption, transFromProps);
        $0014f72894402f77$var$prepareShapeOrExtraTransitionFrom('extra', el, elOption, transFromProps);
        $0014f72894402f77$var$prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
    }
    propsToSet.style = styleOpt;
    $0014f72894402f77$var$applyPropsDirectly(el, propsToSet, clearStyle);
    $0014f72894402f77$var$applyMiscProps(el, elOption);
    if (hasAnimation) {
        if (isInit) {
            var enterFromProps_1 = {};
            (0, $2N6Uo.each)($0014f72894402f77$export$9a911ad86e905b13, function(propName) {
                var prop = propName ? elOption[propName] : elOption;
                if (prop && prop.enterFrom) {
                    if (propName) enterFromProps_1[propName] = enterFromProps_1[propName] || {};
                    (0, $2N6Uo.extend)(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
                }
            });
            var config = $0014f72894402f77$var$getElementAnimationConfig('enter', el, elOption, animatableModel, dataIndex);
            if (config.duration > 0) el.animateFrom(enterFromProps_1, config);
        } else $0014f72894402f77$var$applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
    }
    // Store leave to be used in leave transition.
    $0014f72894402f77$export$a6f11bb1cb100e2a(el, elOption);
    styleOpt ? el.dirty() : el.markRedraw();
}
function $0014f72894402f77$export$a6f11bb1cb100e2a(el, elOption) {
    // Try merge to previous set leaveTo
    var leaveToProps = $0014f72894402f77$var$transitionInnerStore(el).leaveToProps;
    for(var i = 0; i < $0014f72894402f77$export$9a911ad86e905b13.length; i++){
        var propName = $0014f72894402f77$export$9a911ad86e905b13[i];
        var prop = propName ? elOption[propName] : elOption;
        if (prop && prop.leaveTo) {
            if (!leaveToProps) leaveToProps = $0014f72894402f77$var$transitionInnerStore(el).leaveToProps = {};
            if (propName) leaveToProps[propName] = leaveToProps[propName] || {};
            (0, $2N6Uo.extend)(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
        }
    }
}
function $0014f72894402f77$export$15575b6d82d35bb3(el, elOption, animatableModel, onRemove) {
    if (el) {
        var parent_1 = el.parent;
        var leaveToProps = $0014f72894402f77$var$transitionInnerStore(el).leaveToProps;
        if (leaveToProps) {
            // TODO TODO use leave after leaveAnimation in series is introduced
            // TODO Data index?
            var config = $0014f72894402f77$var$getElementAnimationConfig('update', el, elOption, animatableModel, 0);
            config.done = function() {
                parent_1 && parent_1.remove(el);
                onRemove && onRemove();
            };
            el.animateTo(leaveToProps, config);
        } else {
            parent_1 && parent_1.remove(el);
            onRemove && onRemove();
        }
    }
}
function $0014f72894402f77$export$6f3361b4b8d7a8ba(transition) {
    return transition === 'all';
}
function $0014f72894402f77$var$applyPropsDirectly(el, // Can be null/undefined
allPropsFinal, clearStyle) {
    var styleOpt = allPropsFinal.style;
    if (!el.isGroup && styleOpt) {
        if (clearStyle) {
            el.useStyle({});
            // When style object changed, how to trade the existing animation?
            // It is probably complicated and not needed to cover all the cases.
            // But still need consider the case:
            // (1) When using init animation on `style.opacity`, and before the animation
            //     ended users triggers an update by mousewhel. At that time the init
            //     animation should better be continued rather than terminated.
            //     So after `useStyle` called, we should change the animation target manually
            //     to continue the effect of the init animation.
            // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
            //     to update the value to `val2` and no animation declared, should be terminate
            //     the previous animation or just modify the target of the animation?
            //     Therotically That will happen not only on `style` but also on `shape` and
            //     `transfrom` props. But we haven't handle this case at present yet.
            // (3) PENDING: Is it proper to visit `animators` and `targetName`?
            var animators = el.animators;
            for(var i = 0; i < animators.length; i++){
                var animator = animators[i];
                // targetName is the "topKey".
                if (animator.targetName === 'style') animator.changeTarget(el.style);
            }
        }
        el.setStyle(styleOpt);
    }
    if (allPropsFinal) {
        // Not set style here.
        allPropsFinal.style = null;
        // Set el to the final state firstly.
        allPropsFinal && el.attr(allPropsFinal);
        allPropsFinal.style = styleOpt;
    }
}
function $0014f72894402f77$var$applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
transFromProps) {
    if (transFromProps) {
        var config = $0014f72894402f77$var$getElementAnimationConfig('update', el, elOption, model, dataIndex);
        if (config.duration > 0) el.animateFrom(transFromProps, config);
    }
}
function $0014f72894402f77$var$applyMiscProps(el, elOption) {
    // Merge by default.
    (0, $2N6Uo.hasOwn)(elOption, 'silent') && (el.silent = elOption.silent);
    (0, $2N6Uo.hasOwn)(elOption, 'ignore') && (el.ignore = elOption.ignore);
    if (el instanceof (0, $6Ekel.default)) (0, $2N6Uo.hasOwn)(elOption, 'invisible') && (el.invisible = elOption.invisible);
    if (el instanceof (0, $4oDJM.default)) (0, $2N6Uo.hasOwn)(elOption, 'autoBatch') && (el.autoBatch = elOption.autoBatch);
}
// Use it to avoid it be exposed to user.
var $0014f72894402f77$var$tmpDuringScope = {};
var $0014f72894402f77$var$transitionDuringAPI = {
    // Usually other props do not need to be changed in animation during.
    setTransform: function(key, val) {
        $0014f72894402f77$var$tmpDuringScope.el[key] = val;
        return this;
    },
    getTransform: function(key) {
        return $0014f72894402f77$var$tmpDuringScope.el[key];
    },
    setShape: function(key, val) {
        var el = $0014f72894402f77$var$tmpDuringScope.el;
        var shape = el.shape || (el.shape = {});
        shape[key] = val;
        el.dirtyShape && el.dirtyShape();
        return this;
    },
    getShape: function(key) {
        var shape = $0014f72894402f77$var$tmpDuringScope.el.shape;
        if (shape) return shape[key];
    },
    setStyle: function(key, val) {
        var el = $0014f72894402f77$var$tmpDuringScope.el;
        var style = el.style;
        if (style) {
            style[key] = val;
            el.dirtyStyle && el.dirtyStyle();
        }
        return this;
    },
    getStyle: function(key) {
        var style = $0014f72894402f77$var$tmpDuringScope.el.style;
        if (style) return style[key];
    },
    setExtra: function(key, val) {
        var extra = $0014f72894402f77$var$tmpDuringScope.el.extra || ($0014f72894402f77$var$tmpDuringScope.el.extra = {});
        extra[key] = val;
        return this;
    },
    getExtra: function(key) {
        var extra = $0014f72894402f77$var$tmpDuringScope.el.extra;
        if (extra) return extra[key];
    }
};
function $0014f72894402f77$var$assertNotReserved(key) {}
function $0014f72894402f77$var$duringCall() {
    // Do not provide "percent" until some requirements come.
    // Because consider thies case:
    // enterFrom: {x: 100, y: 30}, transition: 'x'.
    // And enter duration is different from update duration.
    // Thus it might be confused about the meaning of "percent" in during callback.
    var scope = this;
    var el = scope.el;
    if (!el) return;
    // If el is remove from zr by reason like legend, during still need to called,
    // because el will be added back to zr and the prop value should not be incorrect.
    var latestUserDuring = $0014f72894402f77$var$transitionInnerStore(el).userDuring;
    var scopeUserDuring = scope.userDuring;
    // Ensured a during is only called once in each animation frame.
    // If a during is called multiple times in one frame, maybe some users' calculation logic
    // might be wrong (not sure whether this usage exists).
    // The case of a during might be called twice can be: by default there is a animator for
    // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
    // another animators for 'style'/'shape'/'extra'.
    if (latestUserDuring !== scopeUserDuring) {
        // release
        scope.el = scope.userDuring = null;
        return;
    }
    $0014f72894402f77$var$tmpDuringScope.el = el;
    // Give no `this` to user in "during" calling.
    scopeUserDuring($0014f72894402f77$var$transitionDuringAPI);
// FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
// consider the issue that the prop might be incorrect when return to "normal" state.
}
function $0014f72894402f77$var$prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var elPropsInAttr = fromEl[mainAttr];
    var transFromPropsInAttr;
    if (elPropsInAttr) {
        var transition = elOption.transition;
        var attrTransition = attrOpt.transition;
        if (attrTransition) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            if ($0014f72894402f77$export$6f3361b4b8d7a8ba(attrTransition)) (0, $2N6Uo.extend)(transFromPropsInAttr, elPropsInAttr);
            else {
                var transitionKeys = (0, $bx3T8.normalizeToArray)(attrTransition);
                for(var i = 0; i < transitionKeys.length; i++){
                    var key = transitionKeys[i];
                    var elVal = elPropsInAttr[key];
                    transFromPropsInAttr[key] = elVal;
                }
            }
        } else if ($0014f72894402f77$export$6f3361b4b8d7a8ba(transition) || (0, $2N6Uo.indexOf)(transition, mainAttr) >= 0) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            var elPropsInAttrKeys = (0, $2N6Uo.keys)(elPropsInAttr);
            for(var i = 0; i < elPropsInAttrKeys.length; i++){
                var key = elPropsInAttrKeys[i];
                var elVal = elPropsInAttr[key];
                if ($0014f72894402f77$var$isNonStyleTransitionEnabled(attrOpt[key], elVal)) transFromPropsInAttr[key] = elVal;
            }
        }
    }
}
function $0014f72894402f77$var$prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var allPropsInAttr = allProps[mainAttr] = {};
    var keysInAttr = (0, $2N6Uo.keys)(attrOpt);
    for(var i = 0; i < keysInAttr.length; i++){
        var key = keysInAttr[i];
        // To avoid share one object with different element, and
        // to avoid user modify the object inexpectedly, have to clone.
        allPropsInAttr[key] = (0, $GuYp4.cloneValue)(attrOpt[key]);
    }
}
function $0014f72894402f77$var$prepareTransformTransitionFrom(el, elOption, transFromProps) {
    var transition = elOption.transition;
    var transitionKeys = $0014f72894402f77$export$6f3361b4b8d7a8ba(transition) ? (0, $erz95.TRANSFORMABLE_PROPS) : (0, $bx3T8.normalizeToArray)(transition || []);
    for(var i = 0; i < transitionKeys.length; i++){
        var key = transitionKeys[i];
        if (key === 'style' || key === 'shape' || key === 'extra') continue;
        var elVal = el[key];
        // Do not clone, animator will perform that clone.
        transFromProps[key] = elVal;
    }
}
function $0014f72894402f77$var$prepareTransformAllPropsFinal(el, elOption, allProps) {
    for(var i = 0; i < $0014f72894402f77$var$LEGACY_TRANSFORM_PROPS.length; i++){
        var legacyName = $0014f72894402f77$var$LEGACY_TRANSFORM_PROPS[i];
        var xyName = $0014f72894402f77$var$LEGACY_TRANSFORM_PROPS_MAP[legacyName];
        var legacyArr = elOption[legacyName];
        if (legacyArr) {
            allProps[xyName[0]] = legacyArr[0];
            allProps[xyName[1]] = legacyArr[1];
        }
    }
    for(var i = 0; i < (0, $erz95.TRANSFORMABLE_PROPS).length; i++){
        var key = (0, $erz95.TRANSFORMABLE_PROPS)[i];
        if (elOption[key] != null) allProps[key] = elOption[key];
    }
}
function $0014f72894402f77$var$prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
    if (!styleOpt) return;
    var fromElStyle = fromEl.style;
    var transFromStyleProps;
    if (fromElStyle) {
        var styleTransition = styleOpt.transition;
        var elTransition = elOption.transition;
        if (styleTransition && !$0014f72894402f77$export$6f3361b4b8d7a8ba(styleTransition)) {
            var transitionKeys = (0, $bx3T8.normalizeToArray)(styleTransition);
            !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
            for(var i = 0; i < transitionKeys.length; i++){
                var key = transitionKeys[i];
                var elVal = fromElStyle[key];
                // Do not clone, see `checkNonStyleTansitionRefer`.
                transFromStyleProps[key] = elVal;
            }
        } else if (fromEl.getAnimationStyleProps && ($0014f72894402f77$export$6f3361b4b8d7a8ba(elTransition) || $0014f72894402f77$export$6f3361b4b8d7a8ba(styleTransition) || (0, $2N6Uo.indexOf)(elTransition, 'style') >= 0)) {
            var animationProps = fromEl.getAnimationStyleProps();
            var animationStyleProps = animationProps ? animationProps.style : null;
            if (animationStyleProps) {
                !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
                var styleKeys = (0, $2N6Uo.keys)(styleOpt);
                for(var i = 0; i < styleKeys.length; i++){
                    var key = styleKeys[i];
                    if (animationStyleProps[key]) {
                        var elVal = fromElStyle[key];
                        transFromStyleProps[key] = elVal;
                    }
                }
            }
        }
    }
}
function $0014f72894402f77$var$isNonStyleTransitionEnabled(optVal, elVal) {
    // The same as `checkNonStyleTansitionRefer`.
    return !(0, $2N6Uo.isArrayLike)(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
}
var $0014f72894402f77$var$checkTransformPropRefer;

});

parcelRegister("bwI2M", function(module, exports) {

$parcel$export(module.exports, "stopPreviousKeyframeAnimationAndRestore", function () { return $8644d9131735b8ee$export$9e5c70edf1ec0cb4; });
$parcel$export(module.exports, "applyKeyframeAnimation", function () { return $8644d9131735b8ee$export$b0aa6a5f01693fa4; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $0r1IS = parcelRequire("0r1IS");

var $ipprj = parcelRequire("ipprj");


var $bx3T8 = parcelRequire("bx3T8");
var $8644d9131735b8ee$var$getStateToRestore = (0, $bx3T8.makeInner)();
var $8644d9131735b8ee$var$KEYFRAME_EXCLUDE_KEYS = [
    'percent',
    'easing',
    'shape',
    'style',
    'extra'
];
function $8644d9131735b8ee$export$9e5c70edf1ec0cb4(el) {
    // Stop previous keyframe animation.
    el.stopAnimation('keyframe');
    // Restore
    el.attr($8644d9131735b8ee$var$getStateToRestore(el));
}
function $8644d9131735b8ee$export$b0aa6a5f01693fa4(el, animationOpts, animatableModel) {
    if (!animatableModel.isAnimationEnabled() || !animationOpts) return;
    if ((0, $2N6Uo.isArray)(animationOpts)) {
        (0, $2N6Uo.each)(animationOpts, function(singleAnimationOpts) {
            $8644d9131735b8ee$export$b0aa6a5f01693fa4(el, singleAnimationOpts, animatableModel);
        });
        return;
    }
    var keyframes = animationOpts.keyframes;
    var duration = animationOpts.duration;
    if (animatableModel && duration == null) {
        // Default to use duration of config.
        // NOTE: animation config from payload will be ignored because they are mainly for transitions.
        var config = (0, $ipprj.getAnimationConfig)('enter', animatableModel, 0);
        duration = config && config.duration;
    }
    if (!keyframes || !duration) return;
    var stateToRestore = $8644d9131735b8ee$var$getStateToRestore(el);
    (0, $2N6Uo.each)((0, $0r1IS.ELEMENT_ANIMATABLE_PROPS), function(targetPropName) {
        if (targetPropName && !el[targetPropName]) return;
        var animator;
        var endFrameIsSet = false;
        // Sort keyframes by percent.
        keyframes.sort(function(a, b) {
            return a.percent - b.percent;
        });
        (0, $2N6Uo.each)(keyframes, function(kf) {
            // Stop current animation.
            var animators = el.animators;
            var kfValues = targetPropName ? kf[targetPropName] : kf;
            if (!kfValues) return;
            var propKeys = (0, $2N6Uo.keys)(kfValues);
            if (!targetPropName) // PENDING performance?
            propKeys = (0, $2N6Uo.filter)(propKeys, function(key) {
                return (0, $2N6Uo.indexOf)($8644d9131735b8ee$var$KEYFRAME_EXCLUDE_KEYS, key) < 0;
            });
            if (!propKeys.length) return;
            if (!animator) {
                animator = el.animate(targetPropName, animationOpts.loop, true);
                animator.scope = 'keyframe';
            }
            for(var i = 0; i < animators.length; i++)// Stop all other animation that is not keyframe.
            if (animators[i] !== animator && animators[i].targetName === animator.targetName) animators[i].stopTracks(propKeys);
            targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
            var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
            (0, $2N6Uo.each)(propKeys, function(key) {
                // Save original value.
                savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
            });
            animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
        });
        if (!animator) return;
        animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
    });
}

});



parcelRegister("9KAgp", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $71948a23086cb1d1$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hU6gJ = parcelRequire("hU6gJ");

var $faQcA = parcelRequire("faQcA");

var $2tzwZ = parcelRequire("2tzwZ");
function $71948a23086cb1d1$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $hU6gJ.default));
    registers.registerSeriesModel((0, $faQcA.default));
    registers.registerLayout((0, $2tzwZ.default)('effectScatter'));
}

});
parcelRegister("hU6gJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d08c877f1c29f0b9$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $ih3Ax = parcelRequire("ih3Ax");

var $lS6WG = parcelRequire("lS6WG");

var $19Ywy = parcelRequire("19Ywy");

var $2tzwZ = parcelRequire("2tzwZ");

var $cWIrM = parcelRequire("cWIrM");
var $d08c877f1c29f0b9$var$EffectScatterView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(EffectScatterView, _super);
    function EffectScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterView.type;
        return _this;
    }
    EffectScatterView.prototype.init = function() {
        this._symbolDraw = new (0, $ih3Ax.default)((0, $lS6WG.default));
    };
    EffectScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var effectSymbolDraw = this._symbolDraw;
        effectSymbolDraw.updateData(data, {
            clipShape: this._getClipShape(seriesModel)
        });
        this.group.add(effectSymbolDraw.group);
    };
    EffectScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get('clip', true) ? clipArea : null;
    };
    EffectScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        this.group.dirty();
        var res = (0, $2tzwZ.default)('').reset(seriesModel, ecModel, api);
        if (res.progress) res.progress({
            start: 0,
            end: data.count(),
            count: data.count()
        }, data);
        this._symbolDraw.updateLayout();
    };
    EffectScatterView.prototype._updateGroupTransform = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.getRoamTransform) {
            this.group.transform = $19Ywy.clone(coordSys.getRoamTransform());
            this.group.decomposeTransform();
        }
    };
    EffectScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
    };
    EffectScatterView.type = 'effectScatter';
    return EffectScatterView;
}((0, $cWIrM.default));
var $d08c877f1c29f0b9$export$2e2bcd8739ae039 = $d08c877f1c29f0b9$var$EffectScatterView;

});
parcelRegister("ih3Ax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4dc9913e6de5e89$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iQonF = parcelRequire("iQonF");
var $h9U3p = parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $cWCFS = parcelRequire("cWCFS");

var $2N6Uo = parcelRequire("2N6Uo");

var $bysmE = parcelRequire("bysmE");
function $d4dc9913e6de5e89$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
function $d4dc9913e6de5e89$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $2N6Uo.isObject)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $d4dc9913e6de5e89$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel('emphasis');
    return {
        emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle(),
        focus: emphasisModel.get('focus'),
        blurScope: emphasisModel.get('blurScope'),
        emphasisDisabled: emphasisModel.get('disabled'),
        hoverScale: emphasisModel.get('scale'),
        labelStatesModels: (0, $bysmE.getLabelStatesModels)(seriesModel),
        cursorStyle: seriesModel.get('cursor')
    };
}
var $d4dc9913e6de5e89$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $iQonF.default();
        this._SymbolCtor = SymbolCtor || (0, $cWCFS.default);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        // Remove progressive els.
        this._progressiveEls = null;
        opt = $d4dc9913e6de5e89$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $d4dc9913e6de5e89$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        };
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($d4dc9913e6de5e89$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$d4dc9913e6de5e89$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $ipprj.updateProps(symbolEl, target, seriesModel);
            }
            // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            }, seriesModel);
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $d4dc9913e6de5e89$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        // Clear
        this._progressiveEls = [];
        opt = $d4dc9913e6de5e89$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($d4dc9913e6de5e89$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    SymbolDraw.prototype.eachRendered = function(cb) {
        $h9U3p.traverseElements(this._progressiveEls || this.group, cb);
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data;
        // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            }, data.hostModel);
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $d4dc9913e6de5e89$export$2e2bcd8739ae039 = $d4dc9913e6de5e89$var$SymbolDraw;

});
parcelRegister("cWCFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96c8e6beee6b6e99$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $k0QDS = parcelRequire("k0QDS");

var $iQonF = parcelRequire("iQonF");
var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $6TSUP = parcelRequire("6TSUP");

var $bwPbQ = parcelRequire("bwPbQ");

var $d8wDg = parcelRequire("d8wDg");

var $2N6Uo = parcelRequire("2N6Uo");

var $bysmE = parcelRequire("bysmE");

var $lQsZt = parcelRequire("lQsZt");

var $ipprj = parcelRequire("ipprj");
var $96c8e6beee6b6e99$var$Symbol = /** @class */ function(_super) {
    (0, $9nEce.__extends)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, z2, keepAspect) {
        // Remove paths created before
        this.removeAll();
        // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $k0QDS.createSymbol)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: (0, $2N6Uo.retrieve2)(z2, 100),
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        });
        // Rewrite drift method
        symbolPath.drift = $96c8e6beee6b6e99$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $bwPbQ.enterEmphasis)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $bwPbQ.leaveEmphasis)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable, hasCursorOption) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = !hasCursorOption && draggable ? 'move' : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var z2 = Symbol.getSymbolZ2(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
            this._createSymbol(symbolType, data, idx, symbolSize, z2, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $ipprj.updateProps(symbolPath, target, seriesModel, idx);
            (0, $ipprj.saveOldStyle)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $ipprj.initProps(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop leave transition manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation('leave');
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var emphasisDisabled;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
            emphasisDisabled = seriesScope.emphasisDisabled;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            selectItemStyle = itemModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            emphasisDisabled = emphasisModel.get('disabled');
            labelStatesModels = (0, $bysmE.getLabelStatesModels)(itemModel);
            hoverScale = emphasisModel.getShallow('scale');
            cursorStyle = itemModel.getShallow('cursor');
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $k0QDS.normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr('cursor', cursorStyle);
        var symbolStyle = data.getItemVisual(idx, 'style');
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $lQsZt.default)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $2N6Uo.extend)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $2N6Uo.extend)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
            // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, 'liftZ');
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $bysmE.setLabelStyle)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        });
        // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $d8wDg.getDefaultLabel)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState('emphasis');
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState('select').style = selectItemStyle;
        symbolPath.ensureState('blur').style = blurItemStyle;
        // null / undefined / true means to use default strategy.
        // 0 / false / negative number / NaN / Infinity means no scale.
        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1;
        // always set scale to allow resetting
        emphasisState.scaleX = this._sizeX * scaleRatio;
        emphasisState.scaleY = this._sizeY * scaleRatio;
        this.setSymbolScale(1);
        (0, $bwPbQ.toggleHoverEmphasis)(this, focus, blurScope, emphasisDisabled);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, seriesModel, opt) {
        var symbolPath = this.childAt(0);
        var dataIndex = (0, $6TSUP.getECData)(this).dataIndex;
        var animationOpt = opt && opt.animation;
        // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true;
        // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $ipprj.removeElement(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $ipprj.removeElement(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $k0QDS.normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
    };
    Symbol.getSymbolZ2 = function(data, idx) {
        return data.getItemVisual(idx, 'z2');
    };
    return Symbol;
}($iQonF.default);
function $96c8e6beee6b6e99$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $96c8e6beee6b6e99$export$2e2bcd8739ae039 = $96c8e6beee6b6e99$var$Symbol;

});


parcelRegister("lS6WG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fec4075b1f4423f4$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $k0QDS = parcelRequire("k0QDS");

var $iQonF = parcelRequire("iQonF");

var $bwPbQ = parcelRequire("bwPbQ");

var $cWCFS = parcelRequire("cWCFS");
function $fec4075b1f4423f4$var$updateRipplePath(rippleGroup, effectCfg) {
    var color = effectCfg.rippleEffectColor || effectCfg.color;
    rippleGroup.eachChild(function(ripplePath) {
        ripplePath.attr({
            z: effectCfg.z,
            zlevel: effectCfg.zlevel,
            style: {
                stroke: effectCfg.brushType === 'stroke' ? color : null,
                fill: effectCfg.brushType === 'fill' ? color : null
            }
        });
    });
}
var $fec4075b1f4423f4$var$EffectSymbol = /** @class */ function(_super) {
    (0, $9nEce.__extends)(EffectSymbol, _super);
    function EffectSymbol(data, idx) {
        var _this = _super.call(this) || this;
        var symbol = new (0, $cWCFS.default)(data, idx);
        var rippleGroup = new (0, $iQonF.default)();
        _this.add(symbol);
        _this.add(rippleGroup);
        _this.updateData(data, idx);
        return _this;
    }
    EffectSymbol.prototype.stopEffectAnimation = function() {
        this.childAt(1).removeAll();
    };
    EffectSymbol.prototype.startEffectAnimation = function(effectCfg) {
        var symbolType = effectCfg.symbolType;
        var color = effectCfg.color;
        var rippleNumber = effectCfg.rippleNumber;
        var rippleGroup = this.childAt(1);
        for(var i = 0; i < rippleNumber; i++){
            // If width/height are set too small (e.g., set to 1) on ios10
            // and macOS Sierra, a circle stroke become a rect, no matter what
            // the scale is set. So we set width/height as 2. See #4136.
            var ripplePath = (0, $k0QDS.createSymbol)(symbolType, -1, -1, 2, 2, color);
            ripplePath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 99,
                silent: true,
                scaleX: 0.5,
                scaleY: 0.5
            });
            var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
            ripplePath.animate('', true).when(effectCfg.period, {
                scaleX: effectCfg.rippleScale / 2,
                scaleY: effectCfg.rippleScale / 2
            }).delay(delay).start();
            ripplePath.animateStyle(true).when(effectCfg.period, {
                opacity: 0
            }).delay(delay).start();
            rippleGroup.add(ripplePath);
        }
        $fec4075b1f4423f4$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Update effect symbol
   */ EffectSymbol.prototype.updateEffectAnimation = function(effectCfg) {
        var oldEffectCfg = this._effectCfg;
        var rippleGroup = this.childAt(1);
        // Must reinitialize effect if following configuration changed
        var DIFFICULT_PROPS = [
            'symbolType',
            'period',
            'rippleScale',
            'rippleNumber'
        ];
        for(var i = 0; i < DIFFICULT_PROPS.length; i++){
            var propName = DIFFICULT_PROPS[i];
            if (oldEffectCfg[propName] !== effectCfg[propName]) {
                this.stopEffectAnimation();
                this.startEffectAnimation(effectCfg);
                return;
            }
        }
        $fec4075b1f4423f4$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Highlight symbol
   */ EffectSymbol.prototype.highlight = function() {
        (0, $bwPbQ.enterEmphasis)(this);
    };
    /**
   * Downplay symbol
   */ EffectSymbol.prototype.downplay = function() {
        (0, $bwPbQ.leaveEmphasis)(this);
    };
    EffectSymbol.prototype.getSymbolType = function() {
        var symbol = this.childAt(0);
        return symbol && symbol.getSymbolType();
    };
    /**
   * Update symbol properties
   */ EffectSymbol.prototype.updateData = function(data, idx) {
        var _this = this;
        var seriesModel = data.hostModel;
        this.childAt(0).updateData(data, idx);
        var rippleGroup = this.childAt(1);
        var itemModel = data.getItemModel(idx);
        var symbolType = data.getItemVisual(idx, 'symbol');
        var symbolSize = (0, $k0QDS.normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
        var symbolStyle = data.getItemVisual(idx, 'style');
        var color = symbolStyle && symbolStyle.fill;
        var emphasisModel = itemModel.getModel('emphasis');
        rippleGroup.setScale(symbolSize);
        rippleGroup.traverse(function(ripplePath) {
            ripplePath.setStyle('fill', color);
        });
        var symbolOffset = (0, $k0QDS.normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            rippleGroup.x = symbolOffset[0];
            rippleGroup.y = symbolOffset[1];
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
        var effectCfg = {};
        effectCfg.showEffectOn = seriesModel.get('showEffectOn');
        effectCfg.rippleScale = itemModel.get([
            'rippleEffect',
            'scale'
        ]);
        effectCfg.brushType = itemModel.get([
            'rippleEffect',
            'brushType'
        ]);
        effectCfg.period = itemModel.get([
            'rippleEffect',
            'period'
        ]) * 1000;
        effectCfg.effectOffset = idx / data.count();
        effectCfg.z = seriesModel.getShallow('z') || 0;
        effectCfg.zlevel = seriesModel.getShallow('zlevel') || 0;
        effectCfg.symbolType = symbolType;
        effectCfg.color = color;
        effectCfg.rippleEffectColor = itemModel.get([
            'rippleEffect',
            'color'
        ]);
        effectCfg.rippleNumber = itemModel.get([
            'rippleEffect',
            'number'
        ]);
        if (effectCfg.showEffectOn === 'render') {
            this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
            this._effectCfg = effectCfg;
        } else {
            // Not keep old effect config
            this._effectCfg = null;
            this.stopEffectAnimation();
            this.onHoverStateChange = function(toState) {
                if (toState === 'emphasis') {
                    if (effectCfg.showEffectOn !== 'render') _this.startEffectAnimation(effectCfg);
                } else if (toState === 'normal') {
                    if (effectCfg.showEffectOn !== 'render') _this.stopEffectAnimation();
                }
            };
        }
        this._effectCfg = effectCfg;
        (0, $bwPbQ.toggleHoverEmphasis)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    EffectSymbol.prototype.fadeOut = function(cb) {
        cb && cb();
    };
    return EffectSymbol;
}((0, $iQonF.default));
var $fec4075b1f4423f4$export$2e2bcd8739ae039 = $fec4075b1f4423f4$var$EffectSymbol;

});

parcelRegister("2tzwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cd9d9ed1b1744dd$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $Uomg7 = parcelRequire("Uomg7");

var $a1eW0 = parcelRequire("a1eW0");

var $hp8dQ = parcelRequire("hp8dQ");
function $1cd9d9ed1b1744dd$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $Uomg7.default)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $2N6Uo.map)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            if ((0, $a1eW0.isDimensionStacked)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $a1eW0.isDimensionStacked)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $hp8dQ.createFloat32Array)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i);
                            // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i);
                            // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout('points', points);
                }
            };
        }
    };
}

});


parcelRegister("faQcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0c0486b8a550950$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $dOrFN = parcelRequire("dOrFN");

var $49X8G = parcelRequire("49X8G");
var $b0c0486b8a550950$var$EffectScatterSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(EffectScatterSeriesModel, _super);
    function EffectScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    EffectScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $dOrFN.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    EffectScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    EffectScatterSeriesModel.type = 'series.effectScatter';
    EffectScatterSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    EffectScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        effectType: 'ripple',
        progressive: 0,
        // When to show the effect, option: 'render'|'emphasis'
        showEffectOn: 'render',
        clip: true,
        // Ripple effect config
        rippleEffect: {
            period: 4,
            // Scale of ripple
            scale: 2.5,
            // Brush type can be fill or stroke
            brushType: 'fill',
            // Ripple number
            number: 3
        },
        universalTransition: {
            divideShape: 'clone'
        },
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    };
    return EffectScatterSeriesModel;
}((0, $49X8G.default));
var $b0c0486b8a550950$export$2e2bcd8739ae039 = $b0c0486b8a550950$var$EffectScatterSeriesModel;

});


parcelRegister("gpiX5", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $bf1dae9abc034c60$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fGId1 = parcelRequire("fGId1");

var $2ydsJ = parcelRequire("2ydsJ");

var $643as = parcelRequire("643as");

var $impUY = parcelRequire("impUY");
function $bf1dae9abc034c60$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $fGId1.default));
    registers.registerSeriesModel((0, $2ydsJ.default));
    registers.registerLayout((0, $643as.default));
    registers.registerProcessor((0, $impUY.default)('funnel'));
}

});
parcelRegister("fGId1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6bd12422120c4ea$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $ipprj = parcelRequire("ipprj");
var $9KN3M = parcelRequire("9KN3M");parcelRequire("h9U3p");
var $hXTRG = parcelRequire("hXTRG");
var $ewDYK = parcelRequire("ewDYK");
var $ipprj = parcelRequire("ipprj");
var $kBKw3 = parcelRequire("kBKw3");

var $bwPbQ = parcelRequire("bwPbQ");

var $cWIrM = parcelRequire("cWIrM");

var $ctvp5 = parcelRequire("ctvp5");

var $bysmE = parcelRequire("bysmE");

var $ipprj = parcelRequire("ipprj");
var $b6bd12422120c4ea$var$opacityAccessPath = [
    'itemStyle',
    'opacity'
];
/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $b6bd12422120c4ea$var$FunnelPiece = /** @class */ function(_super) {
    (0, $9nEce.__extends)(FunnelPiece, _super);
    function FunnelPiece(data, idx) {
        var _this = _super.call(this) || this;
        var polygon = _this;
        var labelLine = new $ewDYK.default();
        var text = new $kBKw3.default();
        polygon.setTextContent(text);
        _this.setTextGuideLine(labelLine);
        _this.updateData(data, idx, true);
        return _this;
    }
    FunnelPiece.prototype.updateData = function(data, idx, firstCreate) {
        var polygon = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var opacity = itemModel.get($b6bd12422120c4ea$var$opacityAccessPath);
        opacity = opacity == null ? 1 : opacity;
        if (!firstCreate) (0, $ipprj.saveOldStyle)(polygon);
        // Update common style
        polygon.useStyle(data.getItemVisual(idx, 'style'));
        polygon.style.lineJoin = 'round';
        if (firstCreate) {
            polygon.setShape({
                points: layout.points
            });
            polygon.style.opacity = 0;
            $ipprj.initProps(polygon, {
                style: {
                    opacity: opacity
                }
            }, seriesModel, idx);
        } else $ipprj.updateProps(polygon, {
            style: {
                opacity: opacity
            },
            shape: {
                points: layout.points
            }
        }, seriesModel, idx);
        (0, $bwPbQ.setStatesStylesFromModel)(polygon, itemModel);
        this._updateLabel(data, idx);
        (0, $bwPbQ.toggleHoverEmphasis)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    FunnelPiece.prototype._updateLabel = function(data, idx) {
        var polygon = this;
        var labelLine = this.getTextGuideLine();
        var labelText = polygon.getTextContent();
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var labelLayout = layout.label;
        var style = data.getItemVisual(idx, 'style');
        var visualColor = style.fill;
        (0, $bysmE.setLabelStyle)(// position will not be used in setLabelStyle
        labelText, (0, $bysmE.getLabelStatesModels)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            defaultOpacity: style.opacity,
            defaultText: data.getName(idx)
        }, {
            normal: {
                align: labelLayout.textAlign,
                verticalAlign: labelLayout.verticalAlign
            }
        });
        var labelModel = itemModel.getModel('label');
        var labelColor = labelModel.get('color');
        var overrideColor = labelColor === 'inherit' ? visualColor : null;
        polygon.setTextConfig({
            local: true,
            inside: !!labelLayout.inside,
            insideStroke: overrideColor,
            outsideFill: overrideColor
        });
        var linePoints = labelLayout.linePoints;
        labelLine.setShape({
            points: linePoints
        });
        polygon.textGuideLineConfig = {
            anchor: linePoints ? new $9KN3M.default(linePoints[0][0], linePoints[0][1]) : null
        };
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        $ipprj.updateProps(labelText, {
            style: {
                x: labelLayout.x,
                y: labelLayout.y
            }
        }, seriesModel, idx);
        labelText.attr({
            rotation: labelLayout.rotation,
            originX: labelLayout.x,
            originY: labelLayout.y,
            z2: 10
        });
        (0, $ctvp5.setLabelLineStyle)(polygon, (0, $ctvp5.getLabelLineStatesModels)(itemModel), {
            // Default use item visual color
            stroke: visualColor
        });
    };
    return FunnelPiece;
}($hXTRG.default);
var $b6bd12422120c4ea$var$FunnelView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(FunnelView, _super);
    function FunnelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelView.type;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    FunnelView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        data.diff(oldData).add(function(idx) {
            var funnelPiece = new $b6bd12422120c4ea$var$FunnelPiece(data, idx);
            data.setItemGraphicEl(idx, funnelPiece);
            group.add(funnelPiece);
        }).update(function(newIdx, oldIdx) {
            var piece = oldData.getItemGraphicEl(oldIdx);
            piece.updateData(data, newIdx);
            group.add(piece);
            data.setItemGraphicEl(newIdx, piece);
        }).remove(function(idx) {
            var piece = oldData.getItemGraphicEl(idx);
            $ipprj.removeElementWithFadeOut(piece, seriesModel, idx);
        }).execute();
        this._data = data;
    };
    FunnelView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    FunnelView.prototype.dispose = function() {};
    FunnelView.type = 'funnel';
    return FunnelView;
}((0, $cWIrM.default));
var $b6bd12422120c4ea$export$2e2bcd8739ae039 = $b6bd12422120c4ea$var$FunnelView;

});
parcelRegister("ctvp5", function(module, exports) {

$parcel$export(module.exports, "updateLabelLinePoints", function () { return $91508d9984b07d5c$export$cc93ba643cd97d83; });
$parcel$export(module.exports, "limitTurnAngle", function () { return $91508d9984b07d5c$export$ac52062003fbe6a; });
$parcel$export(module.exports, "limitSurfaceAngle", function () { return $91508d9984b07d5c$export$973e1fdb2708f71b; });
$parcel$export(module.exports, "setLabelLineStyle", function () { return $91508d9984b07d5c$export$c09e0b0574bdd2dc; });
$parcel$export(module.exports, "getLabelLineStatesModels", function () { return $91508d9984b07d5c$export$2979fdbf5ebce521; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("h9U3p");
var $4oDJM = parcelRequire("4oDJM");
var $ewDYK = parcelRequire("ewDYK");
var $9KN3M = parcelRequire("9KN3M");

var $eAFw0 = parcelRequire("eAFw0");

var $3HvzJ = parcelRequire("3HvzJ");

var $1kxDI = parcelRequire("1kxDI");

var $2N6Uo = parcelRequire("2N6Uo");

var $19Ywy = parcelRequire("19Ywy");

var $U1aqY = parcelRequire("U1aqY");

var $bwPbQ = parcelRequire("bwPbQ");
var $91508d9984b07d5c$var$PI2 = Math.PI * 2;
var $91508d9984b07d5c$var$CMD = (0, $eAFw0.default).CMD;
var $91508d9984b07d5c$var$DEFAULT_SEARCH_SPACE = [
    'top',
    'right',
    'bottom',
    'left'
];
function $91508d9984b07d5c$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case 'top':
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case 'bottom':
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case 'left':
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case 'right':
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $91508d9984b07d5c$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d;
    // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $91508d9984b07d5c$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $3HvzJ.normalizeRadian)(endAngle);
        endAngle = (0, $3HvzJ.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $3HvzJ.normalizeRadian)(startAngle);
        endAngle = (0, $3HvzJ.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $91508d9984b07d5c$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $91508d9984b07d5c$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $91508d9984b07d5c$var$PI2 >= startAngle && angle + $91508d9984b07d5c$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $91508d9984b07d5c$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen;
    // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $91508d9984b07d5c$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $91508d9984b07d5c$var$tmpPt = [];
function $91508d9984b07d5c$var$nearestPointOnRect(pt, rect, out) {
    var dist = $91508d9984b07d5c$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $91508d9984b07d5c$var$tmpPt);
    out.set($91508d9984b07d5c$var$tmpPt[0], $91508d9984b07d5c$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $91508d9984b07d5c$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $91508d9984b07d5c$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $91508d9984b07d5c$var$CMD.L:
                d = $91508d9984b07d5c$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $91508d9984b07d5c$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $91508d9984b07d5c$var$CMD.C:
                d = (0, $1kxDI.cubicProjectPoint)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $91508d9984b07d5c$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $91508d9984b07d5c$var$CMD.Q:
                d = (0, $1kxDI.quadraticProjectPoint)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $91508d9984b07d5c$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $91508d9984b07d5c$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                }
                // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $91508d9984b07d5c$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $91508d9984b07d5c$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $91508d9984b07d5c$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $91508d9984b07d5c$var$projectPointToRect(x0, y0, width, height, x, y, $91508d9984b07d5c$var$tmpPt);
                break;
            case $91508d9984b07d5c$var$CMD.Z:
                d = $91508d9984b07d5c$var$projectPointToLine(xi, yi, x0, y0, x, y, $91508d9984b07d5c$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($91508d9984b07d5c$var$tmpPt[0], $91508d9984b07d5c$var$tmpPt[1]);
        }
    }
    return minDist;
}
// Temporal variable for intermediate usage.
var $91508d9984b07d5c$var$pt0 = new (0, $9KN3M.default)();
var $91508d9984b07d5c$var$pt1 = new (0, $9KN3M.default)();
var $91508d9984b07d5c$var$pt2 = new (0, $9KN3M.default)();
var $91508d9984b07d5c$var$dir = new (0, $9KN3M.default)();
var $91508d9984b07d5c$var$dir2 = new (0, $9KN3M.default)();
function $91508d9984b07d5c$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent();
    // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $91508d9984b07d5c$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $19Ywy.invert)([], targetTransform);
    var len = labelLineModel.get('length2') || 0;
    if (anchorPoint) $91508d9984b07d5c$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $91508d9984b07d5c$var$getCandidateAnchor(candidate, 0, labelRect, $91508d9984b07d5c$var$pt0, $91508d9984b07d5c$var$dir);
        (0, $9KN3M.default).scaleAndAdd($91508d9984b07d5c$var$pt1, $91508d9984b07d5c$var$pt0, $91508d9984b07d5c$var$dir, len);
        // Transform to target coord space.
        $91508d9984b07d5c$var$pt1.transform(targetInversedTransform);
        // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($91508d9984b07d5c$var$pt1) : target instanceof (0, $4oDJM.default) ? $91508d9984b07d5c$var$nearestPointOnPath($91508d9984b07d5c$var$pt1, target.path, $91508d9984b07d5c$var$pt2) : $91508d9984b07d5c$var$nearestPointOnRect($91508d9984b07d5c$var$pt1, boundingRect, $91508d9984b07d5c$var$pt2);
        // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist;
            // Transform back to global space.
            $91508d9984b07d5c$var$pt1.transform(targetTransform);
            $91508d9984b07d5c$var$pt2.transform(targetTransform);
            $91508d9984b07d5c$var$pt2.toArray(points[0]);
            $91508d9984b07d5c$var$pt1.toArray(points[1]);
            $91508d9984b07d5c$var$pt0.toArray(points[2]);
        }
    }
    $91508d9984b07d5c$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
    labelLine.setShape({
        points: points
    });
}
// Temporal variable for the limitTurnAngle function
var $91508d9984b07d5c$var$tmpArr = [];
var $91508d9984b07d5c$var$tmpProjPoint = new (0, $9KN3M.default)();
function $91508d9984b07d5c$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI;
    // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $91508d9984b07d5c$var$pt0.fromArray(linePoints[0]);
    $91508d9984b07d5c$var$pt1.fromArray(linePoints[1]);
    $91508d9984b07d5c$var$pt2.fromArray(linePoints[2]);
    (0, $9KN3M.default).sub($91508d9984b07d5c$var$dir, $91508d9984b07d5c$var$pt0, $91508d9984b07d5c$var$pt1);
    (0, $9KN3M.default).sub($91508d9984b07d5c$var$dir2, $91508d9984b07d5c$var$pt2, $91508d9984b07d5c$var$pt1);
    var len1 = $91508d9984b07d5c$var$dir.len();
    var len2 = $91508d9984b07d5c$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $91508d9984b07d5c$var$dir.scale(1 / len1);
    $91508d9984b07d5c$var$dir2.scale(1 / len2);
    var angleCos = $91508d9984b07d5c$var$dir.dot($91508d9984b07d5c$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $91508d9984b07d5c$var$projectPointToLine($91508d9984b07d5c$var$pt1.x, $91508d9984b07d5c$var$pt1.y, $91508d9984b07d5c$var$pt2.x, $91508d9984b07d5c$var$pt2.y, $91508d9984b07d5c$var$pt0.x, $91508d9984b07d5c$var$pt0.y, $91508d9984b07d5c$var$tmpArr, false);
        $91508d9984b07d5c$var$tmpProjPoint.fromArray($91508d9984b07d5c$var$tmpArr);
        // Calculate new projected length with limited minTurnAngle and get the new connect point
        $91508d9984b07d5c$var$tmpProjPoint.scaleAndAdd($91508d9984b07d5c$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
        // Limit the new calculated connect point between pt1 and pt2.
        var t = $91508d9984b07d5c$var$pt2.x !== $91508d9984b07d5c$var$pt1.x ? ($91508d9984b07d5c$var$tmpProjPoint.x - $91508d9984b07d5c$var$pt1.x) / ($91508d9984b07d5c$var$pt2.x - $91508d9984b07d5c$var$pt1.x) : ($91508d9984b07d5c$var$tmpProjPoint.y - $91508d9984b07d5c$var$pt1.y) / ($91508d9984b07d5c$var$pt2.y - $91508d9984b07d5c$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $9KN3M.default).copy($91508d9984b07d5c$var$tmpProjPoint, $91508d9984b07d5c$var$pt1);
        else if (t > 1) (0, $9KN3M.default).copy($91508d9984b07d5c$var$tmpProjPoint, $91508d9984b07d5c$var$pt2);
        $91508d9984b07d5c$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $91508d9984b07d5c$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $91508d9984b07d5c$var$pt0.fromArray(linePoints[0]);
    $91508d9984b07d5c$var$pt1.fromArray(linePoints[1]);
    $91508d9984b07d5c$var$pt2.fromArray(linePoints[2]);
    (0, $9KN3M.default).sub($91508d9984b07d5c$var$dir, $91508d9984b07d5c$var$pt1, $91508d9984b07d5c$var$pt0);
    (0, $9KN3M.default).sub($91508d9984b07d5c$var$dir2, $91508d9984b07d5c$var$pt2, $91508d9984b07d5c$var$pt1);
    var len1 = $91508d9984b07d5c$var$dir.len();
    var len2 = $91508d9984b07d5c$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $91508d9984b07d5c$var$dir.scale(1 / len1);
    $91508d9984b07d5c$var$dir2.scale(1 / len2);
    var angleCos = $91508d9984b07d5c$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $91508d9984b07d5c$var$projectPointToLine($91508d9984b07d5c$var$pt1.x, $91508d9984b07d5c$var$pt1.y, $91508d9984b07d5c$var$pt2.x, $91508d9984b07d5c$var$pt2.y, $91508d9984b07d5c$var$pt0.x, $91508d9984b07d5c$var$pt0.y, $91508d9984b07d5c$var$tmpArr, false);
        $91508d9984b07d5c$var$tmpProjPoint.fromArray($91508d9984b07d5c$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($91508d9984b07d5c$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $9KN3M.default).copy($91508d9984b07d5c$var$tmpProjPoint, $91508d9984b07d5c$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $91508d9984b07d5c$var$tmpProjPoint.scaleAndAdd($91508d9984b07d5c$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
            // Limit the new calculated connect point between pt1 and pt2.
            var t = $91508d9984b07d5c$var$pt2.x !== $91508d9984b07d5c$var$pt1.x ? ($91508d9984b07d5c$var$tmpProjPoint.x - $91508d9984b07d5c$var$pt1.x) / ($91508d9984b07d5c$var$pt2.x - $91508d9984b07d5c$var$pt1.x) : ($91508d9984b07d5c$var$tmpProjPoint.y - $91508d9984b07d5c$var$pt1.y) / ($91508d9984b07d5c$var$pt2.y - $91508d9984b07d5c$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $9KN3M.default).copy($91508d9984b07d5c$var$tmpProjPoint, $91508d9984b07d5c$var$pt1);
            else if (t > 1) (0, $9KN3M.default).copy($91508d9984b07d5c$var$tmpProjPoint, $91508d9984b07d5c$var$pt2);
        }
        $91508d9984b07d5c$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $91508d9984b07d5c$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === 'normal';
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
    // Make sure display.
    stateObj.ignore = ignore;
    // Set smooth
    var smooth = stateModel.get('smooth');
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel('lineStyle').getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $91508d9984b07d5c$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $U1aqY.dist(points[0], points[1]);
        var len2 = $U1aqY.dist(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $U1aqY.lerp([], points[1], points[0], moveLen / len1);
        var midPoint2 = $U1aqY.lerp([], points[1], points[2], moveLen / len2);
        var midPoint1 = $U1aqY.lerp([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $91508d9984b07d5c$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get('show');
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $bwPbQ.DISPLAY_STATES).length; i++){
        var stateName = (0, $bwPbQ.DISPLAY_STATES)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === 'normal';
        if (stateModel) {
            var stateShow = stateModel.get('show');
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $2N6Uo.retrieve2)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $2N6Uo.retrieve2)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
                if (stateObj) stateObj.ignore = true;
                if (!!labelLine) $91508d9984b07d5c$var$setLabelLineState(labelLine, true, stateName, stateModel);
                continue;
            }
            // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $ewDYK.default)();
                targetEl.setTextGuideLine(labelLine);
                // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $91508d9984b07d5c$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $91508d9984b07d5c$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $2N6Uo.defaults)(labelLine.style, defaultStyle);
        // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get('showAbove');
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false;
        // Custom the buildPath.
        labelLine.buildPath = $91508d9984b07d5c$var$buildLabelLinePath;
    }
}
function $91508d9984b07d5c$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || 'labelLine';
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $bwPbQ.SPECIAL_STATES).length; i++){
        var stateName = (0, $bwPbQ.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}

});


parcelRegister("2ydsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1db933145e29fc4a$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $1rIDm = parcelRequire("1rIDm");

var $bx3T8 = parcelRequire("bx3T8");

var $6VFOB = parcelRequire("6VFOB");

var $jP9NX = parcelRequire("jP9NX");

var $49X8G = parcelRequire("49X8G");

var $6aXXD = parcelRequire("6aXXD");
var $1db933145e29fc4a$var$FunnelSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(FunnelSeriesModel, _super);
    function FunnelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelSeriesModel.type;
        return _this;
    }
    FunnelSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $jP9NX.default)($2N6Uo.bind(this.getData, this), $2N6Uo.bind(this.getRawData, this));
        // Extend labelLine emphasis
        this._defaultLabelLine(option);
    };
    FunnelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $1rIDm.default)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $2N6Uo.curry((0, $6VFOB.makeSeriesEncodeForNameBased), this)
        });
    };
    FunnelSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        (0, $bx3T8.defaultEmphasis)(option, 'labelLine', [
            'show'
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    // Overwrite
    FunnelSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        var valueDim = data.mapDimension('value');
        var sum = data.getSum(valueDim);
        // Percent is 0 if sum is 0
        params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
        params.$vars.push('percent');
        return params;
    };
    FunnelSeriesModel.type = 'series.funnel';
    FunnelSeriesModel.defaultOption = {
        coordinateSystemUsage: 'box',
        // zlevel: 0,                  // 一级层叠
        z: 2,
        legendHoverLink: true,
        colorBy: 'data',
        left: 80,
        top: 60,
        right: 80,
        bottom: 65,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        // 默认取数据最小最大值
        // min: 0,
        // max: 100,
        minSize: '0%',
        maxSize: '100%',
        sort: 'descending',
        orient: 'vertical',
        gap: 0,
        funnelAlign: 'center',
        label: {
            show: true,
            position: 'outer'
        },
        labelLine: {
            show: true,
            length: 20,
            lineStyle: {
                // color: 各异,
                width: 1
            }
        },
        itemStyle: {
            // color: 各异,
            borderColor: (0, $6aXXD.default).color.neutral00,
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: (0, $6aXXD.default).color.primary
            }
        }
    };
    return FunnelSeriesModel;
}((0, $49X8G.default));
var $1db933145e29fc4a$export$2e2bcd8739ae039 = $1db933145e29fc4a$var$FunnelSeriesModel;

});

parcelRegister("643as", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46a592d4d287016f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a35Wn = parcelRequire("a35Wn");

var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");
function $46a592d4d287016f$var$getSortedIndices(data, sort) {
    var valueDim = data.mapDimension('value');
    var valueArr = data.mapArray(valueDim, function(val) {
        return val;
    });
    var indices = [];
    var isAscending = sort === 'ascending';
    for(var i = 0, len = data.count(); i < len; i++)indices[i] = i;
    // Add custom sortable function & none sortable opetion by "options.sort"
    if ((0, $2N6Uo.isFunction)(sort)) indices.sort(sort);
    else if (sort !== 'none') indices.sort(function(a, b) {
        return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
    return indices;
}
function $46a592d4d287016f$var$labelLayout(data) {
    var seriesModel = data.hostModel;
    var orient = seriesModel.get('orient');
    data.each(function(idx) {
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel('label');
        var labelPosition = labelModel.get('position');
        var labelLineModel = itemModel.getModel('labelLine');
        var layout = data.getItemLayout(idx);
        var points = layout.points;
        var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
        var textAlign;
        var textX;
        var textY;
        var linePoints;
        if (isLabelInside) {
            if (labelPosition === 'insideLeft') {
                textX = (points[0][0] + points[3][0]) / 2 + 5;
                textY = (points[0][1] + points[3][1]) / 2;
                textAlign = 'left';
            } else if (labelPosition === 'insideRight') {
                textX = (points[1][0] + points[2][0]) / 2 - 5;
                textY = (points[1][1] + points[2][1]) / 2;
                textAlign = 'right';
            } else {
                textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
                textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
                textAlign = 'center';
            }
            linePoints = [
                [
                    textX,
                    textY
                ],
                [
                    textX,
                    textY
                ]
            ];
        } else {
            var x1 = void 0;
            var y1 = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var labelLineLen = labelLineModel.get('length');
            if (labelPosition === 'left') {
                // Left side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                x2 = x1 - labelLineLen;
                textX = x2 - 5;
                textAlign = 'right';
            } else if (labelPosition === 'right') {
                // Right side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                x2 = x1 + labelLineLen;
                textX = x2 + 5;
                textAlign = 'left';
            } else if (labelPosition === 'top') {
                // Top side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                y2 = y1 - labelLineLen;
                textY = y2 - 5;
                textAlign = 'center';
            } else if (labelPosition === 'bottom') {
                // Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                y2 = y1 + labelLineLen;
                textY = y2 + 5;
                textAlign = 'center';
            } else if (labelPosition === 'rightTop') {
                // RightTop side
                x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
                y1 = orient === 'horizontal' ? points[3][1] : points[1][1];
                if (orient === 'horizontal') {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'top';
                }
            } else if (labelPosition === 'rightBottom') {
                // RightBottom side
                x1 = points[2][0];
                y1 = points[2][1];
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'bottom';
                }
            } else if (labelPosition === 'leftTop') {
                // LeftTop side
                x1 = points[0][0];
                y1 = orient === 'horizontal' ? points[0][1] : points[1][1];
                if (orient === 'horizontal') {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = 'right';
                }
            } else if (labelPosition === 'leftBottom') {
                // LeftBottom side
                x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
                y1 = orient === 'horizontal' ? points[1][1] : points[2][1];
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = 'right';
                }
            } else {
                // Right side or Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'left';
                }
            }
            if (orient === 'horizontal') {
                x2 = x1;
                textX = x2;
            } else {
                y2 = y1;
                textY = y2;
            }
            linePoints = [
                [
                    x1,
                    y1
                ],
                [
                    x2,
                    y2
                ]
            ];
        }
        layout.label = {
            linePoints: linePoints,
            x: textX,
            y: textY,
            verticalAlign: 'middle',
            textAlign: textAlign,
            inside: isLabelInside
        };
    });
}
function $46a592d4d287016f$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('funnel', function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var sort = seriesModel.get('sort');
        var layoutRef = $a35Wn.createBoxLayoutReference(seriesModel, api);
        var viewRect = $a35Wn.getLayoutRect(seriesModel.getBoxLayoutParams(), layoutRef.refContainer);
        var orient = seriesModel.get('orient');
        var viewWidth = viewRect.width;
        var viewHeight = viewRect.height;
        var indices = $46a592d4d287016f$var$getSortedIndices(data, sort);
        var x = viewRect.x;
        var y = viewRect.y;
        var sizeExtent = orient === 'horizontal' ? [
            (0, $iCU10.parsePercent)(seriesModel.get('minSize'), viewHeight),
            (0, $iCU10.parsePercent)(seriesModel.get('maxSize'), viewHeight)
        ] : [
            (0, $iCU10.parsePercent)(seriesModel.get('minSize'), viewWidth),
            (0, $iCU10.parsePercent)(seriesModel.get('maxSize'), viewWidth)
        ];
        var dataExtent = data.getDataExtent(valueDim);
        var min = seriesModel.get('min');
        var max = seriesModel.get('max');
        if (min == null) min = Math.min(dataExtent[0], 0);
        if (max == null) max = dataExtent[1];
        var funnelAlign = seriesModel.get('funnelAlign');
        var gap = seriesModel.get('gap');
        var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
        var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
        var getLinePoints = function(idx, offset) {
            // End point index is data.count() and we assign it 0
            if (orient === 'horizontal') {
                var val_1 = data.get(valueDim, idx) || 0;
                var itemHeight = (0, $iCU10.linearMap)(val_1, [
                    min,
                    max
                ], sizeExtent, true);
                var y0 = void 0;
                switch(funnelAlign){
                    case 'top':
                        y0 = y;
                        break;
                    case 'center':
                        y0 = y + (viewHeight - itemHeight) / 2;
                        break;
                    case 'bottom':
                        y0 = y + (viewHeight - itemHeight);
                        break;
                }
                return [
                    [
                        offset,
                        y0
                    ],
                    [
                        offset,
                        y0 + itemHeight
                    ]
                ];
            }
            var val = data.get(valueDim, idx) || 0;
            var itemWidth = (0, $iCU10.linearMap)(val, [
                min,
                max
            ], sizeExtent, true);
            var x0;
            switch(funnelAlign){
                case 'left':
                    x0 = x;
                    break;
                case 'center':
                    x0 = x + (viewWidth - itemWidth) / 2;
                    break;
                case 'right':
                    x0 = x + viewWidth - itemWidth;
                    break;
            }
            return [
                [
                    x0,
                    offset
                ],
                [
                    x0 + itemWidth,
                    offset
                ]
            ];
        };
        if (sort === 'ascending') {
            // From bottom to top
            itemSize = -itemSize;
            gap = -gap;
            if (orient === 'horizontal') x += viewWidth;
            else y += viewHeight;
            indices = indices.reverse();
        }
        for(var i = 0; i < indices.length; i++){
            var idx = indices[i];
            var nextIdx = indices[i + 1];
            var itemModel = data.getItemModel(idx);
            if (orient === 'horizontal') {
                var width = itemModel.get([
                    'itemStyle',
                    'width'
                ]);
                if (width == null) width = itemSize;
                else {
                    width = (0, $iCU10.parsePercent)(width, viewWidth);
                    if (sort === 'ascending') width = -width;
                }
                var start = getLinePoints(idx, x);
                var end = getLinePoints(nextIdx, x + width);
                x += width + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            } else {
                var height = itemModel.get([
                    'itemStyle',
                    'height'
                ]);
                if (height == null) height = itemSize;
                else {
                    height = (0, $iCU10.parsePercent)(height, viewHeight);
                    if (sort === 'ascending') height = -height;
                }
                var start = getLinePoints(idx, y);
                var end = getLinePoints(nextIdx, y + height);
                y += height + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            }
        }
        $46a592d4d287016f$var$labelLayout(data);
    });
}

});


parcelRegister("gN6fY", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $c39613601b7e745d$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jb1xE = parcelRequire("jb1xE");

var $dOyXR = parcelRequire("dOyXR");
function $c39613601b7e745d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $jb1xE.default));
    registers.registerSeriesModel((0, $dOyXR.default));
}

});
parcelRegister("jb1xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df603d940010930e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $hMd6Y = parcelRequire("hMd6Y");

var $iQonF = parcelRequire("iQonF");
var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $c3CaY = parcelRequire("c3CaY");
var $60Kbk = parcelRequire("60Kbk");
var $ipprj = parcelRequire("ipprj");
var $kBKw3 = parcelRequire("kBKw3");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");

var $cWIrM = parcelRequire("cWIrM");

var $iCU10 = parcelRequire("iCU10");

var $hdNsB = parcelRequire("hdNsB");

var $k0QDS = parcelRequire("k0QDS");

var $lQsZt = parcelRequire("lQsZt");

var $2N6Uo = parcelRequire("2N6Uo");

var $6TSUP = parcelRequire("6TSUP");

var $eAFw0 = parcelRequire("eAFw0");
function $df603d940010930e$var$parsePosition(seriesModel, api) {
    var center = seriesModel.get('center');
    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = (0, $iCU10.parsePercent)(center[0], api.getWidth());
    var cy = (0, $iCU10.parsePercent)(center[1], api.getHeight());
    var r = (0, $iCU10.parsePercent)(seriesModel.get('radius'), size / 2);
    return {
        cx: cx,
        cy: cy,
        r: r
    };
}
function $df603d940010930e$var$formatLabel(value, labelFormatter) {
    var label = value == null ? '' : value + '';
    if (labelFormatter) {
        if ((0, $2N6Uo.isString)(labelFormatter)) label = labelFormatter.replace('{value}', label);
        else if ((0, $2N6Uo.isFunction)(labelFormatter)) label = labelFormatter(value);
    }
    return label;
}
var $df603d940010930e$var$GaugeView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GaugeView, _super);
    function GaugeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeView.type;
        return _this;
    }
    GaugeView.prototype.render = function(seriesModel, ecModel, api) {
        this.group.removeAll();
        var colorList = seriesModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var posInfo = $df603d940010930e$var$parsePosition(seriesModel, api);
        this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
        this._data = seriesModel.getData();
    };
    GaugeView.prototype.dispose = function() {};
    GaugeView.prototype._renderMain = function(seriesModel, ecModel, api, colorList, posInfo) {
        var group = this.group;
        var clockwise = seriesModel.get('clockwise');
        var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
        var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
        var axisLineModel = seriesModel.getModel('axisLine');
        var roundCap = axisLineModel.get('roundCap');
        var MainPath = roundCap ? (0, $hdNsB.default) : $60Kbk.default;
        var showAxis = axisLineModel.get('show');
        var lineStyleModel = axisLineModel.getModel('lineStyle');
        var axisLineWidth = lineStyleModel.get('width');
        var angles = [
            startAngle,
            endAngle
        ];
        (0, $eAFw0.normalizeArcAngles)(angles, !clockwise);
        startAngle = angles[0];
        endAngle = angles[1];
        var angleRangeSpan = endAngle - startAngle;
        var prevEndAngle = startAngle;
        var sectors = [];
        for(var i = 0; showAxis && i < colorList.length; i++){
            // Clamp
            var percent = Math.min(Math.max(colorList[i][0], 0), 1);
            endAngle = startAngle + angleRangeSpan * percent;
            var sector = new MainPath({
                shape: {
                    startAngle: prevEndAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: posInfo.r - axisLineWidth,
                    r: posInfo.r
                },
                silent: true
            });
            sector.setStyle({
                fill: colorList[i][1]
            });
            sector.setStyle(lineStyleModel.getLineStyle(// Because we use sector to simulate arc
            // so the properties for stroking are useless
            [
                'color',
                'width'
            ]));
            sectors.push(sector);
            prevEndAngle = endAngle;
        }
        sectors.reverse();
        (0, $2N6Uo.each)(sectors, function(sector) {
            return group.add(sector);
        });
        var getColor = function(percent) {
            // Less than 0
            if (percent <= 0) return colorList[0][1];
            var i;
            for(i = 0; i < colorList.length; i++){
                if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) return colorList[i][1];
            }
            // More than 1
            return colorList[i - 1][1];
        };
        this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
        this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);
        this._renderAnchor(seriesModel, posInfo);
        this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
    };
    GaugeView.prototype._renderTicks = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var cx = posInfo.cx;
        var cy = posInfo.cy;
        var r = posInfo.r;
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var splitLineModel = seriesModel.getModel('splitLine');
        var tickModel = seriesModel.getModel('axisTick');
        var labelModel = seriesModel.getModel('axisLabel');
        var splitNumber = seriesModel.get('splitNumber');
        var subSplitNumber = tickModel.get('splitNumber');
        var splitLineLen = (0, $iCU10.parsePercent)(splitLineModel.get('length'), r);
        var tickLen = (0, $iCU10.parsePercent)(tickModel.get('length'), r);
        var angle = startAngle;
        var step = (endAngle - startAngle) / splitNumber;
        var subStep = step / subSplitNumber;
        var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
        var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
        var splitLineDistance = splitLineModel.get('distance');
        var unitX;
        var unitY;
        for(var i = 0; i <= splitNumber; i++){
            unitX = Math.cos(angle);
            unitY = Math.sin(angle);
            // Split line
            if (splitLineModel.get('show')) {
                var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
                var splitLine = new $c3CaY.default({
                    shape: {
                        x1: unitX * (r - distance) + cx,
                        y1: unitY * (r - distance) + cy,
                        x2: unitX * (r - splitLineLen - distance) + cx,
                        y2: unitY * (r - splitLineLen - distance) + cy
                    },
                    style: splitLineStyle,
                    silent: true
                });
                if (splitLineStyle.stroke === 'auto') splitLine.setStyle({
                    stroke: getColor(i / splitNumber)
                });
                group.add(splitLine);
            }
            // Label
            if (labelModel.get('show')) {
                var distance = labelModel.get('distance') + splitLineDistance;
                var label = $df603d940010930e$var$formatLabel((0, $iCU10.round)(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
                var autoColor = getColor(i / splitNumber);
                var textStyleX = unitX * (r - splitLineLen - distance) + cx;
                var textStyleY = unitY * (r - splitLineLen - distance) + cy;
                var rotateType = labelModel.get('rotate');
                var rotate = 0;
                if (rotateType === 'radial') {
                    rotate = -angle + 2 * Math.PI;
                    if (rotate > Math.PI / 2) rotate += Math.PI;
                } else if (rotateType === 'tangential') rotate = -angle - Math.PI / 2;
                else if ((0, $2N6Uo.isNumber)(rotateType)) rotate = rotateType * Math.PI / 180;
                if (rotate === 0) group.add(new $kBKw3.default({
                    style: (0, $bysmE.createTextStyle)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: unitY < -0.8 ? 'top' : unitY > 0.8 ? 'bottom' : 'middle',
                        align: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true
                }));
                else group.add(new $kBKw3.default({
                    style: (0, $bysmE.createTextStyle)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: 'middle',
                        align: 'center'
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true,
                    originX: textStyleX,
                    originY: textStyleY,
                    rotation: rotate
                }));
            }
            // Axis tick
            if (tickModel.get('show') && i !== splitNumber) {
                var distance = tickModel.get('distance');
                distance = distance ? distance + axisLineWidth : axisLineWidth;
                for(var j = 0; j <= subSplitNumber; j++){
                    unitX = Math.cos(angle);
                    unitY = Math.sin(angle);
                    var tickLine = new $c3CaY.default({
                        shape: {
                            x1: unitX * (r - distance) + cx,
                            y1: unitY * (r - distance) + cy,
                            x2: unitX * (r - tickLen - distance) + cx,
                            y2: unitY * (r - tickLen - distance) + cy
                        },
                        silent: true,
                        style: tickLineStyle
                    });
                    if (tickLineStyle.stroke === 'auto') tickLine.setStyle({
                        stroke: getColor((i + j / subSplitNumber) / splitNumber)
                    });
                    group.add(tickLine);
                    angle += subStep;
                }
                angle -= subStep;
            } else angle += step;
        }
    };
    GaugeView.prototype._renderPointer = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var oldData = this._data;
        var oldProgressData = this._progressEls;
        var progressList = [];
        var showPointer = seriesModel.get([
            'pointer',
            'show'
        ]);
        var progressModel = seriesModel.getModel('progress');
        var showProgress = progressModel.get('show');
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var valueExtent = [
            minVal,
            maxVal
        ];
        var angleExtent = [
            startAngle,
            endAngle
        ];
        function createPointer(idx, angle) {
            var itemModel = data.getItemModel(idx);
            var pointerModel = itemModel.getModel('pointer');
            var pointerWidth = (0, $iCU10.parsePercent)(pointerModel.get('width'), posInfo.r);
            var pointerLength = (0, $iCU10.parsePercent)(pointerModel.get('length'), posInfo.r);
            var pointerStr = seriesModel.get([
                'pointer',
                'icon'
            ]);
            var pointerOffset = pointerModel.get('offsetCenter');
            var pointerOffsetX = (0, $iCU10.parsePercent)(pointerOffset[0], posInfo.r);
            var pointerOffsetY = (0, $iCU10.parsePercent)(pointerOffset[1], posInfo.r);
            var pointerKeepAspect = pointerModel.get('keepAspect');
            var pointer;
            // not exist icon type will be set 'rect'
            if (pointerStr) pointer = (0, $k0QDS.createSymbol)(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
            else pointer = new (0, $hMd6Y.default)({
                shape: {
                    angle: -Math.PI / 2,
                    width: pointerWidth,
                    r: pointerLength,
                    x: pointerOffsetX,
                    y: pointerOffsetY
                }
            });
            pointer.rotation = -(angle + Math.PI / 2);
            pointer.x = posInfo.cx;
            pointer.y = posInfo.cy;
            return pointer;
        }
        function createProgress(idx, endAngle) {
            var roundCap = progressModel.get('roundCap');
            var ProgressPath = roundCap ? (0, $hdNsB.default) : $60Kbk.default;
            var isOverlap = progressModel.get('overlap');
            var progressWidth = isOverlap ? progressModel.get('width') : axisLineWidth / data.count();
            var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
            var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
            var progress = new ProgressPath({
                shape: {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: r0,
                    r: r
                }
            });
            isOverlap && (progress.z2 = (0, $iCU10.linearMap)(data.get(valueDim, idx), [
                minVal,
                maxVal
            ], [
                100,
                0
            ], true));
            return progress;
        }
        if (showProgress || showPointer) {
            data.diff(oldData).add(function(idx) {
                var val = data.get(valueDim, idx);
                if (showPointer) {
                    var pointer = createPointer(idx, startAngle);
                    // TODO hide pointer on NaN value?
                    $ipprj.initProps(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $iCU10.linearMap)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(idx, pointer);
                }
                if (showProgress) {
                    var progress = createProgress(idx, startAngle);
                    var isClip = progressModel.get('clip');
                    $ipprj.initProps(progress, {
                        shape: {
                            endAngle: (0, $iCU10.linearMap)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $6TSUP.setCommonECData)(seriesModel.seriesIndex, data.dataType, idx, progress);
                    progressList[idx] = progress;
                }
            }).update(function(newIdx, oldIdx) {
                var val = data.get(valueDim, newIdx);
                if (showPointer) {
                    var previousPointer = oldData.getItemGraphicEl(oldIdx);
                    var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
                    var pointer = createPointer(newIdx, previousRotate);
                    pointer.rotation = previousRotate;
                    $ipprj.updateProps(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $iCU10.linearMap)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(newIdx, pointer);
                }
                if (showProgress) {
                    var previousProgress = oldProgressData[oldIdx];
                    var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
                    var progress = createProgress(newIdx, previousEndAngle);
                    var isClip = progressModel.get('clip');
                    $ipprj.updateProps(progress, {
                        shape: {
                            endAngle: (0, $iCU10.linearMap)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $6TSUP.setCommonECData)(seriesModel.seriesIndex, data.dataType, newIdx, progress);
                    progressList[newIdx] = progress;
                }
            }).execute();
            data.each(function(idx) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel = itemModel.getModel('emphasis');
                var focus = emphasisModel.get('focus');
                var blurScope = emphasisModel.get('blurScope');
                var emphasisDisabled = emphasisModel.get('disabled');
                if (showPointer) {
                    var pointer = data.getItemGraphicEl(idx);
                    var symbolStyle = data.getItemVisual(idx, 'style');
                    var visualColor = symbolStyle.fill;
                    if (pointer instanceof (0, $lQsZt.default)) {
                        var pathStyle = pointer.style;
                        pointer.useStyle((0, $2N6Uo.extend)({
                            image: pathStyle.image,
                            x: pathStyle.x,
                            y: pathStyle.y,
                            width: pathStyle.width,
                            height: pathStyle.height
                        }, symbolStyle));
                    } else {
                        pointer.useStyle(symbolStyle);
                        pointer.type !== 'pointer' && pointer.setColor(visualColor);
                    }
                    pointer.setStyle(itemModel.getModel([
                        'pointer',
                        'itemStyle'
                    ]).getItemStyle());
                    if (pointer.style.fill === 'auto') pointer.setStyle('fill', getColor((0, $iCU10.linearMap)(data.get(valueDim, idx), valueExtent, [
                        0,
                        1
                    ], true)));
                    pointer.z2EmphasisLift = 0;
                    (0, $bwPbQ.setStatesStylesFromModel)(pointer, itemModel);
                    (0, $bwPbQ.toggleHoverEmphasis)(pointer, focus, blurScope, emphasisDisabled);
                }
                if (showProgress) {
                    var progress = progressList[idx];
                    progress.useStyle(data.getItemVisual(idx, 'style'));
                    progress.setStyle(itemModel.getModel([
                        'progress',
                        'itemStyle'
                    ]).getItemStyle());
                    progress.z2EmphasisLift = 0;
                    (0, $bwPbQ.setStatesStylesFromModel)(progress, itemModel);
                    (0, $bwPbQ.toggleHoverEmphasis)(progress, focus, blurScope, emphasisDisabled);
                }
            });
            this._progressEls = progressList;
        }
    };
    GaugeView.prototype._renderAnchor = function(seriesModel, posInfo) {
        var anchorModel = seriesModel.getModel('anchor');
        var showAnchor = anchorModel.get('show');
        if (showAnchor) {
            var anchorSize = anchorModel.get('size');
            var anchorType = anchorModel.get('icon');
            var offsetCenter = anchorModel.get('offsetCenter');
            var anchorKeepAspect = anchorModel.get('keepAspect');
            var anchor = (0, $k0QDS.createSymbol)(anchorType, posInfo.cx - anchorSize / 2 + (0, $iCU10.parsePercent)(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + (0, $iCU10.parsePercent)(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
            anchor.z2 = anchorModel.get('showAbove') ? 1 : 0;
            anchor.setStyle(anchorModel.getModel('itemStyle').getItemStyle());
            this.group.add(anchor);
        }
    };
    GaugeView.prototype._renderTitleAndDetail = function(seriesModel, ecModel, api, getColor, posInfo) {
        var _this = this;
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var contentGroup = new $iQonF.default();
        var newTitleEls = [];
        var newDetailEls = [];
        var hasAnimation = seriesModel.isAnimationEnabled();
        var showPointerAbove = seriesModel.get([
            'pointer',
            'showAbove'
        ]);
        data.diff(this._data).add(function(idx) {
            newTitleEls[idx] = new $kBKw3.default({
                silent: true
            });
            newDetailEls[idx] = new $kBKw3.default({
                silent: true
            });
        }).update(function(idx, oldIdx) {
            newTitleEls[idx] = _this._titleEls[oldIdx];
            newDetailEls[idx] = _this._detailEls[oldIdx];
        }).execute();
        data.each(function(idx) {
            var itemModel = data.getItemModel(idx);
            var value = data.get(valueDim, idx);
            var itemGroup = new $iQonF.default();
            var autoColor = getColor((0, $iCU10.linearMap)(value, [
                minVal,
                maxVal
            ], [
                0,
                1
            ], true));
            var itemTitleModel = itemModel.getModel('title');
            if (itemTitleModel.get('show')) {
                var titleOffsetCenter = itemTitleModel.get('offsetCenter');
                var titleX = posInfo.cx + (0, $iCU10.parsePercent)(titleOffsetCenter[0], posInfo.r);
                var titleY = posInfo.cy + (0, $iCU10.parsePercent)(titleOffsetCenter[1], posInfo.r);
                var labelEl = newTitleEls[idx];
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $bysmE.createTextStyle)(itemTitleModel, {
                        x: titleX,
                        y: titleY,
                        text: data.getName(idx),
                        align: 'center',
                        verticalAlign: 'middle'
                    }, {
                        inheritColor: autoColor
                    })
                });
                itemGroup.add(labelEl);
            }
            var itemDetailModel = itemModel.getModel('detail');
            if (itemDetailModel.get('show')) {
                var detailOffsetCenter = itemDetailModel.get('offsetCenter');
                var detailX = posInfo.cx + (0, $iCU10.parsePercent)(detailOffsetCenter[0], posInfo.r);
                var detailY = posInfo.cy + (0, $iCU10.parsePercent)(detailOffsetCenter[1], posInfo.r);
                var width = (0, $iCU10.parsePercent)(itemDetailModel.get('width'), posInfo.r);
                var height = (0, $iCU10.parsePercent)(itemDetailModel.get('height'), posInfo.r);
                var detailColor = seriesModel.get([
                    'progress',
                    'show'
                ]) ? data.getItemVisual(idx, 'style').fill : autoColor;
                var labelEl = newDetailEls[idx];
                var formatter_1 = itemDetailModel.get('formatter');
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $bysmE.createTextStyle)(itemDetailModel, {
                        x: detailX,
                        y: detailY,
                        text: $df603d940010930e$var$formatLabel(value, formatter_1),
                        width: isNaN(width) ? null : width,
                        height: isNaN(height) ? null : height,
                        align: 'center',
                        verticalAlign: 'middle'
                    }, {
                        inheritColor: detailColor
                    })
                });
                (0, $bysmE.setLabelValueAnimation)(labelEl, {
                    normal: itemDetailModel
                }, value, function(value) {
                    return $df603d940010930e$var$formatLabel(value, formatter_1);
                });
                hasAnimation && (0, $bysmE.animateLabelValue)(labelEl, idx, data, seriesModel, {
                    getFormattedLabel: function(labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
                        return $df603d940010930e$var$formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
                    }
                });
                itemGroup.add(labelEl);
            }
            contentGroup.add(itemGroup);
        });
        this.group.add(contentGroup);
        this._titleEls = newTitleEls;
        this._detailEls = newDetailEls;
    };
    GaugeView.type = 'gauge';
    return GaugeView;
}((0, $cWIrM.default));
var $df603d940010930e$export$2e2bcd8739ae039 = $df603d940010930e$var$GaugeView;

});
parcelRegister("hMd6Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf111704b069a0f6$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");
var $cf111704b069a0f6$var$PointerShape = /** @class */ function() {
    function PointerShape() {
        this.angle = 0;
        this.width = 10;
        this.r = 10;
        this.x = 0;
        this.y = 0;
    }
    return PointerShape;
}();
var $cf111704b069a0f6$var$PointerPath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PointerPath, _super);
    function PointerPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'pointer';
        return _this;
    }
    PointerPath.prototype.getDefaultShape = function() {
        return new $cf111704b069a0f6$var$PointerShape();
    };
    PointerPath.prototype.buildPath = function(ctx, shape) {
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        var r = shape.r;
        var width = shape.width;
        var angle = shape.angle;
        var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
        var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
        angle = shape.angle - Math.PI / 2;
        ctx.moveTo(x, y);
        ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
        ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
        ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
        ctx.lineTo(x, y);
    };
    return PointerPath;
}((0, $4oDJM.default));
var $cf111704b069a0f6$export$2e2bcd8739ae039 = $cf111704b069a0f6$var$PointerPath;

});


parcelRegister("dOyXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0eb1119226f1075$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $1rIDm = parcelRequire("1rIDm");

var $49X8G = parcelRequire("49X8G");

var $6aXXD = parcelRequire("6aXXD");
var $a0eb1119226f1075$var$GaugeSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GaugeSeriesModel, _super);
    function GaugeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeSeriesModel.type;
        _this.visualStyleAccessPath = 'itemStyle';
        return _this;
    }
    GaugeSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $1rIDm.default)(this, [
            'value'
        ]);
    };
    GaugeSeriesModel.type = 'series.gauge';
    GaugeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        legendHoverLink: true,
        radius: '75%',
        startAngle: 225,
        endAngle: -45,
        clockwise: true,
        // 最小值
        min: 0,
        // 最大值
        max: 100,
        // 分割段数，默认为10
        splitNumber: 10,
        // 坐标轴线
        axisLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            roundCap: false,
            lineStyle: {
                color: [
                    [
                        1,
                        (0, $6aXXD.default).color.neutral10
                    ]
                ],
                width: 10
            }
        },
        // 坐标轴线
        progress: {
            // 默认显示，属性show控制显示与否
            show: false,
            overlap: true,
            width: 10,
            roundCap: false,
            clip: true
        },
        // 分隔线
        splitLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            // 属性length控制线长
            length: 10,
            distance: 10,
            // 属性lineStyle（详见lineStyle）控制线条样式
            lineStyle: {
                color: (0, $6aXXD.default).color.axisTick,
                width: 3,
                type: 'solid'
            }
        },
        // 坐标轴小标记
        axisTick: {
            // 属性show控制显示与否，默认不显示
            show: true,
            // 每份split细分多少段
            splitNumber: 5,
            // 属性length控制线长
            length: 6,
            distance: 10,
            // 属性lineStyle控制线条样式
            lineStyle: {
                color: (0, $6aXXD.default).color.axisTickMinor,
                width: 1,
                type: 'solid'
            }
        },
        axisLabel: {
            show: true,
            distance: 15,
            // formatter: null,
            color: (0, $6aXXD.default).color.axisLabel,
            fontSize: 12,
            rotate: 0
        },
        pointer: {
            icon: null,
            offsetCenter: [
                0,
                0
            ],
            show: true,
            showAbove: true,
            length: '60%',
            width: 6,
            keepAspect: false
        },
        anchor: {
            show: false,
            showAbove: false,
            size: 6,
            icon: 'circle',
            offsetCenter: [
                0,
                0
            ],
            keepAspect: false,
            itemStyle: {
                color: (0, $6aXXD.default).color.neutral00,
                borderWidth: 0,
                borderColor: (0, $6aXXD.default).color.theme[0]
            }
        },
        title: {
            show: true,
            // x, y，单位px
            offsetCenter: [
                0,
                '20%'
            ],
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: (0, $6aXXD.default).color.secondary,
            fontSize: 16,
            valueAnimation: false
        },
        detail: {
            show: true,
            backgroundColor: (0, $6aXXD.default).color.transparent,
            borderWidth: 0,
            borderColor: (0, $6aXXD.default).color.neutral40,
            width: 100,
            height: null,
            padding: [
                5,
                10
            ],
            // x, y，单位px
            offsetCenter: [
                0,
                '40%'
            ],
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: (0, $6aXXD.default).color.primary,
            fontSize: 30,
            fontWeight: 'bold',
            lineHeight: 30,
            valueAnimation: false
        }
    };
    return GaugeSeriesModel;
}((0, $49X8G.default));
var $a0eb1119226f1075$export$2e2bcd8739ae039 = $a0eb1119226f1075$var$GaugeSeriesModel;

});


parcelRegister("7Zi7T", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $5d0c4a6e03e98114$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4FqUh = parcelRequire("4FqUh");

var $6ZovY = parcelRequire("6ZovY");

var $gxUxR = parcelRequire("gxUxR");

var $1lPVW = parcelRequire("1lPVW");

var $1lUYy = parcelRequire("1lUYy");

var $3Okgo = parcelRequire("3Okgo");

var $8AQG6 = parcelRequire("8AQG6");

var $11tae = parcelRequire("11tae");

var $4KTbx = parcelRequire("4KTbx");

var $3f68f = parcelRequire("3f68f");

var $kc4jZ = parcelRequire("kc4jZ");

var $2N6Uo = parcelRequire("2N6Uo");
function $5d0c4a6e03e98114$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $4KTbx.default));
    registers.registerSeriesModel((0, $3f68f.default));
    registers.registerProcessor((0, $4FqUh.default));
    registers.registerVisual((0, $6ZovY.default));
    registers.registerVisual((0, $gxUxR.default));
    registers.registerLayout((0, $1lPVW.default));
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $1lUYy.default));
    registers.registerLayout((0, $3Okgo.default));
    registers.registerCoordinateSystem('graphView', {
        dimensions: (0, $11tae.default).dimensions,
        create: (0, $8AQG6.default)
    });
    // Register legacy focus actions
    registers.registerAction({
        type: 'focusNodeAdjacency',
        event: 'focusNodeAdjacency',
        update: 'series:focusNodeAdjacency'
    }, (0, $2N6Uo.noop));
    registers.registerAction({
        type: 'unfocusNodeAdjacency',
        event: 'unfocusNodeAdjacency',
        update: 'series:unfocusNodeAdjacency'
    }, (0, $2N6Uo.noop));
    // Register roam action.
    registers.registerAction({
        type: 'graphRoam',
        event: 'graphRoam',
        update: 'none'
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: 'series',
            query: payload
        }, function(seriesModel) {
            var graphView = api.getViewOfSeriesModel(seriesModel);
            if (graphView) {
                if (payload.dx != null && payload.dy != null) graphView.updateViewOnPan(seriesModel, api, payload);
                if (payload.zoom != null && payload.originX != null && payload.originY != null) graphView.updateViewOnZoom(seriesModel, api, payload);
            }
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $kc4jZ.updateCenterAndZoomInAction)(coordSys, payload, seriesModel.get('scaleLimit'));
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}

});
parcelRegister("4FqUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $365fdce4fef0f164$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $365fdce4fef0f164$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (!legendModels || !legendModels.length) return;
    ecModel.eachSeriesByType('graph', function(graphSeries) {
        var categoriesData = graphSeries.getCategoriesData();
        var graph = graphSeries.getGraph();
        var data = graph.data;
        var categoryNames = categoriesData.mapArray(categoriesData.getName);
        data.filterSelf(function(idx) {
            var model = data.getItemModel(idx);
            var category = model.getShallow('category');
            if (category != null) {
                if ((0, $2N6Uo.isNumber)(category)) category = categoryNames[category];
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    if (!legendModels[i].isSelected(category)) return false;
                }
            }
            return true;
        });
    });
}

});

parcelRegister("6ZovY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $516b74abadece6a8$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $516b74abadece6a8$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var categoriesData = seriesModel.getCategoriesData();
        var data = seriesModel.getData();
        var categoryNameIdxMap = {};
        categoriesData.each(function(idx) {
            var name = categoriesData.getName(idx);
            // Add prefix to avoid conflict with Object.prototype.
            categoryNameIdxMap['ec-' + name] = idx;
            var itemModel = categoriesData.getItemModel(idx);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (!style.fill) // Get color from palette.
            style.fill = seriesModel.getColorFromPalette(name, paletteScope);
            categoriesData.setItemVisual(idx, 'style', style);
            var symbolVisualList = [
                'symbol',
                'symbolSize',
                'symbolKeepAspect'
            ];
            for(var i = 0; i < symbolVisualList.length; i++){
                var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);
                if (symbolVisual != null) categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
            }
        });
        // Assign category color to visual
        if (categoriesData.count()) data.each(function(idx) {
            var model = data.getItemModel(idx);
            var categoryIdx = model.getShallow('category');
            if (categoryIdx != null) {
                if ((0, $2N6Uo.isString)(categoryIdx)) categoryIdx = categoryNameIdxMap['ec-' + categoryIdx];
                var categoryStyle = categoriesData.getItemVisual(categoryIdx, 'style');
                var style = data.ensureUniqueItemVisual(idx, 'style');
                (0, $2N6Uo.extend)(style, categoryStyle);
                var visualList = [
                    'symbol',
                    'symbolSize',
                    'symbolKeepAspect'
                ];
                for(var i = 0; i < visualList.length; i++)data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
            }
        });
    });
}

});

parcelRegister("gxUxR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0bb9717bf702d7c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $c0bb9717bf702d7c$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
function $c0bb9717bf702d7c$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var graph = seriesModel.getGraph();
        var edgeData = seriesModel.getEdgeData();
        var symbolType = $c0bb9717bf702d7c$var$normalize(seriesModel.get('edgeSymbol'));
        var symbolSize = $c0bb9717bf702d7c$var$normalize(seriesModel.get('edgeSymbolSize'));
        // const colorQuery = ['lineStyle', 'color'] as const;
        // const opacityQuery = ['lineStyle', 'opacity'] as const;
        edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
        edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
        edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
        edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
        edgeData.setVisual('style', seriesModel.getModel('lineStyle').getLineStyle());
        edgeData.each(function(idx) {
            var itemModel = edgeData.getItemModel(idx);
            var edge = graph.getEdgeByIndex(idx);
            var symbolType = $c0bb9717bf702d7c$var$normalize(itemModel.getShallow('symbol', true));
            var symbolSize = $c0bb9717bf702d7c$var$normalize(itemModel.getShallow('symbolSize', true));
            // Edge visual must after node visual
            var style = itemModel.getModel('lineStyle').getLineStyle();
            var existsStyle = edgeData.ensureUniqueItemVisual(idx, 'style');
            (0, $2N6Uo.extend)(existsStyle, style);
            switch(existsStyle.stroke){
                case 'source':
                    var nodeStyle = edge.node1.getVisual('style');
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
                case 'target':
                    var nodeStyle = edge.node2.getVisual('style');
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
            }
            symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
            symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
            symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
            symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
        });
    });
}

});

parcelRegister("1lPVW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fc00984da88b73d$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $3heFw = parcelRequire("3heFw");
function $0fc00984da88b73d$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var layout = seriesModel.get('layout');
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.type !== 'view') {
            var data_1 = seriesModel.getData();
            var dimensions_1 = [];
            (0, $2N6Uo.each)(coordSys.dimensions, function(coordDim) {
                dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
            });
            for(var dataIndex = 0; dataIndex < data_1.count(); dataIndex++){
                var value = [];
                var hasValue = false;
                for(var i = 0; i < dimensions_1.length; i++){
                    var val = data_1.get(dimensions_1[i], dataIndex);
                    if (!isNaN(val)) hasValue = true;
                    value.push(val);
                }
                if (hasValue) data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
                else // Also {Array.<number>}, not undefined to avoid if...else... statement
                data_1.setItemLayout(dataIndex, [
                    NaN,
                    NaN
                ]);
            }
            (0, $3heFw.simpleLayoutEdge)(data_1.graph, seriesModel);
        } else if (!layout || layout === 'none') (0, $3heFw.simpleLayout)(seriesModel);
    });
}

});
parcelRegister("3heFw", function(module, exports) {

$parcel$export(module.exports, "simpleLayout", function () { return $262e56843e17936d$export$6d7efb25f4dcb4db; });
$parcel$export(module.exports, "simpleLayoutEdge", function () { return $262e56843e17936d$export$a25b52345bee32aa; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $U1aqY = parcelRequire("U1aqY");

var $2N6Uo = parcelRequire("2N6Uo");

var $cmtYx = parcelRequire("cmtYx");
function $262e56843e17936d$export$6d7efb25f4dcb4db(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== 'view') return;
    var graph = seriesModel.getGraph();
    graph.eachNode(function(node) {
        var model = node.getModel();
        node.setLayout([
            +model.get('x'),
            +model.get('y')
        ]);
    });
    $262e56843e17936d$export$a25b52345bee32aa(graph, seriesModel);
}
function $262e56843e17936d$export$a25b52345bee32aa(graph, seriesModel) {
    graph.eachEdge(function(edge, index) {
        var curveness = $2N6Uo.retrieve3(edge.getModel().get([
            'lineStyle',
            'curveness'
        ]), -(0, $cmtYx.getCurvenessForEdge)(edge, seriesModel, index, true), 0);
        var p1 = $U1aqY.clone(edge.node1.getLayout());
        var p2 = $U1aqY.clone(edge.node2.getLayout());
        var points = [
            p1,
            p2
        ];
        if (+curveness) points.push([
            (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness,
            (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness
        ]);
        edge.setLayout(points);
    });
}

});
parcelRegister("cmtYx", function(module, exports) {

$parcel$export(module.exports, "initCurvenessList", function () { return $8ffeca9813786b65$export$4f05389c1f2934b8; });
$parcel$export(module.exports, "createEdgeMapForCurveness", function () { return $8ffeca9813786b65$export$c47b549eed9a7311; });
$parcel$export(module.exports, "getCurvenessForEdge", function () { return $8ffeca9813786b65$export$7e88123f7f1f62da; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $2N6Uo = parcelRequire("2N6Uo");
var $8ffeca9813786b65$var$KEY_DELIMITER = '-->';
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */ var $8ffeca9813786b65$var$getAutoCurvenessParams = function(seriesModel) {
    return seriesModel.get('autoCurveness') || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */ var $8ffeca9813786b65$var$createCurveness = function(seriesModel, appendLength) {
    var autoCurvenessParmas = $8ffeca9813786b65$var$getAutoCurvenessParams(seriesModel);
    var length = 20;
    var curvenessList = [];
    // handler the function set
    if ($2N6Uo.isNumber(autoCurvenessParmas)) length = autoCurvenessParmas;
    else if ($2N6Uo.isArray(autoCurvenessParmas)) {
        seriesModel.__curvenessList = autoCurvenessParmas;
        return;
    }
    // append length
    if (appendLength > length) length = appendLength;
    // make sure the length is even
    var len = length % 2 ? length + 2 : length + 3;
    curvenessList = [];
    for(var i = 0; i < len; i++)curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
    seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */ var $8ffeca9813786b65$var$getKeyOfEdges = function(n1, n2, seriesModel) {
    var source = [
        n1.id,
        n1.dataIndex
    ].join('.');
    var target = [
        n2.id,
        n2.dataIndex
    ].join('.');
    return [
        seriesModel.uid,
        source,
        target
    ].join($8ffeca9813786b65$var$KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */ var $8ffeca9813786b65$var$getOppositeKey = function(key) {
    var keys = key.split($8ffeca9813786b65$var$KEY_DELIMITER);
    return [
        keys[0],
        keys[2],
        keys[1]
    ].join($8ffeca9813786b65$var$KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */ var $8ffeca9813786b65$var$getEdgeFromMap = function(edge, seriesModel) {
    var key = $8ffeca9813786b65$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */ var $8ffeca9813786b65$var$getTotalLengthBetweenNodes = function(edge, seriesModel) {
    var len = $8ffeca9813786b65$var$getEdgeMapLengthWithKey($8ffeca9813786b65$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
    var lenV = $8ffeca9813786b65$var$getEdgeMapLengthWithKey($8ffeca9813786b65$var$getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
    return len + lenV;
};
/**
 *
 * @param key
 */ var $8ffeca9813786b65$var$getEdgeMapLengthWithKey = function(key, seriesModel) {
    var edgeMap = seriesModel.__edgeMap;
    return edgeMap[key] ? edgeMap[key].length : 0;
};
function $8ffeca9813786b65$export$4f05389c1f2934b8(seriesModel) {
    if (!$8ffeca9813786b65$var$getAutoCurvenessParams(seriesModel)) return;
    seriesModel.__curvenessList = [];
    seriesModel.__edgeMap = {};
    // calc the array of curveness List
    $8ffeca9813786b65$var$createCurveness(seriesModel);
}
function $8ffeca9813786b65$export$c47b549eed9a7311(n1, n2, seriesModel, index) {
    if (!$8ffeca9813786b65$var$getAutoCurvenessParams(seriesModel)) return;
    var key = $8ffeca9813786b65$var$getKeyOfEdges(n1, n2, seriesModel);
    var edgeMap = seriesModel.__edgeMap;
    var oppositeEdges = edgeMap[$8ffeca9813786b65$var$getOppositeKey(key)];
    // set direction
    if (edgeMap[key] && !oppositeEdges) edgeMap[key].isForward = true;
    else if (oppositeEdges && edgeMap[key]) {
        oppositeEdges.isForward = true;
        edgeMap[key].isForward = false;
    }
    edgeMap[key] = edgeMap[key] || [];
    edgeMap[key].push(index);
}
function $8ffeca9813786b65$export$7e88123f7f1f62da(edge, seriesModel, index, needReverse) {
    var autoCurvenessParams = $8ffeca9813786b65$var$getAutoCurvenessParams(seriesModel);
    var isArrayParam = $2N6Uo.isArray(autoCurvenessParams);
    if (!autoCurvenessParams) return null;
    var edgeArray = $8ffeca9813786b65$var$getEdgeFromMap(edge, seriesModel);
    if (!edgeArray) return null;
    var edgeIndex = -1;
    for(var i = 0; i < edgeArray.length; i++)if (edgeArray[i] === index) {
        edgeIndex = i;
        break;
    }
    // if totalLen is Longer createCurveness
    var totalLen = $8ffeca9813786b65$var$getTotalLengthBetweenNodes(edge, seriesModel);
    $8ffeca9813786b65$var$createCurveness(seriesModel, totalLen);
    edge.lineStyle = edge.lineStyle || {};
    // if is opposite edge, must set curvenss to opposite number
    var curKey = $8ffeca9813786b65$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    var curvenessList = seriesModel.__curvenessList;
    // if pass array no need parity
    var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
    if (!edgeArray.isForward) {
        // the opposite edge show outside
        var oppositeKey = $8ffeca9813786b65$var$getOppositeKey(curKey);
        var len = $8ffeca9813786b65$var$getEdgeMapLengthWithKey(oppositeKey, seriesModel);
        var resValue = curvenessList[edgeIndex + len + parityCorrection];
        // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
        if (needReverse) {
            // set as array may make the parity handle with the len of opposite
            if (isArrayParam) {
                if (autoCurvenessParams && autoCurvenessParams[0] === 0) return (len + parityCorrection) % 2 ? resValue : -resValue;
                else return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
            } else return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else return curvenessList[edgeIndex + len + parityCorrection];
    } else return curvenessList[parityCorrection + edgeIndex];
}

});



parcelRegister("1lUYy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fc3f2d11fb4d00d$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dIsge = parcelRequire("dIsge");
function $0fc3f2d11fb4d00d$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        if (seriesModel.get('layout') === 'circular') (0, $dIsge.circularLayout)(seriesModel, 'symbolSize');
    });
}

});
parcelRegister("dIsge", function(module, exports) {

$parcel$export(module.exports, "circularLayout", function () { return $9fc54e6bd7e5a917$export$cbfed6ae5cab3dae; });
$parcel$export(module.exports, "rotateNodeLabel", function () { return $9fc54e6bd7e5a917$export$c768377a6a0a9ab8; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $U1aqY = parcelRequire("U1aqY");

var $fijY1 = parcelRequire("fijY1");

var $2N6Uo = parcelRequire("2N6Uo");

var $cmtYx = parcelRequire("cmtYx");
var $9fc54e6bd7e5a917$var$PI = Math.PI;
var $9fc54e6bd7e5a917$var$_symbolRadiansHalf = [];
function $9fc54e6bd7e5a917$export$cbfed6ae5cab3dae(seriesModel, basedOn, draggingNode, pointer) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== 'view') return;
    var rect = coordSys.getBoundingRect();
    var nodeData = seriesModel.getData();
    var graph = nodeData.graph;
    var cx = rect.width / 2 + rect.x;
    var cy = rect.height / 2 + rect.y;
    var r = Math.min(rect.width, rect.height) / 2;
    var count = nodeData.count();
    nodeData.setLayout({
        cx: cx,
        cy: cy
    });
    if (!count) return;
    if (draggingNode) {
        var _a = coordSys.pointToData(pointer), tempX = _a[0], tempY = _a[1];
        var v = [
            tempX - cx,
            tempY - cy
        ];
        $U1aqY.normalize(v, v);
        $U1aqY.scale(v, v, r);
        draggingNode.setLayout([
            cx + v[0],
            cy + v[1]
        ], true);
        var circularRotateLabel = seriesModel.get([
            'circular',
            'rotateLabel'
        ]);
        $9fc54e6bd7e5a917$export$c768377a6a0a9ab8(draggingNode, circularRotateLabel, cx, cy);
    }
    $9fc54e6bd7e5a917$var$_layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);
    graph.eachEdge(function(edge, index) {
        var curveness = $2N6Uo.retrieve3(edge.getModel().get([
            'lineStyle',
            'curveness'
        ]), (0, $cmtYx.getCurvenessForEdge)(edge, seriesModel, index), 0);
        var p1 = $U1aqY.clone(edge.node1.getLayout());
        var p2 = $U1aqY.clone(edge.node2.getLayout());
        var cp1;
        var x12 = (p1[0] + p2[0]) / 2;
        var y12 = (p1[1] + p2[1]) / 2;
        if (+curveness) {
            curveness *= 3;
            cp1 = [
                cx * curveness + x12 * (1 - curveness),
                cy * curveness + y12 * (1 - curveness)
            ];
        }
        edge.setLayout([
            p1,
            p2,
            cp1
        ]);
    });
}
var $9fc54e6bd7e5a917$var$_layoutNodesBasedOn = {
    value: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var angle = 0;
        var sum = nodeData.getSum('value');
        var unitAngle = Math.PI * 2 / (sum || count);
        graph.eachNode(function(node) {
            var value = node.getValue('value');
            var radianHalf = unitAngle * (sum ? value : 1) / 2;
            angle += radianHalf;
            node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    },
    symbolSize: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var sumRadian = 0;
        $9fc54e6bd7e5a917$var$_symbolRadiansHalf.length = count;
        var nodeScale = (0, $fijY1.getNodeGlobalScale)(seriesModel);
        graph.eachNode(function(node) {
            var symbolSize = (0, $fijY1.getSymbolSize)(node);
            // Normally this case will not happen, but we still add
            // some the defensive code (2px is an arbitrary value).
            isNaN(symbolSize) && (symbolSize = 2);
            symbolSize < 0 && (symbolSize = 0);
            symbolSize *= nodeScale;
            var symbolRadianHalf = Math.asin(symbolSize / 2 / r);
            // when `symbolSize / 2` is bigger than `r`.
            isNaN(symbolRadianHalf) && (symbolRadianHalf = $9fc54e6bd7e5a917$var$PI / 2);
            $9fc54e6bd7e5a917$var$_symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
            sumRadian += symbolRadianHalf * 2;
        });
        var halfRemainRadian = (2 * $9fc54e6bd7e5a917$var$PI - sumRadian) / count / 2;
        var angle = 0;
        graph.eachNode(function(node) {
            var radianHalf = halfRemainRadian + $9fc54e6bd7e5a917$var$_symbolRadiansHalf[node.dataIndex];
            angle += radianHalf;
            // init circular layout for
            // 1. layout undefined node
            // 2. not fixed node
            (!node.getLayout() || !node.getLayout().fixed) && node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    }
};
function $9fc54e6bd7e5a917$export$c768377a6a0a9ab8(node, circularRotateLabel, cx, cy) {
    var el = node.getGraphicEl();
    // need to check if el exists. '-' value may not create node element.
    if (!el) return;
    var nodeModel = node.getModel();
    var labelRotate = nodeModel.get([
        'label',
        'rotate'
    ]) || 0;
    var symbolPath = el.getSymbolPath();
    if (circularRotateLabel) {
        var pos = node.getLayout();
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
        if (rad < 0) rad = Math.PI * 2 + rad;
        var isLeft = pos[0] < cx;
        if (isLeft) rad = rad - Math.PI;
        var textPosition = isLeft ? 'left' : 'right';
        symbolPath.setTextConfig({
            rotation: -rad,
            position: textPosition,
            origin: 'center'
        });
        var emphasisState = symbolPath.ensureState('emphasis');
        $2N6Uo.extend(emphasisState.textConfig || (emphasisState.textConfig = {}), {
            position: textPosition
        });
    } else symbolPath.setTextConfig({
        rotation: labelRotate *= Math.PI / 180
    });
}

});
parcelRegister("fijY1", function(module, exports) {

$parcel$export(module.exports, "getNodeGlobalScale", function () { return $b228068248f2d5a5$export$e2aa0fb9ed198ba7; });
$parcel$export(module.exports, "getSymbolSize", function () { return $b228068248f2d5a5$export$8d4a06d3facd414b; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $b228068248f2d5a5$export$e2aa0fb9ed198ba7(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys.type !== 'view') return 1;
    var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
    var groupZoom = coordSys.scaleX;
    // Scale node when zoom changes
    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
}
function $b228068248f2d5a5$export$8d4a06d3facd414b(node) {
    var symbolSize = node.getVisual('symbolSize');
    if (symbolSize instanceof Array) symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
    return +symbolSize;
}

});



parcelRegister("3Okgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c65c27e9d83a5e2$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bukSz = parcelRequire("bukSz");

var $3heFw = parcelRequire("3heFw");

var $dIsge = parcelRequire("dIsge");

var $iCU10 = parcelRequire("iCU10");

var $U1aqY = parcelRequire("U1aqY");

var $2N6Uo = parcelRequire("2N6Uo");

var $cmtYx = parcelRequire("cmtYx");
function $2c65c27e9d83a5e2$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(graphSeries) {
        var coordSys = graphSeries.coordinateSystem;
        if (coordSys && coordSys.type !== 'view') return;
        if (graphSeries.get('layout') === 'force') {
            var preservedPoints_1 = graphSeries.preservedPoints || {};
            var graph_1 = graphSeries.getGraph();
            var nodeData_1 = graph_1.data;
            var edgeData = graph_1.edgeData;
            var forceModel = graphSeries.getModel('force');
            var initLayout = forceModel.get('initLayout');
            if (graphSeries.preservedPoints) nodeData_1.each(function(idx) {
                var id = nodeData_1.getId(idx);
                nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [
                    NaN,
                    NaN
                ]);
            });
            else if (!initLayout || initLayout === 'none') (0, $3heFw.simpleLayout)(graphSeries);
            else if (initLayout === 'circular') (0, $dIsge.circularLayout)(graphSeries, 'value');
            var nodeDataExtent_1 = nodeData_1.getDataExtent('value');
            var edgeDataExtent_1 = edgeData.getDataExtent('value');
            // let edgeDataExtent = edgeData.getDataExtent('value');
            var repulsion = forceModel.get('repulsion');
            var edgeLength = forceModel.get('edgeLength');
            var repulsionArr_1 = $2N6Uo.isArray(repulsion) ? repulsion : [
                repulsion,
                repulsion
            ];
            var edgeLengthArr_1 = $2N6Uo.isArray(edgeLength) ? edgeLength : [
                edgeLength,
                edgeLength
            ];
            // Larger value has smaller length
            edgeLengthArr_1 = [
                edgeLengthArr_1[1],
                edgeLengthArr_1[0]
            ];
            var nodes_1 = nodeData_1.mapArray('value', function(value, idx) {
                var point = nodeData_1.getItemLayout(idx);
                var rep = (0, $iCU10.linearMap)(value, nodeDataExtent_1, repulsionArr_1);
                if (isNaN(rep)) rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
                return {
                    w: rep,
                    rep: rep,
                    fixed: nodeData_1.getItemModel(idx).get('fixed'),
                    p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
                };
            });
            var edges = edgeData.mapArray('value', function(value, idx) {
                var edge = graph_1.getEdgeByIndex(idx);
                var d = (0, $iCU10.linearMap)(value, edgeDataExtent_1, edgeLengthArr_1);
                if (isNaN(d)) d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
                var edgeModel = edge.getModel();
                var curveness = $2N6Uo.retrieve3(edge.getModel().get([
                    'lineStyle',
                    'curveness'
                ]), -(0, $cmtYx.getCurvenessForEdge)(edge, graphSeries, idx, true), 0);
                return {
                    n1: nodes_1[edge.node1.dataIndex],
                    n2: nodes_1[edge.node2.dataIndex],
                    d: d,
                    curveness: curveness,
                    ignoreForceLayout: edgeModel.get('ignoreForceLayout')
                };
            });
            // let coordSys = graphSeries.coordinateSystem;
            var rect = coordSys.getBoundingRect();
            var forceInstance = (0, $bukSz.forceLayout)(nodes_1, edges, {
                rect: rect,
                gravity: forceModel.get('gravity'),
                friction: forceModel.get('friction')
            });
            forceInstance.beforeStep(function(nodes, edges) {
                for(var i = 0, l = nodes.length; i < l; i++)if (nodes[i].fixed) // Write back to layout instance
                $U1aqY.copy(nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
            });
            forceInstance.afterStep(function(nodes, edges, stopped) {
                for(var i = 0, l = nodes.length; i < l; i++){
                    if (!nodes[i].fixed) graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
                    preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
                }
                for(var i = 0, l = edges.length; i < l; i++){
                    var e = edges[i];
                    var edge = graph_1.getEdgeByIndex(i);
                    var p1 = e.n1.p;
                    var p2 = e.n2.p;
                    var points = edge.getLayout();
                    points = points ? points.slice() : [];
                    points[0] = points[0] || [];
                    points[1] = points[1] || [];
                    $U1aqY.copy(points[0], p1);
                    $U1aqY.copy(points[1], p2);
                    if (+e.curveness) points[2] = [
                        (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness,
                        (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness
                    ];
                    edge.setLayout(points);
                }
            });
            graphSeries.forceLayout = forceInstance;
            graphSeries.preservedPoints = preservedPoints_1;
            // Step to get the layout
            forceInstance.step();
        } else // Remove prev injected forceLayout instance
        graphSeries.forceLayout = null;
    });
}

});
parcelRegister("bukSz", function(module, exports) {

$parcel$export(module.exports, "forceLayout", function () { return $85d2b134900aee71$export$100e93b4853dcbde; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $U1aqY = parcelRequire("U1aqY");
var $85d2b134900aee71$var$scaleAndAdd = $U1aqY.scaleAndAdd;
function $85d2b134900aee71$export$100e93b4853dcbde(inNodes, inEdges, opts) {
    var nodes = inNodes;
    var edges = inEdges;
    var rect = opts.rect;
    var width = rect.width;
    var height = rect.height;
    var center = [
        rect.x + width / 2,
        rect.y + height / 2
    ];
    // let scale = opts.scale || 1;
    var gravity = opts.gravity == null ? 0.1 : opts.gravity;
    // for (let i = 0; i < edges.length; i++) {
    //     let e = edges[i];
    //     let n1 = e.n1;
    //     let n2 = e.n2;
    //     n1.edges = n1.edges || [];
    //     n2.edges = n2.edges || [];
    //     n1.edges.push(e);
    //     n2.edges.push(e);
    // }
    // Init position
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        if (!n.p) n.p = $U1aqY.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
        n.pp = $U1aqY.clone(n.p);
        n.edges = null;
    }
    // Formula in 'Graph Drawing by Force-directed Placement'
    // let k = scale * Math.sqrt(width * height / nodes.length);
    // let k2 = k * k;
    var initialFriction = opts.friction == null ? 0.6 : opts.friction;
    var friction = initialFriction;
    var beforeStepCallback;
    var afterStepCallback;
    return {
        warmUp: function() {
            friction = initialFriction * 0.8;
        },
        setFixed: function(idx) {
            nodes[idx].fixed = true;
        },
        setUnfixed: function(idx) {
            nodes[idx].fixed = false;
        },
        /**
     * Before step hook
     */ beforeStep: function(cb) {
            beforeStepCallback = cb;
        },
        /**
     * After step hook
     */ afterStep: function(cb) {
            afterStepCallback = cb;
        },
        /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */ step: function(cb) {
            beforeStepCallback && beforeStepCallback(nodes, edges);
            var v12 = [];
            var nLen = nodes.length;
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                if (e.ignoreForceLayout) continue;
                var n1 = e.n1;
                var n2 = e.n2;
                $U1aqY.sub(v12, n2.p, n1.p);
                var d = $U1aqY.len(v12) - e.d;
                var w = n2.w / (n1.w + n2.w);
                if (isNaN(w)) w = 0;
                $U1aqY.normalize(v12, v12);
                !n1.fixed && $85d2b134900aee71$var$scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
                !n2.fixed && $85d2b134900aee71$var$scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
            }
            // Gravity
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $U1aqY.sub(v12, center, n.p);
                    // let d = vec2.len(v12);
                    // vec2.scale(v12, v12, 1 / d);
                    // let gravityFactor = gravity;
                    $85d2b134900aee71$var$scaleAndAdd(n.p, n.p, v12, gravity * friction);
                }
            }
            // Repulsive
            // PENDING
            for(var i = 0; i < nLen; i++){
                var n1 = nodes[i];
                for(var j = i + 1; j < nLen; j++){
                    var n2 = nodes[j];
                    $U1aqY.sub(v12, n2.p, n1.p);
                    var d = $U1aqY.len(v12);
                    if (d === 0) {
                        // Random repulse
                        $U1aqY.set(v12, Math.random() - 0.5, Math.random() - 0.5);
                        d = 1;
                    }
                    var repFact = (n1.rep + n2.rep) / d / d;
                    !n1.fixed && $85d2b134900aee71$var$scaleAndAdd(n1.pp, n1.pp, v12, repFact);
                    !n2.fixed && $85d2b134900aee71$var$scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
                }
            }
            var v = [];
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $U1aqY.sub(v, n.p, n.pp);
                    $85d2b134900aee71$var$scaleAndAdd(n.p, n.p, v, friction);
                    $U1aqY.copy(n.pp, n.p);
                }
            }
            friction = friction * 0.992;
            var finished = friction < 0.01;
            afterStepCallback && afterStepCallback(nodes, edges, finished);
            cb && cb(finished);
        }
    };
}

});


parcelRegister("8AQG6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $641a8c4cee2878e0$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME Where to create the simple view coordinate system

var $11tae = parcelRequire("11tae");

var $a35Wn = parcelRequire("a35Wn");

var $kK0Aj = parcelRequire("kK0Aj");

var $2N6Uo = parcelRequire("2N6Uo");

var $hIXrb = parcelRequire("hIXrb");
function $641a8c4cee2878e0$var$getViewRect(seriesModel, api, aspect) {
    var layoutRef = (0, $a35Wn.createBoxLayoutReference)(seriesModel, api);
    var option = (0, $2N6Uo.extend)(seriesModel.getBoxLayoutParams(), {
        aspect: aspect
    });
    var viewRect = (0, $a35Wn.getLayoutRect)(option, layoutRef.refContainer);
    return (0, $a35Wn.applyPreserveAspect)(seriesModel, viewRect, aspect);
}
function $641a8c4cee2878e0$export$2e2bcd8739ae039(ecModel, api) {
    var viewList = [];
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        (0, $hIXrb.injectCoordSysByOption)({
            targetModel: seriesModel,
            coordSysType: 'view',
            coordSysProvider: createViewCoordSys,
            isDefaultDataCoordSys: true
        });
        function createViewCoordSys() {
            var data = seriesModel.getData();
            var positions = data.mapArray(function(idx) {
                var itemModel = data.getItemModel(idx);
                return [
                    +itemModel.get('x'),
                    +itemModel.get('y')
                ];
            });
            var min = [];
            var max = [];
            $kK0Aj.fromPoints(positions, min, max);
            // If width or height is 0
            if (max[0] - min[0] === 0) {
                max[0] += 1;
                min[0] -= 1;
            }
            if (max[1] - min[1] === 0) {
                max[1] += 1;
                min[1] -= 1;
            }
            var aspect = (max[0] - min[0]) / (max[1] - min[1]);
            // FIXME If get view rect after data processed?
            var viewRect = $641a8c4cee2878e0$var$getViewRect(seriesModel, api, aspect);
            // Position may be NaN, use view rect instead
            if (isNaN(aspect)) {
                min = [
                    viewRect.x,
                    viewRect.y
                ];
                max = [
                    viewRect.x + viewRect.width,
                    viewRect.y + viewRect.height
                ];
            }
            var bbWidth = max[0] - min[0];
            var bbHeight = max[1] - min[1];
            var viewCoordSys = new (0, $11tae.default)(null, {
                api: api,
                ecModel: ecModel
            });
            viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
            viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
            viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
            // Update roam info
            viewCoordSys.setCenter(seriesModel.get('center'));
            viewCoordSys.setZoom(seriesModel.get('zoom'));
            viewList.push(viewCoordSys);
            return viewCoordSys;
        }
    });
    return viewList;
}

});
parcelRegister("11tae", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bec81cde8e07dbd$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $U1aqY = parcelRequire("U1aqY");

var $19Ywy = parcelRequire("19Ywy");

var $67W72 = parcelRequire("67W72");

var $erz95 = parcelRequire("erz95");

var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");

var $kc4jZ = parcelRequire("kc4jZ");
var $0bec81cde8e07dbd$var$v2ApplyTransform = $U1aqY.applyTransform;
var $0bec81cde8e07dbd$var$View = /** @class */ function(_super) {
    (0, $9nEce.__extends)(View, _super);
    function View(name, opt) {
        var _this = _super.call(this) || this;
        _this.type = 'view';
        _this.dimensions = [
            'x',
            'y'
        ];
        /**
     * Represents the transform brought by roam/zoom.
     * If `View['_viewRect']` applies roam transform,
     * we can get the final displayed rect.
     */ _this._roamTransformable = new (0, $erz95.default)();
        /**
     * Represents the transform from `View['_rect']` to `View['_viewRect']`.
     */ _this._rawTransformable = new (0, $erz95.default)();
        _this.name = name;
        _this._opt = opt;
        return _this;
    }
    View.prototype.setBoundingRect = function(x, y, width, height) {
        this._rect = new (0, $67W72.default)(x, y, width, height);
        this._updateCenterAndZoom();
        return this._rect;
    };
    View.prototype.getBoundingRect = function() {
        return this._rect;
    };
    /**
   * If no need to transform `View['_rect']` to `View['_viewRect']`, the calling of
   * `setViewRect` can be omitted.
   */ View.prototype.setViewRect = function(x, y, width, height) {
        this._transformTo(x, y, width, height);
        this._viewRect = new (0, $67W72.default)(x, y, width, height);
    };
    /**
   * Transformed to particular position and size
   */ View.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var rawTransform = this._rawTransformable;
        rawTransform.transform = rect.calculateTransform(new (0, $67W72.default)(x, y, width, height));
        var rawParent = rawTransform.parent;
        rawTransform.parent = null;
        rawTransform.decomposeTransform();
        rawTransform.parent = rawParent;
        this._updateTransform();
    };
    /**
   * [NOTICE]
   *  The definition of this center has always been irrelevant to some other series center like
   *  'series-pie.center' - this center is a point on the same coord sys as `View['_rect'].x/y`,
   *  rather than canvas viewport, and the unit is not necessarily pixel (e.g., in geo case).
   *  @see {View['_center']} for details.
   */ View.prototype.setCenter = function(centerCoord) {
        // #16904 introcuded percentage string here, such as '33%'. But it was based on canvas
        // width/height, which is not reasonable - the unit may incorrect, and it is unpredictable if
        // the `View['_rect']` is not calculated based on the current canvas rect. Therefore the percentage
        // value is changed to based on `View['_rect'].width/height` since v6. Under this definition, users
        // can use '0%' to map the top-left of `View['_rect']` to the center of `View['_viewRect']`.
        var opt = this._opt;
        if (opt && opt.api && opt.ecModel && opt.ecModel.getShallow('legacyViewCoordSysCenterBase') && centerCoord) centerCoord = [
            (0, $iCU10.parsePercent)(centerCoord[0], opt.api.getWidth()),
            (0, $iCU10.parsePercent)(centerCoord[1], opt.api.getWidth())
        ];
        this._centerOption = (0, $2N6Uo.clone)(centerCoord);
        this._updateCenterAndZoom();
    };
    View.prototype.setZoom = function(zoom) {
        this._zoom = (0, $kc4jZ.clampByZoomLimit)(zoom || 1, this.zoomLimit);
        this._updateCenterAndZoom();
    };
    /**
   * Get default center without roam
   */ View.prototype.getDefaultCenter = function() {
        // Rect before any transform
        var rawRect = this.getBoundingRect();
        var cx = rawRect.x + rawRect.width / 2;
        var cy = rawRect.y + rawRect.height / 2;
        return [
            cx,
            cy
        ];
    };
    View.prototype.getCenter = function() {
        return this._center || this.getDefaultCenter();
    };
    View.prototype.getZoom = function() {
        return this._zoom || 1;
    };
    View.prototype.getRoamTransform = function() {
        return this._roamTransformable.getLocalTransform();
    };
    /**
   * Ensure this method is idempotent, since it should be called when
   * every relevant prop (e.g. _centerOption/_zoom/_rect/_viewRect) changed.
   */ View.prototype._updateCenterAndZoom = function() {
        var centerOption = this._centerOption;
        var rect = this._rect;
        if (centerOption && rect) this._center = [
            (0, $iCU10.parsePercent)(centerOption[0], rect.width, rect.x),
            (0, $iCU10.parsePercent)(centerOption[1], rect.height, rect.y)
        ];
        // Must update after view transform updated
        var rawTransformMatrix = this._rawTransformable.getLocalTransform();
        var roamTransform = this._roamTransformable;
        var defaultCenter = this.getDefaultCenter();
        var center = this.getCenter();
        var zoom = this.getZoom();
        center = $U1aqY.applyTransform([], center, rawTransformMatrix);
        defaultCenter = $U1aqY.applyTransform([], defaultCenter, rawTransformMatrix);
        roamTransform.originX = center[0];
        roamTransform.originY = center[1];
        roamTransform.x = defaultCenter[0] - center[0];
        roamTransform.y = defaultCenter[1] - center[1];
        roamTransform.scaleX = roamTransform.scaleY = zoom;
        this._updateTransform();
    };
    /**
   * Update transform props on `this` based on the current
   * `this._roamTransformable` and `this._rawTransformable`.
   */ View.prototype._updateTransform = function() {
        var roamTransformable = this._roamTransformable;
        var rawTransformable = this._rawTransformable;
        rawTransformable.parent = roamTransformable;
        roamTransformable.updateTransform();
        rawTransformable.updateTransform();
        $19Ywy.copy(this.transform || (this.transform = []), rawTransformable.transform || $19Ywy.create());
        this._rawTransform = rawTransformable.getLocalTransform();
        this.invTransform = this.invTransform || [];
        $19Ywy.invert(this.invTransform, this.transform);
        this.decomposeTransform();
    };
    View.prototype.getTransformInfo = function() {
        var rawTransformable = this._rawTransformable;
        var roamTransformable = this._roamTransformable;
        // Because roamTransformabel has `originX/originY` modified,
        // but the caller of `getTransformInfo` can not handle `originX/originY`,
        // so need to recalculate them.
        var dummyTransformable = new (0, $erz95.default)();
        dummyTransformable.transform = roamTransformable.transform;
        dummyTransformable.decomposeTransform();
        return {
            roam: {
                x: dummyTransformable.x,
                y: dummyTransformable.y,
                scaleX: dummyTransformable.scaleX,
                scaleY: dummyTransformable.scaleY
            },
            raw: {
                x: rawTransformable.x,
                y: rawTransformable.y,
                scaleX: rawTransformable.scaleX,
                scaleY: rawTransformable.scaleY
            }
        };
    };
    View.prototype.getViewRect = function() {
        return this._viewRect;
    };
    /**
   * Get view rect after roam transform
   */ View.prototype.getViewRectAfterRoam = function() {
        var rect = this.getBoundingRect().clone();
        rect.applyTransform(this.transform);
        return rect;
    };
    /**
   * Convert a single (lon, lat) data item to (x, y) point.
   */ View.prototype.dataToPoint = function(data, noRoam, out) {
        var transform = noRoam ? this._rawTransform : this.transform;
        out = out || [];
        return transform ? $0bec81cde8e07dbd$var$v2ApplyTransform(out, data, transform) : $U1aqY.copy(out, data);
    };
    /**
   * Convert a (x, y) point to (lon, lat) data
   */ View.prototype.pointToData = function(point, reserved, out) {
        out = out || [];
        var invTransform = this.invTransform;
        return invTransform ? $0bec81cde8e07dbd$var$v2ApplyTransform(out, point, invTransform) : (out[0] = point[0], out[1] = point[1], out);
    };
    View.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $0bec81cde8e07dbd$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    View.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $0bec81cde8e07dbd$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    /**
   * @implements
   */ View.prototype.containPoint = function(point) {
        return this.getViewRectAfterRoam().contain(point[0], point[1]);
    };
    View.dimensions = [
        'x',
        'y'
    ];
    return View;
}((0, $erz95.default));
function $0bec81cde8e07dbd$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
}
var $0bec81cde8e07dbd$export$2e2bcd8739ae039 = $0bec81cde8e07dbd$var$View;

});
parcelRegister("kc4jZ", function(module, exports) {

$parcel$export(module.exports, "updateViewOnPan", function () { return $eb3847c830737dcc$export$1e6abcd98caba733; });
$parcel$export(module.exports, "updateViewOnZoom", function () { return $eb3847c830737dcc$export$29b3c66d30a4866; });
$parcel$export(module.exports, "clampByZoomLimit", function () { return $eb3847c830737dcc$export$8b6a36ab62a3dea0; });
$parcel$export(module.exports, "updateController", function () { return $eb3847c830737dcc$export$805408382b623838; });
$parcel$export(module.exports, "updateCenterAndZoomInAction", function () { return $eb3847c830737dcc$export$94d6a16eae2c4cf4; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("h9U3p");
var $67W72 = parcelRequire("67W72");
function $eb3847c830737dcc$export$1e6abcd98caba733(controllerHost, dx, dy) {
    var target = controllerHost.target;
    target.x += dx;
    target.y += dy;
    target.dirty();
}
function $eb3847c830737dcc$export$29b3c66d30a4866(controllerHost, zoomDelta, zoomX, zoomY) {
    var target = controllerHost.target;
    var zoomLimit = controllerHost.zoomLimit;
    var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
    newZoom *= zoomDelta;
    newZoom = $eb3847c830737dcc$export$8b6a36ab62a3dea0(newZoom, zoomLimit);
    var zoomScale = newZoom / controllerHost.zoom;
    controllerHost.zoom = newZoom;
    $eb3847c830737dcc$var$zoomTransformableByOrigin(target, zoomX, zoomY, zoomScale);
    target.dirty();
}
function $eb3847c830737dcc$export$805408382b623838(seriesModel, api, pointerCheckerEl, controller, controllerHost, clipRect) {
    var tmpRect = new (0, $67W72.default)(0, 0, 0, 0);
    controller.enable(seriesModel.get('roam'), {
        api: api,
        zInfo: {
            component: seriesModel
        },
        triggerInfo: {
            roamTrigger: seriesModel.get('roamTrigger'),
            isInSelf: function(e, x, y) {
                tmpRect.copy(pointerCheckerEl.getBoundingRect());
                tmpRect.applyTransform(pointerCheckerEl.getComputedTransform());
                return tmpRect.contain(x, y);
            },
            isInClip: function(e, x, y) {
                return !clipRect || clipRect.contain(x, y);
            }
        }
    });
    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
    var coordinate = seriesModel.coordinateSystem;
    controllerHost.zoom = coordinate ? coordinate.getZoom() : 1;
    var type = seriesModel.subType + 'Roam';
    controller.off('pan').off('zoom').on('pan', function(e) {
        $eb3847c830737dcc$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
        api.dispatchAction({
            seriesId: seriesModel.id,
            type: type,
            dx: e.dx,
            dy: e.dy
        });
    }).on('zoom', function(e) {
        /**
     * FIXME: should do nothing except `api.dispatchAction` here, the other logic
     *  should be performed in the action handler and `updateTransform`; otherwise,
     *  they are inconsistent if user triggers this action explicitly.
     */ $eb3847c830737dcc$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
        api.dispatchAction({
            seriesId: seriesModel.id,
            type: type,
            zoom: e.scale,
            originX: e.originX,
            originY: e.originY
        });
        // Only update label layout on zoom
        api.updateLabelLayout();
    });
}
function $eb3847c830737dcc$var$getCenterCoord(view, point) {
    // Use projected coord as center because it's linear.
    return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
}
function $eb3847c830737dcc$export$94d6a16eae2c4cf4(view, payload, zoomLimit) {
    var previousZoom = view.getZoom();
    var center = view.getCenter();
    var deltaZoom = payload.zoom;
    var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);
    if (payload.dx != null && payload.dy != null) {
        point[0] -= payload.dx;
        point[1] -= payload.dy;
        view.setCenter($eb3847c830737dcc$var$getCenterCoord(view, point));
    }
    if (deltaZoom != null) {
        deltaZoom = $eb3847c830737dcc$export$8b6a36ab62a3dea0(previousZoom * deltaZoom, zoomLimit) / previousZoom;
        $eb3847c830737dcc$var$zoomTransformableByOrigin(view, payload.originX, payload.originY, deltaZoom);
        view.updateTransform();
        // [NOTICE] Tricky: `getCetnerCoord` uses `this.invTransform` modified by the `updateTransform` above.
        view.setCenter($eb3847c830737dcc$var$getCenterCoord(view, point));
        view.setZoom(deltaZoom * previousZoom);
    }
    return {
        center: view.getCenter(),
        zoom: view.getZoom()
    };
}
function $eb3847c830737dcc$var$zoomTransformableByOrigin(target, originX, originY, deltaZoom) {
    // Keep the mouse center when scaling.
    target.x -= (originX - target.x) * (deltaZoom - 1);
    target.y -= (originY - target.y) * (deltaZoom - 1);
    target.scaleX *= deltaZoom;
    target.scaleY *= deltaZoom;
}
function $eb3847c830737dcc$export$8b6a36ab62a3dea0(zoom, zoomLimit) {
    if (zoomLimit) {
        var zoomMin = zoomLimit.min || 0;
        var zoomMax = zoomLimit.max || Infinity;
        zoom = Math.max(Math.min(zoomMax, zoom), zoomMin);
    }
    return zoom;
}

});



parcelRegister("4KTbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $376643e6086fdc0f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $ih3Ax = parcelRequire("ih3Ax");

var $3ru3e = parcelRequire("3ru3e");

var $ic6Qi = parcelRequire("ic6Qi");

var $kc4jZ = parcelRequire("kc4jZ");

var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $2OfXK = parcelRequire("2OfXK");

var $fijY1 = parcelRequire("fijY1");

var $cWIrM = parcelRequire("cWIrM");

var $6TSUP = parcelRequire("6TSUP");

var $3heFw = parcelRequire("3heFw");

var $dIsge = parcelRequire("dIsge");

var $2N6Uo = parcelRequire("2N6Uo");

var $gi6rJ = parcelRequire("gi6rJ");

var $YaX0v = parcelRequire("YaX0v");
function $376643e6086fdc0f$var$isViewCoordSys(coordSys) {
    return coordSys.type === 'view';
}
var $376643e6086fdc0f$var$GraphView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GraphView, _super);
    function GraphView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphView.type;
        return _this;
    }
    GraphView.prototype.init = function(ecModel, api) {
        var symbolDraw = new (0, $ih3Ax.default)();
        var lineDraw = new (0, $3ru3e.default)();
        var group = this.group;
        var mainGroup = new $iQonF.default();
        this._controller = new (0, $ic6Qi.default)(api.getZr());
        this._controllerHost = {
            target: mainGroup
        };
        mainGroup.add(symbolDraw.group);
        mainGroup.add(lineDraw.group);
        group.add(mainGroup);
        this._symbolDraw = symbolDraw;
        this._lineDraw = lineDraw;
        this._mainGroup = mainGroup;
        this._firstRender = true;
    };
    GraphView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        var isForceLayout = false;
        this._model = seriesModel;
        this._api = api;
        this._active = true;
        var thumbnailInfo = this._getThumbnailInfo();
        if (thumbnailInfo) thumbnailInfo.bridge.reset(api);
        var symbolDraw = this._symbolDraw;
        var lineDraw = this._lineDraw;
        if ($376643e6086fdc0f$var$isViewCoordSys(coordSys)) {
            var groupNewProp = {
                x: coordSys.x,
                y: coordSys.y,
                scaleX: coordSys.scaleX,
                scaleY: coordSys.scaleY
            };
            if (this._firstRender) this._mainGroup.attr(groupNewProp);
            else $ipprj.updateProps(this._mainGroup, groupNewProp, seriesModel);
        }
        // Fix edge contact point with node
        (0, $2OfXK.default)(seriesModel.getGraph(), (0, $fijY1.getNodeGlobalScale)(seriesModel));
        var data = seriesModel.getData();
        symbolDraw.updateData(data);
        var edgeData = seriesModel.getEdgeData();
        // TODO: TYPE
        lineDraw.updateData(edgeData);
        this._updateNodeAndLinkScale();
        this._updateController(null, seriesModel, api);
        clearTimeout(this._layoutTimeout);
        var forceLayout = seriesModel.forceLayout;
        var layoutAnimation = seriesModel.get([
            'force',
            'layoutAnimation'
        ]);
        if (forceLayout) {
            isForceLayout = true;
            this._startForceLayoutIteration(forceLayout, api, layoutAnimation);
        }
        var layout = seriesModel.get('layout');
        data.graph.eachNode(function(node) {
            var idx = node.dataIndex;
            var el = node.getGraphicEl();
            var itemModel = node.getModel();
            if (!el) return;
            // Update draggable
            el.off('drag').off('dragend');
            var draggable = itemModel.get('draggable');
            if (draggable) el.on('drag', function(e) {
                switch(layout){
                    case 'force':
                        forceLayout.warmUp();
                        !_this._layouting && _this._startForceLayoutIteration(forceLayout, api, layoutAnimation);
                        forceLayout.setFixed(idx);
                        // Write position back to layout
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        break;
                    case 'circular':
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // mark node fixed
                        node.setLayout({
                            fixed: true
                        }, true);
                        // recalculate circular layout
                        (0, $dIsge.circularLayout)(seriesModel, 'symbolSize', node, [
                            e.offsetX,
                            e.offsetY
                        ]);
                        _this.updateLayout(seriesModel);
                        break;
                    case 'none':
                    default:
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // update edge
                        (0, $3heFw.simpleLayoutEdge)(seriesModel.getGraph(), seriesModel);
                        _this.updateLayout(seriesModel);
                        break;
                }
            }).on('dragend', function() {
                if (forceLayout) forceLayout.setUnfixed(idx);
            });
            el.setDraggable(draggable, !!itemModel.get('cursor'));
            var focus = itemModel.get([
                'emphasis',
                'focus'
            ]);
            if (focus === 'adjacency') (0, $6TSUP.getECData)(el).focus = node.getAdjacentDataIndices();
        });
        data.graph.eachEdge(function(edge) {
            var el = edge.getGraphicEl();
            var focus = edge.getModel().get([
                'emphasis',
                'focus'
            ]);
            if (!el) return;
            if (focus === 'adjacency') (0, $6TSUP.getECData)(el).focus = {
                edge: [
                    edge.dataIndex
                ],
                node: [
                    edge.node1.dataIndex,
                    edge.node2.dataIndex
                ]
            };
        });
        var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get([
            'circular',
            'rotateLabel'
        ]);
        var cx = data.getLayout('cx');
        var cy = data.getLayout('cy');
        data.graph.eachNode(function(node) {
            (0, $dIsge.rotateNodeLabel)(node, circularRotateLabel, cx, cy);
        });
        this._firstRender = false;
        // Force layout will render thumbnail when layout is finished.
        if (!isForceLayout) this._renderThumbnail(seriesModel, api, this._symbolDraw, this._lineDraw);
    };
    GraphView.prototype.dispose = function() {
        this.remove();
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    GraphView.prototype._startForceLayoutIteration = function(forceLayout, api, layoutAnimation) {
        var self = this;
        var firstRendered = false;
        (function step() {
            forceLayout.step(function(stopped) {
                self.updateLayout(self._model);
                if (stopped || !firstRendered) {
                    firstRendered = true;
                    self._renderThumbnail(self._model, api, self._symbolDraw, self._lineDraw);
                }
                (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
            });
        })();
    };
    GraphView.prototype._updateController = function(clipRect, seriesModel, api) {
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var coordSys = seriesModel.coordinateSystem;
        if (!$376643e6086fdc0f$var$isViewCoordSys(coordSys)) {
            controller.disable();
            return;
        }
        controller.enable(seriesModel.get('roam'), {
            api: api,
            zInfo: {
                component: seriesModel
            },
            triggerInfo: {
                roamTrigger: seriesModel.get('roamTrigger'),
                isInSelf: function(e, x, y) {
                    return coordSys.containPoint([
                        x,
                        y
                    ]);
                },
                isInClip: function(e, x, y) {
                    return !clipRect || clipRect.contain(x, y);
                }
            }
        });
        controllerHost.zoomLimit = seriesModel.get('scaleLimit');
        controllerHost.zoom = coordSys.getZoom();
        controller.off('pan').off('zoom').on('pan', function(e) {
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'graphRoam',
                dx: e.dx,
                dy: e.dy
            });
        }).on('zoom', function(e) {
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'graphRoam',
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
        });
    };
    /**
   * A performance shortcut - called by action handler to update the view directly
   * without any data/visual processing (which are assumed to be unchanged), while
   * ensuring consistent behavior between internal and external action triggers.
   */ GraphView.prototype.updateViewOnPan = function(seriesModel, api, params) {
        if (!this._active) return;
        (0, $kc4jZ.updateViewOnPan)(this._controllerHost, params.dx, params.dy);
        this._updateThumbnailWindow();
    };
    /**
   * A performance shortcut - called by action handler to update the view directly
   * without any data/visual processing (which are assumed to be unchanged), while
   * ensuring consistent behavior between internal and external action triggers.
   */ GraphView.prototype.updateViewOnZoom = function(seriesModel, api, params) {
        if (!this._active) return;
        (0, $kc4jZ.updateViewOnZoom)(this._controllerHost, params.zoom, params.originX, params.originY);
        this._updateNodeAndLinkScale();
        (0, $2OfXK.default)(seriesModel.getGraph(), (0, $fijY1.getNodeGlobalScale)(seriesModel));
        this._lineDraw.updateLayout();
        // Only update label layout on zoom
        api.updateLabelLayout();
        this._updateThumbnailWindow();
    };
    GraphView.prototype._updateNodeAndLinkScale = function() {
        var seriesModel = this._model;
        var data = seriesModel.getData();
        var nodeScale = (0, $fijY1.getNodeGlobalScale)(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el && el.setSymbolScale(nodeScale);
        });
    };
    GraphView.prototype.updateLayout = function(seriesModel) {
        if (!this._active) return;
        (0, $2OfXK.default)(seriesModel.getGraph(), (0, $fijY1.getNodeGlobalScale)(seriesModel));
        this._symbolDraw.updateLayout();
        this._lineDraw.updateLayout();
    };
    GraphView.prototype.remove = function() {
        this._active = false;
        clearTimeout(this._layoutTimeout);
        this._layouting = false;
        this._layoutTimeout = null;
        this._symbolDraw && this._symbolDraw.remove();
        this._lineDraw && this._lineDraw.remove();
        this._controller && this._controller.disable();
    };
    /**
   * Get thumbnail data structure only if supported.
   */ GraphView.prototype._getThumbnailInfo = function() {
        var model = this._model;
        var coordSys = model.coordinateSystem;
        if (coordSys.type !== 'view') return;
        var bridge = (0, $YaX0v.getThumbnailBridge)(model);
        if (!bridge) return;
        return {
            bridge: bridge,
            coordSys: coordSys
        };
    };
    GraphView.prototype._updateThumbnailWindow = function() {
        var info = this._getThumbnailInfo();
        if (info) info.bridge.updateWindow(info.coordSys.transform, this._api);
    };
    GraphView.prototype._renderThumbnail = function(seriesModel, api, symbolDraw, lineDraw) {
        var info = this._getThumbnailInfo();
        if (!info) return;
        var bridgeGroup = new $iQonF.default();
        var symbolNodes = symbolDraw.group.children();
        var lineNodes = lineDraw.group.children();
        var lineGroup = new $iQonF.default();
        var symbolGroup = new $iQonF.default();
        bridgeGroup.add(symbolGroup);
        bridgeGroup.add(lineGroup);
        // TODO: reuse elemenents for performance in large graph?
        for(var i = 0; i < symbolNodes.length; i++){
            var node = symbolNodes[i];
            var sub = node.children()[0];
            var x = node.x;
            var y = node.y;
            var subShape = (0, $2N6Uo.clone)(sub.shape);
            var shape = (0, $2N6Uo.extend)(subShape, {
                width: sub.scaleX,
                height: sub.scaleY,
                x: x - sub.scaleX / 2,
                y: y - sub.scaleY / 2
            });
            var style = (0, $2N6Uo.clone)(sub.style);
            var subThumbnail = new sub.constructor({
                shape: shape,
                style: style,
                z2: 151
            });
            symbolGroup.add(subThumbnail);
        }
        for(var i = 0; i < lineNodes.length; i++){
            var node = lineNodes[i];
            var line = node.children()[0];
            var style = (0, $2N6Uo.clone)(line.style);
            var shape = (0, $2N6Uo.clone)(line.shape);
            var lineThumbnail = new (0, $gi6rJ.default)({
                style: style,
                shape: shape,
                z2: 151
            });
            lineGroup.add(lineThumbnail);
        }
        info.bridge.renderContent({
            api: api,
            roamType: seriesModel.get('roam'),
            viewportRect: null,
            group: bridgeGroup,
            targetTrans: info.coordSys.transform
        });
    };
    GraphView.type = 'graph';
    return GraphView;
}((0, $cWIrM.default));
var $376643e6086fdc0f$export$2e2bcd8739ae039 = $376643e6086fdc0f$var$GraphView;

});
parcelRegister("3ru3e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $281b343c55bf5a58$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iQonF = parcelRequire("iQonF");
var $h9U3p = parcelRequire("h9U3p");

var $Y6qOy = parcelRequire("Y6qOy");

var $bysmE = parcelRequire("bysmE");
var $281b343c55bf5a58$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $iQonF.default();
        this._LineCtor = LineCtor || (0, $Y6qOy.default);
    }
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        // Remove progressive els.
        this._progressiveEls = null;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData;
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $281b343c55bf5a58$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData;
        // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $281b343c55bf5a58$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        this._progressiveEls = [];
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$281b343c55bf5a58$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($281b343c55bf5a58$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype.eachRendered = function(cb) {
        $h9U3p.traverseElements(this._progressiveEls || this.group, cb);
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$281b343c55bf5a58$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$281b343c55bf5a58$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $281b343c55bf5a58$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $281b343c55bf5a58$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    var emphasisModel = hostModel.getModel('emphasis');
    return {
        lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
        emphasisLineStyle: emphasisModel.getModel([
            'lineStyle'
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            'blur',
            'lineStyle'
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            'select',
            'lineStyle'
        ]).getLineStyle(),
        emphasisDisabled: emphasisModel.get('disabled'),
        blurScope: emphasisModel.get('blurScope'),
        focus: emphasisModel.get('focus'),
        labelStatesModels: (0, $bysmE.getLabelStatesModels)(hostModel)
    };
}
function $281b343c55bf5a58$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $281b343c55bf5a58$var$lineNeedsDraw(pts) {
    return pts && !$281b343c55bf5a58$var$isPointNaN(pts[0]) && !$281b343c55bf5a58$var$isPointNaN(pts[1]);
}
var $281b343c55bf5a58$export$2e2bcd8739ae039 = $281b343c55bf5a58$var$LineDraw;

});
parcelRegister("Y6qOy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b4a97df210404a5$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $U1aqY = parcelRequire("U1aqY");

var $k0QDS = parcelRequire("k0QDS");

var $gi6rJ = parcelRequire("gi6rJ");

var $iQonF = parcelRequire("iQonF");
var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");

var $iCU10 = parcelRequire("iCU10");

var $6aXXD = parcelRequire("6aXXD");
var $0b4a97df210404a5$var$SYMBOL_CATEGORIES = [
    'fromSymbol',
    'toSymbol'
];
function $0b4a97df210404a5$var$makeSymbolTypeKey(symbolCategory) {
    return '_' + symbolCategory + 'Type';
}
function $0b4a97df210404a5$var$makeSymbolTypeValue(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return symbolType;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $k0QDS.normalizeSymbolSize(symbolSize);
    var symbolOffsetArr = $k0QDS.normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
    return symbolType + symbolSizeArr + symbolOffsetArr + (symbolRotate || '') + (symbolKeepAspect || '');
}
/**
 * @inner
 */ function $0b4a97df210404a5$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $k0QDS.normalizeSymbolSize(symbolSize);
    var symbolOffsetArr = $k0QDS.normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $k0QDS.createSymbol(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $0b4a97df210404a5$var$createLine(points) {
    var line = new (0, $gi6rJ.default)({
        name: 'line',
        subPixelOptimize: true
    });
    $0b4a97df210404a5$var$setLinePoints(line.shape, points);
    return line;
}
function $0b4a97df210404a5$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $0b4a97df210404a5$var$Line = /** @class */ function(_super) {
    (0, $9nEce.__extends)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var z2 = lineData.getItemVisual(idx, 'z2');
        var line = $0b4a97df210404a5$var$createLine(linePoints);
        line.shape.percent = 0;
        $ipprj.initProps(line, {
            z2: (0, $2N6Uo.retrieve2)(z2, 0),
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $2N6Uo.each)($0b4a97df210404a5$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $0b4a97df210404a5$var$createSymbol(symbolCategory, lineData, idx);
            // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$0b4a97df210404a5$var$makeSymbolTypeKey(symbolCategory)] = $0b4a97df210404a5$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $0b4a97df210404a5$var$setLinePoints(target.shape, linePoints);
        $ipprj.updateProps(line, target, seriesModel, idx);
        (0, $2N6Uo.each)($0b4a97df210404a5$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = $0b4a97df210404a5$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
            var key = $0b4a97df210404a5$var$makeSymbolTypeKey(symbolCategory);
            // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $0b4a97df210404a5$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
            blurLineStyle = itemModel.getModel([
                'blur',
                'lineStyle'
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                'select',
                'lineStyle'
            ]).getLineStyle();
            emphasisDisabled = emphasisModel.get('disabled');
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            labelStatesModels = (0, $bysmE.getLabelStatesModels)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState('emphasis').style = emphasisLineStyle;
        line.ensureState('blur').style = blurLineStyle;
        line.ensureState('select').style = selectLineStyle;
        // Update symbol
        (0, $2N6Uo.each)($0b4a97df210404a5$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $bwPbQ.SPECIAL_STATES).length; i++){
                    var stateName = (0, $bwPbQ.SPECIAL_STATES)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $bysmE.setLabelStyle)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || (0, $6aXXD.default).color.neutral99,
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $iCU10.round)(rawVal) : rawVal) + ''
        });
        var label = this.getTextContent();
        // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign;
            // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get('position') || 'middle';
            var distance = labelNormalModel.get('distance');
            if (!(0, $2N6Uo.isArray)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $bwPbQ.toggleHoverEmphasis)(this, focus, blurScope, emphasisDisabled);
    };
    Line.prototype.highlight = function() {
        (0, $bwPbQ.enterEmphasis)(this);
    };
    Line.prototype.downplay = function() {
        (0, $bwPbQ.leaveEmphasis)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName('line');
        $0b4a97df210404a5$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName('fromSymbol');
        var symbolTo = lineGroup.childOfName('toSymbol');
        var label = lineGroup.getTextContent();
        // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName('line');
        // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $U1aqY.sub([], toPos, fromPos);
        $U1aqY.normalize(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr('rotation', specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== 'start' && label.__position !== 'end') {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case 'insideStartTop':
                case 'insideMiddleTop':
                case 'insideEndTop':
                case 'middle':
                    dy = -distanceY;
                    textVerticalAlign = 'bottom';
                    break;
                case 'insideStartBottom':
                case 'insideMiddleBottom':
                case 'insideEndBottom':
                    dy = distanceY;
                    textVerticalAlign = 'top';
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = 'middle';
            }
            switch(label.__position){
                case 'end':
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
                    break;
                case 'start':
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
                    break;
                case 'insideStartTop':
                case 'insideStart':
                case 'insideStartBottom':
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? 'right' : 'left';
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case 'insideMiddleTop':
                case 'insideMiddle':
                case 'insideMiddleBottom':
                case 'middle':
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = 'center';
                    label.originY = -dy;
                    break;
                case 'insideEndTop':
                case 'insideEnd':
                case 'insideEndBottom':
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? 'right' : 'left';
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($iQonF.default);
var $0b4a97df210404a5$export$2e2bcd8739ae039 = $0b4a97df210404a5$var$Line;

});
parcelRegister("gi6rJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc353e523a7c3be$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");
parcelRequire("h9U3p");
var $1y8oO = parcelRequire("1y8oO");
var $c3CaY = parcelRequire("c3CaY");
var $4oDJM = parcelRequire("4oDJM");

var $U1aqY = parcelRequire("U1aqY");

var $6aXXD = parcelRequire("6aXXD");
var $bdc353e523a7c3be$var$straightLineProto = $c3CaY.default.prototype;
var $bdc353e523a7c3be$var$bezierCurveProto = $1y8oO.default.prototype;
var $bdc353e523a7c3be$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0;
        // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $bdc353e523a7c3be$var$CurveShape = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($bdc353e523a7c3be$var$StraightLineShape);
function $bdc353e523a7c3be$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $bdc353e523a7c3be$var$ECLinePath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-line';
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $6aXXD.default).color.neutral99,
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $bdc353e523a7c3be$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($bdc353e523a7c3be$var$isStraightLine(shape)) $bdc353e523a7c3be$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $bdc353e523a7c3be$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($bdc353e523a7c3be$var$isStraightLine(this.shape)) return $bdc353e523a7c3be$var$straightLineProto.pointAt.call(this, t);
        else return $bdc353e523a7c3be$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $bdc353e523a7c3be$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $bdc353e523a7c3be$var$bezierCurveProto.tangentAt.call(this, t);
        return $U1aqY.normalize(p, p);
    };
    return ECLinePath;
}($4oDJM.default);
var $bdc353e523a7c3be$export$2e2bcd8739ae039 = $bdc353e523a7c3be$var$ECLinePath;

});



parcelRegister("ic6Qi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3eea7be4db4d62b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $5Uet9 = parcelRequire("5Uet9");

var $pGNPI = parcelRequire("pGNPI");

var $ast3M = parcelRequire("ast3M");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $h9U3p = parcelRequire("h9U3p");

var $7vl3X = parcelRequire("7vl3X");
/**
 * An manager of zoom and pan(darg) hehavior.
 * But it is not responsible for updating the view, since view updates vary and can
 * not be handled in a uniform way.
 *
 * Note: regarding view updates:
 *  - Transformabe views typically use `coord/View` (e.g., geo and series.graph roaming).
 *    Some commonly used view update logic has been organized into `roamHelper.ts`.
 *  - Non-transformable views handle updates themselves, possibly involving re-layout,
 *    (e.g., treemap).
 *  - Some scenarios do not require transformation (e.g., dataZoom roaming for cartesian,
 *    brush component).
 */ var $d3eea7be4db4d62b$var$RoamController = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RoamController, _super);
    function RoamController(zr) {
        var _this = _super.call(this) || this;
        _this._zr = zr;
        // Avoid two roamController bind the same handler
        var mousedownHandler = (0, $2N6Uo.bind)(_this._mousedownHandler, _this);
        var mousemoveHandler = (0, $2N6Uo.bind)(_this._mousemoveHandler, _this);
        var mouseupHandler = (0, $2N6Uo.bind)(_this._mouseupHandler, _this);
        var mousewheelHandler = (0, $2N6Uo.bind)(_this._mousewheelHandler, _this);
        var pinchHandler = (0, $2N6Uo.bind)(_this._pinchHandler, _this);
        /**
     * Notice:
     *  - only enable needed types. For example, if 'zoom'
     *    is not needed, 'zoom' should not be enabled, otherwise
     *    default mousewheel behaviour (scroll page) will be disabled.
     *  - This method is idempotent.
     */ _this.enable = function(controlType, rawOpt) {
            var zInfo = rawOpt.zInfo;
            var _a = (0, $h9U3p.retrieveZInfo)(zInfo.component), z = _a.z, zlevel = _a.zlevel;
            var zInfoParsed = {
                component: zInfo.component,
                z: z,
                zlevel: zlevel,
                // By default roam controller is the lowest z2 comparing to other elememts in a component.
                z2: (0, $2N6Uo.retrieve2)(zInfo.z2, -Infinity)
            };
            var triggerInfo = (0, $2N6Uo.extend)({}, rawOpt.triggerInfo);
            this._opt = (0, $2N6Uo.defaults)((0, $2N6Uo.extend)({}, rawOpt), {
                zoomOnMouseWheel: true,
                moveOnMouseMove: true,
                // By default, wheel do not trigger move.
                moveOnMouseWheel: false,
                preventDefaultMouseMove: true,
                zInfoParsed: zInfoParsed,
                triggerInfo: triggerInfo
            });
            if (controlType == null) controlType = true;
            // A handy optimization for repeatedly calling `enable` during roaming.
            // Assert `disable` is only affected by `controlType`.
            if (!this._enabled || this._controlType !== controlType) {
                this._enabled = true;
                // Disable previous first
                this.disable();
                if (controlType === true || controlType === 'move' || controlType === 'pan') {
                    $d3eea7be4db4d62b$var$addRoamZrListener(zr, 'mousedown', mousedownHandler, zInfoParsed);
                    $d3eea7be4db4d62b$var$addRoamZrListener(zr, 'mousemove', mousemoveHandler, zInfoParsed);
                    $d3eea7be4db4d62b$var$addRoamZrListener(zr, 'mouseup', mouseupHandler, zInfoParsed);
                }
                if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
                    $d3eea7be4db4d62b$var$addRoamZrListener(zr, 'mousewheel', mousewheelHandler, zInfoParsed);
                    $d3eea7be4db4d62b$var$addRoamZrListener(zr, 'pinch', pinchHandler, zInfoParsed);
                }
            }
        };
        _this.disable = function() {
            this._enabled = false;
            $d3eea7be4db4d62b$var$removeRoamZrListener(zr, 'mousedown', mousedownHandler);
            $d3eea7be4db4d62b$var$removeRoamZrListener(zr, 'mousemove', mousemoveHandler);
            $d3eea7be4db4d62b$var$removeRoamZrListener(zr, 'mouseup', mouseupHandler);
            $d3eea7be4db4d62b$var$removeRoamZrListener(zr, 'mousewheel', mousewheelHandler);
            $d3eea7be4db4d62b$var$removeRoamZrListener(zr, 'pinch', pinchHandler);
        };
        return _this;
    }
    RoamController.prototype.isDragging = function() {
        return this._dragging;
    };
    RoamController.prototype.isPinching = function() {
        return this._pinching;
    };
    RoamController.prototype._checkPointer = function(e, x, y) {
        var opt = this._opt;
        var zInfoParsed = opt.zInfoParsed;
        if ((0, $7vl3X.onIrrelevantElement)(e, opt.api, zInfoParsed.component)) return false;
        var triggerInfo = opt.triggerInfo;
        var roamTrigger = triggerInfo.roamTrigger;
        var inArea = false;
        if (roamTrigger === 'global') inArea = true;
        if (!inArea) inArea = triggerInfo.isInSelf(e, x, y);
        if (inArea && triggerInfo.isInClip && !triggerInfo.isInClip(e, x, y)) inArea = false;
        return inArea;
    };
    RoamController.prototype._decideCursorStyle = function(e, x, y, forReverse) {
        // If this cursor style decision is not strictly consistent with zrender,
        // it's fine - zr will set the cursor on the next mousemove.
        // This `grab` cursor style should take the lowest precedence. If the hovring element already
        // have a cursor, zrender will set it to be non-'default' before entering this handler.
        // (note, e.target is never silent, e.topTarget can be silent be irrelevant.)
        var target = e.target;
        if (!target && this._checkPointer(e, x, y)) // To indicate users that this area is draggable, otherwise users probably cannot kwown
        // that when hovering out of the shape but still inside the bounding rect.
        return 'grab';
        if (forReverse) return target && target.cursor || 'default';
    };
    RoamController.prototype.dispose = function() {
        this.disable();
    };
    RoamController.prototype._mousedownHandler = function(e) {
        if ($pGNPI.isMiddleOrRightButtonOnMouseUpDown(e) || $d3eea7be4db4d62b$var$eventConsumed(e)) return;
        var el = e.target;
        while(el){
            if (el.draggable) return;
            // check if host is draggable
            el = el.__hostTarget || el.parent;
        }
        var x = e.offsetX;
        var y = e.offsetY;
        // To determine dragging start, only by checking on mosedown, but not mousemove.
        // Mouse can be out of target when mouse moving.
        if (this._checkPointer(e, x, y)) {
            this._x = x;
            this._y = y;
            this._dragging = true;
        }
    };
    RoamController.prototype._mousemoveHandler = function(e) {
        var zr = this._zr;
        if (e.gestureEvent === 'pinch' || $ast3M.isTaken(zr, 'globalPan') || $d3eea7be4db4d62b$var$eventConsumed(e)) return;
        var x = e.offsetX;
        var y = e.offsetY;
        if (!this._dragging || !$d3eea7be4db4d62b$var$isAvailableBehavior('moveOnMouseMove', e, this._opt)) {
            var cursorStyle = this._decideCursorStyle(e, x, y, false);
            if (cursorStyle) zr.setCursorStyle(cursorStyle);
            return;
        }
        zr.setCursorStyle('grabbing');
        var oldX = this._x;
        var oldY = this._y;
        var dx = x - oldX;
        var dy = y - oldY;
        this._x = x;
        this._y = y;
        if (this._opt.preventDefaultMouseMove) $pGNPI.stop(e.event);
        e.__ecRoamConsumed = true;
        $d3eea7be4db4d62b$var$trigger(this, 'pan', 'moveOnMouseMove', e, {
            dx: dx,
            dy: dy,
            oldX: oldX,
            oldY: oldY,
            newX: x,
            newY: y,
            isAvailableBehavior: null
        });
    };
    RoamController.prototype._mouseupHandler = function(e) {
        if ($d3eea7be4db4d62b$var$eventConsumed(e)) return;
        var zr = this._zr;
        if (!$pGNPI.isMiddleOrRightButtonOnMouseUpDown(e)) {
            this._dragging = false;
            var cursorStyle = this._decideCursorStyle(e, e.offsetX, e.offsetY, true);
            if (cursorStyle) zr.setCursorStyle(cursorStyle);
        }
    };
    RoamController.prototype._mousewheelHandler = function(e) {
        if ($d3eea7be4db4d62b$var$eventConsumed(e)) return;
        var shouldZoom = $d3eea7be4db4d62b$var$isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
        var shouldMove = $d3eea7be4db4d62b$var$isAvailableBehavior('moveOnMouseWheel', e, this._opt);
        var wheelDelta = e.wheelDelta;
        var absWheelDeltaDelta = Math.abs(wheelDelta);
        var originX = e.offsetX;
        var originY = e.offsetY;
        // wheelDelta maybe -0 in chrome mac.
        if (wheelDelta === 0 || !shouldZoom && !shouldMove) return;
        // If both `shouldZoom` and `shouldMove` is true, trigger
        // their event both, and the final behavior is determined
        // by event listener themselves.
        if (shouldZoom) {
            // Convenience:
            // Mac and VM Windows on Mac: scroll up: zoom out.
            // Windows: scroll up: zoom in.
            // FIXME: Should do more test in different environment.
            // wheelDelta is too complicated in difference nvironment
            // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
            // although it has been normallized by zrender.
            // wheelDelta of mouse wheel is bigger than touch pad.
            var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
            var scale = wheelDelta > 0 ? factor : 1 / factor;
            this._checkTriggerMoveZoom(this, 'zoom', 'zoomOnMouseWheel', e, {
                scale: scale,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
        if (shouldMove) {
            // FIXME: Should do more test in different environment.
            var absDelta = Math.abs(wheelDelta);
            // wheelDelta of mouse wheel is bigger than touch pad.
            var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
            this._checkTriggerMoveZoom(this, 'scrollMove', 'moveOnMouseWheel', e, {
                scrollDelta: scrollDelta,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
    };
    RoamController.prototype._pinchHandler = function(e) {
        if ($ast3M.isTaken(this._zr, 'globalPan') || $d3eea7be4db4d62b$var$eventConsumed(e)) return;
        var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
        this._checkTriggerMoveZoom(this, 'zoom', null, e, {
            scale: scale,
            originX: e.pinchX,
            originY: e.pinchY,
            isAvailableBehavior: null
        });
    };
    RoamController.prototype._checkTriggerMoveZoom = function(controller, eventName, behaviorToCheck, e, contollerEvent) {
        if (controller._checkPointer(e, contollerEvent.originX, contollerEvent.originY)) {
            // When mouse is out of roamController rect,
            // default befavoius should not be be disabled, otherwise
            // page sliding is disabled, contrary to expectation.
            $pGNPI.stop(e.event);
            e.__ecRoamConsumed = true;
            $d3eea7be4db4d62b$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
        }
    };
    return RoamController;
}((0, $5Uet9.default));
function $d3eea7be4db4d62b$var$eventConsumed(e) {
    return e.__ecRoamConsumed;
}
var $d3eea7be4db4d62b$var$innerZrStore = (0, $bx3T8.makeInner)();
function $d3eea7be4db4d62b$var$ensureZrStore(zr) {
    var store = $d3eea7be4db4d62b$var$innerZrStore(zr);
    store.roam = store.roam || {};
    store.uniform = store.uniform || {};
    return store;
}
/**
 * Listeners are sorted by z2/z/zlevel in descending order.
 * This decides the precedence between different roam controllers if they are overlapped.
 *
 * [MEMO]: It's not easy to perfectly reconcile the conflicts caused by overlap.
 *  - Consider cases:
 *    - Multiple roam controllers overlapped.
 *      - Usually only the topmost can trigger roam.
 *    - Roam controllers overlap with other zr elements:
 *      - zr elements are relevant or irrelevent to the host of the roam controller. e.g., axis split line
 *        or series elements is relevant to a cartesian and should trigger roam.
 *      - zr elements is above or below the roam controller host, which affects the precedence of interaction.
 *      - zr elements may not silent only for triggering tooltip by hovering, which is available to roam;
 *        or may not silent for click, where roam is not preferable.
 *  - Approach - `addRoamZrListener+pointerChecker+onIrrelevantElement` (currently used):
 *    - Resolve the precedence between different roam controllers
 *    - But cannot prevent the handling on other zr elements that under the roam controller in z-order.
 *  - Approach - "use an invisible zr elements to receive the zr events to trigger roam":
 *    - More complicated in impl.
 *    - May cause bad cases where zr event cannot be receive due to other non-silient zr elements covering it.
 */ function $d3eea7be4db4d62b$var$addRoamZrListener(zr, eventType, listener, zInfoParsed) {
    var store = $d3eea7be4db4d62b$var$ensureZrStore(zr);
    var roam = store.roam;
    var listenerList = roam[eventType] = roam[eventType] || [];
    var idx = 0;
    for(; idx < listenerList.length; idx++){
        var currZInfo = listenerList[idx].zInfoParsed;
        if ((currZInfo.zlevel - zInfoParsed.zlevel || currZInfo.z - zInfoParsed.z || currZInfo.z2 - zInfoParsed.z2) <= 0) break;
    }
    listenerList.splice(idx, 0, {
        listener: listener,
        zInfoParsed: zInfoParsed
    });
    $d3eea7be4db4d62b$var$ensureUniformListener(zr, eventType);
}
function $d3eea7be4db4d62b$var$removeRoamZrListener(zr, eventType, listener) {
    var store = $d3eea7be4db4d62b$var$ensureZrStore(zr);
    var listenerList = store.roam[eventType] || [];
    for(var idx = 0; idx < listenerList.length; idx++)if (listenerList[idx].listener === listener) {
        listenerList.splice(idx, 1);
        if (!listenerList.length) $d3eea7be4db4d62b$var$removeUniformListener(zr, eventType);
        return;
    }
}
function $d3eea7be4db4d62b$var$ensureUniformListener(zr, eventType) {
    var store = $d3eea7be4db4d62b$var$ensureZrStore(zr);
    if (!store.uniform[eventType]) zr.on(eventType, store.uniform[eventType] = function(event) {
        var listenerList = store.roam[eventType];
        if (listenerList) for(var i = 0; i < listenerList.length; i++)listenerList[i].listener(event);
    });
}
function $d3eea7be4db4d62b$var$removeUniformListener(zr, eventType) {
    var store = $d3eea7be4db4d62b$var$ensureZrStore(zr);
    var uniform = store.uniform;
    if (uniform[eventType]) {
        zr.off(eventType, uniform[eventType]);
        uniform[eventType] = null;
    }
}
function $d3eea7be4db4d62b$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    // Also provide behavior checker for event listener, for some case that
    // multiple components share one listener.
    contollerEvent.isAvailableBehavior = (0, $2N6Uo.bind)($d3eea7be4db4d62b$var$isAvailableBehavior, null, behaviorToCheck, e);
    // TODO should not have type issue.
    controller.trigger(eventName, contollerEvent);
}
// settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
function $d3eea7be4db4d62b$var$isAvailableBehavior(behaviorToCheck, e, settings) {
    var setting = settings[behaviorToCheck];
    return !behaviorToCheck || setting && (!(0, $2N6Uo.isString)(setting) || e.event[setting + 'Key']);
}
var $d3eea7be4db4d62b$export$2e2bcd8739ae039 = $d3eea7be4db4d62b$var$RoamController;

});
parcelRegister("ast3M", function(module, exports) {

$parcel$export(module.exports, "take", function () { return $79d30fa1b8af4488$export$b7df5d561049483a; });
$parcel$export(module.exports, "release", function () { return $79d30fa1b8af4488$export$23d3fad09dc44362; });
$parcel$export(module.exports, "isTaken", function () { return $79d30fa1b8af4488$export$5623cba512bc9470; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N0NF = parcelRequire("2N0NF");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");
var $79d30fa1b8af4488$var$inner = (0, $bx3T8.makeInner)();
function $79d30fa1b8af4488$export$b7df5d561049483a(zr, resourceKey, userKey) {
    $79d30fa1b8af4488$var$inner(zr)[resourceKey] = userKey;
}
function $79d30fa1b8af4488$export$23d3fad09dc44362(zr, resourceKey, userKey) {
    var store = $79d30fa1b8af4488$var$inner(zr);
    var uKey = store[resourceKey];
    if (uKey === userKey) store[resourceKey] = null;
}
function $79d30fa1b8af4488$export$5623cba512bc9470(zr, resourceKey) {
    return !!$79d30fa1b8af4488$var$inner(zr)[resourceKey];
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */ // TODO: SELF REGISTERED.
$2N0NF.registerAction({
    type: 'takeGlobalCursor',
    event: 'globalCursorTaken',
    update: 'update'
}, (0, $2N6Uo.noop));

});

parcelRegister("7vl3X", function(module, exports) {

$parcel$export(module.exports, "onIrrelevantElement", function () { return $576bc44e9d44def8$export$8a33eacb690eac07; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $h9U3p = parcelRequire("h9U3p");
var $576bc44e9d44def8$var$IRRELEVANT_EXCLUDES = {
    'axisPointer': 1,
    'tooltip': 1,
    'brush': 1
};
function $576bc44e9d44def8$export$8a33eacb690eac07(e, api, targetComponent) {
    var eventElComponent = api.getComponentByElement(e.topTarget);
    if (!eventElComponent || eventElComponent === targetComponent || $576bc44e9d44def8$var$IRRELEVANT_EXCLUDES.hasOwnProperty(eventElComponent.mainType)) return false;
    // At present the `true` return is conservative. That is, the caller, such as a RoamController,
    // is more likely to get a `false` return and start a roam behavior, becuase even if the
    // `model.coordinateSystem` does not exist, the `e.topTarget` may be also a relevant element,
    // such as axis split line/area or series elements, where roam should be available. Otherwise,
    // if a dataZoom-served cartesian is full of series elements, the dataZoom-roaming can hardly
    // be triggered.
    var eventElCoordSys = eventElComponent.coordinateSystem;
    // If eventElComponent is axisModel, it works only if it is injected with coordinateSystem.
    if (!eventElCoordSys || eventElCoordSys.model === targetComponent) return false;
    // e.g., if a cartesian is covered by a graph, the graph has a higher presedence in roam.
    // A potential bad case is that RoamController does not prevent the cartesian from handling zr
    // event, such as click and hovering, but it's fine so far.
    // Aslo be conservative, if equals, return false.
    var eventElCmptZInfo = (0, $h9U3p.retrieveZInfo)(eventElComponent);
    var targetCmptZInfo = (0, $h9U3p.retrieveZInfo)(targetComponent);
    if ((eventElCmptZInfo.zlevel - targetCmptZInfo.zlevel || eventElCmptZInfo.z - targetCmptZInfo.z) <= 0) return false;
    return true;
}

});


parcelRegister("2OfXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20bca21e5a80c023$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1kxDI = parcelRequire("1kxDI");

var $U1aqY = parcelRequire("U1aqY");

var $fijY1 = parcelRequire("fijY1");
var $20bca21e5a80c023$var$v1 = [];
var $20bca21e5a80c023$var$v2 = [];
var $20bca21e5a80c023$var$v3 = [];
var $20bca21e5a80c023$var$quadraticAt = $1kxDI.quadraticAt;
var $20bca21e5a80c023$var$v2DistSquare = $U1aqY.distSquare;
var $20bca21e5a80c023$var$mathAbs = Math.abs;
function $20bca21e5a80c023$var$intersectCurveCircle(curvePoints, center, radius) {
    var p0 = curvePoints[0];
    var p1 = curvePoints[1];
    var p2 = curvePoints[2];
    var d = Infinity;
    var t;
    var radiusSquare = radius * radius;
    var interval = 0.1;
    for(var _t = 0.1; _t <= 0.9; _t += 0.1){
        $20bca21e5a80c023$var$v1[0] = $20bca21e5a80c023$var$quadraticAt(p0[0], p1[0], p2[0], _t);
        $20bca21e5a80c023$var$v1[1] = $20bca21e5a80c023$var$quadraticAt(p0[1], p1[1], p2[1], _t);
        var diff = $20bca21e5a80c023$var$mathAbs($20bca21e5a80c023$var$v2DistSquare($20bca21e5a80c023$var$v1, center) - radiusSquare);
        if (diff < d) {
            d = diff;
            t = _t;
        }
    }
    // Assume the segment is monotone，Find root through Bisection method
    // At most 32 iteration
    for(var i = 0; i < 32; i++){
        // let prev = t - interval;
        var next = t + interval;
        // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
        // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
        $20bca21e5a80c023$var$v2[0] = $20bca21e5a80c023$var$quadraticAt(p0[0], p1[0], p2[0], t);
        $20bca21e5a80c023$var$v2[1] = $20bca21e5a80c023$var$quadraticAt(p0[1], p1[1], p2[1], t);
        $20bca21e5a80c023$var$v3[0] = $20bca21e5a80c023$var$quadraticAt(p0[0], p1[0], p2[0], next);
        $20bca21e5a80c023$var$v3[1] = $20bca21e5a80c023$var$quadraticAt(p0[1], p1[1], p2[1], next);
        var diff = $20bca21e5a80c023$var$v2DistSquare($20bca21e5a80c023$var$v2, center) - radiusSquare;
        if ($20bca21e5a80c023$var$mathAbs(diff) < 1e-2) break;
        // let prevDiff = v2DistSquare(v1, center) - radiusSquare;
        var nextDiff = $20bca21e5a80c023$var$v2DistSquare($20bca21e5a80c023$var$v3, center) - radiusSquare;
        interval /= 2;
        if (diff < 0) {
            if (nextDiff >= 0) t = t + interval;
            else t = t - interval;
        } else if (nextDiff >= 0) t = t - interval;
        else t = t + interval;
    }
    return t;
}
function $20bca21e5a80c023$export$2e2bcd8739ae039(graph, scale) {
    var tmp0 = [];
    var quadraticSubdivide = $1kxDI.quadraticSubdivide;
    var pts = [
        [],
        [],
        []
    ];
    var pts2 = [
        [],
        []
    ];
    var v = [];
    scale /= 2;
    graph.eachEdge(function(edge, idx) {
        var linePoints = edge.getLayout();
        var fromSymbol = edge.getVisual('fromSymbol');
        var toSymbol = edge.getVisual('toSymbol');
        if (!linePoints.__original) {
            linePoints.__original = [
                $U1aqY.clone(linePoints[0]),
                $U1aqY.clone(linePoints[1])
            ];
            if (linePoints[2]) linePoints.__original.push($U1aqY.clone(linePoints[2]));
        }
        var originalPoints = linePoints.__original;
        // Quadratic curve
        if (linePoints[2] != null) {
            $U1aqY.copy(pts[0], originalPoints[0]);
            $U1aqY.copy(pts[1], originalPoints[2]);
            $U1aqY.copy(pts[2], originalPoints[1]);
            if (fromSymbol && fromSymbol !== 'none') {
                var symbolSize = (0, $fijY1.getSymbolSize)(edge.node1);
                var t = $20bca21e5a80c023$var$intersectCurveCircle(pts, originalPoints[0], symbolSize * scale);
                // Subdivide and get the second
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[0][0] = tmp0[3];
                pts[1][0] = tmp0[4];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[0][1] = tmp0[3];
                pts[1][1] = tmp0[4];
            }
            if (toSymbol && toSymbol !== 'none') {
                var symbolSize = (0, $fijY1.getSymbolSize)(edge.node2);
                var t = $20bca21e5a80c023$var$intersectCurveCircle(pts, originalPoints[1], symbolSize * scale);
                // Subdivide and get the first
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[1][0] = tmp0[1];
                pts[2][0] = tmp0[2];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[1][1] = tmp0[1];
                pts[2][1] = tmp0[2];
            }
            // Copy back to layout
            $U1aqY.copy(linePoints[0], pts[0]);
            $U1aqY.copy(linePoints[1], pts[2]);
            $U1aqY.copy(linePoints[2], pts[1]);
        } else {
            $U1aqY.copy(pts2[0], originalPoints[0]);
            $U1aqY.copy(pts2[1], originalPoints[1]);
            $U1aqY.sub(v, pts2[1], pts2[0]);
            $U1aqY.normalize(v, v);
            if (fromSymbol && fromSymbol !== 'none') {
                var symbolSize = (0, $fijY1.getSymbolSize)(edge.node1);
                $U1aqY.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
            }
            if (toSymbol && toSymbol !== 'none') {
                var symbolSize = (0, $fijY1.getSymbolSize)(edge.node2);
                $U1aqY.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
            }
            $U1aqY.copy(linePoints[0], pts2[0]);
            $U1aqY.copy(linePoints[1], pts2[1]);
        }
    });
}

});

parcelRegister("YaX0v", function(module, exports) {

$parcel$export(module.exports, "getThumbnailBridge", function () { return $0b4e194c56eabf7b$export$a3afb75f2ef39b51; });
$parcel$export(module.exports, "injectThumbnailBridge", function () { return $0b4e194c56eabf7b$export$db2c4d283c33f141; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");
/**
 * @caveat Do not import other `src/component/thumbnail/*` files.
 *  This file should be decoupled from them for sake of the size consideration.
 */ /**
 * FIXME: This is a temporary implmentation. May need refactor to decouple
 *  the direct call from series.graph to thumbnail.
 */ var $0b4e194c56eabf7b$var$inner = (0, $bx3T8.makeInner)();
function $0b4e194c56eabf7b$export$a3afb75f2ef39b51(model) {
    if (model) return $0b4e194c56eabf7b$var$inner(model).bridge;
}
function $0b4e194c56eabf7b$export$db2c4d283c33f141(model, thumbnailBridge) {
    if (model) $0b4e194c56eabf7b$var$inner(model).bridge = thumbnailBridge;
}

});


parcelRegister("3f68f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25c787807fa38a7e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2kN4z = parcelRequire("2kN4z");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $b8YKU = parcelRequire("b8YKU");

var $elq2d = parcelRequire("elq2d");

var $jP9NX = parcelRequire("jP9NX");

var $49X8G = parcelRequire("49X8G");

var $5KdhI = parcelRequire("5KdhI");

var $1Z9ox = parcelRequire("1Z9ox");

var $cmtYx = parcelRequire("cmtYx");

var $6aXXD = parcelRequire("6aXXD");
var $25c787807fa38a7e$var$GraphSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GraphSeriesModel, _super);
    function GraphSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    GraphSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        var self = this;
        function getCategoriesData() {
            return self._categoriesData;
        }
        // Provide data for legend select
        this.legendVisualProvider = new (0, $jP9NX.default)(getCategoriesData, getCategoriesData);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeDefaultAndTheme = function(option) {
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        (0, $bx3T8.defaultEmphasis)(option, 'edgeLabel', [
            'show'
        ]);
    };
    GraphSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var self = this;
        if (nodes && edges) {
            // auto curveness
            (0, $cmtYx.initCurvenessList)(this);
            var graph = (0, $elq2d.default)(nodes, edges, this, true, beforeLink);
            $2N6Uo.each(graph.edges, function(edge) {
                (0, $cmtYx.createEdgeMapForCurveness)(edge.node1, edge.node2, this, edge.dataIndex);
            }, this);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // Overwrite nodeData.getItemModel to
            nodeData.wrapMethod('getItemModel', function(model) {
                var categoriesModels = self._categoriesModels;
                var categoryIdx = model.getShallow('category');
                var categoryModel = categoriesModels[categoryIdx];
                if (categoryModel) {
                    categoryModel.parentModel = model.parentModel;
                    model.parentModel = categoryModel;
                }
                return model;
            });
            // TODO Inherit resolveParentPath by default in Model#getModel?
            var oldGetModel = (0, $b8YKU.default).prototype.getModel;
            function newGetModel(path, parentModel) {
                var model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod('getItemModel', function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === 'label' || pathArr[1] === 'label')) {
                    var newPathArr = pathArr.slice();
                    if (pathArr[0] === 'label') newPathArr[0] = 'edgeLabel';
                    else if (pathArr[1] === 'label') newPathArr[1] = 'edgeLabel';
                    return newPathArr;
                }
                return pathArr;
            }
        }
    };
    GraphSeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    GraphSeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    GraphSeriesModel.prototype.getCategoriesData = function() {
        return this._categoriesData;
    };
    GraphSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        if (dataType === 'edge') {
            var nodeData = this.getData();
            var params = this.getDataParams(dataIndex, dataType);
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var nameArr = [];
            sourceName != null && nameArr.push(sourceName);
            targetName != null && nameArr.push(targetName);
            return (0, $5KdhI.createTooltipMarkup)('nameValue', {
                name: nameArr.join(' > '),
                value: params.value,
                noValue: params.value == null
            });
        }
        // dataType === 'node' or empty
        var nodeMarkup = (0, $1Z9ox.defaultSeriesFormatTooltip)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
        return nodeMarkup;
    };
    GraphSeriesModel.prototype._updateCategoriesData = function() {
        var categories = $2N6Uo.map(this.option.categories || [], function(category) {
            // Data must has value
            return category.value != null ? category : $2N6Uo.extend({
                value: 0
            }, category);
        });
        var categoriesData = new (0, $2kN4z.default)([
            'value'
        ], this);
        categoriesData.initData(categories);
        this._categoriesData = categoriesData;
        this._categoriesModels = categoriesData.mapArray(function(idx) {
            return categoriesData.getItemModel(idx);
        });
    };
    GraphSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GraphSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    GraphSeriesModel.prototype.isAnimationEnabled = function() {
        return _super.prototype.isAnimationEnabled.call(this) && !(this.get('layout') === 'force' && this.get([
            'force',
            'layoutAnimation'
        ]));
    };
    GraphSeriesModel.type = 'series.graph';
    GraphSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    GraphSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'view',
        // Default option for all coordinate systems
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // polarIndex: 0,
        // geoIndex: 0,
        legendHoverLink: true,
        layout: null,
        // Configuration of circular layout
        circular: {
            rotateLabel: false
        },
        // Configuration of force directed layout
        force: {
            initLayout: null,
            // Node repulsion. Can be an array to represent range.
            repulsion: [
                0,
                50
            ],
            gravity: 0.1,
            // Initial friction
            friction: 0.6,
            // Edge length. Can be an array to represent range.
            edgeLength: 30,
            layoutAnimation: true
        },
        left: 'center',
        top: 'center',
        // right: null,
        // bottom: null,
        // width: '80%',
        // height: '80%',
        symbol: 'circle',
        symbolSize: 10,
        edgeSymbol: [
            'none',
            'none'
        ],
        edgeSymbolSize: 10,
        edgeLabel: {
            position: 'middle',
            distance: 5
        },
        draggable: false,
        roam: false,
        // Default on center of graph
        center: null,
        zoom: 1,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.6,
        // cursor: null,
        // categories: [],
        // data: []
        // Or
        // nodes: []
        //
        // links: []
        // Or
        // edges: []
        label: {
            show: false,
            formatter: '{b}'
        },
        itemStyle: {},
        lineStyle: {
            // Don't use tokens.color.border because of the opacity
            color: (0, $6aXXD.default).color.neutral50,
            width: 1,
            opacity: 0.5
        },
        emphasis: {
            scale: true,
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: (0, $6aXXD.default).color.primary
            }
        }
    };
    return GraphSeriesModel;
}((0, $49X8G.default));
var $25c787807fa38a7e$export$2e2bcd8739ae039 = $25c787807fa38a7e$var$GraphSeriesModel;

});


parcelRegister("ecVCx", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $a57ee1e6918746af$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5gTwb = parcelRequire("5gTwb");

var $aACiw = parcelRequire("aACiw");
function $a57ee1e6918746af$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $5gTwb.default));
    registers.registerSeriesModel((0, $aACiw.default));
}

});
parcelRegister("5gTwb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d69831d0c5a72d1$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");
parcelRequire("h9U3p");
var $lQsZt = parcelRequire("lQsZt");
var $aH2k0 = parcelRequire("aH2k0");
var $h9U3p = parcelRequire("h9U3p");

var $bwPbQ = parcelRequire("bwPbQ");

var $4qUjN = parcelRequire("4qUjN");

var $2N6Uo = parcelRequire("2N6Uo");

var $cWIrM = parcelRequire("cWIrM");

var $kXNP6 = parcelRequire("kXNP6");

var $bysmE = parcelRequire("bysmE");
function $3d69831d0c5a72d1$var$getIsInPiecewiseRange(dataExtent, pieceList, selected) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    pieceList = $2N6Uo.map(pieceList, function(piece) {
        return {
            interval: [
                (piece.interval[0] - dataExtent[0]) / dataSpan,
                (piece.interval[1] - dataExtent[0]) / dataSpan
            ]
        };
    });
    var len = pieceList.length;
    var lastIndex = 0;
    return function(val) {
        var i;
        // Try to find in the location of the last found
        for(i = lastIndex; i < len; i++){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        if (i === len) // Not found, back interation
        for(i = lastIndex - 1; i >= 0; i--){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        return i >= 0 && i < len && selected[i];
    };
}
function $3d69831d0c5a72d1$var$getIsInContinuousRange(dataExtent, range) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    range = [
        (range[0] - dataExtent[0]) / dataSpan,
        (range[1] - dataExtent[0]) / dataSpan
    ];
    return function(val) {
        return val >= range[0] && val <= range[1];
    };
}
function $3d69831d0c5a72d1$var$isGeoCoordSys(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === 'lng' && dimensions[1] === 'lat';
}
var $3d69831d0c5a72d1$var$HeatmapView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(HeatmapView, _super);
    function HeatmapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapView.type;
        return _this;
    }
    HeatmapView.prototype.render = function(seriesModel, ecModel, api) {
        var visualMapOfThisSeries;
        ecModel.eachComponent('visualMap', function(visualMap) {
            visualMap.eachTargetSeries(function(targetSeries) {
                if (targetSeries === seriesModel) visualMapOfThisSeries = visualMap;
            });
        });
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this.group.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar' || coordSys.type === 'matrix') this._renderOnGridLike(seriesModel, api, 0, seriesModel.getData().count());
        else if ($3d69831d0c5a72d1$var$isGeoCoordSys(coordSys)) this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    };
    HeatmapView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this.group.removeAll();
    };
    HeatmapView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys) {
            // geo does not support incremental rendering?
            if ($3d69831d0c5a72d1$var$isGeoCoordSys(coordSys)) this.render(seriesModel, ecModel, api);
            else {
                this._progressiveEls = [];
                this._renderOnGridLike(seriesModel, api, params.start, params.end, true);
            }
        }
    };
    HeatmapView.prototype.eachRendered = function(cb) {
        $h9U3p.traverseElements(this._progressiveEls || this.group, cb);
    };
    HeatmapView.prototype._renderOnGridLike = function(seriesModel, api, start, end, incremental) {
        var coordSys = seriesModel.coordinateSystem;
        var isCartesian2d = (0, $kXNP6.isCoordinateSystemType)(coordSys, 'cartesian2d');
        var isMatrix = (0, $kXNP6.isCoordinateSystemType)(coordSys, 'matrix');
        var width;
        var height;
        var xAxisExtent;
        var yAxisExtent;
        if (isCartesian2d) {
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            // add 0.5px to avoid the gaps
            width = xAxis.getBandWidth() + .5;
            height = yAxis.getBandWidth() + .5;
            xAxisExtent = xAxis.scale.getExtent();
            yAxisExtent = yAxis.scale.getExtent();
        }
        var group = this.group;
        var data = seriesModel.getData();
        var emphasisStyle = seriesModel.getModel([
            'emphasis',
            'itemStyle'
        ]).getItemStyle();
        var blurStyle = seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle();
        var selectStyle = seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle();
        var borderRadius = seriesModel.get([
            'itemStyle',
            'borderRadius'
        ]);
        var labelStatesModels = (0, $bysmE.getLabelStatesModels)(seriesModel);
        var emphasisModel = seriesModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');
        var dataDims = isCartesian2d || isMatrix ? [
            data.mapDimension('x'),
            data.mapDimension('y'),
            data.mapDimension('value')
        ] : [
            data.mapDimension('time'),
            data.mapDimension('value')
        ];
        for(var idx = start; idx < end; idx++){
            var rect = void 0;
            var style = data.getItemVisual(idx, 'style');
            if (isCartesian2d) {
                var dataDimX = data.get(dataDims[0], idx);
                var dataDimY = data.get(dataDims[1], idx);
                // Ignore empty data and out of extent data
                if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) continue;
                var point = coordSys.dataToPoint([
                    dataDimX,
                    dataDimY
                ]);
                rect = new $aH2k0.default({
                    shape: {
                        x: point[0] - width / 2,
                        y: point[1] - height / 2,
                        width: width,
                        height: height
                    },
                    style: style
                });
            } else if (isMatrix) {
                var shape = coordSys.dataToLayout([
                    data.get(dataDims[0], idx),
                    data.get(dataDims[1], idx)
                ]).rect;
                if ($2N6Uo.eqNaN(shape.x)) continue;
                rect = new $aH2k0.default({
                    z2: 1,
                    shape: shape,
                    style: style
                });
            } else {
                // Calendar
                // Ignore empty data
                if (isNaN(data.get(dataDims[1], idx))) continue;
                var layout = coordSys.dataToLayout([
                    data.get(dataDims[0], idx)
                ]);
                var shape = layout.contentRect || layout.rect;
                if ($2N6Uo.eqNaN(shape.x) || $2N6Uo.eqNaN(shape.y)) continue;
                rect = new $aH2k0.default({
                    z2: 1,
                    shape: shape,
                    style: style
                });
            }
            // Optimization for large dataset
            if (data.hasItemOption) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel_1 = itemModel.getModel('emphasis');
                emphasisStyle = emphasisModel_1.getModel('itemStyle').getItemStyle();
                blurStyle = itemModel.getModel([
                    'blur',
                    'itemStyle'
                ]).getItemStyle();
                selectStyle = itemModel.getModel([
                    'select',
                    'itemStyle'
                ]).getItemStyle();
                // Each item value struct in the data would be firstly
                // {
                //     itemStyle: { borderRadius: [30, 30] },
                //     value: [2022, 02, 22]
                // }
                borderRadius = itemModel.get([
                    'itemStyle',
                    'borderRadius'
                ]);
                focus = emphasisModel_1.get('focus');
                blurScope = emphasisModel_1.get('blurScope');
                emphasisDisabled = emphasisModel_1.get('disabled');
                labelStatesModels = (0, $bysmE.getLabelStatesModels)(itemModel);
            }
            rect.shape.r = borderRadius;
            var rawValue = seriesModel.getRawValue(idx);
            var defaultText = '-';
            if (rawValue && rawValue[2] != null) defaultText = rawValue[2] + '';
            (0, $bysmE.setLabelStyle)(rect, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultOpacity: style.opacity,
                defaultText: defaultText
            });
            rect.ensureState('emphasis').style = emphasisStyle;
            rect.ensureState('blur').style = blurStyle;
            rect.ensureState('select').style = selectStyle;
            (0, $bwPbQ.toggleHoverEmphasis)(rect, focus, blurScope, emphasisDisabled);
            rect.incremental = incremental;
            // PENDING
            if (incremental) // Rect must use hover layer if it's incremental.
            rect.states.emphasis.hoverLayer = true;
            group.add(rect);
            data.setItemGraphicEl(idx, rect);
            if (this._progressiveEls) this._progressiveEls.push(rect);
        }
    };
    HeatmapView.prototype._renderOnGeo = function(geo, seriesModel, visualMapModel, api) {
        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange;
        // if (!visualMapping) {
        //     throw new Error('Data range must have color visuals');
        // }
        var data = seriesModel.getData();
        var hmLayer = this._hmLayer || this._hmLayer || new (0, $4qUjN.default)();
        hmLayer.blurSize = seriesModel.get('blurSize');
        hmLayer.pointSize = seriesModel.get('pointSize');
        hmLayer.minOpacity = seriesModel.get('minOpacity');
        hmLayer.maxOpacity = seriesModel.get('maxOpacity');
        var rect = geo.getViewRect().clone();
        var roamTransform = geo.getRoamTransform();
        rect.applyTransform(roamTransform);
        // Clamp on viewport
        var x = Math.max(rect.x, 0);
        var y = Math.max(rect.y, 0);
        var x2 = Math.min(rect.width + rect.x, api.getWidth());
        var y2 = Math.min(rect.height + rect.y, api.getHeight());
        var width = x2 - x;
        var height = y2 - y;
        var dims = [
            data.mapDimension('lng'),
            data.mapDimension('lat'),
            data.mapDimension('value')
        ];
        var points = data.mapArray(dims, function(lng, lat, value) {
            var pt = geo.dataToPoint([
                lng,
                lat
            ]);
            pt[0] -= x;
            pt[1] -= y;
            pt.push(value);
            return pt;
        });
        var dataExtent = visualMapModel.getExtent();
        var isInRange = visualMapModel.type === 'visualMap.continuous' ? $3d69831d0c5a72d1$var$getIsInContinuousRange(dataExtent, visualMapModel.option.range) : $3d69831d0c5a72d1$var$getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
            inRange: inRangeVisuals.color.getColorMapper(),
            outOfRange: outOfRangeVisuals.color.getColorMapper()
        }, isInRange);
        var img = new $lQsZt.default({
            style: {
                width: width,
                height: height,
                x: x,
                y: y,
                image: hmLayer.canvas
            },
            silent: true
        });
        this.group.add(img);
    };
    HeatmapView.type = 'heatmap';
    return HeatmapView;
}((0, $cWIrM.default));
var $3d69831d0c5a72d1$export$2e2bcd8739ae039 = $3d69831d0c5a72d1$var$HeatmapView;

});
parcelRegister("4qUjN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33a546c41dfb4b59$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8ClampedArray */ 
var $3WHoM = parcelRequire("3WHoM");

var $6aXXD = parcelRequire("6aXXD");
var $33a546c41dfb4b59$var$GRADIENT_LEVELS = 256;
var $33a546c41dfb4b59$var$HeatmapLayer = /** @class */ function() {
    function HeatmapLayer() {
        this.blurSize = 30;
        this.pointSize = 20;
        this.maxOpacity = 1;
        this.minOpacity = 0;
        this._gradientPixels = {
            inRange: null,
            outOfRange: null
        };
        var canvas = (0, $3WHoM.platformApi).createCanvas();
        this.canvas = canvas;
    }
    /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */ HeatmapLayer.prototype.update = function(data, width, height, normalize, colorFunc, isInRange) {
        var brush = this._getBrush();
        var gradientInRange = this._getGradient(colorFunc, 'inRange');
        var gradientOutOfRange = this._getGradient(colorFunc, 'outOfRange');
        var r = this.pointSize + this.blurSize;
        var canvas = this.canvas;
        var ctx = canvas.getContext('2d');
        var len = data.length;
        canvas.width = width;
        canvas.height = height;
        for(var i = 0; i < len; ++i){
            var p = data[i];
            var x = p[0];
            var y = p[1];
            var value = p[2];
            // calculate alpha using value
            var alpha = normalize(value);
            // draw with the circle brush with alpha
            ctx.globalAlpha = alpha;
            ctx.drawImage(brush, x - r, y - r);
        }
        if (!canvas.width || !canvas.height) // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
        // 'CanvasRenderingContext2D': The source height is 0."
        return canvas;
        // colorize the canvas using alpha value and set with gradient
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var offset = 0;
        var pixelLen = pixels.length;
        var minOpacity = this.minOpacity;
        var maxOpacity = this.maxOpacity;
        var diffOpacity = maxOpacity - minOpacity;
        while(offset < pixelLen){
            var alpha = pixels[offset + 3] / 256;
            var gradientOffset = Math.floor(alpha * ($33a546c41dfb4b59$var$GRADIENT_LEVELS - 1)) * 4;
            // Simple optimize to ignore the empty data
            if (alpha > 0) {
                var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange;
                // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
                alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
                pixels[offset++] = gradient[gradientOffset];
                pixels[offset++] = gradient[gradientOffset + 1];
                pixels[offset++] = gradient[gradientOffset + 2];
                pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
            } else offset += 4;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    /**
   * get canvas of a black circle brush used for canvas to draw later
   */ HeatmapLayer.prototype._getBrush = function() {
        var brushCanvas = this._brushCanvas || (this._brushCanvas = (0, $3WHoM.platformApi).createCanvas());
        // set brush size
        var r = this.pointSize + this.blurSize;
        var d = r * 2;
        brushCanvas.width = d;
        brushCanvas.height = d;
        var ctx = brushCanvas.getContext('2d');
        ctx.clearRect(0, 0, d, d);
        // in order to render shadow without the distinct circle,
        // draw the distinct circle in an invisible place,
        // and use shadowOffset to draw shadow in the center of the canvas
        ctx.shadowOffsetX = d;
        ctx.shadowBlur = this.blurSize;
        // draw the shadow in black, and use alpha and shadow blur to generate
        // color in color map
        ctx.shadowColor = (0, $6aXXD.default).color.neutral99;
        // draw circle in the left to the canvas
        ctx.beginPath();
        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return brushCanvas;
    };
    /**
   * get gradient color map
   * @private
   */ HeatmapLayer.prototype._getGradient = function(colorFunc, state) {
        var gradientPixels = this._gradientPixels;
        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(1024));
        var color = [
            0,
            0,
            0,
            0
        ];
        var off = 0;
        for(var i = 0; i < 256; i++){
            colorFunc[state](i / 255, true, color);
            pixelsSingleState[off++] = color[0];
            pixelsSingleState[off++] = color[1];
            pixelsSingleState[off++] = color[2];
            pixelsSingleState[off++] = color[3];
        }
        return pixelsSingleState;
    };
    return HeatmapLayer;
}();
var $33a546c41dfb4b59$export$2e2bcd8739ae039 = $33a546c41dfb4b59$var$HeatmapLayer;

});


parcelRegister("aACiw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b5af94f85970122$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $dOrFN = parcelRequire("dOrFN");

var $hIXrb = parcelRequire("hIXrb");

var $6aXXD = parcelRequire("6aXXD");
var $7b5af94f85970122$var$HeatmapSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(HeatmapSeriesModel, _super);
    function HeatmapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapSeriesModel.type;
        return _this;
    }
    HeatmapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $dOrFN.default)(null, this, {
            generateCoord: 'value'
        });
    };
    HeatmapSeriesModel.prototype.preventIncremental = function() {
        var coordSysCreator = (0, $hIXrb.default).get(this.get('coordinateSystem'));
        if (coordSysCreator && coordSysCreator.dimensions) return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
    };
    HeatmapSeriesModel.type = 'series.heatmap';
    HeatmapSeriesModel.dependencies = [
        'grid',
        'geo',
        'calendar',
        'matrix'
    ];
    HeatmapSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0,
        select: {
            itemStyle: {
                borderColor: (0, $6aXXD.default).color.primary
            }
        }
    };
    return HeatmapSeriesModel;
}((0, $49X8G.default));
var $7b5af94f85970122$export$2e2bcd8739ae039 = $7b5af94f85970122$var$HeatmapSeriesModel;

});


parcelRegister("icheD", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $d3f6b77df6a4ac89$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lzqqu = parcelRequire("lzqqu");

var $jmPCW = parcelRequire("jmPCW");

var $2tzwZ = parcelRequire("2tzwZ");

var $dx8xl = parcelRequire("dx8xl");
function $d3f6b77df6a4ac89$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $jmPCW.default));
    registers.registerSeriesModel((0, $lzqqu.default));
    registers.registerLayout((0, $2tzwZ.default)('line', true));
    registers.registerVisual({
        seriesType: 'line',
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // Visual coding for legend
            var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual('style').fill;
            data.setVisual('legendLineStyle', lineStyle);
        }
    });
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $dx8xl.default)('line'));
}

});
parcelRegister("lzqqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb415d93bb058da0$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $dOrFN = parcelRequire("dOrFN");

var $49X8G = parcelRequire("49X8G");

var $k0QDS = parcelRequire("k0QDS");

var $iQonF = parcelRequire("iQonF");

var $6aXXD = parcelRequire("6aXXD");
var $fb415d93bb058da0$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $dOrFN.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $iQonF.default)();
        var line = (0, $k0QDS.createSymbol)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual('symbol');
        var visualRotate = this.getData().getVisual('symbolRotate');
        var symbolType = visualType === 'none' ? 'circle' : visualType;
        // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $k0QDS.createSymbol)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf('empty') > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = (0, $6aXXD.default).color.neutral00;
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = 'series.line';
    LineSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    LineSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 3,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        clip: true,
        label: {
            position: 'top'
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: 'solid'
        },
        emphasis: {
            scale: true
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: 'emptyCircle',
        symbolSize: 6,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: 'auto',
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: 'none',
        animationEasing: 'linear',
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: 'clone'
        },
        triggerLineEvent: false
    };
    return LineSeriesModel;
}((0, $49X8G.default));
var $fb415d93bb058da0$export$2e2bcd8739ae039 = $fb415d93bb058da0$var$LineSeriesModel;

});

parcelRegister("jmPCW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1981e6f0287b90f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $ih3Ax = parcelRequire("ih3Ax");

var $cWCFS = parcelRequire("cWCFS");

var $gIas0 = parcelRequire("gIas0");

var $iQonF = parcelRequire("iQonF");
var $ipprj = parcelRequire("ipprj");
var $ftfXE = parcelRequire("ftfXE");
var $kBKw3 = parcelRequire("kBKw3");parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $bx3T8 = parcelRequire("bx3T8");

var $4Wbqa = parcelRequire("4Wbqa");

var $cWIrM = parcelRequire("cWIrM");

var $iKEw9 = parcelRequire("iKEw9");

var $dTvcN = parcelRequire("dTvcN");

var $kXNP6 = parcelRequire("kXNP6");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");

var $d8wDg = parcelRequire("d8wDg");

var $6TSUP = parcelRequire("6TSUP");

var $hp8dQ = parcelRequire("hp8dQ");

var $hrphB = parcelRequire("hrphB");

var $3UxDF = parcelRequire("3UxDF");
function $e1981e6f0287b90f$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $e1981e6f0287b90f$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $e1981e6f0287b90f$var$getBoundingDiff(points1, points2) {
    var _a = $e1981e6f0287b90f$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $e1981e6f0287b90f$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
    // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $e1981e6f0287b90f$var$getSmooth(smooth) {
    return $2N6Uo.isNumber(smooth) ? smooth : smooth ? 0.5 : 0;
}
function $e1981e6f0287b90f$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $hp8dQ.createFloat32Array)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $iKEw9.getStackedOnPoint)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
/**
 * Filter the null data and extend data for step considering `stepTurnAt`
 *
 * @param points data to convert, that may containing null
 * @param basePoints base data to reference, used only for areaStyle points
 * @param coordSys coordinate system
 * @param stepTurnAt 'start' | 'end' | 'middle' | true
 * @param connectNulls whether to connect nulls
 * @returns converted point positions
 */ function $e1981e6f0287b90f$var$turnPointsIntoStep(points, basePoints, coordSys, stepTurnAt, connectNulls) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    var filteredPoints = [];
    if (connectNulls) {
        for(i = 0; i < points.length; i += 2){
            /**
       * For areaStyle of stepped lines, `stackedOnPoints` should be
       * filtered the same as `points` so that the base axis values
       * should stay the same as the lines above. See #20021
       */ var reference = basePoints || points;
            if (!isNaN(reference[i]) && !isNaN(reference[i + 1])) filteredPoints.push(points[i], points[i + 1]);
        }
        points = filteredPoints;
    }
    for(i = 0; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case 'end':
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case 'middle':
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    }
    // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $e1981e6f0287b90f$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length;
    // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $3UxDF.lerp)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
            else if (prevOutOfRangeColorStop) // If there are two stops and coord range is between these two stops
            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $e1981e6f0287b90f$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual('visualMeta');
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== 'cartesian2d') return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim;
        // Can only be x or y
        if (coordDim === 'x' || coordDim === 'y') {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
    // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim);
    // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $2N6Uo.map(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $e1981e6f0287b90f$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return 'transparent';
    $2N6Uo.each(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || 'transparent'
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || 'transparent'
    });
    var gradient = new $ftfXE.default(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + '2'] = maxCoord;
    return gradient;
}
function $e1981e6f0287b90f$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get('showAllSymbol');
    var isAuto = showAllSymbol === 'auto';
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
    if (!categoryAxis) return;
    // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto && $e1981e6f0287b90f$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
    // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $2N6Uo.each(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $e1981e6f0287b90f$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In most cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $cWCFS.default).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
    }
    return true;
}
function $e1981e6f0287b90f$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $e1981e6f0287b90f$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$e1981e6f0287b90f$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $e1981e6f0287b90f$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $e1981e6f0287b90f$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === 'x' ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $e1981e6f0287b90f$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        'endLabel',
        'show'
    ])) return true;
    for(var i = 0; i < (0, $bwPbQ.SPECIAL_STATES).length; i++){
        if (seriesModel.get([
            (0, $bwPbQ.SPECIAL_STATES)[i],
            'endLabel',
            'show'
        ])) return true;
    }
    return false;
}
function $e1981e6f0287b90f$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $kXNP6.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
        var endLabelModel_1 = seriesModel.getModel('endLabel');
        var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $e1981e6f0287b90f$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $dTvcN.createGridClipPath)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during);
        // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get('clip', true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $dTvcN.createPolarClipPath)(coordSys, hasAnimation, seriesModel);
}
function $e1981e6f0287b90f$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
    var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
    return {
        normal: {
            align: endLabelModel.get('align') || align,
            verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
        }
    };
}
var $e1981e6f0287b90f$var$LineView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $iQonF.default();
        var symbolDraw = new (0, $ih3Ax.default)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
        this._changePolyState = $2N6Uo.bind(this._changePolyState, this);
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel('lineStyle');
        var areaStyleModel = seriesModel.getModel('areaStyle');
        var points = data.getLayout('points') || [];
        var isCoordSysPolar = coordSys.type === 'polar';
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = !ecModel.ssr && seriesModel.get('animation');
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get('origin');
        var dataCoordInfo = (0, $iKEw9.prepareDataCoordInfo)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $e1981e6f0287b90f$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get('showSymbol');
        var connectNulls = seriesModel.get('connectNulls');
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $e1981e6f0287b90f$var$getIsIgnoreFunc(seriesModel, data, coordSys);
        // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup);
        // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get('step') : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
            clipShapeForSymbol = coordSys.getArea();
            // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $e1981e6f0287b90f$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')];
        // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                if (stackedOnPoints) stackedOnPoints = $e1981e6f0287b90f$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                // TODO If stacked series is not step
                points = $e1981e6f0287b90f$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon) {
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $hrphB.convertToColorString)(visualColor));
            lineGroup.setClipPath($e1981e6f0287b90f$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $hrphB.convertToColorString)(visualColor));
            // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $e1981e6f0287b90f$var$createLineClipPath(this, coordSys, false, seriesModel);
                $ipprj.initProps(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($e1981e6f0287b90f$var$createLineClipPath(this, coordSys, true, seriesModel));
            // Always update, or it is wrong in the case turning on legend
            // because points are not changed.
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            // In the case data zoom triggered refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing.
            if (!$e1981e6f0287b90f$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$e1981e6f0287b90f$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
                else {
                    // Not do it in update with animation
                    if (step) {
                        if (stackedOnPoints) stackedOnPoints = $e1981e6f0287b90f$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                        // TODO If stacked series is not step
                        points = $e1981e6f0287b90f$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var emphasisModel = seriesModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');
        polyline.useStyle($2N6Uo.defaults(// Use color in lineStyle first
        lineStyleModel.getLineStyle(), {
            fill: 'none',
            stroke: visualColor,
            lineJoin: 'bevel'
        }));
        (0, $bwPbQ.setStatesStylesFromModel)(polyline, seriesModel, 'lineStyle');
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            'emphasis',
            'lineStyle',
            'width'
        ]) === 'bolder') {
            var emphasisLineStyle = polyline.getState('emphasis').style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        }
        // Needs seriesIndex for focus
        (0, $6TSUP.getECData)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $bwPbQ.toggleHoverEmphasis)(polyline, focus, blurScope, emphasisDisabled);
        var smooth = $e1981e6f0287b90f$var$getSmooth(seriesModel.get('smooth'));
        var smoothMonotone = seriesModel.get('smoothMonotone');
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
            var stackedOnSmooth = 0;
            polygon.useStyle($2N6Uo.defaults(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: 'bevel',
                decal: data.getVisual('style').decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $e1981e6f0287b90f$var$getSmooth(stackedOnSeries.get('smooth'));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $bwPbQ.setStatesStylesFromModel)(polygon, seriesModel, 'areaStyle');
            // Needs seriesIndex for focus
            (0, $6TSUP.getECData)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $bwPbQ.toggleHoverEmphasis)(polygon, focus, blurScope, emphasisDisabled);
        }
        var changePolyState = this._changePolyState;
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data;
        // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
        if (seriesModel.get('triggerLineEvent')) {
            this.packEventData(seriesModel, polyline);
            polygon && this.packEventData(seriesModel, polygon);
        }
    };
    LineView.prototype.packEventData = function(seriesModel, el) {
        (0, $6TSUP.getECData)(el).eventData = {
            componentType: 'series',
            componentSubType: 'line',
            componentIndex: seriesModel.componentIndex,
            seriesIndex: seriesModel.seriesIndex,
            seriesName: seriesModel.name,
            seriesType: 'line'
        };
    };
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $bx3T8.queryDataIndex(data, payload);
        this._changePolyState('emphasis');
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout('points');
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get('zlevel') || 0;
                var z = seriesModel.get('z') || 0;
                symbol = new (0, $cWCFS.default)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z);
                // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol);
                // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $cWIrM.default).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $bx3T8.queryDataIndex(data, payload);
        this._changePolyState('normal');
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $cWIrM.default).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $bwPbQ.setStatesFlag)(this._polyline, toState);
        polygon && (0, $bwPbQ.setStatesFlag)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline;
        // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $4Wbqa.ECPolyline)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon;
        // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $4Wbqa.ECPolygon)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === 'cartesian2d') {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === 'polar') {
            isHorizontalOrRadial = baseAxis.dim === 'angle';
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get('animationDuration');
        if ($2N6Uo.isFunction(seriesDuration)) seriesDuration = seriesDuration(null);
        var seriesDelay = seriesModel.get('animationDelay') || 0;
        var seriesDelayValue = $2N6Uo.isFunction(seriesDelay) ? seriesDelay(null) : seriesDelay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = $2N6Uo.isFunction(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel('endLabel');
        if ($e1981e6f0287b90f$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            // series may be filtered.
            var points = data_2.getLayout('points');
            if (!points) {
                polyline.removeTextContent();
                this._endLabel = null;
                return;
            }
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $kBKw3.default({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            }
            // Find last non-NaN data to display data
            var dataIndex = $e1981e6f0287b90f$var$getLastIndexNotNull(points);
            if (dataIndex >= 0) {
                (0, $bysmE.setLabelStyle)(polyline, (0, $bysmE.getLabelStatesModels)(seriesModel, 'endLabel'), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $d8wDg.getDefaultInterpolatedLabel)(data_2, interpolatedValue) : (0, $d8wDg.getDefaultLabel)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $e1981e6f0287b90f$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout('points');
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get('connectNulls');
            var precision = endLabelModel.get('precision');
            var distance = endLabelModel.get('distance') || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? 'x' : 'y';
            var dataIndexRange = $e1981e6f0287b90f$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $e1981e6f0287b90f$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $bx3T8.interpolateRawValues(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $e1981e6f0287b90f$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) {
                var inner = (0, $bysmE.labelInner)(endLabel);
                if (typeof inner.setLabelText === 'function') inner.setLabelText(value);
            }
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $gIas0.default)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            stackedOnCurrent = $e1981e6f0287b90f$var$turnPointsIntoStep(diff.stackedOnCurrent, diff.current, coordSys, step, connectNulls);
            current = $e1981e6f0287b90f$var$turnPointsIntoStep(diff.current, null, coordSys, step, connectNulls);
            stackedOnNext = $e1981e6f0287b90f$var$turnPointsIntoStep(diff.stackedOnNext, diff.next, coordSys, step, connectNulls);
            next = $e1981e6f0287b90f$var$turnPointsIntoStep(diff.next, null, coordSys, step, connectNulls);
        }
        // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($e1981e6f0287b90f$var$getBoundingDiff(current, next) > 3000 || polygon && $e1981e6f0287b90f$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        };
        // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
        // Stop previous animation.
        polyline.stopAnimation();
        $ipprj.updateProps(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $ipprj.updateProps(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
            // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === '=') {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true);
        // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = 'line';
    return LineView;
}((0, $cWIrM.default));
var $e1981e6f0287b90f$export$2e2bcd8739ae039 = $e1981e6f0287b90f$var$LineView;

});
parcelRegister("gIas0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2a8dcb40c88345e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iKEw9 = parcelRequire("iKEw9");

var $hp8dQ = parcelRequire("hp8dQ");
function $c2a8dcb40c88345e$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: '+',
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: '=',
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: '-',
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $c2a8dcb40c88345e$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $c2a8dcb40c88345e$var$diffData(oldData, newData);
    // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = [];
    // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $iKEw9.prepareDataCoordInfo)(oldCoordSys, newData, oldValueOrigin);
    // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout('points') || [];
    var newPoints = newData.getLayout('points') || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0;
        // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case '=':
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1];
                // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case '+':
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $iKEw9.getStackedOnPoint)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case '-':
                pointAdded = false;
        }
        // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    }
    // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $hp8dQ.createFloat32Array)(len);
    var sortedNextPoints = (0, $hp8dQ.createFloat32Array)(len);
    var sortedCurrStackedPoints = (0, $hp8dQ.createFloat32Array)(len);
    var sortedNextStackedPoints = (0, $hp8dQ.createFloat32Array)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}

});
parcelRegister("iKEw9", function(module, exports) {

$parcel$export(module.exports, "prepareDataCoordInfo", function () { return $da6bf3d314370f70$export$b488a529581b37e; });
$parcel$export(module.exports, "getStackedOnPoint", function () { return $da6bf3d314370f70$export$c1601aa630e7b5f8; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a1eW0 = parcelRequire("a1eW0");

var $2N6Uo = parcelRequire("2N6Uo");
function $da6bf3d314370f70$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $da6bf3d314370f70$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
    var dims = (0, $2N6Uo.map)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo('stackResultDimension');
    if ((0, $a1eW0.isDimensionStacked)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $a1eW0.isDimensionStacked)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
    };
}
function $da6bf3d314370f70$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === 'start') valueStart = extent[0];
    else if (valueOrigin === 'end') valueStart = extent[1];
    else if ((0, $2N6Uo.isNumber)(valueOrigin) && !isNaN(valueOrigin)) valueStart = valueOrigin;
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
    // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $da6bf3d314370f70$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}

});


parcelRegister("4Wbqa", function(module, exports) {

$parcel$export(module.exports, "ECPolyline", function () { return $39857035f3456e01$export$bf7c0585b8f7d00f; });
$parcel$export(module.exports, "ECPolygon", function () { return $39857035f3456e01$export$6042a400d113f2bd; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $4oDJM = parcelRequire("4oDJM");

var $eAFw0 = parcelRequire("eAFw0");

var $1kxDI = parcelRequire("1kxDI");

var $6aXXD = parcelRequire("6aXXD");
var $39857035f3456e01$var$mathMin = Math.min;
var $39857035f3456e01$var$mathMax = Math.max;
function $39857035f3456e01$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $39857035f3456e01$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($39857035f3456e01$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY;
            // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                // Ignore duplicate point
                while(nextX === x && nextY === y && k < segLen){
                    k++;
                    nextIdx += dir;
                    idx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                    x = points[idx * 2];
                    y = points[idx * 2 + 1];
                    dx = x - prevX;
                    dy = y - prevY;
                }
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($39857035f3456e01$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0;
                // Is last point
                if (tmpK >= segLen || $39857035f3456e01$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === 'x') {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        var dir_1 = vx > 0 ? 1 : -1;
                        cpx1 = x - dir_1 * lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + dir_1 * lenNextSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === 'y') {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        var dir_2 = vy > 0 ? 1 : -1;
                        cpx1 = x;
                        cpy1 = y - dir_2 * lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + dir_2 * lenNextSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                        // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                        // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg;
                        // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $39857035f3456e01$var$mathMin(nextCpx0, $39857035f3456e01$var$mathMax(nextX, x));
                        nextCpy0 = $39857035f3456e01$var$mathMin(nextCpy0, $39857035f3456e01$var$mathMax(nextY, y));
                        nextCpx0 = $39857035f3456e01$var$mathMax(nextCpx0, $39857035f3456e01$var$mathMin(nextX, x));
                        nextCpy0 = $39857035f3456e01$var$mathMax(nextCpy0, $39857035f3456e01$var$mathMin(nextY, y));
                        // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                        // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $39857035f3456e01$var$mathMin(cpx1, $39857035f3456e01$var$mathMax(prevX, x));
                        cpy1 = $39857035f3456e01$var$mathMin(cpy1, $39857035f3456e01$var$mathMax(prevY, y));
                        cpx1 = $39857035f3456e01$var$mathMax(cpx1, $39857035f3456e01$var$mathMin(prevX, x));
                        cpy1 = $39857035f3456e01$var$mathMax(cpy1, $39857035f3456e01$var$mathMin(prevY, y));
                        // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $39857035f3456e01$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $39857035f3456e01$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polyline';
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $6aXXD.default).color.neutral99,
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $39857035f3456e01$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2;
        // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$39857035f3456e01$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$39857035f3456e01$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $39857035f3456e01$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $eAFw0.default).CMD;
        var x0;
        var y0;
        var isDimX = dim === 'x';
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $1kxDI.cubicRootAt)(x0, x, x2, x3, xOrY, roots) : (0, $1kxDI.cubicRootAt)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $1kxDI.cubicAt)(y0, y, y2, y3, t_1) : (0, $1kxDI.cubicAt)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $4oDJM.default));
var $39857035f3456e01$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($39857035f3456e01$var$ECPolylineShape);
var $39857035f3456e01$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polygon';
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $39857035f3456e01$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$39857035f3456e01$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$39857035f3456e01$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $39857035f3456e01$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $39857035f3456e01$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $4oDJM.default));

});



parcelRegister("ejMXD", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $a6c8d1a8dd2b6c88$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $g3Zqp = parcelRequire("g3Zqp");

var $jfqgp = parcelRequire("jfqgp");

var $g8p5n = parcelRequire("g8p5n");

var $7LtoH = parcelRequire("7LtoH");
function $a6c8d1a8dd2b6c88$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $g3Zqp.default));
    registers.registerSeriesModel((0, $jfqgp.default));
    registers.registerLayout((0, $g8p5n.default));
    registers.registerVisual((0, $7LtoH.default));
}

});
parcelRegister("g3Zqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb1c92d84e84a726$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $3ru3e = parcelRequire("3ru3e");

var $l4ZgL = parcelRequire("l4ZgL");

var $Y6qOy = parcelRequire("Y6qOy");

var $eKn7A = parcelRequire("eKn7A");

var $iG1IN = parcelRequire("iG1IN");

var $lmFii = parcelRequire("lmFii");

var $g8p5n = parcelRequire("g8p5n");

var $dTvcN = parcelRequire("dTvcN");

var $cWIrM = parcelRequire("cWIrM");
var $bb1c92d84e84a726$var$LinesView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LinesView, _super);
    function LinesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesView.type;
        return _this;
    }
    LinesView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        var zlevel = seriesModel.get('zlevel');
        var trailLength = seriesModel.get([
            'effect',
            'trailLength'
        ]);
        var zr = api.getZr();
        // Avoid the drag cause ghost shadow
        // FIXME Better way ?
        // SVG doesn't support
        var isSvg = zr.painter.getType() === 'svg';
        if (!isSvg) zr.painter.getLayer(zlevel).clear(true);
        // Config layer with motion blur
        if (this._lastZlevel != null && !isSvg) zr.configLayer(this._lastZlevel, {
            motionBlur: false
        });
        if (this._showEffect(seriesModel) && trailLength > 0) {
            if (!isSvg) zr.configLayer(zlevel, {
                motionBlur: true,
                lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
            });
        }
        lineDraw.updateData(data);
        var clipPath = seriesModel.get('clip', true) && (0, $dTvcN.createClipPath)(seriesModel.coordinateSystem, false, seriesModel);
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
        this._lastZlevel = zlevel;
        this._finished = true;
    };
    LinesView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        lineDraw.incrementalPrepareUpdate(data);
        this._clearLayer(api);
        this._finished = false;
    };
    LinesView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    LinesView.prototype.eachRendered = function(cb) {
        this._lineDraw && this._lineDraw.eachRendered(cb);
    };
    LinesView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var pipelineContext = seriesModel.pipelineContext;
        if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) // TODO Don't have to do update in large mode. Only do it when there are millions of data.
        return {
            update: true
        };
        else {
            // TODO Use same logic with ScatterView.
            // Manually update layout
            var res = (0, $g8p5n.default).reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            // Not in large mode
            this._lineDraw.updateLayout();
            this._clearLayer(api);
        }
    };
    LinesView.prototype._updateLineDraw = function(data, seriesModel) {
        var lineDraw = this._lineDraw;
        var hasEffect = this._showEffect(seriesModel);
        var isPolyline = !!seriesModel.get('polyline');
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
            if (lineDraw) lineDraw.remove();
            lineDraw = this._lineDraw = isLargeDraw ? new (0, $lmFii.default)() : new (0, $3ru3e.default)(isPolyline ? hasEffect ? (0, $iG1IN.default) : (0, $eKn7A.default) : hasEffect ? (0, $l4ZgL.default) : (0, $Y6qOy.default));
            this._hasEffet = hasEffect;
            this._isPolyline = isPolyline;
            this._isLargeDraw = isLargeDraw;
        }
        this.group.add(lineDraw.group);
        return lineDraw;
    };
    LinesView.prototype._showEffect = function(seriesModel) {
        return !!seriesModel.get([
            'effect',
            'show'
        ]);
    };
    LinesView.prototype._clearLayer = function(api) {
        // Not use motion when dragging or zooming
        var zr = api.getZr();
        var isSvg = zr.painter.getType() === 'svg';
        if (!isSvg && this._lastZlevel != null) zr.painter.getLayer(this._lastZlevel).clear(true);
    };
    LinesView.prototype.remove = function(ecModel, api) {
        this._lineDraw && this._lineDraw.remove();
        this._lineDraw = null;
        // Clear motion when lineDraw is removed
        this._clearLayer(api);
    };
    LinesView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    LinesView.type = 'lines';
    return LinesView;
}((0, $cWIrM.default));
var $bb1c92d84e84a726$export$2e2bcd8739ae039 = $bb1c92d84e84a726$var$LinesView;

});
parcelRegister("l4ZgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5897f7f2d6dcd24$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $iQonF = parcelRequire("iQonF");

var $Y6qOy = parcelRequire("Y6qOy");

var $2N6Uo = parcelRequire("2N6Uo");

var $k0QDS = parcelRequire("k0QDS");

var $U1aqY = parcelRequire("U1aqY");

var $1kxDI = parcelRequire("1kxDI");
var $f5897f7f2d6dcd24$var$EffectLine = /** @class */ function(_super) {
    (0, $9nEce.__extends)(EffectLine, _super);
    function EffectLine(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this.add(_this.createLine(lineData, idx, seriesScope));
        _this._updateEffectSymbol(lineData, idx);
        return _this;
    }
    EffectLine.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $Y6qOy.default)(lineData, idx, seriesScope);
    };
    EffectLine.prototype._updateEffectSymbol = function(lineData, idx) {
        var itemModel = lineData.getItemModel(idx);
        var effectModel = itemModel.getModel('effect');
        var size = effectModel.get('symbolSize');
        var symbolType = effectModel.get('symbol');
        if (!$2N6Uo.isArray(size)) size = [
            size,
            size
        ];
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var color = effectModel.get('color') || lineStyle && lineStyle.stroke;
        var symbol = this.childAt(1);
        if (this._symbolType !== symbolType) {
            // Remove previous
            this.remove(symbol);
            symbol = (0, $k0QDS.createSymbol)(symbolType, -0.5, -0.5, 1, 1, color);
            symbol.z2 = 100;
            symbol.culling = true;
            this.add(symbol);
        }
        // Symbol may be removed if loop is false
        if (!symbol) return;
        // Shadow color is same with color in default
        symbol.setStyle('shadowColor', color);
        symbol.setStyle(effectModel.getItemStyle([
            'color'
        ]));
        symbol.scaleX = size[0];
        symbol.scaleY = size[1];
        symbol.setColor(color);
        this._symbolType = symbolType;
        this._symbolScale = size;
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    EffectLine.prototype._updateEffectAnimation = function(lineData, effectModel, idx) {
        var symbol = this.childAt(1);
        if (!symbol) return;
        var points = lineData.getItemLayout(idx);
        var period = effectModel.get('period') * 1000;
        var loop = effectModel.get('loop');
        var roundTrip = effectModel.get('roundTrip');
        var constantSpeed = effectModel.get('constantSpeed');
        var delayExpr = $2N6Uo.retrieve(effectModel.get('delay'), function(idx) {
            return idx / lineData.count() * period / 3;
        });
        // Ignore when updating
        symbol.ignore = true;
        this._updateAnimationPoints(symbol, points);
        if (constantSpeed > 0) period = this._getLineLength(symbol) / constantSpeed * 1000;
        if (period !== this._period || loop !== this._loop || roundTrip !== this._roundTrip) {
            symbol.stopAnimation();
            var delayNum = void 0;
            if ($2N6Uo.isFunction(delayExpr)) delayNum = delayExpr(idx);
            else delayNum = delayExpr;
            if (symbol.__t > 0) delayNum = -period * symbol.__t;
            this._animateSymbol(symbol, period, delayNum, loop, roundTrip);
        }
        this._period = period;
        this._loop = loop;
        this._roundTrip = roundTrip;
    };
    EffectLine.prototype._animateSymbol = function(symbol, period, delayNum, loop, roundTrip) {
        if (period > 0) {
            symbol.__t = 0;
            var self_1 = this;
            var animator = symbol.animate('', loop).when(roundTrip ? period * 2 : period, {
                __t: roundTrip ? 2 : 1
            }).delay(delayNum).during(function() {
                self_1._updateSymbolPosition(symbol);
            });
            if (!loop) animator.done(function() {
                self_1.remove(symbol);
            });
            animator.start();
        }
    };
    EffectLine.prototype._getLineLength = function(symbol) {
        // Not so accurate
        return $U1aqY.dist(symbol.__p1, symbol.__cp1) + $U1aqY.dist(symbol.__cp1, symbol.__p2);
    };
    EffectLine.prototype._updateAnimationPoints = function(symbol, points) {
        symbol.__p1 = points[0];
        symbol.__p2 = points[1];
        symbol.__cp1 = points[2] || [
            (points[0][0] + points[1][0]) / 2,
            (points[0][1] + points[1][1]) / 2
        ];
    };
    EffectLine.prototype.updateData = function(lineData, idx, seriesScope) {
        this.childAt(0).updateData(lineData, idx, seriesScope);
        this._updateEffectSymbol(lineData, idx);
    };
    EffectLine.prototype._updateSymbolPosition = function(symbol) {
        var p1 = symbol.__p1;
        var p2 = symbol.__p2;
        var cp1 = symbol.__cp1;
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var pos = [
            symbol.x,
            symbol.y
        ];
        var lastPos = pos.slice();
        var quadraticAt = $1kxDI.quadraticAt;
        var quadraticDerivativeAt = $1kxDI.quadraticDerivativeAt;
        pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
        pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t);
        // Tangent
        var tx = symbol.__t < 1 ? quadraticDerivativeAt(p1[0], cp1[0], p2[0], t) : quadraticDerivativeAt(p2[0], cp1[0], p1[0], 1 - t);
        var ty = symbol.__t < 1 ? quadraticDerivativeAt(p1[1], cp1[1], p2[1], t) : quadraticDerivativeAt(p2[1], cp1[1], p1[1], 1 - t);
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
        if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
            if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
                symbol.scaleY = $U1aqY.dist(lastPos, pos) * 1.05;
                // make sure the last segment render within endPoint
                if (t === 1) {
                    pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
                    pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
                }
            } else if (symbol.__lastT === 1) // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
            symbol.scaleY = 2 * $U1aqY.dist(p1, pos);
            else symbol.scaleY = this._symbolScale[1];
        }
        symbol.__lastT = symbol.__t;
        symbol.ignore = false;
        symbol.x = pos[0];
        symbol.y = pos[1];
    };
    EffectLine.prototype.updateLayout = function(lineData, idx) {
        this.childAt(0).updateLayout(lineData, idx);
        var effectModel = lineData.getItemModel(idx).getModel('effect');
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    return EffectLine;
}($iQonF.default);
var $f5897f7f2d6dcd24$export$2e2bcd8739ae039 = $f5897f7f2d6dcd24$var$EffectLine;

});

parcelRegister("eKn7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02c5476b60152d42$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $ewDYK = parcelRequire("ewDYK");
var $ipprj = parcelRequire("ipprj");

var $bwPbQ = parcelRequire("bwPbQ");
var $02c5476b60152d42$var$Polyline = /** @class */ function(_super) {
    (0, $9nEce.__extends)(Polyline, _super);
    function Polyline(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createPolyline(lineData, idx, seriesScope);
        return _this;
    }
    Polyline.prototype._createPolyline = function(lineData, idx, seriesScope) {
        // let seriesModel = lineData.hostModel;
        var points = lineData.getItemLayout(idx);
        var line = new $ewDYK.default({
            shape: {
                points: points
            }
        });
        this.add(line);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childAt(0);
        var target = {
            shape: {
                points: lineData.getItemLayout(idx)
            }
        };
        $ipprj.updateProps(line, target, seriesModel, idx);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var line = this.childAt(0);
        var itemModel = lineData.getItemModel(idx);
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        if (!seriesScope || lineData.hasItemOption) {
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
            emphasisDisabled = emphasisModel.get('disabled');
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
        }
        line.useStyle(lineData.getItemVisual(idx, 'style'));
        line.style.fill = null;
        line.style.strokeNoScale = true;
        var lineEmphasisState = line.ensureState('emphasis');
        lineEmphasisState.style = emphasisLineStyle;
        (0, $bwPbQ.toggleHoverEmphasis)(this, focus, blurScope, emphasisDisabled);
    };
    Polyline.prototype.updateLayout = function(lineData, idx) {
        var polyline = this.childAt(0);
        polyline.setShape('points', lineData.getItemLayout(idx));
    };
    return Polyline;
}($iQonF.default);
var $02c5476b60152d42$export$2e2bcd8739ae039 = $02c5476b60152d42$var$Polyline;

});

parcelRegister("iG1IN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d98d7c1b5bd7c782$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eKn7A = parcelRequire("eKn7A");

var $l4ZgL = parcelRequire("l4ZgL");

var $U1aqY = parcelRequire("U1aqY");
var $d98d7c1b5bd7c782$var$EffectPolyline = /** @class */ function(_super) {
    (0, $9nEce.__extends)(EffectPolyline, _super);
    function EffectPolyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._lastFrame = 0;
        _this._lastFramePercent = 0;
        return _this;
    }
    // Override
    EffectPolyline.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $eKn7A.default)(lineData, idx, seriesScope);
    };
    // Override
    EffectPolyline.prototype._updateAnimationPoints = function(symbol, points) {
        this._points = points;
        var accLenArr = [
            0
        ];
        var len = 0;
        for(var i = 1; i < points.length; i++){
            var p1 = points[i - 1];
            var p2 = points[i];
            len += $U1aqY.dist(p1, p2);
            accLenArr.push(len);
        }
        if (len === 0) {
            this._length = 0;
            return;
        }
        for(var i = 0; i < accLenArr.length; i++)accLenArr[i] /= len;
        this._offsets = accLenArr;
        this._length = len;
    };
    // Override
    EffectPolyline.prototype._getLineLength = function() {
        return this._length;
    };
    // Override
    EffectPolyline.prototype._updateSymbolPosition = function(symbol) {
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var points = this._points;
        var offsets = this._offsets;
        var len = points.length;
        if (!offsets) // Has length 0
        return;
        var lastFrame = this._lastFrame;
        var frame;
        if (t < this._lastFramePercent) {
            // Start from the next frame
            // PENDING start from lastFrame ?
            var start = Math.min(lastFrame + 1, len - 1);
            for(frame = start; frame >= 0; frame--){
                if (offsets[frame] <= t) break;
            }
            // PENDING really need to do this ?
            frame = Math.min(frame, len - 2);
        } else {
            for(frame = lastFrame; frame < len; frame++){
                if (offsets[frame] > t) break;
            }
            frame = Math.min(frame - 1, len - 2);
        }
        var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
        var p0 = points[frame];
        var p1 = points[frame + 1];
        symbol.x = p0[0] * (1 - p) + p * p1[0];
        symbol.y = p0[1] * (1 - p) + p * p1[1];
        var tx = symbol.__t < 1 ? p1[0] - p0[0] : p0[0] - p1[0];
        var ty = symbol.__t < 1 ? p1[1] - p0[1] : p0[1] - p1[1];
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        this._lastFrame = frame;
        this._lastFramePercent = t;
        symbol.ignore = false;
    };
    return EffectPolyline;
}((0, $l4ZgL.default));
var $d98d7c1b5bd7c782$export$2e2bcd8739ae039 = $d98d7c1b5bd7c782$var$EffectPolyline;

});

parcelRegister("lmFii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8dbaf3611e6e8be$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");
parcelRequire("h9U3p");
var $67W72 = parcelRequire("67W72");
var $4oDJM = parcelRequire("4oDJM");
var $iQonF = parcelRequire("iQonF");

var $luMyO = parcelRequire("luMyO");

var $bQJka = parcelRequire("bQJka");

var $6TSUP = parcelRequire("6TSUP");

var $6aXXD = parcelRequire("6aXXD");
var $f8dbaf3611e6e8be$var$LargeLinesPathShape = /** @class */ function() {
    function LargeLinesPathShape() {
        this.polyline = false;
        this.curveness = 0;
        this.segs = [];
    }
    return LargeLinesPathShape;
}();
var $f8dbaf3611e6e8be$var$LargeLinesPath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LargeLinesPath, _super);
    function LargeLinesPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeLinesPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeLinesPath.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $6aXXD.default).color.neutral99,
            fill: null
        };
    };
    LargeLinesPath.prototype.getDefaultShape = function() {
        return new $f8dbaf3611e6e8be$var$LargeLinesPathShape();
    };
    LargeLinesPath.prototype.buildPath = function(ctx, shape) {
        var segs = shape.segs;
        var curveness = shape.curveness;
        var i;
        if (shape.polyline) for(i = this._off; i < segs.length;){
            var count = segs[i++];
            if (count > 0) {
                ctx.moveTo(segs[i++], segs[i++]);
                for(var k = 1; k < count; k++)ctx.lineTo(segs[i++], segs[i++]);
            }
        }
        else for(i = this._off; i < segs.length;){
            var x0 = segs[i++];
            var y0 = segs[i++];
            var x1 = segs[i++];
            var y1 = segs[i++];
            ctx.moveTo(x0, y0);
            if (curveness > 0) {
                var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                ctx.quadraticCurveTo(x2, y2, x1, y1);
            } else ctx.lineTo(x1, y1);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeLinesPath.prototype.findDataIndex = function(x, y) {
        var shape = this.shape;
        var segs = shape.segs;
        var curveness = shape.curveness;
        var lineWidth = this.style.lineWidth;
        if (shape.polyline) {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var count = segs[i++];
                if (count > 0) {
                    var x0 = segs[i++];
                    var y0 = segs[i++];
                    for(var k = 1; k < count; k++){
                        var x1 = segs[i++];
                        var y1 = segs[i++];
                        if ($luMyO.containStroke(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                    }
                }
                dataIndex++;
            }
        } else {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var x0 = segs[i++];
                var y0 = segs[i++];
                var x1 = segs[i++];
                var y1 = segs[i++];
                if (curveness > 0) {
                    var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                    var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                    if ($bQJka.containStroke(x0, y0, x2, y2, x1, y1, lineWidth, x, y)) return dataIndex;
                } else {
                    if ($luMyO.containStroke(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                }
                dataIndex++;
            }
        }
        return -1;
    };
    LargeLinesPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeLinesPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.segs;
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $67W72.default(minX, minY, maxX, maxY);
        }
        return rect;
    };
    return LargeLinesPath;
}($4oDJM.default);
var $f8dbaf3611e6e8be$var$LargeLineDraw = /** @class */ function() {
    function LargeLineDraw() {
        this.group = new $iQonF.default();
    }
    /**
   * Update symbols draw by new data
   */ LargeLineDraw.prototype.updateData = function(data) {
        this._clear();
        var lineEl = this._create();
        lineEl.setShape({
            segs: data.getLayout('linesPoints')
        });
        this._setCommon(lineEl, data);
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalPrepareUpdate = function(data) {
        this.group.removeAll();
        this._clear();
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalUpdate = function(taskParams, data) {
        var lastAdded = this._newAdded[0];
        var linePoints = data.getLayout('linesPoints');
        var oldSegs = lastAdded && lastAdded.shape.segs;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldSegs && oldSegs.length < 2e4) {
            var oldLen = oldSegs.length;
            var newSegs = new Float32Array(oldLen + linePoints.length);
            // Concat two array
            newSegs.set(oldSegs);
            newSegs.set(linePoints, oldLen);
            lastAdded.setShape({
                segs: newSegs
            });
        } else {
            // Clear
            this._newAdded = [];
            var lineEl = this._create();
            lineEl.incremental = true;
            lineEl.setShape({
                segs: linePoints
            });
            this._setCommon(lineEl, data);
            lineEl.__startIndex = taskParams.start;
        }
    };
    /**
   * @override
   */ LargeLineDraw.prototype.remove = function() {
        this._clear();
    };
    LargeLineDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeLineDraw.prototype._create = function() {
        var lineEl = new $f8dbaf3611e6e8be$var$LargeLinesPath({
            cursor: 'default',
            ignoreCoarsePointer: true
        });
        this._newAdded.push(lineEl);
        this.group.add(lineEl);
        return lineEl;
    };
    LargeLineDraw.prototype._setCommon = function(lineEl, data, isIncremental) {
        var hostModel = data.hostModel;
        lineEl.setShape({
            polyline: hostModel.get('polyline'),
            curveness: hostModel.get([
                'lineStyle',
                'curveness'
            ])
        });
        lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
        lineEl.style.strokeNoScale = true;
        var style = data.getVisual('style');
        if (style && style.stroke) lineEl.setStyle('stroke', style.stroke);
        lineEl.setStyle('fill', null);
        var ecData = (0, $6TSUP.getECData)(lineEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        lineEl.on('mousemove', function(e) {
            ecData.dataIndex = null;
            var dataIndex = lineEl.hoverDataIdx;
            if (dataIndex > 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + lineEl.__startIndex;
        });
    };
    LargeLineDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeLineDraw;
}();
var $f8dbaf3611e6e8be$export$2e2bcd8739ae039 = $f8dbaf3611e6e8be$var$LargeLineDraw;

});

parcelRegister("g8p5n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbf0da326bbd8182$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 
var $Uomg7 = parcelRequire("Uomg7");

var $bbf0da326bbd8182$var$linesLayout = {
    seriesType: 'lines',
    plan: (0, $Uomg7.default)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var isPolyline = seriesModel.get('polyline');
        var isLarge = seriesModel.pipelineContext.large;
        return {
            progress: function(params, lineData) {
                var lineCoords = [];
                if (isLarge) {
                    var points = void 0;
                    var segCount = params.end - params.start;
                    if (isPolyline) {
                        var totalCoordsCount = 0;
                        for(var i = params.start; i < params.end; i++)totalCoordsCount += seriesModel.getLineCoordsCount(i);
                        points = new Float32Array(segCount + totalCoordsCount * 2);
                    } else points = new Float32Array(segCount * 4);
                    var offset = 0;
                    var pt = [];
                    for(var i = params.start; i < params.end; i++){
                        var len = seriesModel.getLineCoords(i, lineCoords);
                        if (isPolyline) points[offset++] = len;
                        for(var k = 0; k < len; k++){
                            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
                            points[offset++] = pt[0];
                            points[offset++] = pt[1];
                        }
                    }
                    lineData.setLayout('linesPoints', points);
                } else for(var i = params.start; i < params.end; i++){
                    var itemModel = lineData.getItemModel(i);
                    var len = seriesModel.getLineCoords(i, lineCoords);
                    var pts = [];
                    if (isPolyline) for(var j = 0; j < len; j++)pts.push(coordSys.dataToPoint(lineCoords[j]));
                    else {
                        pts[0] = coordSys.dataToPoint(lineCoords[0]);
                        pts[1] = coordSys.dataToPoint(lineCoords[1]);
                        var curveness = itemModel.get([
                            'lineStyle',
                            'curveness'
                        ]);
                        if (+curveness) pts[2] = [
                            (pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness,
                            (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness
                        ];
                    }
                    lineData.setItemLayout(i, pts);
                }
            }
        };
    }
};
var $bbf0da326bbd8182$export$2e2bcd8739ae039 = $bbf0da326bbd8182$var$linesLayout;

});


parcelRegister("jfqgp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e033ca77223058aa$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $2kN4z = parcelRequire("2kN4z");

var $2N6Uo = parcelRequire("2N6Uo");


var $5KdhI = parcelRequire("5KdhI");
var $e033ca77223058aa$var$Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
var $e033ca77223058aa$var$Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
function $e033ca77223058aa$var$compatEc2(seriesOpt) {
    var data = seriesOpt.data;
    if (data && data[0] && data[0][0] && data[0][0].coord) seriesOpt.data = (0, $2N6Uo.map)(data, function(itemOpt) {
        var coords = [
            itemOpt[0].coord,
            itemOpt[1].coord
        ];
        var target = {
            coords: coords
        };
        if (itemOpt[0].name) target.fromName = itemOpt[0].name;
        if (itemOpt[1].name) target.toName = itemOpt[1].name;
        return (0, $2N6Uo.mergeAll)([
            target,
            itemOpt[0],
            itemOpt[1]
        ]);
    });
}
var $e033ca77223058aa$var$LinesSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LinesSeriesModel, _super);
    function LinesSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesSeriesModel.type;
        _this.visualStyleAccessPath = 'lineStyle';
        _this.visualDrawType = 'stroke';
        return _this;
    }
    LinesSeriesModel.prototype.init = function(option) {
        // The input data may be null/undefined.
        option.data = option.data || [];
        // Not using preprocessor because mergeOption may not have series.type
        $e033ca77223058aa$var$compatEc2(option);
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        _super.prototype.init.apply(this, arguments);
    };
    LinesSeriesModel.prototype.mergeOption = function(option) {
        $e033ca77223058aa$var$compatEc2(option);
        if (option.data) {
            // Only update when have option data to merge.
            var result = this._processFlatCoordsArray(option.data);
            this._flatCoords = result.flatCoords;
            this._flatCoordsOffset = result.flatCoordsOffset;
            if (result.flatCoords) option.data = new Float32Array(result.count);
        }
        _super.prototype.mergeOption.apply(this, arguments);
    };
    LinesSeriesModel.prototype.appendData = function(params) {
        var result = this._processFlatCoordsArray(params.data);
        if (result.flatCoords) {
            if (!this._flatCoords) {
                this._flatCoords = result.flatCoords;
                this._flatCoordsOffset = result.flatCoordsOffset;
            } else {
                this._flatCoords = (0, $2N6Uo.concatArray)(this._flatCoords, result.flatCoords);
                this._flatCoordsOffset = (0, $2N6Uo.concatArray)(this._flatCoordsOffset, result.flatCoordsOffset);
            }
            params.data = new Float32Array(result.count);
        }
        this.getRawData().appendData(params.data);
    };
    LinesSeriesModel.prototype._getCoordsFromItemModel = function(idx) {
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
        return coords;
    };
    LinesSeriesModel.prototype.getLineCoordsCount = function(idx) {
        if (this._flatCoordsOffset) return this._flatCoordsOffset[idx * 2 + 1];
        else return this._getCoordsFromItemModel(idx).length;
    };
    LinesSeriesModel.prototype.getLineCoords = function(idx, out) {
        if (this._flatCoordsOffset) {
            var offset = this._flatCoordsOffset[idx * 2];
            var len = this._flatCoordsOffset[idx * 2 + 1];
            for(var i = 0; i < len; i++){
                out[i] = out[i] || [];
                out[i][0] = this._flatCoords[offset + i * 2];
                out[i][1] = this._flatCoords[offset + i * 2 + 1];
            }
            return len;
        } else {
            var coords = this._getCoordsFromItemModel(idx);
            for(var i = 0; i < coords.length; i++){
                out[i] = out[i] || [];
                out[i][0] = coords[i][0];
                out[i][1] = coords[i][1];
            }
            return coords.length;
        }
    };
    LinesSeriesModel.prototype._processFlatCoordsArray = function(data) {
        var startOffset = 0;
        if (this._flatCoords) startOffset = this._flatCoords.length;
        // Stored as a typed array. In format
        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
        if ((0, $2N6Uo.isNumber)(data[0])) {
            var len = data.length;
            // Store offset and len of each segment
            var coordsOffsetAndLenStorage = new $e033ca77223058aa$var$Uint32Arr(len);
            var coordsStorage = new $e033ca77223058aa$var$Float64Arr(len);
            var coordsCursor = 0;
            var offsetCursor = 0;
            var dataCount = 0;
            for(var i = 0; i < len;){
                dataCount++;
                var count = data[i++];
                // Offset
                coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset;
                // Len
                coordsOffsetAndLenStorage[offsetCursor++] = count;
                for(var k = 0; k < count; k++){
                    var x = data[i++];
                    var y = data[i++];
                    coordsStorage[coordsCursor++] = x;
                    coordsStorage[coordsCursor++] = y;
                }
            }
            return {
                flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
                flatCoords: coordsStorage,
                count: dataCount
            };
        }
        return {
            flatCoordsOffset: null,
            flatCoords: null,
            count: data.length
        };
    };
    LinesSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var CoordSys;
        var lineData = new (0, $2kN4z.default)([
            'value'
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    };
    LinesSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var itemModel = data.getItemModel(dataIndex);
        var name = itemModel.get('name');
        if (name) return name;
        var fromName = itemModel.get('fromName');
        var toName = itemModel.get('toName');
        var nameArr = [];
        fromName != null && nameArr.push(fromName);
        toName != null && nameArr.push(toName);
        return (0, $5KdhI.createTooltipMarkup)('nameValue', {
            name: nameArr.join(' > ')
        });
    };
    LinesSeriesModel.prototype.preventIncremental = function() {
        return !!this.get([
            'effect',
            'show'
        ]);
    };
    LinesSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) return this.option.large ? 1e4 : this.get('progressive');
        return progressive;
    };
    LinesSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) return this.option.large ? 2e4 : this.get('progressiveThreshold');
        return progressiveThreshold;
    };
    LinesSeriesModel.prototype.getZLevelKey = function() {
        var effectModel = this.getModel('effect');
        var trailLength = effectModel.get('trailLength');
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : effectModel.get('show') && trailLength > 0 ? trailLength + '' : '';
    };
    LinesSeriesModel.type = 'series.lines';
    LinesSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'calendar'
    ];
    LinesSeriesModel.defaultOption = {
        coordinateSystem: 'geo',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Cartesian coordinate system
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            10
        ],
        // Geo coordinate system
        geoIndex: 0,
        effect: {
            show: false,
            period: 4,
            constantSpeed: 0,
            symbol: 'circle',
            symbolSize: 3,
            loop: true,
            trailLength: 0.2
        },
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        polyline: false,
        clip: true,
        label: {
            show: false,
            position: 'end'
        },
        lineStyle: {
            opacity: 0.5
        }
    };
    return LinesSeriesModel;
}((0, $49X8G.default));
var $e033ca77223058aa$export$2e2bcd8739ae039 = $e033ca77223058aa$var$LinesSeriesModel;

});

parcelRegister("7LtoH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a73b9e1c1d7824c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $5a73b9e1c1d7824c$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
var $5a73b9e1c1d7824c$var$linesVisual = {
    seriesType: 'lines',
    reset: function(seriesModel) {
        var symbolType = $5a73b9e1c1d7824c$var$normalize(seriesModel.get('symbol'));
        var symbolSize = $5a73b9e1c1d7824c$var$normalize(seriesModel.get('symbolSize'));
        var data = seriesModel.getData();
        data.setVisual('fromSymbol', symbolType && symbolType[0]);
        data.setVisual('toSymbol', symbolType && symbolType[1]);
        data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
        data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var symbolType = $5a73b9e1c1d7824c$var$normalize(itemModel.getShallow('symbol', true));
            var symbolSize = $5a73b9e1c1d7824c$var$normalize(itemModel.getShallow('symbolSize', true));
            symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
            symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
            symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
            symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};
var $5a73b9e1c1d7824c$export$2e2bcd8739ae039 = $5a73b9e1c1d7824c$var$linesVisual;

});


parcelRegister("1O53J", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $150e629dbb87521e$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $kn8Vq = parcelRequire("kn8Vq");

var $e7sM1 = parcelRequire("e7sM1");

var $eCvlQ = parcelRequire("eCvlQ");

var $4snHY = parcelRequire("4snHY");

var $eHA3F = parcelRequire("eHA3F");

var $enNfu = parcelRequire("enNfu");
function $150e629dbb87521e$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $enNfu.install));
    registers.registerChartView((0, $kn8Vq.default));
    registers.registerSeriesModel((0, $e7sM1.default));
    registers.registerLayout((0, $4snHY.default));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $eCvlQ.default));
    (0, $eHA3F.createLegacyDataSelectAction)('map', registers.registerAction);
}

});
parcelRegister("kn8Vq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed4ce0f88de65f8b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");
parcelRequire("h9U3p");
var $6Utk3 = parcelRequire("6Utk3");

var $2K1nr = parcelRequire("2K1nr");

var $cWIrM = parcelRequire("cWIrM");

var $bysmE = parcelRequire("bysmE");

var $bwPbQ = parcelRequire("bwPbQ");
var $ed4ce0f88de65f8b$var$MapView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MapView, _super);
    function MapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapView.type;
        return _this;
    }
    MapView.prototype.render = function(mapModel, ecModel, api, payload) {
        // Not render if it is an toggleSelect action from self
        if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) return;
        var group = this.group;
        group.removeAll();
        if (mapModel.getHostGeoModel()) return;
        if (this._mapDraw && payload && payload.type === 'geoRoam') this._mapDraw.resetForLabelLayout();
        // Not update map if it is an roam action from self
        if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
            if (mapModel.needsDrawMap) {
                var mapDraw = this._mapDraw || new (0, $2K1nr.default)(api);
                group.add(mapDraw.group);
                mapDraw.draw(mapModel, ecModel, api, this, payload);
                this._mapDraw = mapDraw;
            } else {
                // Remove drawn map
                this._mapDraw && this._mapDraw.remove();
                this._mapDraw = null;
            }
        } else {
            var mapDraw = this._mapDraw;
            mapDraw && group.add(mapDraw.group);
        }
        mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
    };
    MapView.prototype.remove = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
        this.group.removeAll();
    };
    MapView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
    };
    MapView.prototype._renderSymbols = function(mapModel, ecModel, api) {
        var originalData = mapModel.originalData;
        var group = this.group;
        originalData.each(originalData.mapDimension('value'), function(value, originalDataIndex) {
            if (isNaN(value)) return;
            var layout = originalData.getItemLayout(originalDataIndex);
            if (!layout || !layout.point) // Not exists in map
            return;
            var point = layout.point;
            var offset = layout.offset;
            var circle = new $6Utk3.default({
                style: {
                    // Because the special of map draw.
                    // Which needs statistic of multiple series and draw on one map.
                    // And each series also need a symbol with legend color
                    //
                    // Layout and visual are put one the different data
                    // TODO
                    fill: mapModel.getData().getVisual('style').fill
                },
                shape: {
                    cx: point[0] + offset * 9,
                    cy: point[1],
                    r: 3
                },
                silent: true,
                // Do not overlap the first series, on which labels are displayed.
                z2: 8 + (!offset ? (0, $bwPbQ.Z2_EMPHASIS_LIFT) + 1 : 0)
            });
            // Only the series that has the first value on the same region is in charge of rendering the label.
            // But consider the case:
            // series: [
            //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
            //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
            // ]
            // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
            // For backward compatibility, we follow the rule that render label `A` by the
            // settings on series `X` but render label `C` by the settings on series `Y`.
            if (!offset) {
                var fullData = mapModel.mainSeries.getData();
                var name_1 = originalData.getName(originalDataIndex);
                var fullIndex_1 = fullData.indexOfName(name_1);
                var itemModel = originalData.getItemModel(originalDataIndex);
                var labelModel = itemModel.getModel('label');
                var regionGroup = fullData.getItemGraphicEl(fullIndex_1);
                // `getFormattedLabel` needs to use `getData` inside. Here
                // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
                // FIXME
                // If this is not the `mainSeries`, the item model (like label formatter)
                // set on original data item will never get. But it has been working
                // like that from the beginning, and this scenario is rarely encountered.
                // So it won't be fixed until we have to.
                (0, $bysmE.setLabelStyle)(circle, (0, $bysmE.getLabelStatesModels)(itemModel), {
                    labelFetcher: {
                        getFormattedLabel: function(idx, state) {
                            return mapModel.getFormattedLabel(fullIndex_1, state);
                        }
                    },
                    defaultText: name_1
                });
                circle.disableLabelAnimation = true;
                if (!labelModel.get('position')) circle.setTextConfig({
                    position: 'bottom'
                });
                regionGroup.onHoverStateChange = function(toState) {
                    (0, $bwPbQ.setStatesFlag)(circle, toState);
                };
            }
            group.add(circle);
        });
    };
    MapView.type = 'map';
    return MapView;
}((0, $cWIrM.default));
var $ed4ce0f88de65f8b$export$2e2bcd8739ae039 = $ed4ce0f88de65f8b$var$MapView;

});
parcelRegister("2K1nr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ff0f217f490ed7f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $ic6Qi = parcelRequire("ic6Qi");

var $kc4jZ = parcelRequire("kc4jZ");

var $5JZmf = parcelRequire("5JZmf");
var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $hXTRG = parcelRequire("hXTRG");
var $ewDYK = parcelRequire("ewDYK");
var $aH2k0 = parcelRequire("aH2k0");
var $h9U3p = parcelRequire("h9U3p");
var $ipprj = parcelRequire("ipprj");

var $bwPbQ = parcelRequire("bwPbQ");

var $LBjKB = parcelRequire("LBjKB");

var $cKPmR = parcelRequire("cKPmR");

var $bysmE = parcelRequire("bysmE");

var $6TSUP = parcelRequire("6TSUP");

var $9gUBZ = parcelRequire("9gUBZ");

var $6Ekel = parcelRequire("6Ekel");

var $bx3T8 = parcelRequire("bx3T8");
/**
 * Only these tags enable use `itemStyle` if they are named in SVG.
 * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
 * They will not be considered to be styled until some requirements come.
 */ var $1ff0f217f490ed7f$var$OPTION_STYLE_ENABLED_TAGS = [
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path'
];
var $1ff0f217f490ed7f$var$OPTION_STYLE_ENABLED_TAG_MAP = $2N6Uo.createHashMap($1ff0f217f490ed7f$var$OPTION_STYLE_ENABLED_TAGS);
var $1ff0f217f490ed7f$var$STATE_TRIGGER_TAG_MAP = $2N6Uo.createHashMap($1ff0f217f490ed7f$var$OPTION_STYLE_ENABLED_TAGS.concat([
    'g'
]));
var $1ff0f217f490ed7f$var$LABEL_HOST_MAP = $2N6Uo.createHashMap($1ff0f217f490ed7f$var$OPTION_STYLE_ENABLED_TAGS.concat([
    'g'
]));
var $1ff0f217f490ed7f$var$mapLabelRaw = (0, $bx3T8.makeInner)();
function $1ff0f217f490ed7f$var$getFixedItemStyle(model) {
    var itemStyle = model.getItemStyle();
    var areaColor = model.get('areaColor');
    // If user want the color not to be changed when hover,
    // they should both set areaColor and color to be null.
    if (areaColor != null) itemStyle.fill = areaColor;
    return itemStyle;
}
// Only stroke can be used for line.
// Using fill in style if stroke not exits.
// TODO Not sure yet. Perhaps a separate `lineStyle`?
function $1ff0f217f490ed7f$var$fixLineStyle(styleHost) {
    var style = styleHost.style;
    if (style) {
        style.stroke = style.stroke || style.fill;
        style.fill = null;
    }
}
var $1ff0f217f490ed7f$var$MapDraw = /** @class */ function() {
    function MapDraw(api) {
        var group = this.group = new $iQonF.default();
        var transformGroup = this._transformGroup = new $iQonF.default();
        group.add(transformGroup);
        this.uid = (0, $cKPmR.getUID)('ec_map_draw');
        this._controller = new (0, $ic6Qi.default)(api.getZr());
        this._controllerHost = {
            target: transformGroup
        };
        transformGroup.add(this._regionsGroup = new $iQonF.default());
        transformGroup.add(this._svgGroup = new $iQonF.default());
    }
    MapDraw.prototype.draw = function(mapOrGeoModel, ecModel, api, fromView, payload) {
        var isGeo = mapOrGeoModel.mainType === 'geo';
        // Map series has data. GEO model that controlled by map series
        // will be assigned with map data. Other GEO model has no data.
        var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
        isGeo && ecModel.eachComponent({
            mainType: 'series',
            subType: 'map'
        }, function(mapSeries) {
            if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) data = mapSeries.getData();
        });
        var geo = mapOrGeoModel.coordinateSystem;
        var regionsGroup = this._regionsGroup;
        var transformGroup = this._transformGroup;
        var transformInfo = geo.getTransformInfo();
        var transformInfoRaw = transformInfo.raw;
        var transformInfoRoam = transformInfo.roam;
        // No animation when first draw or in action
        var isFirstDraw = !regionsGroup.childAt(0) || payload;
        var clip = mapOrGeoModel.getShallow('clip', true);
        var clipRect;
        if (clip) {
            clipRect = geo.getViewRect().clone();
            this.group.setClipPath(new $aH2k0.default({
                shape: clipRect.clone()
            }));
        } else this.group.removeClipPath();
        if (isFirstDraw) {
            transformGroup.x = transformInfoRoam.x;
            transformGroup.y = transformInfoRoam.y;
            transformGroup.scaleX = transformInfoRoam.scaleX;
            transformGroup.scaleY = transformInfoRoam.scaleY;
            transformGroup.dirty();
        } else $ipprj.updateProps(transformGroup, transformInfoRoam, mapOrGeoModel);
        var isVisualEncodedByVisualMap = data && data.getVisual('visualMeta') && data.getVisual('visualMeta').length > 0;
        var viewBuildCtx = {
            api: api,
            geo: geo,
            mapOrGeoModel: mapOrGeoModel,
            data: data,
            isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
            isGeo: isGeo,
            transformInfoRaw: transformInfoRaw
        };
        if (geo.resourceType === 'geoJSON') this._buildGeoJSON(viewBuildCtx);
        else if (geo.resourceType === 'geoSVG') this._buildSVG(viewBuildCtx);
        this._updateController(mapOrGeoModel, clipRect, ecModel, api);
        this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
    };
    MapDraw.prototype._buildGeoJSON = function(viewBuildCtx) {
        var regionsGroupByName = this._regionsGroupByName = $2N6Uo.createHashMap();
        var regionsInfoByName = $2N6Uo.createHashMap();
        var regionsGroup = this._regionsGroup;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
        var data = viewBuildCtx.data;
        var projection = viewBuildCtx.geo.projection;
        var projectionStream = projection && projection.stream;
        function transformPoint(point, project) {
            if (project) // projection may return null point.
            point = project(point);
            return point && [
                point[0] * transformInfoRaw.scaleX + transformInfoRaw.x,
                point[1] * transformInfoRaw.scaleY + transformInfoRaw.y
            ];
        }
        function transformPolygonPoints(inPoints) {
            var outPoints = [];
            // If projectionStream is provided. Use it instead of single point project.
            var project = !projectionStream && projection && projection.project;
            for(var i = 0; i < inPoints.length; ++i){
                var newPt = transformPoint(inPoints[i], project);
                newPt && outPoints.push(newPt);
            }
            return outPoints;
        }
        function getPolyShape(points) {
            return {
                shape: {
                    points: transformPolygonPoints(points)
                }
            };
        }
        regionsGroup.removeAll();
        // Only when the resource is GeoJSON, there is `geo.regions`.
        $2N6Uo.each(viewBuildCtx.geo.regions, function(region) {
            var regionName = region.name;
            // Consider in GeoJson properties.name may be duplicated, for example,
            // there is multiple region named "United Kindom" or "France" (so many
            // colonies). And it is not appropriate to merge them in geo, which
            // will make them share the same label and bring trouble in label
            // location calculation.
            var regionGroup = regionsGroupByName.get(regionName);
            var _a = regionsInfoByName.get(regionName) || {}, dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            if (!regionGroup) {
                regionGroup = regionsGroupByName.set(regionName, new $iQonF.default());
                regionsGroup.add(regionGroup);
                dataIdx = data ? data.indexOfName(regionName) : null;
                regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
                var silent = regionModel.get('silent', true);
                silent != null && (regionGroup.silent = silent);
                regionsInfoByName.set(regionName, {
                    dataIdx: dataIdx,
                    regionModel: regionModel
                });
            }
            var polygonSubpaths = [];
            var polylineSubpaths = [];
            $2N6Uo.each(region.geometries, function(geometry) {
                // Polygon and MultiPolygon
                if (geometry.type === 'polygon') {
                    var polys = [
                        geometry.exterior
                    ].concat(geometry.interiors || []);
                    if (projectionStream) polys = $1ff0f217f490ed7f$var$projectPolys(polys, projectionStream);
                    $2N6Uo.each(polys, function(poly) {
                        polygonSubpaths.push(new $hXTRG.default(getPolyShape(poly)));
                    });
                } else {
                    var points = geometry.points;
                    if (projectionStream) points = $1ff0f217f490ed7f$var$projectPolys(points, projectionStream, true);
                    $2N6Uo.each(points, function(points) {
                        polylineSubpaths.push(new $ewDYK.default(getPolyShape(points)));
                    });
                }
            });
            var centerPt = transformPoint(region.getCenter(), projection && projection.project);
            function createCompoundPath(subpaths, isLine) {
                if (!subpaths.length) return;
                var compoundPath = new $5JZmf.default({
                    culling: true,
                    segmentIgnoreThreshold: 1,
                    shape: {
                        paths: subpaths
                    }
                });
                regionGroup.add(compoundPath);
                $1ff0f217f490ed7f$var$applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
                $1ff0f217f490ed7f$var$resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);
                if (isLine) {
                    $1ff0f217f490ed7f$var$fixLineStyle(compoundPath);
                    $2N6Uo.each(compoundPath.states, $1ff0f217f490ed7f$var$fixLineStyle);
                }
            }
            createCompoundPath(polygonSubpaths);
            createCompoundPath(polylineSubpaths, true);
        });
        // Ensure children have been added to `regionGroup` before calling them.
        regionsGroupByName.each(function(regionGroup, regionName) {
            var _a = regionsInfoByName.get(regionName), dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            $1ff0f217f490ed7f$var$resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
            $1ff0f217f490ed7f$var$resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
            $1ff0f217f490ed7f$var$resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
        }, this);
    };
    MapDraw.prototype._buildSVG = function(viewBuildCtx) {
        var mapName = viewBuildCtx.geo.map;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        this._svgGroup.x = transformInfoRaw.x;
        this._svgGroup.y = transformInfoRaw.y;
        this._svgGroup.scaleX = transformInfoRaw.scaleX;
        this._svgGroup.scaleY = transformInfoRaw.scaleY;
        if (this._svgResourceChanged(mapName)) {
            this._freeSVG();
            this._useSVG(mapName);
        }
        var svgDispatcherMap = this._svgDispatcherMap = $2N6Uo.createHashMap();
        var focusSelf = false;
        $2N6Uo.each(this._svgGraphicRecord.named, function(namedItem) {
            // Note that we also allow different elements have the same name.
            // For example, a glyph of a city and the label of the city have
            // the same name and their tooltip info can be defined in a single
            // region option.
            var regionName = namedItem.name;
            var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
            var data = viewBuildCtx.data;
            var svgNodeTagLower = namedItem.svgNodeTagLower;
            var el = namedItem.el;
            var dataIdx = data ? data.indexOfName(regionName) : null;
            var regionModel = mapOrGeoModel.getRegionModel(regionName);
            if ($1ff0f217f490ed7f$var$OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof (0, $6Ekel.default)) $1ff0f217f490ed7f$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
            if (el instanceof (0, $6Ekel.default)) el.culling = true;
            var silent = regionModel.get('silent', true);
            silent != null && (el.silent = silent);
            // We do not know how the SVG like so we'd better not to change z2.
            // Otherwise it might bring some unexpected result. For example,
            // an area hovered that make some inner city can not be clicked.
            el.z2EmphasisLift = 0;
            // If self named:
            if (!namedItem.namedFrom) {
                // label should batter to be displayed based on the center of <g>
                // if it is named rather than displayed on each child.
                if ($1ff0f217f490ed7f$var$LABEL_HOST_MAP.get(svgNodeTagLower) != null) $1ff0f217f490ed7f$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
                $1ff0f217f490ed7f$var$resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
                $1ff0f217f490ed7f$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                if ($1ff0f217f490ed7f$var$STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
                    var focus_1 = $1ff0f217f490ed7f$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                    if (focus_1 === 'self') focusSelf = true;
                    var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
                    els.push(el);
                }
            }
        }, this);
        this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
    };
    MapDraw.prototype._enableBlurEntireSVG = function(focusSelf, viewBuildCtx) {
        // It's a little complicated to support blurring the entire geoSVG in series-map.
        // So do not support it until some requirements come.
        // At present, in series-map, only regions can be blurred.
        if (focusSelf && viewBuildCtx.isGeo) {
            var blurStyle = viewBuildCtx.mapOrGeoModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            // Only support `opacity` here. Because not sure that other props are suitable for
            // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).
            var opacity_1 = blurStyle.opacity;
            this._svgGraphicRecord.root.traverse(function(el) {
                if (!el.isGroup) {
                    // PENDING: clear those settings to SVG elements when `_freeSVG`.
                    // (Currently it happen not to be needed.)
                    (0, $bwPbQ.setDefaultStateProxy)(el);
                    var style = el.ensureState('blur').style || {};
                    // Do not overwrite the region style that already set from region option.
                    if (style.opacity == null && opacity_1 != null) style.opacity = opacity_1;
                    // If `ensureState('blur').style = {}`, there will be default opacity.
                    // Enable `stateTransition` (animation).
                    el.ensureState('emphasis');
                }
            });
        }
    };
    MapDraw.prototype.remove = function() {
        this._regionsGroup.removeAll();
        this._regionsGroupByName = null;
        this._svgGroup.removeAll();
        this._freeSVG();
        this._controller.dispose();
        this._controllerHost = null;
    };
    MapDraw.prototype.findHighDownDispatchers = function(name, geoModel) {
        if (name == null) return [];
        var geo = geoModel.coordinateSystem;
        if (geo.resourceType === 'geoJSON') {
            var regionsGroupByName = this._regionsGroupByName;
            if (regionsGroupByName) {
                var regionGroup = regionsGroupByName.get(name);
                return regionGroup ? [
                    regionGroup
                ] : [];
            }
        } else if (geo.resourceType === 'geoSVG') return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
    };
    MapDraw.prototype._svgResourceChanged = function(mapName) {
        return this._svgMapName !== mapName;
    };
    MapDraw.prototype._useSVG = function(mapName) {
        var resource = (0, $LBjKB.default).getGeoResource(mapName);
        if (resource && resource.type === 'geoSVG') {
            var svgGraphic = resource.useGraphic(this.uid);
            this._svgGroup.add(svgGraphic.root);
            this._svgGraphicRecord = svgGraphic;
            this._svgMapName = mapName;
        }
    };
    MapDraw.prototype._freeSVG = function() {
        var mapName = this._svgMapName;
        if (mapName == null) return;
        var resource = (0, $LBjKB.default).getGeoResource(mapName);
        if (resource && resource.type === 'geoSVG') resource.freeGraphic(this.uid);
        this._svgGraphicRecord = null;
        this._svgDispatcherMap = null;
        this._svgGroup.removeAll();
        this._svgMapName = null;
    };
    MapDraw.prototype._updateController = function(mapOrGeoModel, clipRect, ecModel, api) {
        var geo = mapOrGeoModel.coordinateSystem;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
        controllerHost.zoom = geo.getZoom();
        // roamType is will be set default true if it is null
        controller.enable(mapOrGeoModel.get('roam') || false, {
            api: api,
            zInfo: {
                component: mapOrGeoModel
            },
            triggerInfo: {
                roamTrigger: mapOrGeoModel.get('roamTrigger'),
                isInSelf: function(e, x, y) {
                    return geo.containPoint([
                        x,
                        y
                    ]);
                },
                isInClip: function(e, x, y) {
                    return !clipRect || clipRect.contain(x, y);
                }
            }
        });
        var mainType = mapOrGeoModel.mainType;
        function makeActionBase() {
            var action = {
                type: 'geoRoam',
                componentType: mainType
            };
            action[mainType + 'Id'] = mapOrGeoModel.id;
            return action;
        }
        controller.off('pan').on('pan', function(e) {
            this._mouseDownFlag = false;
            $kc4jZ.updateViewOnPan(controllerHost, e.dx, e.dy);
            api.dispatchAction($2N6Uo.extend(makeActionBase(), {
                dx: e.dx,
                dy: e.dy,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.off('zoom').on('zoom', function(e) {
            this._mouseDownFlag = false;
            $kc4jZ.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction($2N6Uo.extend(makeActionBase(), {
                totalZoom: controllerHost.zoom,
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY,
                animation: {
                    duration: 0
                }
            }));
        }, this);
    };
    /**
   * FIXME: this is a temporarily workaround.
   * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
   * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
   * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
   * props will have no chance to be restored.
   * Note: This reset should be after `clearStates` in `renderSeries` because `useStates` in
   * `renderSeries` will cache the modified `ignore` to `el._normalState`.
   * TODO:
   * Use clone/immutable in `LabelManager`?
   */ MapDraw.prototype.resetForLabelLayout = function() {
        this.group.traverse(function(el) {
            var label = el.getTextContent();
            if (label) label.ignore = $1ff0f217f490ed7f$var$mapLabelRaw(label).ignore;
        });
    };
    MapDraw.prototype._updateMapSelectHandler = function(mapOrGeoModel, regionsGroup, api, fromView) {
        var mapDraw = this;
        regionsGroup.off('mousedown');
        regionsGroup.off('click');
        // @ts-ignore FIXME:TS resolve type conflict
        if (mapOrGeoModel.get('selectedMode')) {
            regionsGroup.on('mousedown', function() {
                mapDraw._mouseDownFlag = true;
            });
            regionsGroup.on('click', function(e) {
                if (!mapDraw._mouseDownFlag) return;
                mapDraw._mouseDownFlag = false;
            });
        }
    };
    return MapDraw;
}();
function $1ff0f217f490ed7f$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
    // All of the path are using `itemStyle`, because
    // (1) Some SVG also use fill on polyline (The different between
    // polyline and polygon is "open" or "close" but not fill or not).
    // (2) For the common props like opacity, if some use itemStyle
    // and some use `lineStyle`, it might confuse users.
    // (3) Most SVG use <path>, where can not detect whether to draw a "line"
    // or a filled shape, so use `itemStyle` for <path>.
    var normalStyleModel = regionModel.getModel('itemStyle');
    var emphasisStyleModel = regionModel.getModel([
        'emphasis',
        'itemStyle'
    ]);
    var blurStyleModel = regionModel.getModel([
        'blur',
        'itemStyle'
    ]);
    var selectStyleModel = regionModel.getModel([
        'select',
        'itemStyle'
    ]);
    // NOTE: DON'T use 'style' in visual when drawing map.
    // This component is used for drawing underlying map for both geo component and map series.
    var normalStyle = $1ff0f217f490ed7f$var$getFixedItemStyle(normalStyleModel);
    var emphasisStyle = $1ff0f217f490ed7f$var$getFixedItemStyle(emphasisStyleModel);
    var selectStyle = $1ff0f217f490ed7f$var$getFixedItemStyle(selectStyleModel);
    var blurStyle = $1ff0f217f490ed7f$var$getFixedItemStyle(blurStyleModel);
    // Update the itemStyle if has data visual
    var data = viewBuildCtx.data;
    if (data) {
        // Only visual color of each item will be used. It can be encoded by visualMap
        // But visual color of series is used in symbol drawing
        // Visual color for each series is for the symbol draw
        var style = data.getItemVisual(dataIndex, 'style');
        var decal = data.getItemVisual(dataIndex, 'decal');
        if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) normalStyle.fill = style.fill;
        if (decal) normalStyle.decal = (0, $9gUBZ.createOrUpdatePatternFromDecal)(decal, viewBuildCtx.api);
    }
    // SVG text, tspan and image can be named but not supporeted
    // to be styled by region option yet.
    el.setStyle(normalStyle);
    el.style.strokeNoScale = true;
    el.ensureState('emphasis').style = emphasisStyle;
    el.ensureState('select').style = selectStyle;
    el.ensureState('blur').style = blurStyle;
    // Enable blur
    (0, $bwPbQ.setDefaultStateProxy)(el);
}
function $1ff0f217f490ed7f$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
labelXY) {
    var data = viewBuildCtx.data;
    var isGeo = viewBuildCtx.isGeo;
    var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
    var itemLayout = data && data.getItemLayout(dataIdx);
    // In the following cases label will be drawn
    // 1. In map series and data value is NaN
    // 2. In geo component
    // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout
    if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
        var query = !isGeo ? dataIdx : regionName;
        var labelFetcher = void 0;
        // Consider dataIdx not found.
        if (!data || dataIdx >= 0) labelFetcher = mapOrGeoModel;
        var specifiedTextOpt = labelXY ? {
            normal: {
                align: 'center',
                verticalAlign: 'middle'
            }
        } : null;
        // Caveat: must be called after `setDefaultStateProxy(el);` called.
        // because textContent will be assign with `el.stateProxy` inside.
        (0, $bysmE.setLabelStyle)(el, (0, $bysmE.getLabelStatesModels)(regionModel), {
            labelFetcher: labelFetcher,
            labelDataIndex: query,
            defaultText: regionName
        }, specifiedTextOpt);
        var textEl = el.getTextContent();
        if (textEl) {
            $1ff0f217f490ed7f$var$mapLabelRaw(textEl).ignore = textEl.ignore;
            if (el.textConfig && labelXY) {
                // Compute a relative offset based on the el bounding rect.
                var rect = el.getBoundingRect().clone();
                // Need to make sure the percent position base on the same rect in normal and
                // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
                // has borderWidth (even 0.5px), the text position will be changed obviously
                // if the position is very big like ['1234%', '1345%'].
                el.textConfig.layoutRect = rect;
                el.textConfig.position = [
                    (labelXY[0] - rect.x) / rect.width * 100 + '%',
                    (labelXY[1] - rect.y) / rect.height * 100 + '%'
                ];
            }
        }
        // PENDING:
        // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
        // But el.dataIndex is also used to determine whether user event should be triggered,
        // where el.seriesIndex or el.dataModel must be specified. At present for a single el
        // there is not case that "only label layout enabled but user event disabled", so here
        // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.
        el.disableLabelAnimation = true;
    } else {
        el.removeTextContent();
        el.removeTextConfig();
        el.disableLabelAnimation = null;
    }
}
function $1ff0f217f490ed7f$var$resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx) {
    // setItemGraphicEl, setHoverStyle after all polygons and labels
    // are added to the regionGroup
    if (viewBuildCtx.data) // FIXME: when series-map use a SVG map, and there are duplicated name specified
    // on different SVG elements, after `data.setItemGraphicEl(...)`:
    // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
    // can be triggered only mouse hover. That's correct.
    // (2) only the last element will be kept in `data`, so that if trigger tooltip
    // by `dispatchAction`, only the last one can be found and triggered. That might be
    // not correct. We will fix it in future if anyone demanding that.
    viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
    else // Package custom mouse event for geo component
    (0, $6TSUP.getECData)(eventTrigger).eventData = {
        componentType: 'geo',
        componentIndex: mapOrGeoModel.componentIndex,
        geoIndex: mapOrGeoModel.componentIndex,
        name: regionName,
        region: regionModel && regionModel.option || {}
    };
}
function $1ff0f217f490ed7f$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    if (!viewBuildCtx.data) $h9U3p.setTooltipConfig({
        el: el,
        componentModel: mapOrGeoModel,
        itemName: regionName,
        // @ts-ignore FIXME:TS fix the "compatible with each other"?
        itemTooltipOption: regionModel.get('tooltip')
    });
}
function $1ff0f217f490ed7f$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    el.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode');
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    var emphasisModel = regionModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    (0, $bwPbQ.toggleHoverEmphasis)(el, focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    if (viewBuildCtx.isGeo) (0, $bwPbQ.enableComponentHighDownFeatures)(el, mapOrGeoModel, regionName);
    return focus;
}
function $1ff0f217f490ed7f$var$projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
createStream, isLine) {
    var polygons = [];
    var curPoly;
    function startPolygon() {
        curPoly = [];
    }
    function endPolygon() {
        if (curPoly.length) {
            polygons.push(curPoly);
            curPoly = [];
        }
    }
    var stream = createStream({
        polygonStart: startPolygon,
        polygonEnd: endPolygon,
        lineStart: startPolygon,
        lineEnd: endPolygon,
        point: function(x, y) {
            // May have NaN values from stream.
            if (isFinite(x) && isFinite(y)) curPoly.push([
                x,
                y
            ]);
        },
        sphere: function() {}
    });
    !isLine && stream.polygonStart();
    $2N6Uo.each(rings, function(ring) {
        stream.lineStart();
        for(var i = 0; i < ring.length; i++)stream.point(ring[i][0], ring[i][1]);
        stream.lineEnd();
    });
    !isLine && stream.polygonEnd();
    return polygons;
}
var $1ff0f217f490ed7f$export$2e2bcd8739ae039 // @ts-ignore FIXME:TS fix the "compatible with each other"?
 = $1ff0f217f490ed7f$var$MapDraw;

});
parcelRegister("LBjKB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08f1566429414eb7$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $2kYsT = parcelRequire("2kYsT");

var $6G4e1 = parcelRequire("6G4e1");
var $08f1566429414eb7$var$storage = (0, $2N6Uo.createHashMap)();
var $08f1566429414eb7$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $2kYsT.GeoSVGResource)(mapName, rawDef.svg);
            $08f1566429414eb7$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $6G4e1.GeoJSONResource)(mapName, geoJSON, rawSpecialAreas);
            $08f1566429414eb7$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $08f1566429414eb7$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $08f1566429414eb7$var$storage.get(mapName);
        // Do not support return SVG until some real requirement come.
        return resource && resource.type === 'geoJSON' && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $08f1566429414eb7$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};

});
parcelRegister("2kYsT", function(module, exports) {

$parcel$export(module.exports, "GeoSVGResource", function () { return $1b3c5a1ecc8f4055$export$be52c950efae1f84; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9aqjt = parcelRequire("9aqjt");

var $iQonF = parcelRequire("iQonF");

var $aH2k0 = parcelRequire("aH2k0");

var $2N6Uo = parcelRequire("2N6Uo");

var $67W72 = parcelRequire("67W72");

var $2eSva = parcelRequire("2eSva");

var $1oUQf = parcelRequire("1oUQf");
/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $1b3c5a1ecc8f4055$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $2N6Uo.createHashMap)([
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path',
    // <text> <tspan> are also enabled because some SVG might paint text itself,
    // but still need to trigger events or tooltip.
    'text',
    'tspan',
    // <g> is also enabled because this case: if multiple tags share one name
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    'g'
]);
var $1b3c5a1ecc8f4055$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = 'geoSVG';
        // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $2N6Uo.createHashMap)();
        // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName;
        // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $2eSva.parseXML)(svg);
    }
    GeoSVGResource.prototype.load = function() {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic;
        // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone();
            // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $1b3c5a1ecc8f4055$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $9aqjt.parseSVG)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $2N6Uo.assert)(rootFromParse != null);
        } catch (e) {
            throw new Error('Invalid svg format\n' + e.message);
        }
        // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $iQonF.default)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true;
        // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only support `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            }
            // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $67W72.default)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $9aqjt.makeViewBoxTransform)(viewBoxRect, boundingRect);
            // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        }
        // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $aH2k0.default)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $2N6Uo.each)(result.named, function(namedItem) {
            if ($1b3c5a1ecc8f4055$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $1b3c5a1ecc8f4055$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey /* , nameMap: NameMap */ ) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic);
        // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $1b3c5a1ecc8f4055$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false;
    // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $1b3c5a1ecc8f4055$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $2N6Uo.createHashMap)();
    // Create resions only for the first graphic.
    (0, $2N6Uo.each)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $1oUQf.GeoSVGRegion)(namedItem.name, namedItem.el);
        // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region);
        // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }

});
parcelRegister("9aqjt", function(module, exports) {

$parcel$export(module.exports, "makeViewBoxTransform", function () { return $6ac975791587c2be$export$3e2db4420f14f50f; });
$parcel$export(module.exports, "parseSVG", function () { return $6ac975791587c2be$export$1919f5101c220601; });

var $iQonF = parcelRequire("iQonF");

var $lQsZt = parcelRequire("lQsZt");

var $6Utk3 = parcelRequire("6Utk3");

var $aH2k0 = parcelRequire("aH2k0");

var $3jYPd = parcelRequire("3jYPd");

var $c3CaY = parcelRequire("c3CaY");

var $hXTRG = parcelRequire("hXTRG");

var $ewDYK = parcelRequire("ewDYK");

var $19Ywy = parcelRequire("19Ywy");

var $hI0Jj = parcelRequire("hI0Jj");

var $2N6Uo = parcelRequire("2N6Uo");

var $ftfXE = parcelRequire("ftfXE");

var $fv6es = parcelRequire("fv6es");

var $arPnl = parcelRequire("arPnl");

var $2eSva = parcelRequire("2eSva");

var $3UxDF = parcelRequire("3UxDF");
var $6ac975791587c2be$var$nodeParsers;
var $6ac975791587c2be$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var $6ac975791587c2be$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $2N6Uo.keys)($6ac975791587c2be$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $6ac975791587c2be$var$SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var $6ac975791587c2be$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $2N6Uo.keys)($6ac975791587c2be$var$SELF_STYLE_ATTRIBUTES_MAP);
var $6ac975791587c2be$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $2eSva.parseXML)(xml);
        this._defsUsePending = [];
        var root = new (0, $iQonF.default)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat(svg.getAttribute('width') || opt.width);
        var height = parseFloat(svg.getAttribute('height') || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $6ac975791587c2be$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $6ac975791587c2be$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $6ac975791587c2be$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $6ac975791587c2be$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $iQonF.default)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $aH2k0.default)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') isInDefs = true;
        if (nodeName === 'text') isInText = true;
        if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $6ac975791587c2be$var$nodeParsers[nodeName];
                if (parser_1 && (0, $2N6Uo.hasOwn)($6ac975791587c2be$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $6ac975791587c2be$var$paintServerParsers[nodeName];
            if (parser && (0, $2N6Uo.hasOwn)($6ac975791587c2be$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $arPnl.default)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $6ac975791587c2be$var$inheritStyle(parentGroup, text);
        $6ac975791587c2be$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $6ac975791587c2be$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $6ac975791587c2be$var$nodeParsers = {
            'g': function(xmlNode, parentGroup) {
                var g = new (0, $iQonF.default)();
                $6ac975791587c2be$var$inheritStyle(parentGroup, g);
                $6ac975791587c2be$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function(xmlNode, parentGroup) {
                var rect = new (0, $aH2k0.default)();
                $6ac975791587c2be$var$inheritStyle(parentGroup, rect);
                $6ac975791587c2be$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function(xmlNode, parentGroup) {
                var circle = new (0, $6Utk3.default)();
                $6ac975791587c2be$var$inheritStyle(parentGroup, circle);
                $6ac975791587c2be$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function(xmlNode, parentGroup) {
                var line = new (0, $c3CaY.default)();
                $6ac975791587c2be$var$inheritStyle(parentGroup, line);
                $6ac975791587c2be$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function(xmlNode, parentGroup) {
                var ellipse = new (0, $3jYPd.default)();
                $6ac975791587c2be$var$inheritStyle(parentGroup, ellipse);
                $6ac975791587c2be$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $6ac975791587c2be$var$parsePoints(pointsStr);
                var polygon = new (0, $hXTRG.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $6ac975791587c2be$var$inheritStyle(parentGroup, polygon);
                $6ac975791587c2be$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $6ac975791587c2be$var$parsePoints(pointsStr);
                var polyline = new (0, $ewDYK.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $6ac975791587c2be$var$inheritStyle(parentGroup, polyline);
                $6ac975791587c2be$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function(xmlNode, parentGroup) {
                var img = new (0, $lQsZt.default)();
                $6ac975791587c2be$var$inheritStyle(parentGroup, img);
                $6ac975791587c2be$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $iQonF.default)();
                $6ac975791587c2be$var$inheritStyle(parentGroup, g);
                $6ac975791587c2be$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new (0, $iQonF.default)();
                $6ac975791587c2be$var$inheritStyle(parentGroup, g);
                $6ac975791587c2be$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = (0, $hI0Jj.createFromString)(d);
                $6ac975791587c2be$var$inheritStyle(parentGroup, path);
                $6ac975791587c2be$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $6ac975791587c2be$var$paintServerParsers = {
    'lineargradient': function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new (0, $ftfXE.default)(x1, y1, x2, y2);
        $6ac975791587c2be$var$parsePaintServerUnit(xmlNode, gradient);
        $6ac975791587c2be$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new (0, $fv6es.default)(cx, cy, r);
        $6ac975791587c2be$var$parsePaintServerUnit(xmlNode, gradient);
        $6ac975791587c2be$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $6ac975791587c2be$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
}
function $6ac975791587c2be$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $6ac975791587c2be$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
            var stopOpacity = styleVals.stopOpacity || stop.getAttribute('stop-opacity');
            if (stopOpacity) {
                var rgba = $3UxDF.parse(stopColor);
                var stopColorOpacity = rgba && rgba[3];
                if (stopColorOpacity) {
                    rgba[3] *= $3UxDF.parseCssFloat(stopOpacity);
                    stopColor = $3UxDF.stringify(rgba, 'rgba');
                }
            }
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $6ac975791587c2be$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $2N6Uo.defaults)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $6ac975791587c2be$var$parsePoints(pointsString) {
    var list = $6ac975791587c2be$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $6ac975791587c2be$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $6ac975791587c2be$var$parseTransformAttribute(xmlNode, el);
        $6ac975791587c2be$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $6ac975791587c2be$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $6ac975791587c2be$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $6ac975791587c2be$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    (0, $2N6Uo.each)([
        'lineWidth',
        'opacity',
        'fillOpacity',
        'strokeOpacity',
        'miterLimit',
        'fontSize'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $2N6Uo.each)([
        'lineDashOffset',
        'lineCap',
        'lineJoin',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'textAlign'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $2N6Uo.map)($6ac975791587c2be$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
    if (inheritedStyle.display === 'none') disp.ignore = true;
}
function $6ac975791587c2be$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
        else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') zrTextAlign = 'center';
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $6ac975791587c2be$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $6ac975791587c2be$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($6ac975791587c2be$var$urlRegex);
    if (urlMatch) {
        var url = (0, $2N6Uo.trim)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === 'none') str = null;
    return str;
}
function $6ac975791587c2be$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $6ac975791587c2be$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $6ac975791587c2be$var$splitNumberSequence(rawStr) {
    return rawStr.match($6ac975791587c2be$var$numberReg) || [];
}
var $6ac975791587c2be$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $6ac975791587c2be$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $6ac975791587c2be$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace($6ac975791587c2be$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $6ac975791587c2be$var$splitNumberSequence(value);
            mt = mt || $19Ywy.create();
            switch(type){
                case 'translate':
                    $19Ywy.translate(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || '0')
                    ]);
                    break;
                case 'scale':
                    $19Ywy.scale(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case 'rotate':
                    $19Ywy.rotate(mt, mt, -parseFloat(valueArr[0]) * $6ac975791587c2be$var$DEGREE_TO_ANGLE, [
                        parseFloat(valueArr[1] || '0'),
                        parseFloat(valueArr[2] || '0')
                    ]);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * $6ac975791587c2be$var$DEGREE_TO_ANGLE);
                    $19Ywy.mul(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * $6ac975791587c2be$var$DEGREE_TO_ANGLE);
                    $19Ywy.mul(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $6ac975791587c2be$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $6ac975791587c2be$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) return;
    $6ac975791587c2be$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $6ac975791587c2be$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $2N6Uo.hasOwn)($6ac975791587c2be$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $6ac975791587c2be$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $2N6Uo.hasOwn)($6ac975791587c2be$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $6ac975791587c2be$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $6ac975791587c2be$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $6ac975791587c2be$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $6ac975791587c2be$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$6ac975791587c2be$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $6ac975791587c2be$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $6ac975791587c2be$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$6ac975791587c2be$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $6ac975791587c2be$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $6ac975791587c2be$export$1919f5101c220601(xml, opt) {
    var parser = new $6ac975791587c2be$var$SVGParser();
    return parser.parse(xml, opt);
}

});
parcelRegister("2eSva", function(module, exports) {

$parcel$export(module.exports, "parseXML", function () { return $1a172a7df549a598$export$eacefc55fad2867e; });

var $2N6Uo = parcelRequire("2N6Uo");
function $1a172a7df549a598$export$eacefc55fad2867e(svg) {
    if ((0, $2N6Uo.isString)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}

});


parcelRegister("1oUQf", function(module, exports) {

$parcel$export(module.exports, "GeoJSONPolygonGeometry", function () { return $10541fe5c8356d7f$export$91e20b0f72443753; });
$parcel$export(module.exports, "GeoJSONLineStringGeometry", function () { return $10541fe5c8356d7f$export$335807c9e785d92c; });
$parcel$export(module.exports, "GeoJSONRegion", function () { return $10541fe5c8356d7f$export$ee84fcb463f24b3d; });
$parcel$export(module.exports, "GeoSVGRegion", function () { return $10541fe5c8356d7f$export$5f3d89e7254f3e69; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $67W72 = parcelRequire("67W72");

var $U1aqY = parcelRequire("U1aqY");

var $96Kkt = parcelRequire("96Kkt");

var $19Ywy = parcelRequire("19Ywy");

var $2N6Uo = parcelRequire("2N6Uo");
var $10541fe5c8356d7f$var$TMP_TRANSFORM = [];
function $10541fe5c8356d7f$var$transformPoints(points, transform) {
    for(var p = 0; p < points.length; p++)$U1aqY.applyTransform(points[p], points[p], transform);
}
function $10541fe5c8356d7f$var$updateBBoxFromPoints(points, min, max, projection) {
    for(var i = 0; i < points.length; i++){
        var p = points[i];
        if (projection) // projection may return null point.
        p = projection.project(p);
        if (p && isFinite(p[0]) && isFinite(p[1])) {
            $U1aqY.min(min, min, p);
            $U1aqY.max(max, max, p);
        }
    }
}
function $10541fe5c8356d7f$var$centroid(points) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = points.length;
    var x0 = points[len - 1][0];
    var y0 = points[len - 1][1];
    // Polygon should been closed.
    for(var i = 0; i < len; i++){
        var x1 = points[i][0];
        var y1 = points[i][1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
        x0 = x1;
        y0 = y1;
    }
    return signedArea ? [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ] : [
        points[0][0] || 0,
        points[0][1] || 0
    ];
}
var $10541fe5c8356d7f$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    Region.prototype.setCenter = function(center) {
        this._center = center;
    };
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this.calcCenter();
        return center;
    };
    return Region;
}();
var $10541fe5c8356d7f$export$91e20b0f72443753 = /** @class */ function() {
    function GeoJSONPolygonGeometry(exterior, interiors) {
        this.type = 'polygon';
        this.exterior = exterior;
        this.interiors = interiors;
    }
    return GeoJSONPolygonGeometry;
}();
var $10541fe5c8356d7f$export$335807c9e785d92c = /** @class */ function() {
    function GeoJSONLineStringGeometry(points) {
        this.type = 'linestring';
        this.points = points;
    }
    return GeoJSONLineStringGeometry;
}();
var $10541fe5c8356d7f$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoJSON';
        _this.geometries = geometries;
        _this._center = cp && [
            cp[0],
            cp[1]
        ];
        return _this;
    }
    GeoJSONRegion.prototype.calcCenter = function() {
        var geometries = this.geometries;
        var largestGeo;
        var largestGeoSize = 0;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            var exterior = geo.exterior;
            // Simple trick to use points count instead of polygon area as region size.
            // Ignore linestring
            var size = exterior && exterior.length;
            if (size > largestGeoSize) {
                largestGeo = geo;
                largestGeoSize = size;
            }
        }
        if (largestGeo) return $10541fe5c8356d7f$var$centroid(largestGeo.exterior);
        // from bounding rect by default.
        var rect = this.getBoundingRect();
        return [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.getBoundingRect = function(projection) {
        var rect = this._rect;
        // Always recalculate if using projection.
        if (rect && !projection) return rect;
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        var geometries = this.geometries;
        (0, $2N6Uo.each)(geometries, function(geo) {
            if (geo.type === 'polygon') // Doesn't consider hole
            $10541fe5c8356d7f$var$updateBBoxFromPoints(geo.exterior, min, max, projection);
            else (0, $2N6Uo.each)(geo.points, function(points) {
                $10541fe5c8356d7f$var$updateBBoxFromPoints(points, min, max, projection);
            });
        });
        // Normalie invalid bounding.
        if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) min[0] = min[1] = max[0] = max[1] = 0;
        rect = new (0, $67W72.default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        if (!projection) this._rect = rect;
        return rect;
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            var geo = geometries[i];
            // Only support polygon.
            if (geo.type !== 'polygon') continue;
            var exterior = geo.exterior;
            var interiors = geo.interiors;
            if ($96Kkt.contain(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($96Kkt.contain(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */ GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $67W72.default)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            if (geo.type === 'polygon') {
                $10541fe5c8356d7f$var$transformPoints(geo.exterior, transform);
                (0, $2N6Uo.each)(geo.interiors, function(interior) {
                    $10541fe5c8356d7f$var$transformPoints(interior, transform);
                });
            } else (0, $2N6Uo.each)(geo.points, function(points) {
                $10541fe5c8356d7f$var$transformPoints(points, transform);
            });
        }
        rect = this._rect;
        rect.copy(target);
        // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    return GeoJSONRegion;
}($10541fe5c8356d7f$export$b1f97c3099fc6872);
var $10541fe5c8356d7f$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoSVG';
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.calcCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $19Ywy.identity($10541fe5c8356d7f$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $19Ywy.mul(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $19Ywy.invert(mat, mat);
        $U1aqY.applyTransform(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($10541fe5c8356d7f$export$b1f97c3099fc6872);

});
parcelRegister("96Kkt", function(module, exports) {

$parcel$export(module.exports, "contain", function () { return $6a189c9ebc648562$export$8893e2b90ba10d92; });

var $lM2rq = parcelRequire("lM2rq");
var $6a189c9ebc648562$var$EPSILON = 1e-8;
function $6a189c9ebc648562$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $6a189c9ebc648562$var$EPSILON;
}
function $6a189c9ebc648562$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $lM2rq.default)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$6a189c9ebc648562$var$isAroundEqual(p[0], p0[0]) || !$6a189c9ebc648562$var$isAroundEqual(p[1], p0[1])) w += (0, $lM2rq.default)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}

});



parcelRegister("6G4e1", function(module, exports) {

$parcel$export(module.exports, "GeoJSONResource", function () { return $4dc9f1538a4eb7be$export$859cf85c67f2df51; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $jVkwc = parcelRequire("jVkwc");

var $lP27d = parcelRequire("lP27d");

var $89jNh = parcelRequire("89jNh");

var $70rZ1 = parcelRequire("70rZ1");

var $67W72 = parcelRequire("67W72");
var $4dc9f1538a4eb7be$var$DEFAULT_NAME_PROPERTY = 'name';
var $4dc9f1538a4eb7be$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = 'geoJSON';
        this._parsedMap = (0, $2N6Uo.createHashMap)();
        this._mapName = mapName;
        this._specialAreas = specialAreas;
        // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $4dc9f1538a4eb7be$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $4dc9f1538a4eb7be$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $4dc9f1538a4eb7be$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $2N6Uo.createHashMap)();
        var finalRegions = [];
        (0, $2N6Uo.each)(parsed.regions, function(region) {
            var regionName = region.name;
            // Try use the alias in geoNameMap
            if (nameMap && (0, $2N6Uo.hasOwn)(nameMap, regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $67W72.default)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions;
        // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $jVkwc.default)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error('Invalid geoJson format\n' + e.message);
        }
        (0, $lP27d.default)(mapName, rawRegions);
        (0, $2N6Uo.each)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $89jNh.default)(mapName, region);
            (0, $70rZ1.default)(mapName, region);
            // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $4dc9f1538a4eb7be$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $4dc9f1538a4eb7be$var$parseInput(source) {
    return !(0, $2N6Uo.isString)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}

});
parcelRegister("jVkwc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e81341b5cd02f6d9$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 
var $2N6Uo = parcelRequire("2N6Uo");

var $1oUQf = parcelRequire("1oUQf");
function $e81341b5cd02f6d9$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    $2N6Uo.each(features, function(feature) {
        var geometry = feature.geometry;
        var encodeOffsets = geometry.encodeOffsets;
        var coordinates = geometry.coordinates;
        // Geometry may be appeded manually in the script after json loaded.
        // In this case this geometry is usually not encoded.
        if (!encodeOffsets) return;
        switch(geometry.type){
            case 'LineString':
                geometry.coordinates = $e81341b5cd02f6d9$var$decodeRing(coordinates, encodeOffsets, encodeScale);
                break;
            case 'Polygon':
                $e81341b5cd02f6d9$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case 'MultiLineString':
                $e81341b5cd02f6d9$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case 'MultiPolygon':
                $2N6Uo.each(coordinates, function(rings, idx) {
                    return $e81341b5cd02f6d9$var$decodeRings(rings, encodeOffsets[idx], encodeScale);
                });
        }
    });
    // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $e81341b5cd02f6d9$var$decodeRings(rings, encodeOffsets, encodeScale) {
    for(var c = 0; c < rings.length; c++)rings[c] = $e81341b5cd02f6d9$var$decodeRing(rings[c], encodeOffsets[c], encodeScale);
}
function $e81341b5cd02f6d9$var$decodeRing(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64;
        // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1);
        // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y;
        // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $e81341b5cd02f6d9$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $e81341b5cd02f6d9$var$decode(geoJson);
    return $2N6Uo.map($2N6Uo.filter(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        switch(geo.type){
            case 'Polygon':
                var coordinates = geo.coordinates;
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                geometries.push(new (0, $1oUQf.GeoJSONPolygonGeometry)(coordinates[0], coordinates.slice(1)));
                break;
            case 'MultiPolygon':
                $2N6Uo.each(geo.coordinates, function(item) {
                    if (item[0]) geometries.push(new (0, $1oUQf.GeoJSONPolygonGeometry)(item[0], item.slice(1)));
                });
                break;
            case 'LineString':
                geometries.push(new (0, $1oUQf.GeoJSONLineStringGeometry)([
                    geo.coordinates
                ]));
                break;
            case 'MultiLineString':
                geometries.push(new (0, $1oUQf.GeoJSONLineStringGeometry)(geo.coordinates));
        }
        var region = new (0, $1oUQf.GeoJSONRegion)(properties[nameProperty || 'name'], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}

});

parcelRegister("lP27d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe30007614a9d8ea$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛

var $2N6Uo = parcelRequire("2N6Uo");

var $1oUQf = parcelRequire("1oUQf");
var $fe30007614a9d8ea$var$geoCoord = [
    126,
    25
];
var $fe30007614a9d8ea$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $fe30007614a9d8ea$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $fe30007614a9d8ea$var$i = 0; $fe30007614a9d8ea$var$i < $fe30007614a9d8ea$var$points.length; $fe30007614a9d8ea$var$i++)for(var $fe30007614a9d8ea$var$k = 0; $fe30007614a9d8ea$var$k < $fe30007614a9d8ea$var$points[$fe30007614a9d8ea$var$i].length; $fe30007614a9d8ea$var$k++){
    $fe30007614a9d8ea$var$points[$fe30007614a9d8ea$var$i][$fe30007614a9d8ea$var$k][0] /= 10.5;
    $fe30007614a9d8ea$var$points[$fe30007614a9d8ea$var$i][$fe30007614a9d8ea$var$k][1] /= -14;
    $fe30007614a9d8ea$var$points[$fe30007614a9d8ea$var$i][$fe30007614a9d8ea$var$k][0] += $fe30007614a9d8ea$var$geoCoord[0];
    $fe30007614a9d8ea$var$points[$fe30007614a9d8ea$var$i][$fe30007614a9d8ea$var$k][1] += $fe30007614a9d8ea$var$geoCoord[1];
}
function $fe30007614a9d8ea$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === 'china') {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $fe30007614a9d8ea$var$nanhaiName) return;
        }
        regions.push(new (0, $1oUQf.GeoJSONRegion)($fe30007614a9d8ea$var$nanhaiName, $2N6Uo.map($fe30007614a9d8ea$var$points, function(exterior) {
            return {
                type: 'polygon',
                exterior: exterior
            };
        }), $fe30007614a9d8ea$var$geoCoord));
    }
}

});

parcelRegister("89jNh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5eee849d02751a66$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5eee849d02751a66$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    // '北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $5eee849d02751a66$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china') {
        var coordFix = $5eee849d02751a66$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("70rZ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $519e3d5c0da22286$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $519e3d5c0da22286$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $519e3d5c0da22286$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: 'polygon',
        exterior: $519e3d5c0da22286$var$points[0]
    });
}

});





parcelRegister("e7sM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a47809f1f47e8539$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $1rIDm = parcelRequire("1rIDm");

var $49X8G = parcelRequire("49X8G");

var $LBjKB = parcelRequire("LBjKB");

var $6VFOB = parcelRequire("6VFOB");

var $5KdhI = parcelRequire("5KdhI");

var $k0QDS = parcelRequire("k0QDS");

var $hIXrb = parcelRequire("hIXrb");

var $6aXXD = parcelRequire("6aXXD");
var $a47809f1f47e8539$var$MapSeries = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MapSeries, _super);
    function MapSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapSeries.type;
        // Only first map series of same mapType will drawMap.
        _this.needsDrawMap = false;
        // Group of all map series with same mapType
        _this.seriesGroup = [];
        _this.getTooltipPosition = function(dataIndex) {
            if (dataIndex != null) {
                var name_1 = this.getData().getName(dataIndex);
                var geo = this.coordinateSystem;
                var region = geo.getRegion(name_1);
                return region && geo.dataToPoint(region.getCenter());
            }
        };
        return _this;
    }
    MapSeries.prototype.getInitialData = function(option) {
        var data = (0, $1rIDm.default)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $2N6Uo.curry((0, $6VFOB.makeSeriesEncodeForNameBased), this)
        });
        var dataNameIndexMap = $2N6Uo.createHashMap();
        var toAppendItems = [];
        for(var i = 0, len = data.count(); i < len; i++){
            var name_2 = data.getName(i);
            dataNameIndexMap.set(name_2, i);
        }
        var geoSource = (0, $LBjKB.default).load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
        $2N6Uo.each(geoSource.regions, function(region) {
            var name = region.name;
            var dataNameIdx = dataNameIndexMap.get(name);
            // apply specified echarts style in GeoJSON data
            var specifiedGeoJSONRegionStyle = region.properties && region.properties.echartsStyle;
            var dataItem;
            if (dataNameIdx == null) {
                dataItem = {
                    name: name
                };
                toAppendItems.push(dataItem);
            } else dataItem = data.getRawDataItem(dataNameIdx);
            specifiedGeoJSONRegionStyle && $2N6Uo.merge(dataItem, specifiedGeoJSONRegionStyle);
        });
        // Complete data with missing regions. The consequent processes (like visual
        // map and render) can not be performed without a "full data". For example,
        // find `dataIndex` by name.
        data.appendData(toAppendItems);
        return data;
    };
    /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */ MapSeries.prototype.getHostGeoModel = function() {
        if ((0, $hIXrb.decideCoordSysUsageKind)(this).kind === (0, $hIXrb.CoordinateSystemUsageKind).boxCoordSys) // Always use an internal geo if specify a boxCoordSys.
        // Notice that currently we do not support laying out a geo based on
        // another geo, but preserve the possibility.
        return;
        return this.getReferringComponents('geo', {
            useDefault: false,
            enableAll: false,
            enableNone: false
        }).models[0];
    };
    MapSeries.prototype.getMapType = function() {
        return (this.getHostGeoModel() || this).option.map;
    };
    // _fillOption(option, mapName) {
    // Shallow clone
    // option = zrUtil.extend({}, option);
    // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
    // return option;
    // }
    MapSeries.prototype.getRawValue = function(dataIndex) {
        // Use value stored in data instead because it is calculated from multiple series
        // FIXME Provide all value of multiple series ?
        var data = this.getData();
        return data.get(data.mapDimension('value'), dataIndex);
    };
    /**
   * Get model of region
   */ MapSeries.prototype.getRegionModel = function(regionName) {
        var data = this.getData();
        return data.getItemModel(data.indexOfName(regionName));
    };
    /**
   * Map tooltip formatter
   */ MapSeries.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // FIXME orignalData and data is a bit confusing
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        var seriesGroup = this.seriesGroup;
        var seriesNames = [];
        for(var i = 0; i < seriesGroup.length; i++){
            var otherIndex = seriesGroup[i].originalData.indexOfName(name);
            var valueDim = data.mapDimension('value');
            if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) seriesNames.push(seriesGroup[i].name);
        }
        return (0, $5KdhI.createTooltipMarkup)('section', {
            header: seriesNames.join(', '),
            noHeader: !seriesNames.length,
            blocks: [
                (0, $5KdhI.createTooltipMarkup)('nameValue', {
                    name: name,
                    value: value
                })
            ]
        });
    };
    MapSeries.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    MapSeries.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    MapSeries.prototype.getLegendIcon = function(opt) {
        var iconType = opt.icon || 'roundRect';
        var icon = (0, $k0QDS.createSymbol)(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
        icon.setStyle(opt.itemStyle);
        // Map do not use itemStyle.borderWidth as border width
        icon.style.stroke = 'none';
        // No rotation because no series visual symbol for map
        if (iconType.indexOf('empty') > -1) {
            icon.style.stroke = icon.style.fill;
            icon.style.fill = (0, $6aXXD.default).color.neutral00;
            icon.style.lineWidth = 2;
        }
        return icon;
    };
    MapSeries.type = 'series.map';
    MapSeries.dependencies = [
        'geo'
    ];
    MapSeries.layoutMode = 'box';
    MapSeries.defaultOption = {
        // 一级层叠
        // zlevel: 0,
        // 二级层叠
        z: 2,
        coordinateSystem: 'geo',
        // map should be explicitly specified since ec3.
        map: '',
        // If `geoIndex` is not specified, a exclusive geo will be
        // created. Otherwise use the specified geo component, and
        // `map` and `mapType` are ignored.
        // geoIndex: 0,
        // 'center' | 'left' | 'right' | 'x%' | {number}
        left: 'center',
        // 'center' | 'top' | 'bottom' | 'x%' | {number}
        top: 'center',
        // right
        // bottom
        // width:
        // height
        // Aspect is width / height. Inited to be geoJson bbox aspect
        // This parameter is used for scale this aspect
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient.
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        showLegendSymbol: true,
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ],
        // higher priority than center and zoom
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        selectedMode: true,
        label: {
            show: false,
            color: (0, $6aXXD.default).color.tertiary
        },
        // scaleLimit: null,
        itemStyle: {
            borderWidth: 0.5,
            borderColor: (0, $6aXXD.default).color.border,
            areaColor: (0, $6aXXD.default).color.background
        },
        emphasis: {
            label: {
                show: true,
                color: (0, $6aXXD.default).color.primary
            },
            itemStyle: {
                areaColor: (0, $6aXXD.default).color.highlight
            }
        },
        select: {
            label: {
                show: true,
                color: (0, $6aXXD.default).color.primary
            },
            itemStyle: {
                color: (0, $6aXXD.default).color.highlight
            }
        },
        nameProperty: 'name'
    };
    return MapSeries;
}((0, $49X8G.default));
var $a47809f1f47e8539$export$2e2bcd8739ae039 = $a47809f1f47e8539$var$MapSeries;

});

parcelRegister("eCvlQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa4cef08b057797b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
// FIXME 公用？
function $aa4cef08b057797b$var$dataStatistics(datas, statisticType) {
    var dataNameMap = {};
    $2N6Uo.each(datas, function(data) {
        data.each(data.mapDimension('value'), function(value, idx) {
            // Add prefix to avoid conflict with Object.prototype.
            var mapKey = 'ec-' + data.getName(idx);
            dataNameMap[mapKey] = dataNameMap[mapKey] || [];
            if (!isNaN(value)) dataNameMap[mapKey].push(value);
        });
    });
    return datas[0].map(datas[0].mapDimension('value'), function(value, idx) {
        var mapKey = 'ec-' + datas[0].getName(idx);
        var sum = 0;
        var min = Infinity;
        var max = -Infinity;
        var len = dataNameMap[mapKey].length;
        for(var i = 0; i < len; i++){
            min = Math.min(min, dataNameMap[mapKey][i]);
            max = Math.max(max, dataNameMap[mapKey][i]);
            sum += dataNameMap[mapKey][i];
        }
        var result;
        if (statisticType === 'min') result = min;
        else if (statisticType === 'max') result = max;
        else if (statisticType === 'average') result = sum / len;
        else result = sum;
        return len === 0 ? NaN : result;
    });
}
function $aa4cef08b057797b$export$2e2bcd8739ae039(ecModel) {
    var seriesGroups = {};
    ecModel.eachSeriesByType('map', function(seriesModel) {
        var hostGeoModel = seriesModel.getHostGeoModel();
        var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
        (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
    });
    $2N6Uo.each(seriesGroups, function(seriesList, key) {
        var data = $aa4cef08b057797b$var$dataStatistics($2N6Uo.map(seriesList, function(seriesModel) {
            return seriesModel.getData();
        }), seriesList[0].get('mapValueCalculation'));
        for(var i = 0; i < seriesList.length; i++)seriesList[i].originalData = seriesList[i].getData();
        // FIXME Put where?
        for(var i = 0; i < seriesList.length; i++){
            seriesList[i].seriesGroup = seriesList;
            seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
            seriesList[i].setData(data.cloneShallow());
            seriesList[i].mainSeries = seriesList[0];
        }
    });
}

});

parcelRegister("4snHY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33ec2aee9a832bef$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $33ec2aee9a832bef$export$2e2bcd8739ae039(ecModel) {
    var processedMapType = {};
    ecModel.eachSeriesByType('map', function(mapSeries) {
        var mapType = mapSeries.getMapType();
        if (mapSeries.getHostGeoModel() || processedMapType[mapType]) return;
        var mapSymbolOffsets = {};
        $2N6Uo.each(mapSeries.seriesGroup, function(subMapSeries) {
            var geo = subMapSeries.coordinateSystem;
            var data = subMapSeries.originalData;
            if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) data.each(data.mapDimension('value'), function(value, idx) {
                var name = data.getName(idx);
                var region = geo.getRegion(name);
                // If input series.data is [11, 22, '-'/null/undefined, 44],
                // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
                // not be drawn. So here must validate if value is NaN.
                if (!region || isNaN(value)) return;
                var offset = mapSymbolOffsets[name] || 0;
                var point = geo.dataToPoint(region.getCenter());
                mapSymbolOffsets[name] = offset + 1;
                data.setItemLayout(idx, {
                    point: point,
                    offset: offset
                });
            });
        });
        // Show label of those region not has legendIcon (which is offset 0)
        var data = mapSeries.getData();
        data.each(function(idx) {
            var name = data.getName(idx);
            var layout = data.getItemLayout(idx) || {};
            layout.showLabel = !mapSymbolOffsets[name];
            data.setItemLayout(idx, layout);
        });
        processedMapType[mapType] = true;
    });
}

});

parcelRegister("enNfu", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $a7896a7443fd1529$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VZf1 = parcelRequire("3VZf1");

var $hQ2xG = parcelRequire("hQ2xG");

var $2N6Uo = parcelRequire("2N6Uo");

var $kc4jZ = parcelRequire("kc4jZ");

var $aywSV = parcelRequire("aywSV");

var $LBjKB = parcelRequire("LBjKB");
function $a7896a7443fd1529$var$registerMap(mapName, geoJson, specialAreas) {
    (0, $LBjKB.default).registerMap(mapName, geoJson, specialAreas);
}
function $a7896a7443fd1529$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem('geo', (0, $hQ2xG.default));
    registers.registerComponentModel((0, $3VZf1.default));
    registers.registerComponentView((0, $aywSV.default));
    registers.registerImpl('registerMap', $a7896a7443fd1529$var$registerMap);
    registers.registerImpl('getMap', function(mapName) {
        return (0, $LBjKB.default).getMapForUser(mapName);
    });
    function makeAction(method, actionInfo) {
        actionInfo.update = 'geo:updateSelectStatus';
        registers.registerAction(actionInfo, function(payload, ecModel) {
            var selected = {};
            var allSelected = [];
            ecModel.eachComponent({
                mainType: 'geo',
                query: payload
            }, function(geoModel) {
                geoModel[method](payload.name);
                var geo = geoModel.coordinateSystem;
                (0, $2N6Uo.each)(geo.regions, function(region) {
                    selected[region.name] = geoModel.isSelected(region.name) || false;
                });
                // Notice: there might be duplicated name in different regions.
                var names = [];
                (0, $2N6Uo.each)(selected, function(v, name) {
                    selected[name] && names.push(name);
                });
                allSelected.push({
                    geoIndex: geoModel.componentIndex,
                    // Use singular, the same naming convention as the event `selectchanged`.
                    name: names
                });
            });
            return {
                selected: selected,
                allSelected: allSelected,
                name: payload.name
            };
        });
    }
    makeAction('toggleSelected', {
        type: 'geoToggleSelect',
        event: 'geoselectchanged'
    });
    makeAction('select', {
        type: 'geoSelect',
        event: 'geoselected'
    });
    makeAction('unSelect', {
        type: 'geoUnSelect',
        event: 'geounselected'
    });
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'geoRoam',
        event: 'geoRoam',
        update: 'updateTransform'
    }, function(payload, ecModel, api) {
        var componentType = payload.componentType;
        if (!componentType) {
            // backward compat, but `payload.componentType` is deprecated.
            if (payload.geoId != null) componentType = 'geo';
            else if (payload.seriesId != null) componentType = 'series';
        }
        if (!componentType) componentType = 'series';
        // FIXME: payload.geoId/payload.seriesId should be required, but historically
        //  it is not mandatory, causing that all of the geo or series can be queried below,
        //  which is not reasonable.
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            var geo = componentModel.coordinateSystem;
            if (geo.type !== 'geo') return;
            var res = (0, $kc4jZ.updateCenterAndZoomInAction)(geo, payload, componentModel.get('scaleLimit'));
            componentModel.setCenter && componentModel.setCenter(res.center);
            componentModel.setZoom && componentModel.setZoom(res.zoom);
            // All map series with same `map` use the same geo coordinate system
            // So the center and zoom must be in sync. Include the series not selected by legend
            if (componentType === 'series') (0, $2N6Uo.each)(componentModel.seriesGroup, function(seriesModel) {
                seriesModel.setCenter(res.center);
                seriesModel.setZoom(res.zoom);
            });
        });
    });
}

});
parcelRegister("3VZf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dd6333a92dfd896$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $eLD2b = parcelRequire("eLD2b");

var $b8YKU = parcelRequire("b8YKU");

var $hQ2xG = parcelRequire("hQ2xG");

var $LBjKB = parcelRequire("LBjKB");

var $6aXXD = parcelRequire("6aXXD");
var $2dd6333a92dfd896$var$GeoModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GeoModel, _super);
    function GeoModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoModel.type;
        return _this;
    }
    GeoModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        var source = (0, $LBjKB.default).getGeoResource(option.map);
        if (source && source.type === 'geoJSON') {
            var itemStyle = option.itemStyle = option.itemStyle || {};
            if (!('color' in itemStyle)) itemStyle.color = option.defaultItemStyleColor || (0, $6aXXD.default).color.backgroundTint;
        }
        // Default label emphasis `show`
        $bx3T8.defaultEmphasis(option, 'label', [
            'show'
        ]);
    };
    GeoModel.prototype.optionUpdated = function() {
        var _this = this;
        var option = this.option;
        option.regions = (0, $hQ2xG.default).getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
        var selectedMap = {};
        this._optionModelMap = $2N6Uo.reduce(option.regions || [], function(optionModelMap, regionOpt) {
            var regionName = regionOpt.name;
            if (regionName) {
                optionModelMap.set(regionName, new (0, $b8YKU.default)(regionOpt, _this, _this.ecModel));
                if (regionOpt.selected) selectedMap[regionName] = true;
            }
            return optionModelMap;
        }, $2N6Uo.createHashMap());
        if (!option.selectedMap) option.selectedMap = selectedMap;
    };
    /**
   * Get model of region.
   */ GeoModel.prototype.getRegionModel = function(name) {
        return this._optionModelMap.get(name) || new (0, $b8YKU.default)(null, this, this.ecModel);
    };
    /**
   * Format label
   * @param name Region name
   */ GeoModel.prototype.getFormattedLabel = function(name, status) {
        var regionModel = this.getRegionModel(name);
        var formatter = status === 'normal' ? regionModel.get([
            'label',
            'formatter'
        ]) : regionModel.get([
            'emphasis',
            'label',
            'formatter'
        ]);
        var params = {
            name: name
        };
        if ($2N6Uo.isFunction(formatter)) {
            params.status = status;
            return formatter(params);
        } else if ($2N6Uo.isString(formatter)) return formatter.replace('{a}', name != null ? name : '');
    };
    GeoModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GeoModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    // PENGING If selectedMode is null ?
    GeoModel.prototype.select = function(name) {
        var option = this.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        if (selectedMode !== 'multiple') option.selectedMap = null;
        var selectedMap = option.selectedMap || (option.selectedMap = {});
        selectedMap[name] = true;
    };
    GeoModel.prototype.unSelect = function(name) {
        var selectedMap = this.option.selectedMap;
        if (selectedMap) selectedMap[name] = false;
    };
    GeoModel.prototype.toggleSelected = function(name) {
        this[this.isSelected(name) ? 'unSelect' : 'select'](name);
    };
    GeoModel.prototype.isSelected = function(name) {
        var selectedMap = this.option.selectedMap;
        return !!(selectedMap && selectedMap[name]);
    };
    GeoModel.type = 'geo';
    GeoModel.layoutMode = 'box';
    GeoModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        show: true,
        left: 'center',
        top: 'center',
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // /// Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        silent: false,
        // Map type
        map: '',
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ]
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        // selectedMode: false
        label: {
            show: false,
            color: (0, $6aXXD.default).color.tertiary
        },
        itemStyle: {
            borderWidth: 0.5,
            borderColor: (0, $6aXXD.default).color.border
        },
        emphasis: {
            label: {
                show: true,
                color: (0, $6aXXD.default).color.primary
            },
            itemStyle: {
                color: (0, $6aXXD.default).color.highlight
            }
        },
        select: {
            label: {
                show: true,
                color: (0, $6aXXD.default).color.primary
            },
            itemStyle: {
                color: (0, $6aXXD.default).color.highlight
            }
        },
        regions: []
    };
    return GeoModel;
}((0, $eLD2b.default));
var $2dd6333a92dfd896$export$2e2bcd8739ae039 = $2dd6333a92dfd896$var$GeoModel;

});
parcelRegister("hQ2xG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfc943d2e5a610b9$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $5D0xd = parcelRequire("5D0xd");

var $a35Wn = parcelRequire("a35Wn");

var $iCU10 = parcelRequire("iCU10");

var $LBjKB = parcelRequire("LBjKB");

var $U1aqY = parcelRequire("U1aqY");

var $hIXrb = parcelRequire("hIXrb");

var $bx3T8 = parcelRequire("bx3T8");
/**
 * Resize method bound to the geo
 */ function $cfc943d2e5a610b9$var$resizeGeo(geoModel, api) {
    var boundingCoords = geoModel.get('boundingCoords');
    if (boundingCoords != null) {
        var leftTop_1 = boundingCoords[0];
        var rightBottom_1 = boundingCoords[1];
        if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) ;
        else {
            // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
            var projection_1 = this.projection;
            if (projection_1) {
                var xMin = leftTop_1[0];
                var yMin = leftTop_1[1];
                var xMax = rightBottom_1[0];
                var yMax = rightBottom_1[1];
                leftTop_1 = [
                    Infinity,
                    Infinity
                ];
                rightBottom_1 = [
                    -Infinity,
                    -Infinity
                ];
                // TODO better way?
                var sampleLine = function(x0, y0, x1, y1) {
                    var dx = x1 - x0;
                    var dy = y1 - y0;
                    for(var i = 0; i <= 100; i++){
                        var p = i / 100;
                        var pt = projection_1.project([
                            x0 + dx * p,
                            y0 + dy * p
                        ]);
                        $U1aqY.min(leftTop_1, leftTop_1, pt);
                        $U1aqY.max(rightBottom_1, rightBottom_1, pt);
                    }
                };
                // Top
                sampleLine(xMin, yMin, xMax, yMin);
                // Right
                sampleLine(xMax, yMin, xMax, yMax);
                // Bottom
                sampleLine(xMax, yMax, xMin, yMax);
                // Left
                sampleLine(xMin, yMax, xMax, yMin);
            }
            this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
        }
    }
    var rect = this.getBoundingRect();
    var centerOption = geoModel.get('layoutCenter');
    var sizeOption = geoModel.get('layoutSize');
    // Laying out geo on `dataCoordSys`, such as cartesian, works theoretically but not supported yet.
    // Therefore here we only handle cases that laying out on `boxCoordSys`, such as matrix/calendar.
    var refContainer = $a35Wn.createBoxLayoutReference(geoModel, api).refContainer;
    var aspect = rect.width / rect.height * this.aspectScale;
    var useCenterAndSize = false;
    var center;
    var size;
    if (centerOption && sizeOption) {
        center = [
            $iCU10.parsePercent(centerOption[0], refContainer.width) + refContainer.x,
            $iCU10.parsePercent(centerOption[1], refContainer.height) + refContainer.y
        ];
        size = $iCU10.parsePercent(sizeOption, Math.min(refContainer.width, refContainer.height));
        if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) useCenterAndSize = true;
    }
    var viewRect;
    if (useCenterAndSize) {
        viewRect = {};
        if (aspect > 1) {
            // Width is same with size
            viewRect.width = size;
            viewRect.height = size / aspect;
        } else {
            viewRect.height = size;
            viewRect.width = size * aspect;
        }
        viewRect.y = center[1] - viewRect.height / 2;
        viewRect.x = center[0] - viewRect.width / 2;
    } else {
        // Use left/top/width/height
        var boxLayoutOption = geoModel.getBoxLayoutParams();
        boxLayoutOption.aspect = aspect;
        viewRect = $a35Wn.getLayoutRect(boxLayoutOption, refContainer);
        viewRect = $a35Wn.applyPreserveAspect(geoModel, viewRect, aspect);
    }
    this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
    this.setCenter(geoModel.get('center'));
    this.setZoom(geoModel.get('zoom'));
}
// Back compat for ECharts2, where the coord map is set on map series:
// {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},
function $cfc943d2e5a610b9$var$setGeoCoords(geo, model) {
    $2N6Uo.each(model.get('geoCoord'), function(geoCoord, name) {
        geo.addGeoCoord(name, geoCoord);
    });
}
var $cfc943d2e5a610b9$var$GeoCreator = /** @class */ function() {
    function GeoCreator() {
        // For deciding which dimensions to use when creating list data
        this.dimensions = (0, $5D0xd.geo2DDimensions);
    }
    GeoCreator.prototype.create = function(ecModel, api) {
        var geoList = [];
        function getCommonGeoProperties(model) {
            return {
                nameProperty: model.get('nameProperty'),
                aspectScale: model.get('aspectScale'),
                projection: model.get('projection')
            };
        }
        // FIXME Create each time may be slow
        ecModel.eachComponent('geo', function(geoModel, idx) {
            var mapName = geoModel.get('map');
            var geo = new (0, $5D0xd.default)(mapName + idx, mapName, $2N6Uo.extend({
                nameMap: geoModel.get('nameMap'),
                api: api,
                ecModel: ecModel
            }, getCommonGeoProperties(geoModel)));
            geo.zoomLimit = geoModel.get('scaleLimit');
            geoList.push(geo);
            // setGeoCoords(geo, geoModel);
            geoModel.coordinateSystem = geo;
            geo.model = geoModel;
            // Inject resize method
            geo.resize = $cfc943d2e5a610b9$var$resizeGeo;
            geo.resize(geoModel, api);
        });
        ecModel.eachSeries(function(seriesModel) {
            (0, $hIXrb.injectCoordSysByOption)({
                targetModel: seriesModel,
                coordSysType: 'geo',
                coordSysProvider: function() {
                    var geoModel = seriesModel.subType === 'map' ? seriesModel.getHostGeoModel() : seriesModel.getReferringComponents('geo', (0, $bx3T8.SINGLE_REFERRING)).models[0];
                    return geoModel && geoModel.coordinateSystem;
                },
                allowNotFound: true
            });
        });
        // If has map series
        var mapModelGroupBySeries = {};
        ecModel.eachSeriesByType('map', function(seriesModel) {
            if (!seriesModel.getHostGeoModel()) {
                var mapType = seriesModel.getMapType();
                mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
                mapModelGroupBySeries[mapType].push(seriesModel);
            }
        });
        $2N6Uo.each(mapModelGroupBySeries, function(mapSeries, mapType) {
            var nameMapList = $2N6Uo.map(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get('nameMap');
            });
            var geo = new (0, $5D0xd.default)(mapType, mapType, $2N6Uo.extend({
                nameMap: $2N6Uo.mergeAll(nameMapList),
                api: api,
                ecModel: ecModel
            }, getCommonGeoProperties(mapSeries[0])));
            geo.zoomLimit = $2N6Uo.retrieve.apply(null, $2N6Uo.map(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get('scaleLimit');
            }));
            geoList.push(geo);
            // Inject resize method
            geo.resize = $cfc943d2e5a610b9$var$resizeGeo;
            geo.resize(mapSeries[0], api);
            $2N6Uo.each(mapSeries, function(singleMapSeries) {
                singleMapSeries.coordinateSystem = geo;
                $cfc943d2e5a610b9$var$setGeoCoords(geo, singleMapSeries);
            });
        });
        return geoList;
    };
    /**
   * Fill given regions array
   */ GeoCreator.prototype.getFilledRegions = function(originRegionArr, mapName, nameMap, nameProperty) {
        // Not use the original
        var regionsArr = (originRegionArr || []).slice();
        var dataNameMap = $2N6Uo.createHashMap();
        for(var i = 0; i < regionsArr.length; i++)dataNameMap.set(regionsArr[i].name, regionsArr[i]);
        var source = (0, $LBjKB.default).load(mapName, nameMap, nameProperty);
        $2N6Uo.each(source.regions, function(region) {
            var name = region.name;
            var regionOption = dataNameMap.get(name);
            // apply specified echarts style in GeoJSON data
            var specifiedGeoJSONRegionStyle = region.properties && region.properties.echartsStyle;
            if (!regionOption) {
                regionOption = {
                    name: name
                };
                regionsArr.push(regionOption);
            }
            specifiedGeoJSONRegionStyle && $2N6Uo.merge(regionOption, specifiedGeoJSONRegionStyle);
        });
        return regionsArr;
    };
    return GeoCreator;
}();
var $cfc943d2e5a610b9$var$geoCreator = new $cfc943d2e5a610b9$var$GeoCreator();
var $cfc943d2e5a610b9$export$2e2bcd8739ae039 = $cfc943d2e5a610b9$var$geoCreator;

});
parcelRegister("5D0xd", function(module, exports) {

$parcel$export(module.exports, "geo2DDimensions", function () { return $41910277f39b924f$export$10dbc57975912e0f; });
$parcel$export(module.exports, "default", function () { return $41910277f39b924f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $67W72 = parcelRequire("67W72");

var $11tae = parcelRequire("11tae");

var $LBjKB = parcelRequire("LBjKB");

var $bx3T8 = parcelRequire("bx3T8");

var $41910277f39b924f$var$GEO_DEFAULT_PARAMS = {
    'geoJSON': {
        aspectScale: 0.75,
        invertLongitute: true
    },
    'geoSVG': {
        aspectScale: 1,
        invertLongitute: false
    }
};
var $41910277f39b924f$export$10dbc57975912e0f = [
    'lng',
    'lat'
];
var $41910277f39b924f$var$Geo = /** @class */ function(_super) {
    (0, $9nEce.__extends)(Geo, _super);
    function Geo(name, map, opt) {
        var _this = _super.call(this, name, {
            api: opt.api,
            ecModel: opt.ecModel
        }) || this;
        _this.dimensions = $41910277f39b924f$export$10dbc57975912e0f;
        _this.type = 'geo';
        // Only store specified name coord via `addGeoCoord`.
        _this._nameCoordMap = $2N6Uo.createHashMap();
        _this.map = map;
        var projection = opt.projection;
        var source = (0, $LBjKB.default).load(map, opt.nameMap, opt.nameProperty);
        var resource = (0, $LBjKB.default).getGeoResource(map);
        var resourceType = _this.resourceType = resource ? resource.type : null;
        var regions = _this.regions = source.regions;
        var defaultParams = $41910277f39b924f$var$GEO_DEFAULT_PARAMS[resource.type];
        _this._regionsMap = source.regionsMap;
        _this.regions = source.regions;
        _this.projection = projection;
        var boundingRect;
        if (projection) // Can't reuse the raw bounding rect
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect(projection);
            boundingRect = boundingRect || regionRect.clone();
            boundingRect.union(regionRect);
        }
        else boundingRect = source.boundingRect;
        _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height);
        // aspectScale and invertLongitute actually is the parameters default raw projection.
        // So we ignore them if projection is given.
        // Ignore default aspect scale if projection exits.
        _this.aspectScale = projection ? 1 : $2N6Uo.retrieve2(opt.aspectScale, defaultParams.aspectScale);
        // Not invert longitude if projection exits.
        _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
        return _this;
    }
    Geo.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var invertLongitute = this._invertLongitute;
        rect = rect.clone();
        if (invertLongitute) // Longitude is inverted.
        rect.y = -rect.y - rect.height;
        var rawTransformable = this._rawTransformable;
        rawTransformable.transform = rect.calculateTransform(new (0, $67W72.default)(x, y, width, height));
        var rawParent = rawTransformable.parent;
        rawTransformable.parent = null;
        rawTransformable.decomposeTransform();
        rawTransformable.parent = rawParent;
        if (invertLongitute) rawTransformable.scaleY = -rawTransformable.scaleY;
        this._updateTransform();
    };
    Geo.prototype.getRegion = function(name) {
        return this._regionsMap.get(name);
    };
    Geo.prototype.getRegionByCoord = function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            var region = regions[i];
            if (region.type === 'geoJSON' && region.contain(coord)) return regions[i];
        }
    };
    /**
   * Add geoCoord for indexing by name
   */ Geo.prototype.addGeoCoord = function(name, geoCoord) {
        this._nameCoordMap.set(name, geoCoord);
    };
    /**
   * Get geoCoord by name
   */ Geo.prototype.getGeoCoord = function(name) {
        var region = this._regionsMap.get(name);
        // Calculate center only on demand.
        return this._nameCoordMap.get(name) || region && region.getCenter();
    };
    Geo.prototype.dataToPoint = function(data, noRoam, out) {
        if ($2N6Uo.isString(data)) // Map area name to geoCoord
        data = this.getGeoCoord(data);
        if (data) {
            var projection = this.projection;
            if (projection) // projection may return null point.
            data = projection.project(data);
            return data && this.projectedToPoint(data, noRoam, out);
        }
    };
    Geo.prototype.pointToData = function(point, reserved, out) {
        var projection = this.projection;
        if (projection) // projection may return null point.
        point = projection.unproject(point);
        // FIXME: if no `point`, should return [NaN, NaN], rather than undefined.
        //  null/undefined has special meaning in `convertFromPixel`.
        return point && this.pointToProjected(point, out);
    };
    /**
   * Point to projected data. Same with pointToData when projection is used.
   */ Geo.prototype.pointToProjected = function(point, out) {
        return _super.prototype.pointToData.call(this, point, 0, out);
    };
    Geo.prototype.projectedToPoint = function(projected, noRoam, out) {
        return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
    };
    Geo.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $41910277f39b924f$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Geo.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $41910277f39b924f$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    return Geo;
}((0, $11tae.default));
$2N6Uo.mixin($41910277f39b924f$var$Geo, (0, $11tae.default));
function $41910277f39b924f$var$getCoordSys(finder) {
    var geoModel = finder.geoModel;
    var seriesModel = finder.seriesModel;
    return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
     || (seriesModel.getReferringComponents('geo', (0, $bx3T8.SINGLE_REFERRING)).models[0] || {}).coordinateSystem : null;
}
var $41910277f39b924f$export$2e2bcd8739ae039 = $41910277f39b924f$var$Geo;

});



parcelRegister("aywSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7af6969a0f808280$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2K1nr = parcelRequire("2K1nr");

var $bpyST = parcelRequire("bpyST");

var $6TSUP = parcelRequire("6TSUP");

var $cQG2W = parcelRequire("cQG2W");
var $7af6969a0f808280$var$GeoView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GeoView, _super);
    function GeoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoView.type;
        _this.focusBlurEnabled = true;
        return _this;
    }
    GeoView.prototype.init = function(ecModel, api) {
        this._api = api;
    };
    GeoView.prototype.render = function(geoModel, ecModel, api, payload) {
        this._model = geoModel;
        if (!geoModel.get('show')) {
            this._mapDraw && this._mapDraw.remove();
            this._mapDraw = null;
            return;
        }
        if (!this._mapDraw) this._mapDraw = new (0, $2K1nr.default)(api);
        var mapDraw = this._mapDraw;
        mapDraw.draw(geoModel, ecModel, api, this, payload);
        mapDraw.group.on('click', this._handleRegionClick, this);
        mapDraw.group.silent = geoModel.get('silent');
        this.group.add(mapDraw.group);
        this.updateSelectStatus(geoModel, ecModel, api);
    };
    GeoView.prototype._handleRegionClick = function(e) {
        var eventData;
        (0, $cQG2W.findEventDispatcher)(e.target, function(current) {
            return (eventData = (0, $6TSUP.getECData)(current).eventData) != null;
        }, true);
        if (eventData) this._api.dispatchAction({
            type: 'geoToggleSelect',
            geoId: this._model.id,
            name: eventData.name
        });
    };
    GeoView.prototype.updateSelectStatus = function(model, ecModel, api) {
        var _this = this;
        this._mapDraw.group.traverse(function(node) {
            var eventData = (0, $6TSUP.getECData)(node).eventData;
            if (eventData) {
                _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node);
                // No need to traverse children.
                return true;
            }
        });
    };
    GeoView.prototype.findHighDownDispatchers = function(name) {
        return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
    };
    GeoView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
    };
    GeoView.type = 'geo';
    return GeoView;
}((0, $bpyST.default));
var $7af6969a0f808280$export$2e2bcd8739ae039 = $7af6969a0f808280$var$GeoView;

});



parcelRegister("3vGAD", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $28e54dd107c76e01$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $iHVll = parcelRequire("iHVll");

var $kvpMn = parcelRequire("kvpMn");

var $fK6sX = parcelRequire("fK6sX");

var $2RBC6 = parcelRequire("2RBC6");
function $28e54dd107c76e01$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $2RBC6.install));
    registers.registerChartView((0, $iHVll.default));
    registers.registerSeriesModel((0, $kvpMn.default));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $fK6sX.default));
}

});
parcelRegister("iHVll", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9e8b9506843b20c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $iQonF = parcelRequire("iQonF");
var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $ewDYK = parcelRequire("ewDYK");
var $aH2k0 = parcelRequire("aH2k0");
var $ipprj = parcelRequire("ipprj");

var $bwPbQ = parcelRequire("bwPbQ");

var $cWIrM = parcelRequire("cWIrM");

var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");

var $ipprj = parcelRequire("ipprj");
var $d9e8b9506843b20c$var$DEFAULT_SMOOTH = 0.3;
var $d9e8b9506843b20c$var$ParallelView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        _this._dataGroup = new $iQonF.default();
        _this._initialized = false;
        return _this;
    }
    ParallelView.prototype.init = function() {
        this.group.add(this._dataGroup);
    };
    /**
   * @override
   */ ParallelView.prototype.render = function(seriesModel, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var dataGroup = this._dataGroup;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $d9e8b9506843b20c$var$makeSeriesScope(seriesModel);
        data.diff(oldData).add(add).update(update).remove(remove).execute();
        function add(newDataIndex) {
            var line = $d9e8b9506843b20c$var$addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
            $d9e8b9506843b20c$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function update(newDataIndex, oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            var points = $d9e8b9506843b20c$var$createLinePoints(data, newDataIndex, dimensions, coordSys);
            data.setItemGraphicEl(newDataIndex, line);
            $ipprj.updateProps(line, {
                shape: {
                    points: points
                }
            }, seriesModel, newDataIndex);
            (0, $ipprj.saveOldStyle)(line);
            $d9e8b9506843b20c$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function remove(oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            dataGroup.remove(line);
        }
        // First create
        if (!this._initialized) {
            this._initialized = true;
            var clipPath = $d9e8b9506843b20c$var$createGridClipShape(coordSys, seriesModel, function() {
                // Callback will be invoked immediately if there is no animation
                setTimeout(function() {
                    dataGroup.removeClipPath();
                });
            });
            dataGroup.setClipPath(clipPath);
        }
        this._data = data;
    };
    ParallelView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._initialized = true;
        this._data = null;
        this._dataGroup.removeAll();
    };
    ParallelView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $d9e8b9506843b20c$var$makeSeriesScope(seriesModel);
        var progressiveEls = this._progressiveEls = [];
        for(var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++){
            var line = $d9e8b9506843b20c$var$addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
            line.incremental = true;
            $d9e8b9506843b20c$var$updateElCommon(line, data, dataIndex, seriesScope);
            progressiveEls.push(line);
        }
    };
    ParallelView.prototype.remove = function() {
        this._dataGroup && this._dataGroup.removeAll();
        this._data = null;
    };
    ParallelView.type = 'parallel';
    return ParallelView;
}((0, $cWIrM.default));
function $d9e8b9506843b20c$var$createGridClipShape(coordSys, seriesModel, cb) {
    var parallelModel = coordSys.model;
    var rect = coordSys.getRect();
    var rectEl = new $aH2k0.default({
        shape: {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        }
    });
    var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
    rectEl.setShape(dim, 0);
    $ipprj.initProps(rectEl, {
        shape: {
            width: rect.width,
            height: rect.height
        }
    }, seriesModel, cb);
    return rectEl;
}
function $d9e8b9506843b20c$var$createLinePoints(data, dataIndex, dimensions, coordSys) {
    var points = [];
    for(var i = 0; i < dimensions.length; i++){
        var dimName = dimensions[i];
        var value = data.get(data.mapDimension(dimName), dataIndex);
        if (!$d9e8b9506843b20c$var$isEmptyValue(value, coordSys.getAxis(dimName).type)) points.push(coordSys.dataToPoint(value, dimName));
    }
    return points;
}
function $d9e8b9506843b20c$var$addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
    var points = $d9e8b9506843b20c$var$createLinePoints(data, dataIndex, dimensions, coordSys);
    var line = new $ewDYK.default({
        shape: {
            points: points
        },
        // silent: true,
        z2: 10
    });
    dataGroup.add(line);
    data.setItemGraphicEl(dataIndex, line);
    return line;
}
function $d9e8b9506843b20c$var$makeSeriesScope(seriesModel) {
    var smooth = seriesModel.get('smooth', true);
    smooth === true && (smooth = $d9e8b9506843b20c$var$DEFAULT_SMOOTH);
    smooth = (0, $iCU10.numericToNumber)(smooth);
    (0, $2N6Uo.eqNaN)(smooth) && (smooth = 0);
    return {
        smooth: smooth
    };
}
function $d9e8b9506843b20c$var$updateElCommon(el, data, dataIndex, seriesScope) {
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.fill = null;
    el.setShape('smooth', seriesScope.smooth);
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $bwPbQ.setStatesStylesFromModel)(el, itemModel, 'lineStyle');
    (0, $bwPbQ.toggleHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
// function simpleDiff(oldData, newData, dimensions) {
//     let oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     let dimLen = dimensions.length;
//     for (let i = 0; i < oldLen; i++) {
//         for (let j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME put in common util?
function $d9e8b9506843b20c$var$isEmptyValue(val, axisType) {
    return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
}
var $d9e8b9506843b20c$export$2e2bcd8739ae039 = $d9e8b9506843b20c$var$ParallelView;

});

parcelRegister("kvpMn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eedab31958fc726e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $49X8G = parcelRequire("49X8G");

var $dOrFN = parcelRequire("dOrFN");
var $eedab31958fc726e$var$ParallelSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ParallelSeriesModel, _super);
    function ParallelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelSeriesModel.type;
        _this.visualStyleAccessPath = 'lineStyle';
        _this.visualDrawType = 'stroke';
        return _this;
    }
    ParallelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $dOrFN.default)(null, this, {
            useEncodeDefaulter: (0, $2N6Uo.bind)($eedab31958fc726e$var$makeDefaultEncode, null, this)
        });
    };
    /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @return Raw indices
   */ ParallelSeriesModel.prototype.getRawIndicesByActiveState = function(activeState) {
        var coordSys = this.coordinateSystem;
        var data = this.getData();
        var indices = [];
        coordSys.eachActiveState(data, function(theActiveState, dataIndex) {
            if (activeState === theActiveState) indices.push(data.getRawIndex(dataIndex));
        });
        return indices;
    };
    ParallelSeriesModel.type = 'series.parallel';
    ParallelSeriesModel.dependencies = [
        'parallel'
    ];
    ParallelSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'parallel',
        parallelIndex: 0,
        label: {
            show: false
        },
        inactiveOpacity: 0.05,
        activeOpacity: 1,
        lineStyle: {
            width: 1,
            opacity: 0.45,
            type: 'solid'
        },
        emphasis: {
            label: {
                show: false
            }
        },
        progressive: 500,
        smooth: false,
        animationEasing: 'linear'
    };
    return ParallelSeriesModel;
}((0, $49X8G.default));
function $eedab31958fc726e$var$makeDefaultEncode(seriesModel) {
    // The mapping of parallelAxis dimension to data dimension can
    // be specified in parallelAxis.option.dim. For example, if
    // parallelAxis.option.dim is 'dim3', it mapping to the third
    // dimension of data. But `data.encode` has higher priority.
    // Moreover, parallelModel.dimension should not be regarded as data
    // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
    var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
    if (!parallelModel) return;
    var encodeDefine = {};
    (0, $2N6Uo.each)(parallelModel.dimensions, function(axisDim) {
        var dataDimIndex = $eedab31958fc726e$var$convertDimNameToNumber(axisDim);
        encodeDefine[axisDim] = dataDimIndex;
    });
    return encodeDefine;
}
function $eedab31958fc726e$var$convertDimNameToNumber(dimName) {
    return +dimName.replace('dim', '');
}
var $eedab31958fc726e$export$2e2bcd8739ae039 = $eedab31958fc726e$var$ParallelSeriesModel;

});

parcelRegister("fK6sX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7602aef1169d2cd$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b7602aef1169d2cd$var$opacityAccessPath = [
    'lineStyle',
    'opacity'
];
var $b7602aef1169d2cd$var$parallelVisual = {
    seriesType: 'parallel',
    reset: function(seriesModel, ecModel) {
        var coordSys = seriesModel.coordinateSystem;
        var opacityMap = {
            normal: seriesModel.get([
                'lineStyle',
                'opacity'
            ]),
            active: seriesModel.get('activeOpacity'),
            inactive: seriesModel.get('inactiveOpacity')
        };
        return {
            progress: function(params, data) {
                coordSys.eachActiveState(data, function(activeState, dataIndex) {
                    var opacity = opacityMap[activeState];
                    if (activeState === 'normal' && data.hasItemOption) {
                        var itemOpacity = data.getItemModel(dataIndex).get($b7602aef1169d2cd$var$opacityAccessPath, true);
                        itemOpacity != null && (opacity = itemOpacity);
                    }
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
                    existsStyle.opacity = opacity;
                }, params.start, params.end);
            }
        };
    }
};
var $b7602aef1169d2cd$export$2e2bcd8739ae039 = $b7602aef1169d2cd$var$parallelVisual;

});

parcelRegister("2RBC6", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $215db543e437cbbf$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6tREg = parcelRequire("6tREg");

var $aPeC9 = parcelRequire("aPeC9");

var $kAWnY = parcelRequire("kAWnY");

var $79vxl = parcelRequire("79vxl");

var $lzKMz = parcelRequire("lzKMz");

var $jSODp = parcelRequire("jSODp");

var $680yY = parcelRequire("680yY");

var $5onBH = parcelRequire("5onBH");
var $215db543e437cbbf$var$defaultAxisOption = {
    type: 'value',
    areaSelectStyle: {
        width: 20,
        borderWidth: 1,
        borderColor: 'rgba(160,197,232)',
        color: 'rgba(160,197,232)',
        opacity: 0.3
    },
    realtime: true,
    z: 10
};
function $215db543e437cbbf$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $aPeC9.default));
    registers.registerComponentModel((0, $kAWnY.default));
    registers.registerCoordinateSystem('parallel', (0, $79vxl.default));
    registers.registerPreprocessor((0, $6tREg.default));
    registers.registerComponentModel((0, $jSODp.default));
    registers.registerComponentView((0, $680yY.default));
    (0, $lzKMz.default)(registers, 'parallel', (0, $jSODp.default), $215db543e437cbbf$var$defaultAxisOption);
    (0, $5onBH.installParallelActions)(registers);
}

});
parcelRegister("6tREg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b7f10fcc16cf501$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");
function $4b7f10fcc16cf501$export$2e2bcd8739ae039(option) {
    $4b7f10fcc16cf501$var$createParallelIfNeeded(option);
    $4b7f10fcc16cf501$var$mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */ function $4b7f10fcc16cf501$var$createParallelIfNeeded(option) {
    if (option.parallel) return;
    var hasParallelSeries = false;
    $2N6Uo.each(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === 'parallel') hasParallelSeries = true;
    });
    if (hasParallelSeries) option.parallel = [
        {}
    ];
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */ function $4b7f10fcc16cf501$var$mergeAxisOptionFromParallel(option) {
    var axes = $bx3T8.normalizeToArray(option.parallelAxis);
    $2N6Uo.each(axes, function(axisOption) {
        if (!$2N6Uo.isObject(axisOption)) return;
        var parallelIndex = axisOption.parallelIndex || 0;
        var parallelOption = $bx3T8.normalizeToArray(option.parallel)[parallelIndex];
        if (parallelOption && parallelOption.parallelAxisDefault) $2N6Uo.merge(axisOption, parallelOption.parallelAxisDefault, false);
    });
}

});

parcelRegister("aPeC9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e1a00ee05ef15bb$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $bpyST = parcelRequire("bpyST");

var $2N6Uo = parcelRequire("2N6Uo");

var $99VtN = parcelRequire("99VtN");
var $7e1a00ee05ef15bb$var$CLICK_THRESHOLD = 5; // > 4
var $7e1a00ee05ef15bb$var$ParallelView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        return _this;
    }
    ParallelView.prototype.render = function(parallelModel, ecModel, api) {
        this._model = parallelModel;
        this._api = api;
        if (!this._handlers) {
            this._handlers = {};
            (0, $2N6Uo.each)($7e1a00ee05ef15bb$var$handlers, function(handler, eventName) {
                api.getZr().on(eventName, this._handlers[eventName] = (0, $2N6Uo.bind)(handler, this));
            }, this);
        }
        (0, $99VtN.createOrUpdate)(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
    };
    ParallelView.prototype.dispose = function(ecModel, api) {
        (0, $99VtN.clear)(this, '_throttledDispatchExpand');
        (0, $2N6Uo.each)(this._handlers, function(handler, eventName) {
            api.getZr().off(eventName, handler);
        });
        this._handlers = null;
    };
    /**
   * @internal
   * @param {Object} [opt] If null, cancel the last action triggering for debounce.
   */ ParallelView.prototype._throttledDispatchExpand = function(opt) {
        this._dispatchExpand(opt);
    };
    /**
   * @internal
   */ ParallelView.prototype._dispatchExpand = function(opt) {
        opt && this._api.dispatchAction((0, $2N6Uo.extend)({
            type: 'parallelAxisExpand'
        }, opt));
    };
    ParallelView.type = 'parallel';
    return ParallelView;
}((0, $bpyST.default));
var $7e1a00ee05ef15bb$var$handlers = {
    mousedown: function(e) {
        if ($7e1a00ee05ef15bb$var$checkTrigger(this, 'click')) this._mouseDownPoint = [
            e.offsetX,
            e.offsetY
        ];
    },
    mouseup: function(e) {
        var mouseDownPoint = this._mouseDownPoint;
        if ($7e1a00ee05ef15bb$var$checkTrigger(this, 'click') && mouseDownPoint) {
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
            if (dist > $7e1a00ee05ef15bb$var$CLICK_THRESHOLD) return;
            var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([
                e.offsetX,
                e.offsetY
            ]);
            result.behavior !== 'none' && this._dispatchExpand({
                axisExpandWindow: result.axisExpandWindow
            });
        }
        this._mouseDownPoint = null;
    },
    mousemove: function(e) {
        // Should do nothing when brushing.
        if (this._mouseDownPoint || !$7e1a00ee05ef15bb$var$checkTrigger(this, 'mousemove')) return;
        var model = this._model;
        var result = model.coordinateSystem.getSlidedAxisExpandWindow([
            e.offsetX,
            e.offsetY
        ]);
        var behavior = result.behavior;
        behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
        this._throttledDispatchExpand(behavior === 'none' ? null // Cancel the last trigger, in case that mouse slide out of the area quickly.
         : {
            axisExpandWindow: result.axisExpandWindow,
            // Jumping uses animation, and sliding suppresses animation.
            animation: behavior === 'jump' ? null : {
                duration: 0 // Disable animation.
            }
        });
    }
};
function $7e1a00ee05ef15bb$var$checkTrigger(view, triggerOn) {
    var model = view._model;
    return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
}
var $7e1a00ee05ef15bb$export$2e2bcd8739ae039 = $7e1a00ee05ef15bb$var$ParallelView;

});

parcelRegister("kAWnY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efe475a4d1a763c2$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $eLD2b = parcelRequire("eLD2b");
var $efe475a4d1a763c2$var$ParallelModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ParallelModel, _super);
    function ParallelModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelModel.type;
        return _this;
    }
    ParallelModel.prototype.init = function() {
        _super.prototype.init.apply(this, arguments);
        this.mergeOption({});
    };
    ParallelModel.prototype.mergeOption = function(newOption) {
        var thisOption = this.option;
        newOption && $2N6Uo.merge(thisOption, newOption, true);
        this._initDimensions();
    };
    /**
   * Whether series or axis is in this coordinate system.
   */ ParallelModel.prototype.contains = function(model, ecModel) {
        var parallelIndex = model.get('parallelIndex');
        return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
    };
    ParallelModel.prototype.setAxisExpand = function(opt) {
        $2N6Uo.each([
            'axisExpandable',
            'axisExpandCenter',
            'axisExpandCount',
            'axisExpandWidth',
            'axisExpandWindow'
        ], function(name) {
            if (opt.hasOwnProperty(name)) // @ts-ignore FIXME: why "never" inferred in this.option[name]?
            this.option[name] = opt[name];
        }, this);
    };
    ParallelModel.prototype._initDimensions = function() {
        var dimensions = this.dimensions = [];
        var parallelAxisIndex = this.parallelAxisIndex = [];
        var axisModels = $2N6Uo.filter(this.ecModel.queryComponents({
            mainType: 'parallelAxis'
        }), function(axisModel) {
            // Can not use this.contains here, because
            // initialization has not been completed yet.
            return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
        }, this);
        $2N6Uo.each(axisModels, function(axisModel) {
            dimensions.push('dim' + axisModel.get('dim'));
            parallelAxisIndex.push(axisModel.componentIndex);
        });
    };
    ParallelModel.type = 'parallel';
    ParallelModel.dependencies = [
        'parallelAxis'
    ];
    ParallelModel.layoutMode = 'box';
    ParallelModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        layout: 'horizontal',
        // FIXME
        // naming?
        axisExpandable: false,
        axisExpandCenter: null,
        axisExpandCount: 0,
        axisExpandWidth: 50,
        axisExpandRate: 17,
        axisExpandDebounce: 50,
        // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
        // Do not doc to user until necessary.
        axisExpandSlideTriggerArea: [
            -0.15,
            0.05,
            0.4
        ],
        axisExpandTriggerOn: 'click',
        parallelAxisDefault: null
    };
    return ParallelModel;
}((0, $eLD2b.default));
var $efe475a4d1a763c2$export$2e2bcd8739ae039 = $efe475a4d1a763c2$var$ParallelModel;

});

parcelRegister("79vxl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5351d63a7e281de1$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel coordinate system creater.
 */ 
var $8UIqc = parcelRequire("8UIqc");

var $bx3T8 = parcelRequire("bx3T8");
function $5351d63a7e281de1$var$createParallelCoordSys(ecModel, api) {
    var coordSysList = [];
    ecModel.eachComponent('parallel', function(parallelModel, idx) {
        var coordSys = new (0, $8UIqc.default)(parallelModel, ecModel, api);
        coordSys.name = 'parallel_' + idx;
        coordSys.resize(parallelModel, api);
        parallelModel.coordinateSystem = coordSys;
        coordSys.model = parallelModel;
        coordSysList.push(coordSys);
    });
    // Inject the coordinateSystems into seriesModel
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get('coordinateSystem') === 'parallel') {
            var parallelModel = seriesModel.getReferringComponents('parallel', (0, $bx3T8.SINGLE_REFERRING)).models[0];
            seriesModel.coordinateSystem = parallelModel.coordinateSystem;
        }
    });
    return coordSysList;
}
var $5351d63a7e281de1$var$parallelCoordSysCreator = {
    create: $5351d63a7e281de1$var$createParallelCoordSys
};
var $5351d63a7e281de1$export$2e2bcd8739ae039 = $5351d63a7e281de1$var$parallelCoordSysCreator;

});
parcelRegister("8UIqc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67d602e3ecad5445$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */ 
var $2N6Uo = parcelRequire("2N6Uo");

var $19Ywy = parcelRequire("19Ywy");

var $a35Wn = parcelRequire("a35Wn");

var $9AF98 = parcelRequire("9AF98");

var $iYj1T = parcelRequire("iYj1T");

var $h9U3p = parcelRequire("h9U3p");

var $iCU10 = parcelRequire("iCU10");

var $43jQn = parcelRequire("43jQn");
var $67d602e3ecad5445$var$each = $2N6Uo.each;
var $67d602e3ecad5445$var$mathMin = Math.min;
var $67d602e3ecad5445$var$mathMax = Math.max;
var $67d602e3ecad5445$var$mathFloor = Math.floor;
var $67d602e3ecad5445$var$mathCeil = Math.ceil;
var $67d602e3ecad5445$var$round = $iCU10.round;
var $67d602e3ecad5445$var$PI = Math.PI;
var $67d602e3ecad5445$var$Parallel = /** @class */ function() {
    function Parallel(parallelModel, ecModel, api) {
        this.type = 'parallel';
        /**
     * key: dimension
     */ this._axesMap = $2N6Uo.createHashMap();
        /**
     * key: dimension
     * value: {position: [], rotation, }
     */ this._axesLayout = {};
        this.dimensions = parallelModel.dimensions;
        this._model = parallelModel;
        this._init(parallelModel, ecModel, api);
    }
    Parallel.prototype._init = function(parallelModel, ecModel, api) {
        var dimensions = parallelModel.dimensions;
        var parallelAxisIndex = parallelModel.parallelAxisIndex;
        $67d602e3ecad5445$var$each(dimensions, function(dim, idx) {
            var axisIndex = parallelAxisIndex[idx];
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axis = this._axesMap.set(dim, new (0, $iYj1T.default)(dim, $9AF98.createScaleByModel(axisModel), [
                0,
                0
            ], axisModel.get('type'), axisIndex));
            var isCategory = axis.type === 'category';
            axis.onBand = isCategory && axisModel.get('boundaryGap');
            axis.inverse = axisModel.get('inverse');
            // Injection
            axisModel.axis = axis;
            axis.model = axisModel;
            axis.coordinateSystem = axisModel.coordinateSystem = this;
        }, this);
    };
    /**
   * Update axis scale after data processed
   */ Parallel.prototype.update = function(ecModel, api) {
        this._updateAxesFromSeries(this._model, ecModel);
    };
    Parallel.prototype.containPoint = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var axisBase = layoutInfo.axisBase;
        var layoutBase = layoutInfo.layoutBase;
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var pAxis = point[1 - pixelDimIndex];
        var pLayout = point[pixelDimIndex];
        return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
    };
    Parallel.prototype.getModel = function() {
        return this._model;
    };
    /**
   * Update properties from series
   */ Parallel.prototype._updateAxesFromSeries = function(parallelModel, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            if (!parallelModel.contains(seriesModel, ecModel)) return;
            var data = seriesModel.getData();
            $67d602e3ecad5445$var$each(this.dimensions, function(dim) {
                var axis = this._axesMap.get(dim);
                axis.scale.unionExtentFromData(data, data.mapDimension(dim));
                $9AF98.niceScaleExtent(axis.scale, axis.model);
            }, this);
        }, this);
    };
    /**
   * Resize the parallel coordinate system.
   */ Parallel.prototype.resize = function(parallelModel, api) {
        var refContainer = $a35Wn.createBoxLayoutReference(parallelModel, api).refContainer;
        this._rect = $a35Wn.getLayoutRect(parallelModel.getBoxLayoutParams(), refContainer);
        this._layoutAxes();
    };
    Parallel.prototype.getRect = function() {
        return this._rect;
    };
    Parallel.prototype._makeLayoutInfo = function() {
        var parallelModel = this._model;
        var rect = this._rect;
        var xy = [
            'x',
            'y'
        ];
        var wh = [
            'width',
            'height'
        ];
        var layout = parallelModel.get('layout');
        var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
        var layoutLength = rect[wh[pixelDimIndex]];
        var layoutExtent = [
            0,
            layoutLength
        ];
        var axisCount = this.dimensions.length;
        var axisExpandWidth = $67d602e3ecad5445$var$restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
        var axisExpandCount = $67d602e3ecad5445$var$restrict(parallelModel.get('axisExpandCount') || 0, [
            0,
            axisCount
        ]);
        var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0;
        // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
        // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
        // where collapsed axes should be overlapped.
        var axisExpandWindow = parallelModel.get('axisExpandWindow');
        var winSize;
        if (!axisExpandWindow) {
            winSize = $67d602e3ecad5445$var$restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
            var axisExpandCenter = parallelModel.get('axisExpandCenter') || $67d602e3ecad5445$var$mathFloor(axisCount / 2);
            axisExpandWindow = [
                axisExpandWidth * axisExpandCenter - winSize / 2
            ];
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        } else {
            winSize = $67d602e3ecad5445$var$restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        }
        var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount);
        // Avoid axisCollapseWidth is too small.
        axisCollapseWidth < 3 && (axisCollapseWidth = 0);
        // Find the first and last indices > ewin[0] and < ewin[1].
        var winInnerIndices = [
            $67d602e3ecad5445$var$mathFloor($67d602e3ecad5445$var$round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1,
            $67d602e3ecad5445$var$mathCeil($67d602e3ecad5445$var$round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1
        ];
        // Pos in ec coordinates.
        var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
        return {
            layout: layout,
            pixelDimIndex: pixelDimIndex,
            layoutBase: rect[xy[pixelDimIndex]],
            layoutLength: layoutLength,
            axisBase: rect[xy[1 - pixelDimIndex]],
            axisLength: rect[wh[1 - pixelDimIndex]],
            axisExpandable: axisExpandable,
            axisExpandWidth: axisExpandWidth,
            axisCollapseWidth: axisCollapseWidth,
            axisExpandWindow: axisExpandWindow,
            axisCount: axisCount,
            winInnerIndices: winInnerIndices,
            axisExpandWindow0Pos: axisExpandWindow0Pos
        };
    };
    Parallel.prototype._layoutAxes = function() {
        var rect = this._rect;
        var axes = this._axesMap;
        var dimensions = this.dimensions;
        var layoutInfo = this._makeLayoutInfo();
        var layout = layoutInfo.layout;
        axes.each(function(axis) {
            var axisExtent = [
                0,
                layoutInfo.axisLength
            ];
            var idx = axis.inverse ? 1 : 0;
            axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
        });
        $67d602e3ecad5445$var$each(dimensions, function(dim, idx) {
            var posInfo = (layoutInfo.axisExpandable ? $67d602e3ecad5445$var$layoutAxisWithExpand : $67d602e3ecad5445$var$layoutAxisWithoutExpand)(idx, layoutInfo);
            var positionTable = {
                horizontal: {
                    x: posInfo.position,
                    y: layoutInfo.axisLength
                },
                vertical: {
                    x: 0,
                    y: posInfo.position
                }
            };
            var rotationTable = {
                horizontal: $67d602e3ecad5445$var$PI / 2,
                vertical: 0
            };
            var position = [
                positionTable[layout].x + rect.x,
                positionTable[layout].y + rect.y
            ];
            var rotation = rotationTable[layout];
            var transform = $19Ywy.create();
            $19Ywy.rotate(transform, transform, rotation);
            $19Ywy.translate(transform, transform, position);
            // TODO
            // tick layout info
            // TODO
            // update dimensions info based on axis order.
            this._axesLayout[dim] = {
                position: position,
                rotation: rotation,
                transform: transform,
                axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
                axisLabelShow: posInfo.axisLabelShow,
                nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
                tickDirection: 1,
                labelDirection: 1
            };
        }, this);
    };
    /**
   * Get axis by dim.
   */ Parallel.prototype.getAxis = function(dim) {
        return this._axesMap.get(dim);
    };
    /**
   * Convert a dim value of a single item of series data to Point.
   */ Parallel.prototype.dataToPoint = function(value, dim) {
        return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
    };
    /**
   * Travel data for one time, get activeState of each data item.
   * @param start the start dataIndex that travel from.
   * @param end the next dataIndex of the last dataIndex will be travel.
   */ Parallel.prototype.eachActiveState = function(data, callback, start, end) {
        start == null && (start = 0);
        end == null && (end = data.count());
        var axesMap = this._axesMap;
        var dimensions = this.dimensions;
        var dataDimensions = [];
        var axisModels = [];
        $2N6Uo.each(dimensions, function(axisDim) {
            dataDimensions.push(data.mapDimension(axisDim));
            axisModels.push(axesMap.get(axisDim).model);
        });
        var hasActiveSet = this.hasAxisBrushed();
        for(var dataIndex = start; dataIndex < end; dataIndex++){
            var activeState = void 0;
            if (!hasActiveSet) activeState = 'normal';
            else {
                activeState = 'active';
                var values = data.getValues(dataDimensions, dataIndex);
                for(var j = 0, lenj = dimensions.length; j < lenj; j++){
                    var state = axisModels[j].getActiveState(values[j]);
                    if (state === 'inactive') {
                        activeState = 'inactive';
                        break;
                    }
                }
            }
            callback(activeState, dataIndex);
        }
    };
    /**
   * Whether has any activeSet.
   */ Parallel.prototype.hasAxisBrushed = function() {
        var dimensions = this.dimensions;
        var axesMap = this._axesMap;
        var hasActiveSet = false;
        for(var j = 0, lenj = dimensions.length; j < lenj; j++)if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') hasActiveSet = true;
        return hasActiveSet;
    };
    /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   */ Parallel.prototype.axisCoordToPoint = function(coord, dim) {
        var axisLayout = this._axesLayout[dim];
        return $h9U3p.applyTransform([
            coord,
            0
        ], axisLayout.transform);
    };
    /**
   * Get axis layout.
   */ Parallel.prototype.getAxisLayout = function(dim) {
        return $2N6Uo.clone(this._axesLayout[dim]);
    };
    /**
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */ Parallel.prototype.getSlidedAxisExpandWindow = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var extent = [
            0,
            layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)
        ];
        // Out of the area of coordinate system.
        if (!this.containPoint(point)) return {
            behavior: 'none',
            axisExpandWindow: axisExpandWindow
        };
        // Convert the point from global to expand coordinates.
        var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos;
        // For dragging operation convenience, the window should not be
        // slided when mouse is the center area of the window.
        var delta;
        var behavior = 'slide';
        var axisCollapseWidth = layoutInfo.axisCollapseWidth;
        var triggerArea = this._model.get('axisExpandSlideTriggerArea');
        // But consider touch device, jump is necessary.
        var useJump = triggerArea[0] != null;
        if (axisCollapseWidth) {
            if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
                behavior = 'jump';
                delta = pointCoord - winSize * triggerArea[2];
            } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
                behavior = 'jump';
                delta = pointCoord - winSize * (1 - triggerArea[2]);
            } else (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
            delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
            delta ? (0, $43jQn.default)(delta, axisExpandWindow, extent, 'all') : behavior = 'none';
        } else {
            var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
            var pos = extent[1] * pointCoord / winSize2;
            axisExpandWindow = [
                $67d602e3ecad5445$var$mathMax(0, pos - winSize2 / 2)
            ];
            axisExpandWindow[1] = $67d602e3ecad5445$var$mathMin(extent[1], axisExpandWindow[0] + winSize2);
            axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
        }
        return {
            axisExpandWindow: axisExpandWindow,
            behavior: behavior
        };
    };
    return Parallel;
}();
function $67d602e3ecad5445$var$restrict(len, extent) {
    return $67d602e3ecad5445$var$mathMin($67d602e3ecad5445$var$mathMax(len, extent[0]), extent[1]);
}
function $67d602e3ecad5445$var$layoutAxisWithoutExpand(axisIndex, layoutInfo) {
    var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
    return {
        position: step * axisIndex,
        axisNameAvailableWidth: step,
        axisLabelShow: true
    };
}
function $67d602e3ecad5445$var$layoutAxisWithExpand(axisIndex, layoutInfo) {
    var layoutLength = layoutInfo.layoutLength;
    var axisExpandWidth = layoutInfo.axisExpandWidth;
    var axisCount = layoutInfo.axisCount;
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
    var winInnerIndices = layoutInfo.winInnerIndices;
    var position;
    var axisNameAvailableWidth = axisCollapseWidth;
    var axisLabelShow = false;
    var nameTruncateMaxWidth;
    if (axisIndex < winInnerIndices[0]) {
        position = axisIndex * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    } else if (axisIndex <= winInnerIndices[1]) {
        position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
        axisNameAvailableWidth = axisExpandWidth;
        axisLabelShow = true;
    } else {
        position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    }
    return {
        position: position,
        axisNameAvailableWidth: axisNameAvailableWidth,
        axisLabelShow: axisLabelShow,
        nameTruncateMaxWidth: nameTruncateMaxWidth
    };
}
var $67d602e3ecad5445$export$2e2bcd8739ae039 = $67d602e3ecad5445$var$Parallel;

});
parcelRegister("9AF98", function(module, exports) {

$parcel$export(module.exports, "getScaleExtent", function () { return $6fb764ac153b275a$export$9c0ba8df7eb7b328; });
$parcel$export(module.exports, "niceScaleExtent", function () { return $6fb764ac153b275a$export$51f3e70a54405d5a; });
$parcel$export(module.exports, "retrieveAxisBreaksOption", function () { return $6fb764ac153b275a$export$8094779d9b724f85; });
$parcel$export(module.exports, "createScaleByModel", function () { return $6fb764ac153b275a$export$8941c4cacdc8f5a5; });
$parcel$export(module.exports, "ifAxisCrossZero", function () { return $6fb764ac153b275a$export$3eac36a69f37d52; });
$parcel$export(module.exports, "makeLabelFormatter", function () { return $6fb764ac153b275a$export$742f19a75415b2ae; });
$parcel$export(module.exports, "getAxisRawValue", function () { return $6fb764ac153b275a$export$a5a32f324c1fa457; });
$parcel$export(module.exports, "getOptionCategoryInterval", function () { return $6fb764ac153b275a$export$6d0bc2429155c088; });
$parcel$export(module.exports, "shouldShowAllLabels", function () { return $6fb764ac153b275a$export$c2911c025243d6a6; });
$parcel$export(module.exports, "getDataDimensionsOnAxis", function () { return $6fb764ac153b275a$export$e4cf30b1e74cd69d; });
$parcel$export(module.exports, "unionAxisExtentFromData", function () { return $6fb764ac153b275a$export$635fe7f20d0f4c70; });
$parcel$export(module.exports, "isNameLocationCenter", function () { return $6fb764ac153b275a$export$c06aa22293dea9d2; });
$parcel$export(module.exports, "shouldAxisShow", function () { return $6fb764ac153b275a$export$75b737736393e03c; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $cpzWt = parcelRequire("cpzWt");

var $k1WNO = parcelRequire("k1WNO");

var $e4H3Q = parcelRequire("e4H3Q");

var $5qNR7 = parcelRequire("5qNR7");

var $9X29M = parcelRequire("9X29M");

var $bC2H8 = parcelRequire("bC2H8");

var $a1eW0 = parcelRequire("a1eW0");

var $h4rbp = parcelRequire("h4rbp");

var $7Mt3p = parcelRequire("7Mt3p");

var $bjlCM = parcelRequire("bjlCM");

function $6fb764ac153b275a$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $h4rbp.ensureScaleRawExtentInfo)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max;
    // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === 'time' /* || scaleType === 'interval' */ ) {
        var barSeriesModels = (0, $5qNR7.prepareLayoutBarSeries)('bar', ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $2N6Uo.each(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $5qNR7.makeColumnLayout)(barSeriesModels);
            // Adjust axis min and max to account for overflow
            var adjustedScale = $6fb764ac153b275a$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $6fb764ac153b275a$var$adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = Math.abs(axisExtent[1] - axisExtent[0]);
    // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $5qNR7.retrieveColumnLayout)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $2N6Uo.each(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $2N6Uo.each(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow;
    // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
}
function $6fb764ac153b275a$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $6fb764ac153b275a$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get('splitNumber');
    if (scale instanceof (0, $bC2H8.default)) scale.base = model.get('logBase');
    var scaleType = scale.type;
    var interval = model.get('interval');
    var isIntervalOrTime = scaleType === 'interval' || scaleType === 'time';
    scale.setBreaksFromOption($6fb764ac153b275a$export$8094779d9b724f85(model));
    scale.setExtent(extent[0], extent[1]);
    scale.calcNiceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: isIntervalOrTime ? model.get('minInterval') : null,
        maxInterval: isIntervalOrTime ? model.get('maxInterval') : null
    });
    // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $6fb764ac153b275a$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $cpzWt.default)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $9X29M.default)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $e4H3Q.default).getClass(axisType) || (0, $k1WNO.default))();
    }
}
function $6fb764ac153b275a$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $6fb764ac153b275a$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    if (axis.type === 'time') {
        var parsed_1 = (0, $7Mt3p.parseTimeAxisLabelFormatter)(labelFormatter);
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, parsed_1);
        };
    } else if ($2N6Uo.isString(labelFormatter)) return function(tick) {
        // For category axis, get raw value; for numeric axis,
        // get formatted label like '1,333,444'.
        var label = axis.scale.getLabel(tick);
        var text = labelFormatter.replace('{value}', label != null ? label : '');
        return text;
    };
    else if ($2N6Uo.isFunction(labelFormatter)) {
        if (axis.type === 'category') return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            return labelFormatter($6fb764ac153b275a$export$a5a32f324c1fa457(axis, tick), tick.value - axis.scale.getExtent()[0], null // Using `null` just for backward compat.
            );
        };
        var scaleBreakHelper_1 = (0, $bjlCM.getScaleBreakHelper)();
        return function(tick, idx) {
            // Using `null` just for backward compat. It's been found that in the `test/axis-customTicks.html`,
            // there is a formatter `function (value, index, revers = true) { ... }`. Although the third param
            // `revers` is incorrect and always `null`, changing it might introduce a breaking change.
            var extra = null;
            if (scaleBreakHelper_1) extra = scaleBreakHelper_1.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
            return labelFormatter($6fb764ac153b275a$export$a5a32f324c1fa457(axis, tick), idx, extra);
        };
    } else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $6fb764ac153b275a$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
function $6fb764ac153b275a$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $6fb764ac153b275a$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $6fb764ac153b275a$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $6fb764ac153b275a$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $2N6Uo.each(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $a1eW0.getStackedDimension)(data, dataDim)] = true;
    });
    return $2N6Uo.keys(dataDimMap);
}
function $6fb764ac153b275a$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $2N6Uo.each($6fb764ac153b275a$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}
function $6fb764ac153b275a$export$c06aa22293dea9d2(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $6fb764ac153b275a$export$75b737736393e03c(axisModel) {
    return axisModel.getShallow('show');
}
function $6fb764ac153b275a$export$8094779d9b724f85(model) {
    var option = model.get('breaks', true);
    if (option != null) {
        if (!(0, $bjlCM.getScaleBreakHelper)()) return undefined;
        if (!$6fb764ac153b275a$var$isSupportAxisBreak(model.axis)) return undefined;
        return option;
    }
}
function $6fb764ac153b275a$var$isSupportAxisBreak(axis) {
    // The polar radius axis can also support break feasibly. Do not do it until the requirements are met.
    return (axis.dim === 'x' || axis.dim === 'y' || axis.dim === 'z' || axis.dim === 'single') && axis.type !== 'category';
}

});
parcelRegister("cpzWt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9093b3348440c75f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $e4H3Q = parcelRequire("e4H3Q");

var $72H2h = parcelRequire("72H2h");

var $b0HC9 = parcelRequire("b0HC9");

var $2N6Uo = parcelRequire("2N6Uo");
var $9093b3348440c75f$var$OrdinalScale = /** @class */ function(_super) {
    (0, $9nEce.__extends)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = 'ordinal';
        var ordinalMeta = _this.getSetting('ordinalMeta');
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $72H2h.default)({});
        if ((0, $2N6Uo.isArray)(ordinalMeta)) ordinalMeta = new (0, $72H2h.default)({
            categories: (0, $2N6Uo.map)(ordinalMeta, function(item) {
                return (0, $2N6Uo.isObject)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting('extent') || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) return NaN;
        return (0, $2N6Uo.isString)(val) ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(val) {
        return $b0HC9.contain(val, this._extent) && val >= 0 && val < this._ordinalMeta.categories.length;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(val);
        return this._calculator.normalize(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round(this._calculator.scale(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? '' : cateogry + '';
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.calcNiceTicks = function() {};
    OrdinalScale.prototype.calcNiceExtent = function() {};
    OrdinalScale.type = 'ordinal';
    return OrdinalScale;
}((0, $e4H3Q.default));
(0, $e4H3Q.default).registerClass($9093b3348440c75f$var$OrdinalScale);
var $9093b3348440c75f$export$2e2bcd8739ae039 = $9093b3348440c75f$var$OrdinalScale;

});
parcelRegister("e4H3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3f2d767c3b408aa$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $I7Ovw = parcelRequire("I7Ovw");

var $b0HC9 = parcelRequire("b0HC9");

var $2N6Uo = parcelRequire("2N6Uo");

var $bjlCM = parcelRequire("bjlCM");
var $a3f2d767c3b408aa$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._calculator = new (0, $b0HC9.ScaleCalculator)();
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
        var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
        if (scaleBreakHelper) {
            this._brkCtx = scaleBreakHelper.createScaleBreakContext();
            this._brkCtx.update(this._extent);
        }
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerUnionExtent = function(other) {
        var extent = this._extent;
        // Considered that number could be NaN and should not write into the extent.
        this._innerSetExtent(other[0] < extent[0] ? other[0] : extent[0], other[1] > extent[1] ? other[1] : extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this._innerUnionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get a new slice of extent.
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    Scale.prototype.setExtent = function(start, end) {
        this._innerSetExtent(start, end);
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerSetExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
        this._brkCtx && this._brkCtx.update(thisExtent);
    };
    /**
   * Prerequisite: Scale#parse is ready.
   */ Scale.prototype.setBreaksFromOption = function(breakOptionList) {
        var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
        if (scaleBreakHelper) this._innerSetBreak(scaleBreakHelper.parseAxisBreakOption(breakOptionList, (0, $2N6Uo.bind)(this.parse, this)));
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerSetBreak = function(parsed) {
        if (this._brkCtx) {
            this._brkCtx.setBreaks(parsed);
            this._calculator.updateMethods(this._brkCtx);
            this._brkCtx.update(this._extent);
        }
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerGetBreaks = function() {
        return this._brkCtx ? this._brkCtx.breaks : [];
    };
    /**
   * Do not expose the internal `_breaks` unless necessary.
   */ Scale.prototype.hasBreaks = function() {
        return this._brkCtx ? this._brkCtx.hasBreaks() : false;
    };
    Scale.prototype._getExtentSpanWithBreaks = function() {
        return this._brkCtx && this._brkCtx.hasBreaks() ? this._brkCtx.getExtentSpan() : this._extent[1] - this._extent[0];
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$I7Ovw.enableClassManagement($a3f2d767c3b408aa$var$Scale);
var $a3f2d767c3b408aa$export$2e2bcd8739ae039 = $a3f2d767c3b408aa$var$Scale;

});
parcelRegister("b0HC9", function(module, exports) {

$parcel$export(module.exports, "isIntervalOrLogScale", function () { return $804186acc4b1cff0$export$dfc8cd28ed7b22a0; });
$parcel$export(module.exports, "intervalScaleNiceTicks", function () { return $804186acc4b1cff0$export$eeea879a611eb991; });
$parcel$export(module.exports, "getIntervalPrecision", function () { return $804186acc4b1cff0$export$86a060b060d3d31a; });
$parcel$export(module.exports, "increaseInterval", function () { return $804186acc4b1cff0$export$f39031e8422f329d; });
$parcel$export(module.exports, "contain", function () { return $804186acc4b1cff0$export$8893e2b90ba10d92; });
$parcel$export(module.exports, "ScaleCalculator", function () { return $804186acc4b1cff0$export$94a76197a12818ce; });
$parcel$export(module.exports, "logTransform", function () { return $804186acc4b1cff0$export$a6588cdf5be114b3; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");
function $804186acc4b1cff0$export$a8a5b03ea14764df(val) {
    var exp10 = Math.pow(10, (0, $iCU10.quantityExponent)(Math.abs(val)));
    var f = Math.abs(val / exp10);
    return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function $804186acc4b1cff0$export$dfc8cd28ed7b22a0(scale) {
    return scale.type === 'interval' || scale.type === 'log';
}
function $804186acc4b1cff0$export$eeea879a611eb991(extent, spanWithBreaks, splitNumber, minInterval, maxInterval) {
    var result = {};
    var interval = result.interval = (0, $iCU10.nice)(spanWithBreaks / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    // Tow more digital for tick.
    var precision = result.intervalPrecision = $804186acc4b1cff0$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        (0, $iCU10.round)(Math.ceil(extent[0] / interval) * interval, precision),
        (0, $iCU10.round)(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $804186acc4b1cff0$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $804186acc4b1cff0$export$f39031e8422f329d(interval) {
    var exp10 = Math.pow(10, (0, $iCU10.quantityExponent)(interval));
    // Increase interval
    var f = interval / exp10;
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    return (0, $iCU10.round)(f * exp10);
}
function $804186acc4b1cff0$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return (0, $iCU10.getPrecision)(interval) + 2;
}
function $804186acc4b1cff0$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
}
function $804186acc4b1cff0$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $804186acc4b1cff0$var$clamp(niceTickExtent, 0, extent);
    $804186acc4b1cff0$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $804186acc4b1cff0$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
var $804186acc4b1cff0$export$94a76197a12818ce = /** @class */ function() {
    function ScaleCalculator() {
        this.normalize = $804186acc4b1cff0$var$normalize;
        this.scale = $804186acc4b1cff0$var$scale;
    }
    ScaleCalculator.prototype.updateMethods = function(brkCtx) {
        if (brkCtx.hasBreaks()) {
            this.normalize = (0, $2N6Uo.bind)(brkCtx.normalize, brkCtx);
            this.scale = (0, $2N6Uo.bind)(brkCtx.scale, brkCtx);
        } else {
            this.normalize = $804186acc4b1cff0$var$normalize;
            this.scale = $804186acc4b1cff0$var$scale;
        }
    };
    return ScaleCalculator;
}();
function $804186acc4b1cff0$var$normalize(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $804186acc4b1cff0$var$scale(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}
function $804186acc4b1cff0$export$a6588cdf5be114b3(base, extent, noClampNegative) {
    var loggedBase = Math.log(base);
    return [
        // log(negative) is NaN, so safe guard here.
        // PENDING: But even getting a -Infinity still does not make sense in extent.
        //  Just keep it as is, getting a NaN to make some previous cases works by coincidence.
        Math.log(noClampNegative ? extent[0] : Math.max(0, extent[0])) / loggedBase,
        Math.log(noClampNegative ? extent[1] : Math.max(0, extent[1])) / loggedBase
    ];
}

});


parcelRegister("72H2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $520a1a568f9e700e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $520a1a568f9e700e$var$uidBase = 0;
var $520a1a568f9e700e$var$OrdinalMeta = /** @class */ function() {
    /**
   * PENDING - Regarding forcibly converting to string:
   *  In the early days, the underlying hash map impl used JS plain object and converted the key to
   *  string; later in https://github.com/ecomfe/zrender/pull/966 it was changed to a JS Map (in supported
   *  platforms), which does not require string keys. But consider any input that `scale/Ordinal['parse']`
   *  is involved, a number input represents an `OrdinalNumber` (i.e., an index), and affect the query
   *  behavior:
   *    - If forcbily converting to string:
   *      pros: users can use numeric string (such as, '123') to query the raw data (123), tho it's probably
   *      still confusing.
   *      cons: NaN/null/undefined in data will be equals to 'NaN'/'null'/'undefined', if simply using
   *      `val + ''` to convert them, like currently `getName` does.
   *    - Otherwise:
   *      pros: see NaN/null/undefined case above.
   *      cons: users cannot query the raw data (123) any more.
   *  There are two inconsistent behaviors in the current impl:
   *    - Force conversion is applied on the case `xAxis{data: ['aaa', 'bbb', ...]}`,
   *      but no conversion applied to the case `xAxis{data: [{value: 'aaa'}, ...]}` and
   *      the case `dataset: {source: [['aaa', 123], ['bbb', 234], ...]}`.
   *    - behaves differently according to whether JS Map is supported (the polyfill is simply using JS
   *      plain object) (tho it seems rare platform that do not support it).
   *  Since there's no sufficient good solution to offset cost of the breaking change, we preserve the
   *  current behavior, until real issues is reported.
   */ function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$520a1a568f9e700e$var$uidBase;
        this._onCollect = opt.onCollect;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $2N6Uo.map)(data, $520a1a568f9e700e$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $2N6Uo.isString)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            this._onCollect && this._onCollect(category, index);
            return index;
        }
        var map = this._getOrCreateMap();
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                map.set(category, index);
                this._onCollect && this._onCollect(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $2N6Uo.createHashMap)(this.categories));
    };
    return OrdinalMeta;
}();
function $520a1a568f9e700e$var$getName(obj) {
    if ((0, $2N6Uo.isObject)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $520a1a568f9e700e$export$2e2bcd8739ae039 = $520a1a568f9e700e$var$OrdinalMeta;

});


parcelRegister("k1WNO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e951839abcf4f831$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $iCU10 = parcelRequire("iCU10");

var $hrphB = parcelRequire("hrphB");

var $e4H3Q = parcelRequire("e4H3Q");

var $b0HC9 = parcelRequire("b0HC9");

var $bjlCM = parcelRequire("bjlCM");
var $e951839abcf4f831$var$roundNumber = $iCU10.round;
var $e951839abcf4f831$var$IntervalScale = /** @class */ function(_super) {
    (0, $9nEce.__extends)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'interval';
        // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        // `Scale#parse` (and its overrids) are typically applied at the axis values input
        // in echarts option. e.g., `axis.min/max`, `dataZoom.min/max`, etc.
        // but `series.data` is not included, which uses `dataValueHelper.ts`#`parseDataValue`.
        // `Scale#parse` originally introduced in fb8c813215098b9d2458966229bb95c510883d5e
        // at 2016 for dataZoom start/end settings (See `parseAxisModelMinMax`).
        //
        // Historically `scale/Interval.ts` returns the input value directly. But numeric
        // values (such as a number-like string '123') effectively passed through here and
        // were involved in calculations, which was error-prone and inconsistent with the
        // declared TS return type. Previously such issues are fixed separately in different
        // places case by case (such as #2475).
        //
        // Now, we perform actual parse to ensure its `number` type here. The parsing rule
        // follows the series data parsing rule (`dataValueHelper.ts`#`parseDataValue`)
        // and maintains compatibility as much as possible (thus a more strict parsing
        // `number.ts`#`numericToNumber` is not used here.)
        //
        // FIXME: `ScaleDataValue` also need to be modified to include numeric string type,
        //  since it effectively does.
        return val == null || val === '' ? NaN : Number(val);
    };
    IntervalScale.prototype.contain = function(val) {
        return $b0HC9.contain(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return this._calculator.normalize(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return this._calculator.scale(val, this._extent);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval;
        // Dropped auto calculated niceExtent and use user-set extent.
        // We assume user wants to set both interval, min, max to get a better result.
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $b0HC9.getIntervalPrecision(interval);
    };
    /**
   * @override
   */ IntervalScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        if (opt.breakTicks === 'only_break' && scaleBreakHelper) {
            scaleBreakHelper.addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
            return ticks;
        }
        // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (opt.expandToNicedExtent) ticks.push({
                value: $e951839abcf4f831$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var estimateNiceMultiple = function(tickVal, targetTick) {
            return Math.round((targetTick - tickVal) / interval);
        };
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = $e951839abcf4f831$var$roundNumber(tick + interval, intervalPrecision);
            if (this._brkCtx) {
                var moreMultiple = this._brkCtx.calcNiceTickMultiple(tick, estimateNiceMultiple);
                if (moreMultiple >= 0) tick = $e951839abcf4f831$var$roundNumber(tick + moreMultiple * interval, intervalPrecision);
            }
            if (ticks.length > 0 && tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (opt.expandToNicedExtent) ticks.push({
                value: $e951839abcf4f831$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        if (scaleBreakHelper) scaleBreakHelper.pruneTicksByBreak(opt.pruneByBreak, ticks, this._brkCtx.breaks, function(item) {
            return item.value;
        }, this._interval, this._extent);
        if (opt.breakTicks !== 'none' && scaleBreakHelper) scaleBreakHelper.addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks({
            expandToNicedExtent: true
        });
        // NOTE: In log-scale, do not support minor ticks when breaks exist.
        //  because currently log-scale minor ticks is calculated based on raw values
        //  rather than log-transformed value, due to an odd effect when breaks exist.
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            if (prevTick["break"] || nextTick["break"]) continue;
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            var minorIntervalPrecision = $b0HC9.getIntervalPrecision(minorInterval);
            while(count < splitNumber - 1){
                var minorTick = $e951839abcf4f831$var$roundNumber(prevTick.value + (count + 1) * minorInterval, minorIntervalPrecision);
                // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
            scaleBreakHelper && scaleBreakHelper.pruneTicksByBreak('auto', minorTicksGroup, this._getNonTransBreaks(), function(value) {
                return value;
            }, this._interval, extent);
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    IntervalScale.prototype._getNonTransBreaks = function() {
        return this._brkCtx ? this._brkCtx.breaks : [];
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = $iCU10.getPrecision(data.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $e951839abcf4f831$var$roundNumber(data.value, precision, true);
        return $hrphB.addCommas(dataNum);
    };
    /**
   * FIXME: refactor - disallow override, use composition instead.
   *
   * The override of `calcNiceTicks` should ensure these members are provided:
   *  this._intervalPrecision
   *  this._interval
   *
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.calcNiceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent.slice();
        var span = this._getExtentSpanWithBreaks();
        if (!isFinite(span)) return;
        // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
            this._innerSetExtent(extent[0], extent[1]);
            extent = this._extent.slice();
        }
        var result = $b0HC9.intervalScaleNiceTicks(extent, span, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent.slice();
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                // Note that extents can be both negative. See #13154
                var expandSize = Math.abs(extent[0]);
                // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0];
        // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this._innerSetExtent(extent[0], extent[1]);
        extent = this._extent.slice();
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        var interval = this._interval;
        var intervalPrecition = this._intervalPrecision;
        if (!opt.fixMin) extent[0] = $e951839abcf4f831$var$roundNumber(Math.floor(extent[0] / interval) * interval, intervalPrecition);
        if (!opt.fixMax) extent[1] = $e951839abcf4f831$var$roundNumber(Math.ceil(extent[1] / interval) * interval, intervalPrecition);
        this._innerSetExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.setNiceExtent = function(min, max) {
        this._niceExtent = [
            min,
            max
        ];
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $e4H3Q.default));
(0, $e4H3Q.default).registerClass($e951839abcf4f831$var$IntervalScale);
var $e951839abcf4f831$export$2e2bcd8739ae039 = $e951839abcf4f831$var$IntervalScale;

});

parcelRegister("9X29M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73eb4c05cc3b5bf2$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $iCU10 = parcelRequire("iCU10");

var $7Mt3p = parcelRequire("7Mt3p");

var $b0HC9 = parcelRequire("b0HC9");

var $k1WNO = parcelRequire("k1WNO");

var $e4H3Q = parcelRequire("e4H3Q");


var $2N6Uo = parcelRequire("2N6Uo");

var $bjlCM = parcelRequire("bjlCM");
// FIXME 公用？
var $73eb4c05cc3b5bf2$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $73eb4c05cc3b5bf2$var$TimeScale = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = 'time';
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting('useUTC');
        return (0, $7Mt3p.format)(tick.value, (0, $7Mt3p.fullLeveledFormatter)[(0, $7Mt3p.getDefaultFormatPrecisionOfInterval)((0, $7Mt3p.getPrimaryTimeUnit)(this._minLevelUnit))] || (0, $7Mt3p.fullLeveledFormatter).second, useUTC, this.getSetting('locale'));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting('useUTC');
        var lang = this.getSetting('locale');
        return (0, $7Mt3p.leveledFormat)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   */ TimeScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = this._extent;
        var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        var useUTC = this.getSetting('useUTC');
        if (scaleBreakHelper && opt.breakTicks === 'only_break') {
            (0, $bjlCM.getScaleBreakHelper)().addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
            return ticks;
        }
        var extent0Unit = (0, $7Mt3p.getUnitFromValue)(extent[1], useUTC);
        ticks.push({
            value: extent[0],
            time: {
                level: 0,
                upperTimeUnit: extent0Unit,
                lowerTimeUnit: extent0Unit
            }
        });
        var innerTicks = $73eb4c05cc3b5bf2$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent, this._getExtentSpanWithBreaks(), this._brkCtx);
        ticks = ticks.concat(innerTicks);
        var extent1Unit = (0, $7Mt3p.getUnitFromValue)(extent[1], useUTC);
        ticks.push({
            value: extent[1],
            time: {
                level: 0,
                upperTimeUnit: extent1Unit,
                lowerTimeUnit: extent1Unit
            }
        });
        var isUTC = this.getSetting('useUTC');
        var upperUnitIndex = (0, $7Mt3p.primaryTimeUnits).length - 1;
        var maxLevel = 0;
        (0, $2N6Uo.each)(ticks, function(tick) {
            upperUnitIndex = Math.min(upperUnitIndex, (0, $2N6Uo.indexOf)((0, $7Mt3p.primaryTimeUnits), tick.time.upperTimeUnit));
            maxLevel = Math.max(maxLevel, tick.time.level);
        });
        if (scaleBreakHelper) (0, $bjlCM.getScaleBreakHelper)().pruneTicksByBreak(opt.pruneByBreak, ticks, this._brkCtx.breaks, function(item) {
            return item.value;
        }, this._approxInterval, this._extent);
        if (scaleBreakHelper && opt.breakTicks !== 'none') (0, $bjlCM.getScaleBreakHelper)().addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent, function(trimmedBrk) {
            // @see `parseTimeAxisLabelFormatterDictionary`.
            var lowerBrkUnitIndex = Math.max((0, $2N6Uo.indexOf)((0, $7Mt3p.primaryTimeUnits), (0, $7Mt3p.getUnitFromValue)(trimmedBrk.vmin, isUTC)), (0, $2N6Uo.indexOf)((0, $7Mt3p.primaryTimeUnits), (0, $7Mt3p.getUnitFromValue)(trimmedBrk.vmax, isUTC)));
            var upperBrkUnitIndex = 0;
            for(var unitIdx = 0; unitIdx < (0, $7Mt3p.primaryTimeUnits).length; unitIdx++)if (!$73eb4c05cc3b5bf2$var$isPrimaryUnitValueAndGreaterSame((0, $7Mt3p.primaryTimeUnits)[unitIdx], trimmedBrk.vmin, trimmedBrk.vmax, isUTC)) {
                upperBrkUnitIndex = unitIdx;
                break;
            }
            var upperIdx = Math.min(upperBrkUnitIndex, upperUnitIndex);
            var lowerIdx = Math.max(upperIdx, lowerBrkUnitIndex);
            return {
                level: maxLevel,
                lowerTimeUnit: (0, $7Mt3p.primaryTimeUnits)[lowerIdx],
                upperTimeUnit: (0, $7Mt3p.primaryTimeUnits)[upperIdx]
            };
        });
        return ticks;
    };
    TimeScale.prototype.calcNiceExtent = function(opt) {
        var extent = this.getExtent();
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $7Mt3p.ONE_DAY);
            extent[1] += (0, $7Mt3p.ONE_DAY);
        }
        // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $7Mt3p.ONE_DAY);
        }
        this._innerSetExtent(extent[0], extent[1]);
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.calcNiceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var span = this._getExtentSpanWithBreaks();
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $73eb4c05cc3b5bf2$var$scaleIntervals.length;
        var idx = Math.min($73eb4c05cc3b5bf2$var$bisect($73eb4c05cc3b5bf2$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
        // Interval that can be used to calculate ticks
        this._interval = $73eb4c05cc3b5bf2$var$scaleIntervals[idx][1];
        this._intervalPrecision = $b0HC9.getIntervalPrecision(this._interval);
        // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $73eb4c05cc3b5bf2$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return (0, $2N6Uo.isNumber)(val) ? val : +$iCU10.parseDate(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $b0HC9.contain(val, this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return this._calculator.normalize(val, this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return this._calculator.scale(val, this._extent);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $k1WNO.default));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $73eb4c05cc3b5bf2$var$scaleIntervals = [
    // Format                           interval
    [
        'second',
        (0, $7Mt3p.ONE_SECOND)
    ],
    [
        'minute',
        (0, $7Mt3p.ONE_MINUTE)
    ],
    [
        'hour',
        (0, $7Mt3p.ONE_HOUR)
    ],
    [
        'quarter-day',
        (0, $7Mt3p.ONE_HOUR) * 6
    ],
    [
        'half-day',
        (0, $7Mt3p.ONE_HOUR) * 12
    ],
    [
        'day',
        (0, $7Mt3p.ONE_DAY) * 1.2
    ],
    [
        'half-week',
        (0, $7Mt3p.ONE_DAY) * 3.5
    ],
    [
        'week',
        (0, $7Mt3p.ONE_DAY) * 7
    ],
    [
        'month',
        (0, $7Mt3p.ONE_DAY) * 31
    ],
    [
        'quarter',
        (0, $7Mt3p.ONE_DAY) * 95
    ],
    [
        'half-year',
        (0, $7Mt3p.ONE_YEAR) / 2
    ],
    [
        'year',
        (0, $7Mt3p.ONE_YEAR)
    ] // 1Y
];
function $73eb4c05cc3b5bf2$var$isPrimaryUnitValueAndGreaterSame(unit, valueA, valueB, isUTC) {
    return (0, $7Mt3p.roundTime)(new Date(valueA), unit, isUTC).getTime() === (0, $7Mt3p.roundTime)(new Date(valueB), unit, isUTC).getTime();
}
// function isUnitValueSame(
//     unit: PrimaryTimeUnit,
//     valueA: number,
//     valueB: number,
//     isUTC: boolean
// ): boolean {
//     const dateA = numberUtil.parseDate(valueA) as any;
//     const dateB = numberUtil.parseDate(valueB) as any;
//     const isSame = (unit: PrimaryTimeUnit) => {
//         return getUnitValue(dateA, unit, isUTC)
//             === getUnitValue(dateB, unit, isUTC);
//     };
//     const isSameYear = () => isSame('year');
//     // const isSameHalfYear = () => isSameYear() && isSame('half-year');
//     // const isSameQuater = () => isSameYear() && isSame('quarter');
//     const isSameMonth = () => isSameYear() && isSame('month');
//     const isSameDay = () => isSameMonth() && isSame('day');
//     // const isSameHalfDay = () => isSameDay() && isSame('half-day');
//     const isSameHour = () => isSameDay() && isSame('hour');
//     const isSameMinute = () => isSameHour() && isSame('minute');
//     const isSameSecond = () => isSameMinute() && isSame('second');
//     const isSameMilliSecond = () => isSameSecond() && isSame('millisecond');
//     switch (unit) {
//         case 'year':
//             return isSameYear();
//         case 'month':
//             return isSameMonth();
//         case 'day':
//             return isSameDay();
//         case 'hour':
//             return isSameHour();
//         case 'minute':
//             return isSameMinute();
//         case 'second':
//             return isSameSecond();
//         case 'millisecond':
//             return isSameMilliSecond();
//     }
// }
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $73eb4c05cc3b5bf2$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $7Mt3p.ONE_DAY);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $73eb4c05cc3b5bf2$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $7Mt3p.ONE_DAY);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $73eb4c05cc3b5bf2$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $7Mt3p.ONE_HOUR);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $73eb4c05cc3b5bf2$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $7Mt3p.ONE_MINUTE) : (0, $7Mt3p.ONE_SECOND);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $73eb4c05cc3b5bf2$var$getMillisecondsInterval(approxInterval) {
    return $iCU10.nice(approxInterval, true);
}
// e.g., if the input unit is 'day', start calculate ticks from the first day of
// that month to make ticks "nice".
function $73eb4c05cc3b5bf2$var$getFirstTimestampOfUnit(timestamp, unitName, isUTC) {
    var upperUnitIdx = Math.max(0, (0, $2N6Uo.indexOf)((0, $7Mt3p.primaryTimeUnits), unitName) - 1);
    return (0, $7Mt3p.roundTime)(new Date(timestamp), (0, $7Mt3p.primaryTimeUnits)[upperUnitIdx], isUTC).getTime();
}
function $73eb4c05cc3b5bf2$var$createEstimateNiceMultiple(setMethodName, dateMethodInterval) {
    var tmpDate = new Date(0);
    tmpDate[setMethodName](1);
    var tmpTime = tmpDate.getTime();
    tmpDate[setMethodName](1 + dateMethodInterval);
    var approxTimeInterval = tmpDate.getTime() - tmpTime;
    return function(tickVal, targetValue) {
        // Only in month that accurate result can not get by division of
        // timestamp interval, but no need accurate here.
        return Math.max(0, Math.round((targetValue - tickVal) / approxTimeInterval));
    };
}
function $73eb4c05cc3b5bf2$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent, extentSpanWithBreaks, brkCtx) {
    var safeLimit = 10000;
    var unitNames = (0, $7Mt3p.timeUnits);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var estimateNiceMultiple = $73eb4c05cc3b5bf2$var$createEstimateNiceMultiple(setMethodName, interval);
        var dateTime = minTimestamp;
        var date = new Date(dateTime);
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            if (iter++ > safeLimit) break;
            date[setMethodName](date[getMethodName]() + interval);
            dateTime = date.getTime();
            if (brkCtx) {
                var moreMultiple = brkCtx.calcNiceTickMultiple(dateTime, estimateNiceMultiple);
                if (moreMultiple > 0) {
                    date[setMethodName](date[getMethodName]() + moreMultiple * interval);
                    dateTime = date.getTime();
                }
            }
        }
        // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($73eb4c05cc3b5bf2$var$isPrimaryUnitValueAndGreaterSame((0, $7Mt3p.getPrimaryTimeUnit)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                value: $73eb4c05cc3b5bf2$var$getFirstTimestampOfUnit(extent[0], unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $7Mt3p.ONE_DAY) / 365));
                    getterName = (0, $7Mt3p.fullYearGetterName)(isUTC);
                    setterName = (0, $7Mt3p.fullYearSetterName)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $73eb4c05cc3b5bf2$var$getMonthInterval(approxInterval);
                    getterName = (0, $7Mt3p.monthGetterName)(isUTC);
                    setterName = (0, $7Mt3p.monthSetterName)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $73eb4c05cc3b5bf2$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $7Mt3p.dateGetterName)(isUTC);
                    setterName = (0, $7Mt3p.dateSetterName)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $73eb4c05cc3b5bf2$var$getHourInterval(approxInterval);
                    getterName = (0, $7Mt3p.hoursGetterName)(isUTC);
                    setterName = (0, $7Mt3p.hoursSetterName)(isUTC);
                    break;
                case 'minute':
                    interval = $73eb4c05cc3b5bf2$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $7Mt3p.minutesGetterName)(isUTC);
                    setterName = (0, $7Mt3p.minutesSetterName)(isUTC);
                    break;
                case 'second':
                    interval = $73eb4c05cc3b5bf2$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $7Mt3p.secondsGetterName)(isUTC);
                    setterName = (0, $7Mt3p.secondsSetterName)(isUTC);
                    break;
                case 'millisecond':
                    interval = $73eb4c05cc3b5bf2$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $7Mt3p.millisecondsGetterName)(isUTC);
                    setterName = (0, $7Mt3p.millisecondsSetterName)(isUTC);
                    break;
            }
            // Notice: This expansion by `getFirstTimestampOfUnit` may cause too many ticks and
            // iteration. e.g., when three levels of ticks is displayed, which can be caused by
            // data zoom and axis breaks. Thus trim them here.
            if (endTick >= extent[0] && startTick <= extent[1]) addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length; ++i){
        var primaryTimeUnit = (0, $7Mt3p.getPrimaryTimeUnit)(unitNames[i]);
        if (!(0, $7Mt3p.isPrimaryTimeUnit)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $7Mt3p.getPrimaryTimeUnit)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = extentSpanWithBreaks / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $2N6Uo.filter)((0, $2N6Uo.map)(levelsTicks, function(levelTicks) {
        return (0, $2N6Uo.filter)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k){
            var unit = (0, $7Mt3p.getUnitFromValue)(levelTicks[k].value, isUTC);
            ticks.push({
                value: levelTicks[k].value,
                time: {
                    level: maxLevel - i,
                    upperTimeUnit: unit,
                    lowerTimeUnit: unit
                }
            });
        }
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $e4H3Q.default).registerClass($73eb4c05cc3b5bf2$var$TimeScale);
var $73eb4c05cc3b5bf2$export$2e2bcd8739ae039 = $73eb4c05cc3b5bf2$var$TimeScale;

});

parcelRegister("bC2H8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $874555748a3039ea$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $e4H3Q = parcelRequire("e4H3Q");

var $iCU10 = parcelRequire("iCU10");

var $k1WNO = parcelRequire("k1WNO");

var $b0HC9 = parcelRequire("b0HC9");

var $bjlCM = parcelRequire("bjlCM");
var $874555748a3039ea$var$fixRound = $iCU10.round;
var $874555748a3039ea$var$mathFloor = Math.floor;
var $874555748a3039ea$var$mathCeil = Math.ceil;
var $874555748a3039ea$var$mathPow = Math.pow;
var $874555748a3039ea$var$mathLog = Math.log;
var $874555748a3039ea$var$LogScale = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        _this.base = 10;
        _this._originalScale = new (0, $k1WNO.default)();
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var extent = this._extent.slice();
        var originalExtent = this._originalScale.getExtent();
        var ticks = _super.prototype.getTicks.call(this, opt);
        var base = this.base;
        var originalBreaks = this._originalScale._innerGetBreaks();
        var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
        return $2N6Uo.map(ticks, function(tick) {
            var val = tick.value;
            var roundingCriterion = null;
            var powVal = $874555748a3039ea$var$mathPow(base, val);
            // Fix #4158
            if (val === extent[0] && this._fixMin) roundingCriterion = originalExtent[0];
            else if (val === extent[1] && this._fixMax) roundingCriterion = originalExtent[1];
            var vBreak;
            if (scaleBreakHelper) {
                var transformed = scaleBreakHelper.getTicksLogTransformBreak(tick, base, originalBreaks, $874555748a3039ea$var$fixRoundingError);
                vBreak = transformed.vBreak;
                if (roundingCriterion == null) roundingCriterion = transformed.brkRoundingCriterion;
            }
            if (roundingCriterion != null) powVal = $874555748a3039ea$var$fixRoundingError(powVal, roundingCriterion);
            return {
                value: powVal,
                "break": vBreak
            };
        }, this);
    };
    LogScale.prototype._getNonTransBreaks = function() {
        return this._originalScale._innerGetBreaks();
    };
    LogScale.prototype.setExtent = function(start, end) {
        this._originalScale.setExtent(start, end);
        var loggedExtent = (0, $b0HC9.logTransform)(this.base, [
            start,
            end
        ]);
        _super.prototype.setExtent.call(this, loggedExtent[0], loggedExtent[1]);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = _super.prototype.getExtent.call(this);
        extent[0] = $874555748a3039ea$var$mathPow(base, extent[0]);
        extent[1] = $874555748a3039ea$var$mathPow(base, extent[1]);
        // Fix #4158
        var originalExtent = this._originalScale.getExtent();
        this._fixMin && (extent[0] = $874555748a3039ea$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $874555748a3039ea$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        this._originalScale.unionExtentFromData(data, dim);
        var loggedOther = (0, $b0HC9.logTransform)(this.base, data.getApproximateExtent(dim), true);
        this._innerUnionExtent(loggedOther);
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.calcNiceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent.slice();
        var span = this._getExtentSpanWithBreaks();
        if (!isFinite(span) || span <= 0) return;
        var interval = $iCU10.quantity(span);
        var err = approxTickNum / span * interval;
        // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
        // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $874555748a3039ea$var$fixRound($874555748a3039ea$var$mathCeil(extent[0] / interval) * interval),
            $874555748a3039ea$var$fixRound($874555748a3039ea$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._intervalPrecision = (0, $b0HC9.getIntervalPrecision)(interval);
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.calcNiceExtent = function(opt) {
        _super.prototype.calcNiceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.contain = function(val) {
        val = $874555748a3039ea$var$mathLog(val) / $874555748a3039ea$var$mathLog(this.base);
        return _super.prototype.contain.call(this, val);
    };
    LogScale.prototype.normalize = function(val) {
        val = $874555748a3039ea$var$mathLog(val) / $874555748a3039ea$var$mathLog(this.base);
        return _super.prototype.normalize.call(this, val);
    };
    LogScale.prototype.scale = function(val) {
        val = _super.prototype.scale.call(this, val);
        return $874555748a3039ea$var$mathPow(this.base, val);
    };
    LogScale.prototype.setBreaksFromOption = function(breakOptionList) {
        var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
        if (!scaleBreakHelper) return;
        var _a = scaleBreakHelper.logarithmicParseBreaksFromOption(breakOptionList, this.base, $2N6Uo.bind(this.parse, this)), parsedOriginal = _a.parsedOriginal, parsedLogged = _a.parsedLogged;
        this._originalScale._innerSetBreak(parsedOriginal);
        this._innerSetBreak(parsedLogged);
    };
    LogScale.type = 'log';
    return LogScale;
}((0, $k1WNO.default));
function $874555748a3039ea$var$fixRoundingError(val, originalVal) {
    return $874555748a3039ea$var$fixRound(val, $iCU10.getPrecision(originalVal));
}
(0, $e4H3Q.default).registerClass($874555748a3039ea$var$LogScale);
var $874555748a3039ea$export$2e2bcd8739ae039 = $874555748a3039ea$var$LogScale;

});

parcelRegister("h4rbp", function(module, exports) {

$parcel$export(module.exports, "ensureScaleRawExtentInfo", function () { return $c6d7e56381b8f21b$export$5c3dbcbeb9ce7f5a; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $eVwLk = parcelRequire("eVwLk");
var $c6d7e56381b8f21b$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
    originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on outside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, // Usually: data extent from all series on this axis.
    dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
        this._needCrossZero = scale.type === 'interval' && model.getNeedCrossZero && model.getNeedCrossZero();
        var axisMinValue = model.get('min', true);
        if (axisMinValue == null) axisMinValue = model.get('startValue', true);
        var modelMinRaw = this._modelMinRaw = axisMinValue;
        if ((0, $2N6Uo.isFunction)(modelMinRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMinNum = $c6d7e56381b8f21b$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== 'dataMin') this._modelMinNum = $c6d7e56381b8f21b$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
        if ((0, $2N6Uo.isFunction)(modelMaxRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMaxNum = $c6d7e56381b8f21b$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $c6d7e56381b8f21b$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get('boundaryGap');
            var boundaryGapArr = (0, $2N6Uo.isArray)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $eVwLk.parsePercent)(boundaryGapArr[0], 1),
                (0, $eVwLk.parsePercent)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
        // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum;
        // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        var isBlank = (0, $2N6Uo.eqNaN)(min) || (0, $2N6Uo.eqNaN)(max) || isOrdinal && !axisDataLen;
        // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0;
            // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0;
        // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        }
        // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$c6d7e56381b8f21b$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $c6d7e56381b8f21b$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $c6d7e56381b8f21b$var$DETERMINED_MIN_MAX_ATTR = {
    min: '_determinedMin',
    max: '_determinedMax'
};
var $c6d7e56381b8f21b$var$DATA_MIN_MAX_ATTR = {
    min: '_dataMin',
    max: '_dataMax'
};
function $c6d7e56381b8f21b$export$5c3dbcbeb9ce7f5a(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $c6d7e56381b8f21b$export$c35454f678e99c82(scale, model, originalExtent);
    // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $c6d7e56381b8f21b$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $2N6Uo.eqNaN)(minMax) ? NaN : scale.parse(minMax);
}

});


parcelRegister("iYj1T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcfc976f86b97c5e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $6ZMAw = parcelRequire("6ZMAw");
var $dcfc976f86b97c5e$var$ParallelAxis = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ParallelAxis, _super);
    function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        _this.axisIndex = axisIndex;
        return _this;
    }
    ParallelAxis.prototype.isHorizontal = function() {
        return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
    };
    return ParallelAxis;
}((0, $6ZMAw.default));
var $dcfc976f86b97c5e$export$2e2bcd8739ae039 = $dcfc976f86b97c5e$var$ParallelAxis;

});
parcelRegister("6ZMAw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $517e212e3c6b579b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");

var $2HLpR = parcelRequire("2HLpR");
var $517e212e3c6b579b$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 *
 * Lifetime: recreate for each main process.
 * [NOTICE]: Some caches is stored on the axis instance (see `axisTickLabelBuilder.ts`)
 *  which is based on this lifetime.
 */ var $517e212e3c6b579b$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        // Make sure that `extent[0] > extent[1]` only if `inverse: true`.
        // `inverse` can be inferred by `extent` unless `extent[0] === extent[1]`.
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(this.scale.parse(data));
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $iCU10.getPixelPrecision)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(scale.parse(data));
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $517e212e3c6b579b$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $iCU10.linearMap)(data, $517e212e3c6b579b$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $517e212e3c6b579b$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $iCU10.linearMap)(coord, extent, $517e212e3c6b579b$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $2HLpR.createAxisTicks)(this, tickModel, {
            breakTicks: opt.breakTicks,
            pruneByBreak: opt.pruneByBreak
        });
        var ticks = result.ticks;
        var ticksCoords = (0, $2N6Uo.map)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        $517e212e3c6b579b$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === 'ordinal') // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber');
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $2N6Uo.map)(minorTicks, function(minorTicksGroup) {
            return (0, $2N6Uo.map)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function(ctx) {
        ctx = ctx || (0, $2HLpR.createAxisLabelsComputingContext)((0, $2HLpR.AxisTickLabelComputingKind).determine);
        return (0, $2HLpR.createAxisLabels)(this, ctx).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
        // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function(ctx) {
        ctx = ctx || (0, $2HLpR.createAxisLabelsComputingContext)((0, $2HLpR.AxisTickLabelComputingKind).determine);
        return (0, $2HLpR.calculateCategoryInterval)(this, ctx);
    };
    return Axis;
}();
function $517e212e3c6b579b$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
}
// If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $517e212e3c6b579b$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        ticksCoords[0].onBand = true;
        last = ticksCoords[1] = {
            coord: axisExtent[1],
            tickValue: ticksCoords[0].tickValue,
            onBand: true
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $2N6Uo.each)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
            ticksItem.onBand = true;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize,
            tickValue: dataExtent[1] + 1,
            onBand: true
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1];
    // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0],
        onBand: true
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1],
        onBand: true
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unnecessary tick added.
        a = (0, $iCU10.round)(a);
        b = (0, $iCU10.round)(b);
        return inverse ? a > b : a < b;
    }
}
var $517e212e3c6b579b$export$2e2bcd8739ae039 = $517e212e3c6b579b$var$Axis;

});
parcelRegister("2HLpR", function(module, exports) {

$parcel$export(module.exports, "AxisTickLabelComputingKind", function () { return $1f8460c9198bcfb3$export$31cba7db0a663292; });
$parcel$export(module.exports, "createAxisLabelsComputingContext", function () { return $1f8460c9198bcfb3$export$12d6ac38274c43e7; });
$parcel$export(module.exports, "createAxisLabels", function () { return $1f8460c9198bcfb3$export$10216ebd3e3e485e; });
$parcel$export(module.exports, "createAxisTicks", function () { return $1f8460c9198bcfb3$export$7cccf6836ae8323c; });
$parcel$export(module.exports, "calculateCategoryInterval", function () { return $1f8460c9198bcfb3$export$9ea1d3f146a5a65f; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $eVwLk = parcelRequire("eVwLk");

var $bx3T8 = parcelRequire("bx3T8");

var $9AF98 = parcelRequire("9AF98");
var $1f8460c9198bcfb3$var$modelInner = (0, $bx3T8.makeInner)();
var $1f8460c9198bcfb3$var$axisInner = (0, $bx3T8.makeInner)();
var $1f8460c9198bcfb3$export$31cba7db0a663292 = {
    estimate: 1,
    determine: 2
};
function $1f8460c9198bcfb3$export$12d6ac38274c43e7(kind) {
    return {
        out: {
            noPxChangeTryDetermine: []
        },
        kind: kind
    };
}
function $1f8460c9198bcfb3$var$tickValuesToNumbers(axis, values) {
    var nums = $2N6Uo.map(values, function(val) {
        return axis.scale.parse(val);
    });
    if (axis.type === 'time' && nums.length > 0) {
        // Time axis needs duplicate first/last tick (see TimeScale.getTicks())
        // The first and last tick/label don't get drawn
        nums.sort();
        nums.unshift(nums[0]);
        nums.push(nums[nums.length - 1]);
    }
    return nums;
}
function $1f8460c9198bcfb3$export$10216ebd3e3e485e(axis, ctx) {
    var custom = axis.getLabelModel().get('customValues');
    if (custom) {
        var labelFormatter_1 = (0, $9AF98.makeLabelFormatter)(axis);
        var extent_1 = axis.scale.getExtent();
        var tickNumbers = $1f8460c9198bcfb3$var$tickValuesToNumbers(axis, custom);
        var ticks = $2N6Uo.filter(tickNumbers, function(val) {
            return val >= extent_1[0] && val <= extent_1[1];
        });
        return {
            labels: $2N6Uo.map(ticks, function(numval) {
                var tick = {
                    value: numval
                };
                return {
                    formattedLabel: labelFormatter_1(tick),
                    rawLabel: axis.scale.getLabel(tick),
                    tickValue: numval,
                    time: undefined,
                    "break": undefined
                };
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $1f8460c9198bcfb3$var$makeCategoryLabels(axis, ctx) : $1f8460c9198bcfb3$var$makeRealNumberLabels(axis);
}
function $1f8460c9198bcfb3$export$7cccf6836ae8323c(axis, tickModel, opt) {
    var custom = axis.getTickModel().get('customValues');
    if (custom) {
        var extent_2 = axis.scale.getExtent();
        var tickNumbers = $1f8460c9198bcfb3$var$tickValuesToNumbers(axis, custom);
        return {
            ticks: $2N6Uo.filter(tickNumbers, function(val) {
                return val >= extent_2[0] && val <= extent_2[1];
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $1f8460c9198bcfb3$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $2N6Uo.map(axis.scale.getTicks(opt), function(tick) {
            return tick.value;
        })
    };
}
function $1f8460c9198bcfb3$var$makeCategoryLabels(axis, ctx) {
    var labelModel = axis.getLabelModel();
    var result = $1f8460c9198bcfb3$var$makeCategoryLabelsActually(axis, labelModel, ctx);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: []
    } : result;
}
function $1f8460c9198bcfb3$var$makeCategoryLabelsActually(axis, labelModel, ctx) {
    var labelsCache = $1f8460c9198bcfb3$var$ensureCategoryLabelCache(axis);
    var optionLabelInterval = (0, $9AF98.getOptionCategoryInterval)(labelModel);
    var isEstimate = ctx.kind === $1f8460c9198bcfb3$export$31cba7db0a663292.estimate;
    // In AxisTickLabelComputingKind.estimate, the result likely varies during a single
    // pass of ec main process,due to the change of axisExtent, and will not be shared with
    // splitLine. Therefore no cache is used.
    if (!isEstimate) {
        // PENDING: check necessary?
        var result_1 = $1f8460c9198bcfb3$var$axisCacheGet(labelsCache, optionLabelInterval);
        if (result_1) return result_1;
    }
    var labels;
    var numericLabelInterval;
    if ($2N6Uo.isFunction(optionLabelInterval)) labels = $1f8460c9198bcfb3$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $1f8460c9198bcfb3$var$makeAutoCategoryInterval(axis, ctx) : optionLabelInterval;
        labels = $1f8460c9198bcfb3$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    }
    var result = {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    };
    if (!isEstimate) $1f8460c9198bcfb3$var$axisCacheSet(labelsCache, optionLabelInterval, result);
    else ctx.out.noPxChangeTryDetermine.push(function() {
        $1f8460c9198bcfb3$var$axisCacheSet(labelsCache, optionLabelInterval, result);
        return true;
    });
    return result;
}
function $1f8460c9198bcfb3$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $1f8460c9198bcfb3$var$ensureCategoryTickCache(axis);
    var optionTickInterval = (0, $9AF98.getOptionCategoryInterval)(tickModel);
    var result = $1f8460c9198bcfb3$var$axisCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($2N6Uo.isFunction(optionTickInterval)) ticks = $1f8460c9198bcfb3$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $1f8460c9198bcfb3$var$makeCategoryLabelsActually(axis, axis.getLabelModel(), $1f8460c9198bcfb3$export$12d6ac38274c43e7($1f8460c9198bcfb3$export$31cba7db0a663292.determine));
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $2N6Uo.map(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $1f8460c9198bcfb3$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $1f8460c9198bcfb3$var$axisCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $1f8460c9198bcfb3$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $9AF98.makeLabelFormatter)(axis);
    return {
        labels: $2N6Uo.map(ticks, function(tick, idx) {
            return {
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value,
                time: tick.time,
                "break": tick["break"]
            };
        })
    };
}
// Large category data calculation is performance sensitive, and ticks and label probably will
// be fetched multiple times (e.g. shared by splitLine and axisTick). So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.
var $1f8460c9198bcfb3$var$ensureCategoryTickCache = $1f8460c9198bcfb3$var$initAxisCacheMethod('axisTick');
var $1f8460c9198bcfb3$var$ensureCategoryLabelCache = $1f8460c9198bcfb3$var$initAxisCacheMethod('axisLabel');
/**
 * PENDING: refactor to JS Map? Because key can be a function or more complicated object, and
 * cache size always is small, and currently no JS Map object key polyfill, we use a simple
 * array cache instead of plain object hash.
 */ function $1f8460c9198bcfb3$var$initAxisCacheMethod(prop) {
    return function ensureCache(axis) {
        return $1f8460c9198bcfb3$var$axisInner(axis)[prop] || ($1f8460c9198bcfb3$var$axisInner(axis)[prop] = {
            list: []
        });
    };
}
function $1f8460c9198bcfb3$var$axisCacheGet(cache, key) {
    for(var i = 0; i < cache.list.length; i++){
        if (cache.list[i].key === key) return cache.list[i].value;
    }
}
function $1f8460c9198bcfb3$var$axisCacheSet(cache, key, value) {
    cache.list.push({
        key: key,
        value: value
    });
    return value;
}
function $1f8460c9198bcfb3$var$makeAutoCategoryInterval(axis, ctx) {
    if (ctx.kind === $1f8460c9198bcfb3$export$31cba7db0a663292.estimate) {
        // Currently axisTick is not involved in estimate kind, and the result likely varies during a
        // single pass of ec main process, due to the change of axisExtent. Therefore no cache is used.
        var result_2 = axis.calculateCategoryInterval(ctx);
        ctx.out.noPxChangeTryDetermine.push(function() {
            $1f8460c9198bcfb3$var$axisInner(axis).autoInterval = result_2;
            return true;
        });
        return result_2;
    }
    // Both tick and label uses this result, cacah it to avoid recompute.
    var result = $1f8460c9198bcfb3$var$axisInner(axis).autoInterval;
    return result != null ? result : $1f8460c9198bcfb3$var$axisInner(axis).autoInterval = axis.calculateCategoryInterval(ctx);
}
function $1f8460c9198bcfb3$export$9ea1d3f146a5a65f(axis, ctx) {
    var kind = ctx.kind;
    var params = $1f8460c9198bcfb3$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $9AF98.makeLabelFormatter)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Arbitrary value.
    var maxCount = 40;
    if (tickCount > maxCount) step = Math.max(1, Math.floor(tickCount / maxCount));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $eVwLk.getBoundingRect(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top');
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    if (kind === $1f8460c9198bcfb3$export$31cba7db0a663292.estimate) {
        // In estimate kind, the inteval likely varies, thus do not erase the cache.
        ctx.out.noPxChangeTryDetermine.push($2N6Uo.bind($1f8460c9198bcfb3$var$calculateCategoryIntervalTryDetermine, null, axis, interval, tickCount));
        return interval;
    }
    var lastInterval = $1f8460c9198bcfb3$var$calculateCategoryIntervalDealCache(axis, interval, tickCount);
    return lastInterval != null ? lastInterval : interval;
}
function $1f8460c9198bcfb3$var$calculateCategoryIntervalTryDetermine(axis, interval, tickCount) {
    return $1f8460c9198bcfb3$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) == null;
}
// Return the lastInterval if need to use it, otherwise return NullUndefined and save cache.
function $1f8460c9198bcfb3$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) {
    var cache = $1f8460c9198bcfb3$var$modelInner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) return lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
}
function $1f8460c9198bcfb3$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $1f8460c9198bcfb3$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $9AF98.makeLabelFormatter)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = [];
    // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count();
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $9AF98.shouldShowAllLabels)(axis);
    var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
    var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
    // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue,
            time: undefined,
            "break": undefined
        });
    }
    return result;
}
function $1f8460c9198bcfb3$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $9AF98.makeLabelFormatter)(axis);
    var result = [];
    $2N6Uo.each(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue,
            time: undefined,
            "break": undefined
        });
    });
    return result;
}

});



parcelRegister("43jQn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f36d5cfa8223f99$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param delta Move length.
 * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param handleIndex Can be 'all', means that both move the two handleEnds.
 * @param minSpan The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param maxSpan The range of dataZoom can not be larger than that.
 * @return The input handleEnds.
 */ function $2f36d5cfa8223f99$export$2e2bcd8739ae039(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
    delta = delta || 0;
    var extentSpan = extent[1] - extent[0];
    // Notice maxSpan and minSpan can be null/undefined.
    if (minSpan != null) minSpan = $2f36d5cfa8223f99$var$restrict(minSpan, [
        0,
        extentSpan
    ]);
    if (maxSpan != null) maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
    if (handleIndex === 'all') {
        var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
        handleSpan = $2f36d5cfa8223f99$var$restrict(handleSpan, [
            0,
            extentSpan
        ]);
        minSpan = maxSpan = $2f36d5cfa8223f99$var$restrict(handleSpan, [
            minSpan,
            maxSpan
        ]);
        handleIndex = 0;
    }
    handleEnds[0] = $2f36d5cfa8223f99$var$restrict(handleEnds[0], extent);
    handleEnds[1] = $2f36d5cfa8223f99$var$restrict(handleEnds[1], extent);
    var originalDistSign = $2f36d5cfa8223f99$var$getSpanSign(handleEnds, handleIndex);
    handleEnds[handleIndex] += delta;
    // Restrict in extent.
    var extentMinSpan = minSpan || 0;
    var realExtent = extent.slice();
    originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
    handleEnds[handleIndex] = $2f36d5cfa8223f99$var$restrict(handleEnds[handleIndex], realExtent);
    // Expand span.
    var currDistSign;
    currDistSign = $2f36d5cfa8223f99$var$getSpanSign(handleEnds, handleIndex);
    if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
    // Shrink span.
    currDistSign = $2f36d5cfa8223f99$var$getSpanSign(handleEnds, handleIndex);
    if (maxSpan != null && currDistSign.span > maxSpan) handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
    return handleEnds;
}
function $2f36d5cfa8223f99$var$getSpanSign(handleEnds, handleIndex) {
    var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex];
    // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
    // is at left of handleEnds[1] for non-cross case.
    return {
        span: Math.abs(dist),
        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
    };
}
function $2f36d5cfa8223f99$var$restrict(value, extend) {
    return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}

});



parcelRegister("lzKMz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb5127db2f7be9cb$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $kyB0C = parcelRequire("kyB0C");

var $a35Wn = parcelRequire("a35Wn");

var $72H2h = parcelRequire("72H2h");

var $QLBnO = parcelRequire("QLBnO");

var $2N6Uo = parcelRequire("2N6Uo");

var $Etgh3 = parcelRequire("Etgh3");
function $fb5127db2f7be9cb$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $2N6Uo.each)((0, $QLBnO.AXIS_TYPES), function(v, axisType) {
        var defaultOption = (0, $2N6Uo.merge)((0, $2N6Uo.merge)({}, (0, $kyB0C.default)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $9nEce.__extends)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $a35Wn.fetchLayoutMode)(this);
                var inputPositionParams = layoutMode ? (0, $a35Wn.getLayoutParams)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $2N6Uo.merge)(option, themeModel.get(axisType + 'Axis'));
                (0, $2N6Uo.merge)(option, this.getDefaultOption());
                option.type = $fb5127db2f7be9cb$var$getAxisType(option);
                if (layoutMode) (0, $a35Wn.mergeLayoutParam)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $72H2h.default).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.prototype.updateAxisBreaks = function(payload) {
                var axisBreakHelper = (0, $Etgh3.getAxisBreakHelper)();
                return axisBreakHelper ? axisBreakHelper.updateModelAxisBreak(this, payload) : {
                    breaks: []
                };
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $fb5127db2f7be9cb$var$getAxisType);
}
function $fb5127db2f7be9cb$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}

});
parcelRegister("kyB0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef73b0d818df7baf$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $6aXXD = parcelRequire("6aXXD");
var $ef73b0d818df7baf$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {
    },
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: (0, $6aXXD.default).color.axisLine,
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ],
        breakLine: true
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12,
        color: (0, $6aXXD.default).color.axisLabel,
        // In scenarios like axis labels, when labels text's progression direction matches the label
        // layout direction (e.g., when all letters are in a single line), extra start/end margin is
        // needed to prevent the text from appearing visually joined. In the other case, when lables
        // are stacked (e.g., having rotation or horizontal labels on yAxis), the layout needs to be
        // compact, so NO extra top/bottom margin should be applied.
        textMargin: [
            0,
            3
        ]
    },
    splitLine: {
        show: true,
        showMinLine: true,
        showMaxLine: true,
        lineStyle: {
            color: (0, $6aXXD.default).color.axisSplitLine,
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                (0, $6aXXD.default).color.backgroundTint,
                (0, $6aXXD.default).color.backgroundTransparent
            ]
        }
    },
    breakArea: {
        show: true,
        itemStyle: {
            color: (0, $6aXXD.default).color.neutral00,
            // Break border color should be darker than the splitLine
            // because it has opacity and should be more prominent
            borderColor: (0, $6aXXD.default).color.border,
            borderWidth: 1,
            borderType: [
                3,
                3
            ],
            opacity: 0.6
        },
        zigzagAmplitude: 4,
        zigzagMinSpan: 4,
        zigzagMaxSpan: 20,
        zigzagZ: 100,
        expandOnClick: true
    },
    breakLabelLayout: {
        moveOverlap: 'auto'
    }
};
var $ef73b0d818df7baf$var$categoryAxis = $2N6Uo.merge({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    jitter: 0,
    jitterOverlap: true,
    jitterMargin: 2,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto',
        show: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $ef73b0d818df7baf$var$defaultOption);
var $ef73b0d818df7baf$var$valueAxis = $2N6Uo.merge({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: (0, $6aXXD.default).color.axisMinorSplitLine,
            width: 1
        }
    }
}, $ef73b0d818df7baf$var$defaultOption);
var $ef73b0d818df7baf$var$timeAxis = $2N6Uo.merge({
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $ef73b0d818df7baf$var$valueAxis);
var $ef73b0d818df7baf$var$logAxis = $2N6Uo.defaults({
    logBase: 10
}, $ef73b0d818df7baf$var$valueAxis);
var $ef73b0d818df7baf$export$2e2bcd8739ae039 = {
    category: $ef73b0d818df7baf$var$categoryAxis,
    value: $ef73b0d818df7baf$var$valueAxis,
    time: $ef73b0d818df7baf$var$timeAxis,
    log: $ef73b0d818df7baf$var$logAxis
};

});

parcelRegister("QLBnO", function(module, exports) {

$parcel$export(module.exports, "AXIS_TYPES", function () { return $09e9c833362545b5$export$2e0057d176d6f690; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $09e9c833362545b5$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};

});

parcelRegister("Etgh3", function(module, exports) {

$parcel$export(module.exports, "registerAxisBreakHelperImpl", function () { return $079a6f4352155a0b$export$f5ec8c7ef7a59f4c; });
$parcel$export(module.exports, "getAxisBreakHelper", function () { return $079a6f4352155a0b$export$c1d9b2cc33e7e5e; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $079a6f4352155a0b$var$_impl = null;
function $079a6f4352155a0b$export$f5ec8c7ef7a59f4c(impl) {
    if (!$079a6f4352155a0b$var$_impl) $079a6f4352155a0b$var$_impl = impl;
}
function $079a6f4352155a0b$export$c1d9b2cc33e7e5e() {
    return $079a6f4352155a0b$var$_impl;
}

});


parcelRegister("jSODp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e79a56771ab00219$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $eLD2b = parcelRequire("eLD2b");

var $4jA7C = parcelRequire("4jA7C");

var $iCU10 = parcelRequire("iCU10");

var $fRzLp = parcelRequire("fRzLp");
var $e79a56771ab00219$var$ParallelAxisModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ParallelAxisModel, _super);
    function ParallelAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisModel.type;
        /**
     * @readOnly
     */ _this.activeIntervals = [];
        return _this;
    }
    ParallelAxisModel.prototype.getAreaSelectStyle = function() {
        return (0, $4jA7C.default)([
            [
                'fill',
                'color'
            ],
            [
                'lineWidth',
                'borderWidth'
            ],
            [
                'stroke',
                'borderColor'
            ],
            [
                'width',
                'width'
            ],
            [
                'opacity',
                'opacity'
            ]
        ])(this.getModel('areaSelectStyle'));
    };
    /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param intervals `interval.length === 0` means set all active.
   */ ParallelAxisModel.prototype.setActiveIntervals = function(intervals) {
        var activeIntervals = this.activeIntervals = $2N6Uo.clone(intervals);
        // Normalize
        if (activeIntervals) for(var i = activeIntervals.length - 1; i >= 0; i--)$iCU10.asc(activeIntervals[i]);
    };
    /**
   * @param value When only attempting detect whether 'no activeIntervals set',
   *        `value` is not needed to be input.
   */ ParallelAxisModel.prototype.getActiveState = function(value) {
        var activeIntervals = this.activeIntervals;
        if (!activeIntervals.length) return 'normal';
        if (value == null || isNaN(+value)) return 'inactive';
        // Simple optimization
        if (activeIntervals.length === 1) {
            var interval = activeIntervals[0];
            if (interval[0] <= value && value <= interval[1]) return 'active';
        } else for(var i = 0, len = activeIntervals.length; i < len; i++){
            if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) return 'active';
        }
        return 'inactive';
    };
    return ParallelAxisModel;
}((0, $eLD2b.default));
$2N6Uo.mixin($e79a56771ab00219$var$ParallelAxisModel, (0, $fRzLp.AxisModelCommonMixin));
var $e79a56771ab00219$export$2e2bcd8739ae039 = $e79a56771ab00219$var$ParallelAxisModel;

});
parcelRegister("fRzLp", function(module, exports) {

$parcel$export(module.exports, "AxisModelCommonMixin", function () { return $b8c78c2e15fa3dbc$export$5c54b224726edb5a; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $b8c78c2e15fa3dbc$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();

});


parcelRegister("680yY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4763ed3afdda5872$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $fVg7M = parcelRequire("fVg7M");

var $97tZB = parcelRequire("97tZB");

var $3iC2d = parcelRequire("3iC2d");
parcelRequire("h9U3p");
var $67W72 = parcelRequire("67W72");
var $h9U3p = parcelRequire("h9U3p");
var $iQonF = parcelRequire("iQonF");

var $bpyST = parcelRequire("bpyST");
var $4763ed3afdda5872$var$ParallelAxisView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ParallelAxisView, _super);
    function ParallelAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisView.type;
        return _this;
    }
    ParallelAxisView.prototype.init = function(ecModel, api) {
        _super.prototype.init.apply(this, arguments);
        (this._brushController = new (0, $97tZB.default)(api.getZr())).on('brush', $2N6Uo.bind(this._onBrush, this));
    };
    ParallelAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        if ($4763ed3afdda5872$var$fromAxisAreaSelect(axisModel, ecModel, payload)) return;
        this.axisModel = axisModel;
        this.api = api;
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $iQonF.default();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var coordSysModel = $4763ed3afdda5872$var$getCoordSysModel(axisModel, ecModel);
        var coordSys = coordSysModel.coordinateSystem;
        var areaSelectStyle = axisModel.getAreaSelectStyle();
        var areaWidth = areaSelectStyle.width;
        var dim = axisModel.axis.dim;
        var axisLayout = coordSys.getAxisLayout(dim);
        var builderOpt = $2N6Uo.extend({
            strokeContainThreshold: areaWidth
        }, axisLayout);
        var axisBuilder = new (0, $fVg7M.default)(axisModel, api, builderOpt);
        axisBuilder.build();
        this._axisGroup.add(axisBuilder.group);
        this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
        $h9U3p.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
    };
    // /**
    //  * @override
    //  */
    // updateVisual(axisModel, ecModel, api, payload) {
    //     this._brushController && this._brushController
    //         .updateCovers(getCoverInfoList(axisModel));
    // }
    ParallelAxisView.prototype._refreshBrushController = function(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
        // After filtering, axis may change, select area needs to be update.
        var extent = axisModel.axis.getExtent();
        var extentLen = extent[1] - extent[0];
        var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
        // width/height might be negative, which will be
        // normalized in BoundingRect.
        var rect = $67W72.default.create({
            x: extent[0],
            y: -areaWidth / 2,
            width: extentLen,
            height: areaWidth
        });
        rect.x -= extra;
        rect.width += 2 * extra;
        this._brushController.mount({
            enableGlobalPan: true,
            rotation: builderOpt.rotation,
            x: builderOpt.position[0],
            y: builderOpt.position[1]
        }).setPanels([
            {
                panelId: 'pl',
                clipPath: $3iC2d.makeRectPanelClipPath(rect),
                isTargetByCursor: $3iC2d.makeRectIsTargetByCursor(rect, api, coordSysModel),
                getLinearBrushOtherExtent: $3iC2d.makeLinearBrushOtherExtent(rect, 0)
            }
        ]).enableBrush({
            brushType: 'lineX',
            brushStyle: areaSelectStyle,
            removeOnClick: true
        }).updateCovers($4763ed3afdda5872$var$getCoverInfoList(axisModel));
    };
    ParallelAxisView.prototype._onBrush = function(eventParam) {
        var coverInfoList = eventParam.areas;
        // Do not cache these object, because the mey be changed.
        var axisModel = this.axisModel;
        var axis = axisModel.axis;
        var intervals = $2N6Uo.map(coverInfoList, function(coverInfo) {
            return [
                axis.coordToData(coverInfo.range[0], true),
                axis.coordToData(coverInfo.range[1], true)
            ];
        });
        // If realtime is true, action is not dispatched on drag end, because
        // the drag end emits the same params with the last drag move event,
        // and may have some delay when using touch pad.
        if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) // jshint ignore:line
        this.api.dispatchAction({
            type: 'axisAreaSelect',
            parallelAxisId: axisModel.id,
            intervals: intervals
        });
    };
    ParallelAxisView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    ParallelAxisView.type = 'parallelAxis';
    return ParallelAxisView;
}((0, $bpyST.default));
function $4763ed3afdda5872$var$fromAxisAreaSelect(axisModel, ecModel, payload) {
    return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
        mainType: 'parallelAxis',
        query: payload
    })[0] === axisModel;
}
function $4763ed3afdda5872$var$getCoverInfoList(axisModel) {
    var axis = axisModel.axis;
    return $2N6Uo.map(axisModel.activeIntervals, function(interval) {
        return {
            brushType: 'lineX',
            panelId: 'pl',
            range: [
                axis.dataToCoord(interval[0], true),
                axis.dataToCoord(interval[1], true)
            ]
        };
    });
}
function $4763ed3afdda5872$var$getCoordSysModel(axisModel, ecModel) {
    return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
}
var $4763ed3afdda5872$export$2e2bcd8739ae039 = $4763ed3afdda5872$var$ParallelAxisView;

});
parcelRegister("fVg7M", function(module, exports) {

$parcel$export(module.exports, "getLabelInner", function () { return $b978afdd15b036df$export$c392b818a26a879e; });
$parcel$export(module.exports, "AxisBuilderSharedContext", function () { return $b978afdd15b036df$export$f2e237206f7393f5; });
$parcel$export(module.exports, "resolveAxisNameOverlapDefault", function () { return $b978afdd15b036df$export$7fcb8742f5816cae; });
$parcel$export(module.exports, "moveIfOverlapByLinearLabels", function () { return $b978afdd15b036df$export$e033c6449cc6f6a1; });
$parcel$export(module.exports, "default", function () { return $b978afdd15b036df$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $c3CaY = parcelRequire("c3CaY");
var $aH2k0 = parcelRequire("aH2k0");
var $h9U3p = parcelRequire("h9U3p");
var $kBKw3 = parcelRequire("kBKw3");

var $6TSUP = parcelRequire("6TSUP");

var $bysmE = parcelRequire("bysmE");

var $b8YKU = parcelRequire("b8YKU");

var $iCU10 = parcelRequire("iCU10");

var $k0QDS = parcelRequire("k0QDS");

var $19Ywy = parcelRequire("19Ywy");

var $U1aqY = parcelRequire("U1aqY");

var $9AF98 = parcelRequire("9AF98");

var $g4Fz3 = parcelRequire("g4Fz3");

var $bx3T8 = parcelRequire("bx3T8");

var $Etgh3 = parcelRequire("Etgh3");

var $2OQYM = parcelRequire("2OQYM");

var $bjlCM = parcelRequire("bjlCM");

var $67W72 = parcelRequire("67W72");

var $9KN3M = parcelRequire("9KN3M");

var $erz95 = parcelRequire("erz95");

var $2HLpR = parcelRequire("2HLpR");
var $b978afdd15b036df$var$PI = Math.PI;
var $b978afdd15b036df$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS = [
    [
        1,
        2,
        1,
        2
    ],
    [
        5,
        3,
        5,
        3
    ],
    [
        8,
        3,
        8,
        3
    ]
];
var $b978afdd15b036df$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS = [
    [
        0,
        1,
        0,
        1
    ],
    [
        0,
        3,
        0,
        3
    ],
    [
        0,
        3,
        0,
        3
    ]
];
var $b978afdd15b036df$export$c392b818a26a879e = (0, $bx3T8.makeInner)();
var $b978afdd15b036df$var$getTickInner = (0, $bx3T8.makeInner)();
/**
 * A context shared by difference axisBuilder instances.
 * For cross-axes overlap resolving.
 *
 * Lifecycle constraint: should not over a pass of ec main process.
 *  If model is changed, the context must be disposed.
 *
 * @see AxisBuilderLocalContext
 */ var $b978afdd15b036df$export$f2e237206f7393f5 = /** @class */ function() {
    function AxisBuilderSharedContext(resolveAxisNameOverlap) {
        /**
     * [CAUTION] Do not modify this data structure outside this class.
     */ this.recordMap = {};
        this.resolveAxisNameOverlap = resolveAxisNameOverlap;
    }
    AxisBuilderSharedContext.prototype.ensureRecord = function(axisModel) {
        var dim = axisModel.axis.dim;
        var idx = axisModel.componentIndex;
        var recordMap = this.recordMap;
        var records = recordMap[dim] || (recordMap[dim] = []);
        return records[idx] || (records[idx] = {
            ready: {}
        });
    };
    return AxisBuilderSharedContext;
}();
/**
 * [CAUTION]
 *  1. The call of this function must be after axisLabel overlap handlings
 *     (such as `hideOverlap`, `fixMinMaxLabelShow`) and after transform calculating.
 *  2. Can be called multiple times and should be idempotent.
 */ function $b978afdd15b036df$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList) {
    var axis = axisModel.axis;
    var record = shared.ensureRecord(axisModel);
    var labelInfoList = [];
    var stOccupiedRect;
    var useStOccupiedRect = $b978afdd15b036df$var$hasAxisName(cfg.axisName) && (0, $9AF98.isNameLocationCenter)(cfg.nameLocation);
    (0, $2N6Uo.each)(labelLayoutList, function(layout) {
        var layoutInfo = (0, $g4Fz3.ensureLabelLayoutWithGeometry)(layout);
        if (!layoutInfo || layoutInfo.label.ignore) return;
        labelInfoList.push(layoutInfo);
        var transGroup = record.transGroup;
        if (useStOccupiedRect) {
            // Transform to "standard axis" for creating stOccupiedRect (the label rects union).
            transGroup.transform ? $19Ywy.invert($b978afdd15b036df$var$_stTransTmp, transGroup.transform) : $19Ywy.identity($b978afdd15b036df$var$_stTransTmp);
            if (layoutInfo.transform) $19Ywy.mul($b978afdd15b036df$var$_stTransTmp, $b978afdd15b036df$var$_stTransTmp, layoutInfo.transform);
            (0, $67W72.default).copy($b978afdd15b036df$var$_stLabelRectTmp, layoutInfo.localRect);
            $b978afdd15b036df$var$_stLabelRectTmp.applyTransform($b978afdd15b036df$var$_stTransTmp);
            stOccupiedRect ? stOccupiedRect.union($b978afdd15b036df$var$_stLabelRectTmp) : (0, $67W72.default).copy(stOccupiedRect = new (0, $67W72.default)(0, 0, 0, 0), $b978afdd15b036df$var$_stLabelRectTmp);
        }
    });
    var sortByDim = Math.abs(record.dirVec.x) > 0.1 ? 'x' : 'y';
    var sortByValue = record.transGroup[sortByDim];
    labelInfoList.sort(function(info1, info2) {
        return Math.abs(info1.label[sortByDim] - sortByValue) - Math.abs(info2.label[sortByDim] - sortByValue);
    });
    if (useStOccupiedRect && stOccupiedRect) {
        var extent = axis.getExtent();
        var axisLineX = Math.min(extent[0], extent[1]);
        var axisLineWidth = Math.max(extent[0], extent[1]) - axisLineX;
        // If `nameLocation` is 'middle', enlarge axis labels boundingRect to axisLine to avoid bad
        //  case like that axis name is placed in the gap between axis labels and axis line.
        // If only one label exists, the entire band should be occupied for
        // visual consistency, so extent it to [0, canvas width].
        stOccupiedRect.union(new (0, $67W72.default)(axisLineX, 0, axisLineWidth, 1));
    }
    record.stOccupiedRect = stOccupiedRect;
    record.labelInfoList = labelInfoList;
}
var $b978afdd15b036df$var$_stTransTmp = $19Ywy.create();
var $b978afdd15b036df$var$_stLabelRectTmp = new (0, $67W72.default)(0, 0, 0, 0);
var $b978afdd15b036df$export$7fcb8742f5816cae = function(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    if ((0, $9AF98.isNameLocationCenter)(cfg.nameLocation)) {
        var stOccupiedRect = thisRecord.stOccupiedRect;
        if (stOccupiedRect) $b978afdd15b036df$var$moveIfOverlap((0, $g4Fz3.computeLabelGeometry2)({}, stOccupiedRect, thisRecord.transGroup.transform), nameLayoutInfo, nameMoveDirVec);
    } else $b978afdd15b036df$export$e033c6449cc6f6a1(thisRecord.labelInfoList, thisRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
};
// [NOTICE] not consider ignore.
function $b978afdd15b036df$var$moveIfOverlap(basedLayoutInfo, movableLayoutInfo, moveDirVec) {
    var mtv = new (0, $9KN3M.default)();
    if ((0, $g4Fz3.labelIntersect)(basedLayoutInfo, movableLayoutInfo, mtv, {
        direction: Math.atan2(moveDirVec.y, moveDirVec.x),
        bidirectional: false,
        touchThreshold: 0.05
    })) (0, $g4Fz3.labelLayoutApplyTranslation)(movableLayoutInfo, mtv);
}
function $b978afdd15b036df$export$e033c6449cc6f6a1(baseLayoutInfoList, baseDirVec, movableLayoutInfo, moveDirVec) {
    // Detect and move from far to close.
    var sameDir = (0, $9KN3M.default).dot(moveDirVec, baseDirVec) >= 0;
    for(var idx = 0, len = baseLayoutInfoList.length; idx < len; idx++){
        var labelInfo = baseLayoutInfoList[sameDir ? idx : len - 1 - idx];
        if (!labelInfo.label.ignore) $b978afdd15b036df$var$moveIfOverlap(labelInfo, movableLayoutInfo, moveDirVec);
    }
}
/**
 * @caution
 * - Ensure it is called after the data processing stage finished.
 * - It might be called before `CahrtView#render`, sush as called at `CoordinateSystem#update`,
 *  thus ensure the result the same whenever it is called.
 *
 * A builder for a straight-line axis.
 *
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A "standard axis" is the axis [0,0]-->[abs(axisExtent[1]-axisExtent[0]),0]
 * for example: [0,0]-->[50,0]
 */ var $b978afdd15b036df$var$AxisBuilder = /** @class */ function() {
    /**
   * [CAUTION]: axisModel.axis.extent/scale must be ready to use.
   */ function AxisBuilder(axisModel, api, opt, shared) {
        this.group = new $iQonF.default();
        this._axisModel = axisModel;
        this._api = api;
        this._local = {};
        this._shared = shared || new $b978afdd15b036df$export$f2e237206f7393f5($b978afdd15b036df$export$7fcb8742f5816cae);
        this._resetCfgDetermined(opt);
    }
    /**
   * Regarding axis label related configurations, only the change of label.x/y is supported; other
   * changes are not necessary and not performant. To be specific, only `axis.position`
   * (and consequently `labelOffset`) and `axis.extent` can be changed, and assume everything in
   * `axisModel` are not changed.
   * Axis line related configurations can be changed since this method can only be called
   * before they are created.
   */ AxisBuilder.prototype.updateCfg = function(opt) {
        var ready;
        var raw = this._cfg.raw;
        raw.position = opt.position;
        raw.labelOffset = opt.labelOffset;
        this._resetCfgDetermined(raw);
    };
    /**
   * [CAUTION] For debug usage. Never change it outside!
   */ AxisBuilder.prototype.__getRawCfg = function() {
        return this._cfg.raw;
    };
    AxisBuilder.prototype._resetCfgDetermined = function(raw) {
        var axisModel = this._axisModel;
        // FIXME:
        //  Currently there is no uniformed way to set default values if an option
        //  is specified null/undefined by user (intentionally or unintentionally),
        //  e.g. null/undefined is not a illegal value for `nameLocation`.
        //  Try to use `getDefaultOption` to address it. But radar has no `getDefaultOption`.
        var axisModelDefaultOption = axisModel.getDefaultOption ? axisModel.getDefaultOption() : {};
        // Default value
        var axisName = (0, $2N6Uo.retrieve2)(raw.axisName, axisModel.get('name'));
        var nameMoveOverlapOption = axisModel.get('nameMoveOverlap');
        if (nameMoveOverlapOption == null || nameMoveOverlapOption === 'auto') nameMoveOverlapOption = (0, $2N6Uo.retrieve2)(raw.defaultNameMoveOverlap, true);
        var cfg = {
            raw: raw,
            position: raw.position,
            rotation: raw.rotation,
            nameDirection: (0, $2N6Uo.retrieve2)(raw.nameDirection, 1),
            tickDirection: (0, $2N6Uo.retrieve2)(raw.tickDirection, 1),
            labelDirection: (0, $2N6Uo.retrieve2)(raw.labelDirection, 1),
            labelOffset: (0, $2N6Uo.retrieve2)(raw.labelOffset, 0),
            silent: (0, $2N6Uo.retrieve2)(raw.silent, true),
            axisName: axisName,
            nameLocation: (0, $2N6Uo.retrieve3)(axisModel.get('nameLocation'), axisModelDefaultOption.nameLocation, 'end'),
            shouldNameMoveOverlap: $b978afdd15b036df$var$hasAxisName(axisName) && nameMoveOverlapOption,
            optionHideOverlap: axisModel.get([
                'axisLabel',
                'hideOverlap'
            ]),
            showMinorTicks: axisModel.get([
                'minorTick',
                'show'
            ])
        };
        this._cfg = cfg;
        // FIXME Not use a separate text group?
        var transformGroup = new $iQonF.default({
            x: cfg.position[0],
            y: cfg.position[1],
            rotation: cfg.rotation
        });
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
        var record = this._shared.ensureRecord(axisModel);
        record.transGroup = this._transformGroup;
        record.dirVec = new (0, $9KN3M.default)(Math.cos(-cfg.rotation), Math.sin(-cfg.rotation));
    };
    AxisBuilder.prototype.build = function(axisPartNameMap, extraParams) {
        var _this = this;
        if (!axisPartNameMap) axisPartNameMap = {
            axisLine: true,
            axisTickLabelEstimate: false,
            axisTickLabelDetermine: true,
            axisName: true
        };
        (0, $2N6Uo.each)($b978afdd15b036df$var$AXIS_BUILDER_AXIS_PART_NAMES, function(partName) {
            if (axisPartNameMap[partName]) $b978afdd15b036df$var$builders[partName](_this._cfg, _this._local, _this._shared, _this._axisModel, _this.group, _this._transformGroup, _this._api, extraParams || {});
        });
        return this;
    };
    /**
   * Currently only get text align/verticalAlign by rotation.
   * NO `position` is involved, otherwise it have to be performed for each `updateAxisLabelChangableProps`.
   */ AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $iCU10.remRadian)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $iCU10.isRadianAroundZero)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $iCU10.isRadianAroundZero)(rotationDiff - $b978afdd15b036df$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $b978afdd15b036df$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
// Sorted by dependency order.
var $b978afdd15b036df$var$AXIS_BUILDER_AXIS_PART_NAMES = [
    'axisLine',
    'axisTickLabelEstimate',
    'axisTickLabelDetermine',
    'axisName'
];
var $b978afdd15b036df$var$builders = {
    axisLine: function(cfg, local, shared, axisModel, group, transformGroup, api) {
        var ready;
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto') {
            shown = true;
            if (cfg.raw.axisLineAutoShow != null) shown = !!cfg.raw.axisLineAutoShow;
        }
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $U1aqY.applyTransform)(pt1, pt1, matrix);
            (0, $U1aqY.applyTransform)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $2N6Uo.extend)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var pathBaseProp = {
            strokeContainThreshold: cfg.raw.strokeContainThreshold || 5,
            silent: true,
            z2: 1,
            style: lineStyle
        };
        if (axisModel.get([
            'axisLine',
            'breakLine'
        ]) && axisModel.axis.scale.hasBreaks()) (0, $Etgh3.getAxisBreakHelper)().buildAxisBreakLine(axisModel, group, transformGroup, pathBaseProp);
        else {
            var line = new $c3CaY.default((0, $2N6Uo.extend)({
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                }
            }, pathBaseProp));
            $h9U3p.subPixelOptimizeLine(line.shape, line.style.lineWidth);
            line.anid = 'line';
            group.add(line);
        }
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if ((0, $2N6Uo.isString)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $2N6Uo.isString)(arrowSize) || (0, $2N6Uo.isNumber)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $k0QDS.normalizeSymbolOffset)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $2N6Uo.each)([
                {
                    rotate: cfg.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: cfg.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $k0QDS.createSymbol)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(cfg.rotation),
                        y: pt[1] - r * Math.sin(cfg.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisTickLabelEstimate: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $b978afdd15b036df$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $b978afdd15b036df$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $2HLpR.AxisTickLabelComputingKind).estimate);
    },
    /**
   * Finish axis tick label build.
   * Can be only called once.
   */ axisTickLabelDetermine: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $b978afdd15b036df$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $b978afdd15b036df$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $2HLpR.AxisTickLabelComputingKind).determine);
        var ticksEls = $b978afdd15b036df$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel);
        $b978afdd15b036df$var$syncLabelIgnoreToMajorTicks(cfg, local.labelLayoutList, ticksEls);
        $b978afdd15b036df$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, cfg.tickDirection);
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisName: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var sharedRecord = shared.ensureRecord(axisModel);
        var ready;
        // Remove the existing name result created in estimation phase.
        if (local.nameEl) {
            group.remove(local.nameEl);
            local.nameEl = sharedRecord.nameLayout = sharedRecord.nameLocation = null;
        }
        var name = cfg.axisName;
        if (!$b978afdd15b036df$var$hasAxisName(name)) return;
        var nameLocation = cfg.nameLocation;
        var nameDirection = cfg.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapStartEndSignal = axisModel.axis.inverse ? -1 : 1;
        var pos = new (0, $9KN3M.default)(0, 0);
        var nameMoveDirVec = new (0, $9KN3M.default)(0, 0);
        if (nameLocation === 'start') {
            pos.x = extent[0] - gapStartEndSignal * gap;
            nameMoveDirVec.x = -gapStartEndSignal;
        } else if (nameLocation === 'end') {
            pos.x = extent[1] + gapStartEndSignal * gap;
            nameMoveDirVec.x = gapStartEndSignal;
        } else {
            // 'middle' or 'center'
            pos.x = (extent[0] + extent[1]) / 2;
            pos.y = cfg.labelOffset + nameDirection * gap;
            nameMoveDirVec.y = nameDirection;
        }
        var mt = $19Ywy.create();
        nameMoveDirVec.transform($19Ywy.rotate(mt, mt, cfg.rotation));
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $b978afdd15b036df$var$PI / 180; // To radian.
        var labelLayout;
        var axisNameAvailableWidth;
        if ((0, $9AF98.isNameLocationCenter)(nameLocation)) labelLayout = $b978afdd15b036df$var$AxisBuilder.innerTextLayout(cfg.rotation, nameRotation != null ? nameRotation : cfg.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $b978afdd15b036df$var$endTextLayout(cfg.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = cfg.raw.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $2N6Uo.retrieve)(cfg.raw.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var nameMarginLevel = extraParams.nameMarginLevel || 0;
        var textEl = new $kBKw3.default({
            x: pos.x,
            y: pos.y,
            rotation: labelLayout.rotation,
            silent: $b978afdd15b036df$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $bysmE.createTextStyle)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $h9U3p.setTooltipConfig({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $b978afdd15b036df$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $6TSUP.getECData)(textEl).eventData = eventData;
        }
        transformGroup.add(textEl);
        textEl.updateTransform();
        local.nameEl = textEl;
        var nameLayout = sharedRecord.nameLayout = (0, $g4Fz3.ensureLabelLayoutWithGeometry)({
            label: textEl,
            priority: textEl.z2,
            defaultAttr: {
                ignore: textEl.ignore
            },
            marginDefault: (0, $9AF98.isNameLocationCenter)(nameLocation) ? $b978afdd15b036df$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS[nameMarginLevel] : $b978afdd15b036df$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS[nameMarginLevel]
        });
        sharedRecord.nameLocation = nameLocation;
        group.add(textEl);
        textEl.decomposeTransform();
        if (cfg.shouldNameMoveOverlap && nameLayout) {
            var record = shared.ensureRecord(axisModel);
            shared.resolveAxisNameOverlap(cfg, shared, axisModel, nameLayout, nameMoveDirVec, record);
        }
    }
};
function $b978afdd15b036df$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, kind) {
    if (!$b978afdd15b036df$var$axisLabelBuildResultExists(local)) $b978afdd15b036df$var$buildAxisLabel(cfg, local, group, kind, axisModel, api);
    var labelLayoutList = local.labelLayoutList;
    $b978afdd15b036df$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup);
    $b978afdd15b036df$var$adjustBreakLabels(axisModel, cfg.rotation, labelLayoutList);
    var optionHideOverlap = cfg.optionHideOverlap;
    $b978afdd15b036df$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap);
    if (optionHideOverlap) // This bit fixes the label overlap issue for the time chart.
    // See https://github.com/apache/echarts/issues/14266 for more.
    (0, $g4Fz3.hideOverlap)(// Filter the already ignored labels by the previous overlap resolving methods.
    (0, $2N6Uo.filter)(labelLayoutList, function(layout) {
        return layout && !layout.label.ignore;
    }));
    // Always call it even this axis has no name, since it serves in overlapping detection
    // and grid outerBounds on other axis.
    $b978afdd15b036df$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList);
}
function $b978afdd15b036df$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $iCU10.remRadian)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $iCU10.isRadianAroundZero)(rotationDiff - $b978afdd15b036df$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $iCU10.isRadianAroundZero)(rotationDiff - $b978afdd15b036df$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $b978afdd15b036df$var$PI * 1.5 && rotationDiff > $b978afdd15b036df$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
/**
 * Assume `labelLayoutList` has no `label.ignore: true`.
 * Assume `labelLayoutList` have been sorted by value ascending order.
 */ function $b978afdd15b036df$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap) {
    if ((0, $9AF98.shouldShowAllLabels)(axisModel.axis)) return;
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    // Assert no ignore in labels.
    function deal(showMinMaxLabel, outmostLabelIdx, innerLabelIdx) {
        var outmostLabelLayout = (0, $g4Fz3.ensureLabelLayoutWithGeometry)(labelLayoutList[outmostLabelIdx]);
        var innerLabelLayout = (0, $g4Fz3.ensureLabelLayoutWithGeometry)(labelLayoutList[innerLabelIdx]);
        if (!outmostLabelLayout || !innerLabelLayout) return;
        if (showMinMaxLabel === false || outmostLabelLayout.suggestIgnore) {
            $b978afdd15b036df$var$ignoreEl(outmostLabelLayout.label);
            return;
        }
        if (innerLabelLayout.suggestIgnore) {
            $b978afdd15b036df$var$ignoreEl(innerLabelLayout.label);
            return;
        }
        // PENDING: Originally we thought `optionHideOverlap === false` means do not hide anything,
        //  since currently the bounding rect of text might not accurate enough and might slightly bigger,
        //  which causes false positive. But `optionHideOverlap: null/undfined` is falsy and likely
        //  be treated as false.
        // In most fonts the glyph does not reach the boundary of the bounding rect.
        // This is needed to avoid too aggressive to hide two elements that meet at the edge
        // due to compact layout by the same bounding rect or OBB.
        var touchThreshold = 0.1;
        // This treatment is for backward compatibility. And `!optionHideOverlap` implies that
        // the user accepts the visual touch between adjacent labels, thus "hide min/max label"
        // should be conservative, since the space might be sufficient in this case.
        if (!optionHideOverlap) {
            var marginForce = [
                0,
                0,
                0,
                0
            ];
            // Make a copy to apply `ignoreMargin`.
            outmostLabelLayout = (0, $g4Fz3.newLabelLayoutWithGeometry)({
                marginForce: marginForce
            }, outmostLabelLayout);
            innerLabelLayout = (0, $g4Fz3.newLabelLayoutWithGeometry)({
                marginForce: marginForce
            }, innerLabelLayout);
        }
        if ((0, $g4Fz3.labelIntersect)(outmostLabelLayout, innerLabelLayout, null, {
            touchThreshold: touchThreshold
        })) {
            if (showMinMaxLabel) $b978afdd15b036df$var$ignoreEl(innerLabelLayout.label);
            else $b978afdd15b036df$var$ignoreEl(outmostLabelLayout.label);
        }
    }
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabel = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]);
    var labelsLen = labelLayoutList.length;
    deal(showMinLabel, 0, 1);
    deal(showMaxLabel, labelsLen - 1, labelsLen - 2);
}
// PENDING: Is it necessary to display a tick while the corresponding label is ignored?
function $b978afdd15b036df$var$syncLabelIgnoreToMajorTicks(cfg, labelLayoutList, tickEls) {
    if (cfg.showMinorTicks) // It probably unreaasonable to hide major ticks when show minor ticks.
    return;
    (0, $2N6Uo.each)(labelLayoutList, function(labelLayout) {
        if (labelLayout && labelLayout.label.ignore) for(var idx = 0; idx < tickEls.length; idx++){
            var tickEl = tickEls[idx];
            // Assume small array, linear search is fine for performance.
            // PENDING: measure?
            var tickInner = $b978afdd15b036df$var$getTickInner(tickEl);
            var labelInner = $b978afdd15b036df$export$c392b818a26a879e(labelLayout.label);
            if (tickInner.tickValue != null && !tickInner.onBand && tickInner.tickValue === labelInner.tickValue) {
                $b978afdd15b036df$var$ignoreEl(tickEl);
                return;
            }
        }
    });
}
function $b978afdd15b036df$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $b978afdd15b036df$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $U1aqY.applyTransform)(pt1, pt1, tickTransform);
            (0, $U1aqY.applyTransform)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $c3CaY.default({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $h9U3p.subPixelOptimizeLine(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
        var inner = $b978afdd15b036df$var$getTickInner(tickEl);
        inner.onBand = !!ticksCoords[i].onBand;
        inner.tickValue = ticksCoords[i].tickValue;
    }
    return tickEls;
}
function $b978afdd15b036df$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto') {
        shown = true;
        if (cfg.raw.axisTickAutoShow != null) shown = !!cfg.raw.axisTickAutoShow;
    }
    if (!shown || axis.scale.isBlank()) return [];
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = cfg.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $b978afdd15b036df$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $2N6Uo.defaults)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $b978afdd15b036df$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!cfg.showMinorTicks || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $2N6Uo.defaults)(lineStyleModel.getLineStyle(), (0, $2N6Uo.defaults)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $b978afdd15b036df$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
// Return whether need to call `layOutAxisTickLabel` again.
function $b978afdd15b036df$var$dealLastTickLabelResultReusable(local, group, extraParams) {
    if ($b978afdd15b036df$var$axisLabelBuildResultExists(local)) {
        var axisLabelsCreationContext = local.axisLabelsCreationContext;
        var noPxChangeTryDetermine = axisLabelsCreationContext.out.noPxChangeTryDetermine;
        if (extraParams.noPxChange) {
            var canDetermine = true;
            for(var idx = 0; idx < noPxChangeTryDetermine.length; idx++)canDetermine = canDetermine && noPxChangeTryDetermine[idx]();
            if (canDetermine) return false;
        }
        if (noPxChangeTryDetermine.length) {
            // Remove the result of `buildAxisLabel`
            group.remove(local.labelGroup);
            $b978afdd15b036df$var$axisLabelBuildResultSet(local, null, null, null);
        }
    }
    return true;
}
function $b978afdd15b036df$var$buildAxisLabel(cfg, local, group, kind, axisModel, api) {
    var axis = axisModel.axis;
    var show = (0, $2N6Uo.retrieve)(cfg.raw.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    var labelGroup = new $iQonF.default();
    group.add(labelGroup);
    var axisLabelCreationCtx = (0, $2HLpR.createAxisLabelsComputingContext)(kind);
    if (!show || axis.scale.isBlank()) {
        $b978afdd15b036df$var$axisLabelBuildResultSet(local, [], labelGroup, axisLabelCreationCtx);
        return;
    }
    var labelModel = axisModel.getModel('axisLabel');
    var labels = axis.getViewLabels(axisLabelCreationCtx);
    // Special label rotate.
    var labelRotation = ((0, $2N6Uo.retrieve)(cfg.raw.labelRotate, labelModel.get('rotate')) || 0) * $b978afdd15b036df$var$PI / 180;
    var labelLayout = $b978afdd15b036df$var$AxisBuilder.innerTextLayout(cfg.rotation, labelRotation, cfg.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var triggerEvent = axisModel.get('triggerEvent');
    var z2Min = Infinity;
    var z2Max = -Infinity;
    (0, $2N6Uo.each)(labels, function(labelItem, index) {
        var _a;
        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $2N6Uo.isObject)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $b8YKU.default)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var align = itemLabelModel.getShallow('align', true) || labelLayout.textAlign;
        var alignMin = (0, $2N6Uo.retrieve2)(itemLabelModel.getShallow('alignMinLabel', true), align);
        var alignMax = (0, $2N6Uo.retrieve2)(itemLabelModel.getShallow('alignMaxLabel', true), align);
        var verticalAlign = itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $2N6Uo.retrieve2)(itemLabelModel.getShallow('verticalAlignMinLabel', true), verticalAlign);
        var verticalAlignMax = (0, $2N6Uo.retrieve2)(itemLabelModel.getShallow('verticalAlignMaxLabel', true), verticalAlign);
        var z2 = 10 + (((_a = labelItem.time) === null || _a === void 0 ? void 0 : _a.level) || 0);
        z2Min = Math.min(z2Min, z2);
        z2Max = Math.max(z2Max, z2);
        var textEl = new $kBKw3.default({
            // --- transform props start ---
            // All of the transform props MUST not be set here, but should be set in
            // `updateAxisLabelChangableProps`, because they may change in estimation,
            // and need to calculate based on global coord sys by `decomposeTransform`.
            x: 0,
            y: 0,
            rotation: 0,
            // --- transform props end ---
            silent: $b978afdd15b036df$var$AxisBuilder.isLabelSilent(axisModel),
            z2: z2,
            style: (0, $bysmE.createTextStyle)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $2N6Uo.isFunction)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue;
        var inner = $b978afdd15b036df$export$c392b818a26a879e(textEl);
        inner["break"] = labelItem["break"];
        inner.tickValue = tickValue;
        inner.layoutRotation = labelLayout.rotation;
        $h9U3p.setTooltipConfig({
            el: textEl,
            componentModel: axisModel,
            itemName: formattedLabel,
            formatterParamsExtra: {
                isTruncated: function() {
                    return textEl.isTruncated;
                },
                value: rawLabel,
                tickIndex: index
            }
        });
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $b978afdd15b036df$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            if (labelItem["break"]) eventData["break"] = {
                // type: labelItem.break.type,
                start: labelItem["break"].parsedBreak.vmin,
                end: labelItem["break"].parsedBreak.vmax
            };
            if (axis.type === 'category') eventData.dataIndex = tickValue;
            (0, $6TSUP.getECData)(textEl).eventData = eventData;
            if (labelItem["break"]) $b978afdd15b036df$var$addBreakEventHandler(axisModel, api, textEl, labelItem["break"]);
        }
        labelEls.push(textEl);
        labelGroup.add(textEl);
    });
    var labelLayoutList = (0, $2N6Uo.map)(labelEls, function(label) {
        return {
            label: label,
            priority: $b978afdd15b036df$export$c392b818a26a879e(label)["break"] ? label.z2 + (z2Max - z2Min + 1 // Make break labels be highest priority.
            ) : label.z2,
            defaultAttr: {
                ignore: label.ignore
            }
        };
    });
    $b978afdd15b036df$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelCreationCtx);
}
// Indicate that `layOutAxisTickLabel` has been called.
function $b978afdd15b036df$var$axisLabelBuildResultExists(local) {
    return !!local.labelLayoutList;
}
function $b978afdd15b036df$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelsCreationContext) {
    // Ensure the same lifetime.
    local.labelLayoutList = labelLayoutList;
    local.labelGroup = labelGroup;
    local.axisLabelsCreationContext = axisLabelsCreationContext;
}
function $b978afdd15b036df$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup) {
    var labelMargin = axisModel.get([
        'axisLabel',
        'margin'
    ]);
    (0, $2N6Uo.each)(labelLayoutList, function(layout, idx) {
        var geometry = (0, $g4Fz3.ensureLabelLayoutWithGeometry)(layout);
        if (!geometry) return;
        var labelEl = geometry.label;
        var inner = $b978afdd15b036df$export$c392b818a26a879e(labelEl);
        // See the comment in `suggestIgnore`.
        geometry.suggestIgnore = labelEl.ignore;
        // Currently no `ignore:true` is set in `buildAxisLabel`
        // But `ignore:true` may be set subsequently for overlap handling, thus reset it here.
        labelEl.ignore = false;
        (0, $erz95.copyTransform)($b978afdd15b036df$var$_tmpLayoutEl, $b978afdd15b036df$var$_tmpLayoutElReset);
        $b978afdd15b036df$var$_tmpLayoutEl.x = axisModel.axis.dataToCoord(inner.tickValue);
        $b978afdd15b036df$var$_tmpLayoutEl.y = cfg.labelOffset + cfg.labelDirection * labelMargin;
        $b978afdd15b036df$var$_tmpLayoutEl.rotation = inner.layoutRotation;
        transformGroup.add($b978afdd15b036df$var$_tmpLayoutEl);
        $b978afdd15b036df$var$_tmpLayoutEl.updateTransform();
        transformGroup.remove($b978afdd15b036df$var$_tmpLayoutEl);
        $b978afdd15b036df$var$_tmpLayoutEl.decomposeTransform();
        (0, $erz95.copyTransform)(labelEl, $b978afdd15b036df$var$_tmpLayoutEl);
        labelEl.markRedraw();
        (0, $g4Fz3.setLabelLayoutDirty)(geometry, true);
        (0, $g4Fz3.ensureLabelLayoutWithGeometry)(geometry);
    });
}
var $b978afdd15b036df$var$_tmpLayoutEl = new $aH2k0.default();
var $b978afdd15b036df$var$_tmpLayoutElReset = new $aH2k0.default();
function $b978afdd15b036df$var$hasAxisName(axisName) {
    return !!axisName;
}
function $b978afdd15b036df$var$addBreakEventHandler(axisModel, api, textEl, visualBreak) {
    textEl.on('click', function(params) {
        var payload = {
            type: (0, $2OQYM.AXIS_BREAK_EXPAND_ACTION_TYPE),
            breaks: [
                {
                    start: visualBreak.parsedBreak.breakOption.start,
                    end: visualBreak.parsedBreak.breakOption.end
                }
            ]
        };
        payload[axisModel.axis.dim + "AxisIndex"] = axisModel.componentIndex;
        api.dispatchAction(payload);
    });
}
function $b978afdd15b036df$var$adjustBreakLabels(axisModel, axisRotation, labelLayoutList) {
    var scaleBreakHelper = (0, $bjlCM.getScaleBreakHelper)();
    if (!scaleBreakHelper) return;
    var breakLabelIndexPairs = scaleBreakHelper.retrieveAxisBreakPairs(labelLayoutList, function(layoutInfo) {
        return layoutInfo && $b978afdd15b036df$export$c392b818a26a879e(layoutInfo.label)["break"];
    }, true);
    var moveOverlap = axisModel.get([
        'breakLabelLayout',
        'moveOverlap'
    ], true);
    if (moveOverlap === true || moveOverlap === 'auto') (0, $2N6Uo.each)(breakLabelIndexPairs, function(idxPair) {
        (0, $Etgh3.getAxisBreakHelper)().adjustBreakLabelPair(axisModel.axis.inverse, axisRotation, [
            (0, $g4Fz3.ensureLabelLayoutWithGeometry)(labelLayoutList[idxPair[0]]),
            (0, $g4Fz3.ensureLabelLayoutWithGeometry)(labelLayoutList[idxPair[1]])
        ]);
    });
}
var $b978afdd15b036df$export$2e2bcd8739ae039 = $b978afdd15b036df$var$AxisBuilder;

});
parcelRegister("g4Fz3", function(module, exports) {

$parcel$export(module.exports, "setLabelLayoutDirty", function () { return $bb3d42e205c8161d$export$1551ece3f059eafb; });
$parcel$export(module.exports, "ensureLabelLayoutWithGeometry", function () { return $bb3d42e205c8161d$export$471916f4e89eb5da; });
$parcel$export(module.exports, "computeLabelGeometry", function () { return $bb3d42e205c8161d$export$af9bffc2d00de2cc; });
$parcel$export(module.exports, "computeLabelGeometry2", function () { return $bb3d42e205c8161d$export$bc37ae3f8412d105; });
$parcel$export(module.exports, "labelLayoutApplyTranslation", function () { return $bb3d42e205c8161d$export$91f733c27ab0712f; });
$parcel$export(module.exports, "newLabelLayoutWithGeometry", function () { return $bb3d42e205c8161d$export$a1cfd37e9b88106b; });
$parcel$export(module.exports, "shiftLayoutOnXY", function () { return $bb3d42e205c8161d$export$73ee08bc808f6f3f; });
$parcel$export(module.exports, "restoreIgnore", function () { return $bb3d42e205c8161d$export$ff775ae4fbb23435; });
$parcel$export(module.exports, "hideOverlap", function () { return $bb3d42e205c8161d$export$8ce774e164a49410; });
$parcel$export(module.exports, "labelIntersect", function () { return $bb3d42e205c8161d$export$f28bfabef115ba96; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $h9U3p = parcelRequire("h9U3p");
var $183nE = parcelRequire("183nE");

var $bysmE = parcelRequire("bysmE");
var $bb3d42e205c8161d$var$LABEL_LAYOUT_BASE_PROPS = [
    'label',
    'labelLine',
    'layoutOption',
    'priority',
    'defaultAttr',
    'marginForce',
    'minMarginForce',
    'marginDefault',
    'suggestIgnore'
];
var $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS = 1;
var $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_BIT_OBB = 2;
var $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_ALL = $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS | $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_BIT_OBB;
function $bb3d42e205c8161d$export$1551ece3f059eafb(labelGeometry, dirtyOrClear, dirtyBits) {
    dirtyBits = dirtyBits || $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_ALL;
    dirtyOrClear ? labelGeometry.dirty |= dirtyBits : labelGeometry.dirty &= ~dirtyBits;
}
function $bb3d42e205c8161d$var$isLabelLayoutDirty(labelGeometry, dirtyBits) {
    dirtyBits = dirtyBits || $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_ALL;
    return labelGeometry.dirty == null || !!(labelGeometry.dirty & dirtyBits);
}
function $bb3d42e205c8161d$export$471916f4e89eb5da(labelLayout) {
    if (!labelLayout) return;
    if ($bb3d42e205c8161d$var$isLabelLayoutDirty(labelLayout)) $bb3d42e205c8161d$export$af9bffc2d00de2cc(labelLayout, labelLayout.label, labelLayout);
    return labelLayout;
}
function $bb3d42e205c8161d$export$af9bffc2d00de2cc(out, label, opt) {
    // [CAUTION] These props may be modified directly for performance consideration,
    //  therefore, do not output the internal data structure of zrender Element.
    var rawTransform = label.getComputedTransform();
    out.transform = (0, $h9U3p.ensureCopyTransform)(out.transform, rawTransform);
    // NOTE: should call `getBoundingRect` after `getComputedTransform`, or may get an inaccurate bounding rect.
    //  The reason is that `getComputedTransform` calls `__host.updateInnerText()` internally, which updates the label
    //  by `textConfig` mounted on the host.
    // PENDING: add a dirty bit for that in zrender?
    var outLocalRect = out.localRect = (0, $h9U3p.ensureCopyRect)(out.localRect, label.getBoundingRect());
    var labelStyleExt = label.style;
    var margin = labelStyleExt.margin;
    var marginForce = opt && opt.marginForce;
    var minMarginForce = opt && opt.minMarginForce;
    var marginDefault = opt && opt.marginDefault;
    var marginType = labelStyleExt.__marginType;
    if (marginType == null && marginDefault) {
        margin = marginDefault;
        marginType = (0, $bysmE.LabelMarginType).textMargin;
    }
    // `textMargin` and `minMargin` can not exist both.
    for(var i = 0; i < 4; i++)$bb3d42e205c8161d$var$_tmpLabelMargin[i] = marginType === (0, $bysmE.LabelMarginType).minMargin && minMarginForce && minMarginForce[i] != null ? minMarginForce[i] : marginForce && marginForce[i] != null ? marginForce[i] : margin ? margin[i] : 0;
    if (marginType === (0, $bysmE.LabelMarginType).textMargin) (0, $h9U3p.expandOrShrinkRect)(outLocalRect, $bb3d42e205c8161d$var$_tmpLabelMargin, false, false);
    var outGlobalRect = out.rect = (0, $h9U3p.ensureCopyRect)(out.rect, outLocalRect);
    if (rawTransform) outGlobalRect.applyTransform(rawTransform);
    // Notice: label.style.margin is actually `minMargin / 2`, handled by `setTextStyleCommon`.
    if (marginType === (0, $bysmE.LabelMarginType).minMargin) (0, $h9U3p.expandOrShrinkRect)(outGlobalRect, $bb3d42e205c8161d$var$_tmpLabelMargin, false, false);
    out.axisAligned = (0, $h9U3p.isBoundingRectAxisAligned)(rawTransform);
    (out.label = out.label || {}).ignore = label.ignore;
    $bb3d42e205c8161d$export$1551ece3f059eafb(out, false);
    $bb3d42e205c8161d$export$1551ece3f059eafb(out, true, $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    // Do not remove `obb` (if existing) for reuse, just reset the dirty bit.
    return out;
}
var $bb3d42e205c8161d$var$_tmpLabelMargin = [
    0,
    0,
    0,
    0
];
function $bb3d42e205c8161d$export$bc37ae3f8412d105(out, rawLocalRect, rawTransform) {
    out.transform = (0, $h9U3p.ensureCopyTransform)(out.transform, rawTransform);
    out.localRect = (0, $h9U3p.ensureCopyRect)(out.localRect, rawLocalRect);
    out.rect = (0, $h9U3p.ensureCopyRect)(out.rect, rawLocalRect);
    if (rawTransform) out.rect.applyTransform(rawTransform);
    out.axisAligned = (0, $h9U3p.isBoundingRectAxisAligned)(rawTransform);
    out.obb = undefined; // Reset to undefined, will be created by `ensureOBB` when using.
    (out.label = out.label || {}).ignore = false;
    return out;
}
function $bb3d42e205c8161d$export$91f733c27ab0712f(labelLayout, offset) {
    if (!labelLayout) return;
    labelLayout.label.x += offset.x;
    labelLayout.label.y += offset.y;
    labelLayout.label.markRedraw();
    var transform = labelLayout.transform;
    if (transform) {
        transform[4] += offset.x;
        transform[5] += offset.y;
    }
    var globalRect = labelLayout.rect;
    if (globalRect) {
        globalRect.x += offset.x;
        globalRect.y += offset.y;
    }
    var obb = labelLayout.obb;
    if (obb) obb.fromBoundingRect(labelLayout.localRect, transform);
}
function $bb3d42e205c8161d$export$a1cfd37e9b88106b(newBaseWithDefaults, source) {
    for(var i = 0; i < $bb3d42e205c8161d$var$LABEL_LAYOUT_BASE_PROPS.length; i++){
        var prop = $bb3d42e205c8161d$var$LABEL_LAYOUT_BASE_PROPS[i];
        if (newBaseWithDefaults[prop] == null) newBaseWithDefaults[prop] = source[prop];
    }
    return $bb3d42e205c8161d$export$471916f4e89eb5da(newBaseWithDefaults);
}
/**
 * Create obb if no one, can cache it.
 */ function $bb3d42e205c8161d$var$ensureOBB(labelGeometry) {
    var obb = labelGeometry.obb;
    if (!obb || $bb3d42e205c8161d$var$isLabelLayoutDirty(labelGeometry, $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_BIT_OBB)) {
        labelGeometry.obb = obb = obb || new (0, $183nE.default)();
        obb.fromBoundingRect(labelGeometry.localRect, labelGeometry.transform);
        $bb3d42e205c8161d$export$1551ece3f059eafb(labelGeometry, false, $bb3d42e205c8161d$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    }
    return obb;
}
function $bb3d42e205c8161d$export$73ee08bc808f6f3f(list, xyDimIdx, // 0 for x, 1 for y
minBound, // for x, leftBound; for y, topBound
maxBound, // for x, rightBound; for y, bottomBound
// If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    var len = list.length;
    var xyDim = (0, $h9U3p.XY)[xyDimIdx];
    var sizeDim = (0, $h9U3p.WH)[xyDimIdx];
    if (len < 2) return false;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    // const shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        // shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $bb3d42e205c8161d$export$ff775ae4fbb23435(labelList) {
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var defaultAttr = labelItem.defaultAttr;
        var labelLine = labelItem.labelLine;
        labelItem.label.attr('ignore', defaultAttr.ignore);
        labelLine && labelLine.attr('ignore', defaultAttr.labelGuideIgnore);
    }
}
function $bb3d42e205c8161d$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return (b.suggestIgnore ? 1 : 0) - (a.suggestIgnore ? 1 : 0) || b.priority - a.priority;
    });
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = $bb3d42e205c8161d$export$471916f4e89eb5da(labelList[i]);
        // The current `el.ignore` is involved, since some previous overlap
        // resolving strategies may have set `el.ignore` to true.
        if (labelItem.label.ignore) continue;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        // NOTICE: even when the with/height of globalRect of a label is 0, the label line should
        // still be displayed, since we should follow the concept of "truncation", meaning that
        // something exists even if it cannot be fully displayed. A visible label line is necessary
        // to allow users to get a tooltip with label info on hover.
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++)if ($bb3d42e205c8161d$export$f28bfabef115ba96(labelItem, displayedLabels[j], null, {
            touchThreshold: 0.05
        })) {
            overlapped = true;
            break;
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else displayedLabels.push(labelItem);
    }
}
function $bb3d42e205c8161d$export$f28bfabef115ba96(baseLayoutInfo, targetLayoutInfo, mtv, intersectOpt) {
    if (!baseLayoutInfo || !targetLayoutInfo) return false;
    if (baseLayoutInfo.label && baseLayoutInfo.label.ignore || targetLayoutInfo.label && targetLayoutInfo.label.ignore) return false;
    // Fast rejection.
    if (!baseLayoutInfo.rect.intersect(targetLayoutInfo.rect, mtv, intersectOpt)) return false;
    if (baseLayoutInfo.axisAligned && targetLayoutInfo.axisAligned) return true; // obb is the same as the normal bounding rect.
    return $bb3d42e205c8161d$var$ensureOBB(baseLayoutInfo).intersect($bb3d42e205c8161d$var$ensureOBB(targetLayoutInfo), mtv, intersectOpt);
}

});

parcelRegister("2OQYM", function(module, exports) {

$parcel$export(module.exports, "AXIS_BREAK_EXPAND_ACTION_TYPE", function () { return $20d958de3a247bb0$export$12319e2083cd71ce; });
$parcel$export(module.exports, "AXIS_BREAK_COLLAPSE_ACTION_TYPE", function () { return $20d958de3a247bb0$export$8ba710d11f5d9b28; });
$parcel$export(module.exports, "AXIS_BREAK_TOGGLE_ACTION_TYPE", function () { return $20d958de3a247bb0$export$cfaa507333440c5e; });
$parcel$export(module.exports, "registerAction", function () { return $20d958de3a247bb0$export$408c24786cd729c6; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");
var $20d958de3a247bb0$export$12319e2083cd71ce = 'expandAxisBreak';
var $20d958de3a247bb0$export$8ba710d11f5d9b28 = 'collapseAxisBreak';
var $20d958de3a247bb0$export$cfaa507333440c5e = 'toggleAxisBreak';
var $20d958de3a247bb0$var$AXIS_BREAK_CHANGED_EVENT_TYPE = 'axisbreakchanged';
var $20d958de3a247bb0$var$expandAxisBreakActionInfo = {
    type: $20d958de3a247bb0$export$12319e2083cd71ce,
    event: $20d958de3a247bb0$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $20d958de3a247bb0$var$refineAxisBreakChangeEvent
};
var $20d958de3a247bb0$var$collapseAxisBreakActionInfo = {
    type: $20d958de3a247bb0$export$8ba710d11f5d9b28,
    event: $20d958de3a247bb0$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $20d958de3a247bb0$var$refineAxisBreakChangeEvent
};
var $20d958de3a247bb0$var$toggleAxisBreakActionInfo = {
    type: $20d958de3a247bb0$export$cfaa507333440c5e,
    event: $20d958de3a247bb0$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $20d958de3a247bb0$var$refineAxisBreakChangeEvent
};
function $20d958de3a247bb0$var$refineAxisBreakChangeEvent(actionResultBatch, payload, ecModel, api) {
    var breaks = [];
    (0, $2N6Uo.each)(actionResultBatch, function(actionResult) {
        breaks = breaks.concat(actionResult.eventBreaks);
    });
    return {
        eventContent: {
            breaks: breaks
        }
    };
}
function $20d958de3a247bb0$export$408c24786cd729c6(registers) {
    registers.registerAction($20d958de3a247bb0$var$expandAxisBreakActionInfo, actionHandler);
    registers.registerAction($20d958de3a247bb0$var$collapseAxisBreakActionInfo, actionHandler);
    registers.registerAction($20d958de3a247bb0$var$toggleAxisBreakActionInfo, actionHandler);
    function actionHandler(payload, ecModel) {
        var eventBreaks = [];
        var finderResult = (0, $bx3T8.parseFinder)(ecModel, payload);
        function dealUpdate(modelProp, indexProp) {
            (0, $2N6Uo.each)(finderResult[modelProp], function(axisModel) {
                var result = axisModel.updateAxisBreaks(payload);
                (0, $2N6Uo.each)(result.breaks, function(item) {
                    var _a;
                    eventBreaks.push((0, $2N6Uo.defaults)((_a = {}, _a[indexProp] = axisModel.componentIndex, _a), item));
                });
            });
        }
        dealUpdate('xAxisModels', 'xAxisIndex');
        dealUpdate('yAxisModels', 'yAxisIndex');
        dealUpdate('singleAxisModels', 'singleAxisIndex');
        return {
            eventBreaks: eventBreaks
        };
    }
}

});


parcelRegister("97tZB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a3c086b8e1ffa3c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $5Uet9 = parcelRequire("5Uet9");

var $h9U3p = parcelRequire("h9U3p");
var $hXTRG = parcelRequire("hXTRG");
var $ewDYK = parcelRequire("ewDYK");
var $aH2k0 = parcelRequire("aH2k0");
var $iQonF = parcelRequire("iQonF");

var $ast3M = parcelRequire("ast3M");

var $chf3v = parcelRequire("chf3v");

var $6aXXD = parcelRequire("6aXXD");
var $6a3c086b8e1ffa3c$var$BRUSH_PANEL_GLOBAL = true;
var $6a3c086b8e1ffa3c$var$mathMin = Math.min;
var $6a3c086b8e1ffa3c$var$mathMax = Math.max;
var $6a3c086b8e1ffa3c$var$mathPow = Math.pow;
var $6a3c086b8e1ffa3c$var$COVER_Z = 10000;
var $6a3c086b8e1ffa3c$var$UNSELECT_THRESHOLD = 6;
var $6a3c086b8e1ffa3c$var$MIN_RESIZE_LINE_WIDTH = 6;
var $6a3c086b8e1ffa3c$var$MUTEX_RESOURCE_KEY = 'globalPan';
var $6a3c086b8e1ffa3c$var$DIRECTION_MAP = {
    w: [
        0,
        0
    ],
    e: [
        0,
        1
    ],
    n: [
        1,
        0
    ],
    s: [
        1,
        1
    ]
};
var $6a3c086b8e1ffa3c$var$CURSOR_MAP = {
    w: 'ew',
    e: 'ew',
    n: 'ns',
    s: 'ns',
    ne: 'nesw',
    sw: 'nesw',
    nw: 'nwse',
    se: 'nwse'
};
var $6a3c086b8e1ffa3c$var$DEFAULT_BRUSH_OPT = {
    brushStyle: {
        lineWidth: 2,
        stroke: (0, $6aXXD.default).color.backgroundTint,
        fill: (0, $6aXXD.default).color.borderTint
    },
    transformable: true,
    brushMode: 'single',
    removeOnClick: false
};
var $6a3c086b8e1ffa3c$var$baseUID = 0;
/**
 * params:
 *     areas: Array.<Array>, coord relates to container group,
 *                             If no container specified, to global.
 *     opt {
 *         isEnd: boolean,
 *         removeOnClick: boolean
 *     }
 */ var $6a3c086b8e1ffa3c$var$BrushController = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BrushController, _super);
    function BrushController(zr) {
        var _this = _super.call(this) || this;
        /**
     * @internal
     */ _this._track = [];
        /**
     * @internal
     */ _this._covers = [];
        _this._handlers = {};
        _this._zr = zr;
        _this.group = new $iQonF.default();
        _this._uid = 'brushController_' + $6a3c086b8e1ffa3c$var$baseUID++;
        (0, $2N6Uo.each)($6a3c086b8e1ffa3c$var$pointerHandlers, function(handler, eventName) {
            this._handlers[eventName] = (0, $2N6Uo.bind)(handler, this);
        }, _this);
        return _this;
    }
    /**
   * If set to `false`, select disabled.
   */ BrushController.prototype.enableBrush = function(brushOption) {
        this._brushType && this._doDisableBrush();
        brushOption.brushType && this._doEnableBrush(brushOption);
        return this;
    };
    BrushController.prototype._doEnableBrush = function(brushOption) {
        var zr = this._zr;
        // Consider roam, which takes globalPan too.
        if (!this._enableGlobalPan) $ast3M.take(zr, $6a3c086b8e1ffa3c$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $2N6Uo.each)(this._handlers, function(handler, eventName) {
            zr.on(eventName, handler);
        });
        this._brushType = brushOption.brushType;
        this._brushOption = (0, $2N6Uo.merge)((0, $2N6Uo.clone)($6a3c086b8e1ffa3c$var$DEFAULT_BRUSH_OPT), brushOption, true);
    };
    BrushController.prototype._doDisableBrush = function() {
        var zr = this._zr;
        $ast3M.release(zr, $6a3c086b8e1ffa3c$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $2N6Uo.each)(this._handlers, function(handler, eventName) {
            zr.off(eventName, handler);
        });
        this._brushType = this._brushOption = null;
    };
    /**
   * @param panelOpts If not pass, it is global brush.
   */ BrushController.prototype.setPanels = function(panelOpts) {
        if (panelOpts && panelOpts.length) {
            var panels_1 = this._panels = {};
            (0, $2N6Uo.each)(panelOpts, function(panelOpts) {
                panels_1[panelOpts.panelId] = (0, $2N6Uo.clone)(panelOpts);
            });
        } else this._panels = null;
        return this;
    };
    BrushController.prototype.mount = function(opt) {
        opt = opt || {};
        this._enableGlobalPan = opt.enableGlobalPan;
        var thisGroup = this.group;
        this._zr.add(thisGroup);
        thisGroup.attr({
            x: opt.x || 0,
            y: opt.y || 0,
            rotation: opt.rotation || 0,
            scaleX: opt.scaleX || 1,
            scaleY: opt.scaleY || 1
        });
        this._transform = thisGroup.getLocalTransform();
        return this;
    };
    // eachCover(cb, context): void {
    //     each(this._covers, cb, context);
    // }
    /**
   * Update covers.
   * @param coverConfigList
   *        If coverConfigList is null/undefined, all covers removed.
   */ BrushController.prototype.updateCovers = function(coverConfigList) {
        coverConfigList = (0, $2N6Uo.map)(coverConfigList, function(coverConfig) {
            return (0, $2N6Uo.merge)((0, $2N6Uo.clone)($6a3c086b8e1ffa3c$var$DEFAULT_BRUSH_OPT), coverConfig, true);
        });
        var tmpIdPrefix = '\0-brush-index-';
        var oldCovers = this._covers;
        var newCovers = this._covers = [];
        var controller = this;
        var creatingCover = this._creatingCover;
        new (0, $chf3v.default)(oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
        return this;
        function getKey(brushOption, index) {
            return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
        }
        function oldGetKey(cover, index) {
            return getKey(cover.__brushOption, index);
        }
        function addOrUpdate(newIndex, oldIndex) {
            var newBrushInternal = coverConfigList[newIndex];
            // Consider setOption in event listener of brushSelect,
            // where updating cover when creating should be forbidden.
            if (oldIndex != null && oldCovers[oldIndex] === creatingCover) newCovers[newIndex] = oldCovers[oldIndex];
            else {
                var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : $6a3c086b8e1ffa3c$var$endCreating(controller, $6a3c086b8e1ffa3c$var$createCover(controller, newBrushInternal));
                $6a3c086b8e1ffa3c$var$updateCoverAfterCreation(controller, cover);
            }
        }
        function remove(oldIndex) {
            if (oldCovers[oldIndex] !== creatingCover) controller.group.remove(oldCovers[oldIndex]);
        }
    };
    BrushController.prototype.unmount = function() {
        this.enableBrush(false);
        // container may 'removeAll' outside.
        $6a3c086b8e1ffa3c$var$clearCovers(this);
        this._zr.remove(this.group);
        return this;
    };
    BrushController.prototype.dispose = function() {
        this.unmount();
        this.off();
    };
    return BrushController;
}((0, $5Uet9.default));
function $6a3c086b8e1ffa3c$var$createCover(controller, brushOption) {
    var cover = $6a3c086b8e1ffa3c$var$coverRenderers[brushOption.brushType].createCover(controller, brushOption);
    cover.__brushOption = brushOption;
    $6a3c086b8e1ffa3c$var$updateZ(cover, brushOption);
    controller.group.add(cover);
    return cover;
}
function $6a3c086b8e1ffa3c$var$endCreating(controller, creatingCover) {
    var coverRenderer = $6a3c086b8e1ffa3c$var$getCoverRenderer(creatingCover);
    if (coverRenderer.endCreating) {
        coverRenderer.endCreating(controller, creatingCover);
        $6a3c086b8e1ffa3c$var$updateZ(creatingCover, creatingCover.__brushOption);
    }
    return creatingCover;
}
function $6a3c086b8e1ffa3c$var$updateCoverShape(controller, cover) {
    var brushOption = cover.__brushOption;
    $6a3c086b8e1ffa3c$var$getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}
function $6a3c086b8e1ffa3c$var$updateZ(cover, brushOption) {
    var z = brushOption.z;
    z == null && (z = $6a3c086b8e1ffa3c$var$COVER_Z);
    cover.traverse(function(el) {
        el.z = z;
        el.z2 = z; // Consider in given container.
    });
}
function $6a3c086b8e1ffa3c$var$updateCoverAfterCreation(controller, cover) {
    $6a3c086b8e1ffa3c$var$getCoverRenderer(cover).updateCommon(controller, cover);
    $6a3c086b8e1ffa3c$var$updateCoverShape(controller, cover);
}
function $6a3c086b8e1ffa3c$var$getCoverRenderer(cover) {
    return $6a3c086b8e1ffa3c$var$coverRenderers[cover.__brushOption.brushType];
}
// return target panel or `true` (means global panel)
function $6a3c086b8e1ffa3c$var$getPanelByPoint(controller, e, localCursorPoint) {
    var panels = controller._panels;
    if (!panels) return $6a3c086b8e1ffa3c$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panel;
    var transform = controller._transform;
    (0, $2N6Uo.each)(panels, function(pn) {
        pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
    });
    return panel;
}
// Return a panel or true
function $6a3c086b8e1ffa3c$var$getPanelByCover(controller, cover) {
    var panels = controller._panels;
    if (!panels) return $6a3c086b8e1ffa3c$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panelId = cover.__brushOption.panelId;
    // User may give cover without coord sys info,
    // which is then treated as global panel.
    return panelId != null ? panels[panelId] : $6a3c086b8e1ffa3c$var$BRUSH_PANEL_GLOBAL;
}
function $6a3c086b8e1ffa3c$var$clearCovers(controller) {
    var covers = controller._covers;
    var originalLength = covers.length;
    (0, $2N6Uo.each)(covers, function(cover) {
        controller.group.remove(cover);
    }, controller);
    covers.length = 0;
    return !!originalLength;
}
function $6a3c086b8e1ffa3c$var$trigger(controller, opt) {
    var areas = (0, $2N6Uo.map)(controller._covers, function(cover) {
        var brushOption = cover.__brushOption;
        var range = (0, $2N6Uo.clone)(brushOption.range);
        return {
            brushType: brushOption.brushType,
            panelId: brushOption.panelId,
            range: range
        };
    });
    controller.trigger('brush', {
        areas: areas,
        isEnd: !!opt.isEnd,
        removeOnClick: !!opt.removeOnClick
    });
}
function $6a3c086b8e1ffa3c$var$shouldShowCover(controller) {
    var track = controller._track;
    if (!track.length) return false;
    var p2 = track[track.length - 1];
    var p1 = track[0];
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var dist = $6a3c086b8e1ffa3c$var$mathPow(dx * dx + dy * dy, 0.5);
    return dist > $6a3c086b8e1ffa3c$var$UNSELECT_THRESHOLD;
}
function $6a3c086b8e1ffa3c$var$getTrackEnds(track) {
    var tail = track.length - 1;
    tail < 0 && (tail = 0);
    return [
        track[0],
        track[tail]
    ];
}
function $6a3c086b8e1ffa3c$var$createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
    var cover = new $iQonF.default();
    cover.add(new $aH2k0.default({
        name: 'main',
        style: $6a3c086b8e1ffa3c$var$makeStyle(brushOption),
        silent: true,
        draggable: true,
        cursor: 'move',
        drift: (0, $2N6Uo.curry)($6a3c086b8e1ffa3c$var$driftRect, rectRangeConverter, controller, cover, [
            'n',
            's',
            'w',
            'e'
        ]),
        ondragend: (0, $2N6Uo.curry)($6a3c086b8e1ffa3c$var$trigger, controller, {
            isEnd: true
        })
    }));
    (0, $2N6Uo.each)(edgeNameSequences, function(nameSequence) {
        cover.add(new $aH2k0.default({
            name: nameSequence.join(''),
            style: {
                opacity: 0
            },
            draggable: true,
            silent: true,
            invisible: true,
            drift: (0, $2N6Uo.curry)($6a3c086b8e1ffa3c$var$driftRect, rectRangeConverter, controller, cover, nameSequence),
            ondragend: (0, $2N6Uo.curry)($6a3c086b8e1ffa3c$var$trigger, controller, {
                isEnd: true
            })
        }));
    });
    return cover;
}
function $6a3c086b8e1ffa3c$var$updateBaseRect(controller, cover, localRange, brushOption) {
    var lineWidth = brushOption.brushStyle.lineWidth || 0;
    var handleSize = $6a3c086b8e1ffa3c$var$mathMax(lineWidth, $6a3c086b8e1ffa3c$var$MIN_RESIZE_LINE_WIDTH);
    var x = localRange[0][0];
    var y = localRange[1][0];
    var xa = x - lineWidth / 2;
    var ya = y - lineWidth / 2;
    var x2 = localRange[0][1];
    var y2 = localRange[1][1];
    var x2a = x2 - handleSize + lineWidth / 2;
    var y2a = y2 - handleSize + lineWidth / 2;
    var width = x2 - x;
    var height = y2 - y;
    var widtha = width + lineWidth;
    var heighta = height + lineWidth;
    $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 'main', x, y, width, height);
    if (brushOption.transformable) {
        $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
        $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
        $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
        $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
        $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
        $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
        $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
        $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
    }
}
function $6a3c086b8e1ffa3c$var$updateCommon(controller, cover) {
    var brushOption = cover.__brushOption;
    var transformable = brushOption.transformable;
    var mainEl = cover.childAt(0);
    mainEl.useStyle($6a3c086b8e1ffa3c$var$makeStyle(brushOption));
    mainEl.attr({
        silent: !transformable,
        cursor: transformable ? 'move' : 'default'
    });
    (0, $2N6Uo.each)([
        [
            'w'
        ],
        [
            'e'
        ],
        [
            'n'
        ],
        [
            's'
        ],
        [
            's',
            'e'
        ],
        [
            's',
            'w'
        ],
        [
            'n',
            'e'
        ],
        [
            'n',
            'w'
        ]
    ], function(nameSequence) {
        var el = cover.childOfName(nameSequence.join(''));
        var globalDir = nameSequence.length === 1 ? $6a3c086b8e1ffa3c$var$getGlobalDirection1(controller, nameSequence[0]) : $6a3c086b8e1ffa3c$var$getGlobalDirection2(controller, nameSequence);
        el && el.attr({
            silent: !transformable,
            invisible: !transformable,
            cursor: transformable ? $6a3c086b8e1ffa3c$var$CURSOR_MAP[globalDir] + '-resize' : null
        });
    });
}
function $6a3c086b8e1ffa3c$var$updateRectShape(controller, cover, name, x, y, w, h) {
    var el = cover.childOfName(name);
    el && el.setShape($6a3c086b8e1ffa3c$var$pointsToRect($6a3c086b8e1ffa3c$var$clipByPanel(controller, cover, [
        [
            x,
            y
        ],
        [
            x + w,
            y + h
        ]
    ])));
}
function $6a3c086b8e1ffa3c$var$makeStyle(brushOption) {
    return (0, $2N6Uo.defaults)({
        strokeNoScale: true
    }, brushOption.brushStyle);
}
function $6a3c086b8e1ffa3c$var$formatRectRange(x, y, x2, y2) {
    var min = [
        $6a3c086b8e1ffa3c$var$mathMin(x, x2),
        $6a3c086b8e1ffa3c$var$mathMin(y, y2)
    ];
    var max = [
        $6a3c086b8e1ffa3c$var$mathMax(x, x2),
        $6a3c086b8e1ffa3c$var$mathMax(y, y2)
    ];
    return [
        [
            min[0],
            max[0]
        ],
        [
            min[1],
            max[1]
        ] // y range
    ];
}
function $6a3c086b8e1ffa3c$var$getTransform(controller) {
    return $h9U3p.getTransform(controller.group);
}
function $6a3c086b8e1ffa3c$var$getGlobalDirection1(controller, localDirName) {
    var map = {
        w: 'left',
        e: 'right',
        n: 'top',
        s: 'bottom'
    };
    var inverseMap = {
        left: 'w',
        right: 'e',
        top: 'n',
        bottom: 's'
    };
    var dir = $h9U3p.transformDirection(map[localDirName], $6a3c086b8e1ffa3c$var$getTransform(controller));
    return inverseMap[dir];
}
function $6a3c086b8e1ffa3c$var$getGlobalDirection2(controller, localDirNameSeq) {
    var globalDir = [
        $6a3c086b8e1ffa3c$var$getGlobalDirection1(controller, localDirNameSeq[0]),
        $6a3c086b8e1ffa3c$var$getGlobalDirection1(controller, localDirNameSeq[1])
    ];
    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
    return globalDir.join('');
}
function $6a3c086b8e1ffa3c$var$driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
    var brushOption = cover.__brushOption;
    var rectRange = rectRangeConverter.toRectRange(brushOption.range);
    var localDelta = $6a3c086b8e1ffa3c$var$toLocalDelta(controller, dx, dy);
    (0, $2N6Uo.each)(dirNameSequence, function(dirName) {
        var ind = $6a3c086b8e1ffa3c$var$DIRECTION_MAP[dirName];
        rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
    });
    brushOption.range = rectRangeConverter.fromRectRange($6a3c086b8e1ffa3c$var$formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
    $6a3c086b8e1ffa3c$var$updateCoverAfterCreation(controller, cover);
    $6a3c086b8e1ffa3c$var$trigger(controller, {
        isEnd: false
    });
}
function $6a3c086b8e1ffa3c$var$driftPolygon(controller, cover, dx, dy) {
    var range = cover.__brushOption.range;
    var localDelta = $6a3c086b8e1ffa3c$var$toLocalDelta(controller, dx, dy);
    (0, $2N6Uo.each)(range, function(point) {
        point[0] += localDelta[0];
        point[1] += localDelta[1];
    });
    $6a3c086b8e1ffa3c$var$updateCoverAfterCreation(controller, cover);
    $6a3c086b8e1ffa3c$var$trigger(controller, {
        isEnd: false
    });
}
function $6a3c086b8e1ffa3c$var$toLocalDelta(controller, dx, dy) {
    var thisGroup = controller.group;
    var localD = thisGroup.transformCoordToLocal(dx, dy);
    var localZero = thisGroup.transformCoordToLocal(0, 0);
    return [
        localD[0] - localZero[0],
        localD[1] - localZero[1]
    ];
}
function $6a3c086b8e1ffa3c$var$clipByPanel(controller, cover, data) {
    var panel = $6a3c086b8e1ffa3c$var$getPanelByCover(controller, cover);
    return panel && panel !== $6a3c086b8e1ffa3c$var$BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : (0, $2N6Uo.clone)(data);
}
function $6a3c086b8e1ffa3c$var$pointsToRect(points) {
    var xmin = $6a3c086b8e1ffa3c$var$mathMin(points[0][0], points[1][0]);
    var ymin = $6a3c086b8e1ffa3c$var$mathMin(points[0][1], points[1][1]);
    var xmax = $6a3c086b8e1ffa3c$var$mathMax(points[0][0], points[1][0]);
    var ymax = $6a3c086b8e1ffa3c$var$mathMax(points[0][1], points[1][1]);
    return {
        x: xmin,
        y: ymin,
        width: xmax - xmin,
        height: ymax - ymin
    };
}
function $6a3c086b8e1ffa3c$var$resetCursor(controller, e, localCursorPoint) {
    if (// Check active
    !controller._brushType || $6a3c086b8e1ffa3c$var$isOutsideZrArea(controller, e.offsetX, e.offsetY)) return;
    var zr = controller._zr;
    var covers = controller._covers;
    var currPanel = $6a3c086b8e1ffa3c$var$getPanelByPoint(controller, e, localCursorPoint);
    // Check whether in covers.
    if (!controller._dragging) for(var i = 0; i < covers.length; i++){
        var brushOption = covers[i].__brushOption;
        if (currPanel && (currPanel === $6a3c086b8e1ffa3c$var$BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && $6a3c086b8e1ffa3c$var$coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) // Use cursor style set on cover.
        return;
    }
    currPanel && zr.setCursorStyle('crosshair');
}
function $6a3c086b8e1ffa3c$var$preventDefault(e) {
    var rawE = e.event;
    rawE.preventDefault && rawE.preventDefault();
}
function $6a3c086b8e1ffa3c$var$mainShapeContain(cover, x, y) {
    return cover.childOfName('main').contain(x, y);
}
function $6a3c086b8e1ffa3c$var$updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
    var creatingCover = controller._creatingCover;
    var panel = controller._creatingPanel;
    var thisBrushOption = controller._brushOption;
    var eventParams;
    controller._track.push(localCursorPoint.slice());
    if ($6a3c086b8e1ffa3c$var$shouldShowCover(controller) || creatingCover) {
        if (panel && !creatingCover) {
            thisBrushOption.brushMode === 'single' && $6a3c086b8e1ffa3c$var$clearCovers(controller);
            var brushOption = (0, $2N6Uo.clone)(thisBrushOption);
            brushOption.brushType = $6a3c086b8e1ffa3c$var$determineBrushType(brushOption.brushType, panel);
            brushOption.panelId = panel === $6a3c086b8e1ffa3c$var$BRUSH_PANEL_GLOBAL ? null : panel.panelId;
            creatingCover = controller._creatingCover = $6a3c086b8e1ffa3c$var$createCover(controller, brushOption);
            controller._covers.push(creatingCover);
        }
        if (creatingCover) {
            var coverRenderer = $6a3c086b8e1ffa3c$var$coverRenderers[$6a3c086b8e1ffa3c$var$determineBrushType(controller._brushType, panel)];
            var coverBrushOption = creatingCover.__brushOption;
            coverBrushOption.range = coverRenderer.getCreatingRange($6a3c086b8e1ffa3c$var$clipByPanel(controller, creatingCover, controller._track));
            if (isEnd) {
                $6a3c086b8e1ffa3c$var$endCreating(controller, creatingCover);
                coverRenderer.updateCommon(controller, creatingCover);
            }
            $6a3c086b8e1ffa3c$var$updateCoverShape(controller, creatingCover);
            eventParams = {
                isEnd: isEnd
            };
        }
    } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    {
        if ($6a3c086b8e1ffa3c$var$getPanelByPoint(controller, e, localCursorPoint) && $6a3c086b8e1ffa3c$var$clearCovers(controller)) eventParams = {
            isEnd: isEnd,
            removeOnClick: true
        };
    }
    return eventParams;
}
function $6a3c086b8e1ffa3c$var$determineBrushType(brushType, panel) {
    if (brushType === 'auto') return panel.defaultBrushType;
    return brushType;
}
var $6a3c086b8e1ffa3c$var$pointerHandlers = {
    mousedown: function(e) {
        if (this._dragging) // In case some browser do not support globalOut,
        // and release mouse out side the browser.
        $6a3c086b8e1ffa3c$var$handleDragEnd(this, e);
        else if (!e.target || !e.target.draggable) {
            $6a3c086b8e1ffa3c$var$preventDefault(e);
            var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
            this._creatingCover = null;
            var panel = this._creatingPanel = $6a3c086b8e1ffa3c$var$getPanelByPoint(this, e, localCursorPoint);
            if (panel) {
                this._dragging = true;
                this._track = [
                    localCursorPoint.slice()
                ];
            }
        }
    },
    mousemove: function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = this.group.transformCoordToLocal(x, y);
        $6a3c086b8e1ffa3c$var$resetCursor(this, e, localCursorPoint);
        if (this._dragging) {
            $6a3c086b8e1ffa3c$var$preventDefault(e);
            var eventParams = $6a3c086b8e1ffa3c$var$updateCoverByMouse(this, e, localCursorPoint, false);
            eventParams && $6a3c086b8e1ffa3c$var$trigger(this, eventParams);
        }
    },
    mouseup: function(e) {
        $6a3c086b8e1ffa3c$var$handleDragEnd(this, e);
    }
};
function $6a3c086b8e1ffa3c$var$handleDragEnd(controller, e) {
    if (controller._dragging) {
        $6a3c086b8e1ffa3c$var$preventDefault(e);
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = controller.group.transformCoordToLocal(x, y);
        var eventParams = $6a3c086b8e1ffa3c$var$updateCoverByMouse(controller, e, localCursorPoint, true);
        controller._dragging = false;
        controller._track = [];
        controller._creatingCover = null;
        // trigger event should be at final, after procedure will be nested.
        eventParams && $6a3c086b8e1ffa3c$var$trigger(controller, eventParams);
    }
}
function $6a3c086b8e1ffa3c$var$isOutsideZrArea(controller, x, y) {
    var zr = controller._zr;
    return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 */ var $6a3c086b8e1ffa3c$var$coverRenderers = {
    lineX: $6a3c086b8e1ffa3c$var$getLineRenderer(0),
    lineY: $6a3c086b8e1ffa3c$var$getLineRenderer(1),
    rect: {
        createCover: function(controller, brushOption) {
            function returnInput(range) {
                return range;
            }
            return $6a3c086b8e1ffa3c$var$createBaseRectCover({
                toRectRange: returnInput,
                fromRectRange: returnInput
            }, controller, brushOption, [
                [
                    'w'
                ],
                [
                    'e'
                ],
                [
                    'n'
                ],
                [
                    's'
                ],
                [
                    's',
                    'e'
                ],
                [
                    's',
                    'w'
                ],
                [
                    'n',
                    'e'
                ],
                [
                    'n',
                    'w'
                ]
            ]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $6a3c086b8e1ffa3c$var$getTrackEnds(localTrack);
            return $6a3c086b8e1ffa3c$var$formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            $6a3c086b8e1ffa3c$var$updateBaseRect(controller, cover, localRange, brushOption);
        },
        updateCommon: $6a3c086b8e1ffa3c$var$updateCommon,
        contain: $6a3c086b8e1ffa3c$var$mainShapeContain
    },
    polygon: {
        createCover: function(controller, brushOption) {
            var cover = new $iQonF.default();
            // Do not use graphic.Polygon because graphic.Polyline do not close the
            // border of the shape when drawing, which is a better experience for user.
            cover.add(new $ewDYK.default({
                name: 'main',
                style: $6a3c086b8e1ffa3c$var$makeStyle(brushOption),
                silent: true
            }));
            return cover;
        },
        getCreatingRange: function(localTrack) {
            return localTrack;
        },
        endCreating: function(controller, cover) {
            cover.remove(cover.childAt(0));
            // Use graphic.Polygon close the shape.
            cover.add(new $hXTRG.default({
                name: 'main',
                draggable: true,
                drift: (0, $2N6Uo.curry)($6a3c086b8e1ffa3c$var$driftPolygon, controller, cover),
                ondragend: (0, $2N6Uo.curry)($6a3c086b8e1ffa3c$var$trigger, controller, {
                    isEnd: true
                })
            }));
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            cover.childAt(0).setShape({
                points: $6a3c086b8e1ffa3c$var$clipByPanel(controller, cover, localRange)
            });
        },
        updateCommon: $6a3c086b8e1ffa3c$var$updateCommon,
        contain: $6a3c086b8e1ffa3c$var$mainShapeContain
    }
};
function $6a3c086b8e1ffa3c$var$getLineRenderer(xyIndex) {
    return {
        createCover: function(controller, brushOption) {
            return $6a3c086b8e1ffa3c$var$createBaseRectCover({
                toRectRange: function(range) {
                    var rectRange = [
                        range,
                        [
                            0,
                            100
                        ]
                    ];
                    xyIndex && rectRange.reverse();
                    return rectRange;
                },
                fromRectRange: function(rectRange) {
                    return rectRange[xyIndex];
                }
            }, controller, brushOption, [
                [
                    [
                        'w'
                    ],
                    [
                        'e'
                    ]
                ],
                [
                    [
                        'n'
                    ],
                    [
                        's'
                    ]
                ]
            ][xyIndex]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $6a3c086b8e1ffa3c$var$getTrackEnds(localTrack);
            var min = $6a3c086b8e1ffa3c$var$mathMin(ends[0][xyIndex], ends[1][xyIndex]);
            var max = $6a3c086b8e1ffa3c$var$mathMax(ends[0][xyIndex], ends[1][xyIndex]);
            return [
                min,
                max
            ];
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            var otherExtent;
            // If brushWidth not specified, fit the panel.
            var panel = $6a3c086b8e1ffa3c$var$getPanelByCover(controller, cover);
            if (panel !== $6a3c086b8e1ffa3c$var$BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
            else {
                var zr = controller._zr;
                otherExtent = [
                    0,
                    [
                        zr.getWidth(),
                        zr.getHeight()
                    ][1 - xyIndex]
                ];
            }
            var rectRange = [
                localRange,
                otherExtent
            ];
            xyIndex && rectRange.reverse();
            $6a3c086b8e1ffa3c$var$updateBaseRect(controller, cover, rectRange, brushOption);
        },
        updateCommon: $6a3c086b8e1ffa3c$var$updateCommon,
        contain: $6a3c086b8e1ffa3c$var$mainShapeContain
    };
}
var $6a3c086b8e1ffa3c$export$2e2bcd8739ae039 = $6a3c086b8e1ffa3c$var$BrushController;

});

parcelRegister("3iC2d", function(module, exports) {

$parcel$export(module.exports, "makeRectPanelClipPath", function () { return $26708e6c40f0d323$export$fee17964a62a87a7; });
$parcel$export(module.exports, "makeLinearBrushOtherExtent", function () { return $26708e6c40f0d323$export$7280070e90fad7a0; });
$parcel$export(module.exports, "makeRectIsTargetByCursor", function () { return $26708e6c40f0d323$export$e63e66b3b18aa99f; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $67W72 = parcelRequire("67W72");

var $7vl3X = parcelRequire("7vl3X");

var $h9U3p = parcelRequire("h9U3p");
function $26708e6c40f0d323$export$fee17964a62a87a7(rect) {
    rect = $26708e6c40f0d323$var$normalizeRect(rect);
    return function(localPoints) {
        return $h9U3p.clipPointsByRect(localPoints, rect);
    };
}
function $26708e6c40f0d323$export$7280070e90fad7a0(rect, specifiedXYIndex) {
    rect = $26708e6c40f0d323$var$normalizeRect(rect);
    return function(xyIndex) {
        var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
        var brushWidth = idx ? rect.width : rect.height;
        var base = idx ? rect.x : rect.y;
        return [
            base,
            base + (brushWidth || 0)
        ];
    };
}
function $26708e6c40f0d323$export$e63e66b3b18aa99f(rect, api, targetModel) {
    var boundingRect = $26708e6c40f0d323$var$normalizeRect(rect);
    return function(e, localCursorPoint) {
        return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !(0, $7vl3X.onIrrelevantElement)(e, api, targetModel);
    };
}
// Consider width/height is negative.
function $26708e6c40f0d323$var$normalizeRect(rect) {
    return (0, $67W72.default).create(rect);
}

});


parcelRegister("5onBH", function(module, exports) {

$parcel$export(module.exports, "installParallelActions", function () { return $3ed18184a05e2a55$export$a97c1e0aa84f4f71; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3ed18184a05e2a55$var$actionInfo = {
    type: 'axisAreaSelect',
    event: 'axisAreaSelected'
};
function $3ed18184a05e2a55$export$a97c1e0aa84f4f71(registers) {
    registers.registerAction($3ed18184a05e2a55$var$actionInfo, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'parallelAxis',
            query: payload
        }, function(parallelAxisModel) {
            parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
        });
    });
    /**
   * @payload
   */ registers.registerAction('parallelAxisExpand', function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'parallel',
            query: payload
        }, function(parallelModel) {
            parallelModel.setAxisExpand(payload);
        });
    });
}

});



parcelRegister("9vbiM", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $01c9075517c9b4bf$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4iDP8 = parcelRequire("4iDP8");

var $gtNDS = parcelRequire("gtNDS");

var $5qNR7 = parcelRequire("5qNR7");

var $2N6Uo = parcelRequire("2N6Uo");
function $01c9075517c9b4bf$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $4iDP8.default));
    registers.registerSeriesModel((0, $gtNDS.default));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, $2N6Uo.curry)((0, $5qNR7.layout), 'pictorialBar'));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $5qNR7.createProgressiveLayout)('pictorialBar'));
}

});
parcelRegister("4iDP8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3217bc057639da84$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");

var $bwPbQ = parcelRequire("bwPbQ");

var $k0QDS = parcelRequire("k0QDS");

var $iCU10 = parcelRequire("iCU10");

var $cWIrM = parcelRequire("cWIrM");

var $d8wDg = parcelRequire("d8wDg");

var $bysmE = parcelRequire("bysmE");

var $lQsZt = parcelRequire("lQsZt");

var $6TSUP = parcelRequire("6TSUP");

var $dTvcN = parcelRequire("dTvcN");
var $3217bc057639da84$var$BAR_BORDER_WIDTH_QUERY = [
    'itemStyle',
    'borderWidth'
];
// index: +isHorizontal
var $3217bc057639da84$var$LAYOUT_ATTRS = [
    {
        xy: 'x',
        wh: 'width',
        index: 0,
        posDesc: [
            'left',
            'right'
        ]
    },
    {
        xy: 'y',
        wh: 'height',
        index: 1,
        posDesc: [
            'top',
            'bottom'
        ]
    }
];
var $3217bc057639da84$var$pathForLineWidth = new $h9U3p.Circle();
var $3217bc057639da84$var$PictorialBarView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PictorialBarView, _super);
    function PictorialBarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarView.type;
        return _this;
    }
    PictorialBarView.prototype.render = function(seriesModel, ecModel, api) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var coordSysRect = cartesian.master.getRect();
        var opt = {
            ecSize: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            seriesModel: seriesModel,
            coordSys: cartesian,
            coordSysExtent: [
                [
                    coordSysRect.x,
                    coordSysRect.x + coordSysRect.width
                ],
                [
                    coordSysRect.y,
                    coordSysRect.y + coordSysRect.height
                ]
            ],
            isHorizontal: isHorizontal,
            valueDim: $3217bc057639da84$var$LAYOUT_ATTRS[+isHorizontal],
            categoryDim: $3217bc057639da84$var$LAYOUT_ATTRS[1 - +isHorizontal]
        };
        data.diff(oldData).add(function(dataIndex) {
            if (!data.hasValue(dataIndex)) return;
            var itemModel = $3217bc057639da84$var$getItemModel(data, dataIndex);
            var symbolMeta = $3217bc057639da84$var$getSymbolMeta(data, dataIndex, itemModel, opt);
            var bar = $3217bc057639da84$var$createBar(data, opt, symbolMeta);
            data.setItemGraphicEl(dataIndex, bar);
            group.add(bar);
            $3217bc057639da84$var$updateCommon(bar, opt, symbolMeta);
        }).update(function(newIndex, oldIndex) {
            var bar = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex)) {
                group.remove(bar);
                return;
            }
            var itemModel = $3217bc057639da84$var$getItemModel(data, newIndex);
            var symbolMeta = $3217bc057639da84$var$getSymbolMeta(data, newIndex, itemModel, opt);
            var pictorialShapeStr = $3217bc057639da84$var$getShapeStr(data, symbolMeta);
            if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
                group.remove(bar);
                data.setItemGraphicEl(newIndex, null);
                bar = null;
            }
            if (bar) $3217bc057639da84$var$updateBar(bar, opt, symbolMeta);
            else bar = $3217bc057639da84$var$createBar(data, opt, symbolMeta, true);
            data.setItemGraphicEl(newIndex, bar);
            bar.__pictorialSymbolMeta = symbolMeta;
            // Add back
            group.add(bar);
            $3217bc057639da84$var$updateCommon(bar, opt, symbolMeta);
        }).remove(function(dataIndex) {
            var bar = oldData.getItemGraphicEl(dataIndex);
            bar && $3217bc057639da84$var$removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
        }).execute();
        // Do clipping
        var clipPath = seriesModel.get('clip', true) ? (0, $dTvcN.createClipPath)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
        return this.group;
    };
    PictorialBarView.prototype.remove = function(ecModel, api) {
        var group = this.group;
        var data = this._data;
        if (ecModel.get('animation')) {
            if (data) data.eachItemGraphicEl(function(bar) {
                $3217bc057639da84$var$removeBar(data, (0, $6TSUP.getECData)(bar).dataIndex, ecModel, bar);
            });
        } else group.removeAll();
    };
    PictorialBarView.type = 'pictorialBar';
    return PictorialBarView;
}((0, $cWIrM.default));
// Set or calculate default value about symbol, and calculate layout info.
function $3217bc057639da84$var$getSymbolMeta(data, dataIndex, itemModel, opt) {
    var layout = data.getItemLayout(dataIndex);
    var symbolRepeat = itemModel.get('symbolRepeat');
    var symbolClip = itemModel.get('symbolClip');
    var symbolPosition = itemModel.get('symbolPosition') || 'start';
    var symbolRotate = itemModel.get('symbolRotate');
    var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
    var isAnimationEnabled = itemModel.isAnimationEnabled();
    var symbolMeta = {
        dataIndex: dataIndex,
        layout: layout,
        itemModel: itemModel,
        symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
        style: data.getItemVisual(dataIndex, 'style'),
        symbolClip: symbolClip,
        symbolRepeat: symbolRepeat,
        symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
        symbolPatternSize: symbolPatternSize,
        rotation: rotation,
        animationModel: isAnimationEnabled ? itemModel : null,
        hoverScale: isAnimationEnabled && itemModel.get([
            'emphasis',
            'scale'
        ]),
        z2: itemModel.getShallow('z', true) || 0
    };
    $3217bc057639da84$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
    $3217bc057639da84$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
    $3217bc057639da84$var$prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
    var symbolSize = symbolMeta.symbolSize;
    var symbolOffset = (0, $k0QDS.normalizeSymbolOffset)(itemModel.get('symbolOffset'), symbolSize);
    $3217bc057639da84$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
    return symbolMeta;
}
// bar length can be negative.
function $3217bc057639da84$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var symbolBoundingData = itemModel.get('symbolBoundingData');
    var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
    var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
    var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
    var boundingLength;
    if ($2N6Uo.isArray(symbolBoundingData)) {
        var symbolBoundingExtent = [
            $3217bc057639da84$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx,
            $3217bc057639da84$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx
        ];
        symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
        boundingLength = symbolBoundingExtent[pxSignIdx];
    } else if (symbolBoundingData != null) boundingLength = $3217bc057639da84$var$convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
    else if (symbolRepeat) boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
    else boundingLength = layout[valueDim.wh];
    outputSymbolMeta.boundingLength = boundingLength;
    if (symbolRepeat) outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
    // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
    // and when borderWidth be settled, the actual linewidth will be NaN
    var isXAxis = valueDim.xy === 'x';
    var isInverse = valueAxis.inverse;
    outputSymbolMeta.pxSign = isXAxis && !isInverse || !isXAxis && isInverse ? boundingLength >= 0 ? 1 : -1 : boundingLength > 0 ? 1 : -1;
}
function $3217bc057639da84$var$convertToCoordOnAxis(axis, value) {
    return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
}
// Support ['100%', '100%']
function $3217bc057639da84$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var categoryDim = opt.categoryDim;
    var categorySize = Math.abs(layout[categoryDim.wh]);
    var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
    var parsedSymbolSize;
    if ($2N6Uo.isArray(symbolSize)) parsedSymbolSize = symbolSize.slice();
    else if (symbolSize == null) // will parse to number below
    parsedSymbolSize = [
        '100%',
        '100%'
    ];
    else parsedSymbolSize = [
        symbolSize,
        symbolSize
    ];
    // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
    // to complicated to calculate real percent value if considering scaled lineWidth.
    // So the actual size will bigger than layout size if lineWidth is bigger than zero,
    // which can be tolerated in pictorial chart.
    parsedSymbolSize[categoryDim.index] = (0, $iCU10.parsePercent)(parsedSymbolSize[categoryDim.index], categorySize);
    parsedSymbolSize[valueDim.index] = (0, $iCU10.parsePercent)(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
    outputSymbolMeta.symbolSize = parsedSymbolSize;
    // If x or y is less than zero, show reversed shape.
    var symbolScale = outputSymbolMeta.symbolScale = [
        parsedSymbolSize[0] / symbolPatternSize,
        parsedSymbolSize[1] / symbolPatternSize
    ];
    // Follow convention, 'right' and 'top' is the normal scale.
    symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}
function $3217bc057639da84$var$prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
    // In symbols are drawn with scale, so do not need to care about the case that width
    // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
    // be calculated.
    var valueLineWidth = itemModel.get($3217bc057639da84$var$BAR_BORDER_WIDTH_QUERY) || 0;
    if (valueLineWidth) {
        $3217bc057639da84$var$pathForLineWidth.attr({
            scaleX: symbolScale[0],
            scaleY: symbolScale[1],
            rotation: rotation
        });
        $3217bc057639da84$var$pathForLineWidth.updateTransform();
        valueLineWidth /= $3217bc057639da84$var$pathForLineWidth.getLineScale();
        valueLineWidth *= symbolScale[opt.valueDim.index];
    }
    outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
}
function $3217bc057639da84$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
    var categoryDim = opt.categoryDim;
    var valueDim = opt.valueDim;
    var pxSign = outputSymbolMeta.pxSign;
    var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
    var pathLen = unitLength;
    // Note: rotation will not effect the layout of symbols, because user may
    // want symbols to rotate on its center, which should not be translated
    // when rotating.
    if (symbolRepeat) {
        var absBoundingLength = Math.abs(boundingLength);
        var symbolMargin = $2N6Uo.retrieve(itemModel.get('symbolMargin'), '15%') + '';
        var hasEndGap = false;
        if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
            hasEndGap = true;
            symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
        }
        var symbolMarginNumeric = (0, $iCU10.parsePercent)(symbolMargin, symbolSize[valueDim.index]);
        var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0);
        // When symbol margin is less than 0, margin at both ends will be subtracted
        // to ensure that all of the symbols will not be overflow the given area.
        var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Both final repeatTimes and final symbolMarginNumeric area calculated based on
        // boundingLength.
        var repeatSpecified = (0, $iCU10.isNumeric)(symbolRepeat);
        var repeatTimes = repeatSpecified ? symbolRepeat : $3217bc057639da84$var$toIntTimes((absBoundingLength + endFix) / uLenWithMargin);
        // Adjust calculate margin, to ensure each symbol is displayed
        // entirely in the given layout area.
        var mDiff = absBoundingLength - repeatTimes * unitLength;
        symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
        uLenWithMargin = unitLength + symbolMarginNumeric * 2;
        endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Update repeatTimes when not all symbol will be shown.
        if (!repeatSpecified && symbolRepeat !== 'fixed') repeatTimes = repeatCutLength ? $3217bc057639da84$var$toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
        pathLen = repeatTimes * uLenWithMargin - endFix;
        outputSymbolMeta.repeatTimes = repeatTimes;
        outputSymbolMeta.symbolMargin = symbolMarginNumeric;
    }
    var sizeFix = pxSign * (pathLen / 2);
    var pathPosition = outputSymbolMeta.pathPosition = [];
    pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
    pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
    if (symbolOffset) {
        pathPosition[0] += symbolOffset[0];
        pathPosition[1] += symbolOffset[1];
    }
    var bundlePosition = outputSymbolMeta.bundlePosition = [];
    bundlePosition[categoryDim.index] = layout[categoryDim.xy];
    bundlePosition[valueDim.index] = layout[valueDim.xy];
    var barRectShape = outputSymbolMeta.barRectShape = $2N6Uo.extend({}, layout);
    barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
    barRectShape[categoryDim.wh] = layout[categoryDim.wh];
    var clipShape = outputSymbolMeta.clipShape = {};
    // Consider that symbol may be overflow layout rect.
    clipShape[categoryDim.xy] = -layout[categoryDim.xy];
    clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
    clipShape[valueDim.xy] = 0;
    clipShape[valueDim.wh] = layout[valueDim.wh];
}
function $3217bc057639da84$var$createPath(symbolMeta) {
    var symbolPatternSize = symbolMeta.symbolPatternSize;
    var path = (0, $k0QDS.createSymbol)(// Consider texture img, make a big size.
    symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
    path.attr({
        culling: true
    });
    path.type !== 'image' && path.setStyle({
        strokeNoScale: true
    });
    return path;
}
function $3217bc057639da84$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var symbolSize = symbolMeta.symbolSize;
    var valueLineWidth = symbolMeta.valueLineWidth;
    var pathPosition = symbolMeta.pathPosition;
    var valueDim = opt.valueDim;
    var repeatTimes = symbolMeta.repeatTimes || 0;
    var index = 0;
    var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
    $3217bc057639da84$var$eachPath(bar, function(path) {
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        if (index < repeatTimes) $3217bc057639da84$var$updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
        else $3217bc057639da84$var$updateAttr(path, null, {
            scaleX: 0,
            scaleY: 0
        }, symbolMeta, isUpdate, function() {
            bundle.remove(path);
        });
        // updateHoverAnimation(path, symbolMeta);
        index++;
    });
    for(; index < repeatTimes; index++){
        var path = $3217bc057639da84$var$createPath(symbolMeta);
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        bundle.add(path);
        var target = makeTarget(index);
        $3217bc057639da84$var$updateAttr(path, {
            x: target.x,
            y: target.y,
            scaleX: 0,
            scaleY: 0
        }, {
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            rotation: target.rotation
        }, symbolMeta, isUpdate);
    }
    function makeTarget(index) {
        var position = pathPosition.slice();
        // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
        // Otherwise: i = index;
        var pxSign = symbolMeta.pxSign;
        var i = index;
        if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) i = repeatTimes - 1 - index;
        position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
        return {
            x: position[0],
            y: position[1],
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1],
            rotation: symbolMeta.rotation
        };
    }
}
function $3217bc057639da84$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var mainPath = bar.__pictorialMainPath;
    if (!mainPath) {
        mainPath = bar.__pictorialMainPath = $3217bc057639da84$var$createPath(symbolMeta);
        bundle.add(mainPath);
        $3217bc057639da84$var$updateAttr(mainPath, {
            x: symbolMeta.pathPosition[0],
            y: symbolMeta.pathPosition[1],
            scaleX: 0,
            scaleY: 0,
            rotation: symbolMeta.rotation
        }, {
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1]
        }, symbolMeta, isUpdate);
    } else $3217bc057639da84$var$updateAttr(mainPath, null, {
        x: symbolMeta.pathPosition[0],
        y: symbolMeta.pathPosition[1],
        scaleX: symbolMeta.symbolScale[0],
        scaleY: symbolMeta.symbolScale[1],
        rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
}
// bar rect is used for label.
function $3217bc057639da84$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
    var rectShape = $2N6Uo.extend({}, symbolMeta.barRectShape);
    var barRect = bar.__pictorialBarRect;
    if (!barRect) {
        barRect = bar.__pictorialBarRect = new $h9U3p.Rect({
            z2: 2,
            shape: rectShape,
            silent: true,
            style: {
                stroke: 'transparent',
                fill: 'transparent',
                lineWidth: 0
            }
        });
        barRect.disableMorphing = true;
        bar.add(barRect);
    } else $3217bc057639da84$var$updateAttr(barRect, null, {
        shape: rectShape
    }, symbolMeta, isUpdate);
}
function $3217bc057639da84$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
    // If not clip, symbol will be remove and rebuilt.
    if (symbolMeta.symbolClip) {
        var clipPath = bar.__pictorialClipPath;
        var clipShape = $2N6Uo.extend({}, symbolMeta.clipShape);
        var valueDim = opt.valueDim;
        var animationModel = symbolMeta.animationModel;
        var dataIndex = symbolMeta.dataIndex;
        if (clipPath) $h9U3p.updateProps(clipPath, {
            shape: clipShape
        }, animationModel, dataIndex);
        else {
            clipShape[valueDim.wh] = 0;
            clipPath = new $h9U3p.Rect({
                shape: clipShape
            });
            bar.__pictorialBundle.setClipPath(clipPath);
            bar.__pictorialClipPath = clipPath;
            var target = {};
            target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
            $h9U3p[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
                shape: target
            }, animationModel, dataIndex);
        }
    }
}
function $3217bc057639da84$var$getItemModel(data, dataIndex) {
    var itemModel = data.getItemModel(dataIndex);
    itemModel.getAnimationDelayParams = $3217bc057639da84$var$getAnimationDelayParams;
    itemModel.isAnimationEnabled = $3217bc057639da84$var$isAnimationEnabled;
    return itemModel;
}
function $3217bc057639da84$var$getAnimationDelayParams(path) {
    // The order is the same as the z-order, see `symbolRepeatDiretion`.
    return {
        index: path.__pictorialAnimationIndex,
        count: path.__pictorialRepeatTimes
    };
}
function $3217bc057639da84$var$isAnimationEnabled() {
    // `animation` prop can be set on itemModel in pictorial bar chart.
    return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
}
function $3217bc057639da84$var$createBar(data, opt, symbolMeta, isUpdate) {
    // bar is the main element for each data.
    var bar = new $h9U3p.Group();
    // bundle is used for location and clip.
    var bundle = new $h9U3p.Group();
    bar.add(bundle);
    bar.__pictorialBundle = bundle;
    bundle.x = symbolMeta.bundlePosition[0];
    bundle.y = symbolMeta.bundlePosition[1];
    if (symbolMeta.symbolRepeat) $3217bc057639da84$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
    else $3217bc057639da84$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta);
    $3217bc057639da84$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate);
    $3217bc057639da84$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
    bar.__pictorialShapeStr = $3217bc057639da84$var$getShapeStr(data, symbolMeta);
    bar.__pictorialSymbolMeta = symbolMeta;
    return bar;
}
function $3217bc057639da84$var$updateBar(bar, opt, symbolMeta) {
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;
    var bundle = bar.__pictorialBundle;
    $h9U3p.updateProps(bundle, {
        x: symbolMeta.bundlePosition[0],
        y: symbolMeta.bundlePosition[1]
    }, animationModel, dataIndex);
    if (symbolMeta.symbolRepeat) $3217bc057639da84$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
    else $3217bc057639da84$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
    $3217bc057639da84$var$createOrUpdateBarRect(bar, symbolMeta, true);
    $3217bc057639da84$var$createOrUpdateClip(bar, opt, symbolMeta, true);
}
function $3217bc057639da84$var$removeBar(data, dataIndex, animationModel, bar) {
    // Not show text when animating
    var labelRect = bar.__pictorialBarRect;
    labelRect && labelRect.removeTextContent();
    var paths = [];
    $3217bc057639da84$var$eachPath(bar, function(path) {
        paths.push(path);
    });
    bar.__pictorialMainPath && paths.push(bar.__pictorialMainPath);
    // I do not find proper remove animation for clip yet.
    bar.__pictorialClipPath && (animationModel = null);
    $2N6Uo.each(paths, function(path) {
        $h9U3p.removeElement(path, {
            scaleX: 0,
            scaleY: 0
        }, animationModel, dataIndex, function() {
            bar.parent && bar.parent.remove(bar);
        });
    });
    data.setItemGraphicEl(dataIndex, null);
}
function $3217bc057639da84$var$getShapeStr(data, symbolMeta) {
    return [
        data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none',
        !!symbolMeta.symbolRepeat,
        !!symbolMeta.symbolClip
    ].join(':');
}
function $3217bc057639da84$var$eachPath(bar, cb, context) {
    // Do not use Group#eachChild, because it do not support remove.
    $2N6Uo.each(bar.__pictorialBundle.children(), function(el) {
        el !== bar.__pictorialBarRect && cb.call(context, el);
    });
}
function $3217bc057639da84$var$updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
    immediateAttrs && el.attr(immediateAttrs);
    // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
    if (symbolMeta.symbolClip && !isUpdate) animationAttrs && el.attr(animationAttrs);
    else animationAttrs && $h9U3p[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
}
function $3217bc057639da84$var$updateCommon(bar, opt, symbolMeta) {
    var dataIndex = symbolMeta.dataIndex;
    var itemModel = symbolMeta.itemModel;
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var emphasisModel = itemModel.getModel('emphasis');
    var emphasisStyle = emphasisModel.getModel('itemStyle').getItemStyle();
    var blurStyle = itemModel.getModel([
        'blur',
        'itemStyle'
    ]).getItemStyle();
    var selectStyle = itemModel.getModel([
        'select',
        'itemStyle'
    ]).getItemStyle();
    var cursorStyle = itemModel.getShallow('cursor');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var hoverScale = emphasisModel.get('scale');
    $3217bc057639da84$var$eachPath(bar, function(path) {
        if (path instanceof (0, $lQsZt.default)) {
            var pathStyle = path.style;
            path.useStyle($2N6Uo.extend({
                // TODO other properties like dx, dy ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolMeta.style));
        } else path.useStyle(symbolMeta.style);
        var emphasisState = path.ensureState('emphasis');
        emphasisState.style = emphasisStyle;
        if (hoverScale) {
            // NOTE: Must after scale is set after updateAttr
            emphasisState.scaleX = path.scaleX * 1.1;
            emphasisState.scaleY = path.scaleY * 1.1;
        }
        path.ensureState('blur').style = blurStyle;
        path.ensureState('select').style = selectStyle;
        cursorStyle && (path.cursor = cursorStyle);
        path.z2 = symbolMeta.z2;
    });
    var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
    var barRect = bar.__pictorialBarRect;
    barRect.ignoreClip = true;
    (0, $bysmE.setLabelStyle)(barRect, (0, $bysmE.getLabelStatesModels)(itemModel), {
        labelFetcher: opt.seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $d8wDg.getDefaultLabel)(opt.seriesModel.getData(), dataIndex),
        inheritColor: symbolMeta.style.fill,
        defaultOpacity: symbolMeta.style.opacity,
        defaultOutsidePosition: barPositionOutside
    });
    (0, $bwPbQ.toggleHoverEmphasis)(bar, focus, blurScope, emphasisModel.get('disabled'));
}
function $3217bc057639da84$var$toIntTimes(times) {
    var roundedTimes = Math.round(times);
    // Escapse accurate error
    return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}
var $3217bc057639da84$export$2e2bcd8739ae039 = $3217bc057639da84$var$PictorialBarView;

});

parcelRegister("gtNDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bff5dcae109ee2cb$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $3tTpJ = parcelRequire("3tTpJ");

var $cKPmR = parcelRequire("cKPmR");

var $6aXXD = parcelRequire("6aXXD");
var $bff5dcae109ee2cb$var$PictorialBarSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PictorialBarSeriesModel, _super);
    function PictorialBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarSeriesModel.type;
        _this.hasSymbolVisual = true;
        _this.defaultSymbol = 'roundRect';
        return _this;
    }
    PictorialBarSeriesModel.prototype.getInitialData = function(option) {
        // Disable stack.
        option.stack = null;
        return _super.prototype.getInitialData.apply(this, arguments);
    };
    PictorialBarSeriesModel.type = 'series.pictorialBar';
    PictorialBarSeriesModel.dependencies = [
        'grid'
    ];
    PictorialBarSeriesModel.defaultOption = (0, $cKPmR.inheritDefaultOption)((0, $3tTpJ.default).defaultOption, {
        symbol: 'circle',
        symbolSize: null,
        symbolRotate: null,
        symbolPosition: null,
        symbolOffset: null,
        symbolMargin: null,
        symbolRepeat: false,
        symbolRepeatDirection: 'end',
        symbolClip: false,
        symbolBoundingData: null,
        symbolPatternSize: 400,
        barGap: '-100%',
        // Pictorial bar do not clip by default because in many cases
        // xAxis and yAxis are not displayed and it's expected not to clip
        clip: false,
        // z can be set in data item, which is z2 actually.
        // Disable progressive
        progressive: 0,
        emphasis: {
            // By default pictorialBar do not hover scale. Hover scale is not suitable
            // for the case that both has foreground and background.
            scale: false
        },
        select: {
            itemStyle: {
                borderColor: (0, $6aXXD.default).color.primary
            }
        }
    });
    return PictorialBarSeriesModel;
}((0, $3tTpJ.default));
var $bff5dcae109ee2cb$export$2e2bcd8739ae039 = $bff5dcae109ee2cb$var$PictorialBarSeriesModel;

});


parcelRegister("2UWtH", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $21fe2c3d9523c17d$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eHA3F = parcelRequire("eHA3F");

var $1VhbX = parcelRequire("1VhbX");

var $impUY = parcelRequire("impUY");

var $2N6Uo = parcelRequire("2N6Uo");

var $8S7T2 = parcelRequire("8S7T2");

var $3SP2X = parcelRequire("3SP2X");

var $917fL = parcelRequire("917fL");
function $21fe2c3d9523c17d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $8S7T2.default));
    registers.registerSeriesModel((0, $3SP2X.default));
    (0, $eHA3F.createLegacyDataSelectAction)('pie', registers.registerAction);
    registers.registerLayout((0, $2N6Uo.curry)((0, $1VhbX.default), 'pie'));
    registers.registerProcessor((0, $impUY.default)('pie'));
    registers.registerProcessor((0, $917fL.default)('pie'));
}

});
parcelRegister("1VhbX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1668733ddcda823c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getSeriesLayoutData", function () { return $1668733ddcda823c$export$4e43b88a06b9f223; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iCU10 = parcelRequire("iCU10");

var $eAFw0 = parcelRequire("eAFw0");

var $bx3T8 = parcelRequire("bx3T8");

var $a35Wn = parcelRequire("a35Wn");
var $1668733ddcda823c$var$PI2 = Math.PI * 2;
var $1668733ddcda823c$var$RADIAN = Math.PI / 180;
function $1668733ddcda823c$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var _a = (0, $a35Wn.getCircleLayout)(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0, viewRect = _a.viewRect;
        var startAngle = -seriesModel.get('startAngle') * $1668733ddcda823c$var$RADIAN;
        var endAngle = seriesModel.get('endAngle');
        var padAngle = seriesModel.get('padAngle') * $1668733ddcda823c$var$RADIAN;
        endAngle = endAngle === 'auto' ? startAngle - $1668733ddcda823c$var$PI2 : -endAngle * $1668733ddcda823c$var$RADIAN;
        var minAngle = seriesModel.get('minAngle') * $1668733ddcda823c$var$RADIAN;
        var minAndPadAngle = minAngle + padAngle;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim);
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get('clockwise');
        var roseType = seriesModel.get('roseType');
        var stillShowZeroSum = seriesModel.get('stillShowZeroSum');
        // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0;
        var dir = clockwise ? 1 : -1;
        var angles = [
            startAngle,
            endAngle
        ];
        var halfPadAngle = dir * padAngle / 2;
        (0, $eAFw0.normalizeArcAngles)(angles, !clockwise);
        startAngle = angles[0], endAngle = angles[1];
        var layoutData = $1668733ddcda823c$export$4e43b88a06b9f223(seriesModel);
        layoutData.startAngle = startAngle;
        layoutData.endAngle = endAngle;
        layoutData.clockwise = clockwise;
        layoutData.cx = cx;
        layoutData.cy = cy;
        layoutData.r = r;
        layoutData.r0 = r0;
        var angleRange = Math.abs(endAngle - startAngle);
        // In the case some sector angle is smaller than minAngle
        var restAngle = angleRange;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        // Requird by `pieLabelLayout`.
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            }
            // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== 'area') angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = angleRange / validDataCount;
            if (angle < minAndPadAngle) {
                angle = minAndPadAngle;
                restAngle -= minAndPadAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            // calculate display angle
            var actualStartAngle = 0;
            var actualEndAngle = 0;
            if (padAngle > angle) {
                actualStartAngle = currentAngle + dir * angle / 2;
                actualEndAngle = actualStartAngle;
            } else {
                actualStartAngle = currentAngle + halfPadAngle;
                actualEndAngle = endAngle - halfPadAngle;
            }
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: actualStartAngle,
                endAngle: actualEndAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $iCU10.linearMap)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        });
        // Some sector is constrained by minAngle and padAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $1668733ddcda823c$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle and padAngle
            if (restAngle <= 1e-3) {
                var angle_1 = angleRange / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        layout.angle = angle_1;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle_1 < padAngle) {
                            actualStartAngle = startAngle + dir * (idx + 0.5) * angle_1;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = startAngle + dir * idx * angle_1 + halfPadAngle;
                            actualEndAngle = startAngle + dir * (idx + 1) * angle_1 - halfPadAngle;
                        }
                        layout.startAngle = actualStartAngle;
                        layout.endAngle = actualEndAngle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        var angle = layout.angle === minAndPadAngle ? minAndPadAngle : value * unitRadian;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle < padAngle) {
                            actualStartAngle = currentAngle + dir * angle / 2;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = currentAngle + halfPadAngle;
                            actualEndAngle = currentAngle + dir * angle - halfPadAngle;
                        }
                        layout.startAngle = actualStartAngle;
                        layout.endAngle = actualEndAngle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}
var $1668733ddcda823c$export$4e43b88a06b9f223 = (0, $bx3T8.makeInner)();

});

parcelRegister("8S7T2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67597c06525432c7$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $ewDYK = parcelRequire("ewDYK");
var $60Kbk = parcelRequire("60Kbk");
var $ipprj = parcelRequire("ipprj");
var $kBKw3 = parcelRequire("kBKw3");

var $bwPbQ = parcelRequire("bwPbQ");

var $cWIrM = parcelRequire("cWIrM");

var $2mcSY = parcelRequire("2mcSY");

var $ctvp5 = parcelRequire("ctvp5");

var $bysmE = parcelRequire("bysmE");

var $erB8T = parcelRequire("erB8T");

var $ipprj = parcelRequire("ipprj");

var $1VhbX = parcelRequire("1VhbX");
/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $67597c06525432c7$var$PiePiece = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $kBKw3.default();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var layout = data.getItemLayout(idx);
        // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $2N6Uo.extend)((0, $erB8T.getSectorCornerRadius)(itemModel.getModel('itemStyle'), layout, true), layout);
        // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow('animationType');
            if (seriesModel.ecModel.ssr) {
                // Use scale animation in SSR mode(opacity?)
                // Because CSS SVG animation doesn't support very customized shape animation.
                $ipprj.initProps(sector, {
                    scaleX: 0,
                    scaleY: 0
                }, seriesModel, {
                    dataIndex: idx,
                    isFrom: true
                });
                sector.originX = sectorShape.cx;
                sector.originY = sectorShape.cy;
            } else if (animationType === 'scale') {
                sector.shape.r = layout.r0;
                $ipprj.initProps(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $ipprj.initProps(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $ipprj.updateProps(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $ipprj.saveOldStyle)(sector);
            // Transition animation from the old shape
            $ipprj.updateProps(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, 'style'));
        (0, $bwPbQ.setStatesStylesFromModel)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get('selectedOffset');
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && sector.attr('cursor', cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState('emphasis').shape = (0, $2N6Uo.extend)({
            r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
        }, (0, $erB8T.getSectorCornerRadius)(emphasisModel.getModel('itemStyle'), layout));
        (0, $2N6Uo.extend)(sector.ensureState('select'), {
            x: dx,
            y: dy,
            shape: (0, $erB8T.getSectorCornerRadius)(itemModel.getModel([
                'select',
                'itemStyle'
            ]), layout)
        });
        (0, $2N6Uo.extend)(sector.ensureState('blur'), {
            shape: (0, $erB8T.getSectorCornerRadius)(itemModel.getModel([
                'blur',
                'itemStyle'
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $2N6Uo.extend)(labelLine.ensureState('select'), {
            x: dx,
            y: dy
        });
        // TODO: needs dx, dy in zrender?
        (0, $2N6Uo.extend)(labelText.ensureState('select'), {
            x: dx,
            y: dy
        });
        (0, $bwPbQ.toggleHoverEmphasis)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel('labelLine');
        var style = data.getItemVisual(idx, 'style');
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $bysmE.setLabelStyle)(sector, (0, $bysmE.getLabelStatesModels)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
        });
        var labelText = sector.getTextContent();
        // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        });
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = itemModel.get([
            'label',
            'position'
        ]);
        if (labelPosition !== 'outside' && labelPosition !== 'outer') sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $ewDYK.default();
                this.setTextGuideLine(polyline);
            }
            // Default use item visual color
            (0, $ctvp5.setLabelLineStyle)(this, (0, $ctvp5.getLabelLineStatesModels)(itemModel), {
                stroke: visualColor,
                opacity: (0, $2N6Uo.retrieve3)(labelLineModel.get([
                    'lineStyle',
                    'opacity'
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($60Kbk.default);
// Pie view
var $67597c06525432c7$var$PieView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle;
        // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        }
        // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
        // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
            var layoutData = (0, $1VhbX.getSeriesLayoutData)(seriesModel);
            var sector = new $60Kbk.default({
                shape: (0, $2N6Uo.clone)(layoutData)
            });
            sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $67597c06525432c7$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off('click');
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $ipprj.removeElementWithFadeOut(piePiece, seriesModel, idx);
        }).execute();
        (0, $2mcSY.default)(seriesModel);
        // Always use initial animation.
        if (seriesModel.get('animationTypeUpdate') !== 'expansion') this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = 'pie';
    return PieView;
}((0, $cWIrM.default));
var $67597c06525432c7$export$2e2bcd8739ae039 = $67597c06525432c7$var$PieView;

});
parcelRegister("2mcSY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b77a1aa94227dd0$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position

var $iCU10 = parcelRequire("iCU10");

var $9KN3M = parcelRequire("9KN3M");

var $67W72 = parcelRequire("67W72");

var $2N6Uo = parcelRequire("2N6Uo");

var $ctvp5 = parcelRequire("ctvp5");

var $g4Fz3 = parcelRequire("g4Fz3");
var $1b77a1aa94227dd0$var$RADIAN = Math.PI / 180;
function $1b77a1aa94227dd0$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy);
            // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA;
            // Use ellipse implicit function to calculate x
            var dx = Math.sqrt(Math.abs((1 - dy * dy / rB2) * rA2));
            var newX = cx + (dx + item.len2) * dir;
            var deltaX = newX - item.label.x;
            var newTargetWidth = item.targetTextWidth - deltaX * dir;
            // text x is changed, so need to recalculate width.
            $1b77a1aa94227dd0$var$constrainTextWidth(item, newTargetWidth, true);
            item.label.x = newX;
        }
    }
    // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== 'none') continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy >= semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir;
                // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len;
                // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $g4Fz3.shiftLayoutOnXY)(list, 1, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $1b77a1aa94227dd0$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($1b77a1aa94227dd0$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$1b77a1aa94227dd0$var$isPositionCenter(layout) && layout.linePoints) {
            if (layout.labelStyleWidth != null) continue;
            var label = layout.label;
            var linePoints = layout.linePoints;
            var targetTextWidth = void 0;
            if (layout.labelAlignTo === 'edge') {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (layout.labelAlignTo === 'labelLine') {
                if (label.x < cx) targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            layout.targetTextWidth = targetTextWidth;
            $1b77a1aa94227dd0$var$constrainTextWidth(layout, targetTextWidth, false);
        }
    }
    $1b77a1aa94227dd0$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $1b77a1aa94227dd0$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$1b77a1aa94227dd0$var$isPositionCenter(layout) && layout.linePoints) {
            var label = layout.label;
            var linePoints = layout.linePoints;
            var isAlignToEdge = layout.labelAlignTo === 'edge';
            var padding = label.style.padding;
            var paddingH = padding ? padding[1] + padding[3] : 0;
            // textRect.width already contains paddingH if bgColor is set
            var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
            var realTextWidth = layout.rect.width + extraPaddingH;
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */ function $1b77a1aa94227dd0$var$constrainTextWidth(layout, availableWidth, forceRecalculate) {
    if (layout.labelStyleWidth != null) // User-defined style.width has the highest priority.
    return;
    var label = layout.label;
    var style = label.style;
    var textRect = layout.rect;
    var bgColor = style.backgroundColor;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var overflow = style.overflow;
    // textRect.width already contains paddingH if bgColor is set
    var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
    if (availableWidth < oldOuterWidth || forceRecalculate) {
        if (overflow && overflow.match('break')) {
            // Temporarily set background to be null to calculate
            // the bounding box without background.
            label.setStyle('backgroundColor', null);
            // Set constraining width
            label.setStyle('width', availableWidth - paddingH);
            // This is the real bounding box of the text without padding.
            var innerRect = label.getBoundingRect();
            label.setStyle('width', Math.ceil(innerRect.width));
            label.setStyle('backgroundColor', bgColor);
        } else {
            var availableInnerWidth = availableWidth - paddingH;
            var newWidth = availableWidth < oldOuterWidth ? availableInnerWidth : // Current available width is enough, but the text may have
            // already been wrapped with a smaller available width.
            forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth ? null : availableInnerWidth : null;
            label.setStyle('width', newWidth);
        }
        $1b77a1aa94227dd0$var$computeLabelGlobalRect(textRect, label);
    }
}
function $1b77a1aa94227dd0$var$computeLabelGlobalRect(out, label) {
    $1b77a1aa94227dd0$var$_tmpLabelGeometry.rect = out;
    (0, $g4Fz3.computeLabelGeometry)($1b77a1aa94227dd0$var$_tmpLabelGeometry, label, $1b77a1aa94227dd0$var$_computeLabelGeometryOpt);
}
var $1b77a1aa94227dd0$var$_computeLabelGeometryOpt = {
    minMarginForce: [
        null,
        0,
        null,
        0
    ],
    marginDefault: [
        1,
        0,
        1,
        0
    ]
};
var $1b77a1aa94227dd0$var$_tmpLabelGeometry = {};
function $1b77a1aa94227dd0$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === 'center';
}
function $1b77a1aa94227dd0$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * $1b77a1aa94227dd0$var$RADIAN;
    var viewRect = data.getLayout('viewRect');
    var r = data.getLayout('r');
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel('label');
        // Use position in normal or emphasis
        var labelPosition = labelModel.get('position') || itemModel.get([
            'emphasis',
            'label',
            'position'
        ]);
        var labelDistance = labelModel.get('distanceToLabelLine');
        var labelAlignTo = labelModel.get('alignTo');
        var edgeDistance = (0, $iCU10.parsePercent)(labelModel.get('edgeDistance'), viewWidth);
        var bleedMargin = labelModel.get('bleedMargin');
        if (bleedMargin == null) // An arbitrary strategy for small viewRect - especial pie is layout in calendar or matrix coord sys.
        bleedMargin = Math.min(viewWidth, viewHeight) > 200 ? 10 : 2;
        var labelLineModel = itemModel.getModel('labelLine');
        var labelLineLen = labelLineModel.get('length');
        labelLineLen = (0, $iCU10.parsePercent)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get('length2');
        labelLineLen2 = (0, $iCU10.parsePercent)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $2N6Uo.each)(label.states, setNotShow);
            label.ignore = true;
            if (labelLine) {
                (0, $2N6Uo.each)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            }
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
        if (labelPosition === 'center') {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = 'center';
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === 'edge') // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
        }
        var PI = Math.PI;
        var labelRotate = 0;
        var rotate = labelModel.get('rotate');
        if ((0, $2N6Uo.isNumber)(rotate)) labelRotate = rotate * (PI / 180);
        else if (labelPosition === 'center') labelRotate = 0;
        else if (rotate === 'radial' || rotate === true) {
            var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
            labelRotate = radialAngle;
        } else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
            var rad = Math.atan2(nx, ny);
            if (rad < 0) rad = PI * 2 + rad;
            var isDown = ny > 0;
            if (isDown) rad = PI + rad;
            labelRotate = rad - PI;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: 'middle'
        });
        // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = new (0, $67W72.default)(0, 0, 0, 0);
            $1b77a1aa94227dd0$var$computeLabelGlobalRect(textRect, label);
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get('minTurnAngle'),
                maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
                surfaceNormal: new (0, $9KN3M.default)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect,
                unconstrainedWidth: textRect.width,
                labelStyleWidth: label.style.width
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) $1b77a1aa94227dd0$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $2N6Uo.each)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $2N6Uo.each)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $ctvp5.limitTurnAngle)(linePoints, layout.minTurnAngle);
                (0, $ctvp5.limitSurfaceAngle)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                });
                // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $9KN3M.default)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}

});


parcelRegister("3SP2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d3e030c46b026aa$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $1rIDm = parcelRequire("1rIDm");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $iCU10 = parcelRequire("iCU10");

var $6VFOB = parcelRequire("6VFOB");

var $jP9NX = parcelRequire("jP9NX");

var $49X8G = parcelRequire("49X8G");

var $hIXrb = parcelRequire("hIXrb");
var $2d3e030c46b026aa$var$innerData = $bx3T8.makeInner();
var $2d3e030c46b026aa$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PieSeriesModel, _super);
    function PieSeriesModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $jP9NX.default)($2N6Uo.bind(this.getData, this), $2N6Uo.bind(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $1rIDm.default)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $2N6Uo.curry((0, $6VFOB.makeSeriesEncodeForNameBased), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        // update seats when data is changed
        var dataInner = $2d3e030c46b026aa$var$innerData(data);
        var seats = dataInner.seats;
        if (!seats) {
            var valueList_1 = [];
            data.each(data.mapDimension('value'), function(value) {
                valueList_1.push(value);
            });
            seats = dataInner.seats = (0, $iCU10.getPercentSeats)(valueList_1, data.hostModel.get('percentPrecision'));
        }
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        // seats may be empty when sum is 0
        params.percent = seats[dataIndex] || 0;
        params.$vars.push('percent');
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $bx3T8.defaultEmphasis(option, 'labelLine', [
            'show'
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = 'series.pie';
    PieSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: 'data',
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        radius: [
            0,
            '50%'
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        endAngle: 'auto',
        padAngle: 0,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        coordinateSystemUsage: 'box',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: 'truncate',
            // 'outer', 'inside', 'center'
            position: 'outer',
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: 'none',
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: '25%',
            // Works only position is 'outer' and alignTo is not 'edge'.
            // The default `bleedMargin` is auto determined according to view rect size.
            // bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 30,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: 'solid'
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: 'round'
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: 'lightgray',
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: 'expansion',
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: 'transition',
        animationEasingUpdate: 'cubicInOut',
        animationDurationUpdate: 500,
        animationEasing: 'cubicInOut'
    };
    return PieSeriesModel;
}((0, $49X8G.default));
(0, $hIXrb.registerLayOutOnCoordSysUsage)({
    fullType: $2d3e030c46b026aa$var$PieSeriesModel.type,
    getCoord2: function(model) {
        // Not able to validate `center` type here.
        // But percentage center, such as '12%', is not allowed in this case.
        return model.getShallow('center');
    }
});
var $2d3e030c46b026aa$export$2e2bcd8739ae039 = $2d3e030c46b026aa$var$PieSeriesModel;

});

parcelRegister("917fL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6909d55f712a466b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $6909d55f712a466b$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension('value');
                var curValue = data.get(valueDim, idx);
                if ((0, $2N6Uo.isNumber)(curValue) && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}

});


parcelRegister("fFnzG", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $b67cf8bccf27d932$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $2xZFA = parcelRequire("2xZFA");

var $impUY = parcelRequire("impUY");

var $d9yJZ = parcelRequire("d9yJZ");

var $d5ywl = parcelRequire("d5ywl");

var $2AltV = parcelRequire("2AltV");

var $gFiK4 = parcelRequire("gFiK4");
function $b67cf8bccf27d932$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $gFiK4.install));
    registers.registerChartView((0, $d5ywl.default));
    registers.registerSeriesModel((0, $2AltV.default));
    registers.registerLayout((0, $2xZFA.default));
    registers.registerProcessor((0, $impUY.default)('radar'));
    registers.registerPreprocessor((0, $d9yJZ.default));
}

});
parcelRegister("2xZFA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dae802a28003e62$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $1dae802a28003e62$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('radar', function(seriesModel) {
        var data = seriesModel.getData();
        var points = [];
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var axes = coordSys.getIndicatorAxes();
        $2N6Uo.each(axes, function(axis, axisIndex) {
            data.each(data.mapDimension(axes[axisIndex].dim), function(val, dataIndex) {
                points[dataIndex] = points[dataIndex] || [];
                var point = coordSys.dataToPoint(val, axisIndex);
                points[dataIndex][axisIndex] = $1dae802a28003e62$var$isValidPoint(point) ? point : $1dae802a28003e62$var$getValueMissingPoint(coordSys);
            });
        });
        // Close polygon
        data.each(function(idx) {
            // TODO
            // Is it appropriate to connect to the next data when some data is missing?
            // Or, should trade it like `connectNull` in line chart?
            var firstPoint = $2N6Uo.find(points[idx], function(point) {
                return $1dae802a28003e62$var$isValidPoint(point);
            }) || $1dae802a28003e62$var$getValueMissingPoint(coordSys);
            // Copy the first actual point to the end of the array
            points[idx].push(firstPoint.slice());
            data.setItemLayout(idx, points[idx]);
        });
    });
}
function $1dae802a28003e62$var$isValidPoint(point) {
    return !isNaN(point[0]) && !isNaN(point[1]);
}
function $1dae802a28003e62$var$getValueMissingPoint(coordSys) {
    // It is error-prone to input [NaN, NaN] into polygon, polygon.
    // (probably cause problem when refreshing or animating)
    return [
        coordSys.cx,
        coordSys.cy
    ];
}

});

parcelRegister("d9yJZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9937106af387a181$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck
// Backward compat for radar chart in 2

var $2N6Uo = parcelRequire("2N6Uo");
function $9937106af387a181$export$2e2bcd8739ae039(option) {
    var polarOptArr = option.polar;
    if (polarOptArr) {
        if (!$2N6Uo.isArray(polarOptArr)) polarOptArr = [
            polarOptArr
        ];
        var polarNotRadar_1 = [];
        $2N6Uo.each(polarOptArr, function(polarOpt, idx) {
            if (polarOpt.indicator) {
                if (polarOpt.type && !polarOpt.shape) polarOpt.shape = polarOpt.type;
                option.radar = option.radar || [];
                if (!$2N6Uo.isArray(option.radar)) option.radar = [
                    option.radar
                ];
                option.radar.push(polarOpt);
            } else polarNotRadar_1.push(polarOpt);
        });
        option.polar = polarNotRadar_1;
    }
    $2N6Uo.each(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) seriesOpt.radarIndex = seriesOpt.polarIndex;
    });
}

});

parcelRegister("d5ywl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98768513859d9ca4$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $h9U3p = parcelRequire("h9U3p");

var $bwPbQ = parcelRequire("bwPbQ");

var $2N6Uo = parcelRequire("2N6Uo");

var $k0QDS = parcelRequire("k0QDS");

var $cWIrM = parcelRequire("cWIrM");

var $bysmE = parcelRequire("bysmE");

var $lQsZt = parcelRequire("lQsZt");

var $ipprj = parcelRequire("ipprj");
var $98768513859d9ca4$var$RadarView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(seriesModel, ecModel, api) {
        var polar = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        function createSymbol(data, idx) {
            var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
            if (symbolType === 'none') return;
            var symbolSize = $k0QDS.normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
            var symbolPath = $k0QDS.createSymbol(symbolType, -1, -1, 2, 2);
            var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
            symbolPath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 100,
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2,
                rotation: symbolRotate * Math.PI / 180 || 0
            });
            return symbolPath;
        }
        function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
            // Simply rerender all
            symbolGroup.removeAll();
            for(var i = 0; i < newPoints.length - 1; i++){
                var symbolPath = createSymbol(data, idx);
                if (symbolPath) {
                    symbolPath.__dimIdx = i;
                    if (oldPoints[i]) {
                        symbolPath.setPosition(oldPoints[i]);
                        $h9U3p[isInit ? 'initProps' : 'updateProps'](symbolPath, {
                            x: newPoints[i][0],
                            y: newPoints[i][1]
                        }, seriesModel, idx);
                    } else symbolPath.setPosition(newPoints[i]);
                    symbolGroup.add(symbolPath);
                }
            }
        }
        function getInitialPoints(points) {
            return $2N6Uo.map(points, function(pt) {
                return [
                    polar.cx,
                    polar.cy
                ];
            });
        }
        data.diff(oldData).add(function(idx) {
            var points = data.getItemLayout(idx);
            if (!points) return;
            var polygon = new $h9U3p.Polygon();
            var polyline = new $h9U3p.Polyline();
            var target = {
                shape: {
                    points: points
                }
            };
            polygon.shape.points = getInitialPoints(points);
            polyline.shape.points = getInitialPoints(points);
            $h9U3p.initProps(polygon, target, seriesModel, idx);
            $h9U3p.initProps(polyline, target, seriesModel, idx);
            var itemGroup = new $h9U3p.Group();
            var symbolGroup = new $h9U3p.Group();
            itemGroup.add(polyline);
            itemGroup.add(polygon);
            itemGroup.add(symbolGroup);
            updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
            data.setItemGraphicEl(idx, itemGroup);
        }).update(function(newIdx, oldIdx) {
            var itemGroup = oldData.getItemGraphicEl(oldIdx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            var target = {
                shape: {
                    points: data.getItemLayout(newIdx)
                }
            };
            if (!target.shape.points) return;
            updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
            (0, $ipprj.saveOldStyle)(polygon);
            (0, $ipprj.saveOldStyle)(polyline);
            $h9U3p.updateProps(polyline, target, seriesModel);
            $h9U3p.updateProps(polygon, target, seriesModel);
            data.setItemGraphicEl(newIdx, itemGroup);
        }).remove(function(idx) {
            group.remove(oldData.getItemGraphicEl(idx));
        }).execute();
        data.eachItemGraphicEl(function(itemGroup, idx) {
            var itemModel = data.getItemModel(idx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            // Radar uses the visual encoded from itemStyle.
            var itemStyle = data.getItemVisual(idx, 'style');
            var color = itemStyle.fill;
            group.add(itemGroup);
            polyline.useStyle($2N6Uo.defaults(itemModel.getModel('lineStyle').getLineStyle(), {
                fill: 'none',
                stroke: color
            }));
            (0, $bwPbQ.setStatesStylesFromModel)(polyline, itemModel, 'lineStyle');
            (0, $bwPbQ.setStatesStylesFromModel)(polygon, itemModel, 'areaStyle');
            var areaStyleModel = itemModel.getModel('areaStyle');
            var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
            polygon.ignore = polygonIgnore;
            $2N6Uo.each([
                'emphasis',
                'select',
                'blur'
            ], function(stateName) {
                var stateModel = itemModel.getModel([
                    stateName,
                    'areaStyle'
                ]);
                var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty();
                // Won't be ignore if normal state is not ignore.
                polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
                var lineStyle = itemModel.getModel([
                    stateName,
                    'lineStyle'
                ]).getLineStyle();
                polyline.ensureState(stateName).style = lineStyle;
                var areaStyle = stateModel.getAreaStyle();
                polygon.ensureState(stateName).style = areaStyle;
                var itemStateStyle = itemModel.getModel([
                    stateName,
                    'itemStyle'
                ]).getItemStyle();
                symbolGroup.eachChild(function(symbolPath) {
                    symbolPath.ensureState(stateName).style = $2N6Uo.clone(itemStateStyle);
                });
            });
            polygon.useStyle($2N6Uo.defaults(itemModel.getModel('areaStyle').getAreaStyle(), {
                fill: color,
                opacity: 0.7,
                decal: itemStyle.decal
            }));
            var emphasisModel = itemModel.getModel('emphasis');
            symbolGroup.eachChild(function(symbolPath) {
                if (symbolPath instanceof (0, $lQsZt.default)) {
                    var pathStyle = symbolPath.style;
                    symbolPath.useStyle($2N6Uo.extend({
                        // TODO other properties like x, y ?
                        image: pathStyle.image,
                        x: pathStyle.x,
                        y: pathStyle.y,
                        width: pathStyle.width,
                        height: pathStyle.height
                    }, itemStyle));
                } else {
                    symbolPath.useStyle(itemStyle);
                    symbolPath.setColor(color);
                    symbolPath.style.strokeNoScale = true;
                }
                var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
                (defaultText == null || isNaN(defaultText)) && (defaultText = '');
                (0, $bysmE.setLabelStyle)(symbolPath, (0, $bysmE.getLabelStatesModels)(itemModel), {
                    labelFetcher: data.hostModel,
                    labelDataIndex: idx,
                    labelDimIndex: symbolPath.__dimIdx,
                    defaultText: defaultText,
                    inheritColor: color,
                    defaultOpacity: itemStyle.opacity
                });
            });
            (0, $bwPbQ.toggleHoverEmphasis)(itemGroup, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        this._data = data;
    };
    RadarView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    RadarView.type = 'radar';
    return RadarView;
}((0, $cWIrM.default));
var $98768513859d9ca4$export$2e2bcd8739ae039 = $98768513859d9ca4$var$RadarView;

});

parcelRegister("2AltV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e1f9b5e68deef2b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $1rIDm = parcelRequire("1rIDm");

var $2N6Uo = parcelRequire("2N6Uo");

var $jP9NX = parcelRequire("jP9NX");

var $5KdhI = parcelRequire("5KdhI");
var $1e1f9b5e68deef2b$var$RadarSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RadarSeriesModel, _super);
    function RadarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    // Overwrite
    RadarSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $jP9NX.default)($2N6Uo.bind(this.getData, this), $2N6Uo.bind(this.getRawData, this));
    };
    RadarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $1rIDm.default)(this, {
            generateCoord: 'indicator_',
            generateCoordCount: Infinity
        });
    };
    RadarSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var indicatorAxes = coordSys.getIndicatorAxes();
        var name = this.getData().getName(dataIndex);
        var nameToDisplay = name === '' ? this.name : name;
        var markerColor = (0, $5KdhI.retrieveVisualColorForTooltipMarker)(this, dataIndex);
        return (0, $5KdhI.createTooltipMarkup)('section', {
            header: nameToDisplay,
            sortBlocks: true,
            blocks: $2N6Uo.map(indicatorAxes, function(axis) {
                var val = data.get(data.mapDimension(axis.dim), dataIndex);
                return (0, $5KdhI.createTooltipMarkup)('nameValue', {
                    markerType: 'subItem',
                    markerColor: markerColor,
                    name: axis.name,
                    value: val,
                    sortParam: val
                });
            })
        });
    };
    RadarSeriesModel.prototype.getTooltipPosition = function(dataIndex) {
        if (dataIndex != null) {
            var data_1 = this.getData();
            var coordSys = this.coordinateSystem;
            var values = data_1.getValues($2N6Uo.map(coordSys.dimensions, function(dim) {
                return data_1.mapDimension(dim);
            }), dataIndex);
            for(var i = 0, len = values.length; i < len; i++)if (!isNaN(values[i])) {
                var indicatorAxes = coordSys.getIndicatorAxes();
                return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
            }
        }
    };
    RadarSeriesModel.type = 'series.radar';
    RadarSeriesModel.dependencies = [
        'radar'
    ];
    RadarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        coordinateSystem: 'radar',
        legendHoverLink: true,
        radarIndex: 0,
        lineStyle: {
            width: 2,
            type: 'solid',
            join: 'round'
        },
        label: {
            position: 'top'
        },
        // areaStyle: {
        // },
        // itemStyle: {}
        symbolSize: 8
    };
    return RadarSeriesModel;
}((0, $49X8G.default));
var $1e1f9b5e68deef2b$export$2e2bcd8739ae039 = $1e1f9b5e68deef2b$var$RadarSeriesModel;

});

parcelRegister("gFiK4", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $c21f03785c54df35$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eIEgm = parcelRequire("eIEgm");

var $dpOHz = parcelRequire("dpOHz");

var $k5n58 = parcelRequire("k5n58");
function $c21f03785c54df35$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem('radar', (0, $k5n58.default));
    registers.registerComponentModel((0, $eIEgm.default));
    registers.registerComponentView((0, $dpOHz.default));
    registers.registerVisual({
        seriesType: 'radar',
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // itemVisual symbol is for selected data
            data.each(function(idx) {
                data.setItemVisual(idx, 'legendIcon', 'roundRect');
            });
            // visual is for unselected data
            data.setVisual('legendIcon', 'roundRect');
        }
    });
}

});
parcelRegister("eIEgm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab74681b6984cf72$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $kyB0C = parcelRequire("kyB0C");

var $b8YKU = parcelRequire("b8YKU");

var $fRzLp = parcelRequire("fRzLp");

var $eLD2b = parcelRequire("eLD2b");

var $6aXXD = parcelRequire("6aXXD");
var $ab74681b6984cf72$var$valueAxisDefault = (0, $kyB0C.default).value;
function $ab74681b6984cf72$var$defaultsShow(opt, show) {
    return $2N6Uo.defaults({
        show: show
    }, opt);
}
var $ab74681b6984cf72$var$RadarModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RadarModel, _super);
    function RadarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarModel.type;
        return _this;
    }
    RadarModel.prototype.optionUpdated = function() {
        var boundaryGap = this.get('boundaryGap');
        var splitNumber = this.get('splitNumber');
        var scale = this.get('scale');
        var axisLine = this.get('axisLine');
        var axisTick = this.get('axisTick');
        // let axisType = this.get('axisType');
        var axisLabel = this.get('axisLabel');
        var nameTextStyle = this.get('axisName');
        var showName = this.get([
            'axisName',
            'show'
        ]);
        var nameFormatter = this.get([
            'axisName',
            'formatter'
        ]);
        var nameGap = this.get('axisNameGap');
        var triggerEvent = this.get('triggerEvent');
        var indicatorModels = $2N6Uo.map(this.get('indicator') || [], function(indicatorOpt) {
            // PENDING
            if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) indicatorOpt.min = 0;
            else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) indicatorOpt.max = 0;
            var iNameTextStyle = nameTextStyle;
            if (indicatorOpt.color != null) iNameTextStyle = $2N6Uo.defaults({
                color: indicatorOpt.color
            }, nameTextStyle);
            // Use same configuration
            var innerIndicatorOpt = $2N6Uo.merge($2N6Uo.clone(indicatorOpt), {
                boundaryGap: boundaryGap,
                splitNumber: splitNumber,
                scale: scale,
                axisLine: axisLine,
                axisTick: axisTick,
                // axisType: axisType,
                axisLabel: axisLabel,
                // Compatible with 2 and use text
                name: indicatorOpt.text,
                showName: showName,
                nameLocation: 'end',
                nameGap: nameGap,
                // min: 0,
                nameTextStyle: iNameTextStyle,
                triggerEvent: triggerEvent
            }, false);
            if ($2N6Uo.isString(nameFormatter)) {
                var indName = innerIndicatorOpt.name;
                innerIndicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
            } else if ($2N6Uo.isFunction(nameFormatter)) innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
            var model = new (0, $b8YKU.default)(innerIndicatorOpt, null, this.ecModel);
            $2N6Uo.mixin(model, (0, $fRzLp.AxisModelCommonMixin).prototype);
            // For triggerEvent.
            model.mainType = 'radar';
            model.componentIndex = this.componentIndex;
            return model;
        }, this);
        this._indicatorModels = indicatorModels;
    };
    RadarModel.prototype.getIndicatorModels = function() {
        return this._indicatorModels;
    };
    RadarModel.type = 'radar';
    RadarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            '50%',
            '50%'
        ],
        radius: '50%',
        startAngle: 90,
        axisName: {
            show: true,
            color: (0, $6aXXD.default).color.axisLabel
        },
        boundaryGap: [
            0,
            0
        ],
        splitNumber: 5,
        axisNameGap: 15,
        scale: false,
        // Polygon or circle
        shape: 'polygon',
        axisLine: $2N6Uo.merge({
            lineStyle: {
                color: (0, $6aXXD.default).color.neutral20
            }
        }, $ab74681b6984cf72$var$valueAxisDefault.axisLine),
        axisLabel: $ab74681b6984cf72$var$defaultsShow($ab74681b6984cf72$var$valueAxisDefault.axisLabel, false),
        axisTick: $ab74681b6984cf72$var$defaultsShow($ab74681b6984cf72$var$valueAxisDefault.axisTick, false),
        // axisType: 'value',
        splitLine: $ab74681b6984cf72$var$defaultsShow($ab74681b6984cf72$var$valueAxisDefault.splitLine, true),
        splitArea: $ab74681b6984cf72$var$defaultsShow($ab74681b6984cf72$var$valueAxisDefault.splitArea, true),
        // {text, min, max}
        indicator: []
    };
    return RadarModel;
}((0, $eLD2b.default));
var $ab74681b6984cf72$export$2e2bcd8739ae039 = $ab74681b6984cf72$var$RadarModel;

});

parcelRegister("dpOHz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c44f074c4f6804c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $fVg7M = parcelRequire("fVg7M");
parcelRequire("h9U3p");
var $6Utk3 = parcelRequire("6Utk3");
var $h9U3p = parcelRequire("h9U3p");
var $hXTRG = parcelRequire("hXTRG");
var $ewDYK = parcelRequire("ewDYK");
var $iqf4i = parcelRequire("iqf4i");

var $bpyST = parcelRequire("bpyST");
var $9c44f074c4f6804c$var$RadarView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(radarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        this._buildAxes(radarModel, api);
        this._buildSplitLineAndArea(radarModel);
    };
    RadarView.prototype._buildAxes = function(radarModel, api) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        var axisBuilders = $2N6Uo.map(indicatorAxes, function(indicatorAxis) {
            var axisName = indicatorAxis.model.get('showName') ? indicatorAxis.name : ''; // hide name
            var axisBuilder = new (0, $fVg7M.default)(indicatorAxis.model, api, {
                axisName: axisName,
                position: [
                    radar.cx,
                    radar.cy
                ],
                rotation: indicatorAxis.angle,
                labelDirection: -1,
                tickDirection: -1,
                nameDirection: 1
            });
            return axisBuilder;
        });
        $2N6Uo.each(axisBuilders, function(axisBuilder) {
            axisBuilder.build();
            this.group.add(axisBuilder.group);
        }, this);
    };
    RadarView.prototype._buildSplitLineAndArea = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        if (!indicatorAxes.length) return;
        var shape = radarModel.get('shape');
        var splitLineModel = radarModel.getModel('splitLine');
        var splitAreaModel = radarModel.getModel('splitArea');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var showSplitLine = splitLineModel.get('show');
        var showSplitArea = splitAreaModel.get('show');
        var splitLineColors = lineStyleModel.get('color');
        var splitAreaColors = areaStyleModel.get('color');
        var splitLineColorsArr = $2N6Uo.isArray(splitLineColors) ? splitLineColors : [
            splitLineColors
        ];
        var splitAreaColorsArr = $2N6Uo.isArray(splitAreaColors) ? splitAreaColors : [
            splitAreaColors
        ];
        var splitLines = [];
        var splitAreas = [];
        function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
            var colorIndex = idx % areaOrLineColorList.length;
            areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
            return colorIndex;
        }
        if (shape === 'circle') {
            var ticksRadius = indicatorAxes[0].getTicksCoords();
            var cx = radar.cx;
            var cy = radar.cy;
            for(var i = 0; i < ticksRadius.length; i++){
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $6Utk3.default({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r: ticksRadius[i].coord
                        }
                    }));
                }
                if (showSplitArea && i < ticksRadius.length - 1) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
                    splitAreas[colorIndex].push(new $iqf4i.default({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r0: ticksRadius[i].coord,
                            r: ticksRadius[i + 1].coord
                        }
                    }));
                }
            }
        } else {
            var realSplitNumber_1;
            var axesTicksPoints = $2N6Uo.map(indicatorAxes, function(indicatorAxis, idx) {
                var ticksCoords = indicatorAxis.getTicksCoords();
                realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
                return $2N6Uo.map(ticksCoords, function(tickCoord) {
                    return radar.coordToPoint(tickCoord.coord, idx);
                });
            });
            var prevPoints = [];
            for(var i = 0; i <= realSplitNumber_1; i++){
                var points = [];
                for(var j = 0; j < indicatorAxes.length; j++)points.push(axesTicksPoints[j][i]);
                // Close
                if (points[0]) points.push(points[0].slice());
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $ewDYK.default({
                        shape: {
                            points: points
                        }
                    }));
                }
                if (showSplitArea && prevPoints) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
                    splitAreas[colorIndex].push(new $hXTRG.default({
                        shape: {
                            points: points.concat(prevPoints)
                        }
                    }));
                }
                prevPoints = points.slice().reverse();
            }
        }
        var lineStyle = lineStyleModel.getLineStyle();
        var areaStyle = areaStyleModel.getAreaStyle();
        // Add splitArea before splitLine
        $2N6Uo.each(splitAreas, function(splitAreas, idx) {
            this.group.add($h9U3p.mergePath(splitAreas, {
                style: $2N6Uo.defaults({
                    stroke: 'none',
                    fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
                }, areaStyle),
                silent: true
            }));
        }, this);
        $2N6Uo.each(splitLines, function(splitLines, idx) {
            this.group.add($h9U3p.mergePath(splitLines, {
                style: $2N6Uo.defaults({
                    fill: 'none',
                    stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
                }, lineStyle),
                silent: true
            }));
        }, this);
    };
    RadarView.type = 'radar';
    return RadarView;
}((0, $bpyST.default));
var $9c44f074c4f6804c$export$2e2bcd8739ae039 = $9c44f074c4f6804c$var$RadarView;

});

parcelRegister("k5n58", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9f62dd551e160d3$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO clockwise

var $fLXNP = parcelRequire("fLXNP");

var $k1WNO = parcelRequire("k1WNO");

var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");

var $5UHoe = parcelRequire("5UHoe");

var $a35Wn = parcelRequire("a35Wn");
var $e9f62dd551e160d3$var$Radar = /** @class */ function() {
    function Radar(radarModel, ecModel, api) {
        /**
     *
     * Radar dimensions
     */ this.dimensions = [];
        this._model = radarModel;
        this._indicatorAxes = (0, $2N6Uo.map)(radarModel.getIndicatorModels(), function(indicatorModel, idx) {
            var dim = 'indicator_' + idx;
            var indicatorAxis = new (0, $fLXNP.default)(dim, new (0, $k1WNO.default)());
            indicatorAxis.name = indicatorModel.get('name');
            // Inject model and axis
            indicatorAxis.model = indicatorModel;
            indicatorModel.axis = indicatorAxis;
            this.dimensions.push(dim);
            return indicatorAxis;
        }, this);
        this.resize(radarModel, api);
    }
    Radar.prototype.getIndicatorAxes = function() {
        return this._indicatorAxes;
    };
    Radar.prototype.dataToPoint = function(value, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
    };
    // TODO: API should be coordToPoint([coord, indicatorIndex])
    Radar.prototype.coordToPoint = function(coord, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        var angle = indicatorAxis.angle;
        var x = this.cx + coord * Math.cos(angle);
        var y = this.cy - coord * Math.sin(angle);
        return [
            x,
            y
        ];
    };
    Radar.prototype.pointToData = function(pt) {
        var dx = pt[0] - this.cx;
        var dy = pt[1] - this.cy;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx);
        // Find the closest angle
        // FIXME index can calculated directly
        var minRadianDiff = Infinity;
        var closestAxis;
        var closestAxisIdx = -1;
        for(var i = 0; i < this._indicatorAxes.length; i++){
            var indicatorAxis = this._indicatorAxes[i];
            var diff = Math.abs(radian - indicatorAxis.angle);
            if (diff < minRadianDiff) {
                closestAxis = indicatorAxis;
                closestAxisIdx = i;
                minRadianDiff = diff;
            }
        }
        return [
            closestAxisIdx,
            +(closestAxis && closestAxis.coordToData(radius))
        ];
    };
    Radar.prototype.resize = function(radarModel, api) {
        var refContainer = (0, $a35Wn.createBoxLayoutReference)(radarModel, api).refContainer;
        var center = radarModel.get('center');
        var viewSize = Math.min(refContainer.width, refContainer.height) / 2;
        this.cx = $iCU10.parsePercent(center[0], refContainer.width) + refContainer.x;
        this.cy = $iCU10.parsePercent(center[1], refContainer.height) + refContainer.y;
        this.startAngle = radarModel.get('startAngle') * Math.PI / 180;
        // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
        var radius = radarModel.get('radius');
        if ((0, $2N6Uo.isString)(radius) || (0, $2N6Uo.isNumber)(radius)) radius = [
            0,
            radius
        ];
        this.r0 = $iCU10.parsePercent(radius[0], viewSize);
        this.r = $iCU10.parsePercent(radius[1], viewSize);
        (0, $2N6Uo.each)(this._indicatorAxes, function(indicatorAxis, idx) {
            indicatorAxis.setExtent(this.r0, this.r);
            var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length;
            // Normalize to [-PI, PI]
            angle = Math.atan2(Math.sin(angle), Math.cos(angle));
            indicatorAxis.angle = angle;
        }, this);
    };
    Radar.prototype.update = function(ecModel, api) {
        var indicatorAxes = this._indicatorAxes;
        var radarModel = this._model;
        (0, $2N6Uo.each)(indicatorAxes, function(indicatorAxis) {
            indicatorAxis.scale.setExtent(Infinity, -Infinity);
        });
        ecModel.eachSeriesByType('radar', function(radarSeries, idx) {
            if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) return;
            var data = radarSeries.getData();
            (0, $2N6Uo.each)(indicatorAxes, function(indicatorAxis) {
                indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
            });
        }, this);
        var splitNumber = radarModel.get('splitNumber');
        var dummyScale = new (0, $k1WNO.default)();
        dummyScale.setExtent(0, splitNumber);
        dummyScale.setInterval(1);
        // Force all the axis fixing the maxSplitNumber.
        (0, $2N6Uo.each)(indicatorAxes, function(indicatorAxis, idx) {
            (0, $5UHoe.alignScaleTicks)(indicatorAxis.scale, indicatorAxis.model, dummyScale);
        });
    };
    Radar.prototype.convertToPixel = function(ecModel, finder, value) {
        console.warn('Not implemented.');
        return null;
    };
    Radar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        console.warn('Not implemented.');
        return null;
    };
    Radar.prototype.containPoint = function(point) {
        console.warn('Not implemented.');
        return false;
    };
    Radar.create = function(ecModel, api) {
        var radarList = [];
        ecModel.eachComponent('radar', function(radarModel) {
            var radar = new Radar(radarModel, ecModel, api);
            radarList.push(radar);
            radarModel.coordinateSystem = radar;
        });
        ecModel.eachSeriesByType('radar', function(radarSeries) {
            if (radarSeries.get('coordinateSystem') === 'radar') // Inject coordinate system
            // @ts-ignore
            radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
        });
        return radarList;
    };
    /**
   * Radar dimensions is based on the data
   */ Radar.dimensions = [];
    return Radar;
}();
var $e9f62dd551e160d3$export$2e2bcd8739ae039 = $e9f62dd551e160d3$var$Radar;

});
parcelRegister("fLXNP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7b9a258ee06113c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $6ZMAw = parcelRequire("6ZMAw");
var $b7b9a258ee06113c$var$IndicatorAxis = /** @class */ function(_super) {
    (0, $9nEce.__extends)(IndicatorAxis, _super);
    function IndicatorAxis(dim, scale, radiusExtent) {
        var _this = _super.call(this, dim, scale, radiusExtent) || this;
        _this.type = 'value';
        _this.angle = 0;
        _this.name = '';
        return _this;
    }
    return IndicatorAxis;
}((0, $6ZMAw.default));
var $b7b9a258ee06113c$export$2e2bcd8739ae039 = $b7b9a258ee06113c$var$IndicatorAxis;

});

parcelRegister("5UHoe", function(module, exports) {

$parcel$export(module.exports, "alignScaleTicks", function () { return $44e3d7024f6e58f5$export$c0b3be0e9eb0c2d9; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iCU10 = parcelRequire("iCU10");

var $k1WNO = parcelRequire("k1WNO");

var $9AF98 = parcelRequire("9AF98");


var $b0HC9 = parcelRequire("b0HC9");
function $44e3d7024f6e58f5$export$c0b3be0e9eb0c2d9(scale, axisModel, alignToScale) {
    var _a;
    var intervalScaleProto = (0, $k1WNO.default).prototype;
    // NOTE: There is a precondition for log scale  here:
    // In log scale we store _interval and _extent of exponent value.
    // So if we use the method of InternalScale to set/get these data.
    // It process the exponent value, which is linear and what we want here.
    var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
    var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, {
        expandToNicedExtent: true
    });
    var alignToSplitNumber = alignToTicks.length - 1;
    var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
    var scaleExtent = (0, $9AF98.getScaleExtent)(scale, axisModel);
    var rawExtent = scaleExtent.extent;
    var isMinFixed = scaleExtent.fixMin;
    var isMaxFixed = scaleExtent.fixMax;
    if (scale.type === 'log') rawExtent = (0, $b0HC9.logTransform)(scale.base, rawExtent, true);
    scale.setBreaksFromOption((0, $9AF98.retrieveAxisBreaksOption)(axisModel));
    scale.setExtent(rawExtent[0], rawExtent[1]);
    scale.calcNiceExtent({
        splitNumber: alignToSplitNumber,
        fixMin: isMinFixed,
        fixMax: isMaxFixed
    });
    var extent = intervalScaleProto.getExtent.call(scale);
    // Need to update the rawExtent.
    // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'
    if (isMinFixed) rawExtent[0] = extent[0];
    if (isMaxFixed) rawExtent[1] = extent[1];
    var interval = intervalScaleProto.getInterval.call(scale);
    var min = rawExtent[0];
    var max = rawExtent[1];
    if (isMinFixed && isMaxFixed) // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
    else if (isMinFixed) {
        max = rawExtent[0] + interval * alignToSplitNumber;
        // User set min, expand extent on the other side
        while(max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])){
            interval = (0, $b0HC9.increaseInterval)(interval);
            max = rawExtent[0] + interval * alignToSplitNumber;
        }
    } else if (isMaxFixed) {
        // User set max, expand extent on the other side
        min = rawExtent[1] - interval * alignToSplitNumber;
        while(min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])){
            interval = (0, $b0HC9.increaseInterval)(interval);
            min = rawExtent[1] - interval * alignToSplitNumber;
        }
    } else {
        var nicedSplitNumber = scale.getTicks().length - 1;
        if (nicedSplitNumber > alignToSplitNumber) interval = (0, $b0HC9.increaseInterval)(interval);
        var range = interval * alignToSplitNumber;
        max = Math.ceil(rawExtent[1] / interval) * interval;
        min = (0, $iCU10.round)(max - range);
        // Not change the result that crossing zero.
        if (min < 0 && rawExtent[0] >= 0) {
            min = 0;
            max = (0, $iCU10.round)(range);
        } else if (max > 0 && rawExtent[1] <= 0) {
            max = 0;
            min = -(0, $iCU10.round)(range);
        }
    }
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
    var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval;
    // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.
    intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
    intervalScaleProto.setInterval.call(scale, interval);
    if (t0 || t1) intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
    var ticks;
}

});




parcelRegister("a8yRU", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $7615b2e55ad05847$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6qPXM = parcelRequire("6qPXM");

var $gEPjN = parcelRequire("gEPjN");

var $8sKyA = parcelRequire("8sKyA");

var $ietJK = parcelRequire("ietJK");

var $kc4jZ = parcelRequire("kc4jZ");
function $7615b2e55ad05847$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $6qPXM.default));
    registers.registerSeriesModel((0, $gEPjN.default));
    registers.registerLayout((0, $8sKyA.default));
    registers.registerVisual((0, $ietJK.default));
    registers.registerAction({
        type: 'dragNode',
        event: 'dragnode',
        // here can only use 'update' now, other value is not support in echarts.
        update: 'update'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sankey',
            query: payload
        }, function(seriesModel) {
            seriesModel.setNodePosition(payload.dataIndex, [
                payload.localX,
                payload.localY
            ]);
        });
    });
    registers.registerAction({
        type: 'sankeyRoam',
        event: 'sankeyRoam',
        update: 'none'
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sankey',
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $kc4jZ.updateCenterAndZoomInAction)(coordSys, payload, seriesModel.get('scaleLimit'));
            seriesModel.setCenter(res.center);
            seriesModel.setZoom(res.zoom);
        });
    });
}

});
parcelRegister("6qPXM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4aed7a91ebcd3d1b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $iQonF = parcelRequire("iQonF");
var $ipprj = parcelRequire("ipprj");
var $ftfXE = parcelRequire("ftfXE");parcelRequire("h9U3p");
var $4oDJM = parcelRequire("4oDJM");
var $aH2k0 = parcelRequire("aH2k0");

var $bwPbQ = parcelRequire("bwPbQ");

var $cWIrM = parcelRequire("cWIrM");

var $bysmE = parcelRequire("bysmE");

var $6TSUP = parcelRequire("6TSUP");

var $2N6Uo = parcelRequire("2N6Uo");

var $ic6Qi = parcelRequire("ic6Qi");

var $kc4jZ = parcelRequire("kc4jZ");

var $11tae = parcelRequire("11tae");
var $4aed7a91ebcd3d1b$var$SankeyPathShape = /** @class */ function() {
    function SankeyPathShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.cpx2 = 0;
        this.cpy2 = 0;
        this.extent = 0;
    }
    return SankeyPathShape;
}();
var $4aed7a91ebcd3d1b$var$SankeyPath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SankeyPath, _super);
    function SankeyPath(opts) {
        return _super.call(this, opts) || this;
    }
    SankeyPath.prototype.getDefaultShape = function() {
        return new $4aed7a91ebcd3d1b$var$SankeyPathShape();
    };
    SankeyPath.prototype.buildPath = function(ctx, shape) {
        var extent = shape.extent;
        ctx.moveTo(shape.x1, shape.y1);
        ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
        if (shape.orient === 'vertical') {
            ctx.lineTo(shape.x2 + extent, shape.y2);
            ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
        } else {
            ctx.lineTo(shape.x2, shape.y2 + extent);
            ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
        }
        ctx.closePath();
    };
    SankeyPath.prototype.highlight = function() {
        (0, $bwPbQ.enterEmphasis)(this);
    };
    SankeyPath.prototype.downplay = function() {
        (0, $bwPbQ.leaveEmphasis)(this);
    };
    return SankeyPath;
}($4oDJM.default);
var $4aed7a91ebcd3d1b$var$SankeyView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SankeyView, _super);
    function SankeyView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeyView.type;
        _this._mainGroup = new $iQonF.default();
        _this._focusAdjacencyDisabled = false;
        return _this;
    }
    SankeyView.prototype.init = function(ecModel, api) {
        this._controller = new (0, $ic6Qi.default)(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    };
    SankeyView.prototype.render = function(seriesModel, ecModel, api) {
        var sankeyView = this;
        var graph = seriesModel.getGraph();
        var mainGroup = this._mainGroup;
        var layoutInfo = seriesModel.layoutInfo;
        // view width
        var width = layoutInfo.width;
        // view height
        var height = layoutInfo.height;
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getData('edge');
        var orient = seriesModel.get('orient');
        this._model = seriesModel;
        mainGroup.removeAll();
        mainGroup.x = layoutInfo.x;
        mainGroup.y = layoutInfo.y;
        this._updateViewCoordSys(seriesModel, api);
        $kc4jZ.updateController(seriesModel, api, mainGroup, this._controller, this._controllerHost, null);
        // generate a bezire Curve for each edge
        graph.eachEdge(function(edge) {
            var curve = new $4aed7a91ebcd3d1b$var$SankeyPath();
            var ecData = (0, $6TSUP.getECData)(curve);
            ecData.dataIndex = edge.dataIndex;
            ecData.seriesIndex = seriesModel.seriesIndex;
            ecData.dataType = 'edge';
            var edgeModel = edge.getModel();
            var lineStyleModel = edgeModel.getModel('lineStyle');
            var curvature = lineStyleModel.get('curveness');
            var n1Layout = edge.node1.getLayout();
            var node1Model = edge.node1.getModel();
            var dragX1 = node1Model.get('localX');
            var dragY1 = node1Model.get('localY');
            var n2Layout = edge.node2.getLayout();
            var node2Model = edge.node2.getModel();
            var dragX2 = node2Model.get('localX');
            var dragY2 = node2Model.get('localY');
            var edgeLayout = edge.getLayout();
            var x1;
            var y1;
            var x2;
            var y2;
            var cpx1;
            var cpy1;
            var cpx2;
            var cpy2;
            curve.shape.extent = Math.max(1, edgeLayout.dy);
            curve.shape.orient = orient;
            if (orient === 'vertical') {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
                x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
                y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
                cpx1 = x1;
                cpy1 = y1 * (1 - curvature) + y2 * curvature;
                cpx2 = x2;
                cpy2 = y1 * curvature + y2 * (1 - curvature);
            } else {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
                x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
                y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
                cpx1 = x1 * (1 - curvature) + x2 * curvature;
                cpy1 = y1;
                cpx2 = x1 * curvature + x2 * (1 - curvature);
                cpy2 = y2;
            }
            curve.setShape({
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                cpx1: cpx1,
                cpy1: cpy1,
                cpx2: cpx2,
                cpy2: cpy2
            });
            curve.useStyle(lineStyleModel.getItemStyle());
            // Special color, use source node color or target node color
            $4aed7a91ebcd3d1b$var$applyCurveStyle(curve.style, orient, edge);
            var defaultEdgeLabelText = "" + edgeModel.get('value');
            var edgeLabelStateModels = (0, $bysmE.getLabelStatesModels)(edgeModel, 'edgeLabel');
            (0, $bysmE.setLabelStyle)(curve, edgeLabelStateModels, {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, 'edge', labelDimIndex, // ensure edgeLabel formatter is provided
                        // to prevent the inheritance from `label.formatter` of the series
                        (0, $2N6Uo.retrieve3)(formatter, edgeLabelStateModels.normal && edgeLabelStateModels.normal.get('formatter'), defaultEdgeLabelText), extendParams);
                    }
                },
                labelDataIndex: edge.dataIndex,
                defaultText: defaultEdgeLabelText
            });
            curve.setTextConfig({
                position: 'inside'
            });
            var emphasisModel = edgeModel.getModel('emphasis');
            (0, $bwPbQ.setStatesStylesFromModel)(curve, edgeModel, 'lineStyle', function(model) {
                var style = model.getItemStyle();
                $4aed7a91ebcd3d1b$var$applyCurveStyle(style, orient, edge);
                return style;
            });
            mainGroup.add(curve);
            edgeData.setItemGraphicEl(edge.dataIndex, curve);
            var focus = emphasisModel.get('focus');
            (0, $bwPbQ.toggleHoverEmphasis)(curve, focus === 'adjacency' ? edge.getAdjacentDataIndices() : focus === 'trajectory' ? edge.getTrajectoryDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        // Generate a rect for each node
        graph.eachNode(function(node) {
            var layout = node.getLayout();
            var itemModel = node.getModel();
            var dragX = itemModel.get('localX');
            var dragY = itemModel.get('localY');
            var emphasisModel = itemModel.getModel('emphasis');
            var borderRadius = itemModel.get([
                'itemStyle',
                'borderRadius'
            ]) || 0;
            var rect = new $aH2k0.default({
                shape: {
                    x: dragX != null ? dragX * width : layout.x,
                    y: dragY != null ? dragY * height : layout.y,
                    width: layout.dx,
                    height: layout.dy,
                    r: borderRadius
                },
                style: itemModel.getModel('itemStyle').getItemStyle(),
                z2: 10
            });
            (0, $bysmE.setLabelStyle)(rect, (0, $bysmE.getLabelStatesModels)(itemModel), {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, 'node');
                    }
                },
                labelDataIndex: node.dataIndex,
                defaultText: node.id
            });
            rect.disableLabelAnimation = true;
            rect.setStyle('fill', node.getVisual('color'));
            rect.setStyle('decal', node.getVisual('style').decal);
            (0, $bwPbQ.setStatesStylesFromModel)(rect, itemModel);
            mainGroup.add(rect);
            nodeData.setItemGraphicEl(node.dataIndex, rect);
            (0, $6TSUP.getECData)(rect).dataType = 'node';
            var focus = emphasisModel.get('focus');
            (0, $bwPbQ.toggleHoverEmphasis)(rect, focus === 'adjacency' ? node.getAdjacentDataIndices() : focus === 'trajectory' ? node.getTrajectoryDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        nodeData.eachItemGraphicEl(function(el, dataIndex) {
            var itemModel = nodeData.getItemModel(dataIndex);
            if (itemModel.get('draggable')) {
                el.drift = function(dx, dy) {
                    sankeyView._focusAdjacencyDisabled = true;
                    this.shape.x += dx;
                    this.shape.y += dy;
                    this.dirty();
                    api.dispatchAction({
                        type: 'dragNode',
                        seriesId: seriesModel.id,
                        dataIndex: nodeData.getRawIndex(dataIndex),
                        localX: this.shape.x / width,
                        localY: this.shape.y / height
                    });
                };
                el.ondragend = function() {
                    sankeyView._focusAdjacencyDisabled = false;
                };
                el.draggable = true;
                el.cursor = 'move';
            }
        });
        if (!this._data && seriesModel.isAnimationEnabled()) mainGroup.setClipPath($4aed7a91ebcd3d1b$var$createGridClipShape(mainGroup.getBoundingRect(), seriesModel, function() {
            mainGroup.removeClipPath();
        }));
        this._data = seriesModel.getData();
    };
    SankeyView.prototype.dispose = function() {
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    SankeyView.prototype._updateViewCoordSys = function(seriesModel, api) {
        var layoutInfo = seriesModel.layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var viewCoordSys = seriesModel.coordinateSystem = new (0, $11tae.default)(null, {
            api: api,
            ecModel: seriesModel.ecModel
        });
        viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
        viewCoordSys.setBoundingRect(0, 0, width, height);
        viewCoordSys.setCenter(seriesModel.get('center'));
        viewCoordSys.setZoom(seriesModel.get('zoom'));
        this._controllerHost.target.attr({
            x: viewCoordSys.x,
            y: viewCoordSys.y,
            scaleX: viewCoordSys.scaleX,
            scaleY: viewCoordSys.scaleY
        });
    };
    SankeyView.type = 'sankey';
    return SankeyView;
}((0, $cWIrM.default));
/**
 * Special color, use source node color or target node color
 * @param curveProps curve's style to parse
 * @param orient direction
 * @param edge current curve data
 */ function $4aed7a91ebcd3d1b$var$applyCurveStyle(curveProps, orient, edge) {
    switch(curveProps.fill){
        case 'source':
            curveProps.fill = edge.node1.getVisual('color');
            curveProps.decal = edge.node1.getVisual('style').decal;
            break;
        case 'target':
            curveProps.fill = edge.node2.getVisual('color');
            curveProps.decal = edge.node2.getVisual('style').decal;
            break;
        case 'gradient':
            var sourceColor = edge.node1.getVisual('color');
            var targetColor = edge.node2.getVisual('color');
            if ((0, $2N6Uo.isString)(sourceColor) && (0, $2N6Uo.isString)(targetColor)) curveProps.fill = new $ftfXE.default(0, 0, +(orient === 'horizontal'), +(orient === 'vertical'), [
                {
                    color: sourceColor,
                    offset: 0
                },
                {
                    color: targetColor,
                    offset: 1
                }
            ]);
    }
}
// Add animation to the view
function $4aed7a91ebcd3d1b$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $aH2k0.default({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $ipprj.initProps(rectEl, {
        shape: {
            width: rect.width + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $4aed7a91ebcd3d1b$export$2e2bcd8739ae039 = $4aed7a91ebcd3d1b$var$SankeyView;

});

parcelRegister("gEPjN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2083088e02cddcc$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $elq2d = parcelRequire("elq2d");

var $b8YKU = parcelRequire("b8YKU");

var $5KdhI = parcelRequire("5KdhI");

var $6aXXD = parcelRequire("6aXXD");
var $c2083088e02cddcc$var$SankeySeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SankeySeriesModel, _super);
    function SankeySeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeySeriesModel.type;
        return _this;
    }
    /**
   * Init a graph data structure from data in option series
   */ SankeySeriesModel.prototype.getInitialData = function(option, ecModel) {
        var links = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var levels = option.levels || [];
        this.levelModels = [];
        var levelModels = this.levelModels;
        for(var i = 0; i < levels.length; i++)if (levels[i].depth != null && levels[i].depth >= 0) levelModels[levels[i].depth] = new (0, $b8YKU.default)(levels[i], this, ecModel);
        var graph = (0, $elq2d.default)(nodes, links, this, true, beforeLink);
        return graph.data;
        function beforeLink(nodeData, edgeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var seriesModel = model.parentModel;
                var layout = seriesModel.getData().getItemLayout(idx);
                if (layout) {
                    var nodeDepth = layout.depth;
                    var levelModel = seriesModel.levelModels[nodeDepth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
            edgeData.wrapMethod('getItemModel', function(model, idx) {
                var seriesModel = model.parentModel;
                var edge = seriesModel.getGraph().getEdgeByIndex(idx);
                var layout = edge.node1.getLayout();
                if (layout) {
                    var depth = layout.depth;
                    var levelModel = seriesModel.levelModels[depth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
        }
    };
    SankeySeriesModel.prototype.setNodePosition = function(dataIndex, localPosition) {
        var nodes = this.option.data || this.option.nodes;
        var dataItem = nodes[dataIndex];
        dataItem.localX = localPosition[0];
        dataItem.localY = localPosition[1];
    };
    SankeySeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    SankeySeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    /**
   * Return the graphic data structure
   *
   * @return graphic data structure
   */ SankeySeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    /**
   * Get edge data of graphic data structure
   *
   * @return data structure of list
   */ SankeySeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    SankeySeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        function noValue(val) {
            return isNaN(val) || val == null;
        }
        // dataType === 'node' or empty do not show tooltip by default
        if (dataType === 'edge') {
            var params = this.getDataParams(dataIndex, dataType);
            var rawDataOpt = params.data;
            var edgeValue = params.value;
            var edgeName = rawDataOpt.source + ' -- ' + rawDataOpt.target;
            return (0, $5KdhI.createTooltipMarkup)('nameValue', {
                name: edgeName,
                value: edgeValue,
                noValue: noValue(edgeValue)
            });
        } else {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var value = node.getLayout().value;
            var name_1 = this.getDataParams(dataIndex, dataType).data.name;
            return (0, $5KdhI.createTooltipMarkup)('nameValue', {
                name: name_1 != null ? name_1 + '' : null,
                value: value,
                noValue: noValue(value)
            });
        }
    };
    SankeySeriesModel.prototype.optionUpdated = function() {};
    // Override Series.getDataParams()
    SankeySeriesModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        if (params.value == null && dataType === 'node') {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var nodeValue = node.getLayout().value;
            params.value = nodeValue;
        }
        return params;
    };
    SankeySeriesModel.type = 'series.sankey';
    SankeySeriesModel.layoutMode = 'box';
    SankeySeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // `coordinateSystem` can be declared as 'matrix', 'calendar',
        //  which provides box layout container.
        coordinateSystemUsage: 'box',
        left: '5%',
        top: '5%',
        right: '20%',
        bottom: '5%',
        orient: 'horizontal',
        nodeWidth: 20,
        nodeGap: 8,
        draggable: true,
        layoutIterations: 32,
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        roamTrigger: 'global',
        center: null,
        zoom: 1,
        label: {
            show: true,
            position: 'right',
            fontSize: 12
        },
        edgeLabel: {
            show: false,
            fontSize: 12
        },
        levels: [],
        nodeAlign: 'justify',
        lineStyle: {
            color: (0, $6aXXD.default).color.neutral50,
            opacity: 0.2,
            curveness: 0.5
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                opacity: 0.5
            }
        },
        select: {
            itemStyle: {
                borderColor: (0, $6aXXD.default).color.primary
            }
        },
        animationEasing: 'linear',
        animationDuration: 1000
    };
    return SankeySeriesModel;
}((0, $49X8G.default));
var $c2083088e02cddcc$export$2e2bcd8739ae039 = $c2083088e02cddcc$var$SankeySeriesModel;

});

parcelRegister("8sKyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62950d75264d3a5e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $a35Wn = parcelRequire("a35Wn");
function $62950d75264d3a5e$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('sankey', function(seriesModel) {
        var nodeWidth = seriesModel.get('nodeWidth');
        var nodeGap = seriesModel.get('nodeGap');
        var refContainer = (0, $a35Wn.createBoxLayoutReference)(seriesModel, api).refContainer;
        var layoutInfo = (0, $a35Wn.getLayoutRect)(seriesModel.getBoxLayoutParams(), refContainer);
        seriesModel.layoutInfo = layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        $62950d75264d3a5e$var$computeNodeValues(nodes);
        var filteredNodes = $2N6Uo.filter(nodes, function(node) {
            return node.getLayout().value === 0;
        });
        var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
        var orient = seriesModel.get('orient');
        var nodeAlign = seriesModel.get('nodeAlign');
        $62950d75264d3a5e$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
    });
}
function $62950d75264d3a5e$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
    $62950d75264d3a5e$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
    $62950d75264d3a5e$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
    $62950d75264d3a5e$var$computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 */ function $62950d75264d3a5e$var$computeNodeValues(nodes) {
    $2N6Uo.each(nodes, function(node) {
        var value1 = $62950d75264d3a5e$var$sum(node.outEdges, $62950d75264d3a5e$var$getEdgeValue);
        var value2 = $62950d75264d3a5e$var$sum(node.inEdges, $62950d75264d3a5e$var$getEdgeValue);
        var nodeRawValue = node.getValue() || 0;
        var value = Math.max(value1, value2, nodeRawValue);
        node.setLayout({
            value: value
        }, true);
    });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 */ function $62950d75264d3a5e$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
    // Used to mark whether the edge is deleted. if it is deleted,
    // the value is 0, otherwise it is 1.
    var remainEdges = [];
    // Storage each node's indegree.
    var indegreeArr = [];
    // Used to storage the node with indegree is equal to 0.
    var zeroIndegrees = [];
    var nextTargetNode = [];
    var x = 0;
    // let kx = 0;
    for(var i = 0; i < edges.length; i++)remainEdges[i] = 1;
    for(var i = 0; i < nodes.length; i++){
        indegreeArr[i] = nodes[i].inEdges.length;
        if (indegreeArr[i] === 0) zeroIndegrees.push(nodes[i]);
    }
    var maxNodeDepth = -1;
    // Traversing nodes using topological sorting to calculate the
    // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
    // position of the nodes.
    while(zeroIndegrees.length){
        for(var idx = 0; idx < zeroIndegrees.length; idx++){
            var node = zeroIndegrees[idx];
            var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
            var isItemDepth = item.depth != null && item.depth >= 0;
            if (isItemDepth && item.depth > maxNodeDepth) maxNodeDepth = item.depth;
            node.setLayout({
                depth: isItemDepth ? item.depth : x
            }, true);
            orient === 'vertical' ? node.setLayout({
                dy: nodeWidth
            }, true) : node.setLayout({
                dx: nodeWidth
            }, true);
            for(var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++){
                var edge = node.outEdges[edgeIdx];
                var indexEdge = edges.indexOf(edge);
                remainEdges[indexEdge] = 0;
                var targetNode = edge.node2;
                var nodeIndex = nodes.indexOf(targetNode);
                if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) nextTargetNode.push(targetNode);
            }
        }
        ++x;
        zeroIndegrees = nextTargetNode;
        nextTargetNode = [];
    }
    for(var i = 0; i < remainEdges.length; i++){
        if (remainEdges[i] === 1) throw new Error('Sankey is a DAG, the original data has cycle!');
    }
    var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
    if (nodeAlign && nodeAlign !== 'left') $62950d75264d3a5e$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
    var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
    $62950d75264d3a5e$var$scaleNodeBreadths(nodes, kx, orient);
}
function $62950d75264d3a5e$var$isNodeDepth(node) {
    var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
    return item.depth != null && item.depth >= 0;
}
function $62950d75264d3a5e$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
    if (nodeAlign === 'right') {
        var nextSourceNode = [];
        var remainNodes = nodes;
        var nodeHeight = 0;
        while(remainNodes.length){
            for(var i = 0; i < remainNodes.length; i++){
                var node = remainNodes[i];
                node.setLayout({
                    skNodeHeight: nodeHeight
                }, true);
                for(var j = 0; j < node.inEdges.length; j++){
                    var edge = node.inEdges[j];
                    if (nextSourceNode.indexOf(edge.node1) < 0) nextSourceNode.push(edge.node1);
                }
            }
            remainNodes = nextSourceNode;
            nextSourceNode = [];
            ++nodeHeight;
        }
        $2N6Uo.each(nodes, function(node) {
            if (!$62950d75264d3a5e$var$isNodeDepth(node)) node.setLayout({
                depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
            }, true);
        });
    } else if (nodeAlign === 'justify') $62950d75264d3a5e$var$moveSinksRight(nodes, maxDepth);
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param nodes.  node of sankey view.
 * @param maxDepth.  use to assign to node without outEdges as x-position.
 */ function $62950d75264d3a5e$var$moveSinksRight(nodes, maxDepth) {
    $2N6Uo.each(nodes, function(node) {
        if (!$62950d75264d3a5e$var$isNodeDepth(node) && !node.outEdges.length) node.setLayout({
            depth: maxDepth
        }, true);
    });
}
/**
 * Scale node x-position to the width
 *
 * @param nodes  node of sankey view
 * @param kx   multiple used to scale nodes
 */ function $62950d75264d3a5e$var$scaleNodeBreadths(nodes, kx, orient) {
    $2N6Uo.each(nodes, function(node) {
        var nodeDepth = node.getLayout().depth * kx;
        orient === 'vertical' ? node.setLayout({
            y: nodeDepth
        }, true) : node.setLayout({
            x: nodeDepth
        }, true);
    });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param nodes  node of sankey view
 * @param edges  edge of sankey view
 * @param height  the whole height of the area to draw the view
 * @param nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param iterations  the number of iterations for the algorithm
 */ function $62950d75264d3a5e$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
    var nodesByBreadth = $62950d75264d3a5e$var$prepareNodesByBreadth(nodes, orient);
    $62950d75264d3a5e$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
    $62950d75264d3a5e$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    for(var alpha = 1; iterations > 0; iterations--){
        // 0.99 is a experience parameter, ensure that each iterations of
        // changes as small as possible.
        alpha *= 0.99;
        $62950d75264d3a5e$var$relaxRightToLeft(nodesByBreadth, alpha, orient);
        $62950d75264d3a5e$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
        $62950d75264d3a5e$var$relaxLeftToRight(nodesByBreadth, alpha, orient);
        $62950d75264d3a5e$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    }
}
function $62950d75264d3a5e$var$prepareNodesByBreadth(nodes, orient) {
    var nodesByBreadth = [];
    var keyAttr = orient === 'vertical' ? 'y' : 'x';
    var groupResult = (0, $bx3T8.groupData)(nodes, function(node) {
        return node.getLayout()[keyAttr];
    });
    groupResult.keys.sort(function(a, b) {
        return a - b;
    });
    $2N6Uo.each(groupResult.keys, function(key) {
        nodesByBreadth.push(groupResult.buckets.get(key));
    });
    return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 */ function $62950d75264d3a5e$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
    var minKy = Infinity;
    $2N6Uo.each(nodesByBreadth, function(nodes) {
        var n = nodes.length;
        var sum = 0;
        $2N6Uo.each(nodes, function(node) {
            sum += node.getLayout().value;
        });
        var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
        if (ky < minKy) minKy = ky;
    });
    $2N6Uo.each(nodesByBreadth, function(nodes) {
        $2N6Uo.each(nodes, function(node, i) {
            var nodeDy = node.getLayout().value * minKy;
            if (orient === 'vertical') {
                node.setLayout({
                    x: i
                }, true);
                node.setLayout({
                    dx: nodeDy
                }, true);
            } else {
                node.setLayout({
                    y: i
                }, true);
                node.setLayout({
                    dy: nodeDy
                }, true);
            }
        });
    });
    $2N6Uo.each(edges, function(edge) {
        var edgeDy = +edge.getValue() * minKy;
        edge.setLayout({
            dy: edgeDy
        }, true);
    });
}
/**
 * Resolve the collision of initialized depth (y-position)
 */ function $62950d75264d3a5e$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
    var keyAttr = orient === 'vertical' ? 'x' : 'y';
    $2N6Uo.each(nodesByBreadth, function(nodes) {
        nodes.sort(function(a, b) {
            return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
        });
        var nodeX;
        var node;
        var dy;
        var y0 = 0;
        var n = nodes.length;
        var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';
        for(var i = 0; i < n; i++){
            node = nodes[i];
            dy = y0 - node.getLayout()[keyAttr];
            if (dy > 0) {
                nodeX = node.getLayout()[keyAttr] + dy;
                orient === 'vertical' ? node.setLayout({
                    x: nodeX
                }, true) : node.setLayout({
                    y: nodeX
                }, true);
            }
            y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
        }
        var viewWidth = orient === 'vertical' ? width : height;
        // If the bottommost node goes outside the bounds, push it back up
        dy = y0 - nodeGap - viewWidth;
        if (dy > 0) {
            nodeX = node.getLayout()[keyAttr] - dy;
            orient === 'vertical' ? node.setLayout({
                x: nodeX
            }, true) : node.setLayout({
                y: nodeX
            }, true);
            y0 = nodeX;
            for(var i = n - 2; i >= 0; --i){
                node = nodes[i];
                dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
                if (dy > 0) {
                    nodeX = node.getLayout()[keyAttr] - dy;
                    orient === 'vertical' ? node.setLayout({
                        x: nodeX
                    }, true) : node.setLayout({
                        y: nodeX
                    }, true);
                }
                y0 = node.getLayout()[keyAttr];
            }
        }
    });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 * @param nodesByBreadth
 * @param alpha  parameter used to adjust the nodes y-position
 */ function $62950d75264d3a5e$var$relaxRightToLeft(nodesByBreadth, alpha, orient) {
    $2N6Uo.each(nodesByBreadth.slice().reverse(), function(nodes) {
        $2N6Uo.each(nodes, function(node) {
            if (node.outEdges.length) {
                var y = $62950d75264d3a5e$var$sum(node.outEdges, $62950d75264d3a5e$var$weightedTarget, orient) / $62950d75264d3a5e$var$sum(node.outEdges, $62950d75264d3a5e$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.outEdges.length;
                    y = len ? $62950d75264d3a5e$var$sum(node.outEdges, $62950d75264d3a5e$var$centerTarget, orient) / len : 0;
                }
                if (orient === 'vertical') {
                    var nodeX = node.getLayout().x + (y - $62950d75264d3a5e$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $62950d75264d3a5e$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
function $62950d75264d3a5e$var$weightedTarget(edge, orient) {
    return $62950d75264d3a5e$var$center(edge.node2, orient) * edge.getValue();
}
function $62950d75264d3a5e$var$centerTarget(edge, orient) {
    return $62950d75264d3a5e$var$center(edge.node2, orient);
}
function $62950d75264d3a5e$var$weightedSource(edge, orient) {
    return $62950d75264d3a5e$var$center(edge.node1, orient) * edge.getValue();
}
function $62950d75264d3a5e$var$centerSource(edge, orient) {
    return $62950d75264d3a5e$var$center(edge.node1, orient);
}
function $62950d75264d3a5e$var$center(node, orient) {
    return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}
function $62950d75264d3a5e$var$getEdgeValue(edge) {
    return edge.getValue();
}
function $62950d75264d3a5e$var$sum(array, cb, orient) {
    var sum = 0;
    var len = array.length;
    var i = -1;
    while(++i < len){
        var value = +cb(array[i], orient);
        if (!isNaN(value)) sum += value;
    }
    return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 */ function $62950d75264d3a5e$var$relaxLeftToRight(nodesByBreadth, alpha, orient) {
    $2N6Uo.each(nodesByBreadth, function(nodes) {
        $2N6Uo.each(nodes, function(node) {
            if (node.inEdges.length) {
                var y = $62950d75264d3a5e$var$sum(node.inEdges, $62950d75264d3a5e$var$weightedSource, orient) / $62950d75264d3a5e$var$sum(node.inEdges, $62950d75264d3a5e$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.inEdges.length;
                    y = len ? $62950d75264d3a5e$var$sum(node.inEdges, $62950d75264d3a5e$var$centerSource, orient) / len : 0;
                }
                if (orient === 'vertical') {
                    var nodeX = node.getLayout().x + (y - $62950d75264d3a5e$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $62950d75264d3a5e$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
/**
 * Compute the depth(y-position) of each edge
 */ function $62950d75264d3a5e$var$computeEdgeDepths(nodes, orient) {
    var keyAttr = orient === 'vertical' ? 'x' : 'y';
    $2N6Uo.each(nodes, function(node) {
        node.outEdges.sort(function(a, b) {
            return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
        });
        node.inEdges.sort(function(a, b) {
            return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
        });
    });
    $2N6Uo.each(nodes, function(node) {
        var sy = 0;
        var ty = 0;
        $2N6Uo.each(node.outEdges, function(edge) {
            edge.setLayout({
                sy: sy
            }, true);
            sy += edge.getLayout().dy;
        });
        $2N6Uo.each(node.inEdges, function(edge) {
            edge.setLayout({
                ty: ty
            }, true);
            ty += edge.getLayout().dy;
        });
    });
}

});

parcelRegister("ietJK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d46099ef40030bed$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $dzLre = parcelRequire("dzLre");
function $d46099ef40030bed$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('sankey', function(seriesModel) {
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        if (nodes.length) {
            var minValue_1 = Infinity;
            var maxValue_1 = -Infinity;
            $2N6Uo.each(nodes, function(node) {
                var nodeValue = node.getLayout().value;
                if (nodeValue < minValue_1) minValue_1 = nodeValue;
                if (nodeValue > maxValue_1) maxValue_1 = nodeValue;
            });
            $2N6Uo.each(nodes, function(node) {
                var mapping = new (0, $dzLre.default)({
                    type: 'color',
                    mappingMethod: 'linear',
                    dataExtent: [
                        minValue_1,
                        maxValue_1
                    ],
                    visual: seriesModel.get('color')
                });
                var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
                var customColor = node.getModel().get([
                    'itemStyle',
                    'color'
                ]);
                if (customColor != null) {
                    node.setVisual('color', customColor);
                    node.setVisual('style', {
                        fill: customColor
                    });
                } else {
                    node.setVisual('color', mapValueToColor);
                    node.setVisual('style', {
                        fill: mapValueToColor
                    });
                }
            });
        }
        if (edges.length) $2N6Uo.each(edges, function(edge) {
            var edgeStyle = edge.getModel().get('lineStyle');
            edge.setVisual('style', edgeStyle);
        });
    });
}

});
parcelRegister("dzLre", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e23577a7772f81f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $3UxDF = parcelRequire("3UxDF");

var $iCU10 = parcelRequire("iCU10");

var $9e23577a7772f81f$var$each = $2N6Uo.each;
var $9e23577a7772f81f$var$isObject = $2N6Uo.isObject;
var $9e23577a7772f81f$var$CATEGORY_DEFAULT_VISUAL_INDEX = -1;
var $9e23577a7772f81f$var$VisualMapping = /** @class */ function() {
    function VisualMapping(option) {
        var mappingMethod = option.mappingMethod;
        var visualType = option.type;
        var thisOption = this.option = $2N6Uo.clone(option);
        this.type = visualType;
        this.mappingMethod = mappingMethod;
        this._normalizeData = $9e23577a7772f81f$var$normalizers[mappingMethod];
        var visualHandler = VisualMapping.visualHandlers[visualType];
        this.applyVisual = visualHandler.applyVisual;
        this.getColorMapper = visualHandler.getColorMapper;
        this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];
        if (mappingMethod === 'piecewise') {
            $9e23577a7772f81f$var$normalizeVisualRange(thisOption);
            $9e23577a7772f81f$var$preprocessForPiecewise(thisOption);
        } else if (mappingMethod === 'category') thisOption.categories ? $9e23577a7772f81f$var$preprocessForSpecifiedCategory(thisOption) : $9e23577a7772f81f$var$normalizeVisualRange(thisOption, true);
        else {
            // mappingMethod === 'linear' or 'fixed'
            $2N6Uo.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
            $9e23577a7772f81f$var$normalizeVisualRange(thisOption);
        }
    }
    VisualMapping.prototype.mapValueToVisual = function(value) {
        var normalized = this._normalizeData(value);
        return this._normalizedToVisual(normalized, value);
    };
    VisualMapping.prototype.getNormalizer = function() {
        return $2N6Uo.bind(this._normalizeData, this);
    };
    /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */ VisualMapping.listVisualTypes = function() {
        return $2N6Uo.keys(VisualMapping.visualHandlers);
    };
    // /**
    //  * @public
    //  */
    // static addVisualHandler(name, handler) {
    //     visualHandlers[name] = handler;
    // }
    /**
   * @public
   */ VisualMapping.isValidType = function(visualType) {
        return VisualMapping.visualHandlers.hasOwnProperty(visualType);
    };
    /**
   * Convenient method.
   * Visual can be Object or Array or primary type.
   */ VisualMapping.eachVisual = function(visual, callback, context) {
        if ($2N6Uo.isObject(visual)) $2N6Uo.each(visual, callback, context);
        else callback.call(context, visual);
    };
    VisualMapping.mapVisual = function(visual, callback, context) {
        var isPrimary;
        var newVisual = $2N6Uo.isArray(visual) ? [] : $2N6Uo.isObject(visual) ? {} : (isPrimary = true, null);
        VisualMapping.eachVisual(visual, function(v, key) {
            var newVal = callback.call(context, v, key);
            isPrimary ? newVisual = newVal : newVisual[key] = newVal;
        });
        return newVisual;
    };
    /**
   * Retrieve visual properties from given object.
   */ VisualMapping.retrieveVisuals = function(obj) {
        var ret = {};
        var hasVisual;
        obj && $9e23577a7772f81f$var$each(VisualMapping.visualHandlers, function(h, visualType) {
            if (obj.hasOwnProperty(visualType)) {
                ret[visualType] = obj[visualType];
                hasVisual = true;
            }
        });
        return hasVisual ? ret : null;
    };
    /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */ VisualMapping.prepareVisualTypes = function(visualTypes) {
        if ($2N6Uo.isArray(visualTypes)) visualTypes = visualTypes.slice();
        else if ($9e23577a7772f81f$var$isObject(visualTypes)) {
            var types_1 = [];
            $9e23577a7772f81f$var$each(visualTypes, function(item, type) {
                types_1.push(type);
            });
            visualTypes = types_1;
        } else return [];
        visualTypes.sort(function(type1, type2) {
            // color should be front of colorSaturation, colorAlpha, ...
            // symbol and symbolSize do not matter.
            return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
        });
        return visualTypes;
    };
    /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */ VisualMapping.dependsOn = function(visualType1, visualType2) {
        return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
    };
    /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */ VisualMapping.findPieceIndex = function(value, pieceList, findClosestWhenOutside) {
        var possibleI;
        var abs = Infinity;
        // value has the higher priority.
        for(var i = 0, len = pieceList.length; i < len; i++){
            var pieceValue = pieceList[i].value;
            if (pieceValue != null) {
                if (pieceValue === value || $2N6Uo.isString(pieceValue) && pieceValue === value + '') return i;
                findClosestWhenOutside && updatePossible(pieceValue, i);
            }
        }
        for(var i = 0, len = pieceList.length; i < len; i++){
            var piece = pieceList[i];
            var interval = piece.interval;
            var close_1 = piece.close;
            if (interval) {
                if (interval[0] === -Infinity) {
                    if ($9e23577a7772f81f$var$littleThan(close_1[1], value, interval[1])) return i;
                } else if (interval[1] === Infinity) {
                    if ($9e23577a7772f81f$var$littleThan(close_1[0], interval[0], value)) return i;
                } else if ($9e23577a7772f81f$var$littleThan(close_1[0], interval[0], value) && $9e23577a7772f81f$var$littleThan(close_1[1], value, interval[1])) return i;
                findClosestWhenOutside && updatePossible(interval[0], i);
                findClosestWhenOutside && updatePossible(interval[1], i);
            }
        }
        if (findClosestWhenOutside) return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
        function updatePossible(val, index) {
            var newAbs = Math.abs(val - value);
            if (newAbs < abs) {
                abs = newAbs;
                possibleI = index;
            }
        }
    };
    VisualMapping.visualHandlers = {
        color: {
            applyVisual: $9e23577a7772f81f$var$makeApplyVisual('color'),
            getColorMapper: function() {
                var thisOption = this.option;
                return $2N6Uo.bind(thisOption.mappingMethod === 'category' ? function(value, isNormalized) {
                    !isNormalized && (value = this._normalizeData(value));
                    return $9e23577a7772f81f$var$doMapCategory.call(this, value);
                } : function(value, isNormalized, out) {
                    // If output rgb array
                    // which will be much faster and useful in pixel manipulation
                    var returnRGBArray = !!out;
                    !isNormalized && (value = this._normalizeData(value));
                    out = $3UxDF.fastLerp(value, thisOption.parsedVisual, out);
                    return returnRGBArray ? out : $3UxDF.stringify(out, 'rgba');
                }, this);
            },
            _normalizedToVisual: {
                linear: function(normalized) {
                    return $3UxDF.stringify($3UxDF.fastLerp(normalized, this.option.parsedVisual), 'rgba');
                },
                category: $9e23577a7772f81f$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $9e23577a7772f81f$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $3UxDF.stringify($3UxDF.fastLerp(normalized, this.option.parsedVisual), 'rgba');
                    return result;
                },
                fixed: $9e23577a7772f81f$var$doMapFixed
            }
        },
        colorHue: $9e23577a7772f81f$var$makePartialColorVisualHandler(function(color, value) {
            return $3UxDF.modifyHSL(color, value);
        }),
        colorSaturation: $9e23577a7772f81f$var$makePartialColorVisualHandler(function(color, value) {
            return $3UxDF.modifyHSL(color, null, value);
        }),
        colorLightness: $9e23577a7772f81f$var$makePartialColorVisualHandler(function(color, value) {
            return $3UxDF.modifyHSL(color, null, null, value);
        }),
        colorAlpha: $9e23577a7772f81f$var$makePartialColorVisualHandler(function(color, value) {
            return $3UxDF.modifyAlpha(color, value);
        }),
        decal: {
            applyVisual: $9e23577a7772f81f$var$makeApplyVisual('decal'),
            _normalizedToVisual: {
                linear: null,
                category: $9e23577a7772f81f$var$doMapCategory,
                piecewise: null,
                fixed: null
            }
        },
        opacity: {
            applyVisual: $9e23577a7772f81f$var$makeApplyVisual('opacity'),
            _normalizedToVisual: $9e23577a7772f81f$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        },
        liftZ: {
            applyVisual: $9e23577a7772f81f$var$makeApplyVisual('liftZ'),
            _normalizedToVisual: {
                linear: $9e23577a7772f81f$var$doMapFixed,
                category: $9e23577a7772f81f$var$doMapFixed,
                piecewise: $9e23577a7772f81f$var$doMapFixed,
                fixed: $9e23577a7772f81f$var$doMapFixed
            }
        },
        symbol: {
            applyVisual: function(value, getter, setter) {
                var symbolCfg = this.mapValueToVisual(value);
                setter('symbol', symbolCfg);
            },
            _normalizedToVisual: {
                linear: $9e23577a7772f81f$var$doMapToArray,
                category: $9e23577a7772f81f$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $9e23577a7772f81f$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $9e23577a7772f81f$var$doMapToArray.call(this, normalized);
                    return result;
                },
                fixed: $9e23577a7772f81f$var$doMapFixed
            }
        },
        symbolSize: {
            applyVisual: $9e23577a7772f81f$var$makeApplyVisual('symbolSize'),
            _normalizedToVisual: $9e23577a7772f81f$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        }
    };
    return VisualMapping;
}();
function $9e23577a7772f81f$var$preprocessForPiecewise(thisOption) {
    var pieceList = thisOption.pieceList;
    thisOption.hasSpecialVisual = false;
    $2N6Uo.each(pieceList, function(piece, index) {
        piece.originIndex = index;
        // piece.visual is "result visual value" but not
        // a visual range, so it does not need to be normalized.
        if (piece.visual != null) thisOption.hasSpecialVisual = true;
    });
}
function $9e23577a7772f81f$var$preprocessForSpecifiedCategory(thisOption) {
    // Hash categories.
    var categories = thisOption.categories;
    var categoryMap = thisOption.categoryMap = {};
    var visual = thisOption.visual;
    $9e23577a7772f81f$var$each(categories, function(cate, index) {
        categoryMap[cate] = index;
    });
    // Process visual map input.
    if (!$2N6Uo.isArray(visual)) {
        var visualArr_1 = [];
        if ($2N6Uo.isObject(visual)) $9e23577a7772f81f$var$each(visual, function(v, cate) {
            var index = categoryMap[cate];
            visualArr_1[index != null ? index : $9e23577a7772f81f$var$CATEGORY_DEFAULT_VISUAL_INDEX] = v;
        });
        else // Is primary type, represents default visual.
        visualArr_1[$9e23577a7772f81f$var$CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
        visual = $9e23577a7772f81f$var$setVisualToOption(thisOption, visualArr_1);
    }
    // Remove categories that has no visual,
    // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
    for(var i = categories.length - 1; i >= 0; i--)if (visual[i] == null) {
        delete categoryMap[categories[i]];
        categories.pop();
    }
}
function $9e23577a7772f81f$var$normalizeVisualRange(thisOption, isCategory) {
    var visual = thisOption.visual;
    var visualArr = [];
    if ($2N6Uo.isObject(visual)) $9e23577a7772f81f$var$each(visual, function(v) {
        visualArr.push(v);
    });
    else if (visual != null) visualArr.push(visual);
    var doNotNeedPair = {
        color: 1,
        symbol: 1
    };
    if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
    $9e23577a7772f81f$var$setVisualToOption(thisOption, visualArr);
}
function $9e23577a7772f81f$var$makePartialColorVisualHandler(applyValue) {
    return {
        applyVisual: function(value, getter, setter) {
            // Only used in HSL
            var colorChannel = this.mapValueToVisual(value);
            // Must not be array value
            setter('color', applyValue(getter('color'), colorChannel));
        },
        _normalizedToVisual: $9e23577a7772f81f$var$createNormalizedToNumericVisual([
            0,
            1
        ])
    };
}
function $9e23577a7772f81f$var$doMapToArray(normalized) {
    var visual = this.option.visual;
    return visual[Math.round((0, $iCU10.linearMap)(normalized, [
        0,
        1
    ], [
        0,
        visual.length - 1
    ], true))] || {}; // TODO {}?
}
function $9e23577a7772f81f$var$makeApplyVisual(visualType) {
    return function(value, getter, setter) {
        setter(visualType, this.mapValueToVisual(value));
    };
}
function $9e23577a7772f81f$var$doMapCategory(normalized) {
    var visual = this.option.visual;
    return visual[this.option.loop && normalized !== $9e23577a7772f81f$var$CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}
function $9e23577a7772f81f$var$doMapFixed() {
    // visual will be convert to array.
    return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */ function $9e23577a7772f81f$var$createNormalizedToNumericVisual(sourceExtent) {
    return {
        linear: function(normalized) {
            return (0, $iCU10.linearMap)(normalized, sourceExtent, this.option.visual, true);
        },
        category: $9e23577a7772f81f$var$doMapCategory,
        piecewise: function(normalized, value) {
            var result = $9e23577a7772f81f$var$getSpecifiedVisual.call(this, value);
            if (result == null) result = (0, $iCU10.linearMap)(normalized, sourceExtent, this.option.visual, true);
            return result;
        },
        fixed: $9e23577a7772f81f$var$doMapFixed
    };
}
function $9e23577a7772f81f$var$getSpecifiedVisual(value) {
    var thisOption = this.option;
    var pieceList = thisOption.pieceList;
    if (thisOption.hasSpecialVisual) {
        var pieceIndex = $9e23577a7772f81f$var$VisualMapping.findPieceIndex(value, pieceList);
        var piece = pieceList[pieceIndex];
        if (piece && piece.visual) return piece.visual[this.type];
    }
}
function $9e23577a7772f81f$var$setVisualToOption(thisOption, visualArr) {
    thisOption.visual = visualArr;
    if (thisOption.type === 'color') thisOption.parsedVisual = $2N6Uo.map(visualArr, function(item) {
        var color = $3UxDF.parse(item);
        color;
        return color || [
            0,
            0,
            0,
            1
        ];
    });
    return visualArr;
}
/**
 * Normalizers by mapping methods.
 */ var $9e23577a7772f81f$var$normalizers = {
    linear: function(value) {
        return (0, $iCU10.linearMap)(value, this.option.dataExtent, [
            0,
            1
        ], true);
    },
    piecewise: function(value) {
        var pieceList = this.option.pieceList;
        var pieceIndex = $9e23577a7772f81f$var$VisualMapping.findPieceIndex(value, pieceList, true);
        if (pieceIndex != null) return (0, $iCU10.linearMap)(pieceIndex, [
            0,
            pieceList.length - 1
        ], [
            0,
            1
        ], true);
    },
    category: function(value) {
        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value
        return index == null ? $9e23577a7772f81f$var$CATEGORY_DEFAULT_VISUAL_INDEX : index;
    },
    fixed: $2N6Uo.noop
};
function $9e23577a7772f81f$var$littleThan(close, a, b) {
    return close ? a <= b : a < b;
}
var $9e23577a7772f81f$export$2e2bcd8739ae039 = $9e23577a7772f81f$var$VisualMapping;

});



parcelRegister("12OmF", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $0c2d0bb740beefe0$export$4b3e715f166fdd78; });
$parcel$export(module.exports, "installScatterJitter", function () { return $0c2d0bb740beefe0$export$7dc06c71cf84167d; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $iMB3c = parcelRequire("iMB3c");

var $3VdMJ = parcelRequire("3VdMJ");

var $cWdXX = parcelRequire("cWdXX");

var $2tzwZ = parcelRequire("2tzwZ");

var $fO6Mw = parcelRequire("fO6Mw");
function $0c2d0bb740beefe0$export$4b3e715f166fdd78(registers) {
    // In case developer forget to include grid component
    (0, $gX19P.use)((0, $cWdXX.install));
    registers.registerSeriesModel((0, $iMB3c.default));
    registers.registerChartView((0, $3VdMJ.default));
    registers.registerLayout((0, $2tzwZ.default)('scatter'));
}
function $0c2d0bb740beefe0$export$7dc06c71cf84167d(registers) {
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $fO6Mw.default));
}

});
parcelRegister("iMB3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dac973309250ef2c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $dOrFN = parcelRequire("dOrFN");

var $49X8G = parcelRequire("49X8G");

var $6aXXD = parcelRequire("6aXXD");
var $dac973309250ef2c$var$ScatterSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ScatterSeriesModel, _super);
    function ScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $dOrFN.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    ScatterSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get('progressive');
        return progressive;
    };
    ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get('progressiveThreshold');
        return progressiveThreshold;
    };
    ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    ScatterSeriesModel.prototype.getZLevelKey = function() {
        // Each progressive series has individual key.
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : '';
    };
    ScatterSeriesModel.type = 'series.scatter';
    ScatterSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar',
        'matrix'
    ];
    ScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        symbolSize: 10,
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        itemStyle: {
            opacity: 0.8
        },
        emphasis: {
            scale: true
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true,
        select: {
            itemStyle: {
                borderColor: (0, $6aXXD.default).color.primary
            }
        },
        universalTransition: {
            divideShape: 'clone'
        }
    };
    return ScatterSeriesModel;
}((0, $49X8G.default));
var $dac973309250ef2c$export$2e2bcd8739ae039 = $dac973309250ef2c$var$ScatterSeriesModel;

});

parcelRegister("3VdMJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2db163676ebe845d$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $ih3Ax = parcelRequire("ih3Ax");

var $afbKz = parcelRequire("afbKz");

var $2tzwZ = parcelRequire("2tzwZ");

var $cWIrM = parcelRequire("cWIrM");
var $2db163676ebe845d$var$ScatterView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ScatterView, _super);
    function ScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterView.type;
        return _this;
    }
    ScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    };
    ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    };
    ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4) return {
            update: true
        };
        else {
            var res = (0, $2tzwZ.default)('').reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    };
    ScatterView.prototype.eachRendered = function(cb) {
        this._symbolDraw && this._symbolDraw.eachRendered(cb);
    };
    ScatterView.prototype._getClipShape = function(seriesModel) {
        if (!seriesModel.get('clip', true)) return;
        var coordSys = seriesModel.coordinateSystem;
        // PENDING make `0.1` configurable, for example, `clipTolerance`?
        return coordSys && coordSys.getArea && coordSys.getArea(.1);
    };
    ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new (0, $afbKz.default)() : new (0, $ih3Ax.default)();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    };
    ScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    };
    ScatterView.prototype.dispose = function() {};
    ScatterView.type = 'scatter';
    return ScatterView;
}((0, $cWIrM.default));
var $2db163676ebe845d$export$2e2bcd8739ae039 = $2db163676ebe845d$var$ScatterView;

});
parcelRegister("afbKz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77546b72d4a77880$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");
parcelRequire("h9U3p");
var $67W72 = parcelRequire("67W72");
var $4oDJM = parcelRequire("4oDJM");
var $iQonF = parcelRequire("iQonF");

var $k0QDS = parcelRequire("k0QDS");

var $6TSUP = parcelRequire("6TSUP");
var $77546b72d4a77880$var$BOOST_SIZE_THRESHOLD = 4;
var $77546b72d4a77880$var$LargeSymbolPathShape = /** @class */ function() {
    function LargeSymbolPathShape() {}
    return LargeSymbolPathShape;
}();
var $77546b72d4a77880$var$LargeSymbolPath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LargeSymbolPath, _super);
    function LargeSymbolPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeSymbolPath.prototype.getDefaultShape = function() {
        return new $77546b72d4a77880$var$LargeSymbolPathShape();
    };
    LargeSymbolPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeSymbolPath.prototype.buildPath = function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $77546b72d4a77880$var$BOOST_SIZE_THRESHOLD;
        var softClipShape = this.softClipShape;
        var i;
        // Do draw in afterBrush.
        if (canBoost) {
            this._ctx = ctx;
            return;
        }
        this._ctx = null;
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.afterBrush = function() {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var ctx = this._ctx;
        var softClipShape = this.softClipShape;
        var i;
        if (!ctx) return;
        // PENDING If style or other canvas status changed?
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.findDataIndex = function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4);
        // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    };
    LargeSymbolPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeSymbolPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.points;
            var size = shape.size;
            var w = size[0];
            var h = size[1];
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $67W72.default(minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
        }
        return rect;
    };
    return LargeSymbolPath;
}($4oDJM.default);
var $77546b72d4a77880$var$LargeSymbolDraw = /** @class */ function() {
    function LargeSymbolDraw() {
        this.group = new $iQonF.default();
    }
    /**
   * Update symbols draw by new data
   */ LargeSymbolDraw.prototype.updateData = function(data, opt) {
        this._clear();
        var symbolEl = this._create();
        symbolEl.setShape({
            points: data.getLayout('points')
        });
        this._setCommon(symbolEl, data, opt);
    };
    LargeSymbolDraw.prototype.updateLayout = function(data) {
        var points = data.getLayout('points');
        this.group.eachChild(function(child) {
            if (child.startIndex != null) {
                var len = (child.endIndex - child.startIndex) * 2;
                var byteOffset = child.startIndex * 8;
                points = new Float32Array(points.buffer, byteOffset, len);
            }
            child.setShape('points', points);
            // Reset draw cursor.
            child.reset();
        });
    };
    LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._clear();
    };
    LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        var lastAdded = this._newAdded[0];
        var points = data.getLayout('points');
        var oldPoints = lastAdded && lastAdded.shape.points;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldPoints && oldPoints.length < 2e4) {
            var oldLen = oldPoints.length;
            var newPoints = new Float32Array(oldLen + points.length);
            // Concat two array
            newPoints.set(oldPoints);
            newPoints.set(points, oldLen);
            // Update endIndex
            lastAdded.endIndex = taskParams.end;
            lastAdded.setShape({
                points: newPoints
            });
        } else {
            // Clear
            this._newAdded = [];
            var symbolEl = this._create();
            symbolEl.startIndex = taskParams.start;
            symbolEl.endIndex = taskParams.end;
            symbolEl.incremental = true;
            symbolEl.setShape({
                points: points
            });
            this._setCommon(symbolEl, data, opt);
        }
    };
    LargeSymbolDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeSymbolDraw.prototype._create = function() {
        var symbolEl = new $77546b72d4a77880$var$LargeSymbolPath({
            cursor: 'default'
        });
        symbolEl.ignoreCoarsePointer = true;
        this.group.add(symbolEl);
        this._newAdded.push(symbolEl);
        return symbolEl;
    };
    LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, opt) {
        var hostModel = data.hostModel;
        opt = opt || {};
        var size = data.getVisual('symbolSize');
        symbolEl.setShape('size', size instanceof Array ? size : [
            size,
            size
        ]);
        symbolEl.softClipShape = opt.clipShape || null;
        // Create symbolProxy to build path for each data
        symbolEl.symbolProxy = (0, $k0QDS.createSymbol)(data.getVisual('symbol'), 0, 0, 0, 0);
        // Use symbolProxy setColor method
        symbolEl.setColor = symbolEl.symbolProxy.setColor;
        var extrudeShadow = symbolEl.shape.size[0] < $77546b72d4a77880$var$BOOST_SIZE_THRESHOLD;
        symbolEl.useStyle(// Draw shadow when doing fillRect is extremely slow.
        hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? [
            'color',
            'shadowBlur',
            'shadowColor'
        ] : [
            'color'
        ]));
        var globalStyle = data.getVisual('style');
        var visualColor = globalStyle && globalStyle.fill;
        if (visualColor) symbolEl.setColor(visualColor);
        var ecData = (0, $6TSUP.getECData)(symbolEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        symbolEl.on('mousemove', function(e) {
            ecData.dataIndex = null;
            var dataIndex = symbolEl.hoverDataIdx;
            if (dataIndex >= 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
        });
    };
    LargeSymbolDraw.prototype.remove = function() {
        this._clear();
    };
    LargeSymbolDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeSymbolDraw;
}();
var $77546b72d4a77880$export$2e2bcd8739ae039 = $77546b72d4a77880$var$LargeSymbolDraw;

});


parcelRegister("cWdXX", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $96b5bc3166641643$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $bpyST = parcelRequire("bpyST");

var $32hvB = parcelRequire("32hvB");
parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");

var $2N6Uo = parcelRequire("2N6Uo");

var $6zVf3 = parcelRequire("6zVf3");

var $lzKMz = parcelRequire("lzKMz");

var $eaWwE = parcelRequire("eaWwE");

var $7JjlZ = parcelRequire("7JjlZ");
// Grid view
var $96b5bc3166641643$var$GridView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $aH2k0.default)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $2N6Uo.defaults)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $bpyST.default));
var $96b5bc3166641643$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $96b5bc3166641643$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($96b5bc3166641643$var$GridView);
    registers.registerComponentModel((0, $32hvB.default));
    registers.registerCoordinateSystem('cartesian2d', (0, $eaWwE.default));
    (0, $lzKMz.default)(registers, 'x', (0, $6zVf3.CartesianAxisModel), $96b5bc3166641643$var$extraOption);
    (0, $lzKMz.default)(registers, 'y', (0, $6zVf3.CartesianAxisModel), $96b5bc3166641643$var$extraOption);
    registers.registerComponentView((0, $7JjlZ.CartesianXAxisView));
    registers.registerComponentView((0, $7JjlZ.CartesianYAxisView));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}

});
parcelRegister("32hvB", function(module, exports) {

$parcel$export(module.exports, "OUTER_BOUNDS_DEFAULT", function () { return $235f23d930a4c745$export$57b4bb4ff2a0950c; });
$parcel$export(module.exports, "OUTER_BOUNDS_CLAMP_DEFAULT", function () { return $235f23d930a4c745$export$e78e6bf4dcc3e485; });
$parcel$export(module.exports, "default", function () { return $235f23d930a4c745$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");

var $a35Wn = parcelRequire("a35Wn");

var $6aXXD = parcelRequire("6aXXD");
var $235f23d930a4c745$export$57b4bb4ff2a0950c = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $235f23d930a4c745$export$e78e6bf4dcc3e485 = [
    '25%',
    '25%'
];
var $235f23d930a4c745$var$GridModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var outerBoundsCp = (0, $a35Wn.getLayoutParams)(option.outerBounds);
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        if (outerBoundsCp && option.outerBounds) (0, $a35Wn.mergeLayoutParam)(option.outerBounds, outerBoundsCp);
    };
    GridModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.apply(this, arguments);
        if (this.option.outerBounds && newOption.outerBounds) (0, $a35Wn.mergeLayoutParam)(this.option.outerBounds, newOption.outerBounds);
    };
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: '15%',
        top: 65,
        right: '10%',
        bottom: 80,
        // If grid size contain label
        containLabel: false,
        outerBoundsMode: 'auto',
        outerBounds: $235f23d930a4c745$export$57b4bb4ff2a0950c,
        outerBoundsContain: 'all',
        outerBoundsClampWidth: $235f23d930a4c745$export$e78e6bf4dcc3e485[0],
        outerBoundsClampHeight: $235f23d930a4c745$export$e78e6bf4dcc3e485[1],
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: (0, $6aXXD.default).color.transparent,
        borderWidth: 1,
        borderColor: (0, $6aXXD.default).color.neutral30
    };
    return GridModel;
}((0, $eLD2b.default));
var $235f23d930a4c745$export$2e2bcd8739ae039 = $235f23d930a4c745$var$GridModel;

});

parcelRegister("6zVf3", function(module, exports) {

$parcel$export(module.exports, "CartesianAxisModel", function () { return $4ca269fdf49acd3c$export$483dc37e6ad83a3c; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $eLD2b = parcelRequire("eLD2b");

var $fRzLp = parcelRequire("fRzLp");

var $bx3T8 = parcelRequire("bx3T8");
var $4ca269fdf49acd3c$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $bx3T8.SINGLE_REFERRING)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $eLD2b.default));
$2N6Uo.mixin($4ca269fdf49acd3c$export$483dc37e6ad83a3c, (0, $fRzLp.AxisModelCommonMixin));
var $4ca269fdf49acd3c$export$2e2bcd8739ae039 = $4ca269fdf49acd3c$export$483dc37e6ad83a3c;

});

parcelRegister("eaWwE", function(module, exports) {

$parcel$export(module.exports, "registerLegacyGridContainLabelImpl", function () { return $a51f65d5dd774dc2$export$9da5287b2e41f334; });
$parcel$export(module.exports, "default", function () { return $a51f65d5dd774dc2$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 
var $2N6Uo = parcelRequire("2N6Uo");

var $a35Wn = parcelRequire("a35Wn");

var $9AF98 = parcelRequire("9AF98");

var $97Tyf = parcelRequire("97Tyf");

var $k56eY = parcelRequire("k56eY");

var $bx3T8 = parcelRequire("bx3T8");

var $32hvB = parcelRequire("32hvB");

var $bYUGA = parcelRequire("bYUGA");

var $b0HC9 = parcelRequire("b0HC9");

var $5UHoe = parcelRequire("5UHoe");

var $h9U3p = parcelRequire("h9U3p");

var $fVg7M = parcelRequire("fVg7M");


var $2HLpR = parcelRequire("2HLpR");

var $hIXrb = parcelRequire("hIXrb");

var $iCU10 = parcelRequire("iCU10");
// margin is [top, right, bottom, left]
var $a51f65d5dd774dc2$var$XY_TO_MARGIN_IDX = [
    [
        3,
        1
    ],
    [
        0,
        2
    ] // xyIdx 1 => 'y'
];
var $a51f65d5dd774dc2$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $97Tyf.cartesian2DDimensions);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        function updateAxisTicks(axes) {
            var alignTo;
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $2N6Uo.keys)(axes);
            var len = axesIndices.length;
            if (!len) return;
            var axisNeedsAlign = [];
            // Process once and calculate the ticks for those don't use alignTicks.
            for(var i = len - 1; i >= 0; i--){
                var idx = +axesIndices[i]; // Convert to number.
                var axis = axes[idx];
                var model = axis.model;
                var scale = axis.scale;
                if (// Only value and log axis without interval support alignTicks.
                (0, $b0HC9.isIntervalOrLogScale)(scale) && model.get('alignTicks') && model.get('interval') == null) axisNeedsAlign.push(axis);
                else {
                    (0, $9AF98.niceScaleExtent)(scale, model);
                    if ((0, $b0HC9.isIntervalOrLogScale)(scale)) // Can only align to interval or log axis.
                    alignTo = axis;
                }
            }
            // All axes has set alignTicks. Pick the first one.
            // PENDING. Should we find the axis that both set interval, min, max and align to this one?
            if (axisNeedsAlign.length) {
                if (!alignTo) {
                    alignTo = axisNeedsAlign.pop();
                    (0, $9AF98.niceScaleExtent)(alignTo.scale, alignTo.model);
                }
                (0, $2N6Uo.each)(axisNeedsAlign, function(axis) {
                    (0, $5UHoe.alignScaleTicks)(axis.scale, axis.model, alignTo.scale);
                });
            }
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $2N6Uo.each)(axesMap.x, function(xAxis) {
            $a51f65d5dd774dc2$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $2N6Uo.each)(axesMap.y, function(yAxis) {
            $a51f65d5dd774dc2$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid.
   *
   * [NOTE]
   * If both "grid.containLabel/grid.contain" and pixel-required-data-processing (such as, "dataSampling")
   * exist, circular dependency occurs in logic.
   * The final compromised sequence is:
   *  1. Calculate "axis.extent" (pixel extent) and AffineTransform based on only "grid layout options".
   *      Not accurate if "grid.containLabel/grid.contain" is required, but it is a compromise to avoid
   *      circular dependency.
   *  2. Perform "series data processing" (where "dataSampling" requires "axis.extent").
   *  3. Calculate "scale.extent" (data extent) based on "processed series data".
   *  4. Modify "axis.extent" for "grid.containLabel/grid.contain":
   *      4.1. Calculate "axis labels" based on "scale.extent".
   *      4.2. Modify "axis.extent" by the bounding rects of "axis labels and names".
   */ Grid.prototype.resize = function(gridModel, api, beforeDataProcessing) {
        var layoutRef = (0, $a35Wn.createBoxLayoutReference)(gridModel, api);
        var gridRect = this._rect = (0, $a35Wn.getLayoutRect)(gridModel.getBoxLayoutParams(), layoutRef.refContainer);
        // PENDING: whether to support that if the input `coord` is out of the base coord sys,
        //  do not render anything. At present, the behavior is undefined.
        var axesMap = this._axesMap;
        var coordsList = this._coordsList;
        var optionContainLabel = gridModel.get('containLabel'); // No `.get(, true)` for backward compat.
        $a51f65d5dd774dc2$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
        if (!beforeDataProcessing) {
            var axisBuilderSharedCtx = $a51f65d5dd774dc2$var$createAxisBiulders(gridRect, coordsList, axesMap, optionContainLabel, api);
            var noPxChange = void 0;
            if (optionContainLabel) {
                if ($a51f65d5dd774dc2$var$legacyLayOutGridByContainLabel) {
                    // console.time('legacyLayOutGridByContainLabel');
                    $a51f65d5dd774dc2$var$legacyLayOutGridByContainLabel(this._axesList, gridRect);
                    $a51f65d5dd774dc2$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
                // console.timeEnd('legacyLayOutGridByContainLabel');
                } else noPxChange = $a51f65d5dd774dc2$var$layOutGridByOuterBounds(gridRect.clone(), 'axisLabel', null, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            } else {
                var _a = $a51f65d5dd774dc2$var$prepareOuterBounds(gridModel, gridRect, layoutRef), outerBoundsRect = _a.outerBoundsRect, parsedOuterBoundsContain = _a.parsedOuterBoundsContain, outerBoundsClamp = _a.outerBoundsClamp;
                if (outerBoundsRect) // console.time('layOutGridByOuterBounds');
                noPxChange = $a51f65d5dd774dc2$var$layOutGridByOuterBounds(outerBoundsRect, parsedOuterBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            }
            // console.time('buildAxesView_determine');
            $a51f65d5dd774dc2$var$createOrUpdateAxesView(gridRect, axesMap, (0, $2HLpR.AxisTickLabelComputingKind).determine, null, noPxChange, layoutRef);
        // console.timeEnd('buildAxesView_determine');
        } // End of beforeDataProcessing
        (0, $2N6Uo.each)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $2N6Uo.isObject)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $bx3T8.SINGLE_REFERRING)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $bx3T8.SINGLE_REFERRING)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $2N6Uo.indexOf)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $2N6Uo.each)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $2N6Uo.each)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $97Tyf.default)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$a51f65d5dd774dc2$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $k56eY.default)(dimName, (0, $9AF98.createScaleByModel)(axisModel), [
                    0,
                    0
                ], axisModel.get('type'), axisPosition);
                var isCategory = axis.type === 'category';
                axis.onBand = isCategory && axisModel.get('boundaryGap');
                axis.inverse = axisModel.get('inverse');
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $2N6Uo.each)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === 'category') {
                var categorySortInfo = axis.model.get('categorySortInfo');
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            // If pie (or other similar series) use cartesian2d, the unionExtent logic below is
            // wrong, therefore skip it temporarily. See also in `defaultAxisExtentFromData.ts`.
            // TODO: support union extent in this case.
            if ((0, $bYUGA.isCartesian2DInjectedAsDataCoordSys)(seriesModel)) {
                var axesModelMap = (0, $bYUGA.findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$a51f65d5dd774dc2$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$a51f65d5dd774dc2$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis('x');
                var yAxis = cartesian.getAxis('y');
                unionExtent(data, xAxis);
                unionExtent(data, yAxis);
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $2N6Uo.each)((0, $9AF98.getDataDimensionsOnAxis)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $2N6Uo.each)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $2N6Uo.indexOf)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $2N6Uo.indexOf)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            (0, $hIXrb.injectCoordSysByOption)({
                targetModel: seriesModel,
                coordSysType: 'cartesian2d',
                coordSysProvider: coordSysProvider
            });
            function coordSysProvider() {
                var axesModelMap = (0, $bYUGA.findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                return grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            }
        });
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $97Tyf.cartesian2DDimensions);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $a51f65d5dd774dc2$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $a51f65d5dd774dc2$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($a51f65d5dd774dc2$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $a51f65d5dd774dc2$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
function $a51f65d5dd774dc2$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== 'category' && axis.type !== 'time' && (0, $9AF98.ifAxisCrossZero)(axis);
}
function $a51f65d5dd774dc2$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
function $a51f65d5dd774dc2$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect) {
    (0, $2N6Uo.each)(axesMap.x, function(axis) {
        return $a51f65d5dd774dc2$var$updateAxisExtentTransByGridRect(axis, gridRect.x, gridRect.width);
    });
    (0, $2N6Uo.each)(axesMap.y, function(axis) {
        return $a51f65d5dd774dc2$var$updateAxisExtentTransByGridRect(axis, gridRect.y, gridRect.height);
    });
}
function $a51f65d5dd774dc2$var$updateAxisExtentTransByGridRect(axis, gridXY, gridWH) {
    var extent = [
        0,
        gridWH
    ];
    var idx = axis.inverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);
    $a51f65d5dd774dc2$var$updateAxisTransform(axis, gridXY);
}
var $a51f65d5dd774dc2$var$legacyLayOutGridByContainLabel;
function $a51f65d5dd774dc2$export$9da5287b2e41f334(impl) {
    $a51f65d5dd774dc2$var$legacyLayOutGridByContainLabel = impl;
}
// Return noPxChange.
function $a51f65d5dd774dc2$var$layOutGridByOuterBounds(outerBoundsRect, outerBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef) {
    // Assume `updateAllAxisExtentTransByGridRect` has been performed once before this call.
    // [NOTE]:
    // - The bounding rect of the axis elements might be sensitve to variations in `axis.extent` due to strategies
    //  like hideOverlap/moveOverlap. @see the comment in `LabelLayoutBase['suggestIgnore']`.
    // - The final `gridRect` might be slightly smaller than the ideally expected result if labels are giant and
    //  get hidden due to overlapping. More iterations could improve precision, but not performant. We consider
    //  the current result acceptable, since no alignment among charts can be guaranteed when using this feature.
    $a51f65d5dd774dc2$var$createOrUpdateAxesView(gridRect, axesMap, (0, $2HLpR.AxisTickLabelComputingKind).estimate, outerBoundsContain, false, layoutRef);
    var margin = [
        0,
        0,
        0,
        0
    ];
    fillLabelNameOverflowOnOneDimension(0);
    fillLabelNameOverflowOnOneDimension(1);
    // If axis is blank, no label can be used to detect overflow.
    // gridRect itself should not overflow.
    fillMarginOnOneDimension(gridRect, 0, NaN);
    fillMarginOnOneDimension(gridRect, 1, NaN);
    var noPxChange = (0, $2N6Uo.find)(margin, function(item) {
        return item > 0;
    }) == null;
    (0, $h9U3p.expandOrShrinkRect)(gridRect, margin, true, true, outerBoundsClamp);
    $a51f65d5dd774dc2$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
    return noPxChange;
    function fillLabelNameOverflowOnOneDimension(xyIdx) {
        (0, $2N6Uo.each)(axesMap[(0, $h9U3p.XY)[xyIdx]], function(axis) {
            if (!(0, $9AF98.shouldAxisShow)(axis.model)) return;
            // FIXME: zr Group.union may wrongly union (0, 0, 0, 0) and not performant.
            // unionRect.union(axis.axisBuilder.group.getBoundingRect());
            // If ussing Group.getBoundingRect to calculate shrink space, it is not strictly accurate when
            // the outermost label is ignored and the secondary label is very long and contribute to the
            // union extension:
            //      -|---|---|---|
            //         1,000,000,000
            // Therefore we calculate them one by one.
            // Also considered axis may be blank or no labels.
            var sharedRecord = axisBuilderSharedCtx.ensureRecord(axis.model);
            var labelInfoList = sharedRecord.labelInfoList;
            if (labelInfoList) for(var idx = 0; idx < labelInfoList.length; idx++){
                var labelInfo = labelInfoList[idx];
                var proportion = axis.scale.normalize((0, $fVg7M.getLabelInner)(labelInfo.label).tickValue);
                proportion = xyIdx === 1 ? 1 - proportion : proportion;
                // xAxis use proportion on x, yAxis use proprotion on y, otherwise not.
                fillMarginOnOneDimension(labelInfo.rect, xyIdx, proportion);
                fillMarginOnOneDimension(labelInfo.rect, 1 - xyIdx, NaN);
            }
            var nameLayout = sharedRecord.nameLayout;
            if (nameLayout) {
                var proportion = (0, $9AF98.isNameLocationCenter)(sharedRecord.nameLocation) ? 0.5 : NaN;
                fillMarginOnOneDimension(nameLayout.rect, xyIdx, proportion);
                fillMarginOnOneDimension(nameLayout.rect, 1 - xyIdx, NaN);
            }
        });
    }
    function fillMarginOnOneDimension(itemRect, xyIdx, proportion // NaN mean no use proportion
    ) {
        var overflow1 = outerBoundsRect[(0, $h9U3p.XY)[xyIdx]] - itemRect[(0, $h9U3p.XY)[xyIdx]];
        var overflow2 = itemRect[(0, $h9U3p.WH)[xyIdx]] + itemRect[(0, $h9U3p.XY)[xyIdx]] - (outerBoundsRect[(0, $h9U3p.WH)[xyIdx]] + outerBoundsRect[(0, $h9U3p.XY)[xyIdx]]);
        overflow1 = applyProportion(overflow1, 1 - proportion);
        overflow2 = applyProportion(overflow2, proportion);
        var minIdx = $a51f65d5dd774dc2$var$XY_TO_MARGIN_IDX[xyIdx][0];
        var maxIdx = $a51f65d5dd774dc2$var$XY_TO_MARGIN_IDX[xyIdx][1];
        margin[minIdx] = (0, $iCU10.mathMax)(margin[minIdx], overflow1);
        margin[maxIdx] = (0, $iCU10.mathMax)(margin[maxIdx], overflow2);
    }
    function applyProportion(overflow, proportion) {
        // proportion is not likely to near zero. If so, give up shrink
        if (overflow > 0 && !(0, $2N6Uo.eqNaN)(proportion) && proportion > 1e-4) overflow /= proportion;
        return overflow;
    }
}
function $a51f65d5dd774dc2$var$createAxisBiulders(gridRect, cartesians, axesMap, optionContainLabel, api) {
    var axisBuilderSharedCtx = new (0, $fVg7M.AxisBuilderSharedContext)($a51f65d5dd774dc2$var$resolveAxisNameOverlapForGrid);
    (0, $2N6Uo.each)(axesMap, function(axisList) {
        return (0, $2N6Uo.each)(axisList, function(axis) {
            if ((0, $9AF98.shouldAxisShow)(axis.model)) {
                // See `AxisBaseOptionCommon['nameMoveOverlap']`.
                var defaultNameMoveOverlap = !optionContainLabel;
                axis.axisBuilder = (0, $bYUGA.createCartesianAxisViewCommonPartBuilder)(gridRect, cartesians, axis.model, api, axisBuilderSharedCtx, defaultNameMoveOverlap);
            }
        });
    });
    return axisBuilderSharedCtx;
}
/**
 * Promote the axis-elements-building from "view render" stage to "coordinate system resize" stage.
 * This is aimed to resovle overlap across multiple axes, since currently it's hard to reconcile
 * multiple axes in "view render" stage.
 *
 * [CAUTION] But this promotion assumes that the subsequent "visual mapping" stage does not affect
 * this axis-elements-building; otherwise we have to refactor it again.
 */ function $a51f65d5dd774dc2$var$createOrUpdateAxesView(gridRect, axesMap, kind, outerBoundsContain, noPxChange, layoutRef) {
    var isDetermine = kind === (0, $2HLpR.AxisTickLabelComputingKind).determine;
    (0, $2N6Uo.each)(axesMap, function(axisList) {
        return (0, $2N6Uo.each)(axisList, function(axis) {
            if ((0, $9AF98.shouldAxisShow)(axis.model)) {
                (0, $bYUGA.updateCartesianAxisViewCommonPartBuilder)(axis.axisBuilder, gridRect, axis.model);
                axis.axisBuilder.build(isDetermine ? {
                    axisTickLabelDetermine: true
                } : {
                    axisTickLabelEstimate: true
                }, {
                    noPxChange: noPxChange
                });
            }
        });
    });
    var nameMarginLevelMap = {
        x: 0,
        y: 0
    };
    calcNameMarginLevel(0);
    calcNameMarginLevel(1);
    function calcNameMarginLevel(xyIdx) {
        nameMarginLevelMap[(0, $h9U3p.XY)[1 - xyIdx]] = gridRect[(0, $h9U3p.WH)[xyIdx]] <= layoutRef.refContainer[(0, $h9U3p.WH)[xyIdx]] * 0.5 ? 0 : 1 - xyIdx === 1 ? 2 : 1;
    }
    (0, $2N6Uo.each)(axesMap, function(axisList, xy) {
        return (0, $2N6Uo.each)(axisList, function(axis) {
            if ((0, $9AF98.shouldAxisShow)(axis.model)) {
                if (outerBoundsContain === 'all' || isDetermine) // To resolve overlap, `axisName` layout depends on `axisTickLabel` layout result
                // (all of the axes of the same `grid`; consider multiple x or y axes).
                axis.axisBuilder.build({
                    axisName: true
                }, {
                    nameMarginLevel: nameMarginLevelMap[xy]
                });
                if (isDetermine) axis.axisBuilder.build({
                    axisLine: true
                });
            }
        });
    });
}
function $a51f65d5dd774dc2$var$prepareOuterBounds(gridModel, rawRridRect, layoutRef) {
    var outerBoundsRect;
    var optionOuterBoundsMode = gridModel.get('outerBoundsMode', true);
    if (optionOuterBoundsMode === 'same') outerBoundsRect = rawRridRect.clone();
    else if (optionOuterBoundsMode == null || optionOuterBoundsMode === 'auto') outerBoundsRect = (0, $a35Wn.getLayoutRect)(gridModel.get('outerBounds', true) || (0, $32hvB.OUTER_BOUNDS_DEFAULT), layoutRef.refContainer);
    else optionOuterBoundsMode;
    var optionOuterBoundsContain = gridModel.get('outerBoundsContain', true);
    var parsedOuterBoundsContain;
    if (optionOuterBoundsContain == null || optionOuterBoundsContain === 'auto') parsedOuterBoundsContain = 'all';
    else if ((0, $2N6Uo.indexOf)([
        'all',
        'axisLabel'
    ], optionOuterBoundsContain) < 0) parsedOuterBoundsContain = 'all';
    else parsedOuterBoundsContain = optionOuterBoundsContain;
    var outerBoundsClamp = [
        (0, $iCU10.parsePositionSizeOption)((0, $2N6Uo.retrieve2)(gridModel.get('outerBoundsClampWidth', true), (0, $32hvB.OUTER_BOUNDS_CLAMP_DEFAULT)[0]), rawRridRect.width),
        (0, $iCU10.parsePositionSizeOption)((0, $2N6Uo.retrieve2)(gridModel.get('outerBoundsClampHeight', true), (0, $32hvB.OUTER_BOUNDS_CLAMP_DEFAULT)[1]), rawRridRect.height)
    ];
    return {
        outerBoundsRect: outerBoundsRect,
        parsedOuterBoundsContain: parsedOuterBoundsContain,
        outerBoundsClamp: outerBoundsClamp
    };
}
var $a51f65d5dd774dc2$var$resolveAxisNameOverlapForGrid = function(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    var perpendicularDim = axisModel.axis.dim === 'x' ? 'y' : 'x';
    (0, $fVg7M.resolveAxisNameOverlapDefault)(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord);
    // If nameLocation 'center', and there are multiple axes parallel to this axis, do not adjust by
    //  other axes, because the axis name should be close to its axis line as much as possible even
    //  if overlapping; otherwise it might cause misleading.
    // If nameLocation 'center', do not adjust by perpendicular axes, since they are not likely to overlap.
    // If nameLocation 'start'/'end', move name within the same direction to escape overlap with the
    //  perpendicular axes.
    if (!(0, $9AF98.isNameLocationCenter)(cfg.nameLocation)) (0, $2N6Uo.each)(ctx.recordMap[perpendicularDim], function(perpenRecord) {
        // perpendicular axis may be no name.
        if (perpenRecord && perpenRecord.labelInfoList && perpenRecord.dirVec) (0, $fVg7M.moveIfOverlapByLinearLabels)(perpenRecord.labelInfoList, perpenRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
    });
};
var $a51f65d5dd774dc2$export$2e2bcd8739ae039 = $a51f65d5dd774dc2$var$Grid;

});
parcelRegister("97Tyf", function(module, exports) {

$parcel$export(module.exports, "cartesian2DDimensions", function () { return $6a4fdbda3c2d13d4$export$988a008d2b9120f4; });
$parcel$export(module.exports, "default", function () { return $6a4fdbda3c2d13d4$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $67W72 = parcelRequire("67W72");

var $CO8Ax = parcelRequire("CO8Ax");

var $19Ywy = parcelRequire("19Ywy");

var $U1aqY = parcelRequire("U1aqY");
var $6a4fdbda3c2d13d4$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $6a4fdbda3c2d13d4$var$canCalculateAffineTransform(scale) {
    return (scale.type === 'interval' || scale.type === 'time') && !scale.hasBreaks();
}
var $6a4fdbda3c2d13d4$var$Cartesian2D = /** @class */ function(_super) {
    (0, $9nEce.__extends)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cartesian2d';
        _this.dimensions = $6a4fdbda3c2d13d4$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$6a4fdbda3c2d13d4$var$canCalculateAffineTransform(xAxisScale) || !$6a4fdbda3c2d13d4$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $19Ywy.invert)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $67W72.default)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // [CAVEAT]: Do not add time consuming operation within and before fast path.
        // Fast path.
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $U1aqY.applyTransform)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp, out) {
        out = out || [];
        if (this._invTransform) return (0, $U1aqY.applyTransform)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $67W72.default)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $CO8Ax.default));
var $6a4fdbda3c2d13d4$export$2e2bcd8739ae039 = $6a4fdbda3c2d13d4$var$Cartesian2D;

});
parcelRegister("CO8Ax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $074a70fe00346764$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $074a70fe00346764$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $2N6Uo.map(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $2N6Uo.filter(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $074a70fe00346764$export$2e2bcd8739ae039 = $074a70fe00346764$var$Cartesian;

});


parcelRegister("k56eY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9e91d7f6177307c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $6ZMAw = parcelRequire("6ZMAw");
var $e9e91d7f6177307c$var$Axis2D = /** @class */ function(_super) {
    (0, $9nEce.__extends)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $6ZMAw.default));
var $e9e91d7f6177307c$export$2e2bcd8739ae039 = $e9e91d7f6177307c$var$Axis2D;

});

parcelRegister("bYUGA", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $8b9144f2c7b100e2$export$b3219800bda33a1f; });
$parcel$export(module.exports, "isCartesian2DInjectedAsDataCoordSys", function () { return $8b9144f2c7b100e2$export$e447722773749af; });
$parcel$export(module.exports, "findAxisModels", function () { return $8b9144f2c7b100e2$export$8220131ac1d61d28; });
$parcel$export(module.exports, "createCartesianAxisViewCommonPartBuilder", function () { return $8b9144f2c7b100e2$export$2b2ce820c3e1e776; });
$parcel$export(module.exports, "updateCartesianAxisViewCommonPartBuilder", function () { return $8b9144f2c7b100e2$export$3e8d41f03e1a6a39; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $fVg7M = parcelRequire("fVg7M");

var $b0HC9 = parcelRequire("b0HC9");
function $8b9144f2c7b100e2$export$b3219800bda33a1f(rect, axisModel, opt) {
    opt = opt || {};
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($2N6Uo.retrieve(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $8b9144f2c7b100e2$export$1a2a248dbebc52b5(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $8b9144f2c7b100e2$export$e447722773749af(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $8b9144f2c7b100e2$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $2N6Uo.each(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $bx3T8.SINGLE_REFERRING)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}
function $8b9144f2c7b100e2$export$2b2ce820c3e1e776(gridRect, cartesians, axisModel, api, ctx, defaultNameMoveOverlap) {
    var layoutResult = $8b9144f2c7b100e2$export$b3219800bda33a1f(gridRect, axisModel);
    var axisLineAutoShow = false;
    var axisTickAutoShow = false;
    // Not show axisTick or axisLine if other axis is category / time
    for(var i = 0; i < cartesians.length; i++)if ((0, $b0HC9.isIntervalOrLogScale)(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
        // Still show axis tick or axisLine if other axis is value / log
        axisLineAutoShow = axisTickAutoShow = true;
        if (axisModel.axis.type === 'category' && axisModel.axis.onBand) axisTickAutoShow = false;
    }
    layoutResult.axisLineAutoShow = axisLineAutoShow;
    layoutResult.axisTickAutoShow = axisTickAutoShow;
    layoutResult.defaultNameMoveOverlap = defaultNameMoveOverlap;
    return new (0, $fVg7M.default)(axisModel, api, layoutResult, ctx);
}
function $8b9144f2c7b100e2$export$3e8d41f03e1a6a39(axisBuilder, gridRect, axisModel) {
    var newRaw = $8b9144f2c7b100e2$export$b3219800bda33a1f(gridRect, axisModel);
    var oldRaw_1;
    axisBuilder.updateCfg(newRaw);
}

});


parcelRegister("7JjlZ", function(module, exports) {

$parcel$export(module.exports, "CartesianXAxisView", function () { return $5a0bbf9c7b5bbd02$export$b6d40cd875b8a1c8; });
$parcel$export(module.exports, "CartesianYAxisView", function () { return $5a0bbf9c7b5bbd02$export$417e1bdd0616e0dc; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $iQonF = parcelRequire("iQonF");
var $h9U3p = parcelRequire("h9U3p");
var $c3CaY = parcelRequire("c3CaY");

var $cjjFP = parcelRequire("cjjFP");

var $dcfmi = parcelRequire("dcfmi");

var $Etgh3 = parcelRequire("Etgh3");

var $9AF98 = parcelRequire("9AF98");
var $5a0bbf9c7b5bbd02$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine',
    'breakArea'
];
var $5a0bbf9c7b5bbd02$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $iQonF.default();
        this.group.add(this._axisGroup);
        if (!(0, $9AF98.shouldAxisShow)(axisModel)) return;
        this._axisGroup.add(axisModel.axis.axisBuilder.group);
        $2N6Uo.each($5a0bbf9c7b5bbd02$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $5a0bbf9c7b5bbd02$var$axisElementBuilders[name](this, this._axisGroup, axisModel, axisModel.getCoordSysModel(), api);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $h9U3p.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $dcfmi.rectCoordAxisHandleRemove)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $cjjFP.default));
var $5a0bbf9c7b5bbd02$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var showMinLine = splitLineModel.get('showMinLine') !== false;
        var showMaxLine = splitLineModel.get('showMaxLine') !== false;
        lineColors = $2N6Uo.isArray(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel,
            breakTicks: 'none',
            pruneByBreak: 'preserve_extent_bound'
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (i === 0 && !showMinLine || i === ticksCoords.length - 1 && !showMaxLine) continue;
            var tickValue = ticksCoords[i].tickValue;
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var line = new $c3CaY.default({
                anid: tickValue != null ? 'line_' + tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $2N6Uo.defaults({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $h9U3p.subPixelOptimizeLine(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $c3CaY.default({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $h9U3p.subPixelOptimizeLine(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel, api) {
        (0, $dcfmi.rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, gridModel);
    },
    breakArea: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axisBreakHelper = (0, $Etgh3.getAxisBreakHelper)();
        var scale = axisModel.axis.scale;
        if (axisBreakHelper && scale.type !== 'ordinal') axisBreakHelper.rectCoordBuildBreakAxis(axisGroup, axisView, axisModel, gridModel.coordinateSystem.getRect(), api);
    }
};
var $5a0bbf9c7b5bbd02$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($5a0bbf9c7b5bbd02$var$CartesianAxisView);
var $5a0bbf9c7b5bbd02$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $5a0bbf9c7b5bbd02$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($5a0bbf9c7b5bbd02$var$CartesianAxisView);
var $5a0bbf9c7b5bbd02$export$2e2bcd8739ae039 = $5a0bbf9c7b5bbd02$var$CartesianAxisView;

});
parcelRegister("cjjFP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f6685277b88e831$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $enAKb = parcelRequire("enAKb");

var $bpyST = parcelRequire("bpyST");
var $8f6685277b88e831$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $8f6685277b88e831$var$AxisView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $enAKb.fixValue(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $enAKb.getAxisPointerModel(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $8f6685277b88e831$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $8f6685277b88e831$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $bpyST.default));
var $8f6685277b88e831$export$2e2bcd8739ae039 = $8f6685277b88e831$var$AxisView;

});
parcelRegister("enAKb", function(module, exports) {

$parcel$export(module.exports, "collect", function () { return $a77fb73f963d1066$export$bb44f104e3c54dae; });
$parcel$export(module.exports, "makeKey", function () { return $a77fb73f963d1066$export$d01b444bafb1a792; });
$parcel$export(module.exports, "fixValue", function () { return $a77fb73f963d1066$export$f5ea32e3629d8043; });
$parcel$export(module.exports, "getAxisInfo", function () { return $a77fb73f963d1066$export$bd39458db76002ab; });
$parcel$export(module.exports, "getAxisPointerModel", function () { return $a77fb73f963d1066$export$3b06fce3f68b734; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b8YKU = parcelRequire("b8YKU");

var $2N6Uo = parcelRequire("2N6Uo");
function $a77fb73f963d1066$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $a77fb73f963d1066$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $a77fb73f963d1066$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $a77fb73f963d1066$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer');
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $2N6Uo.each)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $a77fb73f963d1066$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $2N6Uo.each)(coordSys.getAxes(), (0, $2N6Uo.curry)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $2N6Uo.each)(tooltipAxes.baseAxes, (0, $2N6Uo.curry)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $2N6Uo.each)(tooltipAxes.otherAxes, (0, $2N6Uo.curry)(saveTooltipAxisInfo, 'cross', false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$a77fb73f963d1066$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $a77fb73f963d1066$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var triggerEmphasis = axisPointerModel.get('triggerEmphasis');
            var axisKey = $a77fb73f963d1066$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category';
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $a77fb73f963d1066$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $a77fb73f963d1066$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $a77fb73f963d1066$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $2N6Uo.each)(fields, function(field) {
        volatileOption[field] = (0, $2N6Uo.clone)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $2N6Uo.defaults)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $b8YKU.default)(volatileOption, globalAxisPointerModel, ecModel));
}
function $a77fb73f963d1066$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || !coordSys.model // PENDING: radar do not have a model.
         || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $2N6Uo.each)(result.coordSysAxesInfo[$a77fb73f963d1066$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $a77fb73f963d1066$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($a77fb73f963d1066$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $a77fb73f963d1066$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $a77fb73f963d1066$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $a77fb73f963d1066$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $2N6Uo.isArray)(linkPropValue) && (0, $2N6Uo.indexOf)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $a77fb73f963d1066$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $a77fb73f963d1066$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value');
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $a77fb73f963d1066$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $a77fb73f963d1066$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$a77fb73f963d1066$export$d01b444bafb1a792(axisModel)];
}
function $a77fb73f963d1066$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $a77fb73f963d1066$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $a77fb73f963d1066$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $a77fb73f963d1066$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}

});


parcelRegister("dcfmi", function(module, exports) {

$parcel$export(module.exports, "rectCoordAxisBuildSplitArea", function () { return $99b84f3a59488913$export$c80b7ef1527ec8c9; });
$parcel$export(module.exports, "rectCoordAxisHandleRemove", function () { return $99b84f3a59488913$export$48ebf2d6ce8ad076; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");

var $bx3T8 = parcelRequire("bx3T8");
var $99b84f3a59488913$var$inner = (0, $bx3T8.makeInner)();
function $99b84f3a59488913$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    // TODO: TYPE
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true,
        breakTicks: 'none',
        pruneByBreak: 'preserve_extent_bound'
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $99b84f3a59488913$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $2N6Uo.createHashMap();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $2N6Uo.isArray(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $aH2k0.default({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $2N6Uo.defaults({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $99b84f3a59488913$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $99b84f3a59488913$export$48ebf2d6ce8ad076(axisView) {
    $99b84f3a59488913$var$inner(axisView).splitAreaColors = null;
}

});



parcelRegister("fO6Mw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b820c93648fc6d1b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3KhnP = parcelRequire("3KhnP");
function $b820c93648fc6d1b$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('scatter', function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'single')) {
            var baseAxis_1 = coordSys.getBaseAxis ? coordSys.getBaseAxis() : null;
            var hasJitter = baseAxis_1 && (0, $3KhnP.needFixJitter)(seriesModel, baseAxis_1);
            if (hasJitter) {
                var data_1 = seriesModel.getData();
                data_1.each(function(idx) {
                    var dim = baseAxis_1.dim;
                    var orient = baseAxis_1.orient;
                    var isSingleY = orient === 'horizontal' && baseAxis_1.type !== 'category' || orient === 'vertical' && baseAxis_1.type === 'category';
                    var layout = data_1.getItemLayout(idx);
                    var rawSize = data_1.getItemVisual(idx, 'symbolSize');
                    var size = rawSize instanceof Array ? (rawSize[1] + rawSize[0]) / 2 : rawSize;
                    if (dim === 'y' || dim === 'single' && isSingleY) {
                        // x is fixed, and y is floating
                        var jittered = (0, $3KhnP.fixJitter)(baseAxis_1, layout[0], layout[1], size / 2);
                        data_1.setItemLayout(idx, [
                            layout[0],
                            jittered
                        ]);
                    } else if (dim === 'x' || dim === 'single' && !isSingleY) {
                        // y is fixed, and x is floating
                        var jittered = (0, $3KhnP.fixJitter)(baseAxis_1, layout[1], layout[0], size / 2);
                        data_1.setItemLayout(idx, [
                            jittered,
                            layout[1]
                        ]);
                    }
                });
            }
        }
    });
}

});
parcelRegister("3KhnP", function(module, exports) {

$parcel$export(module.exports, "needFixJitter", function () { return $2ba326ed4e4cce47$export$3d0d41e580ffa4e6; });
$parcel$export(module.exports, "fixJitter", function () { return $2ba326ed4e4cce47$export$99f76258a03259ba; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $k56eY = parcelRequire("k56eY");

var $bx3T8 = parcelRequire("bx3T8");
function $2ba326ed4e4cce47$export$3d0d41e580ffa4e6(seriesModel, axis) {
    var coordinateSystem = seriesModel.coordinateSystem;
    var coordType = coordinateSystem && coordinateSystem.type;
    var baseAxis = coordinateSystem && coordinateSystem.getBaseAxis && coordinateSystem.getBaseAxis();
    var scaleType = baseAxis && baseAxis.scale && baseAxis.scale.type;
    var seriesValid = coordType === 'cartesian2d' && scaleType === 'ordinal' || coordType === 'single';
    var axisValid = axis.model.get('jitter') > 0;
    return seriesValid && axisValid;
}
var $2ba326ed4e4cce47$var$inner = (0, $bx3T8.makeInner)();
function $2ba326ed4e4cce47$export$99f76258a03259ba(fixedAxis, fixedCoord, floatCoord, radius) {
    if (fixedAxis instanceof (0, $k56eY.default)) {
        var scaleType = fixedAxis.scale.type;
        if (scaleType !== 'category' && scaleType !== 'ordinal') return floatCoord;
    }
    var axisModel = fixedAxis.model;
    var jitter = axisModel.get('jitter');
    var jitterOverlap = axisModel.get('jitterOverlap');
    var jitterMargin = axisModel.get('jitterMargin') || 0;
    // Get band width to limit jitter range
    var bandWidth = fixedAxis.scale.type === 'ordinal' ? fixedAxis.getBandWidth() : null;
    if (jitter > 0) {
        if (jitterOverlap) return $2ba326ed4e4cce47$var$fixJitterIgnoreOverlaps(floatCoord, jitter, bandWidth, radius);
        else return $2ba326ed4e4cce47$var$fixJitterAvoidOverlaps(fixedAxis, fixedCoord, floatCoord, radius, jitter, jitterMargin);
    }
    return floatCoord;
}
function $2ba326ed4e4cce47$var$fixJitterIgnoreOverlaps(floatCoord, jitter, bandWidth, radius) {
    // Don't clamp single axis
    if (bandWidth === null) return floatCoord + (Math.random() - 0.5) * jitter;
    var maxJitter = bandWidth - radius * 2;
    var actualJitter = Math.min(Math.max(0, jitter), maxJitter);
    return floatCoord + (Math.random() - 0.5) * actualJitter;
}
function $2ba326ed4e4cce47$var$fixJitterAvoidOverlaps(fixedAxis, fixedCoord, floatCoord, radius, jitter, margin) {
    var store = $2ba326ed4e4cce47$var$inner(fixedAxis);
    if (!store.items) store.items = [];
    var items = store.items;
    // Try both positive and negative directions, choose the one with smaller movement
    var overlapA = $2ba326ed4e4cce47$var$placeJitterOnDirection(items, fixedCoord, floatCoord, radius, jitter, margin, 1);
    var overlapB = $2ba326ed4e4cce47$var$placeJitterOnDirection(items, fixedCoord, floatCoord, radius, jitter, margin, -1);
    var minFloat = Math.abs(overlapA - floatCoord) < Math.abs(overlapB - floatCoord) ? overlapA : overlapB;
    // Clamp only category axis
    var bandWidth = fixedAxis.scale.type === 'ordinal' ? fixedAxis.getBandWidth() : null;
    var distance = Math.abs(minFloat - floatCoord);
    if (distance > jitter / 2 || bandWidth && distance > bandWidth / 2 - radius) // If the new item is moved too far, then give up.
    // Fall back to random jitter.
    return $2ba326ed4e4cce47$var$fixJitterIgnoreOverlaps(floatCoord, jitter, bandWidth, radius);
    // Add new point to array
    items.push({
        fixedCoord: fixedCoord,
        floatCoord: minFloat,
        r: radius
    });
    return minFloat;
}
function $2ba326ed4e4cce47$var$placeJitterOnDirection(items, fixedCoord, floatCoord, radius, jitter, margin, direction) {
    var y = floatCoord;
    // Check all existing items for overlap and find the maximum adjustment needed
    for(var i = 0; i < items.length; i++){
        var item = items[i];
        var dx = fixedCoord - item.fixedCoord;
        var dy = y - item.floatCoord;
        var d2 = dx * dx + dy * dy;
        var r = radius + item.r + margin;
        if (d2 < r * r) {
            // Has overlap, calculate required adjustment
            var requiredY = item.floatCoord + Math.sqrt(r * r - dx * dx) * direction;
            // Check if this adjustment would move too far
            if (Math.abs(requiredY - floatCoord) > jitter / 2) return Number.MAX_VALUE; // Give up
            // Update y only when it's larger to the center
            if (direction === 1 && requiredY > y || direction === -1 && requiredY < y) {
                y = requiredY;
                // Loop from the start again
                i = -1; // Reset index to recheck all items
                continue; // Recalculate with the new y position
            }
        }
    }
    return y;
}

});



parcelRegister("4qhWn", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $338781c61de013b3$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4U36G = parcelRequire("4U36G");

var $cZMjX = parcelRequire("cZMjX");

var $85Oik = parcelRequire("85Oik");

var $HfOtG = parcelRequire("HfOtG");

var $impUY = parcelRequire("impUY");

var $2N6Uo = parcelRequire("2N6Uo");

var $bufkO = parcelRequire("bufkO");
function $338781c61de013b3$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $4U36G.default));
    registers.registerSeriesModel((0, $cZMjX.default));
    registers.registerLayout((0, $2N6Uo.curry)((0, $85Oik.default), 'sunburst'));
    registers.registerProcessor((0, $2N6Uo.curry)((0, $impUY.default), 'sunburst'));
    registers.registerVisual((0, $HfOtG.default));
    (0, $bufkO.installSunburstAction)(registers);
}

});
parcelRegister("4U36G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $391ecd559ab9fbc0$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $cWIrM = parcelRequire("cWIrM");

var $cSqOc = parcelRequire("cSqOc");

var $chf3v = parcelRequire("chf3v");

var $bufkO = parcelRequire("bufkO");

var $hrphB = parcelRequire("hrphB");
var $391ecd559ab9fbc0$var$SunburstView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SunburstView, _super);
    function SunburstView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstView.type;
        return _this;
    }
    SunburstView.prototype.render = function(seriesModel, ecModel, api, // @ts-ignore
    payload) {
        var self = this;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var data = seriesModel.getData();
        var virtualRoot = data.tree.root;
        var newRoot = seriesModel.getViewRoot();
        var group = this.group;
        var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
        var newChildren = [];
        newRoot.eachNode(function(node) {
            newChildren.push(node);
        });
        var oldChildren = this._oldChildren || [];
        dualTravel(newChildren, oldChildren);
        renderRollUp(virtualRoot, newRoot);
        this._initEvents();
        this._oldChildren = newChildren;
        function dualTravel(newChildren, oldChildren) {
            if (newChildren.length === 0 && oldChildren.length === 0) return;
            new (0, $chf3v.default)(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove($2N6Uo.curry(processNode, null)).execute();
            function getKey(node) {
                return node.getId();
            }
            function processNode(newIdx, oldIdx) {
                var newNode = newIdx == null ? null : newChildren[newIdx];
                var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
                doRenderNode(newNode, oldNode);
            }
        }
        function doRenderNode(newNode, oldNode) {
            if (!renderLabelForZeroData && newNode && !newNode.getValue()) // Not render data with value 0
            newNode = null;
            if (newNode !== virtualRoot && oldNode !== virtualRoot) {
                if (oldNode && oldNode.piece) {
                    if (newNode) {
                        // Update
                        oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api);
                        // For tooltip
                        data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
                    } else // Remove
                    removeNode(oldNode);
                } else if (newNode) {
                    // Add
                    var piece = new (0, $cSqOc.default)(newNode, seriesModel, ecModel, api);
                    group.add(piece);
                    // For tooltip
                    data.setItemGraphicEl(newNode.dataIndex, piece);
                }
            }
        }
        function removeNode(node) {
            if (!node) return;
            if (node.piece) {
                group.remove(node.piece);
                node.piece = null;
            }
        }
        function renderRollUp(virtualRoot, viewRoot) {
            if (viewRoot.depth > 0) {
                // Render
                if (self.virtualPiece) // Update
                self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
                else {
                    // Add
                    self.virtualPiece = new (0, $cSqOc.default)(virtualRoot, seriesModel, ecModel, api);
                    group.add(self.virtualPiece);
                }
                // TODO event scope
                viewRoot.piece.off('click');
                self.virtualPiece.on('click', function(e) {
                    self._rootToNode(viewRoot.parentNode);
                });
            } else if (self.virtualPiece) {
                // Remove
                group.remove(self.virtualPiece);
                self.virtualPiece = null;
            }
        }
    };
    /**
   * @private
   */ SunburstView.prototype._initEvents = function() {
        var _this = this;
        this.group.off('click');
        this.group.on('click', function(e) {
            var targetFound = false;
            var viewRoot = _this.seriesModel.getViewRoot();
            viewRoot.eachNode(function(node) {
                if (!targetFound && node.piece && node.piece === e.target) {
                    var nodeClick = node.getModel().get('nodeClick');
                    if (nodeClick === 'rootToNode') _this._rootToNode(node);
                    else if (nodeClick === 'link') {
                        var itemModel = node.getModel();
                        var link = itemModel.get('link');
                        if (link) {
                            var linkTarget = itemModel.get('target', true) || '_blank';
                            (0, $hrphB.windowOpen)(link, linkTarget);
                        }
                    }
                    targetFound = true;
                }
            });
        });
    };
    /**
   * @private
   */ SunburstView.prototype._rootToNode = function(node) {
        if (node !== this.seriesModel.getViewRoot()) this.api.dispatchAction({
            type: (0, $bufkO.ROOT_TO_NODE_ACTION),
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: node
        });
    };
    /**
   * @implement
   */ SunburstView.prototype.containPoint = function(point, seriesModel) {
        var treeRoot = seriesModel.getData();
        var itemLayout = treeRoot.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    SunburstView.type = 'sunburst';
    return SunburstView;
}((0, $cWIrM.default));
var $391ecd559ab9fbc0$export$2e2bcd8739ae039 = $391ecd559ab9fbc0$var$SunburstView;

});
parcelRegister("cSqOc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95ff52cf95109dad$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $60Kbk = parcelRequire("60Kbk");
var $ipprj = parcelRequire("ipprj");
var $kBKw3 = parcelRequire("kBKw3");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");

var $6TSUP = parcelRequire("6TSUP");

var $erB8T = parcelRequire("erB8T");

var $9gUBZ = parcelRequire("9gUBZ");

var $ipprj = parcelRequire("ipprj");

var $3HvzJ = parcelRequire("3HvzJ");

var $iCU10 = parcelRequire("iCU10");
var $95ff52cf95109dad$var$DEFAULT_SECTOR_Z = 2;
var $95ff52cf95109dad$var$DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 */ var $95ff52cf95109dad$var$SunburstPiece = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SunburstPiece, _super);
    function SunburstPiece(node, seriesModel, ecModel, api) {
        var _this = _super.call(this) || this;
        _this.z2 = $95ff52cf95109dad$var$DEFAULT_SECTOR_Z;
        _this.textConfig = {
            inside: true
        };
        (0, $6TSUP.getECData)(_this).seriesIndex = seriesModel.seriesIndex;
        var text = new $kBKw3.default({
            z2: $95ff52cf95109dad$var$DEFAULT_TEXT_Z,
            silent: node.getModel().get([
                'label',
                'silent'
            ])
        });
        _this.setTextContent(text);
        _this.updateData(true, node, seriesModel, ecModel, api);
        return _this;
    }
    SunburstPiece.prototype.updateData = function(firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
    seriesModel, ecModel, api) {
        this.node = node;
        node.piece = this;
        seriesModel = seriesModel || this._seriesModel;
        ecModel = ecModel || this._ecModel;
        var sector = this;
        (0, $6TSUP.getECData)(sector).dataIndex = node.dataIndex;
        var itemModel = node.getModel();
        var emphasisModel = itemModel.getModel('emphasis');
        var layout = node.getLayout();
        var sectorShape = $2N6Uo.extend({}, layout);
        sectorShape.label = null;
        var normalStyle = node.getVisual('style');
        normalStyle.lineJoin = 'bevel';
        var decal = node.getVisual('decal');
        if (decal) normalStyle.decal = (0, $9gUBZ.createOrUpdatePatternFromDecal)(decal, api);
        var cornerRadius = (0, $erB8T.getSectorCornerRadius)(itemModel.getModel('itemStyle'), sectorShape, true);
        $2N6Uo.extend(sectorShape, cornerRadius);
        $2N6Uo.each((0, $bwPbQ.SPECIAL_STATES), function(stateName) {
            var state = sector.ensureState(stateName);
            var itemStyleModel = itemModel.getModel([
                stateName,
                'itemStyle'
            ]);
            state.style = itemStyleModel.getItemStyle();
            // border radius
            var cornerRadius = (0, $erB8T.getSectorCornerRadius)(itemStyleModel, sectorShape);
            if (cornerRadius) state.shape = cornerRadius;
        });
        if (firstCreate) {
            sector.setShape(sectorShape);
            sector.shape.r = layout.r0;
            $ipprj.initProps(sector, {
                shape: {
                    r: layout.r
                }
            }, seriesModel, node.dataIndex);
        } else {
            // Disable animation for gradient since no interpolation method
            // is supported for gradient
            $ipprj.updateProps(sector, {
                shape: sectorShape
            }, seriesModel);
            (0, $ipprj.saveOldStyle)(sector);
        }
        sector.useStyle(normalStyle);
        this._updateLabel(seriesModel);
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && sector.attr('cursor', cursorStyle);
        this._seriesModel = seriesModel || this._seriesModel;
        this._ecModel = ecModel || this._ecModel;
        var focus = emphasisModel.get('focus');
        var focusOrIndices = focus === 'relative' ? $2N6Uo.concatArray(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : focus;
        (0, $bwPbQ.toggleHoverEmphasis)(this, focusOrIndices, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    SunburstPiece.prototype._updateLabel = function(seriesModel) {
        var _this = this;
        var itemModel = this.node.getModel();
        var normalLabelModel = itemModel.getModel('label');
        var layout = this.node.getLayout();
        var angle = layout.endAngle - layout.startAngle;
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var sector = this;
        var label = sector.getTextContent();
        var dataIndex = this.node.dataIndex;
        var labelMinAngle = normalLabelModel.get('minAngle') / 180 * Math.PI;
        var isNormalShown = normalLabelModel.get('show') && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
        label.ignore = !isNormalShown;
        // TODO use setLabelStyle
        $2N6Uo.each((0, $bwPbQ.DISPLAY_STATES), function(stateName) {
            var labelStateModel = stateName === 'normal' ? itemModel.getModel('label') : itemModel.getModel([
                stateName,
                'label'
            ]);
            var isNormal = stateName === 'normal';
            var state = isNormal ? label : label.ensureState(stateName);
            var text = seriesModel.getFormattedLabel(dataIndex, stateName);
            if (isNormal) text = text || _this.node.name;
            state.style = (0, $bysmE.createTextStyle)(labelStateModel, {}, null, stateName !== 'normal', true);
            if (text) state.style.text = text;
            // Not displaying text when angle is too small
            var isShown = labelStateModel.get('show');
            if (isShown != null && !isNormal) state.ignore = !isShown;
            var labelPosition = getLabelAttr(labelStateModel, 'position');
            var sectorState = isNormal ? sector : sector.states[stateName];
            var labelColor = sectorState.style.fill;
            sectorState.textConfig = {
                outsideFill: labelStateModel.get('color') === 'inherit' ? labelColor : null,
                inside: labelPosition !== 'outside'
            };
            var r;
            var labelPadding = getLabelAttr(labelStateModel, 'distance') || 0;
            var textAlign = getLabelAttr(labelStateModel, 'align');
            var rotateType = getLabelAttr(labelStateModel, 'rotate');
            var flipStartAngle = Math.PI * 0.5;
            var flipEndAngle = Math.PI * 1.5;
            var midAngleNormal = (0, $3HvzJ.normalizeRadian)(rotateType === 'tangential' ? Math.PI / 2 - midAngle : midAngle);
            // For text that is up-side down, rotate 180 degrees to make sure
            // it's readable
            var needsFlip = midAngleNormal > flipStartAngle && !(0, $iCU10.isRadianAroundZero)(midAngleNormal - flipStartAngle) && midAngleNormal < flipEndAngle;
            if (labelPosition === 'outside') {
                r = layout.r + labelPadding;
                textAlign = needsFlip ? 'right' : 'left';
            } else {
                if (!textAlign || textAlign === 'center') {
                    // Put label in the center if it's a circle
                    if (angle === 2 * Math.PI && layout.r0 === 0) r = 0;
                    else r = (layout.r + layout.r0) / 2;
                    textAlign = 'center';
                } else if (textAlign === 'left') {
                    r = layout.r0 + labelPadding;
                    textAlign = needsFlip ? 'right' : 'left';
                } else if (textAlign === 'right') {
                    r = layout.r - labelPadding;
                    textAlign = needsFlip ? 'left' : 'right';
                }
            }
            state.style.align = textAlign;
            state.style.verticalAlign = getLabelAttr(labelStateModel, 'verticalAlign') || 'middle';
            state.x = r * dx + layout.cx;
            state.y = r * dy + layout.cy;
            var rotate = 0;
            if (rotateType === 'radial') rotate = (0, $3HvzJ.normalizeRadian)(-midAngle) + (needsFlip ? Math.PI : 0);
            else if (rotateType === 'tangential') rotate = (0, $3HvzJ.normalizeRadian)(Math.PI / 2 - midAngle) + (needsFlip ? Math.PI : 0);
            else if ($2N6Uo.isNumber(rotateType)) rotate = rotateType * Math.PI / 180;
            state.rotation = (0, $3HvzJ.normalizeRadian)(rotate);
        });
        function getLabelAttr(model, name) {
            var stateAttr = model.get(name);
            if (stateAttr == null) return normalLabelModel.get(name);
            return stateAttr;
        }
        label.dirtyStyle();
    };
    return SunburstPiece;
}($60Kbk.default);
var $95ff52cf95109dad$export$2e2bcd8739ae039 = $95ff52cf95109dad$var$SunburstPiece;

});

parcelRegister("bufkO", function(module, exports) {

$parcel$export(module.exports, "ROOT_TO_NODE_ACTION", function () { return $85ce643139ffa455$export$b06afbbb40399c8b; });
$parcel$export(module.exports, "installSunburstAction", function () { return $85ce643139ffa455$export$d2def111ea616eb3; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");


var $hs88U = parcelRequire("hs88U");
var $85ce643139ffa455$export$b06afbbb40399c8b = 'sunburstRootToNode';
var $85ce643139ffa455$var$HIGHLIGHT_ACTION = 'sunburstHighlight';
var $85ce643139ffa455$var$UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
function $85ce643139ffa455$export$d2def111ea616eb3(registers) {
    registers.registerAction({
        type: $85ce643139ffa455$export$b06afbbb40399c8b,
        update: 'updateView'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sunburst',
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var targetInfo = (0, $hs88U.retrieveTargetInfo)(payload, [
                $85ce643139ffa455$export$b06afbbb40399c8b
            ], model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = (0, $hs88U.aboveViewRoot)(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
    registers.registerAction({
        type: $85ce643139ffa455$var$HIGHLIGHT_ACTION,
        update: 'none'
    }, function(payload, ecModel, api) {
        // Clone
        payload = (0, $2N6Uo.extend)({}, payload);
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sunburst',
            query: payload
        }, handleHighlight);
        function handleHighlight(model) {
            var targetInfo = (0, $hs88U.retrieveTargetInfo)(payload, [
                $85ce643139ffa455$var$HIGHLIGHT_ACTION
            ], model);
            if (targetInfo) payload.dataIndex = targetInfo.node.dataIndex;
        }
        // Fast forward action
        api.dispatchAction((0, $2N6Uo.extend)(payload, {
            type: 'highlight'
        }));
    });
    registers.registerAction({
        type: $85ce643139ffa455$var$UNHIGHLIGHT_ACTION,
        update: 'updateView'
    }, function(payload, ecModel, api) {
        payload = (0, $2N6Uo.extend)({}, payload);
        api.dispatchAction((0, $2N6Uo.extend)(payload, {
            type: 'downplay'
        }));
    });
}

});
parcelRegister("hs88U", function(module, exports) {

$parcel$export(module.exports, "retrieveTargetInfo", function () { return $cb4b5e299da6e7e9$export$c5445fa59c15dec4; });
$parcel$export(module.exports, "getPathToRoot", function () { return $cb4b5e299da6e7e9$export$6be31fe4499506f9; });
$parcel$export(module.exports, "aboveViewRoot", function () { return $cb4b5e299da6e7e9$export$df59de26c77b5bea; });
$parcel$export(module.exports, "wrapTreePathInfo", function () { return $cb4b5e299da6e7e9$export$c5baa480d6ceb0a3; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $cb4b5e299da6e7e9$export$c5445fa59c15dec4(payload, validPayloadTypes, seriesModel) {
    if (payload && $2N6Uo.indexOf(validPayloadTypes, payload.type) >= 0) {
        var root = seriesModel.getData().tree.root;
        var targetNode = payload.targetNode;
        if ($2N6Uo.isString(targetNode)) targetNode = root.getNodeById(targetNode);
        if (targetNode && root.contains(targetNode)) return {
            node: targetNode
        };
        var targetNodeId = payload.targetNodeId;
        if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) return {
            node: targetNode
        };
    }
}
function $cb4b5e299da6e7e9$export$6be31fe4499506f9(node) {
    var path = [];
    while(node){
        node = node.parentNode;
        node && path.push(node);
    }
    return path.reverse();
}
function $cb4b5e299da6e7e9$export$df59de26c77b5bea(viewRoot, node) {
    var viewPath = $cb4b5e299da6e7e9$export$6be31fe4499506f9(viewRoot);
    return $2N6Uo.indexOf(viewPath, node) >= 0;
}
function $cb4b5e299da6e7e9$export$c5baa480d6ceb0a3(node, seriesModel) {
    var treePathInfo = [];
    while(node){
        var nodeDataIndex = node.dataIndex;
        treePathInfo.push({
            name: node.name,
            dataIndex: nodeDataIndex,
            value: seriesModel.getRawValue(nodeDataIndex)
        });
        node = node.parentNode;
    }
    treePathInfo.reverse();
    return treePathInfo;
}

});



parcelRegister("cZMjX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9760aa0ef5a274e9$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $49X8G = parcelRequire("49X8G");

var $4I5kR = parcelRequire("4I5kR");

var $hs88U = parcelRequire("hs88U");

var $b8YKU = parcelRequire("b8YKU");

var $2oq9K = parcelRequire("2oq9K");
var $9760aa0ef5a274e9$var$SunburstSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SunburstSeriesModel, _super);
    function SunburstSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstSeriesModel.type;
        _this.ignoreStyleOnData = true;
        return _this;
    }
    SunburstSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $9760aa0ef5a274e9$var$completeTreeValue(root);
        var levelModels = this._levelModels = $2N6Uo.map(option.levels || [], function(levelDefine) {
            return new (0, $b8YKU.default)(levelDefine, this, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $4I5kR.default).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = levelModels[node.depth];
                levelModel && (model.parentModel = levelModel);
                return model;
            });
        }
        return tree.data;
    };
    SunburstSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /*
   * @override
   */ SunburstSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treePathInfo = (0, $hs88U.wrapTreePathInfo)(node, this);
        return params;
    };
    SunburstSeriesModel.prototype.getLevelModel = function(node) {
        return this._levelModels && this._levelModels[node.depth];
    };
    SunburstSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    SunburstSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    SunburstSeriesModel.prototype.enableAriaDecal = function() {
        (0, $2oq9K.default)(this);
    };
    SunburstSeriesModel.type = 'series.sunburst';
    SunburstSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        radius: [
            0,
            '75%'
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // 'rootToNode', 'link', or false
        nodeClick: 'rootToNode',
        renderLabelForZeroData: false,
        label: {
            // could be: 'radial', 'tangential', or 'none'
            rotate: 'radial',
            show: true,
            opacity: 1,
            // 'left' is for inner side of inside, and 'right' is for outer
            // side for inside
            align: 'center',
            position: 'inside',
            distance: 5,
            silent: true
        },
        itemStyle: {
            borderWidth: 1,
            borderColor: 'white',
            borderType: 'solid',
            shadowBlur: 0,
            shadowColor: 'rgba(0, 0, 0, 0.2)',
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        emphasis: {
            focus: 'descendant'
        },
        blur: {
            itemStyle: {
                opacity: 0.2
            },
            label: {
                opacity: 0.1
            }
        },
        // Animation type can be expansion, scale.
        animationType: 'expansion',
        animationDuration: 1000,
        animationDurationUpdate: 500,
        data: [],
        /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */ sort: 'desc'
    };
    return SunburstSeriesModel;
}((0, $49X8G.default));
function $9760aa0ef5a274e9$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $2N6Uo.each(dataNode.children, function(child) {
        $9760aa0ef5a274e9$var$completeTreeValue(child);
        var childValue = child.value;
        // TODO First value of array must be a number
        $2N6Uo.isArray(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($2N6Uo.isArray(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $2N6Uo.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
var $9760aa0ef5a274e9$export$2e2bcd8739ae039 = $9760aa0ef5a274e9$var$SunburstSeriesModel;

});
parcelRegister("4I5kR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36df68fe64aa3d18$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Tree data structure
 */ 
var $2N6Uo = parcelRequire("2N6Uo");

var $5CKLS = parcelRequire("5CKLS");

var $2kN4z = parcelRequire("2kN4z");

var $59bDW = parcelRequire("59bDW");

var $bx3T8 = parcelRequire("bx3T8");
var $36df68fe64aa3d18$export$2eba8ec3a333fdbb = /** @class */ function() {
    function TreeNode(name, hostTree) {
        this.depth = 0;
        this.height = 0;
        /**
     * Reference to list item.
     * Do not persistent dataIndex outside,
     * besause it may be changed by list.
     * If dataIndex -1,
     * this node is logical deleted (filtered) in list.
     */ this.dataIndex = -1;
        this.children = [];
        this.viewChildren = [];
        this.isExpand = false;
        this.name = name || '';
        this.hostTree = hostTree;
    }
    /**
   * The node is removed.
   */ TreeNode.prototype.isRemoved = function() {
        return this.dataIndex < 0;
    };
    TreeNode.prototype.eachNode = function(options, cb, context) {
        if ($2N6Uo.isFunction(options)) {
            context = cb;
            cb = options;
            options = null;
        }
        options = options || {};
        if ($2N6Uo.isString(options)) options = {
            order: options
        };
        var order = options.order || 'preorder';
        var children = this[options.attr || 'children'];
        var suppressVisitSub;
        order === 'preorder' && (suppressVisitSub = cb.call(context, this));
        for(var i = 0; !suppressVisitSub && i < children.length; i++)children[i].eachNode(options, cb, context);
        order === 'postorder' && cb.call(context, this);
    };
    /**
   * Update depth and height of this subtree.
   */ TreeNode.prototype.updateDepthAndHeight = function(depth) {
        var height = 0;
        this.depth = depth;
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            child.updateDepthAndHeight(depth + 1);
            if (child.height > height) height = child.height;
        }
        this.height = height + 1;
    };
    TreeNode.prototype.getNodeById = function(id) {
        if (this.getId() === id) return this;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].getNodeById(id);
            if (res) return res;
        }
    };
    TreeNode.prototype.contains = function(node) {
        if (node === this) return true;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].contains(node);
            if (res) return res;
        }
    };
    /**
   * @param includeSelf Default false.
   * @return order: [root, child, grandchild, ...]
   */ TreeNode.prototype.getAncestors = function(includeSelf) {
        var ancestors = [];
        var node = includeSelf ? this : this.parentNode;
        while(node){
            ancestors.push(node);
            node = node.parentNode;
        }
        ancestors.reverse();
        return ancestors;
    };
    TreeNode.prototype.getAncestorsIndices = function() {
        var indices = [];
        var currNode = this;
        while(currNode){
            indices.push(currNode.dataIndex);
            currNode = currNode.parentNode;
        }
        indices.reverse();
        return indices;
    };
    TreeNode.prototype.getDescendantIndices = function() {
        var indices = [];
        this.eachNode(function(childNode) {
            indices.push(childNode.dataIndex);
        });
        return indices;
    };
    TreeNode.prototype.getValue = function(dimension) {
        var data = this.hostTree.data;
        return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
    };
    TreeNode.prototype.setLayout = function(layout, merge) {
        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
    };
    /**
   * @return {Object} layout
   */ TreeNode.prototype.getLayout = function() {
        return this.hostTree.data.getItemLayout(this.dataIndex);
    };
    // @depcrecated
    // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TreeNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var hostTree = this.hostTree;
        var itemModel = hostTree.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    // TODO: TYPE More specific model
    TreeNode.prototype.getLevelModel = function() {
        return (this.hostTree.levelModels || [])[this.depth];
    };
    TreeNode.prototype.setVisual = function(key, value) {
        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
    };
    /**
   * Get item visual
   * FIXME: make return type better
   */ TreeNode.prototype.getVisual = function(key) {
        return this.hostTree.data.getItemVisual(this.dataIndex, key);
    };
    TreeNode.prototype.getRawIndex = function() {
        return this.hostTree.data.getRawIndex(this.dataIndex);
    };
    TreeNode.prototype.getId = function() {
        return this.hostTree.data.getId(this.dataIndex);
    };
    /**
   * index in parent's children
   */ TreeNode.prototype.getChildIndex = function() {
        if (this.parentNode) {
            var children = this.parentNode.children;
            for(var i = 0; i < children.length; ++i){
                if (children[i] === this) return i;
            }
            return -1;
        }
        return -1;
    };
    /**
   * if this is an ancestor of another node
   *
   * @param node another node
   * @return if is ancestor
   */ TreeNode.prototype.isAncestorOf = function(node) {
        var parent = node.parentNode;
        while(parent){
            if (parent === this) return true;
            parent = parent.parentNode;
        }
        return false;
    };
    /**
   * if this is an descendant of another node
   *
   * @param node another node
   * @return if is descendant
   */ TreeNode.prototype.isDescendantOf = function(node) {
        return node !== this && node.isAncestorOf(this);
    };
    return TreeNode;
}();
var $36df68fe64aa3d18$var$Tree = /** @class */ function() {
    function Tree(hostModel) {
        this.type = 'tree';
        this._nodes = [];
        this.hostModel = hostModel;
    }
    Tree.prototype.eachNode = function(options, cb, context) {
        this.root.eachNode(options, cb, context);
    };
    Tree.prototype.getNodeByDataIndex = function(dataIndex) {
        var rawIndex = this.data.getRawIndex(dataIndex);
        return this._nodes[rawIndex];
    };
    Tree.prototype.getNodeById = function(name) {
        return this.root.getNodeById(name);
    };
    /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */ Tree.prototype.update = function() {
        var data = this.data;
        var nodes = this._nodes;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
    };
    /**
   * Clear all layouts
   */ Tree.prototype.clearLayouts = function() {
        this.data.clearItemLayouts();
    };
    /**
   * data node format:
   * {
   *     name: ...
   *     value: ...
   *     children: [
   *         {
   *             name: ...
   *             value: ...
   *             children: ...
   *         },
   *         ...
   *     ]
   * }
   */ Tree.createTree = function(dataRoot, hostModel, beforeLink) {
        var tree = new Tree(hostModel);
        var listData = [];
        var dimMax = 1;
        buildHierarchy(dataRoot);
        function buildHierarchy(dataNode, parentNode) {
            var value = dataNode.value;
            dimMax = Math.max(dimMax, $2N6Uo.isArray(value) ? value.length : 1);
            listData.push(dataNode);
            var node = new $36df68fe64aa3d18$export$2eba8ec3a333fdbb((0, $bx3T8.convertOptionIdName)(dataNode.name, ''), tree);
            parentNode ? $36df68fe64aa3d18$var$addChild(node, parentNode) : tree.root = node;
            tree._nodes.push(node);
            var children = dataNode.children;
            if (children) for(var i = 0; i < children.length; i++)buildHierarchy(children[i], node);
        }
        tree.root.updateDepthAndHeight(0);
        var dimensions = (0, $59bDW.default)(listData, {
            coordDimensions: [
                'value'
            ],
            dimensionsCount: dimMax
        }).dimensions;
        var list = new (0, $2kN4z.default)(dimensions, hostModel);
        list.initData(listData);
        beforeLink && beforeLink(list);
        (0, $5CKLS.default)({
            mainData: list,
            struct: tree,
            structAttr: 'tree'
        });
        tree.update();
        return tree;
    };
    return Tree;
}();
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 */ function $36df68fe64aa3d18$var$addChild(child, node) {
    var children = node.children;
    if (child.parentNode === node) return;
    children.push(child);
    child.parentNode = node;
}
var $36df68fe64aa3d18$export$2e2bcd8739ae039 = $36df68fe64aa3d18$var$Tree;

});

parcelRegister("2oq9K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1be21cbc4e7c3566$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1E7rO = parcelRequire("1E7rO");
function $1be21cbc4e7c3566$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    var decalPaletteScope = {};
    tree.eachNode(function(node) {
        // Use decal of level 1 node
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var decal = (0, $1E7rO.getDecalFromPalette)(seriesModel.ecModel, current.name || current.dataIndex + '', decalPaletteScope);
        node.setVisual('decal', decal);
    });
}

});


parcelRegister("85Oik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e45cdd1a11413cb$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");
// let PI2 = Math.PI * 2;
var $5e45cdd1a11413cb$var$RADIAN = Math.PI / 180;
function $5e45cdd1a11413cb$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var center = seriesModel.get('center');
        var radius = seriesModel.get('radius');
        if (!$2N6Uo.isArray(radius)) radius = [
            0,
            radius
        ];
        if (!$2N6Uo.isArray(center)) center = [
            center,
            center
        ];
        var width = api.getWidth();
        var height = api.getHeight();
        var size = Math.min(width, height);
        var cx = (0, $iCU10.parsePercent)(center[0], width);
        var cy = (0, $iCU10.parsePercent)(center[1], height);
        var r0 = (0, $iCU10.parsePercent)(radius[0], size / 2);
        var r = (0, $iCU10.parsePercent)(radius[1], size / 2);
        var startAngle = -seriesModel.get('startAngle') * $5e45cdd1a11413cb$var$RADIAN;
        var minAngle = seriesModel.get('minAngle') * $5e45cdd1a11413cb$var$RADIAN;
        var virtualRoot = seriesModel.getData().tree.root;
        var treeRoot = seriesModel.getViewRoot();
        var rootDepth = treeRoot.depth;
        var sort = seriesModel.get('sort');
        if (sort != null) $5e45cdd1a11413cb$var$initChildren(treeRoot, sort);
        var validDataCount = 0;
        $2N6Uo.each(treeRoot.children, function(child) {
            !isNaN(child.getValue()) && validDataCount++;
        });
        var sum = treeRoot.getValue();
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var renderRollupNode = treeRoot.depth > 0;
        var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
        var rPerLevel = (r - r0) / (levels || 1);
        var clockwise = seriesModel.get('clockwise');
        var stillShowZeroSum = seriesModel.get('stillShowZeroSum');
        // In the case some sector angle is smaller than minAngle
        // let restAngle = PI2;
        // let valueSumLargerThanMinAngle = 0;
        var dir = clockwise ? 1 : -1;
        /**
     * Render a tree
     * @return increased angle
     */ var renderNode = function(node, startAngle) {
            if (!node) return;
            var endAngle = startAngle;
            // Render self
            if (node !== virtualRoot) {
                // Tree node is virtual, so it doesn't need to be drawn
                var value = node.getValue();
                var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
                if (angle < minAngle) angle = minAngle;
                // else {
                //     valueSumLargerThanMinAngle += value;
                // }
                endAngle = startAngle + dir * angle;
                var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
                var rStart = r0 + rPerLevel * depth;
                var rEnd = r0 + rPerLevel * (depth + 1);
                var levelModel = seriesModel.getLevelModel(node);
                if (levelModel) {
                    var r0_1 = levelModel.get('r0', true);
                    var r_1 = levelModel.get('r', true);
                    var radius_1 = levelModel.get('radius', true);
                    if (radius_1 != null) {
                        r0_1 = radius_1[0];
                        r_1 = radius_1[1];
                    }
                    r0_1 != null && (rStart = (0, $iCU10.parsePercent)(r0_1, size / 2));
                    r_1 != null && (rEnd = (0, $iCU10.parsePercent)(r_1, size / 2));
                }
                node.setLayout({
                    angle: angle,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: rStart,
                    r: rEnd
                });
            }
            // Render children
            if (node.children && node.children.length) {
                // currentAngle = startAngle;
                var siblingAngle_1 = 0;
                $2N6Uo.each(node.children, function(node) {
                    siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
                });
            }
            return endAngle - startAngle;
        };
        // Virtual root node for roll up
        if (renderRollupNode) {
            var rStart = r0;
            var rEnd = r0 + rPerLevel;
            var angle = Math.PI * 2;
            virtualRoot.setLayout({
                angle: angle,
                startAngle: startAngle,
                endAngle: startAngle + angle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: rStart,
                r: rEnd
            });
        }
        renderNode(treeRoot, startAngle);
    });
}
/**
 * Init node children by order and update visual
 */ function $5e45cdd1a11413cb$var$initChildren(node, sortOrder) {
    var children = node.children || [];
    node.children = $5e45cdd1a11413cb$var$sort(children, sortOrder);
    // Init children recursively
    if (children.length) $2N6Uo.each(node.children, function(child) {
        $5e45cdd1a11413cb$var$initChildren(child, sortOrder);
    });
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */ function $5e45cdd1a11413cb$var$sort(children, sortOrder) {
    if ($2N6Uo.isFunction(sortOrder)) {
        var sortTargets = $2N6Uo.map(children, function(child, idx) {
            var value = child.getValue();
            return {
                params: {
                    depth: child.depth,
                    height: child.height,
                    dataIndex: child.dataIndex,
                    getValue: function() {
                        return value;
                    }
                },
                index: idx
            };
        });
        sortTargets.sort(function(a, b) {
            return sortOrder(a.params, b.params);
        });
        return $2N6Uo.map(sortTargets, function(target) {
            return children[target.index];
        });
    } else {
        var isAsc_1 = sortOrder === 'asc';
        return children.sort(function(a, b) {
            var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
            return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
        });
    }
}

});

parcelRegister("HfOtG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0820486e5044320a$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3UxDF = parcelRequire("3UxDF");

var $2N6Uo = parcelRequire("2N6Uo");

var $6aXXD = parcelRequire("6aXXD");
function $0820486e5044320a$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    // Default color strategy
    function pickColor(node, seriesModel, treeHeight) {
        if (node.depth === 0) // Don't use palette color for the root node, because it's displayed only when drilling down.
        return (0, $6aXXD.default).color.neutral50;
        // Choose color from palette based on the first level.
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + '', paletteScope);
        if (node.depth > 1 && (0, $2N6Uo.isString)(color)) // Lighter on the deeper level.
        color = (0, $3UxDF.lift)(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
        return color;
    }
    ecModel.eachSeriesByType('sunburst', function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            var style = model.getModel('itemStyle').getItemStyle();
            if (!style.fill) style.fill = pickColor(node, seriesModel, tree.root.height);
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
            (0, $2N6Uo.extend)(existsStyle, style);
        });
    });
}

});


parcelRegister("acrul", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $76d05904861a7d2b$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $6Ewxm = parcelRequire("6Ewxm");

var $2tTFC = parcelRequire("2tTFC");

var $gwKyP = parcelRequire("gwKyP");

var $impUY = parcelRequire("impUY");
function $76d05904861a7d2b$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $6Ewxm.default));
    registers.registerSeriesModel((0, $2tTFC.default));
    registers.registerLayout((0, $gwKyP.default));
    registers.registerProcessor((0, $impUY.default)('themeRiver'));
}

});
parcelRegister("6Ewxm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d7fb7b4b647f09c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $4Wbqa = parcelRequire("4Wbqa");

var $iQonF = parcelRequire("iQonF");
var $ipprj = parcelRequire("ipprj");parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");
var $ipprj = parcelRequire("ipprj");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");

var $2N6Uo = parcelRequire("2N6Uo");

var $chf3v = parcelRequire("chf3v");

var $cWIrM = parcelRequire("cWIrM");

var $ipprj = parcelRequire("ipprj");
var $4d7fb7b4b647f09c$var$ThemeRiverView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ThemeRiverView, _super);
    function ThemeRiverView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverView.type;
        _this._layers = [];
        return _this;
    }
    ThemeRiverView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var self = this;
        var group = this.group;
        var layersSeries = seriesModel.getLayerSeries();
        var layoutInfo = data.getLayout('layoutInfo');
        var rect = layoutInfo.rect;
        var boundaryGap = layoutInfo.boundaryGap;
        group.x = 0;
        group.y = rect.y + boundaryGap[0];
        function keyGetter(item) {
            return item.name;
        }
        var dataDiffer = new (0, $chf3v.default)(this._layersSeries || [], layersSeries, keyGetter, keyGetter);
        var newLayersGroups = [];
        dataDiffer.add((0, $2N6Uo.bind)(process, this, 'add')).update((0, $2N6Uo.bind)(process, this, 'update')).remove((0, $2N6Uo.bind)(process, this, 'remove')).execute();
        function process(status, idx, oldIdx) {
            var oldLayersGroups = self._layers;
            if (status === 'remove') {
                group.remove(oldLayersGroups[idx]);
                return;
            }
            var points0 = [];
            var points1 = [];
            var style;
            var indices = layersSeries[idx].indices;
            var j = 0;
            for(; j < indices.length; j++){
                var layout = data.getItemLayout(indices[j]);
                var x = layout.x;
                var y0 = layout.y0;
                var y = layout.y;
                points0.push(x, y0);
                points1.push(x, y0 + y);
                style = data.getItemVisual(indices[j], 'style');
            }
            var polygon;
            var textLayout = data.getItemLayout(indices[0]);
            var labelModel = seriesModel.getModel('label');
            var margin = labelModel.get('margin');
            var emphasisModel = seriesModel.getModel('emphasis');
            if (status === 'add') {
                var layerGroup = newLayersGroups[idx] = new $iQonF.default();
                polygon = new (0, $4Wbqa.ECPolygon)({
                    shape: {
                        points: points0,
                        stackedOnPoints: points1,
                        smooth: 0.4,
                        stackedOnSmooth: 0.4,
                        smoothConstraint: false
                    },
                    z2: 0
                });
                layerGroup.add(polygon);
                group.add(layerGroup);
                if (seriesModel.isAnimationEnabled()) polygon.setClipPath($4d7fb7b4b647f09c$var$createGridClipShape(polygon.getBoundingRect(), seriesModel, function() {
                    polygon.removeClipPath();
                }));
            } else {
                var layerGroup = oldLayersGroups[oldIdx];
                polygon = layerGroup.childAt(0);
                group.add(layerGroup);
                newLayersGroups[idx] = layerGroup;
                $ipprj.updateProps(polygon, {
                    shape: {
                        points: points0,
                        stackedOnPoints: points1
                    }
                }, seriesModel);
                (0, $ipprj.saveOldStyle)(polygon);
            }
            (0, $bysmE.setLabelStyle)(polygon, (0, $bysmE.getLabelStatesModels)(seriesModel), {
                labelDataIndex: indices[j - 1],
                defaultText: data.getName(indices[j - 1]),
                inheritColor: style.fill
            }, {
                normal: {
                    verticalAlign: 'middle'
                }
            });
            polygon.setTextConfig({
                position: null,
                local: true
            });
            var labelEl = polygon.getTextContent();
            // TODO More label position options.
            if (labelEl) {
                labelEl.x = textLayout.x - margin;
                labelEl.y = textLayout.y0 + textLayout.y / 2;
            }
            polygon.useStyle(style);
            data.setItemGraphicEl(idx, polygon);
            (0, $bwPbQ.setStatesStylesFromModel)(polygon, seriesModel);
            (0, $bwPbQ.toggleHoverEmphasis)(polygon, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        }
        this._layersSeries = layersSeries;
        this._layers = newLayersGroups;
    };
    ThemeRiverView.type = 'themeRiver';
    return ThemeRiverView;
}((0, $cWIrM.default));
// add animation to the view
function $4d7fb7b4b647f09c$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $aH2k0.default({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $ipprj.initProps(rectEl, {
        shape: {
            x: rect.x - 50,
            width: rect.width + 100,
            height: rect.height + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $4d7fb7b4b647f09c$export$2e2bcd8739ae039 = $4d7fb7b4b647f09c$var$ThemeRiverView;

});

parcelRegister("2tTFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ce9792a6519db35$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $59bDW = parcelRequire("59bDW");

var $fmOlY = parcelRequire("fmOlY");

var $2kN4z = parcelRequire("2kN4z");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $jP9NX = parcelRequire("jP9NX");

var $5KdhI = parcelRequire("5KdhI");
var $1ce9792a6519db35$var$DATA_NAME_INDEX = 2;
var $1ce9792a6519db35$var$ThemeRiverSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ThemeRiverSeriesModel, _super);
    function ThemeRiverSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverSeriesModel.type;
        return _this;
    }
    /**
   * @override
   */ ThemeRiverSeriesModel.prototype.init = function(option) {
        // eslint-disable-next-line
        _super.prototype.init.apply(this, arguments);
        // Put this function here is for the sake of consistency of code style.
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $jP9NX.default)($2N6Uo.bind(this.getData, this), $2N6Uo.bind(this.getRawData, this));
    };
    /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */ ThemeRiverSeriesModel.prototype.fixData = function(data) {
        var rawDataLength = data.length;
        /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */ var timeValueKeys = {};
        // grouped data by name
        var groupResult = (0, $bx3T8.groupData)(data, function(item) {
            if (!timeValueKeys.hasOwnProperty(item[0] + '')) timeValueKeys[item[0] + ''] = -1;
            return item[2];
        });
        var layerData = [];
        groupResult.buckets.each(function(items, key) {
            layerData.push({
                name: key,
                dataList: items
            });
        });
        var layerNum = layerData.length;
        for(var k = 0; k < layerNum; ++k){
            var name_1 = layerData[k].name;
            for(var j = 0; j < layerData[k].dataList.length; ++j){
                var timeValue = layerData[k].dataList[j][0] + '';
                timeValueKeys[timeValue] = k;
            }
            for(var timeValue in timeValueKeys)if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
                timeValueKeys[timeValue] = k;
                data[rawDataLength] = [
                    timeValue,
                    0,
                    name_1
                ];
                rawDataLength++;
            }
        }
        return data;
    };
    /**
   * @override
   * @param  option  the initial option that user gave
   * @param  ecModel  the model object for themeRiver option
   */ ThemeRiverSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var singleAxisModel = this.getReferringComponents('singleAxis', (0, $bx3T8.SINGLE_REFERRING)).models[0];
        var axisType = singleAxisModel.get('type');
        // filter the data item with the value of label is undefined
        var filterData = $2N6Uo.filter(option.data, function(dataItem) {
            return dataItem[2] !== undefined;
        });
        // ??? TODO design a stage to transfer data for themeRiver and lines?
        var data = this.fixData(filterData || []);
        var nameList = [];
        var nameMap = this.nameMap = $2N6Uo.createHashMap();
        var count = 0;
        for(var i = 0; i < data.length; ++i){
            nameList.push(data[i][$1ce9792a6519db35$var$DATA_NAME_INDEX]);
            if (!nameMap.get(data[i][$1ce9792a6519db35$var$DATA_NAME_INDEX])) {
                nameMap.set(data[i][$1ce9792a6519db35$var$DATA_NAME_INDEX], count);
                count++;
            }
        }
        var dimensions = (0, $59bDW.default)(data, {
            coordDimensions: [
                'single'
            ],
            dimensionsDefine: [
                {
                    name: 'time',
                    type: (0, $fmOlY.getDimensionTypeByAxis)(axisType)
                },
                {
                    name: 'value',
                    type: 'float'
                },
                {
                    name: 'name',
                    type: 'ordinal'
                }
            ],
            encodeDefine: {
                single: 0,
                value: 1,
                itemName: 2
            }
        }).dimensions;
        var list = new (0, $2kN4z.default)(dimensions, this);
        list.initData(data);
        return list;
    };
    /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   */ ThemeRiverSeriesModel.prototype.getLayerSeries = function() {
        var data = this.getData();
        var lenCount = data.count();
        var indexArr = [];
        for(var i = 0; i < lenCount; ++i)indexArr[i] = i;
        var timeDim = data.mapDimension('single');
        // data group by name
        var groupResult = (0, $bx3T8.groupData)(indexArr, function(index) {
            return data.get('name', index);
        });
        var layerSeries = [];
        groupResult.buckets.each(function(items, key) {
            items.sort(function(index1, index2) {
                return data.get(timeDim, index1) - data.get(timeDim, index2);
            });
            layerSeries.push({
                name: key,
                indices: items
            });
        });
        return layerSeries;
    };
    /**
   * Get data indices for show tooltip content
   */ ThemeRiverSeriesModel.prototype.getAxisTooltipData = function(dim, value, baseAxis) {
        if (!$2N6Uo.isArray(dim)) dim = dim ? [
            dim
        ] : [];
        var data = this.getData();
        var layerSeries = this.getLayerSeries();
        var indices = [];
        var layerNum = layerSeries.length;
        var nestestValue;
        for(var i = 0; i < layerNum; ++i){
            var minDist = Number.MAX_VALUE;
            var nearestIdx = -1;
            var pointNum = layerSeries[i].indices.length;
            for(var j = 0; j < pointNum; ++j){
                var theValue = data.get(dim[0], layerSeries[i].indices[j]);
                var dist = Math.abs(theValue - value);
                if (dist <= minDist) {
                    nestestValue = theValue;
                    minDist = dist;
                    nearestIdx = layerSeries[i].indices[j];
                }
            }
            indices.push(nearestIdx);
        }
        return {
            dataIndices: indices,
            nestestValue: nestestValue
        };
    };
    ThemeRiverSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var name = data.getName(dataIndex);
        var value = data.get(data.mapDimension('value'), dataIndex);
        return (0, $5KdhI.createTooltipMarkup)('nameValue', {
            name: name,
            value: value
        });
    };
    ThemeRiverSeriesModel.type = 'series.themeRiver';
    ThemeRiverSeriesModel.dependencies = [
        'singleAxis'
    ];
    ThemeRiverSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        coordinateSystem: 'singleAxis',
        // gap in axis's orthogonal orientation
        boundaryGap: [
            '10%',
            '10%'
        ],
        // legendHoverLink: true,
        singleAxisIndex: 0,
        animationEasing: 'linear',
        label: {
            margin: 4,
            show: true,
            position: 'left',
            fontSize: 11
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return ThemeRiverSeriesModel;
}((0, $49X8G.default));
var $1ce9792a6519db35$export$2e2bcd8739ae039 = $1ce9792a6519db35$var$ThemeRiverSeriesModel;

});

parcelRegister("gwKyP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c083c082dc44632f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");
function $c083c082dc44632f$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('themeRiver', function(seriesModel) {
        var data = seriesModel.getData();
        var single = seriesModel.coordinateSystem;
        var layoutInfo = {};
        // use the axis boundingRect for view
        var rect = single.getRect();
        layoutInfo.rect = rect;
        var boundaryGap = seriesModel.get('boundaryGap');
        var axis = single.getAxis();
        layoutInfo.boundaryGap = boundaryGap;
        if (axis.orient === 'horizontal') {
            boundaryGap[0] = $iCU10.parsePercent(boundaryGap[0], rect.height);
            boundaryGap[1] = $iCU10.parsePercent(boundaryGap[1], rect.height);
            var height = rect.height - boundaryGap[0] - boundaryGap[1];
            $c083c082dc44632f$var$doThemeRiverLayout(data, seriesModel, height);
        } else {
            boundaryGap[0] = $iCU10.parsePercent(boundaryGap[0], rect.width);
            boundaryGap[1] = $iCU10.parsePercent(boundaryGap[1], rect.width);
            var width = rect.width - boundaryGap[0] - boundaryGap[1];
            $c083c082dc44632f$var$doThemeRiverLayout(data, seriesModel, width);
        }
        data.setLayout('layoutInfo', layoutInfo);
    });
}
/**
 * The layout information about themeriver
 *
 * @param data  data in the series
 * @param seriesModel  the model object of themeRiver series
 * @param height  value used to compute every series height
 */ function $c083c082dc44632f$var$doThemeRiverLayout(data, seriesModel, height) {
    if (!data.count()) return;
    var coordSys = seriesModel.coordinateSystem;
    // the data in each layer are organized into a series.
    var layerSeries = seriesModel.getLayerSeries();
    // the points in each layer.
    var timeDim = data.mapDimension('single');
    var valueDim = data.mapDimension('value');
    var layerPoints = $2N6Uo.map(layerSeries, function(singleLayer) {
        return $2N6Uo.map(singleLayer.indices, function(idx) {
            var pt = coordSys.dataToPoint(data.get(timeDim, idx));
            pt[1] = data.get(valueDim, idx);
            return pt;
        });
    });
    var base = $c083c082dc44632f$var$computeBaseline(layerPoints);
    var baseLine = base.y0;
    var ky = height / base.max;
    // set layout information for each item.
    var n = layerSeries.length;
    var m = layerSeries[0].indices.length;
    var baseY0;
    for(var j = 0; j < m; ++j){
        baseY0 = baseLine[j] * ky;
        data.setItemLayout(layerSeries[0].indices[j], {
            layerIndex: 0,
            x: layerPoints[0][j][0],
            y0: baseY0,
            y: layerPoints[0][j][1] * ky
        });
        for(var i = 1; i < n; ++i){
            baseY0 += layerPoints[i - 1][j][1] * ky;
            data.setItemLayout(layerSeries[i].indices[j], {
                layerIndex: i,
                x: layerPoints[i][j][0],
                y0: baseY0,
                y: layerPoints[i][j][1] * ky
            });
        }
    }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  data  the points in each layer
 */ function $c083c082dc44632f$var$computeBaseline(data) {
    var layerNum = data.length;
    var pointNum = data[0].length;
    var sums = [];
    var y0 = [];
    var max = 0;
    for(var i = 0; i < pointNum; ++i){
        var temp = 0;
        for(var j = 0; j < layerNum; ++j)temp += data[j][i][1];
        if (temp > max) max = temp;
        sums.push(temp);
    }
    for(var k = 0; k < pointNum; ++k)y0[k] = (max - sums[k]) / 2;
    max = 0;
    for(var l = 0; l < pointNum; ++l){
        var sum = sums[l] + y0[l];
        if (sum > max) max = sum;
    }
    return {
        y0: y0,
        max: max
    };
}

});


parcelRegister("3uFX3", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $28b4b726fedea40c$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fNlod = parcelRequire("fNlod");

var $cFzb2 = parcelRequire("cFzb2");

var $lPt5y = parcelRequire("lPt5y");

var $90rB0 = parcelRequire("90rB0");

var $2XJkx = parcelRequire("2XJkx");
function $28b4b726fedea40c$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $fNlod.default));
    registers.registerSeriesModel((0, $cFzb2.default));
    registers.registerLayout((0, $lPt5y.default));
    registers.registerVisual((0, $90rB0.default));
    (0, $2XJkx.installTreeAction)(registers);
}

});
parcelRegister("fNlod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7fc0628a7967c46$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");
parcelRequire("h9U3p");
var $1y8oO = parcelRequire("1y8oO");
var $ipprj = parcelRequire("ipprj");
var $iQonF = parcelRequire("iQonF");
var $ipprj = parcelRequire("ipprj");

var $6TSUP = parcelRequire("6TSUP");

var $cWCFS = parcelRequire("cWCFS");

var $1ekzq = parcelRequire("1ekzq");

var $kK0Aj = parcelRequire("kK0Aj");

var $11tae = parcelRequire("11tae");

var $kc4jZ = parcelRequire("kc4jZ");

var $ic6Qi = parcelRequire("ic6Qi");

var $iCU10 = parcelRequire("iCU10");

var $cWIrM = parcelRequire("cWIrM");

var $4oDJM = parcelRequire("4oDJM");

var $bwPbQ = parcelRequire("bwPbQ");

var $6aXXD = parcelRequire("6aXXD");
var $b7fc0628a7967c46$var$TreeEdgeShape = /** @class */ function() {
    function TreeEdgeShape() {
        this.parentPoint = [];
        this.childPoints = [];
    }
    return TreeEdgeShape;
}();
var $b7fc0628a7967c46$var$TreePath = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TreePath, _super);
    function TreePath(opts) {
        return _super.call(this, opts) || this;
    }
    TreePath.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $6aXXD.default).color.neutral99,
            fill: null
        };
    };
    TreePath.prototype.getDefaultShape = function() {
        return new $b7fc0628a7967c46$var$TreeEdgeShape();
    };
    TreePath.prototype.buildPath = function(ctx, shape) {
        var childPoints = shape.childPoints;
        var childLen = childPoints.length;
        var parentPoint = shape.parentPoint;
        var firstChildPos = childPoints[0];
        var lastChildPos = childPoints[childLen - 1];
        if (childLen === 1) {
            ctx.moveTo(parentPoint[0], parentPoint[1]);
            ctx.lineTo(firstChildPos[0], firstChildPos[1]);
            return;
        }
        var orient = shape.orient;
        var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
        var otherDim = 1 - forkDim;
        var forkPosition = (0, $iCU10.parsePercent)(shape.forkPosition, 1);
        var tmpPoint = [];
        tmpPoint[forkDim] = parentPoint[forkDim];
        tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
        ctx.moveTo(parentPoint[0], parentPoint[1]);
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.moveTo(firstChildPos[0], firstChildPos[1]);
        tmpPoint[forkDim] = firstChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        tmpPoint[forkDim] = lastChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.lineTo(lastChildPos[0], lastChildPos[1]);
        for(var i = 1; i < childLen - 1; i++){
            var point = childPoints[i];
            ctx.moveTo(point[0], point[1]);
            tmpPoint[forkDim] = point[forkDim];
            ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        }
    };
    return TreePath;
}((0, $4oDJM.default));
var $b7fc0628a7967c46$var$TreeView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TreeView, _super);
    function TreeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreeView.type;
        _this._mainGroup = new $iQonF.default();
        return _this;
    }
    TreeView.prototype.init = function(ecModel, api) {
        this._controller = new (0, $ic6Qi.default)(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    };
    TreeView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var layoutInfo = seriesModel.layoutInfo;
        var group = this._mainGroup;
        var layout = seriesModel.get('layout');
        if (layout === 'radial') {
            group.x = layoutInfo.x + layoutInfo.width / 2;
            group.y = layoutInfo.y + layoutInfo.height / 2;
        } else {
            group.x = layoutInfo.x;
            group.y = layoutInfo.y;
        }
        this._updateViewCoordSys(seriesModel, api);
        this._updateController(seriesModel, null, ecModel, api);
        var oldData = this._data;
        data.diff(oldData).add(function(newIdx) {
            if ($b7fc0628a7967c46$var$symbolNeedsDraw(data, newIdx)) // Create node and edge
            $b7fc0628a7967c46$var$updateNode(data, newIdx, null, group, seriesModel);
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            if (!$b7fc0628a7967c46$var$symbolNeedsDraw(data, newIdx)) {
                symbolEl && $b7fc0628a7967c46$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
                return;
            }
            // Update node and edge
            $b7fc0628a7967c46$var$updateNode(data, newIdx, symbolEl, group, seriesModel);
        }).remove(function(oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // When remove a collapsed node of subtree, since the collapsed
            // node haven't been initialized with a symbol element,
            // you can't found it's symbol element through index.
            // so if we want to remove the symbol element we should insure
            // that the symbol element is not null.
            if (symbolEl) $b7fc0628a7967c46$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
        }).execute();
        this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
        this._updateNodeAndLinkScale(seriesModel);
        if (seriesModel.get('expandAndCollapse') === true) data.eachItemGraphicEl(function(el, dataIndex) {
            el.off('click').on('click', function() {
                api.dispatchAction({
                    type: 'treeExpandAndCollapse',
                    seriesId: seriesModel.id,
                    dataIndex: dataIndex
                });
            });
        });
        this._data = data;
    };
    TreeView.prototype._updateViewCoordSys = function(seriesModel, api) {
        var data = seriesModel.getData();
        var points = [];
        data.each(function(idx) {
            var layout = data.getItemLayout(idx);
            if (layout && !isNaN(layout.x) && !isNaN(layout.y)) points.push([
                +layout.x,
                +layout.y
            ]);
        });
        var min = [];
        var max = [];
        $kK0Aj.fromPoints(points, min, max);
        // If don't Store min max when collapse the root node after roam,
        // the root node will disappear.
        var oldMin = this._min;
        var oldMax = this._max;
        // If width or height is 0
        if (max[0] - min[0] === 0) {
            min[0] = oldMin ? oldMin[0] : min[0] - 1;
            max[0] = oldMax ? oldMax[0] : max[0] + 1;
        }
        if (max[1] - min[1] === 0) {
            min[1] = oldMin ? oldMin[1] : min[1] - 1;
            max[1] = oldMax ? oldMax[1] : max[1] + 1;
        }
        var viewCoordSys = seriesModel.coordinateSystem = new (0, $11tae.default)(null, {
            api: api,
            ecModel: seriesModel.ecModel
        });
        viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
        viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        viewCoordSys.setCenter(seriesModel.get('center'));
        viewCoordSys.setZoom(seriesModel.get('zoom'));
        // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group,
        // and 'treeRoam' action.
        this.group.attr({
            x: viewCoordSys.x,
            y: viewCoordSys.y,
            scaleX: viewCoordSys.scaleX,
            scaleY: viewCoordSys.scaleY
        });
        this._min = min;
        this._max = max;
    };
    TreeView.prototype._updateController = function(seriesModel, clipRect, ecModel, api) {
        var _this = this;
        $kc4jZ.updateController(seriesModel, api, this.group, this._controller, this._controllerHost, clipRect);
        this._controller.on('zoom', function(e) {
            _this._updateNodeAndLinkScale(seriesModel);
        });
    };
    TreeView.prototype._updateNodeAndLinkScale = function(seriesModel) {
        var data = seriesModel.getData();
        var nodeScale = this._getNodeGlobalScale(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el.setSymbolScale(nodeScale);
        });
    };
    TreeView.prototype._getNodeGlobalScale = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type !== 'view') return 1;
        var nodeScaleRatio = this._nodeScaleRatio;
        var groupZoom = coordSys.scaleX || 1;
        // Scale node when zoom changes
        var roamZoom = coordSys.getZoom();
        var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
        return nodeScale / groupZoom;
    };
    TreeView.prototype.dispose = function() {
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    TreeView.prototype.remove = function() {
        this._mainGroup.removeAll();
        this._data = null;
    };
    TreeView.type = 'tree';
    return TreeView;
}((0, $cWIrM.default));
function $b7fc0628a7967c46$var$symbolNeedsDraw(data, dataIndex) {
    var layout = data.getItemLayout(dataIndex);
    return layout && !isNaN(layout.x) && !isNaN(layout.y);
}
function $b7fc0628a7967c46$var$updateNode(data, dataIndex, symbolEl, group, seriesModel) {
    var isInit = !symbolEl;
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var itemModel = node.getModel();
    var visualColor = node.getVisual('style').fill;
    var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : (0, $6aXXD.default).color.neutral00;
    var virtualRoot = data.tree.root;
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceLayout = source.getLayout();
    var sourceOldLayout = sourceSymbolEl ? {
        x: sourceSymbolEl.__oldX,
        y: sourceSymbolEl.__oldY,
        rawX: sourceSymbolEl.__radialOldRawX,
        rawY: sourceSymbolEl.__radialOldRawY
    } : sourceLayout;
    var targetLayout = node.getLayout();
    if (isInit) {
        symbolEl = new (0, $cWCFS.default)(data, dataIndex, null, {
            symbolInnerColor: symbolInnerColor,
            useNameLabel: true
        });
        symbolEl.x = sourceOldLayout.x;
        symbolEl.y = sourceOldLayout.y;
    } else symbolEl.updateData(data, dataIndex, null, {
        symbolInnerColor: symbolInnerColor,
        useNameLabel: true
    });
    symbolEl.__radialOldRawX = symbolEl.__radialRawX;
    symbolEl.__radialOldRawY = symbolEl.__radialRawY;
    symbolEl.__radialRawX = targetLayout.rawX;
    symbolEl.__radialRawY = targetLayout.rawY;
    group.add(symbolEl);
    data.setItemGraphicEl(dataIndex, symbolEl);
    symbolEl.__oldX = symbolEl.x;
    symbolEl.__oldY = symbolEl.y;
    $ipprj.updateProps(symbolEl, {
        x: targetLayout.x,
        y: targetLayout.y
    }, seriesModel);
    var symbolPath = symbolEl.getSymbolPath();
    if (seriesModel.get('layout') === 'radial') {
        var realRoot = virtualRoot.children[0];
        var rootLayout = realRoot.getLayout();
        var length_1 = realRoot.children.length;
        var rad = void 0;
        var isLeft = void 0;
        if (targetLayout.x === rootLayout.x && node.isExpand === true && realRoot.children.length) {
            var center = {
                x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
                y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
            };
            rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            isLeft = center.x < rootLayout.x;
            if (isLeft) rad = rad - Math.PI;
        } else {
            rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
                isLeft = targetLayout.x < rootLayout.x;
                if (isLeft) rad = rad - Math.PI;
            } else {
                isLeft = targetLayout.x > rootLayout.x;
                if (!isLeft) rad = rad - Math.PI;
            }
        }
        var textPosition = isLeft ? 'left' : 'right';
        var normalLabelModel = itemModel.getModel('label');
        var rotate = normalLabelModel.get('rotate');
        var labelRotateRadian = rotate * (Math.PI / 180);
        var textContent = symbolPath.getTextContent();
        if (textContent) {
            symbolPath.setTextConfig({
                position: normalLabelModel.get('position') || textPosition,
                rotation: rotate == null ? -rad : labelRotateRadian,
                origin: 'center'
            });
            textContent.setStyle('verticalAlign', 'middle');
        }
    }
    // Handle status
    var focus = itemModel.get([
        'emphasis',
        'focus'
    ]);
    var focusDataIndices = focus === 'relative' ? $2N6Uo.concatArray(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : null;
    if (focusDataIndices) // Modify the focus to data indices.
    (0, $6TSUP.getECData)(symbolEl).focus = focusDataIndices;
    $b7fc0628a7967c46$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);
    if (symbolEl.__edge) symbolEl.onHoverStateChange = function(toState) {
        if (toState !== 'blur') {
            // NOTE: Ensure the parent elements will been blurred firstly.
            // According to the return of getAncestorsIndices and getDescendantIndices
            // TODO: A bit tricky.
            var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);
            if (!(parentEl && parentEl.hoverState === (0, $bwPbQ.HOVER_STATE_BLUR))) (0, $bwPbQ.setStatesFlag)(symbolEl.__edge, toState);
        }
    };
}
function $b7fc0628a7967c46$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
    var itemModel = node.getModel();
    var edgeShape = seriesModel.get('edgeShape');
    var layout = seriesModel.get('layout');
    var orient = seriesModel.getOrient();
    var curvature = seriesModel.get([
        'lineStyle',
        'curveness'
    ]);
    var edgeForkPosition = seriesModel.get('edgeForkPosition');
    var lineStyle = itemModel.getModel('lineStyle').getLineStyle();
    var edge = symbolEl.__edge;
    // curve edge from node -> parent
    // polyline edge from node -> children
    if (edgeShape === 'curve') {
        if (node.parentNode && node.parentNode !== virtualRoot) {
            if (!edge) edge = symbolEl.__edge = new $1y8oO.default({
                shape: $b7fc0628a7967c46$var$getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
            });
            $ipprj.updateProps(edge, {
                shape: $b7fc0628a7967c46$var$getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
            }, seriesModel);
        }
    } else if (edgeShape === 'polyline') {
        if (layout === 'orthogonal') {
            if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
                var children = node.children;
                var childPoints = [];
                for(var i = 0; i < children.length; i++){
                    var childLayout = children[i].getLayout();
                    childPoints.push([
                        childLayout.x,
                        childLayout.y
                    ]);
                }
                if (!edge) edge = symbolEl.__edge = new $b7fc0628a7967c46$var$TreePath({
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: [
                            [
                                targetLayout.x,
                                targetLayout.y
                            ]
                        ],
                        orient: orient,
                        forkPosition: edgeForkPosition
                    }
                });
                $ipprj.updateProps(edge, {
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: childPoints
                    }
                }, seriesModel);
            }
        }
    }
    // show all edge when edgeShape is 'curve', filter node `isExpand` is false when edgeShape is 'polyline'
    if (edge && !(edgeShape === 'polyline' && !node.isExpand)) {
        edge.useStyle($2N6Uo.defaults({
            strokeNoScale: true,
            fill: null
        }, lineStyle));
        (0, $bwPbQ.setStatesStylesFromModel)(edge, itemModel, 'lineStyle');
        (0, $bwPbQ.setDefaultStateProxy)(edge);
        group.add(edge);
    }
}
function $b7fc0628a7967c46$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
    var virtualRoot = data.tree.root;
    var _a = $b7fc0628a7967c46$var$getSourceNode(virtualRoot, node), source = _a.source, sourceLayout = _a.sourceLayout;
    var symbolEl = data.getItemGraphicEl(node.dataIndex);
    if (!symbolEl) return;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceEdge = sourceSymbolEl.__edge;
    // 1. when expand the sub tree, delete the children node should delete the edge of
    // the source at the same time. because the polyline edge shape is only owned by the source.
    // 2.when the node is the only children of the source, delete the node should delete the edge of
    // the source at the same time. the same reason as above.
    var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
    var edgeShape = seriesModel.get('edgeShape');
    var layoutOpt = seriesModel.get('layout');
    var orient = seriesModel.get('orient');
    var curvature = seriesModel.get([
        'lineStyle',
        'curveness'
    ]);
    if (edge) {
        if (edgeShape === 'curve') $ipprj.removeElement(edge, {
            shape: $b7fc0628a7967c46$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
        else if (edgeShape === 'polyline' && seriesModel.get('layout') === 'orthogonal') $ipprj.removeElement(edge, {
            shape: {
                parentPoint: [
                    sourceLayout.x,
                    sourceLayout.y
                ],
                childPoints: [
                    [
                        sourceLayout.x,
                        sourceLayout.y
                    ]
                ]
            },
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
    }
}
function $b7fc0628a7967c46$var$getSourceNode(virtualRoot, node) {
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceLayout;
    while(sourceLayout = source.getLayout(), sourceLayout == null)source = source.parentNode === virtualRoot ? source : source.parentNode || source;
    return {
        source: source,
        sourceLayout: sourceLayout
    };
}
function $b7fc0628a7967c46$var$removeNode(data, dataIndex, symbolEl, group, seriesModel) {
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var virtualRoot = data.tree.root;
    var sourceLayout = $b7fc0628a7967c46$var$getSourceNode(virtualRoot, node).sourceLayout;
    // Use same duration and easing with update to have more consistent animation.
    var removeAnimationOpt = {
        duration: seriesModel.get('animationDurationUpdate'),
        easing: seriesModel.get('animationEasingUpdate')
    };
    $ipprj.removeElement(symbolEl, {
        x: sourceLayout.x + 1,
        y: sourceLayout.y + 1
    }, seriesModel, {
        cb: function() {
            group.remove(symbolEl);
            data.setItemGraphicEl(dataIndex, null);
        },
        removeOpt: removeAnimationOpt
    });
    symbolEl.fadeOut(null, data.hostModel, {
        fadeLabel: true,
        animation: removeAnimationOpt
    });
    // remove edge as parent node
    node.children.forEach(function(childNode) {
        $b7fc0628a7967c46$var$removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
    });
    // remove edge as child node
    $b7fc0628a7967c46$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
}
function $b7fc0628a7967c46$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
    var cpx1;
    var cpy1;
    var cpx2;
    var cpy2;
    var x1;
    var x2;
    var y1;
    var y2;
    if (layoutOpt === 'radial') {
        x1 = sourceLayout.rawX;
        y1 = sourceLayout.rawY;
        x2 = targetLayout.rawX;
        y2 = targetLayout.rawY;
        var radialCoor1 = (0, $1ekzq.radialCoordinate)(x1, y1);
        var radialCoor2 = (0, $1ekzq.radialCoordinate)(x1, y1 + (y2 - y1) * curvature);
        var radialCoor3 = (0, $1ekzq.radialCoordinate)(x2, y2 + (y1 - y2) * curvature);
        var radialCoor4 = (0, $1ekzq.radialCoordinate)(x2, y2);
        return {
            x1: radialCoor1.x || 0,
            y1: radialCoor1.y || 0,
            x2: radialCoor4.x || 0,
            y2: radialCoor4.y || 0,
            cpx1: radialCoor2.x || 0,
            cpy1: radialCoor2.y || 0,
            cpx2: radialCoor3.x || 0,
            cpy2: radialCoor3.y || 0
        };
    } else {
        x1 = sourceLayout.x;
        y1 = sourceLayout.y;
        x2 = targetLayout.x;
        y2 = targetLayout.y;
        if (orient === 'LR' || orient === 'RL') {
            cpx1 = x1 + (x2 - x1) * curvature;
            cpy1 = y1;
            cpx2 = x2 + (x1 - x2) * curvature;
            cpy2 = y2;
        }
        if (orient === 'TB' || orient === 'BT') {
            cpx1 = x1;
            cpy1 = y1 + (y2 - y1) * curvature;
            cpx2 = x2;
            cpy2 = y2 + (y1 - y2) * curvature;
        }
    }
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
    };
}
var $b7fc0628a7967c46$export$2e2bcd8739ae039 = $b7fc0628a7967c46$var$TreeView;

});
parcelRegister("1ekzq", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $0e570e160d874b58$export$2cd8252107eb640b; });
$parcel$export(module.exports, "firstWalk", function () { return $0e570e160d874b58$export$f7eff93d75358a2c; });
$parcel$export(module.exports, "secondWalk", function () { return $0e570e160d874b58$export$39e6f19b1ce889be; });
$parcel$export(module.exports, "separation", function () { return $0e570e160d874b58$export$3bf720ece7bc7b2e; });
$parcel$export(module.exports, "radialCoordinate", function () { return $0e570e160d874b58$export$60198ec123d36099; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Initialize all computational message for following algorithm.
 */ function $0e570e160d874b58$export$2cd8252107eb640b(inRoot) {
    var root = inRoot;
    root.hierNode = {
        defaultAncestor: null,
        ancestor: root,
        prelim: 0,
        modifier: 0,
        change: 0,
        shift: 0,
        i: 0,
        thread: null
    };
    var nodes = [
        root
    ];
    var node;
    var children;
    while(node = nodes.pop()){
        // jshint ignore:line
        children = node.children;
        if (node.isExpand && children.length) {
            var n = children.length;
            for(var i = n - 1; i >= 0; i--){
                var child = children[i];
                child.hierNode = {
                    defaultAncestor: null,
                    ancestor: child,
                    prelim: 0,
                    modifier: 0,
                    change: 0,
                    shift: 0,
                    i: i,
                    thread: null
                };
                nodes.push(child);
            }
        }
    }
}
function $0e570e160d874b58$export$f7eff93d75358a2c(node, separation) {
    var children = node.isExpand ? node.children : [];
    var siblings = node.parentNode.children;
    var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
    if (children.length) {
        $0e570e160d874b58$var$executeShifts(node);
        var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
        if (subtreeW) {
            node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
            node.hierNode.modifier = node.hierNode.prelim - midPoint;
        } else node.hierNode.prelim = midPoint;
    } else if (subtreeW) node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
    node.parentNode.hierNode.defaultAncestor = $0e570e160d874b58$var$apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
function $0e570e160d874b58$export$39e6f19b1ce889be(node) {
    var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
    node.setLayout({
        x: nodeX
    }, true);
    node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function $0e570e160d874b58$export$3bf720ece7bc7b2e(cb) {
    return arguments.length ? cb : $0e570e160d874b58$var$defaultSeparation;
}
function $0e570e160d874b58$export$60198ec123d36099(rad, r) {
    rad -= Math.PI / 2;
    return {
        x: r * Math.cos(rad),
        y: r * Math.sin(rad)
    };
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $0e570e160d874b58$var$executeShifts(node) {
    var children = node.children;
    var n = children.length;
    var shift = 0;
    var change = 0;
    while(--n >= 0){
        var child = children[n];
        child.hierNode.prelim += shift;
        child.hierNode.modifier += shift;
        change += child.hierNode.change;
        shift += child.hierNode.shift + change;
    }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 */ function $0e570e160d874b58$var$apportion(subtreeV, subtreeW, ancestor, separation) {
    if (subtreeW) {
        var nodeOutRight = subtreeV;
        var nodeInRight = subtreeV;
        var nodeOutLeft = nodeInRight.parentNode.children[0];
        var nodeInLeft = subtreeW;
        var sumOutRight = nodeOutRight.hierNode.modifier;
        var sumInRight = nodeInRight.hierNode.modifier;
        var sumOutLeft = nodeOutLeft.hierNode.modifier;
        var sumInLeft = nodeInLeft.hierNode.modifier;
        while(nodeInLeft = $0e570e160d874b58$var$nextRight(nodeInLeft), nodeInRight = $0e570e160d874b58$var$nextLeft(nodeInRight), nodeInLeft && nodeInRight){
            nodeOutRight = $0e570e160d874b58$var$nextRight(nodeOutRight);
            nodeOutLeft = $0e570e160d874b58$var$nextLeft(nodeOutLeft);
            nodeOutRight.hierNode.ancestor = subtreeV;
            var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
            if (shift > 0) {
                $0e570e160d874b58$var$moveSubtree($0e570e160d874b58$var$nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
                sumInRight += shift;
                sumOutRight += shift;
            }
            sumInLeft += nodeInLeft.hierNode.modifier;
            sumInRight += nodeInRight.hierNode.modifier;
            sumOutRight += nodeOutRight.hierNode.modifier;
            sumOutLeft += nodeOutLeft.hierNode.modifier;
        }
        if (nodeInLeft && !$0e570e160d874b58$var$nextRight(nodeOutRight)) {
            nodeOutRight.hierNode.thread = nodeInLeft;
            nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
        }
        if (nodeInRight && !$0e570e160d874b58$var$nextLeft(nodeOutLeft)) {
            nodeOutLeft.hierNode.thread = nodeInRight;
            nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
            ancestor = subtreeV;
        }
    }
    return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $0e570e160d874b58$var$nextRight(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $0e570e160d874b58$var$nextLeft(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 */ function $0e570e160d874b58$var$nextAncestor(nodeInLeft, node, ancestor) {
    return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 */ function $0e570e160d874b58$var$moveSubtree(wl, wr, shift) {
    var change = shift / (wr.hierNode.i - wl.hierNode.i);
    wr.hierNode.change -= change;
    wr.hierNode.shift += shift;
    wr.hierNode.modifier += shift;
    wr.hierNode.prelim += shift;
    wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $0e570e160d874b58$var$defaultSeparation(node1, node2) {
    return node1.parentNode === node2.parentNode ? 1 : 2;
}

});


parcelRegister("cFzb2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939499c84c087269$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $49X8G = parcelRequire("49X8G");

var $4I5kR = parcelRequire("4I5kR");

var $b8YKU = parcelRequire("b8YKU");

var $5KdhI = parcelRequire("5KdhI");

var $hs88U = parcelRequire("hs88U");

var $6aXXD = parcelRequire("6aXXD");
var $939499c84c087269$var$TreeSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TreeSeriesModel, _super);
    function TreeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSymbolVisual = true;
        // Do it self.
        _this.ignoreStyleOnData = true;
        return _this;
    }
    /**
   * Init a tree data structure from data in option series
   */ TreeSeriesModel.prototype.getInitialData = function(option) {
        // create a virtual root
        var root = {
            name: option.name,
            children: option.data
        };
        var leaves = option.leaves || {};
        var leavesModel = new (0, $b8YKU.default)(leaves, this, this.ecModel);
        var tree = (0, $4I5kR.default).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                if (!(node && node.children.length && node.isExpand)) model.parentModel = leavesModel;
                return model;
            });
        }
        var treeDepth = 0;
        tree.eachNode('preorder', function(node) {
            if (node.depth > treeDepth) treeDepth = node.depth;
        });
        var expandAndCollapse = option.expandAndCollapse;
        var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
        tree.root.eachNode('preorder', function(node) {
            var item = node.hostTree.data.getRawDataItem(node.dataIndex);
            // Add item.collapsed != null, because users can collapse node original in the series.data.
            node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
        });
        return tree.data;
    };
    /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */ TreeSeriesModel.prototype.getOrient = function() {
        var orient = this.get('orient');
        if (orient === 'horizontal') orient = 'LR';
        else if (orient === 'vertical') orient = 'TB';
        return orient;
    };
    TreeSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    TreeSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    TreeSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var tree = this.getData().tree;
        var realRoot = tree.root.children[0];
        var node = tree.getNodeByDataIndex(dataIndex);
        var value = node.getValue();
        var name = node.name;
        while(node && node !== realRoot){
            name = node.parentNode.name + '.' + name;
            node = node.parentNode;
        }
        return (0, $5KdhI.createTooltipMarkup)('nameValue', {
            name: name,
            value: value,
            noValue: isNaN(value) || value == null
        });
    };
    // Add tree path to tooltip param
    TreeSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $hs88U.wrapTreePathInfo)(node, this);
        params.collapsed = !node.isExpand;
        return params;
    };
    TreeSeriesModel.type = 'series.tree';
    // can support the position parameters 'left', 'top','right','bottom', 'width',
    // 'height' in the setOption() with 'merge' mode normal.
    TreeSeriesModel.layoutMode = 'box';
    TreeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // `coordinateSystem` can be declared as 'matrix', 'calendar',
        //  which provides box layout container.
        coordinateSystemUsage: 'box',
        // the position of the whole view
        left: '12%',
        top: '12%',
        right: '12%',
        bottom: '12%',
        // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
        layout: 'orthogonal',
        // value can be 'polyline'
        edgeShape: 'curve',
        edgeForkPosition: '50%',
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        roamTrigger: 'global',
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.4,
        // Default on center of graph
        center: null,
        zoom: 1,
        orient: 'LR',
        symbol: 'emptyCircle',
        symbolSize: 7,
        expandAndCollapse: true,
        initialTreeDepth: 2,
        lineStyle: {
            color: (0, $6aXXD.default).color.borderTint,
            width: 1.5,
            curveness: 0.5
        },
        itemStyle: {
            color: 'lightsteelblue',
            // borderColor: '#c23531',
            borderWidth: 1.5
        },
        label: {
            show: true
        },
        animationEasing: 'linear',
        animationDuration: 700,
        animationDurationUpdate: 500
    };
    return TreeSeriesModel;
}((0, $49X8G.default));
var $939499c84c087269$export$2e2bcd8739ae039 = $939499c84c087269$var$TreeSeriesModel;

});

parcelRegister("lPt5y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe44ecc5f95aa7ee$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ia0PG = parcelRequire("ia0PG");

var $1ekzq = parcelRequire("1ekzq");

var $a35Wn = parcelRequire("a35Wn");
function $fe44ecc5f95aa7ee$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('tree', function(seriesModel) {
        $fe44ecc5f95aa7ee$var$commonLayout(seriesModel, api);
    });
}
function $fe44ecc5f95aa7ee$var$commonLayout(seriesModel, api) {
    var refContainer = (0, $a35Wn.createBoxLayoutReference)(seriesModel, api).refContainer;
    var layoutInfo = (0, $a35Wn.getLayoutRect)(seriesModel.getBoxLayoutParams(), refContainer);
    seriesModel.layoutInfo = layoutInfo;
    var layout = seriesModel.get('layout');
    var width = 0;
    var height = 0;
    var separation = null;
    if (layout === 'radial') {
        width = 2 * Math.PI;
        height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
        separation = (0, $1ekzq.separation)(function(node1, node2) {
            return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
        });
    } else {
        width = layoutInfo.width;
        height = layoutInfo.height;
        separation = (0, $1ekzq.separation)();
    }
    var virtualRoot = seriesModel.getData().tree.root;
    var realRoot = virtualRoot.children[0];
    if (realRoot) {
        (0, $1ekzq.init)(virtualRoot);
        (0, $ia0PG.eachAfter)(realRoot, (0, $1ekzq.firstWalk), separation);
        virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
        (0, $ia0PG.eachBefore)(realRoot, (0, $1ekzq.secondWalk));
        var left_1 = realRoot;
        var right_1 = realRoot;
        var bottom_1 = realRoot;
        (0, $ia0PG.eachBefore)(realRoot, function(node) {
            var x = node.getLayout().x;
            if (x < left_1.getLayout().x) left_1 = node;
            if (x > right_1.getLayout().x) right_1 = node;
            if (node.depth > bottom_1.depth) bottom_1 = node;
        });
        var delta = left_1 === right_1 ? 1 : separation(left_1, right_1) / 2;
        var tx_1 = delta - left_1.getLayout().x;
        var kx_1 = 0;
        var ky_1 = 0;
        var coorX_1 = 0;
        var coorY_1 = 0;
        if (layout === 'radial') {
            kx_1 = width / (right_1.getLayout().x + delta + tx_1);
            // here we use (node.depth - 1), bucause the real root's depth is 1
            ky_1 = height / (bottom_1.depth - 1 || 1);
            (0, $ia0PG.eachBefore)(realRoot, function(node) {
                coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                coorY_1 = (node.depth - 1) * ky_1;
                var finalCoor = (0, $1ekzq.radialCoordinate)(coorX_1, coorY_1);
                node.setLayout({
                    x: finalCoor.x,
                    y: finalCoor.y,
                    rawX: coorX_1,
                    rawY: coorY_1
                }, true);
            });
        } else {
            var orient_1 = seriesModel.getOrient();
            if (orient_1 === 'RL' || orient_1 === 'LR') {
                ky_1 = height / (right_1.getLayout().x + delta + tx_1);
                kx_1 = width / (bottom_1.depth - 1 || 1);
                (0, $ia0PG.eachBefore)(realRoot, function(node) {
                    coorY_1 = (node.getLayout().x + tx_1) * ky_1;
                    coorX_1 = orient_1 === 'LR' ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            } else if (orient_1 === 'TB' || orient_1 === 'BT') {
                kx_1 = width / (right_1.getLayout().x + delta + tx_1);
                ky_1 = height / (bottom_1.depth - 1 || 1);
                (0, $ia0PG.eachBefore)(realRoot, function(node) {
                    coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                    coorY_1 = orient_1 === 'TB' ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            }
        }
    }
}

});
parcelRegister("ia0PG", function(module, exports) {

$parcel$export(module.exports, "eachAfter", function () { return $d389ce8009139295$export$bd961f70bc91ffb4; });
$parcel$export(module.exports, "eachBefore", function () { return $d389ce8009139295$export$32a66ec2b39acdac; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Traverse the tree from bottom to top and do something
 */ function $d389ce8009139295$export$bd961f70bc91ffb4(root, callback, separation) {
    var nodes = [
        root
    ];
    var next = [];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        next.push(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = 0; i < children.length; i++)nodes.push(children[i]);
        }
    }
    while(node = next.pop())// jshint ignore:line
    callback(node, separation);
}
/**
 * Traverse the tree from top to bottom and do something
 */ function $d389ce8009139295$export$32a66ec2b39acdac(root, callback) {
    var nodes = [
        root
    ];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        callback(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = children.length - 1; i >= 0; i--)nodes.push(children[i]);
        }
    }
}

});


parcelRegister("90rB0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68e9851a4453dec7$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $68e9851a4453dec7$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('tree', function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            // TODO Optimize
            var style = model.getModel('itemStyle').getItemStyle();
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
            (0, $2N6Uo.extend)(existsStyle, style);
        });
    });
}

});

parcelRegister("2XJkx", function(module, exports) {

$parcel$export(module.exports, "installTreeAction", function () { return $22844118dee6058b$export$83b6a0f4104bd4f4; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kc4jZ = parcelRequire("kc4jZ");
function $22844118dee6058b$export$83b6a0f4104bd4f4(registers) {
    registers.registerAction({
        type: 'treeExpandAndCollapse',
        event: 'treeExpandAndCollapse',
        update: 'update'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'tree',
            query: payload
        }, function(seriesModel) {
            var dataIndex = payload.dataIndex;
            var tree = seriesModel.getData().tree;
            var node = tree.getNodeByDataIndex(dataIndex);
            node.isExpand = !node.isExpand;
        });
    });
    registers.registerAction({
        type: 'treeRoam',
        event: 'treeRoam',
        // Here we set 'none' instead of 'update', because roam action
        // just need to update the transform matrix without having to recalculate
        // the layout. So don't need to go through the whole update process, such
        // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
        update: 'none'
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'tree',
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $kc4jZ.updateCenterAndZoomInAction)(coordSys, payload, seriesModel.get('scaleLimit'));
            seriesModel.setCenter(res.center);
            seriesModel.setZoom(res.zoom);
        });
    });
}

});


parcelRegister("24giI", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $18189984a80ed5c8$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9uHZq = parcelRequire("9uHZq");

var $8nUw6 = parcelRequire("8nUw6");

var $28bfc = parcelRequire("28bfc");

var $9yYp5 = parcelRequire("9yYp5");

var $bCdr6 = parcelRequire("bCdr6");
function $18189984a80ed5c8$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $8nUw6.default));
    registers.registerChartView((0, $28bfc.default));
    registers.registerVisual((0, $9yYp5.default));
    registers.registerLayout((0, $bCdr6.default));
    (0, $9uHZq.installTreemapAction)(registers);
}

});
parcelRegister("9uHZq", function(module, exports) {

$parcel$export(module.exports, "installTreemapAction", function () { return $6e9909d9bb21e932$export$1ad90fc3f3a8bbf9; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hs88U = parcelRequire("hs88U");

var $2N6Uo = parcelRequire("2N6Uo");
var $6e9909d9bb21e932$var$actionTypes = [
    'treemapZoomToNode',
    'treemapRender',
    'treemapMove'
];
function $6e9909d9bb21e932$export$1ad90fc3f3a8bbf9(registers) {
    for(var i = 0; i < $6e9909d9bb21e932$var$actionTypes.length; i++)registers.registerAction({
        type: $6e9909d9bb21e932$var$actionTypes[i],
        update: 'updateView'
    }, (0, $2N6Uo.noop));
    registers.registerAction({
        type: 'treemapRootToNode',
        update: 'updateView'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'treemap',
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var types = [
                'treemapZoomToNode',
                'treemapRootToNode'
            ];
            var targetInfo = $hs88U.retrieveTargetInfo(payload, types, model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = $hs88U.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
}

});

parcelRegister("8nUw6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61ac4fc41d39975c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $49X8G = parcelRequire("49X8G");

var $4I5kR = parcelRequire("4I5kR");

var $b8YKU = parcelRequire("b8YKU");

var $hs88U = parcelRequire("hs88U");

var $bx3T8 = parcelRequire("bx3T8");

var $5KdhI = parcelRequire("5KdhI");

var $2oq9K = parcelRequire("2oq9K");

var $6aXXD = parcelRequire("6aXXD");
var $61ac4fc41d39975c$var$TreemapSeriesModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TreemapSeriesModel, _super);
    function TreemapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapSeriesModel.type;
        _this.preventUsingHoverLayer = true;
        return _this;
    }
    /**
   * @override
   */ TreemapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $61ac4fc41d39975c$var$completeTreeValue(root);
        var levels = option.levels || [];
        // Used in "visual priority" in `treemapVisual.js`.
        // This way is a little tricky, must satisfy the precondition:
        //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
        //   2. The `Model.prototype.getModel()` will not use any clone-like way.
        var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
        var designatedVisualModel = new (0, $b8YKU.default)({
            itemStyle: designatedVisualItemStyle
        }, this, ecModel);
        levels = option.levels = $61ac4fc41d39975c$var$setDefault(levels, ecModel);
        var levelModels = $2N6Uo.map(levels || [], function(levelDefine) {
            return new (0, $b8YKU.default)(levelDefine, designatedVisualModel, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $4I5kR.default).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = node ? levelModels[node.depth] : null;
                // If no levelModel, we also need `designatedVisualModel`.
                model.parentModel = levelModel || designatedVisualModel;
                return model;
            });
        }
        return tree.data;
    };
    TreemapSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */ TreemapSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        return (0, $5KdhI.createTooltipMarkup)('nameValue', {
            name: name,
            value: value
        });
    };
    /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */ TreemapSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $hs88U.wrapTreePathInfo)(node, this);
        // compatitable the previous code.
        params.treePathInfo = params.treeAncestors;
        return params;
    };
    /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */ TreemapSeriesModel.prototype.setLayoutInfo = function(layoutInfo) {
        /**
     * @readOnly
     * @type {Object}
     */ this.layoutInfo = this.layoutInfo || {};
        $2N6Uo.extend(this.layoutInfo, layoutInfo);
    };
    /**
   * @param  {string} id
   * @return {number} index
   */ TreemapSeriesModel.prototype.mapIdToIndex = function(id) {
        // A feature is implemented:
        // index is monotone increasing with the sequence of
        // input id at the first time.
        // This feature can make sure that each data item and its
        // mapped color have the same index between data list and
        // color list at the beginning, which is useful for user
        // to adjust data-color mapping.
        /**
     * @private
     * @type {Object}
     */ var idIndexMap = this._idIndexMap;
        if (!idIndexMap) {
            idIndexMap = this._idIndexMap = $2N6Uo.createHashMap();
            /**
       * @private
       * @type {number}
       */ this._idIndexMapCount = 0;
        }
        var index = idIndexMap.get(id);
        if (index == null) idIndexMap.set(id, index = this._idIndexMapCount++);
        return index;
    };
    TreemapSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    TreemapSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    TreemapSeriesModel.prototype.enableAriaDecal = function() {
        (0, $2oq9K.default)(this);
    };
    TreemapSeriesModel.type = 'series.treemap';
    TreemapSeriesModel.layoutMode = 'box';
    TreemapSeriesModel.defaultOption = {
        // Disable progressive rendering
        progressive: 0,
        // size: ['80%', '80%'],            // deprecated, compatible with ec2.
        // `coordinateSystem` can be declared as 'matrix', 'calendar',
        //  which provides box layout container.
        coordinateSystemUsage: 'box',
        left: (0, $6aXXD.default).size.l,
        top: (0, $6aXXD.default).size.xxxl,
        right: (0, $6aXXD.default).size.l,
        bottom: (0, $6aXXD.default).size.xxxl,
        sort: true,
        clipWindow: 'origin',
        squareRatio: 0.5 * (1 + Math.sqrt(5)),
        leafDepth: null,
        drillDownIcon: "\u25B6",
        // to align specialized icon. ▷▶❒❐▼✚
        zoomToNodeRatio: 0.1024,
        scaleLimit: {
            max: 5,
            min: 0.2
        },
        roam: true,
        roamTrigger: 'global',
        nodeClick: 'zoomToNode',
        animation: true,
        animationDurationUpdate: 900,
        animationEasing: 'quinticInOut',
        breadcrumb: {
            show: true,
            height: 22,
            left: 'center',
            bottom: (0, $6aXXD.default).size.m,
            // right
            // bottom
            emptyItemWidth: 25,
            itemStyle: {
                color: (0, $6aXXD.default).color.backgroundShade,
                textStyle: {
                    color: (0, $6aXXD.default).color.secondary
                }
            },
            emphasis: {
                itemStyle: {
                    color: (0, $6aXXD.default).color.background
                }
            }
        },
        label: {
            show: true,
            // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
            distance: 0,
            padding: 5,
            position: 'inside',
            // formatter: null,
            color: (0, $6aXXD.default).color.neutral00,
            overflow: 'truncate'
        },
        upperLabel: {
            show: false,
            position: [
                0,
                '50%'
            ],
            height: 20,
            // formatter: null,
            // color: '#fff',
            overflow: 'truncate',
            // align: null,
            verticalAlign: 'middle'
        },
        itemStyle: {
            color: null,
            colorAlpha: null,
            colorSaturation: null,
            borderWidth: 0,
            gapWidth: 0,
            borderColor: (0, $6aXXD.default).color.neutral00,
            borderColorSaturation: null // If specified, borderColor will be ineffective, and the
        },
        emphasis: {
            upperLabel: {
                show: true,
                position: [
                    0,
                    '50%'
                ],
                overflow: 'truncate',
                verticalAlign: 'middle'
            }
        },
        visualDimension: 0,
        visualMin: null,
        visualMax: null,
        color: [],
        // level[n].color (if necessary).
        // + Specify color list of each level. level[0].color would be global
        // color list if not specified. (see method `setDefault`).
        // + But set as a empty array to forbid fetch color from global palette
        // when using nodeModel.get('color'), otherwise nodes on deep level
        // will always has color palette set and are not able to inherit color
        // from parent node.
        // + TreemapSeries.color can not be set as 'none', otherwise effect
        // legend color fetching (see seriesColor.js).
        colorAlpha: null,
        colorSaturation: null,
        colorMappingBy: 'index',
        visibleMin: 10,
        // be rendered. Only works when sort is 'asc' or 'desc'.
        childrenVisibleMin: null,
        // grandchildren will not show.
        // Why grandchildren? If not grandchildren but children,
        // some siblings show children and some not,
        // the appearance may be mess and not consistent,
        levels: [] // Each item: {
    };
    return TreemapSeriesModel;
}((0, $49X8G.default));
/**
 * @param {Object} dataNode
 */ function $61ac4fc41d39975c$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $2N6Uo.each(dataNode.children, function(child) {
        $61ac4fc41d39975c$var$completeTreeValue(child);
        var childValue = child.value;
        $2N6Uo.isArray(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($2N6Uo.isArray(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $2N6Uo.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */ function $61ac4fc41d39975c$var$setDefault(levels, ecModel) {
    var globalColorList = (0, $bx3T8.normalizeToArray)(ecModel.get('color'));
    var globalDecalList = (0, $bx3T8.normalizeToArray)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    if (!globalColorList) return;
    levels = levels || [];
    var hasColorDefine;
    var hasDecalDefine;
    $2N6Uo.each(levels, function(levelDefine) {
        var model = new (0, $b8YKU.default)(levelDefine);
        var modelColor = model.get('color');
        var modelDecal = model.get('decal');
        if (model.get([
            'itemStyle',
            'color'
        ]) || modelColor && modelColor !== 'none') hasColorDefine = true;
        if (model.get([
            'itemStyle',
            'decal'
        ]) || modelDecal && modelDecal !== 'none') hasDecalDefine = true;
    });
    var level0 = levels[0] || (levels[0] = {});
    if (!hasColorDefine) level0.color = globalColorList.slice();
    if (!hasDecalDefine && globalDecalList) level0.decal = globalDecalList.slice();
    return levels;
}
var $61ac4fc41d39975c$export$2e2bcd8739ae039 = $61ac4fc41d39975c$var$TreemapSeriesModel;

});

parcelRegister("28bfc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18d50cff0674fa11$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");

var $6TSUP = parcelRequire("6TSUP");

var $bwPbQ = parcelRequire("bwPbQ");

var $chf3v = parcelRequire("chf3v");

var $hs88U = parcelRequire("hs88U");

var $bPLXT = parcelRequire("bPLXT");

var $ic6Qi = parcelRequire("ic6Qi");

var $67W72 = parcelRequire("67W72");

var $19Ywy = parcelRequire("19Ywy");

var $8NkUi = parcelRequire("8NkUi");

var $4jA7C = parcelRequire("4jA7C");

var $cWIrM = parcelRequire("cWIrM");

var $6Ekel = parcelRequire("6Ekel");

var $bx3T8 = parcelRequire("bx3T8");

var $hrphB = parcelRequire("hrphB");

var $bysmE = parcelRequire("bysmE");
var $18d50cff0674fa11$var$Group = $iQonF.default;
var $18d50cff0674fa11$var$Rect = $aH2k0.default;
var $18d50cff0674fa11$var$DRAG_THRESHOLD = 3;
var $18d50cff0674fa11$var$PATH_LABEL_NOAMAL = 'label';
var $18d50cff0674fa11$var$PATH_UPPERLABEL_NORMAL = 'upperLabel';
// Should larger than emphasis states lift z
var $18d50cff0674fa11$var$Z2_BASE = (0, $bwPbQ.Z2_EMPHASIS_LIFT) * 10; // Should bigger than every z2.
var $18d50cff0674fa11$var$Z2_BG = (0, $bwPbQ.Z2_EMPHASIS_LIFT) * 2;
var $18d50cff0674fa11$var$Z2_CONTENT = (0, $bwPbQ.Z2_EMPHASIS_LIFT) * 3;
var $18d50cff0674fa11$var$getStateItemStyle = (0, $4jA7C.default)([
    [
        'fill',
        'color'
    ],
    // `borderColor` and `borderWidth` has been occupied,
    // so use `stroke` to indicate the stroke of the rect.
    [
        'stroke',
        'strokeColor'
    ],
    [
        'lineWidth',
        'strokeWidth'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ]
]);
var $18d50cff0674fa11$var$getItemStyleNormal = function(model) {
    // Normal style props should include emphasis style props.
    var itemStyle = $18d50cff0674fa11$var$getStateItemStyle(model);
    // Clear styles set by emphasis.
    itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
    return itemStyle;
};
var $18d50cff0674fa11$var$inner = (0, $bx3T8.makeInner)();
var $18d50cff0674fa11$var$TreemapView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TreemapView, _super);
    function TreemapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapView.type;
        _this._state = 'ready';
        _this._storage = $18d50cff0674fa11$var$createStorage();
        return _this;
    }
    /**
   * @override
   */ TreemapView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var models = ecModel.findComponents({
            mainType: 'series',
            subType: 'treemap',
            query: payload
        });
        if ((0, $2N6Uo.indexOf)(models, seriesModel) < 0) return;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var types = [
            'treemapZoomToNode',
            'treemapRootToNode'
        ];
        var targetInfo = $hs88U.retrieveTargetInfo(payload, types, seriesModel);
        var payloadType = payload && payload.type;
        var layoutInfo = seriesModel.layoutInfo;
        var isInit = !this._oldTree;
        var thisStorage = this._storage;
        // Mark new root when action is treemapRootToNode.
        var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
            rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
            direction: payload.direction
        } : null;
        var containerGroup = this._giveContainerGroup(layoutInfo);
        var hasAnimation = seriesModel.get('animation');
        var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
        hasAnimation && !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
        this._resetController(api);
        this._renderBreadcrumb(seriesModel, api, targetInfo);
    };
    TreemapView.prototype._giveContainerGroup = function(layoutInfo) {
        var containerGroup = this._containerGroup;
        if (!containerGroup) {
            // FIXME
            // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
            containerGroup = this._containerGroup = new $18d50cff0674fa11$var$Group();
            this._initEvents(containerGroup);
            this.group.add(containerGroup);
        }
        containerGroup.x = layoutInfo.x;
        containerGroup.y = layoutInfo.y;
        return containerGroup;
    };
    TreemapView.prototype._doRender = function(containerGroup, seriesModel, reRoot) {
        var thisTree = seriesModel.getData().tree;
        var oldTree = this._oldTree;
        // Clear last shape records.
        var lastsForAnimation = $18d50cff0674fa11$var$createStorage();
        var thisStorage = $18d50cff0674fa11$var$createStorage();
        var oldStorage = this._storage;
        var willInvisibleEls = [];
        function doRenderNode(thisNode, oldNode, parentGroup, depth) {
            return $18d50cff0674fa11$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
        }
        // Notice: When thisTree and oldTree are the same tree (see list.cloneShallow),
        // the oldTree is actually losted, so we cannot find all of the old graphic
        // elements from tree. So we use this strategy: make element storage, move
        // from old storage to new storage, clear old storage.
        dualTravel(thisTree.root ? [
            thisTree.root
        ] : [], oldTree && oldTree.root ? [
            oldTree.root
        ] : [], containerGroup, thisTree === oldTree || !oldTree, 0);
        // Process all removing.
        var willDeleteEls = clearStorage(oldStorage);
        this._oldTree = thisTree;
        this._storage = thisStorage;
        if (this._controllerHost) {
            var _oldRootLayout = this.seriesModel.layoutInfo;
            var rootLayout = thisTree.root.getLayout();
            if (rootLayout.width === _oldRootLayout.width && rootLayout.height === _oldRootLayout.height) this._controllerHost.zoom = 1;
        }
        return {
            lastsForAnimation: lastsForAnimation,
            willDeleteEls: willDeleteEls,
            renderFinally: renderFinally
        };
        function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
            // When 'render' is triggered by action,
            // 'this' and 'old' may be the same tree,
            // we use rawIndex in that case.
            if (sameTree) {
                oldViewChildren = thisViewChildren;
                (0, $2N6Uo.each)(thisViewChildren, function(child, index) {
                    !child.isRemoved() && processNode(index, index);
                });
            } else new (0, $chf3v.default)(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove((0, $2N6Uo.curry)(processNode, null)).execute();
            function getKey(node) {
                // Identify by name or raw index.
                return node.getId();
            }
            function processNode(newIndex, oldIndex) {
                var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
                var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
                var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
                group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
            }
        }
        function clearStorage(storage) {
            var willDeleteEls = $18d50cff0674fa11$var$createStorage();
            storage && (0, $2N6Uo.each)(storage, function(store, storageName) {
                var delEls = willDeleteEls[storageName];
                (0, $2N6Uo.each)(store, function(el) {
                    el && (delEls.push(el), $18d50cff0674fa11$var$inner(el).willDelete = true);
                });
            });
            return willDeleteEls;
        }
        function renderFinally() {
            (0, $2N6Uo.each)(willDeleteEls, function(els) {
                (0, $2N6Uo.each)(els, function(el) {
                    el.parent && el.parent.remove(el);
                });
            });
            (0, $2N6Uo.each)(willInvisibleEls, function(el) {
                el.invisible = true;
                // Setting invisible is for optimizing, so no need to set dirty,
                // just mark as invisible.
                el.dirty();
            });
        }
    };
    TreemapView.prototype._doAnimation = function(containerGroup, renderResult, seriesModel, reRoot) {
        var durationOption = seriesModel.get('animationDurationUpdate');
        var easingOption = seriesModel.get('animationEasing');
        // TODO: do not support function until necessary.
        var duration = ((0, $2N6Uo.isFunction)(durationOption) ? 0 : durationOption) || 0;
        var easing = ((0, $2N6Uo.isFunction)(easingOption) ? null : easingOption) || 'cubicOut';
        var animationWrap = $8NkUi.createWrap();
        // Make delete animations.
        (0, $2N6Uo.each)(renderResult.willDeleteEls, function(store, storageName) {
            (0, $2N6Uo.each)(store, function(el, rawIndex) {
                if (el.invisible) return;
                var parent = el.parent; // Always has parent, and parent is nodeGroup.
                var target;
                var innerStore = $18d50cff0674fa11$var$inner(parent);
                if (reRoot && reRoot.direction === 'drillDown') target = parent === reRoot.rootNodeGroup ? {
                    shape: {
                        x: 0,
                        y: 0,
                        width: innerStore.nodeWidth,
                        height: innerStore.nodeHeight
                    },
                    style: {
                        opacity: 0
                    }
                } : {
                    style: {
                        opacity: 0
                    }
                };
                else {
                    var targetX = 0;
                    var targetY = 0;
                    if (!innerStore.willDelete) {
                        // Let node animate to right-bottom corner, cooperating with fadeout,
                        // which is appropriate for user understanding.
                        // Divided by 2 for reRoot rolling up effect.
                        targetX = innerStore.nodeWidth / 2;
                        targetY = innerStore.nodeHeight / 2;
                    }
                    target = storageName === 'nodeGroup' ? {
                        x: targetX,
                        y: targetY,
                        style: {
                            opacity: 0
                        }
                    } : {
                        shape: {
                            x: targetX,
                            y: targetY,
                            width: 0,
                            height: 0
                        },
                        style: {
                            opacity: 0
                        }
                    };
                }
                // TODO: do not support delay until necessary.
                target && animationWrap.add(el, target, duration, 0, easing);
            });
        });
        // Make other animations
        (0, $2N6Uo.each)(this._storage, function(store, storageName) {
            (0, $2N6Uo.each)(store, function(el, rawIndex) {
                var last = renderResult.lastsForAnimation[storageName][rawIndex];
                var target = {};
                if (!last) return;
                if (el instanceof $iQonF.default) {
                    if (last.oldX != null) {
                        target.x = el.x;
                        target.y = el.y;
                        el.x = last.oldX;
                        el.y = last.oldY;
                    }
                } else {
                    if (last.oldShape) {
                        target.shape = (0, $2N6Uo.extend)({}, el.shape);
                        el.setShape(last.oldShape);
                    }
                    if (last.fadein) {
                        el.setStyle('opacity', 0);
                        target.style = {
                            opacity: 1
                        };
                    } else if (el.style.opacity !== 1) target.style = {
                        opacity: 1
                    };
                }
                animationWrap.add(el, target, duration, 0, easing);
            });
        }, this);
        this._state = 'animating';
        animationWrap.finished((0, $2N6Uo.bind)(function() {
            this._state = 'ready';
            renderResult.renderFinally();
        }, this)).start();
    };
    TreemapView.prototype._resetController = function(api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        if (!controllerHost) {
            this._controllerHost = {
                target: this.group
            };
            controllerHost = this._controllerHost;
        }
        var seriesModel = this.seriesModel;
        // Init controller.
        if (!controller) {
            controller = this._controller = new (0, $ic6Qi.default)(api.getZr());
            controller.on('pan', (0, $2N6Uo.bind)(this._onPan, this));
            controller.on('zoom', (0, $2N6Uo.bind)(this._onZoom, this));
        }
        controller.enable(seriesModel.get('roam'), {
            api: api,
            zInfo: {
                component: seriesModel
            },
            triggerInfo: {
                roamTrigger: seriesModel.get('roamTrigger'),
                isInSelf: function(e, x, y) {
                    var containerGroup = _this._containerGroup;
                    return containerGroup ? containerGroup.getBoundingRect().contain(x - containerGroup.x, y - containerGroup.y) : false;
                }
            }
        });
        controllerHost.zoomLimit = seriesModel.get('scaleLimit');
        controllerHost.zoom = seriesModel.get('zoom');
    };
    TreemapView.prototype._clearController = function() {
        var controller = this._controller;
        this._controllerHost = null;
        if (controller) {
            controller.dispose();
            controller = null;
        }
    };
    TreemapView.prototype._onPan = function(e) {
        if (this._state !== 'animating' && (Math.abs(e.dx) > $18d50cff0674fa11$var$DRAG_THRESHOLD || Math.abs(e.dy) > $18d50cff0674fa11$var$DRAG_THRESHOLD)) {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            this.api.dispatchAction({
                type: 'treemapMove',
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rootLayout.x + e.dx,
                    y: rootLayout.y + e.dy,
                    width: rootLayout.width,
                    height: rootLayout.height
                }
            });
        }
    };
    TreemapView.prototype._onZoom = function(e) {
        var mouseX = e.originX;
        var mouseY = e.originY;
        var zoomDelta = e.scale;
        if (this._state !== 'animating') {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            var rect = new (0, $67W72.default)(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
            // scaleLimit
            var zoomLimit = null;
            var _controllerHost = this._controllerHost;
            zoomLimit = _controllerHost.zoomLimit;
            var newZoom = _controllerHost.zoom = _controllerHost.zoom || 1;
            newZoom *= zoomDelta;
            if (zoomLimit) {
                var zoomMin = zoomLimit.min || 0;
                var zoomMax = zoomLimit.max || Infinity;
                newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
            }
            var zoomScale = newZoom / _controllerHost.zoom;
            _controllerHost.zoom = newZoom;
            var layoutInfo = this.seriesModel.layoutInfo;
            // Transform mouse coord from global to containerGroup.
            mouseX -= layoutInfo.x;
            mouseY -= layoutInfo.y;
            // Scale root bounding rect.
            var m = $19Ywy.create();
            $19Ywy.translate(m, m, [
                -mouseX,
                -mouseY
            ]);
            $19Ywy.scale(m, m, [
                zoomScale,
                zoomScale
            ]);
            $19Ywy.translate(m, m, [
                mouseX,
                mouseY
            ]);
            rect.applyTransform(m);
            this.api.dispatchAction({
                type: 'treemapRender',
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }
            });
        }
    };
    TreemapView.prototype._initEvents = function(containerGroup) {
        var _this = this;
        containerGroup.on('click', function(e) {
            if (_this._state !== 'ready') return;
            var nodeClick = _this.seriesModel.get('nodeClick', true);
            if (!nodeClick) return;
            var targetInfo = _this.findTarget(e.offsetX, e.offsetY);
            if (!targetInfo) return;
            var node = targetInfo.node;
            if (node.getLayout().isLeafRoot) _this._rootToNode(targetInfo);
            else {
                if (nodeClick === 'zoomToNode') _this._zoomToNode(targetInfo);
                else if (nodeClick === 'link') {
                    var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
                    var link = itemModel.get('link', true);
                    var linkTarget = itemModel.get('target', true) || 'blank';
                    link && (0, $hrphB.windowOpen)(link, linkTarget);
                }
            }
        }, this);
    };
    TreemapView.prototype._renderBreadcrumb = function(seriesModel, api, targetInfo) {
        var _this = this;
        if (!targetInfo) {
            targetInfo = seriesModel.get('leafDepth', true) != null ? {
                node: seriesModel.getViewRoot()
            } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
            if (!targetInfo) targetInfo = {
                node: seriesModel.getData().tree.root
            };
        }
        (this._breadcrumb || (this._breadcrumb = new (0, $bPLXT.default)(this.group))).render(seriesModel, api, targetInfo.node, function(node) {
            if (_this._state !== 'animating') $hs88U.aboveViewRoot(seriesModel.getViewRoot(), node) ? _this._rootToNode({
                node: node
            }) : _this._zoomToNode({
                node: node
            });
        });
    };
    /**
   * @override
   */ TreemapView.prototype.remove = function() {
        this._clearController();
        this._containerGroup && this._containerGroup.removeAll();
        this._storage = $18d50cff0674fa11$var$createStorage();
        this._state = 'ready';
        this._breadcrumb && this._breadcrumb.remove();
    };
    TreemapView.prototype.dispose = function() {
        this._clearController();
    };
    TreemapView.prototype._zoomToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: 'treemapZoomToNode',
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    TreemapView.prototype._rootToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: 'treemapRootToNode',
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    /**
   * @param x Global coord x.
   * @param y Global coord y.
   * @return info If not found, return undefined;
   * @return info.node Target node.
   * @return info.offsetX x refer to target node.
   * @return info.offsetY y refer to target node.
   */ TreemapView.prototype.findTarget = function(x, y) {
        var targetInfo;
        var viewRoot = this.seriesModel.getViewRoot();
        viewRoot.eachNode({
            attr: 'viewChildren',
            order: 'preorder'
        }, function(node) {
            var bgEl = this._storage.background[node.getRawIndex()];
            // If invisible, there might be no element.
            if (bgEl) {
                var point = bgEl.transformCoordToLocal(x, y);
                var shape = bgEl.shape;
                // For performance consideration, don't use 'getBoundingRect'.
                if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) targetInfo = {
                    node: node,
                    offsetX: point[0],
                    offsetY: point[1]
                };
                else return false; // Suppress visit subtree.
            }
        }, this);
        return targetInfo;
    };
    TreemapView.type = 'treemap';
    return TreemapView;
}((0, $cWIrM.default));
function $18d50cff0674fa11$var$createStorage() {
    return {
        nodeGroup: [],
        background: [],
        content: []
    };
}
/**
 * @return Return undefined means do not travel further.
 */ function $18d50cff0674fa11$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
    // Whether under viewRoot.
    if (!thisNode) // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
    // -------------------------------------------------------------------
    // Start of closure variables available in "Procedures in renderNode".
    var thisLayout = thisNode.getLayout();
    var data = seriesModel.getData();
    var nodeModel = thisNode.getModel();
    // Only for enabling highlight/downplay. Clear firstly.
    // Because some node will not be rendered.
    data.setItemGraphicEl(thisNode.dataIndex, null);
    if (!thisLayout || !thisLayout.isInView) return;
    var thisWidth = thisLayout.width;
    var thisHeight = thisLayout.height;
    var borderWidth = thisLayout.borderWidth;
    var thisInvisible = thisLayout.invisible;
    var thisRawIndex = thisNode.getRawIndex();
    var oldRawIndex = oldNode && oldNode.getRawIndex();
    var thisViewChildren = thisNode.viewChildren;
    var upperHeight = thisLayout.upperHeight;
    var isParent = thisViewChildren && thisViewChildren.length;
    var itemStyleNormalModel = nodeModel.getModel('itemStyle');
    var itemStyleEmphasisModel = nodeModel.getModel([
        'emphasis',
        'itemStyle'
    ]);
    var itemStyleBlurModel = nodeModel.getModel([
        'blur',
        'itemStyle'
    ]);
    var itemStyleSelectModel = nodeModel.getModel([
        'select',
        'itemStyle'
    ]);
    var borderRadius = itemStyleNormalModel.get('borderRadius') || 0;
    // End of closure ariables available in "Procedures in renderNode".
    // -----------------------------------------------------------------
    // Node group
    var group = giveGraphic('nodeGroup', $18d50cff0674fa11$var$Group);
    if (!group) return;
    parentGroup.add(group);
    // x,y are not set when el is above view root.
    group.x = thisLayout.x || 0;
    group.y = thisLayout.y || 0;
    group.markRedraw();
    $18d50cff0674fa11$var$inner(group).nodeWidth = thisWidth;
    $18d50cff0674fa11$var$inner(group).nodeHeight = thisHeight;
    if (thisLayout.isAboveViewRoot) return group;
    // Background
    var bg = giveGraphic('background', $18d50cff0674fa11$var$Rect, depth, $18d50cff0674fa11$var$Z2_BG);
    bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
    var emphasisModel = nodeModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var isDisabled = emphasisModel.get('disabled');
    var focusOrIndices = focus === 'ancestor' ? thisNode.getAncestorsIndices() : focus === 'descendant' ? thisNode.getDescendantIndices() : focus;
    // No children, render content.
    if (isParent) {
        // Because of the implementation about "traverse" in graphic hover style, we
        // can not set hover listener on the "group" of non-leaf node. Otherwise the
        // hover event from the descendents will be listenered.
        if ((0, $bwPbQ.isHighDownDispatcher)(group)) (0, $bwPbQ.setAsHighDownDispatcher)(group, false);
        if (bg) {
            (0, $bwPbQ.setAsHighDownDispatcher)(bg, !isDisabled);
            // Only for enabling highlight/downplay.
            data.setItemGraphicEl(thisNode.dataIndex, bg);
            (0, $bwPbQ.enableHoverFocus)(bg, focusOrIndices, blurScope);
        }
    } else {
        var content = giveGraphic('content', $18d50cff0674fa11$var$Rect, depth, $18d50cff0674fa11$var$Z2_CONTENT);
        content && renderContent(group, content);
        bg.disableMorphing = true;
        if (bg && (0, $bwPbQ.isHighDownDispatcher)(bg)) (0, $bwPbQ.setAsHighDownDispatcher)(bg, false);
        (0, $bwPbQ.setAsHighDownDispatcher)(group, !isDisabled);
        // Only for enabling highlight/downplay.
        data.setItemGraphicEl(thisNode.dataIndex, group);
        var cursorStyle = nodeModel.getShallow('cursor');
        cursorStyle && content.attr('cursor', cursorStyle);
        (0, $bwPbQ.enableHoverFocus)(group, focusOrIndices, blurScope);
    }
    return group;
    // ----------------------------
    // | Procedures in renderNode |
    // ----------------------------
    function renderBackground(group, bg, useUpperLabel) {
        var ecData = (0, $6TSUP.getECData)(bg);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        bg.setShape({
            x: 0,
            y: 0,
            width: thisWidth,
            height: thisHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(bg);
        else {
            bg.invisible = false;
            var style = thisNode.getVisual('style');
            var visualBorderColor = style.stroke;
            var normalStyle = $18d50cff0674fa11$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualBorderColor;
            var emphasisStyle = $18d50cff0674fa11$var$getStateItemStyle(itemStyleEmphasisModel);
            emphasisStyle.fill = itemStyleEmphasisModel.get('borderColor');
            var blurStyle = $18d50cff0674fa11$var$getStateItemStyle(itemStyleBlurModel);
            blurStyle.fill = itemStyleBlurModel.get('borderColor');
            var selectStyle = $18d50cff0674fa11$var$getStateItemStyle(itemStyleSelectModel);
            selectStyle.fill = itemStyleSelectModel.get('borderColor');
            if (useUpperLabel) {
                var upperLabelWidth = thisWidth - 2 * borderWidth;
                prepareText(// PENDING: convert ZRColor to ColorString for text.
                bg, visualBorderColor, style.opacity, {
                    x: borderWidth,
                    y: 0,
                    width: upperLabelWidth,
                    height: upperHeight
                });
            } else bg.removeTextContent();
            bg.setStyle(normalStyle);
            bg.ensureState('emphasis').style = emphasisStyle;
            bg.ensureState('blur').style = blurStyle;
            bg.ensureState('select').style = selectStyle;
            (0, $bwPbQ.setDefaultStateProxy)(bg);
        }
        group.add(bg);
    }
    function renderContent(group, content) {
        var ecData = (0, $6TSUP.getECData)(content);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
        var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
        content.culling = true;
        content.setShape({
            x: borderWidth,
            y: borderWidth,
            width: contentWidth,
            height: contentHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(content);
        else {
            content.invisible = false;
            var nodeStyle = thisNode.getVisual('style');
            var visualColor = nodeStyle.fill;
            var normalStyle = $18d50cff0674fa11$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualColor;
            normalStyle.decal = nodeStyle.decal;
            var emphasisStyle = $18d50cff0674fa11$var$getStateItemStyle(itemStyleEmphasisModel);
            var blurStyle = $18d50cff0674fa11$var$getStateItemStyle(itemStyleBlurModel);
            var selectStyle = $18d50cff0674fa11$var$getStateItemStyle(itemStyleSelectModel);
            // PENDING: convert ZRColor to ColorString for text.
            prepareText(content, visualColor, nodeStyle.opacity, null);
            content.setStyle(normalStyle);
            content.ensureState('emphasis').style = emphasisStyle;
            content.ensureState('blur').style = blurStyle;
            content.ensureState('select').style = selectStyle;
            (0, $bwPbQ.setDefaultStateProxy)(content);
        }
        group.add(content);
    }
    function processInvisible(element) {
        // Delay invisible setting utill animation finished,
        // avoid element vanish suddenly before animation.
        !element.invisible && willInvisibleEls.push(element);
    }
    function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
    upperLabelRect) {
        var normalLabelModel = nodeModel.getModel(upperLabelRect ? $18d50cff0674fa11$var$PATH_UPPERLABEL_NORMAL : $18d50cff0674fa11$var$PATH_LABEL_NOAMAL);
        var defaultText = (0, $bx3T8.convertOptionIdName)(nodeModel.get('name'), null);
        var isShow = normalLabelModel.getShallow('show');
        (0, $bysmE.setLabelStyle)(rectEl, (0, $bysmE.getLabelStatesModels)(nodeModel, upperLabelRect ? $18d50cff0674fa11$var$PATH_UPPERLABEL_NORMAL : $18d50cff0674fa11$var$PATH_LABEL_NOAMAL), {
            defaultText: isShow ? defaultText : null,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            labelFetcher: seriesModel,
            labelDataIndex: thisNode.dataIndex
        });
        var textEl = rectEl.getTextContent();
        if (!textEl) return;
        var textStyle = textEl.style;
        var textPadding = (0, $2N6Uo.normalizeCssArray)(textStyle.padding || 0);
        if (upperLabelRect) {
            rectEl.setTextConfig({
                layoutRect: upperLabelRect
            });
            textEl.disableLabelLayout = true;
        }
        textEl.beforeUpdate = function() {
            var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
            var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);
            if (textStyle.width !== width || textStyle.height !== height) textEl.setStyle({
                width: width,
                height: height
            });
        };
        textStyle.truncateMinChar = 2;
        textStyle.lineOverflow = 'truncate';
        addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
        var textEmphasisState = textEl.getState('emphasis');
        addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
    }
    function addDrillDownIcon(style, upperLabelRect, thisLayout) {
        var text = style ? style.text : null;
        if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
            var iconChar = seriesModel.get('drillDownIcon', true);
            style.text = iconChar ? iconChar + ' ' + text : text;
        }
    }
    function giveGraphic(storageName, Ctor, depth, z) {
        var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
        var lasts = lastsForAnimation[storageName];
        if (element) {
            // Remove from oldStorage
            oldStorage[storageName][oldRawIndex] = null;
            prepareAnimationWhenHasOld(lasts, element);
        } else if (!thisInvisible) {
            element = new Ctor();
            if (element instanceof (0, $6Ekel.default)) element.z2 = $18d50cff0674fa11$var$calculateZ2(depth, z);
            prepareAnimationWhenNoOld(lasts, element);
        }
        // Set to thisStorage
        return thisStorage[storageName][thisRawIndex] = element;
    }
    function prepareAnimationWhenHasOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        if (element instanceof $18d50cff0674fa11$var$Group) {
            lastCfg.oldX = element.x;
            lastCfg.oldY = element.y;
        } else lastCfg.oldShape = (0, $2N6Uo.extend)({}, element.shape);
    }
    // If a element is new, we need to find the animation start point carefully,
    // otherwise it will looks strange when 'zoomToNode'.
    function prepareAnimationWhenNoOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        var parentNode = thisNode.parentNode;
        var isGroup = element instanceof $iQonF.default;
        if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
            var parentOldX = 0;
            var parentOldY = 0;
            // New nodes appear from right-bottom corner in 'zoomToNode' animation.
            // For convenience, get old bounding rect from background.
            var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
            if (!reRoot && parentOldBg && parentOldBg.oldShape) {
                parentOldX = parentOldBg.oldShape.width;
                parentOldY = parentOldBg.oldShape.height;
            }
            // When no parent old shape found, its parent is new too,
            // so we can just use {x:0, y:0}.
            if (isGroup) {
                lastCfg.oldX = 0;
                lastCfg.oldY = parentOldY;
            } else lastCfg.oldShape = {
                x: parentOldX,
                y: parentOldY,
                width: 0,
                height: 0
            };
        }
        // Fade in, user can be aware that these nodes are new.
        lastCfg.fadein = !isGroup;
    }
}
// We cannot set all background with the same z, because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause lower background elements to overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.
function $18d50cff0674fa11$var$calculateZ2(depth, z2InLevel) {
    return depth * $18d50cff0674fa11$var$Z2_BASE + z2InLevel;
}
var $18d50cff0674fa11$export$2e2bcd8739ae039 = $18d50cff0674fa11$var$TreemapView;

});
parcelRegister("bPLXT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89d9a9fd8613b002$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $hXTRG = parcelRequire("hXTRG");
var $kBKw3 = parcelRequire("kBKw3");

var $6TSUP = parcelRequire("6TSUP");

var $a35Wn = parcelRequire("a35Wn");

var $hs88U = parcelRequire("hs88U");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");
var $89d9a9fd8613b002$var$TEXT_PADDING = 8;
var $89d9a9fd8613b002$var$ITEM_GAP = 8;
var $89d9a9fd8613b002$var$ARRAY_LENGTH = 5;
var $89d9a9fd8613b002$var$Breadcrumb = /** @class */ function() {
    function Breadcrumb(containerGroup) {
        this.group = new $iQonF.default();
        containerGroup.add(this.group);
    }
    Breadcrumb.prototype.render = function(seriesModel, api, targetNode, onSelect) {
        var model = seriesModel.getModel('breadcrumb');
        var thisGroup = this.group;
        thisGroup.removeAll();
        if (!model.get('show') || !targetNode) return;
        var normalStyleModel = model.getModel('itemStyle');
        var emphasisModel = model.getModel('emphasis');
        var textStyleModel = normalStyleModel.getModel('textStyle');
        var emphasisTextStyleModel = emphasisModel.getModel([
            'itemStyle',
            'textStyle'
        ]);
        var refContainer = $a35Wn.createBoxLayoutReference(seriesModel, api).refContainer;
        var boxLayoutParams = {
            left: model.get('left'),
            right: model.get('right'),
            top: model.get('top'),
            bottom: model.get('bottom')
        };
        var layoutParam = {
            emptyItemWidth: model.get('emptyItemWidth'),
            totalWidth: 0,
            renderList: []
        };
        var availableSize = $a35Wn.getLayoutRect(boxLayoutParams, refContainer);
        this._prepare(targetNode, layoutParam, textStyleModel);
        this._renderContent(seriesModel, layoutParam, availableSize, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect);
        $a35Wn.positionElement(thisGroup, boxLayoutParams, refContainer);
    };
    /**
   * Prepare render list and total width
   * @private
   */ Breadcrumb.prototype._prepare = function(targetNode, layoutParam, textStyleModel) {
        for(var node = targetNode; node; node = node.parentNode){
            var text = (0, $bx3T8.convertOptionIdName)(node.getModel().get('name'), '');
            var textRect = textStyleModel.getTextRect(text);
            var itemWidth = Math.max(textRect.width + $89d9a9fd8613b002$var$TEXT_PADDING * 2, layoutParam.emptyItemWidth);
            layoutParam.totalWidth += itemWidth + $89d9a9fd8613b002$var$ITEM_GAP;
            layoutParam.renderList.push({
                node: node,
                text: text,
                width: itemWidth
            });
        }
    };
    /**
   * @private
   */ Breadcrumb.prototype._renderContent = function(seriesModel, layoutParam, availableSize, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect) {
        // Start rendering.
        var lastX = 0;
        var emptyItemWidth = layoutParam.emptyItemWidth;
        var height = seriesModel.get([
            'breadcrumb',
            'height'
        ]);
        var totalWidth = layoutParam.totalWidth;
        var renderList = layoutParam.renderList;
        var emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
        for(var i = renderList.length - 1; i >= 0; i--){
            var item = renderList[i];
            var itemNode = item.node;
            var itemWidth = item.width;
            var text = item.text;
            // Hdie text and shorten width if necessary.
            if (totalWidth > availableSize.width) {
                totalWidth -= itemWidth - emptyItemWidth;
                itemWidth = emptyItemWidth;
                text = null;
            }
            var el = new $hXTRG.default({
                shape: {
                    points: $89d9a9fd8613b002$var$makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
                },
                style: (0, $2N6Uo.defaults)(normalStyleModel.getItemStyle(), {
                    lineJoin: 'bevel'
                }),
                textContent: new $kBKw3.default({
                    style: (0, $bysmE.createTextStyle)(textStyleModel, {
                        text: text
                    })
                }),
                textConfig: {
                    position: 'inside'
                },
                z2: (0, $bwPbQ.Z2_EMPHASIS_LIFT) * 1e4,
                onclick: (0, $2N6Uo.curry)(onSelect, itemNode)
            });
            el.disableLabelAnimation = true;
            el.getTextContent().ensureState('emphasis').style = (0, $bysmE.createTextStyle)(emphasisTextStyleModel, {
                text: text
            });
            el.ensureState('emphasis').style = emphasisItemStyle;
            (0, $bwPbQ.toggleHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
            this.group.add(el);
            $89d9a9fd8613b002$var$packEventData(el, seriesModel, itemNode);
            lastX += itemWidth + $89d9a9fd8613b002$var$ITEM_GAP;
        }
    };
    Breadcrumb.prototype.remove = function() {
        this.group.removeAll();
    };
    return Breadcrumb;
}();
function $89d9a9fd8613b002$var$makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
    var points = [
        [
            head ? x : x - $89d9a9fd8613b002$var$ARRAY_LENGTH,
            y
        ],
        [
            x + itemWidth,
            y
        ],
        [
            x + itemWidth,
            y + itemHeight
        ],
        [
            head ? x : x - $89d9a9fd8613b002$var$ARRAY_LENGTH,
            y + itemHeight
        ]
    ];
    !tail && points.splice(2, 0, [
        x + itemWidth + $89d9a9fd8613b002$var$ARRAY_LENGTH,
        y + itemHeight / 2
    ]);
    !head && points.push([
        x,
        y + itemHeight / 2
    ]);
    return points;
}
// Package custom mouse event.
function $89d9a9fd8613b002$var$packEventData(el, seriesModel, itemNode) {
    (0, $6TSUP.getECData)(el).eventData = {
        componentType: 'series',
        componentSubType: 'treemap',
        componentIndex: seriesModel.componentIndex,
        seriesIndex: seriesModel.seriesIndex,
        seriesName: seriesModel.name,
        seriesType: 'treemap',
        selfType: 'breadcrumb',
        nodeData: {
            dataIndex: itemNode && itemNode.dataIndex,
            name: itemNode && itemNode.name
        },
        treePathInfo: itemNode && (0, $hs88U.wrapTreePathInfo)(itemNode, seriesModel)
    };
}
var $89d9a9fd8613b002$export$2e2bcd8739ae039 = $89d9a9fd8613b002$var$Breadcrumb;

});

parcelRegister("8NkUi", function(module, exports) {

$parcel$export(module.exports, "createWrap", function () { return $66731e0516bab734$export$944643101ee10c7; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Animate multiple elements with a single done-callback.
 *
 * @example
 *  animation
 *      .createWrap()
 *      .add(el1, {x: 10, y: 10})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */ var $66731e0516bab734$var$AnimationWrap = /** @class */ function() {
    function AnimationWrap() {
        this._storage = [];
        this._elExistsMap = {};
    }
    /**
   * Caution: a el can only be added once, otherwise 'done'
   * might not be called. This method checks this (by el.id),
   * suppresses adding and returns false when existing el found.
   *
   * @return Whether adding succeeded.
   */ AnimationWrap.prototype.add = function(el, target, duration, delay, easing) {
        if (this._elExistsMap[el.id]) return false;
        this._elExistsMap[el.id] = true;
        this._storage.push({
            el: el,
            target: target,
            duration: duration,
            delay: delay,
            easing: easing
        });
        return true;
    };
    /**
   * Only execute when animation done/aborted.
   */ AnimationWrap.prototype.finished = function(callback) {
        this._finishedCallback = callback;
        return this;
    };
    /**
   * Will stop exist animation firstly.
   */ AnimationWrap.prototype.start = function() {
        var _this = this;
        var count = this._storage.length;
        var checkTerminate = function() {
            count--;
            if (count <= 0) {
                // Guard.
                _this._storage.length = 0;
                _this._elExistsMap = {};
                _this._finishedCallback && _this._finishedCallback();
            }
        };
        for(var i = 0, len = this._storage.length; i < len; i++){
            var item = this._storage[i];
            item.el.animateTo(item.target, {
                duration: item.duration,
                delay: item.delay,
                easing: item.easing,
                setToFinal: true,
                done: checkTerminate,
                aborted: checkTerminate
            });
        }
        return this;
    };
    return AnimationWrap;
}();
function $66731e0516bab734$export$944643101ee10c7() {
    return new $66731e0516bab734$var$AnimationWrap();
}

});


parcelRegister("9yYp5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f6624eb3bae64ca$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dzLre = parcelRequire("dzLre");

var $2N6Uo = parcelRequire("2N6Uo");

var $3UxDF = parcelRequire("3UxDF");

var $bx3T8 = parcelRequire("bx3T8");
var $6f6624eb3bae64ca$var$ITEM_STYLE_NORMAL = 'itemStyle';
var $6f6624eb3bae64ca$var$inner = (0, $bx3T8.makeInner)();
var $6f6624eb3bae64ca$export$2e2bcd8739ae039 = {
    seriesType: 'treemap',
    reset: function(seriesModel) {
        var tree = seriesModel.getData().tree;
        var root = tree.root;
        if (root.isRemoved()) return;
        $6f6624eb3bae64ca$var$travelTree(root, // Visual should calculate from tree root but not view root.
        {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
    }
};
function $6f6624eb3bae64ca$var$travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
    var nodeModel = node.getModel();
    var nodeLayout = node.getLayout();
    var data = node.hostTree.data;
    // Optimize
    if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) return;
    var nodeItemStyleModel = nodeModel.getModel($6f6624eb3bae64ca$var$ITEM_STYLE_NORMAL);
    var visuals = $6f6624eb3bae64ca$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
    var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
    // calculate border color
    var borderColor = nodeItemStyleModel.get('borderColor');
    var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
    var thisNodeColor;
    if (borderColorSaturation != null) {
        // For performance, do not always execute 'calculateColor'.
        thisNodeColor = $6f6624eb3bae64ca$var$calculateColor(visuals);
        borderColor = $6f6624eb3bae64ca$var$calculateBorderColor(borderColorSaturation, thisNodeColor);
    }
    existsStyle.stroke = borderColor;
    var viewChildren = node.viewChildren;
    if (!viewChildren || !viewChildren.length) {
        thisNodeColor = $6f6624eb3bae64ca$var$calculateColor(visuals);
        // Apply visual to this node.
        existsStyle.fill = thisNodeColor;
    } else {
        var mapping_1 = $6f6624eb3bae64ca$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren);
        // Designate visual to children.
        (0, $2N6Uo.each)(viewChildren, function(child, index) {
            // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
            if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
                var childVisual = $6f6624eb3bae64ca$var$mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
                $6f6624eb3bae64ca$var$travelTree(child, childVisual, viewRootAncestors, seriesModel);
            }
        });
    }
}
function $6f6624eb3bae64ca$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
    var visuals = (0, $2N6Uo.extend)({}, designatedVisual);
    var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
    (0, $2N6Uo.each)([
        'color',
        'colorAlpha',
        'colorSaturation'
    ], function(visualName) {
        // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
        designatedVisualItemStyle[visualName] = designatedVisual[visualName];
        var val = nodeItemStyleModel.get(visualName);
        designatedVisualItemStyle[visualName] = null;
        val != null && (visuals[visualName] = val);
    });
    return visuals;
}
function $6f6624eb3bae64ca$var$calculateColor(visuals) {
    var color = $6f6624eb3bae64ca$var$getValueVisualDefine(visuals, 'color');
    if (color) {
        var colorAlpha = $6f6624eb3bae64ca$var$getValueVisualDefine(visuals, 'colorAlpha');
        var colorSaturation = $6f6624eb3bae64ca$var$getValueVisualDefine(visuals, 'colorSaturation');
        if (colorSaturation) color = (0, $3UxDF.modifyHSL)(color, null, null, colorSaturation);
        if (colorAlpha) color = (0, $3UxDF.modifyAlpha)(color, colorAlpha);
        return color;
    }
}
function $6f6624eb3bae64ca$var$calculateBorderColor(borderColorSaturation, thisNodeColor) {
    return thisNodeColor != null ? (0, $3UxDF.modifyHSL)(thisNodeColor, null, null, borderColorSaturation) : null;
}
function $6f6624eb3bae64ca$var$getValueVisualDefine(visuals, name) {
    var value = visuals[name];
    if (value != null && value !== 'none') return value;
}
function $6f6624eb3bae64ca$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
    if (!viewChildren || !viewChildren.length) return;
    var rangeVisual = $6f6624eb3bae64ca$var$getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && ($6f6624eb3bae64ca$var$getRangeVisual(nodeModel, 'colorAlpha') || $6f6624eb3bae64ca$var$getRangeVisual(nodeModel, 'colorSaturation'));
    if (!rangeVisual) return;
    var visualMin = nodeModel.get('visualMin');
    var visualMax = nodeModel.get('visualMax');
    var dataExtent = nodeLayout.dataExtent.slice();
    visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
    visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
    var colorMappingBy = nodeModel.get('colorMappingBy');
    var opt = {
        type: rangeVisual.name,
        dataExtent: dataExtent,
        visual: rangeVisual.range
    };
    if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
        opt.mappingMethod = 'category';
        opt.loop = true;
    // categories is ordinal, so do not set opt.categories.
    } else opt.mappingMethod = 'linear';
    var mapping = new (0, $dzLre.default)(opt);
    $6f6624eb3bae64ca$var$inner(mapping).drColorMappingBy = colorMappingBy;
    return mapping;
}
// Notice: If we don't have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node doesn't have children, and its siblings have children,
// and colorRange is set on level-1, then the node cannot be colored.
// So we separate 'colorRange' and 'color' to different attributes.
function $6f6624eb3bae64ca$var$getRangeVisual(nodeModel, name) {
    // 'colorRange', 'colorARange', 'colorSRange'.
    // If not exists on this node, fetch from levels and series.
    var range = nodeModel.get(name);
    return (0, $2N6Uo.isArray)(range) && range.length ? {
        name: name,
        range: range
    } : null;
}
function $6f6624eb3bae64ca$var$mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
    var childVisuals = (0, $2N6Uo.extend)({}, visuals);
    if (mapping) {
        // Only support color, colorAlpha, colorSaturation.
        var mappingType = mapping.type;
        var colorMappingBy = mappingType === 'color' && $6f6624eb3bae64ca$var$inner(mapping).drColorMappingBy;
        var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
        childVisuals[mappingType] = mapping.mapValueToVisual(value);
    }
    return childVisuals;
}

});

parcelRegister("bCdr6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $874daa6ea2954c27$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $67W72 = parcelRequire("67W72");

var $iCU10 = parcelRequire("iCU10");

var $a35Wn = parcelRequire("a35Wn");

var $hs88U = parcelRequire("hs88U");
var $874daa6ea2954c27$var$mathMax = Math.max;
var $874daa6ea2954c27$var$mathMin = Math.min;
var $874daa6ea2954c27$var$retrieveValue = $2N6Uo.retrieve;
var $874daa6ea2954c27$var$each = $2N6Uo.each;
var $874daa6ea2954c27$var$PATH_BORDER_WIDTH = [
    'itemStyle',
    'borderWidth'
];
var $874daa6ea2954c27$var$PATH_GAP_WIDTH = [
    'itemStyle',
    'gapWidth'
];
var $874daa6ea2954c27$var$PATH_UPPER_LABEL_SHOW = [
    'upperLabel',
    'show'
];
var $874daa6ea2954c27$var$PATH_UPPER_LABEL_HEIGHT = [
    'upperLabel',
    'height'
];
var /**
 * @public
 */ $874daa6ea2954c27$export$2e2bcd8739ae039 = {
    seriesType: 'treemap',
    reset: function(seriesModel, ecModel, api, payload) {
        // Layout result in each node:
        // {x, y, width, height, area, borderWidth}
        var seriesOption = seriesModel.option;
        var refContainer = $a35Wn.createBoxLayoutReference(seriesModel, api).refContainer;
        var layoutInfo = $a35Wn.getLayoutRect(seriesModel.getBoxLayoutParams(), refContainer);
        var size = seriesOption.size || []; // Compatible with ec2.
        var containerWidth = (0, $iCU10.parsePercent)($874daa6ea2954c27$var$retrieveValue(layoutInfo.width, size[0]), refContainer.width);
        var containerHeight = (0, $iCU10.parsePercent)($874daa6ea2954c27$var$retrieveValue(layoutInfo.height, size[1]), refContainer.height);
        // Fetch payload info.
        var payloadType = payload && payload.type;
        var types = [
            'treemapZoomToNode',
            'treemapRootToNode'
        ];
        var targetInfo = $hs88U.retrieveTargetInfo(payload, types, seriesModel);
        var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
        var viewRoot = seriesModel.getViewRoot();
        var viewAbovePath = $hs88U.getPathToRoot(viewRoot);
        if (payloadType !== 'treemapMove') {
            var rootSize = payloadType === 'treemapZoomToNode' ? $874daa6ea2954c27$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [
                rootRect.width,
                rootRect.height
            ] : [
                containerWidth,
                containerHeight
            ];
            var sort_1 = seriesOption.sort;
            if (sort_1 && sort_1 !== 'asc' && sort_1 !== 'desc') // Default to be desc order.
            sort_1 = 'desc';
            var options = {
                squareRatio: seriesOption.squareRatio,
                sort: sort_1,
                leafDepth: seriesOption.leafDepth
            };
            // layout should be cleared because using updateView but not update.
            viewRoot.hostTree.clearLayouts();
            // TODO
            // optimize: if out of view clip, do not layout.
            // But take care that if do not render node out of view clip,
            // how to calculate start po
            var viewRootLayout_1 = {
                x: 0,
                y: 0,
                width: rootSize[0],
                height: rootSize[1],
                area: rootSize[0] * rootSize[1]
            };
            viewRoot.setLayout(viewRootLayout_1);
            $874daa6ea2954c27$var$squarify(viewRoot, options, false, 0);
            // Supplement layout.
            viewRootLayout_1 = viewRoot.getLayout();
            $874daa6ea2954c27$var$each(viewAbovePath, function(node, index) {
                var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
                node.setLayout($2N6Uo.extend({
                    dataExtent: [
                        childValue,
                        childValue
                    ],
                    borderWidth: 0,
                    upperHeight: 0
                }, viewRootLayout_1));
            });
        }
        var treeRoot = seriesModel.getData().tree.root;
        treeRoot.setLayout($874daa6ea2954c27$var$calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
        seriesModel.setLayoutInfo(layoutInfo);
        // FIXME: narrow down pruning boungding rect.
        // Currently ec width/height is used becuases clip is not supported.
        $874daa6ea2954c27$var$prunning(treeRoot, // Transform to base element coordinate system.
        new (0, $67W72.default)(-layoutInfo.x, -layoutInfo.y, api.getWidth(), api.getHeight()), viewAbovePath, viewRoot, 0);
    }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */ function $874daa6ea2954c27$var$squarify(node, options, hideChildren, depth) {
    var width;
    var height;
    if (node.isRemoved()) return;
    var thisLayout = node.getLayout();
    width = thisLayout.width;
    height = thisLayout.height;
    // Considering border and gap
    var nodeModel = node.getModel();
    var borderWidth = nodeModel.get($874daa6ea2954c27$var$PATH_BORDER_WIDTH);
    var halfGapWidth = nodeModel.get($874daa6ea2954c27$var$PATH_GAP_WIDTH) / 2;
    var upperLabelHeight = $874daa6ea2954c27$var$getUpperLabelHeight(nodeModel);
    var upperHeight = Math.max(borderWidth, upperLabelHeight);
    var layoutOffset = borderWidth - halfGapWidth;
    var layoutOffsetUpper = upperHeight - halfGapWidth;
    node.setLayout({
        borderWidth: borderWidth,
        upperHeight: upperHeight,
        upperLabelHeight: upperLabelHeight
    }, true);
    width = $874daa6ea2954c27$var$mathMax(width - 2 * layoutOffset, 0);
    height = $874daa6ea2954c27$var$mathMax(height - layoutOffset - layoutOffsetUpper, 0);
    var totalArea = width * height;
    var viewChildren = $874daa6ea2954c27$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
    if (!viewChildren.length) return;
    var rect = {
        x: layoutOffset,
        y: layoutOffsetUpper,
        width: width,
        height: height
    };
    var rowFixedLength = $874daa6ea2954c27$var$mathMin(width, height);
    var best = Infinity; // the best row score so far
    var row = [];
    row.area = 0;
    for(var i = 0, len = viewChildren.length; i < len;){
        var child = viewChildren[i];
        row.push(child);
        row.area += child.getLayout().area;
        var score = $874daa6ea2954c27$var$worst(row, rowFixedLength, options.squareRatio);
        // continue with this orientation
        if (score <= best) {
            i++;
            best = score;
        } else {
            row.area -= row.pop().getLayout().area;
            $874daa6ea2954c27$var$position(row, rowFixedLength, rect, halfGapWidth, false);
            rowFixedLength = $874daa6ea2954c27$var$mathMin(rect.width, rect.height);
            row.length = row.area = 0;
            best = Infinity;
        }
    }
    if (row.length) $874daa6ea2954c27$var$position(row, rowFixedLength, rect, halfGapWidth, true);
    if (!hideChildren) {
        var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
        if (childrenVisibleMin != null && totalArea < childrenVisibleMin) hideChildren = true;
    }
    for(var i = 0, len = viewChildren.length; i < len; i++)$874daa6ea2954c27$var$squarify(viewChildren[i], options, hideChildren, depth + 1);
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */ function $874daa6ea2954c27$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
    var viewChildren = node.children || [];
    var orderBy = options.sort;
    orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
    var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth;
    // leafDepth has higher priority.
    if (hideChildren && !overLeafDepth) return node.viewChildren = [];
    // Sort children, order by desc.
    viewChildren = $2N6Uo.filter(viewChildren, function(child) {
        return !child.isRemoved();
    });
    $874daa6ea2954c27$var$sort(viewChildren, orderBy);
    var info = $874daa6ea2954c27$var$statistic(nodeModel, viewChildren, orderBy);
    if (info.sum === 0) return node.viewChildren = [];
    info.sum = $874daa6ea2954c27$var$filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
    if (info.sum === 0) return node.viewChildren = [];
    // Set area to each child.
    for(var i = 0, len = viewChildren.length; i < len; i++){
        var area = viewChildren[i].getValue() / info.sum * totalArea;
        // Do not use setLayout({...}, true), because it is needed to clear last layout.
        viewChildren[i].setLayout({
            area: area
        });
    }
    if (overLeafDepth) {
        viewChildren.length && node.setLayout({
            isLeafRoot: true
        }, true);
        viewChildren.length = 0;
    }
    node.viewChildren = viewChildren;
    node.setLayout({
        dataExtent: info.dataExtent
    }, true);
    return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */ function $874daa6ea2954c27$var$filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
    // visibleMin is not supported yet when no option.sort.
    if (!orderBy) return sum;
    var visibleMin = nodeModel.get('visibleMin');
    var len = orderedChildren.length;
    var deletePoint = len;
    // Always travel from little value to big value.
    for(var i = len - 1; i >= 0; i--){
        var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
        if (value / sum * totalArea < visibleMin) {
            deletePoint = i;
            sum -= value;
        }
    }
    orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
    return sum;
}
/**
 * Sort
 */ function $874daa6ea2954c27$var$sort(viewChildren, orderBy) {
    if (orderBy) viewChildren.sort(function(a, b) {
        var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
        return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
    return viewChildren;
}
/**
 * Statistic
 */ function $874daa6ea2954c27$var$statistic(nodeModel, children, orderBy) {
    // Calculate sum.
    var sum = 0;
    for(var i = 0, len = children.length; i < len; i++)sum += children[i].getValue();
    // Statistic data extent for latter visual coding.
    // Notice: data extent should be calculate based on raw children
    // but not filtered view children, otherwise visual mapping will not
    // be stable when zoom (where children is filtered by visibleMin).
    var dimension = nodeModel.get('visualDimension');
    var dataExtent;
    // The same as area dimension.
    if (!children || !children.length) dataExtent = [
        NaN,
        NaN
    ];
    else if (dimension === 'value' && orderBy) {
        dataExtent = [
            children[children.length - 1].getValue(),
            children[0].getValue()
        ];
        orderBy === 'asc' && dataExtent.reverse();
    } else {
        dataExtent = [
            Infinity,
            -Infinity
        ];
        $874daa6ea2954c27$var$each(children, function(child) {
            var value = child.getValue(dimension);
            value < dataExtent[0] && (dataExtent[0] = value);
            value > dataExtent[1] && (dataExtent[1] = value);
        });
    }
    return {
        sum: sum,
        dataExtent: dataExtent
    };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */ function $874daa6ea2954c27$var$worst(row, rowFixedLength, ratio) {
    var areaMax = 0;
    var areaMin = Infinity;
    for(var i = 0, area = void 0, len = row.length; i < len; i++){
        area = row[i].getLayout().area;
        if (area) {
            area < areaMin && (areaMin = area);
            area > areaMax && (areaMax = area);
        }
    }
    var squareArea = row.area * row.area;
    var f = rowFixedLength * rowFixedLength * ratio;
    return squareArea ? $874daa6ea2954c27$var$mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */ function $874daa6ea2954c27$var$position(row, rowFixedLength, rect, halfGapWidth, flush) {
    // When rowFixedLength === rect.width,
    // it is horizontal subdivision,
    // rowFixedLength is the width of the subdivision,
    // rowOtherLength is the height of the subdivision,
    // and nodes will be positioned from left to right.
    // wh[idx0WhenH] means: when horizontal,
    //      wh[idx0WhenH] => wh[0] => 'width'.
    //      xy[idx1WhenH] => xy[1] => 'y'.
    var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
    var idx1WhenH = 1 - idx0WhenH;
    var xy = [
        'x',
        'y'
    ];
    var wh = [
        'width',
        'height'
    ];
    var last = rect[xy[idx0WhenH]];
    var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
    if (flush || rowOtherLength > rect[wh[idx1WhenH]]) rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
    for(var i = 0, rowLen = row.length; i < rowLen; i++){
        var node = row[i];
        var nodeLayout = {};
        var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
        var wh1 = nodeLayout[wh[idx1WhenH]] = $874daa6ea2954c27$var$mathMax(rowOtherLength - 2 * halfGapWidth, 0);
        // We use Math.max/min to avoid negative width/height when considering gap width.
        var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
        var modWH = i === rowLen - 1 || remain < step ? remain : step;
        var wh0 = nodeLayout[wh[idx0WhenH]] = $874daa6ea2954c27$var$mathMax(modWH - 2 * halfGapWidth, 0);
        nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + $874daa6ea2954c27$var$mathMin(halfGapWidth, wh1 / 2);
        nodeLayout[xy[idx0WhenH]] = last + $874daa6ea2954c27$var$mathMin(halfGapWidth, wh0 / 2);
        last += modWH;
        node.setLayout(nodeLayout, true);
    }
    rect[xy[idx1WhenH]] += rowOtherLength;
    rect[wh[idx1WhenH]] -= rowOtherLength;
}
// Return [containerWidth, containerHeight] as default.
function $874daa6ea2954c27$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
    // If targetInfo.node exists, we zoom to the node,
    // so estimate whole width and height by target node.
    var currNode = (targetInfo || {}).node;
    var defaultSize = [
        containerWidth,
        containerHeight
    ];
    if (!currNode || currNode === viewRoot) return defaultSize;
    var parent;
    var viewArea = containerWidth * containerHeight;
    var area = viewArea * seriesModel.option.zoomToNodeRatio;
    while(parent = currNode.parentNode){
        // jshint ignore:line
        var sum = 0;
        var siblings = parent.children;
        for(var i = 0, len = siblings.length; i < len; i++)sum += siblings[i].getValue();
        var currNodeValue = currNode.getValue();
        if (currNodeValue === 0) return defaultSize;
        area *= sum / currNodeValue;
        // Considering border, suppose aspect ratio is 1.
        var parentModel = parent.getModel();
        var borderWidth = parentModel.get($874daa6ea2954c27$var$PATH_BORDER_WIDTH);
        var upperHeight = Math.max(borderWidth, $874daa6ea2954c27$var$getUpperLabelHeight(parentModel));
        area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
        area > (0, $iCU10.MAX_SAFE_INTEGER) && (area = (0, $iCU10.MAX_SAFE_INTEGER));
        currNode = parent;
    }
    area < viewArea && (area = viewArea);
    var scale = Math.pow(area / viewArea, 0.5);
    return [
        containerWidth * scale,
        containerHeight * scale
    ];
}
// Root position based on coord of containerGroup
function $874daa6ea2954c27$var$calculateRootPosition(layoutInfo, rootRect, targetInfo) {
    if (rootRect) return {
        x: rootRect.x,
        y: rootRect.y
    };
    var defaultPosition = {
        x: 0,
        y: 0
    };
    if (!targetInfo) return defaultPosition;
    // If targetInfo is fetched by 'retrieveTargetInfo',
    // old tree and new tree are the same tree,
    // so the node still exists and we can visit it.
    var targetNode = targetInfo.node;
    var layout = targetNode.getLayout();
    if (!layout) return defaultPosition;
    // Transform coord from local to container.
    var targetCenter = [
        layout.width / 2,
        layout.height / 2
    ];
    var node = targetNode;
    while(node){
        var nodeLayout = node.getLayout();
        targetCenter[0] += nodeLayout.x;
        targetCenter[1] += nodeLayout.y;
        node = node.parentNode;
    }
    return {
        x: layoutInfo.width / 2 - targetCenter[0],
        y: layoutInfo.height / 2 - targetCenter[1]
    };
}
// Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.
function $874daa6ea2954c27$var$prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
    var nodeLayout = node.getLayout();
    var nodeInViewAbovePath = viewAbovePath[depth];
    var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
    if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) return;
    node.setLayout({
        // isInView means: viewRoot sub tree + viewAbovePath
        isInView: true,
        // invisible only means: outside view clip so that the node can not
        // see but still layout for animation preparation but not render.
        invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
        isAboveViewRoot: isAboveViewRoot
    }, true);
    // Transform to child coordinate.
    var childClipRect = new (0, $67W72.default)(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
    $874daa6ea2954c27$var$each(node.viewChildren || [], function(child) {
        $874daa6ea2954c27$var$prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
    });
}
function $874daa6ea2954c27$var$getUpperLabelHeight(model) {
    return model.get($874daa6ea2954c27$var$PATH_UPPER_LABEL_SHOW) ? model.get($874daa6ea2954c27$var$PATH_UPPER_LABEL_HEIGHT) : 0;
}

});


parcelRegister("9PcLo", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $7272c701e83885df$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $j55Q3 = parcelRequire("j55Q3");

var $5yqAr = parcelRequire("5yqAr");
function $7272c701e83885df$export$4b3e715f166fdd78(registers) {
    registers.registerPreprocessor((0, $5yqAr.default));
    registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, (0, $j55Q3.default));
}

});
parcelRegister("j55Q3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de43035eec877a78$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $1E7rO = parcelRequire("1E7rO");
var $de43035eec877a78$var$DEFAULT_OPTION = {
    label: {
        enabled: true
    },
    decal: {
        show: false
    }
};
var $de43035eec877a78$var$inner = (0, $bx3T8.makeInner)();
var $de43035eec877a78$var$decalPaletteScope = {};
function $de43035eec877a78$export$2e2bcd8739ae039(ecModel, api) {
    var ariaModel = ecModel.getModel('aria');
    // See "area enabled" detection code in `GlobalModel.ts`.
    if (!ariaModel.get('enabled')) return;
    var defaultOption = $2N6Uo.clone($de43035eec877a78$var$DEFAULT_OPTION);
    $2N6Uo.merge(defaultOption.label, ecModel.getLocaleModel().get('aria'), false);
    $2N6Uo.merge(ariaModel.option, defaultOption, false);
    setDecal();
    setLabel();
    function setDecal() {
        var decalModel = ariaModel.getModel('decal');
        var useDecal = decalModel.get('show');
        if (useDecal) {
            // Each type of series use one scope.
            // Pie and funnel are using different scopes.
            var paletteScopeGroupByType_1 = $2N6Uo.createHashMap();
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries()) return;
                var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);
                if (!decalScope) {
                    decalScope = {};
                    paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
                }
                $de43035eec877a78$var$inner(seriesModel).scope = decalScope;
            });
            ecModel.eachRawSeries(function(seriesModel) {
                if (ecModel.isSeriesFiltered(seriesModel)) return;
                if ($2N6Uo.isFunction(seriesModel.enableAriaDecal)) {
                    // Let series define how to use decal palette on data
                    seriesModel.enableAriaDecal();
                    return;
                }
                var data = seriesModel.getData();
                if (!seriesModel.isColorBySeries()) {
                    var dataAll_1 = seriesModel.getRawData();
                    var idxMap_1 = {};
                    var decalScope_1 = $de43035eec877a78$var$inner(seriesModel).scope;
                    data.each(function(idx) {
                        var rawIdx = data.getRawIndex(idx);
                        idxMap_1[rawIdx] = idx;
                    });
                    var dataCount_1 = dataAll_1.count();
                    dataAll_1.each(function(rawIdx) {
                        var idx = idxMap_1[rawIdx];
                        var name = dataAll_1.getName(rawIdx) || rawIdx + '';
                        var paletteDecal = (0, $1E7rO.getDecalFromPalette)(seriesModel.ecModel, name, decalScope_1, dataCount_1);
                        var specifiedDecal = data.getItemVisual(idx, 'decal');
                        data.setItemVisual(idx, 'decal', mergeDecal(specifiedDecal, paletteDecal));
                    });
                } else {
                    var paletteDecal = (0, $1E7rO.getDecalFromPalette)(seriesModel.ecModel, seriesModel.name, $de43035eec877a78$var$decalPaletteScope, ecModel.getSeriesCount());
                    var specifiedDecal = data.getVisual('decal');
                    data.setVisual('decal', mergeDecal(specifiedDecal, paletteDecal));
                }
                function mergeDecal(specifiedDecal, paletteDecal) {
                    // Merge decal from palette to decal from itemStyle.
                    // User do not need to specify all of the decal props.
                    var resultDecal = specifiedDecal ? $2N6Uo.extend($2N6Uo.extend({}, paletteDecal), specifiedDecal) : paletteDecal;
                    resultDecal.dirty = true;
                    return resultDecal;
                }
            });
        }
    }
    function setLabel() {
        var dom = api.getZr().dom;
        // TODO: support for SSR
        if (!dom) return;
        var labelLocale = ecModel.getLocaleModel().get('aria');
        var labelModel = ariaModel.getModel('label');
        labelModel.option = $2N6Uo.defaults(labelModel.option, labelLocale);
        if (!labelModel.get('enabled')) return;
        dom.setAttribute('role', 'img');
        if (labelModel.get('description')) {
            dom.setAttribute('aria-label', labelModel.get('description'));
            return;
        }
        var seriesCnt = ecModel.getSeriesCount();
        var maxDataCnt = labelModel.get([
            'data',
            'maxCount'
        ]) || 10;
        var maxSeriesCnt = labelModel.get([
            'series',
            'maxCount'
        ]) || 10;
        var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
        var ariaLabel;
        if (seriesCnt < 1) // No series, no aria label
        return;
        else {
            var title = getTitle();
            if (title) {
                var withTitle = labelModel.get([
                    'general',
                    'withTitle'
                ]);
                ariaLabel = replace(withTitle, {
                    title: title
                });
            } else ariaLabel = labelModel.get([
                'general',
                'withoutTitle'
            ]);
            var seriesLabels_1 = [];
            var prefix = seriesCnt > 1 ? labelModel.get([
                'series',
                'multiple',
                'prefix'
            ]) : labelModel.get([
                'series',
                'single',
                'prefix'
            ]);
            ariaLabel += replace(prefix, {
                seriesCount: seriesCnt
            });
            ecModel.eachSeries(function(seriesModel, idx) {
                if (idx < displaySeriesCnt) {
                    var seriesLabel = void 0;
                    var seriesName = seriesModel.get('name');
                    var withName = seriesName ? 'withName' : 'withoutName';
                    seriesLabel = seriesCnt > 1 ? labelModel.get([
                        'series',
                        'multiple',
                        withName
                    ]) : labelModel.get([
                        'series',
                        'single',
                        withName
                    ]);
                    seriesLabel = replace(seriesLabel, {
                        seriesId: seriesModel.seriesIndex,
                        seriesName: seriesModel.get('name'),
                        seriesType: getSeriesTypeName(seriesModel.subType)
                    });
                    var data = seriesModel.getData();
                    if (data.count() > maxDataCnt) {
                        // Show part of data
                        var partialLabel = labelModel.get([
                            'data',
                            'partialData'
                        ]);
                        seriesLabel += replace(partialLabel, {
                            displayCnt: maxDataCnt
                        });
                    } else seriesLabel += labelModel.get([
                        'data',
                        'allData'
                    ]);
                    var middleSeparator_1 = labelModel.get([
                        'data',
                        'separator',
                        'middle'
                    ]);
                    var endSeparator_1 = labelModel.get([
                        'data',
                        'separator',
                        'end'
                    ]);
                    var excludeDimensionId_1 = labelModel.get([
                        'data',
                        'excludeDimensionId'
                    ]);
                    var dataLabels = [];
                    for(var i = 0; i < data.count(); i++)if (i < maxDataCnt) {
                        var name_1 = data.getName(i);
                        var value = !excludeDimensionId_1 ? data.getValues(i) : $2N6Uo.filter(data.getValues(i), function(v, j) {
                            return $2N6Uo.indexOf(excludeDimensionId_1, j) === -1;
                        });
                        var dataLabel = labelModel.get([
                            'data',
                            name_1 ? 'withName' : 'withoutName'
                        ]);
                        dataLabels.push(replace(dataLabel, {
                            name: name_1,
                            value: value.join(middleSeparator_1)
                        }));
                    }
                    seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
                    seriesLabels_1.push(seriesLabel);
                }
            });
            var separatorModel = labelModel.getModel([
                'series',
                'multiple',
                'separator'
            ]);
            var middleSeparator = separatorModel.get('middle');
            var endSeparator = separatorModel.get('end');
            ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
            dom.setAttribute('aria-label', ariaLabel);
        }
    }
    function replace(str, keyValues) {
        if (!$2N6Uo.isString(str)) return str;
        var result = str;
        $2N6Uo.each(keyValues, function(value, key) {
            result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
        });
        return result;
    }
    function getTitle() {
        var title = ecModel.get('title');
        if (title && title.length) title = title[0];
        return title && title.text;
    }
    function getSeriesTypeName(type) {
        var typeNames = ecModel.getLocaleModel().get([
            'series',
            'typeNames'
        ]);
        return typeNames[type] || typeNames.chart;
    }
}

});

parcelRegister("5yqAr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40b4c04a82a00d0f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $40b4c04a82a00d0f$export$2e2bcd8739ae039(option) {
    if (!option || !option.aria) return;
    var aria = option.aria;
    // aria.show is deprecated and should use aria.enabled instead
    if (aria.show != null) aria.enabled = aria.show;
    aria.label = aria.label || {};
    // move description, general, series, data to be under aria.label
    $2N6Uo.each([
        'description',
        'general',
        'series',
        'data'
    ], function(name) {
        if (aria[name] != null) aria.label[name] = aria[name];
    });
}

});


parcelRegister("24qes", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $18204daa827f46dd$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cjjFP = parcelRequire("cjjFP");

var $52Ytr = parcelRequire("52Ytr");

var $1EZRa = parcelRequire("1EZRa");

var $2wZH8 = parcelRequire("2wZH8");

var $2N6Uo = parcelRequire("2N6Uo");

var $enAKb = parcelRequire("enAKb");

var $1gHL9 = parcelRequire("1gHL9");
function $18204daa827f46dd$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $cjjFP.default).registerAxisPointerClass('CartesianAxisPointer', (0, $52Ytr.default));
    registers.registerComponentModel((0, $1EZRa.default));
    registers.registerComponentView((0, $2wZH8.default));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $2N6Uo.isArray)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $enAKb.collect)(ecModel, api);
    });
    // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $1gHL9.default));
}

});
parcelRegister("52Ytr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3acc0c7d1782a019$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $fW5EC = parcelRequire("fW5EC");

var $7bAwM = parcelRequire("7bAwM");

var $bYUGA = parcelRequire("bYUGA");
var $3acc0c7d1782a019$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var otherExtent = $3acc0c7d1782a019$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $7bAwM.buildElStyle(axisPointerModel);
            var pointerOption = $3acc0c7d1782a019$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $bYUGA.layout(grid.getRect(), axisModel);
        $7bAwM.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $bYUGA.layout(axisModel.axis.grid.getRect(), axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $7bAwM.getTransformedPosition(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $3acc0c7d1782a019$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $fW5EC.default));
function $3acc0c7d1782a019$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $3acc0c7d1782a019$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $7bAwM.makeLineShape([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $3acc0c7d1782a019$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $7bAwM.makeRectShape([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $3acc0c7d1782a019$var$getAxisDimIndex(axis))
        };
    }
};
function $3acc0c7d1782a019$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $3acc0c7d1782a019$export$2e2bcd8739ae039 = $3acc0c7d1782a019$var$CartesianAxisPointer;

});
parcelRegister("fW5EC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a0a8960172d10c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");

var $enAKb = parcelRequire("enAKb");

var $pGNPI = parcelRequire("pGNPI");

var $99VtN = parcelRequire("99VtN");

var $bx3T8 = parcelRequire("bx3T8");
var $b9a0a8960172d10c$var$inner = (0, $bx3T8.makeInner)();
var $b9a0a8960172d10c$var$clone = $2N6Uo.clone;
var $b9a0a8960172d10c$var$bind = $2N6Uo.bind;
/**
 * Base axis pointer class in 2D.
 */ var $b9a0a8960172d10c$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status');
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $h9U3p.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $2N6Uo.curry($b9a0a8960172d10c$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $b9a0a8960172d10c$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap');
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $enAKb.getAxisInfo(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemenented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $b9a0a8960172d10c$var$inner(group).pointerEl = new $h9U3p[pointerOption.type]($b9a0a8960172d10c$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $b9a0a8960172d10c$var$inner(group).labelEl = new $h9U3p.Text($b9a0a8960172d10c$var$clone(elOption.label));
            group.add(labelEl);
            $b9a0a8960172d10c$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $b9a0a8960172d10c$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $b9a0a8960172d10c$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $b9a0a8960172d10c$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $h9U3p.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function(e) {
                    // For mobile device, prevent screen slider on the button.
                    $pGNPI.stop(e.event);
                },
                onmousedown: $b9a0a8960172d10c$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $b9a0a8960172d10c$var$bind(this._onHandleDragMove, this),
                ondragend: $b9a0a8960172d10c$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $b9a0a8960172d10c$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ]));
        // update position
        var handleSize = handleModel.get('size');
        if (!$2N6Uo.isArray(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $99VtN.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $b9a0a8960172d10c$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $b9a0a8960172d10c$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($b9a0a8960172d10c$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($b9a0a8960172d10c$var$getHandleTransProps(trans));
        $b9a0a8960172d10c$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value');
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $99VtN.clear(this, '_doDispatchAxisPointer');
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $b9a0a8960172d10c$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$b9a0a8960172d10c$var$propsEqual($b9a0a8960172d10c$var$inner(el).lastProp, props)) {
        $b9a0a8960172d10c$var$inner(el).lastProp = props;
        moveAnimation ? $h9U3p.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $b9a0a8960172d10c$var$propsEqual(lastProps, newProps) {
    if ($2N6Uo.isObject(lastProps) && $2N6Uo.isObject(newProps)) {
        var equals_1 = true;
        $2N6Uo.each(newProps, function(item, key) {
            equals_1 = equals_1 && $b9a0a8960172d10c$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $b9a0a8960172d10c$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $b9a0a8960172d10c$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $b9a0a8960172d10c$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $b9a0a8960172d10c$export$2e2bcd8739ae039 = $b9a0a8960172d10c$var$BaseAxisPointer;

});

parcelRegister("7bAwM", function(module, exports) {

$parcel$export(module.exports, "buildElStyle", function () { return $53b5e51d8ffa3561$export$b7fe459c7cc50060; });
$parcel$export(module.exports, "buildLabelElOption", function () { return $53b5e51d8ffa3561$export$8206a9937c45910f; });
$parcel$export(module.exports, "getValueLabel", function () { return $53b5e51d8ffa3561$export$7cffee0f9aed39d0; });
$parcel$export(module.exports, "getTransformedPosition", function () { return $53b5e51d8ffa3561$export$4bb66440324c3a3d; });
$parcel$export(module.exports, "buildCartesianSingleLabelElOption", function () { return $53b5e51d8ffa3561$export$fd3eb3812211a173; });
$parcel$export(module.exports, "makeLineShape", function () { return $53b5e51d8ffa3561$export$885fa0ad5a826207; });
$parcel$export(module.exports, "makeRectShape", function () { return $53b5e51d8ffa3561$export$a8b35248bcc02756; });
$parcel$export(module.exports, "makeSectorShape", function () { return $53b5e51d8ffa3561$export$b0cf82e7ebc0d7d0; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");

var $eVwLk = parcelRequire("eVwLk");

var $hrphB = parcelRequire("hrphB");

var $19Ywy = parcelRequire("19Ywy");

var $9AF98 = parcelRequire("9AF98");

var $fVg7M = parcelRequire("fVg7M");

var $bysmE = parcelRequire("bysmE");
function $53b5e51d8ffa3561$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $53b5e51d8ffa3561$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $53b5e51d8ffa3561$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $hrphB.normalizeCssArray(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $eVwLk.getBoundingRect(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2);
    // Not overflow ec container
    $53b5e51d8ffa3561$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $bysmE.createTextStyle)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $53b5e51d8ffa3561$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $53b5e51d8ffa3561$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $9AF98.getAxisRawValue(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $2N6Uo.each(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($2N6Uo.isString(formatter)) text = formatter.replace('{value}', text);
        else if ($2N6Uo.isFunction(formatter)) text = formatter(params_1);
    }
    return text;
}
function $53b5e51d8ffa3561$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $19Ywy.create();
    $19Ywy.rotate(transform, transform, layoutInfo.rotation);
    $19Ywy.translate(transform, transform, layoutInfo.position);
    return $h9U3p.applyTransform([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $53b5e51d8ffa3561$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    var textLayout = (0, $fVg7M.default).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $53b5e51d8ffa3561$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $53b5e51d8ffa3561$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $53b5e51d8ffa3561$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $53b5e51d8ffa3561$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $53b5e51d8ffa3561$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}

});


parcelRegister("1EZRa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1359824ae17f25db$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");

var $6aXXD = parcelRequire("6aXXD");
var $1359824ae17f25db$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        // zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: (0, $6aXXD.default).color.border,
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: (0, $6aXXD.default).color.shadowTint
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: (0, $6aXXD.default).color.neutral00,
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: (0, $6aXXD.default).color.accent60,
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: (0, $6aXXD.default).color.accent40,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $eLD2b.default));
var $1359824ae17f25db$export$2e2bcd8739ae039 = $1359824ae17f25db$var$AxisPointerModel;

});

parcelRegister("2wZH8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d7e6d31feca49ab$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $9uL27 = parcelRequire("9uL27");

var $bpyST = parcelRequire("bpyST");
var $1d7e6d31feca49ab$var$AxisPointerView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click';
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $9uL27.register('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $9uL27.unregister('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $9uL27.unregister('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $bpyST.default));
var $1d7e6d31feca49ab$export$2e2bcd8739ae039 = $1d7e6d31feca49ab$var$AxisPointerView;

});
parcelRegister("9uL27", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6e9b662fa89e87cb$export$6503ec6e8aabbaf; });
$parcel$export(module.exports, "unregister", function () { return $6e9b662fa89e87cb$export$d07f55d4c15c0440; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $cirKE = parcelRequire("cirKE");

var $bx3T8 = parcelRequire("bx3T8");
var $6e9b662fa89e87cb$var$inner = (0, $bx3T8.makeInner)();
var $6e9b662fa89e87cb$var$each = $2N6Uo.each;
function $6e9b662fa89e87cb$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $cirKE.default).node) return;
    var zr = api.getZr();
    $6e9b662fa89e87cb$var$inner(zr).records || ($6e9b662fa89e87cb$var$inner(zr).records = {});
    $6e9b662fa89e87cb$var$initGlobalListeners(zr, api);
    var record = $6e9b662fa89e87cb$var$inner(zr).records[key] || ($6e9b662fa89e87cb$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $6e9b662fa89e87cb$var$initGlobalListeners(zr, api) {
    if ($6e9b662fa89e87cb$var$inner(zr).initialized) return;
    $6e9b662fa89e87cb$var$inner(zr).initialized = true;
    useHandler('click', $2N6Uo.curry($6e9b662fa89e87cb$var$doEnter, 'click'));
    useHandler('mousemove', $2N6Uo.curry($6e9b662fa89e87cb$var$doEnter, 'mousemove'));
    // useHandler('mouseout', onLeave);
    useHandler('globalout', $6e9b662fa89e87cb$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $6e9b662fa89e87cb$var$makeDispatchAction(api);
            $6e9b662fa89e87cb$var$each($6e9b662fa89e87cb$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $6e9b662fa89e87cb$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $6e9b662fa89e87cb$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $6e9b662fa89e87cb$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $6e9b662fa89e87cb$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $6e9b662fa89e87cb$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $6e9b662fa89e87cb$export$d07f55d4c15c0440(key, api) {
    if ((0, $cirKE.default).node) return;
    var zr = api.getZr();
    var record = ($6e9b662fa89e87cb$var$inner(zr).records || {})[key];
    if (record) $6e9b662fa89e87cb$var$inner(zr).records[key] = null;
}

});


parcelRegister("1gHL9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ec93ac7a26c30af$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");

var $enAKb = parcelRequire("enAKb");

var $jyhKb = parcelRequire("jyhKb");

var $2N6Uo = parcelRequire("2N6Uo");
var $0ec93ac7a26c30af$var$inner = (0, $bx3T8.makeInner)();
function $0ec93ac7a26c30af$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $2N6Uo.bind)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($0ec93ac7a26c30af$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $jyhKb.default)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $0ec93ac7a26c30af$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $0ec93ac7a26c30af$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $2N6Uo.curry)($0ec93ac7a26c30af$var$showPointer, showValueMap),
        showTooltip: (0, $2N6Uo.curry)($0ec93ac7a26c30af$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $2N6Uo.each)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $2N6Uo.each)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $0ec93ac7a26c30af$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $0ec93ac7a26c30af$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $2N6Uo.each)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $2N6Uo.each)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $0ec93ac7a26c30af$var$makeMapperParam(srcAxisInfo), $0ec93ac7a26c30af$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $2N6Uo.each)(linkTriggers, function(val, tarKey) {
        $0ec93ac7a26c30af$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $0ec93ac7a26c30af$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $0ec93ac7a26c30af$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $0ec93ac7a26c30af$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $0ec93ac7a26c30af$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $0ec93ac7a26c30af$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $2N6Uo.extend)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $0ec93ac7a26c30af$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $2N6Uo.each)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.indicesOfNearest(dim, dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $2N6Uo.each)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $0ec93ac7a26c30af$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $0ec93ac7a26c30af$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $enAKb.makeKey(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $0ec93ac7a26c30af$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $2N6Uo.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
        // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $0ec93ac7a26c30af$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($0ec93ac7a26c30af$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $0ec93ac7a26c30af$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $0ec93ac7a26c30af$var$inner(zr)[highDownKey] || {};
    var newHighlights = $0ec93ac7a26c30af$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $2N6Uo.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && axisInfo.triggerEmphasis && (0, $2N6Uo.each)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $2N6Uo.each)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $2N6Uo.each)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $0ec93ac7a26c30af$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $0ec93ac7a26c30af$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $0ec93ac7a26c30af$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

});
parcelRegister("jyhKb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3bef4db6131de99$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");
function $e3bef4db6131de99$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $bx3T8.queryDataIndex(data, finder);
    if (dataIndex == null || dataIndex < 0 || $2N6Uo.isArray(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($2N6Uo.map(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}

});



parcelRegister("2bUOy", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $1988ae0365eed1e2$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hRQdn = parcelRequire("hRQdn");

var $g4FJO = parcelRequire("g4FJO");

var $6RIiy = parcelRequire("6RIiy");

var $36sVS = parcelRequire("36sVS");

var $6B8xa = parcelRequire("6B8xa");

var $14R3P = parcelRequire("14R3P");

var $2N6Uo = parcelRequire("2N6Uo");
function $1988ae0365eed1e2$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $g4FJO.default));
    registers.registerComponentModel((0, $6RIiy.default));
    registers.registerPreprocessor((0, $hRQdn.default));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $36sVS.default));
    registers.registerAction({
        type: 'brush',
        event: 'brush',
        update: 'updateVisual'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'brush',
            query: payload
        }, function(brushModel) {
            brushModel.setAreas(payload.areas);
        });
    });
    /**
   * payload: {
   *      brushComponents: [
   *          {
   *              brushId,
   *              brushIndex,
   *              brushName,
   *              series: [
   *                  {
   *                      seriesId,
   *                      seriesIndex,
   *                      seriesName,
   *                      rawIndices: [21, 34, ...]
   *                  },
   *                  ...
   *              ]
   *          },
   *          ...
   *      ]
   * }
   */ registers.registerAction({
        type: 'brushSelect',
        event: 'brushSelected',
        update: 'none'
    }, (0, $2N6Uo.noop));
    registers.registerAction({
        type: 'brushEnd',
        event: 'brushEnd',
        update: 'none'
    }, (0, $2N6Uo.noop));
    (0, $14R3P.registerFeature)('brush', (0, $6B8xa.default));
}

});
parcelRegister("hRQdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d01fe3a6cacf9ae4$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");
var $d01fe3a6cacf9ae4$var$DEFAULT_TOOLBOX_BTNS = [
    'rect',
    'polygon',
    'keep',
    'clear'
];
function $d01fe3a6cacf9ae4$export$2e2bcd8739ae039(option, isNew) {
    var brushComponents = (0, $bx3T8.normalizeToArray)(option ? option.brush : []);
    if (!brushComponents.length) return;
    var brushComponentSpecifiedBtns = [];
    $2N6Uo.each(brushComponents, function(brushOpt) {
        var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
        if (tbs instanceof Array) brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    });
    var toolbox = option && option.toolbox;
    if ($2N6Uo.isArray(toolbox)) toolbox = toolbox[0];
    if (!toolbox) {
        toolbox = {
            feature: {}
        };
        option.toolbox = [
            toolbox
        ];
    }
    var toolboxFeature = toolbox.feature || (toolbox.feature = {});
    var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
    var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
    brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
    $d01fe3a6cacf9ae4$var$removeDuplicate(brushTypes);
    if (isNew && !brushTypes.length) brushTypes.push.apply(brushTypes, $d01fe3a6cacf9ae4$var$DEFAULT_TOOLBOX_BTNS);
}
function $d01fe3a6cacf9ae4$var$removeDuplicate(arr) {
    var map = {};
    $2N6Uo.each(arr, function(val) {
        map[val] = 1;
    });
    arr.length = 0;
    $2N6Uo.each(map, function(flag, val) {
        arr.push(val);
    });
}

});

parcelRegister("g4FJO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3d65553e90a7db$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $97tZB = parcelRequire("97tZB");

var $36sVS = parcelRequire("36sVS");

var $bpyST = parcelRequire("bpyST");
var $bb3d65553e90a7db$var$BrushView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BrushView, _super);
    function BrushView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushView.type;
        return _this;
    }
    BrushView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
        this.model;
        (this._brushController = new (0, $97tZB.default)(api.getZr())).on('brush', $2N6Uo.bind(this._onBrush, this)).mount();
    };
    BrushView.prototype.render = function(brushModel, ecModel, api, payload) {
        this.model = brushModel;
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateTransform = function(brushModel, ecModel, api, payload) {
        // PENDING: `updateTransform` is a little tricky, whose layout need
        // to be calculate mandatorily and other stages will not be performed.
        // Take care the correctness of the logic. See #11754 .
        (0, $36sVS.layoutCovers)(ecModel);
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateVisual = function(brushModel, ecModel, api, payload) {
        this.updateTransform(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateView = function(brushModel, ecModel, api, payload) {
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype._updateController = function(brushModel, ecModel, api, payload) {
        // Do not update controller when drawing.
        (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
    };
    // updateLayout: updateController,
    // updateVisual: updateController,
    BrushView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    BrushView.prototype._onBrush = function(eventParam) {
        var modelId = this.model.id;
        var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel);
        // Action is not dispatched on drag end, because the drag end
        // emits the same params with the last drag move event, and
        // may have some delay when using touch pad, which makes
        // animation not smooth (when using debounce).
        (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
            type: 'brush',
            brushId: modelId,
            areas: $2N6Uo.clone(areas),
            $from: modelId
        });
        eventParam.isEnd && this.api.dispatchAction({
            type: 'brushEnd',
            brushId: modelId,
            areas: $2N6Uo.clone(areas),
            $from: modelId
        });
    };
    BrushView.type = 'brush';
    return BrushView;
}((0, $bpyST.default));
var $bb3d65553e90a7db$export$2e2bcd8739ae039 = $bb3d65553e90a7db$var$BrushView;

});
parcelRegister("36sVS", function(module, exports) {

$parcel$export(module.exports, "layoutCovers", function () { return $24286003a42173f3$export$ead1205d8c0d8375; });
$parcel$export(module.exports, "default", function () { return $24286003a42173f3$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $67W72 = parcelRequire("67W72");

var $1UvsP = parcelRequire("1UvsP");

var $jEwsg = parcelRequire("jEwsg");

var $99VtN = parcelRequire("99VtN");

var $7rtpa = parcelRequire("7rtpa");
var $24286003a42173f3$var$STATE_LIST = [
    'inBrush',
    'outOfBrush'
];
var $24286003a42173f3$var$DISPATCH_METHOD = '__ecBrushSelect';
var $24286003a42173f3$var$DISPATCH_FLAG = '__ecInBrushSelectEvent';
function $24286003a42173f3$export$ead1205d8c0d8375(ecModel) {
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel) {
        var brushTargetManager = brushModel.brushTargetManager = new (0, $7rtpa.default)(brushModel.option, ecModel);
        brushTargetManager.setInputRanges(brushModel.areas, ecModel);
    });
}
function $24286003a42173f3$export$2e2bcd8739ae039(ecModel, api, payload) {
    var brushSelected = [];
    var throttleType;
    var throttleDelay;
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel) {
        payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
            brushType: false
        });
    });
    $24286003a42173f3$export$ead1205d8c0d8375(ecModel);
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel, brushIndex) {
        var thisBrushSelected = {
            brushId: brushModel.id,
            brushIndex: brushIndex,
            brushName: brushModel.name,
            areas: $2N6Uo.clone(brushModel.areas),
            selected: []
        };
        // Every brush component exists in event params, convenient
        // for user to find by index.
        brushSelected.push(thisBrushSelected);
        var brushOption = brushModel.option;
        var brushLink = brushOption.brushLink;
        var linkedSeriesMap = [];
        var selectedDataIndexForLink = [];
        var rangeInfoBySeries = [];
        var hasBrushExists = false;
        if (!brushIndex) {
            // Only the first throttle setting works.
            throttleType = brushOption.throttleType;
            throttleDelay = brushOption.throttleDelay;
        }
        // Add boundingRect and selectors to range.
        var areas = $2N6Uo.map(brushModel.areas, function(area) {
            var builder = $24286003a42173f3$var$boundingRectBuilders[area.brushType];
            var selectableArea = $2N6Uo.defaults({
                boundingRect: builder ? builder(area) : void 0
            }, area);
            selectableArea.selectors = (0, $jEwsg.makeBrushCommonSelectorForSeries)(selectableArea);
            return selectableArea;
        });
        var visualMappings = $1UvsP.createVisualMappings(brushModel.option, $24286003a42173f3$var$STATE_LIST, function(mappingOption) {
            mappingOption.mappingMethod = 'fixed';
        });
        $2N6Uo.isArray(brushLink) && $2N6Uo.each(brushLink, function(seriesIndex) {
            linkedSeriesMap[seriesIndex] = 1;
        });
        function linkOthers(seriesIndex) {
            return brushLink === 'all' || !!linkedSeriesMap[seriesIndex];
        }
        // If no supported brush or no brush on the series,
        // all visuals should be in original state.
        function brushed(rangeInfoList) {
            return !!rangeInfoList.length;
        }
        /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */ // Step A
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
            seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
        });
        function stepAParallel(seriesModel, seriesIndex) {
            var coordSys = seriesModel.coordinateSystem;
            hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
            linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function(activeState, dataIndex) {
                activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
            });
        }
        function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
            if (!seriesModel.brushSelector || $24286003a42173f3$var$brushModelNotControll(brushModel, seriesIndex)) return;
            $2N6Uo.each(areas, function(area) {
                if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) rangeInfoList.push(area);
                hasBrushExists = hasBrushExists || brushed(rangeInfoList);
            });
            if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
                var data_1 = seriesModel.getData();
                data_1.each(function(dataIndex) {
                    if ($24286003a42173f3$var$checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) selectedDataIndexForLink[dataIndex] = 1;
                });
            }
        }
        // Step B
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var seriesBrushSelected = {
                seriesId: seriesModel.id,
                seriesIndex: seriesIndex,
                seriesName: seriesModel.name,
                dataIndex: []
            };
            // Every series exists in event params, convenient
            // for user to find series by seriesIndex.
            thisBrushSelected.selected.push(seriesBrushSelected);
            var rangeInfoList = rangeInfoBySeries[seriesIndex];
            var data = seriesModel.getData();
            var getValueState = linkOthers(seriesIndex) ? function(dataIndex) {
                return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
            } : function(dataIndex) {
                return $24286003a42173f3$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
            };
            // If no supported brush or no brush, all visuals are in original state.
            (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && $1UvsP.applyVisual($24286003a42173f3$var$STATE_LIST, visualMappings, data, getValueState);
        });
    });
    $24286003a42173f3$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
}
function $24286003a42173f3$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
    // This event will not be triggered when `setOpion`, otherwise dead lock may
    // triggered when do `setOption` in event listener, which we do not find
    // satisfactory way to solve yet. Some considered resolutions:
    // (a) Diff with prevoius selected data ant only trigger event when changed.
    // But store previous data and diff precisely (i.e., not only by dataIndex, but
    // also detect value changes in selected data) might bring complexity or fragility.
    // (b) Use spectial param like `silent` to suppress event triggering.
    // But such kind of volatile param may be weird in `setOption`.
    if (!payload) return;
    var zr = api.getZr();
    if (zr[$24286003a42173f3$var$DISPATCH_FLAG]) return;
    if (!zr[$24286003a42173f3$var$DISPATCH_METHOD]) zr[$24286003a42173f3$var$DISPATCH_METHOD] = $24286003a42173f3$var$doDispatch;
    var fn = $99VtN.createOrUpdate(zr, $24286003a42173f3$var$DISPATCH_METHOD, throttleDelay, throttleType);
    fn(api, brushSelected);
}
function $24286003a42173f3$var$doDispatch(api, brushSelected) {
    if (!api.isDisposed()) {
        var zr = api.getZr();
        zr[$24286003a42173f3$var$DISPATCH_FLAG] = true;
        api.dispatchAction({
            type: 'brushSelect',
            batch: brushSelected
        });
        zr[$24286003a42173f3$var$DISPATCH_FLAG] = false;
    }
}
function $24286003a42173f3$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
    for(var i = 0, len = rangeInfoList.length; i < len; i++){
        var area = rangeInfoList[i];
        if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) return true;
    }
}
function $24286003a42173f3$var$brushModelNotControll(brushModel, seriesIndex) {
    var seriesIndices = brushModel.option.seriesIndex;
    return seriesIndices != null && seriesIndices !== 'all' && ($2N6Uo.isArray(seriesIndices) ? $2N6Uo.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}
var $24286003a42173f3$var$boundingRectBuilders = {
    rect: function(area) {
        return $24286003a42173f3$var$getBoundingRectFromMinMax(area.range);
    },
    polygon: function(area) {
        var minMax;
        var range = area.range;
        for(var i = 0, len = range.length; i < len; i++){
            minMax = minMax || [
                [
                    Infinity,
                    -Infinity
                ],
                [
                    Infinity,
                    -Infinity
                ]
            ];
            var rg = range[i];
            rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
            rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
            rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
            rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
        }
        return minMax && $24286003a42173f3$var$getBoundingRectFromMinMax(minMax);
    }
};
function $24286003a42173f3$var$getBoundingRectFromMinMax(minMax) {
    return new (0, $67W72.default)(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}

});
parcelRegister("1UvsP", function(module, exports) {

$parcel$export(module.exports, "createVisualMappings", function () { return $16436d7922e69c68$export$89974527642f24a0; });
$parcel$export(module.exports, "replaceVisualOption", function () { return $16436d7922e69c68$export$797d20c0a6de578f; });
$parcel$export(module.exports, "applyVisual", function () { return $16436d7922e69c68$export$bb1ef43951d58629; });
$parcel$export(module.exports, "incrementalApplyVisual", function () { return $16436d7922e69c68$export$fc0ef8703cccf128; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual solution, for consistent option specification.
 */ 
var $2N6Uo = parcelRequire("2N6Uo");

var $dzLre = parcelRequire("dzLre");

var $csdCr = parcelRequire("csdCr");
var $16436d7922e69c68$var$each = $2N6Uo.each;
function $16436d7922e69c68$var$hasKeys(obj) {
    if (obj) for(var name_1 in obj){
        if (obj.hasOwnProperty(name_1)) return true;
    }
}
function $16436d7922e69c68$export$89974527642f24a0(option, stateList, supplementVisualOption) {
    var visualMappings = {};
    $16436d7922e69c68$var$each(stateList, function(state) {
        var mappings = visualMappings[state] = createMappings();
        $16436d7922e69c68$var$each(option[state], function(visualData, visualType) {
            if (!(0, $dzLre.default).isValidType(visualType)) return;
            var mappingOption = {
                type: visualType,
                visual: visualData
            };
            supplementVisualOption && supplementVisualOption(mappingOption, state);
            mappings[visualType] = new (0, $dzLre.default)(mappingOption);
            // Prepare a alpha for opacity, for some case that opacity
            // is not supported, such as rendering using gradient color.
            if (visualType === 'opacity') {
                mappingOption = $2N6Uo.clone(mappingOption);
                mappingOption.type = 'colorAlpha';
                mappings.__hidden.__alphaForOpacity = new (0, $dzLre.default)(mappingOption);
            }
        });
    });
    return visualMappings;
    function createMappings() {
        var Creater = function() {};
        // Make sure hidden fields will not be visited by
        // object iteration (with hasOwnProperty checking).
        Creater.prototype.__hidden = Creater.prototype;
        var obj = new Creater();
        return obj;
    }
}
function $16436d7922e69c68$export$797d20c0a6de578f(thisOption, newOption, keys) {
    // Visual attributes merge is not supported, otherwise it
    // brings overcomplicated merge logic. See #2853. So if
    // newOption has anyone of these keys, all of these keys
    // will be reset. Otherwise, all keys remain.
    var has;
    $2N6Uo.each(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $16436d7922e69c68$var$hasKeys(newOption[key])) has = true;
    });
    has && $2N6Uo.each(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $16436d7922e69c68$var$hasKeys(newOption[key])) thisOption[key] = $2N6Uo.clone(newOption[key]);
        else delete thisOption[key];
    });
}
function $16436d7922e69c68$export$bb1ef43951d58629(stateList, visualMappings, data, getValueState, scope, dimension) {
    var visualTypesMap = {};
    $2N6Uo.each(stateList, function(state) {
        var visualTypes = (0, $dzLre.default).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    var dataIndex;
    function getVisual(key) {
        return (0, $csdCr.getItemVisualFromData)(data, dataIndex, key);
    }
    function setVisual(key, value) {
        (0, $csdCr.setItemVisualFromData)(data, dataIndex, key, value);
    }
    if (dimension == null) data.each(eachItem);
    else data.each([
        dimension
    ], eachItem);
    function eachItem(valueOrIndex, index) {
        dataIndex = dimension == null ? valueOrIndex // First argument is index
         : index;
        var rawDataItem = data.getRawDataItem(dataIndex);
        // Consider performance
        // @ts-ignore
        if (rawDataItem && rawDataItem.visualMap === false) return;
        var valueState = getValueState.call(scope, valueOrIndex);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];
        for(var i = 0, len = visualTypes.length; i < len; i++){
            var type = visualTypes[i];
            mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
        }
    }
}
function $16436d7922e69c68$export$fc0ef8703cccf128(stateList, visualMappings, getValueState, dim) {
    var visualTypesMap = {};
    $2N6Uo.each(stateList, function(state) {
        var visualTypes = (0, $dzLre.default).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    return {
        progress: function progress(params, data) {
            var dimIndex;
            if (dim != null) dimIndex = data.getDimensionIndex(dim);
            function getVisual(key) {
                return (0, $csdCr.getItemVisualFromData)(data, dataIndex, key);
            }
            function setVisual(key, value) {
                (0, $csdCr.setItemVisualFromData)(data, dataIndex, key, value);
            }
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var rawDataItem = data.getRawDataItem(dataIndex);
                // Consider performance
                // @ts-ignore
                if (rawDataItem && rawDataItem.visualMap === false) continue;
                var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
                var valueState = getValueState(value);
                var mappings = visualMappings[valueState];
                var visualTypes = visualTypesMap[valueState];
                for(var i = 0, len = visualTypes.length; i < len; i++){
                    var type = visualTypes[i];
                    mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
                }
            }
        }
    };
}

});

parcelRegister("jEwsg", function(module, exports) {

$parcel$export(module.exports, "makeBrushCommonSelectorForSeries", function () { return $e4eaed9c58b024eb$export$2225cfa0a999c142; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $96Kkt = parcelRequire("96Kkt");

var $67W72 = parcelRequire("67W72");

var $h9U3p = parcelRequire("h9U3p");
function $e4eaed9c58b024eb$export$2225cfa0a999c142(area) {
    var brushType = area.brushType;
    // Do not use function binding or curry for performance.
    var selectors = {
        point: function(itemLayout) {
            return $e4eaed9c58b024eb$var$selector[brushType].point(itemLayout, selectors, area);
        },
        rect: function(itemLayout) {
            return $e4eaed9c58b024eb$var$selector[brushType].rect(itemLayout, selectors, area);
        }
    };
    return selectors;
}
var $e4eaed9c58b024eb$var$selector = {
    lineX: $e4eaed9c58b024eb$var$getLineSelectors(0),
    lineY: $e4eaed9c58b024eb$var$getLineSelectors(1),
    rect: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.intersect(itemLayout);
        }
    },
    polygon: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && $96Kkt.contain(area.range, itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            var points = area.range;
            if (!itemLayout || points.length <= 1) return false;
            var x = itemLayout.x;
            var y = itemLayout.y;
            var width = itemLayout.width;
            var height = itemLayout.height;
            var p = points[0];
            if ($96Kkt.contain(points, x, y) || $96Kkt.contain(points, x + width, y) || $96Kkt.contain(points, x, y + height) || $96Kkt.contain(points, x + width, y + height) || (0, $67W72.default).create(itemLayout).contain(p[0], p[1]) || (0, $h9U3p.linePolygonIntersect)(x, y, x + width, y, points) || (0, $h9U3p.linePolygonIntersect)(x, y, x, y + height, points) || (0, $h9U3p.linePolygonIntersect)(x + width, y, x + width, y + height, points) || (0, $h9U3p.linePolygonIntersect)(x, y + height, x + width, y + height, points)) return true;
        }
    }
};
function $e4eaed9c58b024eb$var$getLineSelectors(xyIndex) {
    var xy = [
        'x',
        'y'
    ];
    var wh = [
        'width',
        'height'
    ];
    return {
        point: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var p = itemLayout[xyIndex];
                return $e4eaed9c58b024eb$var$inLineRange(p, range);
            }
        },
        rect: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var layoutRange = [
                    itemLayout[xy[xyIndex]],
                    itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]
                ];
                layoutRange[1] < layoutRange[0] && layoutRange.reverse();
                return $e4eaed9c58b024eb$var$inLineRange(layoutRange[0], range) || $e4eaed9c58b024eb$var$inLineRange(layoutRange[1], range) || $e4eaed9c58b024eb$var$inLineRange(range[0], layoutRange) || $e4eaed9c58b024eb$var$inLineRange(range[1], layoutRange);
            }
        }
    };
}
function $e4eaed9c58b024eb$var$inLineRange(p, range) {
    return range[0] <= p && p <= range[1];
}
var $e4eaed9c58b024eb$export$2e2bcd8739ae039 = $e4eaed9c58b024eb$var$selector;

});

parcelRegister("7rtpa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56b1dd3a7409f08d$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");

var $3iC2d = parcelRequire("3iC2d");

var $bx3T8 = parcelRequire("bx3T8");
// FIXME
// how to genarialize to more coordinate systems.
var $56b1dd3a7409f08d$var$INCLUDE_FINDER_MAIN_TYPES = [
    'grid',
    'xAxis',
    'yAxis',
    'geo',
    'graph',
    'polar',
    'radiusAxis',
    'angleAxis',
    'bmap'
];
var $56b1dd3a7409f08d$var$BrushTargetManager = /** @class */ function() {
    /**
   * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
   *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
   * @param opt.include include coordinate system types.
   */ function BrushTargetManager(finder, ecModel, opt) {
        var _this = this;
        this._targetInfoList = [];
        var foundCpts = $56b1dd3a7409f08d$var$parseFinder(ecModel, finder);
        (0, $2N6Uo.each)($56b1dd3a7409f08d$var$targetInfoBuilders, function(builder, type) {
            if (!opt || !opt.include || (0, $2N6Uo.indexOf)(opt.include, type) >= 0) builder(foundCpts, _this._targetInfoList);
        });
    }
    BrushTargetManager.prototype.setOutputRanges = function(areas, ecModel) {
        this.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            (area.coordRanges || (area.coordRanges = [])).push(coordRange);
            // area.coordRange is the first of area.coordRanges
            if (!area.coordRange) {
                area.coordRange = coordRange;
                // In 'category' axis, coord to pixel is not reversible, so we can not
                // rebuild range by coordRange accrately, which may bring trouble when
                // brushing only one item. So we use __rangeOffset to rebuilding range
                // by coordRange. And this it only used in brush component so it is no
                // need to be adapted to coordRanges.
                var result = $56b1dd3a7409f08d$var$coordConvert[area.brushType](0, coordSys, coordRange);
                area.__rangeOffset = {
                    offset: $56b1dd3a7409f08d$var$diffProcessor[area.brushType](result.values, area.range, [
                        1,
                        1
                    ]),
                    xyMinMax: result.xyMinMax
                };
            }
        });
        return areas;
    };
    BrushTargetManager.prototype.matchOutputRanges = function(areas, ecModel, cb) {
        (0, $2N6Uo.each)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            if (targetInfo && targetInfo !== true) (0, $2N6Uo.each)(targetInfo.coordSyses, function(coordSys) {
                var result = $56b1dd3a7409f08d$var$coordConvert[area.brushType](1, coordSys, area.range, true);
                cb(area, result.values, coordSys, ecModel);
            });
        }, this);
    };
    /**
   * the `areas` is `BrushModel.areas`.
   * Called in layout stage.
   * convert `area.coordRange` to global range and set panelId to `area.range`.
   */ BrushTargetManager.prototype.setInputRanges = function(areas, ecModel) {
        (0, $2N6Uo.each)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            area.range = area.range || [];
            // convert coordRange to global range and set panelId.
            if (targetInfo && targetInfo !== true) {
                area.panelId = targetInfo.panelId;
                // (1) area.range should always be calculate from coordRange but does
                // not keep its original value, for the sake of the dataZoom scenario,
                // where area.coordRange remains unchanged but area.range may be changed.
                // (2) Only support converting one coordRange to pixel range in brush
                // component. So do not consider `coordRanges`.
                // (3) About __rangeOffset, see comment above.
                var result = $56b1dd3a7409f08d$var$coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
                var rangeOffset = area.__rangeOffset;
                area.range = rangeOffset ? $56b1dd3a7409f08d$var$diffProcessor[area.brushType](result.values, rangeOffset.offset, $56b1dd3a7409f08d$var$getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
            }
        }, this);
    };
    BrushTargetManager.prototype.makePanelOpts = function(api, getDefaultBrushType) {
        return (0, $2N6Uo.map)(this._targetInfoList, function(targetInfo) {
            var rect = targetInfo.getPanelRect();
            return {
                panelId: targetInfo.panelId,
                defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
                clipPath: $3iC2d.makeRectPanelClipPath(rect),
                isTargetByCursor: $3iC2d.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
                getLinearBrushOtherExtent: $3iC2d.makeLinearBrushOtherExtent(rect)
            };
        });
    };
    BrushTargetManager.prototype.controlSeries = function(area, seriesModel, ecModel) {
        // Check whether area is bound in coord, and series do not belong to that coord.
        // If do not do this check, some brush (like lineX) will controll all axes.
        var targetInfo = this.findTargetInfo(area, ecModel);
        return targetInfo === true || targetInfo && (0, $2N6Uo.indexOf)(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
    };
    /**
   * If return Object, a coord found.
   * If return true, global found.
   * Otherwise nothing found.
   */ BrushTargetManager.prototype.findTargetInfo = function(area, ecModel) {
        var targetInfoList = this._targetInfoList;
        var foundCpts = $56b1dd3a7409f08d$var$parseFinder(ecModel, area);
        for(var i = 0; i < targetInfoList.length; i++){
            var targetInfo = targetInfoList[i];
            var areaPanelId = area.panelId;
            if (areaPanelId) {
                if (targetInfo.panelId === areaPanelId) return targetInfo;
            } else for(var j = 0; j < $56b1dd3a7409f08d$var$targetInfoMatchers.length; j++){
                if ($56b1dd3a7409f08d$var$targetInfoMatchers[j](foundCpts, targetInfo)) return targetInfo;
            }
        }
        return true;
    };
    return BrushTargetManager;
}();
function $56b1dd3a7409f08d$var$formatMinMax(minMax) {
    minMax[0] > minMax[1] && minMax.reverse();
    return minMax;
}
function $56b1dd3a7409f08d$var$parseFinder(ecModel, finder) {
    return (0, $bx3T8.parseFinder)(ecModel, finder, {
        includeMainTypes: $56b1dd3a7409f08d$var$INCLUDE_FINDER_MAIN_TYPES
    });
}
var $56b1dd3a7409f08d$var$targetInfoBuilders = {
    grid: function(foundCpts, targetInfoList) {
        var xAxisModels = foundCpts.xAxisModels;
        var yAxisModels = foundCpts.yAxisModels;
        var gridModels = foundCpts.gridModels;
        // Remove duplicated.
        var gridModelMap = (0, $2N6Uo.createHashMap)();
        var xAxesHas = {};
        var yAxesHas = {};
        if (!xAxisModels && !yAxisModels && !gridModels) return;
        (0, $2N6Uo.each)(xAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
        });
        (0, $2N6Uo.each)(yAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            yAxesHas[gridModel.id] = true;
        });
        (0, $2N6Uo.each)(gridModels, function(gridModel) {
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
            yAxesHas[gridModel.id] = true;
        });
        gridModelMap.each(function(gridModel) {
            var grid = gridModel.coordinateSystem;
            var cartesians = [];
            (0, $2N6Uo.each)(grid.getCartesians(), function(cartesian, index) {
                if ((0, $2N6Uo.indexOf)(xAxisModels, cartesian.getAxis('x').model) >= 0 || (0, $2N6Uo.indexOf)(yAxisModels, cartesian.getAxis('y').model) >= 0) cartesians.push(cartesian);
            });
            targetInfoList.push({
                panelId: 'grid--' + gridModel.id,
                gridModel: gridModel,
                coordSysModel: gridModel,
                // Use the first one as the representitive coordSys.
                coordSys: cartesians[0],
                coordSyses: cartesians,
                getPanelRect: $56b1dd3a7409f08d$var$panelRectBuilders.grid,
                xAxisDeclared: xAxesHas[gridModel.id],
                yAxisDeclared: yAxesHas[gridModel.id]
            });
        });
    },
    geo: function(foundCpts, targetInfoList) {
        (0, $2N6Uo.each)(foundCpts.geoModels, function(geoModel) {
            var coordSys = geoModel.coordinateSystem;
            targetInfoList.push({
                panelId: 'geo--' + geoModel.id,
                geoModel: geoModel,
                coordSysModel: geoModel,
                coordSys: coordSys,
                coordSyses: [
                    coordSys
                ],
                getPanelRect: $56b1dd3a7409f08d$var$panelRectBuilders.geo
            });
        });
    }
};
var $56b1dd3a7409f08d$var$targetInfoMatchers = [
    // grid
    function(foundCpts, targetInfo) {
        var xAxisModel = foundCpts.xAxisModel;
        var yAxisModel = foundCpts.yAxisModel;
        var gridModel = foundCpts.gridModel;
        !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
        !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
        return gridModel && gridModel === targetInfo.gridModel;
    },
    // geo
    function(foundCpts, targetInfo) {
        var geoModel = foundCpts.geoModel;
        return geoModel && geoModel === targetInfo.geoModel;
    }
];
var $56b1dd3a7409f08d$var$panelRectBuilders = {
    grid: function() {
        // grid is not Transformable.
        return this.coordSys.master.getRect().clone();
    },
    geo: function() {
        var coordSys = this.coordSys;
        var rect = coordSys.getBoundingRect().clone();
        // geo roam and zoom transform
        rect.applyTransform($h9U3p.getTransform(coordSys));
        return rect;
    }
};
var $56b1dd3a7409f08d$var$coordConvert = {
    lineX: (0, $2N6Uo.curry)($56b1dd3a7409f08d$var$axisConvert, 0),
    lineY: (0, $2N6Uo.curry)($56b1dd3a7409f08d$var$axisConvert, 1),
    rect: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xminymin = to ? coordSys.pointToData([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp);
        var xmaxymax = to ? coordSys.pointToData([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp);
        var values = [
            $56b1dd3a7409f08d$var$formatMinMax([
                xminymin[0],
                xmaxymax[0]
            ]),
            $56b1dd3a7409f08d$var$formatMinMax([
                xminymin[1],
                xmaxymax[1]
            ])
        ];
        return {
            values: values,
            xyMinMax: values
        };
    },
    polygon: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xyMinMax = [
            [
                Infinity,
                -Infinity
            ],
            [
                Infinity,
                -Infinity
            ]
        ];
        var values = (0, $2N6Uo.map)(rangeOrCoordRange, function(item) {
            var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
            xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
            xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
            xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
            xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
            return p;
        });
        return {
            values: values,
            xyMinMax: xyMinMax
        };
    }
};
function $56b1dd3a7409f08d$var$axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
    var axis = coordSys.getAxis([
        'x',
        'y'
    ][axisNameIndex]);
    var values = $56b1dd3a7409f08d$var$formatMinMax((0, $2N6Uo.map)([
        0,
        1
    ], function(i) {
        return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
    }));
    var xyMinMax = [];
    xyMinMax[axisNameIndex] = values;
    xyMinMax[1 - axisNameIndex] = [
        NaN,
        NaN
    ];
    return {
        values: values,
        xyMinMax: xyMinMax
    };
}
var $56b1dd3a7409f08d$var$diffProcessor = {
    lineX: (0, $2N6Uo.curry)($56b1dd3a7409f08d$var$axisDiffProcessor, 0),
    lineY: (0, $2N6Uo.curry)($56b1dd3a7409f08d$var$axisDiffProcessor, 1),
    rect: function(values, refer, scales) {
        return [
            [
                values[0][0] - scales[0] * refer[0][0],
                values[0][1] - scales[0] * refer[0][1]
            ],
            [
                values[1][0] - scales[1] * refer[1][0],
                values[1][1] - scales[1] * refer[1][1]
            ]
        ];
    },
    polygon: function(values, refer, scales) {
        return (0, $2N6Uo.map)(values, function(item, idx) {
            return [
                item[0] - scales[0] * refer[idx][0],
                item[1] - scales[1] * refer[idx][1]
            ];
        });
    }
};
function $56b1dd3a7409f08d$var$axisDiffProcessor(axisNameIndex, values, refer, scales) {
    return [
        values[0] - scales[axisNameIndex] * refer[0],
        values[1] - scales[axisNameIndex] * refer[1]
    ];
}
// We have to process scale caused by dataZoom manually,
// although it might be not accurate.
// Return [0~1, 0~1]
function $56b1dd3a7409f08d$var$getScales(xyMinMaxCurr, xyMinMaxOrigin) {
    var sizeCurr = $56b1dd3a7409f08d$var$getSize(xyMinMaxCurr);
    var sizeOrigin = $56b1dd3a7409f08d$var$getSize(xyMinMaxOrigin);
    var scales = [
        sizeCurr[0] / sizeOrigin[0],
        sizeCurr[1] / sizeOrigin[1]
    ];
    isNaN(scales[0]) && (scales[0] = 1);
    isNaN(scales[1]) && (scales[1] = 1);
    return scales;
}
function $56b1dd3a7409f08d$var$getSize(xyMinMax) {
    return xyMinMax ? [
        xyMinMax[0][1] - xyMinMax[0][0],
        xyMinMax[1][1] - xyMinMax[1][0]
    ] : [
        NaN,
        NaN
    ];
}
var $56b1dd3a7409f08d$export$2e2bcd8739ae039 = $56b1dd3a7409f08d$var$BrushTargetManager;

});



parcelRegister("6RIiy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ffa0e078119c82c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $1UvsP = parcelRequire("1UvsP");

var $b8YKU = parcelRequire("b8YKU");

var $eLD2b = parcelRequire("eLD2b");

var $6aXXD = parcelRequire("6aXXD");
var $4ffa0e078119c82c$var$BrushModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BrushModel, _super);
    function BrushModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushModel.type;
        /**
     * @readOnly
     */ _this.areas = [];
        /**
     * Current brush painting area settings.
     * @readOnly
     */ _this.brushOption = {};
        return _this;
    }
    BrushModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $1UvsP.replaceVisualOption(thisOption, newOption, [
            'inBrush',
            'outOfBrush'
        ]);
        var inBrush = thisOption.inBrush = thisOption.inBrush || {};
        // Always give default visual, consider setOption at the second time.
        thisOption.outOfBrush = thisOption.outOfBrush || {
            color: this.option.defaultOutOfBrushColor
        };
        if (!inBrush.hasOwnProperty('liftZ')) // Bigger than the highlight z lift, otherwise it will
        // be effected by the highlight z when brush.
        inBrush.liftZ = 5;
    };
    /**
   * If `areas` is null/undefined, range state remain.
   */ BrushModel.prototype.setAreas = function(areas) {
        // If areas is null/undefined, range state remain.
        // This helps user to dispatchAction({type: 'brush'}) with no areas
        // set but just want to get the current brush select info from a `brush` event.
        if (!areas) return;
        this.areas = $2N6Uo.map(areas, function(area) {
            return $4ffa0e078119c82c$var$generateBrushOption(this.option, area);
        }, this);
    };
    /**
   * Set the current painting brush option.
   */ BrushModel.prototype.setBrushOption = function(brushOption) {
        this.brushOption = $4ffa0e078119c82c$var$generateBrushOption(this.option, brushOption);
        this.brushType = this.brushOption.brushType;
    };
    BrushModel.type = 'brush';
    BrushModel.dependencies = [
        'geo',
        'grid',
        'xAxis',
        'yAxis',
        'parallel',
        'series'
    ];
    BrushModel.defaultOption = {
        seriesIndex: 'all',
        brushType: 'rect',
        brushMode: 'single',
        transformable: true,
        brushStyle: {
            borderWidth: 1,
            color: (0, $6aXXD.default).color.backgroundTint,
            borderColor: (0, $6aXXD.default).color.borderTint
        },
        throttleType: 'fixRate',
        throttleDelay: 0,
        removeOnClick: true,
        z: 10000,
        defaultOutOfBrushColor: (0, $6aXXD.default).color.disabled
    };
    return BrushModel;
}((0, $eLD2b.default));
function $4ffa0e078119c82c$var$generateBrushOption(option, brushOption) {
    return $2N6Uo.merge({
        brushType: option.brushType,
        brushMode: option.brushMode,
        transformable: option.transformable,
        brushStyle: new (0, $b8YKU.default)(option.brushStyle).getItemStyle(),
        removeOnClick: option.removeOnClick,
        z: option.z
    }, brushOption, true);
}
var $4ffa0e078119c82c$export$2e2bcd8739ae039 = $4ffa0e078119c82c$var$BrushModel;

});

parcelRegister("6B8xa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cdcd171b7cdfc02$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $14R3P = parcelRequire("14R3P");
var $4cdcd171b7cdfc02$var$ICON_TYPES = [
    'rect',
    'polygon',
    'lineX',
    'lineY',
    'keep',
    'clear'
];
var $4cdcd171b7cdfc02$var$BrushFeature = /** @class */ function(_super) {
    (0, $9nEce.__extends)(BrushFeature, _super);
    function BrushFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrushFeature.prototype.render = function(featureModel, ecModel, api) {
        var brushType;
        var brushMode;
        var isBrushed;
        ecModel.eachComponent({
            mainType: 'brush'
        }, function(brushModel) {
            brushType = brushModel.brushType;
            brushMode = brushModel.brushOption.brushMode || 'single';
            isBrushed = isBrushed || !!brushModel.areas.length;
        });
        this._brushType = brushType;
        this._brushMode = brushMode;
        $2N6Uo.each(featureModel.get('type', true), function(type) {
            featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
        });
    };
    BrushFeature.prototype.updateView = function(featureModel, ecModel, api) {
        this.render(featureModel, ecModel, api);
    };
    BrushFeature.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get('icon', true);
        var icons = {};
        $2N6Uo.each(model.get('type', true), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    BrushFeature.prototype.onclick = function(ecModel, api, type) {
        var brushType = this._brushType;
        var brushMode = this._brushMode;
        if (type === 'clear') {
            // Trigger parallel action firstly
            api.dispatchAction({
                type: 'axisAreaSelect',
                intervals: []
            });
            api.dispatchAction({
                type: 'brush',
                command: 'clear',
                // Clear all areas of all brush components.
                areas: []
            });
        } else api.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'brush',
            brushOption: {
                brushType: type === 'keep' ? brushType : brushType === type ? false : type,
                brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
            }
        });
    };
    BrushFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: $4cdcd171b7cdfc02$var$ICON_TYPES.slice(),
            icon: {
                /* eslint-disable */ rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
                polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
                lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
                lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
                keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
                clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
            },
            // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'brush',
                'title'
            ])
        };
        return defaultOption;
    };
    return BrushFeature;
}((0, $14R3P.ToolboxFeature));
var $4cdcd171b7cdfc02$export$2e2bcd8739ae039 = $4cdcd171b7cdfc02$var$BrushFeature;

});
parcelRegister("14R3P", function(module, exports) {

$parcel$export(module.exports, "ToolboxFeature", function () { return $0c8f52eae5437c61$export$1426bfb1b0bcf539; });
$parcel$export(module.exports, "registerFeature", function () { return $0c8f52eae5437c61$export$c6213a6f247cf906; });
$parcel$export(module.exports, "getFeature", function () { return $0c8f52eae5437c61$export$bba2e7bbd72e62e1; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ var $0c8f52eae5437c61$export$1426bfb1b0bcf539 = /** @class */ function() {
    function ToolboxFeature() {}
    return ToolboxFeature;
}();
var $0c8f52eae5437c61$var$features = {};
function $0c8f52eae5437c61$export$c6213a6f247cf906(name, ctor) {
    $0c8f52eae5437c61$var$features[name] = ctor;
}
function $0c8f52eae5437c61$export$bba2e7bbd72e62e1(name) {
    return $0c8f52eae5437c61$var$features[name];
}

});



parcelRegister("dwDVV", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $9d8d3d6fd2369777$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $52LCR = parcelRequire("52LCR");

var $5zKvW = parcelRequire("5zKvW");

var $cXqxH = parcelRequire("cXqxH");
function $9d8d3d6fd2369777$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $52LCR.default));
    registers.registerComponentView((0, $5zKvW.default));
    registers.registerCoordinateSystem('calendar', (0, $cXqxH.default));
}

});
parcelRegister("52LCR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ac2152b21532ec0$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $eLD2b = parcelRequire("eLD2b");

var $a35Wn = parcelRequire("a35Wn");

var $6aXXD = parcelRequire("6aXXD");
var $3ac2152b21532ec0$var$CalendarModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CalendarModel, _super);
    function CalendarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarModel.type;
        return _this;
    }
    /**
   * @override
   */ CalendarModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $a35Wn.getLayoutParams)(option);
        _super.prototype.init.apply(this, arguments);
        $3ac2152b21532ec0$var$mergeAndNormalizeLayoutParams(option, inputPositionParams);
    };
    /**
   * @override
   */ CalendarModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        $3ac2152b21532ec0$var$mergeAndNormalizeLayoutParams(this.option, option);
    };
    CalendarModel.prototype.getCellSize = function() {
        // Has been normalized
        return this.option.cellSize;
    };
    CalendarModel.type = 'calendar';
    CalendarModel.layoutMode = 'box';
    CalendarModel.defaultOption = {
        // zlevel: 0,
        // TODO: theoretically, the z of the calendar should be lower
        // than series, but we don't want the series to be displayed
        // on top of the borders like month split line. To align with
        // the effect of previous versions, we set the z to 2 for now
        // until better solution is found.
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        // horizontal vertical
        orient: 'horizontal',
        // month separate line style
        splitLine: {
            show: true,
            lineStyle: {
                color: (0, $6aXXD.default).color.axisLine,
                width: 1,
                type: 'solid'
            }
        },
        // rect style  temporarily unused emphasis
        itemStyle: {
            color: (0, $6aXXD.default).color.neutral00,
            borderWidth: 1,
            borderColor: (0, $6aXXD.default).color.neutral10
        },
        // week text style
        dayLabel: {
            show: true,
            firstDay: 0,
            // start end
            position: 'start',
            margin: (0, $6aXXD.default).size.s,
            color: (0, $6aXXD.default).color.secondary
        },
        // month text style
        monthLabel: {
            show: true,
            // start end
            position: 'start',
            margin: (0, $6aXXD.default).size.s,
            // center or left
            align: 'center',
            formatter: null,
            color: (0, $6aXXD.default).color.secondary
        },
        // year text style
        yearLabel: {
            show: true,
            // top bottom left right
            position: null,
            margin: (0, $6aXXD.default).size.xl,
            formatter: null,
            color: (0, $6aXXD.default).color.quaternary,
            fontFamily: 'sans-serif',
            fontWeight: 'bolder',
            fontSize: 20
        }
    };
    return CalendarModel;
}((0, $eLD2b.default));
function $3ac2152b21532ec0$var$mergeAndNormalizeLayoutParams(target, raw) {
    // Normalize cellSize
    var cellSize = target.cellSize;
    var cellSizeArr;
    if (!$2N6Uo.isArray(cellSize)) cellSizeArr = target.cellSize = [
        cellSize,
        cellSize
    ];
    else cellSizeArr = cellSize;
    if (cellSizeArr.length === 1) cellSizeArr[1] = cellSizeArr[0];
    var ignoreSize = $2N6Uo.map([
        0,
        1
    ], function(hvIdx) {
        // If user have set `width` or both `left` and `right`, cellSizeArr
        // will be automatically set to 'auto', otherwise the default
        // setting of cellSizeArr will make `width` setting not work.
        if ((0, $a35Wn.sizeCalculable)(raw, hvIdx)) cellSizeArr[hvIdx] = 'auto';
        return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== 'auto';
    });
    (0, $a35Wn.mergeLayoutParam)(target, raw, {
        type: 'box',
        ignoreSize: ignoreSize
    });
}
var $3ac2152b21532ec0$export$2e2bcd8739ae039 = $3ac2152b21532ec0$var$CalendarModel;

});

parcelRegister("5zKvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f44d67c434a863$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");
parcelRequire("h9U3p");
var $ewDYK = parcelRequire("ewDYK");
var $aH2k0 = parcelRequire("aH2k0");
var $kBKw3 = parcelRequire("kBKw3");

var $bysmE = parcelRequire("bysmE");

var $hrphB = parcelRequire("hrphB");

var $iCU10 = parcelRequire("iCU10");

var $bpyST = parcelRequire("bpyST");

var $2FU9b = parcelRequire("2FU9b");
var $40f44d67c434a863$var$CalendarView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(CalendarView, _super);
    function CalendarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarView.type;
        return _this;
    }
    CalendarView.prototype.render = function(calendarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        var coordSys = calendarModel.coordinateSystem;
        // range info
        var rangeData = coordSys.getRangeInfo();
        var orient = coordSys.getOrient();
        // locale
        var localeModel = ecModel.getLocaleModel();
        this._renderDayRect(calendarModel, rangeData, group);
        // _renderLines must be called prior to following function
        this._renderLines(calendarModel, rangeData, orient, group);
        this._renderYearText(calendarModel, rangeData, orient, group);
        this._renderMonthText(calendarModel, localeModel, orient, group);
        this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
    };
    // render day rect
    CalendarView.prototype._renderDayRect = function(calendarModel, rangeData, group) {
        var coordSys = calendarModel.coordinateSystem;
        var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
        var sw = coordSys.getCellWidth();
        var sh = coordSys.getCellHeight();
        for(var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time){
            var point = coordSys.dataToCalendarLayout([
                i
            ], false).tl;
            // every rect
            var rect = new $aH2k0.default({
                shape: {
                    x: point[0],
                    y: point[1],
                    width: sw,
                    height: sh
                },
                cursor: 'default',
                style: itemRectStyleModel
            });
            group.add(rect);
        }
    };
    // render separate line
    CalendarView.prototype._renderLines = function(calendarModel, rangeData, orient, group) {
        var self = this;
        var coordSys = calendarModel.coordinateSystem;
        var lineStyleModel = calendarModel.getModel([
            'splitLine',
            'lineStyle'
        ]).getLineStyle();
        var show = calendarModel.get([
            'splitLine',
            'show'
        ]);
        var lineWidth = lineStyleModel.lineWidth;
        this._tlpoints = [];
        this._blpoints = [];
        this._firstDayOfMonth = [];
        this._firstDayPoints = [];
        var firstDay = rangeData.start;
        for(var i = 0; firstDay.time <= rangeData.end.time; i++){
            addPoints(firstDay.formatedDate);
            if (i === 0) firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
            var date = firstDay.date;
            date.setMonth(date.getMonth() + 1);
            firstDay = coordSys.getDateInfo(date);
        }
        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
        function addPoints(date) {
            self._firstDayOfMonth.push(coordSys.getDateInfo(date));
            self._firstDayPoints.push(coordSys.dataToCalendarLayout([
                date
            ], false).tl);
            var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
            self._tlpoints.push(points[0]);
            self._blpoints.push(points[points.length - 1]);
            show && self._drawSplitline(points, lineStyleModel, group);
        }
        // render top/left line
        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group);
        // render bottom/right line
        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
    };
    // get points at both ends
    CalendarView.prototype._getEdgesPoints = function(points, lineWidth, orient) {
        var rs = [
            points[0].slice(),
            points[points.length - 1].slice()
        ];
        var idx = orient === 'horizontal' ? 0 : 1;
        // both ends of the line are extend half lineWidth
        rs[0][idx] = rs[0][idx] - lineWidth / 2;
        rs[1][idx] = rs[1][idx] + lineWidth / 2;
        return rs;
    };
    // render split line
    CalendarView.prototype._drawSplitline = function(points, lineStyle, group) {
        var poyline = new $ewDYK.default({
            z2: 20,
            shape: {
                points: points
            },
            style: lineStyle
        });
        group.add(poyline);
    };
    // render month line of one week points
    CalendarView.prototype._getLinePointsOfOneWeek = function(calendarModel, date, orient) {
        var coordSys = calendarModel.coordinateSystem;
        var parsedDate = coordSys.getDateInfo(date);
        var points = [];
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(parsedDate.time, i);
            var point = coordSys.dataToCalendarLayout([
                tmpD.time
            ], false);
            points[2 * tmpD.day] = point.tl;
            points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
        }
        return points;
    };
    CalendarView.prototype._formatterLabel = function(formatter, params) {
        if ((0, $2N6Uo.isString)(formatter) && formatter) return (0, $hrphB.formatTplSimple)(formatter, params);
        if ((0, $2N6Uo.isFunction)(formatter)) return formatter(params);
        return params.nameMap;
    };
    CalendarView.prototype._yearTextPositionControl = function(textEl, point, orient, position, margin) {
        var x = point[0];
        var y = point[1];
        var aligns = [
            'center',
            'bottom'
        ];
        if (position === 'bottom') {
            y += margin;
            aligns = [
                'center',
                'top'
            ];
        } else if (position === 'left') x -= margin;
        else if (position === 'right') {
            x += margin;
            aligns = [
                'center',
                'top'
            ];
        } else // top
        y -= margin;
        var rotate = 0;
        if (position === 'left' || position === 'right') rotate = Math.PI / 2;
        return {
            rotation: rotate,
            x: x,
            y: y,
            style: {
                align: aligns[0],
                verticalAlign: aligns[1]
            }
        };
    };
    // render year
    CalendarView.prototype._renderYearText = function(calendarModel, rangeData, orient, group) {
        var yearLabel = calendarModel.getModel('yearLabel');
        if (!yearLabel.get('show')) return;
        var margin = yearLabel.get('margin');
        var pos = yearLabel.get('position');
        if (!pos) pos = orient !== 'horizontal' ? 'top' : 'left';
        var points = [
            this._tlpoints[this._tlpoints.length - 1],
            this._blpoints[0]
        ];
        var xc = (points[0][0] + points[1][0]) / 2;
        var yc = (points[0][1] + points[1][1]) / 2;
        var idx = orient === 'horizontal' ? 0 : 1;
        var posPoints = {
            top: [
                xc,
                points[idx][1]
            ],
            bottom: [
                xc,
                points[1 - idx][1]
            ],
            left: [
                points[1 - idx][0],
                yc
            ],
            right: [
                points[idx][0],
                yc
            ]
        };
        var name = rangeData.start.y;
        if (+rangeData.end.y > +rangeData.start.y) name = name + '-' + rangeData.end.y;
        var formatter = yearLabel.get('formatter');
        var params = {
            start: rangeData.start.y,
            end: rangeData.end.y,
            nameMap: name
        };
        var content = this._formatterLabel(formatter, params);
        var yearText = new $kBKw3.default({
            z2: 30,
            style: (0, $bysmE.createTextStyle)(yearLabel, {
                text: content
            }),
            silent: yearLabel.get('silent')
        });
        yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
        group.add(yearText);
    };
    CalendarView.prototype._monthTextPositionControl = function(point, isCenter, orient, position, margin) {
        var align = 'left';
        var vAlign = 'top';
        var x = point[0];
        var y = point[1];
        if (orient === 'horizontal') {
            y = y + margin;
            if (isCenter) align = 'center';
            if (position === 'start') vAlign = 'bottom';
        } else {
            x = x + margin;
            if (isCenter) vAlign = 'middle';
            if (position === 'start') align = 'right';
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render month and year text
    CalendarView.prototype._renderMonthText = function(calendarModel, localeModel, orient, group) {
        var monthLabel = calendarModel.getModel('monthLabel');
        if (!monthLabel.get('show')) return;
        var nameMap = monthLabel.get('nameMap');
        var margin = monthLabel.get('margin');
        var pos = monthLabel.get('position');
        var align = monthLabel.get('align');
        var termPoints = [
            this._tlpoints,
            this._blpoints
        ];
        if (!nameMap || (0, $2N6Uo.isString)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $2FU9b.getLocaleModel)(nameMap) || localeModel;
            // PENDING
            // for ZH locale, original form is `一月` but current form is `1月`
            nameMap = localeModel.get([
                'time',
                'monthAbbr'
            ]) || [];
        }
        var idx = pos === 'start' ? 0 : 1;
        var axis = orient === 'horizontal' ? 0 : 1;
        margin = pos === 'start' ? -margin : margin;
        var isCenter = align === 'center';
        var labelSilent = monthLabel.get('silent');
        for(var i = 0; i < termPoints[idx].length - 1; i++){
            var tmp = termPoints[idx][i].slice();
            var firstDay = this._firstDayOfMonth[i];
            if (isCenter) {
                var firstDayPoints = this._firstDayPoints[i];
                tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
            }
            var formatter = monthLabel.get('formatter');
            var name_1 = nameMap[+firstDay.m - 1];
            var params = {
                yyyy: firstDay.y,
                yy: (firstDay.y + '').slice(2),
                MM: firstDay.m,
                M: +firstDay.m,
                nameMap: name_1
            };
            var content = this._formatterLabel(formatter, params);
            var monthText = new $kBKw3.default({
                z2: 30,
                style: (0, $2N6Uo.extend)((0, $bysmE.createTextStyle)(monthLabel, {
                    text: content
                }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin)),
                silent: labelSilent
            });
            group.add(monthText);
        }
    };
    CalendarView.prototype._weekTextPositionControl = function(point, orient, position, margin, cellSize) {
        var align = 'center';
        var vAlign = 'middle';
        var x = point[0];
        var y = point[1];
        var isStart = position === 'start';
        if (orient === 'horizontal') {
            x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
            align = isStart ? 'right' : 'left';
        } else {
            y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
            vAlign = isStart ? 'bottom' : 'top';
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render weeks
    CalendarView.prototype._renderWeekText = function(calendarModel, localeModel, rangeData, orient, group) {
        var dayLabel = calendarModel.getModel('dayLabel');
        if (!dayLabel.get('show')) return;
        var coordSys = calendarModel.coordinateSystem;
        var pos = dayLabel.get('position');
        var nameMap = dayLabel.get('nameMap');
        var margin = dayLabel.get('margin');
        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
        if (!nameMap || (0, $2N6Uo.isString)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $2FU9b.getLocaleModel)(nameMap) || localeModel;
            // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file
            var dayOfWeekShort = localeModel.get([
                'time',
                'dayOfWeekShort'
            ]);
            nameMap = dayOfWeekShort || (0, $2N6Uo.map)(localeModel.get([
                'time',
                'dayOfWeekAbbr'
            ]), function(val) {
                return val[0];
            });
        }
        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
        var cellSize = [
            coordSys.getCellWidth(),
            coordSys.getCellHeight()
        ];
        margin = (0, $iCU10.parsePercent)(margin, Math.min(cellSize[1], cellSize[0]));
        if (pos === 'start') {
            start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
            margin = -margin;
        }
        var labelSilent = dayLabel.get('silent');
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(start, i);
            var point = coordSys.dataToCalendarLayout([
                tmpD.time
            ], false).center;
            var day = i;
            day = Math.abs((i + firstDayOfWeek) % 7);
            var weekText = new $kBKw3.default({
                z2: 30,
                style: (0, $2N6Uo.extend)((0, $bysmE.createTextStyle)(dayLabel, {
                    text: nameMap[day]
                }), this._weekTextPositionControl(point, orient, pos, margin, cellSize)),
                silent: labelSilent
            });
            group.add(weekText);
        }
    };
    CalendarView.type = 'calendar';
    return CalendarView;
}((0, $bpyST.default));
var $40f44d67c434a863$export$2e2bcd8739ae039 = $40f44d67c434a863$var$CalendarView;

});

parcelRegister("cXqxH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ef958a83b2edf0$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $a35Wn = parcelRequire("a35Wn");

var $iCU10 = parcelRequire("iCU10");

var $67W72 = parcelRequire("67W72");

var $h9U3p = parcelRequire("h9U3p");

var $hIXrb = parcelRequire("hIXrb");
// (24*60*60*1000)
var $96ef958a83b2edf0$var$PROXIMATE_ONE_DAY = 86400000;
var $96ef958a83b2edf0$var$Calendar = /** @class */ function() {
    function Calendar(calendarModel, ecModel, api) {
        this.type = 'calendar';
        this.dimensions = Calendar.dimensions;
        // Required in createListFromData
        this.getDimensionsInfo = Calendar.getDimensionsInfo;
        this._model = calendarModel;
        this._update(ecModel, api);
    }
    Calendar.getDimensionsInfo = function() {
        return [
            {
                name: 'time',
                type: 'time'
            },
            'value'
        ];
    };
    Calendar.prototype.getRangeInfo = function() {
        return this._rangeInfo;
    };
    Calendar.prototype.getModel = function() {
        return this._model;
    };
    Calendar.prototype.getRect = function() {
        return this._rect;
    };
    Calendar.prototype.getCellWidth = function() {
        return this._sw;
    };
    Calendar.prototype.getCellHeight = function() {
        return this._sh;
    };
    Calendar.prototype.getOrient = function() {
        return this._orient;
    };
    /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */ Calendar.prototype.getFirstDayOfWeek = function() {
        return this._firstDayOfWeek;
    };
    /**
   * get date info
   * }
   */ Calendar.prototype.getDateInfo = function(date) {
        date = $iCU10.parseDate(date);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var mStr = m < 10 ? '0' + m : '' + m;
        var d = date.getDate();
        var dStr = d < 10 ? '0' + d : '' + d;
        var day = date.getDay();
        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
        return {
            y: y + '',
            m: mStr,
            d: dStr,
            day: day,
            time: date.getTime(),
            formatedDate: y + '-' + mStr + '-' + dStr,
            date: date
        };
    };
    Calendar.prototype.getNextNDay = function(date, n) {
        n = n || 0;
        if (n === 0) return this.getDateInfo(date);
        date = new Date(this.getDateInfo(date).time);
        date.setDate(date.getDate() + n);
        return this.getDateInfo(date);
    };
    Calendar.prototype._update = function(ecModel, api) {
        this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
        this._orient = this._model.get('orient');
        this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
        var weeks = this._rangeInfo.weeks || 1;
        var whNames = [
            'width',
            'height'
        ];
        var cellSize = this._model.getCellSize().slice();
        var layoutParams = this._model.getBoxLayoutParams();
        var cellNumbers = this._orient === 'horizontal' ? [
            weeks,
            7
        ] : [
            7,
            weeks
        ];
        $2N6Uo.each([
            0,
            1
        ], function(idx) {
            if (cellSizeSpecified(cellSize, idx)) layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
        });
        var whGlobal = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var calendarRect = this._rect = $a35Wn.getLayoutRect(layoutParams, whGlobal);
        $2N6Uo.each([
            0,
            1
        ], function(idx) {
            if (!cellSizeSpecified(cellSize, idx)) cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
        });
        function cellSizeSpecified(cellSize, idx) {
            return cellSize[idx] != null && cellSize[idx] !== 'auto';
        }
        // Has been calculated out number.
        this._sw = cellSize[0];
        this._sh = cellSize[1];
    };
    /**
   * Convert a time data(time, value) item to (x, y) point.
   */ // TODO Clamp of calendar is not same with cartesian coordinate systems.
    // It will return NaN if data exceeds.
    Calendar.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        $2N6Uo.isArray(data) && (data = data[0]);
        clamp == null && (clamp = true);
        var dayInfo = this.getDateInfo(data);
        var range = this._rangeInfo;
        var date = dayInfo.formatedDate;
        // if not in range return [NaN, NaN]
        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + $96ef958a83b2edf0$var$PROXIMATE_ONE_DAY)) {
            out[0] = out[1] = NaN;
            return out;
        }
        var week = dayInfo.day;
        var nthWeek = this._getRangeInfo([
            range.start.time,
            date
        ]).nthWeek;
        if (this._orient === 'vertical') {
            out[0] = this._rect.x + week * this._sw + this._sw / 2;
            out[1] = this._rect.y + nthWeek * this._sh + this._sh / 2;
        } else {
            out[0] = this._rect.x + nthWeek * this._sw + this._sw / 2;
            out[1] = this._rect.y + week * this._sh + this._sh / 2;
        }
        return out;
    };
    /**
   * Convert a (x, y) point to time data
   */ Calendar.prototype.pointToData = function(point) {
        var date = this.pointToDate(point);
        return date && date.time;
    };
    Calendar.prototype.dataToLayout = function(data, clamp, out) {
        out = out || {};
        var rect = out.rect = out.rect || {};
        var contentRect = out.contentRect = out.contentRect || {};
        var point = this.dataToPoint(data, clamp);
        rect.x = point[0] - this._sw / 2;
        rect.y = point[1] - this._sh / 2;
        rect.width = this._sw;
        rect.height = this._sh;
        (0, $67W72.default).copy(contentRect, rect);
        (0, $h9U3p.expandOrShrinkRect)(contentRect, this._lineWidth / 2, true, true);
        return out;
    };
    /**
   * Convert a time date item to (x, y) four point.
   */ Calendar.prototype.dataToCalendarLayout = function(data, clamp) {
        var point = this.dataToPoint(data, clamp);
        return {
            center: point,
            tl: [
                point[0] - this._sw / 2,
                point[1] - this._sh / 2
            ],
            tr: [
                point[0] + this._sw / 2,
                point[1] - this._sh / 2
            ],
            br: [
                point[0] + this._sw / 2,
                point[1] + this._sh / 2
            ],
            bl: [
                point[0] - this._sw / 2,
                point[1] + this._sh / 2
            ]
        };
    };
    /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */ Calendar.prototype.pointToDate = function(point) {
        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
        var range = this._rangeInfo.range;
        if (this._orient === 'vertical') return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
    };
    Calendar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $96ef958a83b2edf0$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Calendar.prototype.convertToLayout = function(ecModel, finder, value) {
        var coordSys = $96ef958a83b2edf0$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToLayout(value) : null;
    };
    Calendar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $96ef958a83b2edf0$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    Calendar.prototype.containPoint = function(point) {
        console.warn('Not implemented.');
        return false;
    };
    /**
   * initRange
   * Normalize to an [start, end] array
   */ Calendar.prototype._initRangeOption = function() {
        var range = this._model.get('range');
        var normalizedRange;
        // Convert [1990] to 1990
        if ($2N6Uo.isArray(range) && range.length === 1) range = range[0];
        if (!$2N6Uo.isArray(range)) {
            var rangeStr = range.toString();
            // One year.
            if (/^\d{4}$/.test(rangeStr)) normalizedRange = [
                rangeStr + '-01-01',
                rangeStr + '-12-31'
            ];
            // One month
            if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
                var start = this.getDateInfo(rangeStr);
                var firstDay = start.date;
                firstDay.setMonth(firstDay.getMonth() + 1);
                var end = this.getNextNDay(firstDay, -1);
                normalizedRange = [
                    start.formatedDate,
                    end.formatedDate
                ];
            }
            // One day
            if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) normalizedRange = [
                rangeStr,
                rangeStr
            ];
        } else normalizedRange = range;
        if (!normalizedRange) // Not handling it.
        return range;
        var tmp = this._getRangeInfo(normalizedRange);
        if (tmp.start.time > tmp.end.time) normalizedRange.reverse();
        return normalizedRange;
    };
    /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */ Calendar.prototype._getRangeInfo = function(range) {
        var parsedRange = [
            this.getDateInfo(range[0]),
            this.getDateInfo(range[1])
        ];
        var reversed;
        if (parsedRange[0].time > parsedRange[1].time) {
            reversed = true;
            parsedRange.reverse();
        }
        var allDay = Math.floor(parsedRange[1].time / $96ef958a83b2edf0$var$PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / $96ef958a83b2edf0$var$PROXIMATE_ONE_DAY) + 1;
        // Consider case1 (#11677 #10430):
        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
        // Consider case2:
        // Firstly set system timezone as "Time Zone: America/Toronto",
        // ```
        // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
        // let second = new Date(1478412000000);
        // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
        // ```
        // will get wrong result because of DST. So we should fix it.
        var date = new Date(parsedRange[0].time);
        var startDateNum = date.getDate();
        var endDateNum = parsedRange[1].date.getDate();
        date.setDate(startDateNum + allDay - 1);
        // The bias can not over a month, so just compare date.
        var dateNum = date.getDate();
        if (dateNum !== endDateNum) {
            var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;
            while((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0){
                allDay -= sign;
                date.setDate(dateNum - sign);
            }
        }
        var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
        reversed && parsedRange.reverse();
        return {
            range: [
                parsedRange[0].formatedDate,
                parsedRange[1].formatedDate
            ],
            start: parsedRange[0],
            end: parsedRange[1],
            allDay: allDay,
            weeks: weeks,
            // From 0.
            nthWeek: nthWeek,
            fweek: parsedRange[0].day,
            lweek: parsedRange[1].day
        };
    };
    /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */ Calendar.prototype._getDateByWeeksAndDay = function(nthWeek, day, range) {
        var rangeInfo = this._getRangeInfo(range);
        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) return null;
        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
        var date = new Date(rangeInfo.start.time);
        date.setDate(+rangeInfo.start.d + nthDay);
        return this.getDateInfo(date);
    };
    Calendar.create = function(ecModel, api) {
        var calendarList = [];
        ecModel.eachComponent('calendar', function(calendarModel) {
            var calendar = new Calendar(calendarModel, ecModel, api);
            calendarList.push(calendar);
            calendarModel.coordinateSystem = calendar;
        });
        // Inject coordinate system
        ecModel.eachComponent(function(mainType, componentModel) {
            (0, $hIXrb.injectCoordSysByOption)({
                targetModel: componentModel,
                coordSysType: 'calendar',
                coordSysProvider: (0, $hIXrb.simpleCoordSysInjectionProvider)
            });
        });
        return calendarList;
    };
    Calendar.dimensions = [
        'time',
        'value'
    ];
    return Calendar;
}();
function $96ef958a83b2edf0$var$getCoordSys(finder) {
    var calendarModel = finder.calendarModel;
    var seriesModel = finder.seriesModel;
    var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $96ef958a83b2edf0$export$2e2bcd8739ae039 = $96ef958a83b2edf0$var$Calendar;

});


parcelRegister("VrLle", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $0acadc0e01d2834d$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");

var $bpyST = parcelRequire("bpyST");

var $eKQ6A = parcelRequire("eKQ6A");

var $8zxSQ = parcelRequire("8zxSQ");
var $0acadc0e01d2834d$export$83e718f1c3c9edae = /** @class */ function(_super) {
    (0, $9nEce.__extends)(DatasetModel, _super);
    function DatasetModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataset';
        return _this;
    }
    DatasetModel.prototype.init = function(option, parentModel, ecModel) {
        _super.prototype.init.call(this, option, parentModel, ecModel);
        this._sourceManager = new (0, $8zxSQ.SourceManager)(this);
        (0, $8zxSQ.disableTransformOptionMerge)(this);
    };
    DatasetModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.call(this, newOption, ecModel);
        (0, $8zxSQ.disableTransformOptionMerge)(this);
    };
    DatasetModel.prototype.optionUpdated = function() {
        this._sourceManager.dirty();
    };
    DatasetModel.prototype.getSourceManager = function() {
        return this._sourceManager;
    };
    DatasetModel.type = 'dataset';
    DatasetModel.defaultOption = {
        seriesLayoutBy: (0, $eKQ6A.SERIES_LAYOUT_BY_COLUMN)
    };
    return DatasetModel;
}((0, $eLD2b.default));
var $0acadc0e01d2834d$var$DatasetView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(DatasetView, _super);
    function DatasetView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataset';
        return _this;
    }
    DatasetView.type = 'dataset';
    return DatasetView;
}((0, $bpyST.default));
function $0acadc0e01d2834d$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($0acadc0e01d2834d$export$83e718f1c3c9edae);
    registers.registerComponentView($0acadc0e01d2834d$var$DatasetView);
}

});

parcelRegister("7hZHl", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $54e9fae372a88ca7$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $bMKXt = parcelRequire("bMKXt");

var $4XAdJ = parcelRequire("4XAdJ");
function $54e9fae372a88ca7$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $bMKXt.install));
    (0, $gX19P.use)((0, $4XAdJ.install));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

});
parcelRegister("bMKXt", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $89489a4fd52c2330$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $adaSC = parcelRequire("adaSC");

var $7YwlS = parcelRequire("7YwlS");

var $hR3kD = parcelRequire("hR3kD");

var $luD2W = parcelRequire("luD2W");
function $89489a4fd52c2330$export$4b3e715f166fdd78(registers) {
    (0, $luD2W.default)(registers);
    registers.registerComponentModel((0, $adaSC.default));
    registers.registerComponentView((0, $7YwlS.default));
    (0, $hR3kD.installDataZoomRoamProcessor)(registers);
}

});
parcelRegister("adaSC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76f38ecbf5119f7a$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $lT9Rl = parcelRequire("lT9Rl");

var $cKPmR = parcelRequire("cKPmR");
var $76f38ecbf5119f7a$var$InsideZoomModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(InsideZoomModel, _super);
    function InsideZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = InsideZoomModel.type;
        return _this;
    }
    InsideZoomModel.type = 'dataZoom.inside';
    InsideZoomModel.defaultOption = (0, $cKPmR.inheritDefaultOption)((0, $lT9Rl.default).defaultOption, {
        disabled: false,
        zoomLock: false,
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        moveOnMouseWheel: false,
        preventDefaultMouseMove: true
    });
    return InsideZoomModel;
}((0, $lT9Rl.default));
var $76f38ecbf5119f7a$export$2e2bcd8739ae039 = $76f38ecbf5119f7a$var$InsideZoomModel;

});
parcelRegister("lT9Rl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef661e2e395f251$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $eLD2b = parcelRequire("eLD2b");

var $7JqR5 = parcelRequire("7JqR5");

var $bx3T8 = parcelRequire("bx3T8");
var $fef661e2e395f251$var$DataZoomAxisInfo = /** @class */ function() {
    function DataZoomAxisInfo() {
        this.indexList = [];
        this.indexMap = [];
    }
    DataZoomAxisInfo.prototype.add = function(axisCmptIdx) {
        // Remove duplication.
        if (!this.indexMap[axisCmptIdx]) {
            this.indexList.push(axisCmptIdx);
            this.indexMap[axisCmptIdx] = true;
        }
    };
    return DataZoomAxisInfo;
}();
var $fef661e2e395f251$var$DataZoomModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(DataZoomModel, _super);
    function DataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomModel.type;
        _this._autoThrottle = true;
        _this._noTarget = true;
        /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     */ _this._rangePropMode = [
            'percent',
            'percent'
        ];
        return _this;
    }
    DataZoomModel.prototype.init = function(option, parentModel, ecModel) {
        var inputRawOption = $fef661e2e395f251$var$retrieveRawOption(option);
        /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     */ this.settledOption = inputRawOption;
        this.mergeDefaultAndTheme(option, ecModel);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype.mergeOption = function(newOption) {
        var inputRawOption = $fef661e2e395f251$var$retrieveRawOption(newOption);
        // FIX #2591
        (0, $2N6Uo.merge)(this.option, newOption, true);
        (0, $2N6Uo.merge)(this.settledOption, inputRawOption, true);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype._doInit = function(inputRawOption) {
        var thisOption = this.option;
        this._setDefaultThrottle(inputRawOption);
        this._updateRangeUse(inputRawOption);
        var settledOption = this.settledOption;
        (0, $2N6Uo.each)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names, index) {
            // start/end has higher priority over startValue/endValue if they
            // both set, but we should make chart.setOption({endValue: 1000})
            // effective, rather than chart.setOption({endValue: 1000, end: null}).
            if (this._rangePropMode[index] === 'value') thisOption[names[0]] = settledOption[names[0]] = null;
        // Otherwise do nothing and use the merge result.
        }, this);
        this._resetTarget();
    };
    DataZoomModel.prototype._resetTarget = function() {
        var optionOrient = this.get('orient', true);
        var targetAxisIndexMap = this._targetAxisInfoMap = (0, $2N6Uo.createHashMap)();
        var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);
        if (hasAxisSpecified) this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
        else {
            this._orient = optionOrient || 'horizontal';
            this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
        }
        this._noTarget = true;
        targetAxisIndexMap.each(function(axisInfo) {
            if (axisInfo.indexList.length) this._noTarget = false;
        }, this);
    };
    DataZoomModel.prototype._fillSpecifiedTargetAxis = function(targetAxisIndexMap) {
        var hasAxisSpecified = false;
        (0, $2N6Uo.each)((0, $7JqR5.DATA_ZOOM_AXIS_DIMENSIONS), function(axisDim) {
            var refering = this.getReferringComponents((0, $7JqR5.getAxisMainType)(axisDim), (0, $bx3T8.MULTIPLE_REFERRING));
            // When user set axisIndex as a empty array, we think that user specify axisIndex
            // but do not want use auto mode. Because empty array may be encountered when
            // some error occurred.
            if (!refering.specified) return;
            hasAxisSpecified = true;
            var axisInfo = new $fef661e2e395f251$var$DataZoomAxisInfo();
            (0, $2N6Uo.each)(refering.models, function(axisModel) {
                axisInfo.add(axisModel.componentIndex);
            });
            targetAxisIndexMap.set(axisDim, axisInfo);
        }, this);
        return hasAxisSpecified;
    };
    DataZoomModel.prototype._fillAutoTargetAxisByOrient = function(targetAxisIndexMap, orient) {
        var ecModel = this.ecModel;
        var needAuto = true;
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisDim = orient === 'vertical' ? 'y' : 'x';
            var axisModels = ecModel.findComponents({
                mainType: axisDim + 'Axis'
            });
            setParallelAxis(axisModels, axisDim);
        }
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisModels = ecModel.findComponents({
                mainType: 'singleAxis',
                filter: function(axisModel) {
                    return axisModel.get('orient', true) === orient;
                }
            });
            setParallelAxis(axisModels, 'single');
        }
        function setParallelAxis(axisModels, axisDim) {
            // At least use the first parallel axis as the target axis.
            var axisModel = axisModels[0];
            if (!axisModel) return;
            var axisInfo = new $fef661e2e395f251$var$DataZoomAxisInfo();
            axisInfo.add(axisModel.componentIndex);
            targetAxisIndexMap.set(axisDim, axisInfo);
            needAuto = false;
            // Find parallel axes in the same grid.
            if (axisDim === 'x' || axisDim === 'y') {
                var gridModel_1 = axisModel.getReferringComponents('grid', (0, $bx3T8.SINGLE_REFERRING)).models[0];
                gridModel_1 && (0, $2N6Uo.each)(axisModels, function(axModel) {
                    if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents('grid', (0, $bx3T8.SINGLE_REFERRING)).models[0]) axisInfo.add(axModel.componentIndex);
                });
            }
        }
        if (needAuto) // If no parallel axis, find the first category axis as default. (Also consider polar).
        (0, $2N6Uo.each)((0, $7JqR5.DATA_ZOOM_AXIS_DIMENSIONS), function(axisDim) {
            if (!needAuto) return;
            var axisModels = ecModel.findComponents({
                mainType: (0, $7JqR5.getAxisMainType)(axisDim),
                filter: function(axisModel) {
                    return axisModel.get('type', true) === 'category';
                }
            });
            if (axisModels[0]) {
                var axisInfo = new $fef661e2e395f251$var$DataZoomAxisInfo();
                axisInfo.add(axisModels[0].componentIndex);
                targetAxisIndexMap.set(axisDim, axisInfo);
                needAuto = false;
            }
        }, this);
    };
    DataZoomModel.prototype._makeAutoOrientByTargetAxis = function() {
        var dim;
        // Find the first axis
        this.eachTargetAxis(function(axisDim) {
            !dim && (dim = axisDim);
        }, this);
        return dim === 'y' ? 'vertical' : 'horizontal';
    };
    DataZoomModel.prototype._setDefaultThrottle = function(inputRawOption) {
        // When first time user set throttle, auto throttle ends.
        if (inputRawOption.hasOwnProperty('throttle')) this._autoThrottle = false;
        if (this._autoThrottle) {
            var globalOption = this.ecModel.option;
            this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
        }
    };
    DataZoomModel.prototype._updateRangeUse = function(inputRawOption) {
        var rangePropMode = this._rangePropMode;
        var rangeModeInOption = this.get('rangeMode');
        (0, $2N6Uo.each)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names, index) {
            var percentSpecified = inputRawOption[names[0]] != null;
            var valueSpecified = inputRawOption[names[1]] != null;
            if (percentSpecified && !valueSpecified) rangePropMode[index] = 'percent';
            else if (!percentSpecified && valueSpecified) rangePropMode[index] = 'value';
            else if (rangeModeInOption) rangePropMode[index] = rangeModeInOption[index];
            else if (percentSpecified) // percentSpecified && valueSpecified
            rangePropMode[index] = 'percent';
        // else remain its original setting.
        });
    };
    DataZoomModel.prototype.noTarget = function() {
        return this._noTarget;
    };
    DataZoomModel.prototype.getFirstTargetAxisModel = function() {
        var firstAxisModel;
        this.eachTargetAxis(function(axisDim, axisIndex) {
            if (firstAxisModel == null) firstAxisModel = this.ecModel.getComponent((0, $7JqR5.getAxisMainType)(axisDim), axisIndex);
        }, this);
        return firstAxisModel;
    };
    /**
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */ DataZoomModel.prototype.eachTargetAxis = function(callback, context) {
        this._targetAxisInfoMap.each(function(axisInfo, axisDim) {
            (0, $2N6Uo.each)(axisInfo.indexList, function(axisIndex) {
                callback.call(context, axisDim, axisIndex);
            });
        });
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisProxy = function(axisDim, axisIndex) {
        var axisModel = this.getAxisModel(axisDim, axisIndex);
        if (axisModel) return axisModel.__dzAxisProxy;
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisModel = function(axisDim, axisIndex) {
        var axisInfo = this._targetAxisInfoMap.get(axisDim);
        if (axisInfo && axisInfo.indexMap[axisIndex]) return this.ecModel.getComponent((0, $7JqR5.getAxisMainType)(axisDim), axisIndex);
    };
    /**
   * If not specified, set to undefined.
   */ DataZoomModel.prototype.setRawRange = function(opt) {
        var thisOption = this.option;
        var settledOption = this.settledOption;
        (0, $2N6Uo.each)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names) {
            // Consider the pair <start, startValue>:
            // If one has value and the other one is `null/undefined`, we both set them
            // to `settledOption`. This strategy enables the feature to clear the original
            // value in `settledOption` to `null/undefined`.
            // But if both of them are `null/undefined`, we do not set them to `settledOption`
            // and keep `settledOption` with the original value. This strategy enables users to
            // only set <end or endValue> but not set <start or startValue> when calling
            // `dispatchAction`.
            // The pair <end, endValue> is treated in the same way.
            if (opt[names[0]] != null || opt[names[1]] != null) {
                thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
                thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
            }
        }, this);
        this._updateRangeUse(opt);
    };
    DataZoomModel.prototype.setCalculatedRange = function(opt) {
        var option = this.option;
        (0, $2N6Uo.each)([
            'start',
            'startValue',
            'end',
            'endValue'
        ], function(name) {
            option[name] = opt[name];
        });
    };
    DataZoomModel.prototype.getPercentRange = function() {
        var axisProxy = this.findRepresentativeAxisProxy();
        if (axisProxy) return axisProxy.getDataPercentWindow();
    };
    /**
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @return [startValue, endValue] value can only be '-' or finite number.
   */ DataZoomModel.prototype.getValueRange = function(axisDim, axisIndex) {
        if (axisDim == null && axisIndex == null) {
            var axisProxy = this.findRepresentativeAxisProxy();
            if (axisProxy) return axisProxy.getDataValueWindow();
        } else return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
    };
    /**
   * @param axisModel If axisModel given, find axisProxy
   *      corresponding to the axisModel
   */ DataZoomModel.prototype.findRepresentativeAxisProxy = function(axisModel) {
        if (axisModel) return axisModel.__dzAxisProxy;
        // Find the first hosted axisProxy
        var firstProxy;
        var axisDimList = this._targetAxisInfoMap.keys();
        for(var i = 0; i < axisDimList.length; i++){
            var axisDim = axisDimList[i];
            var axisInfo = this._targetAxisInfoMap.get(axisDim);
            for(var j = 0; j < axisInfo.indexList.length; j++){
                var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);
                if (proxy.hostedBy(this)) return proxy;
                if (!firstProxy) firstProxy = proxy;
            }
        }
        // If no hosted proxy found, still need to return a proxy.
        // This case always happens in toolbox dataZoom, where axes are all hosted by
        // other dataZooms.
        return firstProxy;
    };
    DataZoomModel.prototype.getRangePropMode = function() {
        return this._rangePropMode.slice();
    };
    DataZoomModel.prototype.getOrient = function() {
        return this._orient;
    };
    DataZoomModel.type = 'dataZoom';
    DataZoomModel.dependencies = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'series',
        'toolbox'
    ];
    DataZoomModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        filterMode: 'filter',
        start: 0,
        end: 100
    };
    return DataZoomModel;
}((0, $eLD2b.default));
/**
 * Retrieve those raw params from option, which will be cached separately,
 * because they will be overwritten by normalized/calculated values in the main
 * process.
 */ function $fef661e2e395f251$var$retrieveRawOption(option) {
    var ret = {};
    (0, $2N6Uo.each)([
        'start',
        'end',
        'startValue',
        'endValue',
        'throttle'
    ], function(name) {
        option.hasOwnProperty(name) && (ret[name] = option[name]);
    });
    return ret;
}
var $fef661e2e395f251$export$2e2bcd8739ae039 = $fef661e2e395f251$var$DataZoomModel;

});
parcelRegister("7JqR5", function(module, exports) {

$parcel$export(module.exports, "DATA_ZOOM_AXIS_DIMENSIONS", function () { return $5a11914817cea022$export$f25521e726513e83; });
$parcel$export(module.exports, "isCoordSupported", function () { return $5a11914817cea022$export$2d449d4adc0d2cfc; });
$parcel$export(module.exports, "getAxisMainType", function () { return $5a11914817cea022$export$90855f7219399082; });
$parcel$export(module.exports, "findEffectedDataZooms", function () { return $5a11914817cea022$export$9e00b6c2b8b2e9a7; });
$parcel$export(module.exports, "collectReferCoordSysModelInfo", function () { return $5a11914817cea022$export$b41173dee9da195b; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
var $5a11914817cea022$export$f25521e726513e83 = [
    'x',
    'y',
    'radius',
    'angle',
    'single'
];
// Supported coords.
// FIXME: polar has been broken (but rarely used).
var $5a11914817cea022$var$SERIES_COORDS = [
    'cartesian2d',
    'polar',
    'singleAxis'
];
function $5a11914817cea022$export$2d449d4adc0d2cfc(seriesModel) {
    var coordType = seriesModel.get('coordinateSystem');
    return (0, $2N6Uo.indexOf)($5a11914817cea022$var$SERIES_COORDS, coordType) >= 0;
}
function $5a11914817cea022$export$90855f7219399082(axisDim) {
    return axisDim + 'Axis';
}
function $5a11914817cea022$export$f9c16e110bf1e902(axisDim) {
    return axisDim + 'AxisIndex';
}
function $5a11914817cea022$export$fa8714b2310ddff9(axisDim) {
    return axisDim + 'AxisId';
}
function $5a11914817cea022$export$9e00b6c2b8b2e9a7(ecModel, payload) {
    // Key: `DataZoomAxisDimension`
    var axisRecords = (0, $2N6Uo.createHashMap)();
    var effectedModels = [];
    // Key: uid of dataZoomModel
    var effectedModelMap = (0, $2N6Uo.createHashMap)();
    // Find the dataZooms specified by payload.
    ecModel.eachComponent({
        mainType: 'dataZoom',
        query: payload
    }, function(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid)) addToEffected(dataZoomModel);
    });
    // Start from the given dataZoomModels, travel the graph to find
    // all of the linked dataZoom models.
    var foundNewLink;
    do {
        foundNewLink = false;
        ecModel.eachComponent('dataZoom', processSingle);
    }while (foundNewLink);
    function processSingle(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
            addToEffected(dataZoomModel);
            foundNewLink = true;
        }
    }
    function addToEffected(dataZoom) {
        effectedModelMap.set(dataZoom.uid, true);
        effectedModels.push(dataZoom);
        markAxisControlled(dataZoom);
    }
    function isLinked(dataZoomModel) {
        var isLink = false;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var axisIdxArr = axisRecords.get(axisDim);
            if (axisIdxArr && axisIdxArr[axisIndex]) isLink = true;
        });
        return isLink;
    }
    function markAxisControlled(dataZoomModel) {
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
        });
    }
    return effectedModels;
}
function $5a11914817cea022$export$b41173dee9da195b(dataZoomModel) {
    var ecModel = dataZoomModel.ecModel;
    var coordSysInfoWrap = {
        infoList: [],
        infoMap: (0, $2N6Uo.createHashMap)()
    };
    dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
        var axisModel = ecModel.getComponent($5a11914817cea022$export$90855f7219399082(axisDim), axisIndex);
        if (!axisModel) return;
        var coordSysModel = axisModel.getCoordSysModel();
        if (!coordSysModel) return;
        var coordSysUid = coordSysModel.uid;
        var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);
        if (!coordSysInfo) {
            coordSysInfo = {
                model: coordSysModel,
                axisModels: []
            };
            coordSysInfoWrap.infoList.push(coordSysInfo);
            coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
        }
        coordSysInfo.axisModels.push(axisModel);
    });
    return coordSysInfoWrap;
}

});



parcelRegister("7YwlS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ce73b64f482f532$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $iVHee = parcelRequire("iVHee");

var $43jQn = parcelRequire("43jQn");

var $hR3kD = parcelRequire("hR3kD");

var $2N6Uo = parcelRequire("2N6Uo");
var $5ce73b64f482f532$var$InsideZoomView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(InsideZoomView, _super);
    function InsideZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataZoom.inside';
        return _this;
    }
    InsideZoomView.prototype.render = function(dataZoomModel, ecModel, api) {
        _super.prototype.render.apply(this, arguments);
        if (dataZoomModel.noTarget()) {
            this._clear();
            return;
        }
        // Hence the `throttle` util ensures to preserve command order,
        // here simply updating range all the time will not cause missing
        // any of the the roam change.
        this.range = dataZoomModel.getPercentRange();
        // Reset controllers.
        $hR3kD.setViewInfoToCoordSysRecord(api, dataZoomModel, {
            pan: (0, $2N6Uo.bind)($5ce73b64f482f532$var$getRangeHandlers.pan, this),
            zoom: (0, $2N6Uo.bind)($5ce73b64f482f532$var$getRangeHandlers.zoom, this),
            scrollMove: (0, $2N6Uo.bind)($5ce73b64f482f532$var$getRangeHandlers.scrollMove, this)
        });
    };
    InsideZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    InsideZoomView.prototype._clear = function() {
        $hR3kD.disposeCoordSysRecordIfNeeded(this.api, this.dataZoomModel);
        this.range = null;
    };
    InsideZoomView.type = 'dataZoom.inside';
    return InsideZoomView;
}((0, $iVHee.default));
var $5ce73b64f482f532$var$getRangeHandlers = {
    zoom: function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var directionInfo = $5ce73b64f482f532$var$getDirectionInfo[coordSysMainType](null, [
            e.originX,
            e.originY
        ], axisModel, controller, coordSysInfo);
        var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
        var scale = Math.max(1 / e.scale, 0);
        range[0] = (range[0] - percentPoint) * scale + percentPoint;
        range[1] = (range[1] - percentPoint) * scale + percentPoint;
        // Restrict range.
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        (0, $43jQn.default)(0, range, [
            0,
            100
        ], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    },
    pan: $5ce73b64f482f532$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $5ce73b64f482f532$var$getDirectionInfo[coordSysMainType]([
            e.oldX,
            e.oldY
        ], [
            e.newX,
            e.newY
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
    }),
    scrollMove: $5ce73b64f482f532$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $5ce73b64f482f532$var$getDirectionInfo[coordSysMainType]([
            0,
            0
        ], [
            e.scrollDelta,
            e.scrollDelta
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
    })
};
function $5ce73b64f482f532$var$makeMover(getPercentDelta) {
    return function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
        (0, $43jQn.default)(percentDelta, range, [
            0,
            100
        ], 'all');
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    };
}
var $5ce73b64f482f532$var$getDirectionInfo = {
    grid: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.dim === 'x') {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // axis.dim === 'y'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    polar: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var polar = coordSysInfo.model.coordinateSystem;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var angleExtent = polar.getAngleAxis().getExtent();
        oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [
            0,
            0
        ];
        newPoint = polar.pointToCoord(newPoint);
        if (axisModel.mainType === 'radiusAxis') {
            ret.pixel = newPoint[0] - oldPoint[0];
            // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
            // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
            ret.pixelLength = radiusExtent[1] - radiusExtent[0];
            ret.pixelStart = radiusExtent[0];
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'angleAxis'
            ret.pixel = newPoint[1] - oldPoint[1];
            // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
            // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
            ret.pixelLength = angleExtent[1] - angleExtent[0];
            ret.pixelStart = angleExtent[0];
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    singleAxis: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        var ret = {};
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.orient === 'horizontal') {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'vertical'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    }
};
var $5ce73b64f482f532$export$2e2bcd8739ae039 = $5ce73b64f482f532$var$InsideZoomView;

});
parcelRegister("iVHee", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc7f152173041755$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $bpyST = parcelRequire("bpyST");
var $dc7f152173041755$var$DataZoomView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(DataZoomView, _super);
    function DataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomView.type;
        return _this;
    }
    DataZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        this.dataZoomModel = dataZoomModel;
        this.ecModel = ecModel;
        this.api = api;
    };
    DataZoomView.type = 'dataZoom';
    return DataZoomView;
}((0, $bpyST.default));
var $dc7f152173041755$export$2e2bcd8739ae039 = $dc7f152173041755$var$DataZoomView;

});

parcelRegister("hR3kD", function(module, exports) {

$parcel$export(module.exports, "setViewInfoToCoordSysRecord", function () { return $cff9f88738d856ab$export$c499fdc26107c565; });
$parcel$export(module.exports, "disposeCoordSysRecordIfNeeded", function () { return $cff9f88738d856ab$export$d074fdbbb2bf218c; });
$parcel$export(module.exports, "installDataZoomRoamProcessor", function () { return $cff9f88738d856ab$export$f3632ddafc9ea51e; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.

var $ic6Qi = parcelRequire("ic6Qi");

var $99VtN = parcelRequire("99VtN");

var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $7JqR5 = parcelRequire("7JqR5");
var $cff9f88738d856ab$var$inner = (0, $bx3T8.makeInner)();
function $cff9f88738d856ab$export$c499fdc26107c565(api, dataZoomModel, getRange) {
    $cff9f88738d856ab$var$inner(api).coordSysRecordMap.each(function(coordSysRecord) {
        var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);
        if (dzInfo) dzInfo.getRange = getRange;
    });
}
function $cff9f88738d856ab$export$d074fdbbb2bf218c(api, dataZoomModel) {
    var coordSysRecordMap = $cff9f88738d856ab$var$inner(api).coordSysRecordMap;
    var coordSysKeyArr = coordSysRecordMap.keys();
    for(var i = 0; i < coordSysKeyArr.length; i++){
        var coordSysKey = coordSysKeyArr[i];
        var coordSysRecord = coordSysRecordMap.get(coordSysKey);
        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
        if (dataZoomInfoMap) {
            var dzUid = dataZoomModel.uid;
            var dzInfo = dataZoomInfoMap.get(dzUid);
            if (dzInfo) {
                dataZoomInfoMap.removeKey(dzUid);
                if (!dataZoomInfoMap.keys().length) $cff9f88738d856ab$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
            }
        }
    }
}
function $cff9f88738d856ab$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
    if (coordSysRecord) {
        coordSysRecordMap.removeKey(coordSysRecord.model.uid);
        var controller = coordSysRecord.controller;
        controller && controller.dispose();
    }
}
function $cff9f88738d856ab$var$createCoordSysRecord(api, coordSysModel) {
    // These init props will never change after record created.
    var coordSysRecord = {
        model: coordSysModel,
        containsPoint: (0, $2N6Uo.curry)($cff9f88738d856ab$var$containsPoint, coordSysModel),
        dispatchAction: (0, $2N6Uo.curry)($cff9f88738d856ab$var$dispatchAction, api),
        dataZoomInfoMap: null,
        controller: null
    };
    // Must not do anything depends on coordSysRecord outside the event handler here,
    // because coordSysRecord not completed yet.
    var controller = coordSysRecord.controller = new (0, $ic6Qi.default)(api.getZr());
    (0, $2N6Uo.each)([
        'pan',
        'zoom',
        'scrollMove'
    ], function(eventName) {
        controller.on(eventName, function(event) {
            var batch = [];
            coordSysRecord.dataZoomInfoMap.each(function(dzInfo) {
                // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
                // moveOnMouseWheel, ...) enabled.
                if (!event.isAvailableBehavior(dzInfo.model.option)) return;
                var method = (dzInfo.getRange || {})[eventName];
                var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
                !dzInfo.model.get('disabled', true) && range && batch.push({
                    dataZoomId: dzInfo.model.id,
                    start: range[0],
                    end: range[1]
                });
            });
            batch.length && coordSysRecord.dispatchAction(batch);
        });
    });
    return coordSysRecord;
}
/**
 * This action will be throttled.
 */ function $cff9f88738d856ab$var$dispatchAction(api, batch) {
    if (!api.isDisposed()) api.dispatchAction({
        type: 'dataZoom',
        animation: {
            easing: 'cubicOut',
            duration: 100
        },
        batch: batch
    });
}
function $cff9f88738d856ab$var$containsPoint(coordSysModel, e, x, y) {
    return coordSysModel.coordinateSystem.containPoint([
        x,
        y
    ]);
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */ function $cff9f88738d856ab$var$mergeControllerParams(dataZoomInfoMap, coordSysRecord, api) {
    var controlType;
    // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
    // as string, it is probably revert to reserved word by compress tool. See #7411.
    var prefix = 'type_';
    var typePriority = {
        'type_true': 2,
        'type_move': 1,
        'type_false': 0,
        'type_undefined': -1
    };
    var preventDefaultMouseMove = true;
    dataZoomInfoMap.each(function(dataZoomInfo) {
        var dataZoomModel = dataZoomInfo.model;
        var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
        if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) controlType = oneType;
        // Prevent default move event by default. If one false, do not prevent. Otherwise
        // users may be confused why it does not work when multiple insideZooms exist.
        preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get('preventDefaultMouseMove', true);
    });
    return {
        controlType: controlType,
        opt: {
            // RoamController will enable all of these functionalities,
            // and the final behavior is determined by its event listener
            // provided by each inside zoom.
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
            preventDefaultMouseMove: !!preventDefaultMouseMove,
            api: api,
            zInfo: {
                component: coordSysRecord.model
            },
            triggerInfo: {
                roamTrigger: null,
                isInSelf: coordSysRecord.containsPoint
            }
        }
    };
}
function $cff9f88738d856ab$export$f3632ddafc9ea51e(registers) {
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function(ecModel, api) {
        var apiInner = $cff9f88738d856ab$var$inner(api);
        var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = (0, $2N6Uo.createHashMap)());
        coordSysRecordMap.each(function(coordSysRecord) {
            // `coordSysRecordMap` always exists (because it holds the `roam controller`, which should
            // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
            coordSysRecord.dataZoomInfoMap = null;
        });
        ecModel.eachComponent({
            mainType: 'dataZoom',
            subType: 'inside'
        }, function(dataZoomModel) {
            var dzReferCoordSysWrap = (0, $7JqR5.collectReferCoordSysModelInfo)(dataZoomModel);
            (0, $2N6Uo.each)(dzReferCoordSysWrap.infoList, function(dzCoordSysInfo) {
                var coordSysUid = dzCoordSysInfo.model.uid;
                var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, $cff9f88738d856ab$var$createCoordSysRecord(api, dzCoordSysInfo.model));
                var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = (0, $2N6Uo.createHashMap)());
                // Notice these props might be changed each time for a single dataZoomModel.
                dataZoomInfoMap.set(dataZoomModel.uid, {
                    dzReferCoordSysInfo: dzCoordSysInfo,
                    model: dataZoomModel,
                    getRange: null
                });
            });
        });
        // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
        // (2) Clear coord sys if not refered by any dataZoom.
        coordSysRecordMap.each(function(coordSysRecord) {
            var controller = coordSysRecord.controller;
            var firstDzInfo;
            var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
            if (dataZoomInfoMap) {
                var firstDzKey = dataZoomInfoMap.keys()[0];
                if (firstDzKey != null) firstDzInfo = dataZoomInfoMap.get(firstDzKey);
            }
            if (!firstDzInfo) {
                $cff9f88738d856ab$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
                return;
            }
            var controllerParams = $cff9f88738d856ab$var$mergeControllerParams(dataZoomInfoMap, coordSysRecord, api);
            controller.enable(controllerParams.controlType, controllerParams.opt);
            $99VtN.createOrUpdate(coordSysRecord, 'dispatchAction', firstDzInfo.model.get('throttle', true), 'fixRate');
        });
    });
}

});


parcelRegister("luD2W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa5ab01d64c7624a$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1yrz0 = parcelRequire("1yrz0");

var $6u8gy = parcelRequire("6u8gy");
var $fa5ab01d64c7624a$var$installed = false;
function $fa5ab01d64c7624a$export$2e2bcd8739ae039(registers) {
    if ($fa5ab01d64c7624a$var$installed) return;
    $fa5ab01d64c7624a$var$installed = true;
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, (0, $1yrz0.default));
    (0, $6u8gy.default)(registers);
    registers.registerSubTypeDefaulter('dataZoom', function() {
        // Default 'slider' when no type specified.
        return 'slider';
    });
}

});
parcelRegister("1yrz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $121e58fb5ad9686d$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $7JqR5 = parcelRequire("7JqR5");

var $dlGjW = parcelRequire("dlGjW");
var $121e58fb5ad9686d$var$dataZoomProcessor = {
    // `dataZoomProcessor` will only be performed in needed series. Consider if
    // there is a line series and a pie series, it is better not to update the
    // line series if only pie series is needed to be updated.
    getTargetSeries: function(ecModel) {
        function eachAxisModel(cb) {
            ecModel.eachComponent('dataZoom', function(dataZoomModel) {
                dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                    var axisModel = ecModel.getComponent((0, $7JqR5.getAxisMainType)(axisDim), axisIndex);
                    cb(axisDim, axisIndex, axisModel, dataZoomModel);
                });
            });
        }
        // FIXME: it brings side-effect to `getTargetSeries`.
        // Prepare axis proxies.
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // dispose all last axis proxy, in case that some axis are deleted.
            axisModel.__dzAxisProxy = null;
        });
        var proxyList = [];
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // Different dataZooms may constrol the same axis. In that case,
            // an axisProxy serves both of them.
            if (!axisModel.__dzAxisProxy) {
                // Use the first dataZoomModel as the main model of axisProxy.
                axisModel.__dzAxisProxy = new (0, $dlGjW.default)(axisDim, axisIndex, dataZoomModel, ecModel);
                proxyList.push(axisModel.__dzAxisProxy);
            }
        });
        var seriesModelMap = (0, $2N6Uo.createHashMap)();
        (0, $2N6Uo.each)(proxyList, function(axisProxy) {
            (0, $2N6Uo.each)(axisProxy.getTargetSeriesModels(), function(seriesModel) {
                seriesModelMap.set(seriesModel.uid, seriesModel);
            });
        });
        return seriesModelMap;
    },
    // Consider appendData, where filter should be performed. Because data process is
    // in block mode currently, it is not need to worry about that the overallProgress
    // execute every frame.
    overallReset: function(ecModel, api) {
        ecModel.eachComponent('dataZoom', function(dataZoomModel) {
            // We calculate window and reset axis here but not in model
            // init stage and not after action dispatch handler, because
            // reset should be called after seriesData.restoreData.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
            });
            // Caution: data zoom filtering is order sensitive when using
            // percent range and no min/max/scale set on axis.
            // For example, we have dataZoom definition:
            // [
            //      {xAxisIndex: 0, start: 30, end: 70},
            //      {yAxisIndex: 0, start: 20, end: 80}
            // ]
            // In this case, [20, 80] of y-dataZoom should be based on data
            // that have filtered by x-dataZoom using range of [30, 70],
            // but should not be based on full raw data. Thus sliding
            // x-dataZoom will change both ranges of xAxis and yAxis,
            // while sliding y-dataZoom will only change the range of yAxis.
            // So we should filter x-axis after reset x-axis immediately,
            // and then reset y-axis and filter y-axis.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
            });
        });
        ecModel.eachComponent('dataZoom', function(dataZoomModel) {
            // Fullfill all of the range props so that user
            // is able to get them from chart.getOption().
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var percentRange = axisProxy.getDataPercentWindow();
                var valueRange = axisProxy.getDataValueWindow();
                dataZoomModel.setCalculatedRange({
                    start: percentRange[0],
                    end: percentRange[1],
                    startValue: valueRange[0],
                    endValue: valueRange[1]
                });
            }
        });
    }
};
var $121e58fb5ad9686d$export$2e2bcd8739ae039 = $121e58fb5ad9686d$var$dataZoomProcessor;

});
parcelRegister("dlGjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b7e10839aea8ea4$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");

var $43jQn = parcelRequire("43jQn");

var $9AF98 = parcelRequire("9AF98");

var $h4rbp = parcelRequire("h4rbp");

var $7JqR5 = parcelRequire("7JqR5");

var $bx3T8 = parcelRequire("bx3T8");
var $9b7e10839aea8ea4$var$each = $2N6Uo.each;
var $9b7e10839aea8ea4$var$asc = $iCU10.asc;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 */ var $9b7e10839aea8ea4$var$AxisProxy = /** @class */ function() {
    function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
        this._dimName = dimName;
        this._axisIndex = axisIndex;
        this.ecModel = ecModel;
        this._dataZoomModel = dataZoomModel;
    // /**
    //  * @readOnly
    //  * @private
    //  */
    // this.hasSeriesStacked;
    }
    /**
   * Whether the axisProxy is hosted by dataZoomModel.
   */ AxisProxy.prototype.hostedBy = function(dataZoomModel) {
        return this._dataZoomModel === dataZoomModel;
    };
    /**
   * @return Value can only be NaN or finite value.
   */ AxisProxy.prototype.getDataValueWindow = function() {
        return this._valueWindow.slice();
    };
    /**
   * @return {Array.<number>}
   */ AxisProxy.prototype.getDataPercentWindow = function() {
        return this._percentWindow.slice();
    };
    AxisProxy.prototype.getTargetSeriesModels = function() {
        var seriesModels = [];
        this.ecModel.eachSeries(function(seriesModel) {
            if ((0, $7JqR5.isCoordSupported)(seriesModel)) {
                var axisMainType = (0, $7JqR5.getAxisMainType)(this._dimName);
                var axisModel = seriesModel.getReferringComponents(axisMainType, (0, $bx3T8.SINGLE_REFERRING)).models[0];
                if (axisModel && this._axisIndex === axisModel.componentIndex) seriesModels.push(seriesModel);
            }
        }, this);
        return seriesModels;
    };
    AxisProxy.prototype.getAxisModel = function() {
        return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
    };
    AxisProxy.prototype.getMinMaxSpan = function() {
        return $2N6Uo.clone(this._minMaxSpan);
    };
    /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   */ AxisProxy.prototype.calculateDataWindow = function(opt) {
        var dataExtent = this._dataExtent;
        var axisModel = this.getAxisModel();
        var scale = axisModel.axis.scale;
        var rangePropMode = this._dataZoomModel.getRangePropMode();
        var percentExtent = [
            0,
            100
        ];
        var percentWindow = [];
        var valueWindow = [];
        var hasPropModeValue;
        $9b7e10839aea8ea4$var$each([
            'start',
            'end'
        ], function(prop, idx) {
            var boundPercent = opt[prop];
            var boundValue = opt[prop + 'Value'];
            // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
            // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
            // but not min/max of axis, which will be calculated by data window then).
            // The former one is suitable for cases that a dataZoom component controls multiple
            // axes with different unit or extent, and the latter one is suitable for accurate
            // zoom by pixel (e.g., in dataZoomSelect).
            // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
            // only when setOption or dispatchAction, otherwise it remains its original value.
            // (Why not only record `percentProp` and always map to `valueProp`? Because
            // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
            // `valueProp`. consider two axes constrolled by one dataZoom. They have different
            // data extent. All of values that are overflow the `dataExtent` will be calculated
            // to percent '100%').
            if (rangePropMode[idx] === 'percent') {
                boundPercent == null && (boundPercent = percentExtent[idx]);
                // Use scale.parse to math round for category or time axis.
                boundValue = scale.parse($iCU10.linearMap(boundPercent, percentExtent, dataExtent));
            } else {
                hasPropModeValue = true;
                boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue);
                // Calculating `percent` from `value` may be not accurate, because
                // This calculation can not be inversed, because all of values that
                // are overflow the `dataExtent` will be calculated to percent '100%'
                boundPercent = $iCU10.linearMap(boundValue, dataExtent, percentExtent);
            }
            // valueWindow[idx] = round(boundValue);
            // percentWindow[idx] = round(boundPercent);
            // fallback to extent start/end when parsed value or percent is invalid
            valueWindow[idx] = boundValue == null || isNaN(boundValue) ? dataExtent[idx] : boundValue;
            percentWindow[idx] = boundPercent == null || isNaN(boundPercent) ? percentExtent[idx] : boundPercent;
        });
        $9b7e10839aea8ea4$var$asc(valueWindow);
        $9b7e10839aea8ea4$var$asc(percentWindow);
        // The windows from user calling of `dispatchAction` might be out of the extent,
        // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we don't restrict window
        // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
        // where API is able to initialize/modify the window size even though `zoomLock`
        // specified.
        var spans = this._minMaxSpan;
        hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
        function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
            var suffix = toValue ? 'Span' : 'ValueSpan';
            (0, $43jQn.default)(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);
            for(var i = 0; i < 2; i++){
                toWindow[i] = $iCU10.linearMap(fromWindow[i], fromExtent, toExtent, true);
                toValue && (toWindow[i] = scale.parse(toWindow[i]));
            }
        }
        return {
            valueWindow: valueWindow,
            percentWindow: percentWindow
        };
    };
    /**
   * Notice: reset should not be called before series.restoreData() is called,
   * so it is recommended to be called in "process stage" but not "model init
   * stage".
   */ AxisProxy.prototype.reset = function(dataZoomModel) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var targetSeries = this.getTargetSeriesModels();
        // Culculate data window and data extent, and record them.
        this._dataExtent = $9b7e10839aea8ea4$var$calculateDataExtent(this, this._dimName, targetSeries);
        // `calculateDataWindow` uses min/maxSpan.
        this._updateMinMaxSpan();
        var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
        this._valueWindow = dataWindow.valueWindow;
        this._percentWindow = dataWindow.percentWindow;
        // Update axis setting then.
        this._setAxisModel();
    };
    AxisProxy.prototype.filterData = function(dataZoomModel, api) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var axisDim = this._dimName;
        var seriesModels = this.getTargetSeriesModels();
        var filterMode = dataZoomModel.get('filterMode');
        var valueWindow = this._valueWindow;
        if (filterMode === 'none') return;
        // FIXME
        // Toolbox may has dataZoom injected. And if there are stacked bar chart
        // with NaN data, NaN will be filtered and stack will be wrong.
        // So we need to force the mode to be set empty.
        // In fect, it is not a big deal that do not support filterMode-'filter'
        // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
        // selection" some day, which might need "adapt to data extent on the
        // otherAxis", which is disabled by filterMode-'empty'.
        // But currently, stack has been fixed to based on value but not index,
        // so this is not an issue any more.
        // let otherAxisModel = this.getOtherAxisModel();
        // if (dataZoomModel.get('$fromToolbox')
        //     && otherAxisModel
        //     && otherAxisModel.hasSeriesStacked
        // ) {
        //     filterMode = 'empty';
        // }
        // TODO
        // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
        $9b7e10839aea8ea4$var$each(seriesModels, function(seriesModel) {
            var seriesData = seriesModel.getData();
            var dataDims = seriesData.mapDimensionsAll(axisDim);
            if (!dataDims.length) return;
            if (filterMode === 'weakFilter') {
                var store_1 = seriesData.getStore();
                var dataDimIndices_1 = $2N6Uo.map(dataDims, function(dim) {
                    return seriesData.getDimensionIndex(dim);
                }, seriesData);
                seriesData.filterSelf(function(dataIndex) {
                    var leftOut;
                    var rightOut;
                    var hasValue;
                    for(var i = 0; i < dataDims.length; i++){
                        var value = store_1.get(dataDimIndices_1[i], dataIndex);
                        var thisHasValue = !isNaN(value);
                        var thisLeftOut = value < valueWindow[0];
                        var thisRightOut = value > valueWindow[1];
                        if (thisHasValue && !thisLeftOut && !thisRightOut) return true;
                        thisHasValue && (hasValue = true);
                        thisLeftOut && (leftOut = true);
                        thisRightOut && (rightOut = true);
                    }
                    // If both left out and right out, do not filter.
                    return hasValue && leftOut && rightOut;
                });
            } else $9b7e10839aea8ea4$var$each(dataDims, function(dim) {
                if (filterMode === 'empty') seriesModel.setData(seriesData = seriesData.map(dim, function(value) {
                    return !isInWindow(value) ? NaN : value;
                }));
                else {
                    var range = {};
                    range[dim] = valueWindow;
                    // console.time('select');
                    seriesData.selectRange(range);
                // console.timeEnd('select');
                }
            });
            $9b7e10839aea8ea4$var$each(dataDims, function(dim) {
                seriesData.setApproximateExtent(valueWindow, dim);
            });
        });
        function isInWindow(value) {
            return value >= valueWindow[0] && value <= valueWindow[1];
        }
    };
    AxisProxy.prototype._updateMinMaxSpan = function() {
        var minMaxSpan = this._minMaxSpan = {};
        var dataZoomModel = this._dataZoomModel;
        var dataExtent = this._dataExtent;
        $9b7e10839aea8ea4$var$each([
            'min',
            'max'
        ], function(minMax) {
            var percentSpan = dataZoomModel.get(minMax + 'Span');
            var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
            valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan));
            // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
            if (valueSpan != null) percentSpan = $iCU10.linearMap(dataExtent[0] + valueSpan, dataExtent, [
                0,
                100
            ], true);
            else if (percentSpan != null) valueSpan = $iCU10.linearMap(percentSpan, [
                0,
                100
            ], dataExtent, true) - dataExtent[0];
            minMaxSpan[minMax + 'Span'] = percentSpan;
            minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
        }, this);
    };
    AxisProxy.prototype._setAxisModel = function() {
        var axisModel = this.getAxisModel();
        var percentWindow = this._percentWindow;
        var valueWindow = this._valueWindow;
        if (!percentWindow) return;
        // [0, 500]: arbitrary value, guess axis extent.
        var precision = $iCU10.getPixelPrecision(valueWindow, [
            0,
            500
        ]);
        precision = Math.min(precision, 20);
        // For value axis, if min/max/scale are not set, we just use the extent obtained
        // by series data, which may be a little different from the extent calculated by
        // `axisHelper.getScaleExtent`. But the different just affects the experience a
        // little when zooming. So it will not be fixed until some users require it strongly.
        var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;
        if (percentWindow[0] !== 0) rawExtentInfo.setDeterminedMinMax('min', +valueWindow[0].toFixed(precision));
        if (percentWindow[1] !== 100) rawExtentInfo.setDeterminedMinMax('max', +valueWindow[1].toFixed(precision));
        rawExtentInfo.freeze();
    };
    return AxisProxy;
}();
function $9b7e10839aea8ea4$var$calculateDataExtent(axisProxy, axisDim, seriesModels) {
    var dataExtent = [
        Infinity,
        -Infinity
    ];
    $9b7e10839aea8ea4$var$each(seriesModels, function(seriesModel) {
        (0, $9AF98.unionAxisExtentFromData)(dataExtent, seriesModel.getData(), axisDim);
    });
    // It is important to get "consistent" extent when more then one axes is
    // controlled by a `dataZoom`, otherwise those axes will not be synchronized
    // when zooming. But it is difficult to know what is "consistent", considering
    // axes have different type or even different meanings (For example, two
    // time axes are used to compare data of the same date in different years).
    // So basically dataZoom just obtains extent by series.data (in category axis
    // extent can be obtained from axis.data).
    // Nevertheless, user can set min/max/scale on axes to make extent of axes
    // consistent.
    var axisModel = axisProxy.getAxisModel();
    var rawExtentResult = (0, $h4rbp.ensureScaleRawExtentInfo)(axisModel.axis.scale, axisModel, dataExtent).calculate();
    return [
        rawExtentResult.min,
        rawExtentResult.max
    ];
}
var $9b7e10839aea8ea4$export$2e2bcd8739ae039 = $9b7e10839aea8ea4$var$AxisProxy;

});


parcelRegister("6u8gy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b8bf4da938b0ac1$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7JqR5 = parcelRequire("7JqR5");

var $2N6Uo = parcelRequire("2N6Uo");
function $4b8bf4da938b0ac1$export$2e2bcd8739ae039(registers) {
    registers.registerAction('dataZoom', function(payload, ecModel) {
        var effectedModels = (0, $7JqR5.findEffectedDataZooms)(ecModel, payload);
        (0, $2N6Uo.each)(effectedModels, function(dataZoomModel) {
            dataZoomModel.setRawRange({
                start: payload.start,
                end: payload.end,
                startValue: payload.startValue,
                endValue: payload.endValue
            });
        });
    });
}

});



parcelRegister("4XAdJ", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $39c8c4bc3a5fb081$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $g54kB = parcelRequire("g54kB");

var $btKnV = parcelRequire("btKnV");

var $luD2W = parcelRequire("luD2W");
function $39c8c4bc3a5fb081$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $g54kB.default));
    registers.registerComponentView((0, $btKnV.default));
    (0, $luD2W.default)(registers);
}

});
parcelRegister("g54kB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb50790d6904cbca$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $lT9Rl = parcelRequire("lT9Rl");

var $cKPmR = parcelRequire("cKPmR");

var $6aXXD = parcelRequire("6aXXD");
var $bb50790d6904cbca$var$SliderZoomModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SliderZoomModel, _super);
    function SliderZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomModel.type;
        return _this;
    }
    SliderZoomModel.type = 'dataZoom.slider';
    SliderZoomModel.layoutMode = 'box';
    SliderZoomModel.defaultOption = (0, $cKPmR.inheritDefaultOption)((0, $lT9Rl.default).defaultOption, {
        show: true,
        // deault value can only be drived in view stage.
        right: 'ph',
        top: 'ph',
        width: 'ph',
        height: 'ph',
        left: null,
        bottom: null,
        borderColor: (0, $6aXXD.default).color.accent10,
        borderRadius: 0,
        backgroundColor: (0, $6aXXD.default).color.transparent,
        // dataBackgroundColor: '#ddd',
        dataBackground: {
            lineStyle: {
                color: (0, $6aXXD.default).color.accent30,
                width: 0.5
            },
            areaStyle: {
                color: (0, $6aXXD.default).color.accent20,
                opacity: 0.2
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: (0, $6aXXD.default).color.accent40,
                width: 0.5
            },
            areaStyle: {
                color: (0, $6aXXD.default).color.accent20,
                opacity: 0.3
            }
        },
        // Color of selected window.
        fillerColor: 'rgba(135,175,274,0.2)',
        handleIcon: 'path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z',
        // Percent of the slider height
        handleSize: '100%',
        handleStyle: {
            color: (0, $6aXXD.default).color.neutral00,
            borderColor: (0, $6aXXD.default).color.accent20
        },
        moveHandleSize: 7,
        moveHandleIcon: 'path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z',
        moveHandleStyle: {
            color: (0, $6aXXD.default).color.accent40,
            opacity: 0.5
        },
        showDetail: true,
        showDataShadow: 'auto',
        realtime: true,
        zoomLock: false,
        textStyle: {
            color: (0, $6aXXD.default).color.tertiary
        },
        brushSelect: true,
        brushStyle: {
            color: (0, $6aXXD.default).color.accent30,
            opacity: 0.3
        },
        emphasis: {
            handleLabel: {
                show: true
            },
            handleStyle: {
                borderColor: (0, $6aXXD.default).color.accent40
            },
            moveHandleStyle: {
                opacity: 0.8
            }
        },
        defaultLocationEdgeGap: 15
    });
    return SliderZoomModel;
}((0, $lT9Rl.default));
var $bb50790d6904cbca$export$2e2bcd8739ae039 = $bb50790d6904cbca$var$SliderZoomModel;

});

parcelRegister("btKnV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85b66233e5391be8$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $pGNPI = parcelRequire("pGNPI");

var $h9U3p = parcelRequire("h9U3p");
var $hXTRG = parcelRequire("hXTRG");
var $ewDYK = parcelRequire("ewDYK");
var $aH2k0 = parcelRequire("aH2k0");
var $iQonF = parcelRequire("iQonF");
var $9KN3M = parcelRequire("9KN3M");
var $kBKw3 = parcelRequire("kBKw3");

var $99VtN = parcelRequire("99VtN");

var $iVHee = parcelRequire("iVHee");

var $iCU10 = parcelRequire("iCU10");

var $a35Wn = parcelRequire("a35Wn");

var $43jQn = parcelRequire("43jQn");

var $7JqR5 = parcelRequire("7JqR5");

var $bwPbQ = parcelRequire("bwPbQ");

var $k0QDS = parcelRequire("k0QDS");


var $bysmE = parcelRequire("bysmE");

var $6aXXD = parcelRequire("6aXXD");
var $85b66233e5391be8$var$Rect = $aH2k0.default;
// Constants
var $85b66233e5391be8$var$DEFAULT_FRAME_BORDER_WIDTH = 1;
var $85b66233e5391be8$var$DEFAULT_FILLER_SIZE = 30;
var $85b66233e5391be8$var$DEFAULT_MOVE_HANDLE_SIZE = 7;
var $85b66233e5391be8$var$HORIZONTAL = 'horizontal';
var $85b66233e5391be8$var$VERTICAL = 'vertical';
var $85b66233e5391be8$var$LABEL_GAP = 5;
var $85b66233e5391be8$var$SHOW_DATA_SHADOW_SERIES_TYPE = [
    'line',
    'bar',
    'candlestick',
    'scatter'
];
var $85b66233e5391be8$var$REALTIME_ANIMATION_CONFIG = {
    easing: 'cubicOut',
    duration: 100,
    delay: 0
};
var $85b66233e5391be8$var$SliderZoomView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SliderZoomView, _super);
    function SliderZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomView.type;
        _this._displayables = {};
        return _this;
    }
    SliderZoomView.prototype.init = function(ecModel, api) {
        this.api = api;
        // A unique handler for each dataZoom component
        this._onBrush = (0, $2N6Uo.bind)(this._onBrush, this);
        this._onBrushEnd = (0, $2N6Uo.bind)(this._onBrushEnd, this);
    };
    SliderZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        _super.prototype.render.apply(this, arguments);
        $99VtN.createOrUpdate(this, '_dispatchZoomAction', dataZoomModel.get('throttle'), 'fixRate');
        this._orient = dataZoomModel.getOrient();
        if (dataZoomModel.get('show') === false) {
            this.group.removeAll();
            return;
        }
        if (dataZoomModel.noTarget()) {
            this._clear();
            this.group.removeAll();
            return;
        }
        // Notice: this._resetInterval() should not be executed when payload.type
        // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
        // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
        if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) this._buildView();
        this._updateView();
    };
    SliderZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    SliderZoomView.prototype._clear = function() {
        $99VtN.clear(this, '_dispatchZoomAction');
        var zr = this.api.getZr();
        zr.off('mousemove', this._onBrush);
        zr.off('mouseup', this._onBrushEnd);
    };
    SliderZoomView.prototype._buildView = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        this._brushing = false;
        this._displayables.brushRect = null;
        this._resetLocation();
        this._resetInterval();
        var barGroup = this._displayables.sliderGroup = new $iQonF.default();
        this._renderBackground();
        this._renderHandle();
        this._renderDataShadow();
        thisGroup.add(barGroup);
        this._positionGroup();
    };
    SliderZoomView.prototype._resetLocation = function() {
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var showMoveHandle = dataZoomModel.get('brushSelect');
        var moveHandleSize = showMoveHandle ? $85b66233e5391be8$var$DEFAULT_MOVE_HANDLE_SIZE : 0;
        var refContainer = $a35Wn.createBoxLayoutReference(dataZoomModel, api).refContainer;
        // If some of x/y/width/height are not specified,
        // auto-adapt according to target grid.
        var coordRect = this._findCoordRect();
        var edgeGap = dataZoomModel.get('defaultLocationEdgeGap', true) || 0;
        // Default align by coordinate system rect.
        var positionInfo = this._orient === $85b66233e5391be8$var$HORIZONTAL ? {
            // Why using 'right', because right should be used in vertical,
            // and it is better to be consistent for dealing with position param merge.
            right: refContainer.width - coordRect.x - coordRect.width,
            top: refContainer.height - $85b66233e5391be8$var$DEFAULT_FILLER_SIZE - edgeGap - moveHandleSize,
            width: coordRect.width,
            height: $85b66233e5391be8$var$DEFAULT_FILLER_SIZE
        } : {
            right: edgeGap,
            top: coordRect.y,
            width: $85b66233e5391be8$var$DEFAULT_FILLER_SIZE,
            height: coordRect.height
        };
        // Do not write back to option and replace value 'ph', because
        // the 'ph' value should be recalculated when resize.
        var layoutParams = $a35Wn.getLayoutParams(dataZoomModel.option);
        // Replace the placeholder value.
        (0, $2N6Uo.each)([
            'right',
            'top',
            'width',
            'height'
        ], function(name) {
            if (layoutParams[name] === 'ph') layoutParams[name] = positionInfo[name];
        });
        var layoutRect = $a35Wn.getLayoutRect(layoutParams, refContainer);
        this._location = {
            x: layoutRect.x,
            y: layoutRect.y
        };
        this._size = [
            layoutRect.width,
            layoutRect.height
        ];
        this._orient === $85b66233e5391be8$var$VERTICAL && this._size.reverse();
    };
    SliderZoomView.prototype._positionGroup = function() {
        var thisGroup = this.group;
        var location = this._location;
        var orient = this._orient;
        // Just use the first axis to determine mapping.
        var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
        var inverse = targetAxisModel && targetAxisModel.get('inverse');
        var sliderGroup = this._displayables.sliderGroup;
        var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse;
        // Transform barGroup.
        sliderGroup.attr(orient === $85b66233e5391be8$var$HORIZONTAL && !inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: 1
        } : orient === $85b66233e5391be8$var$HORIZONTAL && inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: -1
        } : orient === $85b66233e5391be8$var$VERTICAL && !inverse ? {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: 1,
            rotation: Math.PI / 2
        } : {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: -1,
            rotation: Math.PI / 2
        });
        // Position barGroup
        var rect = thisGroup.getBoundingRect([
            sliderGroup
        ]);
        thisGroup.x = location.x - rect.x;
        thisGroup.y = location.y - rect.y;
        thisGroup.markRedraw();
    };
    SliderZoomView.prototype._getViewExtent = function() {
        return [
            0,
            this._size[0]
        ];
    };
    SliderZoomView.prototype._renderBackground = function() {
        var dataZoomModel = this.dataZoomModel;
        var size = this._size;
        var barGroup = this._displayables.sliderGroup;
        var brushSelect = dataZoomModel.get('brushSelect');
        barGroup.add(new $85b66233e5391be8$var$Rect({
            silent: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: dataZoomModel.get('backgroundColor')
            },
            z2: -40
        }));
        // Click panel, over shadow, below handles.
        var clickPanel = new $85b66233e5391be8$var$Rect({
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: 'transparent'
            },
            z2: 0,
            onclick: (0, $2N6Uo.bind)(this._onClickPanel, this)
        });
        var zr = this.api.getZr();
        if (brushSelect) {
            clickPanel.on('mousedown', this._onBrushStart, this);
            clickPanel.cursor = 'crosshair';
            zr.on('mousemove', this._onBrush);
            zr.on('mouseup', this._onBrushEnd);
        } else {
            zr.off('mousemove', this._onBrush);
            zr.off('mouseup', this._onBrushEnd);
        }
        barGroup.add(clickPanel);
    };
    SliderZoomView.prototype._renderDataShadow = function() {
        var info = this._dataShadowInfo = this._prepareDataShadowInfo();
        this._displayables.dataShadowSegs = [];
        if (!info) return;
        var size = this._size;
        var oldSize = this._shadowSize || [];
        var seriesModel = info.series;
        var data = seriesModel.getRawData();
        var candlestickDim = seriesModel.getShadowDim && seriesModel.getShadowDim();
        var otherDim = candlestickDim && data.getDimensionInfo(candlestickDim) ? seriesModel.getShadowDim() // @see candlestick
         : info.otherDim;
        if (otherDim == null) return;
        var polygonPts = this._shadowPolygonPts;
        var polylinePts = this._shadowPolylinePts;
        // Not re-render if data doesn't change.
        if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            var thisDataExtent_1 = data.getDataExtent(info.thisDim);
            var otherDataExtent_1 = data.getDataExtent(otherDim);
            // Nice extent.
            var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
            otherDataExtent_1 = [
                otherDataExtent_1[0] - otherOffset,
                otherDataExtent_1[1] + otherOffset
            ];
            var otherShadowExtent_1 = [
                0,
                size[1]
            ];
            var thisShadowExtent = [
                0,
                size[0]
            ];
            var areaPoints_1 = [
                [
                    size[0],
                    0
                ],
                [
                    0,
                    0
                ]
            ];
            var linePoints_1 = [];
            var step_1 = thisShadowExtent[1] / Math.max(1, data.count() - 1);
            var normalizationConstant_1 = size[0] / (thisDataExtent_1[1] - thisDataExtent_1[0]);
            var isTimeAxis_1 = info.thisAxis.type === 'time';
            var thisCoord_1 = -step_1;
            // Optimize for large data shadow
            var stride_1 = Math.round(data.count() / size[0]);
            var lastIsEmpty_1;
            data.each([
                info.thisDim,
                otherDim
            ], function(thisValue, otherValue, index) {
                if (stride_1 > 0 && index % stride_1) {
                    if (!isTimeAxis_1) thisCoord_1 += step_1;
                    return;
                }
                thisCoord_1 = isTimeAxis_1 ? (+thisValue - thisDataExtent_1[0]) * normalizationConstant_1 : thisCoord_1 + step_1;
                // FIXME
                // Should consider axis.min/axis.max when drawing dataShadow.
                // FIXME
                // 应该使用统一的空判断？还是在list里进行空判断？
                var isEmpty = otherValue == null || isNaN(otherValue) || otherValue === '';
                // See #4235.
                var otherCoord = isEmpty ? 0 : (0, $iCU10.linearMap)(otherValue, otherDataExtent_1, otherShadowExtent_1, true);
                // Attempt to draw data shadow precisely when there are empty value.
                if (isEmpty && !lastIsEmpty_1 && index) {
                    areaPoints_1.push([
                        areaPoints_1[areaPoints_1.length - 1][0],
                        0
                    ]);
                    linePoints_1.push([
                        linePoints_1[linePoints_1.length - 1][0],
                        0
                    ]);
                } else if (!isEmpty && lastIsEmpty_1) {
                    areaPoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                    linePoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                }
                if (!isEmpty) {
                    areaPoints_1.push([
                        thisCoord_1,
                        otherCoord
                    ]);
                    linePoints_1.push([
                        thisCoord_1,
                        otherCoord
                    ]);
                }
                lastIsEmpty_1 = isEmpty;
            });
            polygonPts = this._shadowPolygonPts = areaPoints_1;
            polylinePts = this._shadowPolylinePts = linePoints_1;
        }
        this._shadowData = data;
        this._shadowDim = otherDim;
        this._shadowSize = [
            size[0],
            size[1]
        ];
        var dataZoomModel = this.dataZoomModel;
        function createDataShadowGroup(isSelectedArea) {
            var model = dataZoomModel.getModel(isSelectedArea ? 'selectedDataBackground' : 'dataBackground');
            var group = new $iQonF.default();
            var polygon = new $hXTRG.default({
                shape: {
                    points: polygonPts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel('areaStyle').getAreaStyle(),
                silent: true,
                z2: -20
            });
            var polyline = new $ewDYK.default({
                shape: {
                    points: polylinePts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel('lineStyle').getLineStyle(),
                silent: true,
                z2: -19
            });
            group.add(polygon);
            group.add(polyline);
            return group;
        }
        // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');
        for(var i = 0; i < 3; i++){
            var group = createDataShadowGroup(i === 1);
            this._displayables.sliderGroup.add(group);
            this._displayables.dataShadowSegs.push(group);
        }
    };
    SliderZoomView.prototype._prepareDataShadowInfo = function() {
        var dataZoomModel = this.dataZoomModel;
        var showDataShadow = dataZoomModel.get('showDataShadow');
        if (showDataShadow === false) return;
        // Find a representative series.
        var result;
        var ecModel = this.ecModel;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
            (0, $2N6Uo.each)(seriesModels, function(seriesModel) {
                if (result) return;
                if (showDataShadow !== true && (0, $2N6Uo.indexOf)($85b66233e5391be8$var$SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) return;
                var thisAxis = ecModel.getComponent((0, $7JqR5.getAxisMainType)(axisDim), axisIndex).axis;
                var otherDim = $85b66233e5391be8$var$getOtherDim(axisDim);
                var otherAxisInverse;
                var coordSys = seriesModel.coordinateSystem;
                if (otherDim != null && coordSys.getOtherAxis) otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
                otherDim = seriesModel.getData().mapDimension(otherDim);
                var thisDim = seriesModel.getData().mapDimension(axisDim);
                result = {
                    thisAxis: thisAxis,
                    series: seriesModel,
                    thisDim: thisDim,
                    otherDim: otherDim,
                    otherAxisInverse: otherAxisInverse
                };
            }, this);
        }, this);
        return result;
    };
    SliderZoomView.prototype._renderHandle = function() {
        var thisGroup = this.group;
        var displayables = this._displayables;
        var handles = displayables.handles = [
            null,
            null
        ];
        var handleLabels = displayables.handleLabels = [
            null,
            null
        ];
        var sliderGroup = this._displayables.sliderGroup;
        var size = this._size;
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var borderRadius = dataZoomModel.get('borderRadius') || 0;
        var brushSelect = dataZoomModel.get('brushSelect');
        var filler = displayables.filler = new $85b66233e5391be8$var$Rect({
            silent: brushSelect,
            style: {
                fill: dataZoomModel.get('fillerColor')
            },
            textConfig: {
                position: 'inside'
            }
        });
        sliderGroup.add(filler);
        // Frame border.
        sliderGroup.add(new $85b66233e5391be8$var$Rect({
            silent: true,
            subPixelOptimize: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1],
                r: borderRadius
            },
            style: {
                // deprecated option
                stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
                lineWidth: $85b66233e5391be8$var$DEFAULT_FRAME_BORDER_WIDTH,
                fill: (0, $6aXXD.default).color.transparent
            }
        }));
        // Left and right handle to resize
        (0, $2N6Uo.each)([
            0,
            1
        ], function(handleIndex) {
            var iconStr = dataZoomModel.get('handleIcon');
            if (!(0, $k0QDS.symbolBuildProxies)[iconStr] && iconStr.indexOf('path://') < 0 && iconStr.indexOf('image://') < 0) // Compatitable with the old icon parsers. Which can use a path string without path://
            iconStr = 'path://' + iconStr;
            var path = (0, $k0QDS.createSymbol)(iconStr, -1, 0, 2, 2, null, true);
            path.attr({
                cursor: $85b66233e5391be8$var$getCursor(this._orient),
                draggable: true,
                drift: (0, $2N6Uo.bind)(this._onDragMove, this, handleIndex),
                ondragend: (0, $2N6Uo.bind)(this._onDragEnd, this),
                onmouseover: (0, $2N6Uo.bind)(this._showDataInfo, this, true),
                onmouseout: (0, $2N6Uo.bind)(this._showDataInfo, this, false),
                z2: 5
            });
            var bRect = path.getBoundingRect();
            var handleSize = dataZoomModel.get('handleSize');
            this._handleHeight = (0, $iCU10.parsePercent)(handleSize, this._size[1]);
            this._handleWidth = bRect.width / bRect.height * this._handleHeight;
            path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
            path.style.strokeNoScale = true;
            path.rectHover = true;
            path.ensureState('emphasis').style = dataZoomModel.getModel([
                'emphasis',
                'handleStyle'
            ]).getItemStyle();
            (0, $bwPbQ.enableHoverEmphasis)(path);
            var handleColor = dataZoomModel.get('handleColor'); // deprecated option
            // Compatitable with previous version
            if (handleColor != null) path.style.fill = handleColor;
            sliderGroup.add(handles[handleIndex] = path);
            var textStyleModel = dataZoomModel.getModel('textStyle');
            var handleLabel = dataZoomModel.get('handleLabel') || {};
            var handleLabelShow = handleLabel.show || false;
            thisGroup.add(handleLabels[handleIndex] = new $kBKw3.default({
                silent: true,
                invisible: !handleLabelShow,
                style: (0, $bysmE.createTextStyle)(textStyleModel, {
                    x: 0,
                    y: 0,
                    text: '',
                    verticalAlign: 'middle',
                    align: 'center',
                    fill: textStyleModel.getTextColor(),
                    font: textStyleModel.getFont()
                }),
                z2: 10
            }));
        }, this);
        // Handle to move. Only visible when brushSelect is set true.
        var actualMoveZone = filler;
        if (brushSelect) {
            var moveHandleHeight = (0, $iCU10.parsePercent)(dataZoomModel.get('moveHandleSize'), size[1]);
            var moveHandle_1 = displayables.moveHandle = new $aH2k0.default({
                style: dataZoomModel.getModel('moveHandleStyle').getItemStyle(),
                silent: true,
                shape: {
                    r: [
                        0,
                        0,
                        2,
                        2
                    ],
                    y: size[1] - 0.5,
                    height: moveHandleHeight
                }
            });
            var iconSize = moveHandleHeight * 0.8;
            var moveHandleIcon = displayables.moveHandleIcon = (0, $k0QDS.createSymbol)(dataZoomModel.get('moveHandleIcon'), -iconSize / 2, -iconSize / 2, iconSize, iconSize, (0, $6aXXD.default).color.neutral00, true);
            moveHandleIcon.silent = true;
            moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
            moveHandle_1.ensureState('emphasis').style = dataZoomModel.getModel([
                'emphasis',
                'moveHandleStyle'
            ]).getItemStyle();
            var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
            actualMoveZone = displayables.moveZone = new $aH2k0.default({
                invisible: true,
                shape: {
                    y: size[1] - moveZoneExpandSize,
                    height: moveHandleHeight + moveZoneExpandSize
                }
            });
            actualMoveZone.on('mouseover', function() {
                api.enterEmphasis(moveHandle_1);
            }).on('mouseout', function() {
                api.leaveEmphasis(moveHandle_1);
            });
            sliderGroup.add(moveHandle_1);
            sliderGroup.add(moveHandleIcon);
            sliderGroup.add(actualMoveZone);
        }
        actualMoveZone.attr({
            draggable: true,
            cursor: 'default',
            drift: (0, $2N6Uo.bind)(this._onDragMove, this, 'all'),
            ondragstart: (0, $2N6Uo.bind)(this._showDataInfo, this, true),
            ondragend: (0, $2N6Uo.bind)(this._onDragEnd, this),
            onmouseover: (0, $2N6Uo.bind)(this._showDataInfo, this, true),
            onmouseout: (0, $2N6Uo.bind)(this._showDataInfo, this, false)
        });
    };
    SliderZoomView.prototype._resetInterval = function() {
        var range = this._range = this.dataZoomModel.getPercentRange();
        var viewExtent = this._getViewExtent();
        this._handleEnds = [
            (0, $iCU10.linearMap)(range[0], [
                0,
                100
            ], viewExtent, true),
            (0, $iCU10.linearMap)(range[1], [
                0,
                100
            ], viewExtent, true)
        ];
    };
    SliderZoomView.prototype._updateInterval = function(handleIndex, delta) {
        var dataZoomModel = this.dataZoomModel;
        var handleEnds = this._handleEnds;
        var viewExtend = this._getViewExtent();
        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        var percentExtent = [
            0,
            100
        ];
        (0, $43jQn.default)(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? (0, $iCU10.linearMap)(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? (0, $iCU10.linearMap)(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        var lastRange = this._range;
        var range = this._range = (0, $iCU10.asc)([
            (0, $iCU10.linearMap)(handleEnds[0], viewExtend, percentExtent, true),
            (0, $iCU10.linearMap)(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
    };
    SliderZoomView.prototype._updateView = function(nonRealtime) {
        var displaybles = this._displayables;
        var handleEnds = this._handleEnds;
        var handleInterval = (0, $iCU10.asc)(handleEnds.slice());
        var size = this._size;
        (0, $2N6Uo.each)([
            0,
            1
        ], function(handleIndex) {
            // Handles
            var handle = displaybles.handles[handleIndex];
            var handleHeight = this._handleHeight;
            handle.attr({
                scaleX: handleHeight / 2,
                scaleY: handleHeight / 2,
                // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
                // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
                x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
                y: size[1] / 2 - handleHeight / 2
            });
        }, this);
        // Filler
        displaybles.filler.setShape({
            x: handleInterval[0],
            y: 0,
            width: handleInterval[1] - handleInterval[0],
            height: size[1]
        });
        var viewExtent = {
            x: handleInterval[0],
            width: handleInterval[1] - handleInterval[0]
        };
        // Move handle
        if (displaybles.moveHandle) {
            displaybles.moveHandle.setShape(viewExtent);
            displaybles.moveZone.setShape(viewExtent);
            // Force update path on the invisible object
            displaybles.moveZone.getBoundingRect();
            displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr('x', viewExtent.x + viewExtent.width / 2);
        }
        // update clip path of shadow.
        var dataShadowSegs = displaybles.dataShadowSegs;
        var segIntervals = [
            0,
            handleInterval[0],
            handleInterval[1],
            size[0]
        ];
        for(var i = 0; i < dataShadowSegs.length; i++){
            var segGroup = dataShadowSegs[i];
            var clipPath = segGroup.getClipPath();
            if (!clipPath) {
                clipPath = new $aH2k0.default();
                segGroup.setClipPath(clipPath);
            }
            clipPath.setShape({
                x: segIntervals[i],
                y: 0,
                width: segIntervals[i + 1] - segIntervals[i],
                height: size[1]
            });
        }
        this._updateDataInfo(nonRealtime);
    };
    SliderZoomView.prototype._updateDataInfo = function(nonRealtime) {
        var dataZoomModel = this.dataZoomModel;
        var displaybles = this._displayables;
        var handleLabels = displaybles.handleLabels;
        var orient = this._orient;
        var labelTexts = [
            '',
            ''
        ];
        // FIXME
        // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
        if (dataZoomModel.get('showDetail')) {
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var axis = axisProxy.getAxisModel().axis;
                var range = this._range;
                var dataInterval = nonRealtime ? axisProxy.calculateDataWindow({
                    start: range[0],
                    end: range[1]
                }).valueWindow : axisProxy.getDataValueWindow();
                labelTexts = [
                    this._formatLabel(dataInterval[0], axis),
                    this._formatLabel(dataInterval[1], axis)
                ];
            }
        }
        var orderedHandleEnds = (0, $iCU10.asc)(this._handleEnds.slice());
        setLabel.call(this, 0);
        setLabel.call(this, 1);
        function setLabel(handleIndex) {
            // Label
            // Text should not transform by barGroup.
            // Ignore handlers transform
            var barTransform = $h9U3p.getTransform(displaybles.handles[handleIndex].parent, this.group);
            var direction = $h9U3p.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
            var offset = this._handleWidth / 2 + $85b66233e5391be8$var$LABEL_GAP;
            var textPoint = $h9U3p.applyTransform([
                orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset),
                this._size[1] / 2
            ], barTransform);
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                verticalAlign: orient === $85b66233e5391be8$var$HORIZONTAL ? 'middle' : direction,
                align: orient === $85b66233e5391be8$var$HORIZONTAL ? direction : 'center',
                text: labelTexts[handleIndex]
            });
        }
    };
    SliderZoomView.prototype._formatLabel = function(value, axis) {
        var dataZoomModel = this.dataZoomModel;
        var labelFormatter = dataZoomModel.get('labelFormatter');
        var labelPrecision = dataZoomModel.get('labelPrecision');
        if (labelPrecision == null || labelPrecision === 'auto') labelPrecision = axis.getPixelPrecision();
        var valueStr = value == null || isNaN(value) ? '' : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel({
            value: Math.round(value)
        }) : value.toFixed(Math.min(labelPrecision, 20));
        return (0, $2N6Uo.isFunction)(labelFormatter) ? labelFormatter(value, valueStr) : (0, $2N6Uo.isString)(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
    };
    /**
   * @param isEmphasis true: show, false: hide
   */ SliderZoomView.prototype._showDataInfo = function(isEmphasis) {
        var handleLabel = this.dataZoomModel.get('handleLabel') || {};
        var normalShow = handleLabel.show || false;
        var emphasisHandleLabel = this.dataZoomModel.getModel([
            'emphasis',
            'handleLabel'
        ]);
        var emphasisShow = emphasisHandleLabel.get('show') || false;
        // Dragging is considered as emphasis, unless emphasisShow is false
        var toShow = isEmphasis || this._dragging ? emphasisShow : normalShow;
        var displayables = this._displayables;
        var handleLabels = displayables.handleLabels;
        handleLabels[0].attr('invisible', !toShow);
        handleLabels[1].attr('invisible', !toShow);
        // Highlight move handle
        displayables.moveHandle && this.api[toShow ? 'enterEmphasis' : 'leaveEmphasis'](displayables.moveHandle, 1);
    };
    SliderZoomView.prototype._onDragMove = function(handleIndex, dx, dy, event) {
        this._dragging = true;
        // For mobile device, prevent screen slider on the button.
        $pGNPI.stop(event.event);
        // Transform dx, dy to bar coordination.
        var barTransform = this._displayables.sliderGroup.getLocalTransform();
        var vertex = $h9U3p.applyTransform([
            dx,
            dy
        ], barTransform, true);
        var changed = this._updateInterval(handleIndex, vertex[0]);
        var realtime = this.dataZoomModel.get('realtime');
        this._updateView(!realtime);
        // Avoid dispatch dataZoom repeatly but range not changed,
        // which cause bad visual effect when progressive enabled.
        changed && realtime && this._dispatchZoomAction(true);
    };
    SliderZoomView.prototype._onDragEnd = function() {
        this._dragging = false;
        this._showDataInfo(false);
        // While in realtime mode and stream mode, dispatch action when
        // drag end will cause the whole view rerender, which is unnecessary.
        var realtime = this.dataZoomModel.get('realtime');
        !realtime && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onClickPanel = function(e) {
        var size = this._size;
        var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);
        if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) return;
        var handleEnds = this._handleEnds;
        var center = (handleEnds[0] + handleEnds[1]) / 2;
        var changed = this._updateInterval('all', localPoint[0] - center);
        this._updateView();
        changed && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrushStart = function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        this._brushStart = new $9KN3M.default(x, y);
        this._brushing = true;
        this._brushStartTime = +new Date();
    // this._updateBrushRect(x, y);
    };
    SliderZoomView.prototype._onBrushEnd = function(e) {
        if (!this._brushing) return;
        var brushRect = this._displayables.brushRect;
        this._brushing = false;
        if (!brushRect) return;
        brushRect.attr('ignore', true);
        var brushShape = brushRect.shape;
        var brushEndTime = +new Date();
        // console.log(brushEndTime - this._brushStartTime);
        if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) // Will treat it as a click
        return;
        var viewExtend = this._getViewExtent();
        var percentExtent = [
            0,
            100
        ];
        var handleEnds = this._handleEnds = [
            brushShape.x,
            brushShape.x + brushShape.width
        ];
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        // Restrict range.
        (0, $43jQn.default)(0, handleEnds, viewExtend, 0, minMaxSpan.minSpan != null ? (0, $iCU10.linearMap)(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? (0, $iCU10.linearMap)(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        this._range = (0, $iCU10.asc)([
            (0, $iCU10.linearMap)(handleEnds[0], viewExtend, percentExtent, true),
            (0, $iCU10.linearMap)(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        this._updateView();
        this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrush = function(e) {
        if (this._brushing) {
            // For mobile device, prevent screen slider on the button.
            $pGNPI.stop(e.event);
            this._updateBrushRect(e.offsetX, e.offsetY);
        }
    };
    SliderZoomView.prototype._updateBrushRect = function(mouseX, mouseY) {
        var displayables = this._displayables;
        var dataZoomModel = this.dataZoomModel;
        var brushRect = displayables.brushRect;
        if (!brushRect) {
            brushRect = displayables.brushRect = new $85b66233e5391be8$var$Rect({
                silent: true,
                style: dataZoomModel.getModel('brushStyle').getItemStyle()
            });
            displayables.sliderGroup.add(brushRect);
        }
        brushRect.attr('ignore', false);
        var brushStart = this._brushStart;
        var sliderGroup = this._displayables.sliderGroup;
        var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
        var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
        var size = this._size;
        endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
        brushRect.setShape({
            x: startPoint[0],
            y: 0,
            width: endPoint[0] - startPoint[0],
            height: size[1]
        });
    };
    /**
   * This action will be throttled.
   */ SliderZoomView.prototype._dispatchZoomAction = function(realtime) {
        var range = this._range;
        this.api.dispatchAction({
            type: 'dataZoom',
            from: this.uid,
            dataZoomId: this.dataZoomModel.id,
            animation: realtime ? $85b66233e5391be8$var$REALTIME_ANIMATION_CONFIG : null,
            start: range[0],
            end: range[1]
        });
    };
    SliderZoomView.prototype._findCoordRect = function() {
        // Find the grid corresponding to the first axis referred by dataZoom.
        var rect;
        var coordSysInfoList = (0, $7JqR5.collectReferCoordSysModelInfo)(this.dataZoomModel).infoList;
        if (!rect && coordSysInfoList.length) {
            var coordSys = coordSysInfoList[0].model.coordinateSystem;
            rect = coordSys.getRect && coordSys.getRect();
        }
        if (!rect) {
            var width = this.api.getWidth();
            var height = this.api.getHeight();
            rect = {
                x: width * 0.2,
                y: height * 0.2,
                width: width * 0.6,
                height: height * 0.6
            };
        }
        return rect;
    };
    SliderZoomView.type = 'dataZoom.slider';
    return SliderZoomView;
}((0, $iVHee.default));
function $85b66233e5391be8$var$getOtherDim(thisDim) {
    // FIXME
    // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
    var map = {
        x: 'y',
        y: 'x',
        radius: 'angle',
        angle: 'radius'
    };
    return map[thisDim];
}
function $85b66233e5391be8$var$getCursor(orient) {
    return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}
var $85b66233e5391be8$export$2e2bcd8739ae039 = $85b66233e5391be8$var$SliderZoomView;

});



parcelRegister("czhcC", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $92661901ca7bec2e$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $7JVKf = parcelRequire("7JVKf");

var $ltnxu = parcelRequire("ltnxu");
function $92661901ca7bec2e$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $7JVKf.GraphicComponentModel));
    registers.registerComponentView((0, $ltnxu.GraphicComponentView));
    registers.registerPreprocessor(function(option) {
        var graphicOption = option.graphic;
        // Convert
        // {graphic: [{left: 10, type: 'circle'}, ...]}
        // or
        // {graphic: {left: 10, type: 'circle'}}
        // to
        // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
        if ((0, $2N6Uo.isArray)(graphicOption)) {
            if (!graphicOption[0] || !graphicOption[0].elements) option.graphic = [
                {
                    elements: graphicOption
                }
            ];
            else // Only one graphic instance can be instantiated. (We don't
            // want that too many views are created in echarts._viewMap.)
            option.graphic = [
                option.graphic[0]
            ];
        } else if (graphicOption && !graphicOption.elements) option.graphic = [
            {
                elements: [
                    graphicOption
                ]
            }
        ];
    });
}

});
parcelRegister("7JVKf", function(module, exports) {

$parcel$export(module.exports, "GraphicComponentModel", function () { return $5a2987569790c2de$export$6d85925da4d2cf23; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $eLD2b = parcelRequire("eLD2b");

var $a35Wn = parcelRequire("a35Wn");
function $5a2987569790c2de$export$f6339b3d96c5d3d7(resultItem, newElOption) {
    var existElOption = resultItem.existing;
    // Set id and type after id assigned.
    newElOption.id = resultItem.keyInfo.id;
    !newElOption.type && existElOption && (newElOption.type = existElOption.type);
    // Set parent id if not specified
    if (newElOption.parentId == null) {
        var newElParentOption = newElOption.parentOption;
        if (newElParentOption) newElOption.parentId = newElParentOption.id;
        else if (existElOption) newElOption.parentId = existElOption.parentId;
    }
    // Clear
    newElOption.parentOption = null;
}
function $5a2987569790c2de$var$isSetLoc(obj, props) {
    var isSet;
    $2N6Uo.each(props, function(prop) {
        obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
    });
    return isSet;
}
function $5a2987569790c2de$var$mergeNewElOptionToExist(existList, index, newElOption) {
    // Update existing options, for `getOption` feature.
    var newElOptCopy = $2N6Uo.extend({}, newElOption);
    var existElOption = existList[index];
    var $action = newElOption.$action || 'merge';
    if ($action === 'merge') {
        if (existElOption) {
            var newType;
            // We can ensure that newElOptCopy and existElOption are not
            // the same object, so `merge` will not change newElOptCopy.
            $2N6Uo.merge(existElOption, newElOptCopy, true);
            // Rigid body, use ignoreSize.
            (0, $a35Wn.mergeLayoutParam)(existElOption, newElOptCopy, {
                ignoreSize: true
            });
            // Will be used in render.
            (0, $a35Wn.copyLayoutParams)(newElOption, existElOption);
            // Copy transition info to new option so it can be used in the transition.
            // DO IT AFTER merge
            $5a2987569790c2de$var$copyTransitionInfo(newElOption, existElOption);
            $5a2987569790c2de$var$copyTransitionInfo(newElOption, existElOption, 'shape');
            $5a2987569790c2de$var$copyTransitionInfo(newElOption, existElOption, 'style');
            $5a2987569790c2de$var$copyTransitionInfo(newElOption, existElOption, 'extra');
            // Copy clipPath
            newElOption.clipPath = existElOption.clipPath;
        } else existList[index] = newElOptCopy;
    } else if ($action === 'replace') existList[index] = newElOptCopy;
    else if ($action === 'remove') // null will be cleaned later.
    existElOption && (existList[index] = null);
}
var $5a2987569790c2de$var$TRANSITION_PROPS_TO_COPY = [
    'transition',
    'enterFrom',
    'leaveTo'
];
var $5a2987569790c2de$var$ROOT_TRANSITION_PROPS_TO_COPY = $5a2987569790c2de$var$TRANSITION_PROPS_TO_COPY.concat([
    'enterAnimation',
    'updateAnimation',
    'leaveAnimation'
]);
function $5a2987569790c2de$var$copyTransitionInfo(target, source, targetProp) {
    if (targetProp) {
        if (!target[targetProp] && source[targetProp]) // TODO avoid creating this empty object when there is no transition configuration.
        target[targetProp] = {};
        target = target[targetProp];
        source = source[targetProp];
    }
    if (!target || !source) return;
    var props = targetProp ? $5a2987569790c2de$var$TRANSITION_PROPS_TO_COPY : $5a2987569790c2de$var$ROOT_TRANSITION_PROPS_TO_COPY;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (target[prop] == null && source[prop] != null) target[prop] = source[prop];
    }
}
function $5a2987569790c2de$var$setLayoutInfoToExist(existItem, newElOption) {
    if (!existItem) return;
    existItem.hv = newElOption.hv = [
        // Rigid body, don't care about `width`.
        $5a2987569790c2de$var$isSetLoc(newElOption, [
            'left',
            'right'
        ]),
        // Rigid body, don't care about `height`.
        $5a2987569790c2de$var$isSetLoc(newElOption, [
            'top',
            'bottom'
        ])
    ];
    // Give default group size. Otherwise layout error may occur.
    if (existItem.type === 'group') {
        var existingGroupOpt = existItem;
        var newGroupOpt = newElOption;
        existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
        existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
    }
}
var $5a2987569790c2de$export$6d85925da4d2cf23 = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GraphicComponentModel, _super);
    function GraphicComponentModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentModel.type;
        _this.preventAutoZ = true;
        return _this;
    }
    GraphicComponentModel.prototype.mergeOption = function(option, ecModel) {
        // Prevent default merge to elements
        var elements = this.option.elements;
        this.option.elements = null;
        _super.prototype.mergeOption.call(this, option, ecModel);
        this.option.elements = elements;
    };
    GraphicComponentModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        var newList = (isInit ? thisOption : newOption).elements;
        var existList = thisOption.elements = isInit ? [] : thisOption.elements;
        var flattenedList = [];
        this._flatten(newList, flattenedList, null);
        var mappingResult = $bx3T8.mappingToExists(existList, flattenedList, 'normalMerge');
        // Clear elOptionsToUpdate
        var elOptionsToUpdate = this._elOptionsToUpdate = [];
        $2N6Uo.each(mappingResult, function(resultItem, index) {
            var newElOption = resultItem.newOption;
            if (!newElOption) return;
            elOptionsToUpdate.push(newElOption);
            $5a2987569790c2de$export$f6339b3d96c5d3d7(resultItem, newElOption);
            $5a2987569790c2de$var$mergeNewElOptionToExist(existList, index, newElOption);
            $5a2987569790c2de$var$setLayoutInfoToExist(existList[index], newElOption);
        }, this);
        // Clean
        thisOption.elements = $2N6Uo.filter(existList, function(item) {
            // $action should be volatile, otherwise option gotten from
            // `getOption` will contain unexpected $action.
            item && delete item.$action;
            return item != null;
        });
    };
    /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   */ GraphicComponentModel.prototype._flatten = function(optionList, result, parentOption) {
        $2N6Uo.each(optionList, function(option) {
            if (!option) return;
            if (parentOption) option.parentOption = parentOption;
            result.push(option);
            var children = option.children;
            // here we don't judge if option.type is `group`
            // when new option doesn't provide `type`, it will cause that the children can't be updated.
            if (children && children.length) this._flatten(children, result, option);
            // Deleting for JSON output, and for not affecting group creation.
            delete option.children;
        }, this);
    };
    // FIXME
    // Pass to view using payload? setOption has a payload?
    GraphicComponentModel.prototype.useElOptionsToUpdate = function() {
        var els = this._elOptionsToUpdate;
        // Clear to avoid render duplicately when zooming.
        this._elOptionsToUpdate = null;
        return els;
    };
    GraphicComponentModel.type = 'graphic';
    GraphicComponentModel.defaultOption = {
        elements: []
    };
    return GraphicComponentModel;
}((0, $eLD2b.default));

});

parcelRegister("ltnxu", function(module, exports) {

$parcel$export(module.exports, "GraphicComponentView", function () { return $fa1e90cf6085f7eb$export$1132c9ab9ad80748; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $6Ekel = parcelRequire("6Ekel");

var $bx3T8 = parcelRequire("bx3T8");

var $h9U3p = parcelRequire("h9U3p");
var $lQsZt = parcelRequire("lQsZt");
var $iQonF = parcelRequire("iQonF");
var $kBKw3 = parcelRequire("kBKw3");

var $a35Wn = parcelRequire("a35Wn");

var $iCU10 = parcelRequire("iCU10");

var $bpyST = parcelRequire("bpyST");

var $6TSUP = parcelRequire("6TSUP");

var $3ceD0 = parcelRequire("3ceD0");

var $0r1IS = parcelRequire("0r1IS");

var $ipprj = parcelRequire("ipprj");

var $bwI2M = parcelRequire("bwI2M");
var $fa1e90cf6085f7eb$var$nonShapeGraphicElements = {
    // Reserved but not supported in graphic component.
    path: null,
    compoundPath: null,
    // Supported in graphic component.
    group: $iQonF.default,
    image: $lQsZt.default,
    text: $kBKw3.default
};
var $fa1e90cf6085f7eb$export$4ae363f1d88fb658 = $bx3T8.makeInner();
// ------------------------
// View
// ------------------------
var $fa1e90cf6085f7eb$export$1132c9ab9ad80748 = /** @class */ function(_super) {
    (0, $9nEce.__extends)(GraphicComponentView, _super);
    function GraphicComponentView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentView.type;
        return _this;
    }
    GraphicComponentView.prototype.init = function() {
        this._elMap = $2N6Uo.createHashMap();
    };
    GraphicComponentView.prototype.render = function(graphicModel, ecModel, api) {
        // Having leveraged between use cases and algorithm complexity, a very
        // simple layout mechanism is used:
        // The size(width/height) can be determined by itself or its parent (not
        // implemented yet), but can not by its children. (Top-down travel)
        // The location(x/y) can be determined by the bounding rect of itself
        // (can including its descendants or not) and the size of its parent.
        // (Bottom-up travel)
        // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
        // view will be reused.
        if (graphicModel !== this._lastGraphicModel) this._clear();
        this._lastGraphicModel = graphicModel;
        this._updateElements(graphicModel);
        this._relocate(graphicModel, api);
    };
    /**
   * Update graphic elements.
   */ GraphicComponentView.prototype._updateElements = function(graphicModel) {
        var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
        if (!elOptionsToUpdate) return;
        var elMap = this._elMap;
        var rootGroup = this.group;
        var globalZ = graphicModel.get('z');
        var globalZLevel = graphicModel.get('zlevel');
        // Top-down tranverse to assign graphic settings to each elements.
        $2N6Uo.each(elOptionsToUpdate, function(elOption) {
            var id = $bx3T8.convertOptionIdName(elOption.id, null);
            var elExisting = id != null ? elMap.get(id) : null;
            var parentId = $bx3T8.convertOptionIdName(elOption.parentId, null);
            var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
            var elType = elOption.type;
            var elOptionStyle = elOption.style;
            if (elType === 'text' && elOptionStyle) // In top/bottom mode, textVerticalAlign should not be used, which cause
            // inaccurately locating.
            {
                if (elOption.hv && elOption.hv[1]) elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
            }
            var textContentOption = elOption.textContent;
            var textConfig = elOption.textConfig;
            if (elOptionStyle && (0, $3ceD0.isEC4CompatibleStyle)(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
                var convertResult = (0, $3ceD0.convertFromEC4CompatibleStyle)(elOptionStyle, elType, true);
                if (!textConfig && convertResult.textConfig) textConfig = elOption.textConfig = convertResult.textConfig;
                if (!textContentOption && convertResult.textContent) textContentOption = convertResult.textContent;
            }
            // Remove unnecessary props to avoid potential problems.
            var elOptionCleaned = $fa1e90cf6085f7eb$var$getCleanedElOption(elOption);
            var $action = elOption.$action || 'merge';
            var isMerge = $action === 'merge';
            var isReplace = $action === 'replace';
            if (isMerge) {
                var isInit = !elExisting;
                var el_1 = elExisting;
                if (isInit) el_1 = $fa1e90cf6085f7eb$var$createEl(id, targetElParent, elOption.type, elMap);
                else {
                    el_1 && ($fa1e90cf6085f7eb$export$4ae363f1d88fb658(el_1).isNew = false);
                    // Stop and restore before update any other attributes.
                    (0, $bwI2M.stopPreviousKeyframeAnimationAndRestore)(el_1);
                }
                if (el_1) {
                    (0, $0r1IS.applyUpdateTransition)(el_1, elOptionCleaned, graphicModel, {
                        isInit: isInit
                    });
                    $fa1e90cf6085f7eb$var$updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
                }
            } else if (isReplace) {
                $fa1e90cf6085f7eb$var$removeEl(elExisting, elOption, elMap, graphicModel);
                var el_2 = $fa1e90cf6085f7eb$var$createEl(id, targetElParent, elOption.type, elMap);
                if (el_2) {
                    (0, $0r1IS.applyUpdateTransition)(el_2, elOptionCleaned, graphicModel, {
                        isInit: true
                    });
                    $fa1e90cf6085f7eb$var$updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
                }
            } else if ($action === 'remove') {
                (0, $0r1IS.updateLeaveTo)(elExisting, elOption);
                $fa1e90cf6085f7eb$var$removeEl(elExisting, elOption, elMap, graphicModel);
            }
            var el = elMap.get(id);
            if (el && textContentOption) {
                if (isMerge) {
                    var textContentExisting = el.getTextContent();
                    textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new $kBKw3.default(textContentOption));
                } else if (isReplace) el.setTextContent(new $kBKw3.default(textContentOption));
            }
            if (el) {
                var clipPathOption = elOption.clipPath;
                if (clipPathOption) {
                    var clipPathType = clipPathOption.type;
                    var clipPath = void 0;
                    var isInit = false;
                    if (isMerge) {
                        var oldClipPath = el.getClipPath();
                        isInit = !oldClipPath || $fa1e90cf6085f7eb$export$4ae363f1d88fb658(oldClipPath).type !== clipPathType;
                        clipPath = isInit ? $fa1e90cf6085f7eb$var$newEl(clipPathType) : oldClipPath;
                    } else if (isReplace) {
                        isInit = true;
                        clipPath = $fa1e90cf6085f7eb$var$newEl(clipPathType);
                    }
                    el.setClipPath(clipPath);
                    (0, $0r1IS.applyUpdateTransition)(clipPath, clipPathOption, graphicModel, {
                        isInit: isInit
                    });
                    (0, $bwI2M.applyKeyframeAnimation)(clipPath, clipPathOption.keyframeAnimation, graphicModel);
                }
                var elInner = $fa1e90cf6085f7eb$export$4ae363f1d88fb658(el);
                el.setTextConfig(textConfig);
                elInner.option = elOption;
                $fa1e90cf6085f7eb$var$setEventData(el, graphicModel, elOption);
                $h9U3p.setTooltipConfig({
                    el: el,
                    componentModel: graphicModel,
                    itemName: el.name,
                    itemTooltipOption: elOption.tooltip
                });
                (0, $bwI2M.applyKeyframeAnimation)(el, elOption.keyframeAnimation, graphicModel);
            }
        });
    };
    /**
   * Locate graphic elements.
   */ GraphicComponentView.prototype._relocate = function(graphicModel, api) {
        var elOptions = graphicModel.option.elements;
        var rootGroup = this.group;
        var elMap = this._elMap;
        var apiWidth = api.getWidth();
        var apiHeight = api.getHeight();
        var xy = [
            'x',
            'y'
        ];
        // Top-down to calculate percentage width/height of group
        for(var i = 0; i < elOptions.length; i++){
            var elOption = elOptions[i];
            var id = $bx3T8.convertOptionIdName(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el || !el.isGroup) continue;
            var parentEl = el.parent;
            var isParentRoot = parentEl === rootGroup;
            // Like 'position:absolut' in css, default 0.
            var elInner = $fa1e90cf6085f7eb$export$4ae363f1d88fb658(el);
            var parentElInner = $fa1e90cf6085f7eb$export$4ae363f1d88fb658(parentEl);
            elInner.width = (0, $iCU10.parsePercent)(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
            elInner.height = (0, $iCU10.parsePercent)(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
        }
        // Bottom-up tranvese all elements (consider ec resize) to locate elements.
        for(var i = elOptions.length - 1; i >= 0; i--){
            var elOption = elOptions[i];
            var id = $bx3T8.convertOptionIdName(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el) continue;
            var parentEl = el.parent;
            var parentElInner = $fa1e90cf6085f7eb$export$4ae363f1d88fb658(parentEl);
            var containerInfo = parentEl === rootGroup ? {
                width: apiWidth,
                height: apiHeight
            } : {
                width: parentElInner.width,
                height: parentElInner.height
            };
            // PENDING
            // Currently, when `bounding: 'all'`, the union bounding rect of the group
            // does not include the rect of [0, 0, group.width, group.height], which
            // is probably weird for users. Should we make a break change for it?
            var layoutPos = {};
            var layouted = $a35Wn.positionElement(el, elOption, containerInfo, null, {
                hv: elOption.hv,
                boundingMode: elOption.bounding
            }, layoutPos);
            if (!$fa1e90cf6085f7eb$export$4ae363f1d88fb658(el).isNew && layouted) {
                var transition = elOption.transition;
                var animatePos = {};
                for(var k = 0; k < xy.length; k++){
                    var key = xy[k];
                    var val = layoutPos[key];
                    if (transition && ((0, $0r1IS.isTransitionAll)(transition) || $2N6Uo.indexOf(transition, key) >= 0)) animatePos[key] = val;
                    else el[key] = val;
                }
                (0, $ipprj.updateProps)(el, animatePos, graphicModel, 0);
            } else el.attr(layoutPos);
        }
    };
    /**
   * Clear all elements.
   */ GraphicComponentView.prototype._clear = function() {
        var _this = this;
        var elMap = this._elMap;
        elMap.each(function(el) {
            $fa1e90cf6085f7eb$var$removeEl(el, $fa1e90cf6085f7eb$export$4ae363f1d88fb658(el).option, elMap, _this._lastGraphicModel);
        });
        this._elMap = $2N6Uo.createHashMap();
    };
    GraphicComponentView.prototype.dispose = function() {
        this._clear();
    };
    GraphicComponentView.type = 'graphic';
    return GraphicComponentView;
}((0, $bpyST.default));
function $fa1e90cf6085f7eb$var$newEl(graphicType) {
    var Clz = $2N6Uo.hasOwn($fa1e90cf6085f7eb$var$nonShapeGraphicElements, graphicType) ? $fa1e90cf6085f7eb$var$nonShapeGraphicElements[graphicType] : $h9U3p.getShapeClass(graphicType);
    var el = new Clz({});
    $fa1e90cf6085f7eb$export$4ae363f1d88fb658(el).type = graphicType;
    return el;
}
function $fa1e90cf6085f7eb$var$createEl(id, targetElParent, graphicType, elMap) {
    var el = $fa1e90cf6085f7eb$var$newEl(graphicType);
    targetElParent.add(el);
    elMap.set(id, el);
    $fa1e90cf6085f7eb$export$4ae363f1d88fb658(el).id = id;
    $fa1e90cf6085f7eb$export$4ae363f1d88fb658(el).isNew = true;
    return el;
}
function $fa1e90cf6085f7eb$var$removeEl(elExisting, elOption, elMap, graphicModel) {
    var existElParent = elExisting && elExisting.parent;
    if (existElParent) {
        elExisting.type === 'group' && elExisting.traverse(function(el) {
            $fa1e90cf6085f7eb$var$removeEl(el, elOption, elMap, graphicModel);
        });
        (0, $0r1IS.applyLeaveTransition)(elExisting, elOption, graphicModel);
        elMap.removeKey($fa1e90cf6085f7eb$export$4ae363f1d88fb658(elExisting).id);
    }
}
function $fa1e90cf6085f7eb$var$updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
    if (!el.isGroup) $2N6Uo.each([
        [
            'cursor',
            (0, $6Ekel.default).prototype.cursor
        ],
        // We should not support configure z and zlevel in the element level.
        // But seems we didn't limit it previously. So here still use it to avoid breaking.
        [
            'zlevel',
            defaultZlevel || 0
        ],
        [
            'z',
            defaultZ || 0
        ],
        // z2 must not be null/undefined, otherwise sort error may occur.
        [
            'z2',
            0
        ]
    ], function(item) {
        var prop = item[0];
        if ($2N6Uo.hasOwn(elOption, prop)) el[prop] = $2N6Uo.retrieve2(elOption[prop], item[1]);
        else if (el[prop] == null) el[prop] = item[1];
    });
    $2N6Uo.each($2N6Uo.keys(elOption), function(key) {
        // Assign event handlers.
        // PENDING: should enumerate all event names or use pattern matching?
        if (key.indexOf('on') === 0) {
            var val = elOption[key];
            el[key] = $2N6Uo.isFunction(val) ? val : null;
        }
    });
    if ($2N6Uo.hasOwn(elOption, 'draggable')) el.draggable = elOption.draggable;
    // Other attributes
    elOption.name != null && (el.name = elOption.name);
    elOption.id != null && (el.id = elOption.id);
}
// Remove unnecessary props to avoid potential problems.
function $fa1e90cf6085f7eb$var$getCleanedElOption(elOption) {
    elOption = $2N6Uo.extend({}, elOption);
    $2N6Uo.each([
        'id',
        'parentId',
        '$action',
        'hv',
        'bounding',
        'textContent',
        'clipPath'
    ].concat($a35Wn.LOCATION_PARAMS), function(name) {
        delete elOption[name];
    });
    return elOption;
}
function $fa1e90cf6085f7eb$var$setEventData(el, graphicModel, elOption) {
    var eventData = (0, $6TSUP.getECData)(el).eventData;
    // Simple optimize for large amount of elements that no need event.
    if (!el.silent && !el.ignore && !eventData) eventData = (0, $6TSUP.getECData)(el).eventData = {
        componentType: 'graphic',
        componentIndex: graphicModel.componentIndex,
        name: el.name
    };
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    if (eventData) eventData.info = elOption.info;
}

});


parcelRegister("gQxzG", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $c43b8be43ce1dfa8$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cWdXX = parcelRequire("cWdXX");

var $24qes = parcelRequire("24qes");

var $gX19P = parcelRequire("gX19P");
function $c43b8be43ce1dfa8$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $cWdXX.install));
    (0, $gX19P.use)((0, $24qes.install));
}

});

parcelRegister("2MEiy", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $206f52e1b0e86436$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $dF5j1 = parcelRequire("dF5j1");

var $L8ujF = parcelRequire("L8ujF");
function $206f52e1b0e86436$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $dF5j1.install));
    (0, $gX19P.use)((0, $L8ujF.install));
}

});
parcelRegister("dF5j1", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $9f233857dc929d7a$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fpx6O = parcelRequire("fpx6O");

var $c7iQf = parcelRequire("c7iQf");

var $4pLCh = parcelRequire("4pLCh");

var $1PElY = parcelRequire("1PElY");
function $9f233857dc929d7a$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $fpx6O.default));
    registers.registerComponentView((0, $c7iQf.default));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $4pLCh.default));
    registers.registerSubTypeDefaulter('legend', function() {
        return 'plain';
    });
    (0, $1PElY.installLegendAction)(registers);
}

});
parcelRegister("fpx6O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b382df85ead57b33$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $b8YKU = parcelRequire("b8YKU");

var $bx3T8 = parcelRequire("bx3T8");

var $eLD2b = parcelRequire("eLD2b");

var $6aXXD = parcelRequire("6aXXD");
var $b382df85ead57b33$var$getDefaultSelectorOptions = function(ecModel, type) {
    if (type === 'all') return {
        type: 'all',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'all'
        ])
    };
    else if (type === 'inverse') return {
        type: 'inverse',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'inverse'
        ])
    };
};
var $b382df85ead57b33$var$LegendModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: 'box',
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            'all',
            'inverse'
        ];
        if ($2N6Uo.isArray(selector)) $2N6Uo.each(selector, function(item, index) {
            $2N6Uo.isString(item) && (item = {
                type: item
            });
            selector[index] = $2N6Uo.merge(item, $b382df85ead57b33$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get('selectedMode') === 'single') {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get('name');
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get('name'));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $bx3T8.isNameSpecified)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get('data') || potentialData;
        var legendNameMap = $2N6Uo.createHashMap();
        var legendData = $2N6Uo.map(rawData, function(dataItem) {
            // Can be string or number
            if ($2N6Uo.isString(dataItem) || $2N6Uo.isNumber(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $b8YKU.default)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $2N6Uo.filter(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get('selectedMode');
        if (selectedMode === 'single') {
            var data = this._data;
            $2N6Uo.each(data, function(dataItem) {
                selected[dataItem.get('name')] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get('selectedMode') !== 'single') this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? 'unSelect' : 'select'](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $2N6Uo.each(data, function(dataItem) {
            selected[dataItem.get('name', true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $2N6Uo.each(data, function(dataItem) {
            var name = dataItem.get('name', true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $2N6Uo.indexOf(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get('orient') === 'vertical' ? {
            index: 1,
            name: 'vertical'
        } : {
            index: 0,
            name: 'horizontal'
        };
    };
    LegendModel.type = 'legend.plain';
    LegendModel.dependencies = [
        'series'
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: 'horizontal',
        left: 'center',
        // right: 'center',
        // top: 0,
        bottom: (0, $6aXXD.default).size.m,
        align: 'auto',
        backgroundColor: (0, $6aXXD.default).color.transparent,
        borderColor: (0, $6aXXD.default).color.border,
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 8,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: 'inherit',
        symbolKeepAspect: true,
        inactiveColor: (0, $6aXXD.default).color.disabled,
        inactiveBorderColor: (0, $6aXXD.default).color.disabled,
        inactiveBorderWidth: 'auto',
        itemStyle: {
            color: 'inherit',
            opacity: 'inherit',
            borderColor: 'inherit',
            borderWidth: 'auto',
            borderCap: 'inherit',
            borderJoin: 'inherit',
            borderDashOffset: 'inherit',
            borderMiterLimit: 'inherit'
        },
        lineStyle: {
            width: 'auto',
            color: 'inherit',
            inactiveColor: (0, $6aXXD.default).color.disabled,
            inactiveWidth: 2,
            opacity: 'inherit',
            type: 'inherit',
            cap: 'inherit',
            join: 'inherit',
            dashOffset: 'inherit',
            miterLimit: 'inherit'
        },
        textStyle: {
            color: (0, $6aXXD.default).color.secondary
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: 'sans-serif',
            color: (0, $6aXXD.default).color.tertiary,
            borderWidth: 1,
            borderColor: (0, $6aXXD.default).color.border
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: (0, $6aXXD.default).color.quaternary
            }
        },
        selectorPosition: 'auto',
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        },
        triggerEvent: false
    };
    return LegendModel;
}((0, $eLD2b.default));
var $b382df85ead57b33$export$2e2bcd8739ae039 = $b382df85ead57b33$var$LegendModel;

});

parcelRegister("c7iQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d24c110fe2f1916$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $3UxDF = parcelRequire("3UxDF");

var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");
var $h9U3p = parcelRequire("h9U3p");
var $kBKw3 = parcelRequire("kBKw3");

var $bwPbQ = parcelRequire("bwPbQ");

var $bysmE = parcelRequire("bysmE");

var $aVbOT = parcelRequire("aVbOT");

var $a35Wn = parcelRequire("a35Wn");

var $bpyST = parcelRequire("bpyST");

var $k0QDS = parcelRequire("k0QDS");

var $9gUBZ = parcelRequire("9gUBZ");

var $6TSUP = parcelRequire("6TSUP");

var $6aXXD = parcelRequire("6aXXD");
var $8d24c110fe2f1916$var$curry = $2N6Uo.curry;
var $8d24c110fe2f1916$var$each = $2N6Uo.each;
var $8d24c110fe2f1916$var$Group = $iQonF.default;
var $8d24c110fe2f1916$var$LegendView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $8d24c110fe2f1916$var$Group());
        this.group.add(this._selectorGroup = new $8d24c110fe2f1916$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get('show', true)) return;
        var itemAlign = legendModel.get('align');
        var orient = legendModel.get('orient');
        if (!itemAlign || itemAlign === 'auto') itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
        // selector has been normalized to an array in model
        var selector = legendModel.get('selector', true);
        var selectorPosition = legendModel.get('selectorPosition', true);
        if (selector && (!selectorPosition || selectorPosition === 'auto')) selectorPosition = orient === 'horizontal' ? 'end' : 'start';
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var refContainer = $a35Wn.createBoxLayoutReference(legendModel, api).refContainer;
        var positionInfo = legendModel.getBoxLayoutParams();
        var padding = legendModel.get('padding');
        var maxSize = $a35Wn.getLayoutRect(positionInfo, refContainer, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $a35Wn.getLayoutRect($2N6Uo.defaults({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), refContainer, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $aVbOT.makeBackground)(mainRect, // FXIME: most itemStyle options does not work in background because inherit is not handled yet.
        legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $2N6Uo.createHashMap();
        var selectMode = legendModel.get('selectedMode');
        var triggerEvent = legendModel.get('triggerEvent');
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
        });
        $8d24c110fe2f1916$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var _this = this;
            var name = legendItemModel.get('name');
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === '' || name === '\n')) {
                var g = new $8d24c110fe2f1916$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual('legendLineStyle') || {};
                var legendIcon = data.getVisual('legendIcon');
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual('style');
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on('click', $8d24c110fe2f1916$var$curry($8d24c110fe2f1916$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', $8d24c110fe2f1916$var$curry($8d24c110fe2f1916$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', $8d24c110fe2f1916$var$curry($8d24c110fe2f1916$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $6TSUP.getECData)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = 'legend';
                });
                if (triggerEvent) itemGroup.eachChild(function(child) {
                    _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                var _this = this;
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, 'style');
                    var legendIcon = provider.getItemVisual(idx, 'legendIcon');
                    var colorArr = (0, $3UxDF.parse)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $2N6Uo.extend($2N6Uo.extend({}, style), {
                            fill: (0, $3UxDF.stringify)(colorArr, 'rgba')
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on('click', $8d24c110fe2f1916$var$curry($8d24c110fe2f1916$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on('mouseover', $8d24c110fe2f1916$var$curry($8d24c110fe2f1916$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', $8d24c110fe2f1916$var$curry($8d24c110fe2f1916$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $6TSUP.getECData)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = 'legend';
                    });
                    if (triggerEvent) itemGroup.eachChild(function(child) {
                        _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype.packEventData = function(el, legendModel, seriesModel, dataIndex, name) {
        var eventData = {
            componentType: 'legend',
            componentIndex: legendModel.componentIndex,
            dataIndex: dataIndex,
            value: name,
            seriesIndex: seriesModel.seriesIndex
        };
        (0, $6TSUP.getECData)(el).eventData = eventData;
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $8d24c110fe2f1916$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $kBKw3.default({
                style: {
                    x: 0,
                    y: 0,
                    align: 'center',
                    verticalAlign: 'middle'
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect',
                        legendId: legendModel.id
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel('selectorLabel');
            var emphasisLabelModel = legendModel.getModel([
                'emphasis',
                'selectorLabel'
            ]);
            (0, $bysmE.setLabelStyle)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $bwPbQ.enableHoverEmphasis)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get('itemWidth');
        var itemHeight = legendModel.get('itemHeight');
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get('symbolRotate');
        var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
        var legendIconType = legendItemModel.get('icon');
        legendIcon = legendIconType || legendIcon || 'roundRect';
        var style = $8d24c110fe2f1916$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $8d24c110fe2f1916$var$Group();
        var textStyleModel = legendItemModel.getModel('textStyle');
        if ($2N6Uo.isFunction(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon
            itemGroup.add($8d24c110fe2f1916$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get('formatter');
        var content = name;
        if ($2N6Uo.isString(formatter) && formatter) content = formatter.replace('{name}', name != null ? name : '');
        else if ($2N6Uo.isFunction(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get('inactiveColor');
        itemGroup.add(new $kBKw3.default({
            style: (0, $bysmE.createTextStyle)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: 'middle'
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $aH2k0.default({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: 'transparent'
            }
        });
        var tooltipModel = legendItemModel.getModel('tooltip');
        if (tooltipModel.get('show')) $h9U3p.setTooltipConfig({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $bwPbQ.enableHoverEmphasis)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $a35Wn.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $a35Wn.box(// Buttons in selectorGroup always layout horizontally
            'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get('selectorButtonGap', true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? 'width' : 'height';
            var hw = orientIdx === 0 ? 'height' : 'width';
            var yx = orientIdx === 0 ? 'y' : 'x';
            if (selectorPosition === 'end') selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = 'legend.plain';
    return LegendView;
}((0, $bpyST.default));
function $8d24c110fe2f1916$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === 'auto') style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $8d24c110fe2f1916$var$each(style, function(propVal, propName) {
            style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel('itemStyle');
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
    var decalStyle = itemStyleModel.getShallow('decal');
    itemStyle.decal = !decalStyle || decalStyle === 'inherit' ? itemVisualStyle.decal : (0, $9gUBZ.createOrUpdatePatternFromDecal)(decalStyle, api);
    if (itemStyle.fill === 'inherit') /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === 'inherit') /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === 'inherit') /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel('lineStyle');
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get('inactiveBorderWidth');
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get('inactiveColor');
        itemStyle.stroke = legendItemModel.get('inactiveBorderColor');
        lineStyle.stroke = legendLineModel.get('inactiveColor');
        lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $8d24c110fe2f1916$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || 'roundRect';
    var icon = (0, $k0QDS.createSymbol)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf('empty') > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = (0, $6aXXD.default).color.neutral00;
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $8d24c110fe2f1916$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $8d24c110fe2f1916$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: 'legendToggleSelect',
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $8d24c110fe2f1916$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $8d24c110fe2f1916$var$isUseHoverLayer(api) {
    var list = api.getZr().storage.getDisplayList();
    var emphasisState;
    var i = 0;
    var len = list.length;
    while(i < len && !(emphasisState = list[i].states.emphasis))i++;
    return emphasisState && emphasisState.hoverLayer;
}
function $8d24c110fe2f1916$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$8d24c110fe2f1916$var$isUseHoverLayer(api)) api.dispatchAction({
        type: 'highlight',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $8d24c110fe2f1916$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$8d24c110fe2f1916$var$isUseHoverLayer(api)) api.dispatchAction({
        type: 'downplay',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $8d24c110fe2f1916$export$2e2bcd8739ae039 = $8d24c110fe2f1916$var$LegendView;

});
parcelRegister("aVbOT", function(module, exports) {

$parcel$export(module.exports, "makeBackground", function () { return $7f38657110148e13$export$fae23936eedfad4f; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hrphB = parcelRequire("hrphB");
parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");
function $7f38657110148e13$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $hrphB.normalizeCssArray(componentModel.get('padding'));
    var style = componentModel.getItemStyle([
        'color',
        'opacity'
    ]);
    style.fill = componentModel.get('backgroundColor');
    var bgRect = new $aH2k0.default({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get('borderRadius')
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return bgRect;
}

});


parcelRegister("4pLCh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $336e6ed64ef481a7$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $336e6ed64ef481a7$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}

});

parcelRegister("1PElY", function(module, exports) {

$parcel$export(module.exports, "installLegendAction", function () { return $1559db3a97f7c428$export$139982ea529c452f; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $1559db3a97f7c428$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var isAllSelect = methodName === 'allSelect' || methodName === 'inverseSelect';
    var selectedMap = {};
    var actionLegendIndices = [];
    ecModel.eachComponent({
        mainType: 'legend',
        query: payload
    }, function(legendModel) {
        if (isAllSelect) legendModel[methodName]();
        else legendModel[methodName](payload.name);
        $1559db3a97f7c428$var$makeSelectedMap(legendModel, selectedMap);
        actionLegendIndices.push(legendModel.componentIndex);
    });
    var allSelectedMap = {};
    // make selectedMap from all legend components
    ecModel.eachComponent('legend', function(legendModel) {
        (0, $2N6Uo.each)(selectedMap, function(isSelected, name) {
            // Force other legend has same selected status
            // Or the first is toggled to true and other are toggled to false
            // In the case one legend has some item unSelected in option. And if other legend
            // doesn't has the item, they will assume it is selected.
            legendModel[isSelected ? 'select' : 'unSelect'](name);
        });
        $1559db3a97f7c428$var$makeSelectedMap(legendModel, allSelectedMap);
    });
    // Return the event explicitly
    return isAllSelect ? {
        selected: allSelectedMap,
        // return legendIndex array to tell the developers which legends are allSelect / inverseSelect
        legendIndex: actionLegendIndices
    } : {
        name: payload.name,
        selected: allSelectedMap
    };
}
function $1559db3a97f7c428$var$makeSelectedMap(legendModel, out) {
    var selectedMap = out || {};
    (0, $2N6Uo.each)(legendModel.getData(), function(model) {
        var name = model.get('name');
        // Wrap element
        if (name === '\n' || name === '') return;
        var isItemSelected = legendModel.isSelected(name);
        if ((0, $2N6Uo.hasOwn)(selectedMap, name)) // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
        else selectedMap[name] = isItemSelected;
    });
    return selectedMap;
}
function $1559db3a97f7c428$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendToggleSelect', 'legendselectchanged', (0, $2N6Uo.curry)($1559db3a97f7c428$var$legendSelectActionHandler, 'toggleSelected'));
    registers.registerAction('legendAllSelect', 'legendselectall', (0, $2N6Uo.curry)($1559db3a97f7c428$var$legendSelectActionHandler, 'allSelect'));
    registers.registerAction('legendInverseSelect', 'legendinverseselect', (0, $2N6Uo.curry)($1559db3a97f7c428$var$legendSelectActionHandler, 'inverseSelect'));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendSelect', 'legendselected', (0, $2N6Uo.curry)($1559db3a97f7c428$var$legendSelectActionHandler, 'select'));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendUnSelect', 'legendunselected', (0, $2N6Uo.curry)($1559db3a97f7c428$var$legendSelectActionHandler, 'unSelect'));
}

});


parcelRegister("L8ujF", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $08daf96f7d55c061$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $dF5j1 = parcelRequire("dF5j1");

var $e8xYh = parcelRequire("e8xYh");

var $kNRpz = parcelRequire("kNRpz");

var $4T0dM = parcelRequire("4T0dM");
function $08daf96f7d55c061$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $dF5j1.install));
    registers.registerComponentModel((0, $e8xYh.default));
    registers.registerComponentView((0, $kNRpz.default));
    (0, $4T0dM.default)(registers);
}

});
parcelRegister("e8xYh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4ac2a0936ec928c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $fpx6O = parcelRequire("fpx6O");

var $a35Wn = parcelRequire("a35Wn");

var $cKPmR = parcelRequire("cKPmR");

var $6aXXD = parcelRequire("6aXXD");
var $a4ac2a0936ec928c$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $a35Wn.getLayoutParams)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $a4ac2a0936ec928c$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $a4ac2a0936ec928c$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = 'legend.scroll';
    ScrollableLegendModel.defaultOption = (0, $cKPmR.inheritDefaultOption)((0, $fpx6O.default).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: 'end',
        pageFormatter: '{current}/{total}',
        pageIcons: {
            horizontal: [
                'M0,0L12,-10L12,10z',
                'M0,0L-12,-10L-12,10z'
            ],
            vertical: [
                'M0,0L20,0L10,-20z',
                'M0,0L20,0L10,20z'
            ]
        },
        pageIconColor: (0, $6aXXD.default).color.accent50,
        pageIconInactiveColor: (0, $6aXXD.default).color.accent10,
        pageIconSize: 15,
        pageTextStyle: {
            color: (0, $6aXXD.default).color.tertiary
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $fpx6O.default));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $a4ac2a0936ec928c$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $a35Wn.mergeLayoutParam)(target, raw, {
        type: 'box',
        ignoreSize: !!ignoreSize
    });
}
var $a4ac2a0936ec928c$export$2e2bcd8739ae039 = $a4ac2a0936ec928c$var$ScrollableLegendModel;

});

parcelRegister("kNRpz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f251d0ac553da879$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");
var $ipprj = parcelRequire("ipprj");
var $iQonF = parcelRequire("iQonF");
var $kBKw3 = parcelRequire("kBKw3");

var $a35Wn = parcelRequire("a35Wn");

var $c7iQf = parcelRequire("c7iQf");
var $f251d0ac553da879$var$Group = $iQonF.default;
var $f251d0ac553da879$var$WH = [
    'width',
    'height'
];
var $f251d0ac553da879$var$XY = [
    'x',
    'y'
];
var $f251d0ac553da879$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $f251d0ac553da879$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $f251d0ac553da879$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get('pageIconSize', true);
        var pageIconSizeArr = $2N6Uo.isArray(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton('pagePrev', 0);
        var pageTextStyleModel = legendModel.getModel('pageTextStyle');
        controllerGroup.add(new $kBKw3.default({
            name: 'pageText',
            style: {
                // Placeholder to calculate a proper layout.
                text: 'xx/xx',
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: 'middle',
                align: 'center'
            },
            silent: true
        }));
        createPageButton('pageNext', 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + 'DataIndex';
            var icon = $h9U3p.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $2N6Uo.bind(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $f251d0ac553da879$var$WH[orientIdx];
        var xy = $f251d0ac553da879$var$XY[orientIdx];
        var hw = $f251d0ac553da879$var$WH[1 - orientIdx];
        var yx = $f251d0ac553da879$var$XY[1 - orientIdx];
        selector && $a35Wn.box(// Buttons in selectorGroup always layout horizontally
        'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
        var selectorButtonGap = legendModel.get('selectorButtonGap', true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $2N6Uo.clone(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === 'end') selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $a35Wn.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $a35Wn.box(// Buttons in controller are layout always horizontally.
        'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $2N6Uo.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get('pageButtonPosition', true);
            // controller is on the right / bottom.
            if (pageButtonPosition === 'end') controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $aH2k0.default({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $ipprj.updateProps(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: 'legendScroll',
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $2N6Uo.each([
            'pagePrev',
            'pageNext'
        ], function(name) {
            var key = name + 'DataIndex';
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
                icon.cursor = canJump ? 'pointer' : 'default';
            }
        });
        var pageText = controllerGroup.childOfName('pageText');
        var pageFormatter = legendModel.get('pageFormatter');
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle('text', $2N6Uo.isString(pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get('scrollDataIndex', true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $f251d0ac553da879$var$WH[orientIdx];
        var xy = $f251d0ac553da879$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = 'legend.scroll';
    return ScrollableLegendView;
}((0, $c7iQf.default));
var $f251d0ac553da879$export$2e2bcd8739ae039 = $f251d0ac553da879$var$ScrollableLegendView;

});

parcelRegister("4T0dM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ec786979b2f0c8$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $38ec786979b2f0c8$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction('legendScroll', 'legendscroll', function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: 'legend',
            subType: 'scroll',
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}

});



parcelRegister("aQjTt", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $7e4e313493988338$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hUmRl = parcelRequire("hUmRl");

var $fSOYQ = parcelRequire("fSOYQ");

var $iPg14 = parcelRequire("iPg14");
function $7e4e313493988338$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $fSOYQ.default));
    registers.registerComponentView((0, $iPg14.default));
    registers.registerPreprocessor(function(opt) {
        if ((0, $hUmRl.default)(opt.series, 'markArea')) // Make sure markArea component is enabled
        opt.markArea = opt.markArea || {};
    });
}

});
parcelRegister("hUmRl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0996608e30f8159$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $d0996608e30f8159$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $2N6Uo.isArray)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}

});

parcelRegister("fSOYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b90371c9fa5b988c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $4TzE1 = parcelRequire("4TzE1");
var $b90371c9fa5b988c$var$MarkAreaModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MarkAreaModel, _super);
    function MarkAreaModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaModel.type;
        return _this;
    }
    MarkAreaModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkAreaModel.type = 'markArea';
    MarkAreaModel.defaultOption = {
        // zlevel: 0,
        // PENDING
        z: 1,
        tooltip: {
            trigger: 'item'
        },
        // markArea should fixed on the coordinate system
        animation: false,
        label: {
            show: true,
            position: 'top'
        },
        itemStyle: {
            // color and borderColor default to use color from series
            // color: 'auto'
            // borderColor: 'auto'
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                position: 'top'
            }
        }
    };
    return MarkAreaModel;
}((0, $4TzE1.default));
var $b90371c9fa5b988c$export$2e2bcd8739ae039 = $b90371c9fa5b988c$var$MarkAreaModel;

});
parcelRegister("4TzE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3907f2bc31694538$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $cirKE = parcelRequire("cirKE");

var $7NPXc = parcelRequire("7NPXc");

var $eLD2b = parcelRequire("eLD2b");

var $bx3T8 = parcelRequire("bx3T8");

var $5KdhI = parcelRequire("5KdhI");
function $3907f2bc31694538$var$fillLabel(opt) {
    (0, $bx3T8.defaultEmphasis)(opt, 'label', [
        'show'
    ]);
}
// { [componentType]: MarkerModel }
var $3907f2bc31694538$var$inner = (0, $bx3T8.makeInner)();
var $3907f2bc31694538$var$MarkerModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        _this.preventAutoZ = true;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $cirKE.default).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $3907f2bc31694538$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $3907f2bc31694538$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $3907f2bc31694538$var$fillLabel(markerOpt);
                $2N6Uo.each(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $3907f2bc31694538$var$fillLabel(item[0]);
                        $3907f2bc31694538$var$fillLabel(item[1]);
                    } else $3907f2bc31694538$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel);
                // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $2N6Uo.extend(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $3907f2bc31694538$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $5KdhI.createTooltipMarkup)('section', {
            header: this.name,
            blocks: [
                (0, $5KdhI.createTooltipMarkup)('nameValue', {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = (0, $7NPXc.DataFormatMixin).prototype.getDataParams.call(this, dataIndex, dataType);
        var hostSeries = this.__hostSeries;
        if (hostSeries) {
            params.seriesId = hostSeries.id;
            params.seriesName = hostSeries.name;
            params.seriesType = hostSeries.subType;
        }
        return params;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, // Support three types of markers. Strict check.
    componentType) {
        return $3907f2bc31694538$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = 'marker';
    MarkerModel.dependencies = [
        'series',
        'grid',
        'polar',
        'geo'
    ];
    return MarkerModel;
}((0, $eLD2b.default));
$2N6Uo.mixin($3907f2bc31694538$var$MarkerModel, (0, $7NPXc.DataFormatMixin).prototype);
var $3907f2bc31694538$export$2e2bcd8739ae039 = $3907f2bc31694538$var$MarkerModel;

});


parcelRegister("iPg14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db4969eab317d365$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $3UxDF = parcelRequire("3UxDF");

var $2kN4z = parcelRequire("2kN4z");

var $iCU10 = parcelRequire("iCU10");

var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $hXTRG = parcelRequire("hXTRG");
var $ipprj = parcelRequire("ipprj");

var $bwPbQ = parcelRequire("bwPbQ");

var $fj43b = parcelRequire("fj43b");

var $eDzDb = parcelRequire("eDzDb");

var $2N6Uo = parcelRequire("2N6Uo");

var $kXNP6 = parcelRequire("kXNP6");

var $4TzE1 = parcelRequire("4TzE1");

var $bx3T8 = parcelRequire("bx3T8");

var $csdCr = parcelRequire("csdCr");

var $bysmE = parcelRequire("bysmE");

var $6TSUP = parcelRequire("6TSUP");

var $irvLa = parcelRequire("irvLa");

var $6aXXD = parcelRequire("6aXXD");
var $db4969eab317d365$var$inner = (0, $bx3T8.makeInner)();
var $db4969eab317d365$var$markAreaTransform = function(seriesModel, coordSys, maModel, item) {
    // item may be null
    var item0 = item[0];
    var item1 = item[1];
    if (!item0 || !item1) return;
    var lt = $fj43b.dataTransform(seriesModel, item0);
    var rb = $fj43b.dataTransform(seriesModel, item1);
    // FIXME make sure lt is less than rb
    var ltCoord = lt.coord;
    var rbCoord = rb.coord;
    ltCoord[0] = (0, $2N6Uo.retrieve)(ltCoord[0], -Infinity);
    ltCoord[1] = (0, $2N6Uo.retrieve)(ltCoord[1], -Infinity);
    rbCoord[0] = (0, $2N6Uo.retrieve)(rbCoord[0], Infinity);
    rbCoord[1] = (0, $2N6Uo.retrieve)(rbCoord[1], Infinity);
    // Merge option into one
    var result = (0, $2N6Uo.mergeAll)([
        {},
        lt,
        rb
    ]);
    result.coord = [
        lt.coord,
        rb.coord
    ];
    result.x0 = lt.x;
    result.y0 = lt.y;
    result.x1 = rb.x;
    result.y1 = rb.y;
    return result;
};
function $db4969eab317d365$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markArea has one dim
function $db4969eab317d365$var$ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    return $db4969eab317d365$var$isInfinity(fromCoord[otherDimIndex]) && $db4969eab317d365$var$isInfinity(toCoord[otherDimIndex]);
}
function $db4969eab317d365$var$markAreaFilter(coordSys, item) {
    var fromCoord = item.coord[0];
    var toCoord = item.coord[1];
    var item0 = {
        coord: fromCoord,
        x: item.x0,
        y: item.y0
    };
    var item1 = {
        coord: toCoord,
        x: item.x1,
        y: item.y1
    };
    if ((0, $kXNP6.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
        // In case
        // {
        //  markArea: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($db4969eab317d365$var$ifMarkAreaHasOnlyDim(1, fromCoord, toCoord, coordSys) || $db4969eab317d365$var$ifMarkAreaHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
        // Directly returning true may also do the work,
        // because markArea will not be shown automatically
        // when it's not included in coordinate system.
        // But filtering ahead can avoid keeping rendering markArea
        // when there are too many of them.
        return $fj43b.zoneFilter(coordSys, item0, item1);
    }
    return $fj43b.dataFilter(coordSys, item0) || $fj43b.dataFilter(coordSys, item1);
}
// dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
function $db4969eab317d365$var$getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $iCU10.parsePercent(itemModel.get(dims[0]), api.getWidth());
    var yPx = $iCU10.parsePercent(itemModel.get(dims[1]), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) {
            // Consider the case that user input the right-bottom point first
            // Pick the larger x and y as 'x1' and 'y1'
            var pointValue0 = data.getValues([
                'x0',
                'y0'
            ], idx);
            var pointValue1 = data.getValues([
                'x1',
                'y1'
            ], idx);
            var clampPointValue0 = coordSys.clampData(pointValue0);
            var clampPointValue1 = coordSys.clampData(pointValue1);
            var pointValue = [];
            if (dims[0] === 'x0') pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue1[0] : pointValue0[0];
            else pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue0[0] : pointValue1[0];
            if (dims[1] === 'y0') pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue1[1] : pointValue0[1];
            else pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue0[1] : pointValue1[1];
            // Use the getMarkerPosition
            point = seriesModel.getMarkerPosition(pointValue, dims, true);
        } else {
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            var pt = [
                x,
                y
            ];
            coordSys.clampData && coordSys.clampData(pt, pt);
            point = coordSys.dataToPoint(pt, true);
        }
        if ((0, $kXNP6.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            if ($db4969eab317d365$var$isInfinity(x)) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
            else if ($db4969eab317d365$var$isInfinity(y)) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    return point;
}
var $db4969eab317d365$export$fc5a505a325de211 = [
    [
        'x0',
        'y0'
    ],
    [
        'x1',
        'y0'
    ],
    [
        'x1',
        'y1'
    ],
    [
        'x0',
        'y1'
    ]
];
var $db4969eab317d365$var$MarkAreaView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MarkAreaView, _super);
    function MarkAreaView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaView.type;
        return _this;
    }
    MarkAreaView.prototype.updateTransform = function(markAreaModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var maModel = (0, $4TzE1.default).getMarkerModelFromSeries(seriesModel, 'markArea');
            if (maModel) {
                var areaData_1 = maModel.getData();
                areaData_1.each(function(idx) {
                    var points = (0, $2N6Uo.map)($db4969eab317d365$export$fc5a505a325de211, function(dim) {
                        return $db4969eab317d365$var$getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
                    });
                    // Layout
                    areaData_1.setItemLayout(idx, points);
                    var el = areaData_1.getItemGraphicEl(idx);
                    el.setShape('points', points);
                });
            }
        }, this);
    };
    MarkAreaView.prototype.renderSeries = function(seriesModel, maModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var areaGroupMap = this.markerGroupMap;
        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
            group: new $iQonF.default()
        });
        this.group.add(polygonGroup.group);
        this.markKeep(polygonGroup);
        var areaData = $db4969eab317d365$var$createList(coordSys, seriesModel, maModel);
        // Line data for tooltip and formatter
        maModel.setData(areaData);
        // Update visual and layout of line
        areaData.each(function(idx) {
            // Layout
            var points = (0, $2N6Uo.map)($db4969eab317d365$export$fc5a505a325de211, function(dim) {
                return $db4969eab317d365$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
            });
            var xAxisScale = coordSys.getAxis('x').scale;
            var yAxisScale = coordSys.getAxis('y').scale;
            var xAxisExtent = xAxisScale.getExtent();
            var yAxisExtent = yAxisScale.getExtent();
            var xPointExtent = [
                xAxisScale.parse(areaData.get('x0', idx)),
                xAxisScale.parse(areaData.get('x1', idx))
            ];
            var yPointExtent = [
                yAxisScale.parse(areaData.get('y0', idx)),
                yAxisScale.parse(areaData.get('y1', idx))
            ];
            $iCU10.asc(xPointExtent);
            $iCU10.asc(yPointExtent);
            var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]);
            // If none of the area is inside coordSys, allClipped is set to be true
            // in layout so that label will not be displayed. See #12591
            var allClipped = !overlapped;
            areaData.setItemLayout(idx, {
                points: points,
                allClipped: allClipped
            });
            var itemModel = areaData.getItemModel(idx);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            var z2 = itemModel.get('z2');
            var color = (0, $csdCr.getVisualFromData)(seriesData, 'color');
            if (!style.fill) {
                style.fill = color;
                if ((0, $2N6Uo.isString)(style.fill)) style.fill = $3UxDF.modifyAlpha(style.fill, 0.4);
            }
            if (!style.stroke) style.stroke = color;
            // Visual
            areaData.setItemVisual(idx, 'style', style);
            areaData.setItemVisual(idx, 'z2', (0, $2N6Uo.retrieve2)(z2, 0));
        });
        areaData.diff($db4969eab317d365$var$inner(polygonGroup).data).add(function(idx) {
            var layout = areaData.getItemLayout(idx);
            var z2 = areaData.getItemVisual(idx, 'z2');
            if (!layout.allClipped) {
                var polygon = new $hXTRG.default({
                    z2: (0, $2N6Uo.retrieve2)(z2, 0),
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(idx, polygon);
                polygonGroup.group.add(polygon);
            }
        }).update(function(newIdx, oldIdx) {
            var polygon = $db4969eab317d365$var$inner(polygonGroup).data.getItemGraphicEl(oldIdx);
            var layout = areaData.getItemLayout(newIdx);
            var z2 = areaData.getItemVisual(newIdx, 'z2');
            if (!layout.allClipped) {
                if (polygon) $ipprj.updateProps(polygon, {
                    z2: (0, $2N6Uo.retrieve2)(z2, 0),
                    shape: {
                        points: layout.points
                    }
                }, maModel, newIdx);
                else polygon = new $hXTRG.default({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(newIdx, polygon);
                polygonGroup.group.add(polygon);
            } else if (polygon) polygonGroup.group.remove(polygon);
        }).remove(function(idx) {
            var polygon = $db4969eab317d365$var$inner(polygonGroup).data.getItemGraphicEl(idx);
            polygonGroup.group.remove(polygon);
        }).execute();
        areaData.eachItemGraphicEl(function(polygon, idx) {
            var itemModel = areaData.getItemModel(idx);
            var style = areaData.getItemVisual(idx, 'style');
            polygon.useStyle(areaData.getItemVisual(idx, 'style'));
            (0, $bysmE.setLabelStyle)(polygon, (0, $bysmE.getLabelStatesModels)(itemModel), {
                labelFetcher: maModel,
                labelDataIndex: idx,
                defaultText: areaData.getName(idx) || '',
                inheritColor: (0, $2N6Uo.isString)(style.fill) ? $3UxDF.modifyAlpha(style.fill, 1) : (0, $6aXXD.default).color.neutral99
            });
            (0, $bwPbQ.setStatesStylesFromModel)(polygon, itemModel);
            (0, $bwPbQ.toggleHoverEmphasis)(polygon, null, null, itemModel.get([
                'emphasis',
                'disabled'
            ]));
            (0, $6TSUP.getECData)(polygon).dataModel = maModel;
        });
        $db4969eab317d365$var$inner(polygonGroup).data = areaData;
        polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
    };
    MarkAreaView.type = 'markArea';
    return MarkAreaView;
}((0, $eDzDb.default));
function $db4969eab317d365$var$createList(coordSys, seriesModel, maModel) {
    var areaData;
    var dataDims;
    var dims = [
        'x0',
        'y0',
        'x1',
        'y1'
    ];
    if (coordSys) {
        var coordDimsInfos_1 = (0, $2N6Uo.map)(coordSys && coordSys.dimensions, function(coordDim) {
            var data = seriesModel.getData();
            var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {};
            // In map series data don't have lng and lat dimension. Fallback to same with coordSys
            return (0, $2N6Uo.extend)((0, $2N6Uo.extend)({}, info), {
                name: coordDim,
                // DON'T use ordinalMeta to parse and collect ordinal.
                ordinalMeta: null
            });
        });
        dataDims = (0, $2N6Uo.map)(dims, function(dim, idx) {
            return {
                name: dim,
                type: coordDimsInfos_1[idx % 2].type
            };
        });
        areaData = new (0, $2kN4z.default)(dataDims, maModel);
    } else {
        dataDims = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        areaData = new (0, $2kN4z.default)(dataDims, maModel);
    }
    var optData = (0, $2N6Uo.map)(maModel.get('data'), (0, $2N6Uo.curry)($db4969eab317d365$var$markAreaTransform, seriesModel, coordSys, maModel));
    if (coordSys) optData = (0, $2N6Uo.filter)(optData, (0, $2N6Uo.curry)($db4969eab317d365$var$markAreaFilter, coordSys));
    var dimValueGetter = coordSys ? function(item, dimName, dataIndex, dimIndex) {
        // TODO should convert to ParsedValue?
        var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
        return (0, $irvLa.parseDataValue)(rawVal, dataDims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $irvLa.parseDataValue)(item.value, dataDims[dimIndex]);
    };
    areaData.initData(optData, null, dimValueGetter);
    areaData.hasItemOption = true;
    return areaData;
}
var $db4969eab317d365$export$2e2bcd8739ae039 = $db4969eab317d365$var$MarkAreaView;

});
parcelRegister("fj43b", function(module, exports) {

$parcel$export(module.exports, "numCalculate", function () { return $b24bc5ac9300dcc4$export$18ddefb55c03640b; });
$parcel$export(module.exports, "dataTransform", function () { return $b24bc5ac9300dcc4$export$3eebd2d54b98c04f; });
$parcel$export(module.exports, "getAxisInfo", function () { return $b24bc5ac9300dcc4$export$bd39458db76002ab; });
$parcel$export(module.exports, "dataFilter", function () { return $b24bc5ac9300dcc4$export$179695f4a9040f73; });
$parcel$export(module.exports, "zoneFilter", function () { return $b24bc5ac9300dcc4$export$c869311b63462da6; });
$parcel$export(module.exports, "createMarkerDimValueGetter", function () { return $b24bc5ac9300dcc4$export$a53767c3c8f69cf7; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iCU10 = parcelRequire("iCU10");

var $a1eW0 = parcelRequire("a1eW0");

var $2N6Uo = parcelRequire("2N6Uo");

var $irvLa = parcelRequire("irvLa");
function $b24bc5ac9300dcc4$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $b24bc5ac9300dcc4$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $b24bc5ac9300dcc4$var$markerTypeCalculatorWithExtent(markerType, data, axisDim, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $a1eW0.isDimensionStacked)(data, targetDataDim /* , otherDataDim */ );
    var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
    var value = $b24bc5ac9300dcc4$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var seriesModel = data.hostModel;
    var dataIndex = seriesModel.indicesOfNearest(axisDim, calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex);
    // Make it simple, do not visit all stacked value to count precision.
    var precision = $iCU10.getPrecision(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
}
// TODO Specified percent
var $b24bc5ac9300dcc4$var$markerTypeCalculator = {
    min: (0, $2N6Uo.curry)($b24bc5ac9300dcc4$var$markerTypeCalculatorWithExtent, 'min'),
    max: (0, $2N6Uo.curry)($b24bc5ac9300dcc4$var$markerTypeCalculatorWithExtent, 'max'),
    average: (0, $2N6Uo.curry)($b24bc5ac9300dcc4$var$markerTypeCalculatorWithExtent, 'average'),
    median: (0, $2N6Uo.curry)($b24bc5ac9300dcc4$var$markerTypeCalculatorWithExtent, 'median')
};
function $b24bc5ac9300dcc4$export$3eebd2d54b98c04f(seriesModel, item) {
    if (!item) return;
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dims = coordSys && coordSys.dimensions;
    // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (!$b24bc5ac9300dcc4$var$hasXAndY(item) && !(0, $2N6Uo.isArray)(item.coord) && (0, $2N6Uo.isArray)(dims)) {
        var axisInfo = $b24bc5ac9300dcc4$export$bd39458db76002ab(item, data, coordSys, seriesModel);
        // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $2N6Uo.clone)(item);
        if (item.type && $b24bc5ac9300dcc4$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $2N6Uo.indexOf)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $2N6Uo.indexOf)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $b24bc5ac9300dcc4$var$markerTypeCalculator[item.type](data, axisInfo.valueAxis.dim, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0];
            // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else // FIXME Only has one of xAxis and yAxis.
        item.coord = [
            item.xAxis != null ? item.xAxis : item.radiusAxis,
            item.yAxis != null ? item.yAxis : item.angleAxis
        ];
    }
    // x y is provided
    if (item.coord == null || !(0, $2N6Uo.isArray)(dims)) {
        item.coord = [];
        var baseAxis = seriesModel.getBaseAxis();
        if (baseAxis && item.type && $b24bc5ac9300dcc4$var$markerTypeCalculator[item.type]) {
            var otherAxis = coordSys.getOtherAxis(baseAxis);
            if (otherAxis) item.value = $b24bc5ac9300dcc4$export$18ddefb55c03640b(data, data.mapDimension(otherAxis.dim), item.type);
        }
    } else {
        // Each coord support max, min, average
        var coord = item.coord;
        for(var i = 0; i < 2; i++)if ($b24bc5ac9300dcc4$var$markerTypeCalculator[coord[i]]) coord[i] = $b24bc5ac9300dcc4$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
    }
    return item;
}
function $b24bc5ac9300dcc4$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($b24bc5ac9300dcc4$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $b24bc5ac9300dcc4$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $b24bc5ac9300dcc4$export$179695f4a9040f73(// Currently only polar and cartesian has containData.
coordSys, item) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$b24bc5ac9300dcc4$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $b24bc5ac9300dcc4$export$c869311b63462da6(// Currently only polar and cartesian has containData.
coordSys, item1, item2) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containZone && item1.coord && item2.coord && !$b24bc5ac9300dcc4$var$hasXOrY(item1) && !$b24bc5ac9300dcc4$var$hasXOrY(item2) ? coordSys.containZone(item1.coord, item2.coord) : true;
}
function $b24bc5ac9300dcc4$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $irvLa.parseDataValue)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $irvLa.parseDataValue)(item.value, dims[dimIndex]);
    };
}
function $b24bc5ac9300dcc4$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === 'average') {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === 'median') return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
}

});

parcelRegister("eDzDb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa8058c8c1abf23d$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $bpyST = parcelRequire("bpyST");

var $2N6Uo = parcelRequire("2N6Uo");

var $4TzE1 = parcelRequire("4TzE1");

var $bx3T8 = parcelRequire("bx3T8");

var $bwPbQ = parcelRequire("bwPbQ");

var $h9U3p = parcelRequire("h9U3p");
var $aa8058c8c1abf23d$var$inner = (0, $bx3T8.makeInner)();
var $aa8058c8c1abf23d$var$MarkerView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $2N6Uo.createHashMap)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $aa8058c8c1abf23d$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $4TzE1.default).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$aa8058c8c1abf23d$var$inner(item).keep && _this.group.remove(item.group);
        });
        $aa8058c8c1abf23d$var$updateZ(ecModel, markerGroupMap, this.type);
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $aa8058c8c1abf23d$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.toggleBlurSeries = function(seriesModelList, isBlur) {
        var _this = this;
        (0, $2N6Uo.each)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $4TzE1.default).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) isBlur ? (0, $bwPbQ.enterBlur)(el) : (0, $bwPbQ.leaveBlur)(el);
                });
            }
        });
    };
    MarkerView.type = 'marker';
    return MarkerView;
}((0, $bpyST.default));
function $aa8058c8c1abf23d$var$updateZ(ecModel, markerGroupMap, type) {
    ecModel.eachSeries(function(seriesModel) {
        var markerModel = (0, $4TzE1.default).getMarkerModelFromSeries(seriesModel, type);
        var markerDraw = markerGroupMap.get(seriesModel.id);
        if (markerModel && markerDraw && markerDraw.group) {
            var _a = (0, $h9U3p.retrieveZInfo)(markerModel), z = _a.z, zlevel = _a.zlevel;
            (0, $h9U3p.traverseUpdateZ)(markerDraw.group, z, zlevel);
        }
    });
}
var $aa8058c8c1abf23d$export$2e2bcd8739ae039 = $aa8058c8c1abf23d$var$MarkerView;

});



parcelRegister("6S8Qg", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $500ea5130a7084b7$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $hUmRl = parcelRequire("hUmRl");

var $ibBV7 = parcelRequire("ibBV7");

var $ekgsx = parcelRequire("ekgsx");
function $500ea5130a7084b7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $ibBV7.default));
    registers.registerComponentView((0, $ekgsx.default));
    registers.registerPreprocessor(function(opt) {
        if ((0, $hUmRl.default)(opt.series, 'markLine')) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

});
parcelRegister("ibBV7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3d6ab3f3b5968e2$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $4TzE1 = parcelRequire("4TzE1");
var $d3d6ab3f3b5968e2$var$MarkLineModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = 'markLine';
    MarkLineModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: [
            'circle',
            'arrow'
        ],
        symbolSize: [
            8,
            16
        ],
        // symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'end',
            distance: 5
        },
        lineStyle: {
            type: 'dashed'
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: 'linear'
    };
    return MarkLineModel;
}((0, $4TzE1.default));
var $d3d6ab3f3b5968e2$export$2e2bcd8739ae039 = $d3d6ab3f3b5968e2$var$MarkLineModel;

});

parcelRegister("ekgsx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6dfb365236c6c60$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2kN4z = parcelRequire("2kN4z");

var $iCU10 = parcelRequire("iCU10");

var $fj43b = parcelRequire("fj43b");

var $3ru3e = parcelRequire("3ru3e");

var $eDzDb = parcelRequire("eDzDb");

var $a1eW0 = parcelRequire("a1eW0");

var $kXNP6 = parcelRequire("kXNP6");

var $6TSUP = parcelRequire("6TSUP");

var $4TzE1 = parcelRequire("4TzE1");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $csdCr = parcelRequire("csdCr");
var $a6dfb365236c6c60$var$inner = (0, $bx3T8.makeInner)();
var $a6dfb365236c6c60$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $2N6Uo.isArray)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
                value = (0, $2N6Uo.retrieve)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $fj43b.getAxisInfo(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $a1eW0.getStackedDimension)(data, axisInfo.valueDataDim);
                value = $fj43b.numCalculate(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
            var baseIndex = 1 - valueIndex;
            // Normized to 2d data with start and end point
            var mlFrom = (0, $2N6Uo.clone)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get('precision');
            if (precision >= 0 && (0, $2N6Uo.isNumber)(value)) value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $fj43b.dataTransform(seriesModel, itemArray[0]),
        $fj43b.dataTransform(seriesModel, itemArray[1]),
        (0, $2N6Uo.extend)({}, itemArray[2])
    ];
    // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null;
    // Merge from option and to option into line option
    (0, $2N6Uo.merge)(normalizedItem[2], normalizedItem[0]);
    (0, $2N6Uo.merge)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $a6dfb365236c6c60$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markLine has one dim
function $a6dfb365236c6c60$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $a6dfb365236c6c60$var$isInfinity(fromCoord[otherDimIndex]) && $a6dfb365236c6c60$var$isInfinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $a6dfb365236c6c60$var$markLineFilter(coordSys, item) {
    if (coordSys.type === 'cartesian2d') {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord;
        // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($a6dfb365236c6c60$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $a6dfb365236c6c60$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $fj43b.dataFilter(coordSys, item[0]) && $fj43b.dataFilter(coordSys, item[1]);
}
function $a6dfb365236c6c60$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $iCU10.parsePercent(itemModel.get('x'), api.getWidth());
    var yPx = $iCU10.parsePercent(itemModel.get('y'), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $kXNP6.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var dims = coordSys.dimensions;
            if ($a6dfb365236c6c60$var$isInfinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($a6dfb365236c6c60$var$isInfinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $a6dfb365236c6c60$var$MarkLineView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $4TzE1.default).getMarkerModelFromSeries(seriesModel, 'markLine');
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $a6dfb365236c6c60$var$inner(mlModel).from;
                var toData_1 = $a6dfb365236c6c60$var$inner(mlModel).to;
                // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $a6dfb365236c6c60$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $a6dfb365236c6c60$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                });
                // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $3ru3e.default)());
        this.group.add(lineDraw.group);
        var mlData = $a6dfb365236c6c60$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $a6dfb365236c6c60$var$inner(mlModel).from = fromData;
        $a6dfb365236c6c60$var$inner(mlModel).to = toData;
        // Line data for tooltip and formatter
        mlModel.setData(lineData);
        // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get('symbol');
        var symbolSize = mlModel.get('symbolSize');
        var symbolRotate = mlModel.get('symbolRotate');
        var symbolOffset = mlModel.get('symbolOffset');
        // TODO: support callback function like markPoint
        if (!(0, $2N6Uo.isArray)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $2N6Uo.isArray)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $2N6Uo.isArray)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $2N6Uo.isArray)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        });
        // Update visual and layout of line
        lineData.each(function(idx) {
            var itemModel = lineData.getItemModel(idx);
            var lineStyle = itemModel.getModel('lineStyle').getLineStyle();
            // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            var z2 = itemModel.get('z2');
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
            lineData.setItemVisual(idx, {
                z2: (0, $2N6Uo.retrieve2)(z2, 0),
                fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
                fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
                fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
                fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
                fromSymbol: fromData.getItemVisual(idx, 'symbol'),
                toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
                toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
                toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
                toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
                toSymbol: toData.getItemVisual(idx, 'symbol'),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData);
        // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el) {
            (0, $6TSUP.getECData)(el).dataModel = mlModel;
            el.traverse(function(child) {
                (0, $6TSUP.getECData)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $a6dfb365236c6c60$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (style.fill == null) style.fill = (0, $csdCr.getVisualFromData)(seriesData, 'color');
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get('symbolKeepAspect'),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $2N6Uo.retrieve2)(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $2N6Uo.retrieve2)(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $2N6Uo.retrieve2)(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $2N6Uo.retrieve2)(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
    };
    MarkLineView.type = 'markLine';
    return MarkLineView;
}((0, $eDzDb.default));
function $a6dfb365236c6c60$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $2N6Uo.map)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $2N6Uo.extend)((0, $2N6Uo.extend)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var fromData = new (0, $2kN4z.default)(coordDimsInfos, mlModel);
    var toData = new (0, $2kN4z.default)(coordDimsInfos, mlModel);
    // No dimensions
    var lineData = new (0, $2kN4z.default)([], mlModel);
    var optData = (0, $2N6Uo.map)(mlModel.get('data'), (0, $2N6Uo.curry)($a6dfb365236c6c60$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $2N6Uo.filter)(optData, (0, $2N6Uo.curry)($a6dfb365236c6c60$var$markLineFilter, coordSys));
    var dimValueGetter = $fj43b.createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
    fromData.initData((0, $2N6Uo.map)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $2N6Uo.map)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $2N6Uo.map)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $a6dfb365236c6c60$export$2e2bcd8739ae039 = $a6dfb365236c6c60$var$MarkLineView;

});


parcelRegister("jyMuy", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $e3d6cec464b647f4$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $hUmRl = parcelRequire("hUmRl");

var $biyYP = parcelRequire("biyYP");

var $bsiXO = parcelRequire("bsiXO");
function $e3d6cec464b647f4$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $biyYP.default));
    registers.registerComponentView((0, $bsiXO.default));
    registers.registerPreprocessor(function(opt) {
        if ((0, $hUmRl.default)(opt.series, 'markPoint')) // Make sure markPoint component is enabled
        opt.markPoint = opt.markPoint || {};
    });
}

});
parcelRegister("biyYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $839c8279337edd4c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $4TzE1 = parcelRequire("4TzE1");
var $839c8279337edd4c$var$MarkPointModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MarkPointModel, _super);
    function MarkPointModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointModel.type;
        return _this;
    }
    MarkPointModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkPointModel.type = 'markPoint';
    MarkPointModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: 'pin',
        symbolSize: 50,
        // symbolRotate: 0,
        // symbolOffset: [0, 0]
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'inside'
        },
        itemStyle: {
            borderWidth: 2
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return MarkPointModel;
}((0, $4TzE1.default));
var $839c8279337edd4c$export$2e2bcd8739ae039 = $839c8279337edd4c$var$MarkPointModel;

});

parcelRegister("bsiXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857105080c1b0dbe$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $ih3Ax = parcelRequire("ih3Ax");

var $iCU10 = parcelRequire("iCU10");

var $2kN4z = parcelRequire("2kN4z");

var $fj43b = parcelRequire("fj43b");

var $eDzDb = parcelRequire("eDzDb");

var $4TzE1 = parcelRequire("4TzE1");

var $2N6Uo = parcelRequire("2N6Uo");

var $6TSUP = parcelRequire("6TSUP");

var $csdCr = parcelRequire("csdCr");
function $857105080c1b0dbe$var$updateMarkerLayout(mpData, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var apiWidth = api.getWidth();
    var apiHeight = api.getHeight();
    var coordRect = coordSys && coordSys.getArea && coordSys.getArea();
    mpData.each(function(idx) {
        var itemModel = mpData.getItemModel(idx);
        var isRelativeToCoordinate = itemModel.get('relativeTo') === 'coordinate';
        var width = isRelativeToCoordinate ? coordRect ? coordRect.width : 0 : apiWidth;
        var height = isRelativeToCoordinate ? coordRect ? coordRect.height : 0 : apiHeight;
        var left = isRelativeToCoordinate && coordRect ? coordRect.x : 0;
        var top = isRelativeToCoordinate && coordRect ? coordRect.y : 0;
        var point;
        var xPx = $iCU10.parsePercent(itemModel.get('x'), width) + left;
        var yPx = $iCU10.parsePercent(itemModel.get('y'), height) + top;
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
        else if (coordSys) {
            var x = mpData.get(coordSys.dimensions[0], idx);
            var y = mpData.get(coordSys.dimensions[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
        mpData.setItemLayout(idx, point);
    });
}
var $857105080c1b0dbe$var$MarkPointView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MarkPointView, _super);
    function MarkPointView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointView.type;
        return _this;
    }
    MarkPointView.prototype.updateTransform = function(markPointModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mpModel = (0, $4TzE1.default).getMarkerModelFromSeries(seriesModel, 'markPoint');
            if (mpModel) {
                $857105080c1b0dbe$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkPointView.prototype.renderSeries = function(seriesModel, mpModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var symbolDrawMap = this.markerGroupMap;
        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new (0, $ih3Ax.default)());
        var mpData = $857105080c1b0dbe$var$createData(coordSys, seriesModel, mpModel);
        // FIXME
        mpModel.setData(mpData);
        $857105080c1b0dbe$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var symbol = itemModel.getShallow('symbol');
            var symbolSize = itemModel.getShallow('symbolSize');
            var symbolRotate = itemModel.getShallow('symbolRotate');
            var symbolOffset = itemModel.getShallow('symbolOffset');
            var symbolKeepAspect = itemModel.getShallow('symbolKeepAspect');
            // TODO: refactor needed: single data item should not support callback function
            if ((0, $2N6Uo.isFunction)(symbol) || (0, $2N6Uo.isFunction)(symbolSize) || (0, $2N6Uo.isFunction)(symbolRotate) || (0, $2N6Uo.isFunction)(symbolOffset)) {
                var rawIdx = mpModel.getRawValue(idx);
                var dataParams = mpModel.getDataParams(idx);
                if ((0, $2N6Uo.isFunction)(symbol)) symbol = symbol(rawIdx, dataParams);
                if ((0, $2N6Uo.isFunction)(symbolSize)) // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
                symbolSize = symbolSize(rawIdx, dataParams);
                if ((0, $2N6Uo.isFunction)(symbolRotate)) symbolRotate = symbolRotate(rawIdx, dataParams);
                if ((0, $2N6Uo.isFunction)(symbolOffset)) symbolOffset = symbolOffset(rawIdx, dataParams);
            }
            var style = itemModel.getModel('itemStyle').getItemStyle();
            var z2 = itemModel.get('z2');
            var color = (0, $csdCr.getVisualFromData)(seriesData, 'color');
            if (!style.fill) style.fill = color;
            mpData.setItemVisual(idx, {
                z2: (0, $2N6Uo.retrieve2)(z2, 0),
                symbol: symbol,
                symbolSize: symbolSize,
                symbolRotate: symbolRotate,
                symbolOffset: symbolOffset,
                symbolKeepAspect: symbolKeepAspect,
                style: style
            });
        });
        // TODO Text are wrong
        symbolDraw.updateData(mpData);
        this.group.add(symbolDraw.group);
        // Set host model for tooltip
        // FIXME
        mpData.eachItemGraphicEl(function(el) {
            el.traverse(function(child) {
                (0, $6TSUP.getECData)(child).dataModel = mpModel;
            });
        });
        this.markKeep(symbolDraw);
        symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
    };
    MarkPointView.type = 'markPoint';
    return MarkPointView;
}((0, $eDzDb.default));
function $857105080c1b0dbe$var$createData(coordSys, seriesModel, mpModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $2N6Uo.map)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $2N6Uo.extend)((0, $2N6Uo.extend)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var mpData = new (0, $2kN4z.default)(coordDimsInfos, mpModel);
    var dataOpt = (0, $2N6Uo.map)(mpModel.get('data'), (0, $2N6Uo.curry)($fj43b.dataTransform, seriesModel));
    if (coordSys) dataOpt = (0, $2N6Uo.filter)(dataOpt, (0, $2N6Uo.curry)($fj43b.dataFilter, coordSys));
    var dimValueGetter = $fj43b.createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
    mpData.initData(dataOpt, null, dimValueGetter);
    return mpData;
}
var $857105080c1b0dbe$export$2e2bcd8739ae039 = $857105080c1b0dbe$var$MarkPointView;

});


parcelRegister("flmBj", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $b2ba594078d2b4ed$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ekI9I = parcelRequire("ekI9I");

var $kFAN2 = parcelRequire("kFAN2");

var $cupBN = parcelRequire("cupBN");
function $b2ba594078d2b4ed$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $ekI9I.default));
    registers.registerComponentView((0, $kFAN2.default));
    registers.registerCoordinateSystem('matrix', (0, $cupBN.default));
}

});
parcelRegister("ekI9I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6f52f57760d61a5$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");

var $b8YKU = parcelRequire("b8YKU");

var $dBxh6 = parcelRequire("dBxh6");

var $jebHn = parcelRequire("jebHn");

var $6aXXD = parcelRequire("6aXXD");
var $a6f52f57760d61a5$var$defaultLabelOption = {
    show: true,
    color: (0, $6aXXD.default).color.secondary,
    // overflow: 'truncate',
    overflow: 'break',
    lineOverflow: 'truncate',
    padding: [
        2,
        3,
        2,
        3
    ],
    // Prefer to use `padding`, rather than distance.
    distance: 0
};
function $a6f52f57760d61a5$var$makeDefaultCellItemStyleOption(isCorner) {
    return {
        color: 'none',
        borderWidth: 1,
        borderColor: isCorner ? 'none' : (0, $6aXXD.default).color.borderTint
    };
}
var $a6f52f57760d61a5$var$defaultDimOption = {
    show: true,
    label: $a6f52f57760d61a5$var$defaultLabelOption,
    itemStyle: $a6f52f57760d61a5$var$makeDefaultCellItemStyleOption(false),
    silent: undefined,
    dividerLineStyle: {
        width: 1,
        color: (0, $6aXXD.default).color.border
    }
};
var $a6f52f57760d61a5$var$defaultBodyOption = {
    label: $a6f52f57760d61a5$var$defaultLabelOption,
    itemStyle: $a6f52f57760d61a5$var$makeDefaultCellItemStyleOption(false),
    silent: undefined
};
var $a6f52f57760d61a5$var$defaultCornerOption = {
    label: $a6f52f57760d61a5$var$defaultLabelOption,
    itemStyle: $a6f52f57760d61a5$var$makeDefaultCellItemStyleOption(true),
    silent: undefined
};
var $a6f52f57760d61a5$var$defaultMatrixOption = {
    // As a most basic coord sys, `z` should be lower than
    // other series and coord sys, such as, grid.
    z: -50,
    left: '10%',
    top: '10%',
    right: '10%',
    bottom: '10%',
    x: $a6f52f57760d61a5$var$defaultDimOption,
    y: $a6f52f57760d61a5$var$defaultDimOption,
    body: $a6f52f57760d61a5$var$defaultBodyOption,
    corner: $a6f52f57760d61a5$var$defaultCornerOption,
    backgroundStyle: {
        color: 'none',
        borderColor: (0, $6aXXD.default).color.axisLine,
        borderWidth: 1
    }
};
var $a6f52f57760d61a5$var$MatrixModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MatrixModel, _super);
    function MatrixModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MatrixModel.type;
        return _this;
    }
    MatrixModel.prototype.optionUpdated = function() {
        // Simply re-create all to follow model changes.
        var dimModels = this._dimModels = {
            // Do not use matrixModel as the parent model, for preventing from cascade-fetching options to it.
            x: new $a6f52f57760d61a5$export$f3b280f0e470ad1f(this.get('x', true) || {}),
            y: new $a6f52f57760d61a5$export$f3b280f0e470ad1f(this.get('y', true) || {})
        };
        dimModels.x.option.type = dimModels.y.option.type = 'category';
        var xDim = dimModels.x.dim = new (0, $dBxh6.MatrixDim)('x', dimModels.x);
        var yDim = dimModels.y.dim = new (0, $dBxh6.MatrixDim)('y', dimModels.y);
        var dims = {
            x: xDim,
            y: yDim
        };
        this._body = new (0, $jebHn.MatrixBodyCorner)('body', new (0, $b8YKU.default)(this.getShallow('body')), dims);
        this._corner = new (0, $jebHn.MatrixBodyCorner)('corner', new (0, $b8YKU.default)(this.getShallow('corner')), dims);
    };
    MatrixModel.prototype.getDimensionModel = function(dim) {
        return this._dimModels[dim];
    };
    MatrixModel.prototype.getBody = function() {
        return this._body;
    };
    MatrixModel.prototype.getCorner = function() {
        return this._corner;
    };
    MatrixModel.type = 'matrix';
    MatrixModel.layoutMode = 'box';
    MatrixModel.defaultOption = $a6f52f57760d61a5$var$defaultMatrixOption;
    return MatrixModel;
}((0, $eLD2b.default));
var $a6f52f57760d61a5$export$f3b280f0e470ad1f = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MatrixDimensionModel, _super);
    function MatrixDimensionModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatrixDimensionModel.prototype.getOrdinalMeta = function() {
        return this.dim.getOrdinalMeta();
    };
    return MatrixDimensionModel;
}((0, $b8YKU.default));
var $a6f52f57760d61a5$export$2e2bcd8739ae039 = $a6f52f57760d61a5$var$MatrixModel;

});
parcelRegister("dBxh6", function(module, exports) {

$parcel$export(module.exports, "MatrixDim", function () { return $9e788ac0c75614ff$export$1a8bd0fc6596656f; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $9KN3M = parcelRequire("9KN3M");

var $72H2h = parcelRequire("72H2h");

var $cpzWt = parcelRequire("cpzWt");

var $h9U3p = parcelRequire("h9U3p");

var $bx3T8 = parcelRequire("bx3T8");

var $fty47 = parcelRequire("fty47");


var $iCU10 = parcelRequire("iCU10");
/**
 * Lifetime: the same with `MatrixModel`, but different from `coord/Matrix`.
 */ var $9e788ac0c75614ff$export$1a8bd0fc6596656f = /** @class */ function() {
    function MatrixDim(dim, dimModel) {
        // Under the current definition, every leave corresponds a unit cell,
        // and leaves can serve as the locator of cells.
        // Therefore make sure:
        //  - The first `_leavesCount` elements in `_cells` are leaves.
        //  - `_cells[leaf.id[XY[this.dimIdx]]]` is the leaf itself.
        //  - Leaves of each subtree are placed together, that is, the leaves of a dimCell are:
        //    `this._cells.slice(dimCell.firstLeafLocator, dimCell.span[XY[this.dimIdx]])`
        this._cells = [];
        // Can be visited by `_levels[cell.level]` or `_levels[cell.id[1 - dimIdx] + _levels.length]`.
        // Items are never be null/undefined after initialized.
        this._levels = [];
        this.dim = dim;
        this.dimIdx = dim === 'x' ? 0 : 1;
        this._model = dimModel;
        this._uniqueValueGen = $9e788ac0c75614ff$var$createUniqueValueGenerator(dim);
        var dimModelData = dimModel.get('data', true);
        if (dimModelData != null && !(0, $2N6Uo.isArray)(dimModelData)) dimModelData = [];
        if (dimModelData) this._initByDimModelData(dimModelData);
        else this._initBySeriesData();
    }
    MatrixDim.prototype._initByDimModelData = function(dimModelData) {
        var self = this;
        var _cells = self._cells;
        var _levels = self._levels;
        var sameLocatorCellsLists = []; // Save for sorting.
        var _cellCount = 0;
        self._leavesCount = traverseInitCells(dimModelData, 0, 0);
        postInitCells();
        return;
        function traverseInitCells(dimModelData, firstLeafLocator, level) {
            var totalSpan = 0;
            if (!dimModelData) return totalSpan;
            (0, $2N6Uo.each)(dimModelData, function(option, optionIdx) {
                var invalidOption = false;
                var cellOption;
                if ((0, $2N6Uo.isString)(option)) cellOption = {
                    value: option
                };
                else if ((0, $2N6Uo.isObject)(option)) {
                    cellOption = option;
                    if (option.value != null && !(0, $2N6Uo.isString)(option.value)) {
                        invalidOption = true;
                        cellOption = {
                            value: null
                        };
                    }
                } else {
                    cellOption = {
                        value: null
                    };
                    if (option != null) invalidOption = true;
                }
                invalidOption;
                var cell = {
                    type: (0, $fty47.MatrixCellLayoutInfoType).nonLeaf,
                    ordinal: NaN,
                    level: level,
                    firstLeafLocator: firstLeafLocator,
                    id: new (0, $9KN3M.default)(),
                    span: (0, $fty47.setDimXYValue)(new (0, $9KN3M.default)(), self.dimIdx, 1, 1),
                    option: cellOption,
                    xy: NaN,
                    wh: NaN,
                    dim: self,
                    rect: (0, $fty47.createNaNRectLike)()
                };
                _cellCount++;
                (sameLocatorCellsLists[firstLeafLocator] || (sameLocatorCellsLists[firstLeafLocator] = [])).push(cell);
                if (!_levels[level]) // Create a level only if at least one cell exists.
                _levels[level] = {
                    type: (0, $fty47.MatrixCellLayoutInfoType).level,
                    xy: NaN,
                    wh: NaN,
                    option: null,
                    id: new (0, $9KN3M.default)(),
                    dim: self
                };
                var childrenSpan = traverseInitCells(cellOption.children, firstLeafLocator, level + 1);
                var subSpan = Math.max(1, childrenSpan);
                cell.span[(0, $h9U3p.XY)[self.dimIdx]] = subSpan;
                totalSpan += subSpan;
                firstLeafLocator += subSpan;
            });
            return totalSpan;
        }
        function postInitCells() {
            // Sort to make sure the leaves are at the beginning, so that
            // they can be used as the locator of body cells.
            var categories = [];
            while(_cells.length < _cellCount)for(var locator = 0; locator < sameLocatorCellsLists.length; locator++){
                var cell = sameLocatorCellsLists[locator].pop();
                if (cell) {
                    cell.ordinal = categories.length;
                    var val = cell.option.value;
                    categories.push(val);
                    _cells.push(cell);
                    self._uniqueValueGen.calcDupBase(val);
                }
            }
            self._uniqueValueGen.ensureValueUnique(categories, _cells);
            var ordinalMeta = self._ordinalMeta = new (0, $72H2h.default)({
                categories: categories,
                needCollect: false,
                deduplication: false
            });
            self._scale = new (0, $cpzWt.default)({
                ordinalMeta: ordinalMeta
            });
            for(var idx = 0; idx < self._leavesCount; idx++){
                var leaf = self._cells[idx];
                leaf.type = (0, $fty47.MatrixCellLayoutInfoType).leaf;
                // Handle the tree level variation: enlarge the span of the leaves to reach the body cells.
                leaf.span[(0, $h9U3p.XY)[1 - self.dimIdx]] = self._levels.length - leaf.level;
            }
            self._initCellsId();
            self._initLevelIdOptions();
        }
    };
    MatrixDim.prototype._initBySeriesData = function() {
        var self = this;
        self._leavesCount = 0;
        self._levels = [
            {
                type: (0, $fty47.MatrixCellLayoutInfoType).level,
                xy: NaN,
                wh: NaN,
                option: null,
                id: new (0, $9KN3M.default)(),
                dim: self
            }
        ];
        self._initLevelIdOptions();
        var ordinalMeta = self._ordinalMeta = new (0, $72H2h.default)({
            needCollect: true,
            deduplication: true,
            onCollect: function(value, ordinalNumber) {
                var cell = self._cells[ordinalNumber] = {
                    type: (0, $fty47.MatrixCellLayoutInfoType).leaf,
                    ordinal: ordinalNumber,
                    level: 0,
                    firstLeafLocator: ordinalNumber,
                    id: new (0, $9KN3M.default)(),
                    span: (0, $fty47.setDimXYValue)(new (0, $9KN3M.default)(), self.dimIdx, 1, 1),
                    // Theoretically `value` is from `dataset` or `series.data`, so it may be any type.
                    // Do not restrict this case for user's convenience, and here simply convert it to
                    // string for display.
                    option: {
                        value: value + ''
                    },
                    xy: NaN,
                    wh: NaN,
                    dim: self,
                    rect: (0, $fty47.createNaNRectLike)()
                };
                self._leavesCount++;
                self._setCellId(cell);
            }
        });
        self._scale = new (0, $cpzWt.default)({
            ordinalMeta: ordinalMeta
        });
    };
    MatrixDim.prototype._setCellId = function(cell) {
        var levelsLen = this._levels.length;
        var dimIdx = this.dimIdx;
        (0, $fty47.setDimXYValue)(cell.id, dimIdx, cell.firstLeafLocator, cell.level - levelsLen);
    };
    MatrixDim.prototype._initCellsId = function() {
        var levelsLen = this._levels.length;
        var dimIdx = this.dimIdx;
        (0, $2N6Uo.each)(this._cells, function(cell) {
            (0, $fty47.setDimXYValue)(cell.id, dimIdx, cell.firstLeafLocator, cell.level - levelsLen);
        });
    };
    MatrixDim.prototype._initLevelIdOptions = function() {
        var levelsLen = this._levels.length;
        var dimIdx = this.dimIdx;
        var levelOptionList = this._model.get('levels', true);
        levelOptionList = (0, $2N6Uo.isArray)(levelOptionList) ? levelOptionList : [];
        (0, $2N6Uo.each)(this._levels, function(levelCfg, level) {
            (0, $fty47.setDimXYValue)(levelCfg.id, dimIdx, 0, level - levelsLen);
            levelCfg.option = levelOptionList[level];
        });
    };
    MatrixDim.prototype.shouldShow = function() {
        return !!this._model.getShallow('show', true);
    };
    /**
   * Iterate leaves (they are layout units) if dimIdx === this.dimIdx.
   * Iterate levels if dimIdx !== this.dimIdx.
   */ MatrixDim.prototype.resetLayoutIterator = function(it, dimIdx, startLocator, count) {
        it = it || new (0, $bx3T8.ListIterator)();
        if (dimIdx === this.dimIdx) {
            var len = this._leavesCount;
            var startIdx = startLocator != null ? Math.max(0, startLocator) : 0;
            count = count != null ? Math.min(count, len) : len;
            it.reset(this._cells, startIdx, startIdx + count);
        } else {
            var len = this._levels.length;
            // Corner locator is from `-this._levels.length` to `-1`.
            var startIdx = startLocator != null ? Math.max(0, startLocator + len) : 0;
            count = count != null ? Math.min(count, len) : len;
            it.reset(this._levels, startIdx, startIdx + count);
        }
        return it;
    };
    MatrixDim.prototype.resetCellIterator = function(it) {
        return (it || new (0, $bx3T8.ListIterator)()).reset(this._cells, 0);
    };
    MatrixDim.prototype.resetLevelIterator = function(it) {
        return (it || new (0, $bx3T8.ListIterator)()).reset(this._levels, 0);
    };
    MatrixDim.prototype.getLayout = function(outRect, dimIdx, locator) {
        var layout = this.getUnitLayoutInfo(dimIdx, locator);
        outRect[(0, $h9U3p.XY)[dimIdx]] = layout ? layout.xy : NaN;
        outRect[(0, $h9U3p.WH)[dimIdx]] = layout ? layout.wh : NaN;
    };
    /**
   * Get leaf cell or get level info.
   * Should be able to return null/undefined if not found on x or y, thus input `dimIdx` is needed.
   */ MatrixDim.prototype.getUnitLayoutInfo = function(dimIdx, locator) {
        return dimIdx === this.dimIdx ? locator < this._leavesCount ? this._cells[locator] : undefined : this._levels[locator + this._levels.length];
    };
    /**
   * Get dimension cell by data, including leaves and non-leaves.
   */ MatrixDim.prototype.getCell = function(value) {
        var ordinal = this._scale.parse(value);
        return (0, $2N6Uo.eqNaN)(ordinal) ? undefined : this._cells[ordinal];
    };
    /**
   * Get leaf count or get level count.
   */ MatrixDim.prototype.getLocatorCount = function(dimIdx) {
        return dimIdx === this.dimIdx ? this._leavesCount : this._levels.length;
    };
    MatrixDim.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    return MatrixDim;
}();
function $9e788ac0c75614ff$var$createUniqueValueGenerator(dim) {
    var dimUpper = dim.toUpperCase();
    var defaultValReg = new RegExp("^" + dimUpper + "([0-9]+)$");
    var dupBase = 0;
    function calcDupBase(val) {
        var matchResult;
        if (val != null && (matchResult = val.match(defaultValReg))) dupBase = (0, $iCU10.mathMax)(dupBase, +matchResult[1] + 1);
    }
    function makeUniqueValue() {
        return "" + dimUpper + dupBase++;
    }
    // Duplicated value is allowed, because the `matrix.x/y.data` can be a tree and it's reasonable
    // that leaves in different subtrees has the same text. But only the first one is allowed to be
    // queried by the text, and the other ones can only be queried by index.
    // Additionally, `matrix.x/y.data: [null, null, ...]` is allowed.
    function ensureValueUnique(categories, cells) {
        // A simple way to deduplicate or handle illegal or not specified values to avoid unexpected behaviors.
        // The tree structure should not be broken even if duplicated.
        var cateMap = (0, $2N6Uo.createHashMap)();
        for(var idx = 0; idx < categories.length; idx++){
            var value = categories[idx];
            // value may be set to NullUndefined by users or if illegal.
            if (value == null || cateMap.get(value) != null) {
                // Still display the original option.value if duplicated, but loose the ability to query by text.
                categories[idx] = value = makeUniqueValue();
                cells[idx].option = (0, $2N6Uo.defaults)({
                    value: value
                }, cells[idx].option);
            }
            cateMap.set(value, true);
        }
    }
    return {
        calcDupBase: calcDupBase,
        ensureValueUnique: ensureValueUnique
    };
}

});
parcelRegister("fty47", function(module, exports) {

$parcel$export(module.exports, "MatrixCellLayoutInfoType", function () { return $b443fd1e0b7c23c8$export$e605ddc25c355f0b; });
$parcel$export(module.exports, "MatrixClampOption", function () { return $b443fd1e0b7c23c8$export$f6f60f1901b7a690; });
$parcel$export(module.exports, "resetXYLocatorRange", function () { return $b443fd1e0b7c23c8$export$7083aa8e2f333744; });
$parcel$export(module.exports, "parseCoordRangeOption", function () { return $b443fd1e0b7c23c8$export$1dc03edb4e724e02; });
$parcel$export(module.exports, "isXYLocatorRangeInvalidOnDim", function () { return $b443fd1e0b7c23c8$export$6f30d23446b696e5; });
$parcel$export(module.exports, "resolveXYLocatorRangeByCellMerge", function () { return $b443fd1e0b7c23c8$export$e83f541b68a414bd; });
$parcel$export(module.exports, "fillIdSpanFromLocatorRange", function () { return $b443fd1e0b7c23c8$export$af43ef7117c4b8ed; });
$parcel$export(module.exports, "cloneXYLocatorRange", function () { return $b443fd1e0b7c23c8$export$1939176e25597afc; });
$parcel$export(module.exports, "xyLocatorRangeToRectOneDim", function () { return $b443fd1e0b7c23c8$export$209b48cb1590c2e6; });
$parcel$export(module.exports, "setDimXYValue", function () { return $b443fd1e0b7c23c8$export$4c9247b5137873ac; });
$parcel$export(module.exports, "createNaNRectLike", function () { return $b443fd1e0b7c23c8$export$97431b409739b7a9; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");

var $iCU10 = parcelRequire("iCU10");
var $b443fd1e0b7c23c8$export$e605ddc25c355f0b = {
    level: 1,
    leaf: 2,
    nonLeaf: 3
};
var $b443fd1e0b7c23c8$export$f6f60f1901b7a690 = {
    // No clamp, be falsy, equals to null/undefined. It means if the input part is
    // null/undefined/NaN/outOfBoundary, the result part is NaN, rather than clamp to
    // the boundary of the matrix.
    none: 0,
    // Clamp, where null/undefined/NaN/outOfBoundary can be used to cover the entire row/column.
    all: 1,
    body: 2,
    corner: 3
};
function $b443fd1e0b7c23c8$export$7b1fafd1ec24d455(coordValue, dims, thisDimIdx // 0 | 1
) {
    // Find in body.
    var result = dims[(0, $h9U3p.XY)[thisDimIdx]].getCell(coordValue);
    // Find in corner or dimension area.
    if (!result && (0, $2N6Uo.isNumber)(coordValue) && coordValue < 0) result = dims[(0, $h9U3p.XY)[1 - thisDimIdx]].getUnitLayoutInfo(thisDimIdx, Math.round(coordValue));
    return result;
}
function $b443fd1e0b7c23c8$export$7083aa8e2f333744(out) {
    var rg = out || [];
    rg[0] = rg[0] || [];
    rg[1] = rg[1] || [];
    rg[0][0] = rg[0][1] = rg[1][0] = rg[1][1] = NaN;
    return rg;
}
function $b443fd1e0b7c23c8$export$1dc03edb4e724e02(locOut, // If illegal input or can not find any target, save reason to it.
// Do nothing if `NullUndefined`.
reasonOut, data, dims, clamp) {
    // x and y are supported to be handled separately - if one dimension is invalid
    // (may be users do not need that), the other one should also be calculated.
    $b443fd1e0b7c23c8$var$parseCoordRangeOptionOnOneDim(locOut[0], reasonOut, clamp, data, dims, 0);
    $b443fd1e0b7c23c8$var$parseCoordRangeOptionOnOneDim(locOut[1], reasonOut, clamp, data, dims, 1);
}
function $b443fd1e0b7c23c8$var$parseCoordRangeOptionOnOneDim(locDimOut, reasonOut, clamp, data, dims, dimIdx) {
    locDimOut[0] = Infinity;
    locDimOut[1] = -Infinity;
    var dataOnDim = data[dimIdx];
    var coordValArr = (0, $2N6Uo.isArray)(dataOnDim) ? dataOnDim : [
        dataOnDim
    ];
    var len = coordValArr.length;
    var hasClamp = !!clamp;
    if (len >= 1) {
        $b443fd1e0b7c23c8$var$parseCoordRangeOptionOnOneDimOnePart(locDimOut, reasonOut, coordValArr, hasClamp, dims, dimIdx, 0);
        if (len > 1) // Users may intuitively input the coords like `[[x1, x2, x3], ...]`;
        // consider the range as `[x1, x3]` in this case.
        $b443fd1e0b7c23c8$var$parseCoordRangeOptionOnOneDimOnePart(locDimOut, reasonOut, coordValArr, hasClamp, dims, dimIdx, len - 1);
    } else locDimOut[0] = locDimOut[1] = NaN;
    if (hasClamp) {
        // null/undefined/NaN or illegal data represents the entire row/column;
        // Cover the entire locator regardless of body or corner, and confine it later.
        var locLowerBound = -dims[(0, $h9U3p.XY)[1 - dimIdx]].getLocatorCount(dimIdx);
        var locUpperBound = dims[(0, $h9U3p.XY)[dimIdx]].getLocatorCount(dimIdx) - 1;
        if (clamp === $b443fd1e0b7c23c8$export$f6f60f1901b7a690.body) locLowerBound = (0, $iCU10.mathMax)(0, locLowerBound);
        else if (clamp === $b443fd1e0b7c23c8$export$f6f60f1901b7a690.corner) locUpperBound = (0, $iCU10.mathMin)(-1, locUpperBound);
        if (locUpperBound < locLowerBound) // Also considered that both x and y has no cell.
        locLowerBound = locUpperBound = NaN;
        if ((0, $2N6Uo.eqNaN)(locDimOut[0])) locDimOut[0] = locLowerBound;
        if ((0, $2N6Uo.eqNaN)(locDimOut[1])) locDimOut[1] = locUpperBound;
        locDimOut[0] = (0, $iCU10.mathMax)((0, $iCU10.mathMin)(locDimOut[0], locUpperBound), locLowerBound);
        locDimOut[1] = (0, $iCU10.mathMax)((0, $iCU10.mathMin)(locDimOut[1], locUpperBound), locLowerBound);
    }
}
// The return val must be finite or NaN.
function $b443fd1e0b7c23c8$var$parseCoordRangeOptionOnOneDimOnePart(locDimOut, reasonOut, coordValArr, hasClamp, dims, dimIdx, partIdx) {
    var layout = $b443fd1e0b7c23c8$export$7b1fafd1ec24d455(coordValArr[partIdx], dims, dimIdx);
    if (!layout) {
        locDimOut[0] = locDimOut[1] = NaN;
        return;
    }
    var locatorA = layout.id[(0, $h9U3p.XY)[dimIdx]];
    var locatorB = locatorA;
    var dimCell = $b443fd1e0b7c23c8$var$cellLayoutInfoToDimCell(layout);
    if (dimCell) // Handle non-leaf
    locatorB += dimCell.span[(0, $h9U3p.XY)[dimIdx]] - 1;
    locDimOut[0] = (0, $iCU10.mathMin)(locDimOut[0], locatorA, locatorB);
    locDimOut[1] = (0, $iCU10.mathMax)(locDimOut[1], locatorA, locatorB);
}
function $b443fd1e0b7c23c8$export$6f30d23446b696e5(locatorRange, dimIdx) {
    return (0, $2N6Uo.eqNaN)(locatorRange[dimIdx][0]) || (0, $2N6Uo.eqNaN)(locatorRange[dimIdx][1]);
}
function $b443fd1e0b7c23c8$export$e83f541b68a414bd(inOutLocatorRange, // Item indices coorespond to mergeDefList (len: mergeDefListTravelLen).
// Indicating whether each item has be merged into the `locatorRange`
outMergedMarkList, mergeDefList, mergeDefListTravelLen) {
    outMergedMarkList = outMergedMarkList || $b443fd1e0b7c23c8$var$_tmpOutMergedMarkList;
    for(var idx = 0; idx < mergeDefListTravelLen; idx++)outMergedMarkList[idx] = false;
    // In most case, cell merging definition list length is smaller than the range extent,
    // therefore, to detection intersection, travelling cell merging definition list is probably
    // performant than traveling the four edges of the rect formed by the locator range.
    while(true){
        var expanded = false;
        for(var idx = 0; idx < mergeDefListTravelLen; idx++){
            var mergeDef = mergeDefList[idx];
            if (!outMergedMarkList[idx] && mergeDef.cellMergeOwner && $b443fd1e0b7c23c8$var$expandXYLocatorRangeIfIntersect(inOutLocatorRange, mergeDef.locatorRange)) {
                outMergedMarkList[idx] = true;
                expanded = true;
            }
        }
        if (!expanded) break;
    }
}
var $b443fd1e0b7c23c8$var$_tmpOutMergedMarkList = [];
// Return whether intersect.
// `thisLocRange` will be expanded (modified) if an intersection is encountered.
function $b443fd1e0b7c23c8$var$expandXYLocatorRangeIfIntersect(thisLocRange, otherLocRange) {
    if (!$b443fd1e0b7c23c8$var$locatorRangeIntersectOneDim(thisLocRange[0], otherLocRange[0]) || !$b443fd1e0b7c23c8$var$locatorRangeIntersectOneDim(thisLocRange[1], otherLocRange[1])) return false;
    thisLocRange[0][0] = (0, $iCU10.mathMin)(thisLocRange[0][0], otherLocRange[0][0]);
    thisLocRange[0][1] = (0, $iCU10.mathMax)(thisLocRange[0][1], otherLocRange[0][1]);
    thisLocRange[1][0] = (0, $iCU10.mathMin)(thisLocRange[1][0], otherLocRange[1][0]);
    thisLocRange[1][1] = (0, $iCU10.mathMax)(thisLocRange[1][1], otherLocRange[1][1]);
    return true;
}
// Notice: If containing NaN, not intersect.
function $b443fd1e0b7c23c8$var$locatorRangeIntersectOneDim(locRange1OneDim, locRange2OneDim) {
    return locRange1OneDim[1] >= locRange2OneDim[0] && locRange1OneDim[0] <= locRange2OneDim[1];
}
function $b443fd1e0b7c23c8$export$af43ef7117c4b8ed(owner, locatorRange) {
    owner.id.set(locatorRange[0][0], locatorRange[1][0]);
    owner.span.set(locatorRange[0][1] - owner.id.x + 1, locatorRange[1][1] - owner.id.y + 1);
}
function $b443fd1e0b7c23c8$export$1939176e25597afc(target, source) {
    target[0][0] = source[0][0];
    target[0][1] = source[0][1];
    target[1][0] = source[1][0];
    target[1][1] = source[1][1];
}
function $b443fd1e0b7c23c8$export$209b48cb1590c2e6(oneDimOut, locRange, dims, dimIdx) {
    var layoutMin = $b443fd1e0b7c23c8$export$7b1fafd1ec24d455(locRange[dimIdx][0], dims, dimIdx);
    var layoutMax = $b443fd1e0b7c23c8$export$7b1fafd1ec24d455(locRange[dimIdx][1], dims, dimIdx);
    oneDimOut[(0, $h9U3p.XY)[dimIdx]] = oneDimOut[(0, $h9U3p.WH)[dimIdx]] = NaN;
    if (layoutMin && layoutMax) {
        oneDimOut[(0, $h9U3p.XY)[dimIdx]] = layoutMin.xy;
        oneDimOut[(0, $h9U3p.WH)[dimIdx]] = layoutMax.xy + layoutMax.wh - layoutMin.xy;
    }
}
function $b443fd1e0b7c23c8$export$4c9247b5137873ac(out, dimIdx, // 0 | 1
valueOnThisDim, valueOnOtherDim) {
    out[(0, $h9U3p.XY)[dimIdx]] = valueOnThisDim;
    out[(0, $h9U3p.XY)[1 - dimIdx]] = valueOnOtherDim;
    return out;
}
/**
 * Return NullUndefined if not dimension cell.
 */ function $b443fd1e0b7c23c8$var$cellLayoutInfoToDimCell(cellLayoutInfo) {
    return cellLayoutInfo && (cellLayoutInfo.type === $b443fd1e0b7c23c8$export$e605ddc25c355f0b.leaf || cellLayoutInfo.type === $b443fd1e0b7c23c8$export$e605ddc25c355f0b.nonLeaf) ? cellLayoutInfo : null;
}
function $b443fd1e0b7c23c8$export$97431b409739b7a9() {
    return {
        x: NaN,
        y: NaN,
        width: NaN,
        height: NaN
    };
}

});


parcelRegister("jebHn", function(module, exports) {

$parcel$export(module.exports, "MatrixBodyCorner", function () { return $dff8663969b262f1$export$4a91097e7bc6c9d0; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");


var $9KN3M = parcelRequire("9KN3M");

var $fty47 = parcelRequire("fty47");
/**
 * Lifetime: the same with `MatrixModel`, but different from `coord/Matrix`.
 */ var $dff8663969b262f1$export$4a91097e7bc6c9d0 = /** @class */ function() {
    function MatrixBodyCorner(kind, bodyOrCornerModel, dims) {
        this._model = bodyOrCornerModel;
        this._dims = dims;
        this._kind = kind;
        this._cellMergeOwnerList = [];
    }
    /**
   * Can not be called before series models initialization finished, since the ordinalMeta may
   * use collect the values from `series.data` in series initialization.
   */ MatrixBodyCorner.prototype._ensureCellMap = function() {
        var self = this;
        var _cellMap = self._cellMap;
        if (!_cellMap) {
            _cellMap = self._cellMap = (0, $2N6Uo.createHashMap)();
            fillCellMap();
        }
        return _cellMap;
        function fillCellMap() {
            var parsedList = [];
            var cellOptionList = self._model.getShallow('data');
            if (cellOptionList && !(0, $2N6Uo.isArray)(cellOptionList)) cellOptionList = null;
            (0, $2N6Uo.each)(cellOptionList, function(option, idx) {
                if (!(0, $2N6Uo.isObject)(option) || !(0, $2N6Uo.isArray)(option.coord)) return;
                var locatorRange = (0, $fty47.resetXYLocatorRange)([]);
                var reasonArr = null;
                (0, $fty47.parseCoordRangeOption)(locatorRange, reasonArr, option.coord, self._dims, option.coordClamp ? (0, $fty47.MatrixClampOption)[self._kind] : (0, $fty47.MatrixClampOption).none);
                if ((0, $fty47.isXYLocatorRangeInvalidOnDim)(locatorRange, 0) || (0, $fty47.isXYLocatorRangeInvalidOnDim)(locatorRange, 1)) return;
                var cellMergeOwner = option && option.mergeCells;
                var parsed = {
                    id: new (0, $9KN3M.default)(),
                    span: new (0, $9KN3M.default)(),
                    locatorRange: locatorRange,
                    option: option,
                    cellMergeOwner: cellMergeOwner
                };
                (0, $fty47.fillIdSpanFromLocatorRange)(parsed, locatorRange);
                // The order of the `parsedList` determines the precedence of the styles, if there
                // are overlaps between ranges specified in different items. Preserve the original
                // order of `matrix.body/corner/data` to make it predictable for users.
                parsedList.push(parsed);
            });
            // Resolve cell merging intersection - union to a larger rect.
            var mergedMarkList = [];
            for(var parsedIdx = 0; parsedIdx < parsedList.length; parsedIdx++){
                var parsed = parsedList[parsedIdx];
                if (!parsed.cellMergeOwner) continue;
                var locatorRange = parsed.locatorRange;
                (0, $fty47.resolveXYLocatorRangeByCellMerge)(locatorRange, mergedMarkList, parsedList, parsedIdx);
                for(var idx = 0; idx < parsedIdx; idx++)if (mergedMarkList[idx]) parsedList[idx].cellMergeOwner = false;
                if (locatorRange[0][0] !== parsed.id.x || locatorRange[1][0] !== parsed.id.y) {
                    // The top-left cell of the unioned locatorRange is not this cell any more.
                    parsed.cellMergeOwner = false;
                    // Reconcile: simply use the last style and value option if multiple styles involved
                    // in a merged area, since there might be no commonly used merge strategy.
                    var newOption = (0, $2N6Uo.extend)({}, parsed.option);
                    newOption.coord = null;
                    var newParsed = {
                        id: new (0, $9KN3M.default)(),
                        span: new (0, $9KN3M.default)(),
                        locatorRange: locatorRange,
                        option: newOption,
                        cellMergeOwner: true
                    };
                    (0, $fty47.fillIdSpanFromLocatorRange)(newParsed, locatorRange);
                    parsedList.push(newParsed);
                }
            }
            // Assign options to cells.
            (0, $2N6Uo.each)(parsedList, function(parsed) {
                var topLeftCell = ensureBodyOrCornerCell(parsed.id.x, parsed.id.y);
                if (parsed.cellMergeOwner) {
                    topLeftCell.cellMergeOwner = true;
                    topLeftCell.span = parsed.span;
                    topLeftCell.locatorRange = parsed.locatorRange;
                    topLeftCell.spanRect = (0, $fty47.createNaNRectLike)();
                    self._cellMergeOwnerList.push(topLeftCell);
                }
                if (!parsed.cellMergeOwner && !parsed.option) return;
                for(var yidx = 0; yidx < parsed.span.y; yidx++)for(var xidx = 0; xidx < parsed.span.x; xidx++){
                    var cell = ensureBodyOrCornerCell(parsed.id.x + xidx, parsed.id.y + yidx);
                    // If multiple style options are defined on a cell, the later ones takes precedence.
                    cell.option = parsed.option;
                    if (parsed.cellMergeOwner) cell.inSpanOf = topLeftCell;
                }
            });
        } // End of fillCellMap
        function ensureBodyOrCornerCell(x, y) {
            var key = $dff8663969b262f1$var$makeCellMapKey(x, y);
            var cell = _cellMap.get(key);
            if (!cell) cell = _cellMap.set(key, {
                id: new (0, $9KN3M.default)(x, y),
                option: null,
                inSpanOf: null,
                span: null,
                spanRect: null,
                locatorRange: null,
                cellMergeOwner: false
            });
            return cell;
        }
    };
    /**
   * Body cells or corner cell are not commonly defined specifically, especially in a large
   * table, thus his is a sparse data structure - bodys or corner cells exist only if there
   * are options specified to it (in `matrix.body.data` or `matrix.corner.data`);
   * otherwise, return `NullUndefined`.
   */ MatrixBodyCorner.prototype.getCell = function(xy) {
        // Assert xy do not contain NaN
        return this._ensureCellMap().get($dff8663969b262f1$var$makeCellMapKey(xy[0], xy[1]));
    };
    /**
   * Only cell existing (has specific definition or props) will be travelled.
   */ MatrixBodyCorner.prototype.travelExistingCells = function(cb) {
        this._ensureCellMap().each(cb);
    };
    /**
   * @param locatorRange Must be the return of `parseCoordRangeOption`.
   */ MatrixBodyCorner.prototype.expandRangeByCellMerge = function(locatorRange) {
        if (!(0, $fty47.isXYLocatorRangeInvalidOnDim)(locatorRange, 0) && !(0, $fty47.isXYLocatorRangeInvalidOnDim)(locatorRange, 1) && locatorRange[0][0] === locatorRange[0][1] && locatorRange[1][0] === locatorRange[1][1]) {
            // If it locates to a single cell, use this quick path to avoid travelling.
            // It is based on the fact that any cell is not contained by more than one cell merging rect.
            $dff8663969b262f1$var$_tmpERBCMLocator[0] = locatorRange[0][0];
            $dff8663969b262f1$var$_tmpERBCMLocator[1] = locatorRange[1][0];
            var cell = this.getCell($dff8663969b262f1$var$_tmpERBCMLocator);
            var inSpanOf = cell && cell.inSpanOf;
            if (inSpanOf) {
                (0, $fty47.cloneXYLocatorRange)(locatorRange, inSpanOf.locatorRange);
                return;
            }
        }
        var list = this._cellMergeOwnerList;
        (0, $fty47.resolveXYLocatorRangeByCellMerge)(locatorRange, null, list, list.length);
    };
    return MatrixBodyCorner;
}();
var $dff8663969b262f1$var$_tmpERBCMLocator = [];
function $dff8663969b262f1$var$makeCellMapKey(x, y) {
    return x + "|" + y;
}

});


parcelRegister("kFAN2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0c42cb5cd561c6c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $bpyST = parcelRequire("bpyST");

var $b8YKU = parcelRequire("b8YKU");

var $67W72 = parcelRequire("67W72");

var $U1aqY = parcelRequire("U1aqY");

var $fcwet = parcelRequire("fcwet");

var $h9U3p = parcelRequire("h9U3p");
var $c3CaY = parcelRequire("c3CaY");
var $aH2k0 = parcelRequire("aH2k0");

var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $19Ywy = parcelRequire("19Ywy");

var $bysmE = parcelRequire("bysmE");
var $f0c42cb5cd561c6c$var$round = Math.round;
var $f0c42cb5cd561c6c$var$Z2_BACKGROUND = 0;
var $f0c42cb5cd561c6c$var$Z2_OUTER_BORDER = 99;
var $f0c42cb5cd561c6c$var$Z2_BODY_CORNER_CELL_DEFAULT = {
    normal: 25,
    special: 100
};
var $f0c42cb5cd561c6c$var$Z2_DIMENSION_CELL_DEFAULT = {
    normal: 50,
    special: 125
};
var $f0c42cb5cd561c6c$var$MatrixView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MatrixView, _super);
    function MatrixView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MatrixView.type;
        return _this;
    }
    MatrixView.prototype.render = function(matrixModel, ecModel) {
        this.group.removeAll();
        var group = this.group;
        var coordSys = matrixModel.coordinateSystem;
        var rect = coordSys.getRect();
        var xDimModel = matrixModel.getDimensionModel('x');
        var yDimModel = matrixModel.getDimensionModel('y');
        var xDim = xDimModel.dim;
        var yDim = yDimModel.dim;
        // PENDING:
        //  reuse the existing text and rect elements for performance?
        $f0c42cb5cd561c6c$var$renderDimensionCells(group, matrixModel, ecModel);
        $f0c42cb5cd561c6c$var$createBodyAndCorner(group, matrixModel, xDim, yDim, ecModel);
        var borderZ2Option = matrixModel.getShallow('borderZ2', true);
        var outerBorderZ2 = (0, $2N6Uo.retrieve2)(borderZ2Option, $f0c42cb5cd561c6c$var$Z2_OUTER_BORDER);
        var dividerLineZ2 = outerBorderZ2 - 1;
        // Outer border and overall background. Use separate elements because of z-order:
        // The overall background should appear below any other elements.
        // But in most cases, the outer border and the divider line should be above the normal cell borders -
        // especially when cell borders have different colors. But users may highlight some specific cells by
        // overstirking their border, in which case it should be above the outer border.
        var bgStyle = matrixModel.getModel('backgroundStyle').getItemStyle([
            'borderWidth'
        ]);
        bgStyle.lineWidth = 0;
        var borderStyle = matrixModel.getModel('backgroundStyle').getItemStyle([
            'color',
            'decal',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ]);
        borderStyle.fill = 'none';
        var bgRect = $f0c42cb5cd561c6c$var$createMatrixRect(rect.clone(), bgStyle, $f0c42cb5cd561c6c$var$Z2_BACKGROUND);
        var borderRect = $f0c42cb5cd561c6c$var$createMatrixRect(rect.clone(), borderStyle, outerBorderZ2);
        bgRect.silent = true;
        borderRect.silent = true;
        group.add(bgRect);
        group.add(borderRect);
        // Header split line.
        var xDimCell0 = xDim.getUnitLayoutInfo(0, 0);
        var yDimCell0 = yDim.getUnitLayoutInfo(1, 0);
        if (xDimCell0 && yDimCell0) {
            if (xDim.shouldShow()) group.add($f0c42cb5cd561c6c$var$createMatrixLine({
                x1: rect.x,
                y1: yDimCell0.xy,
                x2: rect.x + rect.width,
                y2: yDimCell0.xy
            }, xDimModel.getModel('dividerLineStyle').getLineStyle(), dividerLineZ2));
            if (yDim.shouldShow()) group.add($f0c42cb5cd561c6c$var$createMatrixLine({
                x1: xDimCell0.xy,
                y1: rect.y,
                x2: xDimCell0.xy,
                y2: rect.y + rect.height
            }, yDimModel.getModel('dividerLineStyle').getLineStyle(), dividerLineZ2));
        }
    };
    MatrixView.type = 'matrix';
    return MatrixView;
}((0, $bpyST.default));
function $f0c42cb5cd561c6c$var$renderDimensionCells(group, matrixModel, ecModel) {
    renderOnDimension(0);
    renderOnDimension(1);
    function renderOnDimension(dimIdx) {
        var thisDimModel = matrixModel.getDimensionModel((0, $h9U3p.XY)[dimIdx]);
        var thisDim = thisDimModel.dim;
        if (!thisDim.shouldShow()) return;
        var thisDimBgStyleModel = thisDimModel.getModel('itemStyle');
        var thisDimLabelModel = thisDimModel.getModel('label');
        var tooltipOption = matrixModel.getShallow('tooltip', true);
        var xyLocator = [];
        for(var it_1 = thisDim.resetCellIterator(); it_1.next();){
            var dimCell = it_1.item;
            var shape = {};
            (0, $67W72.default).copy(shape, dimCell.rect);
            $U1aqY.set(xyLocator, dimCell.id.x, dimCell.id.y);
            $f0c42cb5cd561c6c$var$createMatrixCell(xyLocator, matrixModel, group, ecModel, dimCell.option, thisDimBgStyleModel, thisDimLabelModel, thisDimModel, shape, dimCell.option.value, $f0c42cb5cd561c6c$var$Z2_DIMENSION_CELL_DEFAULT, tooltipOption);
        }
    }
}
function $f0c42cb5cd561c6c$var$createBodyAndCorner(group, matrixModel, xDim, yDim, ecModel) {
    createBodyOrCornerCells('body', matrixModel.getBody(), xDim, yDim);
    if (xDim.shouldShow() && yDim.shouldShow()) createBodyOrCornerCells('corner', matrixModel.getCorner(), yDim, xDim);
    function createBodyOrCornerCells(bodyCornerOptionRoot, bodyOrCorner, dimForCoordX, // Can be `matrix.y` (transposed) for corners.
    dimForCoordY) {
        // Prevent inheriting from ancestor.
        var parentCellModel = new (0, $b8YKU.default)(matrixModel.getShallow(bodyCornerOptionRoot, true));
        var parentItemStyleModel = parentCellModel.getModel('itemStyle');
        var parentLabelModel = parentCellModel.getModel('label');
        var itx = new (0, $bx3T8.ListIterator)();
        var ity = new (0, $bx3T8.ListIterator)();
        var xyLocator = [];
        var tooltipOption = matrixModel.getShallow('tooltip', true);
        for(dimForCoordY.resetLayoutIterator(ity, 1); ity.next();)for(dimForCoordX.resetLayoutIterator(itx, 0); itx.next();){
            var xLayout = itx.item;
            var yLayout = ity.item;
            $U1aqY.set(xyLocator, xLayout.id.x, yLayout.id.y);
            var bodyCornerCell = bodyOrCorner.getCell(xyLocator);
            // If in span of an other body or corner cell, never render it.
            if (bodyCornerCell && bodyCornerCell.inSpanOf && bodyCornerCell.inSpanOf !== bodyCornerCell) continue;
            var shape = {};
            if (bodyCornerCell && bodyCornerCell.span) (0, $67W72.default).copy(shape, bodyCornerCell.spanRect);
            else {
                xLayout.dim.getLayout(shape, 0, xyLocator[0]);
                yLayout.dim.getLayout(shape, 1, xyLocator[1]);
            }
            var bodyCornerCellOption = bodyCornerCell ? bodyCornerCell.option : null;
            $f0c42cb5cd561c6c$var$createMatrixCell(xyLocator, matrixModel, group, ecModel, bodyCornerCellOption, parentItemStyleModel, parentLabelModel, parentCellModel, shape, bodyCornerCellOption ? bodyCornerCellOption.value : null, $f0c42cb5cd561c6c$var$Z2_BODY_CORNER_CELL_DEFAULT, tooltipOption);
        }
    } // End of createBodyOrCornerCells
}
function $f0c42cb5cd561c6c$var$createMatrixCell(xyLocator, matrixModel, group, ecModel, cellOption, parentItemStyleModel, parentLabelModel, parentCellModel, shape, textValue, zrCellDefault, tooltipOption) {
    var _a;
    // Do not use getModel for handy performance optimization.
    $f0c42cb5cd561c6c$var$_tmpCellItemStyleModel.option = cellOption ? cellOption.itemStyle : null;
    $f0c42cb5cd561c6c$var$_tmpCellItemStyleModel.parentModel = parentItemStyleModel;
    $f0c42cb5cd561c6c$var$_tmpCellModel.option = cellOption;
    $f0c42cb5cd561c6c$var$_tmpCellModel.parentModel = parentCellModel;
    // Use different z2 because special border may be defined in itemStyle.
    var z2 = (0, $2N6Uo.retrieve2)($f0c42cb5cd561c6c$var$_tmpCellModel.getShallow('z2'), cellOption && cellOption.itemStyle ? zrCellDefault.special : zrCellDefault.normal);
    var tooltipOptionShow = tooltipOption && tooltipOption.show;
    var cellRect = $f0c42cb5cd561c6c$var$createMatrixRect(shape, $f0c42cb5cd561c6c$var$_tmpCellItemStyleModel.getItemStyle(), z2);
    group.add(cellRect);
    var cursorOption = $f0c42cb5cd561c6c$var$_tmpCellModel.get('cursor');
    if (cursorOption != null) cellRect.attr('cursor', cursorOption);
    var cellText;
    if (textValue != null) {
        var text = textValue + '';
        $f0c42cb5cd561c6c$var$_tmpCellLabelModel.option = cellOption ? cellOption.label : null;
        $f0c42cb5cd561c6c$var$_tmpCellLabelModel.parentModel = parentLabelModel;
        // This is to accept `option.textStyle` as the default.
        $f0c42cb5cd561c6c$var$_tmpCellLabelModel.ecModel = ecModel;
        (0, $bysmE.setLabelStyle)(cellRect, // Currently do not support other states (`emphasis`, `select`, `blur`)
        {
            normal: $f0c42cb5cd561c6c$var$_tmpCellLabelModel
        }, {
            defaultText: text,
            autoOverflowArea: true,
            // By default based on boundingRect. But boundingRect contains borderWidth,
            // and borderWidth is half outside the cell. Thus specific `layoutRect` explicitly.
            layoutRect: (0, $2N6Uo.clone)(cellRect.shape)
        });
        cellText = cellRect.getTextContent();
        if (cellText) {
            cellText.z2 = z2 + 1;
            var style = cellText.style;
            if (style && style.overflow && style.overflow !== 'none' && style.lineOverflow) {
                // `overflow: 'break'/'breakAll'/'truncate'` does not guarantee prevention of overflow
                // when space is insufficient. Use a `clipPath` in such case.
                var clipShape = {};
                (0, $67W72.default).copy(clipShape, shape);
                // `lineWidth` is half outside half inside the bounding rect.
                (0, $h9U3p.expandOrShrinkRect)(clipShape, (((_a = cellRect.style) === null || _a === void 0 ? void 0 : _a.lineWidth) || 0) / 2, true, true);
                cellRect.updateInnerText();
                cellText.getLocalTransform($f0c42cb5cd561c6c$var$_tmpInnerTextTrans);
                (0, $19Ywy.invert)($f0c42cb5cd561c6c$var$_tmpInnerTextTrans, $f0c42cb5cd561c6c$var$_tmpInnerTextTrans);
                (0, $67W72.default).applyTransform(clipShape, clipShape, $f0c42cb5cd561c6c$var$_tmpInnerTextTrans);
                cellText.setClipPath(new (0, $aH2k0.default)({
                    shape: clipShape
                }));
            }
        }
        (0, $h9U3p.setTooltipConfig)({
            el: cellRect,
            componentModel: matrixModel,
            itemName: text,
            itemTooltipOption: tooltipOption,
            formatterParamsExtra: {
                xyLocator: xyLocator.slice()
            }
        });
    }
    // Set silent
    if (cellText) {
        var labelSilent = $f0c42cb5cd561c6c$var$_tmpCellLabelModel.get('silent');
        // auto, tooltip of text cells need silient: false, but non-text cells
        // do not need a special cursor in most cases.
        if (labelSilent == null) labelSilent = !tooltipOptionShow;
        cellText.silent = labelSilent;
        cellText.ignoreHostSilent = true;
    }
    var rectSilent = $f0c42cb5cd561c6c$var$_tmpCellModel.get('silent');
    if (rectSilent == null) rectSilent = // If no background color in cell, set `rect.silent: false` will cause that only
    // the border response to mouse hovering, which is probably weird.
    !cellRect.style || cellRect.style.fill === 'none' || !cellRect.style.fill;
    cellRect.silent = rectSilent;
    (0, $bx3T8.clearTmpModel)($f0c42cb5cd561c6c$var$_tmpCellModel);
    (0, $bx3T8.clearTmpModel)($f0c42cb5cd561c6c$var$_tmpCellItemStyleModel);
    (0, $bx3T8.clearTmpModel)($f0c42cb5cd561c6c$var$_tmpCellLabelModel);
}
var $f0c42cb5cd561c6c$var$_tmpCellModel = new (0, $b8YKU.default)();
var $f0c42cb5cd561c6c$var$_tmpCellItemStyleModel = new (0, $b8YKU.default)();
var $f0c42cb5cd561c6c$var$_tmpCellLabelModel = new (0, $b8YKU.default)();
var $f0c42cb5cd561c6c$var$_tmpInnerTextTrans = [];
// FIXME: move all of the subpixel process to Matrix.ts resize, otherwise the result of
// `dataToLayout` is not consistent with this rendering, and the caller (like heatmap) can
// not precisely align with the matrix border.
function $f0c42cb5cd561c6c$var$createMatrixRect(shape, style, z2) {
    // Currently `subPixelOptimizeRect` can not be used here because it will break rect alignment.
    // Optimize line and rect with the same direction.
    var lineWidth = style.lineWidth;
    if (lineWidth) {
        var x2Original = shape.x + shape.width;
        var y2Original = shape.y + shape.height;
        shape.x = (0, $fcwet.subPixelOptimize)(shape.x, lineWidth, true);
        shape.y = (0, $fcwet.subPixelOptimize)(shape.y, lineWidth, true);
        shape.width = (0, $fcwet.subPixelOptimize)(x2Original, lineWidth, true) - shape.x;
        shape.height = (0, $fcwet.subPixelOptimize)(y2Original, lineWidth, true) - shape.y;
    }
    return new (0, $aH2k0.default)({
        shape: shape,
        style: style,
        z2: z2
    });
}
function $f0c42cb5cd561c6c$var$createMatrixLine(shape, style, z2) {
    var lineWidth = style.lineWidth;
    if (lineWidth) {
        if ($f0c42cb5cd561c6c$var$round(shape.x1 * 2) === $f0c42cb5cd561c6c$var$round(shape.x2 * 2)) shape.x1 = shape.x2 = (0, $fcwet.subPixelOptimize)(shape.x1, lineWidth, true);
        if ($f0c42cb5cd561c6c$var$round(shape.y1 * 2) === $f0c42cb5cd561c6c$var$round(shape.y2 * 2)) shape.y1 = shape.y2 = (0, $fcwet.subPixelOptimize)(shape.y1, lineWidth, true);
    }
    return new (0, $c3CaY.default)({
        shape: shape,
        style: style,
        silent: true,
        z2: z2
    });
}
var $f0c42cb5cd561c6c$export$2e2bcd8739ae039 = $f0c42cb5cd561c6c$var$MatrixView;

});

parcelRegister("cupBN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $917c26b48339835e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a35Wn = parcelRequire("a35Wn");

var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");

var $b8YKU = parcelRequire("b8YKU");

var $iCU10 = parcelRequire("iCU10");

var $fty47 = parcelRequire("fty47");


var $hIXrb = parcelRequire("hIXrb");
var $917c26b48339835e$var$Matrix = /** @class */ function() {
    function Matrix(matrixModel, ecModel, api) {
        this.dimensions = Matrix.dimensions;
        this.type = 'matrix';
        this._model = matrixModel;
        var models = this._dimModels = {
            x: matrixModel.getDimensionModel('x'),
            y: matrixModel.getDimensionModel('y')
        };
        this._dims = {
            x: models.x.dim,
            y: models.y.dim
        };
        this._resize(matrixModel, api);
    }
    /**
   * @see fetchers in `model/referHelper.ts`,
   * which is used to parse data in ordinal way.
   * In most series only 'x' and 'y' is required,
   * but some series, such as heatmap, can specify value.
   */ Matrix.getDimensionsInfo = function() {
        return [
            {
                name: 'x',
                type: 'ordinal'
            },
            {
                name: 'y',
                type: 'ordinal'
            },
            {
                name: 'value'
            }
        ];
    };
    Matrix.create = function(ecModel, api) {
        var matrixList = [];
        ecModel.eachComponent('matrix', function(matrixModel) {
            var matrix = new Matrix(matrixModel, ecModel, api);
            matrixList.push(matrix);
            matrixModel.coordinateSystem = matrix;
        });
        // Inject coordinate system
        // PENDING: optimize to not to travel all components?
        //  (collect relevant components in ecModel only when model update?)
        ecModel.eachComponent(function(mainType, componentModel) {
            (0, $hIXrb.injectCoordSysByOption)({
                targetModel: componentModel,
                coordSysType: 'matrix',
                coordSysProvider: (0, $hIXrb.simpleCoordSysInjectionProvider)
            });
        });
        return matrixList;
    };
    Matrix.prototype.getRect = function() {
        return this._rect;
    };
    Matrix.prototype._resize = function(matrixModel, api) {
        var dims = this._dims;
        var dimModels = this._dimModels;
        var rect = this._rect = (0, $a35Wn.getLayoutRect)(matrixModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        $917c26b48339835e$var$layOutUnitsOnDimension(dimModels, dims, rect, 0);
        $917c26b48339835e$var$layOutUnitsOnDimension(dimModels, dims, rect, 1);
        $917c26b48339835e$var$layOutDimCellsRestInfoByUnit(0, dims);
        $917c26b48339835e$var$layOutDimCellsRestInfoByUnit(1, dims);
        $917c26b48339835e$var$layOutBodyCornerCellMerge(this._model.getBody(), dims);
        $917c26b48339835e$var$layOutBodyCornerCellMerge(this._model.getCorner(), dims);
    };
    /**
   * @implement
   * - The input is allowed to be `[NaN/null/undefined, xxx]`/`[xxx, NaN/null/undefined]`;
   *  the return is `[NaN, xxxresult]`/`[xxxresult, NaN]` or clamped boundary value if
   *  `clamp` passed. This is for the usage that only get coord on single x or y.
   * - Alwasy return an numeric array, but never be null/undefined.
   *  If it can not be located or invalid, return `[NaN, NaN]`.
   */ Matrix.prototype.dataToPoint = function(data, opt, out) {
        out = out || [];
        this.dataToLayout(data, opt, $917c26b48339835e$var$_dtpOutDataToLayout);
        out[0] = $917c26b48339835e$var$_dtpOutDataToLayout.rect.x + $917c26b48339835e$var$_dtpOutDataToLayout.rect.width / 2;
        out[1] = $917c26b48339835e$var$_dtpOutDataToLayout.rect.y + $917c26b48339835e$var$_dtpOutDataToLayout.rect.height / 2;
        return out;
    };
    /**
   * @implement
   * - The input is allowed to be `[NaN/null/undefined, xxx]`/`[xxx, NaN/null/undefined]`;
   *  the return is `{x: NaN, width: NaN, y: xxxresulty, height: xxxresulth}`/
   *  `{y: NaN, height: NaN, x: xxxresultx, width: xxxresultw}` or clamped boundary value
   *  if `clamp` passed. This is for the usage that only get coord on single x or y.
   * - The returned `out.rect` and `out.matrixXYLocatorRange` is always an object or an 2d-array,
   *  but never be null/undefined. If it cannot be located or invalid, `NaN` is in their
   *  corresponding number props.
   * - Do not provide `out.contentRect`, because it's allowed to input non-leaf dimension x/y or
   *  a range of x/y, which determines a rect covering multiple cells (even not merged), in which
   *  case the padding and borderWidth can not be determined to make a contentRect. Therefore only
   *  return `out.rect` in any case for consistency. The caller is responsible for adding space to
   *  avoid covering cell borders, if necessary.
   */ Matrix.prototype.dataToLayout = function(data, opt, out) {
        var dims = this._dims;
        out = out || {};
        var outRect = out.rect = out.rect || {};
        outRect.x = outRect.y = outRect.width = outRect.height = NaN;
        var outLocRange = out.matrixXYLocatorRange = (0, $fty47.resetXYLocatorRange)(out.matrixXYLocatorRange);
        if (!(0, $2N6Uo.isArray)(data)) return out;
        (0, $fty47.parseCoordRangeOption)(outLocRange, null, data, dims, (0, $2N6Uo.retrieve2)(opt && opt.clamp, (0, $fty47.MatrixClampOption).none));
        if (!opt || !opt.ignoreMergeCells) {
            if (!opt || opt.clamp !== (0, $fty47.MatrixClampOption).corner) this._model.getBody().expandRangeByCellMerge(outLocRange);
            if (!opt || opt.clamp !== (0, $fty47.MatrixClampOption).body) this._model.getCorner().expandRangeByCellMerge(outLocRange);
        }
        (0, $fty47.xyLocatorRangeToRectOneDim)(outRect, outLocRange, dims, 0);
        (0, $fty47.xyLocatorRangeToRectOneDim)(outRect, outLocRange, dims, 1);
        return out;
    };
    /**
   * The returned locator pair can be the input of `dataToPoint` or `dataToLayout`.
   *
   * If point[0] is out of the matrix rect,
   *  the out[0] is NaN;
   * else if it is on the right of top-left corner of body,
   *  the out[0] is the oridinal number (>= 0).
   * else
   *  out[0] is the locator for corner or header (<= 0).
   *
   * The same rule goes for point[1] and out[1].
   *
   * But point[0] and point[1] are calculated separately, i.e.,
   * the reuslt can be `[1, NaN]` or `[NaN, 1]` if only one dimension is out of boundary.
   *
   * @implement
   */ Matrix.prototype.pointToData = function(point, opt, out) {
        var dims = this._dims;
        $917c26b48339835e$var$pointToDataOneDimPrepareCtx($917c26b48339835e$var$_tmpCtxPointToData, 0, dims, point, opt && opt.clamp);
        $917c26b48339835e$var$pointToDataOneDimPrepareCtx($917c26b48339835e$var$_tmpCtxPointToData, 1, dims, point, opt && opt.clamp);
        out = out || [];
        out[0] = out[1] = NaN;
        if ($917c26b48339835e$var$_tmpCtxPointToData.y === $917c26b48339835e$var$CtxPointToDataAreaType.inCorner && $917c26b48339835e$var$_tmpCtxPointToData.x === $917c26b48339835e$var$CtxPointToDataAreaType.inBody) $917c26b48339835e$var$pointToDataOnlyHeaderFillOut($917c26b48339835e$var$_tmpCtxPointToData, out, 0, dims);
        else if ($917c26b48339835e$var$_tmpCtxPointToData.x === $917c26b48339835e$var$CtxPointToDataAreaType.inCorner && $917c26b48339835e$var$_tmpCtxPointToData.y === $917c26b48339835e$var$CtxPointToDataAreaType.inBody) $917c26b48339835e$var$pointToDataOnlyHeaderFillOut($917c26b48339835e$var$_tmpCtxPointToData, out, 1, dims);
        else {
            $917c26b48339835e$var$pointToDataBodyCornerFillOut($917c26b48339835e$var$_tmpCtxPointToData, out, 0, dims);
            $917c26b48339835e$var$pointToDataBodyCornerFillOut($917c26b48339835e$var$_tmpCtxPointToData, out, 1, dims);
        }
        return out;
    };
    Matrix.prototype.convertToPixel = function(ecModel, finder, value, opt) {
        var coordSys = $917c26b48339835e$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value, opt) : undefined;
    };
    Matrix.prototype.convertToLayout = function(ecModel, finder, value, opt) {
        var coordSys = $917c26b48339835e$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToLayout(value, opt) : undefined;
    };
    Matrix.prototype.convertFromPixel = function(ecModel, finder, pixel, opt) {
        var coordSys = $917c26b48339835e$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel, opt) : undefined;
    };
    Matrix.prototype.containPoint = function(point) {
        return this._rect.contain(point[0], point[1]);
    };
    Matrix.dimensions = [
        'x',
        'y',
        'value'
    ];
    return Matrix;
}();
var $917c26b48339835e$var$_dtpOutDataToLayout = {
    rect: (0, $fty47.createNaNRectLike)()
};
var $917c26b48339835e$var$_ptdLevelIt = new (0, $bx3T8.ListIterator)();
var $917c26b48339835e$var$_ptdDimCellIt = new (0, $bx3T8.ListIterator)();
function $917c26b48339835e$var$layOutUnitsOnDimension(dimModels, dims, matrixRect, dimIdx) {
    var otherDimIdx = 1 - dimIdx;
    var thisDim = dims[(0, $h9U3p.XY)[dimIdx]];
    var otherDim = dims[(0, $h9U3p.XY)[otherDimIdx]];
    // Notice: If matrix.x/y.show is false, still lay out, to ensure the
    // consistent return of `dataToLayout`.
    var otherDimShow = otherDim.shouldShow();
    // Reset
    for(var it_1 = thisDim.resetCellIterator(); it_1.next();)it_1.item.wh = it_1.item.xy = NaN;
    for(var it_2 = otherDim.resetLayoutIterator(null, dimIdx); it_2.next();)it_2.item.wh = it_2.item.xy = NaN;
    // Set specified size from option.
    var restSize = matrixRect[(0, $h9U3p.WH)[dimIdx]];
    var restCellsCount = thisDim.getLocatorCount(dimIdx) + otherDim.getLocatorCount(dimIdx);
    var tmpLevelModel = new (0, $b8YKU.default)();
    for(var it_3 = otherDim.resetLevelIterator(); it_3.next();){
        // Consider `matrix.x.levelSize` and `matrix.x.levels[i].levelSize`.
        tmpLevelModel.option = it_3.item.option;
        tmpLevelModel.parentModel = dimModels[(0, $h9U3p.XY)[otherDimIdx]];
        layOutSpecified(it_3.item, otherDimShow ? tmpLevelModel.get('levelSize') : 0);
    }
    var tmpCellModel = new (0, $b8YKU.default)();
    for(var it_4 = thisDim.resetCellIterator(); it_4.next();)// Only leaf support size specification, to avoid unnecessary complexity.
    if (it_4.item.type === (0, $fty47.MatrixCellLayoutInfoType).leaf) {
        tmpCellModel.option = it_4.item.option;
        tmpCellModel.parentModel = undefined;
        layOutSpecified(it_4.item, tmpCellModel.get('size'));
    }
    function layOutSpecified(item, sizeOption) {
        var size = $917c26b48339835e$var$parseSizeOption(sizeOption, dimIdx, matrixRect);
        if (!(0, $2N6Uo.eqNaN)(size)) {
            item.wh = $917c26b48339835e$var$confineSize(size, restSize);
            restSize = $917c26b48339835e$var$confineSize(restSize - item.wh);
            restCellsCount--;
        }
    }
    // Set all sizes and positions to levels and leaf cells of which size is unspecified.
    // Contents lay out based on matrix, rather than inverse; therefore do not support
    // calculating size based on content, but allocate equally.
    var computedCellWH = restCellsCount ? restSize / restCellsCount : 0;
    // If all size specified, but some space remain (may also caused by matrix.x/y.show: false)
    // do not align to the big most edge.
    var notAlignToBigmost = !restCellsCount && restSize >= 1; // `1` for cumulative precision error.
    var currXY = matrixRect[(0, $h9U3p.XY)[dimIdx]];
    var maxLocator = thisDim.getLocatorCount(dimIdx) - 1;
    var it = new (0, $bx3T8.ListIterator)();
    // Lay out levels of the perpendicular dim.
    for(otherDim.resetLayoutIterator(it, dimIdx); it.next();)layOutUnspecified(it.item);
    for(thisDim.resetLayoutIterator(it, dimIdx); it.next();)layOutUnspecified(it.item);
    function layOutUnspecified(item) {
        if ((0, $2N6Uo.eqNaN)(item.wh)) item.wh = computedCellWH;
        item.xy = currXY;
        if (item.id[(0, $h9U3p.XY)[dimIdx]] === maxLocator && !notAlignToBigmost) // Align to the rightmost border, consider cumulative precision error.
        item.wh = matrixRect[(0, $h9U3p.XY)[dimIdx]] + matrixRect[(0, $h9U3p.WH)[dimIdx]] - item.xy;
        currXY += item.wh;
    }
}
function $917c26b48339835e$var$layOutDimCellsRestInfoByUnit(dimIdx, dims) {
    // Finally save layout info based on the unit leaves and levels.
    for(var it_5 = dims[(0, $h9U3p.XY)[dimIdx]].resetCellIterator(); it_5.next();){
        var dimCell = it_5.item;
        $917c26b48339835e$var$layOutRectOneDimBasedOnUnit(dimCell.rect, dimIdx, dimCell.id, dimCell.span, dims);
        // Consider level varitation on tree leaves, should extend the size to touch matrix body
        // to avoid weird appearance.
        $917c26b48339835e$var$layOutRectOneDimBasedOnUnit(dimCell.rect, 1 - dimIdx, dimCell.id, dimCell.span, dims);
        if (dimCell.type === (0, $fty47.MatrixCellLayoutInfoType).nonLeaf) {
            // `xy` and `wh` need to be saved in non-leaf since it supports locating by non-leaf
            // in `dataToPoint` or `dataToLayout`.
            dimCell.xy = dimCell.rect[(0, $h9U3p.XY)[dimIdx]];
            dimCell.wh = dimCell.rect[(0, $h9U3p.WH)[dimIdx]];
        }
    }
}
function $917c26b48339835e$var$layOutBodyCornerCellMerge(bodyOrCorner, dims) {
    bodyOrCorner.travelExistingCells(function(cell) {
        var computedSpan = cell.span;
        if (computedSpan) {
            var layoutRect = cell.spanRect;
            var id = cell.id;
            $917c26b48339835e$var$layOutRectOneDimBasedOnUnit(layoutRect, 0, id, computedSpan, dims);
            $917c26b48339835e$var$layOutRectOneDimBasedOnUnit(layoutRect, 1, id, computedSpan, dims);
        }
    });
}
// Save to rect for rendering.
function $917c26b48339835e$var$layOutRectOneDimBasedOnUnit(outRect, dimIdx, id, span, dims) {
    outRect[(0, $h9U3p.WH)[dimIdx]] = 0;
    var locator = id[(0, $h9U3p.XY)[dimIdx]];
    var dim = locator < 0 ? dims[(0, $h9U3p.XY)[1 - dimIdx]] : dims[(0, $h9U3p.XY)[dimIdx]];
    var layoutUnit = dim.getUnitLayoutInfo(dimIdx, id[(0, $h9U3p.XY)[dimIdx]]);
    outRect[(0, $h9U3p.XY)[dimIdx]] = layoutUnit.xy;
    outRect[(0, $h9U3p.WH)[dimIdx]] = layoutUnit.wh;
    if (span[(0, $h9U3p.XY)[dimIdx]] > 1) {
        var layoutUnit2 = dim.getUnitLayoutInfo(dimIdx, id[(0, $h9U3p.XY)[dimIdx]] + span[(0, $h9U3p.XY)[dimIdx]] - 1);
        // Be careful the cumulative error - cell must be aligned.
        outRect[(0, $h9U3p.WH)[dimIdx]] = layoutUnit2.xy + layoutUnit2.wh - layoutUnit.xy;
    }
}
/**
 * Return NaN if not defined or invalid.
 */ function $917c26b48339835e$var$parseSizeOption(sizeOption, dimIdx, matrixRect) {
    var sizeNum = (0, $iCU10.parsePositionSizeOption)(sizeOption, matrixRect[(0, $h9U3p.WH)[dimIdx]]);
    return $917c26b48339835e$var$confineSize(sizeNum, matrixRect[(0, $h9U3p.WH)[dimIdx]]);
}
function $917c26b48339835e$var$confineSize(sizeNum, sizeLimit) {
    return Math.max(Math.min(sizeNum, (0, $2N6Uo.retrieve2)(sizeLimit, Infinity)), 0);
}
function $917c26b48339835e$var$getCoordSys(finder) {
    var matrixModel = finder.matrixModel;
    var seriesModel = finder.seriesModel;
    var coordSys = matrixModel ? matrixModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $917c26b48339835e$var$CtxPointToDataAreaType = {
    inBody: 1,
    inCorner: 2,
    outside: 3
};
// For handy performance optimization in pointToData.
var $917c26b48339835e$var$_tmpCtxPointToData = {
    x: null,
    y: null,
    point: []
};
function $917c26b48339835e$var$pointToDataOneDimPrepareCtx(ctx, dimIdx, dims, point, clamp) {
    var thisDim = dims[(0, $h9U3p.XY)[dimIdx]];
    var otherDim = dims[(0, $h9U3p.XY)[1 - dimIdx]];
    // Notice: considered cases: `matrix.x/y.show: false`, `matrix.x/y.data` is empty.
    // In this cases the `layout.xy` is on the edge and `layout.wh` is `0`; they still can be
    // use to calculate clampping.
    var bodyMaxUnit = thisDim.getUnitLayoutInfo(dimIdx, thisDim.getLocatorCount(dimIdx) - 1);
    var body0Unit = thisDim.getUnitLayoutInfo(dimIdx, 0);
    var cornerMinUnit = otherDim.getUnitLayoutInfo(dimIdx, -otherDim.getLocatorCount(dimIdx));
    var cornerMinus1Unit = otherDim.shouldShow() ? otherDim.getUnitLayoutInfo(dimIdx, -1) : null;
    var coord = ctx.point[dimIdx] = point[dimIdx]; // Transfer the oridinal coord.
    if (!body0Unit && !cornerMinus1Unit) {
        ctx[(0, $h9U3p.XY)[dimIdx]] = $917c26b48339835e$var$CtxPointToDataAreaType.outside;
        return;
    }
    if (clamp === (0, $fty47.MatrixClampOption).body) {
        if (body0Unit) {
            ctx[(0, $h9U3p.XY)[dimIdx]] = $917c26b48339835e$var$CtxPointToDataAreaType.inBody;
            coord = (0, $iCU10.mathMin)(bodyMaxUnit.xy + bodyMaxUnit.wh, (0, $iCU10.mathMax)(body0Unit.xy, coord));
            ctx.point[dimIdx] = coord;
        } else // If clamp to body, the result must not be in header.
        ctx[(0, $h9U3p.XY)[dimIdx]] = $917c26b48339835e$var$CtxPointToDataAreaType.outside;
        return;
    } else if (clamp === (0, $fty47.MatrixClampOption).corner) {
        if (cornerMinus1Unit) {
            ctx[(0, $h9U3p.XY)[dimIdx]] = $917c26b48339835e$var$CtxPointToDataAreaType.inCorner;
            coord = (0, $iCU10.mathMin)(cornerMinus1Unit.xy + cornerMinus1Unit.wh, (0, $iCU10.mathMax)(cornerMinUnit.xy, coord));
            ctx.point[dimIdx] = coord;
        } else // If clamp to corner, the result must not be in body.
        ctx[(0, $h9U3p.XY)[dimIdx]] = $917c26b48339835e$var$CtxPointToDataAreaType.outside;
        return;
    }
    var pxLoc0 = body0Unit ? body0Unit.xy : cornerMinus1Unit ? cornerMinus1Unit.xy + cornerMinus1Unit.wh : NaN;
    var pxMin = cornerMinUnit ? cornerMinUnit.xy : pxLoc0;
    var pxMax = bodyMaxUnit ? bodyMaxUnit.xy + bodyMaxUnit.wh : pxLoc0;
    if (coord < pxMin) {
        if (!clamp) {
            // Quick pass for later calc, since mouse event on any place will enter this method if use `pointToData`.
            ctx[(0, $h9U3p.XY)[dimIdx]] = $917c26b48339835e$var$CtxPointToDataAreaType.outside;
            return;
        }
        coord = pxMin;
    } else if (coord > pxMax) {
        if (!clamp) {
            ctx[(0, $h9U3p.XY)[dimIdx]] = $917c26b48339835e$var$CtxPointToDataAreaType.outside;
            return;
        }
        coord = pxMax;
    }
    ctx.point[dimIdx] = coord; // Save the updated coord.
    ctx[(0, $h9U3p.XY)[dimIdx]] = pxLoc0 <= coord && coord <= pxMax ? $917c26b48339835e$var$CtxPointToDataAreaType.inBody : pxMin <= coord && coord <= pxLoc0 ? $917c26b48339835e$var$CtxPointToDataAreaType.inCorner : $917c26b48339835e$var$CtxPointToDataAreaType.outside;
// Every props in ctx must be set in every branch of this method.
}
// Assume partialOut has been set to NaN outside.
// This method may fill out[0] and out[1] in one call.
function $917c26b48339835e$var$pointToDataOnlyHeaderFillOut(ctx, partialOut, dimIdx, dims) {
    var otherDimIdx = 1 - dimIdx;
    if (ctx[(0, $h9U3p.XY)[dimIdx]] === $917c26b48339835e$var$CtxPointToDataAreaType.outside) return;
    for(dims[(0, $h9U3p.XY)[dimIdx]].resetCellIterator($917c26b48339835e$var$_ptdDimCellIt); $917c26b48339835e$var$_ptdDimCellIt.next();){
        var cell = $917c26b48339835e$var$_ptdDimCellIt.item;
        if ($917c26b48339835e$var$isCoordInRect(ctx.point[dimIdx], cell.rect, dimIdx) && $917c26b48339835e$var$isCoordInRect(ctx.point[otherDimIdx], cell.rect, otherDimIdx)) {
            // non-leaves are also allowed to be located.
            // If the point is in x or y dimension cell area, should check both x and y coord to
            // determine a cell; in this way a non-leaf cell can be determined.
            partialOut[dimIdx] = cell.ordinal;
            partialOut[otherDimIdx] = cell.id[(0, $h9U3p.XY)[otherDimIdx]];
            return;
        }
    }
}
// Assume partialOut has been set to NaN outside.
// This method may fill out[0] and out[1] in one call.
function $917c26b48339835e$var$pointToDataBodyCornerFillOut(ctx, partialOut, dimIdx, dims) {
    if (ctx[(0, $h9U3p.XY)[dimIdx]] === $917c26b48339835e$var$CtxPointToDataAreaType.outside) return;
    var dim = ctx[(0, $h9U3p.XY)[dimIdx]] === $917c26b48339835e$var$CtxPointToDataAreaType.inCorner ? dims[(0, $h9U3p.XY)[1 - dimIdx]] : dims[(0, $h9U3p.XY)[dimIdx]];
    for(dim.resetLayoutIterator($917c26b48339835e$var$_ptdLevelIt, dimIdx); $917c26b48339835e$var$_ptdLevelIt.next();)if ($917c26b48339835e$var$isCoordInLayoutInfo(ctx.point[dimIdx], $917c26b48339835e$var$_ptdLevelIt.item)) {
        partialOut[dimIdx] = $917c26b48339835e$var$_ptdLevelIt.item.id[(0, $h9U3p.XY)[dimIdx]];
        return;
    }
}
function $917c26b48339835e$var$isCoordInLayoutInfo(coord, cell) {
    return cell.xy <= coord && coord <= cell.xy + cell.wh;
}
function $917c26b48339835e$var$isCoordInRect(coord, rect, dimIdx) {
    return rect[(0, $h9U3p.XY)[dimIdx]] <= coord && coord <= rect[(0, $h9U3p.XY)[dimIdx]] + rect[(0, $h9U3p.WH)[dimIdx]];
}
var $917c26b48339835e$export$2e2bcd8739ae039 = $917c26b48339835e$var$Matrix;

});


parcelRegister("86pGl", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $5e62ce2c35f230f0$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $gX19P = parcelRequire("gX19P");

var $cjjFP = parcelRequire("cjjFP");

var $3lZH2 = parcelRequire("3lZH2");

var $24qes = parcelRequire("24qes");

var $ds1dn = parcelRequire("ds1dn");

var $lzKMz = parcelRequire("lzKMz");

var $eGfs8 = parcelRequire("eGfs8");

var $22DDC = parcelRequire("22DDC");

var $lNSDY = parcelRequire("lNSDY");

var $6O46R = parcelRequire("6O46R");

var $bpyST = parcelRequire("bpyST");

var $2N6Uo = parcelRequire("2N6Uo");

var $jj5ok = parcelRequire("jj5ok");
var $5e62ce2c35f230f0$var$angleAxisExtraOption = {
    startAngle: 90,
    clockwise: true,
    splitNumber: 12,
    axisLabel: {
        rotate: 0
    }
};
var $5e62ce2c35f230f0$var$radiusAxisExtraOption = {
    splitNumber: 5
};
var $5e62ce2c35f230f0$var$PolarView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PolarView, _super);
    function PolarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarView.type;
        return _this;
    }
    PolarView.type = 'polar';
    return PolarView;
}((0, $bpyST.default));
function $5e62ce2c35f230f0$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $24qes.install));
    (0, $cjjFP.default).registerAxisPointerClass('PolarAxisPointer', (0, $3lZH2.default));
    registers.registerCoordinateSystem('polar', (0, $22DDC.default));
    registers.registerComponentModel((0, $ds1dn.default));
    registers.registerComponentView($5e62ce2c35f230f0$var$PolarView);
    // Model and view for angleAxis and radiusAxis
    (0, $lzKMz.default)(registers, 'angle', (0, $eGfs8.AngleAxisModel), $5e62ce2c35f230f0$var$angleAxisExtraOption);
    (0, $lzKMz.default)(registers, 'radius', (0, $eGfs8.RadiusAxisModel), $5e62ce2c35f230f0$var$radiusAxisExtraOption);
    registers.registerComponentView((0, $lNSDY.default));
    registers.registerComponentView((0, $6O46R.default));
    registers.registerLayout((0, $2N6Uo.curry)((0, $jj5ok.default), 'bar'));
}

});
parcelRegister("3lZH2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2713303858feb72f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $fW5EC = parcelRequire("fW5EC");

var $h9U3p = parcelRequire("h9U3p");

var $7bAwM = parcelRequire("7bAwM");

var $19Ywy = parcelRequire("19Ywy");

var $fVg7M = parcelRequire("fVg7M");
var $2713303858feb72f$var$PolarAxisPointer = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PolarAxisPointer, _super);
    function PolarAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ PolarAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        if (axis.dim === 'angle') this.animationThreshold = Math.PI / 18;
        var polar = axis.polar;
        var otherAxis = polar.getOtherAxis(axis);
        var otherExtent = otherAxis.getExtent();
        var coordValue = axis.dataToCoord(value);
        var axisPointerType = axisPointerModel.get('type');
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $7bAwM.buildElStyle(axisPointerModel);
            var pointerOption = $2713303858feb72f$var$pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var labelMargin = axisPointerModel.get([
            'label',
            'margin'
        ]);
        var labelPos = $2713303858feb72f$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
        $7bAwM.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
    };
    return PolarAxisPointer;
}((0, $fW5EC.default));
function $2713303858feb72f$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
    var axis = axisModel.axis;
    var coord = axis.dataToCoord(value);
    var axisAngle = polar.getAngleAxis().getExtent()[0];
    axisAngle = axisAngle / 180 * Math.PI;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var position;
    var align;
    var verticalAlign;
    if (axis.dim === 'radius') {
        var transform = $19Ywy.create();
        $19Ywy.rotate(transform, transform, axisAngle);
        $19Ywy.translate(transform, transform, [
            polar.cx,
            polar.cy
        ]);
        position = $h9U3p.applyTransform([
            coord,
            -labelMargin
        ], transform);
        var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
        // @ts-ignore
        var labelLayout = (0, $fVg7M.default).innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
        align = labelLayout.textAlign;
        verticalAlign = labelLayout.textVerticalAlign;
    } else {
        // angle axis
        var r = radiusExtent[1];
        position = polar.coordToPoint([
            r + labelMargin,
            coord
        ]);
        var cx = polar.cx;
        var cy = polar.cy;
        align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
        verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
    }
    return {
        position: position,
        align: align,
        verticalAlign: verticalAlign
    };
}
var $2713303858feb72f$var$pointerShapeBuilder = {
    line: function(axis, polar, coordValue, otherExtent) {
        return axis.dim === 'angle' ? {
            type: 'Line',
            shape: $7bAwM.makeLineShape(polar.coordToPoint([
                otherExtent[0],
                coordValue
            ]), polar.coordToPoint([
                otherExtent[1],
                coordValue
            ]))
        } : {
            type: 'Circle',
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: coordValue
            }
        };
    },
    shadow: function(axis, polar, coordValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var radian = Math.PI / 180;
        return axis.dim === 'angle' ? {
            type: 'Sector',
            shape: $7bAwM.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
            (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
        } : {
            type: 'Sector',
            shape: $7bAwM.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
        };
    }
};
var $2713303858feb72f$export$2e2bcd8739ae039 = $2713303858feb72f$var$PolarAxisPointer;

});

parcelRegister("ds1dn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9caed51c8307267e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");
var $9caed51c8307267e$var$PolarModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PolarModel, _super);
    function PolarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarModel.type;
        return _this;
    }
    PolarModel.prototype.findAxisModel = function(axisType) {
        var foundAxisModel;
        var ecModel = this.ecModel;
        ecModel.eachComponent(axisType, function(axisModel) {
            if (axisModel.getCoordSysModel() === this) foundAxisModel = axisModel;
        }, this);
        return foundAxisModel;
    };
    PolarModel.type = 'polar';
    PolarModel.dependencies = [
        'radiusAxis',
        'angleAxis'
    ];
    PolarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            '50%',
            '50%'
        ],
        radius: '80%'
    };
    return PolarModel;
}((0, $eLD2b.default));
var $9caed51c8307267e$export$2e2bcd8739ae039 = $9caed51c8307267e$var$PolarModel;

});

parcelRegister("eGfs8", function(module, exports) {

$parcel$export(module.exports, "AngleAxisModel", function () { return $ab00f986ba4bf0b4$export$34735c2c701428ca; });
$parcel$export(module.exports, "RadiusAxisModel", function () { return $ab00f986ba4bf0b4$export$de202388c212a23b; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $eLD2b = parcelRequire("eLD2b");

var $fRzLp = parcelRequire("fRzLp");

var $bx3T8 = parcelRequire("bx3T8");
var $ab00f986ba4bf0b4$export$ae9b190f9f84c66f = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PolarAxisModel, _super);
    function PolarAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolarAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('polar', (0, $bx3T8.SINGLE_REFERRING)).models[0];
    };
    PolarAxisModel.type = 'polarAxis';
    return PolarAxisModel;
}((0, $eLD2b.default));
$2N6Uo.mixin($ab00f986ba4bf0b4$export$ae9b190f9f84c66f, (0, $fRzLp.AxisModelCommonMixin));
var $ab00f986ba4bf0b4$export$34735c2c701428ca = /** @class */ function(_super) {
    (0, $9nEce.__extends)(AngleAxisModel, _super);
    function AngleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisModel.type;
        return _this;
    }
    AngleAxisModel.type = 'angleAxis';
    return AngleAxisModel;
}($ab00f986ba4bf0b4$export$ae9b190f9f84c66f);
var $ab00f986ba4bf0b4$export$de202388c212a23b = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RadiusAxisModel, _super);
    function RadiusAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisModel.type;
        return _this;
    }
    RadiusAxisModel.type = 'radiusAxis';
    return RadiusAxisModel;
}($ab00f986ba4bf0b4$export$ae9b190f9f84c66f);

});

parcelRegister("22DDC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17ca83f3e18769d2$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Axis scale

var $2N6Uo = parcelRequire("2N6Uo");

var $hmUf1 = parcelRequire("hmUf1");

var $iCU10 = parcelRequire("iCU10");

var $9AF98 = parcelRequire("9AF98");

var $bx3T8 = parcelRequire("bx3T8");

var $a35Wn = parcelRequire("a35Wn");
/**
 * Resize method bound to the polar
 */ function $17ca83f3e18769d2$var$resizePolar(polar, polarModel, api) {
    var center = polarModel.get('center');
    var refContainer = (0, $a35Wn.createBoxLayoutReference)(polarModel, api).refContainer;
    polar.cx = (0, $iCU10.parsePercent)(center[0], refContainer.width) + refContainer.x;
    polar.cy = (0, $iCU10.parsePercent)(center[1], refContainer.height) + refContainer.y;
    var radiusAxis = polar.getRadiusAxis();
    var size = Math.min(refContainer.width, refContainer.height) / 2;
    var radius = polarModel.get('radius');
    if (radius == null) radius = [
        0,
        '100%'
    ];
    else if (!$2N6Uo.isArray(radius)) // r0 = 0
    radius = [
        0,
        radius
    ];
    var parsedRadius = [
        (0, $iCU10.parsePercent)(radius[0], size),
        (0, $iCU10.parsePercent)(radius[1], size)
    ];
    radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
}
/**
 * Update polar
 */ function $17ca83f3e18769d2$var$updatePolarScale(ecModel, api) {
    var polar = this;
    var angleAxis = polar.getAngleAxis();
    var radiusAxis = polar.getRadiusAxis();
    // Reset scale
    angleAxis.scale.setExtent(Infinity, -Infinity);
    radiusAxis.scale.setExtent(Infinity, -Infinity);
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem === polar) {
            var data_1 = seriesModel.getData();
            $2N6Uo.each((0, $9AF98.getDataDimensionsOnAxis)(data_1, 'radius'), function(dim) {
                radiusAxis.scale.unionExtentFromData(data_1, dim);
            });
            $2N6Uo.each((0, $9AF98.getDataDimensionsOnAxis)(data_1, 'angle'), function(dim) {
                angleAxis.scale.unionExtentFromData(data_1, dim);
            });
        }
    });
    (0, $9AF98.niceScaleExtent)(angleAxis.scale, angleAxis.model);
    (0, $9AF98.niceScaleExtent)(radiusAxis.scale, radiusAxis.model);
    // Fix extent of category angle axis
    if (angleAxis.type === 'category' && !angleAxis.onBand) {
        var extent = angleAxis.getExtent();
        var diff = 360 / angleAxis.scale.count();
        angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
        angleAxis.setExtent(extent[0], extent[1]);
    }
}
function $17ca83f3e18769d2$var$isAngleAxisModel(axisModel) {
    return axisModel.mainType === 'angleAxis';
}
/**
 * Set common axis properties
 */ function $17ca83f3e18769d2$var$setAxis(axis, axisModel) {
    var _a;
    axis.type = axisModel.get('type');
    axis.scale = (0, $9AF98.createScaleByModel)(axisModel);
    axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
    axis.inverse = axisModel.get('inverse');
    if ($17ca83f3e18769d2$var$isAngleAxisModel(axisModel)) {
        axis.inverse = axis.inverse !== axisModel.get('clockwise');
        var startAngle = axisModel.get('startAngle');
        var endAngle = (_a = axisModel.get('endAngle')) !== null && _a !== void 0 ? _a : startAngle + (axis.inverse ? -360 : 360);
        axis.setExtent(startAngle, endAngle);
    }
    // Inject axis instance
    axisModel.axis = axis;
    axis.model = axisModel;
}
var $17ca83f3e18769d2$var$polarCreator = {
    dimensions: (0, $hmUf1.polarDimensions),
    create: function(ecModel, api) {
        var polarList = [];
        ecModel.eachComponent('polar', function(polarModel, idx) {
            var polar = new (0, $hmUf1.default)(idx + '');
            // Inject resize and update method
            polar.update = $17ca83f3e18769d2$var$updatePolarScale;
            var radiusAxis = polar.getRadiusAxis();
            var angleAxis = polar.getAngleAxis();
            var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
            var angleAxisModel = polarModel.findAxisModel('angleAxis');
            $17ca83f3e18769d2$var$setAxis(radiusAxis, radiusAxisModel);
            $17ca83f3e18769d2$var$setAxis(angleAxis, angleAxisModel);
            $17ca83f3e18769d2$var$resizePolar(polar, polarModel, api);
            polarList.push(polar);
            polarModel.coordinateSystem = polar;
            polar.model = polarModel;
        });
        // Inject coordinateSystem to series
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get('coordinateSystem') === 'polar') {
                var polarModel = seriesModel.getReferringComponents('polar', (0, $bx3T8.SINGLE_REFERRING)).models[0];
                seriesModel.coordinateSystem = polarModel.coordinateSystem;
            }
        });
        return polarList;
    }
};
var $17ca83f3e18769d2$export$2e2bcd8739ae039 = $17ca83f3e18769d2$var$polarCreator;

});
parcelRegister("hmUf1", function(module, exports) {

$parcel$export(module.exports, "polarDimensions", function () { return $ca501e111c67f721$export$f6d9521c10640456; });
$parcel$export(module.exports, "default", function () { return $ca501e111c67f721$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $04UrY = parcelRequire("04UrY");

var $aSBA8 = parcelRequire("aSBA8");
var $ca501e111c67f721$export$f6d9521c10640456 = [
    'radius',
    'angle'
];
var $ca501e111c67f721$var$Polar = /** @class */ function() {
    function Polar(name) {
        this.dimensions = $ca501e111c67f721$export$f6d9521c10640456;
        this.type = 'polar';
        /**
     * x of polar center
     */ this.cx = 0;
        /**
     * y of polar center
     */ this.cy = 0;
        this._radiusAxis = new (0, $04UrY.default)();
        this._angleAxis = new (0, $aSBA8.default)();
        this.axisPointerEnabled = true;
        this.name = name || '';
        this._radiusAxis.polar = this._angleAxis.polar = this;
    }
    /**
   * If contain coord
   */ Polar.prototype.containPoint = function(point) {
        var coord = this.pointToCoord(point);
        return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
    };
    /**
   * If contain data
   */ Polar.prototype.containData = function(data) {
        return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
    };
    Polar.prototype.getAxis = function(dim) {
        var key = '_' + dim + 'Axis';
        return this[key];
    };
    Polar.prototype.getAxes = function() {
        return [
            this._radiusAxis,
            this._angleAxis
        ];
    };
    /**
   * Get axes by type of scale
   */ Polar.prototype.getAxesByScale = function(scaleType) {
        var axes = [];
        var angleAxis = this._angleAxis;
        var radiusAxis = this._radiusAxis;
        angleAxis.scale.type === scaleType && axes.push(angleAxis);
        radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
        return axes;
    };
    Polar.prototype.getAngleAxis = function() {
        return this._angleAxis;
    };
    Polar.prototype.getRadiusAxis = function() {
        return this._radiusAxis;
    };
    Polar.prototype.getOtherAxis = function(axis) {
        var angleAxis = this._angleAxis;
        return axis === angleAxis ? this._radiusAxis : angleAxis;
    };
    /**
   * Base axis will be used on stacking.
   *
   */ Polar.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
    };
    Polar.prototype.getTooltipAxes = function(dim) {
        var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
        return {
            baseAxes: [
                baseAxis
            ],
            otherAxes: [
                this.getOtherAxis(baseAxis)
            ]
        };
    };
    /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   */ Polar.prototype.dataToPoint = function(data, clamp, out) {
        return this.coordToPoint([
            this._radiusAxis.dataToRadius(data[0], clamp),
            this._angleAxis.dataToAngle(data[1], clamp)
        ], out);
    };
    /**
   * Convert a (x, y) point to data
   */ Polar.prototype.pointToData = function(point, clamp, out) {
        out = out || [];
        var coord = this.pointToCoord(point);
        out[0] = this._radiusAxis.radiusToData(coord[0], clamp);
        out[1] = this._angleAxis.angleToData(coord[1], clamp);
        return out;
    };
    /**
   * Convert a (x, y) point to (radius, angle) coord
   */ Polar.prototype.pointToCoord = function(point) {
        var dx = point[0] - this.cx;
        var dy = point[1] - this.cy;
        var angleAxis = this.getAngleAxis();
        var extent = angleAxis.getExtent();
        var minAngle = Math.min(extent[0], extent[1]);
        var maxAngle = Math.max(extent[0], extent[1]);
        // Fix fixed extent in polarCreator
        // FIXME
        angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx) / Math.PI * 180;
        // move to angleExtent
        var dir = radian < minAngle ? 1 : -1;
        while(radian < minAngle || radian > maxAngle)radian += dir * 360;
        return [
            radius,
            radian
        ];
    };
    /**
   * Convert a (radius, angle) coord to (x, y) point
   */ Polar.prototype.coordToPoint = function(coord, out) {
        out = out || [];
        var radius = coord[0];
        var radian = coord[1] / 180 * Math.PI;
        out[0] = Math.cos(radian) * radius + this.cx;
        // Inverse the y
        out[1] = -Math.sin(radian) * radius + this.cy;
        return out;
    };
    /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Polar.prototype.getArea = function() {
        var angleAxis = this.getAngleAxis();
        var radiusAxis = this.getRadiusAxis();
        var radiusExtent = radiusAxis.getExtent().slice();
        radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
        var angleExtent = angleAxis.getExtent();
        var RADIAN = Math.PI / 180;
        var EPSILON = 1e-4;
        return {
            cx: this.cx,
            cy: this.cy,
            r0: radiusExtent[0],
            r: radiusExtent[1],
            startAngle: -angleExtent[0] * RADIAN,
            endAngle: -angleExtent[1] * RADIAN,
            clockwise: angleAxis.inverse,
            contain: function(x, y) {
                // It's a ring shape.
                // Start angle and end angle don't matter
                var dx = x - this.cx;
                var dy = y - this.cy;
                var d2 = dx * dx + dy * dy;
                var r = this.r;
                var r0 = this.r0;
                // minus a tiny value 1e-4 in double side to avoid being clipped unexpectedly
                // r == r0 contain nothing
                return r !== r0 && d2 - EPSILON <= r * r && d2 + EPSILON >= r0 * r0;
            },
            // As the bounding box
            x: this.cx - radiusExtent[1],
            y: this.cy - radiusExtent[1],
            width: radiusExtent[1] * 2,
            height: radiusExtent[1] * 2
        };
    };
    Polar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $ca501e111c67f721$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Polar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $ca501e111c67f721$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Polar;
}();
function $ca501e111c67f721$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var polarModel = finder.polarModel;
    return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $ca501e111c67f721$export$2e2bcd8739ae039 = $ca501e111c67f721$var$Polar;

});
parcelRegister("04UrY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00ec29a5a931c623$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $6ZMAw = parcelRequire("6ZMAw");
var $00ec29a5a931c623$var$RadiusAxis = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RadiusAxis, _super);
    function RadiusAxis(scale, radiusExtent) {
        return _super.call(this, 'radius', scale, radiusExtent) || this;
    }
    RadiusAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
    };
    return RadiusAxis;
}((0, $6ZMAw.default));
$00ec29a5a931c623$var$RadiusAxis.prototype.dataToRadius = (0, $6ZMAw.default).prototype.dataToCoord;
$00ec29a5a931c623$var$RadiusAxis.prototype.radiusToData = (0, $6ZMAw.default).prototype.coordToData;
var $00ec29a5a931c623$export$2e2bcd8739ae039 = $00ec29a5a931c623$var$RadiusAxis;

});

parcelRegister("aSBA8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ebc197c0404f1f7$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eVwLk = parcelRequire("eVwLk");

var $6ZMAw = parcelRequire("6ZMAw");

var $bx3T8 = parcelRequire("bx3T8");
var $7ebc197c0404f1f7$var$inner = (0, $bx3T8.makeInner)();
var $7ebc197c0404f1f7$var$AngleAxis = /** @class */ function(_super) {
    (0, $9nEce.__extends)(AngleAxis, _super);
    function AngleAxis(scale, angleExtent) {
        return _super.call(this, 'angle', scale, angleExtent || [
            0,
            360
        ]) || this;
    }
    AngleAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
    };
    /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */ AngleAxis.prototype.calculateCategoryInterval = function() {
        var axis = this;
        var labelModel = axis.getLabelModel();
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        // Providing this method is for optimization:
        // avoid generating a long array by `getTicks`
        // in large category data case.
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitH = Math.abs(unitSpan);
        // Not precise, just use height as text width
        // and each distance from axis line yet.
        var rect = $eVwLk.getBoundingRect(tickValue == null ? '' : tickValue + '', labelModel.getFont(), 'center', 'top');
        var maxH = Math.max(rect.height, 7);
        var dh = maxH / unitH;
        // 0/0 is NaN, 1/0 is Infinity.
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(dh));
        var cache = $7ebc197c0404f1f7$var$inner(axis.model);
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        // Use cache to keep interval stable while moving zoom window,
        // otherwise the calculated interval might jitter when the zoom
        // window size is close to the interval-changing size.
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
        }
        return interval;
    };
    return AngleAxis;
}((0, $6ZMAw.default));
$7ebc197c0404f1f7$var$AngleAxis.prototype.dataToAngle = (0, $6ZMAw.default).prototype.dataToCoord;
$7ebc197c0404f1f7$var$AngleAxis.prototype.angleToData = (0, $6ZMAw.default).prototype.coordToData;
var $7ebc197c0404f1f7$export$2e2bcd8739ae039 = $7ebc197c0404f1f7$var$AngleAxis;

});



parcelRegister("lNSDY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdf88fabf6f4305e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");

var $bysmE = parcelRequire("bysmE");

var $b8YKU = parcelRequire("b8YKU");

var $cjjFP = parcelRequire("cjjFP");

var $fVg7M = parcelRequire("fVg7M");

var $6TSUP = parcelRequire("6TSUP");
var $fdf88fabf6f4305e$var$elementList = [
    'axisLine',
    'axisLabel',
    'axisTick',
    'minorTick',
    'splitLine',
    'minorSplitLine',
    'splitArea'
];
function $fdf88fabf6f4305e$var$getAxisLineShape(polar, rExtent, angle) {
    rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
    var start = polar.coordToPoint([
        rExtent[0],
        angle
    ]);
    var end = polar.coordToPoint([
        rExtent[1],
        angle
    ]);
    return {
        x1: start[0],
        y1: start[1],
        x2: end[0],
        y2: end[1]
    };
}
function $fdf88fabf6f4305e$var$getRadiusIdx(polar) {
    var radiusAxis = polar.getRadiusAxis();
    return radiusAxis.inverse ? 0 : 1;
}
// Remove the last tick which will overlap the first tick
function $fdf88fabf6f4305e$var$fixAngleOverlap(list) {
    var firstItem = list[0];
    var lastItem = list[list.length - 1];
    if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) list.pop();
}
var $fdf88fabf6f4305e$var$AngleAxisView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(AngleAxisView, _super);
    function AngleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisView.type;
        _this.axisPointerClass = 'PolarAxisPointer';
        return _this;
    }
    AngleAxisView.prototype.render = function(angleAxisModel, ecModel) {
        this.group.removeAll();
        if (!angleAxisModel.get('show')) return;
        var angleAxis = angleAxisModel.axis;
        var polar = angleAxis.polar;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var ticksAngles = angleAxis.getTicksCoords({
            breakTicks: 'none'
        });
        var minorTickAngles = angleAxis.getMinorTicksCoords();
        var labels = $2N6Uo.map(angleAxis.getViewLabels(), function(labelItem) {
            labelItem = $2N6Uo.clone(labelItem);
            var scale = angleAxis.scale;
            var tickValue = scale.type === 'ordinal' ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            labelItem.coord = angleAxis.dataToCoord(tickValue);
            return labelItem;
        });
        $fdf88fabf6f4305e$var$fixAngleOverlap(labels);
        $fdf88fabf6f4305e$var$fixAngleOverlap(ticksAngles);
        $2N6Uo.each($fdf88fabf6f4305e$var$elementList, function(name) {
            if (angleAxisModel.get([
                name,
                'show'
            ]) && (!angleAxis.scale.isBlank() || name === 'axisLine')) $fdf88fabf6f4305e$var$angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
        }, this);
    };
    AngleAxisView.type = 'angleAxis';
    return AngleAxisView;
}((0, $cjjFP.default));
var $fdf88fabf6f4305e$var$angelAxisElementsBuilders = {
    axisLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var lineStyleModel = angleAxisModel.getModel([
            'axisLine',
            'lineStyle'
        ]);
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        // extent id of the axis radius (r0 and r)
        var rId = $fdf88fabf6f4305e$var$getRadiusIdx(polar);
        var r0Id = rId ? 0 : 1;
        var shape;
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? 'Circle' : 'Arc';
        if (radiusExtent[r0Id] === 0) shape = new $h9U3p[shapeType]({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                startAngle: -angleExtent[0] * RADIAN,
                endAngle: -angleExtent[1] * RADIAN,
                clockwise: angleAxis.inverse
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        else shape = new $h9U3p.Ring({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                r0: radiusExtent[r0Id]
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        shape.style.fill = null;
        group.add(shape);
    },
    axisTick: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var tickModel = angleAxisModel.getModel('axisTick');
        var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
        var radius = radiusExtent[$fdf88fabf6f4305e$var$getRadiusIdx(polar)];
        var lines = $2N6Uo.map(ticksAngles, function(tickAngleItem) {
            return new $h9U3p.Line({
                shape: $fdf88fabf6f4305e$var$getAxisLineShape(polar, [
                    radius,
                    radius + tickLen
                ], tickAngleItem.coord)
            });
        });
        group.add($h9U3p.mergePath(lines, {
            style: $2N6Uo.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
                stroke: angleAxisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ])
            })
        }));
    },
    minorTick: function(group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var tickModel = angleAxisModel.getModel('axisTick');
        var minorTickModel = angleAxisModel.getModel('minorTick');
        var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
        var radius = radiusExtent[$fdf88fabf6f4305e$var$getRadiusIdx(polar)];
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $h9U3p.Line({
            shape: $fdf88fabf6f4305e$var$getAxisLineShape(polar, [
                radius,
                radius + tickLen
            ], minorTickAngles[i][k].coord)
        }));
        group.add($h9U3p.mergePath(lines, {
            style: $2N6Uo.defaults(minorTickModel.getModel('lineStyle').getLineStyle(), $2N6Uo.defaults(tickModel.getLineStyle(), {
                stroke: angleAxisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ])
            }))
        }));
    },
    axisLabel: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
        var rawCategoryData = angleAxisModel.getCategories(true);
        var commonLabelModel = angleAxisModel.getModel('axisLabel');
        var labelMargin = commonLabelModel.get('margin');
        var triggerEvent = angleAxisModel.get('triggerEvent');
        // Use length of ticksAngles because it may remove the last tick to avoid overlapping
        $2N6Uo.each(labels, function(labelItem, idx) {
            var labelModel = commonLabelModel;
            var tickValue = labelItem.tickValue;
            var r = radiusExtent[$fdf88fabf6f4305e$var$getRadiusIdx(polar)];
            var p = polar.coordToPoint([
                r + labelMargin,
                labelItem.coord
            ]);
            var cx = polar.cx;
            var cy = polar.cy;
            var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
            var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ($2N6Uo.isObject(rawCategoryItem) && rawCategoryItem.textStyle) labelModel = new (0, $b8YKU.default)(rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
            }
            var textEl = new $h9U3p.Text({
                silent: (0, $fVg7M.default).isLabelSilent(angleAxisModel),
                style: (0, $bysmE.createTextStyle)(labelModel, {
                    x: p[0],
                    y: p[1],
                    fill: labelModel.getTextColor() || angleAxisModel.get([
                        'axisLine',
                        'lineStyle',
                        'color'
                    ]),
                    text: labelItem.formattedLabel,
                    align: labelTextAlign,
                    verticalAlign: labelTextVerticalAlign
                })
            });
            group.add(textEl);
            $h9U3p.setTooltipConfig({
                el: textEl,
                componentModel: angleAxisModel,
                itemName: labelItem.formattedLabel,
                formatterParamsExtra: {
                    isTruncated: function() {
                        return textEl.isTruncated;
                    },
                    value: labelItem.rawLabel,
                    tickIndex: idx
                }
            });
            // Pack data for mouse event
            if (triggerEvent) {
                var eventData = (0, $fVg7M.default).makeAxisEventDataBase(angleAxisModel);
                eventData.targetType = 'axisLabel';
                eventData.value = labelItem.rawLabel;
                (0, $6TSUP.getECData)(textEl).eventData = eventData;
            }
        }, this);
    },
    splitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var splitLineModel = angleAxisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var lineCount = 0;
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksAngles.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $h9U3p.Line({
                shape: $fdf88fabf6f4305e$var$getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($h9U3p.mergePath(splitLines[i], {
            style: $2N6Uo.defaults({
                stroke: lineColors[i % lineColors.length]
            }, lineStyleModel.getLineStyle()),
            silent: true,
            z: angleAxisModel.get('z')
        }));
    },
    minorSplitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $h9U3p.Line({
            shape: $fdf88fabf6f4305e$var$getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
        group.add($h9U3p.mergePath(lines, {
            style: lineStyleModel.getLineStyle(),
            silent: true,
            z: angleAxisModel.get('z')
        }));
    },
    splitArea: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!ticksAngles.length) return;
        var splitAreaModel = angleAxisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var RADIAN = Math.PI / 180;
        var prevAngle = -ticksAngles[0].coord * RADIAN;
        var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
        var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
        var clockwise = angleAxisModel.get('clockwise');
        for(var i = 1, len = ticksAngles.length; i <= len; i++){
            var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $h9U3p.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: r0,
                    r: r1,
                    startAngle: prevAngle,
                    endAngle: -coord * RADIAN,
                    clockwise: clockwise
                },
                silent: true
            }));
            prevAngle = -coord * RADIAN;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($h9U3p.mergePath(splitAreas[i], {
            style: $2N6Uo.defaults({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
var $fdf88fabf6f4305e$export$2e2bcd8739ae039 = $fdf88fabf6f4305e$var$AngleAxisView;

});

parcelRegister("6O46R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f4a99ac2e5876b8$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $h9U3p = parcelRequire("h9U3p");

var $fVg7M = parcelRequire("fVg7M");

var $cjjFP = parcelRequire("cjjFP");
var $4f4a99ac2e5876b8$var$selfBuilderAttrs = [
    'splitLine',
    'splitArea',
    'minorSplitLine'
];
var $4f4a99ac2e5876b8$var$RadiusAxisView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RadiusAxisView, _super);
    function RadiusAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisView.type;
        _this.axisPointerClass = 'PolarAxisPointer';
        return _this;
    }
    RadiusAxisView.prototype.render = function(radiusAxisModel, ecModel, api) {
        this.group.removeAll();
        if (!radiusAxisModel.get('show')) return;
        var oldAxisGroup = this._axisGroup;
        var newAxisGroup = this._axisGroup = new $h9U3p.Group();
        this.group.add(newAxisGroup);
        var radiusAxis = radiusAxisModel.axis;
        var polar = radiusAxis.polar;
        var angleAxis = polar.getAngleAxis();
        var ticksCoords = radiusAxis.getTicksCoords();
        var minorTicksCoords = radiusAxis.getMinorTicksCoords();
        var axisAngle = angleAxis.getExtent()[0];
        var radiusExtent = radiusAxis.getExtent();
        var layout = $4f4a99ac2e5876b8$var$layoutAxis(polar, radiusAxisModel, axisAngle);
        var axisBuilder = new (0, $fVg7M.default)(radiusAxisModel, api, layout);
        axisBuilder.build();
        newAxisGroup.add(axisBuilder.group);
        $h9U3p.groupTransition(oldAxisGroup, newAxisGroup, radiusAxisModel);
        $2N6Uo.each($4f4a99ac2e5876b8$var$selfBuilderAttrs, function(name) {
            if (radiusAxisModel.get([
                name,
                'show'
            ]) && !radiusAxis.scale.isBlank()) $4f4a99ac2e5876b8$var$axisElementBuilders[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
        }, this);
    };
    RadiusAxisView.type = 'radiusAxis';
    return RadiusAxisView;
}((0, $cjjFP.default));
var $4f4a99ac2e5876b8$var$axisElementBuilders = {
    splitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        var splitLineModel = radiusAxisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var lineCount = 0;
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? 'Circle' : 'Arc';
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $h9U3p[shapeType]({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    // ensure circle radius >= 0
                    r: Math.max(ticksCoords[i].coord, 0),
                    startAngle: -angleExtent[0] * RADIAN,
                    endAngle: -angleExtent[1] * RADIAN,
                    clockwise: angleAxis.inverse
                }
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($h9U3p.mergePath(splitLines[i], {
            style: $2N6Uo.defaults({
                stroke: lineColors[i % lineColors.length],
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    minorSplitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
        if (!minorTicksCoords.length) return;
        var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var lines = [];
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++)lines.push(new $h9U3p.Circle({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: minorTicksCoords[i][k].coord
            }
        }));
        group.add($h9U3p.mergePath(lines, {
            style: $2N6Uo.defaults({
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    splitArea: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        if (!ticksCoords.length) return;
        var splitAreaModel = radiusAxisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var prevRadius = ticksCoords[0].coord;
        for(var i = 1; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $h9U3p.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: prevRadius,
                    r: ticksCoords[i].coord,
                    startAngle: 0,
                    endAngle: Math.PI * 2
                },
                silent: true
            }));
            prevRadius = ticksCoords[i].coord;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($h9U3p.mergePath(splitAreas[i], {
            style: $2N6Uo.defaults({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
/**
 * @inner
 */ function $4f4a99ac2e5876b8$var$layoutAxis(polar, radiusAxisModel, axisAngle) {
    return {
        position: [
            polar.cx,
            polar.cy
        ],
        rotation: axisAngle / 180 * Math.PI,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1,
        labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
        // Over splitLine and splitArea
        z2: 1
    };
}
var $4f4a99ac2e5876b8$export$2e2bcd8739ae039 = $4f4a99ac2e5876b8$var$RadiusAxisView;

});

parcelRegister("jj5ok", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0e3f94a91790ecb$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $iCU10 = parcelRequire("iCU10");

var $a1eW0 = parcelRequire("a1eW0");
function $e0e3f94a91790ecb$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
}
function $e0e3f94a91790ecb$var$getAxisKey(polar, axis) {
    return axis.dim + polar.model.componentIndex;
}
function $e0e3f94a91790ecb$var$barLayoutPolar(seriesType, ecModel, api) {
    var lastStackCoords = {};
    var barWidthAndOffset = $e0e3f94a91790ecb$var$calRadialBar($2N6Uo.filter(ecModel.getSeriesByType(seriesType), function(seriesModel) {
        return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
    }));
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for polar only
        if (seriesModel.coordinateSystem.type !== 'polar') return;
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $e0e3f94a91790ecb$var$getAxisKey(polar, baseAxis);
        var stackId = $e0e3f94a91790ecb$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = polar.getOtherAxis(baseAxis);
        var cx = seriesModel.coordinateSystem.cx;
        var cy = seriesModel.coordinateSystem.cy;
        var barMinHeight = seriesModel.get('barMinHeight') || 0;
        var barMinAngle = seriesModel.get('barMinAngle') || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $a1eW0.isDimensionStacked)(data, valueDim /* , baseDim */ );
        var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
        var valueAxisModel = valueAxis.model;
        var startValue = valueAxisModel.get('startValue');
        var valueAxisStart = valueAxis.dataToCoord(startValue || 0);
        for(var idx = 0, len = data.count(); idx < len; idx++){
            var value = data.get(valueDim, idx);
            var baseValue = data.get(baseDim, idx);
            var sign = value >= 0 ? 'p' : 'n';
            var baseCoord = valueAxisStart;
            // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            // Only ordinal axis can be stacked.
            if (stacked) {
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var r0 = void 0;
            var r = void 0;
            var startAngle = void 0;
            var endAngle = void 0;
            // radial sector
            if (valueAxis.dim === 'radius') {
                var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
                var angle = baseAxis.dataToCoord(baseValue);
                if (Math.abs(radiusSpan) < barMinHeight) radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
                r0 = baseCoord;
                r = baseCoord + radiusSpan;
                startAngle = angle - columnOffset;
                endAngle = startAngle - columnWidth;
                stacked && (lastStackCoords[stackId][baseValue][sign] = r);
            } else {
                var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
                var radius = baseAxis.dataToCoord(baseValue);
                if (Math.abs(angleSpan) < barMinAngle) angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
                r0 = radius + columnOffset;
                r = r0 + columnWidth;
                startAngle = baseCoord;
                endAngle = baseCoord + angleSpan;
                // if the previous stack is at the end of the ring,
                // add a round to differentiate it from origin
                // let extent = angleAxis.getExtent();
                // let stackCoord = angle;
                // if (stackCoord === extent[0] && value > 0) {
                //     stackCoord = extent[1];
                // }
                // else if (stackCoord === extent[1] && value < 0) {
                //     stackCoord = extent[0];
                // }
                stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
            }
            data.setItemLayout(idx, {
                cx: cx,
                cy: cy,
                r0: r0,
                r: r,
                // Consider that positive angle is anti-clockwise,
                // while positive radian of sector is clockwise
                startAngle: -startAngle * Math.PI / 180,
                endAngle: -endAngle * Math.PI / 180,
                /**
         * Keep the same logic with bar in catesion: use end value to
         * control direction. Notice that if clockwise is true (by
         * default), the sector will always draw clockwisely, no matter
         * whether endAngle is greater or less than startAngle.
         */ clockwise: startAngle >= endAngle
            });
        }
    });
}
/**
 * Calculate bar width and offset for radial bar charts
 */ function $e0e3f94a91790ecb$var$calRadialBar(barSeries) {
    // Columns info on each category axis. Key is polar name
    var columnsMap = {};
    $2N6Uo.each(barSeries, function(seriesModel, idx) {
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $e0e3f94a91790ecb$var$getAxisKey(polar, baseAxis);
        var axisExtent = baseAxis.getExtent();
        var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: '20%',
            gap: '30%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = $e0e3f94a91790ecb$var$getSeriesStackId(seriesModel);
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        var barWidth = (0, $iCU10.parsePercent)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $iCU10.parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        if (barWidth && !stacks[stackId].width) {
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            stacks[stackId].width = barWidth;
            columnsOnAxis.remainedWidth -= barWidth;
        }
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        barGap != null && (columnsOnAxis.gap = barGap);
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $2N6Uo.each(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGap = (0, $iCU10.parsePercent)(columnsOnAxis.categoryGap, bandWidth);
        var barGapPercent = (0, $iCU10.parsePercent)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        $2N6Uo.each(stacks, function(column, stack) {
            var maxWidth = column.maxWidth;
            if (maxWidth && maxWidth < autoWidth) {
                maxWidth = Math.min(maxWidth, remainedWidth);
                if (column.width) maxWidth = Math.min(maxWidth, column.width);
                remainedWidth -= maxWidth;
                column.width = maxWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $2N6Uo.each(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $2N6Uo.each(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
var $e0e3f94a91790ecb$export$2e2bcd8739ae039 = $e0e3f94a91790ecb$var$barLayoutPolar;

});


parcelRegister("brswz", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $854857a9f94b51cd$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $gX19P = parcelRequire("gX19P");

var $bpyST = parcelRequire("bpyST");

var $jSeiN = parcelRequire("jSeiN");

var $lzKMz = parcelRequire("lzKMz");

var $7v3HL = parcelRequire("7v3HL");

var $2AvKT = parcelRequire("2AvKT");

var $24qes = parcelRequire("24qes");

var $cjjFP = parcelRequire("cjjFP");

var $7yzD3 = parcelRequire("7yzD3");
var $854857a9f94b51cd$var$SingleView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SingleView, _super);
    function SingleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleView.type;
        return _this;
    }
    SingleView.type = 'single';
    return SingleView;
}((0, $bpyST.default));
function $854857a9f94b51cd$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $24qes.install));
    (0, $cjjFP.default).registerAxisPointerClass('SingleAxisPointer', (0, $7yzD3.default));
    registers.registerComponentView($854857a9f94b51cd$var$SingleView);
    // Axis
    registers.registerComponentView((0, $jSeiN.default));
    registers.registerComponentModel((0, $7v3HL.default));
    (0, $lzKMz.default)(registers, 'single', (0, $7v3HL.default), (0, $7v3HL.default).defaultOption);
    registers.registerCoordinateSystem('single', (0, $2AvKT.default));
}

});
parcelRegister("jSeiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e77e279602dddcbf$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $fVg7M = parcelRequire("fVg7M");

var $iQonF = parcelRequire("iQonF");
var $h9U3p = parcelRequire("h9U3p");
var $c3CaY = parcelRequire("c3CaY");

var $g3i9V = parcelRequire("g3i9V");

var $cjjFP = parcelRequire("cjjFP");

var $dcfmi = parcelRequire("dcfmi");

var $Etgh3 = parcelRequire("Etgh3");
var $e77e279602dddcbf$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'breakArea'
];
var $e77e279602dddcbf$var$SingleAxisView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SingleAxisView, _super);
    function SingleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisView.type;
        _this.axisPointerClass = 'SingleAxisPointer';
        return _this;
    }
    SingleAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $iQonF.default();
        var layout = $g3i9V.layout(axisModel);
        var axisBuilder = new (0, $fVg7M.default)(axisModel, api, layout);
        axisBuilder.build();
        group.add(this._axisGroup);
        group.add(axisBuilder.group);
        $2N6Uo.each($e77e279602dddcbf$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $e77e279602dddcbf$var$axisElementBuilders[name](this, this.group, this._axisGroup, axisModel, api);
        }, this);
        $h9U3p.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    SingleAxisView.prototype.remove = function() {
        (0, $dcfmi.rectCoordAxisHandleRemove)(this);
    };
    SingleAxisView.type = 'singleAxis';
    return SingleAxisView;
}((0, $cjjFP.default));
var $e77e279602dddcbf$var$axisElementBuilders = {
    splitLine: function(axisView, group, axisGroup, axisModel, api) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var lineWidth = lineStyleModel.get('width');
        var gridRect = axisModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var splitLines = [];
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel,
            breakTicks: 'none',
            pruneByBreak: 'preserve_extent_bound'
        });
        var p1 = [];
        var p2 = [];
        for(var i = 0; i < ticksCoords.length; ++i){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $c3CaY.default({
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                silent: true
            });
            $h9U3p.subPixelOptimizeLine(line.shape, lineWidth);
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(line);
        }
        var lineStyle = lineStyleModel.getLineStyle([
            'color'
        ]);
        for(var i = 0; i < splitLines.length; ++i)group.add($h9U3p.mergePath(splitLines[i], {
            style: $2N6Uo.defaults({
                stroke: lineColors[i % lineColors.length]
            }, lineStyle),
            silent: true
        }));
    },
    splitArea: function(axisView, group, axisGroup, axisModel, api) {
        (0, $dcfmi.rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, axisModel);
    },
    breakArea: function(axisView, group, axisGroup, axisModel, api) {
        var axisBreakHelper = (0, $Etgh3.getAxisBreakHelper)();
        var scale = axisModel.axis.scale;
        if (axisBreakHelper && scale.type !== 'ordinal') axisBreakHelper.rectCoordBuildBreakAxis(group, axisView, axisModel, axisModel.coordinateSystem.getRect(), api);
    }
};
var $e77e279602dddcbf$export$2e2bcd8739ae039 = $e77e279602dddcbf$var$SingleAxisView;

});
parcelRegister("g3i9V", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $bafb032f8fb6e659$export$b3219800bda33a1f; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $bafb032f8fb6e659$export$b3219800bda33a1f(axisModel, opt) {
    opt = opt || {};
    var single = axisModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var axisPosition = axis.position;
    var orient = axis.orient;
    var rect = single.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var positionMap = {
        horizontal: {
            top: rectBound[2],
            bottom: rectBound[3]
        },
        vertical: {
            left: rectBound[0],
            right: rectBound[1]
        }
    };
    layout.position = [
        orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0],
        orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]
    ];
    var r = {
        horizontal: 0,
        vertical: 1
    };
    layout.rotation = Math.PI / 2 * r[orient];
    var directionMap = {
        top: -1,
        bottom: 1,
        right: 1,
        left: -1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($2N6Uo.retrieve(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
    layout.z2 = 1;
    return layout;
}

});


parcelRegister("7v3HL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $575e4d5bed5577a3$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");

var $fRzLp = parcelRequire("fRzLp");

var $2N6Uo = parcelRequire("2N6Uo");
var $575e4d5bed5577a3$var$SingleAxisModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SingleAxisModel, _super);
    function SingleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisModel.type;
        return _this;
    }
    SingleAxisModel.prototype.getCoordSysModel = function() {
        return this;
    };
    SingleAxisModel.type = 'singleAxis';
    SingleAxisModel.layoutMode = 'box';
    SingleAxisModel.defaultOption = {
        left: '5%',
        top: '5%',
        right: '5%',
        bottom: '5%',
        type: 'value',
        position: 'bottom',
        orient: 'horizontal',
        axisLine: {
            show: true,
            lineStyle: {
                width: 1,
                type: 'solid'
            }
        },
        // Single coordinate system and single axis is the,
        // which is used as the parent tooltip model.
        // same model, so we set default tooltip show as true.
        tooltip: {
            show: true
        },
        axisTick: {
            show: true,
            length: 6,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            interval: 'auto'
        },
        splitLine: {
            show: true,
            lineStyle: {
                type: 'dashed',
                opacity: 0.2
            }
        },
        jitter: 0,
        jitterOverlap: true,
        jitterMargin: 2
    };
    return SingleAxisModel;
}((0, $eLD2b.default));
(0, $2N6Uo.mixin)($575e4d5bed5577a3$var$SingleAxisModel, (0, $fRzLp.AxisModelCommonMixin).prototype);
var $575e4d5bed5577a3$export$2e2bcd8739ae039 = $575e4d5bed5577a3$var$SingleAxisModel;

});

parcelRegister("2AvKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e27938588589930$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinate system creator.
 */ 
var $i020X = parcelRequire("i020X");

var $bx3T8 = parcelRequire("bx3T8");
/**
 * Create single coordinate system and inject it into seriesModel.
 */ function $1e27938588589930$var$create(ecModel, api) {
    var singles = [];
    ecModel.eachComponent('singleAxis', function(axisModel, idx) {
        var single = new (0, $i020X.default)(axisModel, ecModel, api);
        single.name = 'single_' + idx;
        single.resize(axisModel, api);
        axisModel.coordinateSystem = single;
        singles.push(single);
    });
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get('coordinateSystem') === 'singleAxis') {
            var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $bx3T8.SINGLE_REFERRING)).models[0];
            seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
        }
    });
    return singles;
}
var $1e27938588589930$var$singleCreator = {
    create: $1e27938588589930$var$create,
    dimensions: (0, $i020X.singleDimensions)
};
var $1e27938588589930$export$2e2bcd8739ae039 = $1e27938588589930$var$singleCreator;

});
parcelRegister("i020X", function(module, exports) {

$parcel$export(module.exports, "singleDimensions", function () { return $d1a9ca1c71888ec9$export$28486687f659fb1a; });
$parcel$export(module.exports, "default", function () { return $d1a9ca1c71888ec9$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinates system.
 */ 
var $5PvLa = parcelRequire("5PvLa");

var $9AF98 = parcelRequire("9AF98");

var $a35Wn = parcelRequire("a35Wn");

var $2N6Uo = parcelRequire("2N6Uo");
var $d1a9ca1c71888ec9$export$28486687f659fb1a = [
    'single'
];
/**
 * Create a single coordinates system.
 */ var $d1a9ca1c71888ec9$var$Single = /** @class */ function() {
    function Single(axisModel, ecModel, api) {
        this.type = 'single';
        this.dimension = 'single';
        /**
     * Add it just for draw tooltip.
     */ this.dimensions = $d1a9ca1c71888ec9$export$28486687f659fb1a;
        this.axisPointerEnabled = true;
        this.model = axisModel;
        this._init(axisModel, ecModel, api);
    }
    /**
   * Initialize single coordinate system.
   */ Single.prototype._init = function(axisModel, ecModel, api) {
        var dim = this.dimension;
        var axis = new (0, $5PvLa.default)(dim, $9AF98.createScaleByModel(axisModel), [
            0,
            0
        ], axisModel.get('type'), axisModel.get('position'));
        var isCategory = axis.type === 'category';
        axis.onBand = isCategory && axisModel.get('boundaryGap');
        axis.inverse = axisModel.get('inverse');
        axis.orient = axisModel.get('orient');
        axisModel.axis = axis;
        axis.model = axisModel;
        axis.coordinateSystem = this;
        this._axis = axis;
    };
    /**
   * Update axis scale after data processed
   */ Single.prototype.update = function(ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.coordinateSystem === this) {
                var data_1 = seriesModel.getData();
                (0, $2N6Uo.each)(data_1.mapDimensionsAll(this.dimension), function(dim) {
                    this._axis.scale.unionExtentFromData(data_1, dim);
                }, this);
                $9AF98.niceScaleExtent(this._axis.scale, this._axis.model);
            }
        }, this);
    };
    /**
   * Resize the single coordinate system.
   */ Single.prototype.resize = function(axisModel, api) {
        var refContainer = (0, $a35Wn.createBoxLayoutReference)(axisModel, api).refContainer;
        this._rect = (0, $a35Wn.getLayoutRect)(axisModel.getBoxLayoutParams(), refContainer);
        this._adjustAxis();
    };
    Single.prototype.getRect = function() {
        return this._rect;
    };
    Single.prototype._adjustAxis = function() {
        var rect = this._rect;
        var axis = this._axis;
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [
            0,
            rect.width
        ] : [
            0,
            rect.height
        ];
        var idx = axis.inverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
    };
    Single.prototype._updateAxisTransform = function(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var extentSum = axisExtent[0] + axisExtent[1];
        var isHorizontal = axis.isHorizontal();
        axis.toGlobalCoord = isHorizontal ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
        axis.toLocalCoord = isHorizontal ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
    };
    /**
   * Get axis.
   */ Single.prototype.getAxis = function() {
        return this._axis;
    };
    /**
   * Get axis, add it just for draw tooltip.
   */ Single.prototype.getBaseAxis = function() {
        return this._axis;
    };
    Single.prototype.getAxes = function() {
        return [
            this._axis
        ];
    };
    Single.prototype.getTooltipAxes = function() {
        return {
            baseAxes: [
                this.getAxis()
            ],
            // Empty otherAxes
            otherAxes: []
        };
    };
    /**
   * If contain point.
   */ Single.prototype.containPoint = function(point) {
        var rect = this.getRect();
        var axis = this.getAxis();
        var orient = axis.orient;
        if (orient === 'horizontal') return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
        else return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    };
    Single.prototype.pointToData = function(point, reserved, out) {
        out = out || [];
        var axis = this.getAxis();
        out[0] = axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]));
        return out;
    };
    /**
   * Convert the series data to concrete point.
   * Can be [val] | val
   */ Single.prototype.dataToPoint = function(val, reserved, out) {
        var axis = this.getAxis();
        var rect = this.getRect();
        out = out || [];
        var idx = axis.orient === 'horizontal' ? 0 : 1;
        if (val instanceof Array) val = val[0];
        out[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
        out[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
        return out;
    };
    Single.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $d1a9ca1c71888ec9$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Single.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $d1a9ca1c71888ec9$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Single;
}();
function $d1a9ca1c71888ec9$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var singleModel = finder.singleAxisModel;
    return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $d1a9ca1c71888ec9$export$2e2bcd8739ae039 = $d1a9ca1c71888ec9$var$Single;

});
parcelRegister("5PvLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43ea59fb52500b06$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $6ZMAw = parcelRequire("6ZMAw");
var $43ea59fb52500b06$var$SingleAxis = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SingleAxis, _super);
    function SingleAxis(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    /**
   * Judge the orient of the axis.
   */ SingleAxis.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    SingleAxis.prototype.pointToData = function(point, clamp) {
        return this.coordinateSystem.pointToData(point)[0];
    };
    return SingleAxis;
}((0, $6ZMAw.default));
var $43ea59fb52500b06$export$2e2bcd8739ae039 = $43ea59fb52500b06$var$SingleAxis;

});



parcelRegister("7yzD3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5807588817e6cf77$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $fW5EC = parcelRequire("fW5EC");

var $7bAwM = parcelRequire("7bAwM");

var $g3i9V = parcelRequire("g3i9V");
var $5807588817e6cf77$var$XY = [
    'x',
    'y'
];
var $5807588817e6cf77$var$WH = [
    'width',
    'height'
];
var $5807588817e6cf77$var$SingleAxisPointer = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SingleAxisPointer, _super);
    function SingleAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ SingleAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var otherExtent = $5807588817e6cf77$var$getGlobalExtent(coordSys, 1 - $5807588817e6cf77$var$getPointDimIndex(axis));
        var pixelValue = coordSys.dataToPoint(value)[0];
        var axisPointerType = axisPointerModel.get('type');
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $7bAwM.buildElStyle(axisPointerModel);
            var pointerOption = $5807588817e6cf77$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $g3i9V.layout(axisModel);
        $7bAwM.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $g3i9V.layout(axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var position = $7bAwM.getTransformedPosition(axisModel.axis, value, layoutInfo);
        return {
            x: position[0],
            y: position[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var dimIndex = $5807588817e6cf77$var$getPointDimIndex(axis);
        var axisExtent = $5807588817e6cf77$var$getGlobalExtent(coordSys, dimIndex);
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var otherExtent = $5807588817e6cf77$var$getGlobalExtent(coordSys, 1 - dimIndex);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: {
                verticalAlign: 'middle'
            }
        };
    };
    return SingleAxisPointer;
}((0, $fW5EC.default));
var $5807588817e6cf77$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $7bAwM.makeLineShape([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $5807588817e6cf77$var$getPointDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = axis.getBandWidth();
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $7bAwM.makeRectShape([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $5807588817e6cf77$var$getPointDimIndex(axis))
        };
    }
};
function $5807588817e6cf77$var$getPointDimIndex(axis) {
    return axis.isHorizontal() ? 0 : 1;
}
function $5807588817e6cf77$var$getGlobalExtent(coordSys, dimIndex) {
    var rect = coordSys.getRect();
    return [
        rect[$5807588817e6cf77$var$XY[dimIndex]],
        rect[$5807588817e6cf77$var$XY[dimIndex]] + rect[$5807588817e6cf77$var$WH[dimIndex]]
    ];
}
var $5807588817e6cf77$export$2e2bcd8739ae039 = $5807588817e6cf77$var$SingleAxisPointer;

});


parcelRegister("G1KlT", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $07e547332d38304b$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $81mjT = parcelRequire("81mjT");

var $kyEOI = parcelRequire("kyEOI");
function $07e547332d38304b$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $81mjT.ThumbnailModel));
    registers.registerComponentView((0, $kyEOI.ThumbnailView));
}

});
parcelRegister("81mjT", function(module, exports) {

$parcel$export(module.exports, "ThumbnailModel", function () { return $5d6fbafa3eaca820$export$f107faa448341c12; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");


var $6aXXD = parcelRequire("6aXXD");

var $YaX0v = parcelRequire("YaX0v");

var $4Aeux = parcelRequire("4Aeux");
var $5d6fbafa3eaca820$export$f107faa448341c12 = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ThumbnailModel, _super);
    function ThumbnailModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThumbnailModel.type;
        _this.preventAutoZ = true;
        return _this;
    }
    ThumbnailModel.prototype.optionUpdated = function(newCptOption, isInit) {
        this._updateBridge();
    };
    ThumbnailModel.prototype._updateBridge = function() {
        var bridge = this._birdge = this._birdge || new (0, $4Aeux.ThumbnailBridgeImpl)(this);
        // Clear all, in case of option changed.
        this._target = null;
        this.ecModel.eachSeries(function(series) {
            (0, $YaX0v.injectThumbnailBridge)(series, null);
        });
        if (this.shouldShow()) {
            var target = this.getTarget();
            // If a component is targeted by more than one thumbnails, simply only the last one works.
            (0, $YaX0v.injectThumbnailBridge)(target.baseMapProvider, bridge);
        }
    };
    ThumbnailModel.prototype.shouldShow = function() {
        return this.getShallow('show', true);
    };
    ThumbnailModel.prototype.getBridge = function() {
        return this._birdge;
    };
    ThumbnailModel.prototype.getTarget = function() {
        if (this._target) return this._target;
        // Find by `seriesId`/`seriesIndex`.
        var series = this.getReferringComponents('series', {
            useDefault: false,
            enableAll: false,
            enableNone: false
        }).models[0];
        if (series) {
            if (series.subType !== 'graph') series = null;
        } else // If no xxxId and xxxIndex specified, find the first series.graph. If other components,
        // such as geo, is supported in future, the default stretagy may be extended.
        series = this.ecModel.queryComponents({
            mainType: 'series',
            subType: 'graph'
        })[0];
        this._target = {
            baseMapProvider: series
        };
        return this._target;
    };
    ThumbnailModel.type = 'thumbnail';
    ThumbnailModel.layoutMode = 'box';
    // All the supported components should be added here.
    ThumbnailModel.dependencies = [
        'series',
        'geo'
    ];
    ThumbnailModel.defaultOption = {
        show: true,
        right: 1,
        bottom: 1,
        height: '25%',
        width: '25%',
        itemStyle: {
            // Use echarts option.backgorundColor by default.
            borderColor: (0, $6aXXD.default).color.border,
            borderWidth: 2
        },
        windowStyle: {
            borderWidth: 1,
            color: (0, $6aXXD.default).color.neutral30,
            borderColor: (0, $6aXXD.default).color.neutral40,
            opacity: 0.3
        },
        z: 10
    };
    return ThumbnailModel;
}((0, $eLD2b.default));

});
parcelRegister("4Aeux", function(module, exports) {

$parcel$export(module.exports, "ThumbnailBridgeImpl", function () { return $3565c3f5062b28fe$export$69d81bd4a41e2e2b; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $h9U3p = parcelRequire("h9U3p");
/**
 * [CAVEAT]: the call order of `ThumbnailView['render']` and other
 *  `ChartView['render']/ComponentView['render']` is not guaranteed.
 */ var $3565c3f5062b28fe$export$69d81bd4a41e2e2b = /** @class */ function() {
    function ThumbnailBridgeImpl(thumbnailModel) {
        this._thumbnailModel = thumbnailModel;
    }
    ThumbnailBridgeImpl.prototype.reset = function(api) {
        this._renderVersion = api.getMainProcessVersion();
    };
    ThumbnailBridgeImpl.prototype.renderContent = function(opt) {
        var thumbnailView = opt.api.getViewOfComponentModel(this._thumbnailModel);
        if (!thumbnailView) return;
        opt.group.silent = true;
        thumbnailView.renderContent({
            group: opt.group,
            targetTrans: opt.targetTrans,
            z2Range: (0, $h9U3p.calcZ2Range)(opt.group),
            roamType: opt.roamType,
            viewportRect: opt.viewportRect,
            renderVersion: this._renderVersion
        });
    };
    ThumbnailBridgeImpl.prototype.updateWindow = function(targetTrans, api) {
        var thumbnailView = api.getViewOfComponentModel(this._thumbnailModel);
        if (!thumbnailView) return;
        thumbnailView.updateWindow({
            targetTrans: targetTrans,
            renderVersion: this._renderVersion
        });
    };
    return ThumbnailBridgeImpl;
}();

});


parcelRegister("kyEOI", function(module, exports) {

$parcel$export(module.exports, "ThumbnailView", function () { return $ef76a50633336c5b$export$f06e14e146c0b896; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $bpyST = parcelRequire("bpyST");

var $67W72 = parcelRequire("67W72");

var $19Ywy = parcelRequire("19Ywy");

var $ic6Qi = parcelRequire("ic6Qi");

var $6aXXD = parcelRequire("6aXXD");

var $a35Wn = parcelRequire("a35Wn");

var $h9U3p = parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");
var $iQonF = parcelRequire("iQonF");

var $U1aqY = parcelRequire("U1aqY");

var $11tae = parcelRequire("11tae");

var $2N6Uo = parcelRequire("2N6Uo");
var $ef76a50633336c5b$export$f06e14e146c0b896 = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ThumbnailView, _super);
    function ThumbnailView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThumbnailView.type;
        return _this;
    }
    ThumbnailView.prototype.render = function(thumbnailModel, ecModel, api) {
        this._api = api;
        this._model = thumbnailModel;
        if (!this._coordSys) this._coordSys = new (0, $11tae.default)();
        if (!this._isEnabled()) {
            this._clear();
            return;
        }
        this._renderVersion = api.getMainProcessVersion();
        var group = this.group;
        group.removeAll();
        var itemStyleModel = thumbnailModel.getModel('itemStyle');
        var itemStyle = itemStyleModel.getItemStyle();
        if (itemStyle.fill == null) itemStyle.fill = ecModel.get('backgroundColor') || (0, $6aXXD.default).color.neutral00;
        var refContainer = (0, $a35Wn.createBoxLayoutReference)(thumbnailModel, api).refContainer;
        var boxRect = (0, $a35Wn.getLayoutRect)((0, $a35Wn.getBoxLayoutParams)(thumbnailModel, true), refContainer);
        var boxBorderWidth = itemStyle.lineWidth || 0;
        var contentRect = this._contentRect = (0, $h9U3p.expandOrShrinkRect)(boxRect.clone(), boxBorderWidth / 2, true, true);
        var contentGroup = new (0, $iQonF.default)();
        group.add(contentGroup);
        contentGroup.setClipPath(new (0, $aH2k0.default)({
            shape: contentRect.plain()
        }));
        var targetGroup = this._targetGroup = new (0, $iQonF.default)();
        contentGroup.add(targetGroup);
        // Draw border and background and shadow of thumbnail box.
        var borderShape = boxRect.plain();
        borderShape.r = itemStyleModel.getShallow('borderRadius', true);
        group.add(this._bgRect = new (0, $aH2k0.default)({
            style: itemStyle,
            shape: borderShape,
            silent: false,
            cursor: 'grab'
        }));
        var windowStyleModel = thumbnailModel.getModel('windowStyle');
        var windowR = windowStyleModel.getShallow('borderRadius', true);
        contentGroup.add(this._windowRect = new (0, $aH2k0.default)({
            shape: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                r: windowR
            },
            style: windowStyleModel.getItemStyle(),
            silent: false,
            cursor: 'grab'
        }));
        this._dealRenderContent();
        this._dealUpdateWindow();
        $ef76a50633336c5b$var$updateZ(thumbnailModel, this);
    };
    /**
   * Can be called asynchronously directly.
   * This method should be idempotent.
   */ ThumbnailView.prototype.renderContent = function(bridgeRendered) {
        this._bridgeRendered = bridgeRendered;
        if (this._isEnabled()) {
            this._dealRenderContent();
            this._dealUpdateWindow();
            $ef76a50633336c5b$var$updateZ(this._model, this);
        }
    };
    ThumbnailView.prototype._dealRenderContent = function() {
        var bridgeRendered = this._bridgeRendered;
        if (!bridgeRendered || bridgeRendered.renderVersion !== this._renderVersion) return;
        var targetGroup = this._targetGroup;
        var coordSys = this._coordSys;
        var contentRect = this._contentRect;
        targetGroup.removeAll();
        if (!bridgeRendered) return;
        var bridgeGroup = bridgeRendered.group;
        var bridgeRect = bridgeGroup.getBoundingRect();
        targetGroup.add(bridgeGroup);
        this._bgRect.z2 = bridgeRendered.z2Range.min - 10;
        coordSys.setBoundingRect(bridgeRect.x, bridgeRect.y, bridgeRect.width, bridgeRect.height);
        // Use `getLayoutRect` is just to find an approperiate rect in thumbnail.
        var viewRect = (0, $a35Wn.getLayoutRect)({
            left: 'center',
            top: 'center',
            aspect: bridgeRect.width / bridgeRect.height
        }, contentRect);
        coordSys.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
        bridgeGroup.attr(coordSys.getTransformInfo().raw);
        this._windowRect.z2 = bridgeRendered.z2Range.max + 10;
        this._resetRoamController(bridgeRendered.roamType);
    };
    /**
   * Can be called from action handler directly.
   * This method should be idempotent.
   */ ThumbnailView.prototype.updateWindow = function(param) {
        var bridgeRendered = this._bridgeRendered;
        if (bridgeRendered && bridgeRendered.renderVersion === param.renderVersion) bridgeRendered.targetTrans = param.targetTrans;
        if (this._isEnabled()) this._dealUpdateWindow();
    };
    ThumbnailView.prototype._dealUpdateWindow = function() {
        var bridgeRendered = this._bridgeRendered;
        if (!bridgeRendered || bridgeRendered.renderVersion !== this._renderVersion) return;
        var invTargetTrans = $19Ywy.invert([], bridgeRendered.targetTrans);
        var transTargetToThis = $19Ywy.mul([], this._coordSys.transform, invTargetTrans);
        this._transThisToTarget = $19Ywy.invert([], transTargetToThis);
        var viewportRect = bridgeRendered.viewportRect;
        if (!viewportRect) viewportRect = new (0, $67W72.default)(0, 0, this._api.getWidth(), this._api.getHeight());
        else viewportRect = viewportRect.clone();
        viewportRect.applyTransform(transTargetToThis);
        var windowRect = this._windowRect;
        var r = windowRect.shape.r;
        windowRect.setShape((0, $2N6Uo.defaults)({
            r: r
        }, viewportRect));
    };
    ThumbnailView.prototype._resetRoamController = function(roamType) {
        var _this = this;
        var api = this._api;
        var roamController = this._roamController;
        if (!roamController) roamController = this._roamController = new (0, $ic6Qi.default)(api.getZr());
        if (!roamType || !this._isEnabled()) {
            roamController.disable();
            return;
        }
        roamController.enable(roamType, {
            api: api,
            zInfo: {
                component: this._model
            },
            triggerInfo: {
                roamTrigger: null,
                isInSelf: function(e, x, y) {
                    return _this._contentRect.contain(x, y);
                }
            }
        });
        roamController.off('pan').off('zoom').on('pan', (0, $2N6Uo.bind)(this._onPan, this)).on('zoom', (0, $2N6Uo.bind)(this._onZoom, this));
    };
    ThumbnailView.prototype._onPan = function(event) {
        var trans = this._transThisToTarget;
        if (!this._isEnabled() || !trans) return;
        var oldOffset = (0, $U1aqY.applyTransform)([], [
            event.oldX,
            event.oldY
        ], trans);
        var newOffset = (0, $U1aqY.applyTransform)([], [
            event.oldX - event.dx,
            event.oldY - event.dy
        ], trans);
        this._api.dispatchAction($ef76a50633336c5b$var$makeRoamPayload(this._model.getTarget().baseMapProvider, {
            dx: newOffset[0] - oldOffset[0],
            dy: newOffset[1] - oldOffset[1]
        }));
    };
    ThumbnailView.prototype._onZoom = function(event) {
        var trans = this._transThisToTarget;
        if (!this._isEnabled() || !trans) return;
        var offset = (0, $U1aqY.applyTransform)([], [
            event.originX,
            event.originY
        ], trans);
        this._api.dispatchAction($ef76a50633336c5b$var$makeRoamPayload(this._model.getTarget().baseMapProvider, {
            zoom: 1 / event.scale,
            originX: offset[0],
            originY: offset[1]
        }));
    };
    /**
   * This method is also responsible for check enable in asynchronous situation,
   * e.g., in event listeners that is supposed to be outdated but not be removed.
   */ ThumbnailView.prototype._isEnabled = function() {
        var thumbnailModel = this._model;
        if (!thumbnailModel || !thumbnailModel.shouldShow()) return false;
        var baseMapProvider = thumbnailModel.getTarget().baseMapProvider;
        if (!baseMapProvider) return false;
        return true;
    };
    ThumbnailView.prototype._clear = function() {
        this.group.removeAll();
        this._bridgeRendered = null;
        if (this._roamController) this._roamController.disable();
    };
    ThumbnailView.prototype.remove = function() {
        this._clear();
    };
    ThumbnailView.prototype.dispose = function() {
        this._clear();
    };
    ThumbnailView.type = 'thumbnail';
    return ThumbnailView;
}((0, $bpyST.default));
function $ef76a50633336c5b$var$makeRoamPayload(baseMapProvider, params) {
    var type = baseMapProvider.mainType === 'series' ? baseMapProvider.subType + "Roam" // e.g. 'graphRoam'
     : baseMapProvider.mainType + "Roam"; // e.g., 'geoRoam'
    var payload = {
        type: type
    };
    payload[baseMapProvider.mainType + "Id"] = baseMapProvider.id;
    (0, $2N6Uo.extend)(payload, params);
    return payload;
}
function $ef76a50633336c5b$var$updateZ(thumbnailModel, thumbnailView) {
    var zInfo = (0, $h9U3p.retrieveZInfo)(thumbnailModel);
    (0, $h9U3p.traverseUpdateZ)(thumbnailView.group, zInfo.z, zInfo.zlevel);
}

});


parcelRegister("gRi3p", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $c45f99bf72d9c9ce$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $2TzNz = parcelRequire("2TzNz");

var $4wczu = parcelRequire("4wczu");

var $bCVXF = parcelRequire("bCVXF");

var $cLcgy = parcelRequire("cLcgy");
function $c45f99bf72d9c9ce$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2TzNz.default));
    registers.registerComponentView((0, $4wczu.default));
    registers.registerSubTypeDefaulter('timeline', function() {
        // Only slider now.
        return 'slider';
    });
    (0, $bCVXF.installTimelineAction)(registers);
    registers.registerPreprocessor((0, $cLcgy.default));
}

});
parcelRegister("2TzNz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21bc7caa1d86242c$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $i6qrm = parcelRequire("i6qrm");

var $7NPXc = parcelRequire("7NPXc");

var $2N6Uo = parcelRequire("2N6Uo");

var $cKPmR = parcelRequire("cKPmR");

var $6aXXD = parcelRequire("6aXXD");
var $21bc7caa1d86242c$var$SliderTimelineModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SliderTimelineModel, _super);
    function SliderTimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineModel.type;
        return _this;
    }
    SliderTimelineModel.type = 'timeline.slider';
    /**
   * @protected
   */ SliderTimelineModel.defaultOption = (0, $cKPmR.inheritDefaultOption)((0, $i6qrm.default).defaultOption, {
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: (0, $6aXXD.default).color.border,
        borderWidth: 0,
        orient: 'horizontal',
        inverse: false,
        tooltip: {
            trigger: 'item' // data item may also have tootip attr.
        },
        symbol: 'circle',
        symbolSize: 12,
        lineStyle: {
            show: true,
            width: 2,
            color: (0, $6aXXD.default).color.accent10
        },
        label: {
            position: 'auto',
            // When using number, label position is not
            // restricted by viewRect.
            // positive: right/bottom, negative: left/top
            show: true,
            interval: 'auto',
            rotate: 0,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: (0, $6aXXD.default).color.tertiary
        },
        itemStyle: {
            color: (0, $6aXXD.default).color.accent20,
            borderWidth: 0
        },
        checkpointStyle: {
            symbol: 'circle',
            symbolSize: 15,
            color: (0, $6aXXD.default).color.accent50,
            borderColor: (0, $6aXXD.default).color.accent50,
            borderWidth: 0,
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(0, 0, 0, 0)',
            // borderColor: 'rgba(194,53,49, 0.5)',
            animation: true,
            animationDuration: 300,
            animationEasing: 'quinticInOut'
        },
        controlStyle: {
            show: true,
            showPlayBtn: true,
            showPrevBtn: true,
            showNextBtn: true,
            itemSize: 24,
            itemGap: 12,
            position: 'left',
            playIcon: 'path://M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3ZM11.5 10.6699C11.5 9.90014 12.3333 9.41887 13 9.80371L20.5 14.1338C21.1667 14.5187 21.1667 15.4813 20.5 15.8662L13 20.1963C12.3333 20.5811 11.5 20.0999 11.5 19.3301V10.6699Z',
            stopIcon: 'path://M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3ZM11.5 10C12.3284 10 13 10.6716 13 11.5V18.5C13 19.3284 12.3284 20 11.5 20C10.6716 20 10 19.3284 10 18.5V11.5C10 10.6716 10.6716 10 11.5 10ZM18.5 10C19.3284 10 20 10.6716 20 11.5V18.5C20 19.3284 19.3284 20 18.5 20C17.6716 20 17 19.3284 17 18.5V11.5C17 10.6716 17.6716 10 18.5 10Z',
            // eslint-disable-next-line max-len
            nextIcon: 'path://M0.838834 18.7383C0.253048 18.1525 0.253048 17.2028 0.838834 16.617L7.55635 9.89949L0.838834 3.18198C0.253048 2.59619 0.253048 1.64645 0.838834 1.06066C1.42462 0.474874 2.37437 0.474874 2.96015 1.06066L10.7383 8.83883L10.8412 8.95277C11.2897 9.50267 11.2897 10.2963 10.8412 10.8462L10.7383 10.9602L2.96015 18.7383C2.37437 19.3241 1.42462 19.3241 0.838834 18.7383Z',
            // eslint-disable-next-line max-len
            prevIcon: 'path://M10.9602 1.06066C11.5459 1.64645 11.5459 2.59619 10.9602 3.18198L4.24264 9.89949L10.9602 16.617C11.5459 17.2028 11.5459 18.1525 10.9602 18.7383C10.3744 19.3241 9.42462 19.3241 8.83883 18.7383L1.06066 10.9602L0.957771 10.8462C0.509245 10.2963 0.509245 9.50267 0.957771 8.95277L1.06066 8.83883L8.83883 1.06066C9.42462 0.474874 10.3744 0.474874 10.9602 1.06066Z',
            prevBtnSize: 18,
            nextBtnSize: 18,
            color: (0, $6aXXD.default).color.accent50,
            borderColor: (0, $6aXXD.default).color.accent50,
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: (0, $6aXXD.default).color.accent60
            },
            itemStyle: {
                color: (0, $6aXXD.default).color.accent60,
                borderColor: (0, $6aXXD.default).color.accent60
            },
            controlStyle: {
                color: (0, $6aXXD.default).color.accent70,
                borderColor: (0, $6aXXD.default).color.accent70
            }
        },
        progress: {
            lineStyle: {
                color: (0, $6aXXD.default).color.accent30
            },
            itemStyle: {
                color: (0, $6aXXD.default).color.accent40
            }
        },
        data: []
    });
    return SliderTimelineModel;
}((0, $i6qrm.default));
(0, $2N6Uo.mixin)($21bc7caa1d86242c$var$SliderTimelineModel, (0, $7NPXc.DataFormatMixin).prototype);
var $21bc7caa1d86242c$export$2e2bcd8739ae039 = $21bc7caa1d86242c$var$SliderTimelineModel;

});
parcelRegister("i6qrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2dd4c07163c9b65$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");

var $2kN4z = parcelRequire("2kN4z");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $6aXXD = parcelRequire("6aXXD");
var $d2dd4c07163c9b65$var$TimelineModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TimelineModel, _super);
    function TimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineModel.type;
        _this.layoutMode = 'box';
        return _this;
    }
    /**
   * @override
   */ TimelineModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._initData();
    };
    /**
   * @override
   */ TimelineModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this._initData();
    };
    TimelineModel.prototype.setCurrentIndex = function(currentIndex) {
        if (currentIndex == null) currentIndex = this.option.currentIndex;
        var count = this._data.count();
        if (this.option.loop) currentIndex = (currentIndex % count + count) % count;
        else {
            currentIndex >= count && (currentIndex = count - 1);
            currentIndex < 0 && (currentIndex = 0);
        }
        this.option.currentIndex = currentIndex;
    };
    /**
   * @return {number} currentIndex
   */ TimelineModel.prototype.getCurrentIndex = function() {
        return this.option.currentIndex;
    };
    /**
   * @return {boolean}
   */ TimelineModel.prototype.isIndexMax = function() {
        return this.getCurrentIndex() >= this._data.count() - 1;
    };
    /**
   * @param {boolean} state true: play, false: stop
   */ TimelineModel.prototype.setPlayState = function(state) {
        this.option.autoPlay = !!state;
    };
    /**
   * @return {boolean} true: play, false: stop
   */ TimelineModel.prototype.getPlayState = function() {
        return !!this.option.autoPlay;
    };
    /**
   * @private
   */ TimelineModel.prototype._initData = function() {
        var thisOption = this.option;
        var dataArr = thisOption.data || [];
        var axisType = thisOption.axisType;
        var names = this._names = [];
        var processedDataArr;
        if (axisType === 'category') {
            processedDataArr = [];
            (0, $2N6Uo.each)(dataArr, function(item, index) {
                var value = (0, $bx3T8.convertOptionIdName)((0, $bx3T8.getDataItemValue)(item), '');
                var newItem;
                if ((0, $2N6Uo.isObject)(item)) {
                    newItem = (0, $2N6Uo.clone)(item);
                    newItem.value = index;
                } else newItem = index;
                processedDataArr.push(newItem);
                names.push(value);
            });
        } else processedDataArr = dataArr;
        var dimType = {
            category: 'ordinal',
            time: 'time',
            value: 'number'
        }[axisType] || 'number';
        var data = this._data = new (0, $2kN4z.default)([
            {
                name: 'value',
                type: dimType
            }
        ], this);
        data.initData(processedDataArr, names);
    };
    TimelineModel.prototype.getData = function() {
        return this._data;
    };
    /**
   * @public
   * @return {Array.<string>} categoreis
   */ TimelineModel.prototype.getCategories = function() {
        if (this.get('axisType') === 'category') return this._names.slice();
    };
    TimelineModel.type = 'timeline';
    /**
   * @protected
   */ TimelineModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 4,
        show: true,
        axisType: 'time',
        realtime: true,
        left: '20%',
        top: null,
        right: '20%',
        bottom: 0,
        width: null,
        height: 40,
        padding: (0, $6aXXD.default).size.m,
        controlPosition: 'left',
        autoPlay: false,
        rewind: false,
        loop: true,
        playInterval: 2000,
        currentIndex: 0,
        itemStyle: {},
        label: {
            color: (0, $6aXXD.default).color.secondary
        },
        data: []
    };
    return TimelineModel;
}((0, $eLD2b.default));
var $d2dd4c07163c9b65$export$2e2bcd8739ae039 = $d2dd4c07163c9b65$var$TimelineModel;

});


parcelRegister("4wczu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34a3e6fd062478d8$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $67W72 = parcelRequire("67W72");

var $19Ywy = parcelRequire("19Ywy");

var $h9U3p = parcelRequire("h9U3p");
var $c3CaY = parcelRequire("c3CaY");
var $iQonF = parcelRequire("iQonF");
var $kBKw3 = parcelRequire("kBKw3");

var $bysmE = parcelRequire("bysmE");

var $a35Wn = parcelRequire("a35Wn");

var $iugA8 = parcelRequire("iugA8");

var $3vNhb = parcelRequire("3vNhb");

var $k0QDS = parcelRequire("k0QDS");

var $iCU10 = parcelRequire("iCU10");

var $2N6Uo = parcelRequire("2N6Uo");

var $cpzWt = parcelRequire("cpzWt");

var $9X29M = parcelRequire("9X29M");

var $k1WNO = parcelRequire("k1WNO");

var $eVwLk = parcelRequire("eVwLk");

var $bx3T8 = parcelRequire("bx3T8");

var $6TSUP = parcelRequire("6TSUP");

var $bwPbQ = parcelRequire("bwPbQ");

var $5KdhI = parcelRequire("5KdhI");
var $34a3e6fd062478d8$var$PI = Math.PI;
var $34a3e6fd062478d8$var$labelDataIndexStore = (0, $bx3T8.makeInner)();
var $34a3e6fd062478d8$var$SliderTimelineView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SliderTimelineView, _super);
    function SliderTimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineView.type;
        return _this;
    }
    SliderTimelineView.prototype.init = function(ecModel, api) {
        this.api = api;
    };
    /**
   * @override
   */ SliderTimelineView.prototype.render = function(timelineModel, ecModel, api) {
        this.model = timelineModel;
        this.api = api;
        this.ecModel = ecModel;
        this.group.removeAll();
        if (timelineModel.get('show', true)) {
            var layoutInfo_1 = this._layout(timelineModel, api);
            var mainGroup_1 = this._createGroup('_mainGroup');
            var labelGroup = this._createGroup('_labelGroup');
            var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);
            timelineModel.formatTooltip = function(dataIndex) {
                var name = axis_1.scale.getLabel({
                    value: dataIndex
                });
                return (0, $5KdhI.createTooltipMarkup)('nameValue', {
                    noName: true,
                    value: name
                });
            };
            (0, $2N6Uo.each)([
                'AxisLine',
                'AxisTick',
                'Control',
                'CurrentPointer'
            ], function(name) {
                this['_render' + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
            }, this);
            this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);
            this._position(layoutInfo_1, timelineModel);
        }
        this._doPlayStop();
        this._updateTicksStatus();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.remove = function() {
        this._clearTimer();
        this.group.removeAll();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.dispose = function() {
        this._clearTimer();
    };
    SliderTimelineView.prototype._layout = function(timelineModel, api) {
        var labelPosOpt = timelineModel.get([
            'label',
            'position'
        ]);
        var orient = timelineModel.get('orient');
        var viewRect = $34a3e6fd062478d8$var$getViewRect(timelineModel, api);
        var parsedLabelPos;
        // Auto label offset.
        if (labelPosOpt == null || labelPosOpt === 'auto') parsedLabelPos = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
        else if ((0, $2N6Uo.isString)(labelPosOpt)) parsedLabelPos = ({
            horizontal: {
                top: '-',
                bottom: '+'
            },
            vertical: {
                left: '-',
                right: '+'
            }
        })[orient][labelPosOpt];
        else // is number
        parsedLabelPos = labelPosOpt;
        var labelAlignMap = {
            horizontal: 'center',
            vertical: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'left' : 'right'
        };
        var labelBaselineMap = {
            horizontal: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'top' : 'bottom',
            vertical: 'middle'
        };
        var rotationMap = {
            horizontal: 0,
            vertical: $34a3e6fd062478d8$var$PI / 2
        };
        // Position
        var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
        var controlModel = timelineModel.getModel('controlStyle');
        var showControl = controlModel.get('show', true);
        var controlSize = showControl ? controlModel.get('itemSize') : 0;
        var controlGap = showControl ? controlModel.get('itemGap') : 0;
        var sizePlusGap = controlSize + controlGap;
        // Special label rotate.
        var labelRotation = timelineModel.get([
            'label',
            'rotate'
        ]) || 0;
        labelRotation = labelRotation * $34a3e6fd062478d8$var$PI / 180; // To radian.
        var playPosition;
        var prevBtnPosition;
        var nextBtnPosition;
        var controlPosition = controlModel.get('position', true);
        var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
        var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
        var showNextBtn = showControl && controlModel.get('showNextBtn', true);
        var xLeft = 0;
        var xRight = mainLength;
        // position[0] means left, position[1] means middle.
        if (controlPosition === 'left' || controlPosition === 'bottom') {
            showPlayBtn && (playPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                xLeft,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        } else {
            // 'top' 'right'
            showPlayBtn && (playPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        }
        var axisExtent = [
            xLeft,
            xRight
        ];
        if (timelineModel.get('inverse')) axisExtent.reverse();
        return {
            viewRect: viewRect,
            mainLength: mainLength,
            orient: orient,
            rotation: rotationMap[orient],
            labelRotation: labelRotation,
            labelPosOpt: parsedLabelPos,
            labelAlign: timelineModel.get([
                'label',
                'align'
            ]) || labelAlignMap[orient],
            labelBaseline: timelineModel.get([
                'label',
                'verticalAlign'
            ]) || timelineModel.get([
                'label',
                'baseline'
            ]) || labelBaselineMap[orient],
            // Based on mainGroup.
            playPosition: playPosition,
            prevBtnPosition: prevBtnPosition,
            nextBtnPosition: nextBtnPosition,
            axisExtent: axisExtent,
            controlSize: controlSize,
            controlGap: controlGap
        };
    };
    SliderTimelineView.prototype._position = function(layoutInfo, timelineModel) {
        // Position is be called finally, because bounding rect is needed for
        // adapt content to fill viewRect (auto adapt offset).
        // Timeline may be not all in the viewRect when 'offset' is specified
        // as a number, because it is more appropriate that label aligns at
        // 'offset' but not the other edge defined by viewRect.
        var mainGroup = this._mainGroup;
        var labelGroup = this._labelGroup;
        var viewRect = layoutInfo.viewRect;
        if (layoutInfo.orient === 'vertical') {
            // transform to horizontal, inverse rotate by left-top point.
            var m = $19Ywy.create();
            var rotateOriginX = viewRect.x;
            var rotateOriginY = viewRect.y + viewRect.height;
            $19Ywy.translate(m, m, [
                -rotateOriginX,
                -rotateOriginY
            ]);
            $19Ywy.rotate(m, m, -$34a3e6fd062478d8$var$PI / 2);
            $19Ywy.translate(m, m, [
                rotateOriginX,
                rotateOriginY
            ]);
            viewRect = viewRect.clone();
            viewRect.applyTransform(m);
        }
        var viewBound = getBound(viewRect);
        var mainBound = getBound(mainGroup.getBoundingRect());
        var labelBound = getBound(labelGroup.getBoundingRect());
        var mainPosition = [
            mainGroup.x,
            mainGroup.y
        ];
        var labelsPosition = [
            labelGroup.x,
            labelGroup.y
        ];
        labelsPosition[0] = mainPosition[0] = viewBound[0][0];
        var labelPosOpt = layoutInfo.labelPosOpt;
        if (labelPosOpt == null || (0, $2N6Uo.isString)(labelPosOpt)) {
            // '+' or '-'
            var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
        } else {
            var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            labelsPosition[1] = mainPosition[1] + labelPosOpt;
        }
        mainGroup.setPosition(mainPosition);
        labelGroup.setPosition(labelsPosition);
        mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
        setOrigin(mainGroup);
        setOrigin(labelGroup);
        function setOrigin(targetGroup) {
            targetGroup.originX = viewBound[0][0] - targetGroup.x;
            targetGroup.originY = viewBound[1][0] - targetGroup.y;
        }
        function getBound(rect) {
            // [[xmin, xmax], [ymin, ymax]]
            return [
                [
                    rect.x,
                    rect.x + rect.width
                ],
                [
                    rect.y,
                    rect.y + rect.height
                ]
            ];
        }
        function toBound(fromPos, from, to, dimIdx, boundIdx) {
            fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
        }
    };
    SliderTimelineView.prototype._createAxis = function(layoutInfo, timelineModel) {
        var data = timelineModel.getData();
        var axisType = timelineModel.get('axisType');
        var scale = $34a3e6fd062478d8$var$createScaleByModel(timelineModel, axisType);
        // Customize scale. The `tickValue` is `dataIndex`.
        scale.getTicks = function() {
            return data.mapArray([
                'value'
            ], function(value) {
                return {
                    value: value
                };
            });
        };
        var dataExtent = data.getDataExtent('value');
        scale.setExtent(dataExtent[0], dataExtent[1]);
        scale.calcNiceTicks();
        var axis = new (0, $3vNhb.default)('value', scale, layoutInfo.axisExtent, axisType);
        axis.model = timelineModel;
        return axis;
    };
    SliderTimelineView.prototype._createGroup = function(key) {
        var newGroup = this[key] = new $iQonF.default();
        this.group.add(newGroup);
        return newGroup;
    };
    SliderTimelineView.prototype._renderAxisLine = function(layoutInfo, group, axis, timelineModel) {
        var axisExtent = axis.getExtent();
        if (!timelineModel.get([
            'lineStyle',
            'show'
        ])) return;
        var line = new $c3CaY.default({
            shape: {
                x1: axisExtent[0],
                y1: 0,
                x2: axisExtent[1],
                y2: 0
            },
            style: (0, $2N6Uo.extend)({
                lineCap: 'round'
            }, timelineModel.getModel('lineStyle').getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(line);
        var progressLine = this._progressLine = new $c3CaY.default({
            shape: {
                x1: axisExtent[0],
                x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
                y1: 0,
                y2: 0
            },
            style: (0, $2N6Uo.defaults)({
                lineCap: 'round',
                lineWidth: line.style.lineWidth
            }, timelineModel.getModel([
                'progress',
                'lineStyle'
            ]).getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(progressLine);
    };
    SliderTimelineView.prototype._renderAxisTick = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var data = timelineModel.getData();
        // Show all ticks, despite ignoring strategy.
        var ticks = axis.scale.getTicks();
        this._tickSymbols = [];
        // The value is dataIndex, see the customized scale.
        (0, $2N6Uo.each)(ticks, function(tick) {
            var tickCoord = axis.dataToCoord(tick.value);
            var itemModel = data.getItemModel(tick.value);
            var itemStyleModel = itemModel.getModel('itemStyle');
            var hoverStyleModel = itemModel.getModel([
                'emphasis',
                'itemStyle'
            ]);
            var progressStyleModel = itemModel.getModel([
                'progress',
                'itemStyle'
            ]);
            var symbolOpt = {
                x: tickCoord,
                y: 0,
                onclick: (0, $2N6Uo.bind)(_this._changeTimeline, _this, tick.value)
            };
            var el = $34a3e6fd062478d8$var$giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
            el.ensureState('emphasis').style = hoverStyleModel.getItemStyle();
            el.ensureState('progress').style = progressStyleModel.getItemStyle();
            (0, $bwPbQ.enableHoverEmphasis)(el);
            var ecData = (0, $6TSUP.getECData)(el);
            if (itemModel.get('tooltip')) {
                ecData.dataIndex = tick.value;
                ecData.dataModel = timelineModel;
            } else ecData.dataIndex = ecData.dataModel = null;
            _this._tickSymbols.push(el);
        });
    };
    SliderTimelineView.prototype._renderAxisLabel = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var labelModel = axis.getLabelModel();
        if (!labelModel.get('show')) return;
        var data = timelineModel.getData();
        var labels = axis.getViewLabels();
        this._tickLabels = [];
        (0, $2N6Uo.each)(labels, function(labelItem) {
            // The tickValue is dataIndex, see the customized scale.
            var dataIndex = labelItem.tickValue;
            var itemModel = data.getItemModel(dataIndex);
            var normalLabelModel = itemModel.getModel('label');
            var hoverLabelModel = itemModel.getModel([
                'emphasis',
                'label'
            ]);
            var progressLabelModel = itemModel.getModel([
                'progress',
                'label'
            ]);
            var tickCoord = axis.dataToCoord(labelItem.tickValue);
            var textEl = new $kBKw3.default({
                x: tickCoord,
                y: 0,
                rotation: layoutInfo.labelRotation - layoutInfo.rotation,
                onclick: (0, $2N6Uo.bind)(_this._changeTimeline, _this, dataIndex),
                silent: false,
                style: (0, $bysmE.createTextStyle)(normalLabelModel, {
                    text: labelItem.formattedLabel,
                    align: layoutInfo.labelAlign,
                    verticalAlign: layoutInfo.labelBaseline
                })
            });
            textEl.ensureState('emphasis').style = (0, $bysmE.createTextStyle)(hoverLabelModel);
            textEl.ensureState('progress').style = (0, $bysmE.createTextStyle)(progressLabelModel);
            group.add(textEl);
            (0, $bwPbQ.enableHoverEmphasis)(textEl);
            $34a3e6fd062478d8$var$labelDataIndexStore(textEl).dataIndex = dataIndex;
            _this._tickLabels.push(textEl);
        });
    };
    SliderTimelineView.prototype._renderControl = function(layoutInfo, group, axis, timelineModel) {
        var controlSize = layoutInfo.controlSize;
        var rotation = layoutInfo.rotation;
        var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
        var hoverStyle = timelineModel.getModel([
            'emphasis',
            'controlStyle'
        ]).getItemStyle();
        var playState = timelineModel.getPlayState();
        var inverse = timelineModel.get('inverse', true);
        makeBtn(layoutInfo.nextBtnPosition, 'next', (0, $2N6Uo.bind)(this._changeTimeline, this, inverse ? '-' : '+'));
        makeBtn(layoutInfo.prevBtnPosition, 'prev', (0, $2N6Uo.bind)(this._changeTimeline, this, inverse ? '+' : '-'));
        makeBtn(layoutInfo.playPosition, playState ? 'stop' : 'play', (0, $2N6Uo.bind)(this._handlePlayClick, this, !playState), true);
        function makeBtn(position, iconName, onclick, willRotate) {
            if (!position) return;
            var iconSize = (0, $eVwLk.parsePercent)((0, $2N6Uo.retrieve2)(timelineModel.get([
                'controlStyle',
                iconName + 'BtnSize'
            ]), controlSize), controlSize);
            var rect = [
                0,
                -iconSize / 2,
                iconSize,
                iconSize
            ];
            var btn = $34a3e6fd062478d8$var$makeControlIcon(timelineModel, iconName + 'Icon', rect, {
                x: position[0],
                y: position[1],
                originX: controlSize / 2,
                originY: 0,
                rotation: willRotate ? -rotation : 0,
                rectHover: true,
                style: itemStyle,
                onclick: onclick
            });
            btn.ensureState('emphasis').style = hoverStyle;
            group.add(btn);
            (0, $bwPbQ.enableHoverEmphasis)(btn);
        }
    };
    SliderTimelineView.prototype._renderCurrentPointer = function(layoutInfo, group, axis, timelineModel) {
        var data = timelineModel.getData();
        var currentIndex = timelineModel.getCurrentIndex();
        var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
        var me = this;
        var callback = {
            onCreate: function(pointer) {
                pointer.draggable = true;
                pointer.drift = (0, $2N6Uo.bind)(me._handlePointerDrag, me);
                pointer.ondragend = (0, $2N6Uo.bind)(me._handlePointerDragend, me);
                $34a3e6fd062478d8$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
            },
            onUpdate: function(pointer) {
                $34a3e6fd062478d8$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
            }
        };
        // Reuse when exists, for animation and drag.
        this._currentPointer = $34a3e6fd062478d8$var$giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
    };
    SliderTimelineView.prototype._handlePlayClick = function(nextState) {
        this._clearTimer();
        this.api.dispatchAction({
            type: 'timelinePlayChange',
            playState: nextState,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._handlePointerDrag = function(dx, dy, e) {
        this._clearTimer();
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ]);
    };
    SliderTimelineView.prototype._handlePointerDragend = function(e) {
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ], true);
    };
    SliderTimelineView.prototype._pointerChangeTimeline = function(mousePos, trigger) {
        var toCoord = this._toAxisCoord(mousePos)[0];
        var axis = this._axis;
        var axisExtent = $iCU10.asc(axis.getExtent().slice());
        toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
        toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
        this._currentPointer.x = toCoord;
        this._currentPointer.markRedraw();
        var progressLine = this._progressLine;
        if (progressLine) {
            progressLine.shape.x2 = toCoord;
            progressLine.dirty();
        }
        var targetDataIndex = this._findNearestTick(toCoord);
        var timelineModel = this.model;
        if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) this._changeTimeline(targetDataIndex);
    };
    SliderTimelineView.prototype._doPlayStop = function() {
        var _this = this;
        this._clearTimer();
        if (this.model.getPlayState()) this._timer = setTimeout(function() {
            // Do not cache
            var timelineModel = _this.model;
            _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
        }, this.model.get('playInterval'));
    };
    SliderTimelineView.prototype._toAxisCoord = function(vertex) {
        var trans = this._mainGroup.getLocalTransform();
        return $h9U3p.applyTransform(vertex, trans, true);
    };
    SliderTimelineView.prototype._findNearestTick = function(axisCoord) {
        var data = this.model.getData();
        var dist = Infinity;
        var targetDataIndex;
        var axis = this._axis;
        data.each([
            'value'
        ], function(value, dataIndex) {
            var coord = axis.dataToCoord(value);
            var d = Math.abs(coord - axisCoord);
            if (d < dist) {
                dist = d;
                targetDataIndex = dataIndex;
            }
        });
        return targetDataIndex;
    };
    SliderTimelineView.prototype._clearTimer = function() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    };
    SliderTimelineView.prototype._changeTimeline = function(nextIndex) {
        var currentIndex = this.model.getCurrentIndex();
        if (nextIndex === '+') nextIndex = currentIndex + 1;
        else if (nextIndex === '-') nextIndex = currentIndex - 1;
        this.api.dispatchAction({
            type: 'timelineChange',
            currentIndex: nextIndex,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._updateTicksStatus = function() {
        var currentIndex = this.model.getCurrentIndex();
        var tickSymbols = this._tickSymbols;
        var tickLabels = this._tickLabels;
        if (tickSymbols) for(var i = 0; i < tickSymbols.length; i++)tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState('progress', i < currentIndex);
        if (tickLabels) for(var i = 0; i < tickLabels.length; i++)tickLabels && tickLabels[i] && tickLabels[i].toggleState('progress', $34a3e6fd062478d8$var$labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
    };
    SliderTimelineView.type = 'timeline.slider';
    return SliderTimelineView;
}((0, $iugA8.default));
function $34a3e6fd062478d8$var$createScaleByModel(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $cpzWt.default)({
                ordinalMeta: model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $9X29M.default)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // default to be value
            return new (0, $k1WNO.default)();
    }
}
function $34a3e6fd062478d8$var$getViewRect(model, api) {
    return $a35Wn.getLayoutRect(model.getBoxLayoutParams(), $a35Wn.createBoxLayoutReference(model, api).refContainer, model.get('padding'));
}
function $34a3e6fd062478d8$var$makeControlIcon(timelineModel, objPath, rect, opts) {
    var style = opts.style;
    var icon = $h9U3p.createIcon(timelineModel.get([
        'controlStyle',
        objPath
    ]), opts || {}, new (0, $67W72.default)(rect[0], rect[1], rect[2], rect[3]));
    // TODO createIcon won't use style in opt.
    if (style) icon.setStyle(style);
    return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */ function $34a3e6fd062478d8$var$giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
    var color = itemStyleModel.get('color');
    if (!symbol) {
        var symbolType = hostModel.get('symbol');
        symbol = (0, $k0QDS.createSymbol)(symbolType, -1, -1, 2, 2, color);
        symbol.setStyle('strokeNoScale', true);
        group.add(symbol);
        callback && callback.onCreate(symbol);
    } else {
        symbol.setColor(color);
        group.add(symbol); // Group may be new, also need to add.
        callback && callback.onUpdate(symbol);
    }
    // Style
    var itemStyle = itemStyleModel.getItemStyle([
        'color'
    ]);
    symbol.setStyle(itemStyle);
    // Transform and events.
    opt = (0, $2N6Uo.merge)({
        rectHover: true,
        z2: 100
    }, opt, true);
    var symbolSize = (0, $k0QDS.normalizeSymbolSize)(hostModel.get('symbolSize'));
    opt.scaleX = symbolSize[0] / 2;
    opt.scaleY = symbolSize[1] / 2;
    var symbolOffset = (0, $k0QDS.normalizeSymbolOffset)(hostModel.get('symbolOffset'), symbolSize);
    if (symbolOffset) {
        opt.x = (opt.x || 0) + symbolOffset[0];
        opt.y = (opt.y || 0) + symbolOffset[1];
    }
    var symbolRotate = hostModel.get('symbolRotate');
    opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    symbol.attr(opt);
    // FIXME
    // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
    // getBoundingRect will return wrong result.
    // (This is supposed to be resolved in zrender, but it is a little difficult to
    // leverage performance and auto updateTransform)
    // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
    symbol.updateTransform();
    return symbol;
}
function $34a3e6fd062478d8$var$pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
    if (pointer.dragging) return;
    var pointerModel = timelineModel.getModel('checkpointStyle');
    var toCoord = axis.dataToCoord(timelineModel.getData().get('value', dataIndex));
    if (noAnimation || !pointerModel.get('animation', true)) {
        pointer.attr({
            x: toCoord,
            y: 0
        });
        progressLine && progressLine.attr({
            shape: {
                x2: toCoord
            }
        });
    } else {
        var animationCfg = {
            duration: pointerModel.get('animationDuration', true),
            easing: pointerModel.get('animationEasing', true)
        };
        pointer.stopAnimation(null, true);
        pointer.animateTo({
            x: toCoord,
            y: 0
        }, animationCfg);
        progressLine && progressLine.animateTo({
            shape: {
                x2: toCoord
            }
        }, animationCfg);
    }
}
var $34a3e6fd062478d8$export$2e2bcd8739ae039 = $34a3e6fd062478d8$var$SliderTimelineView;

});
parcelRegister("iugA8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d757e42188629b85$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $bpyST = parcelRequire("bpyST");
var $d757e42188629b85$var$TimelineView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TimelineView, _super);
    function TimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineView.type;
        return _this;
    }
    TimelineView.type = 'timeline';
    return TimelineView;
}((0, $bpyST.default));
var $d757e42188629b85$export$2e2bcd8739ae039 = $d757e42188629b85$var$TimelineView;

});

parcelRegister("3vNhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28ea7d8d54220074$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $6ZMAw = parcelRequire("6ZMAw");
/**
 * Extend axis 2d
 */ var $28ea7d8d54220074$var$TimelineAxis = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TimelineAxis, _super);
    function TimelineAxis(dim, scale, coordExtent, axisType) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        return _this;
    }
    /**
   * @override
   */ TimelineAxis.prototype.getLabelModel = function() {
        // Force override
        return this.model.getModel('label');
    };
    /**
   * @override
   */ TimelineAxis.prototype.isHorizontal = function() {
        return this.model.get('orient') === 'horizontal';
    };
    return TimelineAxis;
}((0, $6ZMAw.default));
var $28ea7d8d54220074$export$2e2bcd8739ae039 = $28ea7d8d54220074$var$TimelineAxis;

});


parcelRegister("bCVXF", function(module, exports) {

$parcel$export(module.exports, "installTimelineAction", function () { return $8770343a49e5bef7$export$780c34b7cfe44e86; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");
function $8770343a49e5bef7$export$780c34b7cfe44e86(registers) {
    registers.registerAction({
        type: 'timelineChange',
        event: 'timelineChanged',
        update: 'prepareAndUpdate'
    }, function(payload, ecModel, api) {
        var timelineModel = ecModel.getComponent('timeline');
        if (timelineModel && payload.currentIndex != null) {
            timelineModel.setCurrentIndex(payload.currentIndex);
            if (!timelineModel.get('loop', true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
                timelineModel.setPlayState(false);
                // The timeline has played to the end, trigger event
                api.dispatchAction({
                    type: 'timelinePlayChange',
                    playState: false,
                    from: payload.from
                });
            }
        }
        // Set normalized currentIndex to payload.
        ecModel.resetOption('timeline', {
            replaceMerge: timelineModel.get('replaceMerge', true)
        });
        return (0, $2N6Uo.defaults)({
            currentIndex: timelineModel.option.currentIndex
        }, payload);
    });
    registers.registerAction({
        type: 'timelinePlayChange',
        event: 'timelinePlayChanged',
        update: 'update'
    }, function(payload, ecModel) {
        var timelineModel = ecModel.getComponent('timeline');
        if (timelineModel && payload.playState != null) timelineModel.setPlayState(payload.playState);
    });
}

});

parcelRegister("cLcgy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94a36396ffd8a2f7$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $2N6Uo = parcelRequire("2N6Uo");
function $94a36396ffd8a2f7$export$2e2bcd8739ae039(option) {
    var timelineOpt = option && option.timeline;
    if (!$2N6Uo.isArray(timelineOpt)) timelineOpt = timelineOpt ? [
        timelineOpt
    ] : [];
    $2N6Uo.each(timelineOpt, function(opt) {
        if (!opt) return;
        $94a36396ffd8a2f7$var$compatibleEC2(opt);
    });
}
function $94a36396ffd8a2f7$var$compatibleEC2(opt) {
    var type = opt.type;
    var ec2Types = {
        'number': 'value',
        'time': 'time'
    };
    // Compatible with ec2
    if (ec2Types[type]) {
        opt.axisType = ec2Types[type];
        delete opt.type;
    }
    $94a36396ffd8a2f7$var$transferItem(opt);
    if ($94a36396ffd8a2f7$var$has(opt, 'controlPosition')) {
        var controlStyle = opt.controlStyle || (opt.controlStyle = {});
        if (!$94a36396ffd8a2f7$var$has(controlStyle, 'position')) controlStyle.position = opt.controlPosition;
        if (controlStyle.position === 'none' && !$94a36396ffd8a2f7$var$has(controlStyle, 'show')) {
            controlStyle.show = false;
            delete controlStyle.position;
        }
        delete opt.controlPosition;
    }
    $2N6Uo.each(opt.data || [], function(dataItem) {
        if ($2N6Uo.isObject(dataItem) && !$2N6Uo.isArray(dataItem)) {
            if (!$94a36396ffd8a2f7$var$has(dataItem, 'value') && $94a36396ffd8a2f7$var$has(dataItem, 'name')) // In ec2, using name as value.
            dataItem.value = dataItem.name;
            $94a36396ffd8a2f7$var$transferItem(dataItem);
        }
    });
}
function $94a36396ffd8a2f7$var$transferItem(opt) {
    var itemStyle = opt.itemStyle || (opt.itemStyle = {});
    var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {});
    // Transfer label out
    var label = opt.label || opt.label || {};
    var labelNormal = label.normal || (label.normal = {});
    var excludeLabelAttr = {
        normal: 1,
        emphasis: 1
    };
    $2N6Uo.each(label, function(value, name) {
        if (!excludeLabelAttr[name] && !$94a36396ffd8a2f7$var$has(labelNormal, name)) labelNormal[name] = value;
    });
    if (itemStyleEmphasis.label && !$94a36396ffd8a2f7$var$has(label, 'emphasis')) {
        label.emphasis = itemStyleEmphasis.label;
        delete itemStyleEmphasis.label;
    }
}
function $94a36396ffd8a2f7$var$has(obj, attr) {
    return obj.hasOwnProperty(attr);
}

});


parcelRegister("hoKvC", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $caa8c14084bc8ff3$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");
parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");
var $kBKw3 = parcelRequire("kBKw3");

var $6TSUP = parcelRequire("6TSUP");

var $bysmE = parcelRequire("bysmE");

var $a35Wn = parcelRequire("a35Wn");

var $eLD2b = parcelRequire("eLD2b");

var $bpyST = parcelRequire("bpyST");

var $hrphB = parcelRequire("hrphB");

var $6aXXD = parcelRequire("6aXXD");
var $caa8c14084bc8ff3$var$TitleModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = 'title';
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: '',
        target: 'blank',
        subtext: '',
        subtarget: 'blank',
        left: 'center',
        top: (0, $6aXXD.default).size.m,
        backgroundColor: (0, $6aXXD.default).color.transparent,
        borderColor: (0, $6aXXD.default).color.primary,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: 'bold',
            color: (0, $6aXXD.default).color.primary
        },
        subtextStyle: {
            fontSize: 12,
            color: (0, $6aXXD.default).color.quaternary
        }
    };
    return TitleModel;
}((0, $eLD2b.default));
// View
var $caa8c14084bc8ff3$var$TitleView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get('show')) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel('textStyle');
        var subtextStyleModel = titleModel.getModel('subtextStyle');
        var textAlign = titleModel.get('textAlign');
        var textVerticalAlign = $2N6Uo.retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
        var textEl = new $kBKw3.default({
            style: (0, $bysmE.createTextStyle)(textStyleModel, {
                text: titleModel.get('text'),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get('subtext');
        var subTextEl = new $kBKw3.default({
            style: (0, $bysmE.createTextStyle)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get('itemGap'),
                verticalAlign: 'top'
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get('link');
        var sublink = titleModel.get('sublink');
        var triggerEvent = titleModel.get('triggerEvent', true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on('click', function() {
            (0, $hrphB.windowOpen)(link, '_' + titleModel.get('target'));
        });
        if (sublink) subTextEl.on('click', function() {
            (0, $hrphB.windowOpen)(sublink, '_' + titleModel.get('subtarget'));
        });
        (0, $6TSUP.getECData)(textEl).eventData = (0, $6TSUP.getECData)(subTextEl).eventData = triggerEvent ? {
            componentType: 'title',
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRef = (0, $a35Wn.createBoxLayoutReference)(titleModel, api);
        var layoutRect = (0, $a35Wn.getLayoutRect)(layoutOption, layoutRef.refContainer, titleModel.get('padding'));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get('left') || titleModel.get('right');
            // @ts-ignore
            if (textAlign === 'middle') textAlign = 'center';
            // Adjust layout by text align
            if (textAlign === 'right') layoutRect.x += layoutRect.width;
            else if (textAlign === 'center') layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
            // @ts-ignore
            if (textVerticalAlign === 'center') textVerticalAlign = 'middle';
            if (textVerticalAlign === 'bottom') layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === 'middle') layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || 'top';
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            'color',
            'opacity'
        ]);
        style.fill = titleModel.get('backgroundColor');
        var rect = new $aH2k0.default({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get('borderRadius')
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = 'title';
    return TitleView;
}((0, $bpyST.default));
function $caa8c14084bc8ff3$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($caa8c14084bc8ff3$var$TitleModel);
    registers.registerComponentView($caa8c14084bc8ff3$var$TitleView);
}

});

parcelRegister("lDgOb", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $fbfa474e60b28d50$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $beGVG = parcelRequire("beGVG");

var $jtnaG = parcelRequire("jtnaG");

var $iY1Un = parcelRequire("iY1Un");

var $14R3P = parcelRequire("14R3P");

var $16Ohe = parcelRequire("16Ohe");

var $gCXG4 = parcelRequire("gCXG4");

var $g375u = parcelRequire("g375u");

var $1bECW = parcelRequire("1bECW");

var $5VWrz = parcelRequire("5VWrz");
function $fbfa474e60b28d50$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $jtnaG.default));
    registers.registerComponentView((0, $iY1Un.default));
    (0, $14R3P.registerFeature)('saveAsImage', (0, $16Ohe.default));
    (0, $14R3P.registerFeature)('magicType', (0, $gCXG4.default));
    (0, $14R3P.registerFeature)('dataView', (0, $g375u.default));
    (0, $14R3P.registerFeature)('dataZoom', (0, $5VWrz.default));
    (0, $14R3P.registerFeature)('restore', (0, $1bECW.default));
    (0, $gX19P.use)((0, $beGVG.install));
}

});
parcelRegister("beGVG", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $82e24d62d1337678$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gZXPH = parcelRequire("gZXPH");

var $ie9ow = parcelRequire("ie9ow");

var $luD2W = parcelRequire("luD2W");
function $82e24d62d1337678$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $gZXPH.default));
    registers.registerComponentView((0, $ie9ow.default));
    (0, $luD2W.default)(registers);
}

});
parcelRegister("gZXPH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c600c16b95143322$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $lT9Rl = parcelRequire("lT9Rl");
var $c600c16b95143322$var$SelectDataZoomModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SelectDataZoomModel, _super);
    function SelectDataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomModel.type;
        return _this;
    }
    SelectDataZoomModel.type = 'dataZoom.select';
    return SelectDataZoomModel;
}((0, $lT9Rl.default));
var $c600c16b95143322$export$2e2bcd8739ae039 = $c600c16b95143322$var$SelectDataZoomModel;

});

parcelRegister("ie9ow", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d450d25e33d26ee6$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $iVHee = parcelRequire("iVHee");
var $d450d25e33d26ee6$var$SelectDataZoomView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SelectDataZoomView, _super);
    function SelectDataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomView.type;
        return _this;
    }
    SelectDataZoomView.type = 'dataZoom.select';
    return SelectDataZoomView;
}((0, $iVHee.default));
var $d450d25e33d26ee6$export$2e2bcd8739ae039 = $d450d25e33d26ee6$var$SelectDataZoomView;

});


parcelRegister("jtnaG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2d2b318cae4e95e$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $14R3P = parcelRequire("14R3P");

var $eLD2b = parcelRequire("eLD2b");

var $6aXXD = parcelRequire("6aXXD");
var $e2d2b318cae4e95e$var$ToolboxModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ToolboxModel, _super);
    function ToolboxModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ToolboxModel.type;
        return _this;
    }
    ToolboxModel.prototype.optionUpdated = function() {
        _super.prototype.optionUpdated.apply(this, arguments);
        var ecModel = this.ecModel;
        $2N6Uo.each(this.option.feature, function(featureOpt, featureName) {
            var Feature = $14R3P.getFeature(featureName);
            if (Feature) {
                if (Feature.getDefaultOption) Feature.defaultOption = Feature.getDefaultOption(ecModel);
                $2N6Uo.merge(featureOpt, Feature.defaultOption);
            }
        });
    };
    ToolboxModel.type = 'toolbox';
    ToolboxModel.layoutMode = {
        type: 'box',
        ignoreSize: true
    };
    ToolboxModel.defaultOption = {
        show: true,
        z: 6,
        // zlevel: 0,
        orient: 'horizontal',
        left: 'right',
        top: 'top',
        // right
        // bottom
        backgroundColor: 'transparent',
        borderColor: (0, $6aXXD.default).color.border,
        borderRadius: 0,
        borderWidth: 0,
        padding: (0, $6aXXD.default).size.m,
        itemSize: 15,
        itemGap: (0, $6aXXD.default).size.s,
        showTitle: true,
        iconStyle: {
            borderColor: (0, $6aXXD.default).color.accent50,
            color: 'none'
        },
        emphasis: {
            iconStyle: {
                borderColor: (0, $6aXXD.default).color.accent50
            }
        },
        // textStyle: {},
        // feature
        tooltip: {
            show: false,
            position: 'bottom'
        }
    };
    return ToolboxModel;
}((0, $eLD2b.default));
var $e2d2b318cae4e95e$export$2e2bcd8739ae039 = $e2d2b318cae4e95e$var$ToolboxModel;

});

parcelRegister("iY1Un", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcef4f8fae1b1a33$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $eVwLk = parcelRequire("eVwLk");

var $h9U3p = parcelRequire("h9U3p");

var $bwPbQ = parcelRequire("bwPbQ");

var $b8YKU = parcelRequire("b8YKU");

var $chf3v = parcelRequire("chf3v");

var $aVbOT = parcelRequire("aVbOT");

var $bpyST = parcelRequire("bpyST");

var $14R3P = parcelRequire("14R3P");

var $cKPmR = parcelRequire("cKPmR");

var $kBKw3 = parcelRequire("kBKw3");

var $bysmE = parcelRequire("bysmE");

var $a35Wn = parcelRequire("a35Wn");

var $6aXXD = parcelRequire("6aXXD");
var $dcef4f8fae1b1a33$var$ToolboxView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ToolboxView, _super);
    function ToolboxView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolboxView.prototype.render = function(toolboxModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        if (!toolboxModel.get('show')) return;
        var itemSize = +toolboxModel.get('itemSize');
        var isVertical = toolboxModel.get('orient') === 'vertical';
        var featureOpts = toolboxModel.get('feature') || {};
        var features = this._features || (this._features = {});
        var featureNames = [];
        $2N6Uo.each(featureOpts, function(opt, name) {
            featureNames.push(name);
        });
        new (0, $chf3v.default)(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove($2N6Uo.curry(processFeature, null)).execute();
        // Keep for diff.
        this._featureNames = featureNames;
        function processFeature(newIndex, oldIndex) {
            var featureName = featureNames[newIndex];
            var oldName = featureNames[oldIndex];
            var featureOpt = featureOpts[featureName];
            var featureModel = new (0, $b8YKU.default)(featureOpt, toolboxModel, toolboxModel.ecModel);
            var feature;
            // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
            if (payload && payload.newTitle != null && payload.featureName === featureName) featureOpt.title = payload.newTitle;
            if (featureName && !oldName) {
                // Create
                if ($dcef4f8fae1b1a33$var$isUserFeatureName(featureName)) feature = {
                    onclick: featureModel.option.onclick,
                    featureName: featureName
                };
                else {
                    var Feature = (0, $14R3P.getFeature)(featureName);
                    if (!Feature) return;
                    feature = new Feature();
                }
                features[featureName] = feature;
            } else {
                feature = features[oldName];
                // If feature does not exist.
                if (!feature) return;
            }
            feature.uid = (0, $cKPmR.getUID)('toolbox-feature');
            feature.model = featureModel;
            feature.ecModel = ecModel;
            feature.api = api;
            var isToolboxFeature = feature instanceof (0, $14R3P.ToolboxFeature);
            if (!featureName && oldName) {
                isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
                return;
            }
            if (!featureModel.get('show') || isToolboxFeature && feature.unusable) {
                isToolboxFeature && feature.remove && feature.remove(ecModel, api);
                return;
            }
            createIconPaths(featureModel, feature, featureName);
            featureModel.setIconStatus = function(iconName, status) {
                var option = this.option;
                var iconPaths = this.iconPaths;
                option.iconStatus = option.iconStatus || {};
                option.iconStatus[iconName] = status;
                if (iconPaths[iconName]) (status === 'emphasis' ? (0, $bwPbQ.enterEmphasis) : (0, $bwPbQ.leaveEmphasis))(iconPaths[iconName]);
            };
            if (feature instanceof (0, $14R3P.ToolboxFeature)) {
                if (feature.render) feature.render(featureModel, ecModel, api, payload);
            }
        }
        function createIconPaths(featureModel, feature, featureName) {
            var iconStyleModel = featureModel.getModel('iconStyle');
            var iconStyleEmphasisModel = featureModel.getModel([
                'emphasis',
                'iconStyle'
            ]);
            // If one feature has multiple icons, they are organized as
            // {
            //     icon: {
            //         foo: '',
            //         bar: ''
            //     },
            //     title: {
            //         foo: '',
            //         bar: ''
            //     }
            // }
            var icons = feature instanceof (0, $14R3P.ToolboxFeature) && feature.getIcons ? feature.getIcons() : featureModel.get('icon');
            var titles = featureModel.get('title') || {};
            var iconsMap;
            var titlesMap;
            if ($2N6Uo.isString(icons)) {
                iconsMap = {};
                iconsMap[featureName] = icons;
            } else iconsMap = icons;
            if ($2N6Uo.isString(titles)) {
                titlesMap = {};
                titlesMap[featureName] = titles;
            } else titlesMap = titles;
            var iconPaths = featureModel.iconPaths = {};
            $2N6Uo.each(iconsMap, function(iconStr, iconName) {
                var path = $h9U3p.createIcon(iconStr, {}, {
                    x: -itemSize / 2,
                    y: -itemSize / 2,
                    width: itemSize,
                    height: itemSize
                }); // TODO handling image
                path.setStyle(iconStyleModel.getItemStyle());
                var pathEmphasisState = path.ensureState('emphasis');
                pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle();
                // Text position calculation
                // TODO: extract `textStyle` from `iconStyle` and use `createTextStyle`
                var textContent = new (0, $kBKw3.default)({
                    style: {
                        text: titlesMap[iconName],
                        align: iconStyleEmphasisModel.get('textAlign'),
                        borderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
                        padding: iconStyleEmphasisModel.get('textPadding'),
                        fill: null,
                        font: (0, $bysmE.getFont)({
                            fontStyle: iconStyleEmphasisModel.get('textFontStyle'),
                            fontFamily: iconStyleEmphasisModel.get('textFontFamily'),
                            fontSize: iconStyleEmphasisModel.get('textFontSize'),
                            fontWeight: iconStyleEmphasisModel.get('textFontWeight')
                        }, ecModel)
                    },
                    ignore: true
                });
                path.setTextContent(textContent);
                $h9U3p.setTooltipConfig({
                    el: path,
                    componentModel: toolboxModel,
                    itemName: iconName,
                    formatterParamsExtra: {
                        title: titlesMap[iconName]
                    }
                });
                path.__title = titlesMap[iconName];
                path.on('mouseover', function() {
                    // Should not reuse above hoverStyle, which might be modified.
                    var hoverStyle = iconStyleEmphasisModel.getItemStyle();
                    var defaultTextPosition = isVertical ? toolboxModel.get('right') == null && toolboxModel.get('left') !== 'right' ? 'right' : 'left' : toolboxModel.get('bottom') == null && toolboxModel.get('top') !== 'bottom' ? 'bottom' : 'top';
                    textContent.setStyle({
                        fill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || (0, $6aXXD.default).color.neutral99,
                        backgroundColor: iconStyleEmphasisModel.get('textBackgroundColor')
                    });
                    path.setTextConfig({
                        position: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
                    });
                    textContent.ignore = !toolboxModel.get('showTitle');
                    // Use enterEmphasis and leaveEmphasis provide by ec.
                    // There are flags managed by the echarts.
                    api.enterEmphasis(this);
                }).on('mouseout', function() {
                    if (featureModel.get([
                        'iconStatus',
                        iconName
                    ]) !== 'emphasis') api.leaveEmphasis(this);
                    textContent.hide();
                });
                (featureModel.get([
                    'iconStatus',
                    iconName
                ]) === 'emphasis' ? (0, $bwPbQ.enterEmphasis) : (0, $bwPbQ.leaveEmphasis))(path);
                group.add(path);
                path.on('click', $2N6Uo.bind(feature.onclick, feature, ecModel, api, iconName));
                iconPaths[iconName] = path;
            });
        }
        var refContainer = (0, $a35Wn.createBoxLayoutReference)(toolboxModel, api).refContainer;
        var boxLayoutParams = toolboxModel.getBoxLayoutParams();
        var padding = toolboxModel.get('padding');
        var viewRect = (0, $a35Wn.getLayoutRect)(boxLayoutParams, refContainer, padding);
        (0, $a35Wn.box)(toolboxModel.get('orient'), group, toolboxModel.get('itemGap'), viewRect.width, viewRect.height);
        (0, $a35Wn.positionElement)(group, boxLayoutParams, refContainer, padding);
        // Render background after group is layout
        // FIXME
        group.add($aVbOT.makeBackground(group.getBoundingRect(), toolboxModel));
        // Adjust icon title positions to avoid them out of screen
        isVertical || group.eachChild(function(icon) {
            var titleText = icon.__title;
            // const hoverStyle = icon.hoverStyle;
            // TODO simplify code?
            var emphasisState = icon.ensureState('emphasis');
            var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
            var textContent = icon.getTextContent();
            var emphasisTextState = textContent && textContent.ensureState('emphasis');
            // May be background element
            if (emphasisTextState && !$2N6Uo.isFunction(emphasisTextState) && titleText) {
                var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
                var rect = $eVwLk.getBoundingRect(titleText, (0, $kBKw3.default).makeFont(emphasisTextStyle));
                var offsetX = icon.x + group.x;
                var offsetY = icon.y + group.y + itemSize;
                var needPutOnTop = false;
                if (offsetY + rect.height > api.getHeight()) {
                    emphasisTextConfig.position = 'top';
                    needPutOnTop = true;
                }
                var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;
                if (offsetX + rect.width / 2 > api.getWidth()) {
                    emphasisTextConfig.position = [
                        '100%',
                        topOffset
                    ];
                    emphasisTextStyle.align = 'right';
                } else if (offsetX - rect.width / 2 < 0) {
                    emphasisTextConfig.position = [
                        0,
                        topOffset
                    ];
                    emphasisTextStyle.align = 'left';
                }
            }
        });
    };
    ToolboxView.prototype.updateView = function(toolboxModel, ecModel, api, payload) {
        $2N6Uo.each(this._features, function(feature) {
            feature instanceof (0, $14R3P.ToolboxFeature) && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
        });
    };
    // updateLayout(toolboxModel, ecModel, api, payload) {
    //     zrUtil.each(this._features, function (feature) {
    //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
    //     });
    // },
    ToolboxView.prototype.remove = function(ecModel, api) {
        $2N6Uo.each(this._features, function(feature) {
            feature instanceof (0, $14R3P.ToolboxFeature) && feature.remove && feature.remove(ecModel, api);
        });
        this.group.removeAll();
    };
    ToolboxView.prototype.dispose = function(ecModel, api) {
        $2N6Uo.each(this._features, function(feature) {
            feature instanceof (0, $14R3P.ToolboxFeature) && feature.dispose && feature.dispose(ecModel, api);
        });
    };
    ToolboxView.type = 'toolbox';
    return ToolboxView;
}((0, $bpyST.default));
function $dcef4f8fae1b1a33$var$isUserFeatureName(featureName) {
    return featureName.indexOf('my') === 0;
}
var $dcef4f8fae1b1a33$export$2e2bcd8739ae039 = $dcef4f8fae1b1a33$var$ToolboxView;

});

parcelRegister("16Ohe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ced59f00a5cac19$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $cirKE = parcelRequire("cirKE");

var $14R3P = parcelRequire("14R3P");

var $6aXXD = parcelRequire("6aXXD");
var $0ced59f00a5cac19$var$SaveAsImage = /** @class */ function(_super) {
    (0, $9nEce.__extends)(SaveAsImage, _super);
    function SaveAsImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaveAsImage.prototype.onclick = function(ecModel, api) {
        var model = this.model;
        var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
        var isSvg = api.getZr().painter.getType() === 'svg';
        var type = isSvg ? 'svg' : model.get('type', true) || 'png';
        var url = api.getConnectedDataURL({
            type: type,
            backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || (0, $6aXXD.default).color.neutral00,
            connectedBackgroundColor: model.get('connectedBackgroundColor'),
            excludeComponents: model.get('excludeComponents'),
            pixelRatio: model.get('pixelRatio')
        });
        var browser = (0, $cirKE.default).browser;
        // Chrome, Firefox, New Edge
        if (typeof MouseEvent === 'function' && (browser.newEdge || !browser.ie && !browser.edge)) {
            var $a = document.createElement('a');
            $a.download = title + '.' + type;
            $a.target = '_blank';
            $a.href = url;
            var evt = new MouseEvent('click', {
                // some micro front-end framework， window maybe is a Proxy
                view: document.defaultView,
                bubbles: true,
                cancelable: false
            });
            $a.dispatchEvent(evt);
        } else // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob || isSvg) {
            var parts = url.split(',');
            // data:[<mime type>][;charset=<charset>][;base64],<encoded data>
            var base64Encoded = parts[0].indexOf('base64') > -1;
            var bstr = isSvg ? decodeURIComponent(parts[1]) : parts[1];
            // only `atob` when the data uri is encoded with base64
            // otherwise, like `svg` data uri exported by zrender,
            // there will be an error, for it's not encoded with base64.
            // (just a url-encoded string through `encodeURIComponent`)
            base64Encoded && (bstr = window.atob(bstr));
            var filename = title + '.' + type;
            // @ts-ignore
            if (window.navigator.msSaveOrOpenBlob) {
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while(n--)u8arr[n] = bstr.charCodeAt(n);
                var blob = new Blob([
                    u8arr
                ]); // @ts-ignore
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var frame = document.createElement('iframe');
                document.body.appendChild(frame);
                var cw = frame.contentWindow;
                var doc = cw.document;
                doc.open('image/svg+xml', 'replace');
                doc.write(bstr);
                doc.close();
                cw.focus();
                doc.execCommand('SaveAs', true, filename);
                document.body.removeChild(frame);
            }
        } else {
            var lang = model.get('lang');
            var html = '<body style="margin:0;"><img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
            var tab = window.open();
            tab.document.write(html);
            tab.document.title = title;
        }
    };
    SaveAsImage.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'saveAsImage',
                'title'
            ]),
            type: 'png',
            // Default use option.backgroundColor
            // backgroundColor: '#fff',
            connectedBackgroundColor: (0, $6aXXD.default).color.neutral00,
            name: '',
            excludeComponents: [
                'toolbox'
            ],
            // use current pixel ratio of device by default
            // pixelRatio: 1,
            lang: ecModel.getLocaleModel().get([
                'toolbox',
                'saveAsImage',
                'lang'
            ])
        };
        return defaultOption;
    };
    return SaveAsImage;
}((0, $14R3P.ToolboxFeature));
var $0ced59f00a5cac19$export$2e2bcd8739ae039 = $0ced59f00a5cac19$var$SaveAsImage;

});

parcelRegister("gCXG4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1ae7ca6ad3ab4c4$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N0NF = parcelRequire("2N0NF");

var $2N6Uo = parcelRequire("2N6Uo");

var $14R3P = parcelRequire("14R3P");

var $bx3T8 = parcelRequire("bx3T8");
var $c1ae7ca6ad3ab4c4$var$INNER_STACK_KEYWORD = '__ec_magicType_stack__';
var $c1ae7ca6ad3ab4c4$var$ICON_TYPES = [
    'line',
    'bar',
    'stack'
];
// stack and tiled appears in pair for the title
var $c1ae7ca6ad3ab4c4$var$TITLE_TYPES = [
    'line',
    'bar',
    'stack',
    'tiled'
];
var $c1ae7ca6ad3ab4c4$var$radioTypes = [
    [
        'line',
        'bar'
    ],
    [
        'stack'
    ]
];
var $c1ae7ca6ad3ab4c4$var$MagicType = /** @class */ function(_super) {
    (0, $9nEce.__extends)(MagicType, _super);
    function MagicType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MagicType.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get('icon');
        var icons = {};
        $2N6Uo.each(model.get('type'), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    MagicType.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: [],
            // Icon group
            icon: {
                line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
                bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
                // eslint-disable-next-line
                stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line
            },
            // `line`, `bar`, `stack`, `tiled`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'magicType',
                'title'
            ]),
            option: {},
            seriesIndex: {}
        };
        return defaultOption;
    };
    MagicType.prototype.onclick = function(ecModel, api, type) {
        var model = this.model;
        var seriesIndex = model.get([
            'seriesIndex',
            type
        ]);
        // Not supported magicType
        if (!$c1ae7ca6ad3ab4c4$var$seriesOptGenreator[type]) return;
        var newOption = {
            series: []
        };
        var generateNewSeriesTypes = function(seriesModel) {
            var seriesType = seriesModel.subType;
            var seriesId = seriesModel.id;
            var newSeriesOpt = $c1ae7ca6ad3ab4c4$var$seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
            if (newSeriesOpt) {
                // PENDING If merge original option?
                $2N6Uo.defaults(newSeriesOpt, seriesModel.option);
                newOption.series.push(newSeriesOpt);
            }
            // Modify boundaryGap
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
                var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
                if (categoryAxis) {
                    var axisDim = categoryAxis.dim;
                    var axisType = axisDim + 'Axis';
                    var axisModel = seriesModel.getReferringComponents(axisType, (0, $bx3T8.SINGLE_REFERRING)).models[0];
                    var axisIndex = axisModel.componentIndex;
                    newOption[axisType] = newOption[axisType] || [];
                    for(var i = 0; i <= axisIndex; i++)newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
                    newOption[axisType][axisIndex].boundaryGap = type === 'bar';
                }
            }
        };
        $2N6Uo.each($c1ae7ca6ad3ab4c4$var$radioTypes, function(radio) {
            if ($2N6Uo.indexOf(radio, type) >= 0) $2N6Uo.each(radio, function(item) {
                model.setIconStatus(item, 'normal');
            });
        });
        model.setIconStatus(type, 'emphasis');
        ecModel.eachComponent({
            mainType: 'series',
            query: seriesIndex == null ? null : {
                seriesIndex: seriesIndex
            }
        }, generateNewSeriesTypes);
        var newTitle;
        var currentType = type;
        // Change title of stack
        if (type === 'stack') {
            // use titles in model instead of ecModel
            // as stack and tiled appears in pair, just flip them
            // no need of checking stack state
            newTitle = $2N6Uo.merge({
                stack: model.option.title.tiled,
                tiled: model.option.title.stack
            }, model.option.title);
            if (model.get([
                'iconStatus',
                type
            ]) !== 'emphasis') currentType = 'tiled';
        }
        api.dispatchAction({
            type: 'changeMagicType',
            currentType: currentType,
            newOption: newOption,
            newTitle: newTitle,
            featureName: 'magicType'
        });
    };
    return MagicType;
}((0, $14R3P.ToolboxFeature));
var $c1ae7ca6ad3ab4c4$var$seriesOptGenreator = {
    'line': function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === 'bar') return $2N6Uo.merge({
            id: seriesId,
            type: 'line',
            // Preserve data related option
            data: seriesModel.get('data'),
            stack: seriesModel.get('stack'),
            markPoint: seriesModel.get('markPoint'),
            markLine: seriesModel.get('markLine')
        }, model.get([
            'option',
            'line'
        ]) || {}, true);
    },
    'bar': function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === 'line') return $2N6Uo.merge({
            id: seriesId,
            type: 'bar',
            // Preserve data related option
            data: seriesModel.get('data'),
            stack: seriesModel.get('stack'),
            markPoint: seriesModel.get('markPoint'),
            markLine: seriesModel.get('markLine')
        }, model.get([
            'option',
            'bar'
        ]) || {}, true);
    },
    'stack': function(seriesType, seriesId, seriesModel, model) {
        var isStack = seriesModel.get('stack') === $c1ae7ca6ad3ab4c4$var$INNER_STACK_KEYWORD;
        if (seriesType === 'line' || seriesType === 'bar') {
            model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
            return $2N6Uo.merge({
                id: seriesId,
                stack: isStack ? '' : $c1ae7ca6ad3ab4c4$var$INNER_STACK_KEYWORD
            }, model.get([
                'option',
                'stack'
            ]) || {}, true);
        }
    }
};
// TODO: SELF REGISTERED.
$2N0NF.registerAction({
    type: 'changeMagicType',
    event: 'magicTypeChanged',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    ecModel.mergeOption(payload.newOption);
});
var $c1ae7ca6ad3ab4c4$export$2e2bcd8739ae039 = $c1ae7ca6ad3ab4c4$var$MagicType;

});

parcelRegister("g375u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baf26c9dddc74503$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N0NF = parcelRequire("2N0NF");

var $2N6Uo = parcelRequire("2N6Uo");

var $14R3P = parcelRequire("14R3P");

var $pGNPI = parcelRequire("pGNPI");


var $6aXXD = parcelRequire("6aXXD");
/* global document */ var $baf26c9dddc74503$var$BLOCK_SPLITER = new Array(60).join('-');
var $baf26c9dddc74503$var$ITEM_SPLITER = '\t';
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 */ function $baf26c9dddc74503$var$groupSeries(ecModel) {
    var seriesGroupByCategoryAxis = {};
    var otherSeries = [];
    var meta = [];
    ecModel.eachRawSeries(function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
            // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
            var baseAxis = coordSys.getBaseAxis();
            if (baseAxis.type === 'category') {
                var key = baseAxis.dim + '_' + baseAxis.index;
                if (!seriesGroupByCategoryAxis[key]) {
                    seriesGroupByCategoryAxis[key] = {
                        categoryAxis: baseAxis,
                        valueAxis: coordSys.getOtherAxis(baseAxis),
                        series: []
                    };
                    meta.push({
                        axisDim: baseAxis.dim,
                        axisIndex: baseAxis.index
                    });
                }
                seriesGroupByCategoryAxis[key].series.push(seriesModel);
            } else otherSeries.push(seriesModel);
        } else otherSeries.push(seriesModel);
    });
    return {
        seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
        other: otherSeries,
        meta: meta
    };
}
/**
 * Assemble content of series on cateogory axis
 * @inner
 */ function $baf26c9dddc74503$var$assembleSeriesWithCategoryAxis(groups) {
    var tables = [];
    $2N6Uo.each(groups, function(group, key) {
        var categoryAxis = group.categoryAxis;
        var valueAxis = group.valueAxis;
        var valueAxisDim = valueAxis.dim;
        var headers = [
            ' '
        ].concat($2N6Uo.map(group.series, function(series) {
            return series.name;
        }));
        // @ts-ignore TODO Polar
        var columns = [
            categoryAxis.model.getCategories()
        ];
        $2N6Uo.each(group.series, function(series) {
            var rawData = series.getRawData();
            columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function(val) {
                return val;
            }));
        });
        // Assemble table content
        var lines = [
            headers.join($baf26c9dddc74503$var$ITEM_SPLITER)
        ];
        for(var i = 0; i < columns[0].length; i++){
            var items = [];
            for(var j = 0; j < columns.length; j++)items.push(columns[j][i]);
            lines.push(items.join($baf26c9dddc74503$var$ITEM_SPLITER));
        }
        tables.push(lines.join('\n'));
    });
    return tables.join('\n\n' + $baf26c9dddc74503$var$BLOCK_SPLITER + '\n\n');
}
/**
 * Assemble content of other series
 */ function $baf26c9dddc74503$var$assembleOtherSeries(series) {
    return $2N6Uo.map(series, function(series) {
        var data = series.getRawData();
        var lines = [
            series.name
        ];
        var vals = [];
        data.each(data.dimensions, function() {
            var argLen = arguments.length;
            var dataIndex = arguments[argLen - 1];
            var name = data.getName(dataIndex);
            for(var i = 0; i < argLen - 1; i++)vals[i] = arguments[i];
            lines.push((name ? name + $baf26c9dddc74503$var$ITEM_SPLITER : '') + vals.join($baf26c9dddc74503$var$ITEM_SPLITER));
        });
        return lines.join('\n');
    }).join('\n\n' + $baf26c9dddc74503$var$BLOCK_SPLITER + '\n\n');
}
function $baf26c9dddc74503$var$getContentFromModel(ecModel) {
    var result = $baf26c9dddc74503$var$groupSeries(ecModel);
    return {
        value: $2N6Uo.filter([
            $baf26c9dddc74503$var$assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis),
            $baf26c9dddc74503$var$assembleOtherSeries(result.other)
        ], function(str) {
            return !!str.replace(/[\n\t\s]/g, '');
        }).join('\n\n' + $baf26c9dddc74503$var$BLOCK_SPLITER + '\n\n'),
        meta: result.meta
    };
}
function $baf26c9dddc74503$var$trim(str) {
    return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}
/**
 * If a block is tsv format
 */ function $baf26c9dddc74503$var$isTSVFormat(block) {
    // Simple method to find out if a block is tsv format
    var firstLine = block.slice(0, block.indexOf('\n'));
    if (firstLine.indexOf($baf26c9dddc74503$var$ITEM_SPLITER) >= 0) return true;
}
var $baf26c9dddc74503$var$itemSplitRegex = new RegExp('[' + $baf26c9dddc74503$var$ITEM_SPLITER + ']+', 'g');
/**
 * @param {string} tsv
 * @return {Object}
 */ function $baf26c9dddc74503$var$parseTSVContents(tsv) {
    var tsvLines = tsv.split(/\n+/g);
    var headers = $baf26c9dddc74503$var$trim(tsvLines.shift()).split($baf26c9dddc74503$var$itemSplitRegex);
    var categories = [];
    var series = $2N6Uo.map(headers, function(header) {
        return {
            name: header,
            data: []
        };
    });
    for(var i = 0; i < tsvLines.length; i++){
        var items = $baf26c9dddc74503$var$trim(tsvLines[i]).split($baf26c9dddc74503$var$itemSplitRegex);
        categories.push(items.shift());
        for(var j = 0; j < items.length; j++)series[j] && (series[j].data[i] = items[j]);
    }
    return {
        series: series,
        categories: categories
    };
}
function $baf26c9dddc74503$var$parseListContents(str) {
    var lines = str.split(/\n+/g);
    var seriesName = $baf26c9dddc74503$var$trim(lines.shift());
    var data = [];
    for(var i = 0; i < lines.length; i++){
        // if line is empty, ignore it.
        // there is a case that a user forgot to delete `\n`.
        var line = $baf26c9dddc74503$var$trim(lines[i]);
        if (!line) continue;
        var items = line.split($baf26c9dddc74503$var$itemSplitRegex);
        var name_1 = '';
        var value = void 0;
        var hasName = false;
        if (isNaN(items[0])) {
            // First item is name
            hasName = true;
            name_1 = items[0];
            items = items.slice(1);
            data[i] = {
                name: name_1,
                value: []
            };
            value = data[i].value;
        } else value = data[i] = [];
        for(var j = 0; j < items.length; j++)value.push(+items[j]);
        if (value.length === 1) hasName ? data[i].value = value[0] : data[i] = value[0];
    }
    return {
        name: seriesName,
        data: data
    };
}
function $baf26c9dddc74503$var$parseContents(str, blockMetaList) {
    var blocks = str.split(new RegExp('\n*' + $baf26c9dddc74503$var$BLOCK_SPLITER + '\n*', 'g'));
    var newOption = {
        series: []
    };
    $2N6Uo.each(blocks, function(block, idx) {
        if ($baf26c9dddc74503$var$isTSVFormat(block)) {
            var result = $baf26c9dddc74503$var$parseTSVContents(block);
            var blockMeta = blockMetaList[idx];
            var axisKey = blockMeta.axisDim + 'Axis';
            if (blockMeta) {
                newOption[axisKey] = newOption[axisKey] || [];
                newOption[axisKey][blockMeta.axisIndex] = {
                    data: result.categories
                };
                newOption.series = newOption.series.concat(result.series);
            }
        } else {
            var result = $baf26c9dddc74503$var$parseListContents(block);
            newOption.series.push(result);
        }
    });
    return newOption;
}
var $baf26c9dddc74503$var$DataView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(DataView, _super);
    function DataView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataView.prototype.onclick = function(ecModel, api) {
        // FIXME: better way?
        setTimeout(function() {
            api.dispatchAction({
                type: 'hideTip'
            });
        });
        var container = api.getDom();
        var model = this.model;
        if (this._dom) container.removeChild(this._dom);
        var root = document.createElement('div');
        // use padding to avoid 5px whitespace
        root.style.cssText = 'position:absolute;top:0;bottom:0;left:0;right:0;padding:5px';
        root.style.backgroundColor = model.get('backgroundColor') || (0, $6aXXD.default).color.neutral00;
        // Create elements
        var header = document.createElement('h4');
        var lang = model.get('lang') || [];
        header.innerHTML = lang[0] || model.get('title');
        header.style.cssText = 'margin:10px 20px';
        header.style.color = model.get('textColor');
        var viewMain = document.createElement('div');
        var textarea = document.createElement('textarea');
        viewMain.style.cssText = 'overflow:auto';
        var optionToContent = model.get('optionToContent');
        var contentToOption = model.get('contentToOption');
        var result = $baf26c9dddc74503$var$getContentFromModel(ecModel);
        if ($2N6Uo.isFunction(optionToContent)) {
            var htmlOrDom = optionToContent(api.getOption());
            if ($2N6Uo.isString(htmlOrDom)) viewMain.innerHTML = htmlOrDom;
            else if ($2N6Uo.isDom(htmlOrDom)) viewMain.appendChild(htmlOrDom);
        } else {
            // Use default textarea
            textarea.readOnly = model.get('readOnly');
            var style = textarea.style;
            // eslint-disable-next-line max-len
            style.cssText = 'display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none';
            style.color = model.get('textColor');
            style.borderColor = model.get('textareaBorderColor');
            style.backgroundColor = model.get('textareaColor');
            textarea.value = result.value;
            viewMain.appendChild(textarea);
        }
        var blockMetaList = result.meta;
        var buttonContainer = document.createElement('div');
        buttonContainer.style.cssText = 'position:absolute;bottom:5px;left:0;right:0';
        // eslint-disable-next-line max-len
        var buttonStyle = 'float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
        var closeButton = document.createElement('div');
        var refreshButton = document.createElement('div');
        buttonStyle += ';background-color:' + model.get('buttonColor');
        buttonStyle += ';color:' + model.get('buttonTextColor');
        var self = this;
        function close() {
            container.removeChild(root);
            self._dom = null;
        }
        (0, $pGNPI.addEventListener)(closeButton, 'click', close);
        (0, $pGNPI.addEventListener)(refreshButton, 'click', function() {
            if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
                close();
                return;
            }
            var newOption;
            try {
                if ($2N6Uo.isFunction(contentToOption)) newOption = contentToOption(viewMain, api.getOption());
                else newOption = $baf26c9dddc74503$var$parseContents(textarea.value, blockMetaList);
            } catch (e) {
                close();
                throw new Error('Data view format error ' + e);
            }
            if (newOption) api.dispatchAction({
                type: 'changeDataView',
                newOption: newOption
            });
            close();
        });
        closeButton.innerHTML = lang[1];
        refreshButton.innerHTML = lang[2];
        refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
        !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
        buttonContainer.appendChild(closeButton);
        root.appendChild(header);
        root.appendChild(viewMain);
        root.appendChild(buttonContainer);
        viewMain.style.height = container.clientHeight - 80 + 'px';
        container.appendChild(root);
        this._dom = root;
    };
    DataView.prototype.remove = function(ecModel, api) {
        this._dom && api.getDom().removeChild(this._dom);
    };
    DataView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    DataView.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            readOnly: false,
            optionToContent: null,
            contentToOption: null,
            // eslint-disable-next-line
            icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'dataView',
                'title'
            ]),
            lang: ecModel.getLocaleModel().get([
                'toolbox',
                'dataView',
                'lang'
            ]),
            backgroundColor: (0, $6aXXD.default).color.background,
            textColor: (0, $6aXXD.default).color.primary,
            textareaColor: (0, $6aXXD.default).color.background,
            textareaBorderColor: (0, $6aXXD.default).color.border,
            buttonColor: (0, $6aXXD.default).color.accent50,
            buttonTextColor: (0, $6aXXD.default).color.neutral00
        };
        return defaultOption;
    };
    return DataView;
}((0, $14R3P.ToolboxFeature));
/**
 * @inner
 */ function $baf26c9dddc74503$var$tryMergeDataOption(newData, originalData) {
    return $2N6Uo.map(newData, function(newVal, idx) {
        var original = originalData && originalData[idx];
        if ($2N6Uo.isObject(original) && !$2N6Uo.isArray(original)) {
            var newValIsObject = $2N6Uo.isObject(newVal) && !$2N6Uo.isArray(newVal);
            if (!newValIsObject) newVal = {
                value: newVal
            };
            // original data has name but new data has no name
            var shouldDeleteName = original.name != null && newVal.name == null;
            // Original data has option
            newVal = $2N6Uo.defaults(newVal, original);
            shouldDeleteName && delete newVal.name;
            return newVal;
        } else return newVal;
    });
}
// TODO: SELF REGISTERED.
$2N0NF.registerAction({
    type: 'changeDataView',
    event: 'dataViewChanged',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    var newSeriesOptList = [];
    $2N6Uo.each(payload.newOption.series, function(seriesOpt) {
        var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
        if (!seriesModel) // New created series
        // Geuss the series type
        newSeriesOptList.push($2N6Uo.extend({
            // Default is scatter
            type: 'scatter'
        }, seriesOpt));
        else {
            var originalData = seriesModel.get('data');
            newSeriesOptList.push({
                name: seriesOpt.name,
                data: $baf26c9dddc74503$var$tryMergeDataOption(seriesOpt.data, originalData)
            });
        }
    });
    ecModel.mergeOption($2N6Uo.defaults({
        series: newSeriesOptList
    }, payload.newOption));
});
var $baf26c9dddc74503$export$2e2bcd8739ae039 = $baf26c9dddc74503$var$DataView;

});

parcelRegister("1bECW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dd6553ae52a7adf$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N0NF = parcelRequire("2N0NF");

var $cGdYh = parcelRequire("cGdYh");

var $14R3P = parcelRequire("14R3P");
var $0dd6553ae52a7adf$var$RestoreOption = /** @class */ function(_super) {
    (0, $9nEce.__extends)(RestoreOption, _super);
    function RestoreOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestoreOption.prototype.onclick = function(ecModel, api) {
        $cGdYh.clear(ecModel);
        api.dispatchAction({
            type: 'restore',
            from: this.uid
        });
    };
    RestoreOption.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            // eslint-disable-next-line
            icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'restore',
                'title'
            ])
        };
        return defaultOption;
    };
    return RestoreOption;
}((0, $14R3P.ToolboxFeature));
// TODO: SELF REGISTERED.
$2N0NF.registerAction({
    type: 'restore',
    event: 'restore',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    ecModel.resetOption('recreate');
});
var $0dd6553ae52a7adf$export$2e2bcd8739ae039 = $0dd6553ae52a7adf$var$RestoreOption;

});
parcelRegister("cGdYh", function(module, exports) {

$parcel$export(module.exports, "push", function () { return $93b43eac3a792c9b$export$4cbf152802aa238; });
$parcel$export(module.exports, "pop", function () { return $93b43eac3a792c9b$export$3e41007ebfff0e64; });
$parcel$export(module.exports, "clear", function () { return $93b43eac3a792c9b$export$42ffd38884aecdac; });
$parcel$export(module.exports, "count", function () { return $93b43eac3a792c9b$export$85b9a36db797e02b; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");
var $93b43eac3a792c9b$var$each = $2N6Uo.each;
var $93b43eac3a792c9b$var$inner = (0, $bx3T8.makeInner)();
function $93b43eac3a792c9b$export$4cbf152802aa238(ecModel, newSnapshot) {
    var storedSnapshots = $93b43eac3a792c9b$var$getStoreSnapshots(ecModel);
    // If previous dataZoom can not be found,
    // complete an range with current range.
    $93b43eac3a792c9b$var$each(newSnapshot, function(batchItem, dataZoomId) {
        var i = storedSnapshots.length - 1;
        for(; i >= 0; i--){
            var snapshot = storedSnapshots[i];
            if (snapshot[dataZoomId]) break;
        }
        if (i < 0) {
            // No origin range set, create one by current range.
            var dataZoomModel = ecModel.queryComponents({
                mainType: 'dataZoom',
                subType: 'select',
                id: dataZoomId
            })[0];
            if (dataZoomModel) {
                var percentRange = dataZoomModel.getPercentRange();
                storedSnapshots[0][dataZoomId] = {
                    dataZoomId: dataZoomId,
                    start: percentRange[0],
                    end: percentRange[1]
                };
            }
        }
    });
    storedSnapshots.push(newSnapshot);
}
function $93b43eac3a792c9b$export$3e41007ebfff0e64(ecModel) {
    var storedSnapshots = $93b43eac3a792c9b$var$getStoreSnapshots(ecModel);
    var head = storedSnapshots[storedSnapshots.length - 1];
    storedSnapshots.length > 1 && storedSnapshots.pop();
    // Find top for all dataZoom.
    var snapshot = {};
    $93b43eac3a792c9b$var$each(head, function(batchItem, dataZoomId) {
        for(var i = storedSnapshots.length - 1; i >= 0; i--){
            batchItem = storedSnapshots[i][dataZoomId];
            if (batchItem) {
                snapshot[dataZoomId] = batchItem;
                break;
            }
        }
    });
    return snapshot;
}
function $93b43eac3a792c9b$export$42ffd38884aecdac(ecModel) {
    $93b43eac3a792c9b$var$inner(ecModel).snapshots = null;
}
function $93b43eac3a792c9b$export$85b9a36db797e02b(ecModel) {
    return $93b43eac3a792c9b$var$getStoreSnapshots(ecModel).length;
}
/**
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 */ function $93b43eac3a792c9b$var$getStoreSnapshots(ecModel) {
    var store = $93b43eac3a792c9b$var$inner(ecModel);
    if (!store.snapshots) store.snapshots = [
        {}
    ];
    return store.snapshots;
}

});


parcelRegister("5VWrz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $451f9c4dd5881519$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $97tZB = parcelRequire("97tZB");

var $7rtpa = parcelRequire("7rtpa");

var $cGdYh = parcelRequire("cGdYh");

var $43jQn = parcelRequire("43jQn");

var $14R3P = parcelRequire("14R3P");

var $bx3T8 = parcelRequire("bx3T8");

var $c69Sq = parcelRequire("c69Sq");

var $6aXXD = parcelRequire("6aXXD");
var $451f9c4dd5881519$var$each = $2N6Uo.each;
var $451f9c4dd5881519$var$DATA_ZOOM_ID_BASE = (0, $bx3T8.makeInternalComponentId)('toolbox-dataZoom_');
var $451f9c4dd5881519$var$ICON_TYPES = [
    'zoom',
    'back'
];
var $451f9c4dd5881519$var$DataZoomFeature = /** @class */ function(_super) {
    (0, $9nEce.__extends)(DataZoomFeature, _super);
    function DataZoomFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataZoomFeature.prototype.render = function(featureModel, ecModel, api, payload) {
        if (!this._brushController) {
            this._brushController = new (0, $97tZB.default)(api.getZr());
            this._brushController.on('brush', $2N6Uo.bind(this._onBrush, this)).mount();
        }
        $451f9c4dd5881519$var$updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
        $451f9c4dd5881519$var$updateBackBtnStatus(featureModel, ecModel);
    };
    DataZoomFeature.prototype.onclick = function(ecModel, api, type) {
        $451f9c4dd5881519$var$handlers[type].call(this);
    };
    DataZoomFeature.prototype.remove = function(ecModel, api) {
        this._brushController && this._brushController.unmount();
    };
    DataZoomFeature.prototype.dispose = function(ecModel, api) {
        this._brushController && this._brushController.dispose();
    };
    DataZoomFeature.prototype._onBrush = function(eventParam) {
        var areas = eventParam.areas;
        if (!eventParam.isEnd || !areas.length) return;
        var snapshot = {};
        var ecModel = this.ecModel;
        this._brushController.updateCovers([]); // remove cover
        var brushTargetManager = new (0, $7rtpa.default)($451f9c4dd5881519$var$makeAxisFinder(this.model), ecModel, {
            include: [
                'grid'
            ]
        });
        brushTargetManager.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            if (coordSys.type !== 'cartesian2d') return;
            var brushType = area.brushType;
            if (brushType === 'rect') {
                setBatch('x', coordSys, coordRange[0]);
                setBatch('y', coordSys, coordRange[1]);
            } else setBatch({
                lineX: 'x',
                lineY: 'y'
            }[brushType], coordSys, coordRange);
        });
        $cGdYh.push(ecModel, snapshot);
        this._dispatchZoomAction(snapshot);
        function setBatch(dimName, coordSys, minMax) {
            var axis = coordSys.getAxis(dimName);
            var axisModel = axis.model;
            var dataZoomModel = findDataZoom(dimName, axisModel, ecModel);
            // Restrict range.
            var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
            if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) minMax = (0, $43jQn.default)(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
            dataZoomModel && (snapshot[dataZoomModel.id] = {
                dataZoomId: dataZoomModel.id,
                startValue: minMax[0],
                endValue: minMax[1]
            });
        }
        function findDataZoom(dimName, axisModel, ecModel) {
            var found;
            ecModel.eachComponent({
                mainType: 'dataZoom',
                subType: 'select'
            }, function(dzModel) {
                var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
                has && (found = dzModel);
            });
            return found;
        }
    };
    DataZoomFeature.prototype._dispatchZoomAction = function(snapshot) {
        var batch = [];
        // Convert from hash map to array.
        $451f9c4dd5881519$var$each(snapshot, function(batchItem, dataZoomId) {
            batch.push($2N6Uo.clone(batchItem));
        });
        batch.length && this.api.dispatchAction({
            type: 'dataZoom',
            from: this.uid,
            batch: batch
        });
    };
    DataZoomFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            filterMode: 'filter',
            // Icon group
            icon: {
                zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
                back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
            },
            // `zoom`, `back`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'dataZoom',
                'title'
            ]),
            brushStyle: {
                borderWidth: 0,
                color: (0, $6aXXD.default).color.backgroundTint
            }
        };
        return defaultOption;
    };
    return DataZoomFeature;
}((0, $14R3P.ToolboxFeature));
var $451f9c4dd5881519$var$handlers = {
    zoom: function() {
        var nextActive = !this._isZoomActive;
        this.api.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'dataZoomSelect',
            dataZoomSelectActive: nextActive
        });
    },
    back: function() {
        this._dispatchZoomAction($cGdYh.pop(this.ecModel));
    }
};
function $451f9c4dd5881519$var$makeAxisFinder(dzFeatureModel) {
    var setting = {
        xAxisIndex: dzFeatureModel.get('xAxisIndex', true),
        yAxisIndex: dzFeatureModel.get('yAxisIndex', true),
        xAxisId: dzFeatureModel.get('xAxisId', true),
        yAxisId: dzFeatureModel.get('yAxisId', true)
    };
    // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
    // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
    // Some old cases set like this below to close yAxis control but leave xAxis control:
    // `{ feature: { dataZoom: { yAxisIndex: false } }`.
    if (setting.xAxisIndex == null && setting.xAxisId == null) setting.xAxisIndex = 'all';
    if (setting.yAxisIndex == null && setting.yAxisId == null) setting.yAxisIndex = 'all';
    return setting;
}
function $451f9c4dd5881519$var$updateBackBtnStatus(featureModel, ecModel) {
    featureModel.setIconStatus('back', $cGdYh.count(ecModel) > 1 ? 'emphasis' : 'normal');
}
function $451f9c4dd5881519$var$updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
    var zoomActive = view._isZoomActive;
    if (payload && payload.type === 'takeGlobalCursor') zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
    view._isZoomActive = zoomActive;
    featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
    var brushTargetManager = new (0, $7rtpa.default)($451f9c4dd5881519$var$makeAxisFinder(featureModel), ecModel, {
        include: [
            'grid'
        ]
    });
    var panels = brushTargetManager.makePanelOpts(api, function(targetInfo) {
        return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
    });
    view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
        brushType: 'auto',
        brushStyle: featureModel.getModel('brushStyle').getItemStyle()
    } : false);
}
(0, $c69Sq.registerInternalOptionCreator)('dataZoom', function(ecModel) {
    var toolboxModel = ecModel.getComponent('toolbox', 0);
    var featureDataZoomPath = [
        'feature',
        'dataZoom'
    ];
    if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) return;
    var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
    var dzOptions = [];
    var finder = $451f9c4dd5881519$var$makeAxisFinder(dzFeatureModel);
    var finderResult = (0, $bx3T8.parseFinder)(ecModel, finder);
    $451f9c4dd5881519$var$each(finderResult.xAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, 'xAxis', 'xAxisIndex');
    });
    $451f9c4dd5881519$var$each(finderResult.yAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, 'yAxis', 'yAxisIndex');
    });
    function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
        var axisIndex = axisModel.componentIndex;
        var newOpt = {
            type: 'select',
            $fromToolbox: true,
            // Default to be filter
            filterMode: dzFeatureModel.get('filterMode', true) || 'filter',
            // Id for merge mapping.
            id: $451f9c4dd5881519$var$DATA_ZOOM_ID_BASE + axisMainType + axisIndex
        };
        newOpt[axisIndexPropName] = axisIndex;
        dzOptions.push(newOpt);
    }
    return dzOptions;
});
var $451f9c4dd5881519$export$2e2bcd8739ae039 = $451f9c4dd5881519$var$DataZoomFeature;

});


parcelRegister("aVImd", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $7f51a2b04af2e7fb$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $24qes = parcelRequire("24qes");

var $gX19P = parcelRequire("gX19P");

var $5gFir = parcelRequire("5gFir");

var $jV73y = parcelRequire("jV73y");

var $2N6Uo = parcelRequire("2N6Uo");
function $7f51a2b04af2e7fb$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $24qes.install));
    registers.registerComponentModel((0, $5gFir.default));
    registers.registerComponentView((0, $jV73y.default));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, (0, $2N6Uo.noop));
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, (0, $2N6Uo.noop));
}

});
parcelRegister("5gFir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d5e7af979e613fb$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $eLD2b = parcelRequire("eLD2b");

var $6aXXD = parcelRequire("6aXXD");
var $3d5e7af979e613fb$var$TooltipModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click',
        alwaysShowContent: false,
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaults to `false` (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        displayTransition: true,
        enterable: false,
        backgroundColor: (0, $6aXXD.default).color.neutral00,
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        defaultBorderColor: (0, $6aXXD.default).color.border,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: (0, $6aXXD.default).color.borderShade,
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: (0, $6aXXD.default).color.tertiary,
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $eLD2b.default));
var $3d5e7af979e613fb$export$2e2bcd8739ae039 = $3d5e7af979e613fb$var$TooltipModel;

});

parcelRegister("jV73y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e808d06bbbee5123$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $cirKE = parcelRequire("cirKE");

var $2b2qT = parcelRequire("2b2qT");

var $hmcvQ = parcelRequire("hmcvQ");

var $hrphB = parcelRequire("hrphB");
var $dhQnW = parcelRequire("dhQnW");

var $iCU10 = parcelRequire("iCU10");
parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");

var $jyhKb = parcelRequire("jyhKb");

var $a35Wn = parcelRequire("a35Wn");

var $b8YKU = parcelRequire("b8YKU");

var $9uL27 = parcelRequire("9uL27");

var $9AF98 = parcelRequire("9AF98");

var $7bAwM = parcelRequire("7bAwM");

var $bx3T8 = parcelRequire("bx3T8");

var $bpyST = parcelRequire("bpyST");

var $7Mt3p = parcelRequire("7Mt3p");

var $6TSUP = parcelRequire("6TSUP");

var $9rLJf = parcelRequire("9rLJf");

var $7NPXc = parcelRequire("7NPXc");

var $5KdhI = parcelRequire("5KdhI");

var $cQG2W = parcelRequire("cQG2W");

var $99VtN = parcelRequire("99VtN");
var $e808d06bbbee5123$var$proxyRect = new (0, $aH2k0.default)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $e808d06bbbee5123$var$TooltipView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $cirKE.default).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = this._renderMode = (0, $bx3T8.getTooltipRenderMode)(tooltipModel.get('renderMode'));
        this._tooltipContent = renderMode === 'richText' ? new (0, $hmcvQ.default)(api) : new (0, $2b2qT.default)(api, {
            appendTo: tooltipModel.get('appendToBody', true) ? 'body' : tooltipModel.get('appendTo', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $cirKE.default).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) (0, $99VtN.createOrUpdate)(this, '_updatePosition', 50, 'fixRate');
        else (0, $99VtN.clear)(this, '_updatePosition');
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $9uL27.register('itemTooltip', this._api, (0, $2N6Uo.bind)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get('triggerOn');
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== 'none' && triggerOn !== 'click') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $cirKE.default).node || !api.getDom()) return;
        var dispatchAction = $e808d06bbbee5123$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = '';
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $e808d06bbbee5123$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $e808d06bbbee5123$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $6TSUP.getECData)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $jyhKb.default)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($e808d06bbbee5123$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $e808d06bbbee5123$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $6TSUP.getECData)(el);
            if (ecData.ssrType === 'legend') // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $cQG2W.findEventDispatcher)(el, function(target) {
                if (target.tooltipDisabled) {
                    seriesDispatcher_1 = cmptDispatcher_1 = null;
                    return true;
                }
                if (seriesDispatcher_1 || cmptDispatcher_1) return;
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $6TSUP.getECData)(target).dataIndex != null) seriesDispatcher_1 = target;
                else if ((0, $6TSUP.getECData)(target).tooltipConfig != null) cmptDispatcher_1 = target;
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = (0, $2N6Uo.bind)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $e808d06bbbee5123$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $5KdhI.createTooltipMarkup)('section', {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $5KdhI.TooltipMarkupStyleCreator)();
        (0, $2N6Uo.each)(dataByCoordSys, function(itemCoordSys) {
            (0, $2N6Uo.each)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                // FIXME: when using `tooltip.trigger: 'axis'`, the precision of the axis value displayed in tooltip
                //  should match the original series values rather than using the default stretegy in Interval.ts
                //  (getPrecision(interval) + 2); otherwise it may cuase confusion.
                var axisValueLabel = $7bAwM.getValueLabel(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $5KdhI.createTooltipMarkup)('section', {
                    header: axisValueLabel,
                    noHeader: !(0, $2N6Uo.trim)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $2N6Uo.each)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $9AF98.getAxisRawValue(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', (0, $hrphB.convertToColorString)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $7NPXc.normalizeTooltipFormatResult)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $e808d06bbbee5123$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get('valueFormatter');
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $2N6Uo.extend)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $5KdhI.buildTooltipMarkup)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $6TSUP.getECData)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $e808d06bbbee5123$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $5KdhI.TooltipMarkupStyleCreator)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', (0, $hrphB.convertToColorString)(params.color), renderMode);
        var seriesTooltipResult = (0, $7NPXc.normalizeTooltipFormatResult)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var valueFormatter = tooltipModel.get('valueFormatter');
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $5KdhI.buildTooltipMarkup)(valueFormatter ? (0, $2N6Uo.extend)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var isHTMLRenderMode = this._renderMode === 'html';
        var ecData = (0, $6TSUP.getECData)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        var encodeHTMLContent = tooltipOpt.encodeHTMLContent;
        if ((0, $2N6Uo.isString)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
            // when `tooltipConfig.option` is a string rather than an object,
            // we can't know if the content needs to be encoded
            // for the sake of security, encode it by default.
            encodeHTMLContent = true;
        }
        if (encodeHTMLContent && isHTMLRenderMode && tooltipOpt.content) {
            // clone might be unnecessary?
            tooltipOpt = (0, $2N6Uo.clone)(tooltipOpt);
            tooltipOpt.content = (0, $dhQnW.encodeHTML)(tooltipOpt.content);
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $e808d06bbbee5123$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + '';
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $5KdhI.TooltipMarkupStyleCreator)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $2N6Uo.clone)(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'), tooltipModel.get('defaultBorderColor', true));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $2N6Uo.isString)(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = (0, $2N6Uo.isArray)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $7Mt3p.format)(params0.axisValue, html, useUTC);
                html = (0, $hrphB.formatTpl)(html, params, true);
            } else if ((0, $2N6Uo.isFunction)(formatter)) {
                var callback = (0, $2N6Uo.bind)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor, defaultBorderColor) {
        if (trigger === 'axis' || (0, $2N6Uo.isArray)(tooltipDataParams)) return {
            color: borderColor || defaultBorderColor
        };
        if (!(0, $2N6Uo.isArray)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $2N6Uo.isFunction)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $2N6Uo.isArray)(positionExpr)) {
            x = (0, $iCU10.parsePercent)(positionExpr[0], viewWidth);
            y = (0, $iCU10.parsePercent)(positionExpr[1], viewHeight);
        } else if ((0, $2N6Uo.isObject)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $a35Wn.getLayoutRect)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $2N6Uo.isString)(positionExpr) && el) {
            var pos = $e808d06bbbee5123$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $e808d06bbbee5123$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $e808d06bbbee5123$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $e808d06bbbee5123$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $9rLJf.shouldTooltipConfine)(tooltipModel)) {
            var pos = $e808d06bbbee5123$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $2N6Uo.each)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $2N6Uo.each)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $2N6Uo.each)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $2N6Uo.each)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $cirKE.default).node || !api.getDom()) return;
        (0, $99VtN.clear)(this, '_updatePosition');
        this._tooltipContent.dispose();
        $9uL27.unregister('itemTooltip', api);
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $bpyST.default));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $e808d06bbbee5123$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $b8YKU.default)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $b8YKU.default)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $b8YKU.default)) tooltipOpt = tooltipOpt.get('tooltip', true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $2N6Uo.isString)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $b8YKU.default)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $e808d06bbbee5123$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $2N6Uo.bind)(api.dispatchAction, api);
}
function $e808d06bbbee5123$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $e808d06bbbee5123$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $e808d06bbbee5123$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $e808d06bbbee5123$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $e808d06bbbee5123$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $bx3T8.preParseFinder)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $bx3T8.queryReferringComponents)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $6TSUP.getECData)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $e808d06bbbee5123$export$2e2bcd8739ae039 = $e808d06bbbee5123$var$TooltipView;

});
parcelRegister("2b2qT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $195e7ef4c04119f1$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $pGNPI = parcelRequire("pGNPI");

var $dhQnW = parcelRequire("dhQnW");

var $cirKE = parcelRequire("cirKE");

var $hrphB = parcelRequire("hrphB");

var $9rLJf = parcelRequire("9rLJf");

var $5KdhI = parcelRequire("5KdhI");
/* global document, window */ var $195e7ef4c04119f1$var$CSS_TRANSITION_VENDOR = (0, $9rLJf.toCSSVendorPrefix)((0, $9rLJf.TRANSITION_VENDOR), 'transition');
var $195e7ef4c04119f1$var$CSS_TRANSFORM_VENDOR = (0, $9rLJf.toCSSVendorPrefix)((0, $9rLJf.TRANSFORM_VENDOR), 'transform');
// eslint-disable-next-line
var $195e7ef4c04119f1$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $cirKE.default).transform3dSupported ? 'will-change:transform;' : '');
function $195e7ef4c04119f1$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $195e7ef4c04119f1$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $2N6Uo.isString)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $hrphB.convertToColorString)(borderColor);
    var arrowPos = $195e7ef4c04119f1$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $195e7ef4c04119f1$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $2N6Uo.indexOf)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $195e7ef4c04119f1$var$assembleTransition(duration, onlyFadeTransition, enableDisplayTransition) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = '';
    var transitionText = '';
    if (enableDisplayTransition) {
        transitionOption = " " + duration / 2 + "s " + transitionCurve;
        transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    }
    if (!onlyFadeTransition) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (transitionText.length ? ',' : '') + ((0, $cirKE.default).transformSupported ? "" + $195e7ef4c04119f1$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption);
    }
    return $195e7ef4c04119f1$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $195e7ef4c04119f1$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px';
    // not support transform, use `left` and `top` instead.
    if (!(0, $cirKE.default).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
    // support transform
    var is3d = (0, $cirKE.default).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $195e7ef4c04119f1$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $9rLJf.TRANSFORM_VENDOR),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $195e7ef4c04119f1$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    // @ts-ignore, leave it to the tooltip refactor.
    var lineHeight = (0, $2N6Uo.retrieve2)(textStyleModel.get('lineHeight'), Math.round(fontSize * 3 / 2));
    fontSize && cssText.push('line-height:' + lineHeight + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $2N6Uo.each)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $195e7ef4c04119f1$var$assembleCssText(tooltipModel, enableTransition, onlyFadeTransition, enableDisplayTransition) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $5KdhI.getPaddingFromTooltipModel)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow);
    // Animation transition. Do not animate when transitionDuration <= 0.
    enableTransition && transitionDuration > 0 && cssText.push($195e7ef4c04119f1$var$assembleTransition(transitionDuration, onlyFadeTransition, enableDisplayTransition));
    if (backgroundColor) cssText.push('background-color:' + backgroundColor);
    // Border style
    (0, $2N6Uo.each)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $hrphB.toCamelCase)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    });
    // Text style
    cssText.push($195e7ef4c04119f1$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push('padding:' + (0, $hrphB.normalizeCssArray)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
}
// If not able to make, do not modify the input `out`.
function $195e7ef4c04119f1$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $dhQnW.transformLocalCoord)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $195e7ef4c04119f1$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $cirKE.default).wxa) return null;
        var el = document.createElement('div');
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $2N6Uo.isString)(appendTo) ? document.querySelector(appendTo) : (0, $2N6Uo.isDom)(appendTo) ? appendTo : (0, $2N6Uo.isFunction)(appendTo) && appendTo(api.getDom()));
        $195e7ef4c04119f1$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $pGNPI.normalizeEvent)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $9rLJf.getComputedStyle)(container, 'position');
            var domStyle = container.style;
            if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        this._enableDisplayTransition = tooltipModel.get('displayTransition') && tooltipModel.get('transitionDuration') > 0;
        // update className
        this.el.className = tooltipModel.get('className') || '';
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $195e7ef4c04119f1$var$gCssText + $195e7ef4c04119f1$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide, this._enableDisplayTransition) + $195e7ef4c04119f1$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $hrphB.convertToColorString)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $2N6Uo.isString)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $9rLJf.shouldTooltipConfine)(tooltipModel)) arrow = $195e7ef4c04119f1$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $2N6Uo.isString)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $2N6Uo.isArray)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $2N6Uo.isDom)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return el ? [
            el.offsetWidth,
            el.offsetHeight
        ] : [
            0,
            0
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        if (!this.el) return;
        var styleCoord = this._styleCoord;
        $195e7ef4c04119f1$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $195e7ef4c04119f1$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $2N6Uo.each)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        if (this._enableDisplayTransition) {
            style.visibility = 'hidden';
            style.opacity = '0';
        } else style.display = 'none';
        (0, $cirKE.default).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $2N6Uo.bind)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var zr = this._zr;
        (0, $dhQnW.transformLocalCoordClear)(zr && zr.painter && zr.painter.getViewportRoot(), this._container);
        var el = this.el;
        if (el) {
            el.onmouseenter = el.onmousemove = el.onmouseleave = null;
            var parentNode = el.parentNode;
            parentNode && parentNode.removeChild(el);
        }
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $195e7ef4c04119f1$export$2e2bcd8739ae039 = $195e7ef4c04119f1$var$TooltipHTMLContent;

});
parcelRegister("9rLJf", function(module, exports) {

$parcel$export(module.exports, "shouldTooltipConfine", function () { return $6e0ba8a02cae5b8d$export$a309528050824ba4; });
$parcel$export(module.exports, "TRANSFORM_VENDOR", function () { return $6e0ba8a02cae5b8d$export$7b4286b1e4a23439; });
$parcel$export(module.exports, "TRANSITION_VENDOR", function () { return $6e0ba8a02cae5b8d$export$70a631ae991b5e76; });
$parcel$export(module.exports, "toCSSVendorPrefix", function () { return $6e0ba8a02cae5b8d$export$5886acafe29a08d1; });
$parcel$export(module.exports, "getComputedStyle", function () { return $6e0ba8a02cae5b8d$export$3735103072e4a80; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hrphB = parcelRequire("hrphB");

var $cirKE = parcelRequire("cirKE");
function $6e0ba8a02cae5b8d$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption : tooltipModel.get('renderMode') === 'richText';
}
function $6e0ba8a02cae5b8d$var$testStyle(styleProps) {
    if (!(0, $cirKE.default).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $6e0ba8a02cae5b8d$export$7b4286b1e4a23439 = $6e0ba8a02cae5b8d$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $6e0ba8a02cae5b8d$export$70a631ae991b5e76 = $6e0ba8a02cae5b8d$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $6e0ba8a02cae5b8d$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $hrphB.toCamelCase)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $6e0ba8a02cae5b8d$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}

});


parcelRegister("hmcvQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca2e327f3d2df221$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $kBKw3 = parcelRequire("kBKw3");

var $5KdhI = parcelRequire("5KdhI");

var $byzwF = parcelRequire("byzwF");
var $ca2e327f3d2df221$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $ca2e327f3d2df221$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($2N6Uo.isObject(content)) (0, $byzwF.throwError)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $kBKw3.default)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get('textShadowColor'),
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $5KdhI.getPaddingFromTooltipModel)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        $2N6Uo.each([
            'backgroundColor',
            'borderRadius',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $2N6Uo.each([
            'textShadowBlur',
            'textShadowOffsetX',
            'textShadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $ca2e327f3d2df221$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $ca2e327f3d2df221$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $ca2e327f3d2df221$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $ca2e327f3d2df221$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($2N6Uo.bind(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $ca2e327f3d2df221$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $ca2e327f3d2df221$var$calcShadowOuterSize(style) {
    var shadowBlur = $ca2e327f3d2df221$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $ca2e327f3d2df221$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $ca2e327f3d2df221$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $ca2e327f3d2df221$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $ca2e327f3d2df221$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $ca2e327f3d2df221$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $ca2e327f3d2df221$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $ca2e327f3d2df221$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $ca2e327f3d2df221$export$2e2bcd8739ae039 = $ca2e327f3d2df221$var$TooltipRichContent;

});



parcelRegister("kMkRM", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $f20879fe066d76a6$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8YGQZ = parcelRequire("8YGQZ");

var $gbOiO = parcelRequire("gbOiO");
function $f20879fe066d76a6$export$4b3e715f166fdd78(registers) {
    registers.registerTransform((0, $8YGQZ.filterTransform));
    registers.registerTransform((0, $gbOiO.sortTransform));
}

});
parcelRegister("8YGQZ", function(module, exports) {

$parcel$export(module.exports, "filterTransform", function () { return $68952b2d1011a2f0$export$dc15474d94cdc2b3; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b8B7h = parcelRequire("b8B7h");

var $2N6Uo = parcelRequire("2N6Uo");

var $byzwF = parcelRequire("byzwF");
var $68952b2d1011a2f0$export$dc15474d94cdc2b3 = {
    type: 'echarts:filter',
    // PENDING: enhance to filter by index rather than create new data
    transform: function(params) {
        // [Caveat] Fail-Fast:
        // Do not return the whole dataset unless user config indicates it explicitly.
        // For example, if no condition is specified by mistake, returning an empty result
        // is better than returning the entire raw source for the user to find the mistake.
        var upstream = params.upstream;
        var rawItem;
        var condition = (0, $b8B7h.parseConditionalExpression)(params.config, {
            valueGetterAttrMap: (0, $2N6Uo.createHashMap)({
                dimension: true
            }),
            prepareGetValue: function(exprOption) {
                var errMsg = '';
                var dimLoose = exprOption.dimension;
                if (!(0, $2N6Uo.hasOwn)(exprOption, 'dimension')) (0, $byzwF.throwError)(errMsg);
                var dimInfo = upstream.getDimensionInfo(dimLoose);
                if (!dimInfo) (0, $byzwF.throwError)(errMsg);
                return {
                    dimIdx: dimInfo.index
                };
            },
            getValue: function(param) {
                return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
            }
        });
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++){
            rawItem = upstream.getRawDataItem(i);
            if (condition.evaluate()) resultData.push(rawItem);
        }
        return {
            data: resultData
        };
    }
};

});
parcelRegister("b8B7h", function(module, exports) {

$parcel$export(module.exports, "parseConditionalExpression", function () { return $81bd3ba0d1d2c04e$export$cd61647d82cec762; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $byzwF = parcelRequire("byzwF");

var $irvLa = parcelRequire("irvLa");
var $81bd3ba0d1d2c04e$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
    value: 'eq',
    // PENDING: not good for literal semantic?
    '<': 'lt',
    '<=': 'lte',
    '>': 'gt',
    '>=': 'gte',
    '=': 'eq',
    '!=': 'ne',
    '<>': 'ne'
};
// type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;
var $81bd3ba0d1d2c04e$var$RegExpEvaluator = /** @class */ function() {
    function RegExpEvaluator(rVal) {
        // Support condVal: RegExp | string
        var condValue = this._condVal = (0, $2N6Uo.isString)(rVal) ? new RegExp(rVal) : (0, $2N6Uo.isRegExp)(rVal) ? rVal : null;
        if (condValue == null) {
            var errMsg = '';
            (0, $byzwF.throwError)(errMsg);
        }
    }
    RegExpEvaluator.prototype.evaluate = function(lVal) {
        var type = typeof lVal;
        return (0, $2N6Uo.isString)(type) ? this._condVal.test(lVal) : (0, $2N6Uo.isNumber)(type) ? this._condVal.test(lVal + '') : false;
    };
    return RegExpEvaluator;
}();
var $81bd3ba0d1d2c04e$var$ConstConditionInternal = /** @class */ function() {
    function ConstConditionInternal() {}
    ConstConditionInternal.prototype.evaluate = function() {
        return this.value;
    };
    return ConstConditionInternal;
}();
var $81bd3ba0d1d2c04e$var$AndConditionInternal = /** @class */ function() {
    function AndConditionInternal() {}
    AndConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (!children[i].evaluate()) return false;
        }
        return true;
    };
    return AndConditionInternal;
}();
var $81bd3ba0d1d2c04e$var$OrConditionInternal = /** @class */ function() {
    function OrConditionInternal() {}
    OrConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (children[i].evaluate()) return true;
        }
        return false;
    };
    return OrConditionInternal;
}();
var $81bd3ba0d1d2c04e$var$NotConditionInternal = /** @class */ function() {
    function NotConditionInternal() {}
    NotConditionInternal.prototype.evaluate = function() {
        return !this.child.evaluate();
    };
    return NotConditionInternal;
}();
var $81bd3ba0d1d2c04e$var$RelationalConditionInternal = /** @class */ function() {
    function RelationalConditionInternal() {}
    RelationalConditionInternal.prototype.evaluate = function() {
        var needParse = !!this.valueParser;
        // Call getValue with no `this`.
        var getValue = this.getValue;
        var tarValRaw = getValue(this.valueGetterParam);
        var tarValParsed = needParse ? this.valueParser(tarValRaw) : null;
        // Relational cond follow "and" logic internally.
        for(var i = 0; i < this.subCondList.length; i++){
            if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) return false;
        }
        return true;
    };
    return RelationalConditionInternal;
}();
function $81bd3ba0d1d2c04e$var$parseOption(exprOption, getters) {
    if (exprOption === true || exprOption === false) {
        var cond = new $81bd3ba0d1d2c04e$var$ConstConditionInternal();
        cond.value = exprOption;
        return cond;
    }
    var errMsg = '';
    if (!$81bd3ba0d1d2c04e$var$isObjectNotArray(exprOption)) (0, $byzwF.throwError)(errMsg);
    if (exprOption.and) return $81bd3ba0d1d2c04e$var$parseAndOrOption('and', exprOption, getters);
    else if (exprOption.or) return $81bd3ba0d1d2c04e$var$parseAndOrOption('or', exprOption, getters);
    else if (exprOption.not) return $81bd3ba0d1d2c04e$var$parseNotOption(exprOption, getters);
    return $81bd3ba0d1d2c04e$var$parseRelationalOption(exprOption, getters);
}
function $81bd3ba0d1d2c04e$var$parseAndOrOption(op, exprOption, getters) {
    var subOptionArr = exprOption[op];
    var errMsg = '';
    if (!(0, $2N6Uo.isArray)(subOptionArr)) (0, $byzwF.throwError)(errMsg);
    if (!subOptionArr.length) (0, $byzwF.throwError)(errMsg);
    var cond = op === 'and' ? new $81bd3ba0d1d2c04e$var$AndConditionInternal() : new $81bd3ba0d1d2c04e$var$OrConditionInternal();
    cond.children = (0, $2N6Uo.map)(subOptionArr, function(subOption) {
        return $81bd3ba0d1d2c04e$var$parseOption(subOption, getters);
    });
    if (!cond.children.length) (0, $byzwF.throwError)(errMsg);
    return cond;
}
function $81bd3ba0d1d2c04e$var$parseNotOption(exprOption, getters) {
    var subOption = exprOption.not;
    var errMsg = '';
    if (!$81bd3ba0d1d2c04e$var$isObjectNotArray(subOption)) (0, $byzwF.throwError)(errMsg);
    var cond = new $81bd3ba0d1d2c04e$var$NotConditionInternal();
    cond.child = $81bd3ba0d1d2c04e$var$parseOption(subOption, getters);
    if (!cond.child) (0, $byzwF.throwError)(errMsg);
    return cond;
}
function $81bd3ba0d1d2c04e$var$parseRelationalOption(exprOption, getters) {
    var errMsg = '';
    var valueGetterParam = getters.prepareGetValue(exprOption);
    var subCondList = [];
    var exprKeys = (0, $2N6Uo.keys)(exprOption);
    var parserName = exprOption.parser;
    var valueParser = parserName ? (0, $irvLa.getRawValueParser)(parserName) : null;
    for(var i = 0; i < exprKeys.length; i++){
        var keyRaw = exprKeys[i];
        if (keyRaw === 'parser' || getters.valueGetterAttrMap.get(keyRaw)) continue;
        var op = (0, $2N6Uo.hasOwn)($81bd3ba0d1d2c04e$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? $81bd3ba0d1d2c04e$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
        var condValueRaw = exprOption[keyRaw];
        var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
        var evaluator = (0, $irvLa.createFilterComparator)(op, condValueParsed) || op === 'reg' && new $81bd3ba0d1d2c04e$var$RegExpEvaluator(condValueParsed);
        if (!evaluator) (0, $byzwF.throwError)(errMsg);
        subCondList.push(evaluator);
    }
    if (!subCondList.length) // No relational operator always disabled in case of dangers result.
    (0, $byzwF.throwError)(errMsg);
    var cond = new $81bd3ba0d1d2c04e$var$RelationalConditionInternal();
    cond.valueGetterParam = valueGetterParam;
    cond.valueParser = valueParser;
    cond.getValue = getters.getValue;
    cond.subCondList = subCondList;
    return cond;
}
function $81bd3ba0d1d2c04e$var$isObjectNotArray(val) {
    return (0, $2N6Uo.isObject)(val) && !(0, $2N6Uo.isArrayLike)(val);
}
var $81bd3ba0d1d2c04e$var$ConditionalExpressionParsed = /** @class */ function() {
    function ConditionalExpressionParsed(exprOption, getters) {
        this._cond = $81bd3ba0d1d2c04e$var$parseOption(exprOption, getters);
    }
    ConditionalExpressionParsed.prototype.evaluate = function() {
        return this._cond.evaluate();
    };
    return ConditionalExpressionParsed;
}();
function $81bd3ba0d1d2c04e$export$cd61647d82cec762(exprOption, getters) {
    return new $81bd3ba0d1d2c04e$var$ConditionalExpressionParsed(exprOption, getters);
}

});


parcelRegister("gbOiO", function(module, exports) {

$parcel$export(module.exports, "sortTransform", function () { return $bc94b16b116db75a$export$505f1bb66427eaee; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eKQ6A = parcelRequire("eKQ6A");

var $byzwF = parcelRequire("byzwF");

var $2N6Uo = parcelRequire("2N6Uo");

var $bx3T8 = parcelRequire("bx3T8");

var $irvLa = parcelRequire("irvLa");
var $bc94b16b116db75a$var$sampleLog = '';
var $bc94b16b116db75a$export$505f1bb66427eaee = {
    type: 'echarts:sort',
    transform: function(params) {
        var upstream = params.upstream;
        var config = params.config;
        var errMsg = '';
        // Normalize
        // const orderExprList: OrderExpression[] = isArray(config[0])
        //     ? config as OrderExpression[]
        //     : [config as OrderExpression];
        var orderExprList = (0, $bx3T8.normalizeToArray)(config);
        if (!orderExprList.length) (0, $byzwF.throwError)(errMsg);
        var orderDefList = [];
        (0, $2N6Uo.each)(orderExprList, function(orderExpr) {
            var dimLoose = orderExpr.dimension;
            var order = orderExpr.order;
            var parserName = orderExpr.parser;
            var incomparable = orderExpr.incomparable;
            if (dimLoose == null) (0, $byzwF.throwError)(errMsg);
            if (order !== 'asc' && order !== 'desc') (0, $byzwF.throwError)(errMsg);
            if (incomparable && incomparable !== 'min' && incomparable !== 'max') {
                var errMsg_1 = '';
                (0, $byzwF.throwError)(errMsg_1);
            }
            if (order !== 'asc' && order !== 'desc') {
                var errMsg_2 = '';
                (0, $byzwF.throwError)(errMsg_2);
            }
            var dimInfo = upstream.getDimensionInfo(dimLoose);
            if (!dimInfo) (0, $byzwF.throwError)(errMsg);
            var parser = parserName ? (0, $irvLa.getRawValueParser)(parserName) : null;
            if (parserName && !parser) (0, $byzwF.throwError)(errMsg);
            orderDefList.push({
                dimIdx: dimInfo.index,
                parser: parser,
                comparator: new (0, $irvLa.SortOrderComparator)(order, incomparable)
            });
        });
        // TODO: support it?
        var sourceFormat = upstream.sourceFormat;
        if (sourceFormat !== (0, $eKQ6A.SOURCE_FORMAT_ARRAY_ROWS) && sourceFormat !== (0, $eKQ6A.SOURCE_FORMAT_OBJECT_ROWS)) (0, $byzwF.throwError)(errMsg);
        // Other upstream format are all array.
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++)resultData.push(upstream.getRawDataItem(i));
        resultData.sort(function(item0, item1) {
            for(var i = 0; i < orderDefList.length; i++){
                var orderDef = orderDefList[i];
                var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
                var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);
                if (orderDef.parser) {
                    val0 = orderDef.parser(val0);
                    val1 = orderDef.parser(val1);
                }
                var result = orderDef.comparator.evaluate(val0, val1);
                if (result !== 0) return result;
            }
            return 0;
        });
        return {
            data: resultData
        };
    }
};

});


parcelRegister("7Ink0", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $59debba3c0caf98e$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gX19P = parcelRequire("gX19P");

var $1tYID = parcelRequire("1tYID");

var $hpw8u = parcelRequire("hpw8u");
function $59debba3c0caf98e$export$4b3e715f166fdd78(registers) {
    (0, $gX19P.use)((0, $1tYID.install));
    (0, $gX19P.use)((0, $hpw8u.install));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

});
parcelRegister("1tYID", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $1147996a673cdf0a$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eU7ff = parcelRequire("eU7ff");

var $56oXA = parcelRequire("56oXA");

var $545jm = parcelRequire("545jm");
function $1147996a673cdf0a$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $eU7ff.default));
    registers.registerComponentView((0, $56oXA.default));
    (0, $545jm.default)(registers);
}

});
parcelRegister("eU7ff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad9bea589db0b603$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $8KWGf = parcelRequire("8KWGf");

var $iCU10 = parcelRequire("iCU10");

var $cKPmR = parcelRequire("cKPmR");

var $6aXXD = parcelRequire("6aXXD");
// Constant
var $ad9bea589db0b603$var$DEFAULT_BAR_BOUND = [
    20,
    140
];
var $ad9bea589db0b603$var$ContinuousModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ContinuousModel, _super);
    function ContinuousModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousModel.type;
        return _this;
    }
    /**
   * @override
   */ ContinuousModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        this.resetVisual(function(mappingOption) {
            mappingOption.mappingMethod = 'linear';
            mappingOption.dataExtent = this.getExtent();
        });
        this._resetRange();
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.resetItemSize = function() {
        _super.prototype.resetItemSize.apply(this, arguments);
        var itemSize = this.itemSize;
        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = $ad9bea589db0b603$var$DEFAULT_BAR_BOUND[0]);
        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = $ad9bea589db0b603$var$DEFAULT_BAR_BOUND[1]);
    };
    /**
   * @private
   */ ContinuousModel.prototype._resetRange = function() {
        var dataExtent = this.getExtent();
        var range = this.option.range;
        if (!range || range.auto) {
            // `range` should always be array (so we don't use other
            // value like 'auto') for user-friend. (consider getOption).
            dataExtent.auto = 1;
            this.option.range = dataExtent;
        } else if ($2N6Uo.isArray(range)) {
            if (range[0] > range[1]) range.reverse();
            range[0] = Math.max(range[0], dataExtent[0]);
            range[1] = Math.min(range[1], dataExtent[1]);
        }
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.completeVisualOption = function() {
        _super.prototype.completeVisualOption.apply(this, arguments);
        $2N6Uo.each(this.stateList, function(state) {
            var symbolSize = this.option.controller[state].symbolSize;
            if (symbolSize && symbolSize[0] !== symbolSize[1]) symbolSize[0] = symbolSize[1] / 3; // For good looking.
        }, this);
    };
    /**
   * @override
   */ ContinuousModel.prototype.setSelected = function(selected) {
        this.option.range = selected.slice();
        this._resetRange();
    };
    /**
   * @public
   */ ContinuousModel.prototype.getSelected = function() {
        var dataExtent = this.getExtent();
        var dataInterval = $iCU10.asc((this.get('range') || []).slice());
        // Clamp
        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
        return dataInterval;
    };
    /**
   * @override
   */ ContinuousModel.prototype.getValueState = function(value) {
        var range = this.option.range;
        var dataExtent = this.getExtent();
        var unboundedRange = $2N6Uo.retrieve2(this.option.unboundedRange, true);
        return (unboundedRange && range[0] <= dataExtent[0] || range[0] <= value) && (unboundedRange && range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
    };
    ContinuousModel.prototype.findTargetDataIndices = function(range) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @implement
   */ ContinuousModel.prototype.getVisualMeta = function(getColorVisual) {
        var oVals = $ad9bea589db0b603$var$getColorStopValues(this, 'outOfRange', this.getExtent());
        var iVals = $ad9bea589db0b603$var$getColorStopValues(this, 'inRange', this.option.range.slice());
        var stops = [];
        function setStop(value, valueState) {
            stops.push({
                value: value,
                color: getColorVisual(value, valueState)
            });
        }
        // Format to: outOfRange -- inRange -- outOfRange.
        var iIdx = 0;
        var oIdx = 0;
        var iLen = iVals.length;
        var oLen = oVals.length;
        for(; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++)// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
        if (oVals[oIdx] < iVals[iIdx]) setStop(oVals[oIdx], 'outOfRange');
        for(var first = 1; iIdx < iLen; iIdx++, first = 0){
            // If range is full, value beyond min, max will be clamped.
            // make a singularity
            first && stops.length && setStop(iVals[iIdx], 'outOfRange');
            setStop(iVals[iIdx], 'inRange');
        }
        for(var first = 1; oIdx < oLen; oIdx++)if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
            // make a singularity
            if (first) {
                stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
                first = 0;
            }
            setStop(oVals[oIdx], 'outOfRange');
        }
        var stopsLen = stops.length;
        return {
            stops: stops,
            outerColors: [
                stopsLen ? stops[0].color : 'transparent',
                stopsLen ? stops[stopsLen - 1].color : 'transparent'
            ]
        };
    };
    ContinuousModel.type = 'visualMap.continuous';
    ContinuousModel.defaultOption = (0, $cKPmR.inheritDefaultOption)((0, $8KWGf.default).defaultOption, {
        align: 'auto',
        calculable: false,
        hoverLink: true,
        realtime: true,
        handleIcon: 'path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z',
        handleSize: '120%',
        handleStyle: {
            borderColor: (0, $6aXXD.default).color.neutral00,
            borderWidth: 1
        },
        indicatorIcon: 'circle',
        indicatorSize: '50%',
        indicatorStyle: {
            borderColor: (0, $6aXXD.default).color.neutral00,
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: (0, $6aXXD.default).color.shadow
        }
    });
    return ContinuousModel;
}((0, $8KWGf.default));
function $ad9bea589db0b603$var$getColorStopValues(visualMapModel, valueState, dataExtent) {
    if (dataExtent[0] === dataExtent[1]) return dataExtent.slice();
    // When using colorHue mapping, it is not linear color any more.
    // Moreover, canvas gradient seems not to be accurate linear.
    // FIXME
    // Should be arbitrary value 100? or based on pixel size?
    var count = 200;
    var step = (dataExtent[1] - dataExtent[0]) / count;
    var value = dataExtent[0];
    var stopValues = [];
    for(var i = 0; i <= count && value < dataExtent[1]; i++){
        stopValues.push(value);
        value += step;
    }
    stopValues.push(dataExtent[1]);
    return stopValues;
}
var $ad9bea589db0b603$export$2e2bcd8739ae039 = $ad9bea589db0b603$var$ContinuousModel;

});
parcelRegister("8KWGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6600234aebe3d7a9$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $1Ia3f = parcelRequire("1Ia3f");

var $dzLre = parcelRequire("dzLre");

var $1UvsP = parcelRequire("1UvsP");

var $bx3T8 = parcelRequire("bx3T8");

var $iCU10 = parcelRequire("iCU10");

var $eLD2b = parcelRequire("eLD2b");

var $6aXXD = parcelRequire("6aXXD");
var $6600234aebe3d7a9$var$mapVisual = (0, $dzLre.default).mapVisual;
var $6600234aebe3d7a9$var$eachVisual = (0, $dzLre.default).eachVisual;
var $6600234aebe3d7a9$var$isArray = $2N6Uo.isArray;
var $6600234aebe3d7a9$var$each = $2N6Uo.each;
var $6600234aebe3d7a9$var$asc = $iCU10.asc;
var $6600234aebe3d7a9$var$linearMap = $iCU10.linearMap;
var $6600234aebe3d7a9$var$VisualMapModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(VisualMapModel, _super);
    function VisualMapModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapModel.type;
        _this.stateList = [
            'inRange',
            'outOfRange'
        ];
        _this.replacableOptionKeys = [
            'inRange',
            'outOfRange',
            'target',
            'controller',
            'color'
        ];
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        /**
     * [lowerBound, upperBound]
     */ _this.dataBound = [
            -Infinity,
            Infinity
        ];
        _this.targetVisuals = {};
        _this.controllerVisuals = {};
        return _this;
    }
    VisualMapModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    /**
   * @protected
   */ VisualMapModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $1UvsP.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
        this.textStyleModel = this.getModel('textStyle');
        this.resetItemSize();
        this.completeVisualOption();
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetVisual = function(supplementVisualOption) {
        var stateList = this.stateList;
        supplementVisualOption = $2N6Uo.bind(supplementVisualOption, this);
        this.controllerVisuals = $1UvsP.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
        this.targetVisuals = $1UvsP.createVisualMappings(this.option.target, stateList, supplementVisualOption);
    };
    /**
   * @public
   */ VisualMapModel.prototype.getItemSymbol = function() {
        return null;
    };
    /**
   * @return An array of series indices.
   */ VisualMapModel.prototype.getTargetSeriesIndices = function() {
        var optionSeriesId = this.option.seriesId;
        var optionSeriesIndex = this.option.seriesIndex;
        if (optionSeriesIndex == null && optionSeriesId == null) optionSeriesIndex = 'all';
        var seriesModels = $bx3T8.queryReferringComponents(this.ecModel, 'series', {
            index: optionSeriesIndex,
            id: optionSeriesId
        }, {
            useDefault: false,
            enableAll: true,
            enableNone: false
        }).models;
        return $2N6Uo.map(seriesModels, function(seriesModel) {
            return seriesModel.componentIndex;
        });
    };
    /**
   * @public
   */ VisualMapModel.prototype.eachTargetSeries = function(callback, context) {
        $2N6Uo.each(this.getTargetSeriesIndices(), function(seriesIndex) {
            var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);
            if (seriesModel) callback.call(context, seriesModel);
        }, this);
    };
    /**
   * @pubilc
   */ VisualMapModel.prototype.isTargetSeries = function(seriesModel) {
        var is = false;
        this.eachTargetSeries(function(model) {
            model === seriesModel && (is = true);
        });
        return is;
    };
    /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */ VisualMapModel.prototype.formatValueText = function(value, isCategory, edgeSymbols) {
        var option = this.option;
        var precision = option.precision;
        var dataBound = this.dataBound;
        var formatter = option.formatter;
        var isMinMax;
        edgeSymbols = edgeSymbols || [
            '<',
            '>'
        ];
        if ($2N6Uo.isArray(value)) {
            value = value.slice();
            isMinMax = true;
        }
        var textValue = isCategory ? value // Value is string when isCategory
         : isMinMax ? [
            toFixed(value[0]),
            toFixed(value[1])
        ] : toFixed(value);
        if ($2N6Uo.isString(formatter)) return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
        else if ($2N6Uo.isFunction(formatter)) return isMinMax ? formatter(value[0], value[1]) : formatter(value);
        if (isMinMax) {
            if (value[0] === dataBound[0]) return edgeSymbols[0] + ' ' + textValue[1];
            else if (value[1] === dataBound[1]) return edgeSymbols[1] + ' ' + textValue[0];
            else return textValue[0] + ' - ' + textValue[1];
        } else // Format single value (includes category case).
        return textValue;
        function toFixed(val) {
            return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
        }
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetExtent = function() {
        var thisOption = this.option;
        // Can not calculate data extent by data here.
        // Because series and data may be modified in processing stage.
        // So we do not support the feature "auto min/max".
        var extent = $6600234aebe3d7a9$var$asc([
            thisOption.min,
            thisOption.max
        ]);
        this._dataExtent = extent;
    };
    /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimension. If null/undefined is returned, no dimension is used.
   */ // getDataDimension(data: SeriesData) {
    //     const optDim = this.option.dimension;
    //     if (optDim != null) {
    //         return data.getDimension(optDim);
    //     }
    //     const dimNames = data.dimensions;
    //     for (let i = dimNames.length - 1; i >= 0; i--) {
    //         const dimName = dimNames[i];
    //         const dimInfo = data.getDimensionInfo(dimName);
    //         if (!dimInfo.isCalculationCoord) {
    //             return dimName;
    //         }
    //     }
    // }
    VisualMapModel.prototype.getDataDimensionIndex = function(data) {
        var optDim = this.option.dimension;
        if (optDim != null) return data.getDimensionIndex(optDim);
        var dimNames = data.dimensions;
        for(var i = dimNames.length - 1; i >= 0; i--){
            var dimName = dimNames[i];
            var dimInfo = data.getDimensionInfo(dimName);
            if (!dimInfo.isCalculationCoord) return dimInfo.storeDimIndex;
        }
    };
    VisualMapModel.prototype.getExtent = function() {
        return this._dataExtent.slice();
    };
    VisualMapModel.prototype.completeVisualOption = function() {
        var ecModel = this.ecModel;
        var thisOption = this.option;
        var base = {
            inRange: thisOption.inRange,
            outOfRange: thisOption.outOfRange
        };
        var target = thisOption.target || (thisOption.target = {});
        var controller = thisOption.controller || (thisOption.controller = {});
        $2N6Uo.merge(target, base); // Do not override
        $2N6Uo.merge(controller, base); // Do not override
        var isCategory = this.isCategory();
        completeSingle.call(this, target);
        completeSingle.call(this, controller);
        completeInactive.call(this, target, 'inRange', 'outOfRange');
        // completeInactive.call(this, target, 'outOfRange', 'inRange');
        completeController.call(this, controller);
        function completeSingle(base) {
            // Compatible with ec2 dataRange.color.
            // The mapping order of dataRange.color is: [high value, ..., low value]
            // whereas inRange.color and outOfRange.color is [low value, ..., high value]
            // Notice: ec2 has no inverse.
            if ($6600234aebe3d7a9$var$isArray(thisOption.color) && !base.inRange) base.inRange = {
                color: thisOption.color.slice().reverse()
            };
            // Compatible with previous logic, always give a default color, otherwise
            // simple config with no inRange and outOfRange will not work.
            // Originally we use visualMap.color as the default color, but setOption at
            // the second time the default color will be erased. So we change to use
            // constant DEFAULT_COLOR.
            // If user do not want the default color, set inRange: {color: null}.
            base.inRange = base.inRange || {
                color: ecModel.get('gradientColor')
            };
        }
        function completeInactive(base, stateExist, stateAbsent) {
            var optExist = base[stateExist];
            var optAbsent = base[stateAbsent];
            if (optExist && !optAbsent) {
                optAbsent = base[stateAbsent] = {};
                $6600234aebe3d7a9$var$each(optExist, function(visualData, visualType) {
                    if (!(0, $dzLre.default).isValidType(visualType)) return;
                    var defa = (0, $1Ia3f.default).get(visualType, 'inactive', isCategory);
                    if (defa != null) {
                        optAbsent[visualType] = defa;
                        // Compatibable with ec2:
                        // Only inactive color to rgba(0,0,0,0) can not
                        // make label transparent, so use opacity also.
                        if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) optAbsent.opacity = [
                            0,
                            0
                        ];
                    }
                });
            }
        }
        function completeController(controller) {
            var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
            var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
            var inactiveColor = this.get('inactiveColor');
            var itemSymbol = this.getItemSymbol();
            var defaultSymbol = itemSymbol || 'roundRect';
            $6600234aebe3d7a9$var$each(this.stateList, function(state) {
                var itemSize = this.itemSize;
                var visuals = controller[state];
                // Set inactive color for controller if no other color
                // attr (like colorAlpha) specified.
                if (!visuals) visuals = controller[state] = {
                    color: isCategory ? inactiveColor : [
                        inactiveColor
                    ]
                };
                // Consistent symbol and symbolSize if not specified.
                if (visuals.symbol == null) visuals.symbol = symbolExists && $2N6Uo.clone(symbolExists) || (isCategory ? defaultSymbol : [
                    defaultSymbol
                ]);
                if (visuals.symbolSize == null) visuals.symbolSize = symbolSizeExists && $2N6Uo.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [
                    itemSize[0],
                    itemSize[0]
                ]);
                // Filter none
                visuals.symbol = $6600234aebe3d7a9$var$mapVisual(visuals.symbol, function(symbol) {
                    return symbol === 'none' ? defaultSymbol : symbol;
                });
                // Normalize symbolSize
                var symbolSize = visuals.symbolSize;
                if (symbolSize != null) {
                    var max_1 = -Infinity;
                    // symbolSize can be object when categories defined.
                    $6600234aebe3d7a9$var$eachVisual(symbolSize, function(value) {
                        value > max_1 && (max_1 = value);
                    });
                    visuals.symbolSize = $6600234aebe3d7a9$var$mapVisual(symbolSize, function(value) {
                        return $6600234aebe3d7a9$var$linearMap(value, [
                            0,
                            max_1
                        ], [
                            0,
                            itemSize[0]
                        ], true);
                    });
                }
            }, this);
        }
    };
    VisualMapModel.prototype.resetItemSize = function() {
        this.itemSize = [
            parseFloat(this.get('itemWidth')),
            parseFloat(this.get('itemHeight'))
        ];
    };
    VisualMapModel.prototype.isCategory = function() {
        return !!this.option.categories;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.setSelected = function(selected) {};
    VisualMapModel.prototype.getSelected = function() {
        return null;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.getValueState = function(value) {
        return null;
    };
    /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */ VisualMapModel.prototype.getVisualMeta = function(getColorVisual) {
        return null;
    };
    VisualMapModel.type = 'visualMap';
    VisualMapModel.dependencies = [
        'series'
    ];
    VisualMapModel.defaultOption = {
        show: true,
        // zlevel: 0,
        z: 4,
        // seriesIndex: 'all',
        min: 0,
        max: 200,
        left: 0,
        right: null,
        top: null,
        bottom: 0,
        itemWidth: null,
        itemHeight: null,
        inverse: false,
        orient: 'vertical',
        backgroundColor: (0, $6aXXD.default).color.transparent,
        borderColor: (0, $6aXXD.default).color.borderTint,
        contentColor: (0, $6aXXD.default).color.theme[0],
        inactiveColor: (0, $6aXXD.default).color.disabled,
        borderWidth: 0,
        padding: (0, $6aXXD.default).size.m,
        // 接受数组分别设定上右下左边距，同css
        textGap: 10,
        precision: 0,
        textStyle: {
            color: (0, $6aXXD.default).color.secondary // 值域文字颜色
        }
    };
    return VisualMapModel;
}((0, $eLD2b.default));
var $6600234aebe3d7a9$export$2e2bcd8739ae039 = $6600234aebe3d7a9$var$VisualMapModel;

});
parcelRegister("1Ia3f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13f1b28395eeb464$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual mapping.
 */ 
var $2N6Uo = parcelRequire("2N6Uo");

var $6aXXD = parcelRequire("6aXXD");
var $13f1b28395eeb464$var$visualDefault = {
    /**
   * @public
   */ get: function(visualType, key, isCategory) {
        var value = $2N6Uo.clone(($13f1b28395eeb464$var$defaultOption[visualType] || {})[key]);
        return isCategory ? $2N6Uo.isArray(value) ? value[value.length - 1] : value : value;
    }
};
var $13f1b28395eeb464$var$defaultOption = {
    color: {
        active: [
            '#006edd',
            '#e0ffff'
        ],
        inactive: [
            (0, $6aXXD.default).color.transparent
        ]
    },
    colorHue: {
        active: [
            0,
            360
        ],
        inactive: [
            0,
            0
        ]
    },
    colorSaturation: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    colorLightness: {
        active: [
            0.9,
            0.5
        ],
        inactive: [
            0,
            0
        ]
    },
    colorAlpha: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    opacity: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    symbol: {
        active: [
            'circle',
            'roundRect',
            'diamond'
        ],
        inactive: [
            'none'
        ]
    },
    symbolSize: {
        active: [
            10,
            50
        ],
        inactive: [
            0,
            0
        ]
    }
};
var $13f1b28395eeb464$export$2e2bcd8739ae039 = $13f1b28395eeb464$var$visualDefault;

});



parcelRegister("56oXA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b70dfd40964ab40$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $ftfXE = parcelRequire("ftfXE");

var $pGNPI = parcelRequire("pGNPI");

var $4ANTH = parcelRequire("4ANTH");

var $h9U3p = parcelRequire("h9U3p");
var $hXTRG = parcelRequire("hXTRG");
var $aH2k0 = parcelRequire("aH2k0");
var $iQonF = parcelRequire("iQonF");
var $kBKw3 = parcelRequire("kBKw3");

var $iCU10 = parcelRequire("iCU10");

var $43jQn = parcelRequire("43jQn");

var $5xc3O = parcelRequire("5xc3O");

var $bx3T8 = parcelRequire("bx3T8");

var $eVwLk = parcelRequire("eVwLk");

var $bwPbQ = parcelRequire("bwPbQ");

var $k0QDS = parcelRequire("k0QDS");

var $lQsZt = parcelRequire("lQsZt");

var $6TSUP = parcelRequire("6TSUP");

var $bysmE = parcelRequire("bysmE");

var $cQG2W = parcelRequire("cQG2W");
var $3b70dfd40964ab40$var$linearMap = $iCU10.linearMap;
var $3b70dfd40964ab40$var$each = $2N6Uo.each;
var $3b70dfd40964ab40$var$mathMin = Math.min;
var $3b70dfd40964ab40$var$mathMax = Math.max;
// Arbitrary value
var $3b70dfd40964ab40$var$HOVER_LINK_SIZE = 12;
var $3b70dfd40964ab40$var$HOVER_LINK_OUT = 6;
// Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var $3b70dfd40964ab40$var$ContinuousView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(ContinuousView, _super);
    function ContinuousView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousView.type;
        _this._shapes = {};
        _this._dataInterval = [];
        _this._handleEnds = [];
        _this._hoverLinkDataIndices = [];
        return _this;
    }
    ContinuousView.prototype.init = function(ecModel, api) {
        _super.prototype.init.call(this, ecModel, api);
        this._hoverLinkFromSeriesMouseOver = $2N6Uo.bind(this._hoverLinkFromSeriesMouseOver, this);
        this._hideIndicator = $2N6Uo.bind(this._hideIndicator, this);
    };
    ContinuousView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {
        if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) this._buildView();
    };
    ContinuousView.prototype._buildView = function() {
        this.group.removeAll();
        var visualMapModel = this.visualMapModel;
        var thisGroup = this.group;
        this._orient = visualMapModel.get('orient');
        this._useHandle = visualMapModel.get('calculable');
        this._resetInterval();
        this._renderBar(thisGroup);
        var dataRangeText = visualMapModel.get('text');
        this._renderEndsText(thisGroup, dataRangeText, 0);
        this._renderEndsText(thisGroup, dataRangeText, 1);
        // Do this for background size calculation.
        this._updateView(true);
        // After updating view, inner shapes is built completely,
        // and then background can be rendered.
        this.renderBackground(thisGroup);
        // Real update view
        this._updateView();
        this._enableHoverLinkToSeries();
        this._enableHoverLinkFromSeries();
        this.positionGroup(thisGroup);
    };
    ContinuousView.prototype._renderEndsText = function(group, dataRangeText, endsIndex) {
        if (!dataRangeText) return;
        // Compatible with ec2, text[0] map to high value, text[1] map low value.
        var text = dataRangeText[1 - endsIndex];
        text = text != null ? text + '' : '';
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get('textGap');
        var itemSize = visualMapModel.itemSize;
        var barGroup = this._shapes.mainGroup;
        var position = this._applyTransform([
            itemSize[0] / 2,
            endsIndex === 0 ? -textGap : itemSize[1] + textGap
        ], barGroup);
        var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
        var orient = this._orient;
        var textStyleModel = this.visualMapModel.textStyleModel;
        this.group.add(new $kBKw3.default({
            style: (0, $bysmE.createTextStyle)(textStyleModel, {
                x: position[0],
                y: position[1],
                verticalAlign: textStyleModel.get('verticalAlign') || (orient === 'horizontal' ? 'middle' : align),
                align: textStyleModel.get('align') || (orient === 'horizontal' ? align : 'center'),
                text: text
            })
        }));
    };
    ContinuousView.prototype._renderBar = function(targetGroup) {
        var visualMapModel = this.visualMapModel;
        var shapes = this._shapes;
        var itemSize = visualMapModel.itemSize;
        var orient = this._orient;
        var useHandle = this._useHandle;
        var itemAlign = $5xc3O.getItemAlign(visualMapModel, this.api, itemSize);
        var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);
        var gradientBarGroup = new $iQonF.default();
        mainGroup.add(gradientBarGroup);
        // Bar
        gradientBarGroup.add(shapes.outOfRange = $3b70dfd40964ab40$var$createPolygon());
        gradientBarGroup.add(shapes.inRange = $3b70dfd40964ab40$var$createPolygon(null, useHandle ? $3b70dfd40964ab40$var$getCursor(this._orient) : null, $2N6Uo.bind(this._dragHandle, this, 'all', false), $2N6Uo.bind(this._dragHandle, this, 'all', true)));
        // A border radius clip.
        gradientBarGroup.setClipPath(new $aH2k0.default({
            shape: {
                x: 0,
                y: 0,
                width: itemSize[0],
                height: itemSize[1],
                r: 3
            }
        }));
        var textRect = visualMapModel.textStyleModel.getTextRect("\u56FD");
        var textSize = $3b70dfd40964ab40$var$mathMax(textRect.width, textRect.height);
        // Handle
        if (useHandle) {
            shapes.handleThumbs = [];
            shapes.handleLabels = [];
            shapes.handleLabelPoints = [];
            this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);
            this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
        }
        this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);
        targetGroup.add(mainGroup);
    };
    ContinuousView.prototype._createHandle = function(visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
        var onDrift = $2N6Uo.bind(this._dragHandle, this, handleIndex, false);
        var onDragEnd = $2N6Uo.bind(this._dragHandle, this, handleIndex, true);
        var handleSize = (0, $eVwLk.parsePercent)(visualMapModel.get('handleSize'), itemSize[0]);
        var handleThumb = (0, $k0QDS.createSymbol)(visualMapModel.get('handleIcon'), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
        var cursor = $3b70dfd40964ab40$var$getCursor(this._orient);
        handleThumb.attr({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            ondragend: onDragEnd,
            onmousemove: function(e) {
                $pGNPI.stop(e.event);
            }
        });
        handleThumb.x = itemSize[0] / 2;
        handleThumb.useStyle(visualMapModel.getModel('handleStyle').getItemStyle());
        handleThumb.setStyle({
            strokeNoScale: true,
            strokeFirst: true
        });
        handleThumb.style.lineWidth *= 2;
        handleThumb.ensureState('emphasis').style = visualMapModel.getModel([
            'emphasis',
            'handleStyle'
        ]).getItemStyle();
        (0, $bwPbQ.setAsHighDownDispatcher)(handleThumb, true);
        mainGroup.add(handleThumb);
        // Text is always horizontal layout but should not be effected by
        // transform (orient/inverse). So label is built separately but not
        // use zrender/graphic/helper/RectText, and is located based on view
        // group (according to handleLabelPoint) but not barGroup.
        var textStyleModel = this.visualMapModel.textStyleModel;
        var handleLabel = new $kBKw3.default({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            onmousemove: function(e) {
                // For mobile device, prevent screen slider on the button.
                $pGNPI.stop(e.event);
            },
            ondragend: onDragEnd,
            style: (0, $bysmE.createTextStyle)(textStyleModel, {
                x: 0,
                y: 0,
                text: ''
            })
        });
        handleLabel.ensureState('blur').style = {
            opacity: 0.1
        };
        handleLabel.stateTransition = {
            duration: 200
        };
        this.group.add(handleLabel);
        var handleLabelPoint = [
            handleSize,
            0
        ];
        var shapes = this._shapes;
        shapes.handleThumbs[handleIndex] = handleThumb;
        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
        shapes.handleLabels[handleIndex] = handleLabel;
    };
    ContinuousView.prototype._createIndicator = function(visualMapModel, mainGroup, itemSize, textSize, orient) {
        var scale = (0, $eVwLk.parsePercent)(visualMapModel.get('indicatorSize'), itemSize[0]);
        var indicator = (0, $k0QDS.createSymbol)(visualMapModel.get('indicatorIcon'), -scale / 2, -scale / 2, scale, scale, null, true);
        indicator.attr({
            cursor: 'move',
            invisible: true,
            silent: true,
            x: itemSize[0] / 2
        });
        var indicatorStyle = visualMapModel.getModel('indicatorStyle').getItemStyle();
        if (indicator instanceof (0, $lQsZt.default)) {
            var pathStyle = indicator.style;
            indicator.useStyle($2N6Uo.extend({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, indicatorStyle));
        } else indicator.useStyle(indicatorStyle);
        mainGroup.add(indicator);
        var textStyleModel = this.visualMapModel.textStyleModel;
        var indicatorLabel = new $kBKw3.default({
            silent: true,
            invisible: true,
            style: (0, $bysmE.createTextStyle)(textStyleModel, {
                x: 0,
                y: 0,
                text: ''
            })
        });
        this.group.add(indicatorLabel);
        var indicatorLabelPoint = [
            (orient === 'horizontal' ? textSize / 2 : $3b70dfd40964ab40$var$HOVER_LINK_OUT) + itemSize[0] / 2,
            0
        ];
        var shapes = this._shapes;
        shapes.indicator = indicator;
        shapes.indicatorLabel = indicatorLabel;
        shapes.indicatorLabelPoint = indicatorLabelPoint;
        this._firstShowIndicator = true;
    };
    ContinuousView.prototype._dragHandle = function(handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
    dx, dy) {
        if (!this._useHandle) return;
        this._dragging = !isEnd;
        if (!isEnd) {
            // Transform dx, dy to bar coordination.
            var vertex = this._applyTransform([
                dx,
                dy
            ], this._shapes.mainGroup, true);
            this._updateInterval(handleIndex, vertex[1]);
            this._hideIndicator();
            // Considering realtime, update view should be executed
            // before dispatch action.
            this._updateView();
        }
        // dragEnd do not dispatch action when realtime.
        if (isEnd === !this.visualMapModel.get('realtime')) // jshint ignore:line
        this.api.dispatchAction({
            type: 'selectDataRange',
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
        });
        if (isEnd) !this._hovering && this._clearHoverLinkToSeries();
        else if ($3b70dfd40964ab40$var$useHoverLinkOnHandle(this.visualMapModel)) this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    };
    ContinuousView.prototype._resetInterval = function() {
        var visualMapModel = this.visualMapModel;
        var dataInterval = this._dataInterval = visualMapModel.getSelected();
        var dataExtent = visualMapModel.getExtent();
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        this._handleEnds = [
            $3b70dfd40964ab40$var$linearMap(dataInterval[0], dataExtent, sizeExtent, true),
            $3b70dfd40964ab40$var$linearMap(dataInterval[1], dataExtent, sizeExtent, true)
        ];
    };
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */ ContinuousView.prototype._updateInterval = function(handleIndex, delta) {
        delta = delta || 0;
        var visualMapModel = this.visualMapModel;
        var handleEnds = this._handleEnds;
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        (0, $43jQn.default)(delta, handleEnds, sizeExtent, handleIndex, // cross is forbidden
        0);
        var dataExtent = visualMapModel.getExtent();
        // Update data interval.
        this._dataInterval = [
            $3b70dfd40964ab40$var$linearMap(handleEnds[0], sizeExtent, dataExtent, true),
            $3b70dfd40964ab40$var$linearMap(handleEnds[1], sizeExtent, dataExtent, true)
        ];
    };
    ContinuousView.prototype._updateView = function(forSketch) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var shapes = this._shapes;
        var outOfRangeHandleEnds = [
            0,
            visualMapModel.itemSize[1]
        ];
        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
        shapes.inRange.setStyle({
            fill: visualInRange.barColor
        }).setShape('points', visualInRange.barPoints);
        shapes.outOfRange.setStyle({
            fill: visualOutOfRange.barColor
        }).setShape('points', visualOutOfRange.barPoints);
        this._updateHandle(inRangeHandleEnds, visualInRange);
    };
    ContinuousView.prototype._createBarVisual = function(dataInterval, dataExtent, handleEnds, forceState) {
        var opts = {
            forceState: forceState,
            convertOpacityToAlpha: true
        };
        var colorStops = this._makeColorGradient(dataInterval, opts);
        var symbolSizes = [
            this.getControllerVisual(dataInterval[0], 'symbolSize', opts),
            this.getControllerVisual(dataInterval[1], 'symbolSize', opts)
        ];
        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
        return {
            barColor: new (0, $ftfXE.default)(0, 0, 0, 1, colorStops),
            barPoints: barPoints,
            handlesColor: [
                colorStops[0].color,
                colorStops[colorStops.length - 1].color
            ]
        };
    };
    ContinuousView.prototype._makeColorGradient = function(dataInterval, opts) {
        // Considering colorHue, which is not linear, so we have to sample
        // to calculate gradient color stops, but not only calculate head
        // and tail.
        var sampleNumber = 100; // Arbitrary value.
        var colorStops = [];
        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
        colorStops.push({
            color: this.getControllerVisual(dataInterval[0], 'color', opts),
            offset: 0
        });
        for(var i = 1; i < sampleNumber; i++){
            var currValue = dataInterval[0] + step * i;
            if (currValue > dataInterval[1]) break;
            colorStops.push({
                color: this.getControllerVisual(currValue, 'color', opts),
                offset: i / sampleNumber
            });
        }
        colorStops.push({
            color: this.getControllerVisual(dataInterval[1], 'color', opts),
            offset: 1
        });
        return colorStops;
    };
    ContinuousView.prototype._createBarPoints = function(handleEnds, symbolSizes) {
        var itemSize = this.visualMapModel.itemSize;
        return [
            [
                itemSize[0] - symbolSizes[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[1]
            ],
            [
                itemSize[0] - symbolSizes[1],
                handleEnds[1]
            ]
        ];
    };
    ContinuousView.prototype._createBarGroup = function(itemAlign) {
        var orient = this._orient;
        var inverse = this.visualMapModel.get('inverse');
        return new $iQonF.default(orient === 'horizontal' && !inverse ? {
            scaleX: itemAlign === 'bottom' ? 1 : -1,
            rotation: Math.PI / 2
        } : orient === 'horizontal' && inverse ? {
            scaleX: itemAlign === 'bottom' ? -1 : 1,
            rotation: -Math.PI / 2
        } : orient === 'vertical' && !inverse ? {
            scaleX: itemAlign === 'left' ? 1 : -1,
            scaleY: -1
        } : {
            scaleX: itemAlign === 'left' ? 1 : -1
        });
    };
    ContinuousView.prototype._updateHandle = function(handleEnds, visualInRange) {
        if (!this._useHandle) return;
        var shapes = this._shapes;
        var visualMapModel = this.visualMapModel;
        var handleThumbs = shapes.handleThumbs;
        var handleLabels = shapes.handleLabels;
        var itemSize = visualMapModel.itemSize;
        var dataExtent = visualMapModel.getExtent();
        var align = this._applyTransform('left', shapes.mainGroup);
        $3b70dfd40964ab40$var$each([
            0,
            1
        ], function(handleIndex) {
            var handleThumb = handleThumbs[handleIndex];
            handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
            handleThumb.y = handleEnds[handleIndex];
            var val = $3b70dfd40964ab40$var$linearMap(handleEnds[handleIndex], [
                0,
                itemSize[1]
            ], dataExtent, true);
            var symbolSize = this.getControllerVisual(val, 'symbolSize');
            handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
            handleThumb.x = itemSize[0] - symbolSize / 2;
            // Update handle label position.
            var textPoint = $h9U3p.applyTransform(shapes.handleLabelPoints[handleIndex], $h9U3p.getTransform(handleThumb, this.group));
            if (this._orient === 'horizontal') {
                // If visualMap controls symbol size, an additional offset needs to be added to labels to avoid collision at minimum size.
                // Offset reaches value of 0 at "maximum" position, so maximum position is not altered at all.
                var minimumOffset = align === 'left' || align === 'top' ? (itemSize[0] - symbolSize) / 2 : (itemSize[0] - symbolSize) / -2;
                textPoint[1] += minimumOffset;
            }
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
                verticalAlign: 'middle',
                align: this._orient === 'vertical' ? this._applyTransform('left', shapes.mainGroup) : 'center'
            });
        }, this);
    };
    ContinuousView.prototype._showIndicator = function(cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var itemSize = visualMapModel.itemSize;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var shapes = this._shapes;
        var indicator = shapes.indicator;
        if (!indicator) return;
        indicator.attr('invisible', false);
        var opts = {
            convertOpacityToAlpha: true
        };
        var color = this.getControllerVisual(cursorValue, 'color', opts);
        var symbolSize = this.getControllerVisual(cursorValue, 'symbolSize');
        var y = $3b70dfd40964ab40$var$linearMap(cursorValue, dataExtent, sizeExtent, true);
        var x = itemSize[0] - symbolSize / 2;
        var oldIndicatorPos = {
            x: indicator.x,
            y: indicator.y
        };
        // Update handle label position.
        indicator.y = y;
        indicator.x = x;
        var textPoint = $h9U3p.applyTransform(shapes.indicatorLabelPoint, $h9U3p.getTransform(indicator, this.group));
        var indicatorLabel = shapes.indicatorLabel;
        indicatorLabel.attr('invisible', false);
        var align = this._applyTransform('left', shapes.mainGroup);
        var orient = this._orient;
        var isHorizontal = orient === 'horizontal';
        indicatorLabel.setStyle({
            text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
            verticalAlign: isHorizontal ? align : 'middle',
            align: isHorizontal ? 'center' : align
        });
        var indicatorNewProps = {
            x: x,
            y: y,
            style: {
                fill: color
            }
        };
        var labelNewProps = {
            style: {
                x: textPoint[0],
                y: textPoint[1]
            }
        };
        if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
            var animationCfg = {
                duration: 100,
                easing: 'cubicInOut',
                additive: true
            };
            indicator.x = oldIndicatorPos.x;
            indicator.y = oldIndicatorPos.y;
            indicator.animateTo(indicatorNewProps, animationCfg);
            indicatorLabel.animateTo(labelNewProps, animationCfg);
        } else {
            indicator.attr(indicatorNewProps);
            indicatorLabel.attr(labelNewProps);
        }
        this._firstShowIndicator = false;
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.enterBlur(handleLabels[i]);
    };
    ContinuousView.prototype._enableHoverLinkToSeries = function() {
        var self = this;
        this._shapes.mainGroup.on('mousemove', function(e) {
            self._hovering = true;
            if (!self._dragging) {
                var itemSize = self.visualMapModel.itemSize;
                var pos = self._applyTransform([
                    e.offsetX,
                    e.offsetY
                ], self._shapes.mainGroup, true, true);
                // For hover link show when hover handle, which might be
                // below or upper than sizeExtent.
                pos[1] = $3b70dfd40964ab40$var$mathMin($3b70dfd40964ab40$var$mathMax(0, pos[1]), itemSize[1]);
                self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
            }
        }).on('mouseout', function() {
            // When mouse is out of handle, hoverLink still need
            // to be displayed when realtime is set as false.
            self._hovering = false;
            !self._dragging && self._clearHoverLinkToSeries();
        });
    };
    ContinuousView.prototype._enableHoverLinkFromSeries = function() {
        var zr = this.api.getZr();
        if (this.visualMapModel.option.hoverLink) {
            zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
            zr.on('mouseout', this._hideIndicator, this);
        } else this._clearHoverLinkFromSeries();
    };
    ContinuousView.prototype._doHoverLinkToSeries = function(cursorPos, hoverOnBar) {
        var visualMapModel = this.visualMapModel;
        var itemSize = visualMapModel.itemSize;
        if (!visualMapModel.option.hoverLink) return;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var dataExtent = visualMapModel.getExtent();
        // For hover link show when hover handle, which might be below or upper than sizeExtent.
        cursorPos = $3b70dfd40964ab40$var$mathMin($3b70dfd40964ab40$var$mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
        var halfHoverLinkSize = $3b70dfd40964ab40$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
        var hoverRange = [
            cursorPos - halfHoverLinkSize,
            cursorPos + halfHoverLinkSize
        ];
        var cursorValue = $3b70dfd40964ab40$var$linearMap(cursorPos, sizeExtent, dataExtent, true);
        var valueRange = [
            $3b70dfd40964ab40$var$linearMap(hoverRange[0], sizeExtent, dataExtent, true),
            $3b70dfd40964ab40$var$linearMap(hoverRange[1], sizeExtent, dataExtent, true)
        ];
        // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
        // where china and india has very large population.
        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity);
        // Do not show indicator when mouse is over handle,
        // otherwise labels overlap, especially when dragging.
        if (hoverOnBar) {
            if (valueRange[0] === -Infinity) this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
            else if (valueRange[1] === Infinity) this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
            else this._showIndicator(cursorValue, cursorValue, "\u2248 ", halfHoverLinkSize);
        }
        // When realtime is set as false, handles, which are in barGroup,
        // also trigger hoverLink, which help user to realize where they
        // focus on when dragging. (see test/heatmap-large.html)
        // When realtime is set as true, highlight will not show when hover
        // handle, because the label on handle, which displays a exact value
        // but not range, might mislead users.
        var oldBatch = this._hoverLinkDataIndices;
        var newBatch = [];
        if (hoverOnBar || $3b70dfd40964ab40$var$useHoverLinkOnHandle(visualMapModel)) newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
        var resultBatches = $bx3T8.compressBatches(oldBatch, newBatch);
        this._dispatchHighDown('downplay', $5xc3O.makeHighDownBatch(resultBatches[0], visualMapModel));
        this._dispatchHighDown('highlight', $5xc3O.makeHighDownBatch(resultBatches[1], visualMapModel));
    };
    ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function(e) {
        var ecData;
        (0, $cQG2W.findEventDispatcher)(e.target, function(target) {
            var currECData = (0, $6TSUP.getECData)(target);
            if (currECData.dataIndex != null) {
                ecData = currECData;
                return true;
            }
        }, true);
        if (!ecData) return;
        var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
        var visualMapModel = this.visualMapModel;
        if (!visualMapModel.isTargetSeries(dataModel)) return;
        var data = dataModel.getData(ecData.dataType);
        var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);
        if (!isNaN(value)) this._showIndicator(value, value);
    };
    ContinuousView.prototype._hideIndicator = function() {
        var shapes = this._shapes;
        shapes.indicator && shapes.indicator.attr('invisible', true);
        shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.leaveBlur(handleLabels[i]);
    };
    ContinuousView.prototype._clearHoverLinkToSeries = function() {
        this._hideIndicator();
        var indices = this._hoverLinkDataIndices;
        this._dispatchHighDown('downplay', $5xc3O.makeHighDownBatch(indices, this.visualMapModel));
        indices.length = 0;
    };
    ContinuousView.prototype._clearHoverLinkFromSeries = function() {
        this._hideIndicator();
        var zr = this.api.getZr();
        zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
        zr.off('mouseout', this._hideIndicator);
    };
    ContinuousView.prototype._applyTransform = function(vertex, element, inverse, global) {
        var transform = $h9U3p.getTransform(element, global ? null : this.group);
        return $2N6Uo.isArray(vertex) ? $h9U3p.applyTransform(vertex, transform, inverse) : $h9U3p.transformDirection(vertex, transform, inverse);
    };
    // TODO: TYPE more specified payload types.
    ContinuousView.prototype._dispatchHighDown = function(type, batch) {
        batch && batch.length && this.api.dispatchAction({
            type: type,
            batch: batch
        });
    };
    /**
   * @override
   */ ContinuousView.prototype.dispose = function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    };
    ContinuousView.type = 'visualMap.continuous';
    return ContinuousView;
}((0, $4ANTH.default));
function $3b70dfd40964ab40$var$createPolygon(points, cursor, onDrift, onDragEnd) {
    return new $hXTRG.default({
        shape: {
            points: points
        },
        draggable: !!onDrift,
        cursor: cursor,
        drift: onDrift,
        onmousemove: function(e) {
            // For mobile device, prevent screen slider on the button.
            $pGNPI.stop(e.event);
        },
        ondragend: onDragEnd
    });
}
function $3b70dfd40964ab40$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
    var halfHoverLinkSize = $3b70dfd40964ab40$var$HOVER_LINK_SIZE / 2;
    var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
    if (hoverLinkDataSize) halfHoverLinkSize = $3b70dfd40964ab40$var$linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
    return halfHoverLinkSize;
}
function $3b70dfd40964ab40$var$useHoverLinkOnHandle(visualMapModel) {
    var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
    return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
}
function $3b70dfd40964ab40$var$getCursor(orient) {
    return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}
var $3b70dfd40964ab40$export$2e2bcd8739ae039 = $3b70dfd40964ab40$var$ContinuousView;

});
parcelRegister("4ANTH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35813ad1958e76ad$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");
parcelRequire("h9U3p");
var $aH2k0 = parcelRequire("aH2k0");

var $hrphB = parcelRequire("hrphB");

var $a35Wn = parcelRequire("a35Wn");

var $dzLre = parcelRequire("dzLre");

var $bpyST = parcelRequire("bpyST");
var $35813ad1958e76ad$var$VisualMapView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(VisualMapView, _super);
    function VisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapView.type;
        _this.autoPositionValues = {
            left: 1,
            right: 1,
            top: 1,
            bottom: 1
        };
        return _this;
    }
    VisualMapView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
    };
    /**
   * @protected
   */ VisualMapView.prototype.render = function(visualMapModel, ecModel, api, payload // TODO: TYPE
    ) {
        this.visualMapModel = visualMapModel;
        if (visualMapModel.get('show') === false) {
            this.group.removeAll();
            return;
        }
        this.doRender(visualMapModel, ecModel, api, payload);
    };
    /**
   * @protected
   */ VisualMapView.prototype.renderBackground = function(group) {
        var visualMapModel = this.visualMapModel;
        var padding = $hrphB.normalizeCssArray(visualMapModel.get('padding') || 0);
        var rect = group.getBoundingRect();
        group.add(new (0, $aH2k0.default)({
            z2: -1,
            silent: true,
            shape: {
                x: rect.x - padding[3],
                y: rect.y - padding[0],
                width: rect.width + padding[3] + padding[1],
                height: rect.height + padding[0] + padding[2]
            },
            style: {
                fill: visualMapModel.get('backgroundColor'),
                stroke: visualMapModel.get('borderColor'),
                lineWidth: visualMapModel.get('borderWidth')
            }
        }));
    };
    /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */ VisualMapView.prototype.getControllerVisual = function(targetValue, visualCluster, opts) {
        opts = opts || {};
        var forceState = opts.forceState;
        var visualMapModel = this.visualMapModel;
        var visualObj = {};
        // Default values.
        if (visualCluster === 'color') {
            var defaultColor = visualMapModel.get('contentColor');
            visualObj.color = defaultColor;
        }
        function getter(key) {
            return visualObj[key];
        }
        function setter(key, value) {
            visualObj[key] = value;
        }
        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
        var visualTypes = (0, $dzLre.default).prepareVisualTypes(mappings);
        $2N6Uo.each(visualTypes, function(type) {
            var visualMapping = mappings[type];
            if (opts.convertOpacityToAlpha && type === 'opacity') {
                type = 'colorAlpha';
                visualMapping = mappings.__alphaForOpacity;
            }
            if ((0, $dzLre.default).dependsOn(type, visualCluster)) visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
        });
        return visualObj[visualCluster];
    };
    VisualMapView.prototype.positionGroup = function(group) {
        var model = this.visualMapModel;
        var api = this.api;
        var refContainer = $a35Wn.createBoxLayoutReference(model, api).refContainer;
        $a35Wn.positionElement(group, model.getBoxLayoutParams(), refContainer);
    };
    VisualMapView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {};
    VisualMapView.type = 'visualMap';
    return VisualMapView;
}((0, $bpyST.default));
var $35813ad1958e76ad$export$2e2bcd8739ae039 = $35813ad1958e76ad$var$VisualMapView;

});

parcelRegister("5xc3O", function(module, exports) {

$parcel$export(module.exports, "getItemAlign", function () { return $407963c4b45fd020$export$dca53c4702e35c6; });
$parcel$export(module.exports, "makeHighDownBatch", function () { return $407963c4b45fd020$export$5381a9dc5427ba18; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $a35Wn = parcelRequire("a35Wn");
var $407963c4b45fd020$var$paramsSet = [
    [
        'left',
        'right',
        'width'
    ],
    [
        'top',
        'bottom',
        'height'
    ]
];
function $407963c4b45fd020$export$dca53c4702e35c6(visualMapModel, api, itemSize) {
    var modelOption = visualMapModel.option;
    var itemAlign = modelOption.align;
    if (itemAlign != null && itemAlign !== 'auto') return itemAlign;
    // Auto decision align.
    var ecSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
    var reals = $407963c4b45fd020$var$paramsSet[realIndex];
    var fakeValue = [
        0,
        null,
        10
    ];
    var layoutInput = {};
    for(var i = 0; i < 3; i++){
        layoutInput[$407963c4b45fd020$var$paramsSet[1 - realIndex][i]] = fakeValue[i];
        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
    }
    var rParam = [
        [
            'x',
            'width',
            3
        ],
        [
            'y',
            'height',
            0
        ]
    ][realIndex];
    var rect = (0, $a35Wn.getLayoutRect)(layoutInput, ecSize, modelOption.padding);
    return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
function $407963c4b45fd020$export$5381a9dc5427ba18(batch, visualMapModel) {
    $2N6Uo.each(batch || [], function(batchItem) {
        if (batchItem.dataIndex != null) {
            batchItem.dataIndexInside = batchItem.dataIndex;
            batchItem.dataIndex = null;
        }
        batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
    });
    return batch;
}

});


parcelRegister("545jm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b017228423d3076$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1uWje = parcelRequire("1uWje");

var $hQ1q1 = parcelRequire("hQ1q1");

var $2N6Uo = parcelRequire("2N6Uo");

var $8FR1y = parcelRequire("8FR1y");
var $3b017228423d3076$var$installed = false;
function $3b017228423d3076$export$2e2bcd8739ae039(registers) {
    if ($3b017228423d3076$var$installed) return;
    $3b017228423d3076$var$installed = true;
    registers.registerSubTypeDefaulter('visualMap', function(option) {
        // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
        return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
    });
    registers.registerAction((0, $1uWje.visualMapActionInfo), (0, $1uWje.visualMapActionHander));
    (0, $2N6Uo.each)((0, $hQ1q1.visualMapEncodingHandlers), function(handler) {
        registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
    });
    registers.registerPreprocessor((0, $8FR1y.default));
}

});
parcelRegister("1uWje", function(module, exports) {

$parcel$export(module.exports, "visualMapActionInfo", function () { return $1175d2c4e912e31c$export$c5097295b52f5ecd; });
$parcel$export(module.exports, "visualMapActionHander", function () { return $1175d2c4e912e31c$export$8655c04a6fcbaa76; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1175d2c4e912e31c$export$c5097295b52f5ecd = {
    type: 'selectDataRange',
    event: 'dataRangeSelected',
    // FIXME use updateView appears wrong
    update: 'update'
};
var $1175d2c4e912e31c$export$8655c04a6fcbaa76 = function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: 'visualMap',
        query: payload
    }, function(model) {
        model.setSelected(payload.selected);
    });
};

});

parcelRegister("hQ1q1", function(module, exports) {

$parcel$export(module.exports, "visualMapEncodingHandlers", function () { return $cfc864ba663dac7f$export$5933e7c74ab358d1; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");

var $1UvsP = parcelRequire("1UvsP");

var $dzLre = parcelRequire("dzLre");

var $csdCr = parcelRequire("csdCr");
var $cfc864ba663dac7f$export$5933e7c74ab358d1 = [
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var resetDefines = [];
            ecModel.eachComponent('visualMap', function(visualMapModel) {
                var pipelineContext = seriesModel.pipelineContext;
                if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) return;
                resetDefines.push($1UvsP.incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, $2N6Uo.bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
            });
            return resetDefines;
        }
    },
    // Only support color.
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var visualMetaList = [];
            ecModel.eachComponent('visualMap', function(visualMapModel) {
                if (visualMapModel.isTargetSeries(seriesModel)) {
                    var visualMeta = visualMapModel.getVisualMeta($2N6Uo.bind($cfc864ba663dac7f$var$getColorVisual, null, seriesModel, visualMapModel)) || {
                        stops: [],
                        outerColors: []
                    };
                    var dimIdx = visualMapModel.getDataDimensionIndex(data);
                    if (dimIdx >= 0) {
                        // visualMeta.dimension should be dimension index, but not concrete dimension.
                        visualMeta.dimension = dimIdx;
                        visualMetaList.push(visualMeta);
                    }
                }
            });
            // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
            seriesModel.getData().setVisual('visualMeta', visualMetaList);
        }
    }
];
// FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function $cfc864ba663dac7f$var$getColorVisual(seriesModel, visualMapModel, value, valueState) {
    var mappings = visualMapModel.targetVisuals[valueState];
    var visualTypes = (0, $dzLre.default).prepareVisualTypes(mappings);
    var resultVisual = {
        color: (0, $csdCr.getVisualFromData)(seriesModel.getData(), 'color') // default color.
    };
    for(var i = 0, len = visualTypes.length; i < len; i++){
        var type = visualTypes[i];
        var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
        mapping && mapping.applyVisual(value, getVisual, setVisual);
    }
    return resultVisual.color;
    function getVisual(key) {
        return resultVisual[key];
    }
    function setVisual(key, value) {
        resultVisual[key] = value;
    }
}

});

parcelRegister("8FR1y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $650b48858974b3dc$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $2N6Uo = parcelRequire("2N6Uo");
var $650b48858974b3dc$var$each = $2N6Uo.each;
function $650b48858974b3dc$export$2e2bcd8739ae039(option) {
    var visualMap = option && option.visualMap;
    if (!$2N6Uo.isArray(visualMap)) visualMap = visualMap ? [
        visualMap
    ] : [];
    $650b48858974b3dc$var$each(visualMap, function(opt) {
        if (!opt) return;
        // rename splitList to pieces
        if ($650b48858974b3dc$var$has(opt, 'splitList') && !$650b48858974b3dc$var$has(opt, 'pieces')) {
            opt.pieces = opt.splitList;
            delete opt.splitList;
        }
        var pieces = opt.pieces;
        if (pieces && $2N6Uo.isArray(pieces)) $650b48858974b3dc$var$each(pieces, function(piece) {
            if ($2N6Uo.isObject(piece)) {
                if ($650b48858974b3dc$var$has(piece, 'start') && !$650b48858974b3dc$var$has(piece, 'min')) piece.min = piece.start;
                if ($650b48858974b3dc$var$has(piece, 'end') && !$650b48858974b3dc$var$has(piece, 'max')) piece.max = piece.end;
            }
        });
    });
}
function $650b48858974b3dc$var$has(obj, name) {
    return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}

});



parcelRegister("hpw8u", function(module, exports) {

$parcel$export(module.exports, "install", function () { return $cacdb2fdb96e60a6$export$4b3e715f166fdd78; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2PoGe = parcelRequire("2PoGe");

var $8IfZ7 = parcelRequire("8IfZ7");

var $545jm = parcelRequire("545jm");
function $cacdb2fdb96e60a6$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2PoGe.default));
    registers.registerComponentView((0, $8IfZ7.default));
    (0, $545jm.default)(registers);
}

});
parcelRegister("2PoGe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20f37d2d19b9ecdd$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $8KWGf = parcelRequire("8KWGf");

var $dzLre = parcelRequire("dzLre");

var $1Ia3f = parcelRequire("1Ia3f");

var $iCU10 = parcelRequire("iCU10");

var $cKPmR = parcelRequire("cKPmR");
var $20f37d2d19b9ecdd$var$PiecewiseModel = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PiecewiseModel, _super);
    function PiecewiseModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseModel.type;
        /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */ _this._pieceList = [];
        return _this;
    }
    PiecewiseModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        var mode = this._mode = this._determineMode();
        this._pieceList = [];
        $20f37d2d19b9ecdd$var$resetMethods[this._mode].call(this, this._pieceList);
        this._resetSelected(newOption, isInit);
        var categories = this.option.categories;
        this.resetVisual(function(mappingOption, state) {
            if (mode === 'categories') {
                mappingOption.mappingMethod = 'category';
                mappingOption.categories = $2N6Uo.clone(categories);
            } else {
                mappingOption.dataExtent = this.getExtent();
                mappingOption.mappingMethod = 'piecewise';
                mappingOption.pieceList = $2N6Uo.map(this._pieceList, function(piece) {
                    piece = $2N6Uo.clone(piece);
                    if (state !== 'inRange') // FIXME
                    // outOfRange do not support special visual in pieces.
                    piece.visual = null;
                    return piece;
                });
            }
        });
    };
    /**
   * @protected
   * @override
   */ PiecewiseModel.prototype.completeVisualOption = function() {
        // Consider this case:
        // visualMap: {
        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
        // }
        // where no inRange/outOfRange set but only pieces. So we should make
        // default inRange/outOfRange for this case, otherwise visuals that only
        // appear in `pieces` will not be taken into account in visual encoding.
        var option = this.option;
        var visualTypesInPieces = {};
        var visualTypes = (0, $dzLre.default).listVisualTypes();
        var isCategory = this.isCategory();
        $2N6Uo.each(option.pieces, function(piece) {
            $2N6Uo.each(visualTypes, function(visualType) {
                if (piece.hasOwnProperty(visualType)) visualTypesInPieces[visualType] = 1;
            });
        });
        $2N6Uo.each(visualTypesInPieces, function(v, visualType) {
            var exists = false;
            $2N6Uo.each(this.stateList, function(state) {
                exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
            }, this);
            !exists && $2N6Uo.each(this.stateList, function(state) {
                (option[state] || (option[state] = {}))[visualType] = (0, $1Ia3f.default).get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
            });
        }, this);
        function has(obj, state, visualType) {
            return obj && obj[state] && obj[state].hasOwnProperty(visualType);
        }
        _super.prototype.completeVisualOption.apply(this, arguments);
    };
    PiecewiseModel.prototype._resetSelected = function(newOption, isInit) {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        // Selected do not merge but all override.
        var selected = (isInit ? thisOption : newOption).selected || {};
        thisOption.selected = selected;
        // Consider 'not specified' means true.
        $2N6Uo.each(pieceList, function(piece, index) {
            var key = this.getSelectedMapKey(piece);
            if (!selected.hasOwnProperty(key)) selected[key] = true;
        }, this);
        if (thisOption.selectedMode === 'single') {
            // Ensure there is only one selected.
            var hasSel_1 = false;
            $2N6Uo.each(pieceList, function(piece, index) {
                var key = this.getSelectedMapKey(piece);
                if (selected[key]) hasSel_1 ? selected[key] = false : hasSel_1 = true;
            }, this);
        }
    // thisOption.selectedMode === 'multiple', default: all selected.
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getItemSymbol = function() {
        return this.get('itemSymbol');
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getSelectedMapKey = function(piece) {
        return this._mode === 'categories' ? piece.value + '' : piece.index + '';
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getPieceList = function() {
        return this._pieceList;
    };
    /**
   * @return {string}
   */ PiecewiseModel.prototype._determineMode = function() {
        var option = this.option;
        return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
    };
    /**
   * @override
   */ PiecewiseModel.prototype.setSelected = function(selected) {
        this.option.selected = $2N6Uo.clone(selected);
    };
    /**
   * @override
   */ PiecewiseModel.prototype.getValueState = function(value) {
        var index = (0, $dzLre.default).findPieceIndex(value, this._pieceList);
        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
    };
    /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */ PiecewiseModel.prototype.findTargetDataIndices = function(pieceIndex) {
        var result = [];
        var pieceList = this._pieceList;
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                // Should always base on model pieceList, because it is order sensitive.
                var pIdx = (0, $dzLre.default).findPieceIndex(value, pieceList);
                pIdx === pieceIndex && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */ PiecewiseModel.prototype.getRepresentValue = function(piece) {
        var representValue;
        if (this.isCategory()) representValue = piece.value;
        else if (piece.value != null) representValue = piece.value;
        else {
            var pieceInterval = piece.interval || [];
            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
        }
        return representValue;
    };
    PiecewiseModel.prototype.getVisualMeta = function(getColorVisual) {
        // Do not support category. (category axis is ordinal, numerical)
        if (this.isCategory()) return;
        var stops = [];
        var outerColors = [
            '',
            ''
        ];
        var visualMapModel = this;
        function setStop(interval, valueState) {
            var representValue = visualMapModel.getRepresentValue({
                interval: interval
            }); // Not category
            if (!valueState) valueState = visualMapModel.getValueState(representValue);
            var color = getColorVisual(representValue, valueState);
            if (interval[0] === -Infinity) outerColors[0] = color;
            else if (interval[1] === Infinity) outerColors[1] = color;
            else stops.push({
                value: interval[0],
                color: color
            }, {
                value: interval[1],
                color: color
            });
        }
        // Suplement
        var pieceList = this._pieceList.slice();
        if (!pieceList.length) pieceList.push({
            interval: [
                -Infinity,
                Infinity
            ]
        });
        else {
            var edge = pieceList[0].interval[0];
            edge !== -Infinity && pieceList.unshift({
                interval: [
                    -Infinity,
                    edge
                ]
            });
            edge = pieceList[pieceList.length - 1].interval[1];
            edge !== Infinity && pieceList.push({
                interval: [
                    edge,
                    Infinity
                ]
            });
        }
        var curr = -Infinity;
        $2N6Uo.each(pieceList, function(piece) {
            var interval = piece.interval;
            if (interval) {
                // Fulfill gap.
                interval[0] > curr && setStop([
                    curr,
                    interval[0]
                ], 'outOfRange');
                setStop(interval.slice());
                curr = interval[1];
            }
        }, this);
        return {
            stops: stops,
            outerColors: outerColors
        };
    };
    PiecewiseModel.type = 'visualMap.piecewise';
    PiecewiseModel.defaultOption = (0, $cKPmR.inheritDefaultOption)((0, $8KWGf.default).defaultOption, {
        selected: null,
        minOpen: false,
        maxOpen: false,
        align: 'auto',
        itemWidth: 20,
        itemHeight: 14,
        itemSymbol: 'roundRect',
        pieces: null,
        categories: null,
        splitNumber: 5,
        selectedMode: 'multiple',
        itemGap: 10,
        hoverLink: true // Enable hover highlight.
    });
    return PiecewiseModel;
}((0, $8KWGf.default));
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */ var $20f37d2d19b9ecdd$var$resetMethods = {
    splitNumber: function(outPieceList) {
        var thisOption = this.option;
        var precision = Math.min(thisOption.precision, 20);
        var dataExtent = this.getExtent();
        var splitNumber = thisOption.splitNumber;
        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
        thisOption.splitNumber = splitNumber;
        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber;
        // Precision auto-adaption
        while(+splitStep.toFixed(precision) !== splitStep && precision < 5)precision++;
        thisOption.precision = precision;
        splitStep = +splitStep.toFixed(precision);
        if (thisOption.minOpen) outPieceList.push({
            interval: [
                -Infinity,
                dataExtent[0]
            ],
            close: [
                0,
                0
            ]
        });
        for(var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++){
            var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
            outPieceList.push({
                interval: [
                    curr,
                    max
                ],
                close: [
                    1,
                    1
                ]
            });
        }
        if (thisOption.maxOpen) outPieceList.push({
            interval: [
                dataExtent[1],
                Infinity
            ],
            close: [
                0,
                0
            ]
        });
        (0, $iCU10.reformIntervals)(outPieceList);
        $2N6Uo.each(outPieceList, function(piece, index) {
            piece.index = index;
            piece.text = this.formatValueText(piece.interval);
        }, this);
    },
    categories: function(outPieceList) {
        var thisOption = this.option;
        $2N6Uo.each(thisOption.categories, function(cate) {
            // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
            // 是否改一致。
            outPieceList.push({
                text: this.formatValueText(cate, true),
                value: cate
            });
        }, this);
        // See "Order Rule".
        $20f37d2d19b9ecdd$var$normalizeReverse(thisOption, outPieceList);
    },
    pieces: function(outPieceList) {
        var thisOption = this.option;
        $2N6Uo.each(thisOption.pieces, function(pieceListItem, index) {
            if (!$2N6Uo.isObject(pieceListItem)) pieceListItem = {
                value: pieceListItem
            };
            var item = {
                text: '',
                index: index
            };
            if (pieceListItem.label != null) item.text = pieceListItem.label;
            if (pieceListItem.hasOwnProperty('value')) {
                var value = item.value = pieceListItem.value;
                item.interval = [
                    value,
                    value
                ];
                item.close = [
                    1,
                    1
                ];
            } else {
                // `min` `max` is legacy option.
                // `lt` `gt` `lte` `gte` is recommended.
                var interval = item.interval = [];
                var close_1 = item.close = [
                    0,
                    0
                ];
                var closeList = [
                    1,
                    0,
                    1
                ];
                var infinityList = [
                    -Infinity,
                    Infinity
                ];
                var useMinMax = [];
                for(var lg = 0; lg < 2; lg++){
                    var names = [
                        [
                            'gte',
                            'gt',
                            'min'
                        ],
                        [
                            'lte',
                            'lt',
                            'max'
                        ]
                    ][lg];
                    for(var i = 0; i < 3 && interval[lg] == null; i++){
                        interval[lg] = pieceListItem[names[i]];
                        close_1[lg] = closeList[i];
                        useMinMax[lg] = i === 2;
                    }
                    interval[lg] == null && (interval[lg] = infinityList[lg]);
                }
                useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
                useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);
                if (interval[0] === interval[1] && close_1[0] && close_1[1]) // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
                // we use value to lift the priority when min === max
                item.value = interval[0];
            }
            item.visual = (0, $dzLre.default).retrieveVisuals(pieceListItem);
            outPieceList.push(item);
        }, this);
        // See "Order Rule".
        $20f37d2d19b9ecdd$var$normalizeReverse(thisOption, outPieceList);
        // Only pieces
        (0, $iCU10.reformIntervals)(outPieceList);
        $2N6Uo.each(outPieceList, function(piece) {
            var close = piece.close;
            var edgeSymbols = [
                [
                    '<',
                    "\u2264"
                ][close[1]],
                [
                    '>',
                    "\u2265"
                ][close[0]]
            ];
            piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
        }, this);
    }
};
function $20f37d2d19b9ecdd$var$normalizeReverse(thisOption, pieceList) {
    var inverse = thisOption.inverse;
    if (thisOption.orient === 'vertical' ? !inverse : inverse) pieceList.reverse();
}
var $20f37d2d19b9ecdd$export$2e2bcd8739ae039 = $20f37d2d19b9ecdd$var$PiecewiseModel;

});

parcelRegister("8IfZ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $657ed50f6e601b47$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9nEce = parcelRequire("9nEce");

var $2N6Uo = parcelRequire("2N6Uo");

var $4ANTH = parcelRequire("4ANTH");

var $iQonF = parcelRequire("iQonF");
var $kBKw3 = parcelRequire("kBKw3");

var $k0QDS = parcelRequire("k0QDS");

var $a35Wn = parcelRequire("a35Wn");

var $5xc3O = parcelRequire("5xc3O");

var $bysmE = parcelRequire("bysmE");
var $657ed50f6e601b47$var$PiecewiseVisualMapView = /** @class */ function(_super) {
    (0, $9nEce.__extends)(PiecewiseVisualMapView, _super);
    function PiecewiseVisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseVisualMapView.type;
        return _this;
    }
    PiecewiseVisualMapView.prototype.doRender = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get('textGap');
        var textStyleModel = visualMapModel.textStyleModel;
        var itemAlign = this._getItemAlign();
        var itemSize = visualMapModel.itemSize;
        var viewData = this._getViewData();
        var endsText = viewData.endsText;
        var showLabel = $2N6Uo.retrieve(visualMapModel.get('showLabel', true), !endsText);
        var silent = !visualMapModel.get('selectedMode');
        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
        $2N6Uo.each(viewData.viewPieceList, function(item) {
            var piece = item.piece;
            var itemGroup = new $iQonF.default();
            itemGroup.onclick = $2N6Uo.bind(this._onItemClick, this, piece);
            this._enableHoverLink(itemGroup, item.indexInModelPieceList);
            // TODO Category
            var representValue = visualMapModel.getRepresentValue(piece);
            this._createItemSymbol(itemGroup, representValue, [
                0,
                0,
                itemSize[0],
                itemSize[1]
            ], silent);
            if (showLabel) {
                var visualState = this.visualMapModel.getValueState(representValue);
                var align = textStyleModel.get('align') || itemAlign;
                itemGroup.add(new $kBKw3.default({
                    style: (0, $bysmE.createTextStyle)(textStyleModel, {
                        x: align === 'right' ? -textGap : itemSize[0] + textGap,
                        y: itemSize[1] / 2,
                        text: piece.text,
                        verticalAlign: textStyleModel.get('verticalAlign') || 'middle',
                        align: align,
                        opacity: $2N6Uo.retrieve2(textStyleModel.get('opacity'), visualState === 'outOfRange' ? 0.5 : 1)
                    }),
                    silent: silent
                }));
            }
            thisGroup.add(itemGroup);
        }, this);
        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
        $a35Wn.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
        this.renderBackground(thisGroup);
        this.positionGroup(thisGroup);
    };
    PiecewiseVisualMapView.prototype._enableHoverLink = function(itemGroup, pieceIndex) {
        var _this = this;
        itemGroup.on('mouseover', function() {
            return onHoverLink('highlight');
        }).on('mouseout', function() {
            return onHoverLink('downplay');
        });
        var onHoverLink = function(method) {
            var visualMapModel = _this.visualMapModel;
            // TODO: TYPE More detailed action types
            visualMapModel.option.hoverLink && _this.api.dispatchAction({
                type: method,
                batch: $5xc3O.makeHighDownBatch(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
            });
        };
    };
    PiecewiseVisualMapView.prototype._getItemAlign = function() {
        var visualMapModel = this.visualMapModel;
        var modelOption = visualMapModel.option;
        if (modelOption.orient === 'vertical') return $5xc3O.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
        else {
            // horizontal, most case left unless specifying right.
            var align = modelOption.align;
            if (!align || align === 'auto') align = 'left';
            return align;
        }
    };
    PiecewiseVisualMapView.prototype._renderEndsText = function(group, text, itemSize, showLabel, itemAlign) {
        if (!text) return;
        var itemGroup = new $iQonF.default();
        var textStyleModel = this.visualMapModel.textStyleModel;
        itemGroup.add(new $kBKw3.default({
            style: (0, $bysmE.createTextStyle)(textStyleModel, {
                x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
                y: itemSize[1] / 2,
                verticalAlign: 'middle',
                align: showLabel ? itemAlign : 'center',
                text: text
            })
        }));
        group.add(itemGroup);
    };
    /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */ PiecewiseVisualMapView.prototype._getViewData = function() {
        var visualMapModel = this.visualMapModel;
        var viewPieceList = $2N6Uo.map(visualMapModel.getPieceList(), function(piece, index) {
            return {
                piece: piece,
                indexInModelPieceList: index
            };
        });
        var endsText = visualMapModel.get('text');
        // Consider orient and inverse.
        var orient = visualMapModel.get('orient');
        var inverse = visualMapModel.get('inverse');
        // Order of model pieceList is always [low, ..., high]
        if (orient === 'horizontal' ? inverse : !inverse) viewPieceList.reverse();
        else if (endsText) endsText = endsText.slice().reverse();
        return {
            viewPieceList: viewPieceList,
            endsText: endsText
        };
    };
    PiecewiseVisualMapView.prototype._createItemSymbol = function(group, representValue, shapeParam, silent) {
        var itemSymbol = (0, $k0QDS.createSymbol)(// symbol will be string
        this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
        this.getControllerVisual(representValue, 'color'));
        itemSymbol.silent = silent;
        group.add(itemSymbol);
    };
    PiecewiseVisualMapView.prototype._onItemClick = function(piece) {
        var visualMapModel = this.visualMapModel;
        var option = visualMapModel.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        var selected = $2N6Uo.clone(option.selected);
        var newKey = visualMapModel.getSelectedMapKey(piece);
        if (selectedMode === 'single' || selectedMode === true) {
            selected[newKey] = true;
            $2N6Uo.each(selected, function(o, key) {
                selected[key] = key === newKey;
            });
        } else selected[newKey] = !selected[newKey];
        this.api.dispatchAction({
            type: 'selectDataRange',
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: selected
        });
    };
    PiecewiseVisualMapView.type = 'visualMap.piecewise';
    return PiecewiseVisualMapView;
}((0, $4ANTH.default));
var $657ed50f6e601b47$export$2e2bcd8739ae039 = $657ed50f6e601b47$var$PiecewiseVisualMapView;

});



parcelRegister("atXbX", function(module, exports) {

$parcel$export(module.exports, "installAxisBreak", function () { return $7a1a87197a8eaf9a$export$f3d2e42c14594d5b; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $31vrD = parcelRequire("31vrD");

var $2OQYM = parcelRequire("2OQYM");

var $fHwIR = parcelRequire("fHwIR");
function $7a1a87197a8eaf9a$export$f3d2e42c14594d5b(registers) {
    (0, $2OQYM.registerAction)(registers);
    (0, $31vrD.installScaleBreakHelper)();
    (0, $fHwIR.installAxisBreakHelper)();
}

});
parcelRegister("31vrD", function(module, exports) {

$parcel$export(module.exports, "installScaleBreakHelper", function () { return $2339db6215b77860$export$8a93e423db92f59c; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2N6Uo = parcelRequire("2N6Uo");


var $bjlCM = parcelRequire("bjlCM");

var $iCU10 = parcelRequire("iCU10");
/**
 * @caution
 *  Must not export anything except `installScaleBreakHelper`
 */ var $2339db6215b77860$var$ScaleBreakContextImpl = /** @class */ function() {
    function ScaleBreakContextImpl() {
        // [CAVEAT]: Should set only by `ScaleBreakContext#setBreaks`!
        this.breaks = [];
        // [CAVEAT]: Should update only by `ScaleBreakContext#update`!
        // They are the values that scaleExtent[0] and scaleExtent[1] are mapped to a numeric axis
        // that breaks are applied, primarily for optimization of `Scale#normalize`.
        this._elapsedExtent = [
            Infinity,
            -Infinity
        ];
    }
    ScaleBreakContextImpl.prototype.setBreaks = function(parsed) {
        // @ts-ignore
        this.breaks = parsed.breaks;
    };
    /**
   * [CAVEAT]: Must be called immediately each time scale extent and breaks are updated!
   */ ScaleBreakContextImpl.prototype.update = function(scaleExtent) {
        $2339db6215b77860$var$updateAxisBreakGapReal(this, scaleExtent);
        var elapsedExtent = this._elapsedExtent;
        elapsedExtent[0] = this.elapse(scaleExtent[0]);
        elapsedExtent[1] = this.elapse(scaleExtent[1]);
    };
    ScaleBreakContextImpl.prototype.hasBreaks = function() {
        return !!this.breaks.length;
    };
    /**
   * When iteratively generating ticks by nice interval, currently the `interval`, which is
   * calculated by break-elapsed extent span, is probably very small comparing to the original
   * extent, leading to a large number of iteration and tick generation, even over `safeLimit`.
   * Thus stepping over breaks is necessary in that loop.
   *
   * "Nice" should be ensured on ticks when step over the breaks. Thus this method returns
   * a integer multiple of the "nice tick interval".
   *
   * This method does little work; it is just for unifying and restricting the behavior.
   */ ScaleBreakContextImpl.prototype.calcNiceTickMultiple = function(tickVal, estimateNiceMultiple) {
        for(var idx = 0; idx < this.breaks.length; idx++){
            var brk = this.breaks[idx];
            if (brk.vmin < tickVal && tickVal < brk.vmax) {
                var multiple = estimateNiceMultiple(tickVal, brk.vmax);
                return multiple;
            }
        }
        return 0;
    };
    ScaleBreakContextImpl.prototype.getExtentSpan = function() {
        return this._elapsedExtent[1] - this._elapsedExtent[0];
    };
    ScaleBreakContextImpl.prototype.normalize = function(val) {
        var elapsedSpan = this._elapsedExtent[1] - this._elapsedExtent[0];
        // The same logic as `Scale#normalize`.
        if (elapsedSpan === 0) return 0.5;
        return (this.elapse(val) - this._elapsedExtent[0]) / elapsedSpan;
    };
    ScaleBreakContextImpl.prototype.scale = function(val) {
        return this.unelapse(val * (this._elapsedExtent[1] - this._elapsedExtent[0]) + this._elapsedExtent[0]);
    };
    /**
   * Suppose:
   *    AXIS_BREAK_LAST_BREAK_END_BASE: 0
   *    AXIS_BREAK_ELAPSED_BASE: 0
   *    breaks: [
   *        {start: -400, end: -300, gap: 27},
   *        {start: -100, end: 100, gap: 10},
   *        {start: 200, end: 400, gap: 300},
   *    ]
   * The mapping will be:
   *        |        |
   *    400 +   ->   +  237
   *     |  |        |   |  (gap: 300)
   *    200 +   ->   + -63
   *        |        |
   *    100 +   ->   + -163
   *     |  |        |   |  (gap: 10)
   *   -100 +   ->   + -173
   *        |        |
   *   -300 +   ->   + -373
   *     |  |        |   |  (gap: 27)
   *   -400 +   ->   + -400
   *        |        |
   *   origianl     elapsed
   *
   * Note:
   *   The mapping has nothing to do with "scale extent".
   */ ScaleBreakContextImpl.prototype.elapse = function(val) {
        // If the value is in the break, return the normalized value in the break
        var elapsedVal = $2339db6215b77860$var$AXIS_BREAK_ELAPSED_BASE;
        var lastBreakEnd = $2339db6215b77860$var$AXIS_BREAK_LAST_BREAK_END_BASE;
        var stillOver = true;
        for(var i = 0; i < this.breaks.length; i++){
            var brk = this.breaks[i];
            if (val <= brk.vmax) {
                if (val > brk.vmin) elapsedVal += brk.vmin - lastBreakEnd + (val - brk.vmin) / (brk.vmax - brk.vmin) * brk.gapReal;
                else elapsedVal += val - lastBreakEnd;
                lastBreakEnd = brk.vmax;
                stillOver = false;
                break;
            }
            elapsedVal += brk.vmin - lastBreakEnd + brk.gapReal;
            lastBreakEnd = brk.vmax;
        }
        if (stillOver) elapsedVal += val - lastBreakEnd;
        return elapsedVal;
    };
    ScaleBreakContextImpl.prototype.unelapse = function(elapsedVal) {
        var lastElapsedEnd = $2339db6215b77860$var$AXIS_BREAK_ELAPSED_BASE;
        var lastBreakEnd = $2339db6215b77860$var$AXIS_BREAK_LAST_BREAK_END_BASE;
        var stillOver = true;
        var unelapsedVal = 0;
        for(var i = 0; i < this.breaks.length; i++){
            var brk = this.breaks[i];
            var elapsedStart = lastElapsedEnd + brk.vmin - lastBreakEnd;
            var elapsedEnd = elapsedStart + brk.gapReal;
            if (elapsedVal <= elapsedEnd) {
                if (elapsedVal > elapsedStart) unelapsedVal = brk.vmin + (elapsedVal - elapsedStart) / (elapsedEnd - elapsedStart) * (brk.vmax - brk.vmin);
                else unelapsedVal = lastBreakEnd + elapsedVal - lastElapsedEnd;
                lastBreakEnd = brk.vmax;
                stillOver = false;
                break;
            }
            lastElapsedEnd = elapsedEnd;
            lastBreakEnd = brk.vmax;
        }
        if (stillOver) unelapsedVal = lastBreakEnd + elapsedVal - lastElapsedEnd;
        return unelapsedVal;
    };
    return ScaleBreakContextImpl;
}();
function $2339db6215b77860$var$createScaleBreakContext() {
    return new $2339db6215b77860$var$ScaleBreakContextImpl();
}
// Both can start with any finite value, and are not necessaryily equal. But they need to
// be the same in `axisBreakElapse` and `axisBreakUnelapse` respectively.
var $2339db6215b77860$var$AXIS_BREAK_ELAPSED_BASE = 0;
var $2339db6215b77860$var$AXIS_BREAK_LAST_BREAK_END_BASE = 0;
/**
 * `gapReal` in brkCtx.breaks will be calculated.
 */ function $2339db6215b77860$var$updateAxisBreakGapReal(brkCtx, scaleExtent) {
    // Considered the effect:
    //  - Use dataZoom to move some of the breaks outside the extent.
    //  - Some scenarios that `series.clip: false`.
    //
    // How to calculate `prctBrksGapRealSum`:
    //  Based on the formula:
    //      xxx.span = brk.vmax - brk.vmin
    //      xxx.tpPrct.val / xxx.tpAbs.val means ParsedAxisBreak['gapParsed']['val']
    //      .S/.E means a break that is semi in scaleExtent[0] or scaleExtent[1]
    //      valP = (
    //          + (fullyInExtBrksSum.tpAbs.gapReal - fullyInExtBrksSum.tpAbs.span)
    //          + (semiInExtBrk.S.tpAbs.gapReal - semiInExtBrk.S.tpAbs.span) * semiInExtBrk.S.tpAbs.inExtFrac
    //          + (semiInExtBrk.E.tpAbs.gapReal - semiInExtBrk.E.tpAbs.span) * semiInExtBrk.E.tpAbs.inExtFrac
    //      )
    //      valQ = (
    //          - fullyInExtBrksSum.tpPrct.span
    //          - semiInExtBrk.S.tpPrct.span * semiInExtBrk.S.tpPrct.inExtFrac
    //          - semiInExtBrk.E.tpPrct.span * semiInExtBrk.E.tpPrct.inExtFrac
    //      )
    //      gapPrctSum = sum(xxx.tpPrct.val)
    //      gapPrctSum = prctBrksGapRealSum / (
    //          + (scaleExtent[1] - scaleExtent[0]) + valP + valQ
    //          + fullyInExtBrksSum.tpPrct.gapReal
    //          + semiInExtBrk.S.tpPrct.gapReal * semiInExtBrk.S.tpPrct.inExtFrac
    //          + semiInExtBrk.E.tpPrct.gapReal * semiInExtBrk.E.tpPrct.inExtFrac
    //      )
    //  Assume:
    //      xxx.tpPrct.gapReal = xxx.tpPrct.val / gapPrctSum * prctBrksGapRealSum
    //         (NOTE: This is not accurate when semi-in-extent break exist because its
    //         proportion is not linear, but this assumption approximately works.)
    //  Derived as follows:
    //      prctBrksGapRealSum = gapPrctSum * ( (scaleExtent[1] - scaleExtent[0]) + valP + valQ )
    //          / (1
    //              - fullyInExtBrksSum.tpPrct.val
    //              - semiInExtBrk.S.tpPrct.val * semiInExtBrk.S.tpPrct.inExtFrac
    //              - semiInExtBrk.E.tpPrct.val * semiInExtBrk.E.tpPrct.inExtFrac
    //          )
    var gapPrctSum = 0;
    var fullyInExtBrksSum = {
        tpAbs: {
            span: 0,
            val: 0
        },
        tpPrct: {
            span: 0,
            val: 0
        }
    };
    var init = function() {
        return {
            has: false,
            span: NaN,
            inExtFrac: NaN,
            val: NaN
        };
    };
    var semiInExtBrk = {
        S: {
            tpAbs: init(),
            tpPrct: init()
        },
        E: {
            tpAbs: init(),
            tpPrct: init()
        }
    };
    (0, $2N6Uo.each)(brkCtx.breaks, function(brk) {
        var gapParsed = brk.gapParsed;
        if (gapParsed.type === 'tpPrct') gapPrctSum += gapParsed.val;
        var clampedBrk = $2339db6215b77860$var$clampBreakByExtent(brk, scaleExtent);
        if (clampedBrk) {
            var vminClamped = clampedBrk.vmin !== brk.vmin;
            var vmaxClamped = clampedBrk.vmax !== brk.vmax;
            var clampedSpan = clampedBrk.vmax - clampedBrk.vmin;
            if (vminClamped && vmaxClamped) ;
            else if (vminClamped || vmaxClamped) {
                var sOrE = vminClamped ? 'S' : 'E';
                semiInExtBrk[sOrE][gapParsed.type].has = true;
                semiInExtBrk[sOrE][gapParsed.type].span = clampedSpan;
                semiInExtBrk[sOrE][gapParsed.type].inExtFrac = clampedSpan / (brk.vmax - brk.vmin);
                semiInExtBrk[sOrE][gapParsed.type].val = gapParsed.val;
            } else {
                fullyInExtBrksSum[gapParsed.type].span += clampedSpan;
                fullyInExtBrksSum[gapParsed.type].val += gapParsed.val;
            }
        }
    });
    var prctBrksGapRealSum = gapPrctSum * (0 + (scaleExtent[1] - scaleExtent[0]) + (fullyInExtBrksSum.tpAbs.val - fullyInExtBrksSum.tpAbs.span) + (semiInExtBrk.S.tpAbs.has ? (semiInExtBrk.S.tpAbs.val - semiInExtBrk.S.tpAbs.span) * semiInExtBrk.S.tpAbs.inExtFrac : 0) + (semiInExtBrk.E.tpAbs.has ? (semiInExtBrk.E.tpAbs.val - semiInExtBrk.E.tpAbs.span) * semiInExtBrk.E.tpAbs.inExtFrac : 0) - fullyInExtBrksSum.tpPrct.span - (semiInExtBrk.S.tpPrct.has ? semiInExtBrk.S.tpPrct.span * semiInExtBrk.S.tpPrct.inExtFrac : 0) - (semiInExtBrk.E.tpPrct.has ? semiInExtBrk.E.tpPrct.span * semiInExtBrk.E.tpPrct.inExtFrac : 0)) / (1 - fullyInExtBrksSum.tpPrct.val - (semiInExtBrk.S.tpPrct.has ? semiInExtBrk.S.tpPrct.val * semiInExtBrk.S.tpPrct.inExtFrac : 0) - (semiInExtBrk.E.tpPrct.has ? semiInExtBrk.E.tpPrct.val * semiInExtBrk.E.tpPrct.inExtFrac : 0));
    (0, $2N6Uo.each)(brkCtx.breaks, function(brk) {
        var gapParsed = brk.gapParsed;
        if (gapParsed.type === 'tpPrct') brk.gapReal = gapPrctSum !== 0 ? Math.max(prctBrksGapRealSum, 0) * gapParsed.val / gapPrctSum : 0;
        if (gapParsed.type === 'tpAbs') brk.gapReal = gapParsed.val;
        if (brk.gapReal == null) brk.gapReal = 0;
    });
}
function $2339db6215b77860$var$pruneTicksByBreak(pruneByBreak, ticks, breaks, getValue, interval, scaleExtent) {
    if (pruneByBreak === 'no') return;
    (0, $2N6Uo.each)(breaks, function(brk) {
        // break.vmin/vmax that out of extent must not impact the visible of
        // normal ticks and labels.
        var clampedBrk = $2339db6215b77860$var$clampBreakByExtent(brk, scaleExtent);
        if (!clampedBrk) return;
        // Remove some normal ticks to avoid zigzag shapes overlapping with split lines
        // and to avoid break labels overlapping with normal tick labels (thouth it can
        // also be avoided by `axisLabel.hideOverlap`).
        // It's OK to O(n^2) since the number of `ticks` are small.
        for(var j = ticks.length - 1; j >= 0; j--){
            var tick = ticks[j];
            var val = getValue(tick);
            // 1. Ensure there is no ticks inside `break.vmin` and `break.vmax`.
            // 2. Use an empirically gap value here. Theoritically `zigzagAmplitude` is
            //  supposed to be involved to provide better precision but it will brings
            //  more complexity. The empirically gap value is conservative because break
            //  labels and normal tick lables are prone to overlapping.
            var gap = interval * 3 / 4;
            if (val > clampedBrk.vmin - gap && val < clampedBrk.vmax + gap && (pruneByBreak !== 'preserve_extent_bound' || val !== scaleExtent[0] && val !== scaleExtent[1])) ticks.splice(j, 1);
        }
    });
}
function $2339db6215b77860$var$addBreaksToTicks(// The input ticks should be in accending order.
ticks, breaks, scaleExtent, // Keep the break ends at the same level to avoid an awkward appearance.
getTimeProps) {
    (0, $2N6Uo.each)(breaks, function(brk) {
        var clampedBrk = $2339db6215b77860$var$clampBreakByExtent(brk, scaleExtent);
        if (!clampedBrk) return;
        // - When neight `break.vmin` nor `break.vmax` is in scale extent,
        //  break label should not be displayed and we do not add them to the result.
        // - When only one of `break.vmin` and `break.vmax` is inside the extent and the
        //  other is outsite, we comply with the extent and display only part of the breaks area,
        //  because the extent might be determined by user settings (such as `axis.min/max`)
        ticks.push({
            value: clampedBrk.vmin,
            "break": {
                type: 'vmin',
                parsedBreak: clampedBrk
            },
            time: getTimeProps ? getTimeProps(clampedBrk) : undefined
        });
        // When gap is 0, start tick overlap with end tick, but we still count both of them. Break
        // area shape can address that overlapping. `axisLabel` need draw both start and end separately,
        // otherwise it brings complexity to the logic of label overlapping resolving (e.g., when label
        // rotated), and introduces inconsistency to users in `axisLabel.formatter` between gap is 0 or not.
        ticks.push({
            value: clampedBrk.vmax,
            "break": {
                type: 'vmax',
                parsedBreak: clampedBrk
            },
            time: getTimeProps ? getTimeProps(clampedBrk) : undefined
        });
    });
    if (breaks.length) ticks.sort(function(a, b) {
        return a.value - b.value;
    });
}
/**
 * If break and extent does not intersect, return null/undefined.
 * If the intersection is only a point at scaleExtent[0] or scaleExtent[1], return null/undefined.
 */ function $2339db6215b77860$var$clampBreakByExtent(brk, scaleExtent) {
    var vmin = Math.max(brk.vmin, scaleExtent[0]);
    var vmax = Math.min(brk.vmax, scaleExtent[1]);
    return vmin < vmax || vmin === vmax && vmin > scaleExtent[0] && vmin < scaleExtent[1] ? {
        vmin: vmin,
        vmax: vmax,
        breakOption: brk.breakOption,
        gapParsed: brk.gapParsed,
        gapReal: brk.gapReal
    } : null;
}
function $2339db6215b77860$var$parseAxisBreakOption(// raw user input breaks, retrieved from axis model.
breakOptionList, parse, opt) {
    var parsedBreaks = [];
    if (!breakOptionList) return {
        breaks: parsedBreaks
    };
    function validatePercent(normalizedPercent, msg) {
        if (normalizedPercent >= 0 && normalizedPercent < 1 - 1e-5) // Avoid division error.
        return true;
        return false;
    }
    (0, $2N6Uo.each)(breakOptionList, function(brkOption) {
        if (!brkOption || brkOption.start == null || brkOption.end == null) return;
        if (brkOption.isExpanded) return;
        var parsedBrk = {
            breakOption: (0, $2N6Uo.clone)(brkOption),
            vmin: parse(brkOption.start),
            vmax: parse(brkOption.end),
            gapParsed: {
                type: 'tpAbs',
                val: 0
            },
            gapReal: null
        };
        if (brkOption.gap != null) {
            var isPrct = false;
            if ((0, $2N6Uo.isString)(brkOption.gap)) {
                var trimmedGap = (0, $2N6Uo.trim)(brkOption.gap);
                if (trimmedGap.match(/%$/)) {
                    var normalizedPercent = parseFloat(trimmedGap) / 100;
                    if (!validatePercent(normalizedPercent, 'Percent gap')) normalizedPercent = 0;
                    parsedBrk.gapParsed.type = 'tpPrct';
                    parsedBrk.gapParsed.val = normalizedPercent;
                    isPrct = true;
                }
            }
            if (!isPrct) {
                var absolute = parse(brkOption.gap);
                if (!isFinite(absolute) || absolute < 0) absolute = 0;
                parsedBrk.gapParsed.type = 'tpAbs';
                parsedBrk.gapParsed.val = absolute;
            }
        }
        if (parsedBrk.vmin === parsedBrk.vmax) {
            parsedBrk.gapParsed.type = 'tpAbs';
            parsedBrk.gapParsed.val = 0;
        }
        if (opt && opt.noNegative) (0, $2N6Uo.each)([
            'vmin',
            'vmax'
        ], function(se) {
            if (parsedBrk[se] < 0) parsedBrk[se] = 0;
        });
        // Ascending numerical order is the prerequisite of the calculation in Scale#normalize.
        // User are allowed to input desending vmin/vmax for simplifying the usage.
        if (parsedBrk.vmin > parsedBrk.vmax) {
            var tmp = parsedBrk.vmax;
            parsedBrk.vmax = parsedBrk.vmin;
            parsedBrk.vmin = tmp;
        }
        parsedBreaks.push(parsedBrk);
    });
    // Ascending numerical order is the prerequisite of the calculation in Scale#normalize.
    parsedBreaks.sort(function(item1, item2) {
        return item1.vmin - item2.vmin;
    });
    // Make sure that the intervals in breaks are not overlap.
    var lastEnd = -Infinity;
    (0, $2N6Uo.each)(parsedBreaks, function(brk, idx) {
        if (lastEnd > brk.vmin) parsedBreaks[idx] = null;
        lastEnd = brk.vmax;
    });
    return {
        breaks: parsedBreaks.filter(function(brk) {
            return !!brk;
        })
    };
}
function $2339db6215b77860$var$identifyAxisBreak(brk, identifier) {
    return $2339db6215b77860$var$serializeAxisBreakIdentifier(identifier) === $2339db6215b77860$var$serializeAxisBreakIdentifier(brk);
}
function $2339db6215b77860$var$serializeAxisBreakIdentifier(identifier) {
    // We use user input start/end to identify break. Considered cases like `start: new Date(xxx)`,
    // Theoretically `Scale#parse` should be used here, but not used currently to reduce dependencies,
    // since simply converting to string happens to be correct.
    return identifier.start + '_\0_' + identifier.end;
}
/**
 * - A break pair represents `[vmin, vmax]`,
 * - Only both vmin and vmax item exist, they are counted as a pair.
 */ function $2339db6215b77860$var$retrieveAxisBreakPairs(itemList, getVisualAxisBreak, returnIdx) {
    var idxPairList = [];
    (0, $2N6Uo.each)(itemList, function(el, idx) {
        var vBreak = getVisualAxisBreak(el);
        if (vBreak && vBreak.type === 'vmin') idxPairList.push([
            idx
        ]);
    });
    (0, $2N6Uo.each)(itemList, function(el, idx) {
        var vBreak = getVisualAxisBreak(el);
        if (vBreak && vBreak.type === 'vmax') {
            var idxPair = (0, $2N6Uo.find)(idxPairList, // parsedBreak may be changed, can only use breakOption to match them.
            function(pr) {
                return $2339db6215b77860$var$identifyAxisBreak(getVisualAxisBreak(itemList[pr[0]]).parsedBreak.breakOption, vBreak.parsedBreak.breakOption);
            });
            idxPair && idxPair.push(idx);
        }
    });
    var result = [];
    (0, $2N6Uo.each)(idxPairList, function(idxPair) {
        if (idxPair.length === 2) result.push(returnIdx ? idxPair : [
            itemList[idxPair[0]],
            itemList[idxPair[1]]
        ]);
    });
    return result;
}
function $2339db6215b77860$var$getTicksLogTransformBreak(tick, logBase, logOriginalBreaks, fixRoundingError) {
    var vBreak;
    var brkRoundingCriterion;
    if (tick["break"]) {
        var brk = tick["break"].parsedBreak;
        var originalBreak = (0, $2N6Uo.find)(logOriginalBreaks, function(brk) {
            return $2339db6215b77860$var$identifyAxisBreak(brk.breakOption, tick["break"].parsedBreak.breakOption);
        });
        var vmin = fixRoundingError(Math.pow(logBase, brk.vmin), originalBreak.vmin);
        var vmax = fixRoundingError(Math.pow(logBase, brk.vmax), originalBreak.vmax);
        var gapParsed = {
            type: brk.gapParsed.type,
            val: brk.gapParsed.type === 'tpAbs' ? (0, $iCU10.round)(Math.pow(logBase, brk.vmin + brk.gapParsed.val)) - vmin : brk.gapParsed.val
        };
        vBreak = {
            type: tick["break"].type,
            parsedBreak: {
                breakOption: brk.breakOption,
                vmin: vmin,
                vmax: vmax,
                gapParsed: gapParsed,
                gapReal: brk.gapReal
            }
        };
        brkRoundingCriterion = originalBreak[tick["break"].type];
    }
    return {
        brkRoundingCriterion: brkRoundingCriterion,
        vBreak: vBreak
    };
}
function $2339db6215b77860$var$logarithmicParseBreaksFromOption(breakOptionList, logBase, parse) {
    var opt = {
        noNegative: true
    };
    var parsedOriginal = $2339db6215b77860$var$parseAxisBreakOption(breakOptionList, parse, opt);
    var parsedLogged = $2339db6215b77860$var$parseAxisBreakOption(breakOptionList, parse, opt);
    var loggedBase = Math.log(logBase);
    parsedLogged.breaks = (0, $2N6Uo.map)(parsedLogged.breaks, function(brk) {
        var vmin = Math.log(brk.vmin) / loggedBase;
        var vmax = Math.log(brk.vmax) / loggedBase;
        var gapParsed = {
            type: brk.gapParsed.type,
            val: brk.gapParsed.type === 'tpAbs' ? Math.log(brk.vmin + brk.gapParsed.val) / loggedBase - vmin : brk.gapParsed.val
        };
        return {
            vmin: vmin,
            vmax: vmax,
            gapParsed: gapParsed,
            gapReal: brk.gapReal,
            breakOption: brk.breakOption
        };
    });
    return {
        parsedOriginal: parsedOriginal,
        parsedLogged: parsedLogged
    };
}
var $2339db6215b77860$var$BREAK_MIN_MAX_TO_PARAM = {
    vmin: 'start',
    vmax: 'end'
};
function $2339db6215b77860$var$makeAxisLabelFormatterParamBreak(extraParam, vBreak) {
    if (vBreak) {
        extraParam = extraParam || {};
        extraParam["break"] = {
            type: $2339db6215b77860$var$BREAK_MIN_MAX_TO_PARAM[vBreak.type],
            start: vBreak.parsedBreak.vmin,
            end: vBreak.parsedBreak.vmax
        };
    }
    return extraParam;
}
function $2339db6215b77860$export$8a93e423db92f59c() {
    (0, $bjlCM.registerScaleBreakHelperImpl)({
        createScaleBreakContext: $2339db6215b77860$var$createScaleBreakContext,
        pruneTicksByBreak: $2339db6215b77860$var$pruneTicksByBreak,
        addBreaksToTicks: $2339db6215b77860$var$addBreaksToTicks,
        parseAxisBreakOption: $2339db6215b77860$var$parseAxisBreakOption,
        identifyAxisBreak: $2339db6215b77860$var$identifyAxisBreak,
        serializeAxisBreakIdentifier: $2339db6215b77860$var$serializeAxisBreakIdentifier,
        retrieveAxisBreakPairs: $2339db6215b77860$var$retrieveAxisBreakPairs,
        getTicksLogTransformBreak: $2339db6215b77860$var$getTicksLogTransformBreak,
        logarithmicParseBreaksFromOption: $2339db6215b77860$var$logarithmicParseBreaksFromOption,
        makeAxisLabelFormatterParamBreak: $2339db6215b77860$var$makeAxisLabelFormatterParamBreak
    });
}

});

parcelRegister("fHwIR", function(module, exports) {

$parcel$export(module.exports, "installAxisBreakHelper", function () { return $b6e4412a7dc4dd2d$export$6ecf2ccbc1d386b1; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $bjlCM = parcelRequire("bjlCM");

var $fcwet = parcelRequire("fcwet");

var $U1aqY = parcelRequire("U1aqY");

var $19Ywy = parcelRequire("19Ywy");

var $2OQYM = parcelRequire("2OQYM");

var $g4Fz3 = parcelRequire("g4Fz3");

var $Etgh3 = parcelRequire("Etgh3");


var $iQonF = parcelRequire("iQonF");parcelRequire("h9U3p");
var $c3CaY = parcelRequire("c3CaY");
var $hXTRG = parcelRequire("hXTRG");
var $ewDYK = parcelRequire("ewDYK");
var $h9U3p = parcelRequire("h9U3p");
var $9KN3M = parcelRequire("9KN3M");
/**
 * @caution
 *  Must not export anything except `installAxisBreakHelper`
 */ /**
 * The zigzag shapes for axis breaks are generated according to some random
 * factors. It should persist as much as possible to avoid constantly
 * changing by every user operation.
 */ var $b6e4412a7dc4dd2d$var$viewCache = (0, $bx3T8.makeInner)();
function $b6e4412a7dc4dd2d$var$ensureVisualInCache(visualList, targetBreak) {
    var visual = (0, $2N6Uo.find)(visualList, function(item) {
        return (0, $bjlCM.getScaleBreakHelper)().identifyAxisBreak(item.parsedBreak.breakOption, targetBreak.breakOption);
    });
    if (!visual) visualList.push(visual = {
        zigzagRandomList: [],
        parsedBreak: targetBreak,
        shouldRemove: false
    });
    return visual;
}
function $b6e4412a7dc4dd2d$var$resetCacheVisualRemoveFlag(visualList) {
    (0, $2N6Uo.each)(visualList, function(item) {
        return item.shouldRemove = true;
    });
}
function $b6e4412a7dc4dd2d$var$removeUnusedCacheVisual(visualList) {
    for(var i = visualList.length - 1; i >= 0; i--)if (visualList[i].shouldRemove) visualList.splice(i, 1);
}
function $b6e4412a7dc4dd2d$var$rectCoordBuildBreakAxis(axisGroup, axisView, axisModel, coordSysRect, api) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank() || !(0, $bjlCM.getScaleBreakHelper)()) return;
    var breakPairs = (0, $bjlCM.getScaleBreakHelper)().retrieveAxisBreakPairs(axis.scale.getTicks({
        breakTicks: 'only_break'
    }), function(tick) {
        return tick["break"];
    }, false);
    if (!breakPairs.length) return;
    var breakAreaModel = axisModel.getModel('breakArea');
    var zigzagAmplitude = breakAreaModel.get('zigzagAmplitude');
    var zigzagMinSpan = breakAreaModel.get('zigzagMinSpan');
    var zigzagMaxSpan = breakAreaModel.get('zigzagMaxSpan');
    // Use arbitrary value to avoid dead loop if user gives inappropriate settings.
    zigzagMinSpan = Math.max(2, zigzagMinSpan || 0);
    zigzagMaxSpan = Math.max(zigzagMinSpan, zigzagMaxSpan || 0);
    var expandOnClick = breakAreaModel.get('expandOnClick');
    var zigzagZ = breakAreaModel.get('zigzagZ');
    var itemStyleModel = breakAreaModel.getModel('itemStyle');
    var itemStyle = itemStyleModel.getItemStyle();
    var borderColor = itemStyle.stroke;
    var borderWidth = itemStyle.lineWidth;
    var borderType = itemStyle.lineDash;
    var color = itemStyle.fill;
    var group = new (0, $iQonF.default)({
        ignoreModelZ: true
    });
    var isAxisHorizontal = axis.isHorizontal();
    var cachedVisualList = $b6e4412a7dc4dd2d$var$viewCache(axisView).visualList || ($b6e4412a7dc4dd2d$var$viewCache(axisView).visualList = []);
    $b6e4412a7dc4dd2d$var$resetCacheVisualRemoveFlag(cachedVisualList);
    var _loop_1 = function(i) {
        var parsedBreak = breakPairs[i][0]["break"].parsedBreak;
        // Even if brk.gap is 0, we should also draw the breakArea because
        // border is sometimes required to be visible (as a line)
        var coords = [];
        coords[0] = axis.toGlobalCoord(axis.dataToCoord(parsedBreak.vmin, true));
        coords[1] = axis.toGlobalCoord(axis.dataToCoord(parsedBreak.vmax, true));
        if (coords[1] < coords[0]) coords.reverse();
        var cachedVisual = $b6e4412a7dc4dd2d$var$ensureVisualInCache(cachedVisualList, parsedBreak);
        cachedVisual.shouldRemove = false;
        var breakGroup = new (0, $iQonF.default)();
        addZigzagShapes(cachedVisual.zigzagRandomList, breakGroup, coords[0], coords[1], isAxisHorizontal, parsedBreak);
        if (expandOnClick) breakGroup.on('click', function() {
            var payload = {
                type: (0, $2OQYM.AXIS_BREAK_EXPAND_ACTION_TYPE),
                breaks: [
                    {
                        start: parsedBreak.breakOption.start,
                        end: parsedBreak.breakOption.end
                    }
                ]
            };
            payload[axis.dim + "AxisIndex"] = axisModel.componentIndex;
            api.dispatchAction(payload);
        });
        breakGroup.silent = !expandOnClick;
        group.add(breakGroup);
    };
    for(var i = 0; i < breakPairs.length; i++)_loop_1(i);
    axisGroup.add(group);
    $b6e4412a7dc4dd2d$var$removeUnusedCacheVisual(cachedVisualList);
    function addZigzagShapes(zigzagRandomList, breakGroup, startCoord, endCoord, isAxisHorizontal, trimmedBreak) {
        var polylineStyle = {
            stroke: borderColor,
            lineWidth: borderWidth,
            lineDash: borderType,
            fill: 'none'
        };
        var dimBrk = isAxisHorizontal ? 0 : 1;
        var dimZigzag = 1 - dimBrk;
        var zigzagCoordMax = coordSysRect[(0, $h9U3p.XY)[dimZigzag]] + coordSysRect[(0, $h9U3p.WH)[dimZigzag]];
        // Apply `subPixelOptimizeLine` for alignning with break ticks.
        function subPixelOpt(brkCoord) {
            var pBrk = [];
            var dummyP = [];
            pBrk[dimBrk] = dummyP[dimBrk] = brkCoord;
            pBrk[dimZigzag] = coordSysRect[(0, $h9U3p.XY)[dimZigzag]];
            dummyP[dimZigzag] = zigzagCoordMax;
            var dummyShape = {
                x1: pBrk[0],
                y1: pBrk[1],
                x2: dummyP[0],
                y2: dummyP[1]
            };
            (0, $fcwet.subPixelOptimizeLine)(dummyShape, dummyShape, {
                lineWidth: 1
            });
            pBrk[0] = dummyShape.x1;
            pBrk[1] = dummyShape.y1;
            return pBrk[dimBrk];
        }
        startCoord = subPixelOpt(startCoord);
        endCoord = subPixelOpt(endCoord);
        var pointsA = [];
        var pointsB = [];
        var isSwap = true;
        var current = coordSysRect[(0, $h9U3p.XY)[dimZigzag]];
        for(var idx = 0;; idx++){
            // Use `isFirstPoint` `isLastPoint` to ensure the intersections between zigzag
            // and axis are precise, thus it can join its axis tick correctly.
            var isFirstPoint = current === coordSysRect[(0, $h9U3p.XY)[dimZigzag]];
            var isLastPoint = current >= zigzagCoordMax;
            if (isLastPoint) current = zigzagCoordMax;
            var pA = [];
            var pB = [];
            pA[dimBrk] = startCoord;
            pB[dimBrk] = endCoord;
            if (!isFirstPoint && !isLastPoint) {
                pA[dimBrk] += isSwap ? -zigzagAmplitude : zigzagAmplitude;
                pB[dimBrk] -= !isSwap ? -zigzagAmplitude : zigzagAmplitude;
            }
            pA[dimZigzag] = current;
            pB[dimZigzag] = current;
            pointsA.push(pA);
            pointsB.push(pB);
            var randomVal = void 0;
            if (idx < zigzagRandomList.length) randomVal = zigzagRandomList[idx];
            else {
                randomVal = Math.random();
                zigzagRandomList.push(randomVal);
            }
            current += randomVal * (zigzagMaxSpan - zigzagMinSpan) + zigzagMinSpan;
            isSwap = !isSwap;
            if (isLastPoint) break;
        }
        var anidSuffix = (0, $bjlCM.getScaleBreakHelper)().serializeAxisBreakIdentifier(trimmedBreak.breakOption);
        // Create two polylines and add them to the breakGroup
        breakGroup.add(new (0, $ewDYK.default)({
            anid: "break_a_" + anidSuffix,
            shape: {
                points: pointsA
            },
            style: polylineStyle,
            z: zigzagZ
        }));
        /* Add the second polyline and a polygon only if the gap is not zero
     * Otherwise if the polyline is with dashed line or being opaque,
     * it may not be constant with breaks with non-zero gaps. */ if (trimmedBreak.gapReal !== 0) {
            breakGroup.add(new (0, $ewDYK.default)({
                anid: "break_b_" + anidSuffix,
                shape: {
                    // Not reverse to keep the dash stable when dragging resizing.
                    points: pointsB
                },
                style: polylineStyle,
                z: zigzagZ
            }));
            // Creating the polygon that fills the area between the polylines
            // From end to start for polygon.
            var pointsB2 = pointsB.slice();
            pointsB2.reverse();
            var polygonPoints = pointsA.concat(pointsB2);
            breakGroup.add(new (0, $hXTRG.default)({
                anid: "break_c_" + anidSuffix,
                shape: {
                    points: polygonPoints
                },
                style: {
                    fill: color,
                    opacity: itemStyle.opacity
                },
                z: zigzagZ
            }));
        }
    }
}
function $b6e4412a7dc4dd2d$var$buildAxisBreakLine(axisModel, group, transformGroup, pathBaseProp) {
    var axis = axisModel.axis;
    var transform = transformGroup.transform;
    (0, $2N6Uo.assert)(pathBaseProp.style);
    var extent = axis.getExtent();
    if (axis.inverse) {
        extent = extent.slice();
        extent.reverse();
    }
    var breakPairs = (0, $bjlCM.getScaleBreakHelper)().retrieveAxisBreakPairs(axis.scale.getTicks({
        breakTicks: 'only_break'
    }), function(tick) {
        return tick["break"];
    }, false);
    var brkLayoutList = (0, $2N6Uo.map)(breakPairs, function(breakPair) {
        var parsedBreak = breakPair[0]["break"].parsedBreak;
        var coordPair = [
            axis.dataToCoord(parsedBreak.vmin, true),
            axis.dataToCoord(parsedBreak.vmax, true)
        ];
        coordPair[0] > coordPair[1] && coordPair.reverse();
        return {
            coordPair: coordPair,
            brkId: (0, $bjlCM.getScaleBreakHelper)().serializeAxisBreakIdentifier(parsedBreak.breakOption)
        };
    });
    brkLayoutList.sort(function(layout1, layout2) {
        return layout1.coordPair[0] - layout2.coordPair[0];
    });
    var ySegMin = extent[0];
    var lastLayout = null;
    for(var idx = 0; idx < brkLayoutList.length; idx++){
        var layout = brkLayoutList[idx];
        var brkTirmmedMin = Math.max(layout.coordPair[0], extent[0]);
        var brkTirmmedMax = Math.min(layout.coordPair[1], extent[1]);
        if (ySegMin <= brkTirmmedMin) addSeg(ySegMin, brkTirmmedMin, lastLayout, layout);
        ySegMin = brkTirmmedMax;
        lastLayout = layout;
    }
    if (ySegMin <= extent[1]) addSeg(ySegMin, extent[1], lastLayout, null);
    function addSeg(min, max, layout1, layout2) {
        function trans(p1, p2) {
            if (transform) {
                (0, $U1aqY.applyTransform)(p1, p1, transform);
                (0, $U1aqY.applyTransform)(p2, p2, transform);
            }
        }
        function subPixelOptimizePP(p1, p2) {
            var shape = {
                x1: p1[0],
                y1: p1[1],
                x2: p2[0],
                y2: p2[1]
            };
            (0, $fcwet.subPixelOptimizeLine)(shape, shape, pathBaseProp.style);
            p1[0] = shape.x1;
            p1[1] = shape.y1;
            p2[0] = shape.x2;
            p2[1] = shape.y2;
        }
        var lineP1 = [
            min,
            0
        ];
        var lineP2 = [
            max,
            0
        ];
        // dummy tick is used to align the line segment ends with axis ticks
        // after `subPixelOptimizeLine` being applied.
        var dummyTickEnd1 = [
            min,
            5
        ];
        var dummyTickEnd2 = [
            max,
            5
        ];
        trans(lineP1, dummyTickEnd1);
        subPixelOptimizePP(lineP1, dummyTickEnd1);
        trans(lineP2, dummyTickEnd2);
        subPixelOptimizePP(lineP2, dummyTickEnd2);
        // Apply it keeping the same as the normal axis line.
        subPixelOptimizePP(lineP1, lineP2);
        var seg = new (0, $c3CaY.default)((0, $2N6Uo.extend)({
            shape: {
                x1: lineP1[0],
                y1: lineP1[1],
                x2: lineP2[0],
                y2: lineP2[1]
            }
        }, pathBaseProp));
        group.add(seg);
        // Animation should be precise to be consistent with tick and split line animation.
        seg.anid = "breakLine_" + (layout1 ? layout1.brkId : '\0') + "_\0_" + (layout2 ? layout2.brkId : '\0');
    }
}
/**
 * Resolve the overlap of a pair of labels.
 *
 * [CAUTION] Only label.x/y are allowed to change.
 */ function $b6e4412a7dc4dd2d$var$adjustBreakLabelPair(axisInverse, axisRotation, layoutPair) {
    if ((0, $2N6Uo.find)(layoutPair, function(item) {
        return !item;
    })) return;
    var mtv = new (0, $9KN3M.default)();
    if (!(0, $g4Fz3.labelIntersect)(layoutPair[0], layoutPair[1], mtv, {
        // Assert `labelPair` is `[break_min, break_max]`.
        // `axis.inverse: true` means a smaller scale value corresponds to a bigger value in axis.extent.
        // The axisRotation indicates mtv direction of OBB intersecting.
        direction: -(axisInverse ? axisRotation + Math.PI : axisRotation),
        touchThreshold: 0,
        // If need to resovle intersection align axis by moving labels according to MTV,
        // the direction must not be opposite, otherwise cause misleading.
        bidirectional: false
    })) return;
    // Rotate axis back to (1, 0) direction, to be a standard axis.
    var axisStTrans = $19Ywy.create();
    $19Ywy.rotate(axisStTrans, axisStTrans, -axisRotation);
    var labelPairStTrans = (0, $2N6Uo.map)(layoutPair, function(layout) {
        return layout.transform ? $19Ywy.mul($19Ywy.create(), axisStTrans, layout.transform) : axisStTrans;
    });
    function isParallelToAxis(whIdx) {
        // Assert label[0] and label[1] has the same rotation, so only use [0].
        var localRect = layoutPair[0].localRect;
        var labelVec0 = new (0, $9KN3M.default)(localRect[(0, $h9U3p.WH)[whIdx]] * labelPairStTrans[0][0], localRect[(0, $h9U3p.WH)[whIdx]] * labelPairStTrans[0][1]);
        return Math.abs(labelVec0.y) < 1e-5;
    }
    // If overlapping, move pair[0] pair[1] apart a little. We need to calculate a ratio k to
    // distribute mtv to pair[0] and pair[1]. This is to place the text gap as close as possible
    // to the center of the break ticks, otherwise it might looks weird or misleading.
    // - When labels' width/height are not parallel to axis (usually by rotation),
    //  we can simply treat the k as `0.5`.
    var k = 0.5;
    // - When labels' width/height are parallel to axis, the width/height need to be considered,
    //  since they may differ significantly. In this case we keep textAlign as 'center' rather
    //  than 'left'/'right', due to considerations of space utilization for wide break.gap.
    //  A sample case: break on xAxis(no inverse) is [200, 300000].
    //  We calculate k based on the formula below:
    //      Rotated axis and labels to the direction of (1, 0).
    //      uval = ( (pair[0].insidePt - mtv*k) + (pair[1].insidePt + mtv*(1-k)) ) / 2 - brkCenter
    //      0 <= k <= 1
    //      |uval| should be as small as possible.
    //  Derived as follows:
    //      qval = (pair[0].insidePt + pair[1].insidePt + mtv) / 2 - brkCenter
    //      k = (qval - uval) / mtv
    //      min(qval, qval-mtv) <= uval <= max(qval, qval-mtv)
    if (isParallelToAxis(0) || isParallelToAxis(1)) {
        var rectSt = (0, $2N6Uo.map)(layoutPair, function(layout, idx) {
            var rect = layout.localRect.clone();
            rect.applyTransform(labelPairStTrans[idx]);
            return rect;
        });
        var brkCenterSt = new (0, $9KN3M.default)();
        brkCenterSt.copy(layoutPair[0].label).add(layoutPair[1].label).scale(0.5);
        brkCenterSt.transform(axisStTrans);
        var mtvSt = mtv.clone().transform(axisStTrans);
        var insidePtSum = rectSt[0].x + rectSt[1].x + (mtvSt.x >= 0 ? rectSt[0].width : rectSt[1].width);
        var qval = (insidePtSum + mtvSt.x) / 2 - brkCenterSt.x;
        var uvalMin = Math.min(qval, qval - mtvSt.x);
        var uvalMax = Math.max(qval, qval - mtvSt.x);
        var uval = uvalMax < 0 ? uvalMax : uvalMin > 0 ? uvalMin : 0;
        k = (qval - uval) / mtvSt.x;
    }
    var delta0 = new (0, $9KN3M.default)();
    var delta1 = new (0, $9KN3M.default)();
    (0, $9KN3M.default).scale(delta0, mtv, -k);
    (0, $9KN3M.default).scale(delta1, mtv, 1 - k);
    (0, $g4Fz3.labelLayoutApplyTranslation)(layoutPair[0], delta0);
    (0, $g4Fz3.labelLayoutApplyTranslation)(layoutPair[1], delta1);
}
function $b6e4412a7dc4dd2d$var$updateModelAxisBreak(model, payload) {
    var result = {
        breaks: []
    };
    (0, $2N6Uo.each)(payload.breaks, function(inputBrk) {
        if (!inputBrk) return;
        var breakOption = (0, $2N6Uo.find)(model.get('breaks', true), function(brkOption) {
            return (0, $bjlCM.getScaleBreakHelper)().identifyAxisBreak(brkOption, inputBrk);
        });
        if (!breakOption) return;
        var actionType = payload.type;
        var old = {
            isExpanded: !!breakOption.isExpanded
        };
        breakOption.isExpanded = actionType === (0, $2OQYM.AXIS_BREAK_EXPAND_ACTION_TYPE) ? true : actionType === (0, $2OQYM.AXIS_BREAK_COLLAPSE_ACTION_TYPE) ? false : actionType === (0, $2OQYM.AXIS_BREAK_TOGGLE_ACTION_TYPE) ? !breakOption.isExpanded : breakOption.isExpanded;
        result.breaks.push({
            start: breakOption.start,
            end: breakOption.end,
            isExpanded: !!breakOption.isExpanded,
            old: old
        });
    });
    return result;
}
function $b6e4412a7dc4dd2d$export$6ecf2ccbc1d386b1() {
    (0, $Etgh3.registerAxisBreakHelperImpl)({
        adjustBreakLabelPair: $b6e4412a7dc4dd2d$var$adjustBreakLabelPair,
        buildAxisBreakLine: $b6e4412a7dc4dd2d$var$buildAxisBreakLine,
        rectCoordBuildBreakAxis: $b6e4412a7dc4dd2d$var$rectCoordBuildBreakAxis,
        updateModelAxisBreak: $b6e4412a7dc4dd2d$var$updateModelAxisBreak
    });
}

});


parcelRegister("eahBS", function(module, exports) {

$parcel$export(module.exports, "installLabelLayout", function () { return $a4ffa8ccf6c67a01$export$5320d1b3745c02a5; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bx3T8 = parcelRequire("bx3T8");

var $5WJAA = parcelRequire("5WJAA");
var $a4ffa8ccf6c67a01$var$getLabelManager = (0, $bx3T8.makeInner)();
function $a4ffa8ccf6c67a01$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $a4ffa8ccf6c67a01$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $a4ffa8ccf6c67a01$var$getLabelManager(api).labelManager = new (0, $5WJAA.default)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
        var labelManager = $a4ffa8ccf6c67a01$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}

});
parcelRegister("5WJAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4545bb8dc64d7a9b$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.
parcelRequire("h9U3p");
var $67W72 = parcelRequire("67W72");
var $ipprj = parcelRequire("ipprj");
var $ipprj = parcelRequire("ipprj");

var $6TSUP = parcelRequire("6TSUP");

var $iCU10 = parcelRequire("iCU10");

var $erz95 = parcelRequire("erz95");

var $ctvp5 = parcelRequire("ctvp5");

var $bx3T8 = parcelRequire("bx3T8");

var $2N6Uo = parcelRequire("2N6Uo");

var $g4Fz3 = parcelRequire("g4Fz3");

var $bysmE = parcelRequire("bysmE");

var $3HvzJ = parcelRequire("3HvzJ");
function $4545bb8dc64d7a9b$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $4545bb8dc64d7a9b$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $4545bb8dc64d7a9b$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $4545bb8dc64d7a9b$var$LABEL_OPTION_TO_STYLE_KEYS = [
    'align',
    'verticalAlign',
    'width',
    'height',
    'fontSize'
];
var $4545bb8dc64d7a9b$var$dummyTransformable = new (0, $erz95.default)();
var $4545bb8dc64d7a9b$var$labelLayoutInnerStore = (0, $bx3T8.makeInner)();
var $4545bb8dc64d7a9b$var$labelLineAnimationStore = (0, $bx3T8.makeInner)();
function $4545bb8dc64d7a9b$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $4545bb8dc64d7a9b$var$LABEL_LAYOUT_PROPS = [
    'x',
    'y',
    'rotation'
];
var $4545bb8dc64d7a9b$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOptionOrCb) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {};
        // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $67W72.default).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $4545bb8dc64d7a9b$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $4545bb8dc64d7a9b$var$dummyTransformable.x = $4545bb8dc64d7a9b$var$dummyTransformable.y = $4545bb8dc64d7a9b$var$dummyTransformable.rotation = $4545bb8dc64d7a9b$var$dummyTransformable.originX = $4545bb8dc64d7a9b$var$dummyTransformable.originY = 0;
            $4545bb8dc64d7a9b$var$dummyTransformable.scaleX = $4545bb8dc64d7a9b$var$dummyTransformable.scaleY = 1;
        }
        $4545bb8dc64d7a9b$var$dummyTransformable.rotation = (0, $3HvzJ.normalizeRadian)($4545bb8dc64d7a9b$var$dummyTransformable.rotation);
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $67W72.default).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOptionOrCb: layoutOptionOrCb,
            layoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $4545bb8dc64d7a9b$var$dummyTransformable.x,
                y: $4545bb8dc64d7a9b$var$dummyTransformable.y,
                scaleX: $4545bb8dc64d7a9b$var$dummyTransformable.scaleX,
                scaleY: $4545bb8dc64d7a9b$var$dummyTransformable.scaleY,
                rotation: $4545bb8dc64d7a9b$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get('labelLayout');
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $2N6Uo.isFunction)(layoutOption) || (0, $2N6Uo.keys)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
            // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $6TSUP.getECData)(child);
            // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $ctvp5.updateLabelLinePoints)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0;
            // TODO A global layout option?
            if ((0, $2N6Uo.isFunction)(labelItem.layoutOptionOrCb)) layoutOption = labelItem.layoutOptionOrCb($4545bb8dc64d7a9b$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOptionOrCb;
            layoutOption = layoutOption || {};
            labelItem.layoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180;
            // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $iCU10.parsePercent)(layoutOption.x, width);
                label.setStyle('x', 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle('x', defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $iCU10.parsePercent)(layoutOption.y, height);
                label.setStyle('y', 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle('y', defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    });
                    // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $4545bb8dc64d7a9b$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $4545bb8dc64d7a9b$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $4545bb8dc64d7a9b$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = 'move';
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                }
            } else {
                // TODO Other drag functions?
                label.off('drag');
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = [];
        (0, $2N6Uo.each)(this._labelList, function(inputItem) {
            if (!inputItem.defaultAttr.ignore) labelList.push((0, $g4Fz3.newLabelLayoutWithGeometry)({}, inputItem));
        });
        var labelsNeedsAdjustOnX = (0, $2N6Uo.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftX';
        });
        var labelsNeedsAdjustOnY = (0, $2N6Uo.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftY';
        });
        (0, $g4Fz3.shiftLayoutOnXY)(labelsNeedsAdjustOnX, 0, 0, width);
        (0, $g4Fz3.shiftLayoutOnXY)(labelsNeedsAdjustOnY, 1, 0, height);
        var labelsNeedsHideOverlap = (0, $2N6Uo.filter)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $g4Fz3.restoreIgnore)(labelsNeedsHideOverlap);
        (0, $g4Fz3.hideOverlap)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $2N6Uo.each)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore && !child.forceLabelAnimation) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $4545bb8dc64d7a9b$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent();
        // Update label line style.
        var ecData = (0, $6TSUP.getECData)(el);
        var dataIndex = ecData.dataIndex;
        // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, 'style');
            if (visualStyle) {
                var visualType = data.getVisual('drawType');
                // Default to be same with main color
                defaultStyle.stroke = visualStyle[visualType];
            }
            var labelLineModel = itemModel.getModel('labelLine');
            (0, $ctvp5.setLabelLineStyle)(el, (0, $ctvp5.getLabelLineStatesModels)(itemModel), defaultStyle);
            (0, $ctvp5.updateLabelLinePoints)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine();
        // Animate
        if (textEl && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $ipprj.isElementRemoved)(el))) {
            var layoutStore = $4545bb8dc64d7a9b$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $6TSUP.getECData)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps);
                // Disable fade in animation if value animation is enabled.
                if (!(0, $bysmE.labelInner)(textEl).valueAnimation) {
                    var oldOpacity = (0, $2N6Uo.retrieve2)(textEl.style.opacity, 1);
                    // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $ipprj.initProps)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout);
                // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $2N6Uo.indexOf)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $2N6Uo.indexOf)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $ipprj.updateProps)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $4545bb8dc64d7a9b$var$extendWithKeys(layoutSelect, newProps, $4545bb8dc64d7a9b$var$LABEL_LAYOUT_PROPS);
                $4545bb8dc64d7a9b$var$extendWithKeys(layoutSelect, textEl.states.select, $4545bb8dc64d7a9b$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $4545bb8dc64d7a9b$var$extendWithKeys(layoutEmphasis, newProps, $4545bb8dc64d7a9b$var$LABEL_LAYOUT_PROPS);
                $4545bb8dc64d7a9b$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $4545bb8dc64d7a9b$var$LABEL_LAYOUT_PROPS);
            }
            (0, $bysmE.animateLabelValue)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $4545bb8dc64d7a9b$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $ipprj.initProps)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $ipprj.updateProps)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $4545bb8dc64d7a9b$export$2e2bcd8739ae039 = $4545bb8dc64d7a9b$var$LabelManager;

});


parcelRegister("5InMz", function(module, exports) {

$parcel$export(module.exports, "installLegacyGridContainLabel", function () { return $4293827d06178e51$export$81228e37d220ba46; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $67W72 = parcelRequire("67W72");

var $2N6Uo = parcelRequire("2N6Uo");

var $eaWwE = parcelRequire("eaWwE");

var $cpzWt = parcelRequire("cpzWt");

var $9AF98 = parcelRequire("9AF98");
function $4293827d06178e51$export$81228e37d220ba46() {
    (0, $eaWwE.registerLegacyGridContainLabelImpl)($4293827d06178e51$var$legacyLayOutGridByContained);
}
/**
 * The input gridRect and axes will be modified.
 */ function $4293827d06178e51$var$legacyLayOutGridByContained(axesList, gridRect) {
    (0, $2N6Uo.each)(axesList, function(axis) {
        if (!axis.model.get([
            'axisLabel',
            'inside'
        ])) {
            var labelUnionRect = $4293827d06178e51$var$estimateLabelUnionRect(axis);
            if (labelUnionRect) {
                var dim = axis.isHorizontal() ? 'height' : 'width';
                var margin = axis.model.get([
                    'axisLabel',
                    'margin'
                ]);
                gridRect[dim] -= labelUnionRect[dim] + margin;
                if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
            }
        }
    });
}
/**
 * @return Be null/undefined if no labels.
 */ function $4293827d06178e51$var$estimateLabelUnionRect(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        'axisLabel',
        'show'
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent();
    // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $cpzWt.default)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = (0, $9AF98.makeLabelFormatter)(axis);
    var rect;
    var step = 1;
    // Simple optimization for large amount of category labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
    function rotateTextRect(textRect, rotate) {
        var rotateRadians = rotate * Math.PI / 180;
        var beforeWidth = textRect.width;
        var beforeHeight = textRect.height;
        var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
        var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
        var rotatedRect = new (0, $67W72.default)(textRect.x, textRect.y, afterWidth, afterHeight);
        return rotatedRect;
    }
}

});

parcelRegister("3xe2J", function(module, exports) {

$parcel$export(module.exports, "installUniversalTransition", function () { return $292f58d51269f06b$export$efd07f28fd73e88c; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Universal transitions that can animate between any shapes(series) and any properties in any amounts.

var $49X8G = parcelRequire("49X8G");

var $2N6Uo = parcelRequire("2N6Uo");

var $gLWoJ = parcelRequire("gLWoJ");

var $4oDJM = parcelRequire("4oDJM");

var $ipprj = parcelRequire("ipprj");

var $chf3v = parcelRequire("chf3v");

var $bx3T8 = parcelRequire("bx3T8");

var $byzwF = parcelRequire("byzwF");

var $ipprj = parcelRequire("ipprj");

var $6Ekel = parcelRequire("6Ekel");
var $292f58d51269f06b$var$DATA_COUNT_THRESHOLD = 1e4;
var $292f58d51269f06b$var$TRANSITION_NONE = 0;
var $292f58d51269f06b$var$TRANSITION_P2C = 1;
var $292f58d51269f06b$var$TRANSITION_C2P = 2;
var $292f58d51269f06b$var$getUniversalTransitionGlobalStore = (0, $bx3T8.makeInner)();
function $292f58d51269f06b$var$getDimension(data, visualDimension) {
    var dimensions = data.dimensions;
    for(var i = 0; i < dimensions.length; i++){
        var dimInfo = data.getDimensionInfo(dimensions[i]);
        if (dimInfo && dimInfo.otherDims[visualDimension] === 0) return dimensions[i];
    }
}
// get value by dimension. (only get value of itemGroupId or childGroupId, so convert it to string)
function $292f58d51269f06b$var$getValueByDimension(data, dataIndex, dimension) {
    var dimInfo = data.getDimensionInfo(dimension);
    var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;
    if (dimInfo) {
        var value = data.get(dimInfo.name, dataIndex);
        if (dimOrdinalMeta) return dimOrdinalMeta.categories[value] || value + '';
        return value + '';
    }
}
function $292f58d51269f06b$var$getGroupId(data, dataIndex, dataGroupId, isChild) {
    // try to get groupId from encode
    var visualDimension = isChild ? 'itemChildGroupId' : 'itemGroupId';
    var groupIdDim = $292f58d51269f06b$var$getDimension(data, visualDimension);
    if (groupIdDim) {
        var groupId = $292f58d51269f06b$var$getValueByDimension(data, dataIndex, groupIdDim);
        return groupId;
    }
    // try to get groupId from raw data item
    var rawDataItem = data.getRawDataItem(dataIndex);
    var property = isChild ? 'childGroupId' : 'groupId';
    if (rawDataItem && rawDataItem[property]) return rawDataItem[property] + '';
    // fallback
    if (isChild) return;
    // try to use series.dataGroupId as groupId, otherwise use dataItem's id as groupId
    return dataGroupId || data.getId(dataIndex);
}
// flatten all data items from different serieses into one arrary
function $292f58d51269f06b$var$flattenDataDiffItems(list) {
    var items = [];
    (0, $2N6Uo.each)(list, function(seriesInfo) {
        var data = seriesInfo.data;
        var dataGroupId = seriesInfo.dataGroupId;
        if (data.count() > $292f58d51269f06b$var$DATA_COUNT_THRESHOLD) return;
        var indices = data.getIndices();
        for(var dataIndex = 0; dataIndex < indices.length; dataIndex++)items.push({
            data: data,
            groupId: $292f58d51269f06b$var$getGroupId(data, dataIndex, dataGroupId, false),
            childGroupId: $292f58d51269f06b$var$getGroupId(data, dataIndex, dataGroupId, true),
            divide: seriesInfo.divide,
            dataIndex: dataIndex
        });
    });
    return items;
}
function $292f58d51269f06b$var$fadeInElement(newEl, newSeries, newIndex) {
    newEl.traverse(function(el) {
        if (el instanceof (0, $4oDJM.default)) // TODO use fade in animation for target element.
        (0, $ipprj.initProps)(el, {
            style: {
                opacity: 0
            }
        }, newSeries, {
            dataIndex: newIndex,
            isFrom: true
        });
    });
}
function $292f58d51269f06b$var$removeEl(el) {
    if (el.parent) {
        // Bake parent transform to element.
        // So it can still have proper transform to transition after it's removed.
        var computedTransform = el.getComputedTransform();
        el.setLocalTransform(computedTransform);
        el.parent.remove(el);
    }
}
function $292f58d51269f06b$var$stopAnimation(el) {
    el.stopAnimation();
    if (el.isGroup) el.traverse(function(child) {
        child.stopAnimation();
    });
}
function $292f58d51269f06b$var$animateElementStyles(el, dataIndex, seriesModel) {
    var animationConfig = (0, $ipprj.getAnimationConfig)('update', seriesModel, dataIndex);
    animationConfig && el.traverse(function(child) {
        if (child instanceof (0, $6Ekel.default)) {
            var oldStyle = (0, $ipprj.getOldStyle)(child);
            if (oldStyle) child.animateFrom({
                style: oldStyle
            }, animationConfig);
        }
    });
}
function $292f58d51269f06b$var$isAllIdSame(oldDiffItems, newDiffItems) {
    var len = oldDiffItems.length;
    if (len !== newDiffItems.length) return false;
    for(var i = 0; i < len; i++){
        var oldItem = oldDiffItems[i];
        var newItem = newDiffItems[i];
        if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) return false;
    }
    return true;
}
function $292f58d51269f06b$var$transitionBetween(oldList, newList, api) {
    var oldDiffItems = $292f58d51269f06b$var$flattenDataDiffItems(oldList);
    var newDiffItems = $292f58d51269f06b$var$flattenDataDiffItems(newList);
    function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
        if (rawFrom || from) to.animateFrom({
            style: rawFrom && rawFrom !== from ? (0, $2N6Uo.extend)((0, $2N6Uo.extend)({}, rawFrom.style), from.style) : from.style
        }, animationCfg);
    }
    var hasMorphAnimation = false;
    /**
   * With groupId and childGroupId, we can build parent-child relationships between dataItems.
   * However, we should mind the parent-child "direction" between old and new options.
   *
   * For example, suppose we have two dataItems from two series.data:
   *
   * dataA: [                          dataB: [
   *   {                                 {
   *     value: 5,                         value: 3,
   *     groupId: 'creatures',             groupId: 'animals',
   *     childGroupId: 'animals'           childGroupId: 'dogs'
   *   },                                },
   *   ...                               ...
   * ]                                 ]
   *
   * where dataA is belong to optionA and dataB is belong to optionB.
   *
   * When we `setOption(optionB)` from optionA, we choose childGroupId of dataItemA and groupId of
   * dataItemB as keys so the two keys are matched (both are 'animals'), then universalTransition
   * will work. This derection is "parent -> child".
   *
   * If we `setOption(optionA)` from optionB, we also choose groupId of dataItemB and childGroupId
   * of dataItemA as keys and universalTransition will work. This derection is "child -> parent".
   *
   * If there is no childGroupId specified, which means no multiLevelDrillDown/Up is needed and no
   * parent-child relationship exists. This direction is "none".
   *
   * So we need to know whether to use groupId or childGroupId as the key when we call the keyGetter
   * functions. Thus, we need to decide the direction first.
   *
   * The rule is:
   *
   * if (all childGroupIds in oldDiffItems and all groupIds in newDiffItems have common value) {
   *   direction = 'parent -> child';
   * } else if (all groupIds in oldDiffItems and all childGroupIds in newDiffItems have common value) {
   *   direction = 'child -> parent';
   * } else {
   *   direction = 'none';
   * }
   */ var direction = $292f58d51269f06b$var$TRANSITION_NONE;
    // find all groupIds and childGroupIds from oldDiffItems
    var oldGroupIds = (0, $2N6Uo.createHashMap)();
    var oldChildGroupIds = (0, $2N6Uo.createHashMap)();
    oldDiffItems.forEach(function(item) {
        item.groupId && oldGroupIds.set(item.groupId, true);
        item.childGroupId && oldChildGroupIds.set(item.childGroupId, true);
    });
    // traverse newDiffItems and decide the direction according to the rule
    for(var i = 0; i < newDiffItems.length; i++){
        var newGroupId = newDiffItems[i].groupId;
        if (oldChildGroupIds.get(newGroupId)) {
            direction = $292f58d51269f06b$var$TRANSITION_P2C;
            break;
        }
        var newChildGroupId = newDiffItems[i].childGroupId;
        if (newChildGroupId && oldGroupIds.get(newChildGroupId)) {
            direction = $292f58d51269f06b$var$TRANSITION_C2P;
            break;
        }
    }
    function createKeyGetter(isOld, onlyGetId) {
        return function(diffItem) {
            var data = diffItem.data;
            var dataIndex = diffItem.dataIndex;
            // TODO if specified dim
            if (onlyGetId) return data.getId(dataIndex);
            if (isOld) return direction === $292f58d51269f06b$var$TRANSITION_P2C ? diffItem.childGroupId : diffItem.groupId;
            else return direction === $292f58d51269f06b$var$TRANSITION_C2P ? diffItem.childGroupId : diffItem.groupId;
        };
    }
    // Use id if it's very likely to be an one to one animation
    // It's more robust than groupId
    // TODO Check if key dimension is specified.
    var useId = $292f58d51269f06b$var$isAllIdSame(oldDiffItems, newDiffItems);
    var isElementStillInChart = {};
    if (!useId) // We may have different diff strategy with basicTransition if we use other dimension as key.
    // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
    // We can't use the elements that already being morphed. Let it keep it's original basic transition.
    for(var i = 0; i < newDiffItems.length; i++){
        var newItem = newDiffItems[i];
        var el = newItem.data.getItemGraphicEl(newItem.dataIndex);
        if (el) isElementStillInChart[el.id] = true;
    }
    function updateOneToOne(newIndex, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var newItem = newDiffItems[newIndex];
        var newSeries = newItem.data.hostModel;
        // TODO Mark this elements is morphed and don't morph them anymore
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex);
        // Can't handle same elements.
        if (oldEl === newEl) {
            newEl && $292f58d51269f06b$var$animateElementStyles(newEl, newItem.dataIndex, newSeries);
            return;
        }
        if (// We can't use the elements that already being morphed
        oldEl && isElementStillInChart[oldEl.id]) return;
        if (newEl) {
            // TODO: If keep animating the group in case
            // some of the elements don't want to be morphed.
            // TODO Label?
            $292f58d51269f06b$var$stopAnimation(newEl);
            if (oldEl) {
                $292f58d51269f06b$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $292f58d51269f06b$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $gLWoJ.applyMorphAnimation)((0, $gLWoJ.getPathList)(oldEl), (0, $gLWoJ.getPathList)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $292f58d51269f06b$var$fadeInElement(newEl, newSeries, newIndex);
        }
    // else keep oldEl leaving animation.
    }
    new (0, $chf3v.default)(oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, 'multiple').update(updateOneToOne).updateManyToOne(function(newIndex, oldIndices) {
        var newItem = newDiffItems[newIndex];
        var newData = newItem.data;
        var newSeries = newData.hostModel;
        var newEl = newData.getItemGraphicEl(newItem.dataIndex);
        var oldElsList = (0, $2N6Uo.filter)((0, $2N6Uo.map)(oldIndices, function(idx) {
            return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
        }), function(oldEl) {
            return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
        });
        if (newEl) {
            $292f58d51269f06b$var$stopAnimation(newEl);
            if (oldElsList.length) {
                // If old element is doing leaving animation. stop it and remove it immediately.
                (0, $2N6Uo.each)(oldElsList, function(oldEl) {
                    $292f58d51269f06b$var$stopAnimation(oldEl);
                    $292f58d51269f06b$var$removeEl(oldEl);
                });
                hasMorphAnimation = true;
                (0, $gLWoJ.applyMorphAnimation)((0, $gLWoJ.getPathList)(oldElsList), (0, $gLWoJ.getPathList)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $292f58d51269f06b$var$fadeInElement(newEl, newSeries, newItem.dataIndex);
        }
    // else keep oldEl leaving animation.
    }).updateOneToMany(function(newIndices, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        // We can't use the elements that already being morphed
        if (oldEl && isElementStillInChart[oldEl.id]) return;
        var newElsList = (0, $2N6Uo.filter)((0, $2N6Uo.map)(newIndices, function(idx) {
            return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
        }), function(el) {
            return el && el !== oldEl;
        });
        var newSeris = newDiffItems[newIndices[0]].data.hostModel;
        if (newElsList.length) {
            (0, $2N6Uo.each)(newElsList, function(newEl) {
                return $292f58d51269f06b$var$stopAnimation(newEl);
            });
            if (oldEl) {
                $292f58d51269f06b$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $292f58d51269f06b$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $gLWoJ.applyMorphAnimation)((0, $gLWoJ.getPathList)(oldEl), (0, $gLWoJ.getPathList)(newElsList), oldItem.divide, // Use divide on old.
                newSeris, newIndices[0], updateMorphingPathProps);
            } else (0, $2N6Uo.each)(newElsList, function(newEl) {
                return $292f58d51269f06b$var$fadeInElement(newEl, newSeris, newIndices[0]);
            });
        }
    // else keep oldEl leaving animation.
    }).updateManyToMany(function(newIndices, oldIndices) {
        // If two data are same and both have groupId.
        // Normally they should be diff by id.
        new (0, $chf3v.default)(oldIndices, newIndices, function(rawIdx) {
            return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
        }, function(rawIdx) {
            return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
        }).update(function(newIndex, oldIndex) {
            // Use the original index
            updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
        }).execute();
    }).execute();
    if (hasMorphAnimation) (0, $2N6Uo.each)(newList, function(_a) {
        var data = _a.data;
        var seriesModel = data.hostModel;
        var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
        var animationCfg = (0, $ipprj.getAnimationConfig)('update', seriesModel, 0); // use 0 index.
        if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) view.group.traverse(function(el) {
            if (el instanceof (0, $4oDJM.default) && !el.animators.length) // We can't accept there still exists element that has no animation
            // if universalTransition is enabled
            el.animateFrom({
                style: {
                    opacity: 0
                }
            }, animationCfg);
        });
    });
}
function $292f58d51269f06b$var$getSeriesTransitionKey(series) {
    var seriesKey = series.getModel('universalTransition').get('seriesKey');
    if (!seriesKey) // Use series id by default.
    return series.id;
    return seriesKey;
}
function $292f58d51269f06b$var$convertArraySeriesKeyToString(seriesKey) {
    if ((0, $2N6Uo.isArray)(seriesKey)) // Order independent.
    return seriesKey.sort().join(',');
    return seriesKey;
}
function $292f58d51269f06b$var$getDivideShapeFromData(data) {
    if (data.hostModel) return data.hostModel.getModel('universalTransition').get('divideShape');
}
function $292f58d51269f06b$var$findTransitionSeriesBatches(globalStore, params) {
    var updateBatches = (0, $2N6Uo.createHashMap)();
    var oldDataMap = (0, $2N6Uo.createHashMap)();
    // Map that only store key in array seriesKey.
    // Which is used to query the old data when transition from one to multiple series.
    var oldDataMapForSplit = (0, $2N6Uo.createHashMap)();
    (0, $2N6Uo.each)(globalStore.oldSeries, function(series, idx) {
        var oldDataGroupId = globalStore.oldDataGroupIds[idx];
        var oldData = globalStore.oldData[idx];
        var transitionKey = $292f58d51269f06b$var$getSeriesTransitionKey(series);
        var transitionKeyStr = $292f58d51269f06b$var$convertArraySeriesKeyToString(transitionKey);
        oldDataMap.set(transitionKeyStr, {
            dataGroupId: oldDataGroupId,
            data: oldData
        });
        if ((0, $2N6Uo.isArray)(transitionKey)) // Same key can't in different array seriesKey.
        (0, $2N6Uo.each)(transitionKey, function(key) {
            oldDataMapForSplit.set(key, {
                key: transitionKeyStr,
                dataGroupId: oldDataGroupId,
                data: oldData
            });
        });
    });
    function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
        if (updateBatches.get(transitionKeyStr)) (0, $byzwF.warn)("Duplicated seriesKey in universalTransition " + transitionKeyStr);
    }
    (0, $2N6Uo.each)(params.updatedSeries, function(series) {
        if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
            var newDataGroupId = series.get('dataGroupId');
            var newData = series.getData();
            var transitionKey = $292f58d51269f06b$var$getSeriesTransitionKey(series);
            var transitionKeyStr = $292f58d51269f06b$var$convertArraySeriesKeyToString(transitionKey);
            // Only transition between series with same id.
            var oldData = oldDataMap.get(transitionKeyStr);
            // string transition key is the best match.
            if (oldData) // TODO check if data is same?
            updateBatches.set(transitionKeyStr, {
                oldSeries: [
                    {
                        dataGroupId: oldData.dataGroupId,
                        divide: $292f58d51269f06b$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    }
                ],
                newSeries: [
                    {
                        dataGroupId: newDataGroupId,
                        divide: $292f58d51269f06b$var$getDivideShapeFromData(newData),
                        data: newData
                    }
                ]
            });
            else // Transition from multiple series.
            // e.g. 'female', 'male' -> ['female', 'male']
            if ((0, $2N6Uo.isArray)(transitionKey)) {
                var oldSeries_1 = [];
                (0, $2N6Uo.each)(transitionKey, function(key) {
                    var oldData = oldDataMap.get(key);
                    if (oldData.data) oldSeries_1.push({
                        dataGroupId: oldData.dataGroupId,
                        divide: $292f58d51269f06b$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    });
                });
                if (oldSeries_1.length) updateBatches.set(transitionKeyStr, {
                    oldSeries: oldSeries_1,
                    newSeries: [
                        {
                            dataGroupId: newDataGroupId,
                            data: newData,
                            divide: $292f58d51269f06b$var$getDivideShapeFromData(newData)
                        }
                    ]
                });
            } else {
                // Try transition to multiple series.
                // e.g. ['female', 'male'] -> 'female', 'male'
                var oldData_1 = oldDataMapForSplit.get(transitionKey);
                if (oldData_1) {
                    var batch = updateBatches.get(oldData_1.key);
                    if (!batch) {
                        batch = {
                            oldSeries: [
                                {
                                    dataGroupId: oldData_1.dataGroupId,
                                    data: oldData_1.data,
                                    divide: $292f58d51269f06b$var$getDivideShapeFromData(oldData_1.data)
                                }
                            ],
                            newSeries: []
                        };
                        updateBatches.set(oldData_1.key, batch);
                    }
                    batch.newSeries.push({
                        dataGroupId: newDataGroupId,
                        data: newData,
                        divide: $292f58d51269f06b$var$getDivideShapeFromData(newData)
                    });
                }
            }
        }
    });
    return updateBatches;
}
function $292f58d51269f06b$var$querySeries(series, finder) {
    for(var i = 0; i < series.length; i++){
        var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;
        if (found) return i;
    }
}
function $292f58d51269f06b$var$transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
    var from = [];
    var to = [];
    (0, $2N6Uo.each)((0, $bx3T8.normalizeToArray)(transitionOpt.from), function(finder) {
        var idx = $292f58d51269f06b$var$querySeries(globalStore.oldSeries, finder);
        if (idx >= 0) from.push({
            dataGroupId: globalStore.oldDataGroupIds[idx],
            data: globalStore.oldData[idx],
            // TODO can specify divideShape in transition.
            divide: $292f58d51269f06b$var$getDivideShapeFromData(globalStore.oldData[idx]),
            groupIdDim: finder.dimension
        });
    });
    (0, $2N6Uo.each)((0, $bx3T8.normalizeToArray)(transitionOpt.to), function(finder) {
        var idx = $292f58d51269f06b$var$querySeries(params.updatedSeries, finder);
        if (idx >= 0) {
            var data = params.updatedSeries[idx].getData();
            to.push({
                dataGroupId: globalStore.oldDataGroupIds[idx],
                data: data,
                divide: $292f58d51269f06b$var$getDivideShapeFromData(data),
                groupIdDim: finder.dimension
            });
        }
    });
    if (from.length > 0 && to.length > 0) $292f58d51269f06b$var$transitionBetween(from, to, api);
}
function $292f58d51269f06b$export$efd07f28fd73e88c(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecMOdel, api, params) {
        (0, $2N6Uo.each)((0, $bx3T8.normalizeToArray)(params.seriesTransition), function(transOpt) {
            (0, $2N6Uo.each)((0, $bx3T8.normalizeToArray)(transOpt.to), function(finder) {
                var series = params.updatedSeries;
                for(var i = 0; i < series.length; i++)if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) series[i][0, $49X8G.SERIES_UNIVERSAL_TRANSITION_PROP] = true;
            });
        });
    });
    registers.registerUpdateLifecycle('series:transition', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var globalStore = $292f58d51269f06b$var$getUniversalTransitionGlobalStore(api);
        // TODO multiple to multiple series.
        if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
            // TODO transitionOpt was used in an old implementation and can be removed now
            // Use give transition config if its' give;
            var transitionOpt = params.seriesTransition;
            if (transitionOpt) (0, $2N6Uo.each)((0, $bx3T8.normalizeToArray)(transitionOpt), function(opt) {
                $292f58d51269f06b$var$transitionSeriesFromOpt(opt, globalStore, params, api);
            });
            else {
                // Else guess from series based on transition series key.
                var updateBatches_1 = $292f58d51269f06b$var$findTransitionSeriesBatches(globalStore, params);
                (0, $2N6Uo.each)(updateBatches_1.keys(), function(key) {
                    var batch = updateBatches_1.get(key);
                    $292f58d51269f06b$var$transitionBetween(batch.oldSeries, batch.newSeries, api);
                });
            }
            // Reset
            (0, $2N6Uo.each)(params.updatedSeries, function(series) {
                // Reset;
                if (series[0, $49X8G.SERIES_UNIVERSAL_TRANSITION_PROP]) series[0, $49X8G.SERIES_UNIVERSAL_TRANSITION_PROP] = false;
            });
        }
        // Save all series of current update. Not only the updated one.
        var allSeries = ecModel.getSeries();
        var savedSeries = globalStore.oldSeries = [];
        var savedDataGroupIds = globalStore.oldDataGroupIds = [];
        var savedData = globalStore.oldData = [];
        for(var i = 0; i < allSeries.length; i++){
            var data = allSeries[i].getData();
            // Only save the data that can have transition.
            // Avoid large data costing too much extra memory
            if (data.count() < $292f58d51269f06b$var$DATA_COUNT_THRESHOLD) {
                savedSeries.push(allSeries[i]);
                savedDataGroupIds.push(allSeries[i].get('dataGroupId'));
                savedData.push(data);
            }
        }
    });
}

});
parcelRegister("gLWoJ", function(module, exports) {

$parcel$export(module.exports, "applyMorphAnimation", function () { return $c35e55bdb1ac31a4$export$c6ab3ab2bfe1ec39; });
$parcel$export(module.exports, "getPathList", function () { return $c35e55bdb1ac31a4$export$ad61593d7c3fa814; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $19KOK = parcelRequire("19KOK");
parcelRequire("h9U3p");
var $4oDJM = parcelRequire("4oDJM");

var $2N6Uo = parcelRequire("2N6Uo");

var $ipprj = parcelRequire("ipprj");

var $hI0Jj = parcelRequire("hI0Jj");
function $c35e55bdb1ac31a4$var$isMultiple(elements) {
    return (0, $2N6Uo.isArray)(elements[0]);
}
function $c35e55bdb1ac31a4$var$prepareMorphBatches(one, many) {
    var batches = [];
    var batchCount = one.length;
    for(var i = 0; i < batchCount; i++)batches.push({
        one: one[i],
        many: []
    });
    for(var i = 0; i < many.length; i++){
        var len = many[i].length;
        var k = void 0;
        for(k = 0; k < len; k++)batches[k % batchCount].many.push(many[i][k]);
    }
    var off = 0;
    // If one has more paths than each one of many. average them.
    for(var i = batchCount - 1; i >= 0; i--)if (!batches[i].many.length) {
        var moveFrom = batches[off].many;
        if (moveFrom.length <= 1) {
            // Not enough
            // Start from the first one.
            if (off) off = 0;
            else return batches;
        }
        var len = moveFrom.length;
        var mid = Math.ceil(len / 2);
        batches[i].many = moveFrom.slice(mid, len);
        batches[off].many = moveFrom.slice(0, mid);
        off++;
    }
    return batches;
}
var $c35e55bdb1ac31a4$var$pathDividers = {
    clone: function(params) {
        var ret = [];
        // Fitting the alpha
        var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);
        for(var i = 0; i < params.count; i++){
            var cloned = (0, $hI0Jj.clonePath)(params.path);
            cloned.setStyle('opacity', approxOpacity);
            ret.push(cloned);
        }
        return ret;
    },
    // Use the default divider
    split: null
};
function $c35e55bdb1ac31a4$export$c6ab3ab2bfe1ec39(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
    if (!from.length || !to.length) return;
    var updateAnimationCfg = (0, $ipprj.getAnimationConfig)('update', seriesModel, dataIndex);
    if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) return;
    var animationDelay = seriesModel.getModel('universalTransition').get('delay');
    var animationCfg = Object.assign({
        // Need to setToFinal so the further calculation based on the style can be correct.
        // Like emphasis color.
        setToFinal: true
    }, updateAnimationCfg);
    var many;
    var one;
    if ($c35e55bdb1ac31a4$var$isMultiple(from)) {
        // manyToOne
        many = from;
        one = to;
    }
    if ($c35e55bdb1ac31a4$var$isMultiple(to)) {
        // oneToMany
        many = to;
        one = from;
    }
    function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
        var batchMany = batch.many;
        var batchOne = batch.one;
        if (batchMany.length === 1 && !forceManyOne) {
            // Is one to one
            var batchFrom = fromIsMany ? batchMany[0] : batchOne;
            var batchTo = fromIsMany ? batchOne : batchMany[0];
            if ((0, $19KOK.isCombineMorphing)(batchFrom)) // Keep doing combine animation.
            morphOneBatch({
                many: [
                    batchFrom
                ],
                one: batchTo
            }, true, animateIndex, animateCount, true);
            else {
                var individualAnimationCfg = animationDelay ? (0, $2N6Uo.defaults)({
                    delay: animationDelay(animateIndex, animateCount)
                }, animationCfg) : animationCfg;
                (0, $19KOK.morphPath)(batchFrom, batchTo, individualAnimationCfg);
                animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
            }
        } else {
            var separateAnimationCfg = (0, $2N6Uo.defaults)({
                dividePath: $c35e55bdb1ac31a4$var$pathDividers[divideShape],
                individualDelay: animationDelay && function(idx, count, fromPath, toPath) {
                    return animationDelay(idx + animateIndex, animateCount);
                }
            }, animationCfg);
            var _a = fromIsMany ? (0, $19KOK.combineMorph)(batchMany, batchOne, separateAnimationCfg) : (0, $19KOK.separateMorph)(batchOne, batchMany, separateAnimationCfg), fromIndividuals = _a.fromIndividuals, toIndividuals = _a.toIndividuals;
            var count = fromIndividuals.length;
            for(var k = 0; k < count; k++){
                var individualAnimationCfg = animationDelay ? (0, $2N6Uo.defaults)({
                    delay: animationDelay(k, count)
                }, animationCfg) : animationCfg;
                animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
            }
        }
    }
    var fromIsMany = many ? many === from : from.length > to.length;
    var morphBatches = many ? $c35e55bdb1ac31a4$var$prepareMorphBatches(one, many) : $c35e55bdb1ac31a4$var$prepareMorphBatches(fromIsMany ? to : from, [
        fromIsMany ? from : to
    ]);
    var animateCount = 0;
    for(var i = 0; i < morphBatches.length; i++)animateCount += morphBatches[i].many.length;
    var animateIndex = 0;
    for(var i = 0; i < morphBatches.length; i++){
        morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
        animateIndex += morphBatches[i].many.length;
    }
}
function $c35e55bdb1ac31a4$export$ad61593d7c3fa814(elements) {
    if (!elements) return [];
    if ((0, $2N6Uo.isArray)(elements)) {
        var pathList_1 = [];
        for(var i = 0; i < elements.length; i++)pathList_1.push($c35e55bdb1ac31a4$export$ad61593d7c3fa814(elements[i]));
        return pathList_1;
    }
    var pathList = [];
    elements.traverse(function(el) {
        if (el instanceof (0, $4oDJM.default) && !el.disableMorphing && !el.invisible && !el.ignore) pathList.push(el);
    });
    return pathList;
}

});
parcelRegister("19KOK", function(module, exports) {

$parcel$export(module.exports, "isCombineMorphing", function () { return $0d7af2adfa6c45aa$export$f9f720a01590a46f; });
$parcel$export(module.exports, "morphPath", function () { return $0d7af2adfa6c45aa$export$7174e282c1c7df1c; });
$parcel$export(module.exports, "combineMorph", function () { return $0d7af2adfa6c45aa$export$57d3bac3565fd555; });
$parcel$export(module.exports, "separateMorph", function () { return $0d7af2adfa6c45aa$export$b6ed198024fe6db8; });

var $1kxDI = parcelRequire("1kxDI");

var $4oDJM = parcelRequire("4oDJM");

var $2N6Uo = parcelRequire("2N6Uo");

var $U1aqY = parcelRequire("U1aqY");

var $hI0Jj = parcelRequire("hI0Jj");

var $erz95 = parcelRequire("erz95");

var $9kv0P = parcelRequire("9kv0P");

var $6GQrX = parcelRequire("6GQrX");
function $0d7af2adfa6c45aa$var$alignSubpath(subpath1, subpath2) {
    var len1 = subpath1.length;
    var len2 = subpath2.length;
    if (len1 === len2) return [
        subpath1,
        subpath2
    ];
    var tmpSegX = [];
    var tmpSegY = [];
    var shorterPath = len1 < len2 ? subpath1 : subpath2;
    var shorterLen = Math.min(len1, len2);
    var diff = Math.abs(len2 - len1) / 6;
    var shorterBezierCount = (shorterLen - 2) / 6;
    var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
    var newSubpath = [
        shorterPath[0],
        shorterPath[1]
    ];
    var remained = diff;
    for(var i = 2; i < shorterLen;){
        var x0 = shorterPath[i - 2];
        var y0 = shorterPath[i - 1];
        var x1 = shorterPath[i++];
        var y1 = shorterPath[i++];
        var x2 = shorterPath[i++];
        var y2 = shorterPath[i++];
        var x3 = shorterPath[i++];
        var y3 = shorterPath[i++];
        if (remained <= 0) {
            newSubpath.push(x1, y1, x2, y2, x3, y3);
            continue;
        }
        var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
        for(var k = 1; k <= actualSubDivCount; k++){
            var p = k / actualSubDivCount;
            (0, $1kxDI.cubicSubdivide)(x0, x1, x2, x3, p, tmpSegX);
            (0, $1kxDI.cubicSubdivide)(y0, y1, y2, y3, p, tmpSegY);
            x0 = tmpSegX[3];
            y0 = tmpSegY[3];
            newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
            x1 = tmpSegX[5];
            y1 = tmpSegY[5];
            x2 = tmpSegX[6];
            y2 = tmpSegY[6];
        }
        remained -= actualSubDivCount - 1;
    }
    return shorterPath === subpath1 ? [
        newSubpath,
        subpath2
    ] : [
        subpath1,
        newSubpath
    ];
}
function $0d7af2adfa6c45aa$var$createSubpath(lastSubpathSubpath, otherSubpath) {
    var len = lastSubpathSubpath.length;
    var lastX = lastSubpathSubpath[len - 2];
    var lastY = lastSubpathSubpath[len - 1];
    var newSubpath = [];
    for(var i = 0; i < otherSubpath.length;){
        newSubpath[i++] = lastX;
        newSubpath[i++] = lastY;
    }
    return newSubpath;
}
function $0d7af2adfa6c45aa$export$d7b853a0ab412a07(array1, array2) {
    var _a;
    var lastSubpath1;
    var lastSubpath2;
    var newArray1 = [];
    var newArray2 = [];
    for(var i = 0; i < Math.max(array1.length, array2.length); i++){
        var subpath1 = array1[i];
        var subpath2 = array2[i];
        var newSubpath1 = void 0;
        var newSubpath2 = void 0;
        if (!subpath1) {
            newSubpath1 = $0d7af2adfa6c45aa$var$createSubpath(lastSubpath1 || subpath2, subpath2);
            newSubpath2 = subpath2;
        } else if (!subpath2) {
            newSubpath2 = $0d7af2adfa6c45aa$var$createSubpath(lastSubpath2 || subpath1, subpath1);
            newSubpath1 = subpath1;
        } else {
            _a = $0d7af2adfa6c45aa$var$alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
            lastSubpath1 = newSubpath1;
            lastSubpath2 = newSubpath2;
        }
        newArray1.push(newSubpath1);
        newArray2.push(newSubpath2);
    }
    return [
        newArray1,
        newArray2
    ];
}
function $0d7af2adfa6c45aa$export$e2a20c553f6c85ce(array) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = array.length;
    for(var i = 0, j = len - 2; i < len; j = i, i += 2){
        var x0 = array[j];
        var y0 = array[j + 1];
        var x1 = array[i];
        var y1 = array[i + 1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
    }
    if (signedArea === 0) return [
        array[0] || 0,
        array[1] || 0
    ];
    return [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ];
}
function $0d7af2adfa6c45aa$var$findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
    var bezierCount = (fromSubBeziers.length - 2) / 6;
    var bestScore = Infinity;
    var bestOffset = 0;
    var len = fromSubBeziers.length;
    var len2 = len - 2;
    for(var offset = 0; offset < bezierCount; offset++){
        var cursorOffset = offset * 6;
        var score = 0;
        for(var k = 0; k < len; k += 2){
            var idx = k === 0 ? cursorOffset : (cursorOffset + k - 2) % len2 + 2;
            var x0 = fromSubBeziers[idx] - fromCp[0];
            var y0 = fromSubBeziers[idx + 1] - fromCp[1];
            var x1 = toSubBeziers[k] - toCp[0];
            var y1 = toSubBeziers[k + 1] - toCp[1];
            var dx = x1 - x0;
            var dy = y1 - y0;
            score += dx * dx + dy * dy;
        }
        if (score < bestScore) {
            bestScore = score;
            bestOffset = offset;
        }
    }
    return bestOffset;
}
function $0d7af2adfa6c45aa$var$reverse(array) {
    var newArr = [];
    var len = array.length;
    for(var i = 0; i < len; i += 2){
        newArr[i] = array[len - i - 2];
        newArr[i + 1] = array[len - i - 1];
    }
    return newArr;
}
function $0d7af2adfa6c45aa$var$findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
    var result = [];
    var fromNeedsReverse;
    for(var i = 0; i < fromArr.length; i++){
        var fromSubpathBezier = fromArr[i];
        var toSubpathBezier = toArr[i];
        var fromCp = $0d7af2adfa6c45aa$export$e2a20c553f6c85ce(fromSubpathBezier);
        var toCp = $0d7af2adfa6c45aa$export$e2a20c553f6c85ce(toSubpathBezier);
        if (fromNeedsReverse == null) fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
        var newFromSubpathBezier = [];
        var newToSubpathBezier = [];
        var bestAngle = 0;
        var bestScore = Infinity;
        var tmpArr = [];
        var len = fromSubpathBezier.length;
        if (fromNeedsReverse) fromSubpathBezier = $0d7af2adfa6c45aa$var$reverse(fromSubpathBezier);
        var offset = $0d7af2adfa6c45aa$var$findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
        var len2 = len - 2;
        for(var k = 0; k < len2; k += 2){
            var idx = (offset + k) % len2 + 2;
            newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
            newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
        }
        newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
        newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
        if (searchAngleIteration > 0) {
            var step = searchAngleRange / searchAngleIteration;
            for(var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step){
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                var score = 0;
                for(var k = 0; k < fromSubpathBezier.length; k += 2){
                    var x0 = newFromSubpathBezier[k];
                    var y0 = newFromSubpathBezier[k + 1];
                    var x1 = toSubpathBezier[k] - toCp[0];
                    var y1 = toSubpathBezier[k + 1] - toCp[1];
                    var newX1 = x1 * ca - y1 * sa;
                    var newY1 = x1 * sa + y1 * ca;
                    tmpArr[k] = newX1;
                    tmpArr[k + 1] = newY1;
                    var dx = newX1 - x0;
                    var dy = newY1 - y0;
                    score += dx * dx + dy * dy;
                }
                if (score < bestScore) {
                    bestScore = score;
                    bestAngle = angle;
                    for(var m = 0; m < tmpArr.length; m++)newToSubpathBezier[m] = tmpArr[m];
                }
            }
        } else for(var i_1 = 0; i_1 < len; i_1 += 2){
            newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
            newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
        }
        result.push({
            from: newFromSubpathBezier,
            to: newToSubpathBezier,
            fromCp: fromCp,
            toCp: toCp,
            rotation: -bestAngle
        });
    }
    return result;
}
function $0d7af2adfa6c45aa$export$f9f720a01590a46f(path) {
    return path.__isCombineMorphing;
}
function $0d7af2adfa6c45aa$export$ddee3124b756354f(el) {
    return el.__morphT >= 0;
}
var $0d7af2adfa6c45aa$var$SAVED_METHOD_PREFIX = '__mOriginal_';
function $0d7af2adfa6c45aa$var$saveAndModifyMethod(obj, methodName, modifiers) {
    var savedMethodName = $0d7af2adfa6c45aa$var$SAVED_METHOD_PREFIX + methodName;
    var originalMethod = obj[savedMethodName] || obj[methodName];
    if (!obj[savedMethodName]) obj[savedMethodName] = obj[methodName];
    var replace = modifiers.replace;
    var after = modifiers.after;
    var before = modifiers.before;
    obj[methodName] = function() {
        var args = arguments;
        var res;
        before && before.apply(this, args);
        if (replace) res = replace.apply(this, args);
        else res = originalMethod.apply(this, args);
        after && after.apply(this, args);
        return res;
    };
}
function $0d7af2adfa6c45aa$var$restoreMethod(obj, methodName) {
    var savedMethodName = $0d7af2adfa6c45aa$var$SAVED_METHOD_PREFIX + methodName;
    if (obj[savedMethodName]) {
        obj[methodName] = obj[savedMethodName];
        obj[savedMethodName] = null;
    }
}
function $0d7af2adfa6c45aa$var$applyTransformOnBeziers(bezierCurves, mm) {
    for(var i = 0; i < bezierCurves.length; i++){
        var subBeziers = bezierCurves[i];
        for(var k = 0; k < subBeziers.length;){
            var x = subBeziers[k];
            var y = subBeziers[k + 1];
            subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
            subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
        }
    }
}
function $0d7af2adfa6c45aa$var$prepareMorphPath(fromPath, toPath) {
    var fromPathProxy = fromPath.getUpdatedPathProxy();
    var toPathProxy = toPath.getUpdatedPathProxy();
    var _a = $0d7af2adfa6c45aa$export$d7b853a0ab412a07((0, $6GQrX.pathToBezierCurves)(fromPathProxy), (0, $6GQrX.pathToBezierCurves)(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
    var fromPathTransform = fromPath.getComputedTransform();
    var toPathTransform = toPath.getComputedTransform();
    function updateIdentityTransform() {
        this.transform = null;
    }
    fromPathTransform && $0d7af2adfa6c45aa$var$applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
    toPathTransform && $0d7af2adfa6c45aa$var$applyTransformOnBeziers(toBezierCurves, toPathTransform);
    $0d7af2adfa6c45aa$var$saveAndModifyMethod(toPath, 'updateTransform', {
        replace: updateIdentityTransform
    });
    toPath.transform = null;
    var morphingData = $0d7af2adfa6c45aa$var$findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
    var tmpArr = [];
    $0d7af2adfa6c45aa$var$saveAndModifyMethod(toPath, 'buildPath', {
        replace: function(path) {
            var t = toPath.__morphT;
            var onet = 1 - t;
            var newCp = [];
            for(var i = 0; i < morphingData.length; i++){
                var item = morphingData[i];
                var from = item.from;
                var to = item.to;
                var angle = item.rotation * t;
                var fromCp = item.fromCp;
                var toCp = item.toCp;
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                (0, $U1aqY.lerp)(newCp, fromCp, toCp, t);
                for(var m = 0; m < from.length; m += 2){
                    var x0_1 = from[m];
                    var y0_1 = from[m + 1];
                    var x1 = to[m];
                    var y1 = to[m + 1];
                    var x = x0_1 * onet + x1 * t;
                    var y = y0_1 * onet + y1 * t;
                    tmpArr[m] = x * ca - y * sa + newCp[0];
                    tmpArr[m + 1] = x * sa + y * ca + newCp[1];
                }
                var x0 = tmpArr[0];
                var y0 = tmpArr[1];
                path.moveTo(x0, y0);
                for(var m = 2; m < from.length;){
                    var x1 = tmpArr[m++];
                    var y1 = tmpArr[m++];
                    var x2 = tmpArr[m++];
                    var y2 = tmpArr[m++];
                    var x3 = tmpArr[m++];
                    var y3 = tmpArr[m++];
                    if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) path.lineTo(x3, y3);
                    else path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    x0 = x3;
                    y0 = y3;
                }
            }
        }
    });
}
function $0d7af2adfa6c45aa$export$7174e282c1c7df1c(fromPath, toPath, animationOpts) {
    if (!fromPath || !toPath) return toPath;
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    $0d7af2adfa6c45aa$var$prepareMorphPath(fromPath, toPath);
    toPath.__morphT = 0;
    function restoreToPath() {
        $0d7af2adfa6c45aa$var$restoreMethod(toPath, 'buildPath');
        $0d7af2adfa6c45aa$var$restoreMethod(toPath, 'updateTransform');
        toPath.__morphT = -1;
        toPath.createPathProxy();
        toPath.dirtyShape();
    }
    toPath.animateTo({
        __morphT: 1
    }, (0, $2N6Uo.defaults)({
        during: function(p) {
            toPath.dirtyShape();
            oldDuring && oldDuring(p);
        },
        done: function() {
            restoreToPath();
            oldDone && oldDone();
        }
    }, animationOpts));
    return toPath;
}
function $0d7af2adfa6c45aa$var$hilbert(x, y, minX, minY, maxX, maxY) {
    var bits = 16;
    x = maxX === minX ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
    y = maxY === minY ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
    var d = 0;
    var tmp;
    for(var s = (1 << bits) / 2; s > 0; s /= 2){
        var rx = 0;
        var ry = 0;
        if ((x & s) > 0) rx = 1;
        if ((y & s) > 0) ry = 1;
        d += s * s * (3 * rx ^ ry);
        if (ry === 0) {
            if (rx === 1) {
                x = s - 1 - x;
                y = s - 1 - y;
            }
            tmp = x;
            x = y;
            y = tmp;
        }
    }
    return d;
}
function $0d7af2adfa6c45aa$var$sortPaths(pathList) {
    var xMin = Infinity;
    var yMin = Infinity;
    var xMax = -Infinity;
    var yMax = -Infinity;
    var cps = (0, $2N6Uo.map)(pathList, function(path) {
        var rect = path.getBoundingRect();
        var m = path.getComputedTransform();
        var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
        var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
        xMin = Math.min(x, xMin);
        yMin = Math.min(y, yMin);
        xMax = Math.max(x, xMax);
        yMax = Math.max(y, yMax);
        return [
            x,
            y
        ];
    });
    var items = (0, $2N6Uo.map)(cps, function(cp, idx) {
        return {
            cp: cp,
            z: $0d7af2adfa6c45aa$var$hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
            path: pathList[idx]
        };
    });
    return items.sort(function(a, b) {
        return a.z - b.z;
    }).map(function(item) {
        return item.path;
    });
}
function $0d7af2adfa6c45aa$var$defaultDividePath(param) {
    return (0, $9kv0P.split)(param.path, param.count);
}
function $0d7af2adfa6c45aa$var$createEmptyReturn() {
    return {
        fromIndividuals: [],
        toIndividuals: [],
        count: 0
    };
}
function $0d7af2adfa6c45aa$export$57d3bac3565fd555(fromList, toPath, animationOpts) {
    var fromPathList = [];
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($0d7af2adfa6c45aa$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $4oDJM.default)) fromPathList.push(from);
        }
    }
    addFromPath(fromList);
    var separateCount = fromPathList.length;
    if (!separateCount) return $0d7af2adfa6c45aa$var$createEmptyReturn();
    var dividePath = animationOpts.dividePath || $0d7af2adfa6c45aa$var$defaultDividePath;
    var toSubPathList = dividePath({
        path: toPath,
        count: separateCount
    });
    if (toSubPathList.length !== separateCount) {
        console.error('Invalid morphing: unmatched splitted path');
        return $0d7af2adfa6c45aa$var$createEmptyReturn();
    }
    fromPathList = $0d7af2adfa6c45aa$var$sortPaths(fromPathList);
    toSubPathList = $0d7af2adfa6c45aa$var$sortPaths(toSubPathList);
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    var individualDelay = animationOpts.individualDelay;
    var identityTransform = new (0, $erz95.default)();
    for(var i = 0; i < separateCount; i++){
        var from = fromPathList[i];
        var to = toSubPathList[i];
        to.parent = toPath;
        to.copyTransform(identityTransform);
        if (!individualDelay) $0d7af2adfa6c45aa$var$prepareMorphPath(from, to);
    }
    toPath.__isCombineMorphing = true;
    toPath.childrenRef = function() {
        return toSubPathList;
    };
    function addToSubPathListToZr(zr) {
        for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].addSelfToZr(zr);
    }
    $0d7af2adfa6c45aa$var$saveAndModifyMethod(toPath, 'addSelfToZr', {
        after: function(zr) {
            addToSubPathListToZr(zr);
        }
    });
    $0d7af2adfa6c45aa$var$saveAndModifyMethod(toPath, 'removeSelfFromZr', {
        after: function(zr) {
            for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].removeSelfFromZr(zr);
        }
    });
    function restoreToPath() {
        toPath.__isCombineMorphing = false;
        toPath.__morphT = -1;
        toPath.childrenRef = null;
        $0d7af2adfa6c45aa$var$restoreMethod(toPath, 'addSelfToZr');
        $0d7af2adfa6c45aa$var$restoreMethod(toPath, 'removeSelfFromZr');
    }
    var toLen = toSubPathList.length;
    if (individualDelay) {
        var animating_1 = toLen;
        var eachDone = function() {
            animating_1--;
            if (animating_1 === 0) {
                restoreToPath();
                oldDone && oldDone();
            }
        };
        for(var i = 0; i < toLen; i++){
            var indivdualAnimationOpts = individualDelay ? (0, $2N6Uo.defaults)({
                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
                done: eachDone
            }, animationOpts) : animationOpts;
            $0d7af2adfa6c45aa$export$7174e282c1c7df1c(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
        }
    } else {
        toPath.__morphT = 0;
        toPath.animateTo({
            __morphT: 1
        }, (0, $2N6Uo.defaults)({
            during: function(p) {
                for(var i = 0; i < toLen; i++){
                    var child = toSubPathList[i];
                    child.__morphT = toPath.__morphT;
                    child.dirtyShape();
                }
                oldDuring && oldDuring(p);
            },
            done: function() {
                restoreToPath();
                for(var i = 0; i < fromList.length; i++)$0d7af2adfa6c45aa$var$restoreMethod(fromList[i], 'updateTransform');
                oldDone && oldDone();
            }
        }, animationOpts));
    }
    if (toPath.__zr) addToSubPathListToZr(toPath.__zr);
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toSubPathList,
        count: toLen
    };
}
function $0d7af2adfa6c45aa$export$b6ed198024fe6db8(fromPath, toPathList, animationOpts) {
    var toLen = toPathList.length;
    var fromPathList = [];
    var dividePath = animationOpts.dividePath || $0d7af2adfa6c45aa$var$defaultDividePath;
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($0d7af2adfa6c45aa$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $4oDJM.default)) fromPathList.push(from);
        }
    }
    if ($0d7af2adfa6c45aa$export$f9f720a01590a46f(fromPath)) {
        addFromPath(fromPath.childrenRef());
        var fromLen = fromPathList.length;
        if (fromLen < toLen) {
            var k = 0;
            for(var i = fromLen; i < toLen; i++)fromPathList.push((0, $hI0Jj.clonePath)(fromPathList[k++ % fromLen]));
        }
        fromPathList.length = toLen;
    } else {
        fromPathList = dividePath({
            path: fromPath,
            count: toLen
        });
        var fromPathTransform = fromPath.getComputedTransform();
        for(var i = 0; i < fromPathList.length; i++)fromPathList[i].setLocalTransform(fromPathTransform);
        if (fromPathList.length !== toLen) {
            console.error('Invalid morphing: unmatched splitted path');
            return $0d7af2adfa6c45aa$var$createEmptyReturn();
        }
    }
    fromPathList = $0d7af2adfa6c45aa$var$sortPaths(fromPathList);
    toPathList = $0d7af2adfa6c45aa$var$sortPaths(toPathList);
    var individualDelay = animationOpts.individualDelay;
    for(var i = 0; i < toLen; i++){
        var indivdualAnimationOpts = individualDelay ? (0, $2N6Uo.defaults)({
            delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
        }, animationOpts) : animationOpts;
        $0d7af2adfa6c45aa$export$7174e282c1c7df1c(fromPathList[i], toPathList[i], indivdualAnimationOpts);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toPathList,
        count: toPathList.length
    };
}

});
parcelRegister("9kv0P", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $6cae09ba45087a6d$export$65980d18b75784e2; });

var $kK0Aj = parcelRequire("kK0Aj");

var $67W72 = parcelRequire("67W72");

var $9KN3M = parcelRequire("9KN3M");

var $2N6Uo = parcelRequire("2N6Uo");

var $hXTRG = parcelRequire("hXTRG");

var $aH2k0 = parcelRequire("aH2k0");

var $60Kbk = parcelRequire("60Kbk");

var $6GQrX = parcelRequire("6GQrX");

var $hI0Jj = parcelRequire("hI0Jj");
function $6cae09ba45087a6d$var$getDividingGrids(dimSize, rowDim, count) {
    var rowSize = dimSize[rowDim];
    var columnSize = dimSize[1 - rowDim];
    var ratio = Math.abs(rowSize / columnSize);
    var rowCount = Math.ceil(Math.sqrt(ratio * count));
    var columnCount = Math.floor(count / rowCount);
    if (columnCount === 0) {
        columnCount = 1;
        rowCount = count;
    }
    var grids = [];
    for(var i = 0; i < rowCount; i++)grids.push(columnCount);
    var currentCount = rowCount * columnCount;
    var remained = count - currentCount;
    if (remained > 0) for(var i = 0; i < remained; i++)grids[i % rowCount] += 1;
    return grids;
}
function $6cae09ba45087a6d$var$divideSector(sectorShape, count, outShapes) {
    var r0 = sectorShape.r0;
    var r = sectorShape.r;
    var startAngle = sectorShape.startAngle;
    var endAngle = sectorShape.endAngle;
    var angle = Math.abs(endAngle - startAngle);
    var arcLen = angle * r;
    var deltaR = r - r0;
    var isAngleRow = arcLen > Math.abs(deltaR);
    var grids = $6cae09ba45087a6d$var$getDividingGrids([
        arcLen,
        deltaR
    ], isAngleRow ? 0 : 1, count);
    var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            if (isAngleRow) {
                newShape.startAngle = startAngle + rowSize * row;
                newShape.endAngle = startAngle + rowSize * (row + 1);
                newShape.r0 = r0 + columnSize * column;
                newShape.r = r0 + columnSize * (column + 1);
            } else {
                newShape.startAngle = startAngle + columnSize * column;
                newShape.endAngle = startAngle + columnSize * (column + 1);
                newShape.r0 = r0 + rowSize * row;
                newShape.r = r0 + rowSize * (row + 1);
            }
            newShape.clockwise = sectorShape.clockwise;
            newShape.cx = sectorShape.cx;
            newShape.cy = sectorShape.cy;
            outShapes.push(newShape);
        }
    }
}
function $6cae09ba45087a6d$var$divideRect(rectShape, count, outShapes) {
    var width = rectShape.width;
    var height = rectShape.height;
    var isHorizontalRow = width > height;
    var grids = $6cae09ba45087a6d$var$getDividingGrids([
        width,
        height
    ], isHorizontalRow ? 0 : 1, count);
    var rowSizeDim = isHorizontalRow ? 'width' : 'height';
    var columnSizeDim = isHorizontalRow ? 'height' : 'width';
    var rowDim = isHorizontalRow ? 'x' : 'y';
    var columnDim = isHorizontalRow ? 'y' : 'x';
    var rowSize = rectShape[rowSizeDim] / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = rectShape[columnSizeDim] / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            newShape[rowDim] = row * rowSize;
            newShape[columnDim] = column * columnSize;
            newShape[rowSizeDim] = rowSize;
            newShape[columnSizeDim] = columnSize;
            newShape.x += rectShape.x;
            newShape.y += rectShape.y;
            outShapes.push(newShape);
        }
    }
}
function $6cae09ba45087a6d$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $6cae09ba45087a6d$var$lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    var nmCrossProduct = $6cae09ba45087a6d$var$crossProduct2d(nx, ny, mx, my);
    if (Math.abs(nmCrossProduct) < 1e-6) return null;
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var p = $6cae09ba45087a6d$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return null;
    return new (0, $9KN3M.default)(p * mx + a1x, p * my + a1y);
}
function $6cae09ba45087a6d$var$projPtOnLine(pt, lineA, lineB) {
    var dir = new (0, $9KN3M.default)();
    (0, $9KN3M.default).sub(dir, lineB, lineA);
    dir.normalize();
    var dir2 = new (0, $9KN3M.default)();
    (0, $9KN3M.default).sub(dir2, pt, lineA);
    var len = dir2.dot(dir);
    return len;
}
function $6cae09ba45087a6d$var$addToPoly(poly, pt) {
    var last = poly[poly.length - 1];
    if (last && last[0] === pt[0] && last[1] === pt[1]) return;
    poly.push(pt);
}
function $6cae09ba45087a6d$var$splitPolygonByLine(points, lineA, lineB) {
    var len = points.length;
    var intersections = [];
    for(var i = 0; i < len; i++){
        var p0 = points[i];
        var p1 = points[(i + 1) % len];
        var intersectionPt = $6cae09ba45087a6d$var$lineLineIntersect(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
        if (intersectionPt) intersections.push({
            projPt: $6cae09ba45087a6d$var$projPtOnLine(intersectionPt, lineA, lineB),
            pt: intersectionPt,
            idx: i
        });
    }
    if (intersections.length < 2) return [
        {
            points: points
        },
        {
            points: points
        }
    ];
    intersections.sort(function(a, b) {
        return a.projPt - b.projPt;
    });
    var splitPt0 = intersections[0];
    var splitPt1 = intersections[intersections.length - 1];
    if (splitPt1.idx < splitPt0.idx) {
        var tmp = splitPt0;
        splitPt0 = splitPt1;
        splitPt1 = tmp;
    }
    var splitPt0Arr = [
        splitPt0.pt.x,
        splitPt0.pt.y
    ];
    var splitPt1Arr = [
        splitPt1.pt.x,
        splitPt1.pt.y
    ];
    var newPolyA = [
        splitPt0Arr
    ];
    var newPolyB = [
        splitPt1Arr
    ];
    for(var i = splitPt0.idx + 1; i <= splitPt1.idx; i++)$6cae09ba45087a6d$var$addToPoly(newPolyA, points[i].slice());
    $6cae09ba45087a6d$var$addToPoly(newPolyA, splitPt1Arr);
    $6cae09ba45087a6d$var$addToPoly(newPolyA, splitPt0Arr);
    for(var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++)$6cae09ba45087a6d$var$addToPoly(newPolyB, points[i % len].slice());
    $6cae09ba45087a6d$var$addToPoly(newPolyB, splitPt0Arr);
    $6cae09ba45087a6d$var$addToPoly(newPolyB, splitPt1Arr);
    return [
        {
            points: newPolyA
        },
        {
            points: newPolyB
        }
    ];
}
function $6cae09ba45087a6d$var$binaryDividePolygon(polygonShape) {
    var points = polygonShape.points;
    var min = [];
    var max = [];
    (0, $kK0Aj.fromPoints)(points, min, max);
    var boundingRect = new (0, $67W72.default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    var width = boundingRect.width;
    var height = boundingRect.height;
    var x = boundingRect.x;
    var y = boundingRect.y;
    var pt0 = new (0, $9KN3M.default)();
    var pt1 = new (0, $9KN3M.default)();
    if (width > height) {
        pt0.x = pt1.x = x + width / 2;
        pt0.y = y;
        pt1.y = y + height;
    } else {
        pt0.y = pt1.y = y + height / 2;
        pt0.x = x;
        pt1.x = x + width;
    }
    return $6cae09ba45087a6d$var$splitPolygonByLine(points, pt0, pt1);
}
function $6cae09ba45087a6d$var$binaryDivideRecursive(divider, shape, count, out) {
    if (count === 1) out.push(shape);
    else {
        var mid = Math.floor(count / 2);
        var sub = divider(shape);
        $6cae09ba45087a6d$var$binaryDivideRecursive(divider, sub[0], mid, out);
        $6cae09ba45087a6d$var$binaryDivideRecursive(divider, sub[1], count - mid, out);
    }
    return out;
}
function $6cae09ba45087a6d$export$9cd59f9826255e47(path, count) {
    var paths = [];
    for(var i = 0; i < count; i++)paths.push((0, $hI0Jj.clonePath)(path));
    return paths;
}
function $6cae09ba45087a6d$var$copyPathProps(source, target) {
    target.setStyle(source.style);
    target.z = source.z;
    target.z2 = source.z2;
    target.zlevel = source.zlevel;
}
function $6cae09ba45087a6d$var$polygonConvert(points) {
    var out = [];
    for(var i = 0; i < points.length;)out.push([
        points[i++],
        points[i++]
    ]);
    return out;
}
function $6cae09ba45087a6d$export$65980d18b75784e2(path, count) {
    var outShapes = [];
    var shape = path.shape;
    var OutShapeCtor;
    switch(path.type){
        case 'rect':
            $6cae09ba45087a6d$var$divideRect(shape, count, outShapes);
            OutShapeCtor = (0, $aH2k0.default);
            break;
        case 'sector':
            $6cae09ba45087a6d$var$divideSector(shape, count, outShapes);
            OutShapeCtor = (0, $60Kbk.default);
            break;
        case 'circle':
            $6cae09ba45087a6d$var$divideSector({
                r0: 0,
                r: shape.r,
                startAngle: 0,
                endAngle: Math.PI * 2,
                cx: shape.cx,
                cy: shape.cy
            }, count, outShapes);
            OutShapeCtor = (0, $60Kbk.default);
            break;
        default:
            var m = path.getComputedTransform();
            var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
            var polygons = (0, $2N6Uo.map)((0, $6GQrX.pathToPolygons)(path.getUpdatedPathProxy(), scale), function(poly) {
                return $6cae09ba45087a6d$var$polygonConvert(poly);
            });
            var polygonCount = polygons.length;
            if (polygonCount === 0) $6cae09ba45087a6d$var$binaryDivideRecursive($6cae09ba45087a6d$var$binaryDividePolygon, {
                points: polygons[0]
            }, count, outShapes);
            else if (polygonCount === count) for(var i = 0; i < polygonCount; i++)outShapes.push({
                points: polygons[i]
            });
            else {
                var totalArea_1 = 0;
                var items = (0, $2N6Uo.map)(polygons, function(poly) {
                    var min = [];
                    var max = [];
                    (0, $kK0Aj.fromPoints)(poly, min, max);
                    var area = (max[1] - min[1]) * (max[0] - min[0]);
                    totalArea_1 += area;
                    return {
                        poly: poly,
                        area: area
                    };
                });
                items.sort(function(a, b) {
                    return b.area - a.area;
                });
                var left = count;
                for(var i = 0; i < polygonCount; i++){
                    var item = items[i];
                    if (left <= 0) break;
                    var selfCount = i === polygonCount - 1 ? left : Math.ceil(item.area / totalArea_1 * count);
                    if (selfCount < 0) continue;
                    $6cae09ba45087a6d$var$binaryDivideRecursive($6cae09ba45087a6d$var$binaryDividePolygon, {
                        points: item.poly
                    }, selfCount, outShapes);
                    left -= selfCount;
                }
            }
            OutShapeCtor = (0, $hXTRG.default);
            break;
    }
    if (!OutShapeCtor) return $6cae09ba45087a6d$export$9cd59f9826255e47(path, count);
    var out = [];
    for(var i = 0; i < outShapes.length; i++){
        var subPath = new OutShapeCtor();
        subPath.setShape(outShapes[i]);
        $6cae09ba45087a6d$var$copyPathProps(path, subPath);
        out.push(subPath);
    }
    return out;
}

});
parcelRegister("6GQrX", function(module, exports) {

$parcel$export(module.exports, "pathToBezierCurves", function () { return $4def59cd4de18e80$export$fbc91cffd4bdf629; });
$parcel$export(module.exports, "pathToPolygons", function () { return $4def59cd4de18e80$export$163f4950160f2337; });

var $1kxDI = parcelRequire("1kxDI");

var $eAFw0 = parcelRequire("eAFw0");
var $4def59cd4de18e80$var$CMD = (0, $eAFw0.default).CMD;
function $4def59cd4de18e80$var$aroundEqual(a, b) {
    return Math.abs(a - b) < 1e-5;
}
function $4def59cd4de18e80$export$fbc91cffd4bdf629(path) {
    var data = path.data;
    var len = path.len();
    var bezierArrayGroups = [];
    var currentSubpath;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    function createNewSubpath(x, y) {
        if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
        currentSubpath = [
            x,
            y
        ];
    }
    function addLine(x0, y0, x1, y1) {
        if (!($4def59cd4de18e80$var$aroundEqual(x0, x1) && $4def59cd4de18e80$var$aroundEqual(y0, y1))) currentSubpath.push(x0, y0, x1, y1, x1, y1);
    }
    function addArc(startAngle, endAngle, cx, cy, rx, ry) {
        var delta = Math.abs(endAngle - startAngle);
        var len = Math.tan(delta / 4) * 4 / 3;
        var dir = endAngle < startAngle ? -1 : 1;
        var c1 = Math.cos(startAngle);
        var s1 = Math.sin(startAngle);
        var c2 = Math.cos(endAngle);
        var s2 = Math.sin(endAngle);
        var x1 = c1 * rx + cx;
        var y1 = s1 * ry + cy;
        var x4 = c2 * rx + cx;
        var y4 = s2 * ry + cy;
        var hx = rx * len * dir;
        var hy = ry * len * dir;
        currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
    }
    var x1;
    var y1;
    var x2;
    var y2;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
            if (cmd === $4def59cd4de18e80$var$CMD.L || cmd === $4def59cd4de18e80$var$CMD.C || cmd === $4def59cd4de18e80$var$CMD.Q) currentSubpath = [
                x0,
                y0
            ];
        }
        switch(cmd){
            case $4def59cd4de18e80$var$CMD.M:
                xi = x0 = data[i++];
                yi = y0 = data[i++];
                createNewSubpath(x0, y0);
                break;
            case $4def59cd4de18e80$var$CMD.L:
                x1 = data[i++];
                y1 = data[i++];
                addLine(xi, yi, x1, y1);
                xi = x1;
                yi = y1;
                break;
            case $4def59cd4de18e80$var$CMD.C:
                currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
                break;
            case $4def59cd4de18e80$var$CMD.Q:
                x1 = data[i++];
                y1 = data[i++];
                x2 = data[i++];
                y2 = data[i++];
                currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
                xi = x2;
                yi = y2;
                break;
            case $4def59cd4de18e80$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var startAngle = data[i++];
                var endAngle = data[i++] + startAngle;
                i += 1;
                var anticlockwise = !data[i++];
                x1 = Math.cos(startAngle) * rx + cx;
                y1 = Math.sin(startAngle) * ry + cy;
                if (isFirst) {
                    x0 = x1;
                    y0 = y1;
                    createNewSubpath(x0, y0);
                } else addLine(xi, yi, x1, y1);
                xi = Math.cos(endAngle) * rx + cx;
                yi = Math.sin(endAngle) * ry + cy;
                var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
                for(var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step){
                    var nextAngle = anticlockwise ? Math.max(angle + step, endAngle) : Math.min(angle + step, endAngle);
                    addArc(angle, nextAngle, cx, cy, rx, ry);
                }
                break;
            case $4def59cd4de18e80$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                x1 = x0 + data[i++];
                y1 = y0 + data[i++];
                createNewSubpath(x1, y0);
                addLine(x1, y0, x1, y1);
                addLine(x1, y1, x0, y1);
                addLine(x0, y1, x0, y0);
                addLine(x0, y0, x1, y0);
                break;
            case $4def59cd4de18e80$var$CMD.Z:
                currentSubpath && addLine(xi, yi, x0, y0);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
    return bezierArrayGroups;
}
function $4def59cd4de18e80$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
    if ($4def59cd4de18e80$var$aroundEqual(x0, x1) && $4def59cd4de18e80$var$aroundEqual(y0, y1) && $4def59cd4de18e80$var$aroundEqual(x2, x3) && $4def59cd4de18e80$var$aroundEqual(y2, y3)) {
        out.push(x3, y3);
        return;
    }
    var PIXEL_DISTANCE = 2 / scale;
    var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
    var dx = x3 - x0;
    var dy = y3 - y0;
    var d = Math.sqrt(dx * dx + dy * dy);
    dx /= d;
    dy /= d;
    var dx1 = x1 - x0;
    var dy1 = y1 - y0;
    var dx2 = x2 - x3;
    var dy2 = y2 - y3;
    var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
    var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
    if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
        out.push(x3, y3);
        return;
    }
    var projLen1 = dx * dx1 + dy * dy1;
    var projLen2 = -dx * dx2 - dy * dy2;
    var d1Sqr = cp1LenSqr - projLen1 * projLen1;
    var d2Sqr = cp2LenSqr - projLen2 * projLen2;
    if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0 && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
        out.push(x3, y3);
        return;
    }
    var tmpSegX = [];
    var tmpSegY = [];
    (0, $1kxDI.cubicSubdivide)(x0, x1, x2, x3, 0.5, tmpSegX);
    (0, $1kxDI.cubicSubdivide)(y0, y1, y2, y3, 0.5, tmpSegY);
    $4def59cd4de18e80$var$adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
    $4def59cd4de18e80$var$adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
}
function $4def59cd4de18e80$export$163f4950160f2337(path, scale) {
    var bezierArrayGroups = $4def59cd4de18e80$export$fbc91cffd4bdf629(path);
    var polygons = [];
    scale = scale || 1;
    for(var i = 0; i < bezierArrayGroups.length; i++){
        var beziers = bezierArrayGroups[i];
        var polygon = [];
        var x0 = beziers[0];
        var y0 = beziers[1];
        polygon.push(x0, y0);
        for(var k = 2; k < beziers.length;){
            var x1 = beziers[k++];
            var y1 = beziers[k++];
            var x2 = beziers[k++];
            var y2 = beziers[k++];
            var x3 = beziers[k++];
            var y3 = beziers[k++];
            $4def59cd4de18e80$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
            x0 = x3;
            y0 = y3;
        }
        polygons.push(polygon);
    }
    return polygons;
}

});







parcelRegister("5Bb8e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41390b022bd8f949$export$2e2bcd8739ae039; });

var $diqzg = parcelRequire("diqzg");

var $9YhWF = parcelRequire("9YhWF");

var $26SB8 = parcelRequire("26SB8");
var $41390b022bd8f949$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $diqzg.default)
    ],
    props: {
        query: ''
    },
    data () {
        return {
            _gridThenCallback: null,
            _gridTotalCallback: null,
            listaPoliticaAgendamento: [],
            tabelaPoliticaAgendamento: null,
            columns: [
                {
                    id: 'id',
                    name: 'ID',
                    hidden: true
                },
                {
                    id: 'nome_officer',
                    name: 'Nome do Officer',
                    attributes: {
                        'sticky-column-1': true,
                        'sticky-header': true
                    },
                    hidden: false,
                    width: '140px',
                    formatter: (cell, row)=>{
                        return (0, $26SB8.html)(`
                            <div class="inline-flex items-center max-w-[180px]">
                                <span class="one-line max-w-[180px]">${cell || 'N/A'}</span>
                            </div>
            `);
                    },
                    sort: false
                },
                {
                    id: 'politicas_total',
                    name: "QTD de Pol\xedticas",
                    hidden: false,
                    sort: false,
                    width: '120px',
                    formatter: (cell, row)=>{
                        return (0, $26SB8.html)(`
                            <div class="inline-flex items-center justify-center">
                                <span class="one-line">${cell || '0'}</span>
                            </div>
            `);
                    }
                },
                {
                    id: 'politicas_atendidas',
                    name: "QTD de Pol\xedticas Atendidas",
                    hidden: false,
                    width: '150px',
                    sort: false,
                    formatter: (cell, row)=>{
                        return (0, $26SB8.html)(`
                            <div class="inline-flex items-center justify-center">
                                <span class="one-line">${cell || '0'}</span>
                            </div>
            `);
                    }
                },
                {
                    id: 'percentual',
                    name: "Percentual de Pol\xedticas Atendidas",
                    hidden: false,
                    width: '120px',
                    sort: false,
                    formatter: (cell, row)=>{
                        const percentual = parseFloat(cell) || 0;
                        // Cor baseada no percentual
                        let colorClass = 'text-red-600';
                        if (percentual >= 80) colorClass = 'text-green-600';
                        else if (percentual >= 60) colorClass = 'text-yellow-600';
                        return (0, $26SB8.html)(`
                            <div class="inline-flex items-center justify-center">
                                <span class="one-line ${colorClass}">${cell || '0%'}</span>
                            </div>
            `);
                    }
                }
            ]
        };
    },
    methods: {
        iniciatabelaPoliticaAgendamento () {
            const tabela = document.querySelector('#tabela_politica_agendamento');
            this._gridThenCallback = (responseAtendimentos)=>{
                return this.formataDadoTabela(responseAtendimentos) || [];
            };
            this._gridTotalCallback = (responseAtendimentos)=>{
                return responseAtendimentos.count;
            };
            const optionsPaginacao = {
                pagination: {
                    enabled: true,
                    limit: 10,
                    summary: true,
                    server: {
                        url: (urlApi, page, limit)=>{
                            const prefix = urlApi.includes('?') ? '&' : '?';
                            return `${urlApi}${prefix}page=${++page}&per_page=${limit}`;
                        }
                    }
                }
            };
            const optionsSort = {
                sort: {
                    multiColumn: false,
                    server: {
                        url: (prev, columns)=>{
                            if (!columns.length || columns[0].index !== 3) return prev;
                            const col = columns[0];
                            const dir = col.direction === 1 ? 'asc' : 'desc';
                            return `${prev}&sort_order=${dir}`;
                        }
                    }
                }
            };
            const optionsSearch = {
                search: {
                    server: {
                        url: (prev, keyword)=>`${prev}?officer=${keyword}`
                    }
                }
            };
            this.tabelaPoliticaAgendamento = this.iniciarTabelaGenerica(this.columns, `${window.origin}${(0, $9YhWF.URLS).relatorio_politica_agendamento}`, this._gridThenCallback, this._gridTotalCallback, {
                ...optionsPaginacao,
                ...optionsSort,
                ...optionsSearch
            });
            this.tabelaPoliticaAgendamento.render(tabela);
        },
        atualizarTabelaComNovaQuery () {
            if (!this.tabelaPoliticaAgendamento) return;
            let novaUrl = window.origin + (0, $9YhWF.URLS).relatorio_politica_agendamento;
            if (this.query) novaUrl += '?' + this.query;
            this.tabelaPoliticaAgendamento.updateConfig({
                pagination: {
                    enabled: true,
                    limit: 10,
                    summary: true,
                    server: {
                        url: (urlApi, page, limit)=>{
                            const prefix = urlApi.includes('?') ? '&' : '?';
                            return `${urlApi}${prefix}${this.query}&page=${++page}&per_page=${limit}`;
                        }
                    }
                }
            }).forceRender();
        },
        formataDadoTabela (responseAgendamentos) {
            if (!responseAgendamentos || !responseAgendamentos.dados_officers) {
                console.warn("Estrutura de dados inv\xe1lida:", responseAgendamentos);
                return [];
            }
            const dadosOfficers = responseAgendamentos.dados_officers || [];
            // Para GridJS, você pode mapear como objeto ou array
            const dadosFormatados = dadosOfficers.map((officer)=>{
                // Opção 1: Como array (atual)
                /* return [
					officer.nome_officer || 'N/A',
					officer.politicas_total || 0,
					officer.politicas_atendidas || 0,
					`${officer.percentual || 0}%`,
				] */ // Opção 2: Como objeto (alternativa)
                return {
                    nome_officer: officer.nome_officer || 'N/A',
                    politicas_total: officer.politicas_total || 0,
                    politicas_atendidas: officer.politicas_atendidas || 0,
                    percentual: `${officer.percentual || 0}%`
                };
            });
            this.listaPoliticaAgendamento = dadosFormatados;
            return dadosFormatados;
        }
    },
    watch: {
        query (newVal, oldVal) {
            if (newVal !== oldVal) this.atualizarTabelaComNovaQuery();
        }
    },
    mounted () {
        this.iniciatabelaPoliticaAgendamento();
    },
    template: `
        <table
			id="tabela_politica_agendamento"
			class="!flex"
			js-table-ordenation
			style="margin-inline: 1rem"></table>
    `
};

});

parcelRegister("7UMv2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c33625d84edb56b$export$2e2bcd8739ae039; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $5c33625d84edb56b$export$2e2bcd8739ae039() {
    const api = (0, $c8Lpu.useApi)();
    async function getTopBottomSai(query = '') {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).top_bottom_sai}${query}`);
    }
    async function getTopBottomSap(query = '') {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).top_bottom_sap}${query}`);
    }
    async function getRelatorioPoliticaAgendamento(params) {
        return await api.query((0, $9YhWF.URLS).relatorio_politica_agendamento, params);
    }
    return {
        getTopBottomSai: getTopBottomSai,
        getTopBottomSap: getTopBottomSap,
        getRelatorioPoliticaAgendamento: getRelatorioPoliticaAgendamento,
        ...api
    };
}

});


parcelRegister("knM87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed6b4a3d79a95c99$export$2e2bcd8739ae039; });

var $26SB8 = parcelRequire("26SB8");

var $1UZGW = parcelRequire("1UZGW");

var $gYCWk = parcelRequire("gYCWk");

var $kxhz7 = parcelRequire("kxhz7");

var $hmmUY = parcelRequire("hmmUY");

var $7h4Zs = parcelRequire("7h4Zs");

var $67nR7 = parcelRequire("67nR7");

var $2m7Ys = parcelRequire("2m7Ys");

var $lY3Fi = parcelRequire("lY3Fi");

var $9YhWF = parcelRequire("9YhWF");
const { ref: $ed6b4a3d79a95c99$var$ref } = Vue;
const { getChoicesActive: $ed6b4a3d79a95c99$var$getChoicesActive, formatDateObject: $ed6b4a3d79a95c99$var$formatDateObject } = GLOBAL;
let $ed6b4a3d79a95c99$var$quill = null;
const { getTemplatesEmail: $ed6b4a3d79a95c99$var$getTemplatesEmail, getFundacoesContatos: $ed6b4a3d79a95c99$var$getFundacoesContatos, sendEmail: $ed6b4a3d79a95c99$var$sendEmail, getEmailEnvinhado: $ed6b4a3d79a95c99$var$getEmailEnvinhado, isLoading: $ed6b4a3d79a95c99$var$isLoading } = (0, $kxhz7.emailFundacaoService)();
const { getFiltroFundacao: $ed6b4a3d79a95c99$var$getFiltroFundacao } = (0, $hmmUY.fundacaoService)();
const $ed6b4a3d79a95c99$var$refsSelects = {};
const $ed6b4a3d79a95c99$var$assinaturaTemplateEmailFundacao = `
	<p style="line-height: 0.8;"><strong>Rela\xe7\xf5es com Investidores Institucionais</strong></p>

	<p style="line-height: 0.8;">ri@azquest.com.br</p>

	<p style="line-height: 0.8;">clientesinstitucionais@unifinance.com.br</p>

	<p style="line-height: 0.8;">Tel. (21) 3138-6514</p>

	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>

	<p style="color: #B0B0B0; line-height: 0.8;">A Unifinance AAI \xe9 distribuidora exclusiva dos fundos da AZ Quest para Entidade
	Fechada de Previd\xeancia Complementar \u{2013} EFPC. Institui\xe7\xf5es contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.</p>

	<p style="line-height: 0.8;"><a href="https://www.unifinance.com.br" target="_blank">www.unifinance.com.br</a></p>

`;
const $ed6b4a3d79a95c99$var$assinaturaTemplateEmailIsmael = `
<div style="font-family: Arial, Helvetica, sans-serif; background-color: white; color: #242424; font-size: 14px; line-height: 1.5;">

  <p style="margin-top: 10px;">Estou \xe0 disposi\xe7\xe3o para qualquer eventualidade.</p>

  <p style="margin-top: 10px;">Atenciosamente,</p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 14px; font-weight: bold; color: #1d252c;">
    Ismael Ramos, CFP<sup style="font-size: 10px;">\xae</sup>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 13px; color: #1d252c;">
    Candidato ao CFA N\xedvel III
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    <a href="mailto:ri@azquest.com.br" style="color: #1d252c;">ri@azquest.com.br</a><br>
    <a href="mailto:ismael.ramos@unifinance.com.br" style="color: #1d252c;">ismael.ramos@unifinance.com.br</a>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    Tel: (21) 3138-6506 / (21) 97173-1290
  </p>

  <p>
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 10pt; color: #7f7f7f;">
    A Unifinance AAI \xe9 distribuidora exclusiva dos fundos da AZ Quest para Entidades Fechadas de Previd\xeancia Complementar \u{2013} EFPC. Institui\xe7\xf5es contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.
  </p>

   <a href="www.unifinance.com.br" style="margin-top: 10px;">www.unifinance.com.br</a>
</div>

`;
const $ed6b4a3d79a95c99$var$assinaturaTemplateEmailMatheus = `
	<div style="font-family: Arial, Helvetica, sans-serif; background-color: white; color: #242424; font-size: 14px; line-height: 1.5;">

  <p style="margin-top: 10px;">Estou \xe0 disposi\xe7\xe3o para qualquer eventualidade.</p>

  <p style="margin-top: 10px;">Atenciosamente,</p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 14px; font-weight: bold; color: #1d252c;">
    Matheus Giannini<sup style="font-size: 10px;">\xae</sup>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    <a href="mailto:ri@azquest.com.br" style="color: #1d252c;">ri@azquest.com.br</a><br>
    <a href="matheus@unifinance.com.br" style="color: #1d252c;">matheus@unifinance.com.br</a>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    Tel: (21) 3138-6514
  </p>

  <p>
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 10pt; color: #7f7f7f;">
    A Unifinance AAI \xe9 distribuidora exclusiva dos fundos da AZ Quest para Entidades Fechadas de Previd\xeancia Complementar \u{2013} EFPC. Institui\xe7\xf5es contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.
  </p>

  <a href="www.unifinance.com.br" style="margin-top: 10px;">www.unifinance.com.br</a>
</div>
`;
var $ed6b4a3d79a95c99$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $lY3Fi.default)
    ],
    emits: [],
    props: {},
    components: {
        ModalAprovacao: $gYCWk.default,
        ConfirmModal: $1UZGW.default,
        SelectMultiple: $7h4Zs.default
    },
    data () {
        return {
            tableEmails: [],
            listaEmail: true,
            isCreateEmail: true,
            isVisualizaEmail: false,
            isFilterFundoEmailActivate: false,
            templates: {
                results: []
            },
            fundacoesList: {
                results: []
            },
            emailsEnvinhados: {},
            emailVisualizacao: {
                template: '',
                fundacoes: [],
                corpo_email: '',
                assunto: ''
            },
            isLoading: $ed6b4a3d79a95c99$var$isLoading,
            template: '',
            fundacoes: [],
            corpo_email: '',
            assunto: '',
            quill_visualiza: null,
            filtros: {
                fundo: [],
                tag: [],
                tempoSenAtendimentoRapido: null
            },
            fundoOption: [],
            tagOption: [],
            tempoSenAtendimentoRapidoOption: [
                {
                    label: '1 a 3 meses',
                    value: '1,3'
                },
                {
                    label: '4 a 6 meses',
                    value: '4,6'
                },
                {
                    label: 'Mais de 6 meses',
                    value: '6,1000'
                }
            ],
            isValidSubmit: true
        };
    },
    watch: {
        template () {
            const templateSelecionado = this.templates?.results?.find((template)=>template.id_template === parseInt(this.template));
            if (!$ed6b4a3d79a95c99$var$quill) return;
            if (!templateSelecionado) {
                $ed6b4a3d79a95c99$var$quill.root.innerHTML = '';
                this.assunto = '';
                $ed6b4a3d79a95c99$var$quill.setText('');
                return;
            }
            this.assunto = templateSelecionado.assunto;
            $ed6b4a3d79a95c99$var$quill.setText('');
            this.setDeltaToQuillByContent(templateSelecionado.corpo);
        /* this.quill.root.innerHTML =
				templateSelecionado.corpo + '<br/>' + assinaturaTemplateEmailFundacao */ },
        fundacoes () {
            const selectFundacoes = $ed6b4a3d79a95c99$var$getChoicesActive('email_fundacao', window.listOfChoices);
            if (this.fundacoes.length > 1) /* this.fundacoes = this.fundacoes.filter(
					(itemFundacaoSelecionada) => true
				) */ selectFundacoes.removeActiveItemsByValue('');
        },
        fundacoesList () {
            /* console.log(this.fundacoesList) */ const opcoes = this.fundacoesList?.map((fundacao)=>({
                    value: fundacao.id_fundacao,
                    label: fundacao.sigla_fundacao
                }));
            const selectFundacoes = $ed6b4a3d79a95c99$var$getChoicesActive('email_fundacao', window.listOfChoices);
            selectFundacoes.removeActiveItems();
            selectFundacoes.clearChoices();
            selectFundacoes.setChoices([
                {
                    value: '',
                    label: 'Selecione'
                },
                ...opcoes
            ]);
            if (this.isFilterFundoEmailActivate) {
                if (this.filtros.fundo.length > 0 || this.filtros.tag.length > 0 || this.filtros.tempoSenAtendimentoRapido) opcoes.forEach(({ value: value })=>{
                    selectFundacoes.setChoiceByValue(value);
                });
                else selectFundacoes.setChoiceByValue('');
                this.fundacoes = selectFundacoes.getValue(true);
            } else {
                selectFundacoes.setChoiceByValue('');
                this.fundacoes = [];
            }
            /* console.log('cliente fundo: ',this.fundacoes) */ $ed6b4a3d79a95c99$var$refsSelects.selectFundacoes = selectFundacoes;
        },
        templates () {
            const opcoes = this.templates?.results?.map((fundacao)=>({
                    value: fundacao.id_template,
                    label: fundacao.assunto
                }));
            const selectTemplates = $ed6b4a3d79a95c99$var$getChoicesActive('email_modelo', window.listOfChoices);
            selectTemplates.setChoices([
                {
                    value: '',
                    label: 'Selecione'
                },
                ...opcoes
            ]);
            selectTemplates.setChoiceByValue('');
            $ed6b4a3d79a95c99$var$refsSelects.selectTemplates = selectTemplates;
        }
    },
    methods: {
        initSelectTempo () {
            const selectTempo = $ed6b4a3d79a95c99$var$getChoicesActive('tempo_filtro_lista', window.listOfChoices);
            if (selectTempo) {
                selectTempo.setChoices([
                    {
                        value: '',
                        label: 'Selecione'
                    },
                    ...this.tempoSenAtendimentoRapidoOption
                ]);
                selectTempo.setChoiceByValue('');
            }
        },
        checkCamposIsValid () {
            const fundacoesFiltrado = this.filtrarFundacoesValid();
            const texto = $ed6b4a3d79a95c99$var$quill.getText();
            const isConteudoCorpoVazio = texto.trim().length === 0;
            if (fundacoesFiltrado.length > 0 && this.template && this.assunto && !isConteudoCorpoVazio) this.isValidSubmit = false;
            else this.isValidSubmit = true;
        },
        setDeltaToQuillByContent (content) {
            const delta = $ed6b4a3d79a95c99$var$quill.clipboard.convert({
                html: content
            });
            $ed6b4a3d79a95c99$var$quill.setContents(delta, 'silent');
            $ed6b4a3d79a95c99$var$quill.setSelection(0, 0, 'silent');
            $ed6b4a3d79a95c99$var$quill.focus();
        },
        filtrarFundacoesValid () {
            return this.fundacoes.filter((itemFundacao)=>itemFundacao !== '').map((itemFundacao)=>parseFloat(itemFundacao));
        },
        async onSubmit () {
            const fundacoesFiltrado = this.filtrarFundacoesValid();
            let template = '';
            const atualUsuario = GLOBAL.usuario.nome;
            if (atualUsuario.toLowerCase() === 'ismael') template = $ed6b4a3d79a95c99$var$assinaturaTemplateEmailIsmael;
            else if (atualUsuario.toLowerCase() === 'matheus') template = $ed6b4a3d79a95c99$var$assinaturaTemplateEmailMatheus;
            else template = $ed6b4a3d79a95c99$var$assinaturaTemplateEmailFundacao;
            const conteudoCorpo = $ed6b4a3d79a95c99$var$quill.getSemanticHTML() + '<br/>' + template;
            const data = {
                template_id: this.template,
                clientes_ids: fundacoesFiltrado,
                corpo: conteudoCorpo
            };
            const responseEmail = await $ed6b4a3d79a95c99$var$sendEmail(data, '');
            this.atualizaTableEmails();
            /* this.closeCreateEmail() */ const responseAtendimentoRapido = await this.createAtendimentoRapido('0', $ed6b4a3d79a95c99$var$quill.getSemanticHTML());
            window.location.href = `${window.location.origin}/clientes/email_fundacao/?t=${new Date().getTime()}`;
        },
        openCreateEmail () {
            this.listaEmail = false;
            this.isCreateEmail = true;
        },
        openVisualizaEmail () {
            this.listaEmail = false;
            this.isCreateEmail = false;
            this.isVisualizaEmail = true;
        },
        closeCreateEmail () {
            this.listaEmail = true;
            this.isCreateEmail = true;
            this.clearCamposEnvioEmail();
            this.clearClienteAtendimentoRapido();
        },
        closeVisualizarEmail () {
            this.listaEmail = true;
            this.isCreateEmail = true;
            this.isVisualizaEmail = false;
        },
        /* 		limpaFormEnvioEmail() {
			refsSelects.selectTemplates.setChoiceByValue('')
			refsSelects.selectFundacoes.setChoiceByValue('')
			this.assunto = ''
			this.quill.root.innerHTML = ''
		},
 */ openModalEmailFundacao () {
            modal_padrao_vue.openModal('email_fundacao_filtros');
        },
        updateCorpoEmail () {
            if (!$ed6b4a3d79a95c99$var$quill) return;
            $ed6b4a3d79a95c99$var$quill.on('text-change', ()=>{
                const html = $ed6b4a3d79a95c99$var$quill.root.innerHTML;
                this.corpo_email = html;
            });
        },
        clearCamposEnvioEmail () {
            const selectFundacoes = $ed6b4a3d79a95c99$var$getChoicesActive('email_fundacao', window.listOfChoices);
            const selectTemplates = $ed6b4a3d79a95c99$var$getChoicesActive('email_modelo', window.listOfChoices);
            selectFundacoes.removeActiveItems();
            selectFundacoes.setChoiceByValue('');
            selectTemplates.removeActiveItems();
            this.fundacao = '';
            this.template = '';
            this.assunto = '';
            $ed6b4a3d79a95c99$var$quill.setText('', 'silent');
            const length = $ed6b4a3d79a95c99$var$quill.getLength();
            $ed6b4a3d79a95c99$var$quill.deleteText(0, length, 'silent');
            $ed6b4a3d79a95c99$var$quill.setSelection(0, 0, 'silent');
        },
        iniciarTabelaGenerica (tableSelector, columns, url, customThenCallback, customTotalCallback) {
            const table = document.querySelector(tableSelector);
            const gridInstance = new (0, $26SB8.Grid)({
                search: true,
                resizable: true,
                columns: columns,
                data: [],
                autoWidth: true,
                width: '100%',
                sort: false,
                server: {
                    url: url,
                    then: (data)=>customThenCallback(data),
                    total: (data)=>customTotalCallback(data)
                },
                pagination: {
                    enabled: true,
                    limit: 10,
                    summary: false,
                    server: {
                        url: (urlApi, page, limit)=>`${urlApi}&page=${++page}&paginate_by=${limit}`
                    }
                },
                style: {
                    container: {
                        border: 'none'
                    },
                    table: {
                        border: 'none'
                    },
                    tr: {
                        border: 'none'
                    },
                    th: {
                        'border-bottom': '1px solid #e9ecef'
                    },
                    td: {
                        'border-bottom': '1px solid #e9ecef',
                        cursor: 'pointer',
                        color: '#495057',
                        'font-family': 'Roboto Flex',
                        'font-size': '14px',
                        'font-weight': 500,
                        'line-height': '150%',
                        'letter-spacing': '-0.28px'
                    },
                    footer: {
                        border: 'none'
                    }
                },
                language: {
                    search: {
                        placeholder: 'Busque aqui...'
                    },
                    pagination: {
                        previous: ' Anterior',
                        next: "Pr\xf3ximo "
                    }
                }
            });
            gridInstance.render(table);
            return gridInstance;
        },
        iniciartableEmails () {
            const columns = [
                {
                    id: 'ID',
                    name: 'ID',
                    hidden: true,
                    width: '100px'
                },
                {
                    id: 'Para',
                    name: 'Para',
                    width: '10rem'
                },
                {
                    id: 'Assunto',
                    name: 'Assunto',
                    hidden: false
                },
                {
                    id: 'Enviados',
                    name: 'Enviados',
                    formatter: (cell)=>this.formatDataEmail(cell)
                },
                {
                    id: 'acao',
                    name: '',
                    width: '80px',
                    formatter: (cell, row)=>this.renderHistoricoAcoes(row)
                }
            ];
            this.tableEmails = this.iniciarTabelaGenerica('#table_emails', columns, `${window.origin}${(0, $9YhWF.URLS).email_enviados}?`, (data)=>this.mapAndFilterSolicitations(data), (data)=>this.getTotalEmails(data));
        },
        atualizaTableEmails () {
            this.tableEmails.updateConfig({
                server: {
                    url: `${window.origin}/clientes/email_enviados/?t=${Date.now()}`,
                    then: (data)=>this.mapAndFilterSolicitations(data),
                    total: (data)=>this.getTotalEmails(data)
                }
            }).forceRender();
        },
        mapAndFilterSolicitations (data) {
            const listaEmailsEnvinhados = data?.results || [];
            this.emailsEnvinhados = listaEmailsEnvinhados;
            const emailsEnvinhadosTransformados = listaEmailsEnvinhados.map((emailEnvinhado)=>{
                return {
                    ID: emailEnvinhado?.id,
                    Assunto: emailEnvinhado?.assunto,
                    Para: emailEnvinhado?.enviado_para,
                    Enviados: emailEnvinhado?.enviado_em
                };
            });
            /* 			console.log(emailsEnvinhadosTransformados) */ return emailsEnvinhadosTransformados;
        },
        getTotalEmails (data) {
            /* console.log(data.count) */ return data.count;
        },
        formatDataEmail (data) {
            return $ed6b4a3d79a95c99$var$formatDateObject(new Date(data));
        },
        renderAcoes (row) {
            return (0, $26SB8.h)('div', {
                className: 'flex gap-2 justify-between'
            }, [
                (0, $26SB8.h)('ion-icon', {
                    name: 'checkmark-outline',
                    className: 'success',
                    onClick: ()=>this.openModalSolicitacao(row, 'aprovar')
                }),
                (0, $26SB8.h)('ion-icon', {
                    name: 'close-outline',
                    className: 'error',
                    onClick: ()=>this.openModalSolicitacao(row, 'recusar')
                })
            ]);
        },
        renderHistoricoAcoes (row) {
            return (0, $26SB8.h)('ion-icon', {
                name: 'search-outline',
                onClick: async ()=>await this.getInfoEmailEnvinhado(row)
            });
        },
        async getInfoEmailEnvinhado (row) {
            const idEmail = row?._cells[0]?.data;
            /* const atualEmailVisualizado = this.emailsEnvinhados.find(
				(emailEnvinhado) => emailEnvinhado.id === idEmail
			) */ const atualEmailVisualizado = (await $ed6b4a3d79a95c99$var$getEmailEnvinhado(idEmail))?.results[0];
            if (atualEmailVisualizado) {
                /* console.log(atualEmailVisualizado) */ const opcoesFundacoes = [
                    {
                        label: atualEmailVisualizado?.enviado_para,
                        value: atualEmailVisualizado?.envinhado_para_id
                    }
                ];
                const selectFundacoes = $ed6b4a3d79a95c99$var$getChoicesActive('email_fundacao_visualisa', window.listOfChoices);
                selectFundacoes.removeActiveItems();
                selectFundacoes.clearChoices();
                selectFundacoes.setChoices([
                    {
                        value: '',
                        label: 'Selecione'
                    },
                    ...opcoesFundacoes
                ]);
                const opcoesTemplates = this.templates?.results?.map((fundacao)=>({
                        value: fundacao.id_template,
                        label: fundacao.assunto
                    }));
                const selectTemplates = $ed6b4a3d79a95c99$var$getChoicesActive('email_modelo_visualisa', window.listOfChoices);
                selectTemplates.setChoices([
                    {
                        value: '',
                        label: 'Selecione'
                    },
                    ...opcoesTemplates
                ]);
                /* console.log(atualEmailVisualizado.envinhado_para_id) */ selectFundacoes.setChoiceByValue([
                    atualEmailVisualizado.envinhado_para_id
                ]);
                selectTemplates.setChoiceByValue(atualEmailVisualizado.template_id);
                this.emailVisualizacao.assunto = atualEmailVisualizado.assunto;
                this.quill_visualiza.root.innerHTML = atualEmailVisualizado.corpo_alterado || atualEmailVisualizado.corpo;
                /* selectTemplates.setChoiceByValue('1') 
			this.emailVisualizacao.template = 1; */ /* this.emailVisualizacao = {
				template: '1',
				fundacoes: [atualEmailVisualizado.envinhado_para_id],
				corpo_email: '',
				assunto: '',
			} */ this.openVisualizaEmail();
            }
        },
        async getInfoFundacoesFiltro () {
            let responseFundacoesFundo = [];
            let responseFundacoesTag = [];
            let fundacoesUnificado = [];
            let responseFundacoesTempo = [];
            if (this.filtros.fundo && this.filtros.fundo.length > 0) responseFundacoesFundo = await this.getFundacoesFiltroQuery('fundo') || [];
            if (this.filtros.tag && this.filtros.tag.length > 0) responseFundacoesTag = await this.getFundacoesFiltroQuery('tag') || [];
            if (this.filtros.tempoSenAtendimentoRapido) responseFundacoesTempo = await this.getFundacoesFiltroQuery('tempo') || [];
            const temFiltroFundo = this.filtros.fundo && this.filtros.fundo.length > 0;
            const temFiltroTag = this.filtros.tag && this.filtros.tag.length > 0;
            const temFiltroTempo = this.filtros.tempoSenAtendimentoRapido;
            if (!temFiltroFundo && !temFiltroTag && !temFiltroTempo) fundacoesUnificado = await this.getFundacoesFiltroQuery('all') || [];
            else {
                let resultadosCombinados = [];
                if (temFiltroFundo) resultadosCombinados = resultadosCombinados.concat(responseFundacoesFundo);
                if (temFiltroTag) resultadosCombinados = resultadosCombinados.concat(responseFundacoesTag);
                if (temFiltroTempo) resultadosCombinados = resultadosCombinados.concat(responseFundacoesTempo);
                fundacoesUnificado = resultadosCombinados;
            }
            this.fundacoesList = (0, (/*@__PURE__*/$parcel$interopDefault($2m7Ys))).unionBy(fundacoesUnificado, (itemFundacao)=>`${itemFundacao?.id_fundacao}`);
            this.isFilterFundoEmailActivate = true;
        },
        async getFundacoesFiltroQuery (campo) {
            const paramsUrl = new URLSearchParams();
            if (campo !== 'tempo' && campo !== 'all' && this.filtros[campo]) paramsUrl.append(campo, this.filtros[campo].map((itemFiltro)=>itemFiltro.value).join(','));
            if (this.filtros.tempoSenAtendimentoRapido) paramsUrl.append('meses_sem_atendimento', this.filtros.tempoSenAtendimentoRapido);
            const queryFiltroFundacao = paramsUrl.size > 0 ? `?${paramsUrl.toString()}` : '';
            return await $ed6b4a3d79a95c99$var$getFundacoesContatos(queryFiltroFundacao);
        },
        async initSelectFiltros () {
            const listaFiltroFundacao = await $ed6b4a3d79a95c99$var$getFiltroFundacao();
            /* const fundoChoise = getChoicesActive(
				'fundo_filtro_lista',
				window.listOfChoices
			) */ /* const tagChoise = getChoicesActive(
				'tag_filtro_lista',
				window.listOfChoices
			) */ /* 	fundoChoise.setChoices(
				listaFiltroFundacao?.fundos?.map((itemFiltroFundacao) => {
					return {
						value: itemFiltroFundacao[1],
						label: itemFiltroFundacao[1],
					}
				})
			)
 */ this.fundoOption = listaFiltroFundacao?.fundos?.map((itemFiltroFundacao)=>({
                    value: itemFiltroFundacao[1],
                    label: itemFiltroFundacao[1]
                }));
            /* tagChoise.setChoices(
				listaFiltroFundacao?.tags?.map((itemFiltroFundacao) => {
					return {
						value: itemFiltroFundacao[0],
						label: itemFiltroFundacao[1],
					}
				})
			) */ this.tagOption = listaFiltroFundacao?.tags?.map((itemFiltroTag)=>({
                    value: itemFiltroTag[0],
                    label: itemFiltroTag[1]
                }));
        },
        async limparFiltrosFundos () {
            window.location = `${window.origin}/clientes/email_fundacao/`;
        },
        eventoAddFundacoes () {
            const selectFundacoes = $ed6b4a3d79a95c99$var$getChoicesActive('email_fundacao', window.listOfChoices);
            selectFundacoes.passedElement.element.addEventListener('addItem', (event)=>{
                this.addClienteAtendimentoRapido(event.detail.value);
            });
        },
        eventoDeletaFundacoes () {
            const selectFundacoes = $ed6b4a3d79a95c99$var$getChoicesActive('email_fundacao', window.listOfChoices);
            selectFundacoes.passedElement.element.addEventListener('removeItem', (event)=>{
                this.removeClienteAtendimentoRapido(event.detail.value);
            });
        },
        initEventosSelect () {
            this.eventoAddFundacoes();
            this.eventoDeletaFundacoes();
            this.initSelectTempo();
        }
    },
    created () {
        this.$watch(()=>[
                this.fundacoes,
                this.template,
                this.assunto
            ], ()=>{
            this.checkCamposIsValid();
        });
    },
    async mounted () {
        $ed6b4a3d79a95c99$var$quill = new (0, $67nR7.default)(this.$refs.editor, {
            theme: 'snow',
            modules: {
                toolbar: [
                    [
                        {
                            header: [
                                1,
                                2,
                                false
                            ]
                        }
                    ],
                    [
                        'bold',
                        'italic',
                        'underline'
                    ],
                    [
                        {
                            list: 'ordered'
                        },
                        {
                            list: 'bullet'
                        },
                        {
                            list: 'check'
                        }
                    ],
                    [
                        {
                            color: []
                        },
                        {
                            background: []
                        }
                    ],
                    [
                        'clean',
                        'image'
                    ]
                ]
            }
        });
        this.quill_visualiza = new (0, $67nR7.default)(this.$refs.editor_visualisa, {
            theme: 'snow',
            readOnly: true,
            modules: {
                toolbar: [
                    [
                        {
                            header: [
                                1,
                                2,
                                false
                            ]
                        }
                    ],
                    [
                        'bold',
                        'italic',
                        'underline'
                    ],
                    [
                        {
                            list: 'ordered'
                        },
                        {
                            list: 'bullet'
                        },
                        {
                            list: 'check'
                        }
                    ],
                    [
                        {
                            color: []
                        },
                        {
                            background: []
                        }
                    ],
                    [
                        'clean',
                        'image'
                    ]
                ]
            }
        });
        this.updateCorpoEmail();
        this.fundacoesList = await $ed6b4a3d79a95c99$var$getFundacoesContatos();
        this.templates = await $ed6b4a3d79a95c99$var$getTemplatesEmail();
        await this.initSelectFiltros();
        this.iniciartableEmails();
        this.initEventosSelect();
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});

parcelRegister("kxvFW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef3f75cb9d6e65f0$export$2e2bcd8739ae039; });

var $26SB8 = parcelRequire("26SB8");

var $7h4Zs = parcelRequire("7h4Zs");

var $4nzoT = parcelRequire("4nzoT");

var $2Tg8R = parcelRequire("2Tg8R");

var $2m7Ys = parcelRequire("2m7Ys");

var $iM82Q = parcelRequire("iM82Q");

var $9mPML = parcelRequire("9mPML");

var $fcmEd = parcelRequire("fcmEd");
const { getInvestimentosPf: $ef3f75cb9d6e65f0$var$getInvestimentosPf, getMetaDadosInvestimentos: $ef3f75cb9d6e65f0$var$getMetaDadosInvestimentos } = (0, $2Tg8R.investimentosService)();
const { FormatREALVirgula: $ef3f75cb9d6e65f0$var$FormatREALVirgula } = GLOBAL;
const $ef3f75cb9d6e65f0$var$URLS = {
    investimentos_clientes_pf_api: '/clientes/investimentos/clientes_pf_api/',
    investimentos_cards_clientes_pf_api: '/clientes/investimentos/todos_clientes_pf_api/'
};
const $ef3f75cb9d6e65f0$var$politicasInfo = [
    {
        label: 'Ultra High',
        value: 0
    },
    {
        label: 'Private',
        value: 1
    },
    {
        label: 'Premium',
        value: 2
    },
    {
        label: "Distribui\xe7\xe3o",
        value: 3
    }
];
const $ef3f75cb9d6e65f0$var$defaultOPtionsPaginationLimit = [
    10,
    25,
    50,
    100
];
let $ef3f75cb9d6e65f0$var$isServLoad = false;
var $ef3f75cb9d6e65f0$export$2e2bcd8739ae039 = {
    props: {},
    components: {
        SelectMultiple: $7h4Zs.default,
        ModalResumo: $4nzoT.default,
        Pagination: $iM82Q.default,
        Loader: $9mPML.default,
        CardBigNumbers: $fcmEd.default
    },
    emits: [],
    data () {
        return {
            totalInvestidoPorAtivo: [],
            tableInvestimentos: null,
            haveModalResumo: true,
            isLoading: false,
            isLoadingCards: false,
            query: '?',
            model: {
                filtroOfficer: [],
                filtroPolitica: null,
                filtroMin: null,
                filtroMax: null,
                paginationLimitInvestimentos: 10,
                currentPage: 1
            },
            paginationTest: 10,
            totalRegistros: 0,
            optionsOfficers: [],
            optionsPolitica: [],
            sort: true,
            usuarios: [],
            columns: [
                {
                    id: 'id',
                    name: 'ID',
                    hidden: true
                },
                {
                    id: 'politica',
                    name: 'Politica',
                    hidden: true
                },
                {
                    id: 'nome',
                    name: 'Cliente PF',
                    attributes: {
                        'sticky-column-1': true,
                        'sticky-header': true
                    },
                    hidden: false,
                    width: '180px',
                    formatter: (cell, row)=>{
                        const politica = row?._cells[1]?.data;
                        if (cell === 'Media') return (0, $26SB8.html)(html`<div
								class="flex items-center"
								data-totalizador>
								Média por investimento
							</div>`);
                        else return (0, $26SB8.html)(`<div class="inline-flex items-center max-w-[180px] "  >
							<svg class="h-40 w-40 shrink-0" style="${GLOBAL.generateAvatarColor(politica)}">
									<use xlink:href="#icon_person"></use>
								</svg>
							<span class="one-line max-w-[180px]" title="${cell}">${cell || ''}</span>
						</div>`);
                    },
                    sort: {
                        compare: (a, b)=>{
                            if (a === 'Media' || b === 'Media') return 0;
                            if (a > b) return 1;
                            else if (a < b) return -1;
                            else return 0;
                        }
                    }
                },
                {
                    id: 'usuario_responsavel',
                    name: 'Officer',
                    hidden: false,
                    width: '100px',
                    attributes: {
                        'sticky-column-2': true,
                        'sticky-header': true,
                        center: true
                    },
                    formatter: (cell, row)=>{
                        if (cell) return (0, $26SB8.html)(`<div style="display:flex; flex-direction:column; gap:2px; width: 100%; overflow: hidden; text-overflow: ellipsis; truncate" >
							${cell?.map((item)=>{
                            const nameFormated = item.split('.').map((word)=>(0, $2m7Ys.capitalize)(word)).join(' ');
                            return `<span class="text-center w-full">${nameFormated || ''}</span>`;
                        }).join(' ')}
						</div>`);
                        else return (0, $26SB8.html)(`<span></span>`);
                    }
                },
                {
                    id: 'dados_investimento_renda_fixa',
                    name: 'Renda fixa',
                    width: '230px',
                    attributes: {
                        center: true
                    },
                    formatter: (cell, row)=>{
                        if (cell.media) return (0, $26SB8.html)(`
								<div style='width: 100%;'> 
									<span style='color: black; font-weight: bold;'>${cell.media.toPrecision(3)}%</span>
								</div>	
							`);
                        else if (cell) {
                            // console.log(cell)
                            const { data_ipca: data_ipca, data_pre: data_pre, data_pos: data_pos, totalGlobalPorcentagem: totalGlobalPorcentagem } = cell;
                            const ipcaPorcentagem = data_ipca?.porcentagem_global || 0;
                            const prePorcentagem = data_pre?.porcentagem_global || 0;
                            const posPorcentagem = data_pos?.porcentagem_global || 0;
                            return (0, $26SB8.html)(`
							<div>
								<ul class='flex flex-col items-center font-bold text-black '>
									<li>Ipca: ${ipcaPorcentagem}</li>
									<li>Pre: ${prePorcentagem}</li>
									<li>Pos: ${posPorcentagem}</li>
								</ul>
								<span class='font-bold text-primary-pure'>Total: ${totalGlobalPorcentagem?.valor?.toPrecision(3) || 0} </span>
							</div>
						`);
                        }
                    },
                    sort: false
                }
            ]
        };
    },
    methods: {
        openModal (id, politica) {
            this.$refs.modalResumo.OpenModalResumo({
                id: id,
                politica: politica,
                atendimentoID: null
            });
        },
        openFiltros () {
            modal_padrao_vue.openModal('investimentos_filtros');
        },
        iniciarTabelaGenerica (tableSelector, columns) {
            const table = document.querySelector(tableSelector);
            const gridInstance = new (0, $26SB8.Grid)({
                search: false,
                resizable: true,
                columns: columns,
                data: [],
                autoWidth: true,
                sort: false,
                style: {
                    container: {
                        border: 'none'
                    },
                    table: {
                        border: 'none',
                        'white-space': 'nowrap'
                    },
                    tr: {
                        border: 'none'
                    },
                    th: {
                        'border-bottom': '1px solid #e9ecef',
                        padding: '8px 8px'
                    },
                    td: {
                        'border-bottom': '1px solid #e9ecef',
                        color: '#495057',
                        'font-family': 'Roboto Flex',
                        'font-size': '13px',
                        'font-weight': 500,
                        'line-height': '150%',
                        'letter-spacing': '-0.28px',
                        padding: '4px',
                        'text align': 'center'
                    },
                    footer: {
                        border: ''
                    }
                },
                language: {
                    search: {
                        placeholder: 'Busque aqui...'
                    },
                    pagination: {
                        previous: ' Anterior',
                        next: "Pr\xf3ximo "
                    }
                }
            });
            gridInstance?.render(table);
            return gridInstance;
        },
        iniciartableInvestimentos () {
            this.tableInvestimentos = this.iniciarTabelaGenerica('#table_investimentos', this.columns);
        },
        async buscaDataApiInvestimentoComfiltro () {
            this.setQueryUrl();
            const { data: data } = await axios.get(`${$ef3f75cb9d6e65f0$var$URLS.investimentos_clientes_pf_api}${this.query}`);
            return data;
        },
        async buscaCardsApiInvestimentosBigNumber () {
            this.setQueryUrl();
            const { data: data } = await axios.get(`${$ef3f75cb9d6e65f0$var$URLS.investimentos_cards_clientes_pf_api}${this.query}`);
            return data;
        },
        openModalOnBotton (dados) {
        // this.openModal(id, politica)
        },
        formatValorBr (valor) {
            const numero = Number(valor);
            if (!Number.isNaN(numero)) return '$ ' + valor.toLocaleString('pt-BR', {
                minimumFractionDigits: 2
            });
        },
        formDataInvestimentosTotal (data) {
            return data.count ?? 0;
        },
        formatDataInvestimentosTable (data) {
            // console.log(data)
            // func para achatar o array tipos de investimentos para um objeto com campos para cada item do array
            const dataTransformado = data.results.map((dataItem)=>{
                const tiposInvestimentos = dataItem.tipos_investimento.reduce((tiposInvestimentosFields, tipoInvestimento)=>{
                    tipoInvestimento = {
                        ...tiposInvestimentosFields,
                        [tipoInvestimento.tipo_investimento]: {
                            valor: tipoInvestimento.percentual,
                            isSort: true
                        }
                    };
                    return tipoInvestimento;
                }, {});
                const { tipos_investimento: tipos_investimento, ...clientePf } = {
                    ...dataItem
                };
                return {
                    ...clientePf,
                    ...tiposInvestimentos
                };
            });
            if (dataTransformado.length > 0) {
                let totaisValores = {};
                Object.entries(data.media_investimentos_por_ativo).forEach(([keyMedia, valueMedia])=>{
                    totaisValores[keyMedia] = {
                        valor: valueMedia,
                        isSort: false
                    };
                });
                totaisValores['dados_investimento_renda_fixa'] = {
                    media: data.media_investimentos_por_ativo['Renda Fixa']
                };
                dataTransformado.forEach((itemDataTransformado)=>{
                    itemDataTransformado['dados_investimento_renda_fixa'] = {
                        ...itemDataTransformado.dados_investimento_renda_fixa,
                        totalGlobalPorcentagem: itemDataTransformado['Renda Fixa'] || {
                            valor: 0,
                            isSort: false
                        }
                    };
                });
                dataTransformado.push({
                    nome: 'Media',
                    ...totaisValores
                });
            }
            // console.log(dataTransformado)
            this.totalRegistros = data.count;
            return dataTransformado;
        },
        async setValuesInvestimentos () {
            const responseMetadadosInvestimentos = await $ef3f75cb9d6e65f0$var$getMetaDadosInvestimentos();
            this.setFiltroInvestimentos(responseMetadadosInvestimentos);
        /* this.setColunasInvestimentos(responseMetadadosInvestimentos) */ },
        setFiltroInvestimentos (data) {
            this.optionsOfficers = data?.todos_users.map((itemUser)=>{
                return {
                    label: itemUser.name,
                    value: itemUser.id
                };
            }).filter((itemUser)=>itemUser.label && itemUser.label.length > 1);
            this.optionsPolitica = $ef3f75cb9d6e65f0$var$politicasInfo;
            const urlParams = new URLSearchParams(window.location.search);
            const users = urlParams.get('user')?.trim().split(',');
            const page = urlParams.get('page')?.trim();
            const page_size = urlParams.get('page_size')?.trim();
            this.model.currentPage = page ?? this.model.currentPage;
            this.model.paginationLimitInvestimentos = page_size ?? this.model.paginationLimitInvestimentos;
            this.model.filtrarInvestimentos = users?.map((itemUser)=>parseInt(itemUser)).filter((itemUser)=>{
                return this.optionsOfficers.find((itemOfficer)=>itemOfficer.value === itemUser);
            }) || [];
        },
        setColunasInvestimentos (data) {
        /* this.columns.push(
			this.optionsPolitica = politicasInfo

			const tiposInvestimentos =
				responseMetadadosInvestimentos.tipos_investimento
			this.columns.push(
				...tiposInvestimentos
					.filter((tipoInvestimentos) => tipoInvestimentos !== 'Renda Fixa')
					.map((tipoInvestimentoColumn) => {
						return {
							id: tipoInvestimentoColumn,
							name: tipoInvestimentoColumn,
							width: '5rem',
							minWidth: '5rem',
							attributes: {
								'contet-column': true,
								title: tipoInvestimentoColumn,
							},
							formatter: (cell, row) => {
								if (cell && !isNaN(cell.valor)) {
									const valorPorcetagemInvestimento = cell.valor.toPrecision(3)

									if (row?._cells[2]?.data === 'Media') {
										return htmlGrid(
											`
									<div style='width: 100%; height: 50px; '> 
										<span style='color: black; font-weight: bold;'>${valorPorcetagemInvestimento}%</span>
									</div>	
									`
										)
									}

									const lightnessMax = 90
									const lightnessMin = 30

									const lightness =
										lightnessMax -
										(cell.valor / 100) * (lightnessMax - lightnessMin)
									const colorBg = `hsl(0, 80%, ${lightness}%)`

									return htmlGrid(
										`
								<div style='background-color:${colorBg}; width: 100%; height: 100%; color: white;'> 
									<span>${valorPorcetagemInvestimento}%</span>
								</div>	
								`
									)
								} else {
									return htmlGrid(`<span style='color: black;'>0</span>`)
								}
							},
							sort: {
								compare(a, b) {
									let auxA = a?.valor
									let auxB = b?.valor

									if (a && !a.isSort) {
										return 0
									}

									if (isNaN(auxA)) {
										auxA = 0.0
									}

									if (isNaN(auxB)) {
										auxB = 0.0
									}

									if (auxA > auxB) {
										return 1
									} else if (auxA < auxB) {
										return -1
									}
									return 0
								},
							},
						}
					})
			) */ },
        async updateTabelaInvestimentos () {
            try {
                if (this.tableInvestimentos) {
                    this.isLoading = true;
                    this.isLoadingCards = true;
                    const responseClienteInvestimentos = await this.buscaDataApiInvestimentoComfiltro();
                    const dataTransformado = this.formatDataInvestimentosTable(responseClienteInvestimentos);
                    this.updateColumnsTabelaInvestimentops(responseClienteInvestimentos);
                    this.tableInvestimentos?.updateConfig({
                        data: dataTransformado,
                        columns: this.columns
                    })?.forceRender();
                    this.$nextTick(async ()=>{
                        try {
                            const responseCardInvestimentos = await this.buscaCardsApiInvestimentosBigNumber();
                            this.formatCardsBigNumbers(responseCardInvestimentos);
                        } catch (e) {
                            console.log(e);
                        } finally{
                            this.isLoadingCards = false;
                        }
                    });
                }
            } catch (err) {
                console.error(err);
            } finally{
                this.isLoading = false;
            }
        },
        updateColumnsTabelaInvestimentops (dataInvestimento) {
            const tiposInvestimentos = this.filtraColunasZeradasDataTransformado(dataInvestimento);
            this.columns = this.columns.slice(0, 5);
            this.columns.push(...tiposInvestimentos.filter((tipoInvestimentos)=>tipoInvestimentos !== 'Renda Fixa').map((tipoInvestimentoColumn)=>{
                return {
                    id: tipoInvestimentoColumn,
                    name: tipoInvestimentoColumn,
                    width: '5rem',
                    minWidth: '5rem',
                    attributes: {
                        'contet-column': true,
                        title: tipoInvestimentoColumn
                    },
                    formatter: (cell, row)=>{
                        if (cell && !isNaN(cell.valor)) {
                            const valorPorcetagemInvestimento = cell.valor.toFixed(2);
                            if (row?._cells[2]?.data === 'Media') return (0, $26SB8.html)(`
								<div style='width: 100%; height: 50px; '> 
									<span style='color: black; font-weight: bold;'>${valorPorcetagemInvestimento}%</span>
								</div>  
								`);
                            const lightnessMax = 90;
                            const lightnessMin = 30;
                            const lightness = lightnessMax - cell.valor / 100 * (lightnessMax - lightnessMin);
                            const colorBg = `hsl(0, 80%, ${lightness}%)`;
                            return (0, $26SB8.html)(`
							<div style='background-color:${colorBg}; width: 100%; height: 100%; color: white;'> 
								<span>${valorPorcetagemInvestimento}%</span>
							</div>  
							`);
                        } else return (0, $26SB8.html)(`<span style='color: black;'>0</span>`);
                    },
                    sort: {
                        compare (a, b) {
                            let auxA = a?.valor;
                            let auxB = b?.valor;
                            if (a && !a.isSort) return 0;
                            if (isNaN(auxA)) auxA = 0.0;
                            if (isNaN(auxB)) auxB = 0.0;
                            if (auxA > auxB) return 1;
                            else if (auxA < auxB) return -1;
                            return 0;
                        }
                    }
                };
            }));
        },
        filtraColunasZeradasDataTransformado (dataInvestimento) {
            return Object.keys(dataInvestimento.media_investimentos_por_ativo);
        },
        setQueryUrl () {
            const urlSearchParams = new URLSearchParams();
            this.query = '?';
            const idUsers = this.model?.filtroOfficer?.map((user)=>user.value || user);
            const userJoin = idUsers?.filter((idUser)=>idUser)?.join(',');
            if (userJoin) urlSearchParams.append('user', userJoin);
            if (Array.isArray(this.model?.filtroPolitica) && this.model?.filtroPolitica?.length > 0) {
                const politicasJoin = this.model?.filtroPolitica?.map((itemPolitica)=>itemPolitica.value);
                urlSearchParams.append('politica', politicasJoin);
            }
            if (this.model?.filtroMin) urlSearchParams.append('minimo', this.model?.filtroMin);
            if (this.model?.filtroMax) urlSearchParams.append('maximo', this.model?.filtroMax);
            urlSearchParams.append('page', this.model.currentPage);
            urlSearchParams.append('page_size', this.model.paginationLimitInvestimentos);
            this.query += urlSearchParams.toString();
            window.history.pushState({}, '', this.query);
        },
        async filtrarInvestimentos () {
            this.model.currentPage = 1;
            $ef3f75cb9d6e65f0$var$isServLoad = false;
            this.closeFiltroInvestimentos();
            await this.updateTabelaInvestimentos();
        //window.location.href = `${window.location.origin}/clientes/investimentos/clientes_pf/${this.query}`
        },
        limparFiltroInvestimentos () {
            this.model = {
                filtroOfficer: null,
                filtroPolitica: null,
                filtroMin: null,
                filtroMax: null
            };
            window.location.href = `${window.location.origin}/clientes/investimentos/clientes_pf/`;
        },
        closeFiltroInvestimentos () {
            const filtroInvestimentos = document.getElementById('close_filtro_investimentos');
            if (filtroInvestimentos) filtroInvestimentos.click();
        },
        async addChangeHandlerPaginationLimitFilter (e) {
            this.model.currentPage = 1;
            $ef3f75cb9d6e65f0$var$isServLoad = false;
            await this.$nextTick();
            await this.updateTabelaInvestimentos();
            $ef3f75cb9d6e65f0$var$isServLoad = true;
        },
        formatCardsBigNumbers (data) {
            const { total_investido_por_ativo: total_investido_por_ativo, media_investimentos_por_ativo_todos_clientes: media_investimentos_por_ativo_todos_clientes, media_dados_investimento_renda_fixa_total: media_dados_investimento_renda_fixa_total } = data;
            this.totalInvestidoPorAtivo = Object.entries(total_investido_por_ativo).map(([chave, valor])=>{
                const mediaCategoria = media_investimentos_por_ativo_todos_clientes[chave];
                const ativo = {
                    label: chave,
                    mediaTotal: mediaCategoria,
                    valorTotal: valor
                };
                if (chave === 'Renda Fixa') ativo.subRenda = media_dados_investimento_renda_fixa_total;
                return ativo;
            });
            console.log(this.totalInvestidoPorAtivo);
        },
        getScrollElement () {
            return this.$refs.gridContainer?.querySelector('.gridjs-wrapper');
        },
        scrollUp () {
            window.scrollBy({
                top: -50,
                behavior: 'smooth'
            });
        },
        scrollDown () {
            window.scrollBy({
                top: 50,
                behavior: 'smooth'
            });
        },
        scrollLeft () {
            const container = this.getScrollElement();
            if (container) container.scrollBy({
                left: -50,
                behavior: 'smooth'
            });
        },
        scrollRight () {
            const container = this.getScrollElement();
            if (container) container.scrollBy({
                left: 50,
                behavior: 'smooth'
            });
        },
        investimentoFormated (investimento) {
            if (investimento == '-' || investimento?.toString().toLowerCase() == 'none') return '-';
            const value = $ef3f75cb9d6e65f0$var$FormatREALVirgula(investimento.toString());
            return value;
        }
    },
    computed: {
        maxPagesTable () {
            return this.totalRegistros / this.model.paginationLimitInvestimentos;
        },
        totalInvestidoPorAtivoView () {
            if (this.totalInvestidoPorAtivo) {
                const aux = this.totalInvestidoPorAtivo.map((item)=>{
                    const ativo = {
                        titulo: item.label,
                        totalValor: item.valorTotal,
                        totalPorcent: item.mediaTotal
                    };
                    if (item.label === 'Renda Fixa') ativo.subTipo = {
                        Ipca: item.subRenda.data_ipca.toFixed(2),
                        Pre: item.subRenda.data_pre.toFixed(2),
                        Pos: item.subRenda.data_pos.toFixed(2),
                        Total: (item.subRenda.data_pre + item.subRenda.data_pos + item.subRenda.data_ipca).toFixed(2)
                    };
                    return ativo;
                });
                console.log(aux);
                return aux;
            }
            return [];
        }
    },
    watch: {
        'model.currentPage': {
            async handler (newValue, oldValue) {
                const auxCurrentPage = typeof newValue === 'string' ? parseInt(newValue) : newValue;
                const auxOldPage = typeof oldValue === 'string' ? parseInt(oldValue) : oldValue;
                if (auxCurrentPage !== auxOldPage && $ef3f75cb9d6e65f0$var$isServLoad) await this.updateTabelaInvestimentos();
                $ef3f75cb9d6e65f0$var$isServLoad = true;
            }
        }
    },
    async mounted () {
        this.setQueryUrl();
        this.iniciartableInvestimentos();
        await this.updateTabelaInvestimentos();
        await this.setValuesInvestimentos();
        document.getElementById('choice_pagination_investimentos').addEventListener('change', this.addChangeHandlerPaginationLimitFilter);
    },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("2Tg8R", function(module, exports) {

$parcel$export(module.exports, "investimentosService", function () { return $21ad3d43b65f56dc$export$50a24f418a2162d6; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $21ad3d43b65f56dc$export$50a24f418a2162d6() {
    const api = (0, $c8Lpu.useApi)();
    async function getInvestimentosPf(query = '') {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).investimentos_clientes_pf_api}${query}`);
    }
    async function getMetaDadosInvestimentos(query = '') {
        return api.query(`${window.origin}${(0, $9YhWF.URLS).investimentos_clientes_pf_api}${query}`);
    }
    return {
        getInvestimentosPf: getInvestimentosPf,
        getMetaDadosInvestimentos: getMetaDadosInvestimentos
    };
}

});

parcelRegister("iM82Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dab2f3385e5b9d10$export$2e2bcd8739ae039; });
var $dab2f3385e5b9d10$export$2e2bcd8739ae039 = {
    props: {
        max: {
            type: Number,
            default: 10
        },
        modelValue: {
            type: Number,
            default: 1
        }
    },
    emits: [
        'update:modelValue'
    ],
    computed: {
        current: {
            get () {
                return this.modelValue;
            },
            set (newValue) {
                this.$emit('update:modelValue', newValue);
            }
        }
    },
    template: `
    <div class="q-pa-lg flex flex-center">
        <q-pagination
        v-model="current"
        :max="max"
        :max-pages="5"
        direction-links
        flat
        />
  </div>
    `
};

});

parcelRegister("fcmEd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1098b5b47ee1cb1$export$2e2bcd8739ae039; });
var $b1098b5b47ee1cb1$export$2e2bcd8739ae039 = {
    props: {
        totalPorcent: {
            type: Number
        },
        totalValor: {
            type: Number
        },
        subTipo: {},
        titulo: {
            type: String
        }
    },
    computed: {
        subTipoView () {
            return Object.entries(this.subTipo).map(([chave, valor])=>{
                const chaveCapitalizada = chave[0].toUpperCase() + chave.slice(1);
                return {
                    label: chaveCapitalizada,
                    value: valor
                };
            });
        }
    },
    template: html` <div
		class="rounded-lg border border-neutral-30 !p-12 !w-[11rem] space-y-10">
		<div class="flex items-center justify-between">
			<span class="text-xl text-neutral-75 font-semibold truncate">{{titulo}}</span>
			<q-icon
				v-if="subTipo"
				name="info"
				size="1.6rem"
				color="neutral-75"
				class="cursor-pointer">
				<q-tooltip anchor="bottom right" :offset="[10, 10]">
					<div class="rounded-lg bg-white p-14 shadow-lg">
						<p
							v-for="(item,index) of subTipoView"
							class="flex justify-between items-center gap-x-12"
							:key="index">
							<strong>{{item.label}}:</strong>
							<span class="text-neutral-75">{{item.value}}%</span>
						</p>
					</div>
				</q-tooltip>
			</q-icon>
		</div>
		<div>
			<p class="text-2xl font-bold text-[#0e171e]">{{totalPorcent}}%</p>
		</div>
		<div>
			<span class="text-neutral-75">R$ {{totalValor}}</span>
		</div>
	</div>`
};

});


parcelRegister("84v9a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e06db92831c8f66$export$2e2bcd8739ae039; });

var $3xKh9 = parcelRequire("3xKh9");

var $cxOGa = parcelRequire("cxOGa");

var $dJYFV = parcelRequire("dJYFV");

var $kOH5f = parcelRequire("kOH5f");

var $2RZZR = parcelRequire("2RZZR");

var $hFNAS = parcelRequire("hFNAS");

var $hmmUY = parcelRequire("hmmUY");

var $jzAJi = parcelRequire("jzAJi");

var $i5cs0 = parcelRequire("i5cs0");
const { getClientesPf: $5e06db92831c8f66$var$getClientesPf } = (0, $hFNAS.clientePfService)();
const { getFundacoes: $5e06db92831c8f66$var$getFundacoes, getInformacoesFundacao: $5e06db92831c8f66$var$getInformacoesFundacao } = (0, $hmmUY.fundacaoService)();
const { getInfoAtendimentoCliente: $5e06db92831c8f66$var$getInfoAtendimentoCliente } = (0, $jzAJi.clientAssetsService)();
const { showToastify: $5e06db92831c8f66$var$showToastify } = GLOBAL;
const $5e06db92831c8f66$var$TIPO_USUARIO = {
    CLIENTE_PF: 'PF',
    FUNDACAO: 'FUNDACAO'
};
var $5e06db92831c8f66$export$2e2bcd8739ae039 = {
    props: {},
    emits: [],
    mixins: [
        (0, $kOH5f.default),
        (0, $i5cs0.default)
    ],
    components: {
        Calendario: $3xKh9.default,
        ModalInfoEventoCalendario: $cxOGa.default,
        ModalNovoEventoCalendario: $dJYFV.default,
        InfoEventoCalendario: $2RZZR.default
    },
    data () {
        return {
            eventosCalendario: [],
            infoEventoCalendario: null,
            isEditModoEvento: false,
            editEventoCalendario: null,
            elementoEventoSelecionado: null,
            exibirInfoEvento: false,
            usuarioSelecionadoCalendario: null,
            optionsSelectCliente: [],
            optionsAtendimentoUsuario: [],
            optionsUsuariosCalendarios: [],
            isDoubleClick: false,
            isOpenModalNovoEvento: true,
            calendarioModoType: null,
            data: {
                cliente: {
                    data: null,
                    next: null,
                    previous: null
                },
                fundacao: {
                    data: null,
                    next: null,
                    previous: null
                }
            },
            loading: {
                todosUsuarios: false,
                isFirstLoad: false,
                carregandoEventos: false
            }
        };
    },
    computed: {
        menuAnchor () {
            return this.calendarioModoType === 'timeGridWeek' || this.calendarioModoType === 'timeGridDay' ? 'center right' : 'bottom right';
        },
        menuSelf () {
            return this.calendarioModoType === 'timeGridWeek' || this.calendarioModoType === 'timeGridDay' ? 'center left' : 'bottom left';
        },
        menuOffset () {
            return this.calendarioModoType === 'timeGridWeek' || this.calendarioModoType === 'timeGridDay' ? [
                10,
                0
            ] : [
                10,
                10
            ];
        },
        loadingEventoCalendario () {
            return this.isEditModoEvento ? this.loading.atualizaEvento : this.loading.novoEvento;
        },
        deleteLoadingEventoCalendario () {
            return this.loading.deletaEvento;
        }
    },
    watch: {
        async usuarioSelecionadoCalendario (newVal) {
            if (newVal) await this.carregarEventosCalendarioUsuarioSelecionado();
            else await this.carregarEventosCalendario();
        }
    },
    methods: {
        async authEmail () {
            const responseCalendario = await this.calendarioAuth();
            if (responseCalendario && responseCalendario.auth_url) window.open(responseCalendario.auth_url, '_blank');
        },
        openModalNovoEventoCalendario () {
            modal_padrao_vue.openModal('modal_novo_evento_calendario');
            const modais = document.querySelectorAll('[data-active="modal_novo_evento_calendario"]');
            modais.forEach((modal)=>{
                modal.style.width = '48rem';
            });
            this.isOpenModalNovoEvento = true;
        },
        openModalInfoEventoCalendario () {
            modal_padrao_vue.openModal('modal_info_evento_calendario');
            const modais = document.querySelectorAll('[data-active="modal_info_evento_calendario"]');
            modais.forEach((modal)=>{
                modal.style.width = '19rem';
                modal.style.minWidth = '1rem';
                modal.style.height = 'content';
                modal.style.minHeight = '1rem';
            });
        },
        closeModalNovoEventoCalendario () {
            this.$refs.modalNovoEvento.resetarCamposModal();
            this.isEditModoEvento = false;
            this.isDoubleClick = false;
            this.editEventoCalendario = null;
            this.isOpenModalNovoEvento = false;
            modal_padrao_vue.closeModal('modal_novo_evento_calendario');
        },
        closeModalInfoEventoCalendario () {
            this.exibirInfoEvento = null;
        },
        formatarConvidadosApi (convidados) {
            return convidados.map((email)=>({
                    emailAddress: {
                        address: email,
                        name: email.split('@')[0]
                    },
                    type: 'required'
                }));
        },
        onClickInfoCalendario (evento) {
            this.calendarioModoType = evento.view.type;
            this.infoEventoCalendario = evento.event._def;
            this.elementoEventoSelecionado = evento.el;
            this.exibirInfoEvento = true;
        },
        onClickEditEventoCalendario () {
            const idEvento = this.infoEventoCalendario?.publicId || null;
            const evento = this.eventosCalendario.find((ev)=>ev.id === idEvento);
            if (evento) {
                this.isEditModoEvento = true;
                this.editEventoCalendario = evento;
                this.closeModalInfoEventoCalendario();
                setTimeout(()=>{
                    this.openModalNovoEventoCalendario();
                }, 500);
            }
        },
        onDoubleClickEditEventoCalendario (evento) {
            const idEvento = evento.event._def.publicId || evento.event.id;
            const eventoEdit = this.eventosCalendario.find((ev)=>ev.id === idEvento);
            if (eventoEdit) {
                this.exibirInfoEvento = false;
                this.isEditModoEvento = true;
                this.isDoubleClick = true;
                this.editEventoCalendario = eventoEdit;
                this.openModalNovoEventoCalendario();
            }
        },
        montarPayloadEvento (data) {
            const payload = {
                subject: data.titulo,
                start: {
                    dateTime: data.dataEventoInicio,
                    timeZone: 'America/Sao_Paulo'
                },
                end: {
                    dateTime: data.dataEventoFim,
                    timeZone: 'America/Sao_Paulo'
                },
                location: {
                    displayName: data.localEvento || ''
                },
                attendees: this.formatarConvidadosApi(data.convidados),
                isAllDay: !!data.isDiaInteiro,
                isOnlineMeeting: !!data.isTeams,
                body: {
                    contentType: 'HTML',
                    content: data.descricaoEvento || ''
                },
                id: data?.id,
                isReminderOn: !!data.lembreteAtendimento,
                reminderMinutesBeforeStart: data.lembreteAtendimento || 0,
                atendimento_data: {
                    gerar_atendimento: data.tipoClienteAtendimento,
                    cliente_id: data.usuarioSelecionado?.id || null,
                    tipo: data.tipoAtendimento,
                    politica_atendimento_id: data?.dataPolitica || null
                }
            };
            return payload;
        },
        async initOptionsSelectCliente () {
            try {
                this.loading.todosUsuarios = true;
                await Promise.all([
                    this.setClientesPfs(),
                    this.setFundacoes()
                ]);
                const optionClientePf = this.data.cliente?.data?.map((cliente)=>({
                        label: cliente.nome,
                        value: {
                            id: cliente.id,
                            tipo: $5e06db92831c8f66$var$TIPO_USUARIO.CLIENTE_PF
                        }
                    })) || [];
                const optionFundacao = this.data.fundacao?.data?.map((fundacao)=>({
                        label: fundacao.sigla,
                        value: {
                            id: fundacao.id,
                            tipo: $5e06db92831c8f66$var$TIPO_USUARIO.FUNDACAO
                        }
                    })) || [];
                this.optionsSelectCliente = [
                    ...optionClientePf,
                    ...optionFundacao
                ];
            } finally{
                this.loading.todosUsuarios = false;
            }
        },
        async initOpionsUsuariosCalendarios () {
            try {
                this.loading.todosUsuarios = true;
                const usuariosCalendarios = await this.buscarUsuariosCalendarios();
                this.optionsUsuariosCalendarios = usuariosCalendarios.map((usuario)=>({
                        label: usuario.displayName,
                        value: usuario.id
                    })) || [];
            } finally{
                this.loading.todosUsuarios = false;
            }
        },
        async setClientesPfs (page = 1, search = '') {
            try {
                const params = {
                    page: page,
                    search: search
                };
                const responseClientes = await $5e06db92831c8f66$var$getClientesPf(params);
                this.data.cliente.data = responseClientes?.results || [];
                this.data.cliente.next = responseClientes?.next || null;
                this.data.cliente.previous = responseClientes?.previous || null;
            } catch (error) {
                console.error('Erro ao buscar clientes PF:', error);
            }
        },
        async setFundacoes (page = 1, search = '') {
            try {
                const params = {
                    page: page,
                    search: search
                };
                const responseFundacoes = await $5e06db92831c8f66$var$getFundacoes(params);
                this.data.fundacao.data = responseFundacoes?.results || [];
                this.data.fundacao.next = responseFundacoes?.next || null;
                this.data.fundacao.previous = responseFundacoes?.previous || null;
            } catch (error) {
                console.error("Erro ao buscar funda\xe7\xf5es:", error);
            }
        },
        async carregarEventosCalendario () {
            this.loading.carregandoEventos = true;
            try {
                this.eventosCalendario = await this.buscarEventosFormatados();
            } catch (error) {
                console.error("Erro ao carregar eventos do calend\xe1rio:", error);
            } finally{
                this.loading.carregandoEventos = false;
            }
        },
        async carregarEventosCalendarioUsuarioSelecionado () {
            this.loading.carregandoEventos = true;
            try {
                this.eventosCalendario = await this.buscarEventosUsuarioSelecionadoFormatados({
                    id: this.usuarioSelecionadoCalendario?.value
                });
            } catch (error) {
                console.error("Erro ao carregar eventos do calend\xe1rio:", error);
            } finally{
                this.loading.carregandoEventos = false;
            }
        },
        async criarEventoCalendario (data) {
            const payload = this.montarPayloadEvento(data);
            await this.criarEvento(payload);
            if (!this.error.novoEvento && this.loading.novoEvento === false) {
                $5e06db92831c8f66$var$showToastify("\u2705 Evento criado com sucesso.");
                this.closeModalNovoEventoCalendario();
                await this.carregarEventosCalendario();
            }
        },
        async atualizarEventoCalendario (data) {
            const payload = this.montarPayloadEvento(data);
            await this.atualizarEvento(payload);
            if (!this.error.atualizaEvento && this.loading.atualizaEvento === false) {
                $5e06db92831c8f66$var$showToastify("\u2705 Evento atualizado com sucesso.");
                this.closeModalNovoEventoCalendario();
                await this.carregarEventosCalendario();
            }
        },
        async excluirCalendario (id, data) {
            if (!id) return;
            const payload = {
                body: {
                    contentType: 'HTML',
                    content: data?.mensagemExclusao || ''
                }
            };
            await this.deletarEvento(id, payload);
            if (!this.error.deletaEvento && this.loading.deletaEvento === false) {
                $5e06db92831c8f66$var$showToastify("\u2705 Evento exclu\xeddo com sucesso.");
                this.closeModalInfoEventoCalendario();
                this.closeModalNovoEventoCalendario();
                await this.carregarEventosCalendario();
            }
        },
        async checkIsAutenticado () {
            if (this.eventosCalendario === null) await this.authEmail();
        },
        async initAllConfigs () {
            await this.carregarEventosCalendario();
            await this.checkIsAutenticado();
            await this.initOpionsUsuariosCalendarios();
        },
        checkGestorFundacao () {
            if (this.acessSAI) document.body.classList.add('sai');
        }
    },
    async mounted () {
        this.loading.isFirstLoad = true;
        try {
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            await this.initAllConfigs();
        } catch (error) {
            console.error("Erro ao carregar eventos do calend\xe1rio:", error);
        } finally{
            this.loading.isFirstLoad = false;
            setTimeout(()=>{
                this.checkGestorFundacao();
                console.log("P\xe1gina Calend\xe1rio de Reuni\xf5es carregada.");
            }, 200);
        }
    /* await this.initOptionsSelectCliente() */ },
    delimiters: [
        '{*',
        '*}'
    ]
};

});
parcelRegister("3xKh9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2948598e3eb83720$export$2e2bcd8739ae039; });

var $jnteQ = parcelRequire("jnteQ");

var $kiP87 = parcelRequire("kiP87");

var $a3lgF = parcelRequire("a3lgF");

var $azIjx = parcelRequire("azIjx");

var $7lZL8 = parcelRequire("7lZL8");

var $g8vIm = parcelRequire("g8vIm");

var $5q0Z8 = parcelRequire("5q0Z8");

var $YrtCO = parcelRequire("YrtCO");
parcelRequire("i5cs0");
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5q0Z8))));
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($YrtCO))));
const $2948598e3eb83720$var$hoje = new Date();
$2948598e3eb83720$var$hoje.setHours(0, 0, 0, 0);
var $2948598e3eb83720$export$2e2bcd8739ae039 = {
    props: [
        'eventos',
        'hidenUsuarioSelecionado',
        'hidenMultiselectClientes',
        'bgColorCalendario',
        'optionsClientes',
        'usuarioSelecionado'
    ],
    emits: [
        'click:eventoCalendario',
        'click:novoEvento',
        'doubleClick:eventoCalendario',
        'update:usuarioSelecionado'
    ],
    data () {
        return {
            calendar: null,
            clickTimeout: null,
            optionsClientesFiltradas: [
                ...this.optionsClientes
            ],
            tituloCalendario: '',
            viewAtual: 'dayGridMonth'
        };
    },
    watch: {
        eventos: {
            handler (newValue) {
                if (this.calendar) {
                    const eventosConvertidos = this.convertEventosParaCalendario(newValue);
                    this.calendar.removeAllEvents();
                    this.calendar.addEventSource(eventosConvertidos);
                }
            },
            deep: true
        }
    },
    methods: {
        filterClientes (val, update, abort) {
            if (val === '') {
                update(()=>{
                    this.optionsClientesFiltradas = this.optionsClientes;
                });
                return;
            }
            update(()=>{
                const search = val.toLowerCase();
                this.optionsClientesFiltradas = this.optionsClientes.filter((option)=>{
                    if (typeof option === 'object' && option.label) return option.label.toLowerCase().indexOf(search) > -1;
                    return option.toLowerCase().indexOf(search) > -1;
                });
                console.log('optionsClientesFiltradas', this.optionsClientesFiltradas);
            });
        },
        onUsuarioSelecionadoChange (valor) {
            this.$emit('update:usuarioSelecionado', valor);
        },
        initCalendario () {
            let calendarEl = document.getElementById('calendar');
            this.calendar = new (0, $jnteQ.Calendar)(calendarEl, {
                plugins: [
                    (0, $kiP87.default),
                    (0, $a3lgF.default),
                    (0, $azIjx.default)
                ],
                locale: (0, $7lZL8.default),
                timeZone: 'UTC',
                initialView: 'dayGridMonth',
                displayEventTime: true,
                customButtons: {
                    buttonNovoEvento: {
                        text: 'Novo Evento',
                        click: ()=>{
                            this.$emit('click:novoEvento');
                        }
                    }
                },
                /* headerToolbar: {
					left: this.hidenUsuarioSelecionado
						? 'prev,next today'
						: 'prev,next today buttonNovoEvento',
					center: 'title',
					right: 'dayGridMonth',
					// right: 'dayGridMonth,timeGridWeek,listWeek', 
				},*/ headerToolbar: false,
                events: this.convertEventosParaCalendario(this.eventos),
                eventContent: (arg)=>{
                    const agora = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))().tz('America/Sao_Paulo');
                    const dataEventoFim = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(arg.event.extendedProps.dataEventoFim);
                    const corBolinha = agora.isAfter(dataEventoFim) ? 'bg-[#969ea6]' : 'bg-[#3f9df8]';
                    const timeText = arg.event.extendedProps.isDiaInteiro ? 'Dia Inteiro' : this.padTimeText(arg.timeText);
                    let htmlContent = '';
                    if (this.calendar.view.type === 'dayGridMonth') htmlContent = `
							<div class="flex items-start !gap-x-4 w-full overflow-x-hidden p-4 cursor-pointer">
								<div class="flex items-center !gap-x-2">
									<span class="inline-block size-8 rounded-full ${corBolinha} mr-2"></span>
									<label class="text-paragraph-3">${timeText}</label>
								</div>
								<label> - </label>
								<p class="
									text-paragraph-3 
									text-bold 
									break-words 
									whitespace-normal">${arg.event.title}</p>
							</div>
						`;
                    else htmlContent = `
						<a href="#" class="block !no-underline">	
							<div class="w-full overflow-x-hidden p-4 cursor-pointer">
								<p class="
									text-paragraph-3 
									text-bold 
									break-words 
									whitespace-normal">${arg.event.title}</p>
							</div>
						</a>
						`;
                    return {
                        html: htmlContent
                    };
                },
                eventDidMount: (info)=>{
                    if (info.event.extendedProps.isEventoPassado) info.el.classList.add('evento-passado');
                },
                eventClick: (info)=>{
                    info.jsEvent.preventDefault();
                    info.jsEvent.stopPropagation();
                    if (this.clickTimeout && !this.hidenUsuarioSelecionado) {
                        clearTimeout(this.clickTimeout);
                        this.clickTimeout = null;
                        this.$emit('doubleClick:eventoCalendario', info);
                        return;
                    }
                    this.clickTimeout = setTimeout(()=>{
                        clearTimeout(this.clickTimeout);
                        this.$emit('click:eventoCalendario', info);
                        this.clickTimeout = null;
                    }, 500);
                }
            });
            this.calendar.render();
            this.tituloCalendario = this.calendar.view.title;
            this.viewAtual = this.calendar.view.type;
            console.log(this.calendar.view.title);
            return this.calendar;
        },
        convertEventosParaCalendario (eventos) {
            const eventosConvertidos = eventos?.map((evt)=>{
                let dataEventoInicio, dataEventoFim, start, end;
                const classNames = [];
                classNames.push(`evento-calendario`);
                if (evt.isDiaInteiro) {
                    dataEventoInicio = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).utc(evt.dataEventoInicio).format('YYYY-MM-DDT00:00:00');
                    dataEventoFim = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).utc(evt.dataEventoFim).format('YYYY-MM-DDT00:00:00');
                    start = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).utc(evt.start).format('YYYY-MM-DDT00:00:00');
                    end = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).utc(evt.end).format('YYYY-MM-DDT00:00:00');
                } else {
                    dataEventoInicio = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).utc(evt.dataEventoInicio).tz('America/Sao_Paulo').format();
                    dataEventoFim = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).utc(evt.dataEventoFim).tz('America/Sao_Paulo').format();
                    start = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).utc(evt.start).tz('America/Sao_Paulo').format();
                    end = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).utc(evt.end).tz('America/Sao_Paulo').format();
                }
                return {
                    ...evt,
                    dataEventoInicio: dataEventoInicio,
                    dataEventoFim: dataEventoFim,
                    start: start,
                    end: end,
                    classNames: classNames
                };
            });
            return eventosConvertidos;
        },
        padTimeText (timeText) {
            if (/^\d{1,2}$/.test(timeText)) return `${timeText}:00`;
            return timeText;
        },
        setEventosCalendario () {
            if (this.calendar) {
                document.querySelector('[data-calendar="btn-voltar"]')?.addEventListener('click', ()=>{
                    this.calendar.prev();
                    this.$nextTick(()=>{
                        this.tituloCalendario = this.calendar.view.title;
                    });
                });
                document.querySelector('[data-calendar="btn-avancar"]')?.addEventListener('click', ()=>{
                    this.calendar.next();
                    this.$nextTick(()=>{
                        this.tituloCalendario = this.calendar.view.title;
                    });
                });
                document.querySelector('[data-calendar="btn-hoje"]')?.addEventListener('click', ()=>{
                    this.calendar.today();
                    this.$nextTick(()=>{
                        this.tituloCalendario = this.calendar.view.title;
                    });
                });
                document.querySelector('[data-calendar="btn-novo-evento"]')?.addEventListener('click', ()=>{
                    this.$emit('click:novoEvento');
                });
                document.querySelector('[data-calendar="btn-mes"]')?.addEventListener('click', ()=>{
                    this.calendar.changeView('dayGridMonth');
                    this.viewAtual = 'dayGridMonth';
                    this.$nextTick(()=>{
                        this.tituloCalendario = this.calendar.view.title;
                    });
                });
                document.querySelector('[data-calendar="btn-semana"]')?.addEventListener('click', ()=>{
                    this.calendar.changeView('listWeek');
                    this.viewAtual = 'listWeek';
                    this.$nextTick(()=>{
                        this.tituloCalendario = this.calendar.view.title;
                    });
                });
                document.querySelector('[data-calendar="btn-dia"]')?.addEventListener('click', ()=>{
                    this.calendar.changeView('listDay');
                    this.viewAtual = 'listDay';
                    this.$nextTick(()=>{
                        this.tituloCalendario = this.calendar.view.title;
                    });
                });
            }
        }
    },
    mounted () {
        this.initCalendario();
        this.setEventosCalendario();
    },
    template: `
	<div class="w-full h-full space-y-20">
		<div class="flex items-center justify-between w-full">
			<div class="flex items-center justify-between max-w-max gap-8">
				<div class="space-x-8">
					<q-btn icon="arrow_back_ios" size="8px" color="primary" data-calendar="btn-voltar" />
					<q-btn icon="arrow_forward_ios" size="8px" color="primary" data-calendar="btn-avancar"/>
				</div>
				<q-btn label="Hoje" color="primary" data-calendar="btn-hoje"/>
				<q-btn v-if="!hidenUsuarioSelecionado" label="Novo Evento" color="primary" data-calendar="btn-novo-evento"/>

				<q-select
					v-if="!hidenMultiselectClientes"
					v-model="usuarioSelecionado" 
					use-input
    				input-debounce="300" 
					clearable
					label="Selecione o Officer" 
					label-color="neutral-70" 
					autocomplete="off"
					:options="optionsClientesFiltradas"
					class="calendar-header-select w-min"
					@update:model-value="onUsuarioSelecionadoChange"
					@filter="filterClientes"/>
			
			</div>

			<div :class="{'flex-1 pl-120': !hidenMultiselectClientes}">
				<h2 class="text-title-3 text-gray-700 !w-max">{{tituloCalendario}}</h2>
			</div>

			<div class="flex items-center gap-x-16 min-w-max">
				<q-btn label="M\xeas" color="primary" data-calendar="btn-mes"/>
				<q-btn label="Semana" color="primary" data-calendar="btn-semana"/>
				<q-btn label="Dia" color="primary" data-calendar="btn-dia"/>
			</div>
		</div>
        <div id="calendar"></div>
	</div>
    `
};

});
parcelRegister("jnteQ", function(module, exports) {

$parcel$export(module.exports, "createPlugin", function () { return $e1b6d86ea162c3dc$export$ae829ec7b2625219; });
$parcel$export(module.exports, "Calendar", function () { return $e1b6d86ea162c3dc$export$e1aef45b828286de; });

var $9b1rB = parcelRequire("9b1rB");

var $bvID6 = parcelRequire("bvID6");
parcelRequire("fz456");
const $e1b6d86ea162c3dc$export$794e7bef9c0b12d9 = [];
const $e1b6d86ea162c3dc$var$MINIMAL_RAW_EN_LOCALE = {
    code: 'en',
    week: {
        dow: 0,
        doy: 4
    },
    direction: 'ltr',
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list'
    },
    weekText: 'W',
    weekTextLong: 'Week',
    closeHint: 'Close',
    timeHint: 'Time',
    eventHint: 'Event',
    allDayText: 'all-day',
    moreLinkText: 'more',
    noEventsText: 'No events to display'
};
const $e1b6d86ea162c3dc$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $e1b6d86ea162c3dc$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: 'Previous $0',
        next: 'Next $0',
        today (buttonText, unit) {
            return unit === 'day' ? 'Today' : `This ${buttonText}`;
        }
    },
    viewHint: '$0 view',
    navLinkHint: 'Go to $0',
    moreLinkHint (eventCnt) {
        return `Show ${eventCnt} more event${eventCnt === 1 ? '' : 's'}`;
    }
});
function $e1b6d86ea162c3dc$var$organizeRawLocales(explicitRawLocales) {
    let defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
    let allRawLocales = $e1b6d86ea162c3dc$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    let rawLocaleMap = {
        en: $e1b6d86ea162c3dc$var$RAW_EN_LOCALE
    };
    for (let rawLocale of allRawLocales)rawLocaleMap[rawLocale.code] = rawLocale;
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $e1b6d86ea162c3dc$var$buildLocale(inputSingular, available) {
    if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) return $e1b6d86ea162c3dc$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $e1b6d86ea162c3dc$var$queryLocale(inputSingular, available);
}
function $e1b6d86ea162c3dc$var$queryLocale(codeArg, available) {
    let codes = [].concat(codeArg || []); // will convert to array
    let raw = $e1b6d86ea162c3dc$var$queryRawLocale(codes, available) || $e1b6d86ea162c3dc$var$RAW_EN_LOCALE;
    return $e1b6d86ea162c3dc$var$parseLocale(codeArg, codes, raw);
}
function $e1b6d86ea162c3dc$var$queryRawLocale(codes, available) {
    for(let i = 0; i < codes.length; i += 1){
        let parts = codes[i].toLocaleLowerCase().split('-');
        for(let j = parts.length; j > 0; j -= 1){
            let simpleId = parts.slice(0, j).join('-');
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $e1b6d86ea162c3dc$var$parseLocale(codeArg, codes, raw) {
    let merged = (0, $9b1rB.m)([
        $e1b6d86ea162c3dc$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        'buttonText'
    ]);
    delete merged.code; // don't want this part of the options
    let { week: week } = merged;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $e1b6d86ea162c3dc$export$ae829ec7b2625219(input) {
    return {
        id: (0, $9b1rB.g)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || '',
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $e1b6d86ea162c3dc$var$buildPluginHooks(pluginDefs, globalDefs) {
    let currentPluginIds = {};
    let hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: '',
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        for (let def of defs){
            const pluginName = def.name;
            const currentId = currentPluginIds[pluginName];
            if (currentId === undefined) {
                currentPluginIds[pluginName] = def.id;
                addDefs(def.deps);
                hooks = $e1b6d86ea162c3dc$var$combineHooks(hooks, def);
            } else if (currentId !== def.id) // different ID than the one already added
            console.warn(`Duplicate plugin '${pluginName}'`);
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $e1b6d86ea162c3dc$var$buildBuildPluginHooks() {
    let currentOverrideDefs = [];
    let currentGlobalDefs = [];
    let currentHooks;
    return (overrideDefs, globalDefs)=>{
        if (!currentHooks || !(0, $9b1rB.i)(overrideDefs, currentOverrideDefs) || !(0, $9b1rB.i)(globalDefs, currentGlobalDefs)) currentHooks = $e1b6d86ea162c3dc$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $e1b6d86ea162c3dc$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $e1b6d86ea162c3dc$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $e1b6d86ea162c3dc$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
class $e1b6d86ea162c3dc$var$StandardTheme extends (0, $9b1rB.T) {
}
$e1b6d86ea162c3dc$var$StandardTheme.prototype.classes = {
    root: 'fc-theme-standard',
    tableCellShaded: 'fc-cell-shaded',
    buttonGroup: 'fc-button-group',
    button: 'fc-button fc-button-primary',
    buttonActive: 'fc-button-active'
};
$e1b6d86ea162c3dc$var$StandardTheme.prototype.baseIconClass = 'fc-icon';
$e1b6d86ea162c3dc$var$StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-chevron-left',
    next: 'fc-icon-chevron-right',
    prevYear: 'fc-icon-chevrons-left',
    nextYear: 'fc-icon-chevrons-right'
};
$e1b6d86ea162c3dc$var$StandardTheme.prototype.rtlIconClasses = {
    prev: 'fc-icon-chevron-right',
    next: 'fc-icon-chevron-left',
    prevYear: 'fc-icon-chevrons-right',
    nextYear: 'fc-icon-chevrons-left'
};
$e1b6d86ea162c3dc$var$StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
$e1b6d86ea162c3dc$var$StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
$e1b6d86ea162c3dc$var$StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
function $e1b6d86ea162c3dc$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    let hash = {};
    let viewType;
    for(viewType in defaultConfigs)$e1b6d86ea162c3dc$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$e1b6d86ea162c3dc$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $e1b6d86ea162c3dc$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    let viewDef = $e1b6d86ea162c3dc$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $e1b6d86ea162c3dc$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    let defaultConfig = defaultConfigs[viewType];
    let overrideConfig = overrideConfigs[viewType];
    let queryProp = (name)=>defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    let theComponent = queryProp('component');
    let superType = queryProp('superType');
    let superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error('Can\'t have a custom view type that references itself');
        superDef = $e1b6d86ea162c3dc$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $e1b6d86ea162c3dc$var$parseViewConfigs(inputs) {
    return (0, $9b1rB.a)(inputs, $e1b6d86ea162c3dc$var$parseViewConfig);
}
function $e1b6d86ea162c3dc$var$parseViewConfig(input) {
    let rawOptions = typeof input === 'function' ? {
        component: input
    } : input;
    let { component: component } = rawOptions;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $e1b6d86ea162c3dc$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $9b1rB.B))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $e1b6d86ea162c3dc$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $e1b6d86ea162c3dc$var$createViewHookComponent(options) {
    return (viewProps)=>(0, $bvID6.createElement)((0, $9b1rB.V).Consumer, null, (context)=>(0, $bvID6.createElement)((0, $9b1rB.C), {
                elTag: "div",
                elClasses: (0, $9b1rB.b)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            }));
}
function $e1b6d86ea162c3dc$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let defaultConfigs = $e1b6d86ea162c3dc$var$parseViewConfigs(defaultInputs);
    let overrideConfigs = $e1b6d86ea162c3dc$var$parseViewConfigs(optionOverrides.views);
    let viewDefs = $e1b6d86ea162c3dc$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $9b1rB.a)(viewDefs, (viewDef)=>$e1b6d86ea162c3dc$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults));
}
function $e1b6d86ea162c3dc$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    let duration = null;
    let durationUnit = '';
    let singleUnit = '';
    let singleUnitOverrides = {};
    if (durationInput) {
        duration = $e1b6d86ea162c3dc$var$createDurationCached(durationInput);
        if (duration) {
            let denom = (0, $9b1rB.c)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    let queryButtonText = (optionsSubset)=>{
        let buttonTextMap = optionsSubset.buttonText || {};
        let buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    let queryButtonTitle = (optionsSubset)=>{
        let buttonHints = optionsSubset.buttonHints || {};
        let buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $9b1rB.e)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $9b1rB.e))
    };
}
// hack to get memoization working
let $e1b6d86ea162c3dc$var$durationInputMap = {};
function $e1b6d86ea162c3dc$var$createDurationCached(durationInput) {
    let json = JSON.stringify(durationInput);
    let res = $e1b6d86ea162c3dc$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $9b1rB.d)(durationInput);
        $e1b6d86ea162c3dc$var$durationInputMap[json] = res;
    }
    return res;
}
function $e1b6d86ea162c3dc$var$reduceViewType(viewType, action) {
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            viewType = action.viewType;
    }
    return viewType;
}
function $e1b6d86ea162c3dc$var$reduceCurrentDate(currentDate, action) {
    switch(action.type){
        case 'CHANGE_DATE':
            return action.dateMarker;
        default:
            return currentDate;
    }
}
// should be initialized once and stay constant
// this will change too
function $e1b6d86ea162c3dc$var$getInitialDate(options, dateEnv, nowManager) {
    let initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return nowManager.getDateMarker();
}
function $e1b6d86ea162c3dc$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case 'SET_OPTION':
            return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                [action.optionName]: action.rawOptionValue
            });
        default:
            return dynamicOptionOverrides;
    }
}
function $e1b6d86ea162c3dc$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    let dp;
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case 'CHANGE_DATE':
            return dateProfileGenerator.build(action.dateMarker);
        case 'PREV':
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case 'NEXT':
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $e1b6d86ea162c3dc$var$initEventSources(calendarOptions, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null;
    return $e1b6d86ea162c3dc$var$addSources({}, $e1b6d86ea162c3dc$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $e1b6d86ea162c3dc$var$reduceEventSources(eventSources, action, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case 'ADD_EVENT_SOURCES':
            return $e1b6d86ea162c3dc$var$addSources(eventSources, action.sources, activeRange, context);
        case 'REMOVE_EVENT_SOURCE':
            return $e1b6d86ea162c3dc$var$removeSource(eventSources, action.sourceId);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $e1b6d86ea162c3dc$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case 'FETCH_EVENT_SOURCES':
            return $e1b6d86ea162c3dc$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $9b1rB.f)(action.sourceIds) : $e1b6d86ea162c3dc$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case 'RECEIVE_EVENTS':
        case 'RECEIVE_EVENT_ERROR':
            return $e1b6d86ea162c3dc$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return {};
        default:
            return eventSources;
    }
}
function $e1b6d86ea162c3dc$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $e1b6d86ea162c3dc$var$fetchSourcesByIds(eventSources, $e1b6d86ea162c3dc$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $e1b6d86ea162c3dc$var$computeEventSourcesLoading(eventSources) {
    for(let sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $e1b6d86ea162c3dc$var$addSources(eventSourceHash, sources, fetchRange, context) {
    let hash = {};
    for (let source of sources)hash[source.sourceId] = source;
    if (fetchRange) hash = $e1b6d86ea162c3dc$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $e1b6d86ea162c3dc$var$removeSource(eventSourceHash, sourceId) {
    return (0, $9b1rB.h)(eventSourceHash, (eventSource)=>eventSource.sourceId !== sourceId);
}
function $e1b6d86ea162c3dc$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $e1b6d86ea162c3dc$var$fetchSourcesByIds(sourceHash, (0, $9b1rB.h)(sourceHash, (eventSource)=>$e1b6d86ea162c3dc$var$isSourceDirty(eventSource, fetchRange, context)), fetchRange, false, context);
}
function $e1b6d86ea162c3dc$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$e1b6d86ea162c3dc$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $e1b6d86ea162c3dc$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    let nextSources = {};
    for(let sourceId in prevSources){
        let source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $e1b6d86ea162c3dc$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $e1b6d86ea162c3dc$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    let { options: options, calendarApi: calendarApi } = context;
    let sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    let fetchId = (0, $9b1rB.g)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, (res)=>{
        let { rawEvents: rawEvents } = res;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: 'RECEIVE_EVENTS',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, (error)=>{
        let errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: 'RECEIVE_EVENT_ERROR',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $e1b6d86ea162c3dc$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    let eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
        [sourceId]: Object.assign(Object.assign({}, eventSource), {
            isFetching: false,
            fetchRange: fetchRange
        })
    });
    return sourceHash;
}
function $e1b6d86ea162c3dc$var$excludeStaticSources(eventSources, context) {
    return (0, $9b1rB.h)(eventSources, (eventSource)=>$e1b6d86ea162c3dc$var$doesSourceNeedRange(eventSource, context));
}
function $e1b6d86ea162c3dc$var$parseInitialSources(rawOptions, context) {
    let refiners = (0, $9b1rB.j)(context);
    let rawSources = [].concat(rawOptions.eventSources || []);
    let sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    for (let rawSource of rawSources){
        let source = (0, $9b1rB.p)(rawSource, context, refiners);
        if (source) sources.push(source);
    }
    return sources;
}
function $e1b6d86ea162c3dc$var$doesSourceNeedRange(eventSource, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $e1b6d86ea162c3dc$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case 'UNSELECT_DATES':
            return null;
        case 'SELECT_DATES':
            return action.selection;
        default:
            return currentSelection;
    }
}
function $e1b6d86ea162c3dc$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case 'UNSELECT_EVENT':
            return '';
        case 'SELECT_EVENT':
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $e1b6d86ea162c3dc$var$reduceEventDrag(currentDrag, action) {
    let newDrag;
    switch(action.type){
        case 'UNSET_EVENT_DRAG':
            return null;
        case 'SET_EVENT_DRAG':
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $e1b6d86ea162c3dc$var$reduceEventResize(currentResize, action) {
    let newResize;
    switch(action.type){
        case 'UNSET_EVENT_RESIZE':
            return null;
        case 'SET_EVENT_RESIZE':
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $e1b6d86ea162c3dc$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let header = calendarOptions.headerToolbar ? $e1b6d86ea162c3dc$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    let footer = calendarOptions.footerToolbar ? $e1b6d86ea162c3dc$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $e1b6d86ea162c3dc$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let sectionWidgets = {};
    let viewsWithButtons = [];
    let hasTitle = false;
    for(let sectionName in sectionStrHash){
        let sectionStr = sectionStrHash[sectionName];
        let sectionRes = $e1b6d86ea162c3dc$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push(...sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $e1b6d86ea162c3dc$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let isRtl = calendarOptions.direction === 'rtl';
    let calendarCustomButtons = calendarOptions.customButtons || {};
    let calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    let calendarButtonText = calendarOptions.buttonText || {};
    let calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    let calendarButtonHints = calendarOptions.buttonHints || {};
    let sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
    let viewsWithButtons = [];
    let hasTitle = false;
    let widgets = sectionSubstrs.map((buttonGroupStr)=>buttonGroupStr.split(',').map((buttonName)=>{
            if (buttonName === 'title') {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            let customButtonProps;
            let viewSpec;
            let buttonClick;
            let buttonIcon; // only one of these will be set
            let buttonText; // "
            let buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = (ev)=>{
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = ()=>{
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                let textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $9b1rB.k)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = ()=>{
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === 'prevYear' || buttonName === 'nextYear') {
                    let prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
                    buttonHint = (0, $9b1rB.k)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || 'year',
                        'year'
                    ], calendarButtonText[buttonName]);
                } else buttonHint = (navUnit)=>(0, $9b1rB.k)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        }));
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
class $e1b6d86ea162c3dc$var$ViewImpl {
    constructor(type, getCurrentData, dateEnv){
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    get calendar() {
        return this.getCurrentData().calendarApi;
    }
    get title() {
        return this.getCurrentData().viewTitle;
    }
    get activeStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
    }
    get activeEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
    }
    get currentStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
    }
    get currentEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
    }
    getOption(name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    }
}
let $e1b6d86ea162c3dc$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta (refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch (arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
const $e1b6d86ea162c3dc$var$arrayEventSourcePlugin = $e1b6d86ea162c3dc$export$ae829ec7b2625219({
    name: 'array-event-source',
    eventSourceDefs: [
        $e1b6d86ea162c3dc$var$eventSourceDef$2
    ]
});
let $e1b6d86ea162c3dc$var$eventSourceDef$1 = {
    parseMeta (refined) {
        if (typeof refined.events === 'function') return refined.events;
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { dateEnv: dateEnv } = arg.context;
        const func = arg.eventSource.meta;
        (0, $9b1rB.u)(func.bind(null, (0, $9b1rB.l)(arg.range, dateEnv)), (rawEvents)=>successCallback({
                rawEvents: rawEvents
            }), errorCallback);
    }
};
const $e1b6d86ea162c3dc$var$funcEventSourcePlugin = $e1b6d86ea162c3dc$export$ae829ec7b2625219({
    name: 'func-event-source',
    eventSourceDefs: [
        $e1b6d86ea162c3dc$var$eventSourceDef$1
    ]
});
const $e1b6d86ea162c3dc$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $9b1rB.n),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
let $e1b6d86ea162c3dc$var$eventSourceDef = {
    parseMeta (refined) {
        if (refined.url && (refined.format === 'json' || !refined.format)) return {
            url: refined.url,
            format: 'json',
            method: (refined.method || 'GET').toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { meta: meta } = arg.eventSource;
        const requestParams = $e1b6d86ea162c3dc$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $9b1rB.r)(meta.method, meta.url, requestParams).then(([rawEvents, response])=>{
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
const $e1b6d86ea162c3dc$var$jsonFeedEventSourcePlugin = $e1b6d86ea162c3dc$export$ae829ec7b2625219({
    name: 'json-event-source',
    eventSourceRefiners: $e1b6d86ea162c3dc$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $e1b6d86ea162c3dc$var$eventSourceDef
    ]
});
function $e1b6d86ea162c3dc$var$buildRequestParams(meta, range, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let startParam;
    let endParam;
    let timeZoneParam;
    let customRequestParams;
    let params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== 'local') params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
const $e1b6d86ea162c3dc$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $9b1rB.n),
    startTime: (0, $9b1rB.d),
    endTime: (0, $9b1rB.d),
    duration: (0, $9b1rB.d),
    startRecur: (0, $9b1rB.n),
    endRecur: (0, $9b1rB.n)
};
let $e1b6d86ea162c3dc$var$recurring = {
    parse (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            let recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
                dateEnv: dateEnv
            };
            let duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $9b1rB.s)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand (typeData, framingRange, dateEnv) {
        let clippedFramingRange = (0, $9b1rB.o)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $e1b6d86ea162c3dc$var$expandRanges(typeData.daysOfWeek, typeData.startTime, typeData.dateEnv, dateEnv, clippedFramingRange);
        return [];
    }
};
const $e1b6d86ea162c3dc$var$simpleRecurringEventsPlugin = $e1b6d86ea162c3dc$export$ae829ec7b2625219({
    name: 'simple-recurring-event',
    recurringTypes: [
        $e1b6d86ea162c3dc$var$recurring
    ],
    eventRefiners: $e1b6d86ea162c3dc$var$SIMPLE_RECURRING_REFINERS
});
function $e1b6d86ea162c3dc$var$expandRanges(daysOfWeek, startTime, eventDateEnv, calendarDateEnv, framingRange) {
    let dowHash = daysOfWeek ? (0, $9b1rB.f)(daysOfWeek) : null;
    let dayMarker = (0, $9b1rB.q)(framingRange.start);
    let endMarker = framingRange.end;
    let instanceStarts = [];
    // https://github.com/fullcalendar/fullcalendar/issues/7934
    if (startTime) {
        if (startTime.milliseconds < 0) // possible for next-day to have negative business hours that go into current day
        endMarker = (0, $9b1rB.t)(endMarker, 1);
        else if (startTime.milliseconds >= 86400000) // possible for prev-day to have >24hr business hours that go into current day
        dayMarker = (0, $9b1rB.t)(dayMarker, -1);
    }
    while(dayMarker < endMarker){
        let instanceStart;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = calendarDateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(calendarDateEnv.createMarker(eventDateEnv.toDate(instanceStart)));
        }
        dayMarker = (0, $9b1rB.t)(dayMarker, 1);
    }
    return instanceStarts;
}
const $e1b6d86ea162c3dc$var$changeHandlerPlugin = $e1b6d86ea162c3dc$export$ae829ec7b2625219({
    name: 'change-handler',
    optionChangeHandlers: {
        events (events, context) {
            $e1b6d86ea162c3dc$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $e1b6d86ea162c3dc$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $e1b6d86ea162c3dc$var$handleEventSources(inputs, context) {
    let unfoundSources = (0, $9b1rB.v)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: 'RESET_RAW_EVENTS',
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    let newInputs = [];
    for (let input of inputs){
        let inputFound = false;
        for(let i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
            unfoundSources.splice(i, 1); // delete
            inputFound = true;
            break;
        }
        if (!inputFound) newInputs.push(input);
    }
    for (let unfoundSource of unfoundSources)context.dispatch({
        type: 'REMOVE_EVENT_SOURCE',
        sourceId: unfoundSource.sourceId
    });
    for (let newInput of newInputs)context.calendarApi.addEventSource(newInput);
}
function $e1b6d86ea162c3dc$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger('datesSet', Object.assign(Object.assign({}, (0, $9b1rB.l)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $e1b6d86ea162c3dc$var$handleEventStore(eventStore, context) {
    let { emitter: emitter } = context;
    if (emitter.hasHandlers('eventsSet')) emitter.trigger('eventsSet', (0, $9b1rB.w)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ const $e1b6d86ea162c3dc$export$905153d94e0757fa = [
    $e1b6d86ea162c3dc$var$arrayEventSourcePlugin,
    $e1b6d86ea162c3dc$var$funcEventSourcePlugin,
    $e1b6d86ea162c3dc$var$jsonFeedEventSourcePlugin,
    $e1b6d86ea162c3dc$var$simpleRecurringEventsPlugin,
    $e1b6d86ea162c3dc$var$changeHandlerPlugin,
    $e1b6d86ea162c3dc$export$ae829ec7b2625219({
        name: 'misc',
        isLoadingFuncs: [
            (state)=>$e1b6d86ea162c3dc$var$computeEventSourcesLoading(state.eventSources)
        ],
        propSetHandlers: {
            dateProfile: $e1b6d86ea162c3dc$var$handleDateProfile,
            eventStore: $e1b6d86ea162c3dc$var$handleEventStore
        }
    })
];
class $e1b6d86ea162c3dc$var$TaskRunner {
    constructor(runTaskOption, drainedOption){
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $9b1rB.D)(this.drain.bind(this));
    }
    request(task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    }
    pause(scope) {
        this.delayedRunner.pause(scope);
    }
    resume(scope, force) {
        this.delayedRunner.resume(scope, force);
    }
    drain() {
        let { queue: queue } = this;
        while(queue.length){
            let completedTasks = [];
            let task;
            while(task = queue.shift()){
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    }
    runTask(task) {
        if (this.runTaskOption) this.runTaskOption(task);
    }
    drained(completedTasks) {
        if (this.drainedOption) this.drainedOption(completedTasks);
    }
}
// Computes what the title at the top of the calendarApi should be for this view
function $e1b6d86ea162c3dc$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    let range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $9b1rB.x)(viewOptions.titleFormat || $e1b6d86ea162c3dc$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $e1b6d86ea162c3dc$var$buildTitleFormat(dateProfile) {
    let { currentRangeUnit: currentRangeUnit } = dateProfile;
    if (currentRangeUnit === 'year') return {
        year: 'numeric'
    };
    if (currentRangeUnit === 'month') return {
        year: 'numeric',
        month: 'long'
    }; // like "September 2014"
    let days = (0, $9b1rB.y)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    // one day. longer, like "September 9 2014"
    return {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
}
/*
TODO: test switching timezones when NO timezone plugin
*/ class $e1b6d86ea162c3dc$var$CalendarNowManager {
    constructor(){
        this.resetListeners = new Set();
    }
    handleInput(dateEnv, nowInput) {
        const oldDateEnv = this.dateEnv;
        if (dateEnv !== oldDateEnv) {
            if (typeof nowInput === 'function') this.nowFn = nowInput;
            else if (!oldDateEnv) {
                this.nowAnchorDate = dateEnv.toDate(nowInput ? dateEnv.createMarker(nowInput) : dateEnv.createNowMarker());
                this.nowAnchorQueried = Date.now();
            }
            this.dateEnv = dateEnv;
            // not first time? fire reset handlers
            if (oldDateEnv) for (const resetListener of this.resetListeners.values())resetListener();
        }
    }
    getDateMarker() {
        return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
    }
    addResetListener(handler) {
        this.resetListeners.add(handler);
    }
    removeResetListener(handler) {
        this.resetListeners.delete(handler);
    }
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
class $e1b6d86ea162c3dc$var$CalendarDataManager {
    constructor(props){
        this.computeCurrentViewData = (0, $9b1rB.z)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$organizeRawLocales);
        this.buildLocale = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildLocale);
        this.buildPluginHooks = $e1b6d86ea162c3dc$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildDateEnv$1);
        this.buildTheme = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildTheme);
        this.parseToolbars = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$parseToolbars);
        this.buildViewSpecs = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $9b1rB.A)($e1b6d86ea162c3dc$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildViewApi);
        this.buildViewUiProps = (0, $9b1rB.A)($e1b6d86ea162c3dc$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildEventUiBySource, (0, $9b1rB.E));
        this.buildEventUiBases = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $9b1rB.A)($e1b6d86ea162c3dc$var$parseContextBusinessHours);
        this.buildTitle = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildTitle);
        this.nowManager = new $e1b6d86ea162c3dc$var$CalendarNowManager();
        this.emitter = new (0, $9b1rB.F)();
        this.actionRunner = new $e1b6d86ea162c3dc$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = ()=>this.data;
        this.dispatch = (action)=>{
            this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        this.nowManager = new $e1b6d86ea162c3dc$var$CalendarNowManager();
        let dynamicOptionOverrides = {};
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        let currentDate = $e1b6d86ea162c3dc$var$getInitialDate(optionsData.calendarOptions, optionsData.dateEnv, this.nowManager);
        let dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $9b1rB.G)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        // needs to be after setThisContext
        for (let callback of optionsData.pluginHooks.contextInit)callback(calendarContext);
        // NOT DRY
        let eventSources = $e1b6d86ea162c3dc$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        let initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $9b1rB.H)(),
            renderableEventStore: (0, $9b1rB.H)(),
            dateSelection: null,
            eventSelection: '',
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(initialState, reducer(null, null, contextAndState));
        if ($e1b6d86ea162c3dc$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger('loading', true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    resetOptions(optionOverrides, changedOptionNames) {
        let { props: props } = this;
        if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
        else {
            props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
            this.optionsForRefining.push(...changedOptionNames);
        }
        if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
            type: 'NOTHING'
        });
    }
    _handleAction(action) {
        let { props: props, state: state, emitter: emitter } = this;
        let dynamicOptionOverrides = $e1b6d86ea162c3dc$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = $e1b6d86ea162c3dc$var$reduceViewType(state.currentViewType, action);
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData
        };
        let { currentDate: currentDate, dateProfile: dateProfile } = state;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        currentDate = $e1b6d86ea162c3dc$var$reduceCurrentDate(currentDate, action);
        dateProfile = $e1b6d86ea162c3dc$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
        action.type === 'NEXT' || // "
        !(0, $9b1rB.G)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let eventSources = $e1b6d86ea162c3dc$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        let eventStore = (0, $9b1rB.I)(state.eventStore, action, eventSources, dateProfile, calendarContext);
        let isEventsLoading = $e1b6d86ea162c3dc$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        let renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
        let { eventUiSingleBase: eventUiSingleBase, selectionConfig: selectionConfig } = this.buildViewUiProps(calendarContext); // will memoize obj
        let eventUiBySource = this.buildEventUiBySource(eventSources);
        let eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        let newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: $e1b6d86ea162c3dc$var$reduceDateSelection(state.dateSelection, action),
            eventSelection: $e1b6d86ea162c3dc$var$reduceSelectedEvent(state.eventSelection, action),
            eventDrag: $e1b6d86ea162c3dc$var$reduceEventDrag(state.eventDrag, action),
            eventResize: $e1b6d86ea162c3dc$var$reduceEventResize(state.eventResize, action)
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        let wasLoading = $e1b6d86ea162c3dc$var$computeIsLoading(state, calendarContext);
        let isLoading = $e1b6d86ea162c3dc$var$computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) emitter.trigger('loading', true);
        else if (wasLoading && !isLoading) emitter.trigger('loading', false);
        this.state = newState;
        if (props.onAction) props.onAction(action);
    }
    updateData() {
        let { props: props, state: state } = this;
        let oldData = this.data;
        let optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        let currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        let data = this.data = Object.assign(Object.assign(Object.assign({
            nowManager: this.nowManager,
            viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        }, optionsData), currentViewData), state);
        let changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        let oldCalendarOptions = oldData && oldData.calendarOptions;
        let newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = $e1b6d86ea162c3dc$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = (0, $9b1rB.J)(data.eventStore, oldData.dateEnv, data.dateEnv);
                state.renderableEventStore = data.renderableEventStore = (0, $9b1rB.J)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
            }
            for(let optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
        }
        this.optionsForHandling = [];
        if (props.onData) props.onData(data);
    }
    computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
        let { refinedOptions: refinedOptions, pluginHooks: pluginHooks, localeDefaults: localeDefaults, availableLocaleData: availableLocaleData, extra: extra } = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides);
        $e1b6d86ea162c3dc$var$warnUnknownOptions(extra);
        let dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        let viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
        let theme = this.buildTheme(refinedOptions, pluginHooks);
        let toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
        return this.stableCalendarOptionsData = {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map
        };
    }
    // always called from behind a memoizer
    processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
        let { locales: locales, locale: locale } = (0, $9b1rB.K)([
            (0, $9b1rB.e),
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let availableLocaleData = this.organizeRawLocales(locales);
        let availableRawLocales = availableLocaleData.map;
        let localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        let pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $e1b6d86ea162c3dc$export$905153d94e0757fa);
        let refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $9b1rB.L)), (0, $9b1rB.M)), (0, $9b1rB.N)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let extra = {};
        let raw = (0, $9b1rB.K)([
            (0, $9b1rB.e),
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let refined = {};
        let currentRaw = this.currentCalendarOptionsInput;
        let currentRefined = this.currentCalendarOptionsRefined;
        let anyChanges = false;
        for(let optionName in raw){
            if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $9b1rB.O)[optionName] && optionName in currentRaw && (0, $9b1rB.O)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
            else if (refiners[optionName]) {
                refined[optionName] = refiners[optionName](raw[optionName]);
                anyChanges = true;
            } else extra[optionName] = currentRaw[optionName];
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
            this.stableOptionOverrides = optionOverrides;
            this.stableDynamicOptionOverrides = dynamicOptionOverrides;
        }
        this.optionsForHandling.push(...this.optionsForRefining);
        this.optionsForRefining = [];
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra
        };
    }
    _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        let viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) throw new Error(`viewType "${viewType}" is not available. Please make sure you've loaded all neccessary plugins`);
        let { refinedOptions: refinedOptions, extra: extra } = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides);
        $e1b6d86ea162c3dc$var$warnUnknownOptions(extra);
        this.nowManager.handleInput(optionsData.dateEnv, refinedOptions.now);
        let dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            nowManager: this.nowManager,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            fixedWeekCount: refinedOptions.fixedWeekCount
        });
        let viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return {
            viewSpec: viewSpec,
            options: refinedOptions,
            dateProfileGenerator: dateProfileGenerator,
            viewApi: viewApi
        };
    }
    processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        let raw = (0, $9b1rB.K)([
            (0, $9b1rB.e),
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides
        ]);
        let refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $9b1rB.L)), (0, $9b1rB.M)), (0, $9b1rB.N)), (0, $9b1rB.P)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let refined = {};
        let currentRaw = this.currentViewOptionsInput;
        let currentRefined = this.currentViewOptionsRefined;
        let anyChanges = false;
        let extra = {};
        for(let optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $9b1rB.O)[optionName] && (0, $9b1rB.O)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
        else {
            if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $9b1rB.O)[optionName] && (0, $9b1rB.O)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
            } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
            else extra[optionName] = raw[optionName];
            anyChanges = true;
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra
        };
    }
}
function $e1b6d86ea162c3dc$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    let locale = $e1b6d86ea162c3dc$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $9b1rB.Q)({
        calendarSystem: 'gregory',
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $e1b6d86ea162c3dc$var$buildTheme(options, pluginHooks) {
    let ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $e1b6d86ea162c3dc$var$StandardTheme;
    return new ThemeClass(options);
}
function $e1b6d86ea162c3dc$var$buildDateProfileGenerator(props) {
    let DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $9b1rB.R);
    return new DateProfileGeneratorClass(props);
}
function $e1b6d86ea162c3dc$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $e1b6d86ea162c3dc$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $e1b6d86ea162c3dc$var$buildEventUiBySource(eventSources) {
    return (0, $9b1rB.a)(eventSources, (eventSource)=>eventSource.ui);
}
function $e1b6d86ea162c3dc$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    let eventUiBases = {
        '': eventUiSingleBase
    };
    for(let defId in eventDefs){
        let def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $e1b6d86ea162c3dc$var$buildViewUiProps(calendarContext) {
    let { options: options } = calendarContext;
    return {
        eventUiSingleBase: (0, $9b1rB.S)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $9b1rB.S)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $e1b6d86ea162c3dc$var$computeIsLoading(state, context) {
    for (let isLoadingFunc of context.pluginHooks.isLoadingFuncs){
        if (isLoadingFunc(state)) return true;
    }
    return false;
}
function $e1b6d86ea162c3dc$var$parseContextBusinessHours(calendarContext) {
    return (0, $9b1rB.U)(calendarContext.options.businessHours, calendarContext);
}
function $e1b6d86ea162c3dc$var$warnUnknownOptions(options, viewName) {
    for(let optionName in options)console.warn(`Unknown option '${optionName}'` + (viewName ? ` for view '${viewName}'` : ''));
}
class $e1b6d86ea162c3dc$var$ToolbarSection extends (0, $9b1rB.B) {
    render() {
        let children = this.props.widgetGroups.map((widgetGroup)=>this.renderWidgetGroup(widgetGroup));
        return (0, $bvID6.createElement)('div', {
            className: 'fc-toolbar-chunk'
        }, ...children);
    }
    renderWidgetGroup(widgetGroup) {
        let { props: props } = this;
        let { theme: theme } = this.context;
        let children = [];
        let isOnlyButtons = true;
        for (let widget of widgetGroup){
            let { buttonName: buttonName, buttonClick: buttonClick, buttonText: buttonText, buttonIcon: buttonIcon, buttonHint: buttonHint } = widget;
            if (buttonName === 'title') {
                isOnlyButtons = false;
                children.push((0, $bvID6.createElement)("h2", {
                    className: "fc-toolbar-title",
                    id: props.titleId
                }, props.title));
            } else {
                let isPressed = buttonName === props.activeButton;
                let isDisabled = !props.isTodayEnabled && buttonName === 'today' || !props.isPrevEnabled && buttonName === 'prev' || !props.isNextEnabled && buttonName === 'next';
                let buttonClasses = [
                    `fc-${buttonName}-button`,
                    theme.getClass('button')
                ];
                if (isPressed) buttonClasses.push(theme.getClass('buttonActive'));
                children.push((0, $bvID6.createElement)("button", {
                    type: "button",
                    title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint,
                    disabled: isDisabled,
                    "aria-pressed": isPressed,
                    className: buttonClasses.join(' '),
                    onClick: buttonClick
                }, buttonText || (buttonIcon ? (0, $bvID6.createElement)("span", {
                    className: buttonIcon,
                    role: "img"
                }) : '')));
            }
        }
        if (children.length > 1) {
            let groupClassName = isOnlyButtons && theme.getClass('buttonGroup') || '';
            return (0, $bvID6.createElement)('div', {
                className: groupClassName
            }, ...children);
        }
        return children[0];
    }
}
class $e1b6d86ea162c3dc$var$Toolbar extends (0, $9b1rB.B) {
    render() {
        let { model: model, extraClassName: extraClassName } = this.props;
        let forceLtr = false;
        let startContent;
        let endContent;
        let sectionWidgets = model.sectionWidgets;
        let centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        } else startContent = sectionWidgets.start;
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        } else endContent = sectionWidgets.end;
        let classNames = [
            extraClassName || '',
            'fc-toolbar',
            forceLtr ? 'fc-toolbar-ltr' : ''
        ];
        return (0, $bvID6.createElement)("div", {
            className: classNames.join(' ')
        }, this.renderSection('start', startContent || []), this.renderSection('center', centerContent || []), this.renderSection('end', endContent || []));
    }
    renderSection(key, widgetGroups) {
        let { props: props } = this;
        return (0, $bvID6.createElement)($e1b6d86ea162c3dc$var$ToolbarSection, {
            key: key,
            widgetGroups: widgetGroups,
            title: props.title,
            navUnit: props.navUnit,
            activeButton: props.activeButton,
            isTodayEnabled: props.isTodayEnabled,
            isPrevEnabled: props.isPrevEnabled,
            isNextEnabled: props.isNextEnabled,
            titleId: props.titleId
        });
    }
}
class $e1b6d86ea162c3dc$var$ViewHarness extends (0, $9b1rB.B) {
    constructor(){
        super(...arguments);
        this.state = {
            availableWidth: null
        };
        this.handleEl = (el)=>{
            this.el = el;
            (0, $9b1rB.W)(this.props.elRef, el);
            this.updateAvailableWidth();
        };
        this.handleResize = ()=>{
            this.updateAvailableWidth();
        };
    }
    render() {
        let { props: props, state: state } = this;
        let { aspectRatio: aspectRatio } = props;
        let classNames = [
            'fc-view-harness',
            aspectRatio || props.liquid || props.height ? 'fc-view-harness-active' // harness controls the height
             : 'fc-view-harness-passive'
        ];
        let height = '';
        let paddingBottom = '';
        if (aspectRatio) {
            if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
            else // while waiting to know availableWidth, we can't set height to *zero*
            // because will cause lots of unnecessary scrollbars within scrollgrid.
            // BETTER: don't start rendering ANYTHING yet until we know container width
            // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
            paddingBottom = `${1 / aspectRatio * 100}%`;
        } else height = props.height || '';
        return (0, $bvID6.createElement)("div", {
            "aria-labelledby": props.labeledById,
            ref: this.handleEl,
            className: classNames.join(' '),
            style: {
                height: height,
                paddingBottom: paddingBottom
            }
        }, props.children);
    }
    componentDidMount() {
        this.context.addResizeHandler(this.handleResize);
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    updateAvailableWidth() {
        if (this.el && // needed. but why?
        this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) this.setState({
            availableWidth: this.el.offsetWidth
        });
    }
}
/*
Detects when the user clicks on an event within a DateComponent
*/ class $e1b6d86ea162c3dc$var$EventClicking extends (0, $9b1rB.X) {
    constructor(settings){
        super(settings);
        this.handleSegClick = (ev, segEl)=>{
            let { component: component } = this;
            let { context: context } = component;
            let seg = (0, $9b1rB.Y)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                let hasUrlContainer = (0, $9b1rB.Z)(ev.target, '.fc-event-forced-url');
                let url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                context.emitter.trigger('eventClick', {
                    el: segEl,
                    event: new (0, $9b1rB._)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        this.destroy = (0, $9b1rB.$)(settings.el, 'click', '.fc-event', this.handleSegClick);
    }
}
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ class $e1b6d86ea162c3dc$var$EventHovering extends (0, $9b1rB.X) {
    constructor(settings){
        super(settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        this.handleEventElRemove = (el)=>{
            if (el === this.currentSegEl) this.handleSegLeave(null, this.currentSegEl);
        };
        this.handleSegEnter = (ev, segEl)=>{
            if ((0, $9b1rB.Y)(segEl)) {
                this.currentSegEl = segEl;
                this.triggerEvent('eventMouseEnter', ev, segEl);
            }
        };
        this.handleSegLeave = (ev, segEl)=>{
            if (this.currentSegEl) {
                this.currentSegEl = null;
                this.triggerEvent('eventMouseLeave', ev, segEl);
            }
        };
        this.removeHoverListeners = (0, $9b1rB.a0)(settings.el, '.fc-event', this.handleSegEnter, this.handleSegLeave);
    }
    destroy() {
        this.removeHoverListeners();
    }
    triggerEvent(publicEvName, ev, segEl) {
        let { component: component } = this;
        let { context: context } = component;
        let seg = (0, $9b1rB.Y)(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
            el: segEl,
            event: new (0, $9b1rB._)(context, seg.eventRange.def, seg.eventRange.instance),
            jsEvent: ev,
            view: context.viewApi
        });
    }
}
class $e1b6d86ea162c3dc$var$CalendarContent extends (0, $9b1rB.a1) {
    constructor(){
        super(...arguments);
        this.buildViewContext = (0, $9b1rB.z)((0, $9b1rB.a2));
        this.buildViewPropTransformers = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildViewPropTransformers);
        this.buildToolbarProps = (0, $9b1rB.z)($e1b6d86ea162c3dc$var$buildToolbarProps);
        this.headerRef = (0, $bvID6.createRef)();
        this.footerRef = (0, $bvID6.createRef)();
        this.interactionsStore = {};
        // eslint-disable-next-line
        this.state = {
            viewLabelId: (0, $9b1rB.a3)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        this.registerInteractiveComponent = (component, settingsInput)=>{
            let settings = (0, $9b1rB.a4)(component, settingsInput);
            let DEFAULT_INTERACTIONS = [
                $e1b6d86ea162c3dc$var$EventClicking,
                $e1b6d86ea162c3dc$var$EventHovering
            ];
            let interactionClasses = DEFAULT_INTERACTIONS.concat(this.props.pluginHooks.componentInteractions);
            let interactions = interactionClasses.map((TheInteractionClass)=>new TheInteractionClass(settings));
            this.interactionsStore[component.uid] = interactions;
            (0, $9b1rB.a5)[component.uid] = settings;
        };
        this.unregisterInteractiveComponent = (component)=>{
            let listeners = this.interactionsStore[component.uid];
            if (listeners) {
                for (let listener of listeners)listener.destroy();
                delete this.interactionsStore[component.uid];
            }
            delete (0, $9b1rB.a5)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        this.resizeRunner = new (0, $9b1rB.D)(()=>{
            this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
            this.props.emitter.trigger('windowResize', {
                view: this.props.viewApi
            });
        });
        this.handleWindowResize = (ev)=>{
            let { options: options } = this.props;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) this.resizeRunner.request(options.windowResizeDelay);
        };
    }
    /*
    renders INSIDE of an outer div
    */ render() {
        let { props: props } = this;
        let { toolbarConfig: toolbarConfig, options: options } = props;
        let viewVGrow = false;
        let viewHeight = '';
        let viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) viewHeight = '';
        else if (options.height != null) viewVGrow = true;
        else if (options.contentHeight != null) viewHeight = options.contentHeight;
        else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        let viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.nowManager, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        let viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : undefined;
        return (0, $bvID6.createElement)((0, $9b1rB.V).Provider, {
            value: viewContext
        }, (0, $bvID6.createElement)((0, $9b1rB.a6), {
            unit: "day"
        }, (nowDate)=>{
            let toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, nowDate, props.viewTitle);
            return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, toolbarConfig.header && (0, $bvID6.createElement)($e1b6d86ea162c3dc$var$Toolbar, Object.assign({
                ref: this.headerRef,
                extraClassName: "fc-header-toolbar",
                model: toolbarConfig.header,
                titleId: viewLabelId
            }, toolbarProps)), (0, $bvID6.createElement)($e1b6d86ea162c3dc$var$ViewHarness, {
                liquid: viewVGrow,
                height: viewHeight,
                aspectRatio: viewAspectRatio,
                labeledById: viewLabelId
            }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $bvID6.createElement)($e1b6d86ea162c3dc$var$Toolbar, Object.assign({
                ref: this.footerRef,
                extraClassName: "fc-footer-toolbar",
                model: toolbarConfig.footer,
                titleId: ""
            }, toolbarProps)));
        }));
    }
    componentDidMount() {
        let { props: props } = this;
        this.calendarInteractions = props.pluginHooks.calendarInteractions.map((CalendarInteractionClass)=>new CalendarInteractionClass(props));
        window.addEventListener('resize', this.handleWindowResize);
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
    }
    componentDidUpdate(prevProps) {
        let { props: props } = this;
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        this.resizeRunner.clear();
        for (let interaction of this.calendarInteractions)interaction.destroy();
        this.props.emitter.trigger('_unmount');
    }
    buildAppendContent() {
        let { props: props } = this;
        let children = props.pluginHooks.viewContainerAppends.map((buildAppendContent)=>buildAppendContent(props));
        return (0, $bvID6.createElement)((0, $bvID6.Fragment), {}, ...children);
    }
    renderView(props) {
        let { pluginHooks: pluginHooks } = props;
        let { viewSpec: viewSpec } = props;
        let viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint
        };
        let transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (let transformer of transformers)Object.assign(viewProps, transformer.transform(viewProps, props));
        let ViewComponent = viewSpec.component;
        return (0, $bvID6.createElement)(ViewComponent, Object.assign({}, viewProps));
    }
}
function $e1b6d86ea162c3dc$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    let todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    let prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    let nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $9b1rB.G)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $e1b6d86ea162c3dc$var$buildViewPropTransformers(theClasses) {
    return theClasses.map((TheClass)=>new TheClass());
}
class $e1b6d86ea162c3dc$export$e1aef45b828286de extends (0, $9b1rB.a7) {
    constructor(el, optionOverrides = {}){
        super();
        this.isRendering = false;
        this.isRendered = false;
        this.currentClassNames = [];
        this.customContentRenderId = 0;
        this.handleAction = (action)=>{
            // actions we know we want to render immediately
            switch(action.type){
                case 'SET_EVENT_DRAG':
                case 'SET_EVENT_RESIZE':
                    this.renderRunner.tryDrain();
            }
        };
        this.handleData = (data)=>{
            this.currentData = data;
            this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        this.handleRenderRequest = ()=>{
            if (this.isRendering) {
                this.isRendered = true;
                let { currentData: currentData } = this;
                (0, $9b1rB.a8)(()=>{
                    (0, $bvID6.render)((0, $bvID6.createElement)((0, $9b1rB.a9), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, (classNames, height, isHeightAuto, forPrint)=>{
                        this.setClassNames(classNames);
                        this.setHeight(height);
                        return (0, $bvID6.createElement)((0, $9b1rB.aa).Provider, {
                            value: this.customContentRenderId
                        }, (0, $bvID6.createElement)($e1b6d86ea162c3dc$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), this.el);
                });
            } else if (this.isRendered) {
                this.isRendered = false;
                (0, $bvID6.render)(null, this.el);
                this.setClassNames([]);
                this.setHeight('');
            }
        };
        (0, $9b1rB.ab)(el);
        this.el = el;
        this.renderRunner = new (0, $9b1rB.D)(this.handleRenderRequest);
        new $e1b6d86ea162c3dc$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: this,
            onAction: this.handleAction,
            onData: this.handleData
        });
    }
    render() {
        let wasRendering = this.isRendering;
        if (!wasRendering) this.isRendering = true;
        else this.customContentRenderId += 1;
        this.renderRunner.request();
        if (wasRendering) this.updateSize();
    }
    destroy() {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    }
    updateSize() {
        (0, $9b1rB.a8)(()=>{
            super.updateSize();
        });
    }
    batchRendering(func) {
        this.renderRunner.pause('batchRendering');
        func();
        this.renderRunner.resume('batchRendering');
    }
    pauseRendering() {
        this.renderRunner.pause('pauseRendering');
    }
    resumeRendering() {
        this.renderRunner.resume('pauseRendering', true);
    }
    resetOptions(optionOverrides, changedOptionNames) {
        this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
    }
    setClassNames(classNames) {
        if (!(0, $9b1rB.i)(classNames, this.currentClassNames)) {
            let { classList: classList } = this.el;
            for (let className of this.currentClassNames)classList.remove(className);
            for (let className of classNames)classList.add(className);
            this.currentClassNames = classNames;
        }
    }
    setHeight(height) {
        (0, $9b1rB.ac)(this.el, 'height', height);
    }
}
function $e1b6d86ea162c3dc$export$3ae94a2503e890a1(dateInput, options = {}) {
    let dateEnv = $e1b6d86ea162c3dc$var$buildDateEnv(options);
    let formatter = (0, $9b1rB.x)(options);
    let dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return '';
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $e1b6d86ea162c3dc$export$9b1080e2eec9158(startInput, endInput, options) {
    let dateEnv = $e1b6d86ea162c3dc$var$buildDateEnv(typeof options === 'object' && options ? options : {}); // pass in if non-null object
    let formatter = (0, $9b1rB.x)(options);
    let startMeta = dateEnv.createMarkerMeta(startInput);
    let endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return '';
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $9b1rB.e).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $e1b6d86ea162c3dc$var$buildDateEnv(settings) {
    let locale = $e1b6d86ea162c3dc$var$buildLocale(settings.locale || 'en', $e1b6d86ea162c3dc$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $9b1rB.Q)(Object.assign(Object.assign({
        timeZone: (0, $9b1rB.e).timeZone,
        calendarSystem: 'gregory'
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $e1b6d86ea162c3dc$export$3b384895d0cca0f2(props, allDay) {
    return (0, $9b1rB.ad)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
const $e1b6d86ea162c3dc$export$83d89fbfd8236492 = '6.1.19';

});
parcelRegister("9b1rB", function(module, exports) {

$parcel$export(module.exports, "ct", function () { return $6ae642ef23cd8741$export$e9316ff9106cdb75; });
$parcel$export(module.exports, "ab", function () { return $6ae642ef23cd8741$export$555508cbc6add439; });
$parcel$export(module.exports, "D", function () { return $6ae642ef23cd8741$export$96f57966bedc81b4; });
$parcel$export(module.exports, "Z", function () { return $6ae642ef23cd8741$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "ac", function () { return $6ae642ef23cd8741$export$2219238a014317b0; });
$parcel$export(module.exports, "a3", function () { return $6ae642ef23cd8741$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "$", function () { return $6ae642ef23cd8741$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "a0", function () { return $6ae642ef23cd8741$export$34aec0b863436764; });
$parcel$export(module.exports, "g", function () { return $6ae642ef23cd8741$export$39b482c5e57630a8; });
$parcel$export(module.exports, "k", function () { return $6ae642ef23cd8741$export$342063e11d6c3cad; });
$parcel$export(module.exports, "d", function () { return $6ae642ef23cd8741$export$4368d992c4eafac0; });
$parcel$export(module.exports, "bn", function () { return $6ae642ef23cd8741$export$acf3ba20e47771d; });
$parcel$export(module.exports, "s", function () { return $6ae642ef23cd8741$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "bm", function () { return $6ae642ef23cd8741$export$55ff3cc1821e8445; });
$parcel$export(module.exports, "bq", function () { return $6ae642ef23cd8741$export$4b170465d7badfa1; });
$parcel$export(module.exports, "br", function () { return $6ae642ef23cd8741$export$479ac0420f53ed26; });
$parcel$export(module.exports, "c", function () { return $6ae642ef23cd8741$export$db3b6bfb95261072; });
$parcel$export(module.exports, "i", function () { return $6ae642ef23cd8741$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "bf", function () { return $6ae642ef23cd8741$export$151db275011178c4; });
$parcel$export(module.exports, "t", function () { return $6ae642ef23cd8741$export$625550452a3fa3ec; });
$parcel$export(module.exports, "be", function () { return $6ae642ef23cd8741$export$51b138e5a065c2bb; });
$parcel$export(module.exports, "bg", function () { return $6ae642ef23cd8741$export$136fd86de524d3c2; });
$parcel$export(module.exports, "bj", function () { return $6ae642ef23cd8741$export$b4d5ecaefe2b27f3; });
$parcel$export(module.exports, "q", function () { return $6ae642ef23cd8741$export$9e5f44173e64f162; });
$parcel$export(module.exports, "y", function () { return $6ae642ef23cd8741$export$4a5767248b18ef41; });
$parcel$export(module.exports, "bu", function () { return $6ae642ef23cd8741$export$f438b12253c2b499; });
$parcel$export(module.exports, "bt", function () { return $6ae642ef23cd8741$export$56350196709588fc; });
$parcel$export(module.exports, "bv", function () { return $6ae642ef23cd8741$export$5dbe06c6d8c68cfb; });
$parcel$export(module.exports, "bs", function () { return $6ae642ef23cd8741$export$4e222d082f82ee97; });
$parcel$export(module.exports, "z", function () { return $6ae642ef23cd8741$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $6ae642ef23cd8741$export$ebd11618f299a286; });
$parcel$export(module.exports, "E", function () { return $6ae642ef23cd8741$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "x", function () { return $6ae642ef23cd8741$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "L", function () { return $6ae642ef23cd8741$export$61196ced6d74a310; });
$parcel$export(module.exports, "n", function () { return $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "e", function () { return $6ae642ef23cd8741$export$f1e1789686576879; });
$parcel$export(module.exports, "M", function () { return $6ae642ef23cd8741$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "N", function () { return $6ae642ef23cd8741$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "O", function () { return $6ae642ef23cd8741$export$c4ce752e73470fba; });
$parcel$export(module.exports, "P", function () { return $6ae642ef23cd8741$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "K", function () { return $6ae642ef23cd8741$export$3466f893ebf79586; });
$parcel$export(module.exports, "m", function () { return $6ae642ef23cd8741$export$953cecd6e717a553; });
$parcel$export(module.exports, "h", function () { return $6ae642ef23cd8741$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a", function () { return $6ae642ef23cd8741$export$407448d2b89b1813; });
$parcel$export(module.exports, "f", function () { return $6ae642ef23cd8741$export$2d1720544b23b823; });
$parcel$export(module.exports, "v", function () { return $6ae642ef23cd8741$export$90a7f3efeed30595; });
$parcel$export(module.exports, "Q", function () { return $6ae642ef23cd8741$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "T", function () { return $6ae642ef23cd8741$export$971d5caa766a69d7; });
$parcel$export(module.exports, "a8", function () { return $6ae642ef23cd8741$export$c3950d9923825c02; });
$parcel$export(module.exports, "V", function () { return $6ae642ef23cd8741$export$e7c866399fa523f5; });
$parcel$export(module.exports, "a2", function () { return $6ae642ef23cd8741$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "a1", function () { return $6ae642ef23cd8741$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "B", function () { return $6ae642ef23cd8741$export$ef35774e6d314e91; });
$parcel$export(module.exports, "W", function () { return $6ae642ef23cd8741$export$71cec2538cb2c617; });
$parcel$export(module.exports, "aa", function () { return $6ae642ef23cd8741$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "C", function () { return $6ae642ef23cd8741$export$e7094788287c5e9b; });
$parcel$export(module.exports, "cq", function () { return $6ae642ef23cd8741$export$a3c9165b94390bcd; });
$parcel$export(module.exports, "b", function () { return $6ae642ef23cd8741$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "o", function () { return $6ae642ef23cd8741$export$ae1af26003f05816; });
$parcel$export(module.exports, "G", function () { return $6ae642ef23cd8741$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "ax", function () { return $6ae642ef23cd8741$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "R", function () { return $6ae642ef23cd8741$export$db202ddc8be9136; });
$parcel$export(module.exports, "S", function () { return $6ae642ef23cd8741$export$25ce5a424b770e84; });
$parcel$export(module.exports, "H", function () { return $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "p", function () { return $6ae642ef23cd8741$export$ffb5f4729a158638; });
$parcel$export(module.exports, "j", function () { return $6ae642ef23cd8741$export$35e795649ee09318; });
$parcel$export(module.exports, "I", function () { return $6ae642ef23cd8741$export$9bb611d729802a56; });
$parcel$export(module.exports, "J", function () { return $6ae642ef23cd8741$export$b4171a6734a65d42; });
$parcel$export(module.exports, "F", function () { return $6ae642ef23cd8741$export$d66501df72047452; });
$parcel$export(module.exports, "U", function () { return $6ae642ef23cd8741$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "_", function () { return $6ae642ef23cd8741$export$71511d61b312f219; });
$parcel$export(module.exports, "w", function () { return $6ae642ef23cd8741$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "ad", function () { return $6ae642ef23cd8741$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "bN", function () { return $6ae642ef23cd8741$export$45aabb5431c2d04f; });
$parcel$export(module.exports, "Y", function () { return $6ae642ef23cd8741$export$8743009a87fcb00f; });
$parcel$export(module.exports, "bP", function () { return $6ae642ef23cd8741$export$a91cd623adc48128; });
$parcel$export(module.exports, "bO", function () { return $6ae642ef23cd8741$export$2538633961795d6b; });
$parcel$export(module.exports, "bQ", function () { return $6ae642ef23cd8741$export$993a080e5cb62d74; });
$parcel$export(module.exports, "bR", function () { return $6ae642ef23cd8741$export$4d522598b426bb73; });
$parcel$export(module.exports, "bS", function () { return $6ae642ef23cd8741$export$6dabbe08653f866f; });
$parcel$export(module.exports, "l", function () { return $6ae642ef23cd8741$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $6ae642ef23cd8741$export$3b14a55fb2447963; });
$parcel$export(module.exports, "r", function () { return $6ae642ef23cd8741$export$43caf9889c228507; });
$parcel$export(module.exports, "a9", function () { return $6ae642ef23cd8741$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "X", function () { return $6ae642ef23cd8741$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "a4", function () { return $6ae642ef23cd8741$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "a5", function () { return $6ae642ef23cd8741$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a6", function () { return $6ae642ef23cd8741$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "a7", function () { return $6ae642ef23cd8741$export$a93c5207d687da10; });
$parcel$export(module.exports, "aW", function () { return $6ae642ef23cd8741$export$9d0e2d13d04f7070; });
$parcel$export(module.exports, "aY", function () { return $6ae642ef23cd8741$export$e171bab687b50e0; });
$parcel$export(module.exports, "aX", function () { return $6ae642ef23cd8741$export$1a8f5705751d8277; });
$parcel$export(module.exports, "a_", function () { return $6ae642ef23cd8741$export$a17c37559e1db147; });
$parcel$export(module.exports, "b8", function () { return $6ae642ef23cd8741$export$ad4aebacdcaf47f8; });
$parcel$export(module.exports, "bc", function () { return $6ae642ef23cd8741$export$d22783b3c2400a3a; });
$parcel$export(module.exports, "by", function () { return $6ae642ef23cd8741$export$766bf7dcfb630b6c; });
$parcel$export(module.exports, "bD", function () { return $6ae642ef23cd8741$export$b0165a7e514844; });
$parcel$export(module.exports, "bz", function () { return $6ae642ef23cd8741$export$674f8f4247a5112e; });
$parcel$export(module.exports, "bB", function () { return $6ae642ef23cd8741$export$eb84e45a33f6ba7c; });
$parcel$export(module.exports, "bA", function () { return $6ae642ef23cd8741$export$2e63b696b2c9441b; });
$parcel$export(module.exports, "bC", function () { return $6ae642ef23cd8741$export$d76842aa27385215; });
$parcel$export(module.exports, "bI", function () { return $6ae642ef23cd8741$export$27d1aff6bea49709; });
$parcel$export(module.exports, "bM", function () { return $6ae642ef23cd8741$export$ebb8f7cd71856fb9; });
$parcel$export(module.exports, "bT", function () { return $6ae642ef23cd8741$export$1314441b8d04e1d5; });
$parcel$export(module.exports, "bU", function () { return $6ae642ef23cd8741$export$e0c3a065614c6254; });
$parcel$export(module.exports, "cb", function () { return $6ae642ef23cd8741$export$54c4fabc2291e9c0; });
$parcel$export(module.exports, "cd", function () { return $6ae642ef23cd8741$export$807f1ba34db587c7; });
$parcel$export(module.exports, "c8", function () { return $6ae642ef23cd8741$export$1ec7a8278ebd1290; });
$parcel$export(module.exports, "ca", function () { return $6ae642ef23cd8741$export$89e9012e902952b6; });
$parcel$export(module.exports, "c9", function () { return $6ae642ef23cd8741$export$4ad369a19af21c23; });
$parcel$export(module.exports, "bZ", function () { return $6ae642ef23cd8741$export$c667925124dac624; });
$parcel$export(module.exports, "ck", function () { return $6ae642ef23cd8741$export$c1df809846363ebe; });
$parcel$export(module.exports, "cg", function () { return $6ae642ef23cd8741$export$6735ce526161c7bd; });
$parcel$export(module.exports, "ch", function () { return $6ae642ef23cd8741$export$6e4b1d19c6e2e012; });
$parcel$export(module.exports, "ci", function () { return $6ae642ef23cd8741$export$c5d7c1ac98841e53; });
$parcel$export(module.exports, "cj", function () { return $6ae642ef23cd8741$export$d92db8a7dc823bb0; });
$parcel$export(module.exports, "cm", function () { return $6ae642ef23cd8741$export$b02498c06ddfef28; });
$parcel$export(module.exports, "cl", function () { return $6ae642ef23cd8741$export$b975d55abac2bbe3; });
$parcel$export(module.exports, "cn", function () { return $6ae642ef23cd8741$export$1343a74baacb0543; });
$parcel$export(module.exports, "co", function () { return $6ae642ef23cd8741$export$87b6ab1c2cb8b955; });
$parcel$export(module.exports, "cp", function () { return $6ae642ef23cd8741$export$cd571ca6d1702b73; });

var $bvID6 = parcelRequire("bvID6");

var $fz456 = parcelRequire("fz456");
const $6ae642ef23cd8741$var$styleTexts = [];
const $6ae642ef23cd8741$var$styleEls = new Map();
function $6ae642ef23cd8741$export$e9316ff9106cdb75(styleText) {
    $6ae642ef23cd8741$var$styleTexts.push(styleText);
    $6ae642ef23cd8741$var$styleEls.forEach((styleEl)=>{
        $6ae642ef23cd8741$var$appendStylesTo(styleEl, styleText);
    });
}
function $6ae642ef23cd8741$export$555508cbc6add439(el) {
    if (el.isConnected && // sometimes true if SSR system simulates DOM
    el.getRootNode // sometimes undefined if SSR system simulates DOM
    ) $6ae642ef23cd8741$var$registerStylesRoot(el.getRootNode());
}
function $6ae642ef23cd8741$var$registerStylesRoot(rootNode) {
    let styleEl = $6ae642ef23cd8741$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector('style[data-fullcalendar]');
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.setAttribute('data-fullcalendar', '');
            const nonce = $6ae642ef23cd8741$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            const parentEl = rootNode === document ? document.head : rootNode;
            const insertBefore = rootNode === document ? parentEl.querySelector('script,link[rel=stylesheet],link[as=style],style') : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $6ae642ef23cd8741$var$styleEls.set(rootNode, styleEl);
        $6ae642ef23cd8741$var$hydrateStylesRoot(styleEl);
    }
}
function $6ae642ef23cd8741$var$hydrateStylesRoot(styleEl) {
    for (const styleText of $6ae642ef23cd8741$var$styleTexts)$6ae642ef23cd8741$var$appendStylesTo(styleEl, styleText);
}
function $6ae642ef23cd8741$var$appendStylesTo(styleEl, styleText) {
    const { sheet: sheet } = styleEl;
    const ruleCnt = sheet.cssRules.length;
    styleText.split('}').forEach((styleStr, i)=>{
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + '}', ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
let $6ae642ef23cd8741$var$queriedNonceValue;
function $6ae642ef23cd8741$var$getNonceValue() {
    if ($6ae642ef23cd8741$var$queriedNonceValue === undefined) $6ae642ef23cd8741$var$queriedNonceValue = $6ae642ef23cd8741$var$queryNonceValue();
    return $6ae642ef23cd8741$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $6ae642ef23cd8741$var$queryNonceValue() {
    const metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute('content')) return metaWithNonce.getAttribute('content');
    const elWithNonce = document.querySelector('script[nonce]');
    if (elWithNonce) return elWithNonce.nonce || '';
    return '';
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== 'undefined') $6ae642ef23cd8741$var$registerStylesRoot(document);
var $6ae642ef23cd8741$var$css_248z = ":root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:\"\";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:\"\";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}";
$6ae642ef23cd8741$export$e9316ff9106cdb75($6ae642ef23cd8741$var$css_248z);
class $6ae642ef23cd8741$export$96f57966bedc81b4 {
    constructor(drainedOption){
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    request(delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) this.tryDrain();
            else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
        }
    }
    pause(scope = '') {
        let { pauseDepths: pauseDepths } = this;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    }
    resume(scope = '', force) {
        let { pauseDepths: pauseDepths } = this;
        if (scope in pauseDepths) {
            if (force) delete pauseDepths[scope];
            else {
                pauseDepths[scope] -= 1;
                let depth = pauseDepths[scope];
                if (depth <= 0) delete pauseDepths[scope];
            }
            this.tryDrain();
        }
    }
    isPaused() {
        return Object.keys(this.pauseDepths).length;
    }
    tryDrain() {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while(this.isDirty){
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    }
    clear() {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    }
    clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
    drained() {
        if (this.drainedOption) this.drainedOption();
    }
}
function $6ae642ef23cd8741$export$9f4f30ee63539e24(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$export$dc98b0b04f4c7758(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($6ae642ef23cd8741$export$c03999cb2f36933f(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $6ae642ef23cd8741$export$c03999cb2f36933f(el, selector) {
    let method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $6ae642ef23cd8741$export$23ebac1979863676(container, selector) {
    let containers = container instanceof HTMLElement ? [
        container
    ] : container;
    let allMatches = [];
    for(let i = 0; i < containers.length; i += 1){
        let matches = containers[i].querySelectorAll(selector);
        for(let j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $6ae642ef23cd8741$export$91477dc880baac21(parent, selector) {
    let parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    let allMatches = [];
    for(let i = 0; i < parents.length; i += 1){
        let childNodes = parents[i].children; // only ever elements
        for(let j = 0; j < childNodes.length; j += 1){
            let childNode = childNodes[j];
            if (!selector || $6ae642ef23cd8741$export$c03999cb2f36933f(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
const $6ae642ef23cd8741$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $6ae642ef23cd8741$export$faec65b429be379(el, props) {
    for(let propName in props)$6ae642ef23cd8741$export$2219238a014317b0(el, propName, props[propName]);
}
function $6ae642ef23cd8741$export$2219238a014317b0(el, name, val) {
    if (val == null) el.style[name] = '';
    else if (typeof val === 'number' && $6ae642ef23cd8741$var$PIXEL_PROP_RE.test(name)) el.style[name] = `${val}px`;
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $6ae642ef23cd8741$export$2ed0fc6709e59212(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
let $6ae642ef23cd8741$var$guid$1 = 0;
function $6ae642ef23cd8741$export$6559d589eb85fbb6() {
    $6ae642ef23cd8741$var$guid$1 += 1;
    return 'fc-dom-' + $6ae642ef23cd8741$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $6ae642ef23cd8741$export$fef3dfd9bad05307(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$var$buildDelegationHandler(selector, handler) {
    return (ev)=>{
        let matchedChild = $6ae642ef23cd8741$export$dc98b0b04f4c7758(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $6ae642ef23cd8741$export$3d8c2f653ac9d0b9(container, eventType, selector, handler) {
    let attachedHandler = $6ae642ef23cd8741$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return ()=>{
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $6ae642ef23cd8741$export$34aec0b863436764(container, selector, onMouseEnter, onMouseLeave) {
    let currentMatchedChild;
    return $6ae642ef23cd8741$export$3d8c2f653ac9d0b9(container, 'mouseover', selector, (mouseOverEv, matchedChild)=>{
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            let realOnMouseLeave = (mouseLeaveEv)=>{
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
const $6ae642ef23cd8741$var$transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend'
];
// triggered only when the next single subsequent transition finishes
function $6ae642ef23cd8741$export$8c78c7c36408ea29(el, callback) {
    let realCallback = (ev)=>{
        callback(ev);
        $6ae642ef23cd8741$var$transitionEventNames.forEach((eventName)=>{
            el.removeEventListener(eventName, realCallback);
        });
    };
    $6ae642ef23cd8741$var$transitionEventNames.forEach((eventName)=>{
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $6ae642ef23cd8741$var$createAriaKeyboardAttrs(handler));
}
function $6ae642ef23cd8741$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
let $6ae642ef23cd8741$var$guidNumber = 0;
function $6ae642ef23cd8741$export$39b482c5e57630a8() {
    $6ae642ef23cd8741$var$guidNumber += 1;
    return String($6ae642ef23cd8741$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $6ae642ef23cd8741$export$d66dc83d8cfc8dd() {
    document.body.classList.add('fc-not-allowed');
}
// Returns the mouse cursor to its original look
function $6ae642ef23cd8741$export$1fbe638ecf81657e() {
    document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $6ae642ef23cd8741$export$2f6ca3d3b1f80bf5(el) {
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
    el.addEventListener('selectstart', $6ae642ef23cd8741$export$fef3dfd9bad05307);
}
function $6ae642ef23cd8741$export$8a5498727ef6be21(el) {
    el.style.userSelect = '';
    el.style.webkitUserSelect = '';
    el.removeEventListener('selectstart', $6ae642ef23cd8741$export$fef3dfd9bad05307);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $6ae642ef23cd8741$export$d24c54395ce0c509(el) {
    el.addEventListener('contextmenu', $6ae642ef23cd8741$export$fef3dfd9bad05307);
}
function $6ae642ef23cd8741$export$6554612db691658e(el) {
    el.removeEventListener('contextmenu', $6ae642ef23cd8741$export$fef3dfd9bad05307);
}
function $6ae642ef23cd8741$export$1a82df3d29112e01(input) {
    let specs = [];
    let tokens = [];
    let i;
    let token;
    if (typeof input === 'string') tokens = input.split(/\s*,\s*/);
    else if (typeof input === 'function') tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === 'string') specs.push(token.charAt(0) === '-' ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === 'function') specs.push({
            func: token
        });
    }
    return specs;
}
function $6ae642ef23cd8741$export$306ddfe3a8403e2(obj0, obj1, fieldSpecs) {
    let i;
    let cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $6ae642ef23cd8741$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $6ae642ef23cd8741$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $6ae642ef23cd8741$export$7a38258bbe170828(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $6ae642ef23cd8741$export$7a38258bbe170828(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === 'string' || typeof b === 'string') return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $6ae642ef23cd8741$export$21579262ef46735b(val, len) {
    let s = String(val);
    return '000'.substr(0, len - s.length) + s;
}
function $6ae642ef23cd8741$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === 'function') return formatter(...args);
    if (typeof formatter === 'string') return args.reduce((str, arg, index)=>str.replace('$' + index, arg || ''), formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $6ae642ef23cd8741$export$493d36ec626b6698(a, b) {
    return a - b;
}
function $6ae642ef23cd8741$export$ab83b03e4111b1d0(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $6ae642ef23cd8741$var$computeSmallestCellWidth(cellEl) {
    let allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
    let contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
    if (!allWidthEl) throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
    if (!contentWidthEl) throw new Error('needs fc-scrollgrid-shrink-cushion className');
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
const $6ae642ef23cd8741$var$INTERNAL_UNITS = [
    'years',
    'months',
    'days',
    'milliseconds'
];
const $6ae642ef23cd8741$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $6ae642ef23cd8741$export$4368d992c4eafac0(input, unit) {
    if (typeof input === 'string') return $6ae642ef23cd8741$var$parseString(input);
    if (typeof input === 'object' && input) return $6ae642ef23cd8741$var$parseObject(input);
    if (typeof input === 'number') return $6ae642ef23cd8741$var$parseObject({
        [unit || 'milliseconds']: input
    });
    return null;
}
function $6ae642ef23cd8741$var$parseString(s) {
    let m = $6ae642ef23cd8741$var$PARSE_RE.exec(s);
    if (m) {
        let sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $6ae642ef23cd8741$var$parseObject(obj) {
    let duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    let weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $6ae642ef23cd8741$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $6ae642ef23cd8741$export$a36fb7d24305ed9d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $6ae642ef23cd8741$export$acf3ba20e47771d(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $6ae642ef23cd8741$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $6ae642ef23cd8741$export$55ff3cc1821e8445(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $6ae642ef23cd8741$var$asRoughYears(dur) {
    return $6ae642ef23cd8741$var$asRoughDays(dur) / 365;
}
function $6ae642ef23cd8741$var$asRoughMonths(dur) {
    return $6ae642ef23cd8741$var$asRoughDays(dur) / 30;
}
function $6ae642ef23cd8741$var$asRoughDays(dur) {
    return $6ae642ef23cd8741$export$4b170465d7badfa1(dur) / 864e5;
}
function $6ae642ef23cd8741$export$847533e5bf524f5f(dur) {
    return $6ae642ef23cd8741$export$4b170465d7badfa1(dur) / 60000;
}
function $6ae642ef23cd8741$export$b169257caa88022a(dur) {
    return $6ae642ef23cd8741$export$4b170465d7badfa1(dur) / 1000;
}
function $6ae642ef23cd8741$export$4b170465d7badfa1(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $6ae642ef23cd8741$export$479ac0420f53ed26(numerator, denominator) {
    let res = null;
    for(let i = 0; i < $6ae642ef23cd8741$var$INTERNAL_UNITS.length; i += 1){
        let unit = $6ae642ef23cd8741$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            let localRes = numerator[unit] / denominator[unit];
            if (!$6ae642ef23cd8741$export$ab83b03e4111b1d0(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $6ae642ef23cd8741$export$db3b6bfb95261072(dur) {
    let ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: 'millisecond',
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: 'second',
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: 'minute',
            value: ms / 60000
        };
        if (ms) return {
            unit: 'hour',
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: 'week',
            value: dur.days / 7
        };
        return {
            unit: 'day',
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: 'month',
        value: dur.months
    };
    if (dur.years) return {
        unit: 'year',
        value: dur.years
    };
    return {
        unit: 'millisecond',
        value: 0
    };
}
// TODO: new util arrayify?
function $6ae642ef23cd8741$export$3d12bd131bb975d1(array, exactVal) {
    let removeCnt = 0;
    let i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $6ae642ef23cd8741$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    let len = a0.length;
    let i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
const $6ae642ef23cd8741$var$DAY_IDS = [
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat'
];
// Adding
function $6ae642ef23cd8741$export$151db275011178c4(m, n) {
    let a = $6ae642ef23cd8741$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $6ae642ef23cd8741$var$arrayToUtcDate(a);
}
function $6ae642ef23cd8741$export$625550452a3fa3ec(m, n) {
    let a = $6ae642ef23cd8741$var$dateToUtcArray(m);
    a[2] += n;
    return $6ae642ef23cd8741$var$arrayToUtcDate(a);
}
function $6ae642ef23cd8741$export$51b138e5a065c2bb(m, n) {
    let a = $6ae642ef23cd8741$var$dateToUtcArray(m);
    a[6] += n;
    return $6ae642ef23cd8741$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $6ae642ef23cd8741$export$136fd86de524d3c2(m0, m1) {
    return $6ae642ef23cd8741$export$b4d5ecaefe2b27f3(m0, m1) / 7;
}
function $6ae642ef23cd8741$export$b4d5ecaefe2b27f3(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $6ae642ef23cd8741$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $6ae642ef23cd8741$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $6ae642ef23cd8741$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $6ae642ef23cd8741$export$62d08d6fa708df47(m0, m1) {
    let m0day = $6ae642ef23cd8741$export$9e5f44173e64f162(m0);
    let m1day = $6ae642ef23cd8741$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($6ae642ef23cd8741$export$b4d5ecaefe2b27f3(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $6ae642ef23cd8741$export$31e67cf12fc9668(m0, m1) {
    let d = $6ae642ef23cd8741$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $6ae642ef23cd8741$export$4a5767248b18ef41(m0, m1) {
    if ($6ae642ef23cd8741$var$timeAsMs(m0) === $6ae642ef23cd8741$var$timeAsMs(m1)) return Math.round($6ae642ef23cd8741$export$b4d5ecaefe2b27f3(m0, m1));
    return null;
}
// Start-Of
function $6ae642ef23cd8741$export$9e5f44173e64f162(m) {
    return $6ae642ef23cd8741$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $6ae642ef23cd8741$var$startOfHour(m) {
    return $6ae642ef23cd8741$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $6ae642ef23cd8741$var$startOfMinute(m) {
    return $6ae642ef23cd8741$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $6ae642ef23cd8741$var$startOfSecond(m) {
    return $6ae642ef23cd8741$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $6ae642ef23cd8741$var$weekOfYear(marker, dow, doy) {
    let y = marker.getUTCFullYear();
    let w = $6ae642ef23cd8741$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $6ae642ef23cd8741$var$weekOfGivenYear(marker, y - 1, dow, doy);
    let nextW = $6ae642ef23cd8741$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $6ae642ef23cd8741$var$weekOfGivenYear(marker, year, dow, doy) {
    let firstWeekStart = $6ae642ef23cd8741$var$arrayToUtcDate([
        year,
        0,
        1 + $6ae642ef23cd8741$var$firstWeekOffset(year, dow, doy)
    ]);
    let dayStart = $6ae642ef23cd8741$export$9e5f44173e64f162(marker);
    let days = Math.round($6ae642ef23cd8741$export$b4d5ecaefe2b27f3(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $6ae642ef23cd8741$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    let fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    let fwdlw = (7 + $6ae642ef23cd8741$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $6ae642ef23cd8741$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $6ae642ef23cd8741$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $6ae642ef23cd8741$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $6ae642ef23cd8741$var$arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date(Date.UTC(...a));
}
// Other Utils
function $6ae642ef23cd8741$export$5521614468b862fb(m) {
    return !isNaN(m.valueOf());
}
function $6ae642ef23cd8741$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $6ae642ef23cd8741$export$f438b12253c2b499(marker, timeZoneOffset, stripZeroTime = false) {
    let s = marker.toISOString();
    s = s.replace('.000', '');
    if (stripZeroTime) s = s.replace('T00:00:00Z', '');
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace('Z', '');
        else if (timeZoneOffset !== 0) s = s.replace('Z', $6ae642ef23cd8741$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $6ae642ef23cd8741$export$56350196709588fc(marker) {
    return marker.toISOString().replace(/T.*$/, '');
}
function $6ae642ef23cd8741$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $6ae642ef23cd8741$export$4e222d082f82ee97(marker) {
    return $6ae642ef23cd8741$export$21579262ef46735b(marker.getUTCHours(), 2) + ':' + $6ae642ef23cd8741$export$21579262ef46735b(marker.getUTCMinutes(), 2) + ':' + $6ae642ef23cd8741$export$21579262ef46735b(marker.getUTCSeconds(), 2);
}
function $6ae642ef23cd8741$var$formatTimeZoneOffset(minutes, doIso = false) {
    let sign = minutes < 0 ? '-' : '+';
    let abs = Math.abs(minutes);
    let hours = Math.floor(abs / 60);
    let mins = Math.round(abs % 60);
    if (doIso) return `${sign + $6ae642ef23cd8741$export$21579262ef46735b(hours, 2)}:${$6ae642ef23cd8741$export$21579262ef46735b(mins, 2)}`;
    return `GMT${sign}${hours}${mins ? `:${$6ae642ef23cd8741$export$21579262ef46735b(mins, 2)}` : ''}`;
}
function $6ae642ef23cd8741$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    let currentArgs;
    let currentRes;
    return function(...newArgs) {
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$6ae642ef23cd8741$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $6ae642ef23cd8741$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    let currentArg;
    let currentRes;
    return (newArg)=>{
        if (!currentArg) currentRes = workerFunc.call(this, newArg);
        else if (!$6ae642ef23cd8741$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.call(this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $6ae642ef23cd8741$export$91c6e00c14e7e6fd(workerFunc, resEquality, teardownFunc) {
    let currentArgSets = [];
    let currentResults = [];
    return (newArgSets)=>{
        let currentLen = currentArgSets.length;
        let newLen = newArgSets.length;
        let i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$6ae642ef23cd8741$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                let res = workerFunc.apply(this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $6ae642ef23cd8741$export$9d398bebfec1c039(workerFunc, resEquality, teardownFunc) {
    let currentArgHash = {};
    let currentResHash = {};
    return (newArgHash)=>{
        let newResHash = {};
        for(let key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(this, newArgHash[key]);
            else if (!$6ae642ef23cd8741$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                let res = workerFunc.apply(this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
const $6ae642ef23cd8741$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 9,
    omitZeroMinute: 9,
    meridiem: 9,
    omitCommas: 9
};
const $6ae642ef23cd8741$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
const $6ae642ef23cd8741$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
const $6ae642ef23cd8741$var$COMMA_RE = /,/g; // we need re for globalness
const $6ae642ef23cd8741$var$MULTI_SPACE_RE = /\s+/g;
const $6ae642ef23cd8741$var$LTR_RE = /\u200e/g; // control character
const $6ae642ef23cd8741$var$UTC_RE = /UTC|GMT/;
class $6ae642ef23cd8741$var$NativeFormatter {
    constructor(formatSettings){
        let standardDateProps = {};
        let extendedSettings = {};
        let smallestUnitNum = 9; // the smallest unit in the formatter (9 is a sentinel, beyond max)
        for(let name in formatSettings)if (name in $6ae642ef23cd8741$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            const severity = $6ae642ef23cd8741$var$EXTENDED_SETTINGS_AND_SEVERITIES[name];
            if (severity < 9) smallestUnitNum = Math.min($6ae642ef23cd8741$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], smallestUnitNum);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $6ae642ef23cd8741$var$STANDARD_DATE_PROP_SEVERITIES) smallestUnitNum = Math.min($6ae642ef23cd8741$var$STANDARD_DATE_PROP_SEVERITIES[name], smallestUnitNum);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.smallestUnitNum = smallestUnitNum;
        this.buildFormattingFunc = $6ae642ef23cd8741$export$df995fae86a55f06($6ae642ef23cd8741$var$buildFormattingFunc);
    }
    format(date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        let { standardDateProps: standardDateProps, extendedSettings: extendedSettings } = this;
        let diffSeverity = $6ae642ef23cd8741$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) return this.format(start, context);
        let biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
        (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') && (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') && (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        let full0 = this.format(start, context);
        let full1 = this.format(end, context);
        if (full0 === full1) return full0;
        let partialDateProps = $6ae642ef23cd8741$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        let partialFormattingFunc = $6ae642ef23cd8741$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
        let partial0 = partialFormattingFunc(start);
        let partial1 = partialFormattingFunc(end);
        let insertion = $6ae642ef23cd8741$var$findCommonInsertion(full0, partial0, full1, partial1);
        let separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
        if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
        return full0 + separator + full1;
    }
    getSmallestUnit() {
        switch(this.smallestUnitNum){
            case 7:
            case 6:
            case 5:
                return 'year';
            case 4:
                return 'month';
            case 3:
                return 'week';
            case 2:
                return 'day';
            default:
                return 'time'; // really?
        }
    }
}
function $6ae642ef23cd8741$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    let standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') return (date)=>$6ae642ef23cd8741$var$formatTimeZoneOffset(date.timeZoneOffset);
    if (standardDatePropCnt === 0 && extendedSettings.week) return (date)=>$6ae642ef23cd8741$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    return $6ae642ef23cd8741$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $6ae642ef23cd8741$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $6ae642ef23cd8741$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
    let normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    let zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        let zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return (date)=>{
        let { marker: marker } = date;
        let format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        let s = format.format(marker);
        return $6ae642ef23cd8741$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $6ae642ef23cd8741$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = '2-digit';
        if (!standardDateProps.minute) standardDateProps.minute = '2-digit';
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === 'long') standardDateProps.timeZoneName = 'short';
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $6ae642ef23cd8741$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($6ae642ef23cd8741$var$LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === 'short') s = $6ae642ef23cd8741$var$injectTzoStr(s, context.timeZone === 'UTC' || date.timeZoneOffset == null ? 'UTC' : $6ae642ef23cd8741$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($6ae642ef23cd8741$var$COMMA_RE, '').trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($6ae642ef23cd8741$var$MERIDIEM_RE, '').trim();
    else if (extendedSettings.meridiem === 'narrow') s = s.replace($6ae642ef23cd8741$var$MERIDIEM_RE, (m0, m1)=>m1.toLocaleLowerCase());
    else if (extendedSettings.meridiem === 'short') s = s.replace($6ae642ef23cd8741$var$MERIDIEM_RE, (m0, m1)=>`${m1.toLocaleLowerCase()}m`);
    else if (extendedSettings.meridiem === 'lowercase') s = s.replace($6ae642ef23cd8741$var$MERIDIEM_RE, (m0)=>m0.toLocaleLowerCase());
    s = s.replace($6ae642ef23cd8741$var$MULTI_SPACE_RE, ' ');
    s = s.trim();
    return s;
}
function $6ae642ef23cd8741$var$injectTzoStr(s, tzoStr) {
    let replaced = false;
    s = s.replace($6ae642ef23cd8741$var$UTC_RE, ()=>{
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += ` ${tzoStr}`;
    return s;
}
function $6ae642ef23cd8741$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    let parts = [];
    if (display === 'long') parts.push(weekTextLong);
    else if (display === 'short' || display === 'narrow') parts.push(weekText);
    if (display === 'long' || display === 'short') parts.push(' ');
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === 'rtl') parts.reverse();
    return parts.join('');
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $6ae642ef23cd8741$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($6ae642ef23cd8741$var$timeAsMs(d0) !== $6ae642ef23cd8741$var$timeAsMs(d1)) return 1;
    return 0;
}
function $6ae642ef23cd8741$var$computePartialFormattingOptions(options, biggestUnit) {
    let partialOptions = {};
    for(let name in options)if (!(name in $6ae642ef23cd8741$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $6ae642ef23cd8741$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $6ae642ef23cd8741$var$findCommonInsertion(full0, partial0, full1, partial1) {
    let i0 = 0;
    while(i0 < full0.length){
        let found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        let before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        let after0 = full0.substr(i0);
        let i1 = 0;
        while(i1 < full1.length){
            let found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            let before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            let after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $6ae642ef23cd8741$var$expandZonedMarker(dateInfo, calendarSystem) {
    let a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $6ae642ef23cd8741$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    let startInfo = $6ae642ef23cd8741$var$expandZonedMarker(start, context.calendarSystem);
    let endInfo = end ? $6ae642ef23cd8741$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ class $6ae642ef23cd8741$var$CmdFormatter {
    constructor(cmdStr){
        this.cmdStr = cmdStr;
    }
    format(date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $6ae642ef23cd8741$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $6ae642ef23cd8741$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
class $6ae642ef23cd8741$var$FuncFormatter {
    constructor(func){
        this.func = func;
    }
    format(date, context, betterDefaultSeparator) {
        return this.func($6ae642ef23cd8741$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return this.func($6ae642ef23cd8741$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
function $6ae642ef23cd8741$export$d141bba7fdc215a3(input) {
    if (typeof input === 'object' && input) return new $6ae642ef23cd8741$var$NativeFormatter(input);
    if (typeof input === 'string') return new $6ae642ef23cd8741$var$CmdFormatter(input);
    if (typeof input === 'function') return new $6ae642ef23cd8741$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
const $6ae642ef23cd8741$export$61196ced6d74a310 = {
    navLinkDayClick: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    duration: $6ae642ef23cd8741$export$4368d992c4eafac0,
    bootstrapFontAwesome: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    buttonIcons: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    customButtons: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $6ae642ef23cd8741$export$4368d992c4eafac0,
    defaultTimedEventDuration: $6ae642ef23cd8741$export$4368d992c4eafac0,
    nextDayThreshold: $6ae642ef23cd8741$export$4368d992c4eafac0,
    scrollTime: $6ae642ef23cd8741$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $6ae642ef23cd8741$export$4368d992c4eafac0,
    slotMaxTime: $6ae642ef23cd8741$export$4368d992c4eafac0,
    dayPopoverFormat: $6ae642ef23cd8741$export$d141bba7fdc215a3,
    slotDuration: $6ae642ef23cd8741$export$4368d992c4eafac0,
    snapDuration: $6ae642ef23cd8741$export$4368d992c4eafac0,
    headerToolbar: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    footerToolbar: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $6ae642ef23cd8741$export$d141bba7fdc215a3,
    dayHeaderClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayCellContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    viewDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorSnap: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    nowIndicatorClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    locale: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventOrder: $6ae642ef23cd8741$export$1a82df3d29112e01,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    contentHeight: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $6ae642ef23cd8741$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    initialDate: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    now: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    viewHeight: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventConstraint: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventAllow: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    selectConstraint: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    selectOverlap: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    selectAllow: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $6ae642ef23cd8741$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    allDayContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $6ae642ef23cd8741$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $6ae642ef23cd8741$export$4368d992c4eafac0,
    hiddenDays: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    visibleRange: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    titleFormat: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    navLinkHint: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $6ae642ef23cd8741$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    customRenderingReplaces: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
const $6ae642ef23cd8741$export$f1e1789686576879 = {
    eventDisplay: 'auto',
    defaultRangeSeparator: ' - ',
    titleRangeSeparator: ' \u2013 ',
    defaultTimedEventDuration: '01:00:00',
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: '00:00:00',
    dayHeaders: true,
    initialView: '',
    aspectRatio: 1.35,
    headerToolbar: {
        start: 'title',
        center: '',
        end: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: 'local',
    editable: false,
    nowIndicator: false,
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    slotMinTime: '00:00:00',
    slotMaxTime: '24:00:00',
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timeZoneParam: 'timeZone',
    timeZone: 'local',
    locales: [],
    locale: '',
    themeSystem: 'standard',
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: '*',
    eventOrder: 'start,-duration,allDay,title',
    dayPopoverFormat: {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: 'long',
        day: 'numeric'
    },
    nowIndicatorSnap: 'auto'
};
// calendar listeners
// ------------------
const $6ae642ef23cd8741$export$3a1a48c8f6ef640e = {
    datesSet: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventsSet: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventAdd: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventChange: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventRemove: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    windowResize: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventClick: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    select: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    unselect: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    loading: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    _beforeprint: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    _afterprint: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    _noEventResize: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    _resize: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
const $6ae642ef23cd8741$export$a07804094c3ecf2d = {
    buttonText: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    buttonHints: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    views: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    plugins: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    initialEvents: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    events: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventSources: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5
};
const $6ae642ef23cd8741$export$c4ce752e73470fba = {
    headerToolbar: $6ae642ef23cd8741$var$isMaybeObjectsEqual,
    footerToolbar: $6ae642ef23cd8741$var$isMaybeObjectsEqual,
    buttonText: $6ae642ef23cd8741$var$isMaybeObjectsEqual,
    buttonHints: $6ae642ef23cd8741$var$isMaybeObjectsEqual,
    buttonIcons: $6ae642ef23cd8741$var$isMaybeObjectsEqual,
    dateIncrement: $6ae642ef23cd8741$var$isMaybeObjectsEqual,
    plugins: $6ae642ef23cd8741$var$isMaybeArraysEqual,
    events: $6ae642ef23cd8741$var$isMaybeArraysEqual,
    eventSources: $6ae642ef23cd8741$var$isMaybeArraysEqual,
    ['resources']: $6ae642ef23cd8741$var$isMaybeArraysEqual
};
function $6ae642ef23cd8741$var$isMaybeObjectsEqual(a, b) {
    if (typeof a === 'object' && typeof b === 'object' && a && b) return $6ae642ef23cd8741$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $6ae642ef23cd8741$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $6ae642ef23cd8741$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
const $6ae642ef23cd8741$export$56c0d5a1e737357d = {
    type: String,
    component: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    content: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    didMount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    willUnmount: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$export$3466f893ebf79586(optionSets) {
    return $6ae642ef23cd8741$export$953cecd6e717a553(optionSets, $6ae642ef23cd8741$export$c4ce752e73470fba);
}
function $6ae642ef23cd8741$export$ee7c8ad385a60b7b(input, refiners) {
    let refined = {};
    let extra = {};
    for(let propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(let propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
    return {
        refined: refined,
        extra: extra
    };
}
function $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
const { hasOwnProperty: $6ae642ef23cd8741$var$hasOwnProperty } = Object.prototype;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $6ae642ef23cd8741$export$953cecd6e717a553(propObjs, complexPropsMap) {
    let dest = {};
    if (complexPropsMap) {
        for(let name in complexPropsMap)if (complexPropsMap[name] === $6ae642ef23cd8741$var$isMaybeObjectsEqual) {
            let complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(let i = propObjs.length - 1; i >= 0; i -= 1){
                let val = propObjs[i][name];
                if (typeof val === 'object' && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $6ae642ef23cd8741$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(let i = propObjs.length - 1; i >= 0; i -= 1){
        let props = propObjs[i];
        for(let name in props)if (!(name in dest)) dest[name] = props[name];
    }
    return dest;
}
function $6ae642ef23cd8741$export$dda1d9f60106f0e9(hash, func) {
    let filtered = {};
    for(let key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $6ae642ef23cd8741$export$407448d2b89b1813(hash, func) {
    let newHash = {};
    for(let key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $6ae642ef23cd8741$export$2d1720544b23b823(a) {
    let hash = {};
    for (let item of a)hash[item] = true;
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $6ae642ef23cd8741$export$90a7f3efeed30595(obj) {
    let a = [];
    for(let key in obj)a.push(obj[key]);
    return a;
}
function $6ae642ef23cd8741$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(let key in obj0)if ($6ae642ef23cd8741$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(let key in obj1)if ($6ae642ef23cd8741$var$hasOwnProperty.call(obj1, key)) {
        if (obj0[key] !== obj1[key]) return false;
    }
    return true;
}
const $6ae642ef23cd8741$var$HANDLER_RE = /^on[A-Z]/;
function $6ae642ef23cd8741$var$isNonHandlerPropsEqual(obj0, obj1) {
    const keys = $6ae642ef23cd8741$var$getUnequalProps(obj0, obj1);
    for (let key of keys){
        if (!$6ae642ef23cd8741$var$HANDLER_RE.test(key)) return false;
    }
    return true;
}
function $6ae642ef23cd8741$var$getUnequalProps(obj0, obj1) {
    let keys = [];
    for(let key in obj0){
        if ($6ae642ef23cd8741$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(let key in obj1){
        if ($6ae642ef23cd8741$var$hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) keys.push(key);
        }
    }
    return keys;
}
function $6ae642ef23cd8741$export$b9a6b53f9be3734(oldProps, newProps, equalityFuncs = {}) {
    if (oldProps === newProps) return true;
    // if (debug) {
    //   for (let key in newProps) {
    //     if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) {
    //       // equal
    //     } else {
    //       if (debug) {
    //         console.log('prop difference', key, oldProps[key], newProps[key])
    //       }
    //     }
    //   }
    //   // check for props that were omitted in the new
    //   for (let key in oldProps) {
    //     if (!(key in newProps)) {
    //       if (debug) {
    //         console.log('prop absent', key)
    //       }
    //     }
    //   }
    // }
    for(let key in newProps){
        if (key in oldProps && $6ae642ef23cd8741$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(let key in oldProps){
        if (!(key in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $6ae642ef23cd8741$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $6ae642ef23cd8741$export$a05254e7c3aeba6e(hash, startIndex = 0, endIndex, step = 1) {
    let res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(let i = startIndex; i < endIndex; i += step){
        let val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
let $6ae642ef23cd8741$var$calendarSystemClassMap = {};
function $6ae642ef23cd8741$var$registerCalendarSystem(name, theClass) {
    $6ae642ef23cd8741$var$calendarSystemClassMap[name] = theClass;
}
function $6ae642ef23cd8741$var$createCalendarSystem(name) {
    return new $6ae642ef23cd8741$var$calendarSystemClassMap[name]();
}
class $6ae642ef23cd8741$var$GregorianCalendarSystem {
    getMarkerYear(d) {
        return d.getUTCFullYear();
    }
    getMarkerMonth(d) {
        return d.getUTCMonth();
    }
    getMarkerDay(d) {
        return d.getUTCDate();
    }
    arrayToMarker(arr) {
        return $6ae642ef23cd8741$var$arrayToUtcDate(arr);
    }
    markerToArray(marker) {
        return $6ae642ef23cd8741$var$dateToUtcArray(marker);
    }
}
$6ae642ef23cd8741$var$registerCalendarSystem('gregory', $6ae642ef23cd8741$var$GregorianCalendarSystem);
const $6ae642ef23cd8741$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $6ae642ef23cd8741$export$26a0a7676ca7aa04(str) {
    let m = $6ae642ef23cd8741$var$ISO_RE.exec(str);
    if (m) {
        let marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
        if ($6ae642ef23cd8741$export$5521614468b862fb(marker)) {
            let timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
class $6ae642ef23cd8741$export$3722cfe417b6ed86 {
    constructor(settings){
        let timeZone = this.timeZone = settings.timeZone;
        let isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $6ae642ef23cd8741$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === 'ISO') {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === 'number') this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === 'function') this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    createMarker(input) {
        let meta = this.createMarkerMeta(input);
        if (meta === null) return null;
        return meta.marker;
    }
    createNowMarker() {
        if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return $6ae642ef23cd8741$var$arrayToUtcDate($6ae642ef23cd8741$var$dateToLocalArray(new Date()));
    }
    createMarkerMeta(input) {
        if (typeof input === 'string') return this.parse(input);
        let marker = null;
        if (typeof input === 'number') marker = this.timestampToMarker(input);
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) marker = this.timestampToMarker(input);
        } else if (Array.isArray(input)) marker = $6ae642ef23cd8741$var$arrayToUtcDate(input);
        if (marker === null || !$6ae642ef23cd8741$export$5521614468b862fb(marker)) return null;
        return {
            marker: marker,
            isTimeUnspecified: false,
            forcedTzo: null
        };
    }
    parse(s) {
        let parts = $6ae642ef23cd8741$export$26a0a7676ca7aa04(s);
        if (parts === null) return null;
        let { marker: marker } = parts;
        let forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
            else forcedTzo = parts.timeZoneOffset;
        }
        return {
            marker: marker,
            isTimeUnspecified: parts.isTimeUnspecified,
            forcedTzo: forcedTzo
        };
    }
    // Accessors
    getYear(marker) {
        return this.calendarSystem.getMarkerYear(marker);
    }
    getMonth(marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    }
    getDay(marker) {
        return this.calendarSystem.getMarkerDay(marker);
    }
    // Adding / Subtracting
    add(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    subtract(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    addYears(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    addMonths(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    // Diffing Whole Units
    diffWholeYears(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($6ae642ef23cd8741$var$timeAsMs(m0) === $6ae642ef23cd8741$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        return null;
    }
    diffWholeMonths(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($6ae642ef23cd8741$var$timeAsMs(m0) === $6ae642ef23cd8741$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        return null;
    }
    // Range / Duration
    greatestWholeUnit(m0, m1) {
        let n = this.diffWholeYears(m0, m1);
        if (n !== null) return {
            unit: 'year',
            value: n
        };
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) return {
            unit: 'month',
            value: n
        };
        n = $6ae642ef23cd8741$export$31e67cf12fc9668(m0, m1);
        if (n !== null) return {
            unit: 'week',
            value: n
        };
        n = $6ae642ef23cd8741$export$4a5767248b18ef41(m0, m1);
        if (n !== null) return {
            unit: 'day',
            value: n
        };
        n = $6ae642ef23cd8741$var$diffHours(m0, m1);
        if ($6ae642ef23cd8741$export$ab83b03e4111b1d0(n)) return {
            unit: 'hour',
            value: n
        };
        n = $6ae642ef23cd8741$var$diffMinutes(m0, m1);
        if ($6ae642ef23cd8741$export$ab83b03e4111b1d0(n)) return {
            unit: 'minute',
            value: n
        };
        n = $6ae642ef23cd8741$var$diffSeconds(m0, m1);
        if ($6ae642ef23cd8741$export$ab83b03e4111b1d0(n)) return {
            unit: 'second',
            value: n
        };
        return {
            unit: 'millisecond',
            value: m1.valueOf() - m0.valueOf()
        };
    }
    countDurationsBetween(m0, m1, d) {
        // TODO: can use greatestWholeUnit
        let diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) return diff / $6ae642ef23cd8741$var$asRoughYears(d);
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) return diff / $6ae642ef23cd8741$var$asRoughMonths(d);
        }
        if (d.days) {
            diff = $6ae642ef23cd8741$export$4a5767248b18ef41(m0, m1);
            if (diff !== null) return diff / $6ae642ef23cd8741$var$asRoughDays(d);
        }
        return (m1.valueOf() - m0.valueOf()) / $6ae642ef23cd8741$export$4b170465d7badfa1(d);
    }
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    startOf(m, unit) {
        if (unit === 'year') return this.startOfYear(m);
        if (unit === 'month') return this.startOfMonth(m);
        if (unit === 'week') return this.startOfWeek(m);
        if (unit === 'day') return $6ae642ef23cd8741$export$9e5f44173e64f162(m);
        if (unit === 'hour') return $6ae642ef23cd8741$var$startOfHour(m);
        if (unit === 'minute') return $6ae642ef23cd8741$var$startOfMinute(m);
        if (unit === 'second') return $6ae642ef23cd8741$var$startOfSecond(m);
        return null;
    }
    startOfYear(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m)
        ]);
    }
    startOfMonth(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m)
        ]);
    }
    startOfWeek(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
        ]);
    }
    // Week Number
    computeWeekNumber(marker) {
        if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
        return $6ae642ef23cd8741$var$weekOfYear(marker, this.weekDow, this.weekDoy);
    }
    // TODO: choke on timeZoneName: long
    format(marker, formatter, dateOptions = {}) {
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
        }, this);
    }
    formatRange(start, end, formatter, dateOptions = {}) {
        if (dateOptions.isEndExclusive) end = $6ae642ef23cd8741$export$51b138e5a065c2bb(end, -1);
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
        }, this, dateOptions.defaultSeparator);
    }
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ formatIso(marker, extraOptions = {}) {
        let timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
            else timeZoneOffset = this.offsetForMarker(marker);
        }
        return $6ae642ef23cd8741$export$f438b12253c2b499(marker, timeZoneOffset, extraOptions.omitTime);
    }
    // TimeZone
    timestampToMarker(ms) {
        if (this.timeZone === 'local') return $6ae642ef23cd8741$var$arrayToUtcDate($6ae642ef23cd8741$var$dateToLocalArray(new Date(ms)));
        if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) return new Date(ms);
        return $6ae642ef23cd8741$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    }
    offsetForMarker(m) {
        if (this.timeZone === 'local') return -$6ae642ef23cd8741$var$arrayToLocalDate($6ae642ef23cd8741$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        if (this.timeZone === 'UTC') return 0;
        if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($6ae642ef23cd8741$var$dateToUtcArray(m));
        return null;
    }
    // Conversion
    toDate(m, forcedTzo) {
        if (this.timeZone === 'local') return $6ae642ef23cd8741$var$arrayToLocalDate($6ae642ef23cd8741$var$dateToUtcArray(m));
        if (this.timeZone === 'UTC') return new Date(m.valueOf()); // make sure it's a copy
        if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
        return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($6ae642ef23cd8741$var$dateToUtcArray(m)) * 60000);
    }
}
class $6ae642ef23cd8741$export$971d5caa766a69d7 {
    constructor(calendarOptions){
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    setIconOverride(iconOverrideHash) {
        let iconClassesCopy;
        let buttonName;
        if (typeof iconOverrideHash === 'object' && iconOverrideHash) {
            iconClassesCopy = Object.assign({}, this.iconClasses);
            for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            this.iconClasses = iconClassesCopy;
        } else if (iconOverrideHash === false) this.iconClasses = {};
    }
    applyIconOverridePrefix(className) {
        let prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
        return className;
    }
    getClass(key) {
        return this.classes[key] || '';
    }
    getIconClass(buttonName, isRtl) {
        let className;
        if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        else className = this.iconClasses[buttonName];
        if (className) return `${this.baseIconClass} ${className}`;
        return '';
    }
    getCustomButtonIconClass(customButtonProps) {
        let className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) return `${this.baseIconClass} ${this.applyIconOverridePrefix(className)}`;
        }
        return '';
    }
}
$6ae642ef23cd8741$export$971d5caa766a69d7.prototype.classes = {};
$6ae642ef23cd8741$export$971d5caa766a69d7.prototype.iconClasses = {};
$6ae642ef23cd8741$export$971d5caa766a69d7.prototype.baseIconClass = '';
$6ae642ef23cd8741$export$971d5caa766a69d7.prototype.iconOverridePrefix = '';
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $6ae642ef23cd8741$export$c3950d9923825c02(runBeforeFlush) {
    runBeforeFlush();
    let oldDebounceRendering = $bvID6.options.debounceRendering; // orig
    let callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $bvID6.options.debounceRendering = execCallbackSync;
    $bvID6.render($bvID6.createElement($6ae642ef23cd8741$var$FakeComponent, {}), document.createElement('div'));
    while(callbackQ.length)callbackQ.shift()();
    $bvID6.options.debounceRendering = oldDebounceRendering;
}
class $6ae642ef23cd8741$var$FakeComponent extends $bvID6.Component {
    render() {
        return $bvID6.createElement('div', {});
    }
    componentDidMount() {
        this.setState({});
    }
}
// TODO: use preact/compat instead?
function $6ae642ef23cd8741$export$c9170ad7d4cd7e57(defaultValue) {
    let ContextType = $bvID6.createContext(defaultValue);
    let origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        let isNew = !this.getChildContext;
        let children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            let subs = [];
            this.shouldComponentUpdate = (_props)=>{
                if (this.props.value !== _props.value) subs.forEach((c)=>{
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = (c)=>{
                subs.push(c);
                let old = c.componentWillUnmount;
                c.componentWillUnmount = ()=>{
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
class $6ae642ef23cd8741$export$49e6ee724f7f1ace {
    constructor(execFunc, emitter, scrollTime, scrollTimeReset){
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = (request)=>{
            this.queuedRequest = Object.assign({}, this.queuedRequest || {}, request);
            this.drain();
        };
        emitter.on('_scrollRequest', this.handleScrollRequest);
        this.fireInitialScroll();
    }
    detach() {
        this.emitter.off('_scrollRequest', this.handleScrollRequest);
    }
    update(isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
        else this.drain();
    }
    fireInitialScroll() {
        this.handleScrollRequest({
            time: this.scrollTime
        });
    }
    drain() {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
    }
}
const $6ae642ef23cd8741$export$e7c866399fa523f5 = $6ae642ef23cd8741$export$c9170ad7d4cd7e57({}); // for Components
function $6ae642ef23cd8741$export$ce26c07117d59d6a(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, nowManager, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        nowManager: nowManager,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === 'rtl',
        addResizeHandler (handler) {
            emitter.on('_resize', handler);
        },
        removeResizeHandler (handler) {
            emitter.off('_resize', handler);
        },
        createScrollResponder (execFunc) {
            return new $6ae642ef23cd8741$export$49e6ee724f7f1ace(execFunc, emitter, $6ae642ef23cd8741$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ class $6ae642ef23cd8741$export$3c2fa207a37baaea extends (0, $bvID6.Component) {
    // debug: boolean
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = !$6ae642ef23cd8741$export$b9a6b53f9be3734(this.props, nextProps, this.propEquality /*, this.debug */ ) || !$6ae642ef23cd8741$export$b9a6b53f9be3734(this.state, nextState, this.stateEquality /*, this.debug */ );
        // if (this.debug && shouldUpdate) {
        //   console.log('shouldUpdate!')
        // }
        return shouldUpdate;
    }
    // HACK for freakin' React StrictMode
    safeSetState(newState) {
        if (!$6ae642ef23cd8741$export$b9a6b53f9be3734(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
    }
}
$6ae642ef23cd8741$export$3c2fa207a37baaea.addPropsEquality = $6ae642ef23cd8741$var$addPropsEquality;
$6ae642ef23cd8741$export$3c2fa207a37baaea.addStateEquality = $6ae642ef23cd8741$var$addStateEquality;
$6ae642ef23cd8741$export$3c2fa207a37baaea.contextType = $6ae642ef23cd8741$export$e7c866399fa523f5;
$6ae642ef23cd8741$export$3c2fa207a37baaea.prototype.propEquality = {};
$6ae642ef23cd8741$export$3c2fa207a37baaea.prototype.stateEquality = {};
class $6ae642ef23cd8741$export$ef35774e6d314e91 extends $6ae642ef23cd8741$export$3c2fa207a37baaea {
}
$6ae642ef23cd8741$export$ef35774e6d314e91.contextType = $6ae642ef23cd8741$export$e7c866399fa523f5;
function $6ae642ef23cd8741$var$addPropsEquality(propEquality) {
    let hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $6ae642ef23cd8741$var$addStateEquality(stateEquality) {
    let hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $6ae642ef23cd8741$export$71cec2538cb2c617(ref, current) {
    if (typeof ref === 'function') ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
class $6ae642ef23cd8741$var$ContentInjector extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.id = $6ae642ef23cd8741$export$39b482c5e57630a8();
        this.queuedDomNodes = [];
        this.currentDomNodes = [];
        this.handleEl = (el)=>{
            const { options: options } = this.context;
            const { generatorName: generatorName } = this.props;
            if (!options.customRenderingReplaces || !$6ae642ef23cd8741$var$hasCustomRenderingHandler(generatorName, options)) this.updateElRef(el);
        };
        this.updateElRef = (el)=>{
            if (this.props.elRef) $6ae642ef23cd8741$export$71cec2538cb2c617(this.props.elRef, el);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { customGenerator: customGenerator, defaultGenerator: defaultGenerator, renderProps: renderProps } = props;
        const attrs = $6ae642ef23cd8741$export$9ddbdd0bfc5623a(props, [], this.handleEl);
        let useDefault = false;
        let innerContent;
        let queuedDomNodes = [];
        let currentGeneratorMeta;
        if (customGenerator != null) {
            const customGeneratorRes = typeof customGenerator === 'function' ? customGenerator(renderProps, (0, $bvID6.createElement)) : customGenerator;
            if (customGeneratorRes === true) useDefault = true;
            else {
                const isObject = customGeneratorRes && typeof customGeneratorRes === 'object'; // non-null
                if (isObject && 'html' in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                    __html: customGeneratorRes.html
                };
                else if (isObject && 'domNodes' in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                else if (isObject ? (0, $bvID6.isValidElement)(customGeneratorRes) // vdom node
                 : typeof customGeneratorRes !== 'function' // primitive value (like string or number)
                ) // use in vdom
                innerContent = customGeneratorRes;
                else // an exotic object for handleCustomRendering
                currentGeneratorMeta = customGeneratorRes;
            }
        } else useDefault = !$6ae642ef23cd8741$var$hasCustomRenderingHandler(props.generatorName, options);
        if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
        this.queuedDomNodes = queuedDomNodes;
        this.currentGeneratorMeta = currentGeneratorMeta;
        return (0, $bvID6.createElement)(props.elTag, attrs, innerContent);
    }
    componentDidMount() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentDidUpdate() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentWillUnmount() {
        this.triggerCustomRendering(false); // TODO: different API for removal?
    }
    triggerCustomRendering(isActive) {
        var _a;
        const { props: props, context: context } = this;
        const { handleCustomRendering: handleCustomRendering, customRenderingMetaMap: customRenderingMetaMap } = context.options;
        if (handleCustomRendering) {
            const generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
            if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                id: this.id,
                isActive: isActive,
                containerEl: this.base,
                reportNewContainerEl: this.updateElRef,
                generatorMeta: generatorMeta
            }, props), {
                elClasses: (props.elClasses || []).filter($6ae642ef23cd8741$var$isTruthy)
            }));
        }
    }
    applyQueueudDomNodes() {
        const { queuedDomNodes: queuedDomNodes, currentDomNodes: currentDomNodes } = this;
        const el = this.base;
        if (!$6ae642ef23cd8741$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
            currentDomNodes.forEach($6ae642ef23cd8741$export$9f4f30ee63539e24);
            for (let newNode of queuedDomNodes)el.appendChild(newNode);
            this.currentDomNodes = queuedDomNodes;
        }
    }
}
$6ae642ef23cd8741$var$ContentInjector.addPropsEquality({
    elClasses: $6ae642ef23cd8741$export$23f2a1d2818174ef,
    elStyle: $6ae642ef23cd8741$export$a9c23c6ac3fc3eca,
    elAttrs: $6ae642ef23cd8741$var$isNonHandlerPropsEqual,
    renderProps: $6ae642ef23cd8741$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/ function $6ae642ef23cd8741$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $6ae642ef23cd8741$export$9ddbdd0bfc5623a(props, extraClassNames, elRef) {
    const attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(' ');
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $6ae642ef23cd8741$var$isTruthy(val) {
    return Boolean(val);
}
const $6ae642ef23cd8741$export$7910e0436ed8d1de = $6ae642ef23cd8741$export$c9170ad7d4cd7e57(0);
class $6ae642ef23cd8741$export$e7094788287c5e9b extends (0, $bvID6.Component) {
    constructor(){
        super(...arguments);
        this.InnerContent = $6ae642ef23cd8741$var$InnerContentInjector.bind(undefined, this);
        this.handleEl = (el)=>{
            this.el = el;
            if (this.props.elRef) {
                $6ae642ef23cd8741$export$71cec2538cb2c617(this.props.elRef, el);
                if (el && this.didMountMisfire) this.componentDidMount();
            }
        };
    }
    render() {
        const { props: props } = this;
        const generatedClassNames = $6ae642ef23cd8741$var$generateClassNames(props.classNameGenerator, props.renderProps);
        if (props.children) {
            const elAttrs = $6ae642ef23cd8741$export$9ddbdd0bfc5623a(props, generatedClassNames, this.handleEl);
            const children = props.children(this.InnerContent, props.renderProps, elAttrs);
            if (props.elTag) return (0, $bvID6.createElement)(props.elTag, elAttrs, children);
            else return children;
        } else return (0, $bvID6.createElement)($6ae642ef23cd8741$var$ContentInjector, Object.assign(Object.assign({}, props), {
            elRef: this.handleEl,
            elTag: props.elTag || 'div',
            elClasses: (props.elClasses || []).concat(generatedClassNames),
            renderId: this.context
        }));
    }
    componentDidMount() {
        var _a, _b;
        if (this.el) (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
        else this.didMountMisfire = true;
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
    }
}
$6ae642ef23cd8741$export$e7094788287c5e9b.contextType = $6ae642ef23cd8741$export$7910e0436ed8d1de;
function $6ae642ef23cd8741$var$InnerContentInjector(containerComponent, props) {
    const parentProps = containerComponent.props;
    return (0, $bvID6.createElement)($6ae642ef23cd8741$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $6ae642ef23cd8741$var$generateClassNames(classNameGenerator, renderProps) {
    const classNames = typeof classNameGenerator === 'function' ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === 'string' ? [
        classNames
    ] : classNames;
}
class $6ae642ef23cd8741$export$a3c9165b94390bcd extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = {
            view: context.viewApi
        };
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: [
                ...$6ae642ef23cd8741$export$8b22cf2602fb60ce(props.viewSpec),
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            classNameGenerator: options.viewClassNames,
            generatorName: undefined,
            didMount: options.viewDidMount,
            willUnmount: options.viewWillUnmount
        }, ()=>props.children);
    }
}
function $6ae642ef23cd8741$export$8b22cf2602fb60ce(viewSpec) {
    return [
        `fc-${viewSpec.type}-view`,
        'fc-view'
    ];
}
function $6ae642ef23cd8741$var$parseRange(input, dateEnv) {
    let start = null;
    let end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $6ae642ef23cd8741$var$invertRanges(ranges, constraintRange) {
    let invertedRanges = [];
    let { start: start } = constraintRange; // the end of the previous range. the start of the new range
    let i;
    let dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($6ae642ef23cd8741$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $6ae642ef23cd8741$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $6ae642ef23cd8741$export$ae1af26003f05816(range0, range1) {
    let { start: start, end: end } = range0;
    let newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $6ae642ef23cd8741$export$7a0bdf7d4a91ea88(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $6ae642ef23cd8741$export$c18d01048907ea92(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $6ae642ef23cd8741$export$f074adc9fbd50943(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $6ae642ef23cd8741$export$2329c99376c9d0a4(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $6ae642ef23cd8741$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $6ae642ef23cd8741$var$computeAlignedDayRange(timedRange) {
    let dayCnt = Math.floor($6ae642ef23cd8741$export$b4d5ecaefe2b27f3(timedRange.start, timedRange.end)) || 1;
    let start = $6ae642ef23cd8741$export$9e5f44173e64f162(timedRange.start);
    let end = $6ae642ef23cd8741$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $6ae642ef23cd8741$export$92108d983e8ee699(timedRange, nextDayThreshold = $6ae642ef23cd8741$export$4368d992c4eafac0(0)) {
    let startDay = null;
    let endDay = null;
    if (timedRange.end) {
        endDay = $6ae642ef23cd8741$export$9e5f44173e64f162(timedRange.end);
        let endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $6ae642ef23cd8741$export$4b170465d7badfa1(nextDayThreshold)) endDay = $6ae642ef23cd8741$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $6ae642ef23cd8741$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $6ae642ef23cd8741$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $6ae642ef23cd8741$export$9fa96a7d116ea3ce(range) {
    let visibleRange = $6ae642ef23cd8741$export$92108d983e8ee699(range);
    return $6ae642ef23cd8741$export$b4d5ecaefe2b27f3(visibleRange.start, visibleRange.end) > 1;
}
function $6ae642ef23cd8741$export$28f7fcd39efa255(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === 'year') return $6ae642ef23cd8741$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), 'year');
    if (largeUnit === 'month') return $6ae642ef23cd8741$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), 'month');
    return $6ae642ef23cd8741$export$62d08d6fa708df47(date0, date1); // returns a duration
}
class $6ae642ef23cd8741$export$db202ddc8be9136 {
    constructor(props){
        this.props = props;
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    buildPrev(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    }
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    buildNext(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    }
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    build(currentDate, direction, forceToValid = true) {
        let { props: props } = this;
        let validRange;
        let currentInfo;
        let isRangeAllDay;
        let renderRange;
        let activeRange;
        let isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) currentDate = $6ae642ef23cd8741$var$constrainMarkerToRange(currentDate, validRange);
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) activeRange = $6ae642ef23cd8741$export$ae1af26003f05816(activeRange, currentInfo.range);
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = $6ae642ef23cd8741$export$ae1af26003f05816(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = $6ae642ef23cd8741$export$c18d01048907ea92(currentInfo.range, validRange);
        // HACK: constrain to render-range so `currentDate` is more useful to view rendering
        if (!$6ae642ef23cd8741$export$2329c99376c9d0a4(renderRange, currentDate)) currentDate = renderRange.start;
        return {
            currentDate: currentDate,
            validRange: // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            activeRange: // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange,
            renderRange: // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
        };
    }
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    buildValidRange() {
        let input = this.props.validRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : input;
        return this.refineRange(simpleInput) || {
            start: null,
            end: null
        }; // completely open-ended
    }
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    buildCurrentRangeInfo(date, direction) {
        let { props: props } = this;
        let duration = null;
        let unit = null;
        let range = null;
        let dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        } else if (dayCount = this.props.dayCount) {
            unit = 'day';
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        else {
            duration = this.getFallbackDuration();
            unit = $6ae642ef23cd8741$export$db3b6bfb95261072(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return {
            duration: duration,
            unit: unit,
            range: range
        };
    }
    getFallbackDuration() {
        return $6ae642ef23cd8741$export$4368d992c4eafac0({
            day: 1
        });
    }
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    adjustActiveRange(range) {
        let { dateEnv: dateEnv, usesMinMaxTime: usesMinMaxTime, slotMinTime: slotMinTime, slotMaxTime: slotMaxTime } = this.props;
        let { start: start, end: end } = range;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if ($6ae642ef23cd8741$var$asRoughDays(slotMinTime) < 0) {
                start = $6ae642ef23cd8741$export$9e5f44173e64f162(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if ($6ae642ef23cd8741$var$asRoughDays(slotMaxTime) > 1) {
                end = $6ae642ef23cd8741$export$9e5f44173e64f162(end); // necessary?
                end = $6ae642ef23cd8741$export$625550452a3fa3ec(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return {
            start: start,
            end: end
        };
    }
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    buildRangeFromDuration(date, direction, duration, unit) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let start;
        let end;
        let res;
        // compute what the alignment should be
        if (!dateAlignment) {
            let { dateIncrement: dateIncrement } = this.props;
            if (dateIncrement) {
                // use the smaller of the two units
                if ($6ae642ef23cd8741$export$4b170465d7badfa1(dateIncrement) < $6ae642ef23cd8741$export$4b170465d7badfa1(duration)) dateAlignment = $6ae642ef23cd8741$export$db3b6bfb95261072(dateIncrement).unit;
                else dateAlignment = unit;
            } else dateAlignment = unit;
        }
        // if the view displays a single day or smaller
        if ($6ae642ef23cd8741$var$asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = $6ae642ef23cd8741$export$9e5f44173e64f162(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = {
                start: start,
                end: end
            };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    }
    // Builds the "current" range when a dayCount is specified.
    buildRangeFromDayCount(date, direction, dayCount) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let runningCount = 0;
        let start = date;
        let end;
        if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
        start = $6ae642ef23cd8741$export$9e5f44173e64f162(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = $6ae642ef23cd8741$export$625550452a3fa3ec(end, 1);
            if (!this.isHiddenDay(end)) runningCount += 1;
        }while (runningCount < dayCount);
        return {
            start: start,
            end: end
        };
    }
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    buildCustomVisibleRange(date) {
        let { props: props } = this;
        let input = props.visibleRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
        let range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) return null;
        return range;
    }
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    }
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    buildDateIncrement(fallback) {
        let { dateIncrement: dateIncrement } = this.props;
        let customAlignment;
        if (dateIncrement) return dateIncrement;
        if (customAlignment = this.props.dateAlignment) return $6ae642ef23cd8741$export$4368d992c4eafac0(1, customAlignment);
        if (fallback) return fallback;
        return $6ae642ef23cd8741$export$4368d992c4eafac0({
            days: 1
        });
    }
    refineRange(rangeInput) {
        if (rangeInput) {
            let range = $6ae642ef23cd8741$var$parseRange(rangeInput, this.props.dateEnv);
            if (range) range = $6ae642ef23cd8741$export$92108d983e8ee699(range);
            return range;
        }
        return null;
    }
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays() {
        let hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        let isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        let dayCnt = 0;
        let i;
        if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
        if (!dayCnt) throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        this.isHiddenDayHash = isHiddenDayHash;
    }
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    trimHiddenDays(range) {
        let { start: start, end: end } = range;
        if (start) start = this.skipHiddenDays(start);
        if (end) end = this.skipHiddenDays(end, -1, true);
        if (start == null || end == null || start < end) return {
            start: start,
            end: end
        };
        return null;
    }
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    isHiddenDay(day) {
        if (day instanceof Date) day = day.getUTCDay();
        return this.isHiddenDayHash[day];
    }
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays(date, inc = 1, isExclusive = false) {
        while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $6ae642ef23cd8741$export$625550452a3fa3ec(date, inc);
        return date;
    }
}
function $6ae642ef23cd8741$export$995eb9fca571757(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $6ae642ef23cd8741$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $6ae642ef23cd8741$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(let i = 0; i < recurringTypes.length; i += 1){
        let parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            let { allDay: allDay } = refined;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $6ae642ef23cd8741$var$expandRecurring(eventStore, framingRange, context) {
    let { dateEnv: dateEnv, pluginHooks: pluginHooks, options: options } = context;
    let { defs: defs, instances: instances } = eventStore;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $6ae642ef23cd8741$export$dda1d9f60106f0e9(instances, (instance)=>!defs[instance.defId].recurringDef);
    for(let defId in defs){
        let def = defs[defId];
        if (def.recurringDef) {
            let { duration: duration } = def.recurringDef;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            let starts = $6ae642ef23cd8741$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (let start of starts){
                let instance = $6ae642ef23cd8741$export$995eb9fca571757(defId, {
                    start: start,
                    end: dateEnv.add(start, duration)
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $6ae642ef23cd8741$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    let typeDef = recurringTypes[eventDef.recurringDef.typeId];
    let markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($6ae642ef23cd8741$export$9e5f44173e64f162);
    return markers;
}
const $6ae642ef23cd8741$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
const $6ae642ef23cd8741$var$EVENT_DATE_REFINERS = {
    start: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    end: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    date: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
const $6ae642ef23cd8741$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $6ae642ef23cd8741$var$EVENT_NON_DATE_REFINERS), $6ae642ef23cd8741$var$EVENT_DATE_REFINERS), {
    extendedProps: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5
});
function $6ae642ef23cd8741$var$parseEvent(raw, eventSource, context, allowOpenRange, refiners = $6ae642ef23cd8741$var$buildEventRefiners(context), defIdMap, instanceIdMap) {
    let { refined: refined, extra: extra } = $6ae642ef23cd8741$export$3b513254972cfc9c(raw, context, refiners);
    let defaultAllDay = $6ae642ef23cd8741$var$computeIsDefaultAllDay(eventSource, context);
    let recurringRes = $6ae642ef23cd8741$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        let def = $6ae642ef23cd8741$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    let singleRes = $6ae642ef23cd8741$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        let def = $6ae642ef23cd8741$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        let instance = $6ae642ef23cd8741$export$995eb9fca571757(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def.publicId && instanceIdMap[def.publicId]) instance.instanceId = instanceIdMap[def.publicId];
        return {
            def: def,
            instance: instance
        };
    }
    return null;
}
function $6ae642ef23cd8741$export$3b513254972cfc9c(raw, context, refiners = $6ae642ef23cd8741$var$buildEventRefiners(context)) {
    return $6ae642ef23cd8741$export$ee7c8ad385a60b7b(raw, refiners);
}
function $6ae642ef23cd8741$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $6ae642ef23cd8741$var$EVENT_UI_REFINERS), $6ae642ef23cd8741$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $6ae642ef23cd8741$export$f38c853ae54ed474(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    let def = {
        title: refined.title || '',
        groupId: refined.groupId || '',
        publicId: refined.id || '',
        url: refined.url || '',
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : '') || $6ae642ef23cd8741$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $6ae642ef23cd8741$export$25ce5a424b770e84(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    for (let memberAdder of context.pluginHooks.eventDefMemberAdders)Object.assign(def, memberAdder(refined));
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $6ae642ef23cd8741$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    let { allDay: allDay } = refined;
    let startMeta;
    let startMarker = null;
    let hasEnd = false;
    let endMeta;
    let endMarker = null;
    let startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $6ae642ef23cd8741$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $6ae642ef23cd8741$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $6ae642ef23cd8741$var$computeIsDefaultAllDay(eventSource, context) {
    let res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function $6ae642ef23cd8741$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    let eventStore = $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd();
    let eventRefiners = $6ae642ef23cd8741$var$buildEventRefiners(context);
    for (let rawEvent of rawEvents){
        let tuple = $6ae642ef23cd8741$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
        if (tuple) $6ae642ef23cd8741$export$317a3d46287192d8(tuple, eventStore);
    }
    return eventStore;
}
function $6ae642ef23cd8741$export$317a3d46287192d8(tuple, eventStore = $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd()) {
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $6ae642ef23cd8741$export$667d3bf0c5f83305(eventStore, instanceId) {
    let instance = eventStore.instances[instanceId];
    if (instance) {
        let def = eventStore.defs[instance.defId];
        // get events/instances with same group
        let newStore = $6ae642ef23cd8741$var$filterEventStoreDefs(eventStore, (lookDef)=>$6ae642ef23cd8741$var$isEventDefsGrouped(def, lookDef));
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd();
}
function $6ae642ef23cd8741$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd() {
    return {
        defs: {},
        instances: {}
    };
}
function $6ae642ef23cd8741$export$d377dcb2b61d6c4e(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $6ae642ef23cd8741$var$filterEventStoreDefs(eventStore, filterFunc) {
    let defs = $6ae642ef23cd8741$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    let instances = $6ae642ef23cd8741$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>defs[instance.defId] // still exists?
    );
    return {
        defs: defs,
        instances: instances
    };
}
function $6ae642ef23cd8741$var$excludeSubEventStore(master, sub) {
    let { defs: defs, instances: instances } = master;
    let filteredDefs = {};
    let filteredInstances = {};
    for(let defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(let instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $6ae642ef23cd8741$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $6ae642ef23cd8741$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === 'object' && input) return $6ae642ef23cd8741$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $6ae642ef23cd8741$export$f96d196f7728bb5(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
const $6ae642ef23cd8741$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    overlap: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    allow: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    className: $6ae642ef23cd8741$export$f96d196f7728bb5,
    classNames: $6ae642ef23cd8741$export$f96d196f7728bb5,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
const $6ae642ef23cd8741$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: '',
    borderColor: '',
    textColor: '',
    classNames: []
};
function $6ae642ef23cd8741$export$25ce5a424b770e84(refined, context) {
    let constraint = $6ae642ef23cd8741$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || '',
        borderColor: refined.borderColor || refined.color || '',
        textColor: refined.textColor || '',
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $6ae642ef23cd8741$export$1ee57be6f6687d2c(uis) {
    return uis.reduce($6ae642ef23cd8741$var$combineTwoEventUis, $6ae642ef23cd8741$var$EMPTY_EVENT_UI);
}
function $6ae642ef23cd8741$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
const $6ae642ef23cd8741$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    failure: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5
};
function $6ae642ef23cd8741$export$ffb5f4729a158638(raw, context, refiners = $6ae642ef23cd8741$export$35e795649ee09318(context)) {
    let rawObj;
    if (typeof raw === 'string') rawObj = {
        url: raw
    };
    else if (typeof raw === 'function' || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === 'object' && raw) rawObj = raw;
    if (rawObj) {
        let { refined: refined, extra: extra } = $6ae642ef23cd8741$export$ee7c8ad385a60b7b(rawObj, refiners);
        let metaRes = $6ae642ef23cd8741$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: '',
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || '',
            sourceId: $6ae642ef23cd8741$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $6ae642ef23cd8741$export$25ce5a424b770e84(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $6ae642ef23cd8741$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $6ae642ef23cd8741$var$EVENT_UI_REFINERS), $6ae642ef23cd8741$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $6ae642ef23cd8741$var$buildEventSourceMeta(raw, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    for(let i = defs.length - 1; i >= 0; i -= 1){
        let def = defs[i];
        let meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function $6ae642ef23cd8741$export$9bb611d729802a56(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case 'RECEIVE_EVENTS':
            return $6ae642ef23cd8741$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case 'RESET_RAW_EVENTS':
            return $6ae642ef23cd8741$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case 'ADD_EVENTS':
            return $6ae642ef23cd8741$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case 'RESET_EVENTS':
            return action.eventStore;
        case 'MERGE_EVENTS':
            return $6ae642ef23cd8741$export$d377dcb2b61d6c4e(eventStore, action.eventStore);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $6ae642ef23cd8741$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case 'REMOVE_EVENTS':
            return $6ae642ef23cd8741$var$excludeSubEventStore(eventStore, action.eventStore);
        case 'REMOVE_EVENT_SOURCE':
            return $6ae642ef23cd8741$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return $6ae642ef23cd8741$var$filterEventStoreDefs(eventStore, (eventDef)=>!eventDef.sourceId // only keep events with no source id
            );
        case 'REMOVE_ALL_EVENTS':
            return $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd();
        default:
            return eventStore;
    }
}
function $6ae642ef23cd8741$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        let subset = $6ae642ef23cd8741$var$parseEvents($6ae642ef23cd8741$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $6ae642ef23cd8741$var$expandRecurring(subset, fetchRange, context);
        return $6ae642ef23cd8741$export$d377dcb2b61d6c4e($6ae642ef23cd8741$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $6ae642ef23cd8741$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    const { defIdMap: defIdMap, instanceIdMap: instanceIdMap } = $6ae642ef23cd8741$var$buildPublicIdMaps(existingEventStore);
    let newEventStore = $6ae642ef23cd8741$var$parseEvents($6ae642ef23cd8741$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $6ae642ef23cd8741$var$expandRecurring(newEventStore, activeRange, context);
}
function $6ae642ef23cd8741$var$transformRawEvents(rawEvents, eventSource, context) {
    let calEachTransform = context.options.eventDataTransform;
    let sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $6ae642ef23cd8741$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $6ae642ef23cd8741$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $6ae642ef23cd8741$var$transformEachRawEvent(rawEvents, func) {
    let refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        for (let rawEvent of rawEvents){
            let refinedEvent = func(rawEvent);
            if (refinedEvent) refinedEvents.push(refinedEvent);
            else if (refinedEvent == null) refinedEvents.push(rawEvent);
             // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function $6ae642ef23cd8741$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $6ae642ef23cd8741$var$expandRecurring(subset, expandRange, context);
    return $6ae642ef23cd8741$export$d377dcb2b61d6c4e(eventStore, subset);
}
function $6ae642ef23cd8741$export$b4171a6734a65d42(eventStore, oldDateEnv, newDateEnv) {
    let { defs: defs } = eventStore;
    let instances = $6ae642ef23cd8741$export$407448d2b89b1813(eventStore.instances, (instance)=>{
        let def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $6ae642ef23cd8741$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $6ae642ef23cd8741$var$filterEventStoreDefs(eventStore, (eventDef)=>eventDef.sourceId !== sourceId);
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $6ae642ef23cd8741$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $6ae642ef23cd8741$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>!removals[instance.instanceId])
    };
}
function $6ae642ef23cd8741$var$buildPublicIdMaps(eventStore) {
    const { defs: defs, instances: instances } = eventStore;
    const defIdMap = {};
    const instanceIdMap = {};
    for(let defId in defs){
        const def = defs[defId];
        const { publicId: publicId } = def;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(let instanceId in instances){
        const instance = instances[instanceId];
        const def = defs[instance.defId];
        const { publicId: publicId } = def;
        if (publicId) instanceIdMap[publicId] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
class $6ae642ef23cd8741$export$d66501df72047452 {
    constructor(){
        this.handlers = {};
        this.thisContext = null;
    }
    setThisContext(thisContext) {
        this.thisContext = thisContext;
    }
    setOptions(options) {
        this.options = options;
    }
    on(type, handler) {
        $6ae642ef23cd8741$var$addToHash(this.handlers, type, handler);
    }
    off(type, handler) {
        $6ae642ef23cd8741$var$removeFromHash(this.handlers, type, handler);
    }
    trigger(type, ...args) {
        let attachedHandlers = this.handlers[type] || [];
        let optionHandler = this.options && this.options[type];
        let handlers = [].concat(optionHandler || [], attachedHandlers);
        for (let handler of handlers)handler.apply(this.thisContext, args);
    }
    hasHandlers(type) {
        return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    }
}
function $6ae642ef23cd8741$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $6ae642ef23cd8741$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter((func)=>func !== handler);
    } else delete hash[type]; // remove all handler funcs for this type
}
const $6ae642ef23cd8741$var$DEF_DEFAULTS = {
    startTime: '09:00',
    endTime: '17:00',
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: 'inverse-background',
    classNames: 'fc-non-business',
    groupId: '_businessHours'
};
/*
TODO: pass around as EventDefHash!!!
*/ function $6ae642ef23cd8741$export$3a6d5c9ae78a2c08(input, context) {
    return $6ae642ef23cd8741$var$parseEvents($6ae642ef23cd8741$var$refineInputs(input), null, context);
}
function $6ae642ef23cd8741$var$refineInputs(input) {
    let rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter((rawDef)=>rawDef.daysOfWeek);
    else if (typeof input === 'object' && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map((rawDef)=>Object.assign(Object.assign({}, $6ae642ef23cd8741$var$DEF_DEFAULTS), rawDef));
    return rawDefs;
}
function $6ae642ef23cd8741$export$cbfbec548517f2b6(selection, pev, context) {
    context.emitter.trigger('select', Object.assign(Object.assign({}, $6ae642ef23cd8741$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $6ae642ef23cd8741$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger('unselect', {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $6ae642ef23cd8741$var$buildDateSpanApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.dateSpanTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $6ae642ef23cd8741$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $6ae642ef23cd8741$export$bde1ed0f60b38f2f(allDay, marker, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let end = marker;
    if (allDay) {
        end = $6ae642ef23cd8741$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $6ae642ef23cd8741$export$dabba94403d45c8e(eventStore, eventConfigBase, mutation, context) {
    let eventConfigs = $6ae642ef23cd8741$var$compileEventUis(eventStore.defs, eventConfigBase);
    let dest = $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd();
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        dest.defs[defId] = $6ae642ef23cd8741$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $6ae642ef23cd8741$var$applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $6ae642ef23cd8741$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    let standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    let copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    for (let applier of context.pluginHooks.eventDefMutationAppliers)applier(copy, mutation, context);
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $6ae642ef23cd8741$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    let { dateEnv: dateEnv } = context;
    let forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    let clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    let copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $6ae642ef23cd8741$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $6ae642ef23cd8741$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $6ae642ef23cd8741$export$9e5f44173e64f162(copy.range.start),
        end: $6ae642ef23cd8741$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $6ae642ef23cd8741$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context);
    return copy;
}
class $6ae642ef23cd8741$var$EventSourceImpl {
    constructor(context, internalEventSource){
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    remove() {
        this.context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: this.internalEventSource.sourceId
        });
    }
    refetch() {
        this.context.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            sourceIds: [
                this.internalEventSource.sourceId
            ],
            isRefetch: true
        });
    }
    get id() {
        return this.internalEventSource.publicId;
    }
    get url() {
        return this.internalEventSource.meta.url;
    }
    get format() {
        return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
    }
}
class $6ae642ef23cd8741$export$71511d61b312f219 {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    constructor(context, def, instance){
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */ setProp(name, val) {
        if (name in $6ae642ef23cd8741$var$EVENT_DATE_REFINERS) console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
        else if (name === 'id') {
            val = $6ae642ef23cd8741$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    publicId: val
                }
            });
        } else if (name in $6ae642ef23cd8741$var$EVENT_NON_DATE_REFINERS) {
            val = $6ae642ef23cd8741$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    [name]: val
                }
            });
        } else if (name in $6ae642ef23cd8741$var$EVENT_UI_REFINERS) {
            let ui = $6ae642ef23cd8741$var$EVENT_UI_REFINERS[name](val);
            if (name === 'color') ui = {
                backgroundColor: val,
                borderColor: val
            };
            else if (name === 'editable') ui = {
                startEditable: val,
                durationEditable: val
            };
            else ui = {
                [name]: val
            };
            this.mutate({
                standardProps: {
                    ui: ui
                }
            });
        } else console.warn(`Could not set prop '${name}'. Use setExtendedProp instead.`);
    }
    setExtendedProp(name, val) {
        this.mutate({
            extendedProps: {
                [name]: val
            }
        });
    }
    setStart(startInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let start = dateEnv.createMarker(startInput);
        if (start && this._instance) {
            let instanceRange = this._instance.range;
            let startDelta = $6ae642ef23cd8741$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) this.mutate({
                datesDelta: startDelta
            });
            else this.mutate({
                startDelta: startDelta
            });
        }
    }
    setEnd(endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return; // TODO: warning if parsed bad
        }
        if (this._instance) {
            if (end) {
                let endDelta = $6ae642ef23cd8741$export$28f7fcd39efa255(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({
                    endDelta: endDelta
                });
            } else this.mutate({
                standardProps: {
                    hasEnd: false
                }
            });
        }
    }
    setDates(startInput, endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let standardProps = {
            allDay: options.allDay
        };
        let start = dateEnv.createMarker(startInput);
        let end;
        if (!start) return; // TODO: warning if parsed bad
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return;
        }
        if (this._instance) {
            let instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) instanceRange = $6ae642ef23cd8741$var$computeAlignedDayRange(instanceRange);
            let startDelta = $6ae642ef23cd8741$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                let endDelta = $6ae642ef23cd8741$export$28f7fcd39efa255(instanceRange.end, end, dateEnv, options.granularity);
                if ($6ae642ef23cd8741$var$durationsEqual(startDelta, endDelta)) this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
                else this.mutate({
                    startDelta: startDelta,
                    endDelta: endDelta,
                    standardProps: standardProps
                });
            } else {
                standardProps.hasEnd = false;
                this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
            }
        }
    }
    moveStart(deltaInput) {
        let delta = $6ae642ef23cd8741$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            startDelta: delta
        });
    }
    moveEnd(deltaInput) {
        let delta = $6ae642ef23cd8741$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            endDelta: delta
        });
    }
    moveDates(deltaInput) {
        let delta = $6ae642ef23cd8741$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            datesDelta: delta
        });
    }
    setAllDay(allDay, options = {}) {
        let standardProps = {
            allDay: allDay
        };
        let { maintainDuration: maintainDuration } = options;
        if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
        if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
        this.mutate({
            standardProps: standardProps
        });
    }
    formatRange(formatInput) {
        let { dateEnv: dateEnv } = this._context;
        let instance = this._instance;
        let formatter = $6ae642ef23cd8741$export$d141bba7fdc215a3(formatInput);
        if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
            forcedStartTzo: instance.forcedStartTzo,
            forcedEndTzo: instance.forcedEndTzo
        });
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo
        });
    }
    mutate(mutation) {
        let instance = this._instance;
        if (instance) {
            let def = this._def;
            let context = this._context;
            let { eventStore: eventStore } = context.getCurrentData();
            let relevantEvents = $6ae642ef23cd8741$export$667d3bf0c5f83305(eventStore, instance.instanceId);
            let eventConfigBase = {
                '': {
                    display: '',
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: '',
                    borderColor: '',
                    textColor: '',
                    classNames: []
                }
            };
            relevantEvents = $6ae642ef23cd8741$export$dabba94403d45c8e(relevantEvents, eventConfigBase, mutation, context);
            let oldEvent = new $6ae642ef23cd8741$export$71511d61b312f219(context, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context.dispatch({
                type: 'MERGE_EVENTS',
                eventStore: relevantEvents
            });
            context.emitter.trigger('eventChange', {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: $6ae642ef23cd8741$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                revert () {
                    context.dispatch({
                        type: 'RESET_EVENTS',
                        eventStore: eventStore
                    });
                }
            });
        }
    }
    remove() {
        let context = this._context;
        let asStore = $6ae642ef23cd8741$var$eventApiToStore(this);
        context.dispatch({
            type: 'REMOVE_EVENTS',
            eventStore: asStore
        });
        context.emitter.trigger('eventRemove', {
            event: this,
            relatedEvents: [],
            revert () {
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: asStore
                });
            }
        });
    }
    get source() {
        let { sourceId: sourceId } = this._def;
        if (sourceId) return new $6ae642ef23cd8741$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
        return null;
    }
    get start() {
        return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
    }
    get end() {
        return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
    }
    get startStr() {
        let instance = this._instance;
        if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedStartTzo
        });
        return '';
    }
    get endStr() {
        let instance = this._instance;
        if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedEndTzo
        });
        return '';
    }
    // computable props that all access the def
    // TODO: find a TypeScript-compatible way to do this at scale
    get id() {
        return this._def.publicId;
    }
    get groupId() {
        return this._def.groupId;
    }
    get allDay() {
        return this._def.allDay;
    }
    get title() {
        return this._def.title;
    }
    get url() {
        return this._def.url;
    }
    get display() {
        return this._def.ui.display || 'auto';
    }
    get startEditable() {
        return this._def.ui.startEditable;
    }
    get durationEditable() {
        return this._def.ui.durationEditable;
    }
    get constraint() {
        return this._def.ui.constraints[0] || null;
    }
    get overlap() {
        return this._def.ui.overlap;
    }
    get allow() {
        return this._def.ui.allows[0] || null;
    }
    get backgroundColor() {
        return this._def.ui.backgroundColor;
    }
    get borderColor() {
        return this._def.ui.borderColor;
    }
    get textColor() {
        return this._def.ui.textColor;
    }
    // NOTE: user can't modify these because Object.freeze was called in event-def parsing
    get classNames() {
        return this._def.ui.classNames;
    }
    get extendedProps() {
        return this._def.extendedProps;
    }
    toPlainObject(settings = {}) {
        let def = this._def;
        let { ui: ui } = def;
        let { startStr: startStr, endStr: endStr } = this;
        let res = {
            allDay: def.allDay
        };
        if (def.title) res.title = def.title;
        if (startStr) res.start = startStr;
        if (endStr) res.end = endStr;
        if (def.publicId) res.id = def.publicId;
        if (def.groupId) res.groupId = def.groupId;
        if (def.url) res.url = def.url;
        if (ui.display && ui.display !== 'auto') res.display = ui.display;
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
        else {
            if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
            if (ui.borderColor) res.borderColor = ui.borderColor;
        }
        if (ui.textColor) res.textColor = ui.textColor;
        if (ui.classNames.length) res.classNames = ui.classNames;
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
            else res.extendedProps = def.extendedProps;
        }
        return res;
    }
    toJSON() {
        return this.toPlainObject();
    }
}
function $6ae642ef23cd8741$var$eventApiToStore(eventApi) {
    let def = eventApi._def;
    let instance = eventApi._instance;
    return {
        defs: {
            [def.defId]: def
        },
        instances: instance ? {
            [instance.instanceId]: instance
        } : {}
    };
}
function $6ae642ef23cd8741$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    let { defs: defs, instances: instances } = eventStore;
    let eventApis = [];
    let excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
    for(let id in instances){
        let instance = instances[id];
        let def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $6ae642ef23cd8741$export$71511d61b312f219(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $6ae642ef23cd8741$export$4c3d22f3d993c33f(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    let inverseBgByGroupId = {};
    let inverseBgByDefId = {};
    let defByGroupId = {};
    let bgRanges = [];
    let fgRanges = [];
    let eventUis = $6ae642ef23cd8741$var$compileEventUis(eventStore.defs, eventUiBases);
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        let ui = eventUis[def.defId];
        if (ui.display === 'inverse-background') {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = eventStore.defs[instance.defId];
        let ui = eventUis[def.defId];
        let origRange = instance.range;
        let normalRange = !def.allDay && nextDayThreshold ? $6ae642ef23cd8741$export$92108d983e8ee699(origRange, nextDayThreshold) : origRange;
        let slicedRange = $6ae642ef23cd8741$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === 'inverse-background') {
                if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui.display !== 'none') (ui.display === 'background' ? bgRanges : fgRanges).push({
                def: def,
                ui: ui,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(let groupId in inverseBgByGroupId){
        let ranges = inverseBgByGroupId[groupId];
        let invertedRanges = $6ae642ef23cd8741$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges){
            let def = defByGroupId[groupId];
            let ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    for(let defId in inverseBgByDefId){
        let ranges = inverseBgByDefId[defId];
        let invertedRanges = $6ae642ef23cd8741$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges)bgRanges.push({
            def: eventStore.defs[defId],
            ui: eventUis[defId],
            instance: null,
            range: invertedRange,
            isStart: false,
            isEnd: false
        });
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $6ae642ef23cd8741$export$45aabb5431c2d04f(def) {
    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}
function $6ae642ef23cd8741$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $6ae642ef23cd8741$export$8743009a87fcb00f(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $6ae642ef23cd8741$var$compileEventUis(eventDefs, eventUiBases) {
    return $6ae642ef23cd8741$export$407448d2b89b1813(eventDefs, (eventDef)=>$6ae642ef23cd8741$var$compileEventUi(eventDef, eventUiBases));
}
function $6ae642ef23cd8741$var$compileEventUi(eventDef, eventUiBases) {
    let uis = [];
    if (eventUiBases['']) uis.push(eventUiBases['']);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $6ae642ef23cd8741$export$1ee57be6f6687d2c(uis);
}
function $6ae642ef23cd8741$export$a91cd623adc48128(segs, eventOrderSpecs) {
    let objs = segs.map($6ae642ef23cd8741$var$buildSegCompareObj);
    objs.sort((obj0, obj1)=>$6ae642ef23cd8741$export$306ddfe3a8403e2(obj0, obj1, eventOrderSpecs));
    return objs.map((c)=>c._seg);
}
// returns a object with all primitive props that can be compared
function $6ae642ef23cd8741$var$buildSegCompareObj(seg) {
    let { eventRange: eventRange } = seg;
    let eventDef = eventRange.def;
    let range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    let start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    let end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $6ae642ef23cd8741$var$computeSegDraggable(seg, context) {
    let { pluginHooks: pluginHooks } = context;
    let transformers = pluginHooks.isDraggableTransformers;
    let { def: def, ui: ui } = seg.eventRange;
    let val = ui.startEditable;
    for (let transformer of transformers)val = transformer(val, def, ui, context);
    return val;
}
function $6ae642ef23cd8741$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $6ae642ef23cd8741$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $6ae642ef23cd8741$export$2538633961795d6b(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    let { dateEnv: dateEnv, options: options } = context;
    let { displayEventTime: displayEventTime, displayEventEnd: displayEventEnd } = options;
    let eventDef = seg.eventRange.def;
    let eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    let wholeEventStart = eventInstance.range.start;
    let wholeEventEnd = eventInstance.range.end;
    let segStart = startOverride || seg.start || seg.eventRange.range.start;
    let segEnd = endOverride || seg.end || seg.eventRange.range.end;
    let isStartDay = $6ae642ef23cd8741$export$9e5f44173e64f162(wholeEventStart).valueOf() === $6ae642ef23cd8741$export$9e5f44173e64f162(segStart).valueOf();
    let isEndDay = $6ae642ef23cd8741$export$9e5f44173e64f162($6ae642ef23cd8741$export$51b138e5a065c2bb(wholeEventEnd, -1)).valueOf() === $6ae642ef23cd8741$export$9e5f44173e64f162($6ae642ef23cd8741$export$51b138e5a065c2bb(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return '';
}
function $6ae642ef23cd8741$export$993a080e5cb62d74(seg, todayRange, nowDate) {
    let segRange = seg.eventRange.range;
    return {
        isPast: segRange.end <= (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $6ae642ef23cd8741$export$2329c99376c9d0a4(todayRange, segRange.start)
    };
}
function $6ae642ef23cd8741$var$getEventClassNames(props) {
    let classNames = [
        'fc-event'
    ];
    if (props.isMirror) classNames.push('fc-event-mirror');
    if (props.isDraggable) classNames.push('fc-event-draggable');
    if (props.isStartResizable || props.isEndResizable) classNames.push('fc-event-resizable');
    if (props.isDragging) classNames.push('fc-event-dragging');
    if (props.isResizing) classNames.push('fc-event-resizing');
    if (props.isSelected) classNames.push('fc-event-selected');
    if (props.isStart) classNames.push('fc-event-start');
    if (props.isEnd) classNames.push('fc-event-end');
    if (props.isPast) classNames.push('fc-event-past');
    if (props.isToday) classNames.push('fc-event-today');
    if (props.isFuture) classNames.push('fc-event-future');
    return classNames;
}
function $6ae642ef23cd8741$export$4d522598b426bb73(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : `${eventRange.def.defId}:${eventRange.range.start.toISOString()}`;
// inverse-background events don't have specific instances. TODO: better solution
}
function $6ae642ef23cd8741$export$6dabbe08653f866f(seg, context) {
    let { def: def, instance: instance } = seg.eventRange;
    let { url: url } = def;
    if (url) return {
        href: url
    };
    let { emitter: emitter, options: options } = context;
    let { eventInteractive: eventInteractive } = options;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $6ae642ef23cd8741$var$createAriaKeyboardAttrs((ev)=>{
        emitter.trigger('eventClick', {
            el: ev.target,
            event: new $6ae642ef23cd8741$export$71511d61b312f219(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
const $6ae642ef23cd8741$var$STANDARD_PROPS = {
    start: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    end: $6ae642ef23cd8741$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $6ae642ef23cd8741$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    let span = $6ae642ef23cd8741$var$parseOpenDateSpan(raw, dateEnv);
    let { range: range } = span;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $6ae642ef23cd8741$var$parseOpenDateSpan(raw, dateEnv) {
    let { refined: standardProps, extra: extra } = $6ae642ef23cd8741$export$ee7c8ad385a60b7b(raw, $6ae642ef23cd8741$var$STANDARD_PROPS);
    let startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    let endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    let { allDay: allDay } = standardProps;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $6ae642ef23cd8741$export$7f557e5eb95176c2(span0, span1) {
    return $6ae642ef23cd8741$export$7a0bdf7d4a91ea88(span0.range, span1.range) && span0.allDay === span1.allDay && $6ae642ef23cd8741$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $6ae642ef23cd8741$var$isSpanPropsEqual(span0, span1) {
    for(let propName in span1)if (propName !== 'range' && propName !== 'allDay') {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(let propName in span0){
        if (!(propName in span1)) return false;
    }
    return true;
}
function $6ae642ef23cd8741$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $6ae642ef23cd8741$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $6ae642ef23cd8741$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $6ae642ef23cd8741$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $6ae642ef23cd8741$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $6ae642ef23cd8741$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    let res = $6ae642ef23cd8741$export$3b513254972cfc9c({
        editable: false
    }, context);
    let def = $6ae642ef23cd8741$export$f38c853ae54ed474(res.refined, res.extra, '', dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $6ae642ef23cd8741$var$compileEventUi(def, eventUiBases),
        instance: $6ae642ef23cd8741$export$995eb9fca571757(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $6ae642ef23cd8741$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    let isResolved = false;
    let wrappedSuccess = function(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    let wrappedFailure = function(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    let res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') res.then(wrappedSuccess, wrappedFailure);
}
class $6ae642ef23cd8741$export$f787f51d84a910ad extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
function $6ae642ef23cd8741$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    const fetchOptions = {
        method: method
    };
    if (method === 'GET') url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    return fetch(url, fetchOptions).then((fetchRes)=>{
        if (fetchRes.ok) return fetchRes.json().then((parsedResponse)=>{
            return [
                parsedResponse,
                fetchRes
            ];
        }, ()=>{
            throw new $6ae642ef23cd8741$export$f787f51d84a910ad('Failure parsing JSON', fetchRes);
        });
        else throw new $6ae642ef23cd8741$export$f787f51d84a910ad('Request failed', fetchRes);
    });
}
let $6ae642ef23cd8741$var$canVGrowWithinCell;
function $6ae642ef23cd8741$export$738ab4df8bf92ae9() {
    if ($6ae642ef23cd8741$var$canVGrowWithinCell == null) $6ae642ef23cd8741$var$canVGrowWithinCell = $6ae642ef23cd8741$var$computeCanVGrowWithinCell();
    return $6ae642ef23cd8741$var$canVGrowWithinCell;
}
function $6ae642ef23cd8741$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === 'undefined') return true;
    let el = document.createElement('div');
    el.style.position = 'absolute';
    el.style.top = '0px';
    el.style.left = '0px';
    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
    el.querySelector('table').style.height = '100px';
    el.querySelector('div').style.height = '100%';
    document.body.appendChild(el);
    let div = el.querySelector('div');
    let possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
class $6ae642ef23cd8741$export$a9c996f45e5784d0 extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            forPrint: false
        };
        this.handleBeforePrint = ()=>{
            $6ae642ef23cd8741$export$c3950d9923825c02(()=>{
                this.setState({
                    forPrint: true
                });
            });
        };
        this.handleAfterPrint = ()=>{
            $6ae642ef23cd8741$export$c3950d9923825c02(()=>{
                this.setState({
                    forPrint: false
                });
            });
        };
    }
    render() {
        let { props: props } = this;
        let { options: options } = props;
        let { forPrint: forPrint } = this.state;
        let isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
        let height = !isHeightAuto && options.height != null ? options.height : '';
        let classNames = [
            'fc',
            forPrint ? 'fc-media-print' : 'fc-media-screen',
            `fc-direction-${options.direction}`,
            props.theme.getClass('root')
        ];
        if (!$6ae642ef23cd8741$export$738ab4df8bf92ae9()) classNames.push('fc-liquid-hack');
        return props.children(classNames, height, isHeightAuto, forPrint);
    }
    componentDidMount() {
        let { emitter: emitter } = this.props;
        emitter.on('_beforeprint', this.handleBeforePrint);
        emitter.on('_afterprint', this.handleAfterPrint);
    }
    componentWillUnmount() {
        let { emitter: emitter } = this.props;
        emitter.off('_beforeprint', this.handleBeforePrint);
        emitter.off('_afterprint', this.handleAfterPrint);
    }
}
class $6ae642ef23cd8741$export$78acf4525d8a74c4 {
    constructor(settings){
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    destroy() {}
}
function $6ae642ef23cd8741$export$efca4cbe5dd06740(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $6ae642ef23cd8741$export$381353cf1dd55255(settings) {
    return {
        [settings.component.uid]: settings
    };
}
// global state
const $6ae642ef23cd8741$export$a8550f7dbe79f93a = {};
class $6ae642ef23cd8741$export$2e2af4578d910ddf extends (0, $bvID6.Component) {
    constructor(props, context){
        super(props, context);
        this.handleRefresh = ()=>{
            let timing = this.computeTiming();
            if (timing.state.nowDate.valueOf() !== this.state.nowDate.valueOf()) this.setState(timing.state);
            this.clearTimeout();
            this.setTimeout(timing.waitMs);
        };
        this.handleVisibilityChange = ()=>{
            if (!document.hidden) this.handleRefresh();
        };
        this.state = this.computeTiming().state;
    }
    render() {
        let { props: props, state: state } = this;
        return props.children(state.nowDate, state.todayRange);
    }
    componentDidMount() {
        this.setTimeout();
        this.context.nowManager.addResetListener(this.handleRefresh);
        // fired tab becomes visible after being hidden
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    }
    componentWillUnmount() {
        this.clearTimeout();
        this.context.nowManager.removeResetListener(this.handleRefresh);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    computeTiming() {
        let { props: props, context: context } = this;
        let unroundedNow = context.nowManager.getDateMarker();
        let { nowIndicatorSnap: nowIndicatorSnap } = context.options;
        if (nowIndicatorSnap === 'auto') nowIndicatorSnap = // large unit?
        /year|month|week|day/.test(props.unit) || // if slotDuration 30 mins for example, would NOT appear to snap (legacy behavior)
        (props.unitValue || 1) === 1;
        let nowDate;
        let waitMs;
        if (nowIndicatorSnap) {
            nowDate = context.dateEnv.startOf(unroundedNow, props.unit); // aka currentUnitStart
            let nextUnitStart = context.dateEnv.add(nowDate, $6ae642ef23cd8741$export$4368d992c4eafac0(1, props.unit));
            waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        } else {
            nowDate = unroundedNow;
            waitMs = 60000; // 1 minute
        }
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(86400000, waitMs);
        return {
            state: {
                nowDate: nowDate,
                todayRange: $6ae642ef23cd8741$var$buildDayRange(nowDate)
            },
            waitMs: waitMs
        };
    }
    setTimeout(waitMs = this.computeTiming().waitMs) {
        // NOTE: timeout could take longer than expected if tab sleeps,
        // which is why we listen to 'visibilitychange'
        this.timeoutId = setTimeout(()=>{
            // NOTE: timeout could also return *earlier* than expected, and we need to wait 2 ms more
            // This is why use use same waitMs from computeTiming, so we don't skip an interval while
            // .setState() is executing
            const timing = this.computeTiming();
            this.setState(timing.state, ()=>{
                this.setTimeout(timing.waitMs);
            });
        }, waitMs);
    }
    clearTimeout() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
}
$6ae642ef23cd8741$export$2e2af4578d910ddf.contextType = $6ae642ef23cd8741$export$e7c866399fa523f5;
function $6ae642ef23cd8741$var$buildDayRange(date) {
    let start = $6ae642ef23cd8741$export$9e5f44173e64f162(date);
    let end = $6ae642ef23cd8741$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
class $6ae642ef23cd8741$export$a93c5207d687da10 {
    getCurrentData() {
        return this.currentDataManager.getCurrentData();
    }
    dispatch(action) {
        this.currentDataManager.dispatch(action);
    }
    get view() {
        return this.getCurrentData().viewApi;
    }
    batchRendering(callback) {
        callback();
    }
    updateSize() {
        this.trigger('_resize', true);
    }
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    setOption(name, val) {
        this.dispatch({
            type: 'SET_OPTION',
            optionName: name,
            rawOptionValue: val
        });
    }
    getOption(name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    }
    getAvailableLocaleCodes() {
        return Object.keys(this.getCurrentData().availableRawLocales);
    }
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    on(handlerName, handler) {
        let { currentDataManager: currentDataManager } = this;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
        else console.warn(`Unknown listener name '${handlerName}'`);
    }
    off(handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    }
    // not meant for public use
    trigger(handlerName, ...args) {
        this.currentDataManager.emitter.trigger(handlerName, ...args);
    }
    // View
    // -----------------------------------------------------------------------------------------------------------------
    changeView(viewType, dateOrRange) {
        this.batchRendering(()=>{
            this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) {
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType
                    });
                    this.dispatch({
                        type: 'SET_OPTION',
                        optionName: 'visibleRange',
                        rawOptionValue: dateOrRange
                    });
                } else {
                    let { dateEnv: dateEnv } = this.getCurrentData();
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange)
                    });
                }
            } else this.dispatch({
                type: 'CHANGE_VIEW_TYPE',
                viewType: viewType
            });
        });
    }
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    zoomTo(dateMarker, viewType) {
        let state = this.getCurrentData();
        let spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) this.dispatch({
            type: 'CHANGE_VIEW_TYPE',
            viewType: spec.type,
            dateMarker: dateMarker
        });
        else this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: dateMarker
        });
    }
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec(unit) {
        let { viewSpecs: viewSpecs, toolbarConfig: toolbarConfig } = this.getCurrentData();
        let viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        let i;
        let spec;
        for(let viewType in viewSpecs)viewTypes.push(viewType);
        for(i = 0; i < viewTypes.length; i += 1){
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) return spec;
            }
        }
        return null;
    }
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    prev() {
        this.unselect();
        this.dispatch({
            type: 'PREV'
        });
    }
    next() {
        this.unselect();
        this.dispatch({
            type: 'NEXT'
        });
    }
    prevYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, -1)
        });
    }
    nextYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, 1)
        });
    }
    today() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.nowManager.getDateMarker()
        });
    }
    gotoDate(zonedDateInput) {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.createMarker(zonedDateInput)
        });
    }
    incrementDate(deltaInput) {
        let state = this.getCurrentData();
        let delta = $6ae642ef23cd8741$export$4368d992c4eafac0(deltaInput);
        if (delta) {
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.add(state.currentDate, delta)
            });
        }
    }
    getDate() {
        let state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    }
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    formatDate(d, formatter) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.format(dateEnv.createMarker(d), $6ae642ef23cd8741$export$d141bba7fdc215a3(formatter));
    }
    // `settings` is for formatter AND isEndExclusive
    formatRange(d0, d1, settings) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $6ae642ef23cd8741$export$d141bba7fdc215a3(settings), settings);
    }
    formatIso(d, omitTime) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatIso(dateEnv.createMarker(d), {
            omitTime: omitTime
        });
    }
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    select(dateOrObj, endDate) {
        let selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) selectionInput = dateOrObj;
            else selectionInput = {
                start: dateOrObj,
                end: null
            };
        } else selectionInput = {
            start: dateOrObj,
            end: endDate
        };
        let state = this.getCurrentData();
        let selection = $6ae642ef23cd8741$var$parseDateSpan(selectionInput, state.dateEnv, $6ae642ef23cd8741$export$4368d992c4eafac0({
            days: 1
        }));
        if (selection) {
            this.dispatch({
                type: 'SELECT_DATES',
                selection: selection
            });
            $6ae642ef23cd8741$export$cbfbec548517f2b6(selection, null, state);
        }
    }
    unselect(pev) {
        let state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({
                type: 'UNSELECT_DATES'
            });
            $6ae642ef23cd8741$var$triggerDateUnselect(pev, state);
        }
    }
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    addEvent(eventInput, sourceInput) {
        if (eventInput instanceof $6ae642ef23cd8741$export$71511d61b312f219) {
            let def = eventInput._def;
            let instance = eventInput._instance;
            let currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: 'ADD_EVENTS',
                    eventStore: $6ae642ef23cd8741$export$317a3d46287192d8({
                        def: def,
                        instance: instance
                    })
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        let state = this.getCurrentData();
        let eventSource;
        if (sourceInput instanceof $6ae642ef23cd8741$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
        else if (typeof sourceInput === 'boolean') {
            if (sourceInput) [eventSource] = $6ae642ef23cd8741$export$90a7f3efeed30595(state.eventSources);
        } else if (sourceInput != null) {
            let sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn(`Could not find an event source with ID "${sourceInput}"`); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        let tuple = $6ae642ef23cd8741$var$parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            let newEventApi = new $6ae642ef23cd8741$export$71511d61b312f219(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: 'ADD_EVENTS',
                eventStore: $6ae642ef23cd8741$export$317a3d46287192d8(tuple)
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    }
    triggerEventAdd(eventApi) {
        let { emitter: emitter } = this.getCurrentData();
        emitter.trigger('eventAdd', {
            event: eventApi,
            relatedEvents: [],
            revert: ()=>{
                this.dispatch({
                    type: 'REMOVE_EVENTS',
                    eventStore: $6ae642ef23cd8741$var$eventApiToStore(eventApi)
                });
            }
        });
    }
    // TODO: optimize
    getEventById(id) {
        let state = this.getCurrentData();
        let { defs: defs, instances: instances } = state.eventStore;
        id = String(id);
        for(let defId in defs){
            let def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) return new $6ae642ef23cd8741$export$71511d61b312f219(state, def, null);
                for(let instanceId in instances){
                    let instance = instances[instanceId];
                    if (instance.defId === def.defId) return new $6ae642ef23cd8741$export$71511d61b312f219(state, def, instance);
                }
            }
        }
        return null;
    }
    getEvents() {
        let currentData = this.getCurrentData();
        return $6ae642ef23cd8741$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
    }
    removeAllEvents() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENTS'
        });
    }
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    getEventSources() {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        let sourceApis = [];
        for(let internalId in sourceHash)sourceApis.push(new $6ae642ef23cd8741$var$EventSourceImpl(state, sourceHash[internalId]));
        return sourceApis;
    }
    getEventSourceById(id) {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        id = String(id);
        for(let sourceId in sourceHash){
            if (sourceHash[sourceId].publicId === id) return new $6ae642ef23cd8741$var$EventSourceImpl(state, sourceHash[sourceId]);
        }
        return null;
    }
    addEventSource(sourceInput) {
        let state = this.getCurrentData();
        if (sourceInput instanceof $6ae642ef23cd8741$var$EventSourceImpl) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    sourceInput.internalEventSource
                ]
            });
            return sourceInput;
        }
        let eventSource = $6ae642ef23cd8741$export$ffb5f4729a158638(sourceInput, state);
        if (eventSource) {
            this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    eventSource
                ]
            });
            return new $6ae642ef23cd8741$var$EventSourceImpl(state, eventSource);
        }
        return null;
    }
    removeAllEventSources() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENT_SOURCES'
        });
    }
    refetchEvents() {
        this.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            isRefetch: true
        });
    }
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    scrollToTime(timeInput) {
        let time = $6ae642ef23cd8741$export$4368d992c4eafac0(timeInput);
        if (time) this.trigger('_scrollRequest', {
            time: time
        });
    }
}
function $6ae642ef23cd8741$export$24baa2b76016ce0e(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $6ae642ef23cd8741$export$890c4ad488842ce7(rect1, rect2) {
    let res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $6ae642ef23cd8741$export$a33b77bbdbb8366c(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $6ae642ef23cd8741$export$158acd800e1ef08b(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $6ae642ef23cd8741$export$cf2f7c5792f80b46(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $6ae642ef23cd8741$export$53a70dd1ebbae346(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
const $6ae642ef23cd8741$var$EMPTY_EVENT_STORE = $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd(); // for purecomponents. TODO: keep elsewhere
class $6ae642ef23cd8741$export$9d0e2d13d04f7070 {
    constructor(){
        this.getKeysForEventDefs = $6ae642ef23cd8741$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $6ae642ef23cd8741$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $6ae642ef23cd8741$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $6ae642ef23cd8741$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $6ae642ef23cd8741$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $6ae642ef23cd8741$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    splitProps(props) {
        let keyInfos = this.getKeyInfo(props);
        let defKeys = this.getKeysForEventDefs(props.eventStore);
        let dateSelections = this.splitDateSelection(props.dateSelection);
        let individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        let eventStores = this.splitEventStore(props.eventStore, defKeys);
        let eventDrags = this.splitEventDrag(props.eventDrag);
        let eventResizes = this.splitEventResize(props.eventResize);
        let splitProps = {};
        this.eventUiBuilders = $6ae642ef23cd8741$export$407448d2b89b1813(keyInfos, (info, key)=>this.eventUiBuilders[key] || $6ae642ef23cd8741$export$df995fae86a55f06($6ae642ef23cd8741$var$buildEventUiForKey));
        for(let key in keyInfos){
            let keyInfo = keyInfos[key];
            let eventStore = eventStores[key] || $6ae642ef23cd8741$var$EMPTY_EVENT_STORE;
            let buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null
            };
        }
        return splitProps;
    }
    _splitDateSpan(dateSpan) {
        let dateSpans = {};
        if (dateSpan) {
            let keys = this.getKeysForDateSpan(dateSpan);
            for (let key of keys)dateSpans[key] = dateSpan;
        }
        return dateSpans;
    }
    _getKeysForEventDefs(eventStore) {
        return $6ae642ef23cd8741$export$407448d2b89b1813(eventStore.defs, (eventDef)=>this.getKeysForEventDef(eventDef));
    }
    _splitEventStore(eventStore, defKeys) {
        let { defs: defs, instances: instances } = eventStore;
        let splitStores = {};
        for(let defId in defs)for (let key of defKeys[defId]){
            if (!splitStores[key]) splitStores[key] = $6ae642ef23cd8741$export$7f8ddf7c7c20b3cd();
            splitStores[key].defs[defId] = defs[defId];
        }
        for(let instanceId in instances){
            let instance = instances[instanceId];
            for (let key of defKeys[instance.defId])if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
        }
        return splitStores;
    }
    _splitIndividualUi(eventUiBases, defKeys) {
        let splitHashes = {};
        for(let defId in eventUiBases){
            if (defId) for (let key of defKeys[defId]){
                if (!splitHashes[key]) splitHashes[key] = {};
                splitHashes[key][defId] = eventUiBases[defId];
            }
        }
        return splitHashes;
    }
    _splitInteraction(interaction) {
        let splitStates = {};
        if (interaction) {
            let affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            let mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            let mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            let populate = (key)=>{
                if (!splitStates[key]) splitStates[key] = {
                    affectedEvents: affectedStores[key] || $6ae642ef23cd8741$var$EMPTY_EVENT_STORE,
                    mutatedEvents: mutatedStores[key] || $6ae642ef23cd8741$var$EMPTY_EVENT_STORE,
                    isEvent: interaction.isEvent
                };
            };
            for(let key in affectedStores)populate(key);
            for(let key in mutatedStores)populate(key);
        }
        return splitStates;
    }
}
function $6ae642ef23cd8741$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    let baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    let stuff = {
        '': $6ae642ef23cd8741$export$1ee57be6f6687d2c(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $6ae642ef23cd8741$export$e171bab687b50e0(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && (!dateProfile.activeRange || !$6ae642ef23cd8741$export$2329c99376c9d0a4(dateProfile.activeRange, date))),
        isOther: Boolean(dateProfile && !$6ae642ef23cd8741$export$2329c99376c9d0a4(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $6ae642ef23cd8741$export$2329c99376c9d0a4(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $6ae642ef23cd8741$export$1a8f5705751d8277(meta, theme) {
    let classNames = [
        'fc-day',
        `fc-day-${$6ae642ef23cd8741$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-day-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-day-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-day-past');
        if (meta.isFuture) classNames.push('fc-day-future');
        if (meta.isOther) classNames.push('fc-day-other');
    }
    return classNames;
}
function $6ae642ef23cd8741$export$527e9aa3390079e9(meta, theme) {
    let classNames = [
        'fc-slot',
        `fc-slot-${$6ae642ef23cd8741$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-slot-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-slot-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-slot-past');
        if (meta.isFuture) classNames.push('fc-slot-future');
    }
    return classNames;
}
const $6ae642ef23cd8741$var$DAY_FORMAT = $6ae642ef23cd8741$export$d141bba7fdc215a3({
    year: 'numeric',
    month: 'long',
    day: 'numeric'
});
const $6ae642ef23cd8741$var$WEEK_FORMAT = $6ae642ef23cd8741$export$d141bba7fdc215a3({
    week: 'long'
});
function $6ae642ef23cd8741$export$a17c37559e1db147(context, dateMarker, viewType = 'day', isTabbable = true) {
    const { dateEnv: dateEnv, options: options, calendarApi: calendarApi } = context;
    let dateStr = dateEnv.format(dateMarker, viewType === 'week' ? $6ae642ef23cd8741$var$WEEK_FORMAT : $6ae642ef23cd8741$var$DAY_FORMAT);
    if (options.navLinks) {
        let zonedDate = dateEnv.toDate(dateMarker);
        const handleInteraction = (ev)=>{
            let customAction = viewType === 'day' ? options.navLinkDayClick : viewType === 'week' ? options.navLinkWeekClick : null;
            if (typeof customAction === 'function') customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === 'string') viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $6ae642ef23cd8741$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            'data-navlink': ''
        }, isTabbable ? $6ae642ef23cd8741$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        'aria-label': dateStr
    };
}
let $6ae642ef23cd8741$var$_isRtlScrollbarOnLeft = null;
function $6ae642ef23cd8741$export$c7ca7e4bc4f8a16e() {
    if ($6ae642ef23cd8741$var$_isRtlScrollbarOnLeft === null) $6ae642ef23cd8741$var$_isRtlScrollbarOnLeft = $6ae642ef23cd8741$var$computeIsRtlScrollbarOnLeft();
    return $6ae642ef23cd8741$var$_isRtlScrollbarOnLeft;
}
function $6ae642ef23cd8741$var$computeIsRtlScrollbarOnLeft() {
    let outerEl = document.createElement('div');
    $6ae642ef23cd8741$export$faec65b429be379(outerEl, {
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl'
    });
    outerEl.innerHTML = '<div></div>';
    document.body.appendChild(outerEl);
    let innerEl = outerEl.firstChild;
    let res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $6ae642ef23cd8741$export$9f4f30ee63539e24(outerEl);
    return res;
}
let $6ae642ef23cd8741$var$_scrollbarWidths;
function $6ae642ef23cd8741$export$a1edd97dd51cd48d() {
    if (!$6ae642ef23cd8741$var$_scrollbarWidths) $6ae642ef23cd8741$var$_scrollbarWidths = $6ae642ef23cd8741$var$computeScrollbarWidths();
    return $6ae642ef23cd8741$var$_scrollbarWidths;
}
function $6ae642ef23cd8741$var$computeScrollbarWidths() {
    let el = document.createElement('div');
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    let res = $6ae642ef23cd8741$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $6ae642ef23cd8741$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $6ae642ef23cd8741$export$2ec5befb9e6c97d4(el, getPadding = false) {
    let computedStyle = window.getComputedStyle(el);
    let borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    let borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    let borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    let borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    let badScrollbarWidths = $6ae642ef23cd8741$var$computeScrollbarWidthsForEl(el); // includes border!
    let scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    let scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    let res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($6ae642ef23cd8741$export$c7ca7e4bc4f8a16e() && computedStyle.direction === 'rtl') res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $6ae642ef23cd8741$export$d29e374196577086(el, goWithinPadding = false, doFromWindowViewport) {
    let outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $6ae642ef23cd8741$export$39c1cc7c062529d4(el);
    let edges = $6ae642ef23cd8741$export$2ec5befb9e6c97d4(el, goWithinPadding);
    let res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $6ae642ef23cd8741$export$39c1cc7c062529d4(el) {
    let rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY
    };
}
function $6ae642ef23cd8741$var$computeClippedClientRect(el) {
    let clippingParents = $6ae642ef23cd8741$export$53c86fa97d611818(el);
    let rect = el.getBoundingClientRect();
    for (let clippingParent of clippingParents){
        let intersection = $6ae642ef23cd8741$export$890c4ad488842ce7(rect, clippingParent.getBoundingClientRect());
        if (intersection) rect = intersection;
        else return null;
    }
    return rect;
}
// does not return window
function $6ae642ef23cd8741$export$53c86fa97d611818(el) {
    let parents = [];
    while(el instanceof HTMLElement){
        let computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ class $6ae642ef23cd8741$export$ad4aebacdcaf47f8 {
    constructor(originEl, els, isHorizontal, isVertical){
        this.els = els;
        let originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    // Populates the left/right internal coordinate arrays
    buildElHorizontals(originClientLeft) {
        let lefts = [];
        let rights = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    }
    // Populates the top/bottom internal coordinate arrays
    buildElVerticals(originClientTop) {
        let tops = [];
        let bottoms = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    }
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    leftToIndex(leftPosition) {
        let { lefts: lefts, rights: rights } = this;
        let len = lefts.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    topToIndex(topPosition) {
        let { tops: tops, bottoms: bottoms } = this;
        let len = tops.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Gets the width of the element at the given index
    getWidth(leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    }
    // Gets the height of the element at the given index
    getHeight(topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    }
    similarTo(otherCache) {
        return $6ae642ef23cd8741$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $6ae642ef23cd8741$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $6ae642ef23cd8741$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $6ae642ef23cd8741$var$similarNumArrays(this.rights || [], otherCache.rights || []);
    }
}
function $6ae642ef23cd8741$var$similarNumArrays(a, b) {
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ class $6ae642ef23cd8741$export$4ae495d48253603d {
    getMaxScrollTop() {
        return this.getScrollHeight() - this.getClientHeight();
    }
    getMaxScrollLeft() {
        return this.getScrollWidth() - this.getClientWidth();
    }
    canScrollVertically() {
        return this.getMaxScrollTop() > 0;
    }
    canScrollHorizontally() {
        return this.getMaxScrollLeft() > 0;
    }
    canScrollUp() {
        return this.getScrollTop() > 0;
    }
    canScrollDown() {
        return this.getScrollTop() < this.getMaxScrollTop();
    }
    canScrollLeft() {
        return this.getScrollLeft() > 0;
    }
    canScrollRight() {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    }
}
class $6ae642ef23cd8741$export$7060da4b5db56fb9 extends $6ae642ef23cd8741$export$4ae495d48253603d {
    constructor(el){
        super();
        this.el = el;
    }
    getScrollTop() {
        return this.el.scrollTop;
    }
    getScrollLeft() {
        return this.el.scrollLeft;
    }
    setScrollTop(top) {
        this.el.scrollTop = top;
    }
    setScrollLeft(left) {
        this.el.scrollLeft = left;
    }
    getScrollWidth() {
        return this.el.scrollWidth;
    }
    getScrollHeight() {
        return this.el.scrollHeight;
    }
    getClientHeight() {
        return this.el.clientHeight;
    }
    getClientWidth() {
        return this.el.clientWidth;
    }
}
class $6ae642ef23cd8741$export$c5d1328b37d47994 extends $6ae642ef23cd8741$export$4ae495d48253603d {
    getScrollTop() {
        return window.scrollY;
    }
    getScrollLeft() {
        return window.scrollX;
    }
    setScrollTop(n) {
        window.scroll(window.scrollX, n);
    }
    setScrollLeft(n) {
        window.scroll(n, window.scrollY);
    }
    getScrollWidth() {
        return document.documentElement.scrollWidth;
    }
    getScrollHeight() {
        return document.documentElement.scrollHeight;
    }
    getClientHeight() {
        return document.documentElement.clientHeight;
    }
    getClientWidth() {
        return document.documentElement.clientWidth;
    }
}
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ class $6ae642ef23cd8741$export$d22783b3c2400a3a extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.uid = $6ae642ef23cd8741$export$39b482c5e57630a8();
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    prepareHits() {}
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    }
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    isValidSegDownEl(el) {
        return !this.props.eventDrag && // HACK
        !this.props.eventResize && // HACK
        !$6ae642ef23cd8741$export$dc98b0b04f4c7758(el, '.fc-event-mirror');
    }
    isValidDateDownEl(el) {
        return !$6ae642ef23cd8741$export$dc98b0b04f4c7758(el, '.fc-event:not(.fc-bg-event)') && !$6ae642ef23cd8741$export$dc98b0b04f4c7758(el, '.fc-more-link') && // a "more.." link
        !$6ae642ef23cd8741$export$dc98b0b04f4c7758(el, 'a[data-navlink]') && // a clickable nav link
        !$6ae642ef23cd8741$export$dc98b0b04f4c7758(el, '.fc-popover'); // hack
    }
}
class $6ae642ef23cd8741$export$45d219bdcd8ac53c {
    constructor(timeZoneName){
        this.timeZoneName = timeZoneName;
    }
}
class $6ae642ef23cd8741$export$766bf7dcfb630b6c {
    constructor(getEntryThickness = (entry)=>{
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return entry.thickness || 1;
    }){
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    addSegs(inputs) {
        let hiddenEntries = [];
        for (let input of inputs)this.insertEntry(input, hiddenEntries);
        return hiddenEntries;
    }
    insertEntry(entry, hiddenEntries) {
        let insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) this.insertEntryAt(entry, insertion);
        else this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
    isInsertionValid(insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) {
            const hiddenEntry = Object.assign(Object.assign({}, entry), {
                span: $6ae642ef23cd8741$export$b0165a7e514844(entry.span, insertion.touchingEntry.span)
            });
            hiddenEntries.push(hiddenEntry);
            this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        } else hiddenEntries.push(entry);
    }
    /*
    Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
    */ splitEntry(entry, barrier, hiddenEntries) {
        let entrySpan = entry.span;
        let barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: entrySpan.start,
                end: barrierSpan.start
            }
        }, hiddenEntries);
        if (entrySpan.end > barrierSpan.end) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: barrierSpan.end,
                end: entrySpan.end
            }
        }, hiddenEntries);
    }
    insertEntryAt(entry, insertion) {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        if (insertion.lateral === -1) {
            // create a new level
            $6ae642ef23cd8741$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
            $6ae642ef23cd8741$var$insertAt(entriesByLevel, insertion.level, [
                entry
            ]);
        } else // insert into existing level
        $6ae642ef23cd8741$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        this.stackCnts[$6ae642ef23cd8741$export$674f8f4247a5112e(entry)] = insertion.stackCnt;
    }
    /*
    does not care about limits
    */ findInsertion(newEntry) {
        let { levelCoords: levelCoords, entriesByLevel: entriesByLevel, strictOrder: strictOrder, stackCnts: stackCnts } = this;
        let levelCnt = levelCoords.length;
        let candidateCoord = 0;
        let touchingLevel = -1;
        let touchingLateral = -1;
        let touchingEntry = null;
        let stackCnt = 0;
        for(let trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
            const trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
            let trackingEntries = entriesByLevel[trackingLevel];
            let trackingEntry;
            let searchRes = $6ae642ef23cd8741$export$eb84e45a33f6ba7c(trackingEntries, newEntry.span.start, $6ae642ef23cd8741$export$2e63b696b2c9441b); // find first entry after newEntry's end
            let lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
            trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ){
                let trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                stackCnt = Math.max(stackCnt, stackCnts[$6ae642ef23cd8741$export$674f8f4247a5112e(trackingEntry)] + 1);
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        let destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
        }
        // if adding to an existing level, find where to insert
        let destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $6ae642ef23cd8741$export$eb84e45a33f6ba7c(entriesByLevel[destLevel], newEntry.span.end, $6ae642ef23cd8741$export$2e63b696b2c9441b)[0];
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral
        };
    }
    // sorted by levelCoord (lowest to highest)
    toRects() {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        let levelCnt = entriesByLevel.length;
        let rects = [];
        for(let level = 0; level < levelCnt; level += 1){
            let entries = entriesByLevel[level];
            let levelCoord = levelCoords[level];
            for (let entry of entries)rects.push(Object.assign(Object.assign({}, entry), {
                thickness: this.getEntryThickness(entry),
                levelCoord: levelCoord
            }));
        }
        return rects;
    }
}
function $6ae642ef23cd8741$export$2e63b696b2c9441b(entry) {
    return entry.span.end;
}
function $6ae642ef23cd8741$export$674f8f4247a5112e(entry) {
    return entry.index + ':' + entry.span.start;
}
// returns groups with entries sorted by input order
function $6ae642ef23cd8741$export$d76842aa27385215(entries) {
    let merges = [];
    for (let entry of entries){
        let filteredMerges = [];
        let hungryMerge = {
            span: entry.span,
            entries: [
                entry
            ]
        };
        for (let merge of merges)if ($6ae642ef23cd8741$export$b0165a7e514844(merge.span, hungryMerge.span)) hungryMerge = {
            entries: merge.entries.concat(hungryMerge.entries),
            span: $6ae642ef23cd8741$var$joinSpans(merge.span, hungryMerge.span)
        };
        else filteredMerges.push(merge);
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function $6ae642ef23cd8741$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $6ae642ef23cd8741$export$b0165a7e514844(span0, span1) {
    let start = Math.max(span0.start, span1.start);
    let end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $6ae642ef23cd8741$export$eb84e45a33f6ba7c(a, searchVal, getItemVal) {
    let startIndex = 0;
    let endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        let middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        let middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ class $6ae642ef23cd8741$export$b2bcef12bcefba04 {
    constructor(el, selector){
        this.emitter = new $6ae642ef23cd8741$export$d66501df72047452();
    }
    destroy() {}
    setMirrorIsVisible(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setMirrorNeedsRevert(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setAutoScrollEnabled(bool) {
    // optional
    }
}
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
const $6ae642ef23cd8741$export$aff10ba49ece4b91 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ const $6ae642ef23cd8741$var$DRAG_META_REFINERS = {
    startTime: $6ae642ef23cd8741$export$4368d992c4eafac0,
    duration: $6ae642ef23cd8741$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $6ae642ef23cd8741$export$60bb826a6acf3081(raw) {
    let { refined: refined, extra: extra } = $6ae642ef23cd8741$export$ee7c8ad385a60b7b(raw, $6ae642ef23cd8741$var$DRAG_META_REFINERS);
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $6ae642ef23cd8741$export$1abb261478089fe6(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $6ae642ef23cd8741$export$d141bba7fdc215a3({
        weekday: 'short'
    }); // "Sat"
    if (dayCnt > 1) return $6ae642ef23cd8741$export$d141bba7fdc215a3({
        weekday: 'short',
        month: 'numeric',
        day: 'numeric',
        omitCommas: true
    }); // "Sat 11/12"
    return $6ae642ef23cd8741$export$d141bba7fdc215a3({
        weekday: 'long'
    }); // "Saturday"
}
const $6ae642ef23cd8741$var$CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
function $6ae642ef23cd8741$var$renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
class $6ae642ef23cd8741$export$ebc5e65867841cbe extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    render() {
        let { dateEnv: dateEnv, options: options, theme: theme, viewApi: viewApi } = this.context;
        let { props: props } = this;
        let { date: date, dateProfile: dateProfile } = props;
        let dayMeta = $6ae642ef23cd8741$export$e171bab687b50e0(date, props.todayRange, null, dateProfile);
        let classNames = [
            $6ae642ef23cd8741$var$CLASS_NAME
        ].concat($6ae642ef23cd8741$export$1a8f5705751d8277(dayMeta, theme));
        let text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        let navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $6ae642ef23cd8741$export$a17c37559e1db147(this.context, date) : {};
        let publicDate = dateEnv.toDate(date);
        // workaround for Luxon (and maybe moment) returning prior-days when start-of-day
        // in DST gap: https://github.com/fullcalendar/fullcalendar/issues/7633
        if (dateEnv.namedTimeZoneImpl) publicDate = $6ae642ef23cd8741$export$51b138e5a065c2bb(publicDate, 3600000); // add an hour
        let renderProps = Object.assign(Object.assign(Object.assign({
            date: publicDate,
            view: viewApi
        }, props.extraRenderProps), {
            text: text
        }), dayMeta);
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: classNames,
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan,
                'data-date': !dayMeta.isDisabled ? $6ae642ef23cd8741$export$56350196709588fc(date) : undefined
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $6ae642ef23cd8741$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContainer)=>(0, $bvID6.createElement)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, !dayMeta.isDisabled && (0, $bvID6.createElement)(InnerContainer, {
                elTag: "a",
                elAttrs: navLinkAttrs,
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ]
            })));
    }
}
const $6ae642ef23cd8741$var$WEEKDAY_FORMAT = $6ae642ef23cd8741$export$d141bba7fdc215a3({
    weekday: 'long'
});
class $6ae642ef23cd8741$export$1ddf2d01943a3512 extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { dateEnv: dateEnv, theme: theme, viewApi: viewApi, options: options } = this.context;
        let date = $6ae642ef23cd8741$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        let dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false
        };
        let text = dateEnv.format(date, props.dayHeaderFormat);
        let renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
            date: date
        }, dateMeta), {
            view: viewApi
        }), props.extraRenderProps), {
            text: text
        });
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: [
                $6ae642ef23cd8741$var$CLASS_NAME,
                ...$6ae642ef23cd8741$export$1a8f5705751d8277(dateMeta, theme),
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $6ae642ef23cd8741$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $bvID6.createElement)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, (0, $bvID6.createElement)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ],
                elAttrs: {
                    'aria-label': dateEnv.format(date, $6ae642ef23cd8741$var$WEEKDAY_FORMAT)
                }
            })));
    }
}
class $6ae642ef23cd8741$export$27d1aff6bea49709 extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.createDayHeaderFormatter = $6ae642ef23cd8741$export$df995fae86a55f06($6ae642ef23cd8741$var$createDayHeaderFormatter);
    }
    render() {
        let { context: context } = this;
        let { dates: dates, dateProfile: dateProfile, datesRepDistinctDays: datesRepDistinctDays, renderIntro: renderIntro } = this.props;
        let dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$2e2af4578d910ddf, {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $bvID6.createElement)("tr", {
                role: "row"
            }, renderIntro && renderIntro('day'), dates.map((date)=>datesRepDistinctDays ? (0, $bvID6.createElement)($6ae642ef23cd8741$export$ebc5e65867841cbe, {
                    key: date.toISOString(),
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: todayRange,
                    colCnt: dates.length,
                    dayHeaderFormat: dayHeaderFormat
                }) : (0, $bvID6.createElement)($6ae642ef23cd8741$export$1ddf2d01943a3512, {
                    key: date.getUTCDay(),
                    dow: date.getUTCDay(),
                    dayHeaderFormat: dayHeaderFormat
                }))));
    }
}
function $6ae642ef23cd8741$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $6ae642ef23cd8741$export$1abb261478089fe6(datesRepDistinctDays, dateCnt);
}
class $6ae642ef23cd8741$export$ebb8f7cd71856fb9 {
    constructor(range, dateProfileGenerator){
        let date = range.start;
        let { end: end } = range;
        let indices = [];
        let dates = [];
        let dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $6ae642ef23cd8741$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    sliceRange(range) {
        let firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        let lastIndex = this.getDateDayIndex($6ae642ef23cd8741$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
        let clippedFirstIndex = Math.max(0, firstIndex);
        let clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) return {
            firstIndex: clippedFirstIndex,
            lastIndex: clippedLastIndex,
            isStart: firstIndex === clippedFirstIndex,
            isEnd: lastIndex === clippedLastIndex
        };
        return null;
    }
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex(date) {
        let { indices: indices } = this;
        let dayOffset = Math.floor($6ae642ef23cd8741$export$b4d5ecaefe2b27f3(this.dates[0], date));
        if (dayOffset < 0) return indices[0] - 1;
        if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
        return indices[dayOffset];
    }
}
class $6ae642ef23cd8741$export$1314441b8d04e1d5 {
    constructor(daySeries, breakOnWeeks){
        let { dates: dates } = daySeries;
        let daysPerRow;
        let firstDay;
        let rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    buildCells() {
        let rows = [];
        for(let row = 0; row < this.rowCnt; row += 1){
            let cells = [];
            for(let col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
            rows.push(cells);
        }
        return rows;
    }
    buildCell(row, col) {
        let date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date
        };
    }
    buildHeaderDates() {
        let dates = [];
        for(let col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
        return dates;
    }
    sliceRange(range) {
        let { colCnt: colCnt } = this;
        let seriesSeg = this.daySeries.sliceRange(range);
        let segs = [];
        if (seriesSeg) {
            let { firstIndex: firstIndex, lastIndex: lastIndex } = seriesSeg;
            let index = firstIndex;
            while(index <= lastIndex){
                let row = Math.floor(index / colCnt);
                let nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                });
                index = nextIndex;
            }
        }
        return segs;
    }
}
class $6ae642ef23cd8741$export$e0c3a065614c6254 {
    constructor(){
        this.sliceBusinessHours = $6ae642ef23cd8741$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $6ae642ef23cd8741$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $6ae642ef23cd8741$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $6ae642ef23cd8741$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $6ae642ef23cd8741$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    sliceProps(props, dateProfile, nextDayThreshold, context, ...extraArgs) {
        let { eventUiBases: eventUiBases } = props;
        let eventSegs = this.sliceEventStore(props.eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs);
        return {
            dateSelectionSegs: this.sliceDateSelection(props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs),
            businessHourSegs: this.sliceBusinessHours(props.businessHours, dateProfile, nextDayThreshold, context, ...extraArgs),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag(props.eventDrag, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventResize: this.sliceEventResize(props.eventResize, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventSelection: props.eventSelection
        }; // TODO: give interactionSegs?
    }
    sliceNowDate(date, dateProfile, nextDayThreshold, context, ...extraArgs) {
        return this._sliceDateSpan({
            range: {
                start: date,
                end: $6ae642ef23cd8741$export$51b138e5a065c2bb(date, 1)
            },
            allDay: false
        }, dateProfile, nextDayThreshold, {}, context, ...extraArgs);
    }
    _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context, ...extraArgs) {
        if (!businessHours) return [];
        return this._sliceEventStore($6ae642ef23cd8741$var$expandRecurring(businessHours, $6ae642ef23cd8741$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold, ...extraArgs).bg;
    }
    _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (eventStore) {
            let rangeRes = $6ae642ef23cd8741$export$4c3d22f3d993c33f(eventStore, eventUiBases, $6ae642ef23cd8741$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
            };
        }
        return {
            bg: [],
            fg: []
        };
    }
    _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (!interaction) return null;
        let rangeRes = $6ae642ef23cd8741$export$4c3d22f3d993c33f(interaction.mutatedEvents, eventUiBases, $6ae642ef23cd8741$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent
        };
    }
    _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs) {
        if (!dateSpan) return [];
        let activeRange = $6ae642ef23cd8741$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
        let activeDateSpanRange = $6ae642ef23cd8741$export$ae1af26003f05816(dateSpan.range, activeRange);
        if (activeDateSpanRange) {
            dateSpan = Object.assign(Object.assign({}, dateSpan), {
                range: activeDateSpanRange
            });
            let eventRange = $6ae642ef23cd8741$var$fabricateEventRange(dateSpan, eventUiBases, context);
            let segs = this.sliceRange(dateSpan.range, ...extraArgs);
            for (let seg of segs)seg.eventRange = eventRange;
            return segs;
        }
        return [];
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRanges(eventRanges, extraArgs) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.sliceEventRange(eventRange, extraArgs));
        return segs;
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRange(eventRange, extraArgs) {
        let dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') dateRange = {
            start: dateRange.start,
            end: $6ae642ef23cd8741$export$625550452a3fa3ec(dateRange.start, 1)
        };
        let segs = this.sliceRange(dateRange, ...extraArgs);
        for (let seg of segs){
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    }
}
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $6ae642ef23cd8741$var$computeActiveRange(dateProfile, isComponentAllDay) {
    let range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $6ae642ef23cd8741$export$51b138e5a065c2bb(range.start, dateProfile.slotMinTime.milliseconds),
        end: $6ae642ef23cd8741$export$51b138e5a065c2bb(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$export$6d1e945284085e64(interaction, dateProfile, context) {
    let { instances: instances } = interaction.mutatedEvents;
    for(let instanceId in instances){
        if (!$6ae642ef23cd8741$export$f074adc9fbd50943(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $6ae642ef23cd8741$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $6ae642ef23cd8741$export$545a72cc0d3f00b0(dateSelection, dateProfile, context) {
    if (!$6ae642ef23cd8741$export$f074adc9fbd50943(dateProfile.validRange, dateSelection.range)) return false;
    return $6ae642ef23cd8741$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $6ae642ef23cd8741$var$isNewPropsValid(newProps, context) {
    let calendarState = context.getCurrentData();
    let props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: '',
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: '',
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $6ae642ef23cd8741$export$6b179bb11f7fd3a0)(props, context);
}
function $6ae642ef23cd8741$export$6b179bb11f7fd3a0(state, context, dateSpanMeta = {}, filterConfig) {
    if (state.eventDrag && !$6ae642ef23cd8741$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$6ae642ef23cd8741$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let currentState = context.getCurrentData();
    let interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    let subjectEventStore = interaction.mutatedEvents;
    let subjectDefs = subjectEventStore.defs;
    let subjectInstances = subjectEventStore.instances;
    let subjectConfigs = $6ae642ef23cd8741$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        '': currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $6ae642ef23cd8741$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    let otherEventStore = $6ae642ef23cd8741$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    let otherDefs = otherEventStore.defs;
    let otherInstances = otherEventStore.instances;
    let otherConfigs = $6ae642ef23cd8741$var$compileEventUis(otherDefs, state.eventUiBases);
    for(let subjectInstanceId in subjectInstances){
        let subjectInstance = subjectInstances[subjectInstanceId];
        let subjectRange = subjectInstance.range;
        let subjectConfig = subjectConfigs[subjectInstance.defId];
        let subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$6ae642ef23cd8741$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        let { eventOverlap: eventOverlap } = context.options;
        let eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
        for(let otherInstanceId in otherInstances){
            let otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($6ae642ef23cd8741$export$c18d01048907ea92(subjectRange, otherInstance.range)) {
                let otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $6ae642ef23cd8741$export$71511d61b312f219(context, otherDefs[otherInstance.defId], otherInstance), new $6ae642ef23cd8741$export$71511d61b312f219(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        let calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (let subjectAllow of subjectConfig.allows){
            let subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                range: subjectInstance.range,
                allDay: subjectDef.allDay
            });
            let origDef = calendarEventStore.defs[subjectDef.defId];
            let origInstance = calendarEventStore.instances[subjectInstanceId];
            let eventApi;
            if (origDef) eventApi = new $6ae642ef23cd8741$export$71511d61b312f219(context, origDef, origInstance);
            else eventApi = new $6ae642ef23cd8741$export$71511d61b312f219(context, subjectDef); // no instance, because had no dates
            if (!subjectAllow($6ae642ef23cd8741$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let relevantEventStore = state.eventStore;
    let relevantDefs = relevantEventStore.defs;
    let relevantInstances = relevantEventStore.instances;
    let selection = state.dateSelection;
    let selectionRange = selection.range;
    let { selectionConfig: selectionConfig } = context.getCurrentData();
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$6ae642ef23cd8741$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    let { selectOverlap: selectOverlap } = context.options;
    let selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
    for(let relevantInstanceId in relevantInstances){
        let relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($6ae642ef23cd8741$export$c18d01048907ea92(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $6ae642ef23cd8741$export$71511d61b312f219(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    // allow (a function)
    for (let selectionAllow of selectionConfig.allows){
        let fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
        if (!selectionAllow($6ae642ef23cd8741$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $6ae642ef23cd8741$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (let constraint of constraints){
        if (!$6ae642ef23cd8741$var$anyRangesContainRange($6ae642ef23cd8741$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
    }
    return true;
}
function $6ae642ef23cd8741$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === 'businessHours') return $6ae642ef23cd8741$var$eventStoreToRanges($6ae642ef23cd8741$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === 'string') return $6ae642ef23cd8741$var$eventStoreToRanges($6ae642ef23cd8741$var$filterEventStoreDefs(otherEventStore, (eventDef)=>eventDef.groupId === constraint));
    if (typeof constraint === 'object' && constraint) return $6ae642ef23cd8741$var$eventStoreToRanges($6ae642ef23cd8741$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $6ae642ef23cd8741$var$eventStoreToRanges(eventStore) {
    let { instances: instances } = eventStore;
    let ranges = [];
    for(let instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $6ae642ef23cd8741$var$anyRangesContainRange(outerRanges, innerRange) {
    for (let outerRange of outerRanges){
        if ($6ae642ef23cd8741$export$f074adc9fbd50943(outerRange, innerRange)) return true;
    }
    return false;
}
const $6ae642ef23cd8741$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
class $6ae642ef23cd8741$export$54c4fabc2291e9c0 extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            $6ae642ef23cd8741$export$71cec2538cb2c617(this.props.elRef, el);
        };
    }
    render() {
        let { props: props } = this;
        let { liquid: liquid, liquidIsAbsolute: liquidIsAbsolute } = props;
        let isAbsolute = liquid && liquidIsAbsolute;
        let className = [
            'fc-scroller'
        ];
        if (liquid) {
            if (liquidIsAbsolute) className.push('fc-scroller-liquid-absolute');
            else className.push('fc-scroller-liquid');
        }
        return (0, $bvID6.createElement)("div", {
            ref: this.handleEl,
            className: className.join(' '),
            style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: isAbsolute && -(props.overcomeLeft || 0) || '',
                right: isAbsolute && -(props.overcomeRight || 0) || '',
                bottom: isAbsolute && -(props.overcomeBottom || 0) || '',
                marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || '',
                marginRight: !isAbsolute && -(props.overcomeRight || 0) || '',
                marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || '',
                maxHeight: props.maxHeight || ''
            }
        }, props.children);
    }
    needsXScrolling() {
        if ($6ae642ef23cd8741$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) return true;
        }
        return false;
    }
    needsYScrolling() {
        if ($6ae642ef23cd8741$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) return true;
        }
        return false;
    }
    getXScrollbarWidth() {
        if ($6ae642ef23cd8741$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
    getYScrollbarWidth() {
        if ($6ae642ef23cd8741$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
}
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ class $6ae642ef23cd8741$export$807f1ba34db587c7 {
    constructor(masterCallback){
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = (val, key)=>{
            let { depths: depths, currentMap: currentMap } = this;
            let removed = false;
            let added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete this.callbackMap[key];
                    removed = true;
                }
            }
            if (this.masterCallback) {
                if (removed) this.masterCallback(null, String(key));
                if (added) this.masterCallback(val, String(key));
            }
        };
    }
    createRef(key) {
        let refCallback = this.callbackMap[key];
        if (!refCallback) refCallback = this.callbackMap[key] = (val)=>{
            this.handleValue(val, String(key));
        };
        return refCallback;
    }
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    collect(startIndex, endIndex, step) {
        return $6ae642ef23cd8741$export$a05254e7c3aeba6e(this.currentMap, startIndex, endIndex, step);
    }
    getAll() {
        return $6ae642ef23cd8741$export$90a7f3efeed30595(this.currentMap);
    }
}
function $6ae642ef23cd8741$export$7fe88b5920ffddd2(chunkEls) {
    let shrinkCells = $6ae642ef23cd8741$export$23ebac1979863676(chunkEls, '.fc-scrollgrid-shrink');
    let largestWidth = 0;
    for (let shrinkCell of shrinkCells)largestWidth = Math.max(largestWidth, $6ae642ef23cd8741$var$computeSmallestCellWidth(shrinkCell));
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $6ae642ef23cd8741$export$60e660859c376841(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $6ae642ef23cd8741$export$df838d0240c938cf(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $6ae642ef23cd8741$export$60e660859c376841(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $6ae642ef23cd8741$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, arg, isHeader) {
    let { expandRows: expandRows } = arg;
    let content = typeof chunkConfig.content === 'function' ? chunkConfig.content(arg) : (0, $bvID6.createElement)('table', {
        role: 'presentation',
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : ''
        ].join(' '),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ''
        }
    }, arg.tableColGroupNode, (0, $bvID6.createElement)(isHeader ? 'thead' : 'tbody', {
        role: 'presentation'
    }, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $6ae642ef23cd8741$export$f5339a28e56d1baf(cols0, cols1) {
    return $6ae642ef23cd8741$export$23f2a1d2818174ef(cols0, cols1, $6ae642ef23cd8741$export$a9c23c6ac3fc3eca);
}
function $6ae642ef23cd8741$export$add49c223b9ce4ea(cols, shrinkWidth) {
    let colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for (let colProps of cols){
        let span = colProps.span || 1;
        for(let i = 0; i < span; i += 1)colNodes.push((0, $bvID6.createElement)("col", {
            style: {
                width: colProps.width === 'shrink' ? $6ae642ef23cd8741$export$df7c425476ed4f2(shrinkWidth) : colProps.width || '',
                minWidth: colProps.minWidth || ''
            }
        }));
    }
    return (0, $bvID6.createElement)('colgroup', {}, ...colNodes);
}
function $6ae642ef23cd8741$export$df7c425476ed4f2(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $6ae642ef23cd8741$export$c69d65aa55814164(cols) {
    for (let col of cols){
        if (col.width === 'shrink') return true;
    }
    return false;
}
function $6ae642ef23cd8741$export$65ab0ebced932b79(liquid, context) {
    let classNames = [
        'fc-scrollgrid',
        context.theme.getClass('table')
    ];
    if (liquid) classNames.push('fc-scrollgrid-liquid');
    return classNames;
}
function $6ae642ef23cd8741$export$101619b11a34a0bd(sectionConfig, wholeTableVGrow) {
    let classNames = [
        'fc-scrollgrid-section',
        `fc-scrollgrid-section-${sectionConfig.type}`,
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push('fc-scrollgrid-section-liquid');
    if (sectionConfig.isSticky) classNames.push('fc-scrollgrid-section-sticky');
    return classNames;
}
function $6ae642ef23cd8741$export$1ec7a8278ebd1290(arg) {
    return (0, $bvID6.createElement)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $6ae642ef23cd8741$export$89e9012e902952b6(options) {
    let { stickyHeaderDates: stickyHeaderDates } = options;
    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyHeaderDates;
}
function $6ae642ef23cd8741$export$4ad369a19af21c23(options) {
    let { stickyFooterScrollbar: stickyFooterScrollbar } = options;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyFooterScrollbar;
}
class $6ae642ef23cd8741$export$c667925124dac624 extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.processCols = $6ae642ef23cd8741$export$df995fae86a55f06((a)=>a, $6ae642ef23cd8741$export$f5339a28e56d1baf); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        this.renderMicroColGroup = $6ae642ef23cd8741$export$df995fae86a55f06($6ae642ef23cd8741$export$add49c223b9ce4ea);
        this.scrollerRefs = new $6ae642ef23cd8741$export$807f1ba34db587c7();
        this.scrollerElRefs = new $6ae642ef23cd8741$export$807f1ba34db587c7(this._handleScrollerEl.bind(this));
        this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        this.handleSizing = ()=>{
            this.safeSetState(Object.assign({
                shrinkWidth: this.computeShrinkWidth()
            }, this.computeScrollerDims()));
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let sectionConfigs = props.sections || [];
        let cols = this.processCols(props.cols);
        let microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        let classNames = $6ae642ef23cd8741$export$65ab0ebced932b79(props.liquid, context);
        if (props.collapsibleWidth) classNames.push('fc-scrollgrid-collapsible');
        // TODO: make DRY
        let configCnt = sectionConfigs.length;
        let configI = 0;
        let currentConfig;
        let headSectionNodes = [];
        let bodySectionNodes = [];
        let footSectionNodes = [];
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header'){
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body'){
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer'){
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        let isBuggy = !$6ae642ef23cd8741$export$738ab4df8bf92ae9();
        const roleAttrs = {
            role: 'rowgroup'
        };
        return (0, $bvID6.createElement)('table', {
            role: 'grid',
            className: classNames.join(' '),
            style: {
                height: props.height
            }
        }, Boolean(!isBuggy && headSectionNodes.length) && (0, $bvID6.createElement)('thead', roleAttrs, ...headSectionNodes), Boolean(!isBuggy && bodySectionNodes.length) && (0, $bvID6.createElement)('tbody', roleAttrs, ...bodySectionNodes), Boolean(!isBuggy && footSectionNodes.length) && (0, $bvID6.createElement)('tfoot', roleAttrs, ...footSectionNodes), isBuggy && (0, $bvID6.createElement)('tbody', roleAttrs, ...headSectionNodes, ...bodySectionNodes, ...footSectionNodes));
    }
    renderSection(sectionConfig, microColGroupNode, isHeader) {
        if ('outerContent' in sectionConfig) return (0, $bvID6.createElement)((0, $bvID6.Fragment), {
            key: sectionConfig.key
        }, sectionConfig.outerContent);
        return (0, $bvID6.createElement)("tr", {
            key: sectionConfig.key,
            role: "presentation",
            className: $6ae642ef23cd8741$export$101619b11a34a0bd(sectionConfig, this.props.liquid).join(' ')
        }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    }
    renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ('outerContent' in chunkConfig) return chunkConfig.outerContent;
        let { props: props } = this;
        let { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights } = this.state;
        let needsYScrolling = $6ae642ef23cd8741$export$df838d0240c938cf(props, sectionConfig); // TODO: do lazily. do in section config?
        let isLiquid = $6ae642ef23cd8741$export$60e660859c376841(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        let overflowY = !props.liquid ? 'visible' : forceYScrollbars ? 'scroll' : !needsYScrolling ? 'hidden' : 'auto';
        let sectionKey = sectionConfig.key;
        let content = $6ae642ef23cd8741$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: '',
            clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: ()=>{}
        }, isHeader);
        return (0, $bvID6.createElement)(isHeader ? 'th' : 'td', {
            ref: chunkConfig.elRef,
            role: 'presentation'
        }, (0, $bvID6.createElement)("div", {
            className: `fc-scroller-harness${isLiquid ? ' fc-scroller-harness-liquid' : ''}`
        }, (0, $bvID6.createElement)($6ae642ef23cd8741$export$54c4fabc2291e9c0, {
            ref: this.scrollerRefs.createRef(sectionKey),
            elRef: this.scrollerElRefs.createRef(sectionKey),
            overflowY: overflowY,
            overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */ ,
            maxHeight: sectionConfig.maxHeight,
            liquid: isLiquid,
            liquidIsAbsolute: true
        }, content)));
    }
    _handleScrollerEl(scrollerEl, key) {
        let section = $6ae642ef23cd8741$var$getSectionByKey(this.props.sections, key);
        if (section) $6ae642ef23cd8741$export$71cec2538cb2c617(section.chunk.scrollerElRef, scrollerEl);
    }
    componentDidMount() {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    }
    componentDidUpdate() {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleSizing);
    }
    computeShrinkWidth() {
        return $6ae642ef23cd8741$export$c69d65aa55814164(this.props.cols) ? $6ae642ef23cd8741$export$7fe88b5920ffddd2(this.scrollerElRefs.getAll()) : 0;
    }
    computeScrollerDims() {
        let scrollbarWidth = $6ae642ef23cd8741$export$a1edd97dd51cd48d();
        let { scrollerRefs: scrollerRefs, scrollerElRefs: scrollerElRefs } = this;
        let forceYScrollbars = false;
        let scrollerClientWidths = {};
        let scrollerClientHeights = {};
        for(let sectionKey in scrollerRefs.currentMap){
            let scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (let section of this.props.sections){
            let sectionKey = section.key;
            let scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                let harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                 : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return {
            forceYScrollbars: forceYScrollbars,
            scrollerClientWidths: scrollerClientWidths,
            scrollerClientHeights: scrollerClientHeights
        };
    }
}
$6ae642ef23cd8741$export$c667925124dac624.addStateEquality({
    scrollerClientWidths: $6ae642ef23cd8741$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $6ae642ef23cd8741$export$a9c23c6ac3fc3eca
});
function $6ae642ef23cd8741$var$getSectionByKey(sections, key) {
    for (let section of sections){
        if (section.key === key) return section;
    }
    return null;
}
class $6ae642ef23cd8741$export$c1df809846363ebe extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        // memo
        this.buildPublicEvent = $6ae642ef23cd8741$export$df995fae86a55f06((context, eventDef, eventInstance)=>new $6ae642ef23cd8741$export$71511d61b312f219(context, eventDef, eventInstance));
        this.handleEl = (el)=>{
            this.el = el;
            $6ae642ef23cd8741$export$71cec2538cb2c617(this.props.elRef, el);
            if (el) $6ae642ef23cd8741$var$setElSeg(el, this.props.seg);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { seg: seg } = props;
        const { eventRange: eventRange } = seg;
        const { ui: ui } = eventRange;
        const renderProps = {
            event: this.buildPublicEvent(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && $6ae642ef23cd8741$var$computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && $6ae642ef23cd8741$var$computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && $6ae642ef23cd8741$var$computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing)
        };
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7094788287c5e9b, {
            elRef: this.handleEl,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: [
                ...$6ae642ef23cd8741$var$getEventClassNames(renderProps),
                ...seg.eventRange.ui.classNames,
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "eventContent",
            customGenerator: options.eventContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: options.eventClassNames,
            didMount: options.eventDidMount,
            willUnmount: options.eventWillUnmount
        }, props.children);
    }
    componentDidUpdate(prevProps) {
        if (this.el && this.props.seg !== prevProps.seg) $6ae642ef23cd8741$var$setElSeg(this.el, this.props.seg);
    }
}
// should not be a purecomponent
class $6ae642ef23cd8741$export$6735ce526161c7bd extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let { ui: ui } = seg.eventRange;
        let timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
        let timeText = $6ae642ef23cd8741$export$2538633961795d6b(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$c1df809846363ebe, Object.assign({}, props /* includes elRef */ , {
            elTag: "a",
            elStyle: {
                borderColor: ui.borderColor,
                backgroundColor: ui.backgroundColor
            },
            elAttrs: $6ae642ef23cd8741$export$6dabbe08653f866f(seg, context),
            defaultGenerator: $6ae642ef23cd8741$var$renderInnerContent$1,
            timeText: timeText
        }), (InnerContent, eventContentArg)=>(0, $bvID6.createElement)((0, $bvID6.Fragment), null, (0, $bvID6.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-event-main'
                ],
                elStyle: {
                    color: eventContentArg.textColor
                }
            }), Boolean(eventContentArg.isStartResizable) && (0, $bvID6.createElement)("div", {
                className: "fc-event-resizer fc-event-resizer-start"
            }), Boolean(eventContentArg.isEndResizable) && (0, $bvID6.createElement)("div", {
                className: "fc-event-resizer fc-event-resizer-end"
            })));
    }
}
$6ae642ef23cd8741$export$6735ce526161c7bd.addPropsEquality({
    seg: $6ae642ef23cd8741$export$a9c23c6ac3fc3eca
});
function $6ae642ef23cd8741$var$renderInnerContent$1(innerProps) {
    return (0, $bvID6.createElement)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $bvID6.createElement)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $bvID6.createElement)("div", {
        className: "fc-event-title-container"
    }, (0, $bvID6.createElement)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $bvID6.createElement)((0, $bvID6.Fragment), null, "\u00A0"))));
}
const $6ae642ef23cd8741$export$6e4b1d19c6e2e012 = (props)=>(0, $bvID6.createElement)($6ae642ef23cd8741$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { options: options } = context;
        let renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }, props.children);
    });
const $6ae642ef23cd8741$var$DAY_NUM_FORMAT = $6ae642ef23cd8741$export$d141bba7fdc215a3({
    day: 'numeric'
});
class $6ae642ef23cd8741$export$c5d7c1ac98841e53 extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.refineRenderProps = $6ae642ef23cd8741$export$ebd11618f299a286($6ae642ef23cd8741$var$refineRenderProps);
    }
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = this.refineRenderProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            isMonthStart: props.isMonthStart || false,
            showDayNumber: props.showDayNumber,
            extraRenderProps: props.extraRenderProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
            monthStartFormat: options.monthStartFormat
        });
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                'data-date': $6ae642ef23cd8741$export$56350196709588fc(props.date)
            }),
            elClasses: [
                ...$6ae642ef23cd8741$export$1a8f5705751d8277(renderProps, context.theme),
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "dayCellContent",
            customGenerator: options.dayCellContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: // don't use custom classNames if disabled
            renderProps.isDisabled ? undefined : options.dayCellClassNames,
            didMount: options.dayCellDidMount,
            willUnmount: options.dayCellWillUnmount
        }, props.children);
    }
}
function $6ae642ef23cd8741$export$d92db8a7dc823bb0(options) {
    return Boolean(options.dayCellContent || $6ae642ef23cd8741$var$hasCustomRenderingHandler('dayCellContent', options));
}
function $6ae642ef23cd8741$var$refineRenderProps(raw) {
    let { date: date, dateEnv: dateEnv, dateProfile: dateProfile, isMonthStart: isMonthStart } = raw;
    let dayMeta = $6ae642ef23cd8741$export$e171bab687b50e0(date, raw.todayRange, null, dateProfile);
    let dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $6ae642ef23cd8741$var$DAY_NUM_FORMAT) : '';
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
class $6ae642ef23cd8741$export$b02498c06ddfef28 extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { seg: seg } = props;
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$c1df809846363ebe, {
            elTag: "div",
            elClasses: [
                'fc-bg-event'
            ],
            elStyle: {
                backgroundColor: seg.eventRange.ui.backgroundColor
            },
            defaultGenerator: $6ae642ef23cd8741$var$renderInnerContent,
            seg: seg,
            timeText: "",
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: false,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday,
            disableDragging: true,
            disableResizing: true
        });
    }
}
function $6ae642ef23cd8741$var$renderInnerContent(props) {
    let { title: title } = props.event;
    return title && (0, $bvID6.createElement)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $6ae642ef23cd8741$export$b975d55abac2bbe3(fillType) {
    return (0, $bvID6.createElement)("div", {
        className: `fc-${fillType}`
    });
}
const $6ae642ef23cd8741$export$1343a74baacb0543 = (props)=>(0, $bvID6.createElement)($6ae642ef23cd8741$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { dateEnv: dateEnv, options: options } = context;
        let { date: date } = props;
        let format = options.weekNumberFormat || props.defaultFormat;
        let num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        let text = dateEnv.format(date, format);
        let renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $6ae642ef23cd8741$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }, props.children);
    });
function $6ae642ef23cd8741$var$renderInner(innerProps) {
    return innerProps.text;
}
const $6ae642ef23cd8741$var$PADDING_FROM_VIEWPORT = 10;
class $6ae642ef23cd8741$var$Popover extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            titleId: $6ae642ef23cd8741$export$6559d589eb85fbb6()
        };
        this.handleRootEl = (el)=>{
            this.rootEl = el;
            if (this.props.elRef) $6ae642ef23cd8741$export$71cec2538cb2c617(this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        this.handleDocumentMouseDown = (ev)=>{
            // only hide the popover if the click happened outside the popover
            const target = $6ae642ef23cd8741$export$2ed0fc6709e59212(ev);
            if (!this.rootEl.contains(target)) this.handleCloseClick();
        };
        this.handleDocumentKeyDown = (ev)=>{
            if (ev.key === 'Escape') this.handleCloseClick();
        };
        this.handleCloseClick = ()=>{
            let { onClose: onClose } = this.props;
            if (onClose) onClose();
        };
    }
    render() {
        let { theme: theme, options: options } = this.context;
        let { props: props, state: state } = this;
        let classNames = [
            'fc-popover',
            theme.getClass('popover')
        ].concat(props.extraClassNames || []);
        return (0, $fz456.createPortal)((0, $bvID6.createElement)("div", Object.assign({}, props.extraAttrs, {
            id: props.id,
            className: classNames.join(' '),
            "aria-labelledby": state.titleId,
            ref: this.handleRootEl
        }), (0, $bvID6.createElement)("div", {
            className: 'fc-popover-header ' + theme.getClass('popoverHeader')
        }, (0, $bvID6.createElement)("span", {
            className: "fc-popover-title",
            id: state.titleId
        }, props.title), (0, $bvID6.createElement)("span", {
            className: 'fc-popover-close ' + theme.getIconClass('close'),
            title: options.closeHint,
            onClick: this.handleCloseClick
        })), (0, $bvID6.createElement)("div", {
            className: 'fc-popover-body ' + theme.getClass('popoverContent')
        }, props.children)), props.parentEl);
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleDocumentMouseDown);
        document.addEventListener('keydown', this.handleDocumentKeyDown);
        this.updateSize();
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDocumentMouseDown);
        document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }
    updateSize() {
        let { isRtl: isRtl } = this.context;
        let { alignmentEl: alignmentEl, alignGridTop: alignGridTop } = this.props;
        let { rootEl: rootEl } = this;
        let alignmentRect = $6ae642ef23cd8741$var$computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            let popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            let popoverTop = alignGridTop ? $6ae642ef23cd8741$export$dc98b0b04f4c7758(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top : alignmentRect.top;
            let popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, $6ae642ef23cd8741$var$PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $6ae642ef23cd8741$var$PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, $6ae642ef23cd8741$var$PADDING_FROM_VIEWPORT);
            let origin = rootEl.offsetParent.getBoundingClientRect();
            $6ae642ef23cd8741$export$faec65b429be379(rootEl, {
                top: popoverTop - origin.top,
                left: popoverLeft - origin.left
            });
        }
    }
}
class $6ae642ef23cd8741$var$MorePopover extends $6ae642ef23cd8741$export$d22783b3c2400a3a {
    constructor(){
        super(...arguments);
        this.handleRootEl = (rootEl)=>{
            this.rootEl = rootEl;
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl,
                useEventCenter: false
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { options: options, dateEnv: dateEnv } = this.context;
        let { props: props } = this;
        let { startDate: startDate, todayRange: todayRange, dateProfile: dateProfile } = props;
        let title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$c5d7c1ac98841e53, {
            elRef: this.handleRootEl,
            date: startDate,
            dateProfile: dateProfile,
            todayRange: todayRange
        }, (InnerContent, renderProps, elAttrs)=>(0, $bvID6.createElement)($6ae642ef23cd8741$var$Popover, {
                elRef: elAttrs.ref,
                id: props.id,
                title: title,
                extraClassNames: [
                    'fc-more-popover'
                ].concat(elAttrs.className || []),
                extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                parentEl: props.parentEl,
                alignmentEl: props.alignmentEl,
                alignGridTop: props.alignGridTop,
                onClose: props.onClose
            }, $6ae642ef23cd8741$export$d92db8a7dc823bb0(options) && (0, $bvID6.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-more-popover-misc'
                ]
            }), props.children));
    }
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        let { rootEl: rootEl, props: props } = this;
        if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
            dateProfile: props.dateProfile,
            dateSpan: Object.assign({
                allDay: !props.forceTimed,
                range: {
                    start: props.startDate,
                    end: props.endDate
                }
            }, props.extraDateSpan),
            dayEl: rootEl,
            rect: {
                left: 0,
                top: 0,
                right: elWidth,
                bottom: elHeight
            },
            layer: 1
        };
        return null;
    }
}
class $6ae642ef23cd8741$export$87b6ab1c2cb8b955 extends $6ae642ef23cd8741$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            isPopoverOpen: false,
            popoverId: $6ae642ef23cd8741$export$6559d589eb85fbb6()
        };
        this.handleLinkEl = (linkEl)=>{
            this.linkEl = linkEl;
            if (this.props.elRef) $6ae642ef23cd8741$export$71cec2538cb2c617(this.props.elRef, linkEl);
        };
        this.handleClick = (ev)=>{
            let { props: props, context: context } = this;
            let { moreLinkClick: moreLinkClick } = context.options;
            let date = $6ae642ef23cd8741$var$computeRange(props).start;
            function buildPublicSeg(seg) {
                let { def: def, instance: instance, range: range } = seg.eventRange;
                return {
                    event: new $6ae642ef23cd8741$export$71511d61b312f219(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            }
            if (typeof moreLinkClick === 'function') moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === 'popover') this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === 'string') context.calendarApi.zoomTo(date, moreLinkClick);
        };
        this.handlePopoverClose = ()=>{
            this.setState({
                isPopoverOpen: false
            });
        };
    }
    render() {
        let { props: props, state: state } = this;
        return (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7c866399fa523f5.Consumer, null, (context)=>{
            let { viewApi: viewApi, options: options, calendarApi: calendarApi } = context;
            let { moreLinkText: moreLinkText } = options;
            let { moreCnt: moreCnt } = props;
            let range = $6ae642ef23cd8741$var$computeRange(props);
            let text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
             ? moreLinkText.call(calendarApi, moreCnt) : `+${moreCnt} ${moreLinkText}`;
            let hint = $6ae642ef23cd8741$export$342063e11d6c3cad(options.moreLinkHint, [
                moreCnt
            ], text);
            let renderProps = {
                num: moreCnt,
                shortText: `+${moreCnt}`,
                text: text,
                view: viewApi
            };
            return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, Boolean(props.moreCnt) && (0, $bvID6.createElement)($6ae642ef23cd8741$export$e7094788287c5e9b, {
                elTag: props.elTag || 'a',
                elRef: this.handleLinkEl,
                elClasses: [
                    ...props.elClasses || [],
                    'fc-more-link'
                ],
                elStyle: props.elStyle,
                elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $6ae642ef23cd8741$var$createAriaClickAttrs(this.handleClick)), {
                    title: hint,
                    'aria-expanded': state.isPopoverOpen,
                    'aria-controls': state.isPopoverOpen ? state.popoverId : ''
                }),
                renderProps: renderProps,
                generatorName: "moreLinkContent",
                customGenerator: options.moreLinkContent,
                defaultGenerator: props.defaultGenerator || $6ae642ef23cd8741$var$renderMoreLinkInner,
                classNameGenerator: options.moreLinkClassNames,
                didMount: options.moreLinkDidMount,
                willUnmount: options.moreLinkWillUnmount
            }, props.children), state.isPopoverOpen && (0, $bvID6.createElement)($6ae642ef23cd8741$var$MorePopover, {
                id: state.popoverId,
                startDate: range.start,
                endDate: range.end,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraDateSpan: props.extraDateSpan,
                parentEl: this.parentEl,
                alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : this.linkEl,
                alignGridTop: props.alignGridTop,
                forceTimed: props.forceTimed,
                onClose: this.handlePopoverClose
            }, props.popoverContent()));
        });
    }
    componentDidMount() {
        this.updateParentEl();
    }
    componentDidUpdate() {
        this.updateParentEl();
    }
    updateParentEl() {
        if (this.linkEl) this.parentEl = $6ae642ef23cd8741$export$dc98b0b04f4c7758(this.linkEl, '.fc-view-harness');
    }
}
function $6ae642ef23cd8741$var$renderMoreLinkInner(props) {
    return props.text;
}
function $6ae642ef23cd8741$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $6ae642ef23cd8741$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    let { hiddenSegs: hiddenSegs } = props;
    return {
        start: $6ae642ef23cd8741$export$cd571ca6d1702b73(hiddenSegs),
        end: $6ae642ef23cd8741$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $6ae642ef23cd8741$export$cd571ca6d1702b73(segs) {
    return segs.reduce($6ae642ef23cd8741$var$pickEarliestStart).eventRange.range.start;
}
function $6ae642ef23cd8741$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $6ae642ef23cd8741$var$computeLatestSegEnd(segs) {
    return segs.reduce($6ae642ef23cd8741$var$pickLatestEnd).eventRange.range.end;
}
function $6ae642ef23cd8741$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
class $6ae642ef23cd8741$var$Store {
    constructor(){
        this.handlers = [];
    }
    set(value) {
        this.currentValue = value;
        for (let handler of this.handlers)handler(value);
    }
    subscribe(handler) {
        this.handlers.push(handler);
        if (this.currentValue !== undefined) handler(this.currentValue);
    }
}
/*
Subscribers will get a LIST of CustomRenderings
*/ class $6ae642ef23cd8741$export$1776704b6532a19a extends $6ae642ef23cd8741$var$Store {
    constructor(){
        super(...arguments);
        this.map = new Map();
    }
    // for consistent order
    handle(customRendering) {
        const { map: map } = this;
        let updated = false;
        if (customRendering.isActive) {
            map.set(customRendering.id, customRendering);
            updated = true;
        } else if (map.has(customRendering.id)) {
            map.delete(customRendering.id);
            updated = true;
        }
        if (updated) this.set(map);
    }
}

});
parcelRegister("bvID6", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $8615357c41107301$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "isValidElement", function () { return $8615357c41107301$export$a8257692ac88316c; });
$parcel$export(module.exports, "createElement", function () { return $8615357c41107301$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $8615357c41107301$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $8615357c41107301$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $8615357c41107301$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $8615357c41107301$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $8615357c41107301$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $8615357c41107301$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $8615357c41107301$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $8615357c41107301$export$fd42f52fd3ae1109; });
var $8615357c41107301$var$n, $8615357c41107301$export$41c562ebe57d11e2, $8615357c41107301$var$u, $8615357c41107301$export$a8257692ac88316c, $8615357c41107301$var$t, $8615357c41107301$var$r, $8615357c41107301$var$o, $8615357c41107301$var$f, $8615357c41107301$var$e, $8615357c41107301$var$c = {}, $8615357c41107301$var$s = [], $8615357c41107301$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $8615357c41107301$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $8615357c41107301$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $8615357c41107301$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $8615357c41107301$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $8615357c41107301$var$p(l, f, t, r, null);
}
function $8615357c41107301$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$8615357c41107301$var$u : o
    };
    return null == o && null != $8615357c41107301$export$41c562ebe57d11e2.vnode && $8615357c41107301$export$41c562ebe57d11e2.vnode(f), f;
}
function $8615357c41107301$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $8615357c41107301$export$ffb0004e005737fa(n) {
    return n.children;
}
function $8615357c41107301$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $8615357c41107301$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $8615357c41107301$var$g(n, r, l[r], u[r], i);
}
function $8615357c41107301$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $8615357c41107301$var$a.test(l) ? u : u + "px";
}
function $8615357c41107301$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $8615357c41107301$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $8615357c41107301$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $8615357c41107301$var$w : $8615357c41107301$var$m, r) : n.removeEventListener(l, r ? $8615357c41107301$var$w : $8615357c41107301$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $8615357c41107301$var$m(n) {
    $8615357c41107301$var$t = !0;
    try {
        return this.l[n.type + !1]($8615357c41107301$export$41c562ebe57d11e2.event ? $8615357c41107301$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $8615357c41107301$var$t = !1;
    }
}
function $8615357c41107301$var$w(n) {
    $8615357c41107301$var$t = !0;
    try {
        return this.l[n.type + !0]($8615357c41107301$export$41c562ebe57d11e2.event ? $8615357c41107301$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $8615357c41107301$var$t = !1;
    }
}
function $8615357c41107301$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $8615357c41107301$var$A(n, l) {
    if (null == l) return n.__ ? $8615357c41107301$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $8615357c41107301$var$A(n) : null;
}
function $8615357c41107301$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $8615357c41107301$var$P(n);
    }
}
function $8615357c41107301$var$C(n) {
    $8615357c41107301$var$t ? setTimeout(n) : $8615357c41107301$var$f(n);
}
function $8615357c41107301$var$T(n) {
    (!n.__d && (n.__d = !0) && $8615357c41107301$var$r.push(n) && !$8615357c41107301$var$$.__r++ || $8615357c41107301$var$o !== $8615357c41107301$export$41c562ebe57d11e2.debounceRendering) && (($8615357c41107301$var$o = $8615357c41107301$export$41c562ebe57d11e2.debounceRendering) || $8615357c41107301$var$C)($8615357c41107301$var$$);
}
function $8615357c41107301$var$$() {
    var n, l, u, i, t, o, f, e;
    for($8615357c41107301$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $8615357c41107301$var$r.shift();)n.__d && (l = $8615357c41107301$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $8615357c41107301$var$h({}, o)).__v = o.__v + 1, $8615357c41107301$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $8615357c41107301$var$A(o) : f, o.__h), $8615357c41107301$var$N(i, o), o.__e != f && $8615357c41107301$var$P(o)), $8615357c41107301$var$r.length > l && $8615357c41107301$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $8615357c41107301$var$$.__r = 0;
}
function $8615357c41107301$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $8615357c41107301$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? $8615357c41107301$var$p(null, d, null, null, d) : Array.isArray(d) ? $8615357c41107301$var$p($8615357c41107301$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $8615357c41107301$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $8615357c41107301$var$M(n, d, y = y || $8615357c41107301$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $8615357c41107301$var$I(d, e, n) : e = $8615357c41107301$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $8615357c41107301$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $8615357c41107301$var$L(i).nextSibling), $8615357c41107301$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$8615357c41107301$var$S(g[h], g[++h], g[++h]);
}
function $8615357c41107301$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $8615357c41107301$var$I(i, l, u) : $8615357c41107301$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $8615357c41107301$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $8615357c41107301$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $8615357c41107301$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $8615357c41107301$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $8615357c41107301$var$L(u))) return i;
    }
    return null;
}
function $8615357c41107301$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $8615357c41107301$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (b = u.props, g = (s = $.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in $ && $.prototype.render ? u.__c = a = new $(b, m) : (u.__c = a = new $8615357c41107301$export$16fa2f45be04daa8(b, m), a.constructor = $, a.render = $8615357c41107301$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != $.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $8615357c41107301$var$h({}, a.__s)), $8615357c41107301$var$h(a.__s, $.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == $.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $8615357c41107301$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $8615357c41107301$var$h($8615357c41107301$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $8615357c41107301$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $8615357c41107301$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $8615357c41107301$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $8615357c41107301$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $8615357c41107301$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $8615357c41107301$var$N(n, u) {
    $8615357c41107301$export$41c562ebe57d11e2.__c && $8615357c41107301$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $8615357c41107301$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $8615357c41107301$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $8615357c41107301$var$n.call(l.childNodes), a = (y = i.props || $8615357c41107301$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($8615357c41107301$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_ = u.props.children, $8615357c41107301$var$H(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $8615357c41107301$var$A(i, 0), e), null != o) for(_ = o.length; _--;)null != o[_] && $8615357c41107301$var$v(o[_]);
        e || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $8615357c41107301$var$g(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $8615357c41107301$var$g(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $8615357c41107301$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $8615357c41107301$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $8615357c41107301$var$q(n, u, i) {
    var t, r;
    if ($8615357c41107301$export$41c562ebe57d11e2.unmount && $8615357c41107301$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $8615357c41107301$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $8615357c41107301$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $8615357c41107301$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $8615357c41107301$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $8615357c41107301$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $8615357c41107301$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $8615357c41107301$export$41c562ebe57d11e2.__ && $8615357c41107301$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $8615357c41107301$var$M(i, u = (!r && t || i).__k = $8615357c41107301$export$c8a8987d4410bf2d($8615357c41107301$export$ffb0004e005737fa, null, [
        u
    ]), o || $8615357c41107301$var$c, $8615357c41107301$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $8615357c41107301$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $8615357c41107301$var$N(f, u);
}
function $8615357c41107301$export$fa8d919ba61d84db(n, l) {
    $8615357c41107301$export$b3890eb0ae9dca99(n, l, $8615357c41107301$export$fa8d919ba61d84db);
}
function $8615357c41107301$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $8615357c41107301$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $8615357c41107301$var$n.call(arguments, 2) : i), $8615357c41107301$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $8615357c41107301$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $8615357c41107301$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $8615357c41107301$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$8615357c41107301$var$n = $8615357c41107301$var$s.slice, $8615357c41107301$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $8615357c41107301$var$u = 0, $8615357c41107301$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $8615357c41107301$var$t = !1, $8615357c41107301$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $8615357c41107301$var$h({}, this.state), "function" == typeof n && (n = n($8615357c41107301$var$h({}, u), this.props)), n && $8615357c41107301$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $8615357c41107301$var$T(this));
}, $8615357c41107301$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $8615357c41107301$var$T(this));
}, $8615357c41107301$export$16fa2f45be04daa8.prototype.render = $8615357c41107301$export$ffb0004e005737fa, $8615357c41107301$var$r = [], $8615357c41107301$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $8615357c41107301$var$$.__r = 0, $8615357c41107301$var$e = 0;

});

parcelRegister("fz456", function(module, exports) {

$parcel$export(module.exports, "createPortal", function () { return $b54d4a61e5bacd47$export$d39a5bbd09211389; });

var $bvID6 = parcelRequire("bvID6");

var $32bE5 = parcelRequire("32bE5");
function $b54d4a61e5bacd47$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $b54d4a61e5bacd47$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $b54d4a61e5bacd47$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $b54d4a61e5bacd47$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $b54d4a61e5bacd47$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $b54d4a61e5bacd47$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $bvID6.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($b54d4a61e5bacd47$export$221d75b3f55bb0bd.prototype = new (0, $bvID6.Component)).isPureReactComponent = !0, $b54d4a61e5bacd47$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $b54d4a61e5bacd47$var$C(this.props, n) || $b54d4a61e5bacd47$var$C(this.state, t);
};
var $b54d4a61e5bacd47$var$x = (0, $bvID6.options).__b;
(0, $bvID6.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $b54d4a61e5bacd47$var$x && $b54d4a61e5bacd47$var$x(n);
};
var $b54d4a61e5bacd47$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $b54d4a61e5bacd47$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $b54d4a61e5bacd47$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $b54d4a61e5bacd47$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $b54d4a61e5bacd47$var$A = function(n, t) {
    return null == n ? null : (0, $bvID6.toChildArray)((0, $bvID6.toChildArray)(n).map(t));
}, $b54d4a61e5bacd47$export$dca3b0875bd9a954 = {
    map: $b54d4a61e5bacd47$var$A,
    forEach: $b54d4a61e5bacd47$var$A,
    count: function(n) {
        return n ? (0, $bvID6.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $bvID6.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $bvID6.toChildArray)
}, $b54d4a61e5bacd47$var$T = (0, $bvID6.options).__e;
(0, $bvID6.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $b54d4a61e5bacd47$var$T(n, t, e, r);
};
var $b54d4a61e5bacd47$var$I = (0, $bvID6.options).unmount;
function $b54d4a61e5bacd47$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $b54d4a61e5bacd47$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $b54d4a61e5bacd47$var$L(n, t, e);
    })), n;
}
function $b54d4a61e5bacd47$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $b54d4a61e5bacd47$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $b54d4a61e5bacd47$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $b54d4a61e5bacd47$var$F(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $b54d4a61e5bacd47$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $bvID6.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $b54d4a61e5bacd47$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $bvID6.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $b54d4a61e5bacd47$var$I && $b54d4a61e5bacd47$var$I(n);
}, ($b54d4a61e5bacd47$export$74bf444e3cd11ea5.prototype = new (0, $bvID6.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $b54d4a61e5bacd47$var$F(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $b54d4a61e5bacd47$var$U(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $b54d4a61e5bacd47$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $b54d4a61e5bacd47$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $b54d4a61e5bacd47$var$L(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $bvID6.createElement)((0, $bvID6.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, $bvID6.createElement)((0, $bvID6.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $b54d4a61e5bacd47$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $b54d4a61e5bacd47$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $b54d4a61e5bacd47$var$$(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $bvID6.render)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $bvID6.render)((0, $bvID6.createElement)($b54d4a61e5bacd47$var$P, {
        context: e.context
    }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function $b54d4a61e5bacd47$export$d39a5bbd09211389(n, e) {
    var r = (0, $bvID6.createElement)($b54d4a61e5bacd47$var$$, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($b54d4a61e5bacd47$export$998bcd577473dd93.prototype = new (0, $bvID6.Component)).__a = function(n) {
    var t = this, e = $b54d4a61e5bacd47$var$F(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $b54d4a61e5bacd47$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $b54d4a61e5bacd47$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $bvID6.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $b54d4a61e5bacd47$export$998bcd577473dd93.prototype.componentDidUpdate = $b54d4a61e5bacd47$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $b54d4a61e5bacd47$var$W(n, e, t);
    });
};
var $b54d4a61e5bacd47$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $b54d4a61e5bacd47$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $b54d4a61e5bacd47$var$H = "undefined" != typeof document, $b54d4a61e5bacd47$var$Z = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $b54d4a61e5bacd47$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $bvID6.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $b54d4a61e5bacd47$export$fa8d919ba61d84db(n, t, e) {
    return (0, $bvID6.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $bvID6.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $bvID6.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $b54d4a61e5bacd47$var$G = (0, $bvID6.options).event;
function $b54d4a61e5bacd47$var$J() {}
function $b54d4a61e5bacd47$var$K() {
    return this.cancelBubble;
}
function $b54d4a61e5bacd47$var$Q() {
    return this.defaultPrevented;
}
(0, $bvID6.options).event = function(n) {
    return $b54d4a61e5bacd47$var$G && (n = $b54d4a61e5bacd47$var$G(n)), n.persist = $b54d4a61e5bacd47$var$J, n.isPropagationStopped = $b54d4a61e5bacd47$var$K, n.isDefaultPrevented = $b54d4a61e5bacd47$var$Q, n.nativeEvent = n;
};
var $b54d4a61e5bacd47$var$X, $b54d4a61e5bacd47$var$nn = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $b54d4a61e5bacd47$var$tn = (0, $bvID6.options).vnode;
(0, $bvID6.options).vnode = function(n) {
    var t = n.type, e = n.props, u = e;
    if ("string" == typeof t) {
        var o = -1 === t.indexOf("-");
        for(var i in u = {}, e){
            var l = e[i];
            $b54d4a61e5bacd47$var$H && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !$b54d4a61e5bacd47$var$Z(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $b54d4a61e5bacd47$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
        }
        "select" == t && u.multiple && Array.isArray(u.value) && (u.value = (0, $bvID6.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == t && null != u.defaultValue && (u.value = (0, $bvID6.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), n.props = u, e.class != e.className && ($b54d4a61e5bacd47$var$nn.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", $b54d4a61e5bacd47$var$nn));
    }
    n.$$typeof = $b54d4a61e5bacd47$var$z, $b54d4a61e5bacd47$var$tn && $b54d4a61e5bacd47$var$tn(n);
};
var $b54d4a61e5bacd47$var$en = (0, $bvID6.options).__r;
(0, $bvID6.options).__r = function(n) {
    $b54d4a61e5bacd47$var$en && $b54d4a61e5bacd47$var$en(n), $b54d4a61e5bacd47$var$X = n.__c;
};
var $b54d4a61e5bacd47$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $b54d4a61e5bacd47$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $b54d4a61e5bacd47$export$83d89fbfd8236492 = "17.0.2";
function $b54d4a61e5bacd47$export$d38cd72104c1f0e9(n) {
    return (0, $bvID6.createElement).bind(null, n);
}
function $b54d4a61e5bacd47$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $b54d4a61e5bacd47$var$z;
}
function $b54d4a61e5bacd47$export$e530037191fcd5d7(n) {
    return $b54d4a61e5bacd47$export$a8257692ac88316c(n) ? (0, $bvID6.cloneElement).apply(null, arguments) : n;
}
function $b54d4a61e5bacd47$export$502457920280e6be(n) {
    return !!n.__k && ((0, $bvID6.render)(null, n), !0);
}
function $b54d4a61e5bacd47$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $b54d4a61e5bacd47$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $b54d4a61e5bacd47$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $b54d4a61e5bacd47$export$5f8d39834fd61797 = (0, $bvID6.Fragment);
function $b54d4a61e5bacd47$export$7568632d0d33d16d(n) {
    n();
}
function $b54d4a61e5bacd47$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $b54d4a61e5bacd47$export$7b286972b8d8ccbf() {
    return [
        !1,
        $b54d4a61e5bacd47$export$7568632d0d33d16d
    ];
}
var $b54d4a61e5bacd47$export$aaabe4eda9ed9969 = (0, $32bE5.useLayoutEffect);
function $b54d4a61e5bacd47$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $32bE5.useState)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $32bE5.useLayoutEffect)(function() {
        u.__ = e, u.v = t, $b54d4a61e5bacd47$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $32bE5.useEffect)(function() {
        return $b54d4a61e5bacd47$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $b54d4a61e5bacd47$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $b54d4a61e5bacd47$export$2e2bcd8739ae039 = {
    useState: (0, $32bE5.useState),
    useId: (0, $32bE5.useId),
    useReducer: (0, $32bE5.useReducer),
    useEffect: (0, $32bE5.useEffect),
    useLayoutEffect: (0, $32bE5.useLayoutEffect),
    useInsertionEffect: $b54d4a61e5bacd47$export$aaabe4eda9ed9969,
    useTransition: $b54d4a61e5bacd47$export$7b286972b8d8ccbf,
    useDeferredValue: $b54d4a61e5bacd47$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $b54d4a61e5bacd47$export$306c0aa65ff9ec16,
    startTransition: $b54d4a61e5bacd47$export$7568632d0d33d16d,
    useRef: (0, $32bE5.useRef),
    useImperativeHandle: (0, $32bE5.useImperativeHandle),
    useMemo: (0, $32bE5.useMemo),
    useCallback: (0, $32bE5.useCallback),
    useContext: (0, $32bE5.useContext),
    useDebugValue: (0, $32bE5.useDebugValue),
    version: "17.0.2",
    Children: $b54d4a61e5bacd47$export$dca3b0875bd9a954,
    render: $b54d4a61e5bacd47$export$b3890eb0ae9dca99,
    hydrate: $b54d4a61e5bacd47$export$fa8d919ba61d84db,
    unmountComponentAtNode: $b54d4a61e5bacd47$export$502457920280e6be,
    createPortal: $b54d4a61e5bacd47$export$d39a5bbd09211389,
    createElement: (0, $bvID6.createElement),
    createContext: (0, $bvID6.createContext),
    createFactory: $b54d4a61e5bacd47$export$d38cd72104c1f0e9,
    cloneElement: $b54d4a61e5bacd47$export$e530037191fcd5d7,
    createRef: (0, $bvID6.createRef),
    Fragment: (0, $bvID6.Fragment),
    isValidElement: $b54d4a61e5bacd47$export$a8257692ac88316c,
    findDOMNode: $b54d4a61e5bacd47$export$466bfc07425424d5,
    Component: (0, $bvID6.Component),
    PureComponent: $b54d4a61e5bacd47$export$221d75b3f55bb0bd,
    memo: $b54d4a61e5bacd47$export$7c73462e0d25e514,
    forwardRef: $b54d4a61e5bacd47$export$257a8862b851cb5b,
    flushSync: $b54d4a61e5bacd47$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $b54d4a61e5bacd47$export$c78a37762a8d58e1,
    StrictMode: $b54d4a61e5bacd47$export$5f8d39834fd61797,
    Suspense: $b54d4a61e5bacd47$export$74bf444e3cd11ea5,
    SuspenseList: $b54d4a61e5bacd47$export$998bcd577473dd93,
    lazy: $b54d4a61e5bacd47$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $b54d4a61e5bacd47$export$ae55be85d98224ed
};

});
parcelRegister("32bE5", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $235a9795e18542db$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $235a9795e18542db$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $235a9795e18542db$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $235a9795e18542db$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $235a9795e18542db$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $235a9795e18542db$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $235a9795e18542db$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $235a9795e18542db$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $235a9795e18542db$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $235a9795e18542db$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useId", function () { return $235a9795e18542db$export$f680877a34711e37; });

var $bvID6 = parcelRequire("bvID6");
var $235a9795e18542db$var$t, $235a9795e18542db$var$r, $235a9795e18542db$var$u, $235a9795e18542db$var$i, $235a9795e18542db$var$o = 0, $235a9795e18542db$var$f = [], $235a9795e18542db$var$c = [], $235a9795e18542db$var$e = (0, $bvID6.options).__b, $235a9795e18542db$var$a = (0, $bvID6.options).__r, $235a9795e18542db$var$v = (0, $bvID6.options).diffed, $235a9795e18542db$var$l = (0, $bvID6.options).__c, $235a9795e18542db$var$m = (0, $bvID6.options).unmount;
function $235a9795e18542db$var$d(t, u) {
    (0, $bvID6.options).__h && (0, $bvID6.options).__h($235a9795e18542db$var$r, t, $235a9795e18542db$var$o || u), $235a9795e18542db$var$o = 0;
    var i = $235a9795e18542db$var$r.__H || ($235a9795e18542db$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $235a9795e18542db$var$c
    }), i.__[t];
}
function $235a9795e18542db$export$60241385465d0a34(n) {
    return $235a9795e18542db$var$o = 1, $235a9795e18542db$export$13e3392192263954($235a9795e18542db$var$B, n);
}
function $235a9795e18542db$export$13e3392192263954(n, u, i) {
    var o = $235a9795e18542db$var$d($235a9795e18542db$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $235a9795e18542db$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $235a9795e18542db$var$r, !$235a9795e18542db$var$r.u)) {
        $235a9795e18542db$var$r.u = !0;
        var f = $235a9795e18542db$var$r.shouldComponentUpdate;
        $235a9795e18542db$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $235a9795e18542db$export$6d9c69b0de29b591(u, i) {
    var o = $235a9795e18542db$var$d($235a9795e18542db$var$t++, 3);
    !(0, $bvID6.options).__s && $235a9795e18542db$var$z(o.__H, i) && (o.__ = u, o.i = i, $235a9795e18542db$var$r.__H.__h.push(o));
}
function $235a9795e18542db$export$e5c5a5f917a5871c(u, i) {
    var o = $235a9795e18542db$var$d($235a9795e18542db$var$t++, 4);
    !(0, $bvID6.options).__s && $235a9795e18542db$var$z(o.__H, i) && (o.__ = u, o.i = i, $235a9795e18542db$var$r.__h.push(o));
}
function $235a9795e18542db$export$b8f5890fc79d6aca(n) {
    return $235a9795e18542db$var$o = 5, $235a9795e18542db$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $235a9795e18542db$export$d5a552a76deda3c2(n, t, r) {
    $235a9795e18542db$var$o = 6, $235a9795e18542db$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $235a9795e18542db$export$1538c33de8887b59(n, r) {
    var u = $235a9795e18542db$var$d($235a9795e18542db$var$t++, 7);
    return $235a9795e18542db$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $235a9795e18542db$export$35808ee640e87ca7(n, t) {
    return $235a9795e18542db$var$o = 8, $235a9795e18542db$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $235a9795e18542db$export$fae74005e78b1a27(n) {
    var u = $235a9795e18542db$var$r.context[n.__c], i = $235a9795e18542db$var$d($235a9795e18542db$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($235a9795e18542db$var$r)), u.props.value) : n.__;
}
function $235a9795e18542db$export$dc8fbce3eb94dc1e(t, r) {
    (0, $bvID6.options).useDebugValue && (0, $bvID6.options).useDebugValue(r ? r(t) : t);
}
function $235a9795e18542db$export$c052f6604b7d51fe(n) {
    var u = $235a9795e18542db$var$d($235a9795e18542db$var$t++, 10), i = $235a9795e18542db$export$60241385465d0a34();
    return u.__ = n, $235a9795e18542db$var$r.componentDidCatch || ($235a9795e18542db$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $235a9795e18542db$export$f680877a34711e37() {
    var n = $235a9795e18542db$var$d($235a9795e18542db$var$t++, 11);
    if (!n.__) {
        for(var u = $235a9795e18542db$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $235a9795e18542db$var$b() {
    for(var t; t = $235a9795e18542db$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($235a9795e18542db$var$k), t.__H.__h.forEach($235a9795e18542db$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $bvID6.options).__e(r, t.__v);
    }
}
(0, $bvID6.options).__b = function(n) {
    $235a9795e18542db$var$r = null, $235a9795e18542db$var$e && $235a9795e18542db$var$e(n);
}, (0, $bvID6.options).__r = function(n) {
    $235a9795e18542db$var$a && $235a9795e18542db$var$a(n), $235a9795e18542db$var$t = 0;
    var i = ($235a9795e18542db$var$r = n.__c).__H;
    i && ($235a9795e18542db$var$u === $235a9795e18542db$var$r ? (i.__h = [], $235a9795e18542db$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $235a9795e18542db$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($235a9795e18542db$var$k), i.__h.forEach($235a9795e18542db$var$w), i.__h = [])), $235a9795e18542db$var$u = $235a9795e18542db$var$r;
}, (0, $bvID6.options).diffed = function(t) {
    $235a9795e18542db$var$v && $235a9795e18542db$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $235a9795e18542db$var$f.push(o) && $235a9795e18542db$var$i === (0, $bvID6.options).requestAnimationFrame || (($235a9795e18542db$var$i = (0, $bvID6.options).requestAnimationFrame) || $235a9795e18542db$var$j)($235a9795e18542db$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $235a9795e18542db$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $235a9795e18542db$var$c;
    })), $235a9795e18542db$var$u = $235a9795e18542db$var$r = null;
}, (0, $bvID6.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($235a9795e18542db$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $235a9795e18542db$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $bvID6.options).__e(u, t.__v);
        }
    }), $235a9795e18542db$var$l && $235a9795e18542db$var$l(t, r);
}, (0, $bvID6.options).unmount = function(t) {
    $235a9795e18542db$var$m && $235a9795e18542db$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $235a9795e18542db$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $bvID6.options).__e(r, u.__v));
};
var $235a9795e18542db$var$g = "function" == typeof requestAnimationFrame;
function $235a9795e18542db$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $235a9795e18542db$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $235a9795e18542db$var$g && (t = requestAnimationFrame(r));
}
function $235a9795e18542db$var$k(n) {
    var t = $235a9795e18542db$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $235a9795e18542db$var$r = t;
}
function $235a9795e18542db$var$w(n) {
    var t = $235a9795e18542db$var$r;
    n.__c = n.__(), $235a9795e18542db$var$r = t;
}
function $235a9795e18542db$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $235a9795e18542db$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});




parcelRegister("kiP87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec7d266e49dea3c2$export$2e2bcd8739ae039; });

var $jnteQ = parcelRequire("jnteQ");

var $aEl91 = parcelRequire("aEl91");


var $ec7d266e49dea3c2$export$2e2bcd8739ae039 = (0, $jnteQ.createPlugin)({
    name: '@fullcalendar/daygrid',
    initialView: 'dayGridMonth',
    views: {
        dayGrid: {
            component: (0, $aEl91.DayGridView),
            dateProfileGeneratorClass: (0, $aEl91.TableDateProfileGenerator)
        },
        dayGridDay: {
            type: 'dayGrid',
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: 'dayGrid',
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: 'dayGrid',
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: 'dayGrid',
            duration: {
                years: 1
            }
        }
    }
});

});
parcelRegister("aEl91", function(module, exports) {

$parcel$export(module.exports, "DayTable", function () { return $7c0e0aaea4b15c83$export$cd402b7558adf371; });
$parcel$export(module.exports, "DayGridView", function () { return $7c0e0aaea4b15c83$export$39eed66de95896e5; });
$parcel$export(module.exports, "TableDateProfileGenerator", function () { return $7c0e0aaea4b15c83$export$9fcce6e2d16ec31d; });

var $9b1rB = parcelRequire("9b1rB");

var $bvID6 = parcelRequire("bvID6");
/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
class $7c0e0aaea4b15c83$export$b3c27e869d856b7 extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.headerElRef = (0, $bvID6.createRef)();
    }
    renderSimpleLayout(headerRowContent, bodyContent) {
        let { props: props, context: context } = this;
        let sections = [];
        let stickyHeaderDates = (0, $9b1rB.ca)(context.options);
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: 'fc-col-header',
                rowContent: headerRowContent
            }
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunk: {
                content: bodyContent
            }
        });
        return (0, $bvID6.createElement)((0, $9b1rB.cq), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $bvID6.createElement)((0, $9b1rB.bZ), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
        let { props: props, context: context } = this;
        let stickyHeaderDates = !props.forPrint && (0, $9b1rB.ca)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $9b1rB.c9)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunks: [
                {
                    key: 'main',
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            ]
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunks: [
                {
                    key: 'main',
                    content: bodyContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            type: 'footer',
            key: 'footer',
            isSticky: true,
            chunks: [
                {
                    key: 'main',
                    content: (0, $9b1rB.c8)
                }
            ]
        });
        return (0, $bvID6.createElement)((0, $9b1rB.cq), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $bvID6.createElement)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: props.forPrint,
            colGroups: [
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
}
function $7c0e0aaea4b15c83$var$splitSegsByRow(segs, rowCnt) {
    let byRow = [];
    for(let i = 0; i < rowCnt; i += 1)byRow[i] = [];
    for (let seg of segs)byRow[seg.row].push(seg);
    return byRow;
}
function $7c0e0aaea4b15c83$var$splitSegsByFirstCol(segs, colCnt) {
    let byCol = [];
    for(let i = 0; i < colCnt; i += 1)byCol[i] = [];
    for (let seg of segs)byCol[seg.firstCol].push(seg);
    return byCol;
}
function $7c0e0aaea4b15c83$var$splitInteractionByRow(ui, rowCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < rowCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.row].segs.push(seg);
    }
    return byRow;
}
const $7c0e0aaea4b15c83$var$DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $9b1rB.x)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'narrow'
});
function $7c0e0aaea4b15c83$var$hasListItemDisplay(seg) {
    let { display: display } = seg.eventRange.ui;
    return display === 'list-item' || display === 'auto' && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
class $7c0e0aaea4b15c83$var$TableBlockEvent extends (0, $9b1rB.B) {
    render() {
        let { props: props } = this;
        return (0, $bvID6.createElement)((0, $9b1rB.cg), Object.assign({}, props, {
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-block-event',
                'fc-h-event'
            ],
            defaultTimeFormat: $7c0e0aaea4b15c83$var$DEFAULT_TABLE_EVENT_TIME_FORMAT,
            defaultDisplayEventEnd: props.defaultDisplayEventEnd,
            disableResizing: !props.seg.eventRange.def.allDay
        }));
    }
}
class $7c0e0aaea4b15c83$var$TableListItemEvent extends (0, $9b1rB.B) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let timeFormat = options.eventTimeFormat || $7c0e0aaea4b15c83$var$DEFAULT_TABLE_EVENT_TIME_FORMAT;
        let timeText = (0, $9b1rB.bO)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (0, $bvID6.createElement)((0, $9b1rB.ck), Object.assign({}, props, {
            elTag: "a",
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-dot-event'
            ],
            elAttrs: (0, $9b1rB.bS)(props.seg, context),
            defaultGenerator: $7c0e0aaea4b15c83$var$renderInnerContent,
            timeText: timeText,
            isResizing: false,
            isDateSelecting: false
        }));
    }
}
function $7c0e0aaea4b15c83$var$renderInnerContent(renderProps) {
    return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, (0, $bvID6.createElement)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $bvID6.createElement)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $bvID6.createElement)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $bvID6.createElement)((0, $bvID6.Fragment), null, "\u00A0")));
}
class $7c0e0aaea4b15c83$var$TableCellMoreLink extends (0, $9b1rB.B) {
    constructor(){
        super(...arguments);
        this.compileSegs = (0, $9b1rB.z)($7c0e0aaea4b15c83$var$compileSegs);
    }
    render() {
        let { props: props } = this;
        let { allSegs: allSegs, invisibleSegs: invisibleSegs } = this.compileSegs(props.singlePlacements);
        return (0, $bvID6.createElement)((0, $9b1rB.co), {
            elClasses: [
                'fc-daygrid-more-link'
            ],
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            allDayDate: props.allDayDate,
            moreCnt: props.moreCnt,
            allSegs: allSegs,
            hiddenSegs: invisibleSegs,
            alignmentElRef: props.alignmentElRef,
            alignGridTop: props.alignGridTop,
            extraDateSpan: props.extraDateSpan,
            popoverContent: ()=>{
                let isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, allSegs.map((seg)=>{
                    let instanceId = seg.eventRange.instance.instanceId;
                    return (0, $bvID6.createElement)("div", {
                        className: "fc-daygrid-event-harness",
                        key: instanceId,
                        style: {
                            visibility: isForcedInvisible[instanceId] ? 'hidden' : ''
                        }
                    }, $7c0e0aaea4b15c83$var$hasListItemDisplay(seg) ? (0, $bvID6.createElement)($7c0e0aaea4b15c83$var$TableListItemEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $9b1rB.bQ)(seg, props.todayRange))) : (0, $bvID6.createElement)($7c0e0aaea4b15c83$var$TableBlockEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $9b1rB.bQ)(seg, props.todayRange))));
                }));
            }
        });
    }
}
function $7c0e0aaea4b15c83$var$compileSegs(singlePlacements) {
    let allSegs = [];
    let invisibleSegs = [];
    for (let placement of singlePlacements){
        allSegs.push(placement.seg);
        if (!placement.isVisible) invisibleSegs.push(placement.seg);
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
const $7c0e0aaea4b15c83$var$DEFAULT_WEEK_NUM_FORMAT = (0, $9b1rB.x)({
    week: 'narrow'
});
class $7c0e0aaea4b15c83$var$TableCell extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $bvID6.createRef)();
        this.state = {
            dayNumberId: (0, $9b1rB.a3)()
        };
        this.handleRootEl = (el)=>{
            (0, $9b1rB.W)(this.rootElRef, el);
            (0, $9b1rB.W)(this.props.elRef, el);
        };
    }
    render() {
        let { context: context, props: props, state: state, rootElRef: rootElRef } = this;
        let { options: options, dateEnv: dateEnv } = context;
        let { date: date, dateProfile: dateProfile } = props;
        // TODO: memoize this?
        const isMonthStart = props.showDayNumber && $7c0e0aaea4b15c83$var$shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
        return (0, $bvID6.createElement)((0, $9b1rB.ci), {
            elTag: "td",
            elRef: this.handleRootEl,
            elClasses: [
                'fc-daygrid-day',
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                'aria-labelledby': state.dayNumberId
            } : {}), {
                role: 'gridcell'
            }),
            defaultGenerator: $7c0e0aaea4b15c83$var$renderTopInner,
            date: date,
            dateProfile: dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            isMonthStart: isMonthStart,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent, renderProps)=>(0, $bvID6.createElement)("div", {
                ref: props.innerElRef,
                className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                style: {
                    minHeight: props.minHeight
                }
            }, props.showWeekNumber && (0, $bvID6.createElement)((0, $9b1rB.cn), {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-week-number'
                ],
                elAttrs: (0, $9b1rB.a_)(context, date, 'week'),
                date: date,
                defaultFormat: $7c0e0aaea4b15c83$var$DEFAULT_WEEK_NUM_FORMAT
            }), !renderProps.isDisabled && (props.showDayNumber || (0, $9b1rB.cj)(options) || props.forceDayTop) ? (0, $bvID6.createElement)("div", {
                className: "fc-daygrid-day-top"
            }, (0, $bvID6.createElement)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-day-number',
                    isMonthStart && 'fc-daygrid-month-start'
                ],
                elAttrs: Object.assign(Object.assign({}, (0, $9b1rB.a_)(context, date)), {
                    id: state.dayNumberId
                })
            })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
            (0, $bvID6.createElement)("div", {
                className: "fc-daygrid-day-top",
                style: {
                    visibility: 'hidden'
                }
            }, (0, $bvID6.createElement)("a", {
                className: "fc-daygrid-day-number"
            }, "\u00A0")) : undefined, (0, $bvID6.createElement)("div", {
                className: "fc-daygrid-day-events",
                ref: props.fgContentElRef
            }, props.fgContent, (0, $bvID6.createElement)("div", {
                className: "fc-daygrid-day-bottom",
                style: {
                    marginTop: props.moreMarginTop
                }
            }, (0, $bvID6.createElement)($7c0e0aaea4b15c83$var$TableCellMoreLink, {
                allDayDate: date,
                singlePlacements: props.singlePlacements,
                moreCnt: props.moreCnt,
                alignmentElRef: rootElRef,
                alignGridTop: !props.showDayNumber,
                extraDateSpan: props.extraDateSpan,
                dateProfile: props.dateProfile,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                todayRange: props.todayRange
            }))), (0, $bvID6.createElement)("div", {
                className: "fc-daygrid-day-bg"
            }, props.bgContent)));
    }
}
function $7c0e0aaea4b15c83$var$renderTopInner(props) {
    return props.dayNumberText || (0, $bvID6.createElement)((0, $bvID6.Fragment), null, "\u00A0");
}
function $7c0e0aaea4b15c83$var$shouldDisplayMonthStart(date, currentRange, dateEnv) {
    const { start: currentStart, end: currentEnd } = currentRange;
    const currentEndIncl = (0, $9b1rB.be)(currentEnd, -1);
    const currentFirstYear = dateEnv.getYear(currentStart);
    const currentFirstMonth = dateEnv.getMonth(currentStart);
    const currentLastYear = dateEnv.getYear(currentEndIncl);
    const currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function $7c0e0aaea4b15c83$var$generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ':' + seg.firstCol;
}
function $7c0e0aaea4b15c83$var$generateSegUid(seg) {
    return $7c0e0aaea4b15c83$var$generateSegKey(seg) + ':' + seg.lastCol;
}
function $7c0e0aaea4b15c83$var$computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    let hierarchy = new $7c0e0aaea4b15c83$var$DayGridSegHierarchy((segEntry)=>{
        // TODO: more DRY with generateSegUid
        let segUid = segs[segEntry.index].eventRange.instance.instanceId + ':' + segEntry.span.start + ':' + (segEntry.span.end - 1);
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return segHeights[segUid] || 1;
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === 'number') hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === 'number') {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    let segInputs = [];
    let unknownHeightSegs = [];
    for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let segUid = $7c0e0aaea4b15c83$var$generateSegUid(seg);
        let eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let segRects = hierarchy.toRects();
    let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins } = $7c0e0aaea4b15c83$var$placeRects(segRects, segs, cells);
    let moreCnts = [];
    let moreMarginTops = [];
    // add segs with unknown heights
    for (let seg of unknownHeightSegs){
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
            seg: $7c0e0aaea4b15c83$var$resliceSeg(seg, col, col + 1, cells),
            isVisible: false,
            isAbsolute: false,
            absoluteTop: 0,
            marginTop: 0
        });
    }
    // add the hidden entries
    for(let col = 0; col < cells.length; col += 1)moreCnts.push(0);
    for (let hiddenEntry of hiddenEntries){
        let seg = segs[hiddenEntry.index];
        let hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: $7c0e0aaea4b15c83$var$resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: $7c0e0aaea4b15c83$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    }
    // deal with leftover margins
    for(let col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function $7c0e0aaea4b15c83$var$placeRects(allRects, segs, cells) {
    let rectsByEachCol = $7c0e0aaea4b15c83$var$groupRectsByEachCol(allRects, cells.length);
    let singleColPlacements = [];
    let multiColPlacements = [];
    let leftoverMargins = [];
    for(let col = 0; col < cells.length; col += 1){
        let rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        let singlePlacements = [];
        let currentHeight = 0;
        let currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            singlePlacements.push({
                seg: $7c0e0aaea4b15c83$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        let multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            let isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            let isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) multiPlacements.push({
                    seg: $7c0e0aaea4b15c83$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: true,
                    absoluteTop: rect.levelCoord,
                    marginTop: 0
                });
            } else if (isFirstCol) {
                multiPlacements.push({
                    seg: $7c0e0aaea4b15c83$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function $7c0e0aaea4b15c83$var$groupRectsByEachCol(rects, colCnt) {
    let rectsByEachCol = [];
    for(let col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    for (let rect of rects)for(let col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
    return rectsByEachCol;
}
function $7c0e0aaea4b15c83$var$resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    let eventRange = seg.eventRange;
    let origRange = eventRange.range;
    let slicedRange = (0, $9b1rB.o)(origRange, {
        start: cells[spanStart].date,
        end: (0, $9b1rB.t)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
class $7c0e0aaea4b15c83$var$DayGridSegHierarchy extends (0, $9b1rB.by) {
    constructor(){
        super(...arguments);
        // config
        this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        this.forceHidden = {};
    }
    addSegs(segInputs) {
        const hiddenSegs = super.addSegs(segInputs);
        const { entriesByLevel: entriesByLevel } = this;
        const excludeHidden = (entry)=>!this.forceHidden[(0, $9b1rB.bz)(entry)];
        // remove the forced-hidden segs
        for(let level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        return hiddenSegs;
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        const { entriesByLevel: entriesByLevel, forceHidden: forceHidden } = this;
        const { touchingEntry: touchingEntry, touchingLevel: touchingLevel, touchingLateral: touchingLateral } = insertion;
        // the entry that the new insertion is touching must be hidden
        if (this.hiddenConsumes && touchingEntry) {
            const touchingEntryId = (0, $9b1rB.bz)(touchingEntry);
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    // split up the touchingEntry, reinsert it
                    const hiddenEntry = Object.assign(Object.assign({}, touchingEntry), {
                        span: (0, $9b1rB.bD)(touchingEntry.span, entry.span)
                    });
                    // reinsert the area that turned into a "more" link (so no other entries try to
                    // occupy the space) but mark it forced-hidden
                    const hiddenEntryId = (0, $9b1rB.bz)(hiddenEntry);
                    forceHidden[hiddenEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = hiddenEntry;
                    hiddenEntries.push(hiddenEntry);
                    this.splitEntry(touchingEntry, entry, hiddenEntries);
                } else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        // will try to reslice...
        super.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
}
class $7c0e0aaea4b15c83$var$TableRow extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.cellElRefs = new (0, $9b1rB.cd)(); // the <td>
        this.frameElRefs = new (0, $9b1rB.cd)(); // the fc-daygrid-day-frame
        this.fgElRefs = new (0, $9b1rB.cd)(); // the fc-daygrid-day-events
        this.segHarnessRefs = new (0, $9b1rB.cd)(); // indexed by "instanceId:firstCol"
        this.rootElRef = (0, $bvID6.createRef)();
        this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        this.handleResize = (isForced)=>{
            if (isForced) this.updateSizing(true); // isExternal=true
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let { options: options } = context;
        let colCnt = props.cells.length;
        let businessHoursByCol = $7c0e0aaea4b15c83$var$splitSegsByFirstCol(props.businessHourSegs, colCnt);
        let bgEventSegsByCol = $7c0e0aaea4b15c83$var$splitSegsByFirstCol(props.bgEventSegs, colCnt);
        let highlightSegsByCol = $7c0e0aaea4b15c83$var$splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        let mirrorSegsByCol = $7c0e0aaea4b15c83$var$splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops } = $7c0e0aaea4b15c83$var$computeFgSegPlacement((0, $9b1rB.bP)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells);
        let isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        return (0, $bvID6.createElement)("tr", {
            ref: this.rootElRef,
            role: "row"
        }, props.renderIntro && props.renderIntro(), props.cells.map((cell, col)=>{
            let normalFgNodes = this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
            let mirrorFgNodes = this.renderFgSegs(col, $7c0e0aaea4b15c83$var$buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
            return (0, $bvID6.createElement)($7c0e0aaea4b15c83$var$TableCell, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                innerElRef: this.frameElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                showDayNumber: props.showDayNumbers,
                showWeekNumber: props.showWeekNumbers && col === 0,
                forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                todayRange: props.todayRange,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                moreCnt: moreCnts[col],
                moreMarginTop: moreMarginTops[col],
                singlePlacements: singleColPlacements[col],
                fgContentElRef: this.fgElRefs.createRef(cell.key),
                fgContent: (0, $bvID6.createElement)((0, $bvID6.Fragment), null, (0, $bvID6.createElement)((0, $bvID6.Fragment), null, normalFgNodes), (0, $bvID6.createElement)((0, $bvID6.Fragment), null, mirrorFgNodes)),
                bgContent: (0, $bvID6.createElement)((0, $bvID6.Fragment), null, this.renderFillSegs(highlightSegsByCol[col], 'highlight'), this.renderFillSegs(businessHoursByCol[col], 'non-business'), this.renderFillSegs(bgEventSegsByCol[col], 'bg-event')),
                minHeight: props.cellMinHeight
            });
        }));
    }
    componentDidMount() {
        this.updateSizing(true);
        this.context.addResizeHandler(this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        let currentProps = this.props;
        this.updateSizing(!(0, $9b1rB.E)(prevProps, currentProps));
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    getHighlightSegs() {
        let { props: props } = this;
        if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return props.dateSelectionSegs;
    }
    getMirrorSegs() {
        let { props: props } = this;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return [];
    }
    renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        let { context: context } = this;
        let { eventSelection: eventSelection } = this.props;
        let { framePositions: framePositions } = this.state;
        let defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        let isMirror = isDragging || isResizing || isDateSelecting;
        let nodes = [];
        if (framePositions) for (let placement of segPlacements){
            let { seg: seg } = placement;
            let { instanceId: instanceId } = seg.eventRange.instance;
            let isVisible = placement.isVisible && !isForcedInvisible[instanceId];
            let isAbsolute = placement.isAbsolute;
            let left = '';
            let right = '';
            if (isAbsolute) {
                if (context.isRtl) {
                    right = 0;
                    left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                } else {
                    left = 0;
                    right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                }
            }
            /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $bvID6.createElement)("div", {
                className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''),
                key: $7c0e0aaea4b15c83$var$generateSegKey(seg),
                ref: isMirror ? null : this.segHarnessRefs.createRef($7c0e0aaea4b15c83$var$generateSegUid(seg)),
                style: {
                    visibility: isVisible ? '' : 'hidden',
                    marginTop: isAbsolute ? '' : placement.marginTop,
                    top: isAbsolute ? placement.absoluteTop : '',
                    left: left,
                    right: right
                }
            }, $7c0e0aaea4b15c83$var$hasListItemDisplay(seg) ? (0, $bvID6.createElement)($7c0e0aaea4b15c83$var$TableListItemEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $9b1rB.bQ)(seg, todayRange))) : (0, $bvID6.createElement)($7c0e0aaea4b15c83$var$TableBlockEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $9b1rB.bQ)(seg, todayRange)))));
        }
        return nodes;
    }
    renderFillSegs(segs, fillType) {
        let { isRtl: isRtl } = this.context;
        let { todayRange: todayRange } = this.props;
        let { framePositions: framePositions } = this.state;
        let nodes = [];
        if (framePositions) for (let seg of segs){
            let leftRightCss = isRtl ? {
                right: 0,
                left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
            } : {
                left: 0,
                right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
            };
            nodes.push((0, $bvID6.createElement)("div", {
                key: (0, $9b1rB.bR)(seg.eventRange),
                className: "fc-daygrid-bg-harness",
                style: leftRightCss
            }, fillType === 'bg-event' ? (0, $bvID6.createElement)((0, $9b1rB.cm), Object.assign({
                seg: seg
            }, (0, $9b1rB.bQ)(seg, todayRange))) : (0, $9b1rB.cl)(fillType)));
        }
        return (0, $bvID6.createElement)((0, $bvID6.Fragment), {}, ...nodes);
    }
    updateSizing(isExternalSizingChange) {
        let { props: props, state: state, frameElRefs: frameElRefs } = this;
        if (!props.forPrint && props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                let frameEls = props.cells.map((cell)=>frameElRefs.currentMap[cell.key]);
                if (frameEls.length) {
                    let originEl = this.rootElRef.current;
                    let newPositionCache = new (0, $9b1rB.b8)(originEl, frameEls, true, false);
                    if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                        framePositions: new (0, $9b1rB.b8)(originEl, frameEls, true, false)
                    });
                }
            }
            const oldSegHeights = this.state.segHeights;
            const newSegHeights = this.querySegHeights();
            const limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.safeSetState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
            });
        }
    }
    querySegHeights() {
        let segElMap = this.segHarnessRefs.currentMap;
        let segHeights = {};
        // get the max height amongst instance segs
        for(let segUid in segElMap){
            let height = Math.round(segElMap[segUid].getBoundingClientRect().height);
            segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
        }
        return segHeights;
    }
    computeMaxContentHeight() {
        let firstKey = this.props.cells[0].key;
        let cellEl = this.cellElRefs.currentMap[firstKey];
        let fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    }
    getCellEls() {
        let elMap = this.cellElRefs.currentMap;
        return this.props.cells.map((cell)=>elMap[cell.key]);
    }
}
$7c0e0aaea4b15c83$var$TableRow.addStateEquality({
    segHeights: (0, $9b1rB.E)
});
function $7c0e0aaea4b15c83$var$buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    let topsByInstanceId = $7c0e0aaea4b15c83$var$buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map((seg)=>({
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        }));
}
function $7c0e0aaea4b15c83$var$buildAbsoluteTopHash(colPlacements) {
    let topsByInstanceId = {};
    for (let placements of colPlacements)for (let placement of placements)topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
    return topsByInstanceId;
}
class $7c0e0aaea4b15c83$export$d955b1c53830e05a extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.splitBusinessHourSegs = (0, $9b1rB.z)($7c0e0aaea4b15c83$var$splitSegsByRow);
        this.splitBgEventSegs = (0, $9b1rB.z)($7c0e0aaea4b15c83$var$splitAllDaySegsByRow);
        this.splitFgEventSegs = (0, $9b1rB.z)($7c0e0aaea4b15c83$var$splitSegsByRow);
        this.splitDateSelectionSegs = (0, $9b1rB.z)($7c0e0aaea4b15c83$var$splitSegsByRow);
        this.splitEventDrag = (0, $9b1rB.z)($7c0e0aaea4b15c83$var$splitInteractionByRow);
        this.splitEventResize = (0, $9b1rB.z)($7c0e0aaea4b15c83$var$splitInteractionByRow);
        this.rowRefs = new (0, $9b1rB.cd)();
    }
    render() {
        let { props: props, context: context } = this;
        let rowCnt = props.cells.length;
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
        // choose 7 because a month view will have max 6 rows
        let cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
        return (0, $bvID6.createElement)((0, $9b1rB.a6), {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $bvID6.createElement)((0, $bvID6.Fragment), null, props.cells.map((cells, row)=>(0, $bvID6.createElement)($7c0e0aaea4b15c83$var$TableRow, {
                    ref: this.rowRefs.createRef(row),
                    key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                    ,
                    showDayNumbers: rowCnt > 1,
                    showWeekNumbers: props.showWeekNumbers,
                    todayRange: todayRange,
                    dateProfile: props.dateProfile,
                    cells: cells,
                    renderIntro: props.renderRowIntro,
                    businessHourSegs: businessHourSegsByRow[row],
                    eventSelection: props.eventSelection,
                    bgEventSegs: bgEventSegsByRow[row],
                    fgEventSegs: fgEventSegsByRow[row],
                    dateSelectionSegs: dateSelectionSegsByRow[row],
                    eventDrag: eventDragByRow[row],
                    eventResize: eventResizeByRow[row],
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    cellMinHeight: cellMinHeight,
                    forPrint: props.forPrint
                }))));
    }
    componentDidMount() {
        this.registerInteractiveComponent();
    }
    componentDidUpdate() {
        // for if started with zero cells
        this.registerInteractiveComponent();
    }
    registerInteractiveComponent() {
        if (!this.rootEl) {
            // HACK: need a daygrid wrapper parent to do positioning
            // NOTE: a daygrid resource view w/o resources can have zero cells
            const firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
            const rootEl = firstCellEl ? firstCellEl.closest('.fc-daygrid-body') : null;
            if (rootEl) {
                this.rootEl = rootEl;
                this.context.registerInteractiveComponent(this, {
                    el: rootEl,
                    isHitComboAllowed: this.props.isHitComboAllowed
                });
            }
        }
    }
    componentWillUnmount() {
        if (this.rootEl) {
            this.context.unregisterInteractiveComponent(this);
            this.rootEl = null;
        }
    }
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    prepareHits() {
        this.rowPositions = new (0, $9b1rB.b8)(this.rootEl, this.rowRefs.collect().map((rowObj)=>rowObj.getCellEls()[0]), false, true);
        this.colPositions = new (0, $9b1rB.b8)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
    }
    queryHit(positionLeft, positionTop) {
        let { colPositions: colPositions, rowPositions: rowPositions } = this;
        let col = colPositions.leftToIndex(positionLeft);
        let row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            let cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: Object.assign({
                    range: this.getCellRange(row, col),
                    allDay: true
                }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row]
                },
                layer: 0
            };
        }
        return null;
    }
    getCellEl(row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    }
    getCellRange(row, col) {
        let start = this.props.cells[row][col].date;
        let end = (0, $9b1rB.t)(start, 1);
        return {
            start: start,
            end: end
        };
    }
}
function $7c0e0aaea4b15c83$var$splitAllDaySegsByRow(segs, rowCnt) {
    return $7c0e0aaea4b15c83$var$splitSegsByRow(segs.filter($7c0e0aaea4b15c83$var$isSegAllDay), rowCnt);
}
function $7c0e0aaea4b15c83$var$isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
class $7c0e0aaea4b15c83$export$54ec01a60f47d33d extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.elRef = (0, $bvID6.createRef)();
        this.needsScrollReset = false;
    }
    render() {
        let { props: props } = this;
        let { dayMaxEventRows: dayMaxEventRows, dayMaxEvents: dayMaxEvents, expandRows: expandRows } = props;
        let limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        let classNames = [
            'fc-daygrid-body',
            limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
            expandRows ? '' : 'fc-daygrid-body-natural'
        ];
        return (0, $bvID6.createElement)("div", {
            ref: this.elRef,
            className: classNames.join(' '),
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $bvID6.createElement)("table", {
            role: "presentation",
            className: "fc-scrollgrid-sync-table",
            style: {
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
                height: expandRows ? props.clientHeight : ''
            }
        }, props.colGroupNode, (0, $bvID6.createElement)("tbody", {
            role: "presentation"
        }, (0, $bvID6.createElement)($7c0e0aaea4b15c83$export$d955b1c53830e05a, {
            dateProfile: props.dateProfile,
            cells: props.cells,
            renderRowIntro: props.renderRowIntro,
            showWeekNumbers: props.showWeekNumbers,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows,
            forPrint: props.forPrint,
            isHitComboAllowed: props.isHitComboAllowed
        }))));
    }
    componentDidMount() {
        this.requestScrollReset();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
        else this.flushScrollReset();
    }
    requestScrollReset() {
        this.needsScrollReset = true;
        this.flushScrollReset();
    }
    flushScrollReset() {
        if (this.needsScrollReset && this.props.clientWidth // sizes computed?
        ) {
            const subjectEl = $7c0e0aaea4b15c83$var$getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
            if (subjectEl) {
                const originEl = subjectEl.closest('.fc-daygrid-body');
                const scrollEl = originEl.closest('.fc-scroller');
                const scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
            }
            this.needsScrollReset = false;
        }
    }
}
function $7c0e0aaea4b15c83$var$getScrollSubjectEl(containerEl, dateProfile) {
    let el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector(`[data-date="${(0, $9b1rB.bv)(dateProfile.currentDate)}-01"]`);
    if (!el) el = containerEl.querySelector(`[data-date="${(0, $9b1rB.bt)(dateProfile.currentDate)}"]`);
    return el;
}
class $7c0e0aaea4b15c83$export$eb38be9553e58392 extends (0, $9b1rB.bU) {
    constructor(){
        super(...arguments);
        this.forceDayIfListItem = true;
    }
    sliceRange(dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    }
}
class $7c0e0aaea4b15c83$export$cd402b7558adf371 extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.slicer = new $7c0e0aaea4b15c83$export$eb38be9553e58392();
        this.tableRef = (0, $bvID6.createRef)();
    }
    render() {
        let { props: props, context: context } = this;
        return (0, $bvID6.createElement)($7c0e0aaea4b15c83$export$54ec01a60f47d33d, Object.assign({
            ref: this.tableRef
        }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
            dateProfile: props.dateProfile,
            cells: props.dayTableModel.cells,
            colGroupNode: props.colGroupNode,
            tableMinWidth: props.tableMinWidth,
            renderRowIntro: props.renderRowIntro,
            dayMaxEvents: props.dayMaxEvents,
            dayMaxEventRows: props.dayMaxEventRows,
            showWeekNumbers: props.showWeekNumbers,
            expandRows: props.expandRows,
            headerAlignElRef: props.headerAlignElRef,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: props.forPrint
        }));
    }
}
class $7c0e0aaea4b15c83$export$39eed66de95896e5 extends $7c0e0aaea4b15c83$export$b3c27e869d856b7 {
    constructor(){
        super(...arguments);
        this.buildDayTableModel = (0, $9b1rB.z)($7c0e0aaea4b15c83$export$61e79f95d746b006);
        this.headerRef = (0, $bvID6.createRef)();
        this.tableRef = (0, $bvID6.createRef)();
    // can't override any lifecycle methods from parent
    }
    render() {
        let { options: options, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        let headerContent = options.dayHeaders && (0, $bvID6.createElement)((0, $9b1rB.bI), {
            ref: this.headerRef,
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: dayTableModel.rowCnt === 1
        });
        let bodyContent = (contentArg)=>(0, $bvID6.createElement)($7c0e0aaea4b15c83$export$cd402b7558adf371, {
                ref: this.tableRef,
                dateProfile: props.dateProfile,
                dayTableModel: dayTableModel,
                businessHours: props.businessHours,
                dateSelection: props.dateSelection,
                eventStore: props.eventStore,
                eventUiBases: props.eventUiBases,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                nextDayThreshold: options.nextDayThreshold,
                colGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                dayMaxEvents: options.dayMaxEvents,
                dayMaxEventRows: options.dayMaxEventRows,
                showWeekNumbers: options.weekNumbers,
                expandRows: !props.isHeightAuto,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            });
        return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    }
}
function $7c0e0aaea4b15c83$export$61e79f95d746b006(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $9b1rB.bM)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $9b1rB.bT)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
class $7c0e0aaea4b15c83$export$9fcce6e2d16ec31d extends (0, $9b1rB.R) {
    // Computes the date range that will be rendered
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        let renderRange = super.buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay);
        let { props: props } = this;
        return $7c0e0aaea4b15c83$export$a2ad67969be9f247({
            currentRange: renderRange,
            snapToWeek: /^(year|month)$/.test(currentRangeUnit),
            fixedWeekCount: props.fixedWeekCount,
            dateEnv: props.dateEnv
        });
    }
}
function $7c0e0aaea4b15c83$export$a2ad67969be9f247(props) {
    let { dateEnv: dateEnv, currentRange: currentRange } = props;
    let { start: start, end: end } = currentRange;
    let endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $9b1rB.bf)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        let lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $9b1rB.t)(currentRange.end, -1)));
        let rowCnt = Math.ceil((0, $9b1rB.bg)(lastMonthRenderStart, end));
        end = (0, $9b1rB.bf)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
var $7c0e0aaea4b15c83$var$css_248z = ":root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}";
(0, $9b1rB.ct)($7c0e0aaea4b15c83$var$css_248z);

});


parcelRegister("a3lgF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $751aae86ca9d8125$export$2e2bcd8739ae039; });

var $jnteQ = parcelRequire("jnteQ");

var $5BOXS = parcelRequire("5BOXS");



const $751aae86ca9d8125$var$OPTION_REFINERS = {
    allDaySlot: Boolean
};
var $751aae86ca9d8125$export$2e2bcd8739ae039 = (0, $jnteQ.createPlugin)({
    name: '@fullcalendar/timegrid',
    initialView: 'timeGridWeek',
    optionRefiners: $751aae86ca9d8125$var$OPTION_REFINERS,
    views: {
        timeGrid: {
            component: (0, $5BOXS.DayTimeColsView),
            usesMinMaxTime: true,
            allDaySlot: true,
            slotDuration: '00:30:00',
            slotEventOverlap: true
        },
        timeGridDay: {
            type: 'timeGrid',
            duration: {
                days: 1
            }
        },
        timeGridWeek: {
            type: 'timeGrid',
            duration: {
                weeks: 1
            }
        }
    }
});

});
parcelRegister("5BOXS", function(module, exports) {

$parcel$export(module.exports, "DayTimeColsView", function () { return $4157f0f8015cdf85$export$4b78a540ee976f33; });

var $9b1rB = parcelRequire("9b1rB");

var $bvID6 = parcelRequire("bvID6");

var $aEl91 = parcelRequire("aEl91");
class $4157f0f8015cdf85$var$AllDaySplitter extends (0, $9b1rB.aW) {
    getKeyInfo() {
        return {
            allDay: {},
            timed: {}
        };
    }
    getKeysForDateSpan(dateSpan) {
        if (dateSpan.allDay) return [
            'allDay'
        ];
        return [
            'timed'
        ];
    }
    getKeysForEventDef(eventDef) {
        if (!eventDef.allDay) return [
            'timed'
        ];
        if ((0, $9b1rB.bN)(eventDef)) return [
            'timed',
            'allDay'
        ];
        return [
            'allDay'
        ];
    }
}
const $4157f0f8015cdf85$var$DEFAULT_SLAT_LABEL_FORMAT = (0, $9b1rB.x)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'short'
});
function $4157f0f8015cdf85$var$TimeColsAxisCell(props) {
    let classNames = [
        'fc-timegrid-slot',
        'fc-timegrid-slot-label',
        props.isLabeled ? 'fc-scrollgrid-shrink' : 'fc-timegrid-slot-minor'
    ];
    return (0, $bvID6.createElement)((0, $9b1rB.V).Consumer, null, (context)=>{
        if (!props.isLabeled) return (0, $bvID6.createElement)("td", {
            className: classNames.join(' '),
            "data-time": props.isoTimeStr
        });
        let { dateEnv: dateEnv, options: options, viewApi: viewApi } = context;
        let labelFormat = options.slotLabelFormat == null ? $4157f0f8015cdf85$var$DEFAULT_SLAT_LABEL_FORMAT : Array.isArray(options.slotLabelFormat) ? (0, $9b1rB.x)(options.slotLabelFormat[0]) : (0, $9b1rB.x)(options.slotLabelFormat);
        let renderProps = {
            level: 0,
            time: props.time,
            date: dateEnv.toDate(props.date),
            view: viewApi,
            text: dateEnv.format(props.date, labelFormat)
        };
        return (0, $bvID6.createElement)((0, $9b1rB.C), {
            elTag: "td",
            elClasses: classNames,
            elAttrs: {
                'data-time': props.isoTimeStr
            },
            renderProps: renderProps,
            generatorName: "slotLabelContent",
            customGenerator: options.slotLabelContent,
            defaultGenerator: $4157f0f8015cdf85$var$renderInnerContent,
            classNameGenerator: options.slotLabelClassNames,
            didMount: options.slotLabelDidMount,
            willUnmount: options.slotLabelWillUnmount
        }, (InnerContent)=>(0, $bvID6.createElement)("div", {
                className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame"
            }, (0, $bvID6.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-slot-label-cushion',
                    'fc-scrollgrid-shrink-cushion'
                ]
            })));
    });
}
function $4157f0f8015cdf85$var$renderInnerContent(props) {
    return props.text;
}
class $4157f0f8015cdf85$var$TimeBodyAxis extends (0, $9b1rB.B) {
    render() {
        return this.props.slatMetas.map((slatMeta)=>(0, $bvID6.createElement)("tr", {
                key: slatMeta.key
            }, (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeColsAxisCell, Object.assign({}, slatMeta))));
    }
}
const $4157f0f8015cdf85$var$DEFAULT_WEEK_NUM_FORMAT = (0, $9b1rB.x)({
    week: 'short'
});
const $4157f0f8015cdf85$var$AUTO_ALL_DAY_MAX_EVENT_ROWS = 5;
class $4157f0f8015cdf85$export$667ac525945c6ff8 extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.allDaySplitter = new $4157f0f8015cdf85$var$AllDaySplitter(); // for use by subclasses
        this.headerElRef = (0, $bvID6.createRef)();
        this.rootElRef = (0, $bvID6.createRef)();
        this.scrollerElRef = (0, $bvID6.createRef)();
        this.state = {
            slatCoords: null
        };
        this.handleScrollTopRequest = (scrollTop)=>{
            let scrollerEl = this.scrollerElRef.current;
            if (scrollerEl) scrollerEl.scrollTop = scrollTop;
        };
        /* Header Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ this.renderHeadAxis = (rowKey, frameHeight = '')=>{
            let { options: options } = this.context;
            let { dateProfile: dateProfile } = this.props;
            let range = dateProfile.renderRange;
            let dayCnt = (0, $9b1rB.bj)(range.start, range.end);
            // only do in day views (to avoid doing in week views that dont need it)
            let navLinkAttrs = dayCnt === 1 ? (0, $9b1rB.a_)(this.context, range.start, 'week') : {};
            if (options.weekNumbers && rowKey === 'day') return (0, $bvID6.createElement)((0, $9b1rB.cn), {
                elTag: "th",
                elClasses: [
                    'fc-timegrid-axis',
                    'fc-scrollgrid-shrink'
                ],
                elAttrs: {
                    'aria-hidden': true
                },
                date: range.start,
                defaultFormat: $4157f0f8015cdf85$var$DEFAULT_WEEK_NUM_FORMAT
            }, (InnerContent)=>(0, $bvID6.createElement)("div", {
                    className: [
                        'fc-timegrid-axis-frame',
                        'fc-scrollgrid-shrink-frame',
                        'fc-timegrid-axis-frame-liquid'
                    ].join(' '),
                    style: {
                        height: frameHeight
                    }
                }, (0, $bvID6.createElement)(InnerContent, {
                    elTag: "a",
                    elClasses: [
                        'fc-timegrid-axis-cushion',
                        'fc-scrollgrid-shrink-cushion',
                        'fc-scrollgrid-sync-inner'
                    ],
                    elAttrs: navLinkAttrs
                })));
            return (0, $bvID6.createElement)("th", {
                "aria-hidden": true,
                className: "fc-timegrid-axis"
            }, (0, $bvID6.createElement)("div", {
                className: "fc-timegrid-axis-frame",
                style: {
                    height: frameHeight
                }
            }));
        };
        /* Table Component Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ // only a one-way height sync. we don't send the axis inner-content height to the DayGrid,
        // but DayGrid still needs to have classNames on inner elements in order to measure.
        this.renderTableRowAxis = (rowHeight)=>{
            let { options: options, viewApi: viewApi } = this.context;
            let renderProps = {
                text: options.allDayText,
                view: viewApi
            };
            return(// TODO: make reusable hook. used in list view too
            (0, $bvID6.createElement)((0, $9b1rB.C), {
                elTag: "td",
                elClasses: [
                    'fc-timegrid-axis',
                    'fc-scrollgrid-shrink'
                ],
                elAttrs: {
                    'aria-hidden': true
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: $4157f0f8015cdf85$var$renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            }, (InnerContent)=>(0, $bvID6.createElement)("div", {
                    className: [
                        'fc-timegrid-axis-frame',
                        'fc-scrollgrid-shrink-frame',
                        rowHeight == null ? ' fc-timegrid-axis-frame-liquid' : ''
                    ].join(' '),
                    style: {
                        height: rowHeight
                    }
                }, (0, $bvID6.createElement)(InnerContent, {
                    elTag: "span",
                    elClasses: [
                        'fc-timegrid-axis-cushion',
                        'fc-scrollgrid-shrink-cushion',
                        'fc-scrollgrid-sync-inner'
                    ]
                }))));
        };
        this.handleSlatCoords = (slatCoords)=>{
            this.setState({
                slatCoords: slatCoords
            });
        };
    }
    // rendering
    // ----------------------------------------------------------------------------------------------------
    renderSimpleLayout(headerRowContent, allDayContent, timeContent) {
        let { context: context, props: props } = this;
        let sections = [];
        let stickyHeaderDates = (0, $9b1rB.ca)(context.options);
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: 'fc-col-header',
                rowContent: headerRowContent
            }
        });
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                chunk: {
                    content: allDayContent
                }
            });
            sections.push({
                type: 'body',
                key: 'all-day-divider',
                outerContent: (0, $bvID6.createElement)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $bvID6.createElement)("td", {
                    className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded')
                }))
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunk: {
                scrollerElRef: this.scrollerElRef,
                content: timeContent
            }
        });
        return (0, $bvID6.createElement)((0, $9b1rB.cq), {
            elRef: this.rootElRef,
            elClasses: [
                'fc-timegrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $bvID6.createElement)((0, $9b1rB.bZ), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [
                {
                    width: 'shrink'
                }
            ],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, allDayContent, timeContent, colCnt, dayMinWidth, slatMetas, slatCoords) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
        let { context: context, props: props } = this;
        let stickyHeaderDates = !props.forPrint && (0, $9b1rB.ca)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $9b1rB.c9)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            syncRowHeights: true,
            chunks: [
                {
                    key: 'axis',
                    rowContent: (arg)=>(0, $bvID6.createElement)("tr", {
                            role: "presentation"
                        }, this.renderHeadAxis('day', arg.rowSyncHeights[0]))
                },
                {
                    key: 'cols',
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            ]
        });
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                syncRowHeights: true,
                chunks: [
                    {
                        key: 'axis',
                        rowContent: (contentArg)=>(0, $bvID6.createElement)("tr", {
                                role: "presentation"
                            }, this.renderTableRowAxis(contentArg.rowSyncHeights[0]))
                    },
                    {
                        key: 'cols',
                        content: allDayContent
                    }
                ]
            });
            sections.push({
                key: 'all-day-divider',
                type: 'body',
                outerContent: (0, $bvID6.createElement)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $bvID6.createElement)("td", {
                    colSpan: 2,
                    className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded')
                }))
            });
        }
        let isNowIndicator = context.options.nowIndicator;
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunks: [
                {
                    key: 'axis',
                    content: (arg)=>// TODO: make this now-indicator arrow more DRY with TimeColsContent
                        (0, $bvID6.createElement)("div", {
                            className: "fc-timegrid-axis-chunk"
                        }, (0, $bvID6.createElement)("table", {
                            "aria-hidden": true,
                            style: {
                                height: arg.expandRows ? arg.clientHeight : ''
                            }
                        }, arg.tableColGroupNode, (0, $bvID6.createElement)("tbody", null, (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeBodyAxis, {
                            slatMetas: slatMetas
                        }))), (0, $bvID6.createElement)("div", {
                            className: "fc-timegrid-now-indicator-container"
                        }, (0, $bvID6.createElement)((0, $9b1rB.a6), {
                            unit: isNowIndicator ? 'minute' : 'day' /* hacky */ 
                        }, (nowDate)=>{
                            let nowIndicatorTop = isNowIndicator && slatCoords && slatCoords.safeComputeTop(nowDate); // might return void
                            if (typeof nowIndicatorTop === 'number') return (0, $bvID6.createElement)((0, $9b1rB.ch), {
                                elClasses: [
                                    'fc-timegrid-now-indicator-arrow'
                                ],
                                elStyle: {
                                    top: nowIndicatorTop
                                },
                                isAxis: true,
                                date: nowDate
                            });
                            return null;
                        })))
                },
                {
                    key: 'cols',
                    scrollerElRef: this.scrollerElRef,
                    content: timeContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            key: 'footer',
            type: 'footer',
            isSticky: true,
            chunks: [
                {
                    key: 'axis',
                    content: (0, $9b1rB.c8)
                },
                {
                    key: 'cols',
                    content: (0, $9b1rB.c8)
                }
            ]
        });
        return (0, $bvID6.createElement)((0, $9b1rB.cq), {
            elRef: this.rootElRef,
            elClasses: [
                'fc-timegrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $bvID6.createElement)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: false,
            colGroups: [
                {
                    width: 'shrink',
                    cols: [
                        {
                            width: 'shrink'
                        }
                    ]
                },
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/ getAllDayMaxEventProps() {
        let { dayMaxEvents: dayMaxEvents, dayMaxEventRows: dayMaxEventRows } = this.context.options;
        if (dayMaxEvents === true || dayMaxEventRows === true) {
            dayMaxEvents = undefined;
            dayMaxEventRows = $4157f0f8015cdf85$var$AUTO_ALL_DAY_MAX_EVENT_ROWS; // make sure "auto" goes to a real number
        }
        return {
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows
        };
    }
}
function $4157f0f8015cdf85$var$renderAllDayInner(renderProps) {
    return renderProps.text;
}
class $4157f0f8015cdf85$export$bbb5c25f46ae511d {
    constructor(positions, dateProfile, slotDuration){
        this.positions = positions;
        this.dateProfile = dateProfile;
        this.slotDuration = slotDuration;
    }
    safeComputeTop(date) {
        let { dateProfile: dateProfile } = this;
        if ((0, $9b1rB.G)(dateProfile.currentRange, date)) {
            let startOfDayDate = (0, $9b1rB.q)(date);
            let timeMs = date.valueOf() - startOfDayDate.valueOf();
            if (timeMs >= (0, $9b1rB.bq)(dateProfile.slotMinTime) && timeMs < (0, $9b1rB.bq)(dateProfile.slotMaxTime)) return this.computeTimeTop((0, $9b1rB.d)(timeMs));
        }
        return null;
    }
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    computeDateTop(when, startOfDayDate) {
        if (!startOfDayDate) startOfDayDate = (0, $9b1rB.q)(when);
        return this.computeTimeTop((0, $9b1rB.d)(when.valueOf() - startOfDayDate.valueOf()));
    }
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
    // Eventually allow computation with arbirary slat dates.
    computeTimeTop(duration) {
        let { positions: positions, dateProfile: dateProfile } = this;
        let len = positions.els.length;
        // floating-point value of # of slots covered
        let slatCoverage = (duration.milliseconds - (0, $9b1rB.bq)(dateProfile.slotMinTime)) / (0, $9b1rB.bq)(this.slotDuration);
        let slatIndex;
        let slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because slotMinTime/slotMaxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return positions.tops[slatIndex] + positions.getHeight(slatIndex) * slatRemainder;
    }
}
class $4157f0f8015cdf85$var$TimeColsSlatsBody extends (0, $9b1rB.B) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { slatElRefs: slatElRefs } = props;
        return (0, $bvID6.createElement)("tbody", null, props.slatMetas.map((slatMeta, i)=>{
            let renderProps = {
                time: slatMeta.time,
                date: context.dateEnv.toDate(slatMeta.date),
                view: context.viewApi
            };
            return (0, $bvID6.createElement)("tr", {
                key: slatMeta.key,
                ref: slatElRefs.createRef(slatMeta.key)
            }, props.axis && (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeColsAxisCell, Object.assign({}, slatMeta)), (0, $bvID6.createElement)((0, $9b1rB.C), {
                elTag: "td",
                elClasses: [
                    'fc-timegrid-slot',
                    'fc-timegrid-slot-lane',
                    !slatMeta.isLabeled && 'fc-timegrid-slot-minor'
                ],
                elAttrs: {
                    'data-time': slatMeta.isoTimeStr
                },
                renderProps: renderProps,
                generatorName: "slotLaneContent",
                customGenerator: options.slotLaneContent,
                classNameGenerator: options.slotLaneClassNames,
                didMount: options.slotLaneDidMount,
                willUnmount: options.slotLaneWillUnmount
            }));
        }));
    }
}
/*
for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
*/ class $4157f0f8015cdf85$var$TimeColsSlats extends (0, $9b1rB.B) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $bvID6.createRef)();
        this.slatElRefs = new (0, $9b1rB.cd)();
    }
    render() {
        let { props: props, context: context } = this;
        return (0, $bvID6.createElement)("div", {
            ref: this.rootElRef,
            className: "fc-timegrid-slots"
        }, (0, $bvID6.createElement)("table", {
            "aria-hidden": true,
            className: context.theme.getClass('table'),
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth,
                height: props.minHeight
            }
        }, props.tableColGroupNode /* relies on there only being a single <col> for the axis */ , (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeColsSlatsBody, {
            slatElRefs: this.slatElRefs,
            axis: props.axis,
            slatMetas: props.slatMetas
        })));
    }
    componentDidMount() {
        this.updateSizing();
    }
    componentDidUpdate() {
        this.updateSizing();
    }
    componentWillUnmount() {
        if (this.props.onCoords) this.props.onCoords(null);
    }
    updateSizing() {
        let { context: context, props: props } = this;
        if (props.onCoords && props.clientWidth !== null // means sizing has stabilized
        ) {
            let rootEl = this.rootElRef.current;
            if (rootEl.offsetHeight) props.onCoords(new $4157f0f8015cdf85$export$bbb5c25f46ae511d(new (0, $9b1rB.b8)(this.rootElRef.current, $4157f0f8015cdf85$var$collectSlatEls(this.slatElRefs.currentMap, props.slatMetas), false, true), this.props.dateProfile, context.options.slotDuration));
        }
    }
}
function $4157f0f8015cdf85$var$collectSlatEls(elMap, slatMetas) {
    return slatMetas.map((slatMeta)=>elMap[slatMeta.key]);
}
function $4157f0f8015cdf85$var$splitSegsByCol(segs, colCnt) {
    let segsByCol = [];
    let i;
    for(i = 0; i < colCnt; i += 1)segsByCol.push([]);
    if (segs) for(i = 0; i < segs.length; i += 1)segsByCol[segs[i].col].push(segs[i]);
    return segsByCol;
}
function $4157f0f8015cdf85$var$splitInteractionByCol(ui, colCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < colCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < colCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.col].segs.push(seg);
    }
    return byRow;
}
class $4157f0f8015cdf85$var$TimeColMoreLink extends (0, $9b1rB.B) {
    render() {
        let { props: props } = this;
        return (0, $bvID6.createElement)((0, $9b1rB.co), {
            elClasses: [
                'fc-timegrid-more-link'
            ],
            elStyle: {
                top: props.top,
                bottom: props.bottom
            },
            allDayDate: null,
            moreCnt: props.hiddenSegs.length,
            allSegs: props.hiddenSegs,
            hiddenSegs: props.hiddenSegs,
            extraDateSpan: props.extraDateSpan,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            popoverContent: ()=>$4157f0f8015cdf85$var$renderPlainFgSegs(props.hiddenSegs, props),
            defaultGenerator: $4157f0f8015cdf85$var$renderMoreLinkInner,
            forceTimed: true
        }, (InnerContent)=>(0, $bvID6.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-more-link-inner',
                    'fc-sticky'
                ]
            }));
    }
}
function $4157f0f8015cdf85$var$renderMoreLinkInner(props) {
    return props.shortText;
}
// segInputs assumed sorted
function $4157f0f8015cdf85$var$buildPositioning(segInputs, strictOrder, maxStackCnt) {
    let hierarchy = new (0, $9b1rB.by)();
    if (strictOrder != null) hierarchy.strictOrder = strictOrder;
    if (maxStackCnt != null) hierarchy.maxStackCnt = maxStackCnt;
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let hiddenGroups = (0, $9b1rB.bC)(hiddenEntries);
    let web = $4157f0f8015cdf85$var$buildWeb(hierarchy);
    web = $4157f0f8015cdf85$var$stretchWeb(web, 1); // all levelCoords/thickness will have 0.0-1.0
    let segRects = $4157f0f8015cdf85$var$webToRects(web);
    return {
        segRects: segRects,
        hiddenGroups: hiddenGroups
    };
}
function $4157f0f8015cdf85$var$buildWeb(hierarchy) {
    const { entriesByLevel: entriesByLevel } = hierarchy;
    const buildNode = $4157f0f8015cdf85$var$cacheable((level, lateral)=>level + ':' + lateral, (level, lateral)=>{
        let siblingRange = $4157f0f8015cdf85$var$findNextLevelSegs(hierarchy, level, lateral);
        let nextLevelRes = $4157f0f8015cdf85$var$buildNodes(siblingRange, buildNode);
        let entry = entriesByLevel[level][lateral];
        return [
            Object.assign(Object.assign({}, entry), {
                nextLevelNodes: nextLevelRes[0]
            }),
            entry.thickness + nextLevelRes[1]
        ];
    });
    return $4157f0f8015cdf85$var$buildNodes(entriesByLevel.length ? {
        level: 0,
        lateralStart: 0,
        lateralEnd: entriesByLevel[0].length
    } : null, buildNode)[0];
}
function $4157f0f8015cdf85$var$buildNodes(siblingRange, buildNode) {
    if (!siblingRange) return [
        [],
        0
    ];
    let { level: level, lateralStart: lateralStart, lateralEnd: lateralEnd } = siblingRange;
    let lateral = lateralStart;
    let pairs = [];
    while(lateral < lateralEnd){
        pairs.push(buildNode(level, lateral));
        lateral += 1;
    }
    pairs.sort($4157f0f8015cdf85$var$cmpDescPressures);
    return [
        pairs.map($4157f0f8015cdf85$var$extractNode),
        pairs[0][1]
    ];
}
function $4157f0f8015cdf85$var$cmpDescPressures(a, b) {
    return b[1] - a[1];
}
function $4157f0f8015cdf85$var$extractNode(a) {
    return a[0];
}
function $4157f0f8015cdf85$var$findNextLevelSegs(hierarchy, subjectLevel, subjectLateral) {
    let { levelCoords: levelCoords, entriesByLevel: entriesByLevel } = hierarchy;
    let subjectEntry = entriesByLevel[subjectLevel][subjectLateral];
    let afterSubject = levelCoords[subjectLevel] + subjectEntry.thickness;
    let levelCnt = levelCoords.length;
    let level = subjectLevel;
    // skip past levels that are too high up
    for(; level < levelCnt && levelCoords[level] < afterSubject; level += 1); // do nothing
    for(; level < levelCnt; level += 1){
        let entries = entriesByLevel[level];
        let entry;
        let searchIndex = (0, $9b1rB.bB)(entries, subjectEntry.span.start, (0, $9b1rB.bA));
        let lateralStart = searchIndex[0] + searchIndex[1]; // if exact match (which doesn't collide), go to next one
        let lateralEnd = lateralStart;
        while((entry = entries[lateralEnd]) && // but not past the whole seg list
        entry.span.start < subjectEntry.span.end)lateralEnd += 1;
        if (lateralStart < lateralEnd) return {
            level: level,
            lateralStart: lateralStart,
            lateralEnd: lateralEnd
        };
    }
    return null;
}
function $4157f0f8015cdf85$var$stretchWeb(topLevelNodes, totalThickness) {
    const stretchNode = $4157f0f8015cdf85$var$cacheable((node, startCoord, prevThickness)=>(0, $9b1rB.bz)(node), (node, startCoord, prevThickness)=>{
        let { nextLevelNodes: nextLevelNodes, thickness: thickness } = node;
        let allThickness = thickness + prevThickness;
        let thicknessFraction = thickness / allThickness;
        let endCoord;
        let newChildren = [];
        if (!nextLevelNodes.length) endCoord = totalThickness;
        else {
            for (let childNode of nextLevelNodes)if (endCoord === undefined) {
                let res = stretchNode(childNode, startCoord, allThickness);
                endCoord = res[0];
                newChildren.push(res[1]);
            } else {
                let res = stretchNode(childNode, endCoord, 0);
                newChildren.push(res[1]);
            }
        }
        let newThickness = (endCoord - startCoord) * thicknessFraction;
        return [
            endCoord - newThickness,
            Object.assign(Object.assign({}, node), {
                thickness: newThickness,
                nextLevelNodes: newChildren
            })
        ];
    });
    return topLevelNodes.map((node)=>stretchNode(node, 0, 0)[1]);
}
// not sorted in any particular order
function $4157f0f8015cdf85$var$webToRects(topLevelNodes) {
    let rects = [];
    const processNode = $4157f0f8015cdf85$var$cacheable((node, levelCoord, stackDepth)=>(0, $9b1rB.bz)(node), (node, levelCoord, stackDepth)=>{
        let rect = Object.assign(Object.assign({}, node), {
            levelCoord: levelCoord,
            stackDepth: stackDepth,
            stackForward: 0
        });
        rects.push(rect);
        return rect.stackForward = processNodes(node.nextLevelNodes, levelCoord + node.thickness, stackDepth + 1) + 1;
    });
    function processNodes(nodes, levelCoord, stackDepth) {
        let stackForward = 0;
        for (let node of nodes)stackForward = Math.max(processNode(node, levelCoord, stackDepth), stackForward);
        return stackForward;
    }
    processNodes(topLevelNodes, 0, 0);
    return rects; // TODO: sort rects by levelCoord to be consistent with toRects?
}
// TODO: move to general util
function $4157f0f8015cdf85$var$cacheable(keyFunc, workFunc) {
    const cache = {};
    return (...args)=>{
        let key = keyFunc(...args);
        return key in cache ? cache[key] : cache[key] = workFunc(...args);
    };
}
function $4157f0f8015cdf85$var$computeSegVCoords(segs, colDate, slatCoords = null, eventMinHeight = 0) {
    let vcoords = [];
    if (slatCoords) for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let spanStart = slatCoords.computeDateTop(seg.start, colDate);
        let spanEnd = Math.max(spanStart + (eventMinHeight || 0), slatCoords.computeDateTop(seg.end, colDate));
        vcoords.push({
            start: Math.round(spanStart),
            end: Math.round(spanEnd)
        });
    }
    return vcoords;
}
function $4157f0f8015cdf85$var$computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack) {
    let segInputs = [];
    let dumbSegs = []; // segs without coords
    for(let i = 0; i < segs.length; i += 1){
        let vcoords = segVCoords[i];
        if (vcoords) segInputs.push({
            index: i,
            thickness: 1,
            span: vcoords
        });
        else dumbSegs.push(segs[i]);
    }
    let { segRects: segRects, hiddenGroups: hiddenGroups } = $4157f0f8015cdf85$var$buildPositioning(segInputs, eventOrderStrict, eventMaxStack);
    let segPlacements = [];
    for (let segRect of segRects)segPlacements.push({
        seg: segs[segRect.index],
        rect: segRect
    });
    for (let dumbSeg of dumbSegs)segPlacements.push({
        seg: dumbSeg,
        rect: null
    });
    return {
        segPlacements: segPlacements,
        hiddenGroups: hiddenGroups
    };
}
const $4157f0f8015cdf85$var$DEFAULT_TIME_FORMAT = (0, $9b1rB.x)({
    hour: 'numeric',
    minute: '2-digit',
    meridiem: false
});
class $4157f0f8015cdf85$var$TimeColEvent extends (0, $9b1rB.B) {
    render() {
        return (0, $bvID6.createElement)((0, $9b1rB.cg), Object.assign({}, this.props, {
            elClasses: [
                'fc-timegrid-event',
                'fc-v-event',
                this.props.isShort && 'fc-timegrid-event-short'
            ],
            defaultTimeFormat: $4157f0f8015cdf85$var$DEFAULT_TIME_FORMAT
        }));
    }
}
class $4157f0f8015cdf85$var$TimeCol extends (0, $9b1rB.B) {
    constructor(){
        super(...arguments);
        this.sortEventSegs = (0, $9b1rB.z)((0, $9b1rB.bP));
    }
    // TODO: memoize event-placement?
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let isSelectMirror = options.selectMirror;
        let mirrorSegs = props.eventDrag && props.eventDrag.segs || props.eventResize && props.eventResize.segs || isSelectMirror && props.dateSelectionSegs || [];
        let interactionAffectedInstances = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        let sortedFgSegs = this.sortEventSegs(props.fgEventSegs, options.eventOrder);
        return (0, $bvID6.createElement)((0, $9b1rB.ci), {
            elTag: "td",
            elRef: props.elRef,
            elClasses: [
                'fc-timegrid-col',
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: 'gridcell'
            }, props.extraDataAttrs),
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent)=>(0, $bvID6.createElement)("div", {
                className: "fc-timegrid-col-frame"
            }, (0, $bvID6.createElement)("div", {
                className: "fc-timegrid-col-bg"
            }, this.renderFillSegs(props.businessHourSegs, 'non-business'), this.renderFillSegs(props.bgEventSegs, 'bg-event'), this.renderFillSegs(props.dateSelectionSegs, 'highlight')), (0, $bvID6.createElement)("div", {
                className: "fc-timegrid-col-events"
            }, this.renderFgSegs(sortedFgSegs, interactionAffectedInstances, false, false, false)), (0, $bvID6.createElement)("div", {
                className: "fc-timegrid-col-events"
            }, this.renderFgSegs(mirrorSegs, {}, Boolean(props.eventDrag), Boolean(props.eventResize), Boolean(isSelectMirror), 'mirror')), (0, $bvID6.createElement)("div", {
                className: "fc-timegrid-now-indicator-container"
            }, this.renderNowIndicator(props.nowIndicatorSegs)), (0, $9b1rB.cj)(options) && (0, $bvID6.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-col-misc'
                ]
            })));
    }
    renderFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
        let { props: props } = this;
        if (props.forPrint) return $4157f0f8015cdf85$var$renderPlainFgSegs(sortedFgSegs, props);
        return this.renderPositionedFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey);
    }
    renderPositionedFgSegs(segs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
        let { eventMaxStack: eventMaxStack, eventShortHeight: eventShortHeight, eventOrderStrict: eventOrderStrict, eventMinHeight: eventMinHeight } = this.context.options;
        let { date: date, slatCoords: slatCoords, eventSelection: eventSelection, todayRange: todayRange, nowDate: nowDate } = this.props;
        let isMirror = isDragging || isResizing || isDateSelecting;
        let segVCoords = $4157f0f8015cdf85$var$computeSegVCoords(segs, date, slatCoords, eventMinHeight);
        let { segPlacements: segPlacements, hiddenGroups: hiddenGroups } = $4157f0f8015cdf85$var$computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack);
        return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, this.renderHiddenGroups(hiddenGroups, segs), segPlacements.map((segPlacement)=>{
            let { seg: seg, rect: rect } = segPlacement;
            let instanceId = seg.eventRange.instance.instanceId;
            let isVisible = isMirror || Boolean(!segIsInvisible[instanceId] && rect);
            let vStyle = $4157f0f8015cdf85$var$computeSegVStyle(rect && rect.span);
            let hStyle = !isMirror && rect ? this.computeSegHStyle(rect) : {
                left: 0,
                right: 0
            };
            let isInset = Boolean(rect) && rect.stackForward > 0;
            let isShort = Boolean(rect) && rect.span.end - rect.span.start < eventShortHeight; // look at other places for this problem
            return (0, $bvID6.createElement)("div", {
                className: 'fc-timegrid-event-harness' + (isInset ? ' fc-timegrid-event-harness-inset' : ''),
                key: forcedKey || instanceId,
                style: Object.assign(Object.assign({
                    visibility: isVisible ? '' : 'hidden'
                }, vStyle), hStyle)
            }, (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeColEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                isShort: isShort
            }, (0, $9b1rB.bQ)(seg, todayRange, nowDate))));
        }));
    }
    // will already have eventMinHeight applied because segInputs already had it
    renderHiddenGroups(hiddenGroups, segs) {
        let { extraDateSpan: extraDateSpan, dateProfile: dateProfile, todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize } = this.props;
        return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, hiddenGroups.map((hiddenGroup)=>{
            let positionCss = $4157f0f8015cdf85$var$computeSegVStyle(hiddenGroup.span);
            let hiddenSegs = $4157f0f8015cdf85$var$compileSegsFromEntries(hiddenGroup.entries, segs);
            return (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeColMoreLink, {
                key: (0, $9b1rB.bu)((0, $9b1rB.cp)(hiddenSegs)),
                hiddenSegs: hiddenSegs,
                top: positionCss.top,
                bottom: positionCss.bottom,
                extraDateSpan: extraDateSpan,
                dateProfile: dateProfile,
                todayRange: todayRange,
                nowDate: nowDate,
                eventSelection: eventSelection,
                eventDrag: eventDrag,
                eventResize: eventResize
            });
        }));
    }
    renderFillSegs(segs, fillType) {
        let { props: props, context: context } = this;
        let segVCoords = $4157f0f8015cdf85$var$computeSegVCoords(segs, props.date, props.slatCoords, context.options.eventMinHeight); // don't assume all populated
        let children = segVCoords.map((vcoords, i)=>{
            let seg = segs[i];
            return (0, $bvID6.createElement)("div", {
                key: (0, $9b1rB.bR)(seg.eventRange),
                className: "fc-timegrid-bg-harness",
                style: $4157f0f8015cdf85$var$computeSegVStyle(vcoords)
            }, fillType === 'bg-event' ? (0, $bvID6.createElement)((0, $9b1rB.cm), Object.assign({
                seg: seg
            }, (0, $9b1rB.bQ)(seg, props.todayRange, props.nowDate))) : (0, $9b1rB.cl)(fillType));
        });
        return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, children);
    }
    renderNowIndicator(segs) {
        let { slatCoords: slatCoords, date: date } = this.props;
        if (!slatCoords) return null;
        return segs.map((seg, i)=>(0, $bvID6.createElement)((0, $9b1rB.ch), {
                // key doesn't matter. will only ever be one
                key: i,
                elClasses: [
                    'fc-timegrid-now-indicator-line'
                ],
                elStyle: {
                    top: slatCoords.computeDateTop(seg.start, date)
                },
                isAxis: false,
                date: date
            }));
    }
    computeSegHStyle(segHCoords) {
        let { isRtl: isRtl, options: options } = this.context;
        let shouldOverlap = options.slotEventOverlap;
        let nearCoord = segHCoords.levelCoord; // the left side if LTR. the right side if RTL. floating-point
        let farCoord = segHCoords.levelCoord + segHCoords.thickness; // the right side if LTR. the left side if RTL. floating-point
        let left; // amount of space from left edge, a fraction of the total width
        let right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) // double the width, but don't go beyond the maximum forward coordinate (1.0)
        farCoord = Math.min(1, nearCoord + (farCoord - nearCoord) * 2);
        if (isRtl) {
            left = 1 - farCoord;
            right = nearCoord;
        } else {
            left = nearCoord;
            right = 1 - farCoord;
        }
        let props = {
            zIndex: segHCoords.stackDepth + 1,
            left: left * 100 + '%',
            right: right * 100 + '%'
        };
        if (shouldOverlap && !segHCoords.stackForward) // add padding to the edge so that forward stacked events don't cover the resizer's icon
        props[isRtl ? 'marginLeft' : 'marginRight'] = 20; // 10 is a guesstimate of the icon's width
        return props;
    }
}
function $4157f0f8015cdf85$var$renderPlainFgSegs(sortedFgSegs, { todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize }) {
    let hiddenInstances = (eventDrag ? eventDrag.affectedInstances : null) || (eventResize ? eventResize.affectedInstances : null) || {};
    return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, sortedFgSegs.map((seg)=>{
        let instanceId = seg.eventRange.instance.instanceId;
        return (0, $bvID6.createElement)("div", {
            key: instanceId,
            style: {
                visibility: hiddenInstances[instanceId] ? 'hidden' : ''
            }
        }, (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeColEvent, Object.assign({
            seg: seg,
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: instanceId === eventSelection,
            isShort: false
        }, (0, $9b1rB.bQ)(seg, todayRange, nowDate))));
    }));
}
function $4157f0f8015cdf85$var$computeSegVStyle(segVCoords) {
    if (!segVCoords) return {
        top: '',
        bottom: ''
    };
    return {
        top: segVCoords.start,
        bottom: -segVCoords.end
    };
}
function $4157f0f8015cdf85$var$compileSegsFromEntries(segEntries, allSegs) {
    return segEntries.map((segEntry)=>allSegs[segEntry.index]);
}
class $4157f0f8015cdf85$var$TimeColsContent extends (0, $9b1rB.B) {
    constructor(){
        super(...arguments);
        this.splitFgEventSegs = (0, $9b1rB.z)($4157f0f8015cdf85$var$splitSegsByCol);
        this.splitBgEventSegs = (0, $9b1rB.z)($4157f0f8015cdf85$var$splitSegsByCol);
        this.splitBusinessHourSegs = (0, $9b1rB.z)($4157f0f8015cdf85$var$splitSegsByCol);
        this.splitNowIndicatorSegs = (0, $9b1rB.z)($4157f0f8015cdf85$var$splitSegsByCol);
        this.splitDateSelectionSegs = (0, $9b1rB.z)($4157f0f8015cdf85$var$splitSegsByCol);
        this.splitEventDrag = (0, $9b1rB.z)($4157f0f8015cdf85$var$splitInteractionByCol);
        this.splitEventResize = (0, $9b1rB.z)($4157f0f8015cdf85$var$splitInteractionByCol);
        this.rootElRef = (0, $bvID6.createRef)();
        this.cellElRefs = new (0, $9b1rB.cd)();
    }
    render() {
        let { props: props, context: context } = this;
        let nowIndicatorTop = context.options.nowIndicator && props.slatCoords && props.slatCoords.safeComputeTop(props.nowDate); // might return void
        let colCnt = props.cells.length;
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, colCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, colCnt);
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, colCnt);
        let nowIndicatorSegsByRow = this.splitNowIndicatorSegs(props.nowIndicatorSegs, colCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, colCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, colCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, colCnt);
        return (0, $bvID6.createElement)("div", {
            className: "fc-timegrid-cols",
            ref: this.rootElRef
        }, (0, $bvID6.createElement)("table", {
            role: "presentation",
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth
            }
        }, props.tableColGroupNode, (0, $bvID6.createElement)("tbody", {
            role: "presentation"
        }, (0, $bvID6.createElement)("tr", {
            role: "row"
        }, props.axis && (0, $bvID6.createElement)("td", {
            "aria-hidden": true,
            className: "fc-timegrid-col fc-timegrid-axis"
        }, (0, $bvID6.createElement)("div", {
            className: "fc-timegrid-col-frame"
        }, (0, $bvID6.createElement)("div", {
            className: "fc-timegrid-now-indicator-container"
        }, typeof nowIndicatorTop === 'number' && (0, $bvID6.createElement)((0, $9b1rB.ch), {
            elClasses: [
                'fc-timegrid-now-indicator-arrow'
            ],
            elStyle: {
                top: nowIndicatorTop
            },
            isAxis: true,
            date: props.nowDate
        })))), props.cells.map((cell, i)=>(0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeCol, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                nowDate: props.nowDate,
                todayRange: props.todayRange,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                fgEventSegs: fgEventSegsByRow[i],
                bgEventSegs: bgEventSegsByRow[i],
                businessHourSegs: businessHourSegsByRow[i],
                nowIndicatorSegs: nowIndicatorSegsByRow[i],
                dateSelectionSegs: dateSelectionSegsByRow[i],
                eventDrag: eventDragByRow[i],
                eventResize: eventResizeByRow[i],
                slatCoords: props.slatCoords,
                eventSelection: props.eventSelection,
                forPrint: props.forPrint
            }))))));
    }
    componentDidMount() {
        this.updateCoords();
    }
    componentDidUpdate() {
        this.updateCoords();
    }
    updateCoords() {
        let { props: props } = this;
        if (props.onColCoords && props.clientWidth !== null // means sizing has stabilized
        ) props.onColCoords(new (0, $9b1rB.b8)(this.rootElRef.current, $4157f0f8015cdf85$var$collectCellEls(this.cellElRefs.currentMap, props.cells), true, false));
    }
}
function $4157f0f8015cdf85$var$collectCellEls(elMap, cells) {
    return cells.map((cell)=>elMap[cell.key]);
}
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/ class $4157f0f8015cdf85$export$6d0b14d80f61b392 extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.processSlotOptions = (0, $9b1rB.z)($4157f0f8015cdf85$var$processSlotOptions);
        this.state = {
            slatCoords: null
        };
        this.handleRootEl = (el)=>{
            if (el) this.context.registerInteractiveComponent(this, {
                el: el,
                isHitComboAllowed: this.props.isHitComboAllowed
            });
            else this.context.unregisterInteractiveComponent(this);
        };
        this.handleScrollRequest = (request)=>{
            let { onScrollTopRequest: onScrollTopRequest } = this.props;
            let { slatCoords: slatCoords } = this.state;
            if (onScrollTopRequest && slatCoords) {
                if (request.time) {
                    let top = slatCoords.computeTimeTop(request.time);
                    top = Math.ceil(top); // zoom can give weird floating-point values. rather scroll a little bit further
                    if (top) top += 1; // to overcome top border that slots beyond the first have. looks better
                    onScrollTopRequest(top);
                }
                return true;
            }
            return false;
        };
        this.handleColCoords = (colCoords)=>{
            this.colCoords = colCoords;
        };
        this.handleSlatCoords = (slatCoords)=>{
            this.setState({
                slatCoords: slatCoords
            });
            if (this.props.onSlatCoords) this.props.onSlatCoords(slatCoords);
        };
    }
    render() {
        let { props: props, state: state } = this;
        return (0, $bvID6.createElement)("div", {
            className: "fc-timegrid-body",
            ref: this.handleRootEl,
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeColsSlats, {
            axis: props.axis,
            dateProfile: props.dateProfile,
            slatMetas: props.slatMetas,
            clientWidth: props.clientWidth,
            minHeight: props.expandRows ? props.clientHeight : '',
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.axis ? props.tableColGroupNode : null,
            onCoords: this.handleSlatCoords
        }), (0, $bvID6.createElement)($4157f0f8015cdf85$var$TimeColsContent, {
            cells: props.cells,
            axis: props.axis,
            dateProfile: props.dateProfile,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            todayRange: props.todayRange,
            nowDate: props.nowDate,
            nowIndicatorSegs: props.nowIndicatorSegs,
            clientWidth: props.clientWidth,
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.tableColGroupNode,
            slatCoords: state.slatCoords,
            onColCoords: this.handleColCoords,
            forPrint: props.forPrint
        }));
    }
    componentDidMount() {
        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
    }
    componentDidUpdate(prevProps) {
        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
    }
    componentWillUnmount() {
        this.scrollResponder.detach();
    }
    queryHit(positionLeft, positionTop) {
        let { dateEnv: dateEnv, options: options } = this.context;
        let { colCoords: colCoords } = this;
        let { dateProfile: dateProfile } = this.props;
        let { slatCoords: slatCoords } = this.state;
        let { snapDuration: snapDuration, snapsPerSlot: snapsPerSlot } = this.processSlotOptions(this.props.slotDuration, options.snapDuration);
        let colIndex = colCoords.leftToIndex(positionLeft);
        let slatIndex = slatCoords.positions.topToIndex(positionTop);
        if (colIndex != null && slatIndex != null) {
            let cell = this.props.cells[colIndex];
            let slatTop = slatCoords.positions.tops[slatIndex];
            let slatHeight = slatCoords.positions.getHeight(slatIndex);
            let partial = (positionTop - slatTop) / slatHeight; // floating point number between 0 and 1
            let localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
            let snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
            let dayDate = this.props.cells[colIndex].date;
            let time = (0, $9b1rB.bn)(dateProfile.slotMinTime, (0, $9b1rB.bm)(snapDuration, snapIndex));
            let start = dateEnv.add(dayDate, time);
            let end = dateEnv.add(start, snapDuration);
            return {
                dateProfile: dateProfile,
                dateSpan: Object.assign({
                    range: {
                        start: start,
                        end: end
                    },
                    allDay: false
                }, cell.extraDateSpan),
                dayEl: colCoords.els[colIndex],
                rect: {
                    left: colCoords.lefts[colIndex],
                    right: colCoords.rights[colIndex],
                    top: slatTop,
                    bottom: slatTop + slatHeight
                },
                layer: 0
            };
        }
        return null;
    }
}
function $4157f0f8015cdf85$var$processSlotOptions(slotDuration, snapDurationOverride) {
    let snapDuration = snapDurationOverride || slotDuration;
    let snapsPerSlot = (0, $9b1rB.br)(slotDuration, snapDuration);
    if (snapsPerSlot === null) {
        snapDuration = slotDuration;
        snapsPerSlot = 1;
    // TODO: say warning?
    }
    return {
        snapDuration: snapDuration,
        snapsPerSlot: snapsPerSlot
    };
}
class $4157f0f8015cdf85$export$ca63779cde537f3d extends (0, $9b1rB.bU) {
    sliceRange(range, dayRanges) {
        let segs = [];
        for(let col = 0; col < dayRanges.length; col += 1){
            let segRange = (0, $9b1rB.o)(range, dayRanges[col]);
            if (segRange) segs.push({
                start: segRange.start,
                end: segRange.end,
                isStart: segRange.start.valueOf() === range.start.valueOf(),
                isEnd: segRange.end.valueOf() === range.end.valueOf(),
                col: col
            });
        }
        return segs;
    }
}
class $4157f0f8015cdf85$export$a1033d45b156b3eb extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.buildDayRanges = (0, $9b1rB.z)($4157f0f8015cdf85$export$718c171dfac2fa3a);
        this.slicer = new $4157f0f8015cdf85$export$ca63779cde537f3d();
        this.timeColsRef = (0, $bvID6.createRef)();
    }
    render() {
        let { props: props, context: context } = this;
        let { dateProfile: dateProfile, dayTableModel: dayTableModel } = props;
        let { nowIndicator: nowIndicator, nextDayThreshold: nextDayThreshold } = context.options;
        let dayRanges = this.buildDayRanges(dayTableModel, dateProfile, context.dateEnv);
        // give it the first row of cells
        // TODO: would move this further down hierarchy, but sliceNowDate needs it
        return (0, $bvID6.createElement)((0, $9b1rB.a6), {
            unit: nowIndicator ? 'minute' : 'day'
        }, (nowDate, todayRange)=>(0, $bvID6.createElement)($4157f0f8015cdf85$export$6d0b14d80f61b392, Object.assign({
                ref: this.timeColsRef
            }, this.slicer.sliceProps(props, dateProfile, null, context, dayRanges), {
                forPrint: props.forPrint,
                axis: props.axis,
                dateProfile: dateProfile,
                slatMetas: props.slatMetas,
                slotDuration: props.slotDuration,
                cells: dayTableModel.cells[0],
                tableColGroupNode: props.tableColGroupNode,
                tableMinWidth: props.tableMinWidth,
                clientWidth: props.clientWidth,
                clientHeight: props.clientHeight,
                expandRows: props.expandRows,
                nowDate: nowDate,
                nowIndicatorSegs: nowIndicator && this.slicer.sliceNowDate(nowDate, dateProfile, nextDayThreshold, context, dayRanges),
                todayRange: todayRange,
                onScrollTopRequest: props.onScrollTopRequest,
                onSlatCoords: props.onSlatCoords
            })));
    }
}
function $4157f0f8015cdf85$export$718c171dfac2fa3a(dayTableModel, dateProfile, dateEnv) {
    let ranges = [];
    for (let date of dayTableModel.headerDates)ranges.push({
        start: dateEnv.add(date, dateProfile.slotMinTime),
        end: dateEnv.add(date, dateProfile.slotMaxTime)
    });
    return ranges;
}
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
const $4157f0f8015cdf85$var$STOCK_SUB_DURATIONS = [
    {
        hours: 1
    },
    {
        minutes: 30
    },
    {
        minutes: 15
    },
    {
        seconds: 30
    },
    {
        seconds: 15
    }
];
function $4157f0f8015cdf85$export$717bdb379477c13e(slotMinTime, slotMaxTime, explicitLabelInterval, slotDuration, dateEnv) {
    let dayStart = new Date(0);
    let slatTime = slotMinTime;
    let slatIterator = (0, $9b1rB.d)(0);
    let labelInterval = explicitLabelInterval || $4157f0f8015cdf85$var$computeLabelInterval(slotDuration);
    let metas = [];
    while((0, $9b1rB.bq)(slatTime) < (0, $9b1rB.bq)(slotMaxTime)){
        let date = dateEnv.add(dayStart, slatTime);
        let isLabeled = (0, $9b1rB.br)(slatIterator, labelInterval) !== null;
        metas.push({
            date: date,
            time: slatTime,
            key: date.toISOString(),
            isoTimeStr: (0, $9b1rB.bs)(date),
            isLabeled: isLabeled
        });
        slatTime = (0, $9b1rB.bn)(slatTime, slotDuration);
        slatIterator = (0, $9b1rB.bn)(slatIterator, slotDuration);
    }
    return metas;
}
// Computes an automatic value for slotLabelInterval
function $4157f0f8015cdf85$var$computeLabelInterval(slotDuration) {
    let i;
    let labelInterval;
    let slotsPerLabel;
    // find the smallest stock label interval that results in more than one slots-per-label
    for(i = $4157f0f8015cdf85$var$STOCK_SUB_DURATIONS.length - 1; i >= 0; i -= 1){
        labelInterval = (0, $9b1rB.d)($4157f0f8015cdf85$var$STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = (0, $9b1rB.br)(labelInterval, slotDuration);
        if (slotsPerLabel !== null && slotsPerLabel > 1) return labelInterval;
    }
    return slotDuration; // fall back
}
class $4157f0f8015cdf85$export$4b78a540ee976f33 extends $4157f0f8015cdf85$export$667ac525945c6ff8 {
    constructor(){
        super(...arguments);
        this.buildTimeColsModel = (0, $9b1rB.z)($4157f0f8015cdf85$export$5596a640484dddd2);
        this.buildSlatMetas = (0, $9b1rB.z)($4157f0f8015cdf85$export$717bdb379477c13e);
    }
    render() {
        let { options: options, dateEnv: dateEnv, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let { dateProfile: dateProfile } = props;
        let dayTableModel = this.buildTimeColsModel(dateProfile, dateProfileGenerator);
        let splitProps = this.allDaySplitter.splitProps(props);
        let slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
        let { dayMinWidth: dayMinWidth } = options;
        let hasAttachedAxis = !dayMinWidth;
        let hasDetachedAxis = dayMinWidth;
        let headerContent = options.dayHeaders && (0, $bvID6.createElement)((0, $9b1rB.bI), {
            dates: dayTableModel.headerDates,
            dateProfile: dateProfile,
            datesRepDistinctDays: true,
            renderIntro: hasAttachedAxis ? this.renderHeadAxis : null
        });
        let allDayContent = options.allDaySlot !== false && ((contentArg)=>(0, $bvID6.createElement)((0, $aEl91.DayTable), Object.assign({}, splitProps.allDay, {
                dateProfile: dateProfile,
                dayTableModel: dayTableModel,
                nextDayThreshold: options.nextDayThreshold,
                tableMinWidth: contentArg.tableMinWidth,
                colGroupNode: contentArg.tableColGroupNode,
                renderRowIntro: hasAttachedAxis ? this.renderTableRowAxis : null,
                showWeekNumbers: false,
                expandRows: false,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            }, this.getAllDayMaxEventProps())));
        let timeGridContent = (contentArg)=>(0, $bvID6.createElement)($4157f0f8015cdf85$export$a1033d45b156b3eb, Object.assign({}, splitProps.timed, {
                dayTableModel: dayTableModel,
                dateProfile: dateProfile,
                axis: hasAttachedAxis,
                slotDuration: options.slotDuration,
                slatMetas: slatMetas,
                forPrint: props.forPrint,
                tableColGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                onSlatCoords: this.handleSlatCoords,
                expandRows: contentArg.expandRows,
                onScrollTopRequest: this.handleScrollTopRequest
            }));
        return hasDetachedAxis ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, dayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords) : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
    }
}
function $4157f0f8015cdf85$export$5596a640484dddd2(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $9b1rB.bM)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $9b1rB.bT)(daySeries, false);
}
var $4157f0f8015cdf85$var$css_248z = ".fc-v-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-v-event .fc-event-main{color:var(--fc-event-text-color);height:100%}.fc-v-event .fc-event-main-frame{display:flex;flex-direction:column;height:100%}.fc-v-event .fc-event-time{flex-grow:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{bottom:0;max-height:100%;overflow:hidden;top:0}.fc-v-event:not(.fc-event-start){border-top-left-radius:0;border-top-right-radius:0;border-top-width:0}.fc-v-event:not(.fc-event-end){border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-width:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:var(--fc-event-resizer-thickness);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%;position:relative;z-index:1}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-slot{border-bottom:0;height:1.5em}.fc .fc-timegrid-slot:empty:before{content:\"\\00a0\"}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{align-items:center;display:flex;justify-content:flex-end;overflow:hidden}.fc .fc-timegrid-axis-cushion{flex-shrink:0;max-width:60px}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols{bottom:0;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight{z-index:3}.fc .fc-timegrid-bg-harness{left:0;position:absolute;right:0}.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{bottom:0;left:0;position:absolute;right:0;top:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px var(--fc-page-bg-color)}.fc-timegrid-event,.fc-timegrid-more-link{border-radius:3px;font-size:var(--fc-small-font-size)}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{font-size:var(--fc-small-font-size);margin-bottom:1px;white-space:nowrap}.fc-timegrid-event-short .fc-event-main-frame{flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:\"\\00a0-\\00a0\"}.fc-timegrid-event-short .fc-event-title{font-size:var(--fc-small-font-size)}.fc-timegrid-more-link{background:var(--fc-more-link-bg-color);color:var(--fc-more-link-text-color);cursor:pointer;margin-bottom:1px;position:absolute;z-index:9999}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-arrow,.fc .fc-timegrid-now-indicator-line{pointer-events:none}.fc .fc-timegrid-now-indicator-line{border-color:var(--fc-now-indicator-color);border-style:solid;border-width:1px 0 0;left:0;position:absolute;right:0;z-index:4}.fc .fc-timegrid-now-indicator-arrow{border-color:var(--fc-now-indicator-color);border-style:solid;margin-top:-5px;position:absolute;z-index:4}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 0 5px 6px;left:0}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 6px 5px 0;right:0}";
(0, $9b1rB.ct)($4157f0f8015cdf85$var$css_248z);

});


parcelRegister("azIjx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b2f8c238cf7e8f8$export$2e2bcd8739ae039; });

var $jnteQ = parcelRequire("jnteQ");

var $cqy4Y = parcelRequire("cqy4Y");

var $9b1rB = parcelRequire("9b1rB");

const $7b2f8c238cf7e8f8$var$OPTION_REFINERS = {
    listDayFormat: $7b2f8c238cf7e8f8$var$createFalsableFormatter,
    listDaySideFormat: $7b2f8c238cf7e8f8$var$createFalsableFormatter,
    noEventsClassNames: (0, $9b1rB.n),
    noEventsContent: (0, $9b1rB.n),
    noEventsDidMount: (0, $9b1rB.n),
    noEventsWillUnmount: (0, $9b1rB.n)
};
function $7b2f8c238cf7e8f8$var$createFalsableFormatter(input) {
    return input === false ? null : (0, $9b1rB.x)(input);
}
var $7b2f8c238cf7e8f8$export$2e2bcd8739ae039 = (0, $jnteQ.createPlugin)({
    name: '@fullcalendar/list',
    optionRefiners: $7b2f8c238cf7e8f8$var$OPTION_REFINERS,
    views: {
        list: {
            component: (0, $cqy4Y.ListView),
            buttonTextKey: 'list',
            listDayFormat: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        listDay: {
            type: 'list',
            duration: {
                days: 1
            },
            listDayFormat: {
                weekday: 'long'
            }
        },
        listWeek: {
            type: 'list',
            duration: {
                weeks: 1
            },
            listDayFormat: {
                weekday: 'long'
            },
            listDaySideFormat: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        listMonth: {
            type: 'list',
            duration: {
                month: 1
            },
            listDaySideFormat: {
                weekday: 'long'
            }
        },
        listYear: {
            type: 'list',
            duration: {
                year: 1
            },
            listDaySideFormat: {
                weekday: 'long'
            }
        }
    }
});

});
parcelRegister("cqy4Y", function(module, exports) {

$parcel$export(module.exports, "ListView", function () { return $90c2592c0760f4e8$export$84d0dd190d551cd1; });

var $9b1rB = parcelRequire("9b1rB");

var $bvID6 = parcelRequire("bvID6");
class $90c2592c0760f4e8$var$ListViewHeaderRow extends (0, $9b1rB.B) {
    constructor(){
        super(...arguments);
        this.state = {
            textId: (0, $9b1rB.a3)()
        };
    }
    render() {
        let { theme: theme, dateEnv: dateEnv, options: options, viewApi: viewApi } = this.context;
        let { cellId: cellId, dayDate: dayDate, todayRange: todayRange } = this.props;
        let { textId: textId } = this.state;
        let dayMeta = (0, $9b1rB.aY)(dayDate, todayRange);
        // will ever be falsy?
        let text = options.listDayFormat ? dateEnv.format(dayDate, options.listDayFormat) : '';
        // will ever be falsy? also, BAD NAME "alt"
        let sideText = options.listDaySideFormat ? dateEnv.format(dayDate, options.listDaySideFormat) : '';
        let renderProps = Object.assign({
            date: dateEnv.toDate(dayDate),
            view: viewApi,
            textId: textId,
            text: text,
            sideText: sideText,
            navLinkAttrs: (0, $9b1rB.a_)(this.context, dayDate),
            sideNavLinkAttrs: (0, $9b1rB.a_)(this.context, dayDate, 'day', false)
        }, dayMeta);
        // TODO: make a reusable HOC for dayHeader (used in daygrid/timegrid too)
        return (0, $bvID6.createElement)((0, $9b1rB.C), {
            elTag: "tr",
            elClasses: [
                'fc-list-day',
                ...(0, $9b1rB.aX)(dayMeta, theme)
            ],
            elAttrs: {
                'data-date': (0, $9b1rB.bt)(dayDate)
            },
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $90c2592c0760f4e8$var$renderInnerContent,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $bvID6.createElement)("th", {
                scope: "colgroup",
                colSpan: 3,
                id: cellId,
                "aria-labelledby": textId
            }, (0, $bvID6.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-list-day-cushion',
                    theme.getClass('tableCellShaded')
                ]
            })));
    }
}
function $90c2592c0760f4e8$var$renderInnerContent(props) {
    return (0, $bvID6.createElement)((0, $bvID6.Fragment), null, props.text && (0, $bvID6.createElement)("a", Object.assign({
        id: props.textId,
        className: "fc-list-day-text"
    }, props.navLinkAttrs), props.text), props.sideText && /* not keyboard tabbable */ (0, $bvID6.createElement)("a", Object.assign({
        "aria-hidden": true,
        className: "fc-list-day-side-text"
    }, props.sideNavLinkAttrs), props.sideText));
}
const $90c2592c0760f4e8$var$DEFAULT_TIME_FORMAT = (0, $9b1rB.x)({
    hour: 'numeric',
    minute: '2-digit',
    meridiem: 'short'
});
class $90c2592c0760f4e8$var$ListViewEventRow extends (0, $9b1rB.B) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg, timeHeaderId: timeHeaderId, eventHeaderId: eventHeaderId, dateHeaderId: dateHeaderId } = props;
        let timeFormat = options.eventTimeFormat || $90c2592c0760f4e8$var$DEFAULT_TIME_FORMAT;
        return (0, $bvID6.createElement)((0, $9b1rB.ck), Object.assign({}, props, {
            elTag: "tr",
            elClasses: [
                'fc-list-event',
                seg.eventRange.def.url && 'fc-event-forced-url'
            ],
            defaultGenerator: ()=>$90c2592c0760f4e8$var$renderEventInnerContent(seg, context),
            seg: seg,
            timeText: "",
            disableDragging: true,
            disableResizing: true
        }), (InnerContent, eventContentArg)=>(0, $bvID6.createElement)((0, $bvID6.Fragment), null, $90c2592c0760f4e8$var$buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId), (0, $bvID6.createElement)("td", {
                "aria-hidden": true,
                className: "fc-list-event-graphic"
            }, (0, $bvID6.createElement)("span", {
                className: "fc-list-event-dot",
                style: {
                    borderColor: eventContentArg.borderColor || eventContentArg.backgroundColor
                }
            })), (0, $bvID6.createElement)(InnerContent, {
                elTag: "td",
                elClasses: [
                    'fc-list-event-title'
                ],
                elAttrs: {
                    headers: `${eventHeaderId} ${dateHeaderId}`
                }
            })));
    }
}
function $90c2592c0760f4e8$var$renderEventInnerContent(seg, context) {
    let interactiveAttrs = (0, $9b1rB.bS)(seg, context);
    return (0, $bvID6.createElement)("a", Object.assign({}, interactiveAttrs), seg.eventRange.def.title);
}
function $90c2592c0760f4e8$var$buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId) {
    let { options: options } = context;
    if (options.displayEventTime !== false) {
        let eventDef = seg.eventRange.def;
        let eventInstance = seg.eventRange.instance;
        let doAllDay = false;
        let timeText;
        if (eventDef.allDay) doAllDay = true;
        else if ((0, $9b1rB.ax)(seg.eventRange.range)) {
            if (seg.isStart) timeText = (0, $9b1rB.bO)(seg, timeFormat, context, null, null, eventInstance.range.start, seg.end);
            else if (seg.isEnd) timeText = (0, $9b1rB.bO)(seg, timeFormat, context, null, null, seg.start, eventInstance.range.end);
            else doAllDay = true;
        } else timeText = (0, $9b1rB.bO)(seg, timeFormat, context);
        if (doAllDay) {
            let renderProps = {
                text: context.options.allDayText,
                view: context.viewApi
            };
            return (0, $bvID6.createElement)((0, $9b1rB.C), {
                elTag: "td",
                elClasses: [
                    'fc-list-event-time'
                ],
                elAttrs: {
                    headers: `${timeHeaderId} ${dateHeaderId}`
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: $90c2592c0760f4e8$var$renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            });
        }
        return (0, $bvID6.createElement)("td", {
            className: "fc-list-event-time"
        }, timeText);
    }
    return null;
}
function $90c2592c0760f4e8$var$renderAllDayInner(renderProps) {
    return renderProps.text;
}
/*
Responsible for the scroller, and forwarding event-related actions into the "grid".
*/ class $90c2592c0760f4e8$export$84d0dd190d551cd1 extends (0, $9b1rB.bc) {
    constructor(){
        super(...arguments);
        this.computeDateVars = (0, $9b1rB.z)($90c2592c0760f4e8$var$computeDateVars);
        this.eventStoreToSegs = (0, $9b1rB.z)(this._eventStoreToSegs);
        this.state = {
            timeHeaderId: (0, $9b1rB.a3)(),
            eventHeaderId: (0, $9b1rB.a3)(),
            dateHeaderIdRoot: (0, $9b1rB.a3)()
        };
        this.setRootEl = (rootEl)=>{
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { props: props, context: context } = this;
        let { dayDates: dayDates, dayRanges: dayRanges } = this.computeDateVars(props.dateProfile);
        let eventSegs = this.eventStoreToSegs(props.eventStore, props.eventUiBases, dayRanges);
        return (0, $bvID6.createElement)((0, $9b1rB.cq), {
            elRef: this.setRootEl,
            elClasses: [
                'fc-list',
                context.theme.getClass('table'),
                context.options.stickyHeaderDates !== false ? 'fc-list-sticky' : ''
            ],
            viewSpec: context.viewSpec
        }, (0, $bvID6.createElement)((0, $9b1rB.cb), {
            liquid: !props.isHeightAuto,
            overflowX: props.isHeightAuto ? 'visible' : 'hidden',
            overflowY: props.isHeightAuto ? 'visible' : 'auto'
        }, eventSegs.length > 0 ? this.renderSegList(eventSegs, dayDates) : this.renderEmptyMessage()));
    }
    renderEmptyMessage() {
        let { options: options, viewApi: viewApi } = this.context;
        let renderProps = {
            text: options.noEventsText,
            view: viewApi
        };
        return (0, $bvID6.createElement)((0, $9b1rB.C), {
            elTag: "div",
            elClasses: [
                'fc-list-empty'
            ],
            renderProps: renderProps,
            generatorName: "noEventsContent",
            customGenerator: options.noEventsContent,
            defaultGenerator: $90c2592c0760f4e8$var$renderNoEventsInner,
            classNameGenerator: options.noEventsClassNames,
            didMount: options.noEventsDidMount,
            willUnmount: options.noEventsWillUnmount
        }, (InnerContent)=>(0, $bvID6.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-list-empty-cushion'
                ]
            }));
    }
    renderSegList(allSegs, dayDates) {
        let { theme: theme, options: options } = this.context;
        let { timeHeaderId: timeHeaderId, eventHeaderId: eventHeaderId, dateHeaderIdRoot: dateHeaderIdRoot } = this.state;
        let segsByDay = $90c2592c0760f4e8$var$groupSegsByDay(allSegs); // sparse array
        return (0, $bvID6.createElement)((0, $9b1rB.a6), {
            unit: "day"
        }, (nowDate, todayRange)=>{
            let innerNodes = [];
            for(let dayIndex = 0; dayIndex < segsByDay.length; dayIndex += 1){
                let daySegs = segsByDay[dayIndex];
                if (daySegs) {
                    let dayStr = (0, $9b1rB.bt)(dayDates[dayIndex]);
                    let dateHeaderId = dateHeaderIdRoot + '-' + dayStr;
                    // append a day header
                    innerNodes.push((0, $bvID6.createElement)($90c2592c0760f4e8$var$ListViewHeaderRow, {
                        key: dayStr,
                        cellId: dateHeaderId,
                        dayDate: dayDates[dayIndex],
                        todayRange: todayRange
                    }));
                    daySegs = (0, $9b1rB.bP)(daySegs, options.eventOrder);
                    for (let seg of daySegs)innerNodes.push((0, $bvID6.createElement)($90c2592c0760f4e8$var$ListViewEventRow, Object.assign({
                        key: dayStr + ':' + seg.eventRange.instance.instanceId /* are multiple segs for an instanceId */ ,
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: false,
                        timeHeaderId: timeHeaderId,
                        eventHeaderId: eventHeaderId,
                        dateHeaderId: dateHeaderId
                    }, (0, $9b1rB.bQ)(seg, todayRange, nowDate))));
                }
            }
            return (0, $bvID6.createElement)("table", {
                className: 'fc-list-table ' + theme.getClass('table')
            }, (0, $bvID6.createElement)("thead", null, (0, $bvID6.createElement)("tr", null, (0, $bvID6.createElement)("th", {
                scope: "col",
                id: timeHeaderId
            }, options.timeHint), (0, $bvID6.createElement)("th", {
                scope: "col",
                "aria-hidden": true
            }), (0, $bvID6.createElement)("th", {
                scope: "col",
                id: eventHeaderId
            }, options.eventHint))), (0, $bvID6.createElement)("tbody", null, innerNodes));
        });
    }
    _eventStoreToSegs(eventStore, eventUiBases, dayRanges) {
        return this.eventRangesToSegs((0, $9b1rB.ad)(eventStore, eventUiBases, this.props.dateProfile.activeRange, this.context.options.nextDayThreshold).fg, dayRanges);
    }
    eventRangesToSegs(eventRanges, dayRanges) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.eventRangeToSegs(eventRange, dayRanges));
        return segs;
    }
    eventRangeToSegs(eventRange, dayRanges) {
        let { dateEnv: dateEnv } = this.context;
        let { nextDayThreshold: nextDayThreshold } = this.context.options;
        let range = eventRange.range;
        let allDay = eventRange.def.allDay;
        let dayIndex;
        let segRange;
        let seg;
        let segs = [];
        for(dayIndex = 0; dayIndex < dayRanges.length; dayIndex += 1){
            segRange = (0, $9b1rB.o)(range, dayRanges[dayIndex]);
            if (segRange) {
                seg = {
                    component: this,
                    eventRange: eventRange,
                    start: segRange.start,
                    end: segRange.end,
                    isStart: eventRange.isStart && segRange.start.valueOf() === range.start.valueOf(),
                    isEnd: eventRange.isEnd && segRange.end.valueOf() === range.end.valueOf(),
                    dayIndex: dayIndex
                };
                segs.push(seg);
                // detect when range won't go fully into the next day,
                // and mutate the latest seg to the be the end.
                if (!seg.isEnd && !allDay && dayIndex + 1 < dayRanges.length && range.end < dateEnv.add(dayRanges[dayIndex + 1].start, nextDayThreshold)) {
                    seg.end = range.end;
                    seg.isEnd = true;
                    break;
                }
            }
        }
        return segs;
    }
}
function $90c2592c0760f4e8$var$renderNoEventsInner(renderProps) {
    return renderProps.text;
}
function $90c2592c0760f4e8$var$computeDateVars(dateProfile) {
    let dayStart = (0, $9b1rB.q)(dateProfile.renderRange.start);
    let viewEnd = dateProfile.renderRange.end;
    let dayDates = [];
    let dayRanges = [];
    while(dayStart < viewEnd){
        dayDates.push(dayStart);
        dayRanges.push({
            start: dayStart,
            end: (0, $9b1rB.t)(dayStart, 1)
        });
        dayStart = (0, $9b1rB.t)(dayStart, 1);
    }
    return {
        dayDates: dayDates,
        dayRanges: dayRanges
    };
}
// Returns a sparse array of arrays, segs grouped by their dayIndex
function $90c2592c0760f4e8$var$groupSegsByDay(segs) {
    let segsByDay = []; // sparse array
    let i;
    let seg;
    for(i = 0; i < segs.length; i += 1){
        seg = segs[i];
        (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = [])).push(seg);
    }
    return segsByDay;
}
var $90c2592c0760f4e8$var$css_248z = ":root{--fc-list-event-dot-width:10px;--fc-list-event-hover-bg-color:#f5f5f5}.fc-theme-standard .fc-list{border:1px solid var(--fc-border-color)}.fc .fc-list-empty{align-items:center;background-color:var(--fc-neutral-bg-color);display:flex;height:100%;justify-content:center}.fc .fc-list-empty-cushion{margin:5em 0}.fc .fc-list-table{border-style:hidden;width:100%}.fc .fc-list-table tr>*{border-left:0;border-right:0}.fc .fc-list-sticky .fc-list-day>*{background:var(--fc-page-bg-color);position:sticky;top:0}.fc .fc-list-table thead{left:-10000px;position:absolute}.fc .fc-list-table tbody>tr:first-child th{border-top:0}.fc .fc-list-table th{padding:0}.fc .fc-list-day-cushion,.fc .fc-list-table td{padding:8px 14px}.fc .fc-list-day-cushion:after{clear:both;content:\"\";display:table}.fc-theme-standard .fc-list-day-cushion{background-color:var(--fc-neutral-bg-color)}.fc-direction-ltr .fc-list-day-text,.fc-direction-rtl .fc-list-day-side-text{float:left}.fc-direction-ltr .fc-list-day-side-text,.fc-direction-rtl .fc-list-day-text{float:right}.fc-direction-ltr .fc-list-table .fc-list-event-graphic{padding-right:0}.fc-direction-rtl .fc-list-table .fc-list-event-graphic{padding-left:0}.fc .fc-list-event.fc-event-forced-url{cursor:pointer}.fc .fc-list-event:hover td{background-color:var(--fc-list-event-hover-bg-color)}.fc .fc-list-event-graphic,.fc .fc-list-event-time{white-space:nowrap;width:1px}.fc .fc-list-event-dot{border:calc(var(--fc-list-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-list-event-dot-width)/2);box-sizing:content-box;display:inline-block;height:0;width:0}.fc .fc-list-event-title a{color:inherit;text-decoration:none}.fc .fc-list-event.fc-event-forced-url:hover a{text-decoration:underline}";
(0, $9b1rB.ct)($90c2592c0760f4e8$var$css_248z);

});


parcelRegister("7lZL8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55aa66aa9b3e05d3$export$2e2bcd8739ae039; });
var $55aa66aa9b3e05d3$export$2e2bcd8739ae039 = {
    code: 'pt-br',
    buttonText: {
        prev: 'Anterior',
        next: "Pr\xf3ximo",
        prevYear: 'Ano anterior',
        nextYear: "Pr\xf3ximo ano",
        year: 'Ano',
        today: 'Hoje',
        month: "M\xeas",
        week: 'Semana',
        day: 'Dia',
        list: 'Lista'
    },
    buttonHints: {
        prev: '$0 Anterior',
        next: "Pr\xf3ximo $0",
        today (buttonText) {
            return buttonText === 'Dia' ? 'Hoje' : (buttonText === 'Semana' ? 'Esta' : 'Este') + ' ' + buttonText.toLocaleLowerCase();
        }
    },
    viewHint (buttonText) {
        return 'Visualizar ' + (buttonText === 'Semana' ? 'a' : 'o') + ' ' + buttonText.toLocaleLowerCase();
    },
    weekText: 'Sm',
    weekTextLong: 'Semana',
    allDayText: 'dia inteiro',
    moreLinkText (n) {
        return 'mais +' + n;
    },
    moreLinkHint (eventCnt) {
        return `Mostrar mais ${eventCnt} eventos`;
    },
    noEventsText: "N\xe3o h\xe1 eventos para mostrar",
    navLinkHint: 'Ir para $0',
    closeHint: 'Fechar',
    timeHint: 'A hora',
    eventHint: 'Evento'
};

});


parcelRegister("cxOGa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921fe0ee337e08ce$export$2e2bcd8739ae039; });
var $921fe0ee337e08ce$export$2e2bcd8739ae039 = {
    name: 'ModalInfoEventoCalendario',
    props: [
        'eventoInfo',
        'loading',
        "isReadOnly"
    ],
    emits: [
        'click:close',
        'click:edit-evento',
        'click:delete-evento'
    ],
    methods: {
        formatarIntervaloDeData (dataInicio, dataFim) {
            const opcoesData = {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            };
            const opcoesHora = {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            };
            const formatadorData = new Intl.DateTimeFormat('pt-BR', opcoesData);
            const formatadorHora = new Intl.DateTimeFormat('pt-BR', opcoesHora);
            const dataFormatada = formatadorData.format(dataInicio);
            const horaInicioFormatada = formatadorHora.format(dataInicio);
            const horaFimFormatada = formatadorHora.format(dataFim);
            return `${dataFormatada} ${horaInicioFormatada} - ${horaFimFormatada}`;
        },
        onClickCancelarEvento () {
            this.$emit('click:delete-evento', this.eventoInfo?.extendedProps?.idEventoOriginal || null);
        }
    },
    computed: {
        dataEventoFormatada () {
            const dataInicio = this.eventoInfo?.extendedProps?.dataEventoInicio ? new Date(this.eventoInfo?.extendedProps?.dataEventoInicio) : null;
            const dataFim = this.eventoInfo?.extendedProps?.dataEventoFim ? new Date(this.eventoInfo?.extendedProps?.dataEventoFim) : null;
            if (!dataInicio || !dataFim) return '';
            return this.formatarIntervaloDeData(dataInicio, dataFim);
        },
        locationEventoFormatada () {
            return this.eventoInfo?.extendedProps?.localEvento || '';
        },
        organizadorEvento () {
            if (this.eventoInfo?.extendedProps?.isOrganizador) return "Voc\xea \xe9 o organizador";
            return "Voc\xea n\xe3o \xe9 o organizador";
        },
        membrosEvento () {
            if (this.eventoInfo?.extendedProps?.membrosEventos) return this.eventoInfo?.extendedProps?.membrosEventos;
        }
    },
    watch: {},
    template: `
        <section 
            class="modal--content rounded-md relative flex-1 !w-full !h-max overflow-[initial]" 
            data-id="modal_info_evento_calendario"
            id="modal_info_evento_calendario">

            <q-btn icon="close" size="lg" rounded class="absolute top-4 right-4 text-primary-pure"  @click="$emit('click:close')"/>

            <div class="bg-primary-pure w-full h-4">
            </div>

            <div class="
                flex
                flex-col
                !gap-y-16
                w-full 
                h-full 
                overflow-auto 
                p-20
                mt-10 
                border 
                border-transparent">
                <h1 class="text-title-4 text-bold">Calend\xe1rio</h1>

                <div class="flex items-center gap-4 w-full">
                    <q-icon name="calendar_month" color="primary" size="md"/>

                    <p class="text-title-4">{{eventoInfo?.title || ""}}</p>
                </div> 

                <q-btn 
                    icon="videocam" 
                    color="primary" 
                    label="ingressar" 
                    :href="eventoInfo?.extendedProps?.urlTeams || ''" 
                    class="btn h-48"/>

                <div class="bg-neutral-40 w-full h-1 rounded"></div>

                <div class="flex items-center w-full gap-12">
                    <q-icon name="timer" size="md"/>

                    <p class="text-title-4">{{dataEventoFormatada || ''}}</p>
                </div>

                <div class="bg-neutral-40 w-full h-1 rounded"></div>

                <div class="flex items-center w-full gap-12">
                    <q-icon name="location_on" size="md"/>

                    <p class="text-title-4">{{locationEventoFormatada || ''}}</p>
                </div>

                <div class="bg-neutral-40 w-full h-1 rounded"></div>

                <div class="flex items-start w-full gap-12">
                    <q-icon name="group" size="md"/>

                    <div class="flex flex-col !gap-y-4">
                        <p class="text-title-4">{{organizadorEvento}}</p>
                        <span 
                            v-for="(membro, index) in membrosEvento || []" 
                            :key="index" 
                            class="text-body-2 text-paragraph-3 text-neutral-70">{{membro.email}} - {{membro.status}}</span>
                    </div>
                </div>

                <div v-if="!isReadOnly" class="flex justify-center items-center w-full !gap-x-20">
                    <q-btn class="btn !min-w-[7rem] h-48 secondary" size="md" :disabled="loading" @click="$emit('click:edit-evento', eventoInfo?.id || null)">
                        <q-icon name="edit"/>
                        <span>Editar</span>
                    </q-btn>
                    <q-btn class="btn min-w-[7rem] h-48 primary" size="md" @click="onClickCancelarEvento" :loading="loading">
                        <q-icon name="cancel_presentation"/>
                        <span>Cancelar</span>
                    </q-btn>
                   
                </div>
            </div>
        </section>
    `
};

});

parcelRegister("dJYFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a00e8b2ff7c6847d$export$2e2bcd8739ae039; });

var $67nR7 = parcelRequire("67nR7");

var $hFNAS = parcelRequire("hFNAS");

var $jzAJi = parcelRequire("jzAJi");

var $hmmUY = parcelRequire("hmmUY");

var $g8vIm = parcelRequire("g8vIm");

var $5q0Z8 = parcelRequire("5q0Z8");

var $YrtCO = parcelRequire("YrtCO");
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5q0Z8))));
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($YrtCO))));
const { showToastify: $a00e8b2ff7c6847d$var$showToastify } = GLOBAL;
let $a00e8b2ff7c6847d$var$editorEventoQuill = null;
let $a00e8b2ff7c6847d$var$clienteSelecionado = null;
const $a00e8b2ff7c6847d$var$TIPO_USUARIO = {
    CLIENTE_PF: 'PF',
    FUNDACAO: 'FUNDACAO'
};
const $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO = {
    CLIENTE_PF: 'cliente_pf',
    FUNDACAO: 'fundacao',
    SEM_ATENDIMENTO: 'sem_atendimento'
};
const $a00e8b2ff7c6847d$var$EMAILS_CLIENTES_FIXOS = [
    'ri@unifinance.com.br',
    'ri@ufinvestimentos.com.br'
];
const $a00e8b2ff7c6847d$var$tempoAgendamento = [
    {
        label: "N\xe3o lembrar",
        value: null
    },
    {
        label: '5 minutos',
        value: 5
    },
    {
        label: '15 minutos',
        value: 15
    },
    {
        label: '30 minutos',
        value: 30
    },
    {
        label: '1 hora',
        value: 60
    },
    {
        label: '2 horas',
        value: 120
    },
    {
        label: '3 horas',
        value: 180
    },
    {
        label: '12 horas',
        value: 720
    },
    {
        label: '1 dia',
        value: 1440
    },
    {
        label: '1 semana',
        value: 10080
    }
];
const { getClientesPf: $a00e8b2ff7c6847d$var$getClientesPf } = (0, $hFNAS.clientePfService)();
const { getInfoAtendimentoCliente: $a00e8b2ff7c6847d$var$getInfoAtendimentoCliente } = (0, $jzAJi.clientAssetsService)();
const { getInformacoesFundacao: $a00e8b2ff7c6847d$var$getInformacoesFundacao } = (0, $hmmUY.fundacaoService)();
const { formatDateObject: $a00e8b2ff7c6847d$var$formatDateObject } = GLOBAL;
var $a00e8b2ff7c6847d$export$2e2bcd8739ae039 = {
    name: 'ModalNovoEventoCalendario',
    props: [
        'loading',
        'eventoEdit',
        'isEditModo',
        'isDoubleClick',
        'isOpenModal',
        'isDesativado'
    ],
    emits: [
        'click:close-modal',
        'click:criar-evento',
        'click:atualiza-evento'
    ],
    data () {
        return {
            model: {
                titulo: null,
                convidados: null,
                dataEvento: null,
                horaEventoInicio: null,
                horaEventoFim: null,
                localEvento: null,
                descricaoEvento: null,
                isDiaInteiro: false,
                isTeams: false,
                isTemAtendimento: false,
                tipoClienteAtendimento: $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO,
                usuarioSelecionado: null,
                tipoAtendimento: null,
                dataPolitica: null,
                lembreteAtendimento: $a00e8b2ff7c6847d$var$tempoAgendamento[0].value
            },
            optionsTipoAtendimento: [
                {
                    label: "Pol\xedtica de Atendimento",
                    value: 0
                },
                {
                    label: 'Outro',
                    value: 1
                }
            ],
            optionsLembreteAtendimento: [
                ...$a00e8b2ff7c6847d$var$tempoAgendamento
            ],
            optionsDataAtendimentoUsuario: [],
            optionsUsuarioSelect: [],
            qeditor: null,
            isReadOnly: false,
            labelBotaoPrincipal: 'Salvar evento',
            loadingUsuarios: false,
            loadingDataAtendimento: false,
            clientesPf: [],
            fundacoes: []
        };
    },
    computed: {
        isRequiredInput () {
            return !this.isReadOnly;
        },
        tituloModal () {
            if (this.isEditModo && this.isReadOnly) return 'Evento';
            else if (this.isEditModo && !this.isReadOnly) return 'Editar evento';
            else return 'Novo evento';
        },
        isDisableFieldsEditFormulario () {
            return this.isEditModo && this.isDoubleClick && this.isReadOnly;
        },
        dataEventoFormatadaInfo () {
            if (!this.eventoEdit?.dataEventoInicio || !this.eventoEdit?.dataEventoFim) return '';
            const meses = [
                'janeiro',
                'fevereiro',
                "mar\xe7o",
                'abril',
                'maio',
                'junho',
                'julho',
                'agosto',
                'setembro',
                'outubro',
                'novembro',
                'dezembro'
            ];
            const inicio = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(this.eventoEdit.dataEventoInicio).toDate();
            const fim = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(this.eventoEdit.dataEventoFim).toDate();
            if (isNaN(inicio.getTime()) || isNaN(fim.getTime())) return '';
            const dia = inicio.getDate();
            const mes = meses[inicio.getMonth()];
            const ano = inicio.getFullYear();
            const horaInicio = inicio.toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit'
            });
            const horaFim = fim.toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit'
            });
            if (this.eventoEdit.isDiaInteiro) return `${dia} de ${mes} de ${ano} (Dia inteiro)`;
            return `${dia} de ${mes} de ${ano} ${horaInicio} - ${horaFim}`;
        },
        lembreteFormatado () {
            const minutos = this.eventoEdit?.dataLembrete;
            if (typeof minutos !== 'number' || isNaN(minutos) || minutos <= 0) return '';
            const SEMANA = 10080 // minutos
            ;
            const DIA = 1440;
            const HORA = 60;
            let resto = minutos;
            const semanas = Math.floor(resto / SEMANA);
            resto = resto % SEMANA;
            const dias = Math.floor(resto / DIA);
            resto = resto % DIA;
            const horas = Math.floor(resto / HORA);
            const min = resto % HORA;
            let partes = [];
            if (semanas > 0) partes.push(`${semanas} semana${semanas > 1 ? 's' : ''}`);
            if (dias > 0) partes.push(`${dias} dia${dias > 1 ? 's' : ''}`);
            if (horas > 0) partes.push(`${horas} hora${horas > 1 ? 's' : ''}`);
            if (min > 0) partes.push(`${min} minuto${min > 1 ? 's' : ''}`);
            return partes.length > 0 ? partes.join(' e ') : '0 minuto';
        },
        atendimentoInfo () {
            const usuario = this.eventoEdit?.atendimento_data || null;
            const usuarioInfo = {};
            if (usuario === null) return null;
            if (usuario?.cliente_pf) {
                usuarioInfo.tipo = 'Cliente PF';
                usuarioInfo.nome = usuario.nome_cliente_pf;
                usuarioInfo.data_atendimento = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(usuario.data).format('DD/MM/YYYY');
            } else if (usuario?.fundacao) {
                usuarioInfo.tipo = "Funda\xe7\xe3o";
                usuarioInfo.nome = usuario.nome_fundacao || usuario.sigla_fundacao;
                usuarioInfo.data_atendimento = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(usuario.data).format('DD/MM/YYYY');
            }
            return usuarioInfo;
        }
    },
    watch: {
        'model.tipoAtendimento': {
            immediate: true,
            handler (novoValor) {
                if (novoValor?.value === 0) this.model.dataPolitica = null;
            }
        },
        'model.isTemAtendimento': {
            immediate: true,
            handler (novoValor) {
                if (!novoValor) {
                    this.model.tipoClienteAtendimento = $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO;
                    this.model.dataPolitica = null;
                    this.model.tipoAtendimento = null;
                } else if (!this.isEditModo || !this.eventoEdit) this.model.tipoClienteAtendimento = $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.CLIENTE_PF;
            }
        },
        'model.usuarioSelecionado': {
            immediate: true,
            handler (novoUsuario) {
                if (this.isEditModo && this.eventoEdit) return;
                this.optionsDataAtendimentoUsuario = [];
                this.model.dataPolitica = null;
                this.initEmailConvidados();
                if (novoUsuario) {
                    if (novoUsuario.value.tipo.toLowerCase() === $a00e8b2ff7c6847d$var$TIPO_USUARIO.FUNDACAO.toLowerCase()) this.setAtendimentoFundacao(novoUsuario.value.id);
                    else if (novoUsuario.value.tipo.toLowerCase() === $a00e8b2ff7c6847d$var$TIPO_USUARIO.CLIENTE_PF.toLowerCase()) this.setAtendimentoClientepf(novoUsuario.value.id);
                } else if ($a00e8b2ff7c6847d$var$clienteSelecionado) {
                    $a00e8b2ff7c6847d$var$clienteSelecionado?.cliente?.contatos?.forEach((contato)=>{
                        this.removerConvidado(contato?.email);
                    });
                    $a00e8b2ff7c6847d$var$clienteSelecionado = null;
                }
            }
        },
        isOpenModal: {
            immediate: true,
            handler (valor) {
                if (valor) this.initEmailConvidados();
                else this.resetarCamposModal();
            }
        },
        eventoEdit: {
            immediate: true,
            async handler (novoEvento) {
                let isTemAtendimento = false;
                let tipoClienteAtendimento = $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO;
                if (novoEvento && this.isEditModo) {
                    this.isReadOnly = this.isDoubleClick ? true : false;
                    this.labelBotaoPrincipal = this.isDoubleClick ? 'Editar evento' : 'Salvar evento';
                    if (novoEvento.atendimento_data) {
                        isTemAtendimento = true;
                        const atendimento = novoEvento.atendimento_data;
                        if (atendimento.cliente_pf) {
                            tipoClienteAtendimento = $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.CLIENTE_PF;
                            this.clientesPf.push(atendimento);
                            this.model.usuarioSelecionado = {
                                label: atendimento.nome_cliente_pf || atendimento.nome,
                                value: {
                                    id: atendimento.cliente_pf,
                                    tipo: $a00e8b2ff7c6847d$var$TIPO_USUARIO.CLIENTE_PF
                                }
                            };
                        } else if (atendimento.fundacao) {
                            tipoClienteAtendimento = $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.FUNDACAO;
                            this.fundacoes.push(atendimento);
                            this.model.usuarioSelecionado = {
                                label: atendimento.nome_fundacao || atendimento.sigla || atendimento.nome,
                                value: {
                                    id: atendimento.fundacao,
                                    tipo: $a00e8b2ff7c6847d$var$TIPO_USUARIO.FUNDACAO
                                }
                            };
                        }
                        this.optionsDataAtendimentoUsuario = [
                            {
                                label: $a00e8b2ff7c6847d$var$formatDateObject(new Date(atendimento.data)),
                                value: atendimento.id
                            }
                        ];
                        this.model.dataPolitica = this.optionsDataAtendimentoUsuario[0] || null;
                        if (atendimento?.tipo) this.model.tipoAtendimento = this.optionsTipoAtendimento.find((opt)=>opt.value === Number(atendimento.tipo)) || null;
                        this.model.tipoClienteAtendimento = tipoClienteAtendimento;
                    }
                    const convidadosEmails = (novoEvento.membrosEventos || []).map((membro)=>membro.email);
                    const corpoEmail = this.extrairAntesSeparador(novoEvento.descricaoEvento);
                    const lembreteOption = this.optionsLembreteAtendimento?.find((opt)=>opt.value === novoEvento.dataLembrete) || null;
                    const dataFormatada = GLOBAL.formatDateObject(new Date(novoEvento.dataEventoInicio)) || null;
                    const startEvento = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(novoEvento.dataEventoInicio).tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm:ss');
                    const endEvento = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(novoEvento.dataEventoFim).tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm:ss');
                    this.model = {
                        titulo: novoEvento.titulo || '',
                        convidados: convidadosEmails.join(', '),
                        dataEvento: dataFormatada,
                        horaEventoInicio: this.formatarHoraParaInput(startEvento),
                        horaEventoFim: this.formatarHoraParaInput(endEvento),
                        localEvento: novoEvento.localEvento || '',
                        descricaoEvento: corpoEmail || '',
                        isDiaInteiro: !!novoEvento.isDiaInteiro,
                        isTeams: !!novoEvento.isTeams,
                        isTemAtendimento: isTemAtendimento,
                        lembreteAtendimento: lembreteOption,
                        tipoClienteAtendimento: tipoClienteAtendimento,
                        usuarioSelecionado: this.model.usuarioSelecionado,
                        tipoAtendimento: this.model.tipoAtendimento,
                        dataPolitica: this.model.dataPolitica
                    };
                    this.qeditor = corpoEmail || '';
                    this.isReadOnly = this.isDoubleClick ? false : true;
                    this.labelBotaoPrincipal = this.isDoubleClick ? 'Salvar evento' : 'Editar evento';
                    $a00e8b2ff7c6847d$var$editorEventoQuill.root.innerHTML = this.model.descricaoEvento;
                } else {
                    this.resetarCamposModal();
                    this.isReadOnly = false;
                    this.labelBotaoPrincipal = 'Salvar evento';
                }
                this.initEmailConvidados();
            }
        },
        isEditModo: {
            immediate: true,
            handler (valor) {
                if (valor) {
                    this.isReadOnly = this.isDoubleClick ? true : false;
                    this.labelBotaoPrincipal = this.isDoubleClick ? 'Editar evento' : 'Salvar evento';
                } else {
                    this.isReadOnly = false;
                    this.labelBotaoPrincipal = 'Salvar evento';
                }
            }
        },
        isReadOnly: {
            immediate: true,
            handler (valor) {
                if ($a00e8b2ff7c6847d$var$editorEventoQuill) $a00e8b2ff7c6847d$var$editorEventoQuill.enable(!valor);
            }
        },
        isDoubleClick: {
            immediate: true,
            handler (valor) {
                if (valor && this.isEditModo) {
                    this.isReadOnly = false;
                    this.labelBotaoPrincipal = 'Salvar evento';
                }
            }
        },
        'model.tipoClienteAtendimento': {
            immediate: true,
            async handler (novoTipo) {
                if (this.isEditModo && this.eventoEdit) return;
                await this.buscarUsuarios(novoTipo);
                if (novoTipo === 'cliente_pf') this.optionsUsuarioSelect = this.clientesPf.map((cliente)=>({
                        label: cliente.nome,
                        value: {
                            id: cliente.id,
                            tipo: $a00e8b2ff7c6847d$var$TIPO_USUARIO.CLIENTE_PF
                        }
                    }));
                else if (novoTipo === 'fundacao') this.optionsUsuarioSelect = this.fundacoes.map((fundacao)=>({
                        label: fundacao.sigla,
                        value: {
                            id: fundacao.id,
                            tipo: $a00e8b2ff7c6847d$var$TIPO_USUARIO.FUNDACAO
                        }
                    }));
                else this.optionsUsuarioSelect = [];
                this.model.usuarioSelecionado = null;
                this.removerConvidado();
            }
        }
    },
    methods: {
        ruleUsuarioSelecionado (val) {
            if (this.model.isTemAtendimento) return !!val || "Obrigat\xf3rio";
            return true;
        },
        ruleDiaIneiroSelecionado (val) {
            if (!this.model.isDiaInteiro) return !!val || "Obrigat\xf3rio";
            return true;
        },
        acumularClienteSelecionado (cliente) {
            let clienteData = null;
            if (!cliente) return;
            if (this.model.tipoClienteAtendimento === $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.CLIENTE_PF) {
                clienteData = cliente.clientes[0];
                clienteData.tipoCliente = $a00e8b2ff7c6847d$var$TIPO_USUARIO.CLIENTE_PF;
            } else if (this.model.tipoClienteAtendimento === $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.FUNDACAO) {
                clienteData = cliente.fundacoes[0];
                clienteData.tipoCliente = $a00e8b2ff7c6847d$var$TIPO_USUARIO.FUNDACAO;
            }
            return {
                cliente: {
                    ...clienteData,
                    contatos: cliente.contatos
                }
            };
        },
        removerConvidado (email) {
            if (!email) return;
            let convidados = this.convertConvidadosStringToArray(this.model.convidados);
            convidados = convidados.filter((item)=>item !== email.trim());
            this.model.convidados = convidados.join(', ');
        },
        adicionarConvidado (email) {
            if (!email) return;
            let convidados = this.convertConvidadosStringToArray(this.model.convidados);
            if (!convidados.includes(email.trim())) {
                convidados.push(email.trim());
                this.model.convidados = convidados.join(', ');
            }
        },
        initEmailConvidados () {
            if (!this.isEditModo) this.model.convidados = $a00e8b2ff7c6847d$var$EMAILS_CLIENTES_FIXOS.join(', ');
        },
        formatarDataEvento () {
            let val = this.model.dataEvento;
            let dia, mes, ano;
            if (/^\d{4}-\d{2}-\d{2}$/.test(val)) [ano, mes, dia] = val.split('-');
            else if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) [dia, mes, ano] = val.split('/');
            else if (/^\d{2} \w{3}\. \d{4}$/.test(val)) return;
            else return;
            const meses = [
                'jan',
                'fev',
                'mar',
                'abr',
                'mai',
                'jun',
                'jul',
                'ago',
                'set',
                'out',
                'nov',
                'dez'
            ];
            const mesFormatado = meses[parseInt(mes, 10) - 1];
            if (dia && mesFormatado && ano) this.model.dataEvento = `${parseInt(dia, 10)} ${mesFormatado}. ${ano}`;
        },
        formatarHoraInput (e) {
            let valor = e.target.value.trim();
            if (/^:\d{1,2}$/.test(valor)) {
                const min = valor.replace(':', '').padStart(2, '0');
                valor = `00:${min}`;
            } else {
                valor = valor.replace(/\D/g, '');
                if (valor.length === 0) {
                    e.target.value = '';
                    this.model.horaEvento = '';
                    return '';
                }
                if (valor.length === 1) valor = `0${valor}:00`;
                else if (valor.length === 2) valor = `${valor}:00`;
                else if (valor.length === 3) valor = `${valor.slice(0, 2)}:${valor.slice(2)}0`;
                else if (valor.length >= 4) valor = `${valor.slice(0, 2)}:${valor.slice(2, 4)}`;
            }
            return valor;
        },
        formatarDataParaInput (dataIso) {
            if (!dataIso) return '';
            if (typeof dataIso === 'string') {
                const [date] = dataIso.split('T');
                if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
            }
            return '';
        },
        formatarHoraParaInput (dataIso) {
            if (!dataIso) return '';
            if (typeof dataIso === 'string') {
                const partes = dataIso.split('T');
                if (partes.length > 1) {
                    const hora = partes[1].slice(0, 5);
                    if (/^\d{2}:\d{2}$/.test(hora)) return hora;
                } else if (/^\d{2}:\d{2}$/.test(dataIso)) return dataIso;
            }
            return '';
        },
        formataDataIsoLocal (dateObj) {
            const dataObjLocal = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(dateObj);
            const stringIsoLocal = dataObjLocal.format('YYYY-MM-DDTHH:mm:ss');
            return stringIsoLocal;
        },
        formatarDataEventoDiaInteiro (dateObj) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(dateObj).isValid()) return '';
            return (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(dateObj).format('YYYY-MM-DDTHH:mm:ss');
        },
        extrairAntesSeparador (texto) {
            const separador = '\r\n\r\n\r\n________________________________________________________________________________\r';
            const indice = texto.indexOf(separador);
            if (indice === -1) return texto;
            return texto.substring(0, indice);
        },
        createEditorEventoQuill () {
            const SizeStyle = (0, $67nR7.default).import('attributors/style/size');
            const AlignStyle = (0, $67nR7.default).import('attributors/style/align');
            SizeStyle.whitelist = null;
            (0, $67nR7.default).register(AlignStyle, true);
            (0, $67nR7.default).register(SizeStyle, true);
            $a00e8b2ff7c6847d$var$editorEventoQuill = new (0, $67nR7.default)('#texto-descricao-evento', {
                theme: 'snow',
                formats: [
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'size',
                    'color',
                    'list',
                    'bullet',
                    'check',
                    'background',
                    'align',
                    'header',
                    'clean'
                ],
                modules: {
                    toolbar: [
                        [
                            {
                                header: [
                                    1,
                                    2,
                                    false
                                ]
                            }
                        ],
                        [
                            {
                                size: [
                                    'small',
                                    false,
                                    'large',
                                    'huge'
                                ]
                            }
                        ],
                        [
                            'bold',
                            'italic',
                            'underline'
                        ],
                        [
                            {
                                list: 'ordered'
                            },
                            {
                                list: 'bullet'
                            },
                            {
                                list: 'check'
                            }
                        ],
                        [
                            'clean'
                        ]
                    ]
                }
            });
            $a00e8b2ff7c6847d$var$editorEventoQuill.on('text-change', ()=>{
                this.qeditor = $a00e8b2ff7c6847d$var$editorEventoQuill.root.innerHTML;
                this.model.descricaoEvento = $a00e8b2ff7c6847d$var$editorEventoQuill.root.innerHTML;
            });
            $a00e8b2ff7c6847d$var$editorEventoQuill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta)=>{
                return delta;
            });
            if (this.qeditor) $a00e8b2ff7c6847d$var$editorEventoQuill.root.innerHTML = this.qeditor;
        },
        converterDataParaIso (dataFormatada) {
            if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dataFormatada)) return '';
            const [dia, mes, ano] = dataFormatada.split('/');
            return `${ano}-${mes}-${dia}`;
        },
        convertConvidadosStringToArray (convidadosString) {
            if (!convidadosString) return [];
            return convidadosString.split(',').map((email)=>email.trim()).filter((email)=>email);
        },
        isDataFormatoAbreviado (data) {
            return /^\d{1,2} \w{3}\.? \d{4}$/.test(data);
        },
        closeModal () {
            this.$emit('click:close-modal');
        },
        atualizarQuillComDescricao () {
            if (this.isEditModo && $a00e8b2ff7c6847d$var$editorEventoQuill && this.model.descricaoEvento) $a00e8b2ff7c6847d$var$editorEventoQuill.root.innerHTML = this.model.descricaoEvento;
        },
        criarEventoCalendario () {
            const dataIso = this.converterDataParaIso(this.model.dataEvento);
            let horaInicio = this.model.horaEventoInicio;
            let horaFim = this.model.horaEventoFim;
            let dataEventoFim = dataIso;
            if (this.model.isDiaInteiro) {
                horaInicio = '00:00:00';
                const dataObj = new Date(dataIso);
                dataObj.setDate(dataObj.getDate() + 1);
                dataEventoFim = dataObj.toISOString().slice(0, 10);
                horaFim = '00:00:00';
            } else {
                horaInicio = horaInicio ? `${horaInicio}:00` : '';
                horaFim = horaFim ? `${horaFim}:00` : '';
            }
        },
        criarDatasEvento () {
            const { dataEvento: dataEvento, horaEventoInicio: horaEventoInicio, horaEventoFim: horaEventoFim, isDiaInteiro: isDiaInteiro } = this.model;
            let dataIso = this.converterDataParaIso(dataEvento);
            let dataInicioEvento, dataFimEvento;
            if (isDiaInteiro) {
                dataInicioEvento = new Date(`${dataIso}T00:00:00`);
                dataFimEvento = new Date(dataInicioEvento);
                dataFimEvento.setDate(dataFimEvento.getDate() + 1);
                dataFimEvento.setHours(0, 0, 0, 0);
            } else {
                const horaIni = horaEventoInicio ? `${horaEventoInicio}` : '00:00:00';
                const horaFim = horaEventoFim ? `${horaEventoFim}` : '00:00:00';
                dataInicioEvento = new Date(`${dataIso}T${horaIni}`);
                dataFimEvento = new Date(`${dataIso}T${horaFim}`);
            }
            if (isNaN(dataInicioEvento.getTime()) || isNaN(dataFimEvento.getTime())) return {
                dataInicioEvento: null,
                dataFimEvento: null
            };
            return {
                dataInicioEvento: dataInicioEvento,
                dataFimEvento: dataFimEvento
            };
        },
        criarPayloadEvento () {
            const { dataInicioEvento: dataInicioEvento, dataFimEvento: dataFimEvento } = this.criarDatasEvento();
            const isDiaInteiro = this.model.isDiaInteiro;
            const usuarioSelecionado = this.model.usuarioSelecionado ? this.model.usuarioSelecionado.value : null;
            const tipoAtendimento = this.model.tipoAtendimento?.value != null ? this.model.tipoAtendimento.value : null;
            const dataPolitica = this.model.dataPolitica?.value instanceof Date ? this.formataDataIsoLocal(this.model.dataPolitica.value) : this.model.dataPolitica?.value;
            const lembreteAtendimento = this.model.lembreteAtendimento?.value != null ? this.model.lembreteAtendimento.value : null;
            const payload = {
                ...this.model,
                convidados: this.convertConvidadosStringToArray(this.model.convidados),
                dataEventoInicio: isDiaInteiro ? this.formatarDataEventoDiaInteiro(dataInicioEvento) : this.formataDataIsoLocal(dataInicioEvento),
                dataEventoFim: isDiaInteiro ? this.formatarDataEventoDiaInteiro(dataFimEvento) : this.formataDataIsoLocal(dataFimEvento),
                usuarioSelecionado: usuarioSelecionado,
                tipoAtendimento: tipoAtendimento,
                dataPolitica: dataPolitica,
                lembreteAtendimento: lembreteAtendimento
            };
            return payload;
        },
        criarEventoCalendario () {
            this.$emit('click:criar-evento', this.criarPayloadEvento());
        },
        atualizarEventoCalendario () {
            const payload = this.criarPayloadEvento();
            payload.id = this.eventoEdit?.idEventoOriginal;
            this.$emit('click:atualiza-evento', payload);
        },
        sincronizarHoraFimComInicio () {
            if (this.model.isDiaInteiro) return;
            const inicio = this.model.horaEventoInicio;
            const fim = this.model.horaEventoFim;
            if (inicio && fim) {
                const hoje = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))().format('YYYY-MM-DD');
                const inicioObj = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(`${hoje}T${inicio}`);
                const fimObj = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(`${hoje}T${fim}`);
                if (inicioObj.isAfter(fimObj)) this.model.horaEventoFim = inicio;
            }
        },
        onSubmit (e) {
            e.preventDefault();
            this.$refs.form.validate().then((success)=>{
                if (success) {
                    e.preventDefault();
                    if (this.isEditModo && this.isReadOnly) {
                        this.isReadOnly = false;
                        this.labelBotaoPrincipal = 'Salvar evento';
                    } else if (this.isEditModo && !this.isReadOnly) this.atualizarEventoCalendario();
                    else this.criarEventoCalendario();
                } else $a00e8b2ff7c6847d$var$showToastify("\u274C Por favor, preencha os campos obrigat\xf3rios.");
            });
        },
        onBlurHoraInicio (e) {
            const valor = this.formatarHoraInput(e);
            e.target.value = valor;
            this.model.horaEventoInicio = valor;
            this.sincronizarHoraFimComInicio();
        },
        onBlurHoraFim (e) {
            const valor = this.formatarHoraInput(e);
            e.target.value = valor;
            this.model.horaEventoFim = valor;
            this.sincronizarHoraFimComInicio();
        },
        onBlurHora (e) {
            const valor = this.formatarHoraInput(e);
            this.model.horaEventoInicio = valor;
            e.target.value = valor;
        },
        onInputHora (e) {
            let valor = e.target.value.replace(/[^\d:]/g, '');
            if (/^:\d{1,2}$/.test(valor)) valor = '00:' + valor.slice(1).padStart(2, '0');
            else if (/^\d{1,2}$/.test(valor)) {
                if (valor.length === 2) valor = valor + ':00';
            } else if (/^\d{3,4}$/.test(valor.replace(':', ''))) {
                valor = valor.replace(':', '');
                valor = valor.padStart(4, '0');
                valor = valor.slice(0, 2) + ':' + valor.slice(2, 4);
            } else if (/^\d{2}:\d{2}$/.test(valor)) ;
            else if (/^\d{1}:\d{2}$/.test(valor)) valor = '0' + valor;
            else if (/^\d{2}:\d{1}$/.test(valor)) valor = valor.slice(0, 3) + '0';
            if (valor.length > 5) valor = valor.slice(0, 5);
            e.target.value = valor;
            return valor;
        },
        resetarCamposModal () {
            this.model = {
                titulo: null,
                convidados: null,
                dataEvento: null,
                horaEventoInicio: null,
                horaEventoFim: null,
                localEvento: null,
                descricaoEvento: null,
                isDiaInteiro: false,
                isTeams: false,
                isTemAtendimento: false,
                tipoClienteAtendimento: $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO,
                usuarioSelecionado: null,
                tipoAtendimento: null,
                dataPolitica: null,
                lembreteAtendimento: null
            };
            this.qeditor = null;
            if ($a00e8b2ff7c6847d$var$editorEventoQuill) $a00e8b2ff7c6847d$var$editorEventoQuill.root.innerHTML = '';
            opcaoAnteriorUsuario = null;
            $a00e8b2ff7c6847d$var$clienteSelecionado = null;
            this.clientesPf = [];
            this.fundacoes = [];
            this.optionsUsuarioSelect = [];
            this.optionsDataAtendimentoUsuario = [];
            if (this.$refs.form) this.$refs.form.resetValidation();
        },
        async buscarUsuarios (tipoClientePf = $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO, search = '') {
            this.loadingUsuarios = true;
            const params = {
                page: 1,
                search: search
            };
            try {
                if (this.model.tipoClienteAtendimento === $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.CLIENTE_PF) {
                    const clientesResp = await $a00e8b2ff7c6847d$var$getClientesPf(params);
                    this.clientesPf = clientesResp?.results || [];
                    this.fundacoes = [];
                } else if (this.model.tipoClienteAtendimento === $a00e8b2ff7c6847d$var$TIPO_STATUS_ATENDIMENTO.FUNDACAO) {
                    const { getFundacoes: getFundacoes } = (0, $hmmUY.fundacaoService)();
                    const fundacoesResp = await getFundacoes(params);
                    this.fundacoes = fundacoesResp?.results || [];
                    this.clientesPf = [];
                } else {
                    this.clientesPf = [];
                    this.fundacoes = [];
                }
            } catch (e) {
                console.error("Erro ao buscar usu\xe1rios:", e);
            } finally{
                this.loadingUsuarios = false;
            }
        },
        async filterOptions (val, update) {
            if (!val) {
                update(()=>{});
                return;
            }
            this.loadingUsuarios = true;
            try {
                await this.buscarUsuarios(this.model.tipoClienteAtendimento, val);
                // Atualize as opções do select aqui:
                if (this.model.tipoClienteAtendimento === 'cliente_pf') this.optionsUsuarioSelect = this.clientesPf.map((cliente)=>({
                        label: cliente.nome,
                        value: {
                            id: cliente.id,
                            tipo: 'PF'
                        }
                    }));
                else if (this.model.tipoClienteAtendimento === 'fundacao') this.optionsUsuarioSelect = this.fundacoes.map((fundacao)=>({
                        label: fundacao.sigla,
                        value: {
                            id: fundacao.id,
                            tipo: 'FUNDACAO'
                        }
                    }));
                else this.optionsUsuarioSelect = [];
                opcaoAnteriorUsuario = val;
                update(()=>{});
            } catch (e) {
                console.error("Erro ao filtrar usu\xe1rios:", e);
                update(()=>{});
            } finally{
                this.loadingUsuarios = false;
            }
        },
        async onClearSelect () {
            await this.buscarUsuarios(this.model.tipoClienteAtendimento, '');
            opcaoAnteriorUsuario = null;
            if (this.model.tipoClienteAtendimento === 'cliente_pf') this.optionsUsuarioSelect = this.clientesPf.map((cliente)=>({
                    label: cliente.nome,
                    value: {
                        id: cliente.id,
                        tipo: 'PF'
                    }
                }));
            else if (this.model.tipoClienteAtendimento === 'fundacao') this.optionsUsuarioSelect = this.fundacoes.map((fundacao)=>({
                    label: fundacao.sigla,
                    value: {
                        id: fundacao.id,
                        tipo: 'FUNDACAO'
                    }
                }));
            else this.optionsUsuarioSelect = [];
        },
        async setAtendimentoClientepf (clienteId) {
            if (!clienteId) return;
            this.loadingDataAtendimento = true;
            try {
                const params = {
                    cliente_pf: clienteId
                };
                const responseAtendimento = await $a00e8b2ff7c6847d$var$getInfoAtendimentoCliente('', params) || [];
                const atendimentosValidos = responseAtendimento?.atendimentos?.filter((item)=>item && item.status_atendimento?.toLowerCase() === 'aguardando' && !item.concluido) || [];
                $a00e8b2ff7c6847d$var$clienteSelecionado = this.acumularClienteSelecionado(responseAtendimento);
                this.optionsDataAtendimentoUsuario = atendimentosValidos?.map((item)=>({
                        label: $a00e8b2ff7c6847d$var$formatDateObject(new Date(item.data)),
                        value: item.id
                    }));
                $a00e8b2ff7c6847d$var$clienteSelecionado.cliente.contatos.filter((contato)=>contato?.principal).forEach((contato)=>{
                    this.adicionarConvidado(contato?.email);
                });
            } catch (error) {
                console.error("Erro ao buscar informa\xe7\xf5es do atendimento:", error);
            } finally{
                this.loadingDataAtendimento = false;
            }
        },
        async setAtendimentoFundacao (fundacaoId) {
            if (!fundacaoId) return;
            this.loadingDataAtendimento = true;
            try {
                const params = {
                    fundacao: fundacaoId
                };
                const responseFundacao = await $a00e8b2ff7c6847d$var$getInformacoesFundacao('', params);
                const atendimentosValidos = responseFundacao?.atendimentos?.filter((item)=>item && item.status_atendimento?.toLowerCase() === 'aguardando' && !item.concluido) || [];
                $a00e8b2ff7c6847d$var$clienteSelecionado = this.acumularClienteSelecionado(responseFundacao);
                this.optionsDataAtendimentoUsuario = atendimentosValidos?.map((item)=>({
                        label: $a00e8b2ff7c6847d$var$formatDateObject(new Date(item.data)),
                        value: item.id
                    }));
                $a00e8b2ff7c6847d$var$clienteSelecionado.cliente.contatos.filter((contato)=>contato?.principal).forEach((contato)=>{
                    this.adicionarConvidado(contato?.email);
                });
            } catch (error) {
                console.error("Erro ao buscar informa\xe7\xf5es da funda\xe7\xe3o:", error);
            } finally{
                this.loadingDataAtendimento = false;
            }
        }
    },
    async mounted () {
        this.createEditorEventoQuill();
        await this.buscarUsuarios();
    },
    template: `
        <section class="modal--content rounded-md flex-1 !w-full !h-max overflow-[initial]"
        data-id="modal_novo_evento_calendario"
        id="modal_novo_evento_calendario">
            <header class="flex justify-between items-center bg-primary w-full h-[4.5rem] p-24">
                <h1 class="text-title-2 text-white">{{ tituloModal }}</h1>

                <q-btn icon="close" class="text-white" rounded @click="closeModal"></q-btn>
            </header>
            <q-form ref="form" class="w-full h-full !max-h-[50rem] overflow-auto">
                <div class="grid grid-cols-12 gap-24 py-24">
                    <div class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon v-if="false" name="title" size="md" class="text-neutral-70"/>

						<q-icon size="24px" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_titulo_texto"></use>
							</svg>
						</q-icon>

                        <q-input
                            v-model="model.titulo"
							:disable="isDisableFieldsEditFormulario"
                            name="titulo"
							lazy-rules
							:reactive-rules="false"
                            :rules="[val => !!val || 'Obrigat\xf3rio']"
                            id="input-titulo"
                            label="Adicione um t\xedtulo"
                            label-color="neutral-70"
                            type="text"
							autocomplete="off"
							:error-message-class="'text-negative'"
                            class="!flex-1"
                            />
                    </div>


					<div  class="col-span-full">
						<p class="!ml-[5.3rem] text-headline-2 text-neutral-70 w-max">Atendimento</p>
					</div>

					<div  class="col-span-full flex items-start px-24 gap-16">
						<q-icon size="md" class="text-neutral-70 mr-12">
							<svg>
								<use xlink:href="#icon_chat_mensagem"></use>
							</svg>
						</q-icon>
							
						<div class="!flex !items-center !gap-48 classe-principal">
							<div>
								<label class="text-neutral-70 text-paragraph-2">
									Essa reuni\xe3o precisa gerar um atendimento?
								</label>

								<div class="flex items-center gap-24 mt-16">
									<q-radio v-model="model.isTemAtendimento" :disable="isEditModo" :val="true" label="Sim" class="text-neutral-80 text-headline-2"/>
									<q-radio v-model="model.isTemAtendimento" :disable="isEditModo" :val="false" label="N\xe3o" class="text-neutral-80 text-headline-2"/>
								</div>
							</div>

							<div v-show="model.isTemAtendimento">
								<label class="text-neutral-70 text-paragraph-2">
									Tipo de Cliente
								</label>

								<div class="flex items-center gap-24 mt-16">
									<q-radio v-model="model.tipoClienteAtendimento" :disable="isEditModo" :val="'cliente_pf'" label="Cliente PF" class="text-neutral-80 text-headline-2"/>
									<q-radio v-model="model.tipoClienteAtendimento" :disable="isEditModo" :val="'fundacao'" label="Funda\xe7\xe3o" class="text-neutral-80 text-headline-2"/>
								</div>
							</div>
						</div>
					</div>

					<div v-show="model.isTemAtendimento" class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_add_usuario"></use>
							</svg>
						</q-icon>

						<q-select 
							v-model="model.usuarioSelecionado"
							use-input
    						input-debounce="300" 
							clearable  
							label="Selecione o(s) Cliente(s)" 
							label-color="neutral-70" 
							:disable="isEditModo"
							:options="optionsUsuarioSelect"
							:loading="loadingUsuarios"
							autocomplete="off"
							lazy-rules
							:rules="[ruleUsuarioSelecionado]"
							@filter="filterOptions"
							@clear="onClearSelect"
							class="w-full"/>
					</div>

					<div v-if="model.isTemAtendimento" class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg class="w-full h-full">
								<use xlink:href="#icon_suporte_usuario"></use>
							</svg>
						</q-icon>

						<div class="flex-1 flex justify-between items-center gap-24">
							<q-select 
								v-model="model.tipoAtendimento" 
								label="Tipo de atendimento"  
								label-color="neutral-70" 
								:options="optionsTipoAtendimento"
								:disable="isEditModo"
								lazy-rules
								:rules="[ruleUsuarioSelecionado]"
								autocomplete="off" 
								class="flex-1"/>

							<q-select 
								v-if="model.tipoAtendimento && model?.tipoAtendimento?.value === 0"
								v-model="model.dataPolitica"		 
								label="Data da pol\xedtica"  
								label-color="neutral-70" 
								:loading="loadingDataAtendimento"
								:options="optionsDataAtendimentoUsuario"
								:disable="isEditModo"
								lazy-rules
								:rules="[rule=>true]"
								autocomplete="off"
								class="flex-1"/>
						</div>
					</div>
					
					<div class="col-span-full">
						<p class="!ml-[5.3rem] text-headline-2 text-neutral-70 w-max">Evento</p>
					</div>

                    <div class="col-span-full flex justify-between items-start px-24 gap-24">
						<q-icon size="md" class="text-neutral-70 mt-14">
							<svg>
								<use xlink:href="#icon_email_calendario"></use>
							</svg>
						</q-icon>

                        <div  class="!flex-1 flex flex-col gap-8">
                            <q-input 
								v-model="model.convidados"
								:disable="isDisableFieldsEditFormulario"
                                name="convidados" 
                                id="input-convidados"
                                class="!w-full"
                                label="Adicionar convidados"
                                label-color="neutral-70"
                                type="text" 
								autocomplete="off"
								/>
                            <label class="text-neutral-70 text-paragraph-3">Adicione v\xe1rios convidados separando os e-mails com v\xedrgula (,).</label>
                        </div>  
                    </div>

                    <div class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_relogio"></use>
							</svg>
						</q-icon>	
					

                        <div class="flex-1 grid grid-cols-12 items-center gap-24">
							<q-input
								v-model="model.dataEvento"  
								:disable="isDisableFieldsEditFormulario"
								label="Data"
								label-color="neutral-70"
								placeholder="dd/mm/aaaa"
								class="!col-span-3"
								autocomplete="off"
								mask="##/##/####"
								lazy-rules
								:rules="[val => !!val || 'Obrigat\xf3rio']">
								<template v-slot:append>
									<q-icon name="event" class="cursor-pointer">
									<q-popup-proxy cover transition-show="scale" transition-hide="scale">
										<q-date v-model="model.dataEvento" mask="DD/MM/YYYY">
										<div class="row items-center justify-end">
											<q-btn v-close-popup label="Close" color="primary" flat />
										</div>
										</q-date>
									</q-popup-proxy>
									</q-icon>
								</template>
							</q-input>

                            <div  class="!col-span-2">
                                <q-input
									v-if="!model.isDiaInteiro"
                                    v-model="model.horaEventoInicio"
									:disable="isDisableFieldsEditFormulario"
                                    label="Ini\u{301}cio"
                                    label-color="neutral-70"
                                    name="horaEventoInicio"
                                    id="input-horaEventoInicio"  
                                    type="text"
                                    mask="##:##"
									autocomplete="off"
									lazy-rules
									:rules="[ruleDiaIneiroSelecionado]"
                                    class="w-full h-full"	
                                    @blur="onBlurHoraInicio"
                                    />
                                </div>
                          
                            <div class="!col-span-1">
								<label v-if="!model.isDiaInteiro" class="text-center text-neutral-70">at\xe9</label>
							</div>
                            
                            <div class="!col-span-2">
                                    <q-input
										v-if="!model.isDiaInteiro"
                                        v-model="model.horaEventoFim"
										:disable="isDisableFieldsEditFormulario"
                                        label="Fim"
                                        label-color="neutral-70"
                                        name="horaEventoFim"
										lazy-rules
                                        :rules="[ruleDiaIneiroSelecionado]"
                                        id="input-horaEventoFim"  
                                        type="text"
                                        mask="##:##"
										autocomplete="off"
                                        class="w-full h-full"										
                                        @blur="onBlurHoraFim"
                                    />
                                </div>

                            <span class="col-span-1"></span>

                            <div class="!col-span-3">
                                <q-checkbox 
									v-model="model.isDiaInteiro" 
									:disable="isDisableFieldsEditFormulario"
									size="1.25rem" 
									label="Dia inteiro"
									autocomplete="off"
									class="text-neutral-70"></q-checkbox>
                            </div>
                        </div>
                    </div>

					<div class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_relogio_alarme"></use>
							</svg>
						</q-icon>	

						<q-select 
							v-model="model.lembreteAtendimento"
							:options="optionsLembreteAtendimento"
							:disable="isDisableFieldsEditFormulario"
							clearable
							autocomplete="off"
							label="Lembrete"  
							label-color="neutral-70"
							popup-content-class="select-menu"
							transition-duration="150"
							dropdown-icon="expand_more" 
							class="flex-1 custom-select-style"/>
					</div>

                    <div  class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_localizacao"></use>
							</svg>
						</q-icon>	

                        <q-input
                            v-model="model.localEvento"
							:disable="isDisableFieldsEditFormulario"
                            name="localEvento"
                            
                            id="input-localEvento"
                            class="flex-1 h-48"
                            label="Adicione uma sala ou local"
                            label-color="neutral-70"
                            type="text"
							autocomplete="off"
							/>

                        <div class="flex-1 flex items-center gap-16">
                            <q-checkbox 
								v-model="model.isTeams" 
								size="1.25rem" 
								label="Reuni\xe3o do Teams"
								:disable="isEditModo"
								class="text-neutral-70"></q-checkbox>
							<q-icon v-if="false" name="groups" size="md" class="text-neutral-70"/>

                            <svg class="w-20 h-20">
								<use xlink:href="#icon_atendimento_rapido_email"></use>
							</svg>
                        </div>
                    </div>

                    <div class="col-span-full flex justify-between items-start px-24 gap-24">
					  <q-icon name="format_align_left" size="md" class="text-neutral-70"/>


                      <div class="flex-1">
                        <div id="texto-descricao-evento"></div>
                      </div>
                    </div>

					<div
						class="
							col-span-full 
							flex 
							justify-end 
							items-start 
							px-24 
							gap-24">
						<q-btn
							:disabled="loading"
							class="btn h-48 secondary "
							@click="closeModal">
								Cancelar
						</q-btn>

                       <q-btn             
                            :loading="loading"
							@click="onSubmit"
                            class="btn h-48 primary ">
                                {{ labelBotaoPrincipal }}
                        </q-btn>
                    </div>
                    
                </div>
            </q-form>
        </section>
    `
};

});
parcelRegister("hFNAS", function(module, exports) {

$parcel$export(module.exports, "clientePfService", function () { return $cddcbc4b565be429$export$416a4482a1157361; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $cddcbc4b565be429$export$416a4482a1157361() {
    const api = (0, $c8Lpu.useApi)();
    async function getClientesPf(params = {}) {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).api_clientepf}`, params);
    }
    async function getInformacoesClientePf(clienteId = '') {
        return await api.query(`${window.origin}${(0, $9YhWF.URLS).api_clientepf}${clienteId}`);
    }
    return {
        getClientesPf: getClientesPf,
        getInformacoesClientePf: getInformacoesClientePf,
        ...api
    };
}

});


parcelRegister("kOH5f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f279e5b14995c3bf$export$2e2bcd8739ae039; });
parcelRequire("2m7Ys");

var $iOhKU = parcelRequire("iOhKU");

var $g8vIm = parcelRequire("g8vIm");

var $5q0Z8 = parcelRequire("5q0Z8");

var $YrtCO = parcelRequire("YrtCO");
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5q0Z8))));
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($YrtCO))));
const { getEventos: $f279e5b14995c3bf$var$getEventos, getUsuariosCalendarios: $f279e5b14995c3bf$var$getUsuariosCalendarios, getEventosUsuario: $f279e5b14995c3bf$var$getEventosUsuario, authMicrosoft: $f279e5b14995c3bf$var$authMicrosoft, createEvento: $f279e5b14995c3bf$var$createEvento, updateEvento: $f279e5b14995c3bf$var$updateEvento, deleteEvento: $f279e5b14995c3bf$var$deleteEvento } = (0, $iOhKU.default)();
var $f279e5b14995c3bf$export$2e2bcd8739ae039 = {
    data () {
        return {
            loading: {
                novoEvento: false,
                atualizaEvento: false,
                deletaEvento: false
            },
            error: {
                novoEvento: null,
                atualizaEvento: null,
                deletaEvento: null
            }
        };
    },
    methods: {
        async buscarEventos (params = {}) {
            const response = await $f279e5b14995c3bf$var$getEventos(params);
            if (response && response.results) return response?.results || [];
            return null;
        },
        async buscarUsuariosCalendarios () {
            const response = await $f279e5b14995c3bf$var$getUsuariosCalendarios();
            if (response && response.value) return response?.value || [];
            return null;
        },
        formatarEventos (eventosBrutos) {
            if (eventosBrutos === null) return null;
            const statusEventos = {
                accepted: 'aceito',
                Declined: 'recusado',
                none: "n\xe3o respondeu"
            };
            return eventosBrutos?.map((evento)=>{
                const membrosEventos = evento.attendees.map((attendee)=>({
                        email: attendee.emailAddress.address,
                        status: statusEventos[attendee.status.response] || 'desconhecido'
                    }));
                let dataEventoInicio, dataEventoFim, startEvento, endEvento;
                if (evento.isAllDay) {
                    dataEventoInicio = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(evento.start?.dateTime || evento.start).startOf('day').toDate();
                    dataEventoFim = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(evento.end?.dateTime || evento.end).startOf('day').toDate();
                    startEvento = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(evento.start?.dateTime || evento.start).utc(evento.start?.dateTime || evento.start).utcOffset(180).format('YYYY-MM-DDTHH:mm:ss');
                    endEvento = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(evento.end?.dateTime || evento.end).utc(evento.end?.dateTime || evento.end).utcOffset(180).format('YYYY-MM-DDTHH:mm:ss');
                } else {
                    dataEventoInicio = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(evento.start?.dateTime || evento.start).utc(evento.start?.dateTime || evento.start).utcOffset(-180).toDate();
                    dataEventoFim = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(evento.end?.dateTime || evento.end).utc(evento.end?.dateTime || evento.end).utcOffset(-180).toDate();
                    startEvento = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(evento.start?.dateTime || evento.start).utc(evento.start?.dateTime || evento.start).utcOffset(-180).format('YYYY-MM-DDTHH:mm:ss');
                    endEvento = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(evento.end?.dateTime || evento.end).utc(evento.end?.dateTime || evento.end).utcOffset(-180).format('YYYY-MM-DDTHH:mm:ss');
                }
                return {
                    id: evento.id,
                    title: evento.subject,
                    start: startEvento,
                    end: endEvento,
                    allDay: evento.allDay ?? false,
                    url: evento.webLink || undefined,
                    location: evento.location || undefined,
                    idEventoOriginal: evento.id,
                    titulo: evento.subject,
                    dataEventoInicio: dataEventoInicio || evento.start,
                    dataEventoFim: dataEventoFim || evento.end,
                    localEvento: evento.location?.displayName || '',
                    isDiaInteiro: evento.isAllDay || false,
                    isOrganizador: evento.isOrganizer || false,
                    membrosEventos: membrosEventos,
                    isTeams: evento.isOnlineMeeting || false,
                    urlTeams: evento.onlineMeeting?.joinUrl || null,
                    descricaoEvento: this.limparTextoDeEmail(evento.bodyPreview) || '',
                    dataLembrete: evento.reminderMinutesBeforeStart || null,
                    atendimento_data: evento.atendimento_data || null,
                    isEventoPassado: this.diaJaPassou(dataEventoFim) || false
                };
            });
        },
        limparTextoDeEmail (texto) {
            if (!texto) return '';
            const regexRodape = /\s*_{20,}[\s\S]*/;
            return texto.replace(regexRodape, '').trim();
        },
        filtrarPorData (eventos, data) {
            return eventos.filter((ev)=>ev.start?.startsWith(data));
        },
        agruparPorDia (eventos) {
            return eventos.reduce((acc, ev)=>{
                const dia = ev.start?.substring(0, 10);
                if (!acc[dia]) acc[dia] = [];
                acc[dia].push(ev);
                return acc;
            }, {});
        },
        diaJaPassou (data) {
            const agora = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))();
            const dataComparar = (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(data);
            return dataComparar.isBefore(agora);
        },
        async buscarEventosFormatados (params = {}) {
            const eventosBrutos = await this.buscarEventos(params);
            return this.formatarEventos(eventosBrutos);
        },
        async buscarEventosUsuarioSelecionadoFormatados (params = {}) {
            const eventos = await $f279e5b14995c3bf$var$getEventosUsuario(params);
            return this.formatarEventos(eventos?.value);
        },
        async calendarioAuth () {
            return await $f279e5b14995c3bf$var$authMicrosoft();
        },
        async criarEvento (data) {
            try {
                this.loading.novoEvento = true;
                this.error.novoEvento = null;
                const response = await $f279e5b14995c3bf$var$createEvento(data);
                return response;
            } catch (error) {
                this.error.novoEvento = error;
                console.error('Erro ao criar evento:', error);
            } finally{
                this.loading.novoEvento = false;
            }
        },
        async atualizarEvento (data) {
            try {
                this.loading.atualizaEvento = true;
                this.error.atualizaEvento = null;
                const response = await $f279e5b14995c3bf$var$updateEvento(data);
                return response;
            } catch (error) {
                this.error.atualizaEvento = error;
                console.error('Erro ao atualizar evento:', error);
            } finally{
                this.loading.atualizaEvento = false;
            }
        },
        async deletarEvento (id, dataId) {
            try {
                this.loading.deletaEvento = true;
                this.error.deletaEvento = null;
                const response = await $f279e5b14995c3bf$var$deleteEvento(id, dataId);
                return response;
            } catch (error) {
                this.error.deletaEvento = error;
                console.error('Erro ao deletar evento:', error);
            } finally{
                this.loading.deletaEvento = false;
            }
        }
    }
};

});
parcelRegister("iOhKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db1aab60129a97a1$export$2e2bcd8739ae039; });

var $c8Lpu = parcelRequire("c8Lpu");

var $9YhWF = parcelRequire("9YhWF");
function $db1aab60129a97a1$export$2e2bcd8739ae039() {
    const api = (0, $c8Lpu.useApi)();
    async function getEventos(params) {
        return await api.query(`${(0, $9YhWF.URLS).calendario}`, params);
    }
    async function getEventosUsuario(params) {
        return await api.query(`${(0, $9YhWF.URLS).clientes_calendar_user_events_api}`, params);
    }
    async function getUsuariosCalendarios() {
        return await api.query(`${(0, $9YhWF.URLS).clientes_calendar_user_api}`);
    }
    async function authMicrosoft(params) {
        return await api.query(`${(0, $9YhWF.URLS).calendario_auth}`, params);
    }
    async function createEvento(data) {
        return await api.mutation(`${(0, $9YhWF.URLS).calendario}`, 'post', data);
    }
    async function updateEvento(data) {
        return await api.mutation(`${(0, $9YhWF.URLS).calendario}`, 'patch', data);
    }
    async function deleteEvento(id, data = null) {
        return await api.mutation(`${(0, $9YhWF.URLS).calendario}?id=${id}`, 'delete', data);
    }
    return {
        ...api,
        getEventos: getEventos,
        getEventosUsuario: getEventosUsuario,
        authMicrosoft: authMicrosoft,
        createEvento: createEvento,
        updateEvento: updateEvento,
        deleteEvento: deleteEvento,
        getUsuariosCalendarios: getUsuariosCalendarios
    };
}

});


parcelRegister("2RZZR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21709f3f337bf13e$export$2e2bcd8739ae039; });

var $g8vIm = parcelRequire("g8vIm");

var $5q0Z8 = parcelRequire("5q0Z8");

var $YrtCO = parcelRequire("YrtCO");
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5q0Z8))));
(0, (/*@__PURE__*/$parcel$interopDefault($g8vIm))).extend((0, (/*@__PURE__*/$parcel$interopDefault($YrtCO))));
var $21709f3f337bf13e$export$2e2bcd8739ae039 = {
    name: 'InfoEventoCalendario',
    props: [
        'eventoInfo',
        'loading',
        'isReadOnly'
    ],
    emits: [
        'click:close',
        'click:edit-evento',
        'click:delete-evento'
    ],
    computed: {
        dataEventoFormatada () {
            const dataInicio = this.eventoInfo?.extendedProps?.dataEventoInicio ? (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(this.eventoInfo.extendedProps.dataEventoInicio).tz('America/Sao_Paulo').toDate() : null;
            const dataFim = this.eventoInfo?.extendedProps?.dataEventoFim ? (0, (/*@__PURE__*/$parcel$interopDefault($g8vIm)))(this.eventoInfo?.extendedProps?.dataEventoFim).tz('America/Sao_Paulo').toDate() : null;
            if (!dataInicio || !dataFim) return '';
            return this.formatarIntervaloDeData(dataInicio, dataFim);
        },
        locationEventoFormatada () {
            return this.eventoInfo?.extendedProps?.localEvento || '';
        },
        organizadorEvento () {
            if (this.eventoInfo?.extendedProps?.isOrganizador) return "Voc\xea \xe9 o organizador";
            return "Voc\xea n\xe3o \xe9 o organizador";
        },
        textoBotaoCancelar () {
            if (this.eventoInfo?.extendedProps?.isEventoPassado) return 'Excluir';
            return this.isCancelarEvento ? 'Descartar' : 'Cancelar';
        },
        textoBotaoEditar () {
            return this.isCancelarEvento ? 'Enviar' : 'Editar';
        },
        iconeBotaoCancelar () {
            return this.isCancelarEvento ? 'icon_cross_fechar' : 'icon_lixeira';
        },
        membrosEvento () {
            if (this.eventoInfo?.extendedProps?.membrosEventos) return this.eventoInfo?.extendedProps?.membrosEventos;
        },
        isEventoPassado () {
            return this.eventoInfo?.extendedProps?.isEventoPassado || false;
        }
    },
    data () {
        return {
            model: {
                textoMensagemExclusao: ''
            },
            isCancelarEvento: false
        };
    },
    methods: {
        formatarIntervaloDeData (dataInicio, dataFim) {
            const opcoesData = {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            };
            const opcoesHora = {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            };
            const formatadorData = new Intl.DateTimeFormat('pt-BR', opcoesData);
            const formatadorHora = new Intl.DateTimeFormat('pt-BR', opcoesHora);
            const dataFormatada = formatadorData.format(dataInicio);
            const horaInicioFormatada = formatadorHora.format(dataInicio);
            const horaFimFormatada = formatadorHora.format(dataFim);
            if (this.eventoInfo?.extendedProps?.isDiaInteiro) return `${dataFormatada} (Dia inteiro)`;
            return `${dataFormatada} ${horaInicioFormatada} - ${horaFimFormatada}`;
        },
        onClickChangeEvento () {
            if (this.isCancelarEvento) {
                this.onClickCancelarEvento();
                return;
            }
            this.onClickEditarEvento();
        },
        onClickDeletarEvento () {
            if (this.isEventoPassado) {
                this.onClickCancelarEvento();
                return;
            }
            this.isCancelarEvento = !this.isCancelarEvento;
        },
        onClickEditarEvento () {
            this.$emit('click:edit-evento', this.eventoInfo?.id || null);
        },
        onClickCancelarEvento () {
            const idEvento = this.eventoInfo?.extendedProps?.idEventoOriginal || null;
            const mensagemExclusao = this.model.textoMensagemExclusao || '';
            this.$emit('click:delete-evento', idEvento, mensagemExclusao);
        }
    },
    template: `
        <section 
            class="
                flex 
                flex-col
                relative 
                rounded-md 
                !w-full
                !max-w-[19rem]
                !h-auto
                !min-h-max
                overflow-hidden
                bg-white
                border
                border-neutral-50
                "
                >

            <q-btn icon="close" size="28" rounded class="absolute top-4 right-4 text-primary-pure"  @click="$emit('click:close')"/>

            <div class="bg-primary-pure w-full h-4 rounded-t">
            </div>

            <div class="
                flex
                flex-col
                !gap-y-16
                h-auto
                min-h-max 
                overflow-hidden 
                mt-10 
                border 
                border-transparent">

                <div class="flex-1 px-20">

                    <h1 class="text-headline-3 text-neutral-70 ">Calend\xe1rio</h1>

                    <p class="text-title-3 mt-8">{{eventoInfo?.title || ""}}</p>

                    <q-btn
                        v-if="eventoInfo?.extendedProps?.urlTeams" 
                        color="primary" 
                        :href="eventoInfo?.extendedProps?.urlTeams || ''"
                        target="_blank"
                        class="btn !h-[46px] !mt-24 !rounded-lg">
                        <q-icon size="sm">
							<svg>
								<use xlink:href="#icon_camera"></use>
							</svg>
						</q-icon>
                        <span class="text-paragraph-2 text-white">Ingressar</span>
                    </q-btn>
                        
                </div>

                <div class="bg-neutral-40 w-full h-1 rounded"></div>

                <div v-if="dataEventoFormatada" class="flex flex-col flex-1 px-20 pb-20 !gap-y-16"> 

                    <div v-if="dataEventoFormatada" class="flex items-center w-full gap-12">
                        <q-icon size="sm" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_relogio"></use>
							</svg>
						</q-icon>	

                        <p class="text-paragraph-3 text-bold text-neutral-100">{{dataEventoFormatada || ''}}</p>
                    </div>

                    <div v-if="locationEventoFormatada" class="bg-neutral-40 w-full h-1 rounded"></div>

                    <div v-if="locationEventoFormatada" class="flex items-center w-full gap-12">
                        <q-icon size="sm" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_localizacao"></use>
							</svg>
						</q-icon>	

                        <p class="text-paragraph-3 text-bold text-neutral-100">{{locationEventoFormatada || ''}}</p>
                    </div>

                    <div v-if="membrosEvento && membrosEvento.length > 0" class="bg-neutral-40 w-full h-1 rounded"></div>

                    <div v-if="membrosEvento && membrosEvento.length > 0" class="flex items-start w-full gap-12">
                       <q-icon size="sm" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_usuarios_grupo"></use>
							</svg>
						</q-icon>	

                        <div class="flex flex-col flex-1 !gap-y-4">
                            <p class="text-paragraph-3 text-bold text-neutral-100">Acompanhamento</p>
                            <div class="w-full h-full !max-h-[9rem] overflow-y-auto">
                                <q-list :padding="false" dense>
                                    <q-item v-for="(membro, index) in membrosEvento || []" :key="index" dense class="!p-0">
                                         <q-item-section>
                                            <q-item-label class="text-paragraph-3 text-neutral-70">{{membro.email}} - {{membro.status}}</q-item-label>
                                         </q-item-section>
                                    </q-item>
                                </q-list>
                            </div>
                            
                        </div>
                    </div>

                    <div v-if="isCancelarEvento && isEventoPassado" class="bg-neutral-40 w-full h-1 rounded"></div>


                    <div v-show="isCancelarEvento && !isEventoPassado" class="flex items-start w-full gap-12">
                        <q-icon size="28px" class="text-white">
							<svg>
								<use xlink:href="#icon_cross_fechar"></use>
							</svg>
						</q-icon>	

                        <div>
                            <p class="text-headline-2 text-neutral-100">Cancelar o evento e notificar os participantes.</p>
                                <q-input
                                    v-model="model.textoMensagemExclusao"
                                    label="Adicione uma mensagem (opcional)"
                                    type="textarea"
                                    bg-color="neutral-20"
                                    rounded
                                    class="!min-h-[5.5rem] !rounded-lg mt-16"
                                    />                                  
                        </div>
                    </div>

                    <div class="bg-neutral-40 w-full h-1 rounded !mt-16"></div>
                    
                    <div v-if="!isReadOnly" class="flex justify-start w-full gap-16">
                        <div class="flex-1 flex items-center w-full !gap-x-20">
                            <q-btn
                                :class="{'secondary': !isCancelarEvento}" 
                                :disabled="loading && isEventoPassado" 
                                :loading="loading && !isEventoPassado"
								style="height: 44px;" 
                                class="btn w-max !rounded-lg"
                                @click="onClickChangeEvento">
									<div class="flex justify-between items-center !w-full h-full !gap-x-8">
										<q-icon name="edit" size="16px"/>
										<span class="text-paragraph-2 text-bold">{{textoBotaoEditar}}</span>
									</div>
                            </q-btn>
                            <q-btn 
                            	:class="{'secondary': isCancelarEvento, 'bg-white': !isCancelarEvento}"
                                class="btn w-max !min-h[44px] !border !border-neutral-40 hover:!border-transparent group !rounded-lg"
                                style="height: 44px; border: 1px solid; border-color: #E1E3E5 !important;" 
                                :disabled="loading && !isEventoPassado"
                                :loading="loading && isEventoPassado"
                                @click="onClickDeletarEvento" 
                                >
                                	<div class="flex justify-between items-center w-full h-full !gap-x-8">
										<q-icon v-if="isCancelarEvento" name="delete" size="sm"/>

										<q-icon v-else size="16px" class="!text-white group-hover:!text-primary-10">
											<svg>
												<use xlink:href="#icon_cross_fechar"></use>
											</svg>
										</q-icon>	

                                    	<span 
											:class="{'text-primary-pure': isCancelarEvento, 'text-neutral-80 group-hover:!text-primary-pure': !isCancelarEvento}"
											class="text-paragraph-2 text-bold">{{textoBotaoCancelar}}</span>
									</div>
                            </q-btn>
                        </div>
                    </div>
                   
                </div>

            </div>
        </section>
    `
};

});


parcelRegister("d62of", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $988db0807c594dbf$export$2e2bcd8739ae039; });

var $4yQva = parcelRequire("4yQva");

var $67nR7 = parcelRequire("67nR7");
let $988db0807c594dbf$var$userLogado = document.getElementById('usuario-logado').value;
let $988db0807c594dbf$var$editorAtendimentoQuill = null;
const { showToastify: $988db0807c594dbf$var$showToastify, errorDefault: $988db0807c594dbf$var$errorDefault } = GLOBAL;
const { criarTarefa: $988db0807c594dbf$var$criarTarefa } = (0, $4yQva.default)();
var $988db0807c594dbf$export$2e2bcd8739ae039 = {
    props: [
        'open',
        'notificacaoEvento'
    ],
    emits: [
        'close'
    ],
    data () {
        return {
            model: {
                descricao: null,
                deadline: null
            },
            loading: false,
            showDate: false,
            prazoTarget: null,
            qeditor: null
        };
    },
    watch: {
        open: {
            handler (newVal) {
                if (newVal) this.createEditorCadastrarTarefaQuill();
            }
        }
    },
    computed: {
        isClienteFundacao () {
            if (this.notificacaoEvento) return this.notificacaoEvento?.fundacao_id ? true : false;
        },
        clienteAtivoId () {
            if (this.isClienteFundacao) return this.notificacaoEvento?.fundacao_id;
            return this.notificacaoEvento?.cliente_pf_id;
        },
        nomeCliente () {
            if (this.isClienteFundacao) return this.notificacaoEvento?.nome_fundacao;
            return this.notificacaoEvento?.nome_cliente_pf;
        }
    },
    methods: {
        isValidDate (data) {
            if (!data) return false;
            if (data instanceof Date) return !isNaN(data.getTime());
            return moment(data, 'DD/MM/YYYY', true).isValid();
        },
        limparEditor () {
            if ($988db0807c594dbf$var$editorAtendimentoQuill) {
                $988db0807c594dbf$var$editorAtendimentoQuill.setContents([]);
                this.qeditor = null;
            }
            this.model = {
                descricao: null,
                deadline: null
            };
        },
        async createNovaTarefa () {
            this.loading = true;
            const erros = this.validarCampos();
            if (erros.length > 0) {
                $988db0807c594dbf$var$showToastify(`\u{274C} ${erros.join(', ')}`);
                this.loading = false;
                return;
            }
            const payload = this.createPayloadTarefa();
            try {
                await $988db0807c594dbf$var$criarTarefa(payload);
                $988db0807c594dbf$var$showToastify(`\u{2705} Tarefa criada com sucesso!`);
                this.closeModal();
            } catch (err) {
                $988db0807c594dbf$var$errorDefault(err);
            } finally{
                this.loading = false;
            }
        },
        validarCampos () {
            const erros = [];
            // Validar descrição do Quill
            if (!$988db0807c594dbf$var$editorAtendimentoQuill || !$988db0807c594dbf$var$editorAtendimentoQuill.getText().trim()) erros.push("Descri\xe7\xe3o da tarefa \xe9 obrigat\xf3ria");
            // Validar deadline
            if (!this.model.deadline || !this.model.deadline.trim()) erros.push("Prazo final \xe9 obrigat\xf3rio");
            else if (!this.isValidDate(this.model.deadline)) erros.push("Data do prazo final \xe9 inv\xe1lida");
            return erros;
        },
        createEditorCadastrarTarefaQuill () {
            // Aguarda o próximo tick para garantir que o DOM foi renderizado
            this.$nextTick(()=>{
                const editorElement = document.getElementById('editor-tarefa');
                // Verifica se o elemento existe antes de criar o editor
                if (!editorElement) {
                    console.warn("Elemento #editor-tarefa n\xe3o encontrado");
                    return;
                }
                // Verifica se já existe um editor Quill neste elemento
                if ($988db0807c594dbf$var$editorAtendimentoQuill) $988db0807c594dbf$var$editorAtendimentoQuill = null;
                const SizeStyle = (0, $67nR7.default).import('attributors/style/size');
                const AlignStyle = (0, $67nR7.default).import('attributors/style/align');
                SizeStyle.whitelist = null;
                (0, $67nR7.default).register(AlignStyle, true);
                (0, $67nR7.default).register(SizeStyle, true);
                $988db0807c594dbf$var$editorAtendimentoQuill = new (0, $67nR7.default)('#editor-tarefa', {
                    theme: 'snow',
                    formats: [
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                        'size',
                        'color',
                        'list',
                        'bullet',
                        'ordered',
                        'background',
                        'align',
                        'header',
                        'indent'
                    ],
                    modules: {
                        toolbar: [
                            [
                                {
                                    header: [
                                        1,
                                        2,
                                        false
                                    ]
                                }
                            ],
                            [
                                {
                                    size: [
                                        'small',
                                        false,
                                        'large',
                                        'huge'
                                    ]
                                }
                            ],
                            [
                                'bold',
                                'italic',
                                'underline'
                            ],
                            [
                                {
                                    list: 'ordered'
                                },
                                {
                                    list: 'bullet'
                                }
                            ],
                            [
                                {
                                    indent: '-1'
                                },
                                {
                                    indent: '+1'
                                }
                            ],
                            [
                                {
                                    color: []
                                },
                                {
                                    background: []
                                }
                            ],
                            [
                                {
                                    align: []
                                }
                            ],
                            [
                                'clean'
                            ]
                        ]
                    }
                });
                $988db0807c594dbf$var$editorAtendimentoQuill.on('text-change', ()=>{
                    this.qeditor = $988db0807c594dbf$var$editorAtendimentoQuill.root.innerHTML;
                });
                $988db0807c594dbf$var$editorAtendimentoQuill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta)=>{
                    console.log(node);
                    return delta;
                });
                if (this.qeditor) $988db0807c594dbf$var$editorAtendimentoQuill.root.innerHTML = this.qeditor;
                const descricaoNotificacao = this.notificacaoEvento?.descricao || this.notificacaoEvento?.mensagem || '';
                if (descricaoNotificacao) {
                    $988db0807c594dbf$var$editorAtendimentoQuill.root.innerHTML = descricaoNotificacao;
                    this.qeditor = descricaoNotificacao;
                } else if (this.qeditor) $988db0807c594dbf$var$editorAtendimentoQuill.root.innerHTML = this.qeditor;
            });
        },
        createPayloadTarefa () {
            const tipoCliente = {
                [this.isClienteFundacao ? 'fundacao' : 'cliente_pf']: this.clienteAtivoId
            };
            const descricaoQuill = $988db0807c594dbf$var$editorAtendimentoQuill ? $988db0807c594dbf$var$editorAtendimentoQuill.root.innerHTML : this.qeditor || '';
            return {
                ...tipoCliente,
                descricao: descricaoQuill,
                usuario_responsavel: [
                    $988db0807c594dbf$var$userLogado
                ],
                status: '1',
                deadline: moment(this.model.deadline, 'DD/MM/YYYY').format('YYYY-MM-DD')
            };
        },
        changeCalendarioInput () {
            this.prazoTarget = document.getElementById('prazo-final');
            this.showDate = !this.showDate;
        },
        closeModal () {
            this.limparEditor();
            this.$emit('close');
        }
    },
    mounted () {},
    template: /* html */ `
    <Transition>
        <section v-if="open" 
            class="w-[42rem]  
            !h-max
            !p-16 
            rounded-md absolute 
            overflow-hidden 
            z-[9999999999999999999999] 
            top-1/2 right-1/2 
            translate-y-[-50%] 
            translate-x-[50%] 
            transition-all 
            duration-300 
            ease-in-out">
            <header
                class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure relative z-[9999]"
            >
            <h2 class="text-lg font-medium text-white">Nova Tarefa</h2>
                <button
                    type="button"
                    class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10"
                    data-xclose="modal_padrao"
                    @click="closeModal"
                >
                    <svg class="w-32 h-32">
                        <use xlink:href="#icon_close"></use>
                    </svg>
                </button>
            </header>
            <div class="p-24 bg-white h-full relative z-[9999] space-y-24">

                <div class="flex items-center gap-16">
                    <span class="text-headline-2 text-neutral-100">Cliente: </span>
                    <p class="text-paragraph-2 text-neutral-80">{{ nomeCliente }}</p>
                </div>
                <div class="input-label">
                    <q-input
						v-if="false"
                        v-model="model.descricao"
                        :disable="isDisableFieldsEditFormulario"
                        name="descricao" 
                        id="input-descricao-tarefa"
                        class="!w-full"
                        label="Descri\xe7\xe3o"
                        label-color="neutral-70"
                        type="text" 
                        autocomplete="off"
                        lazy-rules
                        :rules="[ val => !!val|| 'Descri\xe7\xe3o Obrigat\xf3ria' ]"
                                    />

					<div id="editor-tarefa" class=" min-h-[4rem] h-max"></div>
                </div>
                <div class="input-label">
                    <q-input
                        v-model="model.deadline"
                        label="Prazo Final"
                        label-color="neutral-70"
                        placeholder="dd/mm/aaaa"
                        class="!w-full"
                        autocomplete="off"
                        mask="##/##/####"
                        lazy-rules
                        :rules="[ val => !!val || 'Prazo obrigat\xf3rio', val => isValidDate(val) || 'Data inv\xe1lida' ]"
                        id="prazo-deadline">
                            <template v-slot:append>
                                <q-icon id="prazo-final" name="event" class="cursor-pointer" @click.stop="changeCalendarioInput">
                                </q-icon>
                            </template>
                    </q-input>

                </div>
             

                    <div class="w-max m-auto flex items-center gap-16">
                        <div
						    class="
							col-span-full 
							flex 
							justify-end 
							items-start 
							px-24 
							gap-24">
						<q-btn
                            :disable="loading"
							class="btn h-48 secondary "
                            @click="closeModal">
								Cancelar
						</q-btn>

                       <q-btn
                           :loading="loading"
                           class="btn h-48 primary "
                           @click="createNovaTarefa"
                       >
                           Criar
                       </q-btn>
                    </div>
                </div>
            </div>
        </section>
    </Transition>

		<Teleport to="body" v-if="open">
				<div class="background-deep fixed left-0 top-0 bg-[rgba(0,0,0,0.25)] w-[100vw] h-[100vh] z-[999]"
				
				></div>
                 <q-popup-proxy v-model="showDate" :target="prazoTarget" transition-show="scale" transition-hide="scale" class="z-[999999999999999999999999999]">
                    <q-date v-model="model.deadline" mask="DD/MM/YYYY">
                        <div class="row items-center justify-end">
                            <q-btn @click="changeCalendarioInput" label="Fechar" color="primary" flat />
                        </div>
                    </q-date>
                </q-popup-proxy>
		</Teleport>

    `
};

});

parcelRegister("2pJVD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c218b06196895aa$export$2e2bcd8739ae039; });
var $1c218b06196895aa$export$2e2bcd8739ae039 = {
    data () {
        return {
            isOpenModalNovaTarefa: false,
            notificacaoEventoSelecionada: null
        };
    },
    methods: {
        onClickAddTask (notificacao) {
            this.notificacaoEventoSelecionada = notificacao;
            this.openModalNovaTarefa(notificacao);
        },
        openModalNovaTarefa (notificacao) {
            this.isOpenModalNovaTarefa = true;
        },
        closeModalNovaTarefa () {
            this.isOpenModalNovaTarefa = false;
        }
    }
};

});



parcelRequire("bzZjF");
})();
//# sourceMappingURL=index.js.map
